
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6577"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6577"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kxTYF", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lMx4O"));

});
parcelRegister("lMx4O", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $fdb7bcfc9fff7964$export$ffb0004e005737fa; }, function (v) { return $fdb7bcfc9fff7964$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $fdb7bcfc9fff7964$export$34b9dba7ce09269b; }, function (v) { return $fdb7bcfc9fff7964$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $fdb7bcfc9fff7964$export$25062201e9e25d76; }, function (v) { return $fdb7bcfc9fff7964$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fdb7bcfc9fff7964$export$ffb0004e005737fa;
var $fdb7bcfc9fff7964$export$34b9dba7ce09269b;
var $fdb7bcfc9fff7964$export$25062201e9e25d76;
"use strict";

var $8v0nu = parcelRequire("8v0nu");
var $fdb7bcfc9fff7964$var$k = Symbol.for("react.element"), $fdb7bcfc9fff7964$var$l = Symbol.for("react.fragment"), $fdb7bcfc9fff7964$var$m = Object.prototype.hasOwnProperty, $fdb7bcfc9fff7964$var$n = $8v0nu.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $fdb7bcfc9fff7964$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $fdb7bcfc9fff7964$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$fdb7bcfc9fff7964$var$m.call(a, b) && !$fdb7bcfc9fff7964$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $fdb7bcfc9fff7964$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $fdb7bcfc9fff7964$var$n.current
    };
}
$fdb7bcfc9fff7964$export$ffb0004e005737fa = $fdb7bcfc9fff7964$var$l;
$fdb7bcfc9fff7964$export$34b9dba7ce09269b = $fdb7bcfc9fff7964$var$q;
$fdb7bcfc9fff7964$export$25062201e9e25d76 = $fdb7bcfc9fff7964$var$q;

});
parcelRegister("8v0nu", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7Vv40"));

});
parcelRegister("7Vv40", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $5c55f3dc68ec5dce$export$dca3b0875bd9a954; }, function (v) { return $5c55f3dc68ec5dce$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $5c55f3dc68ec5dce$export$16fa2f45be04daa8; }, function (v) { return $5c55f3dc68ec5dce$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $5c55f3dc68ec5dce$export$ffb0004e005737fa; }, function (v) { return $5c55f3dc68ec5dce$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $5c55f3dc68ec5dce$export$e2c29f18771995cb; }, function (v) { return $5c55f3dc68ec5dce$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $5c55f3dc68ec5dce$export$221d75b3f55bb0bd; }, function (v) { return $5c55f3dc68ec5dce$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $5c55f3dc68ec5dce$export$5f8d39834fd61797; }, function (v) { return $5c55f3dc68ec5dce$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $5c55f3dc68ec5dce$export$74bf444e3cd11ea5; }, function (v) { return $5c55f3dc68ec5dce$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $5c55f3dc68ec5dce$export$ae55be85d98224ed; }, function (v) { return $5c55f3dc68ec5dce$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $5c55f3dc68ec5dce$export$3ba232387fd5d6dd; }, function (v) { return $5c55f3dc68ec5dce$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $5c55f3dc68ec5dce$export$e530037191fcd5d7; }, function (v) { return $5c55f3dc68ec5dce$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $5c55f3dc68ec5dce$export$fd42f52fd3ae1109; }, function (v) { return $5c55f3dc68ec5dce$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $5c55f3dc68ec5dce$export$c8a8987d4410bf2d; }, function (v) { return $5c55f3dc68ec5dce$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $5c55f3dc68ec5dce$export$d38cd72104c1f0e9; }, function (v) { return $5c55f3dc68ec5dce$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $5c55f3dc68ec5dce$export$7d1e3a5e95ceca43; }, function (v) { return $5c55f3dc68ec5dce$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $5c55f3dc68ec5dce$export$257a8862b851cb5b; }, function (v) { return $5c55f3dc68ec5dce$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $5c55f3dc68ec5dce$export$a8257692ac88316c; }, function (v) { return $5c55f3dc68ec5dce$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $5c55f3dc68ec5dce$export$488013bae63b21da; }, function (v) { return $5c55f3dc68ec5dce$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $5c55f3dc68ec5dce$export$7c73462e0d25e514; }, function (v) { return $5c55f3dc68ec5dce$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $5c55f3dc68ec5dce$export$7568632d0d33d16d; }, function (v) { return $5c55f3dc68ec5dce$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $5c55f3dc68ec5dce$export$88948ce120ea2619; }, function (v) { return $5c55f3dc68ec5dce$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $5c55f3dc68ec5dce$export$35808ee640e87ca7; }, function (v) { return $5c55f3dc68ec5dce$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $5c55f3dc68ec5dce$export$fae74005e78b1a27; }, function (v) { return $5c55f3dc68ec5dce$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $5c55f3dc68ec5dce$export$dc8fbce3eb94dc1e; }, function (v) { return $5c55f3dc68ec5dce$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $5c55f3dc68ec5dce$export$6a7bc4e911dc01cf; }, function (v) { return $5c55f3dc68ec5dce$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $5c55f3dc68ec5dce$export$6d9c69b0de29b591; }, function (v) { return $5c55f3dc68ec5dce$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $5c55f3dc68ec5dce$export$f680877a34711e37; }, function (v) { return $5c55f3dc68ec5dce$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $5c55f3dc68ec5dce$export$d5a552a76deda3c2; }, function (v) { return $5c55f3dc68ec5dce$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $5c55f3dc68ec5dce$export$aaabe4eda9ed9969; }, function (v) { return $5c55f3dc68ec5dce$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $5c55f3dc68ec5dce$export$e5c5a5f917a5871c; }, function (v) { return $5c55f3dc68ec5dce$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $5c55f3dc68ec5dce$export$1538c33de8887b59; }, function (v) { return $5c55f3dc68ec5dce$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $5c55f3dc68ec5dce$export$13e3392192263954; }, function (v) { return $5c55f3dc68ec5dce$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $5c55f3dc68ec5dce$export$b8f5890fc79d6aca; }, function (v) { return $5c55f3dc68ec5dce$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $5c55f3dc68ec5dce$export$60241385465d0a34; }, function (v) { return $5c55f3dc68ec5dce$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $5c55f3dc68ec5dce$export$306c0aa65ff9ec16; }, function (v) { return $5c55f3dc68ec5dce$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $5c55f3dc68ec5dce$export$7b286972b8d8ccbf; }, function (v) { return $5c55f3dc68ec5dce$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $5c55f3dc68ec5dce$export$83d89fbfd8236492; }, function (v) { return $5c55f3dc68ec5dce$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5c55f3dc68ec5dce$export$dca3b0875bd9a954;
var $5c55f3dc68ec5dce$export$16fa2f45be04daa8;
var $5c55f3dc68ec5dce$export$ffb0004e005737fa;
var $5c55f3dc68ec5dce$export$e2c29f18771995cb;
var $5c55f3dc68ec5dce$export$221d75b3f55bb0bd;
var $5c55f3dc68ec5dce$export$5f8d39834fd61797;
var $5c55f3dc68ec5dce$export$74bf444e3cd11ea5;
var $5c55f3dc68ec5dce$export$ae55be85d98224ed;
var $5c55f3dc68ec5dce$export$3ba232387fd5d6dd;
var $5c55f3dc68ec5dce$export$e530037191fcd5d7;
var $5c55f3dc68ec5dce$export$fd42f52fd3ae1109;
var $5c55f3dc68ec5dce$export$c8a8987d4410bf2d;
var $5c55f3dc68ec5dce$export$d38cd72104c1f0e9;
var $5c55f3dc68ec5dce$export$7d1e3a5e95ceca43;
var $5c55f3dc68ec5dce$export$257a8862b851cb5b;
var $5c55f3dc68ec5dce$export$a8257692ac88316c;
var $5c55f3dc68ec5dce$export$488013bae63b21da;
var $5c55f3dc68ec5dce$export$7c73462e0d25e514;
var $5c55f3dc68ec5dce$export$7568632d0d33d16d;
var $5c55f3dc68ec5dce$export$88948ce120ea2619;
var $5c55f3dc68ec5dce$export$35808ee640e87ca7;
var $5c55f3dc68ec5dce$export$fae74005e78b1a27;
var $5c55f3dc68ec5dce$export$dc8fbce3eb94dc1e;
var $5c55f3dc68ec5dce$export$6a7bc4e911dc01cf;
var $5c55f3dc68ec5dce$export$6d9c69b0de29b591;
var $5c55f3dc68ec5dce$export$f680877a34711e37;
var $5c55f3dc68ec5dce$export$d5a552a76deda3c2;
var $5c55f3dc68ec5dce$export$aaabe4eda9ed9969;
var $5c55f3dc68ec5dce$export$e5c5a5f917a5871c;
var $5c55f3dc68ec5dce$export$1538c33de8887b59;
var $5c55f3dc68ec5dce$export$13e3392192263954;
var $5c55f3dc68ec5dce$export$b8f5890fc79d6aca;
var $5c55f3dc68ec5dce$export$60241385465d0a34;
var $5c55f3dc68ec5dce$export$306c0aa65ff9ec16;
var $5c55f3dc68ec5dce$export$7b286972b8d8ccbf;
var $5c55f3dc68ec5dce$export$83d89fbfd8236492;
"use strict";
var $5c55f3dc68ec5dce$var$l = Symbol.for("react.element"), $5c55f3dc68ec5dce$var$n = Symbol.for("react.portal"), $5c55f3dc68ec5dce$var$p = Symbol.for("react.fragment"), $5c55f3dc68ec5dce$var$q = Symbol.for("react.strict_mode"), $5c55f3dc68ec5dce$var$r = Symbol.for("react.profiler"), $5c55f3dc68ec5dce$var$t = Symbol.for("react.provider"), $5c55f3dc68ec5dce$var$u = Symbol.for("react.context"), $5c55f3dc68ec5dce$var$v = Symbol.for("react.forward_ref"), $5c55f3dc68ec5dce$var$w = Symbol.for("react.suspense"), $5c55f3dc68ec5dce$var$x = Symbol.for("react.memo"), $5c55f3dc68ec5dce$var$y = Symbol.for("react.lazy"), $5c55f3dc68ec5dce$var$z = Symbol.iterator;
function $5c55f3dc68ec5dce$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $5c55f3dc68ec5dce$var$z && a[$5c55f3dc68ec5dce$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $5c55f3dc68ec5dce$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $5c55f3dc68ec5dce$var$C = Object.assign, $5c55f3dc68ec5dce$var$D = {};
function $5c55f3dc68ec5dce$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $5c55f3dc68ec5dce$var$D;
    this.updater = e || $5c55f3dc68ec5dce$var$B;
}
$5c55f3dc68ec5dce$var$E.prototype.isReactComponent = {};
$5c55f3dc68ec5dce$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$5c55f3dc68ec5dce$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $5c55f3dc68ec5dce$var$F() {}
$5c55f3dc68ec5dce$var$F.prototype = $5c55f3dc68ec5dce$var$E.prototype;
function $5c55f3dc68ec5dce$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $5c55f3dc68ec5dce$var$D;
    this.updater = e || $5c55f3dc68ec5dce$var$B;
}
var $5c55f3dc68ec5dce$var$H = $5c55f3dc68ec5dce$var$G.prototype = new $5c55f3dc68ec5dce$var$F;
$5c55f3dc68ec5dce$var$H.constructor = $5c55f3dc68ec5dce$var$G;
$5c55f3dc68ec5dce$var$C($5c55f3dc68ec5dce$var$H, $5c55f3dc68ec5dce$var$E.prototype);
$5c55f3dc68ec5dce$var$H.isPureReactComponent = !0;
var $5c55f3dc68ec5dce$var$I = Array.isArray, $5c55f3dc68ec5dce$var$J = Object.prototype.hasOwnProperty, $5c55f3dc68ec5dce$var$K = {
    current: null
}, $5c55f3dc68ec5dce$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $5c55f3dc68ec5dce$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$5c55f3dc68ec5dce$var$J.call(b, d) && !$5c55f3dc68ec5dce$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $5c55f3dc68ec5dce$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $5c55f3dc68ec5dce$var$K.current
    };
}
function $5c55f3dc68ec5dce$var$N(a, b) {
    return {
        $$typeof: $5c55f3dc68ec5dce$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $5c55f3dc68ec5dce$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $5c55f3dc68ec5dce$var$l;
}
function $5c55f3dc68ec5dce$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $5c55f3dc68ec5dce$var$P = /\/+/g;
function $5c55f3dc68ec5dce$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $5c55f3dc68ec5dce$var$escape("" + a.key) : b.toString(36);
}
function $5c55f3dc68ec5dce$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $5c55f3dc68ec5dce$var$l:
                case $5c55f3dc68ec5dce$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $5c55f3dc68ec5dce$var$Q(h, 0) : d, $5c55f3dc68ec5dce$var$I(c) ? (e = "", null != a && (e = a.replace($5c55f3dc68ec5dce$var$P, "$&/") + "/"), $5c55f3dc68ec5dce$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($5c55f3dc68ec5dce$var$O(c) && (c = $5c55f3dc68ec5dce$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($5c55f3dc68ec5dce$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($5c55f3dc68ec5dce$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $5c55f3dc68ec5dce$var$Q(k, g);
        h += $5c55f3dc68ec5dce$var$R(k, b, e, f, c);
    }
    else if (f = $5c55f3dc68ec5dce$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $5c55f3dc68ec5dce$var$Q(k, g++), h += $5c55f3dc68ec5dce$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $5c55f3dc68ec5dce$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $5c55f3dc68ec5dce$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $5c55f3dc68ec5dce$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $5c55f3dc68ec5dce$var$U = {
    current: null
}, $5c55f3dc68ec5dce$var$V = {
    transition: null
}, $5c55f3dc68ec5dce$var$W = {
    ReactCurrentDispatcher: $5c55f3dc68ec5dce$var$U,
    ReactCurrentBatchConfig: $5c55f3dc68ec5dce$var$V,
    ReactCurrentOwner: $5c55f3dc68ec5dce$var$K
};
function $5c55f3dc68ec5dce$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$5c55f3dc68ec5dce$export$dca3b0875bd9a954 = {
    map: $5c55f3dc68ec5dce$var$S,
    forEach: function(a, b, e) {
        $5c55f3dc68ec5dce$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $5c55f3dc68ec5dce$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $5c55f3dc68ec5dce$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$5c55f3dc68ec5dce$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$5c55f3dc68ec5dce$export$16fa2f45be04daa8 = $5c55f3dc68ec5dce$var$E;
$5c55f3dc68ec5dce$export$ffb0004e005737fa = $5c55f3dc68ec5dce$var$p;
$5c55f3dc68ec5dce$export$e2c29f18771995cb = $5c55f3dc68ec5dce$var$r;
$5c55f3dc68ec5dce$export$221d75b3f55bb0bd = $5c55f3dc68ec5dce$var$G;
$5c55f3dc68ec5dce$export$5f8d39834fd61797 = $5c55f3dc68ec5dce$var$q;
$5c55f3dc68ec5dce$export$74bf444e3cd11ea5 = $5c55f3dc68ec5dce$var$w;
$5c55f3dc68ec5dce$export$ae55be85d98224ed = $5c55f3dc68ec5dce$var$W;
$5c55f3dc68ec5dce$export$3ba232387fd5d6dd = $5c55f3dc68ec5dce$var$X;
$5c55f3dc68ec5dce$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $5c55f3dc68ec5dce$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $5c55f3dc68ec5dce$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$5c55f3dc68ec5dce$var$J.call(b, f) && !$5c55f3dc68ec5dce$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $5c55f3dc68ec5dce$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$5c55f3dc68ec5dce$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $5c55f3dc68ec5dce$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $5c55f3dc68ec5dce$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$5c55f3dc68ec5dce$export$c8a8987d4410bf2d = $5c55f3dc68ec5dce$var$M;
$5c55f3dc68ec5dce$export$d38cd72104c1f0e9 = function(a) {
    var b = $5c55f3dc68ec5dce$var$M.bind(null, a);
    b.type = a;
    return b;
};
$5c55f3dc68ec5dce$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$5c55f3dc68ec5dce$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $5c55f3dc68ec5dce$var$v,
        render: a
    };
};
$5c55f3dc68ec5dce$export$a8257692ac88316c = $5c55f3dc68ec5dce$var$O;
$5c55f3dc68ec5dce$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $5c55f3dc68ec5dce$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $5c55f3dc68ec5dce$var$T
    };
};
$5c55f3dc68ec5dce$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $5c55f3dc68ec5dce$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$5c55f3dc68ec5dce$export$7568632d0d33d16d = function(a) {
    var b = $5c55f3dc68ec5dce$var$V.transition;
    $5c55f3dc68ec5dce$var$V.transition = {};
    try {
        a();
    } finally{
        $5c55f3dc68ec5dce$var$V.transition = b;
    }
};
$5c55f3dc68ec5dce$export$88948ce120ea2619 = $5c55f3dc68ec5dce$var$X;
$5c55f3dc68ec5dce$export$35808ee640e87ca7 = function(a, b) {
    return $5c55f3dc68ec5dce$var$U.current.useCallback(a, b);
};
$5c55f3dc68ec5dce$export$fae74005e78b1a27 = function(a) {
    return $5c55f3dc68ec5dce$var$U.current.useContext(a);
};
$5c55f3dc68ec5dce$export$dc8fbce3eb94dc1e = function() {};
$5c55f3dc68ec5dce$export$6a7bc4e911dc01cf = function(a) {
    return $5c55f3dc68ec5dce$var$U.current.useDeferredValue(a);
};
$5c55f3dc68ec5dce$export$6d9c69b0de29b591 = function(a, b) {
    return $5c55f3dc68ec5dce$var$U.current.useEffect(a, b);
};
$5c55f3dc68ec5dce$export$f680877a34711e37 = function() {
    return $5c55f3dc68ec5dce$var$U.current.useId();
};
$5c55f3dc68ec5dce$export$d5a552a76deda3c2 = function(a, b, e) {
    return $5c55f3dc68ec5dce$var$U.current.useImperativeHandle(a, b, e);
};
$5c55f3dc68ec5dce$export$aaabe4eda9ed9969 = function(a, b) {
    return $5c55f3dc68ec5dce$var$U.current.useInsertionEffect(a, b);
};
$5c55f3dc68ec5dce$export$e5c5a5f917a5871c = function(a, b) {
    return $5c55f3dc68ec5dce$var$U.current.useLayoutEffect(a, b);
};
$5c55f3dc68ec5dce$export$1538c33de8887b59 = function(a, b) {
    return $5c55f3dc68ec5dce$var$U.current.useMemo(a, b);
};
$5c55f3dc68ec5dce$export$13e3392192263954 = function(a, b, e) {
    return $5c55f3dc68ec5dce$var$U.current.useReducer(a, b, e);
};
$5c55f3dc68ec5dce$export$b8f5890fc79d6aca = function(a) {
    return $5c55f3dc68ec5dce$var$U.current.useRef(a);
};
$5c55f3dc68ec5dce$export$60241385465d0a34 = function(a) {
    return $5c55f3dc68ec5dce$var$U.current.useState(a);
};
$5c55f3dc68ec5dce$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $5c55f3dc68ec5dce$var$U.current.useSyncExternalStore(a, b, e);
};
$5c55f3dc68ec5dce$export$7b286972b8d8ccbf = function() {
    return $5c55f3dc68ec5dce$var$U.current.useTransition();
};
$5c55f3dc68ec5dce$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("fgsO0", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b1ceb1d0b2f6e090$export$ae55be85d98224ed; }, function (v) { return $b1ceb1d0b2f6e090$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b1ceb1d0b2f6e090$export$d39a5bbd09211389; }, function (v) { return $b1ceb1d0b2f6e090$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b1ceb1d0b2f6e090$export$882461b6382ed46c; }, function (v) { return $b1ceb1d0b2f6e090$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b1ceb1d0b2f6e090$export$466bfc07425424d5; }, function (v) { return $b1ceb1d0b2f6e090$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b1ceb1d0b2f6e090$export$cd75ccfd720a3cd4; }, function (v) { return $b1ceb1d0b2f6e090$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b1ceb1d0b2f6e090$export$fa8d919ba61d84db; }, function (v) { return $b1ceb1d0b2f6e090$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b1ceb1d0b2f6e090$export$757ceba2d55c277e; }, function (v) { return $b1ceb1d0b2f6e090$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b1ceb1d0b2f6e090$export$b3890eb0ae9dca99; }, function (v) { return $b1ceb1d0b2f6e090$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b1ceb1d0b2f6e090$export$502457920280e6be; }, function (v) { return $b1ceb1d0b2f6e090$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b1ceb1d0b2f6e090$export$c78a37762a8d58e1; }, function (v) { return $b1ceb1d0b2f6e090$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b1ceb1d0b2f6e090$export$dc54d992c10e8a18; }, function (v) { return $b1ceb1d0b2f6e090$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b1ceb1d0b2f6e090$export$83d89fbfd8236492; }, function (v) { return $b1ceb1d0b2f6e090$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b1ceb1d0b2f6e090$export$ae55be85d98224ed;
var $b1ceb1d0b2f6e090$export$d39a5bbd09211389;
var $b1ceb1d0b2f6e090$export$882461b6382ed46c;
var $b1ceb1d0b2f6e090$export$466bfc07425424d5;
var $b1ceb1d0b2f6e090$export$cd75ccfd720a3cd4;
var $b1ceb1d0b2f6e090$export$fa8d919ba61d84db;
var $b1ceb1d0b2f6e090$export$757ceba2d55c277e;
var $b1ceb1d0b2f6e090$export$b3890eb0ae9dca99;
var $b1ceb1d0b2f6e090$export$502457920280e6be;
var $b1ceb1d0b2f6e090$export$c78a37762a8d58e1;
var $b1ceb1d0b2f6e090$export$dc54d992c10e8a18;
var $b1ceb1d0b2f6e090$export$83d89fbfd8236492;
"use strict";

var $8v0nu = parcelRequire("8v0nu");

var $8PV0D = parcelRequire("8PV0D");
function $b1ceb1d0b2f6e090$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b1ceb1d0b2f6e090$var$da = new Set, $b1ceb1d0b2f6e090$var$ea = {};
function $b1ceb1d0b2f6e090$var$fa(a, b) {
    $b1ceb1d0b2f6e090$var$ha(a, b);
    $b1ceb1d0b2f6e090$var$ha(a + "Capture", b);
}
function $b1ceb1d0b2f6e090$var$ha(a, b) {
    $b1ceb1d0b2f6e090$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b1ceb1d0b2f6e090$var$da.add(b[a]);
}
var $b1ceb1d0b2f6e090$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b1ceb1d0b2f6e090$var$ja = Object.prototype.hasOwnProperty, $b1ceb1d0b2f6e090$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b1ceb1d0b2f6e090$var$la = {}, $b1ceb1d0b2f6e090$var$ma = {};
function $b1ceb1d0b2f6e090$var$oa(a) {
    if ($b1ceb1d0b2f6e090$var$ja.call($b1ceb1d0b2f6e090$var$ma, a)) return !0;
    if ($b1ceb1d0b2f6e090$var$ja.call($b1ceb1d0b2f6e090$var$la, a)) return !1;
    if ($b1ceb1d0b2f6e090$var$ka.test(a)) return $b1ceb1d0b2f6e090$var$ma[a] = !0;
    $b1ceb1d0b2f6e090$var$la[a] = !0;
    return !1;
}
function $b1ceb1d0b2f6e090$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b1ceb1d0b2f6e090$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b1ceb1d0b2f6e090$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b1ceb1d0b2f6e090$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b1ceb1d0b2f6e090$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b1ceb1d0b2f6e090$var$z[a] = new $b1ceb1d0b2f6e090$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b1ceb1d0b2f6e090$var$z[b] = new $b1ceb1d0b2f6e090$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b1ceb1d0b2f6e090$var$z[a] = new $b1ceb1d0b2f6e090$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b1ceb1d0b2f6e090$var$z[a] = new $b1ceb1d0b2f6e090$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b1ceb1d0b2f6e090$var$z[a] = new $b1ceb1d0b2f6e090$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b1ceb1d0b2f6e090$var$z[a] = new $b1ceb1d0b2f6e090$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b1ceb1d0b2f6e090$var$z[a] = new $b1ceb1d0b2f6e090$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b1ceb1d0b2f6e090$var$z[a] = new $b1ceb1d0b2f6e090$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b1ceb1d0b2f6e090$var$z[a] = new $b1ceb1d0b2f6e090$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b1ceb1d0b2f6e090$var$ra = /[\-:]([a-z])/g;
function $b1ceb1d0b2f6e090$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b1ceb1d0b2f6e090$var$ra, $b1ceb1d0b2f6e090$var$sa);
    $b1ceb1d0b2f6e090$var$z[b] = new $b1ceb1d0b2f6e090$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b1ceb1d0b2f6e090$var$ra, $b1ceb1d0b2f6e090$var$sa);
    $b1ceb1d0b2f6e090$var$z[b] = new $b1ceb1d0b2f6e090$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b1ceb1d0b2f6e090$var$ra, $b1ceb1d0b2f6e090$var$sa);
    $b1ceb1d0b2f6e090$var$z[b] = new $b1ceb1d0b2f6e090$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b1ceb1d0b2f6e090$var$z[a] = new $b1ceb1d0b2f6e090$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b1ceb1d0b2f6e090$var$z.xlinkHref = new $b1ceb1d0b2f6e090$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b1ceb1d0b2f6e090$var$z[a] = new $b1ceb1d0b2f6e090$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b1ceb1d0b2f6e090$var$ta(a, b, c, d) {
    var e = $b1ceb1d0b2f6e090$var$z.hasOwnProperty(b) ? $b1ceb1d0b2f6e090$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b1ceb1d0b2f6e090$var$qa(b, c, e, d) && (c = null), d || null === e ? $b1ceb1d0b2f6e090$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b1ceb1d0b2f6e090$var$ua = $8v0nu.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b1ceb1d0b2f6e090$var$va = Symbol.for("react.element"), $b1ceb1d0b2f6e090$var$wa = Symbol.for("react.portal"), $b1ceb1d0b2f6e090$var$ya = Symbol.for("react.fragment"), $b1ceb1d0b2f6e090$var$za = Symbol.for("react.strict_mode"), $b1ceb1d0b2f6e090$var$Aa = Symbol.for("react.profiler"), $b1ceb1d0b2f6e090$var$Ba = Symbol.for("react.provider"), $b1ceb1d0b2f6e090$var$Ca = Symbol.for("react.context"), $b1ceb1d0b2f6e090$var$Da = Symbol.for("react.forward_ref"), $b1ceb1d0b2f6e090$var$Ea = Symbol.for("react.suspense"), $b1ceb1d0b2f6e090$var$Fa = Symbol.for("react.suspense_list"), $b1ceb1d0b2f6e090$var$Ga = Symbol.for("react.memo"), $b1ceb1d0b2f6e090$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b1ceb1d0b2f6e090$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b1ceb1d0b2f6e090$var$Ja = Symbol.iterator;
function $b1ceb1d0b2f6e090$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b1ceb1d0b2f6e090$var$Ja && a[$b1ceb1d0b2f6e090$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b1ceb1d0b2f6e090$var$A = Object.assign, $b1ceb1d0b2f6e090$var$La;
function $b1ceb1d0b2f6e090$var$Ma(a) {
    if (void 0 === $b1ceb1d0b2f6e090$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b1ceb1d0b2f6e090$var$La = b && b[1] || "";
    }
    return "\n" + $b1ceb1d0b2f6e090$var$La + a;
}
var $b1ceb1d0b2f6e090$var$Na = !1;
function $b1ceb1d0b2f6e090$var$Oa(a, b) {
    if (!a || $b1ceb1d0b2f6e090$var$Na) return "";
    $b1ceb1d0b2f6e090$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b1ceb1d0b2f6e090$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b1ceb1d0b2f6e090$var$Ma(a) : "";
}
function $b1ceb1d0b2f6e090$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b1ceb1d0b2f6e090$var$Ma(a.type);
        case 16:
            return $b1ceb1d0b2f6e090$var$Ma("Lazy");
        case 13:
            return $b1ceb1d0b2f6e090$var$Ma("Suspense");
        case 19:
            return $b1ceb1d0b2f6e090$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b1ceb1d0b2f6e090$var$Oa(a.type, !1), a;
        case 11:
            return a = $b1ceb1d0b2f6e090$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b1ceb1d0b2f6e090$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b1ceb1d0b2f6e090$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b1ceb1d0b2f6e090$var$ya:
            return "Fragment";
        case $b1ceb1d0b2f6e090$var$wa:
            return "Portal";
        case $b1ceb1d0b2f6e090$var$Aa:
            return "Profiler";
        case $b1ceb1d0b2f6e090$var$za:
            return "StrictMode";
        case $b1ceb1d0b2f6e090$var$Ea:
            return "Suspense";
        case $b1ceb1d0b2f6e090$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b1ceb1d0b2f6e090$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b1ceb1d0b2f6e090$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b1ceb1d0b2f6e090$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b1ceb1d0b2f6e090$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b1ceb1d0b2f6e090$var$Qa(a.type) || "Memo";
        case $b1ceb1d0b2f6e090$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b1ceb1d0b2f6e090$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b1ceb1d0b2f6e090$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b1ceb1d0b2f6e090$var$Qa(b);
        case 8:
            return b === $b1ceb1d0b2f6e090$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b1ceb1d0b2f6e090$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b1ceb1d0b2f6e090$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b1ceb1d0b2f6e090$var$Ua(a) {
    var b = $b1ceb1d0b2f6e090$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b1ceb1d0b2f6e090$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b1ceb1d0b2f6e090$var$Ua(a));
}
function $b1ceb1d0b2f6e090$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b1ceb1d0b2f6e090$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b1ceb1d0b2f6e090$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b1ceb1d0b2f6e090$var$Ya(a, b) {
    var c = b.checked;
    return $b1ceb1d0b2f6e090$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b1ceb1d0b2f6e090$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b1ceb1d0b2f6e090$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b1ceb1d0b2f6e090$var$ab(a, b) {
    b = b.checked;
    null != b && $b1ceb1d0b2f6e090$var$ta(a, "checked", b, !1);
}
function $b1ceb1d0b2f6e090$var$bb(a, b) {
    $b1ceb1d0b2f6e090$var$ab(a, b);
    var c = $b1ceb1d0b2f6e090$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b1ceb1d0b2f6e090$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b1ceb1d0b2f6e090$var$cb(a, b.type, $b1ceb1d0b2f6e090$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b1ceb1d0b2f6e090$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b1ceb1d0b2f6e090$var$cb(a, b, c) {
    if ("number" !== b || $b1ceb1d0b2f6e090$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b1ceb1d0b2f6e090$var$eb = Array.isArray;
function $b1ceb1d0b2f6e090$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b1ceb1d0b2f6e090$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b1ceb1d0b2f6e090$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b1ceb1d0b2f6e090$var$p(91));
    return $b1ceb1d0b2f6e090$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b1ceb1d0b2f6e090$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b1ceb1d0b2f6e090$var$p(92));
            if ($b1ceb1d0b2f6e090$var$eb(c)) {
                if (1 < c.length) throw Error($b1ceb1d0b2f6e090$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b1ceb1d0b2f6e090$var$Sa(c)
    };
}
function $b1ceb1d0b2f6e090$var$ib(a, b) {
    var c = $b1ceb1d0b2f6e090$var$Sa(b.value), d = $b1ceb1d0b2f6e090$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b1ceb1d0b2f6e090$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b1ceb1d0b2f6e090$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b1ceb1d0b2f6e090$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b1ceb1d0b2f6e090$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b1ceb1d0b2f6e090$var$mb, $b1ceb1d0b2f6e090$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b1ceb1d0b2f6e090$var$mb = $b1ceb1d0b2f6e090$var$mb || document.createElement("div");
        $b1ceb1d0b2f6e090$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b1ceb1d0b2f6e090$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b1ceb1d0b2f6e090$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b1ceb1d0b2f6e090$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b1ceb1d0b2f6e090$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b1ceb1d0b2f6e090$var$pb).forEach(function(a) {
    $b1ceb1d0b2f6e090$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b1ceb1d0b2f6e090$var$pb[b] = $b1ceb1d0b2f6e090$var$pb[a];
    });
});
function $b1ceb1d0b2f6e090$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b1ceb1d0b2f6e090$var$pb.hasOwnProperty(a) && $b1ceb1d0b2f6e090$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b1ceb1d0b2f6e090$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b1ceb1d0b2f6e090$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b1ceb1d0b2f6e090$var$tb = $b1ceb1d0b2f6e090$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b1ceb1d0b2f6e090$var$ub(a, b) {
    if (b) {
        if ($b1ceb1d0b2f6e090$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b1ceb1d0b2f6e090$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b1ceb1d0b2f6e090$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b1ceb1d0b2f6e090$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b1ceb1d0b2f6e090$var$p(62));
    }
}
function $b1ceb1d0b2f6e090$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b1ceb1d0b2f6e090$var$wb = null;
function $b1ceb1d0b2f6e090$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b1ceb1d0b2f6e090$var$yb = null, $b1ceb1d0b2f6e090$var$zb = null, $b1ceb1d0b2f6e090$var$Ab = null;
function $b1ceb1d0b2f6e090$var$Bb(a) {
    if (a = $b1ceb1d0b2f6e090$var$Cb(a)) {
        if ("function" !== typeof $b1ceb1d0b2f6e090$var$yb) throw Error($b1ceb1d0b2f6e090$var$p(280));
        var b = a.stateNode;
        b && (b = $b1ceb1d0b2f6e090$var$Db(b), $b1ceb1d0b2f6e090$var$yb(a.stateNode, a.type, b));
    }
}
function $b1ceb1d0b2f6e090$var$Eb(a) {
    $b1ceb1d0b2f6e090$var$zb ? $b1ceb1d0b2f6e090$var$Ab ? $b1ceb1d0b2f6e090$var$Ab.push(a) : $b1ceb1d0b2f6e090$var$Ab = [
        a
    ] : $b1ceb1d0b2f6e090$var$zb = a;
}
function $b1ceb1d0b2f6e090$var$Fb() {
    if ($b1ceb1d0b2f6e090$var$zb) {
        var a = $b1ceb1d0b2f6e090$var$zb, b = $b1ceb1d0b2f6e090$var$Ab;
        $b1ceb1d0b2f6e090$var$Ab = $b1ceb1d0b2f6e090$var$zb = null;
        $b1ceb1d0b2f6e090$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b1ceb1d0b2f6e090$var$Bb(b[a]);
    }
}
function $b1ceb1d0b2f6e090$var$Gb(a, b) {
    return a(b);
}
function $b1ceb1d0b2f6e090$var$Hb() {}
var $b1ceb1d0b2f6e090$var$Ib = !1;
function $b1ceb1d0b2f6e090$var$Jb(a, b, c) {
    if ($b1ceb1d0b2f6e090$var$Ib) return a(b, c);
    $b1ceb1d0b2f6e090$var$Ib = !0;
    try {
        return $b1ceb1d0b2f6e090$var$Gb(a, b, c);
    } finally{
        if ($b1ceb1d0b2f6e090$var$Ib = !1, null !== $b1ceb1d0b2f6e090$var$zb || null !== $b1ceb1d0b2f6e090$var$Ab) $b1ceb1d0b2f6e090$var$Hb(), $b1ceb1d0b2f6e090$var$Fb();
    }
}
function $b1ceb1d0b2f6e090$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b1ceb1d0b2f6e090$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b1ceb1d0b2f6e090$var$p(231, b, typeof c));
    return c;
}
var $b1ceb1d0b2f6e090$var$Lb = !1;
if ($b1ceb1d0b2f6e090$var$ia) try {
    var $b1ceb1d0b2f6e090$var$Mb = {};
    Object.defineProperty($b1ceb1d0b2f6e090$var$Mb, "passive", {
        get: function() {
            $b1ceb1d0b2f6e090$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b1ceb1d0b2f6e090$var$Mb, $b1ceb1d0b2f6e090$var$Mb);
    window.removeEventListener("test", $b1ceb1d0b2f6e090$var$Mb, $b1ceb1d0b2f6e090$var$Mb);
} catch (a) {
    $b1ceb1d0b2f6e090$var$Lb = !1;
}
function $b1ceb1d0b2f6e090$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b1ceb1d0b2f6e090$var$Ob = !1, $b1ceb1d0b2f6e090$var$Pb = null, $b1ceb1d0b2f6e090$var$Qb = !1, $b1ceb1d0b2f6e090$var$Rb = null, $b1ceb1d0b2f6e090$var$Sb = {
    onError: function(a) {
        $b1ceb1d0b2f6e090$var$Ob = !0;
        $b1ceb1d0b2f6e090$var$Pb = a;
    }
};
function $b1ceb1d0b2f6e090$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b1ceb1d0b2f6e090$var$Ob = !1;
    $b1ceb1d0b2f6e090$var$Pb = null;
    $b1ceb1d0b2f6e090$var$Nb.apply($b1ceb1d0b2f6e090$var$Sb, arguments);
}
function $b1ceb1d0b2f6e090$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b1ceb1d0b2f6e090$var$Tb.apply(this, arguments);
    if ($b1ceb1d0b2f6e090$var$Ob) {
        if ($b1ceb1d0b2f6e090$var$Ob) {
            var l = $b1ceb1d0b2f6e090$var$Pb;
            $b1ceb1d0b2f6e090$var$Ob = !1;
            $b1ceb1d0b2f6e090$var$Pb = null;
        } else throw Error($b1ceb1d0b2f6e090$var$p(198));
        $b1ceb1d0b2f6e090$var$Qb || ($b1ceb1d0b2f6e090$var$Qb = !0, $b1ceb1d0b2f6e090$var$Rb = l);
    }
}
function $b1ceb1d0b2f6e090$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b1ceb1d0b2f6e090$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b1ceb1d0b2f6e090$var$Xb(a) {
    if ($b1ceb1d0b2f6e090$var$Vb(a) !== a) throw Error($b1ceb1d0b2f6e090$var$p(188));
}
function $b1ceb1d0b2f6e090$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b1ceb1d0b2f6e090$var$Vb(a);
        if (null === b) throw Error($b1ceb1d0b2f6e090$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b1ceb1d0b2f6e090$var$Xb(e), a;
                if (f === d) return $b1ceb1d0b2f6e090$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b1ceb1d0b2f6e090$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b1ceb1d0b2f6e090$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b1ceb1d0b2f6e090$var$p(190));
    }
    if (3 !== c.tag) throw Error($b1ceb1d0b2f6e090$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b1ceb1d0b2f6e090$var$Zb(a) {
    a = $b1ceb1d0b2f6e090$var$Yb(a);
    return null !== a ? $b1ceb1d0b2f6e090$var$$b(a) : null;
}
function $b1ceb1d0b2f6e090$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b1ceb1d0b2f6e090$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b1ceb1d0b2f6e090$var$ac = $8PV0D.unstable_scheduleCallback, $b1ceb1d0b2f6e090$var$bc = $8PV0D.unstable_cancelCallback, $b1ceb1d0b2f6e090$var$cc = $8PV0D.unstable_shouldYield, $b1ceb1d0b2f6e090$var$dc = $8PV0D.unstable_requestPaint, $b1ceb1d0b2f6e090$var$B = $8PV0D.unstable_now, $b1ceb1d0b2f6e090$var$ec = $8PV0D.unstable_getCurrentPriorityLevel, $b1ceb1d0b2f6e090$var$fc = $8PV0D.unstable_ImmediatePriority, $b1ceb1d0b2f6e090$var$gc = $8PV0D.unstable_UserBlockingPriority, $b1ceb1d0b2f6e090$var$hc = $8PV0D.unstable_NormalPriority, $b1ceb1d0b2f6e090$var$ic = $8PV0D.unstable_LowPriority, $b1ceb1d0b2f6e090$var$jc = $8PV0D.unstable_IdlePriority, $b1ceb1d0b2f6e090$var$kc = null, $b1ceb1d0b2f6e090$var$lc = null;
function $b1ceb1d0b2f6e090$var$mc(a) {
    if ($b1ceb1d0b2f6e090$var$lc && "function" === typeof $b1ceb1d0b2f6e090$var$lc.onCommitFiberRoot) try {
        $b1ceb1d0b2f6e090$var$lc.onCommitFiberRoot($b1ceb1d0b2f6e090$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b1ceb1d0b2f6e090$var$oc = Math.clz32 ? Math.clz32 : $b1ceb1d0b2f6e090$var$nc, $b1ceb1d0b2f6e090$var$pc = Math.log, $b1ceb1d0b2f6e090$var$qc = Math.LN2;
function $b1ceb1d0b2f6e090$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b1ceb1d0b2f6e090$var$pc(a) / $b1ceb1d0b2f6e090$var$qc | 0) | 0;
}
var $b1ceb1d0b2f6e090$var$rc = 64, $b1ceb1d0b2f6e090$var$sc = 4194304;
function $b1ceb1d0b2f6e090$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b1ceb1d0b2f6e090$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b1ceb1d0b2f6e090$var$tc(h) : (f &= g, 0 !== f && (d = $b1ceb1d0b2f6e090$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b1ceb1d0b2f6e090$var$tc(g) : 0 !== f && (d = $b1ceb1d0b2f6e090$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b1ceb1d0b2f6e090$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b1ceb1d0b2f6e090$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b1ceb1d0b2f6e090$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b1ceb1d0b2f6e090$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b1ceb1d0b2f6e090$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b1ceb1d0b2f6e090$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b1ceb1d0b2f6e090$var$yc() {
    var a = $b1ceb1d0b2f6e090$var$rc;
    $b1ceb1d0b2f6e090$var$rc <<= 1;
    0 === ($b1ceb1d0b2f6e090$var$rc & 4194240) && ($b1ceb1d0b2f6e090$var$rc = 64);
    return a;
}
function $b1ceb1d0b2f6e090$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b1ceb1d0b2f6e090$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b1ceb1d0b2f6e090$var$oc(b);
    a[b] = c;
}
function $b1ceb1d0b2f6e090$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b1ceb1d0b2f6e090$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b1ceb1d0b2f6e090$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b1ceb1d0b2f6e090$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b1ceb1d0b2f6e090$var$C = 0;
function $b1ceb1d0b2f6e090$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b1ceb1d0b2f6e090$var$Ec, $b1ceb1d0b2f6e090$var$Fc, $b1ceb1d0b2f6e090$var$Gc, $b1ceb1d0b2f6e090$var$Hc, $b1ceb1d0b2f6e090$var$Ic, $b1ceb1d0b2f6e090$var$Jc = !1, $b1ceb1d0b2f6e090$var$Kc = [], $b1ceb1d0b2f6e090$var$Lc = null, $b1ceb1d0b2f6e090$var$Mc = null, $b1ceb1d0b2f6e090$var$Nc = null, $b1ceb1d0b2f6e090$var$Oc = new Map, $b1ceb1d0b2f6e090$var$Pc = new Map, $b1ceb1d0b2f6e090$var$Qc = [], $b1ceb1d0b2f6e090$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b1ceb1d0b2f6e090$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b1ceb1d0b2f6e090$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b1ceb1d0b2f6e090$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b1ceb1d0b2f6e090$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b1ceb1d0b2f6e090$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b1ceb1d0b2f6e090$var$Pc.delete(b.pointerId);
    }
}
function $b1ceb1d0b2f6e090$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b1ceb1d0b2f6e090$var$Cb(b), null !== b && $b1ceb1d0b2f6e090$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b1ceb1d0b2f6e090$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b1ceb1d0b2f6e090$var$Lc = $b1ceb1d0b2f6e090$var$Tc($b1ceb1d0b2f6e090$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b1ceb1d0b2f6e090$var$Mc = $b1ceb1d0b2f6e090$var$Tc($b1ceb1d0b2f6e090$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b1ceb1d0b2f6e090$var$Nc = $b1ceb1d0b2f6e090$var$Tc($b1ceb1d0b2f6e090$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b1ceb1d0b2f6e090$var$Oc.set(f, $b1ceb1d0b2f6e090$var$Tc($b1ceb1d0b2f6e090$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b1ceb1d0b2f6e090$var$Pc.set(f, $b1ceb1d0b2f6e090$var$Tc($b1ceb1d0b2f6e090$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b1ceb1d0b2f6e090$var$Vc(a) {
    var b = $b1ceb1d0b2f6e090$var$Wc(a.target);
    if (null !== b) {
        var c = $b1ceb1d0b2f6e090$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b1ceb1d0b2f6e090$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b1ceb1d0b2f6e090$var$Ic(a.priority, function() {
                        $b1ceb1d0b2f6e090$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b1ceb1d0b2f6e090$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b1ceb1d0b2f6e090$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b1ceb1d0b2f6e090$var$wb = d;
            c.target.dispatchEvent(d);
            $b1ceb1d0b2f6e090$var$wb = null;
        } else return b = $b1ceb1d0b2f6e090$var$Cb(c), null !== b && $b1ceb1d0b2f6e090$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b1ceb1d0b2f6e090$var$Zc(a, b, c) {
    $b1ceb1d0b2f6e090$var$Xc(a) && c.delete(b);
}
function $b1ceb1d0b2f6e090$var$$c() {
    $b1ceb1d0b2f6e090$var$Jc = !1;
    null !== $b1ceb1d0b2f6e090$var$Lc && $b1ceb1d0b2f6e090$var$Xc($b1ceb1d0b2f6e090$var$Lc) && ($b1ceb1d0b2f6e090$var$Lc = null);
    null !== $b1ceb1d0b2f6e090$var$Mc && $b1ceb1d0b2f6e090$var$Xc($b1ceb1d0b2f6e090$var$Mc) && ($b1ceb1d0b2f6e090$var$Mc = null);
    null !== $b1ceb1d0b2f6e090$var$Nc && $b1ceb1d0b2f6e090$var$Xc($b1ceb1d0b2f6e090$var$Nc) && ($b1ceb1d0b2f6e090$var$Nc = null);
    $b1ceb1d0b2f6e090$var$Oc.forEach($b1ceb1d0b2f6e090$var$Zc);
    $b1ceb1d0b2f6e090$var$Pc.forEach($b1ceb1d0b2f6e090$var$Zc);
}
function $b1ceb1d0b2f6e090$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b1ceb1d0b2f6e090$var$Jc || ($b1ceb1d0b2f6e090$var$Jc = !0, $8PV0D.unstable_scheduleCallback($8PV0D.unstable_NormalPriority, $b1ceb1d0b2f6e090$var$$c)));
}
function $b1ceb1d0b2f6e090$var$bd(a) {
    function b(b) {
        return $b1ceb1d0b2f6e090$var$ad(b, a);
    }
    if (0 < $b1ceb1d0b2f6e090$var$Kc.length) {
        $b1ceb1d0b2f6e090$var$ad($b1ceb1d0b2f6e090$var$Kc[0], a);
        for(var c = 1; c < $b1ceb1d0b2f6e090$var$Kc.length; c++){
            var d = $b1ceb1d0b2f6e090$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b1ceb1d0b2f6e090$var$Lc && $b1ceb1d0b2f6e090$var$ad($b1ceb1d0b2f6e090$var$Lc, a);
    null !== $b1ceb1d0b2f6e090$var$Mc && $b1ceb1d0b2f6e090$var$ad($b1ceb1d0b2f6e090$var$Mc, a);
    null !== $b1ceb1d0b2f6e090$var$Nc && $b1ceb1d0b2f6e090$var$ad($b1ceb1d0b2f6e090$var$Nc, a);
    $b1ceb1d0b2f6e090$var$Oc.forEach(b);
    $b1ceb1d0b2f6e090$var$Pc.forEach(b);
    for(c = 0; c < $b1ceb1d0b2f6e090$var$Qc.length; c++)d = $b1ceb1d0b2f6e090$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b1ceb1d0b2f6e090$var$Qc.length && (c = $b1ceb1d0b2f6e090$var$Qc[0], null === c.blockedOn);)$b1ceb1d0b2f6e090$var$Vc(c), null === c.blockedOn && $b1ceb1d0b2f6e090$var$Qc.shift();
}
var $b1ceb1d0b2f6e090$var$cd = $b1ceb1d0b2f6e090$var$ua.ReactCurrentBatchConfig, $b1ceb1d0b2f6e090$var$dd = !0;
function $b1ceb1d0b2f6e090$var$ed(a, b, c, d) {
    var e = $b1ceb1d0b2f6e090$var$C, f = $b1ceb1d0b2f6e090$var$cd.transition;
    $b1ceb1d0b2f6e090$var$cd.transition = null;
    try {
        $b1ceb1d0b2f6e090$var$C = 1, $b1ceb1d0b2f6e090$var$fd(a, b, c, d);
    } finally{
        $b1ceb1d0b2f6e090$var$C = e, $b1ceb1d0b2f6e090$var$cd.transition = f;
    }
}
function $b1ceb1d0b2f6e090$var$gd(a, b, c, d) {
    var e = $b1ceb1d0b2f6e090$var$C, f = $b1ceb1d0b2f6e090$var$cd.transition;
    $b1ceb1d0b2f6e090$var$cd.transition = null;
    try {
        $b1ceb1d0b2f6e090$var$C = 4, $b1ceb1d0b2f6e090$var$fd(a, b, c, d);
    } finally{
        $b1ceb1d0b2f6e090$var$C = e, $b1ceb1d0b2f6e090$var$cd.transition = f;
    }
}
function $b1ceb1d0b2f6e090$var$fd(a, b, c, d) {
    if ($b1ceb1d0b2f6e090$var$dd) {
        var e = $b1ceb1d0b2f6e090$var$Yc(a, b, c, d);
        if (null === e) $b1ceb1d0b2f6e090$var$hd(a, b, d, $b1ceb1d0b2f6e090$var$id, c), $b1ceb1d0b2f6e090$var$Sc(a, d);
        else if ($b1ceb1d0b2f6e090$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b1ceb1d0b2f6e090$var$Sc(a, d), b & 4 && -1 < $b1ceb1d0b2f6e090$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b1ceb1d0b2f6e090$var$Cb(e);
                null !== f && $b1ceb1d0b2f6e090$var$Ec(f);
                f = $b1ceb1d0b2f6e090$var$Yc(a, b, c, d);
                null === f && $b1ceb1d0b2f6e090$var$hd(a, b, d, $b1ceb1d0b2f6e090$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b1ceb1d0b2f6e090$var$hd(a, b, d, null, c);
    }
}
var $b1ceb1d0b2f6e090$var$id = null;
function $b1ceb1d0b2f6e090$var$Yc(a, b, c, d) {
    $b1ceb1d0b2f6e090$var$id = null;
    a = $b1ceb1d0b2f6e090$var$xb(d);
    a = $b1ceb1d0b2f6e090$var$Wc(a);
    if (null !== a) {
        if (b = $b1ceb1d0b2f6e090$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b1ceb1d0b2f6e090$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b1ceb1d0b2f6e090$var$id = a;
    return null;
}
function $b1ceb1d0b2f6e090$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b1ceb1d0b2f6e090$var$ec()){
                case $b1ceb1d0b2f6e090$var$fc:
                    return 1;
                case $b1ceb1d0b2f6e090$var$gc:
                    return 4;
                case $b1ceb1d0b2f6e090$var$hc:
                case $b1ceb1d0b2f6e090$var$ic:
                    return 16;
                case $b1ceb1d0b2f6e090$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b1ceb1d0b2f6e090$var$kd = null, $b1ceb1d0b2f6e090$var$ld = null, $b1ceb1d0b2f6e090$var$md = null;
function $b1ceb1d0b2f6e090$var$nd() {
    if ($b1ceb1d0b2f6e090$var$md) return $b1ceb1d0b2f6e090$var$md;
    var a, b = $b1ceb1d0b2f6e090$var$ld, c = b.length, d, e = "value" in $b1ceb1d0b2f6e090$var$kd ? $b1ceb1d0b2f6e090$var$kd.value : $b1ceb1d0b2f6e090$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b1ceb1d0b2f6e090$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b1ceb1d0b2f6e090$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b1ceb1d0b2f6e090$var$pd() {
    return !0;
}
function $b1ceb1d0b2f6e090$var$qd() {
    return !1;
}
function $b1ceb1d0b2f6e090$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b1ceb1d0b2f6e090$var$pd : $b1ceb1d0b2f6e090$var$qd;
        this.isPropagationStopped = $b1ceb1d0b2f6e090$var$qd;
        return this;
    }
    $b1ceb1d0b2f6e090$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b1ceb1d0b2f6e090$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b1ceb1d0b2f6e090$var$pd);
        },
        persist: function() {},
        isPersistent: $b1ceb1d0b2f6e090$var$pd
    });
    return b;
}
var $b1ceb1d0b2f6e090$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b1ceb1d0b2f6e090$var$td = $b1ceb1d0b2f6e090$var$rd($b1ceb1d0b2f6e090$var$sd), $b1ceb1d0b2f6e090$var$ud = $b1ceb1d0b2f6e090$var$A({}, $b1ceb1d0b2f6e090$var$sd, {
    view: 0,
    detail: 0
}), $b1ceb1d0b2f6e090$var$vd = $b1ceb1d0b2f6e090$var$rd($b1ceb1d0b2f6e090$var$ud), $b1ceb1d0b2f6e090$var$wd, $b1ceb1d0b2f6e090$var$xd, $b1ceb1d0b2f6e090$var$yd, $b1ceb1d0b2f6e090$var$Ad = $b1ceb1d0b2f6e090$var$A({}, $b1ceb1d0b2f6e090$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b1ceb1d0b2f6e090$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b1ceb1d0b2f6e090$var$yd && ($b1ceb1d0b2f6e090$var$yd && "mousemove" === a.type ? ($b1ceb1d0b2f6e090$var$wd = a.screenX - $b1ceb1d0b2f6e090$var$yd.screenX, $b1ceb1d0b2f6e090$var$xd = a.screenY - $b1ceb1d0b2f6e090$var$yd.screenY) : $b1ceb1d0b2f6e090$var$xd = $b1ceb1d0b2f6e090$var$wd = 0, $b1ceb1d0b2f6e090$var$yd = a);
        return $b1ceb1d0b2f6e090$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $b1ceb1d0b2f6e090$var$xd;
    }
}), $b1ceb1d0b2f6e090$var$Bd = $b1ceb1d0b2f6e090$var$rd($b1ceb1d0b2f6e090$var$Ad), $b1ceb1d0b2f6e090$var$Cd = $b1ceb1d0b2f6e090$var$A({}, $b1ceb1d0b2f6e090$var$Ad, {
    dataTransfer: 0
}), $b1ceb1d0b2f6e090$var$Dd = $b1ceb1d0b2f6e090$var$rd($b1ceb1d0b2f6e090$var$Cd), $b1ceb1d0b2f6e090$var$Ed = $b1ceb1d0b2f6e090$var$A({}, $b1ceb1d0b2f6e090$var$ud, {
    relatedTarget: 0
}), $b1ceb1d0b2f6e090$var$Fd = $b1ceb1d0b2f6e090$var$rd($b1ceb1d0b2f6e090$var$Ed), $b1ceb1d0b2f6e090$var$Gd = $b1ceb1d0b2f6e090$var$A({}, $b1ceb1d0b2f6e090$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b1ceb1d0b2f6e090$var$Hd = $b1ceb1d0b2f6e090$var$rd($b1ceb1d0b2f6e090$var$Gd), $b1ceb1d0b2f6e090$var$Id = $b1ceb1d0b2f6e090$var$A({}, $b1ceb1d0b2f6e090$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b1ceb1d0b2f6e090$var$Jd = $b1ceb1d0b2f6e090$var$rd($b1ceb1d0b2f6e090$var$Id), $b1ceb1d0b2f6e090$var$Kd = $b1ceb1d0b2f6e090$var$A({}, $b1ceb1d0b2f6e090$var$sd, {
    data: 0
}), $b1ceb1d0b2f6e090$var$Ld = $b1ceb1d0b2f6e090$var$rd($b1ceb1d0b2f6e090$var$Kd), $b1ceb1d0b2f6e090$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b1ceb1d0b2f6e090$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b1ceb1d0b2f6e090$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b1ceb1d0b2f6e090$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b1ceb1d0b2f6e090$var$Od[a]) ? !!b[a] : !1;
}
function $b1ceb1d0b2f6e090$var$zd() {
    return $b1ceb1d0b2f6e090$var$Pd;
}
var $b1ceb1d0b2f6e090$var$Qd = $b1ceb1d0b2f6e090$var$A({}, $b1ceb1d0b2f6e090$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $b1ceb1d0b2f6e090$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b1ceb1d0b2f6e090$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b1ceb1d0b2f6e090$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b1ceb1d0b2f6e090$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $b1ceb1d0b2f6e090$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b1ceb1d0b2f6e090$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b1ceb1d0b2f6e090$var$Rd = $b1ceb1d0b2f6e090$var$rd($b1ceb1d0b2f6e090$var$Qd), $b1ceb1d0b2f6e090$var$Sd = $b1ceb1d0b2f6e090$var$A({}, $b1ceb1d0b2f6e090$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b1ceb1d0b2f6e090$var$Td = $b1ceb1d0b2f6e090$var$rd($b1ceb1d0b2f6e090$var$Sd), $b1ceb1d0b2f6e090$var$Ud = $b1ceb1d0b2f6e090$var$A({}, $b1ceb1d0b2f6e090$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b1ceb1d0b2f6e090$var$zd
}), $b1ceb1d0b2f6e090$var$Vd = $b1ceb1d0b2f6e090$var$rd($b1ceb1d0b2f6e090$var$Ud), $b1ceb1d0b2f6e090$var$Wd = $b1ceb1d0b2f6e090$var$A({}, $b1ceb1d0b2f6e090$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b1ceb1d0b2f6e090$var$Xd = $b1ceb1d0b2f6e090$var$rd($b1ceb1d0b2f6e090$var$Wd), $b1ceb1d0b2f6e090$var$Yd = $b1ceb1d0b2f6e090$var$A({}, $b1ceb1d0b2f6e090$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b1ceb1d0b2f6e090$var$Zd = $b1ceb1d0b2f6e090$var$rd($b1ceb1d0b2f6e090$var$Yd), $b1ceb1d0b2f6e090$var$$d = [
    9,
    13,
    27,
    32
], $b1ceb1d0b2f6e090$var$ae = $b1ceb1d0b2f6e090$var$ia && "CompositionEvent" in window, $b1ceb1d0b2f6e090$var$be = null;
$b1ceb1d0b2f6e090$var$ia && "documentMode" in document && ($b1ceb1d0b2f6e090$var$be = document.documentMode);
var $b1ceb1d0b2f6e090$var$ce = $b1ceb1d0b2f6e090$var$ia && "TextEvent" in window && !$b1ceb1d0b2f6e090$var$be, $b1ceb1d0b2f6e090$var$de = $b1ceb1d0b2f6e090$var$ia && (!$b1ceb1d0b2f6e090$var$ae || $b1ceb1d0b2f6e090$var$be && 8 < $b1ceb1d0b2f6e090$var$be && 11 >= $b1ceb1d0b2f6e090$var$be), $b1ceb1d0b2f6e090$var$ee = String.fromCharCode(32), $b1ceb1d0b2f6e090$var$fe = !1;
function $b1ceb1d0b2f6e090$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b1ceb1d0b2f6e090$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b1ceb1d0b2f6e090$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b1ceb1d0b2f6e090$var$ie = !1;
function $b1ceb1d0b2f6e090$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b1ceb1d0b2f6e090$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b1ceb1d0b2f6e090$var$fe = !0;
            return $b1ceb1d0b2f6e090$var$ee;
        case "textInput":
            return a = b.data, a === $b1ceb1d0b2f6e090$var$ee && $b1ceb1d0b2f6e090$var$fe ? null : a;
        default:
            return null;
    }
}
function $b1ceb1d0b2f6e090$var$ke(a, b) {
    if ($b1ceb1d0b2f6e090$var$ie) return "compositionend" === a || !$b1ceb1d0b2f6e090$var$ae && $b1ceb1d0b2f6e090$var$ge(a, b) ? (a = $b1ceb1d0b2f6e090$var$nd(), $b1ceb1d0b2f6e090$var$md = $b1ceb1d0b2f6e090$var$ld = $b1ceb1d0b2f6e090$var$kd = null, $b1ceb1d0b2f6e090$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b1ceb1d0b2f6e090$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b1ceb1d0b2f6e090$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b1ceb1d0b2f6e090$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b1ceb1d0b2f6e090$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b1ceb1d0b2f6e090$var$ne(a, b, c, d) {
    $b1ceb1d0b2f6e090$var$Eb(d);
    b = $b1ceb1d0b2f6e090$var$oe(b, "onChange");
    0 < b.length && (c = new $b1ceb1d0b2f6e090$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b1ceb1d0b2f6e090$var$pe = null, $b1ceb1d0b2f6e090$var$qe = null;
function $b1ceb1d0b2f6e090$var$re(a) {
    $b1ceb1d0b2f6e090$var$se(a, 0);
}
function $b1ceb1d0b2f6e090$var$te(a) {
    var b = $b1ceb1d0b2f6e090$var$ue(a);
    if ($b1ceb1d0b2f6e090$var$Wa(b)) return a;
}
function $b1ceb1d0b2f6e090$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b1ceb1d0b2f6e090$var$we = !1;
if ($b1ceb1d0b2f6e090$var$ia) {
    var $b1ceb1d0b2f6e090$var$xe;
    if ($b1ceb1d0b2f6e090$var$ia) {
        var $b1ceb1d0b2f6e090$var$ye = "oninput" in document;
        if (!$b1ceb1d0b2f6e090$var$ye) {
            var $b1ceb1d0b2f6e090$var$ze = document.createElement("div");
            $b1ceb1d0b2f6e090$var$ze.setAttribute("oninput", "return;");
            $b1ceb1d0b2f6e090$var$ye = "function" === typeof $b1ceb1d0b2f6e090$var$ze.oninput;
        }
        $b1ceb1d0b2f6e090$var$xe = $b1ceb1d0b2f6e090$var$ye;
    } else $b1ceb1d0b2f6e090$var$xe = !1;
    $b1ceb1d0b2f6e090$var$we = $b1ceb1d0b2f6e090$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b1ceb1d0b2f6e090$var$Ae() {
    $b1ceb1d0b2f6e090$var$pe && ($b1ceb1d0b2f6e090$var$pe.detachEvent("onpropertychange", $b1ceb1d0b2f6e090$var$Be), $b1ceb1d0b2f6e090$var$qe = $b1ceb1d0b2f6e090$var$pe = null);
}
function $b1ceb1d0b2f6e090$var$Be(a) {
    if ("value" === a.propertyName && $b1ceb1d0b2f6e090$var$te($b1ceb1d0b2f6e090$var$qe)) {
        var b = [];
        $b1ceb1d0b2f6e090$var$ne(b, $b1ceb1d0b2f6e090$var$qe, a, $b1ceb1d0b2f6e090$var$xb(a));
        $b1ceb1d0b2f6e090$var$Jb($b1ceb1d0b2f6e090$var$re, b);
    }
}
function $b1ceb1d0b2f6e090$var$Ce(a, b, c) {
    "focusin" === a ? ($b1ceb1d0b2f6e090$var$Ae(), $b1ceb1d0b2f6e090$var$pe = b, $b1ceb1d0b2f6e090$var$qe = c, $b1ceb1d0b2f6e090$var$pe.attachEvent("onpropertychange", $b1ceb1d0b2f6e090$var$Be)) : "focusout" === a && $b1ceb1d0b2f6e090$var$Ae();
}
function $b1ceb1d0b2f6e090$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b1ceb1d0b2f6e090$var$te($b1ceb1d0b2f6e090$var$qe);
}
function $b1ceb1d0b2f6e090$var$Ee(a, b) {
    if ("click" === a) return $b1ceb1d0b2f6e090$var$te(b);
}
function $b1ceb1d0b2f6e090$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b1ceb1d0b2f6e090$var$te(b);
}
function $b1ceb1d0b2f6e090$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b1ceb1d0b2f6e090$var$He = "function" === typeof Object.is ? Object.is : $b1ceb1d0b2f6e090$var$Ge;
function $b1ceb1d0b2f6e090$var$Ie(a, b) {
    if ($b1ceb1d0b2f6e090$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b1ceb1d0b2f6e090$var$ja.call(b, e) || !$b1ceb1d0b2f6e090$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b1ceb1d0b2f6e090$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b1ceb1d0b2f6e090$var$Ke(a, b) {
    var c = $b1ceb1d0b2f6e090$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b1ceb1d0b2f6e090$var$Je(c);
    }
}
function $b1ceb1d0b2f6e090$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b1ceb1d0b2f6e090$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b1ceb1d0b2f6e090$var$Me() {
    for(var a = window, b = $b1ceb1d0b2f6e090$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b1ceb1d0b2f6e090$var$Xa(a.document);
    }
    return b;
}
function $b1ceb1d0b2f6e090$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b1ceb1d0b2f6e090$var$Oe(a) {
    var b = $b1ceb1d0b2f6e090$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b1ceb1d0b2f6e090$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b1ceb1d0b2f6e090$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b1ceb1d0b2f6e090$var$Ke(c, f);
                var g = $b1ceb1d0b2f6e090$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b1ceb1d0b2f6e090$var$Pe = $b1ceb1d0b2f6e090$var$ia && "documentMode" in document && 11 >= document.documentMode, $b1ceb1d0b2f6e090$var$Qe = null, $b1ceb1d0b2f6e090$var$Re = null, $b1ceb1d0b2f6e090$var$Se = null, $b1ceb1d0b2f6e090$var$Te = !1;
function $b1ceb1d0b2f6e090$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b1ceb1d0b2f6e090$var$Te || null == $b1ceb1d0b2f6e090$var$Qe || $b1ceb1d0b2f6e090$var$Qe !== $b1ceb1d0b2f6e090$var$Xa(d) || (d = $b1ceb1d0b2f6e090$var$Qe, "selectionStart" in d && $b1ceb1d0b2f6e090$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b1ceb1d0b2f6e090$var$Se && $b1ceb1d0b2f6e090$var$Ie($b1ceb1d0b2f6e090$var$Se, d) || ($b1ceb1d0b2f6e090$var$Se = d, d = $b1ceb1d0b2f6e090$var$oe($b1ceb1d0b2f6e090$var$Re, "onSelect"), 0 < d.length && (b = new $b1ceb1d0b2f6e090$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b1ceb1d0b2f6e090$var$Qe)));
}
function $b1ceb1d0b2f6e090$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b1ceb1d0b2f6e090$var$We = {
    animationend: $b1ceb1d0b2f6e090$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b1ceb1d0b2f6e090$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b1ceb1d0b2f6e090$var$Ve("Animation", "AnimationStart"),
    transitionend: $b1ceb1d0b2f6e090$var$Ve("Transition", "TransitionEnd")
}, $b1ceb1d0b2f6e090$var$Xe = {}, $b1ceb1d0b2f6e090$var$Ye = {};
$b1ceb1d0b2f6e090$var$ia && ($b1ceb1d0b2f6e090$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b1ceb1d0b2f6e090$var$We.animationend.animation, delete $b1ceb1d0b2f6e090$var$We.animationiteration.animation, delete $b1ceb1d0b2f6e090$var$We.animationstart.animation), "TransitionEvent" in window || delete $b1ceb1d0b2f6e090$var$We.transitionend.transition);
function $b1ceb1d0b2f6e090$var$Ze(a) {
    if ($b1ceb1d0b2f6e090$var$Xe[a]) return $b1ceb1d0b2f6e090$var$Xe[a];
    if (!$b1ceb1d0b2f6e090$var$We[a]) return a;
    var b = $b1ceb1d0b2f6e090$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b1ceb1d0b2f6e090$var$Ye) return $b1ceb1d0b2f6e090$var$Xe[a] = b[c];
    return a;
}
var $b1ceb1d0b2f6e090$var$$e = $b1ceb1d0b2f6e090$var$Ze("animationend"), $b1ceb1d0b2f6e090$var$af = $b1ceb1d0b2f6e090$var$Ze("animationiteration"), $b1ceb1d0b2f6e090$var$bf = $b1ceb1d0b2f6e090$var$Ze("animationstart"), $b1ceb1d0b2f6e090$var$cf = $b1ceb1d0b2f6e090$var$Ze("transitionend"), $b1ceb1d0b2f6e090$var$df = new Map, $b1ceb1d0b2f6e090$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b1ceb1d0b2f6e090$var$ff(a, b) {
    $b1ceb1d0b2f6e090$var$df.set(a, b);
    $b1ceb1d0b2f6e090$var$fa(b, [
        a
    ]);
}
for(var $b1ceb1d0b2f6e090$var$gf = 0; $b1ceb1d0b2f6e090$var$gf < $b1ceb1d0b2f6e090$var$ef.length; $b1ceb1d0b2f6e090$var$gf++){
    var $b1ceb1d0b2f6e090$var$hf = $b1ceb1d0b2f6e090$var$ef[$b1ceb1d0b2f6e090$var$gf], $b1ceb1d0b2f6e090$var$jf = $b1ceb1d0b2f6e090$var$hf.toLowerCase(), $b1ceb1d0b2f6e090$var$kf = $b1ceb1d0b2f6e090$var$hf[0].toUpperCase() + $b1ceb1d0b2f6e090$var$hf.slice(1);
    $b1ceb1d0b2f6e090$var$ff($b1ceb1d0b2f6e090$var$jf, "on" + $b1ceb1d0b2f6e090$var$kf);
}
$b1ceb1d0b2f6e090$var$ff($b1ceb1d0b2f6e090$var$$e, "onAnimationEnd");
$b1ceb1d0b2f6e090$var$ff($b1ceb1d0b2f6e090$var$af, "onAnimationIteration");
$b1ceb1d0b2f6e090$var$ff($b1ceb1d0b2f6e090$var$bf, "onAnimationStart");
$b1ceb1d0b2f6e090$var$ff("dblclick", "onDoubleClick");
$b1ceb1d0b2f6e090$var$ff("focusin", "onFocus");
$b1ceb1d0b2f6e090$var$ff("focusout", "onBlur");
$b1ceb1d0b2f6e090$var$ff($b1ceb1d0b2f6e090$var$cf, "onTransitionEnd");
$b1ceb1d0b2f6e090$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b1ceb1d0b2f6e090$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b1ceb1d0b2f6e090$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b1ceb1d0b2f6e090$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b1ceb1d0b2f6e090$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b1ceb1d0b2f6e090$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b1ceb1d0b2f6e090$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b1ceb1d0b2f6e090$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b1ceb1d0b2f6e090$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b1ceb1d0b2f6e090$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b1ceb1d0b2f6e090$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b1ceb1d0b2f6e090$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b1ceb1d0b2f6e090$var$lf));
function $b1ceb1d0b2f6e090$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b1ceb1d0b2f6e090$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b1ceb1d0b2f6e090$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b1ceb1d0b2f6e090$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b1ceb1d0b2f6e090$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b1ceb1d0b2f6e090$var$Qb) throw a = $b1ceb1d0b2f6e090$var$Rb, $b1ceb1d0b2f6e090$var$Qb = !1, $b1ceb1d0b2f6e090$var$Rb = null, a;
}
function $b1ceb1d0b2f6e090$var$D(a, b) {
    var c = b[$b1ceb1d0b2f6e090$var$of];
    void 0 === c && (c = b[$b1ceb1d0b2f6e090$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b1ceb1d0b2f6e090$var$pf(b, a, 2, !1), c.add(d));
}
function $b1ceb1d0b2f6e090$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b1ceb1d0b2f6e090$var$pf(c, a, d, b);
}
var $b1ceb1d0b2f6e090$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b1ceb1d0b2f6e090$var$sf(a) {
    if (!a[$b1ceb1d0b2f6e090$var$rf]) {
        a[$b1ceb1d0b2f6e090$var$rf] = !0;
        $b1ceb1d0b2f6e090$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b1ceb1d0b2f6e090$var$mf.has(b) || $b1ceb1d0b2f6e090$var$qf(b, !1, a), $b1ceb1d0b2f6e090$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b1ceb1d0b2f6e090$var$rf] || (b[$b1ceb1d0b2f6e090$var$rf] = !0, $b1ceb1d0b2f6e090$var$qf("selectionchange", !1, b));
    }
}
function $b1ceb1d0b2f6e090$var$pf(a, b, c, d) {
    switch($b1ceb1d0b2f6e090$var$jd(b)){
        case 1:
            var e = $b1ceb1d0b2f6e090$var$ed;
            break;
        case 4:
            e = $b1ceb1d0b2f6e090$var$gd;
            break;
        default:
            e = $b1ceb1d0b2f6e090$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b1ceb1d0b2f6e090$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b1ceb1d0b2f6e090$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b1ceb1d0b2f6e090$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b1ceb1d0b2f6e090$var$Jb(function() {
        var d = f, e = $b1ceb1d0b2f6e090$var$xb(c), g = [];
        a: {
            var h = $b1ceb1d0b2f6e090$var$df.get(a);
            if (void 0 !== h) {
                var k = $b1ceb1d0b2f6e090$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b1ceb1d0b2f6e090$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b1ceb1d0b2f6e090$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b1ceb1d0b2f6e090$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b1ceb1d0b2f6e090$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b1ceb1d0b2f6e090$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b1ceb1d0b2f6e090$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b1ceb1d0b2f6e090$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b1ceb1d0b2f6e090$var$Vd;
                        break;
                    case $b1ceb1d0b2f6e090$var$$e:
                    case $b1ceb1d0b2f6e090$var$af:
                    case $b1ceb1d0b2f6e090$var$bf:
                        k = $b1ceb1d0b2f6e090$var$Hd;
                        break;
                    case $b1ceb1d0b2f6e090$var$cf:
                        k = $b1ceb1d0b2f6e090$var$Xd;
                        break;
                    case "scroll":
                        k = $b1ceb1d0b2f6e090$var$vd;
                        break;
                    case "wheel":
                        k = $b1ceb1d0b2f6e090$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b1ceb1d0b2f6e090$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b1ceb1d0b2f6e090$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b1ceb1d0b2f6e090$var$Kb(w, x), null != F && t.push($b1ceb1d0b2f6e090$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b1ceb1d0b2f6e090$var$wb && (n = c.relatedTarget || c.fromElement) && ($b1ceb1d0b2f6e090$var$Wc(n) || n[$b1ceb1d0b2f6e090$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $b1ceb1d0b2f6e090$var$Wc(n) : null, null !== n && (J = $b1ceb1d0b2f6e090$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $b1ceb1d0b2f6e090$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b1ceb1d0b2f6e090$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b1ceb1d0b2f6e090$var$ue(k);
                        u = null == n ? h : $b1ceb1d0b2f6e090$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b1ceb1d0b2f6e090$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b1ceb1d0b2f6e090$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b1ceb1d0b2f6e090$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b1ceb1d0b2f6e090$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b1ceb1d0b2f6e090$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b1ceb1d0b2f6e090$var$vf(t);
                                x = $b1ceb1d0b2f6e090$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b1ceb1d0b2f6e090$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b1ceb1d0b2f6e090$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $b1ceb1d0b2f6e090$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b1ceb1d0b2f6e090$var$ve;
                else if ($b1ceb1d0b2f6e090$var$me(h)) {
                    if ($b1ceb1d0b2f6e090$var$we) na = $b1ceb1d0b2f6e090$var$Fe;
                    else {
                        na = $b1ceb1d0b2f6e090$var$De;
                        var xa = $b1ceb1d0b2f6e090$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b1ceb1d0b2f6e090$var$Ee);
                if (na && (na = na(a, d))) {
                    $b1ceb1d0b2f6e090$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b1ceb1d0b2f6e090$var$cb(h, "number", h.value);
            }
            xa = d ? $b1ceb1d0b2f6e090$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($b1ceb1d0b2f6e090$var$me(xa) || "true" === xa.contentEditable) $b1ceb1d0b2f6e090$var$Qe = xa, $b1ceb1d0b2f6e090$var$Re = d, $b1ceb1d0b2f6e090$var$Se = null;
                    break;
                case "focusout":
                    $b1ceb1d0b2f6e090$var$Se = $b1ceb1d0b2f6e090$var$Re = $b1ceb1d0b2f6e090$var$Qe = null;
                    break;
                case "mousedown":
                    $b1ceb1d0b2f6e090$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b1ceb1d0b2f6e090$var$Te = !1;
                    $b1ceb1d0b2f6e090$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($b1ceb1d0b2f6e090$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b1ceb1d0b2f6e090$var$Ue(g, c, e);
            }
            var $a;
            if ($b1ceb1d0b2f6e090$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b1ceb1d0b2f6e090$var$ie ? $b1ceb1d0b2f6e090$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b1ceb1d0b2f6e090$var$de && "ko" !== c.locale && ($b1ceb1d0b2f6e090$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b1ceb1d0b2f6e090$var$ie && ($a = $b1ceb1d0b2f6e090$var$nd()) : ($b1ceb1d0b2f6e090$var$kd = e, $b1ceb1d0b2f6e090$var$ld = "value" in $b1ceb1d0b2f6e090$var$kd ? $b1ceb1d0b2f6e090$var$kd.value : $b1ceb1d0b2f6e090$var$kd.textContent, $b1ceb1d0b2f6e090$var$ie = !0)), xa = $b1ceb1d0b2f6e090$var$oe(d, ba), 0 < xa.length && (ba = new $b1ceb1d0b2f6e090$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b1ceb1d0b2f6e090$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b1ceb1d0b2f6e090$var$ce ? $b1ceb1d0b2f6e090$var$je(a, c) : $b1ceb1d0b2f6e090$var$ke(a, c)) d = $b1ceb1d0b2f6e090$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $b1ceb1d0b2f6e090$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $b1ceb1d0b2f6e090$var$se(g, b);
    });
}
function $b1ceb1d0b2f6e090$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b1ceb1d0b2f6e090$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b1ceb1d0b2f6e090$var$Kb(a, c), null != f && d.unshift($b1ceb1d0b2f6e090$var$tf(a, f, e)), f = $b1ceb1d0b2f6e090$var$Kb(a, b), null != f && d.push($b1ceb1d0b2f6e090$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b1ceb1d0b2f6e090$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b1ceb1d0b2f6e090$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b1ceb1d0b2f6e090$var$Kb(c, f), null != k && g.unshift($b1ceb1d0b2f6e090$var$tf(c, k, h))) : e || (k = $b1ceb1d0b2f6e090$var$Kb(c, f), null != k && g.push($b1ceb1d0b2f6e090$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b1ceb1d0b2f6e090$var$xf = /\r\n?/g, $b1ceb1d0b2f6e090$var$yf = /\u0000|\uFFFD/g;
function $b1ceb1d0b2f6e090$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b1ceb1d0b2f6e090$var$xf, "\n").replace($b1ceb1d0b2f6e090$var$yf, "");
}
function $b1ceb1d0b2f6e090$var$Af(a, b, c) {
    b = $b1ceb1d0b2f6e090$var$zf(b);
    if ($b1ceb1d0b2f6e090$var$zf(a) !== b && c) throw Error($b1ceb1d0b2f6e090$var$p(425));
}
function $b1ceb1d0b2f6e090$var$Bf() {}
var $b1ceb1d0b2f6e090$var$Cf = null, $b1ceb1d0b2f6e090$var$Df = null;
function $b1ceb1d0b2f6e090$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b1ceb1d0b2f6e090$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b1ceb1d0b2f6e090$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b1ceb1d0b2f6e090$var$Hf = "function" === typeof Promise ? Promise : void 0, $b1ceb1d0b2f6e090$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b1ceb1d0b2f6e090$var$Hf ? function(a) {
    return $b1ceb1d0b2f6e090$var$Hf.resolve(null).then(a).catch($b1ceb1d0b2f6e090$var$If);
} : $b1ceb1d0b2f6e090$var$Ff;
function $b1ceb1d0b2f6e090$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b1ceb1d0b2f6e090$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b1ceb1d0b2f6e090$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b1ceb1d0b2f6e090$var$bd(b);
}
function $b1ceb1d0b2f6e090$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b1ceb1d0b2f6e090$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b1ceb1d0b2f6e090$var$Nf = Math.random().toString(36).slice(2), $b1ceb1d0b2f6e090$var$Of = "__reactFiber$" + $b1ceb1d0b2f6e090$var$Nf, $b1ceb1d0b2f6e090$var$Pf = "__reactProps$" + $b1ceb1d0b2f6e090$var$Nf, $b1ceb1d0b2f6e090$var$uf = "__reactContainer$" + $b1ceb1d0b2f6e090$var$Nf, $b1ceb1d0b2f6e090$var$of = "__reactEvents$" + $b1ceb1d0b2f6e090$var$Nf, $b1ceb1d0b2f6e090$var$Qf = "__reactListeners$" + $b1ceb1d0b2f6e090$var$Nf, $b1ceb1d0b2f6e090$var$Rf = "__reactHandles$" + $b1ceb1d0b2f6e090$var$Nf;
function $b1ceb1d0b2f6e090$var$Wc(a) {
    var b = a[$b1ceb1d0b2f6e090$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b1ceb1d0b2f6e090$var$uf] || c[$b1ceb1d0b2f6e090$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b1ceb1d0b2f6e090$var$Mf(a); null !== a;){
                if (c = a[$b1ceb1d0b2f6e090$var$Of]) return c;
                a = $b1ceb1d0b2f6e090$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b1ceb1d0b2f6e090$var$Cb(a) {
    a = a[$b1ceb1d0b2f6e090$var$Of] || a[$b1ceb1d0b2f6e090$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b1ceb1d0b2f6e090$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b1ceb1d0b2f6e090$var$p(33));
}
function $b1ceb1d0b2f6e090$var$Db(a) {
    return a[$b1ceb1d0b2f6e090$var$Pf] || null;
}
var $b1ceb1d0b2f6e090$var$Sf = [], $b1ceb1d0b2f6e090$var$Tf = -1;
function $b1ceb1d0b2f6e090$var$Uf(a) {
    return {
        current: a
    };
}
function $b1ceb1d0b2f6e090$var$E(a) {
    0 > $b1ceb1d0b2f6e090$var$Tf || (a.current = $b1ceb1d0b2f6e090$var$Sf[$b1ceb1d0b2f6e090$var$Tf], $b1ceb1d0b2f6e090$var$Sf[$b1ceb1d0b2f6e090$var$Tf] = null, $b1ceb1d0b2f6e090$var$Tf--);
}
function $b1ceb1d0b2f6e090$var$G(a, b) {
    $b1ceb1d0b2f6e090$var$Tf++;
    $b1ceb1d0b2f6e090$var$Sf[$b1ceb1d0b2f6e090$var$Tf] = a.current;
    a.current = b;
}
var $b1ceb1d0b2f6e090$var$Vf = {}, $b1ceb1d0b2f6e090$var$H = $b1ceb1d0b2f6e090$var$Uf($b1ceb1d0b2f6e090$var$Vf), $b1ceb1d0b2f6e090$var$Wf = $b1ceb1d0b2f6e090$var$Uf(!1), $b1ceb1d0b2f6e090$var$Xf = $b1ceb1d0b2f6e090$var$Vf;
function $b1ceb1d0b2f6e090$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b1ceb1d0b2f6e090$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b1ceb1d0b2f6e090$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b1ceb1d0b2f6e090$var$$f() {
    $b1ceb1d0b2f6e090$var$E($b1ceb1d0b2f6e090$var$Wf);
    $b1ceb1d0b2f6e090$var$E($b1ceb1d0b2f6e090$var$H);
}
function $b1ceb1d0b2f6e090$var$ag(a, b, c) {
    if ($b1ceb1d0b2f6e090$var$H.current !== $b1ceb1d0b2f6e090$var$Vf) throw Error($b1ceb1d0b2f6e090$var$p(168));
    $b1ceb1d0b2f6e090$var$G($b1ceb1d0b2f6e090$var$H, b);
    $b1ceb1d0b2f6e090$var$G($b1ceb1d0b2f6e090$var$Wf, c);
}
function $b1ceb1d0b2f6e090$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b1ceb1d0b2f6e090$var$p(108, $b1ceb1d0b2f6e090$var$Ra(a) || "Unknown", e));
    return $b1ceb1d0b2f6e090$var$A({}, c, d);
}
function $b1ceb1d0b2f6e090$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b1ceb1d0b2f6e090$var$Vf;
    $b1ceb1d0b2f6e090$var$Xf = $b1ceb1d0b2f6e090$var$H.current;
    $b1ceb1d0b2f6e090$var$G($b1ceb1d0b2f6e090$var$H, a);
    $b1ceb1d0b2f6e090$var$G($b1ceb1d0b2f6e090$var$Wf, $b1ceb1d0b2f6e090$var$Wf.current);
    return !0;
}
function $b1ceb1d0b2f6e090$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b1ceb1d0b2f6e090$var$p(169));
    c ? (a = $b1ceb1d0b2f6e090$var$bg(a, b, $b1ceb1d0b2f6e090$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b1ceb1d0b2f6e090$var$E($b1ceb1d0b2f6e090$var$Wf), $b1ceb1d0b2f6e090$var$E($b1ceb1d0b2f6e090$var$H), $b1ceb1d0b2f6e090$var$G($b1ceb1d0b2f6e090$var$H, a)) : $b1ceb1d0b2f6e090$var$E($b1ceb1d0b2f6e090$var$Wf);
    $b1ceb1d0b2f6e090$var$G($b1ceb1d0b2f6e090$var$Wf, c);
}
var $b1ceb1d0b2f6e090$var$eg = null, $b1ceb1d0b2f6e090$var$fg = !1, $b1ceb1d0b2f6e090$var$gg = !1;
function $b1ceb1d0b2f6e090$var$hg(a) {
    null === $b1ceb1d0b2f6e090$var$eg ? $b1ceb1d0b2f6e090$var$eg = [
        a
    ] : $b1ceb1d0b2f6e090$var$eg.push(a);
}
function $b1ceb1d0b2f6e090$var$ig(a) {
    $b1ceb1d0b2f6e090$var$fg = !0;
    $b1ceb1d0b2f6e090$var$hg(a);
}
function $b1ceb1d0b2f6e090$var$jg() {
    if (!$b1ceb1d0b2f6e090$var$gg && null !== $b1ceb1d0b2f6e090$var$eg) {
        $b1ceb1d0b2f6e090$var$gg = !0;
        var a = 0, b = $b1ceb1d0b2f6e090$var$C;
        try {
            var c = $b1ceb1d0b2f6e090$var$eg;
            for($b1ceb1d0b2f6e090$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b1ceb1d0b2f6e090$var$eg = null;
            $b1ceb1d0b2f6e090$var$fg = !1;
        } catch (e) {
            throw null !== $b1ceb1d0b2f6e090$var$eg && ($b1ceb1d0b2f6e090$var$eg = $b1ceb1d0b2f6e090$var$eg.slice(a + 1)), $b1ceb1d0b2f6e090$var$ac($b1ceb1d0b2f6e090$var$fc, $b1ceb1d0b2f6e090$var$jg), e;
        } finally{
            $b1ceb1d0b2f6e090$var$C = b, $b1ceb1d0b2f6e090$var$gg = !1;
        }
    }
    return null;
}
var $b1ceb1d0b2f6e090$var$kg = [], $b1ceb1d0b2f6e090$var$lg = 0, $b1ceb1d0b2f6e090$var$mg = null, $b1ceb1d0b2f6e090$var$ng = 0, $b1ceb1d0b2f6e090$var$og = [], $b1ceb1d0b2f6e090$var$pg = 0, $b1ceb1d0b2f6e090$var$qg = null, $b1ceb1d0b2f6e090$var$rg = 1, $b1ceb1d0b2f6e090$var$sg = "";
function $b1ceb1d0b2f6e090$var$tg(a, b) {
    $b1ceb1d0b2f6e090$var$kg[$b1ceb1d0b2f6e090$var$lg++] = $b1ceb1d0b2f6e090$var$ng;
    $b1ceb1d0b2f6e090$var$kg[$b1ceb1d0b2f6e090$var$lg++] = $b1ceb1d0b2f6e090$var$mg;
    $b1ceb1d0b2f6e090$var$mg = a;
    $b1ceb1d0b2f6e090$var$ng = b;
}
function $b1ceb1d0b2f6e090$var$ug(a, b, c) {
    $b1ceb1d0b2f6e090$var$og[$b1ceb1d0b2f6e090$var$pg++] = $b1ceb1d0b2f6e090$var$rg;
    $b1ceb1d0b2f6e090$var$og[$b1ceb1d0b2f6e090$var$pg++] = $b1ceb1d0b2f6e090$var$sg;
    $b1ceb1d0b2f6e090$var$og[$b1ceb1d0b2f6e090$var$pg++] = $b1ceb1d0b2f6e090$var$qg;
    $b1ceb1d0b2f6e090$var$qg = a;
    var d = $b1ceb1d0b2f6e090$var$rg;
    a = $b1ceb1d0b2f6e090$var$sg;
    var e = 32 - $b1ceb1d0b2f6e090$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b1ceb1d0b2f6e090$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b1ceb1d0b2f6e090$var$rg = 1 << 32 - $b1ceb1d0b2f6e090$var$oc(b) + e | c << e | d;
        $b1ceb1d0b2f6e090$var$sg = f + a;
    } else $b1ceb1d0b2f6e090$var$rg = 1 << f | c << e | d, $b1ceb1d0b2f6e090$var$sg = a;
}
function $b1ceb1d0b2f6e090$var$vg(a) {
    null !== a.return && ($b1ceb1d0b2f6e090$var$tg(a, 1), $b1ceb1d0b2f6e090$var$ug(a, 1, 0));
}
function $b1ceb1d0b2f6e090$var$wg(a) {
    for(; a === $b1ceb1d0b2f6e090$var$mg;)$b1ceb1d0b2f6e090$var$mg = $b1ceb1d0b2f6e090$var$kg[--$b1ceb1d0b2f6e090$var$lg], $b1ceb1d0b2f6e090$var$kg[$b1ceb1d0b2f6e090$var$lg] = null, $b1ceb1d0b2f6e090$var$ng = $b1ceb1d0b2f6e090$var$kg[--$b1ceb1d0b2f6e090$var$lg], $b1ceb1d0b2f6e090$var$kg[$b1ceb1d0b2f6e090$var$lg] = null;
    for(; a === $b1ceb1d0b2f6e090$var$qg;)$b1ceb1d0b2f6e090$var$qg = $b1ceb1d0b2f6e090$var$og[--$b1ceb1d0b2f6e090$var$pg], $b1ceb1d0b2f6e090$var$og[$b1ceb1d0b2f6e090$var$pg] = null, $b1ceb1d0b2f6e090$var$sg = $b1ceb1d0b2f6e090$var$og[--$b1ceb1d0b2f6e090$var$pg], $b1ceb1d0b2f6e090$var$og[$b1ceb1d0b2f6e090$var$pg] = null, $b1ceb1d0b2f6e090$var$rg = $b1ceb1d0b2f6e090$var$og[--$b1ceb1d0b2f6e090$var$pg], $b1ceb1d0b2f6e090$var$og[$b1ceb1d0b2f6e090$var$pg] = null;
}
var $b1ceb1d0b2f6e090$var$xg = null, $b1ceb1d0b2f6e090$var$yg = null, $b1ceb1d0b2f6e090$var$I = !1, $b1ceb1d0b2f6e090$var$zg = null;
function $b1ceb1d0b2f6e090$var$Ag(a, b) {
    var c = $b1ceb1d0b2f6e090$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b1ceb1d0b2f6e090$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b1ceb1d0b2f6e090$var$xg = a, $b1ceb1d0b2f6e090$var$yg = $b1ceb1d0b2f6e090$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b1ceb1d0b2f6e090$var$xg = a, $b1ceb1d0b2f6e090$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b1ceb1d0b2f6e090$var$qg ? {
                id: $b1ceb1d0b2f6e090$var$rg,
                overflow: $b1ceb1d0b2f6e090$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b1ceb1d0b2f6e090$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b1ceb1d0b2f6e090$var$xg = a, $b1ceb1d0b2f6e090$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b1ceb1d0b2f6e090$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b1ceb1d0b2f6e090$var$Eg(a) {
    if ($b1ceb1d0b2f6e090$var$I) {
        var b = $b1ceb1d0b2f6e090$var$yg;
        if (b) {
            var c = b;
            if (!$b1ceb1d0b2f6e090$var$Cg(a, b)) {
                if ($b1ceb1d0b2f6e090$var$Dg(a)) throw Error($b1ceb1d0b2f6e090$var$p(418));
                b = $b1ceb1d0b2f6e090$var$Lf(c.nextSibling);
                var d = $b1ceb1d0b2f6e090$var$xg;
                b && $b1ceb1d0b2f6e090$var$Cg(a, b) ? $b1ceb1d0b2f6e090$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b1ceb1d0b2f6e090$var$I = !1, $b1ceb1d0b2f6e090$var$xg = a);
            }
        } else {
            if ($b1ceb1d0b2f6e090$var$Dg(a)) throw Error($b1ceb1d0b2f6e090$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b1ceb1d0b2f6e090$var$I = !1;
            $b1ceb1d0b2f6e090$var$xg = a;
        }
    }
}
function $b1ceb1d0b2f6e090$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b1ceb1d0b2f6e090$var$xg = a;
}
function $b1ceb1d0b2f6e090$var$Gg(a) {
    if (a !== $b1ceb1d0b2f6e090$var$xg) return !1;
    if (!$b1ceb1d0b2f6e090$var$I) return $b1ceb1d0b2f6e090$var$Fg(a), $b1ceb1d0b2f6e090$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b1ceb1d0b2f6e090$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b1ceb1d0b2f6e090$var$yg)) {
        if ($b1ceb1d0b2f6e090$var$Dg(a)) throw $b1ceb1d0b2f6e090$var$Hg(), Error($b1ceb1d0b2f6e090$var$p(418));
        for(; b;)$b1ceb1d0b2f6e090$var$Ag(a, b), b = $b1ceb1d0b2f6e090$var$Lf(b.nextSibling);
    }
    $b1ceb1d0b2f6e090$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b1ceb1d0b2f6e090$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b1ceb1d0b2f6e090$var$yg = $b1ceb1d0b2f6e090$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b1ceb1d0b2f6e090$var$yg = null;
        }
    } else $b1ceb1d0b2f6e090$var$yg = $b1ceb1d0b2f6e090$var$xg ? $b1ceb1d0b2f6e090$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b1ceb1d0b2f6e090$var$Hg() {
    for(var a = $b1ceb1d0b2f6e090$var$yg; a;)a = $b1ceb1d0b2f6e090$var$Lf(a.nextSibling);
}
function $b1ceb1d0b2f6e090$var$Ig() {
    $b1ceb1d0b2f6e090$var$yg = $b1ceb1d0b2f6e090$var$xg = null;
    $b1ceb1d0b2f6e090$var$I = !1;
}
function $b1ceb1d0b2f6e090$var$Jg(a) {
    null === $b1ceb1d0b2f6e090$var$zg ? $b1ceb1d0b2f6e090$var$zg = [
        a
    ] : $b1ceb1d0b2f6e090$var$zg.push(a);
}
var $b1ceb1d0b2f6e090$var$Kg = $b1ceb1d0b2f6e090$var$ua.ReactCurrentBatchConfig;
function $b1ceb1d0b2f6e090$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b1ceb1d0b2f6e090$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b1ceb1d0b2f6e090$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b1ceb1d0b2f6e090$var$p(284));
        if (!c._owner) throw Error($b1ceb1d0b2f6e090$var$p(290, a));
    }
    return a;
}
function $b1ceb1d0b2f6e090$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b1ceb1d0b2f6e090$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b1ceb1d0b2f6e090$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $b1ceb1d0b2f6e090$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b1ceb1d0b2f6e090$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b1ceb1d0b2f6e090$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b1ceb1d0b2f6e090$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b1ceb1d0b2f6e090$var$Ha && $b1ceb1d0b2f6e090$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $b1ceb1d0b2f6e090$var$Lg(a, b, c), d.return = a, d;
        d = $b1ceb1d0b2f6e090$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b1ceb1d0b2f6e090$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b1ceb1d0b2f6e090$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b1ceb1d0b2f6e090$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b1ceb1d0b2f6e090$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b1ceb1d0b2f6e090$var$va:
                    return c = $b1ceb1d0b2f6e090$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $b1ceb1d0b2f6e090$var$Lg(a, null, b), c.return = a, c;
                case $b1ceb1d0b2f6e090$var$wa:
                    return b = $b1ceb1d0b2f6e090$var$Sg(b, a.mode, c), b.return = a, b;
                case $b1ceb1d0b2f6e090$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b1ceb1d0b2f6e090$var$eb(b) || $b1ceb1d0b2f6e090$var$Ka(b)) return b = $b1ceb1d0b2f6e090$var$Tg(b, a.mode, c, null), b.return = a, b;
            $b1ceb1d0b2f6e090$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b1ceb1d0b2f6e090$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b1ceb1d0b2f6e090$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b1ceb1d0b2f6e090$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b1ceb1d0b2f6e090$var$eb(c) || $b1ceb1d0b2f6e090$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b1ceb1d0b2f6e090$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b1ceb1d0b2f6e090$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b1ceb1d0b2f6e090$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b1ceb1d0b2f6e090$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b1ceb1d0b2f6e090$var$eb(d) || $b1ceb1d0b2f6e090$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b1ceb1d0b2f6e090$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b1ceb1d0b2f6e090$var$I && $b1ceb1d0b2f6e090$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b1ceb1d0b2f6e090$var$I && $b1ceb1d0b2f6e090$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b1ceb1d0b2f6e090$var$I && $b1ceb1d0b2f6e090$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b1ceb1d0b2f6e090$var$Ka(h);
        if ("function" !== typeof l) throw Error($b1ceb1d0b2f6e090$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b1ceb1d0b2f6e090$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b1ceb1d0b2f6e090$var$I && $b1ceb1d0b2f6e090$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b1ceb1d0b2f6e090$var$I && $b1ceb1d0b2f6e090$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b1ceb1d0b2f6e090$var$I && $b1ceb1d0b2f6e090$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b1ceb1d0b2f6e090$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b1ceb1d0b2f6e090$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b1ceb1d0b2f6e090$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b1ceb1d0b2f6e090$var$Ha && $b1ceb1d0b2f6e090$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b1ceb1d0b2f6e090$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b1ceb1d0b2f6e090$var$ya ? (d = $b1ceb1d0b2f6e090$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b1ceb1d0b2f6e090$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $b1ceb1d0b2f6e090$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b1ceb1d0b2f6e090$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b1ceb1d0b2f6e090$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b1ceb1d0b2f6e090$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b1ceb1d0b2f6e090$var$eb(f)) return n(a, d, f, h);
            if ($b1ceb1d0b2f6e090$var$Ka(f)) return t(a, d, f, h);
            $b1ceb1d0b2f6e090$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b1ceb1d0b2f6e090$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b1ceb1d0b2f6e090$var$Ug = $b1ceb1d0b2f6e090$var$Og(!0), $b1ceb1d0b2f6e090$var$Vg = $b1ceb1d0b2f6e090$var$Og(!1), $b1ceb1d0b2f6e090$var$Wg = $b1ceb1d0b2f6e090$var$Uf(null), $b1ceb1d0b2f6e090$var$Xg = null, $b1ceb1d0b2f6e090$var$Yg = null, $b1ceb1d0b2f6e090$var$Zg = null;
function $b1ceb1d0b2f6e090$var$$g() {
    $b1ceb1d0b2f6e090$var$Zg = $b1ceb1d0b2f6e090$var$Yg = $b1ceb1d0b2f6e090$var$Xg = null;
}
function $b1ceb1d0b2f6e090$var$ah(a) {
    var b = $b1ceb1d0b2f6e090$var$Wg.current;
    $b1ceb1d0b2f6e090$var$E($b1ceb1d0b2f6e090$var$Wg);
    a._currentValue = b;
}
function $b1ceb1d0b2f6e090$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b1ceb1d0b2f6e090$var$ch(a, b) {
    $b1ceb1d0b2f6e090$var$Xg = a;
    $b1ceb1d0b2f6e090$var$Zg = $b1ceb1d0b2f6e090$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b1ceb1d0b2f6e090$var$dh = !0), a.firstContext = null);
}
function $b1ceb1d0b2f6e090$var$eh(a) {
    var b = a._currentValue;
    if ($b1ceb1d0b2f6e090$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b1ceb1d0b2f6e090$var$Yg) {
            if (null === $b1ceb1d0b2f6e090$var$Xg) throw Error($b1ceb1d0b2f6e090$var$p(308));
            $b1ceb1d0b2f6e090$var$Yg = a;
            $b1ceb1d0b2f6e090$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b1ceb1d0b2f6e090$var$Yg = $b1ceb1d0b2f6e090$var$Yg.next = a;
    }
    return b;
}
var $b1ceb1d0b2f6e090$var$fh = null;
function $b1ceb1d0b2f6e090$var$gh(a) {
    null === $b1ceb1d0b2f6e090$var$fh ? $b1ceb1d0b2f6e090$var$fh = [
        a
    ] : $b1ceb1d0b2f6e090$var$fh.push(a);
}
function $b1ceb1d0b2f6e090$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b1ceb1d0b2f6e090$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b1ceb1d0b2f6e090$var$ih(a, d);
}
function $b1ceb1d0b2f6e090$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b1ceb1d0b2f6e090$var$jh = !1;
function $b1ceb1d0b2f6e090$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b1ceb1d0b2f6e090$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b1ceb1d0b2f6e090$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b1ceb1d0b2f6e090$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b1ceb1d0b2f6e090$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b1ceb1d0b2f6e090$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b1ceb1d0b2f6e090$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b1ceb1d0b2f6e090$var$ih(a, c);
}
function $b1ceb1d0b2f6e090$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b1ceb1d0b2f6e090$var$Cc(a, c);
    }
}
function $b1ceb1d0b2f6e090$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b1ceb1d0b2f6e090$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $b1ceb1d0b2f6e090$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b1ceb1d0b2f6e090$var$A({}, q, r);
                            break a;
                        case 2:
                            $b1ceb1d0b2f6e090$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b1ceb1d0b2f6e090$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b1ceb1d0b2f6e090$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b1ceb1d0b2f6e090$var$p(191, e));
            e.call(d);
        }
    }
}
var $b1ceb1d0b2f6e090$var$th = {}, $b1ceb1d0b2f6e090$var$uh = $b1ceb1d0b2f6e090$var$Uf($b1ceb1d0b2f6e090$var$th), $b1ceb1d0b2f6e090$var$vh = $b1ceb1d0b2f6e090$var$Uf($b1ceb1d0b2f6e090$var$th), $b1ceb1d0b2f6e090$var$wh = $b1ceb1d0b2f6e090$var$Uf($b1ceb1d0b2f6e090$var$th);
function $b1ceb1d0b2f6e090$var$xh(a) {
    if (a === $b1ceb1d0b2f6e090$var$th) throw Error($b1ceb1d0b2f6e090$var$p(174));
    return a;
}
function $b1ceb1d0b2f6e090$var$yh(a, b) {
    $b1ceb1d0b2f6e090$var$G($b1ceb1d0b2f6e090$var$wh, b);
    $b1ceb1d0b2f6e090$var$G($b1ceb1d0b2f6e090$var$vh, a);
    $b1ceb1d0b2f6e090$var$G($b1ceb1d0b2f6e090$var$uh, $b1ceb1d0b2f6e090$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b1ceb1d0b2f6e090$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b1ceb1d0b2f6e090$var$lb(b, a);
    }
    $b1ceb1d0b2f6e090$var$E($b1ceb1d0b2f6e090$var$uh);
    $b1ceb1d0b2f6e090$var$G($b1ceb1d0b2f6e090$var$uh, b);
}
function $b1ceb1d0b2f6e090$var$zh() {
    $b1ceb1d0b2f6e090$var$E($b1ceb1d0b2f6e090$var$uh);
    $b1ceb1d0b2f6e090$var$E($b1ceb1d0b2f6e090$var$vh);
    $b1ceb1d0b2f6e090$var$E($b1ceb1d0b2f6e090$var$wh);
}
function $b1ceb1d0b2f6e090$var$Ah(a) {
    $b1ceb1d0b2f6e090$var$xh($b1ceb1d0b2f6e090$var$wh.current);
    var b = $b1ceb1d0b2f6e090$var$xh($b1ceb1d0b2f6e090$var$uh.current);
    var c = $b1ceb1d0b2f6e090$var$lb(b, a.type);
    b !== c && ($b1ceb1d0b2f6e090$var$G($b1ceb1d0b2f6e090$var$vh, a), $b1ceb1d0b2f6e090$var$G($b1ceb1d0b2f6e090$var$uh, c));
}
function $b1ceb1d0b2f6e090$var$Bh(a) {
    $b1ceb1d0b2f6e090$var$vh.current === a && ($b1ceb1d0b2f6e090$var$E($b1ceb1d0b2f6e090$var$uh), $b1ceb1d0b2f6e090$var$E($b1ceb1d0b2f6e090$var$vh));
}
var $b1ceb1d0b2f6e090$var$L = $b1ceb1d0b2f6e090$var$Uf(0);
function $b1ceb1d0b2f6e090$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b1ceb1d0b2f6e090$var$Dh = [];
function $b1ceb1d0b2f6e090$var$Eh() {
    for(var a = 0; a < $b1ceb1d0b2f6e090$var$Dh.length; a++)$b1ceb1d0b2f6e090$var$Dh[a]._workInProgressVersionPrimary = null;
    $b1ceb1d0b2f6e090$var$Dh.length = 0;
}
var $b1ceb1d0b2f6e090$var$Fh = $b1ceb1d0b2f6e090$var$ua.ReactCurrentDispatcher, $b1ceb1d0b2f6e090$var$Gh = $b1ceb1d0b2f6e090$var$ua.ReactCurrentBatchConfig, $b1ceb1d0b2f6e090$var$Hh = 0, $b1ceb1d0b2f6e090$var$M = null, $b1ceb1d0b2f6e090$var$N = null, $b1ceb1d0b2f6e090$var$O = null, $b1ceb1d0b2f6e090$var$Ih = !1, $b1ceb1d0b2f6e090$var$Jh = !1, $b1ceb1d0b2f6e090$var$Kh = 0, $b1ceb1d0b2f6e090$var$Lh = 0;
function $b1ceb1d0b2f6e090$var$P() {
    throw Error($b1ceb1d0b2f6e090$var$p(321));
}
function $b1ceb1d0b2f6e090$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b1ceb1d0b2f6e090$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b1ceb1d0b2f6e090$var$Nh(a, b, c, d, e, f) {
    $b1ceb1d0b2f6e090$var$Hh = f;
    $b1ceb1d0b2f6e090$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b1ceb1d0b2f6e090$var$Fh.current = null === a || null === a.memoizedState ? $b1ceb1d0b2f6e090$var$Oh : $b1ceb1d0b2f6e090$var$Ph;
    a = c(d, e);
    if ($b1ceb1d0b2f6e090$var$Jh) {
        f = 0;
        do {
            $b1ceb1d0b2f6e090$var$Jh = !1;
            $b1ceb1d0b2f6e090$var$Kh = 0;
            if (25 <= f) throw Error($b1ceb1d0b2f6e090$var$p(301));
            f += 1;
            $b1ceb1d0b2f6e090$var$O = $b1ceb1d0b2f6e090$var$N = null;
            b.updateQueue = null;
            $b1ceb1d0b2f6e090$var$Fh.current = $b1ceb1d0b2f6e090$var$Qh;
            a = c(d, e);
        }while ($b1ceb1d0b2f6e090$var$Jh);
    }
    $b1ceb1d0b2f6e090$var$Fh.current = $b1ceb1d0b2f6e090$var$Rh;
    b = null !== $b1ceb1d0b2f6e090$var$N && null !== $b1ceb1d0b2f6e090$var$N.next;
    $b1ceb1d0b2f6e090$var$Hh = 0;
    $b1ceb1d0b2f6e090$var$O = $b1ceb1d0b2f6e090$var$N = $b1ceb1d0b2f6e090$var$M = null;
    $b1ceb1d0b2f6e090$var$Ih = !1;
    if (b) throw Error($b1ceb1d0b2f6e090$var$p(300));
    return a;
}
function $b1ceb1d0b2f6e090$var$Sh() {
    var a = 0 !== $b1ceb1d0b2f6e090$var$Kh;
    $b1ceb1d0b2f6e090$var$Kh = 0;
    return a;
}
function $b1ceb1d0b2f6e090$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b1ceb1d0b2f6e090$var$O ? $b1ceb1d0b2f6e090$var$M.memoizedState = $b1ceb1d0b2f6e090$var$O = a : $b1ceb1d0b2f6e090$var$O = $b1ceb1d0b2f6e090$var$O.next = a;
    return $b1ceb1d0b2f6e090$var$O;
}
function $b1ceb1d0b2f6e090$var$Uh() {
    if (null === $b1ceb1d0b2f6e090$var$N) {
        var a = $b1ceb1d0b2f6e090$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b1ceb1d0b2f6e090$var$N.next;
    var b = null === $b1ceb1d0b2f6e090$var$O ? $b1ceb1d0b2f6e090$var$M.memoizedState : $b1ceb1d0b2f6e090$var$O.next;
    if (null !== b) $b1ceb1d0b2f6e090$var$O = b, $b1ceb1d0b2f6e090$var$N = a;
    else {
        if (null === a) throw Error($b1ceb1d0b2f6e090$var$p(310));
        $b1ceb1d0b2f6e090$var$N = a;
        a = {
            memoizedState: $b1ceb1d0b2f6e090$var$N.memoizedState,
            baseState: $b1ceb1d0b2f6e090$var$N.baseState,
            baseQueue: $b1ceb1d0b2f6e090$var$N.baseQueue,
            queue: $b1ceb1d0b2f6e090$var$N.queue,
            next: null
        };
        null === $b1ceb1d0b2f6e090$var$O ? $b1ceb1d0b2f6e090$var$M.memoizedState = $b1ceb1d0b2f6e090$var$O = a : $b1ceb1d0b2f6e090$var$O = $b1ceb1d0b2f6e090$var$O.next = a;
    }
    return $b1ceb1d0b2f6e090$var$O;
}
function $b1ceb1d0b2f6e090$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b1ceb1d0b2f6e090$var$Wh(a) {
    var b = $b1ceb1d0b2f6e090$var$Uh(), c = b.queue;
    if (null === c) throw Error($b1ceb1d0b2f6e090$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b1ceb1d0b2f6e090$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b1ceb1d0b2f6e090$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b1ceb1d0b2f6e090$var$M.lanes |= m;
                $b1ceb1d0b2f6e090$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b1ceb1d0b2f6e090$var$He(d, b.memoizedState) || ($b1ceb1d0b2f6e090$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b1ceb1d0b2f6e090$var$M.lanes |= f, $b1ceb1d0b2f6e090$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b1ceb1d0b2f6e090$var$Xh(a) {
    var b = $b1ceb1d0b2f6e090$var$Uh(), c = b.queue;
    if (null === c) throw Error($b1ceb1d0b2f6e090$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b1ceb1d0b2f6e090$var$He(f, b.memoizedState) || ($b1ceb1d0b2f6e090$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b1ceb1d0b2f6e090$var$Yh() {}
function $b1ceb1d0b2f6e090$var$Zh(a, b) {
    var c = $b1ceb1d0b2f6e090$var$M, d = $b1ceb1d0b2f6e090$var$Uh(), e = b(), f = !$b1ceb1d0b2f6e090$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b1ceb1d0b2f6e090$var$dh = !0);
    d = d.queue;
    $b1ceb1d0b2f6e090$var$$h($b1ceb1d0b2f6e090$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b1ceb1d0b2f6e090$var$O && $b1ceb1d0b2f6e090$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b1ceb1d0b2f6e090$var$bi(9, $b1ceb1d0b2f6e090$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $b1ceb1d0b2f6e090$var$Q) throw Error($b1ceb1d0b2f6e090$var$p(349));
        0 !== ($b1ceb1d0b2f6e090$var$Hh & 30) || $b1ceb1d0b2f6e090$var$di(c, b, e);
    }
    return e;
}
function $b1ceb1d0b2f6e090$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b1ceb1d0b2f6e090$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b1ceb1d0b2f6e090$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b1ceb1d0b2f6e090$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b1ceb1d0b2f6e090$var$ei(b) && $b1ceb1d0b2f6e090$var$fi(a);
}
function $b1ceb1d0b2f6e090$var$ai(a, b, c) {
    return c(function() {
        $b1ceb1d0b2f6e090$var$ei(b) && $b1ceb1d0b2f6e090$var$fi(a);
    });
}
function $b1ceb1d0b2f6e090$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b1ceb1d0b2f6e090$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b1ceb1d0b2f6e090$var$fi(a) {
    var b = $b1ceb1d0b2f6e090$var$ih(a, 1);
    null !== b && $b1ceb1d0b2f6e090$var$gi(b, a, 1, -1);
}
function $b1ceb1d0b2f6e090$var$hi(a) {
    var b = $b1ceb1d0b2f6e090$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b1ceb1d0b2f6e090$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b1ceb1d0b2f6e090$var$ii.bind(null, $b1ceb1d0b2f6e090$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b1ceb1d0b2f6e090$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b1ceb1d0b2f6e090$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b1ceb1d0b2f6e090$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b1ceb1d0b2f6e090$var$ji() {
    return $b1ceb1d0b2f6e090$var$Uh().memoizedState;
}
function $b1ceb1d0b2f6e090$var$ki(a, b, c, d) {
    var e = $b1ceb1d0b2f6e090$var$Th();
    $b1ceb1d0b2f6e090$var$M.flags |= a;
    e.memoizedState = $b1ceb1d0b2f6e090$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b1ceb1d0b2f6e090$var$li(a, b, c, d) {
    var e = $b1ceb1d0b2f6e090$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b1ceb1d0b2f6e090$var$N) {
        var g = $b1ceb1d0b2f6e090$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $b1ceb1d0b2f6e090$var$Mh(d, g.deps)) {
            e.memoizedState = $b1ceb1d0b2f6e090$var$bi(b, c, f, d);
            return;
        }
    }
    $b1ceb1d0b2f6e090$var$M.flags |= a;
    e.memoizedState = $b1ceb1d0b2f6e090$var$bi(1 | b, c, f, d);
}
function $b1ceb1d0b2f6e090$var$mi(a, b) {
    return $b1ceb1d0b2f6e090$var$ki(8390656, 8, a, b);
}
function $b1ceb1d0b2f6e090$var$$h(a, b) {
    return $b1ceb1d0b2f6e090$var$li(2048, 8, a, b);
}
function $b1ceb1d0b2f6e090$var$ni(a, b) {
    return $b1ceb1d0b2f6e090$var$li(4, 2, a, b);
}
function $b1ceb1d0b2f6e090$var$oi(a, b) {
    return $b1ceb1d0b2f6e090$var$li(4, 4, a, b);
}
function $b1ceb1d0b2f6e090$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b1ceb1d0b2f6e090$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b1ceb1d0b2f6e090$var$li(4, 4, $b1ceb1d0b2f6e090$var$pi.bind(null, b, a), c);
}
function $b1ceb1d0b2f6e090$var$ri() {}
function $b1ceb1d0b2f6e090$var$si(a, b) {
    var c = $b1ceb1d0b2f6e090$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b1ceb1d0b2f6e090$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b1ceb1d0b2f6e090$var$ti(a, b) {
    var c = $b1ceb1d0b2f6e090$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b1ceb1d0b2f6e090$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b1ceb1d0b2f6e090$var$ui(a, b, c) {
    if (0 === ($b1ceb1d0b2f6e090$var$Hh & 21)) return a.baseState && (a.baseState = !1, $b1ceb1d0b2f6e090$var$dh = !0), a.memoizedState = c;
    $b1ceb1d0b2f6e090$var$He(c, b) || (c = $b1ceb1d0b2f6e090$var$yc(), $b1ceb1d0b2f6e090$var$M.lanes |= c, $b1ceb1d0b2f6e090$var$rh |= c, a.baseState = !0);
    return b;
}
function $b1ceb1d0b2f6e090$var$vi(a, b) {
    var c = $b1ceb1d0b2f6e090$var$C;
    $b1ceb1d0b2f6e090$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b1ceb1d0b2f6e090$var$Gh.transition;
    $b1ceb1d0b2f6e090$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b1ceb1d0b2f6e090$var$C = c, $b1ceb1d0b2f6e090$var$Gh.transition = d;
    }
}
function $b1ceb1d0b2f6e090$var$wi() {
    return $b1ceb1d0b2f6e090$var$Uh().memoizedState;
}
function $b1ceb1d0b2f6e090$var$xi(a, b, c) {
    var d = $b1ceb1d0b2f6e090$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b1ceb1d0b2f6e090$var$zi(a)) $b1ceb1d0b2f6e090$var$Ai(b, c);
    else if (c = $b1ceb1d0b2f6e090$var$hh(a, b, c, d), null !== c) {
        var e = $b1ceb1d0b2f6e090$var$R();
        $b1ceb1d0b2f6e090$var$gi(c, a, d, e);
        $b1ceb1d0b2f6e090$var$Bi(c, b, d);
    }
}
function $b1ceb1d0b2f6e090$var$ii(a, b, c) {
    var d = $b1ceb1d0b2f6e090$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b1ceb1d0b2f6e090$var$zi(a)) $b1ceb1d0b2f6e090$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b1ceb1d0b2f6e090$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b1ceb1d0b2f6e090$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b1ceb1d0b2f6e090$var$hh(a, b, e, d);
        null !== c && (e = $b1ceb1d0b2f6e090$var$R(), $b1ceb1d0b2f6e090$var$gi(c, a, d, e), $b1ceb1d0b2f6e090$var$Bi(c, b, d));
    }
}
function $b1ceb1d0b2f6e090$var$zi(a) {
    var b = a.alternate;
    return a === $b1ceb1d0b2f6e090$var$M || null !== b && b === $b1ceb1d0b2f6e090$var$M;
}
function $b1ceb1d0b2f6e090$var$Ai(a, b) {
    $b1ceb1d0b2f6e090$var$Jh = $b1ceb1d0b2f6e090$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b1ceb1d0b2f6e090$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b1ceb1d0b2f6e090$var$Cc(a, c);
    }
}
var $b1ceb1d0b2f6e090$var$Rh = {
    readContext: $b1ceb1d0b2f6e090$var$eh,
    useCallback: $b1ceb1d0b2f6e090$var$P,
    useContext: $b1ceb1d0b2f6e090$var$P,
    useEffect: $b1ceb1d0b2f6e090$var$P,
    useImperativeHandle: $b1ceb1d0b2f6e090$var$P,
    useInsertionEffect: $b1ceb1d0b2f6e090$var$P,
    useLayoutEffect: $b1ceb1d0b2f6e090$var$P,
    useMemo: $b1ceb1d0b2f6e090$var$P,
    useReducer: $b1ceb1d0b2f6e090$var$P,
    useRef: $b1ceb1d0b2f6e090$var$P,
    useState: $b1ceb1d0b2f6e090$var$P,
    useDebugValue: $b1ceb1d0b2f6e090$var$P,
    useDeferredValue: $b1ceb1d0b2f6e090$var$P,
    useTransition: $b1ceb1d0b2f6e090$var$P,
    useMutableSource: $b1ceb1d0b2f6e090$var$P,
    useSyncExternalStore: $b1ceb1d0b2f6e090$var$P,
    useId: $b1ceb1d0b2f6e090$var$P,
    unstable_isNewReconciler: !1
}, $b1ceb1d0b2f6e090$var$Oh = {
    readContext: $b1ceb1d0b2f6e090$var$eh,
    useCallback: function(a, b) {
        $b1ceb1d0b2f6e090$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b1ceb1d0b2f6e090$var$eh,
    useEffect: $b1ceb1d0b2f6e090$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b1ceb1d0b2f6e090$var$ki(4194308, 4, $b1ceb1d0b2f6e090$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b1ceb1d0b2f6e090$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $b1ceb1d0b2f6e090$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $b1ceb1d0b2f6e090$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b1ceb1d0b2f6e090$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b1ceb1d0b2f6e090$var$xi.bind(null, $b1ceb1d0b2f6e090$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $b1ceb1d0b2f6e090$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b1ceb1d0b2f6e090$var$hi,
    useDebugValue: $b1ceb1d0b2f6e090$var$ri,
    useDeferredValue: function(a) {
        return $b1ceb1d0b2f6e090$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $b1ceb1d0b2f6e090$var$hi(!1), b = a[0];
        a = $b1ceb1d0b2f6e090$var$vi.bind(null, a[1]);
        $b1ceb1d0b2f6e090$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $b1ceb1d0b2f6e090$var$M, e = $b1ceb1d0b2f6e090$var$Th();
        if ($b1ceb1d0b2f6e090$var$I) {
            if (void 0 === c) throw Error($b1ceb1d0b2f6e090$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b1ceb1d0b2f6e090$var$Q) throw Error($b1ceb1d0b2f6e090$var$p(349));
            0 !== ($b1ceb1d0b2f6e090$var$Hh & 30) || $b1ceb1d0b2f6e090$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b1ceb1d0b2f6e090$var$mi($b1ceb1d0b2f6e090$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b1ceb1d0b2f6e090$var$bi(9, $b1ceb1d0b2f6e090$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $b1ceb1d0b2f6e090$var$Th(), b = $b1ceb1d0b2f6e090$var$Q.identifierPrefix;
        if ($b1ceb1d0b2f6e090$var$I) {
            var c = $b1ceb1d0b2f6e090$var$sg;
            var d = $b1ceb1d0b2f6e090$var$rg;
            c = (d & ~(1 << 32 - $b1ceb1d0b2f6e090$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b1ceb1d0b2f6e090$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b1ceb1d0b2f6e090$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b1ceb1d0b2f6e090$var$Ph = {
    readContext: $b1ceb1d0b2f6e090$var$eh,
    useCallback: $b1ceb1d0b2f6e090$var$si,
    useContext: $b1ceb1d0b2f6e090$var$eh,
    useEffect: $b1ceb1d0b2f6e090$var$$h,
    useImperativeHandle: $b1ceb1d0b2f6e090$var$qi,
    useInsertionEffect: $b1ceb1d0b2f6e090$var$ni,
    useLayoutEffect: $b1ceb1d0b2f6e090$var$oi,
    useMemo: $b1ceb1d0b2f6e090$var$ti,
    useReducer: $b1ceb1d0b2f6e090$var$Wh,
    useRef: $b1ceb1d0b2f6e090$var$ji,
    useState: function() {
        return $b1ceb1d0b2f6e090$var$Wh($b1ceb1d0b2f6e090$var$Vh);
    },
    useDebugValue: $b1ceb1d0b2f6e090$var$ri,
    useDeferredValue: function(a) {
        var b = $b1ceb1d0b2f6e090$var$Uh();
        return $b1ceb1d0b2f6e090$var$ui(b, $b1ceb1d0b2f6e090$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $b1ceb1d0b2f6e090$var$Wh($b1ceb1d0b2f6e090$var$Vh)[0], b = $b1ceb1d0b2f6e090$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b1ceb1d0b2f6e090$var$Yh,
    useSyncExternalStore: $b1ceb1d0b2f6e090$var$Zh,
    useId: $b1ceb1d0b2f6e090$var$wi,
    unstable_isNewReconciler: !1
}, $b1ceb1d0b2f6e090$var$Qh = {
    readContext: $b1ceb1d0b2f6e090$var$eh,
    useCallback: $b1ceb1d0b2f6e090$var$si,
    useContext: $b1ceb1d0b2f6e090$var$eh,
    useEffect: $b1ceb1d0b2f6e090$var$$h,
    useImperativeHandle: $b1ceb1d0b2f6e090$var$qi,
    useInsertionEffect: $b1ceb1d0b2f6e090$var$ni,
    useLayoutEffect: $b1ceb1d0b2f6e090$var$oi,
    useMemo: $b1ceb1d0b2f6e090$var$ti,
    useReducer: $b1ceb1d0b2f6e090$var$Xh,
    useRef: $b1ceb1d0b2f6e090$var$ji,
    useState: function() {
        return $b1ceb1d0b2f6e090$var$Xh($b1ceb1d0b2f6e090$var$Vh);
    },
    useDebugValue: $b1ceb1d0b2f6e090$var$ri,
    useDeferredValue: function(a) {
        var b = $b1ceb1d0b2f6e090$var$Uh();
        return null === $b1ceb1d0b2f6e090$var$N ? b.memoizedState = a : $b1ceb1d0b2f6e090$var$ui(b, $b1ceb1d0b2f6e090$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $b1ceb1d0b2f6e090$var$Xh($b1ceb1d0b2f6e090$var$Vh)[0], b = $b1ceb1d0b2f6e090$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b1ceb1d0b2f6e090$var$Yh,
    useSyncExternalStore: $b1ceb1d0b2f6e090$var$Zh,
    useId: $b1ceb1d0b2f6e090$var$wi,
    unstable_isNewReconciler: !1
};
function $b1ceb1d0b2f6e090$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $b1ceb1d0b2f6e090$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $b1ceb1d0b2f6e090$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b1ceb1d0b2f6e090$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b1ceb1d0b2f6e090$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $b1ceb1d0b2f6e090$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b1ceb1d0b2f6e090$var$R(), e = $b1ceb1d0b2f6e090$var$yi(a), f = $b1ceb1d0b2f6e090$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b1ceb1d0b2f6e090$var$nh(a, f, e);
        null !== b && ($b1ceb1d0b2f6e090$var$gi(b, a, e, d), $b1ceb1d0b2f6e090$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b1ceb1d0b2f6e090$var$R(), e = $b1ceb1d0b2f6e090$var$yi(a), f = $b1ceb1d0b2f6e090$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b1ceb1d0b2f6e090$var$nh(a, f, e);
        null !== b && ($b1ceb1d0b2f6e090$var$gi(b, a, e, d), $b1ceb1d0b2f6e090$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $b1ceb1d0b2f6e090$var$R(), d = $b1ceb1d0b2f6e090$var$yi(a), e = $b1ceb1d0b2f6e090$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b1ceb1d0b2f6e090$var$nh(a, e, d);
        null !== b && ($b1ceb1d0b2f6e090$var$gi(b, a, d, c), $b1ceb1d0b2f6e090$var$oh(b, a, d));
    }
};
function $b1ceb1d0b2f6e090$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b1ceb1d0b2f6e090$var$Ie(c, d) || !$b1ceb1d0b2f6e090$var$Ie(e, f) : !0;
}
function $b1ceb1d0b2f6e090$var$Gi(a, b, c) {
    var d = !1, e = $b1ceb1d0b2f6e090$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b1ceb1d0b2f6e090$var$eh(f) : (e = $b1ceb1d0b2f6e090$var$Zf(b) ? $b1ceb1d0b2f6e090$var$Xf : $b1ceb1d0b2f6e090$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b1ceb1d0b2f6e090$var$Yf(a, e) : $b1ceb1d0b2f6e090$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b1ceb1d0b2f6e090$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b1ceb1d0b2f6e090$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b1ceb1d0b2f6e090$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $b1ceb1d0b2f6e090$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $b1ceb1d0b2f6e090$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b1ceb1d0b2f6e090$var$eh(f) : (f = $b1ceb1d0b2f6e090$var$Zf(b) ? $b1ceb1d0b2f6e090$var$Xf : $b1ceb1d0b2f6e090$var$H.current, e.context = $b1ceb1d0b2f6e090$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b1ceb1d0b2f6e090$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b1ceb1d0b2f6e090$var$Ei.enqueueReplaceState(e, e.state, null), $b1ceb1d0b2f6e090$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b1ceb1d0b2f6e090$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $b1ceb1d0b2f6e090$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b1ceb1d0b2f6e090$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b1ceb1d0b2f6e090$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b1ceb1d0b2f6e090$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $b1ceb1d0b2f6e090$var$Ni(a, b, c) {
    c = $b1ceb1d0b2f6e090$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b1ceb1d0b2f6e090$var$Oi || ($b1ceb1d0b2f6e090$var$Oi = !0, $b1ceb1d0b2f6e090$var$Pi = d);
        $b1ceb1d0b2f6e090$var$Li(a, b);
    };
    return c;
}
function $b1ceb1d0b2f6e090$var$Qi(a, b, c) {
    c = $b1ceb1d0b2f6e090$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b1ceb1d0b2f6e090$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b1ceb1d0b2f6e090$var$Li(a, b);
        "function" !== typeof d && (null === $b1ceb1d0b2f6e090$var$Ri ? $b1ceb1d0b2f6e090$var$Ri = new Set([
            this
        ]) : $b1ceb1d0b2f6e090$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $b1ceb1d0b2f6e090$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b1ceb1d0b2f6e090$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b1ceb1d0b2f6e090$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $b1ceb1d0b2f6e090$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b1ceb1d0b2f6e090$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b1ceb1d0b2f6e090$var$mh(-1, 1), b.tag = 2, $b1ceb1d0b2f6e090$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b1ceb1d0b2f6e090$var$Wi = $b1ceb1d0b2f6e090$var$ua.ReactCurrentOwner, $b1ceb1d0b2f6e090$var$dh = !1;
function $b1ceb1d0b2f6e090$var$Xi(a, b, c, d) {
    b.child = null === a ? $b1ceb1d0b2f6e090$var$Vg(b, null, c, d) : $b1ceb1d0b2f6e090$var$Ug(b, a.child, c, d);
}
function $b1ceb1d0b2f6e090$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b1ceb1d0b2f6e090$var$ch(b, e);
    d = $b1ceb1d0b2f6e090$var$Nh(a, b, c, d, f, e);
    c = $b1ceb1d0b2f6e090$var$Sh();
    if (null !== a && !$b1ceb1d0b2f6e090$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b1ceb1d0b2f6e090$var$Zi(a, b, e);
    $b1ceb1d0b2f6e090$var$I && c && $b1ceb1d0b2f6e090$var$vg(b);
    b.flags |= 1;
    $b1ceb1d0b2f6e090$var$Xi(a, b, d, e);
    return b.child;
}
function $b1ceb1d0b2f6e090$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b1ceb1d0b2f6e090$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b1ceb1d0b2f6e090$var$bj(a, b, f, d, e);
        a = $b1ceb1d0b2f6e090$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b1ceb1d0b2f6e090$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b1ceb1d0b2f6e090$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $b1ceb1d0b2f6e090$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b1ceb1d0b2f6e090$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b1ceb1d0b2f6e090$var$Ie(f, d) && a.ref === b.ref) {
            if ($b1ceb1d0b2f6e090$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b1ceb1d0b2f6e090$var$dh = !0);
            else return b.lanes = a.lanes, $b1ceb1d0b2f6e090$var$Zi(a, b, e);
        }
    }
    return $b1ceb1d0b2f6e090$var$cj(a, b, c, d, e);
}
function $b1ceb1d0b2f6e090$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b1ceb1d0b2f6e090$var$G($b1ceb1d0b2f6e090$var$ej, $b1ceb1d0b2f6e090$var$fj), $b1ceb1d0b2f6e090$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b1ceb1d0b2f6e090$var$G($b1ceb1d0b2f6e090$var$ej, $b1ceb1d0b2f6e090$var$fj), $b1ceb1d0b2f6e090$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b1ceb1d0b2f6e090$var$G($b1ceb1d0b2f6e090$var$ej, $b1ceb1d0b2f6e090$var$fj);
            $b1ceb1d0b2f6e090$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b1ceb1d0b2f6e090$var$G($b1ceb1d0b2f6e090$var$ej, $b1ceb1d0b2f6e090$var$fj), $b1ceb1d0b2f6e090$var$fj |= d;
    $b1ceb1d0b2f6e090$var$Xi(a, b, e, c);
    return b.child;
}
function $b1ceb1d0b2f6e090$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b1ceb1d0b2f6e090$var$cj(a, b, c, d, e) {
    var f = $b1ceb1d0b2f6e090$var$Zf(c) ? $b1ceb1d0b2f6e090$var$Xf : $b1ceb1d0b2f6e090$var$H.current;
    f = $b1ceb1d0b2f6e090$var$Yf(b, f);
    $b1ceb1d0b2f6e090$var$ch(b, e);
    c = $b1ceb1d0b2f6e090$var$Nh(a, b, c, d, f, e);
    d = $b1ceb1d0b2f6e090$var$Sh();
    if (null !== a && !$b1ceb1d0b2f6e090$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b1ceb1d0b2f6e090$var$Zi(a, b, e);
    $b1ceb1d0b2f6e090$var$I && d && $b1ceb1d0b2f6e090$var$vg(b);
    b.flags |= 1;
    $b1ceb1d0b2f6e090$var$Xi(a, b, c, e);
    return b.child;
}
function $b1ceb1d0b2f6e090$var$hj(a, b, c, d, e) {
    if ($b1ceb1d0b2f6e090$var$Zf(c)) {
        var f = !0;
        $b1ceb1d0b2f6e090$var$cg(b);
    } else f = !1;
    $b1ceb1d0b2f6e090$var$ch(b, e);
    if (null === b.stateNode) $b1ceb1d0b2f6e090$var$ij(a, b), $b1ceb1d0b2f6e090$var$Gi(b, c, d), $b1ceb1d0b2f6e090$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b1ceb1d0b2f6e090$var$eh(l) : (l = $b1ceb1d0b2f6e090$var$Zf(c) ? $b1ceb1d0b2f6e090$var$Xf : $b1ceb1d0b2f6e090$var$H.current, l = $b1ceb1d0b2f6e090$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b1ceb1d0b2f6e090$var$Hi(b, g, d, l);
        $b1ceb1d0b2f6e090$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $b1ceb1d0b2f6e090$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b1ceb1d0b2f6e090$var$Wf.current || $b1ceb1d0b2f6e090$var$jh ? ("function" === typeof m && ($b1ceb1d0b2f6e090$var$Di(b, c, m, d), k = b.memoizedState), (h = $b1ceb1d0b2f6e090$var$jh || $b1ceb1d0b2f6e090$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b1ceb1d0b2f6e090$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b1ceb1d0b2f6e090$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b1ceb1d0b2f6e090$var$eh(k) : (k = $b1ceb1d0b2f6e090$var$Zf(c) ? $b1ceb1d0b2f6e090$var$Xf : $b1ceb1d0b2f6e090$var$H.current, k = $b1ceb1d0b2f6e090$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b1ceb1d0b2f6e090$var$Hi(b, g, d, k);
        $b1ceb1d0b2f6e090$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $b1ceb1d0b2f6e090$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b1ceb1d0b2f6e090$var$Wf.current || $b1ceb1d0b2f6e090$var$jh ? ("function" === typeof y && ($b1ceb1d0b2f6e090$var$Di(b, c, y, d), n = b.memoizedState), (l = $b1ceb1d0b2f6e090$var$jh || $b1ceb1d0b2f6e090$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b1ceb1d0b2f6e090$var$jj(a, b, c, d, f, e);
}
function $b1ceb1d0b2f6e090$var$jj(a, b, c, d, e, f) {
    $b1ceb1d0b2f6e090$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b1ceb1d0b2f6e090$var$dg(b, c, !1), $b1ceb1d0b2f6e090$var$Zi(a, b, f);
    d = b.stateNode;
    $b1ceb1d0b2f6e090$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b1ceb1d0b2f6e090$var$Ug(b, a.child, null, f), b.child = $b1ceb1d0b2f6e090$var$Ug(b, null, h, f)) : $b1ceb1d0b2f6e090$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b1ceb1d0b2f6e090$var$dg(b, c, !0);
    return b.child;
}
function $b1ceb1d0b2f6e090$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b1ceb1d0b2f6e090$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b1ceb1d0b2f6e090$var$ag(a, b.context, !1);
    $b1ceb1d0b2f6e090$var$yh(a, b.containerInfo);
}
function $b1ceb1d0b2f6e090$var$lj(a, b, c, d, e) {
    $b1ceb1d0b2f6e090$var$Ig();
    $b1ceb1d0b2f6e090$var$Jg(e);
    b.flags |= 256;
    $b1ceb1d0b2f6e090$var$Xi(a, b, c, d);
    return b.child;
}
var $b1ceb1d0b2f6e090$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b1ceb1d0b2f6e090$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b1ceb1d0b2f6e090$var$oj(a, b, c) {
    var d = b.pendingProps, e = $b1ceb1d0b2f6e090$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b1ceb1d0b2f6e090$var$G($b1ceb1d0b2f6e090$var$L, e & 1);
    if (null === a) {
        $b1ceb1d0b2f6e090$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b1ceb1d0b2f6e090$var$pj(g, d, 0, null), a = $b1ceb1d0b2f6e090$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b1ceb1d0b2f6e090$var$nj(c), b.memoizedState = $b1ceb1d0b2f6e090$var$mj, a) : $b1ceb1d0b2f6e090$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b1ceb1d0b2f6e090$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b1ceb1d0b2f6e090$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b1ceb1d0b2f6e090$var$Pg(h, f) : (f = $b1ceb1d0b2f6e090$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b1ceb1d0b2f6e090$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b1ceb1d0b2f6e090$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b1ceb1d0b2f6e090$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b1ceb1d0b2f6e090$var$qj(a, b) {
    b = $b1ceb1d0b2f6e090$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b1ceb1d0b2f6e090$var$sj(a, b, c, d) {
    null !== d && $b1ceb1d0b2f6e090$var$Jg(d);
    $b1ceb1d0b2f6e090$var$Ug(b, a.child, null, c);
    a = $b1ceb1d0b2f6e090$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b1ceb1d0b2f6e090$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b1ceb1d0b2f6e090$var$Ki(Error($b1ceb1d0b2f6e090$var$p(422))), $b1ceb1d0b2f6e090$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b1ceb1d0b2f6e090$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b1ceb1d0b2f6e090$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b1ceb1d0b2f6e090$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $b1ceb1d0b2f6e090$var$nj(g);
        b.memoizedState = $b1ceb1d0b2f6e090$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b1ceb1d0b2f6e090$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b1ceb1d0b2f6e090$var$p(419));
        d = $b1ceb1d0b2f6e090$var$Ki(f, d, void 0);
        return $b1ceb1d0b2f6e090$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b1ceb1d0b2f6e090$var$dh || h) {
        d = $b1ceb1d0b2f6e090$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b1ceb1d0b2f6e090$var$ih(a, e), $b1ceb1d0b2f6e090$var$gi(d, a, e, -1));
        }
        $b1ceb1d0b2f6e090$var$tj();
        d = $b1ceb1d0b2f6e090$var$Ki(Error($b1ceb1d0b2f6e090$var$p(421)));
        return $b1ceb1d0b2f6e090$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b1ceb1d0b2f6e090$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b1ceb1d0b2f6e090$var$yg = $b1ceb1d0b2f6e090$var$Lf(e.nextSibling);
    $b1ceb1d0b2f6e090$var$xg = b;
    $b1ceb1d0b2f6e090$var$I = !0;
    $b1ceb1d0b2f6e090$var$zg = null;
    null !== a && ($b1ceb1d0b2f6e090$var$og[$b1ceb1d0b2f6e090$var$pg++] = $b1ceb1d0b2f6e090$var$rg, $b1ceb1d0b2f6e090$var$og[$b1ceb1d0b2f6e090$var$pg++] = $b1ceb1d0b2f6e090$var$sg, $b1ceb1d0b2f6e090$var$og[$b1ceb1d0b2f6e090$var$pg++] = $b1ceb1d0b2f6e090$var$qg, $b1ceb1d0b2f6e090$var$rg = a.id, $b1ceb1d0b2f6e090$var$sg = a.overflow, $b1ceb1d0b2f6e090$var$qg = b);
    b = $b1ceb1d0b2f6e090$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b1ceb1d0b2f6e090$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b1ceb1d0b2f6e090$var$bh(a.return, b, c);
}
function $b1ceb1d0b2f6e090$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b1ceb1d0b2f6e090$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b1ceb1d0b2f6e090$var$Xi(a, b, d.children, c);
    d = $b1ceb1d0b2f6e090$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b1ceb1d0b2f6e090$var$vj(a, c, b);
            else if (19 === a.tag) $b1ceb1d0b2f6e090$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b1ceb1d0b2f6e090$var$G($b1ceb1d0b2f6e090$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b1ceb1d0b2f6e090$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b1ceb1d0b2f6e090$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b1ceb1d0b2f6e090$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b1ceb1d0b2f6e090$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $b1ceb1d0b2f6e090$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b1ceb1d0b2f6e090$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b1ceb1d0b2f6e090$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b1ceb1d0b2f6e090$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b1ceb1d0b2f6e090$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b1ceb1d0b2f6e090$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b1ceb1d0b2f6e090$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b1ceb1d0b2f6e090$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $b1ceb1d0b2f6e090$var$kj(b);
            $b1ceb1d0b2f6e090$var$Ig();
            break;
        case 5:
            $b1ceb1d0b2f6e090$var$Ah(b);
            break;
        case 1:
            $b1ceb1d0b2f6e090$var$Zf(b.type) && $b1ceb1d0b2f6e090$var$cg(b);
            break;
        case 4:
            $b1ceb1d0b2f6e090$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b1ceb1d0b2f6e090$var$G($b1ceb1d0b2f6e090$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b1ceb1d0b2f6e090$var$G($b1ceb1d0b2f6e090$var$L, $b1ceb1d0b2f6e090$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b1ceb1d0b2f6e090$var$oj(a, b, c);
                $b1ceb1d0b2f6e090$var$G($b1ceb1d0b2f6e090$var$L, $b1ceb1d0b2f6e090$var$L.current & 1);
                a = $b1ceb1d0b2f6e090$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b1ceb1d0b2f6e090$var$G($b1ceb1d0b2f6e090$var$L, $b1ceb1d0b2f6e090$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b1ceb1d0b2f6e090$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b1ceb1d0b2f6e090$var$G($b1ceb1d0b2f6e090$var$L, $b1ceb1d0b2f6e090$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b1ceb1d0b2f6e090$var$dj(a, b, c);
    }
    return $b1ceb1d0b2f6e090$var$Zi(a, b, c);
}
var $b1ceb1d0b2f6e090$var$zj, $b1ceb1d0b2f6e090$var$Aj, $b1ceb1d0b2f6e090$var$Bj, $b1ceb1d0b2f6e090$var$Cj;
$b1ceb1d0b2f6e090$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b1ceb1d0b2f6e090$var$Aj = function() {};
$b1ceb1d0b2f6e090$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b1ceb1d0b2f6e090$var$xh($b1ceb1d0b2f6e090$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b1ceb1d0b2f6e090$var$Ya(a, e);
                d = $b1ceb1d0b2f6e090$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b1ceb1d0b2f6e090$var$A({}, e, {
                    value: void 0
                });
                d = $b1ceb1d0b2f6e090$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b1ceb1d0b2f6e090$var$gb(a, e);
                d = $b1ceb1d0b2f6e090$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b1ceb1d0b2f6e090$var$Bf);
        }
        $b1ceb1d0b2f6e090$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b1ceb1d0b2f6e090$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b1ceb1d0b2f6e090$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b1ceb1d0b2f6e090$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b1ceb1d0b2f6e090$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b1ceb1d0b2f6e090$var$Dj(a, b) {
    if (!$b1ceb1d0b2f6e090$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b1ceb1d0b2f6e090$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b1ceb1d0b2f6e090$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $b1ceb1d0b2f6e090$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b1ceb1d0b2f6e090$var$S(b), null;
        case 1:
            return $b1ceb1d0b2f6e090$var$Zf(b.type) && $b1ceb1d0b2f6e090$var$$f(), $b1ceb1d0b2f6e090$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b1ceb1d0b2f6e090$var$zh();
            $b1ceb1d0b2f6e090$var$E($b1ceb1d0b2f6e090$var$Wf);
            $b1ceb1d0b2f6e090$var$E($b1ceb1d0b2f6e090$var$H);
            $b1ceb1d0b2f6e090$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b1ceb1d0b2f6e090$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b1ceb1d0b2f6e090$var$zg && ($b1ceb1d0b2f6e090$var$Fj($b1ceb1d0b2f6e090$var$zg), $b1ceb1d0b2f6e090$var$zg = null));
            $b1ceb1d0b2f6e090$var$Aj(a, b);
            $b1ceb1d0b2f6e090$var$S(b);
            return null;
        case 5:
            $b1ceb1d0b2f6e090$var$Bh(b);
            var e = $b1ceb1d0b2f6e090$var$xh($b1ceb1d0b2f6e090$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b1ceb1d0b2f6e090$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b1ceb1d0b2f6e090$var$p(166));
                    $b1ceb1d0b2f6e090$var$S(b);
                    return null;
                }
                a = $b1ceb1d0b2f6e090$var$xh($b1ceb1d0b2f6e090$var$uh.current);
                if ($b1ceb1d0b2f6e090$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b1ceb1d0b2f6e090$var$Of] = b;
                    d[$b1ceb1d0b2f6e090$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b1ceb1d0b2f6e090$var$D("cancel", d);
                            $b1ceb1d0b2f6e090$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b1ceb1d0b2f6e090$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b1ceb1d0b2f6e090$var$lf.length; e++)$b1ceb1d0b2f6e090$var$D($b1ceb1d0b2f6e090$var$lf[e], d);
                            break;
                        case "source":
                            $b1ceb1d0b2f6e090$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b1ceb1d0b2f6e090$var$D("error", d);
                            $b1ceb1d0b2f6e090$var$D("load", d);
                            break;
                        case "details":
                            $b1ceb1d0b2f6e090$var$D("toggle", d);
                            break;
                        case "input":
                            $b1ceb1d0b2f6e090$var$Za(d, f);
                            $b1ceb1d0b2f6e090$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b1ceb1d0b2f6e090$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b1ceb1d0b2f6e090$var$hb(d, f), $b1ceb1d0b2f6e090$var$D("invalid", d);
                    }
                    $b1ceb1d0b2f6e090$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b1ceb1d0b2f6e090$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b1ceb1d0b2f6e090$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b1ceb1d0b2f6e090$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b1ceb1d0b2f6e090$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b1ceb1d0b2f6e090$var$Va(d);
                            $b1ceb1d0b2f6e090$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b1ceb1d0b2f6e090$var$Va(d);
                            $b1ceb1d0b2f6e090$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b1ceb1d0b2f6e090$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b1ceb1d0b2f6e090$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b1ceb1d0b2f6e090$var$Of] = b;
                    a[$b1ceb1d0b2f6e090$var$Pf] = d;
                    $b1ceb1d0b2f6e090$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b1ceb1d0b2f6e090$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b1ceb1d0b2f6e090$var$D("cancel", a);
                                $b1ceb1d0b2f6e090$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b1ceb1d0b2f6e090$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b1ceb1d0b2f6e090$var$lf.length; e++)$b1ceb1d0b2f6e090$var$D($b1ceb1d0b2f6e090$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b1ceb1d0b2f6e090$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b1ceb1d0b2f6e090$var$D("error", a);
                                $b1ceb1d0b2f6e090$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b1ceb1d0b2f6e090$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b1ceb1d0b2f6e090$var$Za(a, d);
                                e = $b1ceb1d0b2f6e090$var$Ya(a, d);
                                $b1ceb1d0b2f6e090$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b1ceb1d0b2f6e090$var$A({}, d, {
                                    value: void 0
                                });
                                $b1ceb1d0b2f6e090$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b1ceb1d0b2f6e090$var$hb(a, d);
                                e = $b1ceb1d0b2f6e090$var$gb(a, d);
                                $b1ceb1d0b2f6e090$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b1ceb1d0b2f6e090$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b1ceb1d0b2f6e090$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b1ceb1d0b2f6e090$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b1ceb1d0b2f6e090$var$ob(a, k) : "number" === typeof k && $b1ceb1d0b2f6e090$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b1ceb1d0b2f6e090$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b1ceb1d0b2f6e090$var$D("scroll", a) : null != k && $b1ceb1d0b2f6e090$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b1ceb1d0b2f6e090$var$Va(a);
                                $b1ceb1d0b2f6e090$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b1ceb1d0b2f6e090$var$Va(a);
                                $b1ceb1d0b2f6e090$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b1ceb1d0b2f6e090$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b1ceb1d0b2f6e090$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b1ceb1d0b2f6e090$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b1ceb1d0b2f6e090$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b1ceb1d0b2f6e090$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b1ceb1d0b2f6e090$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b1ceb1d0b2f6e090$var$p(166));
                c = $b1ceb1d0b2f6e090$var$xh($b1ceb1d0b2f6e090$var$wh.current);
                $b1ceb1d0b2f6e090$var$xh($b1ceb1d0b2f6e090$var$uh.current);
                if ($b1ceb1d0b2f6e090$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b1ceb1d0b2f6e090$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b1ceb1d0b2f6e090$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b1ceb1d0b2f6e090$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b1ceb1d0b2f6e090$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b1ceb1d0b2f6e090$var$Of] = b, b.stateNode = d;
            }
            $b1ceb1d0b2f6e090$var$S(b);
            return null;
        case 13:
            $b1ceb1d0b2f6e090$var$E($b1ceb1d0b2f6e090$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b1ceb1d0b2f6e090$var$I && null !== $b1ceb1d0b2f6e090$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b1ceb1d0b2f6e090$var$Hg(), $b1ceb1d0b2f6e090$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b1ceb1d0b2f6e090$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b1ceb1d0b2f6e090$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b1ceb1d0b2f6e090$var$p(317));
                        f[$b1ceb1d0b2f6e090$var$Of] = b;
                    } else $b1ceb1d0b2f6e090$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b1ceb1d0b2f6e090$var$S(b);
                    f = !1;
                } else null !== $b1ceb1d0b2f6e090$var$zg && ($b1ceb1d0b2f6e090$var$Fj($b1ceb1d0b2f6e090$var$zg), $b1ceb1d0b2f6e090$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b1ceb1d0b2f6e090$var$L.current & 1) ? 0 === $b1ceb1d0b2f6e090$var$T && ($b1ceb1d0b2f6e090$var$T = 3) : $b1ceb1d0b2f6e090$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b1ceb1d0b2f6e090$var$S(b);
            return null;
        case 4:
            return $b1ceb1d0b2f6e090$var$zh(), $b1ceb1d0b2f6e090$var$Aj(a, b), null === a && $b1ceb1d0b2f6e090$var$sf(b.stateNode.containerInfo), $b1ceb1d0b2f6e090$var$S(b), null;
        case 10:
            return $b1ceb1d0b2f6e090$var$ah(b.type._context), $b1ceb1d0b2f6e090$var$S(b), null;
        case 17:
            return $b1ceb1d0b2f6e090$var$Zf(b.type) && $b1ceb1d0b2f6e090$var$$f(), $b1ceb1d0b2f6e090$var$S(b), null;
        case 19:
            $b1ceb1d0b2f6e090$var$E($b1ceb1d0b2f6e090$var$L);
            f = b.memoizedState;
            if (null === f) return $b1ceb1d0b2f6e090$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b1ceb1d0b2f6e090$var$Dj(f, !1);
                else {
                    if (0 !== $b1ceb1d0b2f6e090$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b1ceb1d0b2f6e090$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b1ceb1d0b2f6e090$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b1ceb1d0b2f6e090$var$G($b1ceb1d0b2f6e090$var$L, $b1ceb1d0b2f6e090$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b1ceb1d0b2f6e090$var$B() > $b1ceb1d0b2f6e090$var$Gj && (b.flags |= 128, d = !0, $b1ceb1d0b2f6e090$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b1ceb1d0b2f6e090$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b1ceb1d0b2f6e090$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b1ceb1d0b2f6e090$var$I) return $b1ceb1d0b2f6e090$var$S(b), null;
                    } else 2 * $b1ceb1d0b2f6e090$var$B() - f.renderingStartTime > $b1ceb1d0b2f6e090$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $b1ceb1d0b2f6e090$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b1ceb1d0b2f6e090$var$B(), b.sibling = null, c = $b1ceb1d0b2f6e090$var$L.current, $b1ceb1d0b2f6e090$var$G($b1ceb1d0b2f6e090$var$L, d ? c & 1 | 2 : c & 1), b;
            $b1ceb1d0b2f6e090$var$S(b);
            return null;
        case 22:
        case 23:
            return $b1ceb1d0b2f6e090$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b1ceb1d0b2f6e090$var$fj & 1073741824) && ($b1ceb1d0b2f6e090$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b1ceb1d0b2f6e090$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b1ceb1d0b2f6e090$var$p(156, b.tag));
}
function $b1ceb1d0b2f6e090$var$Ij(a, b) {
    $b1ceb1d0b2f6e090$var$wg(b);
    switch(b.tag){
        case 1:
            return $b1ceb1d0b2f6e090$var$Zf(b.type) && $b1ceb1d0b2f6e090$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b1ceb1d0b2f6e090$var$zh(), $b1ceb1d0b2f6e090$var$E($b1ceb1d0b2f6e090$var$Wf), $b1ceb1d0b2f6e090$var$E($b1ceb1d0b2f6e090$var$H), $b1ceb1d0b2f6e090$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b1ceb1d0b2f6e090$var$Bh(b), null;
        case 13:
            $b1ceb1d0b2f6e090$var$E($b1ceb1d0b2f6e090$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b1ceb1d0b2f6e090$var$p(340));
                $b1ceb1d0b2f6e090$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b1ceb1d0b2f6e090$var$E($b1ceb1d0b2f6e090$var$L), null;
        case 4:
            return $b1ceb1d0b2f6e090$var$zh(), null;
        case 10:
            return $b1ceb1d0b2f6e090$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $b1ceb1d0b2f6e090$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b1ceb1d0b2f6e090$var$Jj = !1, $b1ceb1d0b2f6e090$var$U = !1, $b1ceb1d0b2f6e090$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $b1ceb1d0b2f6e090$var$V = null;
function $b1ceb1d0b2f6e090$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b1ceb1d0b2f6e090$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b1ceb1d0b2f6e090$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b1ceb1d0b2f6e090$var$W(a, b, d);
    }
}
var $b1ceb1d0b2f6e090$var$Nj = !1;
function $b1ceb1d0b2f6e090$var$Oj(a, b) {
    $b1ceb1d0b2f6e090$var$Cf = $b1ceb1d0b2f6e090$var$dd;
    a = $b1ceb1d0b2f6e090$var$Me();
    if ($b1ceb1d0b2f6e090$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b1ceb1d0b2f6e090$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b1ceb1d0b2f6e090$var$dd = !1;
    for($b1ceb1d0b2f6e090$var$V = b; null !== $b1ceb1d0b2f6e090$var$V;)if (b = $b1ceb1d0b2f6e090$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b1ceb1d0b2f6e090$var$V = a;
    else for(; null !== $b1ceb1d0b2f6e090$var$V;){
        b = $b1ceb1d0b2f6e090$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b1ceb1d0b2f6e090$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b1ceb1d0b2f6e090$var$p(163));
            }
        } catch (F) {
            $b1ceb1d0b2f6e090$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b1ceb1d0b2f6e090$var$V = a;
            break;
        }
        $b1ceb1d0b2f6e090$var$V = b.return;
    }
    n = $b1ceb1d0b2f6e090$var$Nj;
    $b1ceb1d0b2f6e090$var$Nj = !1;
    return n;
}
function $b1ceb1d0b2f6e090$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b1ceb1d0b2f6e090$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b1ceb1d0b2f6e090$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b1ceb1d0b2f6e090$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b1ceb1d0b2f6e090$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b1ceb1d0b2f6e090$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b1ceb1d0b2f6e090$var$Of], delete b[$b1ceb1d0b2f6e090$var$Pf], delete b[$b1ceb1d0b2f6e090$var$of], delete b[$b1ceb1d0b2f6e090$var$Qf], delete b[$b1ceb1d0b2f6e090$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b1ceb1d0b2f6e090$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b1ceb1d0b2f6e090$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b1ceb1d0b2f6e090$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b1ceb1d0b2f6e090$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b1ceb1d0b2f6e090$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b1ceb1d0b2f6e090$var$Vj(a, b, c), a = a.sibling; null !== a;)$b1ceb1d0b2f6e090$var$Vj(a, b, c), a = a.sibling;
}
function $b1ceb1d0b2f6e090$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b1ceb1d0b2f6e090$var$Wj(a, b, c), a = a.sibling; null !== a;)$b1ceb1d0b2f6e090$var$Wj(a, b, c), a = a.sibling;
}
var $b1ceb1d0b2f6e090$var$X = null, $b1ceb1d0b2f6e090$var$Xj = !1;
function $b1ceb1d0b2f6e090$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$b1ceb1d0b2f6e090$var$Zj(a, b, c), c = c.sibling;
}
function $b1ceb1d0b2f6e090$var$Zj(a, b, c) {
    if ($b1ceb1d0b2f6e090$var$lc && "function" === typeof $b1ceb1d0b2f6e090$var$lc.onCommitFiberUnmount) try {
        $b1ceb1d0b2f6e090$var$lc.onCommitFiberUnmount($b1ceb1d0b2f6e090$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b1ceb1d0b2f6e090$var$U || $b1ceb1d0b2f6e090$var$Lj(c, b);
        case 6:
            var d = $b1ceb1d0b2f6e090$var$X, e = $b1ceb1d0b2f6e090$var$Xj;
            $b1ceb1d0b2f6e090$var$X = null;
            $b1ceb1d0b2f6e090$var$Yj(a, b, c);
            $b1ceb1d0b2f6e090$var$X = d;
            $b1ceb1d0b2f6e090$var$Xj = e;
            null !== $b1ceb1d0b2f6e090$var$X && ($b1ceb1d0b2f6e090$var$Xj ? (a = $b1ceb1d0b2f6e090$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b1ceb1d0b2f6e090$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b1ceb1d0b2f6e090$var$X && ($b1ceb1d0b2f6e090$var$Xj ? (a = $b1ceb1d0b2f6e090$var$X, c = c.stateNode, 8 === a.nodeType ? $b1ceb1d0b2f6e090$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b1ceb1d0b2f6e090$var$Kf(a, c), $b1ceb1d0b2f6e090$var$bd(a)) : $b1ceb1d0b2f6e090$var$Kf($b1ceb1d0b2f6e090$var$X, c.stateNode));
            break;
        case 4:
            d = $b1ceb1d0b2f6e090$var$X;
            e = $b1ceb1d0b2f6e090$var$Xj;
            $b1ceb1d0b2f6e090$var$X = c.stateNode.containerInfo;
            $b1ceb1d0b2f6e090$var$Xj = !0;
            $b1ceb1d0b2f6e090$var$Yj(a, b, c);
            $b1ceb1d0b2f6e090$var$X = d;
            $b1ceb1d0b2f6e090$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b1ceb1d0b2f6e090$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b1ceb1d0b2f6e090$var$Mj(c, b, g) : 0 !== (f & 4) && $b1ceb1d0b2f6e090$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b1ceb1d0b2f6e090$var$Yj(a, b, c);
            break;
        case 1:
            if (!$b1ceb1d0b2f6e090$var$U && ($b1ceb1d0b2f6e090$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b1ceb1d0b2f6e090$var$W(c, b, h);
            }
            $b1ceb1d0b2f6e090$var$Yj(a, b, c);
            break;
        case 21:
            $b1ceb1d0b2f6e090$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b1ceb1d0b2f6e090$var$U = (d = $b1ceb1d0b2f6e090$var$U) || null !== c.memoizedState, $b1ceb1d0b2f6e090$var$Yj(a, b, c), $b1ceb1d0b2f6e090$var$U = d) : $b1ceb1d0b2f6e090$var$Yj(a, b, c);
            break;
        default:
            $b1ceb1d0b2f6e090$var$Yj(a, b, c);
    }
}
function $b1ceb1d0b2f6e090$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b1ceb1d0b2f6e090$var$Kj);
        b.forEach(function(b) {
            var d = $b1ceb1d0b2f6e090$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b1ceb1d0b2f6e090$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b1ceb1d0b2f6e090$var$X = h.stateNode;
                        $b1ceb1d0b2f6e090$var$Xj = !1;
                        break a;
                    case 3:
                        $b1ceb1d0b2f6e090$var$X = h.stateNode.containerInfo;
                        $b1ceb1d0b2f6e090$var$Xj = !0;
                        break a;
                    case 4:
                        $b1ceb1d0b2f6e090$var$X = h.stateNode.containerInfo;
                        $b1ceb1d0b2f6e090$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b1ceb1d0b2f6e090$var$X) throw Error($b1ceb1d0b2f6e090$var$p(160));
            $b1ceb1d0b2f6e090$var$Zj(f, g, e);
            $b1ceb1d0b2f6e090$var$X = null;
            $b1ceb1d0b2f6e090$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b1ceb1d0b2f6e090$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b1ceb1d0b2f6e090$var$dk(b, a), b = b.sibling;
}
function $b1ceb1d0b2f6e090$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b1ceb1d0b2f6e090$var$ck(b, a);
            $b1ceb1d0b2f6e090$var$ek(a);
            if (d & 4) {
                try {
                    $b1ceb1d0b2f6e090$var$Pj(3, a, a.return), $b1ceb1d0b2f6e090$var$Qj(3, a);
                } catch (t) {
                    $b1ceb1d0b2f6e090$var$W(a, a.return, t);
                }
                try {
                    $b1ceb1d0b2f6e090$var$Pj(5, a, a.return);
                } catch (t) {
                    $b1ceb1d0b2f6e090$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b1ceb1d0b2f6e090$var$ck(b, a);
            $b1ceb1d0b2f6e090$var$ek(a);
            d & 512 && null !== c && $b1ceb1d0b2f6e090$var$Lj(c, c.return);
            break;
        case 5:
            $b1ceb1d0b2f6e090$var$ck(b, a);
            $b1ceb1d0b2f6e090$var$ek(a);
            d & 512 && null !== c && $b1ceb1d0b2f6e090$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b1ceb1d0b2f6e090$var$ob(e, "");
                } catch (t) {
                    $b1ceb1d0b2f6e090$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b1ceb1d0b2f6e090$var$ab(e, f);
                    $b1ceb1d0b2f6e090$var$vb(h, g);
                    var l = $b1ceb1d0b2f6e090$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b1ceb1d0b2f6e090$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b1ceb1d0b2f6e090$var$nb(e, q) : "children" === m ? $b1ceb1d0b2f6e090$var$ob(e, q) : $b1ceb1d0b2f6e090$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b1ceb1d0b2f6e090$var$bb(e, f);
                            break;
                        case "textarea":
                            $b1ceb1d0b2f6e090$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b1ceb1d0b2f6e090$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b1ceb1d0b2f6e090$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b1ceb1d0b2f6e090$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b1ceb1d0b2f6e090$var$Pf] = f;
                } catch (t) {
                    $b1ceb1d0b2f6e090$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b1ceb1d0b2f6e090$var$ck(b, a);
            $b1ceb1d0b2f6e090$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b1ceb1d0b2f6e090$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b1ceb1d0b2f6e090$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b1ceb1d0b2f6e090$var$ck(b, a);
            $b1ceb1d0b2f6e090$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b1ceb1d0b2f6e090$var$bd(b.containerInfo);
            } catch (t) {
                $b1ceb1d0b2f6e090$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b1ceb1d0b2f6e090$var$ck(b, a);
            $b1ceb1d0b2f6e090$var$ek(a);
            break;
        case 13:
            $b1ceb1d0b2f6e090$var$ck(b, a);
            $b1ceb1d0b2f6e090$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b1ceb1d0b2f6e090$var$fk = $b1ceb1d0b2f6e090$var$B()));
            d & 4 && $b1ceb1d0b2f6e090$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b1ceb1d0b2f6e090$var$U = (l = $b1ceb1d0b2f6e090$var$U) || m, $b1ceb1d0b2f6e090$var$ck(b, a), $b1ceb1d0b2f6e090$var$U = l) : $b1ceb1d0b2f6e090$var$ck(b, a);
            $b1ceb1d0b2f6e090$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b1ceb1d0b2f6e090$var$V = a, m = a.child; null !== m;){
                    for(q = $b1ceb1d0b2f6e090$var$V = m; null !== $b1ceb1d0b2f6e090$var$V;){
                        r = $b1ceb1d0b2f6e090$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b1ceb1d0b2f6e090$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $b1ceb1d0b2f6e090$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b1ceb1d0b2f6e090$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b1ceb1d0b2f6e090$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b1ceb1d0b2f6e090$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b1ceb1d0b2f6e090$var$V = y) : $b1ceb1d0b2f6e090$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b1ceb1d0b2f6e090$var$rb("display", g));
                            } catch (t) {
                                $b1ceb1d0b2f6e090$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b1ceb1d0b2f6e090$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b1ceb1d0b2f6e090$var$ck(b, a);
            $b1ceb1d0b2f6e090$var$ek(a);
            d & 4 && $b1ceb1d0b2f6e090$var$ak(a);
            break;
        case 21:
            break;
        default:
            $b1ceb1d0b2f6e090$var$ck(b, a), $b1ceb1d0b2f6e090$var$ek(a);
    }
}
function $b1ceb1d0b2f6e090$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b1ceb1d0b2f6e090$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b1ceb1d0b2f6e090$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b1ceb1d0b2f6e090$var$ob(e, ""), d.flags &= -33);
                    var f = $b1ceb1d0b2f6e090$var$Uj(a);
                    $b1ceb1d0b2f6e090$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b1ceb1d0b2f6e090$var$Uj(a);
                    $b1ceb1d0b2f6e090$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($b1ceb1d0b2f6e090$var$p(161));
            }
        } catch (k) {
            $b1ceb1d0b2f6e090$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b1ceb1d0b2f6e090$var$hk(a, b, c) {
    $b1ceb1d0b2f6e090$var$V = a;
    $b1ceb1d0b2f6e090$var$ik(a, b, c);
}
function $b1ceb1d0b2f6e090$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b1ceb1d0b2f6e090$var$V;){
        var e = $b1ceb1d0b2f6e090$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b1ceb1d0b2f6e090$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b1ceb1d0b2f6e090$var$U;
                h = $b1ceb1d0b2f6e090$var$Jj;
                var l = $b1ceb1d0b2f6e090$var$U;
                $b1ceb1d0b2f6e090$var$Jj = g;
                if (($b1ceb1d0b2f6e090$var$U = k) && !l) for($b1ceb1d0b2f6e090$var$V = e; null !== $b1ceb1d0b2f6e090$var$V;)g = $b1ceb1d0b2f6e090$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b1ceb1d0b2f6e090$var$jk(e) : null !== k ? (k.return = g, $b1ceb1d0b2f6e090$var$V = k) : $b1ceb1d0b2f6e090$var$jk(e);
                for(; null !== f;)$b1ceb1d0b2f6e090$var$V = f, $b1ceb1d0b2f6e090$var$ik(f, b, c), f = f.sibling;
                $b1ceb1d0b2f6e090$var$V = e;
                $b1ceb1d0b2f6e090$var$Jj = h;
                $b1ceb1d0b2f6e090$var$U = l;
            }
            $b1ceb1d0b2f6e090$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b1ceb1d0b2f6e090$var$V = f) : $b1ceb1d0b2f6e090$var$kk(a, b, c);
    }
}
function $b1ceb1d0b2f6e090$var$kk(a) {
    for(; null !== $b1ceb1d0b2f6e090$var$V;){
        var b = $b1ceb1d0b2f6e090$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b1ceb1d0b2f6e090$var$U || $b1ceb1d0b2f6e090$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b1ceb1d0b2f6e090$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b1ceb1d0b2f6e090$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b1ceb1d0b2f6e090$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b1ceb1d0b2f6e090$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b1ceb1d0b2f6e090$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b1ceb1d0b2f6e090$var$p(163));
                }
                $b1ceb1d0b2f6e090$var$U || b.flags & 512 && $b1ceb1d0b2f6e090$var$Rj(b);
            } catch (r) {
                $b1ceb1d0b2f6e090$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b1ceb1d0b2f6e090$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b1ceb1d0b2f6e090$var$V = c;
            break;
        }
        $b1ceb1d0b2f6e090$var$V = b.return;
    }
}
function $b1ceb1d0b2f6e090$var$gk(a) {
    for(; null !== $b1ceb1d0b2f6e090$var$V;){
        var b = $b1ceb1d0b2f6e090$var$V;
        if (b === a) {
            $b1ceb1d0b2f6e090$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b1ceb1d0b2f6e090$var$V = c;
            break;
        }
        $b1ceb1d0b2f6e090$var$V = b.return;
    }
}
function $b1ceb1d0b2f6e090$var$jk(a) {
    for(; null !== $b1ceb1d0b2f6e090$var$V;){
        var b = $b1ceb1d0b2f6e090$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b1ceb1d0b2f6e090$var$Qj(4, b);
                    } catch (k) {
                        $b1ceb1d0b2f6e090$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b1ceb1d0b2f6e090$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b1ceb1d0b2f6e090$var$Rj(b);
                    } catch (k) {
                        $b1ceb1d0b2f6e090$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b1ceb1d0b2f6e090$var$Rj(b);
                    } catch (k) {
                        $b1ceb1d0b2f6e090$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b1ceb1d0b2f6e090$var$W(b, b.return, k);
        }
        if (b === a) {
            $b1ceb1d0b2f6e090$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b1ceb1d0b2f6e090$var$V = h;
            break;
        }
        $b1ceb1d0b2f6e090$var$V = b.return;
    }
}
var $b1ceb1d0b2f6e090$var$lk = Math.ceil, $b1ceb1d0b2f6e090$var$mk = $b1ceb1d0b2f6e090$var$ua.ReactCurrentDispatcher, $b1ceb1d0b2f6e090$var$nk = $b1ceb1d0b2f6e090$var$ua.ReactCurrentOwner, $b1ceb1d0b2f6e090$var$ok = $b1ceb1d0b2f6e090$var$ua.ReactCurrentBatchConfig, $b1ceb1d0b2f6e090$var$K = 0, $b1ceb1d0b2f6e090$var$Q = null, $b1ceb1d0b2f6e090$var$Y = null, $b1ceb1d0b2f6e090$var$Z = 0, $b1ceb1d0b2f6e090$var$fj = 0, $b1ceb1d0b2f6e090$var$ej = $b1ceb1d0b2f6e090$var$Uf(0), $b1ceb1d0b2f6e090$var$T = 0, $b1ceb1d0b2f6e090$var$pk = null, $b1ceb1d0b2f6e090$var$rh = 0, $b1ceb1d0b2f6e090$var$qk = 0, $b1ceb1d0b2f6e090$var$rk = 0, $b1ceb1d0b2f6e090$var$sk = null, $b1ceb1d0b2f6e090$var$tk = null, $b1ceb1d0b2f6e090$var$fk = 0, $b1ceb1d0b2f6e090$var$Gj = Infinity, $b1ceb1d0b2f6e090$var$uk = null, $b1ceb1d0b2f6e090$var$Oi = !1, $b1ceb1d0b2f6e090$var$Pi = null, $b1ceb1d0b2f6e090$var$Ri = null, $b1ceb1d0b2f6e090$var$vk = !1, $b1ceb1d0b2f6e090$var$wk = null, $b1ceb1d0b2f6e090$var$xk = 0, $b1ceb1d0b2f6e090$var$yk = 0, $b1ceb1d0b2f6e090$var$zk = null, $b1ceb1d0b2f6e090$var$Ak = -1, $b1ceb1d0b2f6e090$var$Bk = 0;
function $b1ceb1d0b2f6e090$var$R() {
    return 0 !== ($b1ceb1d0b2f6e090$var$K & 6) ? $b1ceb1d0b2f6e090$var$B() : -1 !== $b1ceb1d0b2f6e090$var$Ak ? $b1ceb1d0b2f6e090$var$Ak : $b1ceb1d0b2f6e090$var$Ak = $b1ceb1d0b2f6e090$var$B();
}
function $b1ceb1d0b2f6e090$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b1ceb1d0b2f6e090$var$K & 2) && 0 !== $b1ceb1d0b2f6e090$var$Z) return $b1ceb1d0b2f6e090$var$Z & -$b1ceb1d0b2f6e090$var$Z;
    if (null !== $b1ceb1d0b2f6e090$var$Kg.transition) return 0 === $b1ceb1d0b2f6e090$var$Bk && ($b1ceb1d0b2f6e090$var$Bk = $b1ceb1d0b2f6e090$var$yc()), $b1ceb1d0b2f6e090$var$Bk;
    a = $b1ceb1d0b2f6e090$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b1ceb1d0b2f6e090$var$jd(a.type);
    return a;
}
function $b1ceb1d0b2f6e090$var$gi(a, b, c, d) {
    if (50 < $b1ceb1d0b2f6e090$var$yk) throw $b1ceb1d0b2f6e090$var$yk = 0, $b1ceb1d0b2f6e090$var$zk = null, Error($b1ceb1d0b2f6e090$var$p(185));
    $b1ceb1d0b2f6e090$var$Ac(a, c, d);
    if (0 === ($b1ceb1d0b2f6e090$var$K & 2) || a !== $b1ceb1d0b2f6e090$var$Q) a === $b1ceb1d0b2f6e090$var$Q && (0 === ($b1ceb1d0b2f6e090$var$K & 2) && ($b1ceb1d0b2f6e090$var$qk |= c), 4 === $b1ceb1d0b2f6e090$var$T && $b1ceb1d0b2f6e090$var$Ck(a, $b1ceb1d0b2f6e090$var$Z)), $b1ceb1d0b2f6e090$var$Dk(a, d), 1 === c && 0 === $b1ceb1d0b2f6e090$var$K && 0 === (b.mode & 1) && ($b1ceb1d0b2f6e090$var$Gj = $b1ceb1d0b2f6e090$var$B() + 500, $b1ceb1d0b2f6e090$var$fg && $b1ceb1d0b2f6e090$var$jg());
}
function $b1ceb1d0b2f6e090$var$Dk(a, b) {
    var c = a.callbackNode;
    $b1ceb1d0b2f6e090$var$wc(a, b);
    var d = $b1ceb1d0b2f6e090$var$uc(a, a === $b1ceb1d0b2f6e090$var$Q ? $b1ceb1d0b2f6e090$var$Z : 0);
    if (0 === d) null !== c && $b1ceb1d0b2f6e090$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b1ceb1d0b2f6e090$var$bc(c);
        if (1 === b) 0 === a.tag ? $b1ceb1d0b2f6e090$var$ig($b1ceb1d0b2f6e090$var$Ek.bind(null, a)) : $b1ceb1d0b2f6e090$var$hg($b1ceb1d0b2f6e090$var$Ek.bind(null, a)), $b1ceb1d0b2f6e090$var$Jf(function() {
            0 === ($b1ceb1d0b2f6e090$var$K & 6) && $b1ceb1d0b2f6e090$var$jg();
        }), c = null;
        else {
            switch($b1ceb1d0b2f6e090$var$Dc(d)){
                case 1:
                    c = $b1ceb1d0b2f6e090$var$fc;
                    break;
                case 4:
                    c = $b1ceb1d0b2f6e090$var$gc;
                    break;
                case 16:
                    c = $b1ceb1d0b2f6e090$var$hc;
                    break;
                case 536870912:
                    c = $b1ceb1d0b2f6e090$var$jc;
                    break;
                default:
                    c = $b1ceb1d0b2f6e090$var$hc;
            }
            c = $b1ceb1d0b2f6e090$var$Fk(c, $b1ceb1d0b2f6e090$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b1ceb1d0b2f6e090$var$Gk(a, b) {
    $b1ceb1d0b2f6e090$var$Ak = -1;
    $b1ceb1d0b2f6e090$var$Bk = 0;
    if (0 !== ($b1ceb1d0b2f6e090$var$K & 6)) throw Error($b1ceb1d0b2f6e090$var$p(327));
    var c = a.callbackNode;
    if ($b1ceb1d0b2f6e090$var$Hk() && a.callbackNode !== c) return null;
    var d = $b1ceb1d0b2f6e090$var$uc(a, a === $b1ceb1d0b2f6e090$var$Q ? $b1ceb1d0b2f6e090$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b1ceb1d0b2f6e090$var$Ik(a, d);
    else {
        b = d;
        var e = $b1ceb1d0b2f6e090$var$K;
        $b1ceb1d0b2f6e090$var$K |= 2;
        var f = $b1ceb1d0b2f6e090$var$Jk();
        if ($b1ceb1d0b2f6e090$var$Q !== a || $b1ceb1d0b2f6e090$var$Z !== b) $b1ceb1d0b2f6e090$var$uk = null, $b1ceb1d0b2f6e090$var$Gj = $b1ceb1d0b2f6e090$var$B() + 500, $b1ceb1d0b2f6e090$var$Kk(a, b);
        for(;;)try {
            $b1ceb1d0b2f6e090$var$Lk();
            break;
        } catch (h) {
            $b1ceb1d0b2f6e090$var$Mk(a, h);
        }
        $b1ceb1d0b2f6e090$var$$g();
        $b1ceb1d0b2f6e090$var$mk.current = f;
        $b1ceb1d0b2f6e090$var$K = e;
        null !== $b1ceb1d0b2f6e090$var$Y ? b = 0 : ($b1ceb1d0b2f6e090$var$Q = null, $b1ceb1d0b2f6e090$var$Z = 0, b = $b1ceb1d0b2f6e090$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b1ceb1d0b2f6e090$var$xc(a), 0 !== e && (d = e, b = $b1ceb1d0b2f6e090$var$Nk(a, e)));
        if (1 === b) throw c = $b1ceb1d0b2f6e090$var$pk, $b1ceb1d0b2f6e090$var$Kk(a, 0), $b1ceb1d0b2f6e090$var$Ck(a, d), $b1ceb1d0b2f6e090$var$Dk(a, $b1ceb1d0b2f6e090$var$B()), c;
        if (6 === b) $b1ceb1d0b2f6e090$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b1ceb1d0b2f6e090$var$Ok(e) && (b = $b1ceb1d0b2f6e090$var$Ik(a, d), 2 === b && (f = $b1ceb1d0b2f6e090$var$xc(a), 0 !== f && (d = f, b = $b1ceb1d0b2f6e090$var$Nk(a, f))), 1 === b)) throw c = $b1ceb1d0b2f6e090$var$pk, $b1ceb1d0b2f6e090$var$Kk(a, 0), $b1ceb1d0b2f6e090$var$Ck(a, d), $b1ceb1d0b2f6e090$var$Dk(a, $b1ceb1d0b2f6e090$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b1ceb1d0b2f6e090$var$p(345));
                case 2:
                    $b1ceb1d0b2f6e090$var$Pk(a, $b1ceb1d0b2f6e090$var$tk, $b1ceb1d0b2f6e090$var$uk);
                    break;
                case 3:
                    $b1ceb1d0b2f6e090$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $b1ceb1d0b2f6e090$var$fk + 500 - $b1ceb1d0b2f6e090$var$B(), 10 < b)) {
                        if (0 !== $b1ceb1d0b2f6e090$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b1ceb1d0b2f6e090$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b1ceb1d0b2f6e090$var$Ff($b1ceb1d0b2f6e090$var$Pk.bind(null, a, $b1ceb1d0b2f6e090$var$tk, $b1ceb1d0b2f6e090$var$uk), b);
                        break;
                    }
                    $b1ceb1d0b2f6e090$var$Pk(a, $b1ceb1d0b2f6e090$var$tk, $b1ceb1d0b2f6e090$var$uk);
                    break;
                case 4:
                    $b1ceb1d0b2f6e090$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b1ceb1d0b2f6e090$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b1ceb1d0b2f6e090$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b1ceb1d0b2f6e090$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b1ceb1d0b2f6e090$var$Ff($b1ceb1d0b2f6e090$var$Pk.bind(null, a, $b1ceb1d0b2f6e090$var$tk, $b1ceb1d0b2f6e090$var$uk), d);
                        break;
                    }
                    $b1ceb1d0b2f6e090$var$Pk(a, $b1ceb1d0b2f6e090$var$tk, $b1ceb1d0b2f6e090$var$uk);
                    break;
                case 5:
                    $b1ceb1d0b2f6e090$var$Pk(a, $b1ceb1d0b2f6e090$var$tk, $b1ceb1d0b2f6e090$var$uk);
                    break;
                default:
                    throw Error($b1ceb1d0b2f6e090$var$p(329));
            }
        }
    }
    $b1ceb1d0b2f6e090$var$Dk(a, $b1ceb1d0b2f6e090$var$B());
    return a.callbackNode === c ? $b1ceb1d0b2f6e090$var$Gk.bind(null, a) : null;
}
function $b1ceb1d0b2f6e090$var$Nk(a, b) {
    var c = $b1ceb1d0b2f6e090$var$sk;
    a.current.memoizedState.isDehydrated && ($b1ceb1d0b2f6e090$var$Kk(a, b).flags |= 256);
    a = $b1ceb1d0b2f6e090$var$Ik(a, b);
    2 !== a && (b = $b1ceb1d0b2f6e090$var$tk, $b1ceb1d0b2f6e090$var$tk = c, null !== b && $b1ceb1d0b2f6e090$var$Fj(b));
    return a;
}
function $b1ceb1d0b2f6e090$var$Fj(a) {
    null === $b1ceb1d0b2f6e090$var$tk ? $b1ceb1d0b2f6e090$var$tk = a : $b1ceb1d0b2f6e090$var$tk.push.apply($b1ceb1d0b2f6e090$var$tk, a);
}
function $b1ceb1d0b2f6e090$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b1ceb1d0b2f6e090$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b1ceb1d0b2f6e090$var$Ck(a, b) {
    b &= ~$b1ceb1d0b2f6e090$var$rk;
    b &= ~$b1ceb1d0b2f6e090$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b1ceb1d0b2f6e090$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b1ceb1d0b2f6e090$var$Ek(a) {
    if (0 !== ($b1ceb1d0b2f6e090$var$K & 6)) throw Error($b1ceb1d0b2f6e090$var$p(327));
    $b1ceb1d0b2f6e090$var$Hk();
    var b = $b1ceb1d0b2f6e090$var$uc(a, 0);
    if (0 === (b & 1)) return $b1ceb1d0b2f6e090$var$Dk(a, $b1ceb1d0b2f6e090$var$B()), null;
    var c = $b1ceb1d0b2f6e090$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b1ceb1d0b2f6e090$var$xc(a);
        0 !== d && (b = d, c = $b1ceb1d0b2f6e090$var$Nk(a, d));
    }
    if (1 === c) throw c = $b1ceb1d0b2f6e090$var$pk, $b1ceb1d0b2f6e090$var$Kk(a, 0), $b1ceb1d0b2f6e090$var$Ck(a, b), $b1ceb1d0b2f6e090$var$Dk(a, $b1ceb1d0b2f6e090$var$B()), c;
    if (6 === c) throw Error($b1ceb1d0b2f6e090$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b1ceb1d0b2f6e090$var$Pk(a, $b1ceb1d0b2f6e090$var$tk, $b1ceb1d0b2f6e090$var$uk);
    $b1ceb1d0b2f6e090$var$Dk(a, $b1ceb1d0b2f6e090$var$B());
    return null;
}
function $b1ceb1d0b2f6e090$var$Qk(a, b) {
    var c = $b1ceb1d0b2f6e090$var$K;
    $b1ceb1d0b2f6e090$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b1ceb1d0b2f6e090$var$K = c, 0 === $b1ceb1d0b2f6e090$var$K && ($b1ceb1d0b2f6e090$var$Gj = $b1ceb1d0b2f6e090$var$B() + 500, $b1ceb1d0b2f6e090$var$fg && $b1ceb1d0b2f6e090$var$jg());
    }
}
function $b1ceb1d0b2f6e090$var$Rk(a) {
    null !== $b1ceb1d0b2f6e090$var$wk && 0 === $b1ceb1d0b2f6e090$var$wk.tag && 0 === ($b1ceb1d0b2f6e090$var$K & 6) && $b1ceb1d0b2f6e090$var$Hk();
    var b = $b1ceb1d0b2f6e090$var$K;
    $b1ceb1d0b2f6e090$var$K |= 1;
    var c = $b1ceb1d0b2f6e090$var$ok.transition, d = $b1ceb1d0b2f6e090$var$C;
    try {
        if ($b1ceb1d0b2f6e090$var$ok.transition = null, $b1ceb1d0b2f6e090$var$C = 1, a) return a();
    } finally{
        $b1ceb1d0b2f6e090$var$C = d, $b1ceb1d0b2f6e090$var$ok.transition = c, $b1ceb1d0b2f6e090$var$K = b, 0 === ($b1ceb1d0b2f6e090$var$K & 6) && $b1ceb1d0b2f6e090$var$jg();
    }
}
function $b1ceb1d0b2f6e090$var$Hj() {
    $b1ceb1d0b2f6e090$var$fj = $b1ceb1d0b2f6e090$var$ej.current;
    $b1ceb1d0b2f6e090$var$E($b1ceb1d0b2f6e090$var$ej);
}
function $b1ceb1d0b2f6e090$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b1ceb1d0b2f6e090$var$Gf(c));
    if (null !== $b1ceb1d0b2f6e090$var$Y) for(c = $b1ceb1d0b2f6e090$var$Y.return; null !== c;){
        var d = c;
        $b1ceb1d0b2f6e090$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b1ceb1d0b2f6e090$var$$f();
                break;
            case 3:
                $b1ceb1d0b2f6e090$var$zh();
                $b1ceb1d0b2f6e090$var$E($b1ceb1d0b2f6e090$var$Wf);
                $b1ceb1d0b2f6e090$var$E($b1ceb1d0b2f6e090$var$H);
                $b1ceb1d0b2f6e090$var$Eh();
                break;
            case 5:
                $b1ceb1d0b2f6e090$var$Bh(d);
                break;
            case 4:
                $b1ceb1d0b2f6e090$var$zh();
                break;
            case 13:
                $b1ceb1d0b2f6e090$var$E($b1ceb1d0b2f6e090$var$L);
                break;
            case 19:
                $b1ceb1d0b2f6e090$var$E($b1ceb1d0b2f6e090$var$L);
                break;
            case 10:
                $b1ceb1d0b2f6e090$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $b1ceb1d0b2f6e090$var$Hj();
        }
        c = c.return;
    }
    $b1ceb1d0b2f6e090$var$Q = a;
    $b1ceb1d0b2f6e090$var$Y = a = $b1ceb1d0b2f6e090$var$Pg(a.current, null);
    $b1ceb1d0b2f6e090$var$Z = $b1ceb1d0b2f6e090$var$fj = b;
    $b1ceb1d0b2f6e090$var$T = 0;
    $b1ceb1d0b2f6e090$var$pk = null;
    $b1ceb1d0b2f6e090$var$rk = $b1ceb1d0b2f6e090$var$qk = $b1ceb1d0b2f6e090$var$rh = 0;
    $b1ceb1d0b2f6e090$var$tk = $b1ceb1d0b2f6e090$var$sk = null;
    if (null !== $b1ceb1d0b2f6e090$var$fh) {
        for(b = 0; b < $b1ceb1d0b2f6e090$var$fh.length; b++)if (c = $b1ceb1d0b2f6e090$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b1ceb1d0b2f6e090$var$fh = null;
    }
    return a;
}
function $b1ceb1d0b2f6e090$var$Mk(a, b) {
    do {
        var c = $b1ceb1d0b2f6e090$var$Y;
        try {
            $b1ceb1d0b2f6e090$var$$g();
            $b1ceb1d0b2f6e090$var$Fh.current = $b1ceb1d0b2f6e090$var$Rh;
            if ($b1ceb1d0b2f6e090$var$Ih) {
                for(var d = $b1ceb1d0b2f6e090$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b1ceb1d0b2f6e090$var$Ih = !1;
            }
            $b1ceb1d0b2f6e090$var$Hh = 0;
            $b1ceb1d0b2f6e090$var$O = $b1ceb1d0b2f6e090$var$N = $b1ceb1d0b2f6e090$var$M = null;
            $b1ceb1d0b2f6e090$var$Jh = !1;
            $b1ceb1d0b2f6e090$var$Kh = 0;
            $b1ceb1d0b2f6e090$var$nk.current = null;
            if (null === c || null === c.return) {
                $b1ceb1d0b2f6e090$var$T = 1;
                $b1ceb1d0b2f6e090$var$pk = b;
                $b1ceb1d0b2f6e090$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b1ceb1d0b2f6e090$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b1ceb1d0b2f6e090$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b1ceb1d0b2f6e090$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $b1ceb1d0b2f6e090$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b1ceb1d0b2f6e090$var$Si(f, l, b);
                            $b1ceb1d0b2f6e090$var$tj();
                            break a;
                        }
                        k = Error($b1ceb1d0b2f6e090$var$p(426));
                    }
                } else if ($b1ceb1d0b2f6e090$var$I && h.mode & 1) {
                    var J = $b1ceb1d0b2f6e090$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b1ceb1d0b2f6e090$var$Vi(J, g, h, f, b);
                        $b1ceb1d0b2f6e090$var$Jg($b1ceb1d0b2f6e090$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $b1ceb1d0b2f6e090$var$Ji(k, h);
                4 !== $b1ceb1d0b2f6e090$var$T && ($b1ceb1d0b2f6e090$var$T = 2);
                null === $b1ceb1d0b2f6e090$var$sk ? $b1ceb1d0b2f6e090$var$sk = [
                    f
                ] : $b1ceb1d0b2f6e090$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b1ceb1d0b2f6e090$var$Ni(f, k, b);
                            $b1ceb1d0b2f6e090$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b1ceb1d0b2f6e090$var$Ri || !$b1ceb1d0b2f6e090$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b1ceb1d0b2f6e090$var$Qi(f, h, b);
                                $b1ceb1d0b2f6e090$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b1ceb1d0b2f6e090$var$Sk(c);
        } catch (na) {
            b = na;
            $b1ceb1d0b2f6e090$var$Y === c && null !== c && ($b1ceb1d0b2f6e090$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b1ceb1d0b2f6e090$var$Jk() {
    var a = $b1ceb1d0b2f6e090$var$mk.current;
    $b1ceb1d0b2f6e090$var$mk.current = $b1ceb1d0b2f6e090$var$Rh;
    return null === a ? $b1ceb1d0b2f6e090$var$Rh : a;
}
function $b1ceb1d0b2f6e090$var$tj() {
    if (0 === $b1ceb1d0b2f6e090$var$T || 3 === $b1ceb1d0b2f6e090$var$T || 2 === $b1ceb1d0b2f6e090$var$T) $b1ceb1d0b2f6e090$var$T = 4;
    null === $b1ceb1d0b2f6e090$var$Q || 0 === ($b1ceb1d0b2f6e090$var$rh & 268435455) && 0 === ($b1ceb1d0b2f6e090$var$qk & 268435455) || $b1ceb1d0b2f6e090$var$Ck($b1ceb1d0b2f6e090$var$Q, $b1ceb1d0b2f6e090$var$Z);
}
function $b1ceb1d0b2f6e090$var$Ik(a, b) {
    var c = $b1ceb1d0b2f6e090$var$K;
    $b1ceb1d0b2f6e090$var$K |= 2;
    var d = $b1ceb1d0b2f6e090$var$Jk();
    if ($b1ceb1d0b2f6e090$var$Q !== a || $b1ceb1d0b2f6e090$var$Z !== b) $b1ceb1d0b2f6e090$var$uk = null, $b1ceb1d0b2f6e090$var$Kk(a, b);
    for(;;)try {
        $b1ceb1d0b2f6e090$var$Tk();
        break;
    } catch (e) {
        $b1ceb1d0b2f6e090$var$Mk(a, e);
    }
    $b1ceb1d0b2f6e090$var$$g();
    $b1ceb1d0b2f6e090$var$K = c;
    $b1ceb1d0b2f6e090$var$mk.current = d;
    if (null !== $b1ceb1d0b2f6e090$var$Y) throw Error($b1ceb1d0b2f6e090$var$p(261));
    $b1ceb1d0b2f6e090$var$Q = null;
    $b1ceb1d0b2f6e090$var$Z = 0;
    return $b1ceb1d0b2f6e090$var$T;
}
function $b1ceb1d0b2f6e090$var$Tk() {
    for(; null !== $b1ceb1d0b2f6e090$var$Y;)$b1ceb1d0b2f6e090$var$Uk($b1ceb1d0b2f6e090$var$Y);
}
function $b1ceb1d0b2f6e090$var$Lk() {
    for(; null !== $b1ceb1d0b2f6e090$var$Y && !$b1ceb1d0b2f6e090$var$cc();)$b1ceb1d0b2f6e090$var$Uk($b1ceb1d0b2f6e090$var$Y);
}
function $b1ceb1d0b2f6e090$var$Uk(a) {
    var b = $b1ceb1d0b2f6e090$var$Vk(a.alternate, a, $b1ceb1d0b2f6e090$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b1ceb1d0b2f6e090$var$Sk(a) : $b1ceb1d0b2f6e090$var$Y = b;
    $b1ceb1d0b2f6e090$var$nk.current = null;
}
function $b1ceb1d0b2f6e090$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b1ceb1d0b2f6e090$var$Ej(c, b, $b1ceb1d0b2f6e090$var$fj), null !== c) {
                $b1ceb1d0b2f6e090$var$Y = c;
                return;
            }
        } else {
            c = $b1ceb1d0b2f6e090$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b1ceb1d0b2f6e090$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b1ceb1d0b2f6e090$var$T = 6;
                $b1ceb1d0b2f6e090$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b1ceb1d0b2f6e090$var$Y = b;
            return;
        }
        $b1ceb1d0b2f6e090$var$Y = b = a;
    }while (null !== b);
    0 === $b1ceb1d0b2f6e090$var$T && ($b1ceb1d0b2f6e090$var$T = 5);
}
function $b1ceb1d0b2f6e090$var$Pk(a, b, c) {
    var d = $b1ceb1d0b2f6e090$var$C, e = $b1ceb1d0b2f6e090$var$ok.transition;
    try {
        $b1ceb1d0b2f6e090$var$ok.transition = null, $b1ceb1d0b2f6e090$var$C = 1, $b1ceb1d0b2f6e090$var$Wk(a, b, c, d);
    } finally{
        $b1ceb1d0b2f6e090$var$ok.transition = e, $b1ceb1d0b2f6e090$var$C = d;
    }
    return null;
}
function $b1ceb1d0b2f6e090$var$Wk(a, b, c, d) {
    do $b1ceb1d0b2f6e090$var$Hk();
    while (null !== $b1ceb1d0b2f6e090$var$wk);
    if (0 !== ($b1ceb1d0b2f6e090$var$K & 6)) throw Error($b1ceb1d0b2f6e090$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b1ceb1d0b2f6e090$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b1ceb1d0b2f6e090$var$Bc(a, f);
    a === $b1ceb1d0b2f6e090$var$Q && ($b1ceb1d0b2f6e090$var$Y = $b1ceb1d0b2f6e090$var$Q = null, $b1ceb1d0b2f6e090$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b1ceb1d0b2f6e090$var$vk || ($b1ceb1d0b2f6e090$var$vk = !0, $b1ceb1d0b2f6e090$var$Fk($b1ceb1d0b2f6e090$var$hc, function() {
        $b1ceb1d0b2f6e090$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b1ceb1d0b2f6e090$var$ok.transition;
        $b1ceb1d0b2f6e090$var$ok.transition = null;
        var g = $b1ceb1d0b2f6e090$var$C;
        $b1ceb1d0b2f6e090$var$C = 1;
        var h = $b1ceb1d0b2f6e090$var$K;
        $b1ceb1d0b2f6e090$var$K |= 4;
        $b1ceb1d0b2f6e090$var$nk.current = null;
        $b1ceb1d0b2f6e090$var$Oj(a, c);
        $b1ceb1d0b2f6e090$var$dk(c, a);
        $b1ceb1d0b2f6e090$var$Oe($b1ceb1d0b2f6e090$var$Df);
        $b1ceb1d0b2f6e090$var$dd = !!$b1ceb1d0b2f6e090$var$Cf;
        $b1ceb1d0b2f6e090$var$Df = $b1ceb1d0b2f6e090$var$Cf = null;
        a.current = c;
        $b1ceb1d0b2f6e090$var$hk(c, a, e);
        $b1ceb1d0b2f6e090$var$dc();
        $b1ceb1d0b2f6e090$var$K = h;
        $b1ceb1d0b2f6e090$var$C = g;
        $b1ceb1d0b2f6e090$var$ok.transition = f;
    } else a.current = c;
    $b1ceb1d0b2f6e090$var$vk && ($b1ceb1d0b2f6e090$var$vk = !1, $b1ceb1d0b2f6e090$var$wk = a, $b1ceb1d0b2f6e090$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($b1ceb1d0b2f6e090$var$Ri = null);
    $b1ceb1d0b2f6e090$var$mc(c.stateNode, d);
    $b1ceb1d0b2f6e090$var$Dk(a, $b1ceb1d0b2f6e090$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b1ceb1d0b2f6e090$var$Oi) throw $b1ceb1d0b2f6e090$var$Oi = !1, a = $b1ceb1d0b2f6e090$var$Pi, $b1ceb1d0b2f6e090$var$Pi = null, a;
    0 !== ($b1ceb1d0b2f6e090$var$xk & 1) && 0 !== a.tag && $b1ceb1d0b2f6e090$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b1ceb1d0b2f6e090$var$zk ? $b1ceb1d0b2f6e090$var$yk++ : ($b1ceb1d0b2f6e090$var$yk = 0, $b1ceb1d0b2f6e090$var$zk = a) : $b1ceb1d0b2f6e090$var$yk = 0;
    $b1ceb1d0b2f6e090$var$jg();
    return null;
}
function $b1ceb1d0b2f6e090$var$Hk() {
    if (null !== $b1ceb1d0b2f6e090$var$wk) {
        var a = $b1ceb1d0b2f6e090$var$Dc($b1ceb1d0b2f6e090$var$xk), b = $b1ceb1d0b2f6e090$var$ok.transition, c = $b1ceb1d0b2f6e090$var$C;
        try {
            $b1ceb1d0b2f6e090$var$ok.transition = null;
            $b1ceb1d0b2f6e090$var$C = 16 > a ? 16 : a;
            if (null === $b1ceb1d0b2f6e090$var$wk) var d = !1;
            else {
                a = $b1ceb1d0b2f6e090$var$wk;
                $b1ceb1d0b2f6e090$var$wk = null;
                $b1ceb1d0b2f6e090$var$xk = 0;
                if (0 !== ($b1ceb1d0b2f6e090$var$K & 6)) throw Error($b1ceb1d0b2f6e090$var$p(331));
                var e = $b1ceb1d0b2f6e090$var$K;
                $b1ceb1d0b2f6e090$var$K |= 4;
                for($b1ceb1d0b2f6e090$var$V = a.current; null !== $b1ceb1d0b2f6e090$var$V;){
                    var f = $b1ceb1d0b2f6e090$var$V, g = f.child;
                    if (0 !== ($b1ceb1d0b2f6e090$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b1ceb1d0b2f6e090$var$V = l; null !== $b1ceb1d0b2f6e090$var$V;){
                                    var m = $b1ceb1d0b2f6e090$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b1ceb1d0b2f6e090$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b1ceb1d0b2f6e090$var$V = q;
                                    else for(; null !== $b1ceb1d0b2f6e090$var$V;){
                                        m = $b1ceb1d0b2f6e090$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b1ceb1d0b2f6e090$var$Sj(m);
                                        if (m === l) {
                                            $b1ceb1d0b2f6e090$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b1ceb1d0b2f6e090$var$V = r;
                                            break;
                                        }
                                        $b1ceb1d0b2f6e090$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b1ceb1d0b2f6e090$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b1ceb1d0b2f6e090$var$V = g;
                    else b: for(; null !== $b1ceb1d0b2f6e090$var$V;){
                        f = $b1ceb1d0b2f6e090$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b1ceb1d0b2f6e090$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b1ceb1d0b2f6e090$var$V = x;
                            break b;
                        }
                        $b1ceb1d0b2f6e090$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b1ceb1d0b2f6e090$var$V = w; null !== $b1ceb1d0b2f6e090$var$V;){
                    g = $b1ceb1d0b2f6e090$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b1ceb1d0b2f6e090$var$V = u;
                    else b: for(g = w; null !== $b1ceb1d0b2f6e090$var$V;){
                        h = $b1ceb1d0b2f6e090$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b1ceb1d0b2f6e090$var$Qj(9, h);
                            }
                        } catch (na) {
                            $b1ceb1d0b2f6e090$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b1ceb1d0b2f6e090$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b1ceb1d0b2f6e090$var$V = F;
                            break b;
                        }
                        $b1ceb1d0b2f6e090$var$V = h.return;
                    }
                }
                $b1ceb1d0b2f6e090$var$K = e;
                $b1ceb1d0b2f6e090$var$jg();
                if ($b1ceb1d0b2f6e090$var$lc && "function" === typeof $b1ceb1d0b2f6e090$var$lc.onPostCommitFiberRoot) try {
                    $b1ceb1d0b2f6e090$var$lc.onPostCommitFiberRoot($b1ceb1d0b2f6e090$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b1ceb1d0b2f6e090$var$C = c, $b1ceb1d0b2f6e090$var$ok.transition = b;
        }
    }
    return !1;
}
function $b1ceb1d0b2f6e090$var$Xk(a, b, c) {
    b = $b1ceb1d0b2f6e090$var$Ji(c, b);
    b = $b1ceb1d0b2f6e090$var$Ni(a, b, 1);
    a = $b1ceb1d0b2f6e090$var$nh(a, b, 1);
    b = $b1ceb1d0b2f6e090$var$R();
    null !== a && ($b1ceb1d0b2f6e090$var$Ac(a, 1, b), $b1ceb1d0b2f6e090$var$Dk(a, b));
}
function $b1ceb1d0b2f6e090$var$W(a, b, c) {
    if (3 === a.tag) $b1ceb1d0b2f6e090$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b1ceb1d0b2f6e090$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b1ceb1d0b2f6e090$var$Ri || !$b1ceb1d0b2f6e090$var$Ri.has(d))) {
                a = $b1ceb1d0b2f6e090$var$Ji(c, a);
                a = $b1ceb1d0b2f6e090$var$Qi(b, a, 1);
                b = $b1ceb1d0b2f6e090$var$nh(b, a, 1);
                a = $b1ceb1d0b2f6e090$var$R();
                null !== b && ($b1ceb1d0b2f6e090$var$Ac(b, 1, a), $b1ceb1d0b2f6e090$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b1ceb1d0b2f6e090$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b1ceb1d0b2f6e090$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $b1ceb1d0b2f6e090$var$Q === a && ($b1ceb1d0b2f6e090$var$Z & c) === c && (4 === $b1ceb1d0b2f6e090$var$T || 3 === $b1ceb1d0b2f6e090$var$T && ($b1ceb1d0b2f6e090$var$Z & 130023424) === $b1ceb1d0b2f6e090$var$Z && 500 > $b1ceb1d0b2f6e090$var$B() - $b1ceb1d0b2f6e090$var$fk ? $b1ceb1d0b2f6e090$var$Kk(a, 0) : $b1ceb1d0b2f6e090$var$rk |= c);
    $b1ceb1d0b2f6e090$var$Dk(a, b);
}
function $b1ceb1d0b2f6e090$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b1ceb1d0b2f6e090$var$sc, $b1ceb1d0b2f6e090$var$sc <<= 1, 0 === ($b1ceb1d0b2f6e090$var$sc & 130023424) && ($b1ceb1d0b2f6e090$var$sc = 4194304)));
    var c = $b1ceb1d0b2f6e090$var$R();
    a = $b1ceb1d0b2f6e090$var$ih(a, b);
    null !== a && ($b1ceb1d0b2f6e090$var$Ac(a, b, c), $b1ceb1d0b2f6e090$var$Dk(a, c));
}
function $b1ceb1d0b2f6e090$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b1ceb1d0b2f6e090$var$Yk(a, c);
}
function $b1ceb1d0b2f6e090$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b1ceb1d0b2f6e090$var$p(314));
    }
    null !== d && d.delete(b);
    $b1ceb1d0b2f6e090$var$Yk(a, c);
}
var $b1ceb1d0b2f6e090$var$Vk;
$b1ceb1d0b2f6e090$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b1ceb1d0b2f6e090$var$Wf.current) $b1ceb1d0b2f6e090$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b1ceb1d0b2f6e090$var$dh = !1, $b1ceb1d0b2f6e090$var$yj(a, b, c);
            $b1ceb1d0b2f6e090$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b1ceb1d0b2f6e090$var$dh = !1, $b1ceb1d0b2f6e090$var$I && 0 !== (b.flags & 1048576) && $b1ceb1d0b2f6e090$var$ug(b, $b1ceb1d0b2f6e090$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b1ceb1d0b2f6e090$var$ij(a, b);
            a = b.pendingProps;
            var e = $b1ceb1d0b2f6e090$var$Yf(b, $b1ceb1d0b2f6e090$var$H.current);
            $b1ceb1d0b2f6e090$var$ch(b, c);
            e = $b1ceb1d0b2f6e090$var$Nh(null, b, d, a, e, c);
            var f = $b1ceb1d0b2f6e090$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b1ceb1d0b2f6e090$var$Zf(d) ? (f = !0, $b1ceb1d0b2f6e090$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b1ceb1d0b2f6e090$var$kh(b), e.updater = $b1ceb1d0b2f6e090$var$Ei, b.stateNode = e, e._reactInternals = b, $b1ceb1d0b2f6e090$var$Ii(b, d, a, c), b = $b1ceb1d0b2f6e090$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $b1ceb1d0b2f6e090$var$I && f && $b1ceb1d0b2f6e090$var$vg(b), $b1ceb1d0b2f6e090$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b1ceb1d0b2f6e090$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b1ceb1d0b2f6e090$var$Zk(d);
                a = $b1ceb1d0b2f6e090$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $b1ceb1d0b2f6e090$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b1ceb1d0b2f6e090$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b1ceb1d0b2f6e090$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b1ceb1d0b2f6e090$var$$i(null, b, d, $b1ceb1d0b2f6e090$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($b1ceb1d0b2f6e090$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b1ceb1d0b2f6e090$var$Ci(d, e), $b1ceb1d0b2f6e090$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b1ceb1d0b2f6e090$var$Ci(d, e), $b1ceb1d0b2f6e090$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $b1ceb1d0b2f6e090$var$kj(b);
                if (null === a) throw Error($b1ceb1d0b2f6e090$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b1ceb1d0b2f6e090$var$lh(a, b);
                $b1ceb1d0b2f6e090$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b1ceb1d0b2f6e090$var$Ji(Error($b1ceb1d0b2f6e090$var$p(423)), b);
                        b = $b1ceb1d0b2f6e090$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b1ceb1d0b2f6e090$var$Ji(Error($b1ceb1d0b2f6e090$var$p(424)), b);
                        b = $b1ceb1d0b2f6e090$var$lj(a, b, d, c, e);
                        break a;
                    } else for($b1ceb1d0b2f6e090$var$yg = $b1ceb1d0b2f6e090$var$Lf(b.stateNode.containerInfo.firstChild), $b1ceb1d0b2f6e090$var$xg = b, $b1ceb1d0b2f6e090$var$I = !0, $b1ceb1d0b2f6e090$var$zg = null, c = $b1ceb1d0b2f6e090$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b1ceb1d0b2f6e090$var$Ig();
                    if (d === e) {
                        b = $b1ceb1d0b2f6e090$var$Zi(a, b, c);
                        break a;
                    }
                    $b1ceb1d0b2f6e090$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b1ceb1d0b2f6e090$var$Ah(b), null === a && $b1ceb1d0b2f6e090$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b1ceb1d0b2f6e090$var$Ef(d, e) ? g = null : null !== f && $b1ceb1d0b2f6e090$var$Ef(d, f) && (b.flags |= 32), $b1ceb1d0b2f6e090$var$gj(a, b), $b1ceb1d0b2f6e090$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $b1ceb1d0b2f6e090$var$Eg(b), null;
        case 13:
            return $b1ceb1d0b2f6e090$var$oj(a, b, c);
        case 4:
            return $b1ceb1d0b2f6e090$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b1ceb1d0b2f6e090$var$Ug(b, null, d, c) : $b1ceb1d0b2f6e090$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b1ceb1d0b2f6e090$var$Ci(d, e), $b1ceb1d0b2f6e090$var$Yi(a, b, d, e, c);
        case 7:
            return $b1ceb1d0b2f6e090$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b1ceb1d0b2f6e090$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b1ceb1d0b2f6e090$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b1ceb1d0b2f6e090$var$G($b1ceb1d0b2f6e090$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b1ceb1d0b2f6e090$var$He(f.value, g)) {
                        if (f.children === e.children && !$b1ceb1d0b2f6e090$var$Wf.current) {
                            b = $b1ceb1d0b2f6e090$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b1ceb1d0b2f6e090$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b1ceb1d0b2f6e090$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b1ceb1d0b2f6e090$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b1ceb1d0b2f6e090$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b1ceb1d0b2f6e090$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b1ceb1d0b2f6e090$var$ch(b, c), e = $b1ceb1d0b2f6e090$var$eh(e), d = d(e), b.flags |= 1, $b1ceb1d0b2f6e090$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b1ceb1d0b2f6e090$var$Ci(d, b.pendingProps), e = $b1ceb1d0b2f6e090$var$Ci(d.type, e), $b1ceb1d0b2f6e090$var$$i(a, b, d, e, c);
        case 15:
            return $b1ceb1d0b2f6e090$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b1ceb1d0b2f6e090$var$Ci(d, e), $b1ceb1d0b2f6e090$var$ij(a, b), b.tag = 1, $b1ceb1d0b2f6e090$var$Zf(d) ? (a = !0, $b1ceb1d0b2f6e090$var$cg(b)) : a = !1, $b1ceb1d0b2f6e090$var$ch(b, c), $b1ceb1d0b2f6e090$var$Gi(b, d, e), $b1ceb1d0b2f6e090$var$Ii(b, d, e, c), $b1ceb1d0b2f6e090$var$jj(null, b, d, !0, a, c);
        case 19:
            return $b1ceb1d0b2f6e090$var$xj(a, b, c);
        case 22:
            return $b1ceb1d0b2f6e090$var$dj(a, b, c);
    }
    throw Error($b1ceb1d0b2f6e090$var$p(156, b.tag));
};
function $b1ceb1d0b2f6e090$var$Fk(a, b) {
    return $b1ceb1d0b2f6e090$var$ac(a, b);
}
function $b1ceb1d0b2f6e090$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b1ceb1d0b2f6e090$var$Bg(a, b, c, d) {
    return new $b1ceb1d0b2f6e090$var$$k(a, b, c, d);
}
function $b1ceb1d0b2f6e090$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b1ceb1d0b2f6e090$var$Zk(a) {
    if ("function" === typeof a) return $b1ceb1d0b2f6e090$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b1ceb1d0b2f6e090$var$Da) return 11;
        if (a === $b1ceb1d0b2f6e090$var$Ga) return 14;
    }
    return 2;
}
function $b1ceb1d0b2f6e090$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $b1ceb1d0b2f6e090$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b1ceb1d0b2f6e090$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b1ceb1d0b2f6e090$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b1ceb1d0b2f6e090$var$ya:
            return $b1ceb1d0b2f6e090$var$Tg(c.children, e, f, b);
        case $b1ceb1d0b2f6e090$var$za:
            g = 8;
            e |= 8;
            break;
        case $b1ceb1d0b2f6e090$var$Aa:
            return a = $b1ceb1d0b2f6e090$var$Bg(12, c, b, e | 2), a.elementType = $b1ceb1d0b2f6e090$var$Aa, a.lanes = f, a;
        case $b1ceb1d0b2f6e090$var$Ea:
            return a = $b1ceb1d0b2f6e090$var$Bg(13, c, b, e), a.elementType = $b1ceb1d0b2f6e090$var$Ea, a.lanes = f, a;
        case $b1ceb1d0b2f6e090$var$Fa:
            return a = $b1ceb1d0b2f6e090$var$Bg(19, c, b, e), a.elementType = $b1ceb1d0b2f6e090$var$Fa, a.lanes = f, a;
        case $b1ceb1d0b2f6e090$var$Ia:
            return $b1ceb1d0b2f6e090$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b1ceb1d0b2f6e090$var$Ba:
                    g = 10;
                    break a;
                case $b1ceb1d0b2f6e090$var$Ca:
                    g = 9;
                    break a;
                case $b1ceb1d0b2f6e090$var$Da:
                    g = 11;
                    break a;
                case $b1ceb1d0b2f6e090$var$Ga:
                    g = 14;
                    break a;
                case $b1ceb1d0b2f6e090$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b1ceb1d0b2f6e090$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $b1ceb1d0b2f6e090$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b1ceb1d0b2f6e090$var$Tg(a, b, c, d) {
    a = $b1ceb1d0b2f6e090$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b1ceb1d0b2f6e090$var$pj(a, b, c, d) {
    a = $b1ceb1d0b2f6e090$var$Bg(22, a, d, b);
    a.elementType = $b1ceb1d0b2f6e090$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b1ceb1d0b2f6e090$var$Qg(a, b, c) {
    a = $b1ceb1d0b2f6e090$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b1ceb1d0b2f6e090$var$Sg(a, b, c) {
    b = $b1ceb1d0b2f6e090$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b1ceb1d0b2f6e090$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b1ceb1d0b2f6e090$var$zc(0);
    this.expirationTimes = $b1ceb1d0b2f6e090$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b1ceb1d0b2f6e090$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b1ceb1d0b2f6e090$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $b1ceb1d0b2f6e090$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b1ceb1d0b2f6e090$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b1ceb1d0b2f6e090$var$kh(f);
    return a;
}
function $b1ceb1d0b2f6e090$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b1ceb1d0b2f6e090$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b1ceb1d0b2f6e090$var$dl(a) {
    if (!a) return $b1ceb1d0b2f6e090$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b1ceb1d0b2f6e090$var$Vb(a) !== a || 1 !== a.tag) throw Error($b1ceb1d0b2f6e090$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b1ceb1d0b2f6e090$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b1ceb1d0b2f6e090$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b1ceb1d0b2f6e090$var$Zf(c)) return $b1ceb1d0b2f6e090$var$bg(a, c, b);
    }
    return b;
}
function $b1ceb1d0b2f6e090$var$el(a, b, c, d, e, f, g, h, k) {
    a = $b1ceb1d0b2f6e090$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $b1ceb1d0b2f6e090$var$dl(null);
    c = a.current;
    d = $b1ceb1d0b2f6e090$var$R();
    e = $b1ceb1d0b2f6e090$var$yi(c);
    f = $b1ceb1d0b2f6e090$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b1ceb1d0b2f6e090$var$nh(c, f, e);
    a.current.lanes = e;
    $b1ceb1d0b2f6e090$var$Ac(a, e, d);
    $b1ceb1d0b2f6e090$var$Dk(a, d);
    return a;
}
function $b1ceb1d0b2f6e090$var$fl(a, b, c, d) {
    var e = b.current, f = $b1ceb1d0b2f6e090$var$R(), g = $b1ceb1d0b2f6e090$var$yi(e);
    c = $b1ceb1d0b2f6e090$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b1ceb1d0b2f6e090$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b1ceb1d0b2f6e090$var$nh(e, b, g);
    null !== a && ($b1ceb1d0b2f6e090$var$gi(a, e, g, f), $b1ceb1d0b2f6e090$var$oh(a, e, g));
    return g;
}
function $b1ceb1d0b2f6e090$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b1ceb1d0b2f6e090$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b1ceb1d0b2f6e090$var$il(a, b) {
    $b1ceb1d0b2f6e090$var$hl(a, b);
    (a = a.alternate) && $b1ceb1d0b2f6e090$var$hl(a, b);
}
function $b1ceb1d0b2f6e090$var$jl() {
    return null;
}
var $b1ceb1d0b2f6e090$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $b1ceb1d0b2f6e090$var$ll(a) {
    this._internalRoot = a;
}
$b1ceb1d0b2f6e090$var$ml.prototype.render = $b1ceb1d0b2f6e090$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b1ceb1d0b2f6e090$var$p(409));
    $b1ceb1d0b2f6e090$var$fl(a, b, null, null);
};
$b1ceb1d0b2f6e090$var$ml.prototype.unmount = $b1ceb1d0b2f6e090$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b1ceb1d0b2f6e090$var$Rk(function() {
            $b1ceb1d0b2f6e090$var$fl(null, a, null, null);
        });
        b[$b1ceb1d0b2f6e090$var$uf] = null;
    }
};
function $b1ceb1d0b2f6e090$var$ml(a) {
    this._internalRoot = a;
}
$b1ceb1d0b2f6e090$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b1ceb1d0b2f6e090$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b1ceb1d0b2f6e090$var$Qc.length && 0 !== b && b < $b1ceb1d0b2f6e090$var$Qc[c].priority; c++);
        $b1ceb1d0b2f6e090$var$Qc.splice(c, 0, a);
        0 === c && $b1ceb1d0b2f6e090$var$Vc(a);
    }
};
function $b1ceb1d0b2f6e090$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b1ceb1d0b2f6e090$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b1ceb1d0b2f6e090$var$pl() {}
function $b1ceb1d0b2f6e090$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $b1ceb1d0b2f6e090$var$gl(g);
                f.call(a);
            };
        }
        var g = $b1ceb1d0b2f6e090$var$el(b, d, a, 0, null, !1, !1, "", $b1ceb1d0b2f6e090$var$pl);
        a._reactRootContainer = g;
        a[$b1ceb1d0b2f6e090$var$uf] = g.current;
        $b1ceb1d0b2f6e090$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b1ceb1d0b2f6e090$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $b1ceb1d0b2f6e090$var$gl(k);
            h.call(a);
        };
    }
    var k = $b1ceb1d0b2f6e090$var$bl(a, 0, !1, null, null, !1, !1, "", $b1ceb1d0b2f6e090$var$pl);
    a._reactRootContainer = k;
    a[$b1ceb1d0b2f6e090$var$uf] = k.current;
    $b1ceb1d0b2f6e090$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b1ceb1d0b2f6e090$var$Rk(function() {
        $b1ceb1d0b2f6e090$var$fl(b, k, c, d);
    });
    return k;
}
function $b1ceb1d0b2f6e090$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $b1ceb1d0b2f6e090$var$gl(g);
                h.call(a);
            };
        }
        $b1ceb1d0b2f6e090$var$fl(b, g, a, e);
    } else g = $b1ceb1d0b2f6e090$var$ql(c, b, a, e, d);
    return $b1ceb1d0b2f6e090$var$gl(g);
}
$b1ceb1d0b2f6e090$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b1ceb1d0b2f6e090$var$tc(b.pendingLanes);
                0 !== c && ($b1ceb1d0b2f6e090$var$Cc(b, c | 1), $b1ceb1d0b2f6e090$var$Dk(b, $b1ceb1d0b2f6e090$var$B()), 0 === ($b1ceb1d0b2f6e090$var$K & 6) && ($b1ceb1d0b2f6e090$var$Gj = $b1ceb1d0b2f6e090$var$B() + 500, $b1ceb1d0b2f6e090$var$jg()));
            }
            break;
        case 13:
            $b1ceb1d0b2f6e090$var$Rk(function() {
                var b = $b1ceb1d0b2f6e090$var$ih(a, 1);
                if (null !== b) {
                    var c = $b1ceb1d0b2f6e090$var$R();
                    $b1ceb1d0b2f6e090$var$gi(b, a, 1, c);
                }
            }), $b1ceb1d0b2f6e090$var$il(a, 1);
    }
};
$b1ceb1d0b2f6e090$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $b1ceb1d0b2f6e090$var$ih(a, 134217728);
        if (null !== b) {
            var c = $b1ceb1d0b2f6e090$var$R();
            $b1ceb1d0b2f6e090$var$gi(b, a, 134217728, c);
        }
        $b1ceb1d0b2f6e090$var$il(a, 134217728);
    }
};
$b1ceb1d0b2f6e090$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $b1ceb1d0b2f6e090$var$yi(a), c = $b1ceb1d0b2f6e090$var$ih(a, b);
        if (null !== c) {
            var d = $b1ceb1d0b2f6e090$var$R();
            $b1ceb1d0b2f6e090$var$gi(c, a, b, d);
        }
        $b1ceb1d0b2f6e090$var$il(a, b);
    }
};
$b1ceb1d0b2f6e090$var$Hc = function() {
    return $b1ceb1d0b2f6e090$var$C;
};
$b1ceb1d0b2f6e090$var$Ic = function(a, b) {
    var c = $b1ceb1d0b2f6e090$var$C;
    try {
        return $b1ceb1d0b2f6e090$var$C = a, b();
    } finally{
        $b1ceb1d0b2f6e090$var$C = c;
    }
};
$b1ceb1d0b2f6e090$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $b1ceb1d0b2f6e090$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b1ceb1d0b2f6e090$var$Db(d);
                        if (!e) throw Error($b1ceb1d0b2f6e090$var$p(90));
                        $b1ceb1d0b2f6e090$var$Wa(d);
                        $b1ceb1d0b2f6e090$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b1ceb1d0b2f6e090$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b1ceb1d0b2f6e090$var$fb(a, !!c.multiple, b, !1);
    }
};
$b1ceb1d0b2f6e090$var$Gb = $b1ceb1d0b2f6e090$var$Qk;
$b1ceb1d0b2f6e090$var$Hb = $b1ceb1d0b2f6e090$var$Rk;
var $b1ceb1d0b2f6e090$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $b1ceb1d0b2f6e090$var$Cb,
        $b1ceb1d0b2f6e090$var$ue,
        $b1ceb1d0b2f6e090$var$Db,
        $b1ceb1d0b2f6e090$var$Eb,
        $b1ceb1d0b2f6e090$var$Fb,
        $b1ceb1d0b2f6e090$var$Qk
    ]
}, $b1ceb1d0b2f6e090$var$tl = {
    findFiberByHostInstance: $b1ceb1d0b2f6e090$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $b1ceb1d0b2f6e090$var$ul = {
    bundleType: $b1ceb1d0b2f6e090$var$tl.bundleType,
    version: $b1ceb1d0b2f6e090$var$tl.version,
    rendererPackageName: $b1ceb1d0b2f6e090$var$tl.rendererPackageName,
    rendererConfig: $b1ceb1d0b2f6e090$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b1ceb1d0b2f6e090$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $b1ceb1d0b2f6e090$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b1ceb1d0b2f6e090$var$tl.findFiberByHostInstance || $b1ceb1d0b2f6e090$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b1ceb1d0b2f6e090$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b1ceb1d0b2f6e090$var$vl.isDisabled && $b1ceb1d0b2f6e090$var$vl.supportsFiber) try {
        $b1ceb1d0b2f6e090$var$kc = $b1ceb1d0b2f6e090$var$vl.inject($b1ceb1d0b2f6e090$var$ul), $b1ceb1d0b2f6e090$var$lc = $b1ceb1d0b2f6e090$var$vl;
    } catch (a) {}
}
$b1ceb1d0b2f6e090$export$ae55be85d98224ed = $b1ceb1d0b2f6e090$var$sl;
$b1ceb1d0b2f6e090$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b1ceb1d0b2f6e090$var$nl(b)) throw Error($b1ceb1d0b2f6e090$var$p(200));
    return $b1ceb1d0b2f6e090$var$cl(a, b, null, c);
};
$b1ceb1d0b2f6e090$export$882461b6382ed46c = function(a, b) {
    if (!$b1ceb1d0b2f6e090$var$nl(a)) throw Error($b1ceb1d0b2f6e090$var$p(299));
    var c = !1, d = "", e = $b1ceb1d0b2f6e090$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b1ceb1d0b2f6e090$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$b1ceb1d0b2f6e090$var$uf] = b.current;
    $b1ceb1d0b2f6e090$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b1ceb1d0b2f6e090$var$ll(b);
};
$b1ceb1d0b2f6e090$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b1ceb1d0b2f6e090$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b1ceb1d0b2f6e090$var$p(268, a));
    }
    a = $b1ceb1d0b2f6e090$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b1ceb1d0b2f6e090$export$cd75ccfd720a3cd4 = function(a) {
    return $b1ceb1d0b2f6e090$var$Rk(a);
};
$b1ceb1d0b2f6e090$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b1ceb1d0b2f6e090$var$ol(b)) throw Error($b1ceb1d0b2f6e090$var$p(200));
    return $b1ceb1d0b2f6e090$var$rl(null, a, b, !0, c);
};
$b1ceb1d0b2f6e090$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b1ceb1d0b2f6e090$var$nl(a)) throw Error($b1ceb1d0b2f6e090$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b1ceb1d0b2f6e090$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b1ceb1d0b2f6e090$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b1ceb1d0b2f6e090$var$uf] = b.current;
    $b1ceb1d0b2f6e090$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b1ceb1d0b2f6e090$var$ml(b);
};
$b1ceb1d0b2f6e090$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b1ceb1d0b2f6e090$var$ol(b)) throw Error($b1ceb1d0b2f6e090$var$p(200));
    return $b1ceb1d0b2f6e090$var$rl(null, a, b, !1, c);
};
$b1ceb1d0b2f6e090$export$502457920280e6be = function(a) {
    if (!$b1ceb1d0b2f6e090$var$ol(a)) throw Error($b1ceb1d0b2f6e090$var$p(40));
    return a._reactRootContainer ? ($b1ceb1d0b2f6e090$var$Rk(function() {
        $b1ceb1d0b2f6e090$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b1ceb1d0b2f6e090$var$uf] = null;
        });
    }), !0) : !1;
};
$b1ceb1d0b2f6e090$export$c78a37762a8d58e1 = $b1ceb1d0b2f6e090$var$Qk;
$b1ceb1d0b2f6e090$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b1ceb1d0b2f6e090$var$ol(c)) throw Error($b1ceb1d0b2f6e090$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b1ceb1d0b2f6e090$var$p(38));
    return $b1ceb1d0b2f6e090$var$rl(a, b, c, !1, d);
};
$b1ceb1d0b2f6e090$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("8PV0D", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dxUUz"));

});
parcelRegister("dxUUz", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $9dca80d8387065dd$export$c4744153514ff05d; }, function (v) { return $9dca80d8387065dd$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $9dca80d8387065dd$export$3e506c1ccc9cc1a7; }, function (v) { return $9dca80d8387065dd$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $9dca80d8387065dd$export$e26fe2ed2fa76875; }, function (v) { return $9dca80d8387065dd$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $9dca80d8387065dd$export$502329bbf4b505b1; }, function (v) { return $9dca80d8387065dd$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $9dca80d8387065dd$export$6e3807111c4874c4; }, function (v) { return $9dca80d8387065dd$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $9dca80d8387065dd$export$c27134553091fb3a; }, function (v) { return $9dca80d8387065dd$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $9dca80d8387065dd$export$33ee1acdc04fd2a2; }, function (v) { return $9dca80d8387065dd$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $9dca80d8387065dd$export$b00a404bbd5edef2; }, function (v) { return $9dca80d8387065dd$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $9dca80d8387065dd$export$8352ce38b91d0c62; }, function (v) { return $9dca80d8387065dd$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $9dca80d8387065dd$export$d66a1c1c77bd778b; }, function (v) { return $9dca80d8387065dd$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $9dca80d8387065dd$export$d3dfb8e4810cb555; }, function (v) { return $9dca80d8387065dd$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $9dca80d8387065dd$export$839f9183b0465a69; }, function (v) { return $9dca80d8387065dd$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $9dca80d8387065dd$export$72fdf0e06517287b; }, function (v) { return $9dca80d8387065dd$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $9dca80d8387065dd$export$4b844e58a3e414b4; }, function (v) { return $9dca80d8387065dd$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $9dca80d8387065dd$export$816d2913ae6b83b1; }, function (v) { return $9dca80d8387065dd$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $9dca80d8387065dd$export$61bcfe829111a1d0; }, function (v) { return $9dca80d8387065dd$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $9dca80d8387065dd$export$7ee8c9beb337bc3f; }, function (v) { return $9dca80d8387065dd$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $9dca80d8387065dd$export$b5836b71941fa3ed; }, function (v) { return $9dca80d8387065dd$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $9dca80d8387065dd$export$cf845f2c119da08a; }, function (v) { return $9dca80d8387065dd$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9dca80d8387065dd$export$c4744153514ff05d;
var $9dca80d8387065dd$export$3e506c1ccc9cc1a7;
var $9dca80d8387065dd$export$e26fe2ed2fa76875;
var $9dca80d8387065dd$export$502329bbf4b505b1;
var $9dca80d8387065dd$export$6e3807111c4874c4;
var $9dca80d8387065dd$export$c27134553091fb3a;
var $9dca80d8387065dd$export$33ee1acdc04fd2a2;
var $9dca80d8387065dd$export$b00a404bbd5edef2;
var $9dca80d8387065dd$export$8352ce38b91d0c62;
var $9dca80d8387065dd$export$d66a1c1c77bd778b;
var $9dca80d8387065dd$export$d3dfb8e4810cb555;
var $9dca80d8387065dd$export$839f9183b0465a69;
var $9dca80d8387065dd$export$72fdf0e06517287b;
var $9dca80d8387065dd$export$4b844e58a3e414b4;
var $9dca80d8387065dd$export$816d2913ae6b83b1;
var $9dca80d8387065dd$export$61bcfe829111a1d0;
var $9dca80d8387065dd$export$7ee8c9beb337bc3f;
var $9dca80d8387065dd$export$b5836b71941fa3ed;
var $9dca80d8387065dd$export$cf845f2c119da08a;
"use strict";
function $9dca80d8387065dd$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $9dca80d8387065dd$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $9dca80d8387065dd$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $9dca80d8387065dd$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $9dca80d8387065dd$var$g(C, c)) n < e && 0 > $9dca80d8387065dd$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $9dca80d8387065dd$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $9dca80d8387065dd$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $9dca80d8387065dd$var$l = performance;
    $9dca80d8387065dd$export$c4744153514ff05d = function() {
        return $9dca80d8387065dd$var$l.now();
    };
} else {
    var $9dca80d8387065dd$var$p = Date, $9dca80d8387065dd$var$q = $9dca80d8387065dd$var$p.now();
    $9dca80d8387065dd$export$c4744153514ff05d = function() {
        return $9dca80d8387065dd$var$p.now() - $9dca80d8387065dd$var$q;
    };
}
var $9dca80d8387065dd$var$r = [], $9dca80d8387065dd$var$t = [], $9dca80d8387065dd$var$u = 1, $9dca80d8387065dd$var$v = null, $9dca80d8387065dd$var$y = 3, $9dca80d8387065dd$var$z = !1, $9dca80d8387065dd$var$A = !1, $9dca80d8387065dd$var$B = !1, $9dca80d8387065dd$var$D = "function" === typeof setTimeout ? setTimeout : null, $9dca80d8387065dd$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $9dca80d8387065dd$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $9dca80d8387065dd$var$G(a) {
    for(var b = $9dca80d8387065dd$var$h($9dca80d8387065dd$var$t); null !== b;){
        if (null === b.callback) $9dca80d8387065dd$var$k($9dca80d8387065dd$var$t);
        else if (b.startTime <= a) $9dca80d8387065dd$var$k($9dca80d8387065dd$var$t), b.sortIndex = b.expirationTime, $9dca80d8387065dd$var$f($9dca80d8387065dd$var$r, b);
        else break;
        b = $9dca80d8387065dd$var$h($9dca80d8387065dd$var$t);
    }
}
function $9dca80d8387065dd$var$H(a) {
    $9dca80d8387065dd$var$B = !1;
    $9dca80d8387065dd$var$G(a);
    if (!$9dca80d8387065dd$var$A) {
        if (null !== $9dca80d8387065dd$var$h($9dca80d8387065dd$var$r)) $9dca80d8387065dd$var$A = !0, $9dca80d8387065dd$var$I($9dca80d8387065dd$var$J);
        else {
            var b = $9dca80d8387065dd$var$h($9dca80d8387065dd$var$t);
            null !== b && $9dca80d8387065dd$var$K($9dca80d8387065dd$var$H, b.startTime - a);
        }
    }
}
function $9dca80d8387065dd$var$J(a, b) {
    $9dca80d8387065dd$var$A = !1;
    $9dca80d8387065dd$var$B && ($9dca80d8387065dd$var$B = !1, $9dca80d8387065dd$var$E($9dca80d8387065dd$var$L), $9dca80d8387065dd$var$L = -1);
    $9dca80d8387065dd$var$z = !0;
    var c = $9dca80d8387065dd$var$y;
    try {
        $9dca80d8387065dd$var$G(b);
        for($9dca80d8387065dd$var$v = $9dca80d8387065dd$var$h($9dca80d8387065dd$var$r); null !== $9dca80d8387065dd$var$v && (!($9dca80d8387065dd$var$v.expirationTime > b) || a && !$9dca80d8387065dd$var$M());){
            var d = $9dca80d8387065dd$var$v.callback;
            if ("function" === typeof d) {
                $9dca80d8387065dd$var$v.callback = null;
                $9dca80d8387065dd$var$y = $9dca80d8387065dd$var$v.priorityLevel;
                var e = d($9dca80d8387065dd$var$v.expirationTime <= b);
                b = $9dca80d8387065dd$export$c4744153514ff05d();
                "function" === typeof e ? $9dca80d8387065dd$var$v.callback = e : $9dca80d8387065dd$var$v === $9dca80d8387065dd$var$h($9dca80d8387065dd$var$r) && $9dca80d8387065dd$var$k($9dca80d8387065dd$var$r);
                $9dca80d8387065dd$var$G(b);
            } else $9dca80d8387065dd$var$k($9dca80d8387065dd$var$r);
            $9dca80d8387065dd$var$v = $9dca80d8387065dd$var$h($9dca80d8387065dd$var$r);
        }
        if (null !== $9dca80d8387065dd$var$v) var w = !0;
        else {
            var m = $9dca80d8387065dd$var$h($9dca80d8387065dd$var$t);
            null !== m && $9dca80d8387065dd$var$K($9dca80d8387065dd$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $9dca80d8387065dd$var$v = null, $9dca80d8387065dd$var$y = c, $9dca80d8387065dd$var$z = !1;
    }
}
var $9dca80d8387065dd$var$N = !1, $9dca80d8387065dd$var$O = null, $9dca80d8387065dd$var$L = -1, $9dca80d8387065dd$var$P = 5, $9dca80d8387065dd$var$Q = -1;
function $9dca80d8387065dd$var$M() {
    return $9dca80d8387065dd$export$c4744153514ff05d() - $9dca80d8387065dd$var$Q < $9dca80d8387065dd$var$P ? !1 : !0;
}
function $9dca80d8387065dd$var$R() {
    if (null !== $9dca80d8387065dd$var$O) {
        var a = $9dca80d8387065dd$export$c4744153514ff05d();
        $9dca80d8387065dd$var$Q = a;
        var b = !0;
        try {
            b = $9dca80d8387065dd$var$O(!0, a);
        } finally{
            b ? $9dca80d8387065dd$var$S() : ($9dca80d8387065dd$var$N = !1, $9dca80d8387065dd$var$O = null);
        }
    } else $9dca80d8387065dd$var$N = !1;
}
var $9dca80d8387065dd$var$S;
if ("function" === typeof $9dca80d8387065dd$var$F) $9dca80d8387065dd$var$S = function() {
    $9dca80d8387065dd$var$F($9dca80d8387065dd$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $9dca80d8387065dd$var$T = new MessageChannel, $9dca80d8387065dd$var$U = $9dca80d8387065dd$var$T.port2;
    $9dca80d8387065dd$var$T.port1.onmessage = $9dca80d8387065dd$var$R;
    $9dca80d8387065dd$var$S = function() {
        $9dca80d8387065dd$var$U.postMessage(null);
    };
} else $9dca80d8387065dd$var$S = function() {
    $9dca80d8387065dd$var$D($9dca80d8387065dd$var$R, 0);
};
function $9dca80d8387065dd$var$I(a) {
    $9dca80d8387065dd$var$O = a;
    $9dca80d8387065dd$var$N || ($9dca80d8387065dd$var$N = !0, $9dca80d8387065dd$var$S());
}
function $9dca80d8387065dd$var$K(a, b) {
    $9dca80d8387065dd$var$L = $9dca80d8387065dd$var$D(function() {
        a($9dca80d8387065dd$export$c4744153514ff05d());
    }, b);
}
$9dca80d8387065dd$export$3e506c1ccc9cc1a7 = 5;
$9dca80d8387065dd$export$e26fe2ed2fa76875 = 1;
$9dca80d8387065dd$export$502329bbf4b505b1 = 4;
$9dca80d8387065dd$export$6e3807111c4874c4 = 3;
$9dca80d8387065dd$export$c27134553091fb3a = null;
$9dca80d8387065dd$export$33ee1acdc04fd2a2 = 2;
$9dca80d8387065dd$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$9dca80d8387065dd$export$8352ce38b91d0c62 = function() {
    $9dca80d8387065dd$var$A || $9dca80d8387065dd$var$z || ($9dca80d8387065dd$var$A = !0, $9dca80d8387065dd$var$I($9dca80d8387065dd$var$J));
};
$9dca80d8387065dd$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $9dca80d8387065dd$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$9dca80d8387065dd$export$d3dfb8e4810cb555 = function() {
    return $9dca80d8387065dd$var$y;
};
$9dca80d8387065dd$export$839f9183b0465a69 = function() {
    return $9dca80d8387065dd$var$h($9dca80d8387065dd$var$r);
};
$9dca80d8387065dd$export$72fdf0e06517287b = function(a) {
    switch($9dca80d8387065dd$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $9dca80d8387065dd$var$y;
    }
    var c = $9dca80d8387065dd$var$y;
    $9dca80d8387065dd$var$y = b;
    try {
        return a();
    } finally{
        $9dca80d8387065dd$var$y = c;
    }
};
$9dca80d8387065dd$export$4b844e58a3e414b4 = function() {};
$9dca80d8387065dd$export$816d2913ae6b83b1 = function() {};
$9dca80d8387065dd$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $9dca80d8387065dd$var$y;
    $9dca80d8387065dd$var$y = a;
    try {
        return b();
    } finally{
        $9dca80d8387065dd$var$y = c;
    }
};
$9dca80d8387065dd$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $9dca80d8387065dd$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $9dca80d8387065dd$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $9dca80d8387065dd$var$f($9dca80d8387065dd$var$t, a), null === $9dca80d8387065dd$var$h($9dca80d8387065dd$var$r) && a === $9dca80d8387065dd$var$h($9dca80d8387065dd$var$t) && ($9dca80d8387065dd$var$B ? ($9dca80d8387065dd$var$E($9dca80d8387065dd$var$L), $9dca80d8387065dd$var$L = -1) : $9dca80d8387065dd$var$B = !0, $9dca80d8387065dd$var$K($9dca80d8387065dd$var$H, c - d))) : (a.sortIndex = e, $9dca80d8387065dd$var$f($9dca80d8387065dd$var$r, a), $9dca80d8387065dd$var$A || $9dca80d8387065dd$var$z || ($9dca80d8387065dd$var$A = !0, $9dca80d8387065dd$var$I($9dca80d8387065dd$var$J)));
    return a;
};
$9dca80d8387065dd$export$b5836b71941fa3ed = $9dca80d8387065dd$var$M;
$9dca80d8387065dd$export$cf845f2c119da08a = function(a) {
    var b = $9dca80d8387065dd$var$y;
    return function() {
        var c = $9dca80d8387065dd$var$y;
        $9dca80d8387065dd$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $9dca80d8387065dd$var$y = c;
        }
    };
};

});



parcelRegister("1yZH7", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $1238d2a40b1b7d79$export$2b8d127b894957b9; }, function (v) { return $1238d2a40b1b7d79$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $1238d2a40b1b7d79$export$cea3a54a6425200c; }, function (v) { return $1238d2a40b1b7d79$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $1238d2a40b1b7d79$export$a7c73072b1a182ae; }, function (v) { return $1238d2a40b1b7d79$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $1238d2a40b1b7d79$export$9f27bc3417b4524d; }, function (v) { return $1238d2a40b1b7d79$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $1238d2a40b1b7d79$export$db77ccec0bb4ccac; }, function (v) { return $1238d2a40b1b7d79$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $1238d2a40b1b7d79$export$8392c0c9d3dcbd35; }, function (v) { return $1238d2a40b1b7d79$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $1238d2a40b1b7d79$export$ffb0004e005737fa; }, function (v) { return $1238d2a40b1b7d79$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $1238d2a40b1b7d79$export$b624eff549462981; }, function (v) { return $1238d2a40b1b7d79$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $1238d2a40b1b7d79$export$7897aa7841a5380c; }, function (v) { return $1238d2a40b1b7d79$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $1238d2a40b1b7d79$export$602eac185826482c; }, function (v) { return $1238d2a40b1b7d79$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $1238d2a40b1b7d79$export$e2c29f18771995cb; }, function (v) { return $1238d2a40b1b7d79$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $1238d2a40b1b7d79$export$5f8d39834fd61797; }, function (v) { return $1238d2a40b1b7d79$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $1238d2a40b1b7d79$export$74bf444e3cd11ea5; }, function (v) { return $1238d2a40b1b7d79$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $1238d2a40b1b7d79$export$92387174baf9b227; }, function (v) { return $1238d2a40b1b7d79$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $1238d2a40b1b7d79$export$ec112efeb987d9c6; }, function (v) { return $1238d2a40b1b7d79$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $1238d2a40b1b7d79$export$b706b080d889d2c9; }, function (v) { return $1238d2a40b1b7d79$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $1238d2a40b1b7d79$export$5be5a87408f70ddc; }, function (v) { return $1238d2a40b1b7d79$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $1238d2a40b1b7d79$export$45a5e7f76e0caa8d; }, function (v) { return $1238d2a40b1b7d79$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $1238d2a40b1b7d79$export$455c2e768291efa6; }, function (v) { return $1238d2a40b1b7d79$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $1238d2a40b1b7d79$export$9522e17588c12572; }, function (v) { return $1238d2a40b1b7d79$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $1238d2a40b1b7d79$export$2110ac352bb060b9; }, function (v) { return $1238d2a40b1b7d79$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $1238d2a40b1b7d79$export$56885ab8b9c456ab; }, function (v) { return $1238d2a40b1b7d79$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $1238d2a40b1b7d79$export$d927fcb6adf8f9de; }, function (v) { return $1238d2a40b1b7d79$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $1238d2a40b1b7d79$export$b82d16f27459e05a; }, function (v) { return $1238d2a40b1b7d79$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $1238d2a40b1b7d79$export$522c17b4f5e123e8; }, function (v) { return $1238d2a40b1b7d79$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $1238d2a40b1b7d79$export$1aabd8a0274ecfd6; }, function (v) { return $1238d2a40b1b7d79$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $1238d2a40b1b7d79$export$9b621391a187a31a; }, function (v) { return $1238d2a40b1b7d79$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $1238d2a40b1b7d79$export$f5bbd400c2f4426f; }, function (v) { return $1238d2a40b1b7d79$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1238d2a40b1b7d79$export$2b8d127b894957b9;
var $1238d2a40b1b7d79$export$cea3a54a6425200c;
var $1238d2a40b1b7d79$export$a7c73072b1a182ae;
var $1238d2a40b1b7d79$export$9f27bc3417b4524d;
var $1238d2a40b1b7d79$export$db77ccec0bb4ccac;
var $1238d2a40b1b7d79$export$8392c0c9d3dcbd35;
var $1238d2a40b1b7d79$export$ffb0004e005737fa;
var $1238d2a40b1b7d79$export$b624eff549462981;
var $1238d2a40b1b7d79$export$7897aa7841a5380c;
var $1238d2a40b1b7d79$export$602eac185826482c;
var $1238d2a40b1b7d79$export$e2c29f18771995cb;
var $1238d2a40b1b7d79$export$5f8d39834fd61797;
var $1238d2a40b1b7d79$export$74bf444e3cd11ea5;
var $1238d2a40b1b7d79$export$92387174baf9b227;
var $1238d2a40b1b7d79$export$ec112efeb987d9c6;
var $1238d2a40b1b7d79$export$b706b080d889d2c9;
var $1238d2a40b1b7d79$export$5be5a87408f70ddc;
var $1238d2a40b1b7d79$export$45a5e7f76e0caa8d;
var $1238d2a40b1b7d79$export$455c2e768291efa6;
var $1238d2a40b1b7d79$export$9522e17588c12572;
var $1238d2a40b1b7d79$export$2110ac352bb060b9;
var $1238d2a40b1b7d79$export$56885ab8b9c456ab;
var $1238d2a40b1b7d79$export$d927fcb6adf8f9de;
var $1238d2a40b1b7d79$export$b82d16f27459e05a;
var $1238d2a40b1b7d79$export$522c17b4f5e123e8;
var $1238d2a40b1b7d79$export$1aabd8a0274ecfd6;
var $1238d2a40b1b7d79$export$9b621391a187a31a;
var $1238d2a40b1b7d79$export$f5bbd400c2f4426f;
"use strict";
var $1238d2a40b1b7d79$var$b = "function" === typeof Symbol && Symbol.for, $1238d2a40b1b7d79$var$c = $1238d2a40b1b7d79$var$b ? Symbol.for("react.element") : 60103, $1238d2a40b1b7d79$var$d = $1238d2a40b1b7d79$var$b ? Symbol.for("react.portal") : 60106, $1238d2a40b1b7d79$var$e = $1238d2a40b1b7d79$var$b ? Symbol.for("react.fragment") : 60107, $1238d2a40b1b7d79$var$f = $1238d2a40b1b7d79$var$b ? Symbol.for("react.strict_mode") : 60108, $1238d2a40b1b7d79$var$g = $1238d2a40b1b7d79$var$b ? Symbol.for("react.profiler") : 60114, $1238d2a40b1b7d79$var$h = $1238d2a40b1b7d79$var$b ? Symbol.for("react.provider") : 60109, $1238d2a40b1b7d79$var$k = $1238d2a40b1b7d79$var$b ? Symbol.for("react.context") : 60110, $1238d2a40b1b7d79$var$l = $1238d2a40b1b7d79$var$b ? Symbol.for("react.async_mode") : 60111, $1238d2a40b1b7d79$var$m = $1238d2a40b1b7d79$var$b ? Symbol.for("react.concurrent_mode") : 60111, $1238d2a40b1b7d79$var$n = $1238d2a40b1b7d79$var$b ? Symbol.for("react.forward_ref") : 60112, $1238d2a40b1b7d79$var$p = $1238d2a40b1b7d79$var$b ? Symbol.for("react.suspense") : 60113, $1238d2a40b1b7d79$var$q = $1238d2a40b1b7d79$var$b ? Symbol.for("react.suspense_list") : 60120, $1238d2a40b1b7d79$var$r = $1238d2a40b1b7d79$var$b ? Symbol.for("react.memo") : 60115, $1238d2a40b1b7d79$var$t = $1238d2a40b1b7d79$var$b ? Symbol.for("react.lazy") : 60116, $1238d2a40b1b7d79$var$v = $1238d2a40b1b7d79$var$b ? Symbol.for("react.block") : 60121, $1238d2a40b1b7d79$var$w = $1238d2a40b1b7d79$var$b ? Symbol.for("react.fundamental") : 60117, $1238d2a40b1b7d79$var$x = $1238d2a40b1b7d79$var$b ? Symbol.for("react.responder") : 60118, $1238d2a40b1b7d79$var$y = $1238d2a40b1b7d79$var$b ? Symbol.for("react.scope") : 60119;
function $1238d2a40b1b7d79$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $1238d2a40b1b7d79$var$c:
                switch(a = a.type, a){
                    case $1238d2a40b1b7d79$var$l:
                    case $1238d2a40b1b7d79$var$m:
                    case $1238d2a40b1b7d79$var$e:
                    case $1238d2a40b1b7d79$var$g:
                    case $1238d2a40b1b7d79$var$f:
                    case $1238d2a40b1b7d79$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $1238d2a40b1b7d79$var$k:
                            case $1238d2a40b1b7d79$var$n:
                            case $1238d2a40b1b7d79$var$t:
                            case $1238d2a40b1b7d79$var$r:
                            case $1238d2a40b1b7d79$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $1238d2a40b1b7d79$var$d:
                return u;
        }
    }
}
function $1238d2a40b1b7d79$var$A(a) {
    return $1238d2a40b1b7d79$var$z(a) === $1238d2a40b1b7d79$var$m;
}
$1238d2a40b1b7d79$export$2b8d127b894957b9 = $1238d2a40b1b7d79$var$l;
$1238d2a40b1b7d79$export$cea3a54a6425200c = $1238d2a40b1b7d79$var$m;
$1238d2a40b1b7d79$export$a7c73072b1a182ae = $1238d2a40b1b7d79$var$k;
$1238d2a40b1b7d79$export$9f27bc3417b4524d = $1238d2a40b1b7d79$var$h;
$1238d2a40b1b7d79$export$db77ccec0bb4ccac = $1238d2a40b1b7d79$var$c;
$1238d2a40b1b7d79$export$8392c0c9d3dcbd35 = $1238d2a40b1b7d79$var$n;
$1238d2a40b1b7d79$export$ffb0004e005737fa = $1238d2a40b1b7d79$var$e;
$1238d2a40b1b7d79$export$b624eff549462981 = $1238d2a40b1b7d79$var$t;
$1238d2a40b1b7d79$export$7897aa7841a5380c = $1238d2a40b1b7d79$var$r;
$1238d2a40b1b7d79$export$602eac185826482c = $1238d2a40b1b7d79$var$d;
$1238d2a40b1b7d79$export$e2c29f18771995cb = $1238d2a40b1b7d79$var$g;
$1238d2a40b1b7d79$export$5f8d39834fd61797 = $1238d2a40b1b7d79$var$f;
$1238d2a40b1b7d79$export$74bf444e3cd11ea5 = $1238d2a40b1b7d79$var$p;
$1238d2a40b1b7d79$export$92387174baf9b227 = function(a) {
    return $1238d2a40b1b7d79$var$A(a) || $1238d2a40b1b7d79$var$z(a) === $1238d2a40b1b7d79$var$l;
};
$1238d2a40b1b7d79$export$ec112efeb987d9c6 = $1238d2a40b1b7d79$var$A;
$1238d2a40b1b7d79$export$b706b080d889d2c9 = function(a) {
    return $1238d2a40b1b7d79$var$z(a) === $1238d2a40b1b7d79$var$k;
};
$1238d2a40b1b7d79$export$5be5a87408f70ddc = function(a) {
    return $1238d2a40b1b7d79$var$z(a) === $1238d2a40b1b7d79$var$h;
};
$1238d2a40b1b7d79$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1238d2a40b1b7d79$var$c;
};
$1238d2a40b1b7d79$export$455c2e768291efa6 = function(a) {
    return $1238d2a40b1b7d79$var$z(a) === $1238d2a40b1b7d79$var$n;
};
$1238d2a40b1b7d79$export$9522e17588c12572 = function(a) {
    return $1238d2a40b1b7d79$var$z(a) === $1238d2a40b1b7d79$var$e;
};
$1238d2a40b1b7d79$export$2110ac352bb060b9 = function(a) {
    return $1238d2a40b1b7d79$var$z(a) === $1238d2a40b1b7d79$var$t;
};
$1238d2a40b1b7d79$export$56885ab8b9c456ab = function(a) {
    return $1238d2a40b1b7d79$var$z(a) === $1238d2a40b1b7d79$var$r;
};
$1238d2a40b1b7d79$export$d927fcb6adf8f9de = function(a) {
    return $1238d2a40b1b7d79$var$z(a) === $1238d2a40b1b7d79$var$d;
};
$1238d2a40b1b7d79$export$b82d16f27459e05a = function(a) {
    return $1238d2a40b1b7d79$var$z(a) === $1238d2a40b1b7d79$var$g;
};
$1238d2a40b1b7d79$export$522c17b4f5e123e8 = function(a) {
    return $1238d2a40b1b7d79$var$z(a) === $1238d2a40b1b7d79$var$f;
};
$1238d2a40b1b7d79$export$1aabd8a0274ecfd6 = function(a) {
    return $1238d2a40b1b7d79$var$z(a) === $1238d2a40b1b7d79$var$p;
};
$1238d2a40b1b7d79$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $1238d2a40b1b7d79$var$e || a === $1238d2a40b1b7d79$var$m || a === $1238d2a40b1b7d79$var$g || a === $1238d2a40b1b7d79$var$f || a === $1238d2a40b1b7d79$var$p || a === $1238d2a40b1b7d79$var$q || "object" === typeof a && null !== a && (a.$$typeof === $1238d2a40b1b7d79$var$t || a.$$typeof === $1238d2a40b1b7d79$var$r || a.$$typeof === $1238d2a40b1b7d79$var$h || a.$$typeof === $1238d2a40b1b7d79$var$k || a.$$typeof === $1238d2a40b1b7d79$var$n || a.$$typeof === $1238d2a40b1b7d79$var$w || a.$$typeof === $1238d2a40b1b7d79$var$x || a.$$typeof === $1238d2a40b1b7d79$var$y || a.$$typeof === $1238d2a40b1b7d79$var$v);
};
$1238d2a40b1b7d79$export$f5bbd400c2f4426f = $1238d2a40b1b7d79$var$z;

});

parcelRegister("v03Ub", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeMax = Math.max, nativeNow = Date.now;
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map"), nativeCreate = getNative(Object, "create");
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
    baseMerge(object, source, srcIndex, customizer);
});
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = mergeWith;

});

parcelRegister("74qed", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $525d407f2643a158$export$2e2bcd8739ae039; });

var $qCQfT = parcelRequire("qCQfT");
var $525d407f2643a158$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $525d407f2643a158$var$index = (0, $qCQfT.default)(function(prop) {
    return $525d407f2643a158$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $525d407f2643a158$export$2e2bcd8739ae039 = $525d407f2643a158$var$index;

});
parcelRegister("qCQfT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05008f002921b361$export$2e2bcd8739ae039; });
function $05008f002921b361$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $05008f002921b361$export$2e2bcd8739ae039 = $05008f002921b361$var$memoize;

});


parcelRegister("9HGsN", function(module, exports) {

$parcel$export(module.exports, "Box", function () { return $abf4a9f25d34b537$export$e71c4d32a2263218; });

var $3lBLT = parcelRequire("3lBLT");
"use client";
const $abf4a9f25d34b537$export$e71c4d32a2263218 = (0, $3lBLT.chakra)("div");
$abf4a9f25d34b537$export$e71c4d32a2263218.displayName = "Box";

});
parcelRegister("3lBLT", function(module, exports) {

$parcel$export(module.exports, "chakra", function () { return $ce7ba5fad7988251$export$7cd122d781af9fa4; });

var $2bWKZ = parcelRequire("2bWKZ");
"use client";
function $ce7ba5fad7988251$var$factory() {
    const cache = /* @__PURE__ */ new Map();
    return new Proxy((0, $2bWKZ.styled), {
        /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */ apply (target, thisArg, argArray) {
            return (0, $2bWKZ.styled)(...argArray);
        },
        /**
     * @example
     * <chakra.div />
     */ get (_, element) {
            if (!cache.has(element)) cache.set(element, (0, $2bWKZ.styled)(element));
            return cache.get(element);
        }
    });
}
const $ce7ba5fad7988251$export$7cd122d781af9fa4 = $ce7ba5fad7988251$var$factory();

});
parcelRegister("2bWKZ", function(module, exports) {

$parcel$export(module.exports, "styled", function () { return $dddbdd9fcc42cda5$export$3817b7a54a07cec7; });

var $h7TjY = parcelRequire("h7TjY");

var $kUotr = parcelRequire("kUotr");
var $7hYFp = parcelRequire("7hYFp");
var $fPIPj = parcelRequire("fPIPj");
var $cSr1Y = parcelRequire("cSr1Y");
var $2EPVw = parcelRequire("2EPVw");

var $49ayA = parcelRequire("49ayA");

var $8v0nu = parcelRequire("8v0nu");

var $YkZTR = parcelRequire("YkZTR");

var $6jXOD = parcelRequire("6jXOD");
"use client";
const $dddbdd9fcc42cda5$var$emotion_styled = (0, $fPIPj.interopDefault)((0, $49ayA.default));
const $dddbdd9fcc42cda5$export$9dba07f3d84163bb = ({ baseStyle: baseStyle })=>(props)=>{
        const { theme: theme, css: cssProp, __css: __css, sx: sx, ...restProps } = props;
        const [styleProps] = (0, $2EPVw.splitProps)(restProps, theme.__isStyleProp);
        const finalBaseStyle = (0, $cSr1Y.runIfFn)(baseStyle, props);
        const finalStyles = (0, $kUotr.assignAfter)({}, __css, finalBaseStyle, (0, $7hYFp.compact)(styleProps), sx);
        const computedCSS = (0, $h7TjY.css)(finalStyles)(props.theme);
        return cssProp ? [
            computedCSS,
            cssProp
        ] : computedCSS;
    };
function $dddbdd9fcc42cda5$export$3817b7a54a07cec7(component, options) {
    const { baseStyle: baseStyle, ...styledOptions } = options ?? {};
    if (!styledOptions.shouldForwardProp) styledOptions.shouldForwardProp = (0, $YkZTR.shouldForwardProp);
    const styleObject = $dddbdd9fcc42cda5$export$9dba07f3d84163bb({
        baseStyle: baseStyle
    });
    const Component = $dddbdd9fcc42cda5$var$emotion_styled(component, styledOptions)(styleObject);
    const chakraComponent = (0, $8v0nu.forwardRef)(function ChakraComponent2(props, ref) {
        const { children: children, ...restProps } = props;
        const { colorMode: colorMode, forced: forced } = (0, $6jXOD.useColorMode)();
        const dataTheme = forced ? colorMode : void 0;
        return (0, $8v0nu.createElement)(Component, {
            ref: ref,
            "data-theme": dataTheme,
            ...restProps
        }, children);
    });
    return chakraComponent;
}

});
parcelRegister("h7TjY", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $3e97eaf6e7b0ff0f$export$dbf350e5966cf602; });

var $fZQg5 = parcelRequire("fZQg5");
var $v03Ub = parcelRequire("v03Ub");
var $cSr1Y = parcelRequire("cSr1Y");

var $lOd5f = parcelRequire("lOd5f");

var $lA3d6 = parcelRequire("lA3d6");

var $4fJZU = parcelRequire("4fJZU");

var $kF3Sa = parcelRequire("kF3Sa");
function $3e97eaf6e7b0ff0f$var$isCssVar(value) {
    return /^var\(--.+\)$/.test(value);
}
const $3e97eaf6e7b0ff0f$var$isCSSVariableTokenValue = (key, value)=>key.startsWith("--") && typeof value === "string" && !$3e97eaf6e7b0ff0f$var$isCssVar(value);
const $3e97eaf6e7b0ff0f$var$resolveTokenValue = (theme, value)=>{
    if (value == null) return value;
    const getVar = (val)=>theme.__cssMap?.[val]?.varRef;
    const getValue = (val)=>getVar(val) ?? val;
    const [tokenValue, fallbackValue] = (0, $kF3Sa.splitByComma)(value);
    value = getVar(tokenValue) ?? getValue(fallbackValue) ?? getValue(value);
    return value;
};
function $3e97eaf6e7b0ff0f$export$955358618f994a11(options) {
    const { configs: configs = {}, pseudos: pseudos = {}, theme: theme } = options;
    const css2 = (stylesOrFn, nested = false)=>{
        const _styles = (0, $cSr1Y.runIfFn)(stylesOrFn, theme);
        const styles = (0, $4fJZU.expandResponsive)(_styles)(theme);
        let computedStyles = {};
        for(let key in styles){
            const valueOrFn = styles[key];
            let value = (0, $cSr1Y.runIfFn)(valueOrFn, theme);
            if (key in pseudos) key = pseudos[key];
            if ($3e97eaf6e7b0ff0f$var$isCSSVariableTokenValue(key, value)) value = $3e97eaf6e7b0ff0f$var$resolveTokenValue(theme, value);
            let config = configs[key];
            if (config === true) config = {
                property: key
            };
            if ((0, $fZQg5.isObject)(value)) {
                computedStyles[key] = computedStyles[key] ?? {};
                computedStyles[key] = (0, (/*@__PURE__*/$parcel$interopDefault($v03Ub)))({}, computedStyles[key], css2(value, true));
                continue;
            }
            let rawValue = config?.transform?.(value, theme, _styles) ?? value;
            rawValue = config?.processResult ? css2(rawValue, true) : rawValue;
            const configProperty = (0, $cSr1Y.runIfFn)(config?.property, theme);
            if (!nested && config?.static) {
                const staticStyles = (0, $cSr1Y.runIfFn)(config.static, theme);
                computedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($v03Ub)))({}, computedStyles, staticStyles);
            }
            if (configProperty && Array.isArray(configProperty)) {
                for (const property of configProperty)computedStyles[property] = rawValue;
                continue;
            }
            if (configProperty) {
                if (configProperty === "&" && (0, $fZQg5.isObject)(rawValue)) computedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($v03Ub)))({}, computedStyles, rawValue);
                else computedStyles[configProperty] = rawValue;
                continue;
            }
            if ((0, $fZQg5.isObject)(rawValue)) {
                computedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($v03Ub)))({}, computedStyles, rawValue);
                continue;
            }
            computedStyles[key] = rawValue;
        }
        return computedStyles;
    };
    return css2;
}
const $3e97eaf6e7b0ff0f$export$dbf350e5966cf602 = (styles)=>(theme)=>{
        const cssFn = $3e97eaf6e7b0ff0f$export$955358618f994a11({
            theme: theme,
            pseudos: (0, $lOd5f.getPseudoSelectors)(theme),
            configs: (0, $lA3d6.systemProps)
        });
        return cssFn(styles);
    };

});
parcelRegister("fZQg5", function(module, exports) {

$parcel$export(module.exports, "isArray", function () { return $7c5860aba894fec8$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isObject", function () { return $7c5860aba894fec8$export$a6cdc56e425d0d0a; });
function $7c5860aba894fec8$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}
function $7c5860aba894fec8$export$3f283ac14831e759(value) {
    return typeof value !== "number" || Number.isNaN(value) || !Number.isFinite(value);
}
function $7c5860aba894fec8$export$e90fb89750dba83f(value) {
    return value != null && value - parseFloat(value) + 1 >= 0;
}
function $7c5860aba894fec8$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $7c5860aba894fec8$export$4c0262a4f954db45(value) {
    return $7c5860aba894fec8$export$43bee75e5e14138e(value) && value.length === 0;
}
function $7c5860aba894fec8$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
function $7c5860aba894fec8$export$4e62c701997796c1(value) {
    return typeof value !== "undefined" && value !== void 0;
}
function $7c5860aba894fec8$export$fce6876652108ab(value) {
    return typeof value === "undefined" || value === void 0;
}
function $7c5860aba894fec8$export$a6cdc56e425d0d0a(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function") && !$7c5860aba894fec8$export$43bee75e5e14138e(value);
}
function $7c5860aba894fec8$export$83b788b1a3698c03(value) {
    return $7c5860aba894fec8$export$a6cdc56e425d0d0a(value) && Object.keys(value).length === 0;
}
function $7c5860aba894fec8$export$630801d484da15df(value) {
    return value == null;
}
function $7c5860aba894fec8$export$844ec244b1367d54(value) {
    return Object.prototype.toString.call(value) === "[object String]";
}
function $7c5860aba894fec8$export$30a9abfd5fb9f5f6(value) {
    return /^var\(--.+\)$/.test(value);
}
function $7c5860aba894fec8$export$dd1bc94b04021eeb(value) {
    if ($7c5860aba894fec8$export$43bee75e5e14138e(value)) return $7c5860aba894fec8$export$4c0262a4f954db45(value);
    if ($7c5860aba894fec8$export$a6cdc56e425d0d0a(value)) return $7c5860aba894fec8$export$83b788b1a3698c03(value);
    if (value == null || value === "") return true;
    return false;
}
function $7c5860aba894fec8$export$dedd81df7bc1307(val) {
    return "current" in val;
}
function $7c5860aba894fec8$export$4215e022093e324e(value) {
    return value && $7c5860aba894fec8$export$a6cdc56e425d0d0a(value) && $7c5860aba894fec8$export$a6cdc56e425d0d0a(value.target);
}

});

parcelRegister("cSr1Y", function(module, exports) {

$parcel$export(module.exports, "runIfFn", function () { return $1cdbeb912eca7651$export$624e501d81f5ffce; });
const $1cdbeb912eca7651$var$isFunction = (value)=>typeof value === "function";
function $1cdbeb912eca7651$export$624e501d81f5ffce(valueOrFn, ...args) {
    return $1cdbeb912eca7651$var$isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}

});

parcelRegister("lOd5f", function(module, exports) {

$parcel$export(module.exports, "getPseudoSelectors", function () { return $e848db045ed1a592$export$f41ab9e4dfc20352; });
$parcel$export(module.exports, "getPseudoPropNames", function () { return $e848db045ed1a592$export$a7126a96abbbb621; });
const $e848db045ed1a592$var$state = {
    open: (str, post)=>`${str}[data-open], ${str}[open], ${str}[data-state=open] ${post}`,
    closed: (str, post)=>`${str}[data-closed], ${str}[data-state=closed] ${post}`,
    hover: (str, post)=>`${str}:hover ${post}, ${str}[data-hover] ${post}`,
    focus: (str, post)=>`${str}:focus ${post}, ${str}[data-focus] ${post}`,
    focusVisible: (str, post)=>`${str}:focus-visible ${post}`,
    focusWithin: (str, post)=>`${str}:focus-within ${post}`,
    active: (str, post)=>`${str}:active ${post}, ${str}[data-active] ${post}`,
    disabled: (str, post)=>`${str}:disabled ${post}, ${str}[data-disabled] ${post}`,
    invalid: (str, post)=>`${str}:invalid ${post}, ${str}[data-invalid] ${post}`,
    checked: (str, post)=>`${str}:checked ${post}, ${str}[data-checked] ${post}`,
    indeterminate: (str, post)=>`${str}:indeterminate ${post}, ${str}[aria-checked=mixed] ${post}, ${str}[data-indeterminate] ${post}`,
    readOnly: (str, post)=>`${str}:read-only ${post}, ${str}[readonly] ${post}, ${str}[data-read-only] ${post}`,
    expanded: (str, post)=>`${str}:read-only ${post}, ${str}[aria-expanded=true] ${post}, ${str}[data-expanded] ${post}`,
    placeholderShown: (str, post)=>`${str}:placeholder-shown ${post}`
};
const $e848db045ed1a592$var$toGroup = (fn)=>$e848db045ed1a592$var$merge((v)=>fn(v, "&"), "[role=group]", "[data-group]", ".group");
const $e848db045ed1a592$var$toPeer = (fn)=>$e848db045ed1a592$var$merge((v)=>fn(v, "~ &"), "[data-peer]", ".peer");
const $e848db045ed1a592$var$merge = (fn, ...selectors)=>selectors.map(fn).join(", ");
const $e848db045ed1a592$var$pseudoSelectors = {
    /**
   * Styles for CSS selector `&:hover`
   */ _hover: "&:hover, &[data-hover]",
    /**
   * Styles for CSS Selector `&:active`
   */ _active: "&:active, &[data-active]",
    /**
   * Styles for CSS selector `&:focus`
   *
   */ _focus: "&:focus, &[data-focus]",
    /**
   * Styles for the highlighted state.
   */ _highlighted: "&[data-highlighted]",
    /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */ _focusWithin: "&:focus-within, &[data-focus-within]",
    /**
   * Styles to apply when this element has received focus via tabbing
   * - CSS Selector `&:focus-visible`
   */ _focusVisible: "&:focus-visible, &[data-focus-visible]",
    /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   * - `&[disabled]`
   */ _disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
    /**
   * Styles for CSS Selector `&:readonly`
   */ _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
    /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */ _before: "&::before",
    /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */ _after: "&::after",
    /**
   * Styles for CSS selector `&:empty`
   */ _empty: "&:empty, &[data-empty]",
    /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */ _expanded: "&[aria-expanded=true], &[data-expanded], &[data-state=expanded]",
    /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */ _checked: "&[aria-checked=true], &[data-checked], &[data-state=checked]",
    /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */ _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
    /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */ _pressed: "&[aria-pressed=true], &[data-pressed]",
    /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */ _invalid: "&[aria-invalid=true], &[data-invalid]",
    /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */ _valid: "&[data-valid], &[data-state=valid]",
    /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */ _loading: "&[data-loading], &[aria-busy=true]",
    /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */ _selected: "&[aria-selected=true], &[data-selected]",
    /**
   * Styles for CSS Selector `[hidden=true]`
   */ _hidden: "&[hidden], &[data-hidden]",
    /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */ _autofill: "&:-webkit-autofill",
    /**
   * Styles for CSS Selector `&:nth-child(even)`
   */ _even: "&:nth-of-type(even)",
    /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */ _odd: "&:nth-of-type(odd)",
    /**
   * Styles for CSS Selector `&:first-of-type`
   */ _first: "&:first-of-type",
    /**
   * Styles for CSS selector `&::first-letter`
   *
   * NOTE: This selector is only applied for block-level elements and not preceded by an image or table.
   * @example
   * ```jsx
   * <Text _firstLetter={{ textDecoration: 'underline' }}>Once upon a time</Text>
   * ```
   */ _firstLetter: "&::first-letter",
    /**
   * Styles for CSS Selector `&:last-of-type`
   */ _last: "&:last-of-type",
    /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */ _notFirst: "&:not(:first-of-type)",
    /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */ _notLast: "&:not(:last-of-type)",
    /**
   * Styles for CSS Selector `&:visited`
   */ _visited: "&:visited",
    /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */ _activeLink: "&[aria-current=page]",
    /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */ _activeStep: "&[aria-current=step]",
    /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */ _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate], &[data-state=indeterminate]",
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is open
   */ _groupOpen: $e848db045ed1a592$var$toGroup($e848db045ed1a592$var$state.open),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is closed
   */ _groupClosed: $e848db045ed1a592$var$toGroup($e848db045ed1a592$var$state.closed),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
   */ _groupHover: $e848db045ed1a592$var$toGroup($e848db045ed1a592$var$state.hover),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
   */ _peerHover: $e848db045ed1a592$var$toPeer($e848db045ed1a592$var$state.hover),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
   */ _groupFocus: $e848db045ed1a592$var$toGroup($e848db045ed1a592$var$state.focus),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
   */ _peerFocus: $e848db045ed1a592$var$toPeer($e848db045ed1a592$var$state.focus),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
   */ _groupFocusVisible: $e848db045ed1a592$var$toGroup($e848db045ed1a592$var$state.focusVisible),
    /**
   * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
   */ _peerFocusVisible: $e848db045ed1a592$var$toPeer($e848db045ed1a592$var$state.focusVisible),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
   */ _groupActive: $e848db045ed1a592$var$toGroup($e848db045ed1a592$var$state.active),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is active
   */ _peerActive: $e848db045ed1a592$var$toPeer($e848db045ed1a592$var$state.active),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
   */ _groupDisabled: $e848db045ed1a592$var$toGroup($e848db045ed1a592$var$state.disabled),
    /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
   */ _peerDisabled: $e848db045ed1a592$var$toPeer($e848db045ed1a592$var$state.disabled),
    /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
   */ _groupInvalid: $e848db045ed1a592$var$toGroup($e848db045ed1a592$var$state.invalid),
    /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
   */ _peerInvalid: $e848db045ed1a592$var$toPeer($e848db045ed1a592$var$state.invalid),
    /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
   */ _groupChecked: $e848db045ed1a592$var$toGroup($e848db045ed1a592$var$state.checked),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
   */ _peerChecked: $e848db045ed1a592$var$toPeer($e848db045ed1a592$var$state.checked),
    /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
   */ _groupFocusWithin: $e848db045ed1a592$var$toGroup($e848db045ed1a592$var$state.focusWithin),
    /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
   */ _peerFocusWithin: $e848db045ed1a592$var$toPeer($e848db045ed1a592$var$state.focusWithin),
    /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
   */ _peerPlaceholderShown: $e848db045ed1a592$var$toPeer($e848db045ed1a592$var$state.placeholderShown),
    /**
   * Styles for CSS Selector `&::placeholder`.
   */ _placeholder: "&::placeholder, &[data-placeholder]",
    /**
   * Styles for CSS Selector `&:placeholder-shown`.
   */ _placeholderShown: "&:placeholder-shown, &[data-placeholder-shown]",
    /**
   * Styles for CSS Selector `&:fullscreen`.
   */ _fullScreen: "&:fullscreen, &[data-fullscreen]",
    /**
   * Styles for CSS Selector `&::selection`
   */ _selection: "&::selection",
    /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when a parent element or this element has `dir="rtl"`
   */ _rtl: "[dir=rtl] &, &[dir=rtl]",
    /**
   * Styles for CSS Selector `[dir=ltr] &`
   * It is applied when a parent element or this element has `dir="ltr"`
   */ _ltr: "[dir=ltr] &, &[dir=ltr]",
    /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * It is used when the user has requested the system use a light or dark color theme.
   */ _mediaDark: "@media (prefers-color-scheme: dark)",
    /**
   * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
   * It is used when the user has requested the system to reduce the amount of animations.
   */ _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
    /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */ _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
    /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */ _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",
    /**
   * Styles for the CSS Selector `&[data-orientation=horizontal]`
   */ _horizontal: "&[data-orientation=horizontal]",
    /**
   * Styles for the CSS Selector `&[data-orientation=vertical]`
   */ _vertical: "&[data-orientation=vertical]",
    /**
   * Styles for the CSS Selector `&[data-open], &[open], &[data-state=open]`
   */ _open: "&[data-open], &[open], &[data-state=open]",
    /**
   * Styles for the CSS Selector `&[data-closed], &[data-state=closed]`
   */ _closed: "&[data-closed], &[data-state=closed]",
    /**
   * Styles for the CSS Selector `&[data-complete]`
   */ _complete: "&[data-complete]",
    /**
   * Styles for the CSS Selector `&[data-incomplete]`
   */ _incomplete: "&[data-incomplete]",
    /**
   * Styles for the CSS Selector `&[data-current]`
   */ _current: "&[data-current]"
};
function $e848db045ed1a592$export$f41ab9e4dfc20352(theme) {
    const __conds = theme.conditions ?? {};
    const conditions = Object.fromEntries(Object.entries(__conds).map(([key, value])=>[
            `_${key}`,
            value
        ]));
    return {
        ...$e848db045ed1a592$var$pseudoSelectors,
        ...conditions
    };
}
function $e848db045ed1a592$export$a7126a96abbbb621(theme) {
    return Object.keys($e848db045ed1a592$export$f41ab9e4dfc20352(theme));
}

});

parcelRegister("lA3d6", function(module, exports) {

$parcel$export(module.exports, "systemProps", function () { return $8d9402c088dd4f07$export$30cfa87a708babfc; });
$parcel$export(module.exports, "layoutPropNames", function () { return $8d9402c088dd4f07$export$bccb7c6ca2f4f912; });
$parcel$export(module.exports, "getPropNames", function () { return $8d9402c088dd4f07$export$efd83c674fc6ddd4; });
$parcel$export(module.exports, "isStylePropFn", function () { return $8d9402c088dd4f07$export$891a13dd8973414c; });

var $v03Ub = parcelRequire("v03Ub");

var $lOd5f = parcelRequire("lOd5f");

var $lhnV3 = parcelRequire("lhnV3");

var $hEHTu = parcelRequire("hEHTu");

var $e5lkB = parcelRequire("e5lkB");

var $VGhSb = parcelRequire("VGhSb");

var $gR9SJ = parcelRequire("gR9SJ");

var $bKBM5 = parcelRequire("bKBM5");

var $75gEG = parcelRequire("75gEG");

var $8MDqm = parcelRequire("8MDqm");

var $33Uvv = parcelRequire("33Uvv");

var $g37bq = parcelRequire("g37bq");

var $4oLqu = parcelRequire("4oLqu");

var $izLro = parcelRequire("izLro");

var $k5v9G = parcelRequire("k5v9G");

var $gGSoD = parcelRequire("gGSoD");

var $6j76Z = parcelRequire("6j76Z");

var $2dUgQ = parcelRequire("2dUgQ");

var $geMxb = parcelRequire("geMxb");

var $66a67 = parcelRequire("66a67");

var $lismd = parcelRequire("lismd");
const $8d9402c088dd4f07$export$30cfa87a708babfc = (0, (/*@__PURE__*/$parcel$interopDefault($v03Ub)))({}, (0, $lhnV3.background), (0, $hEHTu.border), (0, $e5lkB.color), (0, $VGhSb.flexbox), (0, $gR9SJ.layout), (0, $bKBM5.filter), (0, $75gEG.ring), (0, $8MDqm.interactivity), (0, $33Uvv.grid), (0, $g37bq.others), (0, $4oLqu.position), (0, $izLro.effect), (0, $k5v9G.space), (0, $gGSoD.scroll), (0, $6j76Z.typography), (0, $2dUgQ.textDecoration), (0, $geMxb.transform), (0, $66a67.list), (0, $lismd.transition));
const $8d9402c088dd4f07$var$layoutSystem = Object.assign({}, (0, $k5v9G.space), (0, $gR9SJ.layout), (0, $VGhSb.flexbox), (0, $33Uvv.grid), (0, $4oLqu.position));
const $8d9402c088dd4f07$export$bccb7c6ca2f4f912 = Object.keys($8d9402c088dd4f07$var$layoutSystem);
const $8d9402c088dd4f07$export$efd83c674fc6ddd4 = (theme)=>[
        ...Object.keys($8d9402c088dd4f07$export$30cfa87a708babfc),
        ...(0, $lOd5f.getPseudoPropNames)(theme)
    ];
const $8d9402c088dd4f07$export$891a13dd8973414c = (theme)=>{
    const pseudoSelectors = (0, $lOd5f.getPseudoSelectors)(theme);
    const styleProps = {
        ...$8d9402c088dd4f07$export$30cfa87a708babfc,
        ...pseudoSelectors
    };
    return (prop)=>{
        return Object.hasOwnProperty.call(styleProps, prop);
    };
};

});
parcelRegister("lhnV3", function(module, exports) {

$parcel$export(module.exports, "background", function () { return $04a0906fa0e714db$export$8ce1fd94bee2f412; });

var $jLbDJ = parcelRequire("jLbDJ");

var $6eJPF = parcelRequire("6eJPF");
const $04a0906fa0e714db$export$8ce1fd94bee2f412 = {
    background: (0, $jLbDJ.t).colors("background"),
    backgroundColor: (0, $jLbDJ.t).colors("backgroundColor"),
    backgroundImage: (0, $jLbDJ.t).gradients("backgroundImage"),
    backgroundSize: true,
    backgroundPosition: true,
    backgroundRepeat: true,
    backgroundAttachment: true,
    backgroundClip: {
        transform: (0, $6eJPF.transformFunctions).bgClip
    },
    bgSize: (0, $jLbDJ.t).prop("backgroundSize"),
    bgPosition: (0, $jLbDJ.t).prop("backgroundPosition"),
    bg: (0, $jLbDJ.t).colors("background"),
    bgColor: (0, $jLbDJ.t).colors("backgroundColor"),
    bgPos: (0, $jLbDJ.t).prop("backgroundPosition"),
    bgRepeat: (0, $jLbDJ.t).prop("backgroundRepeat"),
    bgAttachment: (0, $jLbDJ.t).prop("backgroundAttachment"),
    bgGradient: (0, $jLbDJ.t).gradients("backgroundImage"),
    bgClip: {
        transform: (0, $6eJPF.transformFunctions).bgClip
    }
};
Object.assign($04a0906fa0e714db$export$8ce1fd94bee2f412, {
    bgImage: $04a0906fa0e714db$export$8ce1fd94bee2f412.backgroundImage,
    bgImg: $04a0906fa0e714db$export$8ce1fd94bee2f412.backgroundImage
});

});
parcelRegister("jLbDJ", function(module, exports) {

$parcel$export(module.exports, "t", function () { return $9f1bd1a822057813$export$625550452a3fa3ec; });

var $2bfJD = parcelRequire("2bfJD");

var $1KPik = parcelRequire("1KPik");

var $dqKGq = parcelRequire("dqKGq");

var $6eJPF = parcelRequire("6eJPF");
const $9f1bd1a822057813$export$625550452a3fa3ec = {
    borderWidths: (0, $dqKGq.toConfig)("borderWidths"),
    borderStyles: (0, $dqKGq.toConfig)("borderStyles"),
    colors: (0, $dqKGq.toConfig)("colors"),
    borders: (0, $dqKGq.toConfig)("borders"),
    gradients: (0, $dqKGq.toConfig)("gradients", (0, $6eJPF.transformFunctions).gradient),
    radii: (0, $dqKGq.toConfig)("radii", (0, $6eJPF.transformFunctions).px),
    space: (0, $dqKGq.toConfig)("space", (0, $1KPik.pipe)((0, $6eJPF.transformFunctions).vh, (0, $6eJPF.transformFunctions).px)),
    spaceT: (0, $dqKGq.toConfig)("space", (0, $1KPik.pipe)((0, $6eJPF.transformFunctions).vh, (0, $6eJPF.transformFunctions).px)),
    degreeT (property) {
        return {
            property: property,
            transform: (0, $6eJPF.transformFunctions).degree
        };
    },
    prop (property, scale, transform) {
        return {
            property: property,
            scale: scale,
            ...scale && {
                transform: (0, $2bfJD.createTransform)({
                    scale: scale,
                    transform: transform
                })
            }
        };
    },
    propT (property, transform) {
        return {
            property: property,
            transform: transform
        };
    },
    sizes: (0, $dqKGq.toConfig)("sizes", (0, $1KPik.pipe)((0, $6eJPF.transformFunctions).vh, (0, $6eJPF.transformFunctions).px)),
    sizesT: (0, $dqKGq.toConfig)("sizes", (0, $1KPik.pipe)((0, $6eJPF.transformFunctions).vh, (0, $6eJPF.transformFunctions).fraction)),
    shadows: (0, $dqKGq.toConfig)("shadows"),
    logical: $dqKGq.logical,
    blur: (0, $dqKGq.toConfig)("blur", (0, $6eJPF.transformFunctions).blur)
};

});
parcelRegister("2bfJD", function(module, exports) {

$parcel$export(module.exports, "createTransform", function () { return $fcd084ba6ac49b2e$export$99c68a89351e15c0; });

var $fZQg5 = parcelRequire("fZQg5");
const $fcd084ba6ac49b2e$var$isImportant = (value)=>/!(important)?$/.test(value);
const $fcd084ba6ac49b2e$var$withoutImportant = (value)=>typeof value === "string" ? value.replace(/!(important)?$/, "").trim() : value;
const $fcd084ba6ac49b2e$export$92f5bb613cffac78 = (scale, value)=>(theme)=>{
        const valueStr = String(value);
        const important = $fcd084ba6ac49b2e$var$isImportant(valueStr);
        const valueWithoutImportant = $fcd084ba6ac49b2e$var$withoutImportant(valueStr);
        const key = scale ? `${scale}.${valueWithoutImportant}` : valueWithoutImportant;
        let transformed = (0, $fZQg5.isObject)(theme.__cssMap) && key in theme.__cssMap ? theme.__cssMap[key].varRef : value;
        transformed = $fcd084ba6ac49b2e$var$withoutImportant(transformed);
        return important ? `${transformed} !important` : transformed;
    };
function $fcd084ba6ac49b2e$export$99c68a89351e15c0(options) {
    const { scale: scale, transform: transform, compose: compose } = options;
    const fn = (value, theme)=>{
        const _value = $fcd084ba6ac49b2e$export$92f5bb613cffac78(scale, value)(theme);
        let result = transform?.(_value, theme) ?? _value;
        if (compose) result = compose(result, theme);
        return result;
    };
    return fn;
}

});

parcelRegister("1KPik", function(module, exports) {

$parcel$export(module.exports, "pipe", function () { return $1cf9ddd0011f02b0$export$a4627e546088548d; });
const $1cf9ddd0011f02b0$export$a4627e546088548d = (...fns)=>(v)=>fns.reduce((a, b)=>b(a), v);

});

parcelRegister("dqKGq", function(module, exports) {

$parcel$export(module.exports, "toConfig", function () { return $90733906baa6530c$export$9ced7da5e9a2be1b; });
$parcel$export(module.exports, "logical", function () { return $90733906baa6530c$export$965c6ce6d3869a7a; });

var $2bfJD = parcelRequire("2bfJD");
function $90733906baa6530c$export$9ced7da5e9a2be1b(scale, transform) {
    return (property)=>{
        const result = {
            property: property,
            scale: scale
        };
        result.transform = (0, $2bfJD.createTransform)({
            scale: scale,
            transform: transform
        });
        return result;
    };
}
const $90733906baa6530c$var$getRtl = ({ rtl: rtl, ltr: ltr })=>(theme)=>theme.direction === "rtl" ? rtl : ltr;
function $90733906baa6530c$export$965c6ce6d3869a7a(options) {
    const { property: property, scale: scale, transform: transform } = options;
    return {
        scale: scale,
        property: $90733906baa6530c$var$getRtl(property),
        transform: scale ? (0, $2bfJD.createTransform)({
            scale: scale,
            compose: transform
        }) : transform
    };
}

});

parcelRegister("6eJPF", function(module, exports) {

$parcel$export(module.exports, "transformFunctions", function () { return $75f22e76054ed893$export$f1c738cddd9a74ae; });

var $kMiRR = parcelRequire("kMiRR");

var $bz7Uf = parcelRequire("bz7Uf");
function $75f22e76054ed893$var$isCssVar(value) {
    return /^var\(--.+\)$/.test(value);
}
const $75f22e76054ed893$var$analyzeCSSValue = (value)=>{
    const num = parseFloat(value.toString());
    const unit = value.toString().replace(String(num), "");
    return {
        unitless: !unit,
        value: num,
        unit: unit
    };
};
const $75f22e76054ed893$var$wrap = (str)=>(value)=>`${str}(${value})`;
const $75f22e76054ed893$export$f1c738cddd9a74ae = {
    filter (value) {
        return value !== "auto" ? value : (0, $kMiRR.filterTemplate);
    },
    backdropFilter (value) {
        return value !== "auto" ? value : (0, $kMiRR.backdropFilterTemplate);
    },
    ring (value) {
        return (0, $kMiRR.getRingTemplate)($75f22e76054ed893$export$f1c738cddd9a74ae.px(value));
    },
    bgClip (value) {
        return value === "text" ? {
            color: "transparent",
            backgroundClip: "text"
        } : {
            backgroundClip: value
        };
    },
    transform (value) {
        if (value === "auto") return (0, $kMiRR.getTransformTemplate)();
        if (value === "auto-gpu") return (0, $kMiRR.getTransformGpuTemplate)();
        return value;
    },
    vh (value) {
        return value === "$100vh" ? "var(--chakra-vh)" : value;
    },
    px (value) {
        if (value == null) return value;
        const { unitless: unitless } = $75f22e76054ed893$var$analyzeCSSValue(value);
        return unitless || typeof value === "number" ? `${value}px` : value;
    },
    fraction (value) {
        return !(typeof value === "number") || value > 1 ? value : `${value * 100}%`;
    },
    float (value, theme) {
        const map = {
            left: "right",
            right: "left"
        };
        return theme.direction === "rtl" ? map[value] : value;
    },
    degree (value) {
        if ($75f22e76054ed893$var$isCssVar(value) || value == null) return value;
        const unitless = typeof value === "string" && !value.endsWith("deg");
        return typeof value === "number" || unitless ? `${value}deg` : value;
    },
    gradient: (0, $bz7Uf.gradientTransform),
    blur: $75f22e76054ed893$var$wrap("blur"),
    opacity: $75f22e76054ed893$var$wrap("opacity"),
    brightness: $75f22e76054ed893$var$wrap("brightness"),
    contrast: $75f22e76054ed893$var$wrap("contrast"),
    dropShadow: $75f22e76054ed893$var$wrap("drop-shadow"),
    grayscale: $75f22e76054ed893$var$wrap("grayscale"),
    hueRotate: (value)=>$75f22e76054ed893$var$wrap("hue-rotate")($75f22e76054ed893$export$f1c738cddd9a74ae.degree(value)),
    invert: $75f22e76054ed893$var$wrap("invert"),
    saturate: $75f22e76054ed893$var$wrap("saturate"),
    sepia: $75f22e76054ed893$var$wrap("sepia"),
    bgImage (value) {
        if (value == null) return value;
        const prevent = (0, $bz7Uf.isCSSFunction)(value) || (0, $bz7Uf.globalSet).has(value);
        return !prevent ? `url(${value})` : value;
    },
    outline (value) {
        const isNoneOrZero = String(value) === "0" || String(value) === "none";
        return value !== null && isNoneOrZero ? {
            outline: "2px solid transparent",
            outlineOffset: "2px"
        } : {
            outline: value
        };
    },
    flexDirection (value) {
        const { space: space, divide: divide } = (0, $kMiRR.flexDirectionTemplate)[value] ?? {};
        const result = {
            flexDirection: value
        };
        if (space) result[space] = 1;
        if (divide) result[divide] = 1;
        return result;
    }
};

});
parcelRegister("kMiRR", function(module, exports) {

$parcel$export(module.exports, "getTransformTemplate", function () { return $b9702ea25cc68fbf$export$5f430efbe955e23; });
$parcel$export(module.exports, "getTransformGpuTemplate", function () { return $b9702ea25cc68fbf$export$64ac7328c339e78f; });
$parcel$export(module.exports, "filterTemplate", function () { return $b9702ea25cc68fbf$export$b74d0d62597cd7c1; });
$parcel$export(module.exports, "backdropFilterTemplate", function () { return $b9702ea25cc68fbf$export$560b9f000772a3a3; });
$parcel$export(module.exports, "getRingTemplate", function () { return $b9702ea25cc68fbf$export$c6454f9b51b226bb; });
$parcel$export(module.exports, "flexDirectionTemplate", function () { return $b9702ea25cc68fbf$export$2d29807f3ae71abd; });
const $b9702ea25cc68fbf$var$transformTemplate = [
    "rotate(var(--chakra-rotate, 0))",
    "scaleX(var(--chakra-scale-x, 1))",
    "scaleY(var(--chakra-scale-y, 1))",
    "skewX(var(--chakra-skew-x, 0))",
    "skewY(var(--chakra-skew-y, 0))"
];
function $b9702ea25cc68fbf$export$5f430efbe955e23() {
    return [
        "translateX(var(--chakra-translate-x, 0))",
        "translateY(var(--chakra-translate-y, 0))",
        ...$b9702ea25cc68fbf$var$transformTemplate
    ].join(" ");
}
function $b9702ea25cc68fbf$export$64ac7328c339e78f() {
    return [
        "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",
        ...$b9702ea25cc68fbf$var$transformTemplate
    ].join(" ");
}
const $b9702ea25cc68fbf$export$b74d0d62597cd7c1 = {
    "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
    filter: [
        "var(--chakra-blur)",
        "var(--chakra-brightness)",
        "var(--chakra-contrast)",
        "var(--chakra-grayscale)",
        "var(--chakra-hue-rotate)",
        "var(--chakra-invert)",
        "var(--chakra-saturate)",
        "var(--chakra-sepia)",
        "var(--chakra-drop-shadow)"
    ].join(" ")
};
const $b9702ea25cc68fbf$export$560b9f000772a3a3 = {
    backdropFilter: [
        "var(--chakra-backdrop-blur)",
        "var(--chakra-backdrop-brightness)",
        "var(--chakra-backdrop-contrast)",
        "var(--chakra-backdrop-grayscale)",
        "var(--chakra-backdrop-hue-rotate)",
        "var(--chakra-backdrop-invert)",
        "var(--chakra-backdrop-opacity)",
        "var(--chakra-backdrop-saturate)",
        "var(--chakra-backdrop-sepia)"
    ].join(" "),
    "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function $b9702ea25cc68fbf$export$c6454f9b51b226bb(value) {
    return {
        "--chakra-ring-offset-shadow": `var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)`,
        "--chakra-ring-shadow": `var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)`,
        "--chakra-ring-width": value,
        boxShadow: [
            `var(--chakra-ring-offset-shadow)`,
            `var(--chakra-ring-shadow)`,
            `var(--chakra-shadow, 0 0 #0000)`
        ].join(", ")
    };
}
const $b9702ea25cc68fbf$export$2d29807f3ae71abd = {
    "row-reverse": {
        space: "--chakra-space-x-reverse",
        divide: "--chakra-divide-x-reverse"
    },
    "column-reverse": {
        space: "--chakra-space-y-reverse",
        divide: "--chakra-divide-y-reverse"
    }
};

});

parcelRegister("bz7Uf", function(module, exports) {

$parcel$export(module.exports, "globalSet", function () { return $34788d60061d1b4d$export$64d5d115563291e3; });
$parcel$export(module.exports, "isCSSFunction", function () { return $34788d60061d1b4d$export$710a7f202c1f9f4e; });
$parcel$export(module.exports, "gradientTransform", function () { return $34788d60061d1b4d$export$6bab994d7a66bebb; });
const $34788d60061d1b4d$var$directionMap = {
    "to-t": "to top",
    "to-tr": "to top right",
    "to-r": "to right",
    "to-br": "to bottom right",
    "to-b": "to bottom",
    "to-bl": "to bottom left",
    "to-l": "to left",
    "to-tl": "to top left"
};
const $34788d60061d1b4d$var$valueSet = new Set(Object.values($34788d60061d1b4d$var$directionMap));
const $34788d60061d1b4d$export$64d5d115563291e3 = /* @__PURE__ */ new Set([
    "none",
    "-moz-initial",
    "inherit",
    "initial",
    "revert",
    "unset"
]);
const $34788d60061d1b4d$var$trimSpace = (str)=>str.trim();
function $34788d60061d1b4d$export$1089ae7f4d02cd2e(value, theme) {
    if (value == null || $34788d60061d1b4d$export$64d5d115563291e3.has(value)) return value;
    const prevent = $34788d60061d1b4d$export$710a7f202c1f9f4e(value) || $34788d60061d1b4d$export$64d5d115563291e3.has(value);
    if (!prevent) return `url('${value}')`;
    const regex = /(^[a-z-A-Z]+)\((.*)\)/g;
    const results = regex.exec(value);
    const type = results?.[1];
    const values = results?.[2];
    if (!type || !values) return value;
    const _type = type.includes("-gradient") ? type : `${type}-gradient`;
    const [maybeDirection, ...stops] = values.split(",").map($34788d60061d1b4d$var$trimSpace).filter(Boolean);
    if (stops?.length === 0) return value;
    const direction = maybeDirection in $34788d60061d1b4d$var$directionMap ? $34788d60061d1b4d$var$directionMap[maybeDirection] : maybeDirection;
    stops.unshift(direction);
    const _values = stops.map((stop)=>{
        if ($34788d60061d1b4d$var$valueSet.has(stop)) return stop;
        const firstStop = stop.indexOf(" ");
        const [_color, _stop] = firstStop !== -1 ? [
            stop.substr(0, firstStop),
            stop.substr(firstStop + 1)
        ] : [
            stop
        ];
        const _stopOrFunc = $34788d60061d1b4d$export$710a7f202c1f9f4e(_stop) ? _stop : _stop && _stop.split(" ");
        const key = `colors.${_color}`;
        const color = key in theme.__cssMap ? theme.__cssMap[key].varRef : _color;
        return _stopOrFunc ? [
            color,
            ...Array.isArray(_stopOrFunc) ? _stopOrFunc : [
                _stopOrFunc
            ]
        ].join(" ") : color;
    });
    return `${_type}(${_values.join(", ")})`;
}
const $34788d60061d1b4d$export$710a7f202c1f9f4e = (value)=>{
    return typeof value === "string" && value.includes("(") && value.includes(")");
};
const $34788d60061d1b4d$export$6bab994d7a66bebb = (value, theme)=>$34788d60061d1b4d$export$1089ae7f4d02cd2e(value, theme ?? {});

});




parcelRegister("hEHTu", function(module, exports) {

$parcel$export(module.exports, "border", function () { return $d89a24d3b4fa6cae$export$1edee58a52776cd9; });

var $jLbDJ = parcelRequire("jLbDJ");
const $d89a24d3b4fa6cae$export$1edee58a52776cd9 = {
    border: (0, $jLbDJ.t).borders("border"),
    borderWidth: (0, $jLbDJ.t).borderWidths("borderWidth"),
    borderStyle: (0, $jLbDJ.t).borderStyles("borderStyle"),
    borderColor: (0, $jLbDJ.t).colors("borderColor"),
    borderRadius: (0, $jLbDJ.t).radii("borderRadius"),
    borderTop: (0, $jLbDJ.t).borders("borderTop"),
    borderBlockStart: (0, $jLbDJ.t).borders("borderBlockStart"),
    borderTopLeftRadius: (0, $jLbDJ.t).radii("borderTopLeftRadius"),
    borderStartStartRadius: (0, $jLbDJ.t).logical({
        scale: "radii",
        property: {
            ltr: "borderTopLeftRadius",
            rtl: "borderTopRightRadius"
        }
    }),
    borderEndStartRadius: (0, $jLbDJ.t).logical({
        scale: "radii",
        property: {
            ltr: "borderBottomLeftRadius",
            rtl: "borderBottomRightRadius"
        }
    }),
    borderTopRightRadius: (0, $jLbDJ.t).radii("borderTopRightRadius"),
    borderStartEndRadius: (0, $jLbDJ.t).logical({
        scale: "radii",
        property: {
            ltr: "borderTopRightRadius",
            rtl: "borderTopLeftRadius"
        }
    }),
    borderEndEndRadius: (0, $jLbDJ.t).logical({
        scale: "radii",
        property: {
            ltr: "borderBottomRightRadius",
            rtl: "borderBottomLeftRadius"
        }
    }),
    borderRight: (0, $jLbDJ.t).borders("borderRight"),
    borderInlineEnd: (0, $jLbDJ.t).borders("borderInlineEnd"),
    borderBottom: (0, $jLbDJ.t).borders("borderBottom"),
    borderBlockEnd: (0, $jLbDJ.t).borders("borderBlockEnd"),
    borderBottomLeftRadius: (0, $jLbDJ.t).radii("borderBottomLeftRadius"),
    borderBottomRightRadius: (0, $jLbDJ.t).radii("borderBottomRightRadius"),
    borderLeft: (0, $jLbDJ.t).borders("borderLeft"),
    borderInlineStart: {
        property: "borderInlineStart",
        scale: "borders"
    },
    borderInlineStartRadius: (0, $jLbDJ.t).logical({
        scale: "radii",
        property: {
            ltr: [
                "borderTopLeftRadius",
                "borderBottomLeftRadius"
            ],
            rtl: [
                "borderTopRightRadius",
                "borderBottomRightRadius"
            ]
        }
    }),
    borderInlineEndRadius: (0, $jLbDJ.t).logical({
        scale: "radii",
        property: {
            ltr: [
                "borderTopRightRadius",
                "borderBottomRightRadius"
            ],
            rtl: [
                "borderTopLeftRadius",
                "borderBottomLeftRadius"
            ]
        }
    }),
    borderX: (0, $jLbDJ.t).borders([
        "borderLeft",
        "borderRight"
    ]),
    borderInline: (0, $jLbDJ.t).borders("borderInline"),
    borderY: (0, $jLbDJ.t).borders([
        "borderTop",
        "borderBottom"
    ]),
    borderBlock: (0, $jLbDJ.t).borders("borderBlock"),
    borderTopWidth: (0, $jLbDJ.t).borderWidths("borderTopWidth"),
    borderBlockStartWidth: (0, $jLbDJ.t).borderWidths("borderBlockStartWidth"),
    borderTopColor: (0, $jLbDJ.t).colors("borderTopColor"),
    borderBlockStartColor: (0, $jLbDJ.t).colors("borderBlockStartColor"),
    borderTopStyle: (0, $jLbDJ.t).borderStyles("borderTopStyle"),
    borderBlockStartStyle: (0, $jLbDJ.t).borderStyles("borderBlockStartStyle"),
    borderBottomWidth: (0, $jLbDJ.t).borderWidths("borderBottomWidth"),
    borderBlockEndWidth: (0, $jLbDJ.t).borderWidths("borderBlockEndWidth"),
    borderBottomColor: (0, $jLbDJ.t).colors("borderBottomColor"),
    borderBlockEndColor: (0, $jLbDJ.t).colors("borderBlockEndColor"),
    borderBottomStyle: (0, $jLbDJ.t).borderStyles("borderBottomStyle"),
    borderBlockEndStyle: (0, $jLbDJ.t).borderStyles("borderBlockEndStyle"),
    borderLeftWidth: (0, $jLbDJ.t).borderWidths("borderLeftWidth"),
    borderInlineStartWidth: (0, $jLbDJ.t).borderWidths("borderInlineStartWidth"),
    borderLeftColor: (0, $jLbDJ.t).colors("borderLeftColor"),
    borderInlineStartColor: (0, $jLbDJ.t).colors("borderInlineStartColor"),
    borderLeftStyle: (0, $jLbDJ.t).borderStyles("borderLeftStyle"),
    borderInlineStartStyle: (0, $jLbDJ.t).borderStyles("borderInlineStartStyle"),
    borderRightWidth: (0, $jLbDJ.t).borderWidths("borderRightWidth"),
    borderInlineEndWidth: (0, $jLbDJ.t).borderWidths("borderInlineEndWidth"),
    borderRightColor: (0, $jLbDJ.t).colors("borderRightColor"),
    borderInlineEndColor: (0, $jLbDJ.t).colors("borderInlineEndColor"),
    borderRightStyle: (0, $jLbDJ.t).borderStyles("borderRightStyle"),
    borderInlineEndStyle: (0, $jLbDJ.t).borderStyles("borderInlineEndStyle"),
    borderTopRadius: (0, $jLbDJ.t).radii([
        "borderTopLeftRadius",
        "borderTopRightRadius"
    ]),
    borderBottomRadius: (0, $jLbDJ.t).radii([
        "borderBottomLeftRadius",
        "borderBottomRightRadius"
    ]),
    borderLeftRadius: (0, $jLbDJ.t).radii([
        "borderTopLeftRadius",
        "borderBottomLeftRadius"
    ]),
    borderRightRadius: (0, $jLbDJ.t).radii([
        "borderTopRightRadius",
        "borderBottomRightRadius"
    ])
};
Object.assign($d89a24d3b4fa6cae$export$1edee58a52776cd9, {
    rounded: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderRadius,
    roundedTop: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderTopRadius,
    roundedTopLeft: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderTopLeftRadius,
    roundedTopRight: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderTopRightRadius,
    roundedTopStart: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderStartStartRadius,
    roundedTopEnd: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderStartEndRadius,
    roundedBottom: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderBottomRadius,
    roundedBottomLeft: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderBottomLeftRadius,
    roundedBottomRight: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderBottomRightRadius,
    roundedBottomStart: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderEndStartRadius,
    roundedBottomEnd: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderEndEndRadius,
    roundedLeft: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderLeftRadius,
    roundedRight: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderRightRadius,
    roundedStart: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderInlineStartRadius,
    roundedEnd: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderInlineEndRadius,
    borderStart: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderInlineStart,
    borderEnd: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderInlineEnd,
    borderTopStartRadius: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderStartStartRadius,
    borderTopEndRadius: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderStartEndRadius,
    borderBottomStartRadius: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderEndStartRadius,
    borderBottomEndRadius: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderEndEndRadius,
    borderStartRadius: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderInlineStartRadius,
    borderEndRadius: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderInlineEndRadius,
    borderStartWidth: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderInlineStartWidth,
    borderEndWidth: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderInlineEndWidth,
    borderStartColor: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderInlineStartColor,
    borderEndColor: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderInlineEndColor,
    borderStartStyle: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderInlineStartStyle,
    borderEndStyle: $d89a24d3b4fa6cae$export$1edee58a52776cd9.borderInlineEndStyle
});

});

parcelRegister("e5lkB", function(module, exports) {

$parcel$export(module.exports, "color", function () { return $40df26644caf3157$export$35e9368ef982300f; });

var $jLbDJ = parcelRequire("jLbDJ");
const $40df26644caf3157$export$35e9368ef982300f = {
    color: (0, $jLbDJ.t).colors("color"),
    textColor: (0, $jLbDJ.t).colors("color"),
    fill: (0, $jLbDJ.t).colors("fill"),
    stroke: (0, $jLbDJ.t).colors("stroke"),
    accentColor: (0, $jLbDJ.t).colors("accentColor"),
    textFillColor: (0, $jLbDJ.t).colors("textFillColor")
};

});

parcelRegister("VGhSb", function(module, exports) {

$parcel$export(module.exports, "flexbox", function () { return $f4ae846258c63c97$export$feec61708a55c80e; });

var $jLbDJ = parcelRequire("jLbDJ");

var $6eJPF = parcelRequire("6eJPF");
const $f4ae846258c63c97$export$feec61708a55c80e = {
    alignItems: true,
    alignContent: true,
    justifyItems: true,
    justifyContent: true,
    flexWrap: true,
    flexDirection: {
        transform: (0, $6eJPF.transformFunctions).flexDirection
    },
    flex: true,
    flexFlow: true,
    flexGrow: true,
    flexShrink: true,
    flexBasis: (0, $jLbDJ.t).sizes("flexBasis"),
    justifySelf: true,
    alignSelf: true,
    order: true,
    placeItems: true,
    placeContent: true,
    placeSelf: true,
    gap: (0, $jLbDJ.t).space("gap"),
    rowGap: (0, $jLbDJ.t).space("rowGap"),
    columnGap: (0, $jLbDJ.t).space("columnGap")
};
Object.assign($f4ae846258c63c97$export$feec61708a55c80e, {
    flexDir: $f4ae846258c63c97$export$feec61708a55c80e.flexDirection
});

});

parcelRegister("gR9SJ", function(module, exports) {

$parcel$export(module.exports, "layout", function () { return $fd06b6d22bb1c06a$export$b3219800bda33a1f; });

var $jLbDJ = parcelRequire("jLbDJ");

var $6eJPF = parcelRequire("6eJPF");
const $fd06b6d22bb1c06a$export$b3219800bda33a1f = {
    width: (0, $jLbDJ.t).sizesT("width"),
    inlineSize: (0, $jLbDJ.t).sizesT("inlineSize"),
    height: (0, $jLbDJ.t).sizes("height"),
    blockSize: (0, $jLbDJ.t).sizes("blockSize"),
    boxSize: (0, $jLbDJ.t).sizes([
        "width",
        "height"
    ]),
    minWidth: (0, $jLbDJ.t).sizes("minWidth"),
    minInlineSize: (0, $jLbDJ.t).sizes("minInlineSize"),
    minHeight: (0, $jLbDJ.t).sizes("minHeight"),
    minBlockSize: (0, $jLbDJ.t).sizes("minBlockSize"),
    maxWidth: (0, $jLbDJ.t).sizes("maxWidth"),
    maxInlineSize: (0, $jLbDJ.t).sizes("maxInlineSize"),
    maxHeight: (0, $jLbDJ.t).sizes("maxHeight"),
    maxBlockSize: (0, $jLbDJ.t).sizes("maxBlockSize"),
    overflow: true,
    overflowX: true,
    overflowY: true,
    overscrollBehavior: true,
    overscrollBehaviorX: true,
    overscrollBehaviorY: true,
    display: true,
    aspectRatio: true,
    hideFrom: {
        scale: "breakpoints",
        transform: (value, theme)=>{
            const breakpoint = theme.__breakpoints?.get(value)?.minW ?? value;
            const mq = `@media screen and (min-width: ${breakpoint})`;
            return {
                [mq]: {
                    display: "none"
                }
            };
        }
    },
    hideBelow: {
        scale: "breakpoints",
        transform: (value, theme)=>{
            const breakpoint = theme.__breakpoints?.get(value)?._minW ?? value;
            const mq = `@media screen and (max-width: ${breakpoint})`;
            return {
                [mq]: {
                    display: "none"
                }
            };
        }
    },
    verticalAlign: true,
    boxSizing: true,
    boxDecorationBreak: true,
    float: (0, $jLbDJ.t).propT("float", (0, $6eJPF.transformFunctions).float),
    objectFit: true,
    objectPosition: true,
    visibility: true,
    isolation: true
};
Object.assign($fd06b6d22bb1c06a$export$b3219800bda33a1f, {
    w: $fd06b6d22bb1c06a$export$b3219800bda33a1f.width,
    h: $fd06b6d22bb1c06a$export$b3219800bda33a1f.height,
    minW: $fd06b6d22bb1c06a$export$b3219800bda33a1f.minWidth,
    maxW: $fd06b6d22bb1c06a$export$b3219800bda33a1f.maxWidth,
    minH: $fd06b6d22bb1c06a$export$b3219800bda33a1f.minHeight,
    maxH: $fd06b6d22bb1c06a$export$b3219800bda33a1f.maxHeight,
    overscroll: $fd06b6d22bb1c06a$export$b3219800bda33a1f.overscrollBehavior,
    overscrollX: $fd06b6d22bb1c06a$export$b3219800bda33a1f.overscrollBehaviorX,
    overscrollY: $fd06b6d22bb1c06a$export$b3219800bda33a1f.overscrollBehaviorY
});

});

parcelRegister("bKBM5", function(module, exports) {

$parcel$export(module.exports, "filter", function () { return $65f546680e59af55$export$3dea766d36a8935f; });

var $jLbDJ = parcelRequire("jLbDJ");

var $6eJPF = parcelRequire("6eJPF");
const $65f546680e59af55$export$3dea766d36a8935f = {
    filter: {
        transform: (0, $6eJPF.transformFunctions).filter
    },
    blur: (0, $jLbDJ.t).blur("--chakra-blur"),
    brightness: (0, $jLbDJ.t).propT("--chakra-brightness", (0, $6eJPF.transformFunctions).brightness),
    contrast: (0, $jLbDJ.t).propT("--chakra-contrast", (0, $6eJPF.transformFunctions).contrast),
    hueRotate: (0, $jLbDJ.t).propT("--chakra-hue-rotate", (0, $6eJPF.transformFunctions).hueRotate),
    invert: (0, $jLbDJ.t).propT("--chakra-invert", (0, $6eJPF.transformFunctions).invert),
    saturate: (0, $jLbDJ.t).propT("--chakra-saturate", (0, $6eJPF.transformFunctions).saturate),
    dropShadow: (0, $jLbDJ.t).propT("--chakra-drop-shadow", (0, $6eJPF.transformFunctions).dropShadow),
    backdropFilter: {
        transform: (0, $6eJPF.transformFunctions).backdropFilter
    },
    backdropBlur: (0, $jLbDJ.t).blur("--chakra-backdrop-blur"),
    backdropBrightness: (0, $jLbDJ.t).propT("--chakra-backdrop-brightness", (0, $6eJPF.transformFunctions).brightness),
    backdropContrast: (0, $jLbDJ.t).propT("--chakra-backdrop-contrast", (0, $6eJPF.transformFunctions).contrast),
    backdropHueRotate: (0, $jLbDJ.t).propT("--chakra-backdrop-hue-rotate", (0, $6eJPF.transformFunctions).hueRotate),
    backdropInvert: (0, $jLbDJ.t).propT("--chakra-backdrop-invert", (0, $6eJPF.transformFunctions).invert),
    backdropSaturate: (0, $jLbDJ.t).propT("--chakra-backdrop-saturate", (0, $6eJPF.transformFunctions).saturate)
};

});

parcelRegister("75gEG", function(module, exports) {

$parcel$export(module.exports, "ring", function () { return $4fa3917e909e6aae$export$e7d0da6968da5dd; });

var $jLbDJ = parcelRequire("jLbDJ");

var $6eJPF = parcelRequire("6eJPF");
const $4fa3917e909e6aae$export$e7d0da6968da5dd = {
    ring: {
        transform: (0, $6eJPF.transformFunctions).ring
    },
    ringColor: (0, $jLbDJ.t).colors("--chakra-ring-color"),
    ringOffset: (0, $jLbDJ.t).prop("--chakra-ring-offset-width"),
    ringOffsetColor: (0, $jLbDJ.t).colors("--chakra-ring-offset-color"),
    ringInset: (0, $jLbDJ.t).prop("--chakra-ring-inset")
};

});

parcelRegister("8MDqm", function(module, exports) {

$parcel$export(module.exports, "interactivity", function () { return $23f0ac32fa62f396$export$2499a341a8256d68; });

var $jLbDJ = parcelRequire("jLbDJ");

var $6eJPF = parcelRequire("6eJPF");
const $23f0ac32fa62f396$export$2499a341a8256d68 = {
    appearance: true,
    cursor: true,
    resize: true,
    userSelect: true,
    pointerEvents: true,
    outline: {
        transform: (0, $6eJPF.transformFunctions).outline
    },
    outlineOffset: true,
    outlineColor: (0, $jLbDJ.t).colors("outlineColor")
};

});

parcelRegister("33Uvv", function(module, exports) {

$parcel$export(module.exports, "grid", function () { return $2c2526be6c4e9ac2$export$85fc379452d91af0; });

var $jLbDJ = parcelRequire("jLbDJ");
const $2c2526be6c4e9ac2$export$85fc379452d91af0 = {
    gridGap: (0, $jLbDJ.t).space("gridGap"),
    gridColumnGap: (0, $jLbDJ.t).space("gridColumnGap"),
    gridRowGap: (0, $jLbDJ.t).space("gridRowGap"),
    gridColumn: true,
    gridRow: true,
    gridAutoFlow: true,
    gridAutoColumns: true,
    gridColumnStart: true,
    gridColumnEnd: true,
    gridRowStart: true,
    gridRowEnd: true,
    gridAutoRows: true,
    gridTemplate: true,
    gridTemplateColumns: true,
    gridTemplateRows: true,
    gridTemplateAreas: true,
    gridArea: true
};

});

parcelRegister("g37bq", function(module, exports) {

$parcel$export(module.exports, "others", function () { return $c67ad7536906f220$export$36263e8f8d7ce3b1; });

var $kTMTU = parcelRequire("kTMTU");
const $c67ad7536906f220$var$srOnly = {
    border: "0px",
    clip: "rect(0, 0, 0, 0)",
    width: "1px",
    height: "1px",
    margin: "-1px",
    padding: "0px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    position: "absolute"
};
const $c67ad7536906f220$var$srFocusable = {
    position: "static",
    width: "auto",
    height: "auto",
    clip: "auto",
    padding: "0",
    margin: "0",
    overflow: "visible",
    whiteSpace: "normal"
};
const $c67ad7536906f220$var$getWithPriority = (theme, key, styles)=>{
    const result = {};
    const obj = (0, $kTMTU.memoizedGet)(theme, key, {});
    for(const prop in obj){
        const isInStyles = prop in styles && styles[prop] != null;
        if (!isInStyles) result[prop] = obj[prop];
    }
    return result;
};
const $c67ad7536906f220$export$36263e8f8d7ce3b1 = {
    srOnly: {
        transform (value) {
            if (value === true) return $c67ad7536906f220$var$srOnly;
            if (value === "focusable") return $c67ad7536906f220$var$srFocusable;
            return {};
        }
    },
    layerStyle: {
        processResult: true,
        transform: (value, theme, styles)=>$c67ad7536906f220$var$getWithPriority(theme, `layerStyles.${value}`, styles)
    },
    textStyle: {
        processResult: true,
        transform: (value, theme, styles)=>$c67ad7536906f220$var$getWithPriority(theme, `textStyles.${value}`, styles)
    },
    apply: {
        processResult: true,
        transform: (value, theme, styles)=>$c67ad7536906f220$var$getWithPriority(theme, value, styles)
    }
};

});
parcelRegister("kTMTU", function(module, exports) {

$parcel$export(module.exports, "memoizedGet", function () { return $01f01d643526e78e$export$1bb32d0c65da6059; });
function $01f01d643526e78e$export$3988ae62b71be9a3(obj, path, fallback, index) {
    const key = typeof path === "string" ? path.split(".") : [
        path
    ];
    for(index = 0; index < key.length; index += 1){
        if (!obj) break;
        obj = obj[key[index]];
    }
    return obj === void 0 ? fallback : obj;
}
const $01f01d643526e78e$export$fc10aeed3a532e2a = (fn)=>{
    const cache = /* @__PURE__ */ new WeakMap();
    const memoizedFn = (obj, path, fallback, index)=>{
        if (typeof obj === "undefined") return fn(obj, path, fallback);
        if (!cache.has(obj)) cache.set(obj, /* @__PURE__ */ new Map());
        const map = cache.get(obj);
        if (map.has(path)) return map.get(path);
        const value = fn(obj, path, fallback, index);
        map.set(path, value);
        return value;
    };
    return memoizedFn;
};
const $01f01d643526e78e$export$1bb32d0c65da6059 = $01f01d643526e78e$export$fc10aeed3a532e2a($01f01d643526e78e$export$3988ae62b71be9a3);

});


parcelRegister("4oLqu", function(module, exports) {

$parcel$export(module.exports, "position", function () { return $ebd1858866dddd54$export$5880b8b5730aff45; });

var $jLbDJ = parcelRequire("jLbDJ");
const $ebd1858866dddd54$export$5880b8b5730aff45 = {
    position: true,
    pos: (0, $jLbDJ.t).prop("position"),
    zIndex: (0, $jLbDJ.t).prop("zIndex", "zIndices"),
    inset: (0, $jLbDJ.t).spaceT("inset"),
    insetX: (0, $jLbDJ.t).spaceT([
        "left",
        "right"
    ]),
    insetInline: (0, $jLbDJ.t).spaceT("insetInline"),
    insetY: (0, $jLbDJ.t).spaceT([
        "top",
        "bottom"
    ]),
    insetBlock: (0, $jLbDJ.t).spaceT("insetBlock"),
    top: (0, $jLbDJ.t).spaceT("top"),
    insetBlockStart: (0, $jLbDJ.t).spaceT("insetBlockStart"),
    bottom: (0, $jLbDJ.t).spaceT("bottom"),
    insetBlockEnd: (0, $jLbDJ.t).spaceT("insetBlockEnd"),
    left: (0, $jLbDJ.t).spaceT("left"),
    insetInlineStart: (0, $jLbDJ.t).logical({
        scale: "space",
        property: {
            ltr: "left",
            rtl: "right"
        }
    }),
    right: (0, $jLbDJ.t).spaceT("right"),
    insetInlineEnd: (0, $jLbDJ.t).logical({
        scale: "space",
        property: {
            ltr: "right",
            rtl: "left"
        }
    })
};
Object.assign($ebd1858866dddd54$export$5880b8b5730aff45, {
    insetStart: $ebd1858866dddd54$export$5880b8b5730aff45.insetInlineStart,
    insetEnd: $ebd1858866dddd54$export$5880b8b5730aff45.insetInlineEnd
});

});

parcelRegister("izLro", function(module, exports) {

$parcel$export(module.exports, "effect", function () { return $ae5b00f53c71f43e$export$dc573d8a6576cdb3; });

var $jLbDJ = parcelRequire("jLbDJ");
const $ae5b00f53c71f43e$export$dc573d8a6576cdb3 = {
    boxShadow: (0, $jLbDJ.t).shadows("boxShadow"),
    mixBlendMode: true,
    blendMode: (0, $jLbDJ.t).prop("mixBlendMode"),
    backgroundBlendMode: true,
    bgBlendMode: (0, $jLbDJ.t).prop("backgroundBlendMode"),
    opacity: true
};
Object.assign($ae5b00f53c71f43e$export$dc573d8a6576cdb3, {
    shadow: $ae5b00f53c71f43e$export$dc573d8a6576cdb3.boxShadow
});

});

parcelRegister("k5v9G", function(module, exports) {

$parcel$export(module.exports, "space", function () { return $3ec712d98bc82f2e$export$a941ed4b947d12f8; });

var $jLbDJ = parcelRequire("jLbDJ");
const $3ec712d98bc82f2e$export$a941ed4b947d12f8 = {
    margin: (0, $jLbDJ.t).spaceT("margin"),
    marginTop: (0, $jLbDJ.t).spaceT("marginTop"),
    marginBlockStart: (0, $jLbDJ.t).spaceT("marginBlockStart"),
    marginRight: (0, $jLbDJ.t).spaceT("marginRight"),
    marginInlineEnd: (0, $jLbDJ.t).spaceT("marginInlineEnd"),
    marginBottom: (0, $jLbDJ.t).spaceT("marginBottom"),
    marginBlockEnd: (0, $jLbDJ.t).spaceT("marginBlockEnd"),
    marginLeft: (0, $jLbDJ.t).spaceT("marginLeft"),
    marginInlineStart: (0, $jLbDJ.t).spaceT("marginInlineStart"),
    marginX: (0, $jLbDJ.t).spaceT([
        "marginInlineStart",
        "marginInlineEnd"
    ]),
    marginInline: (0, $jLbDJ.t).spaceT("marginInline"),
    marginY: (0, $jLbDJ.t).spaceT([
        "marginTop",
        "marginBottom"
    ]),
    marginBlock: (0, $jLbDJ.t).spaceT("marginBlock"),
    padding: (0, $jLbDJ.t).space("padding"),
    paddingTop: (0, $jLbDJ.t).space("paddingTop"),
    paddingBlockStart: (0, $jLbDJ.t).space("paddingBlockStart"),
    paddingRight: (0, $jLbDJ.t).space("paddingRight"),
    paddingBottom: (0, $jLbDJ.t).space("paddingBottom"),
    paddingBlockEnd: (0, $jLbDJ.t).space("paddingBlockEnd"),
    paddingLeft: (0, $jLbDJ.t).space("paddingLeft"),
    paddingInlineStart: (0, $jLbDJ.t).space("paddingInlineStart"),
    paddingInlineEnd: (0, $jLbDJ.t).space("paddingInlineEnd"),
    paddingX: (0, $jLbDJ.t).space([
        "paddingInlineStart",
        "paddingInlineEnd"
    ]),
    paddingInline: (0, $jLbDJ.t).space("paddingInline"),
    paddingY: (0, $jLbDJ.t).space([
        "paddingTop",
        "paddingBottom"
    ]),
    paddingBlock: (0, $jLbDJ.t).space("paddingBlock")
};
Object.assign($3ec712d98bc82f2e$export$a941ed4b947d12f8, {
    m: $3ec712d98bc82f2e$export$a941ed4b947d12f8.margin,
    mt: $3ec712d98bc82f2e$export$a941ed4b947d12f8.marginTop,
    mr: $3ec712d98bc82f2e$export$a941ed4b947d12f8.marginRight,
    me: $3ec712d98bc82f2e$export$a941ed4b947d12f8.marginInlineEnd,
    marginEnd: $3ec712d98bc82f2e$export$a941ed4b947d12f8.marginInlineEnd,
    mb: $3ec712d98bc82f2e$export$a941ed4b947d12f8.marginBottom,
    ml: $3ec712d98bc82f2e$export$a941ed4b947d12f8.marginLeft,
    ms: $3ec712d98bc82f2e$export$a941ed4b947d12f8.marginInlineStart,
    marginStart: $3ec712d98bc82f2e$export$a941ed4b947d12f8.marginInlineStart,
    mx: $3ec712d98bc82f2e$export$a941ed4b947d12f8.marginX,
    my: $3ec712d98bc82f2e$export$a941ed4b947d12f8.marginY,
    p: $3ec712d98bc82f2e$export$a941ed4b947d12f8.padding,
    pt: $3ec712d98bc82f2e$export$a941ed4b947d12f8.paddingTop,
    py: $3ec712d98bc82f2e$export$a941ed4b947d12f8.paddingY,
    px: $3ec712d98bc82f2e$export$a941ed4b947d12f8.paddingX,
    pb: $3ec712d98bc82f2e$export$a941ed4b947d12f8.paddingBottom,
    pl: $3ec712d98bc82f2e$export$a941ed4b947d12f8.paddingLeft,
    ps: $3ec712d98bc82f2e$export$a941ed4b947d12f8.paddingInlineStart,
    paddingStart: $3ec712d98bc82f2e$export$a941ed4b947d12f8.paddingInlineStart,
    pr: $3ec712d98bc82f2e$export$a941ed4b947d12f8.paddingRight,
    pe: $3ec712d98bc82f2e$export$a941ed4b947d12f8.paddingInlineEnd,
    paddingEnd: $3ec712d98bc82f2e$export$a941ed4b947d12f8.paddingInlineEnd
});

});

parcelRegister("gGSoD", function(module, exports) {

$parcel$export(module.exports, "scroll", function () { return $dd83ac86a0e99bfa$export$209876d7b1ac8f3; });

var $jLbDJ = parcelRequire("jLbDJ");
const $dd83ac86a0e99bfa$export$209876d7b1ac8f3 = {
    scrollBehavior: true,
    scrollSnapAlign: true,
    scrollSnapStop: true,
    scrollSnapType: true,
    // scroll margin
    scrollMargin: (0, $jLbDJ.t).spaceT("scrollMargin"),
    scrollMarginTop: (0, $jLbDJ.t).spaceT("scrollMarginTop"),
    scrollMarginBottom: (0, $jLbDJ.t).spaceT("scrollMarginBottom"),
    scrollMarginLeft: (0, $jLbDJ.t).spaceT("scrollMarginLeft"),
    scrollMarginRight: (0, $jLbDJ.t).spaceT("scrollMarginRight"),
    scrollMarginX: (0, $jLbDJ.t).spaceT([
        "scrollMarginLeft",
        "scrollMarginRight"
    ]),
    scrollMarginY: (0, $jLbDJ.t).spaceT([
        "scrollMarginTop",
        "scrollMarginBottom"
    ]),
    // scroll padding
    scrollPadding: (0, $jLbDJ.t).spaceT("scrollPadding"),
    scrollPaddingTop: (0, $jLbDJ.t).spaceT("scrollPaddingTop"),
    scrollPaddingBottom: (0, $jLbDJ.t).spaceT("scrollPaddingBottom"),
    scrollPaddingLeft: (0, $jLbDJ.t).spaceT("scrollPaddingLeft"),
    scrollPaddingRight: (0, $jLbDJ.t).spaceT("scrollPaddingRight"),
    scrollPaddingX: (0, $jLbDJ.t).spaceT([
        "scrollPaddingLeft",
        "scrollPaddingRight"
    ]),
    scrollPaddingY: (0, $jLbDJ.t).spaceT([
        "scrollPaddingTop",
        "scrollPaddingBottom"
    ])
};

});

parcelRegister("6j76Z", function(module, exports) {

$parcel$export(module.exports, "typography", function () { return $b53a1e85e6b97e76$export$d846a084e680d8e; });

var $jLbDJ = parcelRequire("jLbDJ");

var $6eJPF = parcelRequire("6eJPF");
const $b53a1e85e6b97e76$export$d846a084e680d8e = {
    fontFamily: (0, $jLbDJ.t).prop("fontFamily", "fonts"),
    fontSize: (0, $jLbDJ.t).prop("fontSize", "fontSizes", (0, $6eJPF.transformFunctions).px),
    fontWeight: (0, $jLbDJ.t).prop("fontWeight", "fontWeights"),
    lineHeight: (0, $jLbDJ.t).prop("lineHeight", "lineHeights"),
    letterSpacing: (0, $jLbDJ.t).prop("letterSpacing", "letterSpacings"),
    textAlign: true,
    fontStyle: true,
    textIndent: true,
    wordBreak: true,
    overflowWrap: true,
    textOverflow: true,
    textTransform: true,
    whiteSpace: true,
    isTruncated: {
        transform (value) {
            if (value === true) return {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
            };
        }
    },
    noOfLines: {
        static: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            //@ts-ignore
            WebkitLineClamp: "var(--chakra-line-clamp)"
        },
        property: "--chakra-line-clamp"
    }
};

});

parcelRegister("2dUgQ", function(module, exports) {

$parcel$export(module.exports, "textDecoration", function () { return $0c49677c33d50bf2$export$6b7f9af9aa033040; });

var $jLbDJ = parcelRequire("jLbDJ");
const $0c49677c33d50bf2$export$6b7f9af9aa033040 = {
    textDecorationColor: (0, $jLbDJ.t).colors("textDecorationColor"),
    textDecoration: true,
    textDecor: {
        property: "textDecoration"
    },
    textDecorationLine: true,
    textDecorationStyle: true,
    textDecorationThickness: true,
    textUnderlineOffset: true,
    textShadow: (0, $jLbDJ.t).shadows("textShadow")
};

});

parcelRegister("geMxb", function(module, exports) {

$parcel$export(module.exports, "transform", function () { return $1d4bd64342722ce4$export$51186ad6e864892a; });

var $jLbDJ = parcelRequire("jLbDJ");

var $6eJPF = parcelRequire("6eJPF");
const $1d4bd64342722ce4$export$51186ad6e864892a = {
    clipPath: true,
    transform: (0, $jLbDJ.t).propT("transform", (0, $6eJPF.transformFunctions).transform),
    transformOrigin: true,
    translateX: (0, $jLbDJ.t).spaceT("--chakra-translate-x"),
    translateY: (0, $jLbDJ.t).spaceT("--chakra-translate-y"),
    skewX: (0, $jLbDJ.t).degreeT("--chakra-skew-x"),
    skewY: (0, $jLbDJ.t).degreeT("--chakra-skew-y"),
    scaleX: (0, $jLbDJ.t).prop("--chakra-scale-x"),
    scaleY: (0, $jLbDJ.t).prop("--chakra-scale-y"),
    scale: (0, $jLbDJ.t).prop([
        "--chakra-scale-x",
        "--chakra-scale-y"
    ]),
    rotate: (0, $jLbDJ.t).degreeT("--chakra-rotate")
};

});

parcelRegister("66a67", function(module, exports) {

$parcel$export(module.exports, "list", function () { return $250e2ddfc6e7797e$export$8837f4fc672e936d; });

var $jLbDJ = parcelRequire("jLbDJ");
const $250e2ddfc6e7797e$export$8837f4fc672e936d = {
    listStyleType: true,
    listStylePosition: true,
    listStylePos: (0, $jLbDJ.t).prop("listStylePosition"),
    listStyleImage: true,
    listStyleImg: (0, $jLbDJ.t).prop("listStyleImage")
};

});

parcelRegister("lismd", function(module, exports) {

$parcel$export(module.exports, "transition", function () { return $27998950fa8f68ff$export$66bb15e2994e6a26; });

var $jLbDJ = parcelRequire("jLbDJ");
const $27998950fa8f68ff$export$66bb15e2994e6a26 = {
    transition: true,
    transitionDelay: true,
    animation: true,
    willChange: true,
    transitionDuration: (0, $jLbDJ.t).prop("transitionDuration", "transition.duration"),
    transitionProperty: (0, $jLbDJ.t).prop("transitionProperty", "transition.property"),
    transitionTimingFunction: (0, $jLbDJ.t).prop("transitionTimingFunction", "transition.easing")
};

});


parcelRegister("4fJZU", function(module, exports) {

$parcel$export(module.exports, "expandResponsive", function () { return $42b13861f7d4101b$export$fc306d944aa46af9; });

var $fZQg5 = parcelRequire("fZQg5");
var $cSr1Y = parcelRequire("cSr1Y");
const $42b13861f7d4101b$export$fc306d944aa46af9 = (styles)=>(theme)=>{
        if (!theme.__breakpoints) return styles;
        const { isResponsive: isResponsive, toArrayValue: toArrayValue, media: medias } = theme.__breakpoints;
        const computedStyles = {};
        for(const key in styles){
            let value = (0, $cSr1Y.runIfFn)(styles[key], theme);
            if (value == null) continue;
            value = (0, $fZQg5.isObject)(value) && isResponsive(value) ? toArrayValue(value) : value;
            if (!Array.isArray(value)) {
                computedStyles[key] = value;
                continue;
            }
            const queries = value.slice(0, medias.length).length;
            for(let index = 0; index < queries; index += 1){
                const media = medias?.[index];
                if (!media) {
                    computedStyles[key] = value[index];
                    continue;
                }
                computedStyles[media] = computedStyles[media] || {};
                if (value[index] == null) continue;
                computedStyles[media][key] = value[index];
            }
        }
        return computedStyles;
    };

});

parcelRegister("kF3Sa", function(module, exports) {

$parcel$export(module.exports, "splitByComma", function () { return $0a7996dc2eb8944b$export$7a009bad0a54bada; });
function $0a7996dc2eb8944b$export$7a009bad0a54bada(value) {
    const chunks = [];
    let chunk = "";
    let inParens = false;
    for(let i = 0; i < value.length; i++){
        const char = value[i];
        if (char === "(") {
            inParens = true;
            chunk += char;
        } else if (char === ")") {
            inParens = false;
            chunk += char;
        } else if (char === "," && !inParens) {
            chunks.push(chunk);
            chunk = "";
        } else chunk += char;
    }
    chunk = chunk.trim();
    if (chunk) chunks.push(chunk);
    return chunks;
}

});


parcelRegister("kUotr", function(module, exports) {

$parcel$export(module.exports, "assignAfter", function () { return $54c28726a667738e$export$1ab078c80230a125; });
function $54c28726a667738e$export$1ab078c80230a125(target, ...sources) {
    if (target == null) throw new TypeError("Cannot convert undefined or null to object");
    const result = {
        ...target
    };
    for (const nextSource of sources){
        if (nextSource == null) continue;
        for(const nextKey in nextSource){
            if (!Object.prototype.hasOwnProperty.call(nextSource, nextKey)) continue;
            if (nextKey in result) delete result[nextKey];
            result[nextKey] = nextSource[nextKey];
        }
    }
    return result;
}

});

parcelRegister("7hYFp", function(module, exports) {

$parcel$export(module.exports, "compact", function () { return $84c224b811d7dcff$export$8e16b83750b44988; });
function $84c224b811d7dcff$export$8e16b83750b44988(object) {
    const clone = Object.assign({}, object);
    for(let key in clone)if (clone[key] === void 0) delete clone[key];
    return clone;
}

});

parcelRegister("fPIPj", function(module, exports) {

$parcel$export(module.exports, "interopDefault", function () { return $e6ef6e77c074786b$export$c77b7fefca3cef07; });
const $e6ef6e77c074786b$export$c77b7fefca3cef07 = (mod)=>mod.default || mod;

});

parcelRegister("2EPVw", function(module, exports) {

$parcel$export(module.exports, "splitProps", function () { return $d3fcbc2b78a3b6cb$export$45029c61b0073d87; });
function $d3fcbc2b78a3b6cb$export$45029c61b0073d87(props, ...keys) {
    const descriptors = Object.getOwnPropertyDescriptors(props);
    const dKeys = Object.keys(descriptors);
    const split = (k)=>{
        const clone = {};
        for(let i = 0; i < k.length; i++){
            const key = k[i];
            if (descriptors[key]) {
                Object.defineProperty(clone, key, descriptors[key]);
                delete descriptors[key];
            }
        }
        return clone;
    };
    const fn = (key)=>split(Array.isArray(key) ? key : dKeys.filter(key));
    return keys.map(fn).concat(split(dKeys));
}

});

parcelRegister("49ayA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3050310923fddc89$export$2e2bcd8739ae039; });

var $jNAWM = parcelRequire("jNAWM");
parcelRequire("2Jgqn");
parcelRequire("8v0nu");
parcelRequire("6YFOF");

parcelRequire("kiVDV");
parcelRequire("5XkEp");
parcelRequire("2kN9K");
var $3050310923fddc89$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $3050310923fddc89$export$2e2bcd8739ae039 = (0, $jNAWM.default).bind();
$3050310923fddc89$var$tags.forEach(function(tagName) {
    $3050310923fddc89$export$2e2bcd8739ae039[tagName] = $3050310923fddc89$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("jNAWM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e69f40d82df1df6e$export$2e2bcd8739ae039; });

var $2Jgqn = parcelRequire("2Jgqn");

var $8v0nu = parcelRequire("8v0nu");

var $6YFOF = parcelRequire("6YFOF");
parcelRequire("6iKRa");
var $FTTp4 = parcelRequire("FTTp4");

var $kiVDV = parcelRequire("kiVDV");

var $5XkEp = parcelRequire("5XkEp");

var $2kN9K = parcelRequire("2kN9K");
/* import type {
  ElementType,
  StatelessFunctionalComponent,
  AbstractComponent
} from 'react' */ /*
export type Interpolations = Array<any>

export type StyledElementType<Props> =
  | string
  | AbstractComponent<{ ...Props, className: string }, mixed>

export type StyledOptions = {
  label?: string,
  shouldForwardProp?: string => boolean,
  target?: string
}

export type StyledComponent<Props> = StatelessFunctionalComponent<Props> & {
  defaultProps: any,
  toString: () => string,
  withComponent: (
    nextTag: StyledElementType<Props>,
    nextOptions?: StyledOptions
  ) => StyledComponent<Props>
}

export type PrivateStyledComponent<Props> = StyledComponent<Props> & {
  __emotion_real: StyledComponent<Props>,
  __emotion_base: any,
  __emotion_styles: any,
  __emotion_forwardProp: any
}
*/ var $e69f40d82df1df6e$var$testOmitPropsOnStringTag = (0, $6YFOF.default);
var $e69f40d82df1df6e$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $e69f40d82df1df6e$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $e69f40d82df1df6e$var$testOmitPropsOnStringTag : $e69f40d82df1df6e$var$testOmitPropsOnComponent;
};
var $e69f40d82df1df6e$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
/*
export type CreateStyledComponent = <Props>(
  ...args: Interpolations
) => StyledComponent<Props>

export type CreateStyled = {
  <Props>(
    tag: StyledElementType<Props>,
    options?: StyledOptions
  ): (...args: Interpolations) => StyledComponent<Props>,
  [key: string]: CreateStyledComponent,
  bind: () => CreateStyled
}
*/ var $e69f40d82df1df6e$var$isDevelopment = false;
var $e69f40d82df1df6e$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $kiVDV.registerStyles)(cache, serialized, isStringTag);
    (0, $2kN9K.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $kiVDV.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $e69f40d82df1df6e$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $e69f40d82df1df6e$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $e69f40d82df1df6e$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    /* return function<Props>(): PrivateStyledComponent<Props> { */ return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        }
        var Styled = (0, $FTTp4.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $8v0nu.useContext((0, $FTTp4.T));
            }
            if (typeof props.className === "string") className = (0, $kiVDV.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $5XkEp.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $e69f40d82df1df6e$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $8v0nu.createElement($8v0nu.Fragment, null, /*#__PURE__*/ $8v0nu.createElement($e69f40d82df1df6e$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $8v0nu.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                if (targetClassName === undefined && $e69f40d82df1df6e$var$isDevelopment) return "NO_COMPONENT_SELECTOR";
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $2Jgqn.default)({}, options, nextOptions, {
                shouldForwardProp: $e69f40d82df1df6e$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("2Jgqn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fcc864778fe3a17$export$2e2bcd8739ae039; });
function $1fcc864778fe3a17$export$2e2bcd8739ae039() {
    return $1fcc864778fe3a17$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1fcc864778fe3a17$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("6YFOF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5148c87bb48179e4$export$2e2bcd8739ae039; });

var $kzEq3 = parcelRequire("kzEq3");
// eslint-disable-next-line no-undef
var $5148c87bb48179e4$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $5148c87bb48179e4$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $kzEq3.default)(function(prop) {
    return $5148c87bb48179e4$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("kzEq3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efa66df610ae0ce8$export$2e2bcd8739ae039; });
function $efa66df610ae0ce8$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("6iKRa", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $4968c539ba80adb3$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $4968c539ba80adb3$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $4968c539ba80adb3$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "jsx", function () { return $4968c539ba80adb3$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("FTTp4")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("FTTp4")).w; });

var $FTTp4 = parcelRequire("FTTp4");

var $8v0nu = parcelRequire("8v0nu");

var $kiVDV = parcelRequire("kiVDV");

var $2kN9K = parcelRequire("2kN9K");

var $5XkEp = parcelRequire("5XkEp");
parcelRequire("2rHYb");
parcelRequire("2Jgqn");
parcelRequire("g5iQV");

parcelRequire("1NGjT");
var $4968c539ba80adb3$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $FTTp4.h).call(props, "css")) return $8v0nu.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $FTTp4.E);
    createElementArgArray[1] = (0, $FTTp4.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $8v0nu.createElement.apply(null, createElementArgArray);
};
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $4968c539ba80adb3$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $FTTp4.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $5XkEp.serializeStyles)([
        styles
    ], undefined, $8v0nu.useContext((0, $FTTp4.T)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $8v0nu.useRef();
    (0, $2kN9K.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $2kN9K.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $kiVDV.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
/* import type { Interpolation, SerializedStyles } from '@emotion/utils' */ function $4968c539ba80adb3$export$dbf350e5966cf602() /*: SerializedStyles */ {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $5XkEp.serializeStyles)(args);
}
/*
type Keyframes = {|
  name: string,
  styles: string,
  anim: 1,
  toString: () => string
|} & string
*/ var $4968c539ba80adb3$export$d25ddfdf17c3ad3e = function /*: Keyframes */ keyframes() {
    var insertable = $4968c539ba80adb3$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
/*
type ClassNameArg =
  | string
  | boolean
  | { [key: string]: boolean }
  | Array<ClassNameArg>
  | null
  | void
*/ var $4968c539ba80adb3$var$classnames = function /*: string */ classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $4968c539ba80adb3$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $kiVDV.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $4968c539ba80adb3$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $2kN9K.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $kiVDV.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
/*
type Props = {
  children: ({
    css: (...args: any) => string,
    cx: (...args: Array<ClassNameArg>) => string,
    theme: Object
  }) => React.Node
} */ var $4968c539ba80adb3$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $FTTp4.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $FTTp4.i)) throw new Error("css can only be used during render");
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $5XkEp.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $kiVDV.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $FTTp4.i)) throw new Error("cx can only be used during render");
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $4968c539ba80adb3$var$merge(cache.registered, css, $4968c539ba80adb3$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $8v0nu.useContext((0, $FTTp4.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $8v0nu.createElement($8v0nu.Fragment, null, /*#__PURE__*/ $8v0nu.createElement($4968c539ba80adb3$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("FTTp4", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $07df2f8e79983cdd$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "C", function () { return $07df2f8e79983cdd$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $07df2f8e79983cdd$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $07df2f8e79983cdd$export$971d5caa766a69d7; });
$parcel$export(module.exports, "a", function () { return $07df2f8e79983cdd$export$407448d2b89b1813; });
$parcel$export(module.exports, "h", function () { return $07df2f8e79983cdd$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $07df2f8e79983cdd$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $07df2f8e79983cdd$export$a9c23c6ac3fc3eca; });

var $8v0nu = parcelRequire("8v0nu");

var $2rHYb = parcelRequire("2rHYb");

var $2Jgqn = parcelRequire("2Jgqn");

var $g5iQV = parcelRequire("g5iQV");

var $MrQZU = parcelRequire("MrQZU");

var $kiVDV = parcelRequire("kiVDV");

var $5XkEp = parcelRequire("5XkEp");

var $2kN9K = parcelRequire("2kN9K");
var $07df2f8e79983cdd$export$23f2a1d2818174ef = false;
/* import { type EmotionCache } from '@emotion/utils' */ var $07df2f8e79983cdd$var$EmotionCacheContext = /* #__PURE__ */ $8v0nu.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $2rHYb.default)({
    key: "css"
}) : null);
var $07df2f8e79983cdd$export$e7094788287c5e9b = $07df2f8e79983cdd$var$EmotionCacheContext.Provider;
var $07df2f8e79983cdd$export$71511d61b312f219 = function useEmotionCache() /*: EmotionCache | null*/ {
    return (0, $8v0nu.useContext)($07df2f8e79983cdd$var$EmotionCacheContext);
};
var $07df2f8e79983cdd$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.AbstractComponent<Props> */ {
    return /*#__PURE__*/ (0, $8v0nu.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $8v0nu.useContext)($07df2f8e79983cdd$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $07df2f8e79983cdd$export$971d5caa766a69d7 = /* #__PURE__ */ $8v0nu.createContext({});
var $07df2f8e79983cdd$export$3b14a55fb2447963 = function useTheme() {
    return $8v0nu.useContext($07df2f8e79983cdd$export$971d5caa766a69d7);
};
var $07df2f8e79983cdd$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $2Jgqn.default)({}, outerTheme, theme);
};
var $07df2f8e79983cdd$var$createCacheWithTheme = /* #__PURE__ */ (0, $g5iQV.default)(function(outerTheme) {
    return (0, $g5iQV.default)(function(theme) {
        return $07df2f8e79983cdd$var$getTheme(outerTheme, theme);
    });
});
/*
type ThemeProviderProps = {
  theme: Object | (Object => Object),
  children: React.Node
}
*/ var $07df2f8e79983cdd$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $8v0nu.useContext($07df2f8e79983cdd$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $07df2f8e79983cdd$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $8v0nu.createElement($07df2f8e79983cdd$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $07df2f8e79983cdd$export$8b22cf2602fb60ce(Component) /*: React.AbstractComponent<$Diff<Config, { theme: Object }>> */ {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $8v0nu.useContext($07df2f8e79983cdd$export$971d5caa766a69d7);
        return /*#__PURE__*/ $8v0nu.createElement(Component, (0, $2Jgqn.default)({
            theme: theme,
            ref: ref
        }, props));
    };
    var WithTheme = /*#__PURE__*/ $8v0nu.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $MrQZU.default)(WithTheme, Component);
}
var $07df2f8e79983cdd$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $07df2f8e79983cdd$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $07df2f8e79983cdd$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($07df2f8e79983cdd$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$07df2f8e79983cdd$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $07df2f8e79983cdd$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $kiVDV.registerStyles)(cache, serialized, isStringTag);
    (0, $2kN9K.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $kiVDV.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $07df2f8e79983cdd$var$Emotion = /* #__PURE__ */ $07df2f8e79983cdd$export$efccba1c4a2ef57b(/* <any, any> */ function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$07df2f8e79983cdd$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $kiVDV.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $5XkEp.serializeStyles)(registeredStyles, undefined, $8v0nu.useContext($07df2f8e79983cdd$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($07df2f8e79983cdd$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $07df2f8e79983cdd$var$typePropName && !$07df2f8e79983cdd$export$23f2a1d2818174ef) newProps[key] = props[key];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $8v0nu.createElement($8v0nu.Fragment, null, /*#__PURE__*/ $8v0nu.createElement($07df2f8e79983cdd$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $8v0nu.createElement(WrappedComponent, newProps));
});
var $07df2f8e79983cdd$export$a9c23c6ac3fc3eca = $07df2f8e79983cdd$var$Emotion;

});
parcelRegister("2rHYb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c8035d6c52d1652$export$2e2bcd8739ae039; });

var $h1mog = parcelRequire("h1mog");

var $lm909 = parcelRequire("lm909");
var $jH0RY = parcelRequire("jH0RY");
var $8XsuG = parcelRequire("8XsuG");
var $ePDAn = parcelRequire("ePDAn");
var $df3Qg = parcelRequire("df3Qg");
var $bdW8v = parcelRequire("bdW8v");
parcelRequire("g5iQV");
parcelRequire("kzEq3");
var $1c8035d6c52d1652$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $lm909.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $lm909.token)(character)) break;
        (0, $lm909.next)();
    }
    return (0, $lm909.slice)(begin, (0, $lm909.position));
};
var $1c8035d6c52d1652$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $lm909.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $lm909.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $1c8035d6c52d1652$var$identifierWithPointTracking((0, $lm909.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $lm909.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $lm909.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $jH0RY.from)(character);
    }
    while (character = (0, $lm909.next)());
    return parsed;
};
var $1c8035d6c52d1652$var$getRules = function getRules(value, points) {
    return (0, $lm909.dealloc)($1c8035d6c52d1652$var$toRules((0, $lm909.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $1c8035d6c52d1652$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $1c8035d6c52d1652$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$1c8035d6c52d1652$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $1c8035d6c52d1652$var$fixedElements.set(element, true);
    var points = [];
    var rules = $1c8035d6c52d1652$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $1c8035d6c52d1652$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
/* eslint-disable no-fallthrough */ function $1c8035d6c52d1652$var$prefix(value, length) {
    switch((0, $jH0RY.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $ePDAn.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $ePDAn.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $ePDAn.WEBKIT) + value + (0, $ePDAn.MOZ) + value + (0, $ePDAn.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $ePDAn.WEBKIT) + value + (0, $ePDAn.MS) + value + value;
        // order
        case 6165:
            return (0, $ePDAn.WEBKIT) + value + (0, $ePDAn.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $ePDAn.WEBKIT) + value + (0, $jH0RY.replace)(value, /(\w+).+(:[^]+)/, (0, $ePDAn.WEBKIT) + "box-$1$2" + (0, $ePDAn.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $ePDAn.WEBKIT) + value + (0, $ePDAn.MS) + "flex-item-" + (0, $jH0RY.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $ePDAn.WEBKIT) + value + (0, $ePDAn.MS) + "flex-line-pack" + (0, $jH0RY.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $ePDAn.WEBKIT) + value + (0, $ePDAn.MS) + (0, $jH0RY.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $ePDAn.WEBKIT) + value + (0, $ePDAn.MS) + (0, $jH0RY.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $ePDAn.WEBKIT) + "box-" + (0, $jH0RY.replace)(value, "-grow", "") + (0, $ePDAn.WEBKIT) + value + (0, $ePDAn.MS) + (0, $jH0RY.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $ePDAn.WEBKIT) + (0, $jH0RY.replace)(value, /([^-])(transform)/g, "$1" + (0, $ePDAn.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $jH0RY.replace)((0, $jH0RY.replace)((0, $jH0RY.replace)(value, /(zoom-|grab)/, (0, $ePDAn.WEBKIT) + "$1"), /(image-set)/, (0, $ePDAn.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $jH0RY.replace)(value, /(image-set\([^]*)/, (0, $ePDAn.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $jH0RY.replace)((0, $jH0RY.replace)(value, /(.+:)(flex-)?(.*)/, (0, $ePDAn.WEBKIT) + "box-pack:$3" + (0, $ePDAn.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $ePDAn.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $jH0RY.replace)(value, /(.+)-inline(.+)/, (0, $ePDAn.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $jH0RY.strlen)(value) - 1 - length > 6) switch((0, $jH0RY.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $jH0RY.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $jH0RY.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $ePDAn.WEBKIT) + "$2-$3" + "$1" + (0, $ePDAn.MOZ) + ((0, $jH0RY.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $jH0RY.indexof)(value, "stretch") ? $1c8035d6c52d1652$var$prefix((0, $jH0RY.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $jH0RY.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $jH0RY.charat)(value, (0, $jH0RY.strlen)(value) - 3 - (~(0, $jH0RY.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $jH0RY.replace)(value, ":", ":" + (0, $ePDAn.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $jH0RY.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $ePDAn.WEBKIT) + ((0, $jH0RY.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $ePDAn.WEBKIT) + "$2$3" + "$1" + (0, $ePDAn.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $jH0RY.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $ePDAn.WEBKIT) + value + (0, $ePDAn.MS) + (0, $jH0RY.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $ePDAn.WEBKIT) + value + (0, $ePDAn.MS) + (0, $jH0RY.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $ePDAn.WEBKIT) + value + (0, $ePDAn.MS) + (0, $jH0RY.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $ePDAn.WEBKIT) + value + (0, $ePDAn.MS) + value + value;
    }
    return value;
}
var $1c8035d6c52d1652$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $ePDAn.DECLARATION:
                element["return"] = $1c8035d6c52d1652$var$prefix(element.value, element.length);
                break;
            case 0, $ePDAn.KEYFRAMES:
                return (0, $bdW8v.serialize)([
                    (0, $lm909.copy)(element, {
                        value: (0, $jH0RY.replace)(element.value, "@", "@" + (0, $ePDAn.WEBKIT))
                    })
                ], callback);
            case 0, $ePDAn.RULESET:
                if (element.length) return (0, $jH0RY.combine)(element.props, function(value) {
                    switch((0, $jH0RY.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $bdW8v.serialize)([
                                (0, $lm909.copy)(element, {
                                    props: [
                                        (0, $jH0RY.replace)(value, /:(read-\w+)/, ":" + (0, $ePDAn.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $bdW8v.serialize)([
                                (0, $lm909.copy)(element, {
                                    props: [
                                        (0, $jH0RY.replace)(value, /:(plac\w+)/, ":" + (0, $ePDAn.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $lm909.copy)(element, {
                                    props: [
                                        (0, $jH0RY.replace)(value, /:(plac\w+)/, ":" + (0, $ePDAn.MOZ) + "$1")
                                    ]
                                }),
                                (0, $lm909.copy)(element, {
                                    props: [
                                        (0, $jH0RY.replace)(value, /:(plac\w+)/, (0, $ePDAn.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $1c8035d6c52d1652$var$defaultStylisPlugins = [
    $1c8035d6c52d1652$var$prefixer
];
var $1c8035d6c52d1652$export$2e2bcd8739ae039 = function /*: EmotionCache */ createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $1c8035d6c52d1652$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    /* : Node */ var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" ");
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    /*: (
  selector: string,
  serialized: SerializedStyles,
  sheet: StyleSheet,
  shouldCache: boolean
  ) => string | void */ var omnipresentPlugins = [
        $1c8035d6c52d1652$var$compat,
        $1c8035d6c52d1652$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $bdW8v.stringify),
        (0, $df3Qg.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $df3Qg.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $bdW8v.serialize)((0, $8XsuG.compile)(styles), serializer);
    };
    _insert = function /*: void */ insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $h1mog.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("h1mog", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $c643e5ed062df6b9$export$9d753cd7ae895cce; });
var $c643e5ed062df6b9$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $c643e5ed062df6b9$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $c643e5ed062df6b9$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $c643e5ed062df6b9$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$c643e5ed062df6b9$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($c643e5ed062df6b9$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $c643e5ed062df6b9$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("lm909", function(module, exports) {

$parcel$export(module.exports, "position", function () { return $f8c2a28b14853b69$export$5880b8b5730aff45; });
$parcel$export(module.exports, "node", function () { return $f8c2a28b14853b69$export$35059013cd4a06db; });
$parcel$export(module.exports, "copy", function () { return $f8c2a28b14853b69$export$784d13d8ee351f07; });
$parcel$export(module.exports, "char", function () { return $f8c2a28b14853b69$export$eba6f6f03b0a92e7; });
$parcel$export(module.exports, "prev", function () { return $f8c2a28b14853b69$export$232faf9add678146; });
$parcel$export(module.exports, "next", function () { return $f8c2a28b14853b69$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $f8c2a28b14853b69$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "caret", function () { return $f8c2a28b14853b69$export$e88cb2efb12ae807; });
$parcel$export(module.exports, "slice", function () { return $f8c2a28b14853b69$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $f8c2a28b14853b69$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $f8c2a28b14853b69$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $f8c2a28b14853b69$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $f8c2a28b14853b69$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "tokenize", function () { return $f8c2a28b14853b69$export$660b2ee2d4fb4eff; });
$parcel$export(module.exports, "whitespace", function () { return $f8c2a28b14853b69$export$7af1228ff777d175; });
$parcel$export(module.exports, "identifier", function () { return $f8c2a28b14853b69$export$c2ab62c7bf24634; });
$parcel$export(module.exports, "escaping", function () { return $f8c2a28b14853b69$export$955ba06d119e085e; });
$parcel$export(module.exports, "commenter", function () { return $f8c2a28b14853b69$export$4254d4e2b3745c4c; });

var $jH0RY = parcelRequire("jH0RY");
var $f8c2a28b14853b69$export$53f1d5ea8de3d7c = 1;
var $f8c2a28b14853b69$export$4e0c71f277ca26b3 = 1;
var $f8c2a28b14853b69$export$f24224f1c91d8156 = 0;
var $f8c2a28b14853b69$export$5880b8b5730aff45 = 0;
var $f8c2a28b14853b69$export$c0306caf338ac095 = 0;
var $f8c2a28b14853b69$export$30a86d91af8ff6e6 = "";
function $f8c2a28b14853b69$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $f8c2a28b14853b69$export$53f1d5ea8de3d7c,
        column: $f8c2a28b14853b69$export$4e0c71f277ca26b3,
        length: length,
        return: ""
    };
}
function $f8c2a28b14853b69$export$784d13d8ee351f07(root, props) {
    return (0, $jH0RY.assign)($f8c2a28b14853b69$export$35059013cd4a06db("", null, null, "", null, null, 0), root, {
        length: -root.length
    }, props);
}
function $f8c2a28b14853b69$export$eba6f6f03b0a92e7() {
    return $f8c2a28b14853b69$export$c0306caf338ac095;
}
function $f8c2a28b14853b69$export$232faf9add678146() {
    $f8c2a28b14853b69$export$c0306caf338ac095 = $f8c2a28b14853b69$export$5880b8b5730aff45 > 0 ? (0, $jH0RY.charat)($f8c2a28b14853b69$export$30a86d91af8ff6e6, --$f8c2a28b14853b69$export$5880b8b5730aff45) : 0;
    if ($f8c2a28b14853b69$export$4e0c71f277ca26b3--, $f8c2a28b14853b69$export$c0306caf338ac095 === 10) $f8c2a28b14853b69$export$4e0c71f277ca26b3 = 1, $f8c2a28b14853b69$export$53f1d5ea8de3d7c--;
    return $f8c2a28b14853b69$export$c0306caf338ac095;
}
function $f8c2a28b14853b69$export$48cfd1e771a65c4f() {
    $f8c2a28b14853b69$export$c0306caf338ac095 = $f8c2a28b14853b69$export$5880b8b5730aff45 < $f8c2a28b14853b69$export$f24224f1c91d8156 ? (0, $jH0RY.charat)($f8c2a28b14853b69$export$30a86d91af8ff6e6, $f8c2a28b14853b69$export$5880b8b5730aff45++) : 0;
    if ($f8c2a28b14853b69$export$4e0c71f277ca26b3++, $f8c2a28b14853b69$export$c0306caf338ac095 === 10) $f8c2a28b14853b69$export$4e0c71f277ca26b3 = 1, $f8c2a28b14853b69$export$53f1d5ea8de3d7c++;
    return $f8c2a28b14853b69$export$c0306caf338ac095;
}
function $f8c2a28b14853b69$export$4d3fb11e950abb9e() {
    return (0, $jH0RY.charat)($f8c2a28b14853b69$export$30a86d91af8ff6e6, $f8c2a28b14853b69$export$5880b8b5730aff45);
}
function $f8c2a28b14853b69$export$e88cb2efb12ae807() {
    return $f8c2a28b14853b69$export$5880b8b5730aff45;
}
function $f8c2a28b14853b69$export$58adb3bec8346d0f(begin, end) {
    return (0, $jH0RY.substr)($f8c2a28b14853b69$export$30a86d91af8ff6e6, begin, end);
}
function $f8c2a28b14853b69$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $f8c2a28b14853b69$export$2de70f21292aac9e(value) {
    return $f8c2a28b14853b69$export$53f1d5ea8de3d7c = $f8c2a28b14853b69$export$4e0c71f277ca26b3 = 1, $f8c2a28b14853b69$export$f24224f1c91d8156 = (0, $jH0RY.strlen)($f8c2a28b14853b69$export$30a86d91af8ff6e6 = value), $f8c2a28b14853b69$export$5880b8b5730aff45 = 0, [];
}
function $f8c2a28b14853b69$export$45918ac1574455b1(value) {
    return $f8c2a28b14853b69$export$30a86d91af8ff6e6 = "", value;
}
function $f8c2a28b14853b69$export$410ac95b9ec204b8(type) {
    return (0, $jH0RY.trim)($f8c2a28b14853b69$export$58adb3bec8346d0f($f8c2a28b14853b69$export$5880b8b5730aff45 - 1, $f8c2a28b14853b69$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $f8c2a28b14853b69$export$660b2ee2d4fb4eff(value) {
    return $f8c2a28b14853b69$export$45918ac1574455b1($f8c2a28b14853b69$export$5f8c09e3ae6f64e1($f8c2a28b14853b69$export$2de70f21292aac9e(value)));
}
function $f8c2a28b14853b69$export$7af1228ff777d175(type) {
    while($f8c2a28b14853b69$export$c0306caf338ac095 = $f8c2a28b14853b69$export$4d3fb11e950abb9e())if ($f8c2a28b14853b69$export$c0306caf338ac095 < 33) $f8c2a28b14853b69$export$48cfd1e771a65c4f();
    else break;
    return $f8c2a28b14853b69$export$9e1725a4cfeada27(type) > 2 || $f8c2a28b14853b69$export$9e1725a4cfeada27($f8c2a28b14853b69$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $f8c2a28b14853b69$export$5f8c09e3ae6f64e1(children) {
    while($f8c2a28b14853b69$export$48cfd1e771a65c4f())switch($f8c2a28b14853b69$export$9e1725a4cfeada27($f8c2a28b14853b69$export$c0306caf338ac095)){
        case 0:
            (0, $jH0RY.append)($f8c2a28b14853b69$export$c2ab62c7bf24634($f8c2a28b14853b69$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $jH0RY.append)($f8c2a28b14853b69$export$410ac95b9ec204b8($f8c2a28b14853b69$export$c0306caf338ac095), children);
            break;
        default:
            (0, $jH0RY.append)((0, $jH0RY.from)($f8c2a28b14853b69$export$c0306caf338ac095), children);
    }
    return children;
}
function $f8c2a28b14853b69$export$955ba06d119e085e(index, count) {
    while(--count && $f8c2a28b14853b69$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($f8c2a28b14853b69$export$c0306caf338ac095 < 48 || $f8c2a28b14853b69$export$c0306caf338ac095 > 102 || $f8c2a28b14853b69$export$c0306caf338ac095 > 57 && $f8c2a28b14853b69$export$c0306caf338ac095 < 65 || $f8c2a28b14853b69$export$c0306caf338ac095 > 70 && $f8c2a28b14853b69$export$c0306caf338ac095 < 97) break;
    return $f8c2a28b14853b69$export$58adb3bec8346d0f(index, $f8c2a28b14853b69$export$e88cb2efb12ae807() + (count < 6 && $f8c2a28b14853b69$export$4d3fb11e950abb9e() == 32 && $f8c2a28b14853b69$export$48cfd1e771a65c4f() == 32));
}
function $f8c2a28b14853b69$export$c889f2fcc19dbf12(type) {
    while($f8c2a28b14853b69$export$48cfd1e771a65c4f())switch($f8c2a28b14853b69$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $f8c2a28b14853b69$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $f8c2a28b14853b69$export$c889f2fcc19dbf12($f8c2a28b14853b69$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $f8c2a28b14853b69$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $f8c2a28b14853b69$export$48cfd1e771a65c4f();
            break;
    }
    return $f8c2a28b14853b69$export$5880b8b5730aff45;
}
function $f8c2a28b14853b69$export$4254d4e2b3745c4c(type, index) {
    while($f8c2a28b14853b69$export$48cfd1e771a65c4f())// //
    if (type + $f8c2a28b14853b69$export$c0306caf338ac095 === 57) break;
    else if (type + $f8c2a28b14853b69$export$c0306caf338ac095 === 84 && $f8c2a28b14853b69$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $f8c2a28b14853b69$export$58adb3bec8346d0f(index, $f8c2a28b14853b69$export$5880b8b5730aff45 - 1) + "*" + (0, $jH0RY.from)(type === 47 ? type : $f8c2a28b14853b69$export$48cfd1e771a65c4f());
}
function $f8c2a28b14853b69$export$c2ab62c7bf24634(index) {
    while(!$f8c2a28b14853b69$export$9e1725a4cfeada27($f8c2a28b14853b69$export$4d3fb11e950abb9e()))$f8c2a28b14853b69$export$48cfd1e771a65c4f();
    return $f8c2a28b14853b69$export$58adb3bec8346d0f(index, $f8c2a28b14853b69$export$5880b8b5730aff45);
}

});
parcelRegister("jH0RY", function(module, exports) {

$parcel$export(module.exports, "abs", function () { return $e562b52475b1e492$export$2335f513bbd82c6d; });
$parcel$export(module.exports, "from", function () { return $e562b52475b1e492$export$6788812c4e6611e6; });
$parcel$export(module.exports, "assign", function () { return $e562b52475b1e492$export$e6e34fd1f2686227; });
$parcel$export(module.exports, "hash", function () { return $e562b52475b1e492$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $e562b52475b1e492$export$a9db5e087081082d; });
$parcel$export(module.exports, "trim", function () { return $e562b52475b1e492$export$87c2784dc9fc4ab; });
$parcel$export(module.exports, "match", function () { return $e562b52475b1e492$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $e562b52475b1e492$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $e562b52475b1e492$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "substr", function () { return $e562b52475b1e492$export$2f35ab04d2335697; });
$parcel$export(module.exports, "strlen", function () { return $e562b52475b1e492$export$36776f635604f274; });
$parcel$export(module.exports, "sizeof", function () { return $e562b52475b1e492$export$f9084667e487ed46; });
$parcel$export(module.exports, "append", function () { return $e562b52475b1e492$export$10d8903dec122b9d; });
$parcel$export(module.exports, "combine", function () { return $e562b52475b1e492$export$1be1fc439b849fdf; });
/**
 * @param {number}
 * @return {number}
 */ var $e562b52475b1e492$export$2335f513bbd82c6d = Math.abs;
var $e562b52475b1e492$export$6788812c4e6611e6 = String.fromCharCode;
var $e562b52475b1e492$export$e6e34fd1f2686227 = Object.assign;
function $e562b52475b1e492$export$d6af199866bfb566(value, length) {
    return $e562b52475b1e492$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $e562b52475b1e492$export$a9db5e087081082d(value, 0)) << 2 ^ $e562b52475b1e492$export$a9db5e087081082d(value, 1)) << 2 ^ $e562b52475b1e492$export$a9db5e087081082d(value, 2)) << 2 ^ $e562b52475b1e492$export$a9db5e087081082d(value, 3) : 0;
}
function $e562b52475b1e492$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $e562b52475b1e492$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $e562b52475b1e492$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $e562b52475b1e492$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $e562b52475b1e492$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $e562b52475b1e492$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $e562b52475b1e492$export$36776f635604f274(value) {
    return value.length;
}
function $e562b52475b1e492$export$f9084667e487ed46(value) {
    return value.length;
}
function $e562b52475b1e492$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $e562b52475b1e492$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join("");
}

});


parcelRegister("8XsuG", function(module, exports) {

$parcel$export(module.exports, "compile", function () { return $6859efbb8a2fab01$export$ef7acd7185315e22; });

var $ePDAn = parcelRequire("ePDAn");

var $jH0RY = parcelRequire("jH0RY");

var $lm909 = parcelRequire("lm909");
function $6859efbb8a2fab01$export$ef7acd7185315e22(value) {
    return (0, $lm909.dealloc)($6859efbb8a2fab01$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], value = (0, $lm909.alloc)(value), 0, [
        0
    ], value));
}
function $6859efbb8a2fab01$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = "";
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $lm909.next)()){
        // (
        case 40:
            if (previous != 108 && (0, $jH0RY.charat)(characters, length - 1) == 58) {
                if ((0, $jH0RY.indexof)(characters += (0, $jH0RY.replace)((0, $lm909.delimit)(character), "&", "&\f"), "&\f") != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $lm909.delimit)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $lm909.whitespace)(previous);
            break;
        // \
        case 92:
            characters += (0, $lm909.escaping)((0, $lm909.caret)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $lm909.peek)()){
                case 42:
                case 47:
                    (0, $jH0RY.append)($6859efbb8a2fab01$export$4a34f930e789283c((0, $lm909.commenter)((0, $lm909.next)(), (0, $lm909.caret)()), root, parent), declarations);
                    break;
                default:
                    characters += "/";
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $jH0RY.strlen)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $jH0RY.replace)(characters, /\f/g, "");
                    if (property > 0 && (0, $jH0RY.strlen)(characters) - length) (0, $jH0RY.append)(property > 32 ? $6859efbb8a2fab01$export$f8483753829ec8f3(characters + ";", rule, parent, length - 1) : $6859efbb8a2fab01$export$f8483753829ec8f3((0, $jH0RY.replace)(characters, " ", "") + ";", rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ";";
                // { rule/at-rule
                default:
                    (0, $jH0RY.append)(reference = $6859efbb8a2fab01$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $6859efbb8a2fab01$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $jH0RY.charat)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $6859efbb8a2fab01$export$98e6a39c04603d36(value, reference, reference, rule && (0, $jH0RY.append)($6859efbb8a2fab01$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $6859efbb8a2fab01$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ""
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = "", length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $jH0RY.strlen)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $lm909.prev)() == 125) continue;
            }
            switch(characters += (0, $jH0RY.from)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += "\f", -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $jH0RY.strlen)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $lm909.peek)() === 45) characters += (0, $lm909.delimit)((0, $lm909.next)());
                    atrule = (0, $lm909.peek)(), offset = length = (0, $jH0RY.strlen)(type = characters += (0, $lm909.identifier)((0, $lm909.caret)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $jH0RY.strlen)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $6859efbb8a2fab01$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ""
    ];
    var size = (0, $jH0RY.sizeof)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $jH0RY.substr)(value, post + 1, post = (0, $jH0RY.abs)(j = points[i])), z = value; x < size; ++x)if (z = (0, $jH0RY.trim)(j > 0 ? rule[x] + " " + y : (0, $jH0RY.replace)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $lm909.node)(value, root, parent, offset === 0 ? (0, $ePDAn.RULESET) : type, props, children, length);
}
function $6859efbb8a2fab01$export$4a34f930e789283c(value, root, parent) {
    return (0, $lm909.node)(value, root, parent, (0, $ePDAn.COMMENT), (0, $jH0RY.from)((0, $lm909.char)()), (0, $jH0RY.substr)(value, 2, -2), 0);
}
function $6859efbb8a2fab01$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $lm909.node)(value, root, parent, (0, $ePDAn.DECLARATION), (0, $jH0RY.substr)(value, 0, length), (0, $jH0RY.substr)(value, length + 1, -1), length);
}

});
parcelRegister("ePDAn", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $acc489014c5872c4$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $acc489014c5872c4$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $acc489014c5872c4$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "COMMENT", function () { return $acc489014c5872c4$export$a29989082612d0d9; });
$parcel$export(module.exports, "RULESET", function () { return $acc489014c5872c4$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $acc489014c5872c4$export$527d108ccf083c2b; });
$parcel$export(module.exports, "IMPORT", function () { return $acc489014c5872c4$export$a763edbf796b780a; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $acc489014c5872c4$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "LAYER", function () { return $acc489014c5872c4$export$d773506282b3cfe6; });
var $acc489014c5872c4$export$71ad59f2e432cfe8 = "-ms-";
var $acc489014c5872c4$export$2c0f367103c8d01c = "-moz-";
var $acc489014c5872c4$export$39dfd62a25e0fe93 = "-webkit-";
var $acc489014c5872c4$export$a29989082612d0d9 = "comm";
var $acc489014c5872c4$export$aa3a2e812ca8570d = "rule";
var $acc489014c5872c4$export$527d108ccf083c2b = "decl";
var $acc489014c5872c4$export$d3d35020fa5b54f0 = "@page";
var $acc489014c5872c4$export$500415a86c544f73 = "@media";
var $acc489014c5872c4$export$a763edbf796b780a = "@import";
var $acc489014c5872c4$export$2790aeb8b4e5c826 = "@charset";
var $acc489014c5872c4$export$1cc683e23b84b133 = "@viewport";
var $acc489014c5872c4$export$9447a5efea57e862 = "@supports";
var $acc489014c5872c4$export$ef011b4e114b1fba = "@document";
var $acc489014c5872c4$export$6aad947bda0f3f46 = "@namespace";
var $acc489014c5872c4$export$b44a8529a35fcb60 = "@keyframes";
var $acc489014c5872c4$export$2c16de31893252e6 = "@font-face";
var $acc489014c5872c4$export$3d846dd52e150c6f = "@counter-style";
var $acc489014c5872c4$export$22314bfbb57653fe = "@font-feature-values";
var $acc489014c5872c4$export$d773506282b3cfe6 = "@layer";

});


parcelRegister("df3Qg", function(module, exports) {

$parcel$export(module.exports, "middleware", function () { return $9a3fa8006b78417a$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $9a3fa8006b78417a$export$38bcb760f1d4871c; });

var $ePDAn = parcelRequire("ePDAn");

var $jH0RY = parcelRequire("jH0RY");

var $lm909 = parcelRequire("lm909");

var $bdW8v = parcelRequire("bdW8v");

var $bnbHL = parcelRequire("bnbHL");
function $9a3fa8006b78417a$export$5a7767152ae0305f(collection) {
    var length = (0, $jH0RY.sizeof)(collection);
    return function(element, index, children, callback) {
        var output = "";
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || "";
        return output;
    };
}
function $9a3fa8006b78417a$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $9a3fa8006b78417a$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $ePDAn.DECLARATION:
                element.return = (0, $bnbHL.prefix)(element.value, element.length, children);
                return;
            case 0, $ePDAn.KEYFRAMES:
                return (0, $bdW8v.serialize)([
                    (0, $lm909.copy)(element, {
                        value: (0, $jH0RY.replace)(element.value, "@", "@" + (0, $ePDAn.WEBKIT))
                    })
                ], callback);
            case 0, $ePDAn.RULESET:
                if (element.length) return (0, $jH0RY.combine)(element.props, function(value) {
                    switch((0, $jH0RY.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $bdW8v.serialize)([
                                (0, $lm909.copy)(element, {
                                    props: [
                                        (0, $jH0RY.replace)(value, /:(read-\w+)/, ":" + (0, $ePDAn.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $bdW8v.serialize)([
                                (0, $lm909.copy)(element, {
                                    props: [
                                        (0, $jH0RY.replace)(value, /:(plac\w+)/, ":" + (0, $ePDAn.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $lm909.copy)(element, {
                                    props: [
                                        (0, $jH0RY.replace)(value, /:(plac\w+)/, ":" + (0, $ePDAn.MOZ) + "$1")
                                    ]
                                }),
                                (0, $lm909.copy)(element, {
                                    props: [
                                        (0, $jH0RY.replace)(value, /:(plac\w+)/, (0, $ePDAn.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
}
function $9a3fa8006b78417a$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $ePDAn.RULESET:
            element.props = element.props.map(function(value) {
                return (0, $jH0RY.combine)((0, $lm909.tokenize)(value), function(value, index, children) {
                    switch((0, $jH0RY.charat)(value, 0)){
                        // \f
                        case 12:
                            return (0, $jH0RY.substr)(value, 1, (0, $jH0RY.strlen)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === "global") children[index] = "", children[++index] = "\f" + (0, $jH0RY.substr)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? "" : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $jH0RY.sizeof)(children) > 1 ? "" : value;
                                case index = (0, $jH0RY.sizeof)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}

});
parcelRegister("bdW8v", function(module, exports) {

$parcel$export(module.exports, "serialize", function () { return $82be013fdc68c24d$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $82be013fdc68c24d$export$fac44ee5b035f737; });

var $ePDAn = parcelRequire("ePDAn");

var $jH0RY = parcelRequire("jH0RY");
function $82be013fdc68c24d$export$dfdc1655ccc5b9cb(children, callback) {
    var output = "";
    var length = (0, $jH0RY.sizeof)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || "";
    return output;
}
function $82be013fdc68c24d$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $ePDAn.LAYER:
            if (element.children.length) break;
        case 0, $ePDAn.IMPORT:
        case 0, $ePDAn.DECLARATION:
            return element.return = element.return || element.value;
        case 0, $ePDAn.COMMENT:
            return "";
        case 0, $ePDAn.KEYFRAMES:
            return element.return = element.value + "{" + $82be013fdc68c24d$export$dfdc1655ccc5b9cb(element.children, callback) + "}";
        case 0, $ePDAn.RULESET:
            element.value = element.props.join(",");
    }
    return (0, $jH0RY.strlen)(children = $82be013fdc68c24d$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + "{" + children + "}" : "";
}

});

parcelRegister("bnbHL", function(module, exports) {

$parcel$export(module.exports, "prefix", function () { return $847aec06bd93db01$export$82e9f45cca5ba907; });

var $ePDAn = parcelRequire("ePDAn");

var $jH0RY = parcelRequire("jH0RY");
function $847aec06bd93db01$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $jH0RY.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $ePDAn.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $ePDAn.WEBKIT) + value + value;
        // tab-size
        case 4789:
            return (0, $ePDAn.MOZ) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $ePDAn.WEBKIT) + value + (0, $ePDAn.MOZ) + value + (0, $ePDAn.MS) + value + value;
        // writing-mode
        case 5936:
            switch((0, $jH0RY.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $ePDAn.WEBKIT) + value + (0, $ePDAn.MS) + (0, $jH0RY.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $ePDAn.WEBKIT) + value + (0, $ePDAn.MS) + (0, $jH0RY.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $ePDAn.WEBKIT) + value + (0, $ePDAn.MS) + (0, $jH0RY.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $ePDAn.WEBKIT) + value + (0, $ePDAn.MS) + value + value;
        // order
        case 6165:
            return (0, $ePDAn.WEBKIT) + value + (0, $ePDAn.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $ePDAn.WEBKIT) + value + (0, $jH0RY.replace)(value, /(\w+).+(:[^]+)/, (0, $ePDAn.WEBKIT) + "box-$1$2" + (0, $ePDAn.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $ePDAn.WEBKIT) + value + (0, $ePDAn.MS) + "flex-item-" + (0, $jH0RY.replace)(value, /flex-|-self/g, "") + (!(0, $jH0RY.match)(value, /flex-|baseline/) ? (0, $ePDAn.MS) + "grid-row-" + (0, $jH0RY.replace)(value, /flex-|-self/g, "") : "") + value;
        // align-content
        case 4675:
            return (0, $ePDAn.WEBKIT) + value + (0, $ePDAn.MS) + "flex-line-pack" + (0, $jH0RY.replace)(value, /align-content|flex-|-self/g, "") + value;
        // flex-shrink
        case 5548:
            return (0, $ePDAn.WEBKIT) + value + (0, $ePDAn.MS) + (0, $jH0RY.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $ePDAn.WEBKIT) + value + (0, $ePDAn.MS) + (0, $jH0RY.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $ePDAn.WEBKIT) + "box-" + (0, $jH0RY.replace)(value, "-grow", "") + (0, $ePDAn.WEBKIT) + value + (0, $ePDAn.MS) + (0, $jH0RY.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $ePDAn.WEBKIT) + (0, $jH0RY.replace)(value, /([^-])(transform)/g, "$1" + (0, $ePDAn.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $jH0RY.replace)((0, $jH0RY.replace)((0, $jH0RY.replace)(value, /(zoom-|grab)/, (0, $ePDAn.WEBKIT) + "$1"), /(image-set)/, (0, $ePDAn.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $jH0RY.replace)(value, /(image-set\([^]*)/, (0, $ePDAn.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $jH0RY.replace)((0, $jH0RY.replace)(value, /(.+:)(flex-)?(.*)/, (0, $ePDAn.WEBKIT) + "box-pack:$3" + (0, $ePDAn.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $ePDAn.WEBKIT) + value + value;
        // justify-self
        case 4200:
            if (!(0, $jH0RY.match)(value, /flex-|baseline/)) return (0, $ePDAn.MS) + "grid-column-align" + (0, $jH0RY.substr)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $ePDAn.MS) + (0, $jH0RY.replace)(value, "template-", "") + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $jH0RY.match)(element.props, /grid-\w+-end/);
            })) return ~(0, $jH0RY.indexof)(value + (children = children[length].value), "span") ? value : (0, $ePDAn.MS) + (0, $jH0RY.replace)(value, "-start", "") + value + (0, $ePDAn.MS) + "grid-row-span:" + (~(0, $jH0RY.indexof)(children, "span") ? (0, $jH0RY.match)(children, /\d+/) : +(0, $jH0RY.match)(children, /\d+/) - +(0, $jH0RY.match)(value, /\d+/)) + ";";
            return (0, $ePDAn.MS) + (0, $jH0RY.replace)(value, "-start", "") + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $jH0RY.match)(element.props, /grid-\w+-start/);
            }) ? value : (0, $ePDAn.MS) + (0, $jH0RY.replace)((0, $jH0RY.replace)(value, "-end", "-span"), "span ", "") + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $jH0RY.replace)(value, /(.+)-inline(.+)/, (0, $ePDAn.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $jH0RY.strlen)(value) - 1 - length > 6) switch((0, $jH0RY.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $jH0RY.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $jH0RY.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $ePDAn.WEBKIT) + "$2-$3" + "$1" + (0, $ePDAn.MOZ) + ((0, $jH0RY.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $jH0RY.indexof)(value, "stretch") ? $847aec06bd93db01$export$82e9f45cca5ba907((0, $jH0RY.replace)(value, "stretch", "fill-available"), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $jH0RY.replace)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $ePDAn.MS) + a + ":" + b + f + (c ? (0, $ePDAn.MS) + a + "-span:" + (d ? e : +e - +b) + f : "") + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $jH0RY.charat)(value, length + 6) === 121) return (0, $jH0RY.replace)(value, ":", ":" + (0, $ePDAn.WEBKIT)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $jH0RY.charat)(value, (0, $jH0RY.charat)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $jH0RY.replace)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + (0, $ePDAn.WEBKIT) + ((0, $jH0RY.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $ePDAn.WEBKIT) + "$2$3" + "$1" + (0, $ePDAn.MS) + "$2box$3") + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $jH0RY.replace)(value, ":", ":" + (0, $ePDAn.MS)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $jH0RY.replace)(value, "scroll-", "scroll-snap-") + value;
    }
    return value;
}

});


parcelRegister("g5iQV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb5bbcb52531674b$export$2e2bcd8739ae039; });
var $bb5bbcb52531674b$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});


parcelRegister("MrQZU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $091a16fe69851125$export$2e2bcd8739ae039; });

var $1NGjT = parcelRequire("1NGjT");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $091a16fe69851125$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1NGjT)))(targetComponent, sourceComponent);
};

});
parcelRegister("1NGjT", function(module, exports) {
"use strict";

var $kdNdg = parcelRequire("kdNdg");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $14fb31dfeed2b451$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $14fb31dfeed2b451$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $14fb31dfeed2b451$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $14fb31dfeed2b451$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $14fb31dfeed2b451$var$TYPE_STATICS = {};
$14fb31dfeed2b451$var$TYPE_STATICS[$kdNdg.ForwardRef] = $14fb31dfeed2b451$var$FORWARD_REF_STATICS;
$14fb31dfeed2b451$var$TYPE_STATICS[$kdNdg.Memo] = $14fb31dfeed2b451$var$MEMO_STATICS;
function $14fb31dfeed2b451$var$getStatics(component) {
    // React v16.11 and below
    if ($kdNdg.isMemo(component)) return $14fb31dfeed2b451$var$MEMO_STATICS;
     // React v16.12 and above
    return $14fb31dfeed2b451$var$TYPE_STATICS[component["$$typeof"]] || $14fb31dfeed2b451$var$REACT_STATICS;
}
var $14fb31dfeed2b451$var$defineProperty = Object.defineProperty;
var $14fb31dfeed2b451$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $14fb31dfeed2b451$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $14fb31dfeed2b451$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $14fb31dfeed2b451$var$getPrototypeOf = Object.getPrototypeOf;
var $14fb31dfeed2b451$var$objectPrototype = Object.prototype;
function $14fb31dfeed2b451$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($14fb31dfeed2b451$var$objectPrototype) {
            var inheritedComponent = $14fb31dfeed2b451$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $14fb31dfeed2b451$var$objectPrototype) $14fb31dfeed2b451$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $14fb31dfeed2b451$var$getOwnPropertyNames(sourceComponent);
        if ($14fb31dfeed2b451$var$getOwnPropertySymbols) keys = keys.concat($14fb31dfeed2b451$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $14fb31dfeed2b451$var$getStatics(targetComponent);
        var sourceStatics = $14fb31dfeed2b451$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$14fb31dfeed2b451$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $14fb31dfeed2b451$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $14fb31dfeed2b451$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $14fb31dfeed2b451$var$hoistNonReactStatics;

});
parcelRegister("kdNdg", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1yZH7"));

});



parcelRegister("kiVDV", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $ec8233c4b7481c30$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $ec8233c4b7481c30$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $ec8233c4b7481c30$export$6f077d94b33a01aa; });
var $ec8233c4b7481c30$var$isBrowser = true;
function $ec8233c4b7481c30$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $ec8233c4b7481c30$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $ec8233c4b7481c30$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $ec8233c4b7481c30$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $ec8233c4b7481c30$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("5XkEp", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $45627b3f8cf327d3$export$6321afa313b251b5; });

var $laHCk = parcelRequire("laHCk");

var $lThqe = parcelRequire("lThqe");

var $kzEq3 = parcelRequire("kzEq3");
var $45627b3f8cf327d3$var$isDevelopment = false;
var $45627b3f8cf327d3$var$hyphenateRegex = /[A-Z]|^ms/g;
var $45627b3f8cf327d3$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $45627b3f8cf327d3$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $45627b3f8cf327d3$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $45627b3f8cf327d3$var$processStyleName = /* #__PURE__ */ (0, $kzEq3.default)(function(styleName) {
    return $45627b3f8cf327d3$var$isCustomProperty(styleName) ? styleName : styleName.replace($45627b3f8cf327d3$var$hyphenateRegex, "-$&").toLowerCase();
});
var $45627b3f8cf327d3$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($45627b3f8cf327d3$var$animationRegex, function(match, p1, p2) {
                $45627b3f8cf327d3$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $45627b3f8cf327d3$var$cursor
                };
                return p1;
            });
    }
    if ((0, $lThqe.default)[key] !== 1 && !$45627b3f8cf327d3$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $45627b3f8cf327d3$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $45627b3f8cf327d3$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $45627b3f8cf327d3$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $45627b3f8cf327d3$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $45627b3f8cf327d3$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $45627b3f8cf327d3$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $45627b3f8cf327d3$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $45627b3f8cf327d3$var$cursor;
                var result = interpolation(mergedProps);
                $45627b3f8cf327d3$var$cursor = previousCursor;
                return $45627b3f8cf327d3$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $45627b3f8cf327d3$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $45627b3f8cf327d3$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== "object") {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($45627b3f8cf327d3$var$isProcessableValue(asString)) string += $45627b3f8cf327d3$var$processStyleName(key) + ":" + $45627b3f8cf327d3$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === "NO_COMPONENT_SELECTOR" && $45627b3f8cf327d3$var$isDevelopment) throw new Error($45627b3f8cf327d3$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($45627b3f8cf327d3$var$isProcessableValue(value[_i])) string += $45627b3f8cf327d3$var$processStyleName(key) + ":" + $45627b3f8cf327d3$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $45627b3f8cf327d3$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case "animation":
                    case "animationName":
                        string += $45627b3f8cf327d3$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $45627b3f8cf327d3$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list
var $45627b3f8cf327d3$var$cursor;
function $45627b3f8cf327d3$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $45627b3f8cf327d3$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $45627b3f8cf327d3$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $45627b3f8cf327d3$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    }
    $45627b3f8cf327d3$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $45627b3f8cf327d3$var$labelPattern.exec(styles)) !== null)identifierName += "-" + match[1];
    var name = (0, $laHCk.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $45627b3f8cf327d3$var$cursor
    };
}

});
parcelRegister("laHCk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f69c5d9c4592a0a7$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $f69c5d9c4592a0a7$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("lThqe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fefc3fb3701da7c9$export$2e2bcd8739ae039; });
var $fefc3fb3701da7c9$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("2kN9K", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $1b33946bd210aca0$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $1b33946bd210aca0$export$811a713a7276cb9d; });

var $8v0nu = parcelRequire("8v0nu");
var $1b33946bd210aca0$var$syncFallback = function syncFallback(create) {
    return create();
};
var $1b33946bd210aca0$var$useInsertionEffect = $8v0nu.useInsertionEffect ? $8v0nu.useInsertionEffect : false;
var $1b33946bd210aca0$export$db21c7ffa21794e7 = $1b33946bd210aca0$var$useInsertionEffect || $1b33946bd210aca0$var$syncFallback;
var $1b33946bd210aca0$export$811a713a7276cb9d = $1b33946bd210aca0$var$useInsertionEffect || $8v0nu.useLayoutEffect;

});





parcelRegister("YkZTR", function(module, exports) {

$parcel$export(module.exports, "shouldForwardProp", function () { return $a9f893cc6f930972$export$3ba67b570e26eea0; });

var $lA3d6 = parcelRequire("lA3d6");
"use client";
const $a9f893cc6f930972$var$allPropNames = /* @__PURE__ */ new Set([
    ...(0, $lA3d6.getPropNames)({}),
    "textStyle",
    "layerStyle",
    "apply",
    "noOfLines",
    "focusBorderColor",
    "errorBorderColor",
    "as",
    "__css",
    "css",
    "sx"
]);
const $a9f893cc6f930972$var$validHTMLProps = /* @__PURE__ */ new Set([
    "htmlWidth",
    "htmlHeight",
    "htmlSize",
    "htmlTranslate"
]);
function $a9f893cc6f930972$export$3ba67b570e26eea0(prop) {
    return ($a9f893cc6f930972$var$validHTMLProps.has(prop) || !$a9f893cc6f930972$var$allPropNames.has(prop)) && prop[0] !== "_";
}

});

parcelRegister("6jXOD", function(module, exports) {

$parcel$export(module.exports, "ColorModeContext", function () { return $5a13d9245037c716$export$49ddd74a6729fdb0; });
$parcel$export(module.exports, "useColorMode", function () { return $5a13d9245037c716$export$20f3076712c8dfa; });

var $8v0nu = parcelRequire("8v0nu");
"use client";
const $5a13d9245037c716$export$49ddd74a6729fdb0 = (0, $8v0nu.createContext)({});
$5a13d9245037c716$export$49ddd74a6729fdb0.displayName = "ColorModeContext";
function $5a13d9245037c716$export$20f3076712c8dfa() {
    const context = (0, $8v0nu.useContext)($5a13d9245037c716$export$49ddd74a6729fdb0);
    if (context === void 0) throw new Error("useColorMode must be used within a ColorModeProvider");
    return context;
}
function $5a13d9245037c716$export$d18f2ef57b0d7644(light, dark) {
    const { colorMode: colorMode } = $5a13d9245037c716$export$20f3076712c8dfa();
    return colorMode === "dark" ? dark : light;
}

});




parcelRegister("jTKGQ", function(module, exports) {

$parcel$export(module.exports, "useFormikContext", function () { return useFormikContext; });
$parcel$export(module.exports, "yupToFormErrors", function () { return yupToFormErrors; });
$parcel$export(module.exports, "Formik", function () { return Formik; });
$parcel$export(module.exports, "FieldArray", function () { return FieldArray; });
$parcel$export(module.exports, "FastField", function () { return FastField; });

var $l30Rn = parcelRequire("l30Rn");

var $336aN = parcelRequire("336aN");

var $jGWdr = parcelRequire("jGWdr");

var $8v0nu = parcelRequire("8v0nu");

var $eHMvZ = parcelRequire("eHMvZ");

var $7li8V = parcelRequire("7li8V");

var $aAHHW = parcelRequire("aAHHW");

var $cDRNl = parcelRequire("cDRNl");

var $1NGjT = parcelRequire("1NGjT");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var FormikContext = /*#__PURE__*/ (0, $8v0nu.createContext)(undefined);
FormikContext.displayName = "FormikContext";
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $8v0nu.useContext)(FormikContext);
    !!!formik && (0, $7li8V.default)(false);
    return formik;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === "function";
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === "object";
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === "[object String]";
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, $8v0nu.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== "undefined" ? document : undefined);
    if (typeof doc === "undefined") return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $cDRNl.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
     // check if path is not in the end
    if (p !== path.length && !obj) return def;
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, $aAHHW.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $cDRNl.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $aAHHW.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case "SET_VALUES":
            return _extends({}, state, {
                values: msg.payload
            });
        case "SET_TOUCHED":
            return _extends({}, state, {
                touched: msg.payload
            });
        case "SET_ERRORS":
            if ((0, (/*@__PURE__*/$parcel$interopDefault($eHMvZ)))(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case "SET_STATUS":
            return _extends({}, state, {
                status: msg.payload
            });
        case "SET_ISSUBMITTING":
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case "SET_ISVALIDATING":
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case "SET_FIELD_VALUE":
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case "SET_FIELD_TOUCHED":
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case "SET_FIELD_ERROR":
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case "RESET_FORM":
            return _extends({}, state, msg.payload);
        case "SET_FORMIK_STATE":
            return msg.payload(state);
        case "SUBMIT_ATTEMPT":
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case "SUBMIT_FAILURE":
            return _extends({}, state, {
                isSubmitting: false
            });
        case "SUBMIT_SUCCESS":
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $8v0nu.useRef)(props.initialValues);
    var initialErrors = (0, $8v0nu.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, $8v0nu.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, $8v0nu.useRef)(props.initialStatus);
    var isMounted = (0, $8v0nu.useRef)(false);
    var fieldRegistry = (0, $8v0nu.useRef)({});
    (0, $8v0nu.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useState = (0, $8v0nu.useState)(0), setIteration = _React$useState[1];
    var stateRef = (0, $8v0nu.useRef)({
        values: (0, $jGWdr.default)(props.initialValues),
        errors: (0, $jGWdr.default)(props.initialErrors) || emptyErrors,
        touched: (0, $jGWdr.default)(props.initialTouched) || emptyTouched,
        status: (0, $jGWdr.default)(props.initialStatus),
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    });
    var state = stateRef.current;
    var dispatch = (0, $8v0nu.useCallback)(function(action) {
        var prev = stateRef.current;
        stateRef.current = formikReducer(prev, action); // force rerender
        if (prev !== stateRef.current) setIteration(function(x) {
            return x + 1;
        });
    }, []);
    var runValidateHandler = (0, $8v0nu.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $8v0nu.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === "ValidationError") resolve(yupToFormErrors(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $8v0nu.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $8v0nu.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === "DO_NOT_DELETE_YOU_WILL_BE_FIRED") return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $8v0nu.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $l30Rn.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: "SET_ISVALIDATING",
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: false
                });
                dispatch({
                    type: "SET_ERRORS",
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $8v0nu.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($eHMvZ)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $8v0nu.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: "RESET_FORM",
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === "number" ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched,
        props.onReset
    ]);
    (0, $8v0nu.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($eHMvZ)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
                if (validateOnMount) validateFormWithHighPriority(initialValues.current);
            }
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $8v0nu.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($eHMvZ)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: "SET_ERRORS",
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $8v0nu.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($eHMvZ)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: "SET_TOUCHED",
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $8v0nu.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($eHMvZ)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: "SET_STATUS",
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: "SET_FIELD_ERROR",
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: "SET_ISVALIDATING",
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: "SET_FIELD_ERROR",
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: "SET_ISVALIDATING",
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: "SET_FIELD_ERROR",
                    payload: {
                        field: name,
                        value: getIn(error, name)
                    }
                });
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $8v0nu.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $8v0nu.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: "SET_TOUCHED",
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $8v0nu.useCallback)(function(errors) {
        dispatch({
            type: "SET_ERRORS",
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: "SET_VALUES",
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $8v0nu.useCallback)(function(field, value) {
        dispatch({
            type: "SET_FIELD_ERROR",
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        dispatch({
            type: "SET_FIELD_VALUE",
            payload: {
                field: field,
                value: value
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
    });
    var executeChange = (0, $8v0nu.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? "" : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: "SET_FIELD_TOUCHED",
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $8v0nu.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $8v0nu.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: "SET_FORMIK_STATE",
            payload: stateOrCb
        });
        else dispatch({
            type: "SET_FORMIK_STATE",
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $8v0nu.useCallback)(function(status) {
        dispatch({
            type: "SET_STATUS",
            payload: status
        });
    }, []);
    var setSubmitting = (0, $8v0nu.useCallback)(function(isSubmitting) {
        dispatch({
            type: "SET_ISSUBMITTING",
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: "SUBMIT_ATTEMPT"
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: "SUBMIT_SUCCESS"
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: "SUBMIT_FAILURE"
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: "SUBMIT_FAILURE"
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $8v0nu.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $8v0nu.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $8v0nu.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === "checkbox") {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === "radio") {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === "select" && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $8v0nu.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($eHMvZ)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $8v0nu.useMemo)(function() {
        return typeof isInitialValid !== "undefined" ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $8v0nu.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, $8v0nu.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, $8v0nu.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, $8v0nu.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    var normalizedValues = prepareDataForValidation(values);
    return schema[sync ? "validateSync" : "validate"](normalizedValues, {
        abortEarly: false,
        context: context || normalizedValues
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $336aN.default)(value)) return prepareDataForValidation(value);
            else return value !== "" ? value : undefined;
        });
        else if ((0, $336aN.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== "" ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === "undefined") {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $l30Rn.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $l30Rn.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === "boolean") return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == "true" || valueProp == "false") return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $8v0nu.useLayoutEffect) : (0, $8v0nu.useEffect);
function useEventCallback(fn) {
    var ref = (0, $8v0nu.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $8v0nu.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $8v0nu.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, $7li8V.default)(false);
    var fieldHelpers = (0, $8v0nu.useMemo)(function() {
        return getFieldHelpers(fieldName);
    }, [
        getFieldHelpers,
        fieldName
    ]);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        fieldHelpers
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, className = _ref.className, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component",
        "className"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $8v0nu.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === "string") {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $8v0nu.createElement)(component, _extends({
                ref: innerRef
            }, field, rest, {
                className: className
            }), children);
        } // We don't pass `meta` for backwards compat
        return (0, $8v0nu.createElement)(component, _extends({
            field: field,
            form: formik
        }, props, {
            className: className
        }), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || "input";
    if (typeof asElement === "string") {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $8v0nu.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest, {
            className: className
        }), children);
    }
    return (0, $8v0nu.createElement)(asElement, _extends({}, field, props, {
        className: className
    }), children);
}
var Form = /*#__PURE__*/ (0, $8v0nu.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : "#";
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $8v0nu.createElement)("form", _extends({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = "Form";
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== "function") // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || "Component";
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _React$Component.call.apply(_React$Component, [
                    this
                ].concat(args)) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                _this.renderFormComponent = function(formikProps) {
                    return (0, $8v0nu.createElement)(Component$1, _extends({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $8v0nu.createElement)(Formik, _extends({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $8v0nu.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($1NGjT)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, $8v0nu.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, $7li8V.default)(false);
            return (0, $8v0nu.createElement)(Comp, _extends({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || "Component"; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($1NGjT)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
    var fn = typeof alteration === "function" ? alteration : defaultFunction;
    return function(data) {
        if (Array.isArray(data) || isObject(data)) {
            var clone = copyArrayLike(data);
            return fn(clone);
        } // This can be assumed to be a primitive, which
        // is a case for top level validation errors
        return data;
    };
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = createAlterationHandler(alterErrors, fn);
                var updateTouched = createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, $jGWdr.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                length = arr.length;
                return arr;
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        };
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($eHMvZ)))(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
             // if the array only includes undefined values we have to return an empty array
            return isFunction(copy.every) ? copy.every(function(v) {
                return v === undefined;
            }) ? [] : copy : copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array.slice();
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $8v0nu.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === "function" ? children(props) : !isEmptyChildren(children) ? (0, $8v0nu.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $8v0nu.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, $8v0nu.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $8v0nu.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $7li8V.default)(false);
        !!(component && render) && (0, $7li8V.default)(false);
        !!(is && children && isFunction(children)) && (0, $7li8V.default)(false);
        !!(component && children && isFunction(children)) && (0, $7li8V.default)(false);
        !!(render && children && !isEmptyChildren(children)) && (0, $7li8V.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === "string") {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $8v0nu.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $8v0nu.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || "input";
        if (typeof asElement === "string") {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $8v0nu.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $8v0nu.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $8v0nu.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

});
parcelRegister("l30Rn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f52a8b88269c0d84$export$2e2bcd8739ae039; });
var $f52a8b88269c0d84$var$isMergeableObject = function isMergeableObject(value) {
    return $f52a8b88269c0d84$var$isNonNullObject(value) && !$f52a8b88269c0d84$var$isSpecial(value);
};
function $f52a8b88269c0d84$var$isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function $f52a8b88269c0d84$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || $f52a8b88269c0d84$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $f52a8b88269c0d84$var$canUseSymbol = typeof Symbol === "function" && Symbol.for;
var $f52a8b88269c0d84$var$REACT_ELEMENT_TYPE = $f52a8b88269c0d84$var$canUseSymbol ? Symbol.for("react.element") : 0xeac7;
function $f52a8b88269c0d84$var$isReactElement(value) {
    return value.$$typeof === $f52a8b88269c0d84$var$REACT_ELEMENT_TYPE;
}
function $f52a8b88269c0d84$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $f52a8b88269c0d84$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $f52a8b88269c0d84$var$deepmerge($f52a8b88269c0d84$var$emptyTarget(value), value, options) : value;
}
function $f52a8b88269c0d84$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $f52a8b88269c0d84$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $f52a8b88269c0d84$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $f52a8b88269c0d84$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $f52a8b88269c0d84$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $f52a8b88269c0d84$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $f52a8b88269c0d84$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $f52a8b88269c0d84$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $f52a8b88269c0d84$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $f52a8b88269c0d84$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $f52a8b88269c0d84$var$mergeObject(target, source, options);
}
$f52a8b88269c0d84$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return $f52a8b88269c0d84$var$deepmerge(prev, next, options);
    }, {});
};
var $f52a8b88269c0d84$var$deepmerge_1 = $f52a8b88269c0d84$var$deepmerge;
var $f52a8b88269c0d84$export$2e2bcd8739ae039 = $f52a8b88269c0d84$var$deepmerge_1;

});

parcelRegister("336aN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $238670c1e2da118d$export$2e2bcd8739ae039; });

var $2cf7J = parcelRequire("2cf7J");

var $d18qD = parcelRequire("d18qD");

var $9XysK = parcelRequire("9XysK");
/** `Object#toString` result references. */ var $238670c1e2da118d$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $238670c1e2da118d$var$funcProto = Function.prototype, $238670c1e2da118d$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $238670c1e2da118d$var$funcToString = $238670c1e2da118d$var$funcProto.toString;
/** Used to check objects for own properties. */ var $238670c1e2da118d$var$hasOwnProperty = $238670c1e2da118d$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $238670c1e2da118d$var$objectCtorString = $238670c1e2da118d$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $238670c1e2da118d$var$isPlainObject(value) {
    if (!(0, $9XysK.default)(value) || (0, $2cf7J.default)(value) != $238670c1e2da118d$var$objectTag) return false;
    var proto = (0, $d18qD.default)(value);
    if (proto === null) return true;
    var Ctor = $238670c1e2da118d$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $238670c1e2da118d$var$funcToString.call(Ctor) == $238670c1e2da118d$var$objectCtorString;
}
var $238670c1e2da118d$export$2e2bcd8739ae039 = $238670c1e2da118d$var$isPlainObject;

});
parcelRegister("2cf7J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19986f09efbc2ee5$export$2e2bcd8739ae039; });

var $hwtsf = parcelRequire("hwtsf");

var $95GlW = parcelRequire("95GlW");

var $gfHM9 = parcelRequire("gfHM9");
/** `Object#toString` result references. */ var $19986f09efbc2ee5$var$nullTag = "[object Null]", $19986f09efbc2ee5$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $19986f09efbc2ee5$var$symToStringTag = (0, $hwtsf.default) ? (0, $hwtsf.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $19986f09efbc2ee5$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $19986f09efbc2ee5$var$undefinedTag : $19986f09efbc2ee5$var$nullTag;
    return $19986f09efbc2ee5$var$symToStringTag && $19986f09efbc2ee5$var$symToStringTag in Object(value) ? (0, $95GlW.default)(value) : (0, $gfHM9.default)(value);
}
var $19986f09efbc2ee5$export$2e2bcd8739ae039 = $19986f09efbc2ee5$var$baseGetTag;

});
parcelRegister("hwtsf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc1c45e16e5e82ba$export$2e2bcd8739ae039; });

var $cbL8G = parcelRequire("cbL8G");
/** Built-in value references. */ var $cc1c45e16e5e82ba$var$Symbol = (0, $cbL8G.default).Symbol;
var $cc1c45e16e5e82ba$export$2e2bcd8739ae039 = $cc1c45e16e5e82ba$var$Symbol;

});
parcelRegister("cbL8G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8dfb13f5a11de6c6$export$2e2bcd8739ae039; });

var $fJlIs = parcelRequire("fJlIs");
/** Detect free variable `self`. */ var $8dfb13f5a11de6c6$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $8dfb13f5a11de6c6$var$root = (0, $fJlIs.default) || $8dfb13f5a11de6c6$var$freeSelf || Function("return this")();
var $8dfb13f5a11de6c6$export$2e2bcd8739ae039 = $8dfb13f5a11de6c6$var$root;

});
parcelRegister("fJlIs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b73be75724971af0$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $b73be75724971af0$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $b73be75724971af0$export$2e2bcd8739ae039 = $b73be75724971af0$var$freeGlobal;

});



parcelRegister("95GlW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69e56f18a357fb9f$export$2e2bcd8739ae039; });

var $hwtsf = parcelRequire("hwtsf");
/** Used for built-in method references. */ var $69e56f18a357fb9f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $69e56f18a357fb9f$var$hasOwnProperty = $69e56f18a357fb9f$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $69e56f18a357fb9f$var$nativeObjectToString = $69e56f18a357fb9f$var$objectProto.toString;
/** Built-in value references. */ var $69e56f18a357fb9f$var$symToStringTag = (0, $hwtsf.default) ? (0, $hwtsf.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $69e56f18a357fb9f$var$getRawTag(value) {
    var isOwn = $69e56f18a357fb9f$var$hasOwnProperty.call(value, $69e56f18a357fb9f$var$symToStringTag), tag = value[$69e56f18a357fb9f$var$symToStringTag];
    try {
        value[$69e56f18a357fb9f$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $69e56f18a357fb9f$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$69e56f18a357fb9f$var$symToStringTag] = tag;
        else delete value[$69e56f18a357fb9f$var$symToStringTag];
    }
    return result;
}
var $69e56f18a357fb9f$export$2e2bcd8739ae039 = $69e56f18a357fb9f$var$getRawTag;

});

parcelRegister("gfHM9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd5000fc2b79f59c$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $bd5000fc2b79f59c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $bd5000fc2b79f59c$var$nativeObjectToString = $bd5000fc2b79f59c$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $bd5000fc2b79f59c$var$objectToString(value) {
    return $bd5000fc2b79f59c$var$nativeObjectToString.call(value);
}
var $bd5000fc2b79f59c$export$2e2bcd8739ae039 = $bd5000fc2b79f59c$var$objectToString;

});


parcelRegister("d18qD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97a1e817f546ddc3$export$2e2bcd8739ae039; });

var $ayyI5 = parcelRequire("ayyI5");
/** Built-in value references. */ var $97a1e817f546ddc3$var$getPrototype = (0, $ayyI5.default)(Object.getPrototypeOf, Object);
var $97a1e817f546ddc3$export$2e2bcd8739ae039 = $97a1e817f546ddc3$var$getPrototype;

});
parcelRegister("ayyI5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7af8010f1828909b$export$2e2bcd8739ae039; });
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $7af8010f1828909b$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $7af8010f1828909b$export$2e2bcd8739ae039 = $7af8010f1828909b$var$overArg;

});


parcelRegister("9XysK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74045b551f728b99$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $74045b551f728b99$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $74045b551f728b99$export$2e2bcd8739ae039 = $74045b551f728b99$var$isObjectLike;

});


parcelRegister("jGWdr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e55f18fc038f72e8$export$2e2bcd8739ae039; });

var $5t0O7 = parcelRequire("5t0O7");
/** Used to compose bitmasks for cloning. */ var $e55f18fc038f72e8$var$CLONE_DEEP_FLAG = 1, $e55f18fc038f72e8$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $e55f18fc038f72e8$var$cloneDeep(value) {
    return (0, $5t0O7.default)(value, $e55f18fc038f72e8$var$CLONE_DEEP_FLAG | $e55f18fc038f72e8$var$CLONE_SYMBOLS_FLAG);
}
var $e55f18fc038f72e8$export$2e2bcd8739ae039 = $e55f18fc038f72e8$var$cloneDeep;

});
parcelRegister("5t0O7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fb04983a3cdc23b$export$2e2bcd8739ae039; });

var $5dLfO = parcelRequire("5dLfO");

var $7KiuO = parcelRequire("7KiuO");

var $fOFG0 = parcelRequire("fOFG0");

var $dgPnQ = parcelRequire("dgPnQ");

var $fqUOE = parcelRequire("fqUOE");

var $jXF4S = parcelRequire("jXF4S");

var $7KNPo = parcelRequire("7KNPo");

var $XexYp = parcelRequire("XexYp");

var $8NC4G = parcelRequire("8NC4G");

var $eNbR6 = parcelRequire("eNbR6");

var $9atCI = parcelRequire("9atCI");

var $6JaTE = parcelRequire("6JaTE");

var $fGAmH = parcelRequire("fGAmH");

var $25BDK = parcelRequire("25BDK");

var $55JsH = parcelRequire("55JsH");

var $eA9yl = parcelRequire("eA9yl");

var $43Y3b = parcelRequire("43Y3b");

var $28u2G = parcelRequire("28u2G");

var $55CT4 = parcelRequire("55CT4");

var $eoSgZ = parcelRequire("eoSgZ");

var $31LnV = parcelRequire("31LnV");

var $efjUI = parcelRequire("efjUI");
/** Used to compose bitmasks for cloning. */ var $3fb04983a3cdc23b$var$CLONE_DEEP_FLAG = 1, $3fb04983a3cdc23b$var$CLONE_FLAT_FLAG = 2, $3fb04983a3cdc23b$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $3fb04983a3cdc23b$var$argsTag = "[object Arguments]", $3fb04983a3cdc23b$var$arrayTag = "[object Array]", $3fb04983a3cdc23b$var$boolTag = "[object Boolean]", $3fb04983a3cdc23b$var$dateTag = "[object Date]", $3fb04983a3cdc23b$var$errorTag = "[object Error]", $3fb04983a3cdc23b$var$funcTag = "[object Function]", $3fb04983a3cdc23b$var$genTag = "[object GeneratorFunction]", $3fb04983a3cdc23b$var$mapTag = "[object Map]", $3fb04983a3cdc23b$var$numberTag = "[object Number]", $3fb04983a3cdc23b$var$objectTag = "[object Object]", $3fb04983a3cdc23b$var$regexpTag = "[object RegExp]", $3fb04983a3cdc23b$var$setTag = "[object Set]", $3fb04983a3cdc23b$var$stringTag = "[object String]", $3fb04983a3cdc23b$var$symbolTag = "[object Symbol]", $3fb04983a3cdc23b$var$weakMapTag = "[object WeakMap]";
var $3fb04983a3cdc23b$var$arrayBufferTag = "[object ArrayBuffer]", $3fb04983a3cdc23b$var$dataViewTag = "[object DataView]", $3fb04983a3cdc23b$var$float32Tag = "[object Float32Array]", $3fb04983a3cdc23b$var$float64Tag = "[object Float64Array]", $3fb04983a3cdc23b$var$int8Tag = "[object Int8Array]", $3fb04983a3cdc23b$var$int16Tag = "[object Int16Array]", $3fb04983a3cdc23b$var$int32Tag = "[object Int32Array]", $3fb04983a3cdc23b$var$uint8Tag = "[object Uint8Array]", $3fb04983a3cdc23b$var$uint8ClampedTag = "[object Uint8ClampedArray]", $3fb04983a3cdc23b$var$uint16Tag = "[object Uint16Array]", $3fb04983a3cdc23b$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $3fb04983a3cdc23b$var$cloneableTags = {};
$3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$argsTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$arrayTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$arrayBufferTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$dataViewTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$boolTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$dateTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$float32Tag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$float64Tag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$int8Tag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$int16Tag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$int32Tag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$mapTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$numberTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$objectTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$regexpTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$setTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$stringTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$symbolTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$uint8Tag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$uint8ClampedTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$uint16Tag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$uint32Tag] = true;
$3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$errorTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$funcTag] = $3fb04983a3cdc23b$var$cloneableTags[$3fb04983a3cdc23b$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $3fb04983a3cdc23b$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $3fb04983a3cdc23b$var$CLONE_DEEP_FLAG, isFlat = bitmask & $3fb04983a3cdc23b$var$CLONE_FLAT_FLAG, isFull = bitmask & $3fb04983a3cdc23b$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $55CT4.default)(value)) return value;
    var isArr = (0, $eA9yl.default)(value);
    if (isArr) {
        result = (0, $fGAmH.default)(value);
        if (!isDeep) return (0, $7KNPo.default)(value, result);
    } else {
        var tag = (0, $6JaTE.default)(value), isFunc = tag == $3fb04983a3cdc23b$var$funcTag || tag == $3fb04983a3cdc23b$var$genTag;
        if ((0, $43Y3b.default)(value)) return (0, $jXF4S.default)(value, isDeep);
        if (tag == $3fb04983a3cdc23b$var$objectTag || tag == $3fb04983a3cdc23b$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $55JsH.default)(value);
            if (!isDeep) return isFlat ? (0, $8NC4G.default)(value, (0, $fqUOE.default)(result, value)) : (0, $XexYp.default)(value, (0, $dgPnQ.default)(result, value));
        } else {
            if (!$3fb04983a3cdc23b$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $25BDK.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $5dLfO.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $eoSgZ.default)(value)) value.forEach(function(subValue) {
        result.add($3fb04983a3cdc23b$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $28u2G.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $3fb04983a3cdc23b$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $9atCI.default) : (0, $eNbR6.default) : isFlat ? (0, $efjUI.default) : (0, $31LnV.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $7KiuO.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $fOFG0.default)(result, key, $3fb04983a3cdc23b$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $3fb04983a3cdc23b$export$2e2bcd8739ae039 = $3fb04983a3cdc23b$var$baseClone;

});
parcelRegister("5dLfO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3cd2d24f98fbb036$export$2e2bcd8739ae039; });

var $dlf4P = parcelRequire("dlf4P");

var $kGKkA = parcelRequire("kGKkA");

var $23Mbg = parcelRequire("23Mbg");

var $i1fJz = parcelRequire("i1fJz");

var $gReuE = parcelRequire("gReuE");

var $6UH46 = parcelRequire("6UH46");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $3cd2d24f98fbb036$var$Stack(entries) {
    var data = this.__data__ = new (0, $dlf4P.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$3cd2d24f98fbb036$var$Stack.prototype.clear = (0, $kGKkA.default);
$3cd2d24f98fbb036$var$Stack.prototype["delete"] = (0, $23Mbg.default);
$3cd2d24f98fbb036$var$Stack.prototype.get = (0, $i1fJz.default);
$3cd2d24f98fbb036$var$Stack.prototype.has = (0, $gReuE.default);
$3cd2d24f98fbb036$var$Stack.prototype.set = (0, $6UH46.default);
var $3cd2d24f98fbb036$export$2e2bcd8739ae039 = $3cd2d24f98fbb036$var$Stack;

});
parcelRegister("dlf4P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b68ee780c997cac$export$2e2bcd8739ae039; });

var $8NGqa = parcelRequire("8NGqa");

var $9Dleu = parcelRequire("9Dleu");

var $cQgQJ = parcelRequire("cQgQJ");

var $iT8rO = parcelRequire("iT8rO");

var $gMJdO = parcelRequire("gMJdO");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9b68ee780c997cac$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$9b68ee780c997cac$var$ListCache.prototype.clear = (0, $8NGqa.default);
$9b68ee780c997cac$var$ListCache.prototype["delete"] = (0, $9Dleu.default);
$9b68ee780c997cac$var$ListCache.prototype.get = (0, $cQgQJ.default);
$9b68ee780c997cac$var$ListCache.prototype.has = (0, $iT8rO.default);
$9b68ee780c997cac$var$ListCache.prototype.set = (0, $gMJdO.default);
var $9b68ee780c997cac$export$2e2bcd8739ae039 = $9b68ee780c997cac$var$ListCache;

});
parcelRegister("8NGqa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6683ce46208661b7$export$2e2bcd8739ae039; });
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $6683ce46208661b7$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $6683ce46208661b7$export$2e2bcd8739ae039 = $6683ce46208661b7$var$listCacheClear;

});

parcelRegister("9Dleu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $703839f14e9825b3$export$2e2bcd8739ae039; });

var $emTR9 = parcelRequire("emTR9");
/** Used for built-in method references. */ var $703839f14e9825b3$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $703839f14e9825b3$var$splice = $703839f14e9825b3$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $703839f14e9825b3$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $emTR9.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $703839f14e9825b3$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $703839f14e9825b3$export$2e2bcd8739ae039 = $703839f14e9825b3$var$listCacheDelete;

});
parcelRegister("emTR9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a75e72a7367a8fda$export$2e2bcd8739ae039; });

var $5TPq9 = parcelRequire("5TPq9");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a75e72a7367a8fda$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $5TPq9.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $a75e72a7367a8fda$export$2e2bcd8739ae039 = $a75e72a7367a8fda$var$assocIndexOf;

});
parcelRegister("5TPq9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44b9f9ea8066e509$export$2e2bcd8739ae039; });
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $44b9f9ea8066e509$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $44b9f9ea8066e509$export$2e2bcd8739ae039 = $44b9f9ea8066e509$var$eq;

});



parcelRegister("cQgQJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95976950a1bed355$export$2e2bcd8739ae039; });

var $emTR9 = parcelRequire("emTR9");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $95976950a1bed355$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $emTR9.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $95976950a1bed355$export$2e2bcd8739ae039 = $95976950a1bed355$var$listCacheGet;

});

parcelRegister("iT8rO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc03ea9648d19f85$export$2e2bcd8739ae039; });

var $emTR9 = parcelRequire("emTR9");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $dc03ea9648d19f85$var$listCacheHas(key) {
    return (0, $emTR9.default)(this.__data__, key) > -1;
}
var $dc03ea9648d19f85$export$2e2bcd8739ae039 = $dc03ea9648d19f85$var$listCacheHas;

});

parcelRegister("gMJdO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3843523f18b7a46$export$2e2bcd8739ae039; });

var $emTR9 = parcelRequire("emTR9");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $c3843523f18b7a46$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $emTR9.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $c3843523f18b7a46$export$2e2bcd8739ae039 = $c3843523f18b7a46$var$listCacheSet;

});


parcelRegister("kGKkA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0fbab404ad9a4e6$export$2e2bcd8739ae039; });

var $dlf4P = parcelRequire("dlf4P");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $f0fbab404ad9a4e6$var$stackClear() {
    this.__data__ = new (0, $dlf4P.default);
    this.size = 0;
}
var $f0fbab404ad9a4e6$export$2e2bcd8739ae039 = $f0fbab404ad9a4e6$var$stackClear;

});

parcelRegister("23Mbg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18013c45f6284200$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $18013c45f6284200$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
var $18013c45f6284200$export$2e2bcd8739ae039 = $18013c45f6284200$var$stackDelete;

});

parcelRegister("i1fJz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1e486694756753c$export$2e2bcd8739ae039; });
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d1e486694756753c$var$stackGet(key) {
    return this.__data__.get(key);
}
var $d1e486694756753c$export$2e2bcd8739ae039 = $d1e486694756753c$var$stackGet;

});

parcelRegister("gReuE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c45cd6aa70f09604$export$2e2bcd8739ae039; });
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c45cd6aa70f09604$var$stackHas(key) {
    return this.__data__.has(key);
}
var $c45cd6aa70f09604$export$2e2bcd8739ae039 = $c45cd6aa70f09604$var$stackHas;

});

parcelRegister("6UH46", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $508960e5f282e8fa$export$2e2bcd8739ae039; });

var $dlf4P = parcelRequire("dlf4P");

var $5Gj2X = parcelRequire("5Gj2X");

var $5Sw7u = parcelRequire("5Sw7u");
/** Used as the size to enable large array optimizations. */ var $508960e5f282e8fa$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $508960e5f282e8fa$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $dlf4P.default)) {
        var pairs = data.__data__;
        if (!(0, $5Gj2X.default) || pairs.length < $508960e5f282e8fa$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $5Sw7u.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $508960e5f282e8fa$export$2e2bcd8739ae039 = $508960e5f282e8fa$var$stackSet;

});
parcelRegister("5Gj2X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $422fa6479c5bd7ef$export$2e2bcd8739ae039; });

var $cnWT7 = parcelRequire("cnWT7");

var $cbL8G = parcelRequire("cbL8G");
/* Built-in method references that are verified to be native. */ var $422fa6479c5bd7ef$var$Map = (0, $cnWT7.default)((0, $cbL8G.default), "Map");
var $422fa6479c5bd7ef$export$2e2bcd8739ae039 = $422fa6479c5bd7ef$var$Map;

});
parcelRegister("cnWT7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90454fee56e3abff$export$2e2bcd8739ae039; });

var $6HHNz = parcelRequire("6HHNz");

var $e4At8 = parcelRequire("e4At8");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $90454fee56e3abff$var$getNative(object, key) {
    var value = (0, $e4At8.default)(object, key);
    return (0, $6HHNz.default)(value) ? value : undefined;
}
var $90454fee56e3abff$export$2e2bcd8739ae039 = $90454fee56e3abff$var$getNative;

});
parcelRegister("6HHNz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e18bbb875da1870$export$2e2bcd8739ae039; });

var $65Nb9 = parcelRequire("65Nb9");

var $1UREy = parcelRequire("1UREy");

var $55CT4 = parcelRequire("55CT4");

var $ki9xX = parcelRequire("ki9xX");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $4e18bbb875da1870$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $4e18bbb875da1870$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $4e18bbb875da1870$var$funcProto = Function.prototype, $4e18bbb875da1870$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $4e18bbb875da1870$var$funcToString = $4e18bbb875da1870$var$funcProto.toString;
/** Used to check objects for own properties. */ var $4e18bbb875da1870$var$hasOwnProperty = $4e18bbb875da1870$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $4e18bbb875da1870$var$reIsNative = RegExp("^" + $4e18bbb875da1870$var$funcToString.call($4e18bbb875da1870$var$hasOwnProperty).replace($4e18bbb875da1870$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $4e18bbb875da1870$var$baseIsNative(value) {
    if (!(0, $55CT4.default)(value) || (0, $1UREy.default)(value)) return false;
    var pattern = (0, $65Nb9.default)(value) ? $4e18bbb875da1870$var$reIsNative : $4e18bbb875da1870$var$reIsHostCtor;
    return pattern.test((0, $ki9xX.default)(value));
}
var $4e18bbb875da1870$export$2e2bcd8739ae039 = $4e18bbb875da1870$var$baseIsNative;

});
parcelRegister("65Nb9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46f95b963f3247d9$export$2e2bcd8739ae039; });

var $2cf7J = parcelRequire("2cf7J");

var $55CT4 = parcelRequire("55CT4");
/** `Object#toString` result references. */ var $46f95b963f3247d9$var$asyncTag = "[object AsyncFunction]", $46f95b963f3247d9$var$funcTag = "[object Function]", $46f95b963f3247d9$var$genTag = "[object GeneratorFunction]", $46f95b963f3247d9$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $46f95b963f3247d9$var$isFunction(value) {
    if (!(0, $55CT4.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $2cf7J.default)(value);
    return tag == $46f95b963f3247d9$var$funcTag || tag == $46f95b963f3247d9$var$genTag || tag == $46f95b963f3247d9$var$asyncTag || tag == $46f95b963f3247d9$var$proxyTag;
}
var $46f95b963f3247d9$export$2e2bcd8739ae039 = $46f95b963f3247d9$var$isFunction;

});
parcelRegister("55CT4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b4b9591942c6c05$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $3b4b9591942c6c05$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $3b4b9591942c6c05$export$2e2bcd8739ae039 = $3b4b9591942c6c05$var$isObject;

});


parcelRegister("1UREy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1654a3d1c253f392$export$2e2bcd8739ae039; });

var $gE3Lz = parcelRequire("gE3Lz");
/** Used to detect methods masquerading as native. */ var $1654a3d1c253f392$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $gE3Lz.default) && (0, $gE3Lz.default).keys && (0, $gE3Lz.default).keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $1654a3d1c253f392$var$isMasked(func) {
    return !!$1654a3d1c253f392$var$maskSrcKey && $1654a3d1c253f392$var$maskSrcKey in func;
}
var $1654a3d1c253f392$export$2e2bcd8739ae039 = $1654a3d1c253f392$var$isMasked;

});
parcelRegister("gE3Lz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1e34da8907984a5$export$2e2bcd8739ae039; });

var $cbL8G = parcelRequire("cbL8G");
/** Used to detect overreaching core-js shims. */ var $c1e34da8907984a5$var$coreJsData = (0, $cbL8G.default)["__core-js_shared__"];
var $c1e34da8907984a5$export$2e2bcd8739ae039 = $c1e34da8907984a5$var$coreJsData;

});


parcelRegister("ki9xX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec5ce4dc218ac235$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $ec5ce4dc218ac235$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $ec5ce4dc218ac235$var$funcToString = $ec5ce4dc218ac235$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $ec5ce4dc218ac235$var$toSource(func) {
    if (func != null) {
        try {
            return $ec5ce4dc218ac235$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
var $ec5ce4dc218ac235$export$2e2bcd8739ae039 = $ec5ce4dc218ac235$var$toSource;

});


parcelRegister("e4At8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3edba5b7bfad554$export$2e2bcd8739ae039; });
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $a3edba5b7bfad554$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $a3edba5b7bfad554$export$2e2bcd8739ae039 = $a3edba5b7bfad554$var$getValue;

});



parcelRegister("5Sw7u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $447ae933fe5b0e8b$export$2e2bcd8739ae039; });

var $koCjl = parcelRequire("koCjl");

var $krpQl = parcelRequire("krpQl");

var $9mwxA = parcelRequire("9mwxA");

var $66SSL = parcelRequire("66SSL");

var $gUJSA = parcelRequire("gUJSA");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $447ae933fe5b0e8b$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$447ae933fe5b0e8b$var$MapCache.prototype.clear = (0, $koCjl.default);
$447ae933fe5b0e8b$var$MapCache.prototype["delete"] = (0, $krpQl.default);
$447ae933fe5b0e8b$var$MapCache.prototype.get = (0, $9mwxA.default);
$447ae933fe5b0e8b$var$MapCache.prototype.has = (0, $66SSL.default);
$447ae933fe5b0e8b$var$MapCache.prototype.set = (0, $gUJSA.default);
var $447ae933fe5b0e8b$export$2e2bcd8739ae039 = $447ae933fe5b0e8b$var$MapCache;

});
parcelRegister("koCjl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed93c44e36f89c1f$export$2e2bcd8739ae039; });

var $8M2bs = parcelRequire("8M2bs");

var $dlf4P = parcelRequire("dlf4P");

var $5Gj2X = parcelRequire("5Gj2X");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $ed93c44e36f89c1f$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new (0, $8M2bs.default),
        "map": new ((0, $5Gj2X.default) || (0, $dlf4P.default)),
        "string": new (0, $8M2bs.default)
    };
}
var $ed93c44e36f89c1f$export$2e2bcd8739ae039 = $ed93c44e36f89c1f$var$mapCacheClear;

});
parcelRegister("8M2bs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66348011ac2a110f$export$2e2bcd8739ae039; });

var $2aDSK = parcelRequire("2aDSK");

var $1VmKI = parcelRequire("1VmKI");

var $iT1ig = parcelRequire("iT1ig");

var $7gcvJ = parcelRequire("7gcvJ");

var $cF59f = parcelRequire("cF59f");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $66348011ac2a110f$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$66348011ac2a110f$var$Hash.prototype.clear = (0, $2aDSK.default);
$66348011ac2a110f$var$Hash.prototype["delete"] = (0, $1VmKI.default);
$66348011ac2a110f$var$Hash.prototype.get = (0, $iT1ig.default);
$66348011ac2a110f$var$Hash.prototype.has = (0, $7gcvJ.default);
$66348011ac2a110f$var$Hash.prototype.set = (0, $cF59f.default);
var $66348011ac2a110f$export$2e2bcd8739ae039 = $66348011ac2a110f$var$Hash;

});
parcelRegister("2aDSK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $194b73a92e4efb80$export$2e2bcd8739ae039; });

var $3HGab = parcelRequire("3HGab");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $194b73a92e4efb80$var$hashClear() {
    this.__data__ = (0, $3HGab.default) ? (0, $3HGab.default)(null) : {};
    this.size = 0;
}
var $194b73a92e4efb80$export$2e2bcd8739ae039 = $194b73a92e4efb80$var$hashClear;

});
parcelRegister("3HGab", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b2617f9b9d8b9fb$export$2e2bcd8739ae039; });

var $cnWT7 = parcelRequire("cnWT7");
/* Built-in method references that are verified to be native. */ var $2b2617f9b9d8b9fb$var$nativeCreate = (0, $cnWT7.default)(Object, "create");
var $2b2617f9b9d8b9fb$export$2e2bcd8739ae039 = $2b2617f9b9d8b9fb$var$nativeCreate;

});


parcelRegister("1VmKI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $166cc379acadc80f$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $166cc379acadc80f$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $166cc379acadc80f$export$2e2bcd8739ae039 = $166cc379acadc80f$var$hashDelete;

});

parcelRegister("iT1ig", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbfe5df2e345caa4$export$2e2bcd8739ae039; });

var $3HGab = parcelRequire("3HGab");
/** Used to stand-in for `undefined` hash values. */ var $dbfe5df2e345caa4$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $dbfe5df2e345caa4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dbfe5df2e345caa4$var$hasOwnProperty = $dbfe5df2e345caa4$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $dbfe5df2e345caa4$var$hashGet(key) {
    var data = this.__data__;
    if (0, $3HGab.default) {
        var result = data[key];
        return result === $dbfe5df2e345caa4$var$HASH_UNDEFINED ? undefined : result;
    }
    return $dbfe5df2e345caa4$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $dbfe5df2e345caa4$export$2e2bcd8739ae039 = $dbfe5df2e345caa4$var$hashGet;

});

parcelRegister("7gcvJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5493bb62f2318e87$export$2e2bcd8739ae039; });

var $3HGab = parcelRequire("3HGab");
/** Used for built-in method references. */ var $5493bb62f2318e87$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5493bb62f2318e87$var$hasOwnProperty = $5493bb62f2318e87$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $5493bb62f2318e87$var$hashHas(key) {
    var data = this.__data__;
    return (0, $3HGab.default) ? data[key] !== undefined : $5493bb62f2318e87$var$hasOwnProperty.call(data, key);
}
var $5493bb62f2318e87$export$2e2bcd8739ae039 = $5493bb62f2318e87$var$hashHas;

});

parcelRegister("cF59f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $937d4eaa3405f6d2$export$2e2bcd8739ae039; });

var $3HGab = parcelRequire("3HGab");
/** Used to stand-in for `undefined` hash values. */ var $937d4eaa3405f6d2$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $937d4eaa3405f6d2$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $3HGab.default) && value === undefined ? $937d4eaa3405f6d2$var$HASH_UNDEFINED : value;
    return this;
}
var $937d4eaa3405f6d2$export$2e2bcd8739ae039 = $937d4eaa3405f6d2$var$hashSet;

});



parcelRegister("krpQl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee1a603118669651$export$2e2bcd8739ae039; });

var $iFhDd = parcelRequire("iFhDd");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ee1a603118669651$var$mapCacheDelete(key) {
    var result = (0, $iFhDd.default)(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $ee1a603118669651$export$2e2bcd8739ae039 = $ee1a603118669651$var$mapCacheDelete;

});
parcelRegister("iFhDd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d969bb91c9e7ba5a$export$2e2bcd8739ae039; });

var $ddQcW = parcelRequire("ddQcW");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $d969bb91c9e7ba5a$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $ddQcW.default)(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var $d969bb91c9e7ba5a$export$2e2bcd8739ae039 = $d969bb91c9e7ba5a$var$getMapData;

});
parcelRegister("ddQcW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a04fc9d720d6b3c$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $9a04fc9d720d6b3c$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var $9a04fc9d720d6b3c$export$2e2bcd8739ae039 = $9a04fc9d720d6b3c$var$isKeyable;

});



parcelRegister("9mwxA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d0f690b48d61772$export$2e2bcd8739ae039; });

var $iFhDd = parcelRequire("iFhDd");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6d0f690b48d61772$var$mapCacheGet(key) {
    return (0, $iFhDd.default)(this, key).get(key);
}
var $6d0f690b48d61772$export$2e2bcd8739ae039 = $6d0f690b48d61772$var$mapCacheGet;

});

parcelRegister("66SSL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $472de01be4d69782$export$2e2bcd8739ae039; });

var $iFhDd = parcelRequire("iFhDd");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $472de01be4d69782$var$mapCacheHas(key) {
    return (0, $iFhDd.default)(this, key).has(key);
}
var $472de01be4d69782$export$2e2bcd8739ae039 = $472de01be4d69782$var$mapCacheHas;

});

parcelRegister("gUJSA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c50576ffe7171011$export$2e2bcd8739ae039; });

var $iFhDd = parcelRequire("iFhDd");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $c50576ffe7171011$var$mapCacheSet(key, value) {
    var data = (0, $iFhDd.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $c50576ffe7171011$export$2e2bcd8739ae039 = $c50576ffe7171011$var$mapCacheSet;

});




parcelRegister("7KiuO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a3b2d300bbe54a8$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $5a3b2d300bbe54a8$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $5a3b2d300bbe54a8$export$2e2bcd8739ae039 = $5a3b2d300bbe54a8$var$arrayEach;

});

parcelRegister("fOFG0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b83bda9bf2fedf6b$export$2e2bcd8739ae039; });

var $8Xlz0 = parcelRequire("8Xlz0");

var $5TPq9 = parcelRequire("5TPq9");
/** Used for built-in method references. */ var $b83bda9bf2fedf6b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b83bda9bf2fedf6b$var$hasOwnProperty = $b83bda9bf2fedf6b$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $b83bda9bf2fedf6b$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($b83bda9bf2fedf6b$var$hasOwnProperty.call(object, key) && (0, $5TPq9.default)(objValue, value)) || value === undefined && !(key in object)) (0, $8Xlz0.default)(object, key, value);
}
var $b83bda9bf2fedf6b$export$2e2bcd8739ae039 = $b83bda9bf2fedf6b$var$assignValue;

});
parcelRegister("8Xlz0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68548f83f5ce07e3$export$2e2bcd8739ae039; });

var $2cPDw = parcelRequire("2cPDw");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $68548f83f5ce07e3$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && (0, $2cPDw.default)) (0, $2cPDw.default)(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
var $68548f83f5ce07e3$export$2e2bcd8739ae039 = $68548f83f5ce07e3$var$baseAssignValue;

});
parcelRegister("2cPDw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19b4c1adbc8e7dc1$export$2e2bcd8739ae039; });

var $cnWT7 = parcelRequire("cnWT7");
var $19b4c1adbc8e7dc1$var$defineProperty = function() {
    try {
        var func = (0, $cnWT7.default)(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
var $19b4c1adbc8e7dc1$export$2e2bcd8739ae039 = $19b4c1adbc8e7dc1$var$defineProperty;

});



parcelRegister("dgPnQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a94a0b89421f374$export$2e2bcd8739ae039; });

var $4Ekk0 = parcelRequire("4Ekk0");

var $31LnV = parcelRequire("31LnV");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $9a94a0b89421f374$var$baseAssign(object, source) {
    return object && (0, $4Ekk0.default)(source, (0, $31LnV.default)(source), object);
}
var $9a94a0b89421f374$export$2e2bcd8739ae039 = $9a94a0b89421f374$var$baseAssign;

});
parcelRegister("4Ekk0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $362aa94f6d2f95d1$export$2e2bcd8739ae039; });

var $fOFG0 = parcelRequire("fOFG0");

var $8Xlz0 = parcelRequire("8Xlz0");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $362aa94f6d2f95d1$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $8Xlz0.default)(object, key, newValue);
        else (0, $fOFG0.default)(object, key, newValue);
    }
    return object;
}
var $362aa94f6d2f95d1$export$2e2bcd8739ae039 = $362aa94f6d2f95d1$var$copyObject;

});

parcelRegister("31LnV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $234638bc457b2507$export$2e2bcd8739ae039; });

var $9uyOq = parcelRequire("9uyOq");

var $arXl8 = parcelRequire("arXl8");

var $b9DUl = parcelRequire("b9DUl");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $234638bc457b2507$var$keys(object) {
    return (0, $b9DUl.default)(object) ? (0, $9uyOq.default)(object) : (0, $arXl8.default)(object);
}
var $234638bc457b2507$export$2e2bcd8739ae039 = $234638bc457b2507$var$keys;

});
parcelRegister("9uyOq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e91eb6956218860$export$2e2bcd8739ae039; });

var $eASwy = parcelRequire("eASwy");

var $774DM = parcelRequire("774DM");

var $eA9yl = parcelRequire("eA9yl");

var $43Y3b = parcelRequire("43Y3b");

var $7Jqv7 = parcelRequire("7Jqv7");

var $dK8Wz = parcelRequire("dK8Wz");
/** Used for built-in method references. */ var $6e91eb6956218860$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6e91eb6956218860$var$hasOwnProperty = $6e91eb6956218860$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $6e91eb6956218860$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $eA9yl.default)(value), isArg = !isArr && (0, $774DM.default)(value), isBuff = !isArr && !isArg && (0, $43Y3b.default)(value), isType = !isArr && !isArg && !isBuff && (0, $dK8Wz.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $eASwy.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $6e91eb6956218860$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    (0, $7Jqv7.default)(key, length)))) result.push(key);
    return result;
}
var $6e91eb6956218860$export$2e2bcd8739ae039 = $6e91eb6956218860$var$arrayLikeKeys;

});
parcelRegister("eASwy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9feb8d74cb60a7d$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $a9feb8d74cb60a7d$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $a9feb8d74cb60a7d$export$2e2bcd8739ae039 = $a9feb8d74cb60a7d$var$baseTimes;

});

parcelRegister("774DM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52dcc9623304e2de$export$2e2bcd8739ae039; });

var $8Zkg4 = parcelRequire("8Zkg4");

var $9XysK = parcelRequire("9XysK");
/** Used for built-in method references. */ var $52dcc9623304e2de$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $52dcc9623304e2de$var$hasOwnProperty = $52dcc9623304e2de$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $52dcc9623304e2de$var$propertyIsEnumerable = $52dcc9623304e2de$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $52dcc9623304e2de$var$isArguments = (0, $8Zkg4.default)(function() {
    return arguments;
}()) ? (0, $8Zkg4.default) : function(value) {
    return (0, $9XysK.default)(value) && $52dcc9623304e2de$var$hasOwnProperty.call(value, "callee") && !$52dcc9623304e2de$var$propertyIsEnumerable.call(value, "callee");
};
var $52dcc9623304e2de$export$2e2bcd8739ae039 = $52dcc9623304e2de$var$isArguments;

});
parcelRegister("8Zkg4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68b3bc174c908ae4$export$2e2bcd8739ae039; });

var $2cf7J = parcelRequire("2cf7J");

var $9XysK = parcelRequire("9XysK");
/** `Object#toString` result references. */ var $68b3bc174c908ae4$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $68b3bc174c908ae4$var$baseIsArguments(value) {
    return (0, $9XysK.default)(value) && (0, $2cf7J.default)(value) == $68b3bc174c908ae4$var$argsTag;
}
var $68b3bc174c908ae4$export$2e2bcd8739ae039 = $68b3bc174c908ae4$var$baseIsArguments;

});


parcelRegister("eA9yl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9dbd684194449d8$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $a9dbd684194449d8$var$isArray = Array.isArray;
var $a9dbd684194449d8$export$2e2bcd8739ae039 = $a9dbd684194449d8$var$isArray;

});

parcelRegister("43Y3b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f5605ffe485255e$export$2e2bcd8739ae039; });

var $cbL8G = parcelRequire("cbL8G");

var $joVH4 = parcelRequire("joVH4");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $cbL8G.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $joVH4.default);
var $2f5605ffe485255e$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("joVH4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1fd02fbb24c22b3$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $e1fd02fbb24c22b3$var$stubFalse() {
    return false;
}
var $e1fd02fbb24c22b3$export$2e2bcd8739ae039 = $e1fd02fbb24c22b3$var$stubFalse;

});


parcelRegister("7Jqv7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a114ae0fb35c4fe$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $5a114ae0fb35c4fe$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $5a114ae0fb35c4fe$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $5a114ae0fb35c4fe$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $5a114ae0fb35c4fe$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $5a114ae0fb35c4fe$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $5a114ae0fb35c4fe$export$2e2bcd8739ae039 = $5a114ae0fb35c4fe$var$isIndex;

});

parcelRegister("dK8Wz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a016824551b15f1b$export$2e2bcd8739ae039; });

var $KChjy = parcelRequire("KChjy");

var $aN9tr = parcelRequire("aN9tr");

var $lDlcQ = parcelRequire("lDlcQ");
/* Node.js helper references. */ var $a016824551b15f1b$var$nodeIsTypedArray = (0, $lDlcQ.default) && (0, $lDlcQ.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $a016824551b15f1b$var$isTypedArray = $a016824551b15f1b$var$nodeIsTypedArray ? (0, $aN9tr.default)($a016824551b15f1b$var$nodeIsTypedArray) : (0, $KChjy.default);
var $a016824551b15f1b$export$2e2bcd8739ae039 = $a016824551b15f1b$var$isTypedArray;

});
parcelRegister("KChjy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08c1fd421f878292$export$2e2bcd8739ae039; });

var $2cf7J = parcelRequire("2cf7J");

var $XPYOH = parcelRequire("XPYOH");

var $9XysK = parcelRequire("9XysK");
/** `Object#toString` result references. */ var $08c1fd421f878292$var$argsTag = "[object Arguments]", $08c1fd421f878292$var$arrayTag = "[object Array]", $08c1fd421f878292$var$boolTag = "[object Boolean]", $08c1fd421f878292$var$dateTag = "[object Date]", $08c1fd421f878292$var$errorTag = "[object Error]", $08c1fd421f878292$var$funcTag = "[object Function]", $08c1fd421f878292$var$mapTag = "[object Map]", $08c1fd421f878292$var$numberTag = "[object Number]", $08c1fd421f878292$var$objectTag = "[object Object]", $08c1fd421f878292$var$regexpTag = "[object RegExp]", $08c1fd421f878292$var$setTag = "[object Set]", $08c1fd421f878292$var$stringTag = "[object String]", $08c1fd421f878292$var$weakMapTag = "[object WeakMap]";
var $08c1fd421f878292$var$arrayBufferTag = "[object ArrayBuffer]", $08c1fd421f878292$var$dataViewTag = "[object DataView]", $08c1fd421f878292$var$float32Tag = "[object Float32Array]", $08c1fd421f878292$var$float64Tag = "[object Float64Array]", $08c1fd421f878292$var$int8Tag = "[object Int8Array]", $08c1fd421f878292$var$int16Tag = "[object Int16Array]", $08c1fd421f878292$var$int32Tag = "[object Int32Array]", $08c1fd421f878292$var$uint8Tag = "[object Uint8Array]", $08c1fd421f878292$var$uint8ClampedTag = "[object Uint8ClampedArray]", $08c1fd421f878292$var$uint16Tag = "[object Uint16Array]", $08c1fd421f878292$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $08c1fd421f878292$var$typedArrayTags = {};
$08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$float32Tag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$float64Tag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$int8Tag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$int16Tag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$int32Tag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$uint8Tag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$uint8ClampedTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$uint16Tag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$uint32Tag] = true;
$08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$argsTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$arrayTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$arrayBufferTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$boolTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$dataViewTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$dateTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$errorTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$funcTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$mapTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$numberTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$objectTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$regexpTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$setTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$stringTag] = $08c1fd421f878292$var$typedArrayTags[$08c1fd421f878292$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $08c1fd421f878292$var$baseIsTypedArray(value) {
    return (0, $9XysK.default)(value) && (0, $XPYOH.default)(value.length) && !!$08c1fd421f878292$var$typedArrayTags[(0, $2cf7J.default)(value)];
}
var $08c1fd421f878292$export$2e2bcd8739ae039 = $08c1fd421f878292$var$baseIsTypedArray;

});
parcelRegister("XPYOH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b3dd4ee5450b764$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $0b3dd4ee5450b764$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $0b3dd4ee5450b764$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $0b3dd4ee5450b764$var$MAX_SAFE_INTEGER;
}
var $0b3dd4ee5450b764$export$2e2bcd8739ae039 = $0b3dd4ee5450b764$var$isLength;

});


parcelRegister("aN9tr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7db5d44ae8b6fe1a$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $7db5d44ae8b6fe1a$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $7db5d44ae8b6fe1a$export$2e2bcd8739ae039 = $7db5d44ae8b6fe1a$var$baseUnary;

});

parcelRegister("lDlcQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbfdb09b26f3ae19$export$2e2bcd8739ae039; });

var $fJlIs = parcelRequire("fJlIs");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $fJlIs.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
var $fbfdb09b26f3ae19$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("arXl8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79ba74a54de5c743$export$2e2bcd8739ae039; });

var $jcgNC = parcelRequire("jcgNC");

var $9CgKH = parcelRequire("9CgKH");
/** Used for built-in method references. */ var $79ba74a54de5c743$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $79ba74a54de5c743$var$hasOwnProperty = $79ba74a54de5c743$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $79ba74a54de5c743$var$baseKeys(object) {
    if (!(0, $jcgNC.default)(object)) return (0, $9CgKH.default)(object);
    var result = [];
    for(var key in Object(object))if ($79ba74a54de5c743$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
var $79ba74a54de5c743$export$2e2bcd8739ae039 = $79ba74a54de5c743$var$baseKeys;

});
parcelRegister("jcgNC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df9c2b4f37188c4d$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $df9c2b4f37188c4d$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $df9c2b4f37188c4d$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $df9c2b4f37188c4d$var$objectProto;
    return value === proto;
}
var $df9c2b4f37188c4d$export$2e2bcd8739ae039 = $df9c2b4f37188c4d$var$isPrototype;

});

parcelRegister("9CgKH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7004a84f56b52e2e$export$2e2bcd8739ae039; });

var $ayyI5 = parcelRequire("ayyI5");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7004a84f56b52e2e$var$nativeKeys = (0, $ayyI5.default)(Object.keys, Object);
var $7004a84f56b52e2e$export$2e2bcd8739ae039 = $7004a84f56b52e2e$var$nativeKeys;

});


parcelRegister("b9DUl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81ef7dd384cb8657$export$2e2bcd8739ae039; });

var $65Nb9 = parcelRequire("65Nb9");

var $XPYOH = parcelRequire("XPYOH");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $81ef7dd384cb8657$var$isArrayLike(value) {
    return value != null && (0, $XPYOH.default)(value.length) && !(0, $65Nb9.default)(value);
}
var $81ef7dd384cb8657$export$2e2bcd8739ae039 = $81ef7dd384cb8657$var$isArrayLike;

});



parcelRegister("fqUOE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3c55b33a4ec0faa$export$2e2bcd8739ae039; });

var $4Ekk0 = parcelRequire("4Ekk0");

var $efjUI = parcelRequire("efjUI");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $b3c55b33a4ec0faa$var$baseAssignIn(object, source) {
    return object && (0, $4Ekk0.default)(source, (0, $efjUI.default)(source), object);
}
var $b3c55b33a4ec0faa$export$2e2bcd8739ae039 = $b3c55b33a4ec0faa$var$baseAssignIn;

});
parcelRegister("efjUI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5f1e9df7c323e49$export$2e2bcd8739ae039; });

var $9uyOq = parcelRequire("9uyOq");

var $aUFmV = parcelRequire("aUFmV");

var $b9DUl = parcelRequire("b9DUl");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $a5f1e9df7c323e49$var$keysIn(object) {
    return (0, $b9DUl.default)(object) ? (0, $9uyOq.default)(object, true) : (0, $aUFmV.default)(object);
}
var $a5f1e9df7c323e49$export$2e2bcd8739ae039 = $a5f1e9df7c323e49$var$keysIn;

});
parcelRegister("aUFmV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f1f3956e8977175$export$2e2bcd8739ae039; });

var $55CT4 = parcelRequire("55CT4");

var $jcgNC = parcelRequire("jcgNC");

var $aEMAF = parcelRequire("aEMAF");
/** Used for built-in method references. */ var $7f1f3956e8977175$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7f1f3956e8977175$var$hasOwnProperty = $7f1f3956e8977175$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $7f1f3956e8977175$var$baseKeysIn(object) {
    if (!(0, $55CT4.default)(object)) return (0, $aEMAF.default)(object);
    var isProto = (0, $jcgNC.default)(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$7f1f3956e8977175$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $7f1f3956e8977175$export$2e2bcd8739ae039 = $7f1f3956e8977175$var$baseKeysIn;

});
parcelRegister("aEMAF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c2354e0bd7393d1$export$2e2bcd8739ae039; });
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $7c2354e0bd7393d1$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $7c2354e0bd7393d1$export$2e2bcd8739ae039 = $7c2354e0bd7393d1$var$nativeKeysIn;

});




parcelRegister("jXF4S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8836429fc7198d7$export$2e2bcd8739ae039; });

var $cbL8G = parcelRequire("cbL8G");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $cbL8G.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $e8836429fc7198d7$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("7KNPo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a537b0c8857c242$export$2e2bcd8739ae039; });
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $5a537b0c8857c242$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $5a537b0c8857c242$export$2e2bcd8739ae039 = $5a537b0c8857c242$var$copyArray;

});

parcelRegister("XexYp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b20cb8671f49c29$export$2e2bcd8739ae039; });

var $4Ekk0 = parcelRequire("4Ekk0");

var $1QurG = parcelRequire("1QurG");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $0b20cb8671f49c29$var$copySymbols(source, object) {
    return (0, $4Ekk0.default)(source, (0, $1QurG.default)(source), object);
}
var $0b20cb8671f49c29$export$2e2bcd8739ae039 = $0b20cb8671f49c29$var$copySymbols;

});
parcelRegister("1QurG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1582439f74c1dc77$export$2e2bcd8739ae039; });

var $gehIv = parcelRequire("gehIv");

var $ag1N4 = parcelRequire("ag1N4");
/** Used for built-in method references. */ var $1582439f74c1dc77$var$objectProto = Object.prototype;
/** Built-in value references. */ var $1582439f74c1dc77$var$propertyIsEnumerable = $1582439f74c1dc77$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $1582439f74c1dc77$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $1582439f74c1dc77$var$getSymbols = !$1582439f74c1dc77$var$nativeGetSymbols ? (0, $ag1N4.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $gehIv.default)($1582439f74c1dc77$var$nativeGetSymbols(object), function(symbol) {
        return $1582439f74c1dc77$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $1582439f74c1dc77$export$2e2bcd8739ae039 = $1582439f74c1dc77$var$getSymbols;

});
parcelRegister("gehIv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd0bb256a5a104cb$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $bd0bb256a5a104cb$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $bd0bb256a5a104cb$export$2e2bcd8739ae039 = $bd0bb256a5a104cb$var$arrayFilter;

});

parcelRegister("ag1N4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $777cc98a7333c527$export$2e2bcd8739ae039; });
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $777cc98a7333c527$var$stubArray() {
    return [];
}
var $777cc98a7333c527$export$2e2bcd8739ae039 = $777cc98a7333c527$var$stubArray;

});



parcelRegister("8NC4G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66806f1f76f1e804$export$2e2bcd8739ae039; });

var $4Ekk0 = parcelRequire("4Ekk0");

var $j2qXE = parcelRequire("j2qXE");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $66806f1f76f1e804$var$copySymbolsIn(source, object) {
    return (0, $4Ekk0.default)(source, (0, $j2qXE.default)(source), object);
}
var $66806f1f76f1e804$export$2e2bcd8739ae039 = $66806f1f76f1e804$var$copySymbolsIn;

});
parcelRegister("j2qXE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddc31e2885df0493$export$2e2bcd8739ae039; });

var $b68hM = parcelRequire("b68hM");

var $d18qD = parcelRequire("d18qD");

var $1QurG = parcelRequire("1QurG");

var $ag1N4 = parcelRequire("ag1N4");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ddc31e2885df0493$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $ddc31e2885df0493$var$getSymbolsIn = !$ddc31e2885df0493$var$nativeGetSymbols ? (0, $ag1N4.default) : function(object) {
    var result = [];
    while(object){
        (0, $b68hM.default)(result, (0, $1QurG.default)(object));
        object = (0, $d18qD.default)(object);
    }
    return result;
};
var $ddc31e2885df0493$export$2e2bcd8739ae039 = $ddc31e2885df0493$var$getSymbolsIn;

});
parcelRegister("b68hM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8146aea68b56bf82$export$2e2bcd8739ae039; });
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $8146aea68b56bf82$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $8146aea68b56bf82$export$2e2bcd8739ae039 = $8146aea68b56bf82$var$arrayPush;

});



parcelRegister("eNbR6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac4ed68d4381894e$export$2e2bcd8739ae039; });

var $aM6gW = parcelRequire("aM6gW");

var $1QurG = parcelRequire("1QurG");

var $31LnV = parcelRequire("31LnV");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $ac4ed68d4381894e$var$getAllKeys(object) {
    return (0, $aM6gW.default)(object, (0, $31LnV.default), (0, $1QurG.default));
}
var $ac4ed68d4381894e$export$2e2bcd8739ae039 = $ac4ed68d4381894e$var$getAllKeys;

});
parcelRegister("aM6gW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d8340a146618e30$export$2e2bcd8739ae039; });

var $b68hM = parcelRequire("b68hM");

var $eA9yl = parcelRequire("eA9yl");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7d8340a146618e30$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $eA9yl.default)(object) ? result : (0, $b68hM.default)(result, symbolsFunc(object));
}
var $7d8340a146618e30$export$2e2bcd8739ae039 = $7d8340a146618e30$var$baseGetAllKeys;

});


parcelRegister("9atCI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6acc06d55696b3a6$export$2e2bcd8739ae039; });

var $aM6gW = parcelRequire("aM6gW");

var $j2qXE = parcelRequire("j2qXE");

var $efjUI = parcelRequire("efjUI");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $6acc06d55696b3a6$var$getAllKeysIn(object) {
    return (0, $aM6gW.default)(object, (0, $efjUI.default), (0, $j2qXE.default));
}
var $6acc06d55696b3a6$export$2e2bcd8739ae039 = $6acc06d55696b3a6$var$getAllKeysIn;

});

parcelRegister("6JaTE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e5f65e85b625cf1$export$2e2bcd8739ae039; });

var $dZqjW = parcelRequire("dZqjW");

var $5Gj2X = parcelRequire("5Gj2X");

var $gY81o = parcelRequire("gY81o");

var $jJJkK = parcelRequire("jJJkK");

var $hmIjW = parcelRequire("hmIjW");

var $2cf7J = parcelRequire("2cf7J");

var $ki9xX = parcelRequire("ki9xX");
/** `Object#toString` result references. */ var $4e5f65e85b625cf1$var$mapTag = "[object Map]", $4e5f65e85b625cf1$var$objectTag = "[object Object]", $4e5f65e85b625cf1$var$promiseTag = "[object Promise]", $4e5f65e85b625cf1$var$setTag = "[object Set]", $4e5f65e85b625cf1$var$weakMapTag = "[object WeakMap]";
var $4e5f65e85b625cf1$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $4e5f65e85b625cf1$var$dataViewCtorString = (0, $ki9xX.default)((0, $dZqjW.default)), $4e5f65e85b625cf1$var$mapCtorString = (0, $ki9xX.default)((0, $5Gj2X.default)), $4e5f65e85b625cf1$var$promiseCtorString = (0, $ki9xX.default)((0, $gY81o.default)), $4e5f65e85b625cf1$var$setCtorString = (0, $ki9xX.default)((0, $jJJkK.default)), $4e5f65e85b625cf1$var$weakMapCtorString = (0, $ki9xX.default)((0, $hmIjW.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $4e5f65e85b625cf1$var$getTag = (0, $2cf7J.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $dZqjW.default) && $4e5f65e85b625cf1$var$getTag(new (0, $dZqjW.default)(new ArrayBuffer(1))) != $4e5f65e85b625cf1$var$dataViewTag || (0, $5Gj2X.default) && $4e5f65e85b625cf1$var$getTag(new (0, $5Gj2X.default)) != $4e5f65e85b625cf1$var$mapTag || (0, $gY81o.default) && $4e5f65e85b625cf1$var$getTag((0, $gY81o.default).resolve()) != $4e5f65e85b625cf1$var$promiseTag || (0, $jJJkK.default) && $4e5f65e85b625cf1$var$getTag(new (0, $jJJkK.default)) != $4e5f65e85b625cf1$var$setTag || (0, $hmIjW.default) && $4e5f65e85b625cf1$var$getTag(new (0, $hmIjW.default)) != $4e5f65e85b625cf1$var$weakMapTag) $4e5f65e85b625cf1$var$getTag = function(value) {
    var result = (0, $2cf7J.default)(value), Ctor = result == $4e5f65e85b625cf1$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $ki9xX.default)(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $4e5f65e85b625cf1$var$dataViewCtorString:
            return $4e5f65e85b625cf1$var$dataViewTag;
        case $4e5f65e85b625cf1$var$mapCtorString:
            return $4e5f65e85b625cf1$var$mapTag;
        case $4e5f65e85b625cf1$var$promiseCtorString:
            return $4e5f65e85b625cf1$var$promiseTag;
        case $4e5f65e85b625cf1$var$setCtorString:
            return $4e5f65e85b625cf1$var$setTag;
        case $4e5f65e85b625cf1$var$weakMapCtorString:
            return $4e5f65e85b625cf1$var$weakMapTag;
    }
    return result;
};
var $4e5f65e85b625cf1$export$2e2bcd8739ae039 = $4e5f65e85b625cf1$var$getTag;

});
parcelRegister("dZqjW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2f5639d4540d038$export$2e2bcd8739ae039; });

var $cnWT7 = parcelRequire("cnWT7");

var $cbL8G = parcelRequire("cbL8G");
/* Built-in method references that are verified to be native. */ var $a2f5639d4540d038$var$DataView = (0, $cnWT7.default)((0, $cbL8G.default), "DataView");
var $a2f5639d4540d038$export$2e2bcd8739ae039 = $a2f5639d4540d038$var$DataView;

});

parcelRegister("gY81o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5a878d0dd8cec2f$export$2e2bcd8739ae039; });

var $cnWT7 = parcelRequire("cnWT7");

var $cbL8G = parcelRequire("cbL8G");
/* Built-in method references that are verified to be native. */ var $c5a878d0dd8cec2f$var$Promise = (0, $cnWT7.default)((0, $cbL8G.default), "Promise");
var $c5a878d0dd8cec2f$export$2e2bcd8739ae039 = $c5a878d0dd8cec2f$var$Promise;

});

parcelRegister("jJJkK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5e5629a593ab776$export$2e2bcd8739ae039; });

var $cnWT7 = parcelRequire("cnWT7");

var $cbL8G = parcelRequire("cbL8G");
/* Built-in method references that are verified to be native. */ var $e5e5629a593ab776$var$Set = (0, $cnWT7.default)((0, $cbL8G.default), "Set");
var $e5e5629a593ab776$export$2e2bcd8739ae039 = $e5e5629a593ab776$var$Set;

});

parcelRegister("hmIjW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca46dedfd4ba46c8$export$2e2bcd8739ae039; });

var $cnWT7 = parcelRequire("cnWT7");

var $cbL8G = parcelRequire("cbL8G");
/* Built-in method references that are verified to be native. */ var $ca46dedfd4ba46c8$var$WeakMap = (0, $cnWT7.default)((0, $cbL8G.default), "WeakMap");
var $ca46dedfd4ba46c8$export$2e2bcd8739ae039 = $ca46dedfd4ba46c8$var$WeakMap;

});


parcelRegister("fGAmH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6b6fca2f508e28b$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $b6b6fca2f508e28b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b6b6fca2f508e28b$var$hasOwnProperty = $b6b6fca2f508e28b$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $b6b6fca2f508e28b$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $b6b6fca2f508e28b$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $b6b6fca2f508e28b$export$2e2bcd8739ae039 = $b6b6fca2f508e28b$var$initCloneArray;

});

parcelRegister("25BDK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18593ef69d45065f$export$2e2bcd8739ae039; });

var $1jUaD = parcelRequire("1jUaD");

var $9tIkH = parcelRequire("9tIkH");

var $8PUq0 = parcelRequire("8PUq0");

var $564q2 = parcelRequire("564q2");

var $1Z4Db = parcelRequire("1Z4Db");
/** `Object#toString` result references. */ var $18593ef69d45065f$var$boolTag = "[object Boolean]", $18593ef69d45065f$var$dateTag = "[object Date]", $18593ef69d45065f$var$mapTag = "[object Map]", $18593ef69d45065f$var$numberTag = "[object Number]", $18593ef69d45065f$var$regexpTag = "[object RegExp]", $18593ef69d45065f$var$setTag = "[object Set]", $18593ef69d45065f$var$stringTag = "[object String]", $18593ef69d45065f$var$symbolTag = "[object Symbol]";
var $18593ef69d45065f$var$arrayBufferTag = "[object ArrayBuffer]", $18593ef69d45065f$var$dataViewTag = "[object DataView]", $18593ef69d45065f$var$float32Tag = "[object Float32Array]", $18593ef69d45065f$var$float64Tag = "[object Float64Array]", $18593ef69d45065f$var$int8Tag = "[object Int8Array]", $18593ef69d45065f$var$int16Tag = "[object Int16Array]", $18593ef69d45065f$var$int32Tag = "[object Int32Array]", $18593ef69d45065f$var$uint8Tag = "[object Uint8Array]", $18593ef69d45065f$var$uint8ClampedTag = "[object Uint8ClampedArray]", $18593ef69d45065f$var$uint16Tag = "[object Uint16Array]", $18593ef69d45065f$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $18593ef69d45065f$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $18593ef69d45065f$var$arrayBufferTag:
            return (0, $1jUaD.default)(object);
        case $18593ef69d45065f$var$boolTag:
        case $18593ef69d45065f$var$dateTag:
            return new Ctor(+object);
        case $18593ef69d45065f$var$dataViewTag:
            return (0, $9tIkH.default)(object, isDeep);
        case $18593ef69d45065f$var$float32Tag:
        case $18593ef69d45065f$var$float64Tag:
        case $18593ef69d45065f$var$int8Tag:
        case $18593ef69d45065f$var$int16Tag:
        case $18593ef69d45065f$var$int32Tag:
        case $18593ef69d45065f$var$uint8Tag:
        case $18593ef69d45065f$var$uint8ClampedTag:
        case $18593ef69d45065f$var$uint16Tag:
        case $18593ef69d45065f$var$uint32Tag:
            return (0, $1Z4Db.default)(object, isDeep);
        case $18593ef69d45065f$var$mapTag:
            return new Ctor;
        case $18593ef69d45065f$var$numberTag:
        case $18593ef69d45065f$var$stringTag:
            return new Ctor(object);
        case $18593ef69d45065f$var$regexpTag:
            return (0, $8PUq0.default)(object);
        case $18593ef69d45065f$var$setTag:
            return new Ctor;
        case $18593ef69d45065f$var$symbolTag:
            return (0, $564q2.default)(object);
    }
}
var $18593ef69d45065f$export$2e2bcd8739ae039 = $18593ef69d45065f$var$initCloneByTag;

});
parcelRegister("1jUaD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f63231dbc1eaaed$export$2e2bcd8739ae039; });

var $hNU6C = parcelRequire("hNU6C");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $0f63231dbc1eaaed$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $hNU6C.default)(result).set(new (0, $hNU6C.default)(arrayBuffer));
    return result;
}
var $0f63231dbc1eaaed$export$2e2bcd8739ae039 = $0f63231dbc1eaaed$var$cloneArrayBuffer;

});
parcelRegister("hNU6C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf6288b37fed1716$export$2e2bcd8739ae039; });

var $cbL8G = parcelRequire("cbL8G");
/** Built-in value references. */ var $cf6288b37fed1716$var$Uint8Array = (0, $cbL8G.default).Uint8Array;
var $cf6288b37fed1716$export$2e2bcd8739ae039 = $cf6288b37fed1716$var$Uint8Array;

});


parcelRegister("9tIkH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e69360e8e6cb743$export$2e2bcd8739ae039; });

var $1jUaD = parcelRequire("1jUaD");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $6e69360e8e6cb743$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $1jUaD.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $6e69360e8e6cb743$export$2e2bcd8739ae039 = $6e69360e8e6cb743$var$cloneDataView;

});

parcelRegister("8PUq0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66eed9a82bb5fa2e$export$2e2bcd8739ae039; });
/** Used to match `RegExp` flags from their coerced string values. */ var $66eed9a82bb5fa2e$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $66eed9a82bb5fa2e$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $66eed9a82bb5fa2e$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $66eed9a82bb5fa2e$export$2e2bcd8739ae039 = $66eed9a82bb5fa2e$var$cloneRegExp;

});

parcelRegister("564q2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b60f0d384d5d47a$export$2e2bcd8739ae039; });

var $hwtsf = parcelRequire("hwtsf");
/** Used to convert symbols to primitives and strings. */ var $3b60f0d384d5d47a$var$symbolProto = (0, $hwtsf.default) ? (0, $hwtsf.default).prototype : undefined, $3b60f0d384d5d47a$var$symbolValueOf = $3b60f0d384d5d47a$var$symbolProto ? $3b60f0d384d5d47a$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $3b60f0d384d5d47a$var$cloneSymbol(symbol) {
    return $3b60f0d384d5d47a$var$symbolValueOf ? Object($3b60f0d384d5d47a$var$symbolValueOf.call(symbol)) : {};
}
var $3b60f0d384d5d47a$export$2e2bcd8739ae039 = $3b60f0d384d5d47a$var$cloneSymbol;

});

parcelRegister("1Z4Db", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $171f149280584028$export$2e2bcd8739ae039; });

var $1jUaD = parcelRequire("1jUaD");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $171f149280584028$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $1jUaD.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $171f149280584028$export$2e2bcd8739ae039 = $171f149280584028$var$cloneTypedArray;

});


parcelRegister("55JsH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b50af285f841ab5$export$2e2bcd8739ae039; });

var $79thx = parcelRequire("79thx");

var $d18qD = parcelRequire("d18qD");

var $jcgNC = parcelRequire("jcgNC");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $3b50af285f841ab5$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !(0, $jcgNC.default)(object) ? (0, $79thx.default)((0, $d18qD.default)(object)) : {};
}
var $3b50af285f841ab5$export$2e2bcd8739ae039 = $3b50af285f841ab5$var$initCloneObject;

});
parcelRegister("79thx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5350166b48b30c0b$export$2e2bcd8739ae039; });

var $55CT4 = parcelRequire("55CT4");
/** Built-in value references. */ var $5350166b48b30c0b$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $5350166b48b30c0b$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $55CT4.default)(proto)) return {};
        if ($5350166b48b30c0b$var$objectCreate) return $5350166b48b30c0b$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $5350166b48b30c0b$export$2e2bcd8739ae039 = $5350166b48b30c0b$var$baseCreate;

});


parcelRegister("28u2G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18e3a1e0ceac94be$export$2e2bcd8739ae039; });

var $4MjHA = parcelRequire("4MjHA");

var $aN9tr = parcelRequire("aN9tr");

var $lDlcQ = parcelRequire("lDlcQ");
/* Node.js helper references. */ var $18e3a1e0ceac94be$var$nodeIsMap = (0, $lDlcQ.default) && (0, $lDlcQ.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $18e3a1e0ceac94be$var$isMap = $18e3a1e0ceac94be$var$nodeIsMap ? (0, $aN9tr.default)($18e3a1e0ceac94be$var$nodeIsMap) : (0, $4MjHA.default);
var $18e3a1e0ceac94be$export$2e2bcd8739ae039 = $18e3a1e0ceac94be$var$isMap;

});
parcelRegister("4MjHA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37aaed8c35f4b509$export$2e2bcd8739ae039; });

var $6JaTE = parcelRequire("6JaTE");

var $9XysK = parcelRequire("9XysK");
/** `Object#toString` result references. */ var $37aaed8c35f4b509$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $37aaed8c35f4b509$var$baseIsMap(value) {
    return (0, $9XysK.default)(value) && (0, $6JaTE.default)(value) == $37aaed8c35f4b509$var$mapTag;
}
var $37aaed8c35f4b509$export$2e2bcd8739ae039 = $37aaed8c35f4b509$var$baseIsMap;

});


parcelRegister("eoSgZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7bd680c92dcfdec$export$2e2bcd8739ae039; });

var $hJqr3 = parcelRequire("hJqr3");

var $aN9tr = parcelRequire("aN9tr");

var $lDlcQ = parcelRequire("lDlcQ");
/* Node.js helper references. */ var $a7bd680c92dcfdec$var$nodeIsSet = (0, $lDlcQ.default) && (0, $lDlcQ.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $a7bd680c92dcfdec$var$isSet = $a7bd680c92dcfdec$var$nodeIsSet ? (0, $aN9tr.default)($a7bd680c92dcfdec$var$nodeIsSet) : (0, $hJqr3.default);
var $a7bd680c92dcfdec$export$2e2bcd8739ae039 = $a7bd680c92dcfdec$var$isSet;

});
parcelRegister("hJqr3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce8b252015e19951$export$2e2bcd8739ae039; });

var $6JaTE = parcelRequire("6JaTE");

var $9XysK = parcelRequire("9XysK");
/** `Object#toString` result references. */ var $ce8b252015e19951$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $ce8b252015e19951$var$baseIsSet(value) {
    return (0, $9XysK.default)(value) && (0, $6JaTE.default)(value) == $ce8b252015e19951$var$setTag;
}
var $ce8b252015e19951$export$2e2bcd8739ae039 = $ce8b252015e19951$var$baseIsSet;

});




parcelRegister("eHMvZ", function(module, exports) {
"use strict";
var $ab4ab6eb8128c55e$var$isArray = Array.isArray;
var $ab4ab6eb8128c55e$var$keyList = Object.keys;
var $ab4ab6eb8128c55e$var$hasProp = Object.prototype.hasOwnProperty;
var $ab4ab6eb8128c55e$var$hasElementType = typeof Element !== "undefined";
function $ab4ab6eb8128c55e$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        var arrA = $ab4ab6eb8128c55e$var$isArray(a), arrB = $ab4ab6eb8128c55e$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$ab4ab6eb8128c55e$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $ab4ab6eb8128c55e$var$keyList(a);
        length = keys.length;
        if (length !== $ab4ab6eb8128c55e$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$ab4ab6eb8128c55e$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($ab4ab6eb8128c55e$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$ab4ab6eb8128c55e$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $ab4ab6eb8128c55e$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("Warning: react-fast-compare does not handle circular references.", error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("7li8V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55889165d71428b3$export$2e2bcd8739ae039; });
var $55889165d71428b3$var$isProduction = true;
function $55889165d71428b3$var$warning(condition, message) {
    if (!$55889165d71428b3$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $55889165d71428b3$export$2e2bcd8739ae039 = $55889165d71428b3$var$warning;

});

parcelRegister("aAHHW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b5f2b9be7f2363e$export$2e2bcd8739ae039; });

var $5t0O7 = parcelRequire("5t0O7");
/** Used to compose bitmasks for cloning. */ var $7b5f2b9be7f2363e$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $7b5f2b9be7f2363e$var$clone(value) {
    return (0, $5t0O7.default)(value, $7b5f2b9be7f2363e$var$CLONE_SYMBOLS_FLAG);
}
var $7b5f2b9be7f2363e$export$2e2bcd8739ae039 = $7b5f2b9be7f2363e$var$clone;

});

parcelRegister("cDRNl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9342db154376ebed$export$2e2bcd8739ae039; });

var $51q5w = parcelRequire("51q5w");

var $7KNPo = parcelRequire("7KNPo");

var $eA9yl = parcelRequire("eA9yl");

var $fdbzE = parcelRequire("fdbzE");

var $2nPhd = parcelRequire("2nPhd");

var $e9clf = parcelRequire("e9clf");

var $hghOo = parcelRequire("hghOo");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $9342db154376ebed$var$toPath(value) {
    if ((0, $eA9yl.default)(value)) return (0, $51q5w.default)(value, (0, $e9clf.default));
    return (0, $fdbzE.default)(value) ? [
        value
    ] : (0, $7KNPo.default)((0, $2nPhd.default)((0, $hghOo.default)(value)));
}
var $9342db154376ebed$export$2e2bcd8739ae039 = $9342db154376ebed$var$toPath;

});
parcelRegister("51q5w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a81484c1238e5f7$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $3a81484c1238e5f7$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $3a81484c1238e5f7$export$2e2bcd8739ae039 = $3a81484c1238e5f7$var$arrayMap;

});

parcelRegister("fdbzE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1310c491d0c8521$export$2e2bcd8739ae039; });

var $2cf7J = parcelRequire("2cf7J");

var $9XysK = parcelRequire("9XysK");
/** `Object#toString` result references. */ var $b1310c491d0c8521$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $b1310c491d0c8521$var$isSymbol(value) {
    return typeof value == "symbol" || (0, $9XysK.default)(value) && (0, $2cf7J.default)(value) == $b1310c491d0c8521$var$symbolTag;
}
var $b1310c491d0c8521$export$2e2bcd8739ae039 = $b1310c491d0c8521$var$isSymbol;

});

parcelRegister("2nPhd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1bc58141c215843b$export$2e2bcd8739ae039; });

var $a2285 = parcelRequire("a2285");
/** Used to match property names within property paths. */ var $1bc58141c215843b$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $1bc58141c215843b$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $1bc58141c215843b$var$stringToPath = (0, $a2285.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($1bc58141c215843b$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($1bc58141c215843b$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
var $1bc58141c215843b$export$2e2bcd8739ae039 = $1bc58141c215843b$var$stringToPath;

});
parcelRegister("a2285", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74dbbe287fd5bee4$export$2e2bcd8739ae039; });

var $saTWr = parcelRequire("saTWr");
/** Used as the maximum memoize cache size. */ var $74dbbe287fd5bee4$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $74dbbe287fd5bee4$var$memoizeCapped(func) {
    var result = (0, $saTWr.default)(func, function(key) {
        if (cache.size === $74dbbe287fd5bee4$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $74dbbe287fd5bee4$export$2e2bcd8739ae039 = $74dbbe287fd5bee4$var$memoizeCapped;

});
parcelRegister("saTWr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $054b12683a3892d1$export$2e2bcd8739ae039; });

var $5Sw7u = parcelRequire("5Sw7u");
/** Error message constants. */ var $054b12683a3892d1$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $054b12683a3892d1$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($054b12683a3892d1$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($054b12683a3892d1$var$memoize.Cache || (0, $5Sw7u.default));
    return memoized;
}
// Expose `MapCache`.
$054b12683a3892d1$var$memoize.Cache = (0, $5Sw7u.default);
var $054b12683a3892d1$export$2e2bcd8739ae039 = $054b12683a3892d1$var$memoize;

});



parcelRegister("e9clf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4cb7ac731de7b78$export$2e2bcd8739ae039; });

var $fdbzE = parcelRequire("fdbzE");
/** Used as references for various `Number` constants. */ var $a4cb7ac731de7b78$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $a4cb7ac731de7b78$var$toKey(value) {
    if (typeof value == "string" || (0, $fdbzE.default)(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$a4cb7ac731de7b78$var$INFINITY ? "-0" : result;
}
var $a4cb7ac731de7b78$export$2e2bcd8739ae039 = $a4cb7ac731de7b78$var$toKey;

});

parcelRegister("hghOo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c911bf5df7535e60$export$2e2bcd8739ae039; });

var $gdpWJ = parcelRequire("gdpWJ");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $c911bf5df7535e60$var$toString(value) {
    return value == null ? "" : (0, $gdpWJ.default)(value);
}
var $c911bf5df7535e60$export$2e2bcd8739ae039 = $c911bf5df7535e60$var$toString;

});
parcelRegister("gdpWJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bce1fc9efd55e169$export$2e2bcd8739ae039; });

var $hwtsf = parcelRequire("hwtsf");

var $51q5w = parcelRequire("51q5w");

var $eA9yl = parcelRequire("eA9yl");

var $fdbzE = parcelRequire("fdbzE");
/** Used as references for various `Number` constants. */ var $bce1fc9efd55e169$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $bce1fc9efd55e169$var$symbolProto = (0, $hwtsf.default) ? (0, $hwtsf.default).prototype : undefined, $bce1fc9efd55e169$var$symbolToString = $bce1fc9efd55e169$var$symbolProto ? $bce1fc9efd55e169$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $bce1fc9efd55e169$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ((0, $eA9yl.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $51q5w.default)(value, $bce1fc9efd55e169$var$baseToString) + "";
    if ((0, $fdbzE.default)(value)) return $bce1fc9efd55e169$var$symbolToString ? $bce1fc9efd55e169$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$bce1fc9efd55e169$var$INFINITY ? "-0" : result;
}
var $bce1fc9efd55e169$export$2e2bcd8739ae039 = $bce1fc9efd55e169$var$baseToString;

});




parcelRegister("bS3sv", function(module, exports) {

var $diJvt = parcelRequire("diJvt");


module.exports = Promise.all([
    (parcelRequire("cHO59"))((parcelRequire("2E5gs")).resolve("jAdNf")),
    $diJvt("bx80Y")
]).then(()=>parcelRequire("7FG0A"));

});
parcelRegister("diJvt", function(module, exports) {
"use strict";

function $9af0417ccac77538$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("2E5gs")).resolve(id));
}
module.exports = $9af0417ccac77538$var$load;

});

parcelRegister("cHO59", function(module, exports) {
"use strict";

var $kxq42 = parcelRequire("kxq42");
module.exports = $kxq42(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});
parcelRegister("kxq42", function(module, exports) {
"use strict";
var $ef3b1b7ca270acd8$var$cachedBundles = {};
var $ef3b1b7ca270acd8$var$cachedPreloads = {};
var $ef3b1b7ca270acd8$var$cachedPrefetches = {};
function $ef3b1b7ca270acd8$var$getCache(type) {
    switch(type){
        case "preload":
            return $ef3b1b7ca270acd8$var$cachedPreloads;
        case "prefetch":
            return $ef3b1b7ca270acd8$var$cachedPrefetches;
        default:
            return $ef3b1b7ca270acd8$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $ef3b1b7ca270acd8$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("f5gxW", function(module, exports) {

var $3IH32 = parcelRequire("3IH32");
const $afb4286b3f2a0c2e$var$_ = {
    e (str) {
        if (typeof str !== "string") str = String(str);
        return str.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
    },
    t (value, vars = null) {
        if (typeof $3IH32.translate === "function") return $3IH32.translate(value, vars);
        else return $3IH32.format(value, vars);
    },
    toNothing (label = null) {
        if (label === null) label = $afb4286b3f2a0c2e$var$_.t("n/a");
        return `<i class="null">${label}</i>`;
    },
    toList (list, sort = false, formatter = null, ordered = null) {
        let tag = ordered === true ? "ol" : "ul";
        if (!Array.isArray(list)) list = [
            list
        ];
        if (sort) {
            list = list.slice(0);
            if (typeof sort === "function") list.sort(sort);
            else list.sort();
            if (ordered === null) tag = "ol";
        }
        if (typeof formatter === "function") list = list.map(formatter);
        if (list.length === 0) return $afb4286b3f2a0c2e$var$_.toNothing();
        else if (list.length === 1) return list[0];
        else return `<${tag}><li>${list.join("</li><li>")}</li></${tag}>`;
    },
    toLink (url, title = "", rel = "", target = "_blank") {
        if (!title) {
            if (url.length > 50) title = url.replace(/^\w+:\/\/([^\/]+)((\/[^\/\?]+)*\/([^\/\?]+)(\?.*)?)?$/i, function(...x) {
                if (x[4]) return x[1] + "\u200B/[\u2026]/\u200B" + x[4]; // There are invisible zero-width whitespaces after and before the slashes. It allows breaking the link in the browser. Be careful when editing.
                return x[1];
            });
            else title = url.replace(/^\w+:\/\//i, "");
        }
        return `<a href="${$afb4286b3f2a0c2e$var$_.e(url)}" rel="${$afb4286b3f2a0c2e$var$_.e(rel)}" target="${$afb4286b3f2a0c2e$var$_.e(target)}">${$afb4286b3f2a0c2e$var$_.e(title)}</a>`;
    },
    toObject (obj, formatter = null, keyFormatter = null, keyOrder = [], filter = null, path = []) {
        let html = "<dl>";
        let keys = Array.isArray(keyOrder) && keyOrder.length >= 2 ? keyOrder : Object.keys(obj);
        for (let key of keys){
            if (!(key in obj) || typeof filter === "function" && path.length > 0 && !filter(path[0], path.concat([
                key
            ]))) continue;
            let label;
            if (typeof keyFormatter === "function") label = keyFormatter(key, obj);
            else label = $afb4286b3f2a0c2e$var$_.formatKey(key, true);
            let value = obj[key];
            if (typeof formatter === "function") value = formatter(value, key, obj);
            html += `<dt>${label}</dt><dd>${value}</dd>`;
        }
        html += `</dl>`;
        return html;
    },
    abbrev (short, long) {
        return `<abbr title="${$afb4286b3f2a0c2e$var$_.e(long)}">${$afb4286b3f2a0c2e$var$_.e(short)}</abbr>`;
    },
    isObject (obj) {
        return typeof obj === "object" && obj === Object(obj) && !Array.isArray(obj);
    },
    formatKey (key, prefix = false) {
        if (key.includes("/")) // Slashes are strong indicators for URIs or media types, don't format
        return $afb4286b3f2a0c2e$var$_.e($afb4286b3f2a0c2e$var$_.t(key));
        if (prefix === false) key = key.replace(/^[\w-]+:/i, "");
        let formatted = key.split(/[:_\-\s]/g).map((part)=>part.substr(0, 1).toUpperCase() + part.substr(1)).join(" ");
        return $afb4286b3f2a0c2e$var$_.e($afb4286b3f2a0c2e$var$_.t(formatted));
    },
    hexToUint8 (hexString) {
        if (hexString.length === 0 || hexString.length % 2 !== 0) throw new Error(`The string "${hexString}" is not valid hex.`);
        return new Uint8Array(hexString.match(/.{1,2}/g).map((byte)=>parseInt(byte, 16)));
    },
    uint8ToHex (bytes) {
        return bytes.reduce((str, byte)=>str + byte.toString(16).padStart(2, "0"), "");
    },
    keysFromListOfObjects (objectList) {
        return objectList.reduce((arr, o)=>Object.keys(o).reduce((a, k)=>{
                if (a.indexOf(k) == -1) a.push(k);
                return a;
            }, arr), []);
    },
    unit (value, unit = "") {
        if (typeof unit === "string" && unit.length > 0) {
            unit = $afb4286b3f2a0c2e$var$_.t(unit);
            return `${value}&nbsp;<span class="unit">${unit}</unit>`;
        }
        return value;
    }
};
module.exports = $afb4286b3f2a0c2e$var$_;

});
parcelRegister("3IH32", function(module, exports) {
const $2b56df9ddee4ddf5$var$Defaults = {
    collatorOptions: {},
    numberFormatterOptions: {
        maximumFractionDigits: 10
    },
    dateFormatterOptions: {
        day: "numeric",
        month: "numeric",
        year: "numeric"
    },
    dateTimeFormatterOptions: {
        day: "numeric",
        month: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZone: "UTC",
        timeZoneName: "short"
    }
};
const $2b56df9ddee4ddf5$var$I18N = {
    locales: [],
    collator: new Intl.Collator($2b56df9ddee4ddf5$var$Defaults.collatorOptions),
    dateFormatter: new Intl.DateTimeFormat($2b56df9ddee4ddf5$var$Defaults.dateFormatterOptions),
    dateTimeFormatter: new Intl.DateTimeFormat($2b56df9ddee4ddf5$var$Defaults.dateTimeFormatterOptions),
    numberFormatter: new Intl.NumberFormat($2b56df9ddee4ddf5$var$Defaults.numberFormatterOptions),
    translate: null,
    getDefaults () {
        return $2b56df9ddee4ddf5$var$Defaults;
    },
    setLocales (locales, dateFormatterOptions = {}, dateTimeFormatterOptions = {}, numberFormatterOptions = {}, collatorOptions = {}) {
        this.locales = locales;
        collatorOptions = Object.assign({}, $2b56df9ddee4ddf5$var$Defaults.collatorOptions, collatorOptions);
        this.collator = new Intl.Collator(locales, collatorOptions);
        dateFormatterOptions = Object.assign({}, $2b56df9ddee4ddf5$var$Defaults.dateFormatterOptions, dateFormatterOptions);
        this.dateFormatter = new Intl.DateTimeFormat(locales, dateFormatterOptions);
        dateTimeFormatterOptions = Object.assign({}, $2b56df9ddee4ddf5$var$Defaults.dateTimeFormatterOptions, dateTimeFormatterOptions);
        this.dateTimeFormatter = new Intl.DateTimeFormat(locales, dateTimeFormatterOptions);
        numberFormatterOptions = Object.assign({}, $2b56df9ddee4ddf5$var$Defaults.numberFormatterOptions, numberFormatterOptions);
        this.numberFormatter = new Intl.NumberFormat(locales, numberFormatterOptions);
    },
    setTranslator (fn) {
        this.translate = fn;
    },
    format (value, vars = null) {
        if (vars) for(let key in vars)value = value.replaceAll(`{${key}}`, vars[key]);
        return value;
    }
};
module.exports = $2b56df9ddee4ddf5$var$I18N;

});


parcelRegister("aUdEw", function(module, exports) {
module.exports = JSON.parse('{"extensions":{"alternate":"Alternative Access Methods","anon":"Anonymized Location","card4l":{"label":"CARD4L","explain":"CEOS Analysis Ready Data for Land"},"classification":"Classification","contacts":"Contacts","cube":"Data Cube","esa_cci_lc":"ESA Climate Change Initiative - Land Cover","eo":"Electro-Optical","forecast":"Forecast","file":"File","grid":"Gridded Data","goes":{"label":"NOAA GOES","explain":"NOAA Geostationary Operational Environmental Satellite"},"label":"Labels / ML","language":"Internationalization / Localization","mgrs":{"label":"MGRS","explain":"Military Grid Reference System"},"noaa_mrms_qpe":{"label":"NOAA MRMS QPE","explain":"NOAA Multi-Radar Multi-Sensor Quantitative Precipitation Estimation"},"odc":"Open Data Cube","order":"Order","pc":"Point Cloud","processing":"Processing","product":"Product","proj":"Projection","raster":"Raster Imagery","sar":{"label":"SAR","explain":"Synthetic Aperture Radar"},"sat":"Satellite","sci":"Scientific","ssys":"Solar System","stats":"STAC Statistics","storage":"Cloud Storage","table":"Tabular Data","themes":"Themes","tiles":"Tiled Assets","view":"View Geometry","web-map-links":"Web Maps","xarray":"xarray","gee":"Google Earth Engine","landsat":"Landsat","msft":"Microsoft","openeo":"openEO","pl":"Planet Labs PBC","s2":"Sentinel-2","sentinel":"Copernicus Sentinel","cbers":{"label":"CBERS","explain":"China-Brazil Earth Resources Satellite Program"},"geoadmin":{"label":"swisstopo","explain":"Federal Office of Topography (Switzerland)"}},"links":{"href":{"label":"URL","format":"Url"},"hreflang":{"label":"Language","format":"LanguageCode"},"rel":{"label":"Relation","explain":"Based on IANA relation types","mapping":{"self":"This document","root":"Root STAC Catalog","parent":"Parent STAC Catalog","collection":"STAC Collection","derived_from":"STAC Item for input data","about":"About this resource","alternate":"Alternative representation","via":"Source metadata","next":"Next page","prev":"Previous page","canonical":"Origin of this document","processing-expression":"Processing inctructions/code","latest-version":"Latest version","predecessor-version":"Predecessor version","successor-version":"Successor version","source":"Source data","cite-as":"Citation information","related":"Related resource","describedby":"Description of the resource","service-desc":"API definitions","service-doc":"API user documentation","conformance":"API conformance declaration","order":"Order details","3d-tiles":"3D Tiles","pmtiles":"PMTiles","tilejson":"TileJSON","wms":"OGC Web Map Service (WMS)","wmts":"OGC Web Map Tile Service (WMTS)","xyz":"XYZ Web Map"}},"type":{"label":"File Format","explain":"Based on the IANA media (MIME) types","format":"MediaType"},"method":"HTTP Method","headers":"HTTP Headers","body":"Request Body"},"assets":{"href":{"label":"URL","format":"Url"},"hreflang":{"label":"Language","format":"LanguageCode"},"type":{"label":"File Format","explain":"Based on the IANA media (MIME) types","format":"MediaType"},"roles":{"label":"Purpose","mapping":{"thumbnail":"Preview","overview":"Overview","visual":"Visualization","data":"Data","metadata":"Metadata","graphic":"Illustration"}},"alternate":{"label":"Alternatives","listWithKeys":true,"items":{"href":{"label":"URL","format":"Url"},"title":{"alias":"title"},"description":{"alias":"description"}},"summary":false,"ext":"alternate"},"pl:asset_type":"Asset Type","pl:bundle_type":"Bundle Type","table:storage_options":{"alias":"xarray:storage_options"},"xarray:open_kwargs":{"label":"Read Options","custom":true,"summary":false},"xarray:storage_options":{"label":"fsspec Options","custom":true,"summary":false}},"metadata":{"id":"Identifier","keywords":"Keywords","datetime":{"label":"Time of Data","format":"Timestamp","summary":false},"title":{"label":"Title","summary":false},"description":{"label":"Description","format":"CommonMark","summary":false},"roles":"Purpose","start_datetime":{"label":"Time of Data begins","format":"Timestamp","summary":false},"end_datetime":{"label":"Time of Data ends","format":"Timestamp","summary":false},"created":{"label":"Created","format":"Timestamp","summary":"r"},"updated":{"label":"Updated","format":"Timestamp","summary":"r"},"published":{"label":"Published","format":"Timestamp","summary":"r"},"expires":{"label":"Expires","format":"Timestamp","summary":"r"},"unpublished":{"label":"Unpublished","format":"Timestamp","summary":"r"},"license":{"label":"License","format":"License","summary":false},"providers":{"label":"Providers","format":"Providers","summary":false},"platform":"Platform","instruments":{"label":"Instruments","format":"CSV"},"constellation":"Constellation","mission":"Mission","gsd":{"label":"GSD","explain":"Ground Sample Distance","unit":"m"},"bands":{"label":"Bands","items":{"name":{"label":"Name","sortable":true,"id":true,"order":0},"description":{"alias":"description","order":2},"gsd":{"alias":"gsd","sortable":true},"nodata":{"alias":"nodata"},"data_type":{"alias":"data_type","sortable":true},"statistics":{"alias":"statistics"},"eo:common_name":{"alias":"eo:common_name","sortable":true,"order":1},"eo:center_wavelength":{"alias":"eo:center_wavelength","sortable":true},"eo:full_width_half_max":{"alias":"eo:full_width_half_max","sortable":true},"eo:solar_illumination":{"alias":"eo:solar_illumination","sortable":true},"raster:sampling":{"alias":"raster:sampling","sortable":true},"unit":{"alias":"unit","sortable":true},"raster:bits_per_sample":{"alias":"raster:bits_per_sample","sortable":true},"raster:spatial_resolution":{"alias":"raster:spatial_resolution","sortable":true},"raster:scale":{"alias":"raster:scale","sortable":true},"raster:offset":{"alias":"raster:offset","sortable":true},"raster:histogram":{"alias":"raster:histogram"},"classification:classes":{"alias":"classification:classes"},"classification:bitfields":{"alias":"classification:bitfields"}}},"nodata":{"label":"No-Data Values","format":"CSV","summary":false},"data_type":{"label":"Data Type of Values","format":"FileDataType"},"unit":"Unit of Values","statistics":{"label":"Statistics","listWithKeys":true,"items":{"mean":"Average","maximum":{"label":"Max.","explain":"Maxmimum value"},"minimum":{"label":"Min.","explain":"Minimum value"},"stdev":{"label":"Std. Dev.","explain":"Standard Deviation"},"count":{"label":"Count","explain":"Total number of values"},"valid_percent":{"label":"Valid","explain":"Percentage of valid values","unit":"%"}}},"version":{"label":"Data Version","summary":false},"deprecated":{"label":"Deprecated","summary":false},"experimental":{"label":"Experimental","summary":false},"language":{"label":"Current Language","ext":"language","summary":"v","properties":{"name":{"label":"Name"},"alternate":{"label":"Alternate Name"},"code":{"label":"Code"},"dir":{"label":"Direction","explain":"Reading and writing direction","mapping":{"ltr":"left-to-right","rtl":"right-to-left"},"default":"ltr"}}},"languages":{"label":"Available Languages","ext":"language","summary":false,"items":{"name":{"label":"Name","sortable":true,"order":0},"alternate":{"label":"Alternate Name","sortable":true,"order":1},"code":{"label":"Code","sortable":true,"order":2},"dir":{"label":"Direction","explain":"Reading and writing direction","sortable":true,"order":3,"mapping":{"ltr":"left-to-right","rtl":"right-to-left"},"default":"ltr"}}},"contacts":{"label":"Contacts","ext":"contacts","summary":"v","items":{"name":{"label":"Name"},"identifier":{"label":"Identifier"},"position":{"label":"Position"},"organization":{"label":"Organization"},"logo":{"label":"Logo","format":"Image"},"phones":{"label":"Phone","items":{"value":{"label":"Number","format":"Phone","order":0},"roles":{"label":"Used For","order":1,"mapping":{"work":"Work","home":"Personal","fax":"Fax"}}}},"emails":{"label":"Email","items":{"value":{"label":"Address","format":"Email","order":0},"roles":{"label":"Used For","order":1,"mapping":{"work":"Work","home":"Personal"}}}},"addresses":{"label":"Postal Addresses","format":"Address","items":{"deliveryPoint":{"label":"Street / House","order":0},"city":{"label":"City","order":1},"administrativeArea":{"label":"State / Province","order":2},"postalCode":{"label":"Postal Code","order":3},"country":{"label":"Country","order":4}}},"links":{"label":"Additional Resources","format":"Link"},"contactInstructions":"Further Instructions","roles":{"label":"Types","format":"CSV"}}},"themes":{"label":"Themes","ext":"themes","summary":false,"items":{"scheme":{"label":"Vocabulary","order":0,"format":"Url"},"concepts":{"label":"Terms","order":1,"format":"Concepts","items":{"id":{"label":"Identifier","order":0},"title":{"label":"Title","order":1},"description":{"label":"Description","order":2},"url":{"label":"URL","order":3,"format":"Url"}}}}},"crs":{"label":"CRS","format":"CRS","explain":"Coordinate Reference System"},"anon:size":{"label":"Uncertainty","unit":"\xb0","explain":"The size of one side of the anonymized bounding box"},"anon:warning":{"label":"Warning","summary":false},"classification:classes":{"summary":false,"label":"Classes","items":{"color_hint":{"label":"Color","order":0,"format":"HexColor"},"value":{"label":"Value","sortable":true,"order":1},"title":{"label":"Title","sortable":true,"order":2},"name":{"label":"Identifier","sortable":true,"order":3},"description":{"label":"Description","order":4,"format":"CommonMark"},"percentage":{"label":"Percentage of samples","sortable":true,"order":5,"unit":"%"},"count":{"label":"Number of samples","sortable":true,"order":6},"nodata":{"label":"No-data value","order":7,"default":false}}},"classification:bitfields":{"summary":false,"label":"Bit Mask","items":{"name":{"label":"Name","sortable":true,"order":0},"offset":{"label":"Offset","explain":"Offset to the first bit","order":1},"length":{"label":"Number of bits","order":2},"description":{"label":"Description","order":3,"format":"CommonMark"},"classes":{"alias":"classification:classes"},"roles":{"label":"Purpose"}}},"cube:dimensions":{"label":"Dimensions","summary":false,"listWithKeys":true,"items":{"type":{"label":"Type","order":0},"axis":{"label":"Axis","order":1},"description":{"label":"Description","format":"CommonMark","order":2},"extent":{"label":"Extent","format":"Extent","order":3},"bbox":{"alias":"proj:bbox","order":3},"values":{"label":"Values","order":4},"step":{"label":"Step","order":5},"unit":{"alias":"unit","order":5},"geometry_types":{"label":"Geometry Types","order":5},"reference_system":{"label":"Reference System","explain":"Coordinate / Temporal / Other Reference System","order":6}}},"cube:variables":{"label":"Variables","summary":false,"listWithKeys":true,"items":{"dimensions":{"label":"Dimensions","order":0},"type":{"label":"Type","order":1,"mapping":{"data":"Measured values","auxiliary":"Coordinate data"}},"description":{"label":"Description","format":"CommonMark","order":2},"extent":{"label":"Extent","format":"Extent","order":3},"values":{"label":"Values","order":4},"step":{"label":"Step","order":5},"unit":{"alias":"unit","order":6}}},"eo:bands":{"label":"Spectral Bands","items":{"name":{"label":"Name","sortable":true,"id":true,"order":0},"common_name":{"alias":"eo:common_name","sortable":true,"order":1},"center_wavelength":{"alias":"eo:center_wavelength","sortable":true,"order":2},"full_width_half_max":{"alias":"eo:full_width_half_max","sortable":true,"order":3},"solar_illumination":{"alias":"eo:solar_illumination","sortable":true,"order":7},"description":{"alias":"description"},"gsd":{"alias":"gsd","sortable":true},"cloud_cover":{"alias":"eo:cloud_cover","sortable":true}}},"eo:cloud_cover":{"label":"Cloud Cover","unit":"%"},"eo:snow_cover":{"label":"Snow/Ice Cover","unit":"%"},"eo:common_name":"Common Name","eo:center_wavelength":{"label":"Wavelength","explain":"The center wavelength of the band","unit":"\u03BCm"},"eo:full_width_half_max":{"label":"FWHM","explain":"Full Width Half Max","unit":"\u03BCm"},"eo:solar_illumination":{"label":"Solar Illumination","unit":"W/m\xb2/\u03BCm"},"forecast:reference_datetime":{"label":"Reference Time","format":"Timestamp","summary":"r"},"forecast:horizon":{"label":"Forecast Horizon","explain":"The time between the reference time and the forecast time","format":"Duration"},"forecast:duration":{"label":"Forecast Length","format":"Duration"},"file:bits_per_sample":{"alias":"raster:bits_per_sample"},"file:byte_order":"Byte Order","file:checksum":{"label":"Checksum","format":"Checksum","summary":false},"file:data_type":{"alias":"data_type"},"file:header_size":{"label":"Header Size","format":"FileSize","summary":false},"file:nodata":{"alias":"nodata"},"file:size":{"label":"Size","format":"FileSize","summary":false},"file:unit":{"alias":"unit"},"file:values":{"label":"Map of Values","summary":false,"items":{"values":{"label":"Values","format":"CSV","order":1},"summary":{"label":"Summary","order":0}}},"file:local_path":{"label":"Local Path","summary":false},"nodata:values":{"alias":"nodata"},"goes:orbital_slot":"Orbital Slot","goes:system_environment":{"label":"System Environment","mapping":{"OR":"Operational system, real-time data","OT":"Operational system, test data","IR":"Test system, real-time data","IT":"Test system, test data","IP":"Test system, playback data","IS":"Test system, simulated data"}},"goes:image_type":{"label":"Area","mapping":{"FULL DISK":"The Americas (full disk)","CONUS":"North America (continental US)","MESOSCALE":"Central/South America (mesoscale)"}},"goes:mesoscale_image_number":{"label":"Area in Central/South America","mapping":{"1":"Region 1","2":"Region 2"}},"goes:mode":{"label":"Capture Mode","mapping":{"3":"3: 1x full disk, 3x continental US, 30x mesoscale region 1, 30x mesoscale region 2 (every 15 minutes)","4":"4: 1x full disk (every 5 minutes)","6":"6: 1x full disk, 2x continental US, 20x mesoscale region 1, 20x mesoscale region 2 (every 10 minutes)"}},"goes:group_time_threshold":{"label":"Time Threshold in a Group","explain":"Lightning group maximum time difference among lightning events in a group","unit":"s"},"goes:flash_time_threshold":{"label":"Time Threshold in a Flash","explain":"Lightning flash maximum time difference among lightning events in a flash","unit":"s"},"goes:lightning_wavelength":{"label":"Central Wavelength","unit":"nm"},"goes:yaw_flip_flag":{"label":"Yaw Flip Configuration","explain":"Flag indicating that the spacecraft is operating in yaw flip configuration.","mapping":{"0":"Upright","1":"Neither","2":"Inverted"}},"goes:event_count":"Lightning Events","goes:group_count":"Lightning Groups","goes:flash_count":"Lightning Flashes","goes:nominal_satellite_subpoint_lat":{"label":"Satellite Subpoint Latitude","unit":"\xb0N"},"goes:nominal_satellite_subpoint_lon":{"label":"Satellite Subpoint Longitude","unit":"\xb0E"},"goes:nominal_satellite_height":{"label":"Satellite Height","explain":"Nominal satellite height above GRS 80 ellipsoid","unit":"km"},"goes:percent_navigated_L1b_events":{"label":"Events navigated by Instrument","format":"Percent0to1","unit":"%"},"goes:percent_uncorrectable_L0_errors":{"label":"Data Lost","format":"Percent0to1","unit":"%"},"grid:code":{"label":"Grid","format":"GridCode"},"raster:bands":{"label":"Layers","items":{"nodata":{"alias":"nodata"},"sampling":{"alias":"raster:sampling","sortable":true},"data_type":{"alias":"data_type","sortable":true},"bits_per_sample":{"alias":"raster:bits_per_sample","sortable":true},"spatial_resolution":{"alias":"raster:spatial_resolution","sortable":true},"statistics":{"alias":"statistics"},"unit":{"alias":"unit","sortable":true},"scale":{"alias":"raster:scale","sortable":true},"offset":{"alias":"raster:offset","sortable":true},"histogram":{"alias":"raster:histogram"}}},"raster:sampling":{"label":"Sampling","mapping":{"area":"Area","point":"Point (at pixel center)"}},"raster:bits_per_sample":"Bits per Sample","raster:spatial_resolution":{"label":"Resolution","explain":"Average spatial resolution","unit":"m"},"raster:scale":"Scale","raster:offset":"Offset","raster:histogram":{"label":"Histogram","custom":true},"label:properties":{"label":"Properties","null":"raster data"},"label:classes":{"label":"Classes","items":{"name":{"label":"Name","null":"raster-formatted","sortable":true,"id":true},"classes":"Classes"}},"label:description":{"label":"Description","format":"CommonMark","summary":false},"label:type":"Type","label:tasks":"Tasks","label:methods":"Methods","label:overviews":{"label":"Overviews","summary":false,"items":{"property_key":{"label":"Property Key","id":true},"counts":{"label":"Counts","custom":true},"statistics":{"label":"Statistics","custom":true}}},"mgrs:latitude_band":"Latitude Band","mgrs:grid_square":"Grid Square","mgrs:utm_zone":"UTM Zone","noaa_mrms_qpe:pass":{"label":"Pass Number","mapping":{"1":"1 (less latency / less gauges)","2":"2 (more latency / more gauges)"}},"noaa_mrms_qpe:period":{"label":"Accumulation Period","unit":"h"},"noaa_mrms_qpe:region":{"label":"Region","mapping":{"CONUS":"Continental US","HAWAII":"Hawaii","GUAM":"Guam","ALASKA":"Alaska","CARIB":"Caribbean Islands"}},"openeo:status":"Processing Status","api_version":{"label":"API Version","ext":"openeo"},"backend_version":{"label":"Back-End Version","ext":"openeo"},"production":{"label":"Production-Ready","ext":"openeo"},"endpoints":{"label":"Supported Endpoints","ext":"openeo","summary":false,"items":{"path":{"label":"Path Template","order":0},"methods":{"label":"HTTP Methods","order":1,"format":"CSV"}}},"billing":{"label":"Billing","ext":"openeo","custom":true,"summary":false},"order:status":{"label":"Status","mapping":{"orderable":"Orderable (data can be ordered)","ordered":"Ordered (preparing to deliver data)","pending":"Pending (waiting for activation)","shipping":"Shipping (data is getting processed)","succeeded":"Delivered (data is available)","failed":"Failed (unable to deliver)","canceled":"Canceled (delivery stopped)"}},"order:id":"Identifier","order:date":{"label":"Submitted","format":"Timestamp","summary":"r"},"order:expiration_date":{"alias":"expires"},"pc:count":{"label":"Points","explain":"Number of Points"},"pc:type":"Type","pc:encoding":"Format","pc:schemas":{"label":"Schemas","summary":false,"items":{"name":{"label":"Name","sortable":true,"id":true},"size":{"label":"Size","unit":"bytes","sortable":true},"type":{"label":"Type","sortable":true}}},"pc:density":"Density","pc:statistics":{"label":"Statistics","summary":"s","items":{"name":{"label":"Name","id":true},"position":"Position","average":"Average","count":"Count","maximum":{"label":"Max.","explain":"Maxmimum value"},"minimum":{"label":"Min.","explain":"Minimum value"},"stddev":{"label":"Std. Dev.","explain":"Standard Deviation"},"variance":"Variance"}},"processing:expression":{"label":"Processing Instructions","summary":false},"processing:lineage":{"label":"Lineage","format":"CommonMark","summary":false},"processing:level":"Level","processing:facility":"Facility","processing:software":{"label":"Software","format":"Software","summary":false},"processing:version":"Processor Version","processing:datetime":{"label":"Processing Time","format":"Timestamp","summary":"r"},"product:type":"Product Type","product:timeliness":{"label":"Timeliness","format":"Duration"},"product:timeliness_category":"Timeliness Category","product:acquisition_type":{"label":"Acquisition Type","mapping":{"nominal":"Nominal","calibration":"Calibration","other":"Other"}},"proj:epsg":{"label":"EPSG Code","format":"EPSG","summary":"v"},"proj:code":{"label":"Code","format":"CrsCode","summary":"v"},"proj:wkt2":{"label":"WKT2","explain":"Well-Known Text, version 2","format":"WKT2","summary":false},"proj:projjson":{"label":"PROJJSON","explain":"JSON encoding of WKT2","format":"PROJJSON","summary":false},"proj:geometry":{"label":"Footprint","custom":true,"summary":false},"proj:bbox":{"label":"Bounding Box","custom":true,"summary":false},"proj:centroid":{"label":"Centroid","custom":true,"summary":false},"proj:shape":{"label":"Image Dimensions","format":"Shape","summary":false},"proj:transform":{"label":"Transformation Matrix","format":"Transform","summary":false},"sar:instrument_mode":"Instrument Mode","sar:frequency_band":"Frequency Band","sar:center_frequency":{"label":"Center Frequency","unit":"GHz"},"sar:polarizations":{"label":"Polarizations","format":"CSV"},"sar:product_type":"Product Type","sar:resolution_range":{"label":"Range Resolution","unit":"m"},"sar:resolution_azimuth":{"label":"Azimuth Resolution","unit":"m"},"sar:pixel_spacing_range":{"label":"Range Pixel Spacing","unit":"m"},"sar:pixel_spacing_azimuth":{"label":"Azimuth Pixel Spacing","unit":"m"},"sar:looks_range":"Range Looks","sar:looks_azimuth":"Azimuth Looks","sar:looks_equivalent_number":{"label":"ENL","explain":"Equivalent Number of Looks"},"sar:observation_direction":"Observation Direction","sat:platform_international_designator":{"label":"Int. Designator","explain":"International designator for the platform, also known as COSPAR ID and NSSDCA ID."},"sat:orbit_state":"Orbit State","sat:absolute_orbit":{"label":"Abs. Orbit Number","explain":"Absolute Orbit Number"},"sat:relative_orbit":{"label":"Rel. Orbit Number","explain":"Relative Orbit Number"},"sat:anx_datetime":{"label":"ANX Time","format":"Timestamp","explain":"Ascending Node Crossing time","summary":"r"},"sci:doi":{"label":"DOI","format":"DOI"},"sci:citation":"Citation","sci:publications":{"label":"Publications","summary":false,"items":{"citation":{"label":"Publication","sortable":true,"order":0},"doi":{"label":"DOI","format":"DOI","sortable":true,"order":1}}},"ssys:targets":"Target Body","storage:platform":{"label":"Provider","mapping":{"ALIBABA":"Alibaba Cloud","AWS":"Amazon AWS","AZURE":"Microsoft Azure","GCP":"Google Cloud Platform","IBM":"IBM Cloud","ORACLE":"Oracle Cloud"}},"storage:region":"Region","storage:requester_pays":"Requester Pays","storage:tier":"Tier Type","table:columns":{"label":"Columns","items":{"name":{"label":"Name","sortable":true,"id":true,"order":0},"type":{"label":"Data Type","sortable":true,"order":1},"description":{"label":"Description","format":"CommonMark","order":2}}},"table:primary_geometry":"Primary Geometry Column","table:row_count":"Rows","table:tables":{"label":"Tables","summary":false,"listWithKeys":true,"items":{"name":{"label":"Name","sortable":true,"id":true,"order":0},"description":{"label":"Description","format":"CommonMark","order":1}}},"tiles:tile_matrix_sets":{"label":"Tile Matrix Sets","custom":true,"summary":false},"tiles:tile_matrix_set_links":{"label":"Tile Matrix Set Links","custom":true,"summary":false},"view:off_nadir":{"label":"Off-Nadir Angle","unit":"\xb0"},"view:incidence_angle":{"label":"Incidence Angle","unit":"\xb0"},"view:azimuth":{"label":"Viewing Azimuth","unit":"\xb0"},"view:sun_azimuth":{"label":"Sun Azimuth","unit":"\xb0"},"view:sun_elevation":{"label":"Sun Elevation","unit":"\xb0"},"pl:black_fill":{"label":"Unfilled Image Parts","unit":"%"},"pl:clear_percent":{"label":"Clear Sky","unit":"%"},"pl:grid_cell":"Grid Cell","pl:ground_control":"Positional Accuracy","pl:ground_control_ratio":"Successful Rectification Ratio","pl:item_type":"Type","pl:pixel_resolution":{"label":"Spatial Resolution","unit":"m"},"pl:publishing_stage":{"label":"Publishing Stage","mapping":{"preview":"Preview","standard":"Standard","finalized":"Finalized"}},"pl:quality_category":{"label":"Quality Category","mapping":{"standard":"Standard","test":"Test"}},"pl:strip_id":"Image Strip ID","gee:type":{"label":"Type","mapping":{"image":"Single image","image_collection":"Image collection","table":"Table"}},"gee:cadence":"Cadence","gee:schema":{"label":"Variables","items":{"name":"Name","description":"Description","type":"Data Type"},"summary":false},"gee:revisit_interval":"Revisit Interval","gee:terms_of_use":{"label":"Terms of Use","format":"CommonMark","summary":false},"gee:visualizations":{"label":"Visualizations","custom":true,"summary":false},"landsat:scene_id":"Scene ID","landsat:collection_category":"Collection Category","landsat:collection_number":"Collection Number","landsat:wrs_type":{"label":"WRS Type","explain":"Worldwide Reference System Type"},"landsat:wrs_path":{"label":"WRS Path","explain":"Worldwide Reference System Path"},"landsat:wrs_row":{"label":"WRS Row","explain":"Worldwide Reference System Row"},"landsat:cloud_cover_land":{"label":"Land Cloud Cover","unit":"%"},"msft:container":"Container","msft:storage_account":"Storage Account","msft:short_description":{"label":"Summary","summary":false},"sentinel:utm_zone":"UTM Zone","sentinel:latitude_band":"Latitude Band","sentinel:grid_square":"Grid Square","sentinel:sequence":"Sequence","sentinel:product_id":{"label":"Product ID","summary":"s"},"sentinel:data_coverage":{"label":"Data Coverage","unit":"%"},"sentinel:valid_cloud_cover":"Valid Cloud Cover","cbers:data_type":{"label":"Processing Level","explain":"Geolocation precision level","mapping":{"L2":"Geolocation using only satellite telemetry","L3":"Control points used to geolocate image, no terrain correction","L4":"Control points used to geolocate image, orthorectified"},"summary":"v"},"cbers:path":"Reference Grid Path","cbers:row":"Reference Grid Row","card4l:specification":{"label":"Specification","mapping":{"SR":"Surface Reflectance (Optical)","ST":"Surface Temperature (Optical)","NRB":"Normalized Radar Backscatter (SAR)","POL":"Polarimetric Radar (SAR)"}},"card4l:specification_version":"Specification Version","card4l:orbit_mean_altitude":{"label":"Platform Altitude","unit":"m"},"card4l:incidence_angle_near_range":{"label":"Incidence Angle (near)","unit":"\xb0"},"card4l:incidence_angle_far_range":{"label":"Incidence Angle (far)","unit":"\xb0"},"card4l:noise_equivalent_intensity":{"label":"Noise Equivalent Intensity","unit":"dB"},"card4l:mean_faraday_rotation_angle":{"label":"Mean Faraday Rotation","unit":"\xb0"},"card4l:speckle_filtering":{"label":"Speckle Filtering","custom":true,"summary":false,"null":"not applied"},"card4l:relative_rtc_accuracy":{"label":"Rel. RTC Accuracy","explain":"Relative accuracy of the Radiometric Terrain Correction","unit":"dB"},"card4l:absolute_rtc_accuracy":{"label":"Abs. RTC Accuracy","explain":"Absolute accuracy of the Radiometric Terrain Correction","unit":"dB"},"card4l:northern_geometric_accuracy":{"label":"Northern Geometric Accuracy","unit":"m"},"card4l:eastern_geometric_accuracy":{"label":"Eastern Geometric Accuracy","unit":"m"},"card4l:ellipsoidal_height":{"label":"Ellipsoidal Height","unit":"m"},"geoadmin:variant":{"label":"Product Variant","mapping":{"krel":"RGB color with relief","komb":"RGB color without relief","kgrel":"Grayscale with relief","kgrs":"Grayscale without relief"}},"href:servers":{"label":"Servers","ext":"web-map-links"},"pmtiles:layers":{"label":"Layers","ext":"web-map-links"},"wms:layers":{"label":"Layers","ext":"web-map-links"},"wms:styles":{"label":"Styles","ext":"web-map-links"},"wms:dimensions":{"label":"Dimensions","ext":"web-map-links"},"wms:transparent":{"label":"Transparency","ext":"web-map-links"},"wmts:layer":{"label":"Layers","ext":"web-map-links"},"wmts:dimensions":{"label":"Dimensions","ext":"web-map-links"}}}');

});

parcelRegister("4mRY8", function(module, exports) {

$parcel$export(module.exports, "ar", function () { return $32e31499ba21895f$export$d24c54395ce0c509; });
$parcel$export(module.exports, "bg", function () { return $32e31499ba21895f$export$136fd86de524d3c2; });
$parcel$export(module.exports, "ca", function () { return $32e31499ba21895f$export$89e9012e902952b6; });
$parcel$export(module.exports, "cs", function () { return $32e31499ba21895f$export$bde1ed0f60b38f2f; });
$parcel$export(module.exports, "da", function () { return $32e31499ba21895f$export$8c8450b83b664ba4; });
$parcel$export(module.exports, "de", function () { return $32e31499ba21895f$export$2fa162a495d26869; });
$parcel$export(module.exports, "en", function () { return $32e31499ba21895f$export$84584c2a98eb6753; });
$parcel$export(module.exports, "es", function () { return $32e31499ba21895f$export$ca5e4045a55e76d2; });
$parcel$export(module.exports, "et", function () { return $32e31499ba21895f$export$457177dcde8472be; });
$parcel$export(module.exports, "fa", function () { return $32e31499ba21895f$export$48a262eaf0aadda2; });
$parcel$export(module.exports, "fi", function () { return $32e31499ba21895f$export$ed5179c818622fb; });
$parcel$export(module.exports, "fo", function () { return $32e31499ba21895f$export$8979478257f87fe6; });
$parcel$export(module.exports, "fr", function () { return $32e31499ba21895f$export$acb2a88f7d552ebf; });
$parcel$export(module.exports, "gr", function () { return $32e31499ba21895f$export$d911550c75100362; });
$parcel$export(module.exports, "he", function () { return $32e31499ba21895f$export$10cc7d172bb7969; });
$parcel$export(module.exports, "hr", function () { return $32e31499ba21895f$export$b4adb3f464574dcf; });
$parcel$export(module.exports, "hu", function () { return $32e31499ba21895f$export$9901d21957972d53; });
$parcel$export(module.exports, "is", function () { return $32e31499ba21895f$export$226b3eccf92c9ed9; });
$parcel$export(module.exports, "it", function () { return $32e31499ba21895f$export$3486a10f30cf1ee4; });
$parcel$export(module.exports, "ja", function () { return $32e31499ba21895f$export$8c6f505e9474ce90; });
$parcel$export(module.exports, "ko", function () { return $32e31499ba21895f$export$798cf677954c9533; });
$parcel$export(module.exports, "lo", function () { return $32e31499ba21895f$export$bb2182dfba3e387a; });
$parcel$export(module.exports, "lt", function () { return $32e31499ba21895f$export$b961576059b7aeb6; });
$parcel$export(module.exports, "lv", function () { return $32e31499ba21895f$export$54ca4d1eb7926f1; });
$parcel$export(module.exports, "ms", function () { return $32e31499ba21895f$export$5dd2165da01bec80; });
$parcel$export(module.exports, "nl", function () { return $32e31499ba21895f$export$9c64ee4d84d79ce1; });
$parcel$export(module.exports, "no", function () { return $32e31499ba21895f$export$401451a107dc42ce; });
$parcel$export(module.exports, "pl", function () { return $32e31499ba21895f$export$6ea5311eda92944f; });
$parcel$export(module.exports, "pt", function () { return $32e31499ba21895f$export$84175d5f1cb4e39d; });
$parcel$export(module.exports, "ro", function () { return $32e31499ba21895f$export$ea30ec7f37fb148d; });
$parcel$export(module.exports, "ru", function () { return $32e31499ba21895f$export$cf48009033a0126b; });
$parcel$export(module.exports, "sk", function () { return $32e31499ba21895f$export$d608fa5b5bfd2021; });
$parcel$export(module.exports, "sv", function () { return $32e31499ba21895f$export$65540e5f7f6e7dce; });
$parcel$export(module.exports, "tr", function () { return $32e31499ba21895f$export$72451b88a72ad9c2; });
$parcel$export(module.exports, "uk", function () { return $32e31499ba21895f$export$312745a8a3013c00; });
$parcel$export(module.exports, "ur", function () { return $32e31499ba21895f$export$bde472100d10f4c2; });
$parcel$export(module.exports, "vi", function () { return $32e31499ba21895f$export$e3786bf10a8abdf2; });
$parcel$export(module.exports, "zhCN", function () { return $32e31499ba21895f$export$836e793ad054f4a7; });
$parcel$export(module.exports, "zhTW", function () { return $32e31499ba21895f$export$3991fdf1bb6f66b9; });
$parcel$export(module.exports, "isoDuration", function () { return $32e31499ba21895f$export$b097d39b3dd34935; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ var $32e31499ba21895f$var$__assign = function() {
    $32e31499ba21895f$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $32e31499ba21895f$var$__assign.apply(this, arguments);
};
/**
 * The pattern used for parsing ISO8601 duration (PnYnMnDTnHnMnS).
 */ // PnYnMnDTnHnMnS || PnW
var $32e31499ba21895f$var$numbers = "\\d+(?:[\\.,]\\d+)?";
var $32e31499ba21895f$var$weekPattern = "(" + $32e31499ba21895f$var$numbers + "W)";
var $32e31499ba21895f$var$datePattern = "(" + $32e31499ba21895f$var$numbers + "Y)?(" + $32e31499ba21895f$var$numbers + "M)?(" + $32e31499ba21895f$var$numbers + "D)?";
var $32e31499ba21895f$var$timePattern = "T(" + $32e31499ba21895f$var$numbers + "H)?(" + $32e31499ba21895f$var$numbers + "M)?(" + $32e31499ba21895f$var$numbers + "S)?";
var $32e31499ba21895f$var$iso8601 = "^P(?:" + $32e31499ba21895f$var$weekPattern + "|" + $32e31499ba21895f$var$datePattern + "(?:" + $32e31499ba21895f$var$timePattern + ")?)$";
/**
 * The ISO8601 regex for matching / testing durations
 */ var $32e31499ba21895f$var$pattern = new RegExp($32e31499ba21895f$var$iso8601);
var $32e31499ba21895f$var$durationKeys = [
    "weeks",
    "years",
    "months",
    "days",
    "hours",
    "minutes",
    "seconds"
];
var $32e31499ba21895f$var$durationUnitToIsoKey = {
    years: "Y",
    months: "M",
    days: "D",
    hours: "H",
    minutes: "M",
    seconds: "S",
    weeks: "W"
};
var $32e31499ba21895f$var$durationZero = Object.freeze({
    weeks: 0,
    years: 0,
    months: 0,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
});
/** Parse PnYnMnDTnHnMnS format to object
 * @param {string} durationString - PnYnMnDTnHnMnS or PnW formatted string
 * @return {Object} - With a property for each part of the pattern
 */ var $32e31499ba21895f$var$parseIsoString = function(durationString) {
    var durationMatchedPattern = durationString.match($32e31499ba21895f$var$pattern);
    if (!durationMatchedPattern) throw new Error("Invalid duration string");
    var parsed = durationMatchedPattern.slice(1).reduce(function(prev, next, idx) {
        prev[$32e31499ba21895f$var$durationKeys[idx]] = parseFloat(next) || 0;
        return prev;
    }, {});
    return parsed;
};
/** Normalize not completed Partial DurationObj to DurationObj;
 * ex: { days: 1, not_supported_key: 'bar' } => { years: 0, months: 0 days: 1, hours: 0, minutes: 0, seconds: 0 }
 * @param partialDurationObj
 */ var $32e31499ba21895f$var$normalizeDurationObj = function(partialDurationObj) {
    if (partialDurationObj.weeks && partialDurationObj.weeks > 0) return Object.assign({}, $32e31499ba21895f$var$durationZero, {
        weeks: partialDurationObj.weeks
    });
    return $32e31499ba21895f$var$durationKeys.reduce(function(res, key) {
        var _a;
        return $32e31499ba21895f$var$__assign($32e31499ba21895f$var$__assign({}, res), (_a = {}, _a[key] = partialDurationObj[key] || 0, _a));
    }, {});
};
var $32e31499ba21895f$var$config = {
    locales: {},
    options: {},
    setLocales: function(locales, options) {
        this.locales = $32e31499ba21895f$var$__assign($32e31499ba21895f$var$__assign({}, this.locales), locales);
        if (options) this.options = $32e31499ba21895f$var$__assign($32e31499ba21895f$var$__assign({}, this.options), options);
    },
    getLangConfig: function(lang) {
        var localesConfig = this.locales[lang];
        if (!localesConfig && this.options.fallbackLocale) localesConfig = this.locales[this.options.fallbackLocale];
        if (!localesConfig) throw new Error("isoDuration: Translations for language: " + lang + " are not provided");
        return localesConfig;
    }
};
var $32e31499ba21895f$var$getIsoDateElements = function(durationObj) {
    var isoItems = [
        "years",
        "months",
        "days"
    ];
    var isoDate = "";
    for(var _i = 0, isoItems_1 = isoItems; _i < isoItems_1.length; _i++){
        var item = isoItems_1[_i];
        if (durationObj[item]) isoDate += "" + durationObj[item] + $32e31499ba21895f$var$durationUnitToIsoKey[item];
    }
    return isoDate;
};
var $32e31499ba21895f$var$getIsoTimeElements = function(durationObj) {
    var isoItems = [
        "hours",
        "minutes",
        "seconds"
    ];
    var isoDate = "";
    for(var _i = 0, isoItems_2 = isoItems; _i < isoItems_2.length; _i++){
        var item = isoItems_2[_i];
        if (durationObj[item]) isoDate += "" + durationObj[item] + $32e31499ba21895f$var$durationUnitToIsoKey[item];
    }
    return isoDate;
};
var $32e31499ba21895f$var$durationObjToString = function(durationObj) {
    if (durationObj.weeks > 0) return "P" + durationObj.weeks + "W";
    else {
        var durationIsoString = "P";
        var isoDateElement = $32e31499ba21895f$var$getIsoDateElements(durationObj);
        if (isoDateElement) durationIsoString += isoDateElement;
        var isoTimeElement = $32e31499ba21895f$var$getIsoTimeElements(durationObj);
        if (isoTimeElement) durationIsoString += "T" + isoTimeElement;
        if (!isoDateElement && !isoTimeElement) durationIsoString += "0D";
        return durationIsoString;
    }
};
var $32e31499ba21895f$var$humanizeWeek = function(durationObj, lang) {
    var localeConfig = $32e31499ba21895f$var$config.getLangConfig(lang);
    return durationObj.weeks + " " + localeConfig.weeks(durationObj.weeks);
};
var $32e31499ba21895f$var$humanizeDate = function(durationObj, lang, humanizeConfig) {
    var localeConfig = $32e31499ba21895f$var$config.getLangConfig(lang);
    var humanizedTime = "";
    var humanizeOrder = [
        "years",
        "months",
        "days",
        "hours",
        "minutes",
        "seconds"
    ];
    var numOfHumanizedUnits = 0;
    for(var index = 0; index < humanizeOrder.length; index++){
        var item = humanizeOrder[index];
        var unitDuration = durationObj[item];
        if (unitDuration) {
            if (humanizedTime !== "") humanizedTime += " ";
            humanizedTime += unitDuration + " " + localeConfig[item](unitDuration);
            numOfHumanizedUnits++;
            if (humanizeConfig && humanizeConfig.largest && humanizeConfig.largest <= numOfHumanizedUnits) break;
        }
    }
    return humanizedTime;
};
var $32e31499ba21895f$var$humanize = function(durationObj, lang, humanizeConfig) {
    if (durationObj.weeks > 0) return $32e31499ba21895f$var$humanizeWeek(durationObj, lang);
    else return $32e31499ba21895f$var$humanizeDate(durationObj, lang, humanizeConfig);
};
var $32e31499ba21895f$var$normalizeOrder = [
    "seconds",
    "minutes",
    "hours",
    "days",
    "months"
];
var $32e31499ba21895f$var$getNormalizer = function(maxValue) {
    return function(val) {
        return {
            nextUnitValue: Math.floor(val / maxValue),
            value: val % maxValue
        };
    };
};
var $32e31499ba21895f$var$getDaysInMonth = function(month, year) {
    return new Date(year, month + 1, 0).getDate();
};
var $32e31499ba21895f$var$unitNormalizer = {
    seconds: $32e31499ba21895f$var$getNormalizer(60),
    minutes: $32e31499ba21895f$var$getNormalizer(60),
    hours: $32e31499ba21895f$var$getNormalizer(24),
    days: function(val, date) {
        var helperDate = date ? new Date(date.getTime()) : new Date();
        var days = val;
        var fullMonths = 0;
        var daysInMonth = $32e31499ba21895f$var$getDaysInMonth(helperDate.getMonth(), helperDate.getFullYear());
        while(days > daysInMonth){
            days = days - daysInMonth;
            fullMonths++;
            helperDate.setMonth(helperDate.getMonth() + 1);
            daysInMonth = $32e31499ba21895f$var$getDaysInMonth(helperDate.getMonth(), helperDate.getFullYear());
        }
        return {
            nextUnitValue: fullMonths,
            value: days
        };
    },
    months: $32e31499ba21895f$var$getNormalizer(12)
};
var $32e31499ba21895f$var$normalize = function(duration, date) {
    var normalizedDuration = $32e31499ba21895f$var$__assign({}, duration);
    for(var i = 0; i < $32e31499ba21895f$var$normalizeOrder.length; i++){
        var unit = $32e31499ba21895f$var$normalizeOrder[i];
        var unitValue = normalizedDuration[unit];
        if (unitValue > 0) {
            var temp = $32e31499ba21895f$var$unitNormalizer[unit](unitValue, date);
            normalizedDuration[unit] = temp.value;
            if (temp.nextUnitValue) {
                var nextUnit = unit === "months" ? "years" : $32e31499ba21895f$var$normalizeOrder[i + 1];
                normalizedDuration[nextUnit] = normalizedDuration[nextUnit] + temp.nextUnitValue;
            }
        }
    }
    return normalizedDuration;
};
var $32e31499ba21895f$var$IsoDuration = /** @class */ function() {
    function IsoDuration(durationObj) {
        this.durationObj = durationObj;
    }
    IsoDuration.prototype.parse = function() {
        return this.durationObj;
    };
    IsoDuration.prototype.toString = function() {
        return $32e31499ba21895f$var$durationObjToString(this.durationObj);
    };
    IsoDuration.prototype.humanize = function(lang, config) {
        return $32e31499ba21895f$var$humanize(this.durationObj, lang, config);
    };
    IsoDuration.prototype.normalize = function(date) {
        this.durationObj = $32e31499ba21895f$var$normalize(this.durationObj, date);
        return this;
    };
    IsoDuration.prototype.isEmpty = function() {
        var _this = this;
        return Object.keys(this.durationObj).every(function(key) {
            return _this.durationObj[key] === 0;
        });
    };
    return IsoDuration;
}();
function $32e31499ba21895f$var$getArabicForm(c) {
    if (c <= 2) return 0;
    if (c > 2 && c < 11) return 1;
    return 0;
}
var $32e31499ba21895f$export$d24c54395ce0c509 = {
    years: function(c) {
        return c === 1 ? "\u0633\u0646\u0629" : "\u0633\u0646\u0648\u0627\u062A";
    },
    months: function(c) {
        return c === 1 ? "\u0634\u0647\u0631" : "\u0623\u0634\u0647\u0631";
    },
    weeks: function(c) {
        return c === 1 ? "\u0623\u0633\u0628\u0648\u0639" : "\u0623\u0633\u0627\u0628\u064A\u0639";
    },
    days: function(c) {
        return c === 1 ? "\u064A\u0648\u0645" : "\u0623\u064A\u0627\u0645";
    },
    hours: function(c) {
        return c === 1 ? "\u0633\u0627\u0639\u0629" : "\u0633\u0627\u0639\u0627\u062A";
    },
    minutes: function(c) {
        return [
            "\u062F\u0642\u064A\u0642\u0629",
            "\u062F\u0642\u0627\u0626\u0642"
        ][$32e31499ba21895f$var$getArabicForm(c)];
    },
    seconds: function(c) {
        return c === 1 ? "\u062B\u0627\u0646\u064A\u0629" : "\u062B\u0648\u0627\u0646\u064A";
    },
    decimal: ","
};
function $32e31499ba21895f$var$getSlavicForm(c) {
    if (Math.floor(c) !== c) return 2;
    else if (c % 100 >= 5 && c % 100 <= 20 || c % 10 >= 5 && c % 10 <= 9 || c % 10 === 0) return 0;
    else if (c % 10 === 1) return 1;
    else if (c > 1) return 2;
    else return 0;
}
var $32e31499ba21895f$export$136fd86de524d3c2 = {
    years: function(c) {
        return [
            "\u0433\u043E\u0434\u0438\u043D\u0438",
            "\u0433\u043E\u0434\u0438\u043D\u0430",
            "\u0433\u043E\u0434\u0438\u043D\u0438"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    months: function(c) {
        return [
            "\u043C\u0435\u0441\u0435\u0446\u0430",
            "\u043C\u0435\u0441\u0435\u0446",
            "\u043C\u0435\u0441\u0435\u0446\u0430"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    weeks: function(c) {
        return [
            "\u0441\u0435\u0434\u043C\u0438\u0446\u0438",
            "\u0441\u0435\u0434\u043C\u0438\u0446\u0430",
            "\u0441\u0435\u0434\u043C\u0438\u0446\u0438"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    days: function(c) {
        return [
            "\u0434\u043D\u0438",
            "\u0434\u0435\u043D",
            "\u0434\u043D\u0438"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    hours: function(c) {
        return [
            "\u0447\u0430\u0441\u0430",
            "\u0447\u0430\u0441",
            "\u0447\u0430\u0441\u0430"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    minutes: function(c) {
        return [
            "\u043C\u0438\u043D\u0443\u0442\u0438",
            "\u043C\u0438\u043D\u0443\u0442\u0430",
            "\u043C\u0438\u043D\u0443\u0442\u0438"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    seconds: function(c) {
        return [
            "\u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            "\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            "\u0441\u0435\u043A\u0443\u043D\u0434\u0438"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    decimal: ","
};
var $32e31499ba21895f$export$89e9012e902952b6 = {
    years: function(c) {
        return "any" + (c === 1 ? "" : "s");
    },
    months: function(c) {
        return "mes" + (c === 1 ? "" : "os");
    },
    weeks: function(c) {
        return "setman" + (c === 1 ? "a" : "es");
    },
    days: function(c) {
        return "di" + (c === 1 ? "a" : "es");
    },
    hours: function(c) {
        return "hor" + (c === 1 ? "a" : "es");
    },
    minutes: function(c) {
        return "minut" + (c === 1 ? "" : "s");
    },
    seconds: function(c) {
        return "segon" + (c === 1 ? "" : "s");
    },
    decimal: ","
};
function $32e31499ba21895f$var$getCzechOrSlovakForm(c) {
    if (c === 1) return 0;
    else if (Math.floor(c) !== c) return 1;
    else if (c % 10 >= 2 && c % 10 <= 4 && c % 100 < 10) return 2;
    else return 3;
}
var $32e31499ba21895f$export$bde1ed0f60b38f2f = {
    years: function(c) {
        return [
            "rok",
            "roku",
            "roky",
            "let"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    months: function(c) {
        return [
            "m\u011Bs\xedc",
            "m\u011Bs\xedce",
            "m\u011Bs\xedce",
            "m\u011Bs\xedc\u016F"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    weeks: function(c) {
        return [
            "t\xfdden",
            "t\xfddne",
            "t\xfddny",
            "t\xfddn\u016F"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    days: function(c) {
        return [
            "den",
            "dne",
            "dny",
            "dn\xed"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    hours: function(c) {
        return [
            "hodina",
            "hodiny",
            "hodiny",
            "hodin"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    minutes: function(c) {
        return [
            "minuta",
            "minuty",
            "minuty",
            "minut"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    seconds: function(c) {
        return [
            "sekunda",
            "sekundy",
            "sekundy",
            "sekund"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    decimal: ","
};
var $32e31499ba21895f$export$8c8450b83b664ba4 = {
    years: function() {
        return "\xe5r";
    },
    months: function(c) {
        return "m\xe5ned" + (c === 1 ? "" : "er");
    },
    weeks: function(c) {
        return "uge" + (c === 1 ? "" : "r");
    },
    days: function(c) {
        return "dag" + (c === 1 ? "" : "e");
    },
    hours: function(c) {
        return "time" + (c === 1 ? "" : "r");
    },
    minutes: function(c) {
        return "minut" + (c === 1 ? "" : "ter");
    },
    seconds: function(c) {
        return "sekund" + (c === 1 ? "" : "er");
    },
    decimal: ","
};
var $32e31499ba21895f$export$2fa162a495d26869 = {
    years: function(c) {
        return "Jahr" + (c === 1 ? "" : "e");
    },
    months: function(c) {
        return "Monat" + (c === 1 ? "" : "e");
    },
    weeks: function(c) {
        return "Woche" + (c === 1 ? "" : "n");
    },
    days: function(c) {
        return "Tag" + (c === 1 ? "" : "e");
    },
    hours: function(c) {
        return "Stunde" + (c === 1 ? "" : "n");
    },
    minutes: function(c) {
        return "Minute" + (c === 1 ? "" : "n");
    },
    seconds: function(c) {
        return "Sekunde" + (c === 1 ? "" : "n");
    },
    decimal: ","
};
var $32e31499ba21895f$export$84584c2a98eb6753 = {
    years: function(c) {
        return "year" + (c === 1 ? "" : "s");
    },
    months: function(c) {
        return "month" + (c === 1 ? "" : "s");
    },
    weeks: function(c) {
        return "week" + (c === 1 ? "" : "s");
    },
    days: function(c) {
        return "day" + (c === 1 ? "" : "s");
    },
    hours: function(c) {
        return "hour" + (c === 1 ? "" : "s");
    },
    minutes: function(c) {
        return "minute" + (c === 1 ? "" : "s");
    },
    seconds: function(c) {
        return "second" + (c === 1 ? "" : "s");
    },
    decimal: "."
};
var $32e31499ba21895f$export$ca5e4045a55e76d2 = {
    years: function(c) {
        return "a\xf1o" + (c === 1 ? "" : "s");
    },
    months: function(c) {
        return "mes" + (c === 1 ? "" : "es");
    },
    weeks: function(c) {
        return "semana" + (c === 1 ? "" : "s");
    },
    days: function(c) {
        return "d\xeda" + (c === 1 ? "" : "s");
    },
    hours: function(c) {
        return "hora" + (c === 1 ? "" : "s");
    },
    minutes: function(c) {
        return "minuto" + (c === 1 ? "" : "s");
    },
    seconds: function(c) {
        return "segundo" + (c === 1 ? "" : "s");
    },
    decimal: ","
};
var $32e31499ba21895f$export$457177dcde8472be = {
    years: function(c) {
        return "aasta" + (c === 1 ? "" : "t");
    },
    months: function(c) {
        return "kuu" + (c === 1 ? "" : "d");
    },
    weeks: function(c) {
        return "n\xe4dal" + (c === 1 ? "" : "at");
    },
    days: function(c) {
        return "p\xe4ev" + (c === 1 ? "" : "a");
    },
    hours: function(c) {
        return "tund" + (c === 1 ? "" : "i");
    },
    minutes: function(c) {
        return "minut" + (c === 1 ? "" : "it");
    },
    seconds: function(c) {
        return "sekund" + (c === 1 ? "" : "it");
    },
    decimal: ","
};
var $32e31499ba21895f$export$48a262eaf0aadda2 = {
    years: function() {
        return "\u0633\u0627\u0644";
    },
    months: function() {
        return "\u0645\u0627\u0647";
    },
    weeks: function() {
        return "\u0647\u0641\u062A\u0647";
    },
    days: function() {
        return "\u0631\u0648\u0632";
    },
    hours: function() {
        return "\u0633\u0627\u0639\u062A";
    },
    minutes: function() {
        return "\u062F\u0642\u06CC\u0642\u0647";
    },
    seconds: function() {
        return "\u062B\u0627\u0646\u06CC\u0647";
    },
    decimal: "."
};
var $32e31499ba21895f$export$ed5179c818622fb = {
    years: function(c) {
        return c === 1 ? "vuosi" : "vuotta";
    },
    months: function(c) {
        return c === 1 ? "kuukausi" : "kuukautta";
    },
    weeks: function(c) {
        return "viikko" + (c === 1 ? "" : "a");
    },
    days: function(c) {
        return "p\xe4iv\xe4" + (c === 1 ? "" : "\xe4");
    },
    hours: function(c) {
        return "tunti" + (c === 1 ? "" : "a");
    },
    minutes: function(c) {
        return "minuutti" + (c === 1 ? "" : "a");
    },
    seconds: function(c) {
        return "sekunti" + (c === 1 ? "" : "a");
    },
    decimal: ","
};
var $32e31499ba21895f$export$8979478257f87fe6 = {
    years: function() {
        return "\xe1r";
    },
    months: function(c) {
        return c === 1 ? "m\xe1na\xf0ur" : "m\xe1na\xf0ir";
    },
    weeks: function(c) {
        return c === 1 ? "vika" : "vikur";
    },
    days: function(c) {
        return c === 1 ? "dagur" : "dagar";
    },
    hours: function(c) {
        return c === 1 ? "t\xedmi" : "t\xedmar";
    },
    minutes: function(c) {
        return c === 1 ? "minuttur" : "minuttir";
    },
    seconds: function() {
        return "sekund";
    },
    decimal: ","
};
var $32e31499ba21895f$export$acb2a88f7d552ebf = {
    years: function(c) {
        return "an" + (c >= 2 ? "s" : "");
    },
    months: function() {
        return "mois";
    },
    weeks: function(c) {
        return "semaine" + (c >= 2 ? "s" : "");
    },
    days: function(c) {
        return "jour" + (c >= 2 ? "s" : "");
    },
    hours: function(c) {
        return "heure" + (c >= 2 ? "s" : "");
    },
    minutes: function(c) {
        return "minute" + (c >= 2 ? "s" : "");
    },
    seconds: function(c) {
        return "seconde" + (c >= 2 ? "s" : "");
    },
    decimal: ","
};
var $32e31499ba21895f$export$d911550c75100362 = {
    years: function(c) {
        return c === 1 ? "\u03C7\u03C1\u03CC\u03BD\u03BF\u03C2" : "\u03C7\u03C1\u03CC\u03BD\u03B9\u03B1";
    },
    months: function(c) {
        return c === 1 ? "\u03BC\u03AE\u03BD\u03B1\u03C2" : "\u03BC\u03AE\u03BD\u03B5\u03C2";
    },
    weeks: function(c) {
        return c === 1 ? "\u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1" : "\u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2";
    },
    days: function(c) {
        return c === 1 ? "\u03BC\u03AD\u03C1\u03B1" : "\u03BC\u03AD\u03C1\u03B5\u03C2";
    },
    hours: function(c) {
        return c === 1 ? "\u03CE\u03C1\u03B1" : "\u03CE\u03C1\u03B5\u03C2";
    },
    minutes: function(c) {
        return c === 1 ? "\u03BB\u03B5\u03C0\u03C4\u03CC" : "\u03BB\u03B5\u03C0\u03C4\u03AC";
    },
    seconds: function(c) {
        return c === 1 ? "\u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF" : "\u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1";
    },
    decimal: ","
};
var $32e31499ba21895f$export$10cc7d172bb7969 = {
    years: function(c) {
        return c === 1 ? "\u05E9\u05E0\u05D4" : "\u05E9\u05E0\u05D9\u05DD";
    },
    months: function(c) {
        return c === 1 ? "\u05D7\u05D5\u05D3\u05E9" : "\u05D7\u05D5\u05D3\u05E9\u05D9\u05DD";
    },
    weeks: function(c) {
        return c === 1 ? "\u05E9\u05D1\u05D5\u05E2" : "\u05E9\u05D1\u05D5\u05E2\u05D5\u05EA";
    },
    days: function(c) {
        return c === 1 ? "\u05D9\u05D5\u05DD" : "\u05D9\u05DE\u05D9\u05DD";
    },
    hours: function(c) {
        return c === 1 ? "\u05E9\u05E2\u05D4" : "\u05E9\u05E2\u05D5\u05EA";
    },
    minutes: function(c) {
        return c === 1 ? "\u05D3\u05E7\u05D4" : "\u05D3\u05E7\u05D5\u05EA";
    },
    seconds: function(c) {
        return c === 1 ? "\u05E9\u05E0\u05D9\u05D4" : "\u05E9\u05E0\u05D9\u05D5\u05EA";
    },
    decimal: "."
};
var $32e31499ba21895f$export$b4adb3f464574dcf = {
    years: function(c) {
        if (c % 10 === 2 || c % 10 === 3 || c % 10 === 4) return "godine";
        return "godina";
    },
    months: function(c) {
        if (c === 1) return "mjesec";
        else if (c === 2 || c === 3 || c === 4) return "mjeseca";
        return "mjeseci";
    },
    weeks: function(c) {
        if (c % 10 === 1 && c !== 11) return "tjedan";
        return "tjedna";
    },
    days: function(c) {
        return c === 1 ? "dan" : "dana";
    },
    hours: function(c) {
        if (c === 1) return "sat";
        else if (c === 2 || c === 3 || c === 4) return "sata";
        return "sati";
    },
    minutes: function(c) {
        var mod10 = c % 10;
        if ((mod10 === 2 || mod10 === 3 || mod10 === 4) && (c < 10 || c > 14)) return "minute";
        return "minuta";
    },
    seconds: function(c) {
        if (c === 10 || c === 11 || c === 12 || c === 13 || c === 14 || c === 16 || c === 17 || c === 18 || c === 19 || c % 10 === 5) return "sekundi";
        else if (c % 10 === 1) return "sekunda";
        else if (c % 10 === 2 || c % 10 === 3 || c % 10 === 4) return "sekunde";
        return "sekundi";
    },
    decimal: ","
};
var $32e31499ba21895f$export$9901d21957972d53 = {
    years: function() {
        return "\xe9v";
    },
    months: function() {
        return "h\xf3nap";
    },
    weeks: function() {
        return "h\xe9t";
    },
    days: function() {
        return "nap";
    },
    hours: function() {
        return "\xf3ra";
    },
    minutes: function() {
        return "perc";
    },
    seconds: function() {
        return "m\xe1sodperc";
    },
    decimal: ","
};
var $32e31499ba21895f$export$226b3eccf92c9ed9 = {
    years: function() {
        return "\xe1r";
    },
    months: function(c) {
        return "m\xe1nu\xf0" + (c === 1 ? "ur" : "ir");
    },
    weeks: function(c) {
        return "vik" + (c === 1 ? "a" : "ur");
    },
    days: function(c) {
        return "dag" + (c === 1 ? "ur" : "ar");
    },
    hours: function(c) {
        return "klukkut\xedm" + (c === 1 ? "i" : "ar");
    },
    minutes: function(c) {
        return "m\xedn\xfat" + (c === 1 ? "a" : "ur");
    },
    seconds: function(c) {
        return "sek\xfand" + (c === 1 ? "a" : "ur");
    },
    decimal: "."
};
var $32e31499ba21895f$export$3486a10f30cf1ee4 = {
    years: function(c) {
        return "ann" + (c === 1 ? "o" : "i");
    },
    months: function(c) {
        return "mes" + (c === 1 ? "e" : "i");
    },
    weeks: function(c) {
        return "settiman" + (c === 1 ? "a" : "e");
    },
    days: function(c) {
        return "giorn" + (c === 1 ? "o" : "i");
    },
    hours: function(c) {
        return "or" + (c === 1 ? "a" : "e");
    },
    minutes: function(c) {
        return "minut" + (c === 1 ? "o" : "i");
    },
    seconds: function(c) {
        return "second" + (c === 1 ? "o" : "i");
    },
    decimal: ","
};
var $32e31499ba21895f$export$8c6f505e9474ce90 = {
    years: function() {
        return "\u5E74";
    },
    months: function() {
        return "\u6708";
    },
    weeks: function() {
        return "\u9031";
    },
    days: function() {
        return "\u65E5";
    },
    hours: function() {
        return "\u6642\u9593";
    },
    minutes: function() {
        return "\u5206";
    },
    seconds: function() {
        return "\u79D2";
    },
    decimal: "."
};
var $32e31499ba21895f$export$798cf677954c9533 = {
    years: function() {
        return "\uB144";
    },
    months: function() {
        return "\uAC1C\uC6D4";
    },
    weeks: function() {
        return "\uC8FC\uC77C";
    },
    days: function() {
        return "\uC77C";
    },
    hours: function() {
        return "\uC2DC\uAC04";
    },
    minutes: function() {
        return "\uBD84";
    },
    seconds: function() {
        return "\uCD08";
    },
    decimal: "."
};
var $32e31499ba21895f$export$bb2182dfba3e387a = {
    years: function() {
        return "\u0E9B\u0EB5";
    },
    months: function() {
        return "\u0EC0\u0E94\u0EB7\u0EAD\u0E99";
    },
    weeks: function() {
        return "\u0EAD\u0EB2\u0E97\u0EB4\u0E94";
    },
    days: function() {
        return "\u0EA1\u0EB7\u0EC9";
    },
    hours: function() {
        return "\u0E8A\u0EBB\u0EC8\u0EA7\u0EC2\u0EA1\u0E87";
    },
    minutes: function() {
        return "\u0E99\u0EB2\u0E97\u0EB5";
    },
    seconds: function() {
        return "\u0EA7\u0EB4\u0E99\u0EB2\u0E97\u0EB5";
    },
    decimal: ","
};
function $32e31499ba21895f$var$getLithuanianForm(c) {
    if (c === 1 || c % 10 === 1 && c % 100 > 20) return 0;
    else if (Math.floor(c) !== c || c % 10 >= 2 && c % 100 > 20 || c % 10 >= 2 && c % 100 < 10) return 1;
    else return 2;
}
var $32e31499ba21895f$export$b961576059b7aeb6 = {
    years: function(c) {
        return c % 10 === 0 || c % 100 >= 10 && c % 100 <= 20 ? "met\u0173" : "metai";
    },
    months: function(c) {
        return [
            "m\u0117nuo",
            "m\u0117nesiai",
            "m\u0117nesi\u0173"
        ][$32e31499ba21895f$var$getLithuanianForm(c)];
    },
    weeks: function(c) {
        return [
            "savait\u0117",
            "savait\u0117s",
            "savai\u010Di\u0173"
        ][$32e31499ba21895f$var$getLithuanianForm(c)];
    },
    days: function(c) {
        return [
            "diena",
            "dienos",
            "dien\u0173"
        ][$32e31499ba21895f$var$getLithuanianForm(c)];
    },
    hours: function(c) {
        return [
            "valanda",
            "valandos",
            "valand\u0173"
        ][$32e31499ba21895f$var$getLithuanianForm(c)];
    },
    minutes: function(c) {
        return [
            "minut\u0117",
            "minut\u0117s",
            "minu\u010Di\u0173"
        ][$32e31499ba21895f$var$getLithuanianForm(c)];
    },
    seconds: function(c) {
        return [
            "sekund\u0117",
            "sekund\u0117s",
            "sekund\u017Ei\u0173"
        ][$32e31499ba21895f$var$getLithuanianForm(c)];
    },
    decimal: ","
};
function $32e31499ba21895f$var$getLatvianForm(c) {
    if (c === 1 || c % 10 === 1 && c % 100 !== 11) return 0;
    else return 1;
}
var $32e31499ba21895f$export$54ca4d1eb7926f1 = {
    years: function(c) {
        return [
            "gads",
            "gadi"
        ][$32e31499ba21895f$var$getLatvianForm(c)];
    },
    months: function(c) {
        return [
            "m\u0113nesis",
            "m\u0113ne\u0161i"
        ][$32e31499ba21895f$var$getLatvianForm(c)];
    },
    weeks: function(c) {
        return [
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cas"
        ][$32e31499ba21895f$var$getLatvianForm(c)];
    },
    days: function(c) {
        return [
            "diena",
            "dienas"
        ][$32e31499ba21895f$var$getLatvianForm(c)];
    },
    hours: function(c) {
        return [
            "stunda",
            "stundas"
        ][$32e31499ba21895f$var$getLatvianForm(c)];
    },
    minutes: function(c) {
        return [
            "min\u016Bte",
            "min\u016Btes"
        ][$32e31499ba21895f$var$getLatvianForm(c)];
    },
    seconds: function(c) {
        return [
            "sekunde",
            "sekundes"
        ][$32e31499ba21895f$var$getLatvianForm(c)];
    },
    decimal: ","
};
var $32e31499ba21895f$export$5dd2165da01bec80 = {
    years: function() {
        return "tahun";
    },
    months: function() {
        return "bulan";
    },
    weeks: function() {
        return "minggu";
    },
    days: function() {
        return "hari";
    },
    hours: function() {
        return "jam";
    },
    minutes: function() {
        return "minit";
    },
    seconds: function() {
        return "saat";
    },
    decimal: "."
};
var $32e31499ba21895f$export$9c64ee4d84d79ce1 = {
    years: function() {
        return "jaar";
    },
    months: function(c) {
        return c === 1 ? "maand" : "maanden";
    },
    weeks: function(c) {
        return c === 1 ? "week" : "weken";
    },
    days: function(c) {
        return c === 1 ? "dag" : "dagen";
    },
    hours: function() {
        return "uur";
    },
    minutes: function(c) {
        return c === 1 ? "minuut" : "minuten";
    },
    seconds: function(c) {
        return c === 1 ? "seconde" : "seconden";
    },
    decimal: ","
};
var $32e31499ba21895f$export$401451a107dc42ce = {
    years: function() {
        return "\xe5r";
    },
    months: function(c) {
        return "m\xe5ned" + (c === 1 ? "" : "er");
    },
    weeks: function(c) {
        return "uke" + (c === 1 ? "" : "r");
    },
    days: function(c) {
        return "dag" + (c === 1 ? "" : "er");
    },
    hours: function(c) {
        return "time" + (c === 1 ? "" : "r");
    },
    minutes: function(c) {
        return "minutt" + (c === 1 ? "" : "er");
    },
    seconds: function(c) {
        return "sekund" + (c === 1 ? "" : "er");
    },
    decimal: ","
};
function $32e31499ba21895f$var$getPolishForm(c) {
    if (c === 1) return 0;
    else if (Math.floor(c) !== c) return 1;
    else if (c % 10 >= 2 && c % 10 <= 4 && !(c % 100 > 10 && c % 100 < 20)) return 2;
    else return 3;
}
var $32e31499ba21895f$export$6ea5311eda92944f = {
    years: function(c) {
        return [
            "rok",
            "roku",
            "lata",
            "lat"
        ][$32e31499ba21895f$var$getPolishForm(c)];
    },
    months: function(c) {
        return [
            "miesi\u0105c",
            "miesi\u0105ca",
            "miesi\u0105ce",
            "miesi\u0119cy"
        ][$32e31499ba21895f$var$getPolishForm(c)];
    },
    weeks: function(c) {
        return [
            "tydzie\u0144",
            "tygodnia",
            "tygodnie",
            "tygodni"
        ][$32e31499ba21895f$var$getPolishForm(c)];
    },
    days: function(c) {
        return [
            "dzie\u0144",
            "dnia",
            "dni",
            "dni"
        ][$32e31499ba21895f$var$getPolishForm(c)];
    },
    hours: function(c) {
        return [
            "godzina",
            "godziny",
            "godziny",
            "godzin"
        ][$32e31499ba21895f$var$getPolishForm(c)];
    },
    minutes: function(c) {
        return [
            "minuta",
            "minuty",
            "minuty",
            "minut"
        ][$32e31499ba21895f$var$getPolishForm(c)];
    },
    seconds: function(c) {
        return [
            "sekunda",
            "sekundy",
            "sekundy",
            "sekund"
        ][$32e31499ba21895f$var$getPolishForm(c)];
    },
    decimal: ","
};
var $32e31499ba21895f$export$84175d5f1cb4e39d = {
    years: function(c) {
        return "ano" + (c === 1 ? "" : "s");
    },
    months: function(c) {
        return c === 1 ? "m\xeas" : "meses";
    },
    weeks: function(c) {
        return "semana" + (c === 1 ? "" : "s");
    },
    days: function(c) {
        return "dia" + (c === 1 ? "" : "s");
    },
    hours: function(c) {
        return "hora" + (c === 1 ? "" : "s");
    },
    minutes: function(c) {
        return "minuto" + (c === 1 ? "" : "s");
    },
    seconds: function(c) {
        return "segundo" + (c === 1 ? "" : "s");
    },
    decimal: ","
};
var $32e31499ba21895f$export$ea30ec7f37fb148d = {
    years: function(c) {
        return c === 1 ? "an" : "ani";
    },
    months: function(c) {
        return c === 1 ? "lun\u0103" : "luni";
    },
    weeks: function(c) {
        return c === 1 ? "s\u0103pt\u0103m\xe2n\u0103" : "s\u0103pt\u0103m\xe2ni";
    },
    days: function(c) {
        return c === 1 ? "zi" : "zile";
    },
    hours: function(c) {
        return c === 1 ? "or\u0103" : "ore";
    },
    minutes: function(c) {
        return c === 1 ? "minut" : "minute";
    },
    seconds: function(c) {
        return c === 1 ? "secund\u0103" : "secunde";
    },
    decimal: ","
};
var $32e31499ba21895f$export$cf48009033a0126b = {
    years: function(c) {
        return [
            "\u043B\u0435\u0442",
            "\u0433\u043E\u0434",
            "\u0433\u043E\u0434\u0430"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    months: function(c) {
        return [
            "\u043C\u0435\u0441\u044F\u0446\u0435\u0432",
            "\u043C\u0435\u0441\u044F\u0446",
            "\u043C\u0435\u0441\u044F\u0446\u0430"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    weeks: function(c) {
        return [
            "\u043D\u0435\u0434\u0435\u043B\u044C",
            "\u043D\u0435\u0434\u0435\u043B\u044F",
            "\u043D\u0435\u0434\u0435\u043B\u0438"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    days: function(c) {
        return [
            "\u0434\u043D\u0435\u0439",
            "\u0434\u0435\u043D\u044C",
            "\u0434\u043D\u044F"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    hours: function(c) {
        return [
            "\u0447\u0430\u0441\u043E\u0432",
            "\u0447\u0430\u0441",
            "\u0447\u0430\u0441\u0430"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    minutes: function(c) {
        return [
            "\u043C\u0438\u043D\u0443\u0442",
            "\u043C\u0438\u043D\u0443\u0442\u0430",
            "\u043C\u0438\u043D\u0443\u0442\u044B"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    seconds: function(c) {
        return [
            "\u0441\u0435\u043A\u0443\u043D\u0434",
            "\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            "\u0441\u0435\u043A\u0443\u043D\u0434\u044B"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    decimal: ","
};
var $32e31499ba21895f$export$d608fa5b5bfd2021 = {
    years: function(c) {
        return [
            "rok",
            "roky",
            "roky",
            "rokov"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    months: function(c) {
        return [
            "mesiac",
            "mesiace",
            "mesiace",
            "mesiacov"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    weeks: function(c) {
        return [
            "t\xfd\u017Ede\u0148",
            "t\xfd\u017Edne",
            "t\xfd\u017Edne",
            "t\xfd\u017Ed\u0148ov"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    days: function(c) {
        return [
            "de\u0148",
            "dni",
            "dni",
            "dn\xed"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    hours: function(c) {
        return [
            "hodina",
            "hodiny",
            "hodiny",
            "hod\xedn"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    minutes: function(c) {
        return [
            "min\xfata",
            "min\xfaty",
            "min\xfaty",
            "min\xfat"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    seconds: function(c) {
        return [
            "sekunda",
            "sekundy",
            "sekundy",
            "sek\xfand"
        ][$32e31499ba21895f$var$getCzechOrSlovakForm(c)];
    },
    decimal: ","
};
var $32e31499ba21895f$export$65540e5f7f6e7dce = {
    years: function() {
        return "\xe5r";
    },
    months: function(c) {
        return "m\xe5nad" + (c === 1 ? "" : "er");
    },
    weeks: function(c) {
        return "veck" + (c === 1 ? "a" : "or");
    },
    days: function(c) {
        return "dag" + (c === 1 ? "" : "ar");
    },
    hours: function(c) {
        return "timm" + (c === 1 ? "e" : "ar");
    },
    minutes: function(c) {
        return "minut" + (c === 1 ? "" : "er");
    },
    seconds: function(c) {
        return "sekund" + (c === 1 ? "" : "er");
    },
    decimal: ","
};
var $32e31499ba21895f$export$72451b88a72ad9c2 = {
    years: function() {
        return "y\u0131l";
    },
    months: function() {
        return "ay";
    },
    weeks: function() {
        return "hafta";
    },
    days: function() {
        return "g\xfcn";
    },
    hours: function() {
        return "saat";
    },
    minutes: function() {
        return "dakika";
    },
    seconds: function() {
        return "saniye";
    },
    decimal: ","
};
var $32e31499ba21895f$export$312745a8a3013c00 = {
    years: function(c) {
        return [
            "\u0440\u043E\u043A\u0456\u0432",
            "\u0440\u0456\u043A",
            "\u0440\u043E\u043A\u0438"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    months: function(c) {
        return [
            "\u043C\u0456\u0441\u044F\u0446\u0456\u0432",
            "\u043C\u0456\u0441\u044F\u0446\u044C",
            "\u043C\u0456\u0441\u044F\u0446\u0456"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    weeks: function(c) {
        return [
            "\u0442\u0438\u0436\u043D\u0456\u0432",
            "\u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            "\u0442\u0438\u0436\u043D\u0456"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    days: function(c) {
        return [
            "\u0434\u043D\u0456\u0432",
            "\u0434\u0435\u043D\u044C",
            "\u0434\u043D\u0456"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    hours: function(c) {
        return [
            "\u0433\u043E\u0434\u0438\u043D",
            "\u0433\u043E\u0434\u0438\u043D\u0430",
            "\u0433\u043E\u0434\u0438\u043D\u0438"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    minutes: function(c) {
        return [
            "\u0445\u0432\u0438\u043B\u0438\u043D",
            "\u0445\u0432\u0438\u043B\u0438\u043D\u0430",
            "\u0445\u0432\u0438\u043B\u0438\u043D\u0438"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    seconds: function(c) {
        return [
            "\u0441\u0435\u043A\u0443\u043D\u0434",
            "\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            "\u0441\u0435\u043A\u0443\u043D\u0434\u0438"
        ][$32e31499ba21895f$var$getSlavicForm(c)];
    },
    decimal: ","
};
var $32e31499ba21895f$export$bde472100d10f4c2 = {
    years: function() {
        return "\u0633\u0627\u0644";
    },
    months: function(c) {
        return c === 1 ? "\u0645\u06C1\u06CC\u0646\u06C1" : "\u0645\u06C1\u06CC\u0646\u06D2";
    },
    weeks: function(c) {
        return c === 1 ? "\u06C1\u0641\u062A\u06C1" : "\u06C1\u0641\u062A\u06D2";
    },
    days: function() {
        return "\u062F\u0646";
    },
    hours: function(c) {
        return c === 1 ? "\u06AF\u06BE\u0646\u0679\u06C1" : "\u06AF\u06BE\u0646\u0679\u06D2";
    },
    minutes: function() {
        return "\u0645\u0646\u0679";
    },
    seconds: function() {
        return "\u0633\u06CC\u06A9\u0646\u0688";
    },
    decimal: "."
};
var $32e31499ba21895f$export$e3786bf10a8abdf2 = {
    years: function() {
        return "n\u0103m";
    },
    months: function() {
        return "th\xe1ng";
    },
    weeks: function() {
        return "tu\u1EA7n";
    },
    days: function() {
        return "ng\xe0y";
    },
    hours: function() {
        return "gi\u1EDD";
    },
    minutes: function() {
        return "ph\xfat";
    },
    seconds: function() {
        return "gi\xe2y";
    },
    decimal: ","
};
var $32e31499ba21895f$export$836e793ad054f4a7 = {
    years: function() {
        return "\u5E74";
    },
    months: function() {
        return "\u4E2A\u6708";
    },
    weeks: function() {
        return "\u5468";
    },
    days: function() {
        return "\u5929";
    },
    hours: function() {
        return "\u5C0F\u65F6";
    },
    minutes: function() {
        return "\u5206\u949F";
    },
    seconds: function() {
        return "\u79D2";
    },
    decimal: "."
};
var $32e31499ba21895f$export$3991fdf1bb6f66b9 = {
    years: function() {
        return "\u5E74";
    },
    months: function() {
        return "\u500B\u6708";
    },
    weeks: function() {
        return "\u5468";
    },
    days: function() {
        return "\u5929";
    },
    hours: function() {
        return "\u5C0F\u6642";
    },
    minutes: function() {
        return "\u5206\u9418";
    },
    seconds: function() {
        return "\u79D2";
    },
    decimal: "."
};
function $32e31499ba21895f$export$b097d39b3dd34935(duration) {
    if (typeof duration === "string") return new $32e31499ba21895f$var$IsoDuration($32e31499ba21895f$var$parseIsoString(duration));
    return new $32e31499ba21895f$var$IsoDuration($32e31499ba21895f$var$normalizeDurationObj(duration));
}
$32e31499ba21895f$export$b097d39b3dd34935.setLocales = function(obj, options) {
    $32e31499ba21895f$var$config.setLocales(obj, options);
};

});

parcelRegister("fJT3K", function(module, exports) {

$parcel$export(module.exports, "format", function () { return $b755c4a7bdc2d289$export$d9468344d3651243; }, function (v) { return $b755c4a7bdc2d289$export$d9468344d3651243 = v; });
$parcel$export(module.exports, "parse", function () { return $b755c4a7bdc2d289$export$98e6a39c04603d36; }, function (v) { return $b755c4a7bdc2d289$export$98e6a39c04603d36 = v; });
/*!
 * content-type
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $b755c4a7bdc2d289$export$d9468344d3651243;
var $b755c4a7bdc2d289$export$98e6a39c04603d36;
"use strict";
/**
 * RegExp to match *( ";" parameter ) in RFC 7231 sec 3.1.1.1
 *
 * parameter     = token "=" ( token / quoted-string )
 * token         = 1*tchar
 * tchar         = "!" / "#" / "$" / "%" / "&" / "'" / "*"
 *               / "+" / "-" / "." / "^" / "_" / "`" / "|" / "~"
 *               / DIGIT / ALPHA
 *               ; any VCHAR, except delimiters
 * quoted-string = DQUOTE *( qdtext / quoted-pair ) DQUOTE
 * qdtext        = HTAB / SP / %x21 / %x23-5B / %x5D-7E / obs-text
 * obs-text      = %x80-FF
 * quoted-pair   = "\" ( HTAB / SP / VCHAR / obs-text )
 */ var $b755c4a7bdc2d289$var$PARAM_REGEXP = /; *([!#$%&'*+.^_`|~0-9A-Za-z-]+) *= *("(?:[\u000b\u0020\u0021\u0023-\u005b\u005d-\u007e\u0080-\u00ff]|\\[\u000b\u0020-\u00ff])*"|[!#$%&'*+.^_`|~0-9A-Za-z-]+) */g // eslint-disable-line no-control-regex
;
var $b755c4a7bdc2d289$var$TEXT_REGEXP = /^[\u000b\u0020-\u007e\u0080-\u00ff]+$/ // eslint-disable-line no-control-regex
;
var $b755c4a7bdc2d289$var$TOKEN_REGEXP = /^[!#$%&'*+.^_`|~0-9A-Za-z-]+$/;
/**
 * RegExp to match quoted-pair in RFC 7230 sec 3.2.6
 *
 * quoted-pair = "\" ( HTAB / SP / VCHAR / obs-text )
 * obs-text    = %x80-FF
 */ var $b755c4a7bdc2d289$var$QESC_REGEXP = /\\([\u000b\u0020-\u00ff])/g // eslint-disable-line no-control-regex
;
/**
 * RegExp to match chars that must be quoted-pair in RFC 7230 sec 3.2.6
 */ var $b755c4a7bdc2d289$var$QUOTE_REGEXP = /([\\"])/g;
/**
 * RegExp to match type in RFC 7231 sec 3.1.1.1
 *
 * media-type = type "/" subtype
 * type       = token
 * subtype    = token
 */ var $b755c4a7bdc2d289$var$TYPE_REGEXP = /^[!#$%&'*+.^_`|~0-9A-Za-z-]+\/[!#$%&'*+.^_`|~0-9A-Za-z-]+$/;
$b755c4a7bdc2d289$export$d9468344d3651243 = $b755c4a7bdc2d289$var$format;
$b755c4a7bdc2d289$export$98e6a39c04603d36 = $b755c4a7bdc2d289$var$parse;
/**
 * Format object to media type.
 *
 * @param {object} obj
 * @return {string}
 * @public
 */ function $b755c4a7bdc2d289$var$format(obj) {
    if (!obj || typeof obj !== "object") throw new TypeError("argument obj is required");
    var parameters = obj.parameters;
    var type = obj.type;
    if (!type || !$b755c4a7bdc2d289$var$TYPE_REGEXP.test(type)) throw new TypeError("invalid type");
    var string = type;
    // append parameters
    if (parameters && typeof parameters === "object") {
        var param;
        var params = Object.keys(parameters).sort();
        for(var i = 0; i < params.length; i++){
            param = params[i];
            if (!$b755c4a7bdc2d289$var$TOKEN_REGEXP.test(param)) throw new TypeError("invalid parameter name");
            string += "; " + param + "=" + $b755c4a7bdc2d289$var$qstring(parameters[param]);
        }
    }
    return string;
}
/**
 * Parse media type to object.
 *
 * @param {string|object} string
 * @return {Object}
 * @public
 */ function $b755c4a7bdc2d289$var$parse(string) {
    if (!string) throw new TypeError("argument string is required");
    // support req/res-like objects as argument
    var header = typeof string === "object" ? $b755c4a7bdc2d289$var$getcontenttype(string) : string;
    if (typeof header !== "string") throw new TypeError("argument string is required to be a string");
    var index = header.indexOf(";");
    var type = index !== -1 ? header.slice(0, index).trim() : header.trim();
    if (!$b755c4a7bdc2d289$var$TYPE_REGEXP.test(type)) throw new TypeError("invalid media type");
    var obj = new $b755c4a7bdc2d289$var$ContentType(type.toLowerCase());
    // parse parameters
    if (index !== -1) {
        var key;
        var match;
        var value;
        $b755c4a7bdc2d289$var$PARAM_REGEXP.lastIndex = index;
        while(match = $b755c4a7bdc2d289$var$PARAM_REGEXP.exec(header)){
            if (match.index !== index) throw new TypeError("invalid parameter format");
            index += match[0].length;
            key = match[1].toLowerCase();
            value = match[2];
            if (value.charCodeAt(0) === 0x22 /* " */ ) {
                // remove quotes
                value = value.slice(1, -1);
                // remove escapes
                if (value.indexOf("\\") !== -1) value = value.replace($b755c4a7bdc2d289$var$QESC_REGEXP, "$1");
            }
            obj.parameters[key] = value;
        }
        if (index !== header.length) throw new TypeError("invalid parameter format");
    }
    return obj;
}
/**
 * Get content-type from req/res objects.
 *
 * @param {object}
 * @return {Object}
 * @private
 */ function $b755c4a7bdc2d289$var$getcontenttype(obj) {
    var header;
    if (typeof obj.getHeader === "function") // res-like
    header = obj.getHeader("content-type");
    else if (typeof obj.headers === "object") // req-like
    header = obj.headers && obj.headers["content-type"];
    if (typeof header !== "string") throw new TypeError("content-type header is missing from object");
    return header;
}
/**
 * Quote a string if necessary.
 *
 * @param {string} val
 * @return {string}
 * @private
 */ function $b755c4a7bdc2d289$var$qstring(val) {
    var str = String(val);
    // no need to quote tokens
    if ($b755c4a7bdc2d289$var$TOKEN_REGEXP.test(str)) return str;
    if (str.length > 0 && !$b755c4a7bdc2d289$var$TEXT_REGEXP.test(str)) throw new TypeError("invalid parameter value");
    return '"' + str.replace($b755c4a7bdc2d289$var$QUOTE_REGEXP, "\\$1") + '"';
}
/**
 * Class to represent a content type.
 * @private
 */ function $b755c4a7bdc2d289$var$ContentType(type) {
    this.parameters = Object.create(null);
    this.type = type;
}

});

parcelRegister("4TV4A", function(module, exports) {
/* commonmark 0.29 https://github.com/commonmark/commonmark.js @license BSD3 */ (function(global1, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    "use strict";
    function isContainer(node) {
        switch(node._type){
            case "document":
            case "block_quote":
            case "list":
            case "item":
            case "paragraph":
            case "heading":
            case "emph":
            case "strong":
            case "link":
            case "image":
            case "custom_inline":
            case "custom_block":
                return true;
            default:
                return false;
        }
    }
    var resumeAt = function(node, entering) {
        this.current = node;
        this.entering = entering === true;
    };
    var next = function() {
        var cur = this.current;
        var entering = this.entering;
        if (cur === null) return null;
        var container = isContainer(cur);
        if (entering && container) {
            if (cur._firstChild) {
                this.current = cur._firstChild;
                this.entering = true;
            } else // stay on node but exit
            this.entering = false;
        } else if (cur === this.root) this.current = null;
        else if (cur._next === null) {
            this.current = cur._parent;
            this.entering = false;
        } else {
            this.current = cur._next;
            this.entering = true;
        }
        return {
            entering: entering,
            node: cur
        };
    };
    var NodeWalker = function(root) {
        return {
            current: root,
            root: root,
            entering: true,
            next: next,
            resumeAt: resumeAt
        };
    };
    var Node = function(nodeType, sourcepos) {
        this._type = nodeType;
        this._parent = null;
        this._firstChild = null;
        this._lastChild = null;
        this._prev = null;
        this._next = null;
        this._sourcepos = sourcepos;
        this._lastLineBlank = false;
        this._lastLineChecked = false;
        this._open = true;
        this._string_content = null;
        this._literal = null;
        this._listData = {};
        this._info = null;
        this._destination = null;
        this._title = null;
        this._isFenced = false;
        this._fenceChar = null;
        this._fenceLength = 0;
        this._fenceOffset = null;
        this._level = null;
        this._onEnter = null;
        this._onExit = null;
    };
    var proto = Node.prototype;
    Object.defineProperty(proto, "isContainer", {
        get: function() {
            return isContainer(this);
        }
    });
    Object.defineProperty(proto, "type", {
        get: function() {
            return this._type;
        }
    });
    Object.defineProperty(proto, "firstChild", {
        get: function() {
            return this._firstChild;
        }
    });
    Object.defineProperty(proto, "lastChild", {
        get: function() {
            return this._lastChild;
        }
    });
    Object.defineProperty(proto, "next", {
        get: function() {
            return this._next;
        }
    });
    Object.defineProperty(proto, "prev", {
        get: function() {
            return this._prev;
        }
    });
    Object.defineProperty(proto, "parent", {
        get: function() {
            return this._parent;
        }
    });
    Object.defineProperty(proto, "sourcepos", {
        get: function() {
            return this._sourcepos;
        }
    });
    Object.defineProperty(proto, "literal", {
        get: function() {
            return this._literal;
        },
        set: function(s) {
            this._literal = s;
        }
    });
    Object.defineProperty(proto, "destination", {
        get: function() {
            return this._destination;
        },
        set: function(s) {
            this._destination = s;
        }
    });
    Object.defineProperty(proto, "title", {
        get: function() {
            return this._title;
        },
        set: function(s) {
            this._title = s;
        }
    });
    Object.defineProperty(proto, "info", {
        get: function() {
            return this._info;
        },
        set: function(s) {
            this._info = s;
        }
    });
    Object.defineProperty(proto, "level", {
        get: function() {
            return this._level;
        },
        set: function(s) {
            this._level = s;
        }
    });
    Object.defineProperty(proto, "listType", {
        get: function() {
            return this._listData.type;
        },
        set: function(t) {
            this._listData.type = t;
        }
    });
    Object.defineProperty(proto, "listTight", {
        get: function() {
            return this._listData.tight;
        },
        set: function(t) {
            this._listData.tight = t;
        }
    });
    Object.defineProperty(proto, "listStart", {
        get: function() {
            return this._listData.start;
        },
        set: function(n) {
            this._listData.start = n;
        }
    });
    Object.defineProperty(proto, "listDelimiter", {
        get: function() {
            return this._listData.delimiter;
        },
        set: function(delim) {
            this._listData.delimiter = delim;
        }
    });
    Object.defineProperty(proto, "onEnter", {
        get: function() {
            return this._onEnter;
        },
        set: function(s) {
            this._onEnter = s;
        }
    });
    Object.defineProperty(proto, "onExit", {
        get: function() {
            return this._onExit;
        },
        set: function(s) {
            this._onExit = s;
        }
    });
    Node.prototype.appendChild = function(child) {
        child.unlink();
        child._parent = this;
        if (this._lastChild) {
            this._lastChild._next = child;
            child._prev = this._lastChild;
            this._lastChild = child;
        } else {
            this._firstChild = child;
            this._lastChild = child;
        }
    };
    Node.prototype.prependChild = function(child) {
        child.unlink();
        child._parent = this;
        if (this._firstChild) {
            this._firstChild._prev = child;
            child._next = this._firstChild;
            this._firstChild = child;
        } else {
            this._firstChild = child;
            this._lastChild = child;
        }
    };
    Node.prototype.unlink = function() {
        if (this._prev) this._prev._next = this._next;
        else if (this._parent) this._parent._firstChild = this._next;
        if (this._next) this._next._prev = this._prev;
        else if (this._parent) this._parent._lastChild = this._prev;
        this._parent = null;
        this._next = null;
        this._prev = null;
    };
    Node.prototype.insertAfter = function(sibling) {
        sibling.unlink();
        sibling._next = this._next;
        if (sibling._next) sibling._next._prev = sibling;
        sibling._prev = this;
        this._next = sibling;
        sibling._parent = this._parent;
        if (!sibling._next) sibling._parent._lastChild = sibling;
    };
    Node.prototype.insertBefore = function(sibling) {
        sibling.unlink();
        sibling._prev = this._prev;
        if (sibling._prev) sibling._prev._next = sibling;
        sibling._next = this;
        this._prev = sibling;
        sibling._parent = this._parent;
        if (!sibling._prev) sibling._parent._firstChild = sibling;
    };
    Node.prototype.walker = function() {
        var walker = new NodeWalker(this);
        return walker;
    };
    /* Example of use of walker:

     var walker = w.walker();
     var event;

     while (event = walker.next()) {
     console.log(event.entering, event.node.type);
     }

     */ var encodeCache = {};
    // Create a lookup array where anything but characters in `chars` string
    // and alphanumeric chars is percent-encoded.
    //
    function getEncodeCache(exclude) {
        var i, ch, cache = encodeCache[exclude];
        if (cache) return cache;
        cache = encodeCache[exclude] = [];
        for(i = 0; i < 128; i++){
            ch = String.fromCharCode(i);
            if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
            cache.push(ch);
            else cache.push("%" + ("0" + i.toString(16).toUpperCase()).slice(-2));
        }
        for(i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
        return cache;
    }
    // Encode unsafe characters with percent-encoding, skipping already
    // encoded sequences.
    //
    //  - string       - string to encode
    //  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
    //  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
    //
    function encode(string, exclude, keepEscaped) {
        var i, l, code, nextCode, cache, result = "";
        if (typeof exclude !== "string") {
            // encode(string, keepEscaped)
            keepEscaped = exclude;
            exclude = encode.defaultChars;
        }
        if (typeof keepEscaped === "undefined") keepEscaped = true;
        cache = getEncodeCache(exclude);
        for(i = 0, l = string.length; i < l; i++){
            code = string.charCodeAt(i);
            if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
                if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                    result += string.slice(i, i + 3);
                    i += 2;
                    continue;
                }
            }
            if (code < 128) {
                result += cache[code];
                continue;
            }
            if (code >= 0xD800 && code <= 0xDFFF) {
                if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                    nextCode = string.charCodeAt(i + 1);
                    if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                        result += encodeURIComponent(string[i] + string[i + 1]);
                        i++;
                        continue;
                    }
                }
                result += "%EF%BF%BD";
                continue;
            }
            result += encodeURIComponent(string[i]);
        }
        return result;
    }
    encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
    encode.componentChars = "-_.!~*'()";
    var encode_1 = encode;
    var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
    function unwrapExports(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
    }
    function createCommonjsModule(fn, module) {
        return module = {
            exports: {}
        }, fn(module, module.exports), module.exports;
    }
    function getCjsExportFromNamespace(n) {
        return n && n["default"] || n;
    }
    var Aacute = "\xc1";
    var aacute = "\xe1";
    var Abreve = "\u0102";
    var abreve = "\u0103";
    var ac = "\u223E";
    var acd = "\u223F";
    var acE = "\u223E\u0333";
    var Acirc = "\xc2";
    var acirc = "\xe2";
    var acute = "\xb4";
    var Acy = "\u0410";
    var acy = "\u0430";
    var AElig = "\xc6";
    var aelig = "\xe6";
    var af = "\u2061";
    var Afr = "\uD835\uDD04";
    var afr = "\uD835\uDD1E";
    var Agrave = "\xc0";
    var agrave = "\xe0";
    var alefsym = "\u2135";
    var aleph = "\u2135";
    var Alpha = "\u0391";
    var alpha = "\u03B1";
    var Amacr = "\u0100";
    var amacr = "\u0101";
    var amalg = "\u2A3F";
    var amp = "&";
    var AMP = "&";
    var andand = "\u2A55";
    var And = "\u2A53";
    var and = "\u2227";
    var andd = "\u2A5C";
    var andslope = "\u2A58";
    var andv = "\u2A5A";
    var ang = "\u2220";
    var ange = "\u29A4";
    var angle = "\u2220";
    var angmsdaa = "\u29A8";
    var angmsdab = "\u29A9";
    var angmsdac = "\u29AA";
    var angmsdad = "\u29AB";
    var angmsdae = "\u29AC";
    var angmsdaf = "\u29AD";
    var angmsdag = "\u29AE";
    var angmsdah = "\u29AF";
    var angmsd = "\u2221";
    var angrt = "\u221F";
    var angrtvb = "\u22BE";
    var angrtvbd = "\u299D";
    var angsph = "\u2222";
    var angst = "\xc5";
    var angzarr = "\u237C";
    var Aogon = "\u0104";
    var aogon = "\u0105";
    var Aopf = "\uD835\uDD38";
    var aopf = "\uD835\uDD52";
    var apacir = "\u2A6F";
    var ap = "\u2248";
    var apE = "\u2A70";
    var ape = "\u224A";
    var apid = "\u224B";
    var apos = "'";
    var ApplyFunction = "\u2061";
    var approx = "\u2248";
    var approxeq = "\u224A";
    var Aring = "\xc5";
    var aring = "\xe5";
    var Ascr = "\uD835\uDC9C";
    var ascr = "\uD835\uDCB6";
    var Assign = "\u2254";
    var ast = "*";
    var asymp = "\u2248";
    var asympeq = "\u224D";
    var Atilde = "\xc3";
    var atilde = "\xe3";
    var Auml = "\xc4";
    var auml = "\xe4";
    var awconint = "\u2233";
    var awint = "\u2A11";
    var backcong = "\u224C";
    var backepsilon = "\u03F6";
    var backprime = "\u2035";
    var backsim = "\u223D";
    var backsimeq = "\u22CD";
    var Backslash = "\u2216";
    var Barv = "\u2AE7";
    var barvee = "\u22BD";
    var barwed = "\u2305";
    var Barwed = "\u2306";
    var barwedge = "\u2305";
    var bbrk = "\u23B5";
    var bbrktbrk = "\u23B6";
    var bcong = "\u224C";
    var Bcy = "\u0411";
    var bcy = "\u0431";
    var bdquo = "\u201E";
    var becaus = "\u2235";
    var because = "\u2235";
    var Because = "\u2235";
    var bemptyv = "\u29B0";
    var bepsi = "\u03F6";
    var bernou = "\u212C";
    var Bernoullis = "\u212C";
    var Beta = "\u0392";
    var beta = "\u03B2";
    var beth = "\u2136";
    var between = "\u226C";
    var Bfr = "\uD835\uDD05";
    var bfr = "\uD835\uDD1F";
    var bigcap = "\u22C2";
    var bigcirc = "\u25EF";
    var bigcup = "\u22C3";
    var bigodot = "\u2A00";
    var bigoplus = "\u2A01";
    var bigotimes = "\u2A02";
    var bigsqcup = "\u2A06";
    var bigstar = "\u2605";
    var bigtriangledown = "\u25BD";
    var bigtriangleup = "\u25B3";
    var biguplus = "\u2A04";
    var bigvee = "\u22C1";
    var bigwedge = "\u22C0";
    var bkarow = "\u290D";
    var blacklozenge = "\u29EB";
    var blacksquare = "\u25AA";
    var blacktriangle = "\u25B4";
    var blacktriangledown = "\u25BE";
    var blacktriangleleft = "\u25C2";
    var blacktriangleright = "\u25B8";
    var blank = "\u2423";
    var blk12 = "\u2592";
    var blk14 = "\u2591";
    var blk34 = "\u2593";
    var block = "\u2588";
    var bne = "=\u20E5";
    var bnequiv = "\u2261\u20E5";
    var bNot = "\u2AED";
    var bnot = "\u2310";
    var Bopf = "\uD835\uDD39";
    var bopf = "\uD835\uDD53";
    var bot = "\u22A5";
    var bottom = "\u22A5";
    var bowtie = "\u22C8";
    var boxbox = "\u29C9";
    var boxdl = "\u2510";
    var boxdL = "\u2555";
    var boxDl = "\u2556";
    var boxDL = "\u2557";
    var boxdr = "\u250C";
    var boxdR = "\u2552";
    var boxDr = "\u2553";
    var boxDR = "\u2554";
    var boxh = "\u2500";
    var boxH = "\u2550";
    var boxhd = "\u252C";
    var boxHd = "\u2564";
    var boxhD = "\u2565";
    var boxHD = "\u2566";
    var boxhu = "\u2534";
    var boxHu = "\u2567";
    var boxhU = "\u2568";
    var boxHU = "\u2569";
    var boxminus = "\u229F";
    var boxplus = "\u229E";
    var boxtimes = "\u22A0";
    var boxul = "\u2518";
    var boxuL = "\u255B";
    var boxUl = "\u255C";
    var boxUL = "\u255D";
    var boxur = "\u2514";
    var boxuR = "\u2558";
    var boxUr = "\u2559";
    var boxUR = "\u255A";
    var boxv = "\u2502";
    var boxV = "\u2551";
    var boxvh = "\u253C";
    var boxvH = "\u256A";
    var boxVh = "\u256B";
    var boxVH = "\u256C";
    var boxvl = "\u2524";
    var boxvL = "\u2561";
    var boxVl = "\u2562";
    var boxVL = "\u2563";
    var boxvr = "\u251C";
    var boxvR = "\u255E";
    var boxVr = "\u255F";
    var boxVR = "\u2560";
    var bprime = "\u2035";
    var breve = "\u02D8";
    var Breve = "\u02D8";
    var brvbar = "\xa6";
    var bscr = "\uD835\uDCB7";
    var Bscr = "\u212C";
    var bsemi = "\u204F";
    var bsim = "\u223D";
    var bsime = "\u22CD";
    var bsolb = "\u29C5";
    var bsol = "\\";
    var bsolhsub = "\u27C8";
    var bull = "\u2022";
    var bullet = "\u2022";
    var bump = "\u224E";
    var bumpE = "\u2AAE";
    var bumpe = "\u224F";
    var Bumpeq = "\u224E";
    var bumpeq = "\u224F";
    var Cacute = "\u0106";
    var cacute = "\u0107";
    var capand = "\u2A44";
    var capbrcup = "\u2A49";
    var capcap = "\u2A4B";
    var cap = "\u2229";
    var Cap = "\u22D2";
    var capcup = "\u2A47";
    var capdot = "\u2A40";
    var CapitalDifferentialD = "\u2145";
    var caps = "\u2229\uFE00";
    var caret = "\u2041";
    var caron = "\u02C7";
    var Cayleys = "\u212D";
    var ccaps = "\u2A4D";
    var Ccaron = "\u010C";
    var ccaron = "\u010D";
    var Ccedil = "\xc7";
    var ccedil = "\xe7";
    var Ccirc = "\u0108";
    var ccirc = "\u0109";
    var Cconint = "\u2230";
    var ccups = "\u2A4C";
    var ccupssm = "\u2A50";
    var Cdot = "\u010A";
    var cdot = "\u010B";
    var cedil = "\xb8";
    var Cedilla = "\xb8";
    var cemptyv = "\u29B2";
    var cent = "\xa2";
    var centerdot = "\xb7";
    var CenterDot = "\xb7";
    var cfr = "\uD835\uDD20";
    var Cfr = "\u212D";
    var CHcy = "\u0427";
    var chcy = "\u0447";
    var check = "\u2713";
    var checkmark = "\u2713";
    var Chi = "\u03A7";
    var chi = "\u03C7";
    var circ = "\u02C6";
    var circeq = "\u2257";
    var circlearrowleft = "\u21BA";
    var circlearrowright = "\u21BB";
    var circledast = "\u229B";
    var circledcirc = "\u229A";
    var circleddash = "\u229D";
    var CircleDot = "\u2299";
    var circledR = "\xae";
    var circledS = "\u24C8";
    var CircleMinus = "\u2296";
    var CirclePlus = "\u2295";
    var CircleTimes = "\u2297";
    var cir = "\u25CB";
    var cirE = "\u29C3";
    var cire = "\u2257";
    var cirfnint = "\u2A10";
    var cirmid = "\u2AEF";
    var cirscir = "\u29C2";
    var ClockwiseContourIntegral = "\u2232";
    var CloseCurlyDoubleQuote = "\u201D";
    var CloseCurlyQuote = "\u2019";
    var clubs = "\u2663";
    var clubsuit = "\u2663";
    var colon = ":";
    var Colon = "\u2237";
    var Colone = "\u2A74";
    var colone = "\u2254";
    var coloneq = "\u2254";
    var comma = ",";
    var commat = "@";
    var comp = "\u2201";
    var compfn = "\u2218";
    var complement = "\u2201";
    var complexes = "\u2102";
    var cong = "\u2245";
    var congdot = "\u2A6D";
    var Congruent = "\u2261";
    var conint = "\u222E";
    var Conint = "\u222F";
    var ContourIntegral = "\u222E";
    var copf = "\uD835\uDD54";
    var Copf = "\u2102";
    var coprod = "\u2210";
    var Coproduct = "\u2210";
    var copy = "\xa9";
    var COPY = "\xa9";
    var copysr = "\u2117";
    var CounterClockwiseContourIntegral = "\u2233";
    var crarr = "\u21B5";
    var cross = "\u2717";
    var Cross = "\u2A2F";
    var Cscr = "\uD835\uDC9E";
    var cscr = "\uD835\uDCB8";
    var csub = "\u2ACF";
    var csube = "\u2AD1";
    var csup = "\u2AD0";
    var csupe = "\u2AD2";
    var ctdot = "\u22EF";
    var cudarrl = "\u2938";
    var cudarrr = "\u2935";
    var cuepr = "\u22DE";
    var cuesc = "\u22DF";
    var cularr = "\u21B6";
    var cularrp = "\u293D";
    var cupbrcap = "\u2A48";
    var cupcap = "\u2A46";
    var CupCap = "\u224D";
    var cup = "\u222A";
    var Cup = "\u22D3";
    var cupcup = "\u2A4A";
    var cupdot = "\u228D";
    var cupor = "\u2A45";
    var cups = "\u222A\uFE00";
    var curarr = "\u21B7";
    var curarrm = "\u293C";
    var curlyeqprec = "\u22DE";
    var curlyeqsucc = "\u22DF";
    var curlyvee = "\u22CE";
    var curlywedge = "\u22CF";
    var curren = "\xa4";
    var curvearrowleft = "\u21B6";
    var curvearrowright = "\u21B7";
    var cuvee = "\u22CE";
    var cuwed = "\u22CF";
    var cwconint = "\u2232";
    var cwint = "\u2231";
    var cylcty = "\u232D";
    var dagger = "\u2020";
    var Dagger = "\u2021";
    var daleth = "\u2138";
    var darr = "\u2193";
    var Darr = "\u21A1";
    var dArr = "\u21D3";
    var dash = "\u2010";
    var Dashv = "\u2AE4";
    var dashv = "\u22A3";
    var dbkarow = "\u290F";
    var dblac = "\u02DD";
    var Dcaron = "\u010E";
    var dcaron = "\u010F";
    var Dcy = "\u0414";
    var dcy = "\u0434";
    var ddagger = "\u2021";
    var ddarr = "\u21CA";
    var DD = "\u2145";
    var dd = "\u2146";
    var DDotrahd = "\u2911";
    var ddotseq = "\u2A77";
    var deg = "\xb0";
    var Del = "\u2207";
    var Delta = "\u0394";
    var delta = "\u03B4";
    var demptyv = "\u29B1";
    var dfisht = "\u297F";
    var Dfr = "\uD835\uDD07";
    var dfr = "\uD835\uDD21";
    var dHar = "\u2965";
    var dharl = "\u21C3";
    var dharr = "\u21C2";
    var DiacriticalAcute = "\xb4";
    var DiacriticalDot = "\u02D9";
    var DiacriticalDoubleAcute = "\u02DD";
    var DiacriticalGrave = "`";
    var DiacriticalTilde = "\u02DC";
    var diam = "\u22C4";
    var diamond = "\u22C4";
    var Diamond = "\u22C4";
    var diamondsuit = "\u2666";
    var diams = "\u2666";
    var die = "\xa8";
    var DifferentialD = "\u2146";
    var digamma = "\u03DD";
    var disin = "\u22F2";
    var div = "\xf7";
    var divide = "\xf7";
    var divideontimes = "\u22C7";
    var divonx = "\u22C7";
    var DJcy = "\u0402";
    var djcy = "\u0452";
    var dlcorn = "\u231E";
    var dlcrop = "\u230D";
    var dollar = "$";
    var Dopf = "\uD835\uDD3B";
    var dopf = "\uD835\uDD55";
    var Dot = "\xa8";
    var dot = "\u02D9";
    var DotDot = "\u20DC";
    var doteq = "\u2250";
    var doteqdot = "\u2251";
    var DotEqual = "\u2250";
    var dotminus = "\u2238";
    var dotplus = "\u2214";
    var dotsquare = "\u22A1";
    var doublebarwedge = "\u2306";
    var DoubleContourIntegral = "\u222F";
    var DoubleDot = "\xa8";
    var DoubleDownArrow = "\u21D3";
    var DoubleLeftArrow = "\u21D0";
    var DoubleLeftRightArrow = "\u21D4";
    var DoubleLeftTee = "\u2AE4";
    var DoubleLongLeftArrow = "\u27F8";
    var DoubleLongLeftRightArrow = "\u27FA";
    var DoubleLongRightArrow = "\u27F9";
    var DoubleRightArrow = "\u21D2";
    var DoubleRightTee = "\u22A8";
    var DoubleUpArrow = "\u21D1";
    var DoubleUpDownArrow = "\u21D5";
    var DoubleVerticalBar = "\u2225";
    var DownArrowBar = "\u2913";
    var downarrow = "\u2193";
    var DownArrow = "\u2193";
    var Downarrow = "\u21D3";
    var DownArrowUpArrow = "\u21F5";
    var DownBreve = "\u0311";
    var downdownarrows = "\u21CA";
    var downharpoonleft = "\u21C3";
    var downharpoonright = "\u21C2";
    var DownLeftRightVector = "\u2950";
    var DownLeftTeeVector = "\u295E";
    var DownLeftVectorBar = "\u2956";
    var DownLeftVector = "\u21BD";
    var DownRightTeeVector = "\u295F";
    var DownRightVectorBar = "\u2957";
    var DownRightVector = "\u21C1";
    var DownTeeArrow = "\u21A7";
    var DownTee = "\u22A4";
    var drbkarow = "\u2910";
    var drcorn = "\u231F";
    var drcrop = "\u230C";
    var Dscr = "\uD835\uDC9F";
    var dscr = "\uD835\uDCB9";
    var DScy = "\u0405";
    var dscy = "\u0455";
    var dsol = "\u29F6";
    var Dstrok = "\u0110";
    var dstrok = "\u0111";
    var dtdot = "\u22F1";
    var dtri = "\u25BF";
    var dtrif = "\u25BE";
    var duarr = "\u21F5";
    var duhar = "\u296F";
    var dwangle = "\u29A6";
    var DZcy = "\u040F";
    var dzcy = "\u045F";
    var dzigrarr = "\u27FF";
    var Eacute = "\xc9";
    var eacute = "\xe9";
    var easter = "\u2A6E";
    var Ecaron = "\u011A";
    var ecaron = "\u011B";
    var Ecirc = "\xca";
    var ecirc = "\xea";
    var ecir = "\u2256";
    var ecolon = "\u2255";
    var Ecy = "\u042D";
    var ecy = "\u044D";
    var eDDot = "\u2A77";
    var Edot = "\u0116";
    var edot = "\u0117";
    var eDot = "\u2251";
    var ee = "\u2147";
    var efDot = "\u2252";
    var Efr = "\uD835\uDD08";
    var efr = "\uD835\uDD22";
    var eg = "\u2A9A";
    var Egrave = "\xc8";
    var egrave = "\xe8";
    var egs = "\u2A96";
    var egsdot = "\u2A98";
    var el = "\u2A99";
    var Element = "\u2208";
    var elinters = "\u23E7";
    var ell = "\u2113";
    var els = "\u2A95";
    var elsdot = "\u2A97";
    var Emacr = "\u0112";
    var emacr = "\u0113";
    var empty = "\u2205";
    var emptyset = "\u2205";
    var EmptySmallSquare = "\u25FB";
    var emptyv = "\u2205";
    var EmptyVerySmallSquare = "\u25AB";
    var emsp13 = "\u2004";
    var emsp14 = "\u2005";
    var emsp = "\u2003";
    var ENG = "\u014A";
    var eng = "\u014B";
    var ensp = "\u2002";
    var Eogon = "\u0118";
    var eogon = "\u0119";
    var Eopf = "\uD835\uDD3C";
    var eopf = "\uD835\uDD56";
    var epar = "\u22D5";
    var eparsl = "\u29E3";
    var eplus = "\u2A71";
    var epsi = "\u03B5";
    var Epsilon = "\u0395";
    var epsilon = "\u03B5";
    var epsiv = "\u03F5";
    var eqcirc = "\u2256";
    var eqcolon = "\u2255";
    var eqsim = "\u2242";
    var eqslantgtr = "\u2A96";
    var eqslantless = "\u2A95";
    var Equal = "\u2A75";
    var equals = "=";
    var EqualTilde = "\u2242";
    var equest = "\u225F";
    var Equilibrium = "\u21CC";
    var equiv = "\u2261";
    var equivDD = "\u2A78";
    var eqvparsl = "\u29E5";
    var erarr = "\u2971";
    var erDot = "\u2253";
    var escr = "\u212F";
    var Escr = "\u2130";
    var esdot = "\u2250";
    var Esim = "\u2A73";
    var esim = "\u2242";
    var Eta = "\u0397";
    var eta = "\u03B7";
    var ETH = "\xd0";
    var eth = "\xf0";
    var Euml = "\xcb";
    var euml = "\xeb";
    var euro = "\u20AC";
    var excl = "!";
    var exist = "\u2203";
    var Exists = "\u2203";
    var expectation = "\u2130";
    var exponentiale = "\u2147";
    var ExponentialE = "\u2147";
    var fallingdotseq = "\u2252";
    var Fcy = "\u0424";
    var fcy = "\u0444";
    var female = "\u2640";
    var ffilig = "\uFB03";
    var fflig = "\uFB00";
    var ffllig = "\uFB04";
    var Ffr = "\uD835\uDD09";
    var ffr = "\uD835\uDD23";
    var filig = "\uFB01";
    var FilledSmallSquare = "\u25FC";
    var FilledVerySmallSquare = "\u25AA";
    var fjlig = "fj";
    var flat = "\u266D";
    var fllig = "\uFB02";
    var fltns = "\u25B1";
    var fnof = "\u0192";
    var Fopf = "\uD835\uDD3D";
    var fopf = "\uD835\uDD57";
    var forall = "\u2200";
    var ForAll = "\u2200";
    var fork = "\u22D4";
    var forkv = "\u2AD9";
    var Fouriertrf = "\u2131";
    var fpartint = "\u2A0D";
    var frac12 = "\xbd";
    var frac13 = "\u2153";
    var frac14 = "\xbc";
    var frac15 = "\u2155";
    var frac16 = "\u2159";
    var frac18 = "\u215B";
    var frac23 = "\u2154";
    var frac25 = "\u2156";
    var frac34 = "\xbe";
    var frac35 = "\u2157";
    var frac38 = "\u215C";
    var frac45 = "\u2158";
    var frac56 = "\u215A";
    var frac58 = "\u215D";
    var frac78 = "\u215E";
    var frasl = "\u2044";
    var frown = "\u2322";
    var fscr = "\uD835\uDCBB";
    var Fscr = "\u2131";
    var gacute = "\u01F5";
    var Gamma = "\u0393";
    var gamma = "\u03B3";
    var Gammad = "\u03DC";
    var gammad = "\u03DD";
    var gap = "\u2A86";
    var Gbreve = "\u011E";
    var gbreve = "\u011F";
    var Gcedil = "\u0122";
    var Gcirc = "\u011C";
    var gcirc = "\u011D";
    var Gcy = "\u0413";
    var gcy = "\u0433";
    var Gdot = "\u0120";
    var gdot = "\u0121";
    var ge = "\u2265";
    var gE = "\u2267";
    var gEl = "\u2A8C";
    var gel = "\u22DB";
    var geq = "\u2265";
    var geqq = "\u2267";
    var geqslant = "\u2A7E";
    var gescc = "\u2AA9";
    var ges = "\u2A7E";
    var gesdot = "\u2A80";
    var gesdoto = "\u2A82";
    var gesdotol = "\u2A84";
    var gesl = "\u22DB\uFE00";
    var gesles = "\u2A94";
    var Gfr = "\uD835\uDD0A";
    var gfr = "\uD835\uDD24";
    var gg = "\u226B";
    var Gg = "\u22D9";
    var ggg = "\u22D9";
    var gimel = "\u2137";
    var GJcy = "\u0403";
    var gjcy = "\u0453";
    var gla = "\u2AA5";
    var gl = "\u2277";
    var glE = "\u2A92";
    var glj = "\u2AA4";
    var gnap = "\u2A8A";
    var gnapprox = "\u2A8A";
    var gne = "\u2A88";
    var gnE = "\u2269";
    var gneq = "\u2A88";
    var gneqq = "\u2269";
    var gnsim = "\u22E7";
    var Gopf = "\uD835\uDD3E";
    var gopf = "\uD835\uDD58";
    var grave = "`";
    var GreaterEqual = "\u2265";
    var GreaterEqualLess = "\u22DB";
    var GreaterFullEqual = "\u2267";
    var GreaterGreater = "\u2AA2";
    var GreaterLess = "\u2277";
    var GreaterSlantEqual = "\u2A7E";
    var GreaterTilde = "\u2273";
    var Gscr = "\uD835\uDCA2";
    var gscr = "\u210A";
    var gsim = "\u2273";
    var gsime = "\u2A8E";
    var gsiml = "\u2A90";
    var gtcc = "\u2AA7";
    var gtcir = "\u2A7A";
    var gt = ">";
    var GT = ">";
    var Gt = "\u226B";
    var gtdot = "\u22D7";
    var gtlPar = "\u2995";
    var gtquest = "\u2A7C";
    var gtrapprox = "\u2A86";
    var gtrarr = "\u2978";
    var gtrdot = "\u22D7";
    var gtreqless = "\u22DB";
    var gtreqqless = "\u2A8C";
    var gtrless = "\u2277";
    var gtrsim = "\u2273";
    var gvertneqq = "\u2269\uFE00";
    var gvnE = "\u2269\uFE00";
    var Hacek = "\u02C7";
    var hairsp = "\u200A";
    var half = "\xbd";
    var hamilt = "\u210B";
    var HARDcy = "\u042A";
    var hardcy = "\u044A";
    var harrcir = "\u2948";
    var harr = "\u2194";
    var hArr = "\u21D4";
    var harrw = "\u21AD";
    var Hat = "^";
    var hbar = "\u210F";
    var Hcirc = "\u0124";
    var hcirc = "\u0125";
    var hearts = "\u2665";
    var heartsuit = "\u2665";
    var hellip = "\u2026";
    var hercon = "\u22B9";
    var hfr = "\uD835\uDD25";
    var Hfr = "\u210C";
    var HilbertSpace = "\u210B";
    var hksearow = "\u2925";
    var hkswarow = "\u2926";
    var hoarr = "\u21FF";
    var homtht = "\u223B";
    var hookleftarrow = "\u21A9";
    var hookrightarrow = "\u21AA";
    var hopf = "\uD835\uDD59";
    var Hopf = "\u210D";
    var horbar = "\u2015";
    var HorizontalLine = "\u2500";
    var hscr = "\uD835\uDCBD";
    var Hscr = "\u210B";
    var hslash = "\u210F";
    var Hstrok = "\u0126";
    var hstrok = "\u0127";
    var HumpDownHump = "\u224E";
    var HumpEqual = "\u224F";
    var hybull = "\u2043";
    var hyphen = "\u2010";
    var Iacute = "\xcd";
    var iacute = "\xed";
    var ic = "\u2063";
    var Icirc = "\xce";
    var icirc = "\xee";
    var Icy = "\u0418";
    var icy = "\u0438";
    var Idot = "\u0130";
    var IEcy = "\u0415";
    var iecy = "\u0435";
    var iexcl = "\xa1";
    var iff = "\u21D4";
    var ifr = "\uD835\uDD26";
    var Ifr = "\u2111";
    var Igrave = "\xcc";
    var igrave = "\xec";
    var ii = "\u2148";
    var iiiint = "\u2A0C";
    var iiint = "\u222D";
    var iinfin = "\u29DC";
    var iiota = "\u2129";
    var IJlig = "\u0132";
    var ijlig = "\u0133";
    var Imacr = "\u012A";
    var imacr = "\u012B";
    var image = "\u2111";
    var ImaginaryI = "\u2148";
    var imagline = "\u2110";
    var imagpart = "\u2111";
    var imath = "\u0131";
    var Im = "\u2111";
    var imof = "\u22B7";
    var imped = "\u01B5";
    var Implies = "\u21D2";
    var incare = "\u2105";
    var infin = "\u221E";
    var infintie = "\u29DD";
    var inodot = "\u0131";
    var intcal = "\u22BA";
    var int = "\u222B";
    var Int = "\u222C";
    var integers = "\u2124";
    var Integral = "\u222B";
    var intercal = "\u22BA";
    var Intersection = "\u22C2";
    var intlarhk = "\u2A17";
    var intprod = "\u2A3C";
    var InvisibleComma = "\u2063";
    var InvisibleTimes = "\u2062";
    var IOcy = "\u0401";
    var iocy = "\u0451";
    var Iogon = "\u012E";
    var iogon = "\u012F";
    var Iopf = "\uD835\uDD40";
    var iopf = "\uD835\uDD5A";
    var Iota = "\u0399";
    var iota = "\u03B9";
    var iprod = "\u2A3C";
    var iquest = "\xbf";
    var iscr = "\uD835\uDCBE";
    var Iscr = "\u2110";
    var isin = "\u2208";
    var isindot = "\u22F5";
    var isinE = "\u22F9";
    var isins = "\u22F4";
    var isinsv = "\u22F3";
    var isinv = "\u2208";
    var it = "\u2062";
    var Itilde = "\u0128";
    var itilde = "\u0129";
    var Iukcy = "\u0406";
    var iukcy = "\u0456";
    var Iuml = "\xcf";
    var iuml = "\xef";
    var Jcirc = "\u0134";
    var jcirc = "\u0135";
    var Jcy = "\u0419";
    var jcy = "\u0439";
    var Jfr = "\uD835\uDD0D";
    var jfr = "\uD835\uDD27";
    var jmath = "\u0237";
    var Jopf = "\uD835\uDD41";
    var jopf = "\uD835\uDD5B";
    var Jscr = "\uD835\uDCA5";
    var jscr = "\uD835\uDCBF";
    var Jsercy = "\u0408";
    var jsercy = "\u0458";
    var Jukcy = "\u0404";
    var jukcy = "\u0454";
    var Kappa = "\u039A";
    var kappa = "\u03BA";
    var kappav = "\u03F0";
    var Kcedil = "\u0136";
    var kcedil = "\u0137";
    var Kcy = "\u041A";
    var kcy = "\u043A";
    var Kfr = "\uD835\uDD0E";
    var kfr = "\uD835\uDD28";
    var kgreen = "\u0138";
    var KHcy = "\u0425";
    var khcy = "\u0445";
    var KJcy = "\u040C";
    var kjcy = "\u045C";
    var Kopf = "\uD835\uDD42";
    var kopf = "\uD835\uDD5C";
    var Kscr = "\uD835\uDCA6";
    var kscr = "\uD835\uDCC0";
    var lAarr = "\u21DA";
    var Lacute = "\u0139";
    var lacute = "\u013A";
    var laemptyv = "\u29B4";
    var lagran = "\u2112";
    var Lambda = "\u039B";
    var lambda = "\u03BB";
    var lang = "\u27E8";
    var Lang = "\u27EA";
    var langd = "\u2991";
    var langle = "\u27E8";
    var lap = "\u2A85";
    var Laplacetrf = "\u2112";
    var laquo = "\xab";
    var larrb = "\u21E4";
    var larrbfs = "\u291F";
    var larr = "\u2190";
    var Larr = "\u219E";
    var lArr = "\u21D0";
    var larrfs = "\u291D";
    var larrhk = "\u21A9";
    var larrlp = "\u21AB";
    var larrpl = "\u2939";
    var larrsim = "\u2973";
    var larrtl = "\u21A2";
    var latail = "\u2919";
    var lAtail = "\u291B";
    var lat = "\u2AAB";
    var late = "\u2AAD";
    var lates = "\u2AAD\uFE00";
    var lbarr = "\u290C";
    var lBarr = "\u290E";
    var lbbrk = "\u2772";
    var lbrace = "{";
    var lbrack = "[";
    var lbrke = "\u298B";
    var lbrksld = "\u298F";
    var lbrkslu = "\u298D";
    var Lcaron = "\u013D";
    var lcaron = "\u013E";
    var Lcedil = "\u013B";
    var lcedil = "\u013C";
    var lceil = "\u2308";
    var lcub = "{";
    var Lcy = "\u041B";
    var lcy = "\u043B";
    var ldca = "\u2936";
    var ldquo = "\u201C";
    var ldquor = "\u201E";
    var ldrdhar = "\u2967";
    var ldrushar = "\u294B";
    var ldsh = "\u21B2";
    var le = "\u2264";
    var lE = "\u2266";
    var LeftAngleBracket = "\u27E8";
    var LeftArrowBar = "\u21E4";
    var leftarrow = "\u2190";
    var LeftArrow = "\u2190";
    var Leftarrow = "\u21D0";
    var LeftArrowRightArrow = "\u21C6";
    var leftarrowtail = "\u21A2";
    var LeftCeiling = "\u2308";
    var LeftDoubleBracket = "\u27E6";
    var LeftDownTeeVector = "\u2961";
    var LeftDownVectorBar = "\u2959";
    var LeftDownVector = "\u21C3";
    var LeftFloor = "\u230A";
    var leftharpoondown = "\u21BD";
    var leftharpoonup = "\u21BC";
    var leftleftarrows = "\u21C7";
    var leftrightarrow = "\u2194";
    var LeftRightArrow = "\u2194";
    var Leftrightarrow = "\u21D4";
    var leftrightarrows = "\u21C6";
    var leftrightharpoons = "\u21CB";
    var leftrightsquigarrow = "\u21AD";
    var LeftRightVector = "\u294E";
    var LeftTeeArrow = "\u21A4";
    var LeftTee = "\u22A3";
    var LeftTeeVector = "\u295A";
    var leftthreetimes = "\u22CB";
    var LeftTriangleBar = "\u29CF";
    var LeftTriangle = "\u22B2";
    var LeftTriangleEqual = "\u22B4";
    var LeftUpDownVector = "\u2951";
    var LeftUpTeeVector = "\u2960";
    var LeftUpVectorBar = "\u2958";
    var LeftUpVector = "\u21BF";
    var LeftVectorBar = "\u2952";
    var LeftVector = "\u21BC";
    var lEg = "\u2A8B";
    var leg = "\u22DA";
    var leq = "\u2264";
    var leqq = "\u2266";
    var leqslant = "\u2A7D";
    var lescc = "\u2AA8";
    var les = "\u2A7D";
    var lesdot = "\u2A7F";
    var lesdoto = "\u2A81";
    var lesdotor = "\u2A83";
    var lesg = "\u22DA\uFE00";
    var lesges = "\u2A93";
    var lessapprox = "\u2A85";
    var lessdot = "\u22D6";
    var lesseqgtr = "\u22DA";
    var lesseqqgtr = "\u2A8B";
    var LessEqualGreater = "\u22DA";
    var LessFullEqual = "\u2266";
    var LessGreater = "\u2276";
    var lessgtr = "\u2276";
    var LessLess = "\u2AA1";
    var lesssim = "\u2272";
    var LessSlantEqual = "\u2A7D";
    var LessTilde = "\u2272";
    var lfisht = "\u297C";
    var lfloor = "\u230A";
    var Lfr = "\uD835\uDD0F";
    var lfr = "\uD835\uDD29";
    var lg = "\u2276";
    var lgE = "\u2A91";
    var lHar = "\u2962";
    var lhard = "\u21BD";
    var lharu = "\u21BC";
    var lharul = "\u296A";
    var lhblk = "\u2584";
    var LJcy = "\u0409";
    var ljcy = "\u0459";
    var llarr = "\u21C7";
    var ll = "\u226A";
    var Ll = "\u22D8";
    var llcorner = "\u231E";
    var Lleftarrow = "\u21DA";
    var llhard = "\u296B";
    var lltri = "\u25FA";
    var Lmidot = "\u013F";
    var lmidot = "\u0140";
    var lmoustache = "\u23B0";
    var lmoust = "\u23B0";
    var lnap = "\u2A89";
    var lnapprox = "\u2A89";
    var lne = "\u2A87";
    var lnE = "\u2268";
    var lneq = "\u2A87";
    var lneqq = "\u2268";
    var lnsim = "\u22E6";
    var loang = "\u27EC";
    var loarr = "\u21FD";
    var lobrk = "\u27E6";
    var longleftarrow = "\u27F5";
    var LongLeftArrow = "\u27F5";
    var Longleftarrow = "\u27F8";
    var longleftrightarrow = "\u27F7";
    var LongLeftRightArrow = "\u27F7";
    var Longleftrightarrow = "\u27FA";
    var longmapsto = "\u27FC";
    var longrightarrow = "\u27F6";
    var LongRightArrow = "\u27F6";
    var Longrightarrow = "\u27F9";
    var looparrowleft = "\u21AB";
    var looparrowright = "\u21AC";
    var lopar = "\u2985";
    var Lopf = "\uD835\uDD43";
    var lopf = "\uD835\uDD5D";
    var loplus = "\u2A2D";
    var lotimes = "\u2A34";
    var lowast = "\u2217";
    var lowbar = "_";
    var LowerLeftArrow = "\u2199";
    var LowerRightArrow = "\u2198";
    var loz = "\u25CA";
    var lozenge = "\u25CA";
    var lozf = "\u29EB";
    var lpar = "(";
    var lparlt = "\u2993";
    var lrarr = "\u21C6";
    var lrcorner = "\u231F";
    var lrhar = "\u21CB";
    var lrhard = "\u296D";
    var lrm = "\u200E";
    var lrtri = "\u22BF";
    var lsaquo = "\u2039";
    var lscr = "\uD835\uDCC1";
    var Lscr = "\u2112";
    var lsh = "\u21B0";
    var Lsh = "\u21B0";
    var lsim = "\u2272";
    var lsime = "\u2A8D";
    var lsimg = "\u2A8F";
    var lsqb = "[";
    var lsquo = "\u2018";
    var lsquor = "\u201A";
    var Lstrok = "\u0141";
    var lstrok = "\u0142";
    var ltcc = "\u2AA6";
    var ltcir = "\u2A79";
    var lt = "<";
    var LT = "<";
    var Lt = "\u226A";
    var ltdot = "\u22D6";
    var lthree = "\u22CB";
    var ltimes = "\u22C9";
    var ltlarr = "\u2976";
    var ltquest = "\u2A7B";
    var ltri = "\u25C3";
    var ltrie = "\u22B4";
    var ltrif = "\u25C2";
    var ltrPar = "\u2996";
    var lurdshar = "\u294A";
    var luruhar = "\u2966";
    var lvertneqq = "\u2268\uFE00";
    var lvnE = "\u2268\uFE00";
    var macr = "\xaf";
    var male = "\u2642";
    var malt = "\u2720";
    var maltese = "\u2720";
    var map = "\u21A6";
    var mapsto = "\u21A6";
    var mapstodown = "\u21A7";
    var mapstoleft = "\u21A4";
    var mapstoup = "\u21A5";
    var marker = "\u25AE";
    var mcomma = "\u2A29";
    var Mcy = "\u041C";
    var mcy = "\u043C";
    var mdash = "\u2014";
    var mDDot = "\u223A";
    var measuredangle = "\u2221";
    var MediumSpace = "\u205F";
    var Mellintrf = "\u2133";
    var Mfr = "\uD835\uDD10";
    var mfr = "\uD835\uDD2A";
    var mho = "\u2127";
    var micro = "\xb5";
    var midast = "*";
    var midcir = "\u2AF0";
    var mid = "\u2223";
    var middot = "\xb7";
    var minusb = "\u229F";
    var minus = "\u2212";
    var minusd = "\u2238";
    var minusdu = "\u2A2A";
    var MinusPlus = "\u2213";
    var mlcp = "\u2ADB";
    var mldr = "\u2026";
    var mnplus = "\u2213";
    var models = "\u22A7";
    var Mopf = "\uD835\uDD44";
    var mopf = "\uD835\uDD5E";
    var mp = "\u2213";
    var mscr = "\uD835\uDCC2";
    var Mscr = "\u2133";
    var mstpos = "\u223E";
    var Mu = "\u039C";
    var mu = "\u03BC";
    var multimap = "\u22B8";
    var mumap = "\u22B8";
    var nabla = "\u2207";
    var Nacute = "\u0143";
    var nacute = "\u0144";
    var nang = "\u2220\u20D2";
    var nap = "\u2249";
    var napE = "\u2A70\u0338";
    var napid = "\u224B\u0338";
    var napos = "\u0149";
    var napprox = "\u2249";
    var natural = "\u266E";
    var naturals = "\u2115";
    var natur = "\u266E";
    var nbsp = "\xa0";
    var nbump = "\u224E\u0338";
    var nbumpe = "\u224F\u0338";
    var ncap = "\u2A43";
    var Ncaron = "\u0147";
    var ncaron = "\u0148";
    var Ncedil = "\u0145";
    var ncedil = "\u0146";
    var ncong = "\u2247";
    var ncongdot = "\u2A6D\u0338";
    var ncup = "\u2A42";
    var Ncy = "\u041D";
    var ncy = "\u043D";
    var ndash = "\u2013";
    var nearhk = "\u2924";
    var nearr = "\u2197";
    var neArr = "\u21D7";
    var nearrow = "\u2197";
    var ne = "\u2260";
    var nedot = "\u2250\u0338";
    var NegativeMediumSpace = "\u200B";
    var NegativeThickSpace = "\u200B";
    var NegativeThinSpace = "\u200B";
    var NegativeVeryThinSpace = "\u200B";
    var nequiv = "\u2262";
    var nesear = "\u2928";
    var nesim = "\u2242\u0338";
    var NestedGreaterGreater = "\u226B";
    var NestedLessLess = "\u226A";
    var NewLine = "\n";
    var nexist = "\u2204";
    var nexists = "\u2204";
    var Nfr = "\uD835\uDD11";
    var nfr = "\uD835\uDD2B";
    var ngE = "\u2267\u0338";
    var nge = "\u2271";
    var ngeq = "\u2271";
    var ngeqq = "\u2267\u0338";
    var ngeqslant = "\u2A7E\u0338";
    var nges = "\u2A7E\u0338";
    var nGg = "\u22D9\u0338";
    var ngsim = "\u2275";
    var nGt = "\u226B\u20D2";
    var ngt = "\u226F";
    var ngtr = "\u226F";
    var nGtv = "\u226B\u0338";
    var nharr = "\u21AE";
    var nhArr = "\u21CE";
    var nhpar = "\u2AF2";
    var ni = "\u220B";
    var nis = "\u22FC";
    var nisd = "\u22FA";
    var niv = "\u220B";
    var NJcy = "\u040A";
    var njcy = "\u045A";
    var nlarr = "\u219A";
    var nlArr = "\u21CD";
    var nldr = "\u2025";
    var nlE = "\u2266\u0338";
    var nle = "\u2270";
    var nleftarrow = "\u219A";
    var nLeftarrow = "\u21CD";
    var nleftrightarrow = "\u21AE";
    var nLeftrightarrow = "\u21CE";
    var nleq = "\u2270";
    var nleqq = "\u2266\u0338";
    var nleqslant = "\u2A7D\u0338";
    var nles = "\u2A7D\u0338";
    var nless = "\u226E";
    var nLl = "\u22D8\u0338";
    var nlsim = "\u2274";
    var nLt = "\u226A\u20D2";
    var nlt = "\u226E";
    var nltri = "\u22EA";
    var nltrie = "\u22EC";
    var nLtv = "\u226A\u0338";
    var nmid = "\u2224";
    var NoBreak = "\u2060";
    var NonBreakingSpace = "\xa0";
    var nopf = "\uD835\uDD5F";
    var Nopf = "\u2115";
    var Not = "\u2AEC";
    var not = "\xac";
    var NotCongruent = "\u2262";
    var NotCupCap = "\u226D";
    var NotDoubleVerticalBar = "\u2226";
    var NotElement = "\u2209";
    var NotEqual = "\u2260";
    var NotEqualTilde = "\u2242\u0338";
    var NotExists = "\u2204";
    var NotGreater = "\u226F";
    var NotGreaterEqual = "\u2271";
    var NotGreaterFullEqual = "\u2267\u0338";
    var NotGreaterGreater = "\u226B\u0338";
    var NotGreaterLess = "\u2279";
    var NotGreaterSlantEqual = "\u2A7E\u0338";
    var NotGreaterTilde = "\u2275";
    var NotHumpDownHump = "\u224E\u0338";
    var NotHumpEqual = "\u224F\u0338";
    var notin = "\u2209";
    var notindot = "\u22F5\u0338";
    var notinE = "\u22F9\u0338";
    var notinva = "\u2209";
    var notinvb = "\u22F7";
    var notinvc = "\u22F6";
    var NotLeftTriangleBar = "\u29CF\u0338";
    var NotLeftTriangle = "\u22EA";
    var NotLeftTriangleEqual = "\u22EC";
    var NotLess = "\u226E";
    var NotLessEqual = "\u2270";
    var NotLessGreater = "\u2278";
    var NotLessLess = "\u226A\u0338";
    var NotLessSlantEqual = "\u2A7D\u0338";
    var NotLessTilde = "\u2274";
    var NotNestedGreaterGreater = "\u2AA2\u0338";
    var NotNestedLessLess = "\u2AA1\u0338";
    var notni = "\u220C";
    var notniva = "\u220C";
    var notnivb = "\u22FE";
    var notnivc = "\u22FD";
    var NotPrecedes = "\u2280";
    var NotPrecedesEqual = "\u2AAF\u0338";
    var NotPrecedesSlantEqual = "\u22E0";
    var NotReverseElement = "\u220C";
    var NotRightTriangleBar = "\u29D0\u0338";
    var NotRightTriangle = "\u22EB";
    var NotRightTriangleEqual = "\u22ED";
    var NotSquareSubset = "\u228F\u0338";
    var NotSquareSubsetEqual = "\u22E2";
    var NotSquareSuperset = "\u2290\u0338";
    var NotSquareSupersetEqual = "\u22E3";
    var NotSubset = "\u2282\u20D2";
    var NotSubsetEqual = "\u2288";
    var NotSucceeds = "\u2281";
    var NotSucceedsEqual = "\u2AB0\u0338";
    var NotSucceedsSlantEqual = "\u22E1";
    var NotSucceedsTilde = "\u227F\u0338";
    var NotSuperset = "\u2283\u20D2";
    var NotSupersetEqual = "\u2289";
    var NotTilde = "\u2241";
    var NotTildeEqual = "\u2244";
    var NotTildeFullEqual = "\u2247";
    var NotTildeTilde = "\u2249";
    var NotVerticalBar = "\u2224";
    var nparallel = "\u2226";
    var npar = "\u2226";
    var nparsl = "\u2AFD\u20E5";
    var npart = "\u2202\u0338";
    var npolint = "\u2A14";
    var npr = "\u2280";
    var nprcue = "\u22E0";
    var nprec = "\u2280";
    var npreceq = "\u2AAF\u0338";
    var npre = "\u2AAF\u0338";
    var nrarrc = "\u2933\u0338";
    var nrarr = "\u219B";
    var nrArr = "\u21CF";
    var nrarrw = "\u219D\u0338";
    var nrightarrow = "\u219B";
    var nRightarrow = "\u21CF";
    var nrtri = "\u22EB";
    var nrtrie = "\u22ED";
    var nsc = "\u2281";
    var nsccue = "\u22E1";
    var nsce = "\u2AB0\u0338";
    var Nscr = "\uD835\uDCA9";
    var nscr = "\uD835\uDCC3";
    var nshortmid = "\u2224";
    var nshortparallel = "\u2226";
    var nsim = "\u2241";
    var nsime = "\u2244";
    var nsimeq = "\u2244";
    var nsmid = "\u2224";
    var nspar = "\u2226";
    var nsqsube = "\u22E2";
    var nsqsupe = "\u22E3";
    var nsub = "\u2284";
    var nsubE = "\u2AC5\u0338";
    var nsube = "\u2288";
    var nsubset = "\u2282\u20D2";
    var nsubseteq = "\u2288";
    var nsubseteqq = "\u2AC5\u0338";
    var nsucc = "\u2281";
    var nsucceq = "\u2AB0\u0338";
    var nsup = "\u2285";
    var nsupE = "\u2AC6\u0338";
    var nsupe = "\u2289";
    var nsupset = "\u2283\u20D2";
    var nsupseteq = "\u2289";
    var nsupseteqq = "\u2AC6\u0338";
    var ntgl = "\u2279";
    var Ntilde = "\xd1";
    var ntilde = "\xf1";
    var ntlg = "\u2278";
    var ntriangleleft = "\u22EA";
    var ntrianglelefteq = "\u22EC";
    var ntriangleright = "\u22EB";
    var ntrianglerighteq = "\u22ED";
    var Nu = "\u039D";
    var nu = "\u03BD";
    var num = "#";
    var numero = "\u2116";
    var numsp = "\u2007";
    var nvap = "\u224D\u20D2";
    var nvdash = "\u22AC";
    var nvDash = "\u22AD";
    var nVdash = "\u22AE";
    var nVDash = "\u22AF";
    var nvge = "\u2265\u20D2";
    var nvgt = ">\u20D2";
    var nvHarr = "\u2904";
    var nvinfin = "\u29DE";
    var nvlArr = "\u2902";
    var nvle = "\u2264\u20D2";
    var nvlt = "<\u20D2";
    var nvltrie = "\u22B4\u20D2";
    var nvrArr = "\u2903";
    var nvrtrie = "\u22B5\u20D2";
    var nvsim = "\u223C\u20D2";
    var nwarhk = "\u2923";
    var nwarr = "\u2196";
    var nwArr = "\u21D6";
    var nwarrow = "\u2196";
    var nwnear = "\u2927";
    var Oacute = "\xd3";
    var oacute = "\xf3";
    var oast = "\u229B";
    var Ocirc = "\xd4";
    var ocirc = "\xf4";
    var ocir = "\u229A";
    var Ocy = "\u041E";
    var ocy = "\u043E";
    var odash = "\u229D";
    var Odblac = "\u0150";
    var odblac = "\u0151";
    var odiv = "\u2A38";
    var odot = "\u2299";
    var odsold = "\u29BC";
    var OElig = "\u0152";
    var oelig = "\u0153";
    var ofcir = "\u29BF";
    var Ofr = "\uD835\uDD12";
    var ofr = "\uD835\uDD2C";
    var ogon = "\u02DB";
    var Ograve = "\xd2";
    var ograve = "\xf2";
    var ogt = "\u29C1";
    var ohbar = "\u29B5";
    var ohm = "\u03A9";
    var oint = "\u222E";
    var olarr = "\u21BA";
    var olcir = "\u29BE";
    var olcross = "\u29BB";
    var oline = "\u203E";
    var olt = "\u29C0";
    var Omacr = "\u014C";
    var omacr = "\u014D";
    var Omega = "\u03A9";
    var omega = "\u03C9";
    var Omicron = "\u039F";
    var omicron = "\u03BF";
    var omid = "\u29B6";
    var ominus = "\u2296";
    var Oopf = "\uD835\uDD46";
    var oopf = "\uD835\uDD60";
    var opar = "\u29B7";
    var OpenCurlyDoubleQuote = "\u201C";
    var OpenCurlyQuote = "\u2018";
    var operp = "\u29B9";
    var oplus = "\u2295";
    var orarr = "\u21BB";
    var Or = "\u2A54";
    var or = "\u2228";
    var ord = "\u2A5D";
    var order = "\u2134";
    var orderof = "\u2134";
    var ordf = "\xaa";
    var ordm = "\xba";
    var origof = "\u22B6";
    var oror = "\u2A56";
    var orslope = "\u2A57";
    var orv = "\u2A5B";
    var oS = "\u24C8";
    var Oscr = "\uD835\uDCAA";
    var oscr = "\u2134";
    var Oslash = "\xd8";
    var oslash = "\xf8";
    var osol = "\u2298";
    var Otilde = "\xd5";
    var otilde = "\xf5";
    var otimesas = "\u2A36";
    var Otimes = "\u2A37";
    var otimes = "\u2297";
    var Ouml = "\xd6";
    var ouml = "\xf6";
    var ovbar = "\u233D";
    var OverBar = "\u203E";
    var OverBrace = "\u23DE";
    var OverBracket = "\u23B4";
    var OverParenthesis = "\u23DC";
    var para = "\xb6";
    var parallel = "\u2225";
    var par = "\u2225";
    var parsim = "\u2AF3";
    var parsl = "\u2AFD";
    var part = "\u2202";
    var PartialD = "\u2202";
    var Pcy = "\u041F";
    var pcy = "\u043F";
    var percnt = "%";
    var period = ".";
    var permil = "\u2030";
    var perp = "\u22A5";
    var pertenk = "\u2031";
    var Pfr = "\uD835\uDD13";
    var pfr = "\uD835\uDD2D";
    var Phi = "\u03A6";
    var phi = "\u03C6";
    var phiv = "\u03D5";
    var phmmat = "\u2133";
    var phone = "\u260E";
    var Pi = "\u03A0";
    var pi = "\u03C0";
    var pitchfork = "\u22D4";
    var piv = "\u03D6";
    var planck = "\u210F";
    var planckh = "\u210E";
    var plankv = "\u210F";
    var plusacir = "\u2A23";
    var plusb = "\u229E";
    var pluscir = "\u2A22";
    var plus = "+";
    var plusdo = "\u2214";
    var plusdu = "\u2A25";
    var pluse = "\u2A72";
    var PlusMinus = "\xb1";
    var plusmn = "\xb1";
    var plussim = "\u2A26";
    var plustwo = "\u2A27";
    var pm = "\xb1";
    var Poincareplane = "\u210C";
    var pointint = "\u2A15";
    var popf = "\uD835\uDD61";
    var Popf = "\u2119";
    var pound = "\xa3";
    var prap = "\u2AB7";
    var Pr = "\u2ABB";
    var pr = "\u227A";
    var prcue = "\u227C";
    var precapprox = "\u2AB7";
    var prec = "\u227A";
    var preccurlyeq = "\u227C";
    var Precedes = "\u227A";
    var PrecedesEqual = "\u2AAF";
    var PrecedesSlantEqual = "\u227C";
    var PrecedesTilde = "\u227E";
    var preceq = "\u2AAF";
    var precnapprox = "\u2AB9";
    var precneqq = "\u2AB5";
    var precnsim = "\u22E8";
    var pre = "\u2AAF";
    var prE = "\u2AB3";
    var precsim = "\u227E";
    var prime = "\u2032";
    var Prime = "\u2033";
    var primes = "\u2119";
    var prnap = "\u2AB9";
    var prnE = "\u2AB5";
    var prnsim = "\u22E8";
    var prod = "\u220F";
    var Product = "\u220F";
    var profalar = "\u232E";
    var profline = "\u2312";
    var profsurf = "\u2313";
    var prop = "\u221D";
    var Proportional = "\u221D";
    var Proportion = "\u2237";
    var propto = "\u221D";
    var prsim = "\u227E";
    var prurel = "\u22B0";
    var Pscr = "\uD835\uDCAB";
    var pscr = "\uD835\uDCC5";
    var Psi = "\u03A8";
    var psi = "\u03C8";
    var puncsp = "\u2008";
    var Qfr = "\uD835\uDD14";
    var qfr = "\uD835\uDD2E";
    var qint = "\u2A0C";
    var qopf = "\uD835\uDD62";
    var Qopf = "\u211A";
    var qprime = "\u2057";
    var Qscr = "\uD835\uDCAC";
    var qscr = "\uD835\uDCC6";
    var quaternions = "\u210D";
    var quatint = "\u2A16";
    var quest = "?";
    var questeq = "\u225F";
    var quot = '"';
    var QUOT = '"';
    var rAarr = "\u21DB";
    var race = "\u223D\u0331";
    var Racute = "\u0154";
    var racute = "\u0155";
    var radic = "\u221A";
    var raemptyv = "\u29B3";
    var rang = "\u27E9";
    var Rang = "\u27EB";
    var rangd = "\u2992";
    var range = "\u29A5";
    var rangle = "\u27E9";
    var raquo = "\xbb";
    var rarrap = "\u2975";
    var rarrb = "\u21E5";
    var rarrbfs = "\u2920";
    var rarrc = "\u2933";
    var rarr = "\u2192";
    var Rarr = "\u21A0";
    var rArr = "\u21D2";
    var rarrfs = "\u291E";
    var rarrhk = "\u21AA";
    var rarrlp = "\u21AC";
    var rarrpl = "\u2945";
    var rarrsim = "\u2974";
    var Rarrtl = "\u2916";
    var rarrtl = "\u21A3";
    var rarrw = "\u219D";
    var ratail = "\u291A";
    var rAtail = "\u291C";
    var ratio = "\u2236";
    var rationals = "\u211A";
    var rbarr = "\u290D";
    var rBarr = "\u290F";
    var RBarr = "\u2910";
    var rbbrk = "\u2773";
    var rbrace = "}";
    var rbrack = "]";
    var rbrke = "\u298C";
    var rbrksld = "\u298E";
    var rbrkslu = "\u2990";
    var Rcaron = "\u0158";
    var rcaron = "\u0159";
    var Rcedil = "\u0156";
    var rcedil = "\u0157";
    var rceil = "\u2309";
    var rcub = "}";
    var Rcy = "\u0420";
    var rcy = "\u0440";
    var rdca = "\u2937";
    var rdldhar = "\u2969";
    var rdquo = "\u201D";
    var rdquor = "\u201D";
    var rdsh = "\u21B3";
    var real = "\u211C";
    var realine = "\u211B";
    var realpart = "\u211C";
    var reals = "\u211D";
    var Re = "\u211C";
    var rect = "\u25AD";
    var reg = "\xae";
    var REG = "\xae";
    var ReverseElement = "\u220B";
    var ReverseEquilibrium = "\u21CB";
    var ReverseUpEquilibrium = "\u296F";
    var rfisht = "\u297D";
    var rfloor = "\u230B";
    var rfr = "\uD835\uDD2F";
    var Rfr = "\u211C";
    var rHar = "\u2964";
    var rhard = "\u21C1";
    var rharu = "\u21C0";
    var rharul = "\u296C";
    var Rho = "\u03A1";
    var rho = "\u03C1";
    var rhov = "\u03F1";
    var RightAngleBracket = "\u27E9";
    var RightArrowBar = "\u21E5";
    var rightarrow = "\u2192";
    var RightArrow = "\u2192";
    var Rightarrow = "\u21D2";
    var RightArrowLeftArrow = "\u21C4";
    var rightarrowtail = "\u21A3";
    var RightCeiling = "\u2309";
    var RightDoubleBracket = "\u27E7";
    var RightDownTeeVector = "\u295D";
    var RightDownVectorBar = "\u2955";
    var RightDownVector = "\u21C2";
    var RightFloor = "\u230B";
    var rightharpoondown = "\u21C1";
    var rightharpoonup = "\u21C0";
    var rightleftarrows = "\u21C4";
    var rightleftharpoons = "\u21CC";
    var rightrightarrows = "\u21C9";
    var rightsquigarrow = "\u219D";
    var RightTeeArrow = "\u21A6";
    var RightTee = "\u22A2";
    var RightTeeVector = "\u295B";
    var rightthreetimes = "\u22CC";
    var RightTriangleBar = "\u29D0";
    var RightTriangle = "\u22B3";
    var RightTriangleEqual = "\u22B5";
    var RightUpDownVector = "\u294F";
    var RightUpTeeVector = "\u295C";
    var RightUpVectorBar = "\u2954";
    var RightUpVector = "\u21BE";
    var RightVectorBar = "\u2953";
    var RightVector = "\u21C0";
    var ring = "\u02DA";
    var risingdotseq = "\u2253";
    var rlarr = "\u21C4";
    var rlhar = "\u21CC";
    var rlm = "\u200F";
    var rmoustache = "\u23B1";
    var rmoust = "\u23B1";
    var rnmid = "\u2AEE";
    var roang = "\u27ED";
    var roarr = "\u21FE";
    var robrk = "\u27E7";
    var ropar = "\u2986";
    var ropf = "\uD835\uDD63";
    var Ropf = "\u211D";
    var roplus = "\u2A2E";
    var rotimes = "\u2A35";
    var RoundImplies = "\u2970";
    var rpar = ")";
    var rpargt = "\u2994";
    var rppolint = "\u2A12";
    var rrarr = "\u21C9";
    var Rrightarrow = "\u21DB";
    var rsaquo = "\u203A";
    var rscr = "\uD835\uDCC7";
    var Rscr = "\u211B";
    var rsh = "\u21B1";
    var Rsh = "\u21B1";
    var rsqb = "]";
    var rsquo = "\u2019";
    var rsquor = "\u2019";
    var rthree = "\u22CC";
    var rtimes = "\u22CA";
    var rtri = "\u25B9";
    var rtrie = "\u22B5";
    var rtrif = "\u25B8";
    var rtriltri = "\u29CE";
    var RuleDelayed = "\u29F4";
    var ruluhar = "\u2968";
    var rx = "\u211E";
    var Sacute = "\u015A";
    var sacute = "\u015B";
    var sbquo = "\u201A";
    var scap = "\u2AB8";
    var Scaron = "\u0160";
    var scaron = "\u0161";
    var Sc = "\u2ABC";
    var sc = "\u227B";
    var sccue = "\u227D";
    var sce = "\u2AB0";
    var scE = "\u2AB4";
    var Scedil = "\u015E";
    var scedil = "\u015F";
    var Scirc = "\u015C";
    var scirc = "\u015D";
    var scnap = "\u2ABA";
    var scnE = "\u2AB6";
    var scnsim = "\u22E9";
    var scpolint = "\u2A13";
    var scsim = "\u227F";
    var Scy = "\u0421";
    var scy = "\u0441";
    var sdotb = "\u22A1";
    var sdot = "\u22C5";
    var sdote = "\u2A66";
    var searhk = "\u2925";
    var searr = "\u2198";
    var seArr = "\u21D8";
    var searrow = "\u2198";
    var sect = "\xa7";
    var semi = ";";
    var seswar = "\u2929";
    var setminus = "\u2216";
    var setmn = "\u2216";
    var sext = "\u2736";
    var Sfr = "\uD835\uDD16";
    var sfr = "\uD835\uDD30";
    var sfrown = "\u2322";
    var sharp = "\u266F";
    var SHCHcy = "\u0429";
    var shchcy = "\u0449";
    var SHcy = "\u0428";
    var shcy = "\u0448";
    var ShortDownArrow = "\u2193";
    var ShortLeftArrow = "\u2190";
    var shortmid = "\u2223";
    var shortparallel = "\u2225";
    var ShortRightArrow = "\u2192";
    var ShortUpArrow = "\u2191";
    var shy = "\xad";
    var Sigma = "\u03A3";
    var sigma = "\u03C3";
    var sigmaf = "\u03C2";
    var sigmav = "\u03C2";
    var sim = "\u223C";
    var simdot = "\u2A6A";
    var sime = "\u2243";
    var simeq = "\u2243";
    var simg = "\u2A9E";
    var simgE = "\u2AA0";
    var siml = "\u2A9D";
    var simlE = "\u2A9F";
    var simne = "\u2246";
    var simplus = "\u2A24";
    var simrarr = "\u2972";
    var slarr = "\u2190";
    var SmallCircle = "\u2218";
    var smallsetminus = "\u2216";
    var smashp = "\u2A33";
    var smeparsl = "\u29E4";
    var smid = "\u2223";
    var smile = "\u2323";
    var smt = "\u2AAA";
    var smte = "\u2AAC";
    var smtes = "\u2AAC\uFE00";
    var SOFTcy = "\u042C";
    var softcy = "\u044C";
    var solbar = "\u233F";
    var solb = "\u29C4";
    var sol = "/";
    var Sopf = "\uD835\uDD4A";
    var sopf = "\uD835\uDD64";
    var spades = "\u2660";
    var spadesuit = "\u2660";
    var spar = "\u2225";
    var sqcap = "\u2293";
    var sqcaps = "\u2293\uFE00";
    var sqcup = "\u2294";
    var sqcups = "\u2294\uFE00";
    var Sqrt = "\u221A";
    var sqsub = "\u228F";
    var sqsube = "\u2291";
    var sqsubset = "\u228F";
    var sqsubseteq = "\u2291";
    var sqsup = "\u2290";
    var sqsupe = "\u2292";
    var sqsupset = "\u2290";
    var sqsupseteq = "\u2292";
    var square = "\u25A1";
    var Square = "\u25A1";
    var SquareIntersection = "\u2293";
    var SquareSubset = "\u228F";
    var SquareSubsetEqual = "\u2291";
    var SquareSuperset = "\u2290";
    var SquareSupersetEqual = "\u2292";
    var SquareUnion = "\u2294";
    var squarf = "\u25AA";
    var squ = "\u25A1";
    var squf = "\u25AA";
    var srarr = "\u2192";
    var Sscr = "\uD835\uDCAE";
    var sscr = "\uD835\uDCC8";
    var ssetmn = "\u2216";
    var ssmile = "\u2323";
    var sstarf = "\u22C6";
    var Star = "\u22C6";
    var star = "\u2606";
    var starf = "\u2605";
    var straightepsilon = "\u03F5";
    var straightphi = "\u03D5";
    var strns = "\xaf";
    var sub = "\u2282";
    var Sub = "\u22D0";
    var subdot = "\u2ABD";
    var subE = "\u2AC5";
    var sube = "\u2286";
    var subedot = "\u2AC3";
    var submult = "\u2AC1";
    var subnE = "\u2ACB";
    var subne = "\u228A";
    var subplus = "\u2ABF";
    var subrarr = "\u2979";
    var subset = "\u2282";
    var Subset = "\u22D0";
    var subseteq = "\u2286";
    var subseteqq = "\u2AC5";
    var SubsetEqual = "\u2286";
    var subsetneq = "\u228A";
    var subsetneqq = "\u2ACB";
    var subsim = "\u2AC7";
    var subsub = "\u2AD5";
    var subsup = "\u2AD3";
    var succapprox = "\u2AB8";
    var succ = "\u227B";
    var succcurlyeq = "\u227D";
    var Succeeds = "\u227B";
    var SucceedsEqual = "\u2AB0";
    var SucceedsSlantEqual = "\u227D";
    var SucceedsTilde = "\u227F";
    var succeq = "\u2AB0";
    var succnapprox = "\u2ABA";
    var succneqq = "\u2AB6";
    var succnsim = "\u22E9";
    var succsim = "\u227F";
    var SuchThat = "\u220B";
    var sum = "\u2211";
    var Sum = "\u2211";
    var sung = "\u266A";
    var sup1 = "\xb9";
    var sup2 = "\xb2";
    var sup3 = "\xb3";
    var sup = "\u2283";
    var Sup = "\u22D1";
    var supdot = "\u2ABE";
    var supdsub = "\u2AD8";
    var supE = "\u2AC6";
    var supe = "\u2287";
    var supedot = "\u2AC4";
    var Superset = "\u2283";
    var SupersetEqual = "\u2287";
    var suphsol = "\u27C9";
    var suphsub = "\u2AD7";
    var suplarr = "\u297B";
    var supmult = "\u2AC2";
    var supnE = "\u2ACC";
    var supne = "\u228B";
    var supplus = "\u2AC0";
    var supset = "\u2283";
    var Supset = "\u22D1";
    var supseteq = "\u2287";
    var supseteqq = "\u2AC6";
    var supsetneq = "\u228B";
    var supsetneqq = "\u2ACC";
    var supsim = "\u2AC8";
    var supsub = "\u2AD4";
    var supsup = "\u2AD6";
    var swarhk = "\u2926";
    var swarr = "\u2199";
    var swArr = "\u21D9";
    var swarrow = "\u2199";
    var swnwar = "\u292A";
    var szlig = "\xdf";
    var Tab = "	";
    var target = "\u2316";
    var Tau = "\u03A4";
    var tau = "\u03C4";
    var tbrk = "\u23B4";
    var Tcaron = "\u0164";
    var tcaron = "\u0165";
    var Tcedil = "\u0162";
    var tcedil = "\u0163";
    var Tcy = "\u0422";
    var tcy = "\u0442";
    var tdot = "\u20DB";
    var telrec = "\u2315";
    var Tfr = "\uD835\uDD17";
    var tfr = "\uD835\uDD31";
    var there4 = "\u2234";
    var therefore = "\u2234";
    var Therefore = "\u2234";
    var Theta = "\u0398";
    var theta = "\u03B8";
    var thetasym = "\u03D1";
    var thetav = "\u03D1";
    var thickapprox = "\u2248";
    var thicksim = "\u223C";
    var ThickSpace = "\u205F\u200A";
    var ThinSpace = "\u2009";
    var thinsp = "\u2009";
    var thkap = "\u2248";
    var thksim = "\u223C";
    var THORN = "\xde";
    var thorn = "\xfe";
    var tilde = "\u02DC";
    var Tilde = "\u223C";
    var TildeEqual = "\u2243";
    var TildeFullEqual = "\u2245";
    var TildeTilde = "\u2248";
    var timesbar = "\u2A31";
    var timesb = "\u22A0";
    var times = "\xd7";
    var timesd = "\u2A30";
    var tint = "\u222D";
    var toea = "\u2928";
    var topbot = "\u2336";
    var topcir = "\u2AF1";
    var top = "\u22A4";
    var Topf = "\uD835\uDD4B";
    var topf = "\uD835\uDD65";
    var topfork = "\u2ADA";
    var tosa = "\u2929";
    var tprime = "\u2034";
    var trade = "\u2122";
    var TRADE = "\u2122";
    var triangle = "\u25B5";
    var triangledown = "\u25BF";
    var triangleleft = "\u25C3";
    var trianglelefteq = "\u22B4";
    var triangleq = "\u225C";
    var triangleright = "\u25B9";
    var trianglerighteq = "\u22B5";
    var tridot = "\u25EC";
    var trie = "\u225C";
    var triminus = "\u2A3A";
    var TripleDot = "\u20DB";
    var triplus = "\u2A39";
    var trisb = "\u29CD";
    var tritime = "\u2A3B";
    var trpezium = "\u23E2";
    var Tscr = "\uD835\uDCAF";
    var tscr = "\uD835\uDCC9";
    var TScy = "\u0426";
    var tscy = "\u0446";
    var TSHcy = "\u040B";
    var tshcy = "\u045B";
    var Tstrok = "\u0166";
    var tstrok = "\u0167";
    var twixt = "\u226C";
    var twoheadleftarrow = "\u219E";
    var twoheadrightarrow = "\u21A0";
    var Uacute = "\xda";
    var uacute = "\xfa";
    var uarr = "\u2191";
    var Uarr = "\u219F";
    var uArr = "\u21D1";
    var Uarrocir = "\u2949";
    var Ubrcy = "\u040E";
    var ubrcy = "\u045E";
    var Ubreve = "\u016C";
    var ubreve = "\u016D";
    var Ucirc = "\xdb";
    var ucirc = "\xfb";
    var Ucy = "\u0423";
    var ucy = "\u0443";
    var udarr = "\u21C5";
    var Udblac = "\u0170";
    var udblac = "\u0171";
    var udhar = "\u296E";
    var ufisht = "\u297E";
    var Ufr = "\uD835\uDD18";
    var ufr = "\uD835\uDD32";
    var Ugrave = "\xd9";
    var ugrave = "\xf9";
    var uHar = "\u2963";
    var uharl = "\u21BF";
    var uharr = "\u21BE";
    var uhblk = "\u2580";
    var ulcorn = "\u231C";
    var ulcorner = "\u231C";
    var ulcrop = "\u230F";
    var ultri = "\u25F8";
    var Umacr = "\u016A";
    var umacr = "\u016B";
    var uml = "\xa8";
    var UnderBar = "_";
    var UnderBrace = "\u23DF";
    var UnderBracket = "\u23B5";
    var UnderParenthesis = "\u23DD";
    var Union = "\u22C3";
    var UnionPlus = "\u228E";
    var Uogon = "\u0172";
    var uogon = "\u0173";
    var Uopf = "\uD835\uDD4C";
    var uopf = "\uD835\uDD66";
    var UpArrowBar = "\u2912";
    var uparrow = "\u2191";
    var UpArrow = "\u2191";
    var Uparrow = "\u21D1";
    var UpArrowDownArrow = "\u21C5";
    var updownarrow = "\u2195";
    var UpDownArrow = "\u2195";
    var Updownarrow = "\u21D5";
    var UpEquilibrium = "\u296E";
    var upharpoonleft = "\u21BF";
    var upharpoonright = "\u21BE";
    var uplus = "\u228E";
    var UpperLeftArrow = "\u2196";
    var UpperRightArrow = "\u2197";
    var upsi = "\u03C5";
    var Upsi = "\u03D2";
    var upsih = "\u03D2";
    var Upsilon = "\u03A5";
    var upsilon = "\u03C5";
    var UpTeeArrow = "\u21A5";
    var UpTee = "\u22A5";
    var upuparrows = "\u21C8";
    var urcorn = "\u231D";
    var urcorner = "\u231D";
    var urcrop = "\u230E";
    var Uring = "\u016E";
    var uring = "\u016F";
    var urtri = "\u25F9";
    var Uscr = "\uD835\uDCB0";
    var uscr = "\uD835\uDCCA";
    var utdot = "\u22F0";
    var Utilde = "\u0168";
    var utilde = "\u0169";
    var utri = "\u25B5";
    var utrif = "\u25B4";
    var uuarr = "\u21C8";
    var Uuml = "\xdc";
    var uuml = "\xfc";
    var uwangle = "\u29A7";
    var vangrt = "\u299C";
    var varepsilon = "\u03F5";
    var varkappa = "\u03F0";
    var varnothing = "\u2205";
    var varphi = "\u03D5";
    var varpi = "\u03D6";
    var varpropto = "\u221D";
    var varr = "\u2195";
    var vArr = "\u21D5";
    var varrho = "\u03F1";
    var varsigma = "\u03C2";
    var varsubsetneq = "\u228A\uFE00";
    var varsubsetneqq = "\u2ACB\uFE00";
    var varsupsetneq = "\u228B\uFE00";
    var varsupsetneqq = "\u2ACC\uFE00";
    var vartheta = "\u03D1";
    var vartriangleleft = "\u22B2";
    var vartriangleright = "\u22B3";
    var vBar = "\u2AE8";
    var Vbar = "\u2AEB";
    var vBarv = "\u2AE9";
    var Vcy = "\u0412";
    var vcy = "\u0432";
    var vdash = "\u22A2";
    var vDash = "\u22A8";
    var Vdash = "\u22A9";
    var VDash = "\u22AB";
    var Vdashl = "\u2AE6";
    var veebar = "\u22BB";
    var vee = "\u2228";
    var Vee = "\u22C1";
    var veeeq = "\u225A";
    var vellip = "\u22EE";
    var verbar = "|";
    var Verbar = "\u2016";
    var vert = "|";
    var Vert = "\u2016";
    var VerticalBar = "\u2223";
    var VerticalLine = "|";
    var VerticalSeparator = "\u2758";
    var VerticalTilde = "\u2240";
    var VeryThinSpace = "\u200A";
    var Vfr = "\uD835\uDD19";
    var vfr = "\uD835\uDD33";
    var vltri = "\u22B2";
    var vnsub = "\u2282\u20D2";
    var vnsup = "\u2283\u20D2";
    var Vopf = "\uD835\uDD4D";
    var vopf = "\uD835\uDD67";
    var vprop = "\u221D";
    var vrtri = "\u22B3";
    var Vscr = "\uD835\uDCB1";
    var vscr = "\uD835\uDCCB";
    var vsubnE = "\u2ACB\uFE00";
    var vsubne = "\u228A\uFE00";
    var vsupnE = "\u2ACC\uFE00";
    var vsupne = "\u228B\uFE00";
    var Vvdash = "\u22AA";
    var vzigzag = "\u299A";
    var Wcirc = "\u0174";
    var wcirc = "\u0175";
    var wedbar = "\u2A5F";
    var wedge = "\u2227";
    var Wedge = "\u22C0";
    var wedgeq = "\u2259";
    var weierp = "\u2118";
    var Wfr = "\uD835\uDD1A";
    var wfr = "\uD835\uDD34";
    var Wopf = "\uD835\uDD4E";
    var wopf = "\uD835\uDD68";
    var wp = "\u2118";
    var wr = "\u2240";
    var wreath = "\u2240";
    var Wscr = "\uD835\uDCB2";
    var wscr = "\uD835\uDCCC";
    var xcap = "\u22C2";
    var xcirc = "\u25EF";
    var xcup = "\u22C3";
    var xdtri = "\u25BD";
    var Xfr = "\uD835\uDD1B";
    var xfr = "\uD835\uDD35";
    var xharr = "\u27F7";
    var xhArr = "\u27FA";
    var Xi = "\u039E";
    var xi = "\u03BE";
    var xlarr = "\u27F5";
    var xlArr = "\u27F8";
    var xmap = "\u27FC";
    var xnis = "\u22FB";
    var xodot = "\u2A00";
    var Xopf = "\uD835\uDD4F";
    var xopf = "\uD835\uDD69";
    var xoplus = "\u2A01";
    var xotime = "\u2A02";
    var xrarr = "\u27F6";
    var xrArr = "\u27F9";
    var Xscr = "\uD835\uDCB3";
    var xscr = "\uD835\uDCCD";
    var xsqcup = "\u2A06";
    var xuplus = "\u2A04";
    var xutri = "\u25B3";
    var xvee = "\u22C1";
    var xwedge = "\u22C0";
    var Yacute = "\xdd";
    var yacute = "\xfd";
    var YAcy = "\u042F";
    var yacy = "\u044F";
    var Ycirc = "\u0176";
    var ycirc = "\u0177";
    var Ycy = "\u042B";
    var ycy = "\u044B";
    var yen = "\xa5";
    var Yfr = "\uD835\uDD1C";
    var yfr = "\uD835\uDD36";
    var YIcy = "\u0407";
    var yicy = "\u0457";
    var Yopf = "\uD835\uDD50";
    var yopf = "\uD835\uDD6A";
    var Yscr = "\uD835\uDCB4";
    var yscr = "\uD835\uDCCE";
    var YUcy = "\u042E";
    var yucy = "\u044E";
    var yuml = "\xff";
    var Yuml = "\u0178";
    var Zacute = "\u0179";
    var zacute = "\u017A";
    var Zcaron = "\u017D";
    var zcaron = "\u017E";
    var Zcy = "\u0417";
    var zcy = "\u0437";
    var Zdot = "\u017B";
    var zdot = "\u017C";
    var zeetrf = "\u2128";
    var ZeroWidthSpace = "\u200B";
    var Zeta = "\u0396";
    var zeta = "\u03B6";
    var zfr = "\uD835\uDD37";
    var Zfr = "\u2128";
    var ZHcy = "\u0416";
    var zhcy = "\u0436";
    var zigrarr = "\u21DD";
    var zopf = "\uD835\uDD6B";
    var Zopf = "\u2124";
    var Zscr = "\uD835\uDCB5";
    var zscr = "\uD835\uDCCF";
    var zwj = "\u200D";
    var zwnj = "\u200C";
    var entities = {
        Aacute: Aacute,
        aacute: aacute,
        Abreve: Abreve,
        abreve: abreve,
        ac: ac,
        acd: acd,
        acE: acE,
        Acirc: Acirc,
        acirc: acirc,
        acute: acute,
        Acy: Acy,
        acy: acy,
        AElig: AElig,
        aelig: aelig,
        af: af,
        Afr: Afr,
        afr: afr,
        Agrave: Agrave,
        agrave: agrave,
        alefsym: alefsym,
        aleph: aleph,
        Alpha: Alpha,
        alpha: alpha,
        Amacr: Amacr,
        amacr: amacr,
        amalg: amalg,
        amp: amp,
        AMP: AMP,
        andand: andand,
        And: And,
        and: and,
        andd: andd,
        andslope: andslope,
        andv: andv,
        ang: ang,
        ange: ange,
        angle: angle,
        angmsdaa: angmsdaa,
        angmsdab: angmsdab,
        angmsdac: angmsdac,
        angmsdad: angmsdad,
        angmsdae: angmsdae,
        angmsdaf: angmsdaf,
        angmsdag: angmsdag,
        angmsdah: angmsdah,
        angmsd: angmsd,
        angrt: angrt,
        angrtvb: angrtvb,
        angrtvbd: angrtvbd,
        angsph: angsph,
        angst: angst,
        angzarr: angzarr,
        Aogon: Aogon,
        aogon: aogon,
        Aopf: Aopf,
        aopf: aopf,
        apacir: apacir,
        ap: ap,
        apE: apE,
        ape: ape,
        apid: apid,
        apos: apos,
        ApplyFunction: ApplyFunction,
        approx: approx,
        approxeq: approxeq,
        Aring: Aring,
        aring: aring,
        Ascr: Ascr,
        ascr: ascr,
        Assign: Assign,
        ast: ast,
        asymp: asymp,
        asympeq: asympeq,
        Atilde: Atilde,
        atilde: atilde,
        Auml: Auml,
        auml: auml,
        awconint: awconint,
        awint: awint,
        backcong: backcong,
        backepsilon: backepsilon,
        backprime: backprime,
        backsim: backsim,
        backsimeq: backsimeq,
        Backslash: Backslash,
        Barv: Barv,
        barvee: barvee,
        barwed: barwed,
        Barwed: Barwed,
        barwedge: barwedge,
        bbrk: bbrk,
        bbrktbrk: bbrktbrk,
        bcong: bcong,
        Bcy: Bcy,
        bcy: bcy,
        bdquo: bdquo,
        becaus: becaus,
        because: because,
        Because: Because,
        bemptyv: bemptyv,
        bepsi: bepsi,
        bernou: bernou,
        Bernoullis: Bernoullis,
        Beta: Beta,
        beta: beta,
        beth: beth,
        between: between,
        Bfr: Bfr,
        bfr: bfr,
        bigcap: bigcap,
        bigcirc: bigcirc,
        bigcup: bigcup,
        bigodot: bigodot,
        bigoplus: bigoplus,
        bigotimes: bigotimes,
        bigsqcup: bigsqcup,
        bigstar: bigstar,
        bigtriangledown: bigtriangledown,
        bigtriangleup: bigtriangleup,
        biguplus: biguplus,
        bigvee: bigvee,
        bigwedge: bigwedge,
        bkarow: bkarow,
        blacklozenge: blacklozenge,
        blacksquare: blacksquare,
        blacktriangle: blacktriangle,
        blacktriangledown: blacktriangledown,
        blacktriangleleft: blacktriangleleft,
        blacktriangleright: blacktriangleright,
        blank: blank,
        blk12: blk12,
        blk14: blk14,
        blk34: blk34,
        block: block,
        bne: bne,
        bnequiv: bnequiv,
        bNot: bNot,
        bnot: bnot,
        Bopf: Bopf,
        bopf: bopf,
        bot: bot,
        bottom: bottom,
        bowtie: bowtie,
        boxbox: boxbox,
        boxdl: boxdl,
        boxdL: boxdL,
        boxDl: boxDl,
        boxDL: boxDL,
        boxdr: boxdr,
        boxdR: boxdR,
        boxDr: boxDr,
        boxDR: boxDR,
        boxh: boxh,
        boxH: boxH,
        boxhd: boxhd,
        boxHd: boxHd,
        boxhD: boxhD,
        boxHD: boxHD,
        boxhu: boxhu,
        boxHu: boxHu,
        boxhU: boxhU,
        boxHU: boxHU,
        boxminus: boxminus,
        boxplus: boxplus,
        boxtimes: boxtimes,
        boxul: boxul,
        boxuL: boxuL,
        boxUl: boxUl,
        boxUL: boxUL,
        boxur: boxur,
        boxuR: boxuR,
        boxUr: boxUr,
        boxUR: boxUR,
        boxv: boxv,
        boxV: boxV,
        boxvh: boxvh,
        boxvH: boxvH,
        boxVh: boxVh,
        boxVH: boxVH,
        boxvl: boxvl,
        boxvL: boxvL,
        boxVl: boxVl,
        boxVL: boxVL,
        boxvr: boxvr,
        boxvR: boxvR,
        boxVr: boxVr,
        boxVR: boxVR,
        bprime: bprime,
        breve: breve,
        Breve: Breve,
        brvbar: brvbar,
        bscr: bscr,
        Bscr: Bscr,
        bsemi: bsemi,
        bsim: bsim,
        bsime: bsime,
        bsolb: bsolb,
        bsol: bsol,
        bsolhsub: bsolhsub,
        bull: bull,
        bullet: bullet,
        bump: bump,
        bumpE: bumpE,
        bumpe: bumpe,
        Bumpeq: Bumpeq,
        bumpeq: bumpeq,
        Cacute: Cacute,
        cacute: cacute,
        capand: capand,
        capbrcup: capbrcup,
        capcap: capcap,
        cap: cap,
        Cap: Cap,
        capcup: capcup,
        capdot: capdot,
        CapitalDifferentialD: CapitalDifferentialD,
        caps: caps,
        caret: caret,
        caron: caron,
        Cayleys: Cayleys,
        ccaps: ccaps,
        Ccaron: Ccaron,
        ccaron: ccaron,
        Ccedil: Ccedil,
        ccedil: ccedil,
        Ccirc: Ccirc,
        ccirc: ccirc,
        Cconint: Cconint,
        ccups: ccups,
        ccupssm: ccupssm,
        Cdot: Cdot,
        cdot: cdot,
        cedil: cedil,
        Cedilla: Cedilla,
        cemptyv: cemptyv,
        cent: cent,
        centerdot: centerdot,
        CenterDot: CenterDot,
        cfr: cfr,
        Cfr: Cfr,
        CHcy: CHcy,
        chcy: chcy,
        check: check,
        checkmark: checkmark,
        Chi: Chi,
        chi: chi,
        circ: circ,
        circeq: circeq,
        circlearrowleft: circlearrowleft,
        circlearrowright: circlearrowright,
        circledast: circledast,
        circledcirc: circledcirc,
        circleddash: circleddash,
        CircleDot: CircleDot,
        circledR: circledR,
        circledS: circledS,
        CircleMinus: CircleMinus,
        CirclePlus: CirclePlus,
        CircleTimes: CircleTimes,
        cir: cir,
        cirE: cirE,
        cire: cire,
        cirfnint: cirfnint,
        cirmid: cirmid,
        cirscir: cirscir,
        ClockwiseContourIntegral: ClockwiseContourIntegral,
        CloseCurlyDoubleQuote: CloseCurlyDoubleQuote,
        CloseCurlyQuote: CloseCurlyQuote,
        clubs: clubs,
        clubsuit: clubsuit,
        colon: colon,
        Colon: Colon,
        Colone: Colone,
        colone: colone,
        coloneq: coloneq,
        comma: comma,
        commat: commat,
        comp: comp,
        compfn: compfn,
        complement: complement,
        complexes: complexes,
        cong: cong,
        congdot: congdot,
        Congruent: Congruent,
        conint: conint,
        Conint: Conint,
        ContourIntegral: ContourIntegral,
        copf: copf,
        Copf: Copf,
        coprod: coprod,
        Coproduct: Coproduct,
        copy: copy,
        COPY: COPY,
        copysr: copysr,
        CounterClockwiseContourIntegral: CounterClockwiseContourIntegral,
        crarr: crarr,
        cross: cross,
        Cross: Cross,
        Cscr: Cscr,
        cscr: cscr,
        csub: csub,
        csube: csube,
        csup: csup,
        csupe: csupe,
        ctdot: ctdot,
        cudarrl: cudarrl,
        cudarrr: cudarrr,
        cuepr: cuepr,
        cuesc: cuesc,
        cularr: cularr,
        cularrp: cularrp,
        cupbrcap: cupbrcap,
        cupcap: cupcap,
        CupCap: CupCap,
        cup: cup,
        Cup: Cup,
        cupcup: cupcup,
        cupdot: cupdot,
        cupor: cupor,
        cups: cups,
        curarr: curarr,
        curarrm: curarrm,
        curlyeqprec: curlyeqprec,
        curlyeqsucc: curlyeqsucc,
        curlyvee: curlyvee,
        curlywedge: curlywedge,
        curren: curren,
        curvearrowleft: curvearrowleft,
        curvearrowright: curvearrowright,
        cuvee: cuvee,
        cuwed: cuwed,
        cwconint: cwconint,
        cwint: cwint,
        cylcty: cylcty,
        dagger: dagger,
        Dagger: Dagger,
        daleth: daleth,
        darr: darr,
        Darr: Darr,
        dArr: dArr,
        dash: dash,
        Dashv: Dashv,
        dashv: dashv,
        dbkarow: dbkarow,
        dblac: dblac,
        Dcaron: Dcaron,
        dcaron: dcaron,
        Dcy: Dcy,
        dcy: dcy,
        ddagger: ddagger,
        ddarr: ddarr,
        DD: DD,
        dd: dd,
        DDotrahd: DDotrahd,
        ddotseq: ddotseq,
        deg: deg,
        Del: Del,
        Delta: Delta,
        delta: delta,
        demptyv: demptyv,
        dfisht: dfisht,
        Dfr: Dfr,
        dfr: dfr,
        dHar: dHar,
        dharl: dharl,
        dharr: dharr,
        DiacriticalAcute: DiacriticalAcute,
        DiacriticalDot: DiacriticalDot,
        DiacriticalDoubleAcute: DiacriticalDoubleAcute,
        DiacriticalGrave: DiacriticalGrave,
        DiacriticalTilde: DiacriticalTilde,
        diam: diam,
        diamond: diamond,
        Diamond: Diamond,
        diamondsuit: diamondsuit,
        diams: diams,
        die: die,
        DifferentialD: DifferentialD,
        digamma: digamma,
        disin: disin,
        div: div,
        divide: divide,
        divideontimes: divideontimes,
        divonx: divonx,
        DJcy: DJcy,
        djcy: djcy,
        dlcorn: dlcorn,
        dlcrop: dlcrop,
        dollar: dollar,
        Dopf: Dopf,
        dopf: dopf,
        Dot: Dot,
        dot: dot,
        DotDot: DotDot,
        doteq: doteq,
        doteqdot: doteqdot,
        DotEqual: DotEqual,
        dotminus: dotminus,
        dotplus: dotplus,
        dotsquare: dotsquare,
        doublebarwedge: doublebarwedge,
        DoubleContourIntegral: DoubleContourIntegral,
        DoubleDot: DoubleDot,
        DoubleDownArrow: DoubleDownArrow,
        DoubleLeftArrow: DoubleLeftArrow,
        DoubleLeftRightArrow: DoubleLeftRightArrow,
        DoubleLeftTee: DoubleLeftTee,
        DoubleLongLeftArrow: DoubleLongLeftArrow,
        DoubleLongLeftRightArrow: DoubleLongLeftRightArrow,
        DoubleLongRightArrow: DoubleLongRightArrow,
        DoubleRightArrow: DoubleRightArrow,
        DoubleRightTee: DoubleRightTee,
        DoubleUpArrow: DoubleUpArrow,
        DoubleUpDownArrow: DoubleUpDownArrow,
        DoubleVerticalBar: DoubleVerticalBar,
        DownArrowBar: DownArrowBar,
        downarrow: downarrow,
        DownArrow: DownArrow,
        Downarrow: Downarrow,
        DownArrowUpArrow: DownArrowUpArrow,
        DownBreve: DownBreve,
        downdownarrows: downdownarrows,
        downharpoonleft: downharpoonleft,
        downharpoonright: downharpoonright,
        DownLeftRightVector: DownLeftRightVector,
        DownLeftTeeVector: DownLeftTeeVector,
        DownLeftVectorBar: DownLeftVectorBar,
        DownLeftVector: DownLeftVector,
        DownRightTeeVector: DownRightTeeVector,
        DownRightVectorBar: DownRightVectorBar,
        DownRightVector: DownRightVector,
        DownTeeArrow: DownTeeArrow,
        DownTee: DownTee,
        drbkarow: drbkarow,
        drcorn: drcorn,
        drcrop: drcrop,
        Dscr: Dscr,
        dscr: dscr,
        DScy: DScy,
        dscy: dscy,
        dsol: dsol,
        Dstrok: Dstrok,
        dstrok: dstrok,
        dtdot: dtdot,
        dtri: dtri,
        dtrif: dtrif,
        duarr: duarr,
        duhar: duhar,
        dwangle: dwangle,
        DZcy: DZcy,
        dzcy: dzcy,
        dzigrarr: dzigrarr,
        Eacute: Eacute,
        eacute: eacute,
        easter: easter,
        Ecaron: Ecaron,
        ecaron: ecaron,
        Ecirc: Ecirc,
        ecirc: ecirc,
        ecir: ecir,
        ecolon: ecolon,
        Ecy: Ecy,
        ecy: ecy,
        eDDot: eDDot,
        Edot: Edot,
        edot: edot,
        eDot: eDot,
        ee: ee,
        efDot: efDot,
        Efr: Efr,
        efr: efr,
        eg: eg,
        Egrave: Egrave,
        egrave: egrave,
        egs: egs,
        egsdot: egsdot,
        el: el,
        Element: Element,
        elinters: elinters,
        ell: ell,
        els: els,
        elsdot: elsdot,
        Emacr: Emacr,
        emacr: emacr,
        empty: empty,
        emptyset: emptyset,
        EmptySmallSquare: EmptySmallSquare,
        emptyv: emptyv,
        EmptyVerySmallSquare: EmptyVerySmallSquare,
        emsp13: emsp13,
        emsp14: emsp14,
        emsp: emsp,
        ENG: ENG,
        eng: eng,
        ensp: ensp,
        Eogon: Eogon,
        eogon: eogon,
        Eopf: Eopf,
        eopf: eopf,
        epar: epar,
        eparsl: eparsl,
        eplus: eplus,
        epsi: epsi,
        Epsilon: Epsilon,
        epsilon: epsilon,
        epsiv: epsiv,
        eqcirc: eqcirc,
        eqcolon: eqcolon,
        eqsim: eqsim,
        eqslantgtr: eqslantgtr,
        eqslantless: eqslantless,
        Equal: Equal,
        equals: equals,
        EqualTilde: EqualTilde,
        equest: equest,
        Equilibrium: Equilibrium,
        equiv: equiv,
        equivDD: equivDD,
        eqvparsl: eqvparsl,
        erarr: erarr,
        erDot: erDot,
        escr: escr,
        Escr: Escr,
        esdot: esdot,
        Esim: Esim,
        esim: esim,
        Eta: Eta,
        eta: eta,
        ETH: ETH,
        eth: eth,
        Euml: Euml,
        euml: euml,
        euro: euro,
        excl: excl,
        exist: exist,
        Exists: Exists,
        expectation: expectation,
        exponentiale: exponentiale,
        ExponentialE: ExponentialE,
        fallingdotseq: fallingdotseq,
        Fcy: Fcy,
        fcy: fcy,
        female: female,
        ffilig: ffilig,
        fflig: fflig,
        ffllig: ffllig,
        Ffr: Ffr,
        ffr: ffr,
        filig: filig,
        FilledSmallSquare: FilledSmallSquare,
        FilledVerySmallSquare: FilledVerySmallSquare,
        fjlig: fjlig,
        flat: flat,
        fllig: fllig,
        fltns: fltns,
        fnof: fnof,
        Fopf: Fopf,
        fopf: fopf,
        forall: forall,
        ForAll: ForAll,
        fork: fork,
        forkv: forkv,
        Fouriertrf: Fouriertrf,
        fpartint: fpartint,
        frac12: frac12,
        frac13: frac13,
        frac14: frac14,
        frac15: frac15,
        frac16: frac16,
        frac18: frac18,
        frac23: frac23,
        frac25: frac25,
        frac34: frac34,
        frac35: frac35,
        frac38: frac38,
        frac45: frac45,
        frac56: frac56,
        frac58: frac58,
        frac78: frac78,
        frasl: frasl,
        frown: frown,
        fscr: fscr,
        Fscr: Fscr,
        gacute: gacute,
        Gamma: Gamma,
        gamma: gamma,
        Gammad: Gammad,
        gammad: gammad,
        gap: gap,
        Gbreve: Gbreve,
        gbreve: gbreve,
        Gcedil: Gcedil,
        Gcirc: Gcirc,
        gcirc: gcirc,
        Gcy: Gcy,
        gcy: gcy,
        Gdot: Gdot,
        gdot: gdot,
        ge: ge,
        gE: gE,
        gEl: gEl,
        gel: gel,
        geq: geq,
        geqq: geqq,
        geqslant: geqslant,
        gescc: gescc,
        ges: ges,
        gesdot: gesdot,
        gesdoto: gesdoto,
        gesdotol: gesdotol,
        gesl: gesl,
        gesles: gesles,
        Gfr: Gfr,
        gfr: gfr,
        gg: gg,
        Gg: Gg,
        ggg: ggg,
        gimel: gimel,
        GJcy: GJcy,
        gjcy: gjcy,
        gla: gla,
        gl: gl,
        glE: glE,
        glj: glj,
        gnap: gnap,
        gnapprox: gnapprox,
        gne: gne,
        gnE: gnE,
        gneq: gneq,
        gneqq: gneqq,
        gnsim: gnsim,
        Gopf: Gopf,
        gopf: gopf,
        grave: grave,
        GreaterEqual: GreaterEqual,
        GreaterEqualLess: GreaterEqualLess,
        GreaterFullEqual: GreaterFullEqual,
        GreaterGreater: GreaterGreater,
        GreaterLess: GreaterLess,
        GreaterSlantEqual: GreaterSlantEqual,
        GreaterTilde: GreaterTilde,
        Gscr: Gscr,
        gscr: gscr,
        gsim: gsim,
        gsime: gsime,
        gsiml: gsiml,
        gtcc: gtcc,
        gtcir: gtcir,
        gt: gt,
        GT: GT,
        Gt: Gt,
        gtdot: gtdot,
        gtlPar: gtlPar,
        gtquest: gtquest,
        gtrapprox: gtrapprox,
        gtrarr: gtrarr,
        gtrdot: gtrdot,
        gtreqless: gtreqless,
        gtreqqless: gtreqqless,
        gtrless: gtrless,
        gtrsim: gtrsim,
        gvertneqq: gvertneqq,
        gvnE: gvnE,
        Hacek: Hacek,
        hairsp: hairsp,
        half: half,
        hamilt: hamilt,
        HARDcy: HARDcy,
        hardcy: hardcy,
        harrcir: harrcir,
        harr: harr,
        hArr: hArr,
        harrw: harrw,
        Hat: Hat,
        hbar: hbar,
        Hcirc: Hcirc,
        hcirc: hcirc,
        hearts: hearts,
        heartsuit: heartsuit,
        hellip: hellip,
        hercon: hercon,
        hfr: hfr,
        Hfr: Hfr,
        HilbertSpace: HilbertSpace,
        hksearow: hksearow,
        hkswarow: hkswarow,
        hoarr: hoarr,
        homtht: homtht,
        hookleftarrow: hookleftarrow,
        hookrightarrow: hookrightarrow,
        hopf: hopf,
        Hopf: Hopf,
        horbar: horbar,
        HorizontalLine: HorizontalLine,
        hscr: hscr,
        Hscr: Hscr,
        hslash: hslash,
        Hstrok: Hstrok,
        hstrok: hstrok,
        HumpDownHump: HumpDownHump,
        HumpEqual: HumpEqual,
        hybull: hybull,
        hyphen: hyphen,
        Iacute: Iacute,
        iacute: iacute,
        ic: ic,
        Icirc: Icirc,
        icirc: icirc,
        Icy: Icy,
        icy: icy,
        Idot: Idot,
        IEcy: IEcy,
        iecy: iecy,
        iexcl: iexcl,
        iff: iff,
        ifr: ifr,
        Ifr: Ifr,
        Igrave: Igrave,
        igrave: igrave,
        ii: ii,
        iiiint: iiiint,
        iiint: iiint,
        iinfin: iinfin,
        iiota: iiota,
        IJlig: IJlig,
        ijlig: ijlig,
        Imacr: Imacr,
        imacr: imacr,
        image: image,
        ImaginaryI: ImaginaryI,
        imagline: imagline,
        imagpart: imagpart,
        imath: imath,
        Im: Im,
        imof: imof,
        imped: imped,
        Implies: Implies,
        incare: incare,
        "in": "\u2208",
        infin: infin,
        infintie: infintie,
        inodot: inodot,
        intcal: intcal,
        int: int,
        Int: Int,
        integers: integers,
        Integral: Integral,
        intercal: intercal,
        Intersection: Intersection,
        intlarhk: intlarhk,
        intprod: intprod,
        InvisibleComma: InvisibleComma,
        InvisibleTimes: InvisibleTimes,
        IOcy: IOcy,
        iocy: iocy,
        Iogon: Iogon,
        iogon: iogon,
        Iopf: Iopf,
        iopf: iopf,
        Iota: Iota,
        iota: iota,
        iprod: iprod,
        iquest: iquest,
        iscr: iscr,
        Iscr: Iscr,
        isin: isin,
        isindot: isindot,
        isinE: isinE,
        isins: isins,
        isinsv: isinsv,
        isinv: isinv,
        it: it,
        Itilde: Itilde,
        itilde: itilde,
        Iukcy: Iukcy,
        iukcy: iukcy,
        Iuml: Iuml,
        iuml: iuml,
        Jcirc: Jcirc,
        jcirc: jcirc,
        Jcy: Jcy,
        jcy: jcy,
        Jfr: Jfr,
        jfr: jfr,
        jmath: jmath,
        Jopf: Jopf,
        jopf: jopf,
        Jscr: Jscr,
        jscr: jscr,
        Jsercy: Jsercy,
        jsercy: jsercy,
        Jukcy: Jukcy,
        jukcy: jukcy,
        Kappa: Kappa,
        kappa: kappa,
        kappav: kappav,
        Kcedil: Kcedil,
        kcedil: kcedil,
        Kcy: Kcy,
        kcy: kcy,
        Kfr: Kfr,
        kfr: kfr,
        kgreen: kgreen,
        KHcy: KHcy,
        khcy: khcy,
        KJcy: KJcy,
        kjcy: kjcy,
        Kopf: Kopf,
        kopf: kopf,
        Kscr: Kscr,
        kscr: kscr,
        lAarr: lAarr,
        Lacute: Lacute,
        lacute: lacute,
        laemptyv: laemptyv,
        lagran: lagran,
        Lambda: Lambda,
        lambda: lambda,
        lang: lang,
        Lang: Lang,
        langd: langd,
        langle: langle,
        lap: lap,
        Laplacetrf: Laplacetrf,
        laquo: laquo,
        larrb: larrb,
        larrbfs: larrbfs,
        larr: larr,
        Larr: Larr,
        lArr: lArr,
        larrfs: larrfs,
        larrhk: larrhk,
        larrlp: larrlp,
        larrpl: larrpl,
        larrsim: larrsim,
        larrtl: larrtl,
        latail: latail,
        lAtail: lAtail,
        lat: lat,
        late: late,
        lates: lates,
        lbarr: lbarr,
        lBarr: lBarr,
        lbbrk: lbbrk,
        lbrace: lbrace,
        lbrack: lbrack,
        lbrke: lbrke,
        lbrksld: lbrksld,
        lbrkslu: lbrkslu,
        Lcaron: Lcaron,
        lcaron: lcaron,
        Lcedil: Lcedil,
        lcedil: lcedil,
        lceil: lceil,
        lcub: lcub,
        Lcy: Lcy,
        lcy: lcy,
        ldca: ldca,
        ldquo: ldquo,
        ldquor: ldquor,
        ldrdhar: ldrdhar,
        ldrushar: ldrushar,
        ldsh: ldsh,
        le: le,
        lE: lE,
        LeftAngleBracket: LeftAngleBracket,
        LeftArrowBar: LeftArrowBar,
        leftarrow: leftarrow,
        LeftArrow: LeftArrow,
        Leftarrow: Leftarrow,
        LeftArrowRightArrow: LeftArrowRightArrow,
        leftarrowtail: leftarrowtail,
        LeftCeiling: LeftCeiling,
        LeftDoubleBracket: LeftDoubleBracket,
        LeftDownTeeVector: LeftDownTeeVector,
        LeftDownVectorBar: LeftDownVectorBar,
        LeftDownVector: LeftDownVector,
        LeftFloor: LeftFloor,
        leftharpoondown: leftharpoondown,
        leftharpoonup: leftharpoonup,
        leftleftarrows: leftleftarrows,
        leftrightarrow: leftrightarrow,
        LeftRightArrow: LeftRightArrow,
        Leftrightarrow: Leftrightarrow,
        leftrightarrows: leftrightarrows,
        leftrightharpoons: leftrightharpoons,
        leftrightsquigarrow: leftrightsquigarrow,
        LeftRightVector: LeftRightVector,
        LeftTeeArrow: LeftTeeArrow,
        LeftTee: LeftTee,
        LeftTeeVector: LeftTeeVector,
        leftthreetimes: leftthreetimes,
        LeftTriangleBar: LeftTriangleBar,
        LeftTriangle: LeftTriangle,
        LeftTriangleEqual: LeftTriangleEqual,
        LeftUpDownVector: LeftUpDownVector,
        LeftUpTeeVector: LeftUpTeeVector,
        LeftUpVectorBar: LeftUpVectorBar,
        LeftUpVector: LeftUpVector,
        LeftVectorBar: LeftVectorBar,
        LeftVector: LeftVector,
        lEg: lEg,
        leg: leg,
        leq: leq,
        leqq: leqq,
        leqslant: leqslant,
        lescc: lescc,
        les: les,
        lesdot: lesdot,
        lesdoto: lesdoto,
        lesdotor: lesdotor,
        lesg: lesg,
        lesges: lesges,
        lessapprox: lessapprox,
        lessdot: lessdot,
        lesseqgtr: lesseqgtr,
        lesseqqgtr: lesseqqgtr,
        LessEqualGreater: LessEqualGreater,
        LessFullEqual: LessFullEqual,
        LessGreater: LessGreater,
        lessgtr: lessgtr,
        LessLess: LessLess,
        lesssim: lesssim,
        LessSlantEqual: LessSlantEqual,
        LessTilde: LessTilde,
        lfisht: lfisht,
        lfloor: lfloor,
        Lfr: Lfr,
        lfr: lfr,
        lg: lg,
        lgE: lgE,
        lHar: lHar,
        lhard: lhard,
        lharu: lharu,
        lharul: lharul,
        lhblk: lhblk,
        LJcy: LJcy,
        ljcy: ljcy,
        llarr: llarr,
        ll: ll,
        Ll: Ll,
        llcorner: llcorner,
        Lleftarrow: Lleftarrow,
        llhard: llhard,
        lltri: lltri,
        Lmidot: Lmidot,
        lmidot: lmidot,
        lmoustache: lmoustache,
        lmoust: lmoust,
        lnap: lnap,
        lnapprox: lnapprox,
        lne: lne,
        lnE: lnE,
        lneq: lneq,
        lneqq: lneqq,
        lnsim: lnsim,
        loang: loang,
        loarr: loarr,
        lobrk: lobrk,
        longleftarrow: longleftarrow,
        LongLeftArrow: LongLeftArrow,
        Longleftarrow: Longleftarrow,
        longleftrightarrow: longleftrightarrow,
        LongLeftRightArrow: LongLeftRightArrow,
        Longleftrightarrow: Longleftrightarrow,
        longmapsto: longmapsto,
        longrightarrow: longrightarrow,
        LongRightArrow: LongRightArrow,
        Longrightarrow: Longrightarrow,
        looparrowleft: looparrowleft,
        looparrowright: looparrowright,
        lopar: lopar,
        Lopf: Lopf,
        lopf: lopf,
        loplus: loplus,
        lotimes: lotimes,
        lowast: lowast,
        lowbar: lowbar,
        LowerLeftArrow: LowerLeftArrow,
        LowerRightArrow: LowerRightArrow,
        loz: loz,
        lozenge: lozenge,
        lozf: lozf,
        lpar: lpar,
        lparlt: lparlt,
        lrarr: lrarr,
        lrcorner: lrcorner,
        lrhar: lrhar,
        lrhard: lrhard,
        lrm: lrm,
        lrtri: lrtri,
        lsaquo: lsaquo,
        lscr: lscr,
        Lscr: Lscr,
        lsh: lsh,
        Lsh: Lsh,
        lsim: lsim,
        lsime: lsime,
        lsimg: lsimg,
        lsqb: lsqb,
        lsquo: lsquo,
        lsquor: lsquor,
        Lstrok: Lstrok,
        lstrok: lstrok,
        ltcc: ltcc,
        ltcir: ltcir,
        lt: lt,
        LT: LT,
        Lt: Lt,
        ltdot: ltdot,
        lthree: lthree,
        ltimes: ltimes,
        ltlarr: ltlarr,
        ltquest: ltquest,
        ltri: ltri,
        ltrie: ltrie,
        ltrif: ltrif,
        ltrPar: ltrPar,
        lurdshar: lurdshar,
        luruhar: luruhar,
        lvertneqq: lvertneqq,
        lvnE: lvnE,
        macr: macr,
        male: male,
        malt: malt,
        maltese: maltese,
        "Map": "\u2905",
        map: map,
        mapsto: mapsto,
        mapstodown: mapstodown,
        mapstoleft: mapstoleft,
        mapstoup: mapstoup,
        marker: marker,
        mcomma: mcomma,
        Mcy: Mcy,
        mcy: mcy,
        mdash: mdash,
        mDDot: mDDot,
        measuredangle: measuredangle,
        MediumSpace: MediumSpace,
        Mellintrf: Mellintrf,
        Mfr: Mfr,
        mfr: mfr,
        mho: mho,
        micro: micro,
        midast: midast,
        midcir: midcir,
        mid: mid,
        middot: middot,
        minusb: minusb,
        minus: minus,
        minusd: minusd,
        minusdu: minusdu,
        MinusPlus: MinusPlus,
        mlcp: mlcp,
        mldr: mldr,
        mnplus: mnplus,
        models: models,
        Mopf: Mopf,
        mopf: mopf,
        mp: mp,
        mscr: mscr,
        Mscr: Mscr,
        mstpos: mstpos,
        Mu: Mu,
        mu: mu,
        multimap: multimap,
        mumap: mumap,
        nabla: nabla,
        Nacute: Nacute,
        nacute: nacute,
        nang: nang,
        nap: nap,
        napE: napE,
        napid: napid,
        napos: napos,
        napprox: napprox,
        natural: natural,
        naturals: naturals,
        natur: natur,
        nbsp: nbsp,
        nbump: nbump,
        nbumpe: nbumpe,
        ncap: ncap,
        Ncaron: Ncaron,
        ncaron: ncaron,
        Ncedil: Ncedil,
        ncedil: ncedil,
        ncong: ncong,
        ncongdot: ncongdot,
        ncup: ncup,
        Ncy: Ncy,
        ncy: ncy,
        ndash: ndash,
        nearhk: nearhk,
        nearr: nearr,
        neArr: neArr,
        nearrow: nearrow,
        ne: ne,
        nedot: nedot,
        NegativeMediumSpace: NegativeMediumSpace,
        NegativeThickSpace: NegativeThickSpace,
        NegativeThinSpace: NegativeThinSpace,
        NegativeVeryThinSpace: NegativeVeryThinSpace,
        nequiv: nequiv,
        nesear: nesear,
        nesim: nesim,
        NestedGreaterGreater: NestedGreaterGreater,
        NestedLessLess: NestedLessLess,
        NewLine: NewLine,
        nexist: nexist,
        nexists: nexists,
        Nfr: Nfr,
        nfr: nfr,
        ngE: ngE,
        nge: nge,
        ngeq: ngeq,
        ngeqq: ngeqq,
        ngeqslant: ngeqslant,
        nges: nges,
        nGg: nGg,
        ngsim: ngsim,
        nGt: nGt,
        ngt: ngt,
        ngtr: ngtr,
        nGtv: nGtv,
        nharr: nharr,
        nhArr: nhArr,
        nhpar: nhpar,
        ni: ni,
        nis: nis,
        nisd: nisd,
        niv: niv,
        NJcy: NJcy,
        njcy: njcy,
        nlarr: nlarr,
        nlArr: nlArr,
        nldr: nldr,
        nlE: nlE,
        nle: nle,
        nleftarrow: nleftarrow,
        nLeftarrow: nLeftarrow,
        nleftrightarrow: nleftrightarrow,
        nLeftrightarrow: nLeftrightarrow,
        nleq: nleq,
        nleqq: nleqq,
        nleqslant: nleqslant,
        nles: nles,
        nless: nless,
        nLl: nLl,
        nlsim: nlsim,
        nLt: nLt,
        nlt: nlt,
        nltri: nltri,
        nltrie: nltrie,
        nLtv: nLtv,
        nmid: nmid,
        NoBreak: NoBreak,
        NonBreakingSpace: NonBreakingSpace,
        nopf: nopf,
        Nopf: Nopf,
        Not: Not,
        not: not,
        NotCongruent: NotCongruent,
        NotCupCap: NotCupCap,
        NotDoubleVerticalBar: NotDoubleVerticalBar,
        NotElement: NotElement,
        NotEqual: NotEqual,
        NotEqualTilde: NotEqualTilde,
        NotExists: NotExists,
        NotGreater: NotGreater,
        NotGreaterEqual: NotGreaterEqual,
        NotGreaterFullEqual: NotGreaterFullEqual,
        NotGreaterGreater: NotGreaterGreater,
        NotGreaterLess: NotGreaterLess,
        NotGreaterSlantEqual: NotGreaterSlantEqual,
        NotGreaterTilde: NotGreaterTilde,
        NotHumpDownHump: NotHumpDownHump,
        NotHumpEqual: NotHumpEqual,
        notin: notin,
        notindot: notindot,
        notinE: notinE,
        notinva: notinva,
        notinvb: notinvb,
        notinvc: notinvc,
        NotLeftTriangleBar: NotLeftTriangleBar,
        NotLeftTriangle: NotLeftTriangle,
        NotLeftTriangleEqual: NotLeftTriangleEqual,
        NotLess: NotLess,
        NotLessEqual: NotLessEqual,
        NotLessGreater: NotLessGreater,
        NotLessLess: NotLessLess,
        NotLessSlantEqual: NotLessSlantEqual,
        NotLessTilde: NotLessTilde,
        NotNestedGreaterGreater: NotNestedGreaterGreater,
        NotNestedLessLess: NotNestedLessLess,
        notni: notni,
        notniva: notniva,
        notnivb: notnivb,
        notnivc: notnivc,
        NotPrecedes: NotPrecedes,
        NotPrecedesEqual: NotPrecedesEqual,
        NotPrecedesSlantEqual: NotPrecedesSlantEqual,
        NotReverseElement: NotReverseElement,
        NotRightTriangleBar: NotRightTriangleBar,
        NotRightTriangle: NotRightTriangle,
        NotRightTriangleEqual: NotRightTriangleEqual,
        NotSquareSubset: NotSquareSubset,
        NotSquareSubsetEqual: NotSquareSubsetEqual,
        NotSquareSuperset: NotSquareSuperset,
        NotSquareSupersetEqual: NotSquareSupersetEqual,
        NotSubset: NotSubset,
        NotSubsetEqual: NotSubsetEqual,
        NotSucceeds: NotSucceeds,
        NotSucceedsEqual: NotSucceedsEqual,
        NotSucceedsSlantEqual: NotSucceedsSlantEqual,
        NotSucceedsTilde: NotSucceedsTilde,
        NotSuperset: NotSuperset,
        NotSupersetEqual: NotSupersetEqual,
        NotTilde: NotTilde,
        NotTildeEqual: NotTildeEqual,
        NotTildeFullEqual: NotTildeFullEqual,
        NotTildeTilde: NotTildeTilde,
        NotVerticalBar: NotVerticalBar,
        nparallel: nparallel,
        npar: npar,
        nparsl: nparsl,
        npart: npart,
        npolint: npolint,
        npr: npr,
        nprcue: nprcue,
        nprec: nprec,
        npreceq: npreceq,
        npre: npre,
        nrarrc: nrarrc,
        nrarr: nrarr,
        nrArr: nrArr,
        nrarrw: nrarrw,
        nrightarrow: nrightarrow,
        nRightarrow: nRightarrow,
        nrtri: nrtri,
        nrtrie: nrtrie,
        nsc: nsc,
        nsccue: nsccue,
        nsce: nsce,
        Nscr: Nscr,
        nscr: nscr,
        nshortmid: nshortmid,
        nshortparallel: nshortparallel,
        nsim: nsim,
        nsime: nsime,
        nsimeq: nsimeq,
        nsmid: nsmid,
        nspar: nspar,
        nsqsube: nsqsube,
        nsqsupe: nsqsupe,
        nsub: nsub,
        nsubE: nsubE,
        nsube: nsube,
        nsubset: nsubset,
        nsubseteq: nsubseteq,
        nsubseteqq: nsubseteqq,
        nsucc: nsucc,
        nsucceq: nsucceq,
        nsup: nsup,
        nsupE: nsupE,
        nsupe: nsupe,
        nsupset: nsupset,
        nsupseteq: nsupseteq,
        nsupseteqq: nsupseteqq,
        ntgl: ntgl,
        Ntilde: Ntilde,
        ntilde: ntilde,
        ntlg: ntlg,
        ntriangleleft: ntriangleleft,
        ntrianglelefteq: ntrianglelefteq,
        ntriangleright: ntriangleright,
        ntrianglerighteq: ntrianglerighteq,
        Nu: Nu,
        nu: nu,
        num: num,
        numero: numero,
        numsp: numsp,
        nvap: nvap,
        nvdash: nvdash,
        nvDash: nvDash,
        nVdash: nVdash,
        nVDash: nVDash,
        nvge: nvge,
        nvgt: nvgt,
        nvHarr: nvHarr,
        nvinfin: nvinfin,
        nvlArr: nvlArr,
        nvle: nvle,
        nvlt: nvlt,
        nvltrie: nvltrie,
        nvrArr: nvrArr,
        nvrtrie: nvrtrie,
        nvsim: nvsim,
        nwarhk: nwarhk,
        nwarr: nwarr,
        nwArr: nwArr,
        nwarrow: nwarrow,
        nwnear: nwnear,
        Oacute: Oacute,
        oacute: oacute,
        oast: oast,
        Ocirc: Ocirc,
        ocirc: ocirc,
        ocir: ocir,
        Ocy: Ocy,
        ocy: ocy,
        odash: odash,
        Odblac: Odblac,
        odblac: odblac,
        odiv: odiv,
        odot: odot,
        odsold: odsold,
        OElig: OElig,
        oelig: oelig,
        ofcir: ofcir,
        Ofr: Ofr,
        ofr: ofr,
        ogon: ogon,
        Ograve: Ograve,
        ograve: ograve,
        ogt: ogt,
        ohbar: ohbar,
        ohm: ohm,
        oint: oint,
        olarr: olarr,
        olcir: olcir,
        olcross: olcross,
        oline: oline,
        olt: olt,
        Omacr: Omacr,
        omacr: omacr,
        Omega: Omega,
        omega: omega,
        Omicron: Omicron,
        omicron: omicron,
        omid: omid,
        ominus: ominus,
        Oopf: Oopf,
        oopf: oopf,
        opar: opar,
        OpenCurlyDoubleQuote: OpenCurlyDoubleQuote,
        OpenCurlyQuote: OpenCurlyQuote,
        operp: operp,
        oplus: oplus,
        orarr: orarr,
        Or: Or,
        or: or,
        ord: ord,
        order: order,
        orderof: orderof,
        ordf: ordf,
        ordm: ordm,
        origof: origof,
        oror: oror,
        orslope: orslope,
        orv: orv,
        oS: oS,
        Oscr: Oscr,
        oscr: oscr,
        Oslash: Oslash,
        oslash: oslash,
        osol: osol,
        Otilde: Otilde,
        otilde: otilde,
        otimesas: otimesas,
        Otimes: Otimes,
        otimes: otimes,
        Ouml: Ouml,
        ouml: ouml,
        ovbar: ovbar,
        OverBar: OverBar,
        OverBrace: OverBrace,
        OverBracket: OverBracket,
        OverParenthesis: OverParenthesis,
        para: para,
        parallel: parallel,
        par: par,
        parsim: parsim,
        parsl: parsl,
        part: part,
        PartialD: PartialD,
        Pcy: Pcy,
        pcy: pcy,
        percnt: percnt,
        period: period,
        permil: permil,
        perp: perp,
        pertenk: pertenk,
        Pfr: Pfr,
        pfr: pfr,
        Phi: Phi,
        phi: phi,
        phiv: phiv,
        phmmat: phmmat,
        phone: phone,
        Pi: Pi,
        pi: pi,
        pitchfork: pitchfork,
        piv: piv,
        planck: planck,
        planckh: planckh,
        plankv: plankv,
        plusacir: plusacir,
        plusb: plusb,
        pluscir: pluscir,
        plus: plus,
        plusdo: plusdo,
        plusdu: plusdu,
        pluse: pluse,
        PlusMinus: PlusMinus,
        plusmn: plusmn,
        plussim: plussim,
        plustwo: plustwo,
        pm: pm,
        Poincareplane: Poincareplane,
        pointint: pointint,
        popf: popf,
        Popf: Popf,
        pound: pound,
        prap: prap,
        Pr: Pr,
        pr: pr,
        prcue: prcue,
        precapprox: precapprox,
        prec: prec,
        preccurlyeq: preccurlyeq,
        Precedes: Precedes,
        PrecedesEqual: PrecedesEqual,
        PrecedesSlantEqual: PrecedesSlantEqual,
        PrecedesTilde: PrecedesTilde,
        preceq: preceq,
        precnapprox: precnapprox,
        precneqq: precneqq,
        precnsim: precnsim,
        pre: pre,
        prE: prE,
        precsim: precsim,
        prime: prime,
        Prime: Prime,
        primes: primes,
        prnap: prnap,
        prnE: prnE,
        prnsim: prnsim,
        prod: prod,
        Product: Product,
        profalar: profalar,
        profline: profline,
        profsurf: profsurf,
        prop: prop,
        Proportional: Proportional,
        Proportion: Proportion,
        propto: propto,
        prsim: prsim,
        prurel: prurel,
        Pscr: Pscr,
        pscr: pscr,
        Psi: Psi,
        psi: psi,
        puncsp: puncsp,
        Qfr: Qfr,
        qfr: qfr,
        qint: qint,
        qopf: qopf,
        Qopf: Qopf,
        qprime: qprime,
        Qscr: Qscr,
        qscr: qscr,
        quaternions: quaternions,
        quatint: quatint,
        quest: quest,
        questeq: questeq,
        quot: quot,
        QUOT: QUOT,
        rAarr: rAarr,
        race: race,
        Racute: Racute,
        racute: racute,
        radic: radic,
        raemptyv: raemptyv,
        rang: rang,
        Rang: Rang,
        rangd: rangd,
        range: range,
        rangle: rangle,
        raquo: raquo,
        rarrap: rarrap,
        rarrb: rarrb,
        rarrbfs: rarrbfs,
        rarrc: rarrc,
        rarr: rarr,
        Rarr: Rarr,
        rArr: rArr,
        rarrfs: rarrfs,
        rarrhk: rarrhk,
        rarrlp: rarrlp,
        rarrpl: rarrpl,
        rarrsim: rarrsim,
        Rarrtl: Rarrtl,
        rarrtl: rarrtl,
        rarrw: rarrw,
        ratail: ratail,
        rAtail: rAtail,
        ratio: ratio,
        rationals: rationals,
        rbarr: rbarr,
        rBarr: rBarr,
        RBarr: RBarr,
        rbbrk: rbbrk,
        rbrace: rbrace,
        rbrack: rbrack,
        rbrke: rbrke,
        rbrksld: rbrksld,
        rbrkslu: rbrkslu,
        Rcaron: Rcaron,
        rcaron: rcaron,
        Rcedil: Rcedil,
        rcedil: rcedil,
        rceil: rceil,
        rcub: rcub,
        Rcy: Rcy,
        rcy: rcy,
        rdca: rdca,
        rdldhar: rdldhar,
        rdquo: rdquo,
        rdquor: rdquor,
        rdsh: rdsh,
        real: real,
        realine: realine,
        realpart: realpart,
        reals: reals,
        Re: Re,
        rect: rect,
        reg: reg,
        REG: REG,
        ReverseElement: ReverseElement,
        ReverseEquilibrium: ReverseEquilibrium,
        ReverseUpEquilibrium: ReverseUpEquilibrium,
        rfisht: rfisht,
        rfloor: rfloor,
        rfr: rfr,
        Rfr: Rfr,
        rHar: rHar,
        rhard: rhard,
        rharu: rharu,
        rharul: rharul,
        Rho: Rho,
        rho: rho,
        rhov: rhov,
        RightAngleBracket: RightAngleBracket,
        RightArrowBar: RightArrowBar,
        rightarrow: rightarrow,
        RightArrow: RightArrow,
        Rightarrow: Rightarrow,
        RightArrowLeftArrow: RightArrowLeftArrow,
        rightarrowtail: rightarrowtail,
        RightCeiling: RightCeiling,
        RightDoubleBracket: RightDoubleBracket,
        RightDownTeeVector: RightDownTeeVector,
        RightDownVectorBar: RightDownVectorBar,
        RightDownVector: RightDownVector,
        RightFloor: RightFloor,
        rightharpoondown: rightharpoondown,
        rightharpoonup: rightharpoonup,
        rightleftarrows: rightleftarrows,
        rightleftharpoons: rightleftharpoons,
        rightrightarrows: rightrightarrows,
        rightsquigarrow: rightsquigarrow,
        RightTeeArrow: RightTeeArrow,
        RightTee: RightTee,
        RightTeeVector: RightTeeVector,
        rightthreetimes: rightthreetimes,
        RightTriangleBar: RightTriangleBar,
        RightTriangle: RightTriangle,
        RightTriangleEqual: RightTriangleEqual,
        RightUpDownVector: RightUpDownVector,
        RightUpTeeVector: RightUpTeeVector,
        RightUpVectorBar: RightUpVectorBar,
        RightUpVector: RightUpVector,
        RightVectorBar: RightVectorBar,
        RightVector: RightVector,
        ring: ring,
        risingdotseq: risingdotseq,
        rlarr: rlarr,
        rlhar: rlhar,
        rlm: rlm,
        rmoustache: rmoustache,
        rmoust: rmoust,
        rnmid: rnmid,
        roang: roang,
        roarr: roarr,
        robrk: robrk,
        ropar: ropar,
        ropf: ropf,
        Ropf: Ropf,
        roplus: roplus,
        rotimes: rotimes,
        RoundImplies: RoundImplies,
        rpar: rpar,
        rpargt: rpargt,
        rppolint: rppolint,
        rrarr: rrarr,
        Rrightarrow: Rrightarrow,
        rsaquo: rsaquo,
        rscr: rscr,
        Rscr: Rscr,
        rsh: rsh,
        Rsh: Rsh,
        rsqb: rsqb,
        rsquo: rsquo,
        rsquor: rsquor,
        rthree: rthree,
        rtimes: rtimes,
        rtri: rtri,
        rtrie: rtrie,
        rtrif: rtrif,
        rtriltri: rtriltri,
        RuleDelayed: RuleDelayed,
        ruluhar: ruluhar,
        rx: rx,
        Sacute: Sacute,
        sacute: sacute,
        sbquo: sbquo,
        scap: scap,
        Scaron: Scaron,
        scaron: scaron,
        Sc: Sc,
        sc: sc,
        sccue: sccue,
        sce: sce,
        scE: scE,
        Scedil: Scedil,
        scedil: scedil,
        Scirc: Scirc,
        scirc: scirc,
        scnap: scnap,
        scnE: scnE,
        scnsim: scnsim,
        scpolint: scpolint,
        scsim: scsim,
        Scy: Scy,
        scy: scy,
        sdotb: sdotb,
        sdot: sdot,
        sdote: sdote,
        searhk: searhk,
        searr: searr,
        seArr: seArr,
        searrow: searrow,
        sect: sect,
        semi: semi,
        seswar: seswar,
        setminus: setminus,
        setmn: setmn,
        sext: sext,
        Sfr: Sfr,
        sfr: sfr,
        sfrown: sfrown,
        sharp: sharp,
        SHCHcy: SHCHcy,
        shchcy: shchcy,
        SHcy: SHcy,
        shcy: shcy,
        ShortDownArrow: ShortDownArrow,
        ShortLeftArrow: ShortLeftArrow,
        shortmid: shortmid,
        shortparallel: shortparallel,
        ShortRightArrow: ShortRightArrow,
        ShortUpArrow: ShortUpArrow,
        shy: shy,
        Sigma: Sigma,
        sigma: sigma,
        sigmaf: sigmaf,
        sigmav: sigmav,
        sim: sim,
        simdot: simdot,
        sime: sime,
        simeq: simeq,
        simg: simg,
        simgE: simgE,
        siml: siml,
        simlE: simlE,
        simne: simne,
        simplus: simplus,
        simrarr: simrarr,
        slarr: slarr,
        SmallCircle: SmallCircle,
        smallsetminus: smallsetminus,
        smashp: smashp,
        smeparsl: smeparsl,
        smid: smid,
        smile: smile,
        smt: smt,
        smte: smte,
        smtes: smtes,
        SOFTcy: SOFTcy,
        softcy: softcy,
        solbar: solbar,
        solb: solb,
        sol: sol,
        Sopf: Sopf,
        sopf: sopf,
        spades: spades,
        spadesuit: spadesuit,
        spar: spar,
        sqcap: sqcap,
        sqcaps: sqcaps,
        sqcup: sqcup,
        sqcups: sqcups,
        Sqrt: Sqrt,
        sqsub: sqsub,
        sqsube: sqsube,
        sqsubset: sqsubset,
        sqsubseteq: sqsubseteq,
        sqsup: sqsup,
        sqsupe: sqsupe,
        sqsupset: sqsupset,
        sqsupseteq: sqsupseteq,
        square: square,
        Square: Square,
        SquareIntersection: SquareIntersection,
        SquareSubset: SquareSubset,
        SquareSubsetEqual: SquareSubsetEqual,
        SquareSuperset: SquareSuperset,
        SquareSupersetEqual: SquareSupersetEqual,
        SquareUnion: SquareUnion,
        squarf: squarf,
        squ: squ,
        squf: squf,
        srarr: srarr,
        Sscr: Sscr,
        sscr: sscr,
        ssetmn: ssetmn,
        ssmile: ssmile,
        sstarf: sstarf,
        Star: Star,
        star: star,
        starf: starf,
        straightepsilon: straightepsilon,
        straightphi: straightphi,
        strns: strns,
        sub: sub,
        Sub: Sub,
        subdot: subdot,
        subE: subE,
        sube: sube,
        subedot: subedot,
        submult: submult,
        subnE: subnE,
        subne: subne,
        subplus: subplus,
        subrarr: subrarr,
        subset: subset,
        Subset: Subset,
        subseteq: subseteq,
        subseteqq: subseteqq,
        SubsetEqual: SubsetEqual,
        subsetneq: subsetneq,
        subsetneqq: subsetneqq,
        subsim: subsim,
        subsub: subsub,
        subsup: subsup,
        succapprox: succapprox,
        succ: succ,
        succcurlyeq: succcurlyeq,
        Succeeds: Succeeds,
        SucceedsEqual: SucceedsEqual,
        SucceedsSlantEqual: SucceedsSlantEqual,
        SucceedsTilde: SucceedsTilde,
        succeq: succeq,
        succnapprox: succnapprox,
        succneqq: succneqq,
        succnsim: succnsim,
        succsim: succsim,
        SuchThat: SuchThat,
        sum: sum,
        Sum: Sum,
        sung: sung,
        sup1: sup1,
        sup2: sup2,
        sup3: sup3,
        sup: sup,
        Sup: Sup,
        supdot: supdot,
        supdsub: supdsub,
        supE: supE,
        supe: supe,
        supedot: supedot,
        Superset: Superset,
        SupersetEqual: SupersetEqual,
        suphsol: suphsol,
        suphsub: suphsub,
        suplarr: suplarr,
        supmult: supmult,
        supnE: supnE,
        supne: supne,
        supplus: supplus,
        supset: supset,
        Supset: Supset,
        supseteq: supseteq,
        supseteqq: supseteqq,
        supsetneq: supsetneq,
        supsetneqq: supsetneqq,
        supsim: supsim,
        supsub: supsub,
        supsup: supsup,
        swarhk: swarhk,
        swarr: swarr,
        swArr: swArr,
        swarrow: swarrow,
        swnwar: swnwar,
        szlig: szlig,
        Tab: Tab,
        target: target,
        Tau: Tau,
        tau: tau,
        tbrk: tbrk,
        Tcaron: Tcaron,
        tcaron: tcaron,
        Tcedil: Tcedil,
        tcedil: tcedil,
        Tcy: Tcy,
        tcy: tcy,
        tdot: tdot,
        telrec: telrec,
        Tfr: Tfr,
        tfr: tfr,
        there4: there4,
        therefore: therefore,
        Therefore: Therefore,
        Theta: Theta,
        theta: theta,
        thetasym: thetasym,
        thetav: thetav,
        thickapprox: thickapprox,
        thicksim: thicksim,
        ThickSpace: ThickSpace,
        ThinSpace: ThinSpace,
        thinsp: thinsp,
        thkap: thkap,
        thksim: thksim,
        THORN: THORN,
        thorn: thorn,
        tilde: tilde,
        Tilde: Tilde,
        TildeEqual: TildeEqual,
        TildeFullEqual: TildeFullEqual,
        TildeTilde: TildeTilde,
        timesbar: timesbar,
        timesb: timesb,
        times: times,
        timesd: timesd,
        tint: tint,
        toea: toea,
        topbot: topbot,
        topcir: topcir,
        top: top,
        Topf: Topf,
        topf: topf,
        topfork: topfork,
        tosa: tosa,
        tprime: tprime,
        trade: trade,
        TRADE: TRADE,
        triangle: triangle,
        triangledown: triangledown,
        triangleleft: triangleleft,
        trianglelefteq: trianglelefteq,
        triangleq: triangleq,
        triangleright: triangleright,
        trianglerighteq: trianglerighteq,
        tridot: tridot,
        trie: trie,
        triminus: triminus,
        TripleDot: TripleDot,
        triplus: triplus,
        trisb: trisb,
        tritime: tritime,
        trpezium: trpezium,
        Tscr: Tscr,
        tscr: tscr,
        TScy: TScy,
        tscy: tscy,
        TSHcy: TSHcy,
        tshcy: tshcy,
        Tstrok: Tstrok,
        tstrok: tstrok,
        twixt: twixt,
        twoheadleftarrow: twoheadleftarrow,
        twoheadrightarrow: twoheadrightarrow,
        Uacute: Uacute,
        uacute: uacute,
        uarr: uarr,
        Uarr: Uarr,
        uArr: uArr,
        Uarrocir: Uarrocir,
        Ubrcy: Ubrcy,
        ubrcy: ubrcy,
        Ubreve: Ubreve,
        ubreve: ubreve,
        Ucirc: Ucirc,
        ucirc: ucirc,
        Ucy: Ucy,
        ucy: ucy,
        udarr: udarr,
        Udblac: Udblac,
        udblac: udblac,
        udhar: udhar,
        ufisht: ufisht,
        Ufr: Ufr,
        ufr: ufr,
        Ugrave: Ugrave,
        ugrave: ugrave,
        uHar: uHar,
        uharl: uharl,
        uharr: uharr,
        uhblk: uhblk,
        ulcorn: ulcorn,
        ulcorner: ulcorner,
        ulcrop: ulcrop,
        ultri: ultri,
        Umacr: Umacr,
        umacr: umacr,
        uml: uml,
        UnderBar: UnderBar,
        UnderBrace: UnderBrace,
        UnderBracket: UnderBracket,
        UnderParenthesis: UnderParenthesis,
        Union: Union,
        UnionPlus: UnionPlus,
        Uogon: Uogon,
        uogon: uogon,
        Uopf: Uopf,
        uopf: uopf,
        UpArrowBar: UpArrowBar,
        uparrow: uparrow,
        UpArrow: UpArrow,
        Uparrow: Uparrow,
        UpArrowDownArrow: UpArrowDownArrow,
        updownarrow: updownarrow,
        UpDownArrow: UpDownArrow,
        Updownarrow: Updownarrow,
        UpEquilibrium: UpEquilibrium,
        upharpoonleft: upharpoonleft,
        upharpoonright: upharpoonright,
        uplus: uplus,
        UpperLeftArrow: UpperLeftArrow,
        UpperRightArrow: UpperRightArrow,
        upsi: upsi,
        Upsi: Upsi,
        upsih: upsih,
        Upsilon: Upsilon,
        upsilon: upsilon,
        UpTeeArrow: UpTeeArrow,
        UpTee: UpTee,
        upuparrows: upuparrows,
        urcorn: urcorn,
        urcorner: urcorner,
        urcrop: urcrop,
        Uring: Uring,
        uring: uring,
        urtri: urtri,
        Uscr: Uscr,
        uscr: uscr,
        utdot: utdot,
        Utilde: Utilde,
        utilde: utilde,
        utri: utri,
        utrif: utrif,
        uuarr: uuarr,
        Uuml: Uuml,
        uuml: uuml,
        uwangle: uwangle,
        vangrt: vangrt,
        varepsilon: varepsilon,
        varkappa: varkappa,
        varnothing: varnothing,
        varphi: varphi,
        varpi: varpi,
        varpropto: varpropto,
        varr: varr,
        vArr: vArr,
        varrho: varrho,
        varsigma: varsigma,
        varsubsetneq: varsubsetneq,
        varsubsetneqq: varsubsetneqq,
        varsupsetneq: varsupsetneq,
        varsupsetneqq: varsupsetneqq,
        vartheta: vartheta,
        vartriangleleft: vartriangleleft,
        vartriangleright: vartriangleright,
        vBar: vBar,
        Vbar: Vbar,
        vBarv: vBarv,
        Vcy: Vcy,
        vcy: vcy,
        vdash: vdash,
        vDash: vDash,
        Vdash: Vdash,
        VDash: VDash,
        Vdashl: Vdashl,
        veebar: veebar,
        vee: vee,
        Vee: Vee,
        veeeq: veeeq,
        vellip: vellip,
        verbar: verbar,
        Verbar: Verbar,
        vert: vert,
        Vert: Vert,
        VerticalBar: VerticalBar,
        VerticalLine: VerticalLine,
        VerticalSeparator: VerticalSeparator,
        VerticalTilde: VerticalTilde,
        VeryThinSpace: VeryThinSpace,
        Vfr: Vfr,
        vfr: vfr,
        vltri: vltri,
        vnsub: vnsub,
        vnsup: vnsup,
        Vopf: Vopf,
        vopf: vopf,
        vprop: vprop,
        vrtri: vrtri,
        Vscr: Vscr,
        vscr: vscr,
        vsubnE: vsubnE,
        vsubne: vsubne,
        vsupnE: vsupnE,
        vsupne: vsupne,
        Vvdash: Vvdash,
        vzigzag: vzigzag,
        Wcirc: Wcirc,
        wcirc: wcirc,
        wedbar: wedbar,
        wedge: wedge,
        Wedge: Wedge,
        wedgeq: wedgeq,
        weierp: weierp,
        Wfr: Wfr,
        wfr: wfr,
        Wopf: Wopf,
        wopf: wopf,
        wp: wp,
        wr: wr,
        wreath: wreath,
        Wscr: Wscr,
        wscr: wscr,
        xcap: xcap,
        xcirc: xcirc,
        xcup: xcup,
        xdtri: xdtri,
        Xfr: Xfr,
        xfr: xfr,
        xharr: xharr,
        xhArr: xhArr,
        Xi: Xi,
        xi: xi,
        xlarr: xlarr,
        xlArr: xlArr,
        xmap: xmap,
        xnis: xnis,
        xodot: xodot,
        Xopf: Xopf,
        xopf: xopf,
        xoplus: xoplus,
        xotime: xotime,
        xrarr: xrarr,
        xrArr: xrArr,
        Xscr: Xscr,
        xscr: xscr,
        xsqcup: xsqcup,
        xuplus: xuplus,
        xutri: xutri,
        xvee: xvee,
        xwedge: xwedge,
        Yacute: Yacute,
        yacute: yacute,
        YAcy: YAcy,
        yacy: yacy,
        Ycirc: Ycirc,
        ycirc: ycirc,
        Ycy: Ycy,
        ycy: ycy,
        yen: yen,
        Yfr: Yfr,
        yfr: yfr,
        YIcy: YIcy,
        yicy: yicy,
        Yopf: Yopf,
        yopf: yopf,
        Yscr: Yscr,
        yscr: yscr,
        YUcy: YUcy,
        yucy: yucy,
        yuml: yuml,
        Yuml: Yuml,
        Zacute: Zacute,
        zacute: zacute,
        Zcaron: Zcaron,
        zcaron: zcaron,
        Zcy: Zcy,
        zcy: zcy,
        Zdot: Zdot,
        zdot: zdot,
        zeetrf: zeetrf,
        ZeroWidthSpace: ZeroWidthSpace,
        Zeta: Zeta,
        zeta: zeta,
        zfr: zfr,
        Zfr: Zfr,
        ZHcy: ZHcy,
        zhcy: zhcy,
        zigrarr: zigrarr,
        zopf: zopf,
        Zopf: Zopf,
        Zscr: Zscr,
        zscr: zscr,
        zwj: zwj,
        zwnj: zwnj
    };
    var entities$1 = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        Aacute: Aacute,
        aacute: aacute,
        Abreve: Abreve,
        abreve: abreve,
        ac: ac,
        acd: acd,
        acE: acE,
        Acirc: Acirc,
        acirc: acirc,
        acute: acute,
        Acy: Acy,
        acy: acy,
        AElig: AElig,
        aelig: aelig,
        af: af,
        Afr: Afr,
        afr: afr,
        Agrave: Agrave,
        agrave: agrave,
        alefsym: alefsym,
        aleph: aleph,
        Alpha: Alpha,
        alpha: alpha,
        Amacr: Amacr,
        amacr: amacr,
        amalg: amalg,
        amp: amp,
        AMP: AMP,
        andand: andand,
        And: And,
        and: and,
        andd: andd,
        andslope: andslope,
        andv: andv,
        ang: ang,
        ange: ange,
        angle: angle,
        angmsdaa: angmsdaa,
        angmsdab: angmsdab,
        angmsdac: angmsdac,
        angmsdad: angmsdad,
        angmsdae: angmsdae,
        angmsdaf: angmsdaf,
        angmsdag: angmsdag,
        angmsdah: angmsdah,
        angmsd: angmsd,
        angrt: angrt,
        angrtvb: angrtvb,
        angrtvbd: angrtvbd,
        angsph: angsph,
        angst: angst,
        angzarr: angzarr,
        Aogon: Aogon,
        aogon: aogon,
        Aopf: Aopf,
        aopf: aopf,
        apacir: apacir,
        ap: ap,
        apE: apE,
        ape: ape,
        apid: apid,
        apos: apos,
        ApplyFunction: ApplyFunction,
        approx: approx,
        approxeq: approxeq,
        Aring: Aring,
        aring: aring,
        Ascr: Ascr,
        ascr: ascr,
        Assign: Assign,
        ast: ast,
        asymp: asymp,
        asympeq: asympeq,
        Atilde: Atilde,
        atilde: atilde,
        Auml: Auml,
        auml: auml,
        awconint: awconint,
        awint: awint,
        backcong: backcong,
        backepsilon: backepsilon,
        backprime: backprime,
        backsim: backsim,
        backsimeq: backsimeq,
        Backslash: Backslash,
        Barv: Barv,
        barvee: barvee,
        barwed: barwed,
        Barwed: Barwed,
        barwedge: barwedge,
        bbrk: bbrk,
        bbrktbrk: bbrktbrk,
        bcong: bcong,
        Bcy: Bcy,
        bcy: bcy,
        bdquo: bdquo,
        becaus: becaus,
        because: because,
        Because: Because,
        bemptyv: bemptyv,
        bepsi: bepsi,
        bernou: bernou,
        Bernoullis: Bernoullis,
        Beta: Beta,
        beta: beta,
        beth: beth,
        between: between,
        Bfr: Bfr,
        bfr: bfr,
        bigcap: bigcap,
        bigcirc: bigcirc,
        bigcup: bigcup,
        bigodot: bigodot,
        bigoplus: bigoplus,
        bigotimes: bigotimes,
        bigsqcup: bigsqcup,
        bigstar: bigstar,
        bigtriangledown: bigtriangledown,
        bigtriangleup: bigtriangleup,
        biguplus: biguplus,
        bigvee: bigvee,
        bigwedge: bigwedge,
        bkarow: bkarow,
        blacklozenge: blacklozenge,
        blacksquare: blacksquare,
        blacktriangle: blacktriangle,
        blacktriangledown: blacktriangledown,
        blacktriangleleft: blacktriangleleft,
        blacktriangleright: blacktriangleright,
        blank: blank,
        blk12: blk12,
        blk14: blk14,
        blk34: blk34,
        block: block,
        bne: bne,
        bnequiv: bnequiv,
        bNot: bNot,
        bnot: bnot,
        Bopf: Bopf,
        bopf: bopf,
        bot: bot,
        bottom: bottom,
        bowtie: bowtie,
        boxbox: boxbox,
        boxdl: boxdl,
        boxdL: boxdL,
        boxDl: boxDl,
        boxDL: boxDL,
        boxdr: boxdr,
        boxdR: boxdR,
        boxDr: boxDr,
        boxDR: boxDR,
        boxh: boxh,
        boxH: boxH,
        boxhd: boxhd,
        boxHd: boxHd,
        boxhD: boxhD,
        boxHD: boxHD,
        boxhu: boxhu,
        boxHu: boxHu,
        boxhU: boxhU,
        boxHU: boxHU,
        boxminus: boxminus,
        boxplus: boxplus,
        boxtimes: boxtimes,
        boxul: boxul,
        boxuL: boxuL,
        boxUl: boxUl,
        boxUL: boxUL,
        boxur: boxur,
        boxuR: boxuR,
        boxUr: boxUr,
        boxUR: boxUR,
        boxv: boxv,
        boxV: boxV,
        boxvh: boxvh,
        boxvH: boxvH,
        boxVh: boxVh,
        boxVH: boxVH,
        boxvl: boxvl,
        boxvL: boxvL,
        boxVl: boxVl,
        boxVL: boxVL,
        boxvr: boxvr,
        boxvR: boxvR,
        boxVr: boxVr,
        boxVR: boxVR,
        bprime: bprime,
        breve: breve,
        Breve: Breve,
        brvbar: brvbar,
        bscr: bscr,
        Bscr: Bscr,
        bsemi: bsemi,
        bsim: bsim,
        bsime: bsime,
        bsolb: bsolb,
        bsol: bsol,
        bsolhsub: bsolhsub,
        bull: bull,
        bullet: bullet,
        bump: bump,
        bumpE: bumpE,
        bumpe: bumpe,
        Bumpeq: Bumpeq,
        bumpeq: bumpeq,
        Cacute: Cacute,
        cacute: cacute,
        capand: capand,
        capbrcup: capbrcup,
        capcap: capcap,
        cap: cap,
        Cap: Cap,
        capcup: capcup,
        capdot: capdot,
        CapitalDifferentialD: CapitalDifferentialD,
        caps: caps,
        caret: caret,
        caron: caron,
        Cayleys: Cayleys,
        ccaps: ccaps,
        Ccaron: Ccaron,
        ccaron: ccaron,
        Ccedil: Ccedil,
        ccedil: ccedil,
        Ccirc: Ccirc,
        ccirc: ccirc,
        Cconint: Cconint,
        ccups: ccups,
        ccupssm: ccupssm,
        Cdot: Cdot,
        cdot: cdot,
        cedil: cedil,
        Cedilla: Cedilla,
        cemptyv: cemptyv,
        cent: cent,
        centerdot: centerdot,
        CenterDot: CenterDot,
        cfr: cfr,
        Cfr: Cfr,
        CHcy: CHcy,
        chcy: chcy,
        check: check,
        checkmark: checkmark,
        Chi: Chi,
        chi: chi,
        circ: circ,
        circeq: circeq,
        circlearrowleft: circlearrowleft,
        circlearrowright: circlearrowright,
        circledast: circledast,
        circledcirc: circledcirc,
        circleddash: circleddash,
        CircleDot: CircleDot,
        circledR: circledR,
        circledS: circledS,
        CircleMinus: CircleMinus,
        CirclePlus: CirclePlus,
        CircleTimes: CircleTimes,
        cir: cir,
        cirE: cirE,
        cire: cire,
        cirfnint: cirfnint,
        cirmid: cirmid,
        cirscir: cirscir,
        ClockwiseContourIntegral: ClockwiseContourIntegral,
        CloseCurlyDoubleQuote: CloseCurlyDoubleQuote,
        CloseCurlyQuote: CloseCurlyQuote,
        clubs: clubs,
        clubsuit: clubsuit,
        colon: colon,
        Colon: Colon,
        Colone: Colone,
        colone: colone,
        coloneq: coloneq,
        comma: comma,
        commat: commat,
        comp: comp,
        compfn: compfn,
        complement: complement,
        complexes: complexes,
        cong: cong,
        congdot: congdot,
        Congruent: Congruent,
        conint: conint,
        Conint: Conint,
        ContourIntegral: ContourIntegral,
        copf: copf,
        Copf: Copf,
        coprod: coprod,
        Coproduct: Coproduct,
        copy: copy,
        COPY: COPY,
        copysr: copysr,
        CounterClockwiseContourIntegral: CounterClockwiseContourIntegral,
        crarr: crarr,
        cross: cross,
        Cross: Cross,
        Cscr: Cscr,
        cscr: cscr,
        csub: csub,
        csube: csube,
        csup: csup,
        csupe: csupe,
        ctdot: ctdot,
        cudarrl: cudarrl,
        cudarrr: cudarrr,
        cuepr: cuepr,
        cuesc: cuesc,
        cularr: cularr,
        cularrp: cularrp,
        cupbrcap: cupbrcap,
        cupcap: cupcap,
        CupCap: CupCap,
        cup: cup,
        Cup: Cup,
        cupcup: cupcup,
        cupdot: cupdot,
        cupor: cupor,
        cups: cups,
        curarr: curarr,
        curarrm: curarrm,
        curlyeqprec: curlyeqprec,
        curlyeqsucc: curlyeqsucc,
        curlyvee: curlyvee,
        curlywedge: curlywedge,
        curren: curren,
        curvearrowleft: curvearrowleft,
        curvearrowright: curvearrowright,
        cuvee: cuvee,
        cuwed: cuwed,
        cwconint: cwconint,
        cwint: cwint,
        cylcty: cylcty,
        dagger: dagger,
        Dagger: Dagger,
        daleth: daleth,
        darr: darr,
        Darr: Darr,
        dArr: dArr,
        dash: dash,
        Dashv: Dashv,
        dashv: dashv,
        dbkarow: dbkarow,
        dblac: dblac,
        Dcaron: Dcaron,
        dcaron: dcaron,
        Dcy: Dcy,
        dcy: dcy,
        ddagger: ddagger,
        ddarr: ddarr,
        DD: DD,
        dd: dd,
        DDotrahd: DDotrahd,
        ddotseq: ddotseq,
        deg: deg,
        Del: Del,
        Delta: Delta,
        delta: delta,
        demptyv: demptyv,
        dfisht: dfisht,
        Dfr: Dfr,
        dfr: dfr,
        dHar: dHar,
        dharl: dharl,
        dharr: dharr,
        DiacriticalAcute: DiacriticalAcute,
        DiacriticalDot: DiacriticalDot,
        DiacriticalDoubleAcute: DiacriticalDoubleAcute,
        DiacriticalGrave: DiacriticalGrave,
        DiacriticalTilde: DiacriticalTilde,
        diam: diam,
        diamond: diamond,
        Diamond: Diamond,
        diamondsuit: diamondsuit,
        diams: diams,
        die: die,
        DifferentialD: DifferentialD,
        digamma: digamma,
        disin: disin,
        div: div,
        divide: divide,
        divideontimes: divideontimes,
        divonx: divonx,
        DJcy: DJcy,
        djcy: djcy,
        dlcorn: dlcorn,
        dlcrop: dlcrop,
        dollar: dollar,
        Dopf: Dopf,
        dopf: dopf,
        Dot: Dot,
        dot: dot,
        DotDot: DotDot,
        doteq: doteq,
        doteqdot: doteqdot,
        DotEqual: DotEqual,
        dotminus: dotminus,
        dotplus: dotplus,
        dotsquare: dotsquare,
        doublebarwedge: doublebarwedge,
        DoubleContourIntegral: DoubleContourIntegral,
        DoubleDot: DoubleDot,
        DoubleDownArrow: DoubleDownArrow,
        DoubleLeftArrow: DoubleLeftArrow,
        DoubleLeftRightArrow: DoubleLeftRightArrow,
        DoubleLeftTee: DoubleLeftTee,
        DoubleLongLeftArrow: DoubleLongLeftArrow,
        DoubleLongLeftRightArrow: DoubleLongLeftRightArrow,
        DoubleLongRightArrow: DoubleLongRightArrow,
        DoubleRightArrow: DoubleRightArrow,
        DoubleRightTee: DoubleRightTee,
        DoubleUpArrow: DoubleUpArrow,
        DoubleUpDownArrow: DoubleUpDownArrow,
        DoubleVerticalBar: DoubleVerticalBar,
        DownArrowBar: DownArrowBar,
        downarrow: downarrow,
        DownArrow: DownArrow,
        Downarrow: Downarrow,
        DownArrowUpArrow: DownArrowUpArrow,
        DownBreve: DownBreve,
        downdownarrows: downdownarrows,
        downharpoonleft: downharpoonleft,
        downharpoonright: downharpoonright,
        DownLeftRightVector: DownLeftRightVector,
        DownLeftTeeVector: DownLeftTeeVector,
        DownLeftVectorBar: DownLeftVectorBar,
        DownLeftVector: DownLeftVector,
        DownRightTeeVector: DownRightTeeVector,
        DownRightVectorBar: DownRightVectorBar,
        DownRightVector: DownRightVector,
        DownTeeArrow: DownTeeArrow,
        DownTee: DownTee,
        drbkarow: drbkarow,
        drcorn: drcorn,
        drcrop: drcrop,
        Dscr: Dscr,
        dscr: dscr,
        DScy: DScy,
        dscy: dscy,
        dsol: dsol,
        Dstrok: Dstrok,
        dstrok: dstrok,
        dtdot: dtdot,
        dtri: dtri,
        dtrif: dtrif,
        duarr: duarr,
        duhar: duhar,
        dwangle: dwangle,
        DZcy: DZcy,
        dzcy: dzcy,
        dzigrarr: dzigrarr,
        Eacute: Eacute,
        eacute: eacute,
        easter: easter,
        Ecaron: Ecaron,
        ecaron: ecaron,
        Ecirc: Ecirc,
        ecirc: ecirc,
        ecir: ecir,
        ecolon: ecolon,
        Ecy: Ecy,
        ecy: ecy,
        eDDot: eDDot,
        Edot: Edot,
        edot: edot,
        eDot: eDot,
        ee: ee,
        efDot: efDot,
        Efr: Efr,
        efr: efr,
        eg: eg,
        Egrave: Egrave,
        egrave: egrave,
        egs: egs,
        egsdot: egsdot,
        el: el,
        Element: Element,
        elinters: elinters,
        ell: ell,
        els: els,
        elsdot: elsdot,
        Emacr: Emacr,
        emacr: emacr,
        empty: empty,
        emptyset: emptyset,
        EmptySmallSquare: EmptySmallSquare,
        emptyv: emptyv,
        EmptyVerySmallSquare: EmptyVerySmallSquare,
        emsp13: emsp13,
        emsp14: emsp14,
        emsp: emsp,
        ENG: ENG,
        eng: eng,
        ensp: ensp,
        Eogon: Eogon,
        eogon: eogon,
        Eopf: Eopf,
        eopf: eopf,
        epar: epar,
        eparsl: eparsl,
        eplus: eplus,
        epsi: epsi,
        Epsilon: Epsilon,
        epsilon: epsilon,
        epsiv: epsiv,
        eqcirc: eqcirc,
        eqcolon: eqcolon,
        eqsim: eqsim,
        eqslantgtr: eqslantgtr,
        eqslantless: eqslantless,
        Equal: Equal,
        equals: equals,
        EqualTilde: EqualTilde,
        equest: equest,
        Equilibrium: Equilibrium,
        equiv: equiv,
        equivDD: equivDD,
        eqvparsl: eqvparsl,
        erarr: erarr,
        erDot: erDot,
        escr: escr,
        Escr: Escr,
        esdot: esdot,
        Esim: Esim,
        esim: esim,
        Eta: Eta,
        eta: eta,
        ETH: ETH,
        eth: eth,
        Euml: Euml,
        euml: euml,
        euro: euro,
        excl: excl,
        exist: exist,
        Exists: Exists,
        expectation: expectation,
        exponentiale: exponentiale,
        ExponentialE: ExponentialE,
        fallingdotseq: fallingdotseq,
        Fcy: Fcy,
        fcy: fcy,
        female: female,
        ffilig: ffilig,
        fflig: fflig,
        ffllig: ffllig,
        Ffr: Ffr,
        ffr: ffr,
        filig: filig,
        FilledSmallSquare: FilledSmallSquare,
        FilledVerySmallSquare: FilledVerySmallSquare,
        fjlig: fjlig,
        flat: flat,
        fllig: fllig,
        fltns: fltns,
        fnof: fnof,
        Fopf: Fopf,
        fopf: fopf,
        forall: forall,
        ForAll: ForAll,
        fork: fork,
        forkv: forkv,
        Fouriertrf: Fouriertrf,
        fpartint: fpartint,
        frac12: frac12,
        frac13: frac13,
        frac14: frac14,
        frac15: frac15,
        frac16: frac16,
        frac18: frac18,
        frac23: frac23,
        frac25: frac25,
        frac34: frac34,
        frac35: frac35,
        frac38: frac38,
        frac45: frac45,
        frac56: frac56,
        frac58: frac58,
        frac78: frac78,
        frasl: frasl,
        frown: frown,
        fscr: fscr,
        Fscr: Fscr,
        gacute: gacute,
        Gamma: Gamma,
        gamma: gamma,
        Gammad: Gammad,
        gammad: gammad,
        gap: gap,
        Gbreve: Gbreve,
        gbreve: gbreve,
        Gcedil: Gcedil,
        Gcirc: Gcirc,
        gcirc: gcirc,
        Gcy: Gcy,
        gcy: gcy,
        Gdot: Gdot,
        gdot: gdot,
        ge: ge,
        gE: gE,
        gEl: gEl,
        gel: gel,
        geq: geq,
        geqq: geqq,
        geqslant: geqslant,
        gescc: gescc,
        ges: ges,
        gesdot: gesdot,
        gesdoto: gesdoto,
        gesdotol: gesdotol,
        gesl: gesl,
        gesles: gesles,
        Gfr: Gfr,
        gfr: gfr,
        gg: gg,
        Gg: Gg,
        ggg: ggg,
        gimel: gimel,
        GJcy: GJcy,
        gjcy: gjcy,
        gla: gla,
        gl: gl,
        glE: glE,
        glj: glj,
        gnap: gnap,
        gnapprox: gnapprox,
        gne: gne,
        gnE: gnE,
        gneq: gneq,
        gneqq: gneqq,
        gnsim: gnsim,
        Gopf: Gopf,
        gopf: gopf,
        grave: grave,
        GreaterEqual: GreaterEqual,
        GreaterEqualLess: GreaterEqualLess,
        GreaterFullEqual: GreaterFullEqual,
        GreaterGreater: GreaterGreater,
        GreaterLess: GreaterLess,
        GreaterSlantEqual: GreaterSlantEqual,
        GreaterTilde: GreaterTilde,
        Gscr: Gscr,
        gscr: gscr,
        gsim: gsim,
        gsime: gsime,
        gsiml: gsiml,
        gtcc: gtcc,
        gtcir: gtcir,
        gt: gt,
        GT: GT,
        Gt: Gt,
        gtdot: gtdot,
        gtlPar: gtlPar,
        gtquest: gtquest,
        gtrapprox: gtrapprox,
        gtrarr: gtrarr,
        gtrdot: gtrdot,
        gtreqless: gtreqless,
        gtreqqless: gtreqqless,
        gtrless: gtrless,
        gtrsim: gtrsim,
        gvertneqq: gvertneqq,
        gvnE: gvnE,
        Hacek: Hacek,
        hairsp: hairsp,
        half: half,
        hamilt: hamilt,
        HARDcy: HARDcy,
        hardcy: hardcy,
        harrcir: harrcir,
        harr: harr,
        hArr: hArr,
        harrw: harrw,
        Hat: Hat,
        hbar: hbar,
        Hcirc: Hcirc,
        hcirc: hcirc,
        hearts: hearts,
        heartsuit: heartsuit,
        hellip: hellip,
        hercon: hercon,
        hfr: hfr,
        Hfr: Hfr,
        HilbertSpace: HilbertSpace,
        hksearow: hksearow,
        hkswarow: hkswarow,
        hoarr: hoarr,
        homtht: homtht,
        hookleftarrow: hookleftarrow,
        hookrightarrow: hookrightarrow,
        hopf: hopf,
        Hopf: Hopf,
        horbar: horbar,
        HorizontalLine: HorizontalLine,
        hscr: hscr,
        Hscr: Hscr,
        hslash: hslash,
        Hstrok: Hstrok,
        hstrok: hstrok,
        HumpDownHump: HumpDownHump,
        HumpEqual: HumpEqual,
        hybull: hybull,
        hyphen: hyphen,
        Iacute: Iacute,
        iacute: iacute,
        ic: ic,
        Icirc: Icirc,
        icirc: icirc,
        Icy: Icy,
        icy: icy,
        Idot: Idot,
        IEcy: IEcy,
        iecy: iecy,
        iexcl: iexcl,
        iff: iff,
        ifr: ifr,
        Ifr: Ifr,
        Igrave: Igrave,
        igrave: igrave,
        ii: ii,
        iiiint: iiiint,
        iiint: iiint,
        iinfin: iinfin,
        iiota: iiota,
        IJlig: IJlig,
        ijlig: ijlig,
        Imacr: Imacr,
        imacr: imacr,
        image: image,
        ImaginaryI: ImaginaryI,
        imagline: imagline,
        imagpart: imagpart,
        imath: imath,
        Im: Im,
        imof: imof,
        imped: imped,
        Implies: Implies,
        incare: incare,
        infin: infin,
        infintie: infintie,
        inodot: inodot,
        intcal: intcal,
        int: int,
        Int: Int,
        integers: integers,
        Integral: Integral,
        intercal: intercal,
        Intersection: Intersection,
        intlarhk: intlarhk,
        intprod: intprod,
        InvisibleComma: InvisibleComma,
        InvisibleTimes: InvisibleTimes,
        IOcy: IOcy,
        iocy: iocy,
        Iogon: Iogon,
        iogon: iogon,
        Iopf: Iopf,
        iopf: iopf,
        Iota: Iota,
        iota: iota,
        iprod: iprod,
        iquest: iquest,
        iscr: iscr,
        Iscr: Iscr,
        isin: isin,
        isindot: isindot,
        isinE: isinE,
        isins: isins,
        isinsv: isinsv,
        isinv: isinv,
        it: it,
        Itilde: Itilde,
        itilde: itilde,
        Iukcy: Iukcy,
        iukcy: iukcy,
        Iuml: Iuml,
        iuml: iuml,
        Jcirc: Jcirc,
        jcirc: jcirc,
        Jcy: Jcy,
        jcy: jcy,
        Jfr: Jfr,
        jfr: jfr,
        jmath: jmath,
        Jopf: Jopf,
        jopf: jopf,
        Jscr: Jscr,
        jscr: jscr,
        Jsercy: Jsercy,
        jsercy: jsercy,
        Jukcy: Jukcy,
        jukcy: jukcy,
        Kappa: Kappa,
        kappa: kappa,
        kappav: kappav,
        Kcedil: Kcedil,
        kcedil: kcedil,
        Kcy: Kcy,
        kcy: kcy,
        Kfr: Kfr,
        kfr: kfr,
        kgreen: kgreen,
        KHcy: KHcy,
        khcy: khcy,
        KJcy: KJcy,
        kjcy: kjcy,
        Kopf: Kopf,
        kopf: kopf,
        Kscr: Kscr,
        kscr: kscr,
        lAarr: lAarr,
        Lacute: Lacute,
        lacute: lacute,
        laemptyv: laemptyv,
        lagran: lagran,
        Lambda: Lambda,
        lambda: lambda,
        lang: lang,
        Lang: Lang,
        langd: langd,
        langle: langle,
        lap: lap,
        Laplacetrf: Laplacetrf,
        laquo: laquo,
        larrb: larrb,
        larrbfs: larrbfs,
        larr: larr,
        Larr: Larr,
        lArr: lArr,
        larrfs: larrfs,
        larrhk: larrhk,
        larrlp: larrlp,
        larrpl: larrpl,
        larrsim: larrsim,
        larrtl: larrtl,
        latail: latail,
        lAtail: lAtail,
        lat: lat,
        late: late,
        lates: lates,
        lbarr: lbarr,
        lBarr: lBarr,
        lbbrk: lbbrk,
        lbrace: lbrace,
        lbrack: lbrack,
        lbrke: lbrke,
        lbrksld: lbrksld,
        lbrkslu: lbrkslu,
        Lcaron: Lcaron,
        lcaron: lcaron,
        Lcedil: Lcedil,
        lcedil: lcedil,
        lceil: lceil,
        lcub: lcub,
        Lcy: Lcy,
        lcy: lcy,
        ldca: ldca,
        ldquo: ldquo,
        ldquor: ldquor,
        ldrdhar: ldrdhar,
        ldrushar: ldrushar,
        ldsh: ldsh,
        le: le,
        lE: lE,
        LeftAngleBracket: LeftAngleBracket,
        LeftArrowBar: LeftArrowBar,
        leftarrow: leftarrow,
        LeftArrow: LeftArrow,
        Leftarrow: Leftarrow,
        LeftArrowRightArrow: LeftArrowRightArrow,
        leftarrowtail: leftarrowtail,
        LeftCeiling: LeftCeiling,
        LeftDoubleBracket: LeftDoubleBracket,
        LeftDownTeeVector: LeftDownTeeVector,
        LeftDownVectorBar: LeftDownVectorBar,
        LeftDownVector: LeftDownVector,
        LeftFloor: LeftFloor,
        leftharpoondown: leftharpoondown,
        leftharpoonup: leftharpoonup,
        leftleftarrows: leftleftarrows,
        leftrightarrow: leftrightarrow,
        LeftRightArrow: LeftRightArrow,
        Leftrightarrow: Leftrightarrow,
        leftrightarrows: leftrightarrows,
        leftrightharpoons: leftrightharpoons,
        leftrightsquigarrow: leftrightsquigarrow,
        LeftRightVector: LeftRightVector,
        LeftTeeArrow: LeftTeeArrow,
        LeftTee: LeftTee,
        LeftTeeVector: LeftTeeVector,
        leftthreetimes: leftthreetimes,
        LeftTriangleBar: LeftTriangleBar,
        LeftTriangle: LeftTriangle,
        LeftTriangleEqual: LeftTriangleEqual,
        LeftUpDownVector: LeftUpDownVector,
        LeftUpTeeVector: LeftUpTeeVector,
        LeftUpVectorBar: LeftUpVectorBar,
        LeftUpVector: LeftUpVector,
        LeftVectorBar: LeftVectorBar,
        LeftVector: LeftVector,
        lEg: lEg,
        leg: leg,
        leq: leq,
        leqq: leqq,
        leqslant: leqslant,
        lescc: lescc,
        les: les,
        lesdot: lesdot,
        lesdoto: lesdoto,
        lesdotor: lesdotor,
        lesg: lesg,
        lesges: lesges,
        lessapprox: lessapprox,
        lessdot: lessdot,
        lesseqgtr: lesseqgtr,
        lesseqqgtr: lesseqqgtr,
        LessEqualGreater: LessEqualGreater,
        LessFullEqual: LessFullEqual,
        LessGreater: LessGreater,
        lessgtr: lessgtr,
        LessLess: LessLess,
        lesssim: lesssim,
        LessSlantEqual: LessSlantEqual,
        LessTilde: LessTilde,
        lfisht: lfisht,
        lfloor: lfloor,
        Lfr: Lfr,
        lfr: lfr,
        lg: lg,
        lgE: lgE,
        lHar: lHar,
        lhard: lhard,
        lharu: lharu,
        lharul: lharul,
        lhblk: lhblk,
        LJcy: LJcy,
        ljcy: ljcy,
        llarr: llarr,
        ll: ll,
        Ll: Ll,
        llcorner: llcorner,
        Lleftarrow: Lleftarrow,
        llhard: llhard,
        lltri: lltri,
        Lmidot: Lmidot,
        lmidot: lmidot,
        lmoustache: lmoustache,
        lmoust: lmoust,
        lnap: lnap,
        lnapprox: lnapprox,
        lne: lne,
        lnE: lnE,
        lneq: lneq,
        lneqq: lneqq,
        lnsim: lnsim,
        loang: loang,
        loarr: loarr,
        lobrk: lobrk,
        longleftarrow: longleftarrow,
        LongLeftArrow: LongLeftArrow,
        Longleftarrow: Longleftarrow,
        longleftrightarrow: longleftrightarrow,
        LongLeftRightArrow: LongLeftRightArrow,
        Longleftrightarrow: Longleftrightarrow,
        longmapsto: longmapsto,
        longrightarrow: longrightarrow,
        LongRightArrow: LongRightArrow,
        Longrightarrow: Longrightarrow,
        looparrowleft: looparrowleft,
        looparrowright: looparrowright,
        lopar: lopar,
        Lopf: Lopf,
        lopf: lopf,
        loplus: loplus,
        lotimes: lotimes,
        lowast: lowast,
        lowbar: lowbar,
        LowerLeftArrow: LowerLeftArrow,
        LowerRightArrow: LowerRightArrow,
        loz: loz,
        lozenge: lozenge,
        lozf: lozf,
        lpar: lpar,
        lparlt: lparlt,
        lrarr: lrarr,
        lrcorner: lrcorner,
        lrhar: lrhar,
        lrhard: lrhard,
        lrm: lrm,
        lrtri: lrtri,
        lsaquo: lsaquo,
        lscr: lscr,
        Lscr: Lscr,
        lsh: lsh,
        Lsh: Lsh,
        lsim: lsim,
        lsime: lsime,
        lsimg: lsimg,
        lsqb: lsqb,
        lsquo: lsquo,
        lsquor: lsquor,
        Lstrok: Lstrok,
        lstrok: lstrok,
        ltcc: ltcc,
        ltcir: ltcir,
        lt: lt,
        LT: LT,
        Lt: Lt,
        ltdot: ltdot,
        lthree: lthree,
        ltimes: ltimes,
        ltlarr: ltlarr,
        ltquest: ltquest,
        ltri: ltri,
        ltrie: ltrie,
        ltrif: ltrif,
        ltrPar: ltrPar,
        lurdshar: lurdshar,
        luruhar: luruhar,
        lvertneqq: lvertneqq,
        lvnE: lvnE,
        macr: macr,
        male: male,
        malt: malt,
        maltese: maltese,
        map: map,
        mapsto: mapsto,
        mapstodown: mapstodown,
        mapstoleft: mapstoleft,
        mapstoup: mapstoup,
        marker: marker,
        mcomma: mcomma,
        Mcy: Mcy,
        mcy: mcy,
        mdash: mdash,
        mDDot: mDDot,
        measuredangle: measuredangle,
        MediumSpace: MediumSpace,
        Mellintrf: Mellintrf,
        Mfr: Mfr,
        mfr: mfr,
        mho: mho,
        micro: micro,
        midast: midast,
        midcir: midcir,
        mid: mid,
        middot: middot,
        minusb: minusb,
        minus: minus,
        minusd: minusd,
        minusdu: minusdu,
        MinusPlus: MinusPlus,
        mlcp: mlcp,
        mldr: mldr,
        mnplus: mnplus,
        models: models,
        Mopf: Mopf,
        mopf: mopf,
        mp: mp,
        mscr: mscr,
        Mscr: Mscr,
        mstpos: mstpos,
        Mu: Mu,
        mu: mu,
        multimap: multimap,
        mumap: mumap,
        nabla: nabla,
        Nacute: Nacute,
        nacute: nacute,
        nang: nang,
        nap: nap,
        napE: napE,
        napid: napid,
        napos: napos,
        napprox: napprox,
        natural: natural,
        naturals: naturals,
        natur: natur,
        nbsp: nbsp,
        nbump: nbump,
        nbumpe: nbumpe,
        ncap: ncap,
        Ncaron: Ncaron,
        ncaron: ncaron,
        Ncedil: Ncedil,
        ncedil: ncedil,
        ncong: ncong,
        ncongdot: ncongdot,
        ncup: ncup,
        Ncy: Ncy,
        ncy: ncy,
        ndash: ndash,
        nearhk: nearhk,
        nearr: nearr,
        neArr: neArr,
        nearrow: nearrow,
        ne: ne,
        nedot: nedot,
        NegativeMediumSpace: NegativeMediumSpace,
        NegativeThickSpace: NegativeThickSpace,
        NegativeThinSpace: NegativeThinSpace,
        NegativeVeryThinSpace: NegativeVeryThinSpace,
        nequiv: nequiv,
        nesear: nesear,
        nesim: nesim,
        NestedGreaterGreater: NestedGreaterGreater,
        NestedLessLess: NestedLessLess,
        NewLine: NewLine,
        nexist: nexist,
        nexists: nexists,
        Nfr: Nfr,
        nfr: nfr,
        ngE: ngE,
        nge: nge,
        ngeq: ngeq,
        ngeqq: ngeqq,
        ngeqslant: ngeqslant,
        nges: nges,
        nGg: nGg,
        ngsim: ngsim,
        nGt: nGt,
        ngt: ngt,
        ngtr: ngtr,
        nGtv: nGtv,
        nharr: nharr,
        nhArr: nhArr,
        nhpar: nhpar,
        ni: ni,
        nis: nis,
        nisd: nisd,
        niv: niv,
        NJcy: NJcy,
        njcy: njcy,
        nlarr: nlarr,
        nlArr: nlArr,
        nldr: nldr,
        nlE: nlE,
        nle: nle,
        nleftarrow: nleftarrow,
        nLeftarrow: nLeftarrow,
        nleftrightarrow: nleftrightarrow,
        nLeftrightarrow: nLeftrightarrow,
        nleq: nleq,
        nleqq: nleqq,
        nleqslant: nleqslant,
        nles: nles,
        nless: nless,
        nLl: nLl,
        nlsim: nlsim,
        nLt: nLt,
        nlt: nlt,
        nltri: nltri,
        nltrie: nltrie,
        nLtv: nLtv,
        nmid: nmid,
        NoBreak: NoBreak,
        NonBreakingSpace: NonBreakingSpace,
        nopf: nopf,
        Nopf: Nopf,
        Not: Not,
        not: not,
        NotCongruent: NotCongruent,
        NotCupCap: NotCupCap,
        NotDoubleVerticalBar: NotDoubleVerticalBar,
        NotElement: NotElement,
        NotEqual: NotEqual,
        NotEqualTilde: NotEqualTilde,
        NotExists: NotExists,
        NotGreater: NotGreater,
        NotGreaterEqual: NotGreaterEqual,
        NotGreaterFullEqual: NotGreaterFullEqual,
        NotGreaterGreater: NotGreaterGreater,
        NotGreaterLess: NotGreaterLess,
        NotGreaterSlantEqual: NotGreaterSlantEqual,
        NotGreaterTilde: NotGreaterTilde,
        NotHumpDownHump: NotHumpDownHump,
        NotHumpEqual: NotHumpEqual,
        notin: notin,
        notindot: notindot,
        notinE: notinE,
        notinva: notinva,
        notinvb: notinvb,
        notinvc: notinvc,
        NotLeftTriangleBar: NotLeftTriangleBar,
        NotLeftTriangle: NotLeftTriangle,
        NotLeftTriangleEqual: NotLeftTriangleEqual,
        NotLess: NotLess,
        NotLessEqual: NotLessEqual,
        NotLessGreater: NotLessGreater,
        NotLessLess: NotLessLess,
        NotLessSlantEqual: NotLessSlantEqual,
        NotLessTilde: NotLessTilde,
        NotNestedGreaterGreater: NotNestedGreaterGreater,
        NotNestedLessLess: NotNestedLessLess,
        notni: notni,
        notniva: notniva,
        notnivb: notnivb,
        notnivc: notnivc,
        NotPrecedes: NotPrecedes,
        NotPrecedesEqual: NotPrecedesEqual,
        NotPrecedesSlantEqual: NotPrecedesSlantEqual,
        NotReverseElement: NotReverseElement,
        NotRightTriangleBar: NotRightTriangleBar,
        NotRightTriangle: NotRightTriangle,
        NotRightTriangleEqual: NotRightTriangleEqual,
        NotSquareSubset: NotSquareSubset,
        NotSquareSubsetEqual: NotSquareSubsetEqual,
        NotSquareSuperset: NotSquareSuperset,
        NotSquareSupersetEqual: NotSquareSupersetEqual,
        NotSubset: NotSubset,
        NotSubsetEqual: NotSubsetEqual,
        NotSucceeds: NotSucceeds,
        NotSucceedsEqual: NotSucceedsEqual,
        NotSucceedsSlantEqual: NotSucceedsSlantEqual,
        NotSucceedsTilde: NotSucceedsTilde,
        NotSuperset: NotSuperset,
        NotSupersetEqual: NotSupersetEqual,
        NotTilde: NotTilde,
        NotTildeEqual: NotTildeEqual,
        NotTildeFullEqual: NotTildeFullEqual,
        NotTildeTilde: NotTildeTilde,
        NotVerticalBar: NotVerticalBar,
        nparallel: nparallel,
        npar: npar,
        nparsl: nparsl,
        npart: npart,
        npolint: npolint,
        npr: npr,
        nprcue: nprcue,
        nprec: nprec,
        npreceq: npreceq,
        npre: npre,
        nrarrc: nrarrc,
        nrarr: nrarr,
        nrArr: nrArr,
        nrarrw: nrarrw,
        nrightarrow: nrightarrow,
        nRightarrow: nRightarrow,
        nrtri: nrtri,
        nrtrie: nrtrie,
        nsc: nsc,
        nsccue: nsccue,
        nsce: nsce,
        Nscr: Nscr,
        nscr: nscr,
        nshortmid: nshortmid,
        nshortparallel: nshortparallel,
        nsim: nsim,
        nsime: nsime,
        nsimeq: nsimeq,
        nsmid: nsmid,
        nspar: nspar,
        nsqsube: nsqsube,
        nsqsupe: nsqsupe,
        nsub: nsub,
        nsubE: nsubE,
        nsube: nsube,
        nsubset: nsubset,
        nsubseteq: nsubseteq,
        nsubseteqq: nsubseteqq,
        nsucc: nsucc,
        nsucceq: nsucceq,
        nsup: nsup,
        nsupE: nsupE,
        nsupe: nsupe,
        nsupset: nsupset,
        nsupseteq: nsupseteq,
        nsupseteqq: nsupseteqq,
        ntgl: ntgl,
        Ntilde: Ntilde,
        ntilde: ntilde,
        ntlg: ntlg,
        ntriangleleft: ntriangleleft,
        ntrianglelefteq: ntrianglelefteq,
        ntriangleright: ntriangleright,
        ntrianglerighteq: ntrianglerighteq,
        Nu: Nu,
        nu: nu,
        num: num,
        numero: numero,
        numsp: numsp,
        nvap: nvap,
        nvdash: nvdash,
        nvDash: nvDash,
        nVdash: nVdash,
        nVDash: nVDash,
        nvge: nvge,
        nvgt: nvgt,
        nvHarr: nvHarr,
        nvinfin: nvinfin,
        nvlArr: nvlArr,
        nvle: nvle,
        nvlt: nvlt,
        nvltrie: nvltrie,
        nvrArr: nvrArr,
        nvrtrie: nvrtrie,
        nvsim: nvsim,
        nwarhk: nwarhk,
        nwarr: nwarr,
        nwArr: nwArr,
        nwarrow: nwarrow,
        nwnear: nwnear,
        Oacute: Oacute,
        oacute: oacute,
        oast: oast,
        Ocirc: Ocirc,
        ocirc: ocirc,
        ocir: ocir,
        Ocy: Ocy,
        ocy: ocy,
        odash: odash,
        Odblac: Odblac,
        odblac: odblac,
        odiv: odiv,
        odot: odot,
        odsold: odsold,
        OElig: OElig,
        oelig: oelig,
        ofcir: ofcir,
        Ofr: Ofr,
        ofr: ofr,
        ogon: ogon,
        Ograve: Ograve,
        ograve: ograve,
        ogt: ogt,
        ohbar: ohbar,
        ohm: ohm,
        oint: oint,
        olarr: olarr,
        olcir: olcir,
        olcross: olcross,
        oline: oline,
        olt: olt,
        Omacr: Omacr,
        omacr: omacr,
        Omega: Omega,
        omega: omega,
        Omicron: Omicron,
        omicron: omicron,
        omid: omid,
        ominus: ominus,
        Oopf: Oopf,
        oopf: oopf,
        opar: opar,
        OpenCurlyDoubleQuote: OpenCurlyDoubleQuote,
        OpenCurlyQuote: OpenCurlyQuote,
        operp: operp,
        oplus: oplus,
        orarr: orarr,
        Or: Or,
        or: or,
        ord: ord,
        order: order,
        orderof: orderof,
        ordf: ordf,
        ordm: ordm,
        origof: origof,
        oror: oror,
        orslope: orslope,
        orv: orv,
        oS: oS,
        Oscr: Oscr,
        oscr: oscr,
        Oslash: Oslash,
        oslash: oslash,
        osol: osol,
        Otilde: Otilde,
        otilde: otilde,
        otimesas: otimesas,
        Otimes: Otimes,
        otimes: otimes,
        Ouml: Ouml,
        ouml: ouml,
        ovbar: ovbar,
        OverBar: OverBar,
        OverBrace: OverBrace,
        OverBracket: OverBracket,
        OverParenthesis: OverParenthesis,
        para: para,
        parallel: parallel,
        par: par,
        parsim: parsim,
        parsl: parsl,
        part: part,
        PartialD: PartialD,
        Pcy: Pcy,
        pcy: pcy,
        percnt: percnt,
        period: period,
        permil: permil,
        perp: perp,
        pertenk: pertenk,
        Pfr: Pfr,
        pfr: pfr,
        Phi: Phi,
        phi: phi,
        phiv: phiv,
        phmmat: phmmat,
        phone: phone,
        Pi: Pi,
        pi: pi,
        pitchfork: pitchfork,
        piv: piv,
        planck: planck,
        planckh: planckh,
        plankv: plankv,
        plusacir: plusacir,
        plusb: plusb,
        pluscir: pluscir,
        plus: plus,
        plusdo: plusdo,
        plusdu: plusdu,
        pluse: pluse,
        PlusMinus: PlusMinus,
        plusmn: plusmn,
        plussim: plussim,
        plustwo: plustwo,
        pm: pm,
        Poincareplane: Poincareplane,
        pointint: pointint,
        popf: popf,
        Popf: Popf,
        pound: pound,
        prap: prap,
        Pr: Pr,
        pr: pr,
        prcue: prcue,
        precapprox: precapprox,
        prec: prec,
        preccurlyeq: preccurlyeq,
        Precedes: Precedes,
        PrecedesEqual: PrecedesEqual,
        PrecedesSlantEqual: PrecedesSlantEqual,
        PrecedesTilde: PrecedesTilde,
        preceq: preceq,
        precnapprox: precnapprox,
        precneqq: precneqq,
        precnsim: precnsim,
        pre: pre,
        prE: prE,
        precsim: precsim,
        prime: prime,
        Prime: Prime,
        primes: primes,
        prnap: prnap,
        prnE: prnE,
        prnsim: prnsim,
        prod: prod,
        Product: Product,
        profalar: profalar,
        profline: profline,
        profsurf: profsurf,
        prop: prop,
        Proportional: Proportional,
        Proportion: Proportion,
        propto: propto,
        prsim: prsim,
        prurel: prurel,
        Pscr: Pscr,
        pscr: pscr,
        Psi: Psi,
        psi: psi,
        puncsp: puncsp,
        Qfr: Qfr,
        qfr: qfr,
        qint: qint,
        qopf: qopf,
        Qopf: Qopf,
        qprime: qprime,
        Qscr: Qscr,
        qscr: qscr,
        quaternions: quaternions,
        quatint: quatint,
        quest: quest,
        questeq: questeq,
        quot: quot,
        QUOT: QUOT,
        rAarr: rAarr,
        race: race,
        Racute: Racute,
        racute: racute,
        radic: radic,
        raemptyv: raemptyv,
        rang: rang,
        Rang: Rang,
        rangd: rangd,
        range: range,
        rangle: rangle,
        raquo: raquo,
        rarrap: rarrap,
        rarrb: rarrb,
        rarrbfs: rarrbfs,
        rarrc: rarrc,
        rarr: rarr,
        Rarr: Rarr,
        rArr: rArr,
        rarrfs: rarrfs,
        rarrhk: rarrhk,
        rarrlp: rarrlp,
        rarrpl: rarrpl,
        rarrsim: rarrsim,
        Rarrtl: Rarrtl,
        rarrtl: rarrtl,
        rarrw: rarrw,
        ratail: ratail,
        rAtail: rAtail,
        ratio: ratio,
        rationals: rationals,
        rbarr: rbarr,
        rBarr: rBarr,
        RBarr: RBarr,
        rbbrk: rbbrk,
        rbrace: rbrace,
        rbrack: rbrack,
        rbrke: rbrke,
        rbrksld: rbrksld,
        rbrkslu: rbrkslu,
        Rcaron: Rcaron,
        rcaron: rcaron,
        Rcedil: Rcedil,
        rcedil: rcedil,
        rceil: rceil,
        rcub: rcub,
        Rcy: Rcy,
        rcy: rcy,
        rdca: rdca,
        rdldhar: rdldhar,
        rdquo: rdquo,
        rdquor: rdquor,
        rdsh: rdsh,
        real: real,
        realine: realine,
        realpart: realpart,
        reals: reals,
        Re: Re,
        rect: rect,
        reg: reg,
        REG: REG,
        ReverseElement: ReverseElement,
        ReverseEquilibrium: ReverseEquilibrium,
        ReverseUpEquilibrium: ReverseUpEquilibrium,
        rfisht: rfisht,
        rfloor: rfloor,
        rfr: rfr,
        Rfr: Rfr,
        rHar: rHar,
        rhard: rhard,
        rharu: rharu,
        rharul: rharul,
        Rho: Rho,
        rho: rho,
        rhov: rhov,
        RightAngleBracket: RightAngleBracket,
        RightArrowBar: RightArrowBar,
        rightarrow: rightarrow,
        RightArrow: RightArrow,
        Rightarrow: Rightarrow,
        RightArrowLeftArrow: RightArrowLeftArrow,
        rightarrowtail: rightarrowtail,
        RightCeiling: RightCeiling,
        RightDoubleBracket: RightDoubleBracket,
        RightDownTeeVector: RightDownTeeVector,
        RightDownVectorBar: RightDownVectorBar,
        RightDownVector: RightDownVector,
        RightFloor: RightFloor,
        rightharpoondown: rightharpoondown,
        rightharpoonup: rightharpoonup,
        rightleftarrows: rightleftarrows,
        rightleftharpoons: rightleftharpoons,
        rightrightarrows: rightrightarrows,
        rightsquigarrow: rightsquigarrow,
        RightTeeArrow: RightTeeArrow,
        RightTee: RightTee,
        RightTeeVector: RightTeeVector,
        rightthreetimes: rightthreetimes,
        RightTriangleBar: RightTriangleBar,
        RightTriangle: RightTriangle,
        RightTriangleEqual: RightTriangleEqual,
        RightUpDownVector: RightUpDownVector,
        RightUpTeeVector: RightUpTeeVector,
        RightUpVectorBar: RightUpVectorBar,
        RightUpVector: RightUpVector,
        RightVectorBar: RightVectorBar,
        RightVector: RightVector,
        ring: ring,
        risingdotseq: risingdotseq,
        rlarr: rlarr,
        rlhar: rlhar,
        rlm: rlm,
        rmoustache: rmoustache,
        rmoust: rmoust,
        rnmid: rnmid,
        roang: roang,
        roarr: roarr,
        robrk: robrk,
        ropar: ropar,
        ropf: ropf,
        Ropf: Ropf,
        roplus: roplus,
        rotimes: rotimes,
        RoundImplies: RoundImplies,
        rpar: rpar,
        rpargt: rpargt,
        rppolint: rppolint,
        rrarr: rrarr,
        Rrightarrow: Rrightarrow,
        rsaquo: rsaquo,
        rscr: rscr,
        Rscr: Rscr,
        rsh: rsh,
        Rsh: Rsh,
        rsqb: rsqb,
        rsquo: rsquo,
        rsquor: rsquor,
        rthree: rthree,
        rtimes: rtimes,
        rtri: rtri,
        rtrie: rtrie,
        rtrif: rtrif,
        rtriltri: rtriltri,
        RuleDelayed: RuleDelayed,
        ruluhar: ruluhar,
        rx: rx,
        Sacute: Sacute,
        sacute: sacute,
        sbquo: sbquo,
        scap: scap,
        Scaron: Scaron,
        scaron: scaron,
        Sc: Sc,
        sc: sc,
        sccue: sccue,
        sce: sce,
        scE: scE,
        Scedil: Scedil,
        scedil: scedil,
        Scirc: Scirc,
        scirc: scirc,
        scnap: scnap,
        scnE: scnE,
        scnsim: scnsim,
        scpolint: scpolint,
        scsim: scsim,
        Scy: Scy,
        scy: scy,
        sdotb: sdotb,
        sdot: sdot,
        sdote: sdote,
        searhk: searhk,
        searr: searr,
        seArr: seArr,
        searrow: searrow,
        sect: sect,
        semi: semi,
        seswar: seswar,
        setminus: setminus,
        setmn: setmn,
        sext: sext,
        Sfr: Sfr,
        sfr: sfr,
        sfrown: sfrown,
        sharp: sharp,
        SHCHcy: SHCHcy,
        shchcy: shchcy,
        SHcy: SHcy,
        shcy: shcy,
        ShortDownArrow: ShortDownArrow,
        ShortLeftArrow: ShortLeftArrow,
        shortmid: shortmid,
        shortparallel: shortparallel,
        ShortRightArrow: ShortRightArrow,
        ShortUpArrow: ShortUpArrow,
        shy: shy,
        Sigma: Sigma,
        sigma: sigma,
        sigmaf: sigmaf,
        sigmav: sigmav,
        sim: sim,
        simdot: simdot,
        sime: sime,
        simeq: simeq,
        simg: simg,
        simgE: simgE,
        siml: siml,
        simlE: simlE,
        simne: simne,
        simplus: simplus,
        simrarr: simrarr,
        slarr: slarr,
        SmallCircle: SmallCircle,
        smallsetminus: smallsetminus,
        smashp: smashp,
        smeparsl: smeparsl,
        smid: smid,
        smile: smile,
        smt: smt,
        smte: smte,
        smtes: smtes,
        SOFTcy: SOFTcy,
        softcy: softcy,
        solbar: solbar,
        solb: solb,
        sol: sol,
        Sopf: Sopf,
        sopf: sopf,
        spades: spades,
        spadesuit: spadesuit,
        spar: spar,
        sqcap: sqcap,
        sqcaps: sqcaps,
        sqcup: sqcup,
        sqcups: sqcups,
        Sqrt: Sqrt,
        sqsub: sqsub,
        sqsube: sqsube,
        sqsubset: sqsubset,
        sqsubseteq: sqsubseteq,
        sqsup: sqsup,
        sqsupe: sqsupe,
        sqsupset: sqsupset,
        sqsupseteq: sqsupseteq,
        square: square,
        Square: Square,
        SquareIntersection: SquareIntersection,
        SquareSubset: SquareSubset,
        SquareSubsetEqual: SquareSubsetEqual,
        SquareSuperset: SquareSuperset,
        SquareSupersetEqual: SquareSupersetEqual,
        SquareUnion: SquareUnion,
        squarf: squarf,
        squ: squ,
        squf: squf,
        srarr: srarr,
        Sscr: Sscr,
        sscr: sscr,
        ssetmn: ssetmn,
        ssmile: ssmile,
        sstarf: sstarf,
        Star: Star,
        star: star,
        starf: starf,
        straightepsilon: straightepsilon,
        straightphi: straightphi,
        strns: strns,
        sub: sub,
        Sub: Sub,
        subdot: subdot,
        subE: subE,
        sube: sube,
        subedot: subedot,
        submult: submult,
        subnE: subnE,
        subne: subne,
        subplus: subplus,
        subrarr: subrarr,
        subset: subset,
        Subset: Subset,
        subseteq: subseteq,
        subseteqq: subseteqq,
        SubsetEqual: SubsetEqual,
        subsetneq: subsetneq,
        subsetneqq: subsetneqq,
        subsim: subsim,
        subsub: subsub,
        subsup: subsup,
        succapprox: succapprox,
        succ: succ,
        succcurlyeq: succcurlyeq,
        Succeeds: Succeeds,
        SucceedsEqual: SucceedsEqual,
        SucceedsSlantEqual: SucceedsSlantEqual,
        SucceedsTilde: SucceedsTilde,
        succeq: succeq,
        succnapprox: succnapprox,
        succneqq: succneqq,
        succnsim: succnsim,
        succsim: succsim,
        SuchThat: SuchThat,
        sum: sum,
        Sum: Sum,
        sung: sung,
        sup1: sup1,
        sup2: sup2,
        sup3: sup3,
        sup: sup,
        Sup: Sup,
        supdot: supdot,
        supdsub: supdsub,
        supE: supE,
        supe: supe,
        supedot: supedot,
        Superset: Superset,
        SupersetEqual: SupersetEqual,
        suphsol: suphsol,
        suphsub: suphsub,
        suplarr: suplarr,
        supmult: supmult,
        supnE: supnE,
        supne: supne,
        supplus: supplus,
        supset: supset,
        Supset: Supset,
        supseteq: supseteq,
        supseteqq: supseteqq,
        supsetneq: supsetneq,
        supsetneqq: supsetneqq,
        supsim: supsim,
        supsub: supsub,
        supsup: supsup,
        swarhk: swarhk,
        swarr: swarr,
        swArr: swArr,
        swarrow: swarrow,
        swnwar: swnwar,
        szlig: szlig,
        Tab: Tab,
        target: target,
        Tau: Tau,
        tau: tau,
        tbrk: tbrk,
        Tcaron: Tcaron,
        tcaron: tcaron,
        Tcedil: Tcedil,
        tcedil: tcedil,
        Tcy: Tcy,
        tcy: tcy,
        tdot: tdot,
        telrec: telrec,
        Tfr: Tfr,
        tfr: tfr,
        there4: there4,
        therefore: therefore,
        Therefore: Therefore,
        Theta: Theta,
        theta: theta,
        thetasym: thetasym,
        thetav: thetav,
        thickapprox: thickapprox,
        thicksim: thicksim,
        ThickSpace: ThickSpace,
        ThinSpace: ThinSpace,
        thinsp: thinsp,
        thkap: thkap,
        thksim: thksim,
        THORN: THORN,
        thorn: thorn,
        tilde: tilde,
        Tilde: Tilde,
        TildeEqual: TildeEqual,
        TildeFullEqual: TildeFullEqual,
        TildeTilde: TildeTilde,
        timesbar: timesbar,
        timesb: timesb,
        times: times,
        timesd: timesd,
        tint: tint,
        toea: toea,
        topbot: topbot,
        topcir: topcir,
        top: top,
        Topf: Topf,
        topf: topf,
        topfork: topfork,
        tosa: tosa,
        tprime: tprime,
        trade: trade,
        TRADE: TRADE,
        triangle: triangle,
        triangledown: triangledown,
        triangleleft: triangleleft,
        trianglelefteq: trianglelefteq,
        triangleq: triangleq,
        triangleright: triangleright,
        trianglerighteq: trianglerighteq,
        tridot: tridot,
        trie: trie,
        triminus: triminus,
        TripleDot: TripleDot,
        triplus: triplus,
        trisb: trisb,
        tritime: tritime,
        trpezium: trpezium,
        Tscr: Tscr,
        tscr: tscr,
        TScy: TScy,
        tscy: tscy,
        TSHcy: TSHcy,
        tshcy: tshcy,
        Tstrok: Tstrok,
        tstrok: tstrok,
        twixt: twixt,
        twoheadleftarrow: twoheadleftarrow,
        twoheadrightarrow: twoheadrightarrow,
        Uacute: Uacute,
        uacute: uacute,
        uarr: uarr,
        Uarr: Uarr,
        uArr: uArr,
        Uarrocir: Uarrocir,
        Ubrcy: Ubrcy,
        ubrcy: ubrcy,
        Ubreve: Ubreve,
        ubreve: ubreve,
        Ucirc: Ucirc,
        ucirc: ucirc,
        Ucy: Ucy,
        ucy: ucy,
        udarr: udarr,
        Udblac: Udblac,
        udblac: udblac,
        udhar: udhar,
        ufisht: ufisht,
        Ufr: Ufr,
        ufr: ufr,
        Ugrave: Ugrave,
        ugrave: ugrave,
        uHar: uHar,
        uharl: uharl,
        uharr: uharr,
        uhblk: uhblk,
        ulcorn: ulcorn,
        ulcorner: ulcorner,
        ulcrop: ulcrop,
        ultri: ultri,
        Umacr: Umacr,
        umacr: umacr,
        uml: uml,
        UnderBar: UnderBar,
        UnderBrace: UnderBrace,
        UnderBracket: UnderBracket,
        UnderParenthesis: UnderParenthesis,
        Union: Union,
        UnionPlus: UnionPlus,
        Uogon: Uogon,
        uogon: uogon,
        Uopf: Uopf,
        uopf: uopf,
        UpArrowBar: UpArrowBar,
        uparrow: uparrow,
        UpArrow: UpArrow,
        Uparrow: Uparrow,
        UpArrowDownArrow: UpArrowDownArrow,
        updownarrow: updownarrow,
        UpDownArrow: UpDownArrow,
        Updownarrow: Updownarrow,
        UpEquilibrium: UpEquilibrium,
        upharpoonleft: upharpoonleft,
        upharpoonright: upharpoonright,
        uplus: uplus,
        UpperLeftArrow: UpperLeftArrow,
        UpperRightArrow: UpperRightArrow,
        upsi: upsi,
        Upsi: Upsi,
        upsih: upsih,
        Upsilon: Upsilon,
        upsilon: upsilon,
        UpTeeArrow: UpTeeArrow,
        UpTee: UpTee,
        upuparrows: upuparrows,
        urcorn: urcorn,
        urcorner: urcorner,
        urcrop: urcrop,
        Uring: Uring,
        uring: uring,
        urtri: urtri,
        Uscr: Uscr,
        uscr: uscr,
        utdot: utdot,
        Utilde: Utilde,
        utilde: utilde,
        utri: utri,
        utrif: utrif,
        uuarr: uuarr,
        Uuml: Uuml,
        uuml: uuml,
        uwangle: uwangle,
        vangrt: vangrt,
        varepsilon: varepsilon,
        varkappa: varkappa,
        varnothing: varnothing,
        varphi: varphi,
        varpi: varpi,
        varpropto: varpropto,
        varr: varr,
        vArr: vArr,
        varrho: varrho,
        varsigma: varsigma,
        varsubsetneq: varsubsetneq,
        varsubsetneqq: varsubsetneqq,
        varsupsetneq: varsupsetneq,
        varsupsetneqq: varsupsetneqq,
        vartheta: vartheta,
        vartriangleleft: vartriangleleft,
        vartriangleright: vartriangleright,
        vBar: vBar,
        Vbar: Vbar,
        vBarv: vBarv,
        Vcy: Vcy,
        vcy: vcy,
        vdash: vdash,
        vDash: vDash,
        Vdash: Vdash,
        VDash: VDash,
        Vdashl: Vdashl,
        veebar: veebar,
        vee: vee,
        Vee: Vee,
        veeeq: veeeq,
        vellip: vellip,
        verbar: verbar,
        Verbar: Verbar,
        vert: vert,
        Vert: Vert,
        VerticalBar: VerticalBar,
        VerticalLine: VerticalLine,
        VerticalSeparator: VerticalSeparator,
        VerticalTilde: VerticalTilde,
        VeryThinSpace: VeryThinSpace,
        Vfr: Vfr,
        vfr: vfr,
        vltri: vltri,
        vnsub: vnsub,
        vnsup: vnsup,
        Vopf: Vopf,
        vopf: vopf,
        vprop: vprop,
        vrtri: vrtri,
        Vscr: Vscr,
        vscr: vscr,
        vsubnE: vsubnE,
        vsubne: vsubne,
        vsupnE: vsupnE,
        vsupne: vsupne,
        Vvdash: Vvdash,
        vzigzag: vzigzag,
        Wcirc: Wcirc,
        wcirc: wcirc,
        wedbar: wedbar,
        wedge: wedge,
        Wedge: Wedge,
        wedgeq: wedgeq,
        weierp: weierp,
        Wfr: Wfr,
        wfr: wfr,
        Wopf: Wopf,
        wopf: wopf,
        wp: wp,
        wr: wr,
        wreath: wreath,
        Wscr: Wscr,
        wscr: wscr,
        xcap: xcap,
        xcirc: xcirc,
        xcup: xcup,
        xdtri: xdtri,
        Xfr: Xfr,
        xfr: xfr,
        xharr: xharr,
        xhArr: xhArr,
        Xi: Xi,
        xi: xi,
        xlarr: xlarr,
        xlArr: xlArr,
        xmap: xmap,
        xnis: xnis,
        xodot: xodot,
        Xopf: Xopf,
        xopf: xopf,
        xoplus: xoplus,
        xotime: xotime,
        xrarr: xrarr,
        xrArr: xrArr,
        Xscr: Xscr,
        xscr: xscr,
        xsqcup: xsqcup,
        xuplus: xuplus,
        xutri: xutri,
        xvee: xvee,
        xwedge: xwedge,
        Yacute: Yacute,
        yacute: yacute,
        YAcy: YAcy,
        yacy: yacy,
        Ycirc: Ycirc,
        ycirc: ycirc,
        Ycy: Ycy,
        ycy: ycy,
        yen: yen,
        Yfr: Yfr,
        yfr: yfr,
        YIcy: YIcy,
        yicy: yicy,
        Yopf: Yopf,
        yopf: yopf,
        Yscr: Yscr,
        yscr: yscr,
        YUcy: YUcy,
        yucy: yucy,
        yuml: yuml,
        Yuml: Yuml,
        Zacute: Zacute,
        zacute: zacute,
        Zcaron: Zcaron,
        zcaron: zcaron,
        Zcy: Zcy,
        zcy: zcy,
        Zdot: Zdot,
        zdot: zdot,
        zeetrf: zeetrf,
        ZeroWidthSpace: ZeroWidthSpace,
        Zeta: Zeta,
        zeta: zeta,
        zfr: zfr,
        Zfr: Zfr,
        ZHcy: ZHcy,
        zhcy: zhcy,
        zigrarr: zigrarr,
        zopf: zopf,
        Zopf: Zopf,
        Zscr: Zscr,
        zscr: zscr,
        zwj: zwj,
        zwnj: zwnj,
        "default": entities
    });
    var Aacute$1 = "\xc1";
    var aacute$1 = "\xe1";
    var Acirc$1 = "\xc2";
    var acirc$1 = "\xe2";
    var acute$1 = "\xb4";
    var AElig$1 = "\xc6";
    var aelig$1 = "\xe6";
    var Agrave$1 = "\xc0";
    var agrave$1 = "\xe0";
    var amp$1 = "&";
    var AMP$1 = "&";
    var Aring$1 = "\xc5";
    var aring$1 = "\xe5";
    var Atilde$1 = "\xc3";
    var atilde$1 = "\xe3";
    var Auml$1 = "\xc4";
    var auml$1 = "\xe4";
    var brvbar$1 = "\xa6";
    var Ccedil$1 = "\xc7";
    var ccedil$1 = "\xe7";
    var cedil$1 = "\xb8";
    var cent$1 = "\xa2";
    var copy$1 = "\xa9";
    var COPY$1 = "\xa9";
    var curren$1 = "\xa4";
    var deg$1 = "\xb0";
    var divide$1 = "\xf7";
    var Eacute$1 = "\xc9";
    var eacute$1 = "\xe9";
    var Ecirc$1 = "\xca";
    var ecirc$1 = "\xea";
    var Egrave$1 = "\xc8";
    var egrave$1 = "\xe8";
    var ETH$1 = "\xd0";
    var eth$1 = "\xf0";
    var Euml$1 = "\xcb";
    var euml$1 = "\xeb";
    var frac12$1 = "\xbd";
    var frac14$1 = "\xbc";
    var frac34$1 = "\xbe";
    var gt$1 = ">";
    var GT$1 = ">";
    var Iacute$1 = "\xcd";
    var iacute$1 = "\xed";
    var Icirc$1 = "\xce";
    var icirc$1 = "\xee";
    var iexcl$1 = "\xa1";
    var Igrave$1 = "\xcc";
    var igrave$1 = "\xec";
    var iquest$1 = "\xbf";
    var Iuml$1 = "\xcf";
    var iuml$1 = "\xef";
    var laquo$1 = "\xab";
    var lt$1 = "<";
    var LT$1 = "<";
    var macr$1 = "\xaf";
    var micro$1 = "\xb5";
    var middot$1 = "\xb7";
    var nbsp$1 = "\xa0";
    var not$1 = "\xac";
    var Ntilde$1 = "\xd1";
    var ntilde$1 = "\xf1";
    var Oacute$1 = "\xd3";
    var oacute$1 = "\xf3";
    var Ocirc$1 = "\xd4";
    var ocirc$1 = "\xf4";
    var Ograve$1 = "\xd2";
    var ograve$1 = "\xf2";
    var ordf$1 = "\xaa";
    var ordm$1 = "\xba";
    var Oslash$1 = "\xd8";
    var oslash$1 = "\xf8";
    var Otilde$1 = "\xd5";
    var otilde$1 = "\xf5";
    var Ouml$1 = "\xd6";
    var ouml$1 = "\xf6";
    var para$1 = "\xb6";
    var plusmn$1 = "\xb1";
    var pound$1 = "\xa3";
    var quot$1 = '"';
    var QUOT$1 = '"';
    var raquo$1 = "\xbb";
    var reg$1 = "\xae";
    var REG$1 = "\xae";
    var sect$1 = "\xa7";
    var shy$1 = "\xad";
    var sup1$1 = "\xb9";
    var sup2$1 = "\xb2";
    var sup3$1 = "\xb3";
    var szlig$1 = "\xdf";
    var THORN$1 = "\xde";
    var thorn$1 = "\xfe";
    var times$1 = "\xd7";
    var Uacute$1 = "\xda";
    var uacute$1 = "\xfa";
    var Ucirc$1 = "\xdb";
    var ucirc$1 = "\xfb";
    var Ugrave$1 = "\xd9";
    var ugrave$1 = "\xf9";
    var uml$1 = "\xa8";
    var Uuml$1 = "\xdc";
    var uuml$1 = "\xfc";
    var Yacute$1 = "\xdd";
    var yacute$1 = "\xfd";
    var yen$1 = "\xa5";
    var yuml$1 = "\xff";
    var legacy = {
        Aacute: Aacute$1,
        aacute: aacute$1,
        Acirc: Acirc$1,
        acirc: acirc$1,
        acute: acute$1,
        AElig: AElig$1,
        aelig: aelig$1,
        Agrave: Agrave$1,
        agrave: agrave$1,
        amp: amp$1,
        AMP: AMP$1,
        Aring: Aring$1,
        aring: aring$1,
        Atilde: Atilde$1,
        atilde: atilde$1,
        Auml: Auml$1,
        auml: auml$1,
        brvbar: brvbar$1,
        Ccedil: Ccedil$1,
        ccedil: ccedil$1,
        cedil: cedil$1,
        cent: cent$1,
        copy: copy$1,
        COPY: COPY$1,
        curren: curren$1,
        deg: deg$1,
        divide: divide$1,
        Eacute: Eacute$1,
        eacute: eacute$1,
        Ecirc: Ecirc$1,
        ecirc: ecirc$1,
        Egrave: Egrave$1,
        egrave: egrave$1,
        ETH: ETH$1,
        eth: eth$1,
        Euml: Euml$1,
        euml: euml$1,
        frac12: frac12$1,
        frac14: frac14$1,
        frac34: frac34$1,
        gt: gt$1,
        GT: GT$1,
        Iacute: Iacute$1,
        iacute: iacute$1,
        Icirc: Icirc$1,
        icirc: icirc$1,
        iexcl: iexcl$1,
        Igrave: Igrave$1,
        igrave: igrave$1,
        iquest: iquest$1,
        Iuml: Iuml$1,
        iuml: iuml$1,
        laquo: laquo$1,
        lt: lt$1,
        LT: LT$1,
        macr: macr$1,
        micro: micro$1,
        middot: middot$1,
        nbsp: nbsp$1,
        not: not$1,
        Ntilde: Ntilde$1,
        ntilde: ntilde$1,
        Oacute: Oacute$1,
        oacute: oacute$1,
        Ocirc: Ocirc$1,
        ocirc: ocirc$1,
        Ograve: Ograve$1,
        ograve: ograve$1,
        ordf: ordf$1,
        ordm: ordm$1,
        Oslash: Oslash$1,
        oslash: oslash$1,
        Otilde: Otilde$1,
        otilde: otilde$1,
        Ouml: Ouml$1,
        ouml: ouml$1,
        para: para$1,
        plusmn: plusmn$1,
        pound: pound$1,
        quot: quot$1,
        QUOT: QUOT$1,
        raquo: raquo$1,
        reg: reg$1,
        REG: REG$1,
        sect: sect$1,
        shy: shy$1,
        sup1: sup1$1,
        sup2: sup2$1,
        sup3: sup3$1,
        szlig: szlig$1,
        THORN: THORN$1,
        thorn: thorn$1,
        times: times$1,
        Uacute: Uacute$1,
        uacute: uacute$1,
        Ucirc: Ucirc$1,
        ucirc: ucirc$1,
        Ugrave: Ugrave$1,
        ugrave: ugrave$1,
        uml: uml$1,
        Uuml: Uuml$1,
        uuml: uuml$1,
        Yacute: Yacute$1,
        yacute: yacute$1,
        yen: yen$1,
        yuml: yuml$1
    };
    var legacy$1 = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        Aacute: Aacute$1,
        aacute: aacute$1,
        Acirc: Acirc$1,
        acirc: acirc$1,
        acute: acute$1,
        AElig: AElig$1,
        aelig: aelig$1,
        Agrave: Agrave$1,
        agrave: agrave$1,
        amp: amp$1,
        AMP: AMP$1,
        Aring: Aring$1,
        aring: aring$1,
        Atilde: Atilde$1,
        atilde: atilde$1,
        Auml: Auml$1,
        auml: auml$1,
        brvbar: brvbar$1,
        Ccedil: Ccedil$1,
        ccedil: ccedil$1,
        cedil: cedil$1,
        cent: cent$1,
        copy: copy$1,
        COPY: COPY$1,
        curren: curren$1,
        deg: deg$1,
        divide: divide$1,
        Eacute: Eacute$1,
        eacute: eacute$1,
        Ecirc: Ecirc$1,
        ecirc: ecirc$1,
        Egrave: Egrave$1,
        egrave: egrave$1,
        ETH: ETH$1,
        eth: eth$1,
        Euml: Euml$1,
        euml: euml$1,
        frac12: frac12$1,
        frac14: frac14$1,
        frac34: frac34$1,
        gt: gt$1,
        GT: GT$1,
        Iacute: Iacute$1,
        iacute: iacute$1,
        Icirc: Icirc$1,
        icirc: icirc$1,
        iexcl: iexcl$1,
        Igrave: Igrave$1,
        igrave: igrave$1,
        iquest: iquest$1,
        Iuml: Iuml$1,
        iuml: iuml$1,
        laquo: laquo$1,
        lt: lt$1,
        LT: LT$1,
        macr: macr$1,
        micro: micro$1,
        middot: middot$1,
        nbsp: nbsp$1,
        not: not$1,
        Ntilde: Ntilde$1,
        ntilde: ntilde$1,
        Oacute: Oacute$1,
        oacute: oacute$1,
        Ocirc: Ocirc$1,
        ocirc: ocirc$1,
        Ograve: Ograve$1,
        ograve: ograve$1,
        ordf: ordf$1,
        ordm: ordm$1,
        Oslash: Oslash$1,
        oslash: oslash$1,
        Otilde: Otilde$1,
        otilde: otilde$1,
        Ouml: Ouml$1,
        ouml: ouml$1,
        para: para$1,
        plusmn: plusmn$1,
        pound: pound$1,
        quot: quot$1,
        QUOT: QUOT$1,
        raquo: raquo$1,
        reg: reg$1,
        REG: REG$1,
        sect: sect$1,
        shy: shy$1,
        sup1: sup1$1,
        sup2: sup2$1,
        sup3: sup3$1,
        szlig: szlig$1,
        THORN: THORN$1,
        thorn: thorn$1,
        times: times$1,
        Uacute: Uacute$1,
        uacute: uacute$1,
        Ucirc: Ucirc$1,
        ucirc: ucirc$1,
        Ugrave: Ugrave$1,
        ugrave: ugrave$1,
        uml: uml$1,
        Uuml: Uuml$1,
        uuml: uuml$1,
        Yacute: Yacute$1,
        yacute: yacute$1,
        yen: yen$1,
        yuml: yuml$1,
        "default": legacy
    });
    var amp$2 = "&";
    var apos$1 = "'";
    var gt$2 = ">";
    var lt$2 = "<";
    var quot$2 = '"';
    var xml = {
        amp: amp$2,
        apos: apos$1,
        gt: gt$2,
        lt: lt$2,
        quot: quot$2
    };
    var xml$1 = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        amp: amp$2,
        apos: apos$1,
        gt: gt$2,
        lt: lt$2,
        quot: quot$2,
        "default": xml
    });
    var decode = {
        "0": 65533,
        "128": 8364,
        "130": 8218,
        "131": 402,
        "132": 8222,
        "133": 8230,
        "134": 8224,
        "135": 8225,
        "136": 710,
        "137": 8240,
        "138": 352,
        "139": 8249,
        "140": 338,
        "142": 381,
        "145": 8216,
        "146": 8217,
        "147": 8220,
        "148": 8221,
        "149": 8226,
        "150": 8211,
        "151": 8212,
        "152": 732,
        "153": 8482,
        "154": 353,
        "155": 8250,
        "156": 339,
        "158": 382,
        "159": 376
    };
    var decode$1 = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        "default": decode
    });
    var require$$0 = getCjsExportFromNamespace(decode$1);
    var decode_codepoint = createCommonjsModule(function(module, exports1) {
        var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
            return mod && mod.__esModule ? mod : {
                "default": mod
            };
        };
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        var decode_json_1 = __importDefault(require$$0);
        // modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
        function decodeCodePoint(codePoint) {
            if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return "\uFFFD";
            if (codePoint in decode_json_1.default) // @ts-ignore
            codePoint = decode_json_1.default[codePoint];
            var output = "";
            if (codePoint > 0xffff) {
                codePoint -= 0x10000;
                output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
                codePoint = 0xdc00 | codePoint & 0x3ff;
            }
            output += String.fromCharCode(codePoint);
            return output;
        }
        exports1.default = decodeCodePoint;
    });
    unwrapExports(decode_codepoint);
    var require$$1 = getCjsExportFromNamespace(entities$1);
    var require$$1$1 = getCjsExportFromNamespace(legacy$1);
    var require$$0$1 = getCjsExportFromNamespace(xml$1);
    var decode$2 = createCommonjsModule(function(module, exports1) {
        var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
            return mod && mod.__esModule ? mod : {
                "default": mod
            };
        };
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        var entities_json_1 = __importDefault(require$$1);
        var legacy_json_1 = __importDefault(require$$1$1);
        var xml_json_1 = __importDefault(require$$0$1);
        var decode_codepoint_1 = __importDefault(decode_codepoint);
        exports1.decodeXML = getStrictDecoder(xml_json_1.default);
        exports1.decodeHTMLStrict = getStrictDecoder(entities_json_1.default);
        function getStrictDecoder(map) {
            var keys = Object.keys(map).join("|");
            var replace = getReplacer(map);
            keys += "|#[xX][\\da-fA-F]+|#\\d+";
            var re = new RegExp("&(?:" + keys + ");", "g");
            return function(str) {
                return String(str).replace(re, replace);
            };
        }
        var sorter = function(a, b) {
            return a < b ? 1 : -1;
        };
        exports1.decodeHTML = function() {
            var legacy = Object.keys(legacy_json_1.default).sort(sorter);
            var keys = Object.keys(entities_json_1.default).sort(sorter);
            for(var i = 0, j = 0; i < keys.length; i++)if (legacy[j] === keys[i]) {
                keys[i] += ";?";
                j++;
            } else keys[i] += ";";
            var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g");
            var replace = getReplacer(entities_json_1.default);
            function replacer(str) {
                if (str.substr(-1) !== ";") str += ";";
                return replace(str);
            }
            //TODO consider creating a merged map
            return function(str) {
                return String(str).replace(re, replacer);
            };
        }();
        function getReplacer(map) {
            return function replace(str) {
                if (str.charAt(1) === "#") {
                    if (str.charAt(2) === "X" || str.charAt(2) === "x") return decode_codepoint_1.default(parseInt(str.substr(3), 16));
                    return decode_codepoint_1.default(parseInt(str.substr(2), 10));
                }
                return map[str.slice(1, -1)];
            };
        }
    });
    unwrapExports(decode$2);
    var decode_1 = decode$2.decodeXML;
    var decode_2 = decode$2.decodeHTMLStrict;
    var decode_3 = decode$2.decodeHTML;
    var encode$1 = createCommonjsModule(function(module, exports1) {
        var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
            return mod && mod.__esModule ? mod : {
                "default": mod
            };
        };
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        var xml_json_1 = __importDefault(require$$0$1);
        var inverseXML = getInverseObj(xml_json_1.default);
        var xmlReplacer = getInverseReplacer(inverseXML);
        exports1.encodeXML = getInverse(inverseXML, xmlReplacer);
        var entities_json_1 = __importDefault(require$$1);
        var inverseHTML = getInverseObj(entities_json_1.default);
        var htmlReplacer = getInverseReplacer(inverseHTML);
        exports1.encodeHTML = getInverse(inverseHTML, htmlReplacer);
        function getInverseObj(obj) {
            return Object.keys(obj).sort().reduce(function(inverse, name) {
                inverse[obj[name]] = "&" + name + ";";
                return inverse;
            }, {});
        }
        function getInverseReplacer(inverse) {
            var single = [];
            var multiple = [];
            Object.keys(inverse).forEach(function(k) {
                return k.length === 1 ? single.push("\\" + k) : multiple.push(k);
            });
            //TODO add ranges
            multiple.unshift("[" + single.join("") + "]");
            return new RegExp(multiple.join("|"), "g");
        }
        var reNonASCII = /[^\0-\x7F]/g;
        var reAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
        function singleCharReplacer(c) {
            return "&#x" + c.charCodeAt(0).toString(16).toUpperCase() + ";";
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
        function astralReplacer(c, _) {
            // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            var high = c.charCodeAt(0);
            var low = c.charCodeAt(1);
            var codePoint = (high - 0xd800) * 0x400 + low - 0xdc00 + 0x10000;
            return "&#x" + codePoint.toString(16).toUpperCase() + ";";
        }
        function getInverse(inverse, re) {
            return function(data) {
                return data.replace(re, function(name) {
                    return inverse[name];
                }).replace(reAstralSymbols, astralReplacer).replace(reNonASCII, singleCharReplacer);
            };
        }
        var reXmlChars = getInverseReplacer(inverseXML);
        function escape(data) {
            return data.replace(reXmlChars, singleCharReplacer).replace(reAstralSymbols, astralReplacer).replace(reNonASCII, singleCharReplacer);
        }
        exports1.escape = escape;
    });
    unwrapExports(encode$1);
    var encode_1$1 = encode$1.encodeXML;
    var encode_2 = encode$1.encodeHTML;
    var encode_3 = encode$1.escape;
    var lib = createCommonjsModule(function(module, exports1) {
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        function decode(data, level) {
            return (!level || level <= 0 ? decode$2.decodeXML : decode$2.decodeHTML)(data);
        }
        exports1.decode = decode;
        function decodeStrict(data, level) {
            return (!level || level <= 0 ? decode$2.decodeXML : decode$2.decodeHTMLStrict)(data);
        }
        exports1.decodeStrict = decodeStrict;
        function encode(data, level) {
            return (!level || level <= 0 ? encode$1.encodeXML : encode$1.encodeHTML)(data);
        }
        exports1.encode = encode;
        var encode_2 = encode$1;
        exports1.encodeXML = encode_2.encodeXML;
        exports1.encodeHTML = encode_2.encodeHTML;
        exports1.escape = encode_2.escape;
        // Legacy aliases
        exports1.encodeHTML4 = encode_2.encodeHTML;
        exports1.encodeHTML5 = encode_2.encodeHTML;
        var decode_2 = decode$2;
        exports1.decodeXML = decode_2.decodeXML;
        exports1.decodeHTML = decode_2.decodeHTML;
        exports1.decodeHTMLStrict = decode_2.decodeHTMLStrict;
        // Legacy aliases
        exports1.decodeHTML4 = decode_2.decodeHTML;
        exports1.decodeHTML5 = decode_2.decodeHTML;
        exports1.decodeHTML4Strict = decode_2.decodeHTMLStrict;
        exports1.decodeHTML5Strict = decode_2.decodeHTMLStrict;
        exports1.decodeXMLStrict = decode_2.decodeXML;
    });
    unwrapExports(lib);
    var lib_1 = lib.decode;
    var lib_2 = lib.decodeStrict;
    var lib_3 = lib.encode;
    var lib_4 = lib.encodeXML;
    var lib_5 = lib.encodeHTML;
    var lib_6 = lib.escape;
    var lib_7 = lib.encodeHTML4;
    var lib_8 = lib.encodeHTML5;
    var lib_9 = lib.decodeXML;
    var lib_10 = lib.decodeHTML;
    var lib_11 = lib.decodeHTMLStrict;
    var lib_12 = lib.decodeHTML4;
    var lib_13 = lib.decodeHTML5;
    var lib_14 = lib.decodeHTML4Strict;
    var lib_15 = lib.decodeHTML5Strict;
    var lib_16 = lib.decodeXMLStrict;
    var C_BACKSLASH = 92;
    var ENTITY = "&(?:#x[a-f0-9]{1,6}|#[0-9]{1,7}|[a-z][a-z0-9]{1,31});";
    var TAGNAME = "[A-Za-z][A-Za-z0-9-]*";
    var ATTRIBUTENAME = "[a-zA-Z_:][a-zA-Z0-9:._-]*";
    var UNQUOTEDVALUE = "[^\"'=<>`\\x00-\\x20]+";
    var SINGLEQUOTEDVALUE = "'[^']*'";
    var DOUBLEQUOTEDVALUE = '"[^"]*"';
    var ATTRIBUTEVALUE = "(?:" + UNQUOTEDVALUE + "|" + SINGLEQUOTEDVALUE + "|" + DOUBLEQUOTEDVALUE + ")";
    var ATTRIBUTEVALUESPEC = "(?:\\s*=\\s*" + ATTRIBUTEVALUE + ")";
    var ATTRIBUTE = "(?:\\s+" + ATTRIBUTENAME + ATTRIBUTEVALUESPEC + "?)";
    var OPENTAG = "<" + TAGNAME + ATTRIBUTE + "*" + "\\s*/?>";
    var CLOSETAG = "</" + TAGNAME + "\\s*[>]";
    var HTMLCOMMENT = "<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->";
    var PROCESSINGINSTRUCTION = "[<][?][\\s\\S]*?[?][>]";
    var DECLARATION = "<![A-Z]+\\s+[^>]*>";
    var CDATA = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>";
    var HTMLTAG = "(?:" + OPENTAG + "|" + CLOSETAG + "|" + HTMLCOMMENT + "|" + PROCESSINGINSTRUCTION + "|" + DECLARATION + "|" + CDATA + ")";
    var reHtmlTag = new RegExp("^" + HTMLTAG);
    var reBackslashOrAmp = /[\\&]/;
    var ESCAPABLE = "[!\"#$%&'()*+,./:;<=>?@[\\\\\\]^_`{|}~-]";
    var reEntityOrEscapedChar = new RegExp("\\\\" + ESCAPABLE + "|" + ENTITY, "gi");
    var XMLSPECIAL = '[&<>"]';
    var reXmlSpecial = new RegExp(XMLSPECIAL, "g");
    var unescapeChar = function(s) {
        if (s.charCodeAt(0) === C_BACKSLASH) return s.charAt(1);
        else return lib_10(s);
    };
    // Replace entities and backslash escapes with literal characters.
    var unescapeString = function(s) {
        if (reBackslashOrAmp.test(s)) return s.replace(reEntityOrEscapedChar, unescapeChar);
        else return s;
    };
    var normalizeURI = function(uri) {
        try {
            return encode_1(uri);
        } catch (err) {
            return uri;
        }
    };
    var replaceUnsafeChar = function(s) {
        switch(s){
            case "&":
                return "&amp;";
            case "<":
                return "&lt;";
            case ">":
                return "&gt;";
            case '"':
                return "&quot;";
            default:
                return s;
        }
    };
    var escapeXml = function(s) {
        if (reXmlSpecial.test(s)) return s.replace(reXmlSpecial, replaceUnsafeChar);
        else return s;
    };
    // derived from https://github.com/mathiasbynens/String.fromCodePoint
    /*! http://mths.be/fromcodepoint v0.2.1 by @mathias */ var _fromCodePoint;
    function fromCodePoint(_) {
        return _fromCodePoint(_);
    }
    if (String.fromCodePoint) _fromCodePoint = function(_) {
        try {
            return String.fromCodePoint(_);
        } catch (e) {
            if (e instanceof RangeError) return String.fromCharCode(0xfffd);
            throw e;
        }
    };
    else {
        var stringFromCharCode = String.fromCharCode;
        var floor = Math.floor;
        _fromCodePoint = function() {
            var MAX_SIZE = 0x4000;
            var codeUnits = [];
            var highSurrogate;
            var lowSurrogate;
            var index = -1;
            var length = arguments.length;
            if (!length) return "";
            var result = "";
            while(++index < length){
                var codePoint = Number(arguments[index]);
                if (!isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
                codePoint < 0 || // not a valid Unicode code point
                codePoint > 0x10ffff || // not a valid Unicode code point
                floor(codePoint) !== codePoint // not an integer
                ) return String.fromCharCode(0xfffd);
                if (codePoint <= 0xffff) // BMP code point
                codeUnits.push(codePoint);
                else {
                    // Astral code point; split in surrogate halves
                    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                    codePoint -= 0x10000;
                    highSurrogate = (codePoint >> 10) + 0xd800;
                    lowSurrogate = codePoint % 0x400 + 0xdc00;
                    codeUnits.push(highSurrogate, lowSurrogate);
                }
                if (index + 1 === length || codeUnits.length > MAX_SIZE) {
                    result += stringFromCharCode.apply(null, codeUnits);
                    codeUnits.length = 0;
                }
            }
            return result;
        };
    }
    /*! http://mths.be/repeat v0.2.0 by @mathias */ if (!String.prototype.repeat) (function() {
        var defineProperty = function() {
            // IE 8 only supports `Object.defineProperty` on DOM elements
            try {
                var object = {};
                var $defineProperty = Object.defineProperty;
                var result = $defineProperty(object, object, object) && $defineProperty;
            } catch (error) {}
            return result;
        }();
        var repeat = function(count) {
            if (this == null) throw TypeError();
            var string = String(this);
            // `ToInteger`
            var n = count ? Number(count) : 0;
            if (n != n) n = 0;
            // Account for out-of-bounds indices
            if (n < 0 || n == Infinity) throw RangeError();
            var result = "";
            while(n){
                if (n % 2 == 1) result += string;
                if (n > 1) string += string;
                n >>= 1;
            }
            return result;
        };
        if (defineProperty) defineProperty(String.prototype, "repeat", {
            "value": repeat,
            "configurable": true,
            "writable": true
        });
        else String.prototype.repeat = repeat;
    })();
    var normalizeURI$1 = normalizeURI;
    var unescapeString$1 = unescapeString;
    // Constants for character codes:
    var C_NEWLINE = 10;
    var C_ASTERISK = 42;
    var C_UNDERSCORE = 95;
    var C_BACKTICK = 96;
    var C_OPEN_BRACKET = 91;
    var C_CLOSE_BRACKET = 93;
    var C_LESSTHAN = 60;
    var C_BANG = 33;
    var C_BACKSLASH$1 = 92;
    var C_AMPERSAND = 38;
    var C_OPEN_PAREN = 40;
    var C_CLOSE_PAREN = 41;
    var C_COLON = 58;
    var C_SINGLEQUOTE = 39;
    var C_DOUBLEQUOTE = 34;
    // Some regexps used in inline parser:
    var ESCAPABLE$1 = ESCAPABLE;
    var ESCAPED_CHAR = "\\\\" + ESCAPABLE$1;
    var ENTITY$1 = ENTITY;
    var reHtmlTag$1 = reHtmlTag;
    var rePunctuation = new RegExp(/[!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E42\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDF3C-\uDF3E]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]/);
    var reLinkTitle = new RegExp('^(?:"(' + ESCAPED_CHAR + '|[^"\\x00])*"' + "|" + "'(" + ESCAPED_CHAR + "|[^'\\x00])*'" + "|" + "\\((" + ESCAPED_CHAR + "|[^()\\x00])*\\))");
    var reLinkDestinationBraces = /^(?:<(?:[^<>\n\\\x00]|\\.)*>)/;
    var reEscapable = new RegExp("^" + ESCAPABLE$1);
    var reEntityHere = new RegExp("^" + ENTITY$1, "i");
    var reTicks = /`+/;
    var reTicksHere = /^`+/;
    var reEllipses = /\.\.\./g;
    var reDash = /--+/g;
    var reEmailAutolink = /^<([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)>/;
    var reAutolink = /^<[A-Za-z][A-Za-z0-9.+-]{1,31}:[^<>\x00-\x20]*>/i;
    var reSpnl = /^ *(?:\n *)?/;
    var reWhitespaceChar = /^[ \t\n\x0b\x0c\x0d]/;
    var reUnicodeWhitespaceChar = /^\s/;
    var reFinalSpace = / *$/;
    var reInitialSpace = /^ */;
    var reSpaceAtEndOfLine = /^ *(?:\n|$)/;
    var reLinkLabel = /^\[(?:[^\\\[\]]|\\.){0,1000}\]/;
    // Matches a string of non-special characters.
    var reMain = /^[^\n`\[\]\\!<&*_'"]+/m;
    var text = function(s) {
        var node = new Node("text");
        node._literal = s;
        return node;
    };
    // normalize a reference in reference link (remove []s, trim,
    // collapse internal space, unicode case fold.
    // See commonmark/commonmark.js#168.
    var normalizeReference = function(string) {
        return string.slice(1, string.length - 1).trim().replace(/[ \t\r\n]+/, " ").toLowerCase().toUpperCase();
    };
    // INLINE PARSER
    // These are methods of an InlineParser object, defined below.
    // An InlineParser keeps track of a subject (a string to be
    // parsed) and a position in that subject.
    // If re matches at current position in the subject, advance
    // position in subject and return the match; otherwise return null.
    var match = function(re) {
        var m = re.exec(this.subject.slice(this.pos));
        if (m === null) return null;
        else {
            this.pos += m.index + m[0].length;
            return m[0];
        }
    };
    // Returns the code for the character at the current subject position, or -1
    // there are no more characters.
    var peek = function() {
        if (this.pos < this.subject.length) return this.subject.charCodeAt(this.pos);
        else return -1;
    };
    // Parse zero or more space characters, including at most one newline
    var spnl = function() {
        this.match(reSpnl);
        return true;
    };
    // All of the parsers below try to match something at the current position
    // in the subject.  If they succeed in matching anything, they
    // return the inline matched, advancing the subject.
    // Attempt to parse backticks, adding either a backtick code span or a
    // literal sequence of backticks.
    var parseBackticks = function(block) {
        var ticks = this.match(reTicksHere);
        if (ticks === null) return false;
        var afterOpenTicks = this.pos;
        var matched;
        var node;
        var contents;
        while((matched = this.match(reTicks)) !== null)if (matched === ticks) {
            node = new Node("code");
            contents = this.subject.slice(afterOpenTicks, this.pos - ticks.length).replace(/\n/gm, " ");
            if (contents.length > 0 && contents.match(/[^ ]/) !== null && contents[0] == " " && contents[contents.length - 1] == " ") node._literal = contents.slice(1, contents.length - 1);
            else node._literal = contents;
            block.appendChild(node);
            return true;
        }
        // If we got here, we didn't match a closing backtick sequence.
        this.pos = afterOpenTicks;
        block.appendChild(text(ticks));
        return true;
    };
    // Parse a backslash-escaped special character, adding either the escaped
    // character, a hard line break (if the backslash is followed by a newline),
    // or a literal backslash to the block's children.  Assumes current character
    // is a backslash.
    var parseBackslash = function(block) {
        var subj = this.subject;
        var node;
        this.pos += 1;
        if (this.peek() === C_NEWLINE) {
            this.pos += 1;
            node = new Node("linebreak");
            block.appendChild(node);
        } else if (reEscapable.test(subj.charAt(this.pos))) {
            block.appendChild(text(subj.charAt(this.pos)));
            this.pos += 1;
        } else block.appendChild(text("\\"));
        return true;
    };
    // Attempt to parse an autolink (URL or email in pointy brackets).
    var parseAutolink = function(block) {
        var m;
        var dest;
        var node;
        if (m = this.match(reEmailAutolink)) {
            dest = m.slice(1, m.length - 1);
            node = new Node("link");
            node._destination = normalizeURI$1("mailto:" + dest);
            node._title = "";
            node.appendChild(text(dest));
            block.appendChild(node);
            return true;
        } else if (m = this.match(reAutolink)) {
            dest = m.slice(1, m.length - 1);
            node = new Node("link");
            node._destination = normalizeURI$1(dest);
            node._title = "";
            node.appendChild(text(dest));
            block.appendChild(node);
            return true;
        } else return false;
    };
    // Attempt to parse a raw HTML tag.
    var parseHtmlTag = function(block) {
        var m = this.match(reHtmlTag$1);
        if (m === null) return false;
        else {
            var node = new Node("html_inline");
            node._literal = m;
            block.appendChild(node);
            return true;
        }
    };
    // Scan a sequence of characters with code cc, and return information about
    // the number of delimiters and whether they are positioned such that
    // they can open and/or close emphasis or strong emphasis.  A utility
    // function for strong/emph parsing.
    var scanDelims = function(cc) {
        var numdelims = 0;
        var char_before, char_after, cc_after;
        var startpos = this.pos;
        var left_flanking, right_flanking, can_open, can_close;
        var after_is_whitespace, after_is_punctuation, before_is_whitespace, before_is_punctuation;
        if (cc === C_SINGLEQUOTE || cc === C_DOUBLEQUOTE) {
            numdelims++;
            this.pos++;
        } else while(this.peek() === cc){
            numdelims++;
            this.pos++;
        }
        if (numdelims === 0) return null;
        char_before = startpos === 0 ? "\n" : this.subject.charAt(startpos - 1);
        cc_after = this.peek();
        if (cc_after === -1) char_after = "\n";
        else char_after = fromCodePoint(cc_after);
        after_is_whitespace = reUnicodeWhitespaceChar.test(char_after);
        after_is_punctuation = rePunctuation.test(char_after);
        before_is_whitespace = reUnicodeWhitespaceChar.test(char_before);
        before_is_punctuation = rePunctuation.test(char_before);
        left_flanking = !after_is_whitespace && (!after_is_punctuation || before_is_whitespace || before_is_punctuation);
        right_flanking = !before_is_whitespace && (!before_is_punctuation || after_is_whitespace || after_is_punctuation);
        if (cc === C_UNDERSCORE) {
            can_open = left_flanking && (!right_flanking || before_is_punctuation);
            can_close = right_flanking && (!left_flanking || after_is_punctuation);
        } else if (cc === C_SINGLEQUOTE || cc === C_DOUBLEQUOTE) {
            can_open = left_flanking && !right_flanking;
            can_close = right_flanking;
        } else {
            can_open = left_flanking;
            can_close = right_flanking;
        }
        this.pos = startpos;
        return {
            numdelims: numdelims,
            can_open: can_open,
            can_close: can_close
        };
    };
    // Handle a delimiter marker for emphasis or a quote.
    var handleDelim = function(cc, block) {
        var res = this.scanDelims(cc);
        if (!res) return false;
        var numdelims = res.numdelims;
        var startpos = this.pos;
        var contents;
        this.pos += numdelims;
        if (cc === C_SINGLEQUOTE) contents = "\u2019";
        else if (cc === C_DOUBLEQUOTE) contents = "\u201C";
        else contents = this.subject.slice(startpos, this.pos);
        var node = text(contents);
        block.appendChild(node);
        // Add entry to stack for this opener
        if ((res.can_open || res.can_close) && (this.options.smart || cc !== C_SINGLEQUOTE && cc !== C_DOUBLEQUOTE)) {
            this.delimiters = {
                cc: cc,
                numdelims: numdelims,
                origdelims: numdelims,
                node: node,
                previous: this.delimiters,
                next: null,
                can_open: res.can_open,
                can_close: res.can_close
            };
            if (this.delimiters.previous !== null) this.delimiters.previous.next = this.delimiters;
        }
        return true;
    };
    var removeDelimiter = function(delim) {
        if (delim.previous !== null) delim.previous.next = delim.next;
        if (delim.next === null) // top of stack
        this.delimiters = delim.previous;
        else delim.next.previous = delim.previous;
    };
    var removeDelimitersBetween = function(bottom, top) {
        if (bottom.next !== top) {
            bottom.next = top;
            top.previous = bottom;
        }
    };
    var processEmphasis = function(stack_bottom) {
        var opener, closer, old_closer;
        var opener_inl, closer_inl;
        var tempstack;
        var use_delims;
        var tmp, next;
        var opener_found;
        var openers_bottom = [
            [],
            [],
            []
        ];
        var odd_match = false;
        for(var i = 0; i < 3; i++){
            openers_bottom[i][C_UNDERSCORE] = stack_bottom;
            openers_bottom[i][C_ASTERISK] = stack_bottom;
            openers_bottom[i][C_SINGLEQUOTE] = stack_bottom;
            openers_bottom[i][C_DOUBLEQUOTE] = stack_bottom;
        }
        // find first closer above stack_bottom:
        closer = this.delimiters;
        while(closer !== null && closer.previous !== stack_bottom)closer = closer.previous;
        // move forward, looking for closers, and handling each
        while(closer !== null){
            var closercc = closer.cc;
            if (!closer.can_close) closer = closer.next;
            else {
                // found emphasis closer. now look back for first matching opener:
                opener = closer.previous;
                opener_found = false;
                while(opener !== null && opener !== stack_bottom && opener !== openers_bottom[closer.origdelims % 3][closercc]){
                    odd_match = (closer.can_open || opener.can_close) && closer.origdelims % 3 !== 0 && (opener.origdelims + closer.origdelims) % 3 === 0;
                    if (opener.cc === closer.cc && opener.can_open && !odd_match) {
                        opener_found = true;
                        break;
                    }
                    opener = opener.previous;
                }
                old_closer = closer;
                if (closercc === C_ASTERISK || closercc === C_UNDERSCORE) {
                    if (!opener_found) closer = closer.next;
                    else {
                        // calculate actual number of delimiters used from closer
                        use_delims = closer.numdelims >= 2 && opener.numdelims >= 2 ? 2 : 1;
                        opener_inl = opener.node;
                        closer_inl = closer.node;
                        // remove used delimiters from stack elts and inlines
                        opener.numdelims -= use_delims;
                        closer.numdelims -= use_delims;
                        opener_inl._literal = opener_inl._literal.slice(0, opener_inl._literal.length - use_delims);
                        closer_inl._literal = closer_inl._literal.slice(0, closer_inl._literal.length - use_delims);
                        // build contents for new emph element
                        var emph = new Node(use_delims === 1 ? "emph" : "strong");
                        tmp = opener_inl._next;
                        while(tmp && tmp !== closer_inl){
                            next = tmp._next;
                            tmp.unlink();
                            emph.appendChild(tmp);
                            tmp = next;
                        }
                        opener_inl.insertAfter(emph);
                        // remove elts between opener and closer in delimiters stack
                        removeDelimitersBetween(opener, closer);
                        // if opener has 0 delims, remove it and the inline
                        if (opener.numdelims === 0) {
                            opener_inl.unlink();
                            this.removeDelimiter(opener);
                        }
                        if (closer.numdelims === 0) {
                            closer_inl.unlink();
                            tempstack = closer.next;
                            this.removeDelimiter(closer);
                            closer = tempstack;
                        }
                    }
                } else if (closercc === C_SINGLEQUOTE) {
                    closer.node._literal = "\u2019";
                    if (opener_found) opener.node._literal = "\u2018";
                    closer = closer.next;
                } else if (closercc === C_DOUBLEQUOTE) {
                    closer.node._literal = "\u201D";
                    if (opener_found) opener.node.literal = "\u201C";
                    closer = closer.next;
                }
                if (!opener_found) {
                    // Set lower bound for future searches for openers:
                    openers_bottom[old_closer.origdelims % 3][closercc] = old_closer.previous;
                    if (!old_closer.can_open) // We can remove a closer that can't be an opener,
                    // once we've seen there's no matching opener:
                    this.removeDelimiter(old_closer);
                }
            }
        }
        // remove all delimiters
        while(this.delimiters !== null && this.delimiters !== stack_bottom)this.removeDelimiter(this.delimiters);
    };
    // Attempt to parse link title (sans quotes), returning the string
    // or null if no match.
    var parseLinkTitle = function() {
        var title = this.match(reLinkTitle);
        if (title === null) return null;
        else // chop off quotes from title and unescape:
        return unescapeString$1(title.substr(1, title.length - 2));
    };
    // Attempt to parse link destination, returning the string or
    // null if no match.
    var parseLinkDestination = function() {
        var res = this.match(reLinkDestinationBraces);
        if (res === null) {
            if (this.peek() === C_LESSTHAN) return null;
            // TODO handrolled parser; res should be null or the string
            var savepos = this.pos;
            var openparens = 0;
            var c;
            while((c = this.peek()) !== -1){
                if (c === C_BACKSLASH$1 && reEscapable.test(this.subject.charAt(this.pos + 1))) {
                    this.pos += 1;
                    if (this.peek() !== -1) this.pos += 1;
                } else if (c === C_OPEN_PAREN) {
                    this.pos += 1;
                    openparens += 1;
                } else if (c === C_CLOSE_PAREN) {
                    if (openparens < 1) break;
                    else {
                        this.pos += 1;
                        openparens -= 1;
                    }
                } else if (reWhitespaceChar.exec(fromCodePoint(c)) !== null) break;
                else this.pos += 1;
            }
            if (this.pos === savepos && c !== C_CLOSE_PAREN) return null;
            if (openparens !== 0) return null;
            res = this.subject.substr(savepos, this.pos - savepos);
            return normalizeURI$1(unescapeString$1(res));
        } else // chop off surrounding <..>:
        return normalizeURI$1(unescapeString$1(res.substr(1, res.length - 2)));
    };
    // Attempt to parse a link label, returning number of characters parsed.
    var parseLinkLabel = function() {
        var m = this.match(reLinkLabel);
        if (m === null || m.length > 1001) return 0;
        else return m.length;
    };
    // Add open bracket to delimiter stack and add a text node to block's children.
    var parseOpenBracket = function(block) {
        var startpos = this.pos;
        this.pos += 1;
        var node = text("[");
        block.appendChild(node);
        // Add entry to stack for this opener
        this.addBracket(node, startpos, false);
        return true;
    };
    // IF next character is [, and ! delimiter to delimiter stack and
    // add a text node to block's children.  Otherwise just add a text node.
    var parseBang = function(block) {
        var startpos = this.pos;
        this.pos += 1;
        if (this.peek() === C_OPEN_BRACKET) {
            this.pos += 1;
            var node = text("![");
            block.appendChild(node);
            // Add entry to stack for this opener
            this.addBracket(node, startpos + 1, true);
        } else block.appendChild(text("!"));
        return true;
    };
    // Try to match close bracket against an opening in the delimiter
    // stack.  Add either a link or image, or a plain [ character,
    // to block's children.  If there is a matching delimiter,
    // remove it from the delimiter stack.
    var parseCloseBracket = function(block) {
        var startpos;
        var is_image;
        var dest;
        var title;
        var matched = false;
        var reflabel;
        var opener;
        this.pos += 1;
        startpos = this.pos;
        // get last [ or ![
        opener = this.brackets;
        if (opener === null) {
            // no matched opener, just return a literal
            block.appendChild(text("]"));
            return true;
        }
        if (!opener.active) {
            // no matched opener, just return a literal
            block.appendChild(text("]"));
            // take opener off brackets stack
            this.removeBracket();
            return true;
        }
        // If we got here, open is a potential opener
        is_image = opener.image;
        // Check to see if we have a link/image
        var savepos = this.pos;
        // Inline link?
        if (this.peek() === C_OPEN_PAREN) {
            this.pos++;
            if (this.spnl() && (dest = this.parseLinkDestination()) !== null && this.spnl() && // make sure there's a space before the title:
            (reWhitespaceChar.test(this.subject.charAt(this.pos - 1)) && (title = this.parseLinkTitle()) || true) && this.spnl() && this.peek() === C_CLOSE_PAREN) {
                this.pos += 1;
                matched = true;
            } else this.pos = savepos;
        }
        if (!matched) {
            // Next, see if there's a link label
            var beforelabel = this.pos;
            var n = this.parseLinkLabel();
            if (n > 2) reflabel = this.subject.slice(beforelabel, beforelabel + n);
            else if (!opener.bracketAfter) // Empty or missing second label means to use the first label as the reference.
            // The reference must not contain a bracket. If we know there's a bracket, we don't even bother checking it.
            reflabel = this.subject.slice(opener.index, startpos);
            if (n === 0) // If shortcut reference link, rewind before spaces we skipped.
            this.pos = savepos;
            if (reflabel) {
                // lookup rawlabel in refmap
                var link = this.refmap[normalizeReference(reflabel)];
                if (link) {
                    dest = link.destination;
                    title = link.title;
                    matched = true;
                }
            }
        }
        if (matched) {
            var node = new Node(is_image ? "image" : "link");
            node._destination = dest;
            node._title = title || "";
            var tmp, next;
            tmp = opener.node._next;
            while(tmp){
                next = tmp._next;
                tmp.unlink();
                node.appendChild(tmp);
                tmp = next;
            }
            block.appendChild(node);
            this.processEmphasis(opener.previousDelimiter);
            this.removeBracket();
            opener.node.unlink();
            // We remove this bracket and processEmphasis will remove later delimiters.
            // Now, for a link, we also deactivate earlier link openers.
            // (no links in links)
            if (!is_image) {
                opener = this.brackets;
                while(opener !== null){
                    if (!opener.image) opener.active = false; // deactivate this opener
                    opener = opener.previous;
                }
            }
            return true;
        } else {
            // no match
            this.removeBracket(); // remove this opener from stack
            this.pos = startpos;
            block.appendChild(text("]"));
            return true;
        }
    };
    var addBracket = function(node, index, image) {
        if (this.brackets !== null) this.brackets.bracketAfter = true;
        this.brackets = {
            node: node,
            previous: this.brackets,
            previousDelimiter: this.delimiters,
            index: index,
            image: image,
            active: true
        };
    };
    var removeBracket = function() {
        this.brackets = this.brackets.previous;
    };
    // Attempt to parse an entity.
    var parseEntity = function(block) {
        var m;
        if (m = this.match(reEntityHere)) {
            block.appendChild(text(lib_10(m)));
            return true;
        } else return false;
    };
    // Parse a run of ordinary characters, or a single character with
    // a special meaning in markdown, as a plain string.
    var parseString = function(block) {
        var m;
        if (m = this.match(reMain)) {
            if (this.options.smart) block.appendChild(text(m.replace(reEllipses, "\u2026").replace(reDash, function(chars) {
                var enCount = 0;
                var emCount = 0;
                if (chars.length % 3 === 0) // If divisible by 3, use all em dashes
                emCount = chars.length / 3;
                else if (chars.length % 2 === 0) // If divisible by 2, use all en dashes
                enCount = chars.length / 2;
                else if (chars.length % 3 === 2) {
                    // If 2 extra dashes, use en dash for last 2; em dashes for rest
                    enCount = 1;
                    emCount = (chars.length - 2) / 3;
                } else {
                    // Use en dashes for last 4 hyphens; em dashes for rest
                    enCount = 2;
                    emCount = (chars.length - 4) / 3;
                }
                return "\u2014".repeat(emCount) + "\u2013".repeat(enCount);
            })));
            else block.appendChild(text(m));
            return true;
        } else return false;
    };
    // Parse a newline.  If it was preceded by two spaces, return a hard
    // line break; otherwise a soft line break.
    var parseNewline = function(block) {
        this.pos += 1; // assume we're at a \n
        // check previous node for trailing spaces
        var lastc = block._lastChild;
        if (lastc && lastc.type === "text" && lastc._literal[lastc._literal.length - 1] === " ") {
            var hardbreak = lastc._literal[lastc._literal.length - 2] === " ";
            lastc._literal = lastc._literal.replace(reFinalSpace, "");
            block.appendChild(new Node(hardbreak ? "linebreak" : "softbreak"));
        } else block.appendChild(new Node("softbreak"));
        this.match(reInitialSpace); // gobble leading spaces in next line
        return true;
    };
    // Attempt to parse a link reference, modifying refmap.
    var parseReference = function(s, refmap) {
        this.subject = s;
        this.pos = 0;
        var rawlabel;
        var dest;
        var title;
        var matchChars;
        var startpos = this.pos;
        // label:
        matchChars = this.parseLinkLabel();
        if (matchChars === 0) return 0;
        else rawlabel = this.subject.substr(0, matchChars);
        // colon:
        if (this.peek() === C_COLON) this.pos++;
        else {
            this.pos = startpos;
            return 0;
        }
        //  link url
        this.spnl();
        dest = this.parseLinkDestination();
        if (dest === null) {
            this.pos = startpos;
            return 0;
        }
        var beforetitle = this.pos;
        this.spnl();
        if (this.pos !== beforetitle) title = this.parseLinkTitle();
        if (title === null) {
            title = "";
            // rewind before spaces
            this.pos = beforetitle;
        }
        // make sure we're at line end:
        var atLineEnd = true;
        if (this.match(reSpaceAtEndOfLine) === null) {
            if (title === "") atLineEnd = false;
            else {
                // the potential title we found is not at the line end,
                // but it could still be a legal link reference if we
                // discard the title
                title = "";
                // rewind before spaces
                this.pos = beforetitle;
                // and instead check if the link URL is at the line end
                atLineEnd = this.match(reSpaceAtEndOfLine) !== null;
            }
        }
        if (!atLineEnd) {
            this.pos = startpos;
            return 0;
        }
        var normlabel = normalizeReference(rawlabel);
        if (normlabel === "") {
            // label must contain non-whitespace characters
            this.pos = startpos;
            return 0;
        }
        if (!refmap[normlabel]) refmap[normlabel] = {
            destination: dest,
            title: title
        };
        return this.pos - startpos;
    };
    // Parse the next inline element in subject, advancing subject position.
    // On success, add the result to block's children and return true.
    // On failure, return false.
    var parseInline = function(block) {
        var res = false;
        var c = this.peek();
        if (c === -1) return false;
        switch(c){
            case C_NEWLINE:
                res = this.parseNewline(block);
                break;
            case C_BACKSLASH$1:
                res = this.parseBackslash(block);
                break;
            case C_BACKTICK:
                res = this.parseBackticks(block);
                break;
            case C_ASTERISK:
            case C_UNDERSCORE:
                res = this.handleDelim(c, block);
                break;
            case C_SINGLEQUOTE:
            case C_DOUBLEQUOTE:
                res = this.options.smart && this.handleDelim(c, block);
                break;
            case C_OPEN_BRACKET:
                res = this.parseOpenBracket(block);
                break;
            case C_BANG:
                res = this.parseBang(block);
                break;
            case C_CLOSE_BRACKET:
                res = this.parseCloseBracket(block);
                break;
            case C_LESSTHAN:
                res = this.parseAutolink(block) || this.parseHtmlTag(block);
                break;
            case C_AMPERSAND:
                res = this.parseEntity(block);
                break;
            default:
                res = this.parseString(block);
                break;
        }
        if (!res) {
            this.pos += 1;
            block.appendChild(text(fromCodePoint(c)));
        }
        return true;
    };
    // Parse string content in block into inline children,
    // using refmap to resolve references.
    var parseInlines = function(block) {
        this.subject = block._string_content.trim();
        this.pos = 0;
        this.delimiters = null;
        this.brackets = null;
        while(this.parseInline(block));
        block._string_content = null; // allow raw string to be garbage collected
        this.processEmphasis(null);
    };
    // The InlineParser object.
    function InlineParser(options) {
        return {
            subject: "",
            delimiters: null,
            brackets: null,
            pos: 0,
            refmap: {},
            match: match,
            peek: peek,
            spnl: spnl,
            parseBackticks: parseBackticks,
            parseBackslash: parseBackslash,
            parseAutolink: parseAutolink,
            parseHtmlTag: parseHtmlTag,
            scanDelims: scanDelims,
            handleDelim: handleDelim,
            parseLinkTitle: parseLinkTitle,
            parseLinkDestination: parseLinkDestination,
            parseLinkLabel: parseLinkLabel,
            parseOpenBracket: parseOpenBracket,
            parseBang: parseBang,
            parseCloseBracket: parseCloseBracket,
            addBracket: addBracket,
            removeBracket: removeBracket,
            parseEntity: parseEntity,
            parseString: parseString,
            parseNewline: parseNewline,
            parseReference: parseReference,
            parseInline: parseInline,
            processEmphasis: processEmphasis,
            removeDelimiter: removeDelimiter,
            options: options || {},
            parse: parseInlines
        };
    }
    var CODE_INDENT = 4;
    var C_TAB = 9;
    var C_NEWLINE$1 = 10;
    var C_GREATERTHAN = 62;
    var C_LESSTHAN$1 = 60;
    var C_SPACE = 32;
    var C_OPEN_BRACKET$1 = 91;
    var reHtmlBlockOpen = [
        /./,
        /^<(?:script|pre|textarea|style)(?:\s|>|$)/i,
        /^<!--/,
        /^<[?]/,
        /^<![A-Z]/,
        /^<!\[CDATA\[/,
        /^<[/]?(?:address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[123456]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul)(?:\s|[/]?[>]|$)/i,
        new RegExp("^(?:" + OPENTAG + "|" + CLOSETAG + ")\\s*$", "i")
    ];
    var reHtmlBlockClose = [
        /./,
        /<\/(?:script|pre|textarea|style)>/i,
        /-->/,
        /\?>/,
        />/,
        /\]\]>/
    ];
    var reThematicBreak = /^(?:(?:\*[ \t]*){3,}|(?:_[ \t]*){3,}|(?:-[ \t]*){3,})[ \t]*$/;
    var reMaybeSpecial = /^[#`~*+_=<>0-9-]/;
    var reNonSpace = /[^ \t\f\v\r\n]/;
    var reBulletListMarker = /^[*+-]/;
    var reOrderedListMarker = /^(\d{1,9})([.)])/;
    var reATXHeadingMarker = /^#{1,6}(?:[ \t]+|$)/;
    var reCodeFence = /^`{3,}(?!.*`)|^~{3,}/;
    var reClosingCodeFence = /^(?:`{3,}|~{3,})(?= *$)/;
    var reSetextHeadingLine = /^(?:=+|-+)[ \t]*$/;
    var reLineEnding = /\r\n|\n|\r/;
    // Returns true if string contains only space characters.
    var isBlank = function(s) {
        return !reNonSpace.test(s);
    };
    var isSpaceOrTab = function(c) {
        return c === C_SPACE || c === C_TAB;
    };
    var peek$1 = function(ln, pos) {
        if (pos < ln.length) return ln.charCodeAt(pos);
        else return -1;
    };
    // DOC PARSER
    // These are methods of a Parser object, defined below.
    // Returns true if block ends with a blank line, descending if needed
    // into lists and sublists.
    var endsWithBlankLine = function(block) {
        while(block){
            if (block._lastLineBlank) return true;
            var t = block.type;
            if (!block._lastLineChecked && (t === "list" || t === "item")) {
                block._lastLineChecked = true;
                block = block._lastChild;
            } else {
                block._lastLineChecked = true;
                break;
            }
        }
        return false;
    };
    // Add a line to the block at the tip.  We assume the tip
    // can accept lines -- that check should be done before calling this.
    var addLine = function() {
        if (this.partiallyConsumedTab) {
            this.offset += 1; // skip over tab
            // add space characters:
            var charsToTab = 4 - this.column % 4;
            this.tip._string_content += " ".repeat(charsToTab);
        }
        this.tip._string_content += this.currentLine.slice(this.offset) + "\n";
    };
    // Add block of type tag as a child of the tip.  If the tip can't
    // accept children, close and finalize it and try its parent,
    // and so on til we find a block that can accept children.
    var addChild = function(tag, offset) {
        while(!this.blocks[this.tip.type].canContain(tag))this.finalize(this.tip, this.lineNumber - 1);
        var column_number = offset + 1; // offset 0 = column 1
        var newBlock = new Node(tag, [
            [
                this.lineNumber,
                column_number
            ],
            [
                0,
                0
            ]
        ]);
        newBlock._string_content = "";
        this.tip.appendChild(newBlock);
        this.tip = newBlock;
        return newBlock;
    };
    // Parse a list marker and return data on the marker (type,
    // start, delimiter, bullet character, padding) or null.
    var parseListMarker = function(parser, container) {
        var rest = parser.currentLine.slice(parser.nextNonspace);
        var match;
        var nextc;
        var spacesStartCol;
        var spacesStartOffset;
        var data = {
            type: null,
            tight: true,
            bulletChar: null,
            start: null,
            delimiter: null,
            padding: null,
            markerOffset: parser.indent
        };
        if (parser.indent >= 4) return null;
        if (match = rest.match(reBulletListMarker)) {
            data.type = "bullet";
            data.bulletChar = match[0][0];
        } else if ((match = rest.match(reOrderedListMarker)) && (container.type !== "paragraph" || match[1] === "1")) {
            data.type = "ordered";
            data.start = parseInt(match[1]);
            data.delimiter = match[2];
        } else return null;
        // make sure we have spaces after
        nextc = peek$1(parser.currentLine, parser.nextNonspace + match[0].length);
        if (!(nextc === -1 || nextc === C_TAB || nextc === C_SPACE)) return null;
        // if it interrupts paragraph, make sure first line isn't blank
        if (container.type === "paragraph" && !parser.currentLine.slice(parser.nextNonspace + match[0].length).match(reNonSpace)) return null;
        // we've got a match! advance offset and calculate padding
        parser.advanceNextNonspace(); // to start of marker
        parser.advanceOffset(match[0].length, true); // to end of marker
        spacesStartCol = parser.column;
        spacesStartOffset = parser.offset;
        do {
            parser.advanceOffset(1, true);
            nextc = peek$1(parser.currentLine, parser.offset);
        }while (parser.column - spacesStartCol < 5 && isSpaceOrTab(nextc));
        var blank_item = peek$1(parser.currentLine, parser.offset) === -1;
        var spaces_after_marker = parser.column - spacesStartCol;
        if (spaces_after_marker >= 5 || spaces_after_marker < 1 || blank_item) {
            data.padding = match[0].length + 1;
            parser.column = spacesStartCol;
            parser.offset = spacesStartOffset;
            if (isSpaceOrTab(peek$1(parser.currentLine, parser.offset))) parser.advanceOffset(1, true);
        } else data.padding = match[0].length + spaces_after_marker;
        return data;
    };
    // Returns true if the two list items are of the same type,
    // with the same delimiter and bullet character.  This is used
    // in agglomerating list items into lists.
    var listsMatch = function(list_data, item_data) {
        return list_data.type === item_data.type && list_data.delimiter === item_data.delimiter && list_data.bulletChar === item_data.bulletChar;
    };
    // Finalize and close any unmatched blocks.
    var closeUnmatchedBlocks = function() {
        if (!this.allClosed) {
            // finalize any blocks not matched
            while(this.oldtip !== this.lastMatchedContainer){
                var parent = this.oldtip._parent;
                this.finalize(this.oldtip, this.lineNumber - 1);
                this.oldtip = parent;
            }
            this.allClosed = true;
        }
    };
    // 'finalize' is run when the block is closed.
    // 'continue' is run to check whether the block is continuing
    // at a certain line and offset (e.g. whether a block quote
    // contains a `>`.  It returns 0 for matched, 1 for not matched,
    // and 2 for "we've dealt with this line completely, go to next."
    var blocks = {
        document: {
            continue: function() {
                return 0;
            },
            finalize: function() {
                return;
            },
            canContain: function(t) {
                return t !== "item";
            },
            acceptsLines: false
        },
        list: {
            continue: function() {
                return 0;
            },
            finalize: function(parser, block) {
                var item = block._firstChild;
                while(item){
                    // check for non-final list item ending with blank line:
                    if (endsWithBlankLine(item) && item._next) {
                        block._listData.tight = false;
                        break;
                    }
                    // recurse into children of list item, to see if there are
                    // spaces between any of them:
                    var subitem = item._firstChild;
                    while(subitem){
                        if (endsWithBlankLine(subitem) && (item._next || subitem._next)) {
                            block._listData.tight = false;
                            break;
                        }
                        subitem = subitem._next;
                    }
                    item = item._next;
                }
            },
            canContain: function(t) {
                return t === "item";
            },
            acceptsLines: false
        },
        block_quote: {
            continue: function(parser) {
                var ln = parser.currentLine;
                if (!parser.indented && peek$1(ln, parser.nextNonspace) === C_GREATERTHAN) {
                    parser.advanceNextNonspace();
                    parser.advanceOffset(1, false);
                    if (isSpaceOrTab(peek$1(ln, parser.offset))) parser.advanceOffset(1, true);
                } else return 1;
                return 0;
            },
            finalize: function() {
                return;
            },
            canContain: function(t) {
                return t !== "item";
            },
            acceptsLines: false
        },
        item: {
            continue: function(parser, container) {
                if (parser.blank) {
                    if (container._firstChild == null) // Blank line after empty list item
                    return 1;
                    else parser.advanceNextNonspace();
                } else if (parser.indent >= container._listData.markerOffset + container._listData.padding) parser.advanceOffset(container._listData.markerOffset + container._listData.padding, true);
                else return 1;
                return 0;
            },
            finalize: function() {
                return;
            },
            canContain: function(t) {
                return t !== "item";
            },
            acceptsLines: false
        },
        heading: {
            continue: function() {
                // a heading can never container > 1 line, so fail to match:
                return 1;
            },
            finalize: function() {
                return;
            },
            canContain: function() {
                return false;
            },
            acceptsLines: false
        },
        thematic_break: {
            continue: function() {
                // a thematic break can never container > 1 line, so fail to match:
                return 1;
            },
            finalize: function() {
                return;
            },
            canContain: function() {
                return false;
            },
            acceptsLines: false
        },
        code_block: {
            continue: function(parser, container) {
                var ln = parser.currentLine;
                var indent = parser.indent;
                if (container._isFenced) {
                    // fenced
                    var match = indent <= 3 && ln.charAt(parser.nextNonspace) === container._fenceChar && ln.slice(parser.nextNonspace).match(reClosingCodeFence);
                    if (match && match[0].length >= container._fenceLength) {
                        // closing fence - we're at end of line, so we can return
                        parser.lastLineLength = parser.offset + indent + match[0].length;
                        parser.finalize(container, parser.lineNumber);
                        return 2;
                    } else {
                        // skip optional spaces of fence offset
                        var i = container._fenceOffset;
                        while(i > 0 && isSpaceOrTab(peek$1(ln, parser.offset))){
                            parser.advanceOffset(1, true);
                            i--;
                        }
                    }
                } else {
                    // indented
                    if (indent >= CODE_INDENT) parser.advanceOffset(CODE_INDENT, true);
                    else if (parser.blank) parser.advanceNextNonspace();
                    else return 1;
                }
                return 0;
            },
            finalize: function(parser, block) {
                if (block._isFenced) {
                    // fenced
                    // first line becomes info string
                    var content = block._string_content;
                    var newlinePos = content.indexOf("\n");
                    var firstLine = content.slice(0, newlinePos);
                    var rest = content.slice(newlinePos + 1);
                    block.info = unescapeString(firstLine.trim());
                    block._literal = rest;
                } else // indented
                block._literal = block._string_content.replace(/(\n *)+$/, "\n");
                block._string_content = null; // allow GC
            },
            canContain: function() {
                return false;
            },
            acceptsLines: true
        },
        html_block: {
            continue: function(parser, container) {
                return parser.blank && (container._htmlBlockType === 6 || container._htmlBlockType === 7) ? 1 : 0;
            },
            finalize: function(parser, block) {
                block._literal = block._string_content.replace(/(\n *)+$/, "");
                block._string_content = null; // allow GC
            },
            canContain: function() {
                return false;
            },
            acceptsLines: true
        },
        paragraph: {
            continue: function(parser) {
                return parser.blank ? 1 : 0;
            },
            finalize: function(parser, block) {
                var pos;
                var hasReferenceDefs = false;
                // try parsing the beginning as link reference definitions:
                while(peek$1(block._string_content, 0) === C_OPEN_BRACKET$1 && (pos = parser.inlineParser.parseReference(block._string_content, parser.refmap))){
                    block._string_content = block._string_content.slice(pos);
                    hasReferenceDefs = true;
                }
                if (hasReferenceDefs && isBlank(block._string_content)) block.unlink();
            },
            canContain: function() {
                return false;
            },
            acceptsLines: true
        }
    };
    // block start functions.  Return values:
    // 0 = no match
    // 1 = matched container, keep going
    // 2 = matched leaf, no more block starts
    var blockStarts = [
        // block quote
        function(parser) {
            if (!parser.indented && peek$1(parser.currentLine, parser.nextNonspace) === C_GREATERTHAN) {
                parser.advanceNextNonspace();
                parser.advanceOffset(1, false);
                // optional following space
                if (isSpaceOrTab(peek$1(parser.currentLine, parser.offset))) parser.advanceOffset(1, true);
                parser.closeUnmatchedBlocks();
                parser.addChild("block_quote", parser.nextNonspace);
                return 1;
            } else return 0;
        },
        // ATX heading
        function(parser) {
            var match;
            if (!parser.indented && (match = parser.currentLine.slice(parser.nextNonspace).match(reATXHeadingMarker))) {
                parser.advanceNextNonspace();
                parser.advanceOffset(match[0].length, false);
                parser.closeUnmatchedBlocks();
                var container = parser.addChild("heading", parser.nextNonspace);
                container.level = match[0].trim().length; // number of #s
                // remove trailing ###s:
                container._string_content = parser.currentLine.slice(parser.offset).replace(/^[ \t]*#+[ \t]*$/, "").replace(/[ \t]+#+[ \t]*$/, "");
                parser.advanceOffset(parser.currentLine.length - parser.offset);
                return 2;
            } else return 0;
        },
        // Fenced code block
        function(parser) {
            var match;
            if (!parser.indented && (match = parser.currentLine.slice(parser.nextNonspace).match(reCodeFence))) {
                var fenceLength = match[0].length;
                parser.closeUnmatchedBlocks();
                var container = parser.addChild("code_block", parser.nextNonspace);
                container._isFenced = true;
                container._fenceLength = fenceLength;
                container._fenceChar = match[0][0];
                container._fenceOffset = parser.indent;
                parser.advanceNextNonspace();
                parser.advanceOffset(fenceLength, false);
                return 2;
            } else return 0;
        },
        // HTML block
        function(parser, container) {
            if (!parser.indented && peek$1(parser.currentLine, parser.nextNonspace) === C_LESSTHAN$1) {
                var s = parser.currentLine.slice(parser.nextNonspace);
                var blockType;
                for(blockType = 1; blockType <= 7; blockType++)if (reHtmlBlockOpen[blockType].test(s) && (blockType < 7 || container.type !== "paragraph")) {
                    parser.closeUnmatchedBlocks();
                    // We don't adjust parser.offset;
                    // spaces are part of the HTML block:
                    var b = parser.addChild("html_block", parser.offset);
                    b._htmlBlockType = blockType;
                    return 2;
                }
            }
            return 0;
        },
        // Setext heading
        function(parser, container) {
            var match;
            if (!parser.indented && container.type === "paragraph" && (match = parser.currentLine.slice(parser.nextNonspace).match(reSetextHeadingLine))) {
                parser.closeUnmatchedBlocks();
                // resolve reference link definitiosn
                var pos;
                while(peek$1(container._string_content, 0) === C_OPEN_BRACKET$1 && (pos = parser.inlineParser.parseReference(container._string_content, parser.refmap)))container._string_content = container._string_content.slice(pos);
                if (container._string_content.length > 0) {
                    var heading = new Node("heading", container.sourcepos);
                    heading.level = match[0][0] === "=" ? 1 : 2;
                    heading._string_content = container._string_content;
                    container.insertAfter(heading);
                    container.unlink();
                    parser.tip = heading;
                    parser.advanceOffset(parser.currentLine.length - parser.offset, false);
                    return 2;
                } else return 0;
            } else return 0;
        },
        // thematic break
        function(parser) {
            if (!parser.indented && reThematicBreak.test(parser.currentLine.slice(parser.nextNonspace))) {
                parser.closeUnmatchedBlocks();
                parser.addChild("thematic_break", parser.nextNonspace);
                parser.advanceOffset(parser.currentLine.length - parser.offset, false);
                return 2;
            } else return 0;
        },
        // list item
        function(parser, container) {
            var data;
            if ((!parser.indented || container.type === "list") && (data = parseListMarker(parser, container))) {
                parser.closeUnmatchedBlocks();
                // add the list if needed
                if (parser.tip.type !== "list" || !listsMatch(container._listData, data)) {
                    container = parser.addChild("list", parser.nextNonspace);
                    container._listData = data;
                }
                // add the list item
                container = parser.addChild("item", parser.nextNonspace);
                container._listData = data;
                return 1;
            } else return 0;
        },
        // indented code block
        function(parser) {
            if (parser.indented && parser.tip.type !== "paragraph" && !parser.blank) {
                // indented code
                parser.advanceOffset(CODE_INDENT, true);
                parser.closeUnmatchedBlocks();
                parser.addChild("code_block", parser.offset);
                return 2;
            } else return 0;
        }
    ];
    var advanceOffset = function(count, columns) {
        var currentLine = this.currentLine;
        var charsToTab, charsToAdvance;
        var c;
        while(count > 0 && (c = currentLine[this.offset]))if (c === "	") {
            charsToTab = 4 - this.column % 4;
            if (columns) {
                this.partiallyConsumedTab = charsToTab > count;
                charsToAdvance = charsToTab > count ? count : charsToTab;
                this.column += charsToAdvance;
                this.offset += this.partiallyConsumedTab ? 0 : 1;
                count -= charsToAdvance;
            } else {
                this.partiallyConsumedTab = false;
                this.column += charsToTab;
                this.offset += 1;
                count -= 1;
            }
        } else {
            this.partiallyConsumedTab = false;
            this.offset += 1;
            this.column += 1; // assume ascii; block starts are ascii
            count -= 1;
        }
    };
    var advanceNextNonspace = function() {
        this.offset = this.nextNonspace;
        this.column = this.nextNonspaceColumn;
        this.partiallyConsumedTab = false;
    };
    var findNextNonspace = function() {
        var currentLine = this.currentLine;
        var i = this.offset;
        var cols = this.column;
        var c;
        while((c = currentLine.charAt(i)) !== ""){
            if (c === " ") {
                i++;
                cols++;
            } else if (c === "	") {
                i++;
                cols += 4 - cols % 4;
            } else break;
        }
        this.blank = c === "\n" || c === "\r" || c === "";
        this.nextNonspace = i;
        this.nextNonspaceColumn = cols;
        this.indent = this.nextNonspaceColumn - this.column;
        this.indented = this.indent >= CODE_INDENT;
    };
    // Analyze a line of text and update the document appropriately.
    // We parse markdown text by calling this on each line of input,
    // then finalizing the document.
    var incorporateLine = function(ln) {
        var all_matched = true;
        var t;
        var container = this.doc;
        this.oldtip = this.tip;
        this.offset = 0;
        this.column = 0;
        this.blank = false;
        this.partiallyConsumedTab = false;
        this.lineNumber += 1;
        // replace NUL characters for security
        if (ln.indexOf("\0") !== -1) ln = ln.replace(/\0/g, "\uFFFD");
        this.currentLine = ln;
        // For each containing block, try to parse the associated line start.
        // Bail out on failure: container will point to the last matching block.
        // Set all_matched to false if not all containers match.
        var lastChild;
        while((lastChild = container._lastChild) && lastChild._open){
            container = lastChild;
            this.findNextNonspace();
            switch(this.blocks[container.type].continue(this, container)){
                case 0:
                    break;
                case 1:
                    all_matched = false;
                    break;
                case 2:
                    return;
                default:
                    throw "continue returned illegal value, must be 0, 1, or 2";
            }
            if (!all_matched) {
                container = container._parent; // back up to last matching block
                break;
            }
        }
        this.allClosed = container === this.oldtip;
        this.lastMatchedContainer = container;
        var matchedLeaf = container.type !== "paragraph" && blocks[container.type].acceptsLines;
        var starts = this.blockStarts;
        var startsLen = starts.length;
        // Unless last matched container is a code block, try new container starts,
        // adding children to the last matched container:
        while(!matchedLeaf){
            this.findNextNonspace();
            // this is a little performance optimization:
            if (!this.indented && !reMaybeSpecial.test(ln.slice(this.nextNonspace))) {
                this.advanceNextNonspace();
                break;
            }
            var i = 0;
            while(i < startsLen){
                var res = starts[i](this, container);
                if (res === 1) {
                    container = this.tip;
                    break;
                } else if (res === 2) {
                    container = this.tip;
                    matchedLeaf = true;
                    break;
                } else i++;
            }
            if (i === startsLen) {
                // nothing matched
                this.advanceNextNonspace();
                break;
            }
        }
        // What remains at the offset is a text line.  Add the text to the
        // appropriate container.
        // First check for a lazy paragraph continuation:
        if (!this.allClosed && !this.blank && this.tip.type === "paragraph") // lazy paragraph continuation
        this.addLine();
        else {
            // not a lazy continuation
            // finalize any blocks not matched
            this.closeUnmatchedBlocks();
            if (this.blank && container.lastChild) container.lastChild._lastLineBlank = true;
            t = container.type;
            // Block quote lines are never blank as they start with >
            // and we don't count blanks in fenced code for purposes of tight/loose
            // lists or breaking out of lists.  We also don't set _lastLineBlank
            // on an empty list item, or if we just closed a fenced block.
            var lastLineBlank = this.blank && !(t === "block_quote" || t === "code_block" && container._isFenced || t === "item" && !container._firstChild && container.sourcepos[0][0] === this.lineNumber);
            // propagate lastLineBlank up through parents:
            var cont = container;
            while(cont){
                cont._lastLineBlank = lastLineBlank;
                cont = cont._parent;
            }
            if (this.blocks[t].acceptsLines) {
                this.addLine();
                // if HtmlBlock, check for end condition
                if (t === "html_block" && container._htmlBlockType >= 1 && container._htmlBlockType <= 5 && reHtmlBlockClose[container._htmlBlockType].test(this.currentLine.slice(this.offset))) {
                    this.lastLineLength = ln.length;
                    this.finalize(container, this.lineNumber);
                }
            } else if (this.offset < ln.length && !this.blank) {
                // create paragraph container for line
                container = this.addChild("paragraph", this.offset);
                this.advanceNextNonspace();
                this.addLine();
            }
        }
        this.lastLineLength = ln.length;
    };
    // Finalize a block.  Close it and do any necessary postprocessing,
    // e.g. creating string_content from strings, setting the 'tight'
    // or 'loose' status of a list, and parsing the beginnings
    // of paragraphs for reference definitions.  Reset the tip to the
    // parent of the closed block.
    var finalize = function(block, lineNumber) {
        var above = block._parent;
        block._open = false;
        block.sourcepos[1] = [
            lineNumber,
            this.lastLineLength
        ];
        this.blocks[block.type].finalize(this, block);
        this.tip = above;
    };
    // Walk through a block & children recursively, parsing string content
    // into inline content where appropriate.
    var processInlines = function(block) {
        var node, event, t;
        var walker = block.walker();
        this.inlineParser.refmap = this.refmap;
        this.inlineParser.options = this.options;
        while(event = walker.next()){
            node = event.node;
            t = node.type;
            if (!event.entering && (t === "paragraph" || t === "heading")) this.inlineParser.parse(node);
        }
    };
    var Document = function() {
        var doc = new Node("document", [
            [
                1,
                1
            ],
            [
                0,
                0
            ]
        ]);
        return doc;
    };
    // The main parsing function.  Returns a parsed document AST.
    var parse = function(input) {
        this.doc = new Document();
        this.tip = this.doc;
        this.refmap = {};
        this.lineNumber = 0;
        this.lastLineLength = 0;
        this.offset = 0;
        this.column = 0;
        this.lastMatchedContainer = this.doc;
        this.currentLine = "";
        if (this.options.time) console.time("preparing input");
        var lines = input.split(reLineEnding);
        var len = lines.length;
        if (input.charCodeAt(input.length - 1) === C_NEWLINE$1) // ignore last blank line created by final newline
        len -= 1;
        if (this.options.time) console.timeEnd("preparing input");
        if (this.options.time) console.time("block parsing");
        for(var i = 0; i < len; i++)this.incorporateLine(lines[i]);
        while(this.tip)this.finalize(this.tip, len);
        if (this.options.time) console.timeEnd("block parsing");
        if (this.options.time) console.time("inline parsing");
        this.processInlines(this.doc);
        if (this.options.time) console.timeEnd("inline parsing");
        return this.doc;
    };
    // The Parser object.
    function Parser(options) {
        return {
            doc: new Document(),
            blocks: blocks,
            blockStarts: blockStarts,
            tip: this.doc,
            oldtip: this.doc,
            currentLine: "",
            lineNumber: 0,
            offset: 0,
            column: 0,
            nextNonspace: 0,
            nextNonspaceColumn: 0,
            indent: 0,
            indented: false,
            blank: false,
            partiallyConsumedTab: false,
            allClosed: true,
            lastMatchedContainer: this.doc,
            refmap: {},
            lastLineLength: 0,
            inlineParser: new InlineParser(options),
            findNextNonspace: findNextNonspace,
            advanceOffset: advanceOffset,
            advanceNextNonspace: advanceNextNonspace,
            addLine: addLine,
            addChild: addChild,
            incorporateLine: incorporateLine,
            finalize: finalize,
            processInlines: processInlines,
            closeUnmatchedBlocks: closeUnmatchedBlocks,
            parse: parse,
            options: options || {}
        };
    }
    function Renderer() {}
    /**
     *  Walks the AST and calls member methods for each Node type.
     *
     *  @param ast {Node} The root of the abstract syntax tree.
     */ function render(ast) {
        var walker = ast.walker(), event, type;
        this.buffer = "";
        this.lastOut = "\n";
        while(event = walker.next()){
            type = event.node.type;
            if (this[type]) this[type](event.node, event.entering);
        }
        return this.buffer;
    }
    /**
     *  Concatenate a literal string to the buffer.
     *
     *  @param str {String} The string to concatenate.
     */ function lit(str) {
        this.buffer += str;
        this.lastOut = str;
    }
    /**
     *  Output a newline to the buffer.
     */ function cr() {
        if (this.lastOut !== "\n") this.lit("\n");
    }
    /**
     *  Concatenate a string to the buffer possibly escaping the content.
     *
     *  Concrete renderer implementations should override this method.
     *
     *  @param str {String} The string to concatenate.
     */ function out(str) {
        this.lit(str);
    }
    /**
     *  Escape a string for the target renderer.
     *
     *  Abstract function that should be implemented by concrete
     *  renderer implementations.
     *
     *  @param str {String} The string to escape.
     */ function esc(str) {
        return str;
    }
    Renderer.prototype.render = render;
    Renderer.prototype.out = out;
    Renderer.prototype.lit = lit;
    Renderer.prototype.cr = cr;
    Renderer.prototype.esc = esc;
    var reUnsafeProtocol = /^javascript:|vbscript:|file:|data:/i;
    var reSafeDataProtocol = /^data:image\/(?:png|gif|jpeg|webp)/i;
    var potentiallyUnsafe = function(url) {
        return reUnsafeProtocol.test(url) && !reSafeDataProtocol.test(url);
    };
    // Helper function to produce an HTML tag.
    function tag(name, attrs, selfclosing) {
        if (this.disableTags > 0) return;
        this.buffer += "<" + name;
        if (attrs && attrs.length > 0) {
            var i = 0;
            var attrib;
            while((attrib = attrs[i]) !== undefined){
                this.buffer += " " + attrib[0] + '="' + attrib[1] + '"';
                i++;
            }
        }
        if (selfclosing) this.buffer += " /";
        this.buffer += ">";
        this.lastOut = ">";
    }
    function HtmlRenderer(options) {
        options = options || {};
        // by default, soft breaks are rendered as newlines in HTML
        options.softbreak = options.softbreak || "\n";
        // set to "<br />" to make them hard breaks
        // set to " " if you want to ignore line wrapping in source
        this.disableTags = 0;
        this.lastOut = "\n";
        this.options = options;
    }
    /* Node methods */ function text$1(node) {
        this.out(node.literal);
    }
    function softbreak() {
        this.lit(this.options.softbreak);
    }
    function linebreak() {
        this.tag("br", [], true);
        this.cr();
    }
    function link(node, entering) {
        var attrs = this.attrs(node);
        if (entering) {
            if (!(this.options.safe && potentiallyUnsafe(node.destination))) attrs.push([
                "href",
                this.esc(node.destination)
            ]);
            if (node.title) attrs.push([
                "title",
                this.esc(node.title)
            ]);
            this.tag("a", attrs);
        } else this.tag("/a");
    }
    function image$1(node, entering) {
        if (entering) {
            if (this.disableTags === 0) {
                if (this.options.safe && potentiallyUnsafe(node.destination)) this.lit('<img src="" alt="');
                else this.lit('<img src="' + this.esc(node.destination) + '" alt="');
            }
            this.disableTags += 1;
        } else {
            this.disableTags -= 1;
            if (this.disableTags === 0) {
                if (node.title) this.lit('" title="' + this.esc(node.title));
                this.lit('" />');
            }
        }
    }
    function emph(node, entering) {
        this.tag(entering ? "em" : "/em");
    }
    function strong(node, entering) {
        this.tag(entering ? "strong" : "/strong");
    }
    function paragraph(node, entering) {
        var grandparent = node.parent.parent, attrs = this.attrs(node);
        if (grandparent !== null && grandparent.type === "list") {
            if (grandparent.listTight) return;
        }
        if (entering) {
            this.cr();
            this.tag("p", attrs);
        } else {
            this.tag("/p");
            this.cr();
        }
    }
    function heading(node, entering) {
        var tagname = "h" + node.level, attrs = this.attrs(node);
        if (entering) {
            this.cr();
            this.tag(tagname, attrs);
        } else {
            this.tag("/" + tagname);
            this.cr();
        }
    }
    function code(node) {
        this.tag("code");
        this.out(node.literal);
        this.tag("/code");
    }
    function code_block(node) {
        var info_words = node.info ? node.info.split(/\s+/) : [], attrs = this.attrs(node);
        if (info_words.length > 0 && info_words[0].length > 0) attrs.push([
            "class",
            "language-" + this.esc(info_words[0])
        ]);
        this.cr();
        this.tag("pre");
        this.tag("code", attrs);
        this.out(node.literal);
        this.tag("/code");
        this.tag("/pre");
        this.cr();
    }
    function thematic_break(node) {
        var attrs = this.attrs(node);
        this.cr();
        this.tag("hr", attrs, true);
        this.cr();
    }
    function block_quote(node, entering) {
        var attrs = this.attrs(node);
        if (entering) {
            this.cr();
            this.tag("blockquote", attrs);
            this.cr();
        } else {
            this.cr();
            this.tag("/blockquote");
            this.cr();
        }
    }
    function list(node, entering) {
        var tagname = node.listType === "bullet" ? "ul" : "ol", attrs = this.attrs(node);
        if (entering) {
            var start = node.listStart;
            if (start !== null && start !== 1) attrs.push([
                "start",
                start.toString()
            ]);
            this.cr();
            this.tag(tagname, attrs);
            this.cr();
        } else {
            this.cr();
            this.tag("/" + tagname);
            this.cr();
        }
    }
    function item(node, entering) {
        var attrs = this.attrs(node);
        if (entering) this.tag("li", attrs);
        else {
            this.tag("/li");
            this.cr();
        }
    }
    function html_inline(node) {
        if (this.options.safe) this.lit("<!-- raw HTML omitted -->");
        else this.lit(node.literal);
    }
    function html_block(node) {
        this.cr();
        if (this.options.safe) this.lit("<!-- raw HTML omitted -->");
        else this.lit(node.literal);
        this.cr();
    }
    function custom_inline(node, entering) {
        if (entering && node.onEnter) this.lit(node.onEnter);
        else if (!entering && node.onExit) this.lit(node.onExit);
    }
    function custom_block(node, entering) {
        this.cr();
        if (entering && node.onEnter) this.lit(node.onEnter);
        else if (!entering && node.onExit) this.lit(node.onExit);
        this.cr();
    }
    /* Helper methods */ function out$1(s) {
        this.lit(this.esc(s));
    }
    function attrs(node) {
        var att = [];
        if (this.options.sourcepos) {
            var pos = node.sourcepos;
            if (pos) att.push([
                "data-sourcepos",
                String(pos[0][0]) + ":" + String(pos[0][1]) + "-" + String(pos[1][0]) + ":" + String(pos[1][1])
            ]);
        }
        return att;
    }
    // quick browser-compatible inheritance
    HtmlRenderer.prototype = Object.create(Renderer.prototype);
    HtmlRenderer.prototype.text = text$1;
    HtmlRenderer.prototype.html_inline = html_inline;
    HtmlRenderer.prototype.html_block = html_block;
    HtmlRenderer.prototype.softbreak = softbreak;
    HtmlRenderer.prototype.linebreak = linebreak;
    HtmlRenderer.prototype.link = link;
    HtmlRenderer.prototype.image = image$1;
    HtmlRenderer.prototype.emph = emph;
    HtmlRenderer.prototype.strong = strong;
    HtmlRenderer.prototype.paragraph = paragraph;
    HtmlRenderer.prototype.heading = heading;
    HtmlRenderer.prototype.code = code;
    HtmlRenderer.prototype.code_block = code_block;
    HtmlRenderer.prototype.thematic_break = thematic_break;
    HtmlRenderer.prototype.block_quote = block_quote;
    HtmlRenderer.prototype.list = list;
    HtmlRenderer.prototype.item = item;
    HtmlRenderer.prototype.custom_inline = custom_inline;
    HtmlRenderer.prototype.custom_block = custom_block;
    HtmlRenderer.prototype.esc = escapeXml;
    HtmlRenderer.prototype.out = out$1;
    HtmlRenderer.prototype.tag = tag;
    HtmlRenderer.prototype.attrs = attrs;
    var reXMLTag = /\<[^>]*\>/;
    function toTagName(s) {
        return s.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();
    }
    function XmlRenderer(options) {
        options = options || {};
        this.disableTags = 0;
        this.lastOut = "\n";
        this.indentLevel = 0;
        this.indent = "  ";
        this.options = options;
    }
    function render$1(ast) {
        this.buffer = "";
        var attrs;
        var tagname;
        var walker = ast.walker();
        var event, node, entering;
        var container;
        var selfClosing;
        var nodetype;
        var options = this.options;
        if (options.time) console.time("rendering");
        this.buffer += '<?xml version="1.0" encoding="UTF-8"?>\n';
        this.buffer += '<!DOCTYPE document SYSTEM "CommonMark.dtd">\n';
        while(event = walker.next()){
            entering = event.entering;
            node = event.node;
            nodetype = node.type;
            container = node.isContainer;
            selfClosing = nodetype === "thematic_break" || nodetype === "linebreak" || nodetype === "softbreak";
            tagname = toTagName(nodetype);
            if (entering) {
                attrs = [];
                switch(nodetype){
                    case "document":
                        attrs.push([
                            "xmlns",
                            "http://commonmark.org/xml/1.0"
                        ]);
                        break;
                    case "list":
                        if (node.listType !== null) attrs.push([
                            "type",
                            node.listType.toLowerCase()
                        ]);
                        if (node.listStart !== null) attrs.push([
                            "start",
                            String(node.listStart)
                        ]);
                        if (node.listTight !== null) attrs.push([
                            "tight",
                            node.listTight ? "true" : "false"
                        ]);
                        var delim = node.listDelimiter;
                        if (delim !== null) {
                            var delimword = "";
                            if (delim === ".") delimword = "period";
                            else delimword = "paren";
                            attrs.push([
                                "delimiter",
                                delimword
                            ]);
                        }
                        break;
                    case "code_block":
                        if (node.info) attrs.push([
                            "info",
                            node.info
                        ]);
                        break;
                    case "heading":
                        attrs.push([
                            "level",
                            String(node.level)
                        ]);
                        break;
                    case "link":
                    case "image":
                        attrs.push([
                            "destination",
                            node.destination
                        ]);
                        attrs.push([
                            "title",
                            node.title
                        ]);
                        break;
                    case "custom_inline":
                    case "custom_block":
                        attrs.push([
                            "on_enter",
                            node.onEnter
                        ]);
                        attrs.push([
                            "on_exit",
                            node.onExit
                        ]);
                        break;
                }
                if (options.sourcepos) {
                    var pos = node.sourcepos;
                    if (pos) attrs.push([
                        "sourcepos",
                        String(pos[0][0]) + ":" + String(pos[0][1]) + "-" + String(pos[1][0]) + ":" + String(pos[1][1])
                    ]);
                }
                this.cr();
                this.out(this.tag(tagname, attrs, selfClosing));
                if (container) this.indentLevel += 1;
                else if (!container && !selfClosing) {
                    var lit = node.literal;
                    if (lit) this.out(this.esc(lit));
                    this.out(this.tag("/" + tagname));
                }
            } else {
                this.indentLevel -= 1;
                this.cr();
                this.out(this.tag("/" + tagname));
            }
        }
        if (options.time) console.timeEnd("rendering");
        this.buffer += "\n";
        return this.buffer;
    }
    function out$2(s) {
        if (this.disableTags > 0) this.buffer += s.replace(reXMLTag, "");
        else this.buffer += s;
        this.lastOut = s;
    }
    function cr$1() {
        if (this.lastOut !== "\n") {
            this.buffer += "\n";
            this.lastOut = "\n";
            for(var i = this.indentLevel; i > 0; i--)this.buffer += this.indent;
        }
    }
    // Helper function to produce an XML tag.
    function tag$1(name, attrs, selfclosing) {
        var result = "<" + name;
        if (attrs && attrs.length > 0) {
            var i = 0;
            var attrib;
            while((attrib = attrs[i]) !== undefined){
                result += " " + attrib[0] + '="' + this.esc(attrib[1]) + '"';
                i++;
            }
        }
        if (selfclosing) result += " /";
        result += ">";
        return result;
    }
    // quick browser-compatible inheritance
    XmlRenderer.prototype = Object.create(Renderer.prototype);
    XmlRenderer.prototype.render = render$1;
    XmlRenderer.prototype.out = out$2;
    XmlRenderer.prototype.cr = cr$1;
    XmlRenderer.prototype.tag = tag$1;
    XmlRenderer.prototype.esc = escapeXml;
    exports1.HtmlRenderer = HtmlRenderer;
    exports1.Node = Node;
    exports1.Parser = Parser;
    exports1.Renderer = Renderer;
    exports1.XmlRenderer = XmlRenderer;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});

});

parcelRegister("hci3a", function(module, exports) {
/**
 * Multihash implementation in JavaScript.
 *
 * @module multihash
 */ "use strict";

var $3bFLy = parcelRequire("3bFLy");

var $lg1mP = parcelRequire("lg1mP");

var $lPX1n = parcelRequire("lPX1n");
var $c8518f0c26994259$require$names = $lPX1n.names;

var $57dKE = parcelRequire("57dKE");

var $cvLi9 = parcelRequire("cvLi9");

var $gg53d = parcelRequire("gg53d");
const $c8518f0c26994259$var$codes = /** @type {import('./types').CodeNameMap} */ {};
// eslint-disable-next-line guard-for-in
for(const key in $c8518f0c26994259$require$names){
    const name = /** @type {HashName} */ key;
    $c8518f0c26994259$var$codes[$c8518f0c26994259$require$names[name]] = name;
}
/**
 * Convert the given multihash to a hex encoded string.
 *
 * @param {Uint8Array} hash
 * @returns {string}
 */ function $c8518f0c26994259$var$toHexString(hash) {
    if (!(hash instanceof Uint8Array)) throw new Error("must be passed a Uint8Array");
    return $57dKE(hash, "base16");
}
/**
 * Convert the given hex encoded string to a multihash.
 *
 * @param {string} hash
 * @returns {Uint8Array}
 */ function $c8518f0c26994259$var$fromHexString(hash) {
    return $cvLi9(hash, "base16");
}
/**
 * Convert the given multihash to a base58 encoded string.
 *
 * @param {Uint8Array} hash
 * @returns {string}
 */ function $c8518f0c26994259$var$toB58String(hash) {
    if (!(hash instanceof Uint8Array)) throw new Error("must be passed a Uint8Array");
    return $57dKE($3bFLy.encode("base58btc", hash)).slice(1);
}
/**
 * Convert the given base58 encoded string to a multihash.
 *
 * @param {string|Uint8Array} hash
 * @returns {Uint8Array}
 */ function $c8518f0c26994259$var$fromB58String(hash) {
    const encoded = hash instanceof Uint8Array ? $57dKE(hash) : hash;
    return $3bFLy.decode("z" + encoded);
}
/**
 * Decode a hash from the given multihash.
 *
 * @param {Uint8Array} bytes
 * @returns {{code: HashCode, name: HashName, length: number, digest: Uint8Array}} result
 */ function $c8518f0c26994259$var$decode(bytes) {
    if (!(bytes instanceof Uint8Array)) throw new Error("multihash must be a Uint8Array");
    if (bytes.length < 2) throw new Error("multihash too short. must be > 2 bytes.");
    const code = /** @type {HashCode} */ $lg1mP.decode(bytes);
    if (!$c8518f0c26994259$var$isValidCode(code)) throw new Error(`multihash unknown function code: 0x${code.toString(16)}`);
    bytes = bytes.slice($lg1mP.decode.bytes);
    const len = $lg1mP.decode(bytes);
    if (len < 0) throw new Error(`multihash invalid length: ${len}`);
    bytes = bytes.slice($lg1mP.decode.bytes);
    if (bytes.length !== len) throw new Error(`multihash length inconsistent: 0x${$57dKE(bytes, "base16")}`);
    return {
        code: code,
        name: $c8518f0c26994259$var$codes[code],
        length: len,
        digest: bytes
    };
}
/**
 * Encode a hash digest along with the specified function code.
 *
 * > **Note:** the length is derived from the length of the digest itself.
 *
 * @param {Uint8Array} digest
 * @param {HashName | HashCode} code
 * @param {number} [length]
 * @returns {Uint8Array}
 */ function $c8518f0c26994259$var$encode(digest, code, length) {
    if (!digest || code === undefined) throw new Error("multihash encode requires at least two args: digest, code");
    // ensure it's a hashfunction code.
    const hashfn = $c8518f0c26994259$var$coerceCode(code);
    if (!(digest instanceof Uint8Array)) throw new Error("digest should be a Uint8Array");
    if (length == null) length = digest.length;
    if (length && digest.length !== length) throw new Error("digest length should be equal to specified length.");
    const hash = $lg1mP.encode(hashfn);
    const len = $lg1mP.encode(length);
    return $gg53d([
        hash,
        len,
        digest
    ], hash.length + len.length + digest.length);
}
/**
 * Converts a hash function name into the matching code.
 * If passed a number it will return the number if it's a valid code.
 *
 * @param {HashName | number} name
 * @returns {number}
 */ function $c8518f0c26994259$var$coerceCode(name) {
    let code = name;
    if (typeof name === "string") {
        if ($c8518f0c26994259$require$names[name] === undefined) throw new Error(`Unrecognized hash function named: ${name}`);
        code = $c8518f0c26994259$require$names[name];
    }
    if (typeof code !== "number") throw new Error(`Hash function code should be a number. Got: ${code}`);
    // @ts-ignore
    if ($c8518f0c26994259$var$codes[code] === undefined && !$c8518f0c26994259$var$isAppCode(code)) throw new Error(`Unrecognized function code: ${code}`);
    return code;
}
/**
 * Checks if a code is part of the app range
 *
 * @param {number} code
 * @returns {boolean}
 */ function $c8518f0c26994259$var$isAppCode(code) {
    return code > 0 && code < 0x10;
}
/**
 * Checks whether a multihash code is valid.
 *
 * @param {HashCode} code
 * @returns {boolean}
 */ function $c8518f0c26994259$var$isValidCode(code) {
    if ($c8518f0c26994259$var$isAppCode(code)) return true;
    if ($c8518f0c26994259$var$codes[code]) return true;
    return false;
}
/**
 * Check if the given buffer is a valid multihash. Throws an error if it is not valid.
 *
 * @param {Uint8Array} multihash
 * @returns {void}
 * @throws {Error}
 */ function $c8518f0c26994259$var$validate(multihash) {
    $c8518f0c26994259$var$decode(multihash) // throws if bad.
    ;
}
/**
 * Returns a prefix from a valid multihash. Throws an error if it is not valid.
 *
 * @param {Uint8Array} multihash
 * @returns {Uint8Array}
 * @throws {Error}
 */ function $c8518f0c26994259$var$prefix(multihash) {
    $c8518f0c26994259$var$validate(multihash);
    return multihash.subarray(0, 2);
}
module.exports = {
    names: $c8518f0c26994259$require$names,
    codes: Object.freeze($c8518f0c26994259$var$codes),
    toHexString: $c8518f0c26994259$var$toHexString,
    fromHexString: $c8518f0c26994259$var$fromHexString,
    toB58String: $c8518f0c26994259$var$toB58String,
    fromB58String: $c8518f0c26994259$var$fromB58String,
    decode: $c8518f0c26994259$var$decode,
    encode: $c8518f0c26994259$var$encode,
    coerceCode: $c8518f0c26994259$var$coerceCode,
    isAppCode: $c8518f0c26994259$var$isAppCode,
    validate: $c8518f0c26994259$var$validate,
    prefix: $c8518f0c26994259$var$prefix,
    isValidCode: $c8518f0c26994259$var$isValidCode
} /**
 * @typedef { import("./constants").HashCode } HashCode
 * @typedef { import("./constants").HashName } HashName
 */ ;

});
parcelRegister("3bFLy", function(module, exports) {
/**
 * Implementation of the [multibase](https://github.com/multiformats/multibase) specification.
 *
 */ "use strict";

var $3v55g = parcelRequire("3v55g");

var $1UdKz = parcelRequire("1UdKz");
var $2522cc0a9dabdd8a$require$encodeText = $1UdKz.encodeText;
var $2522cc0a9dabdd8a$require$decodeText = $1UdKz.decodeText;
var $2522cc0a9dabdd8a$require$concat = $1UdKz.concat;
/** @typedef {import('./base')} Base */ /** @typedef {import("./types").BaseNameOrCode} BaseNameOrCode */ /** @typedef {import("./types").BaseCode} BaseCode */ /** @typedef {import("./types").BaseName} BaseName */ /**
 * Create a new Uint8Array with the multibase varint+code.
 *
 * @param {BaseNameOrCode} nameOrCode - The multibase name or code number.
 * @param {Uint8Array} buf - The data to be prefixed with multibase.
 * @returns {Uint8Array}
 * @throws {Error} Will throw if the encoding is not supported
 */ function multibase(nameOrCode, buf) {
    if (!buf) throw new Error("requires an encoded Uint8Array");
    const { name, codeBuf } = encoding(nameOrCode);
    validEncode(name, buf);
    return $2522cc0a9dabdd8a$require$concat([
        codeBuf,
        buf
    ], codeBuf.length + buf.length);
}
/**
 * Encode data with the specified base and add the multibase prefix.
 *
 * @param {BaseNameOrCode} nameOrCode - The multibase name or code number.
 * @param {Uint8Array} buf - The data to be encoded.
 * @returns {Uint8Array}
 * @throws {Error} Will throw if the encoding is not supported
 *
 */ function encode(nameOrCode, buf) {
    const enc = encoding(nameOrCode);
    const data = $2522cc0a9dabdd8a$require$encodeText(enc.encode(buf));
    return $2522cc0a9dabdd8a$require$concat([
        enc.codeBuf,
        data
    ], enc.codeBuf.length + data.length);
}
/**
 * Takes a Uint8Array or string encoded with multibase header, decodes it and
 * returns the decoded buffer
 *
 * @param {Uint8Array|string} data
 * @returns {Uint8Array}
 * @throws {Error} Will throw if the encoding is not supported
 *
 */ function decode(data) {
    if (data instanceof Uint8Array) data = $2522cc0a9dabdd8a$require$decodeText(data);
    const prefix = data[0];
    // Make all encodings case-insensitive except the ones that include upper and lower chars in the alphabet
    if ([
        "f",
        "F",
        "v",
        "V",
        "t",
        "T",
        "b",
        "B",
        "c",
        "C",
        "h",
        "k",
        "K"
    ].includes(prefix)) data = data.toLowerCase();
    const enc = encoding(/** @type {BaseCode} */ data[0]);
    return enc.decode(data.substring(1));
}
/**
 * Is the given data multibase encoded?
 *
 * @param {Uint8Array|string} data
 * @returns {false | string}
 */ function isEncoded(data) {
    if (data instanceof Uint8Array) data = $2522cc0a9dabdd8a$require$decodeText(data);
    // Ensure bufOrString is a string
    if (Object.prototype.toString.call(data) !== "[object String]") return false;
    try {
        const enc = encoding(/** @type {BaseCode} */ data[0]);
        return enc.name;
    } catch (err) {
        return false;
    }
}
/**
 * Validate encoded data
 *
 * @param {BaseNameOrCode} name
 * @param {Uint8Array} buf
 * @returns {void}
 * @throws {Error} Will throw if the encoding is not supported
 */ function validEncode(name, buf) {
    const enc = encoding(name);
    enc.decode($2522cc0a9dabdd8a$require$decodeText(buf));
}
/**
 * Get the encoding by name or code
 *
 * @param {BaseNameOrCode} nameOrCode
 * @returns {Base}
 * @throws {Error} Will throw if the encoding is not supported
 */ function encoding(nameOrCode) {
    if (Object.prototype.hasOwnProperty.call($3v55g.names, /** @type {BaseName} */ nameOrCode)) return $3v55g.names[/** @type {BaseName} */ nameOrCode];
    else if (Object.prototype.hasOwnProperty.call($3v55g.codes, /** @type {BaseCode} */ nameOrCode)) return $3v55g.codes[/** @type {BaseCode} */ nameOrCode];
    else throw new Error(`Unsupported encoding: ${nameOrCode}`);
}
/**
 * Get encoding from data
 *
 * @param {string|Uint8Array} data
 * @returns {Base}
 * @throws {Error} Will throw if the encoding is not supported
 */ function encodingFromData(data) {
    if (data instanceof Uint8Array) data = $2522cc0a9dabdd8a$require$decodeText(data);
    return encoding(/** @type {BaseCode} */ data[0]);
}
exports = module.exports = multibase;
exports.encode = encode;
exports.decode = decode;
exports.isEncoded = isEncoded;
exports.encoding = encoding;
exports.encodingFromData = encodingFromData;
exports.names = Object.freeze($3v55g.names);
exports.codes = Object.freeze($3v55g.codes);

});
parcelRegister("3v55g", function(module, exports) {
"use strict";

var $7m1F1 = parcelRequire("7m1F1");

var $d3Wj3 = parcelRequire("d3Wj3");

var $uyyW1 = parcelRequire("uyyW1");
var $28c835e139e8e77c$require$rfc4648 = $uyyW1.rfc4648;

var $1UdKz = parcelRequire("1UdKz");
var $28c835e139e8e77c$require$decodeText = $1UdKz.decodeText;
var $28c835e139e8e77c$require$encodeText = $1UdKz.encodeText;
/** @typedef {import('./types').CodecFactory} CodecFactory */ /** @typedef {import('./types').Codec} Codec */ /** @typedef {import('./types').BaseName} BaseName */ /** @typedef {import('./types').BaseCode} BaseCode */ /** @type {CodecFactory} */ const $28c835e139e8e77c$var$identity = ()=>{
    return {
        encode: $28c835e139e8e77c$require$decodeText,
        decode: $28c835e139e8e77c$require$encodeText
    };
};
/**
 *
 * name, code, implementation, alphabet
 *
 * @type {Array<[BaseName, BaseCode, CodecFactory, string]>}
 */ const $28c835e139e8e77c$var$constants = [
    [
        "identity",
        "\0",
        $28c835e139e8e77c$var$identity,
        ""
    ],
    [
        "base2",
        "0",
        $28c835e139e8e77c$require$rfc4648(1),
        "01"
    ],
    [
        "base8",
        "7",
        $28c835e139e8e77c$require$rfc4648(3),
        "01234567"
    ],
    [
        "base10",
        "9",
        $7m1F1,
        "0123456789"
    ],
    [
        "base16",
        "f",
        $28c835e139e8e77c$require$rfc4648(4),
        "0123456789abcdef"
    ],
    [
        "base16upper",
        "F",
        $28c835e139e8e77c$require$rfc4648(4),
        "0123456789ABCDEF"
    ],
    [
        "base32hex",
        "v",
        $28c835e139e8e77c$require$rfc4648(5),
        "0123456789abcdefghijklmnopqrstuv"
    ],
    [
        "base32hexupper",
        "V",
        $28c835e139e8e77c$require$rfc4648(5),
        "0123456789ABCDEFGHIJKLMNOPQRSTUV"
    ],
    [
        "base32hexpad",
        "t",
        $28c835e139e8e77c$require$rfc4648(5),
        "0123456789abcdefghijklmnopqrstuv="
    ],
    [
        "base32hexpadupper",
        "T",
        $28c835e139e8e77c$require$rfc4648(5),
        "0123456789ABCDEFGHIJKLMNOPQRSTUV="
    ],
    [
        "base32",
        "b",
        $28c835e139e8e77c$require$rfc4648(5),
        "abcdefghijklmnopqrstuvwxyz234567"
    ],
    [
        "base32upper",
        "B",
        $28c835e139e8e77c$require$rfc4648(5),
        "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"
    ],
    [
        "base32pad",
        "c",
        $28c835e139e8e77c$require$rfc4648(5),
        "abcdefghijklmnopqrstuvwxyz234567="
    ],
    [
        "base32padupper",
        "C",
        $28c835e139e8e77c$require$rfc4648(5),
        "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567="
    ],
    [
        "base32z",
        "h",
        $28c835e139e8e77c$require$rfc4648(5),
        "ybndrfg8ejkmcpqxot1uwisza345h769"
    ],
    [
        "base36",
        "k",
        $7m1F1,
        "0123456789abcdefghijklmnopqrstuvwxyz"
    ],
    [
        "base36upper",
        "K",
        $7m1F1,
        "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
    ],
    [
        "base58btc",
        "z",
        $7m1F1,
        "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
    ],
    [
        "base58flickr",
        "Z",
        $7m1F1,
        "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
    ],
    [
        "base64",
        "m",
        $28c835e139e8e77c$require$rfc4648(6),
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"
    ],
    [
        "base64pad",
        "M",
        $28c835e139e8e77c$require$rfc4648(6),
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
    ],
    [
        "base64url",
        "u",
        $28c835e139e8e77c$require$rfc4648(6),
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
    ],
    [
        "base64urlpad",
        "U",
        $28c835e139e8e77c$require$rfc4648(6),
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_="
    ]
];
/** @type {Record<BaseName,Base>} */ const $28c835e139e8e77c$var$names = $28c835e139e8e77c$var$constants.reduce((prev, tupple)=>{
    prev[tupple[0]] = new $d3Wj3(tupple[0], tupple[1], tupple[2], tupple[3]);
    return prev;
}, /** @type {Record<BaseName,Base>} */ {});
/** @type {Record<BaseCode,Base>} */ const $28c835e139e8e77c$var$codes = $28c835e139e8e77c$var$constants.reduce((prev, tupple)=>{
    prev[tupple[1]] = $28c835e139e8e77c$var$names[tupple[0]];
    return prev;
}, /** @type {Record<BaseCode,Base>} */ {});
module.exports = {
    names: $28c835e139e8e77c$var$names,
    codes: $28c835e139e8e77c$var$codes
};

});
parcelRegister("7m1F1", function(module, exports) {
"use strict";
// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function $55abe0448d40c1ed$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        // Skip leading spaces.
        if (source[psz] === " ") return;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip trailing spaces.
        if (source[psz] === " ") return;
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $55abe0448d40c1ed$var$base;

});

parcelRegister("d3Wj3", function(module, exports) {
"use strict";

var $1UdKz = parcelRequire("1UdKz");
var $9828c89444f0abac$require$encodeText = $1UdKz.encodeText;
/** @typedef {import('./types').CodecFactory} CodecFactory */ /** @typedef {import("./types").BaseName} BaseName */ /** @typedef {import("./types").BaseCode} BaseCode */ /**
 * Class to encode/decode in the supported Bases
 *
 */ class $9828c89444f0abac$var$Base {
    /**
   * @param {BaseName} name
   * @param {BaseCode} code
   * @param {CodecFactory} factory
   * @param {string} alphabet
   */ constructor(name, code, factory, alphabet){
        this.name = name;
        this.code = code;
        this.codeBuf = $9828c89444f0abac$require$encodeText(this.code);
        this.alphabet = alphabet;
        this.codec = factory(alphabet);
    }
    /**
   * @param {Uint8Array} buf
   * @returns {string}
   */ encode(buf) {
        return this.codec.encode(buf);
    }
    /**
   * @param {string} string
   * @returns {Uint8Array}
   */ decode(string) {
        for (const char of string){
            if (this.alphabet && this.alphabet.indexOf(char) < 0) throw new Error(`invalid character '${char}' in '${string}'`);
        }
        return this.codec.decode(string);
    }
}
module.exports = $9828c89444f0abac$var$Base;

});
parcelRegister("1UdKz", function(module, exports) {
"use strict";

var $l1lTW = parcelRequire("l1lTW");
var $1635afe7ad1d6a30$require$TextEncoder = $l1lTW.TextEncoder;
var $1635afe7ad1d6a30$require$TextDecoder = $l1lTW.TextDecoder;
const $1635afe7ad1d6a30$var$textDecoder = new $1635afe7ad1d6a30$require$TextDecoder();
/**
 * @param {ArrayBufferView|ArrayBuffer} bytes
 * @returns {string}
 */ const $1635afe7ad1d6a30$var$decodeText = (bytes)=>$1635afe7ad1d6a30$var$textDecoder.decode(bytes);
const $1635afe7ad1d6a30$var$textEncoder = new $1635afe7ad1d6a30$require$TextEncoder();
/**
 * @param {string} text
 * @returns {Uint8Array}
 */ const $1635afe7ad1d6a30$var$encodeText = (text)=>$1635afe7ad1d6a30$var$textEncoder.encode(text);
/**
 * Returns a new Uint8Array created by concatenating the passed Arrays
 *
 * @param {Array<ArrayLike<number>>} arrs
 * @param {number} length
 * @returns {Uint8Array}
 */ function $1635afe7ad1d6a30$var$concat(arrs, length) {
    const output = new Uint8Array(length);
    let offset = 0;
    for (const arr of arrs){
        output.set(arr, offset);
        offset += arr.length;
    }
    return output;
}
module.exports = {
    decodeText: $1635afe7ad1d6a30$var$decodeText,
    encodeText: $1635afe7ad1d6a30$var$encodeText,
    concat: $1635afe7ad1d6a30$var$concat
};

});
parcelRegister("l1lTW", function(module, exports) {

$parcel$export(module.exports, "TextEncoder", function () { return $f4daae1f784d5561$export$88fb0cfd153261a7; }, function (v) { return $f4daae1f784d5561$export$88fb0cfd153261a7 = v; });
$parcel$export(module.exports, "TextDecoder", function () { return $f4daae1f784d5561$export$9c6b53e35bc51b5c; }, function (v) { return $f4daae1f784d5561$export$9c6b53e35bc51b5c = v; });
var $f4daae1f784d5561$export$88fb0cfd153261a7;
var $f4daae1f784d5561$export$9c6b53e35bc51b5c;
"use strict";

$f4daae1f784d5561$export$88fb0cfd153261a7 = typeof TextEncoder !== "undefined" ? TextEncoder : (parcelRequire("ennut")).TextEncoder;

$f4daae1f784d5561$export$9c6b53e35bc51b5c = typeof TextDecoder !== "undefined" ? TextDecoder : (parcelRequire("ennut")).TextDecoder;

});
parcelRegister("ennut", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $fZVRp = parcelRequire("fZVRp");
var $a7756f67f9b306e8$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $a7756f67f9b306e8$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$a7756f67f9b306e8$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($a7756f67f9b306e8$var$inspect(arguments[i]));
        return objects.join(" ");
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($a7756f67f9b306e8$var$formatRegExp, function(x) {
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                return String(args[i++]);
            case "%d":
                return Number(args[i++]);
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return "[Circular]";
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($a7756f67f9b306e8$var$isNull(x) || !$a7756f67f9b306e8$var$isObject(x)) str += " " + x;
    else str += " " + $a7756f67f9b306e8$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $fZVRp !== "undefined" && $fZVRp.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $fZVRp === "undefined") return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($fZVRp.throwDeprecation) throw new Error(msg);
            else if ($fZVRp.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $a7756f67f9b306e8$var$debugs = {};
var $a7756f67f9b306e8$var$debugEnvRegex = /^$/;
var $a7756f67f9b306e8$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$a7756f67f9b306e8$var$debugs[set]) {
        if ($a7756f67f9b306e8$var$debugEnvRegex.test(set)) {
            var pid = $fZVRp.pid;
            $a7756f67f9b306e8$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error("%s %d: %s", set, pid, msg);
            };
        } else $a7756f67f9b306e8$var$debugs[set] = function() {};
    }
    return $a7756f67f9b306e8$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $a7756f67f9b306e8$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $a7756f67f9b306e8$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($a7756f67f9b306e8$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($a7756f67f9b306e8$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($a7756f67f9b306e8$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($a7756f67f9b306e8$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($a7756f67f9b306e8$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $a7756f67f9b306e8$var$stylizeWithColor;
    return $a7756f67f9b306e8$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $a7756f67f9b306e8$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$a7756f67f9b306e8$var$inspect.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$a7756f67f9b306e8$var$inspect.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function $a7756f67f9b306e8$var$stylizeWithColor(str, styleType) {
    var style = $a7756f67f9b306e8$var$inspect.styles[styleType];
    if (style) return "\x1b[" + $a7756f67f9b306e8$var$inspect.colors[style][0] + "m" + str + "\x1b[" + $a7756f67f9b306e8$var$inspect.colors[style][1] + "m";
    else return str;
}
function $a7756f67f9b306e8$var$stylizeNoColor(str, styleType) {
    return str;
}
function $a7756f67f9b306e8$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $a7756f67f9b306e8$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $a7756f67f9b306e8$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$a7756f67f9b306e8$var$isString(ret)) ret = $a7756f67f9b306e8$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $a7756f67f9b306e8$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $a7756f67f9b306e8$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($a7756f67f9b306e8$var$isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return $a7756f67f9b306e8$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($a7756f67f9b306e8$var$isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if ($a7756f67f9b306e8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if ($a7756f67f9b306e8$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if ($a7756f67f9b306e8$var$isError(value)) return $a7756f67f9b306e8$var$formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if ($a7756f67f9b306e8$var$isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if ($a7756f67f9b306e8$var$isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if ($a7756f67f9b306e8$var$isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($a7756f67f9b306e8$var$isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($a7756f67f9b306e8$var$isError(value)) base = " " + $a7756f67f9b306e8$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($a7756f67f9b306e8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $a7756f67f9b306e8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $a7756f67f9b306e8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $a7756f67f9b306e8$var$reduceToSingleString(output, base, braces);
}
function $a7756f67f9b306e8$var$formatPrimitive(ctx, value) {
    if ($a7756f67f9b306e8$var$isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if ($a7756f67f9b306e8$var$isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if ($a7756f67f9b306e8$var$isNumber(value)) return ctx.stylize("" + value, "number");
    if ($a7756f67f9b306e8$var$isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if ($a7756f67f9b306e8$var$isNull(value)) return ctx.stylize("null", "null");
}
function $a7756f67f9b306e8$var$formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function $a7756f67f9b306e8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($a7756f67f9b306e8$var$hasOwnProperty(value, String(i))) output.push($a7756f67f9b306e8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($a7756f67f9b306e8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $a7756f67f9b306e8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!$a7756f67f9b306e8$var$hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($a7756f67f9b306e8$var$isNull(recurseTimes)) str = $a7756f67f9b306e8$var$formatValue(ctx, desc.value, null);
            else str = $a7756f67f9b306e8$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").slice(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if ($a7756f67f9b306e8$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function $a7756f67f9b306e8$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("lp8P9"));
function $a7756f67f9b306e8$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $a7756f67f9b306e8$var$isArray;
function $a7756f67f9b306e8$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
module.exports.isBoolean = $a7756f67f9b306e8$var$isBoolean;
function $a7756f67f9b306e8$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $a7756f67f9b306e8$var$isNull;
function $a7756f67f9b306e8$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $a7756f67f9b306e8$var$isNullOrUndefined;
function $a7756f67f9b306e8$var$isNumber(arg) {
    return typeof arg === "number";
}
module.exports.isNumber = $a7756f67f9b306e8$var$isNumber;
function $a7756f67f9b306e8$var$isString(arg) {
    return typeof arg === "string";
}
module.exports.isString = $a7756f67f9b306e8$var$isString;
function $a7756f67f9b306e8$var$isSymbol(arg) {
    return typeof arg === "symbol";
}
module.exports.isSymbol = $a7756f67f9b306e8$var$isSymbol;
function $a7756f67f9b306e8$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $a7756f67f9b306e8$var$isUndefined;
function $a7756f67f9b306e8$var$isRegExp(re) {
    return $a7756f67f9b306e8$var$isObject(re) && $a7756f67f9b306e8$var$objectToString(re) === "[object RegExp]";
}
module.exports.isRegExp = $a7756f67f9b306e8$var$isRegExp;
module.exports.types.isRegExp = $a7756f67f9b306e8$var$isRegExp;
function $a7756f67f9b306e8$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
module.exports.isObject = $a7756f67f9b306e8$var$isObject;
function $a7756f67f9b306e8$var$isDate(d) {
    return $a7756f67f9b306e8$var$isObject(d) && $a7756f67f9b306e8$var$objectToString(d) === "[object Date]";
}
module.exports.isDate = $a7756f67f9b306e8$var$isDate;
module.exports.types.isDate = $a7756f67f9b306e8$var$isDate;
function $a7756f67f9b306e8$var$isError(e) {
    return $a7756f67f9b306e8$var$isObject(e) && ($a7756f67f9b306e8$var$objectToString(e) === "[object Error]" || e instanceof Error);
}
module.exports.isError = $a7756f67f9b306e8$var$isError;
module.exports.types.isNativeError = $a7756f67f9b306e8$var$isError;
function $a7756f67f9b306e8$var$isFunction(arg) {
    return typeof arg === "function";
}
module.exports.isFunction = $a7756f67f9b306e8$var$isFunction;
function $a7756f67f9b306e8$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
module.exports.isPrimitive = $a7756f67f9b306e8$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("1ec4D"));
function $a7756f67f9b306e8$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $a7756f67f9b306e8$var$pad(n) {
    return n < 10 ? "0" + n.toString(10) : n.toString(10);
}
var $a7756f67f9b306e8$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
// 26 Feb 16:19:34
function $a7756f67f9b306e8$var$timestamp() {
    var d = new Date();
    var time = [
        $a7756f67f9b306e8$var$pad(d.getHours()),
        $a7756f67f9b306e8$var$pad(d.getMinutes()),
        $a7756f67f9b306e8$var$pad(d.getSeconds())
    ].join(":");
    return [
        d.getDate(),
        $a7756f67f9b306e8$var$months[d.getMonth()],
        time
    ].join(" ");
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log("%s - %s", $a7756f67f9b306e8$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("fvL6U"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$a7756f67f9b306e8$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $a7756f67f9b306e8$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $a7756f67f9b306e8$var$kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    if ($a7756f67f9b306e8$var$kCustomPromisifiedSymbol && original[$a7756f67f9b306e8$var$kCustomPromisifiedSymbol]) {
        var fn = original[$a7756f67f9b306e8$var$kCustomPromisifiedSymbol];
        if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $a7756f67f9b306e8$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($a7756f67f9b306e8$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $a7756f67f9b306e8$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $a7756f67f9b306e8$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $a7756f67f9b306e8$var$kCustomPromisifiedSymbol;
function $a7756f67f9b306e8$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $a7756f67f9b306e8$var$callbackify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $fZVRp.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $fZVRp.nextTick($a7756f67f9b306e8$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $a7756f67f9b306e8$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $a7756f67f9b306e8$var$callbackify;

});
parcelRegister("fZVRp", function(module, exports) {
// shim for using process in browser
var $ba596f6607e75a63$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $ba596f6607e75a63$var$cachedSetTimeout;
var $ba596f6607e75a63$var$cachedClearTimeout;
function $ba596f6607e75a63$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $ba596f6607e75a63$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $ba596f6607e75a63$var$cachedSetTimeout = setTimeout;
        else $ba596f6607e75a63$var$cachedSetTimeout = $ba596f6607e75a63$var$defaultSetTimout;
    } catch (e) {
        $ba596f6607e75a63$var$cachedSetTimeout = $ba596f6607e75a63$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $ba596f6607e75a63$var$cachedClearTimeout = clearTimeout;
        else $ba596f6607e75a63$var$cachedClearTimeout = $ba596f6607e75a63$var$defaultClearTimeout;
    } catch (e) {
        $ba596f6607e75a63$var$cachedClearTimeout = $ba596f6607e75a63$var$defaultClearTimeout;
    }
})();
function $ba596f6607e75a63$var$runTimeout(fun) {
    if ($ba596f6607e75a63$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($ba596f6607e75a63$var$cachedSetTimeout === $ba596f6607e75a63$var$defaultSetTimout || !$ba596f6607e75a63$var$cachedSetTimeout) && setTimeout) {
        $ba596f6607e75a63$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $ba596f6607e75a63$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $ba596f6607e75a63$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $ba596f6607e75a63$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $ba596f6607e75a63$var$runClearTimeout(marker) {
    if ($ba596f6607e75a63$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($ba596f6607e75a63$var$cachedClearTimeout === $ba596f6607e75a63$var$defaultClearTimeout || !$ba596f6607e75a63$var$cachedClearTimeout) && clearTimeout) {
        $ba596f6607e75a63$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $ba596f6607e75a63$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $ba596f6607e75a63$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $ba596f6607e75a63$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $ba596f6607e75a63$var$queue = [];
var $ba596f6607e75a63$var$draining = false;
var $ba596f6607e75a63$var$currentQueue;
var $ba596f6607e75a63$var$queueIndex = -1;
function $ba596f6607e75a63$var$cleanUpNextTick() {
    if (!$ba596f6607e75a63$var$draining || !$ba596f6607e75a63$var$currentQueue) return;
    $ba596f6607e75a63$var$draining = false;
    if ($ba596f6607e75a63$var$currentQueue.length) $ba596f6607e75a63$var$queue = $ba596f6607e75a63$var$currentQueue.concat($ba596f6607e75a63$var$queue);
    else $ba596f6607e75a63$var$queueIndex = -1;
    if ($ba596f6607e75a63$var$queue.length) $ba596f6607e75a63$var$drainQueue();
}
function $ba596f6607e75a63$var$drainQueue() {
    if ($ba596f6607e75a63$var$draining) return;
    var timeout = $ba596f6607e75a63$var$runTimeout($ba596f6607e75a63$var$cleanUpNextTick);
    $ba596f6607e75a63$var$draining = true;
    var len = $ba596f6607e75a63$var$queue.length;
    while(len){
        $ba596f6607e75a63$var$currentQueue = $ba596f6607e75a63$var$queue;
        $ba596f6607e75a63$var$queue = [];
        while(++$ba596f6607e75a63$var$queueIndex < len)if ($ba596f6607e75a63$var$currentQueue) $ba596f6607e75a63$var$currentQueue[$ba596f6607e75a63$var$queueIndex].run();
        $ba596f6607e75a63$var$queueIndex = -1;
        len = $ba596f6607e75a63$var$queue.length;
    }
    $ba596f6607e75a63$var$currentQueue = null;
    $ba596f6607e75a63$var$draining = false;
    $ba596f6607e75a63$var$runClearTimeout(timeout);
}
$ba596f6607e75a63$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $ba596f6607e75a63$var$queue.push(new $ba596f6607e75a63$var$Item(fun, args));
    if ($ba596f6607e75a63$var$queue.length === 1 && !$ba596f6607e75a63$var$draining) $ba596f6607e75a63$var$runTimeout($ba596f6607e75a63$var$drainQueue);
};
// v8 likes predictible objects
function $ba596f6607e75a63$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$ba596f6607e75a63$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$ba596f6607e75a63$var$process.title = "browser";
$ba596f6607e75a63$var$process.browser = true;
$ba596f6607e75a63$var$process.env = {};
$ba596f6607e75a63$var$process.argv = [];
$ba596f6607e75a63$var$process.version = ""; // empty string to avoid regexp issues
$ba596f6607e75a63$var$process.versions = {};
function $ba596f6607e75a63$var$noop() {}
$ba596f6607e75a63$var$process.on = $ba596f6607e75a63$var$noop;
$ba596f6607e75a63$var$process.addListener = $ba596f6607e75a63$var$noop;
$ba596f6607e75a63$var$process.once = $ba596f6607e75a63$var$noop;
$ba596f6607e75a63$var$process.off = $ba596f6607e75a63$var$noop;
$ba596f6607e75a63$var$process.removeListener = $ba596f6607e75a63$var$noop;
$ba596f6607e75a63$var$process.removeAllListeners = $ba596f6607e75a63$var$noop;
$ba596f6607e75a63$var$process.emit = $ba596f6607e75a63$var$noop;
$ba596f6607e75a63$var$process.prependListener = $ba596f6607e75a63$var$noop;
$ba596f6607e75a63$var$process.prependOnceListener = $ba596f6607e75a63$var$noop;
$ba596f6607e75a63$var$process.listeners = function(name) {
    return [];
};
$ba596f6607e75a63$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$ba596f6607e75a63$var$process.cwd = function() {
    return "/";
};
$ba596f6607e75a63$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$ba596f6607e75a63$var$process.umask = function() {
    return 0;
};

});

parcelRegister("lp8P9", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";

var $9WLgc = parcelRequire("9WLgc");

var $fd7v8 = parcelRequire("fd7v8");

var $bC4MU = parcelRequire("bC4MU");

var $i9pTi = parcelRequire("i9pTi");
function $f952c70f2aa835f6$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $f952c70f2aa835f6$var$BigIntSupported = typeof BigInt !== "undefined";
var $f952c70f2aa835f6$var$SymbolSupported = typeof Symbol !== "undefined";
var $f952c70f2aa835f6$var$ObjectToString = $f952c70f2aa835f6$var$uncurryThis(Object.prototype.toString);
var $f952c70f2aa835f6$var$numberValue = $f952c70f2aa835f6$var$uncurryThis(Number.prototype.valueOf);
var $f952c70f2aa835f6$var$stringValue = $f952c70f2aa835f6$var$uncurryThis(String.prototype.valueOf);
var $f952c70f2aa835f6$var$booleanValue = $f952c70f2aa835f6$var$uncurryThis(Boolean.prototype.valueOf);
if ($f952c70f2aa835f6$var$BigIntSupported) var $f952c70f2aa835f6$var$bigIntValue = $f952c70f2aa835f6$var$uncurryThis(BigInt.prototype.valueOf);
if ($f952c70f2aa835f6$var$SymbolSupported) var $f952c70f2aa835f6$var$symbolValue = $f952c70f2aa835f6$var$uncurryThis(Symbol.prototype.valueOf);
function $f952c70f2aa835f6$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== "object") return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $9WLgc;
module.exports.isGeneratorFunction = $fd7v8;
module.exports.isTypedArray = $i9pTi;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $f952c70f2aa835f6$var$isPromise(input) {
    return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
}
module.exports.isPromise = $f952c70f2aa835f6$var$isPromise;
function $f952c70f2aa835f6$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $i9pTi(value) || $f952c70f2aa835f6$var$isDataView(value);
}
module.exports.isArrayBufferView = $f952c70f2aa835f6$var$isArrayBufferView;
function $f952c70f2aa835f6$var$isUint8Array(value) {
    return $bC4MU(value) === "Uint8Array";
}
module.exports.isUint8Array = $f952c70f2aa835f6$var$isUint8Array;
function $f952c70f2aa835f6$var$isUint8ClampedArray(value) {
    return $bC4MU(value) === "Uint8ClampedArray";
}
module.exports.isUint8ClampedArray = $f952c70f2aa835f6$var$isUint8ClampedArray;
function $f952c70f2aa835f6$var$isUint16Array(value) {
    return $bC4MU(value) === "Uint16Array";
}
module.exports.isUint16Array = $f952c70f2aa835f6$var$isUint16Array;
function $f952c70f2aa835f6$var$isUint32Array(value) {
    return $bC4MU(value) === "Uint32Array";
}
module.exports.isUint32Array = $f952c70f2aa835f6$var$isUint32Array;
function $f952c70f2aa835f6$var$isInt8Array(value) {
    return $bC4MU(value) === "Int8Array";
}
module.exports.isInt8Array = $f952c70f2aa835f6$var$isInt8Array;
function $f952c70f2aa835f6$var$isInt16Array(value) {
    return $bC4MU(value) === "Int16Array";
}
module.exports.isInt16Array = $f952c70f2aa835f6$var$isInt16Array;
function $f952c70f2aa835f6$var$isInt32Array(value) {
    return $bC4MU(value) === "Int32Array";
}
module.exports.isInt32Array = $f952c70f2aa835f6$var$isInt32Array;
function $f952c70f2aa835f6$var$isFloat32Array(value) {
    return $bC4MU(value) === "Float32Array";
}
module.exports.isFloat32Array = $f952c70f2aa835f6$var$isFloat32Array;
function $f952c70f2aa835f6$var$isFloat64Array(value) {
    return $bC4MU(value) === "Float64Array";
}
module.exports.isFloat64Array = $f952c70f2aa835f6$var$isFloat64Array;
function $f952c70f2aa835f6$var$isBigInt64Array(value) {
    return $bC4MU(value) === "BigInt64Array";
}
module.exports.isBigInt64Array = $f952c70f2aa835f6$var$isBigInt64Array;
function $f952c70f2aa835f6$var$isBigUint64Array(value) {
    return $bC4MU(value) === "BigUint64Array";
}
module.exports.isBigUint64Array = $f952c70f2aa835f6$var$isBigUint64Array;
function $f952c70f2aa835f6$var$isMapToString(value) {
    return $f952c70f2aa835f6$var$ObjectToString(value) === "[object Map]";
}
$f952c70f2aa835f6$var$isMapToString.working = typeof Map !== "undefined" && $f952c70f2aa835f6$var$isMapToString(new Map());
function $f952c70f2aa835f6$var$isMap(value) {
    if (typeof Map === "undefined") return false;
    return $f952c70f2aa835f6$var$isMapToString.working ? $f952c70f2aa835f6$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $f952c70f2aa835f6$var$isMap;
function $f952c70f2aa835f6$var$isSetToString(value) {
    return $f952c70f2aa835f6$var$ObjectToString(value) === "[object Set]";
}
$f952c70f2aa835f6$var$isSetToString.working = typeof Set !== "undefined" && $f952c70f2aa835f6$var$isSetToString(new Set());
function $f952c70f2aa835f6$var$isSet(value) {
    if (typeof Set === "undefined") return false;
    return $f952c70f2aa835f6$var$isSetToString.working ? $f952c70f2aa835f6$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $f952c70f2aa835f6$var$isSet;
function $f952c70f2aa835f6$var$isWeakMapToString(value) {
    return $f952c70f2aa835f6$var$ObjectToString(value) === "[object WeakMap]";
}
$f952c70f2aa835f6$var$isWeakMapToString.working = typeof WeakMap !== "undefined" && $f952c70f2aa835f6$var$isWeakMapToString(new WeakMap());
function $f952c70f2aa835f6$var$isWeakMap(value) {
    if (typeof WeakMap === "undefined") return false;
    return $f952c70f2aa835f6$var$isWeakMapToString.working ? $f952c70f2aa835f6$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $f952c70f2aa835f6$var$isWeakMap;
function $f952c70f2aa835f6$var$isWeakSetToString(value) {
    return $f952c70f2aa835f6$var$ObjectToString(value) === "[object WeakSet]";
}
$f952c70f2aa835f6$var$isWeakSetToString.working = typeof WeakSet !== "undefined" && $f952c70f2aa835f6$var$isWeakSetToString(new WeakSet());
function $f952c70f2aa835f6$var$isWeakSet(value) {
    return $f952c70f2aa835f6$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $f952c70f2aa835f6$var$isWeakSet;
function $f952c70f2aa835f6$var$isArrayBufferToString(value) {
    return $f952c70f2aa835f6$var$ObjectToString(value) === "[object ArrayBuffer]";
}
$f952c70f2aa835f6$var$isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && $f952c70f2aa835f6$var$isArrayBufferToString(new ArrayBuffer());
function $f952c70f2aa835f6$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === "undefined") return false;
    return $f952c70f2aa835f6$var$isArrayBufferToString.working ? $f952c70f2aa835f6$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $f952c70f2aa835f6$var$isArrayBuffer;
function $f952c70f2aa835f6$var$isDataViewToString(value) {
    return $f952c70f2aa835f6$var$ObjectToString(value) === "[object DataView]";
}
$f952c70f2aa835f6$var$isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && $f952c70f2aa835f6$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $f952c70f2aa835f6$var$isDataView(value) {
    if (typeof DataView === "undefined") return false;
    return $f952c70f2aa835f6$var$isDataViewToString.working ? $f952c70f2aa835f6$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $f952c70f2aa835f6$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $f952c70f2aa835f6$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
function $f952c70f2aa835f6$var$isSharedArrayBufferToString(value) {
    return $f952c70f2aa835f6$var$ObjectToString(value) === "[object SharedArrayBuffer]";
}
function $f952c70f2aa835f6$var$isSharedArrayBuffer(value) {
    if (typeof $f952c70f2aa835f6$var$SharedArrayBufferCopy === "undefined") return false;
    if (typeof $f952c70f2aa835f6$var$isSharedArrayBufferToString.working === "undefined") $f952c70f2aa835f6$var$isSharedArrayBufferToString.working = $f952c70f2aa835f6$var$isSharedArrayBufferToString(new $f952c70f2aa835f6$var$SharedArrayBufferCopy());
    return $f952c70f2aa835f6$var$isSharedArrayBufferToString.working ? $f952c70f2aa835f6$var$isSharedArrayBufferToString(value) : value instanceof $f952c70f2aa835f6$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $f952c70f2aa835f6$var$isSharedArrayBuffer;
function $f952c70f2aa835f6$var$isAsyncFunction(value) {
    return $f952c70f2aa835f6$var$ObjectToString(value) === "[object AsyncFunction]";
}
module.exports.isAsyncFunction = $f952c70f2aa835f6$var$isAsyncFunction;
function $f952c70f2aa835f6$var$isMapIterator(value) {
    return $f952c70f2aa835f6$var$ObjectToString(value) === "[object Map Iterator]";
}
module.exports.isMapIterator = $f952c70f2aa835f6$var$isMapIterator;
function $f952c70f2aa835f6$var$isSetIterator(value) {
    return $f952c70f2aa835f6$var$ObjectToString(value) === "[object Set Iterator]";
}
module.exports.isSetIterator = $f952c70f2aa835f6$var$isSetIterator;
function $f952c70f2aa835f6$var$isGeneratorObject(value) {
    return $f952c70f2aa835f6$var$ObjectToString(value) === "[object Generator]";
}
module.exports.isGeneratorObject = $f952c70f2aa835f6$var$isGeneratorObject;
function $f952c70f2aa835f6$var$isWebAssemblyCompiledModule(value) {
    return $f952c70f2aa835f6$var$ObjectToString(value) === "[object WebAssembly.Module]";
}
module.exports.isWebAssemblyCompiledModule = $f952c70f2aa835f6$var$isWebAssemblyCompiledModule;
function $f952c70f2aa835f6$var$isNumberObject(value) {
    return $f952c70f2aa835f6$var$checkBoxedPrimitive(value, $f952c70f2aa835f6$var$numberValue);
}
module.exports.isNumberObject = $f952c70f2aa835f6$var$isNumberObject;
function $f952c70f2aa835f6$var$isStringObject(value) {
    return $f952c70f2aa835f6$var$checkBoxedPrimitive(value, $f952c70f2aa835f6$var$stringValue);
}
module.exports.isStringObject = $f952c70f2aa835f6$var$isStringObject;
function $f952c70f2aa835f6$var$isBooleanObject(value) {
    return $f952c70f2aa835f6$var$checkBoxedPrimitive(value, $f952c70f2aa835f6$var$booleanValue);
}
module.exports.isBooleanObject = $f952c70f2aa835f6$var$isBooleanObject;
function $f952c70f2aa835f6$var$isBigIntObject(value) {
    return $f952c70f2aa835f6$var$BigIntSupported && $f952c70f2aa835f6$var$checkBoxedPrimitive(value, $f952c70f2aa835f6$var$bigIntValue);
}
module.exports.isBigIntObject = $f952c70f2aa835f6$var$isBigIntObject;
function $f952c70f2aa835f6$var$isSymbolObject(value) {
    return $f952c70f2aa835f6$var$SymbolSupported && $f952c70f2aa835f6$var$checkBoxedPrimitive(value, $f952c70f2aa835f6$var$symbolValue);
}
module.exports.isSymbolObject = $f952c70f2aa835f6$var$isSymbolObject;
function $f952c70f2aa835f6$var$isBoxedPrimitive(value) {
    return $f952c70f2aa835f6$var$isNumberObject(value) || $f952c70f2aa835f6$var$isStringObject(value) || $f952c70f2aa835f6$var$isBooleanObject(value) || $f952c70f2aa835f6$var$isBigIntObject(value) || $f952c70f2aa835f6$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $f952c70f2aa835f6$var$isBoxedPrimitive;
function $f952c70f2aa835f6$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== "undefined" && ($f952c70f2aa835f6$var$isArrayBuffer(value) || $f952c70f2aa835f6$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $f952c70f2aa835f6$var$isAnyArrayBuffer;
[
    "isProxy",
    "isExternal",
    "isModuleNamespaceObject"
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + " is not supported in userland");
        }
    });
});

});
parcelRegister("9WLgc", function(module, exports) {
"use strict";

var $73de30bdcd34bd32$var$hasToStringTag = (parcelRequire("9lcIx"))();

var $fvpTx = parcelRequire("fvpTx");
var $73de30bdcd34bd32$var$$toString = $fvpTx("Object.prototype.toString");
var $73de30bdcd34bd32$var$isStandardArguments = function isArguments(value) {
    if ($73de30bdcd34bd32$var$hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $73de30bdcd34bd32$var$$toString(value) === "[object Arguments]";
};
var $73de30bdcd34bd32$var$isLegacyArguments = function isArguments(value) {
    if ($73de30bdcd34bd32$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $73de30bdcd34bd32$var$$toString(value) !== "[object Array]" && $73de30bdcd34bd32$var$$toString(value.callee) === "[object Function]";
};
var $73de30bdcd34bd32$var$supportsStandardArguments = function() {
    return $73de30bdcd34bd32$var$isStandardArguments(arguments);
}();
$73de30bdcd34bd32$var$isStandardArguments.isLegacyArguments = $73de30bdcd34bd32$var$isLegacyArguments; // for tests
module.exports = $73de30bdcd34bd32$var$supportsStandardArguments ? $73de30bdcd34bd32$var$isStandardArguments : $73de30bdcd34bd32$var$isLegacyArguments;

});
parcelRegister("9lcIx", function(module, exports) {
"use strict";

var $lVmUo = parcelRequire("lVmUo");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $lVmUo() && !!Symbol.toStringTag;
};

});
parcelRegister("lVmUo", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("fvpTx", function(module, exports) {
"use strict";

var $fFT7c = parcelRequire("fFT7c");

var $4xYIQ = parcelRequire("4xYIQ");
var $b49dd66a6bb172ab$var$$indexOf = $4xYIQ($fFT7c("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $fFT7c(name, !!allowMissing);
    if (typeof intrinsic === "function" && $b49dd66a6bb172ab$var$$indexOf(name, ".prototype.") > -1) return $4xYIQ(intrinsic);
    return intrinsic;
};

});
parcelRegister("fFT7c", function(module, exports) {
"use strict";
var $b69570147c829841$var$undefined1;

var $1dJrz = parcelRequire("1dJrz");

var $kef4E = parcelRequire("kef4E");

var $7egBS = parcelRequire("7egBS");

var $kE1zH = parcelRequire("kE1zH");

var $ibUZq = parcelRequire("ibUZq");

var $68H9J = parcelRequire("68H9J");

var $hysju = parcelRequire("hysju");
var $b69570147c829841$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $b69570147c829841$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $b69570147c829841$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $b69570147c829841$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($b69570147c829841$var$$gOPD) try {
    $b69570147c829841$var$$gOPD({}, "");
} catch (e) {
    $b69570147c829841$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $b69570147c829841$var$throwTypeError = function() {
    throw new $68H9J();
};
var $b69570147c829841$var$ThrowTypeError = $b69570147c829841$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $b69570147c829841$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $b69570147c829841$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $b69570147c829841$var$throwTypeError;
        }
    }
}() : $b69570147c829841$var$throwTypeError;

var $b69570147c829841$var$hasSymbols = (parcelRequire("lEsMR"))();

var $b69570147c829841$var$hasProto = (parcelRequire("1B898"))();
var $b69570147c829841$var$getProto = Object.getPrototypeOf || ($b69570147c829841$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $b69570147c829841$var$needsEval = {};
var $b69570147c829841$var$TypedArray = typeof Uint8Array === "undefined" || !$b69570147c829841$var$getProto ? undefined : $b69570147c829841$var$getProto(Uint8Array);
var $b69570147c829841$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $b69570147c829841$var$hasSymbols && $b69570147c829841$var$getProto ? $b69570147c829841$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $b69570147c829841$var$needsEval,
    "%AsyncGenerator%": $b69570147c829841$var$needsEval,
    "%AsyncGeneratorFunction%": $b69570147c829841$var$needsEval,
    "%AsyncIteratorPrototype%": $b69570147c829841$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $1dJrz,
    "%eval%": eval,
    "%EvalError%": $kef4E,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $b69570147c829841$var$$Function,
    "%GeneratorFunction%": $b69570147c829841$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $b69570147c829841$var$hasSymbols && $b69570147c829841$var$getProto ? $b69570147c829841$var$getProto($b69570147c829841$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$b69570147c829841$var$hasSymbols || !$b69570147c829841$var$getProto ? undefined : $b69570147c829841$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $7egBS,
    "%ReferenceError%": $kE1zH,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$b69570147c829841$var$hasSymbols || !$b69570147c829841$var$getProto ? undefined : $b69570147c829841$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $b69570147c829841$var$hasSymbols && $b69570147c829841$var$getProto ? $b69570147c829841$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $b69570147c829841$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $ibUZq,
    "%ThrowTypeError%": $b69570147c829841$var$ThrowTypeError,
    "%TypedArray%": $b69570147c829841$var$TypedArray,
    "%TypeError%": $68H9J,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $hysju,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($b69570147c829841$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $b69570147c829841$var$errorProto = $b69570147c829841$var$getProto($b69570147c829841$var$getProto(e));
    $b69570147c829841$var$INTRINSICS["%Error.prototype%"] = $b69570147c829841$var$errorProto;
}
var $b69570147c829841$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $b69570147c829841$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $b69570147c829841$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $b69570147c829841$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $b69570147c829841$var$getProto) value = $b69570147c829841$var$getProto(gen.prototype);
    }
    $b69570147c829841$var$INTRINSICS[name] = value;
    return value;
};
var $b69570147c829841$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $32JYM = parcelRequire("32JYM");

var $2EFKW = parcelRequire("2EFKW");
var $b69570147c829841$var$$concat = $32JYM.call(Function.call, Array.prototype.concat);
var $b69570147c829841$var$$spliceApply = $32JYM.call(Function.apply, Array.prototype.splice);
var $b69570147c829841$var$$replace = $32JYM.call(Function.call, String.prototype.replace);
var $b69570147c829841$var$$strSlice = $32JYM.call(Function.call, String.prototype.slice);
var $b69570147c829841$var$$exec = $32JYM.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $b69570147c829841$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $b69570147c829841$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $b69570147c829841$var$stringToPath = function stringToPath(string) {
    var first = $b69570147c829841$var$$strSlice(string, 0, 1);
    var last = $b69570147c829841$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $ibUZq("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $ibUZq("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $b69570147c829841$var$$replace(string, $b69570147c829841$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $b69570147c829841$var$$replace(subString, $b69570147c829841$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $b69570147c829841$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($2EFKW($b69570147c829841$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $b69570147c829841$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($2EFKW($b69570147c829841$var$INTRINSICS, intrinsicName)) {
        var value = $b69570147c829841$var$INTRINSICS[intrinsicName];
        if (value === $b69570147c829841$var$needsEval) value = $b69570147c829841$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $68H9J("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $ibUZq("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $68H9J("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $68H9J('"allowMissing" argument must be a boolean');
    if ($b69570147c829841$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $ibUZq("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $b69570147c829841$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $b69570147c829841$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $b69570147c829841$var$$spliceApply(parts, $b69570147c829841$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $b69570147c829841$var$$strSlice(part, 0, 1);
        var last = $b69570147c829841$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $ibUZq("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($2EFKW($b69570147c829841$var$INTRINSICS, intrinsicRealName)) value = $b69570147c829841$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $68H9J("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($b69570147c829841$var$$gOPD && i + 1 >= parts.length) {
                var desc = $b69570147c829841$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $2EFKW(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $b69570147c829841$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("1dJrz", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("kef4E", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("7egBS", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("kE1zH", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("ibUZq", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("68H9J", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("hysju", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("lEsMR", function(module, exports) {
"use strict";
var $fc33a9e5f4baa1c6$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $lVmUo = parcelRequire("lVmUo");
module.exports = function hasNativeSymbols() {
    if (typeof $fc33a9e5f4baa1c6$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $fc33a9e5f4baa1c6$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $lVmUo();
};

});

parcelRegister("1B898", function(module, exports) {
"use strict";
var $129f90dbe45d82b4$var$test = {
    __proto__: null,
    foo: {}
};
var $129f90dbe45d82b4$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $129f90dbe45d82b4$var$test
    }).foo === $129f90dbe45d82b4$var$test.foo && !($129f90dbe45d82b4$var$test instanceof $129f90dbe45d82b4$var$$Object);
};

});

parcelRegister("32JYM", function(module, exports) {
"use strict";

var $gbazU = parcelRequire("gbazU");
module.exports = Function.prototype.bind || $gbazU;

});
parcelRegister("gbazU", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $bc75e103466337ba$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $bc75e103466337ba$var$toStr = Object.prototype.toString;
var $bc75e103466337ba$var$max = Math.max;
var $bc75e103466337ba$var$funcType = "[object Function]";
var $bc75e103466337ba$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $bc75e103466337ba$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $bc75e103466337ba$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $bc75e103466337ba$var$toStr.apply(target) !== $bc75e103466337ba$var$funcType) throw new TypeError($bc75e103466337ba$var$ERROR_MESSAGE + target);
    var args = $bc75e103466337ba$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $bc75e103466337ba$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $bc75e103466337ba$var$concatty(args, arguments));
    };
    var boundLength = $bc75e103466337ba$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $bc75e103466337ba$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("2EFKW", function(module, exports) {
"use strict";
var $1eefb51acdc071dd$var$call = Function.prototype.call;
var $1eefb51acdc071dd$var$$hasOwn = Object.prototype.hasOwnProperty;

var $32JYM = parcelRequire("32JYM");
/** @type {import('.')} */ module.exports = $32JYM.call($1eefb51acdc071dd$var$call, $1eefb51acdc071dd$var$$hasOwn);

});


parcelRegister("4xYIQ", function(module, exports) {
"use strict";

var $32JYM = parcelRequire("32JYM");

var $fFT7c = parcelRequire("fFT7c");

var $fxhsa = parcelRequire("fxhsa");

var $68H9J = parcelRequire("68H9J");
var $34f958a72c3e6828$var$$apply = $fFT7c("%Function.prototype.apply%");
var $34f958a72c3e6828$var$$call = $fFT7c("%Function.prototype.call%");
var $34f958a72c3e6828$var$$reflectApply = $fFT7c("%Reflect.apply%", true) || $32JYM.call($34f958a72c3e6828$var$$call, $34f958a72c3e6828$var$$apply);

var $68OFr = parcelRequire("68OFr");
var $34f958a72c3e6828$var$$max = $fFT7c("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $68H9J("a function is required");
    var func = $34f958a72c3e6828$var$$reflectApply($32JYM, $34f958a72c3e6828$var$$call, arguments);
    return $fxhsa(func, 1 + $34f958a72c3e6828$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $34f958a72c3e6828$var$applyBind = function applyBind() {
    return $34f958a72c3e6828$var$$reflectApply($32JYM, $34f958a72c3e6828$var$$apply, arguments);
};
if ($68OFr) $68OFr(module.exports, "apply", {
    value: $34f958a72c3e6828$var$applyBind
});
else module.exports.apply = $34f958a72c3e6828$var$applyBind;

});
parcelRegister("fxhsa", function(module, exports) {
"use strict";

var $fFT7c = parcelRequire("fFT7c");

var $2jDyv = parcelRequire("2jDyv");

var $b4f779f7718318e2$var$hasDescriptors = (parcelRequire("9A3by"))();

var $7sppP = parcelRequire("7sppP");

var $68H9J = parcelRequire("68H9J");
var $b4f779f7718318e2$var$$floor = $fFT7c("%Math.floor%");
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $68H9J("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $b4f779f7718318e2$var$$floor(length) !== length) throw new $68H9J("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $7sppP) {
        var desc = $7sppP(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($b4f779f7718318e2$var$hasDescriptors) $2jDyv(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $2jDyv(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});
parcelRegister("2jDyv", function(module, exports) {
"use strict";

var $68OFr = parcelRequire("68OFr");

var $ibUZq = parcelRequire("ibUZq");

var $68H9J = parcelRequire("68H9J");

var $7sppP = parcelRequire("7sppP");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $68H9J("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $68H9J("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $68H9J("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $68H9J("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $68H9J("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $68H9J("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$7sppP && $7sppP(obj, property);
    if ($68OFr) $68OFr(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $ibUZq("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("68OFr", function(module, exports) {
"use strict";

var $fFT7c = parcelRequire("fFT7c");
/** @type {import('.')} */ var $478acaecc09e872b$var$$defineProperty = $fFT7c("%Object.defineProperty%", true) || false;
if ($478acaecc09e872b$var$$defineProperty) try {
    $478acaecc09e872b$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $478acaecc09e872b$var$$defineProperty = false;
}
module.exports = $478acaecc09e872b$var$$defineProperty;

});

parcelRegister("7sppP", function(module, exports) {
"use strict";

var $fFT7c = parcelRequire("fFT7c");
var $56dedcf407f5fed4$var$$gOPD = $fFT7c("%Object.getOwnPropertyDescriptor%", true);
if ($56dedcf407f5fed4$var$$gOPD) try {
    $56dedcf407f5fed4$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $56dedcf407f5fed4$var$$gOPD = null;
}
module.exports = $56dedcf407f5fed4$var$$gOPD;

});


parcelRegister("9A3by", function(module, exports) {
"use strict";

var $68OFr = parcelRequire("68OFr");
var $6f99f26352031014$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$68OFr;
};
$6f99f26352031014$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$68OFr) return null;
    try {
        return $68OFr([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $6f99f26352031014$var$hasPropertyDescriptors;

});





parcelRegister("fd7v8", function(module, exports) {
"use strict";
var $b12de3826adae023$var$toStr = Object.prototype.toString;
var $b12de3826adae023$var$fnToStr = Function.prototype.toString;
var $b12de3826adae023$var$isFnRegex = /^\s*(?:function)?\*/;

var $b12de3826adae023$var$hasToStringTag = (parcelRequire("9lcIx"))();
var $b12de3826adae023$var$getProto = Object.getPrototypeOf;
var $b12de3826adae023$var$getGeneratorFunc = function() {
    if (!$b12de3826adae023$var$hasToStringTag) return false;
    try {
        return Function("return function*() {}")();
    } catch (e) {}
};
var $b12de3826adae023$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== "function") return false;
    if ($b12de3826adae023$var$isFnRegex.test($b12de3826adae023$var$fnToStr.call(fn))) return true;
    if (!$b12de3826adae023$var$hasToStringTag) {
        var str = $b12de3826adae023$var$toStr.call(fn);
        return str === "[object GeneratorFunction]";
    }
    if (!$b12de3826adae023$var$getProto) return false;
    if (typeof $b12de3826adae023$var$GeneratorFunction === "undefined") {
        var generatorFunc = $b12de3826adae023$var$getGeneratorFunc();
        $b12de3826adae023$var$GeneratorFunction = generatorFunc ? $b12de3826adae023$var$getProto(generatorFunc) : false;
    }
    return $b12de3826adae023$var$getProto(fn) === $b12de3826adae023$var$GeneratorFunction;
};

});

parcelRegister("bC4MU", function(module, exports) {
"use strict";

var $jndmA = parcelRequire("jndmA");

var $1LWSh = parcelRequire("1LWSh");

var $4xYIQ = parcelRequire("4xYIQ");

var $fvpTx = parcelRequire("fvpTx");

var $7sppP = parcelRequire("7sppP");
/** @type {(O: object) => string} */ var $8746f51bbd929fd1$var$$toString = $fvpTx("Object.prototype.toString");

var $8746f51bbd929fd1$var$hasToStringTag = (parcelRequire("9lcIx"))();
var $8746f51bbd929fd1$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
var $8746f51bbd929fd1$var$typedArrays = $1LWSh();
var $8746f51bbd929fd1$var$$slice = $fvpTx("String.prototype.slice");
var $8746f51bbd929fd1$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $8746f51bbd929fd1$var$$indexOf = $fvpTx("Array.prototype.indexOf", true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {(receiver: import('.').TypedArray) => string | typeof Uint8Array.prototype.slice.call | typeof Uint8Array.prototype.set.call} Getter */ /** @type {{ [k in `\$${import('.').TypedArrayName}`]?: Getter } & { __proto__: null }} */ var $8746f51bbd929fd1$var$cache = {
    __proto__: null
};
if ($8746f51bbd929fd1$var$hasToStringTag && $7sppP && $8746f51bbd929fd1$var$getPrototypeOf) $jndmA($8746f51bbd929fd1$var$typedArrays, function(typedArray) {
    var arr = new $8746f51bbd929fd1$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $8746f51bbd929fd1$var$getPrototypeOf(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $7sppP(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $8746f51bbd929fd1$var$getPrototypeOf(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $7sppP(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $8746f51bbd929fd1$var$cache["$" + typedArray] = $4xYIQ(descriptor.get);
    }
});
else $jndmA($8746f51bbd929fd1$var$typedArrays, function(typedArray) {
    var arr = new $8746f51bbd929fd1$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) // @ts-expect-error TODO: fix
    $8746f51bbd929fd1$var$cache["$" + typedArray] = $4xYIQ(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $8746f51bbd929fd1$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $jndmA(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ $8746f51bbd929fd1$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            if ("$" + getter(value) === typedArray) found = $8746f51bbd929fd1$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $8746f51bbd929fd1$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $jndmA(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ $8746f51bbd929fd1$var$cache, /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            getter(value);
            found = $8746f51bbd929fd1$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== "object") return false;
    if (!$8746f51bbd929fd1$var$hasToStringTag) {
        /** @type {string} */ var tag = $8746f51bbd929fd1$var$$slice($8746f51bbd929fd1$var$$toString(value), 8, -1);
        if ($8746f51bbd929fd1$var$$indexOf($8746f51bbd929fd1$var$typedArrays, tag) > -1) return tag;
        if (tag !== "Object") return false;
        // node < 0.6 hits here on real Typed Arrays
        return $8746f51bbd929fd1$var$trySlices(value);
    }
    if (!$7sppP) return null;
     // unknown engine
    return $8746f51bbd929fd1$var$tryTypedArrays(value);
};

});
parcelRegister("jndmA", function(module, exports) {
"use strict";

var $6TAlO = parcelRequire("6TAlO");
var $e1aa87fa05e709ad$var$toStr = Object.prototype.toString;
var $e1aa87fa05e709ad$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $e1aa87fa05e709ad$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($e1aa87fa05e709ad$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var $e1aa87fa05e709ad$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var $e1aa87fa05e709ad$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($e1aa87fa05e709ad$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var $e1aa87fa05e709ad$var$forEach = function forEach(list, iterator, thisArg) {
    if (!$6TAlO(iterator)) throw new TypeError("iterator must be a function");
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($e1aa87fa05e709ad$var$toStr.call(list) === "[object Array]") $e1aa87fa05e709ad$var$forEachArray(list, iterator, receiver);
    else if (typeof list === "string") $e1aa87fa05e709ad$var$forEachString(list, iterator, receiver);
    else $e1aa87fa05e709ad$var$forEachObject(list, iterator, receiver);
};
module.exports = $e1aa87fa05e709ad$var$forEach;

});
parcelRegister("6TAlO", function(module, exports) {
"use strict";
var $505413a71fb8121f$var$fnToStr = Function.prototype.toString;
var $505413a71fb8121f$var$reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
var $505413a71fb8121f$var$badArrayLike;
var $505413a71fb8121f$var$isCallableMarker;
if (typeof $505413a71fb8121f$var$reflectApply === "function" && typeof Object.defineProperty === "function") try {
    $505413a71fb8121f$var$badArrayLike = Object.defineProperty({}, "length", {
        get: function() {
            throw $505413a71fb8121f$var$isCallableMarker;
        }
    });
    $505413a71fb8121f$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $505413a71fb8121f$var$reflectApply(function() {
        throw 42;
    }, null, $505413a71fb8121f$var$badArrayLike);
} catch (_) {
    if (_ !== $505413a71fb8121f$var$isCallableMarker) $505413a71fb8121f$var$reflectApply = null;
}
else $505413a71fb8121f$var$reflectApply = null;
var $505413a71fb8121f$var$constructorRegex = /^\s*class\b/;
var $505413a71fb8121f$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $505413a71fb8121f$var$fnToStr.call(value);
        return $505413a71fb8121f$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $505413a71fb8121f$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($505413a71fb8121f$var$isES6ClassFn(value)) return false;
        $505413a71fb8121f$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $505413a71fb8121f$var$toStr = Object.prototype.toString;
var $505413a71fb8121f$var$objectClass = "[object Object]";
var $505413a71fb8121f$var$fnClass = "[object Function]";
var $505413a71fb8121f$var$genClass = "[object GeneratorFunction]";
var $505413a71fb8121f$var$ddaClass = "[object HTMLAllCollection]"; // IE 11
var $505413a71fb8121f$var$ddaClass2 = "[object HTML document.all class]";
var $505413a71fb8121f$var$ddaClass3 = "[object HTMLCollection]"; // IE 9-10
var $505413a71fb8121f$var$hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $505413a71fb8121f$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $505413a71fb8121f$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === "object") {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $505413a71fb8121f$var$all = document.all;
    if ($505413a71fb8121f$var$toStr.call($505413a71fb8121f$var$all) === $505413a71fb8121f$var$toStr.call(document.all)) $505413a71fb8121f$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($505413a71fb8121f$var$isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) try {
            var str = $505413a71fb8121f$var$toStr.call(value);
            return (str === $505413a71fb8121f$var$ddaClass || str === $505413a71fb8121f$var$ddaClass2 || str === $505413a71fb8121f$var$ddaClass3 // opera 12.16
             || str === $505413a71fb8121f$var$objectClass // IE 6-8
            ) && value("") == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $505413a71fb8121f$var$reflectApply ? function isCallable(value) {
    if ($505413a71fb8121f$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    try {
        $505413a71fb8121f$var$reflectApply(value, null, $505413a71fb8121f$var$badArrayLike);
    } catch (e) {
        if (e !== $505413a71fb8121f$var$isCallableMarker) return false;
    }
    return !$505413a71fb8121f$var$isES6ClassFn(value) && $505413a71fb8121f$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($505413a71fb8121f$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    if ($505413a71fb8121f$var$hasToStringTag) return $505413a71fb8121f$var$tryFunctionObject(value);
    if ($505413a71fb8121f$var$isES6ClassFn(value)) return false;
    var strClass = $505413a71fb8121f$var$toStr.call(value);
    if (strClass !== $505413a71fb8121f$var$fnClass && strClass !== $505413a71fb8121f$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $505413a71fb8121f$var$tryFunctionObject(value);
};

});


parcelRegister("1LWSh", function(module, exports) {
"use strict";

var $ghcFv = parcelRequire("ghcFv");
var $14a7d978ebc4e4ac$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $ghcFv.length; i++)if (typeof $14a7d978ebc4e4ac$var$g[$ghcFv[i]] === "function") // @ts-expect-error
    out[out.length] = $ghcFv[i];
    return out;
};

});
parcelRegister("ghcFv", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = [
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Int16Array",
    "Int32Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array"
];

});



parcelRegister("i9pTi", function(module, exports) {
"use strict";

var $bC4MU = parcelRequire("bC4MU");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$bC4MU(value);
};

});


parcelRegister("1ec4D", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
};

});

parcelRegister("fvL6U", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});





parcelRegister("uyyW1", function(module, exports) {
"use strict";
/** @typedef {import('./types').CodecFactory} CodecFactory */ /**
 * @param {string} string
 * @param {string} alphabet
 * @param {number} bitsPerChar
 * @returns {Uint8Array}
 */ const $05bd9cd784b9de35$var$decode = (string, alphabet, bitsPerChar)=>{
    // Build the character lookup table:
    /** @type {Record<string, number>} */ const codes = {};
    for(let i = 0; i < alphabet.length; ++i)codes[alphabet[i]] = i;
    // Count the padding bytes:
    let end = string.length;
    while(string[end - 1] === "=")--end;
    // Allocate the output:
    const out = new Uint8Array(end * bitsPerChar / 8 | 0);
    // Parse the data:
    let bits = 0 // Number of bits currently in the buffer
    ;
    let buffer = 0 // Bits waiting to be written out, MSB first
    ;
    let written = 0 // Next byte to write
    ;
    for(let i = 0; i < end; ++i){
        // Read one character from the string:
        const value = codes[string[i]];
        if (value === undefined) throw new SyntaxError("Invalid character " + string[i]);
        // Append the bits to the buffer:
        buffer = buffer << bitsPerChar | value;
        bits += bitsPerChar;
        // Write out some bits if the buffer has a byte's worth:
        if (bits >= 8) {
            bits -= 8;
            out[written++] = 0xff & buffer >> bits;
        }
    }
    // Verify that we have received just enough bits:
    if (bits >= bitsPerChar || 0xff & buffer << 8 - bits) throw new SyntaxError("Unexpected end of data");
    return out;
};
/**
 * @param {Uint8Array} data
 * @param {string} alphabet
 * @param {number} bitsPerChar
 * @returns {string}
 */ const $05bd9cd784b9de35$var$encode = (data, alphabet, bitsPerChar)=>{
    const pad = alphabet[alphabet.length - 1] === "=";
    const mask = (1 << bitsPerChar) - 1;
    let out = "";
    let bits = 0 // Number of bits currently in the buffer
    ;
    let buffer = 0 // Bits waiting to be written out, MSB first
    ;
    for(let i = 0; i < data.length; ++i){
        // Slurp data into the buffer:
        buffer = buffer << 8 | data[i];
        bits += 8;
        // Write out as much as we can:
        while(bits > bitsPerChar){
            bits -= bitsPerChar;
            out += alphabet[mask & buffer >> bits];
        }
    }
    // Partial character:
    if (bits) out += alphabet[mask & buffer << bitsPerChar - bits];
    // Add padding characters until we hit a byte boundary:
    if (pad) while(out.length * bitsPerChar & 7)out += "=";
    return out;
};
/**
 * RFC4648 Factory
 *
 * @param {number} bitsPerChar
 * @returns {CodecFactory}
 */ const $05bd9cd784b9de35$var$rfc4648 = (bitsPerChar)=>(alphabet)=>{
        return {
            /**
     * @param {Uint8Array} input
     * @returns {string}
     */ encode (input) {
                return $05bd9cd784b9de35$var$encode(input, alphabet, bitsPerChar);
            },
            /**
     * @param {string} input
     * @returns {Uint8Array}
     */ decode (input) {
                return $05bd9cd784b9de35$var$decode(input, alphabet, bitsPerChar);
            }
        };
    };
module.exports = {
    rfc4648: $05bd9cd784b9de35$var$rfc4648
};

});



parcelRegister("lg1mP", function(module, exports) {



module.exports = {
    encode: (parcelRequire("i4wfg")),
    decode: (parcelRequire("8WKGb")),
    encodingLength: (parcelRequire("0cSFE"))
};

});
parcelRegister("i4wfg", function(module, exports) {
module.exports = $d2819cf4ab326775$var$encode;
var $d2819cf4ab326775$var$MSB = 0x80, $d2819cf4ab326775$var$REST = 0x7F, $d2819cf4ab326775$var$MSBALL = ~$d2819cf4ab326775$var$REST, $d2819cf4ab326775$var$INT = Math.pow(2, 31);
function $d2819cf4ab326775$var$encode(num, out, offset) {
    if (Number.MAX_SAFE_INTEGER && num > Number.MAX_SAFE_INTEGER) {
        $d2819cf4ab326775$var$encode.bytes = 0;
        throw new RangeError("Could not encode varint");
    }
    out = out || [];
    offset = offset || 0;
    var oldOffset = offset;
    while(num >= $d2819cf4ab326775$var$INT){
        out[offset++] = num & 0xFF | $d2819cf4ab326775$var$MSB;
        num /= 128;
    }
    while(num & $d2819cf4ab326775$var$MSBALL){
        out[offset++] = num & 0xFF | $d2819cf4ab326775$var$MSB;
        num >>>= 7;
    }
    out[offset] = num | 0;
    $d2819cf4ab326775$var$encode.bytes = offset - oldOffset + 1;
    return out;
}

});

parcelRegister("8WKGb", function(module, exports) {
module.exports = $6837f31518090046$var$read;
var $6837f31518090046$var$MSB = 0x80, $6837f31518090046$var$REST = 0x7F;
function $6837f31518090046$var$read(buf, offset) {
    var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
    do {
        if (counter >= l || shift > 49) {
            $6837f31518090046$var$read.bytes = 0;
            throw new RangeError("Could not decode varint");
        }
        b = buf[counter++];
        res += shift < 28 ? (b & $6837f31518090046$var$REST) << shift : (b & $6837f31518090046$var$REST) * Math.pow(2, shift);
        shift += 7;
    }while (b >= $6837f31518090046$var$MSB);
    $6837f31518090046$var$read.bytes = counter - offset;
    return res;
}

});

parcelRegister("0cSFE", function(module, exports) {
var $0009fe0ebb08caf7$var$N1 = Math.pow(2, 7);
var $0009fe0ebb08caf7$var$N2 = Math.pow(2, 14);
var $0009fe0ebb08caf7$var$N3 = Math.pow(2, 21);
var $0009fe0ebb08caf7$var$N4 = Math.pow(2, 28);
var $0009fe0ebb08caf7$var$N5 = Math.pow(2, 35);
var $0009fe0ebb08caf7$var$N6 = Math.pow(2, 42);
var $0009fe0ebb08caf7$var$N7 = Math.pow(2, 49);
var $0009fe0ebb08caf7$var$N8 = Math.pow(2, 56);
var $0009fe0ebb08caf7$var$N9 = Math.pow(2, 63);
module.exports = function(value) {
    return value < $0009fe0ebb08caf7$var$N1 ? 1 : value < $0009fe0ebb08caf7$var$N2 ? 2 : value < $0009fe0ebb08caf7$var$N3 ? 3 : value < $0009fe0ebb08caf7$var$N4 ? 4 : value < $0009fe0ebb08caf7$var$N5 ? 5 : value < $0009fe0ebb08caf7$var$N6 ? 6 : value < $0009fe0ebb08caf7$var$N7 ? 7 : value < $0009fe0ebb08caf7$var$N8 ? 8 : value < $0009fe0ebb08caf7$var$N9 ? 9 : 10;
};

});


parcelRegister("lPX1n", function(module, exports) {
/* eslint quote-props: off */ "use strict";
/**
 * Names for all available hashes
 *
 * @typedef { "identity" | "sha1" | "sha2-256" | "sha2-512" | "sha3-512" | "sha3-384" | "sha3-256" | "sha3-224" | "shake-128" | "shake-256" | "keccak-224" | "keccak-256" | "keccak-384" | "keccak-512" | "blake3" | "murmur3-128" | "murmur3-32" | "dbl-sha2-256" | "md4" | "md5" | "bmt" | "sha2-256-trunc254-padded" | "ripemd-128" | "ripemd-160" | "ripemd-256" | "ripemd-320" | "x11" | "kangarootwelve" | "sm3-256" | "blake2b-8" | "blake2b-16" | "blake2b-24" | "blake2b-32" | "blake2b-40" | "blake2b-48" | "blake2b-56" | "blake2b-64" | "blake2b-72" | "blake2b-80" | "blake2b-88" | "blake2b-96" | "blake2b-104" | "blake2b-112" | "blake2b-120" | "blake2b-128" | "blake2b-136" | "blake2b-144" | "blake2b-152" | "blake2b-160" | "blake2b-168" | "blake2b-176" | "blake2b-184" | "blake2b-192" | "blake2b-200" | "blake2b-208" | "blake2b-216" | "blake2b-224" | "blake2b-232" | "blake2b-240" | "blake2b-248" | "blake2b-256" | "blake2b-264" | "blake2b-272" | "blake2b-280" | "blake2b-288" | "blake2b-296" | "blake2b-304" | "blake2b-312" | "blake2b-320" | "blake2b-328" | "blake2b-336" | "blake2b-344" | "blake2b-352" | "blake2b-360" | "blake2b-368" | "blake2b-376" | "blake2b-384" | "blake2b-392" | "blake2b-400" | "blake2b-408" | "blake2b-416" | "blake2b-424" | "blake2b-432" | "blake2b-440" | "blake2b-448" | "blake2b-456" | "blake2b-464" | "blake2b-472" | "blake2b-480" | "blake2b-488" | "blake2b-496" | "blake2b-504" | "blake2b-512" | "blake2s-8" | "blake2s-16" | "blake2s-24" | "blake2s-32" | "blake2s-40" | "blake2s-48" | "blake2s-56" | "blake2s-64" | "blake2s-72" | "blake2s-80" | "blake2s-88" | "blake2s-96" | "blake2s-104" | "blake2s-112" | "blake2s-120" | "blake2s-128" | "blake2s-136" | "blake2s-144" | "blake2s-152" | "blake2s-160" | "blake2s-168" | "blake2s-176" | "blake2s-184" | "blake2s-192" | "blake2s-200" | "blake2s-208" | "blake2s-216" | "blake2s-224" | "blake2s-232" | "blake2s-240" | "blake2s-248" | "blake2s-256" | "skein256-8" | "skein256-16" | "skein256-24" | "skein256-32" | "skein256-40" | "skein256-48" | "skein256-56" | "skein256-64" | "skein256-72" | "skein256-80" | "skein256-88" | "skein256-96" | "skein256-104" | "skein256-112" | "skein256-120" | "skein256-128" | "skein256-136" | "skein256-144" | "skein256-152" | "skein256-160" | "skein256-168" | "skein256-176" | "skein256-184" | "skein256-192" | "skein256-200" | "skein256-208" | "skein256-216" | "skein256-224" | "skein256-232" | "skein256-240" | "skein256-248" | "skein256-256" | "skein512-8" | "skein512-16" | "skein512-24" | "skein512-32" | "skein512-40" | "skein512-48" | "skein512-56" | "skein512-64" | "skein512-72" | "skein512-80" | "skein512-88" | "skein512-96" | "skein512-104" | "skein512-112" | "skein512-120" | "skein512-128" | "skein512-136" | "skein512-144" | "skein512-152" | "skein512-160" | "skein512-168" | "skein512-176" | "skein512-184" | "skein512-192" | "skein512-200" | "skein512-208" | "skein512-216" | "skein512-224" | "skein512-232" | "skein512-240" | "skein512-248" | "skein512-256" | "skein512-264" | "skein512-272" | "skein512-280" | "skein512-288" | "skein512-296" | "skein512-304" | "skein512-312" | "skein512-320" | "skein512-328" | "skein512-336" | "skein512-344" | "skein512-352" | "skein512-360" | "skein512-368" | "skein512-376" | "skein512-384" | "skein512-392" | "skein512-400" | "skein512-408" | "skein512-416" | "skein512-424" | "skein512-432" | "skein512-440" | "skein512-448" | "skein512-456" | "skein512-464" | "skein512-472" | "skein512-480" | "skein512-488" | "skein512-496" | "skein512-504" | "skein512-512" | "skein1024-8" | "skein1024-16" | "skein1024-24" | "skein1024-32" | "skein1024-40" | "skein1024-48" | "skein1024-56" | "skein1024-64" | "skein1024-72" | "skein1024-80" | "skein1024-88" | "skein1024-96" | "skein1024-104" | "skein1024-112" | "skein1024-120" | "skein1024-128" | "skein1024-136" | "skein1024-144" | "skein1024-152" | "skein1024-160" | "skein1024-168" | "skein1024-176" | "skein1024-184" | "skein1024-192" | "skein1024-200" | "skein1024-208" | "skein1024-216" | "skein1024-224" | "skein1024-232" | "skein1024-240" | "skein1024-248" | "skein1024-256" | "skein1024-264" | "skein1024-272" | "skein1024-280" | "skein1024-288" | "skein1024-296" | "skein1024-304" | "skein1024-312" | "skein1024-320" | "skein1024-328" | "skein1024-336" | "skein1024-344" | "skein1024-352" | "skein1024-360" | "skein1024-368" | "skein1024-376" | "skein1024-384" | "skein1024-392" | "skein1024-400" | "skein1024-408" | "skein1024-416" | "skein1024-424" | "skein1024-432" | "skein1024-440" | "skein1024-448" | "skein1024-456" | "skein1024-464" | "skein1024-472" | "skein1024-480" | "skein1024-488" | "skein1024-496" | "skein1024-504" | "skein1024-512" | "skein1024-520" | "skein1024-528" | "skein1024-536" | "skein1024-544" | "skein1024-552" | "skein1024-560" | "skein1024-568" | "skein1024-576" | "skein1024-584" | "skein1024-592" | "skein1024-600" | "skein1024-608" | "skein1024-616" | "skein1024-624" | "skein1024-632" | "skein1024-640" | "skein1024-648" | "skein1024-656" | "skein1024-664" | "skein1024-672" | "skein1024-680" | "skein1024-688" | "skein1024-696" | "skein1024-704" | "skein1024-712" | "skein1024-720" | "skein1024-728" | "skein1024-736" | "skein1024-744" | "skein1024-752" | "skein1024-760" | "skein1024-768" | "skein1024-776" | "skein1024-784" | "skein1024-792" | "skein1024-800" | "skein1024-808" | "skein1024-816" | "skein1024-824" | "skein1024-832" | "skein1024-840" | "skein1024-848" | "skein1024-856" | "skein1024-864" | "skein1024-872" | "skein1024-880" | "skein1024-888" | "skein1024-896" | "skein1024-904" | "skein1024-912" | "skein1024-920" | "skein1024-928" | "skein1024-936" | "skein1024-944" | "skein1024-952" | "skein1024-960" | "skein1024-968" | "skein1024-976" | "skein1024-984" | "skein1024-992" | "skein1024-1000" | "skein1024-1008" | "skein1024-1016" | "skein1024-1024" | "poseidon-bls12_381-a2-fc1" | "poseidon-bls12_381-a2-fc1-sc" } HashName
 */ /**
 * Codes for all available hashes
 *
 * @typedef { 0x00 | 0x11 | 0x12 | 0x13 | 0x14 | 0x15 | 0x16 | 0x17 | 0x18 | 0x19 | 0x1a | 0x1b | 0x1c | 0x1d | 0x1e | 0x22 | 0x23 | 0x56 | 0xd4 | 0xd5 | 0xd6 | 0x1012 | 0x1052 | 0x1053 | 0x1054 | 0x1055 | 0x1100 | 0x1d01 | 0x534d | 0xb201 | 0xb202 | 0xb203 | 0xb204 | 0xb205 | 0xb206 | 0xb207 | 0xb208 | 0xb209 | 0xb20a | 0xb20b | 0xb20c | 0xb20d | 0xb20e | 0xb20f | 0xb210 | 0xb211 | 0xb212 | 0xb213 | 0xb214 | 0xb215 | 0xb216 | 0xb217 | 0xb218 | 0xb219 | 0xb21a | 0xb21b | 0xb21c | 0xb21d | 0xb21e | 0xb21f | 0xb220 | 0xb221 | 0xb222 | 0xb223 | 0xb224 | 0xb225 | 0xb226 | 0xb227 | 0xb228 | 0xb229 | 0xb22a | 0xb22b | 0xb22c | 0xb22d | 0xb22e | 0xb22f | 0xb230 | 0xb231 | 0xb232 | 0xb233 | 0xb234 | 0xb235 | 0xb236 | 0xb237 | 0xb238 | 0xb239 | 0xb23a | 0xb23b | 0xb23c | 0xb23d | 0xb23e | 0xb23f | 0xb240 | 0xb241 | 0xb242 | 0xb243 | 0xb244 | 0xb245 | 0xb246 | 0xb247 | 0xb248 | 0xb249 | 0xb24a | 0xb24b | 0xb24c | 0xb24d | 0xb24e | 0xb24f | 0xb250 | 0xb251 | 0xb252 | 0xb253 | 0xb254 | 0xb255 | 0xb256 | 0xb257 | 0xb258 | 0xb259 | 0xb25a | 0xb25b | 0xb25c | 0xb25d | 0xb25e | 0xb25f | 0xb260 | 0xb301 | 0xb302 | 0xb303 | 0xb304 | 0xb305 | 0xb306 | 0xb307 | 0xb308 | 0xb309 | 0xb30a | 0xb30b | 0xb30c | 0xb30d | 0xb30e | 0xb30f | 0xb310 | 0xb311 | 0xb312 | 0xb313 | 0xb314 | 0xb315 | 0xb316 | 0xb317 | 0xb318 | 0xb319 | 0xb31a | 0xb31b | 0xb31c | 0xb31d | 0xb31e | 0xb31f | 0xb320 | 0xb321 | 0xb322 | 0xb323 | 0xb324 | 0xb325 | 0xb326 | 0xb327 | 0xb328 | 0xb329 | 0xb32a | 0xb32b | 0xb32c | 0xb32d | 0xb32e | 0xb32f | 0xb330 | 0xb331 | 0xb332 | 0xb333 | 0xb334 | 0xb335 | 0xb336 | 0xb337 | 0xb338 | 0xb339 | 0xb33a | 0xb33b | 0xb33c | 0xb33d | 0xb33e | 0xb33f | 0xb340 | 0xb341 | 0xb342 | 0xb343 | 0xb344 | 0xb345 | 0xb346 | 0xb347 | 0xb348 | 0xb349 | 0xb34a | 0xb34b | 0xb34c | 0xb34d | 0xb34e | 0xb34f | 0xb350 | 0xb351 | 0xb352 | 0xb353 | 0xb354 | 0xb355 | 0xb356 | 0xb357 | 0xb358 | 0xb359 | 0xb35a | 0xb35b | 0xb35c | 0xb35d | 0xb35e | 0xb35f | 0xb360 | 0xb361 | 0xb362 | 0xb363 | 0xb364 | 0xb365 | 0xb366 | 0xb367 | 0xb368 | 0xb369 | 0xb36a | 0xb36b | 0xb36c | 0xb36d | 0xb36e | 0xb36f | 0xb370 | 0xb371 | 0xb372 | 0xb373 | 0xb374 | 0xb375 | 0xb376 | 0xb377 | 0xb378 | 0xb379 | 0xb37a | 0xb37b | 0xb37c | 0xb37d | 0xb37e | 0xb37f | 0xb380 | 0xb381 | 0xb382 | 0xb383 | 0xb384 | 0xb385 | 0xb386 | 0xb387 | 0xb388 | 0xb389 | 0xb38a | 0xb38b | 0xb38c | 0xb38d | 0xb38e | 0xb38f | 0xb390 | 0xb391 | 0xb392 | 0xb393 | 0xb394 | 0xb395 | 0xb396 | 0xb397 | 0xb398 | 0xb399 | 0xb39a | 0xb39b | 0xb39c | 0xb39d | 0xb39e | 0xb39f | 0xb3a0 | 0xb3a1 | 0xb3a2 | 0xb3a3 | 0xb3a4 | 0xb3a5 | 0xb3a6 | 0xb3a7 | 0xb3a8 | 0xb3a9 | 0xb3aa | 0xb3ab | 0xb3ac | 0xb3ad | 0xb3ae | 0xb3af | 0xb3b0 | 0xb3b1 | 0xb3b2 | 0xb3b3 | 0xb3b4 | 0xb3b5 | 0xb3b6 | 0xb3b7 | 0xb3b8 | 0xb3b9 | 0xb3ba | 0xb3bb | 0xb3bc | 0xb3bd | 0xb3be | 0xb3bf | 0xb3c0 | 0xb3c1 | 0xb3c2 | 0xb3c3 | 0xb3c4 | 0xb3c5 | 0xb3c6 | 0xb3c7 | 0xb3c8 | 0xb3c9 | 0xb3ca | 0xb3cb | 0xb3cc | 0xb3cd | 0xb3ce | 0xb3cf | 0xb3d0 | 0xb3d1 | 0xb3d2 | 0xb3d3 | 0xb3d4 | 0xb3d5 | 0xb3d6 | 0xb3d7 | 0xb3d8 | 0xb3d9 | 0xb3da | 0xb3db | 0xb3dc | 0xb3dd | 0xb3de | 0xb3df | 0xb3e0 | 0xb401 | 0xb402 } HashCode
 */ /**
 * @type { Record<HashName,HashCode> }
 */ const $fe5c24ccc9d8f463$var$names = Object.freeze({
    "identity": 0x00,
    "sha1": 0x11,
    "sha2-256": 0x12,
    "sha2-512": 0x13,
    "sha3-512": 0x14,
    "sha3-384": 0x15,
    "sha3-256": 0x16,
    "sha3-224": 0x17,
    "shake-128": 0x18,
    "shake-256": 0x19,
    "keccak-224": 0x1a,
    "keccak-256": 0x1b,
    "keccak-384": 0x1c,
    "keccak-512": 0x1d,
    "blake3": 0x1e,
    "murmur3-128": 0x22,
    "murmur3-32": 0x23,
    "dbl-sha2-256": 0x56,
    "md4": 0xd4,
    "md5": 0xd5,
    "bmt": 0xd6,
    "sha2-256-trunc254-padded": 0x1012,
    "ripemd-128": 0x1052,
    "ripemd-160": 0x1053,
    "ripemd-256": 0x1054,
    "ripemd-320": 0x1055,
    "x11": 0x1100,
    "kangarootwelve": 0x1d01,
    "sm3-256": 0x534d,
    "blake2b-8": 0xb201,
    "blake2b-16": 0xb202,
    "blake2b-24": 0xb203,
    "blake2b-32": 0xb204,
    "blake2b-40": 0xb205,
    "blake2b-48": 0xb206,
    "blake2b-56": 0xb207,
    "blake2b-64": 0xb208,
    "blake2b-72": 0xb209,
    "blake2b-80": 0xb20a,
    "blake2b-88": 0xb20b,
    "blake2b-96": 0xb20c,
    "blake2b-104": 0xb20d,
    "blake2b-112": 0xb20e,
    "blake2b-120": 0xb20f,
    "blake2b-128": 0xb210,
    "blake2b-136": 0xb211,
    "blake2b-144": 0xb212,
    "blake2b-152": 0xb213,
    "blake2b-160": 0xb214,
    "blake2b-168": 0xb215,
    "blake2b-176": 0xb216,
    "blake2b-184": 0xb217,
    "blake2b-192": 0xb218,
    "blake2b-200": 0xb219,
    "blake2b-208": 0xb21a,
    "blake2b-216": 0xb21b,
    "blake2b-224": 0xb21c,
    "blake2b-232": 0xb21d,
    "blake2b-240": 0xb21e,
    "blake2b-248": 0xb21f,
    "blake2b-256": 0xb220,
    "blake2b-264": 0xb221,
    "blake2b-272": 0xb222,
    "blake2b-280": 0xb223,
    "blake2b-288": 0xb224,
    "blake2b-296": 0xb225,
    "blake2b-304": 0xb226,
    "blake2b-312": 0xb227,
    "blake2b-320": 0xb228,
    "blake2b-328": 0xb229,
    "blake2b-336": 0xb22a,
    "blake2b-344": 0xb22b,
    "blake2b-352": 0xb22c,
    "blake2b-360": 0xb22d,
    "blake2b-368": 0xb22e,
    "blake2b-376": 0xb22f,
    "blake2b-384": 0xb230,
    "blake2b-392": 0xb231,
    "blake2b-400": 0xb232,
    "blake2b-408": 0xb233,
    "blake2b-416": 0xb234,
    "blake2b-424": 0xb235,
    "blake2b-432": 0xb236,
    "blake2b-440": 0xb237,
    "blake2b-448": 0xb238,
    "blake2b-456": 0xb239,
    "blake2b-464": 0xb23a,
    "blake2b-472": 0xb23b,
    "blake2b-480": 0xb23c,
    "blake2b-488": 0xb23d,
    "blake2b-496": 0xb23e,
    "blake2b-504": 0xb23f,
    "blake2b-512": 0xb240,
    "blake2s-8": 0xb241,
    "blake2s-16": 0xb242,
    "blake2s-24": 0xb243,
    "blake2s-32": 0xb244,
    "blake2s-40": 0xb245,
    "blake2s-48": 0xb246,
    "blake2s-56": 0xb247,
    "blake2s-64": 0xb248,
    "blake2s-72": 0xb249,
    "blake2s-80": 0xb24a,
    "blake2s-88": 0xb24b,
    "blake2s-96": 0xb24c,
    "blake2s-104": 0xb24d,
    "blake2s-112": 0xb24e,
    "blake2s-120": 0xb24f,
    "blake2s-128": 0xb250,
    "blake2s-136": 0xb251,
    "blake2s-144": 0xb252,
    "blake2s-152": 0xb253,
    "blake2s-160": 0xb254,
    "blake2s-168": 0xb255,
    "blake2s-176": 0xb256,
    "blake2s-184": 0xb257,
    "blake2s-192": 0xb258,
    "blake2s-200": 0xb259,
    "blake2s-208": 0xb25a,
    "blake2s-216": 0xb25b,
    "blake2s-224": 0xb25c,
    "blake2s-232": 0xb25d,
    "blake2s-240": 0xb25e,
    "blake2s-248": 0xb25f,
    "blake2s-256": 0xb260,
    "skein256-8": 0xb301,
    "skein256-16": 0xb302,
    "skein256-24": 0xb303,
    "skein256-32": 0xb304,
    "skein256-40": 0xb305,
    "skein256-48": 0xb306,
    "skein256-56": 0xb307,
    "skein256-64": 0xb308,
    "skein256-72": 0xb309,
    "skein256-80": 0xb30a,
    "skein256-88": 0xb30b,
    "skein256-96": 0xb30c,
    "skein256-104": 0xb30d,
    "skein256-112": 0xb30e,
    "skein256-120": 0xb30f,
    "skein256-128": 0xb310,
    "skein256-136": 0xb311,
    "skein256-144": 0xb312,
    "skein256-152": 0xb313,
    "skein256-160": 0xb314,
    "skein256-168": 0xb315,
    "skein256-176": 0xb316,
    "skein256-184": 0xb317,
    "skein256-192": 0xb318,
    "skein256-200": 0xb319,
    "skein256-208": 0xb31a,
    "skein256-216": 0xb31b,
    "skein256-224": 0xb31c,
    "skein256-232": 0xb31d,
    "skein256-240": 0xb31e,
    "skein256-248": 0xb31f,
    "skein256-256": 0xb320,
    "skein512-8": 0xb321,
    "skein512-16": 0xb322,
    "skein512-24": 0xb323,
    "skein512-32": 0xb324,
    "skein512-40": 0xb325,
    "skein512-48": 0xb326,
    "skein512-56": 0xb327,
    "skein512-64": 0xb328,
    "skein512-72": 0xb329,
    "skein512-80": 0xb32a,
    "skein512-88": 0xb32b,
    "skein512-96": 0xb32c,
    "skein512-104": 0xb32d,
    "skein512-112": 0xb32e,
    "skein512-120": 0xb32f,
    "skein512-128": 0xb330,
    "skein512-136": 0xb331,
    "skein512-144": 0xb332,
    "skein512-152": 0xb333,
    "skein512-160": 0xb334,
    "skein512-168": 0xb335,
    "skein512-176": 0xb336,
    "skein512-184": 0xb337,
    "skein512-192": 0xb338,
    "skein512-200": 0xb339,
    "skein512-208": 0xb33a,
    "skein512-216": 0xb33b,
    "skein512-224": 0xb33c,
    "skein512-232": 0xb33d,
    "skein512-240": 0xb33e,
    "skein512-248": 0xb33f,
    "skein512-256": 0xb340,
    "skein512-264": 0xb341,
    "skein512-272": 0xb342,
    "skein512-280": 0xb343,
    "skein512-288": 0xb344,
    "skein512-296": 0xb345,
    "skein512-304": 0xb346,
    "skein512-312": 0xb347,
    "skein512-320": 0xb348,
    "skein512-328": 0xb349,
    "skein512-336": 0xb34a,
    "skein512-344": 0xb34b,
    "skein512-352": 0xb34c,
    "skein512-360": 0xb34d,
    "skein512-368": 0xb34e,
    "skein512-376": 0xb34f,
    "skein512-384": 0xb350,
    "skein512-392": 0xb351,
    "skein512-400": 0xb352,
    "skein512-408": 0xb353,
    "skein512-416": 0xb354,
    "skein512-424": 0xb355,
    "skein512-432": 0xb356,
    "skein512-440": 0xb357,
    "skein512-448": 0xb358,
    "skein512-456": 0xb359,
    "skein512-464": 0xb35a,
    "skein512-472": 0xb35b,
    "skein512-480": 0xb35c,
    "skein512-488": 0xb35d,
    "skein512-496": 0xb35e,
    "skein512-504": 0xb35f,
    "skein512-512": 0xb360,
    "skein1024-8": 0xb361,
    "skein1024-16": 0xb362,
    "skein1024-24": 0xb363,
    "skein1024-32": 0xb364,
    "skein1024-40": 0xb365,
    "skein1024-48": 0xb366,
    "skein1024-56": 0xb367,
    "skein1024-64": 0xb368,
    "skein1024-72": 0xb369,
    "skein1024-80": 0xb36a,
    "skein1024-88": 0xb36b,
    "skein1024-96": 0xb36c,
    "skein1024-104": 0xb36d,
    "skein1024-112": 0xb36e,
    "skein1024-120": 0xb36f,
    "skein1024-128": 0xb370,
    "skein1024-136": 0xb371,
    "skein1024-144": 0xb372,
    "skein1024-152": 0xb373,
    "skein1024-160": 0xb374,
    "skein1024-168": 0xb375,
    "skein1024-176": 0xb376,
    "skein1024-184": 0xb377,
    "skein1024-192": 0xb378,
    "skein1024-200": 0xb379,
    "skein1024-208": 0xb37a,
    "skein1024-216": 0xb37b,
    "skein1024-224": 0xb37c,
    "skein1024-232": 0xb37d,
    "skein1024-240": 0xb37e,
    "skein1024-248": 0xb37f,
    "skein1024-256": 0xb380,
    "skein1024-264": 0xb381,
    "skein1024-272": 0xb382,
    "skein1024-280": 0xb383,
    "skein1024-288": 0xb384,
    "skein1024-296": 0xb385,
    "skein1024-304": 0xb386,
    "skein1024-312": 0xb387,
    "skein1024-320": 0xb388,
    "skein1024-328": 0xb389,
    "skein1024-336": 0xb38a,
    "skein1024-344": 0xb38b,
    "skein1024-352": 0xb38c,
    "skein1024-360": 0xb38d,
    "skein1024-368": 0xb38e,
    "skein1024-376": 0xb38f,
    "skein1024-384": 0xb390,
    "skein1024-392": 0xb391,
    "skein1024-400": 0xb392,
    "skein1024-408": 0xb393,
    "skein1024-416": 0xb394,
    "skein1024-424": 0xb395,
    "skein1024-432": 0xb396,
    "skein1024-440": 0xb397,
    "skein1024-448": 0xb398,
    "skein1024-456": 0xb399,
    "skein1024-464": 0xb39a,
    "skein1024-472": 0xb39b,
    "skein1024-480": 0xb39c,
    "skein1024-488": 0xb39d,
    "skein1024-496": 0xb39e,
    "skein1024-504": 0xb39f,
    "skein1024-512": 0xb3a0,
    "skein1024-520": 0xb3a1,
    "skein1024-528": 0xb3a2,
    "skein1024-536": 0xb3a3,
    "skein1024-544": 0xb3a4,
    "skein1024-552": 0xb3a5,
    "skein1024-560": 0xb3a6,
    "skein1024-568": 0xb3a7,
    "skein1024-576": 0xb3a8,
    "skein1024-584": 0xb3a9,
    "skein1024-592": 0xb3aa,
    "skein1024-600": 0xb3ab,
    "skein1024-608": 0xb3ac,
    "skein1024-616": 0xb3ad,
    "skein1024-624": 0xb3ae,
    "skein1024-632": 0xb3af,
    "skein1024-640": 0xb3b0,
    "skein1024-648": 0xb3b1,
    "skein1024-656": 0xb3b2,
    "skein1024-664": 0xb3b3,
    "skein1024-672": 0xb3b4,
    "skein1024-680": 0xb3b5,
    "skein1024-688": 0xb3b6,
    "skein1024-696": 0xb3b7,
    "skein1024-704": 0xb3b8,
    "skein1024-712": 0xb3b9,
    "skein1024-720": 0xb3ba,
    "skein1024-728": 0xb3bb,
    "skein1024-736": 0xb3bc,
    "skein1024-744": 0xb3bd,
    "skein1024-752": 0xb3be,
    "skein1024-760": 0xb3bf,
    "skein1024-768": 0xb3c0,
    "skein1024-776": 0xb3c1,
    "skein1024-784": 0xb3c2,
    "skein1024-792": 0xb3c3,
    "skein1024-800": 0xb3c4,
    "skein1024-808": 0xb3c5,
    "skein1024-816": 0xb3c6,
    "skein1024-824": 0xb3c7,
    "skein1024-832": 0xb3c8,
    "skein1024-840": 0xb3c9,
    "skein1024-848": 0xb3ca,
    "skein1024-856": 0xb3cb,
    "skein1024-864": 0xb3cc,
    "skein1024-872": 0xb3cd,
    "skein1024-880": 0xb3ce,
    "skein1024-888": 0xb3cf,
    "skein1024-896": 0xb3d0,
    "skein1024-904": 0xb3d1,
    "skein1024-912": 0xb3d2,
    "skein1024-920": 0xb3d3,
    "skein1024-928": 0xb3d4,
    "skein1024-936": 0xb3d5,
    "skein1024-944": 0xb3d6,
    "skein1024-952": 0xb3d7,
    "skein1024-960": 0xb3d8,
    "skein1024-968": 0xb3d9,
    "skein1024-976": 0xb3da,
    "skein1024-984": 0xb3db,
    "skein1024-992": 0xb3dc,
    "skein1024-1000": 0xb3dd,
    "skein1024-1008": 0xb3de,
    "skein1024-1016": 0xb3df,
    "skein1024-1024": 0xb3e0,
    "poseidon-bls12_381-a2-fc1": 0xb401,
    "poseidon-bls12_381-a2-fc1-sc": 0xb402
});
module.exports = {
    names: $fe5c24ccc9d8f463$var$names
};

});

parcelRegister("57dKE", function(module, exports) {
"use strict";

var $cKKV3 = parcelRequire("cKKV3");
/**
 * @typedef {import('./util/bases').SupportedEncodings} SupportedEncodings
 */ /**
 * Turns a `Uint8Array` into a string.
 *
 * Supports `utf8`, `utf-8` and any encoding supported by the multibase module.
 *
 * Also `ascii` which is similar to node's 'binary' encoding.
 *
 * @param {Uint8Array} array - The array to turn into a string
 * @param {SupportedEncodings} [encoding=utf8] - The encoding to use
 * @returns {string}
 */ function $3b9845f36f3548ab$var$toString(array, encoding = "utf8") {
    const base = $cKKV3[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    // strip multibase prefix
    return base.encoder.encode(array).substring(1);
}
module.exports = $3b9845f36f3548ab$var$toString;

});
parcelRegister("cKKV3", function(module, exports) {
"use strict";

var $c0Nzu = parcelRequire("c0Nzu");
var $948e2d1c026ff27e$require$bases = $c0Nzu.bases;
/**
 * @typedef {import('multiformats/bases/interface').MultibaseCodec<any>} MultibaseCodec
 */ /**
 * @param {string} name
 * @param {string} prefix
 * @param {(buf: Uint8Array) => string} encode
 * @param {(str: string) => Uint8Array} decode
 * @returns {MultibaseCodec}
 */ function $948e2d1c026ff27e$var$createCodec(name, prefix, encode, decode) {
    return {
        name: name,
        prefix: prefix,
        encoder: {
            name: name,
            prefix: prefix,
            encode: encode
        },
        decoder: {
            decode: decode
        }
    };
}
const $948e2d1c026ff27e$var$string = $948e2d1c026ff27e$var$createCodec("utf8", "u", (buf)=>{
    const decoder = new TextDecoder("utf8");
    return "u" + decoder.decode(buf);
}, (str)=>{
    const encoder = new TextEncoder();
    return encoder.encode(str.substring(1));
});
const $948e2d1c026ff27e$var$ascii = $948e2d1c026ff27e$var$createCodec("ascii", "a", (buf)=>{
    let string = "a";
    for(let i = 0; i < buf.length; i++)string += String.fromCharCode(buf[i]);
    return string;
}, (str)=>{
    str = str.substring(1);
    const buf = new Uint8Array(str.length);
    for(let i = 0; i < str.length; i++)buf[i] = str.charCodeAt(i);
    return buf;
});
/**
 * @typedef {'utf8' | 'utf-8' | 'hex' | 'latin1' | 'ascii' | 'binary' | keyof bases } SupportedEncodings
 */ /**
 * @type {Record<SupportedEncodings, MultibaseCodec>}
 */ const $948e2d1c026ff27e$var$BASES = {
    "utf8": $948e2d1c026ff27e$var$string,
    "utf-8": $948e2d1c026ff27e$var$string,
    "hex": $948e2d1c026ff27e$require$bases.base16,
    "latin1": $948e2d1c026ff27e$var$ascii,
    "ascii": $948e2d1c026ff27e$var$ascii,
    "binary": $948e2d1c026ff27e$var$ascii,
    ...$948e2d1c026ff27e$require$bases
};
module.exports = $948e2d1c026ff27e$var$BASES;

});
parcelRegister("c0Nzu", function(module, exports) {

$parcel$export(module.exports, "bases", function () { return $8bebeff6d6ff2db6$export$196f613671eb7dd9; });

var $1ffhG = parcelRequire("1ffhG");

var $7Sk9p = parcelRequire("7Sk9p");

var $aOvdb = parcelRequire("aOvdb");

var $8AoPD = parcelRequire("8AoPD");

var $1YvW3 = parcelRequire("1YvW3");

var $1sOTj = parcelRequire("1sOTj");

var $lVzdS = parcelRequire("lVzdS");

var $fkIEb = parcelRequire("fkIEb");

var $hAH2I = parcelRequire("hAH2I");

var $YF8aD = parcelRequire("YF8aD");

var $4etgu = parcelRequire("4etgu");

var $ghDf8 = parcelRequire("ghDf8");

var $5vV8E = parcelRequire("5vV8E");

var $df7WS = parcelRequire("df7WS");
parcelRequire("libLP");
var $gAVqk = parcelRequire("gAVqk");
var $45cfy = parcelRequire("45cfy");
var $lkuiA = parcelRequire("lkuiA");
var $1GK2R = parcelRequire("1GK2R");
var $7kX7z = parcelRequire("7kX7z");
const $8bebeff6d6ff2db6$export$196f613671eb7dd9 = {
    ...$1ffhG,
    ...$7Sk9p,
    ...$aOvdb,
    ...$8AoPD,
    ...$1YvW3,
    ...$1sOTj,
    ...$lVzdS,
    ...$fkIEb,
    ...$hAH2I,
    ...$YF8aD
};
const $8bebeff6d6ff2db6$export$cff071c6f82b8944 = {
    ...$4etgu,
    ...$ghDf8
};
const $8bebeff6d6ff2db6$export$b2c6ab3b27d60531 = {
    raw: $5vV8E,
    json: $df7WS
};

});
parcelRegister("1ffhG", function(module, exports) {

$parcel$export(module.exports, "identity", function () { return $0e830c4a14dab4ae$export$f0954fd7d5368655; });

var $hdc8N = parcelRequire("hdc8N");

var $7kX7z = parcelRequire("7kX7z");
const $0e830c4a14dab4ae$export$f0954fd7d5368655 = (0, $hdc8N.from)({
    prefix: "\0",
    name: "identity",
    encode: (buf)=>(0, $7kX7z.toString)(buf),
    decode: (str)=>(0, $7kX7z.fromString)(str)
});

});
parcelRegister("hdc8N", function(module, exports) {

$parcel$export(module.exports, "from", function () { return $c87d117acb80876d$export$6788812c4e6611e6; });
$parcel$export(module.exports, "baseX", function () { return $c87d117acb80876d$export$180c73aedea7f385; });
$parcel$export(module.exports, "rfc4648", function () { return $c87d117acb80876d$export$fa9dde04c7d2f31a; });

var $4klY3 = parcelRequire("4klY3");

var $7kX7z = parcelRequire("7kX7z");
class $c87d117acb80876d$var$Encoder {
    constructor(name, prefix, baseEncode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
    }
    encode(bytes) {
        if (bytes instanceof Uint8Array) return `${this.prefix}${this.baseEncode(bytes)}`;
        else throw Error("Unknown type, must be binary type");
    }
}
class $c87d117acb80876d$var$Decoder {
    constructor(name, prefix, baseDecode){
        this.name = name;
        this.prefix = prefix;
        if (prefix.codePointAt(0) === undefined) throw new Error("Invalid prefix character");
        this.prefixCodePoint = prefix.codePointAt(0);
        this.baseDecode = baseDecode;
    }
    decode(text) {
        if (typeof text === "string") {
            if (text.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(text)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(text.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(decoder) {
        return $c87d117acb80876d$export$252bb8b3bbdf6749(this, decoder);
    }
}
class $c87d117acb80876d$var$ComposedDecoder {
    constructor(decoders){
        this.decoders = decoders;
    }
    or(decoder) {
        return $c87d117acb80876d$export$252bb8b3bbdf6749(this, decoder);
    }
    decode(input) {
        const prefix = input[0];
        const decoder = this.decoders[prefix];
        if (decoder) return decoder.decode(input);
        else throw RangeError(`Unable to decode multibase string ${JSON.stringify(input)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $c87d117acb80876d$export$252bb8b3bbdf6749 = (left, right)=>new $c87d117acb80876d$var$ComposedDecoder({
        ...left.decoders || {
            [left.prefix]: left
        },
        ...right.decoders || {
            [right.prefix]: right
        }
    });
class $c87d117acb80876d$export$a111e9ced3f1d2d0 {
    constructor(name, prefix, baseEncode, baseDecode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
        this.baseDecode = baseDecode;
        this.encoder = new $c87d117acb80876d$var$Encoder(name, prefix, baseEncode);
        this.decoder = new $c87d117acb80876d$var$Decoder(name, prefix, baseDecode);
    }
    encode(input) {
        return this.encoder.encode(input);
    }
    decode(input) {
        return this.decoder.decode(input);
    }
}
const $c87d117acb80876d$export$6788812c4e6611e6 = ({ name: name, prefix: prefix, encode: encode, decode: decode })=>new $c87d117acb80876d$export$a111e9ced3f1d2d0(name, prefix, encode, decode);
const $c87d117acb80876d$export$180c73aedea7f385 = ({ prefix: prefix, name: name, alphabet: alphabet })=>{
    const { encode: encode, decode: decode } = (0, $4klY3.default)(alphabet, name);
    return $c87d117acb80876d$export$6788812c4e6611e6({
        prefix: prefix,
        name: name,
        encode: encode,
        decode: (text)=>(0, $7kX7z.coerce)(decode(text))
    });
};
const $c87d117acb80876d$var$decode = (string, alphabet, bitsPerChar, name)=>{
    const codes = {};
    for(let i = 0; i < alphabet.length; ++i)codes[alphabet[i]] = i;
    let end = string.length;
    while(string[end - 1] === "=")--end;
    const out = new Uint8Array(end * bitsPerChar / 8 | 0);
    let bits = 0;
    let buffer = 0;
    let written = 0;
    for(let i = 0; i < end; ++i){
        const value = codes[string[i]];
        if (value === undefined) throw new SyntaxError(`Non-${name} character`);
        buffer = buffer << bitsPerChar | value;
        bits += bitsPerChar;
        if (bits >= 8) {
            bits -= 8;
            out[written++] = 255 & buffer >> bits;
        }
    }
    if (bits >= bitsPerChar || 255 & buffer << 8 - bits) throw new SyntaxError("Unexpected end of data");
    return out;
};
const $c87d117acb80876d$var$encode = (data, alphabet, bitsPerChar)=>{
    const pad = alphabet[alphabet.length - 1] === "=";
    const mask = (1 << bitsPerChar) - 1;
    let out = "";
    let bits = 0;
    let buffer = 0;
    for(let i = 0; i < data.length; ++i){
        buffer = buffer << 8 | data[i];
        bits += 8;
        while(bits > bitsPerChar){
            bits -= bitsPerChar;
            out += alphabet[mask & buffer >> bits];
        }
    }
    if (bits) out += alphabet[mask & buffer << bitsPerChar - bits];
    if (pad) while(out.length * bitsPerChar & 7)out += "=";
    return out;
};
const $c87d117acb80876d$export$fa9dde04c7d2f31a = ({ name: name, prefix: prefix, bitsPerChar: bitsPerChar, alphabet: alphabet })=>{
    return $c87d117acb80876d$export$6788812c4e6611e6({
        prefix: prefix,
        name: name,
        encode (input) {
            return $c87d117acb80876d$var$encode(input, alphabet, bitsPerChar);
        },
        decode (input) {
            return $c87d117acb80876d$var$decode(input, alphabet, bitsPerChar, name);
        }
    });
};

});
parcelRegister("4klY3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $326a11fcaf7036c5$export$2e2bcd8739ae039; });
function $326a11fcaf7036c5$var$base(ALPHABET, name) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256);
    var iFACTOR = Math.log(256) / Math.log(BASE);
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        while(pbegin !== pend){
            var carry = source[pbegin];
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        if (source[psz] === " ") return;
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        var size = (source.length - psz) * FACTOR + 1 >>> 0;
        var b256 = new Uint8Array(size);
        while(source[psz]){
            var carry = BASE_MAP[source.charCodeAt(psz)];
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        if (source[psz] === " ") return;
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error(`Non-${name} character`);
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var $326a11fcaf7036c5$var$src = $326a11fcaf7036c5$var$base;
var $326a11fcaf7036c5$var$_brrp__multiformats_scope_baseX = $326a11fcaf7036c5$var$src;
var $326a11fcaf7036c5$export$2e2bcd8739ae039 = $326a11fcaf7036c5$var$_brrp__multiformats_scope_baseX;

});

parcelRegister("7kX7z", function(module, exports) {

$parcel$export(module.exports, "equals", function () { return $557842dfb73dc22c$export$e9bab7fafb253603; });
$parcel$export(module.exports, "coerce", function () { return $557842dfb73dc22c$export$8c14e57e778d3873; });
$parcel$export(module.exports, "fromString", function () { return $557842dfb73dc22c$export$3004f64547af360e; });
$parcel$export(module.exports, "toString", function () { return $557842dfb73dc22c$export$f84e8e69fd4488a5; });
const $557842dfb73dc22c$export$6e22c362a0406a2c = new Uint8Array(0);
const $557842dfb73dc22c$export$7ea66e3774a60b67 = (d)=>d.reduce((hex, byte)=>hex + byte.toString(16).padStart(2, "0"), "");
const $557842dfb73dc22c$export$1a8ceedbd5845648 = (hex)=>{
    const hexes = hex.match(/../g);
    return hexes ? new Uint8Array(hexes.map((b)=>parseInt(b, 16))) : $557842dfb73dc22c$export$6e22c362a0406a2c;
};
const $557842dfb73dc22c$export$e9bab7fafb253603 = (aa, bb)=>{
    if (aa === bb) return true;
    if (aa.byteLength !== bb.byteLength) return false;
    for(let ii = 0; ii < aa.byteLength; ii++){
        if (aa[ii] !== bb[ii]) return false;
    }
    return true;
};
const $557842dfb73dc22c$export$8c14e57e778d3873 = (o)=>{
    if (o instanceof Uint8Array && o.constructor.name === "Uint8Array") return o;
    if (o instanceof ArrayBuffer) return new Uint8Array(o);
    if (ArrayBuffer.isView(o)) return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
    throw new Error("Unknown type, must be binary type");
};
const $557842dfb73dc22c$export$37488ff1135b1696 = (o)=>o instanceof ArrayBuffer || ArrayBuffer.isView(o);
const $557842dfb73dc22c$export$3004f64547af360e = (str)=>new TextEncoder().encode(str);
const $557842dfb73dc22c$export$f84e8e69fd4488a5 = (b)=>new TextDecoder().decode(b);

});



parcelRegister("7Sk9p", function(module, exports) {

$parcel$export(module.exports, "base2", function () { return $5bbd350d07af480f$export$ed5f7917e37e31aa; });

var $hdc8N = parcelRequire("hdc8N");
const $5bbd350d07af480f$export$ed5f7917e37e31aa = (0, $hdc8N.rfc4648)({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});

});

parcelRegister("aOvdb", function(module, exports) {

$parcel$export(module.exports, "base8", function () { return $7df6c8deab17b7c1$export$43b580ac9deb5b96; });

var $hdc8N = parcelRequire("hdc8N");
const $7df6c8deab17b7c1$export$43b580ac9deb5b96 = (0, $hdc8N.rfc4648)({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});

});

parcelRegister("8AoPD", function(module, exports) {

$parcel$export(module.exports, "base10", function () { return $6404f29a0a0e3770$export$63d6a7de0ff813cc; });

var $hdc8N = parcelRequire("hdc8N");
const $6404f29a0a0e3770$export$63d6a7de0ff813cc = (0, $hdc8N.baseX)({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});

});

parcelRegister("1YvW3", function(module, exports) {

$parcel$export(module.exports, "base16", function () { return $17042ab9e1e2ce77$export$586f61c71cb02fe4; });
$parcel$export(module.exports, "base16upper", function () { return $17042ab9e1e2ce77$export$2d835b8dd4032b62; });

var $hdc8N = parcelRequire("hdc8N");
const $17042ab9e1e2ce77$export$586f61c71cb02fe4 = (0, $hdc8N.rfc4648)({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
});
const $17042ab9e1e2ce77$export$2d835b8dd4032b62 = (0, $hdc8N.rfc4648)({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});

});

parcelRegister("1sOTj", function(module, exports) {

$parcel$export(module.exports, "base32", function () { return $110fe1e079565019$export$4a4d5965e2738b2a; });
$parcel$export(module.exports, "base32upper", function () { return $110fe1e079565019$export$fbaa3bbbd754def4; });
$parcel$export(module.exports, "base32pad", function () { return $110fe1e079565019$export$e194fa100d329365; });
$parcel$export(module.exports, "base32padupper", function () { return $110fe1e079565019$export$3a9fc48d294dce32; });
$parcel$export(module.exports, "base32hex", function () { return $110fe1e079565019$export$c57d6760d519c8ac; });
$parcel$export(module.exports, "base32hexupper", function () { return $110fe1e079565019$export$8cf4640df3165d29; });
$parcel$export(module.exports, "base32hexpad", function () { return $110fe1e079565019$export$8c6a05c08ec7d456; });
$parcel$export(module.exports, "base32hexpadupper", function () { return $110fe1e079565019$export$29f73c6a744e639f; });
$parcel$export(module.exports, "base32z", function () { return $110fe1e079565019$export$fdad9af4bdc05e3; });

var $hdc8N = parcelRequire("hdc8N");
const $110fe1e079565019$export$4a4d5965e2738b2a = (0, $hdc8N.rfc4648)({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
});
const $110fe1e079565019$export$fbaa3bbbd754def4 = (0, $hdc8N.rfc4648)({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
});
const $110fe1e079565019$export$e194fa100d329365 = (0, $hdc8N.rfc4648)({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
});
const $110fe1e079565019$export$3a9fc48d294dce32 = (0, $hdc8N.rfc4648)({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
});
const $110fe1e079565019$export$c57d6760d519c8ac = (0, $hdc8N.rfc4648)({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
});
const $110fe1e079565019$export$8cf4640df3165d29 = (0, $hdc8N.rfc4648)({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
});
const $110fe1e079565019$export$8c6a05c08ec7d456 = (0, $hdc8N.rfc4648)({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
});
const $110fe1e079565019$export$29f73c6a744e639f = (0, $hdc8N.rfc4648)({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
});
const $110fe1e079565019$export$fdad9af4bdc05e3 = (0, $hdc8N.rfc4648)({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});

});

parcelRegister("lVzdS", function(module, exports) {

$parcel$export(module.exports, "base36", function () { return $ff6a3e581d0198af$export$95b61e7c39ae893a; });
$parcel$export(module.exports, "base36upper", function () { return $ff6a3e581d0198af$export$bab7c9bdb963afd; });

var $hdc8N = parcelRequire("hdc8N");
const $ff6a3e581d0198af$export$95b61e7c39ae893a = (0, $hdc8N.baseX)({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
});
const $ff6a3e581d0198af$export$bab7c9bdb963afd = (0, $hdc8N.baseX)({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});

});

parcelRegister("fkIEb", function(module, exports) {

$parcel$export(module.exports, "base58btc", function () { return $b29b5b3fe2aef5ed$export$65c61748a9b98a2c; });
$parcel$export(module.exports, "base58flickr", function () { return $b29b5b3fe2aef5ed$export$c6a7baed2941aad2; });

var $hdc8N = parcelRequire("hdc8N");
const $b29b5b3fe2aef5ed$export$65c61748a9b98a2c = (0, $hdc8N.baseX)({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
});
const $b29b5b3fe2aef5ed$export$c6a7baed2941aad2 = (0, $hdc8N.baseX)({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});

});

parcelRegister("hAH2I", function(module, exports) {

$parcel$export(module.exports, "base64", function () { return $cce72fdbba8d1fb3$export$b3b2de96497acc47; });
$parcel$export(module.exports, "base64pad", function () { return $cce72fdbba8d1fb3$export$a9c086fc40b4563c; });
$parcel$export(module.exports, "base64url", function () { return $cce72fdbba8d1fb3$export$7d21597c7bc64465; });
$parcel$export(module.exports, "base64urlpad", function () { return $cce72fdbba8d1fb3$export$e87ddc9183aa53c9; });

var $hdc8N = parcelRequire("hdc8N");
const $cce72fdbba8d1fb3$export$b3b2de96497acc47 = (0, $hdc8N.rfc4648)({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
});
const $cce72fdbba8d1fb3$export$a9c086fc40b4563c = (0, $hdc8N.rfc4648)({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
});
const $cce72fdbba8d1fb3$export$7d21597c7bc64465 = (0, $hdc8N.rfc4648)({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
});
const $cce72fdbba8d1fb3$export$e87ddc9183aa53c9 = (0, $hdc8N.rfc4648)({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});

});

parcelRegister("YF8aD", function(module, exports) {

$parcel$export(module.exports, "base256emoji", function () { return $0b65826d95574aba$export$6a5d4ab6075d2779; });

var $hdc8N = parcelRequire("hdc8N");
const $0b65826d95574aba$var$alphabet = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42");
const $0b65826d95574aba$var$alphabetBytesToChars = $0b65826d95574aba$var$alphabet.reduce((p, c, i)=>{
    p[i] = c;
    return p;
}, []);
const $0b65826d95574aba$var$alphabetCharsToBytes = $0b65826d95574aba$var$alphabet.reduce((p, c, i)=>{
    p[c.codePointAt(0)] = i;
    return p;
}, []);
function $0b65826d95574aba$var$encode(data) {
    return data.reduce((p, c)=>{
        p += $0b65826d95574aba$var$alphabetBytesToChars[c];
        return p;
    }, "");
}
function $0b65826d95574aba$var$decode(str) {
    const byts = [];
    for (const char of str){
        const byt = $0b65826d95574aba$var$alphabetCharsToBytes[char.codePointAt(0)];
        if (byt === undefined) throw new Error(`Non-base256emoji character: ${char}`);
        byts.push(byt);
    }
    return new Uint8Array(byts);
}
const $0b65826d95574aba$export$6a5d4ab6075d2779 = (0, $hdc8N.from)({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $0b65826d95574aba$var$encode,
    decode: $0b65826d95574aba$var$decode
});

});

parcelRegister("4etgu", function(module, exports) {

$parcel$export(module.exports, "sha256", function () { return $314f2ba2e2a4ed17$export$bced8d2aada2d1c9; });
$parcel$export(module.exports, "sha512", function () { return $314f2ba2e2a4ed17$export$a888d2532e6dc7bb; });

var $45cfy = parcelRequire("45cfy");
const $314f2ba2e2a4ed17$var$sha = (name)=>async (data)=>new Uint8Array(await crypto.subtle.digest(name, data));
const $314f2ba2e2a4ed17$export$bced8d2aada2d1c9 = (0, $45cfy.from)({
    name: "sha2-256",
    code: 18,
    encode: $314f2ba2e2a4ed17$var$sha("SHA-256")
});
const $314f2ba2e2a4ed17$export$a888d2532e6dc7bb = (0, $45cfy.from)({
    name: "sha2-512",
    code: 19,
    encode: $314f2ba2e2a4ed17$var$sha("SHA-512")
});

});
parcelRegister("45cfy", function(module, exports) {

$parcel$export(module.exports, "from", function () { return $2f9121a62a9fa05f$export$6788812c4e6611e6; });

var $lkuiA = parcelRequire("lkuiA");
const $2f9121a62a9fa05f$export$6788812c4e6611e6 = ({ name: name, code: code, encode: encode })=>new $2f9121a62a9fa05f$export$df06eed23808f4d0(name, code, encode);
class $2f9121a62a9fa05f$export$df06eed23808f4d0 {
    constructor(name, code, encode){
        this.name = name;
        this.code = code;
        this.encode = encode;
    }
    digest(input) {
        if (input instanceof Uint8Array) {
            const result = this.encode(input);
            return result instanceof Uint8Array ? $lkuiA.create(this.code, result) : result.then((digest)=>$lkuiA.create(this.code, digest));
        } else throw Error("Unknown type, must be binary type");
    }
}

});
parcelRegister("lkuiA", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $f872f7f098bd3ac2$export$185802fd694ee1f5; });
$parcel$export(module.exports, "Digest", function () { return $f872f7f098bd3ac2$export$d67a82ff561eff43; });
$parcel$export(module.exports, "decode", function () { return $f872f7f098bd3ac2$export$2f872c0f2117be69; });
$parcel$export(module.exports, "equals", function () { return $f872f7f098bd3ac2$export$e9bab7fafb253603; });

var $7kX7z = parcelRequire("7kX7z");

var $1GK2R = parcelRequire("1GK2R");
const $f872f7f098bd3ac2$export$185802fd694ee1f5 = (code, digest)=>{
    const size = digest.byteLength;
    const sizeOffset = $1GK2R.encodingLength(code);
    const digestOffset = sizeOffset + $1GK2R.encodingLength(size);
    const bytes = new Uint8Array(digestOffset + size);
    $1GK2R.encodeTo(code, bytes, 0);
    $1GK2R.encodeTo(size, bytes, sizeOffset);
    bytes.set(digest, digestOffset);
    return new $f872f7f098bd3ac2$export$d67a82ff561eff43(code, size, digest, bytes);
};
const $f872f7f098bd3ac2$export$2f872c0f2117be69 = (multihash)=>{
    const bytes = (0, $7kX7z.coerce)(multihash);
    const [code, sizeOffset] = $1GK2R.decode(bytes);
    const [size, digestOffset] = $1GK2R.decode(bytes.subarray(sizeOffset));
    const digest = bytes.subarray(sizeOffset + digestOffset);
    if (digest.byteLength !== size) throw new Error("Incorrect length");
    return new $f872f7f098bd3ac2$export$d67a82ff561eff43(code, size, digest, bytes);
};
const $f872f7f098bd3ac2$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    else return a.code === b.code && a.size === b.size && (0, $7kX7z.equals)(a.bytes, b.bytes);
};
class $f872f7f098bd3ac2$export$d67a82ff561eff43 {
    constructor(code, size, digest, bytes){
        this.code = code;
        this.size = size;
        this.digest = digest;
        this.bytes = bytes;
    }
}

});
parcelRegister("1GK2R", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $13ad6e4acc277cbb$export$2f872c0f2117be69; });
$parcel$export(module.exports, "encodeTo", function () { return $13ad6e4acc277cbb$export$8512cbe4228de3b3; });
$parcel$export(module.exports, "encodingLength", function () { return $13ad6e4acc277cbb$export$cbee51f25f0626d7; });

var $jInbk = parcelRequire("jInbk");
const $13ad6e4acc277cbb$export$2f872c0f2117be69 = (data, offset = 0)=>{
    const code = (0, $jInbk.default).decode(data, offset);
    return [
        code,
        (0, $jInbk.default).decode.bytes
    ];
};
const $13ad6e4acc277cbb$export$8512cbe4228de3b3 = (int, target, offset = 0)=>{
    (0, $jInbk.default).encode(int, target, offset);
    return target;
};
const $13ad6e4acc277cbb$export$cbee51f25f0626d7 = (int)=>{
    return (0, $jInbk.default).encodingLength(int);
};

});
parcelRegister("jInbk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5a41bcd774ee19c$export$2e2bcd8739ae039; });
var $e5a41bcd774ee19c$var$encode_1 = $e5a41bcd774ee19c$var$encode;
var $e5a41bcd774ee19c$var$MSB = 128, $e5a41bcd774ee19c$var$REST = 127, $e5a41bcd774ee19c$var$MSBALL = ~$e5a41bcd774ee19c$var$REST, $e5a41bcd774ee19c$var$INT = Math.pow(2, 31);
function $e5a41bcd774ee19c$var$encode(num, out, offset) {
    out = out || [];
    offset = offset || 0;
    var oldOffset = offset;
    while(num >= $e5a41bcd774ee19c$var$INT){
        out[offset++] = num & 255 | $e5a41bcd774ee19c$var$MSB;
        num /= 128;
    }
    while(num & $e5a41bcd774ee19c$var$MSBALL){
        out[offset++] = num & 255 | $e5a41bcd774ee19c$var$MSB;
        num >>>= 7;
    }
    out[offset] = num | 0;
    $e5a41bcd774ee19c$var$encode.bytes = offset - oldOffset + 1;
    return out;
}
var $e5a41bcd774ee19c$var$decode = $e5a41bcd774ee19c$var$read;
var $e5a41bcd774ee19c$var$MSB$1 = 128, $e5a41bcd774ee19c$var$REST$1 = 127;
function $e5a41bcd774ee19c$var$read(buf, offset) {
    var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
    do {
        if (counter >= l) {
            $e5a41bcd774ee19c$var$read.bytes = 0;
            throw new RangeError("Could not decode varint");
        }
        b = buf[counter++];
        res += shift < 28 ? (b & $e5a41bcd774ee19c$var$REST$1) << shift : (b & $e5a41bcd774ee19c$var$REST$1) * Math.pow(2, shift);
        shift += 7;
    }while (b >= $e5a41bcd774ee19c$var$MSB$1);
    $e5a41bcd774ee19c$var$read.bytes = counter - offset;
    return res;
}
var $e5a41bcd774ee19c$var$N1 = Math.pow(2, 7);
var $e5a41bcd774ee19c$var$N2 = Math.pow(2, 14);
var $e5a41bcd774ee19c$var$N3 = Math.pow(2, 21);
var $e5a41bcd774ee19c$var$N4 = Math.pow(2, 28);
var $e5a41bcd774ee19c$var$N5 = Math.pow(2, 35);
var $e5a41bcd774ee19c$var$N6 = Math.pow(2, 42);
var $e5a41bcd774ee19c$var$N7 = Math.pow(2, 49);
var $e5a41bcd774ee19c$var$N8 = Math.pow(2, 56);
var $e5a41bcd774ee19c$var$N9 = Math.pow(2, 63);
var $e5a41bcd774ee19c$var$length = function(value) {
    return value < $e5a41bcd774ee19c$var$N1 ? 1 : value < $e5a41bcd774ee19c$var$N2 ? 2 : value < $e5a41bcd774ee19c$var$N3 ? 3 : value < $e5a41bcd774ee19c$var$N4 ? 4 : value < $e5a41bcd774ee19c$var$N5 ? 5 : value < $e5a41bcd774ee19c$var$N6 ? 6 : value < $e5a41bcd774ee19c$var$N7 ? 7 : value < $e5a41bcd774ee19c$var$N8 ? 8 : value < $e5a41bcd774ee19c$var$N9 ? 9 : 10;
};
var $e5a41bcd774ee19c$var$varint = {
    encode: $e5a41bcd774ee19c$var$encode_1,
    decode: $e5a41bcd774ee19c$var$decode,
    encodingLength: $e5a41bcd774ee19c$var$length
};
var $e5a41bcd774ee19c$var$_brrp_varint = $e5a41bcd774ee19c$var$varint;
var $e5a41bcd774ee19c$export$2e2bcd8739ae039 = $e5a41bcd774ee19c$var$_brrp_varint;

});





parcelRegister("ghDf8", function(module, exports) {

$parcel$export(module.exports, "identity", function () { return $bdacacb7db06ce88$export$f0954fd7d5368655; });

var $7kX7z = parcelRequire("7kX7z");

var $lkuiA = parcelRequire("lkuiA");
const $bdacacb7db06ce88$var$code = 0;
const $bdacacb7db06ce88$var$name = "identity";
const $bdacacb7db06ce88$var$encode = (0, $7kX7z.coerce);
const $bdacacb7db06ce88$var$digest = (input)=>$lkuiA.create($bdacacb7db06ce88$var$code, $bdacacb7db06ce88$var$encode(input));
const $bdacacb7db06ce88$export$f0954fd7d5368655 = {
    code: $bdacacb7db06ce88$var$code,
    name: $bdacacb7db06ce88$var$name,
    encode: $bdacacb7db06ce88$var$encode,
    digest: $bdacacb7db06ce88$var$digest
};

});

parcelRegister("5vV8E", function(module, exports) {

$parcel$export(module.exports, "name", function () { return $403c2b878f1d3b39$export$a8ff84c12d48cfa6; });
$parcel$export(module.exports, "code", function () { return $403c2b878f1d3b39$export$6565f9f03506010b; });
$parcel$export(module.exports, "encode", function () { return $403c2b878f1d3b39$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decode", function () { return $403c2b878f1d3b39$export$2f872c0f2117be69; });

var $7kX7z = parcelRequire("7kX7z");
const $403c2b878f1d3b39$export$a8ff84c12d48cfa6 = "raw";
const $403c2b878f1d3b39$export$6565f9f03506010b = 85;
const $403c2b878f1d3b39$export$c564cdbbe6da493 = (node)=>(0, $7kX7z.coerce)(node);
const $403c2b878f1d3b39$export$2f872c0f2117be69 = (data)=>(0, $7kX7z.coerce)(data);

});

parcelRegister("df7WS", function(module, exports) {

$parcel$export(module.exports, "name", function () { return $9a42d77d7433efef$export$a8ff84c12d48cfa6; });
$parcel$export(module.exports, "code", function () { return $9a42d77d7433efef$export$6565f9f03506010b; });
$parcel$export(module.exports, "encode", function () { return $9a42d77d7433efef$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decode", function () { return $9a42d77d7433efef$export$2f872c0f2117be69; });
const $9a42d77d7433efef$var$textEncoder = new TextEncoder();
const $9a42d77d7433efef$var$textDecoder = new TextDecoder();
const $9a42d77d7433efef$export$a8ff84c12d48cfa6 = "json";
const $9a42d77d7433efef$export$6565f9f03506010b = 512;
const $9a42d77d7433efef$export$c564cdbbe6da493 = (node)=>$9a42d77d7433efef$var$textEncoder.encode(JSON.stringify(node));
const $9a42d77d7433efef$export$2f872c0f2117be69 = (data)=>JSON.parse($9a42d77d7433efef$var$textDecoder.decode(data));

});

parcelRegister("libLP", function(module, exports) {

var $gAVqk = parcelRequire("gAVqk");

var $1GK2R = parcelRequire("1GK2R");

var $7kX7z = parcelRequire("7kX7z");

var $45cfy = parcelRequire("45cfy");

var $lkuiA = parcelRequire("lkuiA");

});
parcelRegister("gAVqk", function(module, exports) {

var $1GK2R = parcelRequire("1GK2R");

var $lkuiA = parcelRequire("lkuiA");

var $fkIEb = parcelRequire("fkIEb");

var $1sOTj = parcelRequire("1sOTj");

var $7kX7z = parcelRequire("7kX7z");
class $c14c8d42c9ead59e$export$12d863fcef3f6aa {
    constructor(version, code, multihash, bytes){
        this.code = code;
        this.version = version;
        this.multihash = multihash;
        this.bytes = bytes;
        this.byteOffset = bytes.byteOffset;
        this.byteLength = bytes.byteLength;
        this.asCID = this;
        this._baseCache = new Map();
        Object.defineProperties(this, {
            byteOffset: $c14c8d42c9ead59e$var$hidden,
            byteLength: $c14c8d42c9ead59e$var$hidden,
            code: $c14c8d42c9ead59e$var$readonly,
            version: $c14c8d42c9ead59e$var$readonly,
            multihash: $c14c8d42c9ead59e$var$readonly,
            bytes: $c14c8d42c9ead59e$var$readonly,
            _baseCache: $c14c8d42c9ead59e$var$hidden,
            asCID: $c14c8d42c9ead59e$var$hidden
        });
    }
    toV0() {
        switch(this.version){
            case 0:
                return this;
            default:
                {
                    const { code: code, multihash: multihash } = this;
                    if (code !== $c14c8d42c9ead59e$var$DAG_PB_CODE) throw new Error("Cannot convert a non dag-pb CID to CIDv0");
                    if (multihash.code !== $c14c8d42c9ead59e$var$SHA_256_CODE) throw new Error("Cannot convert non sha2-256 multihash CID to CIDv0");
                    return $c14c8d42c9ead59e$export$12d863fcef3f6aa.createV0(multihash);
                }
        }
    }
    toV1() {
        switch(this.version){
            case 0:
                {
                    const { code: code, digest: digest } = this.multihash;
                    const multihash = $lkuiA.create(code, digest);
                    return $c14c8d42c9ead59e$export$12d863fcef3f6aa.createV1(this.code, multihash);
                }
            case 1:
                return this;
            default:
                throw Error(`Can not convert CID version ${this.version} to version 0. This is a bug please report`);
        }
    }
    equals(other) {
        return other && this.code === other.code && this.version === other.version && $lkuiA.equals(this.multihash, other.multihash);
    }
    toString(base) {
        const { bytes: bytes, version: version, _baseCache: _baseCache } = this;
        switch(version){
            case 0:
                return $c14c8d42c9ead59e$var$toStringV0(bytes, _baseCache, base || (0, $fkIEb.base58btc).encoder);
            default:
                return $c14c8d42c9ead59e$var$toStringV1(bytes, _baseCache, base || (0, $1sOTj.base32).encoder);
        }
    }
    toJSON() {
        return {
            code: this.code,
            version: this.version,
            hash: this.multihash.bytes
        };
    }
    get [Symbol.toStringTag]() {
        return "CID";
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
        return "CID(" + this.toString() + ")";
    }
    static isCID(value) {
        $c14c8d42c9ead59e$var$deprecate(/^0\.0/, $c14c8d42c9ead59e$var$IS_CID_DEPRECATION);
        return !!(value && (value[$c14c8d42c9ead59e$var$cidSymbol] || value.asCID === value));
    }
    get toBaseEncodedString() {
        throw new Error("Deprecated, use .toString()");
    }
    get codec() {
        throw new Error('"codec" property is deprecated, use integer "code" property instead');
    }
    get buffer() {
        throw new Error("Deprecated .buffer property, use .bytes to get Uint8Array instead");
    }
    get multibaseName() {
        throw new Error('"multibaseName" property is deprecated');
    }
    get prefix() {
        throw new Error('"prefix" property is deprecated');
    }
    static asCID(value) {
        if (value instanceof $c14c8d42c9ead59e$export$12d863fcef3f6aa) return value;
        else if (value != null && value.asCID === value) {
            const { version: version, code: code, multihash: multihash, bytes: bytes } = value;
            return new $c14c8d42c9ead59e$export$12d863fcef3f6aa(version, code, multihash, bytes || $c14c8d42c9ead59e$var$encodeCID(version, code, multihash.bytes));
        } else if (value != null && value[$c14c8d42c9ead59e$var$cidSymbol] === true) {
            const { version: version, multihash: multihash, code: code } = value;
            const digest = $lkuiA.decode(multihash);
            return $c14c8d42c9ead59e$export$12d863fcef3f6aa.create(version, code, digest);
        } else return null;
    }
    static create(version, code, digest) {
        if (typeof code !== "number") throw new Error("String codecs are no longer supported");
        switch(version){
            case 0:
                if (code !== $c14c8d42c9ead59e$var$DAG_PB_CODE) throw new Error(`Version 0 CID must use dag-pb (code: ${$c14c8d42c9ead59e$var$DAG_PB_CODE}) block encoding`);
                else return new $c14c8d42c9ead59e$export$12d863fcef3f6aa(version, code, digest, digest.bytes);
            case 1:
                {
                    const bytes = $c14c8d42c9ead59e$var$encodeCID(version, code, digest.bytes);
                    return new $c14c8d42c9ead59e$export$12d863fcef3f6aa(version, code, digest, bytes);
                }
            default:
                throw new Error("Invalid version");
        }
    }
    static createV0(digest) {
        return $c14c8d42c9ead59e$export$12d863fcef3f6aa.create(0, $c14c8d42c9ead59e$var$DAG_PB_CODE, digest);
    }
    static createV1(code, digest) {
        return $c14c8d42c9ead59e$export$12d863fcef3f6aa.create(1, code, digest);
    }
    static decode(bytes) {
        const [cid, remainder] = $c14c8d42c9ead59e$export$12d863fcef3f6aa.decodeFirst(bytes);
        if (remainder.length) throw new Error("Incorrect length");
        return cid;
    }
    static decodeFirst(bytes) {
        const specs = $c14c8d42c9ead59e$export$12d863fcef3f6aa.inspectBytes(bytes);
        const prefixSize = specs.size - specs.multihashSize;
        const multihashBytes = (0, $7kX7z.coerce)(bytes.subarray(prefixSize, prefixSize + specs.multihashSize));
        if (multihashBytes.byteLength !== specs.multihashSize) throw new Error("Incorrect length");
        const digestBytes = multihashBytes.subarray(specs.multihashSize - specs.digestSize);
        const digest = new $lkuiA.Digest(specs.multihashCode, specs.digestSize, digestBytes, multihashBytes);
        const cid = specs.version === 0 ? $c14c8d42c9ead59e$export$12d863fcef3f6aa.createV0(digest) : $c14c8d42c9ead59e$export$12d863fcef3f6aa.createV1(specs.codec, digest);
        return [
            cid,
            bytes.subarray(specs.size)
        ];
    }
    static inspectBytes(initialBytes) {
        let offset = 0;
        const next = ()=>{
            const [i, length] = $1GK2R.decode(initialBytes.subarray(offset));
            offset += length;
            return i;
        };
        let version = next();
        let codec = $c14c8d42c9ead59e$var$DAG_PB_CODE;
        if (version === 18) {
            version = 0;
            offset = 0;
        } else if (version === 1) codec = next();
        if (version !== 0 && version !== 1) throw new RangeError(`Invalid CID version ${version}`);
        const prefixSize = offset;
        const multihashCode = next();
        const digestSize = next();
        const size = offset + digestSize;
        const multihashSize = size - prefixSize;
        return {
            version: version,
            codec: codec,
            multihashCode: multihashCode,
            digestSize: digestSize,
            multihashSize: multihashSize,
            size: size
        };
    }
    static parse(source, base) {
        const [prefix, bytes] = $c14c8d42c9ead59e$var$parseCIDtoBytes(source, base);
        const cid = $c14c8d42c9ead59e$export$12d863fcef3f6aa.decode(bytes);
        cid._baseCache.set(prefix, source);
        return cid;
    }
}
const $c14c8d42c9ead59e$var$parseCIDtoBytes = (source, base)=>{
    switch(source[0]){
        case "Q":
            {
                const decoder = base || (0, $fkIEb.base58btc);
                return [
                    (0, $fkIEb.base58btc).prefix,
                    decoder.decode(`${(0, $fkIEb.base58btc).prefix}${source}`)
                ];
            }
        case (0, $fkIEb.base58btc).prefix:
            {
                const decoder = base || (0, $fkIEb.base58btc);
                return [
                    (0, $fkIEb.base58btc).prefix,
                    decoder.decode(source)
                ];
            }
        case (0, $1sOTj.base32).prefix:
            {
                const decoder = base || (0, $1sOTj.base32);
                return [
                    (0, $1sOTj.base32).prefix,
                    decoder.decode(source)
                ];
            }
        default:
            if (base == null) throw Error("To parse non base32 or base58btc encoded CID multibase decoder must be provided");
            return [
                source[0],
                base.decode(source)
            ];
    }
};
const $c14c8d42c9ead59e$var$toStringV0 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    if (prefix !== (0, $fkIEb.base58btc).prefix) throw Error(`Cannot string encode V0 in ${base.name} encoding`);
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes).slice(1);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $c14c8d42c9ead59e$var$toStringV1 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $c14c8d42c9ead59e$var$DAG_PB_CODE = 112;
const $c14c8d42c9ead59e$var$SHA_256_CODE = 18;
const $c14c8d42c9ead59e$var$encodeCID = (version, code, multihash)=>{
    const codeOffset = $1GK2R.encodingLength(version);
    const hashOffset = codeOffset + $1GK2R.encodingLength(code);
    const bytes = new Uint8Array(hashOffset + multihash.byteLength);
    $1GK2R.encodeTo(version, bytes, 0);
    $1GK2R.encodeTo(code, bytes, codeOffset);
    bytes.set(multihash, hashOffset);
    return bytes;
};
const $c14c8d42c9ead59e$var$cidSymbol = Symbol.for("@ipld/js-cid/CID");
const $c14c8d42c9ead59e$var$readonly = {
    writable: false,
    configurable: false,
    enumerable: true
};
const $c14c8d42c9ead59e$var$hidden = {
    writable: false,
    enumerable: false,
    configurable: false
};
const $c14c8d42c9ead59e$var$version = "0.0.0-dev";
const $c14c8d42c9ead59e$var$deprecate = (range, message)=>{
    if (range.test($c14c8d42c9ead59e$var$version)) console.warn(message);
    else throw new Error(message);
};
const $c14c8d42c9ead59e$var$IS_CID_DEPRECATION = `CID.isCID(v) is deprecated and will be removed in the next major release.
Following code pattern:

if (CID.isCID(value)) {
  doSomethingWithCID(value)
}

Is replaced with:

const cid = CID.asCID(value)
if (cid) {
  // Make sure to use cid instead of value
  doSomethingWithCID(cid)
}
`;

});





parcelRegister("cvLi9", function(module, exports) {
"use strict";

var $cKKV3 = parcelRequire("cKKV3");
/**
 * @typedef {import('./util/bases').SupportedEncodings} SupportedEncodings
 */ /**
 * Create a `Uint8Array` from the passed string
 *
 * Supports `utf8`, `utf-8`, `hex`, and any encoding supported by the multiformats module.
 *
 * Also `ascii` which is similar to node's 'binary' encoding.
 *
 * @param {string} string
 * @param {SupportedEncodings} [encoding=utf8] - utf8, base16, base64, base64urlpad, etc
 * @returns {Uint8Array}
 */ function $91bd107769b33832$var$fromString(string, encoding = "utf8") {
    const base = $cKKV3[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    // add multibase prefix
    return base.decoder.decode(`${base.prefix}${string}`);
}
module.exports = $91bd107769b33832$var$fromString;

});

parcelRegister("gg53d", function(module, exports) {
"use strict";
/**
 * Returns a new Uint8Array created by concatenating the passed ArrayLikes
 *
 * @param {Array<ArrayLike<number>>} arrays
 * @param {number} [length]
 */ function $bd620ef28c12eecb$var$concat(arrays, length) {
    if (!length) length = arrays.reduce((acc, curr)=>acc + curr.length, 0);
    const output = new Uint8Array(length);
    let offset = 0;
    for (const arr of arrays){
        output.set(arr, offset);
        offset += arr.length;
    }
    return output;
}
module.exports = $bd620ef28c12eecb$var$concat;

});


parcelRegister("5cAwf", function(module, exports) {

var $3Dz4Y = parcelRequire("3Dz4Y");

var $f5gxW = parcelRequire("f5gxW");

var $3IH32 = parcelRequire("3IH32");

var $cbZCz = parcelRequire("cbZCz");

var $e6fPk = parcelRequire("e6fPk");
function $3c9a66ad3cb1f258$var$formatGrouped(context, data, type, filter, coreKey) {
    // Group fields into extensions
    let groups = {};
    for(let field in data){
        let value;
        try {
            let parts = field.split(/:(.*)/);
            if (parts.length === 1) parts.unshift(coreKey);
            let ext = parts[0];
            if (typeof filter === "function" && !filter(field, [
                field
            ])) continue;
            value = data[field];
            let spec = $3Dz4Y.getSpecification(field, type);
            // Move to another extension (e.g. if no prefix is provided)
            if (spec.ext) ext = spec.ext;
            // Special handling for summaries that contain a list with keys (e.g. cube:dimensions, gee:schema)
            // There's usually just a single object included, so get that as value
            let isSummarizedListWithKeys = false;
            if (type === "summaries" && spec.listWithKeys && Array.isArray(value) && value.length > 0) {
                value = value[0];
                isSummarizedListWithKeys = true;
            }
            // Fill items with missing properties
            let items = null;
            let itemOrder = [];
            if ($f5gxW.isObject(spec.items)) {
                let temp = value;
                // Ignore keys for lists that are stored as object (e.g. cube:dimensions)
                if (spec.listWithKeys) temp = Object.values(temp);
                let itemFieldNames = [];
                if (Array.isArray(temp)) itemFieldNames = $f5gxW.keysFromListOfObjects(temp);
                else if ($f5gxW.isObject(temp)) itemFieldNames = Object.keys(temp);
                items = {};
                // Remove fields from list that are not available in the data
                itemOrder = spec.itemOrder.filter((fieldName)=>itemFieldNames.includes(fieldName));
                itemFieldNames.forEach((key)=>{
                    if (typeof spec.items[key] === "undefined") {
                        // Add fields that are not specified in fields.json
                        items[key] = {
                            label: $f5gxW.formatKey(key),
                            explain: key
                        };
                        // Place non-specified fields at the end
                        itemOrder.push(key);
                    } else {
                        // Clone field spec from fields.json
                        items[key] = Object.assign({}, spec.items[key]);
                        items[key].label = $3c9a66ad3cb1f258$var$label(key, spec.items[key]);
                    }
                });
            }
            // Format values
            let formatted;
            // Handle summaries
            if (type === "summaries") {
                if (!isSummarizedListWithKeys && $f5gxW.isObject(value)) {
                    if (typeof value.minimum !== "undefined" && typeof value.maximum !== "undefined") {
                        const formatSummaryValue = (x)=>$3c9a66ad3cb1f258$var$format(x, field, context, data, spec, filter, [
                                field
                            ]);
                        if (value.minimum === value.maximum) formatted = formatSummaryValue(value.minimum);
                        else if (value.minimum === null) formatted = `< ${formatSummaryValue(value.maximum)}`;
                        else if (value.maximum === null) formatted = `> ${formatSummaryValue(value.minimum)}`;
                        else formatted = `${formatSummaryValue(value.minimum)} \u{2013} ${formatSummaryValue(value.maximum)}`;
                    } else formatted = $cbZCz.object(value);
                } else if ($3Dz4Y.externalRenderer && items) {
                    let formatted = isSummarizedListWithKeys ? Object.assign({}, value) : value.slice(0);
                    // Go through each field's summary
                    for(let i in formatted){
                        let result = $f5gxW.isObject(formatted[i]) ? {} : [];
                        // Go through each entry in a field's summary (this is besically a single value as defined in the Item spec)
                        for(let key in items)result[key] = $3c9a66ad3cb1f258$var$format(formatted[i][key], key, context, data, items[key]);
                        formatted[i] = result;
                    }
                } else if (Array.isArray(value)) formatted = $f5gxW.toList(value, !spec.custom && !spec.items, (v)=>$3c9a66ad3cb1f258$var$format(v, field, context, data, spec));
                else console.warn(`Invalid summary value: ${value}`);
            }
            // Fallback to "normal" rendering if not handled by summaries yet
            if (typeof formatted === "undefined") formatted = $3c9a66ad3cb1f258$var$format(value, field, context, data, spec, filter, [
                field
            ]);
            // Add group if missing
            if (!$f5gxW.isObject(groups[ext])) groups[ext] = {
                extension: ext,
                label: $3c9a66ad3cb1f258$var$extension(ext),
                properties: {}
            };
            groups[ext].properties[field] = {
                label: $3c9a66ad3cb1f258$var$label(field, spec),
                value: value,
                formatted: formatted,
                items: items,
                itemOrder: itemOrder,
                spec: spec
            };
        } catch (error) {
            console.error(`Field '${field}' with value '${value}' resulted in an error`, error);
        }
    }
    return Object.values(groups).sort((a, b)=>$3IH32.collator.compare(a.extension, b.extension));
}
// For assets (item and collection) and item-assets (extension)
function $3c9a66ad3cb1f258$var$formatAsset(asset, context, filter = null, coreKey = "") {
    return $3c9a66ad3cb1f258$var$formatGrouped(context, asset, "assets", filter, coreKey);
}
// For links
function $3c9a66ad3cb1f258$var$formatLink(link, context, filter = null, coreKey = "") {
    return $3c9a66ad3cb1f258$var$formatGrouped(context, link, "links", filter, coreKey);
}
// For Providers
function $3c9a66ad3cb1f258$var$formatProvider(provider, context, filter = null, coreKey = "") {
    return $3c9a66ad3cb1f258$var$formatGrouped(context, provider, "providers", filter, coreKey);
}
// For Collection summaries
function $3c9a66ad3cb1f258$var$formatSummaries(collection, filter = null, coreKey = "") {
    return $3c9a66ad3cb1f258$var$formatGrouped(collection, collection.summaries, "summaries", filter, coreKey);
}
// For Collections
function $3c9a66ad3cb1f258$var$formatCollection(collection, filter = null, coreKey = "") {
    return $3c9a66ad3cb1f258$var$formatGrouped(collection, collection, "collection", filter, coreKey);
}
// For Catalogs
function $3c9a66ad3cb1f258$var$formatCatalog(catalog, filter = null, coreKey = "") {
    return $3c9a66ad3cb1f258$var$formatGrouped(catalog, catalog, "catalog", filter, coreKey);
}
// For item properties
function $3c9a66ad3cb1f258$var$formatItemProperties(item, filter = null, coreKey = "") {
    return $3c9a66ad3cb1f258$var$formatGrouped(item, item.properties, "metadata", filter, coreKey);
}
function $3c9a66ad3cb1f258$var$format(value, field, context = null, parent = null, spec = null, filter = null, path = []) {
    if (!$f5gxW.isObject(spec)) spec = $3Dz4Y.getSpecification(field);
    if (typeof spec.format === "string") {
        let fn = $e6fPk[`format${spec.format}`];
        if (!fn) console.warn(`Formatter '${spec.format}' not available.`);
        return fn(value, field, spec, context, parent);
    } else if (typeof spec.formatter === "function") return spec.formatter(value, field, spec, context, parent);
    else if ($f5gxW.isObject(spec.mapping)) {
        let key = String(value);
        if (typeof spec.mapping[key] !== "undefined") value = spec.mapping[key];
        else if (typeof spec.mapping[key.toLowerCase()] !== "undefined") value = spec.mapping[key.toLowerCase()];
        else if (typeof spec.mapping[key.toUpperCase()] !== "undefined") value = spec.mapping[key.toUpperCase()];
        return $cbZCz.format($f5gxW.t(value), spec.unit);
    } else if (value === null && spec.null) return $cbZCz.null(spec.null);
    else if (Array.isArray(value)) {
        let callback = (v, i)=>$3c9a66ad3cb1f258$var$format(v, field, context, parent, spec, filter, path.concat([
                i
            ]));
        if (typeof filter === "function" && path.length > 0) value = value.filter((v, i)=>filter(path[0], path.concat([
                i
            ])));
        if ($3Dz4Y.externalRenderer && (spec.custom || spec.items)) return value.map(callback);
        else return $f5gxW.toList(value, false, callback);
    } else if ($f5gxW.isObject(value)) {
        let callbackSpec = (k)=>{
            if ($f5gxW.isObject(spec.items)) return spec.listWithKeys ? {
                items: spec.items,
                itemOrder: spec.itemOrder
            } : spec.items[k];
            else if ($f5gxW.isObject(spec.properties)) return spec.properties[k];
            return {};
        };
        let callbackValue = (v, k, p)=>$3c9a66ad3cb1f258$var$format(v, k, context, p, callbackSpec(k), filter, path.concat([
                k
            ]));
        if ($3Dz4Y.externalRenderer && (spec.custom || spec.items || spec.properties)) {
            let formattedValues = {};
            for(let key in value){
                if (typeof filter === "function" && path.length > 0 && !filter(path[0], path.concat([
                    key
                ]))) continue;
                formattedValues[key] = callbackValue(value[key], key, value);
            }
            return formattedValues;
        } else {
            let callbackLabel = (k)=>$3c9a66ad3cb1f258$var$label(k, callbackSpec(k));
            let itemOrder = spec.listWithKeys ? [] : spec.itemOrder;
            return $f5gxW.toObject(value, callbackValue, callbackLabel, itemOrder, filter, path);
        }
    } else return $cbZCz.format(value, spec.unit);
}
function $3c9a66ad3cb1f258$var$label(key, spec = null) {
    if (!$f5gxW.isObject(spec)) spec = $3Dz4Y.getSpecification(key);
    if ($f5gxW.isObject(spec) && typeof spec.label === "string") {
        if (typeof spec.explain === "string") {
            if (spec.explain.match(/^https?:\/\//i)) return $f5gxW.toLink(spec.explain, $f5gxW.t(spec.label), "about");
            else return $f5gxW.abbrev($f5gxW.t(spec.label), $f5gxW.t(spec.explain));
        } else if (typeof spec.label === "string") return $f5gxW.t(spec.label);
    }
    return $f5gxW.formatKey(key);
}
function $3c9a66ad3cb1f258$var$extension(key) {
    return $3c9a66ad3cb1f258$var$label(key, $3Dz4Y.getExtension(key));
}
module.exports = {
    format: $3c9a66ad3cb1f258$var$format,
    label: $3c9a66ad3cb1f258$var$label,
    extension: $3c9a66ad3cb1f258$var$extension,
    formatCatalog: $3c9a66ad3cb1f258$var$formatCatalog,
    formatCollection: $3c9a66ad3cb1f258$var$formatCollection,
    formatSummaries: $3c9a66ad3cb1f258$var$formatSummaries,
    formatItemProperties: $3c9a66ad3cb1f258$var$formatItemProperties,
    formatAsset: $3c9a66ad3cb1f258$var$formatAsset,
    formatLink: $3c9a66ad3cb1f258$var$formatLink,
    formatProvider: $3c9a66ad3cb1f258$var$formatProvider,
    formatGrouped: $3c9a66ad3cb1f258$var$formatGrouped
};

});
parcelRegister("3Dz4Y", function(module, exports) {

var $fE1hr = parcelRequire("fE1hr");
const $2a6039a4382d66e3$var$Registry = {
    externalRenderer: false,
    dependencies: {},
    fields: {
        assets: {},
        extensions: {},
        links: {},
        metadata: {}
    },
    exportFields () {
        return this.fields;
    },
    importFields (fields) {
        fields = $fE1hr.fields(fields);
        for(let key in this.fields)Object.assign(this.fields[key], fields[key]);
    },
    getDependency (name) {
        if (!this.dependencies[name]) console.warn(`Dependency '${name}' not registered.`);
        return this.dependencies[name];
    },
    addDependency (name, library) {
        this.dependencies[name] = library;
    },
    addExtension (prefix, spec) {
        this.fields.extensions[prefix] = $fE1hr.field(spec, this.fields.extensions);
    },
    addMetadataField (field, spec) {
        this.fields.metadata[field] = $fE1hr.field(spec, this.fields.metadata);
    },
    addLinkField (field, spec) {
        this.fields.links[field] = $fE1hr.field(spec, this.fields.links);
    },
    addAssetField (field, spec) {
        this.fields.assets[field] = $fE1hr.field(spec, this.fields.assets);
    },
    addMetadataFields (specs) {
        for(var key in specs)$2a6039a4382d66e3$var$Registry.addMetadataField(key, specs[key]);
    },
    getExtension (name) {
        if (this.fields.extensions[name]) return this.fields.extensions[name];
        else return {};
    },
    getSpecification (field, type = null) {
        let spec = {};
        if (type === "assets" && this.fields.assets[field]) spec = this.fields.assets[field];
        else if (type === "links" && this.fields.links[field]) spec = this.fields.links[field];
        else if (this.fields.metadata[field]) spec = this.fields.metadata[field];
        return spec;
    }
};
module.exports = $2a6039a4382d66e3$var$Registry;

});
parcelRegister("fE1hr", function(module, exports) {

var $f5gxW = parcelRequire("f5gxW");

var $3IH32 = parcelRequire("3IH32");
const $b63b95a9e6d484fa$var$Normalize = {
    fields (fields) {
        let parts = [
            "extensions",
            "metadata",
            "links",
            "assets"
        ];
        for (let part of parts)for(let key in fields[part])fields[part][key] = $b63b95a9e6d484fa$var$Normalize.field(fields[part][key], fields[part], fields);
        return fields;
    },
    field (spec, fields = {}, allFields = {}) {
        // If just a string label is given, make a normal object with a label from it
        if (typeof spec === "string") return {
            label: spec
        };
        // Resolve alias
        if (typeof spec.alias === "string") {
            // As we don't know whether the alias has been resolved so far, resolve it here, too.
            let aliasedSpec = fields[spec.alias] || allFields.metadata[spec.alias];
            if (!aliasedSpec) throw new Error("Alias is invalid: " + spec.alias);
            return Object.assign(spec, $b63b95a9e6d484fa$var$Normalize.field(aliasedSpec, fields, allFields));
        }
        // Normalize items
        if ($f5gxW.isObject(spec.items)) {
            let itemOrder = [];
            for(let key in spec.items){
                spec.items[key] = $b63b95a9e6d484fa$var$Normalize.field(spec.items[key], fields, allFields);
                itemOrder.push(Object.assign({
                    key: key
                }, spec.items[key]));
            }
            spec.itemOrder = itemOrder.sort((i1, i2)=>{
                if (i1.id === true) return -1;
                else if (i2.id === true) return 1;
                else if (typeof i1.order === "number" && typeof i2.order === "number") return i1.order - i2.order;
                else return $3IH32.collator.compare($f5gxW.t(i1.label), $f5gxW.t(i2.label));
            }).map((item)=>item.key);
        }
        // Normalize properties
        if ($f5gxW.isObject(spec.properties)) for(let key in spec.properties)spec.properties[key] = $b63b95a9e6d484fa$var$Normalize.field(spec.properties[key], fields, allFields);
        return spec;
    }
};
module.exports = $b63b95a9e6d484fa$var$Normalize;

});


parcelRegister("cbZCz", function(module, exports) {

var $f5gxW = parcelRequire("f5gxW");

var $3IH32 = parcelRequire("3IH32");
const $8e064fc8feee3a1d$var$DataTypes = {
    array (arr, sort = false, unit = "") {
        return $f5gxW.toList(arr, sort, (v)=>$8e064fc8feee3a1d$var$DataTypes.format(v, unit));
    },
    object (obj) {
        return $f5gxW.toObject(obj, (v)=>$8e064fc8feee3a1d$var$DataTypes.format(v));
    },
    null (label = null) {
        if (label === null) label = $f5gxW.t("n/a");
        return $f5gxW.toNothing(label);
    },
    number (num, unit = "") {
        if (typeof num !== "number") num = parseFloat(num);
        return $f5gxW.unit($3IH32.numberFormatter.format(num), unit);
    },
    string (str, unit = "") {
        return $f5gxW.unit($f5gxW.e(str).replace(/(\r\n|\r|\n){2,}/g, "<br>"), unit);
    },
    boolean (bool) {
        return bool ? "\u2714\uFE0F" : "\u274C";
    },
    format (value, unit = "") {
        if (typeof value === "boolean") return $8e064fc8feee3a1d$var$DataTypes.boolean(value);
        else if (typeof value === "number") return $8e064fc8feee3a1d$var$DataTypes.number(value, unit);
        else if (typeof value === "string") return $8e064fc8feee3a1d$var$DataTypes.string(value, unit);
        else if (Array.isArray(value)) return $8e064fc8feee3a1d$var$DataTypes.array(value, unit);
        else if ($f5gxW.isObject(value)) return $8e064fc8feee3a1d$var$DataTypes.object(value);
        else return $8e064fc8feee3a1d$var$DataTypes.null();
    }
};
module.exports = $8e064fc8feee3a1d$var$DataTypes;

});

parcelRegister("e6fPk", function(module, exports) {

var $f5gxW = parcelRequire("f5gxW");

var $cbZCz = parcelRequire("cbZCz");

var $3IH32 = parcelRequire("3IH32");

var $3Dz4Y = parcelRequire("3Dz4Y");

const $a43de722b9f1af91$var$Formatters = {
    allowHtmlInCommonMark: false,
    formatUrl (value, field, spec = {}, context = null, parent = null) {
        let title = $f5gxW.isObject(parent) && typeof parent === "string" ? parent.title : value;
        return $f5gxW.toLink(value, title, parent.rel || "");
    },
    formatLink (value) {
        return $f5gxW.toList(value, false, (value)=>$f5gxW.toLink(value.href, value.title, value.rel));
    },
    formatMediaType (value, field, spec = {}) {
        return $f5gxW.e($f5gxW.t($a43de722b9f1af91$var$Formatters._formatMediaType(value, field, spec)));
    },
    _formatMediaType (value, field, spec = {}) {
        let short = Boolean(spec.shorten);
        const mediaType = $3Dz4Y.getDependency("content-type");
        if (!mediaType) return short ? "" : $f5gxW.e(value);
        let media;
        try {
            media = mediaType.parse(value);
        } catch (error) {
            console.warn(error);
            return short ? "" : $f5gxW.e(value);
        }
        switch(media.type){
            // not supported: image/vnd.stac.geotiff; cloud-optimized=true
            case "image/tiff":
                if (media.parameters.application === "geotiff") {
                    if (media.parameters.profile === "cloud-optimized") return short ? "COG" : "Cloud-Optimized GeoTIFF image";
                    else return short ? "GeoTiff" : "GeoTIFF image";
                } else return short ? "TIFF" : "TIFF image";
            case "image/jp2":
                return short ? "JPEG 2000" : "JPEG 2000 image";
            case "image/png":
            case "image/apng":
            case "image/vnd.mozilla.apng":
                return short ? "PNG" : "PNG image";
            case "image/gif":
                return short ? "GIF" : "GIF image";
            case "image/jpeg":
            case "image/jpg":
                return short ? "JPEG" : "JPEG image";
            case "image/webp":
                return short ? "WebP" : "WebP image";
            case "image/bmp":
            case "image/x-bmp":
            case "image/x-ms-bmp":
            case "image/wbmp":
                return short ? "Bitmap" : "Bitmap image";
            case "image/svg+xml":
                return short ? "SVG" : "SVG vector image";
            case "text/csv":
                return short ? "CSV" : "Comma-separated values (CSV)";
            case "text/xml":
            case "application/xml":
                return "XML";
            case "text/json":
            case "application/json":
                return "JSON";
            case "application/x-ndjson":
                return short ? "NDJSON" : "Newline Delimited JSON";
            case "text/yaml":
            case "text/vnd.yaml":
            case "text/x-yaml":
            case "application/x-yaml":
                return "YAML";
            case "application/geo+json":
                return "GeoJSON";
            case "application/gml+xml":
                return "GML";
            case "application/vnd.google-earth.kml+xml":
            case "application/vnd.google-earth.kmz":
                return "KML";
            case "application/geopackage+vnd.sqlite3":
            case "application/geopackage+sqlite3":
                return "GeoPackage";
            case "text/html":
            case "application/html":
            case "application/xhtml+xml":
                return short ? "HTML" : "HTML (Website)";
            case "text/plain":
                return short ? "Text" : "Text document";
            case "text/markdown":
                return short ? "Markdown" : "Markdown document";
            case "application/pdf":
                return short ? "PDF" : "PDF document";
            case "application/zip":
                return short ? "ZIP" : "ZIP archive";
            case "application/gzip":
                return short ? "GZIP" : "GZIP archive";
            case "application/x-hdf":
                return "HDF";
            case "application/netcdf":
            case "application/x-netcdf":
                return "NetCDF";
            case "application/x.mrf":
                return short ? "MRF" : "Meta Raster Format";
            case "application/wmo-GRIB2":
                return "GRIB 2";
            case "application/grib":
                return `GRIB ${media.parameters.edition || ""}`.trim();
            case "application/bufr":
                return `BUFR ${media.parameters.edition || ""}`.trim();
            case "application/octet-stream":
                return short ? "Binary" : "Binary file";
            case "application/vnd.laszip":
                return "LASzip";
            case "application/vnd.laszip+copc":
                return short ? "COPC" : "Cloud-Optimized Point Cloud (LASzip)";
            case "application/vnd+zarr":
                return "Zarr";
            case "application/x-parquet":
            case "application/vnd.apache.parquet":
                return "Parquet";
            case "application/vnd.pmtiles":
                return "PMTiles";
            case "application/vnd.cov+json":
                return "CoverageJSON";
            case "application/vnd.flatgeobuf":
                return "FlatGeobuf"; // inofficial: https://github.com/flatgeobuf/flatgeobuf/discussions/112
            case "application/x-filegdb":
                return short ? "Geodatabase" : "Esri File Geodatabase";
            case "application/vnd.nitf":
                return short ? "NITF" : "National Imagery Transmission Format";
            case "application/3dtiles+json":
                return "3D Tiles";
            default:
                {
                    let [group, format] = media.type.split("/");
                    format = $f5gxW.formatKey(format.replace(/^(vnd|x)[.+-]/, ""));
                    if (short) return format;
                    switch(group){
                        case "audio":
                            return `${format} audio`;
                        case "image":
                            return `${format} image`;
                        case "font":
                            return `Font`;
                        case "model":
                            return `${format} 3D model`;
                        case "video":
                            return `${format} video`;
                        case "text":
                        case "application":
                            return format;
                        default:
                            return value;
                    }
                }
        }
    },
    formatTimestamp (value) {
        if (typeof value === "string") try {
            return $3IH32.dateTimeFormatter.format(new Date(value));
        } catch (error) {}
        return $cbZCz.null();
    },
    formatPercent0to1 (value, field, spec = {}) {
        return $cbZCz.number(value * 100, spec.unit);
    },
    formatDate (value) {
        if (typeof value === "string") try {
            return $3IH32.dateFormatter.format(new Date(value));
        } catch (error) {}
        return $cbZCz.null();
    },
    formatDuration (value) {
        if (typeof value === "string") {
            const lib = $3Dz4Y.getDependency("@musement/iso-duration");
            if (!lib) return $f5gxW.e(value);
            const { isoDuration: isoDuration, en: en } = lib;
            isoDuration.setLocales({
                en: en
            }, {
                fallbackLocale: "en"
            });
            let formatted = isoDuration(value).humanize("en");
            if (formatted.length === 0) return $f5gxW.e($f5gxW.t("none"));
            else return $f5gxW.e(formatted);
        }
        return $cbZCz.null();
    },
    formatLanguageCode (value) {
        if (Array.isArray(value)) return $f5gxW.toList(value, true, $a43de722b9f1af91$var$Formatters.formatLanguageCode, false);
        else if (typeof value !== "string" || value.length < 2) return $cbZCz.null();
        const list = (parcelRequire("ggVZQ"));
        const [code, ...rest] = value.split("-");
        if (code in list) {
            const name = list[code];
            if (rest.length > 0) return $f5gxW.e($f5gxW.t(`${name} (${rest.join(" ")})`));
            return $f5gxW.e($f5gxW.t(name));
        }
        return $f5gxW.e($f5gxW.t(value));
    },
    formatLicense (value, field, spec = {}, context = null) {
        if (typeof value !== "string" || value.length === 0) return $cbZCz.null();
        // We could use the spdx-license-ids and/or spdx-to-html packages previously used in STAC Browser,
        // but let's try it without additional dependency for now.
        if (value !== "other" && value !== "proprietary" && value !== "various" && value.match(/^[\w\.\-]+$/i)) return $f5gxW.toLink(`https://spdx.org/licenses/${value}.html`, value, "license");
        let licenses = Array.isArray(context.links) ? context.links.filter((link)=>$f5gxW.isObject(link) && typeof link.href === "string" && link.rel === "license") : [];
        if (licenses.length > 0) return $f5gxW.toList(licenses, false, (link)=>$f5gxW.toLink(link.href, link.title || value, "license"));
        else return $cbZCz.string(value);
    },
    formatProviders (value) {
        return $f5gxW.toList(value, false, (provider)=>{
            let name = provider.name;
            let roles = "";
            let description = "";
            if (typeof provider.url === "string" && provider.url.length > 0) name = $f5gxW.toLink(provider.url, name);
            if (Array.isArray(provider.roles) && provider.roles.length > 0) {
                roles = provider.roles.map((r)=>$cbZCz.format(r)).join(", ");
                roles = ` (<em>${roles}</em>)`;
            }
            if (typeof provider.description === "string" && provider.description.length > 0) description = $a43de722b9f1af91$var$Formatters.formatCommonMark(provider.description);
            return `${name}${roles}${description}`;
        });
    },
    formatCommonMark (value) {
        if (typeof value !== "string" || value.length === 0) return $cbZCz.null();
        const commonmark = $3Dz4Y.getDependency("commonmark");
        let html;
        if (commonmark) {
            let reader = new commonmark.Parser();
            let writer = new commonmark.HtmlRenderer({
                safe: !$a43de722b9f1af91$var$Formatters.allowHtmlInCommonMark,
                smart: true
            });
            html = writer.render(reader.parse(value));
        } else if ($a43de722b9f1af91$var$Formatters.allowHtmlInCommonMark) html = value;
        else html = $f5gxW.e(value);
        return `<div class="description">${html}</div>`;
    },
    formatSoftware (value) {
        if (!$f5gxW.isObject(value)) return $cbZCz.null();
        let list = [];
        for(let software in value){
            let version = value[software];
            if (typeof version === "string" && version.length > 0 || typeof version === "number") list.push(`${software} (${version})`);
            else list.push(software);
        }
        return $f5gxW.toList(list, true, null, false);
    },
    formatDOI (value) {
        value = $cbZCz.format(value);
        return $f5gxW.toLink(`http://doi.org/${value}`, value);
    },
    formatCRS (value) {
        return $f5gxW.toList(value, false, (value)=>{
            if (typeof value === "string") {
                let title = value.replace(/^https?:\/\/www\.opengis\.net\/def\/crs\//i, "") // HTTP(s) URI
                .replace(/^urn:ogc:def:crs:/i, ""); // OGC URN
                return $f5gxW.toLink(value, title);
            }
            return $cbZCz.format(value);
        });
    },
    formatCrsCode (value) {
        if (typeof value === "string") {
            const [authority, code] = value.split(":", 2);
            switch(authority.toUpperCase()){
                case "EPSG":
                case "ESRI":
                case "IAU_2015":
                case "IGNF":
                case "MKG":
                case "OGC":
                    return $f5gxW.toLink(`https://spatialreference.org/ref/${authority.toLowerCase()}/${code}/`, value);
                default:
                    return $cbZCz.string(value);
            }
        }
        return $cbZCz.null();
    },
    /**
	 * @deprecated Use formatCrsCode instead
	 */ formatEPSG (value) {
        if (typeof value === "number") return $a43de722b9f1af91$var$Formatters.formatCrsCode(`EPSG:${value}`);
        else if (typeof value === "string") return $a43de722b9f1af91$var$Formatters.formatCrsCode(value);
        return $cbZCz.null();
    },
    formatExtent (value, field, spec = {}) {
        if (!Array.isArray(value) || value.length < 2) return $cbZCz.null();
        else if (value[0] === value[1]) return $cbZCz.format(value[0], spec.unit);
        else if (value[0] === null) return `< ${$cbZCz.format(value[1], spec.unit)}`;
        else if (value[1] === null) return `> ${$cbZCz.format(value[0], spec.unit)}`;
        else return value.map((v)=>$cbZCz.format(v, spec.unit)).join(" \u2013 ");
    },
    formatHexColor (value) {
        if (typeof value !== "string" || !value.match(/^#?[\dA-F]{3,8}$/i)) return $cbZCz.null();
        if (value.startsWith("#")) value = value.substring(1);
        return `<div class="color" style="background-color: #${value}"><code class="color-code">#${value}</code></div>`;
    },
    formatPROJJSON (value) {
        if (!$f5gxW.isObject(value)) return $cbZCz.null();
        if ($f5gxW.isObject(value.id) && value.id.authority === "EPSG" && typeof value.code === "number" && value.code > 0) return "EPSG " + $a43de722b9f1af91$var$Formatters.formatEPSG(value);
        else if (typeof value.name === "string") return $cbZCz.string(value.name);
        else return $cbZCz.object(value);
    },
    formatTemporalExtent (value, field, spec = {}) {
        if (!Array.isArray(value) || value.length !== 2) return $cbZCz.null();
        value = value.map((d)=>{
            try {
                return d ? new Date(d) : null;
            } catch (e) {
                return null;
            }
        });
        try {
            const [start, end] = value;
            if (start || end) {
                const base = spec.shorten ? $3IH32.dateFormatter : $3IH32.dateTimeFormatter;
                if (!start) return $f5gxW.t("Until {0}", [
                    base.format(end)
                ]);
                else if (!end) return $f5gxW.t("{0} until present", [
                    base.format(start)
                ]);
                else return base.formatRange(start, end);
            }
        } catch (error) {}
        return $cbZCz.null();
    },
    formatTemporalExtents (value, field, spec = {}) {
        let sortExtents = (a, b)=>{
            if (a[0] === null) return -1;
            else return $3IH32.collator.compare(a[0], b[0]);
        };
        return $f5gxW.toList(value, sortExtents, (v)=>$a43de722b9f1af91$var$Formatters.formatTemporalExtent(v, field, spec));
    },
    formatWKT2 (value) {
        if (typeof value !== "string") return $cbZCz.null();
        // This is a VERY simplistic WKT2 formatter, which may fail to render properly in some cases.
        let indent = -1;
        let formatted;
        try {
            formatted = value.replace(/([A-Z]+)\[|\]/ig, (match, keyword)=>{
                if (match === "]") {
                    indent--;
                    return match;
                } else {
                    indent++;
                    let tabs = "  ".repeat(indent);
                    return `\n${tabs}${keyword}[`;
                }
            });
        } catch (e) {
            // In case the formatting did not work properly
            // (usually the number of [ and ] doesn't match)
            // just return the unformatted value
            formatted = value;
        }
        return `<pre>${formatted}</pre>`;
    },
    fileSizeUnits: [
        "B",
        "kB",
        "MB",
        "GB",
        "TB"
    ],
    formatFileSize (value) {
        if (typeof value !== "number") return $cbZCz.format(value);
        var i = value == 0 ? 0 : Math.floor(Math.log(value) / Math.log(1024));
        return $f5gxW.unit((value / Math.pow(1024, i)).toFixed(2) * 1, $a43de722b9f1af91$var$Formatters.fileSizeUnits[i]);
    },
    formatChecksum (value) {
        if (typeof value !== "string") return $cbZCz.null();
        const multihash = $3Dz4Y.getDependency("multihashes");
        if (!multihash) return $f5gxW.e(value);
        try {
            const meta = multihash.decode($f5gxW.hexToUint8(value));
            const name = $f5gxW.e(meta.name);
            const hex = $f5gxW.e($f5gxW.uint8ToHex(meta.digest));
            return `<div class="checksum"><input class="checksum-input" size="32" value="${hex}" readonly><br><span class="checksum-algo">${$f5gxW.t("Hashing algorithm:")} <strong>${name}</strong></span></div>`;
        } catch (error) {
            return $cbZCz.null();
        }
    },
    fileDataTypes: {
        "int8": "8-bit integer",
        "int16": "16-bit integer",
        "int32": "32-bit integer",
        "int64": "64-bit integer",
        "uint8": "unsigned 8-bit integer",
        "uint16": "unsigned 16-bit integer",
        "uint32": "unsigned 32-bit integer",
        "uint64": "unsigned 64-bit integer",
        "float16": "16-bit float",
        "float32": "32-bit float",
        "float64": "64-bit float",
        "cint16": "16-bit complex integer",
        "cint32": "32-bit complex integer",
        "cfloat32": "32-bit complex float",
        "cfloat64": "64-bit complex float"
    },
    formatFileDataType (value) {
        if (value === "other") return $f5gxW.t("non-standard");
        else if (typeof value === "string" && value in $a43de722b9f1af91$var$Formatters.fileDataTypes) return $f5gxW.abbrev($f5gxW.t(value), $f5gxW.t($a43de722b9f1af91$var$Formatters.fileDataTypes[value]));
        return $cbZCz.null();
    },
    formatTransform (value) {
        if (Array.isArray(value) && value.length % 3 === 0) {
            let rows = [];
            for(let i = 0; i < value.length; i = i + 3){
                let chunk = value.slice(i, i + 3);
                rows.push(`[${$a43de722b9f1af91$var$Formatters.formatCSV(chunk)}]`);
            }
            return rows.join("<br>");
        } else return $a43de722b9f1af91$var$Formatters.formatCSV(value);
    },
    formatShape (value, field, spec = {}) {
        if (Array.isArray(value)) return value.map((x)=>$cbZCz.format(x, spec.unit)).join(" \xd7 ");
        else return $cbZCz.format(value, spec.unit);
    },
    formatCSV (value) {
        if (Array.isArray(value)) {
            let numeric = value.find((v)=>typeof v === "number") !== undefined;
            // If there's potentially a comma in the values (decimal or thousand separators in numbers), use semicolon instead of comma.
            return value.map($cbZCz.format).join(numeric ? "; " : ", ");
        } else return $cbZCz.format(value);
    },
    formatImage (value, field) {
        let title = "";
        let src = null;
        if ($f5gxW.isObject(value)) {
            src = value.href;
            title = value.title || "";
        } else if (typeof value === "string") src = value;
        else return $cbZCz.format(src);
        return `<img src="${$f5gxW.e(src)}" title="${$f5gxW.e(title)}" class="${$f5gxW.e(field.replace(":", "_"))}">`;
    },
    formatPhone (value) {
        return $f5gxW.toLink(`tel:${value}`, value);
    },
    formatEmail (value) {
        return $f5gxW.toLink(`mailto:${value}`, value);
    },
    formatConcepts (value) {
        return $f5gxW.toList(value, false, (concept)=>{
            if (!$f5gxW.isObject(concept)) return $cbZCz.format(concept);
            let html = "";
            if (concept.title) {
                let title = concept.title;
                if (concept.url) title = $f5gxW.toLink(concept.url, concept.title);
                html += `<strong>${title}</strong> (<code>${$f5gxW.e(concept.id)}</code>)`;
            } else {
                let title = concept.id;
                if (concept.url) title = $f5gxW.toLink(concept.url, concept.id);
                html += `<strong><code>${title}</code></strong>`;
            }
            if (concept.description) html += `<br><small>${$f5gxW.e(concept.description)}</small>`;
            return html;
        });
    },
    formatAddress (value) {
        return $f5gxW.toList(value, false, (address)=>{
            if (!$f5gxW.isObject(address)) return $cbZCz.format(address);
            let lines = Array.isArray(address.deliveryPoint) ? address.deliveryPoint.slice(0) : [];
            if (address.postalCode && address.city) {
                // Try to create a compact address
                let line = `${address.postalCode} ${address.city}`;
                if (address.administrativeArea) line += ` (${address.administrativeArea})`;
                if (typeof address.country === "string" && address.country.length > 0) {
                    if (address.country.length === 2 && address.country.toUpperCase() === address.country) {
                        line = address.country + "-" + line;
                        lines.push(line);
                    } else {
                        lines.push(line);
                        lines.push(address.country.toUpperCase());
                    }
                }
            } else {
                // Long version of the address
                if (address.city) lines.push(address.city);
                if (address.administrativeArea) lines.push(address.administrativeArea);
                if (address.postalCode) lines.push(address.postalCode);
                if (typeof address.country === "string" && address.country.length > 0) lines.push(address.country.toUpperCase());
            }
            return $cbZCz.string(lines.join("\n\n"));
        });
    },
    formatGridCode (value) {
        if (typeof value !== "string") return $cbZCz.format(value);
        let splitHalf = function(parts, value, labelA, labelB) {
            let len = value.length;
            if (len % 2 === 1) parts.push(`Code: ${value}`);
            else {
                let mid = len / 2;
                let a = value.substring(0, mid);
                parts.push(`${labelA}: ${a}`);
                let b = value.substring(mid, len);
                parts.push(`${labelB}: ${b}`);
            }
        };
        let [designator, code] = value.split(/-(.*)/);
        let parts = [];
        switch(designator){
            case "MGRS":
                parts.push($f5gxW.abbrev($f5gxW.t(designator), $f5gxW.t("Military Grid Reference System")));
                let [, utm, band, sq, coord] = code.match(/^(\d{2})([C-X])([A-Z]{2})(\d*)$/);
                parts.push(`${$f5gxW.t("UTM Zone")}: ${utm}`);
                parts.push(`${$f5gxW.t("Latitude Band")}: ${band}`);
                parts.push(`${$f5gxW.t("Square Identifier")}: ${sq}`);
                if (coord) splitHalf(parts, coord, $f5gxW.t("Easting"), $f5gxW.t("Northing"));
                break;
            case "MSIN":
                parts.push($f5gxW.t("MODIS Sinusoidal Tile Grid"));
                splitHalf(parts, code, $f5gxW.t("Horizontal"), $f5gxW.t("Vertical"));
                break;
            case "WRS1":
            case "WRS2":
                let version = designator.substring(3, 4);
                parts.push($f5gxW.abbrev($f5gxW.t("WRS-" + version), $f5gxW.t("Worldwide Reference System " + version)));
                splitHalf(parts, code, $f5gxW.t("Path"), $f5gxW.t("Row"));
                break;
            case "DOQ":
                parts.push(_abbrev($f5gxW.t(designator), $f5gxW.t("Digital Orthophoto Quadrangle")));
                parts.push(`${$f5gxW.t("Quadrangle")}: ${code}`);
                break;
            case "DOQQ":
                parts.push(_abbrev($f5gxW.t(designator), $f5gxW.t("Digital Orthophoto Quarter Quadrangle")));
                let quad = code.substr(0, code.length - 2);
                parts.push(`${$f5gxW.t("Quadrangle")}: ${quad}`);
                let quarter = code.substr(-2);
                let a = quarter[0] === "N" ? $f5gxW.t("North") : $f5gxW.t("South");
                let b = quarter[1] === "E" ? $f5gxW.t("East") : $f5gxW.t("West");
                parts.push(`${$f5gxW.t("Quarter")}: ${a} ${b}`);
                break;
            case "MXRA":
                parts.push($f5gxW.t("Maxar ARD Tile Grid"));
                let [zone, quadkey] = code.split(/-(.*)/);
                if (zone.startsWith("Z")) zone = zone.substring(1);
                parts.push(`${$f5gxW.t("UTM Zone")}: ${zone}`);
                parts.push(`${$f5gxW.t("Quadkey")}: ${quadkey}`);
                break;
            case "EASE":
                let [dggs, components] = code.split("-");
                if (dggs === "DGGS") {
                    parts.push($f5gxW.t("EASE-DGGS"));
                    let [level, rowcol, ...fractions] = components.split(".");
                    parts.push(`${$f5gxW.t("Level")}: ${level}`);
                    if (rowcol.length === 6) {
                        parts.push(`${$f5gxW.t("Level 0 row cell")}: ${rowcol.substring(0, 3)}`);
                        parts.push(`${$f5gxW.t("Level 0 column cell")}: ${rowcol.substring(3, 6)}`);
                        for(let i in fractions){
                            let value = fractions[i];
                            if (value.length === 2) {
                                parts.push(`${$f5gxW.t("Fraction of level {i} row cell", {
                                    i: i
                                })}: ${value[0]}`);
                                parts.push(`${$f5gxW.t("Fraction of level {i} column cell", {
                                    i: i
                                })}: ${value[1]}`);
                            }
                        }
                    }
                    break;
                }
            case "CDEM":
                let [, n, e] = code.match(/^([A-Z]\d+)([A-Z]\d+)$/);
                parts.push($f5gxW.t("Copernicus Digital Elevation Model Grid"));
                parts.push(`${$f5gxW.t("Easting")}: ${e}`);
                parts.push(`${$f5gxW.t("Northing")}: ${n}`);
            default:
                parts.push(value);
        }
        return parts.join("<br>");
    }
};
module.exports = $a43de722b9f1af91$var$Formatters;

});
parcelRegister("ggVZQ", function(module, exports) {
module.exports = JSON.parse('{"aa":"Afar","ab":"Abkhazian","af":"Afrikaans","ak":"Akan","am":"Amharic","an":"Aragonese","ar":"Arabic","as":"Assamese","av":"Avar","ay":"Aymara","az":"Azerbaijani","ba":"Bashkir","be":"Belarusian","bg":"Bulgarian","bh":"Bihari","bi":"Bislama","bm":"Bambara","bn":"Bengali","bo":"Tibetan","br":"Breton","bs":"Bosnian","ca":"Catalan","ce":"Chechen","ch":"Chamorro","co":"Corsican","cr":"Cree","cs":"Czech","cu":"Old Bulgarian","cv":"Chuvash","cy":"Welsh","da":"Danish","de":"German","dv":"Divehi","dz":"Dzongkha","ee":"Ewe","el":"Greek","en":"English","eo":"Esperanto","es":"Spanish","et":"Estonian","eu":"Basque","fa":"Persian","ff":"Peul","fi":"Finnish","fj":"Fijian","fo":"Faroese","fr":"French","fy":"West Frisian","ga":"Irish","gd":"Scottish Gaelic","gl":"Galician","gn":"Guarani","gu":"Gujarati","gv":"Manx","ha":"Hausa","he":"Hebrew","hi":"Hindi","ho":"Hiri Motu","hr":"Croatian","ht":"Haitian","hu":"Hungarian","hy":"Armenian","hz":"Herero","ia":"Interlingua","id":"Indonesian","ie":"Interlingue","ig":"Igbo","ii":"Sichuan Yi","ik":"Inupiak","io":"Ido","is":"Icelandic","it":"Italian","iu":"Inuktitut","ja":"Japanese","jv":"Javanese","ka":"Georgian","kg":"Kongo","ki":"Kikuyu","kj":"Kuanyama","kk":"Kazakh","kl":"Greenlandic","km":"Cambodian","kn":"Kannada","ko":"Korean","kr":"Kanuri","ks":"Kashmiri","ku":"Kurdish","kv":"Komi","kw":"Cornish","ky":"Kirghiz","la":"Latin","lb":"Luxembourgish","lg":"Ganda","li":"Limburgian","ln":"Lingala","lo":"Laotian","lt":"Lithuanian","lv":"Latvian","mg":"Malagasy","mh":"Marshallese","mi":"Maori","mk":"Macedonian","ml":"Malayalam","mn":"Mongolian","mo":"Moldovan","mr":"Marathi","ms":"Malay","mt":"Maltese","my":"Burmese","na":"Nauruan","nd":"North Ndebele","ne":"Nepali","ng":"Ndonga","nl":"Dutch","nn":"Norwegian Nynorsk","no":"Norwegian","nr":"South Ndebele","nv":"Navajo","ny":"Chichewa","oc":"Occitan","oj":"Ojibwa","om":"Oromo","or":"Oriya","os":"Ossetian","pa":"Punjabi","pi":"Pali","pl":"Polish","ps":"Pashto","pt":"Portuguese","qu":"Quechua","rm":"Raeto Romance","rn":"Kirundi","ro":"Romanian","ru":"Russian","rw":"Rwandi","sa":"Sanskrit","sc":"Sardinian","sd":"Sindhi","sg":"Sango","sh":"Serbo-Croatian","si":"Sinhalese","sk":"Slovak","sl":"Slovenian","sm":"Samoan","sn":"Shona","so":"Somalia","sq":"Albanian","sr":"Serbian","ss":"Swati","st":"Southern Sotho","su":"Sundanese","sv":"Swedish","sw":"Swahili","ta":"Tamil","te":"Telugu","tg":"Tajik","th":"Thai","ti":"Tigrinya","tk":"Turkmen","tl":"Tagalog","tn":"Tswana","to":"Tonga","tr":"Turkish","ts":"Tsonga","tt":"Tatar","tw":"Twi","ty":"Tahitian","ug":"Uyghur","uk":"Ukrainian","ur":"Urdu","ve":"Venda","vi":"Vietnamese","vo":"Volap\xfck","wa":"Walloon","wo":"Wolof","xh":"Xhosa","yi":"Yiddish","yo":"Yoruba","za":"Zhuang","zh":"Chinese","zu":"Zulu"}');

});



parcelRegister("31zZV", function(module, exports) {
/* MapLibre GL JS is licensed under the 3-Clause BSD License. Full text of license: https://github.com/maplibre/maplibre-gl-js/blob/v3.6.2/LICENSE.txt */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /* eslint-disable */ var shared, worker, maplibregl;
    // define gets called three times: one for each chunk. we rely on the order
    // they're imported to know which is which
    function define(_, chunk) {
        if (!shared) shared = chunk;
        else if (!worker) worker = chunk;
        else {
            var workerBundleString = "var sharedChunk = {}; (" + shared + ")(sharedChunk); (" + worker + ")(sharedChunk);";
            var sharedChunk = {};
            shared(sharedChunk);
            maplibregl = chunk(sharedChunk);
            if (typeof window !== "undefined") maplibregl.workerUrl = window.URL.createObjectURL(new Blob([
                workerBundleString
            ], {
                type: "text/javascript"
            }));
        }
    }
    define([
        "exports"
    ], function(t) {
        "use strict";
        function e(t, e, r, n) {
            return new (r || (r = Promise))(function(i, a) {
                function s(t) {
                    try {
                        l(n.next(t));
                    } catch (t) {
                        a(t);
                    }
                }
                function o(t) {
                    try {
                        l(n.throw(t));
                    } catch (t) {
                        a(t);
                    }
                }
                function l(t) {
                    var e;
                    t.done ? i(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                        t(e);
                    })).then(s, o);
                }
                l((n = n.apply(t, e || [])).next());
            });
        }
        function r(t) {
            return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
        }
        "function" == typeof SuppressedError && SuppressedError;
        var n = i;
        function i(t, e) {
            this.x = t, this.y = e;
        }
        i.prototype = {
            clone: function() {
                return new i(this.x, this.y);
            },
            add: function(t) {
                return this.clone()._add(t);
            },
            sub: function(t) {
                return this.clone()._sub(t);
            },
            multByPoint: function(t) {
                return this.clone()._multByPoint(t);
            },
            divByPoint: function(t) {
                return this.clone()._divByPoint(t);
            },
            mult: function(t) {
                return this.clone()._mult(t);
            },
            div: function(t) {
                return this.clone()._div(t);
            },
            rotate: function(t) {
                return this.clone()._rotate(t);
            },
            rotateAround: function(t, e) {
                return this.clone()._rotateAround(t, e);
            },
            matMult: function(t) {
                return this.clone()._matMult(t);
            },
            unit: function() {
                return this.clone()._unit();
            },
            perp: function() {
                return this.clone()._perp();
            },
            round: function() {
                return this.clone()._round();
            },
            mag: function() {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            },
            equals: function(t) {
                return this.x === t.x && this.y === t.y;
            },
            dist: function(t) {
                return Math.sqrt(this.distSqr(t));
            },
            distSqr: function(t) {
                var e = t.x - this.x, r = t.y - this.y;
                return e * e + r * r;
            },
            angle: function() {
                return Math.atan2(this.y, this.x);
            },
            angleTo: function(t) {
                return Math.atan2(this.y - t.y, this.x - t.x);
            },
            angleWith: function(t) {
                return this.angleWithSep(t.x, t.y);
            },
            angleWithSep: function(t, e) {
                return Math.atan2(this.x * e - this.y * t, this.x * t + this.y * e);
            },
            _matMult: function(t) {
                var e = t[2] * this.x + t[3] * this.y;
                return this.x = t[0] * this.x + t[1] * this.y, this.y = e, this;
            },
            _add: function(t) {
                return this.x += t.x, this.y += t.y, this;
            },
            _sub: function(t) {
                return this.x -= t.x, this.y -= t.y, this;
            },
            _mult: function(t) {
                return this.x *= t, this.y *= t, this;
            },
            _div: function(t) {
                return this.x /= t, this.y /= t, this;
            },
            _multByPoint: function(t) {
                return this.x *= t.x, this.y *= t.y, this;
            },
            _divByPoint: function(t) {
                return this.x /= t.x, this.y /= t.y, this;
            },
            _unit: function() {
                return this._div(this.mag()), this;
            },
            _perp: function() {
                var t = this.y;
                return this.y = this.x, this.x = -t, this;
            },
            _rotate: function(t) {
                var e = Math.cos(t), r = Math.sin(t), n = r * this.x + e * this.y;
                return this.x = e * this.x - r * this.y, this.y = n, this;
            },
            _rotateAround: function(t, e) {
                var r = Math.cos(t), n = Math.sin(t), i = e.y + n * (this.x - e.x) + r * (this.y - e.y);
                return this.x = e.x + r * (this.x - e.x) - n * (this.y - e.y), this.y = i, this;
            },
            _round: function() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            }
        }, i.convert = function(t) {
            return t instanceof i ? t : Array.isArray(t) ? new i(t[0], t[1]) : t;
        };
        var a = r(n), s = o;
        function o(t, e, r, n) {
            this.cx = 3 * t, this.bx = 3 * (r - t) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e, this.by = 3 * (n - e) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t, this.p1y = e, this.p2x = r, this.p2y = n;
        }
        o.prototype = {
            sampleCurveX: function(t) {
                return ((this.ax * t + this.bx) * t + this.cx) * t;
            },
            sampleCurveY: function(t) {
                return ((this.ay * t + this.by) * t + this.cy) * t;
            },
            sampleCurveDerivativeX: function(t) {
                return (3 * this.ax * t + 2 * this.bx) * t + this.cx;
            },
            solveCurveX: function(t, e) {
                if (void 0 === e && (e = 1e-6), t < 0) return 0;
                if (t > 1) return 1;
                for(var r = t, n = 0; n < 8; n++){
                    var i = this.sampleCurveX(r) - t;
                    if (Math.abs(i) < e) return r;
                    var a = this.sampleCurveDerivativeX(r);
                    if (Math.abs(a) < 1e-6) break;
                    r -= i / a;
                }
                var s = 0, o = 1;
                for(r = t, n = 0; n < 20 && (i = this.sampleCurveX(r), !(Math.abs(i - t) < e)); n++)t > i ? s = r : o = r, r = .5 * (o - s) + s;
                return r;
            },
            solve: function(t, e) {
                return this.sampleCurveY(this.solveCurveX(t, e));
            }
        };
        var l = r(s);
        let u, c;
        function h() {
            return null == u && (u = "undefined" != typeof OffscreenCanvas && new OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof createImageBitmap), u;
        }
        function p() {
            if (null == c && (c = !1, h())) {
                const t = 5, e = new OffscreenCanvas(t, t).getContext("2d", {
                    willReadFrequently: !0
                });
                if (e) {
                    for(let r = 0; r < t * t; r++){
                        const n = 4 * r;
                        e.fillStyle = `rgb(${n},${n + 1},${n + 2})`, e.fillRect(r % t, Math.floor(r / t), 1, 1);
                    }
                    const r = e.getImageData(0, 0, t, t).data;
                    for(let e = 0; e < t * t * 4; e++)if (e % 4 != 3 && r[e] !== e) {
                        c = !0;
                        break;
                    }
                }
            }
            return c || !1;
        }
        function f(t, e, r, n) {
            const i = new l(t, e, r, n);
            return function(t) {
                return i.solve(t);
            };
        }
        const d = f(.25, .1, .25, 1);
        function y(t, e, r) {
            return Math.min(r, Math.max(e, t));
        }
        function m(t, e, r) {
            const n = r - e, i = ((t - e) % n + n) % n + e;
            return i === e ? r : i;
        }
        function g(t, ...e) {
            for (const r of e)for(const e in r)t[e] = r[e];
            return t;
        }
        let x = 1;
        function v(t, e, r) {
            const n = {};
            for(const i in t)n[i] = e.call(r || this, t[i], i, t);
            return n;
        }
        function b(t, e, r) {
            const n = {};
            for(const i in t)e.call(r || this, t[i], i, t) && (n[i] = t[i]);
            return n;
        }
        function w(t) {
            return Array.isArray(t) ? t.map(w) : "object" == typeof t && t ? v(t, w) : t;
        }
        const _ = {};
        function A(t) {
            _[t] || ("undefined" != typeof console && console.warn(t), _[t] = !0);
        }
        function S(t, e, r) {
            return (r.y - t.y) * (e.x - t.x) > (e.y - t.y) * (r.x - t.x);
        }
        function k(t) {
            let e = 0;
            for(let r, n, i = 0, a = t.length, s = a - 1; i < a; s = i++)r = t[i], n = t[s], e += (n.x - r.x) * (r.y + n.y);
            return e;
        }
        function I() {
            return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope;
        }
        let z = null;
        function M(t) {
            return "undefined" != typeof ImageBitmap && t instanceof ImageBitmap;
        }
        const C = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
        function B(t, r, n, i, a) {
            return e(this, void 0, void 0, function*() {
                if ("undefined" == typeof VideoFrame) throw new Error("VideoFrame not supported");
                const e = new VideoFrame(t, {
                    timestamp: 0
                });
                try {
                    const s = null == e ? void 0 : e.format;
                    if (!s || !s.startsWith("BGR") && !s.startsWith("RGB")) throw new Error(`Unrecognized format ${s}`);
                    const o = s.startsWith("BGR"), l = new Uint8ClampedArray(i * a * 4);
                    if (yield e.copyTo(l, function(t, e, r, n, i) {
                        const a = 4 * Math.max(-e, 0), s = (Math.max(0, r) - r) * n * 4 + a, o = 4 * n, l = Math.max(0, e), u = Math.max(0, r);
                        return {
                            rect: {
                                x: l,
                                y: u,
                                width: Math.min(t.width, e + n) - l,
                                height: Math.min(t.height, r + i) - u
                            },
                            layout: [
                                {
                                    offset: s,
                                    stride: o
                                }
                            ]
                        };
                    }(t, r, n, i, a)), o) for(let t = 0; t < l.length; t += 4){
                        const e = l[t];
                        l[t] = l[t + 2], l[t + 2] = e;
                    }
                    return l;
                } finally{
                    e.close();
                }
            });
        }
        let P, V, E, F;
        const T = {
            now: "undefined" != typeof performance && performance && performance.now ? performance.now.bind(performance) : Date.now.bind(Date),
            frame (t) {
                const e = requestAnimationFrame(t);
                return {
                    cancel: ()=>cancelAnimationFrame(e)
                };
            },
            getImageData (t, e = 0) {
                return this.getImageCanvasContext(t).getImageData(-e, -e, t.width + 2 * e, t.height + 2 * e);
            },
            getImageCanvasContext (t) {
                const e = window.document.createElement("canvas"), r = e.getContext("2d", {
                    willReadFrequently: !0
                });
                if (!r) throw new Error("failed to create canvas 2d context");
                return e.width = t.width, e.height = t.height, r.drawImage(t, 0, 0, t.width, t.height), r;
            },
            resolveURL: (t)=>(E || (E = document.createElement("a")), E.href = t, E.href),
            hardwareConcurrency: "undefined" != typeof navigator && navigator.hardwareConcurrency || 4,
            get prefersReducedMotion () {
                return !!matchMedia && (null == F && (F = matchMedia("(prefers-reduced-motion: reduce)")), F.matches);
            }
        }, $ = {
            MAX_PARALLEL_IMAGE_REQUESTS: 16,
            MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME: 8,
            MAX_TILE_CACHE_ZOOM_LEVELS: 5,
            REGISTERED_PROTOCOLS: {},
            WORKER_URL: ""
        };
        class L extends Error {
            constructor(t, e, r, n){
                super(`AJAXError: ${e} (${t}): ${r}`), this.status = t, this.statusText = e, this.url = r, this.body = n;
            }
        }
        const D = I() ? ()=>self.worker && self.worker.referrer : ()=>("blob:" === window.location.protocol ? window.parent : window).location.href, O = (t)=>$.REGISTERED_PROTOCOLS[t.substring(0, t.indexOf("://"))];
        function U(t, e) {
            const r = new AbortController, n = new Request(t.url, {
                method: t.method || "GET",
                body: t.body,
                credentials: t.credentials,
                headers: t.headers,
                cache: t.cache,
                referrer: D(),
                signal: r.signal
            });
            let i = !1, a = !1;
            "json" === t.type && n.headers.set("Accept", "application/json");
            return a || fetch(n).then((r)=>r.ok ? ((r)=>{
                    ("arrayBuffer" === t.type || "image" === t.type ? r.arrayBuffer() : "json" === t.type ? r.json() : r.text()).then((t)=>{
                        a || (i = !0, e(null, t, r.headers.get("Cache-Control"), r.headers.get("Expires")));
                    }).catch((t)=>{
                        a || e(new Error(t.message));
                    });
                })(r) : r.blob().then((n)=>e(new L(r.status, r.statusText, t.url, n)))).catch((t)=>{
                20 !== t.code && e(new Error(t.message));
            }), {
                cancel: ()=>{
                    a = !0, i || r.abort();
                }
            };
        }
        const R = function(t, e) {
            if (/:\/\//.test(t.url) && !/^https?:|^file:/.test(t.url)) {
                if (I() && self.worker && self.worker.actor) return self.worker.actor.send("getResource", t, e);
                if (!I()) return (O(t.url) || U)(t, e);
            }
            if (!(/^file:/.test(r = t.url) || /^file:/.test(D()) && !/^\w+:/.test(r))) {
                if (fetch && Request && AbortController && Object.prototype.hasOwnProperty.call(Request.prototype, "signal")) return U(t, e);
                if (I() && self.worker && self.worker.actor) return self.worker.actor.send("getResource", t, e, void 0, !0);
            }
            var r;
            return function(t, e) {
                const r = new XMLHttpRequest;
                r.open(t.method || "GET", t.url, !0), "arrayBuffer" !== t.type && "image" !== t.type || (r.responseType = "arraybuffer");
                for(const e in t.headers)r.setRequestHeader(e, t.headers[e]);
                return "json" === t.type && (r.responseType = "text", r.setRequestHeader("Accept", "application/json")), r.withCredentials = "include" === t.credentials, r.onerror = ()=>{
                    e(new Error(r.statusText));
                }, r.onload = ()=>{
                    if ((r.status >= 200 && r.status < 300 || 0 === r.status) && null !== r.response) {
                        let n = r.response;
                        if ("json" === t.type) try {
                            n = JSON.parse(r.response);
                        } catch (t) {
                            return e(t);
                        }
                        e(null, n, r.getResponseHeader("Cache-Control"), r.getResponseHeader("Expires"));
                    } else {
                        const n = new Blob([
                            r.response
                        ], {
                            type: r.getResponseHeader("Content-Type")
                        });
                        e(new L(r.status, r.statusText, t.url, n));
                    }
                }, r.send(t.body), {
                    cancel: ()=>r.abort()
                };
            }(t, e);
        }, q = function(t, e) {
            return R(g(t, {
                type: "arrayBuffer"
            }), e);
        };
        function j(t) {
            if (!t || t.indexOf("://") <= 0 || 0 === t.indexOf("data:image/") || 0 === t.indexOf("blob:")) return !0;
            const e = new URL(t), r = window.location;
            return e.protocol === r.protocol && e.host === r.host;
        }
        function N(t, e, r) {
            r[t] && -1 !== r[t].indexOf(e) || (r[t] = r[t] || [], r[t].push(e));
        }
        function Z(t, e, r) {
            if (r && r[t]) {
                const n = r[t].indexOf(e);
                -1 !== n && r[t].splice(n, 1);
            }
        }
        class K {
            constructor(t, e = {}){
                g(this, e), this.type = t;
            }
        }
        class G extends K {
            constructor(t, e = {}){
                super("error", g({
                    error: t
                }, e));
            }
        }
        class J {
            on(t, e) {
                return this._listeners = this._listeners || {}, N(t, e, this._listeners), this;
            }
            off(t, e) {
                return Z(t, e, this._listeners), Z(t, e, this._oneTimeListeners), this;
            }
            once(t, e) {
                return e ? (this._oneTimeListeners = this._oneTimeListeners || {}, N(t, e, this._oneTimeListeners), this) : new Promise((e)=>this.once(t, e));
            }
            fire(t, e) {
                "string" == typeof t && (t = new K(t, e || {}));
                const r = t.type;
                if (this.listens(r)) {
                    t.target = this;
                    const e = this._listeners && this._listeners[r] ? this._listeners[r].slice() : [];
                    for (const r of e)r.call(this, t);
                    const n = this._oneTimeListeners && this._oneTimeListeners[r] ? this._oneTimeListeners[r].slice() : [];
                    for (const e of n)Z(r, e, this._oneTimeListeners), e.call(this, t);
                    const i = this._eventedParent;
                    i && (g(t, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), i.fire(t));
                } else t instanceof G && console.error(t.error);
                return this;
            }
            listens(t) {
                return this._listeners && this._listeners[t] && this._listeners[t].length > 0 || this._oneTimeListeners && this._oneTimeListeners[t] && this._oneTimeListeners[t].length > 0 || this._eventedParent && this._eventedParent.listens(t);
            }
            setEventedParent(t, e) {
                return this._eventedParent = t, this._eventedParentData = e, this;
            }
        }
        var X = {
            $version: 8,
            $root: {
                version: {
                    required: !0,
                    type: "enum",
                    values: [
                        8
                    ]
                },
                name: {
                    type: "string"
                },
                metadata: {
                    type: "*"
                },
                center: {
                    type: "array",
                    value: "number"
                },
                zoom: {
                    type: "number"
                },
                bearing: {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees"
                },
                pitch: {
                    type: "number",
                    default: 0,
                    units: "degrees"
                },
                light: {
                    type: "light"
                },
                terrain: {
                    type: "terrain"
                },
                sources: {
                    required: !0,
                    type: "sources"
                },
                sprite: {
                    type: "sprite"
                },
                glyphs: {
                    type: "string"
                },
                transition: {
                    type: "transition"
                },
                layers: {
                    required: !0,
                    type: "array",
                    value: "layer"
                }
            },
            sources: {
                "*": {
                    type: "source"
                }
            },
            source: [
                "source_vector",
                "source_raster",
                "source_raster_dem",
                "source_geojson",
                "source_video",
                "source_image"
            ],
            source_vector: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        vector: {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                scheme: {
                    type: "enum",
                    values: {
                        xyz: {},
                        tms: {}
                    },
                    default: "xyz"
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                attribution: {
                    type: "string"
                },
                promoteId: {
                    type: "promoteId"
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_raster: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        raster: {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                tileSize: {
                    type: "number",
                    default: 512,
                    units: "pixels"
                },
                scheme: {
                    type: "enum",
                    values: {
                        xyz: {},
                        tms: {}
                    },
                    default: "xyz"
                },
                attribution: {
                    type: "string"
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_raster_dem: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        "raster-dem": {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                tileSize: {
                    type: "number",
                    default: 512,
                    units: "pixels"
                },
                attribution: {
                    type: "string"
                },
                encoding: {
                    type: "enum",
                    values: {
                        terrarium: {},
                        mapbox: {},
                        custom: {}
                    },
                    default: "mapbox"
                },
                redFactor: {
                    type: "number",
                    default: 1
                },
                blueFactor: {
                    type: "number",
                    default: 1
                },
                greenFactor: {
                    type: "number",
                    default: 1
                },
                baseShift: {
                    type: "number",
                    default: 0
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_geojson: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        geojson: {}
                    }
                },
                data: {
                    required: !0,
                    type: "*"
                },
                maxzoom: {
                    type: "number",
                    default: 18
                },
                attribution: {
                    type: "string"
                },
                buffer: {
                    type: "number",
                    default: 128,
                    maximum: 512,
                    minimum: 0
                },
                filter: {
                    type: "*"
                },
                tolerance: {
                    type: "number",
                    default: .375
                },
                cluster: {
                    type: "boolean",
                    default: !1
                },
                clusterRadius: {
                    type: "number",
                    default: 50,
                    minimum: 0
                },
                clusterMaxZoom: {
                    type: "number"
                },
                clusterMinPoints: {
                    type: "number"
                },
                clusterProperties: {
                    type: "*"
                },
                lineMetrics: {
                    type: "boolean",
                    default: !1
                },
                generateId: {
                    type: "boolean",
                    default: !1
                },
                promoteId: {
                    type: "promoteId"
                }
            },
            source_video: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        video: {}
                    }
                },
                urls: {
                    required: !0,
                    type: "array",
                    value: "string"
                },
                coordinates: {
                    required: !0,
                    type: "array",
                    length: 4,
                    value: {
                        type: "array",
                        length: 2,
                        value: "number"
                    }
                }
            },
            source_image: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        image: {}
                    }
                },
                url: {
                    required: !0,
                    type: "string"
                },
                coordinates: {
                    required: !0,
                    type: "array",
                    length: 4,
                    value: {
                        type: "array",
                        length: 2,
                        value: "number"
                    }
                }
            },
            layer: {
                id: {
                    type: "string",
                    required: !0
                },
                type: {
                    type: "enum",
                    values: {
                        fill: {},
                        line: {},
                        symbol: {},
                        circle: {},
                        heatmap: {},
                        "fill-extrusion": {},
                        raster: {},
                        hillshade: {},
                        background: {}
                    },
                    required: !0
                },
                metadata: {
                    type: "*"
                },
                source: {
                    type: "string"
                },
                "source-layer": {
                    type: "string"
                },
                minzoom: {
                    type: "number",
                    minimum: 0,
                    maximum: 24
                },
                maxzoom: {
                    type: "number",
                    minimum: 0,
                    maximum: 24
                },
                filter: {
                    type: "filter"
                },
                layout: {
                    type: "layout"
                },
                paint: {
                    type: "paint"
                }
            },
            layout: [
                "layout_fill",
                "layout_line",
                "layout_circle",
                "layout_heatmap",
                "layout_fill-extrusion",
                "layout_symbol",
                "layout_raster",
                "layout_hillshade",
                "layout_background"
            ],
            layout_background: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_fill: {
                "fill-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_circle: {
                "circle-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_heatmap: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            "layout_fill-extrusion": {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_line: {
                "line-cap": {
                    type: "enum",
                    values: {
                        butt: {},
                        round: {},
                        square: {}
                    },
                    default: "butt",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-join": {
                    type: "enum",
                    values: {
                        bevel: {},
                        round: {},
                        miter: {}
                    },
                    default: "miter",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-miter-limit": {
                    type: "number",
                    default: 2,
                    requires: [
                        {
                            "line-join": "miter"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-round-limit": {
                    type: "number",
                    default: 1.05,
                    requires: [
                        {
                            "line-join": "round"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_symbol: {
                "symbol-placement": {
                    type: "enum",
                    values: {
                        point: {},
                        line: {},
                        "line-center": {}
                    },
                    default: "point",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-spacing": {
                    type: "number",
                    default: 250,
                    minimum: 1,
                    units: "pixels",
                    requires: [
                        {
                            "symbol-placement": "line"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-avoid-edges": {
                    type: "boolean",
                    default: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "symbol-z-order": {
                    type: "enum",
                    values: {
                        auto: {},
                        "viewport-y": {},
                        source: {}
                    },
                    default: "auto",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-allow-overlap": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        {
                            "!": "icon-overlap"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-overlap": {
                    type: "enum",
                    values: {
                        never: {},
                        always: {},
                        cooperative: {}
                    },
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-ignore-placement": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-optional": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-rotation-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-size": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    units: "factor of the original icon size",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-text-fit": {
                    type: "enum",
                    values: {
                        none: {},
                        width: {},
                        height: {},
                        both: {}
                    },
                    default: "none",
                    requires: [
                        "icon-image",
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-text-fit-padding": {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        0,
                        0,
                        0,
                        0
                    ],
                    units: "pixels",
                    requires: [
                        "icon-image",
                        "text-field",
                        {
                            "icon-text-fit": [
                                "both",
                                "width",
                                "height"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-image": {
                    type: "resolvedImage",
                    tokens: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-padding": {
                    type: "padding",
                    default: [
                        2
                    ],
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-keep-upright": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        {
                            "icon-rotation-alignment": "map"
                        },
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-offset": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-anchor": {
                    type: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    default: "center",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-rotation-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        "viewport-glyph": {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-field": {
                    type: "formatted",
                    default: "",
                    tokens: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-font": {
                    type: "array",
                    value: "string",
                    default: [
                        "Open Sans Regular",
                        "Arial Unicode MS Regular"
                    ],
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-size": {
                    type: "number",
                    default: 16,
                    minimum: 0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-max-width": {
                    type: "number",
                    default: 10,
                    minimum: 0,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-line-height": {
                    type: "number",
                    default: 1.2,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-letter-spacing": {
                    type: "number",
                    default: 0,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-justify": {
                    type: "enum",
                    values: {
                        auto: {},
                        left: {},
                        center: {},
                        right: {}
                    },
                    default: "center",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-radial-offset": {
                    type: "number",
                    units: "ems",
                    default: 0,
                    requires: [
                        "text-field"
                    ],
                    "property-type": "data-driven",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    }
                },
                "text-variable-anchor": {
                    type: "array",
                    value: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-variable-anchor-offset": {
                    type: "variableAnchorOffsetCollection",
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-anchor": {
                    type: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    default: "center",
                    requires: [
                        "text-field",
                        {
                            "!": "text-variable-anchor"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-max-angle": {
                    type: "number",
                    default: 45,
                    units: "degrees",
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-writing-mode": {
                    type: "array",
                    value: "enum",
                    values: {
                        horizontal: {},
                        vertical: {}
                    },
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-padding": {
                    type: "number",
                    default: 2,
                    minimum: 0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-keep-upright": {
                    type: "boolean",
                    default: !0,
                    requires: [
                        "text-field",
                        {
                            "text-rotation-alignment": "map"
                        },
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-transform": {
                    type: "enum",
                    values: {
                        none: {},
                        uppercase: {},
                        lowercase: {}
                    },
                    default: "none",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-offset": {
                    type: "array",
                    value: "number",
                    units: "ems",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    requires: [
                        "text-field",
                        {
                            "!": "text-radial-offset"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-allow-overlap": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field",
                        {
                            "!": "text-overlap"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-overlap": {
                    type: "enum",
                    values: {
                        never: {},
                        always: {},
                        cooperative: {}
                    },
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-ignore-placement": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-optional": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field",
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_raster: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            layout_hillshade: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    "property-type": "constant"
                }
            },
            filter: {
                type: "array",
                value: "*"
            },
            filter_operator: {
                type: "enum",
                values: {
                    "==": {},
                    "!=": {},
                    ">": {},
                    ">=": {},
                    "<": {},
                    "<=": {},
                    in: {},
                    "!in": {},
                    all: {},
                    any: {},
                    none: {},
                    has: {},
                    "!has": {},
                    within: {}
                }
            },
            geometry_type: {
                type: "enum",
                values: {
                    Point: {},
                    LineString: {},
                    Polygon: {}
                }
            },
            function: {
                expression: {
                    type: "expression"
                },
                stops: {
                    type: "array",
                    value: "function_stop"
                },
                base: {
                    type: "number",
                    default: 1,
                    minimum: 0
                },
                property: {
                    type: "string",
                    default: "$zoom"
                },
                type: {
                    type: "enum",
                    values: {
                        identity: {},
                        exponential: {},
                        interval: {},
                        categorical: {}
                    },
                    default: "exponential"
                },
                colorSpace: {
                    type: "enum",
                    values: {
                        rgb: {},
                        lab: {},
                        hcl: {}
                    },
                    default: "rgb"
                },
                default: {
                    type: "*",
                    required: !1
                }
            },
            function_stop: {
                type: "array",
                minimum: 0,
                maximum: 24,
                value: [
                    "number",
                    "color"
                ],
                length: 2
            },
            expression: {
                type: "array",
                value: "*",
                minimum: 1
            },
            light: {
                anchor: {
                    type: "enum",
                    default: "viewport",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    "property-type": "data-constant",
                    transition: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    }
                },
                position: {
                    type: "array",
                    default: [
                        1.15,
                        210,
                        30
                    ],
                    length: 3,
                    value: "number",
                    "property-type": "data-constant",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    }
                },
                color: {
                    type: "color",
                    "property-type": "data-constant",
                    default: "#ffffff",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                intensity: {
                    type: "number",
                    "property-type": "data-constant",
                    default: .5,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                }
            },
            terrain: {
                source: {
                    type: "string",
                    required: !0
                },
                exaggeration: {
                    type: "number",
                    minimum: 0,
                    default: 1
                }
            },
            paint: [
                "paint_fill",
                "paint_line",
                "paint_circle",
                "paint_heatmap",
                "paint_fill-extrusion",
                "paint_symbol",
                "paint_raster",
                "paint_hillshade",
                "paint_background"
            ],
            paint_fill: {
                "fill-antialias": {
                    type: "boolean",
                    default: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-outline-color": {
                    type: "color",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-pattern"
                        },
                        {
                            "fill-antialias": !0
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "fill-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                }
            },
            "paint_fill-extrusion": {
                "fill-extrusion-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-extrusion-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "fill-extrusion-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                },
                "fill-extrusion-height": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "meters",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-base": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "meters",
                    transition: !0,
                    requires: [
                        "fill-extrusion-height"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-vertical-gradient": {
                    type: "boolean",
                    default: !0,
                    transition: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_line: {
                "line-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "line-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "line-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-width": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-gap-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-offset": {
                    type: "number",
                    default: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-dasharray": {
                    type: "array",
                    value: "number",
                    minimum: 0,
                    transition: !0,
                    units: "line widths",
                    requires: [
                        {
                            "!": "line-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "cross-faded"
                },
                "line-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                },
                "line-gradient": {
                    type: "color",
                    transition: !1,
                    requires: [
                        {
                            "!": "line-dasharray"
                        },
                        {
                            "!": "line-pattern"
                        },
                        {
                            source: "geojson",
                            has: {
                                lineMetrics: !0
                            }
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "line-progress"
                        ]
                    },
                    "property-type": "color-ramp"
                }
            },
            paint_circle: {
                "circle-radius": {
                    type: "number",
                    default: 5,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-blur": {
                    type: "number",
                    default: 0,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "circle-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-pitch-scale": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "viewport",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-stroke-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-stroke-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-stroke-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                }
            },
            paint_heatmap: {
                "heatmap-radius": {
                    type: "number",
                    default: 30,
                    minimum: 1,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "heatmap-weight": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "heatmap-intensity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "heatmap-color": {
                    type: "color",
                    default: [
                        "interpolate",
                        [
                            "linear"
                        ],
                        [
                            "heatmap-density"
                        ],
                        0,
                        "rgba(0, 0, 255, 0)",
                        .1,
                        "royalblue",
                        .3,
                        "cyan",
                        .5,
                        "lime",
                        .7,
                        "yellow",
                        1,
                        "red"
                    ],
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "heatmap-density"
                        ]
                    },
                    "property-type": "color-ramp"
                },
                "heatmap-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_symbol: {
                "icon-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-color": {
                    type: "color",
                    default: "rgba(0, 0, 0, 0)",
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "icon-image",
                        "icon-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    overridable: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-color": {
                    type: "color",
                    default: "rgba(0, 0, 0, 0)",
                    transition: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "text-field",
                        "text-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_raster: {
                "raster-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-hue-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    transition: !0,
                    units: "degrees",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-brightness-min": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-brightness-max": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-saturation": {
                    type: "number",
                    default: 0,
                    minimum: -1,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-contrast": {
                    type: "number",
                    default: 0,
                    minimum: -1,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-resampling": {
                    type: "enum",
                    values: {
                        linear: {},
                        nearest: {}
                    },
                    default: "linear",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-fade-duration": {
                    type: "number",
                    default: 300,
                    minimum: 0,
                    transition: !1,
                    units: "milliseconds",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_hillshade: {
                "hillshade-illumination-direction": {
                    type: "number",
                    default: 335,
                    minimum: 0,
                    maximum: 359,
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-illumination-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "viewport",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-exaggeration": {
                    type: "number",
                    default: .5,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-shadow-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-highlight-color": {
                    type: "color",
                    default: "#FFFFFF",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-accent-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_background: {
                "background-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "background-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "background-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "cross-faded"
                },
                "background-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            transition: {
                duration: {
                    type: "number",
                    default: 300,
                    minimum: 0,
                    units: "milliseconds"
                },
                delay: {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "milliseconds"
                }
            },
            "property-type": {
                "data-driven": {
                    type: "property-type"
                },
                "cross-faded": {
                    type: "property-type"
                },
                "cross-faded-data-driven": {
                    type: "property-type"
                },
                "color-ramp": {
                    type: "property-type"
                },
                "data-constant": {
                    type: "property-type"
                },
                constant: {
                    type: "property-type"
                }
            },
            promoteId: {
                "*": {
                    type: "string"
                }
            }
        };
        const Y = [
            "type",
            "source",
            "source-layer",
            "minzoom",
            "maxzoom",
            "filter",
            "layout"
        ];
        function H(t, e) {
            const r = {};
            for(const e in t)"ref" !== e && (r[e] = t[e]);
            return Y.forEach((t)=>{
                t in e && (r[t] = e[t]);
            }), r;
        }
        function W(t, e) {
            if (Array.isArray(t)) {
                if (!Array.isArray(e) || t.length !== e.length) return !1;
                for(let r = 0; r < t.length; r++)if (!W(t[r], e[r])) return !1;
                return !0;
            }
            if ("object" == typeof t && null !== t && null !== e) {
                if ("object" != typeof e) return !1;
                if (Object.keys(t).length !== Object.keys(e).length) return !1;
                for(const r in t)if (!W(t[r], e[r])) return !1;
                return !0;
            }
            return t === e;
        }
        const Q = {
            setStyle: "setStyle",
            addLayer: "addLayer",
            removeLayer: "removeLayer",
            setPaintProperty: "setPaintProperty",
            setLayoutProperty: "setLayoutProperty",
            setFilter: "setFilter",
            addSource: "addSource",
            removeSource: "removeSource",
            setGeoJSONSourceData: "setGeoJSONSourceData",
            setLayerZoomRange: "setLayerZoomRange",
            setLayerProperty: "setLayerProperty",
            setCenter: "setCenter",
            setZoom: "setZoom",
            setBearing: "setBearing",
            setPitch: "setPitch",
            setSprite: "setSprite",
            setGlyphs: "setGlyphs",
            setTransition: "setTransition",
            setLight: "setLight"
        };
        function tt(t, e, r) {
            r.push({
                command: Q.addSource,
                args: [
                    t,
                    e[t]
                ]
            });
        }
        function et(t, e, r) {
            e.push({
                command: Q.removeSource,
                args: [
                    t
                ]
            }), r[t] = !0;
        }
        function rt(t, e, r, n) {
            et(t, r, n), tt(t, e, r);
        }
        function nt(t, e, r) {
            let n;
            for(n in t[r])if (Object.prototype.hasOwnProperty.call(t[r], n) && "data" !== n && !W(t[r][n], e[r][n])) return !1;
            for(n in e[r])if (Object.prototype.hasOwnProperty.call(e[r], n) && "data" !== n && !W(t[r][n], e[r][n])) return !1;
            return !0;
        }
        function it(t, e, r, n, i, a) {
            let s;
            for(s in e = e || {}, t = t || {})Object.prototype.hasOwnProperty.call(t, s) && (W(t[s], e[s]) || r.push({
                command: a,
                args: [
                    n,
                    s,
                    e[s],
                    i
                ]
            }));
            for(s in e)Object.prototype.hasOwnProperty.call(e, s) && !Object.prototype.hasOwnProperty.call(t, s) && (W(t[s], e[s]) || r.push({
                command: a,
                args: [
                    n,
                    s,
                    e[s],
                    i
                ]
            }));
        }
        function at(t) {
            return t.id;
        }
        function st(t, e) {
            return t[e.id] = e, t;
        }
        class ot {
            constructor(t, e, r, n){
                this.message = (t ? `${t}: ` : "") + r, n && (this.identifier = n), null != e && e.__line__ && (this.line = e.__line__);
            }
        }
        function lt(t, ...e) {
            for (const r of e)for(const e in r)t[e] = r[e];
            return t;
        }
        class ut extends Error {
            constructor(t, e){
                super(e), this.message = e, this.key = t;
            }
        }
        class ct {
            constructor(t, e = []){
                this.parent = t, this.bindings = {};
                for (const [t, r] of e)this.bindings[t] = r;
            }
            concat(t) {
                return new ct(this, t);
            }
            get(t) {
                if (this.bindings[t]) return this.bindings[t];
                if (this.parent) return this.parent.get(t);
                throw new Error(`${t} not found in scope.`);
            }
            has(t) {
                return !!this.bindings[t] || !!this.parent && this.parent.has(t);
            }
        }
        const ht = {
            kind: "null"
        }, pt = {
            kind: "number"
        }, ft = {
            kind: "string"
        }, dt = {
            kind: "boolean"
        }, yt = {
            kind: "color"
        }, mt = {
            kind: "object"
        }, gt = {
            kind: "value"
        }, xt = {
            kind: "collator"
        }, vt = {
            kind: "formatted"
        }, bt = {
            kind: "padding"
        }, wt = {
            kind: "resolvedImage"
        }, _t = {
            kind: "variableAnchorOffsetCollection"
        };
        function At(t, e) {
            return {
                kind: "array",
                itemType: t,
                N: e
            };
        }
        function St(t) {
            if ("array" === t.kind) {
                const e = St(t.itemType);
                return "number" == typeof t.N ? `array<${e}, ${t.N}>` : "value" === t.itemType.kind ? "array" : `array<${e}>`;
            }
            return t.kind;
        }
        const kt = [
            ht,
            pt,
            ft,
            dt,
            yt,
            vt,
            mt,
            At(gt),
            bt,
            wt,
            _t
        ];
        function It(t, e) {
            if ("error" === e.kind) return null;
            if ("array" === t.kind) {
                if ("array" === e.kind && (0 === e.N && "value" === e.itemType.kind || !It(t.itemType, e.itemType)) && ("number" != typeof t.N || t.N === e.N)) return null;
            } else {
                if (t.kind === e.kind) return null;
                if ("value" === t.kind) {
                    for (const t of kt)if (!It(t, e)) return null;
                }
            }
            return `Expected ${St(t)} but found ${St(e)} instead.`;
        }
        function zt(t, e) {
            return e.some((e)=>e.kind === t.kind);
        }
        function Mt(t, e) {
            return e.some((e)=>"null" === e ? null === t : "array" === e ? Array.isArray(t) : "object" === e ? t && !Array.isArray(t) && "object" == typeof t : e === typeof t);
        }
        function Ct(t, e) {
            return "array" === t.kind && "array" === e.kind ? t.itemType.kind === e.itemType.kind && "number" == typeof t.N : t.kind === e.kind;
        }
        const Bt = .96422, Pt = .82521, Vt = 4 / 29, Et = 6 / 29, Ft = 3 * Et * Et, Tt = Et * Et * Et, $t = Math.PI / 180, Lt = 180 / Math.PI;
        function Dt(t) {
            return (t %= 360) < 0 && (t += 360), t;
        }
        function Ot([t, e, r, n]) {
            let i, a;
            const s = Rt((.2225045 * (t = Ut(t)) + .7168786 * (e = Ut(e)) + .0606169 * (r = Ut(r))) / 1);
            t === e && e === r ? i = a = s : (i = Rt((.4360747 * t + .3850649 * e + .1430804 * r) / Bt), a = Rt((.0139322 * t + .0971045 * e + .7141733 * r) / Pt));
            const o = 116 * s - 16;
            return [
                o < 0 ? 0 : o,
                500 * (i - s),
                200 * (s - a),
                n
            ];
        }
        function Ut(t) {
            return t <= .04045 ? t / 12.92 : Math.pow((t + .055) / 1.055, 2.4);
        }
        function Rt(t) {
            return t > Tt ? Math.pow(t, 1 / 3) : t / Ft + Vt;
        }
        function qt([t, e, r, n]) {
            let i = (t + 16) / 116, a = isNaN(e) ? i : i + e / 500, s = isNaN(r) ? i : i - r / 200;
            return i = 1 * Nt(i), a = Bt * Nt(a), s = Pt * Nt(s), [
                jt(3.1338561 * a - 1.6168667 * i - .4906146 * s),
                jt(-0.9787684 * a + 1.9161415 * i + .033454 * s),
                jt(.0719453 * a - .2289914 * i + 1.4052427 * s),
                n
            ];
        }
        function jt(t) {
            return (t = t <= .00304 ? 12.92 * t : 1.055 * Math.pow(t, 1 / 2.4) - .055) < 0 ? 0 : t > 1 ? 1 : t;
        }
        function Nt(t) {
            return t > Et ? t * t * t : Ft * (t - Vt);
        }
        function Zt(t) {
            return parseInt(t.padEnd(2, t), 16) / 255;
        }
        function Kt(t, e) {
            return Gt(e ? t / 100 : t, 0, 1);
        }
        function Gt(t, e, r) {
            return Math.min(Math.max(e, t), r);
        }
        function Jt(t) {
            return !t.some(Number.isNaN);
        }
        const Xt = {
            aliceblue: [
                240,
                248,
                255
            ],
            antiquewhite: [
                250,
                235,
                215
            ],
            aqua: [
                0,
                255,
                255
            ],
            aquamarine: [
                127,
                255,
                212
            ],
            azure: [
                240,
                255,
                255
            ],
            beige: [
                245,
                245,
                220
            ],
            bisque: [
                255,
                228,
                196
            ],
            black: [
                0,
                0,
                0
            ],
            blanchedalmond: [
                255,
                235,
                205
            ],
            blue: [
                0,
                0,
                255
            ],
            blueviolet: [
                138,
                43,
                226
            ],
            brown: [
                165,
                42,
                42
            ],
            burlywood: [
                222,
                184,
                135
            ],
            cadetblue: [
                95,
                158,
                160
            ],
            chartreuse: [
                127,
                255,
                0
            ],
            chocolate: [
                210,
                105,
                30
            ],
            coral: [
                255,
                127,
                80
            ],
            cornflowerblue: [
                100,
                149,
                237
            ],
            cornsilk: [
                255,
                248,
                220
            ],
            crimson: [
                220,
                20,
                60
            ],
            cyan: [
                0,
                255,
                255
            ],
            darkblue: [
                0,
                0,
                139
            ],
            darkcyan: [
                0,
                139,
                139
            ],
            darkgoldenrod: [
                184,
                134,
                11
            ],
            darkgray: [
                169,
                169,
                169
            ],
            darkgreen: [
                0,
                100,
                0
            ],
            darkgrey: [
                169,
                169,
                169
            ],
            darkkhaki: [
                189,
                183,
                107
            ],
            darkmagenta: [
                139,
                0,
                139
            ],
            darkolivegreen: [
                85,
                107,
                47
            ],
            darkorange: [
                255,
                140,
                0
            ],
            darkorchid: [
                153,
                50,
                204
            ],
            darkred: [
                139,
                0,
                0
            ],
            darksalmon: [
                233,
                150,
                122
            ],
            darkseagreen: [
                143,
                188,
                143
            ],
            darkslateblue: [
                72,
                61,
                139
            ],
            darkslategray: [
                47,
                79,
                79
            ],
            darkslategrey: [
                47,
                79,
                79
            ],
            darkturquoise: [
                0,
                206,
                209
            ],
            darkviolet: [
                148,
                0,
                211
            ],
            deeppink: [
                255,
                20,
                147
            ],
            deepskyblue: [
                0,
                191,
                255
            ],
            dimgray: [
                105,
                105,
                105
            ],
            dimgrey: [
                105,
                105,
                105
            ],
            dodgerblue: [
                30,
                144,
                255
            ],
            firebrick: [
                178,
                34,
                34
            ],
            floralwhite: [
                255,
                250,
                240
            ],
            forestgreen: [
                34,
                139,
                34
            ],
            fuchsia: [
                255,
                0,
                255
            ],
            gainsboro: [
                220,
                220,
                220
            ],
            ghostwhite: [
                248,
                248,
                255
            ],
            gold: [
                255,
                215,
                0
            ],
            goldenrod: [
                218,
                165,
                32
            ],
            gray: [
                128,
                128,
                128
            ],
            green: [
                0,
                128,
                0
            ],
            greenyellow: [
                173,
                255,
                47
            ],
            grey: [
                128,
                128,
                128
            ],
            honeydew: [
                240,
                255,
                240
            ],
            hotpink: [
                255,
                105,
                180
            ],
            indianred: [
                205,
                92,
                92
            ],
            indigo: [
                75,
                0,
                130
            ],
            ivory: [
                255,
                255,
                240
            ],
            khaki: [
                240,
                230,
                140
            ],
            lavender: [
                230,
                230,
                250
            ],
            lavenderblush: [
                255,
                240,
                245
            ],
            lawngreen: [
                124,
                252,
                0
            ],
            lemonchiffon: [
                255,
                250,
                205
            ],
            lightblue: [
                173,
                216,
                230
            ],
            lightcoral: [
                240,
                128,
                128
            ],
            lightcyan: [
                224,
                255,
                255
            ],
            lightgoldenrodyellow: [
                250,
                250,
                210
            ],
            lightgray: [
                211,
                211,
                211
            ],
            lightgreen: [
                144,
                238,
                144
            ],
            lightgrey: [
                211,
                211,
                211
            ],
            lightpink: [
                255,
                182,
                193
            ],
            lightsalmon: [
                255,
                160,
                122
            ],
            lightseagreen: [
                32,
                178,
                170
            ],
            lightskyblue: [
                135,
                206,
                250
            ],
            lightslategray: [
                119,
                136,
                153
            ],
            lightslategrey: [
                119,
                136,
                153
            ],
            lightsteelblue: [
                176,
                196,
                222
            ],
            lightyellow: [
                255,
                255,
                224
            ],
            lime: [
                0,
                255,
                0
            ],
            limegreen: [
                50,
                205,
                50
            ],
            linen: [
                250,
                240,
                230
            ],
            magenta: [
                255,
                0,
                255
            ],
            maroon: [
                128,
                0,
                0
            ],
            mediumaquamarine: [
                102,
                205,
                170
            ],
            mediumblue: [
                0,
                0,
                205
            ],
            mediumorchid: [
                186,
                85,
                211
            ],
            mediumpurple: [
                147,
                112,
                219
            ],
            mediumseagreen: [
                60,
                179,
                113
            ],
            mediumslateblue: [
                123,
                104,
                238
            ],
            mediumspringgreen: [
                0,
                250,
                154
            ],
            mediumturquoise: [
                72,
                209,
                204
            ],
            mediumvioletred: [
                199,
                21,
                133
            ],
            midnightblue: [
                25,
                25,
                112
            ],
            mintcream: [
                245,
                255,
                250
            ],
            mistyrose: [
                255,
                228,
                225
            ],
            moccasin: [
                255,
                228,
                181
            ],
            navajowhite: [
                255,
                222,
                173
            ],
            navy: [
                0,
                0,
                128
            ],
            oldlace: [
                253,
                245,
                230
            ],
            olive: [
                128,
                128,
                0
            ],
            olivedrab: [
                107,
                142,
                35
            ],
            orange: [
                255,
                165,
                0
            ],
            orangered: [
                255,
                69,
                0
            ],
            orchid: [
                218,
                112,
                214
            ],
            palegoldenrod: [
                238,
                232,
                170
            ],
            palegreen: [
                152,
                251,
                152
            ],
            paleturquoise: [
                175,
                238,
                238
            ],
            palevioletred: [
                219,
                112,
                147
            ],
            papayawhip: [
                255,
                239,
                213
            ],
            peachpuff: [
                255,
                218,
                185
            ],
            peru: [
                205,
                133,
                63
            ],
            pink: [
                255,
                192,
                203
            ],
            plum: [
                221,
                160,
                221
            ],
            powderblue: [
                176,
                224,
                230
            ],
            purple: [
                128,
                0,
                128
            ],
            rebeccapurple: [
                102,
                51,
                153
            ],
            red: [
                255,
                0,
                0
            ],
            rosybrown: [
                188,
                143,
                143
            ],
            royalblue: [
                65,
                105,
                225
            ],
            saddlebrown: [
                139,
                69,
                19
            ],
            salmon: [
                250,
                128,
                114
            ],
            sandybrown: [
                244,
                164,
                96
            ],
            seagreen: [
                46,
                139,
                87
            ],
            seashell: [
                255,
                245,
                238
            ],
            sienna: [
                160,
                82,
                45
            ],
            silver: [
                192,
                192,
                192
            ],
            skyblue: [
                135,
                206,
                235
            ],
            slateblue: [
                106,
                90,
                205
            ],
            slategray: [
                112,
                128,
                144
            ],
            slategrey: [
                112,
                128,
                144
            ],
            snow: [
                255,
                250,
                250
            ],
            springgreen: [
                0,
                255,
                127
            ],
            steelblue: [
                70,
                130,
                180
            ],
            tan: [
                210,
                180,
                140
            ],
            teal: [
                0,
                128,
                128
            ],
            thistle: [
                216,
                191,
                216
            ],
            tomato: [
                255,
                99,
                71
            ],
            turquoise: [
                64,
                224,
                208
            ],
            violet: [
                238,
                130,
                238
            ],
            wheat: [
                245,
                222,
                179
            ],
            white: [
                255,
                255,
                255
            ],
            whitesmoke: [
                245,
                245,
                245
            ],
            yellow: [
                255,
                255,
                0
            ],
            yellowgreen: [
                154,
                205,
                50
            ]
        };
        class Yt {
            constructor(t, e, r, n = 1, i = !0){
                this.r = t, this.g = e, this.b = r, this.a = n, i || (this.r *= n, this.g *= n, this.b *= n, n || this.overwriteGetter("rgb", [
                    t,
                    e,
                    r,
                    n
                ]));
            }
            static parse(t) {
                if (t instanceof Yt) return t;
                if ("string" != typeof t) return;
                const e = function(t) {
                    if ("transparent" === (t = t.toLowerCase().trim())) return [
                        0,
                        0,
                        0,
                        0
                    ];
                    const e = Xt[t];
                    if (e) {
                        const [t, r, n] = e;
                        return [
                            t / 255,
                            r / 255,
                            n / 255,
                            1
                        ];
                    }
                    if (t.startsWith("#") && /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/.test(t)) {
                        const e = t.length < 6 ? 1 : 2;
                        let r = 1;
                        return [
                            Zt(t.slice(r, r += e)),
                            Zt(t.slice(r, r += e)),
                            Zt(t.slice(r, r += e)),
                            Zt(t.slice(r, r + e) || "ff")
                        ];
                    }
                    if (t.startsWith("rgb")) {
                        const e = t.match(/^rgba?\(\s*([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                        if (e) {
                            const [t, r, n, i, a, s, o, l, u, c, h, p] = e, f = [
                                i || " ",
                                o || " ",
                                c
                            ].join("");
                            if ("  " === f || "  /" === f || ",," === f || ",,," === f) {
                                const t = [
                                    n,
                                    s,
                                    u
                                ].join(""), e = "%%%" === t ? 100 : "" === t ? 255 : 0;
                                if (e) {
                                    const t = [
                                        Gt(+r / e, 0, 1),
                                        Gt(+a / e, 0, 1),
                                        Gt(+l / e, 0, 1),
                                        h ? Kt(+h, p) : 1
                                    ];
                                    if (Jt(t)) return t;
                                }
                            }
                            return;
                        }
                    }
                    const r = t.match(/^hsla?\(\s*([\de.+-]+)(?:deg)?(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                    if (r) {
                        const [t, e, n, i, a, s, o, l, u] = r, c = [
                            n || " ",
                            a || " ",
                            o
                        ].join("");
                        if ("  " === c || "  /" === c || ",," === c || ",,," === c) {
                            const t = [
                                +e,
                                Gt(+i, 0, 100),
                                Gt(+s, 0, 100),
                                l ? Kt(+l, u) : 1
                            ];
                            if (Jt(t)) return function([t, e, r, n]) {
                                function i(n) {
                                    const i = (n + t / 30) % 12, a = e * Math.min(r, 1 - r);
                                    return r - a * Math.max(-1, Math.min(i - 3, 9 - i, 1));
                                }
                                return t = Dt(t), e /= 100, r /= 100, [
                                    i(0),
                                    i(8),
                                    i(4),
                                    n
                                ];
                            }(t);
                        }
                    }
                }(t);
                return e ? new Yt(...e, !1) : void 0;
            }
            get rgb() {
                const { r: t, g: e, b: r, a: n } = this, i = n || 1 / 0;
                return this.overwriteGetter("rgb", [
                    t / i,
                    e / i,
                    r / i,
                    n
                ]);
            }
            get hcl() {
                return this.overwriteGetter("hcl", function(t) {
                    const [e, r, n, i] = Ot(t), a = Math.sqrt(r * r + n * n);
                    return [
                        Math.round(1e4 * a) ? Dt(Math.atan2(n, r) * Lt) : NaN,
                        a,
                        e,
                        i
                    ];
                }(this.rgb));
            }
            get lab() {
                return this.overwriteGetter("lab", Ot(this.rgb));
            }
            overwriteGetter(t, e) {
                return Object.defineProperty(this, t, {
                    value: e
                }), e;
            }
            toString() {
                const [t, e, r, n] = this.rgb;
                return `rgba(${[
                    t,
                    e,
                    r
                ].map((t)=>Math.round(255 * t)).join(",")},${n})`;
            }
        }
        Yt.black = new Yt(0, 0, 0, 1), Yt.white = new Yt(1, 1, 1, 1), Yt.transparent = new Yt(0, 0, 0, 0), Yt.red = new Yt(1, 0, 0, 1);
        class Ht {
            constructor(t, e, r){
                this.sensitivity = t ? e ? "variant" : "case" : e ? "accent" : "base", this.locale = r, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                    sensitivity: this.sensitivity,
                    usage: "search"
                });
            }
            compare(t, e) {
                return this.collator.compare(t, e);
            }
            resolvedLocale() {
                return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
            }
        }
        class Wt {
            constructor(t, e, r, n, i){
                this.text = t, this.image = e, this.scale = r, this.fontStack = n, this.textColor = i;
            }
        }
        class Qt {
            constructor(t){
                this.sections = t;
            }
            static fromString(t) {
                return new Qt([
                    new Wt(t, null, null, null, null)
                ]);
            }
            isEmpty() {
                return 0 === this.sections.length || !this.sections.some((t)=>0 !== t.text.length || t.image && 0 !== t.image.name.length);
            }
            static factory(t) {
                return t instanceof Qt ? t : Qt.fromString(t);
            }
            toString() {
                return 0 === this.sections.length ? "" : this.sections.map((t)=>t.text).join("");
            }
        }
        class te {
            constructor(t){
                this.values = t.slice();
            }
            static parse(t) {
                if (t instanceof te) return t;
                if ("number" == typeof t) return new te([
                    t,
                    t,
                    t,
                    t
                ]);
                if (Array.isArray(t) && !(t.length < 1 || t.length > 4)) {
                    for (const e of t)if ("number" != typeof e) return;
                    switch(t.length){
                        case 1:
                            t = [
                                t[0],
                                t[0],
                                t[0],
                                t[0]
                            ];
                            break;
                        case 2:
                            t = [
                                t[0],
                                t[1],
                                t[0],
                                t[1]
                            ];
                            break;
                        case 3:
                            t = [
                                t[0],
                                t[1],
                                t[2],
                                t[1]
                            ];
                    }
                    return new te(t);
                }
            }
            toString() {
                return JSON.stringify(this.values);
            }
        }
        const ee = new Set([
            "center",
            "left",
            "right",
            "top",
            "bottom",
            "top-left",
            "top-right",
            "bottom-left",
            "bottom-right"
        ]);
        class re {
            constructor(t){
                this.values = t.slice();
            }
            static parse(t) {
                if (t instanceof re) return t;
                if (Array.isArray(t) && !(t.length < 1) && t.length % 2 == 0) {
                    for(let e = 0; e < t.length; e += 2){
                        const r = t[e], n = t[e + 1];
                        if ("string" != typeof r || !ee.has(r)) return;
                        if (!Array.isArray(n) || 2 !== n.length || "number" != typeof n[0] || "number" != typeof n[1]) return;
                    }
                    return new re(t);
                }
            }
            toString() {
                return JSON.stringify(this.values);
            }
        }
        class ne {
            constructor(t){
                this.name = t.name, this.available = t.available;
            }
            toString() {
                return this.name;
            }
            static fromString(t) {
                return t ? new ne({
                    name: t,
                    available: !1
                }) : null;
            }
        }
        function ie(t, e, r, n) {
            return "number" == typeof t && t >= 0 && t <= 255 && "number" == typeof e && e >= 0 && e <= 255 && "number" == typeof r && r >= 0 && r <= 255 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : `Invalid rgba value [${[
                t,
                e,
                r,
                n
            ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof n ? [
                t,
                e,
                r,
                n
            ] : [
                t,
                e,
                r
            ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
        }
        function ae(t) {
            if (null === t || "string" == typeof t || "boolean" == typeof t || "number" == typeof t || t instanceof Yt || t instanceof Ht || t instanceof Qt || t instanceof te || t instanceof re || t instanceof ne) return !0;
            if (Array.isArray(t)) {
                for (const e of t)if (!ae(e)) return !1;
                return !0;
            }
            if ("object" == typeof t) {
                for(const e in t)if (!ae(t[e])) return !1;
                return !0;
            }
            return !1;
        }
        function se(t) {
            if (null === t) return ht;
            if ("string" == typeof t) return ft;
            if ("boolean" == typeof t) return dt;
            if ("number" == typeof t) return pt;
            if (t instanceof Yt) return yt;
            if (t instanceof Ht) return xt;
            if (t instanceof Qt) return vt;
            if (t instanceof te) return bt;
            if (t instanceof re) return _t;
            if (t instanceof ne) return wt;
            if (Array.isArray(t)) {
                const e = t.length;
                let r;
                for (const e of t){
                    const t = se(e);
                    if (r) {
                        if (r === t) continue;
                        r = gt;
                        break;
                    }
                    r = t;
                }
                return At(r || gt, e);
            }
            return mt;
        }
        function oe(t) {
            const e = typeof t;
            return null === t ? "" : "string" === e || "number" === e || "boolean" === e ? String(t) : t instanceof Yt || t instanceof Qt || t instanceof te || t instanceof re || t instanceof ne ? t.toString() : JSON.stringify(t);
        }
        class le {
            constructor(t, e){
                this.type = t, this.value = e;
            }
            static parse(t, e) {
                if (2 !== t.length) return e.error(`'literal' expression requires exactly one argument, but found ${t.length - 1} instead.`);
                if (!ae(t[1])) return e.error("invalid value");
                const r = t[1];
                let n = se(r);
                const i = e.expectedType;
                return "array" !== n.kind || 0 !== n.N || !i || "array" !== i.kind || "number" == typeof i.N && 0 !== i.N || (n = i), new le(n, r);
            }
            evaluate() {
                return this.value;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
        }
        class ue {
            constructor(t){
                this.name = "ExpressionEvaluationError", this.message = t;
            }
            toJSON() {
                return this.message;
            }
        }
        const ce = {
            string: ft,
            number: pt,
            boolean: dt,
            object: mt
        };
        class he {
            constructor(t, e){
                this.type = t, this.args = e;
            }
            static parse(t, e) {
                if (t.length < 2) return e.error("Expected at least one argument.");
                let r, n = 1;
                const i = t[0];
                if ("array" === i) {
                    let i, a;
                    if (t.length > 2) {
                        const r = t[1];
                        if ("string" != typeof r || !(r in ce) || "object" === r) return e.error('The item type argument of "array" must be one of string, number, boolean', 1);
                        i = ce[r], n++;
                    } else i = gt;
                    if (t.length > 3) {
                        if (null !== t[2] && ("number" != typeof t[2] || t[2] < 0 || t[2] !== Math.floor(t[2]))) return e.error('The length argument to "array" must be a positive integer literal', 2);
                        a = t[2], n++;
                    }
                    r = At(i, a);
                } else {
                    if (!ce[i]) throw new Error(`Types doesn't contain name = ${i}`);
                    r = ce[i];
                }
                const a = [];
                for(; n < t.length; n++){
                    const r = e.parse(t[n], n, gt);
                    if (!r) return null;
                    a.push(r);
                }
                return new he(r, a);
            }
            evaluate(t) {
                for(let e = 0; e < this.args.length; e++){
                    const r = this.args[e].evaluate(t);
                    if (!It(this.type, se(r))) return r;
                    if (e === this.args.length - 1) throw new ue(`Expected value to be of type ${St(this.type)}, but found ${St(se(r))} instead.`);
                }
                throw new Error;
            }
            eachChild(t) {
                this.args.forEach(t);
            }
            outputDefined() {
                return this.args.every((t)=>t.outputDefined());
            }
        }
        const pe = {
            "to-boolean": dt,
            "to-color": yt,
            "to-number": pt,
            "to-string": ft
        };
        class fe {
            constructor(t, e){
                this.type = t, this.args = e;
            }
            static parse(t, e) {
                if (t.length < 2) return e.error("Expected at least one argument.");
                const r = t[0];
                if (!pe[r]) throw new Error(`Can't parse ${r} as it is not part of the known types`);
                if (("to-boolean" === r || "to-string" === r) && 2 !== t.length) return e.error("Expected one argument.");
                const n = pe[r], i = [];
                for(let r = 1; r < t.length; r++){
                    const n = e.parse(t[r], r, gt);
                    if (!n) return null;
                    i.push(n);
                }
                return new fe(n, i);
            }
            evaluate(t) {
                switch(this.type.kind){
                    case "boolean":
                        return Boolean(this.args[0].evaluate(t));
                    case "color":
                        {
                            let e, r;
                            for (const n of this.args){
                                if (e = n.evaluate(t), r = null, e instanceof Yt) return e;
                                if ("string" == typeof e) {
                                    const r = t.parseColor(e);
                                    if (r) return r;
                                } else if (Array.isArray(e) && (r = e.length < 3 || e.length > 4 ? `Invalid rbga value ${JSON.stringify(e)}: expected an array containing either three or four numeric values.` : ie(e[0], e[1], e[2], e[3]), !r)) return new Yt(e[0] / 255, e[1] / 255, e[2] / 255, e[3]);
                            }
                            throw new ue(r || `Could not parse color from value '${"string" == typeof e ? e : JSON.stringify(e)}'`);
                        }
                    case "padding":
                        {
                            let e;
                            for (const r of this.args){
                                e = r.evaluate(t);
                                const n = te.parse(e);
                                if (n) return n;
                            }
                            throw new ue(`Could not parse padding from value '${"string" == typeof e ? e : JSON.stringify(e)}'`);
                        }
                    case "variableAnchorOffsetCollection":
                        {
                            let e;
                            for (const r of this.args){
                                e = r.evaluate(t);
                                const n = re.parse(e);
                                if (n) return n;
                            }
                            throw new ue(`Could not parse variableAnchorOffsetCollection from value '${"string" == typeof e ? e : JSON.stringify(e)}'`);
                        }
                    case "number":
                        {
                            let e = null;
                            for (const r of this.args){
                                if (e = r.evaluate(t), null === e) return 0;
                                const n = Number(e);
                                if (!isNaN(n)) return n;
                            }
                            throw new ue(`Could not convert ${JSON.stringify(e)} to number.`);
                        }
                    case "formatted":
                        return Qt.fromString(oe(this.args[0].evaluate(t)));
                    case "resolvedImage":
                        return ne.fromString(oe(this.args[0].evaluate(t)));
                    default:
                        return oe(this.args[0].evaluate(t));
                }
            }
            eachChild(t) {
                this.args.forEach(t);
            }
            outputDefined() {
                return this.args.every((t)=>t.outputDefined());
            }
        }
        const de = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        class ye {
            constructor(){
                this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null;
            }
            id() {
                return this.feature && "id" in this.feature ? this.feature.id : null;
            }
            geometryType() {
                return this.feature ? "number" == typeof this.feature.type ? de[this.feature.type] : this.feature.type : null;
            }
            geometry() {
                return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
            }
            canonicalID() {
                return this.canonical;
            }
            properties() {
                return this.feature && this.feature.properties || {};
            }
            parseColor(t) {
                let e = this._parseColorCache[t];
                return e || (e = this._parseColorCache[t] = Yt.parse(t)), e;
            }
        }
        class me {
            constructor(t, e, r = [], n, i = new ct, a = []){
                this.registry = t, this.path = r, this.key = r.map((t)=>`[${t}]`).join(""), this.scope = i, this.errors = a, this.expectedType = n, this._isConstant = e;
            }
            parse(t, e, r, n, i = {}) {
                return e ? this.concat(e, r, n)._parse(t, i) : this._parse(t, i);
            }
            _parse(t, e) {
                function r(t, e, r) {
                    return "assert" === r ? new he(e, [
                        t
                    ]) : "coerce" === r ? new fe(e, [
                        t
                    ]) : t;
                }
                if (null !== t && "string" != typeof t && "boolean" != typeof t && "number" != typeof t || (t = [
                    "literal",
                    t
                ]), Array.isArray(t)) {
                    if (0 === t.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                    const n = t[0];
                    if ("string" != typeof n) return this.error(`Expression name must be a string, but found ${typeof n} instead. If you wanted a literal array, use ["literal", [...]].`, 0), null;
                    const i = this.registry[n];
                    if (i) {
                        let n = i.parse(t, this);
                        if (!n) return null;
                        if (this.expectedType) {
                            const t = this.expectedType, i = n.type;
                            if ("string" !== t.kind && "number" !== t.kind && "boolean" !== t.kind && "object" !== t.kind && "array" !== t.kind || "value" !== i.kind) {
                                if ("color" !== t.kind && "formatted" !== t.kind && "resolvedImage" !== t.kind || "value" !== i.kind && "string" !== i.kind) {
                                    if ("padding" !== t.kind || "value" !== i.kind && "number" !== i.kind && "array" !== i.kind) {
                                        if ("variableAnchorOffsetCollection" !== t.kind || "value" !== i.kind && "array" !== i.kind) {
                                            if (this.checkSubtype(t, i)) return null;
                                        } else n = r(n, t, e.typeAnnotation || "coerce");
                                    } else n = r(n, t, e.typeAnnotation || "coerce");
                                } else n = r(n, t, e.typeAnnotation || "coerce");
                            } else n = r(n, t, e.typeAnnotation || "assert");
                        }
                        if (!(n instanceof le) && "resolvedImage" !== n.type.kind && this._isConstant(n)) {
                            const t = new ye;
                            try {
                                n = new le(n.type, n.evaluate(t));
                            } catch (t) {
                                return this.error(t.message), null;
                            }
                        }
                        return n;
                    }
                    return this.error(`Unknown expression "${n}". If you wanted a literal array, use ["literal", [...]].`, 0);
                }
                return this.error(void 0 === t ? "'undefined' value invalid. Use null instead." : "object" == typeof t ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof t} instead.`);
            }
            concat(t, e, r) {
                const n = "number" == typeof t ? this.path.concat(t) : this.path, i = r ? this.scope.concat(r) : this.scope;
                return new me(this.registry, this._isConstant, n, e || null, i, this.errors);
            }
            error(t, ...e) {
                const r = `${this.key}${e.map((t)=>`[${t}]`).join("")}`;
                this.errors.push(new ut(r, t));
            }
            checkSubtype(t, e) {
                const r = It(t, e);
                return r && this.error(r), r;
            }
        }
        class ge {
            constructor(t, e, r){
                this.type = xt, this.locale = r, this.caseSensitive = t, this.diacriticSensitive = e;
            }
            static parse(t, e) {
                if (2 !== t.length) return e.error("Expected one argument.");
                const r = t[1];
                if ("object" != typeof r || Array.isArray(r)) return e.error("Collator options argument must be an object.");
                const n = e.parse(void 0 !== r["case-sensitive"] && r["case-sensitive"], 1, dt);
                if (!n) return null;
                const i = e.parse(void 0 !== r["diacritic-sensitive"] && r["diacritic-sensitive"], 1, dt);
                if (!i) return null;
                let a = null;
                return r.locale && (a = e.parse(r.locale, 1, ft), !a) ? null : new ge(n, i, a);
            }
            evaluate(t) {
                return new Ht(this.caseSensitive.evaluate(t), this.diacriticSensitive.evaluate(t), this.locale ? this.locale.evaluate(t) : null);
            }
            eachChild(t) {
                t(this.caseSensitive), t(this.diacriticSensitive), this.locale && t(this.locale);
            }
            outputDefined() {
                return !1;
            }
        }
        const xe = 8192;
        function ve(t, e) {
            t[0] = Math.min(t[0], e[0]), t[1] = Math.min(t[1], e[1]), t[2] = Math.max(t[2], e[0]), t[3] = Math.max(t[3], e[1]);
        }
        function be(t, e) {
            return !(t[0] <= e[0] || t[2] >= e[2] || t[1] <= e[1] || t[3] >= e[3]);
        }
        function we(t, e) {
            const r = (180 + t[0]) / 360, n = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t[1] * Math.PI / 360))) / 360, i = Math.pow(2, e.z);
            return [
                Math.round(r * i * xe),
                Math.round(n * i * xe)
            ];
        }
        function _e(t, e, r) {
            const n = t[0] - e[0], i = t[1] - e[1], a = t[0] - r[0], s = t[1] - r[1];
            return n * s - a * i == 0 && n * a <= 0 && i * s <= 0;
        }
        function Ae(t, e) {
            let r = !1;
            for(let s = 0, o = e.length; s < o; s++){
                const o = e[s];
                for(let e = 0, s = o.length; e < s - 1; e++){
                    if (_e(t, o[e], o[e + 1])) return !1;
                    (i = o[e])[1] > (n = t)[1] != (a = o[e + 1])[1] > n[1] && n[0] < (a[0] - i[0]) * (n[1] - i[1]) / (a[1] - i[1]) + i[0] && (r = !r);
                }
            }
            var n, i, a;
            return r;
        }
        function Se(t, e) {
            for(let r = 0; r < e.length; r++)if (Ae(t, e[r])) return !0;
            return !1;
        }
        function ke(t, e, r, n) {
            const i = n[0] - r[0], a = n[1] - r[1], s = (t[0] - r[0]) * a - i * (t[1] - r[1]), o = (e[0] - r[0]) * a - i * (e[1] - r[1]);
            return s > 0 && o < 0 || s < 0 && o > 0;
        }
        function Ie(t, e, r) {
            for (const u of r)for(let r = 0; r < u.length - 1; ++r)if (0 != (o = [
                (s = u[r + 1])[0] - (a = u[r])[0],
                s[1] - a[1]
            ])[0] * (l = [
                (i = e)[0] - (n = t)[0],
                i[1] - n[1]
            ])[1] - o[1] * l[0] && ke(n, i, a, s) && ke(a, s, n, i)) return !0;
            var n, i, a, s, o, l;
            return !1;
        }
        function ze(t, e) {
            for(let r = 0; r < t.length; ++r)if (!Ae(t[r], e)) return !1;
            for(let r = 0; r < t.length - 1; ++r)if (Ie(t[r], t[r + 1], e)) return !1;
            return !0;
        }
        function Me(t, e) {
            for(let r = 0; r < e.length; r++)if (ze(t, e[r])) return !0;
            return !1;
        }
        function Ce(t, e, r) {
            const n = [];
            for(let i = 0; i < t.length; i++){
                const a = [];
                for(let n = 0; n < t[i].length; n++){
                    const s = we(t[i][n], r);
                    ve(e, s), a.push(s);
                }
                n.push(a);
            }
            return n;
        }
        function Be(t, e, r) {
            const n = [];
            for(let i = 0; i < t.length; i++){
                const a = Ce(t[i], e, r);
                n.push(a);
            }
            return n;
        }
        function Pe(t, e, r, n) {
            if (t[0] < r[0] || t[0] > r[2]) {
                const e = .5 * n;
                let i = t[0] - r[0] > e ? -n : r[0] - t[0] > e ? n : 0;
                0 === i && (i = t[0] - r[2] > e ? -n : r[2] - t[0] > e ? n : 0), t[0] += i;
            }
            ve(e, t);
        }
        function Ve(t, e, r, n) {
            const i = Math.pow(2, n.z) * xe, a = [
                n.x * xe,
                n.y * xe
            ], s = [];
            for (const n of t)for (const t of n){
                const n = [
                    t.x + a[0],
                    t.y + a[1]
                ];
                Pe(n, e, r, i), s.push(n);
            }
            return s;
        }
        function Ee(t, e, r, n) {
            const i = Math.pow(2, n.z) * xe, a = [
                n.x * xe,
                n.y * xe
            ], s = [];
            for (const r of t){
                const t = [];
                for (const n of r){
                    const r = [
                        n.x + a[0],
                        n.y + a[1]
                    ];
                    ve(e, r), t.push(r);
                }
                s.push(t);
            }
            if (e[2] - e[0] <= i / 2) {
                (o = e)[0] = o[1] = 1 / 0, o[2] = o[3] = -1 / 0;
                for (const t of s)for (const n of t)Pe(n, e, r, i);
            }
            var o;
            return s;
        }
        class Fe {
            constructor(t, e){
                this.type = dt, this.geojson = t, this.geometries = e;
            }
            static parse(t, e) {
                if (2 !== t.length) return e.error(`'within' expression requires exactly one argument, but found ${t.length - 1} instead.`);
                if (ae(t[1])) {
                    const e = t[1];
                    if ("FeatureCollection" === e.type) for(let t = 0; t < e.features.length; ++t){
                        const r = e.features[t].geometry.type;
                        if ("Polygon" === r || "MultiPolygon" === r) return new Fe(e, e.features[t].geometry);
                    }
                    else if ("Feature" === e.type) {
                        const t = e.geometry.type;
                        if ("Polygon" === t || "MultiPolygon" === t) return new Fe(e, e.geometry);
                    } else if ("Polygon" === e.type || "MultiPolygon" === e.type) return new Fe(e, e);
                }
                return e.error("'within' expression requires valid geojson object that contains polygon geometry type.");
            }
            evaluate(t) {
                if (null != t.geometry() && null != t.canonicalID()) {
                    if ("Point" === t.geometryType()) return function(t, e) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = t.canonicalID();
                        if ("Polygon" === e.type) {
                            const a = Ce(e.coordinates, n, i), s = Ve(t.geometry(), r, n, i);
                            if (!be(r, n)) return !1;
                            for (const t of s)if (!Ae(t, a)) return !1;
                        }
                        if ("MultiPolygon" === e.type) {
                            const a = Be(e.coordinates, n, i), s = Ve(t.geometry(), r, n, i);
                            if (!be(r, n)) return !1;
                            for (const t of s)if (!Se(t, a)) return !1;
                        }
                        return !0;
                    }(t, this.geometries);
                    if ("LineString" === t.geometryType()) return function(t, e) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = t.canonicalID();
                        if ("Polygon" === e.type) {
                            const a = Ce(e.coordinates, n, i), s = Ee(t.geometry(), r, n, i);
                            if (!be(r, n)) return !1;
                            for (const t of s)if (!ze(t, a)) return !1;
                        }
                        if ("MultiPolygon" === e.type) {
                            const a = Be(e.coordinates, n, i), s = Ee(t.geometry(), r, n, i);
                            if (!be(r, n)) return !1;
                            for (const t of s)if (!Me(t, a)) return !1;
                        }
                        return !0;
                    }(t, this.geometries);
                }
                return !1;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
        }
        class Te {
            constructor(t, e){
                this.type = e.type, this.name = t, this.boundExpression = e;
            }
            static parse(t, e) {
                if (2 !== t.length || "string" != typeof t[1]) return e.error("'var' expression requires exactly one string literal argument.");
                const r = t[1];
                return e.scope.has(r) ? new Te(r, e.scope.get(r)) : e.error(`Unknown variable "${r}". Make sure "${r}" has been bound in an enclosing "let" expression before using it.`, 1);
            }
            evaluate(t) {
                return this.boundExpression.evaluate(t);
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
        }
        class $e {
            constructor(t, e, r, n){
                this.name = t, this.type = e, this._evaluate = r, this.args = n;
            }
            evaluate(t) {
                return this._evaluate(t, this.args);
            }
            eachChild(t) {
                this.args.forEach(t);
            }
            outputDefined() {
                return !1;
            }
            static parse(t, e) {
                const r = t[0], n = $e.definitions[r];
                if (!n) return e.error(`Unknown expression "${r}". If you wanted a literal array, use ["literal", [...]].`, 0);
                const i = Array.isArray(n) ? n[0] : n.type, a = Array.isArray(n) ? [
                    [
                        n[1],
                        n[2]
                    ]
                ] : n.overloads, s = a.filter(([e])=>!Array.isArray(e) || e.length === t.length - 1);
                let o = null;
                for (const [n, a] of s){
                    o = new me(e.registry, Le, e.path, null, e.scope);
                    const s = [];
                    let l = !1;
                    for(let e = 1; e < t.length; e++){
                        const r = t[e], i = Array.isArray(n) ? n[e - 1] : n.type, a = o.parse(r, 1 + s.length, i);
                        if (!a) {
                            l = !0;
                            break;
                        }
                        s.push(a);
                    }
                    if (!l) {
                        if (Array.isArray(n) && n.length !== s.length) o.error(`Expected ${n.length} arguments, but found ${s.length} instead.`);
                        else {
                            for(let t = 0; t < s.length; t++){
                                const e = Array.isArray(n) ? n[t] : n.type, r = s[t];
                                o.concat(t + 1).checkSubtype(e, r.type);
                            }
                            if (0 === o.errors.length) return new $e(r, i, a, s);
                        }
                    }
                }
                if (1 === s.length) e.errors.push(...o.errors);
                else {
                    const r = (s.length ? s : a).map(([t])=>{
                        var e;
                        return e = t, Array.isArray(e) ? `(${e.map(St).join(", ")})` : `(${St(e.type)}...)`;
                    }).join(" | "), n = [];
                    for(let r = 1; r < t.length; r++){
                        const i = e.parse(t[r], 1 + n.length);
                        if (!i) return null;
                        n.push(St(i.type));
                    }
                    e.error(`Expected arguments of type ${r}, but found (${n.join(", ")}) instead.`);
                }
                return null;
            }
            static register(t, e) {
                $e.definitions = e;
                for(const r in e)t[r] = $e;
            }
        }
        function Le(t) {
            if (t instanceof Te) return Le(t.boundExpression);
            if (t instanceof $e && "error" === t.name) return !1;
            if (t instanceof ge) return !1;
            if (t instanceof Fe) return !1;
            const e = t instanceof fe || t instanceof he;
            let r = !0;
            return t.eachChild((t)=>{
                r = e ? r && Le(t) : r && t instanceof le;
            }), !!r && De(t) && Ue(t, [
                "zoom",
                "heatmap-density",
                "line-progress",
                "accumulated",
                "is-supported-script"
            ]);
        }
        function De(t) {
            if (t instanceof $e) {
                if ("get" === t.name && 1 === t.args.length) return !1;
                if ("feature-state" === t.name) return !1;
                if ("has" === t.name && 1 === t.args.length) return !1;
                if ("properties" === t.name || "geometry-type" === t.name || "id" === t.name) return !1;
                if (/^filter-/.test(t.name)) return !1;
            }
            if (t instanceof Fe) return !1;
            let e = !0;
            return t.eachChild((t)=>{
                e && !De(t) && (e = !1);
            }), e;
        }
        function Oe(t) {
            if (t instanceof $e && "feature-state" === t.name) return !1;
            let e = !0;
            return t.eachChild((t)=>{
                e && !Oe(t) && (e = !1);
            }), e;
        }
        function Ue(t, e) {
            if (t instanceof $e && e.indexOf(t.name) >= 0) return !1;
            let r = !0;
            return t.eachChild((t)=>{
                r && !Ue(t, e) && (r = !1);
            }), r;
        }
        function Re(t, e) {
            const r = t.length - 1;
            let n, i, a = 0, s = r, o = 0;
            for(; a <= s;)if (o = Math.floor((a + s) / 2), n = t[o], i = t[o + 1], n <= e) {
                if (o === r || e < i) return o;
                a = o + 1;
            } else {
                if (!(n > e)) throw new ue("Input is not a number.");
                s = o - 1;
            }
            return 0;
        }
        class qe {
            constructor(t, e, r){
                this.type = t, this.input = e, this.labels = [], this.outputs = [];
                for (const [t, e] of r)this.labels.push(t), this.outputs.push(e);
            }
            static parse(t, e) {
                if (t.length - 1 < 4) return e.error(`Expected at least 4 arguments, but found only ${t.length - 1}.`);
                if ((t.length - 1) % 2 != 0) return e.error("Expected an even number of arguments.");
                const r = e.parse(t[1], 1, pt);
                if (!r) return null;
                const n = [];
                let i = null;
                e.expectedType && "value" !== e.expectedType.kind && (i = e.expectedType);
                for(let r = 1; r < t.length; r += 2){
                    const a = 1 === r ? -1 / 0 : t[r], s = t[r + 1], o = r, l = r + 1;
                    if ("number" != typeof a) return e.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', o);
                    if (n.length && n[n.length - 1][0] >= a) return e.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', o);
                    const u = e.parse(s, l, i);
                    if (!u) return null;
                    i = i || u.type, n.push([
                        a,
                        u
                    ]);
                }
                return new qe(i, r, n);
            }
            evaluate(t) {
                const e = this.labels, r = this.outputs;
                if (1 === e.length) return r[0].evaluate(t);
                const n = this.input.evaluate(t);
                if (n <= e[0]) return r[0].evaluate(t);
                const i = e.length;
                return n >= e[i - 1] ? r[i - 1].evaluate(t) : r[Re(e, n)].evaluate(t);
            }
            eachChild(t) {
                t(this.input);
                for (const e of this.outputs)t(e);
            }
            outputDefined() {
                return this.outputs.every((t)=>t.outputDefined());
            }
        }
        function je(t, e, r) {
            return t + r * (e - t);
        }
        function Ne(t, e, r) {
            return t.map((t, n)=>je(t, e[n], r));
        }
        const Ze = {
            number: je,
            color: function(t, e, r, n = "rgb") {
                switch(n){
                    case "rgb":
                        {
                            const [n, i, a, s] = Ne(t.rgb, e.rgb, r);
                            return new Yt(n, i, a, s, !1);
                        }
                    case "hcl":
                        {
                            const [n, i, a, s] = t.hcl, [o, l, u, c] = e.hcl;
                            let h, p;
                            if (isNaN(n) || isNaN(o)) isNaN(n) ? isNaN(o) ? h = NaN : (h = o, 1 !== a && 0 !== a || (p = l)) : (h = n, 1 !== u && 0 !== u || (p = i));
                            else {
                                let t = o - n;
                                o > n && t > 180 ? t -= 360 : o < n && n - o > 180 && (t += 360), h = n + r * t;
                            }
                            const [f, d, y, m] = function([t, e, r, n]) {
                                return t = isNaN(t) ? 0 : t * $t, qt([
                                    r,
                                    Math.cos(t) * e,
                                    Math.sin(t) * e,
                                    n
                                ]);
                            }([
                                h,
                                null != p ? p : je(i, l, r),
                                je(a, u, r),
                                je(s, c, r)
                            ]);
                            return new Yt(f, d, y, m, !1);
                        }
                    case "lab":
                        {
                            const [n, i, a, s] = qt(Ne(t.lab, e.lab, r));
                            return new Yt(n, i, a, s, !1);
                        }
                }
            },
            array: Ne,
            padding: function(t, e, r) {
                return new te(Ne(t.values, e.values, r));
            },
            variableAnchorOffsetCollection: function(t, e, r) {
                const n = t.values, i = e.values;
                if (n.length !== i.length) throw new ue(`Cannot interpolate values of different length. from: ${t.toString()}, to: ${e.toString()}`);
                const a = [];
                for(let t = 0; t < n.length; t += 2){
                    if (n[t] !== i[t]) throw new ue(`Cannot interpolate values containing mismatched anchors. from[${t}]: ${n[t]}, to[${t}]: ${i[t]}`);
                    a.push(n[t]);
                    const [e, s] = n[t + 1], [o, l] = i[t + 1];
                    a.push([
                        je(e, o, r),
                        je(s, l, r)
                    ]);
                }
                return new re(a);
            }
        };
        class Ke {
            constructor(t, e, r, n, i){
                this.type = t, this.operator = e, this.interpolation = r, this.input = n, this.labels = [], this.outputs = [];
                for (const [t, e] of i)this.labels.push(t), this.outputs.push(e);
            }
            static interpolationFactor(t, e, r, n) {
                let i = 0;
                if ("exponential" === t.name) i = Ge(e, t.base, r, n);
                else if ("linear" === t.name) i = Ge(e, 1, r, n);
                else if ("cubic-bezier" === t.name) {
                    const a = t.controlPoints;
                    i = new l(a[0], a[1], a[2], a[3]).solve(Ge(e, 1, r, n));
                }
                return i;
            }
            static parse(t, e) {
                let [r, n, i, ...a] = t;
                if (!Array.isArray(n) || 0 === n.length) return e.error("Expected an interpolation type expression.", 1);
                if ("linear" === n[0]) n = {
                    name: "linear"
                };
                else if ("exponential" === n[0]) {
                    const t = n[1];
                    if ("number" != typeof t) return e.error("Exponential interpolation requires a numeric base.", 1, 1);
                    n = {
                        name: "exponential",
                        base: t
                    };
                } else {
                    if ("cubic-bezier" !== n[0]) return e.error(`Unknown interpolation type ${String(n[0])}`, 1, 0);
                    {
                        const t = n.slice(1);
                        if (4 !== t.length || t.some((t)=>"number" != typeof t || t < 0 || t > 1)) return e.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                        n = {
                            name: "cubic-bezier",
                            controlPoints: t
                        };
                    }
                }
                if (t.length - 1 < 4) return e.error(`Expected at least 4 arguments, but found only ${t.length - 1}.`);
                if ((t.length - 1) % 2 != 0) return e.error("Expected an even number of arguments.");
                if (i = e.parse(i, 2, pt), !i) return null;
                const s = [];
                let o = null;
                "interpolate-hcl" === r || "interpolate-lab" === r ? o = yt : e.expectedType && "value" !== e.expectedType.kind && (o = e.expectedType);
                for(let t = 0; t < a.length; t += 2){
                    const r = a[t], n = a[t + 1], i = t + 3, l = t + 4;
                    if ("number" != typeof r) return e.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', i);
                    if (s.length && s[s.length - 1][0] >= r) return e.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', i);
                    const u = e.parse(n, l, o);
                    if (!u) return null;
                    o = o || u.type, s.push([
                        r,
                        u
                    ]);
                }
                return Ct(o, pt) || Ct(o, yt) || Ct(o, bt) || Ct(o, _t) || Ct(o, At(pt)) ? new Ke(o, r, n, i, s) : e.error(`Type ${St(o)} is not interpolatable.`);
            }
            evaluate(t) {
                const e = this.labels, r = this.outputs;
                if (1 === e.length) return r[0].evaluate(t);
                const n = this.input.evaluate(t);
                if (n <= e[0]) return r[0].evaluate(t);
                const i = e.length;
                if (n >= e[i - 1]) return r[i - 1].evaluate(t);
                const a = Re(e, n), s = Ke.interpolationFactor(this.interpolation, n, e[a], e[a + 1]), o = r[a].evaluate(t), l = r[a + 1].evaluate(t);
                switch(this.operator){
                    case "interpolate":
                        return Ze[this.type.kind](o, l, s);
                    case "interpolate-hcl":
                        return Ze.color(o, l, s, "hcl");
                    case "interpolate-lab":
                        return Ze.color(o, l, s, "lab");
                }
            }
            eachChild(t) {
                t(this.input);
                for (const e of this.outputs)t(e);
            }
            outputDefined() {
                return this.outputs.every((t)=>t.outputDefined());
            }
        }
        function Ge(t, e, r, n) {
            const i = n - r, a = t - r;
            return 0 === i ? 0 : 1 === e ? a / i : (Math.pow(e, a) - 1) / (Math.pow(e, i) - 1);
        }
        class Je {
            constructor(t, e){
                this.type = t, this.args = e;
            }
            static parse(t, e) {
                if (t.length < 2) return e.error("Expectected at least one argument.");
                let r = null;
                const n = e.expectedType;
                n && "value" !== n.kind && (r = n);
                const i = [];
                for (const n of t.slice(1)){
                    const t = e.parse(n, 1 + i.length, r, void 0, {
                        typeAnnotation: "omit"
                    });
                    if (!t) return null;
                    r = r || t.type, i.push(t);
                }
                if (!r) throw new Error("No output type");
                const a = n && i.some((t)=>It(n, t.type));
                return new Je(a ? gt : r, i);
            }
            evaluate(t) {
                let e, r = null, n = 0;
                for (const i of this.args)if (n++, r = i.evaluate(t), r && r instanceof ne && !r.available && (e || (e = r.name), r = null, n === this.args.length && (r = e)), null !== r) break;
                return r;
            }
            eachChild(t) {
                this.args.forEach(t);
            }
            outputDefined() {
                return this.args.every((t)=>t.outputDefined());
            }
        }
        class Xe {
            constructor(t, e){
                this.type = e.type, this.bindings = [].concat(t), this.result = e;
            }
            evaluate(t) {
                return this.result.evaluate(t);
            }
            eachChild(t) {
                for (const e of this.bindings)t(e[1]);
                t(this.result);
            }
            static parse(t, e) {
                if (t.length < 4) return e.error(`Expected at least 3 arguments, but found ${t.length - 1} instead.`);
                const r = [];
                for(let n = 1; n < t.length - 1; n += 2){
                    const i = t[n];
                    if ("string" != typeof i) return e.error(`Expected string, but found ${typeof i} instead.`, n);
                    if (/[^a-zA-Z0-9_]/.test(i)) return e.error("Variable names must contain only alphanumeric characters or '_'.", n);
                    const a = e.parse(t[n + 1], n + 1);
                    if (!a) return null;
                    r.push([
                        i,
                        a
                    ]);
                }
                const n = e.parse(t[t.length - 1], t.length - 1, e.expectedType, r);
                return n ? new Xe(r, n) : null;
            }
            outputDefined() {
                return this.result.outputDefined();
            }
        }
        class Ye {
            constructor(t, e, r){
                this.type = t, this.index = e, this.input = r;
            }
            static parse(t, e) {
                if (3 !== t.length) return e.error(`Expected 2 arguments, but found ${t.length - 1} instead.`);
                const r = e.parse(t[1], 1, pt), n = e.parse(t[2], 2, At(e.expectedType || gt));
                return r && n ? new Ye(n.type.itemType, r, n) : null;
            }
            evaluate(t) {
                const e = this.index.evaluate(t), r = this.input.evaluate(t);
                if (e < 0) throw new ue(`Array index out of bounds: ${e} < 0.`);
                if (e >= r.length) throw new ue(`Array index out of bounds: ${e} > ${r.length - 1}.`);
                if (e !== Math.floor(e)) throw new ue(`Array index must be an integer, but found ${e} instead.`);
                return r[e];
            }
            eachChild(t) {
                t(this.index), t(this.input);
            }
            outputDefined() {
                return !1;
            }
        }
        class He {
            constructor(t, e){
                this.type = dt, this.needle = t, this.haystack = e;
            }
            static parse(t, e) {
                if (3 !== t.length) return e.error(`Expected 2 arguments, but found ${t.length - 1} instead.`);
                const r = e.parse(t[1], 1, gt), n = e.parse(t[2], 2, gt);
                return r && n ? zt(r.type, [
                    dt,
                    ft,
                    pt,
                    ht,
                    gt
                ]) ? new He(r, n) : e.error(`Expected first argument to be of type boolean, string, number or null, but found ${St(r.type)} instead`) : null;
            }
            evaluate(t) {
                const e = this.needle.evaluate(t), r = this.haystack.evaluate(t);
                if (!r) return !1;
                if (!Mt(e, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new ue(`Expected first argument to be of type boolean, string, number or null, but found ${St(se(e))} instead.`);
                if (!Mt(r, [
                    "string",
                    "array"
                ])) throw new ue(`Expected second argument to be of type array or string, but found ${St(se(r))} instead.`);
                return r.indexOf(e) >= 0;
            }
            eachChild(t) {
                t(this.needle), t(this.haystack);
            }
            outputDefined() {
                return !0;
            }
        }
        class We {
            constructor(t, e, r){
                this.type = pt, this.needle = t, this.haystack = e, this.fromIndex = r;
            }
            static parse(t, e) {
                if (t.length <= 2 || t.length >= 5) return e.error(`Expected 3 or 4 arguments, but found ${t.length - 1} instead.`);
                const r = e.parse(t[1], 1, gt), n = e.parse(t[2], 2, gt);
                if (!r || !n) return null;
                if (!zt(r.type, [
                    dt,
                    ft,
                    pt,
                    ht,
                    gt
                ])) return e.error(`Expected first argument to be of type boolean, string, number or null, but found ${St(r.type)} instead`);
                if (4 === t.length) {
                    const i = e.parse(t[3], 3, pt);
                    return i ? new We(r, n, i) : null;
                }
                return new We(r, n);
            }
            evaluate(t) {
                const e = this.needle.evaluate(t), r = this.haystack.evaluate(t);
                if (!Mt(e, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new ue(`Expected first argument to be of type boolean, string, number or null, but found ${St(se(e))} instead.`);
                if (!Mt(r, [
                    "string",
                    "array"
                ])) throw new ue(`Expected second argument to be of type array or string, but found ${St(se(r))} instead.`);
                if (this.fromIndex) {
                    const n = this.fromIndex.evaluate(t);
                    return r.indexOf(e, n);
                }
                return r.indexOf(e);
            }
            eachChild(t) {
                t(this.needle), t(this.haystack), this.fromIndex && t(this.fromIndex);
            }
            outputDefined() {
                return !1;
            }
        }
        class Qe {
            constructor(t, e, r, n, i, a){
                this.inputType = t, this.type = e, this.input = r, this.cases = n, this.outputs = i, this.otherwise = a;
            }
            static parse(t, e) {
                if (t.length < 5) return e.error(`Expected at least 4 arguments, but found only ${t.length - 1}.`);
                if (t.length % 2 != 1) return e.error("Expected an even number of arguments.");
                let r, n;
                e.expectedType && "value" !== e.expectedType.kind && (n = e.expectedType);
                const i = {}, a = [];
                for(let s = 2; s < t.length - 1; s += 2){
                    let o = t[s];
                    const l = t[s + 1];
                    Array.isArray(o) || (o = [
                        o
                    ]);
                    const u = e.concat(s);
                    if (0 === o.length) return u.error("Expected at least one branch label.");
                    for (const t of o){
                        if ("number" != typeof t && "string" != typeof t) return u.error("Branch labels must be numbers or strings.");
                        if ("number" == typeof t && Math.abs(t) > Number.MAX_SAFE_INTEGER) return u.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                        if ("number" == typeof t && Math.floor(t) !== t) return u.error("Numeric branch labels must be integer values.");
                        if (r) {
                            if (u.checkSubtype(r, se(t))) return null;
                        } else r = se(t);
                        if (void 0 !== i[String(t)]) return u.error("Branch labels must be unique.");
                        i[String(t)] = a.length;
                    }
                    const c = e.parse(l, s, n);
                    if (!c) return null;
                    n = n || c.type, a.push(c);
                }
                const s = e.parse(t[1], 1, gt);
                if (!s) return null;
                const o = e.parse(t[t.length - 1], t.length - 1, n);
                return o ? "value" !== s.type.kind && e.concat(1).checkSubtype(r, s.type) ? null : new Qe(r, n, s, i, a, o) : null;
            }
            evaluate(t) {
                const e = this.input.evaluate(t);
                return (se(e) === this.inputType && this.outputs[this.cases[e]] || this.otherwise).evaluate(t);
            }
            eachChild(t) {
                t(this.input), this.outputs.forEach(t), t(this.otherwise);
            }
            outputDefined() {
                return this.outputs.every((t)=>t.outputDefined()) && this.otherwise.outputDefined();
            }
        }
        class tr {
            constructor(t, e, r){
                this.type = t, this.branches = e, this.otherwise = r;
            }
            static parse(t, e) {
                if (t.length < 4) return e.error(`Expected at least 3 arguments, but found only ${t.length - 1}.`);
                if (t.length % 2 != 0) return e.error("Expected an odd number of arguments.");
                let r;
                e.expectedType && "value" !== e.expectedType.kind && (r = e.expectedType);
                const n = [];
                for(let i = 1; i < t.length - 1; i += 2){
                    const a = e.parse(t[i], i, dt);
                    if (!a) return null;
                    const s = e.parse(t[i + 1], i + 1, r);
                    if (!s) return null;
                    n.push([
                        a,
                        s
                    ]), r = r || s.type;
                }
                const i = e.parse(t[t.length - 1], t.length - 1, r);
                if (!i) return null;
                if (!r) throw new Error("Can't infer output type");
                return new tr(r, n, i);
            }
            evaluate(t) {
                for (const [e, r] of this.branches)if (e.evaluate(t)) return r.evaluate(t);
                return this.otherwise.evaluate(t);
            }
            eachChild(t) {
                for (const [e, r] of this.branches)t(e), t(r);
                t(this.otherwise);
            }
            outputDefined() {
                return this.branches.every(([t, e])=>e.outputDefined()) && this.otherwise.outputDefined();
            }
        }
        class er {
            constructor(t, e, r, n){
                this.type = t, this.input = e, this.beginIndex = r, this.endIndex = n;
            }
            static parse(t, e) {
                if (t.length <= 2 || t.length >= 5) return e.error(`Expected 3 or 4 arguments, but found ${t.length - 1} instead.`);
                const r = e.parse(t[1], 1, gt), n = e.parse(t[2], 2, pt);
                if (!r || !n) return null;
                if (!zt(r.type, [
                    At(gt),
                    ft,
                    gt
                ])) return e.error(`Expected first argument to be of type array or string, but found ${St(r.type)} instead`);
                if (4 === t.length) {
                    const i = e.parse(t[3], 3, pt);
                    return i ? new er(r.type, r, n, i) : null;
                }
                return new er(r.type, r, n);
            }
            evaluate(t) {
                const e = this.input.evaluate(t), r = this.beginIndex.evaluate(t);
                if (!Mt(e, [
                    "string",
                    "array"
                ])) throw new ue(`Expected first argument to be of type array or string, but found ${St(se(e))} instead.`);
                if (this.endIndex) {
                    const n = this.endIndex.evaluate(t);
                    return e.slice(r, n);
                }
                return e.slice(r);
            }
            eachChild(t) {
                t(this.input), t(this.beginIndex), this.endIndex && t(this.endIndex);
            }
            outputDefined() {
                return !1;
            }
        }
        function rr(t, e) {
            return "==" === t || "!=" === t ? "boolean" === e.kind || "string" === e.kind || "number" === e.kind || "null" === e.kind || "value" === e.kind : "string" === e.kind || "number" === e.kind || "value" === e.kind;
        }
        function nr(t, e, r, n) {
            return 0 === n.compare(e, r);
        }
        function ir(t, e, r) {
            const n = "==" !== t && "!=" !== t;
            return class i {
                constructor(t, e, r){
                    this.type = dt, this.lhs = t, this.rhs = e, this.collator = r, this.hasUntypedArgument = "value" === t.type.kind || "value" === e.type.kind;
                }
                static parse(t, e) {
                    if (3 !== t.length && 4 !== t.length) return e.error("Expected two or three arguments.");
                    const r = t[0];
                    let a = e.parse(t[1], 1, gt);
                    if (!a) return null;
                    if (!rr(r, a.type)) return e.concat(1).error(`"${r}" comparisons are not supported for type '${St(a.type)}'.`);
                    let s = e.parse(t[2], 2, gt);
                    if (!s) return null;
                    if (!rr(r, s.type)) return e.concat(2).error(`"${r}" comparisons are not supported for type '${St(s.type)}'.`);
                    if (a.type.kind !== s.type.kind && "value" !== a.type.kind && "value" !== s.type.kind) return e.error(`Cannot compare types '${St(a.type)}' and '${St(s.type)}'.`);
                    n && ("value" === a.type.kind && "value" !== s.type.kind ? a = new he(s.type, [
                        a
                    ]) : "value" !== a.type.kind && "value" === s.type.kind && (s = new he(a.type, [
                        s
                    ])));
                    let o = null;
                    if (4 === t.length) {
                        if ("string" !== a.type.kind && "string" !== s.type.kind && "value" !== a.type.kind && "value" !== s.type.kind) return e.error("Cannot use collator to compare non-string types.");
                        if (o = e.parse(t[3], 3, xt), !o) return null;
                    }
                    return new i(a, s, o);
                }
                evaluate(i) {
                    const a = this.lhs.evaluate(i), s = this.rhs.evaluate(i);
                    if (n && this.hasUntypedArgument) {
                        const e = se(a), r = se(s);
                        if (e.kind !== r.kind || "string" !== e.kind && "number" !== e.kind) throw new ue(`Expected arguments for "${t}" to be (string, string) or (number, number), but found (${e.kind}, ${r.kind}) instead.`);
                    }
                    if (this.collator && !n && this.hasUntypedArgument) {
                        const t = se(a), r = se(s);
                        if ("string" !== t.kind || "string" !== r.kind) return e(i, a, s);
                    }
                    return this.collator ? r(i, a, s, this.collator.evaluate(i)) : e(i, a, s);
                }
                eachChild(t) {
                    t(this.lhs), t(this.rhs), this.collator && t(this.collator);
                }
                outputDefined() {
                    return !0;
                }
            };
        }
        const ar = ir("==", function(t, e, r) {
            return e === r;
        }, nr), sr = ir("!=", function(t, e, r) {
            return e !== r;
        }, function(t, e, r, n) {
            return !nr(0, e, r, n);
        }), or = ir("<", function(t, e, r) {
            return e < r;
        }, function(t, e, r, n) {
            return n.compare(e, r) < 0;
        }), lr = ir(">", function(t, e, r) {
            return e > r;
        }, function(t, e, r, n) {
            return n.compare(e, r) > 0;
        }), ur = ir("<=", function(t, e, r) {
            return e <= r;
        }, function(t, e, r, n) {
            return n.compare(e, r) <= 0;
        }), cr = ir(">=", function(t, e, r) {
            return e >= r;
        }, function(t, e, r, n) {
            return n.compare(e, r) >= 0;
        });
        class hr {
            constructor(t, e, r, n, i){
                this.type = ft, this.number = t, this.locale = e, this.currency = r, this.minFractionDigits = n, this.maxFractionDigits = i;
            }
            static parse(t, e) {
                if (3 !== t.length) return e.error("Expected two arguments.");
                const r = e.parse(t[1], 1, pt);
                if (!r) return null;
                const n = t[2];
                if ("object" != typeof n || Array.isArray(n)) return e.error("NumberFormat options argument must be an object.");
                let i = null;
                if (n.locale && (i = e.parse(n.locale, 1, ft), !i)) return null;
                let a = null;
                if (n.currency && (a = e.parse(n.currency, 1, ft), !a)) return null;
                let s = null;
                if (n["min-fraction-digits"] && (s = e.parse(n["min-fraction-digits"], 1, pt), !s)) return null;
                let o = null;
                return n["max-fraction-digits"] && (o = e.parse(n["max-fraction-digits"], 1, pt), !o) ? null : new hr(r, i, a, s, o);
            }
            evaluate(t) {
                return new Intl.NumberFormat(this.locale ? this.locale.evaluate(t) : [], {
                    style: this.currency ? "currency" : "decimal",
                    currency: this.currency ? this.currency.evaluate(t) : void 0,
                    minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(t) : void 0,
                    maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(t) : void 0
                }).format(this.number.evaluate(t));
            }
            eachChild(t) {
                t(this.number), this.locale && t(this.locale), this.currency && t(this.currency), this.minFractionDigits && t(this.minFractionDigits), this.maxFractionDigits && t(this.maxFractionDigits);
            }
            outputDefined() {
                return !1;
            }
        }
        class pr {
            constructor(t){
                this.type = vt, this.sections = t;
            }
            static parse(t, e) {
                if (t.length < 2) return e.error("Expected at least one argument.");
                const r = t[1];
                if (!Array.isArray(r) && "object" == typeof r) return e.error("First argument must be an image or text section.");
                const n = [];
                let i = !1;
                for(let r = 1; r <= t.length - 1; ++r){
                    const a = t[r];
                    if (i && "object" == typeof a && !Array.isArray(a)) {
                        i = !1;
                        let t = null;
                        if (a["font-scale"] && (t = e.parse(a["font-scale"], 1, pt), !t)) return null;
                        let r = null;
                        if (a["text-font"] && (r = e.parse(a["text-font"], 1, At(ft)), !r)) return null;
                        let s = null;
                        if (a["text-color"] && (s = e.parse(a["text-color"], 1, yt), !s)) return null;
                        const o = n[n.length - 1];
                        o.scale = t, o.font = r, o.textColor = s;
                    } else {
                        const a = e.parse(t[r], 1, gt);
                        if (!a) return null;
                        const s = a.type.kind;
                        if ("string" !== s && "value" !== s && "null" !== s && "resolvedImage" !== s) return e.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                        i = !0, n.push({
                            content: a,
                            scale: null,
                            font: null,
                            textColor: null
                        });
                    }
                }
                return new pr(n);
            }
            evaluate(t) {
                return new Qt(this.sections.map((e)=>{
                    const r = e.content.evaluate(t);
                    return se(r) === wt ? new Wt("", r, null, null, null) : new Wt(oe(r), null, e.scale ? e.scale.evaluate(t) : null, e.font ? e.font.evaluate(t).join(",") : null, e.textColor ? e.textColor.evaluate(t) : null);
                }));
            }
            eachChild(t) {
                for (const e of this.sections)t(e.content), e.scale && t(e.scale), e.font && t(e.font), e.textColor && t(e.textColor);
            }
            outputDefined() {
                return !1;
            }
        }
        class fr {
            constructor(t){
                this.type = wt, this.input = t;
            }
            static parse(t, e) {
                if (2 !== t.length) return e.error("Expected two arguments.");
                const r = e.parse(t[1], 1, ft);
                return r ? new fr(r) : e.error("No image name provided.");
            }
            evaluate(t) {
                const e = this.input.evaluate(t), r = ne.fromString(e);
                return r && t.availableImages && (r.available = t.availableImages.indexOf(e) > -1), r;
            }
            eachChild(t) {
                t(this.input);
            }
            outputDefined() {
                return !1;
            }
        }
        class dr {
            constructor(t){
                this.type = pt, this.input = t;
            }
            static parse(t, e) {
                if (2 !== t.length) return e.error(`Expected 1 argument, but found ${t.length - 1} instead.`);
                const r = e.parse(t[1], 1);
                return r ? "array" !== r.type.kind && "string" !== r.type.kind && "value" !== r.type.kind ? e.error(`Expected argument of type string or array, but found ${St(r.type)} instead.`) : new dr(r) : null;
            }
            evaluate(t) {
                const e = this.input.evaluate(t);
                if ("string" == typeof e) return e.length;
                if (Array.isArray(e)) return e.length;
                throw new ue(`Expected value to be of type string or array, but found ${St(se(e))} instead.`);
            }
            eachChild(t) {
                t(this.input);
            }
            outputDefined() {
                return !1;
            }
        }
        const yr = {
            "==": ar,
            "!=": sr,
            ">": lr,
            "<": or,
            ">=": cr,
            "<=": ur,
            array: he,
            at: Ye,
            boolean: he,
            case: tr,
            coalesce: Je,
            collator: ge,
            format: pr,
            image: fr,
            in: He,
            "index-of": We,
            interpolate: Ke,
            "interpolate-hcl": Ke,
            "interpolate-lab": Ke,
            length: dr,
            let: Xe,
            literal: le,
            match: Qe,
            number: he,
            "number-format": hr,
            object: he,
            slice: er,
            step: qe,
            string: he,
            "to-boolean": fe,
            "to-color": fe,
            "to-number": fe,
            "to-string": fe,
            var: Te,
            within: Fe
        };
        function mr(t, [e, r, n, i]) {
            e = e.evaluate(t), r = r.evaluate(t), n = n.evaluate(t);
            const a = i ? i.evaluate(t) : 1, s = ie(e, r, n, a);
            if (s) throw new ue(s);
            return new Yt(e / 255, r / 255, n / 255, a, !1);
        }
        function gr(t, e) {
            return t in e;
        }
        function xr(t, e) {
            const r = e[t];
            return void 0 === r ? null : r;
        }
        function vr(t) {
            return {
                type: t
            };
        }
        function br(t) {
            return {
                result: "success",
                value: t
            };
        }
        function wr(t) {
            return {
                result: "error",
                value: t
            };
        }
        function _r(t) {
            return "data-driven" === t["property-type"] || "cross-faded-data-driven" === t["property-type"];
        }
        function Ar(t) {
            return !!t.expression && t.expression.parameters.indexOf("zoom") > -1;
        }
        function Sr(t) {
            return !!t.expression && t.expression.interpolated;
        }
        function kr(t) {
            return t instanceof Number ? "number" : t instanceof String ? "string" : t instanceof Boolean ? "boolean" : Array.isArray(t) ? "array" : null === t ? "null" : typeof t;
        }
        function Ir(t) {
            return "object" == typeof t && null !== t && !Array.isArray(t);
        }
        function zr(t) {
            return t;
        }
        function Mr(t, e) {
            const r = "color" === e.type, n = t.stops && "object" == typeof t.stops[0][0], i = n || !(n || void 0 !== t.property), a = t.type || (Sr(e) ? "exponential" : "interval");
            if (r || "padding" === e.type) {
                const n = r ? Yt.parse : te.parse;
                (t = lt({}, t)).stops && (t.stops = t.stops.map((t)=>[
                        t[0],
                        n(t[1])
                    ])), t.default = n(t.default ? t.default : e.default);
            }
            if (t.colorSpace && "rgb" !== (s = t.colorSpace) && "hcl" !== s && "lab" !== s) throw new Error(`Unknown color space: "${t.colorSpace}"`);
            var s;
            let o, l, u;
            if ("exponential" === a) o = Vr;
            else if ("interval" === a) o = Pr;
            else if ("categorical" === a) {
                o = Br, l = Object.create(null);
                for (const e of t.stops)l[e[0]] = e[1];
                u = typeof t.stops[0][0];
            } else {
                if ("identity" !== a) throw new Error(`Unknown function type "${a}"`);
                o = Er;
            }
            if (n) {
                const r = {}, n = [];
                for(let e = 0; e < t.stops.length; e++){
                    const i = t.stops[e], a = i[0].zoom;
                    void 0 === r[a] && (r[a] = {
                        zoom: a,
                        type: t.type,
                        property: t.property,
                        default: t.default,
                        stops: []
                    }, n.push(a)), r[a].stops.push([
                        i[0].value,
                        i[1]
                    ]);
                }
                const i = [];
                for (const t of n)i.push([
                    r[t].zoom,
                    Mr(r[t], e)
                ]);
                const a = {
                    name: "linear"
                };
                return {
                    kind: "composite",
                    interpolationType: a,
                    interpolationFactor: Ke.interpolationFactor.bind(void 0, a),
                    zoomStops: i.map((t)=>t[0]),
                    evaluate: ({ zoom: r }, n)=>Vr({
                            stops: i,
                            base: t.base
                        }, e, r).evaluate(r, n)
                };
            }
            if (i) {
                const r = "exponential" === a ? {
                    name: "exponential",
                    base: void 0 !== t.base ? t.base : 1
                } : null;
                return {
                    kind: "camera",
                    interpolationType: r,
                    interpolationFactor: Ke.interpolationFactor.bind(void 0, r),
                    zoomStops: t.stops.map((t)=>t[0]),
                    evaluate: ({ zoom: r })=>o(t, e, r, l, u)
                };
            }
            return {
                kind: "source",
                evaluate (r, n) {
                    const i = n && n.properties ? n.properties[t.property] : void 0;
                    return void 0 === i ? Cr(t.default, e.default) : o(t, e, i, l, u);
                }
            };
        }
        function Cr(t, e, r) {
            return void 0 !== t ? t : void 0 !== e ? e : void 0 !== r ? r : void 0;
        }
        function Br(t, e, r, n, i) {
            return Cr(typeof r === i ? n[r] : void 0, t.default, e.default);
        }
        function Pr(t, e, r) {
            if ("number" !== kr(r)) return Cr(t.default, e.default);
            const n = t.stops.length;
            if (1 === n) return t.stops[0][1];
            if (r <= t.stops[0][0]) return t.stops[0][1];
            if (r >= t.stops[n - 1][0]) return t.stops[n - 1][1];
            const i = Re(t.stops.map((t)=>t[0]), r);
            return t.stops[i][1];
        }
        function Vr(t, e, r) {
            const n = void 0 !== t.base ? t.base : 1;
            if ("number" !== kr(r)) return Cr(t.default, e.default);
            const i = t.stops.length;
            if (1 === i) return t.stops[0][1];
            if (r <= t.stops[0][0]) return t.stops[0][1];
            if (r >= t.stops[i - 1][0]) return t.stops[i - 1][1];
            const a = Re(t.stops.map((t)=>t[0]), r), s = function(t, e, r, n) {
                const i = n - r, a = t - r;
                return 0 === i ? 0 : 1 === e ? a / i : (Math.pow(e, a) - 1) / (Math.pow(e, i) - 1);
            }(r, n, t.stops[a][0], t.stops[a + 1][0]), o = t.stops[a][1], l = t.stops[a + 1][1], u = Ze[e.type] || zr;
            return "function" == typeof o.evaluate ? {
                evaluate (...e) {
                    const r = o.evaluate.apply(void 0, e), n = l.evaluate.apply(void 0, e);
                    if (void 0 !== r && void 0 !== n) return u(r, n, s, t.colorSpace);
                }
            } : u(o, l, s, t.colorSpace);
        }
        function Er(t, e, r) {
            switch(e.type){
                case "color":
                    r = Yt.parse(r);
                    break;
                case "formatted":
                    r = Qt.fromString(r.toString());
                    break;
                case "resolvedImage":
                    r = ne.fromString(r.toString());
                    break;
                case "padding":
                    r = te.parse(r);
                    break;
                default:
                    kr(r) === e.type || "enum" === e.type && e.values[r] || (r = void 0);
            }
            return Cr(r, t.default, e.default);
        }
        $e.register(yr, {
            error: [
                {
                    kind: "error"
                },
                [
                    ft
                ],
                (t, [e])=>{
                    throw new ue(e.evaluate(t));
                }
            ],
            typeof: [
                ft,
                [
                    gt
                ],
                (t, [e])=>St(se(e.evaluate(t)))
            ],
            "to-rgba": [
                At(pt, 4),
                [
                    yt
                ],
                (t, [e])=>{
                    const [r, n, i, a] = e.evaluate(t).rgb;
                    return [
                        255 * r,
                        255 * n,
                        255 * i,
                        a
                    ];
                }
            ],
            rgb: [
                yt,
                [
                    pt,
                    pt,
                    pt
                ],
                mr
            ],
            rgba: [
                yt,
                [
                    pt,
                    pt,
                    pt,
                    pt
                ],
                mr
            ],
            has: {
                type: dt,
                overloads: [
                    [
                        [
                            ft
                        ],
                        (t, [e])=>gr(e.evaluate(t), t.properties())
                    ],
                    [
                        [
                            ft,
                            mt
                        ],
                        (t, [e, r])=>gr(e.evaluate(t), r.evaluate(t))
                    ]
                ]
            },
            get: {
                type: gt,
                overloads: [
                    [
                        [
                            ft
                        ],
                        (t, [e])=>xr(e.evaluate(t), t.properties())
                    ],
                    [
                        [
                            ft,
                            mt
                        ],
                        (t, [e, r])=>xr(e.evaluate(t), r.evaluate(t))
                    ]
                ]
            },
            "feature-state": [
                gt,
                [
                    ft
                ],
                (t, [e])=>xr(e.evaluate(t), t.featureState || {})
            ],
            properties: [
                mt,
                [],
                (t)=>t.properties()
            ],
            "geometry-type": [
                ft,
                [],
                (t)=>t.geometryType()
            ],
            id: [
                gt,
                [],
                (t)=>t.id()
            ],
            zoom: [
                pt,
                [],
                (t)=>t.globals.zoom
            ],
            "heatmap-density": [
                pt,
                [],
                (t)=>t.globals.heatmapDensity || 0
            ],
            "line-progress": [
                pt,
                [],
                (t)=>t.globals.lineProgress || 0
            ],
            accumulated: [
                gt,
                [],
                (t)=>void 0 === t.globals.accumulated ? null : t.globals.accumulated
            ],
            "+": [
                pt,
                vr(pt),
                (t, e)=>{
                    let r = 0;
                    for (const n of e)r += n.evaluate(t);
                    return r;
                }
            ],
            "*": [
                pt,
                vr(pt),
                (t, e)=>{
                    let r = 1;
                    for (const n of e)r *= n.evaluate(t);
                    return r;
                }
            ],
            "-": {
                type: pt,
                overloads: [
                    [
                        [
                            pt,
                            pt
                        ],
                        (t, [e, r])=>e.evaluate(t) - r.evaluate(t)
                    ],
                    [
                        [
                            pt
                        ],
                        (t, [e])=>-e.evaluate(t)
                    ]
                ]
            },
            "/": [
                pt,
                [
                    pt,
                    pt
                ],
                (t, [e, r])=>e.evaluate(t) / r.evaluate(t)
            ],
            "%": [
                pt,
                [
                    pt,
                    pt
                ],
                (t, [e, r])=>e.evaluate(t) % r.evaluate(t)
            ],
            ln2: [
                pt,
                [],
                ()=>Math.LN2
            ],
            pi: [
                pt,
                [],
                ()=>Math.PI
            ],
            e: [
                pt,
                [],
                ()=>Math.E
            ],
            "^": [
                pt,
                [
                    pt,
                    pt
                ],
                (t, [e, r])=>Math.pow(e.evaluate(t), r.evaluate(t))
            ],
            sqrt: [
                pt,
                [
                    pt
                ],
                (t, [e])=>Math.sqrt(e.evaluate(t))
            ],
            log10: [
                pt,
                [
                    pt
                ],
                (t, [e])=>Math.log(e.evaluate(t)) / Math.LN10
            ],
            ln: [
                pt,
                [
                    pt
                ],
                (t, [e])=>Math.log(e.evaluate(t))
            ],
            log2: [
                pt,
                [
                    pt
                ],
                (t, [e])=>Math.log(e.evaluate(t)) / Math.LN2
            ],
            sin: [
                pt,
                [
                    pt
                ],
                (t, [e])=>Math.sin(e.evaluate(t))
            ],
            cos: [
                pt,
                [
                    pt
                ],
                (t, [e])=>Math.cos(e.evaluate(t))
            ],
            tan: [
                pt,
                [
                    pt
                ],
                (t, [e])=>Math.tan(e.evaluate(t))
            ],
            asin: [
                pt,
                [
                    pt
                ],
                (t, [e])=>Math.asin(e.evaluate(t))
            ],
            acos: [
                pt,
                [
                    pt
                ],
                (t, [e])=>Math.acos(e.evaluate(t))
            ],
            atan: [
                pt,
                [
                    pt
                ],
                (t, [e])=>Math.atan(e.evaluate(t))
            ],
            min: [
                pt,
                vr(pt),
                (t, e)=>Math.min(...e.map((e)=>e.evaluate(t)))
            ],
            max: [
                pt,
                vr(pt),
                (t, e)=>Math.max(...e.map((e)=>e.evaluate(t)))
            ],
            abs: [
                pt,
                [
                    pt
                ],
                (t, [e])=>Math.abs(e.evaluate(t))
            ],
            round: [
                pt,
                [
                    pt
                ],
                (t, [e])=>{
                    const r = e.evaluate(t);
                    return r < 0 ? -Math.round(-r) : Math.round(r);
                }
            ],
            floor: [
                pt,
                [
                    pt
                ],
                (t, [e])=>Math.floor(e.evaluate(t))
            ],
            ceil: [
                pt,
                [
                    pt
                ],
                (t, [e])=>Math.ceil(e.evaluate(t))
            ],
            "filter-==": [
                dt,
                [
                    ft,
                    gt
                ],
                (t, [e, r])=>t.properties()[e.value] === r.value
            ],
            "filter-id-==": [
                dt,
                [
                    gt
                ],
                (t, [e])=>t.id() === e.value
            ],
            "filter-type-==": [
                dt,
                [
                    ft
                ],
                (t, [e])=>t.geometryType() === e.value
            ],
            "filter-<": [
                dt,
                [
                    ft,
                    gt
                ],
                (t, [e, r])=>{
                    const n = t.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n < i;
                }
            ],
            "filter-id-<": [
                dt,
                [
                    gt
                ],
                (t, [e])=>{
                    const r = t.id(), n = e.value;
                    return typeof r == typeof n && r < n;
                }
            ],
            "filter->": [
                dt,
                [
                    ft,
                    gt
                ],
                (t, [e, r])=>{
                    const n = t.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n > i;
                }
            ],
            "filter-id->": [
                dt,
                [
                    gt
                ],
                (t, [e])=>{
                    const r = t.id(), n = e.value;
                    return typeof r == typeof n && r > n;
                }
            ],
            "filter-<=": [
                dt,
                [
                    ft,
                    gt
                ],
                (t, [e, r])=>{
                    const n = t.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n <= i;
                }
            ],
            "filter-id-<=": [
                dt,
                [
                    gt
                ],
                (t, [e])=>{
                    const r = t.id(), n = e.value;
                    return typeof r == typeof n && r <= n;
                }
            ],
            "filter->=": [
                dt,
                [
                    ft,
                    gt
                ],
                (t, [e, r])=>{
                    const n = t.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n >= i;
                }
            ],
            "filter-id->=": [
                dt,
                [
                    gt
                ],
                (t, [e])=>{
                    const r = t.id(), n = e.value;
                    return typeof r == typeof n && r >= n;
                }
            ],
            "filter-has": [
                dt,
                [
                    gt
                ],
                (t, [e])=>e.value in t.properties()
            ],
            "filter-has-id": [
                dt,
                [],
                (t)=>null !== t.id() && void 0 !== t.id()
            ],
            "filter-type-in": [
                dt,
                [
                    At(ft)
                ],
                (t, [e])=>e.value.indexOf(t.geometryType()) >= 0
            ],
            "filter-id-in": [
                dt,
                [
                    At(gt)
                ],
                (t, [e])=>e.value.indexOf(t.id()) >= 0
            ],
            "filter-in-small": [
                dt,
                [
                    ft,
                    At(gt)
                ],
                (t, [e, r])=>r.value.indexOf(t.properties()[e.value]) >= 0
            ],
            "filter-in-large": [
                dt,
                [
                    ft,
                    At(gt)
                ],
                (t, [e, r])=>(function(t, e, r, n) {
                        for(; r <= n;){
                            const i = r + n >> 1;
                            if (e[i] === t) return !0;
                            e[i] > t ? n = i - 1 : r = i + 1;
                        }
                        return !1;
                    })(t.properties()[e.value], r.value, 0, r.value.length - 1)
            ],
            all: {
                type: dt,
                overloads: [
                    [
                        [
                            dt,
                            dt
                        ],
                        (t, [e, r])=>e.evaluate(t) && r.evaluate(t)
                    ],
                    [
                        vr(dt),
                        (t, e)=>{
                            for (const r of e)if (!r.evaluate(t)) return !1;
                            return !0;
                        }
                    ]
                ]
            },
            any: {
                type: dt,
                overloads: [
                    [
                        [
                            dt,
                            dt
                        ],
                        (t, [e, r])=>e.evaluate(t) || r.evaluate(t)
                    ],
                    [
                        vr(dt),
                        (t, e)=>{
                            for (const r of e)if (r.evaluate(t)) return !0;
                            return !1;
                        }
                    ]
                ]
            },
            "!": [
                dt,
                [
                    dt
                ],
                (t, [e])=>!e.evaluate(t)
            ],
            "is-supported-script": [
                dt,
                [
                    ft
                ],
                (t, [e])=>{
                    const r = t.globals && t.globals.isSupportedScript;
                    return !r || r(e.evaluate(t));
                }
            ],
            upcase: [
                ft,
                [
                    ft
                ],
                (t, [e])=>e.evaluate(t).toUpperCase()
            ],
            downcase: [
                ft,
                [
                    ft
                ],
                (t, [e])=>e.evaluate(t).toLowerCase()
            ],
            concat: [
                ft,
                vr(gt),
                (t, e)=>e.map((e)=>oe(e.evaluate(t))).join("")
            ],
            "resolved-locale": [
                ft,
                [
                    xt
                ],
                (t, [e])=>e.evaluate(t).resolvedLocale()
            ]
        });
        class Fr {
            constructor(t, e){
                var r;
                this.expression = t, this._warningHistory = {}, this._evaluator = new ye, this._defaultValue = e ? "color" === (r = e).type && Ir(r.default) ? new Yt(0, 0, 0, 0) : "color" === r.type ? Yt.parse(r.default) || null : "padding" === r.type ? te.parse(r.default) || null : "variableAnchorOffsetCollection" === r.type ? re.parse(r.default) || null : void 0 === r.default ? null : r.default : null, this._enumValues = e && "enum" === e.type ? e.values : null;
            }
            evaluateWithoutErrorHandling(t, e, r, n, i, a) {
                return this._evaluator.globals = t, this._evaluator.feature = e, this._evaluator.featureState = r, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = a, this.expression.evaluate(this._evaluator);
            }
            evaluate(t, e, r, n, i, a) {
                this._evaluator.globals = t, this._evaluator.feature = e || null, this._evaluator.featureState = r || null, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = a || null;
                try {
                    const t = this.expression.evaluate(this._evaluator);
                    if (null == t || "number" == typeof t && t != t) return this._defaultValue;
                    if (this._enumValues && !(t in this._enumValues)) throw new ue(`Expected value to be one of ${Object.keys(this._enumValues).map((t)=>JSON.stringify(t)).join(", ")}, but found ${JSON.stringify(t)} instead.`);
                    return t;
                } catch (t) {
                    return this._warningHistory[t.message] || (this._warningHistory[t.message] = !0, "undefined" != typeof console && console.warn(t.message)), this._defaultValue;
                }
            }
        }
        function Tr(t) {
            return Array.isArray(t) && t.length > 0 && "string" == typeof t[0] && t[0] in yr;
        }
        function $r(t, e) {
            const r = new me(yr, Le, [], e ? function(t) {
                const e = {
                    color: yt,
                    string: ft,
                    number: pt,
                    enum: ft,
                    boolean: dt,
                    formatted: vt,
                    padding: bt,
                    resolvedImage: wt,
                    variableAnchorOffsetCollection: _t
                };
                return "array" === t.type ? At(e[t.value] || gt, t.length) : e[t.type];
            }(e) : void 0), n = r.parse(t, void 0, void 0, void 0, e && "string" === e.type ? {
                typeAnnotation: "coerce"
            } : void 0);
            return n ? br(new Fr(n, e)) : wr(r.errors);
        }
        class Lr {
            constructor(t, e){
                this.kind = t, this._styleExpression = e, this.isStateDependent = "constant" !== t && !Oe(e.expression);
            }
            evaluateWithoutErrorHandling(t, e, r, n, i, a) {
                return this._styleExpression.evaluateWithoutErrorHandling(t, e, r, n, i, a);
            }
            evaluate(t, e, r, n, i, a) {
                return this._styleExpression.evaluate(t, e, r, n, i, a);
            }
        }
        class Dr {
            constructor(t, e, r, n){
                this.kind = t, this.zoomStops = r, this._styleExpression = e, this.isStateDependent = "camera" !== t && !Oe(e.expression), this.interpolationType = n;
            }
            evaluateWithoutErrorHandling(t, e, r, n, i, a) {
                return this._styleExpression.evaluateWithoutErrorHandling(t, e, r, n, i, a);
            }
            evaluate(t, e, r, n, i, a) {
                return this._styleExpression.evaluate(t, e, r, n, i, a);
            }
            interpolationFactor(t, e, r) {
                return this.interpolationType ? Ke.interpolationFactor(this.interpolationType, t, e, r) : 0;
            }
        }
        function Or(t, e) {
            const r = $r(t, e);
            if ("error" === r.result) return r;
            const n = r.value.expression, i = De(n);
            if (!i && !_r(e)) return wr([
                new ut("", "data expressions not supported")
            ]);
            const a = Ue(n, [
                "zoom"
            ]);
            if (!a && !Ar(e)) return wr([
                new ut("", "zoom expressions not supported")
            ]);
            const s = Rr(n);
            return s || a ? s instanceof ut ? wr([
                s
            ]) : s instanceof Ke && !Sr(e) ? wr([
                new ut("", '"interpolate" expressions cannot be used with this property')
            ]) : br(s ? new Dr(i ? "camera" : "composite", r.value, s.labels, s instanceof Ke ? s.interpolation : void 0) : new Lr(i ? "constant" : "source", r.value)) : wr([
                new ut("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')
            ]);
        }
        class Ur {
            constructor(t, e){
                this._parameters = t, this._specification = e, lt(this, Mr(this._parameters, this._specification));
            }
            static deserialize(t) {
                return new Ur(t._parameters, t._specification);
            }
            static serialize(t) {
                return {
                    _parameters: t._parameters,
                    _specification: t._specification
                };
            }
        }
        function Rr(t) {
            let e = null;
            if (t instanceof Xe) e = Rr(t.result);
            else if (t instanceof Je) {
                for (const r of t.args)if (e = Rr(r), e) break;
            } else (t instanceof qe || t instanceof Ke) && t.input instanceof $e && "zoom" === t.input.name && (e = t);
            return e instanceof ut || t.eachChild((t)=>{
                const r = Rr(t);
                r instanceof ut ? e = r : !e && r ? e = new ut("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : e && r && e !== r && (e = new ut("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
            }), e;
        }
        function qr(t) {
            if (!0 === t || !1 === t) return !0;
            if (!Array.isArray(t) || 0 === t.length) return !1;
            switch(t[0]){
                case "has":
                    return t.length >= 2 && "$id" !== t[1] && "$type" !== t[1];
                case "in":
                    return t.length >= 3 && ("string" != typeof t[1] || Array.isArray(t[2]));
                case "!in":
                case "!has":
                case "none":
                    return !1;
                case "==":
                case "!=":
                case ">":
                case ">=":
                case "<":
                case "<=":
                    return 3 !== t.length || Array.isArray(t[1]) || Array.isArray(t[2]);
                case "any":
                case "all":
                    for (const e of t.slice(1))if (!qr(e) && "boolean" != typeof e) return !1;
                    return !0;
                default:
                    return !0;
            }
        }
        const jr = {
            type: "boolean",
            default: !1,
            transition: !1,
            "property-type": "data-driven",
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            }
        };
        function Nr(t) {
            if (null == t) return {
                filter: ()=>!0,
                needGeometry: !1
            };
            qr(t) || (t = Gr(t));
            const e = $r(t, jr);
            if ("error" === e.result) throw new Error(e.value.map((t)=>`${t.key}: ${t.message}`).join(", "));
            return {
                filter: (t, r, n)=>e.value.evaluate(t, r, {}, n),
                needGeometry: Kr(t)
            };
        }
        function Zr(t, e) {
            return t < e ? -1 : t > e ? 1 : 0;
        }
        function Kr(t) {
            if (!Array.isArray(t)) return !1;
            if ("within" === t[0]) return !0;
            for(let e = 1; e < t.length; e++)if (Kr(t[e])) return !0;
            return !1;
        }
        function Gr(t) {
            if (!t) return !0;
            const e = t[0];
            var r;
            return t.length <= 1 ? "any" !== e : "==" === e ? Jr(t[1], t[2], "==") : "!=" === e ? Hr(Jr(t[1], t[2], "==")) : "<" === e || ">" === e || "<=" === e || ">=" === e ? Jr(t[1], t[2], e) : "any" === e ? (r = t.slice(1), [
                "any"
            ].concat(r.map(Gr))) : "all" === e ? [
                "all"
            ].concat(t.slice(1).map(Gr)) : "none" === e ? [
                "all"
            ].concat(t.slice(1).map(Gr).map(Hr)) : "in" === e ? Xr(t[1], t.slice(2)) : "!in" === e ? Hr(Xr(t[1], t.slice(2))) : "has" === e ? Yr(t[1]) : "!has" === e ? Hr(Yr(t[1])) : "within" !== e || t;
        }
        function Jr(t, e, r) {
            switch(t){
                case "$type":
                    return [
                        `filter-type-${r}`,
                        e
                    ];
                case "$id":
                    return [
                        `filter-id-${r}`,
                        e
                    ];
                default:
                    return [
                        `filter-${r}`,
                        t,
                        e
                    ];
            }
        }
        function Xr(t, e) {
            if (0 === e.length) return !1;
            switch(t){
                case "$type":
                    return [
                        "filter-type-in",
                        [
                            "literal",
                            e
                        ]
                    ];
                case "$id":
                    return [
                        "filter-id-in",
                        [
                            "literal",
                            e
                        ]
                    ];
                default:
                    return e.length > 200 && !e.some((t)=>typeof t != typeof e[0]) ? [
                        "filter-in-large",
                        t,
                        [
                            "literal",
                            e.sort(Zr)
                        ]
                    ] : [
                        "filter-in-small",
                        t,
                        [
                            "literal",
                            e
                        ]
                    ];
            }
        }
        function Yr(t) {
            switch(t){
                case "$type":
                    return !0;
                case "$id":
                    return [
                        "filter-has-id"
                    ];
                default:
                    return [
                        "filter-has",
                        t
                    ];
            }
        }
        function Hr(t) {
            return [
                "!",
                t
            ];
        }
        function Wr(t) {
            const e = typeof t;
            if ("number" === e || "boolean" === e || "string" === e || null == t) return JSON.stringify(t);
            if (Array.isArray(t)) {
                let e = "[";
                for (const r of t)e += `${Wr(r)},`;
                return `${e}]`;
            }
            const r = Object.keys(t).sort();
            let n = "{";
            for(let e = 0; e < r.length; e++)n += `${JSON.stringify(r[e])}:${Wr(t[r[e]])},`;
            return `${n}}`;
        }
        function Qr(t) {
            let e = "";
            for (const r of Y)e += `/${Wr(t[r])}`;
            return e;
        }
        function tn(t) {
            const e = t.value;
            return e ? [
                new ot(t.key, e, "constants have been deprecated as of v8")
            ] : [];
        }
        function en(t) {
            return t instanceof Number || t instanceof String || t instanceof Boolean ? t.valueOf() : t;
        }
        function rn(t) {
            if (Array.isArray(t)) return t.map(rn);
            if (t instanceof Object && !(t instanceof Number || t instanceof String || t instanceof Boolean)) {
                const e = {};
                for(const r in t)e[r] = rn(t[r]);
                return e;
            }
            return en(t);
        }
        function nn(t) {
            const e = t.key, r = t.value, n = t.valueSpec || {}, i = t.objectElementValidators || {}, a = t.style, s = t.styleSpec, o = t.validateSpec;
            let l = [];
            const u = kr(r);
            if ("object" !== u) return [
                new ot(e, r, `object expected, ${u} found`)
            ];
            for(const t in r){
                const u = t.split(".")[0], c = n[u] || n["*"];
                let h;
                if (i[u]) h = i[u];
                else if (n[u]) h = o;
                else if (i["*"]) h = i["*"];
                else {
                    if (!n["*"]) {
                        l.push(new ot(e, r[t], `unknown property "${t}"`));
                        continue;
                    }
                    h = o;
                }
                l = l.concat(h({
                    key: (e ? `${e}.` : e) + t,
                    value: r[t],
                    valueSpec: c,
                    style: a,
                    styleSpec: s,
                    object: r,
                    objectKey: t,
                    validateSpec: o
                }, r));
            }
            for(const t in n)i[t] || n[t].required && void 0 === n[t].default && void 0 === r[t] && l.push(new ot(e, r, `missing required property "${t}"`));
            return l;
        }
        function an(t) {
            const e = t.value, r = t.valueSpec, n = t.style, i = t.styleSpec, a = t.key, s = t.arrayElementValidator || t.validateSpec;
            if ("array" !== kr(e)) return [
                new ot(a, e, `array expected, ${kr(e)} found`)
            ];
            if (r.length && e.length !== r.length) return [
                new ot(a, e, `array length ${r.length} expected, length ${e.length} found`)
            ];
            if (r["min-length"] && e.length < r["min-length"]) return [
                new ot(a, e, `array length at least ${r["min-length"]} expected, length ${e.length} found`)
            ];
            let o = {
                type: r.value,
                values: r.values
            };
            i.$version < 7 && (o.function = r.function), "object" === kr(r.value) && (o = r.value);
            let l = [];
            for(let r = 0; r < e.length; r++)l = l.concat(s({
                array: e,
                arrayIndex: r,
                value: e[r],
                valueSpec: o,
                validateSpec: t.validateSpec,
                style: n,
                styleSpec: i,
                key: `${a}[${r}]`
            }));
            return l;
        }
        function sn(t) {
            const e = t.key, r = t.value, n = t.valueSpec;
            let i = kr(r);
            return "number" === i && r != r && (i = "NaN"), "number" !== i ? [
                new ot(e, r, `number expected, ${i} found`)
            ] : "minimum" in n && r < n.minimum ? [
                new ot(e, r, `${r} is less than the minimum value ${n.minimum}`)
            ] : "maximum" in n && r > n.maximum ? [
                new ot(e, r, `${r} is greater than the maximum value ${n.maximum}`)
            ] : [];
        }
        function on(t) {
            const e = t.valueSpec, r = en(t.value.type);
            let n, i, a, s = {};
            const o = "categorical" !== r && void 0 === t.value.property, l = !o, u = "array" === kr(t.value.stops) && "array" === kr(t.value.stops[0]) && "object" === kr(t.value.stops[0][0]), c = nn({
                key: t.key,
                value: t.value,
                valueSpec: t.styleSpec.function,
                validateSpec: t.validateSpec,
                style: t.style,
                styleSpec: t.styleSpec,
                objectElementValidators: {
                    stops: function(t) {
                        if ("identity" === r) return [
                            new ot(t.key, t.value, 'identity function may not have a "stops" property')
                        ];
                        let e = [];
                        const n = t.value;
                        return e = e.concat(an({
                            key: t.key,
                            value: n,
                            valueSpec: t.valueSpec,
                            validateSpec: t.validateSpec,
                            style: t.style,
                            styleSpec: t.styleSpec,
                            arrayElementValidator: h
                        })), "array" === kr(n) && 0 === n.length && e.push(new ot(t.key, n, "array must have at least one stop")), e;
                    },
                    default: function(t) {
                        return t.validateSpec({
                            key: t.key,
                            value: t.value,
                            valueSpec: e,
                            validateSpec: t.validateSpec,
                            style: t.style,
                            styleSpec: t.styleSpec
                        });
                    }
                }
            });
            return "identity" === r && o && c.push(new ot(t.key, t.value, 'missing required property "property"')), "identity" === r || t.value.stops || c.push(new ot(t.key, t.value, 'missing required property "stops"')), "exponential" === r && t.valueSpec.expression && !Sr(t.valueSpec) && c.push(new ot(t.key, t.value, "exponential functions not supported")), t.styleSpec.$version >= 8 && (l && !_r(t.valueSpec) ? c.push(new ot(t.key, t.value, "property functions not supported")) : o && !Ar(t.valueSpec) && c.push(new ot(t.key, t.value, "zoom functions not supported"))), "categorical" !== r && !u || void 0 !== t.value.property || c.push(new ot(t.key, t.value, '"property" property is required')), c;
            function h(t) {
                let r = [];
                const n = t.value, o = t.key;
                if ("array" !== kr(n)) return [
                    new ot(o, n, `array expected, ${kr(n)} found`)
                ];
                if (2 !== n.length) return [
                    new ot(o, n, `array length 2 expected, length ${n.length} found`)
                ];
                if (u) {
                    if ("object" !== kr(n[0])) return [
                        new ot(o, n, `object expected, ${kr(n[0])} found`)
                    ];
                    if (void 0 === n[0].zoom) return [
                        new ot(o, n, "object stop key must have zoom")
                    ];
                    if (void 0 === n[0].value) return [
                        new ot(o, n, "object stop key must have value")
                    ];
                    if (a && a > en(n[0].zoom)) return [
                        new ot(o, n[0].zoom, "stop zoom values must appear in ascending order")
                    ];
                    en(n[0].zoom) !== a && (a = en(n[0].zoom), i = void 0, s = {}), r = r.concat(nn({
                        key: `${o}[0]`,
                        value: n[0],
                        valueSpec: {
                            zoom: {}
                        },
                        validateSpec: t.validateSpec,
                        style: t.style,
                        styleSpec: t.styleSpec,
                        objectElementValidators: {
                            zoom: sn,
                            value: p
                        }
                    }));
                } else r = r.concat(p({
                    key: `${o}[0]`,
                    value: n[0],
                    valueSpec: {},
                    validateSpec: t.validateSpec,
                    style: t.style,
                    styleSpec: t.styleSpec
                }, n));
                return Tr(rn(n[1])) ? r.concat([
                    new ot(`${o}[1]`, n[1], "expressions are not allowed in function stops.")
                ]) : r.concat(t.validateSpec({
                    key: `${o}[1]`,
                    value: n[1],
                    valueSpec: e,
                    validateSpec: t.validateSpec,
                    style: t.style,
                    styleSpec: t.styleSpec
                }));
            }
            function p(t, a) {
                const o = kr(t.value), l = en(t.value), u = null !== t.value ? t.value : a;
                if (n) {
                    if (o !== n) return [
                        new ot(t.key, u, `${o} stop domain type must match previous stop domain type ${n}`)
                    ];
                } else n = o;
                if ("number" !== o && "string" !== o && "boolean" !== o) return [
                    new ot(t.key, u, "stop domain value must be a number, string, or boolean")
                ];
                if ("number" !== o && "categorical" !== r) {
                    let n = `number expected, ${o} found`;
                    return _r(e) && void 0 === r && (n += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                        new ot(t.key, u, n)
                    ];
                }
                return "categorical" !== r || "number" !== o || isFinite(l) && Math.floor(l) === l ? "categorical" !== r && "number" === o && void 0 !== i && l < i ? [
                    new ot(t.key, u, "stop domain values must appear in ascending order")
                ] : (i = l, "categorical" === r && l in s ? [
                    new ot(t.key, u, "stop domain values must be unique")
                ] : (s[l] = !0, [])) : [
                    new ot(t.key, u, `integer expected, found ${l}`)
                ];
            }
        }
        function ln(t) {
            const e = ("property" === t.expressionContext ? Or : $r)(rn(t.value), t.valueSpec);
            if ("error" === e.result) return e.value.map((e)=>new ot(`${t.key}${e.key}`, t.value, e.message));
            const r = e.value.expression || e.value._styleExpression.expression;
            if ("property" === t.expressionContext && "text-font" === t.propertyKey && !r.outputDefined()) return [
                new ot(t.key, t.value, `Invalid data expression for "${t.propertyKey}". Output values must be contained as literals within the expression.`)
            ];
            if ("property" === t.expressionContext && "layout" === t.propertyType && !Oe(r)) return [
                new ot(t.key, t.value, '"feature-state" data expressions are not supported with layout properties.')
            ];
            if ("filter" === t.expressionContext && !Oe(r)) return [
                new ot(t.key, t.value, '"feature-state" data expressions are not supported with filters.')
            ];
            if (t.expressionContext && 0 === t.expressionContext.indexOf("cluster")) {
                if (!Ue(r, [
                    "zoom",
                    "feature-state"
                ])) return [
                    new ot(t.key, t.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                ];
                if ("cluster-initial" === t.expressionContext && !De(r)) return [
                    new ot(t.key, t.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                ];
            }
            return [];
        }
        function un(t) {
            const e = t.key, r = t.value, n = t.valueSpec, i = [];
            return Array.isArray(n.values) ? -1 === n.values.indexOf(en(r)) && i.push(new ot(e, r, `expected one of [${n.values.join(", ")}], ${JSON.stringify(r)} found`)) : -1 === Object.keys(n.values).indexOf(en(r)) && i.push(new ot(e, r, `expected one of [${Object.keys(n.values).join(", ")}], ${JSON.stringify(r)} found`)), i;
        }
        function cn(t) {
            return qr(rn(t.value)) ? ln(lt({}, t, {
                expressionContext: "filter",
                valueSpec: {
                    value: "boolean"
                }
            })) : hn(t);
        }
        function hn(t) {
            const e = t.value, r = t.key;
            if ("array" !== kr(e)) return [
                new ot(r, e, `array expected, ${kr(e)} found`)
            ];
            const n = t.styleSpec;
            let i, a = [];
            if (e.length < 1) return [
                new ot(r, e, "filter array must have at least 1 element")
            ];
            switch(a = a.concat(un({
                key: `${r}[0]`,
                value: e[0],
                valueSpec: n.filter_operator,
                style: t.style,
                styleSpec: t.styleSpec
            })), en(e[0])){
                case "<":
                case "<=":
                case ">":
                case ">=":
                    e.length >= 2 && "$type" === en(e[1]) && a.push(new ot(r, e, `"$type" cannot be use with operator "${e[0]}"`));
                case "==":
                case "!=":
                    3 !== e.length && a.push(new ot(r, e, `filter array for operator "${e[0]}" must have 3 elements`));
                case "in":
                case "!in":
                    e.length >= 2 && (i = kr(e[1]), "string" !== i && a.push(new ot(`${r}[1]`, e[1], `string expected, ${i} found`)));
                    for(let s = 2; s < e.length; s++)i = kr(e[s]), "$type" === en(e[1]) ? a = a.concat(un({
                        key: `${r}[${s}]`,
                        value: e[s],
                        valueSpec: n.geometry_type,
                        style: t.style,
                        styleSpec: t.styleSpec
                    })) : "string" !== i && "number" !== i && "boolean" !== i && a.push(new ot(`${r}[${s}]`, e[s], `string, number, or boolean expected, ${i} found`));
                    break;
                case "any":
                case "all":
                case "none":
                    for(let n = 1; n < e.length; n++)a = a.concat(hn({
                        key: `${r}[${n}]`,
                        value: e[n],
                        style: t.style,
                        styleSpec: t.styleSpec
                    }));
                    break;
                case "has":
                case "!has":
                    i = kr(e[1]), 2 !== e.length ? a.push(new ot(r, e, `filter array for "${e[0]}" operator must have 2 elements`)) : "string" !== i && a.push(new ot(`${r}[1]`, e[1], `string expected, ${i} found`));
                    break;
                case "within":
                    i = kr(e[1]), 2 !== e.length ? a.push(new ot(r, e, `filter array for "${e[0]}" operator must have 2 elements`)) : "object" !== i && a.push(new ot(`${r}[1]`, e[1], `object expected, ${i} found`));
            }
            return a;
        }
        function pn(t, e) {
            const r = t.key, n = t.validateSpec, i = t.style, a = t.styleSpec, s = t.value, o = t.objectKey, l = a[`${e}_${t.layerType}`];
            if (!l) return [];
            const u = o.match(/^(.*)-transition$/);
            if ("paint" === e && u && l[u[1]] && l[u[1]].transition) return n({
                key: r,
                value: s,
                valueSpec: a.transition,
                style: i,
                styleSpec: a
            });
            const c = t.valueSpec || l[o];
            if (!c) return [
                new ot(r, s, `unknown property "${o}"`)
            ];
            let h;
            if ("string" === kr(s) && _r(c) && !c.tokens && (h = /^{([^}]+)}$/.exec(s))) return [
                new ot(r, s, `"${o}" does not support interpolation syntax\nUse an identity property function instead: \`{ "type": "identity", "property": ${JSON.stringify(h[1])} }\`.`)
            ];
            const p = [];
            return "symbol" === t.layerType && ("text-field" === o && i && !i.glyphs && p.push(new ot(r, s, 'use of "text-field" requires a style "glyphs" property')), "text-font" === o && Ir(rn(s)) && "identity" === en(s.type) && p.push(new ot(r, s, '"text-font" does not support identity functions'))), p.concat(n({
                key: t.key,
                value: s,
                valueSpec: c,
                style: i,
                styleSpec: a,
                expressionContext: "property",
                propertyType: e,
                propertyKey: o
            }));
        }
        function fn(t) {
            return pn(t, "paint");
        }
        function dn(t) {
            return pn(t, "layout");
        }
        function yn(t) {
            let e = [];
            const r = t.value, n = t.key, i = t.style, a = t.styleSpec;
            r.type || r.ref || e.push(new ot(n, r, 'either "type" or "ref" is required'));
            let s = en(r.type);
            const o = en(r.ref);
            if (r.id) {
                const a = en(r.id);
                for(let s = 0; s < t.arrayIndex; s++){
                    const t = i.layers[s];
                    en(t.id) === a && e.push(new ot(n, r.id, `duplicate layer id "${r.id}", previously used at line ${t.id.__line__}`));
                }
            }
            if ("ref" in r) {
                let t;
                [
                    "type",
                    "source",
                    "source-layer",
                    "filter",
                    "layout"
                ].forEach((t)=>{
                    t in r && e.push(new ot(n, r[t], `"${t}" is prohibited for ref layers`));
                }), i.layers.forEach((e)=>{
                    en(e.id) === o && (t = e);
                }), t ? t.ref ? e.push(new ot(n, r.ref, "ref cannot reference another ref layer")) : s = en(t.type) : e.push(new ot(n, r.ref, `ref layer "${o}" not found`));
            } else if ("background" !== s) {
                if (r.source) {
                    const t = i.sources && i.sources[r.source], a = t && en(t.type);
                    t ? "vector" === a && "raster" === s ? e.push(new ot(n, r.source, `layer "${r.id}" requires a raster source`)) : "raster-dem" !== a && "hillshade" === s ? e.push(new ot(n, r.source, `layer "${r.id}" requires a raster-dem source`)) : "raster" === a && "raster" !== s ? e.push(new ot(n, r.source, `layer "${r.id}" requires a vector source`)) : "vector" !== a || r["source-layer"] ? "raster-dem" === a && "hillshade" !== s ? e.push(new ot(n, r.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "line" !== s || !r.paint || !r.paint["line-gradient"] || "geojson" === a && t.lineMetrics || e.push(new ot(n, r, `layer "${r.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : e.push(new ot(n, r, `layer "${r.id}" must specify a "source-layer"`)) : e.push(new ot(n, r.source, `source "${r.source}" not found`));
                } else e.push(new ot(n, r, 'missing required property "source"'));
            }
            return e = e.concat(nn({
                key: n,
                value: r,
                valueSpec: a.layer,
                style: t.style,
                styleSpec: t.styleSpec,
                validateSpec: t.validateSpec,
                objectElementValidators: {
                    "*": ()=>[],
                    type: ()=>t.validateSpec({
                            key: `${n}.type`,
                            value: r.type,
                            valueSpec: a.layer.type,
                            style: t.style,
                            styleSpec: t.styleSpec,
                            validateSpec: t.validateSpec,
                            object: r,
                            objectKey: "type"
                        }),
                    filter: cn,
                    layout: (t)=>nn({
                            layer: r,
                            key: t.key,
                            value: t.value,
                            style: t.style,
                            styleSpec: t.styleSpec,
                            validateSpec: t.validateSpec,
                            objectElementValidators: {
                                "*": (t)=>dn(lt({
                                        layerType: s
                                    }, t))
                            }
                        }),
                    paint: (t)=>nn({
                            layer: r,
                            key: t.key,
                            value: t.value,
                            style: t.style,
                            styleSpec: t.styleSpec,
                            validateSpec: t.validateSpec,
                            objectElementValidators: {
                                "*": (t)=>fn(lt({
                                        layerType: s
                                    }, t))
                            }
                        })
                }
            })), e;
        }
        function mn(t) {
            const e = t.value, r = t.key, n = kr(e);
            return "string" !== n ? [
                new ot(r, e, `string expected, ${n} found`)
            ] : [];
        }
        const gn = {
            promoteId: function({ key: t, value: e }) {
                if ("string" === kr(e)) return mn({
                    key: t,
                    value: e
                });
                {
                    const r = [];
                    for(const n in e)r.push(...mn({
                        key: `${t}.${n}`,
                        value: e[n]
                    }));
                    return r;
                }
            }
        };
        function xn(t) {
            const e = t.value, r = t.key, n = t.styleSpec, i = t.style, a = t.validateSpec;
            if (!e.type) return [
                new ot(r, e, '"type" is required')
            ];
            const s = en(e.type);
            let o;
            switch(s){
                case "vector":
                case "raster":
                    return o = nn({
                        key: r,
                        value: e,
                        valueSpec: n[`source_${s.replace("-", "_")}`],
                        style: t.style,
                        styleSpec: n,
                        objectElementValidators: gn,
                        validateSpec: a
                    }), o;
                case "raster-dem":
                    return o = function(t) {
                        var e;
                        const r = null !== (e = t.sourceName) && void 0 !== e ? e : "", n = t.value, i = t.styleSpec, a = i.source_raster_dem, s = t.style;
                        let o = [];
                        const l = kr(n);
                        if (void 0 === n) return o;
                        if ("object" !== l) return o.push(new ot("source_raster_dem", n, `object expected, ${l} found`)), o;
                        const u = "custom" === en(n.encoding), c = [
                            "redFactor",
                            "greenFactor",
                            "blueFactor",
                            "baseShift"
                        ], h = t.value.encoding ? `"${t.value.encoding}"` : "Default";
                        for(const e in n)!u && c.includes(e) ? o.push(new ot(e, n[e], `In "${r}": "${e}" is only valid when "encoding" is set to "custom". ${h} encoding found`)) : a[e] ? o = o.concat(t.validateSpec({
                            key: e,
                            value: n[e],
                            valueSpec: a[e],
                            validateSpec: t.validateSpec,
                            style: s,
                            styleSpec: i
                        })) : o.push(new ot(e, n[e], `unknown property "${e}"`));
                        return o;
                    }({
                        sourceName: r,
                        value: e,
                        style: t.style,
                        styleSpec: n,
                        validateSpec: a
                    }), o;
                case "geojson":
                    if (o = nn({
                        key: r,
                        value: e,
                        valueSpec: n.source_geojson,
                        style: i,
                        styleSpec: n,
                        validateSpec: a,
                        objectElementValidators: gn
                    }), e.cluster) for(const t in e.clusterProperties){
                        const [n, i] = e.clusterProperties[t], s = "string" == typeof n ? [
                            n,
                            [
                                "accumulated"
                            ],
                            [
                                "get",
                                t
                            ]
                        ] : n;
                        o.push(...ln({
                            key: `${r}.${t}.map`,
                            value: i,
                            validateSpec: a,
                            expressionContext: "cluster-map"
                        })), o.push(...ln({
                            key: `${r}.${t}.reduce`,
                            value: s,
                            validateSpec: a,
                            expressionContext: "cluster-reduce"
                        }));
                    }
                    return o;
                case "video":
                    return nn({
                        key: r,
                        value: e,
                        valueSpec: n.source_video,
                        style: i,
                        validateSpec: a,
                        styleSpec: n
                    });
                case "image":
                    return nn({
                        key: r,
                        value: e,
                        valueSpec: n.source_image,
                        style: i,
                        validateSpec: a,
                        styleSpec: n
                    });
                case "canvas":
                    return [
                        new ot(r, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                    ];
                default:
                    return un({
                        key: `${r}.type`,
                        value: e.type,
                        valueSpec: {
                            values: [
                                "vector",
                                "raster",
                                "raster-dem",
                                "geojson",
                                "video",
                                "image"
                            ]
                        },
                        style: i,
                        validateSpec: a,
                        styleSpec: n
                    });
            }
        }
        function vn(t) {
            const e = t.value, r = t.styleSpec, n = r.light, i = t.style;
            let a = [];
            const s = kr(e);
            if (void 0 === e) return a;
            if ("object" !== s) return a = a.concat([
                new ot("light", e, `object expected, ${s} found`)
            ]), a;
            for(const s in e){
                const o = s.match(/^(.*)-transition$/);
                a = a.concat(o && n[o[1]] && n[o[1]].transition ? t.validateSpec({
                    key: s,
                    value: e[s],
                    valueSpec: r.transition,
                    validateSpec: t.validateSpec,
                    style: i,
                    styleSpec: r
                }) : n[s] ? t.validateSpec({
                    key: s,
                    value: e[s],
                    valueSpec: n[s],
                    validateSpec: t.validateSpec,
                    style: i,
                    styleSpec: r
                }) : [
                    new ot(s, e[s], `unknown property "${s}"`)
                ]);
            }
            return a;
        }
        function bn(t) {
            const e = t.value, r = t.styleSpec, n = r.terrain, i = t.style;
            let a = [];
            const s = kr(e);
            if (void 0 === e) return a;
            if ("object" !== s) return a = a.concat([
                new ot("terrain", e, `object expected, ${s} found`)
            ]), a;
            for(const s in e)a = a.concat(n[s] ? t.validateSpec({
                key: s,
                value: e[s],
                valueSpec: n[s],
                validateSpec: t.validateSpec,
                style: i,
                styleSpec: r
            }) : [
                new ot(s, e[s], `unknown property "${s}"`)
            ]);
            return a;
        }
        function wn(t) {
            let e = [];
            const r = t.value, n = t.key;
            if (Array.isArray(r)) {
                const i = [], a = [];
                for(const s in r)r[s].id && i.includes(r[s].id) && e.push(new ot(n, r, `all the sprites' ids must be unique, but ${r[s].id} is duplicated`)), i.push(r[s].id), r[s].url && a.includes(r[s].url) && e.push(new ot(n, r, `all the sprites' URLs must be unique, but ${r[s].url} is duplicated`)), a.push(r[s].url), e = e.concat(nn({
                    key: `${n}[${s}]`,
                    value: r[s],
                    valueSpec: {
                        id: {
                            type: "string",
                            required: !0
                        },
                        url: {
                            type: "string",
                            required: !0
                        }
                    },
                    validateSpec: t.validateSpec
                }));
                return e;
            }
            return mn({
                key: n,
                value: r
            });
        }
        const _n = {
            "*": ()=>[],
            array: an,
            boolean: function(t) {
                const e = t.value, r = t.key, n = kr(e);
                return "boolean" !== n ? [
                    new ot(r, e, `boolean expected, ${n} found`)
                ] : [];
            },
            number: sn,
            color: function(t) {
                const e = t.key, r = t.value, n = kr(r);
                return "string" !== n ? [
                    new ot(e, r, `color expected, ${n} found`)
                ] : Yt.parse(String(r)) ? [] : [
                    new ot(e, r, `color expected, "${r}" found`)
                ];
            },
            constants: tn,
            enum: un,
            filter: cn,
            function: on,
            layer: yn,
            object: nn,
            source: xn,
            light: vn,
            terrain: bn,
            string: mn,
            formatted: function(t) {
                return 0 === mn(t).length ? [] : ln(t);
            },
            resolvedImage: function(t) {
                return 0 === mn(t).length ? [] : ln(t);
            },
            padding: function(t) {
                const e = t.key, r = t.value;
                if ("array" === kr(r)) {
                    if (r.length < 1 || r.length > 4) return [
                        new ot(e, r, `padding requires 1 to 4 values; ${r.length} values found`)
                    ];
                    const n = {
                        type: "number"
                    };
                    let i = [];
                    for(let a = 0; a < r.length; a++)i = i.concat(t.validateSpec({
                        key: `${e}[${a}]`,
                        value: r[a],
                        validateSpec: t.validateSpec,
                        valueSpec: n
                    }));
                    return i;
                }
                return sn({
                    key: e,
                    value: r,
                    valueSpec: {}
                });
            },
            variableAnchorOffsetCollection: function(t) {
                const e = t.key, r = t.value, n = kr(r), i = t.styleSpec;
                if ("array" !== n || r.length < 1 || r.length % 2 != 0) return [
                    new ot(e, r, "variableAnchorOffsetCollection requires a non-empty array of even length")
                ];
                let a = [];
                for(let n = 0; n < r.length; n += 2)a = a.concat(un({
                    key: `${e}[${n}]`,
                    value: r[n],
                    valueSpec: i.layout_symbol["text-anchor"]
                })), a = a.concat(an({
                    key: `${e}[${n + 1}]`,
                    value: r[n + 1],
                    valueSpec: {
                        length: 2,
                        value: "number"
                    },
                    validateSpec: t.validateSpec,
                    style: t.style,
                    styleSpec: i
                }));
                return a;
            },
            sprite: wn
        };
        function An(t) {
            const e = t.value, r = t.valueSpec, n = t.styleSpec;
            return t.validateSpec = An, r.expression && Ir(en(e)) ? on(t) : r.expression && Tr(rn(e)) ? ln(t) : r.type && _n[r.type] ? _n[r.type](t) : nn(lt({}, t, {
                valueSpec: r.type ? n[r.type] : r
            }));
        }
        function Sn(t) {
            const e = t.value, r = t.key, n = mn(t);
            return n.length || (-1 === e.indexOf("{fontstack}") && n.push(new ot(r, e, '"glyphs" url must include a "{fontstack}" token')), -1 === e.indexOf("{range}") && n.push(new ot(r, e, '"glyphs" url must include a "{range}" token'))), n;
        }
        function kn(t, e = X) {
            let r = [];
            return r = r.concat(An({
                key: "",
                value: t,
                valueSpec: e.$root,
                styleSpec: e,
                style: t,
                validateSpec: An,
                objectElementValidators: {
                    glyphs: Sn,
                    "*": ()=>[]
                }
            })), t.constants && (r = r.concat(tn({
                key: "constants",
                value: t.constants,
                style: t,
                styleSpec: e,
                validateSpec: An
            }))), zn(r);
        }
        function In(t) {
            return function(e) {
                return t({
                    ...e,
                    validateSpec: An
                });
            };
        }
        function zn(t) {
            return [].concat(t).sort((t, e)=>t.line - e.line);
        }
        function Mn(t) {
            return function(...e) {
                return zn(t.apply(this, e));
            };
        }
        kn.source = Mn(In(xn)), kn.sprite = Mn(In(wn)), kn.glyphs = Mn(In(Sn)), kn.light = Mn(In(vn)), kn.terrain = Mn(In(bn)), kn.layer = Mn(In(yn)), kn.filter = Mn(In(cn)), kn.paintProperty = Mn(In(fn)), kn.layoutProperty = Mn(In(dn));
        const Cn = kn, Bn = Cn.light, Pn = Cn.paintProperty, Vn = Cn.layoutProperty;
        function En(t, e) {
            let r = !1;
            if (e && e.length) for (const n of e)t.fire(new G(new Error(n.message))), r = !0;
            return r;
        }
        class Fn {
            constructor(t, e, r){
                const n = this.cells = [];
                if (t instanceof ArrayBuffer) {
                    this.arrayBuffer = t;
                    const i = new Int32Array(this.arrayBuffer);
                    t = i[0], this.d = (e = i[1]) + 2 * (r = i[2]);
                    for(let t = 0; t < this.d * this.d; t++){
                        const e = i[3 + t], r = i[3 + t + 1];
                        n.push(e === r ? null : i.subarray(e, r));
                    }
                    const a = i[3 + n.length + 1];
                    this.keys = i.subarray(i[3 + n.length], a), this.bboxes = i.subarray(a), this.insert = this._insertReadonly;
                } else {
                    this.d = e + 2 * r;
                    for(let t = 0; t < this.d * this.d; t++)n.push([]);
                    this.keys = [], this.bboxes = [];
                }
                this.n = e, this.extent = t, this.padding = r, this.scale = e / t, this.uid = 0;
                const i = r / e * t;
                this.min = -i, this.max = t + i;
            }
            insert(t, e, r, n, i) {
                this._forEachCell(e, r, n, i, this._insertCell, this.uid++, void 0, void 0), this.keys.push(t), this.bboxes.push(e), this.bboxes.push(r), this.bboxes.push(n), this.bboxes.push(i);
            }
            _insertReadonly() {
                throw new Error("Cannot insert into a GridIndex created from an ArrayBuffer.");
            }
            _insertCell(t, e, r, n, i, a) {
                this.cells[i].push(a);
            }
            query(t, e, r, n, i) {
                const a = this.min, s = this.max;
                if (t <= a && e <= a && s <= r && s <= n && !i) return Array.prototype.slice.call(this.keys);
                {
                    const a = [];
                    return this._forEachCell(t, e, r, n, this._queryCell, a, {}, i), a;
                }
            }
            _queryCell(t, e, r, n, i, a, s, o) {
                const l = this.cells[i];
                if (null !== l) {
                    const i = this.keys, u = this.bboxes;
                    for(let c = 0; c < l.length; c++){
                        const h = l[c];
                        if (void 0 === s[h]) {
                            const l = 4 * h;
                            (o ? o(u[l + 0], u[l + 1], u[l + 2], u[l + 3]) : t <= u[l + 2] && e <= u[l + 3] && r >= u[l + 0] && n >= u[l + 1]) ? (s[h] = !0, a.push(i[h])) : s[h] = !1;
                        }
                    }
                }
            }
            _forEachCell(t, e, r, n, i, a, s, o) {
                const l = this._convertToCellCoord(t), u = this._convertToCellCoord(e), c = this._convertToCellCoord(r), h = this._convertToCellCoord(n);
                for(let p = l; p <= c; p++)for(let l = u; l <= h; l++){
                    const u = this.d * l + p;
                    if ((!o || o(this._convertFromCellCoord(p), this._convertFromCellCoord(l), this._convertFromCellCoord(p + 1), this._convertFromCellCoord(l + 1))) && i.call(this, t, e, r, n, u, a, s, o)) return;
                }
            }
            _convertFromCellCoord(t) {
                return (t - this.padding) / this.scale;
            }
            _convertToCellCoord(t) {
                return Math.max(0, Math.min(this.d - 1, Math.floor(t * this.scale) + this.padding));
            }
            toArrayBuffer() {
                if (this.arrayBuffer) return this.arrayBuffer;
                const t = this.cells, e = 3 + this.cells.length + 1 + 1;
                let r = 0;
                for(let t = 0; t < this.cells.length; t++)r += this.cells[t].length;
                const n = new Int32Array(e + r + this.keys.length + this.bboxes.length);
                n[0] = this.extent, n[1] = this.n, n[2] = this.padding;
                let i = e;
                for(let e = 0; e < t.length; e++){
                    const r = t[e];
                    n[3 + e] = i, n.set(r, i), i += r.length;
                }
                return n[3 + t.length] = i, n.set(this.keys, i), i += this.keys.length, n[3 + t.length + 1] = i, n.set(this.bboxes, i), i += this.bboxes.length, n.buffer;
            }
            static serialize(t, e) {
                const r = t.toArrayBuffer();
                return e && e.push(r), {
                    buffer: r
                };
            }
            static deserialize(t) {
                return new Fn(t.buffer);
            }
        }
        const Tn = {};
        function $n(t, e, r = {}) {
            if (Tn[t]) throw new Error(`${t} is already registered.`);
            Object.defineProperty(e, "_classRegistryKey", {
                value: t,
                writeable: !1
            }), Tn[t] = {
                klass: e,
                omit: r.omit || [],
                shallow: r.shallow || []
            };
        }
        $n("Object", Object), $n("TransferableGridIndex", Fn), $n("Color", Yt), $n("Error", Error), $n("AJAXError", L), $n("ResolvedImage", ne), $n("StylePropertyFunction", Ur), $n("StyleExpression", Fr, {
            omit: [
                "_evaluator"
            ]
        }), $n("ZoomDependentExpression", Dr), $n("ZoomConstantExpression", Lr), $n("CompoundExpression", $e, {
            omit: [
                "_evaluate"
            ]
        });
        for(const t in yr)yr[t]._classRegistryKey || $n(`Expression_${t}`, yr[t]);
        function Ln(t) {
            return t && "undefined" != typeof ArrayBuffer && (t instanceof ArrayBuffer || t.constructor && "ArrayBuffer" === t.constructor.name);
        }
        function Dn(t, e) {
            if (null == t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || t instanceof Boolean || t instanceof Number || t instanceof String || t instanceof Date || t instanceof RegExp || t instanceof Blob) return t;
            if (Ln(t)) return e && e.push(t), t;
            if (M(t)) return e && e.push(t), t;
            if (ArrayBuffer.isView(t)) {
                const r = t;
                return e && e.push(r.buffer), r;
            }
            if (t instanceof ImageData) return e && e.push(t.data.buffer), t;
            if (Array.isArray(t)) {
                const r = [];
                for (const n of t)r.push(Dn(n, e));
                return r;
            }
            if ("object" == typeof t) {
                const r = t.constructor, n = r._classRegistryKey;
                if (!n) throw new Error("can't serialize object of unregistered class");
                if (!Tn[n]) throw new Error(`${n} is not registered.`);
                const i = r.serialize ? r.serialize(t, e) : {};
                if (r.serialize) {
                    if (e && i === e[e.length - 1]) throw new Error("statically serialized object won't survive transfer of $name property");
                } else {
                    for(const r in t){
                        if (!t.hasOwnProperty(r)) continue;
                        if (Tn[n].omit.indexOf(r) >= 0) continue;
                        const a = t[r];
                        i[r] = Tn[n].shallow.indexOf(r) >= 0 ? a : Dn(a, e);
                    }
                    t instanceof Error && (i.message = t.message);
                }
                if (i.$name) throw new Error("$name property is reserved for worker serialization logic.");
                return "Object" !== n && (i.$name = n), i;
            }
            throw new Error("can't serialize object of type " + typeof t);
        }
        function On(t) {
            if (null == t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || t instanceof Boolean || t instanceof Number || t instanceof String || t instanceof Date || t instanceof RegExp || t instanceof Blob || Ln(t) || M(t) || ArrayBuffer.isView(t) || t instanceof ImageData) return t;
            if (Array.isArray(t)) return t.map(On);
            if ("object" == typeof t) {
                const e = t.$name || "Object";
                if (!Tn[e]) throw new Error(`can't deserialize unregistered class ${e}`);
                const { klass: r } = Tn[e];
                if (!r) throw new Error(`can't deserialize unregistered class ${e}`);
                if (r.deserialize) return r.deserialize(t);
                const n = Object.create(r.prototype);
                for (const r of Object.keys(t)){
                    if ("$name" === r) continue;
                    const i = t[r];
                    n[r] = Tn[e].shallow.indexOf(r) >= 0 ? i : On(i);
                }
                return n;
            }
            throw new Error("can't deserialize object of type " + typeof t);
        }
        class Un {
            constructor(){
                this.first = !0;
            }
            update(t, e) {
                const r = Math.floor(t);
                return this.first ? (this.first = !1, this.lastIntegerZoom = r, this.lastIntegerZoomTime = 0, this.lastZoom = t, this.lastFloorZoom = r, !0) : (this.lastFloorZoom > r ? (this.lastIntegerZoom = r + 1, this.lastIntegerZoomTime = e) : this.lastFloorZoom < r && (this.lastIntegerZoom = r, this.lastIntegerZoomTime = e), t !== this.lastZoom && (this.lastZoom = t, this.lastFloorZoom = r, !0));
            }
        }
        const Rn = {
            "Latin-1 Supplement": (t)=>t >= 128 && t <= 255,
            Arabic: (t)=>t >= 1536 && t <= 1791,
            "Arabic Supplement": (t)=>t >= 1872 && t <= 1919,
            "Arabic Extended-A": (t)=>t >= 2208 && t <= 2303,
            "Hangul Jamo": (t)=>t >= 4352 && t <= 4607,
            "Unified Canadian Aboriginal Syllabics": (t)=>t >= 5120 && t <= 5759,
            Khmer: (t)=>t >= 6016 && t <= 6143,
            "Unified Canadian Aboriginal Syllabics Extended": (t)=>t >= 6320 && t <= 6399,
            "General Punctuation": (t)=>t >= 8192 && t <= 8303,
            "Letterlike Symbols": (t)=>t >= 8448 && t <= 8527,
            "Number Forms": (t)=>t >= 8528 && t <= 8591,
            "Miscellaneous Technical": (t)=>t >= 8960 && t <= 9215,
            "Control Pictures": (t)=>t >= 9216 && t <= 9279,
            "Optical Character Recognition": (t)=>t >= 9280 && t <= 9311,
            "Enclosed Alphanumerics": (t)=>t >= 9312 && t <= 9471,
            "Geometric Shapes": (t)=>t >= 9632 && t <= 9727,
            "Miscellaneous Symbols": (t)=>t >= 9728 && t <= 9983,
            "Miscellaneous Symbols and Arrows": (t)=>t >= 11008 && t <= 11263,
            "CJK Radicals Supplement": (t)=>t >= 11904 && t <= 12031,
            "Kangxi Radicals": (t)=>t >= 12032 && t <= 12255,
            "Ideographic Description Characters": (t)=>t >= 12272 && t <= 12287,
            "CJK Symbols and Punctuation": (t)=>t >= 12288 && t <= 12351,
            Hiragana: (t)=>t >= 12352 && t <= 12447,
            Katakana: (t)=>t >= 12448 && t <= 12543,
            Bopomofo: (t)=>t >= 12544 && t <= 12591,
            "Hangul Compatibility Jamo": (t)=>t >= 12592 && t <= 12687,
            Kanbun: (t)=>t >= 12688 && t <= 12703,
            "Bopomofo Extended": (t)=>t >= 12704 && t <= 12735,
            "CJK Strokes": (t)=>t >= 12736 && t <= 12783,
            "Katakana Phonetic Extensions": (t)=>t >= 12784 && t <= 12799,
            "Enclosed CJK Letters and Months": (t)=>t >= 12800 && t <= 13055,
            "CJK Compatibility": (t)=>t >= 13056 && t <= 13311,
            "CJK Unified Ideographs Extension A": (t)=>t >= 13312 && t <= 19903,
            "Yijing Hexagram Symbols": (t)=>t >= 19904 && t <= 19967,
            "CJK Unified Ideographs": (t)=>t >= 19968 && t <= 40959,
            "Yi Syllables": (t)=>t >= 40960 && t <= 42127,
            "Yi Radicals": (t)=>t >= 42128 && t <= 42191,
            "Hangul Jamo Extended-A": (t)=>t >= 43360 && t <= 43391,
            "Hangul Syllables": (t)=>t >= 44032 && t <= 55215,
            "Hangul Jamo Extended-B": (t)=>t >= 55216 && t <= 55295,
            "Private Use Area": (t)=>t >= 57344 && t <= 63743,
            "CJK Compatibility Ideographs": (t)=>t >= 63744 && t <= 64255,
            "Arabic Presentation Forms-A": (t)=>t >= 64336 && t <= 65023,
            "Vertical Forms": (t)=>t >= 65040 && t <= 65055,
            "CJK Compatibility Forms": (t)=>t >= 65072 && t <= 65103,
            "Small Form Variants": (t)=>t >= 65104 && t <= 65135,
            "Arabic Presentation Forms-B": (t)=>t >= 65136 && t <= 65279,
            "Halfwidth and Fullwidth Forms": (t)=>t >= 65280 && t <= 65519
        };
        function qn(t) {
            for (const e of t)if (Zn(e.charCodeAt(0))) return !0;
            return !1;
        }
        function jn(t) {
            for (const e of t)if (!Nn(e.charCodeAt(0))) return !1;
            return !0;
        }
        function Nn(t) {
            return !(Rn.Arabic(t) || Rn["Arabic Supplement"](t) || Rn["Arabic Extended-A"](t) || Rn["Arabic Presentation Forms-A"](t) || Rn["Arabic Presentation Forms-B"](t));
        }
        function Zn(t) {
            return !(746 !== t && 747 !== t && (t < 4352 || !(Rn["Bopomofo Extended"](t) || Rn.Bopomofo(t) || Rn["CJK Compatibility Forms"](t) && !(t >= 65097 && t <= 65103) || Rn["CJK Compatibility Ideographs"](t) || Rn["CJK Compatibility"](t) || Rn["CJK Radicals Supplement"](t) || Rn["CJK Strokes"](t) || !(!Rn["CJK Symbols and Punctuation"](t) || t >= 12296 && t <= 12305 || t >= 12308 && t <= 12319 || 12336 === t) || Rn["CJK Unified Ideographs Extension A"](t) || Rn["CJK Unified Ideographs"](t) || Rn["Enclosed CJK Letters and Months"](t) || Rn["Hangul Compatibility Jamo"](t) || Rn["Hangul Jamo Extended-A"](t) || Rn["Hangul Jamo Extended-B"](t) || Rn["Hangul Jamo"](t) || Rn["Hangul Syllables"](t) || Rn.Hiragana(t) || Rn["Ideographic Description Characters"](t) || Rn.Kanbun(t) || Rn["Kangxi Radicals"](t) || Rn["Katakana Phonetic Extensions"](t) || Rn.Katakana(t) && 12540 !== t || !(!Rn["Halfwidth and Fullwidth Forms"](t) || 65288 === t || 65289 === t || 65293 === t || t >= 65306 && t <= 65310 || 65339 === t || 65341 === t || 65343 === t || t >= 65371 && t <= 65503 || 65507 === t || t >= 65512 && t <= 65519) || !(!Rn["Small Form Variants"](t) || t >= 65112 && t <= 65118 || t >= 65123 && t <= 65126) || Rn["Unified Canadian Aboriginal Syllabics"](t) || Rn["Unified Canadian Aboriginal Syllabics Extended"](t) || Rn["Vertical Forms"](t) || Rn["Yijing Hexagram Symbols"](t) || Rn["Yi Syllables"](t) || Rn["Yi Radicals"](t))));
        }
        function Kn(t) {
            return !(Zn(t) || function(t) {
                return !!(Rn["Latin-1 Supplement"](t) && (167 === t || 169 === t || 174 === t || 177 === t || 188 === t || 189 === t || 190 === t || 215 === t || 247 === t) || Rn["General Punctuation"](t) && (8214 === t || 8224 === t || 8225 === t || 8240 === t || 8241 === t || 8251 === t || 8252 === t || 8258 === t || 8263 === t || 8264 === t || 8265 === t || 8273 === t) || Rn["Letterlike Symbols"](t) || Rn["Number Forms"](t) || Rn["Miscellaneous Technical"](t) && (t >= 8960 && t <= 8967 || t >= 8972 && t <= 8991 || t >= 8996 && t <= 9e3 || 9003 === t || t >= 9085 && t <= 9114 || t >= 9150 && t <= 9165 || 9167 === t || t >= 9169 && t <= 9179 || t >= 9186 && t <= 9215) || Rn["Control Pictures"](t) && 9251 !== t || Rn["Optical Character Recognition"](t) || Rn["Enclosed Alphanumerics"](t) || Rn["Geometric Shapes"](t) || Rn["Miscellaneous Symbols"](t) && !(t >= 9754 && t <= 9759) || Rn["Miscellaneous Symbols and Arrows"](t) && (t >= 11026 && t <= 11055 || t >= 11088 && t <= 11097 || t >= 11192 && t <= 11243) || Rn["CJK Symbols and Punctuation"](t) || Rn.Katakana(t) || Rn["Private Use Area"](t) || Rn["CJK Compatibility Forms"](t) || Rn["Small Form Variants"](t) || Rn["Halfwidth and Fullwidth Forms"](t) || 8734 === t || 8756 === t || 8757 === t || t >= 9984 && t <= 10087 || t >= 10102 && t <= 10131 || 65532 === t || 65533 === t);
            }(t));
        }
        function Gn(t) {
            return t >= 1424 && t <= 2303 || Rn["Arabic Presentation Forms-A"](t) || Rn["Arabic Presentation Forms-B"](t);
        }
        function Jn(t, e) {
            return !(!e && Gn(t) || t >= 2304 && t <= 3583 || t >= 3840 && t <= 4255 || Rn.Khmer(t));
        }
        function Xn(t) {
            for (const e of t)if (Gn(e.charCodeAt(0))) return !0;
            return !1;
        }
        const Yn = "deferred", Hn = "loading", Wn = "loaded";
        let Qn = null, ti = "unavailable", ei = null;
        const ri = function(t) {
            t && "string" == typeof t && t.indexOf("NetworkError") > -1 && (ti = "error"), Qn && Qn(t);
        };
        function ni() {
            ii.fire(new K("pluginStateChange", {
                pluginStatus: ti,
                pluginURL: ei
            }));
        }
        const ii = new J, ai = function() {
            return ti;
        }, si = function() {
            if (ti !== Yn || !ei) throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
            ti = Hn, ni(), ei && q({
                url: ei
            }, (t)=>{
                t ? ri(t) : (ti = Wn, ni());
            });
        }, oi = {
            applyArabicShaping: null,
            processBidirectionalText: null,
            processStyledBidirectionalText: null,
            isLoaded: ()=>ti === Wn || null != oi.applyArabicShaping,
            isLoading: ()=>ti === Hn,
            setState (t) {
                if (!I()) throw new Error("Cannot set the state of the rtl-text-plugin when not in the web-worker context");
                ti = t.pluginStatus, ei = t.pluginURL;
            },
            isParsed () {
                if (!I()) throw new Error("rtl-text-plugin is only parsed on the worker-threads");
                return null != oi.applyArabicShaping && null != oi.processBidirectionalText && null != oi.processStyledBidirectionalText;
            },
            getPluginURL () {
                if (!I()) throw new Error("rtl-text-plugin url can only be queried from the worker threads");
                return ei;
            }
        };
        class li {
            constructor(t, e){
                this.zoom = t, e ? (this.now = e.now, this.fadeDuration = e.fadeDuration, this.zoomHistory = e.zoomHistory, this.transition = e.transition) : (this.now = 0, this.fadeDuration = 0, this.zoomHistory = new Un, this.transition = {});
            }
            isSupportedScript(t) {
                return function(t, e) {
                    for (const r of t)if (!Jn(r.charCodeAt(0), e)) return !1;
                    return !0;
                }(t, oi.isLoaded());
            }
            crossFadingFactor() {
                return 0 === this.fadeDuration ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
            }
            getCrossfadeParameters() {
                const t = this.zoom, e = t - Math.floor(t), r = this.crossFadingFactor();
                return t > this.zoomHistory.lastIntegerZoom ? {
                    fromScale: 2,
                    toScale: 1,
                    t: e + (1 - e) * r
                } : {
                    fromScale: .5,
                    toScale: 1,
                    t: 1 - (1 - r) * e
                };
            }
        }
        class ui {
            constructor(t, e){
                this.property = t, this.value = e, this.expression = function(t, e) {
                    if (Ir(t)) return new Ur(t, e);
                    if (Tr(t)) {
                        const r = Or(t, e);
                        if ("error" === r.result) throw new Error(r.value.map((t)=>`${t.key}: ${t.message}`).join(", "));
                        return r.value;
                    }
                    {
                        let r = t;
                        return "color" === e.type && "string" == typeof t ? r = Yt.parse(t) : "padding" !== e.type || "number" != typeof t && !Array.isArray(t) ? "variableAnchorOffsetCollection" === e.type && Array.isArray(t) && (r = re.parse(t)) : r = te.parse(t), {
                            kind: "constant",
                            evaluate: ()=>r
                        };
                    }
                }(void 0 === e ? t.specification.default : e, t.specification);
            }
            isDataDriven() {
                return "source" === this.expression.kind || "composite" === this.expression.kind;
            }
            possiblyEvaluate(t, e, r) {
                return this.property.possiblyEvaluate(this, t, e, r);
            }
        }
        class ci {
            constructor(t){
                this.property = t, this.value = new ui(t, void 0);
            }
            transitioned(t, e) {
                return new pi(this.property, this.value, e, g({}, t.transition, this.transition), t.now);
            }
            untransitioned() {
                return new pi(this.property, this.value, null, {}, 0);
            }
        }
        class hi {
            constructor(t){
                this._properties = t, this._values = Object.create(t.defaultTransitionablePropertyValues);
            }
            getValue(t) {
                return w(this._values[t].value.value);
            }
            setValue(t, e) {
                Object.prototype.hasOwnProperty.call(this._values, t) || (this._values[t] = new ci(this._values[t].property)), this._values[t].value = new ui(this._values[t].property, null === e ? void 0 : w(e));
            }
            getTransition(t) {
                return w(this._values[t].transition);
            }
            setTransition(t, e) {
                Object.prototype.hasOwnProperty.call(this._values, t) || (this._values[t] = new ci(this._values[t].property)), this._values[t].transition = w(e) || void 0;
            }
            serialize() {
                const t = {};
                for (const e of Object.keys(this._values)){
                    const r = this.getValue(e);
                    void 0 !== r && (t[e] = r);
                    const n = this.getTransition(e);
                    void 0 !== n && (t[`${e}-transition`] = n);
                }
                return t;
            }
            transitioned(t, e) {
                const r = new fi(this._properties);
                for (const n of Object.keys(this._values))r._values[n] = this._values[n].transitioned(t, e._values[n]);
                return r;
            }
            untransitioned() {
                const t = new fi(this._properties);
                for (const e of Object.keys(this._values))t._values[e] = this._values[e].untransitioned();
                return t;
            }
        }
        class pi {
            constructor(t, e, r, n, i){
                this.property = t, this.value = e, this.begin = i + n.delay || 0, this.end = this.begin + n.duration || 0, t.specification.transition && (n.delay || n.duration) && (this.prior = r);
            }
            possiblyEvaluate(t, e, r) {
                const n = t.now || 0, i = this.value.possiblyEvaluate(t, e, r), a = this.prior;
                if (a) {
                    if (n > this.end) return this.prior = null, i;
                    if (this.value.isDataDriven()) return this.prior = null, i;
                    if (n < this.begin) return a.possiblyEvaluate(t, e, r);
                    {
                        const s = (n - this.begin) / (this.end - this.begin);
                        return this.property.interpolate(a.possiblyEvaluate(t, e, r), i, function(t) {
                            if (t <= 0) return 0;
                            if (t >= 1) return 1;
                            const e = t * t, r = e * t;
                            return 4 * (t < .5 ? r : 3 * (t - e) + r - .75);
                        }(s));
                    }
                }
                return i;
            }
        }
        class fi {
            constructor(t){
                this._properties = t, this._values = Object.create(t.defaultTransitioningPropertyValues);
            }
            possiblyEvaluate(t, e, r) {
                const n = new mi(this._properties);
                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(t, e, r);
                return n;
            }
            hasTransition() {
                for (const t of Object.keys(this._values))if (this._values[t].prior) return !0;
                return !1;
            }
        }
        class di {
            constructor(t){
                this._properties = t, this._values = Object.create(t.defaultPropertyValues);
            }
            hasValue(t) {
                return void 0 !== this._values[t].value;
            }
            getValue(t) {
                return w(this._values[t].value);
            }
            setValue(t, e) {
                this._values[t] = new ui(this._values[t].property, null === e ? void 0 : w(e));
            }
            serialize() {
                const t = {};
                for (const e of Object.keys(this._values)){
                    const r = this.getValue(e);
                    void 0 !== r && (t[e] = r);
                }
                return t;
            }
            possiblyEvaluate(t, e, r) {
                const n = new mi(this._properties);
                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(t, e, r);
                return n;
            }
        }
        class yi {
            constructor(t, e, r){
                this.property = t, this.value = e, this.parameters = r;
            }
            isConstant() {
                return "constant" === this.value.kind;
            }
            constantOr(t) {
                return "constant" === this.value.kind ? this.value.value : t;
            }
            evaluate(t, e, r, n) {
                return this.property.evaluate(this.value, this.parameters, t, e, r, n);
            }
        }
        class mi {
            constructor(t){
                this._properties = t, this._values = Object.create(t.defaultPossiblyEvaluatedValues);
            }
            get(t) {
                return this._values[t];
            }
        }
        class gi {
            constructor(t){
                this.specification = t;
            }
            possiblyEvaluate(t, e) {
                if (t.isDataDriven()) throw new Error("Value should not be data driven");
                return t.expression.evaluate(e);
            }
            interpolate(t, e, r) {
                const n = Ze[this.specification.type];
                return n ? n(t, e, r) : t;
            }
        }
        class xi {
            constructor(t, e){
                this.specification = t, this.overrides = e;
            }
            possiblyEvaluate(t, e, r, n) {
                return new yi(this, "constant" === t.expression.kind || "camera" === t.expression.kind ? {
                    kind: "constant",
                    value: t.expression.evaluate(e, null, {}, r, n)
                } : t.expression, e);
            }
            interpolate(t, e, r) {
                if ("constant" !== t.value.kind || "constant" !== e.value.kind) return t;
                if (void 0 === t.value.value || void 0 === e.value.value) return new yi(this, {
                    kind: "constant",
                    value: void 0
                }, t.parameters);
                const n = Ze[this.specification.type];
                if (n) {
                    const i = n(t.value.value, e.value.value, r);
                    return new yi(this, {
                        kind: "constant",
                        value: i
                    }, t.parameters);
                }
                return t;
            }
            evaluate(t, e, r, n, i, a) {
                return "constant" === t.kind ? t.value : t.evaluate(e, r, n, i, a);
            }
        }
        class vi extends xi {
            possiblyEvaluate(t, e, r, n) {
                if (void 0 === t.value) return new yi(this, {
                    kind: "constant",
                    value: void 0
                }, e);
                if ("constant" === t.expression.kind) {
                    const i = t.expression.evaluate(e, null, {}, r, n), a = "resolvedImage" === t.property.specification.type && "string" != typeof i ? i.name : i, s = this._calculate(a, a, a, e);
                    return new yi(this, {
                        kind: "constant",
                        value: s
                    }, e);
                }
                if ("camera" === t.expression.kind) {
                    const r = this._calculate(t.expression.evaluate({
                        zoom: e.zoom - 1
                    }), t.expression.evaluate({
                        zoom: e.zoom
                    }), t.expression.evaluate({
                        zoom: e.zoom + 1
                    }), e);
                    return new yi(this, {
                        kind: "constant",
                        value: r
                    }, e);
                }
                return new yi(this, t.expression, e);
            }
            evaluate(t, e, r, n, i, a) {
                if ("source" === t.kind) {
                    const s = t.evaluate(e, r, n, i, a);
                    return this._calculate(s, s, s, e);
                }
                return "composite" === t.kind ? this._calculate(t.evaluate({
                    zoom: Math.floor(e.zoom) - 1
                }, r, n), t.evaluate({
                    zoom: Math.floor(e.zoom)
                }, r, n), t.evaluate({
                    zoom: Math.floor(e.zoom) + 1
                }, r, n), e) : t.value;
            }
            _calculate(t, e, r, n) {
                return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                    from: t,
                    to: e
                } : {
                    from: r,
                    to: e
                };
            }
            interpolate(t) {
                return t;
            }
        }
        class bi {
            constructor(t){
                this.specification = t;
            }
            possiblyEvaluate(t, e, r, n) {
                if (void 0 !== t.value) {
                    if ("constant" === t.expression.kind) {
                        const i = t.expression.evaluate(e, null, {}, r, n);
                        return this._calculate(i, i, i, e);
                    }
                    return this._calculate(t.expression.evaluate(new li(Math.floor(e.zoom - 1), e)), t.expression.evaluate(new li(Math.floor(e.zoom), e)), t.expression.evaluate(new li(Math.floor(e.zoom + 1), e)), e);
                }
            }
            _calculate(t, e, r, n) {
                return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                    from: t,
                    to: e
                } : {
                    from: r,
                    to: e
                };
            }
            interpolate(t) {
                return t;
            }
        }
        class wi {
            constructor(t){
                this.specification = t;
            }
            possiblyEvaluate(t, e, r, n) {
                return !!t.expression.evaluate(e, null, {}, r, n);
            }
            interpolate() {
                return !1;
            }
        }
        class _i {
            constructor(t){
                this.properties = t, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
                for(const e in t){
                    const r = t[e];
                    r.specification.overridable && this.overridableProperties.push(e);
                    const n = this.defaultPropertyValues[e] = new ui(r, void 0), i = this.defaultTransitionablePropertyValues[e] = new ci(r);
                    this.defaultTransitioningPropertyValues[e] = i.untransitioned(), this.defaultPossiblyEvaluatedValues[e] = n.possiblyEvaluate({});
                }
            }
        }
        $n("DataDrivenProperty", xi), $n("DataConstantProperty", gi), $n("CrossFadedDataDrivenProperty", vi), $n("CrossFadedProperty", bi), $n("ColorRampProperty", wi);
        const Ai = "-transition";
        class Si extends J {
            constructor(t, e){
                if (super(), this.id = t.id, this.type = t.type, this._featureFilter = {
                    filter: ()=>!0,
                    needGeometry: !1
                }, "custom" !== t.type && (this.metadata = t.metadata, this.minzoom = t.minzoom, this.maxzoom = t.maxzoom, "background" !== t.type && (this.source = t.source, this.sourceLayer = t["source-layer"], this.filter = t.filter), e.layout && (this._unevaluatedLayout = new di(e.layout)), e.paint)) {
                    this._transitionablePaint = new hi(e.paint);
                    for(const e in t.paint)this.setPaintProperty(e, t.paint[e], {
                        validate: !1
                    });
                    for(const e in t.layout)this.setLayoutProperty(e, t.layout[e], {
                        validate: !1
                    });
                    this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new mi(e.paint);
                }
            }
            getCrossfadeParameters() {
                return this._crossfadeParameters;
            }
            getLayoutProperty(t) {
                return "visibility" === t ? this.visibility : this._unevaluatedLayout.getValue(t);
            }
            setLayoutProperty(t, e, r = {}) {
                null != e && this._validate(Vn, `layers.${this.id}.layout.${t}`, t, e, r) || ("visibility" !== t ? this._unevaluatedLayout.setValue(t, e) : this.visibility = e);
            }
            getPaintProperty(t) {
                return t.endsWith(Ai) ? this._transitionablePaint.getTransition(t.slice(0, -11)) : this._transitionablePaint.getValue(t);
            }
            setPaintProperty(t, e, r = {}) {
                if (null != e && this._validate(Pn, `layers.${this.id}.paint.${t}`, t, e, r)) return !1;
                if (t.endsWith(Ai)) return this._transitionablePaint.setTransition(t.slice(0, -11), e || void 0), !1;
                {
                    const r = this._transitionablePaint._values[t], n = "cross-faded-data-driven" === r.property.specification["property-type"], i = r.value.isDataDriven(), a = r.value;
                    this._transitionablePaint.setValue(t, e), this._handleSpecialPaintPropertyUpdate(t);
                    const s = this._transitionablePaint._values[t].value;
                    return s.isDataDriven() || i || n || this._handleOverridablePaintPropertyUpdate(t, a, s);
                }
            }
            _handleSpecialPaintPropertyUpdate(t) {}
            _handleOverridablePaintPropertyUpdate(t, e, r) {
                return !1;
            }
            isHidden(t) {
                return !!(this.minzoom && t < this.minzoom) || !!(this.maxzoom && t >= this.maxzoom) || "none" === this.visibility;
            }
            updateTransitions(t) {
                this._transitioningPaint = this._transitionablePaint.transitioned(t, this._transitioningPaint);
            }
            hasTransition() {
                return this._transitioningPaint.hasTransition();
            }
            recalculate(t, e) {
                t.getCrossfadeParameters && (this._crossfadeParameters = t.getCrossfadeParameters()), this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(t, void 0, e)), this.paint = this._transitioningPaint.possiblyEvaluate(t, void 0, e);
            }
            serialize() {
                const t = {
                    id: this.id,
                    type: this.type,
                    source: this.source,
                    "source-layer": this.sourceLayer,
                    metadata: this.metadata,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    filter: this.filter,
                    layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                    paint: this._transitionablePaint && this._transitionablePaint.serialize()
                };
                return this.visibility && (t.layout = t.layout || {}, t.layout.visibility = this.visibility), b(t, (t, e)=>!(void 0 === t || "layout" === e && !Object.keys(t).length || "paint" === e && !Object.keys(t).length));
            }
            _validate(t, e, r, n, i = {}) {
                return (!i || !1 !== i.validate) && En(this, t.call(Cn, {
                    key: e,
                    layerType: this.type,
                    objectKey: r,
                    value: n,
                    styleSpec: X,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    }
                }));
            }
            is3D() {
                return !1;
            }
            isTileClipped() {
                return !1;
            }
            hasOffscreenPass() {
                return !1;
            }
            resize() {}
            isStateDependent() {
                for(const t in this.paint._values){
                    const e = this.paint.get(t);
                    if (e instanceof yi && _r(e.property.specification) && ("source" === e.value.kind || "composite" === e.value.kind) && e.value.isStateDependent) return !0;
                }
                return !1;
            }
        }
        const ki = {
            Int8: Int8Array,
            Uint8: Uint8Array,
            Int16: Int16Array,
            Uint16: Uint16Array,
            Int32: Int32Array,
            Uint32: Uint32Array,
            Float32: Float32Array
        };
        class Ii {
            constructor(t, e){
                this._structArray = t, this._pos1 = e * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
            }
        }
        class zi {
            constructor(){
                this.isTransferred = !1, this.capacity = -1, this.resize(0);
            }
            static serialize(t, e) {
                return t._trim(), e && (t.isTransferred = !0, e.push(t.arrayBuffer)), {
                    length: t.length,
                    arrayBuffer: t.arrayBuffer
                };
            }
            static deserialize(t) {
                const e = Object.create(this.prototype);
                return e.arrayBuffer = t.arrayBuffer, e.length = t.length, e.capacity = t.arrayBuffer.byteLength / e.bytesPerElement, e._refreshViews(), e;
            }
            _trim() {
                this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
            }
            clear() {
                this.length = 0;
            }
            resize(t) {
                this.reserve(t), this.length = t;
            }
            reserve(t) {
                if (t > this.capacity) {
                    this.capacity = Math.max(t, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                    const e = this.uint8;
                    this._refreshViews(), e && this.uint8.set(e);
                }
            }
            _refreshViews() {
                throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
            }
        }
        function Mi(t, e = 1) {
            let r = 0, n = 0;
            return {
                members: t.map((t)=>{
                    const i = ki[t.type].BYTES_PER_ELEMENT, a = r = Ci(r, Math.max(e, i)), s = t.components || 1;
                    return n = Math.max(n, i), r += i * s, {
                        name: t.name,
                        type: t.type,
                        components: s,
                        offset: a
                    };
                }),
                size: Ci(r, Math.max(n, e)),
                alignment: e
            };
        }
        function Ci(t, e) {
            return Math.ceil(t / e) * e;
        }
        class Bi extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t, e);
            }
            emplace(t, e, r) {
                const n = 2 * t;
                return this.int16[n + 0] = e, this.int16[n + 1] = r, t;
            }
        }
        Bi.prototype.bytesPerElement = 4, $n("StructArrayLayout2i4", Bi);
        class Pi extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t, e, r);
            }
            emplace(t, e, r, n) {
                const i = 3 * t;
                return this.int16[i + 0] = e, this.int16[i + 1] = r, this.int16[i + 2] = n, t;
            }
        }
        Pi.prototype.bytesPerElement = 6, $n("StructArrayLayout3i6", Pi);
        class Vi extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t, e, r, n);
            }
            emplace(t, e, r, n, i) {
                const a = 4 * t;
                return this.int16[a + 0] = e, this.int16[a + 1] = r, this.int16[a + 2] = n, this.int16[a + 3] = i, t;
            }
        }
        Vi.prototype.bytesPerElement = 8, $n("StructArrayLayout4i8", Vi);
        class Ei extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, a) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t, e, r, n, i, a);
            }
            emplace(t, e, r, n, i, a, s) {
                const o = 6 * t;
                return this.int16[o + 0] = e, this.int16[o + 1] = r, this.int16[o + 2] = n, this.int16[o + 3] = i, this.int16[o + 4] = a, this.int16[o + 5] = s, t;
            }
        }
        Ei.prototype.bytesPerElement = 12, $n("StructArrayLayout2i4i12", Ei);
        class Fi extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, a) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t, e, r, n, i, a);
            }
            emplace(t, e, r, n, i, a, s) {
                const o = 4 * t, l = 8 * t;
                return this.int16[o + 0] = e, this.int16[o + 1] = r, this.uint8[l + 4] = n, this.uint8[l + 5] = i, this.uint8[l + 6] = a, this.uint8[l + 7] = s, t;
            }
        }
        Fi.prototype.bytesPerElement = 8, $n("StructArrayLayout2i4ub8", Fi);
        class Ti extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t, e);
            }
            emplace(t, e, r) {
                const n = 2 * t;
                return this.float32[n + 0] = e, this.float32[n + 1] = r, t;
            }
        }
        Ti.prototype.bytesPerElement = 8, $n("StructArrayLayout2f8", Ti);
        class $i extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, a, s, o, l, u) {
                const c = this.length;
                return this.resize(c + 1), this.emplace(c, t, e, r, n, i, a, s, o, l, u);
            }
            emplace(t, e, r, n, i, a, s, o, l, u, c) {
                const h = 10 * t;
                return this.uint16[h + 0] = e, this.uint16[h + 1] = r, this.uint16[h + 2] = n, this.uint16[h + 3] = i, this.uint16[h + 4] = a, this.uint16[h + 5] = s, this.uint16[h + 6] = o, this.uint16[h + 7] = l, this.uint16[h + 8] = u, this.uint16[h + 9] = c, t;
            }
        }
        $i.prototype.bytesPerElement = 20, $n("StructArrayLayout10ui20", $i);
        class Li extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, a, s, o, l, u, c, h) {
                const p = this.length;
                return this.resize(p + 1), this.emplace(p, t, e, r, n, i, a, s, o, l, u, c, h);
            }
            emplace(t, e, r, n, i, a, s, o, l, u, c, h, p) {
                const f = 12 * t;
                return this.int16[f + 0] = e, this.int16[f + 1] = r, this.int16[f + 2] = n, this.int16[f + 3] = i, this.uint16[f + 4] = a, this.uint16[f + 5] = s, this.uint16[f + 6] = o, this.uint16[f + 7] = l, this.int16[f + 8] = u, this.int16[f + 9] = c, this.int16[f + 10] = h, this.int16[f + 11] = p, t;
            }
        }
        Li.prototype.bytesPerElement = 24, $n("StructArrayLayout4i4ui4i24", Li);
        class Di extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t, e, r);
            }
            emplace(t, e, r, n) {
                const i = 3 * t;
                return this.float32[i + 0] = e, this.float32[i + 1] = r, this.float32[i + 2] = n, t;
            }
        }
        Di.prototype.bytesPerElement = 12, $n("StructArrayLayout3f12", Di);
        class Oi extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(t) {
                const e = this.length;
                return this.resize(e + 1), this.emplace(e, t);
            }
            emplace(t, e) {
                return this.uint32[1 * t + 0] = e, t;
            }
        }
        Oi.prototype.bytesPerElement = 4, $n("StructArrayLayout1ul4", Oi);
        class Ui extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, a, s, o, l) {
                const u = this.length;
                return this.resize(u + 1), this.emplace(u, t, e, r, n, i, a, s, o, l);
            }
            emplace(t, e, r, n, i, a, s, o, l, u) {
                const c = 10 * t, h = 5 * t;
                return this.int16[c + 0] = e, this.int16[c + 1] = r, this.int16[c + 2] = n, this.int16[c + 3] = i, this.int16[c + 4] = a, this.int16[c + 5] = s, this.uint32[h + 3] = o, this.uint16[c + 8] = l, this.uint16[c + 9] = u, t;
            }
        }
        Ui.prototype.bytesPerElement = 20, $n("StructArrayLayout6i1ul2ui20", Ui);
        class Ri extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, a) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t, e, r, n, i, a);
            }
            emplace(t, e, r, n, i, a, s) {
                const o = 6 * t;
                return this.int16[o + 0] = e, this.int16[o + 1] = r, this.int16[o + 2] = n, this.int16[o + 3] = i, this.int16[o + 4] = a, this.int16[o + 5] = s, t;
            }
        }
        Ri.prototype.bytesPerElement = 12, $n("StructArrayLayout2i2i2i12", Ri);
        class qi extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, t, e, r, n, i);
            }
            emplace(t, e, r, n, i, a) {
                const s = 4 * t, o = 8 * t;
                return this.float32[s + 0] = e, this.float32[s + 1] = r, this.float32[s + 2] = n, this.int16[o + 6] = i, this.int16[o + 7] = a, t;
            }
        }
        qi.prototype.bytesPerElement = 16, $n("StructArrayLayout2f1f2i16", qi);
        class ji extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t, e, r, n);
            }
            emplace(t, e, r, n, i) {
                const a = 12 * t, s = 3 * t;
                return this.uint8[a + 0] = e, this.uint8[a + 1] = r, this.float32[s + 1] = n, this.float32[s + 2] = i, t;
            }
        }
        ji.prototype.bytesPerElement = 12, $n("StructArrayLayout2ub2f12", ji);
        class Ni extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t, e, r);
            }
            emplace(t, e, r, n) {
                const i = 3 * t;
                return this.uint16[i + 0] = e, this.uint16[i + 1] = r, this.uint16[i + 2] = n, t;
            }
        }
        Ni.prototype.bytesPerElement = 6, $n("StructArrayLayout3ui6", Ni);
        class Zi extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m) {
                const g = this.length;
                return this.resize(g + 1), this.emplace(g, t, e, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m);
            }
            emplace(t, e, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m, g) {
                const x = 24 * t, v = 12 * t, b = 48 * t;
                return this.int16[x + 0] = e, this.int16[x + 1] = r, this.uint16[x + 2] = n, this.uint16[x + 3] = i, this.uint32[v + 2] = a, this.uint32[v + 3] = s, this.uint32[v + 4] = o, this.uint16[x + 10] = l, this.uint16[x + 11] = u, this.uint16[x + 12] = c, this.float32[v + 7] = h, this.float32[v + 8] = p, this.uint8[b + 36] = f, this.uint8[b + 37] = d, this.uint8[b + 38] = y, this.uint32[v + 10] = m, this.int16[x + 22] = g, t;
            }
        }
        Zi.prototype.bytesPerElement = 48, $n("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48", Zi);
        class Ki extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, A, S, k, I, z) {
                const M = this.length;
                return this.resize(M + 1), this.emplace(M, t, e, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, A, S, k, I, z);
            }
            emplace(t, e, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, A, S, k, I, z, M) {
                const C = 32 * t, B = 16 * t;
                return this.int16[C + 0] = e, this.int16[C + 1] = r, this.int16[C + 2] = n, this.int16[C + 3] = i, this.int16[C + 4] = a, this.int16[C + 5] = s, this.int16[C + 6] = o, this.int16[C + 7] = l, this.uint16[C + 8] = u, this.uint16[C + 9] = c, this.uint16[C + 10] = h, this.uint16[C + 11] = p, this.uint16[C + 12] = f, this.uint16[C + 13] = d, this.uint16[C + 14] = y, this.uint16[C + 15] = m, this.uint16[C + 16] = g, this.uint16[C + 17] = x, this.uint16[C + 18] = v, this.uint16[C + 19] = b, this.uint16[C + 20] = w, this.uint16[C + 21] = _, this.uint16[C + 22] = A, this.uint32[B + 12] = S, this.float32[B + 13] = k, this.float32[B + 14] = I, this.uint16[C + 30] = z, this.uint16[C + 31] = M, t;
            }
        }
        Ki.prototype.bytesPerElement = 64, $n("StructArrayLayout8i15ui1ul2f2ui64", Ki);
        class Gi extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t) {
                const e = this.length;
                return this.resize(e + 1), this.emplace(e, t);
            }
            emplace(t, e) {
                return this.float32[1 * t + 0] = e, t;
            }
        }
        Gi.prototype.bytesPerElement = 4, $n("StructArrayLayout1f4", Gi);
        class Ji extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t, e, r);
            }
            emplace(t, e, r, n) {
                const i = 3 * t;
                return this.uint16[6 * t + 0] = e, this.float32[i + 1] = r, this.float32[i + 2] = n, t;
            }
        }
        Ji.prototype.bytesPerElement = 12, $n("StructArrayLayout1ui2f12", Ji);
        class Xi extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t, e, r);
            }
            emplace(t, e, r, n) {
                const i = 4 * t;
                return this.uint32[2 * t + 0] = e, this.uint16[i + 2] = r, this.uint16[i + 3] = n, t;
            }
        }
        Xi.prototype.bytesPerElement = 8, $n("StructArrayLayout1ul2ui8", Xi);
        class Yi extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t, e) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t, e);
            }
            emplace(t, e, r) {
                const n = 2 * t;
                return this.uint16[n + 0] = e, this.uint16[n + 1] = r, t;
            }
        }
        Yi.prototype.bytesPerElement = 4, $n("StructArrayLayout2ui4", Yi);
        class Hi extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t) {
                const e = this.length;
                return this.resize(e + 1), this.emplace(e, t);
            }
            emplace(t, e) {
                return this.uint16[1 * t + 0] = e, t;
            }
        }
        Hi.prototype.bytesPerElement = 2, $n("StructArrayLayout1ui2", Hi);
        class Wi extends zi {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t, e, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t, e, r, n);
            }
            emplace(t, e, r, n, i) {
                const a = 4 * t;
                return this.float32[a + 0] = e, this.float32[a + 1] = r, this.float32[a + 2] = n, this.float32[a + 3] = i, t;
            }
        }
        Wi.prototype.bytesPerElement = 16, $n("StructArrayLayout4f16", Wi);
        class Qi extends Ii {
            get anchorPointX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get anchorPointY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get x1() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get y1() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get x2() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get y2() {
                return this._structArray.int16[this._pos2 + 5];
            }
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 3];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 8];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 9];
            }
            get anchorPoint() {
                return new a(this.anchorPointX, this.anchorPointY);
            }
        }
        Qi.prototype.size = 20;
        class ta extends Ui {
            get(t) {
                return new Qi(this, t);
            }
        }
        $n("CollisionBoxArray", ta);
        class ea extends Ii {
            get anchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get anchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get glyphStartIndex() {
                return this._structArray.uint16[this._pos2 + 2];
            }
            get numGlyphs() {
                return this._structArray.uint16[this._pos2 + 3];
            }
            get vertexStartIndex() {
                return this._structArray.uint32[this._pos4 + 2];
            }
            get lineStartIndex() {
                return this._structArray.uint32[this._pos4 + 3];
            }
            get lineLength() {
                return this._structArray.uint32[this._pos4 + 4];
            }
            get segment() {
                return this._structArray.uint16[this._pos2 + 10];
            }
            get lowerSize() {
                return this._structArray.uint16[this._pos2 + 11];
            }
            get upperSize() {
                return this._structArray.uint16[this._pos2 + 12];
            }
            get lineOffsetX() {
                return this._structArray.float32[this._pos4 + 7];
            }
            get lineOffsetY() {
                return this._structArray.float32[this._pos4 + 8];
            }
            get writingMode() {
                return this._structArray.uint8[this._pos1 + 36];
            }
            get placedOrientation() {
                return this._structArray.uint8[this._pos1 + 37];
            }
            set placedOrientation(t) {
                this._structArray.uint8[this._pos1 + 37] = t;
            }
            get hidden() {
                return this._structArray.uint8[this._pos1 + 38];
            }
            set hidden(t) {
                this._structArray.uint8[this._pos1 + 38] = t;
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 10];
            }
            set crossTileID(t) {
                this._structArray.uint32[this._pos4 + 10] = t;
            }
            get associatedIconIndex() {
                return this._structArray.int16[this._pos2 + 22];
            }
        }
        ea.prototype.size = 48;
        class ra extends Zi {
            get(t) {
                return new ea(this, t);
            }
        }
        $n("PlacedSymbolArray", ra);
        class na extends Ii {
            get anchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get anchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get rightJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get centerJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get leftJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get verticalPlacedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 5];
            }
            get placedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 6];
            }
            get verticalPlacedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 7];
            }
            get key() {
                return this._structArray.uint16[this._pos2 + 8];
            }
            get textBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 9];
            }
            get textBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 10];
            }
            get verticalTextBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 11];
            }
            get verticalTextBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 12];
            }
            get iconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 13];
            }
            get iconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 14];
            }
            get verticalIconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 15];
            }
            get verticalIconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get featureIndex() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get numHorizontalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get numVerticalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 19];
            }
            get numIconVertices() {
                return this._structArray.uint16[this._pos2 + 20];
            }
            get numVerticalIconVertices() {
                return this._structArray.uint16[this._pos2 + 21];
            }
            get useRuntimeCollisionCircles() {
                return this._structArray.uint16[this._pos2 + 22];
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 12];
            }
            set crossTileID(t) {
                this._structArray.uint32[this._pos4 + 12] = t;
            }
            get textBoxScale() {
                return this._structArray.float32[this._pos4 + 13];
            }
            get collisionCircleDiameter() {
                return this._structArray.float32[this._pos4 + 14];
            }
            get textAnchorOffsetStartIndex() {
                return this._structArray.uint16[this._pos2 + 30];
            }
            get textAnchorOffsetEndIndex() {
                return this._structArray.uint16[this._pos2 + 31];
            }
        }
        na.prototype.size = 64;
        class ia extends Ki {
            get(t) {
                return new na(this, t);
            }
        }
        $n("SymbolInstanceArray", ia);
        class aa extends Gi {
            getoffsetX(t) {
                return this.float32[1 * t + 0];
            }
        }
        $n("GlyphOffsetArray", aa);
        class sa extends Pi {
            getx(t) {
                return this.int16[3 * t + 0];
            }
            gety(t) {
                return this.int16[3 * t + 1];
            }
            gettileUnitDistanceFromAnchor(t) {
                return this.int16[3 * t + 2];
            }
        }
        $n("SymbolLineVertexArray", sa);
        class oa extends Ii {
            get textAnchor() {
                return this._structArray.uint16[this._pos2 + 0];
            }
            get textOffset0() {
                return this._structArray.float32[this._pos4 + 1];
            }
            get textOffset1() {
                return this._structArray.float32[this._pos4 + 2];
            }
        }
        oa.prototype.size = 12;
        class la extends Ji {
            get(t) {
                return new oa(this, t);
            }
        }
        $n("TextAnchorOffsetArray", la);
        class ua extends Ii {
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 0];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 2];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 3];
            }
        }
        ua.prototype.size = 8;
        class ca extends Xi {
            get(t) {
                return new ua(this, t);
            }
        }
        $n("FeatureIndexArray", ca);
        class ha extends Bi {
        }
        class pa extends Bi {
        }
        class fa extends Bi {
        }
        class da extends Ei {
        }
        class ya extends Fi {
        }
        class ma extends Ti {
        }
        class ga extends $i {
        }
        class xa extends Li {
        }
        class va extends Di {
        }
        class ba extends Oi {
        }
        class wa extends Ri {
        }
        class _a extends ji {
        }
        class Aa extends Ni {
        }
        class Sa extends Yi {
        }
        const ka = Mi([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: Ia } = ka;
        class za {
            constructor(t = []){
                this.segments = t;
            }
            prepareSegment(t, e, r, n) {
                let i = this.segments[this.segments.length - 1];
                return t > za.MAX_VERTEX_ARRAY_LENGTH && A(`Max vertices per segment is ${za.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${t}`), (!i || i.vertexLength + t > za.MAX_VERTEX_ARRAY_LENGTH || i.sortKey !== n) && (i = {
                    vertexOffset: e.length,
                    primitiveOffset: r.length,
                    vertexLength: 0,
                    primitiveLength: 0
                }, void 0 !== n && (i.sortKey = n), this.segments.push(i)), i;
            }
            get() {
                return this.segments;
            }
            destroy() {
                for (const t of this.segments)for(const e in t.vaos)t.vaos[e].destroy();
            }
            static simpleSegment(t, e, r, n) {
                return new za([
                    {
                        vertexOffset: t,
                        primitiveOffset: e,
                        vertexLength: r,
                        primitiveLength: n,
                        vaos: {},
                        sortKey: 0
                    }
                ]);
            }
        }
        function Ma(t, e) {
            return 256 * (t = y(Math.floor(t), 0, 255)) + y(Math.floor(e), 0, 255);
        }
        za.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, $n("SegmentVector", za);
        const Ca = Mi([
            {
                name: "a_pattern_from",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pattern_to",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio_from",
                components: 1,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio_to",
                components: 1,
                type: "Uint16"
            }
        ]);
        var Ba = {
            exports: {}
        }, Pa = {
            exports: {}
        };
        Pa.exports = function(t, e) {
            var r, n, i, a, s, o, l, u;
            for(n = t.length - (r = 3 & t.length), i = e, s = 3432918353, o = 461845907, u = 0; u < n;)l = 255 & t.charCodeAt(u) | (255 & t.charCodeAt(++u)) << 8 | (255 & t.charCodeAt(++u)) << 16 | (255 & t.charCodeAt(++u)) << 24, ++u, i = 27492 + (65535 & (a = 5 * (65535 & (i = (i ^= l = (65535 & (l = (l = (65535 & l) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 13 | i >>> 19)) + ((5 * (i >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (a >>> 16) & 65535) << 16);
            switch(l = 0, r){
                case 3:
                    l ^= (255 & t.charCodeAt(u + 2)) << 16;
                case 2:
                    l ^= (255 & t.charCodeAt(u + 1)) << 8;
                case 1:
                    i ^= l = (65535 & (l = (l = (65535 & (l ^= 255 & t.charCodeAt(u))) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295;
            }
            return i ^= t.length, i = 2246822507 * (65535 & (i ^= i >>> 16)) + ((2246822507 * (i >>> 16) & 65535) << 16) & 4294967295, i = 3266489909 * (65535 & (i ^= i >>> 13)) + ((3266489909 * (i >>> 16) & 65535) << 16) & 4294967295, (i ^= i >>> 16) >>> 0;
        };
        var Va = Pa.exports, Ea = {
            exports: {}
        };
        Ea.exports = function(t, e) {
            for(var r, n = t.length, i = e ^ n, a = 0; n >= 4;)r = 1540483477 * (65535 & (r = 255 & t.charCodeAt(a) | (255 & t.charCodeAt(++a)) << 8 | (255 & t.charCodeAt(++a)) << 16 | (255 & t.charCodeAt(++a)) << 24)) + ((1540483477 * (r >>> 16) & 65535) << 16), i = 1540483477 * (65535 & i) + ((1540483477 * (i >>> 16) & 65535) << 16) ^ (r = 1540483477 * (65535 & (r ^= r >>> 24)) + ((1540483477 * (r >>> 16) & 65535) << 16)), n -= 4, ++a;
            switch(n){
                case 3:
                    i ^= (255 & t.charCodeAt(a + 2)) << 16;
                case 2:
                    i ^= (255 & t.charCodeAt(a + 1)) << 8;
                case 1:
                    i = 1540483477 * (65535 & (i ^= 255 & t.charCodeAt(a))) + ((1540483477 * (i >>> 16) & 65535) << 16);
            }
            return i = 1540483477 * (65535 & (i ^= i >>> 13)) + ((1540483477 * (i >>> 16) & 65535) << 16), (i ^= i >>> 15) >>> 0;
        };
        var Fa = Va, Ta = Ea.exports;
        Ba.exports = Fa, Ba.exports.murmur3 = Fa, Ba.exports.murmur2 = Ta;
        var $a = r(Ba.exports);
        class La {
            constructor(){
                this.ids = [], this.positions = [], this.indexed = !1;
            }
            add(t, e, r, n) {
                this.ids.push(Da(t)), this.positions.push(e, r, n);
            }
            getPositions(t) {
                if (!this.indexed) throw new Error("Trying to get index, but feature positions are not indexed");
                const e = Da(t);
                let r = 0, n = this.ids.length - 1;
                for(; r < n;){
                    const t = r + n >> 1;
                    this.ids[t] >= e ? n = t : r = t + 1;
                }
                const i = [];
                for(; this.ids[r] === e;)i.push({
                    index: this.positions[3 * r],
                    start: this.positions[3 * r + 1],
                    end: this.positions[3 * r + 2]
                }), r++;
                return i;
            }
            static serialize(t, e) {
                const r = new Float64Array(t.ids), n = new Uint32Array(t.positions);
                return Oa(r, n, 0, r.length - 1), e && e.push(r.buffer, n.buffer), {
                    ids: r,
                    positions: n
                };
            }
            static deserialize(t) {
                const e = new La;
                return e.ids = t.ids, e.positions = t.positions, e.indexed = !0, e;
            }
        }
        function Da(t) {
            const e = +t;
            return !isNaN(e) && e <= Number.MAX_SAFE_INTEGER ? e : $a(String(t));
        }
        function Oa(t, e, r, n) {
            for(; r < n;){
                const i = t[r + n >> 1];
                let a = r - 1, s = n + 1;
                for(;;){
                    do a++;
                    while (t[a] < i);
                    do s--;
                    while (t[s] > i);
                    if (a >= s) break;
                    Ua(t, a, s), Ua(e, 3 * a, 3 * s), Ua(e, 3 * a + 1, 3 * s + 1), Ua(e, 3 * a + 2, 3 * s + 2);
                }
                s - r < n - s ? (Oa(t, e, r, s), r = s + 1) : (Oa(t, e, s + 1, n), n = s);
            }
        }
        function Ua(t, e, r) {
            const n = t[e];
            t[e] = t[r], t[r] = n;
        }
        $n("FeaturePositionMap", La);
        class Ra {
            constructor(t, e){
                this.gl = t.gl, this.location = e;
            }
        }
        class qa extends Ra {
            constructor(t, e){
                super(t, e), this.current = 0;
            }
            set(t) {
                this.current !== t && (this.current = t, this.gl.uniform1f(this.location, t));
            }
        }
        class ja extends Ra {
            constructor(t, e){
                super(t, e), this.current = [
                    0,
                    0,
                    0,
                    0
                ];
            }
            set(t) {
                t[0] === this.current[0] && t[1] === this.current[1] && t[2] === this.current[2] && t[3] === this.current[3] || (this.current = t, this.gl.uniform4f(this.location, t[0], t[1], t[2], t[3]));
            }
        }
        class Na extends Ra {
            constructor(t, e){
                super(t, e), this.current = Yt.transparent;
            }
            set(t) {
                t.r === this.current.r && t.g === this.current.g && t.b === this.current.b && t.a === this.current.a || (this.current = t, this.gl.uniform4f(this.location, t.r, t.g, t.b, t.a));
            }
        }
        const Za = new Float32Array(16);
        function Ka(t) {
            return [
                Ma(255 * t.r, 255 * t.g),
                Ma(255 * t.b, 255 * t.a)
            ];
        }
        class Ga {
            constructor(t, e, r){
                this.value = t, this.uniformNames = e.map((t)=>`u_${t}`), this.type = r;
            }
            setUniform(t, e, r) {
                t.set(r.constantOr(this.value));
            }
            getBinding(t, e, r) {
                return "color" === this.type ? new Na(t, e) : new qa(t, e);
            }
        }
        class Ja {
            constructor(t, e){
                this.uniformNames = e.map((t)=>`u_${t}`), this.patternFrom = null, this.patternTo = null, this.pixelRatioFrom = 1, this.pixelRatioTo = 1;
            }
            setConstantPatternPositions(t, e) {
                this.pixelRatioFrom = e.pixelRatio, this.pixelRatioTo = t.pixelRatio, this.patternFrom = e.tlbr, this.patternTo = t.tlbr;
            }
            setUniform(t, e, r, n) {
                const i = "u_pattern_to" === n ? this.patternTo : "u_pattern_from" === n ? this.patternFrom : "u_pixel_ratio_to" === n ? this.pixelRatioTo : "u_pixel_ratio_from" === n ? this.pixelRatioFrom : null;
                i && t.set(i);
            }
            getBinding(t, e, r) {
                return "u_pattern" === r.substr(0, 9) ? new ja(t, e) : new qa(t, e);
            }
        }
        class Xa {
            constructor(t, e, r, n){
                this.expression = t, this.type = r, this.maxValue = 0, this.paintVertexAttributes = e.map((t)=>({
                        name: `a_${t}`,
                        type: "Float32",
                        components: "color" === r ? 2 : 1,
                        offset: 0
                    })), this.paintVertexArray = new n;
            }
            populatePaintArray(t, e, r, n, i) {
                const a = this.paintVertexArray.length, s = this.expression.evaluate(new li(0), e, {}, n, [], i);
                this.paintVertexArray.resize(t), this._setPaintValue(a, t, s);
            }
            updatePaintArray(t, e, r, n) {
                const i = this.expression.evaluate({
                    zoom: 0
                }, r, n);
                this._setPaintValue(t, e, i);
            }
            _setPaintValue(t, e, r) {
                if ("color" === this.type) {
                    const n = Ka(r);
                    for(let r = t; r < e; r++)this.paintVertexArray.emplace(r, n[0], n[1]);
                } else {
                    for(let n = t; n < e; n++)this.paintVertexArray.emplace(n, r);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r));
                }
            }
            upload(t) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
        }
        class Ya {
            constructor(t, e, r, n, i, a){
                this.expression = t, this.uniformNames = e.map((t)=>`u_${t}_t`), this.type = r, this.useIntegerZoom = n, this.zoom = i, this.maxValue = 0, this.paintVertexAttributes = e.map((t)=>({
                        name: `a_${t}`,
                        type: "Float32",
                        components: "color" === r ? 4 : 2,
                        offset: 0
                    })), this.paintVertexArray = new a;
            }
            populatePaintArray(t, e, r, n, i) {
                const a = this.expression.evaluate(new li(this.zoom), e, {}, n, [], i), s = this.expression.evaluate(new li(this.zoom + 1), e, {}, n, [], i), o = this.paintVertexArray.length;
                this.paintVertexArray.resize(t), this._setPaintValue(o, t, a, s);
            }
            updatePaintArray(t, e, r, n) {
                const i = this.expression.evaluate({
                    zoom: this.zoom
                }, r, n), a = this.expression.evaluate({
                    zoom: this.zoom + 1
                }, r, n);
                this._setPaintValue(t, e, i, a);
            }
            _setPaintValue(t, e, r, n) {
                if ("color" === this.type) {
                    const i = Ka(r), a = Ka(n);
                    for(let r = t; r < e; r++)this.paintVertexArray.emplace(r, i[0], i[1], a[0], a[1]);
                } else {
                    for(let i = t; i < e; i++)this.paintVertexArray.emplace(i, r, n);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r), Math.abs(n));
                }
            }
            upload(t) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
            setUniform(t, e) {
                const r = this.useIntegerZoom ? Math.floor(e.zoom) : e.zoom, n = y(this.expression.interpolationFactor(r, this.zoom, this.zoom + 1), 0, 1);
                t.set(n);
            }
            getBinding(t, e, r) {
                return new qa(t, e);
            }
        }
        class Ha {
            constructor(t, e, r, n, i, a){
                this.expression = t, this.type = e, this.useIntegerZoom = r, this.zoom = n, this.layerId = a, this.zoomInPaintVertexArray = new i, this.zoomOutPaintVertexArray = new i;
            }
            populatePaintArray(t, e, r) {
                const n = this.zoomInPaintVertexArray.length;
                this.zoomInPaintVertexArray.resize(t), this.zoomOutPaintVertexArray.resize(t), this._setPaintValues(n, t, e.patterns && e.patterns[this.layerId], r);
            }
            updatePaintArray(t, e, r, n, i) {
                this._setPaintValues(t, e, r.patterns && r.patterns[this.layerId], i);
            }
            _setPaintValues(t, e, r, n) {
                if (!n || !r) return;
                const { min: i, mid: a, max: s } = r, o = n[i], l = n[a], u = n[s];
                if (o && l && u) for(let r = t; r < e; r++)this.zoomInPaintVertexArray.emplace(r, l.tl[0], l.tl[1], l.br[0], l.br[1], o.tl[0], o.tl[1], o.br[0], o.br[1], l.pixelRatio, o.pixelRatio), this.zoomOutPaintVertexArray.emplace(r, l.tl[0], l.tl[1], l.br[0], l.br[1], u.tl[0], u.tl[1], u.br[0], u.br[1], l.pixelRatio, u.pixelRatio);
            }
            upload(t) {
                this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer && (this.zoomInPaintVertexBuffer = t.createVertexBuffer(this.zoomInPaintVertexArray, Ca.members, this.expression.isStateDependent), this.zoomOutPaintVertexBuffer = t.createVertexBuffer(this.zoomOutPaintVertexArray, Ca.members, this.expression.isStateDependent));
            }
            destroy() {
                this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(), this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy();
            }
        }
        class Wa {
            constructor(t, e, r){
                this.binders = {}, this._buffers = [];
                const n = [];
                for(const i in t.paint._values){
                    if (!r(i)) continue;
                    const a = t.paint.get(i);
                    if (!(a instanceof yi && _r(a.property.specification))) continue;
                    const s = ts(i, t.type), o = a.value, l = a.property.specification.type, u = a.property.useIntegerZoom, c = a.property.specification["property-type"], h = "cross-faded" === c || "cross-faded-data-driven" === c;
                    if ("constant" === o.kind) this.binders[i] = h ? new Ja(o.value, s) : new Ga(o.value, s, l), n.push(`/u_${i}`);
                    else if ("source" === o.kind || h) {
                        const r = es(i, l, "source");
                        this.binders[i] = h ? new Ha(o, l, u, e, r, t.id) : new Xa(o, s, l, r), n.push(`/a_${i}`);
                    } else {
                        const t = es(i, l, "composite");
                        this.binders[i] = new Ya(o, s, l, u, e, t), n.push(`/z_${i}`);
                    }
                }
                this.cacheKey = n.sort().join("");
            }
            getMaxValue(t) {
                const e = this.binders[t];
                return e instanceof Xa || e instanceof Ya ? e.maxValue : 0;
            }
            populatePaintArrays(t, e, r, n, i) {
                for(const a in this.binders){
                    const s = this.binders[a];
                    (s instanceof Xa || s instanceof Ya || s instanceof Ha) && s.populatePaintArray(t, e, r, n, i);
                }
            }
            setConstantPatternPositions(t, e) {
                for(const r in this.binders){
                    const n = this.binders[r];
                    n instanceof Ja && n.setConstantPatternPositions(t, e);
                }
            }
            updatePaintArrays(t, e, r, n, i) {
                let a = !1;
                for(const s in t){
                    const o = e.getPositions(s);
                    for (const e of o){
                        const o = r.feature(e.index);
                        for(const r in this.binders){
                            const l = this.binders[r];
                            if ((l instanceof Xa || l instanceof Ya || l instanceof Ha) && !0 === l.expression.isStateDependent) {
                                const u = n.paint.get(r);
                                l.expression = u.value, l.updatePaintArray(e.start, e.end, o, t[s], i), a = !0;
                            }
                        }
                    }
                }
                return a;
            }
            defines() {
                const t = [];
                for(const e in this.binders){
                    const r = this.binders[e];
                    (r instanceof Ga || r instanceof Ja) && t.push(...r.uniformNames.map((t)=>`#define HAS_UNIFORM_${t}`));
                }
                return t;
            }
            getBinderAttributes() {
                const t = [];
                for(const e in this.binders){
                    const r = this.binders[e];
                    if (r instanceof Xa || r instanceof Ya) for(let e = 0; e < r.paintVertexAttributes.length; e++)t.push(r.paintVertexAttributes[e].name);
                    else if (r instanceof Ha) for(let e = 0; e < Ca.members.length; e++)t.push(Ca.members[e].name);
                }
                return t;
            }
            getBinderUniforms() {
                const t = [];
                for(const e in this.binders){
                    const r = this.binders[e];
                    if (r instanceof Ga || r instanceof Ja || r instanceof Ya) for (const e of r.uniformNames)t.push(e);
                }
                return t;
            }
            getPaintVertexBuffers() {
                return this._buffers;
            }
            getUniforms(t, e) {
                const r = [];
                for(const n in this.binders){
                    const i = this.binders[n];
                    if (i instanceof Ga || i instanceof Ja || i instanceof Ya) {
                        for (const a of i.uniformNames)if (e[a]) {
                            const s = i.getBinding(t, e[a], a);
                            r.push({
                                name: a,
                                property: n,
                                binding: s
                            });
                        }
                    }
                }
                return r;
            }
            setUniforms(t, e, r, n) {
                for (const { name: t, property: i, binding: a } of e)this.binders[i].setUniform(a, n, r.get(i), t);
            }
            updatePaintBuffers(t) {
                this._buffers = [];
                for(const e in this.binders){
                    const r = this.binders[e];
                    if (t && r instanceof Ha) {
                        const e = 2 === t.fromScale ? r.zoomInPaintVertexBuffer : r.zoomOutPaintVertexBuffer;
                        e && this._buffers.push(e);
                    } else (r instanceof Xa || r instanceof Ya) && r.paintVertexBuffer && this._buffers.push(r.paintVertexBuffer);
                }
            }
            upload(t) {
                for(const e in this.binders){
                    const r = this.binders[e];
                    (r instanceof Xa || r instanceof Ya || r instanceof Ha) && r.upload(t);
                }
                this.updatePaintBuffers();
            }
            destroy() {
                for(const t in this.binders){
                    const e = this.binders[t];
                    (e instanceof Xa || e instanceof Ya || e instanceof Ha) && e.destroy();
                }
            }
        }
        class Qa {
            constructor(t, e, r = ()=>!0){
                this.programConfigurations = {};
                for (const n of t)this.programConfigurations[n.id] = new Wa(n, e, r);
                this.needsUpload = !1, this._featureMap = new La, this._bufferOffset = 0;
            }
            populatePaintArrays(t, e, r, n, i, a) {
                for(const r in this.programConfigurations)this.programConfigurations[r].populatePaintArrays(t, e, n, i, a);
                void 0 !== e.id && this._featureMap.add(e.id, r, this._bufferOffset, t), this._bufferOffset = t, this.needsUpload = !0;
            }
            updatePaintArrays(t, e, r, n) {
                for (const i of r)this.needsUpload = this.programConfigurations[i.id].updatePaintArrays(t, this._featureMap, e, i, n) || this.needsUpload;
            }
            get(t) {
                return this.programConfigurations[t];
            }
            upload(t) {
                if (this.needsUpload) {
                    for(const e in this.programConfigurations)this.programConfigurations[e].upload(t);
                    this.needsUpload = !1;
                }
            }
            destroy() {
                for(const t in this.programConfigurations)this.programConfigurations[t].destroy();
            }
        }
        function ts(t, e) {
            return ({
                "text-opacity": [
                    "opacity"
                ],
                "icon-opacity": [
                    "opacity"
                ],
                "text-color": [
                    "fill_color"
                ],
                "icon-color": [
                    "fill_color"
                ],
                "text-halo-color": [
                    "halo_color"
                ],
                "icon-halo-color": [
                    "halo_color"
                ],
                "text-halo-blur": [
                    "halo_blur"
                ],
                "icon-halo-blur": [
                    "halo_blur"
                ],
                "text-halo-width": [
                    "halo_width"
                ],
                "icon-halo-width": [
                    "halo_width"
                ],
                "line-gap-width": [
                    "gapwidth"
                ],
                "line-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ],
                "fill-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ],
                "fill-extrusion-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ]
            })[t] || [
                t.replace(`${e}-`, "").replace(/-/g, "_")
            ];
        }
        function es(t, e, r) {
            const n = {
                color: {
                    source: Ti,
                    composite: Wi
                },
                number: {
                    source: Gi,
                    composite: Ti
                }
            }, i = function(t) {
                return ({
                    "line-pattern": {
                        source: ga,
                        composite: ga
                    },
                    "fill-pattern": {
                        source: ga,
                        composite: ga
                    },
                    "fill-extrusion-pattern": {
                        source: ga,
                        composite: ga
                    }
                })[t];
            }(t);
            return i && i[r] || n[e][r];
        }
        $n("ConstantBinder", Ga), $n("CrossFadedConstantBinder", Ja), $n("SourceExpressionBinder", Xa), $n("CrossFadedCompositeBinder", Ha), $n("CompositeExpressionBinder", Ya), $n("ProgramConfiguration", Wa, {
            omit: [
                "_buffers"
            ]
        }), $n("ProgramConfigurationSet", Qa);
        const rs = 8192, ns = Math.pow(2, 14) - 1, is = -ns - 1;
        function as(t) {
            const e = rs / t.extent, r = t.loadGeometry();
            for(let t = 0; t < r.length; t++){
                const n = r[t];
                for(let t = 0; t < n.length; t++){
                    const r = n[t], i = Math.round(r.x * e), a = Math.round(r.y * e);
                    r.x = y(i, is, ns), r.y = y(a, is, ns), (i < r.x || i > r.x + 1 || a < r.y || a > r.y + 1) && A("Geometry exceeds allowed extent, reduce your vector tile buffer size");
                }
            }
            return r;
        }
        function ss(t, e) {
            return {
                type: t.type,
                id: t.id,
                properties: t.properties,
                geometry: e ? as(t) : []
            };
        }
        function os(t, e, r, n, i) {
            t.emplaceBack(2 * e + (n + 1) / 2, 2 * r + (i + 1) / 2);
        }
        class ls {
            constructor(t){
                this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map((t)=>t.id), this.index = t.index, this.hasPattern = !1, this.layoutVertexArray = new pa, this.indexArray = new Aa, this.segments = new za, this.programConfigurations = new Qa(t.layers, t.zoom), this.stateDependentLayerIds = this.layers.filter((t)=>t.isStateDependent()).map((t)=>t.id);
            }
            populate(t, e, r) {
                const n = this.layers[0], i = [];
                let a = null, s = !1;
                "circle" === n.type && (a = n.layout.get("circle-sort-key"), s = !a.isConstant());
                for (const { feature: e, id: n, index: o, sourceLayerIndex: l } of t){
                    const t = this.layers[0]._featureFilter.needGeometry, u = ss(e, t);
                    if (!this.layers[0]._featureFilter.filter(new li(this.zoom), u, r)) continue;
                    const c = s ? a.evaluate(u, {}, r) : void 0, h = {
                        id: n,
                        properties: e.properties,
                        type: e.type,
                        sourceLayerIndex: l,
                        index: o,
                        geometry: t ? u.geometry : as(e),
                        patterns: {},
                        sortKey: c
                    };
                    i.push(h);
                }
                s && i.sort((t, e)=>t.sortKey - e.sortKey);
                for (const n of i){
                    const { geometry: i, index: a, sourceLayerIndex: s } = n, o = t[a].feature;
                    this.addFeature(n, i, a, r), e.featureIndex.insert(o, i, a, s, this.index);
                }
            }
            update(t, e, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e, this.stateDependentLayers, r);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t) {
                this.uploaded || (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, Ia), this.indexBuffer = t.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            addFeature(t, e, r, n) {
                for (const r of e)for (const e of r){
                    const r = e.x, n = e.y;
                    if (r < 0 || r >= rs || n < 0 || n >= rs) continue;
                    const i = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, t.sortKey), a = i.vertexLength;
                    os(this.layoutVertexArray, r, n, -1, -1), os(this.layoutVertexArray, r, n, 1, -1), os(this.layoutVertexArray, r, n, 1, 1), os(this.layoutVertexArray, r, n, -1, 1), this.indexArray.emplaceBack(a, a + 1, a + 2), this.indexArray.emplaceBack(a, a + 3, a + 2), i.vertexLength += 4, i.primitiveLength += 2;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, {}, n);
            }
        }
        function us(t, e) {
            for(let r = 0; r < t.length; r++)if (xs(e, t[r])) return !0;
            for(let r = 0; r < e.length; r++)if (xs(t, e[r])) return !0;
            return !!fs(t, e);
        }
        function cs(t, e, r) {
            return !!xs(t, e) || !!ys(e, t, r);
        }
        function hs(t, e) {
            if (1 === t.length) return gs(e, t[0]);
            for(let r = 0; r < e.length; r++){
                const n = e[r];
                for(let e = 0; e < n.length; e++)if (xs(t, n[e])) return !0;
            }
            for(let r = 0; r < t.length; r++)if (gs(e, t[r])) return !0;
            for(let r = 0; r < e.length; r++)if (fs(t, e[r])) return !0;
            return !1;
        }
        function ps(t, e, r) {
            if (t.length > 1) {
                if (fs(t, e)) return !0;
                for(let n = 0; n < e.length; n++)if (ys(e[n], t, r)) return !0;
            }
            for(let n = 0; n < t.length; n++)if (ys(t[n], e, r)) return !0;
            return !1;
        }
        function fs(t, e) {
            if (0 === t.length || 0 === e.length) return !1;
            for(let r = 0; r < t.length - 1; r++){
                const n = t[r], i = t[r + 1];
                for(let t = 0; t < e.length - 1; t++)if (ds(n, i, e[t], e[t + 1])) return !0;
            }
            return !1;
        }
        function ds(t, e, r, n) {
            return S(t, r, n) !== S(e, r, n) && S(t, e, r) !== S(t, e, n);
        }
        function ys(t, e, r) {
            const n = r * r;
            if (1 === e.length) return t.distSqr(e[0]) < n;
            for(let r = 1; r < e.length; r++)if (ms(t, e[r - 1], e[r]) < n) return !0;
            return !1;
        }
        function ms(t, e, r) {
            const n = e.distSqr(r);
            if (0 === n) return t.distSqr(e);
            const i = ((t.x - e.x) * (r.x - e.x) + (t.y - e.y) * (r.y - e.y)) / n;
            return t.distSqr(i < 0 ? e : i > 1 ? r : r.sub(e)._mult(i)._add(e));
        }
        function gs(t, e) {
            let r, n, i, a = !1;
            for(let s = 0; s < t.length; s++){
                r = t[s];
                for(let t = 0, s = r.length - 1; t < r.length; s = t++)n = r[t], i = r[s], n.y > e.y != i.y > e.y && e.x < (i.x - n.x) * (e.y - n.y) / (i.y - n.y) + n.x && (a = !a);
            }
            return a;
        }
        function xs(t, e) {
            let r = !1;
            for(let n = 0, i = t.length - 1; n < t.length; i = n++){
                const a = t[n], s = t[i];
                a.y > e.y != s.y > e.y && e.x < (s.x - a.x) * (e.y - a.y) / (s.y - a.y) + a.x && (r = !r);
            }
            return r;
        }
        function vs(t, e, r) {
            const n = r[0], i = r[2];
            if (t.x < n.x && e.x < n.x || t.x > i.x && e.x > i.x || t.y < n.y && e.y < n.y || t.y > i.y && e.y > i.y) return !1;
            const a = S(t, e, r[0]);
            return a !== S(t, e, r[1]) || a !== S(t, e, r[2]) || a !== S(t, e, r[3]);
        }
        function bs(t, e, r) {
            const n = e.paint.get(t).value;
            return "constant" === n.kind ? n.value : r.programConfigurations.get(e.id).getMaxValue(t);
        }
        function ws(t) {
            return Math.sqrt(t[0] * t[0] + t[1] * t[1]);
        }
        function _s(t, e, r, n, i) {
            if (!e[0] && !e[1]) return t;
            const s = a.convert(e)._mult(i);
            "viewport" === r && s._rotate(-n);
            const o = [];
            for(let e = 0; e < t.length; e++)o.push(t[e].sub(s));
            return o;
        }
        let As, Ss;
        $n("CircleBucket", ls, {
            omit: [
                "layers"
            ]
        });
        var ks = {
            get paint () {
                return Ss = Ss || new _i({
                    "circle-radius": new xi(X.paint_circle["circle-radius"]),
                    "circle-color": new xi(X.paint_circle["circle-color"]),
                    "circle-blur": new xi(X.paint_circle["circle-blur"]),
                    "circle-opacity": new xi(X.paint_circle["circle-opacity"]),
                    "circle-translate": new gi(X.paint_circle["circle-translate"]),
                    "circle-translate-anchor": new gi(X.paint_circle["circle-translate-anchor"]),
                    "circle-pitch-scale": new gi(X.paint_circle["circle-pitch-scale"]),
                    "circle-pitch-alignment": new gi(X.paint_circle["circle-pitch-alignment"]),
                    "circle-stroke-width": new xi(X.paint_circle["circle-stroke-width"]),
                    "circle-stroke-color": new xi(X.paint_circle["circle-stroke-color"]),
                    "circle-stroke-opacity": new xi(X.paint_circle["circle-stroke-opacity"])
                });
            },
            get layout () {
                return As = As || new _i({
                    "circle-sort-key": new xi(X.layout_circle["circle-sort-key"])
                });
            }
        }, Is = 1e-6, zs = "undefined" != typeof Float32Array ? Float32Array : Array;
        function Ms(t) {
            return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = 1, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 1, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
        }
        function Cs(t, e, r) {
            var n = e[0], i = e[1], a = e[2], s = e[3], o = e[4], l = e[5], u = e[6], c = e[7], h = e[8], p = e[9], f = e[10], d = e[11], y = e[12], m = e[13], g = e[14], x = e[15], v = r[0], b = r[1], w = r[2], _ = r[3];
            return t[0] = v * n + b * o + w * h + _ * y, t[1] = v * i + b * l + w * p + _ * m, t[2] = v * a + b * u + w * f + _ * g, t[3] = v * s + b * c + w * d + _ * x, t[4] = (v = r[4]) * n + (b = r[5]) * o + (w = r[6]) * h + (_ = r[7]) * y, t[5] = v * i + b * l + w * p + _ * m, t[6] = v * a + b * u + w * f + _ * g, t[7] = v * s + b * c + w * d + _ * x, t[8] = (v = r[8]) * n + (b = r[9]) * o + (w = r[10]) * h + (_ = r[11]) * y, t[9] = v * i + b * l + w * p + _ * m, t[10] = v * a + b * u + w * f + _ * g, t[11] = v * s + b * c + w * d + _ * x, t[12] = (v = r[12]) * n + (b = r[13]) * o + (w = r[14]) * h + (_ = r[15]) * y, t[13] = v * i + b * l + w * p + _ * m, t[14] = v * a + b * u + w * f + _ * g, t[15] = v * s + b * c + w * d + _ * x, t;
        }
        Math.hypot || (Math.hypot = function() {
            for(var t = 0, e = arguments.length; e--;)t += arguments[e] * arguments[e];
            return Math.sqrt(t);
        });
        var Bs, Ps = Cs;
        function Vs(t, e, r) {
            var n = e[0], i = e[1], a = e[2], s = e[3];
            return t[0] = r[0] * n + r[4] * i + r[8] * a + r[12] * s, t[1] = r[1] * n + r[5] * i + r[9] * a + r[13] * s, t[2] = r[2] * n + r[6] * i + r[10] * a + r[14] * s, t[3] = r[3] * n + r[7] * i + r[11] * a + r[15] * s, t;
        }
        Bs = new zs(4), zs != Float32Array && (Bs[0] = 0, Bs[1] = 0, Bs[2] = 0, Bs[3] = 0);
        class Es extends Si {
            constructor(t){
                super(t, ks);
            }
            createBucket(t) {
                return new ls(t);
            }
            queryRadius(t) {
                const e = t;
                return bs("circle-radius", this, e) + bs("circle-stroke-width", this, e) + ws(this.paint.get("circle-translate"));
            }
            queryIntersectsFeature(t, e, r, n, i, a, s, o) {
                const l = _s(t, this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), a.angle, s), u = this.paint.get("circle-radius").evaluate(e, r) + this.paint.get("circle-stroke-width").evaluate(e, r), c = "map" === this.paint.get("circle-pitch-alignment"), h = c ? l : function(t, e) {
                    return t.map((t)=>Fs(t, e));
                }(l, o), p = c ? u * s : u;
                for (const t of n)for (const e of t){
                    const t = c ? e : Fs(e, o);
                    let r = p;
                    const n = Vs([], [
                        e.x,
                        e.y,
                        0,
                        1
                    ], o);
                    if ("viewport" === this.paint.get("circle-pitch-scale") && "map" === this.paint.get("circle-pitch-alignment") ? r *= n[3] / a.cameraToCenterDistance : "map" === this.paint.get("circle-pitch-scale") && "viewport" === this.paint.get("circle-pitch-alignment") && (r *= a.cameraToCenterDistance / n[3]), cs(h, t, r)) return !0;
                }
                return !1;
            }
        }
        function Fs(t, e) {
            const r = Vs([], [
                t.x,
                t.y,
                0,
                1
            ], e);
            return new a(r[0] / r[3], r[1] / r[3]);
        }
        class Ts extends ls {
        }
        let $s;
        $n("HeatmapBucket", Ts, {
            omit: [
                "layers"
            ]
        });
        var Ls = {
            get paint () {
                return $s = $s || new _i({
                    "heatmap-radius": new xi(X.paint_heatmap["heatmap-radius"]),
                    "heatmap-weight": new xi(X.paint_heatmap["heatmap-weight"]),
                    "heatmap-intensity": new gi(X.paint_heatmap["heatmap-intensity"]),
                    "heatmap-color": new wi(X.paint_heatmap["heatmap-color"]),
                    "heatmap-opacity": new gi(X.paint_heatmap["heatmap-opacity"])
                });
            }
        };
        function Ds(t, { width: e, height: r }, n, i) {
            if (i) {
                if (i instanceof Uint8ClampedArray) i = new Uint8Array(i.buffer);
                else if (i.length !== e * r * n) throw new RangeError(`mismatched image size. expected: ${i.length} but got: ${e * r * n}`);
            } else i = new Uint8Array(e * r * n);
            return t.width = e, t.height = r, t.data = i, t;
        }
        function Os(t, { width: e, height: r }, n) {
            if (e === t.width && r === t.height) return;
            const i = Ds({}, {
                width: e,
                height: r
            }, n);
            Us(t, i, {
                x: 0,
                y: 0
            }, {
                x: 0,
                y: 0
            }, {
                width: Math.min(t.width, e),
                height: Math.min(t.height, r)
            }, n), t.width = e, t.height = r, t.data = i.data;
        }
        function Us(t, e, r, n, i, a) {
            if (0 === i.width || 0 === i.height) return e;
            if (i.width > t.width || i.height > t.height || r.x > t.width - i.width || r.y > t.height - i.height) throw new RangeError("out of range source coordinates for image copy");
            if (i.width > e.width || i.height > e.height || n.x > e.width - i.width || n.y > e.height - i.height) throw new RangeError("out of range destination coordinates for image copy");
            const s = t.data, o = e.data;
            if (s === o) throw new Error("srcData equals dstData, so image is already copied");
            for(let l = 0; l < i.height; l++){
                const u = ((r.y + l) * t.width + r.x) * a, c = ((n.y + l) * e.width + n.x) * a;
                for(let t = 0; t < i.width * a; t++)o[c + t] = s[u + t];
            }
            return e;
        }
        class Rs {
            constructor(t, e){
                Ds(this, t, 1, e);
            }
            resize(t) {
                Os(this, t, 1);
            }
            clone() {
                return new Rs({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(t, e, r, n, i) {
                Us(t, e, r, n, i, 1);
            }
        }
        class qs {
            constructor(t, e){
                Ds(this, t, 4, e);
            }
            resize(t) {
                Os(this, t, 4);
            }
            replace(t, e) {
                e ? this.data.set(t) : this.data = t instanceof Uint8ClampedArray ? new Uint8Array(t.buffer) : t;
            }
            clone() {
                return new qs({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(t, e, r, n, i) {
                Us(t, e, r, n, i, 4);
            }
        }
        function js(t) {
            const e = {}, r = t.resolution || 256, n = t.clips ? t.clips.length : 1, i = t.image || new qs({
                width: r,
                height: n
            });
            if (Math.log(r) / Math.LN2 % 1 != 0) throw new Error(`width is not a power of 2 - ${r}`);
            const a = (r, n, a)=>{
                e[t.evaluationKey] = a;
                const s = t.expression.evaluate(e);
                i.data[r + n + 0] = Math.floor(255 * s.r / s.a), i.data[r + n + 1] = Math.floor(255 * s.g / s.a), i.data[r + n + 2] = Math.floor(255 * s.b / s.a), i.data[r + n + 3] = Math.floor(255 * s.a);
            };
            if (t.clips) for(let e = 0, i = 0; e < n; ++e, i += 4 * r)for(let n = 0, s = 0; n < r; n++, s += 4){
                const o = n / (r - 1), { start: l, end: u } = t.clips[e];
                a(i, s, l * (1 - o) + u * o);
            }
            else for(let t = 0, e = 0; t < r; t++, e += 4)a(0, e, t / (r - 1));
            return i;
        }
        $n("AlphaImage", Rs), $n("RGBAImage", qs);
        class Ns extends Si {
            createBucket(t) {
                return new Ts(t);
            }
            constructor(t){
                super(t, Ls), this._updateColorRamp();
            }
            _handleSpecialPaintPropertyUpdate(t) {
                "heatmap-color" === t && this._updateColorRamp();
            }
            _updateColorRamp() {
                this.colorRamp = js({
                    expression: this._transitionablePaint._values["heatmap-color"].value.expression,
                    evaluationKey: "heatmapDensity",
                    image: this.colorRamp
                }), this.colorRampTexture = null;
            }
            resize() {
                this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
            }
            queryRadius() {
                return 0;
            }
            queryIntersectsFeature() {
                return !1;
            }
            hasOffscreenPass() {
                return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
            }
        }
        let Zs;
        var Ks = {
            get paint () {
                return Zs = Zs || new _i({
                    "hillshade-illumination-direction": new gi(X.paint_hillshade["hillshade-illumination-direction"]),
                    "hillshade-illumination-anchor": new gi(X.paint_hillshade["hillshade-illumination-anchor"]),
                    "hillshade-exaggeration": new gi(X.paint_hillshade["hillshade-exaggeration"]),
                    "hillshade-shadow-color": new gi(X.paint_hillshade["hillshade-shadow-color"]),
                    "hillshade-highlight-color": new gi(X.paint_hillshade["hillshade-highlight-color"]),
                    "hillshade-accent-color": new gi(X.paint_hillshade["hillshade-accent-color"])
                });
            }
        };
        class Gs extends Si {
            constructor(t){
                super(t, Ks);
            }
            hasOffscreenPass() {
                return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
            }
        }
        const Js = Mi([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: Xs } = Js;
        var Ys = {
            exports: {}
        };
        function Hs(t, e, r) {
            r = r || 2;
            var n, i, a, s, o, l, u, c = e && e.length, h = c ? e[0] * r : t.length, p = Ws(t, 0, h, r, !0), f = [];
            if (!p || p.next === p.prev) return f;
            if (c && (p = function(t, e, r, n) {
                var i, a, s, o = [];
                for(i = 0, a = e.length; i < a; i++)(s = Ws(t, e[i] * n, i < a - 1 ? e[i + 1] * n : t.length, n, !1)) === s.next && (s.steiner = !0), o.push(uo(s));
                for(o.sort(ao), i = 0; i < o.length; i++)r = so(o[i], r);
                return r;
            }(t, e, p, r)), t.length > 80 * r) {
                n = a = t[0], i = s = t[1];
                for(var d = r; d < h; d += r)(o = t[d]) < n && (n = o), (l = t[d + 1]) < i && (i = l), o > a && (a = o), l > s && (s = l);
                u = 0 !== (u = Math.max(a - n, s - i)) ? 32767 / u : 0;
            }
            return to(p, f, r, n, i, u, 0), f;
        }
        function Ws(t, e, r, n, i) {
            var a, s;
            if (i === Ao(t, e, r, n) > 0) for(a = e; a < r; a += n)s = bo(a, t[a], t[a + 1], s);
            else for(a = r - n; a >= e; a -= n)s = bo(a, t[a], t[a + 1], s);
            return s && fo(s, s.next) && (wo(s), s = s.next), s;
        }
        function Qs(t, e) {
            if (!t) return t;
            e || (e = t);
            var r, n = t;
            do if (r = !1, n.steiner || !fo(n, n.next) && 0 !== po(n.prev, n, n.next)) n = n.next;
            else {
                if (wo(n), (n = e = n.prev) === n.next) break;
                r = !0;
            }
            while (r || n !== e);
            return e;
        }
        function to(t, e, r, n, i, a, s) {
            if (t) {
                !s && a && function(t, e, r, n) {
                    var i = t;
                    do 0 === i.z && (i.z = lo(i.x, i.y, e, r, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
                    while (i !== t);
                    i.prevZ.nextZ = null, i.prevZ = null, function(t) {
                        var e, r, n, i, a, s, o, l, u = 1;
                        do {
                            for(r = t, t = null, a = null, s = 0; r;){
                                for(s++, n = r, o = 0, e = 0; e < u && (o++, n = n.nextZ); e++);
                                for(l = u; o > 0 || l > 0 && n;)0 !== o && (0 === l || !n || r.z <= n.z) ? (i = r, r = r.nextZ, o--) : (i = n, n = n.nextZ, l--), a ? a.nextZ = i : t = i, i.prevZ = a, a = i;
                                r = n;
                            }
                            a.nextZ = null, u *= 2;
                        }while (s > 1);
                    }(i);
                }(t, n, i, a);
                for(var o, l, u = t; t.prev !== t.next;)if (o = t.prev, l = t.next, a ? ro(t, n, i, a) : eo(t)) e.push(o.i / r | 0), e.push(t.i / r | 0), e.push(l.i / r | 0), wo(t), t = l.next, u = l.next;
                else if ((t = l) === u) {
                    s ? 1 === s ? to(t = no(Qs(t), e, r), e, r, n, i, a, 2) : 2 === s && io(t, e, r, n, i, a) : to(Qs(t), e, r, n, i, a, 1);
                    break;
                }
            }
        }
        function eo(t) {
            var e = t.prev, r = t, n = t.next;
            if (po(e, r, n) >= 0) return !1;
            for(var i = e.x, a = r.x, s = n.x, o = e.y, l = r.y, u = n.y, c = i < a ? i < s ? i : s : a < s ? a : s, h = o < l ? o < u ? o : u : l < u ? l : u, p = i > a ? i > s ? i : s : a > s ? a : s, f = o > l ? o > u ? o : u : l > u ? l : u, d = n.next; d !== e;){
                if (d.x >= c && d.x <= p && d.y >= h && d.y <= f && co(i, o, a, l, s, u, d.x, d.y) && po(d.prev, d, d.next) >= 0) return !1;
                d = d.next;
            }
            return !0;
        }
        function ro(t, e, r, n) {
            var i = t.prev, a = t, s = t.next;
            if (po(i, a, s) >= 0) return !1;
            for(var o = i.x, l = a.x, u = s.x, c = i.y, h = a.y, p = s.y, f = o < l ? o < u ? o : u : l < u ? l : u, d = c < h ? c < p ? c : p : h < p ? h : p, y = o > l ? o > u ? o : u : l > u ? l : u, m = c > h ? c > p ? c : p : h > p ? h : p, g = lo(f, d, e, r, n), x = lo(y, m, e, r, n), v = t.prevZ, b = t.nextZ; v && v.z >= g && b && b.z <= x;){
                if (v.x >= f && v.x <= y && v.y >= d && v.y <= m && v !== i && v !== s && co(o, c, l, h, u, p, v.x, v.y) && po(v.prev, v, v.next) >= 0) return !1;
                if (v = v.prevZ, b.x >= f && b.x <= y && b.y >= d && b.y <= m && b !== i && b !== s && co(o, c, l, h, u, p, b.x, b.y) && po(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            for(; v && v.z >= g;){
                if (v.x >= f && v.x <= y && v.y >= d && v.y <= m && v !== i && v !== s && co(o, c, l, h, u, p, v.x, v.y) && po(v.prev, v, v.next) >= 0) return !1;
                v = v.prevZ;
            }
            for(; b && b.z <= x;){
                if (b.x >= f && b.x <= y && b.y >= d && b.y <= m && b !== i && b !== s && co(o, c, l, h, u, p, b.x, b.y) && po(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            return !0;
        }
        function no(t, e, r) {
            var n = t;
            do {
                var i = n.prev, a = n.next.next;
                !fo(i, a) && yo(i, n, n.next, a) && xo(i, a) && xo(a, i) && (e.push(i.i / r | 0), e.push(n.i / r | 0), e.push(a.i / r | 0), wo(n), wo(n.next), n = t = a), n = n.next;
            }while (n !== t);
            return Qs(n);
        }
        function io(t, e, r, n, i, a) {
            var s = t;
            do {
                for(var o = s.next.next; o !== s.prev;){
                    if (s.i !== o.i && ho(s, o)) {
                        var l = vo(s, o);
                        return s = Qs(s, s.next), l = Qs(l, l.next), to(s, e, r, n, i, a, 0), void to(l, e, r, n, i, a, 0);
                    }
                    o = o.next;
                }
                s = s.next;
            }while (s !== t);
        }
        function ao(t, e) {
            return t.x - e.x;
        }
        function so(t, e) {
            var r = function(t, e) {
                var r, n = e, i = t.x, a = t.y, s = -1 / 0;
                do {
                    if (a <= n.y && a >= n.next.y && n.next.y !== n.y) {
                        var o = n.x + (a - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
                        if (o <= i && o > s && (s = o, r = n.x < n.next.x ? n : n.next, o === i)) return r;
                    }
                    n = n.next;
                }while (n !== e);
                if (!r) return null;
                var l, u = r, c = r.x, h = r.y, p = 1 / 0;
                n = r;
                do i >= n.x && n.x >= c && i !== n.x && co(a < h ? i : s, a, c, h, a < h ? s : i, a, n.x, n.y) && (l = Math.abs(a - n.y) / (i - n.x), xo(n, t) && (l < p || l === p && (n.x > r.x || n.x === r.x && oo(r, n))) && (r = n, p = l)), n = n.next;
                while (n !== u);
                return r;
            }(t, e);
            if (!r) return e;
            var n = vo(r, t);
            return Qs(n, n.next), Qs(r, r.next);
        }
        function oo(t, e) {
            return po(t.prev, t, e.prev) < 0 && po(e.next, t, t.next) < 0;
        }
        function lo(t, e, r, n, i) {
            return (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = (t - r) * i | 0) | t << 8)) | t << 4)) | t << 2)) | t << 1)) | (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = (e - n) * i | 0) | e << 8)) | e << 4)) | e << 2)) | e << 1)) << 1;
        }
        function uo(t) {
            var e = t, r = t;
            do (e.x < r.x || e.x === r.x && e.y < r.y) && (r = e), e = e.next;
            while (e !== t);
            return r;
        }
        function co(t, e, r, n, i, a, s, o) {
            return (i - s) * (e - o) >= (t - s) * (a - o) && (t - s) * (n - o) >= (r - s) * (e - o) && (r - s) * (a - o) >= (i - s) * (n - o);
        }
        function ho(t, e) {
            return t.next.i !== e.i && t.prev.i !== e.i && !function(t, e) {
                var r = t;
                do {
                    if (r.i !== t.i && r.next.i !== t.i && r.i !== e.i && r.next.i !== e.i && yo(r, r.next, t, e)) return !0;
                    r = r.next;
                }while (r !== t);
                return !1;
            }(t, e) && (xo(t, e) && xo(e, t) && function(t, e) {
                var r = t, n = !1, i = (t.x + e.x) / 2, a = (t.y + e.y) / 2;
                do r.y > a != r.next.y > a && r.next.y !== r.y && i < (r.next.x - r.x) * (a - r.y) / (r.next.y - r.y) + r.x && (n = !n), r = r.next;
                while (r !== t);
                return n;
            }(t, e) && (po(t.prev, t, e.prev) || po(t, e.prev, e)) || fo(t, e) && po(t.prev, t, t.next) > 0 && po(e.prev, e, e.next) > 0);
        }
        function po(t, e, r) {
            return (e.y - t.y) * (r.x - e.x) - (e.x - t.x) * (r.y - e.y);
        }
        function fo(t, e) {
            return t.x === e.x && t.y === e.y;
        }
        function yo(t, e, r, n) {
            var i = go(po(t, e, r)), a = go(po(t, e, n)), s = go(po(r, n, t)), o = go(po(r, n, e));
            return i !== a && s !== o || !(0 !== i || !mo(t, r, e)) || !(0 !== a || !mo(t, n, e)) || !(0 !== s || !mo(r, t, n)) || !(0 !== o || !mo(r, e, n));
        }
        function mo(t, e, r) {
            return e.x <= Math.max(t.x, r.x) && e.x >= Math.min(t.x, r.x) && e.y <= Math.max(t.y, r.y) && e.y >= Math.min(t.y, r.y);
        }
        function go(t) {
            return t > 0 ? 1 : t < 0 ? -1 : 0;
        }
        function xo(t, e) {
            return po(t.prev, t, t.next) < 0 ? po(t, e, t.next) >= 0 && po(t, t.prev, e) >= 0 : po(t, e, t.prev) < 0 || po(t, t.next, e) < 0;
        }
        function vo(t, e) {
            var r = new _o(t.i, t.x, t.y), n = new _o(e.i, e.x, e.y), i = t.next, a = e.prev;
            return t.next = e, e.prev = t, r.next = i, i.prev = r, n.next = r, r.prev = n, a.next = n, n.prev = a, n;
        }
        function bo(t, e, r, n) {
            var i = new _o(t, e, r);
            return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
        }
        function wo(t) {
            t.next.prev = t.prev, t.prev.next = t.next, t.prevZ && (t.prevZ.nextZ = t.nextZ), t.nextZ && (t.nextZ.prevZ = t.prevZ);
        }
        function _o(t, e, r) {
            this.i = t, this.x = e, this.y = r, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
        }
        function Ao(t, e, r, n) {
            for(var i = 0, a = e, s = r - n; a < r; a += n)i += (t[s] - t[a]) * (t[a + 1] + t[s + 1]), s = a;
            return i;
        }
        Ys.exports = Hs, Ys.exports.default = Hs, Hs.deviation = function(t, e, r, n) {
            var i = e && e.length, a = Math.abs(Ao(t, 0, i ? e[0] * r : t.length, r));
            if (i) for(var s = 0, o = e.length; s < o; s++)a -= Math.abs(Ao(t, e[s] * r, s < o - 1 ? e[s + 1] * r : t.length, r));
            var l = 0;
            for(s = 0; s < n.length; s += 3){
                var u = n[s] * r, c = n[s + 1] * r, h = n[s + 2] * r;
                l += Math.abs((t[u] - t[h]) * (t[c + 1] - t[u + 1]) - (t[u] - t[c]) * (t[h + 1] - t[u + 1]));
            }
            return 0 === a && 0 === l ? 0 : Math.abs((l - a) / a);
        }, Hs.flatten = function(t) {
            for(var e = t[0][0].length, r = {
                vertices: [],
                holes: [],
                dimensions: e
            }, n = 0, i = 0; i < t.length; i++){
                for(var a = 0; a < t[i].length; a++)for(var s = 0; s < e; s++)r.vertices.push(t[i][a][s]);
                i > 0 && r.holes.push(n += t[i - 1].length);
            }
            return r;
        };
        var So = r(Ys.exports);
        function ko(t, e, r, n, i) {
            Io(t, e, r || 0, n || t.length - 1, i || Mo);
        }
        function Io(t, e, r, n, i) {
            for(; n > r;){
                if (n - r > 600) {
                    var a = n - r + 1, s = e - r + 1, o = Math.log(a), l = .5 * Math.exp(2 * o / 3), u = .5 * Math.sqrt(o * l * (a - l) / a) * (s - a / 2 < 0 ? -1 : 1);
                    Io(t, e, Math.max(r, Math.floor(e - s * l / a + u)), Math.min(n, Math.floor(e + (a - s) * l / a + u)), i);
                }
                var c = t[e], h = r, p = n;
                for(zo(t, r, e), i(t[n], c) > 0 && zo(t, r, n); h < p;){
                    for(zo(t, h, p), h++, p--; i(t[h], c) < 0;)h++;
                    for(; i(t[p], c) > 0;)p--;
                }
                0 === i(t[r], c) ? zo(t, r, p) : zo(t, ++p, n), p <= e && (r = p + 1), e <= p && (n = p - 1);
            }
        }
        function zo(t, e, r) {
            var n = t[e];
            t[e] = t[r], t[r] = n;
        }
        function Mo(t, e) {
            return t < e ? -1 : t > e ? 1 : 0;
        }
        function Co(t, e) {
            const r = t.length;
            if (r <= 1) return [
                t
            ];
            const n = [];
            let i, a;
            for(let e = 0; e < r; e++){
                const r = k(t[e]);
                0 !== r && (t[e].area = Math.abs(r), void 0 === a && (a = r < 0), a === r < 0 ? (i && n.push(i), i = [
                    t[e]
                ]) : i.push(t[e]));
            }
            if (i && n.push(i), e > 1) for(let t = 0; t < n.length; t++)n[t].length <= e || (ko(n[t], e, 1, n[t].length - 1, Bo), n[t] = n[t].slice(0, e));
            return n;
        }
        function Bo(t, e) {
            return e.area - t.area;
        }
        function Po(t, e, r) {
            const n = r.patternDependencies;
            let i = !1;
            for (const r of e){
                const e = r.paint.get(`${t}-pattern`);
                e.isConstant() || (i = !0);
                const a = e.constantOr(null);
                a && (i = !0, n[a.to] = !0, n[a.from] = !0);
            }
            return i;
        }
        function Vo(t, e, r, n, i) {
            const a = i.patternDependencies;
            for (const s of e){
                const e = s.paint.get(`${t}-pattern`).value;
                if ("constant" !== e.kind) {
                    let t = e.evaluate({
                        zoom: n - 1
                    }, r, {}, i.availableImages), o = e.evaluate({
                        zoom: n
                    }, r, {}, i.availableImages), l = e.evaluate({
                        zoom: n + 1
                    }, r, {}, i.availableImages);
                    t = t && t.name ? t.name : t, o = o && o.name ? o.name : o, l = l && l.name ? l.name : l, a[t] = !0, a[o] = !0, a[l] = !0, r.patterns[s.id] = {
                        min: t,
                        mid: o,
                        max: l
                    };
                }
            }
            return r;
        }
        class Eo {
            constructor(t){
                this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map((t)=>t.id), this.index = t.index, this.hasPattern = !1, this.patternFeatures = [], this.layoutVertexArray = new fa, this.indexArray = new Aa, this.indexArray2 = new Sa, this.programConfigurations = new Qa(t.layers, t.zoom), this.segments = new za, this.segments2 = new za, this.stateDependentLayerIds = this.layers.filter((t)=>t.isStateDependent()).map((t)=>t.id);
            }
            populate(t, e, r) {
                this.hasPattern = Po("fill", this.layers, e);
                const n = this.layers[0].layout.get("fill-sort-key"), i = !n.isConstant(), a = [];
                for (const { feature: s, id: o, index: l, sourceLayerIndex: u } of t){
                    const t = this.layers[0]._featureFilter.needGeometry, c = ss(s, t);
                    if (!this.layers[0]._featureFilter.filter(new li(this.zoom), c, r)) continue;
                    const h = i ? n.evaluate(c, {}, r, e.availableImages) : void 0, p = {
                        id: o,
                        properties: s.properties,
                        type: s.type,
                        sourceLayerIndex: u,
                        index: l,
                        geometry: t ? c.geometry : as(s),
                        patterns: {},
                        sortKey: h
                    };
                    a.push(p);
                }
                i && a.sort((t, e)=>t.sortKey - e.sortKey);
                for (const n of a){
                    const { geometry: i, index: a, sourceLayerIndex: s } = n;
                    if (this.hasPattern) {
                        const t = Vo("fill", this.layers, n, this.zoom, e);
                        this.patternFeatures.push(t);
                    } else this.addFeature(n, i, a, r, {});
                    e.featureIndex.insert(t[a].feature, i, a, s, this.index);
                }
            }
            update(t, e, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e, this.stateDependentLayers, r);
            }
            addFeatures(t, e, r) {
                for (const t of this.patternFeatures)this.addFeature(t, t.geometry, t.index, e, r);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t) {
                this.uploaded || (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, Xs), this.indexBuffer = t.createIndexBuffer(this.indexArray), this.indexBuffer2 = t.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(t), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
            }
            addFeature(t, e, r, n, i) {
                for (const t of Co(e, 500)){
                    let e = 0;
                    for (const r of t)e += r.length;
                    const r = this.segments.prepareSegment(e, this.layoutVertexArray, this.indexArray), n = r.vertexLength, i = [], a = [];
                    for (const e of t){
                        if (0 === e.length) continue;
                        e !== t[0] && a.push(i.length / 2);
                        const r = this.segments2.prepareSegment(e.length, this.layoutVertexArray, this.indexArray2), n = r.vertexLength;
                        this.layoutVertexArray.emplaceBack(e[0].x, e[0].y), this.indexArray2.emplaceBack(n + e.length - 1, n), i.push(e[0].x), i.push(e[0].y);
                        for(let t = 1; t < e.length; t++)this.layoutVertexArray.emplaceBack(e[t].x, e[t].y), this.indexArray2.emplaceBack(n + t - 1, n + t), i.push(e[t].x), i.push(e[t].y);
                        r.vertexLength += e.length, r.primitiveLength += e.length;
                    }
                    const s = So(i, a);
                    for(let t = 0; t < s.length; t += 3)this.indexArray.emplaceBack(n + s[t], n + s[t + 1], n + s[t + 2]);
                    r.vertexLength += e, r.primitiveLength += s.length / 3;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, i, n);
            }
        }
        let Fo, To;
        $n("FillBucket", Eo, {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        var $o = {
            get paint () {
                return To = To || new _i({
                    "fill-antialias": new gi(X.paint_fill["fill-antialias"]),
                    "fill-opacity": new xi(X.paint_fill["fill-opacity"]),
                    "fill-color": new xi(X.paint_fill["fill-color"]),
                    "fill-outline-color": new xi(X.paint_fill["fill-outline-color"]),
                    "fill-translate": new gi(X.paint_fill["fill-translate"]),
                    "fill-translate-anchor": new gi(X.paint_fill["fill-translate-anchor"]),
                    "fill-pattern": new vi(X.paint_fill["fill-pattern"])
                });
            },
            get layout () {
                return Fo = Fo || new _i({
                    "fill-sort-key": new xi(X.layout_fill["fill-sort-key"])
                });
            }
        };
        class Lo extends Si {
            constructor(t){
                super(t, $o);
            }
            recalculate(t, e) {
                super.recalculate(t, e);
                const r = this.paint._values["fill-outline-color"];
                "constant" === r.value.kind && void 0 === r.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
            }
            createBucket(t) {
                return new Eo(t);
            }
            queryRadius() {
                return ws(this.paint.get("fill-translate"));
            }
            queryIntersectsFeature(t, e, r, n, i, a, s) {
                return hs(_s(t, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), a.angle, s), n);
            }
            isTileClipped() {
                return !0;
            }
        }
        const Do = Mi([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_normal_ed",
                components: 4,
                type: "Int16"
            }
        ], 4), Oo = Mi([
            {
                name: "a_centroid",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: Uo } = Do;
        var Ro = {}, qo = n, jo = No;
        function No(t, e, r, n, i) {
            this.properties = {}, this.extent = r, this.type = 0, this._pbf = t, this._geometry = -1, this._keys = n, this._values = i, t.readFields(Zo, this, e);
        }
        function Zo(t, e, r) {
            1 == t ? e.id = r.readVarint() : 2 == t ? function(t, e) {
                for(var r = t.readVarint() + t.pos; t.pos < r;){
                    var n = e._keys[t.readVarint()], i = e._values[t.readVarint()];
                    e.properties[n] = i;
                }
            }(r, e) : 3 == t ? e.type = r.readVarint() : 4 == t && (e._geometry = r.pos);
        }
        function Ko(t) {
            for(var e, r, n = 0, i = 0, a = t.length, s = a - 1; i < a; s = i++)n += ((r = t[s]).x - (e = t[i]).x) * (e.y + r.y);
            return n;
        }
        No.types = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ], No.prototype.loadGeometry = function() {
            var t = this._pbf;
            t.pos = this._geometry;
            for(var e, r = t.readVarint() + t.pos, n = 1, i = 0, a = 0, s = 0, o = []; t.pos < r;){
                if (i <= 0) {
                    var l = t.readVarint();
                    n = 7 & l, i = l >> 3;
                }
                if (i--, 1 === n || 2 === n) a += t.readSVarint(), s += t.readSVarint(), 1 === n && (e && o.push(e), e = []), e.push(new qo(a, s));
                else {
                    if (7 !== n) throw new Error("unknown command " + n);
                    e && e.push(e[0].clone());
                }
            }
            return e && o.push(e), o;
        }, No.prototype.bbox = function() {
            var t = this._pbf;
            t.pos = this._geometry;
            for(var e = t.readVarint() + t.pos, r = 1, n = 0, i = 0, a = 0, s = 1 / 0, o = -1 / 0, l = 1 / 0, u = -1 / 0; t.pos < e;){
                if (n <= 0) {
                    var c = t.readVarint();
                    r = 7 & c, n = c >> 3;
                }
                if (n--, 1 === r || 2 === r) (i += t.readSVarint()) < s && (s = i), i > o && (o = i), (a += t.readSVarint()) < l && (l = a), a > u && (u = a);
                else if (7 !== r) throw new Error("unknown command " + r);
            }
            return [
                s,
                l,
                o,
                u
            ];
        }, No.prototype.toGeoJSON = function(t, e, r) {
            var n, i, a = this.extent * Math.pow(2, r), s = this.extent * t, o = this.extent * e, l = this.loadGeometry(), u = No.types[this.type];
            function c(t) {
                for(var e = 0; e < t.length; e++){
                    var r = t[e];
                    t[e] = [
                        360 * (r.x + s) / a - 180,
                        360 / Math.PI * Math.atan(Math.exp((180 - 360 * (r.y + o) / a) * Math.PI / 180)) - 90
                    ];
                }
            }
            switch(this.type){
                case 1:
                    var h = [];
                    for(n = 0; n < l.length; n++)h[n] = l[n][0];
                    c(l = h);
                    break;
                case 2:
                    for(n = 0; n < l.length; n++)c(l[n]);
                    break;
                case 3:
                    for(l = function(t) {
                        var e = t.length;
                        if (e <= 1) return [
                            t
                        ];
                        for(var r, n, i = [], a = 0; a < e; a++){
                            var s = Ko(t[a]);
                            0 !== s && (void 0 === n && (n = s < 0), n === s < 0 ? (r && i.push(r), r = [
                                t[a]
                            ]) : r.push(t[a]));
                        }
                        return r && i.push(r), i;
                    }(l), n = 0; n < l.length; n++)for(i = 0; i < l[n].length; i++)c(l[n][i]);
            }
            1 === l.length ? l = l[0] : u = "Multi" + u;
            var p = {
                type: "Feature",
                geometry: {
                    type: u,
                    coordinates: l
                },
                properties: this.properties
            };
            return "id" in this && (p.id = this.id), p;
        };
        var Go = jo, Jo = Xo;
        function Xo(t, e) {
            this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = t, this._keys = [], this._values = [], this._features = [], t.readFields(Yo, this, e), this.length = this._features.length;
        }
        function Yo(t, e, r) {
            15 === t ? e.version = r.readVarint() : 1 === t ? e.name = r.readString() : 5 === t ? e.extent = r.readVarint() : 2 === t ? e._features.push(r.pos) : 3 === t ? e._keys.push(r.readString()) : 4 === t && e._values.push(function(t) {
                for(var e = null, r = t.readVarint() + t.pos; t.pos < r;){
                    var n = t.readVarint() >> 3;
                    e = 1 === n ? t.readString() : 2 === n ? t.readFloat() : 3 === n ? t.readDouble() : 4 === n ? t.readVarint64() : 5 === n ? t.readVarint() : 6 === n ? t.readSVarint() : 7 === n ? t.readBoolean() : null;
                }
                return e;
            }(r));
        }
        Xo.prototype.feature = function(t) {
            if (t < 0 || t >= this._features.length) throw new Error("feature index out of bounds");
            this._pbf.pos = this._features[t];
            var e = this._pbf.readVarint() + this._pbf.pos;
            return new Go(this._pbf, e, this.extent, this._keys, this._values);
        };
        var Ho = Jo;
        function Wo(t, e, r) {
            if (3 === t) {
                var n = new Ho(r, r.readVarint() + r.pos);
                n.length && (e[n.name] = n);
            }
        }
        Ro.VectorTile = function(t, e) {
            this.layers = t.readFields(Wo, {}, e);
        }, Ro.VectorTileFeature = jo, Ro.VectorTileLayer = Jo;
        const Qo = Ro.VectorTileFeature.types, tl = Math.pow(2, 13);
        function el(t, e, r, n, i, a, s, o) {
            t.emplaceBack(e, r, 2 * Math.floor(n * tl) + s, i * tl * 2, a * tl * 2, Math.round(o));
        }
        class rl {
            constructor(t){
                this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map((t)=>t.id), this.index = t.index, this.hasPattern = !1, this.layoutVertexArray = new da, this.centroidVertexArray = new ha, this.indexArray = new Aa, this.programConfigurations = new Qa(t.layers, t.zoom), this.segments = new za, this.stateDependentLayerIds = this.layers.filter((t)=>t.isStateDependent()).map((t)=>t.id);
            }
            populate(t, e, r) {
                this.features = [], this.hasPattern = Po("fill-extrusion", this.layers, e);
                for (const { feature: n, id: i, index: a, sourceLayerIndex: s } of t){
                    const t = this.layers[0]._featureFilter.needGeometry, o = ss(n, t);
                    if (!this.layers[0]._featureFilter.filter(new li(this.zoom), o, r)) continue;
                    const l = {
                        id: i,
                        sourceLayerIndex: s,
                        index: a,
                        geometry: t ? o.geometry : as(n),
                        properties: n.properties,
                        type: n.type,
                        patterns: {}
                    };
                    this.hasPattern ? this.features.push(Vo("fill-extrusion", this.layers, l, this.zoom, e)) : this.addFeature(l, l.geometry, a, r, {}), e.featureIndex.insert(n, l.geometry, a, s, this.index, !0);
                }
            }
            addFeatures(t, e, r) {
                for (const t of this.features){
                    const { geometry: n } = t;
                    this.addFeature(t, n, t.index, e, r);
                }
            }
            update(t, e, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e, this.stateDependentLayers, r);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length && 0 === this.centroidVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t) {
                this.uploaded || (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, Uo), this.centroidVertexBuffer = t.createVertexBuffer(this.centroidVertexArray, Oo.members, !0), this.indexBuffer = t.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.centroidVertexBuffer.destroy());
            }
            addFeature(t, e, r, n, i) {
                const a = {
                    x: 0,
                    y: 0,
                    vertexCount: 0
                };
                for (const r of Co(e, 500)){
                    let e = 0;
                    for (const t of r)e += t.length;
                    let n = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray);
                    for (const t of r){
                        if (0 === t.length) continue;
                        if (il(t)) continue;
                        let e = 0;
                        for(let r = 0; r < t.length; r++){
                            const i = t[r];
                            if (r >= 1) {
                                const s = t[r - 1];
                                if (!nl(i, s)) {
                                    n.vertexLength + 4 > za.MAX_VERTEX_ARRAY_LENGTH && (n = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray));
                                    const t = i.sub(s)._perp()._unit(), r = s.dist(i);
                                    e + r > 32768 && (e = 0), el(this.layoutVertexArray, i.x, i.y, t.x, t.y, 0, 0, e), el(this.layoutVertexArray, i.x, i.y, t.x, t.y, 0, 1, e), a.x += 2 * i.x, a.y += 2 * i.y, a.vertexCount += 2, e += r, el(this.layoutVertexArray, s.x, s.y, t.x, t.y, 0, 0, e), el(this.layoutVertexArray, s.x, s.y, t.x, t.y, 0, 1, e), a.x += 2 * s.x, a.y += 2 * s.y, a.vertexCount += 2;
                                    const o = n.vertexLength;
                                    this.indexArray.emplaceBack(o, o + 2, o + 1), this.indexArray.emplaceBack(o + 1, o + 2, o + 3), n.vertexLength += 4, n.primitiveLength += 2;
                                }
                            }
                        }
                    }
                    if (n.vertexLength + e > za.MAX_VERTEX_ARRAY_LENGTH && (n = this.segments.prepareSegment(e, this.layoutVertexArray, this.indexArray)), "Polygon" !== Qo[t.type]) continue;
                    const i = [], s = [], o = n.vertexLength;
                    for (const t of r)if (0 !== t.length) {
                        t !== r[0] && s.push(i.length / 2);
                        for(let e = 0; e < t.length; e++){
                            const r = t[e];
                            el(this.layoutVertexArray, r.x, r.y, 0, 0, 1, 1, 0), a.x += r.x, a.y += r.y, a.vertexCount += 1, i.push(r.x), i.push(r.y);
                        }
                    }
                    const l = So(i, s);
                    for(let t = 0; t < l.length; t += 3)this.indexArray.emplaceBack(o + l[t], o + l[t + 2], o + l[t + 1]);
                    n.primitiveLength += l.length / 3, n.vertexLength += e;
                }
                for(let t = 0; t < a.vertexCount; t++)this.centroidVertexArray.emplaceBack(Math.floor(a.x / a.vertexCount), Math.floor(a.y / a.vertexCount));
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, i, n);
            }
        }
        function nl(t, e) {
            return t.x === e.x && (t.x < 0 || t.x > rs) || t.y === e.y && (t.y < 0 || t.y > rs);
        }
        function il(t) {
            return t.every((t)=>t.x < 0) || t.every((t)=>t.x > rs) || t.every((t)=>t.y < 0) || t.every((t)=>t.y > rs);
        }
        let al;
        $n("FillExtrusionBucket", rl, {
            omit: [
                "layers",
                "features"
            ]
        });
        var sl = {
            get paint () {
                return al = al || new _i({
                    "fill-extrusion-opacity": new gi(X["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                    "fill-extrusion-color": new xi(X["paint_fill-extrusion"]["fill-extrusion-color"]),
                    "fill-extrusion-translate": new gi(X["paint_fill-extrusion"]["fill-extrusion-translate"]),
                    "fill-extrusion-translate-anchor": new gi(X["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                    "fill-extrusion-pattern": new vi(X["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                    "fill-extrusion-height": new xi(X["paint_fill-extrusion"]["fill-extrusion-height"]),
                    "fill-extrusion-base": new xi(X["paint_fill-extrusion"]["fill-extrusion-base"]),
                    "fill-extrusion-vertical-gradient": new gi(X["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])
                });
            }
        };
        class ol extends Si {
            constructor(t){
                super(t, sl);
            }
            createBucket(t) {
                return new rl(t);
            }
            queryRadius() {
                return ws(this.paint.get("fill-extrusion-translate"));
            }
            is3D() {
                return !0;
            }
            queryIntersectsFeature(t, e, r, n, i, s, o, l) {
                const u = _s(t, this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), s.angle, o), c = this.paint.get("fill-extrusion-height").evaluate(e, r), h = this.paint.get("fill-extrusion-base").evaluate(e, r), p = function(t, e, r, n) {
                    const i = [];
                    for (const r of t){
                        const t = [
                            r.x,
                            r.y,
                            0,
                            1
                        ];
                        Vs(t, t, e), i.push(new a(t[0] / t[3], t[1] / t[3]));
                    }
                    return i;
                }(u, l), f = function(t, e, r, n) {
                    const i = [], s = [], o = n[8] * e, l = n[9] * e, u = n[10] * e, c = n[11] * e, h = n[8] * r, p = n[9] * r, f = n[10] * r, d = n[11] * r;
                    for (const e of t){
                        const t = [], r = [];
                        for (const i of e){
                            const e = i.x, s = i.y, y = n[0] * e + n[4] * s + n[12], m = n[1] * e + n[5] * s + n[13], g = n[2] * e + n[6] * s + n[14], x = n[3] * e + n[7] * s + n[15], v = g + u, b = x + c, w = y + h, _ = m + p, A = g + f, S = x + d, k = new a((y + o) / b, (m + l) / b);
                            k.z = v / b, t.push(k);
                            const I = new a(w / S, _ / S);
                            I.z = A / S, r.push(I);
                        }
                        i.push(t), s.push(r);
                    }
                    return [
                        i,
                        s
                    ];
                }(n, h, c, l);
                return function(t, e, r) {
                    let n = 1 / 0;
                    hs(r, e) && (n = ul(r, e[0]));
                    for(let i = 0; i < e.length; i++){
                        const a = e[i], s = t[i];
                        for(let t = 0; t < a.length - 1; t++){
                            const e = a[t], i = [
                                e,
                                a[t + 1],
                                s[t + 1],
                                s[t],
                                e
                            ];
                            us(r, i) && (n = Math.min(n, ul(r, i)));
                        }
                    }
                    return n !== 1 / 0 && n;
                }(f[0], f[1], p);
            }
        }
        function ll(t, e) {
            return t.x * e.x + t.y * e.y;
        }
        function ul(t, e) {
            if (1 === t.length) {
                let r = 0;
                const n = e[r++];
                let i;
                for(; !i || n.equals(i);)if (i = e[r++], !i) return 1 / 0;
                for(; r < e.length; r++){
                    const a = e[r], s = t[0], o = i.sub(n), l = a.sub(n), u = s.sub(n), c = ll(o, o), h = ll(o, l), p = ll(l, l), f = ll(u, o), d = ll(u, l), y = c * p - h * h, m = (p * f - h * d) / y, g = (c * d - h * f) / y, x = n.z * (1 - m - g) + i.z * m + a.z * g;
                    if (isFinite(x)) return x;
                }
                return 1 / 0;
            }
            {
                let t = 1 / 0;
                for (const r of e)t = Math.min(t, r.z);
                return t;
            }
        }
        const cl = Mi([
            {
                name: "a_pos_normal",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint8"
            }
        ], 4), { members: hl } = cl, pl = Mi([
            {
                name: "a_uv_x",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_split_index",
                components: 1,
                type: "Float32"
            }
        ]), { members: fl } = pl, dl = Ro.VectorTileFeature.types, yl = Math.cos(Math.PI / 180 * 37.5), ml = Math.pow(2, 14) / .5;
        class gl {
            constructor(t){
                this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map((t)=>t.id), this.index = t.index, this.hasPattern = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((t)=>{
                    this.gradients[t.id] = {};
                }), this.layoutVertexArray = new ya, this.layoutVertexArray2 = new ma, this.indexArray = new Aa, this.programConfigurations = new Qa(t.layers, t.zoom), this.segments = new za, this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter((t)=>t.isStateDependent()).map((t)=>t.id);
            }
            populate(t, e, r) {
                this.hasPattern = Po("line", this.layers, e);
                const n = this.layers[0].layout.get("line-sort-key"), i = !n.isConstant(), a = [];
                for (const { feature: e, id: s, index: o, sourceLayerIndex: l } of t){
                    const t = this.layers[0]._featureFilter.needGeometry, u = ss(e, t);
                    if (!this.layers[0]._featureFilter.filter(new li(this.zoom), u, r)) continue;
                    const c = i ? n.evaluate(u, {}, r) : void 0, h = {
                        id: s,
                        properties: e.properties,
                        type: e.type,
                        sourceLayerIndex: l,
                        index: o,
                        geometry: t ? u.geometry : as(e),
                        patterns: {},
                        sortKey: c
                    };
                    a.push(h);
                }
                i && a.sort((t, e)=>t.sortKey - e.sortKey);
                for (const n of a){
                    const { geometry: i, index: a, sourceLayerIndex: s } = n;
                    if (this.hasPattern) {
                        const t = Vo("line", this.layers, n, this.zoom, e);
                        this.patternFeatures.push(t);
                    } else this.addFeature(n, i, a, r, {});
                    e.featureIndex.insert(t[a].feature, i, a, s, this.index);
                }
            }
            update(t, e, r) {
                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e, this.stateDependentLayers, r);
            }
            addFeatures(t, e, r) {
                for (const t of this.patternFeatures)this.addFeature(t, t.geometry, t.index, e, r);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t) {
                this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = t.createVertexBuffer(this.layoutVertexArray2, fl)), this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, hl), this.indexBuffer = t.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            lineFeatureClips(t) {
                if (t.properties && Object.prototype.hasOwnProperty.call(t.properties, "mapbox_clip_start") && Object.prototype.hasOwnProperty.call(t.properties, "mapbox_clip_end")) return {
                    start: +t.properties.mapbox_clip_start,
                    end: +t.properties.mapbox_clip_end
                };
            }
            addFeature(t, e, r, n, i) {
                const a = this.layers[0].layout, s = a.get("line-join").evaluate(t, {}), o = a.get("line-cap"), l = a.get("line-miter-limit"), u = a.get("line-round-limit");
                this.lineClips = this.lineFeatureClips(t);
                for (const r of e)this.addLine(r, t, s, o, l, u);
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, i, n);
            }
            addLine(t, e, r, n, i, a) {
                if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.lineClips) {
                    this.lineClipsArray.push(this.lineClips);
                    for(let e = 0; e < t.length - 1; e++)this.totalDistance += t[e].dist(t[e + 1]);
                    this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                }
                const s = "Polygon" === dl[e.type];
                let o = t.length;
                for(; o >= 2 && t[o - 1].equals(t[o - 2]);)o--;
                let l = 0;
                for(; l < o - 1 && t[l].equals(t[l + 1]);)l++;
                if (o < (s ? 3 : 2)) return;
                "bevel" === r && (i = 1.05);
                const u = this.overscaling <= 16 ? 15 * rs / (512 * this.overscaling) : 0, c = this.segments.prepareSegment(10 * o, this.layoutVertexArray, this.indexArray);
                let h, p, f, d, y;
                this.e1 = this.e2 = -1, s && (h = t[o - 2], y = t[l].sub(h)._unit()._perp());
                for(let e = l; e < o; e++){
                    if (f = e === o - 1 ? s ? t[l + 1] : void 0 : t[e + 1], f && t[e].equals(f)) continue;
                    y && (d = y), h && (p = h), h = t[e], y = f ? f.sub(h)._unit()._perp() : d, d = d || y;
                    let m = d.add(y);
                    0 === m.x && 0 === m.y || m._unit();
                    const g = d.x * y.x + d.y * y.y, x = m.x * y.x + m.y * y.y, v = 0 !== x ? 1 / x : 1 / 0, b = 2 * Math.sqrt(2 - 2 * x), w = x < yl && p && f, _ = d.x * y.y - d.y * y.x > 0;
                    if (w && e > l) {
                        const t = h.dist(p);
                        if (t > 2 * u) {
                            const e = h.sub(h.sub(p)._mult(u / t)._round());
                            this.updateDistance(p, e), this.addCurrentVertex(e, d, 0, 0, c), p = e;
                        }
                    }
                    const A = p && f;
                    let S = A ? r : s ? "butt" : n;
                    if (A && "round" === S && (v < a ? S = "miter" : v <= 2 && (S = "fakeround")), "miter" === S && v > i && (S = "bevel"), "bevel" === S && (v > 2 && (S = "flipbevel"), v < i && (S = "miter")), p && this.updateDistance(p, h), "miter" === S) m._mult(v), this.addCurrentVertex(h, m, 0, 0, c);
                    else if ("flipbevel" === S) {
                        if (v > 100) m = y.mult(-1);
                        else {
                            const t = v * d.add(y).mag() / d.sub(y).mag();
                            m._perp()._mult(t * (_ ? -1 : 1));
                        }
                        this.addCurrentVertex(h, m, 0, 0, c), this.addCurrentVertex(h, m.mult(-1), 0, 0, c);
                    } else if ("bevel" === S || "fakeround" === S) {
                        const t = -Math.sqrt(v * v - 1), e = _ ? t : 0, r = _ ? 0 : t;
                        if (p && this.addCurrentVertex(h, d, e, r, c), "fakeround" === S) {
                            const t = Math.round(180 * b / Math.PI / 20);
                            for(let e = 1; e < t; e++){
                                let r = e / t;
                                if (.5 !== r) {
                                    const t = r - .5;
                                    r += r * t * (r - 1) * ((1.0904 + g * (g * (3.55645 - 1.43519 * g) - 3.2452)) * t * t + (.848013 + g * (.215638 * g - 1.06021)));
                                }
                                const n = y.sub(d)._mult(r)._add(d)._unit()._mult(_ ? -1 : 1);
                                this.addHalfVertex(h, n.x, n.y, !1, _, 0, c);
                            }
                        }
                        f && this.addCurrentVertex(h, y, -e, -r, c);
                    } else if ("butt" === S) this.addCurrentVertex(h, m, 0, 0, c);
                    else if ("square" === S) {
                        const t = p ? 1 : -1;
                        this.addCurrentVertex(h, m, t, t, c);
                    } else "round" === S && (p && (this.addCurrentVertex(h, d, 0, 0, c), this.addCurrentVertex(h, d, 1, 1, c, !0)), f && (this.addCurrentVertex(h, y, -1, -1, c, !0), this.addCurrentVertex(h, y, 0, 0, c)));
                    if (w && e < o - 1) {
                        const t = h.dist(f);
                        if (t > 2 * u) {
                            const e = h.add(f.sub(h)._mult(u / t)._round());
                            this.updateDistance(h, e), this.addCurrentVertex(e, y, 0, 0, c), h = e;
                        }
                    }
                }
            }
            addCurrentVertex(t, e, r, n, i, a = !1) {
                const s = e.y * n - e.x, o = -e.y - e.x * n;
                this.addHalfVertex(t, e.x + e.y * r, e.y - e.x * r, a, !1, r, i), this.addHalfVertex(t, s, o, a, !0, -n, i), this.distance > ml / 2 && 0 === this.totalDistance && (this.distance = 0, this.updateScaledDistance(), this.addCurrentVertex(t, e, r, n, i, a));
            }
            addHalfVertex({ x: t, y: e }, r, n, i, a, s, o) {
                const l = .5 * (this.lineClips ? this.scaledDistance * (ml - 1) : this.scaledDistance);
                this.layoutVertexArray.emplaceBack((t << 1) + (i ? 1 : 0), (e << 1) + (a ? 1 : 0), Math.round(63 * r) + 128, Math.round(63 * n) + 128, 1 + (0 === s ? 0 : s < 0 ? -1 : 1) | (63 & l) << 2, l >> 6), this.lineClips && this.layoutVertexArray2.emplaceBack((this.scaledDistance - this.lineClips.start) / (this.lineClips.end - this.lineClips.start), this.lineClipsArray.length);
                const u = o.vertexLength++;
                this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, u), o.primitiveLength++), a ? this.e2 = u : this.e1 = u;
            }
            updateScaledDistance() {
                this.scaledDistance = this.lineClips ? this.lineClips.start + (this.lineClips.end - this.lineClips.start) * this.distance / this.totalDistance : this.distance;
            }
            updateDistance(t, e) {
                this.distance += t.dist(e), this.updateScaledDistance();
            }
        }
        let xl, vl;
        $n("LineBucket", gl, {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        var bl = {
            get paint () {
                return vl = vl || new _i({
                    "line-opacity": new xi(X.paint_line["line-opacity"]),
                    "line-color": new xi(X.paint_line["line-color"]),
                    "line-translate": new gi(X.paint_line["line-translate"]),
                    "line-translate-anchor": new gi(X.paint_line["line-translate-anchor"]),
                    "line-width": new xi(X.paint_line["line-width"]),
                    "line-gap-width": new xi(X.paint_line["line-gap-width"]),
                    "line-offset": new xi(X.paint_line["line-offset"]),
                    "line-blur": new xi(X.paint_line["line-blur"]),
                    "line-dasharray": new bi(X.paint_line["line-dasharray"]),
                    "line-pattern": new vi(X.paint_line["line-pattern"]),
                    "line-gradient": new wi(X.paint_line["line-gradient"])
                });
            },
            get layout () {
                return xl = xl || new _i({
                    "line-cap": new gi(X.layout_line["line-cap"]),
                    "line-join": new xi(X.layout_line["line-join"]),
                    "line-miter-limit": new gi(X.layout_line["line-miter-limit"]),
                    "line-round-limit": new gi(X.layout_line["line-round-limit"]),
                    "line-sort-key": new xi(X.layout_line["line-sort-key"])
                });
            }
        };
        class wl extends xi {
            possiblyEvaluate(t, e) {
                return e = new li(Math.floor(e.zoom), {
                    now: e.now,
                    fadeDuration: e.fadeDuration,
                    zoomHistory: e.zoomHistory,
                    transition: e.transition
                }), super.possiblyEvaluate(t, e);
            }
            evaluate(t, e, r, n) {
                return e = g({}, e, {
                    zoom: Math.floor(e.zoom)
                }), super.evaluate(t, e, r, n);
            }
        }
        let _l;
        class Al extends Si {
            constructor(t){
                super(t, bl), this.gradientVersion = 0, _l || (_l = new wl(bl.paint.properties["line-width"].specification), _l.useIntegerZoom = !0);
            }
            _handleSpecialPaintPropertyUpdate(t) {
                if ("line-gradient" === t) {
                    const t = this.gradientExpression();
                    this.stepInterpolant = !!function(t) {
                        return void 0 !== t._styleExpression;
                    }(t) && t._styleExpression.expression instanceof qe, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                }
            }
            gradientExpression() {
                return this._transitionablePaint._values["line-gradient"].value.expression;
            }
            recalculate(t, e) {
                super.recalculate(t, e), this.paint._values["line-floorwidth"] = _l.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, t);
            }
            createBucket(t) {
                return new gl(t);
            }
            queryRadius(t) {
                const e = t, r = Sl(bs("line-width", this, e), bs("line-gap-width", this, e)), n = bs("line-offset", this, e);
                return r / 2 + Math.abs(n) + ws(this.paint.get("line-translate"));
            }
            queryIntersectsFeature(t, e, r, n, i, s, o) {
                const l = _s(t, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), s.angle, o), u = o / 2 * Sl(this.paint.get("line-width").evaluate(e, r), this.paint.get("line-gap-width").evaluate(e, r)), c = this.paint.get("line-offset").evaluate(e, r);
                return c && (n = function(t, e) {
                    const r = [];
                    for(let n = 0; n < t.length; n++){
                        const i = t[n], s = [];
                        for(let t = 0; t < i.length; t++){
                            const r = i[t - 1], n = i[t], o = i[t + 1], l = 0 === t ? new a(0, 0) : n.sub(r)._unit()._perp(), u = t === i.length - 1 ? new a(0, 0) : o.sub(n)._unit()._perp(), c = l._add(u)._unit(), h = c.x * u.x + c.y * u.y;
                            0 !== h && c._mult(1 / h), s.push(c._mult(e)._add(n));
                        }
                        r.push(s);
                    }
                    return r;
                }(n, c * o)), function(t, e, r) {
                    for(let n = 0; n < e.length; n++){
                        const i = e[n];
                        if (t.length >= 3) {
                            for(let e = 0; e < i.length; e++)if (xs(t, i[e])) return !0;
                        }
                        if (ps(t, i, r)) return !0;
                    }
                    return !1;
                }(l, n, u);
            }
            isTileClipped() {
                return !0;
            }
        }
        function Sl(t, e) {
            return e > 0 ? e + 2 * t : t;
        }
        const kl = Mi([
            {
                name: "a_pos_offset",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixeloffset",
                components: 4,
                type: "Int16"
            }
        ], 4), Il = Mi([
            {
                name: "a_projected_pos",
                components: 3,
                type: "Float32"
            }
        ], 4);
        Mi([
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint32"
            }
        ], 4);
        const zl = Mi([
            {
                name: "a_placed",
                components: 2,
                type: "Uint8"
            },
            {
                name: "a_shift",
                components: 2,
                type: "Float32"
            }
        ]);
        Mi([
            {
                type: "Int16",
                name: "anchorPointX"
            },
            {
                type: "Int16",
                name: "anchorPointY"
            },
            {
                type: "Int16",
                name: "x1"
            },
            {
                type: "Int16",
                name: "y1"
            },
            {
                type: "Int16",
                name: "x2"
            },
            {
                type: "Int16",
                name: "y2"
            },
            {
                type: "Uint32",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "sourceLayerIndex"
            },
            {
                type: "Uint16",
                name: "bucketIndex"
            }
        ]);
        const Ml = Mi([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_anchor_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_extrude",
                components: 2,
                type: "Int16"
            }
        ], 4), Cl = Mi([
            {
                name: "a_pos",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_radius",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_flags",
                components: 2,
                type: "Int16"
            }
        ], 4);
        function Bl(t, e, r) {
            return t.sections.forEach((t)=>{
                t.text = function(t, e, r) {
                    const n = e.layout.get("text-transform").evaluate(r, {});
                    return "uppercase" === n ? t = t.toLocaleUpperCase() : "lowercase" === n && (t = t.toLocaleLowerCase()), oi.applyArabicShaping && (t = oi.applyArabicShaping(t)), t;
                }(t.text, e, r);
            }), t;
        }
        Mi([
            {
                name: "triangle",
                components: 3,
                type: "Uint16"
            }
        ]), Mi([
            {
                type: "Int16",
                name: "anchorX"
            },
            {
                type: "Int16",
                name: "anchorY"
            },
            {
                type: "Uint16",
                name: "glyphStartIndex"
            },
            {
                type: "Uint16",
                name: "numGlyphs"
            },
            {
                type: "Uint32",
                name: "vertexStartIndex"
            },
            {
                type: "Uint32",
                name: "lineStartIndex"
            },
            {
                type: "Uint32",
                name: "lineLength"
            },
            {
                type: "Uint16",
                name: "segment"
            },
            {
                type: "Uint16",
                name: "lowerSize"
            },
            {
                type: "Uint16",
                name: "upperSize"
            },
            {
                type: "Float32",
                name: "lineOffsetX"
            },
            {
                type: "Float32",
                name: "lineOffsetY"
            },
            {
                type: "Uint8",
                name: "writingMode"
            },
            {
                type: "Uint8",
                name: "placedOrientation"
            },
            {
                type: "Uint8",
                name: "hidden"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Int16",
                name: "associatedIconIndex"
            }
        ]), Mi([
            {
                type: "Int16",
                name: "anchorX"
            },
            {
                type: "Int16",
                name: "anchorY"
            },
            {
                type: "Int16",
                name: "rightJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "centerJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "leftJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "placedIconSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedIconSymbolIndex"
            },
            {
                type: "Uint16",
                name: "key"
            },
            {
                type: "Uint16",
                name: "textBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "textBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "numHorizontalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numIconVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalIconVertices"
            },
            {
                type: "Uint16",
                name: "useRuntimeCollisionCircles"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Float32",
                name: "textBoxScale"
            },
            {
                type: "Float32",
                name: "collisionCircleDiameter"
            },
            {
                type: "Uint16",
                name: "textAnchorOffsetStartIndex"
            },
            {
                type: "Uint16",
                name: "textAnchorOffsetEndIndex"
            }
        ]), Mi([
            {
                type: "Float32",
                name: "offsetX"
            }
        ]), Mi([
            {
                type: "Int16",
                name: "x"
            },
            {
                type: "Int16",
                name: "y"
            },
            {
                type: "Int16",
                name: "tileUnitDistanceFromAnchor"
            }
        ]), Mi([
            {
                type: "Uint16",
                name: "textAnchor"
            },
            {
                type: "Float32",
                components: 2,
                name: "textOffset"
            }
        ]);
        const Pl = {
            "!": "\uFE15",
            "#": "\uFF03",
            $: "\uFF04",
            "%": "\uFF05",
            "&": "\uFF06",
            "(": "\uFE35",
            ")": "\uFE36",
            "*": "\uFF0A",
            "+": "\uFF0B",
            ",": "\uFE10",
            "-": "\uFE32",
            ".": "\u30FB",
            "/": "\uFF0F",
            ":": "\uFE13",
            ";": "\uFE14",
            "<": "\uFE3F",
            "=": "\uFF1D",
            ">": "\uFE40",
            "?": "\uFE16",
            "@": "\uFF20",
            "[": "\uFE47",
            "\\": "\uFF3C",
            "]": "\uFE48",
            "^": "\uFF3E",
            _: "\uFE33",
            "`": "\uFF40",
            "{": "\uFE37",
            "|": "\u2015",
            "}": "\uFE38",
            "~": "\uFF5E",
            "\xa2": "\uFFE0",
            "\xa3": "\uFFE1",
            "\xa5": "\uFFE5",
            "\xa6": "\uFFE4",
            "\xac": "\uFFE2",
            "\xaf": "\uFFE3",
            "\u2013": "\uFE32",
            "\u2014": "\uFE31",
            "\u2018": "\uFE43",
            "\u2019": "\uFE44",
            "\u201C": "\uFE41",
            "\u201D": "\uFE42",
            "\u2026": "\uFE19",
            "\u2027": "\u30FB",
            "\u20A9": "\uFFE6",
            "\u3001": "\uFE11",
            "\u3002": "\uFE12",
            "\u3008": "\uFE3F",
            "\u3009": "\uFE40",
            "\u300A": "\uFE3D",
            "\u300B": "\uFE3E",
            "\u300C": "\uFE41",
            "\u300D": "\uFE42",
            "\u300E": "\uFE43",
            "\u300F": "\uFE44",
            "\u3010": "\uFE3B",
            "\u3011": "\uFE3C",
            "\u3014": "\uFE39",
            "\u3015": "\uFE3A",
            "\u3016": "\uFE17",
            "\u3017": "\uFE18",
            "\uFF01": "\uFE15",
            "\uFF08": "\uFE35",
            "\uFF09": "\uFE36",
            "\uFF0C": "\uFE10",
            "\uFF0D": "\uFE32",
            "\uFF0E": "\u30FB",
            "\uFF1A": "\uFE13",
            "\uFF1B": "\uFE14",
            "\uFF1C": "\uFE3F",
            "\uFF1E": "\uFE40",
            "\uFF1F": "\uFE16",
            "\uFF3B": "\uFE47",
            "\uFF3D": "\uFE48",
            "\uFF3F": "\uFE33",
            "\uFF5B": "\uFE37",
            "\uFF5C": "\u2015",
            "\uFF5D": "\uFE38",
            "\uFF5F": "\uFE35",
            "\uFF60": "\uFE36",
            "\uFF61": "\uFE12",
            "\uFF62": "\uFE41",
            "\uFF63": "\uFE42"
        };
        var Vl = 24, El = $l, Fl = function(t, e, r, n, i) {
            var a, s, o = 8 * i - n - 1, l = (1 << o) - 1, u = l >> 1, c = -7, h = r ? i - 1 : 0, p = r ? -1 : 1, f = t[e + h];
            for(h += p, a = f & (1 << -c) - 1, f >>= -c, c += o; c > 0; a = 256 * a + t[e + h], h += p, c -= 8);
            for(s = a & (1 << -c) - 1, a >>= -c, c += n; c > 0; s = 256 * s + t[e + h], h += p, c -= 8);
            if (0 === a) a = 1 - u;
            else {
                if (a === l) return s ? NaN : 1 / 0 * (f ? -1 : 1);
                s += Math.pow(2, n), a -= u;
            }
            return (f ? -1 : 1) * s * Math.pow(2, a - n);
        }, Tl = function(t, e, r, n, i, a) {
            var s, o, l, u = 8 * a - i - 1, c = (1 << u) - 1, h = c >> 1, p = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f = n ? 0 : a - 1, d = n ? 1 : -1, y = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;
            for(e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (o = isNaN(e) ? 1 : 0, s = c) : (s = Math.floor(Math.log(e) / Math.LN2), e * (l = Math.pow(2, -s)) < 1 && (s--, l *= 2), (e += s + h >= 1 ? p / l : p * Math.pow(2, 1 - h)) * l >= 2 && (s++, l /= 2), s + h >= c ? (o = 0, s = c) : s + h >= 1 ? (o = (e * l - 1) * Math.pow(2, i), s += h) : (o = e * Math.pow(2, h - 1) * Math.pow(2, i), s = 0)); i >= 8; t[r + f] = 255 & o, f += d, o /= 256, i -= 8);
            for(s = s << i | o, u += i; u > 0; t[r + f] = 255 & s, f += d, s /= 256, u -= 8);
            t[r + f - d] |= 128 * y;
        };
        function $l(t) {
            this.buf = ArrayBuffer.isView && ArrayBuffer.isView(t) ? t : new Uint8Array(t || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
        }
        $l.Varint = 0, $l.Fixed64 = 1, $l.Bytes = 2, $l.Fixed32 = 5;
        var Ll = 4294967296, Dl = 1 / Ll, Ol = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf8");
        function Ul(t) {
            return t.type === $l.Bytes ? t.readVarint() + t.pos : t.pos + 1;
        }
        function Rl(t, e, r) {
            return r ? 4294967296 * e + (t >>> 0) : 4294967296 * (e >>> 0) + (t >>> 0);
        }
        function ql(t, e, r) {
            var n = e <= 16383 ? 1 : e <= 2097151 ? 2 : e <= 268435455 ? 3 : Math.floor(Math.log(e) / (7 * Math.LN2));
            r.realloc(n);
            for(var i = r.pos - 1; i >= t; i--)r.buf[i + n] = r.buf[i];
        }
        function jl(t, e) {
            for(var r = 0; r < t.length; r++)e.writeVarint(t[r]);
        }
        function Nl(t, e) {
            for(var r = 0; r < t.length; r++)e.writeSVarint(t[r]);
        }
        function Zl(t, e) {
            for(var r = 0; r < t.length; r++)e.writeFloat(t[r]);
        }
        function Kl(t, e) {
            for(var r = 0; r < t.length; r++)e.writeDouble(t[r]);
        }
        function Gl(t, e) {
            for(var r = 0; r < t.length; r++)e.writeBoolean(t[r]);
        }
        function Jl(t, e) {
            for(var r = 0; r < t.length; r++)e.writeFixed32(t[r]);
        }
        function Xl(t, e) {
            for(var r = 0; r < t.length; r++)e.writeSFixed32(t[r]);
        }
        function Yl(t, e) {
            for(var r = 0; r < t.length; r++)e.writeFixed64(t[r]);
        }
        function Hl(t, e) {
            for(var r = 0; r < t.length; r++)e.writeSFixed64(t[r]);
        }
        function Wl(t, e) {
            return (t[e] | t[e + 1] << 8 | t[e + 2] << 16) + 16777216 * t[e + 3];
        }
        function Ql(t, e, r) {
            t[r] = e, t[r + 1] = e >>> 8, t[r + 2] = e >>> 16, t[r + 3] = e >>> 24;
        }
        function tu(t, e) {
            return (t[e] | t[e + 1] << 8 | t[e + 2] << 16) + (t[e + 3] << 24);
        }
        $l.prototype = {
            destroy: function() {
                this.buf = null;
            },
            readFields: function(t, e, r) {
                for(r = r || this.length; this.pos < r;){
                    var n = this.readVarint(), i = n >> 3, a = this.pos;
                    this.type = 7 & n, t(i, e, this), this.pos === a && this.skip(n);
                }
                return e;
            },
            readMessage: function(t, e) {
                return this.readFields(t, e, this.readVarint() + this.pos);
            },
            readFixed32: function() {
                var t = Wl(this.buf, this.pos);
                return this.pos += 4, t;
            },
            readSFixed32: function() {
                var t = tu(this.buf, this.pos);
                return this.pos += 4, t;
            },
            readFixed64: function() {
                var t = Wl(this.buf, this.pos) + Wl(this.buf, this.pos + 4) * Ll;
                return this.pos += 8, t;
            },
            readSFixed64: function() {
                var t = Wl(this.buf, this.pos) + tu(this.buf, this.pos + 4) * Ll;
                return this.pos += 8, t;
            },
            readFloat: function() {
                var t = Fl(this.buf, this.pos, !0, 23, 4);
                return this.pos += 4, t;
            },
            readDouble: function() {
                var t = Fl(this.buf, this.pos, !0, 52, 8);
                return this.pos += 8, t;
            },
            readVarint: function(t) {
                var e, r, n = this.buf;
                return e = 127 & (r = n[this.pos++]), r < 128 ? e : (e |= (127 & (r = n[this.pos++])) << 7, r < 128 ? e : (e |= (127 & (r = n[this.pos++])) << 14, r < 128 ? e : (e |= (127 & (r = n[this.pos++])) << 21, r < 128 ? e : function(t, e, r) {
                    var n, i, a = r.buf;
                    if (n = (112 & (i = a[r.pos++])) >> 4, i < 128) return Rl(t, n, e);
                    if (n |= (127 & (i = a[r.pos++])) << 3, i < 128) return Rl(t, n, e);
                    if (n |= (127 & (i = a[r.pos++])) << 10, i < 128) return Rl(t, n, e);
                    if (n |= (127 & (i = a[r.pos++])) << 17, i < 128) return Rl(t, n, e);
                    if (n |= (127 & (i = a[r.pos++])) << 24, i < 128) return Rl(t, n, e);
                    if (n |= (1 & (i = a[r.pos++])) << 31, i < 128) return Rl(t, n, e);
                    throw new Error("Expected varint not more than 10 bytes");
                }(e |= (15 & (r = n[this.pos])) << 28, t, this))));
            },
            readVarint64: function() {
                return this.readVarint(!0);
            },
            readSVarint: function() {
                var t = this.readVarint();
                return t % 2 == 1 ? (t + 1) / -2 : t / 2;
            },
            readBoolean: function() {
                return Boolean(this.readVarint());
            },
            readString: function() {
                var t = this.readVarint() + this.pos, e = this.pos;
                return this.pos = t, t - e >= 12 && Ol ? function(t, e, r) {
                    return Ol.decode(t.subarray(e, r));
                }(this.buf, e, t) : function(t, e, r) {
                    for(var n = "", i = e; i < r;){
                        var a, s, o, l = t[i], u = null, c = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
                        if (i + c > r) break;
                        1 === c ? l < 128 && (u = l) : 2 === c ? 128 == (192 & (a = t[i + 1])) && (u = (31 & l) << 6 | 63 & a) <= 127 && (u = null) : 3 === c ? (s = t[i + 2], 128 == (192 & (a = t[i + 1])) && 128 == (192 & s) && ((u = (15 & l) << 12 | (63 & a) << 6 | 63 & s) <= 2047 || u >= 55296 && u <= 57343) && (u = null)) : 4 === c && (s = t[i + 2], o = t[i + 3], 128 == (192 & (a = t[i + 1])) && 128 == (192 & s) && 128 == (192 & o) && ((u = (15 & l) << 18 | (63 & a) << 12 | (63 & s) << 6 | 63 & o) <= 65535 || u >= 1114112) && (u = null)), null === u ? (u = 65533, c = 1) : u > 65535 && (u -= 65536, n += String.fromCharCode(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), n += String.fromCharCode(u), i += c;
                    }
                    return n;
                }(this.buf, e, t);
            },
            readBytes: function() {
                var t = this.readVarint() + this.pos, e = this.buf.subarray(this.pos, t);
                return this.pos = t, e;
            },
            readPackedVarint: function(t, e) {
                if (this.type !== $l.Bytes) return t.push(this.readVarint(e));
                var r = Ul(this);
                for(t = t || []; this.pos < r;)t.push(this.readVarint(e));
                return t;
            },
            readPackedSVarint: function(t) {
                if (this.type !== $l.Bytes) return t.push(this.readSVarint());
                var e = Ul(this);
                for(t = t || []; this.pos < e;)t.push(this.readSVarint());
                return t;
            },
            readPackedBoolean: function(t) {
                if (this.type !== $l.Bytes) return t.push(this.readBoolean());
                var e = Ul(this);
                for(t = t || []; this.pos < e;)t.push(this.readBoolean());
                return t;
            },
            readPackedFloat: function(t) {
                if (this.type !== $l.Bytes) return t.push(this.readFloat());
                var e = Ul(this);
                for(t = t || []; this.pos < e;)t.push(this.readFloat());
                return t;
            },
            readPackedDouble: function(t) {
                if (this.type !== $l.Bytes) return t.push(this.readDouble());
                var e = Ul(this);
                for(t = t || []; this.pos < e;)t.push(this.readDouble());
                return t;
            },
            readPackedFixed32: function(t) {
                if (this.type !== $l.Bytes) return t.push(this.readFixed32());
                var e = Ul(this);
                for(t = t || []; this.pos < e;)t.push(this.readFixed32());
                return t;
            },
            readPackedSFixed32: function(t) {
                if (this.type !== $l.Bytes) return t.push(this.readSFixed32());
                var e = Ul(this);
                for(t = t || []; this.pos < e;)t.push(this.readSFixed32());
                return t;
            },
            readPackedFixed64: function(t) {
                if (this.type !== $l.Bytes) return t.push(this.readFixed64());
                var e = Ul(this);
                for(t = t || []; this.pos < e;)t.push(this.readFixed64());
                return t;
            },
            readPackedSFixed64: function(t) {
                if (this.type !== $l.Bytes) return t.push(this.readSFixed64());
                var e = Ul(this);
                for(t = t || []; this.pos < e;)t.push(this.readSFixed64());
                return t;
            },
            skip: function(t) {
                var e = 7 & t;
                if (e === $l.Varint) for(; this.buf[this.pos++] > 127;);
                else if (e === $l.Bytes) this.pos = this.readVarint() + this.pos;
                else if (e === $l.Fixed32) this.pos += 4;
                else {
                    if (e !== $l.Fixed64) throw new Error("Unimplemented type: " + e);
                    this.pos += 8;
                }
            },
            writeTag: function(t, e) {
                this.writeVarint(t << 3 | e);
            },
            realloc: function(t) {
                for(var e = this.length || 16; e < this.pos + t;)e *= 2;
                if (e !== this.length) {
                    var r = new Uint8Array(e);
                    r.set(this.buf), this.buf = r, this.length = e;
                }
            },
            finish: function() {
                return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
            },
            writeFixed32: function(t) {
                this.realloc(4), Ql(this.buf, t, this.pos), this.pos += 4;
            },
            writeSFixed32: function(t) {
                this.realloc(4), Ql(this.buf, t, this.pos), this.pos += 4;
            },
            writeFixed64: function(t) {
                this.realloc(8), Ql(this.buf, -1 & t, this.pos), Ql(this.buf, Math.floor(t * Dl), this.pos + 4), this.pos += 8;
            },
            writeSFixed64: function(t) {
                this.realloc(8), Ql(this.buf, -1 & t, this.pos), Ql(this.buf, Math.floor(t * Dl), this.pos + 4), this.pos += 8;
            },
            writeVarint: function(t) {
                (t = +t || 0) > 268435455 || t < 0 ? function(t, e) {
                    var r, n;
                    if (t >= 0 ? (r = t % 4294967296 | 0, n = t / 4294967296 | 0) : (n = ~(-t / 4294967296), 4294967295 ^ (r = ~(-t % 4294967296)) ? r = r + 1 | 0 : (r = 0, n = n + 1 | 0)), t >= 0x10000000000000000 || t < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                    e.realloc(10), function(t, e, r) {
                        r.buf[r.pos++] = 127 & t | 128, t >>>= 7, r.buf[r.pos++] = 127 & t | 128, t >>>= 7, r.buf[r.pos++] = 127 & t | 128, t >>>= 7, r.buf[r.pos++] = 127 & t | 128, r.buf[r.pos] = 127 & (t >>>= 7);
                    }(r, 0, e), function(t, e) {
                        var r = (7 & t) << 4;
                        e.buf[e.pos++] |= r | ((t >>>= 3) ? 128 : 0), t && (e.buf[e.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e.buf[e.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e.buf[e.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e.buf[e.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e.buf[e.pos++] = 127 & t)))));
                    }(n, e);
                }(t, this) : (this.realloc(4), this.buf[this.pos++] = 127 & t | (t > 127 ? 128 : 0), t <= 127 || (this.buf[this.pos++] = 127 & (t >>>= 7) | (t > 127 ? 128 : 0), t <= 127 || (this.buf[this.pos++] = 127 & (t >>>= 7) | (t > 127 ? 128 : 0), t <= 127 || (this.buf[this.pos++] = t >>> 7 & 127))));
            },
            writeSVarint: function(t) {
                this.writeVarint(t < 0 ? 2 * -t - 1 : 2 * t);
            },
            writeBoolean: function(t) {
                this.writeVarint(Boolean(t));
            },
            writeString: function(t) {
                t = String(t), this.realloc(4 * t.length), this.pos++;
                var e = this.pos;
                this.pos = function(t, e, r) {
                    for(var n, i, a = 0; a < e.length; a++){
                        if ((n = e.charCodeAt(a)) > 55295 && n < 57344) {
                            if (!i) {
                                n > 56319 || a + 1 === e.length ? (t[r++] = 239, t[r++] = 191, t[r++] = 189) : i = n;
                                continue;
                            }
                            if (n < 56320) {
                                t[r++] = 239, t[r++] = 191, t[r++] = 189, i = n;
                                continue;
                            }
                            n = i - 55296 << 10 | n - 56320 | 65536, i = null;
                        } else i && (t[r++] = 239, t[r++] = 191, t[r++] = 189, i = null);
                        n < 128 ? t[r++] = n : (n < 2048 ? t[r++] = n >> 6 | 192 : (n < 65536 ? t[r++] = n >> 12 | 224 : (t[r++] = n >> 18 | 240, t[r++] = n >> 12 & 63 | 128), t[r++] = n >> 6 & 63 | 128), t[r++] = 63 & n | 128);
                    }
                    return r;
                }(this.buf, t, this.pos);
                var r = this.pos - e;
                r >= 128 && ql(e, r, this), this.pos = e - 1, this.writeVarint(r), this.pos += r;
            },
            writeFloat: function(t) {
                this.realloc(4), Tl(this.buf, t, this.pos, !0, 23, 4), this.pos += 4;
            },
            writeDouble: function(t) {
                this.realloc(8), Tl(this.buf, t, this.pos, !0, 52, 8), this.pos += 8;
            },
            writeBytes: function(t) {
                var e = t.length;
                this.writeVarint(e), this.realloc(e);
                for(var r = 0; r < e; r++)this.buf[this.pos++] = t[r];
            },
            writeRawMessage: function(t, e) {
                this.pos++;
                var r = this.pos;
                t(e, this);
                var n = this.pos - r;
                n >= 128 && ql(r, n, this), this.pos = r - 1, this.writeVarint(n), this.pos += n;
            },
            writeMessage: function(t, e, r) {
                this.writeTag(t, $l.Bytes), this.writeRawMessage(e, r);
            },
            writePackedVarint: function(t, e) {
                e.length && this.writeMessage(t, jl, e);
            },
            writePackedSVarint: function(t, e) {
                e.length && this.writeMessage(t, Nl, e);
            },
            writePackedBoolean: function(t, e) {
                e.length && this.writeMessage(t, Gl, e);
            },
            writePackedFloat: function(t, e) {
                e.length && this.writeMessage(t, Zl, e);
            },
            writePackedDouble: function(t, e) {
                e.length && this.writeMessage(t, Kl, e);
            },
            writePackedFixed32: function(t, e) {
                e.length && this.writeMessage(t, Jl, e);
            },
            writePackedSFixed32: function(t, e) {
                e.length && this.writeMessage(t, Xl, e);
            },
            writePackedFixed64: function(t, e) {
                e.length && this.writeMessage(t, Yl, e);
            },
            writePackedSFixed64: function(t, e) {
                e.length && this.writeMessage(t, Hl, e);
            },
            writeBytesField: function(t, e) {
                this.writeTag(t, $l.Bytes), this.writeBytes(e);
            },
            writeFixed32Field: function(t, e) {
                this.writeTag(t, $l.Fixed32), this.writeFixed32(e);
            },
            writeSFixed32Field: function(t, e) {
                this.writeTag(t, $l.Fixed32), this.writeSFixed32(e);
            },
            writeFixed64Field: function(t, e) {
                this.writeTag(t, $l.Fixed64), this.writeFixed64(e);
            },
            writeSFixed64Field: function(t, e) {
                this.writeTag(t, $l.Fixed64), this.writeSFixed64(e);
            },
            writeVarintField: function(t, e) {
                this.writeTag(t, $l.Varint), this.writeVarint(e);
            },
            writeSVarintField: function(t, e) {
                this.writeTag(t, $l.Varint), this.writeSVarint(e);
            },
            writeStringField: function(t, e) {
                this.writeTag(t, $l.Bytes), this.writeString(e);
            },
            writeFloatField: function(t, e) {
                this.writeTag(t, $l.Fixed32), this.writeFloat(e);
            },
            writeDoubleField: function(t, e) {
                this.writeTag(t, $l.Fixed64), this.writeDouble(e);
            },
            writeBooleanField: function(t, e) {
                this.writeVarintField(t, Boolean(e));
            }
        };
        var eu = r(El);
        const ru = 3;
        function nu(t, e, r) {
            1 === t && r.readMessage(iu, e);
        }
        function iu(t, e, r) {
            if (3 === t) {
                const { id: t, bitmap: n, width: i, height: a, left: s, top: o, advance: l } = r.readMessage(au, {});
                e.push({
                    id: t,
                    bitmap: new Rs({
                        width: i + 2 * ru,
                        height: a + 2 * ru
                    }, n),
                    metrics: {
                        width: i,
                        height: a,
                        left: s,
                        top: o,
                        advance: l
                    }
                });
            }
        }
        function au(t, e, r) {
            1 === t ? e.id = r.readVarint() : 2 === t ? e.bitmap = r.readBytes() : 3 === t ? e.width = r.readVarint() : 4 === t ? e.height = r.readVarint() : 5 === t ? e.left = r.readSVarint() : 6 === t ? e.top = r.readSVarint() : 7 === t && (e.advance = r.readVarint());
        }
        const su = ru;
        function ou(t) {
            let e = 0, r = 0;
            for (const n of t)e += n.w * n.h, r = Math.max(r, n.w);
            t.sort((t, e)=>e.h - t.h);
            const n = [
                {
                    x: 0,
                    y: 0,
                    w: Math.max(Math.ceil(Math.sqrt(e / .95)), r),
                    h: 1 / 0
                }
            ];
            let i = 0, a = 0;
            for (const e of t)for(let t = n.length - 1; t >= 0; t--){
                const r = n[t];
                if (!(e.w > r.w || e.h > r.h)) {
                    if (e.x = r.x, e.y = r.y, a = Math.max(a, e.y + e.h), i = Math.max(i, e.x + e.w), e.w === r.w && e.h === r.h) {
                        const e = n.pop();
                        t < n.length && (n[t] = e);
                    } else e.h === r.h ? (r.x += e.w, r.w -= e.w) : e.w === r.w ? (r.y += e.h, r.h -= e.h) : (n.push({
                        x: r.x + e.w,
                        y: r.y,
                        w: r.w - e.w,
                        h: e.h
                    }), r.y += e.h, r.h -= e.h);
                    break;
                }
            }
            return {
                w: i,
                h: a,
                fill: e / (i * a) || 0
            };
        }
        const lu = 1;
        class uu {
            constructor(t, { pixelRatio: e, version: r, stretchX: n, stretchY: i, content: a }){
                this.paddedRect = t, this.pixelRatio = e, this.stretchX = n, this.stretchY = i, this.content = a, this.version = r;
            }
            get tl() {
                return [
                    this.paddedRect.x + lu,
                    this.paddedRect.y + lu
                ];
            }
            get br() {
                return [
                    this.paddedRect.x + this.paddedRect.w - lu,
                    this.paddedRect.y + this.paddedRect.h - lu
                ];
            }
            get tlbr() {
                return this.tl.concat(this.br);
            }
            get displaySize() {
                return [
                    (this.paddedRect.w - 2 * lu) / this.pixelRatio,
                    (this.paddedRect.h - 2 * lu) / this.pixelRatio
                ];
            }
        }
        class cu {
            constructor(t, e){
                const r = {}, n = {};
                this.haveRenderCallbacks = [];
                const i = [];
                this.addImages(t, r, i), this.addImages(e, n, i);
                const { w: a, h: s } = ou(i), o = new qs({
                    width: a || 1,
                    height: s || 1
                });
                for(const e in t){
                    const n = t[e], i = r[e].paddedRect;
                    qs.copy(n.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: i.x + lu,
                        y: i.y + lu
                    }, n.data);
                }
                for(const t in e){
                    const r = e[t], i = n[t].paddedRect, a = i.x + lu, s = i.y + lu, l = r.data.width, u = r.data.height;
                    qs.copy(r.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: a,
                        y: s
                    }, r.data), qs.copy(r.data, o, {
                        x: 0,
                        y: u - 1
                    }, {
                        x: a,
                        y: s - 1
                    }, {
                        width: l,
                        height: 1
                    }), qs.copy(r.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: a,
                        y: s + u
                    }, {
                        width: l,
                        height: 1
                    }), qs.copy(r.data, o, {
                        x: l - 1,
                        y: 0
                    }, {
                        x: a - 1,
                        y: s
                    }, {
                        width: 1,
                        height: u
                    }), qs.copy(r.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: a + l,
                        y: s
                    }, {
                        width: 1,
                        height: u
                    });
                }
                this.image = o, this.iconPositions = r, this.patternPositions = n;
            }
            addImages(t, e, r) {
                for(const n in t){
                    const i = t[n], a = {
                        x: 0,
                        y: 0,
                        w: i.data.width + 2 * lu,
                        h: i.data.height + 2 * lu
                    };
                    r.push(a), e[n] = new uu(a, i), i.hasRenderCallback && this.haveRenderCallbacks.push(n);
                }
            }
            patchUpdatedImages(t, e) {
                t.dispatchRenderCallbacks(this.haveRenderCallbacks);
                for(const r in t.updatedImages)this.patchUpdatedImage(this.iconPositions[r], t.getImage(r), e), this.patchUpdatedImage(this.patternPositions[r], t.getImage(r), e);
            }
            patchUpdatedImage(t, e, r) {
                if (!t || !e) return;
                if (t.version === e.version) return;
                t.version = e.version;
                const [n, i] = t.tl;
                r.update(e.data, void 0, {
                    x: n,
                    y: i
                });
            }
        }
        var hu;
        $n("ImagePosition", uu), $n("ImageAtlas", cu), t.ai = void 0, (hu = t.ai || (t.ai = {}))[hu.none = 0] = "none", hu[hu.horizontal = 1] = "horizontal", hu[hu.vertical = 2] = "vertical", hu[hu.horizontalOnly = 3] = "horizontalOnly";
        const pu = -17;
        class fu {
            constructor(){
                this.scale = 1, this.fontStack = "", this.imageName = null;
            }
            static forText(t, e) {
                const r = new fu;
                return r.scale = t || 1, r.fontStack = e, r;
            }
            static forImage(t) {
                const e = new fu;
                return e.imageName = t, e;
            }
        }
        class du {
            constructor(){
                this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
            }
            static fromFeature(t, e) {
                const r = new du;
                for(let n = 0; n < t.sections.length; n++){
                    const i = t.sections[n];
                    i.image ? r.addImageSection(i) : r.addTextSection(i, e);
                }
                return r;
            }
            length() {
                return this.text.length;
            }
            getSection(t) {
                return this.sections[this.sectionIndex[t]];
            }
            getSectionIndex(t) {
                return this.sectionIndex[t];
            }
            getCharCode(t) {
                return this.text.charCodeAt(t);
            }
            verticalizePunctuation() {
                this.text = function(t) {
                    let e = "";
                    for(let r = 0; r < t.length; r++){
                        const n = t.charCodeAt(r + 1) || null, i = t.charCodeAt(r - 1) || null;
                        e += n && Kn(n) && !Pl[t[r + 1]] || i && Kn(i) && !Pl[t[r - 1]] || !Pl[t[r]] ? t[r] : Pl[t[r]];
                    }
                    return e;
                }(this.text);
            }
            trim() {
                let t = 0;
                for(let e = 0; e < this.text.length && mu[this.text.charCodeAt(e)]; e++)t++;
                let e = this.text.length;
                for(let r = this.text.length - 1; r >= 0 && r >= t && mu[this.text.charCodeAt(r)]; r--)e--;
                this.text = this.text.substring(t, e), this.sectionIndex = this.sectionIndex.slice(t, e);
            }
            substring(t, e) {
                const r = new du;
                return r.text = this.text.substring(t, e), r.sectionIndex = this.sectionIndex.slice(t, e), r.sections = this.sections, r;
            }
            toString() {
                return this.text;
            }
            getMaxScale() {
                return this.sectionIndex.reduce((t, e)=>Math.max(t, this.sections[e].scale), 0);
            }
            addTextSection(t, e) {
                this.text += t.text, this.sections.push(fu.forText(t.scale, t.fontStack || e));
                const r = this.sections.length - 1;
                for(let e = 0; e < t.text.length; ++e)this.sectionIndex.push(r);
            }
            addImageSection(t) {
                const e = t.image ? t.image.name : "";
                if (0 === e.length) return void A("Can't add FormattedSection with an empty image.");
                const r = this.getNextImageSectionCharCode();
                r ? (this.text += String.fromCharCode(r), this.sections.push(fu.forImage(e)), this.sectionIndex.push(this.sections.length - 1)) : A("Reached maximum number of images 6401");
            }
            getNextImageSectionCharCode() {
                return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
            }
        }
        function yu(e, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m) {
            const g = du.fromFeature(e, a);
            let x;
            p === t.ai.vertical && g.verticalizePunctuation();
            const { processBidirectionalText: v, processStyledBidirectionalText: b } = oi;
            if (v && 1 === g.sections.length) {
                x = [];
                const t = v(g.toString(), Au(g, c, s, r, i, d, y));
                for (const e of t){
                    const t = new du;
                    t.text = e, t.sections = g.sections;
                    for(let r = 0; r < e.length; r++)t.sectionIndex.push(0);
                    x.push(t);
                }
            } else if (b) {
                x = [];
                const t = b(g.text, g.sectionIndex, Au(g, c, s, r, i, d, y));
                for (const e of t){
                    const t = new du;
                    t.text = e[0], t.sectionIndex = e[1], t.sections = g.sections, x.push(t);
                }
            } else x = function(t, e) {
                const r = [], n = t.text;
                let i = 0;
                for (const n of e)r.push(t.substring(i, n)), i = n;
                return i < n.length && r.push(t.substring(i, n.length)), r;
            }(g, Au(g, c, s, r, i, d, y));
            const w = [], _ = {
                positionedLines: w,
                text: g.toString(),
                top: h[1],
                bottom: h[1],
                left: h[0],
                right: h[0],
                writingMode: p,
                iconsInText: !1,
                verticalizable: !1
            };
            return function(e, r, n, i, a, s, o, l, u, c, h, p) {
                let f = 0, d = pu, y = 0, m = 0;
                const g = "right" === l ? 1 : "left" === l ? 0 : .5;
                let x = 0;
                for (const o of a){
                    o.trim();
                    const a = o.getMaxScale(), l = (a - 1) * Vl, b = {
                        positionedGlyphs: [],
                        lineOffset: 0
                    };
                    e.positionedLines[x] = b;
                    const w = b.positionedGlyphs;
                    let _ = 0;
                    if (!o.length()) {
                        d += s, ++x;
                        continue;
                    }
                    for(let s = 0; s < o.length(); s++){
                        const y = o.getSection(s), m = o.getSectionIndex(s), g = o.getCharCode(s);
                        let x = 0, b = null, A = null, S = null, k = Vl;
                        const I = !(u === t.ai.horizontal || !h && !Zn(g) || h && (mu[g] || (v = g, Rn.Arabic(v) || Rn["Arabic Supplement"](v) || Rn["Arabic Extended-A"](v) || Rn["Arabic Presentation Forms-A"](v) || Rn["Arabic Presentation Forms-B"](v))));
                        if (y.imageName) {
                            const t = i[y.imageName];
                            if (!t) continue;
                            S = y.imageName, e.iconsInText = e.iconsInText || !0, A = t.paddedRect;
                            const r = t.displaySize;
                            y.scale = y.scale * Vl / p, b = {
                                width: r[0],
                                height: r[1],
                                left: lu,
                                top: -su,
                                advance: I ? r[1] : r[0]
                            }, x = l + (Vl - r[1] * y.scale), k = b.advance;
                            const n = I ? r[0] * y.scale - Vl * a : r[1] * y.scale - Vl * a;
                            n > 0 && n > _ && (_ = n);
                        } else {
                            const t = n[y.fontStack], e = t && t[g];
                            if (e && e.rect) A = e.rect, b = e.metrics;
                            else {
                                const t = r[y.fontStack], e = t && t[g];
                                if (!e) continue;
                                b = e.metrics;
                            }
                            x = (a - y.scale) * Vl;
                        }
                        I ? (e.verticalizable = !0, w.push({
                            glyph: g,
                            imageName: S,
                            x: f,
                            y: d + x,
                            vertical: I,
                            scale: y.scale,
                            fontStack: y.fontStack,
                            sectionIndex: m,
                            metrics: b,
                            rect: A
                        }), f += k * y.scale + c) : (w.push({
                            glyph: g,
                            imageName: S,
                            x: f,
                            y: d + x,
                            vertical: I,
                            scale: y.scale,
                            fontStack: y.fontStack,
                            sectionIndex: m,
                            metrics: b,
                            rect: A
                        }), f += b.advance * y.scale + c);
                    }
                    0 !== w.length && (y = Math.max(f - c, y), ku(w, 0, w.length - 1, g, _)), f = 0;
                    const A = s * a + _;
                    b.lineOffset = Math.max(_, l), d += A, m = Math.max(A, m), ++x;
                }
                var v;
                const b = d - pu, { horizontalAlign: w, verticalAlign: _ } = Su(o);
                (function(t, e, r, n, i, a, s, o, l) {
                    const u = (e - r) * i;
                    let c = 0;
                    c = a !== s ? -o * n - pu : (-n * l + .5) * s;
                    for (const e of t)for (const t of e.positionedGlyphs)t.x += u, t.y += c;
                })(e.positionedLines, g, w, _, y, m, s, b, a.length), e.top += -_ * b, e.bottom = e.top + b, e.left += -w * y, e.right = e.left + y;
            }(_, r, n, i, x, o, l, u, p, c, f, m), !function(t) {
                for (const e of t)if (0 !== e.positionedGlyphs.length) return !1;
                return !0;
            }(w) && _;
        }
        const mu = {
            9: !0,
            10: !0,
            11: !0,
            12: !0,
            13: !0,
            32: !0
        }, gu = {
            10: !0,
            32: !0,
            38: !0,
            40: !0,
            41: !0,
            43: !0,
            45: !0,
            47: !0,
            173: !0,
            183: !0,
            8203: !0,
            8208: !0,
            8211: !0,
            8231: !0
        };
        function xu(t, e, r, n, i, a) {
            if (e.imageName) {
                const t = n[e.imageName];
                return t ? t.displaySize[0] * e.scale * Vl / a + i : 0;
            }
            {
                const n = r[e.fontStack], a = n && n[t];
                return a ? a.metrics.advance * e.scale + i : 0;
            }
        }
        function vu(t, e, r, n) {
            const i = Math.pow(t - e, 2);
            return n ? t < e ? i / 2 : 2 * i : i + Math.abs(r) * r;
        }
        function bu(t, e, r) {
            let n = 0;
            return 10 === t && (n -= 1e4), r && (n += 150), 40 !== t && 65288 !== t || (n += 50), 41 !== e && 65289 !== e || (n += 50), n;
        }
        function wu(t, e, r, n, i, a) {
            let s = null, o = vu(e, r, i, a);
            for (const t of n){
                const n = vu(e - t.x, r, i, a) + t.badness;
                n <= o && (s = t, o = n);
            }
            return {
                index: t,
                x: e,
                priorBreak: s,
                badness: o
            };
        }
        function _u(t) {
            return t ? _u(t.priorBreak).concat(t.index) : [];
        }
        function Au(t, e, r, n, i, a, s) {
            if ("point" !== a) return [];
            if (!t) return [];
            const o = [], l = function(t, e, r, n, i, a) {
                let s = 0;
                for(let r = 0; r < t.length(); r++){
                    const o = t.getSection(r);
                    s += xu(t.getCharCode(r), o, n, i, e, a);
                }
                return s / Math.max(1, Math.ceil(s / r));
            }(t, e, r, n, i, s), u = t.text.indexOf("\u200B") >= 0;
            let c = 0;
            for(let r = 0; r < t.length(); r++){
                const a = t.getSection(r), p = t.getCharCode(r);
                if (mu[p] || (c += xu(p, a, n, i, e, s)), r < t.length() - 1) {
                    const e = !((h = p) < 11904 || !(Rn["Bopomofo Extended"](h) || Rn.Bopomofo(h) || Rn["CJK Compatibility Forms"](h) || Rn["CJK Compatibility Ideographs"](h) || Rn["CJK Compatibility"](h) || Rn["CJK Radicals Supplement"](h) || Rn["CJK Strokes"](h) || Rn["CJK Symbols and Punctuation"](h) || Rn["CJK Unified Ideographs Extension A"](h) || Rn["CJK Unified Ideographs"](h) || Rn["Enclosed CJK Letters and Months"](h) || Rn["Halfwidth and Fullwidth Forms"](h) || Rn.Hiragana(h) || Rn["Ideographic Description Characters"](h) || Rn["Kangxi Radicals"](h) || Rn["Katakana Phonetic Extensions"](h) || Rn.Katakana(h) || Rn["Vertical Forms"](h) || Rn["Yi Radicals"](h) || Rn["Yi Syllables"](h)));
                    (gu[p] || e || a.imageName) && o.push(wu(r + 1, c, l, o, bu(p, t.getCharCode(r + 1), e && u), !1));
                }
            }
            var h;
            return _u(wu(t.length(), c, l, o, 0, !0));
        }
        function Su(t) {
            let e = .5, r = .5;
            switch(t){
                case "right":
                case "top-right":
                case "bottom-right":
                    e = 1;
                    break;
                case "left":
                case "top-left":
                case "bottom-left":
                    e = 0;
            }
            switch(t){
                case "bottom":
                case "bottom-right":
                case "bottom-left":
                    r = 1;
                    break;
                case "top":
                case "top-right":
                case "top-left":
                    r = 0;
            }
            return {
                horizontalAlign: e,
                verticalAlign: r
            };
        }
        function ku(t, e, r, n, i) {
            if (!n && !i) return;
            const a = t[r], s = (t[r].x + a.metrics.advance * a.scale) * n;
            for(let n = e; n <= r; n++)t[n].x -= s, t[n].y += i;
        }
        function Iu(t, e, r) {
            const { horizontalAlign: n, verticalAlign: i } = Su(r), a = e[0] - t.displaySize[0] * n, s = e[1] - t.displaySize[1] * i;
            return {
                image: t,
                top: s,
                bottom: s + t.displaySize[1],
                left: a,
                right: a + t.displaySize[0]
            };
        }
        function zu(t, e, r, n, i, a) {
            const s = t.image;
            let o;
            if (s.content) {
                const t = s.content, e = s.pixelRatio || 1;
                o = [
                    t[0] / e,
                    t[1] / e,
                    s.displaySize[0] - t[2] / e,
                    s.displaySize[1] - t[3] / e
                ];
            }
            const l = e.left * a, u = e.right * a;
            let c, h, p, f;
            "width" === r || "both" === r ? (f = i[0] + l - n[3], h = i[0] + u + n[1]) : (f = i[0] + (l + u - s.displaySize[0]) / 2, h = f + s.displaySize[0]);
            const d = e.top * a, y = e.bottom * a;
            return "height" === r || "both" === r ? (c = i[1] + d - n[0], p = i[1] + y + n[2]) : (c = i[1] + (d + y - s.displaySize[1]) / 2, p = c + s.displaySize[1]), {
                image: s,
                top: c,
                right: h,
                bottom: p,
                left: f,
                collisionPadding: o
            };
        }
        const Mu = 255, Cu = 128, Bu = Mu * Cu;
        function Pu(t, e) {
            const { expression: r } = e;
            if ("constant" === r.kind) return {
                kind: "constant",
                layoutSize: r.evaluate(new li(t + 1))
            };
            if ("source" === r.kind) return {
                kind: "source"
            };
            {
                const { zoomStops: e, interpolationType: n } = r;
                let i = 0;
                for(; i < e.length && e[i] <= t;)i++;
                i = Math.max(0, i - 1);
                let a = i;
                for(; a < e.length && e[a] < t + 1;)a++;
                a = Math.min(e.length - 1, a);
                const s = e[i], o = e[a];
                return "composite" === r.kind ? {
                    kind: "composite",
                    minZoom: s,
                    maxZoom: o,
                    interpolationType: n
                } : {
                    kind: "camera",
                    minZoom: s,
                    maxZoom: o,
                    minSize: r.evaluate(new li(s)),
                    maxSize: r.evaluate(new li(o)),
                    interpolationType: n
                };
            }
        }
        function Vu(t, e, r) {
            let n = "never";
            const i = t.get(e);
            return i ? n = i : t.get(r) && (n = "always"), n;
        }
        const Eu = Ro.VectorTileFeature.types, Fu = [
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint8",
                offset: 0
            }
        ];
        function Tu(t, e, r, n, i, a, s, o, l, u, c, h, p) {
            const f = o ? Math.min(Bu, Math.round(o[0])) : 0, d = o ? Math.min(Bu, Math.round(o[1])) : 0;
            t.emplaceBack(e, r, Math.round(32 * n), Math.round(32 * i), a, s, (f << 1) + (l ? 1 : 0), d, 16 * u, 16 * c, 256 * h, 256 * p);
        }
        function $u(t, e, r) {
            t.emplaceBack(e.x, e.y, r), t.emplaceBack(e.x, e.y, r), t.emplaceBack(e.x, e.y, r), t.emplaceBack(e.x, e.y, r);
        }
        function Lu(t) {
            for (const e of t.sections)if (Xn(e.text)) return !0;
            return !1;
        }
        class Du {
            constructor(t){
                this.layoutVertexArray = new xa, this.indexArray = new Aa, this.programConfigurations = t, this.segments = new za, this.dynamicLayoutVertexArray = new va, this.opacityVertexArray = new ba, this.hasVisibleVertices = !1, this.placedSymbolArray = new ra;
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length;
            }
            upload(t, e, r, n) {
                this.isEmpty() || (r && (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, kl.members), this.indexBuffer = t.createIndexBuffer(this.indexArray, e), this.dynamicLayoutVertexBuffer = t.createVertexBuffer(this.dynamicLayoutVertexArray, Il.members, !0), this.opacityVertexBuffer = t.createVertexBuffer(this.opacityVertexArray, Fu, !0), this.opacityVertexBuffer.itemSize = 1), (r || n) && this.programConfigurations.upload(t));
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy());
            }
        }
        $n("SymbolBuffers", Du);
        class Ou {
            constructor(t, e, r){
                this.layoutVertexArray = new t, this.layoutAttributes = e, this.indexArray = new r, this.segments = new za, this.collisionVertexArray = new _a;
            }
            upload(t) {
                this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = t.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = t.createVertexBuffer(this.collisionVertexArray, zl.members, !0);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy());
            }
        }
        $n("CollisionBuffers", Ou);
        class Uu {
            constructor(e){
                this.collisionBoxArray = e.collisionBoxArray, this.zoom = e.zoom, this.overscaling = e.overscaling, this.layers = e.layers, this.layerIds = this.layers.map((t)=>t.id), this.index = e.index, this.pixelRatio = e.pixelRatio, this.sourceLayerIndex = e.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = Ms([]), this.placementViewportMatrix = Ms([]);
                const r = this.layers[0]._unevaluatedLayout._values;
                this.textSizeData = Pu(this.zoom, r["text-size"]), this.iconSizeData = Pu(this.zoom, r["icon-size"]);
                const n = this.layers[0].layout, i = n.get("symbol-sort-key"), a = n.get("symbol-z-order");
                this.canOverlap = "never" !== Vu(n, "text-overlap", "text-allow-overlap") || "never" !== Vu(n, "icon-overlap", "icon-allow-overlap") || n.get("text-ignore-placement") || n.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== a && !i.isConstant(), this.sortFeaturesByY = ("viewport-y" === a || "auto" === a && !this.sortFeaturesByKey) && this.canOverlap, "point" === n.get("symbol-placement") && (this.writingModes = n.get("text-writing-mode").map((e)=>t.ai[e])), this.stateDependentLayerIds = this.layers.filter((t)=>t.isStateDependent()).map((t)=>t.id), this.sourceID = e.sourceID;
            }
            createArrays() {
                this.text = new Du(new Qa(this.layers, this.zoom, (t)=>/^text/.test(t))), this.icon = new Du(new Qa(this.layers, this.zoom, (t)=>/^icon/.test(t))), this.glyphOffsetArray = new aa, this.lineVertexArray = new sa, this.symbolInstances = new ia, this.textAnchorOffsets = new la;
            }
            calculateGlyphDependencies(t, e, r, n, i) {
                for(let a = 0; a < t.length; a++)if (e[t.charCodeAt(a)] = !0, (r || n) && i) {
                    const r = Pl[t.charAt(a)];
                    r && (e[r.charCodeAt(0)] = !0);
                }
            }
            populate(e, r, n) {
                const i = this.layers[0], a = i.layout, s = a.get("text-font"), o = a.get("text-field"), l = a.get("icon-image"), u = ("constant" !== o.value.kind || o.value.value instanceof Qt && !o.value.value.isEmpty() || o.value.value.toString().length > 0) && ("constant" !== s.value.kind || s.value.value.length > 0), c = "constant" !== l.value.kind || !!l.value.value || Object.keys(l.parameters).length > 0, h = a.get("symbol-sort-key");
                if (this.features = [], !u && !c) return;
                const p = r.iconDependencies, f = r.glyphDependencies, d = r.availableImages, y = new li(this.zoom);
                for (const { feature: r, id: o, index: l, sourceLayerIndex: m } of e){
                    const e = i._featureFilter.needGeometry, g = ss(r, e);
                    if (!i._featureFilter.filter(y, g, n)) continue;
                    let x, v;
                    if (e || (g.geometry = as(r)), u) {
                        const t = i.getValueAndResolveTokens("text-field", g, n, d), e = Qt.factory(t);
                        Lu(e) && (this.hasRTLText = !0), (!this.hasRTLText || "unavailable" === ai() || this.hasRTLText && oi.isParsed()) && (x = Bl(e, i, g));
                    }
                    if (c) {
                        const t = i.getValueAndResolveTokens("icon-image", g, n, d);
                        v = t instanceof ne ? t : ne.fromString(t);
                    }
                    if (!x && !v) continue;
                    const b = this.sortFeaturesByKey ? h.evaluate(g, {}, n) : void 0;
                    if (this.features.push({
                        id: o,
                        text: x,
                        icon: v,
                        index: l,
                        sourceLayerIndex: m,
                        geometry: g.geometry,
                        properties: r.properties,
                        type: Eu[r.type],
                        sortKey: b
                    }), v && (p[v.name] = !0), x) {
                        const e = s.evaluate(g, {}, n).join(","), r = "viewport" !== a.get("text-rotation-alignment") && "point" !== a.get("symbol-placement");
                        this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(t.ai.vertical) >= 0;
                        for (const t of x.sections)if (t.image) p[t.image.name] = !0;
                        else {
                            const n = qn(x.toString()), i = t.fontStack || e, a = f[i] = f[i] || {};
                            this.calculateGlyphDependencies(t.text, a, r, this.allowVerticalPlacement, n);
                        }
                    }
                }
                "line" === a.get("symbol-placement") && (this.features = function(t) {
                    const e = {}, r = {}, n = [];
                    let i = 0;
                    function a(e) {
                        n.push(t[e]), i++;
                    }
                    function s(t, e, i) {
                        const a = r[t];
                        return delete r[t], r[e] = a, n[a].geometry[0].pop(), n[a].geometry[0] = n[a].geometry[0].concat(i[0]), a;
                    }
                    function o(t, r, i) {
                        const a = e[r];
                        return delete e[r], e[t] = a, n[a].geometry[0].shift(), n[a].geometry[0] = i[0].concat(n[a].geometry[0]), a;
                    }
                    function l(t, e, r) {
                        const n = r ? e[0][e[0].length - 1] : e[0][0];
                        return `${t}:${n.x}:${n.y}`;
                    }
                    for(let u = 0; u < t.length; u++){
                        const c = t[u], h = c.geometry, p = c.text ? c.text.toString() : null;
                        if (!p) {
                            a(u);
                            continue;
                        }
                        const f = l(p, h), d = l(p, h, !0);
                        if (f in r && d in e && r[f] !== e[d]) {
                            const t = o(f, d, h), i = s(f, d, n[t].geometry);
                            delete e[f], delete r[d], r[l(p, n[i].geometry, !0)] = i, n[t].geometry = null;
                        } else f in r ? s(f, d, h) : d in e ? o(f, d, h) : (a(u), e[f] = i - 1, r[d] = i - 1);
                    }
                    return n.filter((t)=>t.geometry);
                }(this.features)), this.sortFeaturesByKey && this.features.sort((t, e)=>t.sortKey - e.sortKey);
            }
            update(t, e, r) {
                this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(t, e, this.layers, r), this.icon.programConfigurations.updatePaintArrays(t, e, this.layers, r));
            }
            isEmpty() {
                return 0 === this.symbolInstances.length && !this.hasRTLText;
            }
            uploadPending() {
                return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
            }
            upload(t) {
                !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(t), this.iconCollisionBox.upload(t)), this.text.upload(t, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(t, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = !0;
            }
            destroyDebugData() {
                this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
            }
            destroy() {
                this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
            }
            addToLineVertexArray(t, e) {
                const r = this.lineVertexArray.length;
                if (void 0 !== t.segment) {
                    let r = t.dist(e[t.segment + 1]), n = t.dist(e[t.segment]);
                    const i = {};
                    for(let n = t.segment + 1; n < e.length; n++)i[n] = {
                        x: e[n].x,
                        y: e[n].y,
                        tileUnitDistanceFromAnchor: r
                    }, n < e.length - 1 && (r += e[n + 1].dist(e[n]));
                    for(let r = t.segment || 0; r >= 0; r--)i[r] = {
                        x: e[r].x,
                        y: e[r].y,
                        tileUnitDistanceFromAnchor: n
                    }, r > 0 && (n += e[r - 1].dist(e[r]));
                    for(let t = 0; t < e.length; t++){
                        const e = i[t];
                        this.lineVertexArray.emplaceBack(e.x, e.y, e.tileUnitDistanceFromAnchor);
                    }
                }
                return {
                    lineStartIndex: r,
                    lineLength: this.lineVertexArray.length - r
                };
            }
            addSymbols(e, r, n, i, a, s, o, l, u, c, h, p) {
                const f = e.indexArray, d = e.layoutVertexArray, y = e.segments.prepareSegment(4 * r.length, d, f, this.canOverlap ? s.sortKey : void 0), m = this.glyphOffsetArray.length, g = y.vertexLength, x = this.allowVerticalPlacement && o === t.ai.vertical ? Math.PI / 2 : 0, v = s.text && s.text.sections;
                for(let t = 0; t < r.length; t++){
                    const { tl: i, tr: a, bl: o, br: u, tex: c, pixelOffsetTL: h, pixelOffsetBR: m, minFontScaleX: g, minFontScaleY: b, glyphOffset: w, isSDF: _, sectionIndex: A } = r[t], S = y.vertexLength, k = w[1];
                    Tu(d, l.x, l.y, i.x, k + i.y, c.x, c.y, n, _, h.x, h.y, g, b), Tu(d, l.x, l.y, a.x, k + a.y, c.x + c.w, c.y, n, _, m.x, h.y, g, b), Tu(d, l.x, l.y, o.x, k + o.y, c.x, c.y + c.h, n, _, h.x, m.y, g, b), Tu(d, l.x, l.y, u.x, k + u.y, c.x + c.w, c.y + c.h, n, _, m.x, m.y, g, b), $u(e.dynamicLayoutVertexArray, l, x), f.emplaceBack(S, S + 1, S + 2), f.emplaceBack(S + 1, S + 2, S + 3), y.vertexLength += 4, y.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(w[0]), t !== r.length - 1 && A === r[t + 1].sectionIndex || e.programConfigurations.populatePaintArrays(d.length, s, s.index, {}, p, v && v[A]);
                }
                e.placedSymbolArray.emplaceBack(l.x, l.y, m, this.glyphOffsetArray.length - m, g, u, c, l.segment, n ? n[0] : 0, n ? n[1] : 0, i[0], i[1], o, 0, !1, 0, h);
            }
            _addCollisionDebugVertex(t, e, r, n, i, a) {
                return e.emplaceBack(0, 0), t.emplaceBack(r.x, r.y, n, i, Math.round(a.x), Math.round(a.y));
            }
            addCollisionDebugVertices(t, e, r, n, i, s, o) {
                const l = i.segments.prepareSegment(4, i.layoutVertexArray, i.indexArray), u = l.vertexLength, c = i.layoutVertexArray, h = i.collisionVertexArray, p = o.anchorX, f = o.anchorY;
                this._addCollisionDebugVertex(c, h, s, p, f, new a(t, e)), this._addCollisionDebugVertex(c, h, s, p, f, new a(r, e)), this._addCollisionDebugVertex(c, h, s, p, f, new a(r, n)), this._addCollisionDebugVertex(c, h, s, p, f, new a(t, n)), l.vertexLength += 4;
                const d = i.indexArray;
                d.emplaceBack(u, u + 1), d.emplaceBack(u + 1, u + 2), d.emplaceBack(u + 2, u + 3), d.emplaceBack(u + 3, u), l.primitiveLength += 4;
            }
            addDebugCollisionBoxes(t, e, r, n) {
                for(let i = t; i < e; i++){
                    const t = this.collisionBoxArray.get(i);
                    this.addCollisionDebugVertices(t.x1, t.y1, t.x2, t.y2, n ? this.textCollisionBox : this.iconCollisionBox, t.anchorPoint, r);
                }
            }
            generateCollisionDebugBuffers() {
                this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new Ou(wa, Ml.members, Sa), this.iconCollisionBox = new Ou(wa, Ml.members, Sa);
                for(let t = 0; t < this.symbolInstances.length; t++){
                    const e = this.symbolInstances.get(t);
                    this.addDebugCollisionBoxes(e.textBoxStartIndex, e.textBoxEndIndex, e, !0), this.addDebugCollisionBoxes(e.verticalTextBoxStartIndex, e.verticalTextBoxEndIndex, e, !0), this.addDebugCollisionBoxes(e.iconBoxStartIndex, e.iconBoxEndIndex, e, !1), this.addDebugCollisionBoxes(e.verticalIconBoxStartIndex, e.verticalIconBoxEndIndex, e, !1);
                }
            }
            _deserializeCollisionBoxesForSymbol(t, e, r, n, i, a, s, o, l) {
                const u = {};
                for(let n = e; n < r; n++){
                    const e = t.get(n);
                    u.textBox = {
                        x1: e.x1,
                        y1: e.y1,
                        x2: e.x2,
                        y2: e.y2,
                        anchorPointX: e.anchorPointX,
                        anchorPointY: e.anchorPointY
                    }, u.textFeatureIndex = e.featureIndex;
                    break;
                }
                for(let e = n; e < i; e++){
                    const r = t.get(e);
                    u.verticalTextBox = {
                        x1: r.x1,
                        y1: r.y1,
                        x2: r.x2,
                        y2: r.y2,
                        anchorPointX: r.anchorPointX,
                        anchorPointY: r.anchorPointY
                    }, u.verticalTextFeatureIndex = r.featureIndex;
                    break;
                }
                for(let e = a; e < s; e++){
                    const r = t.get(e);
                    u.iconBox = {
                        x1: r.x1,
                        y1: r.y1,
                        x2: r.x2,
                        y2: r.y2,
                        anchorPointX: r.anchorPointX,
                        anchorPointY: r.anchorPointY
                    }, u.iconFeatureIndex = r.featureIndex;
                    break;
                }
                for(let e = o; e < l; e++){
                    const r = t.get(e);
                    u.verticalIconBox = {
                        x1: r.x1,
                        y1: r.y1,
                        x2: r.x2,
                        y2: r.y2,
                        anchorPointX: r.anchorPointX,
                        anchorPointY: r.anchorPointY
                    }, u.verticalIconFeatureIndex = r.featureIndex;
                    break;
                }
                return u;
            }
            deserializeCollisionBoxes(t) {
                this.collisionArrays = [];
                for(let e = 0; e < this.symbolInstances.length; e++){
                    const r = this.symbolInstances.get(e);
                    this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t, r.textBoxStartIndex, r.textBoxEndIndex, r.verticalTextBoxStartIndex, r.verticalTextBoxEndIndex, r.iconBoxStartIndex, r.iconBoxEndIndex, r.verticalIconBoxStartIndex, r.verticalIconBoxEndIndex));
                }
            }
            hasTextData() {
                return this.text.segments.get().length > 0;
            }
            hasIconData() {
                return this.icon.segments.get().length > 0;
            }
            hasDebugData() {
                return this.textCollisionBox && this.iconCollisionBox;
            }
            hasTextCollisionBoxData() {
                return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
            }
            hasIconCollisionBoxData() {
                return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
            }
            addIndicesForPlacedSymbol(t, e) {
                const r = t.placedSymbolArray.get(e), n = r.vertexStartIndex + 4 * r.numGlyphs;
                for(let e = r.vertexStartIndex; e < n; e += 4)t.indexArray.emplaceBack(e, e + 1, e + 2), t.indexArray.emplaceBack(e + 1, e + 2, e + 3);
            }
            getSortedSymbolIndexes(t) {
                if (this.sortedAngle === t && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
                const e = Math.sin(t), r = Math.cos(t), n = [], i = [], a = [];
                for(let t = 0; t < this.symbolInstances.length; ++t){
                    a.push(t);
                    const s = this.symbolInstances.get(t);
                    n.push(0 | Math.round(e * s.anchorX + r * s.anchorY)), i.push(s.featureIndex);
                }
                return a.sort((t, e)=>n[t] - n[e] || i[e] - i[t]), a;
            }
            addToSortKeyRanges(t, e) {
                const r = this.sortKeyRanges[this.sortKeyRanges.length - 1];
                r && r.sortKey === e ? r.symbolInstanceEnd = t + 1 : this.sortKeyRanges.push({
                    sortKey: e,
                    symbolInstanceStart: t,
                    symbolInstanceEnd: t + 1
                });
            }
            sortFeatures(t) {
                if (this.sortFeaturesByY && this.sortedAngle !== t && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                    this.symbolInstanceIndexes = this.getSortedSymbolIndexes(t), this.sortedAngle = t, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                    for (const t of this.symbolInstanceIndexes){
                        const e = this.symbolInstances.get(t);
                        this.featureSortOrder.push(e.featureIndex), [
                            e.rightJustifiedTextSymbolIndex,
                            e.centerJustifiedTextSymbolIndex,
                            e.leftJustifiedTextSymbolIndex
                        ].forEach((t, e, r)=>{
                            t >= 0 && r.indexOf(t) === e && this.addIndicesForPlacedSymbol(this.text, t);
                        }), e.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.text, e.verticalPlacedTextSymbolIndex), e.placedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, e.placedIconSymbolIndex), e.verticalPlacedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, e.verticalPlacedIconSymbolIndex);
                    }
                    this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                }
            }
        }
        let Ru, qu;
        $n("SymbolBucket", Uu, {
            omit: [
                "layers",
                "collisionBoxArray",
                "features",
                "compareText"
            ]
        }), Uu.MAX_GLYPHS = 65535, Uu.addDynamicAttributes = $u;
        var ju = {
            get paint () {
                return qu = qu || new _i({
                    "icon-opacity": new xi(X.paint_symbol["icon-opacity"]),
                    "icon-color": new xi(X.paint_symbol["icon-color"]),
                    "icon-halo-color": new xi(X.paint_symbol["icon-halo-color"]),
                    "icon-halo-width": new xi(X.paint_symbol["icon-halo-width"]),
                    "icon-halo-blur": new xi(X.paint_symbol["icon-halo-blur"]),
                    "icon-translate": new gi(X.paint_symbol["icon-translate"]),
                    "icon-translate-anchor": new gi(X.paint_symbol["icon-translate-anchor"]),
                    "text-opacity": new xi(X.paint_symbol["text-opacity"]),
                    "text-color": new xi(X.paint_symbol["text-color"], {
                        runtimeType: yt,
                        getOverride: (t)=>t.textColor,
                        hasOverride: (t)=>!!t.textColor
                    }),
                    "text-halo-color": new xi(X.paint_symbol["text-halo-color"]),
                    "text-halo-width": new xi(X.paint_symbol["text-halo-width"]),
                    "text-halo-blur": new xi(X.paint_symbol["text-halo-blur"]),
                    "text-translate": new gi(X.paint_symbol["text-translate"]),
                    "text-translate-anchor": new gi(X.paint_symbol["text-translate-anchor"])
                });
            },
            get layout () {
                return Ru = Ru || new _i({
                    "symbol-placement": new gi(X.layout_symbol["symbol-placement"]),
                    "symbol-spacing": new gi(X.layout_symbol["symbol-spacing"]),
                    "symbol-avoid-edges": new gi(X.layout_symbol["symbol-avoid-edges"]),
                    "symbol-sort-key": new xi(X.layout_symbol["symbol-sort-key"]),
                    "symbol-z-order": new gi(X.layout_symbol["symbol-z-order"]),
                    "icon-allow-overlap": new gi(X.layout_symbol["icon-allow-overlap"]),
                    "icon-overlap": new gi(X.layout_symbol["icon-overlap"]),
                    "icon-ignore-placement": new gi(X.layout_symbol["icon-ignore-placement"]),
                    "icon-optional": new gi(X.layout_symbol["icon-optional"]),
                    "icon-rotation-alignment": new gi(X.layout_symbol["icon-rotation-alignment"]),
                    "icon-size": new xi(X.layout_symbol["icon-size"]),
                    "icon-text-fit": new gi(X.layout_symbol["icon-text-fit"]),
                    "icon-text-fit-padding": new gi(X.layout_symbol["icon-text-fit-padding"]),
                    "icon-image": new xi(X.layout_symbol["icon-image"]),
                    "icon-rotate": new xi(X.layout_symbol["icon-rotate"]),
                    "icon-padding": new xi(X.layout_symbol["icon-padding"]),
                    "icon-keep-upright": new gi(X.layout_symbol["icon-keep-upright"]),
                    "icon-offset": new xi(X.layout_symbol["icon-offset"]),
                    "icon-anchor": new xi(X.layout_symbol["icon-anchor"]),
                    "icon-pitch-alignment": new gi(X.layout_symbol["icon-pitch-alignment"]),
                    "text-pitch-alignment": new gi(X.layout_symbol["text-pitch-alignment"]),
                    "text-rotation-alignment": new gi(X.layout_symbol["text-rotation-alignment"]),
                    "text-field": new xi(X.layout_symbol["text-field"]),
                    "text-font": new xi(X.layout_symbol["text-font"]),
                    "text-size": new xi(X.layout_symbol["text-size"]),
                    "text-max-width": new xi(X.layout_symbol["text-max-width"]),
                    "text-line-height": new gi(X.layout_symbol["text-line-height"]),
                    "text-letter-spacing": new xi(X.layout_symbol["text-letter-spacing"]),
                    "text-justify": new xi(X.layout_symbol["text-justify"]),
                    "text-radial-offset": new xi(X.layout_symbol["text-radial-offset"]),
                    "text-variable-anchor": new gi(X.layout_symbol["text-variable-anchor"]),
                    "text-variable-anchor-offset": new xi(X.layout_symbol["text-variable-anchor-offset"]),
                    "text-anchor": new xi(X.layout_symbol["text-anchor"]),
                    "text-max-angle": new gi(X.layout_symbol["text-max-angle"]),
                    "text-writing-mode": new gi(X.layout_symbol["text-writing-mode"]),
                    "text-rotate": new xi(X.layout_symbol["text-rotate"]),
                    "text-padding": new gi(X.layout_symbol["text-padding"]),
                    "text-keep-upright": new gi(X.layout_symbol["text-keep-upright"]),
                    "text-transform": new xi(X.layout_symbol["text-transform"]),
                    "text-offset": new xi(X.layout_symbol["text-offset"]),
                    "text-allow-overlap": new gi(X.layout_symbol["text-allow-overlap"]),
                    "text-overlap": new gi(X.layout_symbol["text-overlap"]),
                    "text-ignore-placement": new gi(X.layout_symbol["text-ignore-placement"]),
                    "text-optional": new gi(X.layout_symbol["text-optional"])
                });
            }
        };
        class Nu {
            constructor(t){
                if (void 0 === t.property.overrides) throw new Error("overrides must be provided to instantiate FormatSectionOverride class");
                this.type = t.property.overrides ? t.property.overrides.runtimeType : ht, this.defaultValue = t;
            }
            evaluate(t) {
                if (t.formattedSection) {
                    const e = this.defaultValue.property.overrides;
                    if (e && e.hasOverride(t.formattedSection)) return e.getOverride(t.formattedSection);
                }
                return t.feature && t.featureState ? this.defaultValue.evaluate(t.feature, t.featureState) : this.defaultValue.property.specification.default;
            }
            eachChild(t) {
                this.defaultValue.isConstant() || t(this.defaultValue.value._styleExpression.expression);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return null;
            }
        }
        $n("FormatSectionOverride", Nu, {
            omit: [
                "defaultValue"
            ]
        });
        class Zu extends Si {
            constructor(t){
                super(t, ju);
            }
            recalculate(t, e) {
                if (super.recalculate(t, e), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = "map" === this.layout.get("text-rotation-alignment") ? "map" : "viewport"), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment")), "point" === this.layout.get("symbol-placement")) {
                    const t = this.layout.get("text-writing-mode");
                    if (t) {
                        const e = [];
                        for (const r of t)e.indexOf(r) < 0 && e.push(r);
                        this.layout._values["text-writing-mode"] = e;
                    } else this.layout._values["text-writing-mode"] = [
                        "horizontal"
                    ];
                }
                this._setPaintOverrides();
            }
            getValueAndResolveTokens(t, e, r, n) {
                const i = this.layout.get(t).evaluate(e, {}, r, n), a = this._unevaluatedLayout._values[t];
                return a.isDataDriven() || Tr(a.value) || !i ? i : function(t, e) {
                    return e.replace(/{([^{}]+)}/g, (e, r)=>t && r in t ? String(t[r]) : "");
                }(e.properties, i);
            }
            createBucket(t) {
                return new Uu(t);
            }
            queryRadius() {
                return 0;
            }
            queryIntersectsFeature() {
                throw new Error("Should take a different path in FeatureIndex");
            }
            _setPaintOverrides() {
                for (const t of ju.paint.overridableProperties){
                    if (!Zu.hasPaintOverride(this.layout, t)) continue;
                    const e = this.paint.get(t), r = new Nu(e), n = new Fr(r, e.property.specification);
                    let i = null;
                    i = "constant" === e.value.kind || "source" === e.value.kind ? new Lr("source", n) : new Dr("composite", n, e.value.zoomStops), this.paint._values[t] = new yi(e.property, i, e.parameters);
                }
            }
            _handleOverridablePaintPropertyUpdate(t, e, r) {
                return !(!this.layout || e.isDataDriven() || r.isDataDriven()) && Zu.hasPaintOverride(this.layout, t);
            }
            static hasPaintOverride(t, e) {
                const r = t.get("text-field"), n = ju.paint.properties[e];
                let i = !1;
                const a = (t)=>{
                    for (const e of t)if (n.overrides && n.overrides.hasOverride(e)) return void (i = !0);
                };
                if ("constant" === r.value.kind && r.value.value instanceof Qt) a(r.value.value.sections);
                else if ("source" === r.value.kind) {
                    const t = (e)=>{
                        i || (e instanceof le && se(e.value) === vt ? a(e.value.sections) : e instanceof pr ? a(e.sections) : e.eachChild(t));
                    }, e = r.value;
                    e._styleExpression && t(e._styleExpression.expression);
                }
                return i;
            }
        }
        let Ku;
        var Gu = {
            get paint () {
                return Ku = Ku || new _i({
                    "background-color": new gi(X.paint_background["background-color"]),
                    "background-pattern": new bi(X.paint_background["background-pattern"]),
                    "background-opacity": new gi(X.paint_background["background-opacity"])
                });
            }
        };
        class Ju extends Si {
            constructor(t){
                super(t, Gu);
            }
        }
        let Xu;
        var Yu = {
            get paint () {
                return Xu = Xu || new _i({
                    "raster-opacity": new gi(X.paint_raster["raster-opacity"]),
                    "raster-hue-rotate": new gi(X.paint_raster["raster-hue-rotate"]),
                    "raster-brightness-min": new gi(X.paint_raster["raster-brightness-min"]),
                    "raster-brightness-max": new gi(X.paint_raster["raster-brightness-max"]),
                    "raster-saturation": new gi(X.paint_raster["raster-saturation"]),
                    "raster-contrast": new gi(X.paint_raster["raster-contrast"]),
                    "raster-resampling": new gi(X.paint_raster["raster-resampling"]),
                    "raster-fade-duration": new gi(X.paint_raster["raster-fade-duration"])
                });
            }
        };
        class Hu extends Si {
            constructor(t){
                super(t, Yu);
            }
        }
        class Wu extends Si {
            constructor(t){
                super(t, {}), this.onAdd = (t)=>{
                    this.implementation.onAdd && this.implementation.onAdd(t, t.painter.context.gl);
                }, this.onRemove = (t)=>{
                    this.implementation.onRemove && this.implementation.onRemove(t, t.painter.context.gl);
                }, this.implementation = t;
            }
            is3D() {
                return "3d" === this.implementation.renderingMode;
            }
            hasOffscreenPass() {
                return void 0 !== this.implementation.prerender;
            }
            recalculate() {}
            updateTransitions() {}
            hasTransition() {
                return !1;
            }
            serialize() {
                throw new Error("Custom layers cannot be serialized");
            }
        }
        class Qu {
            constructor(t){
                this._callback = t, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = ()=>{
                    this._triggered = !1, this._callback();
                });
            }
            trigger() {
                this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(()=>{
                    this._triggered = !1, this._callback();
                }, 0));
            }
            remove() {
                delete this._channel, this._callback = ()=>{};
            }
        }
        const tc = 6371008.8;
        class ec {
            constructor(t, e){
                if (isNaN(t) || isNaN(e)) throw new Error(`Invalid LngLat object: (${t}, ${e})`);
                if (this.lng = +t, this.lat = +e, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
            }
            wrap() {
                return new ec(m(this.lng, -180, 180), this.lat);
            }
            toArray() {
                return [
                    this.lng,
                    this.lat
                ];
            }
            toString() {
                return `LngLat(${this.lng}, ${this.lat})`;
            }
            distanceTo(t) {
                const e = Math.PI / 180, r = this.lat * e, n = t.lat * e, i = Math.sin(r) * Math.sin(n) + Math.cos(r) * Math.cos(n) * Math.cos((t.lng - this.lng) * e);
                return tc * Math.acos(Math.min(i, 1));
            }
            static convert(t) {
                if (t instanceof ec) return t;
                if (Array.isArray(t) && (2 === t.length || 3 === t.length)) return new ec(Number(t[0]), Number(t[1]));
                if (!Array.isArray(t) && "object" == typeof t && null !== t) return new ec(Number("lng" in t ? t.lng : t.lon), Number(t.lat));
                throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
            }
        }
        const rc = 2 * Math.PI * tc;
        function nc(t) {
            return rc * Math.cos(t * Math.PI / 180);
        }
        function ic(t) {
            return (180 + t) / 360;
        }
        function ac(t) {
            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t * Math.PI / 360))) / 360;
        }
        function sc(t, e) {
            return t / nc(e);
        }
        function oc(t) {
            return 360 * t - 180;
        }
        function lc(t) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t) * Math.PI / 180)) - 90;
        }
        class uc {
            constructor(t, e, r = 0){
                this.x = +t, this.y = +e, this.z = +r;
            }
            static fromLngLat(t, e = 0) {
                const r = ec.convert(t);
                return new uc(ic(r.lng), ac(r.lat), sc(e, r.lat));
            }
            toLngLat() {
                return new ec(oc(this.x), lc(this.y));
            }
            toAltitude() {
                return this.z * nc(lc(this.y));
            }
            meterInMercatorCoordinateUnits() {
                var t;
                return 1 / rc * (t = lc(this.y), 1 / Math.cos(t * Math.PI / 180));
            }
        }
        function cc(t, e, r) {
            var n = 2 * Math.PI * 6378137 / 256 / Math.pow(2, r);
            return [
                t * n - 2 * Math.PI * 6378137 / 2,
                e * n - 2 * Math.PI * 6378137 / 2
            ];
        }
        class hc {
            constructor(t, e, r){
                if (t < 0 || t > 25 || r < 0 || r >= Math.pow(2, t) || e < 0 || e >= Math.pow(2, t)) throw new Error(`x=${e}, y=${r}, z=${t} outside of bounds. 0<=x<${Math.pow(2, t)}, 0<=y<${Math.pow(2, t)} 0<=z<=25 `);
                this.z = t, this.x = e, this.y = r, this.key = dc(0, t, t, e, r);
            }
            equals(t) {
                return this.z === t.z && this.x === t.x && this.y === t.y;
            }
            url(t, e, r) {
                const n = (a = this.y, s = this.z, o = cc(256 * (i = this.x), 256 * (a = Math.pow(2, s) - a - 1), s), l = cc(256 * (i + 1), 256 * (a + 1), s), o[0] + "," + o[1] + "," + l[0] + "," + l[1]);
                var i, a, s, o, l;
                const u = function(t, e, r) {
                    let n, i = "";
                    for(let a = t; a > 0; a--)n = 1 << a - 1, i += (e & n ? 1 : 0) + (r & n ? 2 : 0);
                    return i;
                }(this.z, this.x, this.y);
                return t[(this.x + this.y) % t.length].replace(/{prefix}/g, (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === r ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace(/{ratio}/g, e > 1 ? "@2x" : "").replace(/{quadkey}/g, u).replace(/{bbox-epsg-3857}/g, n);
            }
            isChildOf(t) {
                const e = this.z - t.z;
                return e > 0 && t.x === this.x >> e && t.y === this.y >> e;
            }
            getTilePoint(t) {
                const e = Math.pow(2, this.z);
                return new a((t.x * e - this.x) * rs, (t.y * e - this.y) * rs);
            }
            toString() {
                return `${this.z}/${this.x}/${this.y}`;
            }
        }
        class pc {
            constructor(t, e){
                this.wrap = t, this.canonical = e, this.key = dc(t, e.z, e.z, e.x, e.y);
            }
        }
        class fc {
            constructor(t, e, r, n, i){
                if (t < r) throw new Error(`overscaledZ should be >= z; overscaledZ = ${t}; z = ${r}`);
                this.overscaledZ = t, this.wrap = e, this.canonical = new hc(r, +n, +i), this.key = dc(e, t, r, n, i);
            }
            clone() {
                return new fc(this.overscaledZ, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            equals(t) {
                return this.overscaledZ === t.overscaledZ && this.wrap === t.wrap && this.canonical.equals(t.canonical);
            }
            scaledTo(t) {
                if (t > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${t}; overscaledZ = ${this.overscaledZ}`);
                const e = this.canonical.z - t;
                return t > this.canonical.z ? new fc(t, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new fc(t, this.wrap, t, this.canonical.x >> e, this.canonical.y >> e);
            }
            calculateScaledKey(t, e) {
                if (t > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${t}; overscaledZ = ${this.overscaledZ}`);
                const r = this.canonical.z - t;
                return t > this.canonical.z ? dc(this.wrap * +e, t, this.canonical.z, this.canonical.x, this.canonical.y) : dc(this.wrap * +e, t, t, this.canonical.x >> r, this.canonical.y >> r);
            }
            isChildOf(t) {
                if (t.wrap !== this.wrap) return !1;
                const e = this.canonical.z - t.canonical.z;
                return 0 === t.overscaledZ || t.overscaledZ < this.overscaledZ && t.canonical.x === this.canonical.x >> e && t.canonical.y === this.canonical.y >> e;
            }
            children(t) {
                if (this.overscaledZ >= t) return [
                    new fc(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                ];
                const e = this.canonical.z + 1, r = 2 * this.canonical.x, n = 2 * this.canonical.y;
                return [
                    new fc(e, this.wrap, e, r, n),
                    new fc(e, this.wrap, e, r + 1, n),
                    new fc(e, this.wrap, e, r, n + 1),
                    new fc(e, this.wrap, e, r + 1, n + 1)
                ];
            }
            isLessThan(t) {
                return this.wrap < t.wrap || !(this.wrap > t.wrap) && (this.overscaledZ < t.overscaledZ || !(this.overscaledZ > t.overscaledZ) && (this.canonical.x < t.canonical.x || !(this.canonical.x > t.canonical.x) && this.canonical.y < t.canonical.y));
            }
            wrapped() {
                return new fc(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            unwrapTo(t) {
                return new fc(this.overscaledZ, t, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            overscaleFactor() {
                return Math.pow(2, this.overscaledZ - this.canonical.z);
            }
            toUnwrapped() {
                return new pc(this.wrap, this.canonical);
            }
            toString() {
                return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
            }
            getTilePoint(t) {
                return this.canonical.getTilePoint(new uc(t.x - this.wrap, t.y));
            }
        }
        function dc(t, e, r, n, i) {
            (t *= 2) < 0 && (t = -1 * t - 1);
            const a = 1 << r;
            return (a * a * t + a * i + n).toString(36) + r.toString(36) + e.toString(36);
        }
        $n("CanonicalTileID", hc), $n("OverscaledTileID", fc, {
            omit: [
                "posMatrix"
            ]
        });
        class yc {
            constructor(t, e, r, n = 1, i = 1, a = 1, s = 0){
                if (this.uid = t, e.height !== e.width) throw new RangeError("DEM tiles must be square");
                if (r && ![
                    "mapbox",
                    "terrarium",
                    "custom"
                ].includes(r)) return void A(`"${r}" is not a valid encoding type. Valid types include "mapbox", "terrarium" and "custom".`);
                this.stride = e.height;
                const o = this.dim = e.height - 2;
                switch(this.data = new Uint32Array(e.data.buffer), r){
                    case "terrarium":
                        this.redFactor = 256, this.greenFactor = 1, this.blueFactor = 1 / 256, this.baseShift = 32768;
                        break;
                    case "custom":
                        this.redFactor = n, this.greenFactor = i, this.blueFactor = a, this.baseShift = s;
                        break;
                    default:
                        this.redFactor = 6553.6, this.greenFactor = 25.6, this.blueFactor = .1, this.baseShift = 1e4;
                }
                for(let t = 0; t < o; t++)this.data[this._idx(-1, t)] = this.data[this._idx(0, t)], this.data[this._idx(o, t)] = this.data[this._idx(o - 1, t)], this.data[this._idx(t, -1)] = this.data[this._idx(t, 0)], this.data[this._idx(t, o)] = this.data[this._idx(t, o - 1)];
                this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)], this.data[this._idx(o, -1)] = this.data[this._idx(o - 1, 0)], this.data[this._idx(-1, o)] = this.data[this._idx(0, o - 1)], this.data[this._idx(o, o)] = this.data[this._idx(o - 1, o - 1)], this.min = Number.MAX_SAFE_INTEGER, this.max = Number.MIN_SAFE_INTEGER;
                for(let t = 0; t < o; t++)for(let e = 0; e < o; e++){
                    const r = this.get(t, e);
                    r > this.max && (this.max = r), r < this.min && (this.min = r);
                }
            }
            get(t, e) {
                const r = new Uint8Array(this.data.buffer), n = 4 * this._idx(t, e);
                return this.unpack(r[n], r[n + 1], r[n + 2]);
            }
            getUnpackVector() {
                return [
                    this.redFactor,
                    this.greenFactor,
                    this.blueFactor,
                    this.baseShift
                ];
            }
            _idx(t, e) {
                if (t < -1 || t >= this.dim + 1 || e < -1 || e >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
                return (e + 1) * this.stride + (t + 1);
            }
            unpack(t, e, r) {
                return t * this.redFactor + e * this.greenFactor + r * this.blueFactor - this.baseShift;
            }
            getPixels() {
                return new qs({
                    width: this.stride,
                    height: this.stride
                }, new Uint8Array(this.data.buffer));
            }
            backfillBorder(t, e, r) {
                if (this.dim !== t.dim) throw new Error("dem dimension mismatch");
                let n = e * this.dim, i = e * this.dim + this.dim, a = r * this.dim, s = r * this.dim + this.dim;
                switch(e){
                    case -1:
                        n = i - 1;
                        break;
                    case 1:
                        i = n + 1;
                }
                switch(r){
                    case -1:
                        a = s - 1;
                        break;
                    case 1:
                        s = a + 1;
                }
                const o = -e * this.dim, l = -r * this.dim;
                for(let e = a; e < s; e++)for(let r = n; r < i; r++)this.data[this._idx(r, e)] = t.data[this._idx(r + o, e + l)];
            }
        }
        $n("DEMData", yc);
        class mc {
            constructor(t){
                this._stringToNumber = {}, this._numberToString = [];
                for(let e = 0; e < t.length; e++){
                    const r = t[e];
                    this._stringToNumber[r] = e, this._numberToString[e] = r;
                }
            }
            encode(t) {
                return this._stringToNumber[t];
            }
            decode(t) {
                if (t >= this._numberToString.length) throw new Error(`Out of bounds. Index requested n=${t} can't be >= this._numberToString.length ${this._numberToString.length}`);
                return this._numberToString[t];
            }
        }
        class gc {
            constructor(t, e, r, n, i){
                this.type = "Feature", this._vectorTileFeature = t, t._z = e, t._x = r, t._y = n, this.properties = t.properties, this.id = i;
            }
            get geometry() {
                return void 0 === this._geometry && (this._geometry = this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x, this._vectorTileFeature._y, this._vectorTileFeature._z).geometry), this._geometry;
            }
            set geometry(t) {
                this._geometry = t;
            }
            toJSON() {
                const t = {
                    geometry: this.geometry
                };
                for(const e in this)"_geometry" !== e && "_vectorTileFeature" !== e && (t[e] = this[e]);
                return t;
            }
        }
        class xc {
            constructor(t, e){
                this.tileID = t, this.x = t.canonical.x, this.y = t.canonical.y, this.z = t.canonical.z, this.grid = new Fn(rs, 16, 0), this.grid3D = new Fn(rs, 16, 0), this.featureIndexArray = new ca, this.promoteId = e;
            }
            insert(t, e, r, n, i, a) {
                const s = this.featureIndexArray.length;
                this.featureIndexArray.emplaceBack(r, n, i);
                const o = a ? this.grid3D : this.grid;
                for(let t = 0; t < e.length; t++){
                    const r = e[t], n = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ];
                    for(let t = 0; t < r.length; t++){
                        const e = r[t];
                        n[0] = Math.min(n[0], e.x), n[1] = Math.min(n[1], e.y), n[2] = Math.max(n[2], e.x), n[3] = Math.max(n[3], e.y);
                    }
                    n[0] < rs && n[1] < rs && n[2] >= 0 && n[3] >= 0 && o.insert(s, n[0], n[1], n[2], n[3]);
                }
            }
            loadVTLayers() {
                return this.vtLayers || (this.vtLayers = new Ro.VectorTile(new eu(this.rawTileData)).layers, this.sourceLayerCoder = new mc(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                    "_geojsonTileLayer"
                ])), this.vtLayers;
            }
            query(t, e, r, n) {
                this.loadVTLayers();
                const i = t.params || {}, s = rs / t.tileSize / t.scale, o = Nr(i.filter), l = t.queryGeometry, u = t.queryPadding * s, c = bc(l), h = this.grid.query(c.minX - u, c.minY - u, c.maxX + u, c.maxY + u), p = bc(t.cameraQueryGeometry), f = this.grid3D.query(p.minX - u, p.minY - u, p.maxX + u, p.maxY + u, (e, r, n, i)=>(function(t, e, r, n, i) {
                        for (const a of t)if (e <= a.x && r <= a.y && n >= a.x && i >= a.y) return !0;
                        const s = [
                            new a(e, r),
                            new a(e, i),
                            new a(n, i),
                            new a(n, r)
                        ];
                        if (t.length > 2) {
                            for (const e of s)if (xs(t, e)) return !0;
                        }
                        for(let e = 0; e < t.length - 1; e++)if (vs(t[e], t[e + 1], s)) return !0;
                        return !1;
                    })(t.cameraQueryGeometry, e - u, r - u, n + u, i + u));
                for (const t of f)h.push(t);
                h.sort(wc);
                const d = {};
                let y;
                for(let a = 0; a < h.length; a++){
                    const u = h[a];
                    if (u === y) continue;
                    y = u;
                    const c = this.featureIndexArray.get(u);
                    let p = null;
                    this.loadMatchingFeature(d, c.bucketIndex, c.sourceLayerIndex, c.featureIndex, o, i.layers, i.availableImages, e, r, n, (e, r, n)=>(p || (p = as(e)), r.queryIntersectsFeature(l, e, n, p, this.z, t.transform, s, t.pixelPosMatrix)));
                }
                return d;
            }
            loadMatchingFeature(t, e, r, n, i, a, s, o, l, u, c) {
                const h = this.bucketLayerIDs[e];
                if (a && !function(t, e) {
                    for(let r = 0; r < t.length; r++)if (e.indexOf(t[r]) >= 0) return !0;
                    return !1;
                }(a, h)) return;
                const p = this.sourceLayerCoder.decode(r), f = this.vtLayers[p].feature(n);
                if (i.needGeometry) {
                    const t = ss(f, !0);
                    if (!i.filter(new li(this.tileID.overscaledZ), t, this.tileID.canonical)) return;
                } else if (!i.filter(new li(this.tileID.overscaledZ), f)) return;
                const d = this.getId(f, p);
                for(let e = 0; e < h.length; e++){
                    const r = h[e];
                    if (a && a.indexOf(r) < 0) continue;
                    const i = o[r];
                    if (!i) continue;
                    let p = {};
                    d && u && (p = u.getState(i.sourceLayer || "_geojsonTileLayer", d));
                    const y = g({}, l[r]);
                    y.paint = vc(y.paint, i.paint, f, p, s), y.layout = vc(y.layout, i.layout, f, p, s);
                    const m = !c || c(f, i, p);
                    if (!m) continue;
                    const x = new gc(f, this.z, this.x, this.y, d);
                    x.layer = y;
                    let v = t[r];
                    void 0 === v && (v = t[r] = []), v.push({
                        featureIndex: n,
                        feature: x,
                        intersectionZ: m
                    });
                }
            }
            lookupSymbolFeatures(t, e, r, n, i, a, s, o) {
                const l = {};
                this.loadVTLayers();
                const u = Nr(i);
                for (const i of t)this.loadMatchingFeature(l, r, n, i, u, a, s, o, e);
                return l;
            }
            hasLayer(t) {
                for (const e of this.bucketLayerIDs)for (const r of e)if (t === r) return !0;
                return !1;
            }
            getId(t, e) {
                let r = t.id;
                return this.promoteId && (r = t.properties["string" == typeof this.promoteId ? this.promoteId : this.promoteId[e]], "boolean" == typeof r && (r = Number(r))), r;
            }
        }
        function vc(t, e, r, n, i) {
            return v(t, (t, a)=>{
                const s = e instanceof mi ? e.get(a) : null;
                return s && s.evaluate ? s.evaluate(r, n, i) : s;
            });
        }
        function bc(t) {
            let e = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0;
            for (const a of t)e = Math.min(e, a.x), r = Math.min(r, a.y), n = Math.max(n, a.x), i = Math.max(i, a.y);
            return {
                minX: e,
                minY: r,
                maxX: n,
                maxY: i
            };
        }
        function wc(t, e) {
            return e - t;
        }
        function _c(t, e, r, n, i) {
            const s = [];
            for(let o = 0; o < t.length; o++){
                const l = t[o];
                let u;
                for(let t = 0; t < l.length - 1; t++){
                    let o = l[t], c = l[t + 1];
                    o.x < e && c.x < e || (o.x < e ? o = new a(e, o.y + (e - o.x) / (c.x - o.x) * (c.y - o.y))._round() : c.x < e && (c = new a(e, o.y + (e - o.x) / (c.x - o.x) * (c.y - o.y))._round()), o.y < r && c.y < r || (o.y < r ? o = new a(o.x + (r - o.y) / (c.y - o.y) * (c.x - o.x), r)._round() : c.y < r && (c = new a(o.x + (r - o.y) / (c.y - o.y) * (c.x - o.x), r)._round()), o.x >= n && c.x >= n || (o.x >= n ? o = new a(n, o.y + (n - o.x) / (c.x - o.x) * (c.y - o.y))._round() : c.x >= n && (c = new a(n, o.y + (n - o.x) / (c.x - o.x) * (c.y - o.y))._round()), o.y >= i && c.y >= i || (o.y >= i ? o = new a(o.x + (i - o.y) / (c.y - o.y) * (c.x - o.x), i)._round() : c.y >= i && (c = new a(o.x + (i - o.y) / (c.y - o.y) * (c.x - o.x), i)._round()), u && o.equals(u[u.length - 1]) || (u = [
                        o
                    ], s.push(u)), u.push(c)))));
                }
            }
            return s;
        }
        $n("FeatureIndex", xc, {
            omit: [
                "rawTileData",
                "sourceLayerCoder"
            ]
        });
        class Ac extends a {
            constructor(t, e, r, n){
                super(t, e), this.angle = r, void 0 !== n && (this.segment = n);
            }
            clone() {
                return new Ac(this.x, this.y, this.angle, this.segment);
            }
        }
        function Sc(t, e, r, n, i) {
            if (void 0 === e.segment || 0 === r) return !0;
            let a = e, s = e.segment + 1, o = 0;
            for(; o > -r / 2;){
                if (s--, s < 0) return !1;
                o -= t[s].dist(a), a = t[s];
            }
            o += t[s].dist(t[s + 1]), s++;
            const l = [];
            let u = 0;
            for(; o < r / 2;){
                const e = t[s], r = t[s + 1];
                if (!r) return !1;
                let a = t[s - 1].angleTo(e) - e.angleTo(r);
                for(a = Math.abs((a + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
                    distance: o,
                    angleDelta: a
                }), u += a; o - l[0].distance > n;)u -= l.shift().angleDelta;
                if (u > i) return !1;
                s++, o += e.dist(r);
            }
            return !0;
        }
        function kc(t) {
            let e = 0;
            for(let r = 0; r < t.length - 1; r++)e += t[r].dist(t[r + 1]);
            return e;
        }
        function Ic(t, e, r) {
            return t ? .6 * e * r : 0;
        }
        function zc(t, e) {
            return Math.max(t ? t.right - t.left : 0, e ? e.right - e.left : 0);
        }
        function Mc(t, e, r, n, i, a) {
            const s = Ic(r, i, a), o = zc(r, n) * a;
            let l = 0;
            const u = kc(t) / 2;
            for(let r = 0; r < t.length - 1; r++){
                const n = t[r], i = t[r + 1], a = n.dist(i);
                if (l + a > u) {
                    const c = (u - l) / a, h = Ze.number(n.x, i.x, c), p = Ze.number(n.y, i.y, c), f = new Ac(h, p, i.angleTo(n), r);
                    return f._round(), !s || Sc(t, f, o, s, e) ? f : void 0;
                }
                l += a;
            }
        }
        function Cc(t, e, r, n, i, a, s, o, l) {
            const u = Ic(n, a, s), c = zc(n, i), h = c * s, p = 0 === t[0].x || t[0].x === l || 0 === t[0].y || t[0].y === l;
            return e - h < e / 4 && (e = h + e / 4), Bc(t, p ? e / 2 * o % e : (c / 2 + 2 * a) * s * o % e, e, u, r, h, p, !1, l);
        }
        function Bc(t, e, r, n, i, a, s, o, l) {
            const u = a / 2, c = kc(t);
            let h = 0, p = e - r, f = [];
            for(let e = 0; e < t.length - 1; e++){
                const s = t[e], o = t[e + 1], d = s.dist(o), y = o.angleTo(s);
                for(; p + r < h + d;){
                    p += r;
                    const m = (p - h) / d, g = Ze.number(s.x, o.x, m), x = Ze.number(s.y, o.y, m);
                    if (g >= 0 && g < l && x >= 0 && x < l && p - u >= 0 && p + u <= c) {
                        const r = new Ac(g, x, y, e);
                        r._round(), n && !Sc(t, r, a, n, i) || f.push(r);
                    }
                }
                h += d;
            }
            return o || f.length || s || (f = Bc(t, h / 2, r, n, i, a, s, !0, l)), f;
        }
        $n("Anchor", Ac);
        const Pc = lu;
        function Vc(t, e, r, n) {
            const i = [], s = t.image, o = s.pixelRatio, l = s.paddedRect.w - 2 * Pc, u = s.paddedRect.h - 2 * Pc, c = t.right - t.left, h = t.bottom - t.top, p = s.stretchX || [
                [
                    0,
                    l
                ]
            ], f = s.stretchY || [
                [
                    0,
                    u
                ]
            ], d = (t, e)=>t + e[1] - e[0], y = p.reduce(d, 0), m = f.reduce(d, 0), g = l - y, x = u - m;
            let v = 0, b = y, w = 0, _ = m, A = 0, S = g, k = 0, I = x;
            if (s.content && n) {
                const t = s.content;
                v = Ec(p, 0, t[0]), w = Ec(f, 0, t[1]), b = Ec(p, t[0], t[2]), _ = Ec(f, t[1], t[3]), A = t[0] - v, k = t[1] - w, S = t[2] - t[0] - b, I = t[3] - t[1] - _;
            }
            const z = (n, i, l, u)=>{
                const p = Tc(n.stretch - v, b, c, t.left), f = $c(n.fixed - A, S, n.stretch, y), d = Tc(i.stretch - w, _, h, t.top), g = $c(i.fixed - k, I, i.stretch, m), x = Tc(l.stretch - v, b, c, t.left), z = $c(l.fixed - A, S, l.stretch, y), M = Tc(u.stretch - w, _, h, t.top), C = $c(u.fixed - k, I, u.stretch, m), B = new a(p, d), P = new a(x, d), V = new a(x, M), E = new a(p, M), F = new a(f / o, g / o), T = new a(z / o, C / o), $ = e * Math.PI / 180;
                if ($) {
                    const t = Math.sin($), e = Math.cos($), r = [
                        e,
                        -t,
                        t,
                        e
                    ];
                    B._matMult(r), P._matMult(r), E._matMult(r), V._matMult(r);
                }
                const L = n.stretch + n.fixed, D = i.stretch + i.fixed;
                return {
                    tl: B,
                    tr: P,
                    bl: E,
                    br: V,
                    tex: {
                        x: s.paddedRect.x + Pc + L,
                        y: s.paddedRect.y + Pc + D,
                        w: l.stretch + l.fixed - L,
                        h: u.stretch + u.fixed - D
                    },
                    writingMode: void 0,
                    glyphOffset: [
                        0,
                        0
                    ],
                    sectionIndex: 0,
                    pixelOffsetTL: F,
                    pixelOffsetBR: T,
                    minFontScaleX: S / o / c,
                    minFontScaleY: I / o / h,
                    isSDF: r
                };
            };
            if (n && (s.stretchX || s.stretchY)) {
                const t = Fc(p, g, y), e = Fc(f, x, m);
                for(let r = 0; r < t.length - 1; r++){
                    const n = t[r], a = t[r + 1];
                    for(let t = 0; t < e.length - 1; t++)i.push(z(n, e[t], a, e[t + 1]));
                }
            } else i.push(z({
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: l + 1
            }, {
                fixed: 0,
                stretch: u + 1
            }));
            return i;
        }
        function Ec(t, e, r) {
            let n = 0;
            for (const i of t)n += Math.max(e, Math.min(r, i[1])) - Math.max(e, Math.min(r, i[0]));
            return n;
        }
        function Fc(t, e, r) {
            const n = [
                {
                    fixed: -Pc,
                    stretch: 0
                }
            ];
            for (const [e, r] of t){
                const t = n[n.length - 1];
                n.push({
                    fixed: e - t.stretch,
                    stretch: t.stretch
                }), n.push({
                    fixed: e - t.stretch,
                    stretch: t.stretch + (r - e)
                });
            }
            return n.push({
                fixed: e + Pc,
                stretch: r
            }), n;
        }
        function Tc(t, e, r, n) {
            return t / e * r + n;
        }
        function $c(t, e, r, n) {
            return t - e * r / n;
        }
        class Lc {
            constructor(t, e, r, n, i, s, o, l, u, c){
                if (this.boxStartIndex = t.length, u) {
                    let t = s.top, e = s.bottom;
                    const r = s.collisionPadding;
                    r && (t -= r[1], e += r[3]);
                    let n = e - t;
                    n > 0 && (n = Math.max(10, n), this.circleDiameter = n);
                } else {
                    let u = s.top * o - l[0], h = s.bottom * o + l[2], p = s.left * o - l[3], f = s.right * o + l[1];
                    const d = s.collisionPadding;
                    if (d && (p -= d[0] * o, u -= d[1] * o, f += d[2] * o, h += d[3] * o), c) {
                        const t = new a(p, u), e = new a(f, u), r = new a(p, h), n = new a(f, h), i = c * Math.PI / 180;
                        t._rotate(i), e._rotate(i), r._rotate(i), n._rotate(i), p = Math.min(t.x, e.x, r.x, n.x), f = Math.max(t.x, e.x, r.x, n.x), u = Math.min(t.y, e.y, r.y, n.y), h = Math.max(t.y, e.y, r.y, n.y);
                    }
                    t.emplaceBack(e.x, e.y, p, u, f, h, r, n, i);
                }
                this.boxEndIndex = t.length;
            }
        }
        class Dc {
            constructor(t = [], e = Oc){
                if (this.data = t, this.length = this.data.length, this.compare = e, this.length > 0) for(let t = (this.length >> 1) - 1; t >= 0; t--)this._down(t);
            }
            push(t) {
                this.data.push(t), this.length++, this._up(this.length - 1);
            }
            pop() {
                if (0 === this.length) return;
                const t = this.data[0], e = this.data.pop();
                return this.length--, this.length > 0 && (this.data[0] = e, this._down(0)), t;
            }
            peek() {
                return this.data[0];
            }
            _up(t) {
                const { data: e, compare: r } = this, n = e[t];
                for(; t > 0;){
                    const i = t - 1 >> 1, a = e[i];
                    if (r(n, a) >= 0) break;
                    e[t] = a, t = i;
                }
                e[t] = n;
            }
            _down(t) {
                const { data: e, compare: r } = this, n = this.length >> 1, i = e[t];
                for(; t < n;){
                    let n = 1 + (t << 1), a = e[n];
                    const s = n + 1;
                    if (s < this.length && r(e[s], a) < 0 && (n = s, a = e[s]), r(a, i) >= 0) break;
                    e[t] = a, t = n;
                }
                e[t] = i;
            }
        }
        function Oc(t, e) {
            return t < e ? -1 : t > e ? 1 : 0;
        }
        function Uc(t, e = 1, r = !1) {
            let n = 1 / 0, i = 1 / 0, s = -1 / 0, o = -1 / 0;
            const l = t[0];
            for(let t = 0; t < l.length; t++){
                const e = l[t];
                (!t || e.x < n) && (n = e.x), (!t || e.y < i) && (i = e.y), (!t || e.x > s) && (s = e.x), (!t || e.y > o) && (o = e.y);
            }
            const u = Math.min(s - n, o - i);
            let c = u / 2;
            const h = new Dc([], Rc);
            if (0 === u) return new a(n, i);
            for(let e = n; e < s; e += u)for(let r = i; r < o; r += u)h.push(new qc(e + c, r + c, c, t));
            let p = function(t) {
                let e = 0, r = 0, n = 0;
                const i = t[0];
                for(let t = 0, a = i.length, s = a - 1; t < a; s = t++){
                    const a = i[t], o = i[s], l = a.x * o.y - o.x * a.y;
                    r += (a.x + o.x) * l, n += (a.y + o.y) * l, e += 3 * l;
                }
                return new qc(r / e, n / e, 0, t);
            }(t), f = h.length;
            for(; h.length;){
                const n = h.pop();
                (n.d > p.d || !p.d) && (p = n, r && console.log("found best %d after %d probes", Math.round(1e4 * n.d) / 1e4, f)), n.max - p.d <= e || (c = n.h / 2, h.push(new qc(n.p.x - c, n.p.y - c, c, t)), h.push(new qc(n.p.x + c, n.p.y - c, c, t)), h.push(new qc(n.p.x - c, n.p.y + c, c, t)), h.push(new qc(n.p.x + c, n.p.y + c, c, t)), f += 4);
            }
            return r && (console.log(`num probes: ${f}`), console.log(`best distance: ${p.d}`)), p.p;
        }
        function Rc(t, e) {
            return e.max - t.max;
        }
        function qc(t, e, r, n) {
            this.p = new a(t, e), this.h = r, this.d = function(t, e) {
                let r = !1, n = 1 / 0;
                for(let i = 0; i < e.length; i++){
                    const a = e[i];
                    for(let e = 0, i = a.length, s = i - 1; e < i; s = e++){
                        const i = a[e], o = a[s];
                        i.y > t.y != o.y > t.y && t.x < (o.x - i.x) * (t.y - i.y) / (o.y - i.y) + i.x && (r = !r), n = Math.min(n, ms(t, i, o));
                    }
                }
                return (r ? 1 : -1) * Math.sqrt(n);
            }(this.p, n), this.max = this.d + this.h * Math.SQRT2;
        }
        var jc;
        t.aq = void 0, (jc = t.aq || (t.aq = {}))[jc.center = 1] = "center", jc[jc.left = 2] = "left", jc[jc.right = 3] = "right", jc[jc.top = 4] = "top", jc[jc.bottom = 5] = "bottom", jc[jc["top-left"] = 6] = "top-left", jc[jc["top-right"] = 7] = "top-right", jc[jc["bottom-left"] = 8] = "bottom-left", jc[jc["bottom-right"] = 9] = "bottom-right";
        const Nc = 7, Zc = Number.POSITIVE_INFINITY;
        function Kc(t, e) {
            return e[1] !== Zc ? function(t, e, r) {
                let n = 0, i = 0;
                switch(e = Math.abs(e), r = Math.abs(r), t){
                    case "top-right":
                    case "top-left":
                    case "top":
                        i = r - Nc;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                    case "bottom":
                        i = -r + Nc;
                }
                switch(t){
                    case "top-right":
                    case "bottom-right":
                    case "right":
                        n = -e;
                        break;
                    case "top-left":
                    case "bottom-left":
                    case "left":
                        n = e;
                }
                return [
                    n,
                    i
                ];
            }(t, e[0], e[1]) : function(t, e) {
                let r = 0, n = 0;
                e < 0 && (e = 0);
                const i = e / Math.SQRT2;
                switch(t){
                    case "top-right":
                    case "top-left":
                        n = i - Nc;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                        n = -i + Nc;
                        break;
                    case "bottom":
                        n = -e + Nc;
                        break;
                    case "top":
                        n = e - Nc;
                }
                switch(t){
                    case "top-right":
                    case "bottom-right":
                        r = -i;
                        break;
                    case "top-left":
                    case "bottom-left":
                        r = i;
                        break;
                    case "left":
                        r = e;
                        break;
                    case "right":
                        r = -e;
                }
                return [
                    r,
                    n
                ];
            }(t, e[0]);
        }
        function Gc(t, e, r) {
            var n;
            const i = t.layout, a = null === (n = i.get("text-variable-anchor-offset")) || void 0 === n ? void 0 : n.evaluate(e, {}, r);
            if (a) {
                const t = a.values, e = [];
                for(let r = 0; r < t.length; r += 2){
                    const n = e[r] = t[r], i = t[r + 1].map((t)=>t * Vl);
                    n.startsWith("top") ? i[1] -= Nc : n.startsWith("bottom") && (i[1] += Nc), e[r + 1] = i;
                }
                return new re(e);
            }
            const s = i.get("text-variable-anchor");
            if (s) {
                let n;
                n = void 0 !== t._unevaluatedLayout.getValue("text-radial-offset") ? [
                    i.get("text-radial-offset").evaluate(e, {}, r) * Vl,
                    Zc
                ] : i.get("text-offset").evaluate(e, {}, r).map((t)=>t * Vl);
                const a = [];
                for (const t of s)a.push(t, Kc(t, n));
                return new re(a);
            }
            return null;
        }
        function Jc(t) {
            switch(t){
                case "right":
                case "top-right":
                case "bottom-right":
                    return "right";
                case "left":
                case "top-left":
                case "bottom-left":
                    return "left";
            }
            return "center";
        }
        function Xc(e, r, n, i, a, s, o, l, u, c, h) {
            let p = s.textMaxSize.evaluate(r, {});
            void 0 === p && (p = o);
            const f = e.layers[0].layout, d = f.get("icon-offset").evaluate(r, {}, h), y = Hc(n.horizontal), m = o / 24, g = e.tilePixelRatio * m, x = e.tilePixelRatio * p / 24, v = e.tilePixelRatio * l, b = e.tilePixelRatio * f.get("symbol-spacing"), w = f.get("text-padding") * e.tilePixelRatio, _ = function(t, e, r, n = 1) {
                const i = t.get("icon-padding").evaluate(e, {}, r), a = i && i.values;
                return [
                    a[0] * n,
                    a[1] * n,
                    a[2] * n,
                    a[3] * n
                ];
            }(f, r, h, e.tilePixelRatio), S = f.get("text-max-angle") / 180 * Math.PI, k = "viewport" !== f.get("text-rotation-alignment") && "point" !== f.get("symbol-placement"), I = "map" === f.get("icon-rotation-alignment") && "point" !== f.get("symbol-placement"), z = f.get("symbol-placement"), M = b / 2, C = f.get("icon-text-fit");
            let B;
            i && "none" !== C && (e.allowVerticalPlacement && n.vertical && (B = zu(i, n.vertical, C, f.get("icon-text-fit-padding"), d, m)), y && (i = zu(i, y, C, f.get("icon-text-fit-padding"), d, m)));
            const P = (l, p)=>{
                p.x < 0 || p.x >= rs || p.y < 0 || p.y >= rs || function(e, r, n, i, a, s, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, S, k, I) {
                    const z = e.addToLineVertexArray(r, n);
                    let M, C, B, P, V = 0, E = 0, F = 0, T = 0, $ = -1, L = -1;
                    const D = {};
                    let O = $a("");
                    if (e.allowVerticalPlacement && i.vertical) {
                        const t = l.layout.get("text-rotate").evaluate(w, {}, k) + 90;
                        B = new Lc(u, r, c, h, p, i.vertical, f, d, y, t), o && (P = new Lc(u, r, c, h, p, o, g, x, y, t));
                    }
                    if (a) {
                        const n = l.layout.get("icon-rotate").evaluate(w, {}), i = "none" !== l.layout.get("icon-text-fit"), s = Vc(a, n, S, i), f = o ? Vc(o, n, S, i) : void 0;
                        C = new Lc(u, r, c, h, p, a, g, x, !1, n), V = 4 * s.length;
                        const d = e.iconSizeData;
                        let y = null;
                        "source" === d.kind ? (y = [
                            Cu * l.layout.get("icon-size").evaluate(w, {})
                        ], y[0] > Bu && A(`${e.layerIds[0]}: Value for "icon-size" is >= ${Mu}. Reduce your "icon-size".`)) : "composite" === d.kind && (y = [
                            Cu * _.compositeIconSizes[0].evaluate(w, {}, k),
                            Cu * _.compositeIconSizes[1].evaluate(w, {}, k)
                        ], (y[0] > Bu || y[1] > Bu) && A(`${e.layerIds[0]}: Value for "icon-size" is >= ${Mu}. Reduce your "icon-size".`)), e.addSymbols(e.icon, s, y, b, v, w, t.ai.none, r, z.lineStartIndex, z.lineLength, -1, k), $ = e.icon.placedSymbolArray.length - 1, f && (E = 4 * f.length, e.addSymbols(e.icon, f, y, b, v, w, t.ai.vertical, r, z.lineStartIndex, z.lineLength, -1, k), L = e.icon.placedSymbolArray.length - 1);
                    }
                    const U = Object.keys(i.horizontal);
                    for (const n of U){
                        const a = i.horizontal[n];
                        if (!M) {
                            O = $a(a.text);
                            const t = l.layout.get("text-rotate").evaluate(w, {}, k);
                            M = new Lc(u, r, c, h, p, a, f, d, y, t);
                        }
                        const o = 1 === a.positionedLines.length;
                        if (F += Yc(e, r, a, s, l, y, w, m, z, i.vertical ? t.ai.horizontal : t.ai.horizontalOnly, o ? U : [
                            n
                        ], D, $, _, k), o) break;
                    }
                    i.vertical && (T += Yc(e, r, i.vertical, s, l, y, w, m, z, t.ai.vertical, [
                        "vertical"
                    ], D, L, _, k));
                    const R = M ? M.boxStartIndex : e.collisionBoxArray.length, q = M ? M.boxEndIndex : e.collisionBoxArray.length, j = B ? B.boxStartIndex : e.collisionBoxArray.length, N = B ? B.boxEndIndex : e.collisionBoxArray.length, Z = C ? C.boxStartIndex : e.collisionBoxArray.length, K = C ? C.boxEndIndex : e.collisionBoxArray.length, G = P ? P.boxStartIndex : e.collisionBoxArray.length, J = P ? P.boxEndIndex : e.collisionBoxArray.length;
                    let X = -1;
                    const Y = (t, e)=>t && t.circleDiameter ? Math.max(t.circleDiameter, e) : e;
                    X = Y(M, X), X = Y(B, X), X = Y(C, X), X = Y(P, X);
                    const H = X > -1 ? 1 : 0;
                    H && (X *= I / Vl), e.glyphOffsetArray.length >= Uu.MAX_GLYPHS && A("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== w.sortKey && e.addToSortKeyRanges(e.symbolInstances.length, w.sortKey);
                    const W = Gc(l, w, k), [Q, tt] = function(e, r) {
                        const n = e.length, i = null == r ? void 0 : r.values;
                        if ((null == i ? void 0 : i.length) > 0) for(let r = 0; r < i.length; r += 2){
                            const n = i[r + 1];
                            e.emplaceBack(t.aq[i[r]], n[0], n[1]);
                        }
                        return [
                            n,
                            e.length
                        ];
                    }(e.textAnchorOffsets, W);
                    e.symbolInstances.emplaceBack(r.x, r.y, D.right >= 0 ? D.right : -1, D.center >= 0 ? D.center : -1, D.left >= 0 ? D.left : -1, D.vertical || -1, $, L, O, R, q, j, N, Z, K, G, J, c, F, T, V, E, H, 0, f, X, Q, tt);
                }(e, p, l, n, i, a, B, e.layers[0], e.collisionBoxArray, r.index, r.sourceLayerIndex, e.index, g, [
                    w,
                    w,
                    w,
                    w
                ], k, u, v, _, I, d, r, s, c, h, o);
            };
            if ("line" === z) for (const t of _c(r.geometry, 0, 0, rs, rs)){
                const r = Cc(t, b, S, n.vertical || y, i, 24, x, e.overscaling, rs);
                for (const n of r)y && Wc(e, y.text, M, n) || P(t, n);
            }
            else if ("line-center" === z) {
                for (const t of r.geometry)if (t.length > 1) {
                    const e = Mc(t, S, n.vertical || y, i, 24, x);
                    e && P(t, e);
                }
            } else if ("Polygon" === r.type) for (const t of Co(r.geometry, 0)){
                const e = Uc(t, 16);
                P(t[0], new Ac(e.x, e.y, 0));
            }
            else if ("LineString" === r.type) for (const t of r.geometry)P(t, new Ac(t[0].x, t[0].y, 0));
            else if ("Point" === r.type) for (const t of r.geometry)for (const e of t)P([
                e
            ], new Ac(e.x, e.y, 0));
        }
        function Yc(t, e, r, n, i, s, o, l, u, c, h, p, f, d, y) {
            const m = function(t, e, r, n, i, s, o, l) {
                const u = n.layout.get("text-rotate").evaluate(s, {}) * Math.PI / 180, c = [];
                for (const t of e.positionedLines)for (const n of t.positionedGlyphs){
                    if (!n.rect) continue;
                    const s = n.rect || {};
                    let h = su + 1, p = !0, f = 1, d = 0;
                    const y = (i || l) && n.vertical, m = n.metrics.advance * n.scale / 2;
                    if (l && e.verticalizable && (d = t.lineOffset / 2 - (n.imageName ? -(Vl - n.metrics.width * n.scale) / 2 : (n.scale - 1) * Vl)), n.imageName) {
                        const t = o[n.imageName];
                        p = t.sdf, f = t.pixelRatio, h = lu / f;
                    }
                    const g = i ? [
                        n.x + m,
                        n.y
                    ] : [
                        0,
                        0
                    ];
                    let x = i ? [
                        0,
                        0
                    ] : [
                        n.x + m + r[0],
                        n.y + r[1] - d
                    ], v = [
                        0,
                        0
                    ];
                    y && (v = x, x = [
                        0,
                        0
                    ]);
                    const b = n.metrics.isDoubleResolution ? 2 : 1, w = (n.metrics.left - h) * n.scale - m + x[0], _ = (-n.metrics.top - h) * n.scale + x[1], A = w + s.w / b * n.scale / f, S = _ + s.h / b * n.scale / f, k = new a(w, _), I = new a(A, _), z = new a(w, S), M = new a(A, S);
                    if (y) {
                        const t = new a(-m, m - pu), e = -Math.PI / 2, r = Vl / 2 - m, i = new a(5 - pu - r, -(n.imageName ? r : 0)), s = new a(...v);
                        k._rotateAround(e, t)._add(i)._add(s), I._rotateAround(e, t)._add(i)._add(s), z._rotateAround(e, t)._add(i)._add(s), M._rotateAround(e, t)._add(i)._add(s);
                    }
                    if (u) {
                        const t = Math.sin(u), e = Math.cos(u), r = [
                            e,
                            -t,
                            t,
                            e
                        ];
                        k._matMult(r), I._matMult(r), z._matMult(r), M._matMult(r);
                    }
                    const C = new a(0, 0), B = new a(0, 0);
                    c.push({
                        tl: k,
                        tr: I,
                        bl: z,
                        br: M,
                        tex: s,
                        writingMode: e.writingMode,
                        glyphOffset: g,
                        sectionIndex: n.sectionIndex,
                        isSDF: p,
                        pixelOffsetTL: C,
                        pixelOffsetBR: B,
                        minFontScaleX: 0,
                        minFontScaleY: 0
                    });
                }
                return c;
            }(0, r, l, i, s, o, n, t.allowVerticalPlacement), g = t.textSizeData;
            let x = null;
            "source" === g.kind ? (x = [
                Cu * i.layout.get("text-size").evaluate(o, {})
            ], x[0] > Bu && A(`${t.layerIds[0]}: Value for "text-size" is >= ${Mu}. Reduce your "text-size".`)) : "composite" === g.kind && (x = [
                Cu * d.compositeTextSizes[0].evaluate(o, {}, y),
                Cu * d.compositeTextSizes[1].evaluate(o, {}, y)
            ], (x[0] > Bu || x[1] > Bu) && A(`${t.layerIds[0]}: Value for "text-size" is >= ${Mu}. Reduce your "text-size".`)), t.addSymbols(t.text, m, x, l, s, o, c, e, u.lineStartIndex, u.lineLength, f, y);
            for (const e of h)p[e] = t.text.placedSymbolArray.length - 1;
            return 4 * m.length;
        }
        function Hc(t) {
            for(const e in t)return t[e];
            return null;
        }
        function Wc(t, e, r, n) {
            const i = t.compareText;
            if (e in i) {
                const t = i[e];
                for(let e = t.length - 1; e >= 0; e--)if (n.dist(t[e]) < r) return !0;
            } else i[e] = [];
            return i[e].push(n), !1;
        }
        const Qc = [
            Int8Array,
            Uint8Array,
            Uint8ClampedArray,
            Int16Array,
            Uint16Array,
            Int32Array,
            Uint32Array,
            Float32Array,
            Float64Array
        ];
        class th {
            static from(t) {
                if (!(t instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
                const [e, r] = new Uint8Array(t, 0, 2);
                if (219 !== e) throw new Error("Data does not appear to be in a KDBush format.");
                const n = r >> 4;
                if (1 !== n) throw new Error(`Got v${n} data when expected v1.`);
                const i = Qc[15 & r];
                if (!i) throw new Error("Unrecognized array type.");
                const [a] = new Uint16Array(t, 2, 1), [s] = new Uint32Array(t, 4, 1);
                return new th(s, a, i, t);
            }
            constructor(t, e = 64, r = Float64Array, n){
                if (isNaN(t) || t < 0) throw new Error(`Unpexpected numItems value: ${t}.`);
                this.numItems = +t, this.nodeSize = Math.min(Math.max(+e, 2), 65535), this.ArrayType = r, this.IndexArrayType = t < 65536 ? Uint16Array : Uint32Array;
                const i = Qc.indexOf(this.ArrayType), a = 2 * t * this.ArrayType.BYTES_PER_ELEMENT, s = t * this.IndexArrayType.BYTES_PER_ELEMENT, o = (8 - s % 8) % 8;
                if (i < 0) throw new Error(`Unexpected typed array class: ${r}.`);
                n && n instanceof ArrayBuffer ? (this.data = n, this.ids = new this.IndexArrayType(this.data, 8, t), this.coords = new this.ArrayType(this.data, 8 + s + o, 2 * t), this._pos = 2 * t, this._finished = !0) : (this.data = new ArrayBuffer(8 + a + s + o), this.ids = new this.IndexArrayType(this.data, 8, t), this.coords = new this.ArrayType(this.data, 8 + s + o, 2 * t), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([
                    219,
                    16 + i
                ]), new Uint16Array(this.data, 2, 1)[0] = e, new Uint32Array(this.data, 4, 1)[0] = t);
            }
            add(t, e) {
                const r = this._pos >> 1;
                return this.ids[r] = r, this.coords[this._pos++] = t, this.coords[this._pos++] = e, r;
            }
            finish() {
                const t = this._pos >> 1;
                if (t !== this.numItems) throw new Error(`Added ${t} items when expected ${this.numItems}.`);
                return eh(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
            }
            range(t, e, r, n) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: i, coords: a, nodeSize: s } = this, o = [
                    0,
                    i.length - 1,
                    0
                ], l = [];
                for(; o.length;){
                    const u = o.pop() || 0, c = o.pop() || 0, h = o.pop() || 0;
                    if (c - h <= s) {
                        for(let s = h; s <= c; s++){
                            const o = a[2 * s], u = a[2 * s + 1];
                            o >= t && o <= r && u >= e && u <= n && l.push(i[s]);
                        }
                        continue;
                    }
                    const p = h + c >> 1, f = a[2 * p], d = a[2 * p + 1];
                    f >= t && f <= r && d >= e && d <= n && l.push(i[p]), (0 === u ? t <= f : e <= d) && (o.push(h), o.push(p - 1), o.push(1 - u)), (0 === u ? r >= f : n >= d) && (o.push(p + 1), o.push(c), o.push(1 - u));
                }
                return l;
            }
            within(t, e, r) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: n, coords: i, nodeSize: a } = this, s = [
                    0,
                    n.length - 1,
                    0
                ], o = [], l = r * r;
                for(; s.length;){
                    const u = s.pop() || 0, c = s.pop() || 0, h = s.pop() || 0;
                    if (c - h <= a) {
                        for(let r = h; r <= c; r++)ah(i[2 * r], i[2 * r + 1], t, e) <= l && o.push(n[r]);
                        continue;
                    }
                    const p = h + c >> 1, f = i[2 * p], d = i[2 * p + 1];
                    ah(f, d, t, e) <= l && o.push(n[p]), (0 === u ? t - r <= f : e - r <= d) && (s.push(h), s.push(p - 1), s.push(1 - u)), (0 === u ? t + r >= f : e + r >= d) && (s.push(p + 1), s.push(c), s.push(1 - u));
                }
                return o;
            }
        }
        function eh(t, e, r, n, i, a) {
            if (i - n <= r) return;
            const s = n + i >> 1;
            rh(t, e, s, n, i, a), eh(t, e, r, n, s - 1, 1 - a), eh(t, e, r, s + 1, i, 1 - a);
        }
        function rh(t, e, r, n, i, a) {
            for(; i > n;){
                if (i - n > 600) {
                    const s = i - n + 1, o = r - n + 1, l = Math.log(s), u = .5 * Math.exp(2 * l / 3), c = .5 * Math.sqrt(l * u * (s - u) / s) * (o - s / 2 < 0 ? -1 : 1);
                    rh(t, e, r, Math.max(n, Math.floor(r - o * u / s + c)), Math.min(i, Math.floor(r + (s - o) * u / s + c)), a);
                }
                const s = e[2 * r + a];
                let o = n, l = i;
                for(nh(t, e, n, r), e[2 * i + a] > s && nh(t, e, n, i); o < l;){
                    for(nh(t, e, o, l), o++, l--; e[2 * o + a] < s;)o++;
                    for(; e[2 * l + a] > s;)l--;
                }
                e[2 * n + a] === s ? nh(t, e, n, l) : (l++, nh(t, e, l, i)), l <= r && (n = l + 1), r <= l && (i = l - 1);
            }
        }
        function nh(t, e, r, n) {
            ih(t, r, n), ih(e, 2 * r, 2 * n), ih(e, 2 * r + 1, 2 * n + 1);
        }
        function ih(t, e, r) {
            const n = t[e];
            t[e] = t[r], t[r] = n;
        }
        function ah(t, e, r, n) {
            const i = t - r, a = e - n;
            return i * i + a * a;
        }
        var sh;
        t.bh = void 0, (sh = t.bh || (t.bh = {})).create = "create", sh.load = "load", sh.fullLoad = "fullLoad";
        let oh = null, lh = [];
        const uh = 1e3 / 60, ch = "loadTime", hh = "fullLoadTime", ph = {
            mark (t) {
                performance.mark(t);
            },
            frame (t) {
                const e = t;
                null != oh && lh.push(e - oh), oh = e;
            },
            clearMetrics () {
                oh = null, lh = [], performance.clearMeasures(ch), performance.clearMeasures(hh);
                for(const e in t.bh)performance.clearMarks(t.bh[e]);
            },
            getPerformanceMetrics () {
                performance.measure(ch, t.bh.create, t.bh.load), performance.measure(hh, t.bh.create, t.bh.fullLoad);
                const e = performance.getEntriesByName(ch)[0].duration, r = performance.getEntriesByName(hh)[0].duration, n = lh.length, i = 1 / (lh.reduce((t, e)=>t + e, 0) / n / 1e3), a = lh.filter((t)=>t > uh).reduce((t, e)=>t + (e - uh) / uh, 0);
                return {
                    loadTime: e,
                    fullLoadTime: r,
                    fps: i,
                    percentDroppedFrames: a / (n + a) * 100,
                    totalFrames: n
                };
            }
        };
        t.$ = function(t, e, r) {
            var n, i, a, s, o, l, u, c, h, p, f, d, y = r[0], m = r[1], g = r[2];
            return e === t ? (t[12] = e[0] * y + e[4] * m + e[8] * g + e[12], t[13] = e[1] * y + e[5] * m + e[9] * g + e[13], t[14] = e[2] * y + e[6] * m + e[10] * g + e[14], t[15] = e[3] * y + e[7] * m + e[11] * g + e[15]) : (i = e[1], a = e[2], s = e[3], o = e[4], l = e[5], u = e[6], c = e[7], h = e[8], p = e[9], f = e[10], d = e[11], t[0] = n = e[0], t[1] = i, t[2] = a, t[3] = s, t[4] = o, t[5] = l, t[6] = u, t[7] = c, t[8] = h, t[9] = p, t[10] = f, t[11] = d, t[12] = n * y + o * m + h * g + e[12], t[13] = i * y + l * m + p * g + e[13], t[14] = a * y + u * m + f * g + e[14], t[15] = s * y + c * m + d * g + e[15]), t;
        }, t.A = zs, t.B = Ze, t.C = class {
            constructor(t, e, r){
                this.receive = (t)=>{
                    const e = t.data, r = e.id;
                    if (r && (!e.targetMapId || this.mapId === e.targetMapId)) {
                        if ("<cancel>" === e.type) {
                            delete this.tasks[r];
                            const t = this.cancelCallbacks[r];
                            delete this.cancelCallbacks[r], t && t();
                        } else I() || e.mustQueue ? (this.tasks[r] = e, this.taskQueue.push(r), this.invoker.trigger()) : this.processTask(r, e);
                    }
                }, this.process = ()=>{
                    if (!this.taskQueue.length) return;
                    const t = this.taskQueue.shift(), e = this.tasks[t];
                    delete this.tasks[t], this.taskQueue.length && this.invoker.trigger(), e && this.processTask(t, e);
                }, this.target = t, this.parent = e, this.mapId = r, this.callbacks = {}, this.tasks = {}, this.taskQueue = [], this.cancelCallbacks = {}, this.invoker = new Qu(this.process), this.target.addEventListener("message", this.receive, !1), this.globalScope = I() ? t : window;
            }
            send(t, e, r, n, i = !1) {
                const a = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
                r && (this.callbacks[a] = r);
                const s = [], o = {
                    id: a,
                    type: t,
                    hasCallback: !!r,
                    targetMapId: n,
                    mustQueue: i,
                    sourceMapId: this.mapId,
                    data: Dn(e, s)
                };
                return this.target.postMessage(o, {
                    transfer: s
                }), {
                    cancel: ()=>{
                        r && delete this.callbacks[a], this.target.postMessage({
                            id: a,
                            type: "<cancel>",
                            targetMapId: n,
                            sourceMapId: this.mapId
                        });
                    }
                };
            }
            processTask(t, e) {
                if ("<response>" === e.type) {
                    const r = this.callbacks[t];
                    delete this.callbacks[t], r && (e.error ? r(On(e.error)) : r(null, On(e.data)));
                } else {
                    let r = !1;
                    const n = [], i = e.hasCallback ? (e, i)=>{
                        r = !0, delete this.cancelCallbacks[t];
                        const a = {
                            id: t,
                            type: "<response>",
                            sourceMapId: this.mapId,
                            error: e ? Dn(e) : null,
                            data: Dn(i, n)
                        };
                        this.target.postMessage(a, {
                            transfer: n
                        });
                    } : (t)=>{
                        r = !0;
                    };
                    let a = null;
                    const s = On(e.data);
                    if (this.parent[e.type]) a = this.parent[e.type](e.sourceMapId, s, i);
                    else if ("getWorkerSource" in this.parent) {
                        const t = e.type.split(".");
                        a = this.parent.getWorkerSource(e.sourceMapId, t[0], s.source)[t[1]](s, i);
                    } else i(new Error(`Could not find function ${e.type}`));
                    !r && a && a.cancel && (this.cancelCallbacks[t] = a.cancel);
                }
            }
            remove() {
                this.invoker.remove(), this.target.removeEventListener("message", this.receive, !1);
            }
        }, t.D = gi, t.E = J, t.F = function(t, e) {
            const r = {};
            for(let n = 0; n < e.length; n++){
                const i = e[n];
                i in t && (r[i] = t[i]);
            }
            return r;
        }, t.G = ic, t.H = ac, t.I = uu, t.J = h, t.K = p, t.L = ec, t.M = B, t.N = rs, t.O = fc, t.P = a, t.Q = Mi, t.R = qs, t.S = za, t.T = hi, t.U = uc, t.V = class extends Vi {
        }, t.W = hc, t.X = function(t, e) {
            const r = window.document.createElement("video");
            r.muted = !0, r.onloadstart = function() {
                e(null, r);
            };
            for(let e = 0; e < t.length; e++){
                const n = window.document.createElement("source");
                j(t[e]) || (r.crossOrigin = "Anonymous"), n.src = t[e], r.appendChild(n);
            }
            return {
                cancel: ()=>{}
            };
        }, t.Y = ot, t.Z = function() {
            var t = new zs(16);
            return zs != Float32Array && (t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0), t[0] = 1, t[5] = 1, t[10] = 1, t[15] = 1, t;
        }, t._ = e, t.a = M, t.a$ = class extends Hi {
        }, t.a0 = function(t, e, r) {
            var n = r[0], i = r[1], a = r[2];
            return t[0] = e[0] * n, t[1] = e[1] * n, t[2] = e[2] * n, t[3] = e[3] * n, t[4] = e[4] * i, t[5] = e[5] * i, t[6] = e[6] * i, t[7] = e[7] * i, t[8] = e[8] * a, t[9] = e[9] * a, t[10] = e[10] * a, t[11] = e[11] * a, t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t;
        }, t.a1 = Cs, t.a2 = function() {
            return x++;
        }, t.a3 = ta, t.a4 = Uu, t.a5 = function() {
            oi.isLoading() || oi.isLoaded() || "deferred" !== ai() || si();
        }, t.a6 = Nr, t.a7 = ss, t.a8 = li, t.a9 = gc, t.aA = ri, t.aB = function(t) {
            t = t.slice();
            const e = Object.create(null);
            for(let r = 0; r < t.length; r++)e[t[r].id] = t[r];
            for(let r = 0; r < t.length; r++)"ref" in t[r] && (t[r] = H(t[r], e[t[r].ref]));
            return t;
        }, t.aC = function(t) {
            if ("custom" === t.type) return new Wu(t);
            switch(t.type){
                case "background":
                    return new Ju(t);
                case "circle":
                    return new Es(t);
                case "fill":
                    return new Lo(t);
                case "fill-extrusion":
                    return new ol(t);
                case "heatmap":
                    return new Ns(t);
                case "hillshade":
                    return new Gs(t);
                case "line":
                    return new Al(t);
                case "raster":
                    return new Hu(t);
                case "symbol":
                    return new Zu(t);
            }
        }, t.aD = w, t.aE = function(t, e) {
            if (!t) return [
                {
                    command: Q.setStyle,
                    args: [
                        e
                    ]
                }
            ];
            let r = [];
            try {
                if (!W(t.version, e.version)) return [
                    {
                        command: Q.setStyle,
                        args: [
                            e
                        ]
                    }
                ];
                W(t.center, e.center) || r.push({
                    command: Q.setCenter,
                    args: [
                        e.center
                    ]
                }), W(t.zoom, e.zoom) || r.push({
                    command: Q.setZoom,
                    args: [
                        e.zoom
                    ]
                }), W(t.bearing, e.bearing) || r.push({
                    command: Q.setBearing,
                    args: [
                        e.bearing
                    ]
                }), W(t.pitch, e.pitch) || r.push({
                    command: Q.setPitch,
                    args: [
                        e.pitch
                    ]
                }), W(t.sprite, e.sprite) || r.push({
                    command: Q.setSprite,
                    args: [
                        e.sprite
                    ]
                }), W(t.glyphs, e.glyphs) || r.push({
                    command: Q.setGlyphs,
                    args: [
                        e.glyphs
                    ]
                }), W(t.transition, e.transition) || r.push({
                    command: Q.setTransition,
                    args: [
                        e.transition
                    ]
                }), W(t.light, e.light) || r.push({
                    command: Q.setLight,
                    args: [
                        e.light
                    ]
                });
                const n = {}, i = [];
                !function(t, e, r, n) {
                    let i;
                    for(i in e = e || {}, t = t || {})Object.prototype.hasOwnProperty.call(t, i) && (Object.prototype.hasOwnProperty.call(e, i) || et(i, r, n));
                    for(i in e)Object.prototype.hasOwnProperty.call(e, i) && (Object.prototype.hasOwnProperty.call(t, i) ? W(t[i], e[i]) || ("geojson" === t[i].type && "geojson" === e[i].type && nt(t, e, i) ? r.push({
                        command: Q.setGeoJSONSourceData,
                        args: [
                            i,
                            e[i].data
                        ]
                    }) : rt(i, e, r, n)) : tt(i, e, r));
                }(t.sources, e.sources, i, n);
                const a = [];
                t.layers && t.layers.forEach((t)=>{
                    n[t.source] ? r.push({
                        command: Q.removeLayer,
                        args: [
                            t.id
                        ]
                    }) : a.push(t);
                }), r = r.concat(i), function(t, e, r) {
                    e = e || [];
                    const n = (t = t || []).map(at), i = e.map(at), a = t.reduce(st, {}), s = e.reduce(st, {}), o = n.slice(), l = Object.create(null);
                    let u, c, h, p, f, d, y;
                    for(u = 0, c = 0; u < n.length; u++)h = n[u], Object.prototype.hasOwnProperty.call(s, h) ? c++ : (r.push({
                        command: Q.removeLayer,
                        args: [
                            h
                        ]
                    }), o.splice(o.indexOf(h, c), 1));
                    for(u = 0, c = 0; u < i.length; u++)h = i[i.length - 1 - u], o[o.length - 1 - u] !== h && (Object.prototype.hasOwnProperty.call(a, h) ? (r.push({
                        command: Q.removeLayer,
                        args: [
                            h
                        ]
                    }), o.splice(o.lastIndexOf(h, o.length - c), 1)) : c++, d = o[o.length - u], r.push({
                        command: Q.addLayer,
                        args: [
                            s[h],
                            d
                        ]
                    }), o.splice(o.length - u, 0, h), l[h] = !0);
                    for(u = 0; u < i.length; u++)if (h = i[u], p = a[h], f = s[h], !l[h] && !W(p, f)) {
                        if (W(p.source, f.source) && W(p["source-layer"], f["source-layer"]) && W(p.type, f.type)) {
                            for(y in it(p.layout, f.layout, r, h, null, Q.setLayoutProperty), it(p.paint, f.paint, r, h, null, Q.setPaintProperty), W(p.filter, f.filter) || r.push({
                                command: Q.setFilter,
                                args: [
                                    h,
                                    f.filter
                                ]
                            }), W(p.minzoom, f.minzoom) && W(p.maxzoom, f.maxzoom) || r.push({
                                command: Q.setLayerZoomRange,
                                args: [
                                    h,
                                    f.minzoom,
                                    f.maxzoom
                                ]
                            }), p)Object.prototype.hasOwnProperty.call(p, y) && "layout" !== y && "paint" !== y && "filter" !== y && "metadata" !== y && "minzoom" !== y && "maxzoom" !== y && (0 === y.indexOf("paint.") ? it(p[y], f[y], r, h, y.slice(6), Q.setPaintProperty) : W(p[y], f[y]) || r.push({
                                command: Q.setLayerProperty,
                                args: [
                                    h,
                                    y,
                                    f[y]
                                ]
                            }));
                            for(y in f)Object.prototype.hasOwnProperty.call(f, y) && !Object.prototype.hasOwnProperty.call(p, y) && "layout" !== y && "paint" !== y && "filter" !== y && "metadata" !== y && "minzoom" !== y && "maxzoom" !== y && (0 === y.indexOf("paint.") ? it(p[y], f[y], r, h, y.slice(6), Q.setPaintProperty) : W(p[y], f[y]) || r.push({
                                command: Q.setLayerProperty,
                                args: [
                                    h,
                                    y,
                                    f[y]
                                ]
                            }));
                        } else r.push({
                            command: Q.removeLayer,
                            args: [
                                h
                            ]
                        }), d = o[o.lastIndexOf(h) + 1], r.push({
                            command: Q.addLayer,
                            args: [
                                f,
                                d
                            ]
                        });
                    }
                }(a, e.layers, r);
            } catch (t) {
                console.warn("Unable to compute style diff:", t), r = [
                    {
                        command: Q.setStyle,
                        args: [
                            e
                        ]
                    }
                ];
            }
            return r;
        }, t.aF = function(t) {
            const e = [], r = t.id;
            return void 0 === r && e.push({
                message: `layers.${r}: missing required property "id"`
            }), void 0 === t.render && e.push({
                message: `layers.${r}: missing required method "render"`
            }), t.renderingMode && "2d" !== t.renderingMode && "3d" !== t.renderingMode && e.push({
                message: `layers.${r}: property "renderingMode" must be either "2d" or "3d"`
            }), e;
        }, t.aG = function t(e, r) {
            if (Array.isArray(e)) {
                if (!Array.isArray(r) || e.length !== r.length) return !1;
                for(let n = 0; n < e.length; n++)if (!t(e[n], r[n])) return !1;
                return !0;
            }
            if ("object" == typeof e && null !== e && null !== r) {
                if ("object" != typeof r) return !1;
                if (Object.keys(e).length !== Object.keys(r).length) return !1;
                for(const n in e)if (!t(e[n], r[n])) return !1;
                return !0;
            }
            return e === r;
        }, t.aH = v, t.aI = b, t.aJ = ii, t.aK = function(t) {
            return t({
                pluginStatus: ti,
                pluginURL: ei
            }), ii.on("pluginStateChange", t), t;
        }, t.aL = class extends Ra {
            constructor(t, e){
                super(t, e), this.current = 0;
            }
            set(t) {
                this.current !== t && (this.current = t, this.gl.uniform1i(this.location, t));
            }
        }, t.aM = qa, t.aN = class extends Ra {
            constructor(t, e){
                super(t, e), this.current = Za;
            }
            set(t) {
                if (t[12] !== this.current[12] || t[0] !== this.current[0]) return this.current = t, void this.gl.uniformMatrix4fv(this.location, !1, t);
                for(let e = 1; e < 16; e++)if (t[e] !== this.current[e]) {
                    this.current = t, this.gl.uniformMatrix4fv(this.location, !1, t);
                    break;
                }
            }
        }, t.aO = ja, t.aP = class extends Ra {
            constructor(t, e){
                super(t, e), this.current = [
                    0,
                    0,
                    0
                ];
            }
            set(t) {
                t[0] === this.current[0] && t[1] === this.current[1] && t[2] === this.current[2] || (this.current = t, this.gl.uniform3f(this.location, t[0], t[1], t[2]));
            }
        }, t.aQ = class extends Ra {
            constructor(t, e){
                super(t, e), this.current = [
                    0,
                    0
                ];
            }
            set(t) {
                t[0] === this.current[0] && t[1] === this.current[1] || (this.current = t, this.gl.uniform2f(this.location, t[0], t[1]));
            }
        }, t.aR = Na, t.aS = function(t, e, r, n, i, a, s) {
            var o = 1 / (e - r), l = 1 / (n - i), u = 1 / (a - s);
            return t[0] = -2 * o, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = -2 * l, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 2 * u, t[11] = 0, t[12] = (e + r) * o, t[13] = (i + n) * l, t[14] = (s + a) * u, t[15] = 1, t;
        }, t.aT = Yt, t.aU = Ps, t.aV = class extends qi {
        }, t.aW = Cl, t.aX = class extends Ni {
        }, t.aY = function(t) {
            return t <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(t) / Math.LN2));
        }, t.aZ = js, t.a_ = ha, t.aa = function(t) {
            const e = {};
            if (t.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (t, r, n, i)=>{
                const a = n || i;
                return e[r] = !a || a.toLowerCase(), "";
            }), e["max-age"]) {
                const t = parseInt(e["max-age"], 10);
                isNaN(t) ? delete e["max-age"] : e["max-age"] = t;
            }
            return e;
        }, t.ab = function(t, e) {
            const r = [];
            for(const n in t)n in e || r.push(n);
            return r;
        }, t.ac = function(t) {
            if (null == z) {
                const e = t.navigator ? t.navigator.userAgent : null;
                z = !!t.safari || !(!e || !(/\b(iPad|iPhone|iPod)\b/.test(e) || e.match("Safari") && !e.match("Chrome")));
            }
            return z;
        }, t.ad = y, t.ae = function(t, e, r) {
            var n = Math.sin(r), i = Math.cos(r), a = e[0], s = e[1], o = e[2], l = e[3], u = e[4], c = e[5], h = e[6], p = e[7];
            return e !== t && (t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t[0] = a * i + u * n, t[1] = s * i + c * n, t[2] = o * i + h * n, t[3] = l * i + p * n, t[4] = u * i - a * n, t[5] = c * i - s * n, t[6] = h * i - o * n, t[7] = p * i - l * n, t;
        }, t.af = function(t) {
            var e = new zs(16);
            return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15], e;
        }, t.ag = Vs, t.ah = function(t, e) {
            let r = 0, n = 0;
            if ("constant" === t.kind) n = t.layoutSize;
            else if ("source" !== t.kind) {
                const { interpolationType: i, minZoom: a, maxZoom: s } = t, o = i ? y(Ke.interpolationFactor(i, e, a, s), 0, 1) : 0;
                "camera" === t.kind ? n = Ze.number(t.minSize, t.maxSize, o) : r = o;
            }
            return {
                uSizeT: r,
                uSize: n
            };
        }, t.aj = function(t, { uSize: e, uSizeT: r }, { lowerSize: n, upperSize: i }) {
            return "source" === t.kind ? n / Cu : "composite" === t.kind ? Ze.number(n / Cu, i / Cu, r) : e;
        }, t.ak = $u, t.al = function(t, e, r, n) {
            const i = e.y - t.y, s = e.x - t.x, o = n.y - r.y, l = n.x - r.x, u = o * s - l * i;
            if (0 === u) return null;
            const c = (l * (t.y - r.y) - o * (t.x - r.x)) / u;
            return new a(t.x + c * s, t.y + c * i);
        }, t.am = _c, t.an = us, t.ao = Ms, t.ap = Vl, t.ar = Vu, t.as = function(t, e) {
            var r = e[0], n = e[1], i = e[2], a = e[3], s = e[4], o = e[5], l = e[6], u = e[7], c = e[8], h = e[9], p = e[10], f = e[11], d = e[12], y = e[13], m = e[14], g = e[15], x = r * o - n * s, v = r * l - i * s, b = r * u - a * s, w = n * l - i * o, _ = n * u - a * o, A = i * u - a * l, S = c * y - h * d, k = c * m - p * d, I = c * g - f * d, z = h * m - p * y, M = h * g - f * y, C = p * g - f * m, B = x * C - v * M + b * z + w * I - _ * k + A * S;
            return B ? (t[0] = (o * C - l * M + u * z) * (B = 1 / B), t[1] = (i * M - n * C - a * z) * B, t[2] = (y * A - m * _ + g * w) * B, t[3] = (p * _ - h * A - f * w) * B, t[4] = (l * I - s * C - u * k) * B, t[5] = (r * C - i * I + a * k) * B, t[6] = (m * b - d * A - g * v) * B, t[7] = (c * A - p * b + f * v) * B, t[8] = (s * M - o * I + u * S) * B, t[9] = (n * I - r * M - a * S) * B, t[10] = (d * _ - y * b + g * x) * B, t[11] = (h * b - c * _ - f * x) * B, t[12] = (o * k - s * z - l * S) * B, t[13] = (r * z - n * k + i * S) * B, t[14] = (y * v - d * w - m * x) * B, t[15] = (c * w - h * v + p * x) * B, t) : null;
        }, t.at = Jc, t.au = Su, t.av = th, t.aw = function() {
            const t = {}, e = X.$version;
            for(const r in X.$root){
                const n = X.$root[r];
                if (n.required) {
                    let i = null;
                    i = "version" === r ? e : "array" === n.type ? [] : {}, null != i && (t[r] = i);
                }
            }
            return t;
        }, t.ax = Q, t.ay = Un, t.az = D, t.b = function(t, e) {
            const r = new Blob([
                new Uint8Array(t)
            ], {
                type: "image/png"
            });
            createImageBitmap(r).then((t)=>{
                e(null, t);
            }).catch((t)=>{
                e(new Error(`Could not load image because of ${t.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`));
            });
        }, t.b0 = Aa, t.b1 = function(t, e) {
            var r = t[0], n = t[1], i = t[2], a = t[3], s = t[4], o = t[5], l = t[6], u = t[7], c = t[8], h = t[9], p = t[10], f = t[11], d = t[12], y = t[13], m = t[14], g = t[15], x = e[0], v = e[1], b = e[2], w = e[3], _ = e[4], A = e[5], S = e[6], k = e[7], I = e[8], z = e[9], M = e[10], C = e[11], B = e[12], P = e[13], V = e[14], E = e[15];
            return Math.abs(r - x) <= Is * Math.max(1, Math.abs(r), Math.abs(x)) && Math.abs(n - v) <= Is * Math.max(1, Math.abs(n), Math.abs(v)) && Math.abs(i - b) <= Is * Math.max(1, Math.abs(i), Math.abs(b)) && Math.abs(a - w) <= Is * Math.max(1, Math.abs(a), Math.abs(w)) && Math.abs(s - _) <= Is * Math.max(1, Math.abs(s), Math.abs(_)) && Math.abs(o - A) <= Is * Math.max(1, Math.abs(o), Math.abs(A)) && Math.abs(l - S) <= Is * Math.max(1, Math.abs(l), Math.abs(S)) && Math.abs(u - k) <= Is * Math.max(1, Math.abs(u), Math.abs(k)) && Math.abs(c - I) <= Is * Math.max(1, Math.abs(c), Math.abs(I)) && Math.abs(h - z) <= Is * Math.max(1, Math.abs(h), Math.abs(z)) && Math.abs(p - M) <= Is * Math.max(1, Math.abs(p), Math.abs(M)) && Math.abs(f - C) <= Is * Math.max(1, Math.abs(f), Math.abs(C)) && Math.abs(d - B) <= Is * Math.max(1, Math.abs(d), Math.abs(B)) && Math.abs(y - P) <= Is * Math.max(1, Math.abs(y), Math.abs(P)) && Math.abs(m - V) <= Is * Math.max(1, Math.abs(m), Math.abs(V)) && Math.abs(g - E) <= Is * Math.max(1, Math.abs(g), Math.abs(E));
        }, t.b2 = function(t, e) {
            return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t;
        }, t.b3 = function(t, e, r) {
            return t[0] = e[0] * r[0], t[1] = e[1] * r[1], t[2] = e[2] * r[2], t[3] = e[3] * r[3], t;
        }, t.b4 = function(t, e) {
            return t[0] * e[0] + t[1] * e[1] + t[2] * e[2] + t[3] * e[3];
        }, t.b5 = m, t.b6 = pc, t.b7 = sc, t.b8 = function(t, e, r, n, i) {
            var a, s = 1 / Math.tan(e / 2);
            return t[0] = s / r, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = s, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[11] = -1, t[12] = 0, t[13] = 0, t[15] = 0, null != i && i !== 1 / 0 ? (t[10] = (i + n) * (a = 1 / (n - i)), t[14] = 2 * i * n * a) : (t[10] = -1, t[14] = -2 * n), t;
        }, t.b9 = function(t, e, r) {
            var n = Math.sin(r), i = Math.cos(r), a = e[4], s = e[5], o = e[6], l = e[7], u = e[8], c = e[9], h = e[10], p = e[11];
            return e !== t && (t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t[4] = a * i + u * n, t[5] = s * i + c * n, t[6] = o * i + h * n, t[7] = l * i + p * n, t[8] = u * i - a * n, t[9] = c * i - s * n, t[10] = h * i - o * n, t[11] = p * i - l * n, t;
        }, t.bA = n, t.bB = El, t.bC = $r, t.bD = oi, t.ba = f, t.bb = d, t.bc = function(t, e) {
            return t[0] = e[0], t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = e[1], t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = e[2], t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
        }, t.bd = class extends Pi {
        }, t.be = tc, t.bf = oc, t.bg = ph, t.bi = L, t.bj = function(t, e, r = !1) {
            if (ti === Yn || ti === Hn || ti === Wn) throw new Error("setRTLTextPlugin cannot be called multiple times.");
            ei = T.resolveURL(t), ti = Yn, Qn = e, ni(), r || si();
        }, t.bk = ai, t.bl = function(t, e) {
            const r = {};
            for(let n = 0; n < t.length; n++){
                const i = e && e[t[n].id] || Qr(t[n]);
                e && (e[t[n].id] = i);
                let a = r[i];
                a || (a = r[i] = []), a.push(t[n]);
            }
            const n = [];
            for(const t in r)n.push(r[t]);
            return n;
        }, t.bm = $n, t.bn = mc, t.bo = xc, t.bp = cu, t.bq = function(e) {
            e.bucket.createArrays(), e.bucket.tilePixelRatio = rs / (512 * e.bucket.overscaling), e.bucket.compareText = {}, e.bucket.iconsNeedLinear = !1;
            const r = e.bucket.layers[0], n = r.layout, i = r._unevaluatedLayout._values, a = {
                layoutIconSize: i["icon-size"].possiblyEvaluate(new li(e.bucket.zoom + 1), e.canonical),
                layoutTextSize: i["text-size"].possiblyEvaluate(new li(e.bucket.zoom + 1), e.canonical),
                textMaxSize: i["text-size"].possiblyEvaluate(new li(18))
            };
            if ("composite" === e.bucket.textSizeData.kind) {
                const { minZoom: t, maxZoom: r } = e.bucket.textSizeData;
                a.compositeTextSizes = [
                    i["text-size"].possiblyEvaluate(new li(t), e.canonical),
                    i["text-size"].possiblyEvaluate(new li(r), e.canonical)
                ];
            }
            if ("composite" === e.bucket.iconSizeData.kind) {
                const { minZoom: t, maxZoom: r } = e.bucket.iconSizeData;
                a.compositeIconSizes = [
                    i["icon-size"].possiblyEvaluate(new li(t), e.canonical),
                    i["icon-size"].possiblyEvaluate(new li(r), e.canonical)
                ];
            }
            const s = n.get("text-line-height") * Vl, o = "viewport" !== n.get("text-rotation-alignment") && "point" !== n.get("symbol-placement"), l = n.get("text-keep-upright"), u = n.get("text-size");
            for (const i of e.bucket.features){
                const c = n.get("text-font").evaluate(i, {}, e.canonical).join(","), h = u.evaluate(i, {}, e.canonical), p = a.layoutTextSize.evaluate(i, {}, e.canonical), f = a.layoutIconSize.evaluate(i, {}, e.canonical), d = {
                    horizontal: {},
                    vertical: void 0
                }, y = i.text;
                let m, g = [
                    0,
                    0
                ];
                if (y) {
                    const a = y.toString(), u = n.get("text-letter-spacing").evaluate(i, {}, e.canonical) * Vl, f = jn(a) ? u : 0, m = n.get("text-anchor").evaluate(i, {}, e.canonical), x = Gc(r, i, e.canonical);
                    if (!x) {
                        const t = n.get("text-radial-offset").evaluate(i, {}, e.canonical);
                        g = t ? Kc(m, [
                            t * Vl,
                            Zc
                        ]) : n.get("text-offset").evaluate(i, {}, e.canonical).map((t)=>t * Vl);
                    }
                    let v = o ? "center" : n.get("text-justify").evaluate(i, {}, e.canonical);
                    const b = n.get("symbol-placement"), w = "point" === b ? n.get("text-max-width").evaluate(i, {}, e.canonical) * Vl : 0, _ = ()=>{
                        e.bucket.allowVerticalPlacement && qn(a) && (d.vertical = yu(y, e.glyphMap, e.glyphPositions, e.imagePositions, c, w, s, m, "left", f, g, t.ai.vertical, !0, b, p, h));
                    };
                    if (!o && x) {
                        const r = new Set;
                        if ("auto" === v) for(let t = 0; t < x.values.length; t += 2)r.add(Jc(x.values[t]));
                        else r.add(v);
                        let n = !1;
                        for (const i of r)if (!d.horizontal[i]) {
                            if (n) d.horizontal[i] = d.horizontal[0];
                            else {
                                const r = yu(y, e.glyphMap, e.glyphPositions, e.imagePositions, c, w, s, "center", i, f, g, t.ai.horizontal, !1, b, p, h);
                                r && (d.horizontal[i] = r, n = 1 === r.positionedLines.length);
                            }
                        }
                        _();
                    } else {
                        "auto" === v && (v = Jc(m));
                        const r = yu(y, e.glyphMap, e.glyphPositions, e.imagePositions, c, w, s, m, v, f, g, t.ai.horizontal, !1, b, p, h);
                        r && (d.horizontal[v] = r), _(), qn(a) && o && l && (d.vertical = yu(y, e.glyphMap, e.glyphPositions, e.imagePositions, c, w, s, m, v, f, g, t.ai.vertical, !1, b, p, h));
                    }
                }
                let x = !1;
                if (i.icon && i.icon.name) {
                    const t = e.imageMap[i.icon.name];
                    t && (m = Iu(e.imagePositions[i.icon.name], n.get("icon-offset").evaluate(i, {}, e.canonical), n.get("icon-anchor").evaluate(i, {}, e.canonical)), x = !!t.sdf, void 0 === e.bucket.sdfIcons ? e.bucket.sdfIcons = x : e.bucket.sdfIcons !== x && A("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (t.pixelRatio !== e.bucket.pixelRatio || 0 !== n.get("icon-rotate").constantOr(1)) && (e.bucket.iconsNeedLinear = !0));
                }
                const v = Hc(d.horizontal) || d.vertical;
                e.bucket.iconsInText = !!v && v.iconsInText, (v || m) && Xc(e.bucket, i, d, m, e.imageMap, a, p, f, g, x, e.canonical);
            }
            e.showCollisionBoxes && e.bucket.generateCollisionDebugBuffers();
        }, t.br = gl, t.bs = Eo, t.bt = rl, t.bu = class {
            constructor(t){
                this._marks = {
                    start: [
                        t.url,
                        "start"
                    ].join("#"),
                    end: [
                        t.url,
                        "end"
                    ].join("#"),
                    measure: t.url.toString()
                }, performance.mark(this._marks.start);
            }
            finish() {
                performance.mark(this._marks.end);
                let t = performance.getEntriesByName(this._marks.measure);
                return 0 === t.length && (performance.measure(this._marks.measure, this._marks.start, this._marks.end), t = performance.getEntriesByName(this._marks.measure), performance.clearMarks(this._marks.start), performance.clearMarks(this._marks.end), performance.clearMeasures(this._marks.measure)), t;
            }
        }, t.bv = eu, t.bw = Ro, t.bx = function(t, r, n, i, a) {
            return e(this, void 0, void 0, function*() {
                if (p()) try {
                    return yield B(t, r, n, i, a);
                } catch (t) {}
                return function(t, e, r, n, i) {
                    const a = t.width, s = t.height;
                    P && V || (P = new OffscreenCanvas(a, s), V = P.getContext("2d", {
                        willReadFrequently: !0
                    })), P.width = a, P.height = s, V.drawImage(t, 0, 0, a, s);
                    const o = V.getImageData(e, r, n, i);
                    return V.clearRect(0, 0, a, s), o.data;
                }(t, r, n, i, a);
            });
        }, t.by = yc, t.bz = r, t.c = $, t.d = function(t, e) {
            const r = new Image;
            r.onload = ()=>{
                e(null, r), URL.revokeObjectURL(r.src), r.onload = null, window.requestAnimationFrame(()=>{
                    r.src = C;
                });
            }, r.onerror = ()=>e(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
            const n = new Blob([
                new Uint8Array(t)
            ], {
                type: "image/png"
            });
            r.src = t.byteLength ? URL.createObjectURL(n) : C;
        }, t.e = g, t.f = function(t, e) {
            return R(g(t, {
                type: "json"
            }), e);
        }, t.g = O, t.h = T, t.i = I, t.j = G, t.k = K, t.l = q, t.m = R, t.n = function(t) {
            return new eu(t).readFields(nu, []);
        }, t.o = function(t, e, r) {
            if (!t.length) return r(null, []);
            let n = t.length;
            const i = new Array(t.length);
            let a = null;
            t.forEach((t, s)=>{
                e(t, (t, e)=>{
                    t && (a = t), i[s] = e, 0 == --n && r(a, i);
                });
            });
        }, t.p = ou, t.q = Rs, t.r = _i, t.s = j, t.t = Bn, t.u = Rn, t.v = X, t.w = A, t.x = En, t.y = Cn, t.z = function([t, e, r]) {
            return e += 90, e *= Math.PI / 180, r *= Math.PI / 180, {
                x: t * Math.cos(e) * Math.sin(r),
                y: t * Math.sin(e) * Math.sin(r),
                z: t * Math.cos(r)
            };
        };
    });
    define([
        "./shared"
    ], function(e) {
        "use strict";
        class t {
            constructor(e){
                this.keyCache = {}, e && this.replace(e);
            }
            replace(e) {
                this._layerConfigs = {}, this._layers = {}, this.update(e, []);
            }
            update(t, i) {
                for (const i of t){
                    this._layerConfigs[i.id] = i;
                    const t = this._layers[i.id] = e.aC(i);
                    t._featureFilter = e.a6(t.filter), this.keyCache[i.id] && delete this.keyCache[i.id];
                }
                for (const e of i)delete this.keyCache[e], delete this._layerConfigs[e], delete this._layers[e];
                this.familiesBySource = {};
                const o = e.bl(Object.values(this._layerConfigs), this.keyCache);
                for (const e of o){
                    const t = e.map((e)=>this._layers[e.id]), i = t[0];
                    if ("none" === i.visibility) continue;
                    const o = i.source || "";
                    let r = this.familiesBySource[o];
                    r || (r = this.familiesBySource[o] = {});
                    const s = i.sourceLayer || "_geojsonTileLayer";
                    let n = r[s];
                    n || (n = r[s] = []), n.push(t);
                }
            }
        }
        class i {
            constructor(t){
                const i = {}, o = [];
                for(const e in t){
                    const r = t[e], s = i[e] = {};
                    for(const e in r){
                        const t = r[+e];
                        if (!t || 0 === t.bitmap.width || 0 === t.bitmap.height) continue;
                        const i = {
                            x: 0,
                            y: 0,
                            w: t.bitmap.width + 2,
                            h: t.bitmap.height + 2
                        };
                        o.push(i), s[e] = {
                            rect: i,
                            metrics: t.metrics
                        };
                    }
                }
                const { w: r, h: s } = e.p(o), n = new e.q({
                    width: r || 1,
                    height: s || 1
                });
                for(const o in t){
                    const r = t[o];
                    for(const t in r){
                        const s = r[+t];
                        if (!s || 0 === s.bitmap.width || 0 === s.bitmap.height) continue;
                        const a = i[o][t].rect;
                        e.q.copy(s.bitmap, n, {
                            x: 0,
                            y: 0
                        }, {
                            x: a.x + 1,
                            y: a.y + 1
                        }, s.bitmap);
                    }
                }
                this.image = n, this.positions = i;
            }
        }
        e.bm("GlyphAtlas", i);
        class o {
            constructor(t){
                this.tileID = new e.O(t.tileID.overscaledZ, t.tileID.wrap, t.tileID.canonical.z, t.tileID.canonical.x, t.tileID.canonical.y), this.uid = t.uid, this.zoom = t.zoom, this.pixelRatio = t.pixelRatio, this.tileSize = t.tileSize, this.source = t.source, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = t.showCollisionBoxes, this.collectResourceTiming = !!t.collectResourceTiming, this.returnDependencies = !!t.returnDependencies, this.promoteId = t.promoteId, this.inFlightDependencies = [], this.dependencySentinel = -1;
            }
            parse(t, o, s, n, a) {
                this.status = "parsing", this.data = t, this.collisionBoxArray = new e.a3;
                const l = new e.bn(Object.keys(t.layers).sort()), c = new e.bo(this.tileID, this.promoteId);
                c.bucketLayerIDs = [];
                const h = {}, u = {
                    featureIndex: c,
                    iconDependencies: {},
                    patternDependencies: {},
                    glyphDependencies: {},
                    availableImages: s
                }, d = o.familiesBySource[this.source];
                for(const i in d){
                    const o = t.layers[i];
                    if (!o) continue;
                    1 === o.version && e.w(`Vector tile source "${this.source}" layer "${i}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
                    const n = l.encode(i), a = [];
                    for(let e = 0; e < o.length; e++){
                        const t = o.feature(e), r = c.getId(t, i);
                        a.push({
                            feature: t,
                            id: r,
                            index: e,
                            sourceLayerIndex: n
                        });
                    }
                    for (const t of d[i]){
                        const i = t[0];
                        i.source !== this.source && e.w(`layer.source = ${i.source} does not equal this.source = ${this.source}`), i.minzoom && this.zoom < Math.floor(i.minzoom) || i.maxzoom && this.zoom >= i.maxzoom || "none" !== i.visibility && (r(t, this.zoom, s), (h[i.id] = i.createBucket({
                            index: c.bucketLayerIDs.length,
                            layers: t,
                            zoom: this.zoom,
                            pixelRatio: this.pixelRatio,
                            overscaling: this.overscaling,
                            collisionBoxArray: this.collisionBoxArray,
                            sourceLayerIndex: n,
                            sourceID: this.source
                        })).populate(a, u, this.tileID.canonical), c.bucketLayerIDs.push(t.map((e)=>e.id)));
                    }
                }
                let p, f, g, m;
                const y = e.aH(u.glyphDependencies, (e)=>Object.keys(e).map(Number));
                this.inFlightDependencies.forEach((e)=>null == e ? void 0 : e.cancel()), this.inFlightDependencies = [];
                const v = ++this.dependencySentinel;
                Object.keys(y).length ? this.inFlightDependencies.push(n.send("getGlyphs", {
                    uid: this.uid,
                    stacks: y,
                    source: this.source,
                    tileID: this.tileID,
                    type: "glyphs"
                }, (e, t)=>{
                    v === this.dependencySentinel && (p || (p = e, f = t, b.call(this)));
                })) : f = {};
                const w = Object.keys(u.iconDependencies);
                w.length ? this.inFlightDependencies.push(n.send("getImages", {
                    icons: w,
                    source: this.source,
                    tileID: this.tileID,
                    type: "icons"
                }, (e, t)=>{
                    v === this.dependencySentinel && (p || (p = e, g = t, b.call(this)));
                })) : g = {};
                const x = Object.keys(u.patternDependencies);
                function b() {
                    if (p) return a(p);
                    if (f && g && m) {
                        const t = new i(f), o = new e.bp(g, m);
                        for(const i in h){
                            const n = h[i];
                            n instanceof e.a4 ? (r(n.layers, this.zoom, s), e.bq({
                                bucket: n,
                                glyphMap: f,
                                glyphPositions: t.positions,
                                imageMap: g,
                                imagePositions: o.iconPositions,
                                showCollisionBoxes: this.showCollisionBoxes,
                                canonical: this.tileID.canonical
                            })) : n.hasPattern && (n instanceof e.br || n instanceof e.bs || n instanceof e.bt) && (r(n.layers, this.zoom, s), n.addFeatures(u, this.tileID.canonical, o.patternPositions));
                        }
                        this.status = "done", a(null, {
                            buckets: Object.values(h).filter((e)=>!e.isEmpty()),
                            featureIndex: c,
                            collisionBoxArray: this.collisionBoxArray,
                            glyphAtlasImage: t.image,
                            imageAtlas: o,
                            glyphMap: this.returnDependencies ? f : null,
                            iconMap: this.returnDependencies ? g : null,
                            glyphPositions: this.returnDependencies ? t.positions : null
                        });
                    }
                }
                x.length ? this.inFlightDependencies.push(n.send("getImages", {
                    icons: x,
                    source: this.source,
                    tileID: this.tileID,
                    type: "patterns"
                }, (e, t)=>{
                    v === this.dependencySentinel && (p || (p = e, m = t, b.call(this)));
                })) : m = {}, b.call(this);
            }
        }
        function r(t, i, o) {
            const r = new e.a8(i);
            for (const e of t)e.recalculate(r, o);
        }
        function s(t, i) {
            const o = e.l(t.request, (o, r, s, n)=>{
                if (o) i(o);
                else if (r) try {
                    const t = new e.bw.VectorTile(new e.bv(r));
                    i(null, {
                        vectorTile: t,
                        rawData: r,
                        cacheControl: s,
                        expires: n
                    });
                } catch (e) {
                    const o = new Uint8Array(r);
                    let s = `Unable to parse the tile at ${t.request.url}, `;
                    s += 31 === o[0] && 139 === o[1] ? "please make sure the data is not gzipped and that you have configured the relevant header in the server" : `got error: ${e.messge}`, i(new Error(s));
                }
            });
            return ()=>{
                o.cancel(), i();
            };
        }
        class n {
            constructor(e, t, i, o){
                this.actor = e, this.layerIndex = t, this.availableImages = i, this.loadVectorData = o || s, this.fetching = {}, this.loading = {}, this.loaded = {};
            }
            loadTile(t, i) {
                const r = t.uid;
                this.loading || (this.loading = {});
                const s = !!(t && t.request && t.request.collectResourceTiming) && new e.bu(t.request), n = this.loading[r] = new o(t);
                n.abort = this.loadVectorData(t, (t, o)=>{
                    if (delete this.loading[r], t || !o) return n.status = "done", this.loaded[r] = n, i(t);
                    const a = o.rawData, l = {};
                    o.expires && (l.expires = o.expires), o.cacheControl && (l.cacheControl = o.cacheControl);
                    const c = {};
                    if (s) {
                        const e = s.finish();
                        e && (c.resourceTiming = JSON.parse(JSON.stringify(e)));
                    }
                    n.vectorTile = o.vectorTile, n.parse(o.vectorTile, this.layerIndex, this.availableImages, this.actor, (t, o)=>{
                        if (delete this.fetching[r], t || !o) return i(t);
                        i(null, e.e({
                            rawTileData: a.slice(0)
                        }, o, l, c));
                    }), this.loaded = this.loaded || {}, this.loaded[r] = n, this.fetching[r] = {
                        rawTileData: a,
                        cacheControl: l,
                        resourceTiming: c
                    };
                });
            }
            reloadTile(t, i) {
                const o = this.loaded, r = t.uid;
                if (o && o[r]) {
                    const s = o[r];
                    s.showCollisionBoxes = t.showCollisionBoxes, "parsing" === s.status ? s.parse(s.vectorTile, this.layerIndex, this.availableImages, this.actor, (t, o)=>{
                        if (t || !o) return i(t, o);
                        let s;
                        if (this.fetching[r]) {
                            const { rawTileData: t, cacheControl: i, resourceTiming: n } = this.fetching[r];
                            delete this.fetching[r], s = e.e({
                                rawTileData: t.slice(0)
                            }, o, i, n);
                        } else s = o;
                        i(null, s);
                    }) : "done" === s.status && (s.vectorTile ? s.parse(s.vectorTile, this.layerIndex, this.availableImages, this.actor, i) : i());
                }
            }
            abortTile(e, t) {
                const i = this.loading, o = e.uid;
                i && i[o] && i[o].abort && (i[o].abort(), delete i[o]), t();
            }
            removeTile(e, t) {
                const i = this.loaded, o = e.uid;
                i && i[o] && delete i[o], t();
            }
        }
        class a {
            constructor(){
                this.loaded = {};
            }
            loadTile(t, i) {
                return e._(this, void 0, void 0, function*() {
                    const { uid: o, encoding: r, rawImageData: s, redFactor: n, greenFactor: a, blueFactor: l, baseShift: c } = t, h = s.width + 2, u = s.height + 2, d = e.a(s) ? new e.R({
                        width: h,
                        height: u
                    }, (yield e.bx(s, -1, -1, h, u))) : s, p = new e.by(o, d, r, n, a, l, c);
                    this.loaded = this.loaded || {}, this.loaded[o] = p, i(null, p);
                });
            }
            removeTile(e) {
                const t = this.loaded, i = e.uid;
                t && t[i] && delete t[i];
            }
        }
        function l(e, t) {
            if (0 !== e.length) {
                c(e[0], t);
                for(var i = 1; i < e.length; i++)c(e[i], !t);
            }
        }
        function c(e, t) {
            for(var i = 0, o = 0, r = 0, s = e.length, n = s - 1; r < s; n = r++){
                var a = (e[r][0] - e[n][0]) * (e[n][1] + e[r][1]), l = i + a;
                o += Math.abs(i) >= Math.abs(a) ? i - l + a : a - l + i, i = l;
            }
            i + o >= 0 != !!t && e.reverse();
        }
        var h = e.bz(function e(t, i) {
            var o, r = t && t.type;
            if ("FeatureCollection" === r) for(o = 0; o < t.features.length; o++)e(t.features[o], i);
            else if ("GeometryCollection" === r) for(o = 0; o < t.geometries.length; o++)e(t.geometries[o], i);
            else if ("Feature" === r) e(t.geometry, i);
            else if ("Polygon" === r) l(t.coordinates, i);
            else if ("MultiPolygon" === r) for(o = 0; o < t.coordinates.length; o++)l(t.coordinates[o], i);
            return t;
        });
        const u = e.bw.VectorTileFeature.prototype.toGeoJSON;
        var d = {
            exports: {}
        }, p = e.bA, f = e.bw.VectorTileFeature, g = m;
        function m(e, t) {
            this.options = t || {}, this.features = e, this.length = e.length;
        }
        function y(e, t) {
            this.id = "number" == typeof e.id ? e.id : void 0, this.type = e.type, this.rawGeometry = 1 === e.type ? [
                e.geometry
            ] : e.geometry, this.properties = e.tags, this.extent = t || 4096;
        }
        m.prototype.feature = function(e) {
            return new y(this.features[e], this.options.extent);
        }, y.prototype.loadGeometry = function() {
            var e = this.rawGeometry;
            this.geometry = [];
            for(var t = 0; t < e.length; t++){
                for(var i = e[t], o = [], r = 0; r < i.length; r++)o.push(new p(i[r][0], i[r][1]));
                this.geometry.push(o);
            }
            return this.geometry;
        }, y.prototype.bbox = function() {
            this.geometry || this.loadGeometry();
            for(var e = this.geometry, t = 1 / 0, i = -1 / 0, o = 1 / 0, r = -1 / 0, s = 0; s < e.length; s++)for(var n = e[s], a = 0; a < n.length; a++){
                var l = n[a];
                t = Math.min(t, l.x), i = Math.max(i, l.x), o = Math.min(o, l.y), r = Math.max(r, l.y);
            }
            return [
                t,
                o,
                i,
                r
            ];
        }, y.prototype.toGeoJSON = f.prototype.toGeoJSON;
        var v = e.bB, w = g;
        function x(e) {
            var t = new v;
            return function(e, t) {
                for(var i in e.layers)t.writeMessage(3, b, e.layers[i]);
            }(e, t), t.finish();
        }
        function b(e, t) {
            var i;
            t.writeVarintField(15, e.version || 1), t.writeStringField(1, e.name || ""), t.writeVarintField(5, e.extent || 4096);
            var o = {
                keys: [],
                values: [],
                keycache: {},
                valuecache: {}
            };
            for(i = 0; i < e.length; i++)o.feature = e.feature(i), t.writeMessage(2, S, o);
            var r = o.keys;
            for(i = 0; i < r.length; i++)t.writeStringField(3, r[i]);
            var s = o.values;
            for(i = 0; i < s.length; i++)t.writeMessage(4, _, s[i]);
        }
        function S(e, t) {
            var i = e.feature;
            void 0 !== i.id && t.writeVarintField(1, i.id), t.writeMessage(2, M, e), t.writeVarintField(3, i.type), t.writeMessage(4, T, i);
        }
        function M(e, t) {
            var i = e.feature, o = e.keys, r = e.values, s = e.keycache, n = e.valuecache;
            for(var a in i.properties){
                var l = i.properties[a], c = s[a];
                if (null !== l) {
                    void 0 === c && (o.push(a), s[a] = c = o.length - 1), t.writeVarint(c);
                    var h = typeof l;
                    "string" !== h && "boolean" !== h && "number" !== h && (l = JSON.stringify(l));
                    var u = h + ":" + l, d = n[u];
                    void 0 === d && (r.push(l), n[u] = d = r.length - 1), t.writeVarint(d);
                }
            }
        }
        function I(e, t) {
            return (t << 3) + (7 & e);
        }
        function P(e) {
            return e << 1 ^ e >> 31;
        }
        function T(e, t) {
            for(var i = e.loadGeometry(), o = e.type, r = 0, s = 0, n = i.length, a = 0; a < n; a++){
                var l = i[a], c = 1;
                1 === o && (c = l.length), t.writeVarint(I(1, c));
                for(var h = 3 === o ? l.length - 1 : l.length, u = 0; u < h; u++){
                    1 === u && 1 !== o && t.writeVarint(I(2, h - 1));
                    var d = l[u].x - r, p = l[u].y - s;
                    t.writeVarint(P(d)), t.writeVarint(P(p)), r += d, s += p;
                }
                3 === o && t.writeVarint(I(7, 1));
            }
        }
        function _(e, t) {
            var i = typeof e;
            "string" === i ? t.writeStringField(1, e) : "boolean" === i ? t.writeBooleanField(7, e) : "number" === i && (e % 1 != 0 ? t.writeDoubleField(3, e) : e < 0 ? t.writeSVarintField(6, e) : t.writeVarintField(5, e));
        }
        d.exports = x, d.exports.fromVectorTileJs = x, d.exports.fromGeojsonVt = function(e, t) {
            t = t || {};
            var i = {};
            for(var o in e)i[o] = new w(e[o].features, t), i[o].name = o, i[o].version = t.version, i[o].extent = t.extent;
            return x({
                layers: i
            });
        }, d.exports.GeoJSONWrapper = w;
        var k = e.bz(d.exports);
        const D = {
            minZoom: 0,
            maxZoom: 16,
            minPoints: 2,
            radius: 40,
            extent: 512,
            nodeSize: 64,
            log: !1,
            generateId: !1,
            reduce: null,
            map: (e)=>e
        }, O = Math.fround || (C = new Float32Array(1), (e)=>(C[0] = +e, C[0]));
        var C;
        const L = 3, F = 5, z = 6;
        class N {
            constructor(e){
                this.options = Object.assign(Object.create(D), e), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
            }
            load(e) {
                const { log: t, minZoom: i, maxZoom: o } = this.options;
                t && console.time("total time");
                const r = `prepare ${e.length} points`;
                t && console.time(r), this.points = e;
                const s = [];
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    if (!i.geometry) continue;
                    const [o, r] = i.geometry.coordinates, n = O(Z(o)), a = O(G(r));
                    s.push(n, a, 1 / 0, t, -1, 1), this.options.reduce && s.push(0);
                }
                let n = this.trees[o + 1] = this._createTree(s);
                t && console.timeEnd(r);
                for(let e = o; e >= i; e--){
                    const i = +Date.now();
                    n = this.trees[e] = this._createTree(this._cluster(n, e)), t && console.log("z%d: %d clusters in %dms", e, n.numItems, +Date.now() - i);
                }
                return t && console.timeEnd("total time"), this;
            }
            getClusters(e, t) {
                let i = ((e[0] + 180) % 360 + 360) % 360 - 180;
                const o = Math.max(-90, Math.min(90, e[1]));
                let r = 180 === e[2] ? 180 : ((e[2] + 180) % 360 + 360) % 360 - 180;
                const s = Math.max(-90, Math.min(90, e[3]));
                if (e[2] - e[0] >= 360) i = -180, r = 180;
                else if (i > r) {
                    const e = this.getClusters([
                        i,
                        o,
                        180,
                        s
                    ], t), n = this.getClusters([
                        -180,
                        o,
                        r,
                        s
                    ], t);
                    return e.concat(n);
                }
                const n = this.trees[this._limitZoom(t)], a = n.range(Z(i), G(s), Z(r), G(o)), l = n.data, c = [];
                for (const e of a){
                    const t = this.stride * e;
                    c.push(l[t + F] > 1 ? E(l, t, this.clusterProps) : this.points[l[t + L]]);
                }
                return c;
            }
            getChildren(e) {
                const t = this._getOriginId(e), i = this._getOriginZoom(e), o = "No cluster with the specified id.", r = this.trees[i];
                if (!r) throw new Error(o);
                const s = r.data;
                if (t * this.stride >= s.length) throw new Error(o);
                const n = this.options.radius / (this.options.extent * Math.pow(2, i - 1)), a = r.within(s[t * this.stride], s[t * this.stride + 1], n), l = [];
                for (const t of a){
                    const i = t * this.stride;
                    s[i + 4] === e && l.push(s[i + F] > 1 ? E(s, i, this.clusterProps) : this.points[s[i + L]]);
                }
                if (0 === l.length) throw new Error(o);
                return l;
            }
            getLeaves(e, t, i) {
                const o = [];
                return this._appendLeaves(o, e, t = t || 10, i = i || 0, 0), o;
            }
            getTile(e, t, i) {
                const o = this.trees[this._limitZoom(e)], r = Math.pow(2, e), { extent: s, radius: n } = this.options, a = n / s, l = (i - a) / r, c = (i + 1 + a) / r, h = {
                    features: []
                };
                return this._addTileFeatures(o.range((t - a) / r, l, (t + 1 + a) / r, c), o.data, t, i, r, h), 0 === t && this._addTileFeatures(o.range(1 - a / r, l, 1, c), o.data, r, i, r, h), t === r - 1 && this._addTileFeatures(o.range(0, l, a / r, c), o.data, -1, i, r, h), h.features.length ? h : null;
            }
            getClusterExpansionZoom(e) {
                let t = this._getOriginZoom(e) - 1;
                for(; t <= this.options.maxZoom;){
                    const i = this.getChildren(e);
                    if (t++, 1 !== i.length) break;
                    e = i[0].properties.cluster_id;
                }
                return t;
            }
            _appendLeaves(e, t, i, o, r) {
                const s = this.getChildren(t);
                for (const t of s){
                    const s = t.properties;
                    if (s && s.cluster ? r + s.point_count <= o ? r += s.point_count : r = this._appendLeaves(e, s.cluster_id, i, o, r) : r < o ? r++ : e.push(t), e.length === i) break;
                }
                return r;
            }
            _createTree(t) {
                const i = new e.av(t.length / this.stride | 0, this.options.nodeSize, Float32Array);
                for(let e = 0; e < t.length; e += this.stride)i.add(t[e], t[e + 1]);
                return i.finish(), i.data = t, i;
            }
            _addTileFeatures(e, t, i, o, r, s) {
                for (const n of e){
                    const e = n * this.stride, a = t[e + F] > 1;
                    let l, c, h;
                    if (a) l = j(t, e, this.clusterProps), c = t[e], h = t[e + 1];
                    else {
                        const i = this.points[t[e + L]];
                        l = i.properties;
                        const [o, r] = i.geometry.coordinates;
                        c = Z(o), h = G(r);
                    }
                    const u = {
                        type: 1,
                        geometry: [
                            [
                                Math.round(this.options.extent * (c * r - i)),
                                Math.round(this.options.extent * (h * r - o))
                            ]
                        ],
                        tags: l
                    };
                    let d;
                    d = a || this.options.generateId ? t[e + L] : this.points[t[e + L]].id, void 0 !== d && (u.id = d), s.features.push(u);
                }
            }
            _limitZoom(e) {
                return Math.max(this.options.minZoom, Math.min(Math.floor(+e), this.options.maxZoom + 1));
            }
            _cluster(e, t) {
                const { radius: i, extent: o, reduce: r, minPoints: s } = this.options, n = i / (o * Math.pow(2, t)), a = e.data, l = [], c = this.stride;
                for(let i = 0; i < a.length; i += c){
                    if (a[i + 2] <= t) continue;
                    a[i + 2] = t;
                    const o = a[i], h = a[i + 1], u = e.within(a[i], a[i + 1], n), d = a[i + F];
                    let p = d;
                    for (const e of u){
                        const i = e * c;
                        a[i + 2] > t && (p += a[i + F]);
                    }
                    if (p > d && p >= s) {
                        let e, s = o * d, n = h * d, f = -1;
                        const g = ((i / c | 0) << 5) + (t + 1) + this.points.length;
                        for (const o of u){
                            const l = o * c;
                            if (a[l + 2] <= t) continue;
                            a[l + 2] = t;
                            const h = a[l + F];
                            s += a[l] * h, n += a[l + 1] * h, a[l + 4] = g, r && (e || (e = this._map(a, i, !0), f = this.clusterProps.length, this.clusterProps.push(e)), r(e, this._map(a, l)));
                        }
                        a[i + 4] = g, l.push(s / p, n / p, 1 / 0, g, -1, p), r && l.push(f);
                    } else {
                        for(let e = 0; e < c; e++)l.push(a[i + e]);
                        if (p > 1) for (const e of u){
                            const i = e * c;
                            if (!(a[i + 2] <= t)) {
                                a[i + 2] = t;
                                for(let e = 0; e < c; e++)l.push(a[i + e]);
                            }
                        }
                    }
                }
                return l;
            }
            _getOriginId(e) {
                return e - this.points.length >> 5;
            }
            _getOriginZoom(e) {
                return (e - this.points.length) % 32;
            }
            _map(e, t, i) {
                if (e[t + F] > 1) {
                    const o = this.clusterProps[e[t + z]];
                    return i ? Object.assign({}, o) : o;
                }
                const o = this.points[e[t + L]].properties, r = this.options.map(o);
                return i && r === o ? Object.assign({}, r) : r;
            }
        }
        function E(e, t, i) {
            var o;
            return {
                type: "Feature",
                id: e[t + L],
                properties: j(e, t, i),
                geometry: {
                    type: "Point",
                    coordinates: [
                        (o = e[t], 360 * (o - .5)),
                        J(e[t + 1])
                    ]
                }
            };
        }
        function j(e, t, i) {
            const o = e[t + F], r = o >= 1e4 ? `${Math.round(o / 1e3)}k` : o >= 1e3 ? Math.round(o / 100) / 10 + "k" : o, s = e[t + z], n = -1 === s ? {} : Object.assign({}, i[s]);
            return Object.assign(n, {
                cluster: !0,
                cluster_id: e[t + L],
                point_count: o,
                point_count_abbreviated: r
            });
        }
        function Z(e) {
            return e / 360 + .5;
        }
        function G(e) {
            const t = Math.sin(e * Math.PI / 180), i = .5 - .25 * Math.log((1 + t) / (1 - t)) / Math.PI;
            return i < 0 ? 0 : i > 1 ? 1 : i;
        }
        function J(e) {
            const t = (180 - 360 * e) * Math.PI / 180;
            return 360 * Math.atan(Math.exp(t)) / Math.PI - 90;
        }
        function Y(e, t, i, o) {
            for(var r, s = o, n = i - t >> 1, a = i - t, l = e[t], c = e[t + 1], h = e[i], u = e[i + 1], d = t + 3; d < i; d += 3){
                var p = A(e[d], e[d + 1], l, c, h, u);
                if (p > s) r = d, s = p;
                else if (p === s) {
                    var f = Math.abs(d - n);
                    f < a && (r = d, a = f);
                }
            }
            s > o && (r - t > 3 && Y(e, t, r, o), e[r + 2] = s, i - r > 3 && Y(e, r, i, o));
        }
        function A(e, t, i, o, r, s) {
            var n = r - i, a = s - o;
            if (0 !== n || 0 !== a) {
                var l = ((e - i) * n + (t - o) * a) / (n * n + a * a);
                l > 1 ? (i = r, o = s) : l > 0 && (i += n * l, o += a * l);
            }
            return (n = e - i) * n + (a = t - o) * a;
        }
        function V(e, t, i, o) {
            var r = {
                id: void 0 === e ? null : e,
                type: t,
                geometry: i,
                tags: o,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            };
            return function(e) {
                var t = e.geometry, i = e.type;
                if ("Point" === i || "MultiPoint" === i || "LineString" === i) B(e, t);
                else if ("Polygon" === i || "MultiLineString" === i) for(var o = 0; o < t.length; o++)B(e, t[o]);
                else if ("MultiPolygon" === i) for(o = 0; o < t.length; o++)for(var r = 0; r < t[o].length; r++)B(e, t[o][r]);
            }(r), r;
        }
        function B(e, t) {
            for(var i = 0; i < t.length; i += 3)e.minX = Math.min(e.minX, t[i]), e.minY = Math.min(e.minY, t[i + 1]), e.maxX = Math.max(e.maxX, t[i]), e.maxY = Math.max(e.maxY, t[i + 1]);
        }
        function X(e, t, i, o) {
            if (t.geometry) {
                var r = t.geometry.coordinates, s = t.geometry.type, n = Math.pow(i.tolerance / ((1 << i.maxZoom) * i.extent), 2), a = [], l = t.id;
                if (i.promoteId ? l = t.properties[i.promoteId] : i.generateId && (l = o || 0), "Point" === s) q(r, a);
                else if ("MultiPoint" === s) for(var c = 0; c < r.length; c++)q(r[c], a);
                else if ("LineString" === s) R(r, a, n, !1);
                else if ("MultiLineString" === s) {
                    if (i.lineMetrics) {
                        for(c = 0; c < r.length; c++)R(r[c], a = [], n, !1), e.push(V(l, "LineString", a, t.properties));
                        return;
                    }
                    W(r, a, n, !1);
                } else if ("Polygon" === s) W(r, a, n, !0);
                else {
                    if ("MultiPolygon" !== s) {
                        if ("GeometryCollection" === s) {
                            for(c = 0; c < t.geometry.geometries.length; c++)X(e, {
                                id: l,
                                geometry: t.geometry.geometries[c],
                                properties: t.properties
                            }, i, o);
                            return;
                        }
                        throw new Error("Input data is not a valid GeoJSON object.");
                    }
                    for(c = 0; c < r.length; c++){
                        var h = [];
                        W(r[c], h, n, !0), a.push(h);
                    }
                }
                e.push(V(l, s, a, t.properties));
            }
        }
        function q(e, t) {
            t.push($(e[0])), t.push(U(e[1])), t.push(0);
        }
        function R(e, t, i, o) {
            for(var r, s, n = 0, a = 0; a < e.length; a++){
                var l = $(e[a][0]), c = U(e[a][1]);
                t.push(l), t.push(c), t.push(0), a > 0 && (n += o ? (r * c - l * s) / 2 : Math.sqrt(Math.pow(l - r, 2) + Math.pow(c - s, 2))), r = l, s = c;
            }
            var h = t.length - 3;
            t[2] = 1, Y(t, 0, h, i), t[h + 2] = 1, t.size = Math.abs(n), t.start = 0, t.end = t.size;
        }
        function W(e, t, i, o) {
            for(var r = 0; r < e.length; r++){
                var s = [];
                R(e[r], s, i, o), t.push(s);
            }
        }
        function $(e) {
            return e / 360 + .5;
        }
        function U(e) {
            var t = Math.sin(e * Math.PI / 180), i = .5 - .25 * Math.log((1 + t) / (1 - t)) / Math.PI;
            return i < 0 ? 0 : i > 1 ? 1 : i;
        }
        function H(e, t, i, o, r, s, n, a) {
            if (o /= t, s >= (i /= t) && n < o) return e;
            if (n < i || s >= o) return null;
            for(var l = [], c = 0; c < e.length; c++){
                var h = e[c], u = h.geometry, d = h.type, p = 0 === r ? h.minX : h.minY, f = 0 === r ? h.maxX : h.maxY;
                if (p >= i && f < o) l.push(h);
                else if (!(f < i || p >= o)) {
                    var g = [];
                    if ("Point" === d || "MultiPoint" === d) K(u, g, i, o, r);
                    else if ("LineString" === d) Q(u, g, i, o, r, !1, a.lineMetrics);
                    else if ("MultiLineString" === d) te(u, g, i, o, r, !1);
                    else if ("Polygon" === d) te(u, g, i, o, r, !0);
                    else if ("MultiPolygon" === d) for(var m = 0; m < u.length; m++){
                        var y = [];
                        te(u[m], y, i, o, r, !0), y.length && g.push(y);
                    }
                    if (g.length) {
                        if (a.lineMetrics && "LineString" === d) {
                            for(m = 0; m < g.length; m++)l.push(V(h.id, d, g[m], h.tags));
                            continue;
                        }
                        "LineString" !== d && "MultiLineString" !== d || (1 === g.length ? (d = "LineString", g = g[0]) : d = "MultiLineString"), "Point" !== d && "MultiPoint" !== d || (d = 3 === g.length ? "Point" : "MultiPoint"), l.push(V(h.id, d, g, h.tags));
                    }
                }
            }
            return l.length ? l : null;
        }
        function K(e, t, i, o, r) {
            for(var s = 0; s < e.length; s += 3){
                var n = e[s + r];
                n >= i && n <= o && (t.push(e[s]), t.push(e[s + 1]), t.push(e[s + 2]));
            }
        }
        function Q(e, t, i, o, r, s, n) {
            for(var a, l, c = ee(e), h = 0 === r ? oe : re, u = e.start, d = 0; d < e.length - 3; d += 3){
                var p = e[d], f = e[d + 1], g = e[d + 2], m = e[d + 3], y = e[d + 4], v = 0 === r ? p : f, w = 0 === r ? m : y, x = !1;
                n && (a = Math.sqrt(Math.pow(p - m, 2) + Math.pow(f - y, 2))), v < i ? w > i && (l = h(c, p, f, m, y, i), n && (c.start = u + a * l)) : v > o ? w < o && (l = h(c, p, f, m, y, o), n && (c.start = u + a * l)) : ie(c, p, f, g), w < i && v >= i && (l = h(c, p, f, m, y, i), x = !0), w > o && v <= o && (l = h(c, p, f, m, y, o), x = !0), !s && x && (n && (c.end = u + a * l), t.push(c), c = ee(e)), n && (u += a);
            }
            var b = e.length - 3;
            p = e[b], f = e[b + 1], g = e[b + 2], (v = 0 === r ? p : f) >= i && v <= o && ie(c, p, f, g), b = c.length - 3, s && b >= 3 && (c[b] !== c[0] || c[b + 1] !== c[1]) && ie(c, c[0], c[1], c[2]), c.length && t.push(c);
        }
        function ee(e) {
            var t = [];
            return t.size = e.size, t.start = e.start, t.end = e.end, t;
        }
        function te(e, t, i, o, r, s) {
            for(var n = 0; n < e.length; n++)Q(e[n], t, i, o, r, s, !1);
        }
        function ie(e, t, i, o) {
            e.push(t), e.push(i), e.push(o);
        }
        function oe(e, t, i, o, r, s) {
            var n = (s - t) / (o - t);
            return e.push(s), e.push(i + (r - i) * n), e.push(1), n;
        }
        function re(e, t, i, o, r, s) {
            var n = (s - i) / (r - i);
            return e.push(t + (o - t) * n), e.push(s), e.push(1), n;
        }
        function se(e, t) {
            for(var i = [], o = 0; o < e.length; o++){
                var r, s = e[o], n = s.type;
                if ("Point" === n || "MultiPoint" === n || "LineString" === n) r = ne(s.geometry, t);
                else if ("MultiLineString" === n || "Polygon" === n) {
                    r = [];
                    for(var a = 0; a < s.geometry.length; a++)r.push(ne(s.geometry[a], t));
                } else if ("MultiPolygon" === n) for(r = [], a = 0; a < s.geometry.length; a++){
                    for(var l = [], c = 0; c < s.geometry[a].length; c++)l.push(ne(s.geometry[a][c], t));
                    r.push(l);
                }
                i.push(V(s.id, n, r, s.tags));
            }
            return i;
        }
        function ne(e, t) {
            var i = [];
            i.size = e.size, void 0 !== e.start && (i.start = e.start, i.end = e.end);
            for(var o = 0; o < e.length; o += 3)i.push(e[o] + t, e[o + 1], e[o + 2]);
            return i;
        }
        function ae(e, t) {
            if (e.transformed) return e;
            var i, o, r, s = 1 << e.z, n = e.x, a = e.y;
            for(i = 0; i < e.features.length; i++){
                var l = e.features[i], c = l.geometry, h = l.type;
                if (l.geometry = [], 1 === h) for(o = 0; o < c.length; o += 2)l.geometry.push(le(c[o], c[o + 1], t, s, n, a));
                else for(o = 0; o < c.length; o++){
                    var u = [];
                    for(r = 0; r < c[o].length; r += 2)u.push(le(c[o][r], c[o][r + 1], t, s, n, a));
                    l.geometry.push(u);
                }
            }
            return e.transformed = !0, e;
        }
        function le(e, t, i, o, r, s) {
            return [
                Math.round(i * (e * o - r)),
                Math.round(i * (t * o - s))
            ];
        }
        function ce(e, t, i, o, r) {
            for(var s = t === r.maxZoom ? 0 : r.tolerance / ((1 << t) * r.extent), n = {
                features: [],
                numPoints: 0,
                numSimplified: 0,
                numFeatures: 0,
                source: null,
                x: i,
                y: o,
                z: t,
                transformed: !1,
                minX: 2,
                minY: 1,
                maxX: -1,
                maxY: 0
            }, a = 0; a < e.length; a++){
                n.numFeatures++, he(n, e[a], s, r);
                var l = e[a].minX, c = e[a].minY, h = e[a].maxX, u = e[a].maxY;
                l < n.minX && (n.minX = l), c < n.minY && (n.minY = c), h > n.maxX && (n.maxX = h), u > n.maxY && (n.maxY = u);
            }
            return n;
        }
        function he(e, t, i, o) {
            var r = t.geometry, s = t.type, n = [];
            if ("Point" === s || "MultiPoint" === s) for(var a = 0; a < r.length; a += 3)n.push(r[a]), n.push(r[a + 1]), e.numPoints++, e.numSimplified++;
            else if ("LineString" === s) ue(n, r, e, i, !1, !1);
            else if ("MultiLineString" === s || "Polygon" === s) for(a = 0; a < r.length; a++)ue(n, r[a], e, i, "Polygon" === s, 0 === a);
            else if ("MultiPolygon" === s) for(var l = 0; l < r.length; l++){
                var c = r[l];
                for(a = 0; a < c.length; a++)ue(n, c[a], e, i, !0, 0 === a);
            }
            if (n.length) {
                var h = t.tags || null;
                if ("LineString" === s && o.lineMetrics) {
                    for(var u in h = {}, t.tags)h[u] = t.tags[u];
                    h.mapbox_clip_start = r.start / r.size, h.mapbox_clip_end = r.end / r.size;
                }
                var d = {
                    geometry: n,
                    type: "Polygon" === s || "MultiPolygon" === s ? 3 : "LineString" === s || "MultiLineString" === s ? 2 : 1,
                    tags: h
                };
                null !== t.id && (d.id = t.id), e.features.push(d);
            }
        }
        function ue(e, t, i, o, r, s) {
            var n = o * o;
            if (o > 0 && t.size < (r ? n : o)) i.numPoints += t.length / 3;
            else {
                for(var a = [], l = 0; l < t.length; l += 3)(0 === o || t[l + 2] > n) && (i.numSimplified++, a.push(t[l]), a.push(t[l + 1])), i.numPoints++;
                r && function(e, t) {
                    for(var i = 0, o = 0, r = e.length, s = r - 2; o < r; s = o, o += 2)i += (e[o] - e[s]) * (e[o + 1] + e[s + 1]);
                    if (i > 0 === t) for(o = 0, r = e.length; o < r / 2; o += 2){
                        var n = e[o], a = e[o + 1];
                        e[o] = e[r - 2 - o], e[o + 1] = e[r - 1 - o], e[r - 2 - o] = n, e[r - 1 - o] = a;
                    }
                }(a, s), e.push(a);
            }
        }
        function de(e, t) {
            var i = (t = this.options = function(e, t) {
                for(var i in t)e[i] = t[i];
                return e;
            }(Object.create(this.options), t)).debug;
            if (i && console.time("preprocess data"), t.maxZoom < 0 || t.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
            if (t.promoteId && t.generateId) throw new Error("promoteId and generateId cannot be used together.");
            var o = function(e, t) {
                var i = [];
                if ("FeatureCollection" === e.type) for(var o = 0; o < e.features.length; o++)X(i, e.features[o], t, o);
                else X(i, "Feature" === e.type ? e : {
                    geometry: e
                }, t);
                return i;
            }(e, t);
            this.tiles = {}, this.tileCoords = [], i && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", t.indexMaxZoom, t.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), o = function(e, t) {
                var i = t.buffer / t.extent, o = e, r = H(e, 1, -1 - i, i, 0, -1, 2, t), s = H(e, 1, 1 - i, 2 + i, 0, -1, 2, t);
                return (r || s) && (o = H(e, 1, -i, 1 + i, 0, -1, 2, t) || [], r && (o = se(r, 1).concat(o)), s && (o = o.concat(se(s, -1)))), o;
            }(o, t), o.length && this.splitTile(o, 0, 0, 0), i && (o.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
        }
        function pe(e, t, i) {
            return 32 * ((1 << e) * i + t) + e;
        }
        function fe(e, t) {
            return t ? e.properties[t] : e.id;
        }
        function ge(e, t) {
            if (null == e) return !0;
            if ("Feature" === e.type) return null != fe(e, t);
            if ("FeatureCollection" === e.type) {
                const i = new Set;
                for (const o of e.features){
                    const e = fe(o, t);
                    if (null == e) return !1;
                    if (i.has(e)) return !1;
                    i.add(e);
                }
                return !0;
            }
            return !1;
        }
        function me(e, t) {
            const i = new Map;
            if (null == e) ;
            else if ("Feature" === e.type) i.set(fe(e, t), e);
            else for (const o of e.features)i.set(fe(o, t), o);
            return i;
        }
        de.prototype.options = {
            maxZoom: 14,
            indexMaxZoom: 5,
            indexMaxPoints: 1e5,
            tolerance: 3,
            extent: 4096,
            buffer: 64,
            lineMetrics: !1,
            promoteId: null,
            generateId: !1,
            debug: 0
        }, de.prototype.splitTile = function(e, t, i, o, r, s, n) {
            for(var a = [
                e,
                t,
                i,
                o
            ], l = this.options, c = l.debug; a.length;){
                o = a.pop(), i = a.pop(), t = a.pop(), e = a.pop();
                var h = 1 << t, u = pe(t, i, o), d = this.tiles[u];
                if (!d && (c > 1 && console.time("creation"), d = this.tiles[u] = ce(e, t, i, o, l), this.tileCoords.push({
                    z: t,
                    x: i,
                    y: o
                }), c)) {
                    c > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t, i, o, d.numFeatures, d.numPoints, d.numSimplified), console.timeEnd("creation"));
                    var p = "z" + t;
                    this.stats[p] = (this.stats[p] || 0) + 1, this.total++;
                }
                if (d.source = e, r) {
                    if (t === l.maxZoom || t === r) continue;
                    var f = 1 << r - t;
                    if (i !== Math.floor(s / f) || o !== Math.floor(n / f)) continue;
                } else if (t === l.indexMaxZoom || d.numPoints <= l.indexMaxPoints) continue;
                if (d.source = null, 0 !== e.length) {
                    c > 1 && console.time("clipping");
                    var g, m, y, v, w, x, b = .5 * l.buffer / l.extent, S = .5 - b, M = .5 + b, I = 1 + b;
                    g = m = y = v = null, w = H(e, h, i - b, i + M, 0, d.minX, d.maxX, l), x = H(e, h, i + S, i + I, 0, d.minX, d.maxX, l), e = null, w && (g = H(w, h, o - b, o + M, 1, d.minY, d.maxY, l), m = H(w, h, o + S, o + I, 1, d.minY, d.maxY, l), w = null), x && (y = H(x, h, o - b, o + M, 1, d.minY, d.maxY, l), v = H(x, h, o + S, o + I, 1, d.minY, d.maxY, l), x = null), c > 1 && console.timeEnd("clipping"), a.push(g || [], t + 1, 2 * i, 2 * o), a.push(m || [], t + 1, 2 * i, 2 * o + 1), a.push(y || [], t + 1, 2 * i + 1, 2 * o), a.push(v || [], t + 1, 2 * i + 1, 2 * o + 1);
                }
            }
        }, de.prototype.getTile = function(e, t, i) {
            var o = this.options, r = o.extent, s = o.debug;
            if (e < 0 || e > 24) return null;
            var n = 1 << e, a = pe(e, t = (t % n + n) % n, i);
            if (this.tiles[a]) return ae(this.tiles[a], r);
            s > 1 && console.log("drilling down to z%d-%d-%d", e, t, i);
            for(var l, c = e, h = t, u = i; !l && c > 0;)c--, h = Math.floor(h / 2), u = Math.floor(u / 2), l = this.tiles[pe(c, h, u)];
            return l && l.source ? (s > 1 && console.log("found parent tile z%d-%d-%d", c, h, u), s > 1 && console.time("drilling down"), this.splitTile(l.source, c, h, u, e, t, i), s > 1 && console.timeEnd("drilling down"), this.tiles[a] ? ae(this.tiles[a], r) : null) : null;
        };
        class ye extends n {
            constructor(t, i, o, r){
                super(t, i, o), this._dataUpdateable = new Map, this.loadGeoJSON = (t, i)=>{
                    const { promoteId: o } = t;
                    if (t.request) return e.f(t.request, (e, t, r, s)=>{
                        this._dataUpdateable = ge(t, o) ? me(t, o) : void 0, i(e, t, r, s);
                    });
                    if ("string" == typeof t.data) try {
                        const e = JSON.parse(t.data);
                        this._dataUpdateable = ge(e, o) ? me(e, o) : void 0, i(null, e);
                    } catch (e) {
                        i(new Error(`Input data given to '${t.source}' is not a valid GeoJSON object.`));
                    }
                    else t.dataDiff ? this._dataUpdateable ? (function(e, t, i) {
                        var o, r, s, n;
                        if (t.removeAll && e.clear(), t.remove) for (const i of t.remove)e.delete(i);
                        if (t.add) for (const o of t.add){
                            const t = fe(o, i);
                            null != t && e.set(t, o);
                        }
                        if (t.update) for (const i of t.update){
                            let t = e.get(i.id);
                            if (null == t) continue;
                            const a = !i.removeAllProperties && ((null === (o = i.removeProperties) || void 0 === o ? void 0 : o.length) > 0 || (null === (r = i.addOrUpdateProperties) || void 0 === r ? void 0 : r.length) > 0);
                            if ((i.newGeometry || i.removeAllProperties || a) && (t = Object.assign({}, t), e.set(i.id, t), a && (t.properties = Object.assign({}, t.properties))), i.newGeometry && (t.geometry = i.newGeometry), i.removeAllProperties) t.properties = {};
                            else if ((null === (s = i.removeProperties) || void 0 === s ? void 0 : s.length) > 0) for (const e of i.removeProperties)Object.prototype.hasOwnProperty.call(t.properties, e) && delete t.properties[e];
                            if ((null === (n = i.addOrUpdateProperties) || void 0 === n ? void 0 : n.length) > 0) for (const { key: e, value: o } of i.addOrUpdateProperties)t.properties[e] = o;
                        }
                    }(this._dataUpdateable, t.dataDiff, o), i(null, {
                        type: "FeatureCollection",
                        features: Array.from(this._dataUpdateable.values())
                    })) : i(new Error(`Cannot update existing geojson data in ${t.source}`)) : i(new Error(`Input data given to '${t.source}' is not a valid GeoJSON object.`));
                    return {
                        cancel: ()=>{}
                    };
                }, this.loadVectorData = this.loadGeoJSONTile, r && (this.loadGeoJSON = r);
            }
            loadGeoJSONTile(t, i) {
                const o = t.tileID.canonical;
                if (!this._geoJSONIndex) return i(null, null);
                const r = this._geoJSONIndex.getTile(o.z, o.x, o.y);
                if (!r) return i(null, null);
                const s = new class {
                    constructor(t){
                        this.layers = {
                            _geojsonTileLayer: this
                        }, this.name = "_geojsonTileLayer", this.extent = e.N, this.length = t.length, this._features = t;
                    }
                    feature(t) {
                        return new class {
                            constructor(t){
                                this._feature = t, this.extent = e.N, this.type = t.type, this.properties = t.tags, "id" in t && !isNaN(t.id) && (this.id = parseInt(t.id, 10));
                            }
                            loadGeometry() {
                                if (1 === this._feature.type) {
                                    const t = [];
                                    for (const i of this._feature.geometry)t.push([
                                        new e.P(i[0], i[1])
                                    ]);
                                    return t;
                                }
                                {
                                    const t = [];
                                    for (const i of this._feature.geometry){
                                        const o = [];
                                        for (const t of i)o.push(new e.P(t[0], t[1]));
                                        t.push(o);
                                    }
                                    return t;
                                }
                            }
                            toGeoJSON(e, t, i) {
                                return u.call(this, e, t, i);
                            }
                        }(this._features[t]);
                    }
                }(r.features);
                let n = k(s);
                0 === n.byteOffset && n.byteLength === n.buffer.byteLength || (n = new Uint8Array(n)), i(null, {
                    vectorTile: s,
                    rawData: n.buffer
                });
            }
            loadData(t, i) {
                var o;
                null === (o = this._pendingRequest) || void 0 === o || o.cancel(), this._pendingCallback && this._pendingCallback(null, {
                    abandoned: !0
                });
                const r = !!(t && t.request && t.request.collectResourceTiming) && new e.bu(t.request);
                this._pendingCallback = i, this._pendingRequest = this.loadGeoJSON(t, (o, s)=>{
                    if (delete this._pendingCallback, delete this._pendingRequest, o || !s) return i(o);
                    if ("object" != typeof s) return i(new Error(`Input data given to '${t.source}' is not a valid GeoJSON object.`));
                    {
                        h(s, !0);
                        try {
                            if (t.filter) {
                                const i = e.bC(t.filter, {
                                    type: "boolean",
                                    "property-type": "data-driven",
                                    overridable: !1,
                                    transition: !1
                                });
                                if ("error" === i.result) throw new Error(i.value.map((e)=>`${e.key}: ${e.message}`).join(", "));
                                const o = s.features.filter((e)=>i.value.evaluate({
                                        zoom: 0
                                    }, e));
                                s = {
                                    type: "FeatureCollection",
                                    features: o
                                };
                            }
                            this._geoJSONIndex = t.cluster ? new N(function({ superclusterOptions: t, clusterProperties: i }) {
                                if (!i || !t) return t;
                                const o = {}, r = {}, s = {
                                    accumulated: null,
                                    zoom: 0
                                }, n = {
                                    properties: null
                                }, a = Object.keys(i);
                                for (const t of a){
                                    const [s, n] = i[t], a = e.bC(n), l = e.bC("string" == typeof s ? [
                                        s,
                                        [
                                            "accumulated"
                                        ],
                                        [
                                            "get",
                                            t
                                        ]
                                    ] : s);
                                    o[t] = a.value, r[t] = l.value;
                                }
                                return t.map = (e)=>{
                                    n.properties = e;
                                    const t = {};
                                    for (const e of a)t[e] = o[e].evaluate(s, n);
                                    return t;
                                }, t.reduce = (e, t)=>{
                                    n.properties = t;
                                    for (const t of a)s.accumulated = e[t], e[t] = r[t].evaluate(s, n);
                                }, t;
                            }(t)).load(s.features) : function(e, t) {
                                return new de(e, t);
                            }(s, t.geojsonVtOptions);
                        } catch (o) {
                            return i(o);
                        }
                        this.loaded = {};
                        const n = {};
                        if (r) {
                            const e = r.finish();
                            e && (n.resourceTiming = {}, n.resourceTiming[t.source] = JSON.parse(JSON.stringify(e)));
                        }
                        i(null, n);
                    }
                });
            }
            reloadTile(e, t) {
                const i = this.loaded;
                return i && i[e.uid] ? super.reloadTile(e, t) : this.loadTile(e, t);
            }
            removeSource(e, t) {
                this._pendingCallback && this._pendingCallback(null, {
                    abandoned: !0
                }), t();
            }
            getClusterExpansionZoom(e, t) {
                try {
                    t(null, this._geoJSONIndex.getClusterExpansionZoom(e.clusterId));
                } catch (e) {
                    t(e);
                }
            }
            getClusterChildren(e, t) {
                try {
                    t(null, this._geoJSONIndex.getChildren(e.clusterId));
                } catch (e) {
                    t(e);
                }
            }
            getClusterLeaves(e, t) {
                try {
                    t(null, this._geoJSONIndex.getLeaves(e.clusterId, e.limit, e.offset));
                } catch (e) {
                    t(e);
                }
            }
        }
        class ve {
            constructor(t){
                this.self = t, this.actor = new e.C(t, this), this.layerIndexes = {}, this.availableImages = {}, this.workerSourceTypes = {
                    vector: n,
                    geojson: ye
                }, this.workerSources = {}, this.demWorkerSources = {}, this.self.registerWorkerSource = (e, t)=>{
                    if (this.workerSourceTypes[e]) throw new Error(`Worker source with name "${e}" already registered.`);
                    this.workerSourceTypes[e] = t;
                }, this.self.registerRTLTextPlugin = (t)=>{
                    if (e.bD.isParsed()) throw new Error("RTL text plugin already registered.");
                    e.bD.applyArabicShaping = t.applyArabicShaping, e.bD.processBidirectionalText = t.processBidirectionalText, e.bD.processStyledBidirectionalText = t.processStyledBidirectionalText;
                };
            }
            setReferrer(e, t) {
                this.referrer = t;
            }
            setImages(e, t, i) {
                this.availableImages[e] = t;
                for(const i in this.workerSources[e]){
                    const o = this.workerSources[e][i];
                    for(const e in o)o[e].availableImages = t;
                }
                i();
            }
            setLayers(e, t, i) {
                this.getLayerIndex(e).replace(t), i();
            }
            updateLayers(e, t, i) {
                this.getLayerIndex(e).update(t.layers, t.removedIds), i();
            }
            loadTile(e, t, i) {
                this.getWorkerSource(e, t.type, t.source).loadTile(t, i);
            }
            loadDEMTile(e, t, i) {
                this.getDEMWorkerSource(e, t.source).loadTile(t, i);
            }
            reloadTile(e, t, i) {
                this.getWorkerSource(e, t.type, t.source).reloadTile(t, i);
            }
            abortTile(e, t, i) {
                this.getWorkerSource(e, t.type, t.source).abortTile(t, i);
            }
            removeTile(e, t, i) {
                this.getWorkerSource(e, t.type, t.source).removeTile(t, i);
            }
            removeDEMTile(e, t) {
                this.getDEMWorkerSource(e, t.source).removeTile(t);
            }
            removeSource(e, t, i) {
                if (!this.workerSources[e] || !this.workerSources[e][t.type] || !this.workerSources[e][t.type][t.source]) return;
                const o = this.workerSources[e][t.type][t.source];
                delete this.workerSources[e][t.type][t.source], void 0 !== o.removeSource ? o.removeSource(t, i) : i();
            }
            loadWorkerSource(e, t, i) {
                try {
                    this.self.importScripts(t.url), i();
                } catch (e) {
                    i(e.toString());
                }
            }
            syncRTLPluginState(t, i, o) {
                try {
                    e.bD.setState(i);
                    const t = e.bD.getPluginURL();
                    if (e.bD.isLoaded() && !e.bD.isParsed() && null != t) {
                        this.self.importScripts(t);
                        const i = e.bD.isParsed();
                        o(i ? void 0 : new Error(`RTL Text Plugin failed to import scripts from ${t}`), i);
                    }
                } catch (e) {
                    o(e.toString());
                }
            }
            getAvailableImages(e) {
                let t = this.availableImages[e];
                return t || (t = []), t;
            }
            getLayerIndex(e) {
                let i = this.layerIndexes[e];
                return i || (i = this.layerIndexes[e] = new t), i;
            }
            getWorkerSource(e, t, i) {
                return this.workerSources[e] || (this.workerSources[e] = {}), this.workerSources[e][t] || (this.workerSources[e][t] = {}), this.workerSources[e][t][i] || (this.workerSources[e][t][i] = new this.workerSourceTypes[t]({
                    send: (t, i, o)=>{
                        this.actor.send(t, i, o, e);
                    }
                }, this.getLayerIndex(e), this.getAvailableImages(e))), this.workerSources[e][t][i];
            }
            getDEMWorkerSource(e, t) {
                return this.demWorkerSources[e] || (this.demWorkerSources[e] = {}), this.demWorkerSources[e][t] || (this.demWorkerSources[e][t] = new a), this.demWorkerSources[e][t];
            }
        }
        return e.i() && (self.worker = new ve(self)), ve;
    });
    define([
        "./shared"
    ], function(t) {
        "use strict";
        var e = "3.6.2";
        class i {
            static testProp(t) {
                if (!i.docStyle) return t[0];
                for(let e = 0; e < t.length; e++)if (t[e] in i.docStyle) return t[e];
                return t[0];
            }
            static create(t, e, i) {
                const s = window.document.createElement(t);
                return void 0 !== e && (s.className = e), i && i.appendChild(s), s;
            }
            static createNS(t, e) {
                return window.document.createElementNS(t, e);
            }
            static disableDrag() {
                i.docStyle && i.selectProp && (i.userSelect = i.docStyle[i.selectProp], i.docStyle[i.selectProp] = "none");
            }
            static enableDrag() {
                i.docStyle && i.selectProp && (i.docStyle[i.selectProp] = i.userSelect);
            }
            static setTransform(t, e) {
                t.style[i.transformProp] = e;
            }
            static addEventListener(t, e, i, s = {}) {
                t.addEventListener(e, i, "passive" in s ? s : s.capture);
            }
            static removeEventListener(t, e, i, s = {}) {
                t.removeEventListener(e, i, "passive" in s ? s : s.capture);
            }
            static suppressClickInternal(t) {
                t.preventDefault(), t.stopPropagation(), window.removeEventListener("click", i.suppressClickInternal, !0);
            }
            static suppressClick() {
                window.addEventListener("click", i.suppressClickInternal, !0), window.setTimeout(()=>{
                    window.removeEventListener("click", i.suppressClickInternal, !0);
                }, 0);
            }
            static mousePos(e, i) {
                const s = e.getBoundingClientRect();
                return new t.P(i.clientX - s.left - e.clientLeft, i.clientY - s.top - e.clientTop);
            }
            static touchPos(e, i) {
                const s = e.getBoundingClientRect(), a = [];
                for(let o = 0; o < i.length; o++)a.push(new t.P(i[o].clientX - s.left - e.clientLeft, i[o].clientY - s.top - e.clientTop));
                return a;
            }
            static mouseButton(t) {
                return t.button;
            }
            static remove(t) {
                t.parentNode && t.parentNode.removeChild(t);
            }
        }
        i.docStyle = "undefined" != typeof window && window.document && window.document.documentElement.style, i.selectProp = i.testProp([
            "userSelect",
            "MozUserSelect",
            "WebkitUserSelect",
            "msUserSelect"
        ]), i.transformProp = i.testProp([
            "transform",
            "WebkitTransform"
        ]);
        const s = {
            supported: !1,
            testSupport: function(t) {
                !r && o && (n ? l(t) : a = t);
            }
        };
        let a, o, r = !1, n = !1;
        function l(t) {
            const e = t.createTexture();
            t.bindTexture(t.TEXTURE_2D, e);
            try {
                if (t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, o), t.isContextLost()) return;
                s.supported = !0;
            } catch (t) {}
            t.deleteTexture(e), r = !0;
        }
        var h, c;
        "undefined" != typeof document && (o = document.createElement("img"), o.onload = function() {
            a && l(a), a = null, n = !0;
        }, o.onerror = function() {
            r = !0, a = null;
        }, o.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA="), function(e) {
            let i, a, o, r;
            e.resetRequestQueue = ()=>{
                i = [], a = 0, o = 0, r = {};
            }, e.addThrottleControl = (t)=>{
                const e = o++;
                return r[e] = t, e;
            }, e.removeThrottleControl = (t)=>{
                delete r[t], h();
            }, e.getImage = (t, e, o = !0)=>{
                s.supported && (t.headers || (t.headers = {}), t.headers.accept = "image/webp,*/*");
                const r = {
                    requestParameters: t,
                    supportImageRefresh: o,
                    callback: e,
                    cancelled: !1,
                    completed: !1,
                    cancel: ()=>{
                        r.completed || r.cancelled || (r.cancelled = !0, r.innerRequest && (r.innerRequest.cancel(), a--), h());
                    }
                };
                return i.push(r), h(), r;
            };
            const n = (e)=>{
                const { requestParameters: i, supportImageRefresh: s, callback: a } = e;
                return t.e(i, {
                    type: "image"
                }), (!1 !== s || t.i() || t.g(i.url) || i.headers && !Object.keys(i.headers).reduce((t, e)=>t && "accept" === e, !0) ? t.m : c)(i, (t, i, s, o)=>{
                    l(e, a, t, i, s, o);
                });
            }, l = (e, i, s, o, r, n)=>{
                s ? i(s) : o instanceof HTMLImageElement || t.a(o) ? i(null, o) : o && ((e, i)=>{
                    "function" == typeof createImageBitmap ? t.b(e, i) : t.d(e, i);
                })(o, (t, e)=>{
                    null != t ? i(t) : null != e && i(null, e, {
                        cacheControl: r,
                        expires: n
                    });
                }), e.cancelled || (e.completed = !0, a--, h());
            }, h = ()=>{
                const e = (()=>{
                    const t = Object.keys(r);
                    let e = !1;
                    if (t.length > 0) {
                        for (const i of t)if (e = r[i](), e) break;
                    }
                    return e;
                })() ? t.c.MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME : t.c.MAX_PARALLEL_IMAGE_REQUESTS;
                for(let t = a; t < e && i.length > 0; t++){
                    const e = i.shift();
                    if (e.cancelled) {
                        t--;
                        continue;
                    }
                    const s = n(e);
                    a++, e.innerRequest = s;
                }
            }, c = (e, i)=>{
                const s = new Image, a = e.url;
                let o = !1;
                const r = e.credentials;
                return r && "include" === r ? s.crossOrigin = "use-credentials" : (r && "same-origin" === r || !t.s(a)) && (s.crossOrigin = "anonymous"), s.fetchPriority = "high", s.onload = ()=>{
                    i(null, s), s.onerror = s.onload = null;
                }, s.onerror = ()=>{
                    o || i(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.")), s.onerror = s.onload = null;
                }, s.src = a, {
                    cancel: ()=>{
                        o = !0, s.src = "";
                    }
                };
            };
        }(h || (h = {})), h.resetRequestQueue(), function(t) {
            t.Glyphs = "Glyphs", t.Image = "Image", t.Source = "Source", t.SpriteImage = "SpriteImage", t.SpriteJSON = "SpriteJSON", t.Style = "Style", t.Tile = "Tile", t.Unknown = "Unknown";
        }(c || (c = {}));
        class u {
            constructor(t){
                this._transformRequestFn = t;
            }
            transformRequest(t, e) {
                return this._transformRequestFn && this._transformRequestFn(t, e) || {
                    url: t
                };
            }
            normalizeSpriteURL(t, e, i) {
                const s = function(t) {
                    const e = t.match(d);
                    if (!e) throw new Error(`Unable to parse URL "${t}"`);
                    return {
                        protocol: e[1],
                        authority: e[2],
                        path: e[3] || "/",
                        params: e[4] ? e[4].split("&") : []
                    };
                }(t);
                return s.path += `${e}${i}`, function(t) {
                    const e = t.params.length ? `?${t.params.join("&")}` : "";
                    return `${t.protocol}://${t.authority}${t.path}${e}`;
                }(s);
            }
            setTransformRequest(t) {
                this._transformRequestFn = t;
            }
        }
        const d = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
        function _(e) {
            var i = new t.A(3);
            return i[0] = e[0], i[1] = e[1], i[2] = e[2], i;
        }
        var p, m = function(t, e, i) {
            return t[0] = e[0] - i[0], t[1] = e[1] - i[1], t[2] = e[2] - i[2], t;
        };
        p = new t.A(3), t.A != Float32Array && (p[0] = 0, p[1] = 0, p[2] = 0);
        var f = function(t) {
            var e = t[0], i = t[1];
            return e * e + i * i;
        };
        function g(t) {
            const e = [];
            if ("string" == typeof t) e.push({
                id: "default",
                url: t
            });
            else if (t && t.length > 0) {
                const i = [];
                for (const { id: s, url: a } of t){
                    const t = `${s}${a}`;
                    -1 === i.indexOf(t) && (i.push(t), e.push({
                        id: s,
                        url: a
                    }));
                }
            }
            return e;
        }
        function v(e, i, s, a, o) {
            if (a) return void e(a);
            if (o !== Object.values(i).length || o !== Object.values(s).length) return;
            const r = {};
            for(const e in i){
                r[e] = {};
                const a = t.h.getImageCanvasContext(s[e]), o = i[e];
                for(const t in o){
                    const { width: i, height: s, x: n, y: l, sdf: h, pixelRatio: c, stretchX: u, stretchY: d, content: _ } = o[t];
                    r[e][t] = {
                        data: null,
                        pixelRatio: c,
                        sdf: h,
                        stretchX: u,
                        stretchY: d,
                        content: _,
                        spriteData: {
                            width: i,
                            height: s,
                            x: n,
                            y: l,
                            context: a
                        }
                    };
                }
            }
            e(null, r);
        }
        !function() {
            var e = new t.A(2);
            t.A != Float32Array && (e[0] = 0, e[1] = 0);
        }();
        class x {
            constructor(t, e, i, s){
                this.context = t, this.format = i, this.texture = t.gl.createTexture(), this.update(e, s);
            }
            update(e, i, s) {
                const { width: a, height: o } = e, r = !(this.size && this.size[0] === a && this.size[1] === o || s), { context: n } = this, { gl: l } = n;
                if (this.useMipmap = Boolean(i && i.useMipmap), l.bindTexture(l.TEXTURE_2D, this.texture), n.pixelStoreUnpackFlipY.set(!1), n.pixelStoreUnpack.set(1), n.pixelStoreUnpackPremultiplyAlpha.set(this.format === l.RGBA && (!i || !1 !== i.premultiply)), r) this.size = [
                    a,
                    o
                ], e instanceof HTMLImageElement || e instanceof HTMLCanvasElement || e instanceof HTMLVideoElement || e instanceof ImageData || t.a(e) ? l.texImage2D(l.TEXTURE_2D, 0, this.format, this.format, l.UNSIGNED_BYTE, e) : l.texImage2D(l.TEXTURE_2D, 0, this.format, a, o, 0, this.format, l.UNSIGNED_BYTE, e.data);
                else {
                    const { x: i, y: r } = s || {
                        x: 0,
                        y: 0
                    };
                    e instanceof HTMLImageElement || e instanceof HTMLCanvasElement || e instanceof HTMLVideoElement || e instanceof ImageData || t.a(e) ? l.texSubImage2D(l.TEXTURE_2D, 0, i, r, l.RGBA, l.UNSIGNED_BYTE, e) : l.texSubImage2D(l.TEXTURE_2D, 0, i, r, a, o, l.RGBA, l.UNSIGNED_BYTE, e.data);
                }
                this.useMipmap && this.isSizePowerOfTwo() && l.generateMipmap(l.TEXTURE_2D);
            }
            bind(t, e, i) {
                const { context: s } = this, { gl: a } = s;
                a.bindTexture(a.TEXTURE_2D, this.texture), i !== a.LINEAR_MIPMAP_NEAREST || this.isSizePowerOfTwo() || (i = a.LINEAR), t !== this.filter && (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MAG_FILTER, t), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MIN_FILTER, i || t), this.filter = t), e !== this.wrap && (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_S, e), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_T, e), this.wrap = e);
            }
            isSizePowerOfTwo() {
                return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 == 0;
            }
            destroy() {
                const { gl: t } = this.context;
                t.deleteTexture(this.texture), this.texture = null;
            }
        }
        function y(t) {
            const { userImage: e } = t;
            return !!(e && e.render && e.render()) && (t.data.replace(new Uint8Array(e.data.buffer)), !0);
        }
        class b extends t.E {
            constructor(){
                super(), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = !1, this.requestors = [], this.patterns = {}, this.atlasImage = new t.R({
                    width: 1,
                    height: 1
                }), this.dirty = !0;
            }
            isLoaded() {
                return this.loaded;
            }
            setLoaded(t) {
                if (this.loaded !== t && (this.loaded = t, t)) {
                    for (const { ids: t, callback: e } of this.requestors)this._notify(t, e);
                    this.requestors = [];
                }
            }
            getImage(e) {
                const i = this.images[e];
                if (i && !i.data && i.spriteData) {
                    const e = i.spriteData;
                    i.data = new t.R({
                        width: e.width,
                        height: e.height
                    }, e.context.getImageData(e.x, e.y, e.width, e.height).data), i.spriteData = null;
                }
                return i;
            }
            addImage(t, e) {
                if (this.images[t]) throw new Error(`Image id ${t} already exist, use updateImage instead`);
                this._validate(t, e) && (this.images[t] = e);
            }
            _validate(e, i) {
                let s = !0;
                const a = i.data || i.spriteData;
                return this._validateStretch(i.stretchX, a && a.width) || (this.fire(new t.j(new Error(`Image "${e}" has invalid "stretchX" value`))), s = !1), this._validateStretch(i.stretchY, a && a.height) || (this.fire(new t.j(new Error(`Image "${e}" has invalid "stretchY" value`))), s = !1), this._validateContent(i.content, i) || (this.fire(new t.j(new Error(`Image "${e}" has invalid "content" value`))), s = !1), s;
            }
            _validateStretch(t, e) {
                if (!t) return !0;
                let i = 0;
                for (const s of t){
                    if (s[0] < i || s[1] < s[0] || e < s[1]) return !1;
                    i = s[1];
                }
                return !0;
            }
            _validateContent(t, e) {
                if (!t) return !0;
                if (4 !== t.length) return !1;
                const i = e.spriteData, s = i && i.width || e.data.width, a = i && i.height || e.data.height;
                return !(t[0] < 0 || s < t[0] || t[1] < 0 || a < t[1] || t[2] < 0 || s < t[2] || t[3] < 0 || a < t[3] || t[2] < t[0] || t[3] < t[1]);
            }
            updateImage(t, e, i = !0) {
                const s = this.getImage(t);
                if (i && (s.data.width !== e.data.width || s.data.height !== e.data.height)) throw new Error(`size mismatch between old image (${s.data.width}x${s.data.height}) and new image (${e.data.width}x${e.data.height}).`);
                e.version = s.version + 1, this.images[t] = e, this.updatedImages[t] = !0;
            }
            removeImage(t) {
                const e = this.images[t];
                delete this.images[t], delete this.patterns[t], e.userImage && e.userImage.onRemove && e.userImage.onRemove();
            }
            listImages() {
                return Object.keys(this.images);
            }
            getImages(t, e) {
                let i = !0;
                if (!this.isLoaded()) for (const e of t)this.images[e] || (i = !1);
                this.isLoaded() || i ? this._notify(t, e) : this.requestors.push({
                    ids: t,
                    callback: e
                });
            }
            _notify(e, i) {
                const s = {};
                for (const i of e){
                    let e = this.getImage(i);
                    e || (this.fire(new t.k("styleimagemissing", {
                        id: i
                    })), e = this.getImage(i)), e ? s[i] = {
                        data: e.data.clone(),
                        pixelRatio: e.pixelRatio,
                        sdf: e.sdf,
                        version: e.version,
                        stretchX: e.stretchX,
                        stretchY: e.stretchY,
                        content: e.content,
                        hasRenderCallback: Boolean(e.userImage && e.userImage.render)
                    } : t.w(`Image "${i}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
                }
                i(null, s);
            }
            getPixelSize() {
                const { width: t, height: e } = this.atlasImage;
                return {
                    width: t,
                    height: e
                };
            }
            getPattern(e) {
                const i = this.patterns[e], s = this.getImage(e);
                if (!s) return null;
                if (i && i.position.version === s.version) return i.position;
                if (i) i.position.version = s.version;
                else {
                    const i = {
                        w: s.data.width + 2,
                        h: s.data.height + 2,
                        x: 0,
                        y: 0
                    }, a = new t.I(i, s);
                    this.patterns[e] = {
                        bin: i,
                        position: a
                    };
                }
                return this._updatePatternAtlas(), this.patterns[e].position;
            }
            bind(t) {
                const e = t.gl;
                this.atlasTexture ? this.dirty && (this.atlasTexture.update(this.atlasImage), this.dirty = !1) : this.atlasTexture = new x(t, this.atlasImage, e.RGBA), this.atlasTexture.bind(e.LINEAR, e.CLAMP_TO_EDGE);
            }
            _updatePatternAtlas() {
                const e = [];
                for(const t in this.patterns)e.push(this.patterns[t].bin);
                const { w: i, h: s } = t.p(e), a = this.atlasImage;
                a.resize({
                    width: i || 1,
                    height: s || 1
                });
                for(const e in this.patterns){
                    const { bin: i } = this.patterns[e], s = i.x + 1, o = i.y + 1, r = this.getImage(e).data, n = r.width, l = r.height;
                    t.R.copy(r, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: s,
                        y: o
                    }, {
                        width: n,
                        height: l
                    }), t.R.copy(r, a, {
                        x: 0,
                        y: l - 1
                    }, {
                        x: s,
                        y: o - 1
                    }, {
                        width: n,
                        height: 1
                    }), t.R.copy(r, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: s,
                        y: o + l
                    }, {
                        width: n,
                        height: 1
                    }), t.R.copy(r, a, {
                        x: n - 1,
                        y: 0
                    }, {
                        x: s - 1,
                        y: o
                    }, {
                        width: 1,
                        height: l
                    }), t.R.copy(r, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: s + n,
                        y: o
                    }, {
                        width: 1,
                        height: l
                    });
                }
                this.dirty = !0;
            }
            beginFrame() {
                this.callbackDispatchedThisFrame = {};
            }
            dispatchRenderCallbacks(e) {
                for (const i of e){
                    if (this.callbackDispatchedThisFrame[i]) continue;
                    this.callbackDispatchedThisFrame[i] = !0;
                    const e = this.getImage(i);
                    e || t.w(`Image with ID: "${i}" was not found`), y(e) && this.updateImage(i, e);
                }
            }
        }
        const w = 1e20;
        function T(t, e, i, s, a, o, r, n, l) {
            for(let h = e; h < e + s; h++)I(t, i * o + h, o, a, r, n, l);
            for(let h = i; h < i + a; h++)I(t, h * o + e, 1, s, r, n, l);
        }
        function I(t, e, i, s, a, o, r) {
            o[0] = 0, r[0] = -w, r[1] = w, a[0] = t[e];
            for(let n = 1, l = 0, h = 0; n < s; n++){
                a[n] = t[e + n * i];
                const s = n * n;
                do {
                    const t = o[l];
                    h = (a[n] - a[t] + s - t * t) / (n - t) / 2;
                }while (h <= r[l] && --l > -1);
                l++, o[l] = n, r[l] = h, r[l + 1] = w;
            }
            for(let n = 0, l = 0; n < s; n++){
                for(; r[l + 1] < n;)l++;
                const s = o[l], h = n - s;
                t[e + n * i] = a[s] + h * h;
            }
        }
        class E {
            constructor(t, e){
                this.requestManager = t, this.localIdeographFontFamily = e, this.entries = {};
            }
            setURL(t) {
                this.url = t;
            }
            getGlyphs(e, i) {
                const s = [];
                for(const t in e)for (const i of e[t])s.push({
                    stack: t,
                    id: i
                });
                t.o(s, ({ stack: t, id: e }, i)=>{
                    let s = this.entries[t];
                    s || (s = this.entries[t] = {
                        glyphs: {},
                        requests: {},
                        ranges: {}
                    });
                    let a = s.glyphs[e];
                    if (void 0 !== a) return void i(null, {
                        stack: t,
                        id: e,
                        glyph: a
                    });
                    if (a = this._tinySDF(s, t, e), a) return s.glyphs[e] = a, void i(null, {
                        stack: t,
                        id: e,
                        glyph: a
                    });
                    const o = Math.floor(e / 256);
                    if (256 * o > 65535) return void i(new Error("glyphs > 65535 not supported"));
                    if (s.ranges[o]) return void i(null, {
                        stack: t,
                        id: e,
                        glyph: a
                    });
                    if (!this.url) return void i(new Error("glyphsUrl is not set"));
                    let r = s.requests[o];
                    r || (r = s.requests[o] = [], E.loadGlyphRange(t, o, this.url, this.requestManager, (t, e)=>{
                        if (e) {
                            for(const t in e)this._doesCharSupportLocalGlyph(+t) || (s.glyphs[+t] = e[+t]);
                            s.ranges[o] = !0;
                        }
                        for (const i of r)i(t, e);
                        delete s.requests[o];
                    })), r.push((s, a)=>{
                        s ? i(s) : a && i(null, {
                            stack: t,
                            id: e,
                            glyph: a[e] || null
                        });
                    });
                }, (t, e)=>{
                    if (t) i(t);
                    else if (e) {
                        const t = {};
                        for (const { stack: i, id: s, glyph: a } of e)(t[i] || (t[i] = {}))[s] = a && {
                            id: a.id,
                            bitmap: a.bitmap.clone(),
                            metrics: a.metrics
                        };
                        i(null, t);
                    }
                });
            }
            _doesCharSupportLocalGlyph(e) {
                return !!this.localIdeographFontFamily && (t.u["CJK Unified Ideographs"](e) || t.u["Hangul Syllables"](e) || t.u.Hiragana(e) || t.u.Katakana(e));
            }
            _tinySDF(e, i, s) {
                const a = this.localIdeographFontFamily;
                if (!a) return;
                if (!this._doesCharSupportLocalGlyph(s)) return;
                let o = e.tinySDF;
                if (!o) {
                    let t = "400";
                    /bold/i.test(i) ? t = "900" : /medium/i.test(i) ? t = "500" : /light/i.test(i) && (t = "200"), o = e.tinySDF = new E.TinySDF({
                        fontSize: 48,
                        buffer: 6,
                        radius: 16,
                        cutoff: .25,
                        fontFamily: a,
                        fontWeight: t
                    });
                }
                const r = o.draw(String.fromCharCode(s));
                return {
                    id: s,
                    bitmap: new t.q({
                        width: r.width || 60,
                        height: r.height || 60
                    }, r.data),
                    metrics: {
                        width: r.glyphWidth / 2 || 24,
                        height: r.glyphHeight / 2 || 24,
                        left: r.glyphLeft / 2 + .5 || 0,
                        top: r.glyphTop / 2 - 27.5 || -8,
                        advance: r.glyphAdvance / 2 || 24,
                        isDoubleResolution: !0
                    }
                };
            }
        }
        E.loadGlyphRange = function(e, i, s, a, o) {
            const r = 256 * i, n = r + 255, l = a.transformRequest(s.replace("{fontstack}", e).replace("{range}", `${r}-${n}`), c.Glyphs);
            t.l(l, (e, i)=>{
                if (e) o(e);
                else if (i) {
                    const e = {};
                    for (const s of t.n(i))e[s.id] = s;
                    o(null, e);
                }
            });
        }, E.TinySDF = class {
            constructor({ fontSize: t = 24, buffer: e = 3, radius: i = 8, cutoff: s = .25, fontFamily: a = "sans-serif", fontWeight: o = "normal", fontStyle: r = "normal" } = {}){
                this.buffer = e, this.cutoff = s, this.radius = i;
                const n = this.size = t + 4 * e, l = this._createCanvas(n), h = this.ctx = l.getContext("2d", {
                    willReadFrequently: !0
                });
                h.font = `${r} ${o} ${t}px ${a}`, h.textBaseline = "alphabetic", h.textAlign = "left", h.fillStyle = "black", this.gridOuter = new Float64Array(n * n), this.gridInner = new Float64Array(n * n), this.f = new Float64Array(n), this.z = new Float64Array(n + 1), this.v = new Uint16Array(n);
            }
            _createCanvas(t) {
                const e = document.createElement("canvas");
                return e.width = e.height = t, e;
            }
            draw(t) {
                const { width: e, actualBoundingBoxAscent: i, actualBoundingBoxDescent: s, actualBoundingBoxLeft: a, actualBoundingBoxRight: o } = this.ctx.measureText(t), r = Math.ceil(i), n = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(o - a))), l = Math.min(this.size - this.buffer, r + Math.ceil(s)), h = n + 2 * this.buffer, c = l + 2 * this.buffer, u = Math.max(h * c, 0), d = new Uint8ClampedArray(u), _ = {
                    data: d,
                    width: h,
                    height: c,
                    glyphWidth: n,
                    glyphHeight: l,
                    glyphTop: r,
                    glyphLeft: 0,
                    glyphAdvance: e
                };
                if (0 === n || 0 === l) return _;
                const { ctx: p, buffer: m, gridInner: f, gridOuter: g } = this;
                p.clearRect(m, m, n, l), p.fillText(t, m, m + r);
                const v = p.getImageData(m, m, n, l);
                g.fill(w, 0, u), f.fill(0, 0, u);
                for(let t = 0; t < l; t++)for(let e = 0; e < n; e++){
                    const i = v.data[4 * (t * n + e) + 3] / 255;
                    if (0 === i) continue;
                    const s = (t + m) * h + e + m;
                    if (1 === i) g[s] = 0, f[s] = w;
                    else {
                        const t = .5 - i;
                        g[s] = t > 0 ? t * t : 0, f[s] = t < 0 ? t * t : 0;
                    }
                }
                T(g, 0, 0, h, c, h, this.f, this.v, this.z), T(f, m, m, n, l, h, this.f, this.v, this.z);
                for(let t = 0; t < u; t++){
                    const e = Math.sqrt(g[t]) - Math.sqrt(f[t]);
                    d[t] = Math.round(255 - 255 * (e / this.radius + this.cutoff));
                }
                return _;
            }
        };
        class S {
            constructor(){
                this.specification = t.v.light.position;
            }
            possiblyEvaluate(e, i) {
                return t.z(e.expression.evaluate(i));
            }
            interpolate(e, i, s) {
                return {
                    x: t.B.number(e.x, i.x, s),
                    y: t.B.number(e.y, i.y, s),
                    z: t.B.number(e.z, i.z, s)
                };
            }
        }
        let C;
        class P extends t.E {
            constructor(e){
                super(), C = C || new t.r({
                    anchor: new t.D(t.v.light.anchor),
                    position: new S,
                    color: new t.D(t.v.light.color),
                    intensity: new t.D(t.v.light.intensity)
                }), this._transitionable = new t.T(C), this.setLight(e), this._transitioning = this._transitionable.untransitioned();
            }
            getLight() {
                return this._transitionable.serialize();
            }
            setLight(e, i = {}) {
                if (!this._validate(t.t, e, i)) for(const t in e){
                    const i = e[t];
                    t.endsWith("-transition") ? this._transitionable.setTransition(t.slice(0, -11), i) : this._transitionable.setValue(t, i);
                }
            }
            updateTransitions(t) {
                this._transitioning = this._transitionable.transitioned(t, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(t) {
                this.properties = this._transitioning.possiblyEvaluate(t);
            }
            _validate(e, i, s) {
                return (!s || !1 !== s.validate) && t.x(this, e.call(t.y, t.e({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: t.v
                })));
            }
        }
        class D {
            constructor(t, e){
                this.width = t, this.height = e, this.nextRow = 0, this.data = new Uint8Array(this.width * this.height), this.dashEntry = {};
            }
            getDash(t, e) {
                const i = t.join(",") + String(e);
                return this.dashEntry[i] || (this.dashEntry[i] = this.addDash(t, e)), this.dashEntry[i];
            }
            getDashRanges(t, e, i) {
                const s = [];
                let a = t.length % 2 == 1 ? -t[t.length - 1] * i : 0, o = t[0] * i, r = !0;
                s.push({
                    left: a,
                    right: o,
                    isDash: r,
                    zeroLength: 0 === t[0]
                });
                let n = t[0];
                for(let e = 1; e < t.length; e++){
                    r = !r;
                    const l = t[e];
                    a = n * i, n += l, o = n * i, s.push({
                        left: a,
                        right: o,
                        isDash: r,
                        zeroLength: 0 === l
                    });
                }
                return s;
            }
            addRoundDash(t, e, i) {
                const s = e / 2;
                for(let e = -i; e <= i; e++){
                    const a = this.width * (this.nextRow + i + e);
                    let o = 0, r = t[o];
                    for(let n = 0; n < this.width; n++){
                        n / r.right > 1 && (r = t[++o]);
                        const l = Math.abs(n - r.left), h = Math.abs(n - r.right), c = Math.min(l, h);
                        let u;
                        const d = e / i * (s + 1);
                        if (r.isDash) {
                            const t = s - Math.abs(d);
                            u = Math.sqrt(c * c + t * t);
                        } else u = s - Math.sqrt(c * c + d * d);
                        this.data[a + n] = Math.max(0, Math.min(255, u + 128));
                    }
                }
            }
            addRegularDash(t) {
                for(let e = t.length - 1; e >= 0; --e){
                    const i = t[e], s = t[e + 1];
                    i.zeroLength ? t.splice(e, 1) : s && s.isDash === i.isDash && (s.left = i.left, t.splice(e, 1));
                }
                const e = t[0], i = t[t.length - 1];
                e.isDash === i.isDash && (e.left = i.left - this.width, i.right = e.right + this.width);
                const s = this.width * this.nextRow;
                let a = 0, o = t[a];
                for(let e = 0; e < this.width; e++){
                    e / o.right > 1 && (o = t[++a]);
                    const i = Math.abs(e - o.left), r = Math.abs(e - o.right), n = Math.min(i, r);
                    this.data[s + e] = Math.max(0, Math.min(255, (o.isDash ? n : -n) + 128));
                }
            }
            addDash(e, i) {
                const s = i ? 7 : 0, a = 2 * s + 1;
                if (this.nextRow + a > this.height) return t.w("LineAtlas out of space"), null;
                let o = 0;
                for(let t = 0; t < e.length; t++)o += e[t];
                if (0 !== o) {
                    const t = this.width / o, a = this.getDashRanges(e, this.width, t);
                    i ? this.addRoundDash(a, t, s) : this.addRegularDash(a);
                }
                const r = {
                    y: (this.nextRow + s + .5) / this.height,
                    height: 2 * s / this.height,
                    width: o
                };
                return this.nextRow += a, this.dirty = !0, r;
            }
            bind(t) {
                const e = t.gl;
                this.texture ? (e.bindTexture(e.TEXTURE_2D, this.texture), this.dirty && (this.dirty = !1, e.texSubImage2D(e.TEXTURE_2D, 0, 0, 0, this.width, this.height, e.ALPHA, e.UNSIGNED_BYTE, this.data))) : (this.texture = e.createTexture(), e.bindTexture(e.TEXTURE_2D, this.texture), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.REPEAT), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.REPEAT), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.LINEAR), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.LINEAR), e.texImage2D(e.TEXTURE_2D, 0, e.ALPHA, this.width, this.height, 0, e.ALPHA, e.UNSIGNED_BYTE, this.data));
            }
        }
        class M {
            constructor(e, i, s){
                this.workerPool = e, this.actors = [], this.currentActor = 0, this.id = s;
                const a = this.workerPool.acquire(s);
                for(let e = 0; e < a.length; e++){
                    const o = new t.C(a[e], i, s);
                    o.name = `Worker ${e}`, this.actors.push(o);
                }
                if (!this.actors.length) throw new Error("No actors found");
            }
            broadcast(e, i, s) {
                t.o(this.actors, (t, s)=>{
                    t.send(e, i, s);
                }, s = s || function() {});
            }
            getActor() {
                return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
            }
            remove(t = !0) {
                this.actors.forEach((t)=>{
                    t.remove();
                }), this.actors = [], t && this.workerPool.release(this.id);
            }
        }
        function z(e, i, s) {
            const a = function(i, a) {
                if (i) return s(i);
                if (a) {
                    const i = t.F(t.e(a, e), [
                        "tiles",
                        "minzoom",
                        "maxzoom",
                        "attribution",
                        "bounds",
                        "scheme",
                        "tileSize",
                        "encoding"
                    ]);
                    a.vector_layers && (i.vectorLayers = a.vector_layers, i.vectorLayerIds = i.vectorLayers.map((t)=>t.id)), s(null, i);
                }
            };
            return e.url ? t.f(i.transformRequest(e.url, c.Source), a) : t.h.frame(()=>a(null, e));
        }
        class L {
            constructor(t, e){
                t && (e ? this.setSouthWest(t).setNorthEast(e) : Array.isArray(t) && (4 === t.length ? this.setSouthWest([
                    t[0],
                    t[1]
                ]).setNorthEast([
                    t[2],
                    t[3]
                ]) : this.setSouthWest(t[0]).setNorthEast(t[1])));
            }
            setNorthEast(e) {
                return this._ne = e instanceof t.L ? new t.L(e.lng, e.lat) : t.L.convert(e), this;
            }
            setSouthWest(e) {
                return this._sw = e instanceof t.L ? new t.L(e.lng, e.lat) : t.L.convert(e), this;
            }
            extend(e) {
                const i = this._sw, s = this._ne;
                let a, o;
                if (e instanceof t.L) a = e, o = e;
                else {
                    if (!(e instanceof L)) return Array.isArray(e) ? 4 === e.length || e.every(Array.isArray) ? this.extend(L.convert(e)) : this.extend(t.L.convert(e)) : e && ("lng" in e || "lon" in e) && "lat" in e ? this.extend(t.L.convert(e)) : this;
                    if (a = e._sw, o = e._ne, !a || !o) return this;
                }
                return i || s ? (i.lng = Math.min(a.lng, i.lng), i.lat = Math.min(a.lat, i.lat), s.lng = Math.max(o.lng, s.lng), s.lat = Math.max(o.lat, s.lat)) : (this._sw = new t.L(a.lng, a.lat), this._ne = new t.L(o.lng, o.lat)), this;
            }
            getCenter() {
                return new t.L((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
            }
            getSouthWest() {
                return this._sw;
            }
            getNorthEast() {
                return this._ne;
            }
            getNorthWest() {
                return new t.L(this.getWest(), this.getNorth());
            }
            getSouthEast() {
                return new t.L(this.getEast(), this.getSouth());
            }
            getWest() {
                return this._sw.lng;
            }
            getSouth() {
                return this._sw.lat;
            }
            getEast() {
                return this._ne.lng;
            }
            getNorth() {
                return this._ne.lat;
            }
            toArray() {
                return [
                    this._sw.toArray(),
                    this._ne.toArray()
                ];
            }
            toString() {
                return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
            }
            isEmpty() {
                return !(this._sw && this._ne);
            }
            contains(e) {
                const { lng: i, lat: s } = t.L.convert(e);
                let a = this._sw.lng <= i && i <= this._ne.lng;
                return this._sw.lng > this._ne.lng && (a = this._sw.lng >= i && i >= this._ne.lng), this._sw.lat <= s && s <= this._ne.lat && a;
            }
            static convert(t) {
                return t instanceof L ? t : t ? new L(t) : t;
            }
            static fromLngLat(e, i = 0) {
                const s = 360 * i / 40075017, a = s / Math.cos(Math.PI / 180 * e.lat);
                return new L(new t.L(e.lng - a, e.lat - s), new t.L(e.lng + a, e.lat + s));
            }
        }
        class A {
            constructor(t, e, i){
                this.bounds = L.convert(this.validateBounds(t)), this.minzoom = e || 0, this.maxzoom = i || 24;
            }
            validateBounds(t) {
                return Array.isArray(t) && 4 === t.length ? [
                    Math.max(-180, t[0]),
                    Math.max(-90, t[1]),
                    Math.min(180, t[2]),
                    Math.min(90, t[3])
                ] : [
                    -180,
                    -90,
                    180,
                    90
                ];
            }
            contains(e) {
                const i = Math.pow(2, e.z), s = Math.floor(t.G(this.bounds.getWest()) * i), a = Math.floor(t.H(this.bounds.getNorth()) * i), o = Math.ceil(t.G(this.bounds.getEast()) * i), r = Math.ceil(t.H(this.bounds.getSouth()) * i);
                return e.x >= s && e.x < o && e.y >= a && e.y < r;
            }
        }
        class R extends t.E {
            constructor(e, i, s, a){
                if (super(), this.load = ()=>{
                    this._loaded = !1, this.fire(new t.k("dataloading", {
                        dataType: "source"
                    })), this._tileJSONRequest = z(this._options, this.map._requestManager, (e, i)=>{
                        this._tileJSONRequest = null, this._loaded = !0, this.map.style.sourceCaches[this.id].clearTiles(), e ? this.fire(new t.j(e)) : i && (t.e(this, i), i.bounds && (this.tileBounds = new A(i.bounds, this.minzoom, this.maxzoom)), this.fire(new t.k("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        })), this.fire(new t.k("data", {
                            dataType: "source",
                            sourceDataType: "content"
                        })));
                    });
                }, this.serialize = ()=>t.e({}, this._options), this.id = e, this.dispatcher = s, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, t.e(this, t.F(i, [
                    "url",
                    "scheme",
                    "tileSize",
                    "promoteId"
                ])), this._options = t.e({
                    type: "vector"
                }, i), this._collectResourceTiming = i.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
                this.setEventedParent(a);
            }
            loaded() {
                return this._loaded;
            }
            hasTile(t) {
                return !this.tileBounds || this.tileBounds.contains(t.canonical);
            }
            onAdd(t) {
                this.map = t, this.load();
            }
            setSourceProperty(t) {
                this._tileJSONRequest && this._tileJSONRequest.cancel(), t(), this.load();
            }
            setTiles(t) {
                return this.setSourceProperty(()=>{
                    this._options.tiles = t;
                }), this;
            }
            setUrl(t) {
                return this.setSourceProperty(()=>{
                    this.url = t, this._options.url = t;
                }), this;
            }
            onRemove() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
            loadTile(t, e) {
                const i = t.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), s = {
                    request: this.map._requestManager.transformRequest(i, c.Tile),
                    uid: t.uid,
                    tileID: t.tileID,
                    zoom: t.tileID.overscaledZ,
                    tileSize: this.tileSize * t.tileID.overscaleFactor(),
                    type: this.type,
                    source: this.id,
                    pixelRatio: this.map.getPixelRatio(),
                    showCollisionBoxes: this.map.showCollisionBoxes,
                    promoteId: this.promoteId
                };
                function a(i, s) {
                    return delete t.request, t.aborted ? e(null) : i && 404 !== i.status ? e(i) : (s && s.resourceTiming && (t.resourceTiming = s.resourceTiming), this.map._refreshExpiredTiles && s && t.setExpiryData(s), t.loadVectorData(s, this.map.painter), e(null), void (t.reloadCallback && (this.loadTile(t, t.reloadCallback), t.reloadCallback = null)));
                }
                s.request.collectResourceTiming = this._collectResourceTiming, t.actor && "expired" !== t.state ? "loading" === t.state ? t.reloadCallback = e : t.request = t.actor.send("reloadTile", s, a.bind(this)) : (t.actor = this.dispatcher.getActor(), t.request = t.actor.send("loadTile", s, a.bind(this)));
            }
            abortTile(t) {
                t.request && (t.request.cancel(), delete t.request), t.actor && t.actor.send("abortTile", {
                    uid: t.uid,
                    type: this.type,
                    source: this.id
                }, void 0);
            }
            unloadTile(t) {
                t.unloadVectorData(), t.actor && t.actor.send("removeTile", {
                    uid: t.uid,
                    type: this.type,
                    source: this.id
                }, void 0);
            }
            hasTransition() {
                return !1;
            }
        }
        class k extends t.E {
            constructor(e, i, s, a){
                super(), this.id = e, this.dispatcher = s, this.setEventedParent(a), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = t.e({
                    type: "raster"
                }, i), t.e(this, t.F(i, [
                    "url",
                    "scheme",
                    "tileSize"
                ]));
            }
            load() {
                this._loaded = !1, this.fire(new t.k("dataloading", {
                    dataType: "source"
                })), this._tileJSONRequest = z(this._options, this.map._requestManager, (e, i)=>{
                    this._tileJSONRequest = null, this._loaded = !0, e ? this.fire(new t.j(e)) : i && (t.e(this, i), i.bounds && (this.tileBounds = new A(i.bounds, this.minzoom, this.maxzoom)), this.fire(new t.k("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new t.k("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    })));
                });
            }
            loaded() {
                return this._loaded;
            }
            onAdd(t) {
                this.map = t, this.load();
            }
            onRemove() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
            setSourceProperty(t) {
                this._tileJSONRequest && this._tileJSONRequest.cancel(), t(), this.load();
            }
            setTiles(t) {
                return this.setSourceProperty(()=>{
                    this._options.tiles = t;
                }), this;
            }
            serialize() {
                return t.e({}, this._options);
            }
            hasTile(t) {
                return !this.tileBounds || this.tileBounds.contains(t.canonical);
            }
            loadTile(t, e) {
                const i = t.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme);
                t.request = h.getImage(this.map._requestManager.transformRequest(i, c.Tile), (i, s, a)=>{
                    if (delete t.request, t.aborted) t.state = "unloaded", e(null);
                    else if (i) t.state = "errored", e(i);
                    else if (s) {
                        this.map._refreshExpiredTiles && a && t.setExpiryData(a);
                        const i = this.map.painter.context, o = i.gl;
                        t.texture = this.map.painter.getTileTexture(s.width), t.texture ? t.texture.update(s, {
                            useMipmap: !0
                        }) : (t.texture = new x(i, s, o.RGBA, {
                            useMipmap: !0
                        }), t.texture.bind(o.LINEAR, o.CLAMP_TO_EDGE, o.LINEAR_MIPMAP_NEAREST), i.extTextureFilterAnisotropic && o.texParameterf(o.TEXTURE_2D, i.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, i.extTextureFilterAnisotropicMax)), t.state = "loaded", e(null);
                    }
                }, this.map._refreshExpiredTiles);
            }
            abortTile(t, e) {
                t.request && (t.request.cancel(), delete t.request), e();
            }
            unloadTile(t, e) {
                t.texture && this.map.painter.saveTileTexture(t.texture), e();
            }
            hasTransition() {
                return !1;
            }
        }
        class F extends k {
            constructor(e, i, s, a){
                super(e, i, s, a), this.type = "raster-dem", this.maxzoom = 22, this._options = t.e({
                    type: "raster-dem"
                }, i), this.encoding = i.encoding || "mapbox", this.redFactor = i.redFactor, this.greenFactor = i.greenFactor, this.blueFactor = i.blueFactor, this.baseShift = i.baseShift;
            }
            loadTile(e, i) {
                const s = e.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), a = this.map._requestManager.transformRequest(s, c.Tile);
                function o(t, s) {
                    t && (e.state = "errored", i(t)), s && (e.dem = s, e.needsHillshadePrepare = !0, e.needsTerrainPrepare = !0, e.state = "loaded", i(null));
                }
                e.neighboringTiles = this._getNeighboringTiles(e.tileID), e.request = h.getImage(a, (s, a, r)=>t._(this, void 0, void 0, function*() {
                        if (delete e.request, e.aborted) e.state = "unloaded", i(null);
                        else if (s) e.state = "errored", i(s);
                        else if (a) {
                            this.map._refreshExpiredTiles && e.setExpiryData(r);
                            const i = t.a(a) && t.J() ? a : yield function(e) {
                                return t._(this, void 0, void 0, function*() {
                                    if ("undefined" != typeof VideoFrame && t.K()) {
                                        const i = e.width + 2, s = e.height + 2;
                                        try {
                                            return new t.R({
                                                width: i,
                                                height: s
                                            }, (yield t.M(e, -1, -1, i, s)));
                                        } catch (t) {}
                                    }
                                    return t.h.getImageData(e, 1);
                                });
                            }(a), s = {
                                uid: e.uid,
                                coord: e.tileID,
                                source: this.id,
                                rawImageData: i,
                                encoding: this.encoding,
                                redFactor: this.redFactor,
                                greenFactor: this.greenFactor,
                                blueFactor: this.blueFactor,
                                baseShift: this.baseShift
                            };
                            e.actor && "expired" !== e.state || (e.actor = this.dispatcher.getActor(), e.actor.send("loadDEMTile", s, o));
                        }
                    }), this.map._refreshExpiredTiles);
            }
            _getNeighboringTiles(e) {
                const i = e.canonical, s = Math.pow(2, i.z), a = (i.x - 1 + s) % s, o = 0 === i.x ? e.wrap - 1 : e.wrap, r = (i.x + 1 + s) % s, n = i.x + 1 === s ? e.wrap + 1 : e.wrap, l = {};
                return l[new t.O(e.overscaledZ, o, i.z, a, i.y).key] = {
                    backfilled: !1
                }, l[new t.O(e.overscaledZ, n, i.z, r, i.y).key] = {
                    backfilled: !1
                }, i.y > 0 && (l[new t.O(e.overscaledZ, o, i.z, a, i.y - 1).key] = {
                    backfilled: !1
                }, l[new t.O(e.overscaledZ, e.wrap, i.z, i.x, i.y - 1).key] = {
                    backfilled: !1
                }, l[new t.O(e.overscaledZ, n, i.z, r, i.y - 1).key] = {
                    backfilled: !1
                }), i.y + 1 < s && (l[new t.O(e.overscaledZ, o, i.z, a, i.y + 1).key] = {
                    backfilled: !1
                }, l[new t.O(e.overscaledZ, e.wrap, i.z, i.x, i.y + 1).key] = {
                    backfilled: !1
                }, l[new t.O(e.overscaledZ, n, i.z, r, i.y + 1).key] = {
                    backfilled: !1
                }), l;
            }
            unloadTile(t) {
                t.demTexture && this.map.painter.saveTileTexture(t.demTexture), t.fbo && (t.fbo.destroy(), delete t.fbo), t.dem && delete t.dem, delete t.neighboringTiles, t.state = "unloaded", t.actor && t.actor.send("removeDEMTile", {
                    uid: t.uid,
                    source: this.id
                });
            }
        }
        class B extends t.E {
            constructor(e, i, s, a){
                super(), this.load = ()=>{
                    this._updateWorkerData();
                }, this.serialize = ()=>t.e({}, this._options, {
                        type: this.type,
                        data: this._data
                    }), this.id = e, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._removed = !1, this._pendingLoads = 0, this.actor = s.getActor(), this.setEventedParent(a), this._data = i.data, this._options = t.e({}, i), this._collectResourceTiming = i.collectResourceTiming, void 0 !== i.maxzoom && (this.maxzoom = i.maxzoom), i.type && (this.type = i.type), i.attribution && (this.attribution = i.attribution), this.promoteId = i.promoteId;
                const o = t.N / this.tileSize;
                this.workerOptions = t.e({
                    source: this.id,
                    cluster: i.cluster || !1,
                    geojsonVtOptions: {
                        buffer: (void 0 !== i.buffer ? i.buffer : 128) * o,
                        tolerance: (void 0 !== i.tolerance ? i.tolerance : .375) * o,
                        extent: t.N,
                        maxZoom: this.maxzoom,
                        lineMetrics: i.lineMetrics || !1,
                        generateId: i.generateId || !1
                    },
                    superclusterOptions: {
                        maxZoom: void 0 !== i.clusterMaxZoom ? i.clusterMaxZoom : this.maxzoom - 1,
                        minPoints: Math.max(2, i.clusterMinPoints || 2),
                        extent: t.N,
                        radius: (i.clusterRadius || 50) * o,
                        log: !1,
                        generateId: i.generateId || !1
                    },
                    clusterProperties: i.clusterProperties,
                    filter: i.filter
                }, i.workerOptions), "string" == typeof this.promoteId && (this.workerOptions.promoteId = this.promoteId);
            }
            onAdd(t) {
                this.map = t, this.load();
            }
            setData(t) {
                return this._data = t, this._updateWorkerData(), this;
            }
            updateData(t) {
                return this._updateWorkerData(t), this;
            }
            setClusterOptions(t) {
                return this.workerOptions.cluster = t.cluster, t && (void 0 !== t.clusterRadius && (this.workerOptions.superclusterOptions.radius = t.clusterRadius), void 0 !== t.clusterMaxZoom && (this.workerOptions.superclusterOptions.maxZoom = t.clusterMaxZoom)), this._updateWorkerData(), this;
            }
            getClusterExpansionZoom(t, e) {
                return this.actor.send("geojson.getClusterExpansionZoom", {
                    clusterId: t,
                    source: this.id
                }, e), this;
            }
            getClusterChildren(t, e) {
                return this.actor.send("geojson.getClusterChildren", {
                    clusterId: t,
                    source: this.id
                }, e), this;
            }
            getClusterLeaves(t, e, i, s) {
                return this.actor.send("geojson.getClusterLeaves", {
                    source: this.id,
                    clusterId: t,
                    limit: e,
                    offset: i
                }, s), this;
            }
            _updateWorkerData(e) {
                const i = t.e({}, this.workerOptions);
                e ? i.dataDiff = e : "string" == typeof this._data ? (i.request = this.map._requestManager.transformRequest(t.h.resolveURL(this._data), c.Source), i.request.collectResourceTiming = this._collectResourceTiming) : i.data = JSON.stringify(this._data), this._pendingLoads++, this.fire(new t.k("dataloading", {
                    dataType: "source"
                })), this.actor.send(`${this.type}.loadData`, i, (e, i)=>{
                    if (this._pendingLoads--, this._removed || i && i.abandoned) return void this.fire(new t.k("dataabort", {
                        dataType: "source"
                    }));
                    let s = null;
                    if (i && i.resourceTiming && i.resourceTiming[this.id] && (s = i.resourceTiming[this.id].slice(0)), e) return void this.fire(new t.j(e));
                    const a = {
                        dataType: "source"
                    };
                    this._collectResourceTiming && s && s.length > 0 && t.e(a, {
                        resourceTiming: s
                    }), this.fire(new t.k("data", Object.assign(Object.assign({}, a), {
                        sourceDataType: "metadata"
                    }))), this.fire(new t.k("data", Object.assign(Object.assign({}, a), {
                        sourceDataType: "content"
                    })));
                });
            }
            loaded() {
                return 0 === this._pendingLoads;
            }
            loadTile(t, e) {
                const i = t.actor ? "reloadTile" : "loadTile";
                t.actor = this.actor;
                const s = {
                    type: this.type,
                    uid: t.uid,
                    tileID: t.tileID,
                    zoom: t.tileID.overscaledZ,
                    maxZoom: this.maxzoom,
                    tileSize: this.tileSize,
                    source: this.id,
                    pixelRatio: this.map.getPixelRatio(),
                    showCollisionBoxes: this.map.showCollisionBoxes,
                    promoteId: this.promoteId
                };
                t.request = this.actor.send(i, s, (s, a)=>(delete t.request, t.unloadVectorData(), t.aborted ? e(null) : s ? e(s) : (t.loadVectorData(a, this.map.painter, "reloadTile" === i), e(null))));
            }
            abortTile(t) {
                t.request && (t.request.cancel(), delete t.request), t.aborted = !0;
            }
            unloadTile(t) {
                t.unloadVectorData(), this.actor.send("removeTile", {
                    uid: t.uid,
                    type: this.type,
                    source: this.id
                });
            }
            onRemove() {
                this._removed = !0, this.actor.send("removeSource", {
                    type: this.type,
                    source: this.id
                });
            }
            hasTransition() {
                return !1;
            }
        }
        var O = t.Q([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            },
            {
                name: "a_texture_pos",
                type: "Int16",
                components: 2
            }
        ]);
        class N extends t.E {
            constructor(e, i, s, a){
                super(), this.load = (e, i)=>{
                    this._loaded = !1, this.fire(new t.k("dataloading", {
                        dataType: "source"
                    })), this.url = this.options.url, this._request = h.getImage(this.map._requestManager.transformRequest(this.url, c.Image), (s, a)=>{
                        this._request = null, this._loaded = !0, s ? this.fire(new t.j(s)) : a && (this.image = a, e && (this.coordinates = e), i && i(), this._finishLoading());
                    });
                }, this.prepare = ()=>{
                    if (0 === Object.keys(this.tiles).length || !this.image) return;
                    const e = this.map.painter.context, i = e.gl;
                    this.boundsBuffer || (this.boundsBuffer = e.createVertexBuffer(this._boundsArray, O.members)), this.boundsSegments || (this.boundsSegments = t.S.simpleSegment(0, 0, 4, 2)), this.texture || (this.texture = new x(e, this.image, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE));
                    let s = !1;
                    for(const t in this.tiles){
                        const e = this.tiles[t];
                        "loaded" !== e.state && (e.state = "loaded", e.texture = this.texture, s = !0);
                    }
                    s && this.fire(new t.k("data", {
                        dataType: "source",
                        sourceDataType: "idle",
                        sourceId: this.id
                    }));
                }, this.serialize = ()=>({
                        type: "image",
                        url: this.options.url,
                        coordinates: this.coordinates
                    }), this.id = e, this.dispatcher = s, this.coordinates = i.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.setEventedParent(a), this.options = i;
            }
            loaded() {
                return this._loaded;
            }
            updateImage(t) {
                return t.url ? (this._request && (this._request.cancel(), this._request = null), this.options.url = t.url, this.load(t.coordinates, ()=>{
                    this.texture = null;
                }), this) : this;
            }
            _finishLoading() {
                this.map && (this.setCoordinates(this.coordinates), this.fire(new t.k("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                })));
            }
            onAdd(t) {
                this.map = t, this.load();
            }
            onRemove() {
                this._request && (this._request.cancel(), this._request = null);
            }
            setCoordinates(e) {
                this.coordinates = e;
                const i = e.map(t.U.fromLngLat);
                this.tileID = function(e) {
                    let i = 1 / 0, s = 1 / 0, a = -1 / 0, o = -1 / 0;
                    for (const t of e)i = Math.min(i, t.x), s = Math.min(s, t.y), a = Math.max(a, t.x), o = Math.max(o, t.y);
                    const r = Math.max(a - i, o - s), n = Math.max(0, Math.floor(-Math.log(r) / Math.LN2)), l = Math.pow(2, n);
                    return new t.W(n, Math.floor((i + a) / 2 * l), Math.floor((s + o) / 2 * l));
                }(i), this.minzoom = this.maxzoom = this.tileID.z;
                const s = i.map((t)=>this.tileID.getTilePoint(t)._round());
                return this._boundsArray = new t.V, this._boundsArray.emplaceBack(s[0].x, s[0].y, 0, 0), this._boundsArray.emplaceBack(s[1].x, s[1].y, t.N, 0), this._boundsArray.emplaceBack(s[3].x, s[3].y, 0, t.N), this._boundsArray.emplaceBack(s[2].x, s[2].y, t.N, t.N), this.boundsBuffer && (this.boundsBuffer.destroy(), delete this.boundsBuffer), this.fire(new t.k("data", {
                    dataType: "source",
                    sourceDataType: "content"
                })), this;
            }
            loadTile(t, e) {
                this.tileID && this.tileID.equals(t.tileID.canonical) ? (this.tiles[String(t.tileID.wrap)] = t, t.buckets = {}, e(null)) : (t.state = "errored", e(null));
            }
            hasTransition() {
                return !1;
            }
        }
        class U extends N {
            constructor(e, i, s, a){
                super(e, i, s, a), this.load = ()=>{
                    this._loaded = !1;
                    const e = this.options;
                    this.urls = [];
                    for (const t of e.urls)this.urls.push(this.map._requestManager.transformRequest(t, c.Source).url);
                    t.X(this.urls, (e, i)=>{
                        this._loaded = !0, e ? this.fire(new t.j(e)) : i && (this.video = i, this.video.loop = !0, this.video.addEventListener("playing", ()=>{
                            this.map.triggerRepaint();
                        }), this.map && this.video.play(), this._finishLoading());
                    });
                }, this.prepare = ()=>{
                    if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
                    const e = this.map.painter.context, i = e.gl;
                    this.boundsBuffer || (this.boundsBuffer = e.createVertexBuffer(this._boundsArray, O.members)), this.boundsSegments || (this.boundsSegments = t.S.simpleSegment(0, 0, 4, 2)), this.texture ? this.video.paused || (this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), i.texSubImage2D(i.TEXTURE_2D, 0, 0, 0, i.RGBA, i.UNSIGNED_BYTE, this.video)) : (this.texture = new x(e, this.video, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE));
                    let s = !1;
                    for(const t in this.tiles){
                        const e = this.tiles[t];
                        "loaded" !== e.state && (e.state = "loaded", e.texture = this.texture, s = !0);
                    }
                    s && this.fire(new t.k("data", {
                        dataType: "source",
                        sourceDataType: "idle",
                        sourceId: this.id
                    }));
                }, this.serialize = ()=>({
                        type: "video",
                        urls: this.urls,
                        coordinates: this.coordinates
                    }), this.roundZoom = !0, this.type = "video", this.options = i;
            }
            pause() {
                this.video && this.video.pause();
            }
            play() {
                this.video && this.video.play();
            }
            seek(e) {
                if (this.video) {
                    const i = this.video.seekable;
                    e < i.start(0) || e > i.end(0) ? this.fire(new t.j(new t.Y(`sources.${this.id}`, null, `Playback for this video can be set only between the ${i.start(0)} and ${i.end(0)}-second mark.`))) : this.video.currentTime = e;
                }
            }
            getVideo() {
                return this.video;
            }
            onAdd(t) {
                this.map || (this.map = t, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
            }
            hasTransition() {
                return this.video && !this.video.paused;
            }
        }
        class Z extends N {
            constructor(e, i, s, a){
                super(e, i, s, a), this.load = ()=>{
                    this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new t.j(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                        this._playing = !0, this.map.triggerRepaint();
                    }, this.pause = function() {
                        this._playing && (this.prepare(), this._playing = !1);
                    }, this._finishLoading());
                }, this.prepare = ()=>{
                    let e = !1;
                    if (this.canvas.width !== this.width && (this.width = this.canvas.width, e = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, e = !0), this._hasInvalidDimensions()) return;
                    if (0 === Object.keys(this.tiles).length) return;
                    const i = this.map.painter.context, s = i.gl;
                    this.boundsBuffer || (this.boundsBuffer = i.createVertexBuffer(this._boundsArray, O.members)), this.boundsSegments || (this.boundsSegments = t.S.simpleSegment(0, 0, 4, 2)), this.texture ? (e || this._playing) && this.texture.update(this.canvas, {
                        premultiply: !0
                    }) : this.texture = new x(i, this.canvas, s.RGBA, {
                        premultiply: !0
                    });
                    let a = !1;
                    for(const t in this.tiles){
                        const e = this.tiles[t];
                        "loaded" !== e.state && (e.state = "loaded", e.texture = this.texture, a = !0);
                    }
                    a && this.fire(new t.k("data", {
                        dataType: "source",
                        sourceDataType: "idle",
                        sourceId: this.id
                    }));
                }, this.serialize = ()=>({
                        type: "canvas",
                        coordinates: this.coordinates
                    }), i.coordinates ? Array.isArray(i.coordinates) && 4 === i.coordinates.length && !i.coordinates.some((t)=>!Array.isArray(t) || 2 !== t.length || t.some((t)=>"number" != typeof t)) || this.fire(new t.j(new t.Y(`sources.${e}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new t.j(new t.Y(`sources.${e}`, null, 'missing required property "coordinates"'))), i.animate && "boolean" != typeof i.animate && this.fire(new t.j(new t.Y(`sources.${e}`, null, 'optional "animate" property must be a boolean value'))), i.canvas ? "string" == typeof i.canvas || i.canvas instanceof HTMLCanvasElement || this.fire(new t.j(new t.Y(`sources.${e}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new t.j(new t.Y(`sources.${e}`, null, 'missing required property "canvas"'))), this.options = i, this.animate = void 0 === i.animate || i.animate;
            }
            getCanvas() {
                return this.canvas;
            }
            onAdd(t) {
                this.map = t, this.load(), this.canvas && this.animate && this.play();
            }
            onRemove() {
                this.pause();
            }
            hasTransition() {
                return this._playing;
            }
            _hasInvalidDimensions() {
                for (const t of [
                    this.canvas.width,
                    this.canvas.height
                ])if (isNaN(t) || t <= 0) return !0;
                return !1;
            }
        }
        const G = {}, j = (t)=>{
            switch(t){
                case "geojson":
                    return B;
                case "image":
                    return N;
                case "raster":
                    return k;
                case "raster-dem":
                    return F;
                case "vector":
                    return R;
                case "video":
                    return U;
                case "canvas":
                    return Z;
            }
            return G[t];
        };
        function V(e, i) {
            const s = t.Z();
            return t.$(s, s, [
                1,
                1,
                0
            ]), t.a0(s, s, [
                .5 * e.width,
                .5 * e.height,
                1
            ]), t.a1(s, s, e.calculatePosMatrix(i.toUnwrapped()));
        }
        function q(t, e, i, s, a, o) {
            const r = function(t, e, i) {
                if (t) for (const s of t){
                    const t = e[s];
                    if (t && t.source === i && "fill-extrusion" === t.type) return !0;
                }
                else for(const t in e){
                    const s = e[t];
                    if (s.source === i && "fill-extrusion" === s.type) return !0;
                }
                return !1;
            }(a && a.layers, e, t.id), n = o.maxPitchScaleFactor(), l = t.tilesIn(s, n, r);
            l.sort($);
            const h = [];
            for (const s of l)h.push({
                wrappedTileID: s.tileID.wrapped().key,
                queryResults: s.tile.queryRenderedFeatures(e, i, t._state, s.queryGeometry, s.cameraQueryGeometry, s.scale, a, o, n, V(t.transform, s.tileID))
            });
            const c = function(t) {
                const e = {}, i = {};
                for (const s of t){
                    const t = s.queryResults, a = s.wrappedTileID, o = i[a] = i[a] || {};
                    for(const i in t){
                        const s = t[i], a = o[i] = o[i] || {}, r = e[i] = e[i] || [];
                        for (const t of s)a[t.featureIndex] || (a[t.featureIndex] = !0, r.push(t));
                    }
                }
                return e;
            }(h);
            for(const e in c)c[e].forEach((e)=>{
                const i = e.feature, s = t.getFeatureState(i.layer["source-layer"], i.id);
                i.source = i.layer.source, i.layer["source-layer"] && (i.sourceLayer = i.layer["source-layer"]), i.state = s;
            });
            return c;
        }
        function $(t, e) {
            const i = t.tileID, s = e.tileID;
            return i.overscaledZ - s.overscaledZ || i.canonical.y - s.canonical.y || i.wrap - s.wrap || i.canonical.x - s.canonical.x;
        }
        class W {
            constructor(e, i){
                this.timeAdded = 0, this.fadeEndTime = 0, this.tileID = e, this.uid = t.a2(), this.uses = 0, this.tileSize = i, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.rtt = [], this.rttCoords = {}, this.expiredRequestCount = 0, this.state = "loading";
            }
            registerFadeDuration(t) {
                const e = t + this.timeAdded;
                e < this.fadeEndTime || (this.fadeEndTime = e);
            }
            wasRequested() {
                return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
            }
            clearTextures(t) {
                this.demTexture && t.saveTileTexture(this.demTexture), this.demTexture = null;
            }
            loadVectorData(e, i, s) {
                if (this.hasData() && this.unloadVectorData(), this.state = "loaded", e) {
                    e.featureIndex && (this.latestFeatureIndex = e.featureIndex, e.rawTileData ? (this.latestRawTileData = e.rawTileData, this.latestFeatureIndex.rawTileData = e.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = e.collisionBoxArray, this.buckets = function(t, e) {
                        const i = {};
                        if (!e) return i;
                        for (const s of t){
                            const t = s.layerIds.map((t)=>e.getLayer(t)).filter(Boolean);
                            if (0 !== t.length) {
                                s.layers = t, s.stateDependentLayerIds && (s.stateDependentLayers = s.stateDependentLayerIds.map((e)=>t.filter((t)=>t.id === e)[0]));
                                for (const e of t)i[e.id] = s;
                            }
                        }
                        return i;
                    }(e.buckets, i.style), this.hasSymbolBuckets = !1;
                    for(const e in this.buckets){
                        const i = this.buckets[e];
                        if (i instanceof t.a4) {
                            if (this.hasSymbolBuckets = !0, !s) break;
                            i.justReloaded = !0;
                        }
                    }
                    if (this.hasRTLText = !1, this.hasSymbolBuckets) for(const e in this.buckets){
                        const i = this.buckets[e];
                        if (i instanceof t.a4 && i.hasRTLText) {
                            this.hasRTLText = !0, t.a5();
                            break;
                        }
                    }
                    this.queryPadding = 0;
                    for(const t in this.buckets){
                        const e = this.buckets[t];
                        this.queryPadding = Math.max(this.queryPadding, i.style.getLayer(t).queryRadius(e));
                    }
                    e.imageAtlas && (this.imageAtlas = e.imageAtlas), e.glyphAtlasImage && (this.glyphAtlasImage = e.glyphAtlasImage);
                } else this.collisionBoxArray = new t.a3;
            }
            unloadVectorData() {
                for(const t in this.buckets)this.buckets[t].destroy();
                this.buckets = {}, this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.imageAtlas && (this.imageAtlas = null), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.latestFeatureIndex = null, this.state = "unloaded";
            }
            getBucket(t) {
                return this.buckets[t.id];
            }
            upload(t) {
                for(const e in this.buckets){
                    const i = this.buckets[e];
                    i.uploadPending() && i.upload(t);
                }
                const e = t.gl;
                this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new x(t, this.imageAtlas.image, e.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new x(t, this.glyphAtlasImage, e.ALPHA), this.glyphAtlasImage = null);
            }
            prepare(t) {
                this.imageAtlas && this.imageAtlas.patchUpdatedImages(t, this.imageAtlasTexture);
            }
            queryRenderedFeatures(t, e, i, s, a, o, r, n, l, h) {
                return this.latestFeatureIndex && this.latestFeatureIndex.rawTileData ? this.latestFeatureIndex.query({
                    queryGeometry: s,
                    cameraQueryGeometry: a,
                    scale: o,
                    tileSize: this.tileSize,
                    pixelPosMatrix: h,
                    transform: n,
                    params: r,
                    queryPadding: this.queryPadding * l
                }, t, e, i) : {};
            }
            querySourceFeatures(e, i) {
                const s = this.latestFeatureIndex;
                if (!s || !s.rawTileData) return;
                const a = s.loadVTLayers(), o = i && i.sourceLayer ? i.sourceLayer : "", r = a._geojsonTileLayer || a[o];
                if (!r) return;
                const n = t.a6(i && i.filter), { z: l, x: h, y: c } = this.tileID.canonical, u = {
                    z: l,
                    x: h,
                    y: c
                };
                for(let i = 0; i < r.length; i++){
                    const a = r.feature(i);
                    if (n.needGeometry) {
                        const e = t.a7(a, !0);
                        if (!n.filter(new t.a8(this.tileID.overscaledZ), e, this.tileID.canonical)) continue;
                    } else if (!n.filter(new t.a8(this.tileID.overscaledZ), a)) continue;
                    const d = s.getId(a, o), _ = new t.a9(a, l, h, c, d);
                    _.tile = u, e.push(_);
                }
            }
            hasData() {
                return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
            }
            patternsLoaded() {
                return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
            }
            setExpiryData(e) {
                const i = this.expirationTime;
                if (e.cacheControl) {
                    const i = t.aa(e.cacheControl);
                    i["max-age"] && (this.expirationTime = Date.now() + 1e3 * i["max-age"]);
                } else e.expires && (this.expirationTime = new Date(e.expires).getTime());
                if (this.expirationTime) {
                    const t = Date.now();
                    let e = !1;
                    if (this.expirationTime > t) e = !1;
                    else if (i) {
                        if (this.expirationTime < i) e = !0;
                        else {
                            const s = this.expirationTime - i;
                            s ? this.expirationTime = t + Math.max(s, 3e4) : e = !0;
                        }
                    } else e = !0;
                    e ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
                }
            }
            getExpiryTimeout() {
                if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (new Date).getTime(), Math.pow(2, 31) - 1);
            }
            setFeatureState(t, e) {
                if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData || 0 === Object.keys(t).length) return;
                const i = this.latestFeatureIndex.loadVTLayers();
                for(const s in this.buckets){
                    if (!e.style.hasLayer(s)) continue;
                    const a = this.buckets[s], o = a.layers[0].sourceLayer || "_geojsonTileLayer", r = i[o], n = t[o];
                    if (!r || !n || 0 === Object.keys(n).length) continue;
                    a.update(n, r, this.imageAtlas && this.imageAtlas.patternPositions || {});
                    const l = e && e.style && e.style.getLayer(s);
                    l && (this.queryPadding = Math.max(this.queryPadding, l.queryRadius(a)));
                }
            }
            holdingForFade() {
                return void 0 !== this.symbolFadeHoldUntil;
            }
            symbolFadeFinished() {
                return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < t.h.now();
            }
            clearFadeHold() {
                this.symbolFadeHoldUntil = void 0;
            }
            setHoldDuration(e) {
                this.symbolFadeHoldUntil = t.h.now() + e;
            }
            setDependencies(t, e) {
                const i = {};
                for (const t of e)i[t] = !0;
                this.dependencies[t] = i;
            }
            hasDependency(t, e) {
                for (const i of t){
                    const t = this.dependencies[i];
                    if (t) {
                        for (const i of e)if (t[i]) return !0;
                    }
                }
                return !1;
            }
        }
        class H {
            constructor(t, e){
                this.max = t, this.onRemove = e, this.reset();
            }
            reset() {
                for(const t in this.data)for (const e of this.data[t])e.timeout && clearTimeout(e.timeout), this.onRemove(e.value);
                return this.data = {}, this.order = [], this;
            }
            add(t, e, i) {
                const s = t.wrapped().key;
                void 0 === this.data[s] && (this.data[s] = []);
                const a = {
                    value: e,
                    timeout: void 0
                };
                if (void 0 !== i && (a.timeout = setTimeout(()=>{
                    this.remove(t, a);
                }, i)), this.data[s].push(a), this.order.push(s), this.order.length > this.max) {
                    const t = this._getAndRemoveByKey(this.order[0]);
                    t && this.onRemove(t);
                }
                return this;
            }
            has(t) {
                return t.wrapped().key in this.data;
            }
            getAndRemove(t) {
                return this.has(t) ? this._getAndRemoveByKey(t.wrapped().key) : null;
            }
            _getAndRemoveByKey(t) {
                const e = this.data[t].shift();
                return e.timeout && clearTimeout(e.timeout), 0 === this.data[t].length && delete this.data[t], this.order.splice(this.order.indexOf(t), 1), e.value;
            }
            getByKey(t) {
                const e = this.data[t];
                return e ? e[0].value : null;
            }
            get(t) {
                return this.has(t) ? this.data[t.wrapped().key][0].value : null;
            }
            remove(t, e) {
                if (!this.has(t)) return this;
                const i = t.wrapped().key, s = void 0 === e ? 0 : this.data[i].indexOf(e), a = this.data[i][s];
                return this.data[i].splice(s, 1), a.timeout && clearTimeout(a.timeout), 0 === this.data[i].length && delete this.data[i], this.onRemove(a.value), this.order.splice(this.order.indexOf(i), 1), this;
            }
            setMaxSize(t) {
                for(this.max = t; this.order.length > this.max;){
                    const t = this._getAndRemoveByKey(this.order[0]);
                    t && this.onRemove(t);
                }
                return this;
            }
            filter(t) {
                const e = [];
                for(const i in this.data)for (const s of this.data[i])t(s.value) || e.push(s);
                for (const t of e)this.remove(t.value.tileID, t);
            }
        }
        class X {
            constructor(){
                this.state = {}, this.stateChanges = {}, this.deletedStates = {};
            }
            updateState(e, i, s) {
                const a = String(i);
                if (this.stateChanges[e] = this.stateChanges[e] || {}, this.stateChanges[e][a] = this.stateChanges[e][a] || {}, t.e(this.stateChanges[e][a], s), null === this.deletedStates[e]) {
                    this.deletedStates[e] = {};
                    for(const t in this.state[e])t !== a && (this.deletedStates[e][t] = null);
                } else if (this.deletedStates[e] && null === this.deletedStates[e][a]) {
                    this.deletedStates[e][a] = {};
                    for(const t in this.state[e][a])s[t] || (this.deletedStates[e][a][t] = null);
                } else for(const t in s)this.deletedStates[e] && this.deletedStates[e][a] && null === this.deletedStates[e][a][t] && delete this.deletedStates[e][a][t];
            }
            removeFeatureState(t, e, i) {
                if (null === this.deletedStates[t]) return;
                const s = String(e);
                if (this.deletedStates[t] = this.deletedStates[t] || {}, i && void 0 !== e) null !== this.deletedStates[t][s] && (this.deletedStates[t][s] = this.deletedStates[t][s] || {}, this.deletedStates[t][s][i] = null);
                else if (void 0 !== e) {
                    if (this.stateChanges[t] && this.stateChanges[t][s]) for(i in this.deletedStates[t][s] = {}, this.stateChanges[t][s])this.deletedStates[t][s][i] = null;
                    else this.deletedStates[t][s] = null;
                } else this.deletedStates[t] = null;
            }
            getState(e, i) {
                const s = String(i), a = t.e({}, (this.state[e] || {})[s], (this.stateChanges[e] || {})[s]);
                if (null === this.deletedStates[e]) return {};
                if (this.deletedStates[e]) {
                    const t = this.deletedStates[e][i];
                    if (null === t) return {};
                    for(const e in t)delete a[e];
                }
                return a;
            }
            initializeTileState(t, e) {
                t.setFeatureState(this.state, e);
            }
            coalesceChanges(e, i) {
                const s = {};
                for(const e in this.stateChanges){
                    this.state[e] = this.state[e] || {};
                    const i = {};
                    for(const s in this.stateChanges[e])this.state[e][s] || (this.state[e][s] = {}), t.e(this.state[e][s], this.stateChanges[e][s]), i[s] = this.state[e][s];
                    s[e] = i;
                }
                for(const e in this.deletedStates){
                    this.state[e] = this.state[e] || {};
                    const i = {};
                    if (null === this.deletedStates[e]) for(const t in this.state[e])i[t] = {}, this.state[e][t] = {};
                    else for(const t in this.deletedStates[e]){
                        if (null === this.deletedStates[e][t]) this.state[e][t] = {};
                        else for (const i of Object.keys(this.deletedStates[e][t]))delete this.state[e][t][i];
                        i[t] = this.state[e][t];
                    }
                    s[e] = s[e] || {}, t.e(s[e], i);
                }
                if (this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(s).length) for(const t in e)e[t].setFeatureState(s, i);
            }
        }
        class K extends t.E {
            constructor(t, e, i){
                super(), this.id = t, this.dispatcher = i, this.on("data", (t)=>{
                    "source" === t.dataType && "metadata" === t.sourceDataType && (this._sourceLoaded = !0), this._sourceLoaded && !this._paused && "source" === t.dataType && "content" === t.sourceDataType && (this.reload(), this.transform && this.update(this.transform, this.terrain), this._didEmitContent = !0);
                }), this.on("dataloading", ()=>{
                    this._sourceErrored = !1;
                }), this.on("error", ()=>{
                    this._sourceErrored = this._source.loaded();
                }), this._source = ((t, e, i, s)=>{
                    const a = new (j(e.type))(t, e, i, s);
                    if (a.id !== t) throw new Error(`Expected Source id to be ${t} instead of ${a.id}`);
                    return a;
                })(t, e, i, this), this._tiles = {}, this._cache = new H(0, this._unloadTile.bind(this)), this._timers = {}, this._cacheTimers = {}, this._maxTileCacheSize = null, this._maxTileCacheZoomLevels = null, this._loadedParentTiles = {}, this._coveredTiles = {}, this._state = new X, this._didEmitContent = !1, this._updated = !1;
            }
            onAdd(t) {
                this.map = t, this._maxTileCacheSize = t ? t._maxTileCacheSize : null, this._maxTileCacheZoomLevels = t ? t._maxTileCacheZoomLevels : null, this._source && this._source.onAdd && this._source.onAdd(t);
            }
            onRemove(t) {
                this.clearTiles(), this._source && this._source.onRemove && this._source.onRemove(t);
            }
            loaded() {
                if (this._sourceErrored) return !0;
                if (!this._sourceLoaded) return !1;
                if (!this._source.loaded()) return !1;
                if (!(void 0 === this.used && void 0 === this.usedForTerrain || this.used || this.usedForTerrain)) return !0;
                if (!this._updated) return !1;
                for(const t in this._tiles){
                    const e = this._tiles[t];
                    if ("loaded" !== e.state && "errored" !== e.state) return !1;
                }
                return !0;
            }
            getSource() {
                return this._source;
            }
            pause() {
                this._paused = !0;
            }
            resume() {
                if (!this._paused) return;
                const t = this._shouldReloadOnResume;
                this._paused = !1, this._shouldReloadOnResume = !1, t && this.reload(), this.transform && this.update(this.transform, this.terrain);
            }
            _loadTile(t, e) {
                return this._source.loadTile(t, e);
            }
            _unloadTile(t) {
                if (this._source.unloadTile) return this._source.unloadTile(t, ()=>{});
            }
            _abortTile(e) {
                this._source.abortTile && this._source.abortTile(e, ()=>{}), this._source.fire(new t.k("dataabort", {
                    tile: e,
                    coord: e.tileID,
                    dataType: "source"
                }));
            }
            serialize() {
                return this._source.serialize();
            }
            prepare(t) {
                this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
                for(const e in this._tiles){
                    const i = this._tiles[e];
                    i.upload(t), i.prepare(this.map.style.imageManager);
                }
            }
            getIds() {
                return Object.values(this._tiles).map((t)=>t.tileID).sort(Q).map((t)=>t.key);
            }
            getRenderableIds(e) {
                const i = [];
                for(const t in this._tiles)this._isIdRenderable(t, e) && i.push(this._tiles[t]);
                return e ? i.sort((e, i)=>{
                    const s = e.tileID, a = i.tileID, o = new t.P(s.canonical.x, s.canonical.y)._rotate(this.transform.angle), r = new t.P(a.canonical.x, a.canonical.y)._rotate(this.transform.angle);
                    return s.overscaledZ - a.overscaledZ || r.y - o.y || r.x - o.x;
                }).map((t)=>t.tileID.key) : i.map((t)=>t.tileID).sort(Q).map((t)=>t.key);
            }
            hasRenderableParent(t) {
                const e = this.findLoadedParent(t, 0);
                return !!e && this._isIdRenderable(e.tileID.key);
            }
            _isIdRenderable(t, e) {
                return this._tiles[t] && this._tiles[t].hasData() && !this._coveredTiles[t] && (e || !this._tiles[t].holdingForFade());
            }
            reload() {
                if (this._paused) this._shouldReloadOnResume = !0;
                else {
                    this._cache.reset();
                    for(const t in this._tiles)"errored" !== this._tiles[t].state && this._reloadTile(t, "reloading");
                }
            }
            _reloadTile(t, e) {
                const i = this._tiles[t];
                i && ("loading" !== i.state && (i.state = e), this._loadTile(i, this._tileLoaded.bind(this, i, t, e)));
            }
            _tileLoaded(e, i, s, a) {
                if (a) return e.state = "errored", void (404 !== a.status ? this._source.fire(new t.j(a, {
                    tile: e
                })) : this.update(this.transform, this.terrain));
                e.timeAdded = t.h.now(), "expired" === s && (e.refreshedUponExpiration = !0), this._setTileReloadTimer(i, e), "raster-dem" === this.getSource().type && e.dem && this._backfillDEM(e), this._state.initializeTileState(e, this.map ? this.map.painter : null), e.aborted || this._source.fire(new t.k("data", {
                    dataType: "source",
                    tile: e,
                    coord: e.tileID
                }));
            }
            _backfillDEM(t) {
                const e = this.getRenderableIds();
                for(let s = 0; s < e.length; s++){
                    const a = e[s];
                    if (t.neighboringTiles && t.neighboringTiles[a]) {
                        const e = this.getTileByID(a);
                        i(t, e), i(e, t);
                    }
                }
                function i(t, e) {
                    t.needsHillshadePrepare = !0, t.needsTerrainPrepare = !0;
                    let i = e.tileID.canonical.x - t.tileID.canonical.x;
                    const s = e.tileID.canonical.y - t.tileID.canonical.y, a = Math.pow(2, t.tileID.canonical.z), o = e.tileID.key;
                    0 === i && 0 === s || Math.abs(s) > 1 || (Math.abs(i) > 1 && (1 === Math.abs(i + a) ? i += a : 1 === Math.abs(i - a) && (i -= a)), e.dem && t.dem && (t.dem.backfillBorder(e.dem, i, s), t.neighboringTiles && t.neighboringTiles[o] && (t.neighboringTiles[o].backfilled = !0)));
                }
            }
            getTile(t) {
                return this.getTileByID(t.key);
            }
            getTileByID(t) {
                return this._tiles[t];
            }
            _retainLoadedChildren(t, e, i, s) {
                for(const a in this._tiles){
                    let o = this._tiles[a];
                    if (s[a] || !o.hasData() || o.tileID.overscaledZ <= e || o.tileID.overscaledZ > i) continue;
                    let r = o.tileID;
                    for(; o && o.tileID.overscaledZ > e + 1;){
                        const t = o.tileID.scaledTo(o.tileID.overscaledZ - 1);
                        o = this._tiles[t.key], o && o.hasData() && (r = t);
                    }
                    let n = r;
                    for(; n.overscaledZ > e;)if (n = n.scaledTo(n.overscaledZ - 1), t[n.key]) {
                        s[r.key] = r;
                        break;
                    }
                }
            }
            findLoadedParent(t, e) {
                if (t.key in this._loadedParentTiles) {
                    const i = this._loadedParentTiles[t.key];
                    return i && i.tileID.overscaledZ >= e ? i : null;
                }
                for(let i = t.overscaledZ - 1; i >= e; i--){
                    const e = t.scaledTo(i), s = this._getLoadedTile(e);
                    if (s) return s;
                }
            }
            _getLoadedTile(t) {
                const e = this._tiles[t.key];
                return e && e.hasData() ? e : this._cache.getByKey(t.wrapped().key);
            }
            updateCacheSize(e) {
                const i = Math.ceil(e.width / this._source.tileSize) + 1, s = Math.ceil(e.height / this._source.tileSize) + 1, a = Math.floor(i * s * (null === this._maxTileCacheZoomLevels ? t.c.MAX_TILE_CACHE_ZOOM_LEVELS : this._maxTileCacheZoomLevels)), o = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, a) : a;
                this._cache.setMaxSize(o);
            }
            handleWrapJump(t) {
                const e = Math.round((t - (void 0 === this._prevLng ? t : this._prevLng)) / 360);
                if (this._prevLng = t, e) {
                    const t = {};
                    for(const i in this._tiles){
                        const s = this._tiles[i];
                        s.tileID = s.tileID.unwrapTo(s.tileID.wrap + e), t[s.tileID.key] = s;
                    }
                    this._tiles = t;
                    for(const t in this._timers)clearTimeout(this._timers[t]), delete this._timers[t];
                    for(const t in this._tiles)this._setTileReloadTimer(t, this._tiles[t]);
                }
            }
            update(e, i) {
                if (this.transform = e, this.terrain = i, !this._sourceLoaded || this._paused) return;
                let s;
                this.updateCacheSize(e), this.handleWrapJump(this.transform.center.lng), this._coveredTiles = {}, this.used || this.usedForTerrain ? this._source.tileID ? s = e.getVisibleUnwrappedCoordinates(this._source.tileID).map((e)=>new t.O(e.canonical.z, e.wrap, e.canonical.z, e.canonical.x, e.canonical.y)) : (s = e.coveringTiles({
                    tileSize: this.usedForTerrain ? this.tileSize : this._source.tileSize,
                    minzoom: this._source.minzoom,
                    maxzoom: this._source.maxzoom,
                    roundZoom: !this.usedForTerrain && this._source.roundZoom,
                    reparseOverscaled: this._source.reparseOverscaled,
                    terrain: i
                }), this._source.hasTile && (s = s.filter((t)=>this._source.hasTile(t)))) : s = [];
                const a = e.coveringZoomLevel(this._source), o = Math.max(a - K.maxOverzooming, this._source.minzoom), r = Math.max(a + K.maxUnderzooming, this._source.minzoom);
                if (this.usedForTerrain) {
                    const t = {};
                    for (const e of s)if (e.canonical.z > this._source.minzoom) {
                        const i = e.scaledTo(e.canonical.z - 1);
                        t[i.key] = i;
                        const s = e.scaledTo(Math.max(this._source.minzoom, Math.min(e.canonical.z, 5)));
                        t[s.key] = s;
                    }
                    s = s.concat(Object.values(t));
                }
                const n = 0 === s.length && !this._updated && this._didEmitContent;
                this._updated = !0, n && this.fire(new t.k("data", {
                    sourceDataType: "idle",
                    dataType: "source",
                    sourceId: this.id
                }));
                const l = this._updateRetainedTiles(s, a);
                if (Y(this._source.type)) {
                    const e = {}, n = {}, h = Object.keys(l), c = t.h.now();
                    for (const t of h){
                        const i = l[t], s = this._tiles[t];
                        if (!s || 0 !== s.fadeEndTime && s.fadeEndTime <= c) continue;
                        const a = this.findLoadedParent(i, o);
                        a && (this._addTile(a.tileID), e[a.tileID.key] = a.tileID), n[t] = i;
                    }
                    this._retainLoadedChildren(n, a, r, l);
                    for(const t in e)l[t] || (this._coveredTiles[t] = !0, l[t] = e[t]);
                    if (i) {
                        const t = {}, e = {};
                        for (const i of s)this._tiles[i.key].hasData() ? t[i.key] = i : e[i.key] = i;
                        for(const i in e){
                            const s = e[i].children(this._source.maxzoom);
                            this._tiles[s[0].key] && this._tiles[s[1].key] && this._tiles[s[2].key] && this._tiles[s[3].key] && (t[s[0].key] = l[s[0].key] = s[0], t[s[1].key] = l[s[1].key] = s[1], t[s[2].key] = l[s[2].key] = s[2], t[s[3].key] = l[s[3].key] = s[3], delete e[i]);
                        }
                        for(const i in e){
                            const s = this.findLoadedParent(e[i], this._source.minzoom);
                            if (s) {
                                t[s.tileID.key] = l[s.tileID.key] = s.tileID;
                                for(const e in t)t[e].isChildOf(s.tileID) && delete t[e];
                            }
                        }
                        for(const e in this._tiles)t[e] || (this._coveredTiles[e] = !0);
                    }
                }
                for(const t in l)this._tiles[t].clearFadeHold();
                const h = t.ab(this._tiles, l);
                for (const t of h){
                    const e = this._tiles[t];
                    e.hasSymbolBuckets && !e.holdingForFade() ? e.setHoldDuration(this.map._fadeDuration) : e.hasSymbolBuckets && !e.symbolFadeFinished() || this._removeTile(t);
                }
                this._updateLoadedParentTileCache();
            }
            releaseSymbolFadeTiles() {
                for(const t in this._tiles)this._tiles[t].holdingForFade() && this._removeTile(t);
            }
            _updateRetainedTiles(t, e) {
                const i = {}, s = {}, a = Math.max(e - K.maxOverzooming, this._source.minzoom), o = Math.max(e + K.maxUnderzooming, this._source.minzoom), r = {};
                for (const s of t){
                    const t = this._addTile(s);
                    i[s.key] = s, t.hasData() || e < this._source.maxzoom && (r[s.key] = s);
                }
                this._retainLoadedChildren(r, e, o, i);
                for (const o of t){
                    let t = this._tiles[o.key];
                    if (t.hasData()) continue;
                    if (e + 1 > this._source.maxzoom) {
                        const t = o.children(this._source.maxzoom)[0], e = this.getTile(t);
                        if (e && e.hasData()) {
                            i[t.key] = t;
                            continue;
                        }
                    } else {
                        const t = o.children(this._source.maxzoom);
                        if (i[t[0].key] && i[t[1].key] && i[t[2].key] && i[t[3].key]) continue;
                    }
                    let r = t.wasRequested();
                    for(let e = o.overscaledZ - 1; e >= a; --e){
                        const a = o.scaledTo(e);
                        if (s[a.key]) break;
                        if (s[a.key] = !0, t = this.getTile(a), !t && r && (t = this._addTile(a)), t) {
                            const e = t.hasData();
                            if ((r || e) && (i[a.key] = a), r = t.wasRequested(), e) break;
                        }
                    }
                }
                return i;
            }
            _updateLoadedParentTileCache() {
                this._loadedParentTiles = {};
                for(const t in this._tiles){
                    const e = [];
                    let i, s = this._tiles[t].tileID;
                    for(; s.overscaledZ > 0;){
                        if (s.key in this._loadedParentTiles) {
                            i = this._loadedParentTiles[s.key];
                            break;
                        }
                        e.push(s.key);
                        const t = s.scaledTo(s.overscaledZ - 1);
                        if (i = this._getLoadedTile(t), i) break;
                        s = t;
                    }
                    for (const t of e)this._loadedParentTiles[t] = i;
                }
            }
            _addTile(e) {
                let i = this._tiles[e.key];
                if (i) return i;
                i = this._cache.getAndRemove(e), i && (this._setTileReloadTimer(e.key, i), i.tileID = e, this._state.initializeTileState(i, this.map ? this.map.painter : null), this._cacheTimers[e.key] && (clearTimeout(this._cacheTimers[e.key]), delete this._cacheTimers[e.key], this._setTileReloadTimer(e.key, i)));
                const s = i;
                return i || (i = new W(e, this._source.tileSize * e.overscaleFactor()), this._loadTile(i, this._tileLoaded.bind(this, i, e.key, i.state))), i.uses++, this._tiles[e.key] = i, s || this._source.fire(new t.k("dataloading", {
                    tile: i,
                    coord: i.tileID,
                    dataType: "source"
                })), i;
            }
            _setTileReloadTimer(t, e) {
                t in this._timers && (clearTimeout(this._timers[t]), delete this._timers[t]);
                const i = e.getExpiryTimeout();
                i && (this._timers[t] = setTimeout(()=>{
                    this._reloadTile(t, "expired"), delete this._timers[t];
                }, i));
            }
            _removeTile(t) {
                const e = this._tiles[t];
                e && (e.uses--, delete this._tiles[t], this._timers[t] && (clearTimeout(this._timers[t]), delete this._timers[t]), e.uses > 0 || (e.hasData() && "reloading" !== e.state ? this._cache.add(e.tileID, e, e.getExpiryTimeout()) : (e.aborted = !0, this._abortTile(e), this._unloadTile(e))));
            }
            clearTiles() {
                this._shouldReloadOnResume = !1, this._paused = !1;
                for(const t in this._tiles)this._removeTile(t);
                this._cache.reset();
            }
            tilesIn(e, i, s) {
                const a = [], o = this.transform;
                if (!o) return a;
                const r = s ? o.getCameraQueryGeometry(e) : e, n = e.map((t)=>o.pointCoordinate(t, this.terrain)), l = r.map((t)=>o.pointCoordinate(t, this.terrain)), h = this.getIds();
                let c = 1 / 0, u = 1 / 0, d = -1 / 0, _ = -1 / 0;
                for (const t of l)c = Math.min(c, t.x), u = Math.min(u, t.y), d = Math.max(d, t.x), _ = Math.max(_, t.y);
                for(let e = 0; e < h.length; e++){
                    const s = this._tiles[h[e]];
                    if (s.holdingForFade()) continue;
                    const r = s.tileID, p = Math.pow(2, o.zoom - s.tileID.overscaledZ), m = i * s.queryPadding * t.N / s.tileSize / p, f = [
                        r.getTilePoint(new t.U(c, u)),
                        r.getTilePoint(new t.U(d, _))
                    ];
                    if (f[0].x - m < t.N && f[0].y - m < t.N && f[1].x + m >= 0 && f[1].y + m >= 0) {
                        const t = n.map((t)=>r.getTilePoint(t)), e = l.map((t)=>r.getTilePoint(t));
                        a.push({
                            tile: s,
                            tileID: r,
                            queryGeometry: t,
                            cameraQueryGeometry: e,
                            scale: p
                        });
                    }
                }
                return a;
            }
            getVisibleCoordinates(t) {
                const e = this.getRenderableIds(t).map((t)=>this._tiles[t].tileID);
                for (const t of e)t.posMatrix = this.transform.calculatePosMatrix(t.toUnwrapped());
                return e;
            }
            hasTransition() {
                if (this._source.hasTransition()) return !0;
                if (Y(this._source.type)) {
                    const e = t.h.now();
                    for(const t in this._tiles)if (this._tiles[t].fadeEndTime >= e) return !0;
                }
                return !1;
            }
            setFeatureState(t, e, i) {
                this._state.updateState(t = t || "_geojsonTileLayer", e, i);
            }
            removeFeatureState(t, e, i) {
                this._state.removeFeatureState(t = t || "_geojsonTileLayer", e, i);
            }
            getFeatureState(t, e) {
                return this._state.getState(t = t || "_geojsonTileLayer", e);
            }
            setDependencies(t, e, i) {
                const s = this._tiles[t];
                s && s.setDependencies(e, i);
            }
            reloadTilesForDependencies(t, e) {
                for(const i in this._tiles)this._tiles[i].hasDependency(t, e) && this._reloadTile(i, "reloading");
                this._cache.filter((i)=>!i.hasDependency(t, e));
            }
        }
        function Q(t, e) {
            const i = Math.abs(2 * t.wrap) - +(t.wrap < 0), s = Math.abs(2 * e.wrap) - +(e.wrap < 0);
            return t.overscaledZ - e.overscaledZ || s - i || e.canonical.y - t.canonical.y || e.canonical.x - t.canonical.x;
        }
        function Y(t) {
            return "raster" === t || "image" === t || "video" === t;
        }
        K.maxOverzooming = 10, K.maxUnderzooming = 3;
        const J = "mapboxgl_preloaded_worker_pool";
        class tt {
            constructor(){
                this.active = {};
            }
            acquire(e) {
                if (!this.workers) for(this.workers = []; this.workers.length < tt.workerCount;)this.workers.push(new Worker(t.c.WORKER_URL));
                return this.active[e] = !0, this.workers.slice();
            }
            release(t) {
                delete this.active[t], 0 === this.numActive() && (this.workers.forEach((t)=>{
                    t.terminate();
                }), this.workers = null);
            }
            isPreloaded() {
                return !!this.active[J];
            }
            numActive() {
                return Object.keys(this.active).length;
            }
        }
        const et = Math.floor(t.h.hardwareConcurrency / 2);
        let it;
        function st() {
            return it || (it = new tt), it;
        }
        tt.workerCount = t.ac(globalThis) ? Math.max(Math.min(et, 3), 1) : 1;
        class at {
            constructor(t, e){
                this.reset(t, e);
            }
            reset(t, e) {
                this.points = t || [], this._distances = [
                    0
                ];
                for(let t = 1; t < this.points.length; t++)this._distances[t] = this._distances[t - 1] + this.points[t].dist(this.points[t - 1]);
                this.length = this._distances[this._distances.length - 1], this.padding = Math.min(e || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
            }
            lerp(e) {
                if (1 === this.points.length) return this.points[0];
                e = t.ad(e, 0, 1);
                let i = 1, s = this._distances[i];
                const a = e * this.paddedLength + this.padding;
                for(; s < a && i < this._distances.length;)s = this._distances[++i];
                const o = i - 1, r = this._distances[o], n = s - r, l = n > 0 ? (a - r) / n : 0;
                return this.points[o].mult(1 - l).add(this.points[i].mult(l));
            }
        }
        function ot(t, e) {
            let i = !0;
            return "always" === t || "never" !== t && "never" !== e || (i = !1), i;
        }
        class rt {
            constructor(t, e, i){
                const s = this.boxCells = [], a = this.circleCells = [];
                this.xCellCount = Math.ceil(t / i), this.yCellCount = Math.ceil(e / i);
                for(let t = 0; t < this.xCellCount * this.yCellCount; t++)s.push([]), a.push([]);
                this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = t, this.height = e, this.xScale = this.xCellCount / t, this.yScale = this.yCellCount / e, this.boxUid = 0, this.circleUid = 0;
            }
            keysLength() {
                return this.boxKeys.length + this.circleKeys.length;
            }
            insert(t, e, i, s, a) {
                this._forEachCell(e, i, s, a, this._insertBoxCell, this.boxUid++), this.boxKeys.push(t), this.bboxes.push(e), this.bboxes.push(i), this.bboxes.push(s), this.bboxes.push(a);
            }
            insertCircle(t, e, i, s) {
                this._forEachCell(e - s, i - s, e + s, i + s, this._insertCircleCell, this.circleUid++), this.circleKeys.push(t), this.circles.push(e), this.circles.push(i), this.circles.push(s);
            }
            _insertBoxCell(t, e, i, s, a, o) {
                this.boxCells[a].push(o);
            }
            _insertCircleCell(t, e, i, s, a, o) {
                this.circleCells[a].push(o);
            }
            _query(t, e, i, s, a, o, r) {
                if (i < 0 || t > this.width || s < 0 || e > this.height) return [];
                const n = [];
                if (t <= 0 && e <= 0 && this.width <= i && this.height <= s) {
                    if (a) return [
                        {
                            key: null,
                            x1: t,
                            y1: e,
                            x2: i,
                            y2: s
                        }
                    ];
                    for(let t = 0; t < this.boxKeys.length; t++)n.push({
                        key: this.boxKeys[t],
                        x1: this.bboxes[4 * t],
                        y1: this.bboxes[4 * t + 1],
                        x2: this.bboxes[4 * t + 2],
                        y2: this.bboxes[4 * t + 3]
                    });
                    for(let t = 0; t < this.circleKeys.length; t++){
                        const e = this.circles[3 * t], i = this.circles[3 * t + 1], s = this.circles[3 * t + 2];
                        n.push({
                            key: this.circleKeys[t],
                            x1: e - s,
                            y1: i - s,
                            x2: e + s,
                            y2: i + s
                        });
                    }
                } else this._forEachCell(t, e, i, s, this._queryCell, n, {
                    hitTest: a,
                    overlapMode: o,
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, r);
                return n;
            }
            query(t, e, i, s) {
                return this._query(t, e, i, s, !1, null);
            }
            hitTest(t, e, i, s, a, o) {
                return this._query(t, e, i, s, !0, a, o).length > 0;
            }
            hitTestCircle(t, e, i, s, a) {
                const o = t - i, r = t + i, n = e - i, l = e + i;
                if (r < 0 || o > this.width || l < 0 || n > this.height) return !1;
                const h = [];
                return this._forEachCell(o, n, r, l, this._queryCellCircle, h, {
                    hitTest: !0,
                    overlapMode: s,
                    circle: {
                        x: t,
                        y: e,
                        radius: i
                    },
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, a), h.length > 0;
            }
            _queryCell(t, e, i, s, a, o, r, n) {
                const { seenUids: l, hitTest: h, overlapMode: c } = r, u = this.boxCells[a];
                if (null !== u) {
                    const a = this.bboxes;
                    for (const r of u)if (!l.box[r]) {
                        l.box[r] = !0;
                        const u = 4 * r, d = this.boxKeys[r];
                        if (t <= a[u + 2] && e <= a[u + 3] && i >= a[u + 0] && s >= a[u + 1] && (!n || n(d)) && (!h || !ot(c, d.overlapMode)) && (o.push({
                            key: d,
                            x1: a[u],
                            y1: a[u + 1],
                            x2: a[u + 2],
                            y2: a[u + 3]
                        }), h)) return !0;
                    }
                }
                const d = this.circleCells[a];
                if (null !== d) {
                    const a = this.circles;
                    for (const r of d)if (!l.circle[r]) {
                        l.circle[r] = !0;
                        const u = 3 * r, d = this.circleKeys[r];
                        if (this._circleAndRectCollide(a[u], a[u + 1], a[u + 2], t, e, i, s) && (!n || n(d)) && (!h || !ot(c, d.overlapMode))) {
                            const t = a[u], e = a[u + 1], i = a[u + 2];
                            if (o.push({
                                key: d,
                                x1: t - i,
                                y1: e - i,
                                x2: t + i,
                                y2: e + i
                            }), h) return !0;
                        }
                    }
                }
                return !1;
            }
            _queryCellCircle(t, e, i, s, a, o, r, n) {
                const { circle: l, seenUids: h, overlapMode: c } = r, u = this.boxCells[a];
                if (null !== u) {
                    const t = this.bboxes;
                    for (const e of u)if (!h.box[e]) {
                        h.box[e] = !0;
                        const i = 4 * e, s = this.boxKeys[e];
                        if (this._circleAndRectCollide(l.x, l.y, l.radius, t[i + 0], t[i + 1], t[i + 2], t[i + 3]) && (!n || n(s)) && !ot(c, s.overlapMode)) return o.push(!0), !0;
                    }
                }
                const d = this.circleCells[a];
                if (null !== d) {
                    const t = this.circles;
                    for (const e of d)if (!h.circle[e]) {
                        h.circle[e] = !0;
                        const i = 3 * e, s = this.circleKeys[e];
                        if (this._circlesCollide(t[i], t[i + 1], t[i + 2], l.x, l.y, l.radius) && (!n || n(s)) && !ot(c, s.overlapMode)) return o.push(!0), !0;
                    }
                }
            }
            _forEachCell(t, e, i, s, a, o, r, n) {
                const l = this._convertToXCellCoord(t), h = this._convertToYCellCoord(e), c = this._convertToXCellCoord(i), u = this._convertToYCellCoord(s);
                for(let d = l; d <= c; d++)for(let l = h; l <= u; l++)if (a.call(this, t, e, i, s, this.xCellCount * l + d, o, r, n)) return;
            }
            _convertToXCellCoord(t) {
                return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(t * this.xScale)));
            }
            _convertToYCellCoord(t) {
                return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(t * this.yScale)));
            }
            _circlesCollide(t, e, i, s, a, o) {
                const r = s - t, n = a - e, l = i + o;
                return l * l > r * r + n * n;
            }
            _circleAndRectCollide(t, e, i, s, a, o, r) {
                const n = (o - s) / 2, l = Math.abs(t - (s + n));
                if (l > n + i) return !1;
                const h = (r - a) / 2, c = Math.abs(e - (a + h));
                if (c > h + i) return !1;
                if (l <= n || c <= h) return !0;
                const u = l - n, d = c - h;
                return u * u + d * d <= i * i;
            }
        }
        function nt(e, i, s, a, o) {
            const r = t.Z();
            return i ? (t.a0(r, r, [
                1 / o,
                1 / o,
                1
            ]), s || t.ae(r, r, a.angle)) : t.a1(r, a.labelPlaneMatrix, e), r;
        }
        function lt(e, i, s, a, o) {
            if (i) {
                const i = t.af(e);
                return t.a0(i, i, [
                    o,
                    o,
                    1
                ]), s || t.ae(i, i, -a.angle), i;
            }
            return a.glCoordMatrix;
        }
        function ht(e, i, s) {
            let a;
            s ? (a = [
                e.x,
                e.y,
                s(e.x, e.y),
                1
            ], t.ag(a, a, i)) : (a = [
                e.x,
                e.y,
                0,
                1
            ], Tt(a, a, i));
            const o = a[3];
            return {
                point: new t.P(a[0] / o, a[1] / o),
                signedDistanceFromCamera: o
            };
        }
        function ct(t, e) {
            return .5 + t / e * .5;
        }
        function ut(t, e) {
            const i = t[0] / t[3], s = t[1] / t[3];
            return i >= -e[0] && i <= e[0] && s >= -e[1] && s <= e[1];
        }
        function dt(e, i, s, a, o, r, n, l, h, c) {
            const u = a ? e.textSizeData : e.iconSizeData, d = t.ah(u, s.transform.zoom), _ = [
                256 / s.width * 2 + 1,
                256 / s.height * 2 + 1
            ], p = a ? e.text.dynamicLayoutVertexArray : e.icon.dynamicLayoutVertexArray;
            p.clear();
            const m = e.lineVertexArray, f = a ? e.text.placedSymbolArray : e.icon.placedSymbolArray, g = s.transform.width / s.transform.height;
            let v = !1;
            for(let a = 0; a < f.length; a++){
                const x = f.get(a);
                if (x.hidden || x.writingMode === t.ai.vertical && !v) {
                    wt(x.numGlyphs, p);
                    continue;
                }
                let y;
                if (v = !1, c ? (y = [
                    x.anchorX,
                    x.anchorY,
                    c(x.anchorX, x.anchorY),
                    1
                ], t.ag(y, y, i)) : (y = [
                    x.anchorX,
                    x.anchorY,
                    0,
                    1
                ], Tt(y, y, i)), !ut(y, _)) {
                    wt(x.numGlyphs, p);
                    continue;
                }
                const b = ct(s.transform.cameraToCenterDistance, y[3]), w = t.aj(u, d, x), T = n ? w / b : w * b, I = new t.P(x.anchorX, x.anchorY), E = ht(I, o, c).point, S = {
                    projections: {},
                    offsets: {}
                }, C = mt(x, T, !1, l, i, o, r, e.glyphOffsetArray, m, p, E, I, S, g, h, c);
                v = C.useVertical, (C.notEnoughRoom || v || C.needsFlipping && mt(x, T, !0, l, i, o, r, e.glyphOffsetArray, m, p, E, I, S, g, h, c).notEnoughRoom) && wt(x.numGlyphs, p);
            }
            a ? e.text.dynamicLayoutVertexBuffer.updateData(p) : e.icon.dynamicLayoutVertexBuffer.updateData(p);
        }
        function _t(t, e, i, s, a, o, r, n, l, h, c, u, d) {
            const _ = n.glyphStartIndex + n.numGlyphs, p = n.lineStartIndex, m = n.lineStartIndex + n.lineLength, f = e.getoffsetX(n.glyphStartIndex), g = e.getoffsetX(_ - 1), v = yt(t * f, i, s, a, o, r, n.segment, p, m, l, h, c, u, d);
            if (!v) return null;
            const x = yt(t * g, i, s, a, o, r, n.segment, p, m, l, h, c, u, d);
            return x ? {
                first: v,
                last: x
            } : null;
        }
        function pt(e, i, s, a) {
            return e === t.ai.horizontal && Math.abs(s.y - i.y) > Math.abs(s.x - i.x) * a ? {
                useVertical: !0
            } : (e === t.ai.vertical ? i.y < s.y : i.x > s.x) ? {
                needsFlipping: !0
            } : null;
        }
        function mt(e, i, s, a, o, r, n, l, h, c, u, d, _, p, m, f) {
            const g = i / 24, v = e.lineOffsetX * g, x = e.lineOffsetY * g;
            let y;
            if (e.numGlyphs > 1) {
                const t = e.glyphStartIndex + e.numGlyphs, i = e.lineStartIndex, o = e.lineStartIndex + e.lineLength, c = _t(g, l, v, x, s, u, d, e, h, r, _, m, f);
                if (!c) return {
                    notEnoughRoom: !0
                };
                const b = ht(c.first.point, n, f).point, w = ht(c.last.point, n, f).point;
                if (a && !s) {
                    const t = pt(e.writingMode, b, w, p);
                    if (t) return t;
                }
                y = [
                    c.first
                ];
                for(let a = e.glyphStartIndex + 1; a < t - 1; a++)y.push(yt(g * l.getoffsetX(a), v, x, s, u, d, e.segment, i, o, h, r, _, m, f));
                y.push(c.last);
            } else {
                if (a && !s) {
                    const i = ht(d, o, f).point, s = e.lineStartIndex + e.segment + 1, a = new t.P(h.getx(s), h.gety(s)), r = ht(a, o, f), n = r.signedDistanceFromCamera > 0 ? r.point : ft(d, a, i, 1, o, f), l = pt(e.writingMode, i, n, p);
                    if (l) return l;
                }
                const i = yt(g * l.getoffsetX(e.glyphStartIndex), v, x, s, u, d, e.segment, e.lineStartIndex, e.lineStartIndex + e.lineLength, h, r, _, m, f);
                if (!i) return {
                    notEnoughRoom: !0
                };
                y = [
                    i
                ];
            }
            for (const e of y)t.ak(c, e.point, e.angle);
            return {};
        }
        function ft(t, e, i, s, a, o) {
            const r = ht(t.add(t.sub(e)._unit()), a, o).point, n = i.sub(r);
            return i.add(n._mult(s / n.mag()));
        }
        function gt(e, i) {
            const { projectionCache: s, lineVertexArray: a, labelPlaneMatrix: o, tileAnchorPoint: r, distanceFromAnchor: n, getElevation: l, previousVertex: h, direction: c, absOffsetX: u } = i;
            if (s.projections[e]) return s.projections[e];
            const d = new t.P(a.getx(e), a.gety(e)), _ = ht(d, o, l);
            if (_.signedDistanceFromCamera > 0) return s.projections[e] = _.point, _.point;
            const p = e - c;
            return ft(0 === n ? r : new t.P(a.getx(p), a.gety(p)), d, h, u - n + 1, o, l);
        }
        function vt(t, e, i) {
            return t._unit()._perp()._mult(e * i);
        }
        function xt(e, i, s, a, o, r, n, l) {
            const { projectionCache: h, direction: c } = l;
            if (h.offsets[e]) return h.offsets[e];
            const u = s.add(i);
            if (e + c < a || e + c >= o) return h.offsets[e] = u, u;
            const d = gt(e + c, l), _ = vt(d.sub(s), n, c), p = s.add(_), m = d.add(_);
            return h.offsets[e] = t.al(r, u, p, m) || u, h.offsets[e];
        }
        function yt(t, e, i, s, a, o, r, n, l, h, c, u, d, _) {
            const p = s ? t - e : t + e;
            let m = p > 0 ? 1 : -1, f = 0;
            s && (m *= -1, f = Math.PI), m < 0 && (f += Math.PI);
            let g, v, x = m > 0 ? n + r : n + r + 1, y = a, b = a, w = 0, T = 0;
            const I = Math.abs(p), E = [];
            let S;
            for(; w + T <= I;){
                if (x += m, x < n || x >= l) return null;
                w += T, b = y, v = g;
                const t = {
                    projectionCache: u,
                    lineVertexArray: h,
                    labelPlaneMatrix: c,
                    tileAnchorPoint: o,
                    distanceFromAnchor: w,
                    getElevation: _,
                    previousVertex: b,
                    direction: m,
                    absOffsetX: I
                };
                if (y = gt(x, t), 0 === i) E.push(b), S = y.sub(b);
                else {
                    let e;
                    const s = y.sub(b);
                    e = 0 === s.mag() ? vt(gt(x + m, t).sub(y), i, m) : vt(s, i, m), v || (v = b.add(e)), g = xt(x, e, y, n, l, v, i, t), E.push(v), S = g.sub(v);
                }
                T = S.mag();
            }
            const C = S._mult((I - w) / T)._add(v || b), P = f + Math.atan2(y.y - b.y, y.x - b.x);
            return E.push(C), {
                point: C,
                angle: d ? P : 0,
                path: E
            };
        }
        const bt = new Float32Array([
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0
        ]);
        function wt(t, e) {
            for(let i = 0; i < t; i++){
                const t = e.length;
                e.resize(t + 4), e.float32.set(bt, 3 * t);
            }
        }
        function Tt(t, e, i) {
            const s = e[0], a = e[1];
            return t[0] = i[0] * s + i[4] * a + i[12], t[1] = i[1] * s + i[5] * a + i[13], t[3] = i[3] * s + i[7] * a + i[15], t;
        }
        const It = 100;
        class Et {
            constructor(t, e = new rt(t.width + 200, t.height + 200, 25), i = new rt(t.width + 200, t.height + 200, 25)){
                this.transform = t, this.grid = e, this.ignoredGrid = i, this.pitchfactor = Math.cos(t._pitch) * t.cameraToCenterDistance, this.screenRightBoundary = t.width + It, this.screenBottomBoundary = t.height + It, this.gridRightBoundary = t.width + 200, this.gridBottomBoundary = t.height + 200, this.perspectiveRatioCutoff = .6;
            }
            placeCollisionBox(t, e, i, s, a, o) {
                const r = this.projectAndGetPerspectiveRatio(s, t.anchorPointX, t.anchorPointY, o), n = i * r.perspectiveRatio, l = t.x1 * n + r.point.x, h = t.y1 * n + r.point.y, c = t.x2 * n + r.point.x, u = t.y2 * n + r.point.y;
                return !this.isInsideGrid(l, h, c, u) || "always" !== e && this.grid.hitTest(l, h, c, u, e, a) || r.perspectiveRatio < this.perspectiveRatioCutoff ? {
                    box: [],
                    offscreen: !1
                } : {
                    box: [
                        l,
                        h,
                        c,
                        u
                    ],
                    offscreen: this.isOffscreen(l, h, c, u)
                };
            }
            placeCollisionCircles(e, i, s, a, o, r, n, l, h, c, u, d, _, p) {
                const m = [], f = new t.P(i.anchorX, i.anchorY), g = ht(f, r, p), v = ct(this.transform.cameraToCenterDistance, g.signedDistanceFromCamera), x = (c ? o / v : o * v) / t.ap, y = ht(f, n, p).point, b = _t(x, a, i.lineOffsetX * x, i.lineOffsetY * x, !1, y, f, i, s, n, {
                    projections: {},
                    offsets: {}
                }, !1, p);
                let w = !1, T = !1, I = !0;
                if (b) {
                    const i = .5 * d * v + _, s = new t.P(-100, -100), a = new t.P(this.screenRightBoundary, this.screenBottomBoundary), o = new at, r = b.first, n = b.last;
                    let c = [];
                    for(let t = r.path.length - 1; t >= 1; t--)c.push(r.path[t]);
                    for(let t = 1; t < n.path.length; t++)c.push(n.path[t]);
                    const f = 2.5 * i;
                    if (l) {
                        const t = c.map((t)=>ht(t, l, p));
                        c = t.some((t)=>t.signedDistanceFromCamera <= 0) ? [] : t.map((t)=>t.point);
                    }
                    let g = [];
                    if (c.length > 0) {
                        const e = c[0].clone(), i = c[0].clone();
                        for(let t = 1; t < c.length; t++)e.x = Math.min(e.x, c[t].x), e.y = Math.min(e.y, c[t].y), i.x = Math.max(i.x, c[t].x), i.y = Math.max(i.y, c[t].y);
                        g = e.x >= s.x && i.x <= a.x && e.y >= s.y && i.y <= a.y ? [
                            c
                        ] : i.x < s.x || e.x > a.x || i.y < s.y || e.y > a.y ? [] : t.am([
                            c
                        ], s.x, s.y, a.x, a.y);
                    }
                    for (const t of g){
                        o.reset(t, .25 * i);
                        let s = 0;
                        s = o.length <= .5 * i ? 1 : Math.ceil(o.paddedLength / f) + 1;
                        for(let t = 0; t < s; t++){
                            const a = t / Math.max(s - 1, 1), r = o.lerp(a), n = r.x + It, l = r.y + It;
                            m.push(n, l, i, 0);
                            const c = n - i, d = l - i, _ = n + i, p = l + i;
                            if (I = I && this.isOffscreen(c, d, _, p), T = T || this.isInsideGrid(c, d, _, p), "always" !== e && this.grid.hitTestCircle(n, l, i, e, u) && (w = !0, !h)) return {
                                circles: [],
                                offscreen: !1,
                                collisionDetected: w
                            };
                        }
                    }
                }
                return {
                    circles: !h && w || !T || v < this.perspectiveRatioCutoff ? [] : m,
                    offscreen: I,
                    collisionDetected: w
                };
            }
            queryRenderedSymbols(e) {
                if (0 === e.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
                const i = [];
                let s = 1 / 0, a = 1 / 0, o = -1 / 0, r = -1 / 0;
                for (const n of e){
                    const e = new t.P(n.x + It, n.y + It);
                    s = Math.min(s, e.x), a = Math.min(a, e.y), o = Math.max(o, e.x), r = Math.max(r, e.y), i.push(e);
                }
                const n = this.grid.query(s, a, o, r).concat(this.ignoredGrid.query(s, a, o, r)), l = {}, h = {};
                for (const e of n){
                    const s = e.key;
                    if (void 0 === l[s.bucketInstanceId] && (l[s.bucketInstanceId] = {}), l[s.bucketInstanceId][s.featureIndex]) continue;
                    const a = [
                        new t.P(e.x1, e.y1),
                        new t.P(e.x2, e.y1),
                        new t.P(e.x2, e.y2),
                        new t.P(e.x1, e.y2)
                    ];
                    t.an(i, a) && (l[s.bucketInstanceId][s.featureIndex] = !0, void 0 === h[s.bucketInstanceId] && (h[s.bucketInstanceId] = []), h[s.bucketInstanceId].push(s.featureIndex));
                }
                return h;
            }
            insertCollisionBox(t, e, i, s, a, o) {
                (i ? this.ignoredGrid : this.grid).insert({
                    bucketInstanceId: s,
                    featureIndex: a,
                    collisionGroupID: o,
                    overlapMode: e
                }, t[0], t[1], t[2], t[3]);
            }
            insertCollisionCircles(t, e, i, s, a, o) {
                const r = i ? this.ignoredGrid : this.grid, n = {
                    bucketInstanceId: s,
                    featureIndex: a,
                    collisionGroupID: o,
                    overlapMode: e
                };
                for(let e = 0; e < t.length; e += 4)r.insertCircle(n, t[e], t[e + 1], t[e + 2]);
            }
            projectAndGetPerspectiveRatio(e, i, s, a) {
                let o;
                return a ? (o = [
                    i,
                    s,
                    a(i, s),
                    1
                ], t.ag(o, o, e)) : (o = [
                    i,
                    s,
                    0,
                    1
                ], Tt(o, o, e)), {
                    point: new t.P((o[0] / o[3] + 1) / 2 * this.transform.width + It, (-o[1] / o[3] + 1) / 2 * this.transform.height + It),
                    perspectiveRatio: .5 + this.transform.cameraToCenterDistance / o[3] * .5
                };
            }
            isOffscreen(t, e, i, s) {
                return i < It || t >= this.screenRightBoundary || s < It || e > this.screenBottomBoundary;
            }
            isInsideGrid(t, e, i, s) {
                return i >= 0 && t < this.gridRightBoundary && s >= 0 && e < this.gridBottomBoundary;
            }
            getViewportMatrix() {
                const e = t.ao([]);
                return t.$(e, e, [
                    -100,
                    -100,
                    0
                ]), e;
            }
        }
        function St(e, i, s) {
            return i * (t.N / (e.tileSize * Math.pow(2, s - e.tileID.overscaledZ)));
        }
        class Ct {
            constructor(t, e, i, s){
                this.opacity = t ? Math.max(0, Math.min(1, t.opacity + (t.placed ? e : -e))) : s && i ? 1 : 0, this.placed = i;
            }
            isHidden() {
                return 0 === this.opacity && !this.placed;
            }
        }
        class Pt {
            constructor(t, e, i, s, a){
                this.text = new Ct(t ? t.text : null, e, i, a), this.icon = new Ct(t ? t.icon : null, e, s, a);
            }
            isHidden() {
                return this.text.isHidden() && this.icon.isHidden();
            }
        }
        class Dt {
            constructor(t, e, i){
                this.text = t, this.icon = e, this.skipFade = i;
            }
        }
        class Mt {
            constructor(){
                this.invProjMatrix = t.Z(), this.viewportMatrix = t.Z(), this.circles = [];
            }
        }
        class zt {
            constructor(t, e, i, s, a){
                this.bucketInstanceId = t, this.featureIndex = e, this.sourceLayerIndex = i, this.bucketIndex = s, this.tileID = a;
            }
        }
        class Lt {
            constructor(t){
                this.crossSourceCollisions = t, this.maxGroupID = 0, this.collisionGroups = {};
            }
            get(t) {
                if (this.crossSourceCollisions) return {
                    ID: 0,
                    predicate: null
                };
                if (!this.collisionGroups[t]) {
                    const e = ++this.maxGroupID;
                    this.collisionGroups[t] = {
                        ID: e,
                        predicate: (t)=>t.collisionGroupID === e
                    };
                }
                return this.collisionGroups[t];
            }
        }
        function At(e, i, s, a, o) {
            const { horizontalAlign: r, verticalAlign: n } = t.au(e);
            return new t.P(-(r - .5) * i + a[0] * o, -(n - .5) * s + a[1] * o);
        }
        function Rt(e, i, s, a, o, r) {
            const { x1: n, x2: l, y1: h, y2: c, anchorPointX: u, anchorPointY: d } = e, _ = new t.P(i, s);
            return a && _._rotate(o ? r : -r), {
                x1: n + _.x,
                y1: h + _.y,
                x2: l + _.x,
                y2: c + _.y,
                anchorPointX: u,
                anchorPointY: d
            };
        }
        class kt {
            constructor(t, e, i, s, a){
                this.transform = t.clone(), this.terrain = e, this.collisionIndex = new Et(this.transform), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = i, this.retainedQueryData = {}, this.collisionGroups = new Lt(s), this.collisionCircleArrays = {}, this.prevPlacement = a, a && (a.prevPlacement = void 0), this.placedOrientations = {};
            }
            getBucketParts(e, i, s, a) {
                const o = s.getBucket(i), r = s.latestFeatureIndex;
                if (!o || !r || i.id !== o.layerIds[0]) return;
                const n = s.collisionBoxArray, l = o.layers[0].layout, h = Math.pow(2, this.transform.zoom - s.tileID.overscaledZ), c = s.tileSize / t.N, u = this.transform.calculatePosMatrix(s.tileID.toUnwrapped()), d = "map" === l.get("text-pitch-alignment"), _ = "map" === l.get("text-rotation-alignment"), p = St(s, 1, this.transform.zoom), m = nt(u, d, _, this.transform, p);
                let f = null;
                if (d) {
                    const e = lt(u, d, _, this.transform, p);
                    f = t.a1([], this.transform.labelPlaneMatrix, e);
                }
                this.retainedQueryData[o.bucketInstanceId] = new zt(o.bucketInstanceId, r, o.sourceLayerIndex, o.index, s.tileID);
                const g = {
                    bucket: o,
                    layout: l,
                    posMatrix: u,
                    textLabelPlaneMatrix: m,
                    labelToScreenMatrix: f,
                    scale: h,
                    textPixelRatio: c,
                    holdingForFade: s.holdingForFade(),
                    collisionBoxArray: n,
                    partiallyEvaluatedTextSize: t.ah(o.textSizeData, this.transform.zoom),
                    collisionGroup: this.collisionGroups.get(o.sourceID)
                };
                if (a) for (const t of o.sortKeyRanges){
                    const { sortKey: i, symbolInstanceStart: s, symbolInstanceEnd: a } = t;
                    e.push({
                        sortKey: i,
                        symbolInstanceStart: s,
                        symbolInstanceEnd: a,
                        parameters: g
                    });
                }
                else e.push({
                    symbolInstanceStart: 0,
                    symbolInstanceEnd: o.symbolInstances.length,
                    parameters: g
                });
            }
            attemptAnchorPlacement(e, i, s, a, o, r, n, l, h, c, u, d, _, p, m, f) {
                const g = t.aq[e.textAnchor], v = [
                    e.textOffset0,
                    e.textOffset1
                ], x = At(g, s, a, v, o), y = this.collisionIndex.placeCollisionBox(Rt(i, x.x, x.y, r, n, this.transform.angle), u, l, h, c.predicate, f);
                if ((!m || 0 !== this.collisionIndex.placeCollisionBox(Rt(m, x.x, x.y, r, n, this.transform.angle), u, l, h, c.predicate, f).box.length) && y.box.length > 0) {
                    let t;
                    if (this.prevPlacement && this.prevPlacement.variableOffsets[d.crossTileID] && this.prevPlacement.placements[d.crossTileID] && this.prevPlacement.placements[d.crossTileID].text && (t = this.prevPlacement.variableOffsets[d.crossTileID].anchor), 0 === d.crossTileID) throw new Error("symbolInstance.crossTileID can't be 0");
                    return this.variableOffsets[d.crossTileID] = {
                        textOffset: v,
                        width: s,
                        height: a,
                        anchor: g,
                        textBoxScale: o,
                        prevAnchor: t
                    }, this.markUsedJustification(_, g, d, p), _.allowVerticalPlacement && (this.markUsedOrientation(_, p, d), this.placedOrientations[d.crossTileID] = p), {
                        shift: x,
                        placedGlyphBoxes: y
                    };
                }
            }
            placeLayerBucketPart(e, i, s) {
                const { bucket: a, layout: o, posMatrix: r, textLabelPlaneMatrix: n, labelToScreenMatrix: l, textPixelRatio: h, holdingForFade: c, collisionBoxArray: u, partiallyEvaluatedTextSize: d, collisionGroup: _ } = e.parameters, p = o.get("text-optional"), m = o.get("icon-optional"), f = t.ar(o, "text-overlap", "text-allow-overlap"), g = "always" === f, v = t.ar(o, "icon-overlap", "icon-allow-overlap"), x = "always" === v, y = "map" === o.get("text-rotation-alignment"), b = "map" === o.get("text-pitch-alignment"), w = "none" !== o.get("icon-text-fit"), T = "viewport-y" === o.get("symbol-z-order"), I = g && (x || !a.hasIconData() || m), E = x && (g || !a.hasTextData() || p);
                !a.collisionArrays && u && a.deserializeCollisionBoxes(u);
                const S = this.retainedQueryData[a.bucketInstanceId].tileID, C = this.terrain ? (t, e)=>this.terrain.getElevation(S, t, e) : null, P = (e, u)=>{
                    var x, T;
                    if (i[e.crossTileID]) return;
                    if (c) return void (this.placements[e.crossTileID] = new Dt(!1, !1, !1));
                    let S = !1, P = !1, D = !0, M = null, z = {
                        box: null,
                        offscreen: null
                    }, L = {
                        box: null,
                        offscreen: null
                    }, A = null, R = null, k = null, F = 0, B = 0, O = 0;
                    u.textFeatureIndex ? F = u.textFeatureIndex : e.useRuntimeCollisionCircles && (F = e.featureIndex), u.verticalTextFeatureIndex && (B = u.verticalTextFeatureIndex);
                    const N = u.textBox;
                    if (N) {
                        const i = (i)=>{
                            let s = t.ai.horizontal;
                            if (a.allowVerticalPlacement && !i && this.prevPlacement) {
                                const t = this.prevPlacement.placedOrientations[e.crossTileID];
                                t && (this.placedOrientations[e.crossTileID] = t, s = t, this.markUsedOrientation(a, s, e));
                            }
                            return s;
                        }, s = (i, s)=>{
                            if (a.allowVerticalPlacement && e.numVerticalGlyphVertices > 0 && u.verticalTextBox) {
                                for (const e of a.writingModes)if (e === t.ai.vertical ? (z = s(), L = z) : z = i(), z && z.box && z.box.length) break;
                            } else z = i();
                        }, o = e.textAnchorOffsetStartIndex, n = e.textAnchorOffsetEndIndex;
                        if (n === o) {
                            const o = (t, i)=>{
                                const s = this.collisionIndex.placeCollisionBox(t, f, h, r, _.predicate, C);
                                return s && s.box && s.box.length && (this.markUsedOrientation(a, i, e), this.placedOrientations[e.crossTileID] = i), s;
                            };
                            s(()=>o(N, t.ai.horizontal), ()=>{
                                const i = u.verticalTextBox;
                                return a.allowVerticalPlacement && e.numVerticalGlyphVertices > 0 && i ? o(i, t.ai.vertical) : {
                                    box: null,
                                    offscreen: null
                                };
                            }), i(z && z.box && z.box.length);
                        } else {
                            let l = t.aq[null === (T = null === (x = this.prevPlacement) || void 0 === x ? void 0 : x.variableOffsets[e.crossTileID]) || void 0 === T ? void 0 : T.anchor];
                            const c = (t, i, s)=>{
                                const c = t.x2 - t.x1, u = t.y2 - t.y1, d = e.textBoxScale, p = w && "never" === v ? i : null;
                                let m = {
                                    box: [],
                                    offscreen: !1
                                }, g = "never" === f ? 1 : 2, x = "never";
                                l && g++;
                                for(let i = 0; i < g; i++){
                                    for(let i = o; i < n; i++){
                                        const o = a.textAnchorOffsets.get(i);
                                        if (l && o.textAnchor !== l) continue;
                                        const n = this.attemptAnchorPlacement(o, t, c, u, d, y, b, h, r, _, x, e, a, s, p, C);
                                        if (n && (m = n.placedGlyphBoxes, m && m.box && m.box.length)) return S = !0, M = n.shift, m;
                                    }
                                    l ? l = null : x = f;
                                }
                                return m;
                            };
                            s(()=>c(N, u.iconBox, t.ai.horizontal), ()=>{
                                const i = u.verticalTextBox;
                                return a.allowVerticalPlacement && !(z && z.box && z.box.length) && e.numVerticalGlyphVertices > 0 && i ? c(i, u.verticalIconBox, t.ai.vertical) : {
                                    box: null,
                                    offscreen: null
                                };
                            }), z && (S = z.box, D = z.offscreen);
                            const d = i(z && z.box);
                            if (!S && this.prevPlacement) {
                                const t = this.prevPlacement.variableOffsets[e.crossTileID];
                                t && (this.variableOffsets[e.crossTileID] = t, this.markUsedJustification(a, t.anchor, e, d));
                            }
                        }
                    }
                    if (A = z, S = A && A.box && A.box.length > 0, D = A && A.offscreen, e.useRuntimeCollisionCircles) {
                        const i = a.text.placedSymbolArray.get(e.centerJustifiedTextSymbolIndex), h = t.aj(a.textSizeData, d, i), c = o.get("text-padding");
                        R = this.collisionIndex.placeCollisionCircles(f, i, a.lineVertexArray, a.glyphOffsetArray, h, r, n, l, s, b, _.predicate, e.collisionCircleDiameter, c, C), R.circles.length && R.collisionDetected && !s && t.w("Collisions detected, but collision boxes are not shown"), S = g || R.circles.length > 0 && !R.collisionDetected, D = D && R.offscreen;
                    }
                    if (u.iconFeatureIndex && (O = u.iconFeatureIndex), u.iconBox) {
                        const t = (t)=>{
                            const e = w && M ? Rt(t, M.x, M.y, y, b, this.transform.angle) : t;
                            return this.collisionIndex.placeCollisionBox(e, v, h, r, _.predicate, C);
                        };
                        L && L.box && L.box.length && u.verticalIconBox ? (k = t(u.verticalIconBox), P = k.box.length > 0) : (k = t(u.iconBox), P = k.box.length > 0), D = D && k.offscreen;
                    }
                    const U = p || 0 === e.numHorizontalGlyphVertices && 0 === e.numVerticalGlyphVertices, Z = m || 0 === e.numIconVertices;
                    if (U || Z ? Z ? U || (P = P && S) : S = P && S : P = S = P && S, S && A && A.box && this.collisionIndex.insertCollisionBox(A.box, f, o.get("text-ignore-placement"), a.bucketInstanceId, L && L.box && B ? B : F, _.ID), P && k && this.collisionIndex.insertCollisionBox(k.box, v, o.get("icon-ignore-placement"), a.bucketInstanceId, O, _.ID), R && (S && this.collisionIndex.insertCollisionCircles(R.circles, f, o.get("text-ignore-placement"), a.bucketInstanceId, F, _.ID), s)) {
                        const t = a.bucketInstanceId;
                        let e = this.collisionCircleArrays[t];
                        void 0 === e && (e = this.collisionCircleArrays[t] = new Mt);
                        for(let t = 0; t < R.circles.length; t += 4)e.circles.push(R.circles[t + 0]), e.circles.push(R.circles[t + 1]), e.circles.push(R.circles[t + 2]), e.circles.push(R.collisionDetected ? 1 : 0);
                    }
                    if (0 === e.crossTileID) throw new Error("symbolInstance.crossTileID can't be 0");
                    if (0 === a.bucketInstanceId) throw new Error("bucket.bucketInstanceId can't be 0");
                    this.placements[e.crossTileID] = new Dt(S || I, P || E, D || a.justReloaded), i[e.crossTileID] = !0;
                };
                if (T) {
                    if (0 !== e.symbolInstanceStart) throw new Error("bucket.bucketInstanceId should be 0");
                    const t = a.getSortedSymbolIndexes(this.transform.angle);
                    for(let e = t.length - 1; e >= 0; --e){
                        const i = t[e];
                        P(a.symbolInstances.get(i), a.collisionArrays[i]);
                    }
                } else for(let t = e.symbolInstanceStart; t < e.symbolInstanceEnd; t++)P(a.symbolInstances.get(t), a.collisionArrays[t]);
                if (s && a.bucketInstanceId in this.collisionCircleArrays) {
                    const e = this.collisionCircleArrays[a.bucketInstanceId];
                    t.as(e.invProjMatrix, r), e.viewportMatrix = this.collisionIndex.getViewportMatrix();
                }
                a.justReloaded = !1;
            }
            markUsedJustification(e, i, s, a) {
                let o;
                o = a === t.ai.vertical ? s.verticalPlacedTextSymbolIndex : ({
                    left: s.leftJustifiedTextSymbolIndex,
                    center: s.centerJustifiedTextSymbolIndex,
                    right: s.rightJustifiedTextSymbolIndex
                })[t.at(i)];
                const r = [
                    s.leftJustifiedTextSymbolIndex,
                    s.centerJustifiedTextSymbolIndex,
                    s.rightJustifiedTextSymbolIndex,
                    s.verticalPlacedTextSymbolIndex
                ];
                for (const t of r)t >= 0 && (e.text.placedSymbolArray.get(t).crossTileID = o >= 0 && t !== o ? 0 : s.crossTileID);
            }
            markUsedOrientation(e, i, s) {
                const a = i === t.ai.horizontal || i === t.ai.horizontalOnly ? i : 0, o = i === t.ai.vertical ? i : 0, r = [
                    s.leftJustifiedTextSymbolIndex,
                    s.centerJustifiedTextSymbolIndex,
                    s.rightJustifiedTextSymbolIndex
                ];
                for (const t of r)e.text.placedSymbolArray.get(t).placedOrientation = a;
                s.verticalPlacedTextSymbolIndex && (e.text.placedSymbolArray.get(s.verticalPlacedTextSymbolIndex).placedOrientation = o);
            }
            commit(t) {
                this.commitTime = t, this.zoomAtLastRecencyCheck = this.transform.zoom;
                const e = this.prevPlacement;
                let i = !1;
                this.prevZoomAdjustment = e ? e.zoomAdjustment(this.transform.zoom) : 0;
                const s = e ? e.symbolFadeChange(t) : 1, a = e ? e.opacities : {}, o = e ? e.variableOffsets : {}, r = e ? e.placedOrientations : {};
                for(const t in this.placements){
                    const e = this.placements[t], o = a[t];
                    o ? (this.opacities[t] = new Pt(o, s, e.text, e.icon), i = i || e.text !== o.text.placed || e.icon !== o.icon.placed) : (this.opacities[t] = new Pt(null, s, e.text, e.icon, e.skipFade), i = i || e.text || e.icon);
                }
                for(const t in a){
                    const e = a[t];
                    if (!this.opacities[t]) {
                        const a = new Pt(e, s, !1, !1);
                        a.isHidden() || (this.opacities[t] = a, i = i || e.text.placed || e.icon.placed);
                    }
                }
                for(const t in o)this.variableOffsets[t] || !this.opacities[t] || this.opacities[t].isHidden() || (this.variableOffsets[t] = o[t]);
                for(const t in r)this.placedOrientations[t] || !this.opacities[t] || this.opacities[t].isHidden() || (this.placedOrientations[t] = r[t]);
                if (e && void 0 === e.lastPlacementChangeTime) throw new Error("Last placement time for previous placement is not defined");
                i ? this.lastPlacementChangeTime = t : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = e ? e.lastPlacementChangeTime : t);
            }
            updateLayerOpacities(t, e) {
                const i = {};
                for (const s of e){
                    const e = s.getBucket(t);
                    e && s.latestFeatureIndex && t.id === e.layerIds[0] && this.updateBucketOpacities(e, i, s.collisionBoxArray);
                }
            }
            updateBucketOpacities(e, i, s) {
                e.hasTextData() && (e.text.opacityVertexArray.clear(), e.text.hasVisibleVertices = !1), e.hasIconData() && (e.icon.opacityVertexArray.clear(), e.icon.hasVisibleVertices = !1), e.hasIconCollisionBoxData() && e.iconCollisionBox.collisionVertexArray.clear(), e.hasTextCollisionBoxData() && e.textCollisionBox.collisionVertexArray.clear();
                const a = e.layers[0], o = a.layout, r = new Pt(null, 0, !1, !1, !0), n = o.get("text-allow-overlap"), l = o.get("icon-allow-overlap"), h = a._unevaluatedLayout.hasValue("text-variable-anchor") || a._unevaluatedLayout.hasValue("text-variable-anchor-offset"), c = "map" === o.get("text-rotation-alignment"), u = "map" === o.get("text-pitch-alignment"), d = "none" !== o.get("icon-text-fit"), _ = new Pt(null, 0, n && (l || !e.hasIconData() || o.get("icon-optional")), l && (n || !e.hasTextData() || o.get("text-optional")), !0);
                !e.collisionArrays && s && (e.hasIconCollisionBoxData() || e.hasTextCollisionBoxData()) && e.deserializeCollisionBoxes(s);
                const p = (t, e, i)=>{
                    for(let s = 0; s < e / 4; s++)t.opacityVertexArray.emplaceBack(i);
                    t.hasVisibleVertices = t.hasVisibleVertices || i !== qt;
                };
                for(let s = 0; s < e.symbolInstances.length; s++){
                    const a = e.symbolInstances.get(s), { numHorizontalGlyphVertices: o, numVerticalGlyphVertices: n, crossTileID: l } = a;
                    let m = this.opacities[l];
                    i[l] ? m = r : m || (m = _, this.opacities[l] = m), i[l] = !0;
                    const f = a.numIconVertices > 0, g = this.placedOrientations[a.crossTileID], v = g === t.ai.vertical, x = g === t.ai.horizontal || g === t.ai.horizontalOnly;
                    if (o > 0 || n > 0) {
                        const t = Vt(m.text);
                        p(e.text, o, v ? qt : t), p(e.text, n, x ? qt : t);
                        const i = m.text.isHidden();
                        [
                            a.rightJustifiedTextSymbolIndex,
                            a.centerJustifiedTextSymbolIndex,
                            a.leftJustifiedTextSymbolIndex
                        ].forEach((t)=>{
                            t >= 0 && (e.text.placedSymbolArray.get(t).hidden = i || v ? 1 : 0);
                        }), a.verticalPlacedTextSymbolIndex >= 0 && (e.text.placedSymbolArray.get(a.verticalPlacedTextSymbolIndex).hidden = i || x ? 1 : 0);
                        const s = this.variableOffsets[a.crossTileID];
                        s && this.markUsedJustification(e, s.anchor, a, g);
                        const r = this.placedOrientations[a.crossTileID];
                        r && (this.markUsedJustification(e, "left", a, r), this.markUsedOrientation(e, r, a));
                    }
                    if (f) {
                        const t = Vt(m.icon), i = !(d && a.verticalPlacedIconSymbolIndex && v);
                        a.placedIconSymbolIndex >= 0 && (p(e.icon, a.numIconVertices, i ? t : qt), e.icon.placedSymbolArray.get(a.placedIconSymbolIndex).hidden = m.icon.isHidden()), a.verticalPlacedIconSymbolIndex >= 0 && (p(e.icon, a.numVerticalIconVertices, i ? qt : t), e.icon.placedSymbolArray.get(a.verticalPlacedIconSymbolIndex).hidden = m.icon.isHidden());
                    }
                    if (e.hasIconCollisionBoxData() || e.hasTextCollisionBoxData()) {
                        const i = e.collisionArrays[s];
                        if (i) {
                            let s = new t.P(0, 0);
                            if (i.textBox || i.verticalTextBox) {
                                let t = !0;
                                if (h) {
                                    const e = this.variableOffsets[l];
                                    e ? (s = At(e.anchor, e.width, e.height, e.textOffset, e.textBoxScale), c && s._rotate(u ? this.transform.angle : -this.transform.angle)) : t = !1;
                                }
                                i.textBox && Ft(e.textCollisionBox.collisionVertexArray, m.text.placed, !t || v, s.x, s.y), i.verticalTextBox && Ft(e.textCollisionBox.collisionVertexArray, m.text.placed, !t || x, s.x, s.y);
                            }
                            const a = Boolean(!x && i.verticalIconBox);
                            i.iconBox && Ft(e.iconCollisionBox.collisionVertexArray, m.icon.placed, a, d ? s.x : 0, d ? s.y : 0), i.verticalIconBox && Ft(e.iconCollisionBox.collisionVertexArray, m.icon.placed, !a, d ? s.x : 0, d ? s.y : 0);
                        }
                    }
                }
                if (e.sortFeatures(this.transform.angle), this.retainedQueryData[e.bucketInstanceId] && (this.retainedQueryData[e.bucketInstanceId].featureSortOrder = e.featureSortOrder), e.hasTextData() && e.text.opacityVertexBuffer && e.text.opacityVertexBuffer.updateData(e.text.opacityVertexArray), e.hasIconData() && e.icon.opacityVertexBuffer && e.icon.opacityVertexBuffer.updateData(e.icon.opacityVertexArray), e.hasIconCollisionBoxData() && e.iconCollisionBox.collisionVertexBuffer && e.iconCollisionBox.collisionVertexBuffer.updateData(e.iconCollisionBox.collisionVertexArray), e.hasTextCollisionBoxData() && e.textCollisionBox.collisionVertexBuffer && e.textCollisionBox.collisionVertexBuffer.updateData(e.textCollisionBox.collisionVertexArray), e.text.opacityVertexArray.length !== e.text.layoutVertexArray.length / 4) throw new Error(`bucket.text.opacityVertexArray.length (= ${e.text.opacityVertexArray.length}) !== bucket.text.layoutVertexArray.length (= ${e.text.layoutVertexArray.length}) / 4`);
                if (e.icon.opacityVertexArray.length !== e.icon.layoutVertexArray.length / 4) throw new Error(`bucket.icon.opacityVertexArray.length (= ${e.icon.opacityVertexArray.length}) !== bucket.icon.layoutVertexArray.length (= ${e.icon.layoutVertexArray.length}) / 4`);
                if (e.bucketInstanceId in this.collisionCircleArrays) {
                    const t = this.collisionCircleArrays[e.bucketInstanceId];
                    e.placementInvProjMatrix = t.invProjMatrix, e.placementViewportMatrix = t.viewportMatrix, e.collisionCircleArray = t.circles, delete this.collisionCircleArrays[e.bucketInstanceId];
                }
            }
            symbolFadeChange(t) {
                return 0 === this.fadeDuration ? 1 : (t - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
            }
            zoomAdjustment(t) {
                return Math.max(0, (this.transform.zoom - t) / 1.5);
            }
            hasTransitions(t) {
                return this.stale || t - this.lastPlacementChangeTime < this.fadeDuration;
            }
            stillRecent(t, e) {
                const i = this.zoomAtLastRecencyCheck === e ? 1 - this.zoomAdjustment(e) : 1;
                return this.zoomAtLastRecencyCheck = e, this.commitTime + this.fadeDuration * i > t;
            }
            setStale() {
                this.stale = !0;
            }
        }
        function Ft(t, e, i, s, a) {
            t.emplaceBack(e ? 1 : 0, i ? 1 : 0, s || 0, a || 0), t.emplaceBack(e ? 1 : 0, i ? 1 : 0, s || 0, a || 0), t.emplaceBack(e ? 1 : 0, i ? 1 : 0, s || 0, a || 0), t.emplaceBack(e ? 1 : 0, i ? 1 : 0, s || 0, a || 0);
        }
        const Bt = Math.pow(2, 25), Ot = Math.pow(2, 24), Nt = Math.pow(2, 17), Ut = Math.pow(2, 16), Zt = Math.pow(2, 9), Gt = Math.pow(2, 8), jt = Math.pow(2, 1);
        function Vt(t) {
            if (0 === t.opacity && !t.placed) return 0;
            if (1 === t.opacity && t.placed) return 4294967295;
            const e = t.placed ? 1 : 0, i = Math.floor(127 * t.opacity);
            return i * Bt + e * Ot + i * Nt + e * Ut + i * Zt + e * Gt + i * jt + e;
        }
        const qt = 0;
        class $t {
            constructor(t){
                this._sortAcrossTiles = "viewport-y" !== t.layout.get("symbol-z-order") && !t.layout.get("symbol-sort-key").isConstant(), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
            }
            continuePlacement(t, e, i, s, a) {
                const o = this._bucketParts;
                for(; this._currentTileIndex < t.length;)if (e.getBucketParts(o, s, t[this._currentTileIndex], this._sortAcrossTiles), this._currentTileIndex++, a()) return !0;
                for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, o.sort((t, e)=>t.sortKey - e.sortKey)); this._currentPartIndex < o.length;)if (e.placeLayerBucketPart(o[this._currentPartIndex], this._seenCrossTileIDs, i), this._currentPartIndex++, a()) return !0;
                return !1;
            }
        }
        class Wt {
            constructor(t, e, i, s, a, o, r, n){
                this.placement = new kt(t, e, o, r, n), this._currentPlacementIndex = i.length - 1, this._forceFullPlacement = s, this._showCollisionBoxes = a, this._done = !1;
            }
            isDone() {
                return this._done;
            }
            continuePlacement(e, i, s) {
                const a = t.h.now(), o = ()=>!this._forceFullPlacement && t.h.now() - a > 2;
                for(; this._currentPlacementIndex >= 0;){
                    const t = i[e[this._currentPlacementIndex]], a = this.placement.collisionIndex.transform.zoom;
                    if ("symbol" === t.type && (!t.minzoom || t.minzoom <= a) && (!t.maxzoom || t.maxzoom > a)) {
                        if (this._inProgressLayer || (this._inProgressLayer = new $t(t)), this._inProgressLayer.continuePlacement(s[t.source], this.placement, this._showCollisionBoxes, t, o)) return;
                        delete this._inProgressLayer;
                    }
                    this._currentPlacementIndex--;
                }
                this._done = !0;
            }
            commit(t) {
                return this.placement.commit(t), this.placement;
            }
        }
        const Ht = 512 / t.N / 2;
        class Xt {
            constructor(e, i, s){
                this.tileID = e, this.bucketInstanceId = s, this._symbolsByKey = {};
                const a = new Map;
                for(let t = 0; t < i.length; t++){
                    const e = i.get(t), s = e.key, o = a.get(s);
                    o ? o.push(e) : a.set(s, [
                        e
                    ]);
                }
                for (const [e, i] of a){
                    const s = {
                        positions: i.map((t)=>({
                                x: Math.floor(t.anchorX * Ht),
                                y: Math.floor(t.anchorY * Ht)
                            })),
                        crossTileIDs: i.map((t)=>t.crossTileID)
                    };
                    if (s.positions.length > 128) {
                        const e = new t.av(s.positions.length, 16, Uint16Array);
                        for (const { x: t, y: i } of s.positions)e.add(t, i);
                        e.finish(), delete s.positions, s.index = e;
                    }
                    this._symbolsByKey[e] = s;
                }
            }
            getScaledCoordinates(e, i) {
                const { x: s, y: a, z: o } = this.tileID.canonical, { x: r, y: n, z: l } = i.canonical, h = Ht / Math.pow(2, l - o), c = (n * t.N + e.anchorY) * h, u = a * t.N * Ht;
                return {
                    x: Math.floor((r * t.N + e.anchorX) * h - s * t.N * Ht),
                    y: Math.floor(c - u)
                };
            }
            findMatches(t, e, i) {
                const s = this.tileID.canonical.z < e.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - e.canonical.z);
                for(let a = 0; a < t.length; a++){
                    const o = t.get(a);
                    if (o.crossTileID) continue;
                    const r = this._symbolsByKey[o.key];
                    if (!r) continue;
                    const n = this.getScaledCoordinates(o, e);
                    if (r.index) {
                        const t = r.index.range(n.x - s, n.y - s, n.x + s, n.y + s).sort();
                        for (const e of t){
                            const t = r.crossTileIDs[e];
                            if (!i[t]) {
                                i[t] = !0, o.crossTileID = t;
                                break;
                            }
                        }
                    } else if (r.positions) for(let t = 0; t < r.positions.length; t++){
                        const e = r.positions[t], a = r.crossTileIDs[t];
                        if (Math.abs(e.x - n.x) <= s && Math.abs(e.y - n.y) <= s && !i[a]) {
                            i[a] = !0, o.crossTileID = a;
                            break;
                        }
                    }
                }
            }
            getCrossTileIDsLists() {
                return Object.values(this._symbolsByKey).map(({ crossTileIDs: t })=>t);
            }
        }
        class Kt {
            constructor(){
                this.maxCrossTileID = 0;
            }
            generate() {
                return ++this.maxCrossTileID;
            }
        }
        class Qt {
            constructor(){
                this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
            }
            handleWrapJump(t) {
                const e = Math.round((t - this.lng) / 360);
                if (0 !== e) for(const t in this.indexes){
                    const i = this.indexes[t], s = {};
                    for(const t in i){
                        const a = i[t];
                        a.tileID = a.tileID.unwrapTo(a.tileID.wrap + e), s[a.tileID.key] = a;
                    }
                    this.indexes[t] = s;
                }
                this.lng = t;
            }
            addBucket(t, e, i) {
                if (this.indexes[t.overscaledZ] && this.indexes[t.overscaledZ][t.key]) {
                    if (this.indexes[t.overscaledZ][t.key].bucketInstanceId === e.bucketInstanceId) return !1;
                    this.removeBucketCrossTileIDs(t.overscaledZ, this.indexes[t.overscaledZ][t.key]);
                }
                for(let t = 0; t < e.symbolInstances.length; t++)e.symbolInstances.get(t).crossTileID = 0;
                this.usedCrossTileIDs[t.overscaledZ] || (this.usedCrossTileIDs[t.overscaledZ] = {});
                const s = this.usedCrossTileIDs[t.overscaledZ];
                for(const i in this.indexes){
                    const a = this.indexes[i];
                    if (Number(i) > t.overscaledZ) for(const i in a){
                        const o = a[i];
                        o.tileID.isChildOf(t) && o.findMatches(e.symbolInstances, t, s);
                    }
                    else {
                        const o = a[t.scaledTo(Number(i)).key];
                        o && o.findMatches(e.symbolInstances, t, s);
                    }
                }
                for(let t = 0; t < e.symbolInstances.length; t++){
                    const a = e.symbolInstances.get(t);
                    a.crossTileID || (a.crossTileID = i.generate(), s[a.crossTileID] = !0);
                }
                return void 0 === this.indexes[t.overscaledZ] && (this.indexes[t.overscaledZ] = {}), this.indexes[t.overscaledZ][t.key] = new Xt(t, e.symbolInstances, e.bucketInstanceId), !0;
            }
            removeBucketCrossTileIDs(t, e) {
                for (const i of e.getCrossTileIDsLists())for (const e of i)delete this.usedCrossTileIDs[t][e];
            }
            removeStaleBuckets(t) {
                let e = !1;
                for(const i in this.indexes){
                    const s = this.indexes[i];
                    for(const a in s)t[s[a].bucketInstanceId] || (this.removeBucketCrossTileIDs(i, s[a]), delete s[a], e = !0);
                }
                return e;
            }
        }
        class Yt {
            constructor(){
                this.layerIndexes = {}, this.crossTileIDs = new Kt, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
            }
            addLayer(t, e, i) {
                let s = this.layerIndexes[t.id];
                void 0 === s && (s = this.layerIndexes[t.id] = new Qt);
                let a = !1;
                const o = {};
                s.handleWrapJump(i);
                for (const i of e){
                    const e = i.getBucket(t);
                    e && t.id === e.layerIds[0] && (e.bucketInstanceId || (e.bucketInstanceId = ++this.maxBucketInstanceId), s.addBucket(i.tileID, e, this.crossTileIDs) && (a = !0), o[e.bucketInstanceId] = !0);
                }
                return s.removeStaleBuckets(o) && (a = !0), a;
            }
            pruneUnusedLayers(t) {
                const e = {};
                t.forEach((t)=>{
                    e[t] = !0;
                });
                for(const t in this.layerIndexes)e[t] || delete this.layerIndexes[t];
            }
        }
        const Jt = (e, i)=>t.x(e, i && i.filter((t)=>"source.canvas" !== t.identifier)), te = t.F(t.ax, [
            "addLayer",
            "removeLayer",
            "setPaintProperty",
            "setLayoutProperty",
            "setFilter",
            "addSource",
            "removeSource",
            "setLayerZoomRange",
            "setLight",
            "setTransition",
            "setGeoJSONSourceData",
            "setGlyphs",
            "setSprite"
        ]), ee = t.F(t.ax, [
            "setCenter",
            "setZoom",
            "setBearing",
            "setPitch"
        ]), ie = t.aw();
        class se extends t.E {
            constructor(e, i = {}){
                super(), this.map = e, this.dispatcher = new M(st(), this, e._getMapId()), this.imageManager = new b, this.imageManager.setEventedParent(this), this.glyphManager = new E(e._requestManager, i.localIdeographFontFamily), this.lineAtlas = new D(256, 512), this.crossTileSymbolIndex = new Yt, this._spritesImagesIds = {}, this._layers = {}, this._order = [], this.sourceCaches = {}, this.zoomHistory = new t.ay, this._loaded = !1, this._availableImages = [], this._resetUpdates(), this.dispatcher.broadcast("setReferrer", t.az());
                const s = this;
                this._rtlTextPluginCallback = se.registerForPluginStateChange((e)=>{
                    s.dispatcher.broadcast("syncRTLPluginState", {
                        pluginStatus: e.pluginStatus,
                        pluginURL: e.pluginURL
                    }, (e, i)=>{
                        if (t.aA(e), i && i.every((t)=>t)) for(const t in s.sourceCaches){
                            const e = s.sourceCaches[t].getSource().type;
                            "vector" !== e && "geojson" !== e || s.sourceCaches[t].reload();
                        }
                    });
                }), this.on("data", (t)=>{
                    if ("source" !== t.dataType || "metadata" !== t.sourceDataType) return;
                    const e = this.sourceCaches[t.sourceId];
                    if (!e) return;
                    const i = e.getSource();
                    if (i && i.vectorLayerIds) for(const t in this._layers){
                        const e = this._layers[t];
                        e.source === i.id && this._validateLayer(e);
                    }
                });
            }
            loadURL(e, i = {}, s) {
                this.fire(new t.k("dataloading", {
                    dataType: "style"
                })), i.validate = "boolean" != typeof i.validate || i.validate;
                const a = this.map._requestManager.transformRequest(e, c.Style);
                this._request = t.f(a, (e, a)=>{
                    this._request = null, e ? this.fire(new t.j(e)) : a && this._load(a, i, s);
                });
            }
            loadJSON(e, i = {}, s) {
                this.fire(new t.k("dataloading", {
                    dataType: "style"
                })), this._request = t.h.frame(()=>{
                    this._request = null, i.validate = !1 !== i.validate, this._load(e, i, s);
                });
            }
            loadEmpty() {
                this.fire(new t.k("dataloading", {
                    dataType: "style"
                })), this._load(ie, {
                    validate: !1
                });
            }
            _load(e, i, s) {
                var a;
                const o = i.transformStyle ? i.transformStyle(s, e) : e;
                if (!i.validate || !Jt(this, t.y(o))) {
                    this._loaded = !0, this.stylesheet = o;
                    for(const t in o.sources)this.addSource(t, o.sources[t], {
                        validate: !1
                    });
                    o.sprite ? this._loadSprite(o.sprite) : this.imageManager.setLoaded(!0), this.glyphManager.setURL(o.glyphs), this._createLayers(), this.light = new P(this.stylesheet.light), this.map.setTerrain(null !== (a = this.stylesheet.terrain) && void 0 !== a ? a : null), this.fire(new t.k("data", {
                        dataType: "style"
                    })), this.fire(new t.k("style.load"));
                }
            }
            _createLayers() {
                const e = t.aB(this.stylesheet.layers);
                this.dispatcher.broadcast("setLayers", e), this._order = e.map((t)=>t.id), this._layers = {}, this._serializedLayers = null;
                for (const i of e){
                    const e = t.aC(i);
                    e.setEventedParent(this, {
                        layer: {
                            id: i.id
                        }
                    }), this._layers[i.id] = e;
                }
            }
            _loadSprite(e, i = !1, s) {
                this.imageManager.setLoaded(!1), this._spriteRequest = function(e, i, s, a) {
                    const o = g(e), r = o.length, n = s > 1 ? "@2x" : "", l = {}, u = {}, d = {};
                    for (const { id: e, url: s } of o){
                        const o = i.transformRequest(i.normalizeSpriteURL(s, n, ".json"), c.SpriteJSON), _ = `${e}_${o.url}`;
                        l[_] = t.f(o, (t, i)=>{
                            delete l[_], u[e] = i, v(a, u, d, t, r);
                        });
                        const p = i.transformRequest(i.normalizeSpriteURL(s, n, ".png"), c.SpriteImage), m = `${e}_${p.url}`;
                        l[m] = h.getImage(p, (t, i)=>{
                            delete l[m], d[e] = i, v(a, u, d, t, r);
                        });
                    }
                    return {
                        cancel () {
                            for (const t of Object.values(l))t.cancel();
                        }
                    };
                }(e, this.map._requestManager, this.map.getPixelRatio(), (e, a)=>{
                    if (this._spriteRequest = null, e) this.fire(new t.j(e));
                    else if (a) for(const t in a){
                        this._spritesImagesIds[t] = [];
                        const e = this._spritesImagesIds[t] ? this._spritesImagesIds[t].filter((t)=>!(t in a)) : [];
                        for (const t of e)this.imageManager.removeImage(t), this._changedImages[t] = !0;
                        for(const e in a[t]){
                            const s = "default" === t ? e : `${t}:${e}`;
                            this._spritesImagesIds[t].push(s), s in this.imageManager.images ? this.imageManager.updateImage(s, a[t][e], !1) : this.imageManager.addImage(s, a[t][e]), i && (this._changedImages[s] = !0);
                        }
                    }
                    this.imageManager.setLoaded(!0), this._availableImages = this.imageManager.listImages(), i && (this._changed = !0), this.dispatcher.broadcast("setImages", this._availableImages), this.fire(new t.k("data", {
                        dataType: "style"
                    })), s && s(e);
                });
            }
            _unloadSprite() {
                for (const t of Object.values(this._spritesImagesIds).flat())this.imageManager.removeImage(t), this._changedImages[t] = !0;
                this._spritesImagesIds = {}, this._availableImages = this.imageManager.listImages(), this._changed = !0, this.dispatcher.broadcast("setImages", this._availableImages), this.fire(new t.k("data", {
                    dataType: "style"
                }));
            }
            _validateLayer(e) {
                const i = this.sourceCaches[e.source];
                if (!i) return;
                const s = e.sourceLayer;
                if (!s) return;
                const a = i.getSource();
                ("geojson" === a.type || a.vectorLayerIds && -1 === a.vectorLayerIds.indexOf(s)) && this.fire(new t.j(new Error(`Source layer "${s}" does not exist on source "${a.id}" as specified by style layer "${e.id}".`)));
            }
            loaded() {
                if (!this._loaded) return !1;
                if (Object.keys(this._updatedSources).length) return !1;
                for(const t in this.sourceCaches)if (!this.sourceCaches[t].loaded()) return !1;
                return !!this.imageManager.isLoaded();
            }
            _serializeByIds(t) {
                const e = this._serializedAllLayers();
                if (!t || 0 === t.length) return Object.values(e);
                const i = [];
                for (const s of t)e[s] && i.push(e[s]);
                return i;
            }
            _serializedAllLayers() {
                let t = this._serializedLayers;
                if (t) return t;
                t = this._serializedLayers = {};
                const e = Object.keys(this._layers);
                for (const i of e){
                    const e = this._layers[i];
                    "custom" !== e.type && (t[i] = e.serialize());
                }
                return t;
            }
            hasTransitions() {
                if (this.light && this.light.hasTransition()) return !0;
                for(const t in this.sourceCaches)if (this.sourceCaches[t].hasTransition()) return !0;
                for(const t in this._layers)if (this._layers[t].hasTransition()) return !0;
                return !1;
            }
            _checkLoaded() {
                if (!this._loaded) throw new Error("Style is not done loading.");
            }
            update(e) {
                if (!this._loaded) return;
                const i = this._changed;
                if (this._changed) {
                    const t = Object.keys(this._updatedLayers), i = Object.keys(this._removedLayers);
                    (t.length || i.length) && this._updateWorkerLayers(t, i);
                    for(const t in this._updatedSources){
                        const e = this._updatedSources[t];
                        if ("reload" === e) this._reloadSource(t);
                        else {
                            if ("clear" !== e) throw new Error(`Invalid action ${e}`);
                            this._clearSource(t);
                        }
                    }
                    this._updateTilesForChangedImages(), this._updateTilesForChangedGlyphs();
                    for(const t in this._updatedPaintProps)this._layers[t].updateTransitions(e);
                    this.light.updateTransitions(e), this._resetUpdates();
                }
                const s = {};
                for(const t in this.sourceCaches){
                    const e = this.sourceCaches[t];
                    s[t] = e.used, e.used = !1;
                }
                for (const t of this._order){
                    const i = this._layers[t];
                    i.recalculate(e, this._availableImages), !i.isHidden(e.zoom) && i.source && (this.sourceCaches[i.source].used = !0);
                }
                for(const e in s){
                    const i = this.sourceCaches[e];
                    s[e] !== i.used && i.fire(new t.k("data", {
                        sourceDataType: "visibility",
                        dataType: "source",
                        sourceId: e
                    }));
                }
                this.light.recalculate(e), this.z = e.zoom, i && this.fire(new t.k("data", {
                    dataType: "style"
                }));
            }
            _updateTilesForChangedImages() {
                const t = Object.keys(this._changedImages);
                if (t.length) {
                    for(const e in this.sourceCaches)this.sourceCaches[e].reloadTilesForDependencies([
                        "icons",
                        "patterns"
                    ], t);
                    this._changedImages = {};
                }
            }
            _updateTilesForChangedGlyphs() {
                if (this._glyphsDidChange) {
                    for(const t in this.sourceCaches)this.sourceCaches[t].reloadTilesForDependencies([
                        "glyphs"
                    ], [
                        ""
                    ]);
                    this._glyphsDidChange = !1;
                }
            }
            _updateWorkerLayers(t, e) {
                this.dispatcher.broadcast("updateLayers", {
                    layers: this._serializeByIds(t),
                    removedIds: e
                });
            }
            _resetUpdates() {
                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {}, this._glyphsDidChange = !1;
            }
            setState(e, i = {}) {
                this._checkLoaded();
                const s = this.serialize();
                if (e = i.transformStyle ? i.transformStyle(s, e) : e, Jt(this, t.y(e))) return !1;
                (e = t.aD(e)).layers = t.aB(e.layers);
                const a = t.aE(s, e).filter((t)=>!(t.command in ee));
                if (0 === a.length) return !1;
                const o = a.filter((t)=>!(t.command in te));
                if (o.length > 0) throw new Error(`Unimplemented: ${o.map((t)=>t.command).join(", ")}.`);
                for (const t of a)"setTransition" !== t.command && this[t.command].apply(this, t.args);
                return this.stylesheet = e, this._serializedLayers = null, !0;
            }
            addImage(e, i) {
                if (this.getImage(e)) return this.fire(new t.j(new Error(`An image named "${e}" already exists.`)));
                this.imageManager.addImage(e, i), this._afterImageUpdated(e);
            }
            updateImage(t, e) {
                this.imageManager.updateImage(t, e);
            }
            getImage(t) {
                return this.imageManager.getImage(t);
            }
            removeImage(e) {
                if (!this.getImage(e)) return this.fire(new t.j(new Error(`An image named "${e}" does not exist.`)));
                this.imageManager.removeImage(e), this._afterImageUpdated(e);
            }
            _afterImageUpdated(e) {
                this._availableImages = this.imageManager.listImages(), this._changedImages[e] = !0, this._changed = !0, this.dispatcher.broadcast("setImages", this._availableImages), this.fire(new t.k("data", {
                    dataType: "style"
                }));
            }
            listImages() {
                return this._checkLoaded(), this.imageManager.listImages();
            }
            addSource(e, i, s = {}) {
                if (this._checkLoaded(), void 0 !== this.sourceCaches[e]) throw new Error(`Source "${e}" already exists.`);
                if (!i.type) throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(i).join(", ")}.`);
                if ([
                    "vector",
                    "raster",
                    "geojson",
                    "video",
                    "image"
                ].indexOf(i.type) >= 0 && this._validate(t.y.source, `sources.${e}`, i, null, s)) return;
                this.map && this.map._collectResourceTiming && (i.collectResourceTiming = !0);
                const a = this.sourceCaches[e] = new K(e, i, this.dispatcher);
                a.style = this, a.setEventedParent(this, ()=>({
                        isSourceLoaded: a.loaded(),
                        source: a.serialize(),
                        sourceId: e
                    })), a.onAdd(this.map), this._changed = !0;
            }
            removeSource(e) {
                if (this._checkLoaded(), void 0 === this.sourceCaches[e]) throw new Error("There is no source with this ID");
                for(const i in this._layers)if (this._layers[i].source === e) return this.fire(new t.j(new Error(`Source "${e}" cannot be removed while layer "${i}" is using it.`)));
                const i = this.sourceCaches[e];
                delete this.sourceCaches[e], delete this._updatedSources[e], i.fire(new t.k("data", {
                    sourceDataType: "metadata",
                    dataType: "source",
                    sourceId: e
                })), i.setEventedParent(null), i.onRemove(this.map), this._changed = !0;
            }
            setGeoJSONSourceData(t, e) {
                if (this._checkLoaded(), void 0 === this.sourceCaches[t]) throw new Error(`There is no source with this ID=${t}`);
                const i = this.sourceCaches[t].getSource();
                if ("geojson" !== i.type) throw new Error(`geojsonSource.type is ${i.type}, which is !== 'geojson`);
                i.setData(e), this._changed = !0;
            }
            getSource(t) {
                return this.sourceCaches[t] && this.sourceCaches[t].getSource();
            }
            addLayer(e, i, s = {}) {
                this._checkLoaded();
                const a = e.id;
                if (this.getLayer(a)) return void this.fire(new t.j(new Error(`Layer "${a}" already exists on this map.`)));
                let o;
                if ("custom" === e.type) {
                    if (Jt(this, t.aF(e))) return;
                    o = t.aC(e);
                } else {
                    if ("source" in e && "object" == typeof e.source && (this.addSource(a, e.source), e = t.aD(e), e = t.e(e, {
                        source: a
                    })), this._validate(t.y.layer, `layers.${a}`, e, {
                        arrayIndex: -1
                    }, s)) return;
                    o = t.aC(e), this._validateLayer(o), o.setEventedParent(this, {
                        layer: {
                            id: a
                        }
                    });
                }
                const r = i ? this._order.indexOf(i) : this._order.length;
                if (i && -1 === r) this.fire(new t.j(new Error(`Cannot add layer "${a}" before non-existing layer "${i}".`)));
                else {
                    if (this._order.splice(r, 0, a), this._layerOrderChanged = !0, this._layers[a] = o, this._removedLayers[a] && o.source && "custom" !== o.type) {
                        const t = this._removedLayers[a];
                        delete this._removedLayers[a], t.type !== o.type ? this._updatedSources[o.source] = "clear" : (this._updatedSources[o.source] = "reload", this.sourceCaches[o.source].pause());
                    }
                    this._updateLayer(o), o.onAdd && o.onAdd(this.map);
                }
            }
            moveLayer(e, i) {
                if (this._checkLoaded(), this._changed = !0, !this._layers[e]) return void this.fire(new t.j(new Error(`The layer '${e}' does not exist in the map's style and cannot be moved.`)));
                if (e === i) return;
                const s = this._order.indexOf(e);
                this._order.splice(s, 1);
                const a = i ? this._order.indexOf(i) : this._order.length;
                i && -1 === a ? this.fire(new t.j(new Error(`Cannot move layer "${e}" before non-existing layer "${i}".`))) : (this._order.splice(a, 0, e), this._layerOrderChanged = !0);
            }
            removeLayer(e) {
                this._checkLoaded();
                const i = this._layers[e];
                if (!i) return void this.fire(new t.j(new Error(`Cannot remove non-existing layer "${e}".`)));
                i.setEventedParent(null);
                const s = this._order.indexOf(e);
                this._order.splice(s, 1), this._layerOrderChanged = !0, this._changed = !0, this._removedLayers[e] = i, delete this._layers[e], this._serializedLayers && delete this._serializedLayers[e], delete this._updatedLayers[e], delete this._updatedPaintProps[e], i.onRemove && i.onRemove(this.map);
            }
            getLayer(t) {
                return this._layers[t];
            }
            getLayersOrder() {
                return [
                    ...this._order
                ];
            }
            hasLayer(t) {
                return t in this._layers;
            }
            setLayerZoomRange(e, i, s) {
                this._checkLoaded();
                const a = this.getLayer(e);
                a ? a.minzoom === i && a.maxzoom === s || (null != i && (a.minzoom = i), null != s && (a.maxzoom = s), this._updateLayer(a)) : this.fire(new t.j(new Error(`Cannot set the zoom range of non-existing layer "${e}".`)));
            }
            setFilter(e, i, s = {}) {
                this._checkLoaded();
                const a = this.getLayer(e);
                if (a) {
                    if (!t.aG(a.filter, i)) return null == i ? (a.filter = void 0, void this._updateLayer(a)) : void (this._validate(t.y.filter, `layers.${a.id}.filter`, i, null, s) || (a.filter = t.aD(i), this._updateLayer(a)));
                } else this.fire(new t.j(new Error(`Cannot filter non-existing layer "${e}".`)));
            }
            getFilter(e) {
                return t.aD(this.getLayer(e).filter);
            }
            setLayoutProperty(e, i, s, a = {}) {
                this._checkLoaded();
                const o = this.getLayer(e);
                o ? t.aG(o.getLayoutProperty(i), s) || (o.setLayoutProperty(i, s, a), this._updateLayer(o)) : this.fire(new t.j(new Error(`Cannot style non-existing layer "${e}".`)));
            }
            getLayoutProperty(e, i) {
                const s = this.getLayer(e);
                if (s) return s.getLayoutProperty(i);
                this.fire(new t.j(new Error(`Cannot get style of non-existing layer "${e}".`)));
            }
            setPaintProperty(e, i, s, a = {}) {
                this._checkLoaded();
                const o = this.getLayer(e);
                o ? t.aG(o.getPaintProperty(i), s) || (o.setPaintProperty(i, s, a) && this._updateLayer(o), this._changed = !0, this._updatedPaintProps[e] = !0) : this.fire(new t.j(new Error(`Cannot style non-existing layer "${e}".`)));
            }
            getPaintProperty(t, e) {
                return this.getLayer(t).getPaintProperty(e);
            }
            setFeatureState(e, i) {
                this._checkLoaded();
                const s = e.source, a = e.sourceLayer, o = this.sourceCaches[s];
                if (void 0 === o) return void this.fire(new t.j(new Error(`The source '${s}' does not exist in the map's style.`)));
                const r = o.getSource().type;
                "geojson" === r && a ? this.fire(new t.j(new Error("GeoJSON sources cannot have a sourceLayer parameter."))) : "vector" !== r || a ? (void 0 === e.id && this.fire(new t.j(new Error("The feature id parameter must be provided."))), o.setFeatureState(a, e.id, i)) : this.fire(new t.j(new Error("The sourceLayer parameter must be provided for vector source types.")));
            }
            removeFeatureState(e, i) {
                this._checkLoaded();
                const s = e.source, a = this.sourceCaches[s];
                if (void 0 === a) return void this.fire(new t.j(new Error(`The source '${s}' does not exist in the map's style.`)));
                const o = a.getSource().type, r = "vector" === o ? e.sourceLayer : void 0;
                "vector" !== o || r ? i && "string" != typeof e.id && "number" != typeof e.id ? this.fire(new t.j(new Error("A feature id is required to remove its specific state property."))) : a.removeFeatureState(r, e.id, i) : this.fire(new t.j(new Error("The sourceLayer parameter must be provided for vector source types.")));
            }
            getFeatureState(e) {
                this._checkLoaded();
                const i = e.source, s = e.sourceLayer, a = this.sourceCaches[i];
                if (void 0 !== a) return "vector" !== a.getSource().type || s ? (void 0 === e.id && this.fire(new t.j(new Error("The feature id parameter must be provided."))), a.getFeatureState(s, e.id)) : void this.fire(new t.j(new Error("The sourceLayer parameter must be provided for vector source types.")));
                this.fire(new t.j(new Error(`The source '${i}' does not exist in the map's style.`)));
            }
            getTransition() {
                return t.e({
                    duration: 300,
                    delay: 0
                }, this.stylesheet && this.stylesheet.transition);
            }
            serialize() {
                if (!this._loaded) return;
                const e = t.aH(this.sourceCaches, (t)=>t.serialize()), i = this._serializeByIds(this._order), s = this.map.getTerrain() || void 0, a = this.stylesheet;
                return t.aI({
                    version: a.version,
                    name: a.name,
                    metadata: a.metadata,
                    light: a.light,
                    center: a.center,
                    zoom: a.zoom,
                    bearing: a.bearing,
                    pitch: a.pitch,
                    sprite: a.sprite,
                    glyphs: a.glyphs,
                    transition: a.transition,
                    sources: e,
                    layers: i,
                    terrain: s
                }, (t)=>void 0 !== t);
            }
            _updateLayer(t) {
                this._updatedLayers[t.id] = !0, t.source && !this._updatedSources[t.source] && "raster" !== this.sourceCaches[t.source].getSource().type && (this._updatedSources[t.source] = "reload", this.sourceCaches[t.source].pause()), this._serializedLayers = null, this._changed = !0;
            }
            _flattenAndSortRenderedFeatures(t) {
                const e = (t)=>"fill-extrusion" === this._layers[t].type, i = {}, s = [];
                for(let a = this._order.length - 1; a >= 0; a--){
                    const o = this._order[a];
                    if (e(o)) {
                        i[o] = a;
                        for (const e of t){
                            const t = e[o];
                            if (t) for (const e of t)s.push(e);
                        }
                    }
                }
                s.sort((t, e)=>e.intersectionZ - t.intersectionZ);
                const a = [];
                for(let o = this._order.length - 1; o >= 0; o--){
                    const r = this._order[o];
                    if (e(r)) for(let t = s.length - 1; t >= 0; t--){
                        const e = s[t].feature;
                        if (i[e.layer.id] < o) break;
                        a.push(e), s.pop();
                    }
                    else for (const e of t){
                        const t = e[r];
                        if (t) for (const e of t)a.push(e.feature);
                    }
                }
                return a;
            }
            queryRenderedFeatures(e, i, s) {
                i && i.filter && this._validate(t.y.filter, "queryRenderedFeatures.filter", i.filter, null, i);
                const a = {};
                if (i && i.layers) {
                    if (!Array.isArray(i.layers)) return this.fire(new t.j(new Error("parameters.layers must be an Array."))), [];
                    for (const e of i.layers){
                        const i = this._layers[e];
                        if (!i) return this.fire(new t.j(new Error(`The layer '${e}' does not exist in the map's style and cannot be queried for features.`))), [];
                        a[i.source] = !0;
                    }
                }
                const o = [];
                i.availableImages = this._availableImages;
                const r = this._serializedAllLayers();
                for(const t in this.sourceCaches)i.layers && !a[t] || o.push(q(this.sourceCaches[t], this._layers, r, e, i, s));
                return this.placement && o.push(function(t, e, i, s, a, o, r) {
                    const n = {}, l = o.queryRenderedSymbols(s), h = [];
                    for (const t of Object.keys(l).map(Number))h.push(r[t]);
                    h.sort($);
                    for (const i of h){
                        const s = i.featureIndex.lookupSymbolFeatures(l[i.bucketInstanceId], e, i.bucketIndex, i.sourceLayerIndex, a.filter, a.layers, a.availableImages, t);
                        for(const t in s){
                            const e = n[t] = n[t] || [], a = s[t];
                            a.sort((t, e)=>{
                                const s = i.featureSortOrder;
                                if (s) {
                                    const i = s.indexOf(t.featureIndex);
                                    return s.indexOf(e.featureIndex) - i;
                                }
                                return e.featureIndex - t.featureIndex;
                            });
                            for (const t of a)e.push(t);
                        }
                    }
                    for(const e in n)n[e].forEach((s)=>{
                        const a = s.feature, o = i[t[e].source].getFeatureState(a.layer["source-layer"], a.id);
                        a.source = a.layer.source, a.layer["source-layer"] && (a.sourceLayer = a.layer["source-layer"]), a.state = o;
                    });
                    return n;
                }(this._layers, r, this.sourceCaches, e, i, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(o);
            }
            querySourceFeatures(e, i) {
                i && i.filter && this._validate(t.y.filter, "querySourceFeatures.filter", i.filter, null, i);
                const s = this.sourceCaches[e];
                return s ? function(t, e) {
                    const i = t.getRenderableIds().map((e)=>t.getTileByID(e)), s = [], a = {};
                    for(let t = 0; t < i.length; t++){
                        const o = i[t], r = o.tileID.canonical.key;
                        a[r] || (a[r] = !0, o.querySourceFeatures(s, e));
                    }
                    return s;
                }(s, i) : [];
            }
            addSourceType(t, e, i) {
                return j(t) ? i(new Error(`A source type called "${t}" already exists.`)) : (((t, e)=>{
                    G[t] = e;
                })(t, e), e.workerSourceURL ? void this.dispatcher.broadcast("loadWorkerSource", {
                    name: t,
                    url: e.workerSourceURL
                }, i) : i(null, null));
            }
            getLight() {
                return this.light.getLight();
            }
            setLight(e, i = {}) {
                this._checkLoaded();
                const s = this.light.getLight();
                let a = !1;
                for(const i in e)if (!t.aG(e[i], s[i])) {
                    a = !0;
                    break;
                }
                if (!a) return;
                const o = {
                    now: t.h.now(),
                    transition: t.e({
                        duration: 300,
                        delay: 0
                    }, this.stylesheet.transition)
                };
                this.light.setLight(e, i), this.light.updateTransitions(o);
            }
            _validate(e, i, s, a, o = {}) {
                return (!o || !1 !== o.validate) && Jt(this, e.call(t.y, t.e({
                    key: i,
                    style: this.serialize(),
                    value: s,
                    styleSpec: t.v
                }, a)));
            }
            _remove(e = !0) {
                this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.cancel(), this._spriteRequest = null), t.aJ.off("pluginStateChange", this._rtlTextPluginCallback);
                for(const t in this._layers)this._layers[t].setEventedParent(null);
                for(const t in this.sourceCaches){
                    const e = this.sourceCaches[t];
                    e.setEventedParent(null), e.onRemove(this.map);
                }
                this.imageManager.setEventedParent(null), this.setEventedParent(null), this.dispatcher.remove(e);
            }
            _clearSource(t) {
                this.sourceCaches[t].clearTiles();
            }
            _reloadSource(t) {
                this.sourceCaches[t].resume(), this.sourceCaches[t].reload();
            }
            _updateSources(t) {
                for(const e in this.sourceCaches)this.sourceCaches[e].update(t, this.map.terrain);
            }
            _generateCollisionBoxes() {
                for(const t in this.sourceCaches)this._reloadSource(t);
            }
            _updatePlacement(e, i, s, a, o = !1) {
                let r = !1, n = !1;
                const l = {};
                for (const t of this._order){
                    const i = this._layers[t];
                    if ("symbol" !== i.type) continue;
                    if (!l[i.source]) {
                        const t = this.sourceCaches[i.source];
                        l[i.source] = t.getRenderableIds(!0).map((e)=>t.getTileByID(e)).sort((t, e)=>e.tileID.overscaledZ - t.tileID.overscaledZ || (t.tileID.isLessThan(e.tileID) ? -1 : 1));
                    }
                    const s = this.crossTileSymbolIndex.addLayer(i, l[i.source], e.center.lng);
                    r = r || s;
                }
                if (this.crossTileSymbolIndex.pruneUnusedLayers(this._order), ((o = o || this._layerOrderChanged || 0 === s) || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(t.h.now(), e.zoom)) && (this.pauseablePlacement = new Wt(e, this.map.terrain, this._order, o, i, s, a, this.placement), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, l), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(t.h.now()), n = !0), r && this.pauseablePlacement.placement.setStale()), n || r) for (const t of this._order){
                    const e = this._layers[t];
                    "symbol" === e.type && this.placement.updateLayerOpacities(e, l[e.source]);
                }
                return !this.pauseablePlacement.isDone() || this.placement.hasTransitions(t.h.now());
            }
            _releaseSymbolFadeTiles() {
                for(const t in this.sourceCaches)this.sourceCaches[t].releaseSymbolFadeTiles();
            }
            getImages(t, e, i) {
                this.imageManager.getImages(e.icons, i), this._updateTilesForChangedImages();
                const s = this.sourceCaches[e.source];
                s && s.setDependencies(e.tileID.key, e.type, e.icons);
            }
            getGlyphs(t, e, i) {
                this.glyphManager.getGlyphs(e.stacks, i);
                const s = this.sourceCaches[e.source];
                s && s.setDependencies(e.tileID.key, e.type, [
                    ""
                ]);
            }
            getResource(e, i, s) {
                return t.m(i, s);
            }
            getGlyphsUrl() {
                return this.stylesheet.glyphs || null;
            }
            setGlyphs(e, i = {}) {
                this._checkLoaded(), e && this._validate(t.y.glyphs, "glyphs", e, null, i) || (this._glyphsDidChange = !0, this.stylesheet.glyphs = e, this.glyphManager.entries = {}, this.glyphManager.setURL(e));
            }
            addSprite(e, i, s = {}, a) {
                this._checkLoaded();
                const o = [
                    {
                        id: e,
                        url: i
                    }
                ], r = [
                    ...g(this.stylesheet.sprite),
                    ...o
                ];
                this._validate(t.y.sprite, "sprite", r, null, s) || (this.stylesheet.sprite = r, this._loadSprite(o, !0, a));
            }
            removeSprite(e) {
                this._checkLoaded();
                const i = g(this.stylesheet.sprite);
                if (i.find((t)=>t.id === e)) {
                    if (this._spritesImagesIds[e]) for (const t of this._spritesImagesIds[e])this.imageManager.removeImage(t), this._changedImages[t] = !0;
                    i.splice(i.findIndex((t)=>t.id === e), 1), this.stylesheet.sprite = i.length > 0 ? i : void 0, delete this._spritesImagesIds[e], this._availableImages = this.imageManager.listImages(), this._changed = !0, this.dispatcher.broadcast("setImages", this._availableImages), this.fire(new t.k("data", {
                        dataType: "style"
                    }));
                } else this.fire(new t.j(new Error(`Sprite "${e}" doesn't exists on this map.`)));
            }
            getSprite() {
                return g(this.stylesheet.sprite);
            }
            setSprite(e, i = {}, s) {
                this._checkLoaded(), e && this._validate(t.y.sprite, "sprite", e, null, i) || (this.stylesheet.sprite = e, e ? this._loadSprite(e, !0, s) : (this._unloadSprite(), s && s(null)));
            }
        }
        se.registerForPluginStateChange = t.aK;
        var ae = t.Q([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            }
        ]), oe = "attribute vec3 a_pos3d;uniform mat4 u_matrix;uniform float u_ele_delta;varying vec2 v_texture_pos;varying float v_depth;void main() {float extent=8192.0;float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/extent;gl_Position=u_matrix*vec4(a_pos3d.xy,get_elevation(a_pos3d.xy)-ele_delta,1.0);v_depth=gl_Position.z/gl_Position.w;}";
        const re = {
            prelude: ne("#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\n", "#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}\n#ifdef TERRAIN3D\nuniform sampler2D u_terrain;uniform float u_terrain_dim;uniform mat4 u_terrain_matrix;uniform vec4 u_terrain_unpack;uniform float u_terrain_exaggeration;uniform highp sampler2D u_depth;\n#endif\nconst highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitShifts=vec4(1.)/bitSh;highp float unpack(highp vec4 color) {return dot(color,bitShifts);}highp float depthOpacity(vec3 frag) {\n#ifdef TERRAIN3D\nhighp float d=unpack(texture2D(u_depth,frag.xy*0.5+0.5))+0.0001-frag.z;return 1.0-max(0.0,min(1.0,-d*500.0));\n#else\nreturn 1.0;\n#endif\n}float calculate_visibility(vec4 pos) {\n#ifdef TERRAIN3D\nvec3 frag=pos.xyz/pos.w;highp float d=depthOpacity(frag);if (d > 0.95) return 1.0;return (d+depthOpacity(frag+vec3(0.0,0.01,0.0)))/2.0;\n#else\nreturn 1.0;\n#endif\n}float ele(vec2 pos) {\n#ifdef TERRAIN3D\nvec4 rgb=(texture2D(u_terrain,pos)*255.0)*u_terrain_unpack;return rgb.r+rgb.g+rgb.b-u_terrain_unpack.a;\n#else\nreturn 0.0;\n#endif\n}float get_elevation(vec2 pos) {\n#ifdef TERRAIN3D\nvec2 coord=(u_terrain_matrix*vec4(pos,0.0,1.0)).xy*u_terrain_dim+1.0;vec2 f=fract(coord);vec2 c=(floor(coord)+0.5)/(u_terrain_dim+2.0);float d=1.0/(u_terrain_dim+2.0);float tl=ele(c);float tr=ele(c+vec2(d,0.0));float bl=ele(c+vec2(0.0,d));float br=ele(c+vec2(d,d));float elevation=mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);return elevation*u_terrain_exaggeration;\n#else\nreturn 0.0;\n#endif\n}"),
            background: ne("uniform vec4 u_color;uniform float u_opacity;void main() {gl_FragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
            backgroundPattern: ne("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}"),
            circle: ne("varying vec3 v_data;varying float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));gl_FragColor=v_visibility*opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;varying vec3 v_data;varying float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);float ele=get_elevation(circle_center);v_visibility=calculate_visibility(u_matrix*vec4(circle_center,ele,1.0));if (u_pitch_with_map) {vec2 corner_position=circle_center;if (u_scale_with_map) {corner_position+=extrude*(radius+stroke_width)*u_extrude_scale;} else {vec4 projected_center=u_matrix*vec4(circle_center,0,1);corner_position+=extrude*(radius+stroke_width)*u_extrude_scale*(projected_center.w/u_camera_to_center_distance);}gl_Position=u_matrix*vec4(corner_position,ele,1);} else {gl_Position=u_matrix*vec4(circle_center,ele,1);if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);}"),
            clippingMask: ne("void main() {gl_FragColor=vec4(1.0);}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
            heatmap: ne("uniform highp float u_intensity;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec4 pos=vec4(floor(a_pos*0.5)+extrude,0,1);gl_Position=u_matrix*pos;}"),
            heatmapTexture: ne("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(0.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"),
            collisionBox: ne("varying float v_placed;varying float v_notUsed;void main() {float alpha=0.5;gl_FragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {gl_FragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {gl_FragColor*=.1;}}", "attribute vec2 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;attribute vec2 a_shift;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_anchor_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);gl_Position=u_matrix*vec4(a_pos,get_elevation(a_pos),1.0);gl_Position.xy+=(a_extrude+a_shift)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}"),
            collisionCircle: ne("varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);gl_FragColor=color*alpha*opacity_t;}", "attribute vec2 a_pos;attribute float a_radius;attribute vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),
            debug: ne("uniform highp vec4 u_color;uniform sampler2D u_overlay;varying vec2 v_uv;void main() {vec4 overlay_color=texture2D(u_overlay,v_uv);gl_FragColor=mix(u_color,overlay_color,overlay_color.a);}", "attribute vec2 a_pos;varying vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*u_overlay_scale,get_elevation(a_pos),1);}"),
            fill: ne("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_FragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);}"),
            fillOutline: ne("varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=outline_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"),
            fillOutlinePattern: ne("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=mix(color1,color2,u_fade)*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"),
            fillPattern: ne("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_fade)*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}"),
            fillExtrusion: ne("varying vec4 v_color;void main() {gl_FragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;attribute vec2 a_pos;attribute vec4 a_normal_ed;\n#ifdef TERRAIN3D\nattribute vec2 a_centroid;\n#endif\nvarying vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 normal=a_normal_ed.xyz;\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);gl_Position=u_matrix*vec4(a_pos,t > 0.0 ? height : base,1);float colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;float directional=clamp(dot(normal/16384.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}"),
            fillExtrusionPattern: ne("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);gl_FragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec2 a_pos;attribute vec4 a_normal_ed;\n#ifdef TERRAIN3D\nattribute vec2 a_centroid;\n#endif\nvarying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);float z=t > 0.0 ? height : base;gl_Position=u_matrix*vec4(a_pos,z,1);vec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0\n? a_pos\n: vec2(edgedistance,z*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}"),
            hillshadePrepare: ne("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture2D(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack)/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))/pow(2.0,exaggeration+(19.2562-u_zoom));gl_FragColor=clamp(vec4(deriv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),
            hillshade: ne("uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;\n#define PI 3.141592653589793\nvoid main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;}"),
            line: ne("uniform lowp float u_device_pixel_ratio;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_linesofar;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"),
            lineGradient: ne("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;varying highp vec2 v_uv;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture2D(u_image,v_uv);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;attribute float a_uv_x;attribute float a_split_index;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp vec2 v_uv;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"),
            linePattern: ne("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture2D(u_image,pos_a),texture2D(u_image,pos_b),u_fade);gl_FragColor=color*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}"),
            lineSDF: ne("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform float u_sdfgamma;uniform float u_mix;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture2D(u_image,v_tex_a).a;float sdfdist_b=texture2D(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);alpha*=smoothstep(0.5-u_sdfgamma/floorwidth,0.5+u_sdfgamma/floorwidth,sdfdist);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_patternscale_a;uniform float u_tex_y_a;uniform vec2 u_patternscale_b;uniform float u_tex_y_b;uniform vec2 u_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_tex_a=vec2(a_linesofar*u_patternscale_a.x/floorwidth,normal.y*u_patternscale_a.y+u_tex_y_a);v_tex_b=vec2(a_linesofar*u_patternscale_b.x/floorwidth,normal.y*u_patternscale_b.y+u_tex_y_b);v_width2=vec2(outset,inset);}"),
            raster: ne("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);gl_FragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos0=(((a_texture_pos/8192.0)-0.5)/u_buffer_scale )+0.5;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}"),
            symbolIcon: ne("uniform sampler2D u_texture;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,ele,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),ele,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,ele,1.0);float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0),z,1.0);v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float visibility=calculate_visibility(projectedPoint);v_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));}"),
            symbolSDF: ne("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float inner_edge=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);inner_edge=inner_edge+gamma*gamma_scale;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(inner_edge-gamma_scaled,inner_edge+gamma_scaled,dist);if (u_is_halo) {lowp float halo_edge=(6.0-halo_width/fontScale)/SDF_PX;alpha=min(smoothstep(halo_edge-gamma_scaled,halo_edge+gamma_scaled,dist),1.0-alpha);}gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,ele,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),ele,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,ele,1.0);float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset),z,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}"),
            symbolTextAndIcon: ne("#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;gl_FragColor=texture2D(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}", "const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,ele,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),ele,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,ele,1.0);float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale),z,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity,is_sdf);}"),
            terrain: ne("uniform sampler2D u_texture;varying vec2 v_texture_pos;void main() {gl_FragColor=texture2D(u_texture,v_texture_pos);}", oe),
            terrainDepth: ne("varying float v_depth;const highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitMsk=vec4(0.,vec3(1./256.0));highp vec4 pack(highp float value) {highp vec4 comp=fract(value*bitSh);comp-=comp.xxyz*bitMsk;return comp;}void main() {gl_FragColor=pack(v_depth);}", oe),
            terrainCoords: ne("precision mediump float;uniform sampler2D u_texture;uniform float u_terrain_coords_id;varying vec2 v_texture_pos;void main() {vec4 rgba=texture2D(u_texture,v_texture_pos);gl_FragColor=vec4(rgba.r,rgba.g,rgba.b,u_terrain_coords_id);}", oe)
        };
        function ne(t, e) {
            const i = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g, s = e.match(/attribute ([\w]+) ([\w]+)/g), a = t.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), o = e.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), r = o ? o.concat(a) : a, n = {};
            return {
                fragmentSource: t = t.replace(i, (t, e, i, s, a)=>(n[a] = !0, "define" === e ? `\n#ifndef HAS_UNIFORM_u_${a}\nvarying ${i} ${s} ${a};\n#else\nuniform ${i} ${s} u_${a};\n#endif\n` : `\n#ifdef HAS_UNIFORM_u_${a}\n    ${i} ${s} ${a} = u_${a};\n#endif\n`)),
                vertexSource: e = e.replace(i, (t, e, i, s, a)=>{
                    const o = "float" === s ? "vec2" : "vec4", r = a.match(/color/) ? "color" : o;
                    return n[a] ? "define" === e ? `\n#ifndef HAS_UNIFORM_u_${a}\nuniform lowp float u_${a}_t;\nattribute ${i} ${o} a_${a};\nvarying ${i} ${s} ${a};\n#else\nuniform ${i} ${s} u_${a};\n#endif\n` : "vec4" === r ? `\n#ifndef HAS_UNIFORM_u_${a}\n    ${a} = a_${a};\n#else\n    ${i} ${s} ${a} = u_${a};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${a}\n    ${a} = unpack_mix_${r}(a_${a}, u_${a}_t);\n#else\n    ${i} ${s} ${a} = u_${a};\n#endif\n` : "define" === e ? `\n#ifndef HAS_UNIFORM_u_${a}\nuniform lowp float u_${a}_t;\nattribute ${i} ${o} a_${a};\n#else\nuniform ${i} ${s} u_${a};\n#endif\n` : "vec4" === r ? `\n#ifndef HAS_UNIFORM_u_${a}\n    ${i} ${s} ${a} = a_${a};\n#else\n    ${i} ${s} ${a} = u_${a};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${a}\n    ${i} ${s} ${a} = unpack_mix_${r}(a_${a}, u_${a}_t);\n#else\n    ${i} ${s} ${a} = u_${a};\n#endif\n`;
                }),
                staticAttributes: s,
                staticUniforms: r
            };
        }
        class le {
            constructor(){
                this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffer = null, this.vao = null;
            }
            bind(t, e, i, s, a, o, r, n, l) {
                this.context = t;
                let h = this.boundPaintVertexBuffers.length !== s.length;
                for(let t = 0; !h && t < s.length; t++)this.boundPaintVertexBuffers[t] !== s[t] && (h = !0);
                !this.vao || this.boundProgram !== e || this.boundLayoutVertexBuffer !== i || h || this.boundIndexBuffer !== a || this.boundVertexOffset !== o || this.boundDynamicVertexBuffer !== r || this.boundDynamicVertexBuffer2 !== n || this.boundDynamicVertexBuffer3 !== l ? this.freshBind(e, i, s, a, o, r, n, l) : (t.bindVertexArray.set(this.vao), r && r.bind(), a && a.dynamicDraw && a.bind(), n && n.bind(), l && l.bind());
            }
            freshBind(t, e, i, s, a, o, r, n) {
                const l = t.numAttributes, h = this.context, c = h.gl;
                this.vao && this.destroy(), this.vao = h.createVertexArray(), h.bindVertexArray.set(this.vao), this.boundProgram = t, this.boundLayoutVertexBuffer = e, this.boundPaintVertexBuffers = i, this.boundIndexBuffer = s, this.boundVertexOffset = a, this.boundDynamicVertexBuffer = o, this.boundDynamicVertexBuffer2 = r, this.boundDynamicVertexBuffer3 = n, e.enableAttributes(c, t);
                for (const e of i)e.enableAttributes(c, t);
                o && o.enableAttributes(c, t), r && r.enableAttributes(c, t), n && n.enableAttributes(c, t), e.bind(), e.setVertexAttribPointers(c, t, a);
                for (const e of i)e.bind(), e.setVertexAttribPointers(c, t, a);
                o && (o.bind(), o.setVertexAttribPointers(c, t, a)), s && s.bind(), r && (r.bind(), r.setVertexAttribPointers(c, t, a)), n && (n.bind(), n.setVertexAttribPointers(c, t, a)), h.currentNumAttributes = l;
            }
            destroy() {
                this.vao && (this.context.deleteVertexArray(this.vao), this.vao = null);
            }
        }
        function he(t) {
            const e = [];
            for(let i = 0; i < t.length; i++){
                if (null === t[i]) continue;
                const s = t[i].split(" ");
                e.push(s.pop());
            }
            return e;
        }
        class ce {
            constructor(e, i, s, a, o, r){
                const n = e.gl;
                this.program = n.createProgram();
                const l = he(i.staticAttributes), h = s ? s.getBinderAttributes() : [], c = l.concat(h), u = re.prelude.staticUniforms ? he(re.prelude.staticUniforms) : [], d = i.staticUniforms ? he(i.staticUniforms) : [], _ = s ? s.getBinderUniforms() : [], p = u.concat(d).concat(_), m = [];
                for (const t of p)m.indexOf(t) < 0 && m.push(t);
                const f = s ? s.defines() : [];
                o && f.push("#define OVERDRAW_INSPECTOR;"), r && f.push("#define TERRAIN3D;");
                const g = f.concat(re.prelude.fragmentSource, i.fragmentSource).join("\n"), v = f.concat(re.prelude.vertexSource, i.vertexSource).join("\n"), x = n.createShader(n.FRAGMENT_SHADER);
                if (n.isContextLost()) return void (this.failedToCreate = !0);
                if (n.shaderSource(x, g), n.compileShader(x), !n.getShaderParameter(x, n.COMPILE_STATUS)) throw new Error(`Could not compile fragment shader: ${n.getShaderInfoLog(x)}`);
                n.attachShader(this.program, x);
                const y = n.createShader(n.VERTEX_SHADER);
                if (n.isContextLost()) return void (this.failedToCreate = !0);
                if (n.shaderSource(y, v), n.compileShader(y), !n.getShaderParameter(y, n.COMPILE_STATUS)) throw new Error(`Could not compile vertex shader: ${n.getShaderInfoLog(y)}`);
                n.attachShader(this.program, y), this.attributes = {};
                const b = {};
                this.numAttributes = c.length;
                for(let t = 0; t < this.numAttributes; t++)c[t] && (n.bindAttribLocation(this.program, t, c[t]), this.attributes[c[t]] = t);
                if (n.linkProgram(this.program), !n.getProgramParameter(this.program, n.LINK_STATUS)) throw new Error(`Program failed to link: ${n.getProgramInfoLog(this.program)}`);
                n.deleteShader(y), n.deleteShader(x);
                for(let t = 0; t < m.length; t++){
                    const e = m[t];
                    if (e && !b[e]) {
                        const t = n.getUniformLocation(this.program, e);
                        t && (b[e] = t);
                    }
                }
                this.fixedUniforms = a(e, b), this.terrainUniforms = ((e, i)=>({
                        u_depth: new t.aL(e, i.u_depth),
                        u_terrain: new t.aL(e, i.u_terrain),
                        u_terrain_dim: new t.aM(e, i.u_terrain_dim),
                        u_terrain_matrix: new t.aN(e, i.u_terrain_matrix),
                        u_terrain_unpack: new t.aO(e, i.u_terrain_unpack),
                        u_terrain_exaggeration: new t.aM(e, i.u_terrain_exaggeration)
                    }))(e, b), this.binderUniforms = s ? s.getUniforms(e, b) : [];
            }
            draw(t, e, i, s, a, o, r, n, l, h, c, u, d, _, p, m, f, g) {
                const v = t.gl;
                if (this.failedToCreate) return;
                if (t.program.set(this.program), t.setDepthMode(i), t.setStencilMode(s), t.setColorMode(a), t.setCullFace(o), n) {
                    t.activeTexture.set(v.TEXTURE2), v.bindTexture(v.TEXTURE_2D, n.depthTexture), t.activeTexture.set(v.TEXTURE3), v.bindTexture(v.TEXTURE_2D, n.texture);
                    for(const t in this.terrainUniforms)this.terrainUniforms[t].set(n[t]);
                }
                for(const t in this.fixedUniforms)this.fixedUniforms[t].set(r[t]);
                p && p.setUniforms(t, this.binderUniforms, d, {
                    zoom: _
                });
                let x = 0;
                switch(e){
                    case v.LINES:
                        x = 2;
                        break;
                    case v.TRIANGLES:
                        x = 3;
                        break;
                    case v.LINE_STRIP:
                        x = 1;
                }
                for (const i of u.get()){
                    const s = i.vaos || (i.vaos = {});
                    (s[l] || (s[l] = new le)).bind(t, this, h, p ? p.getPaintVertexBuffers() : [], c, i.vertexOffset, m, f, g), v.drawElements(e, i.primitiveLength * x, v.UNSIGNED_SHORT, i.primitiveOffset * x * 2);
                }
            }
        }
        function ue(t, e, i) {
            const s = 1 / St(i, 1, e.transform.tileZoom), a = Math.pow(2, i.tileID.overscaledZ), o = i.tileSize * Math.pow(2, e.transform.tileZoom) / a, r = o * (i.tileID.canonical.x + i.tileID.wrap * a), n = o * i.tileID.canonical.y;
            return {
                u_image: 0,
                u_texsize: i.imageAtlasTexture.size,
                u_scale: [
                    s,
                    t.fromScale,
                    t.toScale
                ],
                u_fade: t.t,
                u_pixel_coord_upper: [
                    r >> 16,
                    n >> 16
                ],
                u_pixel_coord_lower: [
                    65535 & r,
                    65535 & n
                ]
            };
        }
        const de = (e, i, s, a)=>{
            const o = i.style.light, r = o.properties.get("position"), n = [
                r.x,
                r.y,
                r.z
            ], l = function() {
                var e = new t.A(9);
                return t.A != Float32Array && (e[1] = 0, e[2] = 0, e[3] = 0, e[5] = 0, e[6] = 0, e[7] = 0), e[0] = 1, e[4] = 1, e[8] = 1, e;
            }();
            "viewport" === o.properties.get("anchor") && function(t, e) {
                var i = Math.sin(e), s = Math.cos(e);
                t[0] = s, t[1] = i, t[2] = 0, t[3] = -i, t[4] = s, t[5] = 0, t[6] = 0, t[7] = 0, t[8] = 1;
            }(l, -i.transform.angle), function(t, e, i) {
                var s = e[0], a = e[1], o = e[2];
                t[0] = s * i[0] + a * i[3] + o * i[6], t[1] = s * i[1] + a * i[4] + o * i[7], t[2] = s * i[2] + a * i[5] + o * i[8];
            }(n, n, l);
            const h = o.properties.get("color");
            return {
                u_matrix: e,
                u_lightpos: n,
                u_lightintensity: o.properties.get("intensity"),
                u_lightcolor: [
                    h.r,
                    h.g,
                    h.b
                ],
                u_vertical_gradient: +s,
                u_opacity: a
            };
        }, _e = (e, i, s, a, o, r, n)=>t.e(de(e, i, s, a), ue(r, i, n), {
                u_height_factor: -Math.pow(2, o.overscaledZ) / n.tileSize / 8
            }), pe = (t)=>({
                u_matrix: t
            }), me = (e, i, s, a)=>t.e(pe(e), ue(s, i, a)), fe = (t, e)=>({
                u_matrix: t,
                u_world: e
            }), ge = (e, i, s, a, o)=>t.e(me(e, i, s, a), {
                u_world: o
            }), ve = (t, e, i, s)=>{
            const a = t.transform;
            let o, r;
            if ("map" === s.paint.get("circle-pitch-alignment")) {
                const t = St(i, 1, a.zoom);
                o = !0, r = [
                    t,
                    t
                ];
            } else o = !1, r = a.pixelsToGLUnits;
            return {
                u_camera_to_center_distance: a.cameraToCenterDistance,
                u_scale_with_map: +("map" === s.paint.get("circle-pitch-scale")),
                u_matrix: t.translatePosMatrix(e.posMatrix, i, s.paint.get("circle-translate"), s.paint.get("circle-translate-anchor")),
                u_pitch_with_map: +o,
                u_device_pixel_ratio: t.pixelRatio,
                u_extrude_scale: r
            };
        }, xe = (t, e, i)=>{
            const s = St(i, 1, e.zoom), a = Math.pow(2, e.zoom - i.tileID.overscaledZ), o = i.tileID.overscaleFactor();
            return {
                u_matrix: t,
                u_camera_to_center_distance: e.cameraToCenterDistance,
                u_pixels_to_tile_units: s,
                u_extrude_scale: [
                    e.pixelsToGLUnits[0] / (s * a),
                    e.pixelsToGLUnits[1] / (s * a)
                ],
                u_overscale_factor: o
            };
        }, ye = (t, e, i = 1)=>({
                u_matrix: t,
                u_color: e,
                u_overlay: 0,
                u_overlay_scale: i
            }), be = (t)=>({
                u_matrix: t
            }), we = (t, e, i, s)=>({
                u_matrix: t,
                u_extrude_scale: St(e, 1, i),
                u_intensity: s
            });
        function Te(e, i) {
            const s = Math.pow(2, i.canonical.z), a = i.canonical.y;
            return [
                new t.U(0, a / s).toLngLat().lat,
                new t.U(0, (a + 1) / s).toLngLat().lat
            ];
        }
        const Ie = (t, e, i, s)=>{
            const a = t.transform;
            return {
                u_matrix: De(t, e, i, s),
                u_ratio: 1 / St(e, 1, a.zoom),
                u_device_pixel_ratio: t.pixelRatio,
                u_units_to_pixels: [
                    1 / a.pixelsToGLUnits[0],
                    1 / a.pixelsToGLUnits[1]
                ]
            };
        }, Ee = (e, i, s, a, o)=>t.e(Ie(e, i, s, o), {
                u_image: 0,
                u_image_height: a
            }), Se = (t, e, i, s, a)=>{
            const o = t.transform, r = Pe(e, o);
            return {
                u_matrix: De(t, e, i, a),
                u_texsize: e.imageAtlasTexture.size,
                u_ratio: 1 / St(e, 1, o.zoom),
                u_device_pixel_ratio: t.pixelRatio,
                u_image: 0,
                u_scale: [
                    r,
                    s.fromScale,
                    s.toScale
                ],
                u_fade: s.t,
                u_units_to_pixels: [
                    1 / o.pixelsToGLUnits[0],
                    1 / o.pixelsToGLUnits[1]
                ]
            };
        }, Ce = (e, i, s, a, o, r)=>{
            const n = e.lineAtlas, l = Pe(i, e.transform), h = "round" === s.layout.get("line-cap"), c = n.getDash(a.from, h), u = n.getDash(a.to, h), d = c.width * o.fromScale, _ = u.width * o.toScale;
            return t.e(Ie(e, i, s, r), {
                u_patternscale_a: [
                    l / d,
                    -c.height / 2
                ],
                u_patternscale_b: [
                    l / _,
                    -u.height / 2
                ],
                u_sdfgamma: n.width / (256 * Math.min(d, _) * e.pixelRatio) / 2,
                u_image: 0,
                u_tex_y_a: c.y,
                u_tex_y_b: u.y,
                u_mix: o.t
            });
        };
        function Pe(t, e) {
            return 1 / St(t, 1, e.tileZoom);
        }
        function De(t, e, i, s) {
            return t.translatePosMatrix(s ? s.posMatrix : e.tileID.posMatrix, e, i.paint.get("line-translate"), i.paint.get("line-translate-anchor"));
        }
        const Me = (t, e, i, s, a)=>{
            var o, r;
            return {
                u_matrix: t,
                u_tl_parent: e,
                u_scale_parent: i,
                u_buffer_scale: 1,
                u_fade_t: s.mix,
                u_opacity: s.opacity * a.paint.get("raster-opacity"),
                u_image0: 0,
                u_image1: 1,
                u_brightness_low: a.paint.get("raster-brightness-min"),
                u_brightness_high: a.paint.get("raster-brightness-max"),
                u_saturation_factor: (r = a.paint.get("raster-saturation"), r > 0 ? 1 - 1 / (1.001 - r) : -r),
                u_contrast_factor: (o = a.paint.get("raster-contrast"), o > 0 ? 1 / (1 - o) : 1 + o),
                u_spin_weights: ze(a.paint.get("raster-hue-rotate"))
            };
        };
        function ze(t) {
            t *= Math.PI / 180;
            const e = Math.sin(t), i = Math.cos(t);
            return [
                (2 * i + 1) / 3,
                (-Math.sqrt(3) * e - i + 1) / 3,
                (Math.sqrt(3) * e - i + 1) / 3
            ];
        }
        const Le = (t, e, i, s, a, o, r, n, l, h)=>{
            const c = a.transform;
            return {
                u_is_size_zoom_constant: +("constant" === t || "source" === t),
                u_is_size_feature_constant: +("constant" === t || "camera" === t),
                u_size_t: e ? e.uSizeT : 0,
                u_size: e ? e.uSize : 0,
                u_camera_to_center_distance: c.cameraToCenterDistance,
                u_pitch: c.pitch / 360 * 2 * Math.PI,
                u_rotate_symbol: +i,
                u_aspect_ratio: c.width / c.height,
                u_fade_change: a.options.fadeDuration ? a.symbolFadeChange : 1,
                u_matrix: o,
                u_label_plane_matrix: r,
                u_coord_matrix: n,
                u_is_text: +l,
                u_pitch_with_map: +s,
                u_texsize: h,
                u_texture: 0
            };
        }, Ae = (e, i, s, a, o, r, n, l, h, c, u)=>{
            const d = o.transform;
            return t.e(Le(e, i, s, a, o, r, n, l, h, c), {
                u_gamma_scale: a ? Math.cos(d._pitch) * d.cameraToCenterDistance : 1,
                u_device_pixel_ratio: o.pixelRatio,
                u_is_halo: +u
            });
        }, Re = (e, i, s, a, o, r, n, l, h, c)=>t.e(Ae(e, i, s, a, o, r, n, l, !0, h, !0), {
                u_texsize_icon: c,
                u_texture_icon: 1
            }), ke = (t, e, i)=>({
                u_matrix: t,
                u_opacity: e,
                u_color: i
            }), Fe = (e, i, s, a, o, r)=>t.e(function(t, e, i, s) {
                const a = i.imageManager.getPattern(t.from.toString()), o = i.imageManager.getPattern(t.to.toString()), { width: r, height: n } = i.imageManager.getPixelSize(), l = Math.pow(2, s.tileID.overscaledZ), h = s.tileSize * Math.pow(2, i.transform.tileZoom) / l, c = h * (s.tileID.canonical.x + s.tileID.wrap * l), u = h * s.tileID.canonical.y;
                return {
                    u_image: 0,
                    u_pattern_tl_a: a.tl,
                    u_pattern_br_a: a.br,
                    u_pattern_tl_b: o.tl,
                    u_pattern_br_b: o.br,
                    u_texsize: [
                        r,
                        n
                    ],
                    u_mix: e.t,
                    u_pattern_size_a: a.displaySize,
                    u_pattern_size_b: o.displaySize,
                    u_scale_a: e.fromScale,
                    u_scale_b: e.toScale,
                    u_tile_units_to_pixels: 1 / St(s, 1, i.transform.tileZoom),
                    u_pixel_coord_upper: [
                        c >> 16,
                        u >> 16
                    ],
                    u_pixel_coord_lower: [
                        65535 & c,
                        65535 & u
                    ]
                };
            }(a, r, s, o), {
                u_matrix: e,
                u_opacity: i
            }), Be = {
            fillExtrusion: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_lightpos: new t.aP(e, i.u_lightpos),
                    u_lightintensity: new t.aM(e, i.u_lightintensity),
                    u_lightcolor: new t.aP(e, i.u_lightcolor),
                    u_vertical_gradient: new t.aM(e, i.u_vertical_gradient),
                    u_opacity: new t.aM(e, i.u_opacity)
                }),
            fillExtrusionPattern: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_lightpos: new t.aP(e, i.u_lightpos),
                    u_lightintensity: new t.aM(e, i.u_lightintensity),
                    u_lightcolor: new t.aP(e, i.u_lightcolor),
                    u_vertical_gradient: new t.aM(e, i.u_vertical_gradient),
                    u_height_factor: new t.aM(e, i.u_height_factor),
                    u_image: new t.aL(e, i.u_image),
                    u_texsize: new t.aQ(e, i.u_texsize),
                    u_pixel_coord_upper: new t.aQ(e, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t.aQ(e, i.u_pixel_coord_lower),
                    u_scale: new t.aP(e, i.u_scale),
                    u_fade: new t.aM(e, i.u_fade),
                    u_opacity: new t.aM(e, i.u_opacity)
                }),
            fill: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix)
                }),
            fillPattern: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_image: new t.aL(e, i.u_image),
                    u_texsize: new t.aQ(e, i.u_texsize),
                    u_pixel_coord_upper: new t.aQ(e, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t.aQ(e, i.u_pixel_coord_lower),
                    u_scale: new t.aP(e, i.u_scale),
                    u_fade: new t.aM(e, i.u_fade)
                }),
            fillOutline: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_world: new t.aQ(e, i.u_world)
                }),
            fillOutlinePattern: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_world: new t.aQ(e, i.u_world),
                    u_image: new t.aL(e, i.u_image),
                    u_texsize: new t.aQ(e, i.u_texsize),
                    u_pixel_coord_upper: new t.aQ(e, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t.aQ(e, i.u_pixel_coord_lower),
                    u_scale: new t.aP(e, i.u_scale),
                    u_fade: new t.aM(e, i.u_fade)
                }),
            circle: (e, i)=>({
                    u_camera_to_center_distance: new t.aM(e, i.u_camera_to_center_distance),
                    u_scale_with_map: new t.aL(e, i.u_scale_with_map),
                    u_pitch_with_map: new t.aL(e, i.u_pitch_with_map),
                    u_extrude_scale: new t.aQ(e, i.u_extrude_scale),
                    u_device_pixel_ratio: new t.aM(e, i.u_device_pixel_ratio),
                    u_matrix: new t.aN(e, i.u_matrix)
                }),
            collisionBox: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_camera_to_center_distance: new t.aM(e, i.u_camera_to_center_distance),
                    u_pixels_to_tile_units: new t.aM(e, i.u_pixels_to_tile_units),
                    u_extrude_scale: new t.aQ(e, i.u_extrude_scale),
                    u_overscale_factor: new t.aM(e, i.u_overscale_factor)
                }),
            collisionCircle: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_inv_matrix: new t.aN(e, i.u_inv_matrix),
                    u_camera_to_center_distance: new t.aM(e, i.u_camera_to_center_distance),
                    u_viewport_size: new t.aQ(e, i.u_viewport_size)
                }),
            debug: (e, i)=>({
                    u_color: new t.aR(e, i.u_color),
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_overlay: new t.aL(e, i.u_overlay),
                    u_overlay_scale: new t.aM(e, i.u_overlay_scale)
                }),
            clippingMask: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix)
                }),
            heatmap: (e, i)=>({
                    u_extrude_scale: new t.aM(e, i.u_extrude_scale),
                    u_intensity: new t.aM(e, i.u_intensity),
                    u_matrix: new t.aN(e, i.u_matrix)
                }),
            heatmapTexture: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_world: new t.aQ(e, i.u_world),
                    u_image: new t.aL(e, i.u_image),
                    u_color_ramp: new t.aL(e, i.u_color_ramp),
                    u_opacity: new t.aM(e, i.u_opacity)
                }),
            hillshade: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_image: new t.aL(e, i.u_image),
                    u_latrange: new t.aQ(e, i.u_latrange),
                    u_light: new t.aQ(e, i.u_light),
                    u_shadow: new t.aR(e, i.u_shadow),
                    u_highlight: new t.aR(e, i.u_highlight),
                    u_accent: new t.aR(e, i.u_accent)
                }),
            hillshadePrepare: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_image: new t.aL(e, i.u_image),
                    u_dimension: new t.aQ(e, i.u_dimension),
                    u_zoom: new t.aM(e, i.u_zoom),
                    u_unpack: new t.aO(e, i.u_unpack)
                }),
            line: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_ratio: new t.aM(e, i.u_ratio),
                    u_device_pixel_ratio: new t.aM(e, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t.aQ(e, i.u_units_to_pixels)
                }),
            lineGradient: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_ratio: new t.aM(e, i.u_ratio),
                    u_device_pixel_ratio: new t.aM(e, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t.aQ(e, i.u_units_to_pixels),
                    u_image: new t.aL(e, i.u_image),
                    u_image_height: new t.aM(e, i.u_image_height)
                }),
            linePattern: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_texsize: new t.aQ(e, i.u_texsize),
                    u_ratio: new t.aM(e, i.u_ratio),
                    u_device_pixel_ratio: new t.aM(e, i.u_device_pixel_ratio),
                    u_image: new t.aL(e, i.u_image),
                    u_units_to_pixels: new t.aQ(e, i.u_units_to_pixels),
                    u_scale: new t.aP(e, i.u_scale),
                    u_fade: new t.aM(e, i.u_fade)
                }),
            lineSDF: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_ratio: new t.aM(e, i.u_ratio),
                    u_device_pixel_ratio: new t.aM(e, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t.aQ(e, i.u_units_to_pixels),
                    u_patternscale_a: new t.aQ(e, i.u_patternscale_a),
                    u_patternscale_b: new t.aQ(e, i.u_patternscale_b),
                    u_sdfgamma: new t.aM(e, i.u_sdfgamma),
                    u_image: new t.aL(e, i.u_image),
                    u_tex_y_a: new t.aM(e, i.u_tex_y_a),
                    u_tex_y_b: new t.aM(e, i.u_tex_y_b),
                    u_mix: new t.aM(e, i.u_mix)
                }),
            raster: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_tl_parent: new t.aQ(e, i.u_tl_parent),
                    u_scale_parent: new t.aM(e, i.u_scale_parent),
                    u_buffer_scale: new t.aM(e, i.u_buffer_scale),
                    u_fade_t: new t.aM(e, i.u_fade_t),
                    u_opacity: new t.aM(e, i.u_opacity),
                    u_image0: new t.aL(e, i.u_image0),
                    u_image1: new t.aL(e, i.u_image1),
                    u_brightness_low: new t.aM(e, i.u_brightness_low),
                    u_brightness_high: new t.aM(e, i.u_brightness_high),
                    u_saturation_factor: new t.aM(e, i.u_saturation_factor),
                    u_contrast_factor: new t.aM(e, i.u_contrast_factor),
                    u_spin_weights: new t.aP(e, i.u_spin_weights)
                }),
            symbolIcon: (e, i)=>({
                    u_is_size_zoom_constant: new t.aL(e, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t.aL(e, i.u_is_size_feature_constant),
                    u_size_t: new t.aM(e, i.u_size_t),
                    u_size: new t.aM(e, i.u_size),
                    u_camera_to_center_distance: new t.aM(e, i.u_camera_to_center_distance),
                    u_pitch: new t.aM(e, i.u_pitch),
                    u_rotate_symbol: new t.aL(e, i.u_rotate_symbol),
                    u_aspect_ratio: new t.aM(e, i.u_aspect_ratio),
                    u_fade_change: new t.aM(e, i.u_fade_change),
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_label_plane_matrix: new t.aN(e, i.u_label_plane_matrix),
                    u_coord_matrix: new t.aN(e, i.u_coord_matrix),
                    u_is_text: new t.aL(e, i.u_is_text),
                    u_pitch_with_map: new t.aL(e, i.u_pitch_with_map),
                    u_texsize: new t.aQ(e, i.u_texsize),
                    u_texture: new t.aL(e, i.u_texture)
                }),
            symbolSDF: (e, i)=>({
                    u_is_size_zoom_constant: new t.aL(e, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t.aL(e, i.u_is_size_feature_constant),
                    u_size_t: new t.aM(e, i.u_size_t),
                    u_size: new t.aM(e, i.u_size),
                    u_camera_to_center_distance: new t.aM(e, i.u_camera_to_center_distance),
                    u_pitch: new t.aM(e, i.u_pitch),
                    u_rotate_symbol: new t.aL(e, i.u_rotate_symbol),
                    u_aspect_ratio: new t.aM(e, i.u_aspect_ratio),
                    u_fade_change: new t.aM(e, i.u_fade_change),
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_label_plane_matrix: new t.aN(e, i.u_label_plane_matrix),
                    u_coord_matrix: new t.aN(e, i.u_coord_matrix),
                    u_is_text: new t.aL(e, i.u_is_text),
                    u_pitch_with_map: new t.aL(e, i.u_pitch_with_map),
                    u_texsize: new t.aQ(e, i.u_texsize),
                    u_texture: new t.aL(e, i.u_texture),
                    u_gamma_scale: new t.aM(e, i.u_gamma_scale),
                    u_device_pixel_ratio: new t.aM(e, i.u_device_pixel_ratio),
                    u_is_halo: new t.aL(e, i.u_is_halo)
                }),
            symbolTextAndIcon: (e, i)=>({
                    u_is_size_zoom_constant: new t.aL(e, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t.aL(e, i.u_is_size_feature_constant),
                    u_size_t: new t.aM(e, i.u_size_t),
                    u_size: new t.aM(e, i.u_size),
                    u_camera_to_center_distance: new t.aM(e, i.u_camera_to_center_distance),
                    u_pitch: new t.aM(e, i.u_pitch),
                    u_rotate_symbol: new t.aL(e, i.u_rotate_symbol),
                    u_aspect_ratio: new t.aM(e, i.u_aspect_ratio),
                    u_fade_change: new t.aM(e, i.u_fade_change),
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_label_plane_matrix: new t.aN(e, i.u_label_plane_matrix),
                    u_coord_matrix: new t.aN(e, i.u_coord_matrix),
                    u_is_text: new t.aL(e, i.u_is_text),
                    u_pitch_with_map: new t.aL(e, i.u_pitch_with_map),
                    u_texsize: new t.aQ(e, i.u_texsize),
                    u_texsize_icon: new t.aQ(e, i.u_texsize_icon),
                    u_texture: new t.aL(e, i.u_texture),
                    u_texture_icon: new t.aL(e, i.u_texture_icon),
                    u_gamma_scale: new t.aM(e, i.u_gamma_scale),
                    u_device_pixel_ratio: new t.aM(e, i.u_device_pixel_ratio),
                    u_is_halo: new t.aL(e, i.u_is_halo)
                }),
            background: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_opacity: new t.aM(e, i.u_opacity),
                    u_color: new t.aR(e, i.u_color)
                }),
            backgroundPattern: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_opacity: new t.aM(e, i.u_opacity),
                    u_image: new t.aL(e, i.u_image),
                    u_pattern_tl_a: new t.aQ(e, i.u_pattern_tl_a),
                    u_pattern_br_a: new t.aQ(e, i.u_pattern_br_a),
                    u_pattern_tl_b: new t.aQ(e, i.u_pattern_tl_b),
                    u_pattern_br_b: new t.aQ(e, i.u_pattern_br_b),
                    u_texsize: new t.aQ(e, i.u_texsize),
                    u_mix: new t.aM(e, i.u_mix),
                    u_pattern_size_a: new t.aQ(e, i.u_pattern_size_a),
                    u_pattern_size_b: new t.aQ(e, i.u_pattern_size_b),
                    u_scale_a: new t.aM(e, i.u_scale_a),
                    u_scale_b: new t.aM(e, i.u_scale_b),
                    u_pixel_coord_upper: new t.aQ(e, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t.aQ(e, i.u_pixel_coord_lower),
                    u_tile_units_to_pixels: new t.aM(e, i.u_tile_units_to_pixels)
                }),
            terrain: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_texture: new t.aL(e, i.u_texture),
                    u_ele_delta: new t.aM(e, i.u_ele_delta)
                }),
            terrainDepth: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_ele_delta: new t.aM(e, i.u_ele_delta)
                }),
            terrainCoords: (e, i)=>({
                    u_matrix: new t.aN(e, i.u_matrix),
                    u_texture: new t.aL(e, i.u_texture),
                    u_terrain_coords_id: new t.aM(e, i.u_terrain_coords_id),
                    u_ele_delta: new t.aM(e, i.u_ele_delta)
                })
        };
        class Oe {
            constructor(t, e, i){
                this.context = t;
                const s = t.gl;
                this.buffer = s.createBuffer(), this.dynamicDraw = Boolean(i), this.context.unbindVAO(), t.bindElementBuffer.set(this.buffer), s.bufferData(s.ELEMENT_ARRAY_BUFFER, e.arrayBuffer, this.dynamicDraw ? s.DYNAMIC_DRAW : s.STATIC_DRAW), this.dynamicDraw || delete e.arrayBuffer;
            }
            bind() {
                this.context.bindElementBuffer.set(this.buffer);
            }
            updateData(t) {
                const e = this.context.gl;
                if (!this.dynamicDraw) throw new Error("Attempted to update data while not in dynamic mode.");
                this.context.unbindVAO(), this.bind(), e.bufferSubData(e.ELEMENT_ARRAY_BUFFER, 0, t.arrayBuffer);
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        const Ne = {
            Int8: "BYTE",
            Uint8: "UNSIGNED_BYTE",
            Int16: "SHORT",
            Uint16: "UNSIGNED_SHORT",
            Int32: "INT",
            Uint32: "UNSIGNED_INT",
            Float32: "FLOAT"
        };
        class Ue {
            constructor(t, e, i, s){
                this.length = e.length, this.attributes = i, this.itemSize = e.bytesPerElement, this.dynamicDraw = s, this.context = t;
                const a = t.gl;
                this.buffer = a.createBuffer(), t.bindVertexBuffer.set(this.buffer), a.bufferData(a.ARRAY_BUFFER, e.arrayBuffer, this.dynamicDraw ? a.DYNAMIC_DRAW : a.STATIC_DRAW), this.dynamicDraw || delete e.arrayBuffer;
            }
            bind() {
                this.context.bindVertexBuffer.set(this.buffer);
            }
            updateData(t) {
                if (t.length !== this.length) throw new Error(`Length of new data is ${t.length}, which doesn't match current length of ${this.length}`);
                const e = this.context.gl;
                this.bind(), e.bufferSubData(e.ARRAY_BUFFER, 0, t.arrayBuffer);
            }
            enableAttributes(t, e) {
                for(let i = 0; i < this.attributes.length; i++){
                    const s = e.attributes[this.attributes[i].name];
                    void 0 !== s && t.enableVertexAttribArray(s);
                }
            }
            setVertexAttribPointers(t, e, i) {
                for(let s = 0; s < this.attributes.length; s++){
                    const a = this.attributes[s], o = e.attributes[a.name];
                    void 0 !== o && t.vertexAttribPointer(o, a.components, t[Ne[a.type]], !1, this.itemSize, a.offset + this.itemSize * (i || 0));
                }
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        const Ze = new WeakMap;
        function Ge(t) {
            var e;
            if (Ze.has(t)) return Ze.get(t);
            {
                const i = null === (e = t.getParameter(t.VERSION)) || void 0 === e ? void 0 : e.startsWith("WebGL 2.0");
                return Ze.set(t, i), i;
            }
        }
        class je {
            constructor(t){
                this.gl = t.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
            }
            get() {
                return this.current;
            }
            set(t) {}
            getDefault() {
                return this.default;
            }
            setDefault() {
                this.set(this.default);
            }
        }
        class Ve extends je {
            getDefault() {
                return t.aT.transparent;
            }
            set(t) {
                const e = this.current;
                (t.r !== e.r || t.g !== e.g || t.b !== e.b || t.a !== e.a || this.dirty) && (this.gl.clearColor(t.r, t.g, t.b, t.a), this.current = t, this.dirty = !1);
            }
        }
        class qe extends je {
            getDefault() {
                return 1;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.clearDepth(t), this.current = t, this.dirty = !1);
            }
        }
        class $e extends je {
            getDefault() {
                return 0;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.clearStencil(t), this.current = t, this.dirty = !1);
            }
        }
        class We extends je {
            getDefault() {
                return [
                    !0,
                    !0,
                    !0,
                    !0
                ];
            }
            set(t) {
                const e = this.current;
                (t[0] !== e[0] || t[1] !== e[1] || t[2] !== e[2] || t[3] !== e[3] || this.dirty) && (this.gl.colorMask(t[0], t[1], t[2], t[3]), this.current = t, this.dirty = !1);
            }
        }
        class He extends je {
            getDefault() {
                return !0;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.depthMask(t), this.current = t, this.dirty = !1);
            }
        }
        class Xe extends je {
            getDefault() {
                return 255;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.stencilMask(t), this.current = t, this.dirty = !1);
            }
        }
        class Ke extends je {
            getDefault() {
                return {
                    func: this.gl.ALWAYS,
                    ref: 0,
                    mask: 255
                };
            }
            set(t) {
                const e = this.current;
                (t.func !== e.func || t.ref !== e.ref || t.mask !== e.mask || this.dirty) && (this.gl.stencilFunc(t.func, t.ref, t.mask), this.current = t, this.dirty = !1);
            }
        }
        class Qe extends je {
            getDefault() {
                const t = this.gl;
                return [
                    t.KEEP,
                    t.KEEP,
                    t.KEEP
                ];
            }
            set(t) {
                const e = this.current;
                (t[0] !== e[0] || t[1] !== e[1] || t[2] !== e[2] || this.dirty) && (this.gl.stencilOp(t[0], t[1], t[2]), this.current = t, this.dirty = !1);
            }
        }
        class Ye extends je {
            getDefault() {
                return !1;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                t ? e.enable(e.STENCIL_TEST) : e.disable(e.STENCIL_TEST), this.current = t, this.dirty = !1;
            }
        }
        class Je extends je {
            getDefault() {
                return [
                    0,
                    1
                ];
            }
            set(t) {
                const e = this.current;
                (t[0] !== e[0] || t[1] !== e[1] || this.dirty) && (this.gl.depthRange(t[0], t[1]), this.current = t, this.dirty = !1);
            }
        }
        class ti extends je {
            getDefault() {
                return !1;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                t ? e.enable(e.DEPTH_TEST) : e.disable(e.DEPTH_TEST), this.current = t, this.dirty = !1;
            }
        }
        class ei extends je {
            getDefault() {
                return this.gl.LESS;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.depthFunc(t), this.current = t, this.dirty = !1);
            }
        }
        class ii extends je {
            getDefault() {
                return !1;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                t ? e.enable(e.BLEND) : e.disable(e.BLEND), this.current = t, this.dirty = !1;
            }
        }
        class si extends je {
            getDefault() {
                const t = this.gl;
                return [
                    t.ONE,
                    t.ZERO
                ];
            }
            set(t) {
                const e = this.current;
                (t[0] !== e[0] || t[1] !== e[1] || this.dirty) && (this.gl.blendFunc(t[0], t[1]), this.current = t, this.dirty = !1);
            }
        }
        class ai extends je {
            getDefault() {
                return t.aT.transparent;
            }
            set(t) {
                const e = this.current;
                (t.r !== e.r || t.g !== e.g || t.b !== e.b || t.a !== e.a || this.dirty) && (this.gl.blendColor(t.r, t.g, t.b, t.a), this.current = t, this.dirty = !1);
            }
        }
        class oi extends je {
            getDefault() {
                return this.gl.FUNC_ADD;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.blendEquation(t), this.current = t, this.dirty = !1);
            }
        }
        class ri extends je {
            getDefault() {
                return !1;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                t ? e.enable(e.CULL_FACE) : e.disable(e.CULL_FACE), this.current = t, this.dirty = !1;
            }
        }
        class ni extends je {
            getDefault() {
                return this.gl.BACK;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.cullFace(t), this.current = t, this.dirty = !1);
            }
        }
        class li extends je {
            getDefault() {
                return this.gl.CCW;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.frontFace(t), this.current = t, this.dirty = !1);
            }
        }
        class hi extends je {
            getDefault() {
                return null;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.useProgram(t), this.current = t, this.dirty = !1);
            }
        }
        class ci extends je {
            getDefault() {
                return this.gl.TEXTURE0;
            }
            set(t) {
                (t !== this.current || this.dirty) && (this.gl.activeTexture(t), this.current = t, this.dirty = !1);
            }
        }
        class ui extends je {
            getDefault() {
                const t = this.gl;
                return [
                    0,
                    0,
                    t.drawingBufferWidth,
                    t.drawingBufferHeight
                ];
            }
            set(t) {
                const e = this.current;
                (t[0] !== e[0] || t[1] !== e[1] || t[2] !== e[2] || t[3] !== e[3] || this.dirty) && (this.gl.viewport(t[0], t[1], t[2], t[3]), this.current = t, this.dirty = !1);
            }
        }
        class di extends je {
            getDefault() {
                return null;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                e.bindFramebuffer(e.FRAMEBUFFER, t), this.current = t, this.dirty = !1;
            }
        }
        class _i extends je {
            getDefault() {
                return null;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                e.bindRenderbuffer(e.RENDERBUFFER, t), this.current = t, this.dirty = !1;
            }
        }
        class pi extends je {
            getDefault() {
                return null;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                e.bindTexture(e.TEXTURE_2D, t), this.current = t, this.dirty = !1;
            }
        }
        class mi extends je {
            getDefault() {
                return null;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                e.bindBuffer(e.ARRAY_BUFFER, t), this.current = t, this.dirty = !1;
            }
        }
        class fi extends je {
            getDefault() {
                return null;
            }
            set(t) {
                const e = this.gl;
                e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, t), this.current = t, this.dirty = !1;
            }
        }
        class gi extends je {
            getDefault() {
                return null;
            }
            set(t) {
                var e;
                if (t === this.current && !this.dirty) return;
                const i = this.gl;
                Ge(i) ? i.bindVertexArray(t) : null === (e = i.getExtension("OES_vertex_array_object")) || void 0 === e || e.bindVertexArrayOES(t), this.current = t, this.dirty = !1;
            }
        }
        class vi extends je {
            getDefault() {
                return 4;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                e.pixelStorei(e.UNPACK_ALIGNMENT, t), this.current = t, this.dirty = !1;
            }
        }
        class xi extends je {
            getDefault() {
                return !1;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, t), this.current = t, this.dirty = !1;
            }
        }
        class yi extends je {
            getDefault() {
                return !1;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                const e = this.gl;
                e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, t), this.current = t, this.dirty = !1;
            }
        }
        class bi extends je {
            constructor(t, e){
                super(t), this.context = t, this.parent = e;
            }
            getDefault() {
                return null;
            }
        }
        class wi extends bi {
            setDirty() {
                this.dirty = !0;
            }
            set(t) {
                if (t === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const e = this.gl;
                e.framebufferTexture2D(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, t, 0), this.current = t, this.dirty = !1;
            }
        }
        class Ti extends bi {
            set(t) {
                if (t === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const e = this.gl;
                e.framebufferRenderbuffer(e.FRAMEBUFFER, e.DEPTH_ATTACHMENT, e.RENDERBUFFER, t), this.current = t, this.dirty = !1;
            }
        }
        class Ii extends bi {
            set(t) {
                if (t === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const e = this.gl;
                e.framebufferRenderbuffer(e.FRAMEBUFFER, e.DEPTH_STENCIL_ATTACHMENT, e.RENDERBUFFER, t), this.current = t, this.dirty = !1;
            }
        }
        class Ei {
            constructor(t, e, i, s, a){
                this.context = t, this.width = e, this.height = i;
                const o = t.gl, r = this.framebuffer = o.createFramebuffer();
                if (this.colorAttachment = new wi(t, r), s) this.depthAttachment = a ? new Ii(t, r) : new Ti(t, r);
                else if (a) throw new Error("Stencil cannot be setted without depth");
                if (o.checkFramebufferStatus(o.FRAMEBUFFER) !== o.FRAMEBUFFER_COMPLETE) throw new Error("Framebuffer is not complete");
            }
            destroy() {
                const t = this.context.gl, e = this.colorAttachment.get();
                if (e && t.deleteTexture(e), this.depthAttachment) {
                    const e = this.depthAttachment.get();
                    e && t.deleteRenderbuffer(e);
                }
                t.deleteFramebuffer(this.framebuffer);
            }
        }
        class Si {
            constructor(t, e, i){
                this.blendFunction = t, this.blendColor = e, this.mask = i;
            }
        }
        Si.Replace = [
            1,
            0
        ], Si.disabled = new Si(Si.Replace, t.aT.transparent, [
            !1,
            !1,
            !1,
            !1
        ]), Si.unblended = new Si(Si.Replace, t.aT.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Si.alphaBlended = new Si([
            1,
            771
        ], t.aT.transparent, [
            !0,
            !0,
            !0,
            !0
        ]);
        class Ci {
            constructor(t){
                var e, i;
                if (this.gl = t, this.clearColor = new Ve(this), this.clearDepth = new qe(this), this.clearStencil = new $e(this), this.colorMask = new We(this), this.depthMask = new He(this), this.stencilMask = new Xe(this), this.stencilFunc = new Ke(this), this.stencilOp = new Qe(this), this.stencilTest = new Ye(this), this.depthRange = new Je(this), this.depthTest = new ti(this), this.depthFunc = new ei(this), this.blend = new ii(this), this.blendFunc = new si(this), this.blendColor = new ai(this), this.blendEquation = new oi(this), this.cullFace = new ri(this), this.cullFaceSide = new ni(this), this.frontFace = new li(this), this.program = new hi(this), this.activeTexture = new ci(this), this.viewport = new ui(this), this.bindFramebuffer = new di(this), this.bindRenderbuffer = new _i(this), this.bindTexture = new pi(this), this.bindVertexBuffer = new mi(this), this.bindElementBuffer = new fi(this), this.bindVertexArray = new gi(this), this.pixelStoreUnpack = new vi(this), this.pixelStoreUnpackPremultiplyAlpha = new xi(this), this.pixelStoreUnpackFlipY = new yi(this), this.extTextureFilterAnisotropic = t.getExtension("EXT_texture_filter_anisotropic") || t.getExtension("MOZ_EXT_texture_filter_anisotropic") || t.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = t.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.maxTextureSize = t.getParameter(t.MAX_TEXTURE_SIZE), Ge(t)) {
                    this.HALF_FLOAT = t.HALF_FLOAT;
                    const s = t.getExtension("EXT_color_buffer_half_float");
                    this.RGBA16F = null !== (e = t.RGBA16F) && void 0 !== e ? e : null == s ? void 0 : s.RGBA16F_EXT, this.RGB16F = null !== (i = t.RGB16F) && void 0 !== i ? i : null == s ? void 0 : s.RGB16F_EXT, t.getExtension("EXT_color_buffer_float");
                } else {
                    t.getExtension("EXT_color_buffer_half_float"), t.getExtension("OES_texture_half_float_linear");
                    const e = t.getExtension("OES_texture_half_float");
                    this.HALF_FLOAT = null == e ? void 0 : e.HALF_FLOAT_OES;
                }
            }
            setDefault() {
                this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
            }
            setDirty() {
                this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArray.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
            }
            createIndexBuffer(t, e) {
                return new Oe(this, t, e);
            }
            createVertexBuffer(t, e, i) {
                return new Ue(this, t, e, i);
            }
            createRenderbuffer(t, e, i) {
                const s = this.gl, a = s.createRenderbuffer();
                return this.bindRenderbuffer.set(a), s.renderbufferStorage(s.RENDERBUFFER, t, e, i), this.bindRenderbuffer.set(null), a;
            }
            createFramebuffer(t, e, i, s) {
                return new Ei(this, t, e, i, s);
            }
            clear({ color: t, depth: e, stencil: i }) {
                const s = this.gl;
                let a = 0;
                t && (a |= s.COLOR_BUFFER_BIT, this.clearColor.set(t), this.colorMask.set([
                    !0,
                    !0,
                    !0,
                    !0
                ])), void 0 !== e && (a |= s.DEPTH_BUFFER_BIT, this.depthRange.set([
                    0,
                    1
                ]), this.clearDepth.set(e), this.depthMask.set(!0)), void 0 !== i && (a |= s.STENCIL_BUFFER_BIT, this.clearStencil.set(i), this.stencilMask.set(255)), s.clear(a);
            }
            setCullFace(t) {
                !1 === t.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(t.mode), this.frontFace.set(t.frontFace));
            }
            setDepthMode(t) {
                t.func !== this.gl.ALWAYS || t.mask ? (this.depthTest.set(!0), this.depthFunc.set(t.func), this.depthMask.set(t.mask), this.depthRange.set(t.range)) : this.depthTest.set(!1);
            }
            setStencilMode(t) {
                t.test.func !== this.gl.ALWAYS || t.mask ? (this.stencilTest.set(!0), this.stencilMask.set(t.mask), this.stencilOp.set([
                    t.fail,
                    t.depthFail,
                    t.pass
                ]), this.stencilFunc.set({
                    func: t.test.func,
                    ref: t.ref,
                    mask: t.test.mask
                })) : this.stencilTest.set(!1);
            }
            setColorMode(e) {
                t.aG(e.blendFunction, Si.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(e.blendFunction), this.blendColor.set(e.blendColor)), this.colorMask.set(e.mask);
            }
            createVertexArray() {
                var t;
                return Ge(this.gl) ? this.gl.createVertexArray() : null === (t = this.gl.getExtension("OES_vertex_array_object")) || void 0 === t ? void 0 : t.createVertexArrayOES();
            }
            deleteVertexArray(t) {
                var e;
                return Ge(this.gl) ? this.gl.deleteVertexArray(t) : null === (e = this.gl.getExtension("OES_vertex_array_object")) || void 0 === e ? void 0 : e.deleteVertexArrayOES(t);
            }
            unbindVAO() {
                this.bindVertexArray.set(null);
            }
        }
        class Pi {
            constructor(t, e, i){
                this.func = t, this.mask = e, this.range = i;
            }
        }
        Pi.ReadOnly = !1, Pi.ReadWrite = !0, Pi.disabled = new Pi(519, Pi.ReadOnly, [
            0,
            1
        ]);
        const Di = 7680;
        class Mi {
            constructor(t, e, i, s, a, o){
                this.test = t, this.ref = e, this.mask = i, this.fail = s, this.depthFail = a, this.pass = o;
            }
        }
        Mi.disabled = new Mi({
            func: 519,
            mask: 0
        }, 0, 0, Di, Di, Di);
        class zi {
            constructor(t, e, i){
                this.enable = t, this.mode = e, this.frontFace = i;
            }
        }
        let Li;
        function Ai(e, i, s, a, o, r, n) {
            const l = e.context, h = l.gl, c = e.useProgram("collisionBox"), u = [];
            let d = 0, _ = 0;
            for(let p = 0; p < a.length; p++){
                const m = a[p], f = i.getTile(m), g = f.getBucket(s);
                if (!g) continue;
                let v = m.posMatrix;
                0 === o[0] && 0 === o[1] || (v = e.translatePosMatrix(m.posMatrix, f, o, r));
                const x = n ? g.textCollisionBox : g.iconCollisionBox, y = g.collisionCircleArray;
                if (y.length > 0) {
                    const i = t.Z(), s = v;
                    t.aU(i, g.placementInvProjMatrix, e.transform.glCoordMatrix), t.aU(i, i, g.placementViewportMatrix), u.push({
                        circleArray: y,
                        circleOffset: _,
                        transform: s,
                        invTransform: i,
                        coord: m
                    }), d += y.length / 4, _ = d;
                }
                x && c.draw(l, h.LINES, Pi.disabled, Mi.disabled, e.colorModeForRenderPass(), zi.disabled, xe(v, e.transform, f), e.style.map.terrain && e.style.map.terrain.getTerrainData(m), s.id, x.layoutVertexBuffer, x.indexBuffer, x.segments, null, e.transform.zoom, null, null, x.collisionVertexBuffer);
            }
            if (!n || !u.length) return;
            const p = e.useProgram("collisionCircle"), m = new t.aV;
            m.resize(4 * d), m._trim();
            let f = 0;
            for (const t of u)for(let e = 0; e < t.circleArray.length / 4; e++){
                const i = 4 * e, s = t.circleArray[i + 0], a = t.circleArray[i + 1], o = t.circleArray[i + 2], r = t.circleArray[i + 3];
                m.emplace(f++, s, a, o, r, 0), m.emplace(f++, s, a, o, r, 1), m.emplace(f++, s, a, o, r, 2), m.emplace(f++, s, a, o, r, 3);
            }
            (!Li || Li.length < 2 * d) && (Li = function(e) {
                const i = 2 * e, s = new t.aX;
                s.resize(i), s._trim();
                for(let t = 0; t < i; t++){
                    const e = 6 * t;
                    s.uint16[e + 0] = 4 * t + 0, s.uint16[e + 1] = 4 * t + 1, s.uint16[e + 2] = 4 * t + 2, s.uint16[e + 3] = 4 * t + 2, s.uint16[e + 4] = 4 * t + 3, s.uint16[e + 5] = 4 * t + 0;
                }
                return s;
            }(d));
            const g = l.createIndexBuffer(Li, !0), v = l.createVertexBuffer(m, t.aW.members, !0);
            for (const i of u){
                const a = {
                    u_matrix: i.transform,
                    u_inv_matrix: i.invTransform,
                    u_camera_to_center_distance: (x = e.transform).cameraToCenterDistance,
                    u_viewport_size: [
                        x.width,
                        x.height
                    ]
                };
                p.draw(l, h.TRIANGLES, Pi.disabled, Mi.disabled, e.colorModeForRenderPass(), zi.disabled, a, e.style.map.terrain && e.style.map.terrain.getTerrainData(i.coord), s.id, v, g, t.S.simpleSegment(0, 2 * i.circleOffset, i.circleArray.length, i.circleArray.length / 2), null, e.transform.zoom, null, null, null);
            }
            var x;
            v.destroy(), g.destroy();
        }
        zi.disabled = new zi(!1, 1029, 2305), zi.backCCW = new zi(!0, 1029, 2305);
        const Ri = t.ao(new Float32Array(16));
        function ki(e, i, s, a, o, r) {
            const { horizontalAlign: n, verticalAlign: l } = t.au(e);
            return new t.P((-(n - .5) * i / o + a[0]) * r, (-(l - .5) * s / o + a[1]) * r);
        }
        function Fi(e, i, s, a, o, r, n, l, h, c, u) {
            const d = e.text.placedSymbolArray, _ = e.text.dynamicLayoutVertexArray, p = e.icon.dynamicLayoutVertexArray, m = {};
            _.clear();
            for(let p = 0; p < d.length; p++){
                const f = d.get(p), g = f.hidden || !f.crossTileID || e.allowVerticalPlacement && !f.placedOrientation ? null : a[f.crossTileID];
                if (g) {
                    const a = new t.P(f.anchorX, f.anchorY), d = ht(a, s ? n : r, u), p = ct(o.cameraToCenterDistance, d.signedDistanceFromCamera);
                    let v = t.aj(e.textSizeData, h, f) * p / t.ap;
                    s && (v *= e.tilePixelRatio / l);
                    const { width: x, height: y, anchor: b, textOffset: w, textBoxScale: T } = g, I = ki(b, x, y, w, T, v), E = s ? ht(a.add(I), r, u).point : d.point.add(i ? I.rotate(-o.angle) : I), S = e.allowVerticalPlacement && f.placedOrientation === t.ai.vertical ? Math.PI / 2 : 0;
                    for(let e = 0; e < f.numGlyphs; e++)t.ak(_, E, S);
                    c && f.associatedIconIndex >= 0 && (m[f.associatedIconIndex] = {
                        shiftedAnchor: E,
                        angle: S
                    });
                } else wt(f.numGlyphs, _);
            }
            if (c) {
                p.clear();
                const i = e.icon.placedSymbolArray;
                for(let e = 0; e < i.length; e++){
                    const s = i.get(e);
                    if (s.hidden) wt(s.numGlyphs, p);
                    else {
                        const i = m[e];
                        if (i) for(let e = 0; e < s.numGlyphs; e++)t.ak(p, i.shiftedAnchor, i.angle);
                        else wt(s.numGlyphs, p);
                    }
                }
                e.icon.dynamicLayoutVertexBuffer.updateData(p);
            }
            e.text.dynamicLayoutVertexBuffer.updateData(_);
        }
        function Bi(t, e, i) {
            return i.iconsInText && e ? "symbolTextAndIcon" : t ? "symbolSDF" : "symbolIcon";
        }
        function Oi(e, i, s, a, o, r, n, l, h, c, u, d) {
            const _ = e.context, p = _.gl, m = e.transform, f = "map" === l, g = "map" === h, v = "viewport" !== l && "point" !== s.layout.get("symbol-placement"), x = f && !g && !v, y = !s.layout.get("symbol-sort-key").isConstant();
            let b = !1;
            const w = e.depthModeForSublayer(0, Pi.ReadOnly), T = s._unevaluatedLayout.hasValue("text-variable-anchor") || s._unevaluatedLayout.hasValue("text-variable-anchor-offset"), I = [];
            for (const l of a){
                const a = i.getTile(l), h = a.getBucket(s);
                if (!h) continue;
                const u = o ? h.text : h.icon;
                if (!u || !u.segments.get().length || !u.hasVisibleVertices) continue;
                const d = u.programConfigurations.get(s.id), _ = o || h.sdfIcons, w = o ? h.textSizeData : h.iconSizeData, E = g || 0 !== m.pitch, S = e.useProgram(Bi(_, o, h), d), C = t.ah(w, m.zoom), P = e.style.map.terrain && e.style.map.terrain.getTerrainData(l);
                let D, M, z, L, A = [
                    0,
                    0
                ], R = null;
                if (o) M = a.glyphAtlasTexture, z = p.LINEAR, D = a.glyphAtlasTexture.size, h.iconsInText && (A = a.imageAtlasTexture.size, R = a.imageAtlasTexture, L = E || e.options.rotating || e.options.zooming || "composite" === w.kind || "camera" === w.kind ? p.LINEAR : p.NEAREST);
                else {
                    const t = 1 !== s.layout.get("icon-size").constantOr(0) || h.iconsNeedLinear;
                    M = a.imageAtlasTexture, z = _ || e.options.rotating || e.options.zooming || t || E ? p.LINEAR : p.NEAREST, D = a.imageAtlasTexture.size;
                }
                const k = St(a, 1, e.transform.zoom), F = nt(l.posMatrix, g, f, e.transform, k), B = lt(l.posMatrix, g, f, e.transform, k), O = T && h.hasTextData(), N = "none" !== s.layout.get("icon-text-fit") && O && h.hasIconData();
                if (v) {
                    const t = e.style.map.terrain ? (t, i)=>e.style.map.terrain.getElevation(l, t, i) : null, i = "map" === s.layout.get("text-rotation-alignment");
                    dt(h, l.posMatrix, e, o, F, B, g, c, i, t);
                }
                const U = e.translatePosMatrix(l.posMatrix, a, r, n), Z = v || o && T || N ? Ri : F, G = e.translatePosMatrix(B, a, r, n, !0), j = _ && 0 !== s.paint.get(o ? "text-halo-width" : "icon-halo-width").constantOr(1);
                let V;
                V = _ ? h.iconsInText ? Re(w.kind, C, x, g, e, U, Z, G, D, A) : Ae(w.kind, C, x, g, e, U, Z, G, o, D, !0) : Le(w.kind, C, x, g, e, U, Z, G, o, D);
                const q = {
                    program: S,
                    buffers: u,
                    uniformValues: V,
                    atlasTexture: M,
                    atlasTextureIcon: R,
                    atlasInterpolation: z,
                    atlasInterpolationIcon: L,
                    isSDF: _,
                    hasHalo: j
                };
                if (y && h.canOverlap) {
                    b = !0;
                    const e = u.segments.get();
                    for (const i of e)I.push({
                        segments: new t.S([
                            i
                        ]),
                        sortKey: i.sortKey,
                        state: q,
                        terrainData: P
                    });
                } else I.push({
                    segments: u.segments,
                    sortKey: 0,
                    state: q,
                    terrainData: P
                });
            }
            b && I.sort((t, e)=>t.sortKey - e.sortKey);
            for (const t of I){
                const i = t.state;
                if (_.activeTexture.set(p.TEXTURE0), i.atlasTexture.bind(i.atlasInterpolation, p.CLAMP_TO_EDGE), i.atlasTextureIcon && (_.activeTexture.set(p.TEXTURE1), i.atlasTextureIcon && i.atlasTextureIcon.bind(i.atlasInterpolationIcon, p.CLAMP_TO_EDGE)), i.isSDF) {
                    const a = i.uniformValues;
                    i.hasHalo && (a.u_is_halo = 1, Ni(i.buffers, t.segments, s, e, i.program, w, u, d, a, t.terrainData)), a.u_is_halo = 0;
                }
                Ni(i.buffers, t.segments, s, e, i.program, w, u, d, i.uniformValues, t.terrainData);
            }
        }
        function Ni(t, e, i, s, a, o, r, n, l, h) {
            const c = s.context;
            a.draw(c, c.gl.TRIANGLES, o, r, n, zi.disabled, l, h, i.id, t.layoutVertexBuffer, t.indexBuffer, e, i.paint, s.transform.zoom, t.programConfigurations.get(i.id), t.dynamicLayoutVertexBuffer, t.opacityVertexBuffer);
        }
        function Ui(t, e, i, s, a) {
            if (!i || !s || !s.imageAtlas) return;
            const o = s.imageAtlas.patternPositions;
            let r = o[i.to.toString()], n = o[i.from.toString()];
            if (!r && n && (r = n), !n && r && (n = r), !r || !n) {
                const t = a.getPaintProperty(e);
                r = o[t], n = o[t];
            }
            r && n && t.setConstantPatternPositions(r, n);
        }
        function Zi(t, e, i, s, a, o, r) {
            const n = t.context.gl, l = "fill-pattern", h = i.paint.get(l), c = h && h.constantOr(1), u = i.getCrossfadeParameters();
            let d, _, p, m, f;
            r ? (_ = c && !i.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", d = n.LINES) : (_ = c ? "fillPattern" : "fill", d = n.TRIANGLES);
            const g = h.constantOr(null);
            for (const h of s){
                const s = e.getTile(h);
                if (c && !s.patternsLoaded()) continue;
                const v = s.getBucket(i);
                if (!v) continue;
                const x = v.programConfigurations.get(i.id), y = t.useProgram(_, x), b = t.style.map.terrain && t.style.map.terrain.getTerrainData(h);
                c && (t.context.activeTexture.set(n.TEXTURE0), s.imageAtlasTexture.bind(n.LINEAR, n.CLAMP_TO_EDGE), x.updatePaintBuffers(u)), Ui(x, l, g, s, i);
                const w = b ? h : null, T = t.translatePosMatrix(w ? w.posMatrix : h.posMatrix, s, i.paint.get("fill-translate"), i.paint.get("fill-translate-anchor"));
                if (r) {
                    m = v.indexBuffer2, f = v.segments2;
                    const e = [
                        n.drawingBufferWidth,
                        n.drawingBufferHeight
                    ];
                    p = "fillOutlinePattern" === _ && c ? ge(T, t, u, s, e) : fe(T, e);
                } else m = v.indexBuffer, f = v.segments, p = c ? me(T, t, u, s) : pe(T);
                y.draw(t.context, d, a, t.stencilModeForClipping(h), o, zi.disabled, p, b, i.id, v.layoutVertexBuffer, m, f, i.paint, t.transform.zoom, x);
            }
        }
        function Gi(t, e, i, s, a, o, r) {
            const n = t.context, l = n.gl, h = "fill-extrusion-pattern", c = i.paint.get(h), u = c.constantOr(1), d = i.getCrossfadeParameters(), _ = i.paint.get("fill-extrusion-opacity"), p = c.constantOr(null);
            for (const c of s){
                const s = e.getTile(c), m = s.getBucket(i);
                if (!m) continue;
                const f = t.style.map.terrain && t.style.map.terrain.getTerrainData(c), g = m.programConfigurations.get(i.id), v = t.useProgram(u ? "fillExtrusionPattern" : "fillExtrusion", g);
                u && (t.context.activeTexture.set(l.TEXTURE0), s.imageAtlasTexture.bind(l.LINEAR, l.CLAMP_TO_EDGE), g.updatePaintBuffers(d)), Ui(g, h, p, s, i);
                const x = t.translatePosMatrix(c.posMatrix, s, i.paint.get("fill-extrusion-translate"), i.paint.get("fill-extrusion-translate-anchor")), y = i.paint.get("fill-extrusion-vertical-gradient"), b = u ? _e(x, t, y, _, c, d, s) : de(x, t, y, _);
                v.draw(n, n.gl.TRIANGLES, a, o, r, zi.backCCW, b, f, i.id, m.layoutVertexBuffer, m.indexBuffer, m.segments, i.paint, t.transform.zoom, g, t.style.map.terrain && m.centroidVertexBuffer);
            }
        }
        function ji(t, e, i, s, a, o, r) {
            const n = t.context, l = n.gl, h = i.fbo;
            if (!h) return;
            const c = t.useProgram("hillshade"), u = t.style.map.terrain && t.style.map.terrain.getTerrainData(e);
            n.activeTexture.set(l.TEXTURE0), l.bindTexture(l.TEXTURE_2D, h.colorAttachment.get()), c.draw(n, l.TRIANGLES, a, o, r, zi.disabled, ((t, e, i, s)=>{
                const a = i.paint.get("hillshade-shadow-color"), o = i.paint.get("hillshade-highlight-color"), r = i.paint.get("hillshade-accent-color");
                let n = i.paint.get("hillshade-illumination-direction") * (Math.PI / 180);
                "viewport" === i.paint.get("hillshade-illumination-anchor") && (n -= t.transform.angle);
                const l = !t.options.moving;
                return {
                    u_matrix: s ? s.posMatrix : t.transform.calculatePosMatrix(e.tileID.toUnwrapped(), l),
                    u_image: 0,
                    u_latrange: Te(0, e.tileID),
                    u_light: [
                        i.paint.get("hillshade-exaggeration"),
                        n
                    ],
                    u_shadow: a,
                    u_highlight: o,
                    u_accent: r
                };
            })(t, i, s, u ? e : null), u, s.id, t.rasterBoundsBuffer, t.quadTriangleIndexBuffer, t.rasterBoundsSegments);
        }
        function Vi(e, i, s, a, o, r) {
            const n = e.context, l = n.gl, h = i.dem;
            if (h && h.data) {
                const c = h.dim, u = h.stride, d = h.getPixels();
                if (n.activeTexture.set(l.TEXTURE1), n.pixelStoreUnpackPremultiplyAlpha.set(!1), i.demTexture = i.demTexture || e.getTileTexture(u), i.demTexture) {
                    const t = i.demTexture;
                    t.update(d, {
                        premultiply: !1
                    }), t.bind(l.NEAREST, l.CLAMP_TO_EDGE);
                } else i.demTexture = new x(n, d, l.RGBA, {
                    premultiply: !1
                }), i.demTexture.bind(l.NEAREST, l.CLAMP_TO_EDGE);
                n.activeTexture.set(l.TEXTURE0);
                let _ = i.fbo;
                if (!_) {
                    const t = new x(n, {
                        width: c,
                        height: c,
                        data: null
                    }, l.RGBA);
                    t.bind(l.LINEAR, l.CLAMP_TO_EDGE), _ = i.fbo = n.createFramebuffer(c, c, !0, !1), _.colorAttachment.set(t.texture);
                }
                n.bindFramebuffer.set(_.framebuffer), n.viewport.set([
                    0,
                    0,
                    c,
                    c
                ]), e.useProgram("hillshadePrepare").draw(n, l.TRIANGLES, a, o, r, zi.disabled, ((e, i)=>{
                    const s = i.stride, a = t.Z();
                    return t.aS(a, 0, t.N, -t.N, 0, 0, 1), t.$(a, a, [
                        0,
                        -t.N,
                        0
                    ]), {
                        u_matrix: a,
                        u_image: 1,
                        u_dimension: [
                            s,
                            s
                        ],
                        u_zoom: e.overscaledZ,
                        u_unpack: i.getUnpackVector()
                    };
                })(i.tileID, h), null, s.id, e.rasterBoundsBuffer, e.quadTriangleIndexBuffer, e.rasterBoundsSegments), i.needsHillshadePrepare = !1;
            }
        }
        function qi(e, i, s, a, o, r) {
            const n = a.paint.get("raster-fade-duration");
            if (!r && n > 0) {
                const a = t.h.now(), r = (a - e.timeAdded) / n, l = i ? (a - i.timeAdded) / n : -1, h = s.getSource(), c = o.coveringZoomLevel({
                    tileSize: h.tileSize,
                    roundZoom: h.roundZoom
                }), u = !i || Math.abs(i.tileID.overscaledZ - c) > Math.abs(e.tileID.overscaledZ - c), d = u && e.refreshedUponExpiration ? 1 : t.ad(u ? r : 1 - l, 0, 1);
                return e.refreshedUponExpiration && r >= 1 && (e.refreshedUponExpiration = !1), i ? {
                    opacity: 1,
                    mix: 1 - d
                } : {
                    opacity: d,
                    mix: 0
                };
            }
            return {
                opacity: 1,
                mix: 0
            };
        }
        const $i = new t.aT(1, 0, 0, 1), Wi = new t.aT(0, 1, 0, 1), Hi = new t.aT(0, 0, 1, 1), Xi = new t.aT(1, 0, 1, 1), Ki = new t.aT(0, 1, 1, 1);
        function Qi(t, e, i, s) {
            Ji(t, 0, e + i / 2, t.transform.width, i, s);
        }
        function Yi(t, e, i, s) {
            Ji(t, e - i / 2, 0, i, t.transform.height, s);
        }
        function Ji(t, e, i, s, a, o) {
            const r = t.context, n = r.gl;
            n.enable(n.SCISSOR_TEST), n.scissor(e * t.pixelRatio, i * t.pixelRatio, s * t.pixelRatio, a * t.pixelRatio), r.clear({
                color: o
            }), n.disable(n.SCISSOR_TEST);
        }
        function ts(e, i, s) {
            const a = e.context, o = a.gl, r = s.posMatrix, n = e.useProgram("debug"), l = Pi.disabled, h = Mi.disabled, c = e.colorModeForRenderPass(), u = "$debug", d = e.style.map.terrain && e.style.map.terrain.getTerrainData(s);
            a.activeTexture.set(o.TEXTURE0);
            const _ = i.getTileByID(s.key).latestRawTileData, p = Math.floor((_ && _.byteLength || 0) / 1024), m = i.getTile(s).tileSize, f = 512 / Math.min(m, 512) * (s.overscaledZ / e.transform.zoom) * .5;
            let g = s.canonical.toString();
            s.overscaledZ !== s.canonical.z && (g += ` => ${s.overscaledZ}`), function(t, e) {
                t.initDebugOverlayCanvas();
                const i = t.debugOverlayCanvas, s = t.context.gl, a = t.debugOverlayCanvas.getContext("2d");
                a.clearRect(0, 0, i.width, i.height), a.shadowColor = "white", a.shadowBlur = 2, a.lineWidth = 1.5, a.strokeStyle = "white", a.textBaseline = "top", a.font = "bold 36px Open Sans, sans-serif", a.fillText(e, 5, 5), a.strokeText(e, 5, 5), t.debugOverlayTexture.update(i), t.debugOverlayTexture.bind(s.LINEAR, s.CLAMP_TO_EDGE);
            }(e, `${g} ${p}kB`), n.draw(a, o.TRIANGLES, l, h, Si.alphaBlended, zi.disabled, ye(r, t.aT.transparent, f), null, u, e.debugBuffer, e.quadTriangleIndexBuffer, e.debugSegments), n.draw(a, o.LINE_STRIP, l, h, c, zi.disabled, ye(r, t.aT.red), d, u, e.debugBuffer, e.tileBorderIndexBuffer, e.debugSegments);
        }
        function es(t, e, i) {
            const s = t.context, a = s.gl, o = t.colorModeForRenderPass(), r = new Pi(a.LEQUAL, Pi.ReadWrite, t.depthRangeFor3D), n = t.useProgram("terrain"), l = e.getTerrainMesh();
            s.bindFramebuffer.set(null), s.viewport.set([
                0,
                0,
                t.width,
                t.height
            ]);
            for (const h of i){
                const i = t.renderToTexture.getTexture(h), c = e.getTerrainData(h.tileID);
                s.activeTexture.set(a.TEXTURE0), a.bindTexture(a.TEXTURE_2D, i.texture);
                const u = {
                    u_matrix: t.transform.calculatePosMatrix(h.tileID.toUnwrapped()),
                    u_texture: 0,
                    u_ele_delta: e.getMeshFrameDelta(t.transform.zoom)
                };
                n.draw(s, a.TRIANGLES, r, Mi.disabled, o, zi.backCCW, u, c, "terrain", l.vertexBuffer, l.indexBuffer, l.segments);
            }
        }
        class is {
            constructor(e, i){
                this.context = new Ci(e), this.transform = i, this._tileTextures = {}, this.terrainFacilitator = {
                    dirty: !0,
                    matrix: t.Z(),
                    renderTime: 0
                }, this.setup(), this.numSublayers = K.maxUnderzooming + K.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.crossTileSymbolIndex = new Yt;
            }
            resize(t, e, i) {
                if (this.width = Math.floor(t * i), this.height = Math.floor(e * i), this.pixelRatio = i, this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.style) for (const t of this.style._order)this.style._layers[t].resize();
            }
            setup() {
                const e = this.context, i = new t.a_;
                i.emplaceBack(0, 0), i.emplaceBack(t.N, 0), i.emplaceBack(0, t.N), i.emplaceBack(t.N, t.N), this.tileExtentBuffer = e.createVertexBuffer(i, ae.members), this.tileExtentSegments = t.S.simpleSegment(0, 0, 4, 2);
                const s = new t.a_;
                s.emplaceBack(0, 0), s.emplaceBack(t.N, 0), s.emplaceBack(0, t.N), s.emplaceBack(t.N, t.N), this.debugBuffer = e.createVertexBuffer(s, ae.members), this.debugSegments = t.S.simpleSegment(0, 0, 4, 5);
                const a = new t.V;
                a.emplaceBack(0, 0, 0, 0), a.emplaceBack(t.N, 0, t.N, 0), a.emplaceBack(0, t.N, 0, t.N), a.emplaceBack(t.N, t.N, t.N, t.N), this.rasterBoundsBuffer = e.createVertexBuffer(a, O.members), this.rasterBoundsSegments = t.S.simpleSegment(0, 0, 4, 2);
                const o = new t.a_;
                o.emplaceBack(0, 0), o.emplaceBack(1, 0), o.emplaceBack(0, 1), o.emplaceBack(1, 1), this.viewportBuffer = e.createVertexBuffer(o, ae.members), this.viewportSegments = t.S.simpleSegment(0, 0, 4, 2);
                const r = new t.a$;
                r.emplaceBack(0), r.emplaceBack(1), r.emplaceBack(3), r.emplaceBack(2), r.emplaceBack(0), this.tileBorderIndexBuffer = e.createIndexBuffer(r);
                const n = new t.b0;
                n.emplaceBack(0, 1, 2), n.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = e.createIndexBuffer(n);
                const l = this.context.gl;
                this.stencilClearMode = new Mi({
                    func: l.ALWAYS,
                    mask: 0
                }, 0, 255, l.ZERO, l.ZERO, l.ZERO);
            }
            clearStencil() {
                const e = this.context, i = e.gl;
                this.nextStencilID = 1, this.currentStencilSource = void 0;
                const s = t.Z();
                t.aS(s, 0, this.width, this.height, 0, 0, 1), t.a0(s, s, [
                    i.drawingBufferWidth,
                    i.drawingBufferHeight,
                    0
                ]), this.useProgram("clippingMask").draw(e, i.TRIANGLES, Pi.disabled, this.stencilClearMode, Si.disabled, zi.disabled, be(s), null, "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
            }
            _renderTileClippingMasks(t, e) {
                if (this.currentStencilSource === t.source || !t.isTileClipped() || !e || !e.length) return;
                this.currentStencilSource = t.source;
                const i = this.context, s = i.gl;
                this.nextStencilID + e.length > 256 && this.clearStencil(), i.setColorMode(Si.disabled), i.setDepthMode(Pi.disabled);
                const a = this.useProgram("clippingMask");
                this._tileClippingMaskIDs = {};
                for (const t of e){
                    const e = this._tileClippingMaskIDs[t.key] = this.nextStencilID++, o = this.style.map.terrain && this.style.map.terrain.getTerrainData(t);
                    a.draw(i, s.TRIANGLES, Pi.disabled, new Mi({
                        func: s.ALWAYS,
                        mask: 0
                    }, e, 255, s.KEEP, s.KEEP, s.REPLACE), Si.disabled, zi.disabled, be(t.posMatrix), o, "$clipping", this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
                }
            }
            stencilModeFor3D() {
                this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
                const t = this.nextStencilID++, e = this.context.gl;
                return new Mi({
                    func: e.NOTEQUAL,
                    mask: 255
                }, t, 255, e.KEEP, e.KEEP, e.REPLACE);
            }
            stencilModeForClipping(t) {
                const e = this.context.gl;
                return new Mi({
                    func: e.EQUAL,
                    mask: 255
                }, this._tileClippingMaskIDs[t.key], 0, e.KEEP, e.KEEP, e.REPLACE);
            }
            stencilConfigForOverlap(t) {
                const e = this.context.gl, i = t.sort((t, e)=>e.overscaledZ - t.overscaledZ), s = i[i.length - 1].overscaledZ, a = i[0].overscaledZ - s + 1;
                if (a > 1) {
                    this.currentStencilSource = void 0, this.nextStencilID + a > 256 && this.clearStencil();
                    const t = {};
                    for(let i = 0; i < a; i++)t[i + s] = new Mi({
                        func: e.GEQUAL,
                        mask: 255
                    }, i + this.nextStencilID, 255, e.KEEP, e.KEEP, e.REPLACE);
                    return this.nextStencilID += a, [
                        t,
                        i
                    ];
                }
                return [
                    {
                        [s]: Mi.disabled
                    },
                    i
                ];
            }
            colorModeForRenderPass() {
                const e = this.context.gl;
                if (this._showOverdrawInspector) {
                    const i = 1 / 8;
                    return new Si([
                        e.CONSTANT_COLOR,
                        e.ONE
                    ], new t.aT(i, i, i, 0), [
                        !0,
                        !0,
                        !0,
                        !0
                    ]);
                }
                return "opaque" === this.renderPass ? Si.unblended : Si.alphaBlended;
            }
            depthModeForSublayer(t, e, i) {
                if (!this.opaquePassEnabledForLayer()) return Pi.disabled;
                const s = 1 - ((1 + this.currentLayer) * this.numSublayers + t) * this.depthEpsilon;
                return new Pi(i || this.context.gl.LEQUAL, e, [
                    s,
                    s
                ]);
            }
            opaquePassEnabledForLayer() {
                return this.currentLayer < this.opaquePassCutoff;
            }
            render(e, i) {
                this.style = e, this.options = i, this.lineAtlas = e.lineAtlas, this.imageManager = e.imageManager, this.glyphManager = e.glyphManager, this.symbolFadeChange = e.placement.symbolFadeChange(t.h.now()), this.imageManager.beginFrame();
                const s = this.style._order, a = this.style.sourceCaches, o = {}, r = {}, n = {};
                for(const t in a){
                    const e = a[t];
                    e.used && e.prepare(this.context), o[t] = e.getVisibleCoordinates(), r[t] = o[t].slice().reverse(), n[t] = e.getVisibleCoordinates(!0).reverse();
                }
                this.opaquePassCutoff = 1 / 0;
                for(let t = 0; t < s.length; t++)if (this.style._layers[s[t]].is3D()) {
                    this.opaquePassCutoff = t;
                    break;
                }
                if (this.renderToTexture) {
                    this.renderToTexture.prepareForRender(this.style, this.transform.zoom), this.opaquePassCutoff = 0;
                    const e = this.style.map.terrain.sourceCache.tilesAfterTime(this.terrainFacilitator.renderTime);
                    (this.terrainFacilitator.dirty || !t.b1(this.terrainFacilitator.matrix, this.transform.projMatrix) || e.length) && (t.b2(this.terrainFacilitator.matrix, this.transform.projMatrix), this.terrainFacilitator.renderTime = Date.now(), this.terrainFacilitator.dirty = !1, function(e, i) {
                        const s = e.context, a = s.gl, o = Si.unblended, r = new Pi(a.LEQUAL, Pi.ReadWrite, [
                            0,
                            1
                        ]), n = i.getTerrainMesh(), l = i.sourceCache.getRenderableTiles(), h = e.useProgram("terrainDepth");
                        s.bindFramebuffer.set(i.getFramebuffer("depth").framebuffer), s.viewport.set([
                            0,
                            0,
                            e.width / devicePixelRatio,
                            e.height / devicePixelRatio
                        ]), s.clear({
                            color: t.aT.transparent,
                            depth: 1
                        });
                        for (const t of l){
                            const l = i.getTerrainData(t.tileID), c = {
                                u_matrix: e.transform.calculatePosMatrix(t.tileID.toUnwrapped()),
                                u_ele_delta: i.getMeshFrameDelta(e.transform.zoom)
                            };
                            h.draw(s, a.TRIANGLES, r, Mi.disabled, o, zi.backCCW, c, l, "terrain", n.vertexBuffer, n.indexBuffer, n.segments);
                        }
                        s.bindFramebuffer.set(null), s.viewport.set([
                            0,
                            0,
                            e.width,
                            e.height
                        ]);
                    }(this, this.style.map.terrain), function(e, i) {
                        const s = e.context, a = s.gl, o = Si.unblended, r = new Pi(a.LEQUAL, Pi.ReadWrite, [
                            0,
                            1
                        ]), n = i.getTerrainMesh(), l = i.getCoordsTexture(), h = i.sourceCache.getRenderableTiles(), c = e.useProgram("terrainCoords");
                        s.bindFramebuffer.set(i.getFramebuffer("coords").framebuffer), s.viewport.set([
                            0,
                            0,
                            e.width / devicePixelRatio,
                            e.height / devicePixelRatio
                        ]), s.clear({
                            color: t.aT.transparent,
                            depth: 1
                        }), i.coordsIndex = [];
                        for (const t of h){
                            const h = i.getTerrainData(t.tileID);
                            s.activeTexture.set(a.TEXTURE0), a.bindTexture(a.TEXTURE_2D, l.texture);
                            const u = {
                                u_matrix: e.transform.calculatePosMatrix(t.tileID.toUnwrapped()),
                                u_terrain_coords_id: (255 - i.coordsIndex.length) / 255,
                                u_texture: 0,
                                u_ele_delta: i.getMeshFrameDelta(e.transform.zoom)
                            };
                            c.draw(s, a.TRIANGLES, r, Mi.disabled, o, zi.backCCW, u, h, "terrain", n.vertexBuffer, n.indexBuffer, n.segments), i.coordsIndex.push(t.tileID.key);
                        }
                        s.bindFramebuffer.set(null), s.viewport.set([
                            0,
                            0,
                            e.width,
                            e.height
                        ]);
                    }(this, this.style.map.terrain));
                }
                this.renderPass = "offscreen";
                for (const t of s){
                    const e = this.style._layers[t];
                    if (!e.hasOffscreenPass() || e.isHidden(this.transform.zoom)) continue;
                    const i = r[e.source];
                    ("custom" === e.type || i.length) && this.renderLayer(this, a[e.source], e, i);
                }
                if (this.context.bindFramebuffer.set(null), this.context.clear({
                    color: i.showOverdrawInspector ? t.aT.black : t.aT.transparent,
                    depth: 1
                }), this.clearStencil(), this._showOverdrawInspector = i.showOverdrawInspector, this.depthRangeFor3D = [
                    0,
                    1 - (e._order.length + 2) * this.numSublayers * this.depthEpsilon
                ], !this.renderToTexture) for(this.renderPass = "opaque", this.currentLayer = s.length - 1; this.currentLayer >= 0; this.currentLayer--){
                    const t = this.style._layers[s[this.currentLayer]], e = a[t.source], i = o[t.source];
                    this._renderTileClippingMasks(t, i), this.renderLayer(this, e, t, i);
                }
                for(this.renderPass = "translucent", this.currentLayer = 0; this.currentLayer < s.length; this.currentLayer++){
                    const t = this.style._layers[s[this.currentLayer]], e = a[t.source];
                    if (this.renderToTexture && this.renderToTexture.renderLayer(t)) continue;
                    const i = ("symbol" === t.type ? n : r)[t.source];
                    this._renderTileClippingMasks(t, o[t.source]), this.renderLayer(this, e, t, i);
                }
                if (this.options.showTileBoundaries) {
                    const t = function(t, e) {
                        let i = null;
                        const s = Object.values(t._layers).flatMap((i)=>i.source && !i.isHidden(e) ? [
                                t.sourceCaches[i.source]
                            ] : []), a = s.filter((t)=>"vector" === t.getSource().type), o = s.filter((t)=>"vector" !== t.getSource().type), r = (t)=>{
                            (!i || i.getSource().maxzoom < t.getSource().maxzoom) && (i = t);
                        };
                        return a.forEach((t)=>r(t)), i || o.forEach((t)=>r(t)), i;
                    }(this.style, this.transform.zoom);
                    t && function(t, e, i) {
                        for(let s = 0; s < i.length; s++)ts(t, e, i[s]);
                    }(this, t, t.getVisibleCoordinates());
                }
                this.options.showPadding && function(t) {
                    const e = t.transform.padding;
                    Qi(t, t.transform.height - (e.top || 0), 3, $i), Qi(t, e.bottom || 0, 3, Wi), Yi(t, e.left || 0, 3, Hi), Yi(t, t.transform.width - (e.right || 0), 3, Xi);
                    const i = t.transform.centerPoint;
                    !function(t, e, i, s) {
                        Ji(t, e - 1, i - 10, 2, 20, s), Ji(t, e - 10, i - 1, 20, 2, s);
                    }(t, i.x, t.transform.height - i.y, Ki);
                }(this), this.context.setDefault();
            }
            renderLayer(e, i, s, a) {
                if (!s.isHidden(this.transform.zoom) && ("background" === s.type || "custom" === s.type || (a || []).length)) switch(this.id = s.id, s.type){
                    case "symbol":
                        !function(e, i, s, a, o) {
                            if ("translucent" !== e.renderPass) return;
                            const r = Mi.disabled, n = e.colorModeForRenderPass();
                            (s._unevaluatedLayout.hasValue("text-variable-anchor") || s._unevaluatedLayout.hasValue("text-variable-anchor-offset")) && function(e, i, s, a, o, r, n) {
                                const l = i.transform, h = "map" === o, c = "map" === r;
                                for (const o of e){
                                    const e = a.getTile(o), r = e.getBucket(s);
                                    if (!r || !r.text || !r.text.segments.get().length) continue;
                                    const u = t.ah(r.textSizeData, l.zoom), d = St(e, 1, i.transform.zoom), _ = nt(o.posMatrix, c, h, i.transform, d), p = "none" !== s.layout.get("icon-text-fit") && r.hasIconData();
                                    if (u) {
                                        const t = Math.pow(2, l.zoom - e.tileID.overscaledZ);
                                        Fi(r, h, c, n, l, _, o.posMatrix, t, u, p, i.style.map.terrain ? (t, e)=>i.style.map.terrain.getElevation(o, t, e) : null);
                                    }
                                }
                            }(a, e, s, i, s.layout.get("text-rotation-alignment"), s.layout.get("text-pitch-alignment"), o), 0 !== s.paint.get("icon-opacity").constantOr(1) && Oi(e, i, s, a, !1, s.paint.get("icon-translate"), s.paint.get("icon-translate-anchor"), s.layout.get("icon-rotation-alignment"), s.layout.get("icon-pitch-alignment"), s.layout.get("icon-keep-upright"), r, n), 0 !== s.paint.get("text-opacity").constantOr(1) && Oi(e, i, s, a, !0, s.paint.get("text-translate"), s.paint.get("text-translate-anchor"), s.layout.get("text-rotation-alignment"), s.layout.get("text-pitch-alignment"), s.layout.get("text-keep-upright"), r, n), i.map.showCollisionBoxes && (Ai(e, i, s, a, s.paint.get("text-translate"), s.paint.get("text-translate-anchor"), !0), Ai(e, i, s, a, s.paint.get("icon-translate"), s.paint.get("icon-translate-anchor"), !1));
                        }(e, i, s, a, this.style.placement.variableOffsets);
                        break;
                    case "circle":
                        !function(e, i, s, a) {
                            if ("translucent" !== e.renderPass) return;
                            const o = s.paint.get("circle-opacity"), r = s.paint.get("circle-stroke-width"), n = s.paint.get("circle-stroke-opacity"), l = !s.layout.get("circle-sort-key").isConstant();
                            if (0 === o.constantOr(1) && (0 === r.constantOr(1) || 0 === n.constantOr(1))) return;
                            const h = e.context, c = h.gl, u = e.depthModeForSublayer(0, Pi.ReadOnly), d = Mi.disabled, _ = e.colorModeForRenderPass(), p = [];
                            for(let o = 0; o < a.length; o++){
                                const r = a[o], n = i.getTile(r), h = n.getBucket(s);
                                if (!h) continue;
                                const c = h.programConfigurations.get(s.id), u = e.useProgram("circle", c), d = h.layoutVertexBuffer, _ = h.indexBuffer, m = e.style.map.terrain && e.style.map.terrain.getTerrainData(r), f = {
                                    programConfiguration: c,
                                    program: u,
                                    layoutVertexBuffer: d,
                                    indexBuffer: _,
                                    uniformValues: ve(e, r, n, s),
                                    terrainData: m
                                };
                                if (l) {
                                    const e = h.segments.get();
                                    for (const i of e)p.push({
                                        segments: new t.S([
                                            i
                                        ]),
                                        sortKey: i.sortKey,
                                        state: f
                                    });
                                } else p.push({
                                    segments: h.segments,
                                    sortKey: 0,
                                    state: f
                                });
                            }
                            l && p.sort((t, e)=>t.sortKey - e.sortKey);
                            for (const t of p){
                                const { programConfiguration: i, program: a, layoutVertexBuffer: o, indexBuffer: r, uniformValues: n, terrainData: l } = t.state;
                                a.draw(h, c.TRIANGLES, u, d, _, zi.disabled, n, l, s.id, o, r, t.segments, s.paint, e.transform.zoom, i);
                            }
                        }(e, i, s, a);
                        break;
                    case "heatmap":
                        !function(e, i, s, a) {
                            if (0 !== s.paint.get("heatmap-opacity")) {
                                if ("offscreen" === e.renderPass) {
                                    const o = e.context, r = o.gl, n = Mi.disabled, l = new Si([
                                        r.ONE,
                                        r.ONE
                                    ], t.aT.transparent, [
                                        !0,
                                        !0,
                                        !0,
                                        !0
                                    ]);
                                    !function(t, e, i) {
                                        const s = t.gl;
                                        t.activeTexture.set(s.TEXTURE1), t.viewport.set([
                                            0,
                                            0,
                                            e.width / 4,
                                            e.height / 4
                                        ]);
                                        let a = i.heatmapFbo;
                                        if (a) s.bindTexture(s.TEXTURE_2D, a.colorAttachment.get()), t.bindFramebuffer.set(a.framebuffer);
                                        else {
                                            const o = s.createTexture();
                                            s.bindTexture(s.TEXTURE_2D, o), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_S, s.CLAMP_TO_EDGE), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_T, s.CLAMP_TO_EDGE), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MIN_FILTER, s.LINEAR), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MAG_FILTER, s.LINEAR), a = i.heatmapFbo = t.createFramebuffer(e.width / 4, e.height / 4, !1, !1), function(t, e, i, s) {
                                                var a, o;
                                                const r = t.gl, n = null !== (a = t.HALF_FLOAT) && void 0 !== a ? a : r.UNSIGNED_BYTE, l = null !== (o = t.RGBA16F) && void 0 !== o ? o : r.RGBA;
                                                r.texImage2D(r.TEXTURE_2D, 0, l, e.width / 4, e.height / 4, 0, r.RGBA, n, null), s.colorAttachment.set(i);
                                            }(t, e, o, a);
                                        }
                                    }(o, e, s), o.clear({
                                        color: t.aT.transparent
                                    });
                                    for(let t = 0; t < a.length; t++){
                                        const h = a[t];
                                        if (i.hasRenderableParent(h)) continue;
                                        const c = i.getTile(h), u = c.getBucket(s);
                                        if (!u) continue;
                                        const d = u.programConfigurations.get(s.id), _ = e.useProgram("heatmap", d), { zoom: p } = e.transform;
                                        _.draw(o, r.TRIANGLES, Pi.disabled, n, l, zi.disabled, we(h.posMatrix, c, p, s.paint.get("heatmap-intensity")), null, s.id, u.layoutVertexBuffer, u.indexBuffer, u.segments, s.paint, e.transform.zoom, d);
                                    }
                                    o.viewport.set([
                                        0,
                                        0,
                                        e.width,
                                        e.height
                                    ]);
                                } else "translucent" === e.renderPass && (e.context.setColorMode(e.colorModeForRenderPass()), function(e, i) {
                                    const s = e.context, a = s.gl, o = i.heatmapFbo;
                                    if (!o) return;
                                    s.activeTexture.set(a.TEXTURE0), a.bindTexture(a.TEXTURE_2D, o.colorAttachment.get()), s.activeTexture.set(a.TEXTURE1);
                                    let r = i.colorRampTexture;
                                    r || (r = i.colorRampTexture = new x(s, i.colorRamp, a.RGBA)), r.bind(a.LINEAR, a.CLAMP_TO_EDGE), e.useProgram("heatmapTexture").draw(s, a.TRIANGLES, Pi.disabled, Mi.disabled, e.colorModeForRenderPass(), zi.disabled, ((e, i, s, a)=>{
                                        const o = t.Z();
                                        t.aS(o, 0, e.width, e.height, 0, 0, 1);
                                        const r = e.context.gl;
                                        return {
                                            u_matrix: o,
                                            u_world: [
                                                r.drawingBufferWidth,
                                                r.drawingBufferHeight
                                            ],
                                            u_image: 0,
                                            u_color_ramp: 1,
                                            u_opacity: i.paint.get("heatmap-opacity")
                                        };
                                    })(e, i), null, i.id, e.viewportBuffer, e.quadTriangleIndexBuffer, e.viewportSegments, i.paint, e.transform.zoom);
                                }(e, s));
                            }
                        }(e, i, s, a);
                        break;
                    case "line":
                        !function(e, i, s, a) {
                            if ("translucent" !== e.renderPass) return;
                            const o = s.paint.get("line-opacity"), r = s.paint.get("line-width");
                            if (0 === o.constantOr(1) || 0 === r.constantOr(1)) return;
                            const n = e.depthModeForSublayer(0, Pi.ReadOnly), l = e.colorModeForRenderPass(), h = s.paint.get("line-dasharray"), c = s.paint.get("line-pattern"), u = c.constantOr(1), d = s.paint.get("line-gradient"), _ = s.getCrossfadeParameters(), p = u ? "linePattern" : h ? "lineSDF" : d ? "lineGradient" : "line", m = e.context, f = m.gl;
                            let g = !0;
                            for (const o of a){
                                const a = i.getTile(o);
                                if (u && !a.patternsLoaded()) continue;
                                const r = a.getBucket(s);
                                if (!r) continue;
                                const v = r.programConfigurations.get(s.id), y = e.context.program.get(), b = e.useProgram(p, v), w = g || b.program !== y, T = e.style.map.terrain && e.style.map.terrain.getTerrainData(o), I = c.constantOr(null);
                                if (I && a.imageAtlas) {
                                    const t = a.imageAtlas, e = t.patternPositions[I.to.toString()], i = t.patternPositions[I.from.toString()];
                                    e && i && v.setConstantPatternPositions(e, i);
                                }
                                const E = T ? o : null, S = u ? Se(e, a, s, _, E) : h ? Ce(e, a, s, h, _, E) : d ? Ee(e, a, s, r.lineClipsArray.length, E) : Ie(e, a, s, E);
                                if (u) m.activeTexture.set(f.TEXTURE0), a.imageAtlasTexture.bind(f.LINEAR, f.CLAMP_TO_EDGE), v.updatePaintBuffers(_);
                                else if (h && (w || e.lineAtlas.dirty)) m.activeTexture.set(f.TEXTURE0), e.lineAtlas.bind(m);
                                else if (d) {
                                    const a = r.gradients[s.id];
                                    let n = a.texture;
                                    if (s.gradientVersion !== a.version) {
                                        let l = 256;
                                        if (s.stepInterpolant) {
                                            const s = i.getSource().maxzoom, a = o.canonical.z === s ? Math.ceil(1 << e.transform.maxZoom - o.canonical.z) : 1;
                                            l = t.ad(t.aY(r.maxLineLength / t.N * 1024 * a), 256, m.maxTextureSize);
                                        }
                                        a.gradient = t.aZ({
                                            expression: s.gradientExpression(),
                                            evaluationKey: "lineProgress",
                                            resolution: l,
                                            image: a.gradient || void 0,
                                            clips: r.lineClipsArray
                                        }), a.texture ? a.texture.update(a.gradient) : a.texture = new x(m, a.gradient, f.RGBA), a.version = s.gradientVersion, n = a.texture;
                                    }
                                    m.activeTexture.set(f.TEXTURE0), n.bind(s.stepInterpolant ? f.NEAREST : f.LINEAR, f.CLAMP_TO_EDGE);
                                }
                                b.draw(m, f.TRIANGLES, n, e.stencilModeForClipping(o), l, zi.disabled, S, T, s.id, r.layoutVertexBuffer, r.indexBuffer, r.segments, s.paint, e.transform.zoom, v, r.layoutVertexBuffer2), g = !1;
                            }
                        }(e, i, s, a);
                        break;
                    case "fill":
                        !function(e, i, s, a) {
                            const o = s.paint.get("fill-color"), r = s.paint.get("fill-opacity");
                            if (0 === r.constantOr(1)) return;
                            const n = e.colorModeForRenderPass(), l = s.paint.get("fill-pattern"), h = e.opaquePassEnabledForLayer() && !l.constantOr(1) && 1 === o.constantOr(t.aT.transparent).a && 1 === r.constantOr(0) ? "opaque" : "translucent";
                            if (e.renderPass === h) {
                                const t = e.depthModeForSublayer(1, "opaque" === e.renderPass ? Pi.ReadWrite : Pi.ReadOnly);
                                Zi(e, i, s, a, t, n, !1);
                            }
                            if ("translucent" === e.renderPass && s.paint.get("fill-antialias")) {
                                const t = e.depthModeForSublayer(s.getPaintProperty("fill-outline-color") ? 2 : 0, Pi.ReadOnly);
                                Zi(e, i, s, a, t, n, !0);
                            }
                        }(e, i, s, a);
                        break;
                    case "fill-extrusion":
                        !function(t, e, i, s) {
                            const a = i.paint.get("fill-extrusion-opacity");
                            if (0 !== a && "translucent" === t.renderPass) {
                                const o = new Pi(t.context.gl.LEQUAL, Pi.ReadWrite, t.depthRangeFor3D);
                                if (1 !== a || i.paint.get("fill-extrusion-pattern").constantOr(1)) Gi(t, e, i, s, o, Mi.disabled, Si.disabled), Gi(t, e, i, s, o, t.stencilModeFor3D(), t.colorModeForRenderPass());
                                else {
                                    const a = t.colorModeForRenderPass();
                                    Gi(t, e, i, s, o, Mi.disabled, a);
                                }
                            }
                        }(e, i, s, a);
                        break;
                    case "hillshade":
                        !function(t, e, i, s) {
                            if ("offscreen" !== t.renderPass && "translucent" !== t.renderPass) return;
                            const a = t.context, o = t.depthModeForSublayer(0, Pi.ReadOnly), r = t.colorModeForRenderPass(), [n, l] = "translucent" === t.renderPass ? t.stencilConfigForOverlap(s) : [
                                {},
                                s
                            ];
                            for (const s of l){
                                const a = e.getTile(s);
                                void 0 !== a.needsHillshadePrepare && a.needsHillshadePrepare && "offscreen" === t.renderPass ? Vi(t, a, i, o, Mi.disabled, r) : "translucent" === t.renderPass && ji(t, s, a, i, o, n[s.overscaledZ], r);
                            }
                            a.viewport.set([
                                0,
                                0,
                                t.width,
                                t.height
                            ]);
                        }(e, i, s, a);
                        break;
                    case "raster":
                        !function(t, e, i, s) {
                            if ("translucent" !== t.renderPass) return;
                            if (0 === i.paint.get("raster-opacity")) return;
                            if (!s.length) return;
                            const a = t.context, o = a.gl, r = e.getSource(), n = t.useProgram("raster"), l = t.colorModeForRenderPass(), [h, c] = r instanceof N ? [
                                {},
                                s
                            ] : t.stencilConfigForOverlap(s), u = c[c.length - 1].overscaledZ, d = !t.options.moving;
                            for (const s of c){
                                const c = t.depthModeForSublayer(s.overscaledZ - u, 1 === i.paint.get("raster-opacity") ? Pi.ReadWrite : Pi.ReadOnly, o.LESS), _ = e.getTile(s);
                                _.registerFadeDuration(i.paint.get("raster-fade-duration"));
                                const p = e.findLoadedParent(s, 0), m = qi(_, p, e, i, t.transform, t.style.map.terrain);
                                let f, g;
                                const v = "nearest" === i.paint.get("raster-resampling") ? o.NEAREST : o.LINEAR;
                                a.activeTexture.set(o.TEXTURE0), _.texture.bind(v, o.CLAMP_TO_EDGE, o.LINEAR_MIPMAP_NEAREST), a.activeTexture.set(o.TEXTURE1), p ? (p.texture.bind(v, o.CLAMP_TO_EDGE, o.LINEAR_MIPMAP_NEAREST), f = Math.pow(2, p.tileID.overscaledZ - _.tileID.overscaledZ), g = [
                                    _.tileID.canonical.x * f % 1,
                                    _.tileID.canonical.y * f % 1
                                ]) : _.texture.bind(v, o.CLAMP_TO_EDGE, o.LINEAR_MIPMAP_NEAREST);
                                const x = t.style.map.terrain && t.style.map.terrain.getTerrainData(s), y = x ? s : null, b = y ? y.posMatrix : t.transform.calculatePosMatrix(s.toUnwrapped(), d), w = Me(b, g || [
                                    0,
                                    0
                                ], f || 1, m, i);
                                r instanceof N ? n.draw(a, o.TRIANGLES, c, Mi.disabled, l, zi.disabled, w, x, i.id, r.boundsBuffer, t.quadTriangleIndexBuffer, r.boundsSegments) : n.draw(a, o.TRIANGLES, c, h[s.overscaledZ], l, zi.disabled, w, x, i.id, t.rasterBoundsBuffer, t.quadTriangleIndexBuffer, t.rasterBoundsSegments);
                            }
                        }(e, i, s, a);
                        break;
                    case "background":
                        !function(t, e, i, s) {
                            const a = i.paint.get("background-color"), o = i.paint.get("background-opacity");
                            if (0 === o) return;
                            const r = t.context, n = r.gl, l = t.transform, h = l.tileSize, c = i.paint.get("background-pattern");
                            if (t.isPatternMissing(c)) return;
                            const u = !c && 1 === a.a && 1 === o && t.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                            if (t.renderPass !== u) return;
                            const d = Mi.disabled, _ = t.depthModeForSublayer(0, "opaque" === u ? Pi.ReadWrite : Pi.ReadOnly), p = t.colorModeForRenderPass(), m = t.useProgram(c ? "backgroundPattern" : "background"), f = s || l.coveringTiles({
                                tileSize: h,
                                terrain: t.style.map.terrain
                            });
                            c && (r.activeTexture.set(n.TEXTURE0), t.imageManager.bind(t.context));
                            const g = i.getCrossfadeParameters();
                            for (const e of f){
                                const l = s ? e.posMatrix : t.transform.calculatePosMatrix(e.toUnwrapped()), u = c ? Fe(l, o, t, c, {
                                    tileID: e,
                                    tileSize: h
                                }, g) : ke(l, o, a), f = t.style.map.terrain && t.style.map.terrain.getTerrainData(e);
                                m.draw(r, n.TRIANGLES, _, d, p, zi.disabled, u, f, i.id, t.tileExtentBuffer, t.quadTriangleIndexBuffer, t.tileExtentSegments);
                            }
                        }(e, 0, s, a);
                        break;
                    case "custom":
                        !function(t, e, i) {
                            const s = t.context, a = i.implementation;
                            if ("offscreen" === t.renderPass) {
                                const e = a.prerender;
                                e && (t.setCustomLayerDefaults(), s.setColorMode(t.colorModeForRenderPass()), e.call(a, s.gl, t.transform.customLayerMatrix()), s.setDirty(), t.setBaseState());
                            } else if ("translucent" === t.renderPass) {
                                t.setCustomLayerDefaults(), s.setColorMode(t.colorModeForRenderPass()), s.setStencilMode(Mi.disabled);
                                const e = "3d" === a.renderingMode ? new Pi(t.context.gl.LEQUAL, Pi.ReadWrite, t.depthRangeFor3D) : t.depthModeForSublayer(0, Pi.ReadOnly);
                                s.setDepthMode(e), a.render(s.gl, t.transform.customLayerMatrix()), s.setDirty(), t.setBaseState(), s.bindFramebuffer.set(null);
                            }
                        }(e, 0, s);
                }
            }
            translatePosMatrix(e, i, s, a, o) {
                if (!s[0] && !s[1]) return e;
                const r = o ? "map" === a ? this.transform.angle : 0 : "viewport" === a ? -this.transform.angle : 0;
                if (r) {
                    const t = Math.sin(r), e = Math.cos(r);
                    s = [
                        s[0] * e - s[1] * t,
                        s[0] * t + s[1] * e
                    ];
                }
                const n = [
                    o ? s[0] : St(i, s[0], this.transform.zoom),
                    o ? s[1] : St(i, s[1], this.transform.zoom),
                    0
                ], l = new Float32Array(16);
                return t.$(l, e, n), l;
            }
            saveTileTexture(t) {
                const e = this._tileTextures[t.size[0]];
                e ? e.push(t) : this._tileTextures[t.size[0]] = [
                    t
                ];
            }
            getTileTexture(t) {
                const e = this._tileTextures[t];
                return e && e.length > 0 ? e.pop() : null;
            }
            isPatternMissing(t) {
                if (!t) return !1;
                if (!t.from || !t.to) return !0;
                const e = this.imageManager.getPattern(t.from.toString()), i = this.imageManager.getPattern(t.to.toString());
                return !e || !i;
            }
            useProgram(t, e) {
                this.cache = this.cache || {};
                const i = t + (e ? e.cacheKey : "") + (this._showOverdrawInspector ? "/overdraw" : "") + (this.style.map.terrain ? "/terrain" : "");
                return this.cache[i] || (this.cache[i] = new ce(this.context, re[t], e, Be[t], this._showOverdrawInspector, this.style.map.terrain)), this.cache[i];
            }
            setCustomLayerDefaults() {
                this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
            }
            setBaseState() {
                const t = this.context.gl;
                this.context.cullFace.set(!1), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.context.blendEquation.set(t.FUNC_ADD);
            }
            initDebugOverlayCanvas() {
                null == this.debugOverlayCanvas && (this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new x(this.context, this.debugOverlayCanvas, this.context.gl.RGBA));
            }
            destroy() {
                this.debugOverlayTexture && this.debugOverlayTexture.destroy();
            }
            overLimit() {
                const { drawingBufferWidth: t, drawingBufferHeight: e } = this.context.gl;
                return this.width !== t || this.height !== e;
            }
        }
        class ss {
            constructor(t, e){
                this.points = t, this.planes = e;
            }
            static fromInvProjectionMatrix(e, i, s) {
                const a = Math.pow(2, s), o = [
                    [
                        -1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        -1,
                        1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        1,
                        1
                    ]
                ].map((s)=>{
                    const o = 1 / (s = t.ag([], s, e))[3] / i * a;
                    return t.b3(s, s, [
                        o,
                        o,
                        1 / s[3],
                        o
                    ]);
                }), r = [
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        6,
                        5,
                        4
                    ],
                    [
                        0,
                        3,
                        7
                    ],
                    [
                        2,
                        1,
                        5
                    ],
                    [
                        3,
                        2,
                        6
                    ],
                    [
                        0,
                        4,
                        5
                    ]
                ].map((t)=>{
                    const e = function(t, e) {
                        var i = e[0], s = e[1], a = e[2], o = i * i + s * s + a * a;
                        return o > 0 && (o = 1 / Math.sqrt(o)), t[0] = e[0] * o, t[1] = e[1] * o, t[2] = e[2] * o, t;
                    }([], function(t, e, i) {
                        var s = e[0], a = e[1], o = e[2], r = i[0], n = i[1], l = i[2];
                        return t[0] = a * l - o * n, t[1] = o * r - s * l, t[2] = s * n - a * r, t;
                    }([], m([], o[t[0]], o[t[1]]), m([], o[t[2]], o[t[1]]))), i = -((s = e)[0] * (a = o[t[1]])[0] + s[1] * a[1] + s[2] * a[2]);
                    var s, a;
                    return e.concat(i);
                });
                return new ss(o, r);
            }
        }
        class as {
            constructor(t, e){
                this.min = t, this.max = e, this.center = function(t, e, i) {
                    return t[0] = .5 * e[0], t[1] = .5 * e[1], t[2] = .5 * e[2], t;
                }([], function(t, e, i) {
                    return t[0] = e[0] + i[0], t[1] = e[1] + i[1], t[2] = e[2] + i[2], t;
                }([], this.min, this.max));
            }
            quadrant(t) {
                const e = [
                    t % 2 == 0,
                    t < 2
                ], i = _(this.min), s = _(this.max);
                for(let t = 0; t < e.length; t++)i[t] = e[t] ? this.min[t] : this.center[t], s[t] = e[t] ? this.center[t] : this.max[t];
                return s[2] = this.max[2], new as(i, s);
            }
            distanceX(t) {
                return Math.max(Math.min(this.max[0], t[0]), this.min[0]) - t[0];
            }
            distanceY(t) {
                return Math.max(Math.min(this.max[1], t[1]), this.min[1]) - t[1];
            }
            intersects(e) {
                const i = [
                    [
                        this.min[0],
                        this.min[1],
                        this.min[2],
                        1
                    ],
                    [
                        this.max[0],
                        this.min[1],
                        this.min[2],
                        1
                    ],
                    [
                        this.max[0],
                        this.max[1],
                        this.min[2],
                        1
                    ],
                    [
                        this.min[0],
                        this.max[1],
                        this.min[2],
                        1
                    ],
                    [
                        this.min[0],
                        this.min[1],
                        this.max[2],
                        1
                    ],
                    [
                        this.max[0],
                        this.min[1],
                        this.max[2],
                        1
                    ],
                    [
                        this.max[0],
                        this.max[1],
                        this.max[2],
                        1
                    ],
                    [
                        this.min[0],
                        this.max[1],
                        this.max[2],
                        1
                    ]
                ];
                let s = !0;
                for(let a = 0; a < e.planes.length; a++){
                    const o = e.planes[a];
                    let r = 0;
                    for(let e = 0; e < i.length; e++)t.b4(o, i[e]) >= 0 && r++;
                    if (0 === r) return 0;
                    r !== i.length && (s = !1);
                }
                if (s) return 2;
                for(let t = 0; t < 3; t++){
                    let i = Number.MAX_VALUE, s = -Number.MAX_VALUE;
                    for(let a = 0; a < e.points.length; a++){
                        const o = e.points[a][t] - this.min[t];
                        i = Math.min(i, o), s = Math.max(s, o);
                    }
                    if (s < 0 || i > this.max[t] - this.min[t]) return 0;
                }
                return 1;
            }
        }
        class os {
            constructor(t = 0, e = 0, i = 0, s = 0){
                if (isNaN(t) || t < 0 || isNaN(e) || e < 0 || isNaN(i) || i < 0 || isNaN(s) || s < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
                this.top = t, this.bottom = e, this.left = i, this.right = s;
            }
            interpolate(e, i, s) {
                return null != i.top && null != e.top && (this.top = t.B.number(e.top, i.top, s)), null != i.bottom && null != e.bottom && (this.bottom = t.B.number(e.bottom, i.bottom, s)), null != i.left && null != e.left && (this.left = t.B.number(e.left, i.left, s)), null != i.right && null != e.right && (this.right = t.B.number(e.right, i.right, s)), this;
            }
            getCenter(e, i) {
                const s = t.ad((this.left + e - this.right) / 2, 0, e), a = t.ad((this.top + i - this.bottom) / 2, 0, i);
                return new t.P(s, a);
            }
            equals(t) {
                return this.top === t.top && this.bottom === t.bottom && this.left === t.left && this.right === t.right;
            }
            clone() {
                return new os(this.top, this.bottom, this.left, this.right);
            }
            toJSON() {
                return {
                    top: this.top,
                    bottom: this.bottom,
                    left: this.left,
                    right: this.right
                };
            }
        }
        class rs {
            constructor(e, i, s, a, o){
                this.tileSize = 512, this.maxValidLatitude = 85.051129, this._renderWorldCopies = void 0 === o || !!o, this._minZoom = e || 0, this._maxZoom = i || 22, this._minPitch = null == s ? 0 : s, this._maxPitch = null == a ? 60 : a, this.setMaxBounds(), this.width = 0, this.height = 0, this._center = new t.L(0, 0), this._elevation = 0, this.zoom = 0, this.angle = 0, this._fov = .6435011087932844, this._pitch = 0, this._unmodified = !0, this._edgeInsets = new os, this._posMatrixCache = {}, this._alignedPosMatrixCache = {}, this._minEleveationForCurrentTile = 0;
            }
            clone() {
                const t = new rs(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies);
                return t.apply(this), t;
            }
            apply(t) {
                this.tileSize = t.tileSize, this.latRange = t.latRange, this.width = t.width, this.height = t.height, this._center = t._center, this._elevation = t._elevation, this._minEleveationForCurrentTile = t._minEleveationForCurrentTile, this.zoom = t.zoom, this.angle = t.angle, this._fov = t._fov, this._pitch = t._pitch, this._unmodified = t._unmodified, this._edgeInsets = t._edgeInsets.clone(), this._calcMatrices();
            }
            get minZoom() {
                return this._minZoom;
            }
            set minZoom(t) {
                this._minZoom !== t && (this._minZoom = t, this.zoom = Math.max(this.zoom, t));
            }
            get maxZoom() {
                return this._maxZoom;
            }
            set maxZoom(t) {
                this._maxZoom !== t && (this._maxZoom = t, this.zoom = Math.min(this.zoom, t));
            }
            get minPitch() {
                return this._minPitch;
            }
            set minPitch(t) {
                this._minPitch !== t && (this._minPitch = t, this.pitch = Math.max(this.pitch, t));
            }
            get maxPitch() {
                return this._maxPitch;
            }
            set maxPitch(t) {
                this._maxPitch !== t && (this._maxPitch = t, this.pitch = Math.min(this.pitch, t));
            }
            get renderWorldCopies() {
                return this._renderWorldCopies;
            }
            set renderWorldCopies(t) {
                void 0 === t ? t = !0 : null === t && (t = !1), this._renderWorldCopies = t;
            }
            get worldSize() {
                return this.tileSize * this.scale;
            }
            get centerOffset() {
                return this.centerPoint._sub(this.size._div(2));
            }
            get size() {
                return new t.P(this.width, this.height);
            }
            get bearing() {
                return -this.angle / Math.PI * 180;
            }
            set bearing(e) {
                const i = -t.b5(e, -180, 180) * Math.PI / 180;
                this.angle !== i && (this._unmodified = !1, this.angle = i, this._calcMatrices(), this.rotationMatrix = function() {
                    var e = new t.A(4);
                    return t.A != Float32Array && (e[1] = 0, e[2] = 0), e[0] = 1, e[3] = 1, e;
                }(), function(t, e, i) {
                    var s = e[0], a = e[1], o = e[2], r = e[3], n = Math.sin(i), l = Math.cos(i);
                    t[0] = s * l + o * n, t[1] = a * l + r * n, t[2] = s * -n + o * l, t[3] = a * -n + r * l;
                }(this.rotationMatrix, this.rotationMatrix, this.angle));
            }
            get pitch() {
                return this._pitch / Math.PI * 180;
            }
            set pitch(e) {
                const i = t.ad(e, this.minPitch, this.maxPitch) / 180 * Math.PI;
                this._pitch !== i && (this._unmodified = !1, this._pitch = i, this._calcMatrices());
            }
            get fov() {
                return this._fov / Math.PI * 180;
            }
            set fov(t) {
                t = Math.max(.01, Math.min(60, t)), this._fov !== t && (this._unmodified = !1, this._fov = t / 180 * Math.PI, this._calcMatrices());
            }
            get zoom() {
                return this._zoom;
            }
            set zoom(t) {
                const e = Math.min(Math.max(t, this.minZoom), this.maxZoom);
                this._zoom !== e && (this._unmodified = !1, this._zoom = e, this.tileZoom = Math.max(0, Math.floor(e)), this.scale = this.zoomScale(e), this._constrain(), this._calcMatrices());
            }
            get center() {
                return this._center;
            }
            set center(t) {
                t.lat === this._center.lat && t.lng === this._center.lng || (this._unmodified = !1, this._center = t, this._constrain(), this._calcMatrices());
            }
            get elevation() {
                return this._elevation;
            }
            set elevation(t) {
                t !== this._elevation && (this._elevation = t, this._constrain(), this._calcMatrices());
            }
            get padding() {
                return this._edgeInsets.toJSON();
            }
            set padding(t) {
                this._edgeInsets.equals(t) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, t, 1), this._calcMatrices());
            }
            get centerPoint() {
                return this._edgeInsets.getCenter(this.width, this.height);
            }
            isPaddingEqual(t) {
                return this._edgeInsets.equals(t);
            }
            interpolatePadding(t, e, i) {
                this._unmodified = !1, this._edgeInsets.interpolate(t, e, i), this._constrain(), this._calcMatrices();
            }
            coveringZoomLevel(t) {
                const e = (t.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / t.tileSize));
                return Math.max(0, e);
            }
            getVisibleUnwrappedCoordinates(e) {
                const i = [
                    new t.b6(0, e)
                ];
                if (this._renderWorldCopies) {
                    const s = this.pointCoordinate(new t.P(0, 0)), a = this.pointCoordinate(new t.P(this.width, 0)), o = this.pointCoordinate(new t.P(this.width, this.height)), r = this.pointCoordinate(new t.P(0, this.height)), n = Math.floor(Math.min(s.x, a.x, o.x, r.x)), l = Math.floor(Math.max(s.x, a.x, o.x, r.x)), h = 1;
                    for(let s = n - h; s <= l + h; s++)0 !== s && i.push(new t.b6(s, e));
                }
                return i;
            }
            coveringTiles(e) {
                var i, s;
                let a = this.coveringZoomLevel(e);
                const o = a;
                if (void 0 !== e.minzoom && a < e.minzoom) return [];
                void 0 !== e.maxzoom && a > e.maxzoom && (a = e.maxzoom);
                const r = this.pointCoordinate(this.getCameraPoint()), n = t.U.fromLngLat(this.center), l = Math.pow(2, a), h = [
                    l * r.x,
                    l * r.y,
                    0
                ], c = [
                    l * n.x,
                    l * n.y,
                    0
                ], u = ss.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, a);
                let d = e.minzoom || 0;
                !e.terrain && this.pitch <= 60 && this._edgeInsets.top < .1 && (d = a);
                const _ = e.terrain ? 2 / Math.min(this.tileSize, e.tileSize) * this.tileSize : 3, p = (t)=>({
                        aabb: new as([
                            t * l,
                            0,
                            0
                        ], [
                            (t + 1) * l,
                            l,
                            0
                        ]),
                        zoom: 0,
                        x: 0,
                        y: 0,
                        wrap: t,
                        fullyVisible: !1
                    }), m = [], g = [], v = a, x = e.reparseOverscaled ? o : a;
                if (this._renderWorldCopies) for(let t = 1; t <= 3; t++)m.push(p(-t)), m.push(p(t));
                for(m.push(p(0)); m.length > 0;){
                    const a = m.pop(), o = a.x, r = a.y;
                    let n = a.fullyVisible;
                    if (!n) {
                        const t = a.aabb.intersects(u);
                        if (0 === t) continue;
                        n = 2 === t;
                    }
                    const l = e.terrain ? h : c, p = a.aabb.distanceX(l), y = a.aabb.distanceY(l), b = Math.max(Math.abs(p), Math.abs(y));
                    if (a.zoom === v || b > _ + (1 << v - a.zoom) - 2 && a.zoom >= d) {
                        const e = v - a.zoom, i = h[0] - .5 - (o << e), s = h[1] - .5 - (r << e);
                        g.push({
                            tileID: new t.O(a.zoom === v ? x : a.zoom, a.wrap, a.zoom, o, r),
                            distanceSq: f([
                                c[0] - .5 - o,
                                c[1] - .5 - r
                            ]),
                            tileDistanceToCamera: Math.sqrt(i * i + s * s)
                        });
                    } else for(let l = 0; l < 4; l++){
                        const h = (o << 1) + l % 2, c = (r << 1) + (l >> 1), u = a.zoom + 1;
                        let d = a.aabb.quadrant(l);
                        if (e.terrain) {
                            const o = new t.O(u, a.wrap, u, h, c), r = e.terrain.getMinMaxElevation(o), n = null !== (i = r.minElevation) && void 0 !== i ? i : this.elevation, l = null !== (s = r.maxElevation) && void 0 !== s ? s : this.elevation;
                            d = new as([
                                d.min[0],
                                d.min[1],
                                n
                            ], [
                                d.max[0],
                                d.max[1],
                                l
                            ]);
                        }
                        m.push({
                            aabb: d,
                            zoom: u,
                            x: h,
                            y: c,
                            wrap: a.wrap,
                            fullyVisible: n
                        });
                    }
                }
                return g.sort((t, e)=>t.distanceSq - e.distanceSq).map((t)=>t.tileID);
            }
            resize(t, e) {
                this.width = t, this.height = e, this.pixelsToGLUnits = [
                    2 / t,
                    -2 / e
                ], this._constrain(), this._calcMatrices();
            }
            get unmodified() {
                return this._unmodified;
            }
            zoomScale(t) {
                return Math.pow(2, t);
            }
            scaleZoom(t) {
                return Math.log(t) / Math.LN2;
            }
            project(e) {
                const i = t.ad(e.lat, -this.maxValidLatitude, this.maxValidLatitude);
                return new t.P(t.G(e.lng) * this.worldSize, t.H(i) * this.worldSize);
            }
            unproject(e) {
                return new t.U(e.x / this.worldSize, e.y / this.worldSize).toLngLat();
            }
            get point() {
                return this.project(this.center);
            }
            getCameraPosition() {
                return {
                    lngLat: this.pointLocation(this.getCameraPoint()),
                    altitude: Math.cos(this._pitch) * this.cameraToCenterDistance / this._pixelPerMeter + this.elevation
                };
            }
            recalculateZoom(e) {
                const i = this.pointLocation(this.centerPoint, e), s = e.getElevationForLngLatZoom(i, this.tileZoom);
                if (!(this.elevation - s)) return;
                const a = this.getCameraPosition(), o = t.U.fromLngLat(a.lngLat, a.altitude), r = t.U.fromLngLat(i, s), n = o.x - r.x, l = o.y - r.y, h = o.z - r.z, c = Math.sqrt(n * n + l * l + h * h), u = this.scaleZoom(this.cameraToCenterDistance / c / this.tileSize);
                this._elevation = s, this._center = i, this.zoom = u;
            }
            setLocationAtPoint(e, i) {
                const s = this.pointCoordinate(i), a = this.pointCoordinate(this.centerPoint), o = this.locationCoordinate(e), r = new t.U(o.x - (s.x - a.x), o.y - (s.y - a.y));
                this.center = this.coordinateLocation(r), this._renderWorldCopies && (this.center = this.center.wrap());
            }
            locationPoint(t, e) {
                return e ? this.coordinatePoint(this.locationCoordinate(t), e.getElevationForLngLatZoom(t, this.tileZoom), this.pixelMatrix3D) : this.coordinatePoint(this.locationCoordinate(t));
            }
            pointLocation(t, e) {
                return this.coordinateLocation(this.pointCoordinate(t, e));
            }
            locationCoordinate(e) {
                return t.U.fromLngLat(e);
            }
            coordinateLocation(t) {
                return t && t.toLngLat();
            }
            pointCoordinate(e, i) {
                if (i) {
                    const t = i.pointCoordinate(e);
                    if (null != t) return t;
                }
                const s = [
                    e.x,
                    e.y,
                    0,
                    1
                ], a = [
                    e.x,
                    e.y,
                    1,
                    1
                ];
                t.ag(s, s, this.pixelMatrixInverse), t.ag(a, a, this.pixelMatrixInverse);
                const o = s[3], r = a[3], n = s[1] / o, l = a[1] / r, h = s[2] / o, c = a[2] / r, u = h === c ? 0 : (0 - h) / (c - h);
                return new t.U(t.B.number(s[0] / o, a[0] / r, u) / this.worldSize, t.B.number(n, l, u) / this.worldSize);
            }
            coordinatePoint(e, i = 0, s = this.pixelMatrix) {
                const a = [
                    e.x * this.worldSize,
                    e.y * this.worldSize,
                    i,
                    1
                ];
                return t.ag(a, a, s), new t.P(a[0] / a[3], a[1] / a[3]);
            }
            getBounds() {
                const e = Math.max(0, this.height / 2 - this.getHorizon());
                return (new L).extend(this.pointLocation(new t.P(0, e))).extend(this.pointLocation(new t.P(this.width, e))).extend(this.pointLocation(new t.P(this.width, this.height))).extend(this.pointLocation(new t.P(0, this.height)));
            }
            getMaxBounds() {
                return this.latRange && 2 === this.latRange.length && this.lngRange && 2 === this.lngRange.length ? new L([
                    this.lngRange[0],
                    this.latRange[0]
                ], [
                    this.lngRange[1],
                    this.latRange[1]
                ]) : null;
            }
            getHorizon() {
                return Math.tan(Math.PI / 2 - this._pitch) * this.cameraToCenterDistance * .85;
            }
            setMaxBounds(t) {
                t ? (this.lngRange = [
                    t.getWest(),
                    t.getEast()
                ], this.latRange = [
                    t.getSouth(),
                    t.getNorth()
                ], this._constrain()) : (this.lngRange = null, this.latRange = [
                    -this.maxValidLatitude,
                    this.maxValidLatitude
                ]);
            }
            calculatePosMatrix(e, i = !1) {
                const s = e.key, a = i ? this._alignedPosMatrixCache : this._posMatrixCache;
                if (a[s]) return a[s];
                const o = e.canonical, r = this.worldSize / this.zoomScale(o.z), n = o.x + Math.pow(2, o.z) * e.wrap, l = t.ao(new Float64Array(16));
                return t.$(l, l, [
                    n * r,
                    o.y * r,
                    0
                ]), t.a0(l, l, [
                    r / t.N,
                    r / t.N,
                    1
                ]), t.a1(l, i ? this.alignedProjMatrix : this.projMatrix, l), a[s] = new Float32Array(l), a[s];
            }
            customLayerMatrix() {
                return this.mercatorMatrix.slice();
            }
            _constrain() {
                if (!this.center || !this.width || !this.height || this._constraining) return;
                this._constraining = !0;
                let e, i, s, a, o = -90, r = 90, n = -180, l = 180;
                const h = this.size, c = this._unmodified;
                if (this.latRange) {
                    const i = this.latRange;
                    o = t.H(i[1]) * this.worldSize, r = t.H(i[0]) * this.worldSize, e = r - o < h.y ? h.y / (r - o) : 0;
                }
                if (this.lngRange) {
                    const e = this.lngRange;
                    n = t.b5(t.G(e[0]) * this.worldSize, 0, this.worldSize), l = t.b5(t.G(e[1]) * this.worldSize, 0, this.worldSize), l < n && (l += this.worldSize), i = l - n < h.x ? h.x / (l - n) : 0;
                }
                const u = this.point, d = Math.max(i || 0, e || 0);
                if (d) return this.center = this.unproject(new t.P(i ? (l + n) / 2 : u.x, e ? (r + o) / 2 : u.y)), this.zoom += this.scaleZoom(d), this._unmodified = c, void (this._constraining = !1);
                if (this.latRange) {
                    const t = u.y, e = h.y / 2;
                    t - e < o && (a = o + e), t + e > r && (a = r - e);
                }
                if (this.lngRange) {
                    const e = (n + l) / 2, i = t.b5(u.x, e - this.worldSize / 2, e + this.worldSize / 2), a = h.x / 2;
                    i - a < n && (s = n + a), i + a > l && (s = l - a);
                }
                void 0 === s && void 0 === a || (this.center = this.unproject(new t.P(void 0 !== s ? s : u.x, void 0 !== a ? a : u.y)).wrap()), this._unmodified = c, this._constraining = !1;
            }
            _calcMatrices() {
                if (!this.height) return;
                const e = this.centerOffset, i = this.point.x, s = this.point.y;
                this.cameraToCenterDistance = .5 / Math.tan(this._fov / 2) * this.height, this._pixelPerMeter = t.b7(1, this.center.lat) * this.worldSize;
                let a = t.ao(new Float64Array(16));
                t.a0(a, a, [
                    this.width / 2,
                    -this.height / 2,
                    1
                ]), t.$(a, a, [
                    1,
                    -1,
                    0
                ]), this.labelPlaneMatrix = a, a = t.ao(new Float64Array(16)), t.a0(a, a, [
                    1,
                    -1,
                    1
                ]), t.$(a, a, [
                    -1,
                    -1,
                    0
                ]), t.a0(a, a, [
                    2 / this.width,
                    2 / this.height,
                    1
                ]), this.glCoordMatrix = a;
                const o = this.cameraToCenterDistance + this._elevation * this._pixelPerMeter / Math.cos(this._pitch), r = Math.min(this.elevation, this._minEleveationForCurrentTile), n = o - r * this._pixelPerMeter / Math.cos(this._pitch), l = r < 0 ? n : o, h = Math.PI / 2 + this._pitch, c = this._fov * (.5 + e.y / this.height), u = Math.sin(c) * l / Math.sin(t.ad(Math.PI - h - c, .01, Math.PI - .01)), d = this.getHorizon(), _ = 2 * Math.atan(d / this.cameraToCenterDistance) * (.5 + e.y / (2 * d)), p = Math.sin(_) * l / Math.sin(t.ad(Math.PI - h - _, .01, Math.PI - .01)), m = Math.min(u, p), f = 1.01 * (Math.cos(Math.PI / 2 - this._pitch) * m + l), g = this.height / 50;
                a = new Float64Array(16), t.b8(a, this._fov, this.width / this.height, g, f), a[8] = 2 * -e.x / this.width, a[9] = 2 * e.y / this.height, t.a0(a, a, [
                    1,
                    -1,
                    1
                ]), t.$(a, a, [
                    0,
                    0,
                    -this.cameraToCenterDistance
                ]), t.b9(a, a, this._pitch), t.ae(a, a, this.angle), t.$(a, a, [
                    -i,
                    -s,
                    0
                ]), this.mercatorMatrix = t.a0([], a, [
                    this.worldSize,
                    this.worldSize,
                    this.worldSize
                ]), t.a0(a, a, [
                    1,
                    1,
                    this._pixelPerMeter
                ]), this.pixelMatrix = t.a1(new Float64Array(16), this.labelPlaneMatrix, a), t.$(a, a, [
                    0,
                    0,
                    -this.elevation
                ]), this.projMatrix = a, this.invProjMatrix = t.as([], a), this.pixelMatrix3D = t.a1(new Float64Array(16), this.labelPlaneMatrix, a);
                const v = this.width % 2 / 2, x = this.height % 2 / 2, y = Math.cos(this.angle), b = Math.sin(this.angle), w = i - Math.round(i) + y * v + b * x, T = s - Math.round(s) + y * x + b * v, I = new Float64Array(a);
                if (t.$(I, I, [
                    w > .5 ? w - 1 : w,
                    T > .5 ? T - 1 : T,
                    0
                ]), this.alignedProjMatrix = I, a = t.as(new Float64Array(16), this.pixelMatrix), !a) throw new Error("failed to invert matrix");
                this.pixelMatrixInverse = a, this._posMatrixCache = {}, this._alignedPosMatrixCache = {};
            }
            maxPitchScaleFactor() {
                if (!this.pixelMatrixInverse) return 1;
                const e = this.pointCoordinate(new t.P(0, 0)), i = [
                    e.x * this.worldSize,
                    e.y * this.worldSize,
                    0,
                    1
                ];
                return t.ag(i, i, this.pixelMatrix)[3] / this.cameraToCenterDistance;
            }
            getCameraPoint() {
                const e = Math.tan(this._pitch) * (this.cameraToCenterDistance || 1);
                return this.centerPoint.add(new t.P(0, e));
            }
            getCameraQueryGeometry(e) {
                const i = this.getCameraPoint();
                if (1 === e.length) return [
                    e[0],
                    i
                ];
                {
                    let s = i.x, a = i.y, o = i.x, r = i.y;
                    for (const t of e)s = Math.min(s, t.x), a = Math.min(a, t.y), o = Math.max(o, t.x), r = Math.max(r, t.y);
                    return [
                        new t.P(s, a),
                        new t.P(o, a),
                        new t.P(o, r),
                        new t.P(s, r),
                        new t.P(s, a)
                    ];
                }
            }
        }
        function ns(t, e) {
            let i, s = !1, a = null, o = null;
            const r = ()=>{
                a = null, s && (t.apply(o, i), a = setTimeout(r, e), s = !1);
            };
            return (...t)=>(s = !0, o = this, i = t, a || r(), a);
        }
        class ls {
            constructor(t){
                this._getCurrentHash = ()=>{
                    const t = window.location.hash.replace("#", "");
                    if (this._hashName) {
                        let e;
                        return t.split("&").map((t)=>t.split("=")).forEach((t)=>{
                            t[0] === this._hashName && (e = t);
                        }), (e && e[1] || "").split("/");
                    }
                    return t.split("/");
                }, this._onHashChange = ()=>{
                    const t = this._getCurrentHash();
                    if (t.length >= 3 && !t.some((t)=>isNaN(t))) {
                        const e = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(t[3] || 0) : this._map.getBearing();
                        return this._map.jumpTo({
                            center: [
                                +t[2],
                                +t[1]
                            ],
                            zoom: +t[0],
                            bearing: e,
                            pitch: +(t[4] || 0)
                        }), !0;
                    }
                    return !1;
                }, this._updateHashUnthrottled = ()=>{
                    const t = window.location.href.replace(/(#.+)?$/, this.getHashString());
                    try {
                        window.history.replaceState(window.history.state, null, t);
                    } catch (t) {}
                }, this._updateHash = ns(this._updateHashUnthrottled, 300), this._hashName = t && encodeURIComponent(t);
            }
            addTo(t) {
                return this._map = t, addEventListener("hashchange", this._onHashChange, !1), this._map.on("moveend", this._updateHash), this;
            }
            remove() {
                return removeEventListener("hashchange", this._onHashChange, !1), this._map.off("moveend", this._updateHash), clearTimeout(this._updateHash()), delete this._map, this;
            }
            getHashString(t) {
                const e = this._map.getCenter(), i = Math.round(100 * this._map.getZoom()) / 100, s = Math.ceil((i * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), a = Math.pow(10, s), o = Math.round(e.lng * a) / a, r = Math.round(e.lat * a) / a, n = this._map.getBearing(), l = this._map.getPitch();
                let h = "";
                if (h += t ? `/${o}/${r}/${i}` : `${i}/${r}/${o}`, (n || l) && (h += "/" + Math.round(10 * n) / 10), l && (h += `/${Math.round(l)}`), this._hashName) {
                    const t = this._hashName;
                    let e = !1;
                    const i = window.location.hash.slice(1).split("&").map((i)=>{
                        const s = i.split("=")[0];
                        return s === t ? (e = !0, `${s}=${h}`) : i;
                    }).filter((t)=>t);
                    return e || i.push(`${t}=${h}`), `#${i.join("&")}`;
                }
                return `#${h}`;
            }
        }
        const hs = {
            linearity: .3,
            easing: t.ba(0, 0, .3, 1)
        }, cs = t.e({
            deceleration: 2500,
            maxSpeed: 1400
        }, hs), us = t.e({
            deceleration: 20,
            maxSpeed: 1400
        }, hs), ds = t.e({
            deceleration: 1e3,
            maxSpeed: 360
        }, hs), _s = t.e({
            deceleration: 1e3,
            maxSpeed: 90
        }, hs);
        class ps {
            constructor(t){
                this._map = t, this.clear();
            }
            clear() {
                this._inertiaBuffer = [];
            }
            record(e) {
                this._drainInertiaBuffer(), this._inertiaBuffer.push({
                    time: t.h.now(),
                    settings: e
                });
            }
            _drainInertiaBuffer() {
                const e = this._inertiaBuffer, i = t.h.now();
                for(; e.length > 0 && i - e[0].time > 160;)e.shift();
            }
            _onMoveEnd(e) {
                if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
                const i = {
                    zoom: 0,
                    bearing: 0,
                    pitch: 0,
                    pan: new t.P(0, 0),
                    pinchAround: void 0,
                    around: void 0
                };
                for (const { settings: t } of this._inertiaBuffer)i.zoom += t.zoomDelta || 0, i.bearing += t.bearingDelta || 0, i.pitch += t.pitchDelta || 0, t.panDelta && i.pan._add(t.panDelta), t.around && (i.around = t.around), t.pinchAround && (i.pinchAround = t.pinchAround);
                const s = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, a = {};
                if (i.pan.mag()) {
                    const o = fs(i.pan.mag(), s, t.e({}, cs, e || {}));
                    a.offset = i.pan.mult(o.amount / i.pan.mag()), a.center = this._map.transform.center, ms(a, o);
                }
                if (i.zoom) {
                    const t = fs(i.zoom, s, us);
                    a.zoom = this._map.transform.zoom + t.amount, ms(a, t);
                }
                if (i.bearing) {
                    const e = fs(i.bearing, s, ds);
                    a.bearing = this._map.transform.bearing + t.ad(e.amount, -179, 179), ms(a, e);
                }
                if (i.pitch) {
                    const t = fs(i.pitch, s, _s);
                    a.pitch = this._map.transform.pitch + t.amount, ms(a, t);
                }
                if (a.zoom || a.bearing) {
                    const t = void 0 === i.pinchAround ? i.around : i.pinchAround;
                    a.around = t ? this._map.unproject(t) : this._map.getCenter();
                }
                return this.clear(), t.e(a, {
                    noMoveStart: !0
                });
            }
        }
        function ms(t, e) {
            (!t.duration || t.duration < e.duration) && (t.duration = e.duration, t.easing = e.easing);
        }
        function fs(e, i, s) {
            const { maxSpeed: a, linearity: o, deceleration: r } = s, n = t.ad(e * o / (i / 1e3), -a, a), l = Math.abs(n) / (r * o);
            return {
                easing: s.easing,
                duration: 1e3 * l,
                amount: n * (l / 2)
            };
        }
        class gs extends t.k {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e, s, a, o = {}){
                const r = i.mousePos(s.getCanvasContainer(), a), n = s.unproject(r);
                super(e, t.e({
                    point: r,
                    lngLat: n,
                    originalEvent: a
                }, o)), this._defaultPrevented = !1, this.target = s;
            }
        }
        class vs extends t.k {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e, s, a){
                const o = "touchend" === e ? a.changedTouches : a.touches, r = i.touchPos(s.getCanvasContainer(), o), n = r.map((t)=>s.unproject(t)), l = r.reduce((t, e, i, s)=>t.add(e.div(s.length)), new t.P(0, 0));
                super(e, {
                    points: r,
                    point: l,
                    lngLats: n,
                    lngLat: s.unproject(l),
                    originalEvent: a
                }), this._defaultPrevented = !1;
            }
        }
        class xs extends t.k {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(t, e, i){
                super(t, {
                    originalEvent: i
                }), this._defaultPrevented = !1;
            }
        }
        class ys {
            constructor(t, e){
                this._map = t, this._clickTolerance = e.clickTolerance;
            }
            reset() {
                delete this._mousedownPos;
            }
            wheel(t) {
                return this._firePreventable(new xs(t.type, this._map, t));
            }
            mousedown(t, e) {
                return this._mousedownPos = e, this._firePreventable(new gs(t.type, this._map, t));
            }
            mouseup(t) {
                this._map.fire(new gs(t.type, this._map, t));
            }
            click(t, e) {
                this._mousedownPos && this._mousedownPos.dist(e) >= this._clickTolerance || this._map.fire(new gs(t.type, this._map, t));
            }
            dblclick(t) {
                return this._firePreventable(new gs(t.type, this._map, t));
            }
            mouseover(t) {
                this._map.fire(new gs(t.type, this._map, t));
            }
            mouseout(t) {
                this._map.fire(new gs(t.type, this._map, t));
            }
            touchstart(t) {
                return this._firePreventable(new vs(t.type, this._map, t));
            }
            touchmove(t) {
                this._map.fire(new vs(t.type, this._map, t));
            }
            touchend(t) {
                this._map.fire(new vs(t.type, this._map, t));
            }
            touchcancel(t) {
                this._map.fire(new vs(t.type, this._map, t));
            }
            _firePreventable(t) {
                if (this._map.fire(t), t.defaultPrevented) return {};
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class bs {
            constructor(t){
                this._map = t;
            }
            reset() {
                this._delayContextMenu = !1, this._ignoreContextMenu = !0, delete this._contextMenuEvent;
            }
            mousemove(t) {
                this._map.fire(new gs(t.type, this._map, t));
            }
            mousedown() {
                this._delayContextMenu = !0, this._ignoreContextMenu = !1;
            }
            mouseup() {
                this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new gs("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
            }
            contextmenu(t) {
                this._delayContextMenu ? this._contextMenuEvent = t : this._ignoreContextMenu || this._map.fire(new gs(t.type, this._map, t)), this._map.listens("contextmenu") && t.preventDefault();
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class ws {
            constructor(t){
                this._map = t;
            }
            get transform() {
                return this._map._requestedCameraState || this._map.transform;
            }
            get center() {
                return {
                    lng: this.transform.center.lng,
                    lat: this.transform.center.lat
                };
            }
            get zoom() {
                return this.transform.zoom;
            }
            get pitch() {
                return this.transform.pitch;
            }
            get bearing() {
                return this.transform.bearing;
            }
            unproject(e) {
                return this.transform.pointLocation(t.P.convert(e), this._map.terrain);
            }
        }
        class Ts {
            constructor(t, e){
                this._map = t, this._tr = new ws(t), this._el = t.getCanvasContainer(), this._container = t.getContainer(), this._clickTolerance = e.clickTolerance || 1;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            enable() {
                this.isEnabled() || (this._enabled = !0);
            }
            disable() {
                this.isEnabled() && (this._enabled = !1);
            }
            mousedown(t, e) {
                this.isEnabled() && t.shiftKey && 0 === t.button && (i.disableDrag(), this._startPos = this._lastPos = e, this._active = !0);
            }
            mousemoveWindow(t, e) {
                if (!this._active) return;
                const s = e;
                if (this._lastPos.equals(s) || !this._box && s.dist(this._startPos) < this._clickTolerance) return;
                const a = this._startPos;
                this._lastPos = s, this._box || (this._box = i.create("div", "maplibregl-boxzoom", this._container), this._container.classList.add("maplibregl-crosshair"), this._fireEvent("boxzoomstart", t));
                const o = Math.min(a.x, s.x), r = Math.max(a.x, s.x), n = Math.min(a.y, s.y), l = Math.max(a.y, s.y);
                i.setTransform(this._box, `translate(${o}px,${n}px)`), this._box.style.width = r - o + "px", this._box.style.height = l - n + "px";
            }
            mouseupWindow(e, s) {
                if (!this._active) return;
                if (0 !== e.button) return;
                const a = this._startPos, o = s;
                if (this.reset(), i.suppressClick(), a.x !== o.x || a.y !== o.y) return this._map.fire(new t.k("boxzoomend", {
                    originalEvent: e
                })), {
                    cameraAnimation: (t)=>t.fitScreenCoordinates(a, o, this._tr.bearing, {
                            linear: !0
                        })
                };
                this._fireEvent("boxzoomcancel", e);
            }
            keydown(t) {
                this._active && 27 === t.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", t));
            }
            reset() {
                this._active = !1, this._container.classList.remove("maplibregl-crosshair"), this._box && (i.remove(this._box), this._box = null), i.enableDrag(), delete this._startPos, delete this._lastPos;
            }
            _fireEvent(e, i) {
                return this._map.fire(new t.k(e, {
                    originalEvent: i
                }));
            }
        }
        function Is(t, e) {
            if (t.length !== e.length) throw new Error(`The number of touches and points are not equal - touches ${t.length}, points ${e.length}`);
            const i = {};
            for(let s = 0; s < t.length; s++)i[t[s].identifier] = e[s];
            return i;
        }
        class Es {
            constructor(t){
                this.reset(), this.numTouches = t.numTouches;
            }
            reset() {
                delete this.centroid, delete this.startTime, delete this.touches, this.aborted = !1;
            }
            touchstart(e, i, s) {
                (this.centroid || s.length > this.numTouches) && (this.aborted = !0), this.aborted || (void 0 === this.startTime && (this.startTime = e.timeStamp), s.length === this.numTouches && (this.centroid = function(e) {
                    const i = new t.P(0, 0);
                    for (const t of e)i._add(t);
                    return i.div(e.length);
                }(i), this.touches = Is(s, i)));
            }
            touchmove(t, e, i) {
                if (this.aborted || !this.centroid) return;
                const s = Is(i, e);
                for(const t in this.touches){
                    const e = s[t];
                    (!e || e.dist(this.touches[t]) > 30) && (this.aborted = !0);
                }
            }
            touchend(t, e, i) {
                if ((!this.centroid || t.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === i.length) {
                    const t = !this.aborted && this.centroid;
                    if (this.reset(), t) return t;
                }
            }
        }
        class Ss {
            constructor(t){
                this.singleTap = new Es(t), this.numTaps = t.numTaps, this.reset();
            }
            reset() {
                this.lastTime = 1 / 0, delete this.lastTap, this.count = 0, this.singleTap.reset();
            }
            touchstart(t, e, i) {
                this.singleTap.touchstart(t, e, i);
            }
            touchmove(t, e, i) {
                this.singleTap.touchmove(t, e, i);
            }
            touchend(t, e, i) {
                const s = this.singleTap.touchend(t, e, i);
                if (s) {
                    const e = t.timeStamp - this.lastTime < 500, i = !this.lastTap || this.lastTap.dist(s) < 30;
                    if (e && i || this.reset(), this.count++, this.lastTime = t.timeStamp, this.lastTap = s, this.count === this.numTaps) return this.reset(), s;
                }
            }
        }
        class Cs {
            constructor(t){
                this._tr = new ws(t), this._zoomIn = new Ss({
                    numTouches: 1,
                    numTaps: 2
                }), this._zoomOut = new Ss({
                    numTouches: 2,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
            }
            touchstart(t, e, i) {
                this._zoomIn.touchstart(t, e, i), this._zoomOut.touchstart(t, e, i);
            }
            touchmove(t, e, i) {
                this._zoomIn.touchmove(t, e, i), this._zoomOut.touchmove(t, e, i);
            }
            touchend(t, e, i) {
                const s = this._zoomIn.touchend(t, e, i), a = this._zoomOut.touchend(t, e, i), o = this._tr;
                return s ? (this._active = !0, t.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (e)=>e.easeTo({
                            duration: 300,
                            zoom: o.zoom + 1,
                            around: o.unproject(s)
                        }, {
                            originalEvent: t
                        })
                }) : a ? (this._active = !0, t.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (e)=>e.easeTo({
                            duration: 300,
                            zoom: o.zoom - 1,
                            around: o.unproject(a)
                        }, {
                            originalEvent: t
                        })
                }) : void 0;
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Ps {
            constructor(t){
                this._enabled = !!t.enable, this._moveStateManager = t.moveStateManager, this._clickTolerance = t.clickTolerance || 1, this._moveFunction = t.move, this._activateOnStart = !!t.activateOnStart, t.assignEvents(this), this.reset();
            }
            reset(t) {
                this._active = !1, this._moved = !1, delete this._lastPoint, this._moveStateManager.endMove(t);
            }
            _move(...t) {
                const e = this._moveFunction(...t);
                if (e.bearingDelta || e.pitchDelta || e.around || e.panDelta) return this._active = !0, e;
            }
            dragStart(t, e) {
                this.isEnabled() && !this._lastPoint && this._moveStateManager.isValidStartEvent(t) && (this._moveStateManager.startMove(t), this._lastPoint = e.length ? e[0] : e, this._activateOnStart && this._lastPoint && (this._active = !0));
            }
            dragMove(t, e) {
                if (!this.isEnabled()) return;
                const i = this._lastPoint;
                if (!i) return;
                if (t.preventDefault(), !this._moveStateManager.isValidMoveEvent(t)) return void this.reset(t);
                const s = e.length ? e[0] : e;
                return !this._moved && s.dist(i) < this._clickTolerance ? void 0 : (this._moved = !0, this._lastPoint = s, this._move(i, s));
            }
            dragEnd(t) {
                this.isEnabled() && this._lastPoint && this._moveStateManager.isValidEndEvent(t) && (this._moved && i.suppressClick(), this.reset(t));
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            getClickTolerance() {
                return this._clickTolerance;
            }
        }
        const Ds = {
            0: 1,
            2: 2
        };
        class Ms {
            constructor(t){
                this._correctEvent = t.checkCorrectEvent;
            }
            startMove(t) {
                const e = i.mouseButton(t);
                this._eventButton = e;
            }
            endMove(t) {
                delete this._eventButton;
            }
            isValidStartEvent(t) {
                return this._correctEvent(t);
            }
            isValidMoveEvent(t) {
                return !function(t, e) {
                    const i = Ds[e];
                    return void 0 === t.buttons || (t.buttons & i) !== i;
                }(t, this._eventButton);
            }
            isValidEndEvent(t) {
                return i.mouseButton(t) === this._eventButton;
            }
        }
        class zs {
            constructor(){
                this._firstTouch = void 0;
            }
            _isOneFingerTouch(t) {
                return 1 === t.targetTouches.length;
            }
            _isSameTouchEvent(t) {
                return t.targetTouches[0].identifier === this._firstTouch;
            }
            startMove(t) {
                this._firstTouch = t.targetTouches[0].identifier;
            }
            endMove(t) {
                delete this._firstTouch;
            }
            isValidStartEvent(t) {
                return this._isOneFingerTouch(t);
            }
            isValidMoveEvent(t) {
                return this._isOneFingerTouch(t) && this._isSameTouchEvent(t);
            }
            isValidEndEvent(t) {
                return this._isOneFingerTouch(t) && this._isSameTouchEvent(t);
            }
        }
        const Ls = (t)=>{
            t.mousedown = t.dragStart, t.mousemoveWindow = t.dragMove, t.mouseup = t.dragEnd, t.contextmenu = function(t) {
                t.preventDefault();
            };
        }, As = ({ enable: t, clickTolerance: e, bearingDegreesPerPixelMoved: s = .8 })=>{
            const a = new Ms({
                checkCorrectEvent: (t)=>0 === i.mouseButton(t) && t.ctrlKey || 2 === i.mouseButton(t)
            });
            return new Ps({
                clickTolerance: e,
                move: (t, e)=>({
                        bearingDelta: (e.x - t.x) * s
                    }),
                moveStateManager: a,
                enable: t,
                assignEvents: Ls
            });
        }, Rs = ({ enable: t, clickTolerance: e, pitchDegreesPerPixelMoved: s = -0.5 })=>{
            const a = new Ms({
                checkCorrectEvent: (t)=>0 === i.mouseButton(t) && t.ctrlKey || 2 === i.mouseButton(t)
            });
            return new Ps({
                clickTolerance: e,
                move: (t, e)=>({
                        pitchDelta: (e.y - t.y) * s
                    }),
                moveStateManager: a,
                enable: t,
                assignEvents: Ls
            });
        };
        class ks {
            constructor(t, e){
                this._minTouches = t.cooperativeGestures ? 2 : 1, this._clickTolerance = t.clickTolerance || 1, this._map = e, this.reset();
            }
            reset() {
                this._active = !1, this._touches = {}, this._sum = new t.P(0, 0), setTimeout(()=>{
                    this._cancelCooperativeMessage = !1;
                }, 200);
            }
            touchstart(t, e, i) {
                return this._calculateTransform(t, e, i);
            }
            touchmove(t, e, i) {
                if (this._map._cooperativeGestures && (2 === this._minTouches && i.length < 2 && !this._cancelCooperativeMessage ? this._map._onCooperativeGesture(t, !1, i.length) : this._cancelCooperativeMessage || (this._cancelCooperativeMessage = !0)), this._active && !(i.length < this._minTouches)) return t.preventDefault(), this._calculateTransform(t, e, i);
            }
            touchend(t, e, i) {
                this._calculateTransform(t, e, i), this._active && i.length < this._minTouches && this.reset();
            }
            touchcancel() {
                this.reset();
            }
            _calculateTransform(e, i, s) {
                s.length > 0 && (this._active = !0);
                const a = Is(s, i), o = new t.P(0, 0), r = new t.P(0, 0);
                let n = 0;
                for(const t in a){
                    const e = a[t], i = this._touches[t];
                    i && (o._add(e), r._add(e.sub(i)), n++, a[t] = e);
                }
                if (this._touches = a, n < this._minTouches || !r.mag()) return;
                const l = r.div(n);
                return this._sum._add(l), this._sum.mag() < this._clickTolerance ? void 0 : {
                    around: o.div(n),
                    panDelta: l
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Fs {
            constructor(){
                this.reset();
            }
            reset() {
                this._active = !1, delete this._firstTwoTouches;
            }
            touchstart(t, e, i) {
                this._firstTwoTouches || i.length < 2 || (this._firstTwoTouches = [
                    i[0].identifier,
                    i[1].identifier
                ], this._start([
                    e[0],
                    e[1]
                ]));
            }
            touchmove(t, e, i) {
                if (!this._firstTwoTouches) return;
                t.preventDefault();
                const [s, a] = this._firstTwoTouches, o = Bs(i, e, s), r = Bs(i, e, a);
                if (!o || !r) return;
                const n = this._aroundCenter ? null : o.add(r).div(2);
                return this._move([
                    o,
                    r
                ], n, t);
            }
            touchend(t, e, s) {
                if (!this._firstTwoTouches) return;
                const [a, o] = this._firstTwoTouches, r = Bs(s, e, a), n = Bs(s, e, o);
                r && n || (this._active && i.suppressClick(), this.reset());
            }
            touchcancel() {
                this.reset();
            }
            enable(t) {
                this._enabled = !0, this._aroundCenter = !!t && "center" === t.around;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        function Bs(t, e, i) {
            for(let s = 0; s < t.length; s++)if (t[s].identifier === i) return e[s];
        }
        function Os(t, e) {
            return Math.log(t / e) / Math.LN2;
        }
        class Ns extends Fs {
            reset() {
                super.reset(), delete this._distance, delete this._startDistance;
            }
            _start(t) {
                this._startDistance = this._distance = t[0].dist(t[1]);
            }
            _move(t, e) {
                const i = this._distance;
                if (this._distance = t[0].dist(t[1]), this._active || !(Math.abs(Os(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                    zoomDelta: Os(this._distance, i),
                    pinchAround: e
                };
            }
        }
        function Us(t, e) {
            return 180 * t.angleWith(e) / Math.PI;
        }
        class Zs extends Fs {
            reset() {
                super.reset(), delete this._minDiameter, delete this._startVector, delete this._vector;
            }
            _start(t) {
                this._startVector = this._vector = t[0].sub(t[1]), this._minDiameter = t[0].dist(t[1]);
            }
            _move(t, e) {
                const i = this._vector;
                if (this._vector = t[0].sub(t[1]), this._active || !this._isBelowThreshold(this._vector)) return this._active = !0, {
                    bearingDelta: Us(this._vector, i),
                    pinchAround: e
                };
            }
            _isBelowThreshold(t) {
                this._minDiameter = Math.min(this._minDiameter, t.mag());
                const e = 25 / (Math.PI * this._minDiameter) * 360, i = Us(t, this._startVector);
                return Math.abs(i) < e;
            }
        }
        function Gs(t) {
            return Math.abs(t.y) > Math.abs(t.x);
        }
        class js extends Fs {
            constructor(t){
                super(), this._map = t;
            }
            reset() {
                super.reset(), this._valid = void 0, delete this._firstMove, delete this._lastPoints;
            }
            touchstart(t, e, i) {
                super.touchstart(t, e, i), this._currentTouchCount = i.length;
            }
            _start(t) {
                this._lastPoints = t, Gs(t[0].sub(t[1])) && (this._valid = !1);
            }
            _move(t, e, i) {
                if (this._map._cooperativeGestures && this._currentTouchCount < 3) return;
                const s = t[0].sub(this._lastPoints[0]), a = t[1].sub(this._lastPoints[1]);
                return this._valid = this.gestureBeginsVertically(s, a, i.timeStamp), this._valid ? (this._lastPoints = t, this._active = !0, {
                    pitchDelta: (s.y + a.y) / 2 * -0.5
                }) : void 0;
            }
            gestureBeginsVertically(t, e, i) {
                if (void 0 !== this._valid) return this._valid;
                const s = t.mag() >= 2, a = e.mag() >= 2;
                if (!s && !a) return;
                if (!s || !a) return void 0 === this._firstMove && (this._firstMove = i), i - this._firstMove < 100 && void 0;
                const o = t.y > 0 == e.y > 0;
                return Gs(t) && Gs(e) && o;
            }
        }
        const Vs = {
            panStep: 100,
            bearingStep: 15,
            pitchStep: 10
        };
        class qs {
            constructor(t){
                this._tr = new ws(t);
                const e = Vs;
                this._panStep = e.panStep, this._bearingStep = e.bearingStep, this._pitchStep = e.pitchStep, this._rotationDisabled = !1;
            }
            reset() {
                this._active = !1;
            }
            keydown(t) {
                if (t.altKey || t.ctrlKey || t.metaKey) return;
                let e = 0, i = 0, s = 0, a = 0, o = 0;
                switch(t.keyCode){
                    case 61:
                    case 107:
                    case 171:
                    case 187:
                        e = 1;
                        break;
                    case 189:
                    case 109:
                    case 173:
                        e = -1;
                        break;
                    case 37:
                        t.shiftKey ? i = -1 : (t.preventDefault(), a = -1);
                        break;
                    case 39:
                        t.shiftKey ? i = 1 : (t.preventDefault(), a = 1);
                        break;
                    case 38:
                        t.shiftKey ? s = 1 : (t.preventDefault(), o = -1);
                        break;
                    case 40:
                        t.shiftKey ? s = -1 : (t.preventDefault(), o = 1);
                        break;
                    default:
                        return;
                }
                return this._rotationDisabled && (i = 0, s = 0), {
                    cameraAnimation: (r)=>{
                        const n = this._tr;
                        r.easeTo({
                            duration: 300,
                            easeId: "keyboardHandler",
                            easing: $s,
                            zoom: e ? Math.round(n.zoom) + e * (t.shiftKey ? 2 : 1) : n.zoom,
                            bearing: n.bearing + i * this._bearingStep,
                            pitch: n.pitch + s * this._pitchStep,
                            offset: [
                                -a * this._panStep,
                                -o * this._panStep
                            ],
                            center: n.center
                        }, {
                            originalEvent: t
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            disableRotation() {
                this._rotationDisabled = !0;
            }
            enableRotation() {
                this._rotationDisabled = !1;
            }
        }
        function $s(t) {
            return t * (2 - t);
        }
        const Ws = 4.000244140625;
        class Hs {
            constructor(t, e){
                this._onTimeout = (t)=>{
                    this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(t);
                }, this._map = t, this._tr = new ws(t), this._el = t.getCanvasContainer(), this._triggerRenderFrame = e, this._delta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = .0022222222222222222;
            }
            setZoomRate(t) {
                this._defaultZoomRate = t;
            }
            setWheelZoomRate(t) {
                this._wheelZoomRate = t;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active || void 0 !== this._finishTimeout;
            }
            isZooming() {
                return !!this._zooming;
            }
            enable(t) {
                this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!t && "center" === t.around);
            }
            disable() {
                this.isEnabled() && (this._enabled = !1);
            }
            wheel(e) {
                if (!this.isEnabled()) return;
                if (this._map._cooperativeGestures) {
                    if (!e[this._map._metaKey]) return;
                    e.preventDefault();
                }
                let i = e.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * e.deltaY : e.deltaY;
                const s = t.h.now(), a = s - (this._lastWheelEventTime || 0);
                this._lastWheelEventTime = s, 0 !== i && i % Ws == 0 ? this._type = "wheel" : 0 !== i && Math.abs(i) < 4 ? this._type = "trackpad" : a > 400 ? (this._type = null, this._lastValue = i, this._timeout = setTimeout(this._onTimeout, 40, e)) : this._type || (this._type = Math.abs(a * i) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, i += this._lastValue)), e.shiftKey && i && (i /= 4), this._type && (this._lastWheelEvent = e, this._delta -= i, this._active || this._start(e)), e.preventDefault();
            }
            _start(e) {
                if (!this._delta) return;
                this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                const s = i.mousePos(this._el, e), a = this._tr;
                this._around = t.L.convert(this._aroundCenter ? a.center : a.unproject(s)), this._aroundPoint = a.transform.locationPoint(this._around), this._frameId || (this._frameId = !0, this._triggerRenderFrame());
            }
            renderFrame() {
                if (!this._frameId) return;
                if (this._frameId = null, !this.isActive()) return;
                const e = this._tr.transform;
                if (0 !== this._delta) {
                    const t = "wheel" === this._type && Math.abs(this._delta) > Ws ? this._wheelZoomRate : this._defaultZoomRate;
                    let i = 2 / (1 + Math.exp(-Math.abs(this._delta * t)));
                    this._delta < 0 && 0 !== i && (i = 1 / i);
                    const s = "number" == typeof this._targetZoom ? e.zoomScale(this._targetZoom) : e.scale;
                    this._targetZoom = Math.min(e.maxZoom, Math.max(e.minZoom, e.scaleZoom(s * i))), "wheel" === this._type && (this._startZoom = e.zoom, this._easing = this._smoothOutEasing(200)), this._delta = 0;
                }
                const i = "number" == typeof this._targetZoom ? this._targetZoom : e.zoom, s = this._startZoom, a = this._easing;
                let o, r = !1;
                if ("wheel" === this._type && s && a) {
                    const e = Math.min((t.h.now() - this._lastWheelEventTime) / 200, 1), n = a(e);
                    o = t.B.number(s, i, n), e < 1 ? this._frameId || (this._frameId = !0) : r = !0;
                } else o = i, r = !0;
                return this._active = !0, r && (this._active = !1, this._finishTimeout = setTimeout(()=>{
                    this._zooming = !1, this._triggerRenderFrame(), delete this._targetZoom, delete this._finishTimeout;
                }, 200)), {
                    noInertia: !0,
                    needsRenderFrame: !r,
                    zoomDelta: o - e.zoom,
                    around: this._aroundPoint,
                    originalEvent: this._lastWheelEvent
                };
            }
            _smoothOutEasing(e) {
                let i = t.bb;
                if (this._prevEase) {
                    const e = this._prevEase, s = (t.h.now() - e.start) / e.duration, a = e.easing(s + .01) - e.easing(s), o = .27 / Math.sqrt(a * a + 1e-4) * .01, r = Math.sqrt(.0729 - o * o);
                    i = t.ba(o, r, .25, 1);
                }
                return this._prevEase = {
                    start: t.h.now(),
                    duration: e,
                    easing: i
                }, i;
            }
            reset() {
                this._active = !1, this._zooming = !1, delete this._targetZoom, this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
            }
        }
        class Xs {
            constructor(t, e){
                this._clickZoom = t, this._tapZoom = e;
            }
            enable() {
                this._clickZoom.enable(), this._tapZoom.enable();
            }
            disable() {
                this._clickZoom.disable(), this._tapZoom.disable();
            }
            isEnabled() {
                return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
            }
            isActive() {
                return this._clickZoom.isActive() || this._tapZoom.isActive();
            }
        }
        class Ks {
            constructor(t){
                this._tr = new ws(t), this.reset();
            }
            reset() {
                this._active = !1;
            }
            dblclick(t, e) {
                return t.preventDefault(), {
                    cameraAnimation: (i)=>{
                        i.easeTo({
                            duration: 300,
                            zoom: this._tr.zoom + (t.shiftKey ? -1 : 1),
                            around: this._tr.unproject(e)
                        }, {
                            originalEvent: t
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Qs {
            constructor(){
                this._tap = new Ss({
                    numTouches: 1,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, delete this._swipePoint, delete this._swipeTouch, delete this._tapTime, delete this._tapPoint, this._tap.reset();
            }
            touchstart(t, e, i) {
                if (!this._swipePoint) {
                    if (this._tapTime) {
                        const s = e[0], a = t.timeStamp - this._tapTime < 500, o = this._tapPoint.dist(s) < 30;
                        a && o ? i.length > 0 && (this._swipePoint = s, this._swipeTouch = i[0].identifier) : this.reset();
                    } else this._tap.touchstart(t, e, i);
                }
            }
            touchmove(t, e, i) {
                if (this._tapTime) {
                    if (this._swipePoint) {
                        if (i[0].identifier !== this._swipeTouch) return;
                        const s = e[0], a = s.y - this._swipePoint.y;
                        return this._swipePoint = s, t.preventDefault(), this._active = !0, {
                            zoomDelta: a / 128
                        };
                    }
                } else this._tap.touchmove(t, e, i);
            }
            touchend(t, e, i) {
                if (this._tapTime) this._swipePoint && 0 === i.length && this.reset();
                else {
                    const s = this._tap.touchend(t, e, i);
                    s && (this._tapTime = t.timeStamp, this._tapPoint = s);
                }
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Ys {
            constructor(t, e, i){
                this._el = t, this._mousePan = e, this._touchPan = i;
            }
            enable(t) {
                this._inertiaOptions = t || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("maplibregl-touch-drag-pan");
            }
            disable() {
                this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("maplibregl-touch-drag-pan");
            }
            isEnabled() {
                return this._mousePan.isEnabled() && this._touchPan.isEnabled();
            }
            isActive() {
                return this._mousePan.isActive() || this._touchPan.isActive();
            }
        }
        class Js {
            constructor(t, e, i){
                this._pitchWithRotate = t.pitchWithRotate, this._mouseRotate = e, this._mousePitch = i;
            }
            enable() {
                this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
            }
            disable() {
                this._mouseRotate.disable(), this._mousePitch.disable();
            }
            isEnabled() {
                return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
            }
            isActive() {
                return this._mouseRotate.isActive() || this._mousePitch.isActive();
            }
        }
        class ta {
            constructor(t, e, i, s){
                this._el = t, this._touchZoom = e, this._touchRotate = i, this._tapDragZoom = s, this._rotationDisabled = !1, this._enabled = !0;
            }
            enable(t) {
                this._touchZoom.enable(t), this._rotationDisabled || this._touchRotate.enable(t), this._tapDragZoom.enable(), this._el.classList.add("maplibregl-touch-zoom-rotate");
            }
            disable() {
                this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("maplibregl-touch-zoom-rotate");
            }
            isEnabled() {
                return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
            }
            isActive() {
                return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
            }
            disableRotation() {
                this._rotationDisabled = !0, this._touchRotate.disable();
            }
            enableRotation() {
                this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
            }
        }
        const ea = (t)=>t.zoom || t.drag || t.pitch || t.rotate;
        class ia extends t.k {
        }
        function sa(t) {
            return t.panDelta && t.panDelta.mag() || t.zoomDelta || t.bearingDelta || t.pitchDelta;
        }
        class aa {
            constructor(t, e){
                this.handleWindowEvent = (t)=>{
                    this.handleEvent(t, `${t.type}Window`);
                }, this.handleEvent = (t, e)=>{
                    if ("blur" === t.type) return void this.stop(!0);
                    this._updatingCamera = !0;
                    const s = "renderFrame" === t.type ? void 0 : t, a = {
                        needsRenderFrame: !1
                    }, o = {}, r = {}, n = t.touches, l = n ? this._getMapTouches(n) : void 0, h = l ? i.touchPos(this._el, l) : i.mousePos(this._el, t);
                    for (const { handlerName: i, handler: n, allowed: c } of this._handlers){
                        if (!n.isEnabled()) continue;
                        let u;
                        this._blockedByActive(r, c, i) ? n.reset() : n[e || t.type] && (u = n[e || t.type](t, h, l), this.mergeHandlerResult(a, o, u, i, s), u && u.needsRenderFrame && this._triggerRenderFrame()), (u || n.isActive()) && (r[i] = n);
                    }
                    const c = {};
                    for(const t in this._previousActiveHandlers)r[t] || (c[t] = s);
                    this._previousActiveHandlers = r, (Object.keys(c).length || sa(a)) && (this._changes.push([
                        a,
                        o,
                        c
                    ]), this._triggerRenderFrame()), (Object.keys(r).length || sa(a)) && this._map._stop(!0), this._updatingCamera = !1;
                    const { cameraAnimation: u } = a;
                    u && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], u(this._map));
                }, this._map = t, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new ps(t), this._bearingSnap = e.bearingSnap, this._previousActiveHandlers = {}, this._eventsInProgress = {}, this._addDefaultHandlers(e);
                const s = this._el;
                this._listeners = [
                    [
                        s,
                        "touchstart",
                        {
                            passive: !0
                        }
                    ],
                    [
                        s,
                        "touchmove",
                        {
                            passive: !1
                        }
                    ],
                    [
                        s,
                        "touchend",
                        void 0
                    ],
                    [
                        s,
                        "touchcancel",
                        void 0
                    ],
                    [
                        s,
                        "mousedown",
                        void 0
                    ],
                    [
                        s,
                        "mousemove",
                        void 0
                    ],
                    [
                        s,
                        "mouseup",
                        void 0
                    ],
                    [
                        document,
                        "mousemove",
                        {
                            capture: !0
                        }
                    ],
                    [
                        document,
                        "mouseup",
                        void 0
                    ],
                    [
                        s,
                        "mouseover",
                        void 0
                    ],
                    [
                        s,
                        "mouseout",
                        void 0
                    ],
                    [
                        s,
                        "dblclick",
                        void 0
                    ],
                    [
                        s,
                        "click",
                        void 0
                    ],
                    [
                        s,
                        "keydown",
                        {
                            capture: !1
                        }
                    ],
                    [
                        s,
                        "keyup",
                        void 0
                    ],
                    [
                        s,
                        "wheel",
                        {
                            passive: !1
                        }
                    ],
                    [
                        s,
                        "contextmenu",
                        void 0
                    ],
                    [
                        window,
                        "blur",
                        void 0
                    ]
                ];
                for (const [t, e, s] of this._listeners)i.addEventListener(t, e, t === document ? this.handleWindowEvent : this.handleEvent, s);
            }
            destroy() {
                for (const [t, e, s] of this._listeners)i.removeEventListener(t, e, t === document ? this.handleWindowEvent : this.handleEvent, s);
            }
            _addDefaultHandlers(t) {
                const e = this._map, s = e.getCanvasContainer();
                this._add("mapEvent", new ys(e, t));
                const a = e.boxZoom = new Ts(e, t);
                this._add("boxZoom", a), t.interactive && t.boxZoom && a.enable();
                const o = new Cs(e), r = new Ks(e);
                e.doubleClickZoom = new Xs(r, o), this._add("tapZoom", o), this._add("clickZoom", r), t.interactive && t.doubleClickZoom && e.doubleClickZoom.enable();
                const n = new Qs;
                this._add("tapDragZoom", n);
                const l = e.touchPitch = new js(e);
                this._add("touchPitch", l), t.interactive && t.touchPitch && e.touchPitch.enable(t.touchPitch);
                const h = As(t), c = Rs(t);
                e.dragRotate = new Js(t, h, c), this._add("mouseRotate", h, [
                    "mousePitch"
                ]), this._add("mousePitch", c, [
                    "mouseRotate"
                ]), t.interactive && t.dragRotate && e.dragRotate.enable();
                const u = (({ enable: t, clickTolerance: e })=>{
                    const s = new Ms({
                        checkCorrectEvent: (t)=>0 === i.mouseButton(t) && !t.ctrlKey
                    });
                    return new Ps({
                        clickTolerance: e,
                        move: (t, e)=>({
                                around: e,
                                panDelta: e.sub(t)
                            }),
                        activateOnStart: !0,
                        moveStateManager: s,
                        enable: t,
                        assignEvents: Ls
                    });
                })(t), d = new ks(t, e);
                e.dragPan = new Ys(s, u, d), this._add("mousePan", u), this._add("touchPan", d, [
                    "touchZoom",
                    "touchRotate"
                ]), t.interactive && t.dragPan && e.dragPan.enable(t.dragPan);
                const _ = new Zs, p = new Ns;
                e.touchZoomRotate = new ta(s, p, _, n), this._add("touchRotate", _, [
                    "touchPan",
                    "touchZoom"
                ]), this._add("touchZoom", p, [
                    "touchPan",
                    "touchRotate"
                ]), t.interactive && t.touchZoomRotate && e.touchZoomRotate.enable(t.touchZoomRotate);
                const m = e.scrollZoom = new Hs(e, ()=>this._triggerRenderFrame());
                this._add("scrollZoom", m, [
                    "mousePan"
                ]), t.interactive && t.scrollZoom && e.scrollZoom.enable(t.scrollZoom);
                const f = e.keyboard = new qs(e);
                this._add("keyboard", f), t.interactive && t.keyboard && e.keyboard.enable(), this._add("blockableMapEvent", new bs(e));
            }
            _add(t, e, i) {
                this._handlers.push({
                    handlerName: t,
                    handler: e,
                    allowed: i
                }), this._handlersById[t] = e;
            }
            stop(t) {
                if (!this._updatingCamera) {
                    for (const { handler: t } of this._handlers)t.reset();
                    this._inertia.clear(), this._fireEvents({}, {}, t), this._changes = [];
                }
            }
            isActive() {
                for (const { handler: t } of this._handlers)if (t.isActive()) return !0;
                return !1;
            }
            isZooming() {
                return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
            }
            isRotating() {
                return !!this._eventsInProgress.rotate;
            }
            isMoving() {
                return Boolean(ea(this._eventsInProgress)) || this.isZooming();
            }
            _blockedByActive(t, e, i) {
                for(const s in t)if (s !== i && (!e || e.indexOf(s) < 0)) return !0;
                return !1;
            }
            _getMapTouches(t) {
                const e = [];
                for (const i of t)this._el.contains(i.target) && e.push(i);
                return e;
            }
            mergeHandlerResult(e, i, s, a, o) {
                if (!s) return;
                t.e(e, s);
                const r = {
                    handlerName: a,
                    originalEvent: s.originalEvent || o
                };
                void 0 !== s.zoomDelta && (i.zoom = r), void 0 !== s.panDelta && (i.drag = r), void 0 !== s.pitchDelta && (i.pitch = r), void 0 !== s.bearingDelta && (i.rotate = r);
            }
            _applyChanges() {
                const e = {}, i = {}, s = {};
                for (const [a, o, r] of this._changes)a.panDelta && (e.panDelta = (e.panDelta || new t.P(0, 0))._add(a.panDelta)), a.zoomDelta && (e.zoomDelta = (e.zoomDelta || 0) + a.zoomDelta), a.bearingDelta && (e.bearingDelta = (e.bearingDelta || 0) + a.bearingDelta), a.pitchDelta && (e.pitchDelta = (e.pitchDelta || 0) + a.pitchDelta), void 0 !== a.around && (e.around = a.around), void 0 !== a.pinchAround && (e.pinchAround = a.pinchAround), a.noInertia && (e.noInertia = a.noInertia), t.e(i, o), t.e(s, r);
                this._updateMapTransform(e, i, s), this._changes = [];
            }
            _updateMapTransform(t, e, i) {
                const s = this._map, a = s._getTransformForUpdate(), o = s.terrain;
                if (!(sa(t) || o && this._terrainMovement)) return this._fireEvents(e, i, !0);
                let { panDelta: r, zoomDelta: n, bearingDelta: l, pitchDelta: h, around: c, pinchAround: u } = t;
                void 0 !== u && (c = u), s._stop(!0), c = c || s.transform.centerPoint;
                const d = a.pointLocation(r ? c.sub(r) : c);
                l && (a.bearing += l), h && (a.pitch += h), n && (a.zoom += n), o ? this._terrainMovement || !e.drag && !e.zoom ? e.drag && this._terrainMovement ? a.center = a.pointLocation(a.centerPoint.sub(r)) : a.setLocationAtPoint(d, c) : (this._terrainMovement = !0, this._map._elevationFreeze = !0, a.setLocationAtPoint(d, c), this._map.once("moveend", ()=>{
                    this._map._elevationFreeze = !1, this._terrainMovement = !1, a.recalculateZoom(s.terrain);
                })) : a.setLocationAtPoint(d, c), s._applyUpdatedTransform(a), this._map._update(), t.noInertia || this._inertia.record(t), this._fireEvents(e, i, !0);
            }
            _fireEvents(e, i, s) {
                const a = ea(this._eventsInProgress), o = ea(e), r = {};
                for(const t in e){
                    const { originalEvent: i } = e[t];
                    this._eventsInProgress[t] || (r[`${t}start`] = i), this._eventsInProgress[t] = e[t];
                }
                !a && o && this._fireEvent("movestart", o.originalEvent);
                for(const t in r)this._fireEvent(t, r[t]);
                o && this._fireEvent("move", o.originalEvent);
                for(const t in e){
                    const { originalEvent: i } = e[t];
                    this._fireEvent(t, i);
                }
                const n = {};
                let l;
                for(const t in this._eventsInProgress){
                    const { handlerName: e, originalEvent: s } = this._eventsInProgress[t];
                    this._handlersById[e].isActive() || (delete this._eventsInProgress[t], l = i[e] || s, n[`${t}end`] = l);
                }
                for(const t in n)this._fireEvent(t, n[t]);
                const h = ea(this._eventsInProgress);
                if (s && (a || o) && !h) {
                    this._updatingCamera = !0;
                    const e = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), i = (t)=>0 !== t && -this._bearingSnap < t && t < this._bearingSnap;
                    !e || !e.essential && t.h.prefersReducedMotion ? (this._map.fire(new t.k("moveend", {
                        originalEvent: l
                    })), i(this._map.getBearing()) && this._map.resetNorth()) : (i(e.bearing || this._map.getBearing()) && (e.bearing = 0), e.freezeElevation = !0, this._map.easeTo(e, {
                        originalEvent: l
                    })), this._updatingCamera = !1;
                }
            }
            _fireEvent(e, i) {
                this._map.fire(new t.k(e, i ? {
                    originalEvent: i
                } : {}));
            }
            _requestFrame() {
                return this._map.triggerRepaint(), this._map._renderTaskQueue.add((t)=>{
                    delete this._frameId, this.handleEvent(new ia("renderFrame", {
                        timeStamp: t
                    })), this._applyChanges();
                });
            }
            _triggerRenderFrame() {
                void 0 === this._frameId && (this._frameId = this._requestFrame());
            }
        }
        class oa extends t.E {
            constructor(e, i){
                super(), this._renderFrameCallback = ()=>{
                    const e = Math.min((t.h.now() - this._easeStart) / this._easeOptions.duration, 1);
                    this._onEaseFrame(this._easeOptions.easing(e)), e < 1 && this._easeFrameId ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
                }, this._moving = !1, this._zooming = !1, this.transform = e, this._bearingSnap = i.bearingSnap, this.on("moveend", ()=>{
                    delete this._requestedCameraState;
                });
            }
            getCenter() {
                return new t.L(this.transform.center.lng, this.transform.center.lat);
            }
            setCenter(t, e) {
                return this.jumpTo({
                    center: t
                }, e);
            }
            panBy(e, i, s) {
                return e = t.P.convert(e).mult(-1), this.panTo(this.transform.center, t.e({
                    offset: e
                }, i), s);
            }
            panTo(e, i, s) {
                return this.easeTo(t.e({
                    center: e
                }, i), s);
            }
            getZoom() {
                return this.transform.zoom;
            }
            setZoom(t, e) {
                return this.jumpTo({
                    zoom: t
                }, e), this;
            }
            zoomTo(e, i, s) {
                return this.easeTo(t.e({
                    zoom: e
                }, i), s);
            }
            zoomIn(t, e) {
                return this.zoomTo(this.getZoom() + 1, t, e), this;
            }
            zoomOut(t, e) {
                return this.zoomTo(this.getZoom() - 1, t, e), this;
            }
            getBearing() {
                return this.transform.bearing;
            }
            setBearing(t, e) {
                return this.jumpTo({
                    bearing: t
                }, e), this;
            }
            getPadding() {
                return this.transform.padding;
            }
            setPadding(t, e) {
                return this.jumpTo({
                    padding: t
                }, e), this;
            }
            rotateTo(e, i, s) {
                return this.easeTo(t.e({
                    bearing: e
                }, i), s);
            }
            resetNorth(e, i) {
                return this.rotateTo(0, t.e({
                    duration: 1e3
                }, e), i), this;
            }
            resetNorthPitch(e, i) {
                return this.easeTo(t.e({
                    bearing: 0,
                    pitch: 0,
                    duration: 1e3
                }, e), i), this;
            }
            snapToNorth(t, e) {
                return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(t, e) : this;
            }
            getPitch() {
                return this.transform.pitch;
            }
            setPitch(t, e) {
                return this.jumpTo({
                    pitch: t
                }, e), this;
            }
            cameraForBounds(t, e) {
                t = L.convert(t);
                const i = e && e.bearing || 0;
                return this._cameraForBoxAndBearing(t.getNorthWest(), t.getSouthEast(), i, e);
            }
            _cameraForBoxAndBearing(e, i, s, a) {
                const o = {
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0
                };
                if ("number" == typeof (a = t.e({
                    padding: o,
                    offset: [
                        0,
                        0
                    ],
                    maxZoom: this.transform.maxZoom
                }, a)).padding) {
                    const t = a.padding;
                    a.padding = {
                        top: t,
                        bottom: t,
                        right: t,
                        left: t
                    };
                }
                a.padding = t.e(o, a.padding);
                const r = this.transform, n = r.padding, l = r.project(t.L.convert(e)), h = r.project(t.L.convert(i)), c = l.rotate(-s * Math.PI / 180), u = h.rotate(-s * Math.PI / 180), d = new t.P(Math.max(c.x, u.x), Math.max(c.y, u.y)), _ = new t.P(Math.min(c.x, u.x), Math.min(c.y, u.y)), p = d.sub(_), m = (r.width - (n.left + n.right + a.padding.left + a.padding.right)) / p.x, f = (r.height - (n.top + n.bottom + a.padding.top + a.padding.bottom)) / p.y;
                if (f < 0 || m < 0) return void t.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                const g = Math.min(r.scaleZoom(r.scale * Math.min(m, f)), a.maxZoom), v = t.P.convert(a.offset), x = new t.P((a.padding.left - a.padding.right) / 2, (a.padding.top - a.padding.bottom) / 2).rotate(s * Math.PI / 180), y = v.add(x).mult(r.scale / r.zoomScale(g));
                return {
                    center: r.unproject(l.add(h).div(2).sub(y)),
                    zoom: g,
                    bearing: s
                };
            }
            fitBounds(t, e, i) {
                return this._fitInternal(this.cameraForBounds(t, e), e, i);
            }
            fitScreenCoordinates(e, i, s, a, o) {
                return this._fitInternal(this._cameraForBoxAndBearing(this.transform.pointLocation(t.P.convert(e)), this.transform.pointLocation(t.P.convert(i)), s, a), a, o);
            }
            _fitInternal(e, i, s) {
                return e ? (delete (i = t.e(e, i)).padding, i.linear ? this.easeTo(i, s) : this.flyTo(i, s)) : this;
            }
            jumpTo(e, i) {
                this.stop();
                const s = this._getTransformForUpdate();
                let a = !1, o = !1, r = !1;
                return "zoom" in e && s.zoom !== +e.zoom && (a = !0, s.zoom = +e.zoom), void 0 !== e.center && (s.center = t.L.convert(e.center)), "bearing" in e && s.bearing !== +e.bearing && (o = !0, s.bearing = +e.bearing), "pitch" in e && s.pitch !== +e.pitch && (r = !0, s.pitch = +e.pitch), null == e.padding || s.isPaddingEqual(e.padding) || (s.padding = e.padding), this._applyUpdatedTransform(s), this.fire(new t.k("movestart", i)).fire(new t.k("move", i)), a && this.fire(new t.k("zoomstart", i)).fire(new t.k("zoom", i)).fire(new t.k("zoomend", i)), o && this.fire(new t.k("rotatestart", i)).fire(new t.k("rotate", i)).fire(new t.k("rotateend", i)), r && this.fire(new t.k("pitchstart", i)).fire(new t.k("pitch", i)).fire(new t.k("pitchend", i)), this.fire(new t.k("moveend", i));
            }
            calculateCameraOptionsFromTo(e, i, s, a = 0) {
                const o = t.U.fromLngLat(e, i), r = t.U.fromLngLat(s, a), n = r.x - o.x, l = r.y - o.y, h = r.z - o.z, c = Math.hypot(n, l, h);
                if (0 === c) throw new Error("Can't calculate camera options with same From and To");
                const u = Math.hypot(n, l), d = this.transform.scaleZoom(this.transform.cameraToCenterDistance / c / this.transform.tileSize), _ = 180 * Math.atan2(n, -l) / Math.PI;
                let p = 180 * Math.acos(u / c) / Math.PI;
                return p = h < 0 ? 90 - p : 90 + p, {
                    center: r.toLngLat(),
                    zoom: d,
                    pitch: p,
                    bearing: _
                };
            }
            easeTo(e, i) {
                this._stop(!1, e.easeId), (!1 === (e = t.e({
                    offset: [
                        0,
                        0
                    ],
                    duration: 500,
                    easing: t.bb
                }, e)).animate || !e.essential && t.h.prefersReducedMotion) && (e.duration = 0);
                const s = this._getTransformForUpdate(), a = this.getZoom(), o = this.getBearing(), r = this.getPitch(), n = this.getPadding(), l = "zoom" in e ? +e.zoom : a, h = "bearing" in e ? this._normalizeBearing(e.bearing, o) : o, c = "pitch" in e ? +e.pitch : r, u = "padding" in e ? e.padding : s.padding, d = t.P.convert(e.offset);
                let _ = s.centerPoint.add(d);
                const p = s.pointLocation(_), m = t.L.convert(e.center || p);
                this._normalizeCenter(m);
                const f = s.project(p), g = s.project(m).sub(f), v = s.zoomScale(l - a);
                let x, y;
                e.around && (x = t.L.convert(e.around), y = s.locationPoint(x));
                const b = {
                    moving: this._moving,
                    zooming: this._zooming,
                    rotating: this._rotating,
                    pitching: this._pitching
                };
                return this._zooming = this._zooming || l !== a, this._rotating = this._rotating || o !== h, this._pitching = this._pitching || c !== r, this._padding = !s.isPaddingEqual(u), this._easeId = e.easeId, this._prepareEase(i, e.noMoveStart, b), this.terrain && this._prepareElevation(m), this._ease((p)=>{
                    if (this._zooming && (s.zoom = t.B.number(a, l, p)), this._rotating && (s.bearing = t.B.number(o, h, p)), this._pitching && (s.pitch = t.B.number(r, c, p)), this._padding && (s.interpolatePadding(n, u, p), _ = s.centerPoint.add(d)), this.terrain && !e.freezeElevation && this._updateElevation(p), x) s.setLocationAtPoint(x, y);
                    else {
                        const t = s.zoomScale(s.zoom - a), e = l > a ? Math.min(2, v) : Math.max(.5, v), i = Math.pow(e, 1 - p), o = s.unproject(f.add(g.mult(p * i)).mult(t));
                        s.setLocationAtPoint(s.renderWorldCopies ? o.wrap() : o, _);
                    }
                    this._applyUpdatedTransform(s), this._fireMoveEvents(i);
                }, (t)=>{
                    this.terrain && this._finalizeElevation(), this._afterEase(i, t);
                }, e), this;
            }
            _prepareEase(e, i, s = {}) {
                this._moving = !0, i || s.moving || this.fire(new t.k("movestart", e)), this._zooming && !s.zooming && this.fire(new t.k("zoomstart", e)), this._rotating && !s.rotating && this.fire(new t.k("rotatestart", e)), this._pitching && !s.pitching && this.fire(new t.k("pitchstart", e));
            }
            _prepareElevation(t) {
                this._elevationCenter = t, this._elevationStart = this.transform.elevation, this._elevationTarget = this.terrain.getElevationForLngLatZoom(t, this.transform.tileZoom), this._elevationFreeze = !0;
            }
            _updateElevation(e) {
                this.transform._minEleveationForCurrentTile = this.terrain.getMinTileElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom);
                const i = this.terrain.getElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom);
                if (e < 1 && i !== this._elevationTarget) {
                    const t = this._elevationTarget - this._elevationStart;
                    this._elevationStart += e * (t - (i - (t * e + this._elevationStart)) / (1 - e)), this._elevationTarget = i;
                }
                this.transform.elevation = t.B.number(this._elevationStart, this._elevationTarget, e);
            }
            _finalizeElevation() {
                this._elevationFreeze = !1, this.transform.recalculateZoom(this.terrain);
            }
            _getTransformForUpdate() {
                return this.transformCameraUpdate ? (this._requestedCameraState || (this._requestedCameraState = this.transform.clone()), this._requestedCameraState) : this.transform;
            }
            _applyUpdatedTransform(t) {
                if (!this.transformCameraUpdate) return;
                const e = t.clone(), { center: i, zoom: s, pitch: a, bearing: o, elevation: r } = this.transformCameraUpdate(e);
                i && (e.center = i), void 0 !== s && (e.zoom = s), void 0 !== a && (e.pitch = a), void 0 !== o && (e.bearing = o), void 0 !== r && (e.elevation = r), this.transform.apply(e);
            }
            _fireMoveEvents(e) {
                this.fire(new t.k("move", e)), this._zooming && this.fire(new t.k("zoom", e)), this._rotating && this.fire(new t.k("rotate", e)), this._pitching && this.fire(new t.k("pitch", e));
            }
            _afterEase(e, i) {
                if (this._easeId && i && this._easeId === i) return;
                delete this._easeId;
                const s = this._zooming, a = this._rotating, o = this._pitching;
                this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._padding = !1, s && this.fire(new t.k("zoomend", e)), a && this.fire(new t.k("rotateend", e)), o && this.fire(new t.k("pitchend", e)), this.fire(new t.k("moveend", e));
            }
            flyTo(e, i) {
                if (!e.essential && t.h.prefersReducedMotion) {
                    const s = t.F(e, [
                        "center",
                        "zoom",
                        "bearing",
                        "pitch",
                        "around"
                    ]);
                    return this.jumpTo(s, i);
                }
                this.stop(), e = t.e({
                    offset: [
                        0,
                        0
                    ],
                    speed: 1.2,
                    curve: 1.42,
                    easing: t.bb
                }, e);
                const s = this._getTransformForUpdate(), a = this.getZoom(), o = this.getBearing(), r = this.getPitch(), n = this.getPadding(), l = "zoom" in e ? t.ad(+e.zoom, s.minZoom, s.maxZoom) : a, h = "bearing" in e ? this._normalizeBearing(e.bearing, o) : o, c = "pitch" in e ? +e.pitch : r, u = "padding" in e ? e.padding : s.padding, d = s.zoomScale(l - a), _ = t.P.convert(e.offset);
                let p = s.centerPoint.add(_);
                const m = s.pointLocation(p), f = t.L.convert(e.center || m);
                this._normalizeCenter(f);
                const g = s.project(m), v = s.project(f).sub(g);
                let x = e.curve;
                const y = Math.max(s.width, s.height), b = y / d, w = v.mag();
                if ("minZoom" in e) {
                    const i = t.ad(Math.min(e.minZoom, a, l), s.minZoom, s.maxZoom), o = y / s.zoomScale(i - a);
                    x = Math.sqrt(o / w * 2);
                }
                const T = x * x;
                function I(t) {
                    const e = (b * b - y * y + (t ? -1 : 1) * T * T * w * w) / (2 * (t ? b : y) * T * w);
                    return Math.log(Math.sqrt(e * e + 1) - e);
                }
                function E(t) {
                    return (Math.exp(t) - Math.exp(-t)) / 2;
                }
                function S(t) {
                    return (Math.exp(t) + Math.exp(-t)) / 2;
                }
                const C = I(!1);
                let P = function(t) {
                    return S(C) / S(C + x * t);
                }, D = function(t) {
                    var e;
                    return y * ((S(C) * (E(e = C + x * t) / S(e)) - E(C)) / T) / w;
                }, M = (I(!0) - C) / x;
                if (Math.abs(w) < 1e-6 || !isFinite(M)) {
                    if (Math.abs(y - b) < 1e-6) return this.easeTo(e, i);
                    const t = b < y ? -1 : 1;
                    M = Math.abs(Math.log(b / y)) / x, D = function() {
                        return 0;
                    }, P = function(e) {
                        return Math.exp(t * x * e);
                    };
                }
                return e.duration = "duration" in e ? +e.duration : 1e3 * M / ("screenSpeed" in e ? +e.screenSpeed / x : +e.speed), e.maxDuration && e.duration > e.maxDuration && (e.duration = 0), this._zooming = !0, this._rotating = o !== h, this._pitching = c !== r, this._padding = !s.isPaddingEqual(u), this._prepareEase(i, !1), this.terrain && this._prepareElevation(f), this._ease((d)=>{
                    const m = d * M, x = 1 / P(m);
                    s.zoom = 1 === d ? l : a + s.scaleZoom(x), this._rotating && (s.bearing = t.B.number(o, h, d)), this._pitching && (s.pitch = t.B.number(r, c, d)), this._padding && (s.interpolatePadding(n, u, d), p = s.centerPoint.add(_)), this.terrain && !e.freezeElevation && this._updateElevation(d);
                    const y = 1 === d ? f : s.unproject(g.add(v.mult(D(m))).mult(x));
                    s.setLocationAtPoint(s.renderWorldCopies ? y.wrap() : y, p), this._applyUpdatedTransform(s), this._fireMoveEvents(i);
                }, ()=>{
                    this.terrain && this._finalizeElevation(), this._afterEase(i);
                }, e), this;
            }
            isEasing() {
                return !!this._easeFrameId;
            }
            stop() {
                return this._stop();
            }
            _stop(t, e) {
                if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), delete this._easeFrameId, delete this._onEaseFrame), this._onEaseEnd) {
                    const t = this._onEaseEnd;
                    delete this._onEaseEnd, t.call(this, e);
                }
                if (!t) {
                    const t = this.handlers;
                    t && t.stop(!1);
                }
                return this;
            }
            _ease(e, i, s) {
                !1 === s.animate || 0 === s.duration ? (e(1), i()) : (this._easeStart = t.h.now(), this._easeOptions = s, this._onEaseFrame = e, this._onEaseEnd = i, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
            }
            _normalizeBearing(e, i) {
                e = t.b5(e, -180, 180);
                const s = Math.abs(e - i);
                return Math.abs(e - 360 - i) < s && (e -= 360), Math.abs(e + 360 - i) < s && (e += 360), e;
            }
            _normalizeCenter(t) {
                const e = this.transform;
                if (!e.renderWorldCopies || e.lngRange) return;
                const i = t.lng - e.center.lng;
                t.lng += i > 180 ? -360 : i < -180 ? 360 : 0;
            }
            queryTerrainElevation(e) {
                return this.terrain ? this.terrain.getElevationForLngLatZoom(t.L.convert(e), this.transform.tileZoom) - this.transform.elevation : null;
            }
        }
        class ra {
            constructor(t = {}){
                this._toggleAttribution = ()=>{
                    this._container.classList.contains("maplibregl-compact") && (this._container.classList.contains("maplibregl-compact-show") ? (this._container.setAttribute("open", ""), this._container.classList.remove("maplibregl-compact-show")) : (this._container.classList.add("maplibregl-compact-show"), this._container.removeAttribute("open")));
                }, this._updateData = (t)=>{
                    !t || "metadata" !== t.sourceDataType && "visibility" !== t.sourceDataType && "style" !== t.dataType && "terrain" !== t.type || this._updateAttributions();
                }, this._updateCompact = ()=>{
                    this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? !1 === this._compact ? this._container.setAttribute("open", "") : this._container.classList.contains("maplibregl-compact") || this._container.classList.contains("maplibregl-attrib-empty") || (this._container.setAttribute("open", ""), this._container.classList.add("maplibregl-compact", "maplibregl-compact-show")) : (this._container.setAttribute("open", ""), this._container.classList.contains("maplibregl-compact") && this._container.classList.remove("maplibregl-compact", "maplibregl-compact-show"));
                }, this._updateCompactMinimize = ()=>{
                    this._container.classList.contains("maplibregl-compact") && this._container.classList.contains("maplibregl-compact-show") && this._container.classList.remove("maplibregl-compact-show");
                }, this.options = t;
            }
            getDefaultPosition() {
                return "bottom-right";
            }
            onAdd(t) {
                return this._map = t, this._compact = this.options && this.options.compact, this._container = i.create("details", "maplibregl-ctrl maplibregl-ctrl-attrib"), this._compactButton = i.create("summary", "maplibregl-ctrl-attrib-button", this._container), this._compactButton.addEventListener("click", this._toggleAttribution), this._setElementTitle(this._compactButton, "ToggleAttribution"), this._innerContainer = i.create("div", "maplibregl-ctrl-attrib-inner", this._container), this._updateAttributions(), this._updateCompact(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("terrain", this._updateData), this._map.on("resize", this._updateCompact), this._map.on("drag", this._updateCompactMinimize), this._container;
            }
            onRemove() {
                i.remove(this._container), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("terrain", this._updateData), this._map.off("resize", this._updateCompact), this._map.off("drag", this._updateCompactMinimize), this._map = void 0, this._compact = void 0, this._attribHTML = void 0;
            }
            _setElementTitle(t, e) {
                const i = this._map._getUIString(`AttributionControl.${e}`);
                t.title = i, t.setAttribute("aria-label", i);
            }
            _updateAttributions() {
                if (!this._map.style) return;
                let t = [];
                if (this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? t = t.concat(this.options.customAttribution.map((t)=>"string" != typeof t ? "" : t)) : "string" == typeof this.options.customAttribution && t.push(this.options.customAttribution)), this._map.style.stylesheet) {
                    const t = this._map.style.stylesheet;
                    this.styleOwner = t.owner, this.styleId = t.id;
                }
                const e = this._map.style.sourceCaches;
                for(const i in e){
                    const s = e[i];
                    if (s.used || s.usedForTerrain) {
                        const e = s.getSource();
                        e.attribution && t.indexOf(e.attribution) < 0 && t.push(e.attribution);
                    }
                }
                t = t.filter((t)=>String(t).trim()), t.sort((t, e)=>t.length - e.length), t = t.filter((e, i)=>{
                    for(let s = i + 1; s < t.length; s++)if (t[s].indexOf(e) >= 0) return !1;
                    return !0;
                });
                const i = t.join(" | ");
                i !== this._attribHTML && (this._attribHTML = i, t.length ? (this._innerContainer.innerHTML = i, this._container.classList.remove("maplibregl-attrib-empty")) : this._container.classList.add("maplibregl-attrib-empty"), this._updateCompact(), this._editLink = null);
            }
        }
        class na {
            constructor(t = {}){
                this._updateCompact = ()=>{
                    const t = this._container.children;
                    if (t.length) {
                        const e = t[0];
                        this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? !1 !== this._compact && e.classList.add("maplibregl-compact") : e.classList.remove("maplibregl-compact");
                    }
                }, this.options = t;
            }
            getDefaultPosition() {
                return "bottom-left";
            }
            onAdd(t) {
                this._map = t, this._compact = this.options && this.options.compact, this._container = i.create("div", "maplibregl-ctrl");
                const e = i.create("a", "maplibregl-ctrl-logo");
                return e.target = "_blank", e.rel = "noopener nofollow", e.href = "https://maplibre.org/", e.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), e.setAttribute("rel", "noopener nofollow"), this._container.appendChild(e), this._container.style.display = "block", this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
            }
            onRemove() {
                i.remove(this._container), this._map.off("resize", this._updateCompact), this._map = void 0, this._compact = void 0;
            }
        }
        class la {
            constructor(){
                this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
            }
            add(t) {
                const e = ++this._id;
                return this._queue.push({
                    callback: t,
                    id: e,
                    cancelled: !1
                }), e;
            }
            remove(t) {
                const e = this._currentlyRunning, i = e ? this._queue.concat(e) : this._queue;
                for (const e of i)if (e.id === t) return void (e.cancelled = !0);
            }
            run(t = 0) {
                if (this._currentlyRunning) throw new Error("Attempting to run(), but is already running.");
                const e = this._currentlyRunning = this._queue;
                this._queue = [];
                for (const i of e)if (!i.cancelled && (i.callback(t), this._cleared)) break;
                this._cleared = !1, this._currentlyRunning = !1;
            }
            clear() {
                this._currentlyRunning && (this._cleared = !0), this._queue = [];
            }
        }
        const ha = {
            "AttributionControl.ToggleAttribution": "Toggle attribution",
            "AttributionControl.MapFeedback": "Map feedback",
            "FullscreenControl.Enter": "Enter fullscreen",
            "FullscreenControl.Exit": "Exit fullscreen",
            "GeolocateControl.FindMyLocation": "Find my location",
            "GeolocateControl.LocationNotAvailable": "Location not available",
            "LogoControl.Title": "Mapbox logo",
            "NavigationControl.ResetBearing": "Reset bearing to north",
            "NavigationControl.ZoomIn": "Zoom in",
            "NavigationControl.ZoomOut": "Zoom out",
            "ScaleControl.Feet": "ft",
            "ScaleControl.Meters": "m",
            "ScaleControl.Kilometers": "km",
            "ScaleControl.Miles": "mi",
            "ScaleControl.NauticalMiles": "nm",
            "TerrainControl.enableTerrain": "Enable terrain",
            "TerrainControl.disableTerrain": "Disable terrain"
        };
        var ca = t.Q([
            {
                name: "a_pos3d",
                type: "Int16",
                components: 3
            }
        ]);
        class ua extends t.E {
            constructor(t){
                super(), this.sourceCache = t, this._tiles = {}, this._renderableTilesKeys = [], this._sourceTileCache = {}, this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.deltaZoom = 1, t.usedForTerrain = !0, t.tileSize = this.tileSize * 2 ** this.deltaZoom;
            }
            destruct() {
                this.sourceCache.usedForTerrain = !1, this.sourceCache.tileSize = null;
            }
            update(e, i) {
                this.sourceCache.update(e, i), this._renderableTilesKeys = [];
                const s = {};
                for (const a of e.coveringTiles({
                    tileSize: this.tileSize,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    reparseOverscaled: !1,
                    terrain: i
                }))s[a.key] = !0, this._renderableTilesKeys.push(a.key), this._tiles[a.key] || (a.posMatrix = new Float64Array(16), t.aS(a.posMatrix, 0, t.N, 0, t.N, 0, 1), this._tiles[a.key] = new W(a, this.tileSize));
                for(const t in this._tiles)s[t] || delete this._tiles[t];
            }
            freeRtt(t) {
                for(const e in this._tiles){
                    const i = this._tiles[e];
                    (!t || i.tileID.equals(t) || i.tileID.isChildOf(t) || t.isChildOf(i.tileID)) && (i.rtt = []);
                }
            }
            getRenderableTiles() {
                return this._renderableTilesKeys.map((t)=>this.getTileByID(t));
            }
            getTileByID(t) {
                return this._tiles[t];
            }
            getTerrainCoords(e) {
                const i = {};
                for (const s of this._renderableTilesKeys){
                    const a = this._tiles[s].tileID;
                    if (a.canonical.equals(e.canonical)) {
                        const a = e.clone();
                        a.posMatrix = new Float64Array(16), t.aS(a.posMatrix, 0, t.N, 0, t.N, 0, 1), i[s] = a;
                    } else if (a.canonical.isChildOf(e.canonical)) {
                        const o = e.clone();
                        o.posMatrix = new Float64Array(16);
                        const r = a.canonical.z - e.canonical.z, n = a.canonical.x - (a.canonical.x >> r << r), l = a.canonical.y - (a.canonical.y >> r << r), h = t.N >> r;
                        t.aS(o.posMatrix, 0, h, 0, h, 0, 1), t.$(o.posMatrix, o.posMatrix, [
                            -n * h,
                            -l * h,
                            0
                        ]), i[s] = o;
                    } else if (e.canonical.isChildOf(a.canonical)) {
                        const o = e.clone();
                        o.posMatrix = new Float64Array(16);
                        const r = e.canonical.z - a.canonical.z, n = e.canonical.x - (e.canonical.x >> r << r), l = e.canonical.y - (e.canonical.y >> r << r), h = t.N >> r;
                        t.aS(o.posMatrix, 0, t.N, 0, t.N, 0, 1), t.$(o.posMatrix, o.posMatrix, [
                            n * h,
                            l * h,
                            0
                        ]), t.a0(o.posMatrix, o.posMatrix, [
                            1 / 2 ** r,
                            1 / 2 ** r,
                            0
                        ]), i[s] = o;
                    }
                }
                return i;
            }
            getSourceTile(t, e) {
                const i = this.sourceCache._source;
                let s = t.overscaledZ - this.deltaZoom;
                if (s > i.maxzoom && (s = i.maxzoom), s < i.minzoom) return null;
                this._sourceTileCache[t.key] || (this._sourceTileCache[t.key] = t.scaledTo(s).key);
                let a = this.sourceCache.getTileByID(this._sourceTileCache[t.key]);
                if ((!a || !a.dem) && e) for(; s >= i.minzoom && (!a || !a.dem);)a = this.sourceCache.getTileByID(t.scaledTo(s--).key);
                return a;
            }
            tilesAfterTime(t = Date.now()) {
                return Object.values(this._tiles).filter((e)=>e.timeAdded >= t);
            }
        }
        class da {
            constructor(t, e, i){
                this.painter = t, this.sourceCache = new ua(e), this.options = i, this.exaggeration = "number" == typeof i.exaggeration ? i.exaggeration : 1, this.qualityFactor = 2, this.meshSize = 128, this._demMatrixCache = {}, this.coordsIndex = [], this._coordsTextureSize = 1024;
            }
            getDEMElevation(e, i, s, a = t.N) {
                var o;
                if (!(i >= 0 && i < a && s >= 0 && s < a)) return 0;
                const r = this.getTerrainData(e), n = null === (o = r.tile) || void 0 === o ? void 0 : o.dem;
                if (!n) return 0;
                const l = function(t, e, i) {
                    var s = e[0], a = e[1];
                    return t[0] = i[0] * s + i[4] * a + i[12], t[1] = i[1] * s + i[5] * a + i[13], t;
                }([], [
                    i / a * t.N,
                    s / a * t.N
                ], r.u_terrain_matrix), h = [
                    l[0] * n.dim,
                    l[1] * n.dim
                ], c = Math.floor(h[0]), u = Math.floor(h[1]), d = h[0] - c, _ = h[1] - u;
                return n.get(c, u) * (1 - d) * (1 - _) + n.get(c + 1, u) * d * (1 - _) + n.get(c, u + 1) * (1 - d) * _ + n.get(c + 1, u + 1) * d * _;
            }
            getElevationForLngLatZoom(e, i) {
                const { tileID: s, mercatorX: a, mercatorY: o } = this._getOverscaledTileIDFromLngLatZoom(e, i);
                return this.getElevation(s, a % t.N, o % t.N, t.N);
            }
            getElevation(e, i, s, a = t.N) {
                return this.getDEMElevation(e, i, s, a) * this.exaggeration;
            }
            getTerrainData(e) {
                if (!this._emptyDemTexture) {
                    const e = this.painter.context, i = new t.R({
                        width: 1,
                        height: 1
                    }, new Uint8Array(4));
                    this._emptyDepthTexture = new x(e, i, e.gl.RGBA, {
                        premultiply: !1
                    }), this._emptyDemUnpack = [
                        0,
                        0,
                        0,
                        0
                    ], this._emptyDemTexture = new x(e, new t.R({
                        width: 1,
                        height: 1
                    }), e.gl.RGBA, {
                        premultiply: !1
                    }), this._emptyDemTexture.bind(e.gl.NEAREST, e.gl.CLAMP_TO_EDGE), this._emptyDemMatrix = t.ao([]);
                }
                const i = this.sourceCache.getSourceTile(e, !0);
                if (i && i.dem && (!i.demTexture || i.needsTerrainPrepare)) {
                    const t = this.painter.context;
                    i.demTexture = this.painter.getTileTexture(i.dem.stride), i.demTexture ? i.demTexture.update(i.dem.getPixels(), {
                        premultiply: !1
                    }) : i.demTexture = new x(t, i.dem.getPixels(), t.gl.RGBA, {
                        premultiply: !1
                    }), i.demTexture.bind(t.gl.NEAREST, t.gl.CLAMP_TO_EDGE), i.needsTerrainPrepare = !1;
                }
                const s = i && i + i.tileID.key + e.key;
                if (s && !this._demMatrixCache[s]) {
                    const s = this.sourceCache.sourceCache._source.maxzoom;
                    let a = e.canonical.z - i.tileID.canonical.z;
                    e.overscaledZ > e.canonical.z && (e.canonical.z >= s ? a = e.canonical.z - s : t.w("cannot calculate elevation if elevation maxzoom > source.maxzoom"));
                    const o = e.canonical.x - (e.canonical.x >> a << a), r = e.canonical.y - (e.canonical.y >> a << a), n = t.bc(new Float64Array(16), [
                        1 / (t.N << a),
                        1 / (t.N << a),
                        0
                    ]);
                    t.$(n, n, [
                        o * t.N,
                        r * t.N,
                        0
                    ]), this._demMatrixCache[e.key] = {
                        matrix: n,
                        coord: e
                    };
                }
                return {
                    u_depth: 2,
                    u_terrain: 3,
                    u_terrain_dim: i && i.dem && i.dem.dim || 1,
                    u_terrain_matrix: s ? this._demMatrixCache[e.key].matrix : this._emptyDemMatrix,
                    u_terrain_unpack: i && i.dem && i.dem.getUnpackVector() || this._emptyDemUnpack,
                    u_terrain_exaggeration: this.exaggeration,
                    texture: (i && i.demTexture || this._emptyDemTexture).texture,
                    depthTexture: (this._fboDepthTexture || this._emptyDepthTexture).texture,
                    tile: i
                };
            }
            getFramebuffer(t) {
                const e = this.painter, i = e.width / devicePixelRatio, s = e.height / devicePixelRatio;
                return !this._fbo || this._fbo.width === i && this._fbo.height === s || (this._fbo.destroy(), this._fboCoordsTexture.destroy(), this._fboDepthTexture.destroy(), delete this._fbo, delete this._fboDepthTexture, delete this._fboCoordsTexture), this._fboCoordsTexture || (this._fboCoordsTexture = new x(e.context, {
                    width: i,
                    height: s,
                    data: null
                }, e.context.gl.RGBA, {
                    premultiply: !1
                }), this._fboCoordsTexture.bind(e.context.gl.NEAREST, e.context.gl.CLAMP_TO_EDGE)), this._fboDepthTexture || (this._fboDepthTexture = new x(e.context, {
                    width: i,
                    height: s,
                    data: null
                }, e.context.gl.RGBA, {
                    premultiply: !1
                }), this._fboDepthTexture.bind(e.context.gl.NEAREST, e.context.gl.CLAMP_TO_EDGE)), this._fbo || (this._fbo = e.context.createFramebuffer(i, s, !0, !1), this._fbo.depthAttachment.set(e.context.createRenderbuffer(e.context.gl.DEPTH_COMPONENT16, i, s))), this._fbo.colorAttachment.set("coords" === t ? this._fboCoordsTexture.texture : this._fboDepthTexture.texture), this._fbo;
            }
            getCoordsTexture() {
                const e = this.painter.context;
                if (this._coordsTexture) return this._coordsTexture;
                const i = new Uint8Array(this._coordsTextureSize * this._coordsTextureSize * 4);
                for(let t = 0, e = 0; t < this._coordsTextureSize; t++)for(let s = 0; s < this._coordsTextureSize; s++, e += 4)i[e + 0] = 255 & s, i[e + 1] = 255 & t, i[e + 2] = s >> 8 << 4 | t >> 8, i[e + 3] = 0;
                const s = new t.R({
                    width: this._coordsTextureSize,
                    height: this._coordsTextureSize
                }, new Uint8Array(i.buffer)), a = new x(e, s, e.gl.RGBA, {
                    premultiply: !1
                });
                return a.bind(e.gl.NEAREST, e.gl.CLAMP_TO_EDGE), this._coordsTexture = a, a;
            }
            pointCoordinate(e) {
                const i = new Uint8Array(4), s = this.painter.context, a = s.gl;
                s.bindFramebuffer.set(this.getFramebuffer("coords").framebuffer), a.readPixels(e.x, this.painter.height / devicePixelRatio - e.y - 1, 1, 1, a.RGBA, a.UNSIGNED_BYTE, i), s.bindFramebuffer.set(null);
                const o = i[0] + (i[2] >> 4 << 8), r = i[1] + ((15 & i[2]) << 8), n = this.coordsIndex[255 - i[3]], l = n && this.sourceCache.getTileByID(n);
                if (!l) return null;
                const h = this._coordsTextureSize, c = (1 << l.tileID.canonical.z) * h;
                return new t.U(this._allowMercatorOverflow(e, (l.tileID.canonical.x * h + o) / c), (l.tileID.canonical.y * h + r) / c, this.getElevation(l.tileID, o, r, h));
            }
            getTerrainMesh() {
                if (this._mesh) return this._mesh;
                const e = this.painter.context, i = new t.bd, s = new t.b0, a = this.meshSize, o = t.N / a, r = a * a;
                for(let t = 0; t <= a; t++)for(let e = 0; e <= a; e++)i.emplaceBack(e * o, t * o, 0);
                for(let t = 0; t < r; t += a + 1)for(let e = 0; e < a; e++)s.emplaceBack(e + t, a + e + t + 1, a + e + t + 2), s.emplaceBack(e + t, a + e + t + 2, e + t + 1);
                const n = i.length, l = n + 2 * (a + 1);
                for (const e of [
                    0,
                    1
                ])for(let s = 0; s <= a; s++)for (const a of [
                    0,
                    1
                ])i.emplaceBack(s * o, e * t.N, a);
                for(let t = 0; t < 2 * a; t += 2)s.emplaceBack(l + t, l + t + 1, l + t + 3), s.emplaceBack(l + t, l + t + 3, l + t + 2), s.emplaceBack(n + t, n + t + 3, n + t + 1), s.emplaceBack(n + t, n + t + 2, n + t + 3);
                const h = i.length, c = h + 2 * (a + 1);
                for (const e of [
                    0,
                    1
                ])for(let s = 0; s <= a; s++)for (const a of [
                    0,
                    1
                ])i.emplaceBack(e * t.N, s * o, a);
                for(let t = 0; t < 2 * a; t += 2)s.emplaceBack(h + t, h + t + 1, h + t + 3), s.emplaceBack(h + t, h + t + 3, h + t + 2), s.emplaceBack(c + t, c + t + 3, c + t + 1), s.emplaceBack(c + t, c + t + 2, c + t + 3);
                return this._mesh = {
                    indexBuffer: e.createIndexBuffer(s),
                    vertexBuffer: e.createVertexBuffer(i, ca.members),
                    segments: t.S.simpleSegment(0, 0, i.length, s.length)
                }, this._mesh;
            }
            getMeshFrameDelta(e) {
                return 2 * Math.PI * t.be / Math.pow(2, e) / 5;
            }
            getMinTileElevationForLngLatZoom(t, e) {
                var i;
                const { tileID: s } = this._getOverscaledTileIDFromLngLatZoom(t, e);
                return null !== (i = this.getMinMaxElevation(s).minElevation) && void 0 !== i ? i : 0;
            }
            getMinMaxElevation(t) {
                const e = this.getTerrainData(t).tile, i = {
                    minElevation: null,
                    maxElevation: null
                };
                return e && e.dem && (i.minElevation = e.dem.min * this.exaggeration, i.maxElevation = e.dem.max * this.exaggeration), i;
            }
            _getOverscaledTileIDFromLngLatZoom(e, i) {
                const s = t.U.fromLngLat(e.wrap()), a = (1 << i) * t.N, o = s.x * a, r = s.y * a, n = Math.floor(o / t.N), l = Math.floor(r / t.N);
                return {
                    tileID: new t.O(i, 0, i, n, l),
                    mercatorX: o,
                    mercatorY: r
                };
            }
            _allowMercatorOverflow(e, i) {
                const s = e.x < this.painter.width / 2;
                let a = t.bf(i);
                const o = this.painter.transform.center.lng;
                return s && Math.sign(a) > 0 && Math.sign(o) < 0 || !s && Math.sign(a) < 0 && Math.sign(o) > 0 ? (a = 360 * Math.sign(o) + a, t.G(a)) : i;
            }
        }
        class _a {
            constructor(t, e, i){
                this._context = t, this._size = e, this._tileSize = i, this._objects = [], this._recentlyUsed = [], this._stamp = 0;
            }
            destruct() {
                for (const t of this._objects)t.texture.destroy(), t.fbo.destroy();
            }
            _createObject(t) {
                const e = this._context.createFramebuffer(this._tileSize, this._tileSize, !0, !0), i = new x(this._context, {
                    width: this._tileSize,
                    height: this._tileSize,
                    data: null
                }, this._context.gl.RGBA);
                return i.bind(this._context.gl.LINEAR, this._context.gl.CLAMP_TO_EDGE), e.depthAttachment.set(this._context.createRenderbuffer(this._context.gl.DEPTH_STENCIL, this._tileSize, this._tileSize)), e.colorAttachment.set(i.texture), {
                    id: t,
                    fbo: e,
                    texture: i,
                    stamp: -1,
                    inUse: !1
                };
            }
            getObjectForId(t) {
                return this._objects[t];
            }
            useObject(t) {
                t.inUse = !0, this._recentlyUsed = this._recentlyUsed.filter((e)=>t.id !== e), this._recentlyUsed.push(t.id);
            }
            stampObject(t) {
                t.stamp = ++this._stamp;
            }
            getOrCreateFreeObject() {
                for (const t of this._recentlyUsed)if (!this._objects[t].inUse) return this._objects[t];
                if (this._objects.length >= this._size) throw new Error("No free RenderPool available, call freeAllObjects() required!");
                const t = this._createObject(this._objects.length);
                return this._objects.push(t), t;
            }
            freeObject(t) {
                t.inUse = !1;
            }
            freeAllObjects() {
                for (const t of this._objects)this.freeObject(t);
            }
            isFull() {
                return !(this._objects.length < this._size) && !1 === this._objects.some((t)=>!t.inUse);
            }
        }
        const pa = {
            background: !0,
            fill: !0,
            line: !0,
            raster: !0,
            hillshade: !0
        };
        class ma {
            constructor(t, e){
                this.painter = t, this.terrain = e, this.pool = new _a(t.context, 30, e.sourceCache.tileSize * e.qualityFactor);
            }
            destruct() {
                this.pool.destruct();
            }
            getTexture(t) {
                return this.pool.getObjectForId(t.rtt[this._stacks.length - 1].id).texture;
            }
            prepareForRender(t, e) {
                this._stacks = [], this._prevType = null, this._rttTiles = [], this._renderableTiles = this.terrain.sourceCache.getRenderableTiles(), this._renderableLayerIds = t._order.filter((i)=>!t._layers[i].isHidden(e)), this._coordsDescendingInv = {};
                for(const e in t.sourceCaches){
                    this._coordsDescendingInv[e] = {};
                    const i = t.sourceCaches[e].getVisibleCoordinates();
                    for (const t of i){
                        const i = this.terrain.sourceCache.getTerrainCoords(t);
                        for(const t in i)this._coordsDescendingInv[e][t] || (this._coordsDescendingInv[e][t] = []), this._coordsDescendingInv[e][t].push(i[t]);
                    }
                }
                this._coordsDescendingInvStr = {};
                for (const e of t._order){
                    const i = t._layers[e], s = i.source;
                    if (pa[i.type] && !this._coordsDescendingInvStr[s]) {
                        this._coordsDescendingInvStr[s] = {};
                        for(const t in this._coordsDescendingInv[s])this._coordsDescendingInvStr[s][t] = this._coordsDescendingInv[s][t].map((t)=>t.key).sort().join();
                    }
                }
                for (const t of this._renderableTiles)for(const e in this._coordsDescendingInvStr){
                    const i = this._coordsDescendingInvStr[e][t.tileID.key];
                    i && i !== t.rttCoords[e] && (t.rtt = []);
                }
            }
            renderLayer(e) {
                if (e.isHidden(this.painter.transform.zoom)) return !1;
                const i = e.type, s = this.painter, a = this._renderableLayerIds[this._renderableLayerIds.length - 1] === e.id;
                if (pa[i] && (this._prevType && pa[this._prevType] || this._stacks.push([]), this._prevType = i, this._stacks[this._stacks.length - 1].push(e.id), !a)) return !0;
                if (pa[this._prevType] || pa[i] && a) {
                    this._prevType = i;
                    const e = this._stacks.length - 1, a = this._stacks[e] || [];
                    for (const i of this._renderableTiles){
                        if (this.pool.isFull() && (es(this.painter, this.terrain, this._rttTiles), this._rttTiles = [], this.pool.freeAllObjects()), this._rttTiles.push(i), i.rtt[e]) {
                            const t = this.pool.getObjectForId(i.rtt[e].id);
                            if (t.stamp === i.rtt[e].stamp) {
                                this.pool.useObject(t);
                                continue;
                            }
                        }
                        const o = this.pool.getOrCreateFreeObject();
                        this.pool.useObject(o), this.pool.stampObject(o), i.rtt[e] = {
                            id: o.id,
                            stamp: o.stamp
                        }, s.context.bindFramebuffer.set(o.fbo.framebuffer), s.context.clear({
                            color: t.aT.transparent,
                            stencil: 0
                        }), s.currentStencilSource = void 0;
                        for(let t = 0; t < a.length; t++){
                            const e = s.style._layers[a[t]], r = e.source ? this._coordsDescendingInv[e.source][i.tileID.key] : [
                                i.tileID
                            ];
                            s.context.viewport.set([
                                0,
                                0,
                                o.fbo.width,
                                o.fbo.height
                            ]), s._renderTileClippingMasks(e, r), s.renderLayer(s, s.style.sourceCaches[e.source], e, r), e.source && (i.rttCoords[e.source] = this._coordsDescendingInvStr[e.source][i.tileID.key]);
                        }
                    }
                    return es(this.painter, this.terrain, this._rttTiles), this._rttTiles = [], this.pool.freeAllObjects(), pa[i];
                }
                return !1;
            }
        }
        const fa = e, ga = {
            center: [
                0,
                0
            ],
            zoom: 0,
            bearing: 0,
            pitch: 0,
            minZoom: -2,
            maxZoom: 22,
            minPitch: 0,
            maxPitch: 60,
            interactive: !0,
            scrollZoom: !0,
            boxZoom: !0,
            dragRotate: !0,
            dragPan: !0,
            keyboard: !0,
            doubleClickZoom: !0,
            touchZoomRotate: !0,
            touchPitch: !0,
            cooperativeGestures: void 0,
            bearingSnap: 7,
            clickTolerance: 3,
            pitchWithRotate: !0,
            hash: !1,
            attributionControl: !0,
            maplibreLogo: !1,
            failIfMajorPerformanceCaveat: !1,
            preserveDrawingBuffer: !1,
            trackResize: !0,
            renderWorldCopies: !0,
            refreshExpiredTiles: !0,
            maxTileCacheSize: null,
            maxTileCacheZoomLevels: t.c.MAX_TILE_CACHE_ZOOM_LEVELS,
            localIdeographFontFamily: "sans-serif",
            transformRequest: null,
            transformCameraUpdate: null,
            fadeDuration: 300,
            crossSourceCollisions: !0,
            validateStyle: !0,
            maxCanvasSize: [
                4096,
                4096
            ]
        }, va = (t)=>{
            t.touchstart = t.dragStart, t.touchmoveWindow = t.dragMove, t.touchend = t.dragEnd;
        }, xa = {
            showCompass: !0,
            showZoom: !0,
            visualizePitch: !1
        };
        class ya {
            constructor(e, s, a = !1){
                this.mousedown = (e)=>{
                    this.startMouse(t.e({}, e, {
                        ctrlKey: !0,
                        preventDefault: ()=>e.preventDefault()
                    }), i.mousePos(this.element, e)), i.addEventListener(window, "mousemove", this.mousemove), i.addEventListener(window, "mouseup", this.mouseup);
                }, this.mousemove = (t)=>{
                    this.moveMouse(t, i.mousePos(this.element, t));
                }, this.mouseup = (t)=>{
                    this.mouseRotate.dragEnd(t), this.mousePitch && this.mousePitch.dragEnd(t), this.offTemp();
                }, this.touchstart = (t)=>{
                    1 !== t.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = i.touchPos(this.element, t.targetTouches)[0], this.startTouch(t, this._startPos), i.addEventListener(window, "touchmove", this.touchmove, {
                        passive: !1
                    }), i.addEventListener(window, "touchend", this.touchend));
                }, this.touchmove = (t)=>{
                    1 !== t.targetTouches.length ? this.reset() : (this._lastPos = i.touchPos(this.element, t.targetTouches)[0], this.moveTouch(t, this._lastPos));
                }, this.touchend = (t)=>{
                    0 === t.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), delete this._startPos, delete this._lastPos, this.offTemp();
                }, this.reset = ()=>{
                    this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), this.touchRotate.reset(), this.touchPitch && this.touchPitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
                }, this._clickTolerance = 10;
                const o = e.dragRotate._mouseRotate.getClickTolerance(), r = e.dragRotate._mousePitch.getClickTolerance();
                this.element = s, this.mouseRotate = As({
                    clickTolerance: o,
                    enable: !0
                }), this.touchRotate = (({ enable: t, clickTolerance: e, bearingDegreesPerPixelMoved: i = .8 })=>{
                    const s = new zs;
                    return new Ps({
                        clickTolerance: e,
                        move: (t, e)=>({
                                bearingDelta: (e.x - t.x) * i
                            }),
                        moveStateManager: s,
                        enable: t,
                        assignEvents: va
                    });
                })({
                    clickTolerance: o,
                    enable: !0
                }), this.map = e, a && (this.mousePitch = Rs({
                    clickTolerance: r,
                    enable: !0
                }), this.touchPitch = (({ enable: t, clickTolerance: e, pitchDegreesPerPixelMoved: i = -0.5 })=>{
                    const s = new zs;
                    return new Ps({
                        clickTolerance: e,
                        move: (t, e)=>({
                                pitchDelta: (e.y - t.y) * i
                            }),
                        moveStateManager: s,
                        enable: t,
                        assignEvents: va
                    });
                })({
                    clickTolerance: r,
                    enable: !0
                })), i.addEventListener(s, "mousedown", this.mousedown), i.addEventListener(s, "touchstart", this.touchstart, {
                    passive: !1
                }), i.addEventListener(s, "touchcancel", this.reset);
            }
            startMouse(t, e) {
                this.mouseRotate.dragStart(t, e), this.mousePitch && this.mousePitch.dragStart(t, e), i.disableDrag();
            }
            startTouch(t, e) {
                this.touchRotate.dragStart(t, e), this.touchPitch && this.touchPitch.dragStart(t, e), i.disableDrag();
            }
            moveMouse(t, e) {
                const i = this.map, { bearingDelta: s } = this.mouseRotate.dragMove(t, e) || {};
                if (s && i.setBearing(i.getBearing() + s), this.mousePitch) {
                    const { pitchDelta: s } = this.mousePitch.dragMove(t, e) || {};
                    s && i.setPitch(i.getPitch() + s);
                }
            }
            moveTouch(t, e) {
                const i = this.map, { bearingDelta: s } = this.touchRotate.dragMove(t, e) || {};
                if (s && i.setBearing(i.getBearing() + s), this.touchPitch) {
                    const { pitchDelta: s } = this.touchPitch.dragMove(t, e) || {};
                    s && i.setPitch(i.getPitch() + s);
                }
            }
            off() {
                const t = this.element;
                i.removeEventListener(t, "mousedown", this.mousedown), i.removeEventListener(t, "touchstart", this.touchstart, {
                    passive: !1
                }), i.removeEventListener(window, "touchmove", this.touchmove, {
                    passive: !1
                }), i.removeEventListener(window, "touchend", this.touchend), i.removeEventListener(t, "touchcancel", this.reset), this.offTemp();
            }
            offTemp() {
                i.enableDrag(), i.removeEventListener(window, "mousemove", this.mousemove), i.removeEventListener(window, "mouseup", this.mouseup), i.removeEventListener(window, "touchmove", this.touchmove, {
                    passive: !1
                }), i.removeEventListener(window, "touchend", this.touchend);
            }
        }
        let ba;
        function wa(e, i, s) {
            if (e = new t.L(e.lng, e.lat), i) {
                const a = new t.L(e.lng - 360, e.lat), o = new t.L(e.lng + 360, e.lat), r = s.locationPoint(e).distSqr(i);
                s.locationPoint(a).distSqr(i) < r ? e = a : s.locationPoint(o).distSqr(i) < r && (e = o);
            }
            for(; Math.abs(e.lng - s.center.lng) > 180;){
                const t = s.locationPoint(e);
                if (t.x >= 0 && t.y >= 0 && t.x <= s.width && t.y <= s.height) break;
                e.lng > s.center.lng ? e.lng -= 360 : e.lng += 360;
            }
            return e;
        }
        const Ta = {
            center: "translate(-50%,-50%)",
            top: "translate(-50%,0)",
            "top-left": "translate(0,0)",
            "top-right": "translate(-100%,0)",
            bottom: "translate(-50%,-100%)",
            "bottom-left": "translate(0,-100%)",
            "bottom-right": "translate(-100%,-100%)",
            left: "translate(0,-50%)",
            right: "translate(-100%,-50%)"
        };
        function Ia(t, e, i) {
            const s = t.classList;
            for(const t in Ta)s.remove(`maplibregl-${i}-anchor-${t}`);
            s.add(`maplibregl-${i}-anchor-${e}`);
        }
        class Ea extends t.E {
            constructor(e){
                if (super(), this._onKeyPress = (t)=>{
                    const e = t.code, i = t.charCode || t.keyCode;
                    "Space" !== e && "Enter" !== e && 32 !== i && 13 !== i || this.togglePopup();
                }, this._onMapClick = (t)=>{
                    const e = t.originalEvent.target, i = this._element;
                    this._popup && (e === i || i.contains(e)) && this.togglePopup();
                }, this._update = (t)=>{
                    if (!this._map) return;
                    const e = this._map.loaded() && !this._map.isMoving();
                    ("terrain" === (null == t ? void 0 : t.type) || "render" === (null == t ? void 0 : t.type) && !e) && this._map.once("render", this._update), this._map.transform.renderWorldCopies && (this._lngLat = wa(this._lngLat, this._pos, this._map.transform)), this._pos = this._map.project(this._lngLat)._add(this._offset);
                    let s = "";
                    "viewport" === this._rotationAlignment || "auto" === this._rotationAlignment ? s = `rotateZ(${this._rotation}deg)` : "map" === this._rotationAlignment && (s = `rotateZ(${this._rotation - this._map.getBearing()}deg)`);
                    let a = "";
                    "viewport" === this._pitchAlignment || "auto" === this._pitchAlignment ? a = "rotateX(0deg)" : "map" === this._pitchAlignment && (a = `rotateX(${this._map.getPitch()}deg)`), t && "moveend" !== t.type || (this._pos = this._pos.round()), i.setTransform(this._element, `${Ta[this._anchor]} translate(${this._pos.x}px, ${this._pos.y}px) ${a} ${s}`), this._map.terrain && !this._opacityTimeout && (this._opacityTimeout = setTimeout(()=>{
                        const t = this._map.unproject(this._pos), e = 40075016.686 * Math.abs(Math.cos(this._lngLat.lat * Math.PI / 180)) / Math.pow(2, this._map.transform.tileZoom + 8);
                        this._element.style.opacity = t.distanceTo(this._lngLat) > 20 * e ? "0.2" : "1.0", this._opacityTimeout = null;
                    }, 100));
                }, this._onMove = (e)=>{
                    if (!this._isDragging) {
                        const t = this._clickTolerance || this._map._clickTolerance;
                        this._isDragging = e.point.dist(this._pointerdownPos) >= t;
                    }
                    this._isDragging && (this._pos = e.point.sub(this._positionDelta), this._lngLat = this._map.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new t.k("dragstart"))), this.fire(new t.k("drag")));
                }, this._onUp = ()=>{
                    this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1, this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), "active" === this._state && this.fire(new t.k("dragend")), this._state = "inactive";
                }, this._addDragHandler = (t)=>{
                    this._element.contains(t.originalEvent.target) && (t.preventDefault(), this._positionDelta = t.point.sub(this._pos).add(this._offset), this._pointerdownPos = t.point, this._state = "pending", this._map.on("mousemove", this._onMove), this._map.on("touchmove", this._onMove), this._map.once("mouseup", this._onUp), this._map.once("touchend", this._onUp));
                }, this._anchor = e && e.anchor || "center", this._color = e && e.color || "#3FB1CE", this._scale = e && e.scale || 1, this._draggable = e && e.draggable || !1, this._clickTolerance = e && e.clickTolerance || 0, this._isDragging = !1, this._state = "inactive", this._rotation = e && e.rotation || 0, this._rotationAlignment = e && e.rotationAlignment || "auto", this._pitchAlignment = e && e.pitchAlignment && "auto" !== e.pitchAlignment ? e.pitchAlignment : this._rotationAlignment, e && e.element) this._element = e.element, this._offset = t.P.convert(e && e.offset || [
                    0,
                    0
                ]);
                else {
                    this._defaultMarker = !0, this._element = i.create("div"), this._element.setAttribute("aria-label", "Map marker");
                    const s = i.createNS("http://www.w3.org/2000/svg", "svg"), a = 41, o = 27;
                    s.setAttributeNS(null, "display", "block"), s.setAttributeNS(null, "height", `${a}px`), s.setAttributeNS(null, "width", `${o}px`), s.setAttributeNS(null, "viewBox", `0 0 ${o} ${a}`);
                    const r = i.createNS("http://www.w3.org/2000/svg", "g");
                    r.setAttributeNS(null, "stroke", "none"), r.setAttributeNS(null, "stroke-width", "1"), r.setAttributeNS(null, "fill", "none"), r.setAttributeNS(null, "fill-rule", "evenodd");
                    const n = i.createNS("http://www.w3.org/2000/svg", "g");
                    n.setAttributeNS(null, "fill-rule", "nonzero");
                    const l = i.createNS("http://www.w3.org/2000/svg", "g");
                    l.setAttributeNS(null, "transform", "translate(3.0, 29.0)"), l.setAttributeNS(null, "fill", "#000000");
                    const h = [
                        {
                            rx: "10.5",
                            ry: "5.25002273"
                        },
                        {
                            rx: "10.5",
                            ry: "5.25002273"
                        },
                        {
                            rx: "9.5",
                            ry: "4.77275007"
                        },
                        {
                            rx: "8.5",
                            ry: "4.29549936"
                        },
                        {
                            rx: "7.5",
                            ry: "3.81822308"
                        },
                        {
                            rx: "6.5",
                            ry: "3.34094679"
                        },
                        {
                            rx: "5.5",
                            ry: "2.86367051"
                        },
                        {
                            rx: "4.5",
                            ry: "2.38636864"
                        }
                    ];
                    for (const t of h){
                        const e = i.createNS("http://www.w3.org/2000/svg", "ellipse");
                        e.setAttributeNS(null, "opacity", "0.04"), e.setAttributeNS(null, "cx", "10.5"), e.setAttributeNS(null, "cy", "5.80029008"), e.setAttributeNS(null, "rx", t.rx), e.setAttributeNS(null, "ry", t.ry), l.appendChild(e);
                    }
                    const c = i.createNS("http://www.w3.org/2000/svg", "g");
                    c.setAttributeNS(null, "fill", this._color);
                    const u = i.createNS("http://www.w3.org/2000/svg", "path");
                    u.setAttributeNS(null, "d", "M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"), c.appendChild(u);
                    const d = i.createNS("http://www.w3.org/2000/svg", "g");
                    d.setAttributeNS(null, "opacity", "0.25"), d.setAttributeNS(null, "fill", "#000000");
                    const _ = i.createNS("http://www.w3.org/2000/svg", "path");
                    _.setAttributeNS(null, "d", "M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"), d.appendChild(_);
                    const p = i.createNS("http://www.w3.org/2000/svg", "g");
                    p.setAttributeNS(null, "transform", "translate(6.0, 7.0)"), p.setAttributeNS(null, "fill", "#FFFFFF");
                    const m = i.createNS("http://www.w3.org/2000/svg", "g");
                    m.setAttributeNS(null, "transform", "translate(8.0, 8.0)");
                    const f = i.createNS("http://www.w3.org/2000/svg", "circle");
                    f.setAttributeNS(null, "fill", "#000000"), f.setAttributeNS(null, "opacity", "0.25"), f.setAttributeNS(null, "cx", "5.5"), f.setAttributeNS(null, "cy", "5.5"), f.setAttributeNS(null, "r", "5.4999962");
                    const g = i.createNS("http://www.w3.org/2000/svg", "circle");
                    g.setAttributeNS(null, "fill", "#FFFFFF"), g.setAttributeNS(null, "cx", "5.5"), g.setAttributeNS(null, "cy", "5.5"), g.setAttributeNS(null, "r", "5.4999962"), m.appendChild(f), m.appendChild(g), n.appendChild(l), n.appendChild(c), n.appendChild(d), n.appendChild(p), n.appendChild(m), s.appendChild(n), s.setAttributeNS(null, "height", a * this._scale + "px"), s.setAttributeNS(null, "width", o * this._scale + "px"), this._element.appendChild(s), this._offset = t.P.convert(e && e.offset || [
                        0,
                        -14
                    ]);
                }
                if (this._element.classList.add("maplibregl-marker"), this._element.addEventListener("dragstart", (t)=>{
                    t.preventDefault();
                }), this._element.addEventListener("mousedown", (t)=>{
                    t.preventDefault();
                }), Ia(this._element, this._anchor, "marker"), e && e.className) for (const t of e.className.split(" "))this._element.classList.add(t);
                this._popup = null;
            }
            addTo(t) {
                return this.remove(), this._map = t, t.getCanvasContainer().appendChild(this._element), t.on("move", this._update), t.on("moveend", this._update), t.on("terrain", this._update), this.setDraggable(this._draggable), this._update(), this._map.on("click", this._onMapClick), this;
            }
            remove() {
                return this._opacityTimeout && (clearTimeout(this._opacityTimeout), delete this._opacityTimeout), this._map && (this._map.off("click", this._onMapClick), this._map.off("move", this._update), this._map.off("moveend", this._update), this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler), this._map.off("mouseup", this._onUp), this._map.off("touchend", this._onUp), this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), delete this._map), i.remove(this._element), this._popup && this._popup.remove(), this;
            }
            getLngLat() {
                return this._lngLat;
            }
            setLngLat(e) {
                return this._lngLat = t.L.convert(e), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(), this;
            }
            getElement() {
                return this._element;
            }
            setPopup(t) {
                if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), t) {
                    if (!("offset" in t.options)) {
                        const e = 38.1, i = 13.5, s = Math.abs(i) / Math.SQRT2;
                        t.options.offset = this._defaultMarker ? {
                            top: [
                                0,
                                0
                            ],
                            "top-left": [
                                0,
                                0
                            ],
                            "top-right": [
                                0,
                                0
                            ],
                            bottom: [
                                0,
                                -e
                            ],
                            "bottom-left": [
                                s,
                                -1 * (e - i + s)
                            ],
                            "bottom-right": [
                                -s,
                                -1 * (e - i + s)
                            ],
                            left: [
                                i,
                                -1 * (e - i)
                            ],
                            right: [
                                -i,
                                -1 * (e - i)
                            ]
                        } : this._offset;
                    }
                    this._popup = t, this._lngLat && this._popup.setLngLat(this._lngLat), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress);
                }
                return this;
            }
            getPopup() {
                return this._popup;
            }
            togglePopup() {
                const t = this._popup;
                return t ? (t.isOpen() ? t.remove() : t.addTo(this._map), this) : this;
            }
            getOffset() {
                return this._offset;
            }
            setOffset(e) {
                return this._offset = t.P.convert(e), this._update(), this;
            }
            addClassName(t) {
                this._element.classList.add(t);
            }
            removeClassName(t) {
                this._element.classList.remove(t);
            }
            toggleClassName(t) {
                return this._element.classList.toggle(t);
            }
            setDraggable(t) {
                return this._draggable = !!t, this._map && (t ? (this._map.on("mousedown", this._addDragHandler), this._map.on("touchstart", this._addDragHandler)) : (this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler))), this;
            }
            isDraggable() {
                return this._draggable;
            }
            setRotation(t) {
                return this._rotation = t || 0, this._update(), this;
            }
            getRotation() {
                return this._rotation;
            }
            setRotationAlignment(t) {
                return this._rotationAlignment = t || "auto", this._update(), this;
            }
            getRotationAlignment() {
                return this._rotationAlignment;
            }
            setPitchAlignment(t) {
                return this._pitchAlignment = t && "auto" !== t ? t : this._rotationAlignment, this._update(), this;
            }
            getPitchAlignment() {
                return this._pitchAlignment;
            }
        }
        const Sa = {
            positionOptions: {
                enableHighAccuracy: !1,
                maximumAge: 0,
                timeout: 6e3
            },
            fitBoundsOptions: {
                maxZoom: 15
            },
            trackUserLocation: !1,
            showAccuracyCircle: !0,
            showUserLocation: !0
        };
        let Ca = 0, Pa = !1;
        const Da = {
            maxWidth: 100,
            unit: "metric"
        };
        function Ma(t, e, i) {
            const s = i && i.maxWidth || 100, a = t._container.clientHeight / 2, o = t.unproject([
                0,
                a
            ]), r = t.unproject([
                s,
                a
            ]), n = o.distanceTo(r);
            if (i && "imperial" === i.unit) {
                const i = 3.2808 * n;
                i > 5280 ? za(e, s, i / 5280, t._getUIString("ScaleControl.Miles")) : za(e, s, i, t._getUIString("ScaleControl.Feet"));
            } else i && "nautical" === i.unit ? za(e, s, n / 1852, t._getUIString("ScaleControl.NauticalMiles")) : n >= 1e3 ? za(e, s, n / 1e3, t._getUIString("ScaleControl.Kilometers")) : za(e, s, n, t._getUIString("ScaleControl.Meters"));
        }
        function za(t, e, i, s) {
            const a = function(t) {
                const e = Math.pow(10, `${Math.floor(t)}`.length - 1);
                let i = t / e;
                return i = i >= 10 ? 10 : i >= 5 ? 5 : i >= 3 ? 3 : i >= 2 ? 2 : i >= 1 ? 1 : function(t) {
                    const e = Math.pow(10, Math.ceil(-Math.log(t) / Math.LN10));
                    return Math.round(t * e) / e;
                }(i), e * i;
            }(i);
            t.style.width = e * (a / i) + "px", t.innerHTML = `${a}&nbsp;${s}`;
        }
        const La = {
            closeButton: !0,
            closeOnClick: !0,
            focusAfterOpen: !0,
            className: "",
            maxWidth: "240px"
        }, Aa = [
            "a[href]",
            "[tabindex]:not([tabindex='-1'])",
            "[contenteditable]:not([contenteditable='false'])",
            "button:not([disabled])",
            "input:not([disabled])",
            "select:not([disabled])",
            "textarea:not([disabled])"
        ].join(", ");
        function Ra(e) {
            if (e) {
                if ("number" == typeof e) {
                    const i = Math.round(Math.abs(e) / Math.SQRT2);
                    return {
                        center: new t.P(0, 0),
                        top: new t.P(0, e),
                        "top-left": new t.P(i, i),
                        "top-right": new t.P(-i, i),
                        bottom: new t.P(0, -e),
                        "bottom-left": new t.P(i, -i),
                        "bottom-right": new t.P(-i, -i),
                        left: new t.P(e, 0),
                        right: new t.P(-e, 0)
                    };
                }
                if (e instanceof t.P || Array.isArray(e)) {
                    const i = t.P.convert(e);
                    return {
                        center: i,
                        top: i,
                        "top-left": i,
                        "top-right": i,
                        bottom: i,
                        "bottom-left": i,
                        "bottom-right": i,
                        left: i,
                        right: i
                    };
                }
                return {
                    center: t.P.convert(e.center || [
                        0,
                        0
                    ]),
                    top: t.P.convert(e.top || [
                        0,
                        0
                    ]),
                    "top-left": t.P.convert(e["top-left"] || [
                        0,
                        0
                    ]),
                    "top-right": t.P.convert(e["top-right"] || [
                        0,
                        0
                    ]),
                    bottom: t.P.convert(e.bottom || [
                        0,
                        0
                    ]),
                    "bottom-left": t.P.convert(e["bottom-left"] || [
                        0,
                        0
                    ]),
                    "bottom-right": t.P.convert(e["bottom-right"] || [
                        0,
                        0
                    ]),
                    left: t.P.convert(e.left || [
                        0,
                        0
                    ]),
                    right: t.P.convert(e.right || [
                        0,
                        0
                    ])
                };
            }
            return Ra(new t.P(0, 0));
        }
        const ka = {
            extend: (e, ...i)=>t.e(e, ...i),
            run (t) {
                t();
            },
            logToElement (t, e = !1, i = "log") {
                const s = window.document.getElementById(i);
                s && (e && (s.innerHTML = ""), s.innerHTML += `<br>${t}`);
            }
        }, Fa = e;
        class Ba {
            static get version() {
                return Fa;
            }
            static get workerCount() {
                return tt.workerCount;
            }
            static set workerCount(t) {
                tt.workerCount = t;
            }
            static get maxParallelImageRequests() {
                return t.c.MAX_PARALLEL_IMAGE_REQUESTS;
            }
            static set maxParallelImageRequests(e) {
                t.c.MAX_PARALLEL_IMAGE_REQUESTS = e;
            }
            static get workerUrl() {
                return t.c.WORKER_URL;
            }
            static set workerUrl(e) {
                t.c.WORKER_URL = e;
            }
            static addProtocol(e, i) {
                t.c.REGISTERED_PROTOCOLS[e] = i;
            }
            static removeProtocol(e) {
                delete t.c.REGISTERED_PROTOCOLS[e];
            }
        }
        return Ba.Map = class extends oa {
            constructor(e){
                if (t.bg.mark(t.bh.create), null != (e = t.e({}, ga, e)).minZoom && null != e.maxZoom && e.minZoom > e.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                if (null != e.minPitch && null != e.maxPitch && e.minPitch > e.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                if (null != e.minPitch && e.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                if (null != e.maxPitch && e.maxPitch > 85) throw new Error("maxPitch must be less than or equal to 85");
                if (super(new rs(e.minZoom, e.maxZoom, e.minPitch, e.maxPitch, e.renderWorldCopies), {
                    bearingSnap: e.bearingSnap
                }), this._cooperativeGesturesOnWheel = (t)=>{
                    this._onCooperativeGesture(t, t[this._metaKey], 1);
                }, this._contextLost = (e)=>{
                    e.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.fire(new t.k("webglcontextlost", {
                        originalEvent: e
                    }));
                }, this._contextRestored = (e)=>{
                    this._setupPainter(), this.resize(), this._update(), this.fire(new t.k("webglcontextrestored", {
                        originalEvent: e
                    }));
                }, this._onMapScroll = (t)=>{
                    if (t.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
                }, this._onWindowOnline = ()=>{
                    this._update();
                }, this._interactive = e.interactive, this._cooperativeGestures = e.cooperativeGestures, this._metaKey = 0 === navigator.platform.indexOf("Mac") ? "metaKey" : "ctrlKey", this._maxTileCacheSize = e.maxTileCacheSize, this._maxTileCacheZoomLevels = e.maxTileCacheZoomLevels, this._failIfMajorPerformanceCaveat = e.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = e.preserveDrawingBuffer, this._antialias = e.antialias, this._trackResize = e.trackResize, this._bearingSnap = e.bearingSnap, this._refreshExpiredTiles = e.refreshExpiredTiles, this._fadeDuration = e.fadeDuration, this._crossSourceCollisions = e.crossSourceCollisions, this._crossFadingFactor = 1, this._collectResourceTiming = e.collectResourceTiming, this._renderTaskQueue = new la, this._controls = [], this._mapId = t.a2(), this._locale = t.e({}, ha, e.locale), this._clickTolerance = e.clickTolerance, this._overridePixelRatio = e.pixelRatio, this._maxCanvasSize = e.maxCanvasSize, this.transformCameraUpdate = e.transformCameraUpdate, this._imageQueueHandle = h.addThrottleControl(()=>this.isMoving()), this._requestManager = new u(e.transformRequest), "string" == typeof e.container) {
                    if (this._container = document.getElementById(e.container), !this._container) throw new Error(`Container '${e.container}' not found.`);
                } else {
                    if (!(e.container instanceof HTMLElement)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                    this._container = e.container;
                }
                if (e.maxBounds && this.setMaxBounds(e.maxBounds), this._setupContainer(), this._setupPainter(), this.on("move", ()=>this._update(!1)), this.on("moveend", ()=>this._update(!1)), this.on("zoom", ()=>this._update(!0)), this.on("terrain", ()=>{
                    this.painter.terrainFacilitator.dirty = !0, this._update(!0);
                }), this.once("idle", ()=>{
                    this._idleTriggered = !0;
                }), "undefined" != typeof window) {
                    addEventListener("online", this._onWindowOnline, !1);
                    let t = !1;
                    const e = ns((t)=>{
                        this._trackResize && !this._removed && this.resize(t)._update();
                    }, 50);
                    this._resizeObserver = new ResizeObserver((i)=>{
                        t ? e(i) : t = !0;
                    }), this._resizeObserver.observe(this._container);
                }
                this.handlers = new aa(this, e), this._cooperativeGestures && this._setupCooperativeGestures(), this._hash = e.hash && new ls("string" == typeof e.hash && e.hash || void 0).addTo(this), this._hash && this._hash._onHashChange() || (this.jumpTo({
                    center: e.center,
                    zoom: e.zoom,
                    bearing: e.bearing,
                    pitch: e.pitch
                }), e.bounds && (this.resize(), this.fitBounds(e.bounds, t.e({}, e.fitBoundsOptions, {
                    duration: 0
                })))), this.resize(), this._localIdeographFontFamily = e.localIdeographFontFamily, this._validateStyle = e.validateStyle, e.style && this.setStyle(e.style, {
                    localIdeographFontFamily: e.localIdeographFontFamily
                }), e.attributionControl && this.addControl(new ra({
                    customAttribution: e.customAttribution
                })), e.maplibreLogo && this.addControl(new na, e.logoPosition), this.on("style.load", ()=>{
                    this.transform.unmodified && this.jumpTo(this.style.stylesheet);
                }), this.on("data", (e)=>{
                    this._update("style" === e.dataType), this.fire(new t.k(`${e.dataType}data`, e));
                }), this.on("dataloading", (e)=>{
                    this.fire(new t.k(`${e.dataType}dataloading`, e));
                }), this.on("dataabort", (e)=>{
                    this.fire(new t.k("sourcedataabort", e));
                });
            }
            _getMapId() {
                return this._mapId;
            }
            addControl(e, i) {
                if (void 0 === i && (i = e.getDefaultPosition ? e.getDefaultPosition() : "top-right"), !e || !e.onAdd) return this.fire(new t.j(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                const s = e.onAdd(this);
                this._controls.push(e);
                const a = this._controlPositions[i];
                return -1 !== i.indexOf("bottom") ? a.insertBefore(s, a.firstChild) : a.appendChild(s), this;
            }
            removeControl(e) {
                if (!e || !e.onRemove) return this.fire(new t.j(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                const i = this._controls.indexOf(e);
                return i > -1 && this._controls.splice(i, 1), e.onRemove(this), this;
            }
            hasControl(t) {
                return this._controls.indexOf(t) > -1;
            }
            calculateCameraOptionsFromTo(t, e, i, s) {
                return null == s && this.terrain && (s = this.terrain.getElevationForLngLatZoom(i, this.transform.tileZoom)), super.calculateCameraOptionsFromTo(t, e, i, s);
            }
            resize(e) {
                var i;
                const s = this._containerDimensions(), a = s[0], o = s[1], r = this._getClampedPixelRatio(a, o);
                if (this._resizeCanvas(a, o, r), this.painter.resize(a, o, r), this.painter.overLimit()) {
                    const t = this.painter.context.gl;
                    this._maxCanvasSize = [
                        t.drawingBufferWidth,
                        t.drawingBufferHeight
                    ];
                    const e = this._getClampedPixelRatio(a, o);
                    this._resizeCanvas(a, o, e), this.painter.resize(a, o, e);
                }
                this.transform.resize(a, o), null === (i = this._requestedCameraState) || void 0 === i || i.resize(a, o);
                const n = !this._moving;
                return n && (this.stop(), this.fire(new t.k("movestart", e)).fire(new t.k("move", e))), this.fire(new t.k("resize", e)), n && this.fire(new t.k("moveend", e)), this;
            }
            _getClampedPixelRatio(t, e) {
                const { 0: i, 1: s } = this._maxCanvasSize, a = this.getPixelRatio(), o = t * a, r = e * a;
                return Math.min(o > i ? i / o : 1, r > s ? s / r : 1) * a;
            }
            getPixelRatio() {
                var t;
                return null !== (t = this._overridePixelRatio) && void 0 !== t ? t : devicePixelRatio;
            }
            setPixelRatio(t) {
                this._overridePixelRatio = t, this.resize();
            }
            getBounds() {
                return this.transform.getBounds();
            }
            getMaxBounds() {
                return this.transform.getMaxBounds();
            }
            setMaxBounds(t) {
                return this.transform.setMaxBounds(L.convert(t)), this._update();
            }
            setMinZoom(t) {
                if ((t = null == t ? -2 : t) >= -2 && t <= this.transform.maxZoom) return this.transform.minZoom = t, this._update(), this.getZoom() < t && this.setZoom(t), this;
                throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
            }
            getMinZoom() {
                return this.transform.minZoom;
            }
            setMaxZoom(t) {
                if ((t = null == t ? 22 : t) >= this.transform.minZoom) return this.transform.maxZoom = t, this._update(), this.getZoom() > t && this.setZoom(t), this;
                throw new Error("maxZoom must be greater than the current minZoom");
            }
            getMaxZoom() {
                return this.transform.maxZoom;
            }
            setMinPitch(t) {
                if ((t = null == t ? 0 : t) < 0) throw new Error("minPitch must be greater than or equal to 0");
                if (t >= 0 && t <= this.transform.maxPitch) return this.transform.minPitch = t, this._update(), this.getPitch() < t && this.setPitch(t), this;
                throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
            }
            getMinPitch() {
                return this.transform.minPitch;
            }
            setMaxPitch(t) {
                if ((t = null == t ? 60 : t) > 85) throw new Error("maxPitch must be less than or equal to 85");
                if (t >= this.transform.minPitch) return this.transform.maxPitch = t, this._update(), this.getPitch() > t && this.setPitch(t), this;
                throw new Error("maxPitch must be greater than the current minPitch");
            }
            getMaxPitch() {
                return this.transform.maxPitch;
            }
            getRenderWorldCopies() {
                return this.transform.renderWorldCopies;
            }
            setRenderWorldCopies(t) {
                return this.transform.renderWorldCopies = t, this._update();
            }
            getCooperativeGestures() {
                return this._cooperativeGestures;
            }
            setCooperativeGestures(t) {
                return this._cooperativeGestures = t, this._cooperativeGestures ? this._setupCooperativeGestures() : this._destroyCooperativeGestures(), this;
            }
            project(e) {
                return this.transform.locationPoint(t.L.convert(e), this.style && this.terrain);
            }
            unproject(e) {
                return this.transform.pointLocation(t.P.convert(e), this.terrain);
            }
            isMoving() {
                var t;
                return this._moving || (null === (t = this.handlers) || void 0 === t ? void 0 : t.isMoving());
            }
            isZooming() {
                var t;
                return this._zooming || (null === (t = this.handlers) || void 0 === t ? void 0 : t.isZooming());
            }
            isRotating() {
                var t;
                return this._rotating || (null === (t = this.handlers) || void 0 === t ? void 0 : t.isRotating());
            }
            _createDelegatedListener(t, e, i) {
                if ("mouseenter" === t || "mouseover" === t) {
                    let s = !1;
                    const a = (a)=>{
                        const o = this.getLayer(e) ? this.queryRenderedFeatures(a.point, {
                            layers: [
                                e
                            ]
                        }) : [];
                        o.length ? s || (s = !0, i.call(this, new gs(t, this, a.originalEvent, {
                            features: o
                        }))) : s = !1;
                    };
                    return {
                        layer: e,
                        listener: i,
                        delegates: {
                            mousemove: a,
                            mouseout: ()=>{
                                s = !1;
                            }
                        }
                    };
                }
                if ("mouseleave" === t || "mouseout" === t) {
                    let s = !1;
                    const a = (a)=>{
                        (this.getLayer(e) ? this.queryRenderedFeatures(a.point, {
                            layers: [
                                e
                            ]
                        }) : []).length ? s = !0 : s && (s = !1, i.call(this, new gs(t, this, a.originalEvent)));
                    }, o = (e)=>{
                        s && (s = !1, i.call(this, new gs(t, this, e.originalEvent)));
                    };
                    return {
                        layer: e,
                        listener: i,
                        delegates: {
                            mousemove: a,
                            mouseout: o
                        }
                    };
                }
                {
                    const s = (t)=>{
                        const s = this.getLayer(e) ? this.queryRenderedFeatures(t.point, {
                            layers: [
                                e
                            ]
                        }) : [];
                        s.length && (t.features = s, i.call(this, t), delete t.features);
                    };
                    return {
                        layer: e,
                        listener: i,
                        delegates: {
                            [t]: s
                        }
                    };
                }
            }
            on(t, e, i) {
                if (void 0 === i) return super.on(t, e);
                const s = this._createDelegatedListener(t, e, i);
                this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[t] = this._delegatedListeners[t] || [], this._delegatedListeners[t].push(s);
                for(const t in s.delegates)this.on(t, s.delegates[t]);
                return this;
            }
            once(t, e, i) {
                if (void 0 === i) return super.once(t, e);
                const s = this._createDelegatedListener(t, e, i);
                for(const t in s.delegates)this.once(t, s.delegates[t]);
                return this;
            }
            off(t, e, i) {
                return void 0 === i ? super.off(t, e) : (this._delegatedListeners && this._delegatedListeners[t] && ((s)=>{
                    const a = this._delegatedListeners[t];
                    for(let t = 0; t < a.length; t++){
                        const s = a[t];
                        if (s.layer === e && s.listener === i) {
                            for(const t in s.delegates)this.off(t, s.delegates[t]);
                            return a.splice(t, 1), this;
                        }
                    }
                })(), this);
            }
            queryRenderedFeatures(e, i) {
                if (!this.style) return [];
                let s;
                const a = e instanceof t.P || Array.isArray(e), o = a ? e : [
                    [
                        0,
                        0
                    ],
                    [
                        this.transform.width,
                        this.transform.height
                    ]
                ];
                if (i = i || (a ? {} : e) || {}, o instanceof t.P || "number" == typeof o[0]) s = [
                    t.P.convert(o)
                ];
                else {
                    const e = t.P.convert(o[0]), i = t.P.convert(o[1]);
                    s = [
                        e,
                        new t.P(i.x, e.y),
                        i,
                        new t.P(e.x, i.y),
                        e
                    ];
                }
                return this.style.queryRenderedFeatures(s, i, this.transform);
            }
            querySourceFeatures(t, e) {
                return this.style.querySourceFeatures(t, e);
            }
            setStyle(e, i) {
                return !1 !== (i = t.e({}, {
                    localIdeographFontFamily: this._localIdeographFontFamily,
                    validate: this._validateStyle
                }, i)).diff && i.localIdeographFontFamily === this._localIdeographFontFamily && this.style && e ? (this._diffStyle(e, i), this) : (this._localIdeographFontFamily = i.localIdeographFontFamily, this._updateStyle(e, i));
            }
            setTransformRequest(t) {
                return this._requestManager.setTransformRequest(t), this;
            }
            _getUIString(t) {
                const e = this._locale[t];
                if (null == e) throw new Error(`Missing UI string '${t}'`);
                return e;
            }
            _updateStyle(t, e) {
                if (e.transformStyle && this.style && !this.style._loaded) return void this.style.once("style.load", ()=>this._updateStyle(t, e));
                const i = this.style && e.transformStyle ? this.style.serialize() : void 0;
                return this.style && (this.style.setEventedParent(null), this.style._remove(!t)), t ? (this.style = new se(this, e || {}), this.style.setEventedParent(this, {
                    style: this.style
                }), "string" == typeof t ? this.style.loadURL(t, e, i) : this.style.loadJSON(t, e, i), this) : (delete this.style, this);
            }
            _lazyInitEmptyStyle() {
                this.style || (this.style = new se(this, {}), this.style.setEventedParent(this, {
                    style: this.style
                }), this.style.loadEmpty());
            }
            _diffStyle(e, i) {
                if ("string" == typeof e) {
                    const s = this._requestManager.transformRequest(e, c.Style);
                    t.f(s, (e, s)=>{
                        e ? this.fire(new t.j(e)) : s && this._updateDiff(s, i);
                    });
                } else "object" == typeof e && this._updateDiff(e, i);
            }
            _updateDiff(e, i) {
                try {
                    this.style.setState(e, i) && this._update(!0);
                } catch (s) {
                    t.w(`Unable to perform style diff: ${s.message || s.error || s}.  Rebuilding the style from scratch.`), this._updateStyle(e, i);
                }
            }
            getStyle() {
                if (this.style) return this.style.serialize();
            }
            isStyleLoaded() {
                return this.style ? this.style.loaded() : t.w("There is no style added to the map.");
            }
            addSource(t, e) {
                return this._lazyInitEmptyStyle(), this.style.addSource(t, e), this._update(!0);
            }
            isSourceLoaded(e) {
                const i = this.style && this.style.sourceCaches[e];
                if (void 0 !== i) return i.loaded();
                this.fire(new t.j(new Error(`There is no source with ID '${e}'`)));
            }
            setTerrain(e) {
                if (this.style._checkLoaded(), this._terrainDataCallback && this.style.off("data", this._terrainDataCallback), e) {
                    const i = this.style.sourceCaches[e.source];
                    if (!i) throw new Error(`cannot load terrain, because there exists no source with ID: ${e.source}`);
                    for(const i in this.style._layers){
                        const s = this.style._layers[i];
                        "hillshade" === s.type && s.source === e.source && t.w("You are using the same source for a hillshade layer and for 3D terrain. Please consider using two separate sources to improve rendering quality.");
                    }
                    this.terrain = new da(this.painter, i, e), this.painter.renderToTexture = new ma(this.painter, this.terrain), this.transform._minEleveationForCurrentTile = this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom), this.transform.elevation = this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom), this._terrainDataCallback = (t)=>{
                        "style" === t.dataType ? this.terrain.sourceCache.freeRtt() : "source" === t.dataType && t.tile && (t.sourceId !== e.source || this._elevationFreeze || (this.transform._minEleveationForCurrentTile = this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom), this.transform.elevation = this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), this.terrain.sourceCache.freeRtt(t.tile.tileID));
                    }, this.style.on("data", this._terrainDataCallback);
                } else this.terrain && this.terrain.sourceCache.destruct(), this.terrain = null, this.painter.renderToTexture && this.painter.renderToTexture.destruct(), this.painter.renderToTexture = null, this.transform._minEleveationForCurrentTile = 0, this.transform.elevation = 0;
                return this.fire(new t.k("terrain", {
                    terrain: e
                })), this;
            }
            getTerrain() {
                var t, e;
                return null !== (e = null === (t = this.terrain) || void 0 === t ? void 0 : t.options) && void 0 !== e ? e : null;
            }
            areTilesLoaded() {
                const t = this.style && this.style.sourceCaches;
                for(const e in t){
                    const i = t[e]._tiles;
                    for(const t in i){
                        const e = i[t];
                        if ("loaded" !== e.state && "errored" !== e.state) return !1;
                    }
                }
                return !0;
            }
            addSourceType(t, e, i) {
                return this._lazyInitEmptyStyle(), this.style.addSourceType(t, e, i);
            }
            removeSource(t) {
                return this.style.removeSource(t), this._update(!0);
            }
            getSource(t) {
                return this.style.getSource(t);
            }
            addImage(e, i, s = {}) {
                const { pixelRatio: a = 1, sdf: o = !1, stretchX: r, stretchY: n, content: l } = s;
                if (this._lazyInitEmptyStyle(), !(i instanceof HTMLImageElement || t.a(i))) {
                    if (void 0 === i.width || void 0 === i.height) return this.fire(new t.j(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    {
                        const { width: s, height: h, data: c } = i, u = i;
                        return this.style.addImage(e, {
                            data: new t.R({
                                width: s,
                                height: h
                            }, new Uint8Array(c)),
                            pixelRatio: a,
                            stretchX: r,
                            stretchY: n,
                            content: l,
                            sdf: o,
                            version: 0,
                            userImage: u
                        }), u.onAdd && u.onAdd(this, e), this;
                    }
                }
                {
                    const { width: s, height: h, data: c } = t.h.getImageData(i);
                    this.style.addImage(e, {
                        data: new t.R({
                            width: s,
                            height: h
                        }, c),
                        pixelRatio: a,
                        stretchX: r,
                        stretchY: n,
                        content: l,
                        sdf: o,
                        version: 0
                    });
                }
            }
            updateImage(e, i) {
                const s = this.style.getImage(e);
                if (!s) return this.fire(new t.j(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                const a = i instanceof HTMLImageElement || t.a(i) ? t.h.getImageData(i) : i, { width: o, height: r, data: n } = a;
                if (void 0 === o || void 0 === r) return this.fire(new t.j(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                if (o !== s.data.width || r !== s.data.height) return this.fire(new t.j(new Error("The width and height of the updated image must be that same as the previous version of the image")));
                const l = !(i instanceof HTMLImageElement || t.a(i));
                return s.data.replace(n, l), this.style.updateImage(e, s), this;
            }
            getImage(t) {
                return this.style.getImage(t);
            }
            hasImage(e) {
                return e ? !!this.style.getImage(e) : (this.fire(new t.j(new Error("Missing required image id"))), !1);
            }
            removeImage(t) {
                this.style.removeImage(t);
            }
            loadImage(t, e) {
                h.getImage(this._requestManager.transformRequest(t, c.Image), e);
            }
            listImages() {
                return this.style.listImages();
            }
            addLayer(t, e) {
                return this._lazyInitEmptyStyle(), this.style.addLayer(t, e), this._update(!0);
            }
            moveLayer(t, e) {
                return this.style.moveLayer(t, e), this._update(!0);
            }
            removeLayer(t) {
                return this.style.removeLayer(t), this._update(!0);
            }
            getLayer(t) {
                return this.style.getLayer(t);
            }
            getLayersOrder() {
                return this.style.getLayersOrder();
            }
            setLayerZoomRange(t, e, i) {
                return this.style.setLayerZoomRange(t, e, i), this._update(!0);
            }
            setFilter(t, e, i = {}) {
                return this.style.setFilter(t, e, i), this._update(!0);
            }
            getFilter(t) {
                return this.style.getFilter(t);
            }
            setPaintProperty(t, e, i, s = {}) {
                return this.style.setPaintProperty(t, e, i, s), this._update(!0);
            }
            getPaintProperty(t, e) {
                return this.style.getPaintProperty(t, e);
            }
            setLayoutProperty(t, e, i, s = {}) {
                return this.style.setLayoutProperty(t, e, i, s), this._update(!0);
            }
            getLayoutProperty(t, e) {
                return this.style.getLayoutProperty(t, e);
            }
            setGlyphs(t, e = {}) {
                return this._lazyInitEmptyStyle(), this.style.setGlyphs(t, e), this._update(!0);
            }
            getGlyphs() {
                return this.style.getGlyphsUrl();
            }
            addSprite(t, e, i = {}) {
                return this._lazyInitEmptyStyle(), this.style.addSprite(t, e, i, (t)=>{
                    t || this._update(!0);
                }), this;
            }
            removeSprite(t) {
                return this._lazyInitEmptyStyle(), this.style.removeSprite(t), this._update(!0);
            }
            getSprite() {
                return this.style.getSprite();
            }
            setSprite(t, e = {}) {
                return this._lazyInitEmptyStyle(), this.style.setSprite(t, e, (t)=>{
                    t || this._update(!0);
                }), this;
            }
            setLight(t, e = {}) {
                return this._lazyInitEmptyStyle(), this.style.setLight(t, e), this._update(!0);
            }
            getLight() {
                return this.style.getLight();
            }
            setFeatureState(t, e) {
                return this.style.setFeatureState(t, e), this._update();
            }
            removeFeatureState(t, e) {
                return this.style.removeFeatureState(t, e), this._update();
            }
            getFeatureState(t) {
                return this.style.getFeatureState(t);
            }
            getContainer() {
                return this._container;
            }
            getCanvasContainer() {
                return this._canvasContainer;
            }
            getCanvas() {
                return this._canvas;
            }
            _containerDimensions() {
                let t = 0, e = 0;
                return this._container && (t = this._container.clientWidth || 400, e = this._container.clientHeight || 300), [
                    t,
                    e
                ];
            }
            _setupContainer() {
                const t = this._container;
                t.classList.add("maplibregl-map");
                const e = this._canvasContainer = i.create("div", "maplibregl-canvas-container", t);
                this._interactive && e.classList.add("maplibregl-interactive"), this._canvas = i.create("canvas", "maplibregl-canvas", e), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("tabindex", "0"), this._canvas.setAttribute("aria-label", "Map"), this._canvas.setAttribute("role", "region");
                const s = this._containerDimensions(), a = this._getClampedPixelRatio(s[0], s[1]);
                this._resizeCanvas(s[0], s[1], a);
                const o = this._controlContainer = i.create("div", "maplibregl-control-container", t), r = this._controlPositions = {};
                [
                    "top-left",
                    "top-right",
                    "bottom-left",
                    "bottom-right"
                ].forEach((t)=>{
                    r[t] = i.create("div", `maplibregl-ctrl-${t} `, o);
                }), this._container.addEventListener("scroll", this._onMapScroll, !1);
            }
            _setupCooperativeGestures() {
                this._cooperativeGesturesScreen = i.create("div", "maplibregl-cooperative-gesture-screen", this._container);
                let t = "boolean" != typeof this._cooperativeGestures && this._cooperativeGestures.windowsHelpText ? this._cooperativeGestures.windowsHelpText : "Use Ctrl + scroll to zoom the map";
                0 === navigator.platform.indexOf("Mac") && (t = "boolean" != typeof this._cooperativeGestures && this._cooperativeGestures.macHelpText ? this._cooperativeGestures.macHelpText : "Use \u2318 + scroll to zoom the map"), this._cooperativeGesturesScreen.innerHTML = `\n            <div class="maplibregl-desktop-message">${t}</div>\n            <div class="maplibregl-mobile-message">${"boolean" != typeof this._cooperativeGestures && this._cooperativeGestures.mobileHelpText ? this._cooperativeGestures.mobileHelpText : "Use two fingers to move the map"}</div>\n        `, this._cooperativeGesturesScreen.setAttribute("aria-hidden", "true"), this._canvasContainer.addEventListener("wheel", this._cooperativeGesturesOnWheel, !1), this._canvasContainer.classList.add("maplibregl-cooperative-gestures");
            }
            _destroyCooperativeGestures() {
                i.remove(this._cooperativeGesturesScreen), this._canvasContainer.removeEventListener("wheel", this._cooperativeGesturesOnWheel, !1), this._canvasContainer.classList.remove("maplibregl-cooperative-gestures");
            }
            _resizeCanvas(t, e, i) {
                this._canvas.width = Math.floor(i * t), this._canvas.height = Math.floor(i * e), this._canvas.style.width = `${t}px`, this._canvas.style.height = `${e}px`;
            }
            _setupPainter() {
                const t = {
                    alpha: !0,
                    stencil: !0,
                    depth: !0,
                    failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
                    preserveDrawingBuffer: this._preserveDrawingBuffer,
                    antialias: this._antialias || !1
                };
                let e = null;
                this._canvas.addEventListener("webglcontextcreationerror", (i)=>{
                    e = {
                        requestedAttributes: t
                    }, i && (e.statusMessage = i.statusMessage, e.type = i.type);
                }, {
                    once: !0
                });
                const i = this._canvas.getContext("webgl2", t) || this._canvas.getContext("webgl", t);
                if (!i) {
                    const t = "Failed to initialize WebGL";
                    throw e ? (e.message = t, new Error(JSON.stringify(e))) : new Error(t);
                }
                this.painter = new is(i, this.transform), s.testSupport(i);
            }
            _onCooperativeGesture(t, e, i) {
                return !e && i < 2 && (this._cooperativeGesturesScreen.classList.add("maplibregl-show"), setTimeout(()=>{
                    this._cooperativeGesturesScreen.classList.remove("maplibregl-show");
                }, 100)), !1;
            }
            loaded() {
                return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
            }
            _update(t) {
                return this.style && this.style._loaded ? (this._styleDirty = this._styleDirty || t, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
            }
            _requestRenderFrame(t) {
                return this._update(), this._renderTaskQueue.add(t);
            }
            _cancelRenderFrame(t) {
                this._renderTaskQueue.remove(t);
            }
            _render(e) {
                const i = this._idleTriggered ? this._fadeDuration : 0;
                if (this.painter.context.setDirty(), this.painter.setBaseState(), this._renderTaskQueue.run(e), this._removed) return;
                let s = !1;
                if (this.style && this._styleDirty) {
                    this._styleDirty = !1;
                    const e = this.transform.zoom, a = t.h.now();
                    this.style.zoomHistory.update(e, a);
                    const o = new t.a8(e, {
                        now: a,
                        fadeDuration: i,
                        zoomHistory: this.style.zoomHistory,
                        transition: this.style.getTransition()
                    }), r = o.crossFadingFactor();
                    1 === r && r === this._crossFadingFactor || (s = !0, this._crossFadingFactor = r), this.style.update(o);
                }
                this.style && this._sourcesDirty && (this._sourcesDirty = !1, this.style._updateSources(this.transform)), this.terrain ? (this.terrain.sourceCache.update(this.transform, this.terrain), this.transform._minEleveationForCurrentTile = this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom), this._elevationFreeze || (this.transform.elevation = this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom))) : (this.transform._minEleveationForCurrentTile = 0, this.transform.elevation = 0), this._placementDirty = this.style && this.style._updatePlacement(this.painter.transform, this.showCollisionBoxes, i, this._crossSourceCollisions), this.painter.render(this.style, {
                    showTileBoundaries: this.showTileBoundaries,
                    showOverdrawInspector: this._showOverdrawInspector,
                    rotating: this.isRotating(),
                    zooming: this.isZooming(),
                    moving: this.isMoving(),
                    fadeDuration: i,
                    showPadding: this.showPadding
                }), this.fire(new t.k("render")), this.loaded() && !this._loaded && (this._loaded = !0, t.bg.mark(t.bh.load), this.fire(new t.k("load"))), this.style && (this.style.hasTransitions() || s) && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles();
                const a = this._sourcesDirty || this._styleDirty || this._placementDirty;
                return a || this._repaint ? this.triggerRepaint() : !this.isMoving() && this.loaded() && this.fire(new t.k("idle")), !this._loaded || this._fullyLoaded || a || (this._fullyLoaded = !0, t.bg.mark(t.bh.fullLoad)), this;
            }
            redraw() {
                return this.style && (this._frame && (this._frame.cancel(), this._frame = null), this._render(0)), this;
            }
            remove() {
                var e;
                this._hash && this._hash.remove();
                for (const t of this._controls)t.onRemove(this);
                this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this.painter.destroy(), this.handlers.destroy(), delete this.handlers, this.setStyle(null), "undefined" != typeof window && removeEventListener("online", this._onWindowOnline, !1), h.removeThrottleControl(this._imageQueueHandle), null === (e = this._resizeObserver) || void 0 === e || e.disconnect();
                const s = this.painter.context.gl.getExtension("WEBGL_lose_context");
                s && s.loseContext(), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.removeEventListener("webglcontextlost", this._contextLost, !1), i.remove(this._canvasContainer), i.remove(this._controlContainer), this._cooperativeGestures && this._destroyCooperativeGestures(), this._container.classList.remove("maplibregl-map"), t.bg.clearMetrics(), this._removed = !0, this.fire(new t.k("remove"));
            }
            triggerRepaint() {
                this.style && !this._frame && (this._frame = t.h.frame((e)=>{
                    t.bg.frame(e), this._frame = null, this._render(e);
                }));
            }
            get showTileBoundaries() {
                return !!this._showTileBoundaries;
            }
            set showTileBoundaries(t) {
                this._showTileBoundaries !== t && (this._showTileBoundaries = t, this._update());
            }
            get showPadding() {
                return !!this._showPadding;
            }
            set showPadding(t) {
                this._showPadding !== t && (this._showPadding = t, this._update());
            }
            get showCollisionBoxes() {
                return !!this._showCollisionBoxes;
            }
            set showCollisionBoxes(t) {
                this._showCollisionBoxes !== t && (this._showCollisionBoxes = t, t ? this.style._generateCollisionBoxes() : this._update());
            }
            get showOverdrawInspector() {
                return !!this._showOverdrawInspector;
            }
            set showOverdrawInspector(t) {
                this._showOverdrawInspector !== t && (this._showOverdrawInspector = t, this._update());
            }
            get repaint() {
                return !!this._repaint;
            }
            set repaint(t) {
                this._repaint !== t && (this._repaint = t, this.triggerRepaint());
            }
            get vertices() {
                return !!this._vertices;
            }
            set vertices(t) {
                this._vertices = t, this._update();
            }
            get version() {
                return fa;
            }
            getCameraTargetElevation() {
                return this.transform.elevation;
            }
        }, Ba.NavigationControl = class {
            constructor(e){
                this._updateZoomButtons = ()=>{
                    const t = this._map.getZoom(), e = t === this._map.getMaxZoom(), i = t === this._map.getMinZoom();
                    this._zoomInButton.disabled = e, this._zoomOutButton.disabled = i, this._zoomInButton.setAttribute("aria-disabled", e.toString()), this._zoomOutButton.setAttribute("aria-disabled", i.toString());
                }, this._rotateCompassArrow = ()=>{
                    const t = this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(this._map.transform.pitch * (Math.PI / 180)), .5)}) rotateX(${this._map.transform.pitch}deg) rotateZ(${this._map.transform.angle * (180 / Math.PI)}deg)` : `rotate(${this._map.transform.angle * (180 / Math.PI)}deg)`;
                    this._compassIcon.style.transform = t;
                }, this._setButtonTitle = (t, e)=>{
                    const i = this._map._getUIString(`NavigationControl.${e}`);
                    t.title = i, t.setAttribute("aria-label", i);
                }, this.options = t.e({}, xa, e), this._container = i.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._container.addEventListener("contextmenu", (t)=>t.preventDefault()), this.options.showZoom && (this._zoomInButton = this._createButton("maplibregl-ctrl-zoom-in", (t)=>this._map.zoomIn({}, {
                        originalEvent: t
                    })), i.create("span", "maplibregl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("maplibregl-ctrl-zoom-out", (t)=>this._map.zoomOut({}, {
                        originalEvent: t
                    })), i.create("span", "maplibregl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (this._compass = this._createButton("maplibregl-ctrl-compass", (t)=>{
                    this.options.visualizePitch ? this._map.resetNorthPitch({}, {
                        originalEvent: t
                    }) : this._map.resetNorth({}, {
                        originalEvent: t
                    });
                }), this._compassIcon = i.create("span", "maplibregl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
            }
            onAdd(t) {
                return this._map = t, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), this._map.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && this._map.on("pitch", this._rotateCompassArrow), this._map.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new ya(this._map, this._compass, this.options.visualizePitch)), this._container;
            }
            onRemove() {
                i.remove(this._container), this.options.showZoom && this._map.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && this._map.off("pitch", this._rotateCompassArrow), this._map.off("rotate", this._rotateCompassArrow), this._handler.off(), delete this._handler), delete this._map;
            }
            _createButton(t, e) {
                const s = i.create("button", t, this._container);
                return s.type = "button", s.addEventListener("click", e), s;
            }
        }, Ba.GeolocateControl = class extends t.E {
            constructor(e){
                super(), this._onSuccess = (e)=>{
                    if (this._map) {
                        if (this._isOutOfMapMaxBounds(e)) return this._setErrorState(), this.fire(new t.k("outofmaxbounds", e)), this._updateMarker(), void this._finish();
                        if (this.options.trackUserLocation) switch(this._lastKnownPosition = e, this._watchState){
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                                break;
                            case "BACKGROUND":
                            case "BACKGROUND_ERROR":
                                this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background");
                                break;
                            default:
                                throw new Error(`Unexpected watchState ${this._watchState}`);
                        }
                        this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(e), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(e), this.options.showUserLocation && this._dotElement.classList.remove("maplibregl-user-location-dot-stale"), this.fire(new t.k("geolocate", e)), this._finish();
                    }
                }, this._updateCamera = (e)=>{
                    const i = new t.L(e.coords.longitude, e.coords.latitude), s = e.coords.accuracy, a = this._map.getBearing(), o = t.e({
                        bearing: a
                    }, this.options.fitBoundsOptions), r = L.fromLngLat(i, s);
                    this._map.fitBounds(r, o, {
                        geolocateSource: !0
                    });
                }, this._updateMarker = (e)=>{
                    if (e) {
                        const i = new t.L(e.coords.longitude, e.coords.latitude);
                        this._accuracyCircleMarker.setLngLat(i).addTo(this._map), this._userLocationDotMarker.setLngLat(i).addTo(this._map), this._accuracy = e.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                    } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
                }, this._onZoom = ()=>{
                    this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                }, this._onError = (e)=>{
                    if (this._map) {
                        if (this.options.trackUserLocation) {
                            if (1 === e.code) {
                                this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                                const t = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                this._geolocateButton.title = t, this._geolocateButton.setAttribute("aria-label", t), void 0 !== this._geolocationWatchID && this._clearWatch();
                            } else {
                                if (3 === e.code && Pa) return;
                                this._setErrorState();
                            }
                        }
                        "OFF" !== this._watchState && this.options.showUserLocation && this._dotElement.classList.add("maplibregl-user-location-dot-stale"), this.fire(new t.k("error", e)), this._finish();
                    }
                }, this._finish = ()=>{
                    this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
                }, this._setupUI = (e)=>{
                    if (this._map) {
                        if (this._container.addEventListener("contextmenu", (t)=>t.preventDefault()), this._geolocateButton = i.create("button", "maplibregl-ctrl-geolocate", this._container), i.create("span", "maplibregl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", !1 === e) {
                            t.w("Geolocation support is not available so the GeolocateControl will be disabled.");
                            const e = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                            this._geolocateButton.disabled = !0, this._geolocateButton.title = e, this._geolocateButton.setAttribute("aria-label", e);
                        } else {
                            const t = this._map._getUIString("GeolocateControl.FindMyLocation");
                            this._geolocateButton.title = t, this._geolocateButton.setAttribute("aria-label", t);
                        }
                        this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = i.create("div", "maplibregl-user-location-dot"), this._userLocationDotMarker = new Ea({
                            element: this._dotElement
                        }), this._circleElement = i.create("div", "maplibregl-user-location-accuracy-circle"), this._accuracyCircleMarker = new Ea({
                            element: this._circleElement,
                            pitchAlignment: "map"
                        }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", (e)=>{
                            e.geolocateSource || "ACTIVE_LOCK" !== this._watchState || e.originalEvent && "resize" === e.originalEvent.type || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this.fire(new t.k("trackuserlocationend")));
                        });
                    }
                }, this.options = t.e({}, Sa, e);
            }
            onAdd(t) {
                return this._map = t, this._container = i.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), function(t, e = !1) {
                    void 0 === ba || e ? void 0 !== window.navigator.permissions ? window.navigator.permissions.query({
                        name: "geolocation"
                    }).then((e)=>{
                        ba = "denied" !== e.state, t(ba);
                    }).catch(()=>{
                        ba = !!window.navigator.geolocation, t(ba);
                    }) : (ba = !!window.navigator.geolocation, t(ba)) : t(ba);
                }(this._setupUI), this._container;
            }
            onRemove() {
                void 0 !== this._geolocationWatchID && (window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), i.remove(this._container), this._map.off("zoom", this._onZoom), this._map = void 0, Ca = 0, Pa = !1;
            }
            _isOutOfMapMaxBounds(t) {
                const e = this._map.getMaxBounds(), i = t.coords;
                return e && (i.longitude < e.getWest() || i.longitude > e.getEast() || i.latitude < e.getSouth() || i.latitude > e.getNorth());
            }
            _setErrorState() {
                switch(this._watchState){
                    case "WAITING_ACTIVE":
                        this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error");
                        break;
                    case "ACTIVE_LOCK":
                        this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                        break;
                    case "BACKGROUND":
                        this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                        break;
                    case "ACTIVE_ERROR":
                        break;
                    default:
                        throw new Error(`Unexpected watchState ${this._watchState}`);
                }
            }
            _updateCircleRadius() {
                const t = this._map.getBounds(), e = t.getSouthEast(), i = t.getNorthEast(), s = e.distanceTo(i), a = Math.ceil(this._accuracy / (s / this._map._container.clientHeight) * 2);
                this._circleElement.style.width = `${a}px`, this._circleElement.style.height = `${a}px`;
            }
            trigger() {
                if (!this._setup) return t.w("Geolocate control triggered before added to a map"), !1;
                if (this.options.trackUserLocation) {
                    switch(this._watchState){
                        case "OFF":
                            this._watchState = "WAITING_ACTIVE", this.fire(new t.k("trackuserlocationstart"));
                            break;
                        case "WAITING_ACTIVE":
                        case "ACTIVE_LOCK":
                        case "ACTIVE_ERROR":
                        case "BACKGROUND_ERROR":
                            Ca--, Pa = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this.fire(new t.k("trackuserlocationend"));
                            break;
                        case "BACKGROUND":
                            this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new t.k("trackuserlocationstart"));
                            break;
                        default:
                            throw new Error(`Unexpected watchState ${this._watchState}`);
                    }
                    switch(this._watchState){
                        case "WAITING_ACTIVE":
                            this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                            break;
                        case "ACTIVE_LOCK":
                            this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                            break;
                        case "OFF":
                            break;
                        default:
                            throw new Error(`Unexpected watchState ${this._watchState}`);
                    }
                    if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                    else if (void 0 === this._geolocationWatchID) {
                        let t;
                        this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), Ca++, Ca > 1 ? (t = {
                            maximumAge: 6e5,
                            timeout: 0
                        }, Pa = !0) : (t = this.options.positionOptions, Pa = !1), this._geolocationWatchID = window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, t);
                    }
                } else window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
                return !0;
            }
            _clearWatch() {
                window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
            }
        }, Ba.AttributionControl = ra, Ba.LogoControl = na, Ba.ScaleControl = class {
            constructor(e){
                this._onMove = ()=>{
                    Ma(this._map, this._container, this.options);
                }, this.setUnit = (t)=>{
                    this.options.unit = t, Ma(this._map, this._container, this.options);
                }, this.options = t.e({}, Da, e);
            }
            getDefaultPosition() {
                return "bottom-left";
            }
            onAdd(t) {
                return this._map = t, this._container = i.create("div", "maplibregl-ctrl maplibregl-ctrl-scale", t.getContainer()), this._map.on("move", this._onMove), this._onMove(), this._container;
            }
            onRemove() {
                i.remove(this._container), this._map.off("move", this._onMove), this._map = void 0;
            }
        }, Ba.FullscreenControl = class extends t.E {
            constructor(e = {}){
                super(), this._onFullscreenChange = ()=>{
                    (window.document.fullscreenElement || window.document.mozFullScreenElement || window.document.webkitFullscreenElement || window.document.msFullscreenElement) === this._container !== this._fullscreen && this._handleFullscreenChange();
                }, this._onClickFullscreen = ()=>{
                    this._isFullscreen() ? this._exitFullscreen() : this._requestFullscreen();
                }, this._fullscreen = !1, e && e.container && (e.container instanceof HTMLElement ? this._container = e.container : t.w("Full screen control 'container' must be a DOM element.")), "onfullscreenchange" in document ? this._fullscreenchange = "fullscreenchange" : "onmozfullscreenchange" in document ? this._fullscreenchange = "mozfullscreenchange" : "onwebkitfullscreenchange" in document ? this._fullscreenchange = "webkitfullscreenchange" : "onmsfullscreenchange" in document && (this._fullscreenchange = "MSFullscreenChange");
            }
            onAdd(t) {
                return this._map = t, this._container || (this._container = this._map.getContainer()), this._controlContainer = i.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._setupUI(), this._controlContainer;
            }
            onRemove() {
                i.remove(this._controlContainer), this._map = null, window.document.removeEventListener(this._fullscreenchange, this._onFullscreenChange);
            }
            _setupUI() {
                const t = this._fullscreenButton = i.create("button", "maplibregl-ctrl-fullscreen", this._controlContainer);
                i.create("span", "maplibregl-ctrl-icon", t).setAttribute("aria-hidden", "true"), t.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), window.document.addEventListener(this._fullscreenchange, this._onFullscreenChange);
            }
            _updateTitle() {
                const t = this._getTitle();
                this._fullscreenButton.setAttribute("aria-label", t), this._fullscreenButton.title = t;
            }
            _getTitle() {
                return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
            }
            _isFullscreen() {
                return this._fullscreen;
            }
            _handleFullscreenChange() {
                this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("maplibregl-ctrl-shrink"), this._fullscreenButton.classList.toggle("maplibregl-ctrl-fullscreen"), this._updateTitle(), this._fullscreen ? (this.fire(new t.k("fullscreenstart")), this._map._cooperativeGestures && (this._prevCooperativeGestures = this._map._cooperativeGestures, this._map.setCooperativeGestures())) : (this.fire(new t.k("fullscreenend")), this._prevCooperativeGestures && (this._map.setCooperativeGestures(this._prevCooperativeGestures), delete this._prevCooperativeGestures));
            }
            _exitFullscreen() {
                window.document.exitFullscreen ? window.document.exitFullscreen() : window.document.mozCancelFullScreen ? window.document.mozCancelFullScreen() : window.document.msExitFullscreen ? window.document.msExitFullscreen() : window.document.webkitCancelFullScreen ? window.document.webkitCancelFullScreen() : this._togglePseudoFullScreen();
            }
            _requestFullscreen() {
                this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.mozRequestFullScreen ? this._container.mozRequestFullScreen() : this._container.msRequestFullscreen ? this._container.msRequestFullscreen() : this._container.webkitRequestFullscreen ? this._container.webkitRequestFullscreen() : this._togglePseudoFullScreen();
            }
            _togglePseudoFullScreen() {
                this._container.classList.toggle("maplibregl-pseudo-fullscreen"), this._handleFullscreenChange(), this._map.resize();
            }
        }, Ba.TerrainControl = class {
            constructor(t){
                this._toggleTerrain = ()=>{
                    this._map.getTerrain() ? this._map.setTerrain(null) : this._map.setTerrain(this.options), this._updateTerrainIcon();
                }, this._updateTerrainIcon = ()=>{
                    this._terrainButton.classList.remove("maplibregl-ctrl-terrain"), this._terrainButton.classList.remove("maplibregl-ctrl-terrain-enabled"), this._map.terrain ? (this._terrainButton.classList.add("maplibregl-ctrl-terrain-enabled"), this._terrainButton.title = this._map._getUIString("TerrainControl.disableTerrain")) : (this._terrainButton.classList.add("maplibregl-ctrl-terrain"), this._terrainButton.title = this._map._getUIString("TerrainControl.enableTerrain"));
                }, this.options = t;
            }
            onAdd(t) {
                return this._map = t, this._container = i.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._terrainButton = i.create("button", "maplibregl-ctrl-terrain", this._container), i.create("span", "maplibregl-ctrl-icon", this._terrainButton).setAttribute("aria-hidden", "true"), this._terrainButton.type = "button", this._terrainButton.addEventListener("click", this._toggleTerrain), this._updateTerrainIcon(), this._map.on("terrain", this._updateTerrainIcon), this._container;
            }
            onRemove() {
                i.remove(this._container), this._map.off("terrain", this._updateTerrainIcon), this._map = void 0;
            }
        }, Ba.Popup = class extends t.E {
            constructor(e){
                super(), this.remove = ()=>(this._content && i.remove(this._content), this._container && (i.remove(this._container), delete this._container), this._map && (this._map.off("move", this._update), this._map.off("move", this._onClose), this._map.off("click", this._onClose), this._map.off("remove", this.remove), this._map.off("mousemove", this._onMouseMove), this._map.off("mouseup", this._onMouseUp), this._map.off("drag", this._onDrag), delete this._map), this.fire(new t.k("close")), this), this._onMouseUp = (t)=>{
                    this._update(t.point);
                }, this._onMouseMove = (t)=>{
                    this._update(t.point);
                }, this._onDrag = (t)=>{
                    this._update(t.point);
                }, this._update = (t)=>{
                    if (!this._map || !this._lngLat && !this._trackPointer || !this._content) return;
                    if (!this._container) {
                        if (this._container = i.create("div", "maplibregl-popup", this._map.getContainer()), this._tip = i.create("div", "maplibregl-popup-tip", this._container), this._container.appendChild(this._content), this.options.className) for (const t of this.options.className.split(" "))this._container.classList.add(t);
                        this._trackPointer && this._container.classList.add("maplibregl-popup-track-pointer");
                    }
                    if (this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth && (this._container.style.maxWidth = this.options.maxWidth), this._map.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = wa(this._lngLat, this._pos, this._map.transform)), this._trackPointer && !t) return;
                    const e = this._pos = this._trackPointer && t ? t : this._map.project(this._lngLat);
                    let s = this.options.anchor;
                    const a = Ra(this.options.offset);
                    if (!s) {
                        const t = this._container.offsetWidth, i = this._container.offsetHeight;
                        let o;
                        o = e.y + a.bottom.y < i ? [
                            "top"
                        ] : e.y > this._map.transform.height - i ? [
                            "bottom"
                        ] : [], e.x < t / 2 ? o.push("left") : e.x > this._map.transform.width - t / 2 && o.push("right"), s = 0 === o.length ? "bottom" : o.join("-");
                    }
                    const o = e.add(a[s]).round();
                    i.setTransform(this._container, `${Ta[s]} translate(${o.x}px,${o.y}px)`), Ia(this._container, s, "popup");
                }, this._onClose = ()=>{
                    this.remove();
                }, this.options = t.e(Object.create(La), e);
            }
            addTo(e) {
                return this._map && this.remove(), this._map = e, this.options.closeOnClick && this._map.on("click", this._onClose), this.options.closeOnMove && this._map.on("move", this._onClose), this._map.on("remove", this.remove), this._update(), this._focusFirstElement(), this._trackPointer ? (this._map.on("mousemove", this._onMouseMove), this._map.on("mouseup", this._onMouseUp), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")) : this._map.on("move", this._update), this.fire(new t.k("open")), this;
            }
            isOpen() {
                return !!this._map;
            }
            getLngLat() {
                return this._lngLat;
            }
            setLngLat(e) {
                return this._lngLat = t.L.convert(e), this._pos = null, this._trackPointer = !1, this._update(), this._map && (this._map.on("move", this._update), this._map.off("mousemove", this._onMouseMove), this._container && this._container.classList.remove("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.remove("maplibregl-track-pointer")), this;
            }
            trackPointer() {
                return this._trackPointer = !0, this._pos = null, this._update(), this._map && (this._map.off("move", this._update), this._map.on("mousemove", this._onMouseMove), this._map.on("drag", this._onDrag), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")), this;
            }
            getElement() {
                return this._container;
            }
            setText(t) {
                return this.setDOMContent(document.createTextNode(t));
            }
            setHTML(t) {
                const e = document.createDocumentFragment(), i = document.createElement("body");
                let s;
                for(i.innerHTML = t; s = i.firstChild, s;)e.appendChild(s);
                return this.setDOMContent(e);
            }
            getMaxWidth() {
                var t;
                return null === (t = this._container) || void 0 === t ? void 0 : t.style.maxWidth;
            }
            setMaxWidth(t) {
                return this.options.maxWidth = t, this._update(), this;
            }
            setDOMContent(t) {
                if (this._content) for(; this._content.hasChildNodes();)this._content.firstChild && this._content.removeChild(this._content.firstChild);
                else this._content = i.create("div", "maplibregl-popup-content", this._container);
                return this._content.appendChild(t), this._createCloseButton(), this._update(), this._focusFirstElement(), this;
            }
            addClassName(t) {
                this._container && this._container.classList.add(t);
            }
            removeClassName(t) {
                this._container && this._container.classList.remove(t);
            }
            setOffset(t) {
                return this.options.offset = t, this._update(), this;
            }
            toggleClassName(t) {
                if (this._container) return this._container.classList.toggle(t);
            }
            _createCloseButton() {
                this.options.closeButton && (this._closeButton = i.create("button", "maplibregl-popup-close-button", this._content), this._closeButton.type = "button", this._closeButton.setAttribute("aria-label", "Close popup"), this._closeButton.innerHTML = "&#215;", this._closeButton.addEventListener("click", this._onClose));
            }
            _focusFirstElement() {
                if (!this.options.focusAfterOpen || !this._container) return;
                const t = this._container.querySelector(Aa);
                t && t.focus();
            }
        }, Ba.Marker = Ea, Ba.Style = se, Ba.LngLat = t.L, Ba.LngLatBounds = L, Ba.Point = t.P, Ba.MercatorCoordinate = t.U, Ba.Evented = t.E, Ba.AJAXError = t.bi, Ba.config = t.c, Ba.CanvasSource = Z, Ba.GeoJSONSource = B, Ba.ImageSource = N, Ba.RasterDEMTileSource = F, Ba.RasterTileSource = k, Ba.VectorTileSource = R, Ba.VideoSource = U, Ba.setRTLTextPlugin = t.bj, Ba.getRTLTextPluginStatus = t.bk, Ba.prewarm = function() {
            st().acquire(J);
        }, Ba.clearPrewarmedResources = function() {
            const t = it;
            t && (t.isPreloaded() && 1 === t.numActive() ? (t.release(J), it = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
        }, ka.extend(Ba, {
            isSafari: t.ac,
            getPerformanceMetrics: t.bg.getPerformanceMetrics
        }), Ba;
    });
    //
    // Our custom intro provides a specialized "define()" function, called by the
    // AMD modules below, that sets up the worker blob URL and then executes the
    // main module, storing its exported value as 'maplibregl'
    var maplibregl$1 = maplibregl;
    return maplibregl$1;
});

});


var $kxTYF = parcelRequire("kxTYF");

var $8v0nu = parcelRequire("8v0nu");
var $70200245338e5781$export$882461b6382ed46c;
var $70200245338e5781$export$757ceba2d55c277e;
"use strict";
var $e95e39c2a873bfa2$exports = {};
"use strict";
function $e95e39c2a873bfa2$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($e95e39c2a873bfa2$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$e95e39c2a873bfa2$var$checkDCE();

$e95e39c2a873bfa2$exports = (parcelRequire("fgsO0"));


var $70200245338e5781$var$i;
$70200245338e5781$export$882461b6382ed46c = $e95e39c2a873bfa2$exports.createRoot;
$70200245338e5781$export$757ceba2d55c277e = $e95e39c2a873bfa2$exports.hydrateRoot;


/**
 * React Router DOM v6.27.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8v0nu = parcelRequire("8v0nu");

/**
 * @remix-run/router v1.20.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $318e60a76c97e9b3$var$_extends() {
    $318e60a76c97e9b3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $318e60a76c97e9b3$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $318e60a76c97e9b3$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($318e60a76c97e9b3$export$e19cd5f9376f8cee || ($318e60a76c97e9b3$export$e19cd5f9376f8cee = {}));
const $318e60a76c97e9b3$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $318e60a76c97e9b3$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $318e60a76c97e9b3$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $318e60a76c97e9b3$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $318e60a76c97e9b3$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $318e60a76c97e9b3$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $318e60a76c97e9b3$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $318e60a76c97e9b3$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $318e60a76c97e9b3$export$fe53371bee54353d(to);
    }
    return $318e60a76c97e9b3$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $318e60a76c97e9b3$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $318e60a76c97e9b3$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $318e60a76c97e9b3$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $318e60a76c97e9b3$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $318e60a76c97e9b3$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $318e60a76c97e9b3$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $318e60a76c97e9b3$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $318e60a76c97e9b3$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $318e60a76c97e9b3$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $318e60a76c97e9b3$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $318e60a76c97e9b3$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $318e60a76c97e9b3$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $318e60a76c97e9b3$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $318e60a76c97e9b3$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $318e60a76c97e9b3$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $318e60a76c97e9b3$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $318e60a76c97e9b3$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($318e60a76c97e9b3$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Push;
        let location = $318e60a76c97e9b3$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $318e60a76c97e9b3$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Replace;
        let location = $318e60a76c97e9b3$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $318e60a76c97e9b3$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $318e60a76c97e9b3$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $318e60a76c97e9b3$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($318e60a76c97e9b3$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($318e60a76c97e9b3$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $318e60a76c97e9b3$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($318e60a76c97e9b3$var$ResultType || ($318e60a76c97e9b3$var$ResultType = {}));
const $318e60a76c97e9b3$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $318e60a76c97e9b3$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $318e60a76c97e9b3$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $318e60a76c97e9b3$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $318e60a76c97e9b3$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($318e60a76c97e9b3$var$isIndexRoute(route)) {
            let indexRoute = $318e60a76c97e9b3$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $318e60a76c97e9b3$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $318e60a76c97e9b3$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $318e60a76c97e9b3$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $318e60a76c97e9b3$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $318e60a76c97e9b3$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $318e60a76c97e9b3$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $318e60a76c97e9b3$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $318e60a76c97e9b3$var$flattenRoutes(routes);
    $318e60a76c97e9b3$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $318e60a76c97e9b3$export$30d21fd6d7295f52(pathname);
        matches = $318e60a76c97e9b3$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $318e60a76c97e9b3$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $318e60a76c97e9b3$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $318e60a76c97e9b3$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $318e60a76c97e9b3$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $318e60a76c97e9b3$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $318e60a76c97e9b3$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $318e60a76c97e9b3$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $318e60a76c97e9b3$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $318e60a76c97e9b3$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $318e60a76c97e9b3$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $318e60a76c97e9b3$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $318e60a76c97e9b3$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $318e60a76c97e9b3$var$paramRe = /^:[\w-]+$/;
const $318e60a76c97e9b3$var$dynamicSegmentValue = 3;
const $318e60a76c97e9b3$var$indexRouteValue = 2;
const $318e60a76c97e9b3$var$emptySegmentValue = 1;
const $318e60a76c97e9b3$var$staticSegmentValue = 10;
const $318e60a76c97e9b3$var$splatPenalty = -2;
const $318e60a76c97e9b3$var$isSplat = (s)=>s === "*";
function $318e60a76c97e9b3$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($318e60a76c97e9b3$var$isSplat)) initialScore += $318e60a76c97e9b3$var$splatPenalty;
    if (index) initialScore += $318e60a76c97e9b3$var$indexRouteValue;
    return segments.filter((s)=>!$318e60a76c97e9b3$var$isSplat(s)).reduce((score, segment)=>score + ($318e60a76c97e9b3$var$paramRe.test(segment) ? $318e60a76c97e9b3$var$dynamicSegmentValue : segment === "" ? $318e60a76c97e9b3$var$emptySegmentValue : $318e60a76c97e9b3$var$staticSegmentValue), initialScore);
}
function $318e60a76c97e9b3$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $318e60a76c97e9b3$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $318e60a76c97e9b3$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $318e60a76c97e9b3$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $318e60a76c97e9b3$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $318e60a76c97e9b3$export$a5c6d149b50c1d86($318e60a76c97e9b3$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $318e60a76c97e9b3$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $318e60a76c97e9b3$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $318e60a76c97e9b3$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $318e60a76c97e9b3$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $318e60a76c97e9b3$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $318e60a76c97e9b3$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $318e60a76c97e9b3$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $318e60a76c97e9b3$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $318e60a76c97e9b3$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $318e60a76c97e9b3$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $318e60a76c97e9b3$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $318e60a76c97e9b3$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $318e60a76c97e9b3$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $318e60a76c97e9b3$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $318e60a76c97e9b3$var$normalizeSearch(search),
        hash: $318e60a76c97e9b3$var$normalizeHash(hash)
    };
}
function $318e60a76c97e9b3$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $318e60a76c97e9b3$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $318e60a76c97e9b3$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $318e60a76c97e9b3$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $318e60a76c97e9b3$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $318e60a76c97e9b3$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $318e60a76c97e9b3$export$8ccf933b0513f8d0(toArg);
    else {
        to = $318e60a76c97e9b3$var$_extends({}, toArg);
        $318e60a76c97e9b3$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $318e60a76c97e9b3$var$getInvalidPathError("?", "pathname", "search", to));
        $318e60a76c97e9b3$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $318e60a76c97e9b3$var$getInvalidPathError("#", "pathname", "hash", to));
        $318e60a76c97e9b3$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $318e60a76c97e9b3$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $318e60a76c97e9b3$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $318e60a76c97e9b3$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $318e60a76c97e9b3$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $318e60a76c97e9b3$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $318e60a76c97e9b3$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $318e60a76c97e9b3$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $318e60a76c97e9b3$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $318e60a76c97e9b3$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $318e60a76c97e9b3$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $318e60a76c97e9b3$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $318e60a76c97e9b3$export$4051a07651545597(data, init) {
    return new $318e60a76c97e9b3$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $318e60a76c97e9b3$export$42a99a7a4bc0e76a extends Error {
}
class $318e60a76c97e9b3$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $318e60a76c97e9b3$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $318e60a76c97e9b3$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $318e60a76c97e9b3$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $318e60a76c97e9b3$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $318e60a76c97e9b3$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $318e60a76c97e9b3$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $318e60a76c97e9b3$var$unwrapTrackedPromise(value) {
    if (!$318e60a76c97e9b3$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $318e60a76c97e9b3$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $318e60a76c97e9b3$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $318e60a76c97e9b3$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $318e60a76c97e9b3$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $318e60a76c97e9b3$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $318e60a76c97e9b3$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $318e60a76c97e9b3$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $318e60a76c97e9b3$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $318e60a76c97e9b3$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $318e60a76c97e9b3$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $318e60a76c97e9b3$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $318e60a76c97e9b3$var$validMutationMethods = new Set($318e60a76c97e9b3$var$validMutationMethodsArr);
const $318e60a76c97e9b3$var$validRequestMethodsArr = [
    "get",
    ...$318e60a76c97e9b3$var$validMutationMethodsArr
];
const $318e60a76c97e9b3$var$validRequestMethods = new Set($318e60a76c97e9b3$var$validRequestMethodsArr);
const $318e60a76c97e9b3$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $318e60a76c97e9b3$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $318e60a76c97e9b3$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $318e60a76c97e9b3$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $318e60a76c97e9b3$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $318e60a76c97e9b3$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $318e60a76c97e9b3$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $318e60a76c97e9b3$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $318e60a76c97e9b3$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $318e60a76c97e9b3$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $318e60a76c97e9b3$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $318e60a76c97e9b3$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $318e60a76c97e9b3$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $318e60a76c97e9b3$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $318e60a76c97e9b3$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $318e60a76c97e9b3$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $318e60a76c97e9b3$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$318e60a76c97e9b3$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$318e60a76c97e9b3$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $318e60a76c97e9b3$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $318e60a76c97e9b3$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $318e60a76c97e9b3$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $318e60a76c97e9b3$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$318e60a76c97e9b3$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($318e60a76c97e9b3$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $318e60a76c97e9b3$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $318e60a76c97e9b3$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $318e60a76c97e9b3$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $318e60a76c97e9b3$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $318e60a76c97e9b3$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $318e60a76c97e9b3$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $318e60a76c97e9b3$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $318e60a76c97e9b3$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $318e60a76c97e9b3$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($318e60a76c97e9b3$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $318e60a76c97e9b3$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $318e60a76c97e9b3$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $318e60a76c97e9b3$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $318e60a76c97e9b3$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $318e60a76c97e9b3$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $318e60a76c97e9b3$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $318e60a76c97e9b3$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $318e60a76c97e9b3$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $318e60a76c97e9b3$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $318e60a76c97e9b3$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $318e60a76c97e9b3$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $318e60a76c97e9b3$var$findNearestBoundary(matches).route.id,
            {
                type: $318e60a76c97e9b3$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $318e60a76c97e9b3$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($318e60a76c97e9b3$var$isErrorResult(result) && $318e60a76c97e9b3$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $318e60a76c97e9b3$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $318e60a76c97e9b3$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $318e60a76c97e9b3$var$_extends({
            matches: updatedMatches || matches
        }, $318e60a76c97e9b3$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $318e60a76c97e9b3$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $318e60a76c97e9b3$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $318e60a76c97e9b3$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $318e60a76c97e9b3$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $318e60a76c97e9b3$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $318e60a76c97e9b3$var$ResultType.error,
            error: $318e60a76c97e9b3$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($318e60a76c97e9b3$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $318e60a76c97e9b3$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($318e60a76c97e9b3$var$isDeferredResult(result)) throw $318e60a76c97e9b3$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($318e60a76c97e9b3$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $318e60a76c97e9b3$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $318e60a76c97e9b3$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $318e60a76c97e9b3$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $318e60a76c97e9b3$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($318e60a76c97e9b3$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $318e60a76c97e9b3$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $318e60a76c97e9b3$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $318e60a76c97e9b3$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $318e60a76c97e9b3$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $318e60a76c97e9b3$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $318e60a76c97e9b3$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $318e60a76c97e9b3$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $318e60a76c97e9b3$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $318e60a76c97e9b3$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $318e60a76c97e9b3$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$318e60a76c97e9b3$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $318e60a76c97e9b3$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $318e60a76c97e9b3$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $318e60a76c97e9b3$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $318e60a76c97e9b3$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $318e60a76c97e9b3$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $318e60a76c97e9b3$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $318e60a76c97e9b3$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $318e60a76c97e9b3$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $318e60a76c97e9b3$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $318e60a76c97e9b3$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $318e60a76c97e9b3$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $318e60a76c97e9b3$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($318e60a76c97e9b3$var$isRedirectResult(actionResult) || $318e60a76c97e9b3$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $318e60a76c97e9b3$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($318e60a76c97e9b3$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $318e60a76c97e9b3$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $318e60a76c97e9b3$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($318e60a76c97e9b3$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($318e60a76c97e9b3$var$isDeferredResult(actionResult)) throw $318e60a76c97e9b3$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $318e60a76c97e9b3$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $318e60a76c97e9b3$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $318e60a76c97e9b3$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $318e60a76c97e9b3$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $318e60a76c97e9b3$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $318e60a76c97e9b3$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $318e60a76c97e9b3$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $318e60a76c97e9b3$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $318e60a76c97e9b3$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $318e60a76c97e9b3$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $318e60a76c97e9b3$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $318e60a76c97e9b3$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $318e60a76c97e9b3$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $318e60a76c97e9b3$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $318e60a76c97e9b3$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $318e60a76c97e9b3$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($318e60a76c97e9b3$var$isDeferredResult(result)) result = await $318e60a76c97e9b3$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $318e60a76c97e9b3$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($318e60a76c97e9b3$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $318e60a76c97e9b3$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($318e60a76c97e9b3$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $318e60a76c97e9b3$export$3e9cee6b33872309(!$318e60a76c97e9b3$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $318e60a76c97e9b3$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $318e60a76c97e9b3$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $318e60a76c97e9b3$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $318e60a76c97e9b3$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($318e60a76c97e9b3$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $318e60a76c97e9b3$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $318e60a76c97e9b3$export$e19cd5f9376f8cee.Replace : $318e60a76c97e9b3$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $318e60a76c97e9b3$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($318e60a76c97e9b3$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $318e60a76c97e9b3$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $318e60a76c97e9b3$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $318e60a76c97e9b3$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $318e60a76c97e9b3$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $318e60a76c97e9b3$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($318e60a76c97e9b3$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $318e60a76c97e9b3$var$ResultType.redirect,
                response: $318e60a76c97e9b3$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $318e60a76c97e9b3$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $318e60a76c97e9b3$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $318e60a76c97e9b3$var$ResultType.error,
                    error: $318e60a76c97e9b3$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $318e60a76c97e9b3$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $318e60a76c97e9b3$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $318e60a76c97e9b3$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $318e60a76c97e9b3$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $318e60a76c97e9b3$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $318e60a76c97e9b3$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $318e60a76c97e9b3$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $318e60a76c97e9b3$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $318e60a76c97e9b3$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $318e60a76c97e9b3$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $318e60a76c97e9b3$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $318e60a76c97e9b3$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $318e60a76c97e9b3$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $318e60a76c97e9b3$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$318e60a76c97e9b3$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $318e60a76c97e9b3$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $318e60a76c97e9b3$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $318e60a76c97e9b3$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $318e60a76c97e9b3$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $318e60a76c97e9b3$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $318e60a76c97e9b3$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $318e60a76c97e9b3$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $318e60a76c97e9b3$export$4d0306f8f6a4585b = Symbol("deferred");
function $318e60a76c97e9b3$export$3336b097a6fbc59a(routes, opts) {
    $318e60a76c97e9b3$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $318e60a76c97e9b3$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $318e60a76c97e9b3$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $318e60a76c97e9b3$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $318e60a76c97e9b3$var$createLocation("", $318e60a76c97e9b3$export$fe53371bee54353d(url), null, "default");
        let matches = $318e60a76c97e9b3$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$318e60a76c97e9b3$var$isValidMethod(method) && method !== "HEAD") {
            let error = $318e60a76c97e9b3$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $318e60a76c97e9b3$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $318e60a76c97e9b3$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $318e60a76c97e9b3$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($318e60a76c97e9b3$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $318e60a76c97e9b3$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $318e60a76c97e9b3$var$createLocation("", $318e60a76c97e9b3$export$fe53371bee54353d(url), null, "default");
        let matches = $318e60a76c97e9b3$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$318e60a76c97e9b3$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $318e60a76c97e9b3$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $318e60a76c97e9b3$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $318e60a76c97e9b3$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $318e60a76c97e9b3$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $318e60a76c97e9b3$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($318e60a76c97e9b3$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$318e60a76c97e9b3$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $318e60a76c97e9b3$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($318e60a76c97e9b3$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $318e60a76c97e9b3$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $318e60a76c97e9b3$var$isResponse(result) ? result : $318e60a76c97e9b3$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($318e60a76c97e9b3$var$isDataStrategyResult(e) && $318e60a76c97e9b3$var$isResponse(e.result)) {
                if (e.type === $318e60a76c97e9b3$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($318e60a76c97e9b3$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $318e60a76c97e9b3$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $318e60a76c97e9b3$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $318e60a76c97e9b3$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($318e60a76c97e9b3$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($318e60a76c97e9b3$var$isDeferredResult(result)) {
            let error = $318e60a76c97e9b3$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $318e60a76c97e9b3$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($318e60a76c97e9b3$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($318e60a76c97e9b3$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $318e60a76c97e9b3$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $318e60a76c97e9b3$var$_extends({}, context, {
                statusCode: $318e60a76c97e9b3$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $318e60a76c97e9b3$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $318e60a76c97e9b3$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $318e60a76c97e9b3$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $318e60a76c97e9b3$var$isErrorResult(pendingActionResult[1]) ? $318e60a76c97e9b3$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $318e60a76c97e9b3$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $318e60a76c97e9b3$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $318e60a76c97e9b3$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $318e60a76c97e9b3$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $318e60a76c97e9b3$var$callDataStrategyImpl(dataStrategy || $318e60a76c97e9b3$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($318e60a76c97e9b3$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $318e60a76c97e9b3$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($318e60a76c97e9b3$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $318e60a76c97e9b3$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $318e60a76c97e9b3$export$fec11da027c70692(routes, context, error) {
    let newContext = $318e60a76c97e9b3$var$_extends({}, context, {
        statusCode: $318e60a76c97e9b3$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $318e60a76c97e9b3$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $318e60a76c97e9b3$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $318e60a76c97e9b3$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $318e60a76c97e9b3$export$cae722b0cc860f13(to ? to : ".", $318e60a76c97e9b3$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $318e60a76c97e9b3$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $318e60a76c97e9b3$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $318e60a76c97e9b3$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $318e60a76c97e9b3$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $318e60a76c97e9b3$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$318e60a76c97e9b3$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$318e60a76c97e9b3$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $318e60a76c97e9b3$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $318e60a76c97e9b3$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $318e60a76c97e9b3$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$318e60a76c97e9b3$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$318e60a76c97e9b3$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $318e60a76c97e9b3$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $318e60a76c97e9b3$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $318e60a76c97e9b3$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $318e60a76c97e9b3$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $318e60a76c97e9b3$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($318e60a76c97e9b3$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $318e60a76c97e9b3$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $318e60a76c97e9b3$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $318e60a76c97e9b3$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $318e60a76c97e9b3$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $318e60a76c97e9b3$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $318e60a76c97e9b3$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $318e60a76c97e9b3$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $318e60a76c97e9b3$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $318e60a76c97e9b3$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $318e60a76c97e9b3$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($318e60a76c97e9b3$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $318e60a76c97e9b3$var$shouldRevalidateLoader(match, $318e60a76c97e9b3$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $318e60a76c97e9b3$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $318e60a76c97e9b3$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $318e60a76c97e9b3$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $318e60a76c97e9b3$var$shouldRevalidateLoader(fetcherMatch, $318e60a76c97e9b3$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $318e60a76c97e9b3$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $318e60a76c97e9b3$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $318e60a76c97e9b3$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $318e60a76c97e9b3$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $318e60a76c97e9b3$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $318e60a76c97e9b3$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$318e60a76c97e9b3$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $318e60a76c97e9b3$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $318e60a76c97e9b3$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$318e60a76c97e9b3$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $318e60a76c97e9b3$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $318e60a76c97e9b3$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $318e60a76c97e9b3$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$318e60a76c97e9b3$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $318e60a76c97e9b3$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $318e60a76c97e9b3$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $318e60a76c97e9b3$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $318e60a76c97e9b3$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $318e60a76c97e9b3$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $318e60a76c97e9b3$var$ResultType.data,
                result: undefined
            });
        };
        return $318e60a76c97e9b3$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $318e60a76c97e9b3$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $318e60a76c97e9b3$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $318e60a76c97e9b3$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $318e60a76c97e9b3$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $318e60a76c97e9b3$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $318e60a76c97e9b3$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $318e60a76c97e9b3$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($318e60a76c97e9b3$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $318e60a76c97e9b3$var$ResultType.error,
                error: e
            };
        }
        if (type === $318e60a76c97e9b3$var$ResultType.error) return {
            type: $318e60a76c97e9b3$var$ResultType.error,
            error: new $318e60a76c97e9b3$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $318e60a76c97e9b3$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $318e60a76c97e9b3$var$ResultType.error) {
        if ($318e60a76c97e9b3$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $318e60a76c97e9b3$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown data() to ErrorResponse instances
            result = new $318e60a76c97e9b3$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $318e60a76c97e9b3$var$ResultType.error,
            error: result,
            statusCode: $318e60a76c97e9b3$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($318e60a76c97e9b3$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $318e60a76c97e9b3$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($318e60a76c97e9b3$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $318e60a76c97e9b3$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $318e60a76c97e9b3$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $318e60a76c97e9b3$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $318e60a76c97e9b3$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$318e60a76c97e9b3$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $318e60a76c97e9b3$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $318e60a76c97e9b3$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($318e60a76c97e9b3$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $318e60a76c97e9b3$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $318e60a76c97e9b3$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($318e60a76c97e9b3$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $318e60a76c97e9b3$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $318e60a76c97e9b3$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $318e60a76c97e9b3$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $318e60a76c97e9b3$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $318e60a76c97e9b3$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $318e60a76c97e9b3$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $318e60a76c97e9b3$export$3e9cee6b33872309(!$318e60a76c97e9b3$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($318e60a76c97e9b3$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $318e60a76c97e9b3$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $318e60a76c97e9b3$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($318e60a76c97e9b3$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $318e60a76c97e9b3$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $318e60a76c97e9b3$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $318e60a76c97e9b3$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($318e60a76c97e9b3$var$isErrorResult(result)) {
            let boundaryMatch = $318e60a76c97e9b3$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $318e60a76c97e9b3$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($318e60a76c97e9b3$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $318e60a76c97e9b3$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($318e60a76c97e9b3$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $318e60a76c97e9b3$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $318e60a76c97e9b3$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $318e60a76c97e9b3$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $318e60a76c97e9b3$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $318e60a76c97e9b3$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $318e60a76c97e9b3$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $318e60a76c97e9b3$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $318e60a76c97e9b3$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $318e60a76c97e9b3$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $318e60a76c97e9b3$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $318e60a76c97e9b3$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($318e60a76c97e9b3$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $318e60a76c97e9b3$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $318e60a76c97e9b3$export$8ccf933b0513f8d0(path) : path;
    return $318e60a76c97e9b3$export$fe53371bee54353d($318e60a76c97e9b3$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $318e60a76c97e9b3$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $318e60a76c97e9b3$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $318e60a76c97e9b3$var$ResultType.data || result.type === $318e60a76c97e9b3$var$ResultType.error);
}
function $318e60a76c97e9b3$var$isRedirectDataStrategyResultResult(result) {
    return $318e60a76c97e9b3$var$isResponse(result.result) && $318e60a76c97e9b3$var$redirectStatusCodes.has(result.result.status);
}
function $318e60a76c97e9b3$var$isDeferredResult(result) {
    return result.type === $318e60a76c97e9b3$var$ResultType.deferred;
}
function $318e60a76c97e9b3$var$isErrorResult(result) {
    return result.type === $318e60a76c97e9b3$var$ResultType.error;
}
function $318e60a76c97e9b3$var$isRedirectResult(result) {
    return (result && result.type) === $318e60a76c97e9b3$var$ResultType.redirect;
}
function $318e60a76c97e9b3$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $318e60a76c97e9b3$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $318e60a76c97e9b3$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $318e60a76c97e9b3$var$isRedirectResponse(result) {
    if (!$318e60a76c97e9b3$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $318e60a76c97e9b3$var$isValidMethod(method) {
    return $318e60a76c97e9b3$var$validRequestMethods.has(method.toLowerCase());
}
function $318e60a76c97e9b3$var$isMutationMethod(method) {
    return $318e60a76c97e9b3$var$validMutationMethods.has(method.toLowerCase());
}
async function $318e60a76c97e9b3$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$318e60a76c97e9b3$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($318e60a76c97e9b3$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $318e60a76c97e9b3$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $318e60a76c97e9b3$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($318e60a76c97e9b3$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $318e60a76c97e9b3$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $318e60a76c97e9b3$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $318e60a76c97e9b3$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $318e60a76c97e9b3$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $318e60a76c97e9b3$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $318e60a76c97e9b3$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $318e60a76c97e9b3$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $318e60a76c97e9b3$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $318e60a76c97e9b3$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $318e60a76c97e9b3$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $318e60a76c97e9b3$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $318e60a76c97e9b3$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $318e60a76c97e9b3$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $318e60a76c97e9b3$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $318e60a76c97e9b3$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $318e60a76c97e9b3$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $318e60a76c97e9b3$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $318e60a76c97e9b3$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($318e60a76c97e9b3$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $318e60a76c97e9b3$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($318e60a76c97e9b3$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $318e60a76c97e9b3$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.27.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8v0nu = parcelRequire("8v0nu");

function $aa6b6e9e15323f83$var$_extends() {
    $aa6b6e9e15323f83$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $aa6b6e9e15323f83$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $aa6b6e9e15323f83$export$3add0d5dce533e2e = /*#__PURE__*/ $8v0nu.createContext(null);
const $aa6b6e9e15323f83$export$145dfa71566a64dc = /*#__PURE__*/ $8v0nu.createContext(null);
const $aa6b6e9e15323f83$var$AwaitContext = /*#__PURE__*/ $8v0nu.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $aa6b6e9e15323f83$export$26749e8557646306 = /*#__PURE__*/ $8v0nu.createContext(null);
const $aa6b6e9e15323f83$export$c7914228fb69b0f5 = /*#__PURE__*/ $8v0nu.createContext(null);
const $aa6b6e9e15323f83$export$9072aa6dd1f93057 = /*#__PURE__*/ $8v0nu.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $aa6b6e9e15323f83$var$RouteErrorContext = /*#__PURE__*/ $8v0nu.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $aa6b6e9e15323f83$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$aa6b6e9e15323f83$export$9c954a9d03d32f4a() && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $8v0nu.useContext($aa6b6e9e15323f83$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $aa6b6e9e15323f83$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $318e60a76c97e9b3$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $aa6b6e9e15323f83$export$9c954a9d03d32f4a() {
    return $8v0nu.useContext($aa6b6e9e15323f83$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $aa6b6e9e15323f83$export$45d76561a5302f2b() {
    !$aa6b6e9e15323f83$export$9c954a9d03d32f4a() && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    return $8v0nu.useContext($aa6b6e9e15323f83$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $aa6b6e9e15323f83$export$1b3f31771c5d07c() {
    return $8v0nu.useContext($aa6b6e9e15323f83$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $aa6b6e9e15323f83$export$6c330e8992e8a295(pattern) {
    !$aa6b6e9e15323f83$export$9c954a9d03d32f4a() && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $aa6b6e9e15323f83$export$45d76561a5302f2b();
    return $8v0nu.useMemo(()=>(0, $318e60a76c97e9b3$export$81336c211d5ff295)(pattern, (0, $318e60a76c97e9b3$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $aa6b6e9e15323f83$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $aa6b6e9e15323f83$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $8v0nu.useContext($aa6b6e9e15323f83$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8v0nu.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $aa6b6e9e15323f83$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $8v0nu.useContext($aa6b6e9e15323f83$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $aa6b6e9e15323f83$var$useNavigateStable() : $aa6b6e9e15323f83$var$useNavigateUnstable();
}
function $aa6b6e9e15323f83$var$useNavigateUnstable() {
    !$aa6b6e9e15323f83$export$9c954a9d03d32f4a() && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    let dataRouterContext = $8v0nu.useContext($aa6b6e9e15323f83$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $8v0nu.useContext($aa6b6e9e15323f83$export$26749e8557646306);
    let { matches: matches } = $8v0nu.useContext($aa6b6e9e15323f83$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $aa6b6e9e15323f83$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $318e60a76c97e9b3$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $8v0nu.useRef(false);
    $aa6b6e9e15323f83$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8v0nu.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $318e60a76c97e9b3$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $318e60a76c97e9b3$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $aa6b6e9e15323f83$var$OutletContext = /*#__PURE__*/ $8v0nu.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $aa6b6e9e15323f83$export$4138103a3ae699cc() {
    return $8v0nu.useContext($aa6b6e9e15323f83$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $aa6b6e9e15323f83$export$a3be3530d8e40d0b(context) {
    let outlet = $8v0nu.useContext($aa6b6e9e15323f83$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $aa6b6e9e15323f83$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $8v0nu.useContext($aa6b6e9e15323f83$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $aa6b6e9e15323f83$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $8v0nu.useContext($aa6b6e9e15323f83$export$26749e8557646306);
    let { matches: matches } = $8v0nu.useContext($aa6b6e9e15323f83$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $aa6b6e9e15323f83$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $318e60a76c97e9b3$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $8v0nu.useMemo(()=>(0, $318e60a76c97e9b3$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $aa6b6e9e15323f83$export$5d3fca4a98652595(routes, locationArg) {
    return $aa6b6e9e15323f83$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $aa6b6e9e15323f83$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$aa6b6e9e15323f83$export$9c954a9d03d32f4a() && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $8v0nu.useContext($aa6b6e9e15323f83$export$26749e8557646306);
    let { matches: parentMatches } = $8v0nu.useContext($aa6b6e9e15323f83$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $aa6b6e9e15323f83$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $318e60a76c97e9b3$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $318e60a76c97e9b3$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $aa6b6e9e15323f83$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $318e60a76c97e9b3$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $318e60a76c97e9b3$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $aa6b6e9e15323f83$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $318e60a76c97e9b3$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $aa6b6e9e15323f83$var$DefaultErrorComponent() {
    let error = $aa6b6e9e15323f83$export$ed527bf60f6e05f2();
    let message = (0, $318e60a76c97e9b3$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $8v0nu.createElement($8v0nu.Fragment, null, /*#__PURE__*/ $8v0nu.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $8v0nu.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $8v0nu.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $aa6b6e9e15323f83$var$defaultErrorElement = /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$var$DefaultErrorComponent, null);
class $aa6b6e9e15323f83$var$RenderErrorBoundary extends $8v0nu.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $aa6b6e9e15323f83$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $8v0nu.useContext($aa6b6e9e15323f83$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $aa6b6e9e15323f83$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $aa6b6e9e15323f83$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $aa6b6e9e15323f83$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $8v0nu.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $aa6b6e9e15323f83$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($aa6b6e9e15323f83$var$DataRouterHook || {});
var $aa6b6e9e15323f83$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($aa6b6e9e15323f83$var$DataRouterStateHook || {});
function $aa6b6e9e15323f83$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $aa6b6e9e15323f83$var$useDataRouterContext(hookName) {
    let ctx = $8v0nu.useContext($aa6b6e9e15323f83$export$3add0d5dce533e2e);
    !ctx && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    return ctx;
}
function $aa6b6e9e15323f83$var$useDataRouterState(hookName) {
    let state = $8v0nu.useContext($aa6b6e9e15323f83$export$145dfa71566a64dc);
    !state && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    return state;
}
function $aa6b6e9e15323f83$var$useRouteContext(hookName) {
    let route = $8v0nu.useContext($aa6b6e9e15323f83$export$9072aa6dd1f93057);
    !route && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $aa6b6e9e15323f83$var$useCurrentRouteId(hookName) {
    let route = $aa6b6e9e15323f83$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $aa6b6e9e15323f83$export$5fc8298006ad9e58() {
    return $aa6b6e9e15323f83$var$useCurrentRouteId($aa6b6e9e15323f83$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $aa6b6e9e15323f83$export$d0fd4b7106de2769() {
    let state = $aa6b6e9e15323f83$var$useDataRouterState($aa6b6e9e15323f83$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $aa6b6e9e15323f83$export$600dc272ed516c15() {
    let dataRouterContext = $aa6b6e9e15323f83$var$useDataRouterContext($aa6b6e9e15323f83$var$DataRouterHook.UseRevalidator);
    let state = $aa6b6e9e15323f83$var$useDataRouterState($aa6b6e9e15323f83$var$DataRouterStateHook.UseRevalidator);
    return $8v0nu.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $aa6b6e9e15323f83$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $aa6b6e9e15323f83$var$useDataRouterState($aa6b6e9e15323f83$var$DataRouterStateHook.UseMatches);
    return $8v0nu.useMemo(()=>matches.map((m)=>(0, $318e60a76c97e9b3$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $aa6b6e9e15323f83$export$1448a5050d252c4d() {
    let state = $aa6b6e9e15323f83$var$useDataRouterState($aa6b6e9e15323f83$var$DataRouterStateHook.UseLoaderData);
    let routeId = $aa6b6e9e15323f83$var$useCurrentRouteId($aa6b6e9e15323f83$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $aa6b6e9e15323f83$export$fd5d37484eab868d(routeId) {
    let state = $aa6b6e9e15323f83$var$useDataRouterState($aa6b6e9e15323f83$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $aa6b6e9e15323f83$export$fdc00f3f26066d5e() {
    let state = $aa6b6e9e15323f83$var$useDataRouterState($aa6b6e9e15323f83$var$DataRouterStateHook.UseActionData);
    let routeId = $aa6b6e9e15323f83$var$useCurrentRouteId($aa6b6e9e15323f83$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $aa6b6e9e15323f83$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $8v0nu.useContext($aa6b6e9e15323f83$var$RouteErrorContext);
    let state = $aa6b6e9e15323f83$var$useDataRouterState($aa6b6e9e15323f83$var$DataRouterStateHook.UseRouteError);
    let routeId = $aa6b6e9e15323f83$var$useCurrentRouteId($aa6b6e9e15323f83$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $aa6b6e9e15323f83$export$78a72ddb39bdd145() {
    let value = $8v0nu.useContext($aa6b6e9e15323f83$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $aa6b6e9e15323f83$export$17f53340677d5831() {
    let value = $8v0nu.useContext($aa6b6e9e15323f83$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $aa6b6e9e15323f83$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $aa6b6e9e15323f83$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $aa6b6e9e15323f83$var$useDataRouterContext($aa6b6e9e15323f83$var$DataRouterHook.UseBlocker);
    let state = $aa6b6e9e15323f83$var$useDataRouterState($aa6b6e9e15323f83$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $8v0nu.useState("");
    let blockerFunction = $8v0nu.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $aa6b6e9e15323f83$var$_extends({}, currentLocation, {
                pathname: (0, $318e60a76c97e9b3$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $aa6b6e9e15323f83$var$_extends({}, nextLocation, {
                pathname: (0, $318e60a76c97e9b3$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $8v0nu.useEffect(()=>{
        let key = String(++$aa6b6e9e15323f83$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $8v0nu.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $318e60a76c97e9b3$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $aa6b6e9e15323f83$var$useNavigateStable() {
    let { router: router } = $aa6b6e9e15323f83$var$useDataRouterContext($aa6b6e9e15323f83$var$DataRouterHook.UseNavigateStable);
    let id = $aa6b6e9e15323f83$var$useCurrentRouteId($aa6b6e9e15323f83$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $8v0nu.useRef(false);
    $aa6b6e9e15323f83$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8v0nu.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $aa6b6e9e15323f83$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $aa6b6e9e15323f83$var$alreadyWarned = {};
function $aa6b6e9e15323f83$var$warningOnce(key, cond, message) {
    if (!cond && !$aa6b6e9e15323f83$var$alreadyWarned[key]) $aa6b6e9e15323f83$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $aa6b6e9e15323f83$var$START_TRANSITION = "startTransition";
const $aa6b6e9e15323f83$var$startTransitionImpl = $8v0nu[$aa6b6e9e15323f83$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $aa6b6e9e15323f83$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8v0nu.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8v0nu.useCallback((newState)=>{
        if (v7_startTransition && $aa6b6e9e15323f83$var$startTransitionImpl) $aa6b6e9e15323f83$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8v0nu.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $8v0nu.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8v0nu.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8v0nu.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8v0nu.createElement($8v0nu.Fragment, null, /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $aa6b6e9e15323f83$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $aa6b6e9e15323f83$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $aa6b6e9e15323f83$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $8v0nu.useRef();
    if (historyRef.current == null) historyRef.current = (0, $318e60a76c97e9b3$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8v0nu.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8v0nu.useCallback((newState)=>{
        v7_startTransition && $aa6b6e9e15323f83$var$startTransitionImpl ? $aa6b6e9e15323f83$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8v0nu.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $aa6b6e9e15323f83$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$aa6b6e9e15323f83$export$9c954a9d03d32f4a() && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $8v0nu.useContext($aa6b6e9e15323f83$export$26749e8557646306);
    let { matches: matches } = $8v0nu.useContext($aa6b6e9e15323f83$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $aa6b6e9e15323f83$export$45d76561a5302f2b();
    let navigate = $aa6b6e9e15323f83$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $318e60a76c97e9b3$export$cae722b0cc860f13)(to, (0, $318e60a76c97e9b3$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $8v0nu.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $aa6b6e9e15323f83$export$910ae8079b2c2852(props) {
    return $aa6b6e9e15323f83$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $aa6b6e9e15323f83$export$e7b0ac011bb776c6(_props) {
    (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $aa6b6e9e15323f83$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $318e60a76c97e9b3$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$aa6b6e9e15323f83$export$9c954a9d03d32f4a() && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $8v0nu.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $aa6b6e9e15323f83$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $318e60a76c97e9b3$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $8v0nu.useMemo(()=>{
        let trailingPathname = (0, $318e60a76c97e9b3$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $aa6b6e9e15323f83$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $aa6b6e9e15323f83$export$5d3fca4a98652595($aa6b6e9e15323f83$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $aa6b6e9e15323f83$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$var$ResolveAwait, null, children));
}
var $aa6b6e9e15323f83$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($aa6b6e9e15323f83$var$AwaitRenderStatus || {});
const $aa6b6e9e15323f83$var$neverSettledPromise = new Promise(()=>{});
class $aa6b6e9e15323f83$var$AwaitErrorBoundary extends $8v0nu.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $aa6b6e9e15323f83$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $aa6b6e9e15323f83$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $aa6b6e9e15323f83$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $aa6b6e9e15323f83$var$AwaitRenderStatus.error : "_data" in promise ? $aa6b6e9e15323f83$var$AwaitRenderStatus.success : $aa6b6e9e15323f83$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $aa6b6e9e15323f83$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $aa6b6e9e15323f83$var$AwaitRenderStatus.error && promise._error instanceof (0, $318e60a76c97e9b3$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $aa6b6e9e15323f83$var$neverSettledPromise;
        if (status === $aa6b6e9e15323f83$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $aa6b6e9e15323f83$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $aa6b6e9e15323f83$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $8v0nu.createElement($aa6b6e9e15323f83$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $aa6b6e9e15323f83$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $aa6b6e9e15323f83$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $8v0nu.createElement($8v0nu.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $aa6b6e9e15323f83$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $8v0nu.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $8v0nu.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $8v0nu.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $aa6b6e9e15323f83$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $aa6b6e9e15323f83$export$e7b0ac011bb776c6) && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $aa6b6e9e15323f83$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $aa6b6e9e15323f83$export$daf73786167a7f72(matches) {
    return $aa6b6e9e15323f83$var$_renderMatches(matches);
}
function $aa6b6e9e15323f83$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $8v0nu.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $8v0nu.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $8v0nu.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $aa6b6e9e15323f83$export$f30f7e456d254e83(routes, opts) {
    return (0, $318e60a76c97e9b3$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $aa6b6e9e15323f83$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $318e60a76c97e9b3$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $aa6b6e9e15323f83$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $d9197f3f1e79e9d9$var$_extends() {
    $d9197f3f1e79e9d9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d9197f3f1e79e9d9$var$_extends.apply(this, arguments);
}
function $d9197f3f1e79e9d9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $d9197f3f1e79e9d9$var$defaultMethod = "get";
const $d9197f3f1e79e9d9$var$defaultEncType = "application/x-www-form-urlencoded";
function $d9197f3f1e79e9d9$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $d9197f3f1e79e9d9$var$isButtonElement(object) {
    return $d9197f3f1e79e9d9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $d9197f3f1e79e9d9$var$isFormElement(object) {
    return $d9197f3f1e79e9d9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $d9197f3f1e79e9d9$var$isInputElement(object) {
    return $d9197f3f1e79e9d9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $d9197f3f1e79e9d9$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $d9197f3f1e79e9d9$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$d9197f3f1e79e9d9$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $d9197f3f1e79e9d9$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $d9197f3f1e79e9d9$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $d9197f3f1e79e9d9$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $d9197f3f1e79e9d9$var$_formDataSupportsSubmitter = null;
function $d9197f3f1e79e9d9$var$isFormDataSubmitterSupported() {
    if ($d9197f3f1e79e9d9$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $d9197f3f1e79e9d9$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $d9197f3f1e79e9d9$var$_formDataSupportsSubmitter = true;
    }
    return $d9197f3f1e79e9d9$var$_formDataSupportsSubmitter;
}
const $d9197f3f1e79e9d9$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $d9197f3f1e79e9d9$var$getFormEncType(encType) {
    if (encType != null && !$d9197f3f1e79e9d9$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $d9197f3f1e79e9d9$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($d9197f3f1e79e9d9$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $318e60a76c97e9b3$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $d9197f3f1e79e9d9$var$defaultMethod;
        encType = $d9197f3f1e79e9d9$var$getFormEncType(target.getAttribute("enctype")) || $d9197f3f1e79e9d9$var$defaultEncType;
        formData = new FormData(target);
    } else if ($d9197f3f1e79e9d9$var$isButtonElement(target) || $d9197f3f1e79e9d9$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $318e60a76c97e9b3$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $d9197f3f1e79e9d9$var$defaultMethod;
        encType = $d9197f3f1e79e9d9$var$getFormEncType(target.getAttribute("formenctype")) || $d9197f3f1e79e9d9$var$getFormEncType(form.getAttribute("enctype")) || $d9197f3f1e79e9d9$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$d9197f3f1e79e9d9$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($d9197f3f1e79e9d9$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $d9197f3f1e79e9d9$var$defaultMethod;
        action = null;
        encType = $d9197f3f1e79e9d9$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $d9197f3f1e79e9d9$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $d9197f3f1e79e9d9$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $d9197f3f1e79e9d9$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $d9197f3f1e79e9d9$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $d9197f3f1e79e9d9$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $d9197f3f1e79e9d9$export$1f3f55432a00e06d(routes, opts) {
    return (0, $318e60a76c97e9b3$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $d9197f3f1e79e9d9$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $318e60a76c97e9b3$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $d9197f3f1e79e9d9$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aa6b6e9e15323f83$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $d9197f3f1e79e9d9$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $318e60a76c97e9b3$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $d9197f3f1e79e9d9$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $318e60a76c97e9b3$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $d9197f3f1e79e9d9$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aa6b6e9e15323f83$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $d9197f3f1e79e9d9$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $d9197f3f1e79e9d9$var$_extends({}, state, {
        errors: $d9197f3f1e79e9d9$var$deserializeErrors(state.errors)
    });
    return state;
}
function $d9197f3f1e79e9d9$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $318e60a76c97e9b3$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $d9197f3f1e79e9d9$export$7ad602f0e94e62d1 = /*#__PURE__*/ $8v0nu.createContext({
    isTransitioning: false
});
const $d9197f3f1e79e9d9$export$148fd98d095596d4 = /*#__PURE__*/ $8v0nu.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $d9197f3f1e79e9d9$var$START_TRANSITION = "startTransition";
const $d9197f3f1e79e9d9$var$startTransitionImpl = $8v0nu[$d9197f3f1e79e9d9$var$START_TRANSITION];
const $d9197f3f1e79e9d9$var$FLUSH_SYNC = "flushSync";
const $d9197f3f1e79e9d9$var$flushSyncImpl = $e95e39c2a873bfa2$exports[$d9197f3f1e79e9d9$var$FLUSH_SYNC];
const $d9197f3f1e79e9d9$var$USE_ID = "useId";
const $d9197f3f1e79e9d9$var$useIdImpl = $8v0nu[$d9197f3f1e79e9d9$var$USE_ID];
function $d9197f3f1e79e9d9$var$startTransitionSafe(cb) {
    if ($d9197f3f1e79e9d9$var$startTransitionImpl) $d9197f3f1e79e9d9$var$startTransitionImpl(cb);
    else cb();
}
function $d9197f3f1e79e9d9$var$flushSyncSafe(cb) {
    if ($d9197f3f1e79e9d9$var$flushSyncImpl) $d9197f3f1e79e9d9$var$flushSyncImpl(cb);
    else cb();
}
class $d9197f3f1e79e9d9$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $d9197f3f1e79e9d9$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8v0nu.useState(router.state);
    let [pendingState, setPendingState] = $8v0nu.useState();
    let [vtContext, setVtContext] = $8v0nu.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $8v0nu.useState();
    let [transition, setTransition] = $8v0nu.useState();
    let [interruption, setInterruption] = $8v0nu.useState();
    let fetcherData = $8v0nu.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $8v0nu.useCallback((cb)=>{
        if (v7_startTransition) $d9197f3f1e79e9d9$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $8v0nu.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $d9197f3f1e79e9d9$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $d9197f3f1e79e9d9$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $d9197f3f1e79e9d9$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $d9197f3f1e79e9d9$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $d9197f3f1e79e9d9$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8v0nu.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $8v0nu.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $d9197f3f1e79e9d9$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $8v0nu.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $8v0nu.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $8v0nu.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $8v0nu.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8v0nu.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8v0nu.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $8v0nu.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8v0nu.createElement($8v0nu.Fragment, null, /*#__PURE__*/ $8v0nu.createElement((0, $aa6b6e9e15323f83$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8v0nu.createElement((0, $aa6b6e9e15323f83$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $8v0nu.createElement($d9197f3f1e79e9d9$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $8v0nu.createElement($d9197f3f1e79e9d9$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $8v0nu.createElement((0, $aa6b6e9e15323f83$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8v0nu.createElement($d9197f3f1e79e9d9$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $d9197f3f1e79e9d9$var$MemoizedDataRoutes = /*#__PURE__*/ $8v0nu.memo($d9197f3f1e79e9d9$var$DataRoutes);
function $d9197f3f1e79e9d9$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $aa6b6e9e15323f83$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $d9197f3f1e79e9d9$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $8v0nu.useRef();
    if (historyRef.current == null) historyRef.current = (0, $318e60a76c97e9b3$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8v0nu.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8v0nu.useCallback((newState)=>{
        v7_startTransition && $d9197f3f1e79e9d9$var$startTransitionImpl ? $d9197f3f1e79e9d9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8v0nu.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8v0nu.createElement((0, $aa6b6e9e15323f83$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $d9197f3f1e79e9d9$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $8v0nu.useRef();
    if (historyRef.current == null) historyRef.current = (0, $318e60a76c97e9b3$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8v0nu.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8v0nu.useCallback((newState)=>{
        v7_startTransition && $d9197f3f1e79e9d9$var$startTransitionImpl ? $d9197f3f1e79e9d9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8v0nu.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8v0nu.createElement((0, $aa6b6e9e15323f83$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $d9197f3f1e79e9d9$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $8v0nu.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8v0nu.useCallback((newState)=>{
        v7_startTransition && $d9197f3f1e79e9d9$var$startTransitionImpl ? $d9197f3f1e79e9d9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8v0nu.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8v0nu.createElement((0, $aa6b6e9e15323f83$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $d9197f3f1e79e9d9$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $d9197f3f1e79e9d9$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $d9197f3f1e79e9d9$export$a6c7ac8248d6e38a = /*#__PURE__*/ $8v0nu.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $d9197f3f1e79e9d9$var$_objectWithoutPropertiesLoose(_ref7, $d9197f3f1e79e9d9$var$_excluded);
    let { basename: basename } = $8v0nu.useContext((0, $aa6b6e9e15323f83$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $d9197f3f1e79e9d9$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($d9197f3f1e79e9d9$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $318e60a76c97e9b3$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $aa6b6e9e15323f83$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $d9197f3f1e79e9d9$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $8v0nu.createElement("a", $d9197f3f1e79e9d9$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $d9197f3f1e79e9d9$export$b0d92dbee9b5b60d = /*#__PURE__*/ $8v0nu.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $d9197f3f1e79e9d9$var$_objectWithoutPropertiesLoose(_ref8, $d9197f3f1e79e9d9$var$_excluded2);
    let path = (0, $aa6b6e9e15323f83$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $aa6b6e9e15323f83$export$45d76561a5302f2b)();
    let routerState = $8v0nu.useContext((0, $aa6b6e9e15323f83$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $8v0nu.useContext((0, $aa6b6e9e15323f83$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $d9197f3f1e79e9d9$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $318e60a76c97e9b3$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $8v0nu.createElement($d9197f3f1e79e9d9$export$a6c7ac8248d6e38a, $d9197f3f1e79e9d9$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $d9197f3f1e79e9d9$export$a7fed597f4b8afd8 = /*#__PURE__*/ $8v0nu.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $d9197f3f1e79e9d9$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $d9197f3f1e79e9d9$var$_objectWithoutPropertiesLoose(_ref9, $d9197f3f1e79e9d9$var$_excluded3);
    let submit = $d9197f3f1e79e9d9$export$47c85c6e3a081d3();
    let formAction = $d9197f3f1e79e9d9$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $8v0nu.createElement("form", $d9197f3f1e79e9d9$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $d9197f3f1e79e9d9$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $d9197f3f1e79e9d9$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $d9197f3f1e79e9d9$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($d9197f3f1e79e9d9$var$DataRouterHook || ($d9197f3f1e79e9d9$var$DataRouterHook = {}));
var $d9197f3f1e79e9d9$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($d9197f3f1e79e9d9$var$DataRouterStateHook || ($d9197f3f1e79e9d9$var$DataRouterStateHook = {}));
// Internal hooks
function $d9197f3f1e79e9d9$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $d9197f3f1e79e9d9$var$useDataRouterContext(hookName) {
    let ctx = $8v0nu.useContext((0, $aa6b6e9e15323f83$export$3add0d5dce533e2e));
    !ctx && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    return ctx;
}
function $d9197f3f1e79e9d9$var$useDataRouterState(hookName) {
    let state = $8v0nu.useContext((0, $aa6b6e9e15323f83$export$145dfa71566a64dc));
    !state && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $d9197f3f1e79e9d9$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $aa6b6e9e15323f83$export$9770f232ac06a008)();
    let location = (0, $aa6b6e9e15323f83$export$45d76561a5302f2b)();
    let path = (0, $aa6b6e9e15323f83$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $8v0nu.useCallback((event)=>{
        if ($d9197f3f1e79e9d9$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $318e60a76c97e9b3$export$fe53371bee54353d)(location) === (0, $318e60a76c97e9b3$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $d9197f3f1e79e9d9$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $8v0nu.useRef($d9197f3f1e79e9d9$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $8v0nu.useRef(false);
    let location = (0, $aa6b6e9e15323f83$export$45d76561a5302f2b)();
    let searchParams = $8v0nu.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $d9197f3f1e79e9d9$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $aa6b6e9e15323f83$export$9770f232ac06a008)();
    let setSearchParams = $8v0nu.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $d9197f3f1e79e9d9$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $d9197f3f1e79e9d9$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $d9197f3f1e79e9d9$var$fetcherId = 0;
let $d9197f3f1e79e9d9$var$getUniqueFetcherId = ()=>"__" + String(++$d9197f3f1e79e9d9$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $d9197f3f1e79e9d9$export$47c85c6e3a081d3() {
    let { router: router } = $d9197f3f1e79e9d9$var$useDataRouterContext($d9197f3f1e79e9d9$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $8v0nu.useContext((0, $aa6b6e9e15323f83$export$26749e8557646306));
    let currentRouteId = (0, $aa6b6e9e15323f83$export$5fc8298006ad9e58)();
    return $8v0nu.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $d9197f3f1e79e9d9$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $d9197f3f1e79e9d9$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $d9197f3f1e79e9d9$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $d9197f3f1e79e9d9$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $8v0nu.useContext((0, $aa6b6e9e15323f83$export$26749e8557646306));
    let routeContext = $8v0nu.useContext((0, $aa6b6e9e15323f83$export$9072aa6dd1f93057));
    !routeContext && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $d9197f3f1e79e9d9$var$_extends({}, (0, $aa6b6e9e15323f83$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $aa6b6e9e15323f83$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $318e60a76c97e9b3$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $318e60a76c97e9b3$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $d9197f3f1e79e9d9$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $d9197f3f1e79e9d9$var$useDataRouterContext($d9197f3f1e79e9d9$var$DataRouterHook.UseFetcher);
    let state = $d9197f3f1e79e9d9$var$useDataRouterState($d9197f3f1e79e9d9$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $8v0nu.useContext($d9197f3f1e79e9d9$export$148fd98d095596d4);
    let route = $8v0nu.useContext((0, $aa6b6e9e15323f83$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    !route && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $d9197f3f1e79e9d9$var$useIdImpl ? $d9197f3f1e79e9d9$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $8v0nu.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($d9197f3f1e79e9d9$var$getUniqueFetcherId());
    // Registration/cleanup
    $8v0nu.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $8v0nu.useCallback((href, opts)=>{
        !routeId && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $d9197f3f1e79e9d9$export$47c85c6e3a081d3();
    let submit = $8v0nu.useCallback((target, opts)=>{
        submitImpl(target, $d9197f3f1e79e9d9$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $8v0nu.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $8v0nu.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $8v0nu.createElement($d9197f3f1e79e9d9$export$a7fed597f4b8afd8, $d9197f3f1e79e9d9$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $318e60a76c97e9b3$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $8v0nu.useMemo(()=>$d9197f3f1e79e9d9$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $d9197f3f1e79e9d9$export$fa996778a3a31087() {
    let state = $d9197f3f1e79e9d9$var$useDataRouterState($d9197f3f1e79e9d9$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $d9197f3f1e79e9d9$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $d9197f3f1e79e9d9$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $d9197f3f1e79e9d9$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $d9197f3f1e79e9d9$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $d9197f3f1e79e9d9$var$useDataRouterContext($d9197f3f1e79e9d9$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $d9197f3f1e79e9d9$var$useDataRouterState($d9197f3f1e79e9d9$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $8v0nu.useContext((0, $aa6b6e9e15323f83$export$26749e8557646306));
    let location = (0, $aa6b6e9e15323f83$export$45d76561a5302f2b)();
    let matches = (0, $aa6b6e9e15323f83$export$2378eb7f5ff86053)();
    let navigation = (0, $aa6b6e9e15323f83$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $8v0nu.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $d9197f3f1e79e9d9$var$usePageHide($8v0nu.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $d9197f3f1e79e9d9$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $d9197f3f1e79e9d9$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($d9197f3f1e79e9d9$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8v0nu.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $d9197f3f1e79e9d9$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $d9197f3f1e79e9d9$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8v0nu.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($d9197f3f1e79e9d9$var$_extends({}, location, {
                    pathname: (0, $318e60a76c97e9b3$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($d9197f3f1e79e9d9$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8v0nu.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $d9197f3f1e79e9d9$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $8v0nu.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $d9197f3f1e79e9d9$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $8v0nu.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $d9197f3f1e79e9d9$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $aa6b6e9e15323f83$export$b273b3273281a049)(when);
    $8v0nu.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $8v0nu.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $d9197f3f1e79e9d9$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $8v0nu.useContext($d9197f3f1e79e9d9$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $318e60a76c97e9b3$export$3e9cee6b33872309)(false);
    let { basename: basename } = $d9197f3f1e79e9d9$var$useDataRouterContext($d9197f3f1e79e9d9$var$DataRouterHook.useViewTransitionState);
    let path = (0, $aa6b6e9e15323f83$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $318e60a76c97e9b3$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $318e60a76c97e9b3$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $318e60a76c97e9b3$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $318e60a76c97e9b3$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


function $e0dd48e6f7e62a59$export$477202748c7242bf(name, map = {}) {
    let called = false;
    function assert() {
        if (!called) {
            called = true;
            return;
        }
        throw new Error("[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?");
    }
    function parts(...values) {
        assert();
        for (const part of values)map[part] = toPart(part);
        return $e0dd48e6f7e62a59$export$477202748c7242bf(name, map);
    }
    function extend(...parts2) {
        for (const part of parts2){
            if (part in map) continue;
            map[part] = toPart(part);
        }
        return $e0dd48e6f7e62a59$export$477202748c7242bf(name, map);
    }
    function selectors() {
        const value = Object.fromEntries(Object.entries(map).map(([key, part])=>[
                key,
                part.selector
            ]));
        return value;
    }
    function classnames() {
        const value = Object.fromEntries(Object.entries(map).map(([key, part])=>[
                key,
                part.className
            ]));
        return value;
    }
    function toPart(part) {
        const el = [
            "container",
            "root"
        ].includes(part ?? "") ? [
            name
        ] : [
            name,
            part
        ];
        const attr = el.filter(Boolean).join("__");
        const className = `chakra-${attr}`;
        const partObj = {
            className: className,
            selector: `.${className}`,
            toString: ()=>part
        };
        return partObj;
    }
    const __type = {};
    return {
        parts: parts,
        toPart: toPart,
        extend: extend,
        selectors: selectors,
        classnames: classnames,
        get keys () {
            return Object.keys(map);
        },
        __type: __type
    };
}


const $52fc62550c714bbf$export$377a77e99e7c73a5 = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("accordion").parts("root", "container", "button", "panel", "icon");
const $52fc62550c714bbf$export$fc51889fa4de265a = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("alert").parts("title", "description", "container", "icon", "spinner");
const $52fc62550c714bbf$export$60f8655d889e17c7 = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("avatar").parts("label", "badge", "container", "excessLabel", "group");
const $52fc62550c714bbf$export$2fb03f744a6ecf93 = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("breadcrumb").parts("link", "item", "container", "separator");
const $52fc62550c714bbf$export$1699c5cb20c07888 = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("button").parts();
const $52fc62550c714bbf$export$21946b04497ed6ac = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("checkbox").parts("control", "icon", "container", "label");
const $52fc62550c714bbf$export$2c953111278f3272 = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("progress").parts("track", "filledTrack", "label");
const $52fc62550c714bbf$export$d3f4aaa4b0f2907a = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("drawer").parts("overlay", "dialogContainer", "dialog", "header", "closeButton", "body", "footer");
const $52fc62550c714bbf$export$2813c9511eeab082 = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("editable").parts("preview", "input", "textarea");
const $52fc62550c714bbf$export$4b243e3f209a7e5e = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("form").parts("container", "requiredIndicator", "helperText");
const $52fc62550c714bbf$export$bb18c440c00e82d9 = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("formError").parts("text", "icon");
const $52fc62550c714bbf$export$1ffeb100b532f46d = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("input").parts("addon", "field", "element", "group");
const $52fc62550c714bbf$export$12b3a655a94374ed = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("list").parts("container", "item", "icon");
const $52fc62550c714bbf$export$e251092a5dcb1329 = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("menu").parts("button", "list", "item", "groupTitle", "icon", "command", "divider");
const $52fc62550c714bbf$export$34e33beb8d992ac2 = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("modal").parts("overlay", "dialogContainer", "dialog", "header", "closeButton", "body", "footer");
const $52fc62550c714bbf$export$859cc7ca3200df97 = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("numberinput").parts("root", "field", "stepperGroup", "stepper");
const $52fc62550c714bbf$export$12bb869d7991ac50 = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("pininput").parts("field");
const $52fc62550c714bbf$export$afda07d12cd4337d = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("popover").parts("content", "header", "body", "footer", "popper", "arrow", "closeButton");
const $52fc62550c714bbf$export$ba6328c242bd649c = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("progress").parts("label", "filledTrack", "track");
const $52fc62550c714bbf$export$d28d06d0e29ef022 = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("radio").parts("container", "control", "label");
const $52fc62550c714bbf$export$17993f0be9538b5a = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("select").parts("field", "icon");
const $52fc62550c714bbf$export$c21b4b3f8b239f32 = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("slider").parts("container", "track", "thumb", "filledTrack", "mark");
const $52fc62550c714bbf$export$2cfbad67ae6ee421 = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("stat").parts("container", "label", "helpText", "number", "icon");
const $52fc62550c714bbf$export$921c1a2d1ce1e86a = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("switch").parts("container", "track", "thumb", "label");
const $52fc62550c714bbf$export$8b1b9cdd5db9f5fd = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("table").parts("table", "thead", "tbody", "tr", "th", "td", "tfoot", "caption");
const $52fc62550c714bbf$export$97383552563be58d = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("tabs").parts("root", "tab", "tablist", "tabpanel", "tabpanels", "indicator");
const $52fc62550c714bbf$export$4c2f5f7f2ea94a8e = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("tag").parts("container", "label", "closeButton");
const $52fc62550c714bbf$export$487a447ffa5755b6 = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("card").parts("container", "header", "body", "footer");
const $52fc62550c714bbf$export$76976ae72ac68c27 = (0, $e0dd48e6f7e62a59$export$477202748c7242bf)("stepper").parts("stepper", "step", "title", "description", "indicator", "separator", "icon", "number");


function $8d7ccf069e08e0a2$export$9a6b93c1c4f92839(styles) {
    return styles;
}
function $8d7ccf069e08e0a2$export$5c9a64458a4ed8a4(config) {
    return config;
}
function $8d7ccf069e08e0a2$export$d5f717dc145477b8(parts) {
    return {
        definePartsStyle (config) {
            return config;
        },
        defineMultiStyleConfig (config) {
            return {
                parts: parts,
                ...config
            };
        }
    };
}


const { definePartsStyle: $023ac293753e3098$var$definePartsStyle, defineMultiStyleConfig: $023ac293753e3098$var$defineMultiStyleConfig } = (0, $8d7ccf069e08e0a2$export$d5f717dc145477b8)((0, $52fc62550c714bbf$export$377a77e99e7c73a5).keys);
const $023ac293753e3098$var$baseStyleContainer = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    borderTopWidth: "1px",
    borderColor: "inherit",
    _last: {
        borderBottomWidth: "1px"
    }
});
const $023ac293753e3098$var$baseStyleButton = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    transitionProperty: "common",
    transitionDuration: "normal",
    fontSize: "md",
    _focusVisible: {
        boxShadow: "outline"
    },
    _hover: {
        bg: "blackAlpha.50"
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
    },
    px: "4",
    py: "2"
});
const $023ac293753e3098$var$baseStylePanel = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    pt: "2",
    px: "4",
    pb: "5"
});
const $023ac293753e3098$var$baseStyleIcon = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    fontSize: "1.25em"
});
const $023ac293753e3098$var$baseStyle = $023ac293753e3098$var$definePartsStyle({
    container: $023ac293753e3098$var$baseStyleContainer,
    button: $023ac293753e3098$var$baseStyleButton,
    panel: $023ac293753e3098$var$baseStylePanel,
    icon: $023ac293753e3098$var$baseStyleIcon
});
const $023ac293753e3098$export$20ec2254f76fa604 = $023ac293753e3098$var$defineMultiStyleConfig({
    baseStyle: $023ac293753e3098$var$baseStyle
});



function $b8e754b253ef3f21$var$replaceWhiteSpace(value, replaceValue = "-") {
    return value.replace(/\s+/g, replaceValue);
}
function $b8e754b253ef3f21$var$escape(value) {
    const valueStr = $b8e754b253ef3f21$var$replaceWhiteSpace(value.toString());
    return $b8e754b253ef3f21$var$escapeSymbol($b8e754b253ef3f21$var$escapeDot(valueStr));
}
function $b8e754b253ef3f21$var$escapeDot(value) {
    if (value.includes("\\.")) return value;
    const isDecimal = !Number.isInteger(parseFloat(value.toString()));
    return isDecimal ? value.replace(".", `\\.`) : value;
}
function $b8e754b253ef3f21$var$escapeSymbol(value) {
    return value.replace(/[!-,/:-@[-^`{-~]/g, "\\$&");
}
function $b8e754b253ef3f21$export$9748efee331ec573(value, prefix = "") {
    return [
        prefix,
        value
    ].filter(Boolean).join("-");
}
function $b8e754b253ef3f21$export$bb435e137b4b8e38(name, fallback) {
    return `var(${name}${fallback ? `, ${fallback}` : ""})`;
}
function $b8e754b253ef3f21$export$3695bd65cc73dae9(value, prefix = "") {
    return $b8e754b253ef3f21$var$escape(`--${$b8e754b253ef3f21$export$9748efee331ec573(value, prefix)}`);
}
function $b8e754b253ef3f21$export$8b4981022bd80a4e(name, fallback, cssVarPrefix) {
    const cssVariable = $b8e754b253ef3f21$export$3695bd65cc73dae9(name, cssVarPrefix);
    return {
        variable: cssVariable,
        reference: $b8e754b253ef3f21$export$bb435e137b4b8e38(cssVariable, fallback)
    };
}
function $b8e754b253ef3f21$export$bd40561c6c056841(scope, keys) {
    const vars = {};
    for (const key of keys){
        if (Array.isArray(key)) {
            const [name, fallback] = key;
            vars[name] = $b8e754b253ef3f21$export$8b4981022bd80a4e(`${scope}-${name}`, fallback);
            continue;
        }
        vars[key] = $b8e754b253ef3f21$export$8b4981022bd80a4e(`${scope}-${key}`);
    }
    return vars;
}


function $7aa42ca4064af0f9$export$93c8e06b7014dc33(theme, scale, value) {
    return theme.__cssMap?.[`${scale}.${value}`]?.varRef ?? value;
}


/**
 * A simple guard function:
 *
 * ```js
 * Math.min(Math.max(low, value), high)
 * ```
 */ function $3166f38b2e6db4ea$export$864d727b48066337(low, high, value) {
    return Math.min(Math.max(low, value), high);
}
class $3166f38b2e6db4ea$var$ColorError extends Error {
    constructor(color){
        super(`Failed to parse color: "${color}"`);
    }
}
var $3166f38b2e6db4ea$export$21f8cadbc4af9bbf = $3166f38b2e6db4ea$var$ColorError;
/**
 * Parses a color into red, gree, blue, alpha parts
 *
 * @param color the input color. Can be a RGB, RBGA, HSL, HSLA, or named color
 */ function $3166f38b2e6db4ea$export$88c26fe48243d749(color) {
    if (typeof color !== "string") throw new $3166f38b2e6db4ea$export$21f8cadbc4af9bbf(color);
    if (color.trim().toLowerCase() === "transparent") return [
        0,
        0,
        0,
        0
    ];
    let normalizedColor = color.trim();
    normalizedColor = $3166f38b2e6db4ea$var$namedColorRegex.test(color) ? $3166f38b2e6db4ea$var$nameToHex(color) : color;
    const reducedHexMatch = $3166f38b2e6db4ea$var$reducedHexRegex.exec(normalizedColor);
    if (reducedHexMatch) {
        const arr = Array.from(reducedHexMatch).slice(1);
        return [
            ...arr.slice(0, 3).map((x)=>parseInt($3166f38b2e6db4ea$var$r(x, 2), 16)),
            parseInt($3166f38b2e6db4ea$var$r(arr[3] || "f", 2), 16) / 255
        ];
    }
    const hexMatch = $3166f38b2e6db4ea$var$hexRegex.exec(normalizedColor);
    if (hexMatch) {
        const arr = Array.from(hexMatch).slice(1);
        return [
            ...arr.slice(0, 3).map((x)=>parseInt(x, 16)),
            parseInt(arr[3] || "ff", 16) / 255
        ];
    }
    const rgbaMatch = $3166f38b2e6db4ea$var$rgbaRegex.exec(normalizedColor);
    if (rgbaMatch) {
        const arr = Array.from(rgbaMatch).slice(1);
        return [
            ...arr.slice(0, 3).map((x)=>parseInt(x, 10)),
            parseFloat(arr[3] || "1")
        ];
    }
    const hslaMatch = $3166f38b2e6db4ea$var$hslaRegex.exec(normalizedColor);
    if (hslaMatch) {
        const [h, s, l, a] = Array.from(hslaMatch).slice(1).map(parseFloat);
        if ($3166f38b2e6db4ea$export$864d727b48066337(0, 100, s) !== s) throw new $3166f38b2e6db4ea$export$21f8cadbc4af9bbf(color);
        if ($3166f38b2e6db4ea$export$864d727b48066337(0, 100, l) !== l) throw new $3166f38b2e6db4ea$export$21f8cadbc4af9bbf(color);
        return [
            ...$3166f38b2e6db4ea$var$hslToRgb(h, s, l),
            Number.isNaN(a) ? 1 : a
        ];
    }
    throw new $3166f38b2e6db4ea$export$21f8cadbc4af9bbf(color);
}
function $3166f38b2e6db4ea$var$hash(str) {
    let hash = 5381;
    let i = str.length;
    while(i)hash = hash * 33 ^ str.charCodeAt(--i);
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */ return (hash >>> 0) % 2341;
}
const $3166f38b2e6db4ea$var$colorToInt = (x)=>parseInt(x.replace(/_/g, ""), 36);
const $3166f38b2e6db4ea$var$compressedColorMap = "1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm".split(" ").reduce((acc, next)=>{
    const key = $3166f38b2e6db4ea$var$colorToInt(next.substring(0, 3));
    const hex = $3166f38b2e6db4ea$var$colorToInt(next.substring(3)).toString(16);
    // NOTE: padStart could be used here but it breaks Node 6 compat
    // https://github.com/ricokahler/color2k/issues/351
    let prefix = "";
    for(let i = 0; i < 6 - hex.length; i++)prefix += "0";
    acc[key] = `${prefix}${hex}`;
    return acc;
}, {});
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 */ function $3166f38b2e6db4ea$var$nameToHex(color) {
    const normalizedColorName = color.toLowerCase().trim();
    const result = $3166f38b2e6db4ea$var$compressedColorMap[$3166f38b2e6db4ea$var$hash(normalizedColorName)];
    if (!result) throw new $3166f38b2e6db4ea$export$21f8cadbc4af9bbf(color);
    return `#${result}`;
}
const $3166f38b2e6db4ea$var$r = (str, amount)=>Array.from(Array(amount)).map(()=>str).join("");
const $3166f38b2e6db4ea$var$reducedHexRegex = new RegExp(`^#${$3166f38b2e6db4ea$var$r("([a-f0-9])", 3)}([a-f0-9])?$`, "i");
const $3166f38b2e6db4ea$var$hexRegex = new RegExp(`^#${$3166f38b2e6db4ea$var$r("([a-f0-9]{2})", 3)}([a-f0-9]{2})?$`, "i");
const $3166f38b2e6db4ea$var$rgbaRegex = new RegExp(`^rgba?\\(\\s*(\\d+)\\s*${$3166f38b2e6db4ea$var$r(",\\s*(\\d+)\\s*", 2)}(?:,\\s*([\\d.]+))?\\s*\\)$`, "i");
const $3166f38b2e6db4ea$var$hslaRegex = /^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i;
const $3166f38b2e6db4ea$var$namedColorRegex = /^[a-z]+$/i;
const $3166f38b2e6db4ea$var$roundColor = (color)=>{
    return Math.round(color * 255);
};
const $3166f38b2e6db4ea$var$hslToRgb = (hue, saturation, lightness)=>{
    let l = lightness / 100;
    if (saturation === 0) // achromatic
    return [
        l,
        l,
        l
    ].map($3166f38b2e6db4ea$var$roundColor);
    // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
    const huePrime = (hue % 360 + 360) % 360 / 60;
    const chroma = (1 - Math.abs(2 * l - 1)) * (saturation / 100);
    const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    let red = 0;
    let green = 0;
    let blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    const lightnessModification = l - chroma / 2;
    const finalRed = red + lightnessModification;
    const finalGreen = green + lightnessModification;
    const finalBlue = blue + lightnessModification;
    return [
        finalRed,
        finalGreen,
        finalBlue
    ].map($3166f38b2e6db4ea$var$roundColor);
};
// taken from:
// https://github.com/styled-components/polished/blob/a23a6a2bb26802b3d922d9c3b67bac3f3a54a310/src/internalHelpers/_rgbToHsl.js
/**
 * Parses a color in hue, saturation, lightness, and the alpha channel.
 *
 * Hue is a number between 0 and 360, saturation, lightness, and alpha are
 * decimal percentages between 0 and 1
 */ function $3166f38b2e6db4ea$export$c7d9b10ca8edee87(color) {
    const [red, green, blue, alpha] = $3166f38b2e6db4ea$export$88c26fe48243d749(color).map((value, index)=>// 3rd index is alpha channel which is already normalized
        index === 3 ? value : value / 255);
    const max = Math.max(red, green, blue);
    const min = Math.min(red, green, blue);
    const lightness = (max + min) / 2;
    // achromatic
    if (max === min) return [
        0,
        0,
        lightness,
        alpha
    ];
    const delta = max - min;
    const saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
    const hue = 60 * (red === max ? (green - blue) / delta + (green < blue ? 6 : 0) : green === max ? (blue - red) / delta + 2 : (red - green) / delta + 4);
    return [
        hue,
        saturation,
        lightness,
        alpha
    ];
}
/**
 * Takes in hsla parts and constructs an hsla string
 *
 * @param hue The color circle (from 0 to 360) - 0 (or 360) is red, 120 is green, 240 is blue
 * @param saturation Percentage of saturation, given as a decimal between 0 and 1
 * @param lightness Percentage of lightness, given as a decimal between 0 and 1
 * @param alpha Percentage of opacity, given as a decimal between 0 and 1
 */ function $3166f38b2e6db4ea$export$810b04175080204c(hue, saturation, lightness, alpha) {
    return `hsla(${(hue % 360).toFixed()}, ${$3166f38b2e6db4ea$export$864d727b48066337(0, 100, saturation * 100).toFixed()}%, ${$3166f38b2e6db4ea$export$864d727b48066337(0, 100, lightness * 100).toFixed()}%, ${parseFloat($3166f38b2e6db4ea$export$864d727b48066337(0, 1, alpha).toFixed(3))})`;
}
/**
 * Adjusts the current hue of the color by the given degrees. Wraps around when
 * over 360.
 *
 * @param color input color
 * @param degrees degrees to adjust the input color, accepts degree integers
 * (0 - 360) and wraps around on overflow
 */ function $3166f38b2e6db4ea$export$2b372a09365374d6(color, degrees) {
    const [h, s, l, a] = $3166f38b2e6db4ea$export$c7d9b10ca8edee87(color);
    return $3166f38b2e6db4ea$export$810b04175080204c(h + degrees, s, l, a);
}
/**
 * Darkens using lightness. This is equivalent to subtracting the lightness
 * from the L in HSL.
 *
 * @param amount The amount to darken, given as a decimal between 0 and 1
 */ function $3166f38b2e6db4ea$export$4b073707ff63303(color, amount) {
    const [hue, saturation, lightness, alpha] = $3166f38b2e6db4ea$export$c7d9b10ca8edee87(color);
    return $3166f38b2e6db4ea$export$810b04175080204c(hue, saturation, lightness - amount, alpha);
}
/**
 * Desaturates the input color by the given amount via subtracting from the `s`
 * in `hsla`.
 *
 * @param amount The amount to desaturate, given as a decimal between 0 and 1
 */ function $3166f38b2e6db4ea$export$fb75607d98509d9(color, amount) {
    const [h, s, l, a] = $3166f38b2e6db4ea$export$c7d9b10ca8edee87(color);
    return $3166f38b2e6db4ea$export$810b04175080204c(h, s - amount, l, a);
}
// taken from:
// https://github.com/styled-components/polished/blob/0764c982551b487469043acb56281b0358b3107b/src/color/getLuminance.js
/**
 * Returns a number (float) representing the luminance of a color.
 */ function $3166f38b2e6db4ea$export$c852d90bf7403b62(color) {
    if (color === "transparent") return 0;
    function f(x) {
        const channel = x / 255;
        return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }
    const [r, g, b] = $3166f38b2e6db4ea$export$88c26fe48243d749(color);
    return 0.2126 * f(r) + 0.7152 * f(g) + 0.0722 * f(b);
}
// taken from:
// https://github.com/styled-components/polished/blob/0764c982551b487469043acb56281b0358b3107b/src/color/getContrast.js
/**
 * Returns the contrast ratio between two colors based on
 * [W3's recommended equation for calculating contrast](http://www.w3.org/TR/WCAG20/#contrast-ratiodef).
 */ function $3166f38b2e6db4ea$export$850ce485a60d103b(color1, color2) {
    const luminance1 = $3166f38b2e6db4ea$export$c852d90bf7403b62(color1);
    const luminance2 = $3166f38b2e6db4ea$export$c852d90bf7403b62(color2);
    return luminance1 > luminance2 ? (luminance1 + 0.05) / (luminance2 + 0.05) : (luminance2 + 0.05) / (luminance1 + 0.05);
}
/**
 * Takes in rgba parts and returns an rgba string
 *
 * @param red The amount of red in the red channel, given in a number between 0 and 255 inclusive
 * @param green The amount of green in the red channel, given in a number between 0 and 255 inclusive
 * @param blue The amount of blue in the red channel, given in a number between 0 and 255 inclusive
 * @param alpha Percentage of opacity, given as a decimal between 0 and 1
 */ function $3166f38b2e6db4ea$export$4e46ac54fc82cf3b(red, green, blue, alpha) {
    return `rgba(${$3166f38b2e6db4ea$export$864d727b48066337(0, 255, red).toFixed()}, ${$3166f38b2e6db4ea$export$864d727b48066337(0, 255, green).toFixed()}, ${$3166f38b2e6db4ea$export$864d727b48066337(0, 255, blue).toFixed()}, ${parseFloat($3166f38b2e6db4ea$export$864d727b48066337(0, 1, alpha).toFixed(3))})`;
}
/**
 * Mixes two colors together. Taken from sass's implementation.
 */ function $3166f38b2e6db4ea$export$2c9e8a9632a706b2(color1, color2, weight) {
    const normalize = (n, index)=>// 3rd index is alpha channel which is already normalized
        index === 3 ? n : n / 255;
    const [r1, g1, b1, a1] = $3166f38b2e6db4ea$export$88c26fe48243d749(color1).map(normalize);
    const [r2, g2, b2, a2] = $3166f38b2e6db4ea$export$88c26fe48243d749(color2).map(normalize);
    // The formula is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
    const alphaDelta = a2 - a1;
    const normalizedWeight = weight * 2 - 1;
    const combinedWeight = normalizedWeight * alphaDelta === -1 ? normalizedWeight : normalizedWeight + alphaDelta / (1 + normalizedWeight * alphaDelta);
    const weight2 = (combinedWeight + 1) / 2;
    const weight1 = 1 - weight2;
    const r = (r1 * weight1 + r2 * weight2) * 255;
    const g = (g1 * weight1 + g2 * weight2) * 255;
    const b = (b1 * weight1 + b2 * weight2) * 255;
    const a = a2 * weight + a1 * (1 - weight);
    return $3166f38b2e6db4ea$export$4e46ac54fc82cf3b(r, g, b, a);
}
/**
 * Given a series colors, this function will return a `scale(x)` function that
 * accepts a percentage as a decimal between 0 and 1 and returns the color at
 * that percentage in the scale.
 *
 * ```js
 * const scale = getScale('red', 'yellow', 'green');
 * console.log(scale(0)); // rgba(255, 0, 0, 1)
 * console.log(scale(0.5)); // rgba(255, 255, 0, 1)
 * console.log(scale(1)); // rgba(0, 128, 0, 1)
 * ```
 *
 * If you'd like to limit the domain and range like chroma-js, we recommend
 * wrapping scale again.
 *
 * ```js
 * const _scale = getScale('red', 'yellow', 'green');
 * const scale = x => _scale(x / 100);
 *
 * console.log(scale(0)); // rgba(255, 0, 0, 1)
 * console.log(scale(50)); // rgba(255, 255, 0, 1)
 * console.log(scale(100)); // rgba(0, 128, 0, 1)
 * ```
 */ function $3166f38b2e6db4ea$export$5cdac61cf538712e(...colors) {
    return (n)=>{
        const lastIndex = colors.length - 1;
        const lowIndex = $3166f38b2e6db4ea$export$864d727b48066337(0, lastIndex, Math.floor(n * lastIndex));
        const highIndex = $3166f38b2e6db4ea$export$864d727b48066337(0, lastIndex, Math.ceil(n * lastIndex));
        const color1 = colors[lowIndex];
        const color2 = colors[highIndex];
        const unit = 1 / lastIndex;
        const weight = (n - unit * lowIndex) / unit;
        return $3166f38b2e6db4ea$export$2c9e8a9632a706b2(color1, color2, weight);
    };
}
const $3166f38b2e6db4ea$var$guidelines = {
    decorative: 1.5,
    readable: 3,
    aa: 4.5,
    aaa: 7
};
/**
 * Returns whether or not a color has bad contrast against a background
 * according to a given standard.
 */ function $3166f38b2e6db4ea$export$f4ab80233a44f806(color, standard = "aa", background = "#fff") {
    return $3166f38b2e6db4ea$export$850ce485a60d103b(color, background) < $3166f38b2e6db4ea$var$guidelines[standard];
}
/**
 * Lightens a color by a given amount. This is equivalent to
 * `darken(color, -amount)`
 *
 * @param amount The amount to darken, given as a decimal between 0 and 1
 */ function $3166f38b2e6db4ea$export$c0816ed86df316af(color, amount) {
    return $3166f38b2e6db4ea$export$4b073707ff63303(color, -amount);
}
/**
 * Takes in a color and makes it more transparent by convert to `rgba` and
 * decreasing the amount in the alpha channel.
 *
 * @param amount The amount to increase the transparency by, given as a decimal between 0 and 1
 */ function $3166f38b2e6db4ea$export$d11da87e55cc498f(color, amount) {
    const [r, g, b, a] = $3166f38b2e6db4ea$export$88c26fe48243d749(color);
    return $3166f38b2e6db4ea$export$4e46ac54fc82cf3b(r, g, b, a - amount);
}
/**
 * Takes a color and un-transparentizes it. Equivalent to
 * `transparentize(color, -amount)`
 *
 * @param amount The amount to increase the opacity by, given as a decimal between 0 and 1
 */ function $3166f38b2e6db4ea$export$f4f50e3877dd0530(color, amount) {
    return $3166f38b2e6db4ea$export$d11da87e55cc498f(color, -amount);
}
/**
 * An alternative function to `readableColor`. Returns whether or not the 
 * readable color (i.e. the color to be place on top the input color) should be
 * black.
 */ function $3166f38b2e6db4ea$export$dcb2d24cf045d06(color) {
    return $3166f38b2e6db4ea$export$c852d90bf7403b62(color) > 0.179;
}
/**
 * Returns black or white for best contrast depending on the luminosity of the
 * given color.
 */ function $3166f38b2e6db4ea$export$61654c1796c44811(color) {
    return $3166f38b2e6db4ea$export$dcb2d24cf045d06(color) ? "#000" : "#fff";
}
/**
 * Saturates a color by converting it to `hsl` and increasing the saturation
 * amount. Equivalent to `desaturate(color, -amount)`
 * 
 * @param color Input color
 * @param amount The amount to darken, given as a decimal between 0 and 1
 */ function $3166f38b2e6db4ea$export$5fcac96f5a87e3db(color, amount) {
    return $3166f38b2e6db4ea$export$fb75607d98509d9(color, -amount);
}
/**
 * Takes in any color and returns it as a hex code.
 */ function $3166f38b2e6db4ea$export$7ea66e3774a60b67(color) {
    const [r, g, b, a] = $3166f38b2e6db4ea$export$88c26fe48243d749(color);
    let hex = (x)=>{
        const h = $3166f38b2e6db4ea$export$864d727b48066337(0, 255, x).toString(16);
        // NOTE: padStart could be used here but it breaks Node 6 compat
        // https://github.com/ricokahler/color2k/issues/351
        return h.length === 1 ? `0${h}` : h;
    };
    return `#${hex(r)}${hex(g)}${hex(b)}${a < 1 ? hex(Math.round(a * 255)) : ""}`;
}
/**
 * Takes in any color and returns it as an rgba string.
 */ function $3166f38b2e6db4ea$export$5db297beaffffbfc(color) {
    return $3166f38b2e6db4ea$export$4e46ac54fc82cf3b(...$3166f38b2e6db4ea$export$88c26fe48243d749(color));
}
/**
 * Takes in any color and returns it as an hsla string.
 */ function $3166f38b2e6db4ea$export$b9678a7d4ac803cc(color) {
    return $3166f38b2e6db4ea$export$810b04175080204c(...$3166f38b2e6db4ea$export$c7d9b10ca8edee87(color));
}


const $4d69a52220934355$var$isEmptyObject = (obj)=>Object.keys(obj).length === 0;
function $4d69a52220934355$var$get(obj, key, def, p, undef) {
    key = key.split ? key.split(".") : key;
    for(p = 0; p < key.length; p++)obj = obj ? obj[key[p]] : undef;
    return obj === undef ? def : obj;
}
const $4d69a52220934355$export$5551a2d24ff40153 = (theme, color, fallback)=>{
    const hex = $4d69a52220934355$var$get(theme, `colors.${color}`, color);
    try {
        (0, $3166f38b2e6db4ea$export$7ea66e3774a60b67)(hex);
        return hex;
    } catch  {
        return fallback ?? "#000000";
    }
};
const $4d69a52220934355$export$fdaf813cf8a11246 = (theme, color, fallback)=>{
    return (0, $7aa42ca4064af0f9$export$93c8e06b7014dc33)(theme, "colors", color) ?? fallback;
};
const $4d69a52220934355$var$getBrightness = (color)=>{
    const [r, g, b] = (0, $3166f38b2e6db4ea$export$88c26fe48243d749)(color);
    return (r * 299 + g * 587 + b * 114) / 1e3;
};
const $4d69a52220934355$export$7297c25227171a1f = (color)=>(theme)=>{
        const hex = $4d69a52220934355$export$5551a2d24ff40153(theme, color);
        const brightness = $4d69a52220934355$var$getBrightness(hex);
        const isDark2 = brightness < 128;
        return isDark2 ? "dark" : "light";
    };
const $4d69a52220934355$export$a79ad82046afa44e = (color)=>(theme)=>$4d69a52220934355$export$7297c25227171a1f(color)(theme) === "dark";
const $4d69a52220934355$export$44af652f4cca9039 = (color)=>(theme)=>$4d69a52220934355$export$7297c25227171a1f(color)(theme) === "light";
const $4d69a52220934355$export$d11da87e55cc498f = (color, opacity)=>(theme)=>{
        const raw = $4d69a52220934355$export$5551a2d24ff40153(theme, color);
        return (0, $3166f38b2e6db4ea$export$d11da87e55cc498f)(raw, 1 - opacity);
    };
const $4d69a52220934355$export$81525e9955aa80e8 = (color, amount)=>(theme)=>{
        const raw = $4d69a52220934355$export$5551a2d24ff40153(theme, color);
        return (0, $3166f38b2e6db4ea$export$7ea66e3774a60b67)((0, $3166f38b2e6db4ea$export$2c9e8a9632a706b2)(raw, "#fff", amount));
    };
const $4d69a52220934355$export$2b471577c483101c = (color, amount)=>(theme)=>{
        const raw = $4d69a52220934355$export$5551a2d24ff40153(theme, color);
        return (0, $3166f38b2e6db4ea$export$7ea66e3774a60b67)((0, $3166f38b2e6db4ea$export$2c9e8a9632a706b2)(raw, "#000", amount / 100));
    };
const $4d69a52220934355$export$4b073707ff63303 = (color, amount)=>(theme)=>{
        const raw = $4d69a52220934355$export$5551a2d24ff40153(theme, color);
        return (0, $3166f38b2e6db4ea$export$7ea66e3774a60b67)((0, $3166f38b2e6db4ea$export$4b073707ff63303)(raw, amount / 100));
    };
const $4d69a52220934355$export$c0816ed86df316af = (color, amount)=>(theme)=>{
        const raw = $4d69a52220934355$export$5551a2d24ff40153(theme, color);
        (0, $3166f38b2e6db4ea$export$7ea66e3774a60b67)((0, $3166f38b2e6db4ea$export$c0816ed86df316af)(raw, amount / 100));
    };
const $4d69a52220934355$export$1ec78ac20028ebd4 = (fg, bg)=>(theme)=>(0, $3166f38b2e6db4ea$export$850ce485a60d103b)($4d69a52220934355$export$5551a2d24ff40153(theme, bg), $4d69a52220934355$export$5551a2d24ff40153(theme, fg));
const $4d69a52220934355$export$cd41ae544cfc2a65 = (textColor, bgColor, options)=>(theme)=>$4d69a52220934355$export$3fe5b5ca1e6a6a28($4d69a52220934355$export$5551a2d24ff40153(theme, bgColor), $4d69a52220934355$export$5551a2d24ff40153(theme, textColor), options);
function $4d69a52220934355$export$3fe5b5ca1e6a6a28(color1, color2, wcag2 = {
    level: "AA",
    size: "small"
}) {
    const readabilityLevel = $4d69a52220934355$export$b7b705aaad1c5b6a(color1, color2);
    switch((wcag2.level ?? "AA") + (wcag2.size ?? "small")){
        case "AAsmall":
        case "AAAlarge":
            return readabilityLevel >= 4.5;
        case "AAlarge":
            return readabilityLevel >= 3;
        case "AAAsmall":
            return readabilityLevel >= 7;
        default:
            return false;
    }
}
function $4d69a52220934355$export$b7b705aaad1c5b6a(color1, color2) {
    return (Math.max((0, $3166f38b2e6db4ea$export$c852d90bf7403b62)(color1), (0, $3166f38b2e6db4ea$export$c852d90bf7403b62)(color2)) + 0.05) / (Math.min((0, $3166f38b2e6db4ea$export$c852d90bf7403b62)(color1), (0, $3166f38b2e6db4ea$export$c852d90bf7403b62)(color2)) + 0.05);
}
const $4d69a52220934355$export$504efcfbebdbcaf = (color)=>(theme)=>{
        const raw = $4d69a52220934355$export$5551a2d24ff40153(theme, color);
        const hsl = (0, $3166f38b2e6db4ea$export$c7d9b10ca8edee87)(raw);
        const complementHsl = Object.assign(hsl, [
            (hsl[0] + 180) % 360
        ]);
        return (0, $3166f38b2e6db4ea$export$7ea66e3774a60b67)((0, $3166f38b2e6db4ea$export$810b04175080204c)(...complementHsl));
    };
function $4d69a52220934355$export$db0ffb03ee9f3080(size = "1rem", color = "rgba(255, 255, 255, 0.15)") {
    return {
        backgroundImage: `linear-gradient(
    45deg,
    ${color} 25%,
    transparent 25%,
    transparent 50%,
    ${color} 50%,
    ${color} 75%,
    transparent 75%,
    transparent
  )`,
        backgroundSize: `${size} ${size}`
    };
}
const $4d69a52220934355$var$randomHex = ()=>`#${Math.floor(Math.random() * 16777215).toString(16).padEnd(6, "0")}`;
function $4d69a52220934355$export$f3c6ed4330abfc18(opts) {
    const fallback = $4d69a52220934355$var$randomHex();
    if (!opts || $4d69a52220934355$var$isEmptyObject(opts)) return fallback;
    if (opts.string && opts.colors) return $4d69a52220934355$var$randomColorFromList(opts.string, opts.colors);
    if (opts.string && !opts.colors) return $4d69a52220934355$var$randomColorFromString(opts.string);
    if (opts.colors && !opts.string) return $4d69a52220934355$var$randomFromList(opts.colors);
    return fallback;
}
function $4d69a52220934355$var$randomColorFromString(str) {
    let hash = 0;
    if (str.length === 0) return hash.toString();
    for(let i = 0; i < str.length; i += 1){
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
    }
    let color = "#";
    for(let j = 0; j < 3; j += 1){
        const value = hash >> j * 8 & 255;
        color += `00${value.toString(16)}`.substr(-2);
    }
    return color;
}
function $4d69a52220934355$var$randomColorFromList(str, list) {
    let index = 0;
    if (str.length === 0) return list[0];
    for(let i = 0; i < str.length; i += 1){
        index = str.charCodeAt(i) + ((index << 5) - index);
        index = index & index;
    }
    index = (index % list.length + list.length) % list.length;
    return list[index];
}
function $4d69a52220934355$var$randomFromList(list) {
    return list[Math.floor(Math.random() * list.length)];
}


const { definePartsStyle: $d7cb368afffa3532$var$definePartsStyle, defineMultiStyleConfig: $d7cb368afffa3532$var$defineMultiStyleConfig } = (0, $8d7ccf069e08e0a2$export$d5f717dc145477b8)((0, $52fc62550c714bbf$export$fc51889fa4de265a).keys);
const $d7cb368afffa3532$var$$fg = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("alert-fg");
const $d7cb368afffa3532$var$$bg = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("alert-bg");
const $d7cb368afffa3532$var$baseStyle = $d7cb368afffa3532$var$definePartsStyle({
    container: {
        bg: $d7cb368afffa3532$var$$bg.reference,
        px: "4",
        py: "3"
    },
    title: {
        fontWeight: "bold",
        lineHeight: "6",
        marginEnd: "2"
    },
    description: {
        lineHeight: "6"
    },
    icon: {
        color: $d7cb368afffa3532$var$$fg.reference,
        flexShrink: 0,
        marginEnd: "3",
        w: "5",
        h: "6"
    },
    spinner: {
        color: $d7cb368afffa3532$var$$fg.reference,
        flexShrink: 0,
        marginEnd: "3",
        w: "5",
        h: "5"
    }
});
function $d7cb368afffa3532$var$getBg(props) {
    const { theme: theme, colorScheme: c } = props;
    const darkBg = (0, $4d69a52220934355$export$d11da87e55cc498f)(`${c}.200`, 0.16)(theme);
    return {
        light: `colors.${c}.100`,
        dark: darkBg
    };
}
const $d7cb368afffa3532$var$variantSubtle = $d7cb368afffa3532$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    const bg = $d7cb368afffa3532$var$getBg(props);
    return {
        container: {
            [$d7cb368afffa3532$var$$fg.variable]: `colors.${c}.600`,
            [$d7cb368afffa3532$var$$bg.variable]: bg.light,
            _dark: {
                [$d7cb368afffa3532$var$$fg.variable]: `colors.${c}.200`,
                [$d7cb368afffa3532$var$$bg.variable]: bg.dark
            }
        }
    };
});
const $d7cb368afffa3532$var$variantLeftAccent = $d7cb368afffa3532$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    const bg = $d7cb368afffa3532$var$getBg(props);
    return {
        container: {
            [$d7cb368afffa3532$var$$fg.variable]: `colors.${c}.600`,
            [$d7cb368afffa3532$var$$bg.variable]: bg.light,
            _dark: {
                [$d7cb368afffa3532$var$$fg.variable]: `colors.${c}.200`,
                [$d7cb368afffa3532$var$$bg.variable]: bg.dark
            },
            paddingStart: "3",
            borderStartWidth: "4px",
            borderStartColor: $d7cb368afffa3532$var$$fg.reference
        }
    };
});
const $d7cb368afffa3532$var$variantTopAccent = $d7cb368afffa3532$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    const bg = $d7cb368afffa3532$var$getBg(props);
    return {
        container: {
            [$d7cb368afffa3532$var$$fg.variable]: `colors.${c}.600`,
            [$d7cb368afffa3532$var$$bg.variable]: bg.light,
            _dark: {
                [$d7cb368afffa3532$var$$fg.variable]: `colors.${c}.200`,
                [$d7cb368afffa3532$var$$bg.variable]: bg.dark
            },
            pt: "2",
            borderTopWidth: "4px",
            borderTopColor: $d7cb368afffa3532$var$$fg.reference
        }
    };
});
const $d7cb368afffa3532$var$variantSolid = $d7cb368afffa3532$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        container: {
            [$d7cb368afffa3532$var$$fg.variable]: `colors.white`,
            [$d7cb368afffa3532$var$$bg.variable]: `colors.${c}.600`,
            _dark: {
                [$d7cb368afffa3532$var$$fg.variable]: `colors.gray.900`,
                [$d7cb368afffa3532$var$$bg.variable]: `colors.${c}.200`
            },
            color: $d7cb368afffa3532$var$$fg.reference
        }
    };
});
const $d7cb368afffa3532$var$variants = {
    subtle: $d7cb368afffa3532$var$variantSubtle,
    "left-accent": $d7cb368afffa3532$var$variantLeftAccent,
    "top-accent": $d7cb368afffa3532$var$variantTopAccent,
    solid: $d7cb368afffa3532$var$variantSolid
};
const $d7cb368afffa3532$export$9d77d9665d829e89 = $d7cb368afffa3532$var$defineMultiStyleConfig({
    baseStyle: $d7cb368afffa3532$var$baseStyle,
    variants: $d7cb368afffa3532$var$variants,
    defaultProps: {
        variant: "subtle",
        colorScheme: "blue"
    }
});





const $e6e0e28ef0210b6a$export$5458b64234d1333c = {
    px: "1px",
    0.5: "0.125rem",
    1: "0.25rem",
    1.5: "0.375rem",
    2: "0.5rem",
    2.5: "0.625rem",
    3: "0.75rem",
    3.5: "0.875rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem",
    12: "3rem",
    14: "3.5rem",
    16: "4rem",
    20: "5rem",
    24: "6rem",
    28: "7rem",
    32: "8rem",
    36: "9rem",
    40: "10rem",
    44: "11rem",
    48: "12rem",
    52: "13rem",
    56: "14rem",
    60: "15rem",
    64: "16rem",
    72: "18rem",
    80: "20rem",
    96: "24rem"
};


const $28f18922c5747ca5$var$largeSizes = {
    max: "max-content",
    min: "min-content",
    full: "100%",
    "3xs": "14rem",
    "2xs": "16rem",
    xs: "20rem",
    sm: "24rem",
    md: "28rem",
    lg: "32rem",
    xl: "36rem",
    "2xl": "42rem",
    "3xl": "48rem",
    "4xl": "56rem",
    "5xl": "64rem",
    "6xl": "72rem",
    "7xl": "80rem",
    "8xl": "90rem",
    prose: "60ch"
};
const $28f18922c5747ca5$var$container = {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px"
};
const $28f18922c5747ca5$export$2e2bcd8739ae039 = {
    ...(0, $e6e0e28ef0210b6a$export$5458b64234d1333c),
    ...$28f18922c5747ca5$var$largeSizes,
    container: $28f18922c5747ca5$var$container
};


const $ce259e7686c84807$var$isFunction = (value)=>typeof value === "function";
function $ce259e7686c84807$export$624e501d81f5ffce(valueOrFn, ...args) {
    return $ce259e7686c84807$var$isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}


const { definePartsStyle: $f8889329eca89b14$var$definePartsStyle, defineMultiStyleConfig: $f8889329eca89b14$var$defineMultiStyleConfig } = (0, $8d7ccf069e08e0a2$export$d5f717dc145477b8)((0, $52fc62550c714bbf$export$60f8655d889e17c7).keys);
const $f8889329eca89b14$var$$border = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("avatar-border-color");
const $f8889329eca89b14$var$$bg = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("avatar-bg");
const $f8889329eca89b14$var$$fs = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("avatar-font-size");
const $f8889329eca89b14$var$$size = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("avatar-size");
const $f8889329eca89b14$var$baseStyleBadge = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    borderRadius: "full",
    border: "0.2em solid",
    borderColor: $f8889329eca89b14$var$$border.reference,
    [$f8889329eca89b14$var$$border.variable]: "white",
    _dark: {
        [$f8889329eca89b14$var$$border.variable]: "colors.gray.800"
    }
});
const $f8889329eca89b14$var$baseStyleExcessLabel = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    bg: $f8889329eca89b14$var$$bg.reference,
    fontSize: $f8889329eca89b14$var$$fs.reference,
    width: $f8889329eca89b14$var$$size.reference,
    height: $f8889329eca89b14$var$$size.reference,
    lineHeight: "1",
    [$f8889329eca89b14$var$$bg.variable]: "colors.gray.200",
    _dark: {
        [$f8889329eca89b14$var$$bg.variable]: "colors.whiteAlpha.400"
    }
});
const $f8889329eca89b14$var$baseStyleContainer = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>{
    const { name: name, theme: theme } = props;
    const bg = name ? (0, $4d69a52220934355$export$f3c6ed4330abfc18)({
        string: name
    }) : "colors.gray.400";
    const isBgDark = (0, $4d69a52220934355$export$a79ad82046afa44e)(bg)(theme);
    let color = "white";
    if (!isBgDark) color = "gray.800";
    return {
        bg: $f8889329eca89b14$var$$bg.reference,
        fontSize: $f8889329eca89b14$var$$fs.reference,
        color: color,
        borderColor: $f8889329eca89b14$var$$border.reference,
        verticalAlign: "top",
        width: $f8889329eca89b14$var$$size.reference,
        height: $f8889329eca89b14$var$$size.reference,
        "&:not([data-loaded])": {
            [$f8889329eca89b14$var$$bg.variable]: bg
        },
        [$f8889329eca89b14$var$$border.variable]: "colors.white",
        _dark: {
            [$f8889329eca89b14$var$$border.variable]: "colors.gray.800"
        }
    };
});
const $f8889329eca89b14$var$baseStyleLabel = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    fontSize: $f8889329eca89b14$var$$fs.reference,
    lineHeight: "1"
});
const $f8889329eca89b14$var$baseStyle = $f8889329eca89b14$var$definePartsStyle((props)=>({
        badge: (0, $ce259e7686c84807$export$624e501d81f5ffce)($f8889329eca89b14$var$baseStyleBadge, props),
        excessLabel: (0, $ce259e7686c84807$export$624e501d81f5ffce)($f8889329eca89b14$var$baseStyleExcessLabel, props),
        container: (0, $ce259e7686c84807$export$624e501d81f5ffce)($f8889329eca89b14$var$baseStyleContainer, props),
        label: $f8889329eca89b14$var$baseStyleLabel
    }));
function $f8889329eca89b14$var$getSize(size) {
    const themeSize = size !== "100%" ? (0, $28f18922c5747ca5$export$2e2bcd8739ae039)[size] : void 0;
    return $f8889329eca89b14$var$definePartsStyle({
        container: {
            [$f8889329eca89b14$var$$size.variable]: themeSize ?? size,
            [$f8889329eca89b14$var$$fs.variable]: `calc(${themeSize ?? size} / 2.5)`
        },
        excessLabel: {
            [$f8889329eca89b14$var$$size.variable]: themeSize ?? size,
            [$f8889329eca89b14$var$$fs.variable]: `calc(${themeSize ?? size} / 2.5)`
        }
    });
}
const $f8889329eca89b14$var$sizes = {
    "2xs": $f8889329eca89b14$var$getSize(4),
    xs: $f8889329eca89b14$var$getSize(6),
    sm: $f8889329eca89b14$var$getSize(8),
    md: $f8889329eca89b14$var$getSize(12),
    lg: $f8889329eca89b14$var$getSize(16),
    xl: $f8889329eca89b14$var$getSize(24),
    "2xl": $f8889329eca89b14$var$getSize(32),
    full: $f8889329eca89b14$var$getSize("100%")
};
const $f8889329eca89b14$export$9975d21893c10e66 = $f8889329eca89b14$var$defineMultiStyleConfig({
    baseStyle: $f8889329eca89b14$var$baseStyle,
    sizes: $f8889329eca89b14$var$sizes,
    defaultProps: {
        size: "md"
    }
});




const $23f998ac7374aa93$export$947cd287c296b479 = (0, $b8e754b253ef3f21$export$bd40561c6c056841)("badge", [
    "bg",
    "color",
    "shadow"
]);
const $23f998ac7374aa93$var$baseStyle = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    px: 1,
    textTransform: "uppercase",
    fontSize: "xs",
    borderRadius: "sm",
    fontWeight: "bold",
    bg: $23f998ac7374aa93$export$947cd287c296b479.bg.reference,
    color: $23f998ac7374aa93$export$947cd287c296b479.color.reference,
    boxShadow: $23f998ac7374aa93$export$947cd287c296b479.shadow.reference
});
const $23f998ac7374aa93$var$variantSolid = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    const dark = (0, $4d69a52220934355$export$d11da87e55cc498f)(`${c}.500`, 0.6)(theme);
    return {
        [$23f998ac7374aa93$export$947cd287c296b479.bg.variable]: `colors.${c}.500`,
        [$23f998ac7374aa93$export$947cd287c296b479.color.variable]: `colors.white`,
        _dark: {
            [$23f998ac7374aa93$export$947cd287c296b479.bg.variable]: dark,
            [$23f998ac7374aa93$export$947cd287c296b479.color.variable]: `colors.whiteAlpha.800`
        }
    };
});
const $23f998ac7374aa93$var$variantSubtle = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    const darkBg = (0, $4d69a52220934355$export$d11da87e55cc498f)(`${c}.200`, 0.16)(theme);
    return {
        [$23f998ac7374aa93$export$947cd287c296b479.bg.variable]: `colors.${c}.100`,
        [$23f998ac7374aa93$export$947cd287c296b479.color.variable]: `colors.${c}.800`,
        _dark: {
            [$23f998ac7374aa93$export$947cd287c296b479.bg.variable]: darkBg,
            [$23f998ac7374aa93$export$947cd287c296b479.color.variable]: `colors.${c}.200`
        }
    };
});
const $23f998ac7374aa93$var$variantOutline = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    const darkColor = (0, $4d69a52220934355$export$d11da87e55cc498f)(`${c}.200`, 0.8)(theme);
    return {
        [$23f998ac7374aa93$export$947cd287c296b479.color.variable]: `colors.${c}.500`,
        _dark: {
            [$23f998ac7374aa93$export$947cd287c296b479.color.variable]: darkColor
        },
        [$23f998ac7374aa93$export$947cd287c296b479.shadow.variable]: `inset 0 0 0px 1px ${$23f998ac7374aa93$export$947cd287c296b479.color.reference}`
    };
});
const $23f998ac7374aa93$var$variants = {
    solid: $23f998ac7374aa93$var$variantSolid,
    subtle: $23f998ac7374aa93$var$variantSubtle,
    outline: $23f998ac7374aa93$var$variantOutline
};
const $23f998ac7374aa93$export$eb6e7cbc82d0f88b = (0, $8d7ccf069e08e0a2$export$5c9a64458a4ed8a4)({
    baseStyle: $23f998ac7374aa93$var$baseStyle,
    variants: $23f998ac7374aa93$var$variants,
    defaultProps: {
        variant: "subtle",
        colorScheme: "gray"
    }
});




const { defineMultiStyleConfig: $9f6f278d0733b607$var$defineMultiStyleConfig, definePartsStyle: $9f6f278d0733b607$var$definePartsStyle } = (0, $8d7ccf069e08e0a2$export$d5f717dc145477b8)((0, $52fc62550c714bbf$export$2fb03f744a6ecf93).keys);
const $9f6f278d0733b607$var$$decor = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("breadcrumb-link-decor");
const $9f6f278d0733b607$var$baseStyleLink = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    transitionProperty: "common",
    transitionDuration: "fast",
    transitionTimingFunction: "ease-out",
    outline: "none",
    color: "inherit",
    textDecoration: $9f6f278d0733b607$var$$decor.reference,
    [$9f6f278d0733b607$var$$decor.variable]: "none",
    "&:not([aria-current=page])": {
        cursor: "pointer",
        _hover: {
            [$9f6f278d0733b607$var$$decor.variable]: "underline"
        },
        _focusVisible: {
            boxShadow: "outline"
        }
    }
});
const $9f6f278d0733b607$var$baseStyle = $9f6f278d0733b607$var$definePartsStyle({
    link: $9f6f278d0733b607$var$baseStyleLink
});
const $9f6f278d0733b607$export$e2d8c6f6af55009 = $9f6f278d0733b607$var$defineMultiStyleConfig({
    baseStyle: $9f6f278d0733b607$var$baseStyle
});



function $37b8f53742d8e800$export$549ff81930776885(light, dark) {
    return (props)=>props.colorMode === "dark" ? dark : light;
}
function $37b8f53742d8e800$export$f3eec17ee6065eee(options) {
    const { orientation: orientation, vertical: vertical, horizontal: horizontal } = options;
    if (!orientation) return {};
    return orientation === "vertical" ? vertical : horizontal;
}



const $d73f50da4c8d30bf$var$baseStyle = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    lineHeight: "1.2",
    borderRadius: "md",
    fontWeight: "semibold",
    transitionProperty: "common",
    transitionDuration: "normal",
    _focusVisible: {
        boxShadow: "outline"
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed",
        boxShadow: "none"
    },
    _hover: {
        _disabled: {
            bg: "initial"
        }
    }
});
const $d73f50da4c8d30bf$var$variantGhost = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    if (c === "gray") return {
        color: (0, $37b8f53742d8e800$export$549ff81930776885)(`gray.800`, `whiteAlpha.900`)(props),
        _hover: {
            bg: (0, $37b8f53742d8e800$export$549ff81930776885)(`gray.100`, `whiteAlpha.200`)(props)
        },
        _active: {
            bg: (0, $37b8f53742d8e800$export$549ff81930776885)(`gray.200`, `whiteAlpha.300`)(props)
        }
    };
    const darkHoverBg = (0, $4d69a52220934355$export$d11da87e55cc498f)(`${c}.200`, 0.12)(theme);
    const darkActiveBg = (0, $4d69a52220934355$export$d11da87e55cc498f)(`${c}.200`, 0.24)(theme);
    return {
        color: (0, $37b8f53742d8e800$export$549ff81930776885)(`${c}.600`, `${c}.200`)(props),
        bg: "transparent",
        _hover: {
            bg: (0, $37b8f53742d8e800$export$549ff81930776885)(`${c}.50`, darkHoverBg)(props)
        },
        _active: {
            bg: (0, $37b8f53742d8e800$export$549ff81930776885)(`${c}.100`, darkActiveBg)(props)
        }
    };
});
const $d73f50da4c8d30bf$var$variantOutline = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    const borderColor = (0, $37b8f53742d8e800$export$549ff81930776885)(`gray.200`, `whiteAlpha.300`)(props);
    return {
        border: "1px solid",
        borderColor: c === "gray" ? borderColor : "currentColor",
        ".chakra-button__group[data-attached][data-orientation=horizontal] > &:not(:last-of-type)": {
            marginEnd: "-1px"
        },
        ".chakra-button__group[data-attached][data-orientation=vertical] > &:not(:last-of-type)": {
            marginBottom: "-1px"
        },
        ...(0, $ce259e7686c84807$export$624e501d81f5ffce)($d73f50da4c8d30bf$var$variantGhost, props)
    };
});
const $d73f50da4c8d30bf$var$accessibleColorMap = {
    yellow: {
        bg: "yellow.400",
        color: "black",
        hoverBg: "yellow.500",
        activeBg: "yellow.600"
    },
    cyan: {
        bg: "cyan.400",
        color: "black",
        hoverBg: "cyan.500",
        activeBg: "cyan.600"
    }
};
const $d73f50da4c8d30bf$var$variantSolid = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    if (c === "gray") {
        const bg2 = (0, $37b8f53742d8e800$export$549ff81930776885)(`gray.100`, `whiteAlpha.200`)(props);
        return {
            bg: bg2,
            color: (0, $37b8f53742d8e800$export$549ff81930776885)(`gray.800`, `whiteAlpha.900`)(props),
            _hover: {
                bg: (0, $37b8f53742d8e800$export$549ff81930776885)(`gray.200`, `whiteAlpha.300`)(props),
                _disabled: {
                    bg: bg2
                }
            },
            _active: {
                bg: (0, $37b8f53742d8e800$export$549ff81930776885)(`gray.300`, `whiteAlpha.400`)(props)
            }
        };
    }
    const { bg: bg = `${c}.500`, color: color = "white", hoverBg: hoverBg = `${c}.600`, activeBg: activeBg = `${c}.700` } = $d73f50da4c8d30bf$var$accessibleColorMap[c] ?? {};
    const background = (0, $37b8f53742d8e800$export$549ff81930776885)(bg, `${c}.200`)(props);
    return {
        bg: background,
        color: (0, $37b8f53742d8e800$export$549ff81930776885)(color, `gray.800`)(props),
        _hover: {
            bg: (0, $37b8f53742d8e800$export$549ff81930776885)(hoverBg, `${c}.300`)(props),
            _disabled: {
                bg: background
            }
        },
        _active: {
            bg: (0, $37b8f53742d8e800$export$549ff81930776885)(activeBg, `${c}.400`)(props)
        }
    };
});
const $d73f50da4c8d30bf$var$variantLink = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    return {
        padding: 0,
        height: "auto",
        lineHeight: "normal",
        verticalAlign: "baseline",
        color: (0, $37b8f53742d8e800$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
        _hover: {
            textDecoration: "underline",
            _disabled: {
                textDecoration: "none"
            }
        },
        _active: {
            color: (0, $37b8f53742d8e800$export$549ff81930776885)(`${c}.700`, `${c}.500`)(props)
        }
    };
});
const $d73f50da4c8d30bf$var$variantUnstyled = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    bg: "none",
    color: "inherit",
    display: "inline",
    lineHeight: "inherit",
    m: "0",
    p: "0"
});
const $d73f50da4c8d30bf$var$variants = {
    ghost: $d73f50da4c8d30bf$var$variantGhost,
    outline: $d73f50da4c8d30bf$var$variantOutline,
    solid: $d73f50da4c8d30bf$var$variantSolid,
    link: $d73f50da4c8d30bf$var$variantLink,
    unstyled: $d73f50da4c8d30bf$var$variantUnstyled
};
const $d73f50da4c8d30bf$var$sizes = {
    lg: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        h: "12",
        minW: "12",
        fontSize: "lg",
        px: "6"
    }),
    md: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        h: "10",
        minW: "10",
        fontSize: "md",
        px: "4"
    }),
    sm: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        h: "8",
        minW: "8",
        fontSize: "sm",
        px: "3"
    }),
    xs: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        h: "6",
        minW: "6",
        fontSize: "xs",
        px: "2"
    })
};
const $d73f50da4c8d30bf$export$577deec5d331f6be = (0, $8d7ccf069e08e0a2$export$5c9a64458a4ed8a4)({
    baseStyle: $d73f50da4c8d30bf$var$baseStyle,
    variants: $d73f50da4c8d30bf$var$variants,
    sizes: $d73f50da4c8d30bf$var$sizes,
    defaultProps: {
        variant: "solid",
        size: "md",
        colorScheme: "gray"
    }
});




const { definePartsStyle: $1e9e9815abc906fb$var$definePartsStyle, defineMultiStyleConfig: $1e9e9815abc906fb$var$defineMultiStyleConfig } = (0, $8d7ccf069e08e0a2$export$d5f717dc145477b8)((0, $52fc62550c714bbf$export$487a447ffa5755b6).keys);
const $1e9e9815abc906fb$var$$bg = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("card-bg");
const $1e9e9815abc906fb$var$$padding = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("card-padding");
const $1e9e9815abc906fb$var$$shadow = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("card-shadow");
const $1e9e9815abc906fb$var$$radius = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("card-radius");
const $1e9e9815abc906fb$var$$border = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("card-border-width", "0");
const $1e9e9815abc906fb$var$$borderColor = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("card-border-color");
const $1e9e9815abc906fb$var$baseStyle = $1e9e9815abc906fb$var$definePartsStyle({
    container: {
        [$1e9e9815abc906fb$var$$bg.variable]: "colors.chakra-body-bg",
        backgroundColor: $1e9e9815abc906fb$var$$bg.reference,
        boxShadow: $1e9e9815abc906fb$var$$shadow.reference,
        borderRadius: $1e9e9815abc906fb$var$$radius.reference,
        color: "chakra-body-text",
        borderWidth: $1e9e9815abc906fb$var$$border.reference,
        borderColor: $1e9e9815abc906fb$var$$borderColor.reference
    },
    body: {
        padding: $1e9e9815abc906fb$var$$padding.reference,
        flex: "1 1 0%"
    },
    header: {
        padding: $1e9e9815abc906fb$var$$padding.reference
    },
    footer: {
        padding: $1e9e9815abc906fb$var$$padding.reference
    }
});
const $1e9e9815abc906fb$var$sizes = {
    sm: $1e9e9815abc906fb$var$definePartsStyle({
        container: {
            [$1e9e9815abc906fb$var$$radius.variable]: "radii.base",
            [$1e9e9815abc906fb$var$$padding.variable]: "space.3"
        }
    }),
    md: $1e9e9815abc906fb$var$definePartsStyle({
        container: {
            [$1e9e9815abc906fb$var$$radius.variable]: "radii.md",
            [$1e9e9815abc906fb$var$$padding.variable]: "space.5"
        }
    }),
    lg: $1e9e9815abc906fb$var$definePartsStyle({
        container: {
            [$1e9e9815abc906fb$var$$radius.variable]: "radii.xl",
            [$1e9e9815abc906fb$var$$padding.variable]: "space.7"
        }
    })
};
const $1e9e9815abc906fb$var$variants = {
    elevated: $1e9e9815abc906fb$var$definePartsStyle({
        container: {
            [$1e9e9815abc906fb$var$$shadow.variable]: "shadows.base",
            _dark: {
                [$1e9e9815abc906fb$var$$bg.variable]: "colors.gray.700"
            }
        }
    }),
    outline: $1e9e9815abc906fb$var$definePartsStyle({
        container: {
            [$1e9e9815abc906fb$var$$border.variable]: "1px",
            [$1e9e9815abc906fb$var$$borderColor.variable]: "colors.chakra-border-color"
        }
    }),
    filled: $1e9e9815abc906fb$var$definePartsStyle({
        container: {
            [$1e9e9815abc906fb$var$$bg.variable]: "colors.chakra-subtle-bg"
        }
    }),
    unstyled: {
        body: {
            [$1e9e9815abc906fb$var$$padding.variable]: 0
        },
        header: {
            [$1e9e9815abc906fb$var$$padding.variable]: 0
        },
        footer: {
            [$1e9e9815abc906fb$var$$padding.variable]: 0
        }
    }
};
const $1e9e9815abc906fb$export$880f7b1201440c23 = $1e9e9815abc906fb$var$defineMultiStyleConfig({
    baseStyle: $1e9e9815abc906fb$var$baseStyle,
    variants: $1e9e9815abc906fb$var$variants,
    sizes: $1e9e9815abc906fb$var$sizes,
    defaultProps: {
        variant: "elevated",
        size: "md"
    }
});






const { definePartsStyle: $0ca4e214b54757fd$var$definePartsStyle, defineMultiStyleConfig: $0ca4e214b54757fd$var$defineMultiStyleConfig } = (0, $8d7ccf069e08e0a2$export$d5f717dc145477b8)((0, $52fc62550c714bbf$export$21946b04497ed6ac).keys);
const $0ca4e214b54757fd$var$$size = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("checkbox-size");
const $0ca4e214b54757fd$var$baseStyleControl = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    return {
        w: $0ca4e214b54757fd$var$$size.reference,
        h: $0ca4e214b54757fd$var$$size.reference,
        transitionProperty: "box-shadow",
        transitionDuration: "normal",
        border: "2px solid",
        borderRadius: "sm",
        borderColor: "inherit",
        color: "white",
        _checked: {
            bg: (0, $37b8f53742d8e800$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
            borderColor: (0, $37b8f53742d8e800$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
            color: (0, $37b8f53742d8e800$export$549ff81930776885)("white", "gray.900")(props),
            _hover: {
                bg: (0, $37b8f53742d8e800$export$549ff81930776885)(`${c}.600`, `${c}.300`)(props),
                borderColor: (0, $37b8f53742d8e800$export$549ff81930776885)(`${c}.600`, `${c}.300`)(props)
            },
            _disabled: {
                borderColor: (0, $37b8f53742d8e800$export$549ff81930776885)("gray.200", "transparent")(props),
                bg: (0, $37b8f53742d8e800$export$549ff81930776885)("gray.200", "whiteAlpha.300")(props),
                color: (0, $37b8f53742d8e800$export$549ff81930776885)("gray.500", "whiteAlpha.500")(props)
            }
        },
        _indeterminate: {
            bg: (0, $37b8f53742d8e800$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
            borderColor: (0, $37b8f53742d8e800$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
            color: (0, $37b8f53742d8e800$export$549ff81930776885)("white", "gray.900")(props)
        },
        _disabled: {
            bg: (0, $37b8f53742d8e800$export$549ff81930776885)("gray.100", "whiteAlpha.100")(props),
            borderColor: (0, $37b8f53742d8e800$export$549ff81930776885)("gray.100", "transparent")(props)
        },
        _focusVisible: {
            boxShadow: "outline"
        },
        _invalid: {
            borderColor: (0, $37b8f53742d8e800$export$549ff81930776885)("red.500", "red.300")(props)
        }
    };
});
const $0ca4e214b54757fd$var$baseStyleContainer = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    _disabled: {
        cursor: "not-allowed"
    }
});
const $0ca4e214b54757fd$var$baseStyleLabel = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    userSelect: "none",
    _disabled: {
        opacity: 0.4
    }
});
const $0ca4e214b54757fd$var$baseStyleIcon = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    transitionProperty: "transform",
    transitionDuration: "normal"
});
const $0ca4e214b54757fd$var$baseStyle = $0ca4e214b54757fd$var$definePartsStyle((props)=>({
        icon: $0ca4e214b54757fd$var$baseStyleIcon,
        container: $0ca4e214b54757fd$var$baseStyleContainer,
        control: (0, $ce259e7686c84807$export$624e501d81f5ffce)($0ca4e214b54757fd$var$baseStyleControl, props),
        label: $0ca4e214b54757fd$var$baseStyleLabel
    }));
const $0ca4e214b54757fd$var$sizes = {
    sm: $0ca4e214b54757fd$var$definePartsStyle({
        control: {
            [$0ca4e214b54757fd$var$$size.variable]: "sizes.3"
        },
        label: {
            fontSize: "sm"
        },
        icon: {
            fontSize: "3xs"
        }
    }),
    md: $0ca4e214b54757fd$var$definePartsStyle({
        control: {
            [$0ca4e214b54757fd$var$$size.variable]: "sizes.4"
        },
        label: {
            fontSize: "md"
        },
        icon: {
            fontSize: "2xs"
        }
    }),
    lg: $0ca4e214b54757fd$var$definePartsStyle({
        control: {
            [$0ca4e214b54757fd$var$$size.variable]: "sizes.5"
        },
        label: {
            fontSize: "lg"
        },
        icon: {
            fontSize: "2xs"
        }
    })
};
const $0ca4e214b54757fd$export$86286d8c37984115 = $0ca4e214b54757fd$var$defineMultiStyleConfig({
    baseStyle: $0ca4e214b54757fd$var$baseStyle,
    sizes: $0ca4e214b54757fd$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});



function $cfd38c9d69ecffc9$export$2ad0182371401ea4(value) {
    return !Number.isInteger(parseFloat(value.toString()));
}
function $cfd38c9d69ecffc9$var$replaceWhiteSpace(value, replaceValue = "-") {
    return value.replace(/\s+/g, replaceValue);
}
function $cfd38c9d69ecffc9$var$escape(value) {
    const valueStr = $cfd38c9d69ecffc9$var$replaceWhiteSpace(value.toString());
    if (valueStr.includes("\\.")) return value;
    return $cfd38c9d69ecffc9$export$2ad0182371401ea4(value) ? valueStr.replace(".", `\\.`) : value;
}
function $cfd38c9d69ecffc9$export$9748efee331ec573(value, prefix = "") {
    return [
        prefix,
        $cfd38c9d69ecffc9$var$escape(value)
    ].filter(Boolean).join("-");
}
function $cfd38c9d69ecffc9$export$44410db3a43190e8(name, fallback) {
    return `var(${$cfd38c9d69ecffc9$var$escape(name)}${fallback ? `, ${fallback}` : ""})`;
}
function $cfd38c9d69ecffc9$export$e2ffa342f278b3a3(value, prefix = "") {
    return `--${$cfd38c9d69ecffc9$export$9748efee331ec573(value, prefix)}`;
}
function $cfd38c9d69ecffc9$export$8b4981022bd80a4e(name, options) {
    const cssVariable = $cfd38c9d69ecffc9$export$e2ffa342f278b3a3(name, options?.prefix);
    return {
        variable: cssVariable,
        reference: $cfd38c9d69ecffc9$export$44410db3a43190e8(cssVariable, $cfd38c9d69ecffc9$var$getFallback(options?.fallback))
    };
}
function $cfd38c9d69ecffc9$var$getFallback(fallback) {
    if (typeof fallback === "string") return fallback;
    return fallback?.reference;
}


const $d1e3840686d5a9e0$var$$size = (0, $cfd38c9d69ecffc9$export$8b4981022bd80a4e)("close-button-size");
const $d1e3840686d5a9e0$var$$bg = (0, $cfd38c9d69ecffc9$export$8b4981022bd80a4e)("close-button-bg");
const $d1e3840686d5a9e0$var$baseStyle = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    w: [
        $d1e3840686d5a9e0$var$$size.reference
    ],
    h: [
        $d1e3840686d5a9e0$var$$size.reference
    ],
    borderRadius: "md",
    transitionProperty: "common",
    transitionDuration: "normal",
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed",
        boxShadow: "none"
    },
    _hover: {
        [$d1e3840686d5a9e0$var$$bg.variable]: "colors.blackAlpha.100",
        _dark: {
            [$d1e3840686d5a9e0$var$$bg.variable]: "colors.whiteAlpha.100"
        }
    },
    _active: {
        [$d1e3840686d5a9e0$var$$bg.variable]: "colors.blackAlpha.200",
        _dark: {
            [$d1e3840686d5a9e0$var$$bg.variable]: "colors.whiteAlpha.200"
        }
    },
    _focusVisible: {
        boxShadow: "outline"
    },
    bg: $d1e3840686d5a9e0$var$$bg.reference
});
const $d1e3840686d5a9e0$var$sizes = {
    lg: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        [$d1e3840686d5a9e0$var$$size.variable]: "sizes.10",
        fontSize: "md"
    }),
    md: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        [$d1e3840686d5a9e0$var$$size.variable]: "sizes.8",
        fontSize: "xs"
    }),
    sm: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        [$d1e3840686d5a9e0$var$$size.variable]: "sizes.6",
        fontSize: "2xs"
    })
};
const $d1e3840686d5a9e0$export$47615e5b7f7e315f = (0, $8d7ccf069e08e0a2$export$5c9a64458a4ed8a4)({
    baseStyle: $d1e3840686d5a9e0$var$baseStyle,
    sizes: $d1e3840686d5a9e0$var$sizes,
    defaultProps: {
        size: "md"
    }
});




const { variants: $72f3326394570a2d$var$variants, defaultProps: $72f3326394570a2d$var$defaultProps } = (0, $23f998ac7374aa93$export$eb6e7cbc82d0f88b);
const $72f3326394570a2d$var$baseStyle = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    fontFamily: "mono",
    fontSize: "sm",
    px: "0.2em",
    borderRadius: "sm",
    bg: (0, $23f998ac7374aa93$export$947cd287c296b479).bg.reference,
    color: (0, $23f998ac7374aa93$export$947cd287c296b479).color.reference,
    boxShadow: (0, $23f998ac7374aa93$export$947cd287c296b479).shadow.reference
});
const $72f3326394570a2d$export$f9b9a8633a36e3c7 = (0, $8d7ccf069e08e0a2$export$5c9a64458a4ed8a4)({
    baseStyle: $72f3326394570a2d$var$baseStyle,
    variants: $72f3326394570a2d$var$variants,
    defaultProps: $72f3326394570a2d$var$defaultProps
});



const $5b07e5d79ed38f2b$var$baseStyle = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    w: "100%",
    mx: "auto",
    maxW: "prose",
    px: "4"
});
const $5b07e5d79ed38f2b$export$3ca0760d240fe5f4 = (0, $8d7ccf069e08e0a2$export$5c9a64458a4ed8a4)({
    baseStyle: $5b07e5d79ed38f2b$var$baseStyle
});



const $8c65f681dcb39dca$var$baseStyle = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    opacity: 0.6,
    borderColor: "inherit"
});
const $8c65f681dcb39dca$var$variantSolid = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    borderStyle: "solid"
});
const $8c65f681dcb39dca$var$variantDashed = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    borderStyle: "dashed"
});
const $8c65f681dcb39dca$var$variants = {
    solid: $8c65f681dcb39dca$var$variantSolid,
    dashed: $8c65f681dcb39dca$var$variantDashed
};
const $8c65f681dcb39dca$export$f0e91f779c5bb416 = (0, $8d7ccf069e08e0a2$export$5c9a64458a4ed8a4)({
    baseStyle: $8c65f681dcb39dca$var$baseStyle,
    variants: $8c65f681dcb39dca$var$variants,
    defaultProps: {
        variant: "solid"
    }
});





const { definePartsStyle: $6b5932b76005d954$var$definePartsStyle, defineMultiStyleConfig: $6b5932b76005d954$var$defineMultiStyleConfig } = (0, $8d7ccf069e08e0a2$export$d5f717dc145477b8)((0, $52fc62550c714bbf$export$d3f4aaa4b0f2907a).keys);
const $6b5932b76005d954$var$$bg = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("drawer-bg");
const $6b5932b76005d954$var$$bs = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("drawer-box-shadow");
function $6b5932b76005d954$var$getSize(value) {
    if (value === "full") return $6b5932b76005d954$var$definePartsStyle({
        dialog: {
            maxW: "100vw",
            h: "100vh"
        }
    });
    return $6b5932b76005d954$var$definePartsStyle({
        dialog: {
            maxW: value
        }
    });
}
const $6b5932b76005d954$var$baseStyleOverlay = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    bg: "blackAlpha.600",
    zIndex: "modal"
});
const $6b5932b76005d954$var$baseStyleDialogContainer = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    display: "flex",
    zIndex: "modal",
    justifyContent: "center"
});
const $6b5932b76005d954$var$baseStyleDialog = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>{
    const { isFullHeight: isFullHeight } = props;
    return {
        ...isFullHeight && {
            height: "100vh"
        },
        zIndex: "modal",
        maxH: "100vh",
        color: "inherit",
        [$6b5932b76005d954$var$$bg.variable]: "colors.white",
        [$6b5932b76005d954$var$$bs.variable]: "shadows.lg",
        _dark: {
            [$6b5932b76005d954$var$$bg.variable]: "colors.gray.700",
            [$6b5932b76005d954$var$$bs.variable]: "shadows.dark-lg"
        },
        bg: $6b5932b76005d954$var$$bg.reference,
        boxShadow: $6b5932b76005d954$var$$bs.reference
    };
});
const $6b5932b76005d954$var$baseStyleHeader = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    px: "6",
    py: "4",
    fontSize: "xl",
    fontWeight: "semibold"
});
const $6b5932b76005d954$var$baseStyleCloseButton = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    position: "absolute",
    top: "2",
    insetEnd: "3"
});
const $6b5932b76005d954$var$baseStyleBody = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    px: "6",
    py: "2",
    flex: "1",
    overflow: "auto"
});
const $6b5932b76005d954$var$baseStyleFooter = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    px: "6",
    py: "4"
});
const $6b5932b76005d954$var$baseStyle = $6b5932b76005d954$var$definePartsStyle((props)=>({
        overlay: $6b5932b76005d954$var$baseStyleOverlay,
        dialogContainer: $6b5932b76005d954$var$baseStyleDialogContainer,
        dialog: (0, $ce259e7686c84807$export$624e501d81f5ffce)($6b5932b76005d954$var$baseStyleDialog, props),
        header: $6b5932b76005d954$var$baseStyleHeader,
        closeButton: $6b5932b76005d954$var$baseStyleCloseButton,
        body: $6b5932b76005d954$var$baseStyleBody,
        footer: $6b5932b76005d954$var$baseStyleFooter
    }));
const $6b5932b76005d954$var$sizes = {
    xs: $6b5932b76005d954$var$getSize("xs"),
    sm: $6b5932b76005d954$var$getSize("md"),
    md: $6b5932b76005d954$var$getSize("lg"),
    lg: $6b5932b76005d954$var$getSize("2xl"),
    xl: $6b5932b76005d954$var$getSize("4xl"),
    full: $6b5932b76005d954$var$getSize("full")
};
const $6b5932b76005d954$export$8057937c11129602 = $6b5932b76005d954$var$defineMultiStyleConfig({
    baseStyle: $6b5932b76005d954$var$baseStyle,
    sizes: $6b5932b76005d954$var$sizes,
    defaultProps: {
        size: "xs"
    }
});




const { definePartsStyle: $e1cd97034ee8715e$var$definePartsStyle, defineMultiStyleConfig: $e1cd97034ee8715e$var$defineMultiStyleConfig } = (0, $8d7ccf069e08e0a2$export$d5f717dc145477b8)((0, $52fc62550c714bbf$export$2813c9511eeab082).keys);
const $e1cd97034ee8715e$var$baseStylePreview = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    borderRadius: "md",
    py: "1",
    transitionProperty: "common",
    transitionDuration: "normal"
});
const $e1cd97034ee8715e$var$baseStyleInput = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    borderRadius: "md",
    py: "1",
    transitionProperty: "common",
    transitionDuration: "normal",
    width: "full",
    _focusVisible: {
        boxShadow: "outline"
    },
    _placeholder: {
        opacity: 0.6
    }
});
const $e1cd97034ee8715e$var$baseStyleTextarea = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    borderRadius: "md",
    py: "1",
    transitionProperty: "common",
    transitionDuration: "normal",
    width: "full",
    _focusVisible: {
        boxShadow: "outline"
    },
    _placeholder: {
        opacity: 0.6
    }
});
const $e1cd97034ee8715e$var$baseStyle = $e1cd97034ee8715e$var$definePartsStyle({
    preview: $e1cd97034ee8715e$var$baseStylePreview,
    input: $e1cd97034ee8715e$var$baseStyleInput,
    textarea: $e1cd97034ee8715e$var$baseStyleTextarea
});
const $e1cd97034ee8715e$export$a09813cbe72349b1 = $e1cd97034ee8715e$var$defineMultiStyleConfig({
    baseStyle: $e1cd97034ee8715e$var$baseStyle
});




const { definePartsStyle: $1bb6915b07ab1aeb$var$definePartsStyle, defineMultiStyleConfig: $1bb6915b07ab1aeb$var$defineMultiStyleConfig } = (0, $8d7ccf069e08e0a2$export$d5f717dc145477b8)((0, $52fc62550c714bbf$export$4b243e3f209a7e5e).keys);
const $1bb6915b07ab1aeb$var$$fg = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("form-control-color");
const $1bb6915b07ab1aeb$var$baseStyleRequiredIndicator = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    marginStart: "1",
    [$1bb6915b07ab1aeb$var$$fg.variable]: "colors.red.500",
    _dark: {
        [$1bb6915b07ab1aeb$var$$fg.variable]: "colors.red.300"
    },
    color: $1bb6915b07ab1aeb$var$$fg.reference
});
const $1bb6915b07ab1aeb$var$baseStyleHelperText = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    mt: "2",
    [$1bb6915b07ab1aeb$var$$fg.variable]: "colors.gray.600",
    _dark: {
        [$1bb6915b07ab1aeb$var$$fg.variable]: "colors.whiteAlpha.600"
    },
    color: $1bb6915b07ab1aeb$var$$fg.reference,
    lineHeight: "normal",
    fontSize: "sm"
});
const $1bb6915b07ab1aeb$var$baseStyle = $1bb6915b07ab1aeb$var$definePartsStyle({
    container: {
        width: "100%",
        position: "relative"
    },
    requiredIndicator: $1bb6915b07ab1aeb$var$baseStyleRequiredIndicator,
    helperText: $1bb6915b07ab1aeb$var$baseStyleHelperText
});
const $1bb6915b07ab1aeb$export$870bcc1d98fee0aa = $1bb6915b07ab1aeb$var$defineMultiStyleConfig({
    baseStyle: $1bb6915b07ab1aeb$var$baseStyle
});




const { definePartsStyle: $f53feeec21f482b0$var$definePartsStyle, defineMultiStyleConfig: $f53feeec21f482b0$var$defineMultiStyleConfig } = (0, $8d7ccf069e08e0a2$export$d5f717dc145477b8)((0, $52fc62550c714bbf$export$bb18c440c00e82d9).keys);
const $f53feeec21f482b0$var$$fg = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("form-error-color");
const $f53feeec21f482b0$var$baseStyleText = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    [$f53feeec21f482b0$var$$fg.variable]: `colors.red.500`,
    _dark: {
        [$f53feeec21f482b0$var$$fg.variable]: `colors.red.300`
    },
    color: $f53feeec21f482b0$var$$fg.reference,
    mt: "2",
    fontSize: "sm",
    lineHeight: "normal"
});
const $f53feeec21f482b0$var$baseStyleIcon = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    marginEnd: "0.5em",
    [$f53feeec21f482b0$var$$fg.variable]: `colors.red.500`,
    _dark: {
        [$f53feeec21f482b0$var$$fg.variable]: `colors.red.300`
    },
    color: $f53feeec21f482b0$var$$fg.reference
});
const $f53feeec21f482b0$var$baseStyle = $f53feeec21f482b0$var$definePartsStyle({
    text: $f53feeec21f482b0$var$baseStyleText,
    icon: $f53feeec21f482b0$var$baseStyleIcon
});
const $f53feeec21f482b0$export$b8d6747e16cd5f4d = $f53feeec21f482b0$var$defineMultiStyleConfig({
    baseStyle: $f53feeec21f482b0$var$baseStyle
});



const $728b1a145d429543$var$baseStyle = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    fontSize: "md",
    marginEnd: "3",
    mb: "2",
    fontWeight: "medium",
    transitionProperty: "common",
    transitionDuration: "normal",
    opacity: 1,
    _disabled: {
        opacity: 0.4
    }
});
const $728b1a145d429543$export$c49af69dbfc0c993 = (0, $8d7ccf069e08e0a2$export$5c9a64458a4ed8a4)({
    baseStyle: $728b1a145d429543$var$baseStyle
});



const $1b33832437d7c8cf$var$baseStyle = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    fontFamily: "heading",
    fontWeight: "bold"
});
const $1b33832437d7c8cf$var$sizes = {
    "4xl": (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        fontSize: [
            "6xl",
            null,
            "7xl"
        ],
        lineHeight: 1
    }),
    "3xl": (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        fontSize: [
            "5xl",
            null,
            "6xl"
        ],
        lineHeight: 1
    }),
    "2xl": (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        fontSize: [
            "4xl",
            null,
            "5xl"
        ],
        lineHeight: [
            1.2,
            null,
            1
        ]
    }),
    xl: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        fontSize: [
            "3xl",
            null,
            "4xl"
        ],
        lineHeight: [
            1.33,
            null,
            1.2
        ]
    }),
    lg: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        fontSize: [
            "2xl",
            null,
            "3xl"
        ],
        lineHeight: [
            1.33,
            null,
            1.2
        ]
    }),
    md: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        fontSize: "xl",
        lineHeight: 1.2
    }),
    sm: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        fontSize: "md",
        lineHeight: 1.2
    }),
    xs: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        fontSize: "sm",
        lineHeight: 1.2
    })
};
const $1b33832437d7c8cf$export$5f175074e0f09e7b = (0, $8d7ccf069e08e0a2$export$5c9a64458a4ed8a4)({
    baseStyle: $1b33832437d7c8cf$var$baseStyle,
    sizes: $1b33832437d7c8cf$var$sizes,
    defaultProps: {
        size: "xl"
    }
});





const { definePartsStyle: $4b3c58b0e6e141ca$var$definePartsStyle, defineMultiStyleConfig: $4b3c58b0e6e141ca$var$defineMultiStyleConfig } = (0, $8d7ccf069e08e0a2$export$d5f717dc145477b8)((0, $52fc62550c714bbf$export$1ffeb100b532f46d).keys);
const $4b3c58b0e6e141ca$var$$height = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("input-height");
const $4b3c58b0e6e141ca$var$$fontSize = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("input-font-size");
const $4b3c58b0e6e141ca$var$$padding = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("input-padding");
const $4b3c58b0e6e141ca$var$$borderRadius = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("input-border-radius");
const $4b3c58b0e6e141ca$var$baseStyle = $4b3c58b0e6e141ca$var$definePartsStyle({
    addon: {
        height: $4b3c58b0e6e141ca$var$$height.reference,
        fontSize: $4b3c58b0e6e141ca$var$$fontSize.reference,
        px: $4b3c58b0e6e141ca$var$$padding.reference,
        borderRadius: $4b3c58b0e6e141ca$var$$borderRadius.reference
    },
    field: {
        width: "100%",
        height: $4b3c58b0e6e141ca$var$$height.reference,
        fontSize: $4b3c58b0e6e141ca$var$$fontSize.reference,
        px: $4b3c58b0e6e141ca$var$$padding.reference,
        borderRadius: $4b3c58b0e6e141ca$var$$borderRadius.reference,
        minWidth: 0,
        outline: 0,
        position: "relative",
        appearance: "none",
        transitionProperty: "common",
        transitionDuration: "normal",
        _disabled: {
            opacity: 0.4,
            cursor: "not-allowed"
        }
    }
});
const $4b3c58b0e6e141ca$var$size = {
    lg: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        [$4b3c58b0e6e141ca$var$$fontSize.variable]: "fontSizes.lg",
        [$4b3c58b0e6e141ca$var$$padding.variable]: "space.4",
        [$4b3c58b0e6e141ca$var$$borderRadius.variable]: "radii.md",
        [$4b3c58b0e6e141ca$var$$height.variable]: "sizes.12"
    }),
    md: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        [$4b3c58b0e6e141ca$var$$fontSize.variable]: "fontSizes.md",
        [$4b3c58b0e6e141ca$var$$padding.variable]: "space.4",
        [$4b3c58b0e6e141ca$var$$borderRadius.variable]: "radii.md",
        [$4b3c58b0e6e141ca$var$$height.variable]: "sizes.10"
    }),
    sm: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        [$4b3c58b0e6e141ca$var$$fontSize.variable]: "fontSizes.sm",
        [$4b3c58b0e6e141ca$var$$padding.variable]: "space.3",
        [$4b3c58b0e6e141ca$var$$borderRadius.variable]: "radii.sm",
        [$4b3c58b0e6e141ca$var$$height.variable]: "sizes.8"
    }),
    xs: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        [$4b3c58b0e6e141ca$var$$fontSize.variable]: "fontSizes.xs",
        [$4b3c58b0e6e141ca$var$$padding.variable]: "space.2",
        [$4b3c58b0e6e141ca$var$$borderRadius.variable]: "radii.sm",
        [$4b3c58b0e6e141ca$var$$height.variable]: "sizes.6"
    })
};
const $4b3c58b0e6e141ca$var$sizes = {
    lg: $4b3c58b0e6e141ca$var$definePartsStyle({
        field: $4b3c58b0e6e141ca$var$size.lg,
        group: $4b3c58b0e6e141ca$var$size.lg
    }),
    md: $4b3c58b0e6e141ca$var$definePartsStyle({
        field: $4b3c58b0e6e141ca$var$size.md,
        group: $4b3c58b0e6e141ca$var$size.md
    }),
    sm: $4b3c58b0e6e141ca$var$definePartsStyle({
        field: $4b3c58b0e6e141ca$var$size.sm,
        group: $4b3c58b0e6e141ca$var$size.sm
    }),
    xs: $4b3c58b0e6e141ca$var$definePartsStyle({
        field: $4b3c58b0e6e141ca$var$size.xs,
        group: $4b3c58b0e6e141ca$var$size.xs
    })
};
function $4b3c58b0e6e141ca$var$getDefaults(props) {
    const { focusBorderColor: fc, errorBorderColor: ec } = props;
    return {
        focusBorderColor: fc || (0, $37b8f53742d8e800$export$549ff81930776885)("blue.500", "blue.300")(props),
        errorBorderColor: ec || (0, $37b8f53742d8e800$export$549ff81930776885)("red.500", "red.300")(props)
    };
}
const $4b3c58b0e6e141ca$var$variantOutline = $4b3c58b0e6e141ca$var$definePartsStyle((props)=>{
    const { theme: theme } = props;
    const { focusBorderColor: fc, errorBorderColor: ec } = $4b3c58b0e6e141ca$var$getDefaults(props);
    return {
        field: {
            border: "1px solid",
            borderColor: "inherit",
            bg: "inherit",
            _hover: {
                borderColor: (0, $37b8f53742d8e800$export$549ff81930776885)("gray.300", "whiteAlpha.400")(props)
            },
            _readOnly: {
                boxShadow: "none !important",
                userSelect: "all"
            },
            _invalid: {
                borderColor: (0, $4d69a52220934355$export$5551a2d24ff40153)(theme, ec),
                boxShadow: `0 0 0 1px ${(0, $4d69a52220934355$export$5551a2d24ff40153)(theme, ec)}`
            },
            _focusVisible: {
                zIndex: 1,
                borderColor: (0, $4d69a52220934355$export$5551a2d24ff40153)(theme, fc),
                boxShadow: `0 0 0 1px ${(0, $4d69a52220934355$export$5551a2d24ff40153)(theme, fc)}`
            }
        },
        addon: {
            border: "1px solid",
            borderColor: (0, $37b8f53742d8e800$export$549ff81930776885)("inherit", "whiteAlpha.50")(props),
            bg: (0, $37b8f53742d8e800$export$549ff81930776885)("gray.100", "whiteAlpha.300")(props)
        }
    };
});
const $4b3c58b0e6e141ca$var$variantFilled = $4b3c58b0e6e141ca$var$definePartsStyle((props)=>{
    const { theme: theme } = props;
    const { focusBorderColor: fc, errorBorderColor: ec } = $4b3c58b0e6e141ca$var$getDefaults(props);
    return {
        field: {
            border: "2px solid",
            borderColor: "transparent",
            bg: (0, $37b8f53742d8e800$export$549ff81930776885)("gray.100", "whiteAlpha.50")(props),
            _hover: {
                bg: (0, $37b8f53742d8e800$export$549ff81930776885)("gray.200", "whiteAlpha.100")(props)
            },
            _readOnly: {
                boxShadow: "none !important",
                userSelect: "all"
            },
            _invalid: {
                borderColor: (0, $4d69a52220934355$export$5551a2d24ff40153)(theme, ec)
            },
            _focusVisible: {
                bg: "transparent",
                borderColor: (0, $4d69a52220934355$export$5551a2d24ff40153)(theme, fc)
            }
        },
        addon: {
            border: "2px solid",
            borderColor: "transparent",
            bg: (0, $37b8f53742d8e800$export$549ff81930776885)("gray.100", "whiteAlpha.50")(props)
        }
    };
});
const $4b3c58b0e6e141ca$var$variantFlushed = $4b3c58b0e6e141ca$var$definePartsStyle((props)=>{
    const { theme: theme } = props;
    const { focusBorderColor: fc, errorBorderColor: ec } = $4b3c58b0e6e141ca$var$getDefaults(props);
    return {
        field: {
            borderBottom: "1px solid",
            borderColor: "inherit",
            borderRadius: "0",
            px: "0",
            bg: "transparent",
            _readOnly: {
                boxShadow: "none !important",
                userSelect: "all"
            },
            _invalid: {
                borderColor: (0, $4d69a52220934355$export$5551a2d24ff40153)(theme, ec),
                boxShadow: `0px 1px 0px 0px ${(0, $4d69a52220934355$export$5551a2d24ff40153)(theme, ec)}`
            },
            _focusVisible: {
                borderColor: (0, $4d69a52220934355$export$5551a2d24ff40153)(theme, fc),
                boxShadow: `0px 1px 0px 0px ${(0, $4d69a52220934355$export$5551a2d24ff40153)(theme, fc)}`
            }
        },
        addon: {
            borderBottom: "2px solid",
            borderColor: "inherit",
            borderRadius: "0",
            px: "0",
            bg: "transparent"
        }
    };
});
const $4b3c58b0e6e141ca$var$variantUnstyled = $4b3c58b0e6e141ca$var$definePartsStyle({
    field: {
        bg: "transparent",
        px: "0",
        height: "auto"
    },
    addon: {
        bg: "transparent",
        px: "0",
        height: "auto"
    }
});
const $4b3c58b0e6e141ca$var$variants = {
    outline: $4b3c58b0e6e141ca$var$variantOutline,
    filled: $4b3c58b0e6e141ca$var$variantFilled,
    flushed: $4b3c58b0e6e141ca$var$variantFlushed,
    unstyled: $4b3c58b0e6e141ca$var$variantUnstyled
};
const $4b3c58b0e6e141ca$export$b1b9f3bced726e54 = $4b3c58b0e6e141ca$var$defineMultiStyleConfig({
    baseStyle: $4b3c58b0e6e141ca$var$baseStyle,
    sizes: $4b3c58b0e6e141ca$var$sizes,
    variants: $4b3c58b0e6e141ca$var$variants,
    defaultProps: {
        size: "md",
        variant: "outline"
    }
});



const $036d271f404b38cc$var$$bg = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("kbd-bg");
const $036d271f404b38cc$var$baseStyle = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    [$036d271f404b38cc$var$$bg.variable]: "colors.gray.100",
    _dark: {
        [$036d271f404b38cc$var$$bg.variable]: "colors.whiteAlpha.100"
    },
    bg: $036d271f404b38cc$var$$bg.reference,
    borderRadius: "md",
    borderWidth: "1px",
    borderBottomWidth: "3px",
    fontSize: "0.8em",
    fontWeight: "bold",
    lineHeight: "normal",
    px: "0.4em",
    whiteSpace: "nowrap"
});
const $036d271f404b38cc$export$e193528a501e9a4a = (0, $8d7ccf069e08e0a2$export$5c9a64458a4ed8a4)({
    baseStyle: $036d271f404b38cc$var$baseStyle
});



const $31bc4fb96ac62636$var$baseStyle = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    transitionProperty: "common",
    transitionDuration: "fast",
    transitionTimingFunction: "ease-out",
    cursor: "pointer",
    textDecoration: "none",
    outline: "none",
    color: "inherit",
    _hover: {
        textDecoration: "underline"
    },
    _focusVisible: {
        boxShadow: "outline"
    }
});
const $31bc4fb96ac62636$export$af7f58b96695762e = (0, $8d7ccf069e08e0a2$export$5c9a64458a4ed8a4)({
    baseStyle: $31bc4fb96ac62636$var$baseStyle
});




const { defineMultiStyleConfig: $9d9970829dc32716$var$defineMultiStyleConfig, definePartsStyle: $9d9970829dc32716$var$definePartsStyle } = (0, $8d7ccf069e08e0a2$export$d5f717dc145477b8)((0, $52fc62550c714bbf$export$12b3a655a94374ed).keys);
const $9d9970829dc32716$var$baseStyleIcon = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    marginEnd: "2",
    display: "inline",
    verticalAlign: "text-bottom"
});
const $9d9970829dc32716$var$baseStyle = $9d9970829dc32716$var$definePartsStyle({
    icon: $9d9970829dc32716$var$baseStyleIcon
});
const $9d9970829dc32716$export$ce840f8e8ef752d = $9d9970829dc32716$var$defineMultiStyleConfig({
    baseStyle: $9d9970829dc32716$var$baseStyle
});




const { defineMultiStyleConfig: $36deda6b76e1e00d$var$defineMultiStyleConfig, definePartsStyle: $36deda6b76e1e00d$var$definePartsStyle } = (0, $8d7ccf069e08e0a2$export$d5f717dc145477b8)((0, $52fc62550c714bbf$export$e251092a5dcb1329).keys);
const $36deda6b76e1e00d$var$$bg = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("menu-bg");
const $36deda6b76e1e00d$var$$shadow = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("menu-shadow");
const $36deda6b76e1e00d$var$baseStyleList = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    [$36deda6b76e1e00d$var$$bg.variable]: "#fff",
    [$36deda6b76e1e00d$var$$shadow.variable]: "shadows.sm",
    _dark: {
        [$36deda6b76e1e00d$var$$bg.variable]: "colors.gray.700",
        [$36deda6b76e1e00d$var$$shadow.variable]: "shadows.dark-lg"
    },
    color: "inherit",
    minW: "3xs",
    py: "2",
    zIndex: "dropdown",
    borderRadius: "md",
    borderWidth: "1px",
    bg: $36deda6b76e1e00d$var$$bg.reference,
    boxShadow: $36deda6b76e1e00d$var$$shadow.reference
});
const $36deda6b76e1e00d$var$baseStyleItem = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    py: "1.5",
    px: "3",
    transitionProperty: "background",
    transitionDuration: "ultra-fast",
    transitionTimingFunction: "ease-in",
    _focus: {
        [$36deda6b76e1e00d$var$$bg.variable]: "colors.gray.100",
        _dark: {
            [$36deda6b76e1e00d$var$$bg.variable]: "colors.whiteAlpha.100"
        }
    },
    _active: {
        [$36deda6b76e1e00d$var$$bg.variable]: "colors.gray.200",
        _dark: {
            [$36deda6b76e1e00d$var$$bg.variable]: "colors.whiteAlpha.200"
        }
    },
    _expanded: {
        [$36deda6b76e1e00d$var$$bg.variable]: "colors.gray.100",
        _dark: {
            [$36deda6b76e1e00d$var$$bg.variable]: "colors.whiteAlpha.100"
        }
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
    },
    bg: $36deda6b76e1e00d$var$$bg.reference
});
const $36deda6b76e1e00d$var$baseStyleGroupTitle = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    mx: 4,
    my: 2,
    fontWeight: "semibold",
    fontSize: "sm"
});
const $36deda6b76e1e00d$var$baseStyleIcon = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
});
const $36deda6b76e1e00d$var$baseStyleCommand = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    opacity: 0.6
});
const $36deda6b76e1e00d$var$baseStyleDivider = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    border: 0,
    borderBottom: "1px solid",
    borderColor: "inherit",
    my: "2",
    opacity: 0.6
});
const $36deda6b76e1e00d$var$baseStyleButton = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    transitionProperty: "common",
    transitionDuration: "normal"
});
const $36deda6b76e1e00d$var$baseStyle = $36deda6b76e1e00d$var$definePartsStyle({
    button: $36deda6b76e1e00d$var$baseStyleButton,
    list: $36deda6b76e1e00d$var$baseStyleList,
    item: $36deda6b76e1e00d$var$baseStyleItem,
    groupTitle: $36deda6b76e1e00d$var$baseStyleGroupTitle,
    icon: $36deda6b76e1e00d$var$baseStyleIcon,
    command: $36deda6b76e1e00d$var$baseStyleCommand,
    divider: $36deda6b76e1e00d$var$baseStyleDivider
});
const $36deda6b76e1e00d$export$687ce088075ea42b = $36deda6b76e1e00d$var$defineMultiStyleConfig({
    baseStyle: $36deda6b76e1e00d$var$baseStyle
});





const { defineMultiStyleConfig: $81ce714c8cf90ce7$var$defineMultiStyleConfig, definePartsStyle: $81ce714c8cf90ce7$var$definePartsStyle } = (0, $8d7ccf069e08e0a2$export$d5f717dc145477b8)((0, $52fc62550c714bbf$export$34e33beb8d992ac2).keys);
const $81ce714c8cf90ce7$var$$bg = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("modal-bg");
const $81ce714c8cf90ce7$var$$shadow = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("modal-shadow");
const $81ce714c8cf90ce7$var$baseStyleOverlay = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    bg: "blackAlpha.600",
    zIndex: "modal"
});
const $81ce714c8cf90ce7$var$baseStyleDialogContainer = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>{
    const { isCentered: isCentered, scrollBehavior: scrollBehavior } = props;
    return {
        display: "flex",
        zIndex: "modal",
        justifyContent: "center",
        alignItems: isCentered ? "center" : "flex-start",
        overflow: scrollBehavior === "inside" ? "hidden" : "auto",
        overscrollBehaviorY: "none"
    };
});
const $81ce714c8cf90ce7$var$baseStyleDialog = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>{
    const { isCentered: isCentered, scrollBehavior: scrollBehavior } = props;
    return {
        borderRadius: "md",
        color: "inherit",
        my: isCentered ? "auto" : "16",
        mx: isCentered ? "auto" : void 0,
        zIndex: "modal",
        maxH: scrollBehavior === "inside" ? "calc(100% - 7.5rem)" : void 0,
        [$81ce714c8cf90ce7$var$$bg.variable]: "colors.white",
        [$81ce714c8cf90ce7$var$$shadow.variable]: "shadows.lg",
        _dark: {
            [$81ce714c8cf90ce7$var$$bg.variable]: "colors.gray.700",
            [$81ce714c8cf90ce7$var$$shadow.variable]: "shadows.dark-lg"
        },
        bg: $81ce714c8cf90ce7$var$$bg.reference,
        boxShadow: $81ce714c8cf90ce7$var$$shadow.reference
    };
});
const $81ce714c8cf90ce7$var$baseStyleHeader = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    px: "6",
    py: "4",
    fontSize: "xl",
    fontWeight: "semibold"
});
const $81ce714c8cf90ce7$var$baseStyleCloseButton = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    position: "absolute",
    top: "2",
    insetEnd: "3"
});
const $81ce714c8cf90ce7$var$baseStyleBody = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>{
    const { scrollBehavior: scrollBehavior } = props;
    return {
        px: "6",
        py: "2",
        flex: "1",
        overflow: scrollBehavior === "inside" ? "auto" : void 0
    };
});
const $81ce714c8cf90ce7$var$baseStyleFooter = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    px: "6",
    py: "4"
});
const $81ce714c8cf90ce7$var$baseStyle = $81ce714c8cf90ce7$var$definePartsStyle((props)=>({
        overlay: $81ce714c8cf90ce7$var$baseStyleOverlay,
        dialogContainer: (0, $ce259e7686c84807$export$624e501d81f5ffce)($81ce714c8cf90ce7$var$baseStyleDialogContainer, props),
        dialog: (0, $ce259e7686c84807$export$624e501d81f5ffce)($81ce714c8cf90ce7$var$baseStyleDialog, props),
        header: $81ce714c8cf90ce7$var$baseStyleHeader,
        closeButton: $81ce714c8cf90ce7$var$baseStyleCloseButton,
        body: (0, $ce259e7686c84807$export$624e501d81f5ffce)($81ce714c8cf90ce7$var$baseStyleBody, props),
        footer: $81ce714c8cf90ce7$var$baseStyleFooter
    }));
function $81ce714c8cf90ce7$var$getSize(value) {
    if (value === "full") return $81ce714c8cf90ce7$var$definePartsStyle({
        dialog: {
            maxW: "100vw",
            minH: "$100vh",
            my: "0",
            borderRadius: "0"
        }
    });
    return $81ce714c8cf90ce7$var$definePartsStyle({
        dialog: {
            maxW: value
        }
    });
}
const $81ce714c8cf90ce7$var$sizes = {
    xs: $81ce714c8cf90ce7$var$getSize("xs"),
    sm: $81ce714c8cf90ce7$var$getSize("sm"),
    md: $81ce714c8cf90ce7$var$getSize("md"),
    lg: $81ce714c8cf90ce7$var$getSize("lg"),
    xl: $81ce714c8cf90ce7$var$getSize("xl"),
    "2xl": $81ce714c8cf90ce7$var$getSize("2xl"),
    "3xl": $81ce714c8cf90ce7$var$getSize("3xl"),
    "4xl": $81ce714c8cf90ce7$var$getSize("4xl"),
    "5xl": $81ce714c8cf90ce7$var$getSize("5xl"),
    "6xl": $81ce714c8cf90ce7$var$getSize("6xl"),
    full: $81ce714c8cf90ce7$var$getSize("full")
};
const $81ce714c8cf90ce7$export$158ae9a07be41c05 = $81ce714c8cf90ce7$var$defineMultiStyleConfig({
    baseStyle: $81ce714c8cf90ce7$var$baseStyle,
    sizes: $81ce714c8cf90ce7$var$sizes,
    defaultProps: {
        size: "md"
    }
});





var $fZQg5 = parcelRequire("fZQg5");
function $68e91679e3618cb6$var$toRef(operand) {
    if ((0, $fZQg5.isObject)(operand) && operand.reference) return operand.reference;
    return String(operand);
}
const $68e91679e3618cb6$var$toExpr = (operator, ...operands)=>operands.map($68e91679e3618cb6$var$toRef).join(` ${operator} `).replace(/calc/g, "");
const $68e91679e3618cb6$var$add = (...operands)=>`calc(${$68e91679e3618cb6$var$toExpr("+", ...operands)})`;
const $68e91679e3618cb6$var$subtract = (...operands)=>`calc(${$68e91679e3618cb6$var$toExpr("-", ...operands)})`;
const $68e91679e3618cb6$var$multiply = (...operands)=>`calc(${$68e91679e3618cb6$var$toExpr("*", ...operands)})`;
const $68e91679e3618cb6$var$divide = (...operands)=>`calc(${$68e91679e3618cb6$var$toExpr("/", ...operands)})`;
const $68e91679e3618cb6$var$negate = (x)=>{
    const value = $68e91679e3618cb6$var$toRef(x);
    if (value != null && !Number.isNaN(parseFloat(value))) return String(value).startsWith("-") ? String(value).slice(1) : `-${value}`;
    return $68e91679e3618cb6$var$multiply(value, -1);
};
const $68e91679e3618cb6$export$42bfa9b2d4dad91a = Object.assign((x)=>({
        add: (...operands)=>$68e91679e3618cb6$export$42bfa9b2d4dad91a($68e91679e3618cb6$var$add(x, ...operands)),
        subtract: (...operands)=>$68e91679e3618cb6$export$42bfa9b2d4dad91a($68e91679e3618cb6$var$subtract(x, ...operands)),
        multiply: (...operands)=>$68e91679e3618cb6$export$42bfa9b2d4dad91a($68e91679e3618cb6$var$multiply(x, ...operands)),
        divide: (...operands)=>$68e91679e3618cb6$export$42bfa9b2d4dad91a($68e91679e3618cb6$var$divide(x, ...operands)),
        negate: ()=>$68e91679e3618cb6$export$42bfa9b2d4dad91a($68e91679e3618cb6$var$negate(x)),
        toString: ()=>x.toString()
    }), {
    add: $68e91679e3618cb6$var$add,
    subtract: $68e91679e3618cb6$var$subtract,
    multiply: $68e91679e3618cb6$var$multiply,
    divide: $68e91679e3618cb6$var$divide,
    negate: $68e91679e3618cb6$var$negate
});


const $5bc790e5a1cb6d07$export$2e2bcd8739ae039 = {
    letterSpacings: {
        tighter: "-0.05em",
        tight: "-0.025em",
        normal: "0",
        wide: "0.025em",
        wider: "0.05em",
        widest: "0.1em"
    },
    lineHeights: {
        normal: "normal",
        none: 1,
        shorter: 1.25,
        short: 1.375,
        base: 1.5,
        tall: 1.625,
        taller: "2",
        "3": ".75rem",
        "4": "1rem",
        "5": "1.25rem",
        "6": "1.5rem",
        "7": "1.75rem",
        "8": "2rem",
        "9": "2.25rem",
        "10": "2.5rem"
    },
    fontWeights: {
        hairline: 100,
        thin: 200,
        light: 300,
        normal: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
        extrabold: 800,
        black: 900
    },
    fonts: {
        heading: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
        body: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
        mono: `SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace`
    },
    fontSizes: {
        "3xs": "0.45rem",
        "2xs": "0.625rem",
        xs: "0.75rem",
        sm: "0.875rem",
        md: "1rem",
        lg: "1.125rem",
        xl: "1.25rem",
        "2xl": "1.5rem",
        "3xl": "1.875rem",
        "4xl": "2.25rem",
        "5xl": "3rem",
        "6xl": "3.75rem",
        "7xl": "4.5rem",
        "8xl": "6rem",
        "9xl": "8rem"
    }
};




const { defineMultiStyleConfig: $6907580507ff3147$var$defineMultiStyleConfig, definePartsStyle: $6907580507ff3147$var$definePartsStyle } = (0, $8d7ccf069e08e0a2$export$d5f717dc145477b8)((0, $52fc62550c714bbf$export$859cc7ca3200df97).keys);
const $6907580507ff3147$var$$stepperWidth = (0, $cfd38c9d69ecffc9$export$8b4981022bd80a4e)("number-input-stepper-width");
const $6907580507ff3147$var$$inputPadding = (0, $cfd38c9d69ecffc9$export$8b4981022bd80a4e)("number-input-input-padding");
const $6907580507ff3147$var$inputPaddingValue = (0, $68e91679e3618cb6$export$42bfa9b2d4dad91a)($6907580507ff3147$var$$stepperWidth).add("0.5rem").toString();
const $6907580507ff3147$var$$bg = (0, $cfd38c9d69ecffc9$export$8b4981022bd80a4e)("number-input-bg");
const $6907580507ff3147$var$$fg = (0, $cfd38c9d69ecffc9$export$8b4981022bd80a4e)("number-input-color");
const $6907580507ff3147$var$$border = (0, $cfd38c9d69ecffc9$export$8b4981022bd80a4e)("number-input-border-color");
const $6907580507ff3147$var$baseStyleRoot = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    [$6907580507ff3147$var$$stepperWidth.variable]: "sizes.6",
    [$6907580507ff3147$var$$inputPadding.variable]: $6907580507ff3147$var$inputPaddingValue
});
const $6907580507ff3147$var$baseStyleField = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>(0, $ce259e7686c84807$export$624e501d81f5ffce)((0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).baseStyle, props)?.field ?? {});
const $6907580507ff3147$var$baseStyleStepperGroup = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    width: $6907580507ff3147$var$$stepperWidth.reference
});
const $6907580507ff3147$var$baseStyleStepper = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    borderStart: "1px solid",
    borderStartColor: $6907580507ff3147$var$$border.reference,
    color: $6907580507ff3147$var$$fg.reference,
    bg: $6907580507ff3147$var$$bg.reference,
    [$6907580507ff3147$var$$fg.variable]: "colors.chakra-body-text",
    [$6907580507ff3147$var$$border.variable]: "colors.chakra-border-color",
    _dark: {
        [$6907580507ff3147$var$$fg.variable]: "colors.whiteAlpha.800",
        [$6907580507ff3147$var$$border.variable]: "colors.whiteAlpha.300"
    },
    _active: {
        [$6907580507ff3147$var$$bg.variable]: "colors.gray.200",
        _dark: {
            [$6907580507ff3147$var$$bg.variable]: "colors.whiteAlpha.300"
        }
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
    }
});
const $6907580507ff3147$var$baseStyle = $6907580507ff3147$var$definePartsStyle((props)=>({
        root: $6907580507ff3147$var$baseStyleRoot,
        field: (0, $ce259e7686c84807$export$624e501d81f5ffce)($6907580507ff3147$var$baseStyleField, props) ?? {},
        stepperGroup: $6907580507ff3147$var$baseStyleStepperGroup,
        stepper: $6907580507ff3147$var$baseStyleStepper
    }));
function $6907580507ff3147$var$getSize(size) {
    const sizeStyle = (0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).sizes?.[size];
    const radius = {
        lg: "md",
        md: "md",
        sm: "sm",
        xs: "sm"
    };
    const _fontSize = sizeStyle.field?.fontSize ?? "md";
    const fontSize = (0, $5bc790e5a1cb6d07$export$2e2bcd8739ae039).fontSizes[_fontSize];
    return $6907580507ff3147$var$definePartsStyle({
        field: {
            ...sizeStyle.field,
            paddingInlineEnd: $6907580507ff3147$var$$inputPadding.reference,
            verticalAlign: "top"
        },
        stepper: {
            fontSize: (0, $68e91679e3618cb6$export$42bfa9b2d4dad91a)(fontSize).multiply(0.75).toString(),
            _first: {
                borderTopEndRadius: radius[size]
            },
            _last: {
                borderBottomEndRadius: radius[size],
                mt: "-1px",
                borderTopWidth: 1
            }
        }
    });
}
const $6907580507ff3147$var$sizes = {
    xs: $6907580507ff3147$var$getSize("xs"),
    sm: $6907580507ff3147$var$getSize("sm"),
    md: $6907580507ff3147$var$getSize("md"),
    lg: $6907580507ff3147$var$getSize("lg")
};
const $6907580507ff3147$export$b9bc5fa6e7f960a1 = $6907580507ff3147$var$defineMultiStyleConfig({
    baseStyle: $6907580507ff3147$var$baseStyle,
    sizes: $6907580507ff3147$var$sizes,
    variants: (0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).variants,
    defaultProps: (0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).defaultProps
});





const $7cf2ba0ffa79695c$var$baseStyle = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    ...(0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).baseStyle?.field,
    textAlign: "center"
});
const $7cf2ba0ffa79695c$var$sizes = {
    lg: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        fontSize: "lg",
        w: 12,
        h: 12,
        borderRadius: "md"
    }),
    md: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        fontSize: "md",
        w: 10,
        h: 10,
        borderRadius: "md"
    }),
    sm: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        fontSize: "sm",
        w: 8,
        h: 8,
        borderRadius: "sm"
    }),
    xs: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        fontSize: "xs",
        w: 6,
        h: 6,
        borderRadius: "sm"
    })
};
const $7cf2ba0ffa79695c$var$variants = {
    outline: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>(0, $ce259e7686c84807$export$624e501d81f5ffce)((0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).variants?.outline, props)?.field ?? {}),
    flushed: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>(0, $ce259e7686c84807$export$624e501d81f5ffce)((0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).variants?.flushed, props)?.field ?? {}),
    filled: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>(0, $ce259e7686c84807$export$624e501d81f5ffce)((0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).variants?.filled, props)?.field ?? {}),
    unstyled: (0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).variants?.unstyled.field ?? {}
};
const $7cf2ba0ffa79695c$export$8504c22c55a552e0 = (0, $8d7ccf069e08e0a2$export$5c9a64458a4ed8a4)({
    baseStyle: $7cf2ba0ffa79695c$var$baseStyle,
    sizes: $7cf2ba0ffa79695c$var$sizes,
    variants: $7cf2ba0ffa79695c$var$variants,
    defaultProps: (0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).defaultProps
});





const { defineMultiStyleConfig: $9039829e11461b55$var$defineMultiStyleConfig, definePartsStyle: $9039829e11461b55$var$definePartsStyle } = (0, $8d7ccf069e08e0a2$export$d5f717dc145477b8)((0, $52fc62550c714bbf$export$afda07d12cd4337d).keys);
const $9039829e11461b55$var$$popperBg = (0, $cfd38c9d69ecffc9$export$8b4981022bd80a4e)("popper-bg");
const $9039829e11461b55$var$$arrowBg = (0, $cfd38c9d69ecffc9$export$8b4981022bd80a4e)("popper-arrow-bg");
const $9039829e11461b55$var$$arrowShadowColor = (0, $cfd38c9d69ecffc9$export$8b4981022bd80a4e)("popper-arrow-shadow-color");
const $9039829e11461b55$var$baseStylePopper = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    zIndex: "popover"
});
const $9039829e11461b55$var$baseStyleContent = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    [$9039829e11461b55$var$$popperBg.variable]: `colors.white`,
    bg: $9039829e11461b55$var$$popperBg.reference,
    [$9039829e11461b55$var$$arrowBg.variable]: $9039829e11461b55$var$$popperBg.reference,
    [$9039829e11461b55$var$$arrowShadowColor.variable]: `colors.gray.200`,
    _dark: {
        [$9039829e11461b55$var$$popperBg.variable]: `colors.gray.700`,
        [$9039829e11461b55$var$$arrowShadowColor.variable]: `colors.whiteAlpha.300`
    },
    width: "xs",
    border: "1px solid",
    borderColor: "inherit",
    borderRadius: "md",
    boxShadow: "sm",
    zIndex: "inherit",
    _focusVisible: {
        outline: 0,
        boxShadow: "outline"
    }
});
const $9039829e11461b55$var$baseStyleHeader = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    px: 3,
    py: 2,
    borderBottomWidth: "1px"
});
const $9039829e11461b55$var$baseStyleBody = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    px: 3,
    py: 2
});
const $9039829e11461b55$var$baseStyleFooter = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    px: 3,
    py: 2,
    borderTopWidth: "1px"
});
const $9039829e11461b55$var$baseStyleCloseButton = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    position: "absolute",
    borderRadius: "md",
    top: 1,
    insetEnd: 2,
    padding: 2
});
const $9039829e11461b55$var$baseStyle = $9039829e11461b55$var$definePartsStyle({
    popper: $9039829e11461b55$var$baseStylePopper,
    content: $9039829e11461b55$var$baseStyleContent,
    header: $9039829e11461b55$var$baseStyleHeader,
    body: $9039829e11461b55$var$baseStyleBody,
    footer: $9039829e11461b55$var$baseStyleFooter,
    closeButton: $9039829e11461b55$var$baseStyleCloseButton
});
const $9039829e11461b55$export$135f12f777be1ef7 = $9039829e11461b55$var$defineMultiStyleConfig({
    baseStyle: $9039829e11461b55$var$baseStyle
});





const { defineMultiStyleConfig: $7ac8b45047d2fc2c$var$defineMultiStyleConfig, definePartsStyle: $7ac8b45047d2fc2c$var$definePartsStyle } = (0, $8d7ccf069e08e0a2$export$d5f717dc145477b8)((0, $52fc62550c714bbf$export$ba6328c242bd649c).keys);
const $7ac8b45047d2fc2c$var$filledStyle = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: t, isIndeterminate: isIndeterminate, hasStripe: hasStripe } = props;
    const stripeStyle = (0, $37b8f53742d8e800$export$549ff81930776885)((0, $4d69a52220934355$export$db0ffb03ee9f3080)(), (0, $4d69a52220934355$export$db0ffb03ee9f3080)("1rem", "rgba(0,0,0,0.1)"))(props);
    const bgColor = (0, $37b8f53742d8e800$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props);
    const gradient = `linear-gradient(
    to right,
    transparent 0%,
    ${(0, $4d69a52220934355$export$5551a2d24ff40153)(t, bgColor)} 50%,
    transparent 100%
  )`;
    const addStripe = !isIndeterminate && hasStripe;
    return {
        ...addStripe && stripeStyle,
        ...isIndeterminate ? {
            bgImage: gradient
        } : {
            bgColor: bgColor
        }
    };
});
const $7ac8b45047d2fc2c$var$baseStyleLabel = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    lineHeight: "1",
    fontSize: "0.25em",
    fontWeight: "bold",
    color: "white"
});
const $7ac8b45047d2fc2c$var$baseStyleTrack = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>{
    return {
        bg: (0, $37b8f53742d8e800$export$549ff81930776885)("gray.100", "whiteAlpha.300")(props)
    };
});
const $7ac8b45047d2fc2c$var$baseStyleFilledTrack = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>{
    return {
        transitionProperty: "common",
        transitionDuration: "slow",
        ...$7ac8b45047d2fc2c$var$filledStyle(props)
    };
});
const $7ac8b45047d2fc2c$var$baseStyle = $7ac8b45047d2fc2c$var$definePartsStyle((props)=>({
        label: $7ac8b45047d2fc2c$var$baseStyleLabel,
        filledTrack: $7ac8b45047d2fc2c$var$baseStyleFilledTrack(props),
        track: $7ac8b45047d2fc2c$var$baseStyleTrack(props)
    }));
const $7ac8b45047d2fc2c$var$sizes = {
    xs: $7ac8b45047d2fc2c$var$definePartsStyle({
        track: {
            h: "1"
        }
    }),
    sm: $7ac8b45047d2fc2c$var$definePartsStyle({
        track: {
            h: "2"
        }
    }),
    md: $7ac8b45047d2fc2c$var$definePartsStyle({
        track: {
            h: "3"
        }
    }),
    lg: $7ac8b45047d2fc2c$var$definePartsStyle({
        track: {
            h: "4"
        }
    })
};
const $7ac8b45047d2fc2c$export$dc04d8e6a17afea1 = $7ac8b45047d2fc2c$var$defineMultiStyleConfig({
    sizes: $7ac8b45047d2fc2c$var$sizes,
    baseStyle: $7ac8b45047d2fc2c$var$baseStyle,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});






const { defineMultiStyleConfig: $9052b0594a97d3c5$var$defineMultiStyleConfig, definePartsStyle: $9052b0594a97d3c5$var$definePartsStyle } = (0, $8d7ccf069e08e0a2$export$d5f717dc145477b8)((0, $52fc62550c714bbf$export$d28d06d0e29ef022).keys);
const $9052b0594a97d3c5$var$baseStyleControl = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>{
    const controlStyle = (0, $ce259e7686c84807$export$624e501d81f5ffce)((0, $0ca4e214b54757fd$export$86286d8c37984115).baseStyle, props)?.control;
    return {
        ...controlStyle,
        borderRadius: "full",
        _checked: {
            ...controlStyle?.["_checked"],
            _before: {
                content: `""`,
                display: "inline-block",
                pos: "relative",
                w: "50%",
                h: "50%",
                borderRadius: "50%",
                bg: "currentColor"
            }
        }
    };
});
const $9052b0594a97d3c5$var$baseStyle = $9052b0594a97d3c5$var$definePartsStyle((props)=>({
        label: (0, $0ca4e214b54757fd$export$86286d8c37984115).baseStyle?.(props).label,
        container: (0, $0ca4e214b54757fd$export$86286d8c37984115).baseStyle?.(props).container,
        control: $9052b0594a97d3c5$var$baseStyleControl(props)
    }));
const $9052b0594a97d3c5$var$sizes = {
    md: $9052b0594a97d3c5$var$definePartsStyle({
        control: {
            w: "4",
            h: "4"
        },
        label: {
            fontSize: "md"
        }
    }),
    lg: $9052b0594a97d3c5$var$definePartsStyle({
        control: {
            w: "5",
            h: "5"
        },
        label: {
            fontSize: "lg"
        }
    }),
    sm: $9052b0594a97d3c5$var$definePartsStyle({
        control: {
            width: "3",
            height: "3"
        },
        label: {
            fontSize: "sm"
        }
    })
};
const $9052b0594a97d3c5$export$f0b387b940941887 = $9052b0594a97d3c5$var$defineMultiStyleConfig({
    baseStyle: $9052b0594a97d3c5$var$baseStyle,
    sizes: $9052b0594a97d3c5$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});





const { defineMultiStyleConfig: $8f3e073822cf3f64$var$defineMultiStyleConfig, definePartsStyle: $8f3e073822cf3f64$var$definePartsStyle } = (0, $8d7ccf069e08e0a2$export$d5f717dc145477b8)((0, $52fc62550c714bbf$export$17993f0be9538b5a).keys);
const $8f3e073822cf3f64$var$$bg = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("select-bg");
const $8f3e073822cf3f64$var$baseStyleField = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    ...(0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).baseStyle?.field,
    appearance: "none",
    paddingBottom: "1px",
    lineHeight: "normal",
    bg: $8f3e073822cf3f64$var$$bg.reference,
    [$8f3e073822cf3f64$var$$bg.variable]: "colors.white",
    _dark: {
        [$8f3e073822cf3f64$var$$bg.variable]: "colors.gray.700"
    },
    "> option, > optgroup": {
        bg: $8f3e073822cf3f64$var$$bg.reference
    }
});
const $8f3e073822cf3f64$var$baseStyleIcon = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    width: "6",
    height: "100%",
    insetEnd: "2",
    position: "relative",
    color: "currentColor",
    fontSize: "xl",
    _disabled: {
        opacity: 0.5
    }
});
const $8f3e073822cf3f64$var$baseStyle = $8f3e073822cf3f64$var$definePartsStyle({
    field: $8f3e073822cf3f64$var$baseStyleField,
    icon: $8f3e073822cf3f64$var$baseStyleIcon
});
const $8f3e073822cf3f64$var$iconSpacing = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    paddingInlineEnd: "8"
});
const $8f3e073822cf3f64$var$sizes = {
    lg: {
        ...(0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).sizes?.lg,
        field: {
            ...(0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).sizes?.lg.field,
            ...$8f3e073822cf3f64$var$iconSpacing
        }
    },
    md: {
        ...(0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).sizes?.md,
        field: {
            ...(0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).sizes?.md.field,
            ...$8f3e073822cf3f64$var$iconSpacing
        }
    },
    sm: {
        ...(0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).sizes?.sm,
        field: {
            ...(0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).sizes?.sm.field,
            ...$8f3e073822cf3f64$var$iconSpacing
        }
    },
    xs: {
        ...(0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).sizes?.xs,
        field: {
            ...(0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).sizes?.xs.field,
            ...$8f3e073822cf3f64$var$iconSpacing
        },
        icon: {
            insetEnd: "1"
        }
    }
};
const $8f3e073822cf3f64$export$21af0fc3c16183e1 = $8f3e073822cf3f64$var$defineMultiStyleConfig({
    baseStyle: $8f3e073822cf3f64$var$baseStyle,
    sizes: $8f3e073822cf3f64$var$sizes,
    variants: (0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).variants,
    defaultProps: (0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).defaultProps
});



const $3eedb63d701bb5f1$var$$startColor = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("skeleton-start-color");
const $3eedb63d701bb5f1$var$$endColor = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("skeleton-end-color");
const $3eedb63d701bb5f1$var$baseStyle = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    [$3eedb63d701bb5f1$var$$startColor.variable]: "colors.gray.100",
    [$3eedb63d701bb5f1$var$$endColor.variable]: "colors.gray.400",
    _dark: {
        [$3eedb63d701bb5f1$var$$startColor.variable]: "colors.gray.800",
        [$3eedb63d701bb5f1$var$$endColor.variable]: "colors.gray.600"
    },
    background: $3eedb63d701bb5f1$var$$startColor.reference,
    borderColor: $3eedb63d701bb5f1$var$$endColor.reference,
    opacity: 0.7,
    borderRadius: "sm"
});
const $3eedb63d701bb5f1$export$7680371ad2d79142 = (0, $8d7ccf069e08e0a2$export$5c9a64458a4ed8a4)({
    baseStyle: $3eedb63d701bb5f1$var$baseStyle
});



const $a578b7de46c890e7$var$$bg = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("skip-link-bg");
const $a578b7de46c890e7$var$baseStyle = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    borderRadius: "md",
    fontWeight: "semibold",
    _focusVisible: {
        boxShadow: "outline",
        padding: "4",
        position: "fixed",
        top: "6",
        insetStart: "6",
        [$a578b7de46c890e7$var$$bg.variable]: "colors.white",
        _dark: {
            [$a578b7de46c890e7$var$$bg.variable]: "colors.gray.700"
        },
        bg: $a578b7de46c890e7$var$$bg.reference
    }
});
const $a578b7de46c890e7$export$a8cf3228ef52959 = (0, $8d7ccf069e08e0a2$export$5c9a64458a4ed8a4)({
    baseStyle: $a578b7de46c890e7$var$baseStyle
});




var $fZQg5 = parcelRequire("fZQg5");
function $8f1cebefed6fc84f$var$resolveReference(operand) {
    if ((0, $fZQg5.isObject)(operand) && operand.reference) return operand.reference;
    return String(operand);
}
const $8f1cebefed6fc84f$var$toExpression = (operator, ...operands)=>operands.map($8f1cebefed6fc84f$var$resolveReference).join(` ${operator} `).replace(/calc/g, "");
const $8f1cebefed6fc84f$var$add = (...operands)=>`calc(${$8f1cebefed6fc84f$var$toExpression("+", ...operands)})`;
const $8f1cebefed6fc84f$var$subtract = (...operands)=>`calc(${$8f1cebefed6fc84f$var$toExpression("-", ...operands)})`;
const $8f1cebefed6fc84f$var$multiply = (...operands)=>`calc(${$8f1cebefed6fc84f$var$toExpression("*", ...operands)})`;
const $8f1cebefed6fc84f$var$divide = (...operands)=>`calc(${$8f1cebefed6fc84f$var$toExpression("/", ...operands)})`;
const $8f1cebefed6fc84f$var$negate = (x)=>{
    const value = $8f1cebefed6fc84f$var$resolveReference(x);
    if (value != null && !Number.isNaN(parseFloat(value))) return String(value).startsWith("-") ? String(value).slice(1) : `-${value}`;
    return $8f1cebefed6fc84f$var$multiply(value, -1);
};
const $8f1cebefed6fc84f$export$42bfa9b2d4dad91a = Object.assign((x)=>({
        add: (...operands)=>$8f1cebefed6fc84f$export$42bfa9b2d4dad91a($8f1cebefed6fc84f$var$add(x, ...operands)),
        subtract: (...operands)=>$8f1cebefed6fc84f$export$42bfa9b2d4dad91a($8f1cebefed6fc84f$var$subtract(x, ...operands)),
        multiply: (...operands)=>$8f1cebefed6fc84f$export$42bfa9b2d4dad91a($8f1cebefed6fc84f$var$multiply(x, ...operands)),
        divide: (...operands)=>$8f1cebefed6fc84f$export$42bfa9b2d4dad91a($8f1cebefed6fc84f$var$divide(x, ...operands)),
        negate: ()=>$8f1cebefed6fc84f$export$42bfa9b2d4dad91a($8f1cebefed6fc84f$var$negate(x)),
        toString: ()=>x.toString()
    }), {
    add: $8f1cebefed6fc84f$var$add,
    subtract: $8f1cebefed6fc84f$var$subtract,
    multiply: $8f1cebefed6fc84f$var$multiply,
    divide: $8f1cebefed6fc84f$var$divide,
    negate: $8f1cebefed6fc84f$var$negate
});



const { defineMultiStyleConfig: $d5e6bd099e4d9c3d$var$defineMultiStyleConfig, definePartsStyle: $d5e6bd099e4d9c3d$var$definePartsStyle } = (0, $8d7ccf069e08e0a2$export$d5f717dc145477b8)((0, $52fc62550c714bbf$export$c21b4b3f8b239f32).keys);
const $d5e6bd099e4d9c3d$var$$thumbSize = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("slider-thumb-size");
const $d5e6bd099e4d9c3d$var$$trackSize = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("slider-track-size");
const $d5e6bd099e4d9c3d$var$$bg = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("slider-bg");
const $d5e6bd099e4d9c3d$var$baseStyleContainer = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>{
    const { orientation: orientation } = props;
    return {
        display: "inline-block",
        position: "relative",
        cursor: "pointer",
        _disabled: {
            opacity: 0.6,
            cursor: "default",
            pointerEvents: "none"
        },
        ...(0, $37b8f53742d8e800$export$f3eec17ee6065eee)({
            orientation: orientation,
            vertical: {
                h: "100%",
                px: (0, $8f1cebefed6fc84f$export$42bfa9b2d4dad91a)($d5e6bd099e4d9c3d$var$$thumbSize.reference).divide(2).toString()
            },
            horizontal: {
                w: "100%",
                py: (0, $8f1cebefed6fc84f$export$42bfa9b2d4dad91a)($d5e6bd099e4d9c3d$var$$thumbSize.reference).divide(2).toString()
            }
        })
    };
});
const $d5e6bd099e4d9c3d$var$baseStyleTrack = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>{
    const orientationStyles = (0, $37b8f53742d8e800$export$f3eec17ee6065eee)({
        orientation: props.orientation,
        horizontal: {
            h: $d5e6bd099e4d9c3d$var$$trackSize.reference
        },
        vertical: {
            w: $d5e6bd099e4d9c3d$var$$trackSize.reference
        }
    });
    return {
        ...orientationStyles,
        overflow: "hidden",
        borderRadius: "sm",
        [$d5e6bd099e4d9c3d$var$$bg.variable]: "colors.gray.200",
        _dark: {
            [$d5e6bd099e4d9c3d$var$$bg.variable]: "colors.whiteAlpha.200"
        },
        _disabled: {
            [$d5e6bd099e4d9c3d$var$$bg.variable]: "colors.gray.300",
            _dark: {
                [$d5e6bd099e4d9c3d$var$$bg.variable]: "colors.whiteAlpha.300"
            }
        },
        bg: $d5e6bd099e4d9c3d$var$$bg.reference
    };
});
const $d5e6bd099e4d9c3d$var$baseStyleThumb = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>{
    const { orientation: orientation } = props;
    const orientationStyle = (0, $37b8f53742d8e800$export$f3eec17ee6065eee)({
        orientation: orientation,
        vertical: {
            left: "50%",
            transform: `translateX(-50%)`,
            _active: {
                transform: `translateX(-50%) scale(1.15)`
            }
        },
        horizontal: {
            top: "50%",
            transform: `translateY(-50%)`,
            _active: {
                transform: `translateY(-50%) scale(1.15)`
            }
        }
    });
    return {
        ...orientationStyle,
        w: $d5e6bd099e4d9c3d$var$$thumbSize.reference,
        h: $d5e6bd099e4d9c3d$var$$thumbSize.reference,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        outline: 0,
        zIndex: 1,
        borderRadius: "full",
        bg: "white",
        boxShadow: "base",
        border: "1px solid",
        borderColor: "transparent",
        transitionProperty: "transform",
        transitionDuration: "normal",
        _focusVisible: {
            boxShadow: "outline"
        },
        _disabled: {
            bg: "gray.300"
        }
    };
});
const $d5e6bd099e4d9c3d$var$baseStyleFilledTrack = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    return {
        width: "inherit",
        height: "inherit",
        [$d5e6bd099e4d9c3d$var$$bg.variable]: `colors.${c}.500`,
        _dark: {
            [$d5e6bd099e4d9c3d$var$$bg.variable]: `colors.${c}.200`
        },
        bg: $d5e6bd099e4d9c3d$var$$bg.reference
    };
});
const $d5e6bd099e4d9c3d$var$baseStyle = $d5e6bd099e4d9c3d$var$definePartsStyle((props)=>({
        container: $d5e6bd099e4d9c3d$var$baseStyleContainer(props),
        track: $d5e6bd099e4d9c3d$var$baseStyleTrack(props),
        thumb: $d5e6bd099e4d9c3d$var$baseStyleThumb(props),
        filledTrack: $d5e6bd099e4d9c3d$var$baseStyleFilledTrack(props)
    }));
const $d5e6bd099e4d9c3d$var$sizeLg = $d5e6bd099e4d9c3d$var$definePartsStyle({
    container: {
        [$d5e6bd099e4d9c3d$var$$thumbSize.variable]: `sizes.4`,
        [$d5e6bd099e4d9c3d$var$$trackSize.variable]: `sizes.1`
    }
});
const $d5e6bd099e4d9c3d$var$sizeMd = $d5e6bd099e4d9c3d$var$definePartsStyle({
    container: {
        [$d5e6bd099e4d9c3d$var$$thumbSize.variable]: `sizes.3.5`,
        [$d5e6bd099e4d9c3d$var$$trackSize.variable]: `sizes.1`
    }
});
const $d5e6bd099e4d9c3d$var$sizeSm = $d5e6bd099e4d9c3d$var$definePartsStyle({
    container: {
        [$d5e6bd099e4d9c3d$var$$thumbSize.variable]: `sizes.2.5`,
        [$d5e6bd099e4d9c3d$var$$trackSize.variable]: `sizes.0.5`
    }
});
const $d5e6bd099e4d9c3d$var$sizes = {
    lg: $d5e6bd099e4d9c3d$var$sizeLg,
    md: $d5e6bd099e4d9c3d$var$sizeMd,
    sm: $d5e6bd099e4d9c3d$var$sizeSm
};
const $d5e6bd099e4d9c3d$export$fff8df8fd8e1ed6f = $d5e6bd099e4d9c3d$var$defineMultiStyleConfig({
    baseStyle: $d5e6bd099e4d9c3d$var$baseStyle,
    sizes: $d5e6bd099e4d9c3d$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});




const $c055b83805192e3f$var$$size = (0, $cfd38c9d69ecffc9$export$8b4981022bd80a4e)("spinner-size");
const $c055b83805192e3f$var$baseStyle = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    width: [
        $c055b83805192e3f$var$$size.reference
    ],
    height: [
        $c055b83805192e3f$var$$size.reference
    ]
});
const $c055b83805192e3f$var$sizes = {
    xs: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        [$c055b83805192e3f$var$$size.variable]: "sizes.3"
    }),
    sm: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        [$c055b83805192e3f$var$$size.variable]: "sizes.4"
    }),
    md: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        [$c055b83805192e3f$var$$size.variable]: "sizes.6"
    }),
    lg: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        [$c055b83805192e3f$var$$size.variable]: "sizes.8"
    }),
    xl: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        [$c055b83805192e3f$var$$size.variable]: "sizes.12"
    })
};
const $c055b83805192e3f$export$d76156e68e556d3f = (0, $8d7ccf069e08e0a2$export$5c9a64458a4ed8a4)({
    baseStyle: $c055b83805192e3f$var$baseStyle,
    sizes: $c055b83805192e3f$var$sizes,
    defaultProps: {
        size: "md"
    }
});




const { defineMultiStyleConfig: $62451f1ddd6da230$var$defineMultiStyleConfig, definePartsStyle: $62451f1ddd6da230$var$definePartsStyle } = (0, $8d7ccf069e08e0a2$export$d5f717dc145477b8)((0, $52fc62550c714bbf$export$2cfbad67ae6ee421).keys);
const $62451f1ddd6da230$var$baseStyleLabel = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    fontWeight: "medium"
});
const $62451f1ddd6da230$var$baseStyleHelpText = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    opacity: 0.8,
    marginBottom: "2"
});
const $62451f1ddd6da230$var$baseStyleNumber = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    verticalAlign: "baseline",
    fontWeight: "semibold"
});
const $62451f1ddd6da230$var$baseStyleIcon = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    marginEnd: 1,
    w: "3.5",
    h: "3.5",
    verticalAlign: "middle"
});
const $62451f1ddd6da230$var$baseStyle = $62451f1ddd6da230$var$definePartsStyle({
    container: {},
    label: $62451f1ddd6da230$var$baseStyleLabel,
    helpText: $62451f1ddd6da230$var$baseStyleHelpText,
    number: $62451f1ddd6da230$var$baseStyleNumber,
    icon: $62451f1ddd6da230$var$baseStyleIcon
});
const $62451f1ddd6da230$var$sizes = {
    md: $62451f1ddd6da230$var$definePartsStyle({
        label: {
            fontSize: "sm"
        },
        helpText: {
            fontSize: "sm"
        },
        number: {
            fontSize: "2xl"
        }
    })
};
const $62451f1ddd6da230$export$f3301eb37a20f09e = $62451f1ddd6da230$var$defineMultiStyleConfig({
    baseStyle: $62451f1ddd6da230$var$baseStyle,
    sizes: $62451f1ddd6da230$var$sizes,
    defaultProps: {
        size: "md"
    }
});



const { defineMultiStyleConfig: $fa46a297dac2e3dc$var$defineMultiStyleConfig, definePartsStyle: $fa46a297dac2e3dc$var$definePartsStyle } = (0, $8d7ccf069e08e0a2$export$d5f717dc145477b8)([
    "stepper",
    "step",
    "title",
    "description",
    "indicator",
    "separator",
    "icon",
    "number"
]);
const $fa46a297dac2e3dc$var$$size = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("stepper-indicator-size");
const $fa46a297dac2e3dc$var$$iconSize = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("stepper-icon-size");
const $fa46a297dac2e3dc$var$$titleFontSize = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("stepper-title-font-size");
const $fa46a297dac2e3dc$var$$descFontSize = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("stepper-description-font-size");
const $fa46a297dac2e3dc$var$$accentColor = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("stepper-accent-color");
const $fa46a297dac2e3dc$var$baseStyle = $fa46a297dac2e3dc$var$definePartsStyle(({ colorScheme: c })=>({
        stepper: {
            display: "flex",
            justifyContent: "space-between",
            gap: "4",
            "&[data-orientation=vertical]": {
                flexDirection: "column",
                alignItems: "flex-start"
            },
            "&[data-orientation=horizontal]": {
                flexDirection: "row",
                alignItems: "center"
            },
            [$fa46a297dac2e3dc$var$$accentColor.variable]: `colors.${c}.500`,
            _dark: {
                [$fa46a297dac2e3dc$var$$accentColor.variable]: `colors.${c}.200`
            }
        },
        title: {
            fontSize: $fa46a297dac2e3dc$var$$titleFontSize.reference,
            fontWeight: "medium"
        },
        description: {
            fontSize: $fa46a297dac2e3dc$var$$descFontSize.reference,
            color: "chakra-subtle-text"
        },
        number: {
            fontSize: $fa46a297dac2e3dc$var$$titleFontSize.reference
        },
        step: {
            flexShrink: 0,
            position: "relative",
            display: "flex",
            gap: "2",
            "&[data-orientation=horizontal]": {
                alignItems: "center"
            },
            flex: "1",
            "&:last-of-type:not([data-stretch])": {
                flex: "initial"
            }
        },
        icon: {
            flexShrink: 0,
            width: $fa46a297dac2e3dc$var$$iconSize.reference,
            height: $fa46a297dac2e3dc$var$$iconSize.reference
        },
        indicator: {
            flexShrink: 0,
            borderRadius: "full",
            width: $fa46a297dac2e3dc$var$$size.reference,
            height: $fa46a297dac2e3dc$var$$size.reference,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "&[data-status=active]": {
                borderWidth: "2px",
                borderColor: $fa46a297dac2e3dc$var$$accentColor.reference
            },
            "&[data-status=complete]": {
                bg: $fa46a297dac2e3dc$var$$accentColor.reference,
                color: "chakra-inverse-text"
            },
            "&[data-status=incomplete]": {
                borderWidth: "2px"
            }
        },
        separator: {
            bg: "chakra-border-color",
            flex: "1",
            "&[data-status=complete]": {
                bg: $fa46a297dac2e3dc$var$$accentColor.reference
            },
            "&[data-orientation=horizontal]": {
                width: "100%",
                height: "2px",
                marginStart: "2"
            },
            "&[data-orientation=vertical]": {
                width: "2px",
                position: "absolute",
                height: "100%",
                maxHeight: `calc(100% - ${$fa46a297dac2e3dc$var$$size.reference} - 8px)`,
                top: `calc(${$fa46a297dac2e3dc$var$$size.reference} + 4px)`,
                insetStart: `calc(${$fa46a297dac2e3dc$var$$size.reference} / 2 - 1px)`
            }
        }
    }));
const $fa46a297dac2e3dc$export$54c84d54375c8d75 = $fa46a297dac2e3dc$var$defineMultiStyleConfig({
    baseStyle: $fa46a297dac2e3dc$var$baseStyle,
    sizes: {
        xs: $fa46a297dac2e3dc$var$definePartsStyle({
            stepper: {
                [$fa46a297dac2e3dc$var$$size.variable]: "sizes.4",
                [$fa46a297dac2e3dc$var$$iconSize.variable]: "sizes.3",
                [$fa46a297dac2e3dc$var$$titleFontSize.variable]: "fontSizes.xs",
                [$fa46a297dac2e3dc$var$$descFontSize.variable]: "fontSizes.xs"
            }
        }),
        sm: $fa46a297dac2e3dc$var$definePartsStyle({
            stepper: {
                [$fa46a297dac2e3dc$var$$size.variable]: "sizes.6",
                [$fa46a297dac2e3dc$var$$iconSize.variable]: "sizes.4",
                [$fa46a297dac2e3dc$var$$titleFontSize.variable]: "fontSizes.sm",
                [$fa46a297dac2e3dc$var$$descFontSize.variable]: "fontSizes.xs"
            }
        }),
        md: $fa46a297dac2e3dc$var$definePartsStyle({
            stepper: {
                [$fa46a297dac2e3dc$var$$size.variable]: "sizes.8",
                [$fa46a297dac2e3dc$var$$iconSize.variable]: "sizes.5",
                [$fa46a297dac2e3dc$var$$titleFontSize.variable]: "fontSizes.md",
                [$fa46a297dac2e3dc$var$$descFontSize.variable]: "fontSizes.sm"
            }
        }),
        lg: $fa46a297dac2e3dc$var$definePartsStyle({
            stepper: {
                [$fa46a297dac2e3dc$var$$size.variable]: "sizes.10",
                [$fa46a297dac2e3dc$var$$iconSize.variable]: "sizes.6",
                [$fa46a297dac2e3dc$var$$titleFontSize.variable]: "fontSizes.lg",
                [$fa46a297dac2e3dc$var$$descFontSize.variable]: "fontSizes.md"
            }
        })
    },
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});





const { defineMultiStyleConfig: $f2caa07405e5033e$var$defineMultiStyleConfig, definePartsStyle: $f2caa07405e5033e$var$definePartsStyle } = (0, $8d7ccf069e08e0a2$export$d5f717dc145477b8)((0, $52fc62550c714bbf$export$921c1a2d1ce1e86a).keys);
const $f2caa07405e5033e$var$$width = (0, $cfd38c9d69ecffc9$export$8b4981022bd80a4e)("switch-track-width");
const $f2caa07405e5033e$var$$height = (0, $cfd38c9d69ecffc9$export$8b4981022bd80a4e)("switch-track-height");
const $f2caa07405e5033e$var$$diff = (0, $cfd38c9d69ecffc9$export$8b4981022bd80a4e)("switch-track-diff");
const $f2caa07405e5033e$var$diffValue = (0, $68e91679e3618cb6$export$42bfa9b2d4dad91a).subtract($f2caa07405e5033e$var$$width, $f2caa07405e5033e$var$$height);
const $f2caa07405e5033e$var$$translateX = (0, $cfd38c9d69ecffc9$export$8b4981022bd80a4e)("switch-thumb-x");
const $f2caa07405e5033e$var$$bg = (0, $cfd38c9d69ecffc9$export$8b4981022bd80a4e)("switch-bg");
const $f2caa07405e5033e$var$baseStyleTrack = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    return {
        borderRadius: "full",
        p: "0.5",
        width: [
            $f2caa07405e5033e$var$$width.reference
        ],
        height: [
            $f2caa07405e5033e$var$$height.reference
        ],
        transitionProperty: "common",
        transitionDuration: "fast",
        [$f2caa07405e5033e$var$$bg.variable]: "colors.gray.300",
        _dark: {
            [$f2caa07405e5033e$var$$bg.variable]: "colors.whiteAlpha.400"
        },
        _focusVisible: {
            boxShadow: "outline"
        },
        _disabled: {
            opacity: 0.4,
            cursor: "not-allowed"
        },
        _checked: {
            [$f2caa07405e5033e$var$$bg.variable]: `colors.${c}.500`,
            _dark: {
                [$f2caa07405e5033e$var$$bg.variable]: `colors.${c}.200`
            }
        },
        bg: $f2caa07405e5033e$var$$bg.reference
    };
});
const $f2caa07405e5033e$var$baseStyleThumb = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    bg: "white",
    transitionProperty: "transform",
    transitionDuration: "normal",
    borderRadius: "inherit",
    width: [
        $f2caa07405e5033e$var$$height.reference
    ],
    height: [
        $f2caa07405e5033e$var$$height.reference
    ],
    _checked: {
        transform: `translateX(${$f2caa07405e5033e$var$$translateX.reference})`
    }
});
const $f2caa07405e5033e$var$baseStyle = $f2caa07405e5033e$var$definePartsStyle((props)=>({
        container: {
            [$f2caa07405e5033e$var$$diff.variable]: $f2caa07405e5033e$var$diffValue,
            [$f2caa07405e5033e$var$$translateX.variable]: $f2caa07405e5033e$var$$diff.reference,
            _rtl: {
                [$f2caa07405e5033e$var$$translateX.variable]: (0, $68e91679e3618cb6$export$42bfa9b2d4dad91a)($f2caa07405e5033e$var$$diff).negate().toString()
            }
        },
        track: $f2caa07405e5033e$var$baseStyleTrack(props),
        thumb: $f2caa07405e5033e$var$baseStyleThumb
    }));
const $f2caa07405e5033e$var$sizes = {
    sm: $f2caa07405e5033e$var$definePartsStyle({
        container: {
            [$f2caa07405e5033e$var$$width.variable]: "1.375rem",
            [$f2caa07405e5033e$var$$height.variable]: "sizes.3"
        }
    }),
    md: $f2caa07405e5033e$var$definePartsStyle({
        container: {
            [$f2caa07405e5033e$var$$width.variable]: "1.875rem",
            [$f2caa07405e5033e$var$$height.variable]: "sizes.4"
        }
    }),
    lg: $f2caa07405e5033e$var$definePartsStyle({
        container: {
            [$f2caa07405e5033e$var$$width.variable]: "2.875rem",
            [$f2caa07405e5033e$var$$height.variable]: "sizes.6"
        }
    })
};
const $f2caa07405e5033e$export$6856b73e98185bff = $f2caa07405e5033e$var$defineMultiStyleConfig({
    baseStyle: $f2caa07405e5033e$var$baseStyle,
    sizes: $f2caa07405e5033e$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});





const { defineMultiStyleConfig: $92ac31e834875188$var$defineMultiStyleConfig, definePartsStyle: $92ac31e834875188$var$definePartsStyle } = (0, $8d7ccf069e08e0a2$export$d5f717dc145477b8)((0, $52fc62550c714bbf$export$8b1b9cdd5db9f5fd).keys);
const $92ac31e834875188$var$baseStyle = $92ac31e834875188$var$definePartsStyle({
    table: {
        fontVariantNumeric: "lining-nums tabular-nums",
        borderCollapse: "collapse",
        width: "full"
    },
    th: {
        fontFamily: "heading",
        fontWeight: "bold",
        textTransform: "uppercase",
        letterSpacing: "wider",
        textAlign: "start"
    },
    td: {
        textAlign: "start"
    },
    caption: {
        mt: 4,
        fontFamily: "heading",
        textAlign: "center",
        fontWeight: "medium"
    }
});
const $92ac31e834875188$var$numericStyles = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    "&[data-is-numeric=true]": {
        textAlign: "end"
    }
});
const $92ac31e834875188$var$variantSimple = $92ac31e834875188$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        th: {
            color: (0, $37b8f53742d8e800$export$549ff81930776885)("gray.600", "gray.400")(props),
            borderBottom: "1px",
            borderColor: (0, $37b8f53742d8e800$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props),
            ...$92ac31e834875188$var$numericStyles
        },
        td: {
            borderBottom: "1px",
            borderColor: (0, $37b8f53742d8e800$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props),
            ...$92ac31e834875188$var$numericStyles
        },
        caption: {
            color: (0, $37b8f53742d8e800$export$549ff81930776885)("gray.600", "gray.100")(props)
        },
        tfoot: {
            tr: {
                "&:last-of-type": {
                    th: {
                        borderBottomWidth: 0
                    }
                }
            }
        }
    };
});
const $92ac31e834875188$var$variantStripe = $92ac31e834875188$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        th: {
            color: (0, $37b8f53742d8e800$export$549ff81930776885)("gray.600", "gray.400")(props),
            borderBottom: "1px",
            borderColor: (0, $37b8f53742d8e800$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props),
            ...$92ac31e834875188$var$numericStyles
        },
        td: {
            borderBottom: "1px",
            borderColor: (0, $37b8f53742d8e800$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props),
            ...$92ac31e834875188$var$numericStyles
        },
        caption: {
            color: (0, $37b8f53742d8e800$export$549ff81930776885)("gray.600", "gray.100")(props)
        },
        tbody: {
            tr: {
                "&:nth-of-type(odd)": {
                    "th, td": {
                        borderBottomWidth: "1px",
                        borderColor: (0, $37b8f53742d8e800$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props)
                    },
                    td: {
                        background: (0, $37b8f53742d8e800$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props)
                    }
                }
            }
        },
        tfoot: {
            tr: {
                "&:last-of-type": {
                    th: {
                        borderBottomWidth: 0
                    }
                }
            }
        }
    };
});
const $92ac31e834875188$var$variants = {
    simple: $92ac31e834875188$var$variantSimple,
    striped: $92ac31e834875188$var$variantStripe,
    unstyled: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({})
};
const $92ac31e834875188$var$sizes = {
    sm: $92ac31e834875188$var$definePartsStyle({
        th: {
            px: "4",
            py: "1",
            lineHeight: "4",
            fontSize: "xs"
        },
        td: {
            px: "4",
            py: "2",
            fontSize: "sm",
            lineHeight: "4"
        },
        caption: {
            px: "4",
            py: "2",
            fontSize: "xs"
        }
    }),
    md: $92ac31e834875188$var$definePartsStyle({
        th: {
            px: "6",
            py: "3",
            lineHeight: "4",
            fontSize: "xs"
        },
        td: {
            px: "6",
            py: "4",
            lineHeight: "5"
        },
        caption: {
            px: "6",
            py: "2",
            fontSize: "sm"
        }
    }),
    lg: $92ac31e834875188$var$definePartsStyle({
        th: {
            px: "8",
            py: "4",
            lineHeight: "5",
            fontSize: "sm"
        },
        td: {
            px: "8",
            py: "5",
            lineHeight: "6"
        },
        caption: {
            px: "6",
            py: "2",
            fontSize: "md"
        }
    })
};
const $92ac31e834875188$export$3339219781bb5161 = $92ac31e834875188$var$defineMultiStyleConfig({
    baseStyle: $92ac31e834875188$var$baseStyle,
    variants: $92ac31e834875188$var$variants,
    sizes: $92ac31e834875188$var$sizes,
    defaultProps: {
        variant: "simple",
        size: "md",
        colorScheme: "gray"
    }
});





const $1758427d9b5cdc6e$var$$fg = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("tabs-color");
const $1758427d9b5cdc6e$var$$bg = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("tabs-bg");
const $1758427d9b5cdc6e$var$$border = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("tabs-border-color");
const { defineMultiStyleConfig: $1758427d9b5cdc6e$var$defineMultiStyleConfig, definePartsStyle: $1758427d9b5cdc6e$var$definePartsStyle } = (0, $8d7ccf069e08e0a2$export$d5f717dc145477b8)((0, $52fc62550c714bbf$export$97383552563be58d).keys);
const $1758427d9b5cdc6e$var$baseStyleRoot = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>{
    const { orientation: orientation } = props;
    return {
        display: orientation === "vertical" ? "flex" : "block"
    };
});
const $1758427d9b5cdc6e$var$baseStyleTab = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>{
    const { isFitted: isFitted } = props;
    return {
        flex: isFitted ? 1 : void 0,
        transitionProperty: "common",
        transitionDuration: "normal",
        _focusVisible: {
            zIndex: 1,
            boxShadow: "outline"
        },
        _disabled: {
            cursor: "not-allowed",
            opacity: 0.4
        }
    };
});
const $1758427d9b5cdc6e$var$baseStyleTablist = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>{
    const { align: align = "start", orientation: orientation } = props;
    const alignments = {
        end: "flex-end",
        center: "center",
        start: "flex-start"
    };
    return {
        justifyContent: alignments[align],
        flexDirection: orientation === "vertical" ? "column" : "row"
    };
});
const $1758427d9b5cdc6e$var$baseStyleTabpanel = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    p: 4
});
const $1758427d9b5cdc6e$var$baseStyle = $1758427d9b5cdc6e$var$definePartsStyle((props)=>({
        root: $1758427d9b5cdc6e$var$baseStyleRoot(props),
        tab: $1758427d9b5cdc6e$var$baseStyleTab(props),
        tablist: $1758427d9b5cdc6e$var$baseStyleTablist(props),
        tabpanel: $1758427d9b5cdc6e$var$baseStyleTabpanel
    }));
const $1758427d9b5cdc6e$var$sizes = {
    sm: $1758427d9b5cdc6e$var$definePartsStyle({
        tab: {
            py: 1,
            px: 4,
            fontSize: "sm"
        }
    }),
    md: $1758427d9b5cdc6e$var$definePartsStyle({
        tab: {
            fontSize: "md",
            py: 2,
            px: 4
        }
    }),
    lg: $1758427d9b5cdc6e$var$definePartsStyle({
        tab: {
            fontSize: "lg",
            py: 3,
            px: 4
        }
    })
};
const $1758427d9b5cdc6e$var$variantLine = $1758427d9b5cdc6e$var$definePartsStyle((props)=>{
    const { colorScheme: c, orientation: orientation } = props;
    const isVertical = orientation === "vertical";
    const borderProp = isVertical ? "borderStart" : "borderBottom";
    const marginProp = isVertical ? "marginStart" : "marginBottom";
    return {
        tablist: {
            [borderProp]: "2px solid",
            borderColor: "inherit"
        },
        tab: {
            [borderProp]: "2px solid",
            borderColor: "transparent",
            [marginProp]: "-2px",
            _selected: {
                [$1758427d9b5cdc6e$var$$fg.variable]: `colors.${c}.600`,
                _dark: {
                    [$1758427d9b5cdc6e$var$$fg.variable]: `colors.${c}.300`
                },
                borderColor: "currentColor"
            },
            _active: {
                [$1758427d9b5cdc6e$var$$bg.variable]: "colors.gray.200",
                _dark: {
                    [$1758427d9b5cdc6e$var$$bg.variable]: "colors.whiteAlpha.300"
                }
            },
            _disabled: {
                _active: {
                    bg: "none"
                }
            },
            color: $1758427d9b5cdc6e$var$$fg.reference,
            bg: $1758427d9b5cdc6e$var$$bg.reference
        }
    };
});
const $1758427d9b5cdc6e$var$variantEnclosed = $1758427d9b5cdc6e$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        tab: {
            borderTopRadius: "md",
            border: "1px solid",
            borderColor: "transparent",
            mb: "-1px",
            [$1758427d9b5cdc6e$var$$border.variable]: "transparent",
            _selected: {
                [$1758427d9b5cdc6e$var$$fg.variable]: `colors.${c}.600`,
                [$1758427d9b5cdc6e$var$$border.variable]: `colors.white`,
                _dark: {
                    [$1758427d9b5cdc6e$var$$fg.variable]: `colors.${c}.300`,
                    [$1758427d9b5cdc6e$var$$border.variable]: `colors.gray.800`
                },
                borderColor: "inherit",
                borderBottomColor: $1758427d9b5cdc6e$var$$border.reference
            },
            color: $1758427d9b5cdc6e$var$$fg.reference
        },
        tablist: {
            mb: "-1px",
            borderBottom: "1px solid",
            borderColor: "inherit"
        }
    };
});
const $1758427d9b5cdc6e$var$variantEnclosedColored = $1758427d9b5cdc6e$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        tab: {
            border: "1px solid",
            borderColor: "inherit",
            [$1758427d9b5cdc6e$var$$bg.variable]: "colors.gray.50",
            _dark: {
                [$1758427d9b5cdc6e$var$$bg.variable]: "colors.whiteAlpha.50"
            },
            mb: "-1px",
            _notLast: {
                marginEnd: "-1px"
            },
            _selected: {
                [$1758427d9b5cdc6e$var$$bg.variable]: "colors.white",
                [$1758427d9b5cdc6e$var$$fg.variable]: `colors.${c}.600`,
                _dark: {
                    [$1758427d9b5cdc6e$var$$bg.variable]: "colors.gray.800",
                    [$1758427d9b5cdc6e$var$$fg.variable]: `colors.${c}.300`
                },
                borderColor: "inherit",
                borderTopColor: "currentColor",
                borderBottomColor: "transparent"
            },
            color: $1758427d9b5cdc6e$var$$fg.reference,
            bg: $1758427d9b5cdc6e$var$$bg.reference
        },
        tablist: {
            mb: "-1px",
            borderBottom: "1px solid",
            borderColor: "inherit"
        }
    };
});
const $1758427d9b5cdc6e$var$variantSoftRounded = $1758427d9b5cdc6e$var$definePartsStyle((props)=>{
    const { colorScheme: c, theme: theme } = props;
    return {
        tab: {
            borderRadius: "full",
            fontWeight: "semibold",
            color: "gray.600",
            _selected: {
                color: (0, $4d69a52220934355$export$5551a2d24ff40153)(theme, `${c}.700`),
                bg: (0, $4d69a52220934355$export$5551a2d24ff40153)(theme, `${c}.100`)
            }
        }
    };
});
const $1758427d9b5cdc6e$var$variantSolidRounded = $1758427d9b5cdc6e$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        tab: {
            borderRadius: "full",
            fontWeight: "semibold",
            [$1758427d9b5cdc6e$var$$fg.variable]: "colors.gray.600",
            _dark: {
                [$1758427d9b5cdc6e$var$$fg.variable]: "inherit"
            },
            _selected: {
                [$1758427d9b5cdc6e$var$$fg.variable]: "colors.white",
                [$1758427d9b5cdc6e$var$$bg.variable]: `colors.${c}.600`,
                _dark: {
                    [$1758427d9b5cdc6e$var$$fg.variable]: "colors.gray.800",
                    [$1758427d9b5cdc6e$var$$bg.variable]: `colors.${c}.300`
                }
            },
            color: $1758427d9b5cdc6e$var$$fg.reference,
            bg: $1758427d9b5cdc6e$var$$bg.reference
        }
    };
});
const $1758427d9b5cdc6e$var$variantUnstyled = $1758427d9b5cdc6e$var$definePartsStyle({});
const $1758427d9b5cdc6e$var$variants = {
    line: $1758427d9b5cdc6e$var$variantLine,
    enclosed: $1758427d9b5cdc6e$var$variantEnclosed,
    "enclosed-colored": $1758427d9b5cdc6e$var$variantEnclosedColored,
    "soft-rounded": $1758427d9b5cdc6e$var$variantSoftRounded,
    "solid-rounded": $1758427d9b5cdc6e$var$variantSolidRounded,
    unstyled: $1758427d9b5cdc6e$var$variantUnstyled
};
const $1758427d9b5cdc6e$export$847a245e7ebce2a1 = $1758427d9b5cdc6e$var$defineMultiStyleConfig({
    baseStyle: $1758427d9b5cdc6e$var$baseStyle,
    sizes: $1758427d9b5cdc6e$var$sizes,
    variants: $1758427d9b5cdc6e$var$variants,
    defaultProps: {
        size: "md",
        variant: "line",
        colorScheme: "blue"
    }
});





const { defineMultiStyleConfig: $5a022b0534305c6f$var$defineMultiStyleConfig, definePartsStyle: $5a022b0534305c6f$var$definePartsStyle } = (0, $8d7ccf069e08e0a2$export$d5f717dc145477b8)((0, $52fc62550c714bbf$export$4c2f5f7f2ea94a8e).keys);
const $5a022b0534305c6f$var$$bg = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("tag-bg");
const $5a022b0534305c6f$var$$color = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("tag-color");
const $5a022b0534305c6f$var$$shadow = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("tag-shadow");
const $5a022b0534305c6f$var$$minH = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("tag-min-height");
const $5a022b0534305c6f$var$$minW = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("tag-min-width");
const $5a022b0534305c6f$var$$fontSize = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("tag-font-size");
const $5a022b0534305c6f$var$$paddingX = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("tag-padding-inline");
const $5a022b0534305c6f$var$baseStyleContainer = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    fontWeight: "medium",
    lineHeight: 1.2,
    outline: 0,
    [$5a022b0534305c6f$var$$color.variable]: (0, $23f998ac7374aa93$export$947cd287c296b479).color.reference,
    [$5a022b0534305c6f$var$$bg.variable]: (0, $23f998ac7374aa93$export$947cd287c296b479).bg.reference,
    [$5a022b0534305c6f$var$$shadow.variable]: (0, $23f998ac7374aa93$export$947cd287c296b479).shadow.reference,
    color: $5a022b0534305c6f$var$$color.reference,
    bg: $5a022b0534305c6f$var$$bg.reference,
    boxShadow: $5a022b0534305c6f$var$$shadow.reference,
    borderRadius: "md",
    minH: $5a022b0534305c6f$var$$minH.reference,
    minW: $5a022b0534305c6f$var$$minW.reference,
    fontSize: $5a022b0534305c6f$var$$fontSize.reference,
    px: $5a022b0534305c6f$var$$paddingX.reference,
    _focusVisible: {
        [$5a022b0534305c6f$var$$shadow.variable]: "shadows.outline"
    }
});
const $5a022b0534305c6f$var$baseStyleLabel = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    lineHeight: 1.2,
    overflow: "visible"
});
const $5a022b0534305c6f$var$baseStyleCloseButton = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    fontSize: "lg",
    w: "5",
    h: "5",
    transitionProperty: "common",
    transitionDuration: "normal",
    borderRadius: "full",
    marginStart: "1.5",
    marginEnd: "-1",
    opacity: 0.5,
    _disabled: {
        opacity: 0.4
    },
    _focusVisible: {
        boxShadow: "outline",
        bg: "rgba(0, 0, 0, 0.14)"
    },
    _hover: {
        opacity: 0.8
    },
    _active: {
        opacity: 1
    }
});
const $5a022b0534305c6f$var$baseStyle = $5a022b0534305c6f$var$definePartsStyle({
    container: $5a022b0534305c6f$var$baseStyleContainer,
    label: $5a022b0534305c6f$var$baseStyleLabel,
    closeButton: $5a022b0534305c6f$var$baseStyleCloseButton
});
const $5a022b0534305c6f$var$sizes = {
    sm: $5a022b0534305c6f$var$definePartsStyle({
        container: {
            [$5a022b0534305c6f$var$$minH.variable]: "sizes.5",
            [$5a022b0534305c6f$var$$minW.variable]: "sizes.5",
            [$5a022b0534305c6f$var$$fontSize.variable]: "fontSizes.xs",
            [$5a022b0534305c6f$var$$paddingX.variable]: "space.2"
        },
        closeButton: {
            marginEnd: "-2px",
            marginStart: "0.35rem"
        }
    }),
    md: $5a022b0534305c6f$var$definePartsStyle({
        container: {
            [$5a022b0534305c6f$var$$minH.variable]: "sizes.6",
            [$5a022b0534305c6f$var$$minW.variable]: "sizes.6",
            [$5a022b0534305c6f$var$$fontSize.variable]: "fontSizes.sm",
            [$5a022b0534305c6f$var$$paddingX.variable]: "space.2"
        }
    }),
    lg: $5a022b0534305c6f$var$definePartsStyle({
        container: {
            [$5a022b0534305c6f$var$$minH.variable]: "sizes.8",
            [$5a022b0534305c6f$var$$minW.variable]: "sizes.8",
            [$5a022b0534305c6f$var$$fontSize.variable]: "fontSizes.md",
            [$5a022b0534305c6f$var$$paddingX.variable]: "space.3"
        }
    })
};
const $5a022b0534305c6f$var$variants = {
    subtle: $5a022b0534305c6f$var$definePartsStyle((props)=>({
            container: (0, $23f998ac7374aa93$export$eb6e7cbc82d0f88b).variants?.subtle(props)
        })),
    solid: $5a022b0534305c6f$var$definePartsStyle((props)=>({
            container: (0, $23f998ac7374aa93$export$eb6e7cbc82d0f88b).variants?.solid(props)
        })),
    outline: $5a022b0534305c6f$var$definePartsStyle((props)=>({
            container: (0, $23f998ac7374aa93$export$eb6e7cbc82d0f88b).variants?.outline(props)
        }))
};
const $5a022b0534305c6f$export$f8ab9ac2a319695b = $5a022b0534305c6f$var$defineMultiStyleConfig({
    variants: $5a022b0534305c6f$var$variants,
    baseStyle: $5a022b0534305c6f$var$baseStyle,
    sizes: $5a022b0534305c6f$var$sizes,
    defaultProps: {
        size: "md",
        variant: "subtle",
        colorScheme: "gray"
    }
});




const $c7eff9738c2c7181$var$baseStyle = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    ...(0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).baseStyle?.field,
    paddingY: "2",
    minHeight: "20",
    lineHeight: "short",
    verticalAlign: "top"
});
const $c7eff9738c2c7181$var$variants = {
    outline: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>(0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).variants?.outline(props).field ?? {}),
    flushed: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>(0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).variants?.flushed(props).field ?? {}),
    filled: (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)((props)=>(0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).variants?.filled(props).field ?? {}),
    unstyled: (0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).variants?.unstyled.field ?? {}
};
const $c7eff9738c2c7181$var$sizes = {
    xs: (0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).sizes?.xs.field ?? {},
    sm: (0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).sizes?.sm.field ?? {},
    md: (0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).sizes?.md.field ?? {},
    lg: (0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54).sizes?.lg.field ?? {}
};
const $c7eff9738c2c7181$export$394b8322fab774c1 = (0, $8d7ccf069e08e0a2$export$5c9a64458a4ed8a4)({
    baseStyle: $c7eff9738c2c7181$var$baseStyle,
    sizes: $c7eff9738c2c7181$var$sizes,
    variants: $c7eff9738c2c7181$var$variants,
    defaultProps: {
        size: "md",
        variant: "outline"
    }
});




const $ba04d9dcc71d24b1$var$$bg = (0, $cfd38c9d69ecffc9$export$8b4981022bd80a4e)("tooltip-bg");
const $ba04d9dcc71d24b1$var$$fg = (0, $cfd38c9d69ecffc9$export$8b4981022bd80a4e)("tooltip-fg");
const $ba04d9dcc71d24b1$var$$arrowBg = (0, $cfd38c9d69ecffc9$export$8b4981022bd80a4e)("popper-arrow-bg");
const $ba04d9dcc71d24b1$var$baseStyle = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    bg: $ba04d9dcc71d24b1$var$$bg.reference,
    color: $ba04d9dcc71d24b1$var$$fg.reference,
    [$ba04d9dcc71d24b1$var$$bg.variable]: "colors.gray.700",
    [$ba04d9dcc71d24b1$var$$fg.variable]: "colors.whiteAlpha.900",
    _dark: {
        [$ba04d9dcc71d24b1$var$$bg.variable]: "colors.gray.300",
        [$ba04d9dcc71d24b1$var$$fg.variable]: "colors.gray.900"
    },
    [$ba04d9dcc71d24b1$var$$arrowBg.variable]: $ba04d9dcc71d24b1$var$$bg.reference,
    px: "2",
    py: "0.5",
    borderRadius: "sm",
    fontWeight: "medium",
    fontSize: "sm",
    boxShadow: "md",
    maxW: "xs",
    zIndex: "tooltip"
});
const $ba04d9dcc71d24b1$export$7472a7883840b563 = (0, $8d7ccf069e08e0a2$export$5c9a64458a4ed8a4)({
    baseStyle: $ba04d9dcc71d24b1$var$baseStyle
});


const $f1b544f56d781b21$export$9b5ac10f59f76296 = {
    Accordion: (0, $023ac293753e3098$export$20ec2254f76fa604),
    Alert: (0, $d7cb368afffa3532$export$9d77d9665d829e89),
    Avatar: (0, $f8889329eca89b14$export$9975d21893c10e66),
    Badge: (0, $23f998ac7374aa93$export$eb6e7cbc82d0f88b),
    Breadcrumb: (0, $9f6f278d0733b607$export$e2d8c6f6af55009),
    Button: (0, $d73f50da4c8d30bf$export$577deec5d331f6be),
    Checkbox: (0, $0ca4e214b54757fd$export$86286d8c37984115),
    CloseButton: (0, $d1e3840686d5a9e0$export$47615e5b7f7e315f),
    Code: (0, $72f3326394570a2d$export$f9b9a8633a36e3c7),
    Container: (0, $5b07e5d79ed38f2b$export$3ca0760d240fe5f4),
    Divider: (0, $8c65f681dcb39dca$export$f0e91f779c5bb416),
    Drawer: (0, $6b5932b76005d954$export$8057937c11129602),
    Editable: (0, $e1cd97034ee8715e$export$a09813cbe72349b1),
    Form: (0, $1bb6915b07ab1aeb$export$870bcc1d98fee0aa),
    FormError: (0, $f53feeec21f482b0$export$b8d6747e16cd5f4d),
    FormLabel: (0, $728b1a145d429543$export$c49af69dbfc0c993),
    Heading: (0, $1b33832437d7c8cf$export$5f175074e0f09e7b),
    Input: (0, $4b3c58b0e6e141ca$export$b1b9f3bced726e54),
    Kbd: (0, $036d271f404b38cc$export$e193528a501e9a4a),
    Link: (0, $31bc4fb96ac62636$export$af7f58b96695762e),
    List: (0, $9d9970829dc32716$export$ce840f8e8ef752d),
    Menu: (0, $36deda6b76e1e00d$export$687ce088075ea42b),
    Modal: (0, $81ce714c8cf90ce7$export$158ae9a07be41c05),
    NumberInput: (0, $6907580507ff3147$export$b9bc5fa6e7f960a1),
    PinInput: (0, $7cf2ba0ffa79695c$export$8504c22c55a552e0),
    Popover: (0, $9039829e11461b55$export$135f12f777be1ef7),
    Progress: (0, $7ac8b45047d2fc2c$export$dc04d8e6a17afea1),
    Radio: (0, $9052b0594a97d3c5$export$f0b387b940941887),
    Select: (0, $8f3e073822cf3f64$export$21af0fc3c16183e1),
    Skeleton: (0, $3eedb63d701bb5f1$export$7680371ad2d79142),
    SkipLink: (0, $a578b7de46c890e7$export$a8cf3228ef52959),
    Slider: (0, $d5e6bd099e4d9c3d$export$fff8df8fd8e1ed6f),
    Spinner: (0, $c055b83805192e3f$export$d76156e68e556d3f),
    Stat: (0, $62451f1ddd6da230$export$f3301eb37a20f09e),
    Switch: (0, $f2caa07405e5033e$export$6856b73e98185bff),
    Table: (0, $92ac31e834875188$export$3339219781bb5161),
    Tabs: (0, $1758427d9b5cdc6e$export$847a245e7ebce2a1),
    Tag: (0, $5a022b0534305c6f$export$f8ab9ac2a319695b),
    Textarea: (0, $c7eff9738c2c7181$export$394b8322fab774c1),
    Tooltip: (0, $ba04d9dcc71d24b1$export$7472a7883840b563),
    Card: (0, $1e9e9815abc906fb$export$880f7b1201440c23),
    Stepper: (0, $fa46a297dac2e3dc$export$54c84d54375c8d75)
};


const $a11dc2dba4d17ed1$export$2e2bcd8739ae039 = {
    none: 0,
    "1px": "1px solid",
    "2px": "2px solid",
    "4px": "4px solid",
    "8px": "8px solid"
};


const $d6cf977c3276e7bb$export$2e2bcd8739ae039 = {
    base: "0em",
    sm: "30em",
    md: "48em",
    lg: "62em",
    xl: "80em",
    "2xl": "96em"
};


const $00dd83f133c429bf$export$2e2bcd8739ae039 = {
    transparent: "transparent",
    current: "currentColor",
    black: "#000000",
    white: "#FFFFFF",
    whiteAlpha: {
        50: "rgba(255, 255, 255, 0.04)",
        100: "rgba(255, 255, 255, 0.06)",
        200: "rgba(255, 255, 255, 0.08)",
        300: "rgba(255, 255, 255, 0.16)",
        400: "rgba(255, 255, 255, 0.24)",
        500: "rgba(255, 255, 255, 0.36)",
        600: "rgba(255, 255, 255, 0.48)",
        700: "rgba(255, 255, 255, 0.64)",
        800: "rgba(255, 255, 255, 0.80)",
        900: "rgba(255, 255, 255, 0.92)"
    },
    blackAlpha: {
        50: "rgba(0, 0, 0, 0.04)",
        100: "rgba(0, 0, 0, 0.06)",
        200: "rgba(0, 0, 0, 0.08)",
        300: "rgba(0, 0, 0, 0.16)",
        400: "rgba(0, 0, 0, 0.24)",
        500: "rgba(0, 0, 0, 0.36)",
        600: "rgba(0, 0, 0, 0.48)",
        700: "rgba(0, 0, 0, 0.64)",
        800: "rgba(0, 0, 0, 0.80)",
        900: "rgba(0, 0, 0, 0.92)"
    },
    gray: {
        50: "#F7FAFC",
        100: "#EDF2F7",
        200: "#E2E8F0",
        300: "#CBD5E0",
        400: "#A0AEC0",
        500: "#718096",
        600: "#4A5568",
        700: "#2D3748",
        800: "#1A202C",
        900: "#171923"
    },
    red: {
        50: "#FFF5F5",
        100: "#FED7D7",
        200: "#FEB2B2",
        300: "#FC8181",
        400: "#F56565",
        500: "#E53E3E",
        600: "#C53030",
        700: "#9B2C2C",
        800: "#822727",
        900: "#63171B"
    },
    orange: {
        50: "#FFFAF0",
        100: "#FEEBC8",
        200: "#FBD38D",
        300: "#F6AD55",
        400: "#ED8936",
        500: "#DD6B20",
        600: "#C05621",
        700: "#9C4221",
        800: "#7B341E",
        900: "#652B19"
    },
    yellow: {
        50: "#FFFFF0",
        100: "#FEFCBF",
        200: "#FAF089",
        300: "#F6E05E",
        400: "#ECC94B",
        500: "#D69E2E",
        600: "#B7791F",
        700: "#975A16",
        800: "#744210",
        900: "#5F370E"
    },
    green: {
        50: "#F0FFF4",
        100: "#C6F6D5",
        200: "#9AE6B4",
        300: "#68D391",
        400: "#48BB78",
        500: "#38A169",
        600: "#2F855A",
        700: "#276749",
        800: "#22543D",
        900: "#1C4532"
    },
    teal: {
        50: "#E6FFFA",
        100: "#B2F5EA",
        200: "#81E6D9",
        300: "#4FD1C5",
        400: "#38B2AC",
        500: "#319795",
        600: "#2C7A7B",
        700: "#285E61",
        800: "#234E52",
        900: "#1D4044"
    },
    blue: {
        50: "#ebf8ff",
        100: "#bee3f8",
        200: "#90cdf4",
        300: "#63b3ed",
        400: "#4299e1",
        500: "#3182ce",
        600: "#2b6cb0",
        700: "#2c5282",
        800: "#2a4365",
        900: "#1A365D"
    },
    cyan: {
        50: "#EDFDFD",
        100: "#C4F1F9",
        200: "#9DECF9",
        300: "#76E4F7",
        400: "#0BC5EA",
        500: "#00B5D8",
        600: "#00A3C4",
        700: "#0987A0",
        800: "#086F83",
        900: "#065666"
    },
    purple: {
        50: "#FAF5FF",
        100: "#E9D8FD",
        200: "#D6BCFA",
        300: "#B794F4",
        400: "#9F7AEA",
        500: "#805AD5",
        600: "#6B46C1",
        700: "#553C9A",
        800: "#44337A",
        900: "#322659"
    },
    pink: {
        50: "#FFF5F7",
        100: "#FED7E2",
        200: "#FBB6CE",
        300: "#F687B3",
        400: "#ED64A6",
        500: "#D53F8C",
        600: "#B83280",
        700: "#97266D",
        800: "#702459",
        900: "#521B41"
    }
};


const $0380e094bc6d7d3a$export$2e2bcd8739ae039 = {
    none: "0",
    sm: "0.125rem",
    base: "0.25rem",
    md: "0.375rem",
    lg: "0.5rem",
    xl: "0.75rem",
    "2xl": "1rem",
    "3xl": "1.5rem",
    full: "9999px"
};


const $ac38960603f03f3b$export$2e2bcd8739ae039 = {
    xs: "0 0 0 1px rgba(0, 0, 0, 0.05)",
    sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    outline: "0 0 0 3px rgba(66, 153, 225, 0.6)",
    inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
    none: "none",
    "dark-lg": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px"
};




const $6279d4e92c768187$var$transitionProperty = {
    common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
    colors: "background-color, border-color, color, fill, stroke",
    dimensions: "width, height",
    position: "left, right, top, bottom",
    background: "background-color, background-image, background-position"
};
const $6279d4e92c768187$var$transitionTimingFunction = {
    "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
    "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
    "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
};
const $6279d4e92c768187$var$transitionDuration = {
    "ultra-fast": "50ms",
    faster: "100ms",
    fast: "150ms",
    normal: "200ms",
    slow: "300ms",
    slower: "400ms",
    "ultra-slow": "500ms"
};
const $6279d4e92c768187$export$2e2bcd8739ae039 = {
    property: $6279d4e92c768187$var$transitionProperty,
    easing: $6279d4e92c768187$var$transitionTimingFunction,
    duration: $6279d4e92c768187$var$transitionDuration
};



const $876a8fb0f8cf4760$export$2e2bcd8739ae039 = {
    hide: -1,
    auto: "auto",
    base: 0,
    docked: 10,
    dropdown: 1e3,
    sticky: 1100,
    banner: 1200,
    overlay: 1300,
    modal: 1400,
    popover: 1500,
    skipLink: 1600,
    toast: 1700,
    tooltip: 1800
};


const $cb70337a3ae63f3e$export$2e2bcd8739ae039 = {
    none: 0,
    sm: "4px",
    base: "8px",
    md: "12px",
    lg: "16px",
    xl: "24px",
    "2xl": "40px",
    "3xl": "64px"
};


const $d75eacc2226d3bd8$export$651a0b7b10dae380 = {
    breakpoints: $d6cf977c3276e7bb$export$2e2bcd8739ae039,
    zIndices: $876a8fb0f8cf4760$export$2e2bcd8739ae039,
    radii: $0380e094bc6d7d3a$export$2e2bcd8739ae039,
    blur: $cb70337a3ae63f3e$export$2e2bcd8739ae039,
    colors: $00dd83f133c429bf$export$2e2bcd8739ae039,
    ...(0, $5bc790e5a1cb6d07$export$2e2bcd8739ae039),
    sizes: $28f18922c5747ca5$export$2e2bcd8739ae039,
    shadows: $ac38960603f03f3b$export$2e2bcd8739ae039,
    space: (0, $e6e0e28ef0210b6a$export$5458b64234d1333c),
    borders: $a11dc2dba4d17ed1$export$2e2bcd8739ae039,
    transition: $6279d4e92c768187$export$2e2bcd8739ae039
};


const $a5b8ee1d698388c0$export$c1b409c4e1d33fce = {
    colors: {
        "chakra-body-text": {
            _light: "gray.800",
            _dark: "whiteAlpha.900"
        },
        "chakra-body-bg": {
            _light: "white",
            _dark: "gray.800"
        },
        "chakra-border-color": {
            _light: "gray.200",
            _dark: "whiteAlpha.300"
        },
        "chakra-inverse-text": {
            _light: "white",
            _dark: "gray.800"
        },
        "chakra-subtle-bg": {
            _light: "gray.100",
            _dark: "gray.700"
        },
        "chakra-subtle-text": {
            _light: "gray.600",
            _dark: "gray.400"
        },
        "chakra-placeholder-color": {
            _light: "gray.500",
            _dark: "whiteAlpha.400"
        }
    }
};


const $84de56c17187c8bb$export$9dd6ff9ea0189349 = {
    global: {
        body: {
            fontFamily: "body",
            color: "chakra-body-text",
            bg: "chakra-body-bg",
            transitionProperty: "background-color",
            transitionDuration: "normal",
            lineHeight: "base"
        },
        "*::placeholder": {
            color: "chakra-placeholder-color"
        },
        "*, *::before, &::after": {
            borderColor: "chakra-border-color"
        }
    }
};



var $fZQg5 = parcelRequire("fZQg5");
const $598e53bf8605736b$export$1fad0bb5bac74e8f = [
    "borders",
    "breakpoints",
    "colors",
    "components",
    "config",
    "direction",
    "fonts",
    "fontSizes",
    "fontWeights",
    "letterSpacings",
    "lineHeights",
    "radii",
    "shadows",
    "sizes",
    "space",
    "styles",
    "transition",
    "zIndices"
];
function $598e53bf8605736b$export$73a6ae01926a4f0e(unit) {
    if (!(0, $fZQg5.isObject)(unit)) return false;
    return $598e53bf8605736b$export$1fad0bb5bac74e8f.every((propertyName)=>Object.prototype.hasOwnProperty.call(unit, propertyName));
}


const $9336ec4b7857882b$var$direction = "ltr";
const $9336ec4b7857882b$var$config = {
    useSystemColorMode: false,
    initialColorMode: "light",
    cssVarPrefix: "chakra"
};
const $9336ec4b7857882b$export$bca14c5b3b88a9c9 = {
    semanticTokens: $a5b8ee1d698388c0$export$c1b409c4e1d33fce,
    direction: $9336ec4b7857882b$var$direction,
    ...(0, $d75eacc2226d3bd8$export$651a0b7b10dae380),
    components: $f1b544f56d781b21$export$9b5ac10f59f76296,
    styles: $84de56c17187c8bb$export$9dd6ff9ea0189349,
    config: $9336ec4b7857882b$var$config
};
const $9336ec4b7857882b$export$9e955aef208055a6 = {
    semanticTokens: $a5b8ee1d698388c0$export$c1b409c4e1d33fce,
    direction: $9336ec4b7857882b$var$direction,
    components: {},
    ...(0, $d75eacc2226d3bd8$export$651a0b7b10dae380),
    styles: $84de56c17187c8bb$export$9dd6ff9ea0189349,
    config: $9336ec4b7857882b$var$config
};



var $kxTYF = parcelRequire("kxTYF");

var $kxTYF = parcelRequire("kxTYF");

var $kxTYF = parcelRequire("kxTYF");
function $ede4194696cbd159$export$1b3bfaa9684536aa(el) {
    return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}
function $ede4194696cbd159$export$4e09c449d6c407f7() {
    return Boolean(globalThis?.document);
}
function $ede4194696cbd159$export$63ed1d20cf8213cf(element) {
    return $ede4194696cbd159$export$1b3bfaa9684536aa(element) && element.localName === "input" && "select" in element;
}
function $ede4194696cbd159$export$8a2eb51c14bb8899(element) {
    const doc = $ede4194696cbd159$export$1b3bfaa9684536aa(element) ? element.ownerDocument : document;
    return doc.activeElement === element;
}
function $ede4194696cbd159$export$ca1c506c57abefed(element) {
    if (element.parentElement && $ede4194696cbd159$export$ca1c506c57abefed(element.parentElement)) return true;
    return element.hidden;
}
function $ede4194696cbd159$export$de19eba357c4d80f(element) {
    const value = element.getAttribute("contenteditable");
    return value !== "false" && value != null;
}
function $ede4194696cbd159$export$f1048a3bb039cd02(element) {
    return Boolean(element.getAttribute("disabled")) === true || Boolean(element.getAttribute("aria-disabled")) === true;
}


parcelRequire("6iKRa");
var $FTTp4 = parcelRequire("FTTp4");

var $8v0nu = parcelRequire("8v0nu");

var $6jXOD = parcelRequire("6jXOD");
"use client";
const $ff48eea4c6649c63$var$classNames = {
    light: "chakra-ui-light",
    dark: "chakra-ui-dark"
};
function $ff48eea4c6649c63$export$4bb933d353baa01c(options = {}) {
    const { preventTransition: preventTransition = true, nonce: nonce } = options;
    const utils = {
        setDataset: (value)=>{
            const cleanup = preventTransition ? utils.preventTransition() : void 0;
            document.documentElement.dataset.theme = value;
            document.documentElement.style.colorScheme = value;
            cleanup?.();
        },
        setClassName (dark) {
            document.body.classList.add(dark ? $ff48eea4c6649c63$var$classNames.dark : $ff48eea4c6649c63$var$classNames.light);
            document.body.classList.remove(dark ? $ff48eea4c6649c63$var$classNames.light : $ff48eea4c6649c63$var$classNames.dark);
        },
        query () {
            return window.matchMedia("(prefers-color-scheme: dark)");
        },
        getSystemTheme (fallback) {
            const dark = utils.query().matches ?? fallback === "dark";
            return dark ? "dark" : "light";
        },
        addListener (fn) {
            const mql = utils.query();
            const listener = (e)=>{
                fn(e.matches ? "dark" : "light");
            };
            if (typeof mql.addListener === "function") mql.addListener(listener);
            else mql.addEventListener("change", listener);
            return ()=>{
                if (typeof mql.removeListener === "function") mql.removeListener(listener);
                else mql.removeEventListener("change", listener);
            };
        },
        preventTransition () {
            const css = document.createElement("style");
            css.appendChild(document.createTextNode(`*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}`));
            if (nonce !== void 0) css.nonce = nonce;
            document.head.appendChild(css);
            return ()=>{
                (()=>window.getComputedStyle(document.body))();
                requestAnimationFrame(()=>{
                    requestAnimationFrame(()=>{
                        document.head.removeChild(css);
                    });
                });
            };
        }
    };
    return utils;
}


"use client";
const $87e9ffa45b14f6e0$export$86880b4b2e1a2384 = "chakra-ui-color-mode";
function $87e9ffa45b14f6e0$export$cdf53b88b62eb393(key) {
    return {
        ssr: false,
        type: "localStorage",
        get (init) {
            if (!globalThis?.document) return init;
            let value;
            try {
                value = localStorage.getItem(key) || init;
            } catch (e) {}
            return value || init;
        },
        set (value) {
            try {
                localStorage.setItem(key, value);
            } catch (e) {}
        }
    };
}
const $87e9ffa45b14f6e0$export$8e35886de8a54f45 = $87e9ffa45b14f6e0$export$cdf53b88b62eb393($87e9ffa45b14f6e0$export$86880b4b2e1a2384);
function $87e9ffa45b14f6e0$var$parseCookie(cookie, key) {
    const match = cookie.match(new RegExp(`(^| )${key}=([^;]+)`));
    return match?.[2];
}
function $87e9ffa45b14f6e0$export$df28b7d6efe2673c(key, cookie) {
    return {
        ssr: !!cookie,
        type: "cookie",
        get (init) {
            if (cookie) return $87e9ffa45b14f6e0$var$parseCookie(cookie, key);
            if (!globalThis?.document) return init;
            return $87e9ffa45b14f6e0$var$parseCookie(document.cookie, key) || init;
        },
        set (value) {
            document.cookie = `${key}=${value}; max-age=31536000; path=/`;
        }
    };
}
const $87e9ffa45b14f6e0$export$2e2b0158437077e3 = $87e9ffa45b14f6e0$export$df28b7d6efe2673c($87e9ffa45b14f6e0$export$86880b4b2e1a2384);
const $87e9ffa45b14f6e0$export$d76e8eed3e914fa0 = (cookie)=>$87e9ffa45b14f6e0$export$df28b7d6efe2673c($87e9ffa45b14f6e0$export$86880b4b2e1a2384, cookie);


"use client";
const $a2bff2db1109dc20$var$noop = ()=>{};
const $a2bff2db1109dc20$var$useSafeLayoutEffect = (0, $ede4194696cbd159$export$4e09c449d6c407f7)() ? (0, $8v0nu.useLayoutEffect) : (0, $8v0nu.useEffect);
function $a2bff2db1109dc20$var$getTheme(manager, fallback) {
    return manager.type === "cookie" && manager.ssr ? manager.get(fallback) : fallback;
}
const $a2bff2db1109dc20$export$7a858aa3ff83dde7 = (0, $FTTp4.w)(function ColorModeProvider2(props, cache) {
    const { value: value, children: children, options: { useSystemColorMode: useSystemColorMode, initialColorMode: initialColorMode, disableTransitionOnChange: disableTransitionOnChange } = {}, colorModeManager: colorModeManager = (0, $87e9ffa45b14f6e0$export$8e35886de8a54f45) } = props;
    const defaultColorMode = initialColorMode === "dark" ? "dark" : "light";
    const [colorMode, rawSetColorMode] = (0, $8v0nu.useState)(()=>$a2bff2db1109dc20$var$getTheme(colorModeManager, defaultColorMode));
    const [resolvedColorMode, setResolvedColorMode] = (0, $8v0nu.useState)(()=>$a2bff2db1109dc20$var$getTheme(colorModeManager));
    const { getSystemTheme: getSystemTheme, setClassName: setClassName, setDataset: setDataset, addListener: addListener } = (0, $8v0nu.useMemo)(()=>(0, $ff48eea4c6649c63$export$4bb933d353baa01c)({
            preventTransition: disableTransitionOnChange,
            nonce: cache?.nonce
        }), [
        disableTransitionOnChange,
        cache?.nonce
    ]);
    const resolvedValue = initialColorMode === "system" && !colorMode ? resolvedColorMode : colorMode;
    const setColorMode = (0, $8v0nu.useCallback)((value2)=>{
        const resolved = value2 === "system" ? getSystemTheme() : value2;
        rawSetColorMode(resolved);
        setClassName(resolved === "dark");
        setDataset(resolved);
        colorModeManager.set(resolved);
    }, [
        colorModeManager,
        getSystemTheme,
        setClassName,
        setDataset
    ]);
    $a2bff2db1109dc20$var$useSafeLayoutEffect(()=>{
        if (initialColorMode === "system") setResolvedColorMode(getSystemTheme());
    }, []);
    (0, $8v0nu.useEffect)(()=>{
        const managerValue = colorModeManager.get();
        if (managerValue) {
            setColorMode(managerValue);
            return;
        }
        if (initialColorMode === "system") {
            setColorMode("system");
            return;
        }
        setColorMode(defaultColorMode);
    }, [
        colorModeManager,
        defaultColorMode,
        initialColorMode,
        setColorMode
    ]);
    const toggleColorMode = (0, $8v0nu.useCallback)(()=>{
        setColorMode(resolvedValue === "dark" ? "light" : "dark");
    }, [
        resolvedValue,
        setColorMode
    ]);
    (0, $8v0nu.useEffect)(()=>{
        if (!useSystemColorMode) return;
        return addListener(setColorMode);
    }, [
        useSystemColorMode,
        addListener,
        setColorMode
    ]);
    const context = (0, $8v0nu.useMemo)(()=>({
            colorMode: value ?? resolvedValue,
            toggleColorMode: value ? $a2bff2db1109dc20$var$noop : toggleColorMode,
            setColorMode: value ? $a2bff2db1109dc20$var$noop : setColorMode,
            forced: value !== void 0
        }), [
        resolvedValue,
        toggleColorMode,
        setColorMode,
        value
    ]);
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $6jXOD.ColorModeContext).Provider, {
        value: context,
        children: children
    });
});
$a2bff2db1109dc20$export$7a858aa3ff83dde7.displayName = "ColorModeProvider";
function $a2bff2db1109dc20$export$8b41b18ed1f3731e(props) {
    const context = (0, $8v0nu.useMemo)(()=>({
            colorMode: "dark",
            toggleColorMode: $a2bff2db1109dc20$var$noop,
            setColorMode: $a2bff2db1109dc20$var$noop,
            forced: true
        }), []);
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $6jXOD.ColorModeContext).Provider, {
        value: context,
        ...props
    });
}
$a2bff2db1109dc20$export$8b41b18ed1f3731e.displayName = "DarkMode";
function $a2bff2db1109dc20$export$cee2b1aa9166b2a3(props) {
    const context = (0, $8v0nu.useMemo)(()=>({
            colorMode: "light",
            toggleColorMode: $a2bff2db1109dc20$var$noop,
            setColorMode: $a2bff2db1109dc20$var$noop,
            forced: true
        }), []);
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $6jXOD.ColorModeContext).Provider, {
        value: context,
        ...props
    });
}
$a2bff2db1109dc20$export$cee2b1aa9166b2a3.displayName = "LightMode";



var $kxTYF = parcelRequire("kxTYF");

var $6iKRa = parcelRequire("6iKRa");
"use client";
const $0607300448d66c30$var$css = String.raw;
const $0607300448d66c30$var$vhPolyfill = $0607300448d66c30$var$css`
  :root,
  :host {
    --chakra-vh: 100vh;
  }

  @supports (height: -webkit-fill-available) {
    :root,
    :host {
      --chakra-vh: -webkit-fill-available;
    }
  }

  @supports (height: -moz-fill-available) {
    :root,
    :host {
      --chakra-vh: -moz-fill-available;
    }
  }

  @supports (height: 100dvh) {
    :root,
    :host {
      --chakra-vh: 100dvh;
    }
  }
`;
const $0607300448d66c30$export$43a6590e493ec44a = ()=>/* @__PURE__ */ (0, $kxTYF.jsx)((0, $6iKRa.Global), {
        styles: $0607300448d66c30$var$vhPolyfill
    });
const $0607300448d66c30$export$b751feffed387621 = ({ scope: scope = "" })=>/* @__PURE__ */ (0, $kxTYF.jsx)((0, $6iKRa.Global), {
        styles: $0607300448d66c30$var$css`
      html {
        line-height: 1.5;
        -webkit-text-size-adjust: 100%;
        font-family: system-ui, sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        touch-action: manipulation;
      }

      body {
        position: relative;
        min-height: 100%;
        margin: 0;
        font-feature-settings: "kern";
      }

      ${scope} :where(*, *::before, *::after) {
        border-width: 0;
        border-style: solid;
        box-sizing: border-box;
        word-wrap: break-word;
      }

      main {
        display: block;
      }

      ${scope} hr {
        border-top-width: 1px;
        box-sizing: content-box;
        height: 0;
        overflow: visible;
      }

      ${scope} :where(pre, code, kbd,samp) {
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        font-size: 1em;
      }

      ${scope} a {
        background-color: transparent;
        color: inherit;
        text-decoration: inherit;
      }

      ${scope} abbr[title] {
        border-bottom: none;
        text-decoration: underline;
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
      }

      ${scope} :where(b, strong) {
        font-weight: bold;
      }

      ${scope} small {
        font-size: 80%;
      }

      ${scope} :where(sub,sup) {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
      }

      ${scope} sub {
        bottom: -0.25em;
      }

      ${scope} sup {
        top: -0.5em;
      }

      ${scope} img {
        border-style: none;
      }

      ${scope} :where(button, input, optgroup, select, textarea) {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0;
      }

      ${scope} :where(button, input) {
        overflow: visible;
      }

      ${scope} :where(button, select) {
        text-transform: none;
      }

      ${scope} :where(
          button::-moz-focus-inner,
          [type="button"]::-moz-focus-inner,
          [type="reset"]::-moz-focus-inner,
          [type="submit"]::-moz-focus-inner
        ) {
        border-style: none;
        padding: 0;
      }

      ${scope} fieldset {
        padding: 0.35em 0.75em 0.625em;
      }

      ${scope} legend {
        box-sizing: border-box;
        color: inherit;
        display: table;
        max-width: 100%;
        padding: 0;
        white-space: normal;
      }

      ${scope} progress {
        vertical-align: baseline;
      }

      ${scope} textarea {
        overflow: auto;
      }

      ${scope} :where([type="checkbox"], [type="radio"]) {
        box-sizing: border-box;
        padding: 0;
      }

      ${scope} input[type="number"]::-webkit-inner-spin-button,
      ${scope} input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
      }

      ${scope} input[type="number"] {
        -moz-appearance: textfield;
      }

      ${scope} input[type="search"] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
      }

      ${scope} input[type="search"]::-webkit-search-decoration {
        -webkit-appearance: none !important;
      }

      ${scope} ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit;
      }

      ${scope} details {
        display: block;
      }

      ${scope} summary {
        display: list-item;
      }

      template {
        display: none;
      }

      [hidden] {
        display: none !important;
      }

      ${scope} :where(
          blockquote,
          dl,
          dd,
          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          hr,
          figure,
          p,
          pre
        ) {
        margin: 0;
      }

      ${scope} button {
        background: transparent;
        padding: 0;
      }

      ${scope} fieldset {
        margin: 0;
        padding: 0;
      }

      ${scope} :where(ol, ul) {
        margin: 0;
        padding: 0;
      }

      ${scope} textarea {
        resize: vertical;
      }

      ${scope} :where(button, [role="button"]) {
        cursor: pointer;
      }

      ${scope} button::-moz-focus-inner {
        border: 0 !important;
      }

      ${scope} table {
        border-collapse: collapse;
      }

      ${scope} :where(h1, h2, h3, h4, h5, h6) {
        font-size: inherit;
        font-weight: inherit;
      }

      ${scope} :where(button, input, optgroup, select, textarea) {
        padding: 0;
        line-height: inherit;
        color: inherit;
      }

      ${scope} :where(img, svg, video, canvas, audio, iframe, embed, object) {
        display: block;
      }

      ${scope} :where(img, video) {
        max-width: 100%;
        height: auto;
      }

      [data-js-focus-visible]
        :focus:not([data-focus-visible-added]):not(
          [data-focus-visible-disabled]
        ) {
        outline: none;
        box-shadow: none;
      }

      ${scope} select::-ms-expand {
        display: none;
      }

      ${$0607300448d66c30$var$vhPolyfill}
    `
    });



var $kxTYF = parcelRequire("kxTYF");

var $h7TjY = parcelRequire("h7TjY");
var $fZQg5 = parcelRequire("fZQg5");
function $a884227448deaae2$var$getLastItem(array) {
    const length = array == null ? 0 : array.length;
    return length ? array[length - 1] : void 0;
}
function $a884227448deaae2$var$analyzeCSSValue(value) {
    const num = parseFloat(value.toString());
    const unit = value.toString().replace(String(num), "");
    return {
        unitless: !unit,
        value: num,
        unit: unit
    };
}
function $a884227448deaae2$export$91c0eda1d06bf008(value) {
    if (value == null) return value;
    const { unitless: unitless } = $a884227448deaae2$var$analyzeCSSValue(value);
    return unitless || typeof value === "number" ? `${value}px` : value;
}
const $a884227448deaae2$var$sortByBreakpointValue = (a, b)=>parseInt(a[1], 10) > parseInt(b[1], 10) ? 1 : -1;
const $a884227448deaae2$var$sortBps = (breakpoints)=>Object.fromEntries(Object.entries(breakpoints).sort($a884227448deaae2$var$sortByBreakpointValue));
function $a884227448deaae2$var$normalize(breakpoints) {
    const sorted = $a884227448deaae2$var$sortBps(breakpoints);
    return Object.assign(Object.values(sorted), sorted);
}
function $a884227448deaae2$var$keys(breakpoints) {
    const value = Object.keys($a884227448deaae2$var$sortBps(breakpoints));
    return new Set(value);
}
function $a884227448deaae2$var$subtract(value) {
    if (!value) return value;
    value = $a884227448deaae2$export$91c0eda1d06bf008(value) ?? value;
    const OFFSET = -0.02;
    return typeof value === "number" ? `${value + OFFSET}` : value.replace(/(\d+\.?\d*)/u, (m)=>`${parseFloat(m) + OFFSET}`);
}
function $a884227448deaae2$export$81f279c16481b446(min, max) {
    const query = [
        "@media screen"
    ];
    if (min) query.push("and", `(min-width: ${$a884227448deaae2$export$91c0eda1d06bf008(min)})`);
    if (max) query.push("and", `(max-width: ${$a884227448deaae2$export$91c0eda1d06bf008(max)})`);
    return query.join(" ");
}
function $a884227448deaae2$export$9aa97eb2b674b920(breakpoints) {
    if (!breakpoints) return null;
    breakpoints.base = breakpoints.base ?? "0px";
    const normalized = $a884227448deaae2$var$normalize(breakpoints);
    const queries = Object.entries(breakpoints).sort($a884227448deaae2$var$sortByBreakpointValue).map(([breakpoint, minW], index, entry)=>{
        let [, maxW] = entry[index + 1] ?? [];
        maxW = parseFloat(maxW) > 0 ? $a884227448deaae2$var$subtract(maxW) : void 0;
        return {
            _minW: $a884227448deaae2$var$subtract(minW),
            breakpoint: breakpoint,
            minW: minW,
            maxW: maxW,
            maxWQuery: $a884227448deaae2$export$81f279c16481b446(null, maxW),
            minWQuery: $a884227448deaae2$export$81f279c16481b446(minW),
            minMaxQuery: $a884227448deaae2$export$81f279c16481b446(minW, maxW)
        };
    });
    const _keys = $a884227448deaae2$var$keys(breakpoints);
    const _keysArr = Array.from(_keys.values());
    return {
        keys: _keys,
        normalized: normalized,
        isResponsive (test) {
            const keys2 = Object.keys(test);
            return keys2.length > 0 && keys2.every((key)=>_keys.has(key));
        },
        asObject: $a884227448deaae2$var$sortBps(breakpoints),
        asArray: $a884227448deaae2$var$normalize(breakpoints),
        details: queries,
        get (key) {
            return queries.find((q)=>q.breakpoint === key);
        },
        media: [
            null,
            ...normalized.map((minW)=>$a884227448deaae2$export$81f279c16481b446(minW)).slice(1)
        ],
        /**
     * Converts the object responsive syntax to array syntax
     *
     * @example
     * toArrayValue({ base: 1, sm: 2, md: 3 }) // => [1, 2, 3]
     */ toArrayValue (test) {
            if (!(0, $fZQg5.isObject)(test)) throw new Error("toArrayValue: value must be an object");
            const result = _keysArr.map((bp)=>test[bp] ?? null);
            while($a884227448deaae2$var$getLastItem(result) === null)result.pop();
            return result;
        },
        /**
     * Converts the array responsive syntax to object syntax
     *
     * @example
     * toObjectValue([1, 2, 3]) // => { base: 1, sm: 2, md: 3 }
     */ toObjectValue (test) {
            if (!Array.isArray(test)) throw new Error("toObjectValue: value must be an array");
            return test.reduce((acc, value, index)=>{
                const key = _keysArr[index];
                if (key != null && value != null) acc[key] = value;
                return acc;
            }, {});
        }
    };
}



var $fZQg5 = parcelRequire("fZQg5");
var $v03Ub = parcelRequire("v03Ub");

var $lOd5f = parcelRequire("lOd5f");



var $fZQg5 = parcelRequire("fZQg5");
function $72c1fbcb4960900f$export$915658b6215945a4(target, predicate, options = {}) {
    const { stop: stop, getKey: getKey } = options;
    function inner(value, path = []) {
        if ((0, $fZQg5.isObject)(value) || Array.isArray(value)) {
            const result = {};
            for (const [prop, child] of Object.entries(value)){
                const key = getKey?.(prop) ?? prop;
                const childPath = [
                    ...path,
                    key
                ];
                if (stop?.(value, childPath)) return predicate(value, path);
                result[key] = inner(child, childPath);
            }
            return result;
        }
        return predicate(value, path);
    }
    return inner(target);
}



var $lOd5f = parcelRequire("lOd5f");
function $a78d5708c8345732$export$357523c63a2253b9(object, keysToPick) {
    const result = {};
    for (const key of keysToPick)if (key in object) result[key] = object[key];
    return result;
}


const $95d4d738ba68e94f$var$tokens = [
    "colors",
    "borders",
    "borderWidths",
    "borderStyles",
    "fonts",
    "fontSizes",
    "fontWeights",
    "gradients",
    "letterSpacings",
    "lineHeights",
    "radii",
    "space",
    "shadows",
    "sizes",
    "zIndices",
    "transition",
    "blur",
    "breakpoints"
];
function $95d4d738ba68e94f$export$10e0af2de97b9ee7(theme) {
    const _tokens = $95d4d738ba68e94f$var$tokens;
    return (0, $a78d5708c8345732$export$357523c63a2253b9)(theme, _tokens);
}
function $95d4d738ba68e94f$export$39f91607195ce67d(theme) {
    return theme.semanticTokens;
}
function $95d4d738ba68e94f$export$290969626bfda4a4(rawTheme) {
    const { __cssMap: __cssMap, __cssVars: __cssVars, __breakpoints: __breakpoints, ...cleanTheme } = rawTheme;
    return cleanTheme;
}


function $ac9da5f0cb9b5ec7$export$8f520cff3dbc4769(theme) {
    const tokens = (0, $95d4d738ba68e94f$export$10e0af2de97b9ee7)(theme);
    const semanticTokens = (0, $95d4d738ba68e94f$export$39f91607195ce67d)(theme);
    const pseudoPropNames = (0, $lOd5f.getPseudoPropNames)(theme);
    const isSemanticCondition = (key)=>pseudoPropNames.includes(key) || "default" === key;
    const result = {};
    (0, $72c1fbcb4960900f$export$915658b6215945a4)(tokens, (value, path)=>{
        if (value == null) return;
        result[path.join(".")] = {
            isSemantic: false,
            value: value
        };
    });
    (0, $72c1fbcb4960900f$export$915658b6215945a4)(semanticTokens, (value, path)=>{
        if (value == null) return;
        result[path.join(".")] = {
            isSemantic: true,
            value: value
        };
    }, {
        stop: (value)=>Object.keys(value).every(isSemanticCondition)
    });
    return result;
}


function $973cdf17eb8b69a2$var$tokenToCssVar(token, prefix) {
    return (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)(String(token).replace(/\./g, "-"), void 0, prefix);
}
function $973cdf17eb8b69a2$export$69e96ceeb663bb9(theme) {
    const flatTokens = (0, $ac9da5f0cb9b5ec7$export$8f520cff3dbc4769)(theme);
    const cssVarPrefix = theme.config?.cssVarPrefix;
    const pseudoSelectors = (0, $lOd5f.getPseudoSelectors)(theme);
    let cssVars = {};
    const cssMap = {};
    function lookupToken(token, maybeToken) {
        const scale = String(token).split(".")[0];
        const withScale = [
            scale,
            maybeToken
        ].join(".");
        const resolvedTokenValue = flatTokens[withScale];
        if (!resolvedTokenValue) return maybeToken;
        const { reference: reference } = $973cdf17eb8b69a2$var$tokenToCssVar(withScale, cssVarPrefix);
        return reference;
    }
    for (const [token, tokenValue] of Object.entries(flatTokens)){
        const { isSemantic: isSemantic, value: value } = tokenValue;
        const { variable: variable, reference: reference } = $973cdf17eb8b69a2$var$tokenToCssVar(token, cssVarPrefix);
        if (!isSemantic) {
            if (token.startsWith("space")) {
                const keys = token.split(".");
                const [firstKey, ...referenceKeys] = keys;
                const negativeLookupKey = `${firstKey}.-${referenceKeys.join(".")}`;
                const negativeValue = (0, $8f1cebefed6fc84f$export$42bfa9b2d4dad91a).negate(value);
                const negatedReference = (0, $8f1cebefed6fc84f$export$42bfa9b2d4dad91a).negate(reference);
                cssMap[negativeLookupKey] = {
                    value: negativeValue,
                    var: variable,
                    varRef: negatedReference
                };
            }
            cssVars[variable] = value;
            cssMap[token] = {
                value: value,
                var: variable,
                varRef: reference
            };
            continue;
        }
        const normalizedValue = (0, $fZQg5.isObject)(value) ? value : {
            default: value
        };
        cssVars = (0, (/*@__PURE__*/$parcel$interopDefault($v03Ub)))(cssVars, Object.entries(normalizedValue).reduce((acc, [conditionAlias, conditionValue])=>{
            if (!conditionValue) return acc;
            const tokenReference = lookupToken(token, `${conditionValue}`);
            if (conditionAlias === "default") {
                acc[variable] = tokenReference;
                return acc;
            }
            const conditionSelector = pseudoSelectors?.[conditionAlias] ?? conditionAlias;
            acc[conditionSelector] = {
                [variable]: tokenReference
            };
            return acc;
        }, {}));
        cssMap[token] = {
            value: reference,
            var: variable,
            varRef: reference
        };
    }
    return {
        cssVars: cssVars,
        cssMap: cssMap
    };
}




var $lA3d6 = parcelRequire("lA3d6");
function $725c2c1febf767aa$export$d4e5dc2a444c0164(rawTheme) {
    const theme = (0, $95d4d738ba68e94f$export$290969626bfda4a4)(rawTheme);
    const { cssMap: /**
     * This is more like a dictionary of tokens users will type `green.500`,
     * and their equivalent css variable.
     */ cssMap, cssVars: /**
     * The extracted css variables will be stored here, and used in
     * the emotion's <Global/> component to attach variables to `:root`
     */ cssVars } = (0, $973cdf17eb8b69a2$export$69e96ceeb663bb9)(theme);
    const defaultCssVars = {
        "--chakra-ring-inset": "var(--chakra-empty,/*!*/ /*!*/)",
        "--chakra-ring-offset-width": "0px",
        "--chakra-ring-offset-color": "#fff",
        "--chakra-ring-color": "rgba(66, 153, 225, 0.6)",
        "--chakra-ring-offset-shadow": "0 0 #0000",
        "--chakra-ring-shadow": "0 0 #0000",
        "--chakra-space-x-reverse": "0",
        "--chakra-space-y-reverse": "0"
    };
    const isStyleProp = (0, $lA3d6.isStylePropFn)(theme);
    Object.assign(theme, {
        __cssVars: {
            ...defaultCssVars,
            ...cssVars
        },
        __cssMap: cssMap,
        __breakpoints: (0, $a884227448deaae2$export$9aa97eb2b674b920)(theme.breakpoints),
        __isStyleProp: isStyleProp
    });
    return theme;
}



var $8v0nu = parcelRequire("8v0nu");
function $3473b2b1e3b906ba$var$getErrorMessage(hook, provider) {
    return `${hook} returned \`undefined\`. Seems you forgot to wrap component within ${provider}`;
}
function $3473b2b1e3b906ba$export$fd42f52fd3ae1109(options = {}) {
    const { name: name, strict: strict = true, hookName: hookName = "useContext", providerName: providerName = "Provider", errorMessage: errorMessage, defaultValue: defaultValue } = options;
    const Context = (0, $8v0nu.createContext)(defaultValue);
    Context.displayName = name;
    function useContext$1() {
        const context = (0, $8v0nu.useContext)(Context);
        if (!context && strict) {
            const error = new Error(errorMessage ?? $3473b2b1e3b906ba$var$getErrorMessage(hookName, providerName));
            error.name = "ContextError";
            Error.captureStackTrace?.(error, useContext$1);
            throw error;
        }
        return context;
    }
    return [
        Context.Provider,
        useContext$1,
        Context
    ];
}

function $e9bac7ee162de0e5$export$3988ae62b71be9a3(obj, path, fallback, index) {
    const key = typeof path === "string" ? path.split(".") : [
        path
    ];
    for(index = 0; index < key.length; index += 1){
        if (!obj) break;
        obj = obj[key[index]];
    }
    return obj === void 0 ? fallback : obj;
}
const $e9bac7ee162de0e5$var$memoize = (fn)=>{
    const cache = /* @__PURE__ */ new WeakMap();
    const memoizedFn = (obj, path, fallback, index)=>{
        if (typeof obj === "undefined") return fn(obj, path, fallback);
        if (!cache.has(obj)) cache.set(obj, /* @__PURE__ */ new Map());
        const map = cache.get(obj);
        if (map.has(path)) return map.get(path);
        const value = fn(obj, path, fallback, index);
        map.set(path, value);
        return value;
    };
    return memoizedFn;
};
const $e9bac7ee162de0e5$export$1bb32d0c65da6059 = $e9bac7ee162de0e5$var$memoize($e9bac7ee162de0e5$export$3988ae62b71be9a3);


var $cSr1Y = parcelRequire("cSr1Y");

var $6iKRa = parcelRequire("6iKRa");
var $FTTp4 = parcelRequire("FTTp4");

var $8v0nu = parcelRequire("8v0nu");

var $6jXOD = parcelRequire("6jXOD");
"use client";
function $9e39c58cc161b735$export$d8964aec282183a3(props) {
    const { cssVarsRoot: cssVarsRoot, theme: theme, children: children } = props;
    const computedTheme = (0, $8v0nu.useMemo)(()=>(0, $725c2c1febf767aa$export$d4e5dc2a444c0164)(theme), [
        theme
    ]);
    return /* @__PURE__ */ (0, $kxTYF.jsxs)((0, $FTTp4.a), {
        theme: computedTheme,
        children: [
            /* @__PURE__ */ (0, $kxTYF.jsx)($9e39c58cc161b735$export$d767872124667db6, {
                root: cssVarsRoot
            }),
            children
        ]
    });
}
function $9e39c58cc161b735$export$d767872124667db6({ root: root = ":host, :root" }) {
    const selector = [
        root,
        `[data-theme]`
    ].join(",");
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $6iKRa.Global), {
        styles: (theme)=>({
                [selector]: theme.__cssVars
            })
    });
}
const [$9e39c58cc161b735$export$dc4c659861f00dbe, $9e39c58cc161b735$export$28e6b9b82ee883c] = (0, $3473b2b1e3b906ba$export$fd42f52fd3ae1109)({
    name: "StylesContext",
    errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
});
function $9e39c58cc161b735$export$11d9f9905bcdc114(componentName) {
    return (0, $3473b2b1e3b906ba$export$fd42f52fd3ae1109)({
        name: `${componentName}StylesContext`,
        errorMessage: `useStyles: "styles" is undefined. Seems you forgot to wrap the components in "<${componentName} />" `
    });
}
function $9e39c58cc161b735$export$f05794e648629f6c() {
    const { colorMode: colorMode } = (0, $6jXOD.useColorMode)();
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $6iKRa.Global), {
        styles: (theme)=>{
            const styleObjectOrFn = (0, $e9bac7ee162de0e5$export$1bb32d0c65da6059)(theme, "styles.global");
            const globalStyles = (0, $cSr1Y.runIfFn)(styleObjectOrFn, {
                theme: theme,
                colorMode: colorMode
            });
            if (!globalStyles) return void 0;
            const styles = (0, $h7TjY.css)(globalStyles)(theme);
            return styles;
        }
    });
}



var $kxTYF = parcelRequire("kxTYF");

"use client";
const [$94c10bfe68b0b4de$var$PortalManagerContextProvider, $94c10bfe68b0b4de$export$ef203b29c2cc1f5d] = (0, $3473b2b1e3b906ba$export$fd42f52fd3ae1109)({
    strict: false,
    name: "PortalManagerContext"
});
function $94c10bfe68b0b4de$export$52c7ef79917c2f38(props) {
    const { children: children, zIndex: zIndex } = props;
    return /* @__PURE__ */ (0, $kxTYF.jsx)($94c10bfe68b0b4de$var$PortalManagerContextProvider, {
        value: {
            zIndex: zIndex
        },
        children: children
    });
}
$94c10bfe68b0b4de$export$52c7ef79917c2f38.displayName = "PortalManager";



var $kxTYF = parcelRequire("kxTYF");

var $8v0nu = parcelRequire("8v0nu");
"use client";
const $456f92579f2f647e$export$deebe11a338de063 = Boolean(globalThis?.document) ? (0, $8v0nu.useLayoutEffect) : (0, $8v0nu.useEffect);



var $8v0nu = parcelRequire("8v0nu");
"use client";
const $859eaf816c30ec7c$var$EnvironmentContext = (0, $8v0nu.createContext)({
    getDocument () {
        return document;
    },
    getWindow () {
        return window;
    }
});
$859eaf816c30ec7c$var$EnvironmentContext.displayName = "EnvironmentContext";
function $859eaf816c30ec7c$export$ea7ed2425832167d({ defer: defer } = {}) {
    const [, forceUpdate] = (0, $8v0nu.useReducer)((c)=>c + 1, 0);
    (0, $456f92579f2f647e$export$deebe11a338de063)(()=>{
        if (!defer) return;
        forceUpdate();
    }, [
        defer
    ]);
    return (0, $8v0nu.useContext)($859eaf816c30ec7c$var$EnvironmentContext);
}
function $859eaf816c30ec7c$export$29a4c0b32fc9db42(props) {
    const { children: children, environment: environmentProp, disabled: disabled } = props;
    const ref = (0, $8v0nu.useRef)(null);
    const context = (0, $8v0nu.useMemo)(()=>{
        if (environmentProp) return environmentProp;
        return {
            getDocument: ()=>ref.current?.ownerDocument ?? document,
            getWindow: ()=>ref.current?.ownerDocument.defaultView ?? window
        };
    }, [
        environmentProp
    ]);
    const showSpan = !disabled || !environmentProp;
    return /* @__PURE__ */ (0, $kxTYF.jsxs)($859eaf816c30ec7c$var$EnvironmentContext.Provider, {
        value: context,
        children: [
            children,
            showSpan && /* @__PURE__ */ (0, $kxTYF.jsx)("span", {
                id: "__chakra_env",
                hidden: true,
                ref: ref
            })
        ]
    });
}
$859eaf816c30ec7c$export$29a4c0b32fc9db42.displayName = "EnvironmentProvider";


"use client";
const $d6e500ffd5d1beeb$export$2881499e37b75b9a = (props)=>{
    const { children: children, colorModeManager: colorModeManager, portalZIndex: portalZIndex, resetScope: resetScope, resetCSS: resetCSS = true, theme: theme = {}, environment: environment, cssVarsRoot: cssVarsRoot, disableEnvironment: disableEnvironment, disableGlobalStyle: disableGlobalStyle } = props;
    const _children = /* @__PURE__ */ (0, $kxTYF.jsx)((0, $859eaf816c30ec7c$export$29a4c0b32fc9db42), {
        environment: environment,
        disabled: disableEnvironment,
        children: children
    });
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $9e39c58cc161b735$export$d8964aec282183a3), {
        theme: theme,
        cssVarsRoot: cssVarsRoot,
        children: /* @__PURE__ */ (0, $kxTYF.jsxs)((0, $a2bff2db1109dc20$export$7a858aa3ff83dde7), {
            colorModeManager: colorModeManager,
            options: theme.config,
            children: [
                resetCSS ? /* @__PURE__ */ (0, $kxTYF.jsx)((0, $0607300448d66c30$export$b751feffed387621), {
                    scope: resetScope
                }) : /* @__PURE__ */ (0, $kxTYF.jsx)((0, $0607300448d66c30$export$43a6590e493ec44a), {}),
                !disableGlobalStyle && /* @__PURE__ */ (0, $kxTYF.jsx)((0, $9e39c58cc161b735$export$f05794e648629f6c), {}),
                portalZIndex ? /* @__PURE__ */ (0, $kxTYF.jsx)((0, $94c10bfe68b0b4de$export$52c7ef79917c2f38), {
                    zIndex: portalZIndex,
                    children: _children
                }) : _children
            ]
        })
    });
};



var $kxTYF = parcelRequire("kxTYF");


var $8v0nu = parcelRequire("8v0nu");

var $8v0nu = parcelRequire("8v0nu");

var $8v0nu = parcelRequire("8v0nu");

var $8v0nu = parcelRequire("8v0nu");
const $e1934d508facd30d$export$4e09c449d6c407f7 = typeof document !== "undefined";


const $0e2bf99806b8255e$export$700979bc83e7db82 = (0, $e1934d508facd30d$export$4e09c449d6c407f7) ? (0, $8v0nu.useLayoutEffect) : (0, $8v0nu.useEffect);


function $ee7971d46e71cb08$export$80c2a3957bcb42ea() {
    const isMounted = (0, $8v0nu.useRef)(false);
    (0, $0e2bf99806b8255e$export$700979bc83e7db82)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}


const $8e8d79bd50b58ce2$export$8793edee2d425525 = (any)=>any;


class $78f612790abb38e1$var$Queue {
    constructor(){
        this.order = [];
        this.scheduled = new Set();
    }
    add(process) {
        if (!this.scheduled.has(process)) {
            this.scheduled.add(process);
            this.order.push(process);
            return true;
        }
    }
    remove(process) {
        const index = this.order.indexOf(process);
        if (index !== -1) {
            this.order.splice(index, 1);
            this.scheduled.delete(process);
        }
    }
    clear() {
        this.order.length = 0;
        this.scheduled.clear();
    }
}
function $78f612790abb38e1$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new $78f612790abb38e1$var$Queue();
    let nextFrame = new $78f612790abb38e1$var$Queue();
    let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (queue.add(callback) && addToCurrentFrame && isProcessing) // If we're adding it to the currently running queue, update its measured size
            numToRun = thisFrame.order.length;
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.remove(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            numToRun = thisFrame.order.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = thisFrame.order[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $b6e6a552d61b8bd3$export$71ecace0a033b35a = [
    "prepare",
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $b6e6a552d61b8bd3$var$maxElapsed = 40;
function $b6e6a552d61b8bd3$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0,
        timestamp: 0,
        isProcessing: false
    };
    const steps = $b6e6a552d61b8bd3$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $78f612790abb38e1$export$b995e5e85f5c8289)(()=>runNextFrame = true);
        return acc;
    }, {});
    const processStep = (stepId)=>steps[stepId].process(state);
    const processBatch = ()=>{
        const timestamp = performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $b6e6a552d61b8bd3$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        $b6e6a552d61b8bd3$export$71ecace0a033b35a.forEach(processStep);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $b6e6a552d61b8bd3$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>$b6e6a552d61b8bd3$export$71ecace0a033b35a.forEach((key)=>steps[key].cancel(process));
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $5368c6a94979c99d$export$2cef06c20297c17d, cancel: $5368c6a94979c99d$export$ec99c0ef4978dccb, state: $5368c6a94979c99d$export$fff89137e9e818ce, steps: $5368c6a94979c99d$export$be3f796aed065412 } = (0, $b6e6a552d61b8bd3$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $8e8d79bd50b58ce2$export$8793edee2d425525), true);


function $3ebf9ac8f50fbc11$export$91db9bc4f8ac944a() {
    const isMounted = (0, $ee7971d46e71cb08$export$80c2a3957bcb42ea)();
    const [forcedRenderCount, setForcedRenderCount] = (0, $8v0nu.useState)(0);
    const forceRender = (0, $8v0nu.useCallback)(()=>{
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ const deferredForceRender = (0, $8v0nu.useCallback)(()=>(0, $5368c6a94979c99d$export$2cef06c20297c17d).postRender(forceRender), [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}




var $8v0nu = parcelRequire("8v0nu");

var $8v0nu = parcelRequire("8v0nu");
/**
 * @public
 */ const $af42344d352b5efc$export$f224e4635b6f8ce2 = (0, $8v0nu.createContext)(null);



var $8v0nu = parcelRequire("8v0nu");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $01b8aedaf4ac1f4d$export$fe4300aa8eebea86(init) {
    const ref = (0, $8v0nu.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}



var $8v0nu = parcelRequire("8v0nu");
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $dad16b534d3de887$var$PopChildMeasure extends $8v0nu.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $dad16b534d3de887$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $8v0nu.useId)();
    const ref = (0, $8v0nu.useRef)(null);
    const size = (0, $8v0nu.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $8v0nu.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return $8v0nu.createElement($dad16b534d3de887$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size
    }, $8v0nu.cloneElement(children, {
        ref: ref
    }));
}


const $b408ae5bb45d75d9$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $01b8aedaf4ac1f4d$export$fe4300aa8eebea86)($b408ae5bb45d75d9$var$newChildrenMap);
    const id = (0, $8v0nu.useId)();
    const context = (0, $8v0nu.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? undefined : [
        isPresent
    ]);
    (0, $8v0nu.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $8v0nu.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = $8v0nu.createElement((0, $dad16b534d3de887$export$1d6cdde0c6816c6d), {
        isPresent: isPresent
    }, children);
    return $8v0nu.createElement((0, $af42344d352b5efc$export$f224e4635b6f8ce2).Provider, {
        value: context
    }, children);
};
function $b408ae5bb45d75d9$var$newChildrenMap() {
    return new Map();
}



var $8v0nu = parcelRequire("8v0nu");
const $f8fa84f618a4fe1a$export$a3579ca508007a95 = (0, $8v0nu.createContext)({});




var $8v0nu = parcelRequire("8v0nu");
function $2fb3c7a06bdc1277$export$f3a192d0cbd30b96(callback) {
    return (0, $8v0nu.useEffect)(()=>()=>callback(), []);
}



let $3b78c10950e93e60$export$491112666e282270 = (0, $8e8d79bd50b58ce2$export$8793edee2d425525);
let $3b78c10950e93e60$export$f5708dca728d7177 = (0, $8e8d79bd50b58ce2$export$8793edee2d425525);
var $3b78c10950e93e60$var$check, $3b78c10950e93e60$var$message, $3b78c10950e93e60$var$check1, $3b78c10950e93e60$var$message1;


const $f1f51be609a91d37$var$getChildKey = (child)=>child.key || "";
function $f1f51be609a91d37$var$updateChildLookup(children, allChildren) {
    children.forEach((child)=>{
        const key = $f1f51be609a91d37$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $f1f51be609a91d37$var$onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $8v0nu.Children).forEach(children, (child)=>{
        if ((0, $8v0nu.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $f1f51be609a91d37$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, exitBeforeEnter: exitBeforeEnter, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    (0, $3b78c10950e93e60$export$f5708dca728d7177)(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    const forceRender = (0, $8v0nu.useContext)((0, $f8fa84f618a4fe1a$export$a3579ca508007a95)).forceRender || (0, $3ebf9ac8f50fbc11$export$91db9bc4f8ac944a)()[0];
    const isMounted = (0, $ee7971d46e71cb08$export$80c2a3957bcb42ea)();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    const filteredChildren = $f1f51be609a91d37$var$onlyElements(children);
    let childrenToRender = filteredChildren;
    const exitingChildren = (0, $8v0nu.useRef)(new Map()).current;
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    const presentChildren = (0, $8v0nu.useRef)(childrenToRender);
    // A lookup table to quickly reference components by key
    const allChildren = (0, $8v0nu.useRef)(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    const isInitialRender = (0, $8v0nu.useRef)(true);
    (0, $0e2bf99806b8255e$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        $f1f51be609a91d37$var$updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    (0, $2fb3c7a06bdc1277$export$f3a192d0cbd30b96)(()=>{
        isInitialRender.current = true;
        allChildren.clear();
        exitingChildren.clear();
    });
    if (isInitialRender.current) return $8v0nu.createElement($8v0nu.Fragment, null, childrenToRender.map((child)=>$8v0nu.createElement((0, $b408ae5bb45d75d9$export$979daf65881a382a), {
            key: $f1f51be609a91d37$var$getChildKey(child),
            isPresent: true,
            initial: initial ? undefined : false,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child)));
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = [
        ...childrenToRender
    ];
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    const presentKeys = presentChildren.current.map($f1f51be609a91d37$var$getChildKey);
    const targetKeys = filteredChildren.map($f1f51be609a91d37$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    const numPresent = presentKeys.length;
    for(let i = 0; i < numPresent; i++){
        const key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1 && !exitingChildren.has(key)) exitingChildren.set(key, undefined);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (mode === "wait" && exitingChildren.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exitingChildren.forEach((component, key)=>{
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        const child = allChildren.get(key);
        if (!child) return;
        const insertionIndex = presentKeys.indexOf(key);
        let exitingComponent = component;
        if (!exitingComponent) {
            const onExit = ()=>{
                // clean up the exiting children map
                exitingChildren.delete(key);
                // compute the keys of children that were rendered once but are no longer present
                // this could happen in case of too many fast consequent renderings
                // @link https://github.com/framer/motion/issues/2023
                const leftOverKeys = Array.from(allChildren.keys()).filter((childKey)=>!targetKeys.includes(childKey));
                // clean up the all children map
                leftOverKeys.forEach((leftOverKey)=>allChildren.delete(leftOverKey));
                // make sure to render only the children that are actually visible
                presentChildren.current = filteredChildren.filter((presentChild)=>{
                    const presentChildKey = $f1f51be609a91d37$var$getChildKey(presentChild);
                    return(// filter out the node exiting
                    presentChildKey === key || // filter out the leftover children
                    leftOverKeys.includes(presentChildKey));
                });
                // Defer re-rendering until all exiting children have indeed left
                if (!exitingChildren.size) {
                    if (isMounted.current === false) return;
                    forceRender();
                    onExitComplete && onExitComplete();
                }
            };
            exitingComponent = $8v0nu.createElement((0, $b408ae5bb45d75d9$export$979daf65881a382a), {
                key: $f1f51be609a91d37$var$getChildKey(child),
                isPresent: false,
                onExitComplete: onExit,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode
            }, child);
            exitingChildren.set(key, exitingComponent);
        }
        childrenToRender.splice(insertionIndex, 0, exitingComponent);
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map((child)=>{
        const key = child.key;
        return exitingChildren.has(key) ? child : $8v0nu.createElement((0, $b408ae5bb45d75d9$export$979daf65881a382a), {
            key: $f1f51be609a91d37$var$getChildKey(child),
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child);
    });
    return $8v0nu.createElement($8v0nu.Fragment, null, exitingChildren.size ? childrenToRender : childrenToRender.map((child)=>(0, $8v0nu.cloneElement)(child)));
};



var $8v0nu = parcelRequire("8v0nu");

var $kxTYF = parcelRequire("kxTYF");

var $8v0nu = parcelRequire("8v0nu");

var $8v0nu = parcelRequire("8v0nu");
"use client";
function $7bf98d1f0832a6d6$export$25bec8c6f54ee79a(callback, deps = []) {
    const callbackRef = (0, $8v0nu.useRef)(callback);
    (0, $8v0nu.useEffect)(()=>{
        callbackRef.current = callback;
    });
    return (0, $8v0nu.useCallback)((...args)=>callbackRef.current?.(...args), deps);
}


"use client";
function $eb487cc9f0b1eb88$export$d8e6abf214c9ec0f(callback, delay) {
    const fn = (0, $7bf98d1f0832a6d6$export$25bec8c6f54ee79a)(callback);
    (0, $8v0nu.useEffect)(()=>{
        if (delay == null) return void 0;
        let timeoutId = null;
        timeoutId = window.setTimeout(()=>{
            fn();
        }, delay);
        return ()=>{
            if (timeoutId) window.clearTimeout(timeoutId);
        };
    }, [
        delay,
        fn
    ]);
}


var $8v0nu = parcelRequire("8v0nu");
"use client";
const $9fe29ceca799989a$export$496315a1608d9602 = (effect, deps)=>{
    const renderCycleRef = (0, $8v0nu.useRef)(false);
    const effectCycleRef = (0, $8v0nu.useRef)(false);
    (0, $8v0nu.useEffect)(()=>{
        const isMounted = renderCycleRef.current;
        const shouldRun = isMounted && effectCycleRef.current;
        if (shouldRun) return effect();
        effectCycleRef.current = true;
    }, deps);
    (0, $8v0nu.useEffect)(()=>{
        renderCycleRef.current = true;
        return ()=>{
            renderCycleRef.current = false;
        };
    }, []);
};



var $cSr1Y = parcelRequire("cSr1Y");

var $8v0nu = parcelRequire("8v0nu");

var $8v0nu = parcelRequire("8v0nu");
/**
 * @public
 */ const $1dcdcab29f5a59b3$export$22a697fb29aac98d = (0, $8v0nu.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $8v0nu = parcelRequire("8v0nu");
const $bb7a60e717387246$export$2285bbca2c666415 = (0, $8v0nu.createContext)({});



var $8v0nu = parcelRequire("8v0nu");




var $8v0nu = parcelRequire("8v0nu");
const $16011037ea920e2b$export$40f10139ecf1f171 = (0, $8v0nu.createContext)({
    strict: false
});



/**
 * Convert camelCase to dash-case properties.
 */ const $dd392415fdd57598$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();


const $690af1df48563525$export$ed7b8fa9dbf0105d = "framerAppearId";
const $690af1df48563525$export$8592e1c077c890a6 = "data-" + (0, $dd392415fdd57598$export$9fd24a634729c672)($690af1df48563525$export$ed7b8fa9dbf0105d);


function $4b0ed2f25349061e$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    const { visualElement: parent } = (0, $8v0nu.useContext)((0, $bb7a60e717387246$export$2285bbca2c666415));
    const lazyContext = (0, $8v0nu.useContext)((0, $16011037ea920e2b$export$40f10139ecf1f171));
    const presenceContext = (0, $8v0nu.useContext)((0, $af42344d352b5efc$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $8v0nu.useContext)((0, $1dcdcab29f5a59b3$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $8v0nu.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    (0, $8v0nu.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const wantsHandoff = (0, $8v0nu.useRef)(Boolean(props[0, $690af1df48563525$export$8592e1c077c890a6] && !window.HandoffComplete));
    (0, $0e2bf99806b8255e$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        visualElement.render();
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $8v0nu.useEffect)(()=>{
        if (!visualElement) return;
        visualElement.updateFeatures();
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            wantsHandoff.current = false;
            // This ensures all future calls to animateChanges() will run in useEffect
            window.HandoffComplete = true;
        }
    });
    return visualElement;
}



var $8v0nu = parcelRequire("8v0nu");
function $cddfc7e2c37cb099$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}


/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $270aa8ab7f4fd0fc$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $8v0nu.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $cddfc7e2c37cb099$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $8v0nu = parcelRequire("8v0nu");

/**
 * Decides if the supplied variable is variant label
 */ function $b1763de14481003e$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $25a749b50b8e7ca5$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}



const $e95939688e97d48b$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $e95939688e97d48b$export$1405a65085f40b9 = [
    "initial",
    ...$e95939688e97d48b$export$16e45afcc206d3a8
];


function $d7ec71cb02690a35$export$4b3c3bd8d910d78d(props) {
    return (0, $25a749b50b8e7ca5$export$aa71198ceeaf53ce)(props.animate) || (0, $e95939688e97d48b$export$1405a65085f40b9).some((name)=>(0, $b1763de14481003e$export$720b90e312cea233)(props[name]));
}
function $d7ec71cb02690a35$export$ce46fa4165cdec40(props) {
    return Boolean($d7ec71cb02690a35$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $7481a28f44d5b4c1$export$12fc32fc096a04a3(props, context) {
    if ((0, $d7ec71cb02690a35$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $b1763de14481003e$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $b1763de14481003e$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $260e5925d2bbc616$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $7481a28f44d5b4c1$export$12fc32fc096a04a3)(props, (0, $8v0nu.useContext)((0, $bb7a60e717387246$export$2285bbca2c666415)));
    return (0, $8v0nu.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $260e5925d2bbc616$var$variantLabelsAsDependency(initial),
        $260e5925d2bbc616$var$variantLabelsAsDependency(animate)
    ]);
}
function $260e5925d2bbc616$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}


const $e6b85364d2a9bfe7$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $e6b85364d2a9bfe7$export$65570e08d843624d = {};
for(const key in $e6b85364d2a9bfe7$var$featureProps)$e6b85364d2a9bfe7$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$e6b85364d2a9bfe7$var$featureProps[key].some((name)=>!!props[name])
};


function $9b1c1ed11de10b20$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $e6b85364d2a9bfe7$export$65570e08d843624d)[key] = {
        ...(0, $e6b85364d2a9bfe7$export$65570e08d843624d)[key],
        ...features[key]
    };
}






var $8v0nu = parcelRequire("8v0nu");
/**
 * Internal, exported only for usage in Framer
 */ const $970c209bfbf3f8ee$export$da5f7b802957459a = (0, $8v0nu.createContext)({});


const $1dc9feb9cadcf21c$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");


/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $0bb08eeb023bf43d$export$46b7e4b9dc6110c3({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $9b1c1ed11de10b20$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $8v0nu.useContext)((0, $1dcdcab29f5a59b3$export$22a697fb29aac98d)),
            ...props,
            layoutId: $0bb08eeb023bf43d$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $260e5925d2bbc616$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $e1934d508facd30d$export$4e09c449d6c407f7)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $4b0ed2f25349061e$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */ const initialLayoutGroupConfig = (0, $8v0nu.useContext)((0, $970c209bfbf3f8ee$export$da5f7b802957459a));
            const isStrict = (0, $8v0nu.useContext)((0, $16011037ea920e2b$export$40f10139ecf1f171)).strict;
            if (context.visualElement) MeasureLayout = context.visualElement.loadFeatures(// Note: Pass the full new combined props to correctly re-render dynamic feature components.
            configAndProps, isStrict, preloadedFeatures, initialLayoutGroupConfig);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return $8v0nu.createElement((0, $bb7a60e717387246$export$2285bbca2c666415).Provider, {
            value: context
        }, MeasureLayout && context.visualElement ? $8v0nu.createElement(MeasureLayout, {
            visualElement: context.visualElement,
            ...configAndProps
        }) : null, useRender(Component, props, (0, $270aa8ab7f4fd0fc$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement));
    }
    const ForwardRefComponent = (0, $8v0nu.forwardRef)(MotionComponent);
    ForwardRefComponent[0, $1dc9feb9cadcf21c$export$28e2e4cce424ae23] = Component;
    return ForwardRefComponent;
}
function $0bb08eeb023bf43d$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $8v0nu.useContext)((0, $f8fa84f618a4fe1a$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}



/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $f04fd5bab6629190$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return (0, $0bb08eeb023bf43d$export$46b7e4b9dc6110c3)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}


/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $074c6b22688d52a7$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $8da896a5df5bb10c$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $074c6b22688d52a7$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}



var $8v0nu = parcelRequire("8v0nu");

var $8v0nu = parcelRequire("8v0nu");
const $04382bd4b1e45b5c$export$91ddd985b97788d1 = {};
function $04382bd4b1e45b5c$export$de9e7791c71225fd(correctors) {
    Object.assign($04382bd4b1e45b5c$export$91ddd985b97788d1, correctors);
}


/**
 * Generate a list of every possible transform key.
 */ const $c4e1e7d581f55f0c$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $c4e1e7d581f55f0c$export$7b42a0094fb00b6e = new Set($c4e1e7d581f55f0c$export$280dc01950909d86);


function $0abaf5ceadad7a62$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $c4e1e7d581f55f0c$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $04382bd4b1e45b5c$export$91ddd985b97788d1)[key] || key === "opacity");
}


const $4ff834aefd3b2e30$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);



const $4f8d31f2a4d19f76$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $4f8d31f2a4d19f76$var$numTransforms = (0, $c4e1e7d581f55f0c$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $4f8d31f2a4d19f76$export$bdc96e0d5c8f914(transform, { enableHardwareAcceleration: enableHardwareAcceleration = true, allowTransformNone: allowTransformNone = true }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $4f8d31f2a4d19f76$var$numTransforms; i++){
        const key = (0, $c4e1e7d581f55f0c$export$280dc01950909d86)[i];
        if (transform[key] !== undefined) {
            const transformName = $4f8d31f2a4d19f76$var$translateAlias[key] || key;
            transformString += `${transformName}(${transform[key]}) `;
        }
    }
    if (enableHardwareAcceleration && !transform.z) transformString += "translateZ(0)";
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}


const $6dc47aeeece053cc$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $6dc47aeeece053cc$export$9de1236619d9e756 = $6dc47aeeece053cc$var$checkStringStartsWith("--");
const $6dc47aeeece053cc$export$31f9caa2600b5723 = $6dc47aeeece053cc$var$checkStringStartsWith("var(--");
const $6dc47aeeece053cc$export$f7c0a352d8ef6313 = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g;



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $d534a8a64c679513$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};


const $fef110efd8128ce2$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);


const $32a823a43e726818$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $32a823a43e726818$export$58f0f39f63f3cf42 = {
    ...$32a823a43e726818$export$98e628dec113755e,
    transform: (v)=>(0, $fef110efd8128ce2$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $32a823a43e726818$export$dcdf75081b88279d = {
    ...$32a823a43e726818$export$98e628dec113755e,
    default: 1
};


/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $ab39891b2aea4379$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $ab39891b2aea4379$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
const $ab39891b2aea4379$export$740b69c5fad25dba = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
const $ab39891b2aea4379$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function $ab39891b2aea4379$export$844ec244b1367d54(v) {
    return typeof v === "string";
}


const $32bf3b07842a1e2f$var$createUnitType = (unit)=>({
        test: (v)=>(0, $ab39891b2aea4379$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $32bf3b07842a1e2f$export$41fc368e1a942b97 = $32bf3b07842a1e2f$var$createUnitType("deg");
const $32bf3b07842a1e2f$export$626336c2cd4b14de = $32bf3b07842a1e2f$var$createUnitType("%");
const $32bf3b07842a1e2f$export$91c0eda1d06bf008 = $32bf3b07842a1e2f$var$createUnitType("px");
const $32bf3b07842a1e2f$export$f91e8c45a95a32f2 = $32bf3b07842a1e2f$var$createUnitType("vh");
const $32bf3b07842a1e2f$export$aed3d7b7d206c196 = $32bf3b07842a1e2f$var$createUnitType("vw");
const $32bf3b07842a1e2f$export$44e2e1705876d7ed = {
    ...$32bf3b07842a1e2f$export$626336c2cd4b14de,
    parse: (v)=>$32bf3b07842a1e2f$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$32bf3b07842a1e2f$export$626336c2cd4b14de.transform(v * 100)
};



const $68e40a923c02fda2$export$7d260a2a5f8bc19e = {
    ...(0, $32a823a43e726818$export$98e628dec113755e),
    transform: Math.round
};


const $345d5f3a6b7b9505$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    borderTopWidth: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    borderRightWidth: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    borderRadius: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    radius: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    maxWidth: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    height: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    maxHeight: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    size: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    top: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    right: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    bottom: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    left: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    paddingTop: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    paddingRight: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    paddingBottom: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    paddingLeft: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    margin: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    marginTop: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    marginRight: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    marginBottom: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    marginLeft: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $32bf3b07842a1e2f$export$41fc368e1a942b97),
    rotateX: (0, $32bf3b07842a1e2f$export$41fc368e1a942b97),
    rotateY: (0, $32bf3b07842a1e2f$export$41fc368e1a942b97),
    rotateZ: (0, $32bf3b07842a1e2f$export$41fc368e1a942b97),
    scale: $32a823a43e726818$export$dcdf75081b88279d,
    scaleX: (0, $32a823a43e726818$export$dcdf75081b88279d),
    scaleY: (0, $32a823a43e726818$export$dcdf75081b88279d),
    scaleZ: (0, $32a823a43e726818$export$dcdf75081b88279d),
    skew: (0, $32bf3b07842a1e2f$export$41fc368e1a942b97),
    skewX: (0, $32bf3b07842a1e2f$export$41fc368e1a942b97),
    skewY: (0, $32bf3b07842a1e2f$export$41fc368e1a942b97),
    distance: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    translateX: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    translateY: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    translateZ: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    x: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    y: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    z: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    perspective: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    transformPerspective: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    opacity: (0, $32a823a43e726818$export$58f0f39f63f3cf42),
    originX: (0, $32bf3b07842a1e2f$export$44e2e1705876d7ed),
    originY: (0, $32bf3b07842a1e2f$export$44e2e1705876d7ed),
    originZ: (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $68e40a923c02fda2$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $32a823a43e726818$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $32a823a43e726818$export$58f0f39f63f3cf42),
    numOctaves: (0, $68e40a923c02fda2$export$7d260a2a5f8bc19e)
};


function $070549112069826c$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    const { style: style, vars: vars, transform: transform, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $6dc47aeeece053cc$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = (0, $345d5f3a6b7b9505$export$eec14432cd1cb67b)[key];
        const valueAsType = (0, $d534a8a64c679513$export$453ef540a9a1bd6b)(value, valueType);
        if ((0, $c4e1e7d581f55f0c$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0)) transformIsNone = false;
        } else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        } else style[key] = valueAsType;
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $4f8d31f2a4d19f76$export$bdc96e0d5c8f914)(state.transform, options, transformIsNone, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


const $c8111101bbe2ffd4$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


function $98b95a9386733211$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $4ff834aefd3b2e30$export$605d60a2578142d3)(source[key]) && !(0, $0abaf5ceadad7a62$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $98b95a9386733211$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState, isStatic) {
    return (0, $8v0nu.useMemo)(()=>{
        const state = (0, $c8111101bbe2ffd4$export$8940b483cf52eeda)();
        (0, $070549112069826c$export$bb517f8b40f8e99d)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $98b95a9386733211$var$useStyle(props, visualState, isStatic) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $98b95a9386733211$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $98b95a9386733211$var$useInitialMotionValues(props, visualState, isStatic));
    return props.transformValues ? props.transformValues(style) : style;
}
function $98b95a9386733211$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $98b95a9386733211$var$useStyle(props, visualState, isStatic);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $ef6e9b9940eefba5$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $ef6e9b9940eefba5$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $ef6e9b9940eefba5$var$validMotionProps.has(key);
}


let $1a71b3f4aaf781b2$var$shouldForward = (key)=>!(0, $ef6e9b9940eefba5$export$2f9c46555243bf04)(key);
function $1a71b3f4aaf781b2$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $1a71b3f4aaf781b2$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $ef6e9b9940eefba5$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $1a71b3f4aaf781b2$export$59d6962c470509a5((parcelRequire("74qed")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $1a71b3f4aaf781b2$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($1a71b3f4aaf781b2$var$shouldForward(key) || forwardMotionProps === true && (0, $ef6e9b9940eefba5$export$2f9c46555243bf04)(key) || !isDom && !(0, $ef6e9b9940eefba5$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}




var $8v0nu = parcelRequire("8v0nu");



function $1ba776d5dde91be6$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $1ba776d5dde91be6$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $1ba776d5dde91be6$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $1ba776d5dde91be6$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $5e552e5f23207a69$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $5e552e5f23207a69$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $5e552e5f23207a69$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $5e552e5f23207a69$var$dashKeys : $5e552e5f23207a69$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $1f315a6043306c74$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, options, isSVGTag, transformTemplate) {
    (0, $070549112069826c$export$bb517f8b40f8e99d)(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $1ba776d5dde91be6$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $5e552e5f23207a69$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}



const $7c6b441b4b9274e9$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $c8111101bbe2ffd4$export$8940b483cf52eeda)(),
        attrs: {}
    });


const $fd02d19c38cb8508$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";


function $2b8926df5fb75707$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $8v0nu.useMemo)(()=>{
        const state = (0, $7c6b441b4b9274e9$export$41be8b43e1c4d4f9)();
        (0, $1f315a6043306c74$export$5475d24f125d7053)(state, visualState, {
            enableHardwareAcceleration: false
        }, (0, $fd02d19c38cb8508$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $98b95a9386733211$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $7770e214ebb5f5f8$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $8da896a5df5bb10c$export$88f3fc2fd3766989)(Component) ? (0, $2b8926df5fb75707$export$84309c4f53cb1bd5) : (0, $98b95a9386733211$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $1a71b3f4aaf781b2$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = {
            ...filteredProps,
            ...visualProps,
            ref: ref
        };
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $8v0nu.useMemo)(()=>(0, $4ff834aefd3b2e30$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $8v0nu.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}



function $ac940d4a64639ff1$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $e9c10ab9bb8cc858$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $28dc81cfe4da704c$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $ac940d4a64639ff1$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $e9c10ab9bb8cc858$export$28931db5d57958e5).has(key) ? (0, $dd392415fdd57598$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $17c9d9dedc8cbffe$export$16da615486abaa45(props, prevProps) {
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $4ff834aefd3b2e30$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $4ff834aefd3b2e30$export$605d60a2578142d3)(prevProps.style[key]) || (0, $0abaf5ceadad7a62$export$6d27ce8e3de1c3cf)(key, props)) newValues[key] = style[key];
    return newValues;
}



function $58f3f67b97df4109$export$16da615486abaa45(props, prevProps) {
    const newValues = (0, $17c9d9dedc8cbffe$export$16da615486abaa45)(props, prevProps);
    for(const key in props)if ((0, $4ff834aefd3b2e30$export$605d60a2578142d3)(props[key]) || (0, $4ff834aefd3b2e30$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $c4e1e7d581f55f0c$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}



var $8v0nu = parcelRequire("8v0nu");


function $8c7a89cc6ee14e51$export$d68f140c4d9b48bc(props, definition, custom, currentValues = {}, currentVelocity = {}) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    return definition;
}



const $1993926d51cc737c$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


const $4d2cb305129fc05b$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $4d2cb305129fc05b$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $1993926d51cc737c$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $4cd27bdbf6ceb04f$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $4ff834aefd3b2e30$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $4d2cb305129fc05b$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}




function $677b4d6a54b7deb3$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext) {
    const state = {
        latestValues: $677b4d6a54b7deb3$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $677b4d6a54b7deb3$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $8v0nu.useContext)((0, $bb7a60e717387246$export$2285bbca2c666415));
        const presenceContext = (0, $8v0nu.useContext)((0, $af42344d352b5efc$export$f224e4635b6f8ce2));
        const make = ()=>$677b4d6a54b7deb3$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $01b8aedaf4ac1f4d$export$fe4300aa8eebea86)(make);
    };
function $677b4d6a54b7deb3$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $4cd27bdbf6ceb04f$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $d7ec71cb02690a35$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $d7ec71cb02690a35$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $25a749b50b8e7ca5$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach((definition)=>{
            const resolved = (0, $8c7a89cc6ee14e51$export$d68f140c4d9b48bc)(props, definition);
            if (!resolved) return;
            const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
            for(const key in target){
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(const key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}






const $e2771a43a453f54d$export$44dabd3fae512e85 = {
    useVisualState: (0, $677b4d6a54b7deb3$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $58f3f67b97df4109$export$16da615486abaa45),
        createRenderState: (0, $7c6b441b4b9274e9$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            (0, $5368c6a94979c99d$export$2cef06c20297c17d).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $5368c6a94979c99d$export$2cef06c20297c17d).render(()=>{
                (0, $1f315a6043306c74$export$5475d24f125d7053)(renderState, latestValues, {
                    enableHardwareAcceleration: false
                }, (0, $fd02d19c38cb8508$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
                (0, $28dc81cfe4da704c$export$c5f8399d19a7394b)(instance, renderState);
            });
        }
    })
};





const $d725d5ceb0f39a86$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $677b4d6a54b7deb3$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: $17c9d9dedc8cbffe$export$16da615486abaa45,
        createRenderState: (0, $c8111101bbe2ffd4$export$8940b483cf52eeda)
    })
};


function $ae5406e851d9bb65$export$732916c0e88175fb(Component, { forwardMotionProps: forwardMotionProps = false }, preloadedFeatures, createVisualElement) {
    const baseConfig = (0, $8da896a5df5bb10c$export$88f3fc2fd3766989)(Component) ? (0, $e2771a43a453f54d$export$44dabd3fae512e85) : (0, $d725d5ceb0f39a86$export$e13ea21d87ea57c8);
    return {
        ...baseConfig,
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $7770e214ebb5f5f8$export$5d29104eefd89cc8)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    };
}


function $5fdcb9c4fda70259$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}


const $b4c7e2764e88dddc$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $b5ad284edca80238$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[pointType + "X"],
            y: event[pointType + "Y"]
        }
    };
}
const $b5ad284edca80238$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $b4c7e2764e88dddc$export$a4cf9c8a4b063a6e)(event) && handler(event, $b5ad284edca80238$export$12f84bb882d06e1a(event));
};


function $72c76525032a2230$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $5fdcb9c4fda70259$export$b1d829ddf82884aa)(target, eventName, (0, $b5ad284edca80238$export$c404e80f92c98d29)(handler), options);
}


/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $ea4c575eedcd4a80$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $ea4c575eedcd4a80$export$a4627e546088548d = (...transformers)=>transformers.reduce($ea4c575eedcd4a80$var$combineFunctions);


function $19a32e6be8bb22b4$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $19a32e6be8bb22b4$var$globalHorizontalLock = $19a32e6be8bb22b4$export$518c5fc2dcb7974b("dragHorizontal");
const $19a32e6be8bb22b4$var$globalVerticalLock = $19a32e6be8bb22b4$export$518c5fc2dcb7974b("dragVertical");
function $19a32e6be8bb22b4$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $19a32e6be8bb22b4$var$globalVerticalLock();
    else if (drag === "x") lock = $19a32e6be8bb22b4$var$globalHorizontalLock();
    else {
        const openHorizontal = $19a32e6be8bb22b4$var$globalHorizontalLock();
        const openVertical = $19a32e6be8bb22b4$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $19a32e6be8bb22b4$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $19a32e6be8bb22b4$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


class $759f54af44af347e$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}



function $cc15e52ee567d9ef$var$addHoverEvent(node, isActive) {
    const eventName = "pointer" + (isActive ? "enter" : "leave");
    const callbackName = "onHover" + (isActive ? "Start" : "End");
    const handleEvent = (event, info)=>{
        if (event.pointerType === "touch" || (0, $19a32e6be8bb22b4$export$1b3dd616664938e4)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        if (props[callbackName]) (0, $5368c6a94979c99d$export$2cef06c20297c17d).update(()=>props[callbackName](event, info));
    };
    return (0, $72c76525032a2230$export$fcff2e64e6676b81)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $cc15e52ee567d9ef$export$93a81ea037eac456 extends (0, $759f54af44af347e$export$6e91cf7616333d5) {
    mount() {
        this.unmount = (0, $ea4c575eedcd4a80$export$a4627e546088548d)($cc15e52ee567d9ef$var$addHoverEvent(this.node, true), $cc15e52ee567d9ef$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}





class $78ae3a229bdfd739$export$d4826db40d47595b extends (0, $759f54af44af347e$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $ea4c575eedcd4a80$export$a4627e546088548d)((0, $5fdcb9c4fda70259$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $5fdcb9c4fda70259$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}








/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $7af7d0cb7771c3a5$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $7af7d0cb7771c3a5$export$e841ada32ff745b(parent, child.parentElement);
};




function $c31d8ac99222e41b$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $b5ad284edca80238$export$12f84bb882d06e1a)(syntheticPointerEvent));
}
class $c31d8ac99222e41b$export$f026abdbba7f0c9e extends (0, $759f54af44af347e$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $8e8d79bd50b58ce2$export$8793edee2d425525);
        this.removeEndListeners = (0, $8e8d79bd50b58ce2$export$8793edee2d425525);
        this.removeAccessibleListeners = (0, $8e8d79bd50b58ce2$export$8793edee2d425525);
        this.startPointerPress = (startEvent, startInfo)=>{
            if (this.isPressing) return;
            this.removeEndListeners();
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel, globalTapTarget: globalTapTarget } = this.node.getProps();
                (0, $5368c6a94979c99d$export$2cef06c20297c17d).update(()=>{
                    /**
                     * We only count this as a tap gesture if the event.target is the same
                     * as, or a child of, this component's element
                     */ !globalTapTarget && !(0, $7af7d0cb7771c3a5$export$e841ada32ff745b)(this.node.current, endEvent.target) ? onTapCancel && onTapCancel(endEvent, endInfo) : onTap && onTap(endEvent, endInfo);
                });
            };
            const removePointerUpListener = (0, $72c76525032a2230$export$fcff2e64e6676b81)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $72c76525032a2230$export$fcff2e64e6676b81)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $ea4c575eedcd4a80$export$a4627e546088548d)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $c31d8ac99222e41b$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) (0, $5368c6a94979c99d$export$2cef06c20297c17d).update(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $5fdcb9c4fda70259$export$b1d829ddf82884aa)(this.node.current, "keyup", handleKeyup);
                $c31d8ac99222e41b$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $5fdcb9c4fda70259$export$b1d829ddf82884aa)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $c31d8ac99222e41b$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $5fdcb9c4fda70259$export$b1d829ddf82884aa)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $ea4c575eedcd4a80$export$a4627e546088548d)(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, $5368c6a94979c99d$export$2cef06c20297c17d).update(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $19a32e6be8bb22b4$export$1b3dd616664938e4)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, $5368c6a94979c99d$export$2cef06c20297c17d).update(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $72c76525032a2230$export$fcff2e64e6676b81)(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $5fdcb9c4fda70259$export$b1d829ddf82884aa)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $ea4c575eedcd4a80$export$a4627e546088548d)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $52783e887ce4601a$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $52783e887ce4601a$var$observers = new WeakMap();
const $52783e887ce4601a$var$fireObserverCallback = (entry)=>{
    const callback = $52783e887ce4601a$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $52783e887ce4601a$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($52783e887ce4601a$var$fireObserverCallback);
};
function $52783e887ce4601a$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$52783e887ce4601a$var$observers.has(lookupRoot)) $52783e887ce4601a$var$observers.set(lookupRoot, {});
    const rootObservers = $52783e887ce4601a$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($52783e887ce4601a$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $52783e887ce4601a$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $52783e887ce4601a$var$initIntersectionObserver(options);
    $52783e887ce4601a$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $52783e887ce4601a$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $c1283771cafee117$var$thresholdNames = {
    some: 0,
    all: 1
};
class $c1283771cafee117$export$150851c8cc2f0c72 extends (0, $759f54af44af347e$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $c1283771cafee117$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $52783e887ce4601a$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($c1283771cafee117$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $c1283771cafee117$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $a46435c1e154ac53$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $c1283771cafee117$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $c31d8ac99222e41b$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $78ae3a229bdfd739$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $cc15e52ee567d9ef$export$93a81ea037eac456)
    }
};





function $7a6713bf51b60eb5$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}




/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $d13952e1a84030aa$var$getCurrent(visualElement) {
    const current = {};
    visualElement.values.forEach((value, key)=>current[key] = value.get());
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $d13952e1a84030aa$var$getVelocity(visualElement) {
    const velocity = {};
    visualElement.values.forEach((value, key)=>velocity[key] = value.getVelocity());
    return velocity;
}
function $d13952e1a84030aa$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $8c7a89cc6ee14e51$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, $d13952e1a84030aa$var$getCurrent(visualElement), $d13952e1a84030aa$var$getVelocity(visualElement));
}







/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $54a46bfbff4c833f$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $54a46bfbff4c833f$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;


const $b424baa9e4ec2dc6$export$888a3d84909f9e3d = {
    current: false
};


const $12abc4bee585eb02$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


function $8ab42f88f8f77236$export$fcdd8f3f2160beda(easing) {
    return Boolean(!easing || typeof easing === "string" && $8ab42f88f8f77236$export$2cf569f5e2221176[easing] || (0, $12abc4bee585eb02$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($8ab42f88f8f77236$export$fcdd8f3f2160beda));
}
const $8ab42f88f8f77236$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $8ab42f88f8f77236$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: $8ab42f88f8f77236$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: $8ab42f88f8f77236$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: $8ab42f88f8f77236$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: $8ab42f88f8f77236$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $8ab42f88f8f77236$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    return (0, $12abc4bee585eb02$export$ff43f99925d7366b)(easing) ? $8ab42f88f8f77236$export$2523b8f0bd8f44cb(easing) : Array.isArray(easing) ? easing.map($8ab42f88f8f77236$export$916ea73bcd3a6030) : $8ab42f88f8f77236$export$2cf569f5e2221176[easing];
}


function $3a0f4e0bddbe83f9$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $8ab42f88f8f77236$export$916ea73bcd3a6030)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}



function $7629f9e9b0a0d0c9$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }) {
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : keyframes.length - 1;
    return keyframes[index];
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $edef5cfcb2ac5a62$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $edef5cfcb2ac5a62$var$subdivisionPrecision = 0.0000001;
const $edef5cfcb2ac5a62$var$subdivisionMaxIterations = 12;
function $edef5cfcb2ac5a62$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $edef5cfcb2ac5a62$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $edef5cfcb2ac5a62$var$subdivisionPrecision && ++i < $edef5cfcb2ac5a62$var$subdivisionMaxIterations);
    return currentT;
}
function $edef5cfcb2ac5a62$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $8e8d79bd50b58ce2$export$8793edee2d425525;
    const getTForX = (aX)=>$edef5cfcb2ac5a62$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $edef5cfcb2ac5a62$var$calcBezier(getTForX(t), mY1, mY2);
}


const $c92ec1c6360c9bec$export$929e5a82286172a6 = (0, $edef5cfcb2ac5a62$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $c92ec1c6360c9bec$export$57636bb43b1ccbb0 = (0, $edef5cfcb2ac5a62$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $c92ec1c6360c9bec$export$c07234257a03d5e9 = (0, $edef5cfcb2ac5a62$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $1dbc8ea0e5b39f4b$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};






// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $20be542f6f6feb29$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $f8ce8e74851ac2ef$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $0fa5c70753cab431$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $0fa5c70753cab431$export$c8d67a19199d1a50 = (0, $f8ce8e74851ac2ef$export$2c07eeff45156d4d)($0fa5c70753cab431$export$e444123e42d03385);
const $0fa5c70753cab431$export$30d3455eee55bed5 = (0, $20be542f6f6feb29$export$f946554fb8aeaf0d)($0fa5c70753cab431$export$e444123e42d03385);





const $62022f98a4fded1a$export$77edfce482316a60 = (0, $edef5cfcb2ac5a62$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $62022f98a4fded1a$export$b01116c84cdfe1a2 = (0, $f8ce8e74851ac2ef$export$2c07eeff45156d4d)($62022f98a4fded1a$export$77edfce482316a60);
const $62022f98a4fded1a$export$ddc5fd596f6c71b2 = (0, $20be542f6f6feb29$export$f946554fb8aeaf0d)($62022f98a4fded1a$export$b01116c84cdfe1a2);



const $fab08b3b032ed1f4$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $62022f98a4fded1a$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));


const $ad477d9ab72d101f$var$easingLookup = {
    linear: (0, $8e8d79bd50b58ce2$export$8793edee2d425525),
    easeIn: $c92ec1c6360c9bec$export$929e5a82286172a6,
    easeInOut: $c92ec1c6360c9bec$export$c07234257a03d5e9,
    easeOut: $c92ec1c6360c9bec$export$57636bb43b1ccbb0,
    circIn: $0fa5c70753cab431$export$e444123e42d03385,
    circInOut: $0fa5c70753cab431$export$30d3455eee55bed5,
    circOut: $0fa5c70753cab431$export$c8d67a19199d1a50,
    backIn: $62022f98a4fded1a$export$b01116c84cdfe1a2,
    backInOut: $62022f98a4fded1a$export$ddc5fd596f6c71b2,
    backOut: $62022f98a4fded1a$export$77edfce482316a60,
    anticipate: $fab08b3b032ed1f4$export$6b0af63b873d419e
};
const $ad477d9ab72d101f$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $3b78c10950e93e60$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $edef5cfcb2ac5a62$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $3b78c10950e93e60$export$f5708dca728d7177)($ad477d9ab72d101f$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $ad477d9ab72d101f$var$easingLookup[definition];
    }
    return definition;
};








/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $4b566bb20d68d1e5$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $ab39891b2aea4379$export$844ec244b1367d54)(v) && (0, $ab39891b2aea4379$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $4b566bb20d68d1e5$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $ab39891b2aea4379$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $ab39891b2aea4379$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $43b665c0697a47a3$var$clampRgbUnit = (v)=>(0, $fef110efd8128ce2$export$7d15b64cf5a3a4c4)(0, 255, v);
const $43b665c0697a47a3$export$7a99c86b5b1f4c9e = {
    ...(0, $32a823a43e726818$export$98e628dec113755e),
    transform: (v)=>Math.round($43b665c0697a47a3$var$clampRgbUnit(v))
};
const $43b665c0697a47a3$export$4e46ac54fc82cf3b = {
    test: (0, $4b566bb20d68d1e5$export$2c8400d58aca05e)("rgb", "red"),
    parse: (0, $4b566bb20d68d1e5$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $43b665c0697a47a3$export$7a99c86b5b1f4c9e.transform(red) + ", " + $43b665c0697a47a3$export$7a99c86b5b1f4c9e.transform(green) + ", " + $43b665c0697a47a3$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $ab39891b2aea4379$export$83d2e9e3e4ee39ed)((0, $32a823a43e726818$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $db7b699378fc6be6$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $db7b699378fc6be6$export$834dfc94dde4b3d8 = {
    test: (0, $4b566bb20d68d1e5$export$2c8400d58aca05e)("#"),
    parse: $db7b699378fc6be6$var$parseHex,
    transform: (0, $43b665c0697a47a3$export$4e46ac54fc82cf3b).transform
};






const $4bf2d4491de61a5c$export$810b04175080204c = {
    test: (0, $4b566bb20d68d1e5$export$2c8400d58aca05e)("hsl", "hue"),
    parse: (0, $4b566bb20d68d1e5$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $32bf3b07842a1e2f$export$626336c2cd4b14de).transform((0, $ab39891b2aea4379$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $32bf3b07842a1e2f$export$626336c2cd4b14de).transform((0, $ab39891b2aea4379$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $ab39891b2aea4379$export$83d2e9e3e4ee39ed)((0, $32a823a43e726818$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $228bc0a5c559dd3e$export$35e9368ef982300f = {
    test: (v)=>(0, $43b665c0697a47a3$export$4e46ac54fc82cf3b).test(v) || (0, $db7b699378fc6be6$export$834dfc94dde4b3d8).test(v) || (0, $4bf2d4491de61a5c$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $43b665c0697a47a3$export$4e46ac54fc82cf3b).test(v)) return (0, $43b665c0697a47a3$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $4bf2d4491de61a5c$export$810b04175080204c).test(v)) return (0, $4bf2d4491de61a5c$export$810b04175080204c).parse(v);
        else return (0, $db7b699378fc6be6$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $ab39891b2aea4379$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $43b665c0697a47a3$export$4e46ac54fc82cf3b).transform(v) : (0, $4bf2d4491de61a5c$export$810b04175080204c).transform(v);
    }
};



/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $072c4273bd475353$export$2c9e8a9632a706b2 = (from, to, progress)=>-progress * from + progress * to + from;




// Adapted from https://gist.github.com/mjackson/5311256
function $ea1d8e5607f64718$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $ea1d8e5607f64718$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $ea1d8e5607f64718$var$hueToRgb(p, q, hue + 1 / 3);
        green = $ea1d8e5607f64718$var$hueToRgb(p, q, hue);
        blue = $ea1d8e5607f64718$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $b5bdbe494c40c7f8$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
};
const $b5bdbe494c40c7f8$var$colorTypes = [
    (0, $db7b699378fc6be6$export$834dfc94dde4b3d8),
    (0, $43b665c0697a47a3$export$4e46ac54fc82cf3b),
    (0, $4bf2d4491de61a5c$export$810b04175080204c)
];
const $b5bdbe494c40c7f8$var$getColorType = (v)=>$b5bdbe494c40c7f8$var$colorTypes.find((type)=>type.test(v));
function $b5bdbe494c40c7f8$var$asRGBA(color) {
    const type = $b5bdbe494c40c7f8$var$getColorType(color);
    (0, $3b78c10950e93e60$export$f5708dca728d7177)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    let model = type.parse(color);
    if (type === (0, $4bf2d4491de61a5c$export$810b04175080204c)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $ea1d8e5607f64718$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $b5bdbe494c40c7f8$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $b5bdbe494c40c7f8$var$asRGBA(from);
    const toRGBA = $b5bdbe494c40c7f8$var$asRGBA(to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $b5bdbe494c40c7f8$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $b5bdbe494c40c7f8$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $b5bdbe494c40c7f8$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $072c4273bd475353$export$2c9e8a9632a706b2)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $43b665c0697a47a3$export$4e46ac54fc82cf3b).transform(blended);
    };
};












function $ef43d6c315d6b79c$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $ab39891b2aea4379$export$844ec244b1367d54)(v) && (((_a = v.match((0, $ab39891b2aea4379$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $ab39891b2aea4379$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $ef43d6c315d6b79c$var$cssVarTokeniser = {
    regex: (0, $6dc47aeeece053cc$export$f7c0a352d8ef6313),
    countKey: "Vars",
    token: "${v}",
    parse: (0, $8e8d79bd50b58ce2$export$8793edee2d425525)
};
const $ef43d6c315d6b79c$var$colorTokeniser = {
    regex: (0, $ab39891b2aea4379$export$740b69c5fad25dba),
    countKey: "Colors",
    token: "${c}",
    parse: (0, $228bc0a5c559dd3e$export$35e9368ef982300f).parse
};
const $ef43d6c315d6b79c$var$numberTokeniser = {
    regex: (0, $ab39891b2aea4379$export$2444ca58c08448e4),
    countKey: "Numbers",
    token: "${n}",
    parse: (0, $32a823a43e726818$export$98e628dec113755e).parse
};
function $ef43d6c315d6b79c$var$tokenise(info, { regex: regex, countKey: countKey, token: token, parse: parse }) {
    const matches = info.tokenised.match(regex);
    if (!matches) return;
    info["num" + countKey] = matches.length;
    info.tokenised = info.tokenised.replace(regex, token);
    info.values.push(...matches.map(parse));
}
function $ef43d6c315d6b79c$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const info = {
        value: originalValue,
        tokenised: originalValue,
        values: [],
        numVars: 0,
        numColors: 0,
        numNumbers: 0
    };
    if (info.value.includes("var(--")) $ef43d6c315d6b79c$var$tokenise(info, $ef43d6c315d6b79c$var$cssVarTokeniser);
    $ef43d6c315d6b79c$var$tokenise(info, $ef43d6c315d6b79c$var$colorTokeniser);
    $ef43d6c315d6b79c$var$tokenise(info, $ef43d6c315d6b79c$var$numberTokeniser);
    return info;
}
function $ef43d6c315d6b79c$var$parseComplexValue(v) {
    return $ef43d6c315d6b79c$export$b61fc7c44bf646d5(v).values;
}
function $ef43d6c315d6b79c$var$createTransformer(source) {
    const { values: values, numColors: numColors, numVars: numVars, tokenised: tokenised } = $ef43d6c315d6b79c$export$b61fc7c44bf646d5(source);
    const numValues = values.length;
    return (v)=>{
        let output = tokenised;
        for(let i = 0; i < numValues; i++){
            if (i < numVars) output = output.replace($ef43d6c315d6b79c$var$cssVarTokeniser.token, v[i]);
            else if (i < numVars + numColors) output = output.replace($ef43d6c315d6b79c$var$colorTokeniser.token, (0, $228bc0a5c559dd3e$export$35e9368ef982300f).transform(v[i]));
            else output = output.replace($ef43d6c315d6b79c$var$numberTokeniser.token, (0, $ab39891b2aea4379$export$83d2e9e3e4ee39ed)(v[i]));
        }
        return output;
    };
}
const $ef43d6c315d6b79c$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $ef43d6c315d6b79c$var$getAnimatableNone(v) {
    const parsed = $ef43d6c315d6b79c$var$parseComplexValue(v);
    const transformer = $ef43d6c315d6b79c$var$createTransformer(v);
    return transformer(parsed.map($ef43d6c315d6b79c$var$convertNumbersToZero));
}
const $ef43d6c315d6b79c$export$83a0e34f1302825b = {
    test: $ef43d6c315d6b79c$var$test,
    parse: $ef43d6c315d6b79c$var$parseComplexValue,
    createTransformer: $ef43d6c315d6b79c$var$createTransformer,
    getAnimatableNone: $ef43d6c315d6b79c$var$getAnimatableNone
};


const $9e2f3c5018af5a06$var$mixImmediate = (origin, target)=>(p)=>`${p > 0 ? target : origin}`;
function $9e2f3c5018af5a06$var$getMixer(origin, target) {
    if (typeof origin === "number") return (v)=>(0, $072c4273bd475353$export$2c9e8a9632a706b2)(origin, target, v);
    else if ((0, $228bc0a5c559dd3e$export$35e9368ef982300f).test(origin)) return (0, $b5bdbe494c40c7f8$export$51e568cf5c039bac)(origin, target);
    else return origin.startsWith("var(") ? $9e2f3c5018af5a06$var$mixImmediate(origin, target) : $9e2f3c5018af5a06$export$65516310a87d8205(origin, target);
}
const $9e2f3c5018af5a06$export$3bbefa2f402845c4 = (from, to)=>{
    const output = [
        ...from
    ];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i)=>$9e2f3c5018af5a06$var$getMixer(fromThis, to[i]));
    return (v)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
const $9e2f3c5018af5a06$export$ebc23b6840c51ba1 = (origin, target)=>{
    const output = {
        ...origin,
        ...target
    };
    const blendValue = {};
    for(const key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $9e2f3c5018af5a06$var$getMixer(origin[key], target[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
const $9e2f3c5018af5a06$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $ef43d6c315d6b79c$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $ef43d6c315d6b79c$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $ef43d6c315d6b79c$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.numVars === targetStats.numVars && originStats.numColors === targetStats.numColors && originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) return (0, $ea4c575eedcd4a80$export$a4627e546088548d)($9e2f3c5018af5a06$export$3bbefa2f402845c4(originStats.values, targetStats.values), template);
    else {
        (0, $3b78c10950e93e60$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return $9e2f3c5018af5a06$var$mixImmediate(origin, target);
    }
};



/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $265dc3ce03680acb$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



const $170a696d5a498d6f$var$mixNumber = (from, to)=>(p)=>(0, $072c4273bd475353$export$2c9e8a9632a706b2)(from, to, p);
function $170a696d5a498d6f$var$detectMixerFactory(v) {
    if (typeof v === "number") return $170a696d5a498d6f$var$mixNumber;
    else if (typeof v === "string") return (0, $228bc0a5c559dd3e$export$35e9368ef982300f).test(v) ? (0, $b5bdbe494c40c7f8$export$51e568cf5c039bac) : (0, $9e2f3c5018af5a06$export$65516310a87d8205);
    else if (Array.isArray(v)) return 0, $9e2f3c5018af5a06$export$3bbefa2f402845c4;
    else if (typeof v === "object") return 0, $9e2f3c5018af5a06$export$ebc23b6840c51ba1;
    return $170a696d5a498d6f$var$mixNumber;
}
function $170a696d5a498d6f$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || $170a696d5a498d6f$var$detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $8e8d79bd50b58ce2$export$8793edee2d425525) : ease;
            mixer = (0, $ea4c575eedcd4a80$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $170a696d5a498d6f$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $3b78c10950e93e60$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $170a696d5a498d6f$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $265dc3ce03680acb$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $fef110efd8128ce2$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $59f19402a7c9fede$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $265dc3ce03680acb$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $072c4273bd475353$export$2c9e8a9632a706b2)(min, 1, offsetProgress));
    }
}


function $a3f63d3e731b9e5c$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $59f19402a7c9fede$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $5112351093e9630d$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $29440fbb341e3a20$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $c92ec1c6360c9bec$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $29440fbb341e3a20$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $1dbc8ea0e5b39f4b$export$216948827bbdc797)(ease) ? ease.map((0, $ad477d9ab72d101f$export$ef97fe084f156ca4)) : (0, $ad477d9ab72d101f$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $5112351093e9630d$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $a3f63d3e731b9e5c$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $170a696d5a498d6f$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $29440fbb341e3a20$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}



/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $f7e95caf04fa713e$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $96158e920006b9f4$var$velocitySampleDuration = 5; // ms
function $96158e920006b9f4$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $96158e920006b9f4$var$velocitySampleDuration, 0);
    return (0, $f7e95caf04fa713e$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}





const $fd0ba4ba66528ee2$var$safeMin = 0.001;
const $fd0ba4ba66528ee2$export$a3cdb76e84ee608e = 0.01;
const $fd0ba4ba66528ee2$export$1824b851fad8862b = 10.0;
const $fd0ba4ba66528ee2$export$ff08f2d53484465 = 0.05;
const $fd0ba4ba66528ee2$export$201ca48e54038115 = 1;
function $fd0ba4ba66528ee2$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $3b78c10950e93e60$export$491112666e282270)(duration <= (0, $54a46bfbff4c833f$export$fc3e7e8557f8c8c7)($fd0ba4ba66528ee2$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $fef110efd8128ce2$export$7d15b64cf5a3a4c4)($fd0ba4ba66528ee2$export$ff08f2d53484465, $fd0ba4ba66528ee2$export$201ca48e54038115, dampingRatio);
    duration = (0, $fef110efd8128ce2$export$7d15b64cf5a3a4c4)($fd0ba4ba66528ee2$export$a3cdb76e84ee608e, $fd0ba4ba66528ee2$export$1824b851fad8862b, (0, $54a46bfbff4c833f$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $fd0ba4ba66528ee2$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $fd0ba4ba66528ee2$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $fd0ba4ba66528ee2$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $fd0ba4ba66528ee2$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$fd0ba4ba66528ee2$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $fd0ba4ba66528ee2$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $54a46bfbff4c833f$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $fd0ba4ba66528ee2$var$rootIterations = 12;
function $fd0ba4ba66528ee2$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $fd0ba4ba66528ee2$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $fd0ba4ba66528ee2$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $d240c7c5b3d2b224$var$durationKeys = [
    "duration",
    "bounce"
];
const $d240c7c5b3d2b224$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $d240c7c5b3d2b224$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $d240c7c5b3d2b224$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$d240c7c5b3d2b224$var$isSpringType(options, $d240c7c5b3d2b224$var$physicsKeys) && $d240c7c5b3d2b224$var$isSpringType(options, $d240c7c5b3d2b224$var$durationKeys)) {
        const derived = (0, $fd0ba4ba66528ee2$export$b15f158dc6d6f458)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $d240c7c5b3d2b224$export$b36281d89752ae66({ keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $d240c7c5b3d2b224$var$getSpringOptions({
        ...options,
        velocity: -(0, $54a46bfbff4c833f$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $54a46bfbff4c833f$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $fd0ba4ba66528ee2$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */ if (dampingRatio < 1) currentVelocity = (0, $96158e920006b9f4$export$854187271d233eb5)(resolveSpring, t, current);
                    else currentVelocity = 0;
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}




function $06f0021211529ae2$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $d240c7c5b3d2b224$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $96158e920006b9f4$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t > timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



const $ade6ed0b0efe29ba$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $5368c6a94979c99d$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $5368c6a94979c99d$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $5368c6a94979c99d$export$fff89137e9e818ce).isProcessing ? (0, $5368c6a94979c99d$export$fff89137e9e818ce).timestamp : performance.now()
    };
};





/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $bc6d51577d6e1ade$export$f4ff70a5b4808fd8 = 20000;
function $bc6d51577d6e1ade$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $bc6d51577d6e1ade$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $bc6d51577d6e1ade$export$f4ff70a5b4808fd8 ? Infinity : duration;
}



const $80ad830299aa8f41$var$types = {
    decay: (0, $06f0021211529ae2$export$ee3ff3a17106998),
    inertia: $06f0021211529ae2$export$ee3ff3a17106998,
    tween: (0, $29440fbb341e3a20$export$d25ddfdf17c3ad3e),
    keyframes: (0, $29440fbb341e3a20$export$d25ddfdf17c3ad3e),
    spring: $d240c7c5b3d2b224$export$b36281d89752ae66
};
/**
 * Animate a single value on the main thread.
 *
 * This function is written, where functionality overlaps,
 * to be largely spec-compliant with WAAPI to allow fungibility
 * between the two.
 */ function $80ad830299aa8f41$export$ee9b76de7353d815({ autoplay: autoplay = true, delay: delay = 0, driver: driver = (0, $ade6ed0b0efe29ba$export$c1033964b5ad7fef), keyframes: keyframes$1, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", onPlay: onPlay, onStop: onStop, onComplete: onComplete, onUpdate: onUpdate, ...options }) {
    let speed = 1;
    let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let animationDriver;
    const generatorFactory = $80ad830299aa8f41$var$types[type] || (0, $29440fbb341e3a20$export$d25ddfdf17c3ad3e);
    /**
     * If this isn't the keyframes generator and we've been provided
     * strings as keyframes, we need to interpolate these.
     */ let mapNumbersToKeyframes;
    if (generatorFactory !== (0, $29440fbb341e3a20$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
        mapNumbersToKeyframes = (0, $170a696d5a498d6f$export$89e29e4ab65e70a9)([
            0,
            100
        ], keyframes$1, {
            clamp: false
        });
        keyframes$1 = [
            0,
            100
        ];
    }
    const generator = generatorFactory({
        ...options,
        keyframes: keyframes$1
    });
    let mirroredGenerator;
    if (repeatType === "mirror") mirroredGenerator = generatorFactory({
        ...options,
        keyframes: [
            ...keyframes$1
        ].reverse(),
        velocity: -(options.velocity || 0)
    });
    let playState = "idle";
    let holdTime = null;
    let startTime = null;
    let cancelTime = null;
    /**
     * If duration is undefined and we have repeat options,
     * we need to calculate a duration from the generator.
     *
     * We set it to the generator itself to cache the duration.
     * Any timeline resolver will need to have already precalculated
     * the duration by this step.
     */ if (generator.calculatedDuration === null && repeat) generator.calculatedDuration = (0, $bc6d51577d6e1ade$export$cbdd6b3d40ea54e2)(generator);
    const { calculatedDuration: calculatedDuration } = generator;
    let resolvedDuration = Infinity;
    let totalDuration = Infinity;
    if (calculatedDuration !== null) {
        resolvedDuration = calculatedDuration + repeatDelay;
        totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
    }
    let currentTime = 0;
    const tick = (timestamp)=>{
        if (startTime === null) return;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (speed > 0) startTime = Math.min(startTime, timestamp);
        if (speed < 0) startTime = Math.min(timestamp - totalDuration / speed, startTime);
        if (holdTime !== null) currentTime = holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        currentTime = Math.round(timestamp - startTime) * speed;
        // Rebase on delay
        const timeWithoutDelay = currentTime - delay * (speed >= 0 ? 1 : -1);
        const isInDelayPhase = speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        currentTime = Math.max(timeWithoutDelay, 0);
        /**
         * If this animation has finished, set the current time
         * to the total duration.
         */ if (playState === "finished" && holdTime === null) currentTime = totalDuration;
        let elapsed = currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $fef110efd8128ce2$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes$1[0]
        } : frameGenerator.next(elapsed);
        if (mapNumbersToKeyframes) state.value = mapNumbersToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = speed >= 0 ? currentTime >= totalDuration : currentTime <= 0;
        const isAnimationFinished = holdTime === null && (playState === "finished" || playState === "running" && done);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) finish();
        return state;
    };
    const stopAnimationDriver = ()=>{
        animationDriver && animationDriver.stop();
        animationDriver = undefined;
    };
    const cancel = ()=>{
        playState = "idle";
        stopAnimationDriver();
        resolveFinishedPromise();
        updateFinishedPromise();
        startTime = cancelTime = null;
    };
    const finish = ()=>{
        playState = "finished";
        onComplete && onComplete();
        stopAnimationDriver();
        resolveFinishedPromise();
    };
    const play = ()=>{
        if (hasStopped) return;
        if (!animationDriver) animationDriver = driver(tick);
        const now = animationDriver.now();
        onPlay && onPlay();
        if (holdTime !== null) startTime = now - holdTime;
        else if (!startTime || playState === "finished") startTime = now;
        if (playState === "finished") updateFinishedPromise();
        cancelTime = startTime;
        holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ playState = "running";
        animationDriver.start();
    };
    if (autoplay) play();
    const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        get time () {
            return (0, $54a46bfbff4c833f$export$f64c3bfbc58eec0f)(currentTime);
        },
        set time (newTime){
            newTime = (0, $54a46bfbff4c833f$export$fc3e7e8557f8c8c7)(newTime);
            currentTime = newTime;
            if (holdTime !== null || !animationDriver || speed === 0) holdTime = newTime;
            else startTime = animationDriver.now() - newTime / speed;
        },
        get duration () {
            const duration = generator.calculatedDuration === null ? (0, $bc6d51577d6e1ade$export$cbdd6b3d40ea54e2)(generator) : generator.calculatedDuration;
            return (0, $54a46bfbff4c833f$export$f64c3bfbc58eec0f)(duration);
        },
        get speed () {
            return speed;
        },
        set speed (newSpeed){
            if (newSpeed === speed || !animationDriver) return;
            speed = newSpeed;
            controls.time = (0, $54a46bfbff4c833f$export$f64c3bfbc58eec0f)(currentTime);
        },
        get state () {
            return playState;
        },
        play: play,
        pause: ()=>{
            playState = "paused";
            holdTime = currentTime;
        },
        stop: ()=>{
            hasStopped = true;
            if (playState === "idle") return;
            playState = "idle";
            onStop && onStop();
            cancel();
        },
        cancel: ()=>{
            if (cancelTime !== null) tick(cancelTime);
            cancel();
        },
        complete: ()=>{
            playState = "finished";
        },
        sample: (elapsed)=>{
            startTime = 0;
            return tick(elapsed);
        }
    };
    return controls;
}



function $931681e4d38dc040$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}




const $622326b0b6760838$var$supportsWaapi = (0, $931681e4d38dc040$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
/**
 * A list of values that can be hardware-accelerated.
 */ const $622326b0b6760838$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform",
    "backgroundColor"
]);
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $622326b0b6760838$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $622326b0b6760838$var$maxDuration = 20000;
const $622326b0b6760838$var$requiresPregeneratedKeyframes = (valueName, options)=>options.type === "spring" || valueName === "backgroundColor" || !(0, $8ab42f88f8f77236$export$fcdd8f3f2160beda)(options.ease);
function $622326b0b6760838$export$4d5d9557ab897126(value, valueName, { onUpdate: onUpdate, onComplete: onComplete, ...options }) {
    const canAccelerateAnimation = $622326b0b6760838$var$supportsWaapi() && $622326b0b6760838$var$acceleratedValues.has(valueName) && !options.repeatDelay && options.repeatType !== "mirror" && options.damping !== 0 && options.type !== "inertia";
    if (!canAccelerateAnimation) return false;
    /**
     * TODO: Unify with js/index
     */ let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Cancelling an animation will write to the DOM. For safety we want to defer
     * this until the next `update` frame lifecycle. This flag tracks whether we
     * have a pending cancel, if so we shouldn't allow animations to finish.
     */ let pendingCancel = false;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let { keyframes: keyframes, duration: duration = 300, ease: ease, times: times } = options;
    /**
     * If this animation needs pre-generated keyframes then generate.
     */ if ($622326b0b6760838$var$requiresPregeneratedKeyframes(valueName, options)) {
        const sampleAnimation = (0, $80ad830299aa8f41$export$ee9b76de7353d815)({
            ...options,
            repeat: 0,
            delay: 0
        });
        let state = {
            done: false,
            value: keyframes[0]
        };
        const pregeneratedKeyframes = [];
        /**
         * Bail after 20 seconds of pre-generated keyframes as it's likely
         * we're heading for an infinite loop.
         */ let t = 0;
        while(!state.done && t < $622326b0b6760838$var$maxDuration){
            state = sampleAnimation.sample(t);
            pregeneratedKeyframes.push(state.value);
            t += $622326b0b6760838$var$sampleDelta;
        }
        times = undefined;
        keyframes = pregeneratedKeyframes;
        duration = t - $622326b0b6760838$var$sampleDelta;
        ease = "linear";
    }
    const animation = (0, $3a0f4e0bddbe83f9$export$c76cd972d26986f9)(value.owner.current, valueName, keyframes, {
        ...options,
        duration: duration,
        /**
         * This function is currently not called if ease is provided
         * as a function so the cast is safe.
         *
         * However it would be possible for a future refinement to port
         * in easing pregeneration from Motion One for browsers that
         * support the upcoming `linear()` easing function.
         */ ease: ease,
        times: times
    });
    const cancelAnimation = ()=>{
        pendingCancel = false;
        animation.cancel();
    };
    const safeCancel = ()=>{
        pendingCancel = true;
        (0, $5368c6a94979c99d$export$2cef06c20297c17d).update(cancelAnimation);
        resolveFinishedPromise();
        updateFinishedPromise();
    };
    /**
     * Prefer the `onfinish` prop as it's more widely supported than
     * the `finished` promise.
     *
     * Here, we synchronously set the provided MotionValue to the end
     * keyframe. If we didn't, when the WAAPI animation is finished it would
     * be removed from the element which would then revert to its old styles.
     */ animation.onfinish = ()=>{
        if (pendingCancel) return;
        value.set((0, $7629f9e9b0a0d0c9$export$14de59408fad90b)(keyframes, options));
        onComplete && onComplete();
        safeCancel();
    };
    /**
     * Animation interrupt callback.
     */ const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        attachTimeline (timeline) {
            animation.timeline = timeline;
            animation.onfinish = null;
            return 0, $8e8d79bd50b58ce2$export$8793edee2d425525;
        },
        get time () {
            return (0, $54a46bfbff4c833f$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
        },
        set time (newTime){
            animation.currentTime = (0, $54a46bfbff4c833f$export$fc3e7e8557f8c8c7)(newTime);
        },
        get speed () {
            return animation.playbackRate;
        },
        set speed (newSpeed){
            animation.playbackRate = newSpeed;
        },
        get duration () {
            return (0, $54a46bfbff4c833f$export$f64c3bfbc58eec0f)(duration);
        },
        play: ()=>{
            if (hasStopped) return;
            animation.play();
            /**
             * Cancel any pending cancel tasks
             */ (0, $5368c6a94979c99d$export$ec99c0ef4978dccb)(cancelAnimation);
        },
        pause: ()=>animation.pause(),
        stop: ()=>{
            hasStopped = true;
            if (animation.playState === "idle") return;
            /**
             * WAAPI doesn't natively have any interruption capabilities.
             *
             * Rather than read commited styles back out of the DOM, we can
             * create a renderless JS animation and sample it twice to calculate
             * its current value, "previous" value, and therefore allow
             * Motion to calculate velocity for any subsequent animation.
             */ const { currentTime: currentTime } = animation;
            if (currentTime) {
                const sampleAnimation = (0, $80ad830299aa8f41$export$ee9b76de7353d815)({
                    ...options,
                    autoplay: false
                });
                value.setWithVelocity(sampleAnimation.sample(currentTime - $622326b0b6760838$var$sampleDelta).value, sampleAnimation.sample(currentTime).value, $622326b0b6760838$var$sampleDelta);
            }
            safeCancel();
        },
        complete: ()=>{
            if (pendingCancel) return;
            animation.finish();
        },
        cancel: safeCancel
    };
    return controls;
}




function $b1b72a99b11ba400$export$6f34fc8ef6c42b70({ keyframes: keyframes, delay: delay, onUpdate: onUpdate, onComplete: onComplete }) {
    const setValue = ()=>{
        onUpdate && onUpdate(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
        /**
         * TODO: As this API grows it could make sense to always return
         * animateValue. This will be a bigger project as animateValue
         * is frame-locked whereas this function resolves instantly.
         * This is a behavioural change and also has ramifications regarding
         * assumptions within tests.
         */ return {
            time: 0,
            speed: 1,
            duration: 0,
            play: (0, $8e8d79bd50b58ce2$export$8793edee2d425525),
            pause: (0, $8e8d79bd50b58ce2$export$8793edee2d425525),
            stop: (0, $8e8d79bd50b58ce2$export$8793edee2d425525),
            then: (resolve)=>{
                resolve();
                return Promise.resolve();
            },
            cancel: (0, $8e8d79bd50b58ce2$export$8793edee2d425525),
            complete: (0, $8e8d79bd50b58ce2$export$8793edee2d425525)
        };
    };
    return delay ? (0, $80ad830299aa8f41$export$ee9b76de7353d815)({
        keyframes: [
            0,
            1
        ],
        duration: 0,
        delay: delay,
        onComplete: setValue
    }) : setValue();
}



const $a400151b2f574e4e$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $a400151b2f574e4e$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $a400151b2f574e4e$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $a400151b2f574e4e$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $a400151b2f574e4e$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $a400151b2f574e4e$var$keyframesTransition;
    else if ((0, $c4e1e7d581f55f0c$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $a400151b2f574e4e$var$criticallyDampedSpring(keyframes[1]) : $a400151b2f574e4e$var$underDampedSpring;
    return $a400151b2f574e4e$var$ease;
};



/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $6cf8f838e4969b00$export$65676b58b122bc38 = (key, value)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $ef43d6c315d6b79c$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};





/**
 * Properties that should default to 1 or 100%
 */ const $472e0c6fdf026245$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $472e0c6fdf026245$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $ab39891b2aea4379$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $472e0c6fdf026245$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $472e0c6fdf026245$var$functionRegex = /([a-z-]*)\(.*?\)/g;
const $472e0c6fdf026245$export$3dea766d36a8935f = {
    ...(0, $ef43d6c315d6b79c$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($472e0c6fdf026245$var$functionRegex);
        return functions ? functions.map($472e0c6fdf026245$var$applyDefaultFilter).join(" ") : v;
    }
};





/**
 * A map of default value types for common values
 */ const $2a0597ef1be1a26f$export$98cd7c72c5a731fb = {
    ...(0, $345d5f3a6b7b9505$export$eec14432cd1cb67b),
    color: // Color props
    $228bc0a5c559dd3e$export$35e9368ef982300f,
    backgroundColor: (0, $228bc0a5c559dd3e$export$35e9368ef982300f),
    outlineColor: (0, $228bc0a5c559dd3e$export$35e9368ef982300f),
    fill: (0, $228bc0a5c559dd3e$export$35e9368ef982300f),
    stroke: (0, $228bc0a5c559dd3e$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $228bc0a5c559dd3e$export$35e9368ef982300f),
    borderTopColor: (0, $228bc0a5c559dd3e$export$35e9368ef982300f),
    borderRightColor: (0, $228bc0a5c559dd3e$export$35e9368ef982300f),
    borderBottomColor: (0, $228bc0a5c559dd3e$export$35e9368ef982300f),
    borderLeftColor: (0, $228bc0a5c559dd3e$export$35e9368ef982300f),
    filter: $472e0c6fdf026245$export$3dea766d36a8935f,
    WebkitFilter: (0, $472e0c6fdf026245$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $2a0597ef1be1a26f$export$67d1babe0338d23b = (key)=>$2a0597ef1be1a26f$export$98cd7c72c5a731fb[key];


function $f04dbff4b1348b31$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $2a0597ef1be1a26f$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $472e0c6fdf026245$export$3dea766d36a8935f)) defaultValueType = (0, $ef43d6c315d6b79c$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}



/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $d792af57501c8122$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/.test(v);


function $0a8580e1831a7813$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $d792af57501c8122$export$ade84c85e44a6cb1)(value);
}


function $7027679c31520336$export$b2b5e866b2fbf2ec(value, valueName, target, transition) {
    const isTargetAnimatable = (0, $6cf8f838e4969b00$export$65676b58b122bc38)(valueName, target);
    let keyframes;
    if (Array.isArray(target)) keyframes = [
        ...target
    ];
    else keyframes = [
        null,
        target
    ];
    const defaultOrigin = transition.from !== undefined ? transition.from : value.get();
    let animatableTemplateValue = undefined;
    const noneKeyframeIndexes = [];
    for(let i = 0; i < keyframes.length; i++){
        /**
         * Fill null/wildcard keyframes
         */ if (keyframes[i] === null) keyframes[i] = i === 0 ? defaultOrigin : keyframes[i - 1];
        if ((0, $0a8580e1831a7813$export$e56af863d5645d5f)(keyframes[i])) noneKeyframeIndexes.push(i);
        // TODO: Clean this conditional, it works for now
        if (typeof keyframes[i] === "string" && keyframes[i] !== "none" && keyframes[i] !== "0") animatableTemplateValue = keyframes[i];
    }
    if (isTargetAnimatable && noneKeyframeIndexes.length && animatableTemplateValue) for(let i = 0; i < noneKeyframeIndexes.length; i++){
        const index = noneKeyframeIndexes[i];
        keyframes[index] = (0, $f04dbff4b1348b31$export$cea0cedcb94873b5)(valueName, animatableTemplateValue);
    }
    return keyframes;
}


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $7ae90ec94b7af2ca$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function $7ae90ec94b7af2ca$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}



const $c49b7b05afae88d2$export$dd826089e3c5e502 = {
    skipAnimations: false
};


const $778546bdbc86ca82$export$90b3dfc33ff3548 = (valueName, value, target, transition = {})=>{
    return (onComplete)=>{
        const valueTransition = (0, $7ae90ec94b7af2ca$export$7c1391340308742e)(transition, valueName) || {};
        /**
         * Most transition values are currently completely overwritten by value-specific
         * transitions. In the future it'd be nicer to blend these transitions. But for now
         * delay actually does inherit from the root transition if not value-specific.
         */ const delay = valueTransition.delay || transition.delay || 0;
        /**
         * Elapsed isn't a public transition option but can be passed through from
         * optimized appear effects in milliseconds.
         */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $54a46bfbff4c833f$export$fc3e7e8557f8c8c7)(delay);
        const keyframes = (0, $7027679c31520336$export$b2b5e866b2fbf2ec)(value, valueName, target, valueTransition);
        /**
         * Check if we're able to animate between the start and end keyframes,
         * and throw a warning if we're attempting to animate between one that's
         * animatable and another that isn't.
         */ const originKeyframe = keyframes[0];
        const targetKeyframe = keyframes[keyframes.length - 1];
        const isOriginAnimatable = (0, $6cf8f838e4969b00$export$65676b58b122bc38)(valueName, originKeyframe);
        const isTargetAnimatable = (0, $6cf8f838e4969b00$export$65676b58b122bc38)(valueName, targetKeyframe);
        (0, $3b78c10950e93e60$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${valueName} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
        let options = {
            keyframes: keyframes,
            velocity: value.getVelocity(),
            ease: "easeOut",
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            }
        };
        /**
         * If there's no transition defined for this value, we can generate
         * unqiue transition settings for this value.
         */ if (!(0, $7ae90ec94b7af2ca$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $a400151b2f574e4e$export$262124b154b9f1c0)(valueName, options)
        };
        /**
         * Both WAAPI and our internal animation functions use durations
         * as defined by milliseconds, while our external API defines them
         * as seconds.
         */ if (options.duration) options.duration = (0, $54a46bfbff4c833f$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $54a46bfbff4c833f$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (!isOriginAnimatable || !isTargetAnimatable || (0, $b424baa9e4ec2dc6$export$888a3d84909f9e3d).current || valueTransition.type === false || (0, $c49b7b05afae88d2$export$dd826089e3c5e502).skipAnimations) /**
             * If we can't animate this value, or the global instant animation flag is set,
             * or this is simply defined as an instant transition, return an instant transition.
             */ return (0, $b1b72a99b11ba400$export$6f34fc8ef6c42b70)((0, $b424baa9e4ec2dc6$export$888a3d84909f9e3d).current ? {
            ...options,
            delay: 0
        } : options);
        /**
         * Animate via WAAPI if possible.
         */ if (/**
         * If this is a handoff animation, the optimised animation will be running via
         * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
         * optimised animation.
         */ !transition.isHandoff && value.owner && value.owner.current instanceof HTMLElement && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !value.owner.getProps().onUpdate) {
            const acceleratedAnimation = (0, $622326b0b6760838$export$4d5d9557ab897126)(value, valueName, options);
            if (acceleratedAnimation) return acceleratedAnimation;
        }
        /**
         * If we didn't create an accelerated animation, create a JS animation
         */ return (0, $80ad830299aa8f41$export$ee9b76de7353d815)(options);
    };
};



function $d12c09077e65382c$export$98397f3adbf6259f(value) {
    return Boolean((0, $4ff834aefd3b2e30$export$605d60a2578142d3)(value) && value.add);
}


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $76ebd3c77a70a60b$export$65583ed5a868f2d9 = (v)=>/^\-?\d*\.?\d+$/.test(v);




function $9c78c0c4a394a3ef$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $9c78c0c4a394a3ef$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $9c78c0c4a394a3ef$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $ef011d7b5574c5da$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $9c78c0c4a394a3ef$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $9c78c0c4a394a3ef$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}





const $be35e922e4ecba6f$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $be35e922e4ecba6f$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $be35e922e4ecba6f$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "10.18.0";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            this.prev = this.current;
            this.current = v;
            // Update timestamp
            const { delta: delta, timestamp: timestamp } = (0, $5368c6a94979c99d$export$fff89137e9e818ce);
            if (this.lastUpdated !== timestamp) {
                this.timeDelta = delta;
                this.lastUpdated = timestamp;
                (0, $5368c6a94979c99d$export$2cef06c20297c17d).postRender(this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (this.prev !== this.current && this.events.change) this.events.change.notify(this.current);
            // Update velocity subscribers
            if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = ()=>(0, $5368c6a94979c99d$export$2cef06c20297c17d).postRender(this.velocityCheck);
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = ({ timestamp: timestamp })=>{
            if (timestamp !== this.lastUpdated) {
                this.prev = this.current;
                if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = $be35e922e4ecba6f$var$isFloat(this.current);
        this.owner = options.owner;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $ef011d7b5574c5da$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $5368c6a94979c99d$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = prev;
        this.timeDelta = delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v) {
        this.updateAndNotify(v);
        this.prev = v;
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($be35e922e4ecba6f$export$67fcd818a264039d.current) $be35e922e4ecba6f$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, $f7e95caf04fa713e$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $be35e922e4ecba6f$export$ce8bdc721e76545f(init, options) {
    return new $be35e922e4ecba6f$export$8cea36d14ee64562(init, options);
}








/**
 * Tests a provided value against a ValueType
 */ const $3ac077752e837ba6$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $df3e9373f76aac44$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $79126bf5a2d16360$export$d176691c1998a1f5 = [
    (0, $32a823a43e726818$export$98e628dec113755e),
    (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008),
    (0, $32bf3b07842a1e2f$export$626336c2cd4b14de),
    (0, $32bf3b07842a1e2f$export$41fc368e1a942b97),
    (0, $32bf3b07842a1e2f$export$aed3d7b7d206c196),
    (0, $32bf3b07842a1e2f$export$f91e8c45a95a32f2),
    (0, $df3e9373f76aac44$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $79126bf5a2d16360$export$eefdd52e3ccae428 = (v)=>$79126bf5a2d16360$export$d176691c1998a1f5.find((0, $3ac077752e837ba6$export$6eae4d0a6a7ca7cd)(v));



/**
 * A list of all ValueTypes
 */ const $2d6a8285ab2d1a2a$var$valueTypes = [
    ...(0, $79126bf5a2d16360$export$d176691c1998a1f5),
    (0, $228bc0a5c559dd3e$export$35e9368ef982300f),
    (0, $ef43d6c315d6b79c$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $2d6a8285ab2d1a2a$export$950e7e59ea1ffed7 = (v)=>$2d6a8285ab2d1a2a$var$valueTypes.find((0, $3ac077752e837ba6$export$6eae4d0a6a7ca7cd)(v));



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $f39c71fcd12d36b6$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $be35e922e4ecba6f$export$ce8bdc721e76545f)(value));
}
function $f39c71fcd12d36b6$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $d13952e1a84030aa$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $4d2cb305129fc05b$export$5485128c47bd48bb)(target[key]);
        $f39c71fcd12d36b6$var$setMotionValue(visualElement, key, value);
    }
}
function $f39c71fcd12d36b6$var$setVariants(visualElement, variantLabels) {
    const reversedLabels = [
        ...variantLabels
    ].reverse();
    reversedLabels.forEach((key)=>{
        const variant = visualElement.getVariant(key);
        variant && $f39c71fcd12d36b6$export$1f61c53461aff4a5(visualElement, variant);
        if (visualElement.variantChildren) visualElement.variantChildren.forEach((child)=>{
            $f39c71fcd12d36b6$var$setVariants(child, variantLabels);
        });
    });
}
function $f39c71fcd12d36b6$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $f39c71fcd12d36b6$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $f39c71fcd12d36b6$var$setVariants(visualElement, [
        definition
    ]);
    else $f39c71fcd12d36b6$export$1f61c53461aff4a5(visualElement, definition);
}
function $f39c71fcd12d36b6$export$6afbed164019a54c(visualElement, target, origin) {
    var _a, _b;
    const newValueKeys = Object.keys(target).filter((key)=>!visualElement.hasValue(key));
    const numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(let i = 0; i < numNewValues; i++){
        const key = newValueKeys[i];
        const targetValue = target[key];
        let value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && ((0, $76ebd3c77a70a60b$export$65583ed5a868f2d9)(value) || (0, $d792af57501c8122$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, $2d6a8285ab2d1a2a$export$950e7e59ea1ffed7)(value) && (0, $ef43d6c315d6b79c$export$83a0e34f1302825b).test(targetValue)) value = (0, $f04dbff4b1348b31$export$cea0cedcb94873b5)(key, targetValue);
        visualElement.addValue(key, (0, $be35e922e4ecba6f$export$ce8bdc721e76545f)(value, {
            owner: visualElement
        }));
        if (origin[key] === undefined) origin[key] = value;
        if (value !== null) visualElement.setBaseTarget(key, value);
    }
}
function $f39c71fcd12d36b6$export$c3befe8e18686628(key, transition) {
    if (!transition) return;
    const valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function $f39c71fcd12d36b6$export$5a759dc7a1cfb72a(target, transition, visualElement) {
    const origin = {};
    for(const key in target){
        const transitionOrigin = $f39c71fcd12d36b6$export$c3befe8e18686628(key, transition);
        if (transitionOrigin !== undefined) origin[key] = transitionOrigin;
        else {
            const value = visualElement.getValue(key);
            if (value) origin[key] = value.get();
        }
    }
    return origin;
}




/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $19d2d854edcfd38d$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $19d2d854edcfd38d$var$hasKeyframesChanged(value, target) {
    const current = value.get();
    if (Array.isArray(target)) for(let i = 0; i < target.length; i++){
        if (target[i] !== current) return true;
    }
    else return current !== target;
}
function $19d2d854edcfd38d$export$68cacfeee78d98d2(visualElement, definition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = visualElement.makeTargetAnimatable(definition);
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key);
        const valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && $19d2d854edcfd38d$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            elapsed: 0,
            ...(0, $7ae90ec94b7af2ca$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ if (window.HandoffAppearAnimations) {
            const appearId = visualElement.getProps()[0, $690af1df48563525$export$8592e1c077c890a6];
            if (appearId) {
                const elapsed = window.HandoffAppearAnimations(appearId, key, value, (0, $5368c6a94979c99d$export$2cef06c20297c17d));
                if (elapsed !== null) {
                    valueTransition.elapsed = elapsed;
                    valueTransition.isHandoff = true;
                }
            }
        }
        let canSkip = !valueTransition.isHandoff && !$19d2d854edcfd38d$var$hasKeyframesChanged(value, valueTarget);
        if (valueTransition.type === "spring" && (value.getVelocity() || valueTransition.velocity)) canSkip = false;
        /**
         * Temporarily disable skipping animations if there's an animation in
         * progress. Better would be to track the current target of a value
         * and compare that against valueTarget.
         */ if (value.animation) canSkip = false;
        if (canSkip) continue;
        value.start((0, $778546bdbc86ca82$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $c4e1e7d581f55f0c$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition));
        const animation = value.animation;
        if ((0, $d12c09077e65382c$export$98397f3adbf6259f)(willChange)) {
            willChange.add(key);
            animation.then(()=>willChange.remove(key));
        }
        animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        transitionEnd && (0, $f39c71fcd12d36b6$export$1f61c53461aff4a5)(visualElement, transitionEnd);
    });
    return animations;
}




function $dadb10b02090b1bf$export$4709dc300705b2af(visualElement, variant, options = {}) {
    const resolved = (0, $d13952e1a84030aa$export$7b1b1c981f4f0558)(visualElement, variant, options.custom);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $19d2d854edcfd38d$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $dadb10b02090b1bf$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $dadb10b02090b1bf$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($dadb10b02090b1bf$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($dadb10b02090b1bf$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $dadb10b02090b1bf$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}


function $6ca211fac9a658ff$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $dadb10b02090b1bf$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $dadb10b02090b1bf$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $d13952e1a84030aa$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $19d2d854edcfd38d$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>visualElement.notify("AnimationComplete", definition));
}


const $282f680f6638305c$var$reversePriorityOrder = [
    ...(0, $e95939688e97d48b$export$16e45afcc206d3a8)
].reverse();
const $282f680f6638305c$var$numAnimationTypes = (0, $e95939688e97d48b$export$16e45afcc206d3a8).length;
function $282f680f6638305c$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $6ca211fac9a658ff$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $282f680f6638305c$export$bb53502b7a672aa8(visualElement) {
    let animate = $282f680f6638305c$var$animateList(visualElement);
    const state = $282f680f6638305c$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (acc, definition)=>{
        const resolved = (0, $d13952e1a84030aa$export$7b1b1c981f4f0558)(visualElement, definition);
        if (resolved) {
            const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
            acc = {
                ...acc,
                ...target,
                ...transitionEnd
            };
        }
        return acc;
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $282f680f6638305c$var$numAnimationTypes; i++){
            const type = $282f680f6638305c$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $b1763de14481003e$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $25a749b50b8e7ca5$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $282f680f6638305c$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $1993926d51cc737c$export$9153ad4c4999f4a0)(next) && (0, $1993926d51cc737c$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $7a6713bf51b60eb5$export$90e866afbd6b9f1a)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             */ if (shouldAnimateType && (!isInherited || handledRemovedValues)) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type,
                        ...options
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(options, type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state
    };
}
function $282f680f6638305c$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $7a6713bf51b60eb5$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $282f680f6638305c$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $282f680f6638305c$var$createState() {
    return {
        animate: $282f680f6638305c$var$createTypeState(true),
        whileInView: $282f680f6638305c$var$createTypeState(),
        whileHover: $282f680f6638305c$var$createTypeState(),
        whileTap: $282f680f6638305c$var$createTypeState(),
        whileDrag: $282f680f6638305c$var$createTypeState(),
        whileFocus: $282f680f6638305c$var$createTypeState(),
        exit: $282f680f6638305c$var$createTypeState()
    };
}



class $157fd3be837bcd23$export$b45b3fe5caabdca extends (0, $759f54af44af347e$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $282f680f6638305c$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        this.unmount();
        if ((0, $25a749b50b8e7ca5$export$aa71198ceeaf53ce)(animate)) this.unmount = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {}
}



let $455e223518e62b4a$var$id = 0;
class $455e223518e62b4a$export$4989d1eb6104cc6c extends (0, $759f54af44af347e$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $455e223518e62b4a$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete, custom: custom } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent, {
            custom: custom !== null && custom !== void 0 ? custom : this.node.getProps().custom
        });
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $eb9271000c09ec39$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $157fd3be837bcd23$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $455e223518e62b4a$export$4989d1eb6104cc6c)
    }
};









const $58c819ee51481345$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $58c819ee51481345$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $58c819ee51481345$export$9f17032d917177de(a.x, b.x);
    const yDelta = $58c819ee51481345$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $2d1c7bc68ffa3f23$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow, dragSnapToOrigin: dragSnapToOrigin = false } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $2d1c7bc68ffa3f23$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $58c819ee51481345$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $5368c6a94979c99d$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $2d1c7bc68ffa3f23$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $5368c6a94979c99d$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $2d1c7bc68ffa3f23$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $2d1c7bc68ffa3f23$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $b4c7e2764e88dddc$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $b5ad284edca80238$export$12f84bb882d06e1a)(event);
        const initialInfo = $2d1c7bc68ffa3f23$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $5368c6a94979c99d$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $2d1c7bc68ffa3f23$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $ea4c575eedcd4a80$export$a4627e546088548d)((0, $72c76525032a2230$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $72c76525032a2230$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $72c76525032a2230$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $5368c6a94979c99d$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $2d1c7bc68ffa3f23$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $2d1c7bc68ffa3f23$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $2d1c7bc68ffa3f23$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $2d1c7bc68ffa3f23$var$subtractPoint(point, $2d1c7bc68ffa3f23$var$lastDevicePoint(history)),
        offset: $2d1c7bc68ffa3f23$var$subtractPoint(point, $2d1c7bc68ffa3f23$var$startDevicePoint(history)),
        velocity: $2d1c7bc68ffa3f23$var$getVelocity(history, 0.1)
    };
}
function $2d1c7bc68ffa3f23$var$startDevicePoint(history) {
    return history[0];
}
function $2d1c7bc68ffa3f23$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $2d1c7bc68ffa3f23$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $2d1c7bc68ffa3f23$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $54a46bfbff4c833f$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $54a46bfbff4c833f$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}







function $a1243ce774ecc0c8$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $a1243ce774ecc0c8$export$28d0384c4b79bde2(value, target = 0, maxDistance = 0.01) {
    return Math.abs(value - target) <= maxDistance;
}
function $a1243ce774ecc0c8$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $072c4273bd475353$export$2c9e8a9632a706b2)(source.min, source.max, delta.origin);
    delta.scale = $a1243ce774ecc0c8$export$c1c127004b72a37(target) / $a1243ce774ecc0c8$export$c1c127004b72a37(source);
    if ($a1243ce774ecc0c8$export$28d0384c4b79bde2(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = (0, $072c4273bd475353$export$2c9e8a9632a706b2)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($a1243ce774ecc0c8$export$28d0384c4b79bde2(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function $a1243ce774ecc0c8$export$c0d25e96fc67d310(delta, source, target, origin) {
    $a1243ce774ecc0c8$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $a1243ce774ecc0c8$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $a1243ce774ecc0c8$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $a1243ce774ecc0c8$export$c1c127004b72a37(relative);
}
function $a1243ce774ecc0c8$export$426154f9d100f99(target, relative, parent) {
    $a1243ce774ecc0c8$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $a1243ce774ecc0c8$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $a1243ce774ecc0c8$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $a1243ce774ecc0c8$export$c1c127004b72a37(layout);
}
function $a1243ce774ecc0c8$export$2785bfcc929c5650(target, layout, parent) {
    $a1243ce774ecc0c8$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $a1243ce774ecc0c8$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $7f5bc3e929ead266$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $072c4273bd475353$export$2c9e8a9632a706b2)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $072c4273bd475353$export$2c9e8a9632a706b2)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $7f5bc3e929ead266$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $7f5bc3e929ead266$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $7f5bc3e929ead266$export$690c180aa5775042(layoutBox.x, left, right),
        y: $7f5bc3e929ead266$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $7f5bc3e929ead266$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $7f5bc3e929ead266$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $7f5bc3e929ead266$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $7f5bc3e929ead266$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $7f5bc3e929ead266$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $a1243ce774ecc0c8$export$c1c127004b72a37)(source);
    const targetLength = (0, $a1243ce774ecc0c8$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $265dc3ce03680acb$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $265dc3ce03680acb$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $fef110efd8128ce2$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $7f5bc3e929ead266$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $7f5bc3e929ead266$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $7f5bc3e929ead266$export$7c5eaef8f4723d22(dragElastic = $7f5bc3e929ead266$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $7f5bc3e929ead266$export$a3366d3bac43a742;
    return {
        x: $7f5bc3e929ead266$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $7f5bc3e929ead266$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $7f5bc3e929ead266$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $7f5bc3e929ead266$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $7f5bc3e929ead266$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $7f5bc3e929ead266$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $9ef64ca3aa1da428$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $9ef64ca3aa1da428$export$3d227df54007d73a = ()=>({
        x: $9ef64ca3aa1da428$export$ff25708b37f72782(),
        y: $9ef64ca3aa1da428$export$ff25708b37f72782()
    });
const $9ef64ca3aa1da428$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $9ef64ca3aa1da428$export$6459fc9e86be362e = ()=>({
        x: $9ef64ca3aa1da428$export$6db76765312617ac(),
        y: $9ef64ca3aa1da428$export$6db76765312617ac()
    });


function $6b4752f129b75902$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $cf4f345279411669$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $cf4f345279411669$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $cf4f345279411669$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $c93f19b0ec73bfa8$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $c93f19b0ec73bfa8$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$c93f19b0ec73bfa8$var$isIdentityScale(scale) || !$c93f19b0ec73bfa8$var$isIdentityScale(scaleX) || !$c93f19b0ec73bfa8$var$isIdentityScale(scaleY);
}
function $c93f19b0ec73bfa8$export$a545127cf1fbb600(values) {
    return $c93f19b0ec73bfa8$export$bdf30dca883ea463(values) || $c93f19b0ec73bfa8$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function $c93f19b0ec73bfa8$export$bf80f5f8f4dc327f(values) {
    return $c93f19b0ec73bfa8$var$is2DTranslate(values.x) || $c93f19b0ec73bfa8$var$is2DTranslate(values.y);
}
function $c93f19b0ec73bfa8$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $801ba56674d01115$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $801ba56674d01115$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $801ba56674d01115$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $801ba56674d01115$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $801ba56674d01115$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $801ba56674d01115$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $801ba56674d01115$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $801ba56674d01115$export$d80074982803af5c(box, { x: x, y: y }) {
    $801ba56674d01115$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $801ba56674d01115$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $801ba56674d01115$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const instance = node.instance;
        if (instance && instance.style && instance.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $801ba56674d01115$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $801ba56674d01115$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $c93f19b0ec73bfa8$export$a545127cf1fbb600)(node.latestValues)) $801ba56674d01115$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ treeScale.x = $801ba56674d01115$var$snapToDefault(treeScale.x);
    treeScale.y = $801ba56674d01115$var$snapToDefault(treeScale.y);
}
function $801ba56674d01115$var$snapToDefault(scale) {
    if (Number.isInteger(scale)) return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function $801ba56674d01115$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $801ba56674d01115$export$625f1dd140a2f5e7(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = (0, $072c4273bd475353$export$2c9e8a9632a706b2)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $801ba56674d01115$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $801ba56674d01115$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $801ba56674d01115$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $801ba56674d01115$export$58b16271041fbfb(box, transform) {
    $801ba56674d01115$export$625f1dd140a2f5e7(box.x, transform, $801ba56674d01115$var$xKeys);
    $801ba56674d01115$export$625f1dd140a2f5e7(box.y, transform, $801ba56674d01115$var$yKeys);
}


function $4e54d82997c38b54$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $cf4f345279411669$export$d3955c6a8f65a36b)((0, $cf4f345279411669$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $4e54d82997c38b54$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $4e54d82997c38b54$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $801ba56674d01115$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $801ba56674d01115$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}









// Fixes https://github.com/framer/motion/issues/2270
const $bd5aa336cdaff265$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};



const $8e573d0750749e1a$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $8e573d0750749e1a$export$86bff71f18910307 {
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $9ef64ca3aa1da428$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $b5ad284edca80238$export$12f84bb882d06e1a)(event, "page").point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $19a32e6be8bb22b4$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $6b4752f129b75902$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $32bf3b07842a1e2f$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $a1243ce774ecc0c8$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $5368c6a94979c99d$export$2cef06c20297c17d).update(()=>onDragStart(event, info), false, true);
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $8e573d0750749e1a$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $6b4752f129b75902$export$b789de563eb43b1)((axis)=>{
                var _a;
                return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
            });
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $2d1c7bc68ffa3f23$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $bd5aa336cdaff265$export$d533d84f9871c879)(this.visualElement)
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $5368c6a94979c99d$export$2cef06c20297c17d).update(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$8e573d0750749e1a$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $7f5bc3e929ead266$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $cddfc7e2c37cb099$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $7f5bc3e929ead266$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $7f5bc3e929ead266$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $6b4752f129b75902$export$b789de563eb43b1)((axis)=>{
            if (this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $7f5bc3e929ead266$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $cddfc7e2c37cb099$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $3b78c10950e93e60$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $4e54d82997c38b54$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $7f5bc3e929ead266$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $cf4f345279411669$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $cf4f345279411669$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $6b4752f129b75902$export$b789de563eb43b1)((axis)=>{
            if (!$8e573d0750749e1a$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start((0, $778546bdbc86ca82$export$90b3dfc33ff3548)(axis, axisValue, 0, transition));
    }
    stopAnimation() {
        (0, $6b4752f129b75902$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $6b4752f129b75902$export$b789de563eb43b1)((axis)=>{
            var _a;
            return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = "_drag" + axis.toUpperCase();
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $6b4752f129b75902$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$8e573d0750749e1a$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $072c4273bd475353$export$2c9e8a9632a706b2)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $cddfc7e2c37cb099$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $6b4752f129b75902$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $7f5bc3e929ead266$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $6b4752f129b75902$export$b789de563eb43b1)((axis)=>{
            if (!$8e573d0750749e1a$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $072c4273bd475353$export$2c9e8a9632a706b2)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $8e573d0750749e1a$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $72c76525032a2230$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $cddfc7e2c37cb099$export$dedd81df7bc1307)(dragConstraints)) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $5fdcb9c4fda70259$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $6b4752f129b75902$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $7f5bc3e929ead266$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $8e573d0750749e1a$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $8e573d0750749e1a$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $28c1c17ce2591278$export$5d97dc2872682820 extends (0, $759f54af44af347e$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $8e8d79bd50b58ce2$export$8793edee2d425525);
        this.removeListeners = (0, $8e8d79bd50b58ce2$export$8793edee2d425525);
        this.controls = new (0, $8e573d0750749e1a$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $8e8d79bd50b58ce2$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}








const $1be04a0d843be2d0$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $5368c6a94979c99d$export$2cef06c20297c17d).update(()=>handler(event, info));
    };
class $1be04a0d843be2d0$export$b4f8f1ee75ce5859 extends (0, $759f54af44af347e$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $8e8d79bd50b58ce2$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $2d1c7bc68ffa3f23$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $bd5aa336cdaff265$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $1be04a0d843be2d0$var$asyncHandler(onPanSessionStart),
            onStart: $1be04a0d843be2d0$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $5368c6a94979c99d$export$2cef06c20297c17d).update(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $72c76525032a2230$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}



var $8v0nu = parcelRequire("8v0nu");

var $8v0nu = parcelRequire("8v0nu");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $178906c13254c0f7$export$2a8c16d82a0a0e26() {
    const context = (0, $8v0nu.useContext)((0, $af42344d352b5efc$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $8v0nu.useId)();
    (0, $8v0nu.useEffect)(()=>register(id), []);
    const safeToRemove = ()=>onExitComplete && onExitComplete(id);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $178906c13254c0f7$export$8249053f690ea39a() {
    return $178906c13254c0f7$export$ee27c052bca048fb((0, $8v0nu.useContext)((0, $af42344d352b5efc$export$f224e4635b6f8ce2)));
}
function $178906c13254c0f7$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $067145307b1665b2$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $50cbb14cb165cf18$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $50cbb14cb165cf18$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $32bf3b07842a1e2f$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $50cbb14cb165cf18$export$fafff692be55225d(latest, node.target.x);
        const y = $50cbb14cb165cf18$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $d8f91ba9e005bb4c$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $ef43d6c315d6b79c$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $ef43d6c315d6b79c$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $072c4273bd475353$export$2c9e8a9632a706b2)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};




class $43797e3e47d3582a$var$MeasureLayoutWithContext extends (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).Component {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $04382bd4b1e45b5c$export$de9e7791c71225fd)($43797e3e47d3582a$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $067145307b1665b2$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $5368c6a94979c99d$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            queueMicrotask(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $43797e3e47d3582a$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $178906c13254c0f7$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $8v0nu.useContext)((0, $f8fa84f618a4fe1a$export$a3579ca508007a95));
    return (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).createElement($43797e3e47d3582a$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $8v0nu.useContext)((0, $970c209bfbf3f8ee$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $43797e3e47d3582a$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $50cbb14cb165cf18$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $50cbb14cb165cf18$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $50cbb14cb165cf18$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $50cbb14cb165cf18$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $50cbb14cb165cf18$export$5eafb6257a5844c),
    boxShadow: (0, $d8f91ba9e005bb4c$export$eb0bc629e74dcf8)
};








const $31abffad69346f2f$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $31abffad69346f2f$var$numBorders = $31abffad69346f2f$var$borders.length;
const $31abffad69346f2f$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $31abffad69346f2f$var$isPx = (value)=>typeof value === "number" || (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008).test(value);
function $31abffad69346f2f$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $072c4273bd475353$export$2c9e8a9632a706b2)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $31abffad69346f2f$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $072c4273bd475353$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, 0, $31abffad69346f2f$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $072c4273bd475353$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $31abffad69346f2f$var$numBorders; i++){
        const borderLabel = `border${$31abffad69346f2f$var$borders[i]}Radius`;
        let followRadius = $31abffad69346f2f$var$getRadius(follow, borderLabel);
        let leadRadius = $31abffad69346f2f$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $31abffad69346f2f$var$isPx(followRadius) === $31abffad69346f2f$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $072c4273bd475353$export$2c9e8a9632a706b2)($31abffad69346f2f$var$asNumber(followRadius), $31abffad69346f2f$var$asNumber(leadRadius), progress), 0);
            if ((0, $32bf3b07842a1e2f$export$626336c2cd4b14de).test(leadRadius) || (0, $32bf3b07842a1e2f$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $072c4273bd475353$export$2c9e8a9632a706b2)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $31abffad69346f2f$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $31abffad69346f2f$var$easeCrossfadeIn = $31abffad69346f2f$var$compress(0, 0.5, (0, $0fa5c70753cab431$export$c8d67a19199d1a50));
const $31abffad69346f2f$var$easeCrossfadeOut = $31abffad69346f2f$var$compress(0.5, 0.95, (0, $8e8d79bd50b58ce2$export$8793edee2d425525));
function $31abffad69346f2f$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $265dc3ce03680acb$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $3620b8180cb69445$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $3620b8180cb69445$export$c53fd88f45d77e4b(box, originBox) {
    $3620b8180cb69445$export$a0230ae482601ae8(box.x, originBox.x);
    $3620b8180cb69445$export$a0230ae482601ae8(box.y, originBox.y);
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $d2629bebd72d9741$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $801ba56674d01115$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $801ba56674d01115$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $d2629bebd72d9741$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $32bf3b07842a1e2f$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $072c4273bd475353$export$2c9e8a9632a706b2)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $072c4273bd475353$export$2c9e8a9632a706b2)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $d2629bebd72d9741$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $d2629bebd72d9741$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $d2629bebd72d9741$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $d2629bebd72d9741$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $d2629bebd72d9741$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $d2629bebd72d9741$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $d2629bebd72d9741$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $d2629bebd72d9741$export$42b76f1d0d16d5b(box.x, transforms, $d2629bebd72d9741$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $d2629bebd72d9741$export$42b76f1d0d16d5b(box.y, transforms, $d2629bebd72d9741$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}





function $27d2975258da9dfa$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $27d2975258da9dfa$export$a7ec7642fe550fb6(delta) {
    return $27d2975258da9dfa$var$isAxisDeltaZero(delta.x) && $27d2975258da9dfa$var$isAxisDeltaZero(delta.y);
}
function $27d2975258da9dfa$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}
function $27d2975258da9dfa$export$ef641b782d85522(a, b) {
    return Math.round(a.x.min) === Math.round(b.x.min) && Math.round(a.x.max) === Math.round(b.x.max) && Math.round(a.y.min) === Math.round(b.y.min) && Math.round(a.y.max) === Math.round(b.y.max);
}
function $27d2975258da9dfa$export$c5706146bc63213(box) {
    return (0, $a1243ce774ecc0c8$export$c1c127004b72a37)(box.x) / (0, $a1243ce774ecc0c8$export$c1c127004b72a37)(box.y);
}



class $dd5e23215ac88e93$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $9c78c0c4a394a3ef$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $9c78c0c4a394a3ef$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $64995057e3c1f753$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    if (xTranslate || yTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { rotate: rotate, rotateX: rotateX, rotateY: rotateY } = latestTransform;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $f3f708a114f1fef5$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $a0ef6307c8e33936$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $9c78c0c4a394a3ef$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $9c78c0c4a394a3ef$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $f3f708a114f1fef5$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}





/**
 * Timeout defined in ms
 */ function $32274178866aa5e4$export$1391212d75b2ee65(callback, timeout) {
    const start = performance.now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $5368c6a94979c99d$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $5368c6a94979c99d$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $5368c6a94979c99d$export$ec99c0ef4978dccb)(checkElapsed);
}



function $feeacf3034e0733d$export$e5185e241753e543(data) {
    if (window.MotionDebug) window.MotionDebug.record(data);
}


function $fa0a3b6c77b6f798$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}





function $ba69c14f100438cc$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $4ff834aefd3b2e30$export$605d60a2578142d3)(value) ? value : (0, $be35e922e4ecba6f$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $778546bdbc86ca82$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}





const $f1f73c05506fd292$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $f1f73c05506fd292$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $f1f73c05506fd292$var$animationTarget = 1000;
let $f1f73c05506fd292$var$id = 0;
/**
 * Use a mutable data object for debug data so as to not create a new
 * object every frame.
 */ const $f1f73c05506fd292$var$projectionFrameData = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
function $f1f73c05506fd292$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $f1f73c05506fd292$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ $f1f73c05506fd292$var$projectionFrameData.totalNodes = $f1f73c05506fd292$var$projectionFrameData.resolvedTargetDeltas = $f1f73c05506fd292$var$projectionFrameData.recalculatedProjection = 0;
                this.nodes.forEach($f1f73c05506fd292$export$131f2f0cc5fe9609);
                this.nodes.forEach($f1f73c05506fd292$var$resolveTargetDelta);
                this.nodes.forEach($f1f73c05506fd292$var$calcProjection);
                this.nodes.forEach($f1f73c05506fd292$export$c2664f37bc951031);
                (0, $feeacf3034e0733d$export$e5185e241753e543)($f1f73c05506fd292$var$projectionFrameData);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $a0ef6307c8e33936$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $ef011d7b5574c5da$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $fa0a3b6c77b6f798$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $32274178866aa5e4$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $067145307b1665b2$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $067145307b1665b2$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($f1f73c05506fd292$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $f1f73c05506fd292$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $27d2975258da9dfa$export$ef641b782d85522)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $7ae90ec94b7af2ca$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $f1f73c05506fd292$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $5368c6a94979c99d$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($f1f73c05506fd292$var$resetRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($f1f73c05506fd292$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($f1f73c05506fd292$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($f1f73c05506fd292$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($f1f73c05506fd292$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($f1f73c05506fd292$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = performance.now();
            (0, $5368c6a94979c99d$export$fff89137e9e818ce).delta = (0, $fef110efd8128ce2$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $5368c6a94979c99d$export$fff89137e9e818ce).timestamp);
            (0, $5368c6a94979c99d$export$fff89137e9e818ce).timestamp = now;
            (0, $5368c6a94979c99d$export$fff89137e9e818ce).isProcessing = true;
            (0, $5368c6a94979c99d$export$be3f796aed065412).update.process((0, $5368c6a94979c99d$export$fff89137e9e818ce));
            (0, $5368c6a94979c99d$export$be3f796aed065412).preRender.process((0, $5368c6a94979c99d$export$fff89137e9e818ce));
            (0, $5368c6a94979c99d$export$be3f796aed065412).render.process((0, $5368c6a94979c99d$export$fff89137e9e818ce));
            (0, $5368c6a94979c99d$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                queueMicrotask(()=>this.update());
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($f1f73c05506fd292$var$clearSnapshot);
            this.sharedNodes.forEach($f1f73c05506fd292$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $5368c6a94979c99d$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $5368c6a94979c99d$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $9ef64ca3aa1da428$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) this.scroll = {
                animationId: this.root.animationId,
                phase: phase,
                isRoot: checkIsScrollRoot(this.instance),
                offset: measureScroll(this.instance)
            };
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            const hasProjection = this.projectionDelta && !(0, $27d2975258da9dfa$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $c93f19b0ec73bfa8$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $f1f73c05506fd292$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $9ef64ca3aa1da428$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll: scroll } = this.root;
            if (scroll) {
                (0, $801ba56674d01115$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                (0, $801ba56674d01115$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $9ef64ca3aa1da428$export$6459fc9e86be362e)();
            (0, $3620b8180cb69445$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.isRoot) {
                        (0, $3620b8180cb69445$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                        const { scroll: rootScroll } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            (0, $801ba56674d01115$export$a807a5ce5ebb3895)(boxWithoutScroll.x, -rootScroll.offset.x);
                            (0, $801ba56674d01115$export$a807a5ce5ebb3895)(boxWithoutScroll.y, -rootScroll.offset.y);
                        }
                    }
                    (0, $801ba56674d01115$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $801ba56674d01115$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $9ef64ca3aa1da428$export$6459fc9e86be362e)();
            (0, $3620b8180cb69445$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $801ba56674d01115$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $c93f19b0ec73bfa8$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $801ba56674d01115$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $c93f19b0ec73bfa8$export$a545127cf1fbb600)(this.latestValues)) (0, $801ba56674d01115$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $9ef64ca3aa1da428$export$6459fc9e86be362e)();
            (0, $3620b8180cb69445$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $c93f19b0ec73bfa8$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $c93f19b0ec73bfa8$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $9ef64ca3aa1da428$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $3620b8180cb69445$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $d2629bebd72d9741$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $c93f19b0ec73bfa8$export$a545127cf1fbb600)(this.latestValues)) (0, $d2629bebd72d9741$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $5368c6a94979c99d$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $5368c6a94979c99d$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $9ef64ca3aa1da428$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $9ef64ca3aa1da428$export$6459fc9e86be362e)();
                    (0, $a1243ce774ecc0c8$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $3620b8180cb69445$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $9ef64ca3aa1da428$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $9ef64ca3aa1da428$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $a1243ce774ecc0c8$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $3620b8180cb69445$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $801ba56674d01115$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $3620b8180cb69445$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $9ef64ca3aa1da428$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $9ef64ca3aa1da428$export$6459fc9e86be362e)();
                    (0, $a1243ce774ecc0c8$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $3620b8180cb69445$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ $f1f73c05506fd292$var$projectionFrameData.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $c93f19b0ec73bfa8$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $c93f19b0ec73bfa8$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $5368c6a94979c99d$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $3620b8180cb69445$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $801ba56674d01115$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) lead.target = lead.layout.layoutBox;
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.projectionTransform) {
                    this.projectionDelta = (0, $9ef64ca3aa1da428$export$3d227df54007d73a)();
                    this.projectionTransform = "none";
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta) {
                this.projectionDelta = (0, $9ef64ca3aa1da428$export$3d227df54007d73a)();
                this.projectionDeltaWithTransform = (0, $9ef64ca3aa1da428$export$3d227df54007d73a)();
            }
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $a1243ce774ecc0c8$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, $64995057e3c1f753$export$d33653b270fe725c)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ $f1f73c05506fd292$var$projectionFrameData.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.scheduleRender && this.options.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $9ef64ca3aa1da428$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $9ef64ca3aa1da428$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($f1f73c05506fd292$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $f1f73c05506fd292$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $f1f73c05506fd292$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $a1243ce774ecc0c8$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $f1f73c05506fd292$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $27d2975258da9dfa$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $9ef64ca3aa1da428$export$6459fc9e86be362e)();
                    (0, $3620b8180cb69445$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $31abffad69346f2f$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $5368c6a94979c99d$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $5368c6a94979c99d$export$2cef06c20297c17d).update(()=>{
                (0, $067145307b1665b2$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $ba69c14f100438cc$export$335a17c977067b99)(0, $f1f73c05506fd292$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($f1f73c05506fd292$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $f1f73c05506fd292$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $9ef64ca3aa1da428$export$6459fc9e86be362e)();
                const xLength = (0, $a1243ce774ecc0c8$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $a1243ce774ecc0c8$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $3620b8180cb69445$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $801ba56674d01115$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $a1243ce774ecc0c8$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $dd5e23215ac88e93$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected rotation values, we can early return without a forced render.
            let hasRotate = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ) hasRotate = true;
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate) return;
            const resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for(let i = 0; i < $f1f73c05506fd292$var$transformAxes.length; i++){
                const key = "rotate" + $f1f73c05506fd292$var$transformAxes[i];
                // Record the rotation and then temporarily set it to 0
                if (latestValues[key]) {
                    resetValues[key] = latestValues[key];
                    visualElement.setStaticValue(key, 0);
                }
            }
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues)visualElement.setStaticValue(key, resetValues[key]);
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $f1f73c05506fd292$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $4cd27bdbf6ceb04f$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $4cd27bdbf6ceb04f$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $c93f19b0ec73bfa8$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $64995057e3c1f753$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $04382bd4b1e45b5c$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $04382bd4b1e45b5c$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $4cd27bdbf6ceb04f$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($f1f73c05506fd292$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $f1f73c05506fd292$var$updateLayout(node) {
    node.updateLayout();
}
function $f1f73c05506fd292$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $6b4752f129b75902$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $a1243ce774ecc0c8$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($f1f73c05506fd292$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $6b4752f129b75902$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $a1243ce774ecc0c8$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $9ef64ca3aa1da428$export$3d227df54007d73a)();
        (0, $a1243ce774ecc0c8$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $9ef64ca3aa1da428$export$3d227df54007d73a)();
        if (isShared) (0, $a1243ce774ecc0c8$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $a1243ce774ecc0c8$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $27d2975258da9dfa$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $9ef64ca3aa1da428$export$6459fc9e86be362e)();
                    (0, $a1243ce774ecc0c8$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $9ef64ca3aa1da428$export$6459fc9e86be362e)();
                    (0, $a1243ce774ecc0c8$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $27d2975258da9dfa$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $f1f73c05506fd292$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ $f1f73c05506fd292$var$projectionFrameData.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $f1f73c05506fd292$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $f1f73c05506fd292$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $f1f73c05506fd292$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $f1f73c05506fd292$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $f1f73c05506fd292$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $f1f73c05506fd292$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $f1f73c05506fd292$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $f1f73c05506fd292$var$calcProjection(node) {
    node.calcProjection();
}
function $f1f73c05506fd292$var$resetRotation(node) {
    node.resetRotation();
}
function $f1f73c05506fd292$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $f1f73c05506fd292$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $072c4273bd475353$export$2c9e8a9632a706b2)(delta.translate, 0, p);
    output.scale = (0, $072c4273bd475353$export$2c9e8a9632a706b2)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $f1f73c05506fd292$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $072c4273bd475353$export$2c9e8a9632a706b2)(from.min, to.min, p);
    output.max = (0, $072c4273bd475353$export$2c9e8a9632a706b2)(from.max, to.max, p);
}
function $f1f73c05506fd292$export$6ffd3e6ae339a132(output, from, to, p) {
    $f1f73c05506fd292$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $f1f73c05506fd292$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $f1f73c05506fd292$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $f1f73c05506fd292$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $f1f73c05506fd292$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $f1f73c05506fd292$var$roundPoint = $f1f73c05506fd292$var$userAgentContains("applewebkit/") && !$f1f73c05506fd292$var$userAgentContains("chrome/") ? Math.round : (0, $8e8d79bd50b58ce2$export$8793edee2d425525);
function $f1f73c05506fd292$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $f1f73c05506fd292$var$roundPoint(axis.min);
    axis.max = $f1f73c05506fd292$var$roundPoint(axis.max);
}
function $f1f73c05506fd292$var$roundBox(box) {
    $f1f73c05506fd292$var$roundAxis(box.x);
    $f1f73c05506fd292$var$roundAxis(box.y);
}
function $f1f73c05506fd292$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $a1243ce774ecc0c8$export$28d0384c4b79bde2)((0, $27d2975258da9dfa$export$c5706146bc63213)(snapshot), (0, $27d2975258da9dfa$export$c5706146bc63213)(layout), 0.2);
}




const $47d9feaffa8e9285$export$2d029a49a09b6177 = (0, $f1f73c05506fd292$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $5fdcb9c4fda70259$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $56cdc2fb37e90050$export$b91509fcf893b648 = {
    current: undefined
};
const $56cdc2fb37e90050$export$b61a9eb3dbde8858 = (0, $f1f73c05506fd292$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$56cdc2fb37e90050$export$b91509fcf893b648.current) {
            const documentNode = new (0, $47d9feaffa8e9285$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $56cdc2fb37e90050$export$b91509fcf893b648.current = documentNode;
        }
        return $56cdc2fb37e90050$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $8ee2ff021c4b535a$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $1be04a0d843be2d0$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $28c1c17ce2591278$export$5d97dc2872682820),
        ProjectionNode: (0, $56cdc2fb37e90050$export$b61a9eb3dbde8858),
        MeasureLayout: $43797e3e47d3582a$export$779f5fb01ad751cd
    }
};













/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $88185421c2a6ee83$var$splitCSSVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $88185421c2a6ee83$export$b9f0c1f373aee2b0(current) {
    const match = $88185421c2a6ee83$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
}
const $88185421c2a6ee83$var$maxDepth = 4;
function $88185421c2a6ee83$var$getVariableValue(current, element, depth = 1) {
    (0, $3b78c10950e93e60$export$f5708dca728d7177)(depth <= $88185421c2a6ee83$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $88185421c2a6ee83$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $76ebd3c77a70a60b$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    } else if ((0, $6dc47aeeece053cc$export$31f9caa2600b5723)(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return $88185421c2a6ee83$var$getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function $88185421c2a6ee83$export$669319b042b57350(visualElement, { ...target }, transitionEnd) {
    const element = visualElement.current;
    if (!(element instanceof Element)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = {
        ...transitionEnd
    };
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.values.forEach((value)=>{
        const current = value.get();
        if (!(0, $6dc47aeeece053cc$export$31f9caa2600b5723)(current)) return;
        const resolved = $88185421c2a6ee83$var$getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(const key in target){
        const current = target[key];
        if (!(0, $6dc47aeeece053cc$export$31f9caa2600b5723)(current)) continue;
        const resolved = $88185421c2a6ee83$var$getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        if (!transitionEnd) transitionEnd = {};
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd[key] === undefined) transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}









const $5ab420bc9b614b4b$var$positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $5ab420bc9b614b4b$var$isPositionalKey = (key)=>$5ab420bc9b614b4b$var$positionalKeys.has(key);
const $5ab420bc9b614b4b$var$hasPositionalKey = (target)=>{
    return Object.keys(target).some($5ab420bc9b614b4b$var$isPositionalKey);
};
const $5ab420bc9b614b4b$var$isNumOrPxType = (v)=>v === (0, $32a823a43e726818$export$98e628dec113755e) || v === (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008);
const $5ab420bc9b614b4b$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $5ab420bc9b614b4b$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return $5ab420bc9b614b4b$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return $5ab420bc9b614b4b$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $5ab420bc9b614b4b$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $5ab420bc9b614b4b$var$nonTranslationalTransformKeys = (0, $c4e1e7d581f55f0c$export$280dc01950909d86).filter((key)=>!$5ab420bc9b614b4b$var$transformKeys.has(key));
function $5ab420bc9b614b4b$var$removeNonTranslationalTransform(visualElement) {
    const removedTransforms = [];
    $5ab420bc9b614b4b$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.render();
    return removedTransforms;
}
const $5ab420bc9b614b4b$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $5ab420bc9b614b4b$var$getTranslateFromMatrix(4, 13),
    y: $5ab420bc9b614b4b$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$5ab420bc9b614b4b$export$781d46a8aa670d52.translateX = $5ab420bc9b614b4b$export$781d46a8aa670d52.x;
$5ab420bc9b614b4b$export$781d46a8aa670d52.translateY = $5ab420bc9b614b4b$export$781d46a8aa670d52.y;
const $5ab420bc9b614b4b$var$convertChangedValueTypes = (target, visualElement, changedKeys)=>{
    const originBbox = visualElement.measureViewportBox();
    const element = visualElement.current;
    const elementComputedStyle = getComputedStyle(element);
    const { display: display } = elementComputedStyle;
    const origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    /**
     * Record origins before we render and update styles
     */ changedKeys.forEach((key)=>{
        origin[key] = $5ab420bc9b614b4b$export$781d46a8aa670d52[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.render();
    const targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach((key)=>{
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        const value = visualElement.getValue(key);
        value && value.jump(origin[key]);
        target[key] = $5ab420bc9b614b4b$export$781d46a8aa670d52[key](targetBbox, elementComputedStyle);
    });
    return target;
};
const $5ab420bc9b614b4b$var$checkAndConvertChangedValueTypes = (visualElement, target, origin = {}, transitionEnd = {})=>{
    target = {
        ...target
    };
    transitionEnd = {
        ...transitionEnd
    };
    const targetPositionalKeys = Object.keys(target).filter($5ab420bc9b614b4b$var$isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    let removedTransformValues = [];
    let hasAttemptedToRemoveTransformValues = false;
    const changedValueTypeKeys = [];
    targetPositionalKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        let from = origin[key];
        let fromType = (0, $79126bf5a2d16360$export$eefdd52e3ccae428)(from);
        const to = target[key];
        let toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, $1993926d51cc737c$export$9153ad4c4999f4a0)(to)) {
            const numKeyframes = to.length;
            const fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = (0, $79126bf5a2d16360$export$eefdd52e3ccae428)(from);
            for(let i = fromIndex; i < numKeyframes; i++){
                /**
                 * Don't allow wildcard keyframes to be used to detect
                 * a difference in value types.
                 */ if (to[i] === null) break;
                if (!toType) {
                    toType = (0, $79126bf5a2d16360$export$eefdd52e3ccae428)(to[i]);
                    (0, $3b78c10950e93e60$export$f5708dca728d7177)(toType === fromType || $5ab420bc9b614b4b$var$isNumOrPxType(fromType) && $5ab420bc9b614b4b$var$isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
                } else (0, $3b78c10950e93e60$export$f5708dca728d7177)((0, $79126bf5a2d16360$export$eefdd52e3ccae428)(to[i]) === toType, "All keyframes must be of the same type");
            }
        } else toType = (0, $79126bf5a2d16360$export$eefdd52e3ccae428)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if ($5ab420bc9b614b4b$var$isNumOrPxType(fromType) && $5ab420bc9b614b4b$var$isNumOrPxType(toType)) {
                const current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, $32bf3b07842a1e2f$export$91c0eda1d06bf008)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = $5ab420bc9b614b4b$var$removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                value.jump(to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        const scrollY = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
        const convertedTarget = $5ab420bc9b614b4b$var$convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(([key, value])=>{
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.render();
        // Restore scroll position
        if ((0, $e1934d508facd30d$export$4e09c449d6c407f7) && scrollY !== null) window.scrollTo({
            top: scrollY
        });
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function $5ab420bc9b614b4b$export$9e04b0cab841a28(visualElement, target, origin, transitionEnd) {
    return $5ab420bc9b614b4b$var$hasPositionalKey(target) ? $5ab420bc9b614b4b$var$checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}


/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ const $d84724be36f033b6$export$5849e743e29831d6 = (visualElement, target, origin, transitionEnd)=>{
    const resolved = (0, $88185421c2a6ee83$export$669319b042b57350)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, $5ab420bc9b614b4b$export$9e04b0cab841a28)(visualElement, target, origin, transitionEnd);
};






// Does this device prefer reduced motion? Returns `null` server-side.
const $c5f63ea11706c83b$export$ff7706047246b98b = {
    current: null
};
const $c5f63ea11706c83b$export$6476d16e2fd2d0db = {
    current: false
};


function $fad6e4e5ad0cee03$export$ca9f41fb23dded3d() {
    (0, $c5f63ea11706c83b$export$6476d16e2fd2d0db).current = true;
    if (!(0, $e1934d508facd30d$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $c5f63ea11706c83b$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $c5f63ea11706c83b$export$ff7706047246b98b).current = false;
}














function $209adea97db300f6$export$9a552858d5197f6e(element, next, prev) {
    const { willChange: willChange } = next;
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $4ff834aefd3b2e30$export$605d60a2578142d3)(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
            if ((0, $d12c09077e65382c$export$98397f3adbf6259f)(willChange)) willChange.add(key);
        } else if ((0, $4ff834aefd3b2e30$export$605d60a2578142d3)(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $be35e922e4ecba6f$export$ce8bdc721e76545f)(nextValue, {
                owner: element
            }));
            if ((0, $d12c09077e65382c$export$98397f3adbf6259f)(willChange)) willChange.remove(key);
        } else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $be35e922e4ecba6f$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}






const $5570425d605320df$export$bc2a978a17abfdde = new WeakMap();



const $5fe3a51d3a11d9f1$var$featureNames = Object.keys((0, $e6b85364d2a9bfe7$export$65570e08d843624d));
const $5fe3a51d3a11d9f1$var$numFeatures = $5fe3a51d3a11d9f1$var$featureNames.length;
const $5fe3a51d3a11d9f1$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const $5fe3a51d3a11d9f1$var$numVariantProps = (0, $e95939688e97d48b$export$1405a65085f40b9).length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $5fe3a51d3a11d9f1$export$fa8b653c0f3714e5 {
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = ()=>(0, $5368c6a94979c99d$export$2cef06c20297c17d).render(this.render, false, true);
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.isControllingVariants = (0, $d7ec71cb02690a35$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $d7ec71cb02690a35$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {});
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $4ff834aefd3b2e30$export$605d60a2578142d3)(value)) {
                value.set(latestValues[key], false);
                if ((0, $d12c09077e65382c$export$98397f3adbf6259f)(willChange)) willChange.add(key);
            }
        }
    }
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps) {
        return {};
    }
    mount(instance) {
        this.current = instance;
        (0, $5570425d605320df$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $c5f63ea11706c83b$export$6476d16e2fd2d0db).current) (0, $fad6e4e5ad0cee03$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $c5f63ea11706c83b$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $5570425d605320df$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $5368c6a94979c99d$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $5368c6a94979c99d$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features)this.features[key].unmount();
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = (0, $c4e1e7d581f55f0c$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $5368c6a94979c99d$export$2cef06c20297c17d).update(this.notifyUpdate, false, true);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    loadFeatures({ children: children, ...renderedProps }, isStrict, preloadedFeatures, initialLayoutGroupConfig) {
        let ProjectionNodeConstructor;
        let MeasureLayout;
        for(let i = 0; i < $5fe3a51d3a11d9f1$var$numFeatures; i++){
            const name = $5fe3a51d3a11d9f1$var$featureNames[i];
            const { isEnabled: isEnabled, Feature: FeatureConstructor, ProjectionNode: ProjectionNode, MeasureLayout: MeasureLayoutComponent } = (0, $e6b85364d2a9bfe7$export$65570e08d843624d)[name];
            if (ProjectionNode) ProjectionNodeConstructor = ProjectionNode;
            if (isEnabled(renderedProps)) {
                if (!this.features[name] && FeatureConstructor) this.features[name] = new FeatureConstructor(this);
                if (MeasureLayoutComponent) MeasureLayout = MeasureLayoutComponent;
            }
        }
        if ((this.type === "html" || this.type === "svg") && !this.projection && ProjectionNodeConstructor) {
            this.projection = new ProjectionNodeConstructor(this.latestValues, this.parent && this.parent.projection);
            const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = renderedProps;
            this.projection.setOptions({
                layoutId: layoutId,
                layout: layout,
                alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $cddfc7e2c37cb099$export$dedd81df7bc1307)(dragConstraints),
                visualElement: this,
                scheduleRender: ()=>this.scheduleRender(),
                /**
                 * TODO: Update options in an effect. This could be tricky as it'll be too late
                 * to update by the time layout animations run.
                 * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                 * ensuring it gets called if there's no potential layout animations.
                 *
                 */ animationType: typeof layout === "string" ? layout : "both",
                initialPromotionConfig: initialLayoutGroupConfig,
                layoutScroll: layoutScroll,
                layoutRoot: layoutRoot
            });
        }
        return MeasureLayout;
    }
    updateFeatures() {
        for(const key in this.features){
            const feature = this.features[key];
            if (feature.isMounted) feature.update();
            else {
                feature.mount();
                feature.isMounted = true;
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $9ef64ca3aa1da428$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Make a target animatable by Popmotion. For instance, if we're
     * trying to animate width from 100px to 100vw we need to measure 100vw
     * in pixels to determine what we really need to animate to. This is also
     * pluggable to support Framer's custom value types like Color,
     * and CSS variables.
     */ makeTargetAnimatable(target, canMutate = true) {
        return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $5fe3a51d3a11d9f1$var$propEventHandlers.length; i++){
            const key = $5fe3a51d3a11d9f1$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listener = props["on" + key];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $209adea97db300f6$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $5fe3a51d3a11d9f1$var$numVariantProps; i++){
            const name = (0, $e95939688e97d48b$export$1405a65085f40b9)[i];
            const prop = this.props[name];
            if ((0, $b1763de14481003e$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        if (value !== this.values.get(key)) {
            this.removeValue(key);
            this.bindToMotionValue(key, value);
        }
        this.values.set(key, value);
        this.latestValues[key] = value.get();
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $be35e922e4ecba6f$export$ce8bdc721e76545f)(defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key) {
        var _a;
        return this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        const valueFromInitial = typeof initial === "string" || typeof initial === "object" ? (_a = (0, $8c7a89cc6ee14e51$export$d68f140c4d9b48bc)(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key] : undefined;
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $4ff834aefd3b2e30$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $ef011d7b5574c5da$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}


class $c73e91ce66442f0f$export$e49735c2a366bdc7 extends (0, $5fe3a51d3a11d9f1$export$fa8b653c0f3714e5) {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    makeTargetAnimatableFromInstance({ transition: transition, transitionEnd: transitionEnd, ...target }, { transformValues: transformValues }, isMounted) {
        let origin = (0, $f39c71fcd12d36b6$export$5a759dc7a1cfb72a)(target, transition || {}, this);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, $f39c71fcd12d36b6$export$6afbed164019a54c)(this, target, origin);
            const parsed = (0, $d84724be36f033b6$export$5849e743e29831d6)(this, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return {
            transition: transition,
            transitionEnd: transitionEnd,
            ...target
        };
    }
}



function $51bc5e5d6fc243de$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $51bc5e5d6fc243de$export$23fea75b03ac16b3 extends (0, $c73e91ce66442f0f$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
    }
    readValueFromInstance(instance, key) {
        if ((0, $c4e1e7d581f55f0c$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $2a0597ef1be1a26f$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $51bc5e5d6fc243de$export$3735103072e4a80(instance);
            const value = ((0, $6dc47aeeece053cc$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $4e54d82997c38b54$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        (0, $070549112069826c$export$bb517f8b40f8e99d)(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $17c9d9dedc8cbffe$export$16da615486abaa45)(props, prevProps);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $4ff834aefd3b2e30$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $ac940d4a64639ff1$export$1a32bf6229c258c0)(instance, renderState, styleProp, projection);
    }
}












class $19079f989ea11f2e$export$86bcdffbaf733d84 extends (0, $c73e91ce66442f0f$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $c4e1e7d581f55f0c$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $2a0597ef1be1a26f$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $e9c10ab9bb8cc858$export$28931db5d57958e5).has(key) ? (0, $dd392415fdd57598$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return (0, $9ef64ca3aa1da428$export$6459fc9e86be362e)();
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $58f3f67b97df4109$export$16da615486abaa45)(props, prevProps);
    }
    build(renderState, latestValues, options, props) {
        (0, $1f315a6043306c74$export$5475d24f125d7053)(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $28dc81cfe4da704c$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $fd02d19c38cb8508$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $2ed68384d46bf5e0$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $8da896a5df5bb10c$export$88f3fc2fd3766989)(Component) ? new (0, $19079f989ea11f2e$export$86bcdffbaf733d84)(options, {
        enableHardwareAcceleration: false
    }) : new (0, $51bc5e5d6fc243de$export$23fea75b03ac16b3)(options, {
        enableHardwareAcceleration: true
    });
};




const $f2d1729f079fc421$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $56cdc2fb37e90050$export$b61a9eb3dbde8858),
        MeasureLayout: $43797e3e47d3582a$export$779f5fb01ad751cd
    }
};


const $378127958faa4916$var$preloadedFeatures = {
    ...(0, $eb9271000c09ec39$export$7f9953c70dacfd7f),
    ...(0, $a46435c1e154ac53$export$e5b72898e5a201f1),
    ...(0, $8ee2ff021c4b535a$export$d7d5d435647ed5a0),
    ...(0, $f2d1729f079fc421$export$b3219800bda33a1f)
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ const $378127958faa4916$export$e25e478948902b8b = /*@__PURE__*/ (0, $f04fd5bab6629190$export$a28d6df673050e18)((Component, config)=>(0, $ae5406e851d9bb65$export$732916c0e88175fb)(Component, config, $378127958faa4916$var$preloadedFeatures, (0, $2ed68384d46bf5e0$export$56ba0183203348f5)));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $378127958faa4916$export$546614c4a05701f9(key) {
    return (0, $0bb08eeb023bf43d$export$46b7e4b9dc6110c3)((0, $ae5406e851d9bb65$export$732916c0e88175fb)(key, {
        forwardMotionProps: false
    }, $378127958faa4916$var$preloadedFeatures, (0, $2ed68384d46bf5e0$export$56ba0183203348f5)));
}



var $8v0nu = parcelRequire("8v0nu");
"use client";
const $7c8e5060094276a5$export$6486ede9e74d7d9d = (arr, id)=>arr.find((toast)=>toast.id === id);
function $7c8e5060094276a5$export$67080b9d5f0a62ea(toasts, id) {
    const position = $7c8e5060094276a5$export$500f52ac46324ec6(toasts, id);
    const index = position ? toasts[position].findIndex((toast)=>toast.id === id) : -1;
    return {
        position: position,
        index: index
    };
}
function $7c8e5060094276a5$export$500f52ac46324ec6(toasts, id) {
    for (const [position, values] of Object.entries(toasts)){
        if ($7c8e5060094276a5$export$6486ede9e74d7d9d(values, id)) return position;
    }
}
const $7c8e5060094276a5$export$795910f5f15a9633 = (toasts, id)=>!!$7c8e5060094276a5$export$500f52ac46324ec6(toasts, id);
function $7c8e5060094276a5$export$27777812cc6d52de(position) {
    const isRighty = position.includes("right");
    const isLefty = position.includes("left");
    let alignItems = "center";
    if (isRighty) alignItems = "flex-end";
    if (isLefty) alignItems = "flex-start";
    return {
        display: "flex",
        flexDirection: "column",
        alignItems: alignItems
    };
}
function $7c8e5060094276a5$export$55dd410e8ef136e0(position) {
    const isTopOrBottom = position === "top" || position === "bottom";
    const margin = isTopOrBottom ? "0 auto" : void 0;
    const top = position.includes("top") ? "env(safe-area-inset-top, 0px)" : void 0;
    const bottom = position.includes("bottom") ? "env(safe-area-inset-bottom, 0px)" : void 0;
    const right = !position.includes("left") ? "env(safe-area-inset-right, 0px)" : void 0;
    const left = !position.includes("right") ? "env(safe-area-inset-left, 0px)" : void 0;
    return {
        position: "fixed",
        zIndex: "var(--toast-z-index, 5500)",
        pointerEvents: "none",
        display: "flex",
        flexDirection: "column",
        margin: margin,
        top: top,
        bottom: bottom,
        right: right,
        left: left
    };
}



var $3lBLT = parcelRequire("3lBLT");
"use client";
const $3f6a856e4664eca8$var$toastMotionVariants = {
    initial: (props)=>{
        const { position: position } = props;
        const dir = [
            "top",
            "bottom"
        ].includes(position) ? "y" : "x";
        let factor = [
            "top-right",
            "bottom-right"
        ].includes(position) ? 1 : -1;
        if (position === "bottom") factor = 1;
        return {
            opacity: 0,
            [dir]: factor * 24
        };
    },
    animate: {
        opacity: 1,
        y: 0,
        x: 0,
        scale: 1,
        transition: {
            duration: 0.4,
            ease: [
                0.4,
                0,
                0.2,
                1
            ]
        }
    },
    exit: {
        opacity: 0,
        scale: 0.85,
        transition: {
            duration: 0.2,
            ease: [
                0.4,
                0,
                1,
                1
            ]
        }
    }
};
const $3f6a856e4664eca8$export$8743ba3ef25f9582 = (0, $8v0nu.memo)((props)=>{
    const { id: id, message: message, onCloseComplete: onCloseComplete, onRequestRemove: onRequestRemove, requestClose: requestClose = false, position: position = "bottom", duration: duration = 5e3, containerStyle: containerStyle, motionVariants: motionVariants = $3f6a856e4664eca8$var$toastMotionVariants, toastSpacing: toastSpacing = "0.5rem" } = props;
    const [delay, setDelay] = (0, $8v0nu.useState)(duration);
    const isPresent = (0, $178906c13254c0f7$export$8249053f690ea39a)();
    (0, $9fe29ceca799989a$export$496315a1608d9602)(()=>{
        if (!isPresent) onCloseComplete?.();
    }, [
        isPresent
    ]);
    (0, $9fe29ceca799989a$export$496315a1608d9602)(()=>{
        setDelay(duration);
    }, [
        duration
    ]);
    const onMouseEnter = ()=>setDelay(null);
    const onMouseLeave = ()=>setDelay(duration);
    const close = ()=>{
        if (isPresent) onRequestRemove();
    };
    (0, $8v0nu.useEffect)(()=>{
        if (isPresent && requestClose) onRequestRemove();
    }, [
        isPresent,
        requestClose,
        onRequestRemove
    ]);
    (0, $eb487cc9f0b1eb88$export$d8e6abf214c9ec0f)(close, delay);
    const containerStyles = (0, $8v0nu.useMemo)(()=>({
            pointerEvents: "auto",
            maxWidth: 560,
            minWidth: 300,
            margin: toastSpacing,
            ...containerStyle
        }), [
        containerStyle,
        toastSpacing
    ]);
    const toastStyle = (0, $8v0nu.useMemo)(()=>(0, $7c8e5060094276a5$export$27777812cc6d52de)(position), [
        position
    ]);
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $378127958faa4916$export$e25e478948902b8b).div, {
        layout: true,
        className: "chakra-toast",
        variants: motionVariants,
        initial: "initial",
        animate: "animate",
        exit: "exit",
        onHoverStart: onMouseEnter,
        onHoverEnd: onMouseLeave,
        custom: {
            position: position
        },
        style: toastStyle,
        children: /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
            role: "status",
            "aria-atomic": "true",
            className: "chakra-toast__inner",
            __css: containerStyles,
            children: (0, $cSr1Y.runIfFn)(message, {
                id: id,
                onClose: close
            })
        })
    });
});
$3f6a856e4664eca8$export$8743ba3ef25f9582.displayName = "ToastComponent";



var $kxTYF = parcelRequire("kxTYF");

var $kxTYF = parcelRequire("kxTYF");
function $26295883b405048e$export$30a06c8d3562193f(object, keysToOmit = []) {
    const clone = Object.assign({}, object);
    for (const key of keysToOmit)if (key in clone) delete clone[key];
    return clone;
}


function $58ff34c9d17adf03$export$adfcf5a5e4d17785(props) {
    return (0, $26295883b405048e$export$30a06c8d3562193f)(props, [
        "styleConfig",
        "size",
        "variant",
        "colorScheme"
    ]);
}


const $94ee945bf8ea8e46$export$a274e22fb40f762e = (...classNames)=>classNames.filter(Boolean).join(" ");




var $kxTYF = parcelRequire("kxTYF");

var $kxTYF = parcelRequire("kxTYF");


var $8v0nu = parcelRequire("8v0nu");
"use client";
function $5c5c853bf41fd64f$export$257a8862b851cb5b(component) {
    return (0, $8v0nu.forwardRef)(component);
}



var $fZQg5 = parcelRequire("fZQg5");
var $v03Ub = parcelRequire("v03Ub");
var $cSr1Y = parcelRequire("cSr1Y");
function $7379acaa162a1275$var$normalize(value, toArray) {
    if (Array.isArray(value)) return value;
    if ((0, $fZQg5.isObject)(value)) return toArray(value);
    if (value != null) return [
        value
    ];
}
function $7379acaa162a1275$var$getNextIndex(values, i) {
    for(let j = i + 1; j < values.length; j++){
        if (values[j] != null) return j;
    }
    return -1;
}
function $7379acaa162a1275$var$createResolver(theme) {
    const breakpointUtil = theme.__breakpoints;
    return function resolver(config, prop, value, props) {
        if (!breakpointUtil) return;
        const result = {};
        const normalized = $7379acaa162a1275$var$normalize(value, breakpointUtil.toArrayValue);
        if (!normalized) return result;
        const len = normalized.length;
        const isSingle = len === 1;
        const isMultipart = !!config.parts;
        for(let i = 0; i < len; i++){
            const key = breakpointUtil.details[i];
            const nextKey = breakpointUtil.details[$7379acaa162a1275$var$getNextIndex(normalized, i)];
            const query = (0, $a884227448deaae2$export$81f279c16481b446)(key.minW, nextKey?._minW);
            const styles = (0, $cSr1Y.runIfFn)(config[prop]?.[normalized[i]], props);
            if (!styles) continue;
            if (isMultipart) {
                config.parts?.forEach((part)=>{
                    (0, (/*@__PURE__*/$parcel$interopDefault($v03Ub)))(result, {
                        [part]: isSingle ? styles[part] : {
                            [query]: styles[part]
                        }
                    });
                });
                continue;
            }
            if (!isMultipart) {
                if (isSingle) (0, (/*@__PURE__*/$parcel$interopDefault($v03Ub)))(result, styles);
                else result[query] = styles;
                continue;
            }
            result[query] = styles;
        }
        return result;
    };
}
function $7379acaa162a1275$export$f94106bbb00e81eb(config) {
    return (props)=>{
        const { variant: variant, size: size, theme: theme } = props;
        const recipe = $7379acaa162a1275$var$createResolver(theme);
        return (0, (/*@__PURE__*/$parcel$interopDefault($v03Ub)))({}, (0, $cSr1Y.runIfFn)(config.baseStyle ?? {}, props), recipe(config, "sizes", size, props), recipe(config, "variants", variant, props));
    };
}



var $7hYFp = parcelRequire("7hYFp");
var $v03Ub = parcelRequire("v03Ub");

var $8v0nu = parcelRequire("8v0nu");
var $4376394e3d10b334$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $4376394e3d10b334$var$hasElementType = typeof Element !== "undefined";
var $4376394e3d10b334$var$hasMap = typeof Map === "function";
var $4376394e3d10b334$var$hasSet = typeof Set === "function";
var $4376394e3d10b334$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $4376394e3d10b334$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$4376394e3d10b334$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($4376394e3d10b334$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$4376394e3d10b334$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($4376394e3d10b334$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($4376394e3d10b334$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($4376394e3d10b334$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$4376394e3d10b334$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$4376394e3d10b334$exports = function isEqual(a, b) {
    try {
        return $4376394e3d10b334$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};


parcelRequire("6iKRa");
var $FTTp4 = parcelRequire("FTTp4");

var $8v0nu = parcelRequire("8v0nu");
"use client";
function $00627e1df6d22967$export$93d4e7f90805808f() {
    const theme = (0, $8v0nu.useContext)((0, $FTTp4.T));
    if (!theme) throw Error("useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`");
    return theme;
}



var $6jXOD = parcelRequire("6jXOD");
"use client";
function $0023d2f189964130$export$a513a93efd9ab8a7() {
    const colorModeResult = (0, $6jXOD.useColorMode)();
    const theme = (0, $00627e1df6d22967$export$93d4e7f90805808f)();
    return {
        ...colorModeResult,
        theme: theme
    };
}
function $0023d2f189964130$var$getBreakpointValue(theme, value, fallback) {
    if (value == null) return value;
    const getValue = (val)=>theme.__breakpoints?.asArray?.[val];
    return getValue(value) ?? getValue(fallback) ?? fallback;
}
function $0023d2f189964130$var$getTokenValue(theme, value, fallback) {
    if (value == null) return value;
    const getValue = (val)=>theme.__cssMap?.[val]?.value;
    return getValue(value) ?? getValue(fallback) ?? fallback;
}
function $0023d2f189964130$export$31dcd79391e423fe(scale, token, fallback) {
    const theme = (0, $00627e1df6d22967$export$93d4e7f90805808f)();
    return $0023d2f189964130$export$257b2d10b709d8ef(scale, token, fallback)(theme);
}
function $0023d2f189964130$export$257b2d10b709d8ef(scale, token, fallback) {
    const _token = Array.isArray(token) ? token : [
        token
    ];
    const _fallback = Array.isArray(fallback) ? fallback : [
        fallback
    ];
    return (theme)=>{
        const fallbackArr = _fallback.filter(Boolean);
        const result = _token.map((token2, index)=>{
            if (scale === "breakpoints") return $0023d2f189964130$var$getBreakpointValue(theme, token2, fallbackArr[index] ?? token2);
            const path = `${scale}.${token2}`;
            return $0023d2f189964130$var$getTokenValue(theme, path, fallbackArr[index] ?? token2);
        });
        return Array.isArray(token) ? result : result[0];
    };
}


"use client";
function $c7d173d35275482d$var$useStyleConfigImpl(themeKey, props = {}) {
    const { styleConfig: styleConfigProp, ...rest } = props;
    const { theme: theme, colorMode: colorMode } = (0, $0023d2f189964130$export$a513a93efd9ab8a7)();
    const themeStyleConfig = themeKey ? (0, $e9bac7ee162de0e5$export$1bb32d0c65da6059)(theme, `components.${themeKey}`) : void 0;
    const styleConfig = styleConfigProp || themeStyleConfig;
    const mergedProps = (0, (/*@__PURE__*/$parcel$interopDefault($v03Ub)))({
        theme: theme,
        colorMode: colorMode
    }, styleConfig?.defaultProps ?? {}, (0, $7hYFp.compact)((0, $26295883b405048e$export$30a06c8d3562193f)(rest, [
        "children"
    ])), (obj, src)=>!obj ? src : void 0);
    const stylesRef = (0, $8v0nu.useRef)({});
    if (styleConfig) {
        const getStyles = (0, $7379acaa162a1275$export$f94106bbb00e81eb)(styleConfig);
        const styles = getStyles(mergedProps);
        const isStyleEqual = (0, (/*@__PURE__*/$parcel$interopDefault($4376394e3d10b334$exports)))(stylesRef.current, styles);
        if (!isStyleEqual) stylesRef.current = styles;
    }
    return stylesRef.current;
}
function $c7d173d35275482d$export$b863f77547fbcb03(themeKey, props = {}) {
    return $c7d173d35275482d$var$useStyleConfigImpl(themeKey, props);
}
function $c7d173d35275482d$export$31cdfe60c085d76f(themeKey, props = {}) {
    return $c7d173d35275482d$var$useStyleConfigImpl(themeKey, props);
}



var $3lBLT = parcelRequire("3lBLT");
"use client";
const $09b0bffb6a1e43af$var$fallbackIcon = {
    path: /* @__PURE__ */ (0, $kxTYF.jsxs)("g", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        children: [
            /* @__PURE__ */ (0, $kxTYF.jsx)("path", {
                strokeLinecap: "round",
                fill: "none",
                d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
            }),
            /* @__PURE__ */ (0, $kxTYF.jsx)("path", {
                fill: "currentColor",
                strokeLinecap: "round",
                d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
            }),
            /* @__PURE__ */ (0, $kxTYF.jsx)("circle", {
                fill: "none",
                strokeMiterlimit: "10",
                cx: "12",
                cy: "12",
                r: "11.25"
            })
        ]
    }),
    viewBox: "0 0 24 24"
};
const $09b0bffb6a1e43af$export$f04a61298a47a40f = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    const { as: element, viewBox: viewBox, color: color = "currentColor", focusable: focusable = false, children: children, className: className, __css: __css, ...rest } = props;
    const _className = (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-icon", className);
    const customStyles = (0, $c7d173d35275482d$export$b863f77547fbcb03)("Icon", props);
    const styles = {
        w: "1em",
        h: "1em",
        display: "inline-block",
        lineHeight: "1em",
        flexShrink: 0,
        color: color,
        ...__css,
        ...customStyles
    };
    const shared = {
        ref: ref,
        focusable: focusable,
        className: _className,
        __css: styles
    };
    const _viewBox = viewBox ?? $09b0bffb6a1e43af$var$fallbackIcon.viewBox;
    if (element && typeof element !== "string") return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).svg, {
        as: element,
        ...shared,
        ...rest
    });
    const _path = children ?? $09b0bffb6a1e43af$var$fallbackIcon.path;
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).svg, {
        verticalAlign: "middle",
        viewBox: _viewBox,
        ...shared,
        ...rest,
        children: _path
    });
});
$09b0bffb6a1e43af$export$f04a61298a47a40f.displayName = "Icon";


"use client";
function $6f2b79b29f3ed7e0$export$7dd004358974b05d(props) {
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $09b0bffb6a1e43af$export$f04a61298a47a40f), {
        viewBox: "0 0 24 24",
        ...props,
        children: /* @__PURE__ */ (0, $kxTYF.jsx)("path", {
            fill: "currentColor",
            d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
        })
    });
}
function $6f2b79b29f3ed7e0$export$2957fc44b3d2481(props) {
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $09b0bffb6a1e43af$export$f04a61298a47a40f), {
        viewBox: "0 0 24 24",
        ...props,
        children: /* @__PURE__ */ (0, $kxTYF.jsx)("path", {
            fill: "currentColor",
            d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
        })
    });
}
function $6f2b79b29f3ed7e0$export$f7dc499a72baa103(props) {
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $09b0bffb6a1e43af$export$f04a61298a47a40f), {
        viewBox: "0 0 24 24",
        ...props,
        children: /* @__PURE__ */ (0, $kxTYF.jsx)("path", {
            fill: "currentColor",
            d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
        })
    });
}



var $kxTYF = parcelRequire("kxTYF");



var $6iKRa = parcelRequire("6iKRa");



var $3lBLT = parcelRequire("3lBLT");
"use client";
const $4d6bfe65067932d8$var$spin = (0, $6iKRa.keyframes)({
    "0%": {
        transform: "rotate(0deg)"
    },
    "100%": {
        transform: "rotate(360deg)"
    }
});
const $4d6bfe65067932d8$export$7f7cbe89f1eacd2 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $c7d173d35275482d$export$b863f77547fbcb03)("Spinner", props);
    const { label: label = "Loading...", thickness: thickness = "2px", speed: speed = "0.45s", emptyColor: emptyColor = "transparent", className: className, ...rest } = (0, $58ff34c9d17adf03$export$adfcf5a5e4d17785)(props);
    const _className = (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-spinner", className);
    const spinnerStyles = {
        display: "inline-block",
        borderColor: "currentColor",
        borderStyle: "solid",
        borderRadius: "99999px",
        borderWidth: thickness,
        borderBottomColor: emptyColor,
        borderLeftColor: emptyColor,
        animation: `${$4d6bfe65067932d8$var$spin} ${speed} linear infinite`,
        ...styles
    };
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
        ref: ref,
        __css: spinnerStyles,
        className: _className,
        ...rest,
        children: label && /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).span, {
            srOnly: true,
            children: label
        })
    });
});
$4d6bfe65067932d8$export$7f7cbe89f1eacd2.displayName = "Spinner";


"use client";
const [$78728de1f6898875$export$a7901f7b4cce70b0, $78728de1f6898875$export$50b520f08832063d] = (0, $3473b2b1e3b906ba$export$fd42f52fd3ae1109)({
    name: "AlertContext",
    hookName: "useAlertContext",
    providerName: "<Alert />"
});
const [$78728de1f6898875$export$17cf5063e294f385, $78728de1f6898875$export$167ececdbea67592] = (0, $3473b2b1e3b906ba$export$fd42f52fd3ae1109)({
    name: `AlertStylesContext`,
    hookName: `useAlertStyles`,
    providerName: "<Alert />"
});
const $78728de1f6898875$var$STATUSES = {
    info: {
        icon: (0, $6f2b79b29f3ed7e0$export$2957fc44b3d2481),
        colorScheme: "blue"
    },
    warning: {
        icon: (0, $6f2b79b29f3ed7e0$export$f7dc499a72baa103),
        colorScheme: "orange"
    },
    success: {
        icon: (0, $6f2b79b29f3ed7e0$export$7dd004358974b05d),
        colorScheme: "green"
    },
    error: {
        icon: (0, $6f2b79b29f3ed7e0$export$f7dc499a72baa103),
        colorScheme: "red"
    },
    loading: {
        icon: (0, $4d6bfe65067932d8$export$7f7cbe89f1eacd2),
        colorScheme: "blue"
    }
};
function $78728de1f6898875$export$8df8f66d0469c54d(status) {
    return $78728de1f6898875$var$STATUSES[status].colorScheme;
}
function $78728de1f6898875$export$c742923ea4ac4c1c(status) {
    return $78728de1f6898875$var$STATUSES[status].icon;
}





var $3lBLT = parcelRequire("3lBLT");
"use client";
const $98691c64807de5f3$export$caec2af78bcc877f = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function Alert2(props, ref) {
    const { status: status = "info", addRole: addRole = true, ...rest } = (0, $58ff34c9d17adf03$export$adfcf5a5e4d17785)(props);
    const colorScheme = props.colorScheme ?? (0, $78728de1f6898875$export$8df8f66d0469c54d)(status);
    const styles = (0, $c7d173d35275482d$export$31cdfe60c085d76f)("Alert", {
        ...props,
        colorScheme: colorScheme
    });
    const alertStyles = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        width: "100%",
        display: "flex",
        alignItems: "center",
        position: "relative",
        overflow: "hidden",
        ...styles.container
    });
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $78728de1f6898875$export$a7901f7b4cce70b0), {
        value: {
            status: status
        },
        children: /* @__PURE__ */ (0, $kxTYF.jsx)((0, $78728de1f6898875$export$17cf5063e294f385), {
            value: styles,
            children: /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
                "data-status": status,
                role: addRole ? "alert" : void 0,
                ref: ref,
                ...rest,
                className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-alert", props.className),
                __css: alertStyles
            })
        })
    });
});
$98691c64807de5f3$export$caec2af78bcc877f.displayName = "Alert";



var $kxTYF = parcelRequire("kxTYF");



var $3lBLT = parcelRequire("3lBLT");
"use client";
function $5f951a81f6289a1e$export$4a143c8822a09fb4(props) {
    const { status: status } = (0, $78728de1f6898875$export$50b520f08832063d)();
    const BaseIcon = (0, $78728de1f6898875$export$c742923ea4ac4c1c)(status);
    const styles = (0, $78728de1f6898875$export$167ececdbea67592)();
    const css = status === "loading" ? styles.spinner : styles.icon;
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).span, {
        display: "inherit",
        "data-status": status,
        ...props,
        className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-alert__icon", props.className),
        __css: css,
        children: props.children || /* @__PURE__ */ (0, $kxTYF.jsx)(BaseIcon, {
            h: "100%",
            w: "100%"
        })
    });
}
$5f951a81f6289a1e$export$4a143c8822a09fb4.displayName = "AlertIcon";



var $kxTYF = parcelRequire("kxTYF");




var $3lBLT = parcelRequire("3lBLT");
"use client";
const $b0a82382d0cda50b$export$4a7253439a300753 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function AlertTitle2(props, ref) {
    const styles = (0, $78728de1f6898875$export$167ececdbea67592)();
    const { status: status } = (0, $78728de1f6898875$export$50b520f08832063d)();
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
        ref: ref,
        "data-status": status,
        ...props,
        className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-alert__title", props.className),
        __css: styles.title
    });
});
$b0a82382d0cda50b$export$4a7253439a300753.displayName = "AlertTitle";



var $kxTYF = parcelRequire("kxTYF");





var $3lBLT = parcelRequire("3lBLT");
"use client";
const $e45388a2580a4b51$export$d4feae172fccda11 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function AlertDescription2(props, ref) {
    const { status: status } = (0, $78728de1f6898875$export$50b520f08832063d)();
    const styles = (0, $78728de1f6898875$export$167ececdbea67592)();
    const descriptionStyles = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        display: "inline",
        ...styles.description
    });
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
        ref: ref,
        "data-status": status,
        ...props,
        className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-alert__desc", props.className),
        __css: descriptionStyles
    });
});
$e45388a2580a4b51$export$d4feae172fccda11.displayName = "AlertDescription";



var $kxTYF = parcelRequire("kxTYF");





var $3lBLT = parcelRequire("3lBLT");
"use client";
function $2e7b525ea2280ded$var$CloseIcon(props) {
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $09b0bffb6a1e43af$export$f04a61298a47a40f), {
        focusable: "false",
        "aria-hidden": true,
        ...props,
        children: /* @__PURE__ */ (0, $kxTYF.jsx)("path", {
            fill: "currentColor",
            d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
        })
    });
}
const $2e7b525ea2280ded$export$de65de8213222d10 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function CloseButton2(props, ref) {
    const styles = (0, $c7d173d35275482d$export$b863f77547fbcb03)("CloseButton", props);
    const { children: children, isDisabled: isDisabled, __css: __css, ...rest } = (0, $58ff34c9d17adf03$export$adfcf5a5e4d17785)(props);
    const baseStyle = {
        outline: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0
    };
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).button, {
        type: "button",
        "aria-label": "Close",
        ref: ref,
        disabled: isDisabled,
        __css: {
            ...baseStyle,
            ...styles,
            ...__css
        },
        ...rest,
        children: children || /* @__PURE__ */ (0, $kxTYF.jsx)($2e7b525ea2280ded$var$CloseIcon, {
            width: "1em",
            height: "1em"
        })
    });
});
$2e7b525ea2280ded$export$de65de8213222d10.displayName = "CloseButton";



var $3lBLT = parcelRequire("3lBLT");
"use client";
const $2e391be1c055dce0$export$8d8dc7d5f743331b = (props)=>{
    const { status: status, variant: variant = "solid", id: id, title: title, isClosable: isClosable, onClose: onClose, description: description, colorScheme: colorScheme, icon: icon } = props;
    const ids = id ? {
        root: `toast-${id}`,
        title: `toast-${id}-title`,
        description: `toast-${id}-description`
    } : void 0;
    return /* @__PURE__ */ (0, $kxTYF.jsxs)((0, $98691c64807de5f3$export$caec2af78bcc877f), {
        addRole: false,
        status: status,
        variant: variant,
        id: ids?.root,
        alignItems: "start",
        borderRadius: "md",
        boxShadow: "lg",
        paddingEnd: 8,
        textAlign: "start",
        width: "auto",
        colorScheme: colorScheme,
        children: [
            /* @__PURE__ */ (0, $kxTYF.jsx)((0, $5f951a81f6289a1e$export$4a143c8822a09fb4), {
                children: icon
            }),
            /* @__PURE__ */ (0, $kxTYF.jsxs)((0, $3lBLT.chakra).div, {
                flex: "1",
                maxWidth: "100%",
                children: [
                    title && /* @__PURE__ */ (0, $kxTYF.jsx)((0, $b0a82382d0cda50b$export$4a7253439a300753), {
                        id: ids?.title,
                        children: title
                    }),
                    description && /* @__PURE__ */ (0, $kxTYF.jsx)((0, $e45388a2580a4b51$export$d4feae172fccda11), {
                        id: ids?.description,
                        display: "block",
                        children: description
                    })
                ]
            }),
            isClosable && /* @__PURE__ */ (0, $kxTYF.jsx)((0, $2e7b525ea2280ded$export$de65de8213222d10), {
                size: "sm",
                onClick: onClose,
                position: "absolute",
                insetEnd: 1,
                top: 1
            })
        ]
    });
};
function $2e391be1c055dce0$export$d9d796c483697359(options = {}) {
    const { render: render, toastComponent: ToastComponent = $2e391be1c055dce0$export$8d8dc7d5f743331b } = options;
    const renderToast = (props)=>{
        if (typeof render === "function") return render({
            ...props,
            ...options
        });
        return /* @__PURE__ */ (0, $kxTYF.jsx)(ToastComponent, {
            ...props,
            ...options
        });
    };
    return renderToast;
}



"use client";
const $3f045d9ec09af1a6$var$initialState = {
    top: [],
    "top-left": [],
    "top-right": [],
    "bottom-left": [],
    bottom: [],
    "bottom-right": []
};
const $3f045d9ec09af1a6$export$e80fa18a42ed98ef = $3f045d9ec09af1a6$var$createStore($3f045d9ec09af1a6$var$initialState);
function $3f045d9ec09af1a6$var$createStore(initialState2) {
    let state = initialState2;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (setStateFn)=>{
        state = setStateFn(state);
        listeners.forEach((l)=>l());
    };
    return {
        getState: ()=>state,
        subscribe: (listener)=>{
            listeners.add(listener);
            return ()=>{
                setState(()=>initialState2);
                listeners.delete(listener);
            };
        },
        /**
     * Delete a toast record at its position
     */ removeToast: (id, position)=>{
            setState((prevState)=>({
                    ...prevState,
                    // id may be string or number
                    // eslint-disable-next-line eqeqeq
                    [position]: prevState[position].filter((toast)=>toast.id != id)
                }));
        },
        notify: (message, options)=>{
            const toast = $3f045d9ec09af1a6$var$createToast(message, options);
            const { position: position, id: id } = toast;
            setState((prevToasts)=>{
                const isTop = position.includes("top");
                const toasts = isTop ? [
                    toast,
                    ...prevToasts[position] ?? []
                ] : [
                    ...prevToasts[position] ?? [],
                    toast
                ];
                return {
                    ...prevToasts,
                    [position]: toasts
                };
            });
            return id;
        },
        update: (id, options)=>{
            if (!id) return;
            setState((prevState)=>{
                const nextState = {
                    ...prevState
                };
                const { position: position, index: index } = (0, $7c8e5060094276a5$export$67080b9d5f0a62ea)(nextState, id);
                if (position && index !== -1) nextState[position][index] = {
                    ...nextState[position][index],
                    ...options,
                    message: (0, $2e391be1c055dce0$export$d9d796c483697359)(options)
                };
                return nextState;
            });
        },
        closeAll: ({ positions: positions } = {})=>{
            setState((prev)=>{
                const allPositions = [
                    "bottom",
                    "bottom-right",
                    "bottom-left",
                    "top",
                    "top-left",
                    "top-right"
                ];
                const positionsToClose = positions ?? allPositions;
                return positionsToClose.reduce((acc, position)=>{
                    acc[position] = prev[position].map((toast)=>({
                            ...toast,
                            requestClose: true
                        }));
                    return acc;
                }, {
                    ...prev
                });
            });
        },
        close: (id)=>{
            setState((prevState)=>{
                const position = (0, $7c8e5060094276a5$export$500f52ac46324ec6)(prevState, id);
                if (!position) return prevState;
                return {
                    ...prevState,
                    [position]: prevState[position].map((toast)=>{
                        if (toast.id == id) return {
                            ...toast,
                            requestClose: true
                        };
                        return toast;
                    })
                };
            });
        },
        isActive: (id)=>Boolean((0, $7c8e5060094276a5$export$67080b9d5f0a62ea)($3f045d9ec09af1a6$export$e80fa18a42ed98ef.getState(), id).position)
    };
}
let $3f045d9ec09af1a6$var$counter = 0;
function $3f045d9ec09af1a6$var$createToast(message, options = {}) {
    $3f045d9ec09af1a6$var$counter += 1;
    const id = options.id ?? $3f045d9ec09af1a6$var$counter;
    const position = options.position ?? "bottom";
    return {
        id: id,
        message: message,
        position: position,
        duration: options.duration,
        onCloseComplete: options.onCloseComplete,
        onRequestRemove: ()=>$3f045d9ec09af1a6$export$e80fa18a42ed98ef.removeToast(String(id), position),
        status: options.status,
        requestClose: false,
        containerStyle: options.containerStyle
    };
}




var $kxTYF = parcelRequire("kxTYF");



var $8v0nu = parcelRequire("8v0nu");


"use client";
const [$3ceaac588a2e3fcb$var$PortalContextProvider, $3ceaac588a2e3fcb$var$usePortalContext] = (0, $3473b2b1e3b906ba$export$fd42f52fd3ae1109)({
    strict: false,
    name: "PortalContext"
});
const $3ceaac588a2e3fcb$var$PORTAL_CLASSNAME = "chakra-portal";
const $3ceaac588a2e3fcb$var$PORTAL_SELECTOR = `.chakra-portal`;
const $3ceaac588a2e3fcb$var$Container = (props)=>/* @__PURE__ */ (0, $kxTYF.jsx)("div", {
        className: "chakra-portal-zIndex",
        style: {
            position: "absolute",
            zIndex: props.zIndex,
            top: 0,
            left: 0,
            right: 0
        },
        children: props.children
    });
const $3ceaac588a2e3fcb$var$DefaultPortal = (props)=>{
    const { appendToParentPortal: appendToParentPortal, children: children } = props;
    const [tempNode, setTempNode] = (0, $8v0nu.useState)(null);
    const portal = (0, $8v0nu.useRef)(null);
    const [, forceUpdate] = (0, $8v0nu.useState)({});
    (0, $8v0nu.useEffect)(()=>forceUpdate({}), []);
    const parentPortal = $3ceaac588a2e3fcb$var$usePortalContext();
    const manager = (0, $94c10bfe68b0b4de$export$ef203b29c2cc1f5d)();
    (0, $456f92579f2f647e$export$deebe11a338de063)(()=>{
        if (!tempNode) return;
        const doc = tempNode.ownerDocument;
        const host = appendToParentPortal ? parentPortal ?? doc.body : doc.body;
        if (!host) return;
        portal.current = doc.createElement("div");
        portal.current.className = $3ceaac588a2e3fcb$var$PORTAL_CLASSNAME;
        host.appendChild(portal.current);
        forceUpdate({});
        const portalNode = portal.current;
        return ()=>{
            if (host.contains(portalNode)) host.removeChild(portalNode);
        };
    }, [
        tempNode
    ]);
    const _children = manager?.zIndex ? /* @__PURE__ */ (0, $kxTYF.jsx)($3ceaac588a2e3fcb$var$Container, {
        zIndex: manager?.zIndex,
        children: children
    }) : children;
    return portal.current ? (0, $e95e39c2a873bfa2$exports.createPortal)(/* @__PURE__ */ (0, $kxTYF.jsx)($3ceaac588a2e3fcb$var$PortalContextProvider, {
        value: portal.current,
        children: _children
    }), portal.current) : /* @__PURE__ */ (0, $kxTYF.jsx)("span", {
        ref: (el)=>{
            if (el) setTempNode(el);
        }
    });
};
const $3ceaac588a2e3fcb$var$ContainerPortal = (props)=>{
    const { children: children, containerRef: containerRef, appendToParentPortal: appendToParentPortal } = props;
    const containerEl = containerRef.current;
    const host = containerEl ?? (typeof window !== "undefined" ? document.body : void 0);
    const portal = (0, $8v0nu.useMemo)(()=>{
        const node = containerEl?.ownerDocument.createElement("div");
        if (node) node.className = $3ceaac588a2e3fcb$var$PORTAL_CLASSNAME;
        return node;
    }, [
        containerEl
    ]);
    const [, forceUpdate] = (0, $8v0nu.useState)({});
    (0, $456f92579f2f647e$export$deebe11a338de063)(()=>forceUpdate({}), []);
    (0, $456f92579f2f647e$export$deebe11a338de063)(()=>{
        if (!portal || !host) return;
        host.appendChild(portal);
        return ()=>{
            host.removeChild(portal);
        };
    }, [
        portal,
        host
    ]);
    if (host && portal) return (0, $e95e39c2a873bfa2$exports.createPortal)(/* @__PURE__ */ (0, $kxTYF.jsx)($3ceaac588a2e3fcb$var$PortalContextProvider, {
        value: appendToParentPortal ? portal : null,
        children: children
    }), portal);
    return null;
};
function $3ceaac588a2e3fcb$export$602eac185826482c(props) {
    const portalProps = {
        appendToParentPortal: true,
        ...props
    };
    const { containerRef: containerRef, ...rest } = portalProps;
    return containerRef ? /* @__PURE__ */ (0, $kxTYF.jsx)($3ceaac588a2e3fcb$var$ContainerPortal, {
        containerRef: containerRef,
        ...rest
    }) : /* @__PURE__ */ (0, $kxTYF.jsx)($3ceaac588a2e3fcb$var$DefaultPortal, {
        ...rest
    });
}
$3ceaac588a2e3fcb$export$602eac185826482c.className = $3ceaac588a2e3fcb$var$PORTAL_CLASSNAME;
$3ceaac588a2e3fcb$export$602eac185826482c.selector = $3ceaac588a2e3fcb$var$PORTAL_SELECTOR;
$3ceaac588a2e3fcb$export$602eac185826482c.displayName = "Portal";


"use client";
const [$2a35b1f793a340fa$export$cfcc07abbe2e36a8, $2a35b1f793a340fa$export$7c4af276256dc908] = (0, $3473b2b1e3b906ba$export$fd42f52fd3ae1109)({
    name: `ToastOptionsContext`,
    strict: false
});
const $2a35b1f793a340fa$export$f5d03d415824e0e = (props)=>{
    const state = (0, $8v0nu.useSyncExternalStore)((0, $3f045d9ec09af1a6$export$e80fa18a42ed98ef).subscribe, (0, $3f045d9ec09af1a6$export$e80fa18a42ed98ef).getState, (0, $3f045d9ec09af1a6$export$e80fa18a42ed98ef).getState);
    const { motionVariants: motionVariants, component: Component = (0, $3f6a856e4664eca8$export$8743ba3ef25f9582), portalProps: portalProps, animatePresenceProps: animatePresenceProps } = props;
    const stateKeys = Object.keys(state);
    const toastList = stateKeys.map((position)=>{
        const toasts = state[position];
        return /* @__PURE__ */ (0, $kxTYF.jsx)("div", {
            role: "region",
            "aria-live": "polite",
            "aria-label": `Notifications-${position}`,
            id: `chakra-toast-manager-${position}`,
            style: (0, $7c8e5060094276a5$export$55dd410e8ef136e0)(position),
            children: /* @__PURE__ */ (0, $kxTYF.jsx)((0, $f1f51be609a91d37$export$3ae376d12526dd6f), {
                ...animatePresenceProps,
                initial: false,
                children: toasts.map((toast)=>/* @__PURE__ */ (0, $kxTYF.jsx)(Component, {
                        motionVariants: motionVariants,
                        ...toast
                    }, toast.id))
            })
        }, position);
    });
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3ceaac588a2e3fcb$export$602eac185826482c), {
        ...portalProps,
        children: toastList
    });
};


"use client";
const $16d29f50de85e868$export$500fbc0cd14cdbaa = (providerTheme)=>{
    return function ChakraProvider({ children: children, theme: theme = providerTheme, toastOptions: toastOptions, ...restProps }) {
        return /* @__PURE__ */ (0, $kxTYF.jsxs)((0, $d6e500ffd5d1beeb$export$2881499e37b75b9a), {
            theme: theme,
            ...restProps,
            children: [
                /* @__PURE__ */ (0, $kxTYF.jsx)((0, $2a35b1f793a340fa$export$cfcc07abbe2e36a8), {
                    value: toastOptions?.defaultOptions,
                    children: children
                }),
                /* @__PURE__ */ (0, $kxTYF.jsx)((0, $2a35b1f793a340fa$export$f5d03d415824e0e), {
                    ...toastOptions
                })
            ]
        });
    };
};


"use client";
const $8cf81b0fc725af40$export$80dbe0482bcbd25a = (0, $16d29f50de85e868$export$500fbc0cd14cdbaa)((0, $9336ec4b7857882b$export$bca14c5b3b88a9c9));


var $kxTYF = parcelRequire("kxTYF");
"use client";
const $e573fadeff6283fe$var$VALID_VALUES = /* @__PURE__ */ new Set([
    "dark",
    "light",
    "system"
]);
function $e573fadeff6283fe$var$normalize(initialColorMode) {
    let value = initialColorMode;
    if (!$e573fadeff6283fe$var$VALID_VALUES.has(value)) value = "light";
    return value;
}
function $e573fadeff6283fe$export$9d3c6b7e0351f78c(props = {}) {
    const { initialColorMode: initialColorMode = "light", type: type = "localStorage", storageKey: key = "chakra-ui-color-mode" } = props;
    const init = $e573fadeff6283fe$var$normalize(initialColorMode);
    const isCookie = type === "cookie";
    const cookieScript = `(function(){try{var a=function(o){var l="(prefers-color-scheme: dark)",v=window.matchMedia(l).matches?"dark":"light",e=o==="system"?v:o,d=document.documentElement,m=document.body,i="chakra-ui-light",n="chakra-ui-dark",s=e==="dark";return m.classList.add(s?n:i),m.classList.remove(s?i:n),d.style.colorScheme=e,d.dataset.theme=e,e},u=a,h="${init}",r="${key}",t=document.cookie.match(new RegExp("(^| )".concat(r,"=([^;]+)"))),c=t?t[2]:null;c?a(c):document.cookie="".concat(r,"=").concat(a(h),"; max-age=31536000; path=/")}catch(a){}})();
  `;
    const localStorageScript = `(function(){try{var a=function(c){var v="(prefers-color-scheme: dark)",h=window.matchMedia(v).matches?"dark":"light",r=c==="system"?h:c,o=document.documentElement,s=document.body,l="chakra-ui-light",d="chakra-ui-dark",i=r==="dark";return s.classList.add(i?d:l),s.classList.remove(i?l:d),o.style.colorScheme=r,o.dataset.theme=r,r},n=a,m="${init}",e="${key}",t=localStorage.getItem(e);t?a(t):localStorage.setItem(e,a(m))}catch(a){}})();
  `;
    const fn = isCookie ? cookieScript : localStorageScript;
    return `!${fn}`.trim();
}
function $e573fadeff6283fe$export$7730ada0bba3cb70(props = {}) {
    const { nonce: nonce } = props;
    return /* @__PURE__ */ (0, $kxTYF.jsx)("script", {
        id: "chakra-script",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: $e573fadeff6283fe$export$9d3c6b7e0351f78c(props)
        }
    });
}



var $8v0nu = parcelRequire("8v0nu");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $eba44fb2c963ffed$var$__assign = function() {
    $eba44fb2c963ffed$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $eba44fb2c963ffed$var$__assign.apply(this, arguments);
};
function $eba44fb2c963ffed$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $eba44fb2c963ffed$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $eba44fb2c963ffed$var$__generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $eba44fb2c963ffed$var$debounce = function(fn, ms) {
    if (ms === void 0) ms = 250;
    var timeoutId;
    return function() {
        var _this = this;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function() {
            return fn.apply(_this, args);
        }, ms);
    };
};
var $eba44fb2c963ffed$var$SearchMode;
(function(SearchMode) {
    SearchMode["GET"] = "GET";
    SearchMode["POST"] = "POST";
})($eba44fb2c963ffed$var$SearchMode || ($eba44fb2c963ffed$var$SearchMode = {}));
var $eba44fb2c963ffed$var$StacApi = /** @class */ function() {
    function StacApi(baseUrl, searchMode, options) {
        this.searchMode = $eba44fb2c963ffed$var$SearchMode.GET;
        this.baseUrl = baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;
        this.searchMode = searchMode;
        this.options = options;
    }
    StacApi.prototype.fixBboxCoordinateOrder = function(bbox) {
        if (!bbox) return undefined;
        var lonMin = bbox[0], latMin = bbox[1], lonMax = bbox[2], latMax = bbox[3];
        var sortedBbox = [
            lonMin,
            latMin,
            lonMax,
            latMax
        ];
        if (lonMin > lonMax) {
            sortedBbox[0] = lonMax;
            sortedBbox[2] = lonMin;
        }
        if (latMin > latMax) {
            sortedBbox[1] = latMax;
            sortedBbox[3] = latMin;
        }
        return sortedBbox;
    };
    StacApi.prototype.makeArrayPayload = function(arr) {
        return (arr === null || arr === void 0 ? void 0 : arr.length) ? arr : undefined;
    };
    StacApi.prototype.makeDatetimePayload = function(dateRange) {
        if (!dateRange) return undefined;
        var from = dateRange.from, to = dateRange.to;
        if (from || to) return "".concat(from || "..", "/").concat(to || "..");
        else return undefined;
    };
    StacApi.prototype.payloadToQuery = function(_a) {
        var sortby = _a.sortby, payload = $eba44fb2c963ffed$var$__rest(_a, [
            "sortby"
        ]);
        var queryObj = {};
        for(var _i = 0, _b = Object.entries(payload); _i < _b.length; _i++){
            var _c = _b[_i], key = _c[0], value = _c[1];
            if (!value) continue;
            if (Array.isArray(value)) queryObj[key] = value.join(",");
            else queryObj[key] = value;
        }
        if (sortby) queryObj["sortby"] = sortby.map(function(_a) {
            var field = _a.field, direction = _a.direction;
            return "".concat(direction === "asc" ? "+" : "-").concat(field);
        }).join(",");
        return new URLSearchParams(queryObj).toString();
    };
    StacApi.prototype.handleError = function(response) {
        return $eba44fb2c963ffed$var$__awaiter(this, void 0, void 0, function() {
            var status, statusText, e, clone, _a, _b;
            return $eba44fb2c963ffed$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        status = response.status, statusText = response.statusText;
                        e = {
                            status: status,
                            statusText: statusText
                        };
                        clone = response.clone();
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            ,
                            5
                        ]);
                        _a = e;
                        return [
                            4 /*yield*/ ,
                            response.json()
                        ];
                    case 2:
                        _a.detail = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        _c.sent();
                        _b = e;
                        return [
                            4 /*yield*/ ,
                            clone.text()
                        ];
                    case 4:
                        _b.detail = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            Promise.reject(e)
                        ];
                }
            });
        });
    };
    StacApi.prototype.fetch = function(url, options) {
        var _this = this;
        var _a;
        if (options === void 0) options = {};
        var _b = options.method, method = _b === void 0 ? "GET" : _b, payload = options.payload, _c = options.headers, headers = _c === void 0 ? {} : _c;
        return fetch(url, {
            method: method,
            headers: $eba44fb2c963ffed$var$__assign($eba44fb2c963ffed$var$__assign({
                "Content-Type": "application/json"
            }, headers), (_a = this.options) === null || _a === void 0 ? void 0 : _a.headers),
            body: payload ? JSON.stringify(payload) : undefined
        }).then(function(response) {
            return $eba44fb2c963ffed$var$__awaiter(_this, void 0, void 0, function() {
                return $eba44fb2c963ffed$var$__generator(this, function(_a) {
                    if (response.ok) return [
                        2 /*return*/ ,
                        response
                    ];
                    return [
                        2 /*return*/ ,
                        this.handleError(response)
                    ];
                });
            });
        });
    };
    StacApi.prototype.search = function(payload, headers) {
        if (headers === void 0) headers = {};
        var ids = payload.ids, bbox = payload.bbox, dateRange = payload.dateRange, collections = payload.collections, restPayload = $eba44fb2c963ffed$var$__rest(payload, [
            "ids",
            "bbox",
            "dateRange",
            "collections"
        ]);
        var requestPayload = $eba44fb2c963ffed$var$__assign($eba44fb2c963ffed$var$__assign({}, restPayload), {
            ids: this.makeArrayPayload(ids),
            collections: this.makeArrayPayload(collections),
            bbox: this.fixBboxCoordinateOrder(bbox),
            datetime: this.makeDatetimePayload(dateRange)
        });
        if (this.searchMode === "POST") return this.fetch("".concat(this.baseUrl, "/search"), {
            method: "POST",
            payload: requestPayload,
            headers: headers
        });
        else {
            var query = this.payloadToQuery(requestPayload);
            return this.fetch("".concat(this.baseUrl, "/search?").concat(query), {
                method: "GET",
                headers: headers
            });
        }
    };
    StacApi.prototype.getCollections = function() {
        return this.fetch("".concat(this.baseUrl, "/collections"));
    };
    StacApi.prototype.get = function(href, headers) {
        if (headers === void 0) headers = {};
        return this.fetch(href, {
            headers: headers
        });
    };
    return StacApi;
}();
function $eba44fb2c963ffed$export$d5f91e9964fa0ed1(url, options) {
    var _a = (0, $8v0nu.useState)(), stacApi = _a[0], setStacApi = _a[1];
    (0, $8v0nu.useEffect)(function() {
        var baseUrl;
        var searchMode = $eba44fb2c963ffed$var$SearchMode.GET;
        fetch(url, {
            headers: $eba44fb2c963ffed$var$__assign({
                "Content-Type": "application/json"
            }, options === null || options === void 0 ? void 0 : options.headers)
        }).then(function(response) {
            baseUrl = response.url;
            return response;
        }).then(function(response) {
            return response.json();
        }).then(function(response) {
            var doesPost = response.links.find(function(_a) {
                var rel = _a.rel, method = _a.method;
                return rel === "search" && method === "POST";
            });
            if (doesPost) searchMode = $eba44fb2c963ffed$var$SearchMode.POST;
        }).then(function() {
            return setStacApi(new $eba44fb2c963ffed$var$StacApi(baseUrl, searchMode, options));
        });
    }, [
        url,
        options
    ]);
    return {
        stacApi: stacApi
    };
}
var $eba44fb2c963ffed$var$StacApiContext = (0, $8v0nu.createContext)({});
function $eba44fb2c963ffed$export$dc253927969915ae(_a) {
    var children = _a.children, apiUrl = _a.apiUrl, options = _a.options;
    var stacApi = $eba44fb2c963ffed$export$d5f91e9964fa0ed1(apiUrl, options).stacApi;
    var _b = (0, $8v0nu.useState)(), collections = _b[0], setCollections = _b[1];
    var _c = (0, $8v0nu.useState)(new Map()), items = _c[0], setItems = _c[1];
    var getItem = (0, $8v0nu.useCallback)(function(id) {
        return items.get(id);
    }, [
        items
    ]);
    var addItem = (0, $8v0nu.useCallback)(function(itemPath, item) {
        setItems(new Map(items.set(itemPath, item)));
    }, [
        items
    ]);
    var deleteItem = (0, $8v0nu.useCallback)(function(itemPath) {
        var tempItems = new Map(items);
        items.delete(itemPath);
        setItems(tempItems);
    }, [
        items
    ]);
    var contextValue = (0, $8v0nu.useMemo)(function() {
        return {
            stacApi: stacApi,
            collections: collections,
            setCollections: setCollections,
            getItem: getItem,
            addItem: addItem,
            deleteItem: deleteItem
        };
    }, [
        addItem,
        collections,
        deleteItem,
        getItem,
        stacApi
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).createElement($eba44fb2c963ffed$var$StacApiContext.Provider, {
        value: contextValue
    }, children);
}
function $eba44fb2c963ffed$var$useStacApiContext() {
    var _a = (0, $8v0nu.useContext)($eba44fb2c963ffed$var$StacApiContext), stacApi = _a.stacApi, collections = _a.collections, setCollections = _a.setCollections, getItem = _a.getItem, addItem = _a.addItem, deleteItem = _a.deleteItem;
    return {
        stacApi: stacApi,
        collections: collections,
        setCollections: setCollections,
        getItem: getItem,
        addItem: addItem,
        deleteItem: deleteItem
    };
}
function $eba44fb2c963ffed$export$47c1284bb8faa96() {
    var stacApi = $eba44fb2c963ffed$var$useStacApiContext().stacApi;
    var _a = (0, $8v0nu.useState)(), results = _a[0], setResults = _a[1];
    var _b = (0, $8v0nu.useState)(), ids = _b[0], setIds = _b[1];
    var _c = (0, $8v0nu.useState)(), bbox = _c[0], setBbox = _c[1];
    var _d = (0, $8v0nu.useState)(), collections = _d[0], setCollections = _d[1];
    var _e = (0, $8v0nu.useState)(""), dateRangeFrom = _e[0], setDateRangeFrom = _e[1];
    var _f = (0, $8v0nu.useState)(""), dateRangeTo = _f[0], setDateRangeTo = _f[1];
    var _g = (0, $8v0nu.useState)(25), limit = _g[0], setLimit = _g[1];
    var _h = (0, $8v0nu.useState)(), sortby = _h[0], setSortby = _h[1];
    var _j = (0, $8v0nu.useState)("IDLE"), state = _j[0], setState = _j[1];
    var _k = (0, $8v0nu.useState)(), error = _k[0], setError = _k[1];
    var _l = (0, $8v0nu.useState)(), nextPageConfig = _l[0], setNextPageConfig = _l[1];
    var _m = (0, $8v0nu.useState)(), previousPageConfig = _m[0], setPreviousPageConfig = _m[1];
    var reset = function() {
        setResults(undefined);
        setBbox(undefined);
        setCollections(undefined);
        setIds(undefined);
        setDateRangeFrom("");
        setDateRangeTo("");
        setSortby(undefined);
        setLimit(25);
    };
    /**
     * Reset state when stacApi changes
     */ (0, $8v0nu.useEffect)(reset, [
        stacApi
    ]);
    /**
     * Extracts the pagination config from the the links array of the items response
     */ var setPaginationConfig = (0, $8v0nu.useCallback)(function(links) {
        setNextPageConfig(links.find(function(_a) {
            var rel = _a.rel;
            return rel === "next";
        }));
        setPreviousPageConfig(links.find(function(_a) {
            var rel = _a.rel;
            return [
                "prev",
                "previous"
            ].includes(rel);
        }));
    }, []);
    /**
     * Returns the search payload based on the current application state
     */ var getSearchPayload = (0, $8v0nu.useCallback)(function() {
        return {
            ids: ids,
            bbox: bbox,
            collections: collections,
            dateRange: {
                from: dateRangeFrom,
                to: dateRangeTo
            },
            sortby: sortby,
            limit: limit
        };
    }, [
        ids,
        bbox,
        collections,
        dateRangeFrom,
        dateRangeTo,
        sortby,
        limit
    ]);
    /**
     * Resets the state and processes the results from the provided request
     */ var processRequest = (0, $8v0nu.useCallback)(function(request) {
        setResults(undefined);
        setState("LOADING");
        setError(undefined);
        setNextPageConfig(undefined);
        setPreviousPageConfig(undefined);
        request.then(function(response) {
            return response.json();
        }).then(function(data) {
            setResults(data);
            if (data.links) setPaginationConfig(data.links);
        }).catch(function(err) {
            return setError(err);
        }).finally(function() {
            return setState("IDLE");
        });
    }, [
        setPaginationConfig
    ]);
    /**
     * Executes a POST request against the `search` endpoint using the provided payload and headers
     */ var executeSearch = (0, $8v0nu.useCallback)(function(payload, headers) {
        if (headers === void 0) headers = {};
        return stacApi && processRequest(stacApi.search(payload, headers));
    }, [
        stacApi,
        processRequest
    ]);
    /**
     * Execute a GET request against the provided URL
     */ var getItems = (0, $8v0nu.useCallback)(function(url) {
        return stacApi && processRequest(stacApi.get(url));
    }, [
        stacApi,
        processRequest
    ]);
    /**
     * Retreives a page from a paginatied item set using the provided link config.
     * Executes a POST request against the `search` endpoint if pagination uses POST
     * or retrieves the page items using GET against the link href
     */ var flipPage = (0, $8v0nu.useCallback)(function(link) {
        if (link) {
            var payload = link.body;
            if (payload) {
                if (payload.merge) payload = $eba44fb2c963ffed$var$__assign($eba44fb2c963ffed$var$__assign({}, payload), getSearchPayload());
                executeSearch(payload, link.headers);
            } else getItems(link.href);
        }
    }, [
        executeSearch,
        getItems,
        getSearchPayload
    ]);
    var nextPageFn = (0, $8v0nu.useCallback)(function() {
        return flipPage(nextPageConfig);
    }, [
        flipPage,
        nextPageConfig
    ]);
    var previousPageFn = (0, $8v0nu.useCallback)(function() {
        return flipPage(previousPageConfig);
    }, [
        flipPage,
        previousPageConfig
    ]);
    var _submit = (0, $8v0nu.useCallback)(function() {
        var payload = getSearchPayload();
        executeSearch(payload);
    }, [
        executeSearch,
        getSearchPayload
    ]);
    var submit = (0, $8v0nu.useMemo)(function() {
        return $eba44fb2c963ffed$var$debounce(_submit);
    }, [
        _submit
    ]);
    return {
        submit: submit,
        ids: ids,
        setIds: setIds,
        bbox: bbox,
        setBbox: setBbox,
        collections: collections,
        setCollections: setCollections,
        dateRangeFrom: dateRangeFrom,
        setDateRangeFrom: setDateRangeFrom,
        dateRangeTo: dateRangeTo,
        setDateRangeTo: setDateRangeTo,
        results: results,
        state: state,
        error: error,
        sortby: sortby,
        setSortby: setSortby,
        limit: limit,
        setLimit: setLimit,
        nextPage: nextPageConfig ? nextPageFn : undefined,
        previousPage: previousPageConfig ? previousPageFn : undefined
    };
}
function $eba44fb2c963ffed$export$2b5787016ed09c4d() {
    var _a = $eba44fb2c963ffed$var$useStacApiContext(), stacApi = _a.stacApi, collections = _a.collections, setCollections = _a.setCollections;
    var _b = (0, $8v0nu.useState)("IDLE"), state = _b[0], setState = _b[1];
    var _c = (0, $8v0nu.useState)(), error = _c[0], setError = _c[1];
    var _getCollections = (0, $8v0nu.useCallback)(function() {
        if (stacApi) {
            setState("LOADING");
            stacApi.getCollections().then(function(response) {
                return response.json();
            }).then(setCollections).catch(function(err) {
                setError(err);
                setCollections(undefined);
            }).finally(function() {
                return setState("IDLE");
            });
        }
    }, [
        setCollections,
        stacApi
    ]);
    var getCollections = (0, $8v0nu.useMemo)(function() {
        return $eba44fb2c963ffed$var$debounce(_getCollections);
    }, [
        _getCollections
    ]);
    (0, $8v0nu.useEffect)(function() {
        if (stacApi && !error && !collections) getCollections();
    }, [
        getCollections,
        stacApi,
        collections,
        error
    ]);
    return {
        collections: collections,
        reload: getCollections,
        state: state,
        error: error
    };
}
function $eba44fb2c963ffed$export$6cd28814d92fa9c9(collectionId) {
    var _a = $eba44fb2c963ffed$export$2b5787016ed09c4d(), collections = _a.collections, state = _a.state, requestError = _a.error, reload = _a.reload;
    var _b = (0, $8v0nu.useState)(), error = _b[0], setError = _b[1];
    (0, $8v0nu.useEffect)(function() {
        setError(requestError);
    }, [
        requestError
    ]);
    var collection = (0, $8v0nu.useMemo)(function() {
        var coll = collections === null || collections === void 0 ? void 0 : collections.collections.find(function(_a) {
            var id = _a.id;
            return id === collectionId;
        });
        if (!coll) setError({
            status: 404,
            statusText: "Not found",
            detail: "Collection does not exist"
        });
        return coll;
    }, [
        collectionId,
        collections
    ]);
    return {
        collection: collection,
        state: state,
        error: error,
        reload: reload
    };
}
function $eba44fb2c963ffed$export$9842ce616dcc8723(url) {
    var _a = $eba44fb2c963ffed$var$useStacApiContext(), stacApi = _a.stacApi, getItem = _a.getItem, addItem = _a.addItem, deleteItem = _a.deleteItem;
    var _b = (0, $8v0nu.useState)("IDLE"), state = _b[0], setState = _b[1];
    var _c = (0, $8v0nu.useState)(), item = _c[0], setItem = _c[1];
    var _d = (0, $8v0nu.useState)(), error = _d[0], setError = _d[1];
    (0, $8v0nu.useEffect)(function() {
        if (!stacApi) return;
        setState("LOADING");
        new Promise(function(resolve, reject) {
            var i = getItem(url);
            if (i) resolve(i);
            else stacApi.fetch(url).then(function(r) {
                return r.json();
            }).then(function(r) {
                addItem(url, r);
                resolve(r);
            }).catch(function(err) {
                return reject(err);
            });
        }).then(setItem).catch(function(err) {
            return setError(err);
        }).finally(function() {
            return setState("IDLE");
        });
    }, [
        stacApi,
        addItem,
        getItem,
        url
    ]);
    var fetchItem = (0, $8v0nu.useCallback)(function() {
        if (!stacApi) return;
        setState("LOADING");
        new Promise(function(resolve, reject) {
            var i = getItem(url);
            if (i) resolve(i);
            else stacApi.fetch(url).then(function(r) {
                return r.json();
            }).then(function(r) {
                addItem(url, r);
                resolve(r);
            }).catch(function(err) {
                return reject(err);
            });
        }).then(setItem).catch(function(err) {
            return setError(err);
        }).finally(function() {
            return setState("IDLE");
        });
    }, [
        addItem,
        getItem,
        stacApi,
        url
    ]);
    var reload = (0, $8v0nu.useCallback)(function() {
        deleteItem(url);
        fetchItem();
    }, [
        deleteItem,
        fetchItem,
        url
    ]);
    return {
        item: item,
        state: state,
        error: error,
        reload: reload
    };
}



var $kxTYF = parcelRequire("kxTYF");

var $8v0nu = parcelRequire("8v0nu");
// Create context
const $c14d6b556e5e27a6$var$PluginConfigContext = /*#__PURE__*/ (0, $8v0nu.createContext)(null);
function $c14d6b556e5e27a6$export$1bd450f81b7fc15b(props) {
    const { config: config, children: children } = props;
    return /*#__PURE__*/ (0, $kxTYF.jsx)($c14d6b556e5e27a6$var$PluginConfigContext.Provider, {
        value: {
            config: config
        },
        children: children
    });
}
const $c14d6b556e5e27a6$export$bb6ca6e2ef1fe760 = ()=>{
    const context = (0, $8v0nu.useContext)($c14d6b556e5e27a6$var$PluginConfigContext);
    if (!context) throw new Error("usePluginConfig must be used within a PluginConfigProvider");
    return context.config;
};



var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");

var $kxTYF = parcelRequire("kxTYF");





var $3lBLT = parcelRequire("3lBLT");
"use client";
const $6cea469a0e58db34$export$37acb3580601e69a = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function Badge2(props, ref) {
    const styles = (0, $c7d173d35275482d$export$b863f77547fbcb03)("Badge", props);
    const { className: className, ...rest } = (0, $58ff34c9d17adf03$export$adfcf5a5e4d17785)(props);
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).span, {
        ref: ref,
        className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-badge", props.className),
        ...rest,
        __css: {
            display: "inline-block",
            whiteSpace: "nowrap",
            verticalAlign: "middle",
            ...styles
        }
    });
});
$6cea469a0e58db34$export$37acb3580601e69a.displayName = "Badge";


var $9HGsN = parcelRequire("9HGsN");
var $kxTYF = parcelRequire("kxTYF");





var $3lBLT = parcelRequire("3lBLT");
"use client";
const $f3e451793b23b8d1$export$42a852a2b6b56249 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function Container2(props, ref) {
    const { className: className, centerContent: centerContent, ...rest } = (0, $58ff34c9d17adf03$export$adfcf5a5e4d17785)(props);
    const styles = (0, $c7d173d35275482d$export$b863f77547fbcb03)("Container", props);
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
        ref: ref,
        className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-container", className),
        ...rest,
        __css: {
            ...styles,
            ...centerContent && {
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
            }
        }
    });
});
$f3e451793b23b8d1$export$42a852a2b6b56249.displayName = "Container";


var $kxTYF = parcelRequire("kxTYF");





var $3lBLT = parcelRequire("3lBLT");
"use client";
const $a3bfda7295e9946f$export$2e0a83ec2e27ecbb = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function Divider2(props, ref) {
    const { borderLeftWidth: borderLeftWidth, borderBottomWidth: borderBottomWidth, borderTopWidth: borderTopWidth, borderRightWidth: borderRightWidth, borderWidth: borderWidth, borderStyle: borderStyle, borderColor: borderColor, ...styles } = (0, $c7d173d35275482d$export$b863f77547fbcb03)("Divider", props);
    const { className: className, orientation: orientation = "horizontal", __css: __css, ...rest } = (0, $58ff34c9d17adf03$export$adfcf5a5e4d17785)(props);
    const dividerStyles = {
        vertical: {
            borderLeftWidth: borderLeftWidth || borderRightWidth || borderWidth || "1px",
            height: "100%"
        },
        horizontal: {
            borderBottomWidth: borderBottomWidth || borderTopWidth || borderWidth || "1px",
            width: "100%"
        }
    };
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).hr, {
        ref: ref,
        "aria-orientation": orientation,
        ...rest,
        __css: {
            ...styles,
            border: "0",
            borderColor: borderColor,
            borderStyle: borderStyle,
            ...dividerStyles[orientation],
            ...__css
        },
        className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-divider", className)
    });
});
$a3bfda7295e9946f$export$2e0a83ec2e27ecbb.displayName = "Divider";


var $kxTYF = parcelRequire("kxTYF");



var $8v0nu = parcelRequire("8v0nu");
"use client";
const $d0a5f3b4fd110683$export$9ee1d08bb6db426f = {
    ease: [
        0.25,
        0.1,
        0.25,
        1
    ],
    easeIn: [
        0.4,
        0,
        1,
        1
    ],
    easeOut: [
        0,
        0,
        0.2,
        1
    ],
    easeInOut: [
        0.4,
        0,
        0.2,
        1
    ]
};
const $d0a5f3b4fd110683$export$55b7325ba41bb523 = {
    scale: {
        enter: {
            scale: 1
        },
        exit: {
            scale: 0.95
        }
    },
    fade: {
        enter: {
            opacity: 1
        },
        exit: {
            opacity: 0
        }
    },
    pushLeft: {
        enter: {
            x: "100%"
        },
        exit: {
            x: "-30%"
        }
    },
    pushRight: {
        enter: {
            x: "-100%"
        },
        exit: {
            x: "30%"
        }
    },
    pushUp: {
        enter: {
            y: "100%"
        },
        exit: {
            y: "-30%"
        }
    },
    pushDown: {
        enter: {
            y: "-100%"
        },
        exit: {
            y: "30%"
        }
    },
    slideLeft: {
        position: {
            left: 0,
            top: 0,
            bottom: 0,
            width: "100%"
        },
        enter: {
            x: 0,
            y: 0
        },
        exit: {
            x: "-100%",
            y: 0
        }
    },
    slideRight: {
        position: {
            right: 0,
            top: 0,
            bottom: 0,
            width: "100%"
        },
        enter: {
            x: 0,
            y: 0
        },
        exit: {
            x: "100%",
            y: 0
        }
    },
    slideUp: {
        position: {
            top: 0,
            left: 0,
            right: 0,
            maxWidth: "100vw"
        },
        enter: {
            x: 0,
            y: 0
        },
        exit: {
            x: 0,
            y: "-100%"
        }
    },
    slideDown: {
        position: {
            bottom: 0,
            left: 0,
            right: 0,
            maxWidth: "100vw"
        },
        enter: {
            x: 0,
            y: 0
        },
        exit: {
            x: 0,
            y: "100%"
        }
    }
};
function $d0a5f3b4fd110683$export$76af7f35258e628d(options) {
    const side = options?.direction ?? "right";
    switch(side){
        case "right":
            return $d0a5f3b4fd110683$export$55b7325ba41bb523.slideRight;
        case "left":
            return $d0a5f3b4fd110683$export$55b7325ba41bb523.slideLeft;
        case "bottom":
            return $d0a5f3b4fd110683$export$55b7325ba41bb523.slideDown;
        case "top":
            return $d0a5f3b4fd110683$export$55b7325ba41bb523.slideUp;
        default:
            return $d0a5f3b4fd110683$export$55b7325ba41bb523.slideRight;
    }
}
const $d0a5f3b4fd110683$export$f995eb860f745cb = {
    enter: {
        duration: 0.2,
        ease: $d0a5f3b4fd110683$export$9ee1d08bb6db426f.easeOut
    },
    exit: {
        duration: 0.1,
        ease: $d0a5f3b4fd110683$export$9ee1d08bb6db426f.easeIn
    }
};
const $d0a5f3b4fd110683$export$fc492bd0f1c91c = {
    enter: (transition, delay)=>({
            ...transition,
            delay: typeof delay === "number" ? delay : delay?.["enter"]
        }),
    exit: (transition, delay)=>({
            ...transition,
            delay: typeof delay === "number" ? delay : delay?.["exit"]
        })
};


"use client";
const $cf1ab35b07148e68$var$variants = {
    enter: ({ transition: transition, transitionEnd: transitionEnd, delay: delay } = {})=>({
            opacity: 1,
            transition: transition?.enter ?? (0, $d0a5f3b4fd110683$export$fc492bd0f1c91c).enter((0, $d0a5f3b4fd110683$export$f995eb860f745cb).enter, delay),
            transitionEnd: transitionEnd?.enter
        }),
    exit: ({ transition: transition, transitionEnd: transitionEnd, delay: delay } = {})=>({
            opacity: 0,
            transition: transition?.exit ?? (0, $d0a5f3b4fd110683$export$fc492bd0f1c91c).exit((0, $d0a5f3b4fd110683$export$f995eb860f745cb).exit, delay),
            transitionEnd: transitionEnd?.exit
        })
};
const $cf1ab35b07148e68$export$4342735ea5c231d = {
    initial: "exit",
    animate: "enter",
    exit: "exit",
    variants: $cf1ab35b07148e68$var$variants
};
const $cf1ab35b07148e68$export$c983850c6c9d8b0e = (0, $8v0nu.forwardRef)(function Fade2(props, ref) {
    const { unmountOnExit: unmountOnExit, in: isOpen, className: className, transition: transition, transitionEnd: transitionEnd, delay: delay, animatePresenceProps: animatePresenceProps, ...rest } = props;
    const animate = isOpen || unmountOnExit ? "enter" : "exit";
    const show = unmountOnExit ? isOpen && unmountOnExit : true;
    const custom = {
        transition: transition,
        transitionEnd: transitionEnd,
        delay: delay
    };
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $f1f51be609a91d37$export$3ae376d12526dd6f), {
        ...animatePresenceProps,
        custom: custom,
        children: show && /* @__PURE__ */ (0, $kxTYF.jsx)((0, $378127958faa4916$export$e25e478948902b8b).div, {
            ref: ref,
            className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-fade", className),
            custom: custom,
            ...$cf1ab35b07148e68$export$4342735ea5c231d,
            animate: animate,
            ...rest
        })
    });
});
$cf1ab35b07148e68$export$c983850c6c9d8b0e.displayName = "Fade";


var $kxTYF = parcelRequire("kxTYF");


var $3lBLT = parcelRequire("3lBLT");
"use client";
const $fa11479c07f903fc$export$f51f4c4ede09e011 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function Flex2(props, ref) {
    const { direction: direction, align: align, justify: justify, wrap: wrap, basis: basis, grow: grow, shrink: shrink, ...rest } = props;
    const styles = {
        display: "flex",
        flexDirection: direction,
        alignItems: align,
        justifyContent: justify,
        flexWrap: wrap,
        flexBasis: basis,
        flexGrow: grow,
        flexShrink: shrink
    };
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
        ref: ref,
        __css: styles,
        ...rest
    });
});
$fa11479c07f903fc$export$f51f4c4ede09e011.displayName = "Flex";


var $kxTYF = parcelRequire("kxTYF");





var $3lBLT = parcelRequire("3lBLT");
"use client";
const $8651ef577e25eea6$export$a8a3e93435678ff9 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function Heading2(props, ref) {
    const styles = (0, $c7d173d35275482d$export$b863f77547fbcb03)("Heading", props);
    const { className: className, ...rest } = (0, $58ff34c9d17adf03$export$adfcf5a5e4d17785)(props);
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).h2, {
        ref: ref,
        className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-heading", props.className),
        ...rest,
        __css: styles
    });
});
$8651ef577e25eea6$export$a8a3e93435678ff9.displayName = "Heading";


var $kxTYF = parcelRequire("kxTYF");


var $kxTYF = parcelRequire("kxTYF");

"use client";
const $a4b7888889a6290d$export$1a94f80a613efc3a = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function NativeImage2(props, ref) {
    const { htmlWidth: htmlWidth, htmlHeight: htmlHeight, alt: alt, ...rest } = props;
    return /* @__PURE__ */ (0, $kxTYF.jsx)("img", {
        width: htmlWidth,
        height: htmlHeight,
        ref: ref,
        alt: alt,
        ...rest
    });
});
$a4b7888889a6290d$export$1a94f80a613efc3a.displayName = "NativeImage";




var $8v0nu = parcelRequire("8v0nu");
"use client";
function $65811e07b2b1042b$export$e4da99f09da8b739(props) {
    const { loading: loading, src: src, srcSet: srcSet, onLoad: onLoad, onError: onError, crossOrigin: crossOrigin, sizes: sizes, ignoreFallback: ignoreFallback } = props;
    const [status, setStatus] = (0, $8v0nu.useState)("pending");
    (0, $8v0nu.useEffect)(()=>{
        setStatus(src ? "loading" : "pending");
    }, [
        src
    ]);
    const imageRef = (0, $8v0nu.useRef)();
    const load = (0, $8v0nu.useCallback)(()=>{
        if (!src) return;
        flush();
        const img = new Image();
        img.src = src;
        if (crossOrigin) img.crossOrigin = crossOrigin;
        if (srcSet) img.srcset = srcSet;
        if (sizes) img.sizes = sizes;
        if (loading) img.loading = loading;
        img.onload = (event)=>{
            flush();
            setStatus("loaded");
            onLoad?.(event);
        };
        img.onerror = (error)=>{
            flush();
            setStatus("failed");
            onError?.(error);
        };
        imageRef.current = img;
    }, [
        src,
        crossOrigin,
        srcSet,
        sizes,
        onLoad,
        onError,
        loading
    ]);
    const flush = ()=>{
        if (imageRef.current) {
            imageRef.current.onload = null;
            imageRef.current.onerror = null;
            imageRef.current = null;
        }
    };
    (0, $456f92579f2f647e$export$deebe11a338de063)(()=>{
        if (ignoreFallback) return void 0;
        if (status === "loading") load();
        return ()=>{
            flush();
        };
    }, [
        status,
        load,
        ignoreFallback
    ]);
    return ignoreFallback ? "loaded" : status;
}
const $65811e07b2b1042b$export$b80814126d314dea = (status, fallbackStrategy)=>status !== "loaded" && fallbackStrategy === "beforeLoadOrError" || status === "failed" && fallbackStrategy === "onError";




var $3lBLT = parcelRequire("3lBLT");
"use client";
const $9d94326d5feb12f2$export$3e431a229df88919 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function Image2(props, ref) {
    const { fallbackSrc: fallbackSrc, fallback: fallback, src: src, srcSet: srcSet, align: align, fit: fit, loading: loading, ignoreFallback: ignoreFallback, crossOrigin: crossOrigin, fallbackStrategy: fallbackStrategy = "beforeLoadOrError", referrerPolicy: referrerPolicy, ...rest } = props;
    const providedFallback = fallbackSrc !== void 0 || fallback !== void 0;
    const shouldIgnoreFallbackImage = loading != null || // use can opt out of fallback image
    ignoreFallback || // if the user doesn't provide any kind of fallback we should ignore it
    !providedFallback;
    const status = (0, $65811e07b2b1042b$export$e4da99f09da8b739)({
        ...props,
        crossOrigin: crossOrigin,
        ignoreFallback: shouldIgnoreFallbackImage
    });
    const showFallbackImage = (0, $65811e07b2b1042b$export$b80814126d314dea)(status, fallbackStrategy);
    const shared = {
        ref: ref,
        objectFit: fit,
        objectPosition: align,
        ...shouldIgnoreFallbackImage ? rest : (0, $26295883b405048e$export$30a06c8d3562193f)(rest, [
            "onError",
            "onLoad"
        ])
    };
    if (showFallbackImage) {
        if (fallback) return fallback;
        return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).img, {
            as: (0, $a4b7888889a6290d$export$1a94f80a613efc3a),
            className: "chakra-image__placeholder",
            src: fallbackSrc,
            ...shared
        });
    }
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).img, {
        as: (0, $a4b7888889a6290d$export$1a94f80a613efc3a),
        src: src,
        srcSet: srcSet,
        crossOrigin: crossOrigin,
        loading: loading,
        referrerPolicy: referrerPolicy,
        className: "chakra-image",
        ...shared
    });
});
$9d94326d5feb12f2$export$3e431a229df88919.displayName = "Image";


var $kxTYF = parcelRequire("kxTYF");


var $7hYFp = parcelRequire("7hYFp");



var $3lBLT = parcelRequire("3lBLT");
"use client";
const $3963bf82c5559c75$export$5f1af8db9871e1d6 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function Text2(props, ref) {
    const styles = (0, $c7d173d35275482d$export$b863f77547fbcb03)("Text", props);
    const { className: className, align: align, decoration: decoration, casing: casing, ...rest } = (0, $58ff34c9d17adf03$export$adfcf5a5e4d17785)(props);
    const aliasedProps = (0, $7hYFp.compact)({
        textAlign: props.align,
        textDecoration: props.decoration,
        textTransform: props.casing
    });
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).p, {
        ref: ref,
        className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-text", props.className),
        ...aliasedProps,
        ...rest,
        __css: styles
    });
});
$3963bf82c5559c75$export$5f1af8db9871e1d6.displayName = "Text";



var $6iKRa = parcelRequire("6iKRa");


var $8v0nu = parcelRequire("8v0nu");

/**
 * Creates a collecticons component.
 *
 * @param {function} creatorFn Function to create the collecticon.
 */ function $9138db1f951ed55c$export$7209ba2b0568490(creatorFn, iconSvgProps = {}) {
    const CollecticonChakra = (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).forwardRef((props, ref)=>{
        const { title: title, size: size, meaningful: meaningful, ...rest } = props;
        const s = typeof size !== "undefined" ? size : "1rem";
        const iconProps = {
            title: title,
            width: s,
            height: s,
            fill: "currentColor",
            role: "img",
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg",
            // By default icons are rendered decoratively (aria hidden true) Using
            // "meaningful" prop (together with a descriptive title) will enable the
            // icon to be understood by assistive technologies.
            "aria-hidden": !meaningful,
            ...iconSvgProps,
            ...rest
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).createElement((0, $09b0bffb6a1e43af$export$f04a61298a47a40f), {
            ...iconProps,
            ref: ref
        }, title && (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).createElement("title", null, title), creatorFn(iconProps));
    });
    CollecticonChakra.displayName = "CollecticonChakra";
    return CollecticonChakra;
}
const $9138db1f951ed55c$export$fb146e0ebe1880c9 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M4 12v1h8v-1h1V4h-1V3H4v1H3v8zm3-5h2v2H7zm9 5v4h-4v-1H4v1H0v-4h1V4H0V0h4v1h8V0h4v4h-1v8z"
    })));
const $9138db1f951ed55c$export$4d7881fd068b9554 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M12 12H5.414l9.607-9.607L13.607.979 4 10.586V4H2v10h10z"
    })));
const $9138db1f951ed55c$export$ff31736f1164b93d = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M12 4v6.586L2.393.979.979 2.393 10.586 12H4v2h10V4z"
    })));
const $9138db1f951ed55c$export$bab927fca1b80a3 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M13.586 7.586 9 12.172V0H7v12.172L2.414 7.586 1 9l7 7 7-7z"
    })));
const $9138db1f951ed55c$export$7c84e7446b64c8ba = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8.414 13.586 3.828 9H16V7H3.828l4.586-4.586L7 1 0 8l7 7z"
    })));
const $9138db1f951ed55c$export$669f6b165f77f8e7 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M6 4H3.528q.112-.121.228-.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756A5.97 5.97 0 0 1 14 8h2a8 8 0 0 0-8-8 7.98 7.98 0 0 0-6 2.709V0H0v6h6zm4 8h2.472q-.112.122-.228.244C11.109 13.375 9.603 14 8 14s-3.109-.625-4.244-1.756A5.97 5.97 0 0 1 2 8H0a8 8 0 0 0 8 8 7.98 7.98 0 0 0 6-2.709V16h2v-6h-6z"
    })));
const $9138db1f951ed55c$export$d4555cec95ec110c = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M7.5 1.924 5.773 3.651l-.712-.712L8 0l2.939 2.939-.712.712L8.5 1.924V7.5h5.576l-1.727-1.727.712-.712L16 8l-2.939 2.939-.712-.712L14.076 8.5H8.5v5.576l1.727-1.727.712.712L8 16l-2.939-2.939.712-.712L7.5 14.076V8.5H1.924l1.727 1.727-.712.712L0 8l2.939-2.939.712.712L1.924 7.5H7.5z"
    })));
const $9138db1f951ed55c$export$4337670c5d4a46ab = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M16 11a4 4 0 0 0-4-4H3.828l2.586-2.586L5 3 0 8l5 5 1.414-1.414L3.828 9H12a2 2 0 0 1 2 2v3h2z"
    })));
const $9138db1f951ed55c$export$404215554288eeeb = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M14.238 5.762A5.96 5.96 0 0 0 10 4H3.828l2.586-2.586L5 0 0 5l5 5 1.414-1.414L3.828 6H10c1.063 0 2.066.418 2.824 1.176S14 8.937 14 10s-.418 2.066-1.176 2.824A3.97 3.97 0 0 1 10 14H6v2h4c1.597 0 3.102-.626 4.238-1.762S16 11.597 16 10s-.626-3.102-1.762-4.238"
    })));
const $9138db1f951ed55c$export$45ced6d791f6eabf = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M0 0h2v2.709A7.98 7.98 0 0 1 8 0a8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8h2c0 1.603.624 3.11 1.756 4.244A5.96 5.96 0 0 0 8 14a5.97 5.97 0 0 0 4.244-1.756A5.97 5.97 0 0 0 14 8a5.97 5.97 0 0 0-1.756-4.244A5.97 5.97 0 0 0 8 2a5.97 5.97 0 0 0-4.472 2H6v2H0zm10.784 4.916 1.485 1.337L7.1 12 3.856 8.794l1.406-1.422 1.754 1.731z"
    })));
const $9138db1f951ed55c$export$d30f3c1f95f9e187 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M7.586 2.414 12.172 7H0v2h12.172l-4.586 4.586L9 15l7-7-7-7z"
    })));
const $9138db1f951ed55c$export$d33a98b6c97f9bcf = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M0 0v6h6V4H3.528q.11-.127.228-.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756C13.375 4.891 14 6.397 14 8s-.625 3.109-1.756 4.244A5.97 5.97 0 0 1 8 14v2c4.419 0 8-3.581 8-8s-3.581-8-8-8a7.98 7.98 0 0 0-6 2.709V0z"
    })));
const $9138db1f951ed55c$export$65b63483548348e7 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M14 0v2.709A7.98 7.98 0 0 0 8 0C3.581 0 0 3.581 0 8s3.581 8 8 8v-2a5.97 5.97 0 0 1-4.244-1.756C2.625 11.109 2 9.603 2 8s.625-3.109 1.756-4.244C4.891 2.625 6.397 2 8 2a5.97 5.97 0 0 1 4.472 2H10v2h6V0z"
    })));
const $9138db1f951ed55c$export$1e31cff672fc44e7 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M0 0v6h6V4H3.528q.11-.127.228-.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756C13.375 4.891 14 6.397 14 8s-.625 3.109-1.756 4.244C11.109 13.375 9.603 14 8 14s-3.112-.622-4.244-1.756S2 9.603 2 8H0c0 4.419 3.581 8 8 8s8-3.581 8-8-3.581-8-8-8a7.98 7.98 0 0 0-6 2.709V0z"
    })));
const $9138db1f951ed55c$export$8b2c6a502c5588cb = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M14 0v2.709A7.98 7.98 0 0 0 8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8h-2c0 1.603-.625 3.109-1.756 4.244S9.603 14 8 14s-3.109-.625-4.244-1.756C2.625 11.109 2 9.603 2 8s.625-3.109 1.756-4.244C4.891 2.625 6.397 2 8 2a5.97 5.97 0 0 1 4.472 2H10v2h6V0z"
    })));
const $9138db1f951ed55c$export$e18c7fe3ad046317 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M4 12V5.414l9.607 9.607 1.414-1.414L5.414 4H12V2H2v10z"
    })));
const $9138db1f951ed55c$export$c59521707fa9adf4 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M4 4h6.586L.979 13.607l1.414 1.414L12 5.414V12h2V2H4z"
    })));
const $9138db1f951ed55c$export$44382674197c7e20 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M2.414 8.414 7 3.828V16h2V3.828l4.586 4.586L15 7 8 0 1 7z"
    })));
const $9138db1f951ed55c$export$6d44efda105760b1 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M13 9V6.5c0-2.306-1.759-4.222-4-4.472V1.5a1 1 0 1 0-2 0v.528c-2.241.25-4 2.166-4 4.472V9c0 1.103-.897 2-2 2v2h14v-2c-1.103 0-2-.897-2-2m-5 6.5c.931 0 1.716-.638 1.938-1.5H6.062A2 2 0 0 0 8 15.5"
    })));
const $9138db1f951ed55c$export$67ac5bddd7c814c4 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8 3a3.001 3.001 0 0 0-6 0h2c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1H0v2h5c1.656 0 3-1.344 3-3m4-2a4 4 0 0 0-4 4v1h2V5c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2H1v2h11.5v-.031A4.001 4.001 0 0 0 12 1m-3 9H2v2h7c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1H6a3.001 3.001 0 0 0 6 0c0-1.656-1.344-3-3-3"
    })));
const $9138db1f951ed55c$export$bd738f28ecacfb4c = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M9 1H3v14h6a4.001 4.001 0 0 0 2.645-7A4.001 4.001 0 0 0 9 1M8 9a2 2 0 0 1 0 4H6V9zm0-6a2 2 0 0 1 0 4H6V3z"
    })));
const $9138db1f951ed55c$export$32797ac8ba9dbc26 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M5 12h9V0H9v6L7 4 5 6V0H4C2.9 0 2 .9 2 2v12c0 1.1.9 2 2 2h10v-2H5c-.6 0-1-.4-1-1s.4-1 1-1"
    })));
const $9138db1f951ed55c$export$f27e10809e8ad7c = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M5 12h9V0H4C2.9 0 2 .9 2 2v12c0 1.1.9 2 2 2h10v-2H5c-.6 0-1-.4-1-1s.4-1 1-1M5 2h7v2H5z"
    })));
const $9138db1f951ed55c$export$a7cf23fc039bccca = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M12.042 0h-8v2h8zM10.87 11.828C10.114 12.584 9.111 13 8.042 13s-2.072-.416-2.828-1.172S4.042 10.069 4.042 9s.416-2.072 1.172-2.828S6.973 5 8.042 5s2.072.416 2.828 1.172A4 4 0 0 1 11.917 8h2.041a6 6 0 1 0 0 2h-2.041a4 4 0 0 1-1.047 1.828"
    })));
const $9138db1f951ed55c$export$3fd46276f478a1b0 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M9.053 13.581c-.003-.322.084-.6.219-.891-.288.253-.403.541-.506.931.028-.456.25-3.45.25-3.6.766-2.188.425-8.722 1.4-9.534C9.291.691 8.913 1.841 8.55 2.753 8.194 1.681 8.475 1 7.294.625c.944.8.756 1.491.95 2.594-.566-.734-.391-1.65-1.041-2.4-.184-.191-.797-.657-.797-.657 0 .028.491 1.009.581 1.528.091.519.306 1.556.275 1.938.079 2.119.613 4.172.979 6.25.059.353.244 1.391.244 1.391l.04.431c-.066-.284-.125-.541-.163-.65-.106-.312-.366-1.103-.428-1.431-.89-1.832-2.518-5.419-4.693-5.95C4.475 4.763 5.803 6.206 6.1 7.6c-.663-.931-3.269-2.919-4.328-3.644 1.997 2.072 3.6 4.219 5.337 6.522.503.653 1.131 1.978 1.178 2.278.034.222.075 1.05.1 1.559-.972-2.344-1.506-3.534-3.297-4.587-.306-.162-1.256-.491-1.256-.491.431.475.959.5 1.353 1.166-.815-.534-1.662-.628-2.593-.659 2.991 1.547 4.606 1.978 5.616 4.95.081.487-.041.856-.032 1.306h.669c-.003-.316.003-.616 0-.678.031-.206.041-.831.131-1.022.312-.794.819-1.169 1.525-1.631-.641.206-.962.128-1.45.912m2.944-7.003c-.247.234-.978 1.162-.978 1.162.044-1.312.372-2.719 1.209-3.7-1.163.762-1.822 2.644-2.125 3.794-.119.463-1.497 3.144-.856 4.584.125-.525.422-1.038.75-1.487.153-.203.794-1.228 1.438-2.688.566-1.469 1.491-2.328 2.8-3.056-.985.151-1.548.719-2.238 1.391"
    })));
const $9138db1f951ed55c$export$dd983756265c5ba0 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M15 0H1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h7.178c-.009-.45.113-.819.031-1.306-1.009-2.972-2.625-3.403-5.616-4.95.931.031 1.778.125 2.594.659-.393-.665-.921-.69-1.353-1.165 0 0 .95.328 1.256.491 1.791 1.053 2.325 2.244 3.297 4.587-.025-.509-.066-1.337-.1-1.559-.047-.3-.675-1.625-1.178-2.278-1.737-2.303-3.341-4.45-5.338-6.522C2.831 4.681 5.438 6.669 6.1 7.6c-.297-1.394-1.625-2.837-2.859-3.931 2.175.531 3.803 4.119 4.693 5.95.062.328.322 1.119.428 1.431.038.109.097.366.163.65l-.041-.431S8.3 10.231 8.24 9.878c-.366-2.078-.9-4.131-.978-6.25.031-.381-.184-1.419-.275-1.938S6.406.19 6.406.162c0 0 .613.466.797.656.65.75.475 1.666 1.041 2.4-.194-1.102-.006-1.793-.95-2.593 1.181.375.9 1.056 1.256 2.128.363-.913.741-2.062 1.866-2.266-.975.812-.634 7.347-1.4 9.534 0 .15-.222 3.144-.25 3.6.103-.391.219-.678.506-.931-.134.291-.222.569-.219.891.488-.784.809-.706 1.45-.913-.706.462-1.212.837-1.525 1.631-.091.191-.1.816-.131 1.022.003.062-.003.359 0 .675H15a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1m-3.566 8.244c-.644 1.459-1.284 2.484-1.438 2.688-.328.45-.625.962-.75 1.488-.641-1.441.738-4.122.856-4.584.303-1.15.962-3.031 2.125-3.794-.837.981-1.166 2.387-1.209 3.7 0 0 .731-.928.978-1.162.691-.672 1.253-1.241 2.238-1.391-1.309.727-2.234 1.586-2.8 3.055"
    })));
const $9138db1f951ed55c$export$c9ea3985d0020928 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8.011 3.76 4.005 6.317 8.01 8.874 4.005 11.43 0 8.852l4.005-2.557L0 3.76l4.005-2.557zm-4.027 8.48 4.005-2.557 4.005 2.557-4.005 2.557zm4.027-3.388 4.005-2.557L8.011 3.76l3.984-2.557L16 3.76l-4.005 2.557L16 8.874l-4.005 2.557z"
    })));
const $9138db1f951ed55c$export$834c92baa9723134 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M15.117 0H.883A.883.883 0 0 0 0 .883v14.234c0 .488.395.883.883.883h7.664V9.812H6.469V7.391h2.078V5.608c0-2.067 1.262-3.192 3.106-3.192.883 0 1.642.066 1.863.095v2.16l-1.271.001c-1.003 0-1.197.477-1.197 1.176v1.543h2.398l-.312 2.422h-2.086V16h4.07a.88.88 0 0 0 .882-.883V.883A.883.883 0 0 0 15.117 0"
    })));
const $9138db1f951ed55c$export$d8149c9a6ffff702 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M0 8a3.5 3.5 0 1 0 7 0 3.5 3.5 0 0 0-7 0m9 0a3.5 3.5 0 1 0 7 0 3.5 3.5 0 0 0-7 0"
    })));
const $9138db1f951ed55c$export$68cfb6157bb0630 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        fillRule: "evenodd",
        d: "M7.999 0a8 8 0 0 0-2.528 15.591c.4.073.546-.174.546-.386 0-.19-.007-.693-.011-1.361-2.225.483-2.695-1.072-2.695-1.072-.364-.924-.888-1.17-.888-1.17-.726-.496.055-.486.055-.486.803.057 1.225.824 1.225.824.714 1.223 1.872.87 2.328.665.073-.517.279-.87.508-1.069-1.776-.202-3.644-.888-3.644-3.954 0-.873.312-1.587.823-2.147-.081-.202-.356-1.016.08-2.117 0 0 .672-.215 2.2.82A7.7 7.7 0 0 1 8 3.869a7.7 7.7 0 0 1 2.003.269c1.527-1.035 2.198-.82 2.198-.82.436 1.101.162 1.915.08 2.117.513.559.822 1.273.822 2.147 0 3.073-1.87 3.75-3.653 3.948.287.247.543.735.543 1.481 0 1.069-.01 1.932-.01 2.195 0 .214.144.463.55.385A8 8 0 0 0 7.999 0",
        clipRule: "evenodd"
    })));
const $9138db1f951ed55c$export$41b74980cc97582d = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M14.544 7.272V5.816h-1.456v1.456h-1.453v1.453h1.456v1.456h1.459V8.725H16V7.272zm-9.453 0v1.747h2.891c-.116.75-.872 2.197-2.887 2.197-1.737 0-3.156-1.441-3.156-3.216s1.416-3.216 3.153-3.216c.991 0 1.653.422 2.031.784L8.504 4.24c-.888-.831-2.038-1.331-3.41-1.331a5.09 5.09 0 1 0-.003 10.182c2.941 0 4.887-2.066 4.887-4.975a4.7 4.7 0 0 0-.081-.844z"
    })));
const $9138db1f951ed55c$export$eabd4486e49012ba = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M7.734 0c.334.184 1.469.938 1.469 2.297 0 1.203-1.941 4.791-1.188 5.722l4.812-6s1.197 1.456.478 2.688c-.747 1.281-2.588 2.781-3.325 3.897-.456.69-.234 1.059-.234 1.059l5.834-3.194s.469 1.391-.641 2.391c-1.172 1.056-3.931 1.475-3.931 2.575h4.006s-.409 1.216-1.184 1.384c-.684.15-2.144-.247-2.831.372C10.271 13.847 9.456 16 7.015 16c-1.641 0-2.912-1.184-3.703-2.738-.913-1.797-1.938-2.663-2.991-2.881 0 0 .575-1.359 2.088-1.359 2.081 0 2.972 3.409 4.544 3.409.453 0 .934-.234.934-.903 0-.725-1.044-1.325-1.334-1.525-.691-.481-1.244-1.247-.888-2.531z"
    })));
const $9138db1f951ed55c$export$b32786cce09df9e0 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M0 14.462h2.518V4.963H0zM0 3.83h2.518V1.538H0zm15.756 1.769a5.7 5.7 0 0 0-.916-2.074 4.24 4.24 0 0 0-2.189-1.629q-.794-.261-1.988-.279H5.124v12.845h5.538q2.913 0 4.308-2.396Q16 10.288 16 7.725q0-1.01-.244-2.126m-2.894 4.758q-.75 1.874-2.653 1.874H7.73V3.847h2.479q1.833 0 2.448 1.05t.615 3.011q0 1.422-.41 2.449"
    })));
const $9138db1f951ed55c$export$c85efb9e6a50791b = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2m3-10H5C2.237 0 0 2.237 0 5v6c0 2.762 2.237 5 5 5h6a5 5 0 0 0 5-5V5c0-2.763-2.238-5-5-5m3 11c0 1.653-1.347 3-3 3H5c-1.653 0-3-1.347-3-3V5c0-1.653 1.347-3 3-3h6c1.653 0 3 1.347 3 3zm-2-8a1 1 0 1 0 0 2 1 1 0 1 0 0-2"
    })));
const $9138db1f951ed55c$export$4238e97612e0856e = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M3.997 12.445c2.072 0 3.059-.972 3.059-.972L6.469 9.88s-.953 1.062-2.381 1.062c-1.266 0-2.162-1.1-2.162-2.859 0-2.253 1.138-3.059 2.253-3.059 1.613 0 2.125 1.044 2.566 2.381l.588 1.831c.588 1.778 1.688 3.206 4.856 3.206 2.272 0 3.812-.697 3.812-2.528 0-1.484-.844-2.253-2.419-2.622l-1.172-.256c-.806-.184-1.044-.512-1.044-1.062 0-.622.494-.991 1.3-.991.878 0 1.356.331 1.428 1.119l1.831-.219c-.147-1.65-1.284-2.328-3.153-2.328-1.65 0-3.262.622-3.262 2.622 0 1.247.606 2.034 2.125 2.4l1.247.294c.934.219 1.247.606 1.247 1.137 0 .678-.659.953-1.906.953-1.85 0-2.622-.972-3.059-2.309L8.556 6.82c-.765-2.384-1.994-3.262-4.431-3.262C1.428 3.558 0 5.261 0 8.158c0 2.784 1.428 4.287 3.997 4.287"
    })));
const $9138db1f951ed55c$export$a2e102bc44d355e3 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M14.815 0H1.18C.53 0 0 .517 0 1.153v13.694C0 15.485.53 16 1.18 16h13.636c.651 0 1.184-.515 1.184-1.153V1.153C16 .517 15.467 0 14.815 0M4.746 13.634H2.371V5.999h2.376zM3.559 4.955a1.376 1.376 0 1 1-.001-2.753 1.376 1.376 0 0 1 .001 2.753m10.074 8.679h-2.371V9.922c0-.886-.017-2.025-1.233-2.025-1.235 0-1.423.964-1.423 1.96v3.778H6.235V5.999h2.274v1.043h.033c.317-.6 1.091-1.233 2.245-1.233 2.401 0 2.845 1.581 2.845 3.638z"
    })));
const $9138db1f951ed55c$export$435e172f1afd8f3 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M0 0v16h16V0zm13.292 3.791-.858.823a.25.25 0 0 0-.095.241V10.9a.25.25 0 0 0 .095.241l.838.823v.181H9.057v-.181l.868-.843c.085-.085.085-.11.085-.241V5.993l-2.414 6.13h-.325l-2.81-6.13v4.109a.57.57 0 0 0 .156.472l1.129 1.37v.181H2.544v-.181l1.129-1.37a.55.55 0 0 0 .146-.472V5.351A.42.42 0 0 0 3.683 5L2.679 3.791V3.61h3.116l2.409 5.283 2.118-5.283h2.971v.181z"
    })));
const $9138db1f951ed55c$export$b3ee3fb5dcd7cd96 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M11 5 9 7V4L8 3 7 4v3L5 5H0v6h5l2-2v4h2V9l2 2h5V5zm-9 5H1V6h1zm2 0H3V6h1zm9 0h-1V6h1zm2 0h-1V6h1z"
    })));
const $9138db1f951ed55c$export$f01132691dc82ba2 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M15.239 9.03q.068-.487.069-.992c0-4.036-3.29-7.309-7.347-7.309a7.3 7.3 0 0 0-1.183.096A4.384 4.384 0 0 0 .706 6.886a7 7 0 0 0-.091 1.152c0 4.037 3.288 7.309 7.346 7.309.458 0 .904-.045 1.337-.123a4.384 4.384 0 0 0 6.701-3.724 4.36 4.36 0 0 0-.76-2.47m-6.591 4.395c-2.335.122-3.427-.395-4.428-1.334-1.118-1.049-.669-2.245.242-2.306.91-.061 1.456 1.032 1.942 1.335.485.303 2.331.993 3.306-.122 1.062-1.213-.706-1.841-2.002-2.031-1.85-.274-4.186-1.275-4.004-3.247S5.379 2.738 6.95 2.595c2.002-.182 3.306.303 4.337 1.183 1.192 1.017.547 2.153-.212 2.244-.757.092-1.607-1.671-3.275-1.698-1.72-.027-2.882 1.79-.759 2.306s4.398.728 5.218 2.669c.819 1.942-1.274 4.004-3.611 4.126"
    })));
const $9138db1f951ed55c$export$8b71514e84056695 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M0 10.111c0 .925.756 1.681 1.681 1.681s1.681-.756 1.681-1.681V8.43H1.681C.756 8.43 0 9.186 0 10.111m16-4.222c0-.925-.756-1.681-1.681-1.681s-1.681.756-1.681 1.681V7.57h1.681c.925 0 1.681-.756 1.681-1.681M10.111 7.57c.925 0 1.681-.756 1.681-1.681V1.681C11.792.756 11.036 0 10.111 0S8.43.756 8.43 1.681v4.208c0 .925.756 1.681 1.681 1.681m-4.222.86c-.925 0-1.681.756-1.681 1.681v4.208c0 .925.756 1.681 1.681 1.681s1.681-.756 1.681-1.681v-4.208c0-.925-.756-1.681-1.681-1.681m0-4.222H1.681C.756 4.208 0 4.964 0 5.889S.756 7.57 1.681 7.57h4.208c.925 0 1.681-.756 1.681-1.681s-.756-1.681-1.681-1.681m0-4.208c-.925 0-1.681.756-1.681 1.681s.756 1.681 1.681 1.681H7.57V1.681C7.57.756 6.814 0 5.889 0m8.43 8.43h-4.208c-.925 0-1.681.756-1.681 1.681s.756 1.681 1.681 1.681h4.208c.925 0 1.681-.756 1.681-1.681s-.756-1.681-1.681-1.681m-4.208 4.208H8.43v1.681c0 .925.756 1.681 1.681 1.681s1.681-.756 1.681-1.681-.756-1.681-1.681-1.681"
    })));
const $9138db1f951ed55c$export$4eeeb34c908b13d0 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M2.035 7.791a.097.097 0 0 0-.094.094L1.8 9.638l.141 1.694a.094.094 0 0 0 .094.091c.05 0 .091-.041.094-.091l.159-1.694-.159-1.754c-.004-.056-.044-.093-.094-.093m.641.112a.11.11 0 0 0-.107.106l-.134 1.626.134 1.71a.11.11 0 0 0 .106.106.11.11 0 0 0 .106-.106l.15-1.71-.149-1.626a.11.11 0 0 0-.106-.106m.643-1.031a.123.123 0 0 0-.122.119l-.125 2.644.125 1.71a.123.123 0 0 0 .122.119.123.123 0 0 0 .122-.119l.141-1.71-.141-2.645a.125.125 0 0 0-.122-.118M1.4 7.85c-.044 0-.075.034-.081.078l-.15 1.707.15 1.644a.08.08 0 0 0 .081.078c.041 0 .075-.034.081-.078l.169-1.644-.168-1.707c-.007-.047-.038-.078-.082-.078m-1.219.831c-.034 0-.059.025-.066.063L0 9.635l.116.875a.065.065 0 0 0 .066.063c.031 0 .059-.025.063-.063l.138-.875-.139-.888c-.003-.041-.031-.066-.063-.066m.591-.55c-.034 0-.063.028-.066.066L.55 9.635l.156 1.407c.003.038.031.066.066.066.034 0 .063-.025.066-.066l.178-1.407-.178-1.438c-.003-.038-.032-.066-.066-.066m3.185-1.869a.137.137 0 0 0-.134.134l-.116 3.248.116 1.697a.137.137 0 0 0 .134.134.137.137 0 0 0 .134-.134l.131-1.697-.131-3.247a.135.135 0 0 0-.134-.135m3.448-.859q-.05-.034-.113-.035c-.063-.001-.078.013-.109.034a.2.2 0 0 0-.094.169v.038l-.075 4.026.078 1.635v.006a.2.2 0 0 0 .047.122.2.2 0 0 0 .156.075.2.2 0 0 0 .141-.059.22.22 0 0 0 .063-.144l.009-.163.078-1.469-.085-4.067a.24.24 0 0 0-.096-.168m6.629 2.134c-.269 0-.528.053-.763.153a3.473 3.473 0 0 0-3.46-3.166c-.444 0-.878.088-1.26.234-.149.057-.187.116-.19.232v6.248a.23.23 0 0 0 .213.225h5.457a1.964 1.964 0 1 0 .003-3.926M6.617 6.031a.193.193 0 0 0-.191.188l-.084 3.416.084 1.644a.191.191 0 0 0 .382 0l.094-1.644-.094-3.417a.19.19 0 0 0-.191-.187m1.456-1.013a.2.2 0 0 0-.109-.031q-.08.002-.138.05a.24.24 0 0 0-.081.166v.022l-.087 4.413.044.816.044.794c0 .119.1.216.216.216a.216.216 0 0 0 .216-.216v.003l.097-1.61-.098-4.435a.21.21 0 0 0-.104-.188m-2.125.897a.175.175 0 0 0-.175.175l-.094 3.545.094 1.653c.003.097.078.175.175.175s.172-.078.175-.175l.103-1.653-.103-3.548a.176.176 0 0 0-.175-.172m-.666-.081a.166.166 0 0 0-.163.163l-.1 3.638.1 1.669c.003.091.075.159.163.159s.159-.072.163-.159l.113-1.669-.113-3.639a.165.165 0 0 0-.163-.162m-.659.134a.15.15 0 0 0-.15.147l-.11 3.52.109 1.682c.003.081.069.147.15.147s.144-.066.15-.147l.122-1.682-.121-3.52a.154.154 0 0 0-.15-.147"
    })));
const $9138db1f951ed55c$export$e582f877f685c307 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M9.707 15.997c-3.396 0-4.687-2.503-4.687-4.274V6.496H3.412V4.43C5.83 3.555 6.421 1.368 6.552.118A.13.13 0 0 1 6.667 0H9.01v4.074h3.199v2.421H8.995v4.98c.009.669.25 1.581 1.472 1.581h.059c.422-.012.99-.137 1.29-.278l.772 2.284c-.291.425-1.6.915-2.771.937h-.119c0-.002.009-.002.009-.002"
    })));
const $9138db1f951ed55c$export$f26b4f060f08f8f9 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M16 3.038a6.6 6.6 0 0 1-1.885.517 3.3 3.3 0 0 0 1.443-1.816 6.6 6.6 0 0 1-2.085.797 3.283 3.283 0 0 0-5.594 2.993 9.32 9.32 0 0 1-6.766-3.43A3.3 3.3 0 0 0 .669 3.75c0 1.139.579 2.144 1.46 2.732a3.3 3.3 0 0 1-1.486-.411v.041a3.286 3.286 0 0 0 2.633 3.219 3.3 3.3 0 0 1-1.483.057 3.29 3.29 0 0 0 3.066 2.28 6.6 6.6 0 0 1-4.86 1.359 9.3 9.3 0 0 0 5.032 1.475c6.038 0 9.34-5.002 9.34-9.34a9 9 0 0 0-.01-.425A6.7 6.7 0 0 0 16 3.038"
    })));
const $9138db1f951ed55c$export$c07c7d541b672534 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M2.096 1.031h2.188l9.658 12.914h-2.187zM.039 0l6.177 8.26L0 14.975h1.399l5.443-5.879 4.397 5.879H16L9.475 6.251 15.261 0h-1.399L8.85 5.415 4.8 0z"
    })));
const $9138db1f951ed55c$export$5e55219a763bfc51 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M6.364 10.379V5.621L10.545 8zm9.302-6.255A2.01 2.01 0 0 0 14.251 2.7C13.003 2.364 8 2.364 8 2.364s-5.003 0-6.251.336A2.01 2.01 0 0 0 .334 4.124C0 5.38 0 8 0 8s0 2.62.334 3.876A2.01 2.01 0 0 0 1.749 13.3c1.248.336 6.251.336 6.251.336s5.003 0 6.251-.336a2.01 2.01 0 0 0 1.415-1.424C16 10.62 16 8 16 8s0-2.62-.334-3.876"
    })));
const $9138db1f951ed55c$export$3f241c3fc4d9dd7a = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M6 2h4v1h2V2c0-1.1-.9-2-2-2H6C4.9 0 4 .9 4 2v1h2zM0 14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V8H0zm7-5h2v1a1 1 0 1 1-2 0zm8-5H1c-.55 0-1 .45-1 1v2h16V5c0-.55-.45-1-1-1"
    })));
const $9138db1f951ed55c$export$7e0d7941fbd8a620 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M11.5 0H10v3H9V1H5V0H3.5v3h-1V1H1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h4.341A6 6 0 0 1 5 11H2V5h10c1 0 1.393.368 2 .72V2a1 1 0 0 0-1-1h-1.5z"
    }), $8v0nu.createElement("path", {
        d: "M16 11a5 5 0 1 1-10.001-.001A5 5 0 0 1 16 11m-7.5.625h5v-1.25h-5z"
    })));
const $9138db1f951ed55c$export$8266db1827cb2822 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M11.5 0H10v3H9V1H5V0H3.5v3h-1V1H1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h4.341A6 6 0 0 1 5 11H2V5h10c1 0 1.393.368 2 .72V2a1 1 0 0 0-1-1h-1.5z"
    }), $8v0nu.createElement("path", {
        d: "M16 11a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-5.625-2.5v1.875H8.5v1.25h1.875V13.5h1.25v-1.875H13.5v-1.25h-1.875V8.5z"
    })));
const $9138db1f951ed55c$export$16c0cbaf2c55e7b6 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M15 15H1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h1v2h3V2h6v2h3V2h1a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1m-1-9H2v7h12zm-5 6H7v-2h2zm-3 0H4v-2h2zm6-3h-2V7h2zM9 9H7V7h2zM4 3H3V.494C3 .222 3.222 0 3.497 0h.009C3.778 0 4 .222 4 .494zm9 0h-1V.494c0-.272.222-.494.497-.494h.009c.272 0 .494.222.494.494z"
    })));
const $9138db1f951ed55c$export$edaa4810f882e615 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M6 7H4v2h2zm9-5h-1v2h-3V2H5v2H2V2H1a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m-1 11H2V6h12zM4 .494A.495.495 0 0 0 3.506 0h-.009A.496.496 0 0 0 3 .494V3h1zm9 0A.495.495 0 0 0 12.506 0h-.009A.496.496 0 0 0 12 .494V3h1z",
        style: {
            fillRule: "nonzero"
        }
    })));
const $9138db1f951ed55c$export$af3433002e85528f = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M6 7H4v2h2zm0 3H4v2h2zm3-3H7v2h2zm0 3H7v2h2zm3-3h-2v2h2zm0 3h-2v2h2zm3-8h-1v2h-3V2H5v2H2V2H1a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m-1 11H2V6h12zM4 .494A.495.495 0 0 0 3.506 0h-.009A.496.496 0 0 0 3 .494V3h1zm9 0A.495.495 0 0 0 12.506 0h-.009A.496.496 0 0 0 12 .494V3h1z"
    })));
const $9138db1f951ed55c$export$ebaef9cfe20e1737 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M6 8.5c0 1.103.897 2 2 2s2-.897 2-2-.897-2-2-2-2 .897-2 2M15 3h-3.5c-.25-1-.5-2-1.5-2H6C5 1 4.75 2 4.5 3H1c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1m-7 9.5a4 4 0 1 1 0-8 4 4 0 0 1 0 8"
    })));
const $9138db1f951ed55c$export$e71f7b946c7cc127 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M16 14v2H0v-2zm-5-9v8H9V5zm4-4v12h-2V1zM3 9v4H1V9zm4-6v10H5V3z"
    })));
const $9138db1f951ed55c$export$51e1bcc8c9b70cf = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M16 14v2H0v-2zm-2.708-9.61A1.499 1.499 0 0 1 14.5 2a1.5 1.5 0 0 1 0 3l-.052-.001-3.74 5.611A1.499 1.499 0 0 1 9.5 13a1.5 1.5 0 0 1-1.249-2.33L5.626 6.995a2 2 0 0 1-.252 0L2.749 10.67a1.5 1.5 0 1 1-1.123-.665L4.251 6.33a1.5 1.5 0 1 1 2.498 0l2.625 3.675a2 2 0 0 1 .178-.004z"
    })));
const $9138db1f951ed55c$export$acdc8ffe67b5cfdc = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M7 9h7c-.05 3.913-3.167 7-7 7-3.863 0-7-3.137-7-7s3.137-7 7-7zm9-2H9V0l1.41.142C13.576.793 15.962 3.577 16 7"
    })));
const $9138db1f951ed55c$export$c99fa69b6fe4cbfa = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M12.586 4.586 8 9.172 3.414 4.586 2 6l6 6 6-6z"
    })));
const $9138db1f951ed55c$export$d24fe4633d517542 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M12.586 6.586 8 11.172 3.414 6.586 2 8l6 6 6-6zM8.172 8.828h-.344l-.25-.25h.844zm.5-.5H7.328l-.25-.25h1.844zm.5-.5H6.828l-.25-.25h2.844zm.5-.5H6.328l-.25-.25h3.844zm.5-.5H5.828l-.25-.25h4.844zm.5-.5H5.328l-.25-.25h2.828L8 6.172l.094-.094h2.828zm-3.016-.5H4.828l-.25-.25h2.828zm3.516 0H8.344l.25-.25h2.828zm-4.016-.5H4.328l-.25-.25h2.828zm4.516 0H8.844l.25-.25h2.828zm-5.016-.5H3.828l-.25-.25h2.828zm5.516 0H9.344l.25-.25h2.828zm-6.016-.5H3.328l-.25-.25h2.828zm6.516 0H9.844l.25-.25h2.828zm-7.016-.5H2.828l-.25-.25h2.828zm7.516 0h-2.828l.25-.25h2.828zm-8.016-.5H2.328l-.25-.25h2.828zm8.516 0h-2.828l.25-.25h2.828zm-9.016-.5H2.172l.25-.25h1.984zm9.172 0h-2.484l.25-.25h1.984zm-9.672-.5H2.672l.242-.242h1zm9.172 0h-1.484l.242-.242h1zm-9.664-.492h-.5l.25-.25zm9.172 0h-.5l.25-.25z"
    })));
const $9138db1f951ed55c$export$6be9a9d30ce9b0ed = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M14.586 3.586 8 10.172 1.414 3.586 0 5l8 8 8-8z"
    })));
const $9138db1f951ed55c$export$5257c06aa807f52c = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M11.414 12.586 6.828 8l4.586-4.586L10 2 4 8l6 6z"
    })));
const $9138db1f951ed55c$export$bd98fc092ca567ad = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M9.414 12.586 4.828 8l4.586-4.586L8 2 2 8l6 6zM7.172 8.172v-.344l.25-.25v.844zm.5.5V7.328l.25-.25v1.844zm.5.5V6.828l.25-.25v2.844zm.5.5V6.328l.25-.25v3.844zm.5.5V5.828l.25-.25v4.844zm.5.5V5.328l.25-.25v2.828L9.828 8l.094.094v2.828zm.5-3.016V4.828l.25-.25v2.828zm0 3.516V8.344l.25.25v2.828zm.5-4.016V4.328l.25-.25v2.828zm0 4.516V8.844l.25.25v2.828zm.5-5.016V3.828l.25-.25v2.828zm0 5.516V9.344l.25.25v2.828zm.5-6.016V3.328l.25-.25v2.828zm0 6.516V9.844l.25.25v2.828zm.5-7.016V2.828l.25-.25v2.828zm0 7.516v-2.828l.25.25v2.828zm.5-8.016V2.328l.25-.25v2.828zm0 8.516v-2.828l.25.25v2.828zm.5-9.016V2.172l.25.25v1.984zm0 9.172v-2.484l.25.25v1.984zm.5-9.672V2.672l.242.242v1zm0 9.172v-1.484l.242.242v1zm.492-9.664v-.5l.25.25zm0 9.172v-.5l.25.25z"
    })));
const $9138db1f951ed55c$export$87375f63e1783ecd = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M12.414 14.586 5.828 8l6.586-6.586L11 0 3 8l8 8z"
    })));
const $9138db1f951ed55c$export$1871f85e3a28ae2d = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M4.586 3.414 9.172 8l-4.586 4.586L6 14l6-6-6-6z"
    })));
const $9138db1f951ed55c$export$5bb5160993ff67f0 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M6.586 3.414 11.172 8l-4.586 4.586L8 14l6-6-6-6zm2.242 4.414v.344l-.25.25v-.844zm-.5-.5v1.344l-.25.25V7.078zm-.5-.5v2.344l-.25.25V6.578zm-.5-.5v3.344l-.25.25V6.078zm-.5-.5v4.344l-.25.25V5.578zm-.5-.5v5.344l-.25.25V8.094L6.172 8l-.094-.094V5.078zm-.5 3.016v2.828l-.25.25V8.594zm0-3.516v2.828l-.25-.25V4.578zm-.5 4.016v2.828l-.25.25V9.094zm0-4.516v2.828l-.25-.25V4.078zm-.5 5.016v2.828l-.25.25V9.594zm0-5.516v2.828l-.25-.25V3.578zm-.5 6.016v2.828l-.25.25v-2.828zm0-6.516v2.828l-.25-.25V3.078zm-.5 7.016v2.828l-.25.25v-2.828zm0-7.516v2.828l-.25-.25V2.578zm-.5 8.016v2.828l-.25.25v-2.828zm0-8.516v2.828l-.25-.25V2.078zm-.5 9.016v2.484l-.25-.25v-1.984zm0-9.172v2.484l-.25-.25V2.422zm-.5 9.672v1.484l-.242-.242v-1zm0-9.172v1.484l-.242-.242v-1zm-.492 9.664v.5l-.25-.25zm0-9.172v.5l-.25-.25z"
    })));
const $9138db1f951ed55c$export$f98cf460e7941c2b = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M3.586 1.414 10.172 8l-6.586 6.586L5 16l8-8-8-8z"
    })));
const $9138db1f951ed55c$export$61133413a12a7ef4 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M2 15h2V1H2zM14.4 2.4 13 1 6 8l7 7 1.4-1.4L8.8 8z"
    })));
const $9138db1f951ed55c$export$e4779f93e989d6cc = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M14 1h-2v14h2zM7.2 8l-5.6 5.6L3 15l7-7-7-7-1.4 1.4z"
    })));
const $9138db1f951ed55c$export$66e62118032befb3 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M3.414 11.414 8 6.828l4.586 4.586L14 10 8 4l-6 6z"
    })));
const $9138db1f951ed55c$export$ef1b2d050d1d9596 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M3.414 9.414 8 4.828l4.586 4.586L14 8 8 2 2 8zm4.414-2.242h.344l.25.25h-.844zm-.5.5h1.344l.25.25H7.078zm-.5.5h2.344l.25.25H6.578zm-.5.5h3.344l.25.25H6.078zm-.5.5h4.344l.25.25H5.578zm-.5.5h5.344l.25.25H8.094L8 9.828l-.094.094H5.078zm3.016.5h2.828l.25.25H8.594zm-3.516 0h2.828l-.25.25H4.578zm4.016.5h2.828l.25.25H9.094zm-4.516 0h2.828l-.25.25H4.078zm5.016.5h2.828l.25.25H9.594zm-5.516 0h2.828l-.25.25H3.578zm6.016.5h2.828l.25.25h-2.828zm-6.516 0h2.828l-.25.25H3.078zm7.016.5h2.828l.25.25h-2.828zm-7.516 0h2.828l-.25.25H2.578zm8.016.5h2.828l.25.25h-2.828zm-8.516 0h2.828l-.25.25H2.078zm9.016.5h2.484l-.25.25h-1.984zm-9.172 0h2.484l-.25.25H2.422zm9.672.5h1.484l-.242.242h-1zm-9.172 0h1.484l-.242.242h-1zm9.664.492h.5l-.25.25zm-9.172 0h.5l-.25.25z"
    })));
const $9138db1f951ed55c$export$cd6ea45e6c6fa795 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M1.414 12.414 8 5.828l6.586 6.586L16 11 8 3l-8 8z"
    })));
const $9138db1f951ed55c$export$f72e08a2ef494448 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M7 9h2V4H7zm2 2a1 1 0 1 0-2 0 1 1 0 1 0 2 0m7-3c0-4.419-3.581-8-8-8S0 3.581 0 8s3.581 8 8 8 8-3.581 8-8m-2 0a5.97 5.97 0 0 1-1.756 4.244C11.109 13.375 9.603 14 8 14s-3.109-.625-4.244-1.756C2.625 11.109 2 9.603 2 8s.625-3.109 1.756-4.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756A5.97 5.97 0 0 1 14 8"
    })));
const $9138db1f951ed55c$export$543083732c6741d9 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M0 8c0 4.419 3.581 8 8 8s8-3.581 8-8-3.581-8-8-8-8 3.581-8 8m12.891 3.478L4.522 3.109A5.97 5.97 0 0 1 8 2c1.603 0 3.109.625 4.244 1.756A5.97 5.97 0 0 1 14 8a5.97 5.97 0 0 1-1.109 3.478M2 8c0-1.266.391-2.469 1.109-3.478l8.369 8.369A5.97 5.97 0 0 1 8 14a5.97 5.97 0 0 1-4.244-1.756A5.97 5.97 0 0 1 2 8"
    })));
const $9138db1f951ed55c$export$5ec4aa1366cd882 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M7 12h2V7H7zm1-8a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0-4a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.243 12.243C11.109 13.376 9.603 14 8 14s-3.109-.624-4.243-1.757C2.624 11.109 2 9.603 2 8s.624-3.109 1.757-4.243C4.891 2.624 6.397 2 8 2s3.109.624 4.243 1.757A5.96 5.96 0 0 1 14 8a5.96 5.96 0 0 1-1.757 4.243"
    })));
const $9138db1f951ed55c$export$e356a46c6dfa0cd = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m4.244 12.244C11.109 13.375 9.603 14 8 14s-3.109-.625-4.244-1.756A5.97 5.97 0 0 1 2 8c0-1.603.625-3.109 1.756-4.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756A5.97 5.97 0 0 1 14 8a5.97 5.97 0 0 1-1.756 4.244M5 11h2V5H5zm4 0h2V5H9z"
    })));
const $9138db1f951ed55c$export$f251922d9c0b7d86 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "m5 11 4-3-4-3zM8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m4.244 12.244C11.109 13.375 9.603 14 8 14s-3.109-.625-4.244-1.756A5.97 5.97 0 0 1 2 8c0-1.603.625-3.109 1.756-4.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756A5.97 5.97 0 0 1 14 8a5.97 5.97 0 0 1-1.756 4.244M9 8v3h2V5H9z"
    })));
const $9138db1f951ed55c$export$b8c4b2c7e344e0c3 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "m6 12 6-4-6-4zM8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m4.244 12.244C11.109 13.375 9.603 14 8 14s-3.109-.625-4.244-1.756C2.625 11.109 2 9.603 2 8s.625-3.109 1.756-4.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756C13.375 4.891 14 6.397 14 8s-.625 3.109-1.756 4.244"
    })));
const $9138db1f951ed55c$export$94c33b488623435e = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8 10.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.243 12.243C11.109 13.376 9.603 14 8 14s-3.109-.624-4.243-1.757C2.624 11.109 2 9.603 2 8s.624-3.109 1.757-4.243C4.891 2.624 6.397 2 8 2s3.109.624 4.243 1.757A5.96 5.96 0 0 1 14 8a5.96 5.96 0 0 1-1.757 4.243M7.927 3.755c-2.248 0-2.76 1.695-2.802 2.906h1.571c.028-.256.101-1.418 1.221-1.418.672 0 1.206.406 1.206 1.175 0 .695-.724 1.155-1.303 1.711s-.652 1.196-.652 1.695V10h1.615v-.176c0-1.256 1.967-1.594 1.967-3.541 0-1.224-.876-2.528-2.823-2.528"
    })));
const $9138db1f951ed55c$export$1d64b5b770b4b3ed = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8 .035a7.986 7.986 0 0 1 7.983 7.982A7.987 7.987 0 0 1 8 16 7.987 7.987 0 0 1 .017 8.017 7.986 7.986 0 0 1 8 .035m0 2a5.986 5.986 0 0 0-5.983 5.982A5.986 5.986 0 0 0 8 14a5.986 5.986 0 0 0 5.983-5.983A5.986 5.986 0 0 0 8 2.035m-.011 2.982a2.984 2.984 0 0 1 0 5.966 2.984 2.984 0 0 1 0-5.966"
    })));
const $9138db1f951ed55c$export$5836eb8e2e3e864d = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M5 11h6V5H5zM8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m4.244 12.244C11.109 13.375 9.603 14 8 14s-3.109-.625-4.244-1.756C2.625 11.109 2 9.603 2 8s.625-3.109 1.756-4.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756C13.375 4.891 14 6.397 14 8s-.625 3.109-1.756 4.244"
    })));
const $9138db1f951ed55c$export$c65898577f07616b = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m4.244 12.244C11.109 13.375 9.603 14 8 14s-3.109-.625-4.244-1.756C2.625 11.109 2 9.603 2 8s.625-3.109 1.756-4.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756C13.375 4.891 14 6.397 14 8s-.625 3.109-1.756 4.244m-1.46-7.328L7.016 9.103 5.262 7.372 3.856 8.794 7.1 12l5.169-5.747z"
    })));
const $9138db1f951ed55c$export$6fb1bca6e16c2c94 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M10.294 4.294 8 6.584 5.706 4.291 4.291 5.706 6.584 8 4.29 10.294l1.416 1.416L8 9.416l2.294 2.294 1.416-1.416L9.416 8l2.294-2.294zM8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m4.244 12.244C11.109 13.375 9.603 14 8 14s-3.109-.625-4.244-1.756C2.625 11.109 2 9.603 2 8s.625-3.109 1.756-4.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756C13.375 4.891 14 6.397 14 8s-.625 3.109-1.756 4.244"
    })));
const $9138db1f951ed55c$export$5a17af862a7576da = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M11 2c0-.6-.4-1-1-1h-.6C9.2.4 8.7 0 8 0S6.8.4 6.6 1H6c-.6 0-1 .4-1 1v2h6zm2 0h-1v2h1v10H3V4h1V2H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2M7 9.7 5.2 8 3.8 9.4 7 12.6l5.2-5.7-1.5-1.3z"
    })));
const $9138db1f951ed55c$export$b21a11de10d6bf76 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M11 6H5v2h6zm0-4c0-.6-.4-1-1-1h-.6C9.2.4 8.7 0 8 0S6.8.4 6.6 1H6c-.6 0-1 .4-1 1v2h6zm0 8H5v2h6zm2-8h-1v2h1v10H3V4h1V2H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2"
    })));
const $9138db1f951ed55c$export$17345b07225e0aa = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8 0a7.97 7.97 0 0 0-6 2.709V0H0v6h6V4H3.528c.072-.084.153-.162.228-.244C4.891 2.625 6.397 2 8 2s3.109.625 4.244 1.756C13.375 4.891 14 6.397 14 8s-.625 3.109-1.756 4.244C11.109 13.375 9.603 14 8 14s-3.113-.619-4.244-1.756S2 9.603 2 8H0c0 4.419 3.581 8 8 8s8-3.581 8-8-3.581-8-8-8M7 4v4.416l3.291 3.291 1.416-1.416L9 7.584V4z"
    })));
const $9138db1f951ed55c$export$bbbb9b7c1aff7988 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M9 4H7v4.416l3.294 3.291 1.413-1.416L9 7.584zM8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m0 14c-3.312 0-6-2.688-6-6s2.688-6 6-6 6 2.688 6 6-2.688 6-6 6"
    })));
const $9138db1f951ed55c$export$1610bcb056ae58bb = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M12.294 3.294 10.878 4.71 13.5 8l-2.622 3.294 1.416 1.416L16 8zM5.122 4.706 3.706 3.291 0 8l3.706 4.706 1.416-1.416L2.5 8zM6 13h2l2-10H8z"
    })));
const $9138db1f951ed55c$export$4073c4c5b5a233d4 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M16 9V7l-2.259-.753a6 6 0 0 0-.441-1.066l1.066-2.131-1.416-1.416L10.819 2.7a6.3 6.3 0 0 0-1.066-.441L9 0H7l-.753 2.259a6 6 0 0 0-1.066.441L3.05 1.638 1.638 3.05l1.066 2.131a6 6 0 0 0-.445 1.066L0 7v2l2.259.753c.112.372.263.728.441 1.066L1.634 12.95l1.416 1.416L5.181 13.3c.338.178.694.328 1.066.441L7 16h2l.753-2.259a6 6 0 0 0 1.066-.441l2.131 1.066 1.416-1.416-1.066-2.131c.178-.337.328-.694.441-1.066zm-8 2a3.001 3.001 0 0 1 0-6 3.001 3.001 0 0 1 0 6"
    })));
const $9138db1f951ed55c$export$fa207a04e28a42cb = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M15 1 1 6l7 2 2 7z"
    })));
const $9138db1f951ed55c$export$6df11ed8ec8f8d62 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m0 14c-3.312 0-6-2.688-6-6s2.688-6 6-6 6 2.688 6 6-2.688 6-6 6M6.5 6.5 4 11v1h1l4.5-2.5L12 5V4h-1zM8 9a1 1 0 1 1 0-2 1 1 0 1 1 0 2"
    })));
const $9138db1f951ed55c$export$ec3499dc3f62d571 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m4.244 12.244A5.95 5.95 0 0 1 9 13.919V11H7v2.919a5.96 5.96 0 0 1-3.244-1.675A5.98 5.98 0 0 1 2.081 9H5V7H2.081c.203-1.222.781-2.35 1.675-3.244S5.775 2.284 7 2.081V5h2V2.081a5.96 5.96 0 0 1 3.244 1.675A5.95 5.95 0 0 1 13.919 7H11v2h2.919a6 6 0 0 1-1.675 3.244"
    })));
const $9138db1f951ed55c$export$daacca6cce9e30d3 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M13.916 7A6.005 6.005 0 0 0 9 2.084V0H7v2.084A6.005 6.005 0 0 0 2.084 7H0v2h2.084A6.005 6.005 0 0 0 7 13.916V16h2v-2.084A6 6 0 0 0 13.916 9H16V7zm-3.088 3.828C10.072 11.584 9.069 12 8 12s-2.072-.416-2.828-1.172S4 9.069 4 8s.416-2.072 1.172-2.828S6.931 4 8 4s2.072.416 2.828 1.172S12 6.931 12 8s-.416 2.072-1.172 2.828M8 6c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2"
    })));
const $9138db1f951ed55c$export$23ce67b3071ee16e = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m4 6H6.181a.494.494 0 0 0-.493.494v.009c0 .272.222.494.494.494H10c1.103 0 2 .897 2 2v1c0 1.103-.897 2-2 2H9v1H7v-1H4v-2h5.506A.495.495 0 0 0 10 9.503v-.009A.495.495 0 0 0 9.506 9H5.981A1.98 1.98 0 0 1 4 7.019V6c0-1.103.897-2 2-2h1V3h2v1h3z"
    })));
const $9138db1f951ed55c$export$65f71275cd169acd = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.707 11.293-1.414 1.414L8 9.414l-3.293 3.293-1.414-1.414L6.586 8 3.293 4.707l1.414-1.414L8 6.586l3.293-3.293 1.414 1.414L9.414 8z"
    })));
const $9138db1f951ed55c$export$cb9a136b7e677418 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M12.706 8.294 11.29 6.878 9 9.172V0H7v9.172L4.706 6.878 3.291 8.294 8 13zM16 14H0v2h16z"
    })));
const $9138db1f951ed55c$export$70f26903e40c814d = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M12.706 8.294 11.29 6.878 9 9.172V0H7v9.172L4.706 6.878 3.291 8.294 8 13zM14 4v10H2V4H0v12h16V4z"
    })));
const $9138db1f951ed55c$export$d5822d1e3e781a7c = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8 13c2 0 4.497-1.5 4-4-1 0-6 4-4 4M8 0S1 5 1 10c0 4 3.688 6 7 6s7-2 7-6C15 5 8 0 8 0m4.606 11.687c-.244.456-.6.866-1.062 1.209a5.4 5.4 0 0 1-1.641.816C9.294 13.9 8.637 14 8 14s-1.294-.1-1.903-.288a5.3 5.3 0 0 1-1.641-.816 3.7 3.7 0 0 1-1.062-1.209C3.131 11.194 3 10.625 3 10c0-.788.278-1.684.825-2.669.494-.891 1.2-1.831 2.094-2.794A25 25 0 0 1 8 2.553a24 24 0 0 1 2.084 1.984c.894.966 1.6 1.906 2.094 2.794.544.985.822 1.881.822 2.669 0 .625-.134 1.194-.394 1.687"
    })));
const $9138db1f951ed55c$export$74e5b01e82a6f5df = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M4 8c0-1.103-.897-2-2-2s-2 .897-2 2 .897 2 2 2 2-.897 2-2m2 0c0 1.103.897 2 2 2s2-.897 2-2-.897-2-2-2-2 .897-2 2m6 0c0 1.103.897 2 2 2s2-.897 2-2-.897-2-2-2-2 .897-2 2"
    })));
const $9138db1f951ed55c$export$b307b75901e71920 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8 4c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2m0 2c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2m0 6c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2"
    })));
const $9138db1f951ed55c$export$8f179830d10593db = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M0 6v8h16V6l-8 5zm0-4v2l8 5 8-5V2z"
    })));
const $9138db1f951ed55c$export$5af68724e0a1bf3d = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M2 11h12V9H2zm0-6v2h12V5z"
    })));
const $9138db1f951ed55c$export$35a394b139d2779b = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M1 11h14V9H1zm0-6v2h14V5z"
    })));
const $9138db1f951ed55c$export$d37d6805b1edaaab = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M9 11a1 1 0 1 0-2 0 1 1 0 1 0 2 0m0-7v5H7V4z"
    })));
const $9138db1f951ed55c$export$5edd362dbec83f16 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M4.414 15.414 8 11.828l3.586 3.586L13 14 8 9l-5 5zM11.586.586 8 4.172 4.414.586 3 2l5 5 5-5z",
        style: {
            fillRule: "nonzero"
        }
    })));
const $9138db1f951ed55c$export$2a5f2ff1590ba9f0 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M13 11H9v2h6V1H3v6h2V3h8zM0 8v8h8v-2H3.412l6.294-6.294-1.412-1.412L2 12.587V8z"
    })));
const $9138db1f951ed55c$export$e4d1c1f093ddfc94 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M3 3h8v4h2V1H1v12h6v-2H3zm11 5v4.587L7.706 6.294 6.294 7.706 12.587 14H8v2h8V8z"
    })));
const $9138db1f951ed55c$export$b96e2b4e5f7775c1 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M16 16H0V0h16zM4 2v12h10V2zm1.586 3.414L8.172 8l-2.586 2.586L7 12l4-4-4-4z"
    })));
const $9138db1f951ed55c$export$bfc74f0b8ad1f2ce = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M0 0h16v16H0zm12 14V2H2v12zm-1.586-3.414L7.828 8l2.586-2.586L9 4 5 8l4 4z"
    })));
const $9138db1f951ed55c$export$c5cb8522150f3be8 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M13 13H5V9H3v6h12V3H9v2h4zM2 8V3.413l6.294 6.294 1.413-1.413L3.412 2H8V0H0v8z"
    })));
const $9138db1f951ed55c$export$10a0ddbd1861a097 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M3 5h4V3H1v12h12V9h-2v4H3zm13 3V0H8v2h4.587L6.294 8.294l1.413 1.413L14 3.413V8z"
    })));
const $9138db1f951ed55c$export$c52792559dd5fde = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M11.685 2.886zl2.9-2.9L16 1.4l-2.655 2.655C15.264 5.792 16 8 16 8s-2 6-8 6c-1.463 0-2.688-.357-3.704-.896L1.4 16l-1.414-1.414 2.654-2.654 1.415-1.416L5.472 9.1zm-5.879 8.708A5.9 5.9 0 0 0 8 12c3.479 0 5.214-2.733 5.832-4-.313-.644-.915-1.662-1.883-2.51.021.168.051.335.051.51a4 4 0 0 1-4.561 3.961zm-4.137-.692C.478 9.435 0 8 0 8s2-6 8-6a8 8 0 0 1 2.26.311L4.549 8.023A4 4 0 0 1 4 6c0-.174.03-.34.051-.509C3.082 6.34 2.481 7.358 2.168 8c.193.396.493.932.92 1.484z"
    })));
const $9138db1f951ed55c$export$5b296b74fc93300b = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8 2C2 2 0 8 0 8s2 6 8 6 8-6 8-6-2-6-8-6m0 10c-3.481 0-5.213-2.728-5.832-4 .313-.642.914-1.66 1.883-2.509C4.03 5.66 4 5.826 4 6a4 4 0 0 0 8 0c0-.175-.03-.342-.051-.51.968.848 1.57 1.866 1.883 2.51-.618 1.267-2.353 4-5.832 4"
    })));
const $9138db1f951ed55c$export$baa7a52704f72315 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M5 7a1 1 0 1 0 0-2 1 1 0 1 0 0 2m3 3a2 2 0 0 1-1.731-1H4.125a4.001 4.001 0 0 0 7.75 0H9.731c-.347.597-.993 1-1.731 1M8 0a8 8 0 0 0-8 8 8 8 0 0 0 8 8 8 8 0 0 0 8-8 8 8 0 0 0-8-8m4.244 12.244A5.97 5.97 0 0 1 8 14a5.97 5.97 0 0 1-4.244-1.756A5.97 5.97 0 0 1 2 8c0-1.603.625-3.109 1.756-4.244A5.97 5.97 0 0 1 8 2c1.603 0 3.109.625 4.244 1.756A5.97 5.97 0 0 1 14 8a5.97 5.97 0 0 1-1.756 4.244M11 5a1 1 0 1 0 0 2 1 1 0 1 0 0-2"
    })));
const $9138db1f951ed55c$export$3ca36d1b1b6880d8 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8 8a4 4 0 0 0-3.875 3h2.144c.347-.597.994-1 1.731-1s1.384.403 1.731 1h2.144A4.004 4.004 0 0 0 8 8M5 7a1 1 0 1 0 0-2 1 1 0 1 0 0 2m3-7a8 8 0 0 0-8 8 8 8 0 0 0 8 8 8 8 0 0 0 8-8 8 8 0 0 0-8-8m4.244 12.244A5.97 5.97 0 0 1 8 14a5.97 5.97 0 0 1-4.244-1.756A5.97 5.97 0 0 1 2 8c0-1.603.625-3.109 1.756-4.244A5.97 5.97 0 0 1 8 2c1.603 0 3.109.625 4.244 1.756A5.97 5.97 0 0 1 14 8a5.97 5.97 0 0 1-1.756 4.244M11 5a1 1 0 1 0 0 2 1 1 0 1 0 0-2"
    })));
const $9138db1f951ed55c$export$d05ae46b0b12cd6f = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M0 16h3V0H0zm10-8V4L4 8v8h6v-4h2v4h4V4z"
    })));
const $9138db1f951ed55c$export$ccb23f910e5c3193 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "m14 0-2 2v2h-2V2L8 0 6 2v2H4V2L2 0 0 2v14h4v-2h2v2h4v-2h2v2h4V2zM4 12V6h2v6zm6 0V6h2v6z"
    })));
const $9138db1f951ed55c$export$f153bd1599ddd890 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M7 16v-6L0 2V0h16v2l-7 8v4z"
    })));
const $9138db1f951ed55c$export$9fcd2875a6bf0e38 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M2.009 0h-.018A.99.99 0 0 0 1 .991V16h2V.991A.99.99 0 0 0 2.009 0M16 1H4v8h12l-4-4z"
    })));
const $9138db1f951ed55c$export$964c15ec9e30ae83 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "m9.65 4.05.45.45c.9.95 1.6 1.9 2.1 2.8.55 1 .85 1.9.85 2.65 0 .6-.15 1.2-.4 1.7q-.375.675-1.05 1.2c-.45.35-1 .6-1.65.8-.65.25-1.3.35-1.95.35s-1.3-.1-1.9-.3-1.15-.45-1.65-.8q-.675-.525-1.05-1.2c-.25-.5-.4-1.05-.4-1.7 0-.6.2-1.3.65-2.1.1-.2.2-.4.35-.6.8.65 1.55.8 2.05.8.85 0 1.65-.4 2.3-1.1.4-.5.75-1.1 1-1.85.1-.35.2-.7.3-1.1M8 0c0 3.9-.85 6.1-1.95 6.1C5.45 6.1 4.7 5.45 4 4c-1.65 1.85-3 4-3 6 0 4 3.7 6 7 6s7-2 7-6C15 5 8 0 8 0"
    })));
const $9138db1f951ed55c$export$5c5e312ef0488786 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M5 2v4L.817 12.971A2.001 2.001 0 0 0 2.532 16h10.936a2 2 0 0 0 1.715-3.029L11 6V2h1V0H4v2zm6.068 8H4.932L7 6.554V2h2v4.554z"
    })));
const $9138db1f951ed55c$export$22e733acfe1431e6 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "m7 1 2 2h7v11H0V1z"
    })));
const $9138db1f951ed55c$export$6c64be5e42deae66 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m0 14c-3.312 0-6-2.688-6-6s2.688-6 6-6 6 2.688 6 6-2.688 6-6 6m.225-5.984L6.172 5.387l.575 3.287a1.5 1.5 0 1 0 1.478-.658M8 3a5 5 0 0 0-4.9 4h1.141A3.84 3.84 0 0 1 5.25 5.25C5.984 4.516 6.963 4.113 8 4.113s2.016.403 2.75 1.137A3.85 3.85 0 0 1 11.759 7H12.9A5 5 0 0 0 8 3"
    })));
const $9138db1f951ed55c$export$476bfa1ddc2dfe7a = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M13 9v2h-2.488a.5.5 0 0 1-.169-.069L7.416 8l2.931-2.931A.5.5 0 0 1 10.516 5H13v2l3-3-3-3v2h-2.5c-.538 0-1.181.266-1.559.647L6.584 6H0v4h6.584l2.353 2.353c.382.381 1.022.647 1.56.647h2.5v2l3-3z"
    })));
const $9138db1f951ed55c$export$922c85641f9f6751 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8 0C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8M3.756 12.244A5.97 5.97 0 0 1 2 8q0-.855.231-1.653l.506 1.334 2.819 2.225.469.106-.691 1.106 1.022 2.653a6 6 0 0 1-2.6-1.527m9.066-.669a6 6 0 0 1-.578.669 5.96 5.96 0 0 1-4.041 1.753l1.678-1.325.216-1.131-4.241-1.972-.262-.457-.344-.237-.178-.784-.581.237.194-.762.694-.091.619.688.202-1.188.759-1.05.809-.287.082-.547-.175-.188.766-.125.087-.6-.694-.716-.593.079-.735-.366-.4 1.253-.884-.537 1.284-1.344-1.644.334a5.96 5.96 0 0 1 2.759-.869L9.484 3.65l.684.184.144-.528.703-.491c.441.256.85.572 1.219.941q.276.278.516.584l-.544.941-.534.106.656 4.137.731.766zm.037-5.384.247-.331.281.34z"
    })));
const $9138db1f951ed55c$export$4a42f583c9418002 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        fillRule: "evenodd",
        d: "M2 5h12v1h-1v8h2v1h1v1H0v-1h1v-1h2V6H2zm5 1H5v8h2zm2 0h2v8H9zM8.112.056a.25.25 0 0 0-.224 0l-6.94 3.47C.71 3.644.794 4 1.058 4h13.882c.264 0 .348-.356.112-.474zM8 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
        clipRule: "evenodd"
    })));
const $9138db1f951ed55c$export$384500bdee9cfb28 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M3 7V5H1v2zm0 4V9H1v2zm4-4V5H5v2zm0 4V9H5v2zm4-4V5H9v2zm0 4V9H9v2zm4-4V5h-2v2zm0 4V9h-2v2z"
    })));
const $9138db1f951ed55c$export$686e909ad6dbb500 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M7 13H5v2h2zm4 0H9v2h2zM7 9H5v2h2zm4 0H9v2h2zM7 5H5v2h2zm4 0H9v2h2zM7 1H5v2h2zm4 0H9v2h2z"
    })));
const $9138db1f951ed55c$export$77134c21538c4a4c = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M1 9h14V7H1zm0 5h14v-2H1zM1 2v2h14V2z"
    })));
const $9138db1f951ed55c$export$89331070f6fc9967 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8 8V1a1 1 0 0 1 2 0v7h1V2a1 1 0 0 1 2 0v6h1V5a1 1 0 0 1 2 0v9a2 2 0 0 1-2 2H7c-.63 0-1.222-.296-1.6-.8L0 8a1.63 1.63 0 0 1 2.131-.152L5 10V3a1 1 0 0 1 2 0v5z"
    })));
const $9138db1f951ed55c$export$90416b71b616b91 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M5 11V4.5a1.5 1.5 0 0 1 3 0V8h1.528c.31 0 .617.072.894.211l2.472 1.236A2 2 0 0 1 14 11.236V14a2 2 0 0 1-2 2H6.702c-.455 0-.895-.155-1.25-.438L1 12a1 1 0 0 1 1-1zM2 4.5C2 2.016 4.016 0 6.5 0S11 2.016 11 4.5H9a2.5 2.5 0 0 0-5 0z"
    })));
const $9138db1f951ed55c$export$84d82bc35f21d6b6 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M3 10V1H0v9zm12 1a.997.997 0 0 0 1-1V6.277a1 1 0 0 0-.143-.515l-2.274-3.791A2 2 0 0 0 11.868 1H6a2 2 0 0 0-2 2v7.298c0 .455.155.895.438 1.25L8 16a1 1 0 0 0 1-1v-4z"
    })));
const $9138db1f951ed55c$export$ffd6616d7f2ec8c7 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M3 6v9H0V6zm12-1a.997.997 0 0 1 1 1v3.723a1 1 0 0 1-.143.515l-2.274 3.791a2 2 0 0 1-1.715.971H6a2 2 0 0 1-2-2V5.702c0-.455.155-.895.438-1.25L8 0a1 1 0 0 1 1 1v4z"
    })));
const $9138db1f951ed55c$export$9551e39be92a9bc5 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M11 8H5V1H3v14h2v-5h6v5h2V1h-2z"
    })));
const $9138db1f951ed55c$export$3094a1b9f32c68d5 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M11.75 1A4.25 4.25 0 0 0 8 3.249 4.25 4.25 0 0 0 0 5.25C0 11 8 15 8 15s8-4 8-9.75A4.25 4.25 0 0 0 11.75 1"
    })));
const $9138db1f951ed55c$export$62a58013efdd2c1a = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M0 6v10h6v-6h4v6h6V6L8 0z"
    })));
const $9138db1f951ed55c$export$72fd52d03f766e5d = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M0 8v7h3v-4h3v4h6V8L6 3zm10-7L7.6 3 13 7.5V13h3V6z"
    })));
const $9138db1f951ed55c$export$b7a766f44e29e48c = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8 9 0 5l8-4 8 4zm6.397-1.8L16 8l-8 4-8-4 1.603-.8L8 10.397zm0 3L16 11l-8 4-8-4 1.603-.8L8 13.397z"
    })));
const $9138db1f951ed55c$export$f6547b3d6e6e28f2 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "m9.439 3-5 10H1v2h9v-2H6.561l5-10H15V1H6v2z"
    })));
const $9138db1f951ed55c$export$bf1e1a02918ee573 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M16 4a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zm-4 6v2H4v-2zM4 7v2H2V7zm3 0v2H5V7zm3 0v2H8V7zm4 0v2h-3V7zM4 4v2H2V4zm3 0v2H5V4zm3 0v2H8V4zm4 0v2h-3V4z"
    })));
const $9138db1f951ed55c$export$4c6f701ae5fe9073 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M0 16h7V0H0zm15 0V0H8v16z"
    })));
const $9138db1f951ed55c$export$af3a5aeff000074d = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M7 9v7H0V9zm8 0v7H8V9zM7 1v7H0V1zm8 0v7H8V1z"
    })));
const $9138db1f951ed55c$export$3b51a6b9653487d2 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M1 1h4v4H1zm5 0h4v4H6zm5 0h4v4h-4zM1 6h4v4H1zm5 0h4v4H6zm5 0h4v4h-4zM1 11h4v4H1zm5 0h4v4H6zm5 0h4v4h-4z"
    })));
const $9138db1f951ed55c$export$ae59d452b696795b = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M0 0v7h16V0zm0 15h16V8H0z"
    })));
const $9138db1f951ed55c$export$b64d86384c92f1e0 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8 0a7 7 0 0 0-7 7v9h2v-4a7 7 0 0 1 7-7h2a7 7 0 0 0-7 7v2h3a7 7 0 0 0 7-7V0z"
    })));
const $9138db1f951ed55c$export$c1c6fe15475bbb7e = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M6.794 12.794c-.478.475-1.113.737-1.794.737s-1.316-.262-1.794-.738a2.54 2.54 0 0 1 0-3.584L5.5 6.916 4.084 5.5 1.791 7.794a4.54 4.54 0 0 0 .003 6.413c.853.855 1.99 1.324 3.206 1.324s2.353-.469 3.206-1.325l2.294-2.294L9.084 10.5zm7.412-11C13.353.938 12.216.469 11 .469S8.647.938 7.794 1.794L5.5 4.084 6.916 5.5 9.21 3.206c.474-.475 1.109-.737 1.79-.737s1.316.263 1.794.737a2.537 2.537 0 0 1 0 3.584L10.5 9.084l1.416 1.416 2.294-2.294a4.54 4.54 0 0 0-.004-6.412m-2.5 3.912L10.29 4.29l-6 6 1.416 1.416z"
    })));
const $9138db1f951ed55c$export$8eec6b150ddf7426 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M0 10V9h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-.75a.25.25 0 0 0-.25.25v.5a.25.25 0 0 0 .25.25H3v1H1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h.75a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25zm4 1h12v2H4zm0-4h12v2H4zM1 3.25A.25.25 0 0 0 .75 3H0V2h1a1 1 0 0 1 1 1v4H1zM4 3h12v2H4z"
    })));
const $9138db1f951ed55c$export$8e6bd23949fc26d0 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M4 3v2h12V3zM0 5h2V3H0zm4 4h12V7H4zM0 9h2V7H0zm4 4h12v-2H4zm-4 0h2v-2H0z"
    })));
const $9138db1f951ed55c$export$70cca5edf1a67180 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M12.25 7H12V4c0-1.653-1.347-3-3-3H7C5.347 1 4 2.347 4 4v1h2V4c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v3H3.75a.753.753 0 0 0-.75.75v6.5c0 .412.338.75.75.75h8.5c.412 0 .75-.338.75-.75v-6.5a.753.753 0 0 0-.75-.75"
    })));
const $9138db1f951ed55c$export$d5b6665210f0a539 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M12.25 7H12V4c0-1.653-1.347-3-3-3H7C5.347 1 4 2.347 4 4v3h-.25a.753.753 0 0 0-.75.75v6.5c0 .413.338.75.75.75h8.5c.413 0 .75-.337.75-.75v-6.5a.75.75 0 0 0-.75-.75M6 4c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v3H6z"
    })));
const $9138db1f951ed55c$export$247536f07b7c3b83 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M14 7h-1V4c0-2.206-1.794-4-4-4H7C4.794 0 3 1.794 3 4h2c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v3H2c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1m-5 5.731v.769c0 .55-.45 1-1 1s-1-.45-1-1v-.769a2 2 0 1 1 2 0"
    })));
const $9138db1f951ed55c$export$5c8bd75215c9ed1f = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M14 7h-1V4c0-2.206-1.794-4-4-4H7C4.794 0 3 1.794 3 4v3H2c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1m-5 5.731v.769c0 .55-.45 1-1 1s-1-.45-1-1v-.769a2 2 0 1 1 2 0M5 7V4c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v3z"
    })));
const $9138db1f951ed55c$export$1692611780ac32d = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M14 14V2H8V0h8v16H8v-2zm-6.998-.998L12 8 7 3 5.584 4.416 8.172 7H0v2h8.172l-2.586 2.586z"
    })));
const $9138db1f951ed55c$export$2d4c748bd12d78e0 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M14 14V2H8V0h8v16H8v-2zm-9.002-.998L0 8l5-5 1.416 1.416L3.828 7H12v2H3.828l2.586 2.586z"
    })));
const $9138db1f951ed55c$export$b2a4ca5137e627ff = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "m15.708 13.587-3.675-3.675a6.5 6.5 0 1 0-2.121 2.121l3.675 3.675a1.003 1.003 0 0 0 1.414 0l.707-.707a1.003 1.003 0 0 0 0-1.414M3.318 9.682C2.468 8.832 2 7.702 2 6.5s.468-2.332 1.318-3.182S5.298 2 6.5 2s2.332.468 3.182 1.318S11 5.298 11 6.5s-.468 2.332-1.318 3.182S7.702 11 6.5 11s-2.332-.468-3.182-1.318"
    })));
const $9138db1f951ed55c$export$2b187ab490e92c13 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M3.5 5.5h6v2h-6z"
    }), $8v0nu.createElement("path", {
        d: "m12.033 9.912 3.675 3.675a1.003 1.003 0 0 1 0 1.414l-.707.707a1.003 1.003 0 0 1-1.414 0l-3.675-3.675a6.5 6.5 0 1 1 2.121-2.121m-8.715-.23A4.47 4.47 0 0 0 6.5 11a4.47 4.47 0 0 0 3.182-1.318A4.47 4.47 0 0 0 11 6.5a4.47 4.47 0 0 0-1.318-3.182A4.47 4.47 0 0 0 6.5 2a4.47 4.47 0 0 0-3.182 1.318A4.47 4.47 0 0 0 2 6.5a4.47 4.47 0 0 0 1.318 3.182"
    })));
const $9138db1f951ed55c$export$aef499440d07757c = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M7.5 7.5h2v-2h-2v-2h-2v2h-2v2h2v2h2z"
    }), $8v0nu.createElement("path", {
        d: "M15.708 13.587a1.003 1.003 0 0 1 0 1.414l-.707.707a1.003 1.003 0 0 1-1.414 0l-3.675-3.675a6.5 6.5 0 1 1 2.121-2.121zM2 6.5a4.47 4.47 0 0 0 1.318 3.182A4.47 4.47 0 0 0 6.5 11a4.47 4.47 0 0 0 3.182-1.318A4.47 4.47 0 0 0 11 6.5a4.47 4.47 0 0 0-1.318-3.182A4.47 4.47 0 0 0 6.5 2a4.47 4.47 0 0 0-3.182 1.318A4.47 4.47 0 0 0 2 6.5"
    })));
const $9138db1f951ed55c$export$89ad07d969809ef0 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "m.292 15.001.707.707a1.003 1.003 0 0 0 1.414 0l3.675-3.675a6.5 6.5 0 1 0-2.121-2.121L.292 13.587a1.003 1.003 0 0 0 0 1.414M9.5 11a4.47 4.47 0 0 1-3.182-1.318C5.468 8.832 5 7.702 5 6.5s.468-2.332 1.318-3.182S8.298 2 9.5 2s2.332.468 3.182 1.318S14 5.298 14 6.5s-.468 2.332-1.318 3.182A4.47 4.47 0 0 1 9.5 11"
    })));
const $9138db1f951ed55c$export$a85a53f46ea5d4e1 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "m0 3 5-2v12l-5 2zm11 0v12l-5-1.667v-12zm5-2v12l-4 1.6v-12z"
    })));
const $9138db1f951ed55c$export$ddb0bcf29e4fc4bb = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8 0C4.688 0 2 2.688 2 6c0 6 6 10 6 10s6-4 6-10c0-3.312-2.688-6-6-6m0 8a3.001 3.001 0 0 1 0-6 3.001 3.001 0 0 1 0 6"
    })));
const $9138db1f951ed55c$export$41cf3a9d8250975e = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M4 10.471V16l4-2 4 2v-5.529A5.99 5.99 0 0 0 14 6c0-3.311-2.689-6-6-6S2 2.689 2 6c0 1.775.773 3.372 2 4.471M8 3a3.001 3.001 0 0 1 0 6 3.001 3.001 0 0 1 0-6"
    })));
const $9138db1f951ed55c$export$448b293f3d913b8a = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M14 7H2v2h12z"
    })));
const $9138db1f951ed55c$export$8b95d566fbd56482 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M15 7H1v2h14z"
    })));
const $9138db1f951ed55c$export$40baeeb0bb7c9f71 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M11.5 0h-7C3.675 0 3 .675 3 1.5v13c0 .825.675 1.5 1.5 1.5h7c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5M8 15a1 1 0 1 1 0-2 1 1 0 1 1 0 2m4-3H4V2h8z"
    })));
const $9138db1f951ed55c$export$d7458318da00be20 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M16 5H4.988v9H16v1.988H3V3.012h13zM0 .012h14V2H1.988v12H0V.012m8.2 8.36L6.794 9.794 10.037 13l5.169-5.747-1.484-1.338-3.769 4.187z"
    })));
const $9138db1f951ed55c$export$c5e5312dcf5a204f = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M14.706 4.206 10.794.294A1 1 0 0 0 10.088 0H1v7h2V2h7v3h3v9H9v2h6V4.916c0-.266-.106-.522-.294-.71m-7.114 8.179L9 12.15v-1.288l-1.408-.231a3 3 0 0 0-.288-.697l.833-1.164-.91-.91-1.161.832a3.2 3.2 0 0 0-.689-.285L5.146 7H3.857l-.231 1.407a3.1 3.1 0 0 0-.692.285L1.771 7.86l-.911.91.832 1.163a3.2 3.2 0 0 0-.285.691L0 10.856v1.288l1.408.231c.066.244.166.475.285.691L.86 14.23l.91.91 1.164-.832c.219.119.447.219.691.285L3.857 16h1.289l.231-1.407c.244-.066.476-.166.688-.285l1.164.832.91-.91-.829-1.154c.116-.219.217-.447.282-.691m-3.1.403c-.71 0-1.289-.579-1.289-1.288s.579-1.288 1.289-1.288a1.289 1.289 0 1 1 0 2.576"
    })));
const $9138db1f951ed55c$export$4de7d3a780aa7d4b = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M14.706 4.206 10.794.294A1 1 0 0 0 10.088 0H1v8H0v4h10V8H3V2h7v3h3v9H3v-1H1v3h14V4.916c0-.266-.106-.522-.294-.71"
    })));
const $9138db1f951ed55c$export$37ce21e1ba043044 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M14.706 4.206 10.793.293A1 1 0 0 0 10.087 0H1v9h2V2h7v3h3v9H9v2h6V4.916c0-.266-.106-.522-.294-.71M9 10h2V9c0-1.653-1.347-3-3-3S5 7.347 5 9v1H.991a.995.995 0 0 0-.991.991v4.019c0 .543.447.99.991.99H7.01c.543 0 .99-.447.99-.991V10.99a.995.995 0 0 0-.991-.99H7V9c0-.55.45-1 1-1s1 .45 1 1zm-5 4a1 1 0 1 1 0-2 1 1 0 1 1 0 2"
    })));
const $9138db1f951ed55c$export$4a8a225852a3176 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M14.706 4.206 10.793.293A1 1 0 0 0 10.087 0H1v16h14V4.916c0-.266-.106-.522-.294-.71M13 14H3V2h7v3h3zM5.2 8.372 3.794 9.794 7.037 13l5.169-5.747-1.484-1.338-3.769 4.187z"
    })));
const $9138db1f951ed55c$export$63c83462b6ec5fb6 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M14.706 4.206c.188.188.294.444.294.71V16H1V0h9.087c.266 0 .519.106.706.293zM13 14V5h-3V2H3v12zm-7.586-3.586L4 9l4-4 4 4-1.414 1.414L9 8.828V13H7V8.828z"
    })));
const $9138db1f951ed55c$export$c04e66d9f370f139 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M14.706 4.206 10.793.293A1 1 0 0 0 10.087 0H1v16h14V4.916c0-.266-.106-.522-.294-.71M13 14H3V2h7v3h3z"
    })));
const $9138db1f951ed55c$export$509fad11b885abb0 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M3 3H1v13h11v-2H3zm9-3H4v13h11V3zm1 11H6V2h5v2h2z"
    })));
const $9138db1f951ed55c$export$b8f31e9a5cf17074 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M1 11v4h4l7-7-4-4zM11 1 9 3l4 4 2-2z"
    })));
const $9138db1f951ed55c$export$20df3a4d38f4449c = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M4 4h2v10H4zm10 10h-2a2 2 0 0 1-2-2V4h2v7.5c0 .133.053.26.146.354A.5.5 0 0 0 12.5 12H14zM2 2h12v2H2z"
    })));
const $9138db1f951ed55c$export$c273953023f3b0d9 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M11.5 7a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 11.5 7M13 8l-4 2-3-5-3 6v1h10zM0 1v14h16V1zm14 12H2V3h12z"
    })));
const $9138db1f951ed55c$export$1f35cd9a970948ef = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8 14H6v-4c-2.208 0-4-1.792-4-4 0-2.177 1.742-3.949 4-4h8v2h-2v10h-2V4H8z"
    })));
const $9138db1f951ed55c$export$3a9f56a1d1f9a714 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M14 7H9V2H7v5H2v2h5v5h2V9h5z"
    })));
const $9138db1f951ed55c$export$889d6f1a30ea74d6 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M15 7H9V1H7v6H1v2h6v6h2V9h6z"
    })));
const $9138db1f951ed55c$export$37ff0821c075ffdb = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M2 14h10V5H2zm2-7h6v5H4zm1-5v2h8v7h2V2z"
    })));
const $9138db1f951ed55c$export$f4bc043c492a6c31 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M4 2v9h10V2zm8 7H6V4h6zM3 5H1v9h10v-2H3z"
    })));
const $9138db1f951ed55c$export$cabb19bc45ece1c2 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M13 1H3v2h10zm2 3H1c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h2v4h10v-4h2c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1m-4 9H5V9h6zm3-6a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
    })));
const $9138db1f951ed55c$export$1a26968bd5e528c1 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M15.938 9h-2.02a6 6 0 0 1-1.674 3.244A5.97 5.97 0 0 1 8 14a5.97 5.97 0 0 1-4.244-1.756A5.97 5.97 0 0 1 2 8a5.97 5.97 0 0 1 2-4.472V6h2V0H0v2h2.709A7.98 7.98 0 0 0 0 8a8 8 0 0 0 8 8 8 8 0 0 0 7.938-7m-5.154-4.084 1.485 1.337L7.1 12 3.856 8.794l1.406-1.422 1.754 1.731zm3.536-1.822-1.427 1.427A5.9 5.9 0 0 1 13.918 7h2.02a7.96 7.96 0 0 0-1.618-3.906m-2.842.014 1.428-1.428A7.97 7.97 0 0 0 8 0v2a5.96 5.96 0 0 1 3.478 1.108"
    })));
const $9138db1f951ed55c$export$bf479e9952d124c2 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M4.522 12.892 3.094 14.32A7.96 7.96 0 0 0 7 15.938v-2.02a5.95 5.95 0 0 1-2.478-1.026m6.956 0A5.95 5.95 0 0 1 9 13.918v2.02a7.96 7.96 0 0 0 3.906-1.618zM13.918 9a5.95 5.95 0 0 1-1.026 2.478l1.428 1.428A7.96 7.96 0 0 0 15.938 9zM2.082 9H.062a7.96 7.96 0 0 0 1.618 3.906l1.428-1.428A5.95 5.95 0 0 1 2.082 9m8.702-4.084 1.485 1.337L7.1 12 3.856 8.794l1.406-1.422 1.754 1.731zm3.536-1.822-1.427 1.427A5.9 5.9 0 0 1 13.918 7h2.02a7.96 7.96 0 0 0-1.618-3.906M.062 7h2.02A5.98 5.98 0 0 1 4 3.528V6h2V0H0v2h2.709A7.98 7.98 0 0 0 .062 7m11.416-3.892 1.428-1.428A7.97 7.97 0 0 0 8 0v2a5.96 5.96 0 0 1 3.478 1.108"
    })));
const $9138db1f951ed55c$export$e936722be7af186a = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M7 15.938v-2.02a6 6 0 0 1-3.244-1.674A5.97 5.97 0 0 1 2 8a5.97 5.97 0 0 1 2-4.472V6h2V0H0v2h2.709A7.98 7.98 0 0 0 0 8a8 8 0 0 0 7 7.938m4.478-3.046A5.95 5.95 0 0 1 9 13.918v2.02a7.96 7.96 0 0 0 3.906-1.618zM15.938 9h-2.02a5.95 5.95 0 0 1-1.026 2.478l1.428 1.428A7.96 7.96 0 0 0 15.938 9m-5.154-4.084 1.485 1.337L7.1 12 3.856 8.794l1.406-1.422 1.754 1.731zm3.536-1.822-1.427 1.427A5.9 5.9 0 0 1 13.918 7h2.02a7.96 7.96 0 0 0-1.618-3.906m-2.842.014 1.428-1.428A7.97 7.97 0 0 0 8 0v2a5.96 5.96 0 0 1 3.478 1.108"
    })));
const $9138db1f951ed55c$export$cc12b47c9c533761 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M16 3V1c-4.188 0-7 2.812-7 7v7h7V8h-5c0-3.084 1.916-5 5-5M0 8v7h7V8H2c0-3.084 1.916-5 5-5V1C2.812 1 0 3.812 0 8"
    })));
const $9138db1f951ed55c$export$31a206cffc6bcef8 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M0 8h5c0 3.084-1.916 5-5 5v2c4.188 0 7-2.812 7-7V1H0zm9-7v7h5c0 3.084-1.916 5-5 5v2c4.188 0 7-2.812 7-7V1z"
    })));
const $9138db1f951ed55c$export$8aa06688994ea65a = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M6.999 16h2.002V0H6.999zM5.414 5.414 4 4 0 8l4 4 1.414-1.414L3.828 9H6V7H3.828zM12 4l-1.414 1.414L12.172 7H10v2h2.172l-1.586 1.586L12 12l4-4z"
    })));
const $9138db1f951ed55c$export$ce07c1505fc240fa = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M0 6.999v2.002h16V6.999zm7-3.171V6h2V3.828l1.586 1.586L12 4 8 0 4 4l1.414 1.414zm2 8.344V10H7v2.172l-1.586-1.586L4 12l4 4 4-4-1.414-1.414z"
    })));
const $9138db1f951ed55c$export$4ec862b3067b2249 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M2 8h6v6H6v-2.6L1.4 16l-1.414-1.414L4.572 10H2zm6-6h2v2.6L14.6 0l1.414 1.414L11.428 6H14v2H8z"
    })));
const $9138db1f951ed55c$export$3c2cb1e70bb7ddf8 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "m1.986 12.6 4.6-4.6L8 9.414 3.414 14h2.572v2h-6v-6h2zM12.586 2h-2.572V0h6v6h-2V3.4L9.414 8 8 6.586z"
    })));
const $9138db1f951ed55c$export$62497cdf6d0d1934 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M16 16 13 0H9v1H7V0H3L0 16h7v-4h2v4zM7 3h2v2H7zm0 7V7h2v3z"
    })));
const $9138db1f951ed55c$export$a7789793f3c2c8cc = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "m6.516 2.612 2.809.938.734 2.934.188.75.644.428 2.238 1.494.605 4.844H2.441l.331-1.65 1.125-.562.875-.438.191-.959zM5 0 3 10l-2 1-1 5h16l-1-8-3-2-1-4z"
    })));
const $9138db1f951ed55c$export$67a54af4fd4d9a2e = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M1 5v2a7.982 7.982 0 0 1 5.656 2.343A7.98 7.98 0 0 1 9 15h2C11 9.477 6.523 5 1 5m3 5a2 2 0 1 0-.001 3.999A2 2 0 0 0 4 10M1 1v2a11.955 11.955 0 0 1 8.485 3.515 12 12 0 0 1 2.573 3.815c.625 1.478.942 3.049.942 4.67h2C15 7.268 8.732 1 1 1"
    })));
const $9138db1f951ed55c$export$611ca684c7a93fe1 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M13.5 11c-.609 0-1.169.219-1.603.581l-6.9-3.45Q5.001 8.066 5 8q0-.066-.003-.131l6.9-3.45a2.5 2.5 0 1 0-.894-1.788l-6.9 3.45a2.5 2.5 0 1 0 0 3.838l6.9 3.45q-.004.065-.003.131a2.5 2.5 0 1 0 2.5-2.5"
    })));
const $9138db1f951ed55c$export$7cffb2c8835f2a25 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M10 6v2h3v6H3V8h3V6H1v10h14V6zM7 3.328V11h2V3.328l1.834 1.834L12 4 8 0 4 4l1.166 1.166z"
    })));
const $9138db1f951ed55c$export$72c7f3691d5e45db = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M16 16H0V0h16zM4 2v12h10V2zm6.414 8.586L7.828 8l2.586-2.586L9 4 5 8l4 4z"
    })));
const $9138db1f951ed55c$export$d11c632cbde2be34 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M0 0h16v16H0zm12 14V2H2v12zM5.586 5.414 8.172 8l-2.586 2.586L7 12l4-4-4-4z"
    })));
const $9138db1f951ed55c$export$3b59d4afb984fe49 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M15.006 12.262 8.994 1.737c-.547-.956-1.438-.956-1.984 0L.994 12.262C.447 13.219.9 14 2 14h12c1.1 0 1.553-.781 1.006-1.738M8 13a1.25 1.25 0 1 1-.002-2.498A1.25 1.25 0 0 1 8 13m1-3H7V5h2z"
    })));
const $9138db1f951ed55c$export$1ff70e20de9defba = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M4 12H0v2h4v1h3v-4H4zm5-2h3V6H9v1H0v2h9zM3 5h3V1H3v1H0v2h3zm5 9h8v-2H8zM7 2v2h9V2zm6 7h3V7h-3z"
    })));
const $9138db1f951ed55c$export$5363c08acc839f14 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M12 12v4h2v-4h1V9h-4v3zm-2-5V4H6v3h1v9h2V7zm-5 6v-3H1v3h1v3h2v-3zm9-5V0h-2v8zM2 9h2V0H2zm7-6V0H7v3z"
    })));
const $9138db1f951ed55c$export$7306271c30123976 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M11.292 8.878 11.139 9h.275zm.872.872h-1.966l-.312.25h2.531zm-.5-.5h-.837l-.313.25h1.403zM8.627 11h3.181l.319-.25H8.939zm-.629 3 .319-.25h-.634zM6.73 13h2.54l.319-.25H6.411zm-.635-.5h3.809l.319-.25H5.777zm1.269 1h1.269l.319-.25H7.048zM5.458 12h5.078l.319-.25H5.142zm-.95-.75.319.25h3.172l-.312-.25zm5.059-1-.312.25h3.188l.262-.206-.044-.044zM7.998 11.5h3.175l.319-.25H8.311zM4.705 8.878 4.583 9h.275zm.468.372h-.837l-.25.25h1.403zm1.885 1.5H3.87l.319.25H7.37zm-.628-.5H3.336l-.044.044.263.206h3.188zm-.628-.5H3.836l-.25.25h2.531zM7.998 4.5l3.294 2.622 1.416-1.416L7.998 2 3.292 5.706l1.416 1.416z"
    })));
const $9138db1f951ed55c$export$d51a5d41a86d4b55 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M9.27 3H6.73l-.319.25h3.175zM7.373 5H4.192l-.319.25h3.184zm1.263-2.5H7.367l-.319.25h1.903zM10.542 4H5.461l-.319.25h5.712zm-.637-.5H6.098l-.318.25h4.444zM8.002 2l-.319.25h.634zm3.49 2.75-.319-.25H8.002l.312.25zm-3.49-.25H4.827l-.319.25h3.181zM9.57 5.75h3.094l.044-.044-.263-.206H9.258zm-.628-.5h3.184L11.808 5H8.63zm2.975 1.25h-1.403l.312.25h.837zm-.775.5.153.122.122-.122zM6.433 5.75l.312-.25H3.558l-.263.206.044.044zm5.984.25H9.886l.312.25h1.966zm-6.928.5H4.086l.25.25h.838zm-.903.5.122.122L4.861 7zm1.531-1H3.586l.25.25h1.966zm1.885 5.5L4.708 8.878l-1.416 1.416L8.002 14l4.706-3.706-1.416-1.416z"
    })));
const $9138db1f951ed55c$export$24bdafc250bc28ef = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M9.269 3H6.728l-.319.25h3.175zM7.372 5H4.191l-.319.25h3.184zm1.262-2.5H7.366l-.319.25H8.95zM10.541 4H5.459l-.318.25h5.712zm-.638-.5H6.097l-.319.25h4.444zM8 2l-.319.25h.634zm3.491 2.75-.319-.25H8l.312.25zM8 4.5H4.825l-.319.25h3.181zm1.569 1.25h3.094l.044-.044-.263-.206H9.256zm-.628-.5h3.184L11.806 5H8.628zm2.975 1.25h-1.403l.312.25h.837zm-.775.5.153.122.122-.122zm-4.71-1.25.313-.25H3.556l-.262.206.044.044zm4.863 3.128L11.141 9h.275zm.872.872H10.2l-.313.25h2.531zm-.5-.5h-.837l-.313.25h1.403zm.75-3.25H9.884l.312.25h1.966zm-3.788 5h3.181l.319-.25H8.941zM8 14l.319-.25h-.635zm-1.269-1h2.541l.319-.25H6.412zm-.634-.5h3.809l.319-.25H5.778zm1.269 1h1.269l.319-.25H7.05zM5.459 12h5.078l.319-.25H5.144zm-.95-.75.319.25H8l-.312-.25zm5.06-1-.313.25h3.188l.262-.206-.044-.044zM8 11.5h3.175l.319-.25H8.312zM4.706 8.878 4.584 9h.275zm.469.372h-.837l-.25.25h1.403zm.313-2.75H4.084l.25.25h.838zm-.904.5.122.122L4.859 7zm2.475 3.75H3.872l.319.25h3.181zM6.116 6H3.584l.25.25H5.8zm.315 4.25H3.338l-.044.044.262.206h3.188zm-.628-.5H3.837l-.25.25h2.531z"
    })));
const $9138db1f951ed55c$export$ee66e65f9bacd0b7 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8 11.5 4.706 8.878 3.29 10.294 8 14l4.706-3.706-1.416-1.416zm0-7 3.294 2.622 1.416-1.416L8 2 3.294 5.706 4.71 7.122z"
    })));
const $9138db1f951ed55c$export$f0833711cb9f68ce = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M10 1 3 9h4.5L6 15l7-8H8.5z"
    })));
const $9138db1f951ed55c$export$154cb3948df3efa1 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M4 13H2a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H8l-4 3z"
    })));
const $9138db1f951ed55c$export$b347ffcee0e953cc = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M4 4h8v8H4z"
    })));
const $9138db1f951ed55c$export$ade582b79af72d78 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M2 2h12v12H2z"
    })));
const $9138db1f951ed55c$export$75f6b5de4cbd2386 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "m16 6.204-5.528-.803L8 .392 5.528 5.401 0 6.204l4 3.899-.944 5.505L8 13.009l4.944 2.599L12 10.103z"
    })));
const $9138db1f951ed55c$export$2bdb2cf27f0a265 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M7 16h2v-6H7zm5.603-12.956A5 5 0 0 0 8 0C5.238 0 3 2.237 3 5a3.001 3.001 0 0 0 0 6h.284L4 15h2L5 9H3c-.55 0-1-.45-1-1s.45-1 1-1h2V5c0-1.653 1.347-3 3-3 1.206 0 2.291.719 2.762 1.828l.438 1.028 1.103.166c.466.072.897.306 1.209.669A2.002 2.002 0 0 1 12 9h-1l-1 6h2l.725-4.066a4 4 0 0 0-.122-7.89"
    })));
const $9138db1f951ed55c$export$2eb1b0b2d752ea4b = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M13 12v-1h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-.75a.25.25 0 0 0-.25.25v.5a.25.25 0 0 0 .25.25H16v1h-2a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h.75a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25zm-1 3h-2v-5H4v5H2V6c0-2.76 2.24-5 5-5s5 2.24 5 5zm-2-7V6a3.001 3.001 0 0 0-6 0v2z",
        style: {
            fillRule: "nonzero"
        }
    })));
const $9138db1f951ed55c$export$b147170bf0ac6406 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M13 12v-1h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-.75a.25.25 0 0 0-.25.25v.5a.25.25 0 0 0 .25.25H16v1h-2a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h.75a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25zM8.414 8l4 4H9.586L7 9.414 4.414 12H1.586l4-4-4-4h2.828L7 6.586 9.586 4h2.828z"
    })));
const $9138db1f951ed55c$export$831d605561b8cca5 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M12 15h-2v-5H4v5H2V6c0-2.76 2.24-5 5-5s5 2.24 5 5zm-2-7V6a3.001 3.001 0 0 0-6 0v2zm3-7V0h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-.75a.25.25 0 0 0-.25.25v.5a.25.25 0 0 0 .25.25H16v1h-2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h.75a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25z"
    })));
const $9138db1f951ed55c$export$3a4c80bfe15d601a = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "m8.414 8 4 4H9.586L7 9.414 4.414 12H1.586l4-4-4-4h2.828L7 6.586 9.586 4h2.828zM13 1V0h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-.75a.25.25 0 0 0-.25.25v.5a.25.25 0 0 0 .25.25H16v1h-2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h.75a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25z"
    })));
const $9138db1f951ed55c$export$8702548ed1d7ac29 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M0 11h11.2l-2.6 2.6L10 15l6-6H0zm4.8-6 2.6-2.6L6 1 0 7h16V5z"
    })));
const $9138db1f951ed55c$export$4a3cdaf8654d6ecf = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M5 16V4.8L2.4 7.4 1 6l6-6v16zm6-4.8 2.6-2.6L15 10l-6 6V0h2z"
    })));
const $9138db1f951ed55c$export$7f7b28202d8c7331 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M12 11v2h2v-2h2V9h-2V7h-2v2h-2v2zm2-5V1a.997.997 0 0 0-1-1H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1H9V2h3v4zM4 2h3v12H4z"
    })));
const $9138db1f951ed55c$export$ca16e8c9b654c9e9 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M11 12h2v2h-2v2H9v-2H7v-2h2v-2h2zm-5 2H1a.997.997 0 0 1-1-1V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-1V9H2v3h4zM2 4v3h12V4z"
    })));
const $9138db1f951ed55c$export$5784f2a304a439e3 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M11.414 13 13 11.414 14.586 13 16 11.586 14.414 10 16 8.414 14.586 7 13 8.586 11.414 7 10 8.414 11.586 10 10 11.586zM14 6V1a.997.997 0 0 0-1-1H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1H9V2h3v4zM4 2h3v12H4z"
    })));
const $9138db1f951ed55c$export$51fa6d51058f66a4 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M13 11.414 11.414 13 13 14.586 11.586 16 10 14.414 8.414 16 7 14.586 8.586 13 7 11.414 8.414 10 10 11.586 11.586 10zM6 14H1a.997.997 0 0 1-1-1V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-1V9H2v3h4zM2 4v3h12V4z"
    })));
const $9138db1f951ed55c$export$c69ace2e6416b89c = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M1 16a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zm1-9v7h2V7zm4 0v7h4V7zm6 0v7h2V7zM2 2v3h12V2z"
    })));
const $9138db1f951ed55c$export$7b73804de18dac8e = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M14.497 0H9.988c-.826 0-1.981.478-2.565 1.063L.438 8.047a1.506 1.506 0 0 0 0 2.125l5.389 5.389a1.506 1.506 0 0 0 2.125 0l6.984-6.984C15.522 7.993 16 6.838 16 6.012V1.503C16 .676 15.324 0 14.497 0M12.5 5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 12.5 5"
    })));
const $9138db1f951ed55c$export$40d1ddcefe169242 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 6.5c-1.378 0-2.5-1.122-2.5-2.5S6.622 5.5 8 5.5s2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5M8 7a1 1 0 1 0 0 2 1 1 0 1 0 0-2m0-7C3.581 0 0 3.581 0 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8m4.244 12.244C11.109 13.375 9.603 14 8 14s-3.109-.625-4.244-1.756S2 9.603 2 8s.625-3.109 1.756-4.244S6.397 2 8 2s3.109.625 4.244 1.756S14 6.397 14 8s-.625 3.109-1.756 4.244"
    })));
const $9138db1f951ed55c$export$3b8ef319a6c5f131 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M0 10h16V8H0zM0 0v2h16V0zm0 14h8v-2H0zm0-8h16V4H0z"
    })));
const $9138db1f951ed55c$export$7679025d661a5f99 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M2 9.014 3.414 7.6l2.59 2.589L12.593 3.6l1.414 1.414-8.004 8.003z"
    })));
const $9138db1f951ed55c$export$6a564a3c64a0c770 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M0 9.014 1.414 7.6l3.59 3.589L14.593 1.6l1.414 1.414L5.003 14.017z"
    })));
const $9138db1f951ed55c$export$5918e8962b6636e9 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M11 5h2v8.5c0 .825-.675 1.5-1.5 1.5h-7c-.825 0-1.5-.675-1.5-1.5V5h2v8h2V5h2v8h2zM2 2h12v2H2zm4-2h4v1H6z"
    })));
const $9138db1f951ed55c$export$f7790cfaf03c8a87 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8 11 3 6h10z"
    })));
const $9138db1f951ed55c$export$d0e1eaac53e25db1 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8 13 0 5h16z"
    })));
const $9138db1f951ed55c$export$668e2789cbc708d7 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "m5 8 5-5v10z"
    })));
const $9138db1f951ed55c$export$1974c1a52230d9bf = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "m3 8 8-8v16z"
    })));
const $9138db1f951ed55c$export$501ada128b32fc9e = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "m11 8-5 5V3z"
    })));
const $9138db1f951ed55c$export$79a26f2c80e33f90 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "m13 8-8 8V0z"
    })));
const $9138db1f951ed55c$export$18dba1b5898bbfb1 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "m8 5 5 5H3z"
    })));
const $9138db1f951ed55c$export$9bef3663bbeb4db3 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "m8 3 8 8H0z"
    })));
const $9138db1f951ed55c$export$3c99c824037eed46 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M2 5h10.672l-1.837 1.834L12 8l4-4-4-4-1.166 1.166L12.672 3H0v7l2-2zm12 6H3.328l1.838-1.834L4 8l-4 4 4 4 1.166-1.166L3.328 13H16V6l-2 2z"
    })));
const $9138db1f951ed55c$export$bf9bd1a6e1a39cb5 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "m6 13-3 2 .889-2.667L0 10h16l-3.889 2.333L13 15l-3-2zm10-4H0V8l3-2c0-2.76 2.24-5 5-5s5 2.24 5 5l3 2z"
    })));
const $9138db1f951ed55c$export$193ca764ca13a0c5 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M3 13h10v2H3zm8-12h2v6c0 2.76-2.24 5-5 5S3 9.76 3 7V1h2v6a3.001 3.001 0 0 0 6 0z"
    })));
const $9138db1f951ed55c$export$6ec63552fd597a0c = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M3.294 7.706 4.71 9.122 7 6.828V16h2V6.828l2.294 2.294 1.416-1.416L8 3zM0 2h16V0H0z"
    })));
const $9138db1f951ed55c$export$65f5fd8d1a192873 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M3.294 7.706 4.71 9.122 7 6.828V16h2V6.828l2.294 2.294 1.416-1.416L8 3zM2 12V2h12v10h2V0H0v12z"
    })));
const $9138db1f951ed55c$export$de7094d8f3d0eff8 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M14 12.5a2.5 2.5 0 0 0-2.5-2.5h-7A2.5 2.5 0 0 0 2 12.5V15h12zM12 6h2a2 2 0 0 1 2 2v3h-1.337A3.5 3.5 0 0 0 11.5 9h-.855A4 4 0 0 0 12 6M1.337 11H0V8a2 2 0 0 1 2-2h2a4 4 0 0 0 1.355 3H4.5a3.5 3.5 0 0 0-3.163 2M8 3a3.001 3.001 0 0 1 0 6 3.001 3.001 0 0 1 0-6M4.127 4.996a2 2 0 1 1 1.825-2.432 4.01 4.01 0 0 0-1.825 2.432m5.921-2.432a2 2 0 1 1 1.825 2.432 4.01 4.01 0 0 0-1.825-2.432"
    })));
const $9138db1f951ed55c$export$24f630ce129477b6 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M8 8a4 4 0 1 0 0-8 4 4 0 0 0 0 8m4 2H4a4 4 0 0 0-4 4v2h16v-2a4 4 0 0 0-4-4"
    })));
const $9138db1f951ed55c$export$7c42224f1c8d83b0 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M16 12.5a2.5 2.5 0 0 0-2.5-2.5h-7A2.5 2.5 0 0 0 4 12.5V15h12zM3 13H0v-2.5A2.5 2.5 0 0 1 2.5 8h4.036c.218.376.495.714.819 1H6.5A3.5 3.5 0 0 0 3 12.5zm7-10a3.001 3.001 0 0 1 0 6 3.001 3.001 0 0 1 0-6M6.126 6.997 6 7a3.001 3.001 0 0 1 0-6c1.026 0 1.932.516 2.473 1.302a4.004 4.004 0 0 0-2.347 4.695"
    })));
const $9138db1f951ed55c$export$25372d620e7a1b0b = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M15 3v1.268A1.999 1.999 0 0 1 14 8a2 2 0 0 1-1-3.732V3.5a1.5 1.5 0 0 0-3 0v8.513A4 4 0 0 1 6 16c-2.208 0-4-1.792-4-4v-.171A3.001 3.001 0 1 1 6 9a3 3 0 0 1-2 2.829v.177a1.95 1.95 0 0 0 .157.772A2.001 2.001 0 0 0 8 12V3.5a3.501 3.501 0 0 1 6.964-.5zM3 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
    })));
const $9138db1f951ed55c$export$db99d8e121938012 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "M15.379 12.379 8.79 5.79c.123-.411.21-.839.21-1.29A4.5 4.5 0 0 0 4.5 0c-.451 0-.879.087-1.29.21l2.291 2.291a2.12 2.12 0 0 1 0 2.998l-.002.002a2.12 2.12 0 0 1-2.998 0L.21 3.21C.087 3.621 0 4.049 0 4.5A4.5 4.5 0 0 0 4.5 9c.451 0 .879-.087 1.29-.21l6.589 6.589a2.12 2.12 0 0 0 2.998 0l.002-.002a2.12 2.12 0 0 0 0-2.998M13.75 14.75a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
    })));
const $9138db1f951ed55c$export$4cca98ab4f54f41d = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "m13.707 3.707-1.414-1.414L8 6.586 3.707 2.293 2.293 3.707 6.586 8l-4.293 4.293 1.414 1.414L8 9.414l4.293 4.293 1.414-1.414L9.414 8z"
    })));
const $9138db1f951ed55c$export$eeb267586df04918 = $9138db1f951ed55c$export$7209ba2b0568490(()=>$8v0nu.createElement($8v0nu.Fragment, null, $8v0nu.createElement("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
    }), $8v0nu.createElement("path", {
        d: "m14.707 2.707-1.414-1.414L8 6.586 2.707 1.293 1.293 2.707 6.586 8l-5.293 5.293 1.414 1.414L8 9.414l5.293 5.293 1.414-1.414L9.414 8z"
    })));
const $9138db1f951ed55c$export$83d89fbfd8236492 = "3.0.3";



var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");

var $kxTYF = parcelRequire("kxTYF");

var $8v0nu = parcelRequire("8v0nu");
"use client";
function $95f7db4ddbf3eda0$export$d734136a7b018efe(ref, value) {
    if (ref == null) return;
    if (typeof ref === "function") {
        ref(value);
        return;
    }
    try {
        ref.current = value;
    } catch (error) {
        throw new Error(`Cannot assign value '${value}' to ref '${ref}'`);
    }
}
function $95f7db4ddbf3eda0$export$c9058316764c140e(...refs) {
    return (node)=>{
        refs.forEach((ref)=>{
            $95f7db4ddbf3eda0$export$d734136a7b018efe(ref, node);
        });
    };
}
function $95f7db4ddbf3eda0$export$74665b213cb5c4cf(...refs) {
    return (0, $8v0nu.useMemo)(()=>$95f7db4ddbf3eda0$export$c9058316764c140e(...refs), refs);
}



const $2892ce0537b3699a$export$5cc3b7b83e34ade7 = (condition)=>condition ? "" : void 0;
const $2892ce0537b3699a$export$91a6105db3d4be7b = (condition)=>condition ? true : void 0;



var $8v0nu = parcelRequire("8v0nu");

"use client";
const [$a656748d54ee87a2$export$85041a2bb9328e33, $a656748d54ee87a2$export$749e21be8b14b968] = (0, $3473b2b1e3b906ba$export$fd42f52fd3ae1109)({
    strict: false,
    name: "ButtonGroupContext"
});



var $kxTYF = parcelRequire("kxTYF");


var $8v0nu = parcelRequire("8v0nu");

var $3lBLT = parcelRequire("3lBLT");
"use client";
function $43b9e48fb7630f7a$export$e1c22a2ee2645e36(props) {
    const { children: children, className: className, ...rest } = props;
    const _children = (0, $8v0nu.isValidElement)(children) ? (0, $8v0nu.cloneElement)(children, {
        "aria-hidden": true,
        focusable: false
    }) : children;
    const _className = (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-button__icon", className);
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).span, {
        display: "inline-flex",
        alignSelf: "center",
        flexShrink: 0,
        ...rest,
        className: _className,
        children: _children
    });
}
$43b9e48fb7630f7a$export$e1c22a2ee2645e36.displayName = "ButtonIcon";



var $kxTYF = parcelRequire("kxTYF");



var $8v0nu = parcelRequire("8v0nu");


var $3lBLT = parcelRequire("3lBLT");
"use client";
function $d01b5478b5749abf$export$f2c034885dd3ba7b(props) {
    const { label: label, placement: placement, spacing: spacing = "0.5rem", children: children = /* @__PURE__ */ (0, $kxTYF.jsx)((0, $4d6bfe65067932d8$export$7f7cbe89f1eacd2), {
        color: "currentColor",
        width: "1em",
        height: "1em"
    }), className: className, __css: __css, ...rest } = props;
    const _className = (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-button__spinner", className);
    const marginProp = placement === "start" ? "marginEnd" : "marginStart";
    const spinnerStyles = (0, $8v0nu.useMemo)(()=>(0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
            display: "flex",
            alignItems: "center",
            position: label ? "relative" : "absolute",
            [marginProp]: label ? spacing : 0,
            fontSize: "1em",
            lineHeight: "normal",
            ...__css
        }), [
        __css,
        label,
        marginProp,
        spacing
    ]);
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
        className: _className,
        ...rest,
        __css: spinnerStyles,
        children: children
    });
}
$d01b5478b5749abf$export$f2c034885dd3ba7b.displayName = "ButtonSpinner";



var $8v0nu = parcelRequire("8v0nu");
"use client";
function $92e34ae18a3f4a6b$export$867b668ad7ef61e5(value) {
    const [isButton, setIsButton] = (0, $8v0nu.useState)(!value);
    const refCallback = (0, $8v0nu.useCallback)((node)=>{
        if (!node) return;
        setIsButton(node.tagName === "BUTTON");
    }, []);
    const type = isButton ? "button" : void 0;
    return {
        ref: refCallback,
        type: type
    };
}





var $3lBLT = parcelRequire("3lBLT");
"use client";
const $b8b7f6458056e8af$export$353f5b6fc5456de1 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    const group = (0, $a656748d54ee87a2$export$749e21be8b14b968)();
    const styles = (0, $c7d173d35275482d$export$b863f77547fbcb03)("Button", {
        ...group,
        ...props
    });
    const { isDisabled: isDisabled = group?.isDisabled, isLoading: isLoading, isActive: isActive, children: children, leftIcon: leftIcon, rightIcon: rightIcon, loadingText: loadingText, iconSpacing: iconSpacing = "0.5rem", type: type, spinner: spinner, spinnerPlacement: spinnerPlacement = "start", className: className, as: as, shouldWrapChildren: shouldWrapChildren, ...rest } = (0, $58ff34c9d17adf03$export$adfcf5a5e4d17785)(props);
    const buttonStyles = (0, $8v0nu.useMemo)(()=>{
        const _focus = {
            ...styles?.["_focus"],
            zIndex: 1
        };
        return {
            display: "inline-flex",
            appearance: "none",
            alignItems: "center",
            justifyContent: "center",
            userSelect: "none",
            position: "relative",
            whiteSpace: "nowrap",
            verticalAlign: "middle",
            outline: "none",
            ...styles,
            ...!!group && {
                _focus: _focus
            }
        };
    }, [
        styles,
        group
    ]);
    const { ref: _ref, type: defaultType } = (0, $92e34ae18a3f4a6b$export$867b668ad7ef61e5)(as);
    const contentProps = {
        rightIcon: rightIcon,
        leftIcon: leftIcon,
        iconSpacing: iconSpacing,
        children: children,
        shouldWrapChildren: shouldWrapChildren
    };
    return /* @__PURE__ */ (0, $kxTYF.jsxs)((0, $3lBLT.chakra).button, {
        disabled: isDisabled || isLoading,
        ref: (0, $95f7db4ddbf3eda0$export$74665b213cb5c4cf)(ref, _ref),
        as: as,
        type: type ?? defaultType,
        "data-active": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isActive),
        "data-loading": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isLoading),
        __css: buttonStyles,
        className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-button", className),
        ...rest,
        children: [
            isLoading && spinnerPlacement === "start" && /* @__PURE__ */ (0, $kxTYF.jsx)((0, $d01b5478b5749abf$export$f2c034885dd3ba7b), {
                className: "chakra-button__spinner--start",
                label: loadingText,
                placement: "start",
                spacing: iconSpacing,
                children: spinner
            }),
            isLoading ? loadingText || /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).span, {
                opacity: 0,
                children: /* @__PURE__ */ (0, $kxTYF.jsx)($b8b7f6458056e8af$var$ButtonContent, {
                    ...contentProps
                })
            }) : /* @__PURE__ */ (0, $kxTYF.jsx)($b8b7f6458056e8af$var$ButtonContent, {
                ...contentProps
            }),
            isLoading && spinnerPlacement === "end" && /* @__PURE__ */ (0, $kxTYF.jsx)((0, $d01b5478b5749abf$export$f2c034885dd3ba7b), {
                className: "chakra-button__spinner--end",
                label: loadingText,
                placement: "end",
                spacing: iconSpacing,
                children: spinner
            })
        ]
    });
});
$b8b7f6458056e8af$export$353f5b6fc5456de1.displayName = "Button";
function $b8b7f6458056e8af$var$ButtonContent(props) {
    const { leftIcon: leftIcon, rightIcon: rightIcon, children: children, iconSpacing: iconSpacing, shouldWrapChildren: shouldWrapChildren } = props;
    if (!shouldWrapChildren) return /* @__PURE__ */ (0, $kxTYF.jsxs)((0, $kxTYF.Fragment), {
        children: [
            leftIcon && /* @__PURE__ */ (0, $kxTYF.jsx)((0, $43b9e48fb7630f7a$export$e1c22a2ee2645e36), {
                marginEnd: iconSpacing,
                children: leftIcon
            }),
            children,
            rightIcon && /* @__PURE__ */ (0, $kxTYF.jsx)((0, $43b9e48fb7630f7a$export$e1c22a2ee2645e36), {
                marginStart: iconSpacing,
                children: rightIcon
            })
        ]
    });
    return /* @__PURE__ */ (0, $kxTYF.jsxs)("span", {
        style: {
            display: "contents"
        },
        children: [
            leftIcon && /* @__PURE__ */ (0, $kxTYF.jsx)((0, $43b9e48fb7630f7a$export$e1c22a2ee2645e36), {
                marginEnd: iconSpacing,
                children: leftIcon
            }),
            children,
            rightIcon && /* @__PURE__ */ (0, $kxTYF.jsx)((0, $43b9e48fb7630f7a$export$e1c22a2ee2645e36), {
                marginStart: iconSpacing,
                children: rightIcon
            })
        ]
    });
}



var $kxTYF = parcelRequire("kxTYF");

var $8v0nu = parcelRequire("8v0nu");

const $dfd76aae8c4830bc$export$644c29b44a905178 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(({ title: title, overline: overline, actions: actions, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
        ref: ref,
        bg: "base.50",
        borderRadius: "md",
        p: 8,
        direction: "column",
        gap: 2,
        ...rest,
        children: [
            overline && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3963bf82c5559c75$export$5f1af8db9871e1d6), {
                as: "p",
                color: "base.400",
                children: overline
            }),
            /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                gap: 4,
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8651ef577e25eea6$export$a8a3e93435678ff9), {
                        size: "lg",
                        noOfLines: 1,
                        as: "h1",
                        children: title
                    }),
                    actions && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                        gap: 2,
                        children: actions
                    })
                ]
            })
        ]
    });
});
const $dfd76aae8c4830bc$export$47c5baa971b64ccb = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    const [isAtTop, setIsAtTop] = (0, $8v0nu.useState)(false);
    const localRef = (0, $8v0nu.useRef)(null);
    (0, $8v0nu.useEffect)(()=>{
        const el = localRef.current;
        if (!el) return;
        const observer = new IntersectionObserver(([entry])=>{
            setIsAtTop(entry.intersectionRatio < 1);
        }, {
            threshold: [
                1
            ]
        });
        observer.observe(el);
        return ()=>{
            observer.unobserve(el);
        };
    }, []);
    const headerRef = (v)=>{
        localRef.current = v;
        if (typeof ref === "function") ref(v);
        else if (ref != null) ref.current = v;
    };
    return /*#__PURE__*/ (0, $kxTYF.jsx)($dfd76aae8c4830bc$export$644c29b44a905178, {
        ref: headerRef,
        position: "sticky",
        top: "-1px",
        boxShadow: isAtTop ? "md" : "none",
        zIndex: 100,
        ...props
    });
});



var $8v0nu = parcelRequire("8v0nu");
function $aec39e40387762bd$var$usePageTitle(title) {
    (0, $8v0nu.useEffect)(()=>{
        document.title = title;
    }, [
        title
    ]);
}
var $aec39e40387762bd$export$2e2bcd8739ae039 = $aec39e40387762bd$var$usePageTitle;



var $kxTYF = parcelRequire("kxTYF");

var $8v0nu = parcelRequire("8v0nu");
// src/AuthContext.ts

var $8v0nu = parcelRequire("8v0nu");
// src/utils/Logger.ts
class $763c7880287ce6c8$export$b9721ef022f71a68 extends Error {
}
$763c7880287ce6c8$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
function $763c7880287ce6c8$var$b64DecodeUnicode(str) {
    return decodeURIComponent(atob(str).replace(/(.)/g, (m, p)=>{
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = "0" + code;
        return "%" + code;
    }));
}
function $763c7880287ce6c8$var$base64UrlDecode(str) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("base64 string is not of the correct length");
    }
    try {
        return $763c7880287ce6c8$var$b64DecodeUnicode(output);
    } catch (err) {
        return atob(output);
    }
}
function $763c7880287ce6c8$export$fa1e2fb699b7861e(token, options) {
    if (typeof token !== "string") throw new $763c7880287ce6c8$export$b9721ef022f71a68("Invalid token specified: must be a string");
    options || (options = {});
    const pos = options.header === true ? 0 : 1;
    const part = token.split(".")[pos];
    if (typeof part !== "string") throw new $763c7880287ce6c8$export$b9721ef022f71a68(`Invalid token specified: missing part #${pos + 1}`);
    let decoded;
    try {
        decoded = $763c7880287ce6c8$var$base64UrlDecode(part);
    } catch (e) {
        throw new $763c7880287ce6c8$export$b9721ef022f71a68(`Invalid token specified: invalid base64 for part #${pos + 1} (${e.message})`);
    }
    try {
        return JSON.parse(decoded);
    } catch (e) {
        throw new $763c7880287ce6c8$export$b9721ef022f71a68(`Invalid token specified: invalid json for part #${pos + 1} (${e.message})`);
    }
}


var $91cdf6b8491513ba$var$nopLogger = {
    debug: ()=>void 0,
    info: ()=>void 0,
    warn: ()=>void 0,
    error: ()=>void 0
};
var $91cdf6b8491513ba$var$level;
var $91cdf6b8491513ba$var$logger;
var $91cdf6b8491513ba$export$ce30dbb46644d06c = /* @__PURE__ */ ((Log2)=>{
    Log2[Log2["NONE"] = 0] = "NONE";
    Log2[Log2["ERROR"] = 1] = "ERROR";
    Log2[Log2["WARN"] = 2] = "WARN";
    Log2[Log2["INFO"] = 3] = "INFO";
    Log2[Log2["DEBUG"] = 4] = "DEBUG";
    return Log2;
})($91cdf6b8491513ba$export$ce30dbb46644d06c || {});
((Log2)=>{
    function reset() {
        $91cdf6b8491513ba$var$level = 3 /* INFO */ ;
        $91cdf6b8491513ba$var$logger = $91cdf6b8491513ba$var$nopLogger;
    }
    Log2.reset = reset;
    function setLevel(value) {
        if (!(0 /* NONE */  <= value && value <= 4 /* DEBUG */ )) throw new Error("Invalid log level");
        $91cdf6b8491513ba$var$level = value;
    }
    Log2.setLevel = setLevel;
    function setLogger(value) {
        $91cdf6b8491513ba$var$logger = value;
    }
    Log2.setLogger = setLogger;
})($91cdf6b8491513ba$export$ce30dbb46644d06c || ($91cdf6b8491513ba$export$ce30dbb46644d06c = {}));
var $91cdf6b8491513ba$export$efa9a398d6368992 = class _Logger {
    constructor(_name){
        this._name = _name;
    }
    /* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */ debug(...args) {
        if ($91cdf6b8491513ba$var$level >= 4 /* DEBUG */ ) $91cdf6b8491513ba$var$logger.debug(_Logger._format(this._name, this._method), ...args);
    }
    info(...args) {
        if ($91cdf6b8491513ba$var$level >= 3 /* INFO */ ) $91cdf6b8491513ba$var$logger.info(_Logger._format(this._name, this._method), ...args);
    }
    warn(...args) {
        if ($91cdf6b8491513ba$var$level >= 2 /* WARN */ ) $91cdf6b8491513ba$var$logger.warn(_Logger._format(this._name, this._method), ...args);
    }
    error(...args) {
        if ($91cdf6b8491513ba$var$level >= 1 /* ERROR */ ) $91cdf6b8491513ba$var$logger.error(_Logger._format(this._name, this._method), ...args);
    }
    /* eslint-enable @typescript-eslint/no-unsafe-enum-comparison */ throw(err) {
        this.error(err);
        throw err;
    }
    create(method) {
        const methodLogger = Object.create(this);
        methodLogger._method = method;
        methodLogger.debug("begin");
        return methodLogger;
    }
    static createStatic(name, staticMethod) {
        const staticLogger = new _Logger(`${name}.${staticMethod}`);
        staticLogger.debug("begin");
        return staticLogger;
    }
    static _format(name, method) {
        const prefix = `[${name}]`;
        return method ? `${prefix} ${method}:` : prefix;
    }
    /* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */ // helpers for static class methods
    static debug(name, ...args) {
        if ($91cdf6b8491513ba$var$level >= 4 /* DEBUG */ ) $91cdf6b8491513ba$var$logger.debug(_Logger._format(name), ...args);
    }
    static info(name, ...args) {
        if ($91cdf6b8491513ba$var$level >= 3 /* INFO */ ) $91cdf6b8491513ba$var$logger.info(_Logger._format(name), ...args);
    }
    static warn(name, ...args) {
        if ($91cdf6b8491513ba$var$level >= 2 /* WARN */ ) $91cdf6b8491513ba$var$logger.warn(_Logger._format(name), ...args);
    }
    static error(name, ...args) {
        if ($91cdf6b8491513ba$var$level >= 1 /* ERROR */ ) $91cdf6b8491513ba$var$logger.error(_Logger._format(name), ...args);
    }
};
$91cdf6b8491513ba$export$ce30dbb46644d06c.reset();
var $91cdf6b8491513ba$var$JwtUtils = class {
    // IMPORTANT: doesn't validate the token
    static decode(token) {
        try {
            return (0, $763c7880287ce6c8$export$fa1e2fb699b7861e)(token);
        } catch (err) {
            $91cdf6b8491513ba$export$efa9a398d6368992.error("JwtUtils.decode", err);
            throw err;
        }
    }
    static async generateSignedJwt(header, payload, privateKey) {
        const encodedHeader = $91cdf6b8491513ba$var$CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(header)));
        const encodedPayload = $91cdf6b8491513ba$var$CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(payload)));
        const encodedToken = `${encodedHeader}.${encodedPayload}`;
        const signature = await window.crypto.subtle.sign({
            name: "ECDSA",
            hash: {
                name: "SHA-256"
            }
        }, privateKey, new TextEncoder().encode(encodedToken));
        const encodedSignature = $91cdf6b8491513ba$var$CryptoUtils.encodeBase64Url(new Uint8Array(signature));
        return `${encodedToken}.${encodedSignature}`;
    }
    static async generateSignedJwtWithHmac(header, payload, secretKey) {
        const encodedHeader = $91cdf6b8491513ba$var$CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(header)));
        const encodedPayload = $91cdf6b8491513ba$var$CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(payload)));
        const encodedToken = `${encodedHeader}.${encodedPayload}`;
        const signature = await window.crypto.subtle.sign("HMAC", secretKey, new TextEncoder().encode(encodedToken));
        const encodedSignature = $91cdf6b8491513ba$var$CryptoUtils.encodeBase64Url(new Uint8Array(signature));
        return `${encodedToken}.${encodedSignature}`;
    }
};
// src/utils/CryptoUtils.ts
var $91cdf6b8491513ba$var$UUID_V4_TEMPLATE = "10000000-1000-4000-8000-100000000000";
var $91cdf6b8491513ba$var$toBase64 = (val)=>btoa([
        ...new Uint8Array(val)
    ].map((chr)=>String.fromCharCode(chr)).join(""));
var $91cdf6b8491513ba$var$_CryptoUtils = class _CryptoUtils {
    static _randomWord() {
        const arr = new Uint32Array(1);
        crypto.getRandomValues(arr);
        return arr[0];
    }
    /**
   * Generates RFC4122 version 4 guid
   */ static generateUUIDv4() {
        const uuid = $91cdf6b8491513ba$var$UUID_V4_TEMPLATE.replace(/[018]/g, (c)=>(+c ^ _CryptoUtils._randomWord() & 15 >> +c / 4).toString(16));
        return uuid.replace(/-/g, "");
    }
    /**
   * PKCE: Generate a code verifier
   */ static generateCodeVerifier() {
        return _CryptoUtils.generateUUIDv4() + _CryptoUtils.generateUUIDv4() + _CryptoUtils.generateUUIDv4();
    }
    /**
   * PKCE: Generate a code challenge
   */ static async generateCodeChallenge(code_verifier) {
        if (!crypto.subtle) throw new Error("Crypto.subtle is available only in secure contexts (HTTPS).");
        try {
            const encoder = new TextEncoder();
            const data = encoder.encode(code_verifier);
            const hashed = await crypto.subtle.digest("SHA-256", data);
            return $91cdf6b8491513ba$var$toBase64(hashed).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
        } catch (err) {
            $91cdf6b8491513ba$export$efa9a398d6368992.error("CryptoUtils.generateCodeChallenge", err);
            throw err;
        }
    }
    /**
   * Generates a base64-encoded string for a basic auth header
   */ static generateBasicAuth(client_id, client_secret) {
        const encoder = new TextEncoder();
        const data = encoder.encode([
            client_id,
            client_secret
        ].join(":"));
        return $91cdf6b8491513ba$var$toBase64(data);
    }
    /**
   * Generates a hash of a string using a given algorithm
   * @param alg
   * @param message
   */ static async hash(alg, message) {
        const msgUint8 = new TextEncoder().encode(message);
        const hashBuffer = await crypto.subtle.digest(alg, msgUint8);
        return new Uint8Array(hashBuffer);
    }
    /**
   * Generates a rfc7638 compliant jwk thumbprint
   * @param jwk
   */ static async customCalculateJwkThumbprint(jwk) {
        let jsonObject;
        switch(jwk.kty){
            case "RSA":
                jsonObject = {
                    "e": jwk.e,
                    "kty": jwk.kty,
                    "n": jwk.n
                };
                break;
            case "EC":
                jsonObject = {
                    "crv": jwk.crv,
                    "kty": jwk.kty,
                    "x": jwk.x,
                    "y": jwk.y
                };
                break;
            case "OKP":
                jsonObject = {
                    "crv": jwk.crv,
                    "kty": jwk.kty,
                    "x": jwk.x
                };
                break;
            case "oct":
                jsonObject = {
                    "crv": jwk.k,
                    "kty": jwk.kty
                };
                break;
            default:
                throw new Error("Unknown jwk type");
        }
        const utf8encodedAndHashed = await _CryptoUtils.hash("SHA-256", JSON.stringify(jsonObject));
        return _CryptoUtils.encodeBase64Url(utf8encodedAndHashed);
    }
    static async generateDPoPProof({ url: url, accessToken: accessToken, httpMethod: httpMethod, keyPair: keyPair, nonce: nonce }) {
        let hashedToken;
        let encodedHash;
        const payload = {
            "jti": window.crypto.randomUUID(),
            "htm": httpMethod != null ? httpMethod : "GET",
            "htu": url,
            "iat": Math.floor(Date.now() / 1e3)
        };
        if (accessToken) {
            hashedToken = await _CryptoUtils.hash("SHA-256", accessToken);
            encodedHash = _CryptoUtils.encodeBase64Url(hashedToken);
            payload.ath = encodedHash;
        }
        if (nonce) payload.nonce = nonce;
        try {
            const publicJwk = await crypto.subtle.exportKey("jwk", keyPair.publicKey);
            const header = {
                "alg": "ES256",
                "typ": "dpop+jwt",
                "jwk": {
                    "crv": publicJwk.crv,
                    "kty": publicJwk.kty,
                    "x": publicJwk.x,
                    "y": publicJwk.y
                }
            };
            return await $91cdf6b8491513ba$var$JwtUtils.generateSignedJwt(header, payload, keyPair.privateKey);
        } catch (err) {
            if (err instanceof TypeError) throw new Error(`Error exporting dpop public key: ${err.message}`);
            else throw err;
        }
    }
    static async generateDPoPJkt(keyPair) {
        try {
            const publicJwk = await crypto.subtle.exportKey("jwk", keyPair.publicKey);
            return await _CryptoUtils.customCalculateJwkThumbprint(publicJwk);
        } catch (err) {
            if (err instanceof TypeError) throw new Error(`Could not retrieve dpop keys from storage: ${err.message}`);
            else throw err;
        }
    }
    static async generateDPoPKeys() {
        return await window.crypto.subtle.generateKey({
            name: "ECDSA",
            namedCurve: "P-256"
        }, false, [
            "sign",
            "verify"
        ]);
    }
    /**
   * Generates a client assertion JWT for client_secret_jwt authentication
   * @param client_id The client identifier
   * @param client_secret The client secret
   * @param audience The token endpoint URL (audience)
   * @param algorithm The HMAC algorithm to use (HS256, HS384, HS512). Defaults to HS256
   */ static async generateClientAssertionJwt(client_id, client_secret, audience, algorithm = "HS256") {
        const now = Math.floor(Date.now() / 1e3);
        const header = {
            "alg": algorithm,
            "typ": "JWT"
        };
        const payload = {
            "iss": client_id,
            "sub": client_id,
            "aud": audience,
            "jti": _CryptoUtils.generateUUIDv4(),
            "exp": now + 300,
            // 5 minutes
            "iat": now
        };
        const hashMap = {
            "HS256": "SHA-256",
            "HS384": "SHA-384",
            "HS512": "SHA-512"
        };
        const hashFunction = hashMap[algorithm];
        if (!hashFunction) throw new Error(`Unsupported algorithm: ${algorithm}. Supported algorithms are: HS256, HS384, HS512`);
        const encoder = new TextEncoder();
        const secretKey = await crypto.subtle.importKey("raw", encoder.encode(client_secret), {
            name: "HMAC",
            hash: hashFunction
        }, false, [
            "sign"
        ]);
        return await $91cdf6b8491513ba$var$JwtUtils.generateSignedJwtWithHmac(header, payload, secretKey);
    }
};
/**
 * Generates a base64url encoded string
 */ $91cdf6b8491513ba$var$_CryptoUtils.encodeBase64Url = (input)=>{
    return $91cdf6b8491513ba$var$toBase64(input).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
};
var $91cdf6b8491513ba$var$CryptoUtils = $91cdf6b8491513ba$var$_CryptoUtils;
// src/utils/Event.ts
var $91cdf6b8491513ba$var$Event = class {
    constructor(_name){
        this._name = _name;
        this._callbacks = [];
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992(`Event('${this._name}')`);
    }
    addHandler(cb) {
        this._callbacks.push(cb);
        return ()=>this.removeHandler(cb);
    }
    removeHandler(cb) {
        const idx = this._callbacks.lastIndexOf(cb);
        if (idx >= 0) this._callbacks.splice(idx, 1);
    }
    async raise(...ev) {
        this._logger.debug("raise:", ...ev);
        for (const cb of this._callbacks)await cb(...ev);
    }
};
// src/utils/PopupUtils.ts
var $91cdf6b8491513ba$var$PopupUtils = class {
    /**
   * Populates a map of window features with a placement centered in front of
   * the current window. If no explicit width is given, a default value is
   * binned into [800, 720, 600, 480, 360] based on the current window's width.
   */ static center({ ...features }) {
        var _a, _b, _c;
        if (features.width == null) features.width = (_a = [
            800,
            720,
            600,
            480
        ].find((width)=>width <= window.outerWidth / 1.618)) != null ? _a : 360;
        (_b = features.left) != null ? _b : features.left = Math.max(0, Math.round(window.screenX + (window.outerWidth - features.width) / 2));
        if (features.height != null) (_c = features.top) != null ? _c : features.top = Math.max(0, Math.round(window.screenY + (window.outerHeight - features.height) / 2));
        return features;
    }
    static serialize(features) {
        return Object.entries(features).filter(([, value])=>value != null).map(([key, value])=>`${key}=${typeof value !== "boolean" ? value : value ? "yes" : "no"}`).join(",");
    }
};
// src/utils/Timer.ts
var $91cdf6b8491513ba$var$Timer = class _Timer extends $91cdf6b8491513ba$var$Event {
    constructor(){
        super(...arguments);
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992(`Timer('${this._name}')`);
        this._timerHandle = null;
        this._expiration = 0;
        this._callback = ()=>{
            const diff = this._expiration - _Timer.getEpochTime();
            this._logger.debug("timer completes in", diff);
            if (this._expiration <= _Timer.getEpochTime()) {
                this.cancel();
                super.raise();
            }
        };
    }
    // get the time
    static getEpochTime() {
        return Math.floor(Date.now() / 1e3);
    }
    init(durationInSeconds) {
        const logger2 = this._logger.create("init");
        durationInSeconds = Math.max(Math.floor(durationInSeconds), 1);
        const expiration = _Timer.getEpochTime() + durationInSeconds;
        if (this.expiration === expiration && this._timerHandle) {
            logger2.debug("skipping since already initialized for expiration at", this.expiration);
            return;
        }
        this.cancel();
        logger2.debug("using duration", durationInSeconds);
        this._expiration = expiration;
        const timerDurationInSeconds = Math.min(durationInSeconds, 5);
        this._timerHandle = setInterval(this._callback, timerDurationInSeconds * 1e3);
    }
    get expiration() {
        return this._expiration;
    }
    cancel() {
        this._logger.create("cancel");
        if (this._timerHandle) {
            clearInterval(this._timerHandle);
            this._timerHandle = null;
        }
    }
};
// src/utils/UrlUtils.ts
var $91cdf6b8491513ba$var$UrlUtils = class {
    static readParams(url, responseMode = "query") {
        if (!url) throw new TypeError("Invalid URL");
        const parsedUrl = new URL(url, "http://127.0.0.1");
        const params = parsedUrl[responseMode === "fragment" ? "hash" : "search"];
        return new URLSearchParams(params.slice(1));
    }
};
var $91cdf6b8491513ba$var$URL_STATE_DELIMITER = ";";
// src/errors/ErrorResponse.ts
var $91cdf6b8491513ba$export$acf1a680051f5031 = class extends Error {
    constructor(args, form){
        var _a, _b, _c;
        super(args.error_description || args.error || "");
        this.form = form;
        /** Marker to detect class: "ErrorResponse" */ this.name = "ErrorResponse";
        if (!args.error) {
            $91cdf6b8491513ba$export$efa9a398d6368992.error("ErrorResponse", "No error passed");
            throw new Error("No error passed");
        }
        this.error = args.error;
        this.error_description = (_a = args.error_description) != null ? _a : null;
        this.error_uri = (_b = args.error_uri) != null ? _b : null;
        this.state = args.userState;
        this.session_state = (_c = args.session_state) != null ? _c : null;
        this.url_state = args.url_state;
    }
};
// src/errors/ErrorTimeout.ts
var $91cdf6b8491513ba$export$5312ab5d2c8d859c = class extends Error {
    constructor(message){
        super(message);
        /** Marker to detect class: "ErrorTimeout" */ this.name = "ErrorTimeout";
    }
};
// src/AccessTokenEvents.ts
var $91cdf6b8491513ba$export$3b2b5f2b57921d4f = class {
    constructor(args){
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("AccessTokenEvents");
        this._expiringTimer = new $91cdf6b8491513ba$var$Timer("Access token expiring");
        this._expiredTimer = new $91cdf6b8491513ba$var$Timer("Access token expired");
        this._expiringNotificationTimeInSeconds = args.expiringNotificationTimeInSeconds;
    }
    async load(container) {
        const logger2 = this._logger.create("load");
        if (container.access_token && container.expires_in !== void 0) {
            const duration = container.expires_in;
            logger2.debug("access token present, remaining duration:", duration);
            if (duration > 0) {
                let expiring = duration - this._expiringNotificationTimeInSeconds;
                if (expiring <= 0) expiring = 1;
                logger2.debug("registering expiring timer, raising in", expiring, "seconds");
                this._expiringTimer.init(expiring);
            } else {
                logger2.debug("canceling existing expiring timer because we're past expiration.");
                this._expiringTimer.cancel();
            }
            const expired = duration + 1;
            logger2.debug("registering expired timer, raising in", expired, "seconds");
            this._expiredTimer.init(expired);
        } else {
            this._expiringTimer.cancel();
            this._expiredTimer.cancel();
        }
    }
    async unload() {
        this._logger.debug("unload: canceling existing access token timers");
        this._expiringTimer.cancel();
        this._expiredTimer.cancel();
    }
    /**
   * Add callback: Raised prior to the access token expiring.
   */ addAccessTokenExpiring(cb) {
        return this._expiringTimer.addHandler(cb);
    }
    /**
   * Remove callback: Raised prior to the access token expiring.
   */ removeAccessTokenExpiring(cb) {
        this._expiringTimer.removeHandler(cb);
    }
    /**
   * Add callback: Raised after the access token has expired.
   */ addAccessTokenExpired(cb) {
        return this._expiredTimer.addHandler(cb);
    }
    /**
   * Remove callback: Raised after the access token has expired.
   */ removeAccessTokenExpired(cb) {
        this._expiredTimer.removeHandler(cb);
    }
};
// src/CheckSessionIFrame.ts
var $91cdf6b8491513ba$export$e3e6062266eff2d4 = class {
    constructor(_callback, _client_id, url, _intervalInSeconds, _stopOnError){
        this._callback = _callback;
        this._client_id = _client_id;
        this._intervalInSeconds = _intervalInSeconds;
        this._stopOnError = _stopOnError;
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("CheckSessionIFrame");
        this._timer = null;
        this._session_state = null;
        this._message = (e)=>{
            if (e.origin === this._frame_origin && e.source === this._frame.contentWindow) {
                if (e.data === "error") {
                    this._logger.error("error message from check session op iframe");
                    if (this._stopOnError) this.stop();
                } else if (e.data === "changed") {
                    this._logger.debug("changed message from check session op iframe");
                    this.stop();
                    this._callback();
                } else this._logger.debug(e.data + " message from check session op iframe");
            }
        };
        const parsedUrl = new URL(url);
        this._frame_origin = parsedUrl.origin;
        this._frame = window.document.createElement("iframe");
        this._frame.style.visibility = "hidden";
        this._frame.style.position = "fixed";
        this._frame.style.left = "-1000px";
        this._frame.style.top = "0";
        this._frame.width = "0";
        this._frame.height = "0";
        this._frame.src = parsedUrl.href;
    }
    load() {
        return new Promise((resolve)=>{
            this._frame.onload = ()=>{
                resolve();
            };
            window.document.body.appendChild(this._frame);
            window.addEventListener("message", this._message, false);
        });
    }
    start(session_state) {
        if (this._session_state === session_state) return;
        this._logger.create("start");
        this.stop();
        this._session_state = session_state;
        const send = ()=>{
            if (!this._frame.contentWindow || !this._session_state) return;
            this._frame.contentWindow.postMessage(this._client_id + " " + this._session_state, this._frame_origin);
        };
        send();
        this._timer = setInterval(send, this._intervalInSeconds * 1e3);
    }
    stop() {
        this._logger.create("stop");
        this._session_state = null;
        if (this._timer) {
            clearInterval(this._timer);
            this._timer = null;
        }
    }
};
// src/InMemoryWebStorage.ts
var $91cdf6b8491513ba$export$46e428416143c79c = class {
    constructor(){
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("InMemoryWebStorage");
        this._data = {};
    }
    clear() {
        this._logger.create("clear");
        this._data = {};
    }
    getItem(key) {
        this._logger.create(`getItem('${key}')`);
        return this._data[key];
    }
    setItem(key, value) {
        this._logger.create(`setItem('${key}')`);
        this._data[key] = value;
    }
    removeItem(key) {
        this._logger.create(`removeItem('${key}')`);
        delete this._data[key];
    }
    get length() {
        return Object.getOwnPropertyNames(this._data).length;
    }
    key(index) {
        return Object.getOwnPropertyNames(this._data)[index];
    }
};
// src/errors/ErrorDPoPNonce.ts
var $91cdf6b8491513ba$var$ErrorDPoPNonce = class extends Error {
    constructor(nonce, message){
        super(message);
        /** Marker to detect class: "ErrorDPoPNonce" */ this.name = "ErrorDPoPNonce";
        this.nonce = nonce;
    }
};
// src/JsonService.ts
var $91cdf6b8491513ba$var$JsonService = class {
    constructor(additionalContentTypes = [], _jwtHandler = null, _extraHeaders = {}){
        this._jwtHandler = _jwtHandler;
        this._extraHeaders = _extraHeaders;
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("JsonService");
        this._contentTypes = [];
        this._contentTypes.push(...additionalContentTypes, "application/json");
        if (_jwtHandler) this._contentTypes.push("application/jwt");
    }
    async fetchWithTimeout(input, init = {}) {
        const { timeoutInSeconds: timeoutInSeconds, ...initFetch } = init;
        if (!timeoutInSeconds) return await fetch(input, initFetch);
        const controller = new AbortController();
        const timeoutId = setTimeout(()=>controller.abort(), timeoutInSeconds * 1e3);
        try {
            const response = await fetch(input, {
                ...init,
                signal: controller.signal
            });
            return response;
        } catch (err) {
            if (err instanceof DOMException && err.name === "AbortError") throw new $91cdf6b8491513ba$export$5312ab5d2c8d859c("Network timed out");
            throw err;
        } finally{
            clearTimeout(timeoutId);
        }
    }
    async getJson(url, { token: token, credentials: credentials, timeoutInSeconds: timeoutInSeconds } = {}) {
        const logger2 = this._logger.create("getJson");
        const headers = {
            "Accept": this._contentTypes.join(", ")
        };
        if (token) {
            logger2.debug("token passed, setting Authorization header");
            headers["Authorization"] = "Bearer " + token;
        }
        this._appendExtraHeaders(headers);
        let response;
        try {
            logger2.debug("url:", url);
            response = await this.fetchWithTimeout(url, {
                method: "GET",
                headers: headers,
                timeoutInSeconds: timeoutInSeconds,
                credentials: credentials
            });
        } catch (err) {
            logger2.error("Network Error");
            throw err;
        }
        logger2.debug("HTTP response received, status", response.status);
        const contentType = response.headers.get("Content-Type");
        if (contentType && !this._contentTypes.find((item)=>contentType.startsWith(item))) logger2.throw(new Error(`Invalid response Content-Type: ${contentType != null ? contentType : "undefined"}, from URL: ${url}`));
        if (response.ok && this._jwtHandler && (contentType == null ? void 0 : contentType.startsWith("application/jwt"))) return await this._jwtHandler(await response.text());
        let json;
        try {
            json = await response.json();
        } catch (err) {
            logger2.error("Error parsing JSON response", err);
            if (response.ok) throw err;
            throw new Error(`${response.statusText} (${response.status})`);
        }
        if (!response.ok) {
            logger2.error("Error from server:", json);
            if (json.error) throw new $91cdf6b8491513ba$export$acf1a680051f5031(json);
            throw new Error(`${response.statusText} (${response.status}): ${JSON.stringify(json)}`);
        }
        return json;
    }
    async postForm(url, { body: body, basicAuth: basicAuth, timeoutInSeconds: timeoutInSeconds, initCredentials: initCredentials, extraHeaders: extraHeaders }) {
        const logger2 = this._logger.create("postForm");
        const headers = {
            "Accept": this._contentTypes.join(", "),
            "Content-Type": "application/x-www-form-urlencoded",
            ...extraHeaders
        };
        if (basicAuth !== void 0) headers["Authorization"] = "Basic " + basicAuth;
        this._appendExtraHeaders(headers);
        let response;
        try {
            logger2.debug("url:", url);
            response = await this.fetchWithTimeout(url, {
                method: "POST",
                headers: headers,
                body: body,
                timeoutInSeconds: timeoutInSeconds,
                credentials: initCredentials
            });
        } catch (err) {
            logger2.error("Network error");
            throw err;
        }
        logger2.debug("HTTP response received, status", response.status);
        const contentType = response.headers.get("Content-Type");
        if (contentType && !this._contentTypes.find((item)=>contentType.startsWith(item))) throw new Error(`Invalid response Content-Type: ${contentType != null ? contentType : "undefined"}, from URL: ${url}`);
        const responseText = await response.text();
        let json = {};
        if (responseText) try {
            json = JSON.parse(responseText);
        } catch (err) {
            logger2.error("Error parsing JSON response", err);
            if (response.ok) throw err;
            throw new Error(`${response.statusText} (${response.status})`);
        }
        if (!response.ok) {
            logger2.error("Error from server:", json);
            if (response.headers.has("dpop-nonce")) {
                const nonce = response.headers.get("dpop-nonce");
                throw new $91cdf6b8491513ba$var$ErrorDPoPNonce(nonce, `${JSON.stringify(json)}`);
            }
            if (json.error) throw new $91cdf6b8491513ba$export$acf1a680051f5031(json, body);
            throw new Error(`${response.statusText} (${response.status}): ${JSON.stringify(json)}`);
        }
        return json;
    }
    _appendExtraHeaders(headers) {
        const logger2 = this._logger.create("appendExtraHeaders");
        const customKeys = Object.keys(this._extraHeaders);
        const protectedHeaders = [
            "accept",
            "content-type"
        ];
        const preventOverride = [
            "authorization"
        ];
        if (customKeys.length === 0) return;
        customKeys.forEach((headerName)=>{
            if (protectedHeaders.includes(headerName.toLocaleLowerCase())) {
                logger2.warn("Protected header could not be set", headerName, protectedHeaders);
                return;
            }
            if (preventOverride.includes(headerName.toLocaleLowerCase()) && Object.keys(headers).includes(headerName)) {
                logger2.warn("Header could not be overridden", headerName, preventOverride);
                return;
            }
            const content = typeof this._extraHeaders[headerName] === "function" ? this._extraHeaders[headerName]() : this._extraHeaders[headerName];
            if (content && content !== "") headers[headerName] = content;
        });
    }
};
// src/MetadataService.ts
var $91cdf6b8491513ba$export$b732ab16be80c4ec = class {
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("MetadataService");
        this._signingKeys = null;
        this._metadata = null;
        this._metadataUrl = this._settings.metadataUrl;
        this._jsonService = new $91cdf6b8491513ba$var$JsonService([
            "application/jwk-set+json"
        ], null, this._settings.extraHeaders);
        if (this._settings.signingKeys) {
            this._logger.debug("using signingKeys from settings");
            this._signingKeys = this._settings.signingKeys;
        }
        if (this._settings.metadata) {
            this._logger.debug("using metadata from settings");
            this._metadata = this._settings.metadata;
        }
        if (this._settings.fetchRequestCredentials) {
            this._logger.debug("using fetchRequestCredentials from settings");
            this._fetchRequestCredentials = this._settings.fetchRequestCredentials;
        }
    }
    resetSigningKeys() {
        this._signingKeys = null;
    }
    async getMetadata() {
        const logger2 = this._logger.create("getMetadata");
        if (this._metadata) {
            logger2.debug("using cached values");
            return this._metadata;
        }
        if (!this._metadataUrl) {
            logger2.throw(new Error("No authority or metadataUrl configured on settings"));
            throw null;
        }
        logger2.debug("getting metadata from", this._metadataUrl);
        const metadata = await this._jsonService.getJson(this._metadataUrl, {
            credentials: this._fetchRequestCredentials,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds
        });
        logger2.debug("merging remote JSON with seed metadata");
        this._metadata = Object.assign({}, metadata, this._settings.metadataSeed);
        return this._metadata;
    }
    getIssuer() {
        return this._getMetadataProperty("issuer");
    }
    getAuthorizationEndpoint() {
        return this._getMetadataProperty("authorization_endpoint");
    }
    getUserInfoEndpoint() {
        return this._getMetadataProperty("userinfo_endpoint");
    }
    getTokenEndpoint(optional = true) {
        return this._getMetadataProperty("token_endpoint", optional);
    }
    getCheckSessionIframe() {
        return this._getMetadataProperty("check_session_iframe", true);
    }
    getEndSessionEndpoint() {
        return this._getMetadataProperty("end_session_endpoint", true);
    }
    getRevocationEndpoint(optional = true) {
        return this._getMetadataProperty("revocation_endpoint", optional);
    }
    getKeysEndpoint(optional = true) {
        return this._getMetadataProperty("jwks_uri", optional);
    }
    async _getMetadataProperty(name, optional = false) {
        const logger2 = this._logger.create(`_getMetadataProperty('${name}')`);
        const metadata = await this.getMetadata();
        logger2.debug("resolved");
        if (metadata[name] === void 0) {
            if (optional === true) {
                logger2.warn("Metadata does not contain optional property");
                return void 0;
            }
            logger2.throw(new Error("Metadata does not contain property " + name));
        }
        return metadata[name];
    }
    async getSigningKeys() {
        const logger2 = this._logger.create("getSigningKeys");
        if (this._signingKeys) {
            logger2.debug("returning signingKeys from cache");
            return this._signingKeys;
        }
        const jwks_uri = await this.getKeysEndpoint(false);
        logger2.debug("got jwks_uri", jwks_uri);
        const keySet = await this._jsonService.getJson(jwks_uri, {
            timeoutInSeconds: this._settings.requestTimeoutInSeconds
        });
        logger2.debug("got key set", keySet);
        if (!Array.isArray(keySet.keys)) {
            logger2.throw(new Error("Missing keys on keyset"));
            throw null;
        }
        this._signingKeys = keySet.keys;
        return this._signingKeys;
    }
};
// src/WebStorageStateStore.ts
var $91cdf6b8491513ba$export$6a5d9eefd8f07eee = class {
    constructor({ prefix: prefix = "oidc.", store: store = localStorage } = {}){
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("WebStorageStateStore");
        this._store = store;
        this._prefix = prefix;
    }
    async set(key, value) {
        this._logger.create(`set('${key}')`);
        key = this._prefix + key;
        await this._store.setItem(key, value);
    }
    async get(key) {
        this._logger.create(`get('${key}')`);
        key = this._prefix + key;
        const item = await this._store.getItem(key);
        return item;
    }
    async remove(key) {
        this._logger.create(`remove('${key}')`);
        key = this._prefix + key;
        const item = await this._store.getItem(key);
        await this._store.removeItem(key);
        return item;
    }
    async getAllKeys() {
        this._logger.create("getAllKeys");
        const len = await this._store.length;
        const keys = [];
        for(let index = 0; index < len; index++){
            const key = await this._store.key(index);
            if (key && key.indexOf(this._prefix) === 0) keys.push(key.substr(this._prefix.length));
        }
        return keys;
    }
};
// src/OidcClientSettings.ts
var $91cdf6b8491513ba$var$DefaultResponseType = "code";
var $91cdf6b8491513ba$var$DefaultScope = "openid";
var $91cdf6b8491513ba$var$DefaultClientAuthentication = "client_secret_post";
var $91cdf6b8491513ba$var$DefaultStaleStateAgeInSeconds = 900;
var $91cdf6b8491513ba$export$f0d75c4d483197bb = class {
    constructor({ authority: // metadata related
    authority, metadataUrl: metadataUrl, metadata: metadata, signingKeys: signingKeys, metadataSeed: metadataSeed, client_id: // client related
    client_id, client_secret: client_secret, response_type: response_type = $91cdf6b8491513ba$var$DefaultResponseType, scope: scope = $91cdf6b8491513ba$var$DefaultScope, redirect_uri: redirect_uri, post_logout_redirect_uri: post_logout_redirect_uri, client_authentication: client_authentication = $91cdf6b8491513ba$var$DefaultClientAuthentication, token_endpoint_auth_signing_alg: token_endpoint_auth_signing_alg = "HS256", prompt: // optional protocol
    prompt, display: display, max_age: max_age, ui_locales: ui_locales, acr_values: acr_values, resource: resource, response_mode: response_mode, filterProtocolClaims: // behavior flags
    filterProtocolClaims = true, loadUserInfo: loadUserInfo = false, requestTimeoutInSeconds: requestTimeoutInSeconds, staleStateAgeInSeconds: staleStateAgeInSeconds = $91cdf6b8491513ba$var$DefaultStaleStateAgeInSeconds, mergeClaimsStrategy: mergeClaimsStrategy = {
        array: "replace"
    }, disablePKCE: disablePKCE = false, stateStore: // other behavior
    stateStore, revokeTokenAdditionalContentTypes: revokeTokenAdditionalContentTypes, fetchRequestCredentials: fetchRequestCredentials, refreshTokenAllowedScope: refreshTokenAllowedScope, extraQueryParams: // extra
    extraQueryParams = {}, extraTokenParams: extraTokenParams = {}, extraHeaders: extraHeaders = {}, dpop: dpop, omitScopeWhenRequesting: omitScopeWhenRequesting = false }){
        var _a;
        this.authority = authority;
        if (metadataUrl) this.metadataUrl = metadataUrl;
        else {
            this.metadataUrl = authority;
            if (authority) {
                if (!this.metadataUrl.endsWith("/")) this.metadataUrl += "/";
                this.metadataUrl += ".well-known/openid-configuration";
            }
        }
        this.metadata = metadata;
        this.metadataSeed = metadataSeed;
        this.signingKeys = signingKeys;
        this.client_id = client_id;
        this.client_secret = client_secret;
        this.response_type = response_type;
        this.scope = scope;
        this.redirect_uri = redirect_uri;
        this.post_logout_redirect_uri = post_logout_redirect_uri;
        this.client_authentication = client_authentication;
        this.token_endpoint_auth_signing_alg = token_endpoint_auth_signing_alg;
        this.prompt = prompt;
        this.display = display;
        this.max_age = max_age;
        this.ui_locales = ui_locales;
        this.acr_values = acr_values;
        this.resource = resource;
        this.response_mode = response_mode;
        this.filterProtocolClaims = filterProtocolClaims != null ? filterProtocolClaims : true;
        this.loadUserInfo = !!loadUserInfo;
        this.staleStateAgeInSeconds = staleStateAgeInSeconds;
        this.mergeClaimsStrategy = mergeClaimsStrategy;
        this.omitScopeWhenRequesting = omitScopeWhenRequesting;
        this.disablePKCE = !!disablePKCE;
        this.revokeTokenAdditionalContentTypes = revokeTokenAdditionalContentTypes;
        this.fetchRequestCredentials = fetchRequestCredentials ? fetchRequestCredentials : "same-origin";
        this.requestTimeoutInSeconds = requestTimeoutInSeconds;
        if (stateStore) this.stateStore = stateStore;
        else {
            const store = typeof window !== "undefined" ? window.localStorage : new $91cdf6b8491513ba$export$46e428416143c79c();
            this.stateStore = new $91cdf6b8491513ba$export$6a5d9eefd8f07eee({
                store: store
            });
        }
        this.refreshTokenAllowedScope = refreshTokenAllowedScope;
        this.extraQueryParams = extraQueryParams;
        this.extraTokenParams = extraTokenParams;
        this.extraHeaders = extraHeaders;
        this.dpop = dpop;
        if (this.dpop && !((_a = this.dpop) == null ? void 0 : _a.store)) throw new Error("A DPoPStore is required when dpop is enabled");
    }
};
// src/UserInfoService.ts
var $91cdf6b8491513ba$var$UserInfoService = class {
    constructor(_settings, _metadataService){
        this._settings = _settings;
        this._metadataService = _metadataService;
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("UserInfoService");
        this._getClaimsFromJwt = async (responseText)=>{
            const logger2 = this._logger.create("_getClaimsFromJwt");
            try {
                const payload = $91cdf6b8491513ba$var$JwtUtils.decode(responseText);
                logger2.debug("JWT decoding successful");
                return payload;
            } catch (err) {
                logger2.error("Error parsing JWT response");
                throw err;
            }
        };
        this._jsonService = new $91cdf6b8491513ba$var$JsonService(void 0, this._getClaimsFromJwt, this._settings.extraHeaders);
    }
    async getClaims(token) {
        const logger2 = this._logger.create("getClaims");
        if (!token) this._logger.throw(new Error("No token passed"));
        const url = await this._metadataService.getUserInfoEndpoint();
        logger2.debug("got userinfo url", url);
        const claims = await this._jsonService.getJson(url, {
            token: token,
            credentials: this._settings.fetchRequestCredentials,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds
        });
        logger2.debug("got claims", claims);
        return claims;
    }
};
// src/TokenClient.ts
var $91cdf6b8491513ba$var$TokenClient = class {
    constructor(_settings, _metadataService){
        this._settings = _settings;
        this._metadataService = _metadataService;
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("TokenClient");
        this._jsonService = new $91cdf6b8491513ba$var$JsonService(this._settings.revokeTokenAdditionalContentTypes, null, this._settings.extraHeaders);
    }
    /**
   * Exchange code.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-4.1.3
   */ async exchangeCode({ grant_type: grant_type = "authorization_code", redirect_uri: redirect_uri = this._settings.redirect_uri, client_id: client_id = this._settings.client_id, client_secret: client_secret = this._settings.client_secret, extraHeaders: extraHeaders, ...args }) {
        const logger2 = this._logger.create("exchangeCode");
        if (!client_id) logger2.throw(new Error("A client_id is required"));
        if (!redirect_uri) logger2.throw(new Error("A redirect_uri is required"));
        if (!args.code) logger2.throw(new Error("A code is required"));
        const params = new URLSearchParams({
            grant_type: grant_type,
            redirect_uri: redirect_uri
        });
        for (const [key, value] of Object.entries(args))if (value != null) params.set(key, value);
        if ((this._settings.client_authentication === "client_secret_basic" || this._settings.client_authentication === "client_secret_jwt") && (client_secret === void 0 || client_secret === null)) {
            logger2.throw(new Error("A client_secret is required"));
            throw null;
        }
        let basicAuth;
        const url = await this._metadataService.getTokenEndpoint(false);
        switch(this._settings.client_authentication){
            case "client_secret_basic":
                basicAuth = $91cdf6b8491513ba$var$CryptoUtils.generateBasicAuth(client_id, client_secret);
                break;
            case "client_secret_post":
                params.append("client_id", client_id);
                if (client_secret) params.append("client_secret", client_secret);
                break;
            case "client_secret_jwt":
                {
                    const clientAssertion = await $91cdf6b8491513ba$var$CryptoUtils.generateClientAssertionJwt(client_id, client_secret, url, this._settings.token_endpoint_auth_signing_alg);
                    params.append("client_id", client_id);
                    params.append("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer");
                    params.append("client_assertion", clientAssertion);
                    break;
                }
        }
        logger2.debug("got token endpoint");
        const response = await this._jsonService.postForm(url, {
            body: params,
            basicAuth: basicAuth,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds,
            initCredentials: this._settings.fetchRequestCredentials,
            extraHeaders: extraHeaders
        });
        logger2.debug("got response");
        return response;
    }
    /**
   * Exchange credentials.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-4.3.2
   */ async exchangeCredentials({ grant_type: grant_type = "password", client_id: client_id = this._settings.client_id, client_secret: client_secret = this._settings.client_secret, scope: scope = this._settings.scope, ...args }) {
        const logger2 = this._logger.create("exchangeCredentials");
        if (!client_id) logger2.throw(new Error("A client_id is required"));
        const params = new URLSearchParams({
            grant_type: grant_type
        });
        if (!this._settings.omitScopeWhenRequesting) params.set("scope", scope);
        for (const [key, value] of Object.entries(args))if (value != null) params.set(key, value);
        if ((this._settings.client_authentication === "client_secret_basic" || this._settings.client_authentication === "client_secret_jwt") && (client_secret === void 0 || client_secret === null)) {
            logger2.throw(new Error("A client_secret is required"));
            throw null;
        }
        let basicAuth;
        const url = await this._metadataService.getTokenEndpoint(false);
        switch(this._settings.client_authentication){
            case "client_secret_basic":
                basicAuth = $91cdf6b8491513ba$var$CryptoUtils.generateBasicAuth(client_id, client_secret);
                break;
            case "client_secret_post":
                params.append("client_id", client_id);
                if (client_secret) params.append("client_secret", client_secret);
                break;
            case "client_secret_jwt":
                {
                    const clientAssertion = await $91cdf6b8491513ba$var$CryptoUtils.generateClientAssertionJwt(client_id, client_secret, url, this._settings.token_endpoint_auth_signing_alg);
                    params.append("client_id", client_id);
                    params.append("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer");
                    params.append("client_assertion", clientAssertion);
                    break;
                }
        }
        logger2.debug("got token endpoint");
        const response = await this._jsonService.postForm(url, {
            body: params,
            basicAuth: basicAuth,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds,
            initCredentials: this._settings.fetchRequestCredentials
        });
        logger2.debug("got response");
        return response;
    }
    /**
   * Exchange a refresh token.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-6
   */ async exchangeRefreshToken({ grant_type: grant_type = "refresh_token", client_id: client_id = this._settings.client_id, client_secret: client_secret = this._settings.client_secret, timeoutInSeconds: timeoutInSeconds, extraHeaders: extraHeaders, ...args }) {
        const logger2 = this._logger.create("exchangeRefreshToken");
        if (!client_id) logger2.throw(new Error("A client_id is required"));
        if (!args.refresh_token) logger2.throw(new Error("A refresh_token is required"));
        const params = new URLSearchParams({
            grant_type: grant_type
        });
        for (const [key, value] of Object.entries(args)){
            if (Array.isArray(value)) value.forEach((param)=>params.append(key, param));
            else if (value != null) params.set(key, value);
        }
        if ((this._settings.client_authentication === "client_secret_basic" || this._settings.client_authentication === "client_secret_jwt") && (client_secret === void 0 || client_secret === null)) {
            logger2.throw(new Error("A client_secret is required"));
            throw null;
        }
        let basicAuth;
        const url = await this._metadataService.getTokenEndpoint(false);
        switch(this._settings.client_authentication){
            case "client_secret_basic":
                basicAuth = $91cdf6b8491513ba$var$CryptoUtils.generateBasicAuth(client_id, client_secret);
                break;
            case "client_secret_post":
                params.append("client_id", client_id);
                if (client_secret) params.append("client_secret", client_secret);
                break;
            case "client_secret_jwt":
                {
                    const clientAssertion = await $91cdf6b8491513ba$var$CryptoUtils.generateClientAssertionJwt(client_id, client_secret, url, this._settings.token_endpoint_auth_signing_alg);
                    params.append("client_id", client_id);
                    params.append("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer");
                    params.append("client_assertion", clientAssertion);
                    break;
                }
        }
        logger2.debug("got token endpoint");
        const response = await this._jsonService.postForm(url, {
            body: params,
            basicAuth: basicAuth,
            timeoutInSeconds: timeoutInSeconds,
            initCredentials: this._settings.fetchRequestCredentials,
            extraHeaders: extraHeaders
        });
        logger2.debug("got response");
        return response;
    }
    /**
   * Revoke an access or refresh token.
   *
   * @see https://datatracker.ietf.org/doc/html/rfc7009#section-2.1
   */ async revoke(args) {
        var _a;
        const logger2 = this._logger.create("revoke");
        if (!args.token) logger2.throw(new Error("A token is required"));
        const url = await this._metadataService.getRevocationEndpoint(false);
        logger2.debug(`got revocation endpoint, revoking ${(_a = args.token_type_hint) != null ? _a : "default token type"}`);
        const params = new URLSearchParams();
        for (const [key, value] of Object.entries(args))if (value != null) params.set(key, value);
        params.set("client_id", this._settings.client_id);
        if (this._settings.client_secret) params.set("client_secret", this._settings.client_secret);
        await this._jsonService.postForm(url, {
            body: params,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds
        });
        logger2.debug("got response");
    }
};
// src/ResponseValidator.ts
var $91cdf6b8491513ba$var$ResponseValidator = class {
    constructor(_settings, _metadataService, _claimsService){
        this._settings = _settings;
        this._metadataService = _metadataService;
        this._claimsService = _claimsService;
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("ResponseValidator");
        this._userInfoService = new $91cdf6b8491513ba$var$UserInfoService(this._settings, this._metadataService);
        this._tokenClient = new $91cdf6b8491513ba$var$TokenClient(this._settings, this._metadataService);
    }
    async validateSigninResponse(response, state, extraHeaders) {
        const logger2 = this._logger.create("validateSigninResponse");
        this._processSigninState(response, state);
        logger2.debug("state processed");
        await this._processCode(response, state, extraHeaders);
        logger2.debug("code processed");
        if (response.isOpenId) this._validateIdTokenAttributes(response, "", state.nonce);
        logger2.debug("tokens validated");
        await this._processClaims(response, state == null ? void 0 : state.skipUserInfo, response.isOpenId);
        logger2.debug("claims processed");
    }
    async validateCredentialsResponse(response, skipUserInfo) {
        const logger2 = this._logger.create("validateCredentialsResponse");
        const shouldValidateSubClaim = response.isOpenId && !!response.id_token;
        if (shouldValidateSubClaim) this._validateIdTokenAttributes(response);
        logger2.debug("tokens validated");
        await this._processClaims(response, skipUserInfo, shouldValidateSubClaim);
        logger2.debug("claims processed");
    }
    async validateRefreshResponse(response, state) {
        var _a, _b;
        const logger2 = this._logger.create("validateRefreshResponse");
        response.userState = state.data;
        (_a = response.session_state) != null ? _a : response.session_state = state.session_state;
        (_b = response.scope) != null ? _b : response.scope = state.scope;
        if (response.isOpenId && !!response.id_token) {
            this._validateIdTokenAttributes(response, state.id_token);
            logger2.debug("ID Token validated");
        }
        if (!response.id_token) {
            response.id_token = state.id_token;
            response.profile = state.profile;
        }
        const hasIdToken = response.isOpenId && !!response.id_token;
        await this._processClaims(response, false, hasIdToken);
        logger2.debug("claims processed");
    }
    validateSignoutResponse(response, state) {
        const logger2 = this._logger.create("validateSignoutResponse");
        if (state.id !== response.state) logger2.throw(new Error("State does not match"));
        logger2.debug("state validated");
        response.userState = state.data;
        if (response.error) {
            logger2.warn("Response was error", response.error);
            throw new $91cdf6b8491513ba$export$acf1a680051f5031(response);
        }
    }
    _processSigninState(response, state) {
        var _a;
        const logger2 = this._logger.create("_processSigninState");
        if (state.id !== response.state) logger2.throw(new Error("State does not match"));
        if (!state.client_id) logger2.throw(new Error("No client_id on state"));
        if (!state.authority) logger2.throw(new Error("No authority on state"));
        if (this._settings.authority !== state.authority) logger2.throw(new Error("authority mismatch on settings vs. signin state"));
        if (this._settings.client_id && this._settings.client_id !== state.client_id) logger2.throw(new Error("client_id mismatch on settings vs. signin state"));
        logger2.debug("state validated");
        response.userState = state.data;
        response.url_state = state.url_state;
        (_a = response.scope) != null ? _a : response.scope = state.scope;
        if (response.error) {
            logger2.warn("Response was error", response.error);
            throw new $91cdf6b8491513ba$export$acf1a680051f5031(response);
        }
        if (state.code_verifier && !response.code) logger2.throw(new Error("Expected code in response"));
    }
    async _processClaims(response, skipUserInfo = false, validateSub = true) {
        const logger2 = this._logger.create("_processClaims");
        response.profile = this._claimsService.filterProtocolClaims(response.profile);
        if (skipUserInfo || !this._settings.loadUserInfo || !response.access_token) {
            logger2.debug("not loading user info");
            return;
        }
        logger2.debug("loading user info");
        const claims = await this._userInfoService.getClaims(response.access_token);
        logger2.debug("user info claims received from user info endpoint");
        if (validateSub && claims.sub !== response.profile.sub) logger2.throw(new Error("subject from UserInfo response does not match subject in ID Token"));
        response.profile = this._claimsService.mergeClaims(response.profile, this._claimsService.filterProtocolClaims(claims));
        logger2.debug("user info claims received, updated profile:", response.profile);
    }
    async _processCode(response, state, extraHeaders) {
        const logger2 = this._logger.create("_processCode");
        if (response.code) {
            logger2.debug("Validating code");
            const tokenResponse = await this._tokenClient.exchangeCode({
                client_id: state.client_id,
                client_secret: state.client_secret,
                code: response.code,
                redirect_uri: state.redirect_uri,
                code_verifier: state.code_verifier,
                extraHeaders: extraHeaders,
                ...state.extraTokenParams
            });
            Object.assign(response, tokenResponse);
        } else logger2.debug("No code to process");
    }
    _validateIdTokenAttributes(response, existingToken, nonce) {
        var _a;
        const logger2 = this._logger.create("_validateIdTokenAttributes");
        logger2.debug("decoding ID Token JWT");
        const incoming = $91cdf6b8491513ba$var$JwtUtils.decode((_a = response.id_token) != null ? _a : "");
        if (!incoming.sub) logger2.throw(new Error("ID Token is missing a subject claim"));
        if (nonce && incoming.nonce !== nonce) logger2.throw(new Error("nonce in id_token does not match nonce in client storage"));
        if (existingToken) {
            const existing = $91cdf6b8491513ba$var$JwtUtils.decode(existingToken);
            if (incoming.sub !== existing.sub) logger2.throw(new Error("sub in id_token does not match current sub"));
            if (incoming.auth_time && incoming.auth_time !== existing.auth_time) logger2.throw(new Error("auth_time in id_token does not match original auth_time"));
            if (incoming.azp && incoming.azp !== existing.azp) logger2.throw(new Error("azp in id_token does not match original azp"));
            if (!incoming.azp && existing.azp) logger2.throw(new Error("azp not in id_token, but present in original id_token"));
        }
        response.profile = incoming;
    }
};
// src/State.ts
var $91cdf6b8491513ba$export$7254cc27399e90bd = class _State {
    constructor(args){
        this.id = args.id || $91cdf6b8491513ba$var$CryptoUtils.generateUUIDv4();
        this.data = args.data;
        if (args.created && args.created > 0) this.created = args.created;
        else this.created = $91cdf6b8491513ba$var$Timer.getEpochTime();
        this.request_type = args.request_type;
        this.url_state = args.url_state;
    }
    toStorageString() {
        new $91cdf6b8491513ba$export$efa9a398d6368992("State").create("toStorageString");
        return JSON.stringify({
            id: this.id,
            data: this.data,
            created: this.created,
            request_type: this.request_type,
            url_state: this.url_state
        });
    }
    static fromStorageString(storageString) {
        $91cdf6b8491513ba$export$efa9a398d6368992.createStatic("State", "fromStorageString");
        return Promise.resolve(new _State(JSON.parse(storageString)));
    }
    static async clearStaleState(storage, age) {
        const logger2 = $91cdf6b8491513ba$export$efa9a398d6368992.createStatic("State", "clearStaleState");
        const cutoff = $91cdf6b8491513ba$var$Timer.getEpochTime() - age;
        const keys = await storage.getAllKeys();
        logger2.debug("got keys", keys);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const item = await storage.get(key);
            let remove = false;
            if (item) try {
                const state = await _State.fromStorageString(item);
                logger2.debug("got item from key:", key, state.created);
                if (state.created <= cutoff) remove = true;
            } catch (err) {
                logger2.error("Error parsing state for key:", key, err);
                remove = true;
            }
            else {
                logger2.debug("no item in storage for key:", key);
                remove = true;
            }
            if (remove) {
                logger2.debug("removed item for key:", key);
                storage.remove(key);
            }
        }
    }
};
// src/SigninState.ts
var $91cdf6b8491513ba$export$d12e9f373447e92a = class _SigninState extends $91cdf6b8491513ba$export$7254cc27399e90bd {
    constructor(args){
        super(args);
        this.code_verifier = args.code_verifier;
        this.code_challenge = args.code_challenge;
        this.authority = args.authority;
        this.client_id = args.client_id;
        this.redirect_uri = args.redirect_uri;
        this.scope = args.scope;
        this.client_secret = args.client_secret;
        this.extraTokenParams = args.extraTokenParams;
        this.response_mode = args.response_mode;
        this.skipUserInfo = args.skipUserInfo;
        this.nonce = args.nonce;
    }
    static async create(args) {
        const code_verifier = args.code_verifier === true ? $91cdf6b8491513ba$var$CryptoUtils.generateCodeVerifier() : args.code_verifier || void 0;
        const code_challenge = code_verifier ? await $91cdf6b8491513ba$var$CryptoUtils.generateCodeChallenge(code_verifier) : void 0;
        return new _SigninState({
            ...args,
            code_verifier: code_verifier,
            code_challenge: code_challenge
        });
    }
    toStorageString() {
        new $91cdf6b8491513ba$export$efa9a398d6368992("SigninState").create("toStorageString");
        return JSON.stringify({
            id: this.id,
            data: this.data,
            created: this.created,
            request_type: this.request_type,
            url_state: this.url_state,
            code_verifier: this.code_verifier,
            authority: this.authority,
            client_id: this.client_id,
            redirect_uri: this.redirect_uri,
            scope: this.scope,
            client_secret: this.client_secret,
            extraTokenParams: this.extraTokenParams,
            response_mode: this.response_mode,
            skipUserInfo: this.skipUserInfo,
            nonce: this.nonce
        });
    }
    static fromStorageString(storageString) {
        $91cdf6b8491513ba$export$efa9a398d6368992.createStatic("SigninState", "fromStorageString");
        const data = JSON.parse(storageString);
        return _SigninState.create(data);
    }
};
// src/SigninRequest.ts
var $91cdf6b8491513ba$var$_SigninRequest = class _SigninRequest {
    constructor(args){
        this.url = args.url;
        this.state = args.state;
    }
    static async create({ url: // mandatory
    url, authority: authority, client_id: client_id, redirect_uri: redirect_uri, response_type: response_type, scope: scope, state_data: // optional
    state_data, response_mode: response_mode, request_type: request_type, client_secret: client_secret, nonce: nonce, url_state: url_state, resource: resource, skipUserInfo: skipUserInfo, extraQueryParams: extraQueryParams, extraTokenParams: extraTokenParams, disablePKCE: disablePKCE, dpopJkt: dpopJkt, omitScopeWhenRequesting: omitScopeWhenRequesting, ...optionalParams }) {
        if (!url) {
            this._logger.error("create: No url passed");
            throw new Error("url");
        }
        if (!client_id) {
            this._logger.error("create: No client_id passed");
            throw new Error("client_id");
        }
        if (!redirect_uri) {
            this._logger.error("create: No redirect_uri passed");
            throw new Error("redirect_uri");
        }
        if (!response_type) {
            this._logger.error("create: No response_type passed");
            throw new Error("response_type");
        }
        if (!scope) {
            this._logger.error("create: No scope passed");
            throw new Error("scope");
        }
        if (!authority) {
            this._logger.error("create: No authority passed");
            throw new Error("authority");
        }
        const state = await $91cdf6b8491513ba$export$d12e9f373447e92a.create({
            data: state_data,
            request_type: request_type,
            url_state: url_state,
            code_verifier: !disablePKCE,
            client_id: client_id,
            authority: authority,
            redirect_uri: redirect_uri,
            response_mode: response_mode,
            client_secret: client_secret,
            scope: scope,
            extraTokenParams: extraTokenParams,
            skipUserInfo: skipUserInfo,
            nonce: nonce
        });
        const parsedUrl = new URL(url);
        parsedUrl.searchParams.append("client_id", client_id);
        parsedUrl.searchParams.append("redirect_uri", redirect_uri);
        parsedUrl.searchParams.append("response_type", response_type);
        if (!omitScopeWhenRequesting) parsedUrl.searchParams.append("scope", scope);
        if (nonce) parsedUrl.searchParams.append("nonce", nonce);
        if (dpopJkt) parsedUrl.searchParams.append("dpop_jkt", dpopJkt);
        let stateParam = state.id;
        if (url_state) stateParam = `${stateParam}${$91cdf6b8491513ba$var$URL_STATE_DELIMITER}${url_state}`;
        parsedUrl.searchParams.append("state", stateParam);
        if (state.code_challenge) {
            parsedUrl.searchParams.append("code_challenge", state.code_challenge);
            parsedUrl.searchParams.append("code_challenge_method", "S256");
        }
        if (resource) {
            const resources = Array.isArray(resource) ? resource : [
                resource
            ];
            resources.forEach((r)=>parsedUrl.searchParams.append("resource", r));
        }
        for (const [key, value] of Object.entries({
            response_mode: response_mode,
            ...optionalParams,
            ...extraQueryParams
        }))if (value != null) parsedUrl.searchParams.append(key, value.toString());
        return new _SigninRequest({
            url: parsedUrl.href,
            state: state
        });
    }
};
$91cdf6b8491513ba$var$_SigninRequest._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("SigninRequest");
var $91cdf6b8491513ba$var$SigninRequest = $91cdf6b8491513ba$var$_SigninRequest;
// src/SigninResponse.ts
var $91cdf6b8491513ba$var$OidcScope = "openid";
var $91cdf6b8491513ba$export$60021acc97e24041 = class {
    constructor(params){
        /** @see {@link User.access_token} */ this.access_token = "";
        /** @see {@link User.token_type} */ this.token_type = "";
        /** @see {@link User.profile} */ this.profile = {};
        this.state = params.get("state");
        this.session_state = params.get("session_state");
        if (this.state) {
            const splitState = decodeURIComponent(this.state).split($91cdf6b8491513ba$var$URL_STATE_DELIMITER);
            this.state = splitState[0];
            if (splitState.length > 1) this.url_state = splitState.slice(1).join($91cdf6b8491513ba$var$URL_STATE_DELIMITER);
        }
        this.error = params.get("error");
        this.error_description = params.get("error_description");
        this.error_uri = params.get("error_uri");
        this.code = params.get("code");
    }
    get expires_in() {
        if (this.expires_at === void 0) return void 0;
        return this.expires_at - $91cdf6b8491513ba$var$Timer.getEpochTime();
    }
    set expires_in(value) {
        if (typeof value === "string") value = Number(value);
        if (value !== void 0 && value >= 0) this.expires_at = Math.floor(value) + $91cdf6b8491513ba$var$Timer.getEpochTime();
    }
    get isOpenId() {
        var _a;
        return ((_a = this.scope) == null ? void 0 : _a.split(" ").includes($91cdf6b8491513ba$var$OidcScope)) || !!this.id_token;
    }
};
// src/SignoutRequest.ts
var $91cdf6b8491513ba$var$SignoutRequest = class {
    constructor({ url: url, state_data: state_data, id_token_hint: id_token_hint, post_logout_redirect_uri: post_logout_redirect_uri, extraQueryParams: extraQueryParams, request_type: request_type, client_id: client_id, url_state: url_state }){
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("SignoutRequest");
        if (!url) {
            this._logger.error("ctor: No url passed");
            throw new Error("url");
        }
        const parsedUrl = new URL(url);
        if (id_token_hint) parsedUrl.searchParams.append("id_token_hint", id_token_hint);
        if (client_id) parsedUrl.searchParams.append("client_id", client_id);
        if (post_logout_redirect_uri) {
            parsedUrl.searchParams.append("post_logout_redirect_uri", post_logout_redirect_uri);
            if (state_data || url_state) {
                this.state = new $91cdf6b8491513ba$export$7254cc27399e90bd({
                    data: state_data,
                    request_type: request_type,
                    url_state: url_state
                });
                let stateParam = this.state.id;
                if (url_state) stateParam = `${stateParam}${$91cdf6b8491513ba$var$URL_STATE_DELIMITER}${url_state}`;
                parsedUrl.searchParams.append("state", stateParam);
            }
        }
        for (const [key, value] of Object.entries({
            ...extraQueryParams
        }))if (value != null) parsedUrl.searchParams.append(key, value.toString());
        this.url = parsedUrl.href;
    }
};
// src/SignoutResponse.ts
var $91cdf6b8491513ba$export$7ddf7038233313f6 = class {
    constructor(params){
        this.state = params.get("state");
        if (this.state) {
            const splitState = decodeURIComponent(this.state).split($91cdf6b8491513ba$var$URL_STATE_DELIMITER);
            this.state = splitState[0];
            if (splitState.length > 1) this.url_state = splitState.slice(1).join($91cdf6b8491513ba$var$URL_STATE_DELIMITER);
        }
        this.error = params.get("error");
        this.error_description = params.get("error_description");
        this.error_uri = params.get("error_uri");
    }
};
// src/ClaimsService.ts
var $91cdf6b8491513ba$var$DefaultProtocolClaims = [
    "nbf",
    "jti",
    "auth_time",
    "nonce",
    "acr",
    "amr",
    "azp",
    "at_hash"
];
var $91cdf6b8491513ba$var$InternalRequiredProtocolClaims = [
    "sub",
    "iss",
    "aud",
    "exp",
    "iat"
];
var $91cdf6b8491513ba$var$ClaimsService = class {
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("ClaimsService");
    }
    filterProtocolClaims(claims) {
        const result = {
            ...claims
        };
        if (this._settings.filterProtocolClaims) {
            let protocolClaims;
            if (Array.isArray(this._settings.filterProtocolClaims)) protocolClaims = this._settings.filterProtocolClaims;
            else protocolClaims = $91cdf6b8491513ba$var$DefaultProtocolClaims;
            for (const claim of protocolClaims)if (!$91cdf6b8491513ba$var$InternalRequiredProtocolClaims.includes(claim)) delete result[claim];
        }
        return result;
    }
    mergeClaims(claims1, claims2) {
        const result = {
            ...claims1
        };
        for (const [claim, values] of Object.entries(claims2))if (result[claim] !== values) {
            if (Array.isArray(result[claim]) || Array.isArray(values)) {
                if (this._settings.mergeClaimsStrategy.array == "replace") result[claim] = values;
                else {
                    const mergedValues = Array.isArray(result[claim]) ? result[claim] : [
                        result[claim]
                    ];
                    for (const value of Array.isArray(values) ? values : [
                        values
                    ])if (!mergedValues.includes(value)) mergedValues.push(value);
                    result[claim] = mergedValues;
                }
            } else if (typeof result[claim] === "object" && typeof values === "object") result[claim] = this.mergeClaims(result[claim], values);
            else result[claim] = values;
        }
        return result;
    }
};
// src/DPoPStore.ts
var $91cdf6b8491513ba$export$dc765d984eae7c82 = class {
    constructor(keys, nonce){
        this.keys = keys;
        this.nonce = nonce;
    }
};
// src/OidcClient.ts
var $91cdf6b8491513ba$export$b112d407fa897c7e = class {
    constructor(settings, metadataService){
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("OidcClient");
        this.settings = settings instanceof $91cdf6b8491513ba$export$f0d75c4d483197bb ? settings : new $91cdf6b8491513ba$export$f0d75c4d483197bb(settings);
        this.metadataService = metadataService != null ? metadataService : new $91cdf6b8491513ba$export$b732ab16be80c4ec(this.settings);
        this._claimsService = new $91cdf6b8491513ba$var$ClaimsService(this.settings);
        this._validator = new $91cdf6b8491513ba$var$ResponseValidator(this.settings, this.metadataService, this._claimsService);
        this._tokenClient = new $91cdf6b8491513ba$var$TokenClient(this.settings, this.metadataService);
    }
    async createSigninRequest({ state: state, request: request, request_uri: request_uri, request_type: request_type, id_token_hint: id_token_hint, login_hint: login_hint, skipUserInfo: skipUserInfo, nonce: nonce, url_state: url_state, response_type: response_type = this.settings.response_type, scope: scope = this.settings.scope, redirect_uri: redirect_uri = this.settings.redirect_uri, prompt: prompt = this.settings.prompt, display: display = this.settings.display, max_age: max_age = this.settings.max_age, ui_locales: ui_locales = this.settings.ui_locales, acr_values: acr_values = this.settings.acr_values, resource: resource = this.settings.resource, response_mode: response_mode = this.settings.response_mode, extraQueryParams: extraQueryParams = this.settings.extraQueryParams, extraTokenParams: extraTokenParams = this.settings.extraTokenParams, dpopJkt: dpopJkt, omitScopeWhenRequesting: omitScopeWhenRequesting = this.settings.omitScopeWhenRequesting }) {
        const logger2 = this._logger.create("createSigninRequest");
        if (response_type !== "code") throw new Error("Only the Authorization Code flow (with PKCE) is supported");
        const url = await this.metadataService.getAuthorizationEndpoint();
        logger2.debug("Received authorization endpoint", url);
        const signinRequest = await $91cdf6b8491513ba$var$SigninRequest.create({
            url: url,
            authority: this.settings.authority,
            client_id: this.settings.client_id,
            redirect_uri: redirect_uri,
            response_type: response_type,
            scope: scope,
            state_data: state,
            url_state: url_state,
            prompt: prompt,
            display: display,
            max_age: max_age,
            ui_locales: ui_locales,
            id_token_hint: id_token_hint,
            login_hint: login_hint,
            acr_values: acr_values,
            dpopJkt: dpopJkt,
            resource: resource,
            request: request,
            request_uri: request_uri,
            extraQueryParams: extraQueryParams,
            extraTokenParams: extraTokenParams,
            request_type: request_type,
            response_mode: response_mode,
            client_secret: this.settings.client_secret,
            skipUserInfo: skipUserInfo,
            nonce: nonce,
            disablePKCE: this.settings.disablePKCE,
            omitScopeWhenRequesting: omitScopeWhenRequesting
        });
        await this.clearStaleState();
        const signinState = signinRequest.state;
        await this.settings.stateStore.set(signinState.id, signinState.toStorageString());
        return signinRequest;
    }
    async readSigninResponseState(url, removeState = false) {
        const logger2 = this._logger.create("readSigninResponseState");
        const response = new $91cdf6b8491513ba$export$60021acc97e24041($91cdf6b8491513ba$var$UrlUtils.readParams(url, this.settings.response_mode));
        if (!response.state) {
            logger2.throw(new Error("No state in response"));
            throw null;
        }
        const storedStateString = await this.settings.stateStore[removeState ? "remove" : "get"](response.state);
        if (!storedStateString) {
            logger2.throw(new Error("No matching state found in storage"));
            throw null;
        }
        const state = await $91cdf6b8491513ba$export$d12e9f373447e92a.fromStorageString(storedStateString);
        return {
            state: state,
            response: response
        };
    }
    async processSigninResponse(url, extraHeaders, removeState = true) {
        const logger2 = this._logger.create("processSigninResponse");
        const { state: state, response: response } = await this.readSigninResponseState(url, removeState);
        logger2.debug("received state from storage; validating response");
        if (this.settings.dpop && this.settings.dpop.store) {
            const dpopProof = await this.getDpopProof(this.settings.dpop.store);
            extraHeaders = {
                ...extraHeaders,
                "DPoP": dpopProof
            };
        }
        try {
            await this._validator.validateSigninResponse(response, state, extraHeaders);
        } catch (err) {
            if (err instanceof $91cdf6b8491513ba$var$ErrorDPoPNonce && this.settings.dpop) {
                const dpopProof = await this.getDpopProof(this.settings.dpop.store, err.nonce);
                extraHeaders["DPoP"] = dpopProof;
                await this._validator.validateSigninResponse(response, state, extraHeaders);
            } else throw err;
        }
        return response;
    }
    async getDpopProof(dpopStore, nonce) {
        let keyPair;
        let dpopState;
        if (!(await dpopStore.getAllKeys()).includes(this.settings.client_id)) {
            keyPair = await $91cdf6b8491513ba$var$CryptoUtils.generateDPoPKeys();
            dpopState = new $91cdf6b8491513ba$export$dc765d984eae7c82(keyPair, nonce);
            await dpopStore.set(this.settings.client_id, dpopState);
        } else {
            dpopState = await dpopStore.get(this.settings.client_id);
            if (dpopState.nonce !== nonce && nonce) {
                dpopState.nonce = nonce;
                await dpopStore.set(this.settings.client_id, dpopState);
            }
        }
        return await $91cdf6b8491513ba$var$CryptoUtils.generateDPoPProof({
            url: await this.metadataService.getTokenEndpoint(false),
            httpMethod: "POST",
            keyPair: dpopState.keys,
            nonce: dpopState.nonce
        });
    }
    async processResourceOwnerPasswordCredentials({ username: username, password: password, skipUserInfo: skipUserInfo = false, extraTokenParams: extraTokenParams = {} }) {
        const tokenResponse = await this._tokenClient.exchangeCredentials({
            username: username,
            password: password,
            ...extraTokenParams
        });
        const signinResponse = new $91cdf6b8491513ba$export$60021acc97e24041(new URLSearchParams());
        Object.assign(signinResponse, tokenResponse);
        await this._validator.validateCredentialsResponse(signinResponse, skipUserInfo);
        return signinResponse;
    }
    async useRefreshToken({ state: state, redirect_uri: redirect_uri, resource: resource, timeoutInSeconds: timeoutInSeconds, extraHeaders: extraHeaders, extraTokenParams: extraTokenParams }) {
        var _a;
        const logger2 = this._logger.create("useRefreshToken");
        let scope;
        if (this.settings.refreshTokenAllowedScope === void 0) scope = state.scope;
        else {
            const allowableScopes = this.settings.refreshTokenAllowedScope.split(" ");
            const providedScopes = ((_a = state.scope) == null ? void 0 : _a.split(" ")) || [];
            scope = providedScopes.filter((s)=>allowableScopes.includes(s)).join(" ");
        }
        if (this.settings.dpop && this.settings.dpop.store) {
            const dpopProof = await this.getDpopProof(this.settings.dpop.store);
            extraHeaders = {
                ...extraHeaders,
                "DPoP": dpopProof
            };
        }
        let result;
        try {
            result = await this._tokenClient.exchangeRefreshToken({
                refresh_token: state.refresh_token,
                scope: // provide the (possible filtered) scope list
                scope,
                redirect_uri: redirect_uri,
                resource: resource,
                timeoutInSeconds: timeoutInSeconds,
                extraHeaders: extraHeaders,
                ...extraTokenParams
            });
        } catch (err) {
            if (err instanceof $91cdf6b8491513ba$var$ErrorDPoPNonce && this.settings.dpop) {
                extraHeaders["DPoP"] = await this.getDpopProof(this.settings.dpop.store, err.nonce);
                result = await this._tokenClient.exchangeRefreshToken({
                    refresh_token: state.refresh_token,
                    scope: // provide the (possible filtered) scope list
                    scope,
                    redirect_uri: redirect_uri,
                    resource: resource,
                    timeoutInSeconds: timeoutInSeconds,
                    extraHeaders: extraHeaders,
                    ...extraTokenParams
                });
            } else throw err;
        }
        const response = new $91cdf6b8491513ba$export$60021acc97e24041(new URLSearchParams());
        Object.assign(response, result);
        logger2.debug("validating response", response);
        await this._validator.validateRefreshResponse(response, {
            ...state,
            scope: // override the scope in the state handed over to the validator
            // so it can set the granted scope to the requested scope in case none is included in the response
            scope
        });
        return response;
    }
    async createSignoutRequest({ state: state, id_token_hint: id_token_hint, client_id: client_id, request_type: request_type, url_state: url_state, post_logout_redirect_uri: post_logout_redirect_uri = this.settings.post_logout_redirect_uri, extraQueryParams: extraQueryParams = this.settings.extraQueryParams } = {}) {
        const logger2 = this._logger.create("createSignoutRequest");
        const url = await this.metadataService.getEndSessionEndpoint();
        if (!url) {
            logger2.throw(new Error("No end session endpoint"));
            throw null;
        }
        logger2.debug("Received end session endpoint", url);
        if (!client_id && post_logout_redirect_uri && !id_token_hint) client_id = this.settings.client_id;
        const request = new $91cdf6b8491513ba$var$SignoutRequest({
            url: url,
            id_token_hint: id_token_hint,
            client_id: client_id,
            post_logout_redirect_uri: post_logout_redirect_uri,
            state_data: state,
            extraQueryParams: extraQueryParams,
            request_type: request_type,
            url_state: url_state
        });
        await this.clearStaleState();
        const signoutState = request.state;
        if (signoutState) {
            logger2.debug("Signout request has state to persist");
            await this.settings.stateStore.set(signoutState.id, signoutState.toStorageString());
        }
        return request;
    }
    async readSignoutResponseState(url, removeState = false) {
        const logger2 = this._logger.create("readSignoutResponseState");
        const response = new $91cdf6b8491513ba$export$7ddf7038233313f6($91cdf6b8491513ba$var$UrlUtils.readParams(url, this.settings.response_mode));
        if (!response.state) {
            logger2.debug("No state in response");
            if (response.error) {
                logger2.warn("Response was error:", response.error);
                throw new $91cdf6b8491513ba$export$acf1a680051f5031(response);
            }
            return {
                state: void 0,
                response: response
            };
        }
        const storedStateString = await this.settings.stateStore[removeState ? "remove" : "get"](response.state);
        if (!storedStateString) {
            logger2.throw(new Error("No matching state found in storage"));
            throw null;
        }
        const state = await $91cdf6b8491513ba$export$7254cc27399e90bd.fromStorageString(storedStateString);
        return {
            state: state,
            response: response
        };
    }
    async processSignoutResponse(url) {
        const logger2 = this._logger.create("processSignoutResponse");
        const { state: state, response: response } = await this.readSignoutResponseState(url, true);
        if (state) {
            logger2.debug("Received state from storage; validating response");
            this._validator.validateSignoutResponse(response, state);
        } else logger2.debug("No state from storage; skipping response validation");
        return response;
    }
    clearStaleState() {
        this._logger.create("clearStaleState");
        return $91cdf6b8491513ba$export$7254cc27399e90bd.clearStaleState(this.settings.stateStore, this.settings.staleStateAgeInSeconds);
    }
    async revokeToken(token, type) {
        this._logger.create("revokeToken");
        return await this._tokenClient.revoke({
            token: token,
            token_type_hint: type
        });
    }
};
// src/SessionMonitor.ts
var $91cdf6b8491513ba$export$d962324009a92d99 = class {
    constructor(_userManager){
        this._userManager = _userManager;
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("SessionMonitor");
        this._start = async (user)=>{
            const session_state = user.session_state;
            if (!session_state) return;
            const logger2 = this._logger.create("_start");
            if (user.profile) {
                this._sub = user.profile.sub;
                logger2.debug("session_state", session_state, ", sub", this._sub);
            } else {
                this._sub = void 0;
                logger2.debug("session_state", session_state, ", anonymous user");
            }
            if (this._checkSessionIFrame) {
                this._checkSessionIFrame.start(session_state);
                return;
            }
            try {
                const url = await this._userManager.metadataService.getCheckSessionIframe();
                if (url) {
                    logger2.debug("initializing check session iframe");
                    const client_id = this._userManager.settings.client_id;
                    const intervalInSeconds = this._userManager.settings.checkSessionIntervalInSeconds;
                    const stopOnError = this._userManager.settings.stopCheckSessionOnError;
                    const checkSessionIFrame = new $91cdf6b8491513ba$export$e3e6062266eff2d4(this._callback, client_id, url, intervalInSeconds, stopOnError);
                    await checkSessionIFrame.load();
                    this._checkSessionIFrame = checkSessionIFrame;
                    checkSessionIFrame.start(session_state);
                } else logger2.warn("no check session iframe found in the metadata");
            } catch (err) {
                logger2.error("Error from getCheckSessionIframe:", err instanceof Error ? err.message : err);
            }
        };
        this._stop = ()=>{
            const logger2 = this._logger.create("_stop");
            this._sub = void 0;
            if (this._checkSessionIFrame) this._checkSessionIFrame.stop();
            if (this._userManager.settings.monitorAnonymousSession) {
                const timerHandle = setInterval(async ()=>{
                    clearInterval(timerHandle);
                    try {
                        const session = await this._userManager.querySessionStatus();
                        if (session) {
                            const tmpUser = {
                                session_state: session.session_state,
                                profile: session.sub ? {
                                    sub: session.sub
                                } : null
                            };
                            this._start(tmpUser);
                        }
                    } catch (err) {
                        logger2.error("error from querySessionStatus", err instanceof Error ? err.message : err);
                    }
                }, 1e3);
            }
        };
        this._callback = async ()=>{
            const logger2 = this._logger.create("_callback");
            try {
                const session = await this._userManager.querySessionStatus();
                let raiseEvent = true;
                if (session && this._checkSessionIFrame) {
                    if (session.sub === this._sub) {
                        raiseEvent = false;
                        this._checkSessionIFrame.start(session.session_state);
                        logger2.debug("same sub still logged in at OP, session state has changed, restarting check session iframe; session_state", session.session_state);
                        await this._userManager.events._raiseUserSessionChanged();
                    } else logger2.debug("different subject signed into OP", session.sub);
                } else logger2.debug("subject no longer signed into OP");
                if (raiseEvent) {
                    if (this._sub) await this._userManager.events._raiseUserSignedOut();
                    else await this._userManager.events._raiseUserSignedIn();
                } else logger2.debug("no change in session detected, no event to raise");
            } catch (err) {
                if (this._sub) {
                    logger2.debug("Error calling queryCurrentSigninSession; raising signed out event", err);
                    await this._userManager.events._raiseUserSignedOut();
                }
            }
        };
        if (!_userManager) this._logger.throw(new Error("No user manager passed"));
        this._userManager.events.addUserLoaded(this._start);
        this._userManager.events.addUserUnloaded(this._stop);
        this._init().catch((err)=>{
            this._logger.error(err);
        });
    }
    async _init() {
        this._logger.create("_init");
        const user = await this._userManager.getUser();
        if (user) this._start(user);
        else if (this._userManager.settings.monitorAnonymousSession) {
            const session = await this._userManager.querySessionStatus();
            if (session) {
                const tmpUser = {
                    session_state: session.session_state,
                    profile: session.sub ? {
                        sub: session.sub
                    } : null
                };
                this._start(tmpUser);
            }
        }
    }
};
// src/User.ts
var $91cdf6b8491513ba$export$1f44aaf2ec115b54 = class _User {
    constructor(args){
        var _a;
        this.id_token = args.id_token;
        this.session_state = (_a = args.session_state) != null ? _a : null;
        this.access_token = args.access_token;
        this.refresh_token = args.refresh_token;
        this.token_type = args.token_type;
        this.scope = args.scope;
        this.profile = args.profile;
        this.expires_at = args.expires_at;
        this.state = args.userState;
        this.url_state = args.url_state;
    }
    /** Computed number of seconds the access token has remaining. */ get expires_in() {
        if (this.expires_at === void 0) return void 0;
        return this.expires_at - $91cdf6b8491513ba$var$Timer.getEpochTime();
    }
    set expires_in(value) {
        if (value !== void 0) this.expires_at = Math.floor(value) + $91cdf6b8491513ba$var$Timer.getEpochTime();
    }
    /** Computed value indicating if the access token is expired. */ get expired() {
        const expires_in = this.expires_in;
        if (expires_in === void 0) return void 0;
        return expires_in <= 0;
    }
    /** Array representing the parsed values from the `scope`. */ get scopes() {
        var _a, _b;
        return (_b = (_a = this.scope) == null ? void 0 : _a.split(" ")) != null ? _b : [];
    }
    toStorageString() {
        new $91cdf6b8491513ba$export$efa9a398d6368992("User").create("toStorageString");
        return JSON.stringify({
            id_token: this.id_token,
            session_state: this.session_state,
            access_token: this.access_token,
            refresh_token: this.refresh_token,
            token_type: this.token_type,
            scope: this.scope,
            profile: this.profile,
            expires_at: this.expires_at
        });
    }
    static fromStorageString(storageString) {
        $91cdf6b8491513ba$export$efa9a398d6368992.createStatic("User", "fromStorageString");
        return new _User(JSON.parse(storageString));
    }
};
// src/navigators/AbstractChildWindow.ts
var $91cdf6b8491513ba$var$messageSource = "oidc-client";
var $91cdf6b8491513ba$var$AbstractChildWindow = class {
    constructor(){
        this._abort = new $91cdf6b8491513ba$var$Event("Window navigation aborted");
        this._disposeHandlers = /* @__PURE__ */ new Set();
        this._window = null;
    }
    async navigate(params) {
        const logger2 = this._logger.create("navigate");
        if (!this._window) throw new Error("Attempted to navigate on a disposed window");
        logger2.debug("setting URL in window");
        this._window.location.replace(params.url);
        const { url: url, keepOpen: keepOpen } = await new Promise((resolve, reject)=>{
            const listener = (e)=>{
                var _a;
                const data = e.data;
                const origin = (_a = params.scriptOrigin) != null ? _a : window.location.origin;
                if (e.origin !== origin || (data == null ? void 0 : data.source) !== $91cdf6b8491513ba$var$messageSource) return;
                try {
                    const state = $91cdf6b8491513ba$var$UrlUtils.readParams(data.url, params.response_mode).get("state");
                    if (!state) logger2.warn("no state found in response url");
                    if (e.source !== this._window && state !== params.state) return;
                } catch  {
                    this._dispose();
                    reject(new Error("Invalid response from window"));
                }
                resolve(data);
            };
            window.addEventListener("message", listener, false);
            this._disposeHandlers.add(()=>window.removeEventListener("message", listener, false));
            const channel = new BroadcastChannel(`oidc-client-popup-${params.state}`);
            channel.addEventListener("message", listener, false);
            this._disposeHandlers.add(()=>channel.close());
            this._disposeHandlers.add(this._abort.addHandler((reason)=>{
                this._dispose();
                reject(reason);
            }));
        });
        logger2.debug("got response from window");
        this._dispose();
        if (!keepOpen) this.close();
        return {
            url: url
        };
    }
    _dispose() {
        this._logger.create("_dispose");
        for (const dispose of this._disposeHandlers)dispose();
        this._disposeHandlers.clear();
    }
    static _notifyParent(parent, url, keepOpen = false, targetOrigin = window.location.origin) {
        const msgData = {
            source: $91cdf6b8491513ba$var$messageSource,
            url: url,
            keepOpen: keepOpen
        };
        const logger2 = new $91cdf6b8491513ba$export$efa9a398d6368992("_notifyParent");
        if (parent) {
            logger2.debug("With parent. Using parent.postMessage.");
            parent.postMessage(msgData, targetOrigin);
        } else {
            logger2.debug("No parent. Using BroadcastChannel.");
            const state = new URL(url).searchParams.get("state");
            if (!state) throw new Error("No parent and no state in URL. Can't complete notification.");
            const channel = new BroadcastChannel(`oidc-client-popup-${state}`);
            channel.postMessage(msgData);
            channel.close();
        }
    }
};
// src/UserManagerSettings.ts
var $91cdf6b8491513ba$var$DefaultPopupWindowFeatures = {
    location: false,
    toolbar: false,
    height: 640,
    closePopupWindowAfterInSeconds: -1
};
var $91cdf6b8491513ba$var$DefaultPopupTarget = "_blank";
var $91cdf6b8491513ba$var$DefaultAccessTokenExpiringNotificationTimeInSeconds = 60;
var $91cdf6b8491513ba$var$DefaultCheckSessionIntervalInSeconds = 2;
var $91cdf6b8491513ba$var$DefaultSilentRequestTimeoutInSeconds = 10;
var $91cdf6b8491513ba$export$620f0a652f69895a = class extends $91cdf6b8491513ba$export$f0d75c4d483197bb {
    constructor(args){
        const { popup_redirect_uri: popup_redirect_uri = args.redirect_uri, popup_post_logout_redirect_uri: popup_post_logout_redirect_uri = args.post_logout_redirect_uri, popupWindowFeatures: popupWindowFeatures = $91cdf6b8491513ba$var$DefaultPopupWindowFeatures, popupWindowTarget: popupWindowTarget = $91cdf6b8491513ba$var$DefaultPopupTarget, redirectMethod: redirectMethod = "assign", redirectTarget: redirectTarget = "self", iframeNotifyParentOrigin: iframeNotifyParentOrigin = args.iframeNotifyParentOrigin, iframeScriptOrigin: iframeScriptOrigin = args.iframeScriptOrigin, requestTimeoutInSeconds: requestTimeoutInSeconds, silent_redirect_uri: silent_redirect_uri = args.redirect_uri, silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds, automaticSilentRenew: automaticSilentRenew = true, validateSubOnSilentRenew: validateSubOnSilentRenew = true, includeIdTokenInSilentRenew: includeIdTokenInSilentRenew = false, monitorSession: monitorSession = false, monitorAnonymousSession: monitorAnonymousSession = false, checkSessionIntervalInSeconds: checkSessionIntervalInSeconds = $91cdf6b8491513ba$var$DefaultCheckSessionIntervalInSeconds, query_status_response_type: query_status_response_type = "code", stopCheckSessionOnError: stopCheckSessionOnError = true, revokeTokenTypes: revokeTokenTypes = [
            "access_token",
            "refresh_token"
        ], revokeTokensOnSignout: revokeTokensOnSignout = false, includeIdTokenInSilentSignout: includeIdTokenInSilentSignout = false, accessTokenExpiringNotificationTimeInSeconds: accessTokenExpiringNotificationTimeInSeconds = $91cdf6b8491513ba$var$DefaultAccessTokenExpiringNotificationTimeInSeconds, maxSilentRenewTimeoutRetries: maxSilentRenewTimeoutRetries, userStore: userStore } = args;
        super(args);
        this.popup_redirect_uri = popup_redirect_uri;
        this.popup_post_logout_redirect_uri = popup_post_logout_redirect_uri;
        this.popupWindowFeatures = popupWindowFeatures;
        this.popupWindowTarget = popupWindowTarget;
        this.redirectMethod = redirectMethod;
        this.redirectTarget = redirectTarget;
        this.iframeNotifyParentOrigin = iframeNotifyParentOrigin;
        this.iframeScriptOrigin = iframeScriptOrigin;
        this.silent_redirect_uri = silent_redirect_uri;
        this.silentRequestTimeoutInSeconds = silentRequestTimeoutInSeconds || requestTimeoutInSeconds || $91cdf6b8491513ba$var$DefaultSilentRequestTimeoutInSeconds;
        this.automaticSilentRenew = automaticSilentRenew;
        this.validateSubOnSilentRenew = validateSubOnSilentRenew;
        this.includeIdTokenInSilentRenew = includeIdTokenInSilentRenew;
        this.monitorSession = monitorSession;
        this.monitorAnonymousSession = monitorAnonymousSession;
        this.checkSessionIntervalInSeconds = checkSessionIntervalInSeconds;
        this.stopCheckSessionOnError = stopCheckSessionOnError;
        this.query_status_response_type = query_status_response_type;
        this.revokeTokenTypes = revokeTokenTypes;
        this.revokeTokensOnSignout = revokeTokensOnSignout;
        this.includeIdTokenInSilentSignout = includeIdTokenInSilentSignout;
        this.accessTokenExpiringNotificationTimeInSeconds = accessTokenExpiringNotificationTimeInSeconds;
        this.maxSilentRenewTimeoutRetries = maxSilentRenewTimeoutRetries;
        if (userStore) this.userStore = userStore;
        else {
            const store = typeof window !== "undefined" ? window.sessionStorage : new $91cdf6b8491513ba$export$46e428416143c79c();
            this.userStore = new $91cdf6b8491513ba$export$6a5d9eefd8f07eee({
                store: store
            });
        }
    }
};
// src/navigators/IFrameWindow.ts
var $91cdf6b8491513ba$var$IFrameWindow = class _IFrameWindow extends $91cdf6b8491513ba$var$AbstractChildWindow {
    constructor({ silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds = $91cdf6b8491513ba$var$DefaultSilentRequestTimeoutInSeconds }){
        super();
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("IFrameWindow");
        this._timeoutInSeconds = silentRequestTimeoutInSeconds;
        this._frame = _IFrameWindow.createHiddenIframe();
        this._window = this._frame.contentWindow;
    }
    static createHiddenIframe() {
        const iframe = window.document.createElement("iframe");
        iframe.style.visibility = "hidden";
        iframe.style.position = "fixed";
        iframe.style.left = "-1000px";
        iframe.style.top = "0";
        iframe.width = "0";
        iframe.height = "0";
        window.document.body.appendChild(iframe);
        return iframe;
    }
    async navigate(params) {
        this._logger.debug("navigate: Using timeout of:", this._timeoutInSeconds);
        const timer = setTimeout(()=>void this._abort.raise(new $91cdf6b8491513ba$export$5312ab5d2c8d859c("IFrame timed out without a response")), this._timeoutInSeconds * 1e3);
        this._disposeHandlers.add(()=>clearTimeout(timer));
        return await super.navigate(params);
    }
    close() {
        var _a;
        if (this._frame) {
            if (this._frame.parentNode) {
                this._frame.addEventListener("load", (ev)=>{
                    var _a2;
                    const frame = ev.target;
                    (_a2 = frame.parentNode) == null || _a2.removeChild(frame);
                    this._abort.raise(new Error("IFrame removed from DOM"));
                }, true);
                (_a = this._frame.contentWindow) == null || _a.location.replace("about:blank");
            }
            this._frame = null;
        }
        this._window = null;
    }
    static notifyParent(url, targetOrigin) {
        return super._notifyParent(window.parent, url, false, targetOrigin);
    }
};
// src/navigators/IFrameNavigator.ts
var $91cdf6b8491513ba$var$IFrameNavigator = class {
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("IFrameNavigator");
    }
    async prepare({ silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds = this._settings.silentRequestTimeoutInSeconds }) {
        return new $91cdf6b8491513ba$var$IFrameWindow({
            silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
        });
    }
    async callback(url) {
        this._logger.create("callback");
        $91cdf6b8491513ba$var$IFrameWindow.notifyParent(url, this._settings.iframeNotifyParentOrigin);
    }
};
// src/navigators/PopupWindow.ts
var $91cdf6b8491513ba$var$checkForPopupClosedInterval = 500;
var $91cdf6b8491513ba$var$second = 1e3;
var $91cdf6b8491513ba$var$PopupWindow = class extends $91cdf6b8491513ba$var$AbstractChildWindow {
    constructor({ popupWindowTarget: popupWindowTarget = $91cdf6b8491513ba$var$DefaultPopupTarget, popupWindowFeatures: popupWindowFeatures = {}, popupSignal: popupSignal, popupAbortOnClose: popupAbortOnClose }){
        super();
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("PopupWindow");
        const centeredPopup = $91cdf6b8491513ba$var$PopupUtils.center({
            ...$91cdf6b8491513ba$var$DefaultPopupWindowFeatures,
            ...popupWindowFeatures
        });
        this._window = window.open(void 0, popupWindowTarget, $91cdf6b8491513ba$var$PopupUtils.serialize(centeredPopup));
        this.abortOnClose = Boolean(popupAbortOnClose);
        if (popupSignal) popupSignal.addEventListener("abort", ()=>{
            var _a;
            this._abort.raise(new Error((_a = popupSignal.reason) != null ? _a : "Popup aborted"));
        });
        if (popupWindowFeatures.closePopupWindowAfterInSeconds && popupWindowFeatures.closePopupWindowAfterInSeconds > 0) setTimeout(()=>{
            if (!this._window || typeof this._window.closed !== "boolean" || this._window.closed) {
                this._abort.raise(new Error("Popup blocked by user"));
                return;
            }
            this.close();
        }, popupWindowFeatures.closePopupWindowAfterInSeconds * $91cdf6b8491513ba$var$second);
    }
    async navigate(params) {
        var _a;
        (_a = this._window) == null || _a.focus();
        const popupClosedInterval = setInterval(()=>{
            if (!this._window || this._window.closed) {
                this._logger.debug("Popup closed by user or isolated by redirect");
                clearPopupClosedInterval();
                this._disposeHandlers.delete(clearPopupClosedInterval);
                if (this.abortOnClose) this._abort.raise(new Error("Popup closed by user"));
            }
        }, $91cdf6b8491513ba$var$checkForPopupClosedInterval);
        const clearPopupClosedInterval = ()=>clearInterval(popupClosedInterval);
        this._disposeHandlers.add(clearPopupClosedInterval);
        return await super.navigate(params);
    }
    close() {
        if (this._window) {
            if (!this._window.closed) {
                this._window.close();
                this._abort.raise(new Error("Popup closed"));
            }
        }
        this._window = null;
    }
    static notifyOpener(url, keepOpen) {
        super._notifyParent(window.opener, url, keepOpen);
        if (!keepOpen && !window.opener) window.close();
    }
};
// src/navigators/PopupNavigator.ts
var $91cdf6b8491513ba$var$PopupNavigator = class {
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("PopupNavigator");
    }
    async prepare({ popupWindowFeatures: popupWindowFeatures = this._settings.popupWindowFeatures, popupWindowTarget: popupWindowTarget = this._settings.popupWindowTarget, popupSignal: popupSignal, popupAbortOnClose: popupAbortOnClose }) {
        return new $91cdf6b8491513ba$var$PopupWindow({
            popupWindowFeatures: popupWindowFeatures,
            popupWindowTarget: popupWindowTarget,
            popupSignal: popupSignal,
            popupAbortOnClose: popupAbortOnClose
        });
    }
    async callback(url, { keepOpen: keepOpen = false }) {
        this._logger.create("callback");
        $91cdf6b8491513ba$var$PopupWindow.notifyOpener(url, keepOpen);
    }
};
// src/navigators/RedirectNavigator.ts
var $91cdf6b8491513ba$var$RedirectNavigator = class {
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("RedirectNavigator");
    }
    async prepare({ redirectMethod: redirectMethod = this._settings.redirectMethod, redirectTarget: redirectTarget = this._settings.redirectTarget }) {
        var _a;
        this._logger.create("prepare");
        let targetWindow = window.self;
        if (redirectTarget === "top") targetWindow = (_a = window.top) != null ? _a : window.self;
        const redirect = targetWindow.location[redirectMethod].bind(targetWindow.location);
        let abort;
        return {
            navigate: async (params)=>{
                this._logger.create("navigate");
                const promise = new Promise((resolve, reject)=>{
                    abort = reject;
                    window.addEventListener("pageshow", ()=>resolve(window.location.href));
                    redirect(params.url);
                });
                return await promise;
            },
            close: ()=>{
                this._logger.create("close");
                abort == null || abort(new Error("Redirect aborted"));
                targetWindow.stop();
            }
        };
    }
    async callback() {
        return;
    }
};
// src/UserManagerEvents.ts
var $91cdf6b8491513ba$var$UserManagerEvents = class extends $91cdf6b8491513ba$export$3b2b5f2b57921d4f {
    constructor(settings){
        super({
            expiringNotificationTimeInSeconds: settings.accessTokenExpiringNotificationTimeInSeconds
        });
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("UserManagerEvents");
        this._userLoaded = new $91cdf6b8491513ba$var$Event("User loaded");
        this._userUnloaded = new $91cdf6b8491513ba$var$Event("User unloaded");
        this._silentRenewError = new $91cdf6b8491513ba$var$Event("Silent renew error");
        this._userSignedIn = new $91cdf6b8491513ba$var$Event("User signed in");
        this._userSignedOut = new $91cdf6b8491513ba$var$Event("User signed out");
        this._userSessionChanged = new $91cdf6b8491513ba$var$Event("User session changed");
    }
    async load(user, raiseEvent = true) {
        await super.load(user);
        if (raiseEvent) await this._userLoaded.raise(user);
    }
    async unload() {
        await super.unload();
        await this._userUnloaded.raise();
    }
    /**
   * Add callback: Raised when a user session has been established (or re-established).
   */ addUserLoaded(cb) {
        return this._userLoaded.addHandler(cb);
    }
    /**
   * Remove callback: Raised when a user session has been established (or re-established).
   */ removeUserLoaded(cb) {
        return this._userLoaded.removeHandler(cb);
    }
    /**
   * Add callback: Raised when a user session has been terminated.
   */ addUserUnloaded(cb) {
        return this._userUnloaded.addHandler(cb);
    }
    /**
   * Remove callback: Raised when a user session has been terminated.
   */ removeUserUnloaded(cb) {
        return this._userUnloaded.removeHandler(cb);
    }
    /**
   * Add callback: Raised when the automatic silent renew has failed.
   */ addSilentRenewError(cb) {
        return this._silentRenewError.addHandler(cb);
    }
    /**
   * Remove callback: Raised when the automatic silent renew has failed.
   */ removeSilentRenewError(cb) {
        return this._silentRenewError.removeHandler(cb);
    }
    /**
   * @internal
   */ async _raiseSilentRenewError(e) {
        await this._silentRenewError.raise(e);
    }
    /**
   * Add callback: Raised when the user is signed in (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */ addUserSignedIn(cb) {
        return this._userSignedIn.addHandler(cb);
    }
    /**
   * Remove callback: Raised when the user is signed in (when `monitorSession` is set).
   */ removeUserSignedIn(cb) {
        this._userSignedIn.removeHandler(cb);
    }
    /**
   * @internal
   */ async _raiseUserSignedIn() {
        await this._userSignedIn.raise();
    }
    /**
   * Add callback: Raised when the user's sign-in status at the OP has changed (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */ addUserSignedOut(cb) {
        return this._userSignedOut.addHandler(cb);
    }
    /**
   * Remove callback: Raised when the user's sign-in status at the OP has changed (when `monitorSession` is set).
   */ removeUserSignedOut(cb) {
        this._userSignedOut.removeHandler(cb);
    }
    /**
   * @internal
   */ async _raiseUserSignedOut() {
        await this._userSignedOut.raise();
    }
    /**
   * Add callback: Raised when the user session changed (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */ addUserSessionChanged(cb) {
        return this._userSessionChanged.addHandler(cb);
    }
    /**
   * Remove callback: Raised when the user session changed (when `monitorSession` is set).
   */ removeUserSessionChanged(cb) {
        this._userSessionChanged.removeHandler(cb);
    }
    /**
   * @internal
   */ async _raiseUserSessionChanged() {
        await this._userSessionChanged.raise();
    }
};
// src/SilentRenewService.ts
var $91cdf6b8491513ba$var$SilentRenewService = class {
    constructor(_userManager){
        this._userManager = _userManager;
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("SilentRenewService");
        this._isStarted = false;
        this._retryTimer = new $91cdf6b8491513ba$var$Timer("Retry Silent Renew");
        this._timeoutRetryCount = 0;
        this._tokenExpiring = async ()=>{
            const logger2 = this._logger.create("_tokenExpiring");
            try {
                await this._userManager.signinSilent();
                this._timeoutRetryCount = 0;
                logger2.debug("silent token renewal successful");
            } catch (err) {
                if (err instanceof $91cdf6b8491513ba$export$5312ab5d2c8d859c) {
                    this._timeoutRetryCount++;
                    const maxRetries = this._userManager.settings.maxSilentRenewTimeoutRetries;
                    const hasReachedLimit = maxRetries !== void 0 && this._timeoutRetryCount > maxRetries;
                    if (hasReachedLimit) {
                        logger2.error(`Timeout retry limit reached (${this._timeoutRetryCount} > ${maxRetries}), raising silentRenewError:`, err);
                        this._timeoutRetryCount = 0;
                        await this._userManager.events._raiseSilentRenewError(err);
                        return;
                    }
                    logger2.warn(`ErrorTimeout from signinSilent (attempt ${this._timeoutRetryCount}), retry in 5s:`, err);
                    this._retryTimer.init(5);
                    return;
                }
                logger2.error("Error from signinSilent:", err);
                this._timeoutRetryCount = 0;
                await this._userManager.events._raiseSilentRenewError(err);
            }
        };
    }
    async start() {
        const logger2 = this._logger.create("start");
        if (!this._isStarted) {
            this._isStarted = true;
            this._userManager.events.addAccessTokenExpiring(this._tokenExpiring);
            this._retryTimer.addHandler(this._tokenExpiring);
            try {
                await this._userManager.getUser();
            } catch (err) {
                logger2.error("getUser error", err);
            }
        }
    }
    stop() {
        if (this._isStarted) {
            this._retryTimer.cancel();
            this._retryTimer.removeHandler(this._tokenExpiring);
            this._userManager.events.removeAccessTokenExpiring(this._tokenExpiring);
            this._isStarted = false;
        }
    }
};
// src/RefreshState.ts
var $91cdf6b8491513ba$var$RefreshState = class {
    constructor(args){
        this.refresh_token = args.refresh_token;
        this.id_token = args.id_token;
        this.session_state = args.session_state;
        this.scope = args.scope;
        this.profile = args.profile;
        this.data = args.state;
    }
};
// src/UserManager.ts
var $91cdf6b8491513ba$export$4c4d82ee86d9366d = class {
    constructor(settings, redirectNavigator, popupNavigator, iframeNavigator){
        this._logger = new $91cdf6b8491513ba$export$efa9a398d6368992("UserManager");
        this.settings = new $91cdf6b8491513ba$export$620f0a652f69895a(settings);
        this._client = new $91cdf6b8491513ba$export$b112d407fa897c7e(settings);
        this._redirectNavigator = redirectNavigator != null ? redirectNavigator : new $91cdf6b8491513ba$var$RedirectNavigator(this.settings);
        this._popupNavigator = popupNavigator != null ? popupNavigator : new $91cdf6b8491513ba$var$PopupNavigator(this.settings);
        this._iframeNavigator = iframeNavigator != null ? iframeNavigator : new $91cdf6b8491513ba$var$IFrameNavigator(this.settings);
        this._events = new $91cdf6b8491513ba$var$UserManagerEvents(this.settings);
        this._silentRenewService = new $91cdf6b8491513ba$var$SilentRenewService(this);
        if (this.settings.automaticSilentRenew) this.startSilentRenew();
        this._sessionMonitor = null;
        if (this.settings.monitorSession) this._sessionMonitor = new $91cdf6b8491513ba$export$d962324009a92d99(this);
    }
    /**
   * Get object used to register for events raised by the `UserManager`.
   */ get events() {
        return this._events;
    }
    /**
   * Get object used to access the metadata configuration of the identity provider.
   */ get metadataService() {
        return this._client.metadataService;
    }
    /**
   * Load the `User` object for the currently authenticated user.
   *
   * @param raiseEvent - If `true`, the `UserLoaded` event will be raised. Defaults to false.
   * @returns A promise
   */ async getUser(raiseEvent = false) {
        const logger2 = this._logger.create("getUser");
        const user = await this._loadUser();
        if (user) {
            logger2.info("user loaded");
            await this._events.load(user, raiseEvent);
            return user;
        }
        logger2.info("user not found in storage");
        return null;
    }
    /**
   * Remove from any storage the currently authenticated user.
   *
   * @returns A promise
   */ async removeUser() {
        const logger2 = this._logger.create("removeUser");
        await this.storeUser(null);
        logger2.info("user removed from storage");
        await this._events.unload();
    }
    /**
   * Trigger a redirect of the current window to the authorization endpoint.
   *
   * @returns A promise
   *
   * @throws `Error` In cases of wrong authentication.
   */ async signinRedirect(args = {}) {
        var _a;
        this._logger.create("signinRedirect");
        const { redirectMethod: redirectMethod, ...requestArgs } = args;
        let dpopJkt;
        if ((_a = this.settings.dpop) == null ? void 0 : _a.bind_authorization_code) dpopJkt = await this.generateDPoPJkt(this.settings.dpop);
        const handle = await this._redirectNavigator.prepare({
            redirectMethod: redirectMethod
        });
        await this._signinStart({
            request_type: "si:r",
            dpopJkt: dpopJkt,
            ...requestArgs
        }, handle);
    }
    /**
   * Process the response (callback) from the authorization endpoint.
   * It is recommended to use {@link UserManager.signinCallback} instead.
   *
   * @returns A promise containing the authenticated `User`.
   *
   * @see {@link UserManager.signinCallback}
   */ async signinRedirectCallback(url = window.location.href) {
        const logger2 = this._logger.create("signinRedirectCallback");
        const user = await this._signinEnd(url);
        if (user.profile && user.profile.sub) logger2.info("success, signed in subject", user.profile.sub);
        else logger2.info("no subject");
        return user;
    }
    /**
   * Trigger the signin with user/password.
   *
   * @returns A promise containing the authenticated `User`.
   * @throws {@link ErrorResponse} In cases of wrong authentication.
   */ async signinResourceOwnerCredentials({ username: username, password: password, skipUserInfo: skipUserInfo = false }) {
        const logger2 = this._logger.create("signinResourceOwnerCredential");
        const signinResponse = await this._client.processResourceOwnerPasswordCredentials({
            username: username,
            password: password,
            skipUserInfo: skipUserInfo,
            extraTokenParams: this.settings.extraTokenParams
        });
        logger2.debug("got signin response");
        const user = await this._buildUser(signinResponse);
        if (user.profile && user.profile.sub) logger2.info("success, signed in subject", user.profile.sub);
        else logger2.info("no subject");
        return user;
    }
    /**
   * Trigger a request (via a popup window) to the authorization endpoint.
   *
   * @returns A promise containing the authenticated `User`.
   * @throws `Error` In cases of wrong authentication.
   */ async signinPopup(args = {}) {
        var _a;
        const logger2 = this._logger.create("signinPopup");
        let dpopJkt;
        if ((_a = this.settings.dpop) == null ? void 0 : _a.bind_authorization_code) dpopJkt = await this.generateDPoPJkt(this.settings.dpop);
        const { popupWindowFeatures: popupWindowFeatures, popupWindowTarget: popupWindowTarget, popupSignal: popupSignal, popupAbortOnClose: popupAbortOnClose, ...requestArgs } = args;
        const url = this.settings.popup_redirect_uri;
        if (!url) logger2.throw(new Error("No popup_redirect_uri configured"));
        const handle = await this._popupNavigator.prepare({
            popupWindowFeatures: popupWindowFeatures,
            popupWindowTarget: popupWindowTarget,
            popupSignal: popupSignal,
            popupAbortOnClose: popupAbortOnClose
        });
        const user = await this._signin({
            request_type: "si:p",
            redirect_uri: url,
            display: "popup",
            dpopJkt: dpopJkt,
            ...requestArgs
        }, handle);
        if (user) {
            if (user.profile && user.profile.sub) logger2.info("success, signed in subject", user.profile.sub);
            else logger2.info("no subject");
        }
        return user;
    }
    /**
   * Notify the opening window of response (callback) from the authorization endpoint.
   * It is recommended to use {@link UserManager.signinCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signinCallback}
   */ async signinPopupCallback(url = window.location.href, keepOpen = false) {
        const logger2 = this._logger.create("signinPopupCallback");
        await this._popupNavigator.callback(url, {
            keepOpen: keepOpen
        });
        logger2.info("success");
    }
    /**
   * Trigger a silent request (via refresh token or an iframe) to the authorization endpoint.
   *
   * @returns A promise that contains the authenticated `User`.
   */ async signinSilent(args = {}) {
        var _a, _b;
        const logger2 = this._logger.create("signinSilent");
        const { silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds, ...requestArgs } = args;
        let user = await this._loadUser();
        if (!args.forceIframeAuth && (user == null ? void 0 : user.refresh_token)) {
            logger2.debug("using refresh token");
            const state = new $91cdf6b8491513ba$var$RefreshState(user);
            return await this._useRefreshToken({
                state: state,
                redirect_uri: requestArgs.redirect_uri,
                resource: requestArgs.resource,
                extraTokenParams: requestArgs.extraTokenParams,
                timeoutInSeconds: silentRequestTimeoutInSeconds
            });
        }
        let dpopJkt;
        if ((_a = this.settings.dpop) == null ? void 0 : _a.bind_authorization_code) dpopJkt = await this.generateDPoPJkt(this.settings.dpop);
        const url = this.settings.silent_redirect_uri;
        if (!url) logger2.throw(new Error("No silent_redirect_uri configured"));
        let verifySub;
        if (user && this.settings.validateSubOnSilentRenew) {
            logger2.debug("subject prior to silent renew:", user.profile.sub);
            verifySub = user.profile.sub;
        }
        const handle = await this._iframeNavigator.prepare({
            silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
        });
        user = await this._signin({
            request_type: "si:s",
            redirect_uri: url,
            prompt: "none",
            id_token_hint: this.settings.includeIdTokenInSilentRenew ? user == null ? void 0 : user.id_token : void 0,
            dpopJkt: dpopJkt,
            ...requestArgs
        }, handle, verifySub);
        if (user) {
            if ((_b = user.profile) == null ? void 0 : _b.sub) logger2.info("success, signed in subject", user.profile.sub);
            else logger2.info("no subject");
        }
        return user;
    }
    async _useRefreshToken(args) {
        const response = await this._client.useRefreshToken({
            timeoutInSeconds: this.settings.silentRequestTimeoutInSeconds,
            ...args
        });
        const user = new $91cdf6b8491513ba$export$1f44aaf2ec115b54({
            ...args.state,
            ...response
        });
        await this.storeUser(user);
        await this._events.load(user);
        return user;
    }
    /**
   *
   * Notify the parent window of response (callback) from the authorization endpoint.
   * It is recommended to use {@link UserManager.signinCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signinCallback}
   */ async signinSilentCallback(url = window.location.href) {
        const logger2 = this._logger.create("signinSilentCallback");
        await this._iframeNavigator.callback(url);
        logger2.info("success");
    }
    /**
   * Process any response (callback) from the authorization endpoint, by dispatching the request_type
   * and executing one of the following functions:
   * - {@link UserManager.signinRedirectCallback}
   * - {@link UserManager.signinPopupCallback}
   * - {@link UserManager.signinSilentCallback}
   *
   * @throws `Error` If request_type is unknown or signin cannot be processed.
   */ async signinCallback(url = window.location.href) {
        const { state: state } = await this._client.readSigninResponseState(url);
        switch(state.request_type){
            case "si:r":
                return await this.signinRedirectCallback(url);
            case "si:p":
                await this.signinPopupCallback(url);
                break;
            case "si:s":
                await this.signinSilentCallback(url);
                break;
            default:
                throw new Error("invalid request_type in state");
        }
        return void 0;
    }
    /**
   * Process any response (callback) from the end session endpoint, by dispatching the request_type
   * and executing one of the following functions:
   * - {@link UserManager.signoutRedirectCallback}
   * - {@link UserManager.signoutPopupCallback}
   * - {@link UserManager.signoutSilentCallback}
   *
   * @throws `Error` If request_type is unknown or signout cannot be processed.
   */ async signoutCallback(url = window.location.href, keepOpen = false) {
        const { state: state } = await this._client.readSignoutResponseState(url);
        if (!state) return void 0;
        switch(state.request_type){
            case "so:r":
                return await this.signoutRedirectCallback(url);
            case "so:p":
                await this.signoutPopupCallback(url, keepOpen);
                break;
            case "so:s":
                await this.signoutSilentCallback(url);
                break;
            default:
                throw new Error("invalid request_type in state");
        }
        return void 0;
    }
    /**
   * Query OP for user's current signin status.
   *
   * @returns A promise object with session_state and subject identifier.
   */ async querySessionStatus(args = {}) {
        const logger2 = this._logger.create("querySessionStatus");
        const { silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds, ...requestArgs } = args;
        const url = this.settings.silent_redirect_uri;
        if (!url) logger2.throw(new Error("No silent_redirect_uri configured"));
        const user = await this._loadUser();
        const handle = await this._iframeNavigator.prepare({
            silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
        });
        const navResponse = await this._signinStart({
            request_type: "si:s",
            // this acts like a signin silent
            redirect_uri: url,
            prompt: "none",
            id_token_hint: this.settings.includeIdTokenInSilentRenew ? user == null ? void 0 : user.id_token : void 0,
            response_type: this.settings.query_status_response_type,
            scope: "openid",
            skipUserInfo: true,
            ...requestArgs
        }, handle);
        try {
            const extraHeaders = {};
            const signinResponse = await this._client.processSigninResponse(navResponse.url, extraHeaders);
            logger2.debug("got signin response");
            if (signinResponse.session_state && signinResponse.profile.sub) {
                logger2.info("success for subject", signinResponse.profile.sub);
                return {
                    session_state: signinResponse.session_state,
                    sub: signinResponse.profile.sub
                };
            }
            logger2.info("success, user not authenticated");
            return null;
        } catch (err) {
            if (this.settings.monitorAnonymousSession && err instanceof $91cdf6b8491513ba$export$acf1a680051f5031) switch(err.error){
                case "login_required":
                case "consent_required":
                case "interaction_required":
                case "account_selection_required":
                    logger2.info("success for anonymous user");
                    return {
                        session_state: err.session_state
                    };
            }
            throw err;
        }
    }
    async _signin(args, handle, verifySub) {
        const navResponse = await this._signinStart(args, handle);
        return await this._signinEnd(navResponse.url, verifySub);
    }
    async _signinStart(args, handle) {
        const logger2 = this._logger.create("_signinStart");
        try {
            const signinRequest = await this._client.createSigninRequest(args);
            logger2.debug("got signin request");
            return await handle.navigate({
                url: signinRequest.url,
                state: signinRequest.state.id,
                response_mode: signinRequest.state.response_mode,
                scriptOrigin: this.settings.iframeScriptOrigin
            });
        } catch (err) {
            logger2.debug("error after preparing navigator, closing navigator window");
            handle.close();
            throw err;
        }
    }
    async _signinEnd(url, verifySub) {
        const logger2 = this._logger.create("_signinEnd");
        const extraHeaders = {};
        const signinResponse = await this._client.processSigninResponse(url, extraHeaders);
        logger2.debug("got signin response");
        const user = await this._buildUser(signinResponse, verifySub);
        return user;
    }
    async _buildUser(signinResponse, verifySub) {
        const logger2 = this._logger.create("_buildUser");
        const user = new $91cdf6b8491513ba$export$1f44aaf2ec115b54(signinResponse);
        if (verifySub) {
            if (verifySub !== user.profile.sub) {
                logger2.debug("current user does not match user returned from signin. sub from signin:", user.profile.sub);
                throw new $91cdf6b8491513ba$export$acf1a680051f5031({
                    ...signinResponse,
                    error: "login_required"
                });
            }
            logger2.debug("current user matches user returned from signin");
        }
        await this.storeUser(user);
        logger2.debug("user stored");
        await this._events.load(user);
        return user;
    }
    /**
   * Trigger a redirect of the current window to the end session endpoint.
   *
   * @returns A promise
   */ async signoutRedirect(args = {}) {
        const logger2 = this._logger.create("signoutRedirect");
        const { redirectMethod: redirectMethod, ...requestArgs } = args;
        const handle = await this._redirectNavigator.prepare({
            redirectMethod: redirectMethod
        });
        await this._signoutStart({
            request_type: "so:r",
            post_logout_redirect_uri: this.settings.post_logout_redirect_uri,
            ...requestArgs
        }, handle);
        logger2.info("success");
    }
    /**
   * Process response (callback) from the end session endpoint.
   * It is recommended to use {@link UserManager.signoutCallback} instead.
   *
   * @returns A promise containing signout response
   *
   * @see {@link UserManager.signoutCallback}
   */ async signoutRedirectCallback(url = window.location.href) {
        const logger2 = this._logger.create("signoutRedirectCallback");
        const response = await this._signoutEnd(url);
        logger2.info("success");
        return response;
    }
    /**
   * Trigger a redirect of a popup window to the end session endpoint.
   *
   * @returns A promise
   */ async signoutPopup(args = {}) {
        const logger2 = this._logger.create("signoutPopup");
        const { popupWindowFeatures: popupWindowFeatures, popupWindowTarget: popupWindowTarget, popupSignal: popupSignal, ...requestArgs } = args;
        const url = this.settings.popup_post_logout_redirect_uri;
        const handle = await this._popupNavigator.prepare({
            popupWindowFeatures: popupWindowFeatures,
            popupWindowTarget: popupWindowTarget,
            popupSignal: popupSignal
        });
        await this._signout({
            request_type: "so:p",
            post_logout_redirect_uri: url,
            // we're putting a dummy entry in here because we
            // need a unique id from the state for notification
            // to the parent window, which is necessary if we
            // plan to return back to the client after signout
            // and so we can close the popup after signout
            state: url == null ? void 0 : {},
            ...requestArgs
        }, handle);
        logger2.info("success");
    }
    /**
   * Process response (callback) from the end session endpoint from a popup window.
   * It is recommended to use {@link UserManager.signoutCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signoutCallback}
   */ async signoutPopupCallback(url = window.location.href, keepOpen = false) {
        const logger2 = this._logger.create("signoutPopupCallback");
        await this._popupNavigator.callback(url, {
            keepOpen: keepOpen
        });
        logger2.info("success");
    }
    async _signout(args, handle) {
        const navResponse = await this._signoutStart(args, handle);
        return await this._signoutEnd(navResponse.url);
    }
    async _signoutStart(args = {}, handle) {
        var _a;
        const logger2 = this._logger.create("_signoutStart");
        try {
            const user = await this._loadUser();
            logger2.debug("loaded current user from storage");
            if (this.settings.revokeTokensOnSignout) await this._revokeInternal(user);
            const id_token = args.id_token_hint || user && user.id_token;
            if (id_token) {
                logger2.debug("setting id_token_hint in signout request");
                args.id_token_hint = id_token;
            }
            await this.removeUser();
            logger2.debug("user removed, creating signout request");
            const signoutRequest = await this._client.createSignoutRequest(args);
            logger2.debug("got signout request");
            return await handle.navigate({
                url: signoutRequest.url,
                state: (_a = signoutRequest.state) == null ? void 0 : _a.id,
                scriptOrigin: this.settings.iframeScriptOrigin
            });
        } catch (err) {
            logger2.debug("error after preparing navigator, closing navigator window");
            handle.close();
            throw err;
        }
    }
    async _signoutEnd(url) {
        const logger2 = this._logger.create("_signoutEnd");
        const signoutResponse = await this._client.processSignoutResponse(url);
        logger2.debug("got signout response");
        return signoutResponse;
    }
    /**
   * Trigger a silent request (via an iframe) to the end session endpoint.
   *
   * @returns A promise
   */ async signoutSilent(args = {}) {
        var _a;
        const logger2 = this._logger.create("signoutSilent");
        const { silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds, ...requestArgs } = args;
        const id_token_hint = this.settings.includeIdTokenInSilentSignout ? (_a = await this._loadUser()) == null ? void 0 : _a.id_token : void 0;
        const url = this.settings.popup_post_logout_redirect_uri;
        const handle = await this._iframeNavigator.prepare({
            silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
        });
        await this._signout({
            request_type: "so:s",
            post_logout_redirect_uri: url,
            id_token_hint: id_token_hint,
            ...requestArgs
        }, handle);
        logger2.info("success");
    }
    /**
   * Notify the parent window of response (callback) from the end session endpoint.
   * It is recommended to use {@link UserManager.signoutCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signoutCallback}
   */ async signoutSilentCallback(url = window.location.href) {
        const logger2 = this._logger.create("signoutSilentCallback");
        await this._iframeNavigator.callback(url);
        logger2.info("success");
    }
    async revokeTokens(types) {
        const user = await this._loadUser();
        await this._revokeInternal(user, types);
    }
    async _revokeInternal(user, types = this.settings.revokeTokenTypes) {
        const logger2 = this._logger.create("_revokeInternal");
        if (!user) return;
        const typesPresent = types.filter((type)=>typeof user[type] === "string");
        if (!typesPresent.length) {
            logger2.debug("no need to revoke due to no token(s)");
            return;
        }
        for (const type of typesPresent){
            await this._client.revokeToken(user[type], type);
            logger2.info(`${type} revoked successfully`);
            if (type !== "access_token") user[type] = null;
        }
        await this.storeUser(user);
        logger2.debug("user stored");
        await this._events.load(user);
    }
    /**
   * Enables silent renew for the `UserManager`.
   */ startSilentRenew() {
        this._logger.create("startSilentRenew");
        this._silentRenewService.start();
    }
    /**
   * Disables silent renew for the `UserManager`.
   */ stopSilentRenew() {
        this._silentRenewService.stop();
    }
    get _userStoreKey() {
        return `user:${this.settings.authority}:${this.settings.client_id}`;
    }
    async _loadUser() {
        const logger2 = this._logger.create("_loadUser");
        const storageString = await this.settings.userStore.get(this._userStoreKey);
        if (storageString) {
            logger2.debug("user storageString loaded");
            return $91cdf6b8491513ba$export$1f44aaf2ec115b54.fromStorageString(storageString);
        }
        logger2.debug("no user storageString");
        return null;
    }
    async storeUser(user) {
        const logger2 = this._logger.create("storeUser");
        if (user) {
            logger2.debug("storing user");
            const storageString = user.toStorageString();
            await this.settings.userStore.set(this._userStoreKey, storageString);
        } else {
            this._logger.debug("removing user");
            await this.settings.userStore.remove(this._userStoreKey);
            if (this.settings.dpop) await this.settings.dpop.store.remove(this.settings.client_id);
        }
    }
    /**
   * Removes stale state entries in storage for incomplete authorize requests.
   */ async clearStaleState() {
        await this._client.clearStaleState();
    }
    /**
   * Dynamically generates a DPoP proof for a given user, URL and optional Http method.
   * This method is useful when you need to make a request to a resource server
   * with fetch or similar, and you need to include a DPoP proof in a DPoP header.
   * @param url - The URL to generate the DPoP proof for
   * @param user - The user to generate the DPoP proof for
   * @param httpMethod - Optional, defaults to "GET"
   * @param nonce - Optional nonce provided by the resource server
   *
   * @returns A promise containing the DPoP proof or undefined if DPoP is not enabled/no user is found.
   */ async dpopProof(url, user, httpMethod, nonce) {
        var _a, _b;
        const dpopState = await ((_b = (_a = this.settings.dpop) == null ? void 0 : _a.store) == null ? void 0 : _b.get(this.settings.client_id));
        if (dpopState) return await $91cdf6b8491513ba$var$CryptoUtils.generateDPoPProof({
            url: url,
            accessToken: user == null ? void 0 : user.access_token,
            httpMethod: httpMethod,
            keyPair: dpopState.keys,
            nonce: nonce
        });
        return void 0;
    }
    async generateDPoPJkt(dpopSettings) {
        let dpopState = await dpopSettings.store.get(this.settings.client_id);
        if (!dpopState) {
            const dpopKeys = await $91cdf6b8491513ba$var$CryptoUtils.generateDPoPKeys();
            dpopState = new $91cdf6b8491513ba$export$dc765d984eae7c82(dpopKeys);
            await dpopSettings.store.set(this.settings.client_id, dpopState);
        }
        return await $91cdf6b8491513ba$var$CryptoUtils.generateDPoPJkt(dpopState.keys);
    }
};
// package.json
var $91cdf6b8491513ba$var$version = "3.5.0";
// src/Version.ts
var $91cdf6b8491513ba$export$682c179f50ab847d = $91cdf6b8491513ba$var$version;
// src/IndexedDbDPoPStore.ts
var $91cdf6b8491513ba$export$400f3eb0d146981b = class {
    constructor(){
        this._dbName = "oidc";
        this._storeName = "dpop";
    }
    async set(key, value) {
        const store = await this.createStore(this._dbName, this._storeName);
        await store("readwrite", (str)=>{
            str.put(value, key);
            return this.promisifyRequest(str.transaction);
        });
    }
    async get(key) {
        const store = await this.createStore(this._dbName, this._storeName);
        return await store("readonly", (str)=>{
            return this.promisifyRequest(str.get(key));
        });
    }
    async remove(key) {
        const item = await this.get(key);
        const store = await this.createStore(this._dbName, this._storeName);
        await store("readwrite", (str)=>{
            return this.promisifyRequest(str.delete(key));
        });
        return item;
    }
    async getAllKeys() {
        const store = await this.createStore(this._dbName, this._storeName);
        return await store("readonly", (str)=>{
            return this.promisifyRequest(str.getAllKeys());
        });
    }
    promisifyRequest(request) {
        return new Promise((resolve, reject)=>{
            request.oncomplete = request.onsuccess = ()=>resolve(request.result);
            request.onabort = request.onerror = ()=>reject(request.error);
        });
    }
    async createStore(dbName, storeName) {
        const request = indexedDB.open(dbName);
        request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
        const db = await this.promisifyRequest(request);
        return async (txMode, callback)=>{
            const tx = db.transaction(storeName, txMode);
            const store = tx.objectStore(storeName);
            return await callback(store);
        };
    }
};


var $0d5ae4184fc53fd0$export$a0fd8390cfe8ae69 = (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).createContext(void 0);
$0d5ae4184fc53fd0$export$a0fd8390cfe8ae69.displayName = "AuthContext";
// src/AuthState.ts
var $0d5ae4184fc53fd0$var$initialAuthState = {
    isLoading: true,
    isAuthenticated: false
};
// src/reducer.ts
var $0d5ae4184fc53fd0$var$reducer = (state, action)=>{
    switch(action.type){
        case "INITIALISED":
        case "USER_LOADED":
            return {
                ...state,
                user: action.user,
                isLoading: false,
                isAuthenticated: action.user ? !action.user.expired : false,
                error: void 0
            };
        case "USER_SIGNED_OUT":
        case "USER_UNLOADED":
            return {
                ...state,
                user: void 0,
                isAuthenticated: false
            };
        case "NAVIGATOR_INIT":
            return {
                ...state,
                isLoading: true,
                activeNavigator: action.method
            };
        case "NAVIGATOR_CLOSE":
            return {
                ...state,
                isLoading: false,
                activeNavigator: void 0
            };
        case "ERROR":
            {
                const error = action.error;
                error["toString"] = ()=>`${error.name}: ${error.message}`;
                return {
                    ...state,
                    isLoading: false,
                    error: error
                };
            }
        default:
            {
                const innerError = new TypeError(`unknown type ${action["type"]}`);
                const error = {
                    name: innerError.name,
                    message: innerError.message,
                    innerError: innerError,
                    stack: innerError.stack,
                    source: "unknown"
                };
                error["toString"] = ()=>`${error.name}: ${error.message}`;
                return {
                    ...state,
                    isLoading: false,
                    error: error
                };
            }
    }
};
// src/utils.ts
var $0d5ae4184fc53fd0$export$431ecbe9d31d54bd = (location = window.location)=>{
    let searchParams = new URLSearchParams(location.search);
    if ((searchParams.get("code") || searchParams.get("error")) && searchParams.get("state")) return true;
    searchParams = new URLSearchParams(location.hash.replace("#", "?"));
    if ((searchParams.get("code") || searchParams.get("error")) && searchParams.get("state")) return true;
    return false;
};
var $0d5ae4184fc53fd0$var$signinError = $0d5ae4184fc53fd0$var$normalizeErrorFn("signinCallback", "Sign-in failed");
var $0d5ae4184fc53fd0$var$signoutError = $0d5ae4184fc53fd0$var$normalizeErrorFn("signoutCallback", "Sign-out failed");
var $0d5ae4184fc53fd0$var$renewSilentError = $0d5ae4184fc53fd0$var$normalizeErrorFn("renewSilent", "Renew silent failed");
function $0d5ae4184fc53fd0$var$normalizeError(error, fallbackMessage) {
    return {
        name: $0d5ae4184fc53fd0$var$stringFieldOf(error, "name", ()=>"Error"),
        message: $0d5ae4184fc53fd0$var$stringFieldOf(error, "message", ()=>fallbackMessage),
        stack: $0d5ae4184fc53fd0$var$stringFieldOf(error, "stack", ()=>new Error().stack),
        innerError: error
    };
}
function $0d5ae4184fc53fd0$var$normalizeErrorFn(source, fallbackMessage) {
    return (error)=>{
        return {
            ...$0d5ae4184fc53fd0$var$normalizeError(error, fallbackMessage),
            source: source
        };
    };
}
function $0d5ae4184fc53fd0$var$stringFieldOf(element, fieldName, or) {
    if (element && typeof element === "object") {
        const value = element[fieldName];
        if (typeof value === "string") return value;
    }
    return or();
}
// src/AuthProvider.tsx
var $0d5ae4184fc53fd0$var$userManagerContextKeys = [
    "clearStaleState",
    "querySessionStatus",
    "revokeTokens",
    "startSilentRenew",
    "stopSilentRenew"
];
var $0d5ae4184fc53fd0$var$navigatorKeys = [
    "signinPopup",
    "signinSilent",
    "signinRedirect",
    "signinResourceOwnerCredentials",
    "signoutPopup",
    "signoutRedirect",
    "signoutSilent"
];
var $0d5ae4184fc53fd0$var$unsupportedEnvironment = (fnName)=>()=>{
        throw new Error(`UserManager#${fnName} was called from an unsupported context. If this is a server-rendered page, defer this call with useEffect() or pass a custom UserManager implementation.`);
    };
var $0d5ae4184fc53fd0$var$UserManagerImpl = typeof window === "undefined" ? null : (0, $91cdf6b8491513ba$export$4c4d82ee86d9366d);
var $0d5ae4184fc53fd0$export$87091915187a1a85 = (props)=>{
    const { children: children, onSigninCallback: onSigninCallback, skipSigninCallback: skipSigninCallback, matchSignoutCallback: matchSignoutCallback, onSignoutCallback: onSignoutCallback, onRemoveUser: onRemoveUser, userManager: userManagerProp = null, ...userManagerSettings } = props;
    const [userManager] = (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).useState(()=>{
        return userManagerProp != null ? userManagerProp : $0d5ae4184fc53fd0$var$UserManagerImpl ? new $0d5ae4184fc53fd0$var$UserManagerImpl(userManagerSettings) : {
            settings: userManagerSettings
        };
    });
    const [state, dispatch] = (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).useReducer($0d5ae4184fc53fd0$var$reducer, $0d5ae4184fc53fd0$var$initialAuthState);
    const userManagerContext = (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).useMemo(()=>Object.assign({
            settings: userManager.settings,
            events: userManager.events
        }, Object.fromEntries($0d5ae4184fc53fd0$var$userManagerContextKeys.map((key)=>{
            var _a, _b;
            return [
                key,
                (_b = (_a = userManager[key]) == null ? void 0 : _a.bind(userManager)) != null ? _b : $0d5ae4184fc53fd0$var$unsupportedEnvironment(key)
            ];
        })), Object.fromEntries($0d5ae4184fc53fd0$var$navigatorKeys.map((key)=>[
                key,
                userManager[key] ? async (args)=>{
                    dispatch({
                        type: "NAVIGATOR_INIT",
                        method: key
                    });
                    try {
                        return await userManager[key](args);
                    } catch (error) {
                        dispatch({
                            type: "ERROR",
                            error: {
                                ...$0d5ae4184fc53fd0$var$normalizeError(error, `Unknown error while executing ${key}(...).`),
                                source: key,
                                args: args
                            }
                        });
                        return null;
                    } finally{
                        dispatch({
                            type: "NAVIGATOR_CLOSE"
                        });
                    }
                } : $0d5ae4184fc53fd0$var$unsupportedEnvironment(key)
            ]))), [
        userManager
    ]);
    const didInitialize = (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).useRef(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).useEffect(()=>{
        if (!userManager || didInitialize.current) return;
        didInitialize.current = true;
        (async ()=>{
            try {
                let user = null;
                if ($0d5ae4184fc53fd0$export$431ecbe9d31d54bd() && !skipSigninCallback) {
                    user = await userManager.signinCallback();
                    if (onSigninCallback) await onSigninCallback(user);
                }
                user = !user ? await userManager.getUser() : user;
                dispatch({
                    type: "INITIALISED",
                    user: user
                });
            } catch (error) {
                dispatch({
                    type: "ERROR",
                    error: $0d5ae4184fc53fd0$var$signinError(error)
                });
            }
            try {
                if (matchSignoutCallback && matchSignoutCallback(userManager.settings)) {
                    const resp = await userManager.signoutCallback();
                    if (onSignoutCallback) await onSignoutCallback(resp);
                }
            } catch (error) {
                dispatch({
                    type: "ERROR",
                    error: $0d5ae4184fc53fd0$var$signoutError(error)
                });
            }
        })();
    }, [
        userManager,
        skipSigninCallback,
        onSigninCallback,
        onSignoutCallback,
        matchSignoutCallback
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).useEffect(()=>{
        if (!userManager) return void 0;
        const handleUserLoaded = (user)=>{
            dispatch({
                type: "USER_LOADED",
                user: user
            });
        };
        userManager.events.addUserLoaded(handleUserLoaded);
        const handleUserUnloaded = ()=>{
            dispatch({
                type: "USER_UNLOADED"
            });
        };
        userManager.events.addUserUnloaded(handleUserUnloaded);
        const handleUserSignedOut = ()=>{
            dispatch({
                type: "USER_SIGNED_OUT"
            });
        };
        userManager.events.addUserSignedOut(handleUserSignedOut);
        const handleSilentRenewError = (error)=>{
            dispatch({
                type: "ERROR",
                error: $0d5ae4184fc53fd0$var$renewSilentError(error)
            });
        };
        userManager.events.addSilentRenewError(handleSilentRenewError);
        return ()=>{
            userManager.events.removeUserLoaded(handleUserLoaded);
            userManager.events.removeUserUnloaded(handleUserUnloaded);
            userManager.events.removeUserSignedOut(handleUserSignedOut);
            userManager.events.removeSilentRenewError(handleSilentRenewError);
        };
    }, [
        userManager
    ]);
    const removeUser = (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).useCallback(async ()=>{
        if (!userManager) $0d5ae4184fc53fd0$var$unsupportedEnvironment("removeUser");
        await userManager.removeUser();
        if (onRemoveUser) await onRemoveUser();
    }, [
        userManager,
        onRemoveUser
    ]);
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).useMemo(()=>{
        return {
            ...state,
            ...userManagerContext,
            removeUser: removeUser
        };
    }, [
        state,
        userManagerContext,
        removeUser
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).createElement($0d5ae4184fc53fd0$export$a0fd8390cfe8ae69.Provider, {
        value: contextValue
    }, children);
};
var $0d5ae4184fc53fd0$export$1d39dc5b47e56ff0 = ()=>{
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).useContext($0d5ae4184fc53fd0$export$a0fd8390cfe8ae69);
    if (!context) console.warn("AuthProvider context is undefined, please verify you are calling useAuth() as child of a <AuthProvider> component.");
    return context;
};
function $0d5ae4184fc53fd0$export$427f722d7a79eb97({ signinMethod: signinMethod = "signinRedirect", signinArgs: signinArgs } = {}) {
    const auth = $0d5ae4184fc53fd0$export$1d39dc5b47e56ff0();
    const [hasTriedSignin, setHasTriedSignin] = (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).useState(false);
    const shouldAttemptSignin = (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).useMemo(()=>!$0d5ae4184fc53fd0$export$431ecbe9d31d54bd() && !auth.isAuthenticated && !auth.activeNavigator && !auth.isLoading && !hasTriedSignin, [
        auth.activeNavigator,
        auth.isAuthenticated,
        auth.isLoading,
        hasTriedSignin
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).useEffect(()=>{
        if (shouldAttemptSignin) {
            switch(signinMethod){
                case "signinPopup":
                    auth.signinPopup(signinArgs);
                    break;
                case "signinRedirect":
                default:
                    auth.signinRedirect(signinArgs);
                    break;
            }
            setHasTriedSignin(true);
        }
    }, [
        auth,
        hasTriedSignin,
        shouldAttemptSignin,
        signinMethod,
        signinArgs
    ]);
    return {
        isLoading: auth.isLoading,
        isAuthenticated: auth.isAuthenticated,
        error: auth.error
    };
}
function $0d5ae4184fc53fd0$export$edfabac72365802(Component) {
    const displayName = `withAuth(${Component.displayName || Component.name})`;
    const C = (props)=>{
        const auth = $0d5ae4184fc53fd0$export$1d39dc5b47e56ff0();
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).createElement(Component, {
            ...props,
            auth: auth
        });
    };
    C.displayName = displayName;
    return C;
}
var $0d5ae4184fc53fd0$export$2cfd0b285ff12c70 = (Component, options = {})=>{
    const { OnRedirecting: OnRedirecting = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).Fragment, null), onBeforeSignin: onBeforeSignin, signinRedirectArgs: signinRedirectArgs } = options;
    const displayName = `withAuthenticationRequired(${Component.displayName || Component.name})`;
    const C = (props)=>{
        const auth = $0d5ae4184fc53fd0$export$1d39dc5b47e56ff0();
        (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).useEffect(()=>{
            if ($0d5ae4184fc53fd0$export$431ecbe9d31d54bd() || auth.isLoading || auth.activeNavigator || auth.isAuthenticated) return;
            (async ()=>{
                if (onBeforeSignin) await onBeforeSignin();
                await auth.signinRedirect(signinRedirectArgs);
            })();
        }, [
            auth.isLoading,
            auth.isAuthenticated,
            auth
        ]);
        return auth.isAuthenticated ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).createElement(Component, {
            ...props
        }) : OnRedirecting();
    };
    C.displayName = displayName;
    return C;
};



const $c837ac9c698038bc$var$DisabledContext = {
    isEnabled: false,
    isLoading: false,
    isAuthenticated: false,
    login: ()=>Promise.resolve(),
    logout: ()=>Promise.resolve()
};
const $c837ac9c698038bc$var$AuthContext = /*#__PURE__*/ (0, $8v0nu.createContext)($c837ac9c698038bc$var$DisabledContext);
const $c837ac9c698038bc$var$config = undefined;
function $c837ac9c698038bc$var$EnabledAuthBridge(props) {
    const oidc = (0, $0d5ae4184fc53fd0$export$1d39dc5b47e56ff0)();
    const value = (0, $8v0nu.useMemo)(()=>{
        const p = oidc.user?.profile;
        const profile = p ? {
            username: p.preferred_username,
            email: p.email,
            firstName: p.given_name,
            lastName: p.family_name,
            emailVerified: p.email_verified
        } : undefined;
        return {
            isEnabled: true,
            isLoading: oidc.isLoading,
            isAuthenticated: !!oidc.isAuthenticated,
            profile: profile,
            token: oidc.user?.access_token,
            login: (opts)=>oidc.signinRedirect({
                    redirect_uri: opts?.redirectUri ?? window.location.href
                }),
            logout: (opts)=>oidc.signoutRedirect({
                    post_logout_redirect_uri: opts?.redirectUri ?? window.location.href
                })
        };
    }, [
        oidc
    ]);
    return /*#__PURE__*/ (0, $kxTYF.jsx)($c837ac9c698038bc$var$AuthContext.Provider, {
        value: value,
        children: props.children
    });
}
function $c837ac9c698038bc$export$87091915187a1a85(props) {
    if (!$c837ac9c698038bc$var$config) {
        // eslint-disable-next-line no-console
        console.debug("OIDC config not found, authentication disabled. To enable, set REACT_APP_OIDC_AUTHORITY and REACT_APP_OIDC_CLIENT_ID environment variables.");
        return /*#__PURE__*/ (0, $kxTYF.jsx)($c837ac9c698038bc$var$AuthContext.Provider, {
            value: $c837ac9c698038bc$var$DisabledContext,
            children: props.children
        });
    }
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $0d5ae4184fc53fd0$export$87091915187a1a85), {
        authority: $c837ac9c698038bc$var$config.authority,
        client_id: $c837ac9c698038bc$var$config.clientId,
        redirect_uri: window.location.origin + window.location.pathname,
        post_logout_redirect_uri: window.location.origin + window.location.pathname,
        userStore: new (0, $91cdf6b8491513ba$export$6a5d9eefd8f07eee)({
            store: window.localStorage
        }),
        onSigninCallback: ()=>{
            // Remove code/state params from URL after successful login
            window.history.replaceState({}, document.title, window.location.pathname);
        },
        children: /*#__PURE__*/ (0, $kxTYF.jsx)($c837ac9c698038bc$var$EnabledAuthBridge, {
            children: props.children
        })
    });
}
function $c837ac9c698038bc$export$1d39dc5b47e56ff0() {
    return (0, $8v0nu.useContext)($c837ac9c698038bc$var$AuthContext);
}


function $ab8658d5c674cf12$export$8ef2ed426dede42d(props) {
    const { Component: Component, ...rest } = props;
    (0, $aec39e40387762bd$export$2e2bcd8739ae039)("Authentication Required");
    const auth = (0, $c837ac9c698038bc$export$1d39dc5b47e56ff0)();
    if (!auth.isEnabled) return /*#__PURE__*/ (0, $kxTYF.jsx)(Component, {
        ...rest
    });
    if (auth.isAuthenticated) return /*#__PURE__*/ (0, $kxTYF.jsx)(Component, {
        ...rest
    });
    return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
        direction: "column",
        gap: 4,
        children: [
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $dfd76aae8c4830bc$export$644c29b44a905178), {
                title: "Authentication Required",
                overline: "Oops"
            }),
            /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                direction: "column",
                gap: 2,
                p: 4,
                children: [
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3963bf82c5559c75$export$5f1af8db9871e1d6), {
                        children: "You need to login to access this content."
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $b8b7f6458056e8af$export$353f5b6fc5456de1), {
                        alignSelf: "flex-start",
                        variant: "solid",
                        colorScheme: "primary",
                        onClick: ()=>auth.login({
                                redirectUri: window.location.href
                            }),
                        children: "Login"
                    })
                ]
            })
        ]
    });
}



var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");

var $kxTYF = parcelRequire("kxTYF");


var $8v0nu = parcelRequire("8v0nu");
function $da8753851e8cc1f3$export$b2c43d7d050b2e63(children) {
    return (0, $8v0nu.Children).toArray(children).filter((child)=>(0, $8v0nu.isValidElement)(child));
}






var $3lBLT = parcelRequire("3lBLT");
"use client";
const [$95452836d4e53d4d$var$ListStylesProvider, $95452836d4e53d4d$export$cc8f1462c0be9565] = (0, $3473b2b1e3b906ba$export$fd42f52fd3ae1109)({
    name: `ListStylesContext`,
    errorMessage: `useListStyles returned is 'undefined'. Seems you forgot to wrap the components in "<List />" `
});
const $95452836d4e53d4d$export$54c2e3dc7acea9f5 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function List2(props, ref) {
    const styles = (0, $c7d173d35275482d$export$31cdfe60c085d76f)("List", props);
    const { children: children, styleType: styleType = "none", stylePosition: stylePosition, spacing: spacing, ...rest } = (0, $58ff34c9d17adf03$export$adfcf5a5e4d17785)(props);
    const validChildren = (0, $da8753851e8cc1f3$export$b2c43d7d050b2e63)(children);
    const selector = "& > *:not(style) ~ *:not(style)";
    const spacingStyle = spacing ? {
        [selector]: {
            mt: spacing
        }
    } : {};
    return /* @__PURE__ */ (0, $kxTYF.jsx)($95452836d4e53d4d$var$ListStylesProvider, {
        value: styles,
        children: /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).ul, {
            ref: ref,
            listStyleType: styleType,
            listStylePosition: stylePosition,
            role: "list",
            __css: {
                ...styles.container,
                ...spacingStyle
            },
            ...rest,
            children: validChildren
        })
    });
});
$95452836d4e53d4d$export$54c2e3dc7acea9f5.displayName = "List";
const $95452836d4e53d4d$export$547f885a1fca4e31 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    const { as: as, ...rest } = props;
    return /* @__PURE__ */ (0, $kxTYF.jsx)($95452836d4e53d4d$export$54c2e3dc7acea9f5, {
        ref: ref,
        as: "ol",
        styleType: "decimal",
        marginStart: "1em",
        ...rest
    });
});
$95452836d4e53d4d$export$547f885a1fca4e31.displayName = "OrderedList";
const $95452836d4e53d4d$export$30b2abb1ad323770 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function UnorderedList2(props, ref) {
    const { as: as, ...rest } = props;
    return /* @__PURE__ */ (0, $kxTYF.jsx)($95452836d4e53d4d$export$54c2e3dc7acea9f5, {
        ref: ref,
        as: "ul",
        styleType: "initial",
        marginStart: "1em",
        ...rest
    });
});
$95452836d4e53d4d$export$30b2abb1ad323770.displayName = "UnorderedList";
const $95452836d4e53d4d$export$a7b06bfba60a8a78 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function ListItem2(props, ref) {
    const styles = $95452836d4e53d4d$export$cc8f1462c0be9565();
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).li, {
        ref: ref,
        ...props,
        __css: styles.item
    });
});
$95452836d4e53d4d$export$a7b06bfba60a8a78.displayName = "ListItem";
const $95452836d4e53d4d$export$230671d7ba50d3c8 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function ListIcon2(props, ref) {
    const styles = $95452836d4e53d4d$export$cc8f1462c0be9565();
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $09b0bffb6a1e43af$export$f04a61298a47a40f), {
        ref: ref,
        role: "presentation",
        ...props,
        __css: styles.icon
    });
});
$95452836d4e53d4d$export$230671d7ba50d3c8.displayName = "ListIcon";




var $kxTYF = parcelRequire("kxTYF");

var $8v0nu = parcelRequire("8v0nu");

var $kxTYF = parcelRequire("kxTYF");





var $3lBLT = parcelRequire("3lBLT");
"use client";
const $8ed68ad193328d44$export$a6c7ac8248d6e38a = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function Link2(props, ref) {
    const styles = (0, $c7d173d35275482d$export$b863f77547fbcb03)("Link", props);
    const { className: className, isExternal: isExternal, ...rest } = (0, $58ff34c9d17adf03$export$adfcf5a5e4d17785)(props);
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).a, {
        target: isExternal ? "_blank" : void 0,
        rel: isExternal ? "noopener" : void 0,
        ref: ref,
        className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-link", className),
        ...rest,
        __css: styles
    });
});
$8ed68ad193328d44$export$a6c7ac8248d6e38a.displayName = "Link";



var $78d29a24c660df8a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).forwardRef(function SmartLink(props, ref) {
    const { to: to, ...rest } = props;
    const isExternal = to.match(/^(https?:)?\/\//) || to.match(/^(mailto|tel):/);
    return isExternal ? /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8ed68ad193328d44$export$a6c7ac8248d6e38a), {
        ref: ref,
        href: to,
        ...rest
    }) : /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8ed68ad193328d44$export$a6c7ac8248d6e38a), {
        ref: ref,
        as: (0, $d9197f3f1e79e9d9$export$a6c7ac8248d6e38a),
        to: to,
        ...rest
    });
});



var $kxTYF = parcelRequire("kxTYF");

var $8v0nu = parcelRequire("8v0nu");

var $kxTYF = parcelRequire("kxTYF");

function $5bb288c143ca173e$export$9dd9a52f2dd5b9ce(...fns) {
    return function mergedFn(...args) {
        fns.forEach((fn)=>fn?.(...args));
    };
}
function $5bb288c143ca173e$export$5bdd3f730ec2c47e(...fns) {
    return function func(event) {
        fns.some((fn)=>{
            fn?.(event);
            return event?.defaultPrevented;
        });
    };
}



var $8v0nu = parcelRequire("8v0nu");

"use client";
const [$897cbdb7a63a983c$export$ba63ffea77f18f6b, $897cbdb7a63a983c$export$766de4db34c66f23] = (0, $3473b2b1e3b906ba$export$fd42f52fd3ae1109)({
    name: `AvatarStylesContext`,
    hookName: `useAvatarStyles`,
    providerName: "<Avatar/>"
});



var $kxTYF = parcelRequire("kxTYF");

var $8v0nu = parcelRequire("8v0nu");

var $kxTYF = parcelRequire("kxTYF");


var $3lBLT = parcelRequire("3lBLT");
"use client";
function $481ae9d6eade2bb8$export$82a129a7016c8ea8(name) {
    const names = name.trim().split(" ");
    const firstName = names[0] ?? "";
    const lastName = names.length > 1 ? names[names.length - 1] : "";
    return firstName && lastName ? `${firstName.charAt(0)}${lastName.charAt(0)}` : firstName.charAt(0);
}
function $481ae9d6eade2bb8$export$1851e4eca212b22f(props) {
    const { name: name, getInitials: getInitials, ...rest } = props;
    const styles = (0, $897cbdb7a63a983c$export$766de4db34c66f23)();
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
        role: "img",
        "aria-label": name,
        ...rest,
        __css: styles.label,
        children: name ? getInitials?.(name) : null
    });
}
$481ae9d6eade2bb8$export$1851e4eca212b22f.displayName = "AvatarName";



var $kxTYF = parcelRequire("kxTYF");

var $3lBLT = parcelRequire("3lBLT");
"use client";
const $d4e8aa6837949d77$export$7f80e61621b7c427 = (props)=>/* @__PURE__ */ (0, $kxTYF.jsxs)((0, $3lBLT.chakra).svg, {
        viewBox: "0 0 128 128",
        color: "#fff",
        width: "100%",
        height: "100%",
        className: "chakra-avatar__svg",
        ...props,
        children: [
            /* @__PURE__ */ (0, $kxTYF.jsx)("path", {
                fill: "currentColor",
                d: "M103,102.1388 C93.094,111.92 79.3504,118 64.1638,118 C48.8056,118 34.9294,111.768 25,101.7892 L25,95.2 C25,86.8096 31.981,80 40.6,80 L87.4,80 C96.019,80 103,86.8096 103,95.2 L103,102.1388 Z"
            }),
            /* @__PURE__ */ (0, $kxTYF.jsx)("path", {
                fill: "currentColor",
                d: "M63.9961647,24 C51.2938136,24 41,34.2938136 41,46.9961647 C41,59.7061864 51.2938136,70 63.9961647,70 C76.6985159,70 87,59.7061864 87,46.9961647 C87,34.2938136 76.6985159,24 63.9961647,24"
            })
        ]
    });




var $3lBLT = parcelRequire("3lBLT");
"use client";
function $5dc68f21c4284165$export$2cd8ae1985206fe8(props) {
    const { src: src, srcSet: srcSet, onError: onError, onLoad: onLoad, getInitials: getInitials, name: name, borderRadius: borderRadius, loading: loading, iconLabel: iconLabel, icon: icon = /* @__PURE__ */ (0, $kxTYF.jsx)((0, $d4e8aa6837949d77$export$7f80e61621b7c427), {}), ignoreFallback: ignoreFallback, referrerPolicy: referrerPolicy, crossOrigin: crossOrigin } = props;
    const status = (0, $65811e07b2b1042b$export$e4da99f09da8b739)({
        src: src,
        onError: onError,
        crossOrigin: crossOrigin,
        ignoreFallback: ignoreFallback
    });
    const hasLoaded = status === "loaded";
    const showFallback = !src || !hasLoaded;
    if (showFallback) return name ? /* @__PURE__ */ (0, $kxTYF.jsx)((0, $481ae9d6eade2bb8$export$1851e4eca212b22f), {
        className: "chakra-avatar__initials",
        getInitials: getInitials,
        name: name
    }) : (0, $8v0nu.cloneElement)(icon, {
        role: "img",
        "aria-label": iconLabel
    });
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).img, {
        src: src,
        srcSet: srcSet,
        alt: name ?? iconLabel,
        onLoad: onLoad,
        referrerPolicy: referrerPolicy,
        crossOrigin: crossOrigin ?? void 0,
        className: "chakra-avatar__img",
        loading: loading,
        __css: {
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: borderRadius
        }
    });
}
$5dc68f21c4284165$export$2cd8ae1985206fe8.displayName = "AvatarImage";







var $3lBLT = parcelRequire("3lBLT");
"use client";
const $7f8a0294d9e5c90c$export$360b744af11007ac = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    textTransform: "uppercase",
    fontWeight: "medium",
    position: "relative",
    flexShrink: 0
});
const $7f8a0294d9e5c90c$export$e2255cf6045e8d47 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $c7d173d35275482d$export$31cdfe60c085d76f)("Avatar", props);
    const [isLoaded, setIsLoaded] = (0, $8v0nu.useState)(false);
    const { src: src, srcSet: srcSet, name: name, showBorder: showBorder, borderRadius: borderRadius = "full", onError: onError, onLoad: onLoadProp, getInitials: getInitials = (0, $481ae9d6eade2bb8$export$82a129a7016c8ea8), icon: icon = /* @__PURE__ */ (0, $kxTYF.jsx)((0, $d4e8aa6837949d77$export$7f80e61621b7c427), {}), iconLabel: iconLabel = " avatar", loading: loading, children: children, borderColor: borderColor, ignoreFallback: ignoreFallback, crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, ...rest } = (0, $58ff34c9d17adf03$export$adfcf5a5e4d17785)(props);
    const avatarStyles = {
        borderRadius: borderRadius,
        borderWidth: showBorder ? "2px" : void 0,
        ...$7f8a0294d9e5c90c$export$360b744af11007ac,
        ...styles.container
    };
    if (borderColor) avatarStyles.borderColor = borderColor;
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).span, {
        ref: ref,
        ...rest,
        className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-avatar", props.className),
        "data-loaded": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isLoaded),
        __css: avatarStyles,
        children: /* @__PURE__ */ (0, $kxTYF.jsxs)((0, $897cbdb7a63a983c$export$ba63ffea77f18f6b), {
            value: styles,
            children: [
                /* @__PURE__ */ (0, $kxTYF.jsx)((0, $5dc68f21c4284165$export$2cd8ae1985206fe8), {
                    src: src,
                    srcSet: srcSet,
                    loading: loading,
                    onLoad: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(onLoadProp, ()=>{
                        setIsLoaded(true);
                    }),
                    onError: onError,
                    getInitials: getInitials,
                    name: name,
                    borderRadius: borderRadius,
                    icon: icon,
                    iconLabel: iconLabel,
                    ignoreFallback: ignoreFallback,
                    crossOrigin: crossOrigin,
                    referrerPolicy: referrerPolicy
                }),
                children
            ]
        })
    });
});
$7f8a0294d9e5c90c$export$e2255cf6045e8d47.displayName = "Avatar";




async function $0a265d2a46e29432$var$hash(string) {
    const utf8 = new TextEncoder().encode(string);
    const hashBuffer = await crypto.subtle.digest("SHA-256", utf8);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map((bytes)=>bytes.toString(16).padStart(2, "0")).join("");
    return hashHex;
}
function $0a265d2a46e29432$export$c6ede3bfc40c5e4b() {
    const { profile: profile, isLoading: isLoading, isEnabled: isEnabled, isAuthenticated: isAuthenticated, login: login, logout: logout } = (0, $c837ac9c698038bc$export$1d39dc5b47e56ff0)();
    const [userEmailHash, setUserEmailHash] = (0, $8v0nu.useState)("");
    (0, $8v0nu.useEffect)(()=>{
        if (profile?.email) $0a265d2a46e29432$var$hash(profile.email).then(setUserEmailHash);
    }, [
        profile?.email
    ]);
    if (!isEnabled) return null;
    if (!isAuthenticated || !profile || isLoading) return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $b8b7f6458056e8af$export$353f5b6fc5456de1), {
        variant: "outline",
        rightIcon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$1692611780ac32d), {}),
        onClick: ()=>{
            if (!isLoading) login({
                redirectUri: window.location.href
            });
        },
        children: "Login"
    });
    const username = `${profile.firstName} ${profile.lastName}`.trim() || profile.username;
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $b8b7f6458056e8af$export$353f5b6fc5456de1), {
        variant: "outline",
        rightIcon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$2d4c748bd12d78e0), {}),
        leftIcon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $7f8a0294d9e5c90c$export$e2255cf6045e8d47), {
            size: "sm",
            name: username,
            bg: "secondary.500",
            color: "white",
            borderRadius: "4px",
            src: `https://www.gravatar.com/avatar/${userEmailHash}?d=404`
        }),
        pl: "2px",
        onClick: ()=>{
            if (!isLoading) logout({
                redirectUri: window.location.href
            });
        },
        children: "Logout"
    });
}



function $e206030315a52ed9$var$NavItem(props) {
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $95452836d4e53d4d$export$a7b06bfba60a8a78), {
        children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $b8b7f6458056e8af$export$353f5b6fc5456de1), {
            as: (0, $78d29a24c660df8a$export$2e2bcd8739ae039),
            variant: "ghost",
            sx: {
                "&:hover": {
                    textDecoration: "none"
                }
            },
            ...props
        })
    });
}
function $e206030315a52ed9$var$MainNavigation() {
    const { isEnabled: isEnabled, isAuthenticated: isAuthenticated } = (0, $c837ac9c698038bc$export$1d39dc5b47e56ff0)();
    return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
        as: "nav",
        "aria-label": "Main",
        gap: 4,
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $95452836d4e53d4d$export$54c2e3dc7acea9f5), {
                display: "flex",
                gap: 2,
                children: [
                    /*#__PURE__*/ (0, $kxTYF.jsx)($e206030315a52ed9$var$NavItem, {
                        to: "/collections/",
                        rightIcon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$22e733acfe1431e6), {}),
                        children: "Browse"
                    }),
                    isAuthenticated && /*#__PURE__*/ (0, $kxTYF.jsx)($e206030315a52ed9$var$NavItem, {
                        to: "/collections/new",
                        rightIcon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$3a9f56a1d1f9a714), {}),
                        children: "Create"
                    })
                ]
            }),
            isEnabled && /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $kxTYF.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $a3bfda7295e9946f$export$2e0a83ec2e27ecbb), {
                        orientation: "vertical",
                        borderLeftWidth: "2px",
                        borderColor: "base.200",
                        h: "1rem"
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $0a265d2a46e29432$export$c6ede3bfc40c5e4b), {})
                ]
            })
        ]
    });
}
var $e206030315a52ed9$export$2e2bcd8739ae039 = $e206030315a52ed9$var$MainNavigation;



var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");



var $8v0nu = parcelRequire("8v0nu");
function $87103801ad4a1bee$var$usePrevious(value) {
    const [current, setCurrent] = (0, $8v0nu.useState)(value);
    const [previous, setPrevious] = (0, $8v0nu.useState)(value);
    if (value !== current) {
        setPrevious(current);
        setCurrent(value);
    }
    return previous;
}
var $87103801ad4a1bee$export$2e2bcd8739ae039 = $87103801ad4a1bee$var$usePrevious;




function $d26150280087d264$var$Home() {
    (0, $aec39e40387762bd$export$2e2bcd8739ae039)("STAC Manager Demo");
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $aa6b6e9e15323f83$export$444b3ab0cb9aec40), {
        to: "/collections",
        replace: true
    });
}
var $d26150280087d264$export$2e2bcd8739ae039 = $d26150280087d264$var$Home;



var $kxTYF = parcelRequire("kxTYF");

var $8v0nu = parcelRequire("8v0nu");

var $9HGsN = parcelRequire("9HGsN");
var $kxTYF = parcelRequire("kxTYF");

var $8v0nu = parcelRequire("8v0nu");


"use client";
const $5f067ccb39c91cbc$export$c25acd513dcc8062 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    const { icon: icon, children: children, isRound: isRound, "aria-label": ariaLabel, ...rest } = props;
    const element = icon || children;
    const _children = (0, $8v0nu.isValidElement)(element) ? (0, $8v0nu.cloneElement)(element, {
        "aria-hidden": true,
        focusable: false
    }) : null;
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $b8b7f6458056e8af$export$353f5b6fc5456de1), {
        px: "0",
        py: "0",
        borderRadius: isRound ? "full" : void 0,
        ref: ref,
        "aria-label": ariaLabel,
        ...rest,
        children: _children
    });
});
$5f067ccb39c91cbc$export$c25acd513dcc8062.displayName = "IconButton";


var $kxTYF = parcelRequire("kxTYF");




var $kxTYF = parcelRequire("kxTYF");




var $8v0nu = parcelRequire("8v0nu");



var $3lBLT = parcelRequire("3lBLT");
"use client";
const [$02b238a4ba05f901$var$FormControlStylesProvider, $02b238a4ba05f901$export$2824197c2cd75b1e] = (0, $3473b2b1e3b906ba$export$fd42f52fd3ae1109)({
    name: `FormControlStylesContext`,
    errorMessage: `useFormControlStyles returned is 'undefined'. Seems you forgot to wrap the components in "<FormControl />" `
});
const [$02b238a4ba05f901$var$FormControlProvider, $02b238a4ba05f901$export$97a2352498389516] = (0, $3473b2b1e3b906ba$export$fd42f52fd3ae1109)({
    strict: false,
    name: "FormControlContext"
});
function $02b238a4ba05f901$var$useFormControlProvider(props) {
    const { id: idProp, isRequired: isRequired, isInvalid: isInvalid, isDisabled: isDisabled, isReadOnly: isReadOnly, ...htmlProps } = props;
    const uuid = (0, $8v0nu.useId)();
    const id = idProp || `field-${uuid}`;
    const labelId = `${id}-label`;
    const feedbackId = `${id}-feedback`;
    const helpTextId = `${id}-helptext`;
    const [hasFeedbackText, setHasFeedbackText] = (0, $8v0nu.useState)(false);
    const [hasHelpText, setHasHelpText] = (0, $8v0nu.useState)(false);
    const [isFocused, setFocus] = (0, $8v0nu.useState)(false);
    const getHelpTextProps = (0, $8v0nu.useCallback)((props2 = {}, forwardedRef = null)=>({
            id: helpTextId,
            ...props2,
            /**
       * Notify the field context when the help text is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */ ref: (0, $95f7db4ddbf3eda0$export$c9058316764c140e)(forwardedRef, (node)=>{
                if (!node) return;
                setHasHelpText(true);
            })
        }), [
        helpTextId
    ]);
    const getLabelProps = (0, $8v0nu.useCallback)((props2 = {}, forwardedRef = null)=>({
            ...props2,
            ref: forwardedRef,
            "data-focus": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isFocused),
            "data-disabled": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isDisabled),
            "data-invalid": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isInvalid),
            "data-readonly": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isReadOnly),
            id: props2.id !== void 0 ? props2.id : labelId,
            htmlFor: props2.htmlFor !== void 0 ? props2.htmlFor : id
        }), [
        id,
        isDisabled,
        isFocused,
        isInvalid,
        isReadOnly,
        labelId
    ]);
    const getErrorMessageProps = (0, $8v0nu.useCallback)((props2 = {}, forwardedRef = null)=>({
            id: feedbackId,
            ...props2,
            /**
       * Notify the field context when the error message is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */ ref: (0, $95f7db4ddbf3eda0$export$c9058316764c140e)(forwardedRef, (node)=>{
                if (!node) return;
                setHasFeedbackText(true);
            }),
            "aria-live": "polite"
        }), [
        feedbackId
    ]);
    const getRootProps = (0, $8v0nu.useCallback)((props2 = {}, forwardedRef = null)=>({
            ...props2,
            ...htmlProps,
            ref: forwardedRef,
            role: "group",
            "data-focus": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isFocused),
            "data-disabled": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isDisabled),
            "data-invalid": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isInvalid),
            "data-readonly": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isReadOnly)
        }), [
        htmlProps,
        isDisabled,
        isFocused,
        isInvalid,
        isReadOnly
    ]);
    const getRequiredIndicatorProps = (0, $8v0nu.useCallback)((props2 = {}, forwardedRef = null)=>({
            ...props2,
            ref: forwardedRef,
            role: "presentation",
            "aria-hidden": true,
            children: props2.children || "*"
        }), []);
    return {
        isRequired: !!isRequired,
        isInvalid: !!isInvalid,
        isReadOnly: !!isReadOnly,
        isDisabled: !!isDisabled,
        isFocused: !!isFocused,
        onFocus: ()=>setFocus(true),
        onBlur: ()=>setFocus(false),
        hasFeedbackText: hasFeedbackText,
        setHasFeedbackText: setHasFeedbackText,
        hasHelpText: hasHelpText,
        setHasHelpText: setHasHelpText,
        id: id,
        labelId: labelId,
        feedbackId: feedbackId,
        helpTextId: helpTextId,
        htmlProps: htmlProps,
        getHelpTextProps: getHelpTextProps,
        getErrorMessageProps: getErrorMessageProps,
        getRootProps: getRootProps,
        getLabelProps: getLabelProps,
        getRequiredIndicatorProps: getRequiredIndicatorProps
    };
}
const $02b238a4ba05f901$export$fe5d99d8691b3f62 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function FormControl2(props, ref) {
    const styles = (0, $c7d173d35275482d$export$31cdfe60c085d76f)("Form", props);
    const ownProps = (0, $58ff34c9d17adf03$export$adfcf5a5e4d17785)(props);
    const { getRootProps: getRootProps, htmlProps: _, ...context } = $02b238a4ba05f901$var$useFormControlProvider(ownProps);
    const className = (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-form-control", props.className);
    return /* @__PURE__ */ (0, $kxTYF.jsx)($02b238a4ba05f901$var$FormControlProvider, {
        value: context,
        children: /* @__PURE__ */ (0, $kxTYF.jsx)($02b238a4ba05f901$var$FormControlStylesProvider, {
            value: styles,
            children: /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
                ...getRootProps({}, ref),
                className: className,
                __css: styles["container"]
            })
        })
    });
});
$02b238a4ba05f901$export$fe5d99d8691b3f62.displayName = "FormControl";
const $02b238a4ba05f901$export$75f9ed82f6172e27 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function FormHelperText2(props, ref) {
    const field = $02b238a4ba05f901$export$97a2352498389516();
    const styles = $02b238a4ba05f901$export$2824197c2cd75b1e();
    const className = (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-form__helper-text", props.className);
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
        ...field?.getHelpTextProps(props, ref),
        __css: styles.helperText,
        className: className
    });
});
$02b238a4ba05f901$export$75f9ed82f6172e27.displayName = "FormHelperText";


"use client";
function $4f32164aecdf11bb$export$62ecd8ad1bbe1a18(props) {
    const { isDisabled: isDisabled, isInvalid: isInvalid, isReadOnly: isReadOnly, isRequired: isRequired, ...rest } = $4f32164aecdf11bb$export$1819803dd567b95f(props);
    return {
        ...rest,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        "aria-invalid": (0, $2892ce0537b3699a$export$91a6105db3d4be7b)(isInvalid),
        "aria-required": (0, $2892ce0537b3699a$export$91a6105db3d4be7b)(isRequired),
        "aria-readonly": (0, $2892ce0537b3699a$export$91a6105db3d4be7b)(isReadOnly)
    };
}
function $4f32164aecdf11bb$export$1819803dd567b95f(props) {
    const field = (0, $02b238a4ba05f901$export$97a2352498389516)();
    const { id: id, disabled: disabled, readOnly: readOnly, required: required, isRequired: isRequired, isInvalid: isInvalid, isReadOnly: isReadOnly, isDisabled: isDisabled, onFocus: onFocus, onBlur: onBlur, ...rest } = props;
    const labelIds = props["aria-describedby"] ? [
        props["aria-describedby"]
    ] : [];
    if (field?.hasFeedbackText && field?.isInvalid) labelIds.push(field.feedbackId);
    if (field?.hasHelpText) labelIds.push(field.helpTextId);
    return {
        ...rest,
        "aria-describedby": labelIds.join(" ") || void 0,
        id: id ?? field?.id,
        isDisabled: disabled ?? isDisabled ?? field?.isDisabled,
        isReadOnly: readOnly ?? isReadOnly ?? field?.isReadOnly,
        isRequired: required ?? isRequired ?? field?.isRequired,
        isInvalid: isInvalid ?? field?.isInvalid,
        onFocus: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(field?.onFocus, onFocus),
        onBlur: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(field?.onBlur, onBlur)
    };
}





var $3lBLT = parcelRequire("3lBLT");
"use client";
const $3d8cf0c200c5d2d0$export$f5b8910cec6cf069 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function Input2(props, ref) {
    const { htmlSize: htmlSize, ...rest } = props;
    const styles = (0, $c7d173d35275482d$export$31cdfe60c085d76f)("Input", rest);
    const ownProps = (0, $58ff34c9d17adf03$export$adfcf5a5e4d17785)(rest);
    const input = (0, $4f32164aecdf11bb$export$62ecd8ad1bbe1a18)(ownProps);
    const _className = (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-input", props.className);
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).input, {
        size: htmlSize,
        ...input,
        __css: styles.field,
        ref: ref,
        className: _className
    });
});
$3d8cf0c200c5d2d0$export$f5b8910cec6cf069.displayName = "Input";
$3d8cf0c200c5d2d0$export$f5b8910cec6cf069.id = "Input";


var $kxTYF = parcelRequire("kxTYF");


var $7hYFp = parcelRequire("7hYFp");

var $8v0nu = parcelRequire("8v0nu");



var $3lBLT = parcelRequire("3lBLT");
"use client";
const [$5678c8a868262504$var$InputGroupStylesProvider, $5678c8a868262504$export$635b0139be441f68] = (0, $3473b2b1e3b906ba$export$fd42f52fd3ae1109)({
    name: `InputGroupStylesContext`,
    errorMessage: `useInputGroupStyles returned is 'undefined'. Seems you forgot to wrap the components in "<InputGroup />" `
});
const $5678c8a868262504$export$6e5a9cd40e0c9b97 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function InputGroup2(props, ref) {
    const styles = (0, $c7d173d35275482d$export$31cdfe60c085d76f)("Input", props);
    const { children: children, className: className, ...rest } = (0, $58ff34c9d17adf03$export$adfcf5a5e4d17785)(props);
    const _className = (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-input__group", className);
    const groupStyles = {};
    const validChildren = (0, $da8753851e8cc1f3$export$b2c43d7d050b2e63)(children);
    const input = styles.field;
    validChildren.forEach((child)=>{
        if (!styles) return;
        if (input && child.type.id === "InputLeftElement") groupStyles.paddingStart = input.height ?? input.h;
        if (input && child.type.id === "InputRightElement") groupStyles.paddingEnd = input.height ?? input.h;
        if (child.type.id === "InputRightAddon") groupStyles.borderEndRadius = 0;
        if (child.type.id === "InputLeftAddon") groupStyles.borderStartRadius = 0;
    });
    const clones = validChildren.map((child)=>{
        const theming = (0, $7hYFp.compact)({
            size: child.props?.size || props.size,
            variant: child.props?.variant || props.variant
        });
        return child.type.id !== "Input" ? (0, $8v0nu.cloneElement)(child, theming) : (0, $8v0nu.cloneElement)(child, Object.assign(theming, groupStyles, child.props));
    });
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
        className: _className,
        ref: ref,
        __css: {
            width: "100%",
            display: "flex",
            position: "relative",
            // Parts of inputs override z-index to ensure that they stack correctly on each other
            // Create a new stacking context so that these overrides don't leak out and conflict with other z-indexes
            isolation: "isolate",
            ...styles.group
        },
        "data-group": true,
        ...rest,
        children: /* @__PURE__ */ (0, $kxTYF.jsx)($5678c8a868262504$var$InputGroupStylesProvider, {
            value: styles,
            children: clones
        })
    });
});
$5678c8a868262504$export$6e5a9cd40e0c9b97.displayName = "InputGroup";


var $kxTYF = parcelRequire("kxTYF");



var $3lBLT = parcelRequire("3lBLT");

"use client";
const $0f6ca7b518b921a6$var$StyledInputElement = (0, $3lBLT.chakra)("div", {
    baseStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        top: "0",
        zIndex: 2
    }
});
const $0f6ca7b518b921a6$var$InputElement = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function InputElement2(props, ref) {
    const { placement: placement = "left", ...rest } = props;
    const styles = (0, $5678c8a868262504$export$635b0139be441f68)();
    const input = styles.field;
    const attr = placement === "left" ? "insetStart" : "insetEnd";
    const elementStyles = {
        [attr]: "0",
        width: input?.height ?? input?.h,
        height: input?.height ?? input?.h,
        fontSize: input?.fontSize,
        ...styles.element
    };
    return /* @__PURE__ */ (0, $kxTYF.jsx)($0f6ca7b518b921a6$var$StyledInputElement, {
        ref: ref,
        __css: elementStyles,
        ...rest
    });
});
$0f6ca7b518b921a6$var$InputElement.id = "InputElement";
$0f6ca7b518b921a6$var$InputElement.displayName = "InputElement";
const $0f6ca7b518b921a6$export$b5cdbc34a3b65f4c = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function InputLeftElement2(props, ref) {
    const { className: className, ...rest } = props;
    const _className = (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-input__left-element", className);
    return /* @__PURE__ */ (0, $kxTYF.jsx)($0f6ca7b518b921a6$var$InputElement, {
        ref: ref,
        placement: "left",
        className: _className,
        ...rest
    });
});
$0f6ca7b518b921a6$export$b5cdbc34a3b65f4c.id = "InputLeftElement";
$0f6ca7b518b921a6$export$b5cdbc34a3b65f4c.displayName = "InputLeftElement";
const $0f6ca7b518b921a6$export$8a7b8bdd4608e7e3 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function InputRightElement2(props, ref) {
    const { className: className, ...rest } = props;
    const _className = (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-input__right-element", className);
    return /* @__PURE__ */ (0, $kxTYF.jsx)($0f6ca7b518b921a6$var$InputElement, {
        ref: ref,
        placement: "right",
        className: _className,
        ...rest
    });
});
$0f6ca7b518b921a6$export$8a7b8bdd4608e7e3.id = "InputRightElement";
$0f6ca7b518b921a6$export$8a7b8bdd4608e7e3.displayName = "InputRightElement";


var $kxTYF = parcelRequire("kxTYF");


var $cSr1Y = parcelRequire("cSr1Y");

var $8v0nu = parcelRequire("8v0nu");

function $cdd2e2c2ab3cfefc$export$f21a1ffae260145a(node) {
    return $cdd2e2c2ab3cfefc$export$b204af158042fbac(node)?.defaultView ?? window;
}
function $cdd2e2c2ab3cfefc$export$b204af158042fbac(node) {
    return (0, $ede4194696cbd159$export$1b3bfaa9684536aa)(node) ? node.ownerDocument : document;
}
function $cdd2e2c2ab3cfefc$export$8d16348623687f6(event) {
    return event.view ?? window;
}
function $cdd2e2c2ab3cfefc$export$cd4e5573fbe2b576(node) {
    return $cdd2e2c2ab3cfefc$export$b204af158042fbac(node).activeElement;
}



var $8v0nu = parcelRequire("8v0nu");

var $8v0nu = parcelRequire("8v0nu");

"use client";
function $0313565cc024e2ed$export$7080b3e976bc91ab(target, event, handler, options) {
    const listener = (0, $7bf98d1f0832a6d6$export$25bec8c6f54ee79a)(handler);
    (0, $8v0nu.useEffect)(()=>{
        const node = typeof target === "function" ? target() : target ?? document;
        if (!handler || !node) return;
        node.addEventListener(event, listener, options);
        return ()=>{
            node.removeEventListener(event, listener, options);
        };
    }, [
        event,
        target,
        options,
        listener,
        handler
    ]);
    return ()=>{
        const node = typeof target === "function" ? target() : target ?? document;
        node?.removeEventListener(event, listener, options);
    };
}


"use client";
function $f7cea9053f03399a$export$7ee548861327febe(props) {
    const { isOpen: isOpen, ref: ref } = props;
    const [mounted, setMounted] = (0, $8v0nu.useState)(isOpen);
    const [once, setOnce] = (0, $8v0nu.useState)(false);
    (0, $8v0nu.useEffect)(()=>{
        if (!once) {
            setMounted(isOpen);
            setOnce(true);
        }
    }, [
        isOpen,
        once,
        mounted
    ]);
    (0, $0313565cc024e2ed$export$7080b3e976bc91ab)(()=>ref.current, "animationend", ()=>{
        setMounted(isOpen);
    });
    const hidden = isOpen ? false : !mounted;
    return {
        present: !hidden,
        onComplete () {
            const win = (0, $cdd2e2c2ab3cfefc$export$f21a1ffae260145a)(ref.current);
            const evt = new win.CustomEvent("animationend", {
                bubbles: true
            });
            ref.current?.dispatchEvent(evt);
        }
    };
}


var $8v0nu = parcelRequire("8v0nu");

"use client";
function $3268be99fa453fba$export$7301e09313e4cf1b(prop, state) {
    const controlled = typeof prop !== "undefined";
    const value = controlled ? prop : state;
    return (0, $8v0nu.useMemo)(()=>[
            controlled,
            value
        ], [
        controlled,
        value
    ]);
}
function $3268be99fa453fba$export$6f32135080cb4c3(props) {
    const { value: valueProp, defaultValue: defaultValue, onChange: onChange, shouldUpdate: shouldUpdate = (prev, next)=>prev !== next } = props;
    const onChangeProp = (0, $7bf98d1f0832a6d6$export$25bec8c6f54ee79a)(onChange);
    const shouldUpdateProp = (0, $7bf98d1f0832a6d6$export$25bec8c6f54ee79a)(shouldUpdate);
    const [uncontrolledState, setUncontrolledState] = (0, $8v0nu.useState)(defaultValue);
    const controlled = valueProp !== void 0;
    const value = controlled ? valueProp : uncontrolledState;
    const setValue = (0, $7bf98d1f0832a6d6$export$25bec8c6f54ee79a)((next)=>{
        const setter = next;
        const nextValue = typeof next === "function" ? setter(value) : next;
        if (!shouldUpdateProp(value, nextValue)) return;
        if (!controlled) setUncontrolledState(nextValue);
        onChangeProp(nextValue);
    }, [
        controlled,
        onChangeProp,
        value,
        shouldUpdateProp
    ]);
    return [
        value,
        setValue
    ];
}



var $8v0nu = parcelRequire("8v0nu");
"use client";
function $cc3982b77d606367$export$6e3e27031a30522f(props = {}) {
    const { onClose: onCloseProp, onOpen: onOpenProp, isOpen: isOpenProp, id: idProp } = props;
    const handleOpen = (0, $7bf98d1f0832a6d6$export$25bec8c6f54ee79a)(onOpenProp);
    const handleClose = (0, $7bf98d1f0832a6d6$export$25bec8c6f54ee79a)(onCloseProp);
    const [isOpenState, setIsOpen] = (0, $8v0nu.useState)(props.defaultIsOpen || false);
    const isOpen = isOpenProp !== void 0 ? isOpenProp : isOpenState;
    const isControlled = isOpenProp !== void 0;
    const uid = (0, $8v0nu.useId)();
    const id = idProp ?? `disclosure-${uid}`;
    const onClose = (0, $8v0nu.useCallback)(()=>{
        if (!isControlled) setIsOpen(false);
        handleClose?.();
    }, [
        isControlled,
        handleClose
    ]);
    const onOpen = (0, $8v0nu.useCallback)(()=>{
        if (!isControlled) setIsOpen(true);
        handleOpen?.();
    }, [
        isControlled,
        handleOpen
    ]);
    const onToggle = (0, $8v0nu.useCallback)(()=>{
        if (isOpen) onClose();
        else onOpen();
    }, [
        isOpen,
        onOpen,
        onClose
    ]);
    function getButtonProps(props2 = {}) {
        return {
            ...props2,
            "aria-expanded": isOpen,
            "aria-controls": id,
            onClick (event) {
                props2.onClick?.(event);
                onToggle();
            }
        };
    }
    function getDisclosureProps(props2 = {}) {
        return {
            ...props2,
            hidden: !isOpen,
            id: id
        };
    }
    return {
        isOpen: isOpen,
        onOpen: onOpen,
        onClose: onClose,
        onToggle: onToggle,
        isControlled: isControlled,
        getButtonProps: getButtonProps,
        getDisclosureProps: getDisclosureProps
    };
}


const $2f0f9843592ee423$export$f5f22eac728522fd = (element)=>window.getComputedStyle(element).display === "none";
const $2f0f9843592ee423$export$54209d29bacd2cb9 = (element)=>element.hasAttribute("tabindex");
const $2f0f9843592ee423$export$87df0ed37d24dd13 = (element)=>$2f0f9843592ee423$export$54209d29bacd2cb9(element) && element.tabIndex === -1;
function $2f0f9843592ee423$export$848589947316f680(element) {
    if (!document.activeElement) return false;
    return element.contains(document.activeElement);
}
function $2f0f9843592ee423$export$4c063cf1350e6fed(element) {
    if (!(0, $ede4194696cbd159$export$1b3bfaa9684536aa)(element) || (0, $ede4194696cbd159$export$ca1c506c57abefed)(element) || (0, $ede4194696cbd159$export$f1048a3bb039cd02)(element)) return false;
    const { localName: localName } = element;
    const focusableTags = [
        "input",
        "select",
        "textarea",
        "button"
    ];
    if (focusableTags.indexOf(localName) >= 0) return true;
    const others = {
        a: ()=>element.hasAttribute("href"),
        audio: ()=>element.hasAttribute("controls"),
        video: ()=>element.hasAttribute("controls")
    };
    if (localName in others) return others[localName]();
    if ((0, $ede4194696cbd159$export$de19eba357c4d80f)(element)) return true;
    return $2f0f9843592ee423$export$54209d29bacd2cb9(element);
}
function $2f0f9843592ee423$export$bebd5a1431fec25d(element) {
    if (!element) return false;
    return (0, $ede4194696cbd159$export$1b3bfaa9684536aa)(element) && $2f0f9843592ee423$export$4c063cf1350e6fed(element) && !$2f0f9843592ee423$export$87df0ed37d24dd13(element);
}


const $dd5ef4147bb4b05b$var$focusableElList = [
    "input:not(:disabled):not([disabled])",
    "select:not(:disabled):not([disabled])",
    "textarea:not(:disabled):not([disabled])",
    "embed",
    "iframe",
    "object",
    "a[href]",
    "area[href]",
    "button:not(:disabled):not([disabled])",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    "*[tabindex]:not([aria-disabled])",
    "*[contenteditable]"
];
const $dd5ef4147bb4b05b$var$focusableElSelector = $dd5ef4147bb4b05b$var$focusableElList.join();
const $dd5ef4147bb4b05b$var$isVisible = (el)=>el.offsetWidth > 0 && el.offsetHeight > 0;
function $dd5ef4147bb4b05b$export$4ae682d253b556eb(container) {
    const focusableEls = Array.from(container.querySelectorAll($dd5ef4147bb4b05b$var$focusableElSelector));
    focusableEls.unshift(container);
    return focusableEls.filter((el)=>(0, $2f0f9843592ee423$export$4c063cf1350e6fed)(el) && $dd5ef4147bb4b05b$var$isVisible(el));
}
function $dd5ef4147bb4b05b$export$748138f04a69bf21(container) {
    const allFocusable = $dd5ef4147bb4b05b$export$4ae682d253b556eb(container);
    return allFocusable.length ? allFocusable[0] : null;
}
function $dd5ef4147bb4b05b$export$f9ba66356f7359cf(container, fallbackToFocusable) {
    const allFocusable = Array.from(container.querySelectorAll($dd5ef4147bb4b05b$var$focusableElSelector));
    const allTabbable = allFocusable.filter((0, $2f0f9843592ee423$export$bebd5a1431fec25d));
    if ((0, $2f0f9843592ee423$export$bebd5a1431fec25d)(container)) allTabbable.unshift(container);
    if (!allTabbable.length && fallbackToFocusable) return allFocusable;
    return allTabbable;
}
function $dd5ef4147bb4b05b$export$168b663469d4c75e(container, fallbackToFocusable) {
    const [first] = $dd5ef4147bb4b05b$export$f9ba66356f7359cf(container, fallbackToFocusable);
    return first || null;
}
function $dd5ef4147bb4b05b$export$a6fe3106a93f5f4b(container, fallbackToFocusable) {
    const allTabbable = $dd5ef4147bb4b05b$export$f9ba66356f7359cf(container, fallbackToFocusable);
    return allTabbable[allTabbable.length - 1] || null;
}
function $dd5ef4147bb4b05b$export$28f33206776129a7(container, fallbackToFocusable) {
    const allFocusable = $dd5ef4147bb4b05b$export$4ae682d253b556eb(container);
    const index = allFocusable.indexOf(document.activeElement);
    const slice = allFocusable.slice(index + 1);
    return slice.find((0, $2f0f9843592ee423$export$bebd5a1431fec25d)) || allFocusable.find((0, $2f0f9843592ee423$export$bebd5a1431fec25d)) || (fallbackToFocusable ? slice[0] : null);
}
function $dd5ef4147bb4b05b$export$2e5518c3303f364a(container, fallbackToFocusable) {
    const allFocusable = $dd5ef4147bb4b05b$export$4ae682d253b556eb(container).reverse();
    const index = allFocusable.indexOf(document.activeElement);
    const slice = allFocusable.slice(index + 1);
    return slice.find((0, $2f0f9843592ee423$export$bebd5a1431fec25d)) || allFocusable.find((0, $2f0f9843592ee423$export$bebd5a1431fec25d)) || (fallbackToFocusable ? slice[0] : null);
}



var $8v0nu = parcelRequire("8v0nu");



"use client";
function $6c3b109dd1e78e88$var$preventReturnFocus(containerRef) {
    const el = containerRef.current;
    if (!el) return false;
    const activeElement = (0, $cdd2e2c2ab3cfefc$export$cd4e5573fbe2b576)(el);
    if (!activeElement) return false;
    if (el.contains(activeElement)) return false;
    if ((0, $2f0f9843592ee423$export$bebd5a1431fec25d)(activeElement)) return true;
    return false;
}
function $6c3b109dd1e78e88$export$68b323438c1fbb28(containerRef, options) {
    const { shouldFocus: shouldFocusProp, visible: visible, focusRef: focusRef } = options;
    const shouldFocus = shouldFocusProp && !visible;
    (0, $9fe29ceca799989a$export$496315a1608d9602)(()=>{
        if (!shouldFocus) return;
        if ($6c3b109dd1e78e88$var$preventReturnFocus(containerRef)) return;
        const el = focusRef?.current || containerRef.current;
        let rafId;
        if (el) {
            rafId = requestAnimationFrame(()=>{
                el.focus({
                    preventScroll: true
                });
            });
            return ()=>{
                cancelAnimationFrame(rafId);
            };
        }
    }, [
        shouldFocus,
        containerRef,
        focusRef
    ]);
}
const $6c3b109dd1e78e88$var$defaultOptions = {
    preventScroll: true,
    shouldFocus: false
};
function $6c3b109dd1e78e88$export$54b5c2a5755195e7(target, options = $6c3b109dd1e78e88$var$defaultOptions) {
    const { focusRef: focusRef, preventScroll: preventScroll, shouldFocus: shouldFocus, visible: visible } = options;
    const element = $6c3b109dd1e78e88$var$isRefObject(target) ? target.current : target;
    const autoFocusValue = shouldFocus && visible;
    const autoFocusRef = (0, $8v0nu.useRef)(autoFocusValue);
    const lastVisibleRef = (0, $8v0nu.useRef)(visible);
    (0, $456f92579f2f647e$export$deebe11a338de063)(()=>{
        if (!lastVisibleRef.current && visible) autoFocusRef.current = autoFocusValue;
        lastVisibleRef.current = visible;
    }, [
        visible,
        autoFocusValue
    ]);
    const onFocus = (0, $8v0nu.useCallback)(()=>{
        if (!visible || !element || !autoFocusRef.current) return;
        autoFocusRef.current = false;
        if (element.contains(document.activeElement)) return;
        if (focusRef?.current) requestAnimationFrame(()=>{
            focusRef.current?.focus({
                preventScroll: preventScroll
            });
        });
        else {
            const tabbableEls = (0, $dd5ef4147bb4b05b$export$4ae682d253b556eb)(element);
            if (tabbableEls.length > 0) requestAnimationFrame(()=>{
                tabbableEls[0].focus({
                    preventScroll: preventScroll
                });
            });
        }
    }, [
        visible,
        preventScroll,
        element,
        focusRef
    ]);
    (0, $9fe29ceca799989a$export$496315a1608d9602)(()=>{
        onFocus();
    }, [
        onFocus
    ]);
    (0, $0313565cc024e2ed$export$7080b3e976bc91ab)(element, "transitionend", onFocus);
}
function $6c3b109dd1e78e88$var$isRefObject(val) {
    return "current" in val;
}


var $8v0nu = parcelRequire("8v0nu");
"use client";
function $9d8f051d0eee816d$export$f680877a34711e37(idProp, prefix) {
    const id = (0, $8v0nu.useId)();
    return (0, $8v0nu.useMemo)(()=>idProp || [
            prefix,
            id
        ].filter(Boolean).join("-"), [
        idProp,
        prefix,
        id
    ]);
}
function $9d8f051d0eee816d$export$365c04e2f432779(idProp, ...prefixes) {
    const id = $9d8f051d0eee816d$export$f680877a34711e37(idProp);
    return (0, $8v0nu.useMemo)(()=>{
        return prefixes.map((prefix)=>`${prefix}-${id}`);
    }, [
        id,
        prefixes
    ]);
}
function $9d8f051d0eee816d$export$bc294ecf36b44bfb(partId) {
    const [id, setId] = (0, $8v0nu.useState)(null);
    const ref = (0, $8v0nu.useCallback)((node)=>{
        setId(node ? partId : null);
    }, [
        partId
    ]);
    return {
        ref: ref,
        id: id,
        isRendered: Boolean(id)
    };
}


var $8v0nu = parcelRequire("8v0nu");

"use client";
function $313dea541a92f272$export$71b2224f1ce5e08e(props) {
    const { ref: ref, handler: handler, enabled: enabled = true } = props;
    const savedHandler = (0, $7bf98d1f0832a6d6$export$25bec8c6f54ee79a)(handler);
    const stateRef = (0, $8v0nu.useRef)({
        isPointerDown: false,
        ignoreEmulatedMouseEvents: false
    });
    const state = stateRef.current;
    (0, $8v0nu.useEffect)(()=>{
        if (!enabled) return;
        const onPointerDown = (e)=>{
            if ($313dea541a92f272$var$isValidEvent(e, ref)) state.isPointerDown = true;
        };
        const onMouseUp = (event)=>{
            if (state.ignoreEmulatedMouseEvents) {
                state.ignoreEmulatedMouseEvents = false;
                return;
            }
            if (state.isPointerDown && handler && $313dea541a92f272$var$isValidEvent(event, ref)) {
                state.isPointerDown = false;
                savedHandler(event);
            }
        };
        const onTouchEnd = (event)=>{
            state.ignoreEmulatedMouseEvents = true;
            if (handler && state.isPointerDown && $313dea541a92f272$var$isValidEvent(event, ref)) {
                state.isPointerDown = false;
                savedHandler(event);
            }
        };
        const doc = $313dea541a92f272$var$getOwnerDocument(ref.current);
        doc.addEventListener("mousedown", onPointerDown, true);
        doc.addEventListener("mouseup", onMouseUp, true);
        doc.addEventListener("touchstart", onPointerDown, true);
        doc.addEventListener("touchend", onTouchEnd, true);
        return ()=>{
            doc.removeEventListener("mousedown", onPointerDown, true);
            doc.removeEventListener("mouseup", onMouseUp, true);
            doc.removeEventListener("touchstart", onPointerDown, true);
            doc.removeEventListener("touchend", onTouchEnd, true);
        };
    }, [
        handler,
        ref,
        savedHandler,
        state,
        enabled
    ]);
}
function $313dea541a92f272$var$isValidEvent(event, ref) {
    const target = event.composedPath?.()[0] ?? event.target;
    if (target) {
        const doc = $313dea541a92f272$var$getOwnerDocument(target);
        if (!doc.contains(target)) return false;
    }
    return !ref.current?.contains(target);
}
function $313dea541a92f272$var$getOwnerDocument(node) {
    return node?.ownerDocument ?? document;
}


function $4b0f1a1d98c64842$export$76655e7dd9ffc0ba(options) {
    const { wasSelected: wasSelected, enabled: enabled, isSelected: isSelected, mode: mode = "unmount" } = options;
    if (!enabled) return true;
    if (isSelected) return true;
    if (mode === "keepMounted" && wasSelected) return true;
    return false;
}



var $8v0nu = parcelRequire("8v0nu");
"use client";
function $c051f3d33780cc4c$export$18ed781d9da46f95(items, searchString, itemToString, currentItem) {
    if (searchString == null) return currentItem;
    if (!currentItem) {
        const foundItem = items.find((item)=>itemToString(item).toLowerCase().startsWith(searchString.toLowerCase()));
        return foundItem;
    }
    const matchingItems = items.filter((item)=>itemToString(item).toLowerCase().startsWith(searchString.toLowerCase()));
    if (matchingItems.length > 0) {
        let nextIndex;
        if (matchingItems.includes(currentItem)) {
            const currentIndex = matchingItems.indexOf(currentItem);
            nextIndex = currentIndex + 1;
            if (nextIndex === matchingItems.length) nextIndex = 0;
            return matchingItems[nextIndex];
        }
        nextIndex = items.indexOf(matchingItems[0]);
        return items[nextIndex];
    }
    return currentItem;
}



var $8v0nu = parcelRequire("8v0nu");
"use client";
function $8017fa62fdefcad3$var$isPrintableCharacter(event) {
    const { key: key } = event;
    return key.length === 1 || key.length > 1 && /[^a-zA-Z0-9]/.test(key);
}
function $8017fa62fdefcad3$export$b0ebbe7904d8d94a(props = {}) {
    const { timeout: timeout = 300, preventDefault: preventDefault = ()=>true } = props;
    const [keys, setKeys] = (0, $8v0nu.useState)([]);
    const timeoutRef = (0, $8v0nu.useRef)();
    const flush = ()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    };
    const clearKeysAfterDelay = ()=>{
        flush();
        timeoutRef.current = setTimeout(()=>{
            setKeys([]);
            timeoutRef.current = null;
        }, timeout);
    };
    (0, $8v0nu.useEffect)(()=>flush, []);
    function onKeyDown(fn) {
        return (event)=>{
            if (event.key === "Backspace") {
                const keysCopy = [
                    ...keys
                ];
                keysCopy.pop();
                setKeys(keysCopy);
                return;
            }
            if ($8017fa62fdefcad3$var$isPrintableCharacter(event)) {
                const keysCopy = keys.concat(event.key);
                if (preventDefault(event)) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                setKeys(keysCopy);
                fn(keysCopy.join(""));
                clearKeysAfterDelay();
            }
        };
    }
    return onKeyDown;
}





var $8v0nu = parcelRequire("8v0nu");

var $8v0nu = parcelRequire("8v0nu");
"use client";
function $5f9d77101be932d0$export$96d07f33920abf3e(nodes) {
    return nodes.sort((a, b)=>{
        const compare = a.compareDocumentPosition(b);
        if (compare & Node.DOCUMENT_POSITION_FOLLOWING || compare & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
        if (compare & Node.DOCUMENT_POSITION_PRECEDING || compare & Node.DOCUMENT_POSITION_CONTAINS) return 1;
        if (compare & Node.DOCUMENT_POSITION_DISCONNECTED || compare & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC) throw Error("Cannot sort the given nodes.");
        else return 0;
    });
}
const $5f9d77101be932d0$export$45a5e7f76e0caa8d = (el)=>typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
function $5f9d77101be932d0$export$c42e0e80904d519(current, max, loop) {
    let next = current + 1;
    if (loop && next >= max) next = 0;
    return next;
}
function $5f9d77101be932d0$export$1081b7170ed6e343(current, max, loop) {
    let next = current - 1;
    if (loop && next < 0) next = max;
    return next;
}
const $5f9d77101be932d0$export$deebe11a338de063 = typeof window !== "undefined" ? (0, $8v0nu.useLayoutEffect) : (0, $8v0nu.useEffect);
const $5f9d77101be932d0$export$f2db7d5238e1d23f = (value)=>value;


"use client";
var $cc5b0dde5db15f64$var$__defProp = Object.defineProperty;
var $cc5b0dde5db15f64$var$__defNormalProp = (obj, key, value)=>key in obj ? $cc5b0dde5db15f64$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $cc5b0dde5db15f64$var$__publicField = (obj, key, value)=>{
    $cc5b0dde5db15f64$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
class $cc5b0dde5db15f64$export$e6418ef1851accd {
    constructor(){
        $cc5b0dde5db15f64$var$__publicField(this, "descendants", /* @__PURE__ */ new Map());
        $cc5b0dde5db15f64$var$__publicField(this, "register", (nodeOrOptions)=>{
            if (nodeOrOptions == null) return;
            if ((0, $5f9d77101be932d0$export$45a5e7f76e0caa8d)(nodeOrOptions)) return this.registerNode(nodeOrOptions);
            return (node)=>{
                this.registerNode(node, nodeOrOptions);
            };
        });
        $cc5b0dde5db15f64$var$__publicField(this, "unregister", (node)=>{
            this.descendants.delete(node);
            const sorted = (0, $5f9d77101be932d0$export$96d07f33920abf3e)(Array.from(this.descendants.keys()));
            this.assignIndex(sorted);
        });
        $cc5b0dde5db15f64$var$__publicField(this, "destroy", ()=>{
            this.descendants.clear();
        });
        $cc5b0dde5db15f64$var$__publicField(this, "assignIndex", (descendants)=>{
            this.descendants.forEach((descendant)=>{
                const index = descendants.indexOf(descendant.node);
                descendant.index = index;
                descendant.node.dataset["index"] = descendant.index.toString();
            });
        });
        $cc5b0dde5db15f64$var$__publicField(this, "count", ()=>this.descendants.size);
        $cc5b0dde5db15f64$var$__publicField(this, "enabledCount", ()=>this.enabledValues().length);
        $cc5b0dde5db15f64$var$__publicField(this, "values", ()=>{
            const values = Array.from(this.descendants.values());
            return values.sort((a, b)=>a.index - b.index);
        });
        $cc5b0dde5db15f64$var$__publicField(this, "enabledValues", ()=>{
            return this.values().filter((descendant)=>!descendant.disabled);
        });
        $cc5b0dde5db15f64$var$__publicField(this, "item", (index)=>{
            if (this.count() === 0) return void 0;
            return this.values()[index];
        });
        $cc5b0dde5db15f64$var$__publicField(this, "enabledItem", (index)=>{
            if (this.enabledCount() === 0) return void 0;
            return this.enabledValues()[index];
        });
        $cc5b0dde5db15f64$var$__publicField(this, "first", ()=>this.item(0));
        $cc5b0dde5db15f64$var$__publicField(this, "firstEnabled", ()=>this.enabledItem(0));
        $cc5b0dde5db15f64$var$__publicField(this, "last", ()=>this.item(this.descendants.size - 1));
        $cc5b0dde5db15f64$var$__publicField(this, "lastEnabled", ()=>{
            const lastIndex = this.enabledValues().length - 1;
            return this.enabledItem(lastIndex);
        });
        $cc5b0dde5db15f64$var$__publicField(this, "indexOf", (node)=>{
            if (!node) return -1;
            return this.descendants.get(node)?.index ?? -1;
        });
        $cc5b0dde5db15f64$var$__publicField(this, "enabledIndexOf", (node)=>{
            if (node == null) return -1;
            return this.enabledValues().findIndex((i)=>i.node.isSameNode(node));
        });
        $cc5b0dde5db15f64$var$__publicField(this, "next", (index, loop = true)=>{
            const next = (0, $5f9d77101be932d0$export$c42e0e80904d519)(index, this.count(), loop);
            return this.item(next);
        });
        $cc5b0dde5db15f64$var$__publicField(this, "nextEnabled", (index, loop = true)=>{
            const item = this.item(index);
            if (!item) return;
            const enabledIndex = this.enabledIndexOf(item.node);
            const nextEnabledIndex = (0, $5f9d77101be932d0$export$c42e0e80904d519)(enabledIndex, this.enabledCount(), loop);
            return this.enabledItem(nextEnabledIndex);
        });
        $cc5b0dde5db15f64$var$__publicField(this, "prev", (index, loop = true)=>{
            const prev = (0, $5f9d77101be932d0$export$1081b7170ed6e343)(index, this.count() - 1, loop);
            return this.item(prev);
        });
        $cc5b0dde5db15f64$var$__publicField(this, "prevEnabled", (index, loop = true)=>{
            const item = this.item(index);
            if (!item) return;
            const enabledIndex = this.enabledIndexOf(item.node);
            const prevEnabledIndex = (0, $5f9d77101be932d0$export$1081b7170ed6e343)(enabledIndex, this.enabledCount() - 1, loop);
            return this.enabledItem(prevEnabledIndex);
        });
        $cc5b0dde5db15f64$var$__publicField(this, "registerNode", (node, options)=>{
            if (!node || this.descendants.has(node)) return;
            const keys = Array.from(this.descendants.keys()).concat(node);
            const sorted = (0, $5f9d77101be932d0$export$96d07f33920abf3e)(keys);
            if (options?.disabled) options.disabled = !!options.disabled;
            const descendant = {
                node: node,
                index: -1,
                ...options
            };
            this.descendants.set(node, descendant);
            this.assignIndex(sorted);
        });
    }
}



"use client";
function $351cee6c59f3b060$export$126c4100f8947d7() {
    const [DescendantsContextProvider, useDescendantsContext] = (0, $3473b2b1e3b906ba$export$fd42f52fd3ae1109)({
        name: "DescendantsProvider",
        errorMessage: "useDescendantsContext must be used within DescendantsProvider"
    });
    const useDescendant = (options)=>{
        const descendants = useDescendantsContext();
        const [index, setIndex] = (0, $8v0nu.useState)(-1);
        const ref = (0, $8v0nu.useRef)(null);
        (0, $5f9d77101be932d0$export$deebe11a338de063)(()=>{
            return ()=>{
                if (!ref.current) return;
                descendants.unregister(ref.current);
            };
        }, []);
        (0, $5f9d77101be932d0$export$deebe11a338de063)(()=>{
            if (!ref.current) return;
            const dataIndex = Number(ref.current.dataset["index"]);
            if (index != dataIndex && !Number.isNaN(dataIndex)) setIndex(dataIndex);
        });
        const refCallback = options ? (0, $5f9d77101be932d0$export$f2db7d5238e1d23f)(descendants.register(options)) : (0, $5f9d77101be932d0$export$f2db7d5238e1d23f)(descendants.register);
        return {
            descendants: descendants,
            index: index,
            enabledIndex: descendants.enabledIndexOf(ref.current),
            register: (0, $95f7db4ddbf3eda0$export$c9058316764c140e)(refCallback, ref)
        };
    };
    const useDescendants = ()=>{
        const descendants = (0, $8v0nu.useRef)(new (0, $cc5b0dde5db15f64$export$e6418ef1851accd)());
        (0, $5f9d77101be932d0$export$deebe11a338de063)(()=>{
            return ()=>descendants.current.destroy();
        });
        return descendants.current;
    };
    return [
        // context provider
        DescendantsContextProvider,
        // call this when you need to read from context
        useDescendantsContext,
        // descendants state information, to be called and passed to `ContextProvider`
        useDescendants,
        // descendant index information
        useDescendant
    ];
}



function $becc4ee28f521e69$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $288b4f28aeac3257$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $becc4ee28f521e69$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $288b4f28aeac3257$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $becc4ee28f521e69$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $288b4f28aeac3257$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $becc4ee28f521e69$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $6c2fbcec0a5c39a8$export$8960430cfd85939f = Math.max;
var $6c2fbcec0a5c39a8$export$96ec731ed4dcb222 = Math.min;
var $6c2fbcec0a5c39a8$export$2077e0241d6afd3c = Math.round;



function $cabf7592cae4db05$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $d58cafdf737e3ba9$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $cabf7592cae4db05$export$2e2bcd8739ae039)());
}


function $892cbd7bb3672483$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $288b4f28aeac3257$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $6c2fbcec0a5c39a8$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $6c2fbcec0a5c39a8$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $288b4f28aeac3257$export$45a5e7f76e0caa8d)(element) ? (0, $becc4ee28f521e69$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $d58cafdf737e3ba9$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $079d3233ec0c2dde$export$2e2bcd8739ae039(node) {
    var win = (0, $becc4ee28f521e69$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $e9544f285183003b$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $b1786efd789f7d5b$export$2e2bcd8739ae039(node) {
    if (node === (0, $becc4ee28f521e69$export$2e2bcd8739ae039)(node) || !(0, $288b4f28aeac3257$export$1b3bfaa9684536aa)(node)) return (0, $079d3233ec0c2dde$export$2e2bcd8739ae039)(node);
    else return (0, $e9544f285183003b$export$2e2bcd8739ae039)(node);
}


function $00bd2ce7da26be41$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $0ba43c19f913d28a$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $288b4f28aeac3257$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $29827ee0741a6cf6$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $892cbd7bb3672483$export$2e2bcd8739ae039)((0, $0ba43c19f913d28a$export$2e2bcd8739ae039)(element)).left + (0, $079d3233ec0c2dde$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $ee98ef44cde3cdfb$export$2e2bcd8739ae039(element) {
    return (0, $becc4ee28f521e69$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $10ec2776eda15543$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $ee98ef44cde3cdfb$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $935f8c3e49cee800$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $6c2fbcec0a5c39a8$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $6c2fbcec0a5c39a8$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $935f8c3e49cee800$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $288b4f28aeac3257$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $288b4f28aeac3257$export$1b3bfaa9684536aa)(offsetParent) && $935f8c3e49cee800$var$isElementScaled(offsetParent);
    var documentElement = (0, $0ba43c19f913d28a$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $892cbd7bb3672483$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $00bd2ce7da26be41$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $10ec2776eda15543$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $b1786efd789f7d5b$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $288b4f28aeac3257$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $892cbd7bb3672483$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $29827ee0741a6cf6$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $32131b74da817c54$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $892cbd7bb3672483$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $5138f277baf36c69$export$2e2bcd8739ae039(element) {
    if ((0, $00bd2ce7da26be41$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $288b4f28aeac3257$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0ba43c19f913d28a$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $ac4f2f9d39d08b80$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $00bd2ce7da26be41$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $288b4f28aeac3257$export$1b3bfaa9684536aa)(node) && (0, $10ec2776eda15543$export$2e2bcd8739ae039)(node)) return node;
    return $ac4f2f9d39d08b80$export$2e2bcd8739ae039((0, $5138f277baf36c69$export$2e2bcd8739ae039)(node));
}





function $bb4991d78b6356a2$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $ac4f2f9d39d08b80$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $becc4ee28f521e69$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $10ec2776eda15543$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($bb4991d78b6356a2$export$2e2bcd8739ae039((0, $5138f277baf36c69$export$2e2bcd8739ae039)(target)));
}







function $58de25162797ce4d$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $00bd2ce7da26be41$export$2e2bcd8739ae039)(element)) >= 0;
}




function $89ab075476fedee0$var$getTrueOffsetParent(element) {
    if (!(0, $288b4f28aeac3257$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $ee98ef44cde3cdfb$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $89ab075476fedee0$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $cabf7592cae4db05$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $cabf7592cae4db05$export$2e2bcd8739ae039)());
    if (isIE && (0, $288b4f28aeac3257$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $ee98ef44cde3cdfb$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $5138f277baf36c69$export$2e2bcd8739ae039)(element);
    if ((0, $288b4f28aeac3257$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $288b4f28aeac3257$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $00bd2ce7da26be41$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $ee98ef44cde3cdfb$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $89ab075476fedee0$export$2e2bcd8739ae039(element) {
    var window = (0, $becc4ee28f521e69$export$2e2bcd8739ae039)(element);
    var offsetParent = $89ab075476fedee0$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $58de25162797ce4d$export$2e2bcd8739ae039)(offsetParent) && (0, $ee98ef44cde3cdfb$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $89ab075476fedee0$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $00bd2ce7da26be41$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $00bd2ce7da26be41$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $ee98ef44cde3cdfb$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $89ab075476fedee0$var$getContainingBlock(element) || window;
}


var $84357ccb6d4c8548$export$1e95b668f3b82d = "top";
var $84357ccb6d4c8548$export$40e543e69a8b3fbb = "bottom";
var $84357ccb6d4c8548$export$79ffe56a765070d2 = "right";
var $84357ccb6d4c8548$export$eabcd2c8791e7bf4 = "left";
var $84357ccb6d4c8548$export$dfb5619354ba860 = "auto";
var $84357ccb6d4c8548$export$aec2ce47c367b8c3 = [
    $84357ccb6d4c8548$export$1e95b668f3b82d,
    $84357ccb6d4c8548$export$40e543e69a8b3fbb,
    $84357ccb6d4c8548$export$79ffe56a765070d2,
    $84357ccb6d4c8548$export$eabcd2c8791e7bf4
];
var $84357ccb6d4c8548$export$b3571188c770cc5a = "start";
var $84357ccb6d4c8548$export$bd5df0f255a350f8 = "end";
var $84357ccb6d4c8548$export$390fd549c5303b4d = "clippingParents";
var $84357ccb6d4c8548$export$d7b7311ec04a3e8f = "viewport";
var $84357ccb6d4c8548$export$ae5ab1c730825774 = "popper";
var $84357ccb6d4c8548$export$ca50aac9f3ba507f = "reference";
var $84357ccb6d4c8548$export$368f9a87e87fa4e1 = /*#__PURE__*/ $84357ccb6d4c8548$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $84357ccb6d4c8548$export$b3571188c770cc5a,
        placement + "-" + $84357ccb6d4c8548$export$bd5df0f255a350f8
    ]);
}, []);
var $84357ccb6d4c8548$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($84357ccb6d4c8548$export$aec2ce47c367b8c3, [
    $84357ccb6d4c8548$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $84357ccb6d4c8548$export$b3571188c770cc5a,
        placement + "-" + $84357ccb6d4c8548$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $84357ccb6d4c8548$export$421679a7c3d56e = "beforeRead";
var $84357ccb6d4c8548$export$aafa59e2e03f2942 = "read";
var $84357ccb6d4c8548$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $84357ccb6d4c8548$export$c65e99957a05207c = "beforeMain";
var $84357ccb6d4c8548$export$f22da7240b7add18 = "main";
var $84357ccb6d4c8548$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $84357ccb6d4c8548$export$8d4d2d70e7d46032 = "beforeWrite";
var $84357ccb6d4c8548$export$68d8715fc104d294 = "write";
var $84357ccb6d4c8548$export$70a6e5159acce2e6 = "afterWrite";
var $84357ccb6d4c8548$export$d087d3878fdf71d5 = [
    $84357ccb6d4c8548$export$421679a7c3d56e,
    $84357ccb6d4c8548$export$aafa59e2e03f2942,
    $84357ccb6d4c8548$export$6964f6c886723980,
    $84357ccb6d4c8548$export$c65e99957a05207c,
    $84357ccb6d4c8548$export$f22da7240b7add18,
    $84357ccb6d4c8548$export$bab79516f2d662fe,
    $84357ccb6d4c8548$export$8d4d2d70e7d46032,
    $84357ccb6d4c8548$export$68d8715fc104d294,
    $84357ccb6d4c8548$export$70a6e5159acce2e6
];


function $c15856958b2ae627$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $c15856958b2ae627$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $c15856958b2ae627$var$order(modifiers); // order based on phase
    return (0, $84357ccb6d4c8548$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $e0ed14627cfc2c08$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $a3398435f38f330b$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $b3850ced1ba808ef$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $b3850ced1ba808ef$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $b3850ced1ba808ef$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b3850ced1ba808ef$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $b3850ced1ba808ef$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $288b4f28aeac3257$export$45a5e7f76e0caa8d)(reference) ? (0, $bb4991d78b6356a2$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $bb4991d78b6356a2$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $bb4991d78b6356a2$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $c15856958b2ae627$export$2e2bcd8739ae039)((0, $a3398435f38f330b$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b3850ced1ba808ef$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $935f8c3e49cee800$export$2e2bcd8739ae039)(reference, (0, $89ab075476fedee0$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $32131b74da817c54$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $e0ed14627cfc2c08$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b3850ced1ba808ef$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b3850ced1ba808ef$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b3850ced1ba808ef$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $b3f6d5b843880420$var$passive = {
    passive: true
};
function $b3f6d5b843880420$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $becc4ee28f521e69$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $b3f6d5b843880420$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $b3f6d5b843880420$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $b3f6d5b843880420$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $b3f6d5b843880420$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $b3f6d5b843880420$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $b3f6d5b843880420$var$effect,
    data: {}
};



function $194a03b9f446405c$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $fe36e31b210873d9$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $7397b4d86a251602$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $793e21da71dba97f$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $194a03b9f446405c$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $fe36e31b210873d9$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $84357ccb6d4c8548$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $84357ccb6d4c8548$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $84357ccb6d4c8548$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $84357ccb6d4c8548$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $7397b4d86a251602$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $84357ccb6d4c8548$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $84357ccb6d4c8548$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $300a3a8a966e63cb$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $793e21da71dba97f$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $300a3a8a966e63cb$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $300a3a8a966e63cb$var$popperOffsets,
    data: {}
};










var $3d64eea58ab27a42$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $3d64eea58ab27a42$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $6c2fbcec0a5c39a8$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $6c2fbcec0a5c39a8$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $3d64eea58ab27a42$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $84357ccb6d4c8548$export$eabcd2c8791e7bf4);
    var sideY = (0, $84357ccb6d4c8548$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $89ab075476fedee0$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $becc4ee28f521e69$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0ba43c19f913d28a$export$2e2bcd8739ae039)(popper);
            if ((0, $ee98ef44cde3cdfb$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $84357ccb6d4c8548$export$1e95b668f3b82d) || (placement === (0, $84357ccb6d4c8548$export$eabcd2c8791e7bf4) || placement === (0, $84357ccb6d4c8548$export$79ffe56a765070d2)) && variation === (0, $84357ccb6d4c8548$export$bd5df0f255a350f8)) {
            sideY = (0, $84357ccb6d4c8548$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $84357ccb6d4c8548$export$eabcd2c8791e7bf4) || (placement === (0, $84357ccb6d4c8548$export$1e95b668f3b82d) || placement === (0, $84357ccb6d4c8548$export$40e543e69a8b3fbb)) && variation === (0, $84357ccb6d4c8548$export$bd5df0f255a350f8)) {
            sideX = (0, $84357ccb6d4c8548$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $3d64eea58ab27a42$var$unsetSides);
    var _ref4 = roundOffsets === true ? $3d64eea58ab27a42$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $becc4ee28f521e69$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $3d64eea58ab27a42$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $194a03b9f446405c$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $fe36e31b210873d9$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $3d64eea58ab27a42$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $3d64eea58ab27a42$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $3d64eea58ab27a42$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $3d64eea58ab27a42$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $29f402839a225ae6$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $288b4f28aeac3257$export$1b3bfaa9684536aa)(element) || !(0, $00bd2ce7da26be41$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $29f402839a225ae6$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $288b4f28aeac3257$export$1b3bfaa9684536aa)(element) || !(0, $00bd2ce7da26be41$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $29f402839a225ae6$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $29f402839a225ae6$var$applyStyles,
    effect: $29f402839a225ae6$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $bcd518213ce3fb76$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $194a03b9f446405c$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $84357ccb6d4c8548$export$eabcd2c8791e7bf4),
        (0, $84357ccb6d4c8548$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $84357ccb6d4c8548$export$eabcd2c8791e7bf4),
        (0, $84357ccb6d4c8548$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $bcd518213ce3fb76$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $84357ccb6d4c8548$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $bcd518213ce3fb76$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $bcd518213ce3fb76$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $bcd518213ce3fb76$var$offset
};


var $38d03ecb170adc33$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $38d03ecb170adc33$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $38d03ecb170adc33$var$hash[matched];
    });
}



var $bfbe79691448964b$var$hash = {
    start: "end",
    end: "start"
};
function $bfbe79691448964b$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $bfbe79691448964b$var$hash[matched];
    });
}







function $5db13d6ffaa2187b$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $becc4ee28f521e69$export$2e2bcd8739ae039)(element);
    var html = (0, $0ba43c19f913d28a$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $d58cafdf737e3ba9$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $29827ee0741a6cf6$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $8e7a8dce4a15a549$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0ba43c19f913d28a$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $079d3233ec0c2dde$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $6c2fbcec0a5c39a8$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $6c2fbcec0a5c39a8$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $29827ee0741a6cf6$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $ee98ef44cde3cdfb$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $6c2fbcec0a5c39a8$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $4fcbc0c0bd953a48$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $288b4f28aeac3257$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $ae2722c0e8c723c9$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $7b6268786e139960$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $892cbd7bb3672483$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $7b6268786e139960$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $84357ccb6d4c8548$export$d7b7311ec04a3e8f) ? (0, $ae2722c0e8c723c9$export$2e2bcd8739ae039)((0, $5db13d6ffaa2187b$export$2e2bcd8739ae039)(element, strategy)) : (0, $288b4f28aeac3257$export$45a5e7f76e0caa8d)(clippingParent) ? $7b6268786e139960$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $ae2722c0e8c723c9$export$2e2bcd8739ae039)((0, $8e7a8dce4a15a549$export$2e2bcd8739ae039)((0, $0ba43c19f913d28a$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $7b6268786e139960$var$getClippingParents(element) {
    var clippingParents = (0, $bb4991d78b6356a2$export$2e2bcd8739ae039)((0, $5138f277baf36c69$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $ee98ef44cde3cdfb$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $288b4f28aeac3257$export$1b3bfaa9684536aa)(element) ? (0, $89ab075476fedee0$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $288b4f28aeac3257$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $288b4f28aeac3257$export$45a5e7f76e0caa8d)(clippingParent) && (0, $4fcbc0c0bd953a48$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $00bd2ce7da26be41$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $7b6268786e139960$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $7b6268786e139960$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $7b6268786e139960$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $6c2fbcec0a5c39a8$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $6c2fbcec0a5c39a8$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $6c2fbcec0a5c39a8$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $6c2fbcec0a5c39a8$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $7b6268786e139960$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $6f2e7eeda21675ba$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $a6fc9303fc46d059$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $6f2e7eeda21675ba$export$2e2bcd8739ae039)(), paddingObject);
}


function $485151362bc3d468$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $a7b13e71df35089a$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $84357ccb6d4c8548$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $84357ccb6d4c8548$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $84357ccb6d4c8548$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $a6fc9303fc46d059$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $485151362bc3d468$export$2e2bcd8739ae039)(padding, (0, $84357ccb6d4c8548$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $84357ccb6d4c8548$export$ae5ab1c730825774) ? (0, $84357ccb6d4c8548$export$ca50aac9f3ba507f) : (0, $84357ccb6d4c8548$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $7b6268786e139960$export$2e2bcd8739ae039)((0, $288b4f28aeac3257$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0ba43c19f913d28a$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $892cbd7bb3672483$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $793e21da71dba97f$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $ae2722c0e8c723c9$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $84357ccb6d4c8548$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $84357ccb6d4c8548$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $84357ccb6d4c8548$export$79ffe56a765070d2),
                (0, $84357ccb6d4c8548$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $84357ccb6d4c8548$export$1e95b668f3b82d),
                (0, $84357ccb6d4c8548$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $4969171fb4fc67b4$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $84357ccb6d4c8548$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $fe36e31b210873d9$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $84357ccb6d4c8548$export$368f9a87e87fa4e1) : (0, $84357ccb6d4c8548$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $fe36e31b210873d9$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $84357ccb6d4c8548$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $a7b13e71df35089a$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $194a03b9f446405c$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $7140db9ee0800447$var$getExpandedFallbackPlacements(placement) {
    if ((0, $194a03b9f446405c$export$2e2bcd8739ae039)(placement) === (0, $84357ccb6d4c8548$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $38d03ecb170adc33$export$2e2bcd8739ae039)(placement);
    return [
        (0, $bfbe79691448964b$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $bfbe79691448964b$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $7140db9ee0800447$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $194a03b9f446405c$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $38d03ecb170adc33$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $7140db9ee0800447$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $194a03b9f446405c$export$2e2bcd8739ae039)(placement) === (0, $84357ccb6d4c8548$export$dfb5619354ba860) ? (0, $4969171fb4fc67b4$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $194a03b9f446405c$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $fe36e31b210873d9$export$2e2bcd8739ae039)(placement) === (0, $84357ccb6d4c8548$export$b3571188c770cc5a);
        var isVertical = [
            (0, $84357ccb6d4c8548$export$1e95b668f3b82d),
            (0, $84357ccb6d4c8548$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $a7b13e71df35089a$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $84357ccb6d4c8548$export$79ffe56a765070d2) : (0, $84357ccb6d4c8548$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $84357ccb6d4c8548$export$40e543e69a8b3fbb) : (0, $84357ccb6d4c8548$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $38d03ecb170adc33$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $38d03ecb170adc33$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $7140db9ee0800447$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $7140db9ee0800447$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $b65032ad2cae8652$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $162ecb468ad54e87$export$f28d906d67a997f3(min, value, max) {
    return (0, $6c2fbcec0a5c39a8$export$8960430cfd85939f)(min, (0, $6c2fbcec0a5c39a8$export$96ec731ed4dcb222)(value, max));
}
function $162ecb468ad54e87$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $162ecb468ad54e87$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $b014e28e6c5b6170$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $a7b13e71df35089a$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $194a03b9f446405c$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $fe36e31b210873d9$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $7397b4d86a251602$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $b65032ad2cae8652$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $84357ccb6d4c8548$export$1e95b668f3b82d) : (0, $84357ccb6d4c8548$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $84357ccb6d4c8548$export$40e543e69a8b3fbb) : (0, $84357ccb6d4c8548$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $84357ccb6d4c8548$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $84357ccb6d4c8548$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $32131b74da817c54$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $6f2e7eeda21675ba$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $162ecb468ad54e87$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $89ab075476fedee0$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $162ecb468ad54e87$export$f28d906d67a997f3)(tether ? (0, $6c2fbcec0a5c39a8$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $6c2fbcec0a5c39a8$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $84357ccb6d4c8548$export$1e95b668f3b82d) : (0, $84357ccb6d4c8548$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $84357ccb6d4c8548$export$40e543e69a8b3fbb) : (0, $84357ccb6d4c8548$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $84357ccb6d4c8548$export$1e95b668f3b82d),
            (0, $84357ccb6d4c8548$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $162ecb468ad54e87$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $162ecb468ad54e87$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $b014e28e6c5b6170$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $b014e28e6c5b6170$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $6e400d2b6a3c92f3$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $a6fc9303fc46d059$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $485151362bc3d468$export$2e2bcd8739ae039)(padding, (0, $84357ccb6d4c8548$export$aec2ce47c367b8c3)));
};
function $6e400d2b6a3c92f3$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $194a03b9f446405c$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $7397b4d86a251602$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $84357ccb6d4c8548$export$eabcd2c8791e7bf4),
        (0, $84357ccb6d4c8548$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $6e400d2b6a3c92f3$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $32131b74da817c54$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $84357ccb6d4c8548$export$1e95b668f3b82d) : (0, $84357ccb6d4c8548$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $84357ccb6d4c8548$export$40e543e69a8b3fbb) : (0, $84357ccb6d4c8548$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $89ab075476fedee0$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $162ecb468ad54e87$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $6e400d2b6a3c92f3$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $4fcbc0c0bd953a48$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $6e400d2b6a3c92f3$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $6e400d2b6a3c92f3$var$arrow,
    effect: $6e400d2b6a3c92f3$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $bc59d63674ebbf9d$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $bc59d63674ebbf9d$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $84357ccb6d4c8548$export$1e95b668f3b82d),
        (0, $84357ccb6d4c8548$export$79ffe56a765070d2),
        (0, $84357ccb6d4c8548$export$40e543e69a8b3fbb),
        (0, $84357ccb6d4c8548$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $bc59d63674ebbf9d$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $a7b13e71df35089a$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $a7b13e71df35089a$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $bc59d63674ebbf9d$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $bc59d63674ebbf9d$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $bc59d63674ebbf9d$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $bc59d63674ebbf9d$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $bc59d63674ebbf9d$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $bc59d63674ebbf9d$var$hide
};




var $046b93e3cd9c42d1$export$d34966752335dd47 = [
    (0, $b3f6d5b843880420$export$2e2bcd8739ae039),
    (0, $300a3a8a966e63cb$export$2e2bcd8739ae039),
    (0, $3d64eea58ab27a42$export$2e2bcd8739ae039),
    (0, $29f402839a225ae6$export$2e2bcd8739ae039),
    (0, $bcd518213ce3fb76$export$2e2bcd8739ae039),
    (0, $7140db9ee0800447$export$2e2bcd8739ae039),
    (0, $b014e28e6c5b6170$export$2e2bcd8739ae039),
    (0, $6e400d2b6a3c92f3$export$2e2bcd8739ae039),
    (0, $bc59d63674ebbf9d$export$2e2bcd8739ae039)
];
var $046b93e3cd9c42d1$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $b3850ced1ba808ef$export$ed5e13716264f202)({
    defaultModifiers: $046b93e3cd9c42d1$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules



var $8v0nu = parcelRequire("8v0nu");
"use client";
const $d220822e16a1bad8$var$toVar = (value, fallback)=>({
        var: value,
        varRef: fallback ? `var(${value}, ${fallback})` : `var(${value})`
    });
const $d220822e16a1bad8$export$fd62969fb0b7081c = {
    arrowShadowColor: $d220822e16a1bad8$var$toVar("--popper-arrow-shadow-color"),
    arrowSize: $d220822e16a1bad8$var$toVar("--popper-arrow-size", "8px"),
    arrowSizeHalf: $d220822e16a1bad8$var$toVar("--popper-arrow-size-half"),
    arrowBg: $d220822e16a1bad8$var$toVar("--popper-arrow-bg"),
    transformOrigin: $d220822e16a1bad8$var$toVar("--popper-transform-origin"),
    arrowOffset: $d220822e16a1bad8$var$toVar("--popper-arrow-offset")
};
function $d220822e16a1bad8$export$bba5a971afe05444(placement) {
    if (placement.includes("top")) return `1px 1px 0px 0 var(--popper-arrow-shadow-color)`;
    if (placement.includes("bottom")) return `-1px -1px 0px 0 var(--popper-arrow-shadow-color)`;
    if (placement.includes("right")) return `-1px 1px 0px 0 var(--popper-arrow-shadow-color)`;
    if (placement.includes("left")) return `1px -1px 0px 0 var(--popper-arrow-shadow-color)`;
}
const $d220822e16a1bad8$var$transforms = {
    top: "bottom center",
    "top-start": "bottom left",
    "top-end": "bottom right",
    bottom: "top center",
    "bottom-start": "top left",
    "bottom-end": "top right",
    left: "right center",
    "left-start": "right top",
    "left-end": "right bottom",
    right: "left center",
    "right-start": "left top",
    "right-end": "left bottom"
};
const $d220822e16a1bad8$export$4b94194e48e4ec29 = (placement)=>$d220822e16a1bad8$var$transforms[placement];
const $d220822e16a1bad8$var$defaultEventListeners = {
    scroll: true,
    resize: true
};
function $d220822e16a1bad8$export$fafd30a196ad8838(value) {
    let eventListeners;
    if (typeof value === "object") eventListeners = {
        enabled: true,
        options: {
            ...$d220822e16a1bad8$var$defaultEventListeners,
            ...value
        }
    };
    else eventListeners = {
        enabled: value,
        options: $d220822e16a1bad8$var$defaultEventListeners
    };
    return eventListeners;
}


"use client";
const $3249a6942cbdc467$export$45d38cc6268103c7 = {
    name: "matchWidth",
    enabled: true,
    phase: "beforeWrite",
    requires: [
        "computeStyles"
    ],
    fn: ({ state: state })=>{
        state.styles.popper.width = `${state.rects.reference.width}px`;
    },
    effect: ({ state: state })=>()=>{
            const reference = state.elements.reference;
            state.elements.popper.style.width = `${reference.offsetWidth}px`;
        }
};
const $3249a6942cbdc467$export$bd7bb1bc943e0611 = {
    name: "transformOrigin",
    enabled: true,
    phase: "write",
    fn: ({ state: state })=>{
        $3249a6942cbdc467$var$setTransformOrigin(state);
    },
    effect: ({ state: state })=>()=>{
            $3249a6942cbdc467$var$setTransformOrigin(state);
        }
};
const $3249a6942cbdc467$var$setTransformOrigin = (state)=>{
    state.elements.popper.style.setProperty((0, $d220822e16a1bad8$export$fd62969fb0b7081c).transformOrigin.var, (0, $d220822e16a1bad8$export$4b94194e48e4ec29)(state.placement));
};
const $3249a6942cbdc467$export$36f2614d91c73bb6 = {
    name: "positionArrow",
    enabled: true,
    phase: "afterWrite",
    fn: ({ state: state })=>{
        $3249a6942cbdc467$var$setArrowStyles(state);
    }
};
const $3249a6942cbdc467$var$setArrowStyles = (state)=>{
    if (!state.placement) return;
    const overrides = $3249a6942cbdc467$var$getArrowStyle(state.placement);
    if (state.elements?.arrow && overrides) {
        Object.assign(state.elements.arrow.style, {
            [overrides.property]: overrides.value,
            width: (0, $d220822e16a1bad8$export$fd62969fb0b7081c).arrowSize.varRef,
            height: (0, $d220822e16a1bad8$export$fd62969fb0b7081c).arrowSize.varRef,
            zIndex: -1
        });
        const vars = {
            [(0, $d220822e16a1bad8$export$fd62969fb0b7081c).arrowSizeHalf.var]: `calc(${(0, $d220822e16a1bad8$export$fd62969fb0b7081c).arrowSize.varRef} / 2 - 1px)`,
            [(0, $d220822e16a1bad8$export$fd62969fb0b7081c).arrowOffset.var]: `calc(${(0, $d220822e16a1bad8$export$fd62969fb0b7081c).arrowSizeHalf.varRef} * -1)`
        };
        for(const property in vars)state.elements.arrow.style.setProperty(property, vars[property]);
    }
};
const $3249a6942cbdc467$var$getArrowStyle = (placement)=>{
    if (placement.startsWith("top")) return {
        property: "bottom",
        value: (0, $d220822e16a1bad8$export$fd62969fb0b7081c).arrowOffset.varRef
    };
    if (placement.startsWith("bottom")) return {
        property: "top",
        value: (0, $d220822e16a1bad8$export$fd62969fb0b7081c).arrowOffset.varRef
    };
    if (placement.startsWith("left")) return {
        property: "right",
        value: (0, $d220822e16a1bad8$export$fd62969fb0b7081c).arrowOffset.varRef
    };
    if (placement.startsWith("right")) return {
        property: "left",
        value: (0, $d220822e16a1bad8$export$fd62969fb0b7081c).arrowOffset.varRef
    };
};
const $3249a6942cbdc467$export$616f7fc4ffce8510 = {
    name: "innerArrow",
    enabled: true,
    phase: "main",
    requires: [
        "arrow"
    ],
    fn: ({ state: state })=>{
        $3249a6942cbdc467$var$setInnerArrowStyles(state);
    },
    effect: ({ state: state })=>()=>{
            $3249a6942cbdc467$var$setInnerArrowStyles(state);
        }
};
const $3249a6942cbdc467$var$setInnerArrowStyles = (state)=>{
    if (!state.elements.arrow) return;
    const inner = state.elements.arrow.querySelector("[data-popper-arrow-inner]");
    if (!inner) return;
    const boxShadow = (0, $d220822e16a1bad8$export$bba5a971afe05444)(state.placement);
    if (boxShadow) inner.style.setProperty("--popper-arrow-default-shadow", boxShadow);
    Object.assign(inner.style, {
        transform: "rotate(45deg)",
        background: (0, $d220822e16a1bad8$export$fd62969fb0b7081c).arrowBg.varRef,
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        position: "absolute",
        zIndex: "inherit",
        boxShadow: `var(--popper-arrow-shadow, var(--popper-arrow-default-shadow))`
    });
};


"use client";
const $d55589f82f3c0030$var$logicals = {
    "start-start": {
        ltr: "left-start",
        rtl: "right-start"
    },
    "start-end": {
        ltr: "left-end",
        rtl: "right-end"
    },
    "end-start": {
        ltr: "right-start",
        rtl: "left-start"
    },
    "end-end": {
        ltr: "right-end",
        rtl: "left-end"
    },
    start: {
        ltr: "left",
        rtl: "right"
    },
    end: {
        ltr: "right",
        rtl: "left"
    }
};
const $d55589f82f3c0030$var$opposites = {
    "auto-start": "auto-end",
    "auto-end": "auto-start",
    "top-start": "top-end",
    "top-end": "top-start",
    "bottom-start": "bottom-end",
    "bottom-end": "bottom-start"
};
function $d55589f82f3c0030$export$833b022d5a236f09(placement, dir = "ltr") {
    const value = $d55589f82f3c0030$var$logicals[placement]?.[dir] || placement;
    if (dir === "ltr") return value;
    return $d55589f82f3c0030$var$opposites[placement] ?? value;
}



"use client";
function $e7e710a1f1f06f28$export$f4d5bf230a36dd6e(props = {}) {
    const { enabled: enabled = true, modifiers: modifiers, placement: placementProp = "bottom", strategy: strategy = "absolute", arrowPadding: arrowPadding = 8, eventListeners: eventListeners = true, offset: offset, gutter: gutter = 8, flip: flip = true, boundary: boundary = "clippingParents", preventOverflow: preventOverflow = true, matchWidth: matchWidth$1, direction: direction = "ltr" } = props;
    const reference = (0, $8v0nu.useRef)(null);
    const popper = (0, $8v0nu.useRef)(null);
    const instance = (0, $8v0nu.useRef)(null);
    const placement = (0, $d55589f82f3c0030$export$833b022d5a236f09)(placementProp, direction);
    const cleanup = (0, $8v0nu.useRef)(()=>{});
    const setupPopper = (0, $8v0nu.useCallback)(()=>{
        if (!enabled || !reference.current || !popper.current) return;
        cleanup.current?.();
        instance.current = (0, $046b93e3cd9c42d1$export$8f7491d57c8f97a9)(reference.current, popper.current, {
            placement: placement,
            modifiers: [
                (0, $3249a6942cbdc467$export$616f7fc4ffce8510),
                (0, $3249a6942cbdc467$export$36f2614d91c73bb6),
                (0, $3249a6942cbdc467$export$bd7bb1bc943e0611),
                {
                    ...(0, $3249a6942cbdc467$export$45d38cc6268103c7),
                    enabled: !!matchWidth$1
                },
                {
                    name: "eventListeners",
                    ...(0, $d220822e16a1bad8$export$fafd30a196ad8838)(eventListeners)
                },
                {
                    name: "arrow",
                    options: {
                        padding: arrowPadding
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: offset ?? [
                            0,
                            gutter
                        ]
                    }
                },
                {
                    name: "flip",
                    enabled: !!flip,
                    options: {
                        padding: 8
                    }
                },
                {
                    name: "preventOverflow",
                    enabled: !!preventOverflow,
                    options: {
                        boundary: boundary
                    }
                },
                // allow users override internal modifiers
                ...modifiers ?? []
            ],
            strategy: strategy
        });
        instance.current.forceUpdate();
        cleanup.current = instance.current.destroy;
    }, [
        placement,
        enabled,
        modifiers,
        matchWidth$1,
        eventListeners,
        arrowPadding,
        offset,
        gutter,
        flip,
        preventOverflow,
        boundary,
        strategy
    ]);
    (0, $8v0nu.useEffect)(()=>{
        return ()=>{
            if (!reference.current && !popper.current) {
                instance.current?.destroy();
                instance.current = null;
            }
        };
    }, []);
    const referenceRef = (0, $8v0nu.useCallback)((node)=>{
        reference.current = node;
        setupPopper();
    }, [
        setupPopper
    ]);
    const getReferenceProps = (0, $8v0nu.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            ref: (0, $95f7db4ddbf3eda0$export$c9058316764c140e)(referenceRef, ref)
        }), [
        referenceRef
    ]);
    const popperRef = (0, $8v0nu.useCallback)((node)=>{
        popper.current = node;
        setupPopper();
    }, [
        setupPopper
    ]);
    const getPopperProps = (0, $8v0nu.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            ref: (0, $95f7db4ddbf3eda0$export$c9058316764c140e)(popperRef, ref),
            style: {
                ...props2.style,
                position: strategy,
                minWidth: matchWidth$1 ? void 0 : "max-content",
                inset: "0 auto auto 0"
            }
        }), [
        strategy,
        popperRef,
        matchWidth$1
    ]);
    const getArrowProps = (0, $8v0nu.useCallback)((props2 = {}, ref = null)=>{
        const { size: size, shadowColor: shadowColor, bg: bg, style: style, ...rest } = props2;
        return {
            ...rest,
            ref: ref,
            "data-popper-arrow": "",
            style: $e7e710a1f1f06f28$var$getArrowStyle(props2)
        };
    }, []);
    const getArrowInnerProps = (0, $8v0nu.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            ref: ref,
            "data-popper-arrow-inner": ""
        }), []);
    return {
        update () {
            instance.current?.update();
        },
        forceUpdate () {
            instance.current?.forceUpdate();
        },
        transformOrigin: (0, $d220822e16a1bad8$export$fd62969fb0b7081c).transformOrigin.varRef,
        referenceRef: referenceRef,
        popperRef: popperRef,
        getPopperProps: getPopperProps,
        getArrowProps: getArrowProps,
        getArrowInnerProps: getArrowInnerProps,
        getReferenceProps: getReferenceProps
    };
}
function $e7e710a1f1f06f28$var$getArrowStyle(props) {
    const { size: size, shadowColor: shadowColor, bg: bg, style: style } = props;
    const computedStyle = {
        ...style,
        position: "absolute"
    };
    if (size) computedStyle["--popper-arrow-size"] = size;
    if (shadowColor) computedStyle["--popper-arrow-shadow-color"] = shadowColor;
    if (bg) computedStyle["--popper-arrow-bg"] = bg;
    return computedStyle;
}





var $8v0nu = parcelRequire("8v0nu");

var $8v0nu = parcelRequire("8v0nu");
"use client";
function $d959f2902998ddbe$export$43d26308f6d75a57() {
    const listeners = (0, $8v0nu.useRef)(/* @__PURE__ */ new Map());
    const currentListeners = listeners.current;
    const add = (0, $8v0nu.useCallback)((el, type, listener, options)=>{
        listeners.current.set(listener, {
            type: type,
            el: el,
            options: options
        });
        el.addEventListener(type, listener, options);
    }, []);
    const remove = (0, $8v0nu.useCallback)((el, type, listener, options)=>{
        el.removeEventListener(type, listener, options);
        listeners.current.delete(listener);
    }, []);
    (0, $8v0nu.useEffect)(()=>()=>{
            currentListeners.forEach((value, key)=>{
                remove(value.el, value.type, key, value.options);
            });
        }, [
        remove,
        currentListeners
    ]);
    return {
        add: add,
        remove: remove
    };
}


"use client";
function $d3555d79611ee58d$var$isValidElement(event) {
    const target = event.composedPath?.()?.[0] ?? event.target;
    const { tagName: tagName, isContentEditable: isContentEditable } = target;
    return tagName !== "INPUT" && tagName !== "TEXTAREA" && isContentEditable !== true;
}
function $d3555d79611ee58d$export$ed213cc82e426b1a(props = {}) {
    const { ref: htmlRef, isDisabled: isDisabled, isFocusable: isFocusable, clickOnEnter: clickOnEnter = true, clickOnSpace: clickOnSpace = true, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, tabIndex: tabIndexProp, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave, ...htmlProps } = props;
    const [isButton, setIsButton] = (0, $8v0nu.useState)(true);
    const [isPressed, setIsPressed] = (0, $8v0nu.useState)(false);
    const listeners = (0, $d959f2902998ddbe$export$43d26308f6d75a57)();
    const refCallback = (node)=>{
        if (!node) return;
        if (node.tagName !== "BUTTON") setIsButton(false);
    };
    const tabIndex = isButton ? tabIndexProp : tabIndexProp || 0;
    const trulyDisabled = isDisabled && !isFocusable;
    const handleClick = (0, $8v0nu.useCallback)((event)=>{
        if (isDisabled) {
            event.stopPropagation();
            event.preventDefault();
            return;
        }
        const self = event.currentTarget;
        self.focus();
        onClick?.(event);
    }, [
        isDisabled,
        onClick
    ]);
    const onDocumentKeyUp = (0, $8v0nu.useCallback)((e)=>{
        if (isPressed && $d3555d79611ee58d$var$isValidElement(e)) {
            e.preventDefault();
            e.stopPropagation();
            setIsPressed(false);
            listeners.remove(document, "keyup", onDocumentKeyUp, false);
        }
    }, [
        isPressed,
        listeners
    ]);
    const handleKeyDown = (0, $8v0nu.useCallback)((event)=>{
        onKeyDown?.(event);
        if (isDisabled || event.defaultPrevented || event.metaKey) return;
        if (!$d3555d79611ee58d$var$isValidElement(event.nativeEvent) || isButton) return;
        const shouldClickOnEnter = clickOnEnter && event.key === "Enter";
        const shouldClickOnSpace = clickOnSpace && event.key === " ";
        if (shouldClickOnSpace) {
            event.preventDefault();
            setIsPressed(true);
        }
        if (shouldClickOnEnter) {
            event.preventDefault();
            const self = event.currentTarget;
            self.click();
        }
        listeners.add(document, "keyup", onDocumentKeyUp, false);
    }, [
        isDisabled,
        isButton,
        onKeyDown,
        clickOnEnter,
        clickOnSpace,
        listeners,
        onDocumentKeyUp
    ]);
    const handleKeyUp = (0, $8v0nu.useCallback)((event)=>{
        onKeyUp?.(event);
        if (isDisabled || event.defaultPrevented || event.metaKey) return;
        if (!$d3555d79611ee58d$var$isValidElement(event.nativeEvent) || isButton) return;
        const shouldClickOnSpace = clickOnSpace && event.key === " ";
        if (shouldClickOnSpace) {
            event.preventDefault();
            setIsPressed(false);
            const self = event.currentTarget;
            self.click();
        }
    }, [
        clickOnSpace,
        isButton,
        isDisabled,
        onKeyUp
    ]);
    const onDocumentMouseUp = (0, $8v0nu.useCallback)((event)=>{
        if (event.button !== 0) return;
        setIsPressed(false);
        listeners.remove(document, "mouseup", onDocumentMouseUp, false);
    }, [
        listeners
    ]);
    const handleMouseDown = (0, $8v0nu.useCallback)((event)=>{
        if (event.button !== 0) return;
        if (isDisabled) {
            event.stopPropagation();
            event.preventDefault();
            return;
        }
        if (!isButton) setIsPressed(true);
        const target = event.currentTarget;
        target.focus({
            preventScroll: true
        });
        listeners.add(document, "mouseup", onDocumentMouseUp, false);
        onMouseDown?.(event);
    }, [
        isDisabled,
        isButton,
        onMouseDown,
        listeners,
        onDocumentMouseUp
    ]);
    const handleMouseUp = (0, $8v0nu.useCallback)((event)=>{
        if (event.button !== 0) return;
        if (!isButton) setIsPressed(false);
        onMouseUp?.(event);
    }, [
        onMouseUp,
        isButton
    ]);
    const handleMouseOver = (0, $8v0nu.useCallback)((event)=>{
        if (isDisabled) {
            event.preventDefault();
            return;
        }
        onMouseOver?.(event);
    }, [
        isDisabled,
        onMouseOver
    ]);
    const handleMouseLeave = (0, $8v0nu.useCallback)((event)=>{
        if (isPressed) {
            event.preventDefault();
            setIsPressed(false);
        }
        onMouseLeave?.(event);
    }, [
        isPressed,
        onMouseLeave
    ]);
    const ref = (0, $95f7db4ddbf3eda0$export$c9058316764c140e)(htmlRef, refCallback);
    if (isButton) return {
        ...htmlProps,
        ref: ref,
        type: "button",
        "aria-disabled": trulyDisabled ? void 0 : isDisabled,
        disabled: trulyDisabled,
        onClick: handleClick,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyUp: onKeyUp,
        onKeyDown: onKeyDown,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
    };
    return {
        ...htmlProps,
        ref: ref,
        role: "button",
        "data-active": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isPressed),
        "aria-disabled": isDisabled ? "true" : void 0,
        tabIndex: trulyDisabled ? void 0 : tabIndex,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onMouseUp: handleMouseUp,
        onKeyUp: handleKeyUp,
        onKeyDown: handleKeyDown,
        onMouseOver: handleMouseOver,
        onMouseLeave: handleMouseLeave
    };
}


"use client";
const [$e1536a6b8ce0ec15$export$6bd12c048acae948, $e1536a6b8ce0ec15$export$fb081774625c317c, $e1536a6b8ce0ec15$export$c383d7d91778257e, $e1536a6b8ce0ec15$export$e44adeffd1a0865c] = (0, $351cee6c59f3b060$export$126c4100f8947d7)();
const [$e1536a6b8ce0ec15$export$62b22d151866115d, $e1536a6b8ce0ec15$export$21c7ab35b39f78ec] = (0, $3473b2b1e3b906ba$export$fd42f52fd3ae1109)({
    strict: false,
    name: "MenuContext"
});
function $e1536a6b8ce0ec15$var$getOwnerDocument(node) {
    return node?.ownerDocument ?? document;
}
function $e1536a6b8ce0ec15$var$isActiveElement(element) {
    const doc = $e1536a6b8ce0ec15$var$getOwnerDocument(element);
    return doc.activeElement === element;
}
function $e1536a6b8ce0ec15$export$38eaa17faae8f579(props = {}) {
    const { id: id, closeOnSelect: closeOnSelect = true, closeOnBlur: closeOnBlur = true, initialFocusRef: initialFocusRef, autoSelect: autoSelect = true, isLazy: isLazy, isOpen: isOpenProp, defaultIsOpen: defaultIsOpen, onClose: onCloseProp, onOpen: onOpenProp, placement: placement = "bottom-start", lazyBehavior: lazyBehavior = "unmount", direction: direction, computePositionOnMount: computePositionOnMount = false, ...popperProps } = props;
    const menuRef = (0, $8v0nu.useRef)(null);
    const buttonRef = (0, $8v0nu.useRef)(null);
    const scrollIntoViewRef = (0, $8v0nu.useRef)(true);
    const descendants = $e1536a6b8ce0ec15$export$c383d7d91778257e();
    const focusMenu = (0, $8v0nu.useCallback)(()=>{
        requestAnimationFrame(()=>{
            menuRef.current?.focus({
                preventScroll: false
            });
        });
    }, []);
    const focusFirstItem = (0, $8v0nu.useCallback)(()=>{
        const id2 = setTimeout(()=>{
            if (initialFocusRef) initialFocusRef.current?.focus();
            else if (!descendants.count()) menuRef.current?.focus({
                preventScroll: false
            });
            else {
                const first = descendants.firstEnabled();
                if (first) setFocusedIndex(first.index);
            }
        });
        timeoutIds.current.add(id2);
    }, [
        descendants,
        initialFocusRef
    ]);
    const focusLastItem = (0, $8v0nu.useCallback)(()=>{
        const id2 = setTimeout(()=>{
            if (!descendants.count()) menuRef.current?.focus({
                preventScroll: false
            });
            else {
                const last = descendants.lastEnabled();
                if (last) setFocusedIndex(last.index);
            }
        });
        timeoutIds.current.add(id2);
    }, [
        descendants
    ]);
    const onOpenInternal = (0, $8v0nu.useCallback)(()=>{
        onOpenProp?.();
        if (autoSelect) focusFirstItem();
        else focusMenu();
    }, [
        autoSelect,
        focusFirstItem,
        focusMenu,
        onOpenProp
    ]);
    const { isOpen: isOpen, onOpen: onOpen, onClose: onClose, onToggle: onToggle } = (0, $cc3982b77d606367$export$6e3e27031a30522f)({
        isOpen: isOpenProp,
        defaultIsOpen: defaultIsOpen,
        onClose: onCloseProp,
        onOpen: onOpenInternal
    });
    (0, $313dea541a92f272$export$71b2224f1ce5e08e)({
        enabled: isOpen && closeOnBlur,
        ref: menuRef,
        handler: (event)=>{
            const target = event.composedPath?.()?.[0] ?? event.target;
            if (!buttonRef.current?.contains(target)) onClose();
        }
    });
    const popper = (0, $e7e710a1f1f06f28$export$f4d5bf230a36dd6e)({
        ...popperProps,
        enabled: isOpen || computePositionOnMount,
        placement: placement,
        direction: direction
    });
    const [focusedIndex, setFocusedIndex] = (0, $8v0nu.useState)(-1);
    (0, $6c3b109dd1e78e88$export$68b323438c1fbb28)(menuRef, {
        focusRef: buttonRef,
        visible: isOpen,
        shouldFocus: true
    });
    const animationState = (0, $f7cea9053f03399a$export$7ee548861327febe)({
        isOpen: isOpen,
        ref: menuRef
    });
    const [buttonId, menuId] = (0, $9d8f051d0eee816d$export$365c04e2f432779)(id, `menu-button`, `menu-list`);
    const openAndFocusMenu = (0, $8v0nu.useCallback)(()=>{
        onOpen();
        focusMenu();
    }, [
        onOpen,
        focusMenu
    ]);
    const timeoutIds = (0, $8v0nu.useRef)(/* @__PURE__ */ new Set([]));
    (0, $8v0nu.useEffect)(()=>{
        const ids = timeoutIds.current;
        return ()=>{
            ids.forEach((id2)=>clearTimeout(id2));
            ids.clear();
        };
    }, []);
    (0, $9fe29ceca799989a$export$496315a1608d9602)(()=>{
        if (isOpen) return;
        setFocusedIndex(-1);
        menuRef.current?.scrollTo(0, 0);
    }, [
        isOpen
    ]);
    (0, $9fe29ceca799989a$export$496315a1608d9602)(()=>{
        if (!isOpen) return;
        if (focusedIndex === -1) focusMenu();
    }, [
        focusedIndex,
        isOpen
    ]);
    (0, $8v0nu.useEffect)(()=>{
        if (!isOpen) return;
        const item = descendants.item(focusedIndex);
        item?.node?.focus({
            preventScroll: !scrollIntoViewRef.current
        });
    }, [
        descendants,
        focusedIndex,
        isOpen
    ]);
    const openAndFocusFirstItem = (0, $8v0nu.useCallback)(()=>{
        onOpen();
        focusFirstItem();
    }, [
        focusFirstItem,
        onOpen
    ]);
    const openAndFocusLastItem = (0, $8v0nu.useCallback)(()=>{
        scrollIntoViewRef.current = true;
        onOpen();
        focusLastItem();
    }, [
        onOpen,
        focusLastItem
    ]);
    const refocus = (0, $8v0nu.useCallback)(()=>{
        const doc = $e1536a6b8ce0ec15$var$getOwnerDocument(menuRef.current);
        const hasFocusWithin = menuRef.current?.contains(doc.activeElement);
        const shouldRefocus = isOpen && !hasFocusWithin;
        if (!shouldRefocus) return;
        const node = descendants.item(focusedIndex)?.node;
        node?.focus({
            preventScroll: !scrollIntoViewRef.current
        });
    }, [
        isOpen,
        focusedIndex,
        descendants
    ]);
    return {
        openAndFocusMenu: openAndFocusMenu,
        openAndFocusFirstItem: openAndFocusFirstItem,
        openAndFocusLastItem: openAndFocusLastItem,
        onTransitionEnd: refocus,
        unstable__animationState: animationState,
        descendants: descendants,
        popper: popper,
        buttonId: buttonId,
        menuId: menuId,
        forceUpdate: popper.forceUpdate,
        orientation: "vertical",
        isOpen: isOpen,
        onToggle: onToggle,
        onOpen: onOpen,
        onClose: onClose,
        menuRef: menuRef,
        buttonRef: buttonRef,
        focusedIndex: focusedIndex,
        closeOnSelect: closeOnSelect,
        closeOnBlur: closeOnBlur,
        autoSelect: autoSelect,
        setFocusedIndex: setFocusedIndex,
        isLazy: isLazy,
        lazyBehavior: lazyBehavior,
        initialFocusRef: initialFocusRef,
        scrollIntoViewRef: scrollIntoViewRef
    };
}
function $e1536a6b8ce0ec15$export$660510f872408795(props = {}, externalRef = null) {
    const menu = $e1536a6b8ce0ec15$export$21c7ab35b39f78ec();
    const { onToggle: onToggle, popper: popper, openAndFocusFirstItem: openAndFocusFirstItem, openAndFocusLastItem: openAndFocusLastItem, scrollIntoViewRef: scrollIntoViewRef } = menu;
    const onKeyDown = (0, $8v0nu.useCallback)((event)=>{
        const eventKey = event.key;
        const keyMap = {
            Enter: openAndFocusFirstItem,
            ArrowDown: openAndFocusFirstItem,
            ArrowUp: openAndFocusLastItem
        };
        const action = keyMap[eventKey];
        if (action) {
            scrollIntoViewRef.current = true;
            event.preventDefault();
            event.stopPropagation();
            action(event);
        }
    }, [
        openAndFocusFirstItem,
        openAndFocusLastItem,
        scrollIntoViewRef
    ]);
    return {
        ...props,
        ref: (0, $95f7db4ddbf3eda0$export$c9058316764c140e)(menu.buttonRef, externalRef, popper.referenceRef),
        id: menu.buttonId,
        "data-active": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(menu.isOpen),
        "aria-expanded": menu.isOpen,
        "aria-haspopup": "menu",
        "aria-controls": menu.menuId,
        onClick: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props.onClick, onToggle),
        onKeyDown: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props.onKeyDown, onKeyDown)
    };
}
function $e1536a6b8ce0ec15$var$isTargetMenuItem(target) {
    return $e1536a6b8ce0ec15$var$isHTMLElement(target) && !!target?.getAttribute("role")?.startsWith("menuitem");
}
function $e1536a6b8ce0ec15$export$8dcac42583be8292(props = {}, ref = null) {
    const menu = $e1536a6b8ce0ec15$export$21c7ab35b39f78ec();
    if (!menu) throw new Error(`useMenuContext: context is undefined. Seems you forgot to wrap component within <Menu>`);
    const { focusedIndex: focusedIndex, setFocusedIndex: setFocusedIndex, menuRef: menuRef, isOpen: isOpen, onClose: onClose, menuId: menuId, isLazy: isLazy, lazyBehavior: lazyBehavior, scrollIntoViewRef: scrollIntoViewRef, unstable__animationState: animated } = menu;
    const descendants = $e1536a6b8ce0ec15$export$fb081774625c317c();
    const createTypeaheadHandler = (0, $8017fa62fdefcad3$export$b0ebbe7904d8d94a)({
        preventDefault: (event)=>event.key !== " " && $e1536a6b8ce0ec15$var$isTargetMenuItem(event.target)
    });
    const onKeyDown = (0, $8v0nu.useCallback)((event)=>{
        if (!event.currentTarget.contains(event.target)) return;
        const eventKey = event.key;
        const keyMap = {
            Tab: (event2)=>event2.preventDefault(),
            Escape: (event2)=>{
                event2.stopPropagation();
                onClose();
            },
            ArrowDown: ()=>{
                scrollIntoViewRef.current = true;
                const next = descendants.nextEnabled(focusedIndex) ?? descendants.firstEnabled();
                if (next) setFocusedIndex(next.index);
            },
            ArrowUp: ()=>{
                scrollIntoViewRef.current = true;
                const prev = descendants.prevEnabled(focusedIndex) ?? descendants.firstEnabled();
                if (prev) setFocusedIndex(prev.index);
            }
        };
        const fn = keyMap[eventKey];
        if (fn) {
            event.preventDefault();
            fn(event);
            return;
        }
        const onTypeahead = createTypeaheadHandler((character)=>{
            const nextItem = (0, $c051f3d33780cc4c$export$18ed781d9da46f95)(descendants.values(), character, (item)=>item?.node?.textContent ?? "", descendants.item(focusedIndex));
            if (nextItem) {
                const index = descendants.indexOf(nextItem.node);
                setFocusedIndex(index);
            }
        });
        if ($e1536a6b8ce0ec15$var$isTargetMenuItem(event.target)) onTypeahead(event);
    }, [
        descendants,
        focusedIndex,
        createTypeaheadHandler,
        onClose,
        setFocusedIndex,
        scrollIntoViewRef
    ]);
    const hasBeenOpened = (0, $8v0nu.useRef)(false);
    if (isOpen) hasBeenOpened.current = true;
    const shouldRenderChildren = (0, $4b0f1a1d98c64842$export$76655e7dd9ffc0ba)({
        wasSelected: hasBeenOpened.current,
        enabled: isLazy,
        mode: lazyBehavior,
        isSelected: animated.present
    });
    return {
        ...props,
        ref: (0, $95f7db4ddbf3eda0$export$c9058316764c140e)(menuRef, ref),
        children: shouldRenderChildren ? props.children : null,
        tabIndex: -1,
        role: "menu",
        id: menuId,
        style: {
            ...props.style,
            transformOrigin: "var(--popper-transform-origin)"
        },
        "aria-orientation": "vertical",
        onKeyDown: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props.onKeyDown, onKeyDown)
    };
}
function $e1536a6b8ce0ec15$export$5149508ab5f84d86(props = {}) {
    const { popper: popper, isOpen: isOpen } = $e1536a6b8ce0ec15$export$21c7ab35b39f78ec();
    return popper.getPopperProps({
        ...props,
        style: {
            visibility: isOpen ? "visible" : "hidden",
            ...props.style
        }
    });
}
function $e1536a6b8ce0ec15$export$9d32628fc2aea7da(props = {}, externalRef = null) {
    const { onMouseEnter: onMouseEnterProp, onMouseMove: onMouseMoveProp, onMouseLeave: onMouseLeaveProp, onClick: onClickProp, onFocus: onFocusProp, isDisabled: isDisabled, isFocusable: isFocusable, closeOnSelect: closeOnSelect, type: typeProp, ...htmlProps } = props;
    const menu = $e1536a6b8ce0ec15$export$21c7ab35b39f78ec();
    const { setFocusedIndex: setFocusedIndex, focusedIndex: focusedIndex, closeOnSelect: menuCloseOnSelect, onClose: onClose, menuId: menuId, scrollIntoViewRef: scrollIntoViewRef } = menu;
    const ref = (0, $8v0nu.useRef)(null);
    const id = `${menuId}-menuitem-${(0, $8v0nu.useId)()}`;
    const { index: index, register: register } = $e1536a6b8ce0ec15$export$e44adeffd1a0865c({
        disabled: isDisabled && !isFocusable
    });
    const onMouseEnter = (0, $8v0nu.useCallback)((event)=>{
        onMouseEnterProp?.(event);
        if (isDisabled) return;
        scrollIntoViewRef.current = false;
        setFocusedIndex(index);
    }, [
        setFocusedIndex,
        index,
        isDisabled,
        onMouseEnterProp,
        scrollIntoViewRef
    ]);
    const onMouseMove = (0, $8v0nu.useCallback)((event)=>{
        onMouseMoveProp?.(event);
        if (ref.current && !$e1536a6b8ce0ec15$var$isActiveElement(ref.current)) onMouseEnter(event);
    }, [
        onMouseEnter,
        onMouseMoveProp
    ]);
    const onMouseLeave = (0, $8v0nu.useCallback)((event)=>{
        onMouseLeaveProp?.(event);
        if (isDisabled) return;
        setFocusedIndex(-1);
    }, [
        setFocusedIndex,
        isDisabled,
        onMouseLeaveProp
    ]);
    const onClick = (0, $8v0nu.useCallback)((event)=>{
        onClickProp?.(event);
        if (!$e1536a6b8ce0ec15$var$isTargetMenuItem(event.currentTarget)) return;
        if (closeOnSelect ?? menuCloseOnSelect) onClose();
    }, [
        onClose,
        onClickProp,
        menuCloseOnSelect,
        closeOnSelect
    ]);
    const onFocus = (0, $8v0nu.useCallback)((event)=>{
        onFocusProp?.(event);
        setFocusedIndex(index);
    }, [
        setFocusedIndex,
        onFocusProp,
        index
    ]);
    const isFocused = index === focusedIndex;
    const clickableProps = (0, $d3555d79611ee58d$export$ed213cc82e426b1a)({
        onClick: onClick,
        onFocus: onFocus,
        onMouseEnter: onMouseEnter,
        onMouseMove: onMouseMove,
        onMouseLeave: onMouseLeave,
        ref: (0, $95f7db4ddbf3eda0$export$c9058316764c140e)(register, ref, externalRef),
        isDisabled: isDisabled,
        isFocusable: isFocusable
    });
    return {
        ...htmlProps,
        ...clickableProps,
        type: typeProp ?? clickableProps.type,
        id: id,
        role: "menuitem",
        tabIndex: isFocused ? 0 : -1
    };
}
function $e1536a6b8ce0ec15$export$8ca3fd7c19c454af(props = {}, ref = null) {
    const { type: type = "radio", isChecked: isChecked, ...rest } = props;
    const ownProps = $e1536a6b8ce0ec15$export$9d32628fc2aea7da(rest, ref);
    return {
        ...ownProps,
        role: `menuitem${type}`,
        "aria-checked": isChecked
    };
}
function $e1536a6b8ce0ec15$export$9dcb3089500f52be(props = {}) {
    const { children: children, type: type = "radio", value: valueProp, defaultValue: defaultValue, onChange: onChangeProp, ...htmlProps } = props;
    const isRadio = type === "radio";
    const fallback = isRadio ? "" : [];
    const [value, setValue] = (0, $3268be99fa453fba$export$6f32135080cb4c3)({
        defaultValue: defaultValue ?? fallback,
        value: valueProp,
        onChange: onChangeProp
    });
    const onChange = (0, $8v0nu.useCallback)((selectedValue)=>{
        if (type === "radio" && typeof value === "string") setValue(selectedValue);
        if (type === "checkbox" && Array.isArray(value)) {
            const nextValue = value.includes(selectedValue) ? value.filter((item)=>item !== selectedValue) : value.concat(selectedValue);
            setValue(nextValue);
        }
    }, [
        value,
        setValue,
        type
    ]);
    const validChildren = (0, $da8753851e8cc1f3$export$b2c43d7d050b2e63)(children);
    const clones = validChildren.map((child)=>{
        if (child.type.id !== "MenuItemOption") return child;
        const onClick = (event)=>{
            onChange(child.props.value);
            child.props.onClick?.(event);
        };
        const isChecked = type === "radio" ? child.props.value === value : value.includes(child.props.value);
        return (0, $8v0nu.cloneElement)(child, {
            type: type,
            onClick: onClick,
            isChecked: isChecked
        });
    });
    return {
        ...htmlProps,
        children: clones
    };
}
function $e1536a6b8ce0ec15$export$8091e3849c182a6() {
    const { isOpen: isOpen, onClose: onClose } = $e1536a6b8ce0ec15$export$21c7ab35b39f78ec();
    return {
        isOpen: isOpen,
        onClose: onClose
    };
}
function $e1536a6b8ce0ec15$var$isHTMLElement(el) {
    if (!$e1536a6b8ce0ec15$var$isElement(el)) return false;
    const win = el.ownerDocument.defaultView ?? window;
    return el instanceof win.HTMLElement;
}
function $e1536a6b8ce0ec15$var$isElement(el) {
    return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}




"use client";
const [$bbc1594d228c6000$var$MenuStylesProvider, $bbc1594d228c6000$export$e7aea412cbc2ca01] = (0, $3473b2b1e3b906ba$export$fd42f52fd3ae1109)({
    name: `MenuStylesContext`,
    errorMessage: `useMenuStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Menu />" `
});
const $bbc1594d228c6000$export$d9b273488cd8ce6f = (props)=>{
    const { children: children } = props;
    const styles = (0, $c7d173d35275482d$export$31cdfe60c085d76f)("Menu", props);
    const ownProps = (0, $58ff34c9d17adf03$export$adfcf5a5e4d17785)(props);
    const { direction: direction } = (0, $00627e1df6d22967$export$93d4e7f90805808f)();
    const { descendants: descendants, ...ctx } = (0, $e1536a6b8ce0ec15$export$38eaa17faae8f579)({
        ...ownProps,
        direction: direction
    });
    const context = (0, $8v0nu.useMemo)(()=>ctx, [
        ctx
    ]);
    const { isOpen: isOpen, onClose: onClose, forceUpdate: forceUpdate } = context;
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $e1536a6b8ce0ec15$export$6bd12c048acae948), {
        value: descendants,
        children: /* @__PURE__ */ (0, $kxTYF.jsx)((0, $e1536a6b8ce0ec15$export$62b22d151866115d), {
            value: context,
            children: /* @__PURE__ */ (0, $kxTYF.jsx)($bbc1594d228c6000$var$MenuStylesProvider, {
                value: styles,
                children: (0, $cSr1Y.runIfFn)(children, {
                    isOpen: isOpen,
                    onClose: onClose,
                    forceUpdate: forceUpdate
                })
            })
        })
    });
};
$bbc1594d228c6000$export$d9b273488cd8ce6f.displayName = "Menu";


var $kxTYF = parcelRequire("kxTYF");





var $3lBLT = parcelRequire("3lBLT");
"use client";
const $5277a93d60858aae$var$StyledMenuButton = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $bbc1594d228c6000$export$e7aea412cbc2ca01)();
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).button, {
        ref: ref,
        ...props,
        __css: {
            display: "inline-flex",
            appearance: "none",
            alignItems: "center",
            outline: 0,
            ...styles.button
        }
    });
});
const $5277a93d60858aae$export$266a769812832828 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    const { children: children, as: As, ...rest } = props;
    const buttonProps = (0, $e1536a6b8ce0ec15$export$660510f872408795)(rest, ref);
    const Element = As || $5277a93d60858aae$var$StyledMenuButton;
    return /* @__PURE__ */ (0, $kxTYF.jsx)(Element, {
        ...buttonProps,
        className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-menu__menu-button", props.className),
        children: /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).span, {
            __css: {
                pointerEvents: "none",
                flex: "1 1 auto",
                minW: 0
            },
            children: props.children
        })
    });
});
$5277a93d60858aae$export$266a769812832828.displayName = "MenuButton";


var $kxTYF = parcelRequire("kxTYF");


var $kxTYF = parcelRequire("kxTYF");



var $3lBLT = parcelRequire("3lBLT");
"use client";
const $730257f49726f637$export$1fab7891e4a3c1fd = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $bbc1594d228c6000$export$e7aea412cbc2ca01)();
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).span, {
        ref: ref,
        ...props,
        __css: styles.command,
        className: "chakra-menu__command"
    });
});
$730257f49726f637$export$1fab7891e4a3c1fd.displayName = "MenuCommand";



var $kxTYF = parcelRequire("kxTYF");


var $8v0nu = parcelRequire("8v0nu");


var $3lBLT = parcelRequire("3lBLT");
"use client";
const $45900d708c901680$export$46e1d66043f363e6 = (props)=>{
    const { className: className, children: children, ...rest } = props;
    const styles = (0, $bbc1594d228c6000$export$e7aea412cbc2ca01)();
    const child = (0, $8v0nu.Children).only(children);
    const clone = (0, $8v0nu.isValidElement)(child) ? (0, $8v0nu.cloneElement)(child, {
        focusable: "false",
        "aria-hidden": true,
        className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-menu__icon", child.props.className)
    }) : null;
    const _className = (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-menu__icon-wrapper", className);
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).span, {
        className: _className,
        ...rest,
        __css: styles.icon,
        children: clone
    });
};
$45900d708c901680$export$46e1d66043f363e6.displayName = "MenuIcon";



var $kxTYF = parcelRequire("kxTYF");

var $8v0nu = parcelRequire("8v0nu");



var $3lBLT = parcelRequire("3lBLT");
"use client";
const $6dff93895e1728c7$export$cae703c457e46f23 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    const { type: type, ...rest } = props;
    const styles = (0, $bbc1594d228c6000$export$e7aea412cbc2ca01)();
    const btnType = rest.as || type ? type ?? void 0 : "button";
    const buttonStyles = (0, $8v0nu.useMemo)(()=>({
            textDecoration: "none",
            color: "inherit",
            userSelect: "none",
            display: "flex",
            width: "100%",
            alignItems: "center",
            textAlign: "start",
            flex: "0 0 auto",
            outline: 0,
            ...styles.item
        }), [
        styles.item
    ]);
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).button, {
        ref: ref,
        type: btnType,
        ...rest,
        __css: buttonStyles
    });
});




"use client";
const $293887a95e6a8bc4$export$2ce376c2cc3355c8 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    const { icon: icon, iconSpacing: iconSpacing = "0.75rem", command: command, commandSpacing: commandSpacing = "0.75rem", children: children, ...rest } = props;
    const menuitemProps = (0, $e1536a6b8ce0ec15$export$9d32628fc2aea7da)(rest, ref);
    const shouldWrap = icon || command;
    const _children = shouldWrap ? /* @__PURE__ */ (0, $kxTYF.jsx)("span", {
        style: {
            pointerEvents: "none",
            flex: 1
        },
        children: children
    }) : children;
    return /* @__PURE__ */ (0, $kxTYF.jsxs)((0, $6dff93895e1728c7$export$cae703c457e46f23), {
        ...menuitemProps,
        className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-menu__menuitem", menuitemProps.className),
        children: [
            icon && /* @__PURE__ */ (0, $kxTYF.jsx)((0, $45900d708c901680$export$46e1d66043f363e6), {
                fontSize: "0.8em",
                marginEnd: iconSpacing,
                children: icon
            }),
            _children,
            command && /* @__PURE__ */ (0, $kxTYF.jsx)((0, $730257f49726f637$export$1fab7891e4a3c1fd), {
                marginStart: commandSpacing,
                children: command
            })
        ]
    });
});
$293887a95e6a8bc4$export$2ce376c2cc3355c8.displayName = "MenuItem";


var $kxTYF = parcelRequire("kxTYF");





var $3lBLT = parcelRequire("3lBLT");

"use client";
const $caedd5fbd169c955$var$motionVariants = {
    enter: {
        visibility: "visible",
        opacity: 1,
        scale: 1,
        transition: {
            duration: 0.2,
            ease: [
                0.4,
                0,
                0.2,
                1
            ]
        }
    },
    exit: {
        transitionEnd: {
            visibility: "hidden"
        },
        opacity: 0,
        scale: 0.8,
        transition: {
            duration: 0.1,
            easings: "easeOut"
        }
    }
};
const $caedd5fbd169c955$var$MenuTransition = (0, $3lBLT.chakra)((0, $378127958faa4916$export$e25e478948902b8b).div);
const $caedd5fbd169c955$export$d4c4e98c5044dc8 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function MenuList2(props, ref) {
    const { rootProps: rootProps, motionProps: motionProps, ...rest } = props;
    const { isOpen: isOpen, onTransitionEnd: onTransitionEnd, unstable__animationState: animated } = (0, $e1536a6b8ce0ec15$export$21c7ab35b39f78ec)();
    const listProps = (0, $e1536a6b8ce0ec15$export$8dcac42583be8292)(rest, ref);
    const positionerProps = (0, $e1536a6b8ce0ec15$export$5149508ab5f84d86)(rootProps);
    const styles = (0, $bbc1594d228c6000$export$e7aea412cbc2ca01)();
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
        ...positionerProps,
        __css: {
            zIndex: props.zIndex ?? styles.list?.zIndex
        },
        children: /* @__PURE__ */ (0, $kxTYF.jsx)($caedd5fbd169c955$var$MenuTransition, {
            variants: $caedd5fbd169c955$var$motionVariants,
            initial: false,
            animate: isOpen ? "enter" : "exit",
            __css: {
                outline: 0,
                ...styles.list
            },
            ...motionProps,
            ...listProps,
            className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-menu__menu-list", listProps.className),
            onUpdate: onTransitionEnd,
            onAnimationComplete: (0, $5bb288c143ca173e$export$9dd9a52f2dd5b9ce)(animated.onComplete, listProps.onAnimationComplete)
        })
    });
});
$caedd5fbd169c955$export$d4c4e98c5044dc8.displayName = "MenuList";


var $kxTYF = parcelRequire("kxTYF");

var $lA3d6 = parcelRequire("lA3d6");
function $24a367edf3ea1eb0$export$65980d18b75784e2(object, keys) {
    const picked = {};
    const omitted = {};
    for (const [key, value] of Object.entries(object))if (keys.includes(key)) picked[key] = value;
    else omitted[key] = value;
    return [
        picked,
        omitted
    ];
}



var $8v0nu = parcelRequire("8v0nu");

var $kxTYF = parcelRequire("kxTYF");



var $3lBLT = parcelRequire("3lBLT");
"use client";
const $8dde20333ee23e63$export$d55b50a564d0b931 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function SelectField2(props, ref) {
    const { children: children, placeholder: placeholder, className: className, ...rest } = props;
    return /* @__PURE__ */ (0, $kxTYF.jsxs)((0, $3lBLT.chakra).select, {
        ...rest,
        ref: ref,
        className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-select", className),
        children: [
            placeholder && /* @__PURE__ */ (0, $kxTYF.jsx)("option", {
                value: "",
                children: placeholder
            }),
            children
        ]
    });
});
$8dde20333ee23e63$export$d55b50a564d0b931.displayName = "SelectField";





var $3lBLT = parcelRequire("3lBLT");

"use client";
const $10c1d0a50fcf4e99$export$ef9b1a59e592288f = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $c7d173d35275482d$export$31cdfe60c085d76f)("Select", props);
    const { rootProps: rootProps, placeholder: placeholder, icon: icon, color: color, height: height, h: h, minH: minH, minHeight: minHeight, iconColor: iconColor, iconSize: iconSize, ...rest } = (0, $58ff34c9d17adf03$export$adfcf5a5e4d17785)(props);
    const [layoutProps, otherProps] = (0, $24a367edf3ea1eb0$export$65980d18b75784e2)(rest, (0, $lA3d6.layoutPropNames));
    const ownProps = (0, $4f32164aecdf11bb$export$62ecd8ad1bbe1a18)(otherProps);
    const rootStyles = {
        width: "100%",
        height: "fit-content",
        position: "relative",
        color: color
    };
    const fieldStyles = {
        paddingEnd: "2rem",
        ...styles.field,
        _focus: {
            zIndex: "unset",
            ...styles.field?.["_focus"]
        }
    };
    return /* @__PURE__ */ (0, $kxTYF.jsxs)((0, $3lBLT.chakra).div, {
        className: "chakra-select__wrapper",
        __css: rootStyles,
        ...layoutProps,
        ...rootProps,
        children: [
            /* @__PURE__ */ (0, $kxTYF.jsx)((0, $8dde20333ee23e63$export$d55b50a564d0b931), {
                ref: ref,
                height: h ?? height,
                minH: minH ?? minHeight,
                placeholder: placeholder,
                ...ownProps,
                __css: fieldStyles,
                children: props.children
            }),
            /* @__PURE__ */ (0, $kxTYF.jsx)($10c1d0a50fcf4e99$var$SelectIcon, {
                "data-disabled": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(ownProps.disabled),
                ...(iconColor || color) && {
                    color: iconColor || color
                },
                __css: styles.icon,
                ...iconSize && {
                    fontSize: iconSize
                },
                children: icon
            })
        ]
    });
});
$10c1d0a50fcf4e99$export$ef9b1a59e592288f.displayName = "Select";
const $10c1d0a50fcf4e99$export$d206ce4c12e8ddf6 = (props)=>/* @__PURE__ */ (0, $kxTYF.jsx)("svg", {
        viewBox: "0 0 24 24",
        ...props,
        children: /* @__PURE__ */ (0, $kxTYF.jsx)("path", {
            fill: "currentColor",
            d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
        })
    });
const $10c1d0a50fcf4e99$var$IconWrapper = (0, $3lBLT.chakra)("div", {
    baseStyle: {
        position: "absolute",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "none",
        top: "50%",
        transform: "translateY(-50%)"
    }
});
const $10c1d0a50fcf4e99$var$SelectIcon = (props)=>{
    const { children: children = /* @__PURE__ */ (0, $kxTYF.jsx)($10c1d0a50fcf4e99$export$d206ce4c12e8ddf6, {}), ...rest } = props;
    const clone = (0, $8v0nu.cloneElement)(children, {
        role: "presentation",
        className: "chakra-select__icon",
        focusable: false,
        "aria-hidden": true,
        // force icon to adhere to `IconWrapper` styles
        style: {
            width: "1em",
            height: "1em",
            color: "currentColor"
        }
    });
    return /* @__PURE__ */ (0, $kxTYF.jsx)($10c1d0a50fcf4e99$var$IconWrapper, {
        ...rest,
        className: "chakra-select__icon-wrapper",
        children: (0, $8v0nu.isValidElement)(children) ? clone : null
    });
};
$10c1d0a50fcf4e99$var$SelectIcon.displayName = "SelectIcon";


var $kxTYF = parcelRequire("kxTYF");

var $fZQg5 = parcelRequire("fZQg5");
const $709e79e23fab15a6$export$d07517a676ce386f = Object.freeze([
    "base",
    "sm",
    "md",
    "lg",
    "xl",
    "2xl"
]);
function $709e79e23fab15a6$export$eca1915781c2aaca(prop, mapper) {
    if (Array.isArray(prop)) return prop.map((item)=>item === null ? null : mapper(item));
    if ((0, $fZQg5.isObject)(prop)) return Object.keys(prop).reduce((result, key)=>{
        result[key] = mapper(prop[key]);
        return result;
    }, {});
    if (prop != null) return mapper(prop);
    return null;
}
function $709e79e23fab15a6$export$d9dcf045f3ec145e(obj, bps = $709e79e23fab15a6$export$d07517a676ce386f) {
    const result = bps.map((br)=>obj[br] ?? null);
    const lastItem = result[result.length - 1];
    while(lastItem === null)result.pop();
    return result;
}
function $709e79e23fab15a6$export$60476530468641e7(values, bps = $709e79e23fab15a6$export$d07517a676ce386f) {
    const result = {};
    values.forEach((value, index)=>{
        const key = bps[index];
        if (value == null) return;
        result[key] = value;
    });
    return result;
}
function $709e79e23fab15a6$export$2f4b3062f5f33794(obj, bps = $709e79e23fab15a6$export$d07517a676ce386f) {
    const keys = Object.keys(obj);
    return keys.length > 0 && keys.every((key)=>bps.includes(key));
}
const $709e79e23fab15a6$export$4cdfc817e07de39e = (v)=>Number.isNaN(Number(v));



var $kxTYF = parcelRequire("kxTYF");


var $3lBLT = parcelRequire("3lBLT");
"use client";
const $da89f256d660f801$export$ef2184bd89960b14 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function Grid2(props, ref) {
    const { templateAreas: templateAreas, gap: gap, rowGap: rowGap, columnGap: columnGap, column: column, row: row, autoFlow: autoFlow, autoRows: autoRows, templateRows: templateRows, autoColumns: autoColumns, templateColumns: templateColumns, ...rest } = props;
    const styles = {
        display: "grid",
        gridTemplateAreas: templateAreas,
        gridGap: gap,
        gridRowGap: rowGap,
        gridColumnGap: columnGap,
        gridAutoColumns: autoColumns,
        gridColumn: column,
        gridRow: row,
        gridAutoFlow: autoFlow,
        gridAutoRows: autoRows,
        gridTemplateRows: templateRows,
        gridTemplateColumns: templateColumns
    };
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
        ref: ref,
        __css: styles,
        ...rest
    });
});
$da89f256d660f801$export$ef2184bd89960b14.displayName = "Grid";





"use client";
const $97afd073f9746d02$export$de97fecb6d4b30a5 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function SimpleGrid2(props, ref) {
    const { columns: columns, spacingX: spacingX, spacingY: spacingY, spacing: spacing, minChildWidth: minChildWidth, ...rest } = props;
    const theme = (0, $00627e1df6d22967$export$93d4e7f90805808f)();
    const templateColumns = minChildWidth ? $97afd073f9746d02$var$widthToColumns(minChildWidth, theme) : $97afd073f9746d02$var$countToColumns(columns);
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $da89f256d660f801$export$ef2184bd89960b14), {
        ref: ref,
        gap: spacing,
        columnGap: spacingX,
        rowGap: spacingY,
        templateColumns: templateColumns,
        ...rest
    });
});
$97afd073f9746d02$export$de97fecb6d4b30a5.displayName = "SimpleGrid";
function $97afd073f9746d02$var$toPx(n) {
    return typeof n === "number" ? `${n}px` : n;
}
function $97afd073f9746d02$var$widthToColumns(width, theme) {
    return (0, $709e79e23fab15a6$export$eca1915781c2aaca)(width, (value)=>{
        const _value = (0, $0023d2f189964130$export$257b2d10b709d8ef)("sizes", value, $97afd073f9746d02$var$toPx(value))(theme);
        return value === null ? null : `repeat(auto-fit, minmax(${_value}, 1fr))`;
    });
}
function $97afd073f9746d02$var$countToColumns(count) {
    return (0, $709e79e23fab15a6$export$eca1915781c2aaca)(count, (value)=>value === null ? null : `repeat(${value}, minmax(0, 1fr))`);
}







var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");

var $9HGsN = parcelRequire("9HGsN");
var $kxTYF = parcelRequire("kxTYF");



"use client";
const [$ca02dd4eedb4fe81$export$f051b3a3c1998e0, $ca02dd4eedb4fe81$export$7e0f545483b3a68c] = (0, $9e39c58cc161b735$export$11d9f9905bcdc114)("Card");





var $3lBLT = parcelRequire("3lBLT");
"use client";
const $6b1f130f71952b48$export$60332b2344f7fe41 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function Card2(props, ref) {
    const { className: className, children: children, direction: direction = "column", justify: justify, align: align, ...rest } = (0, $58ff34c9d17adf03$export$adfcf5a5e4d17785)(props);
    const styles = (0, $c7d173d35275482d$export$31cdfe60c085d76f)("Card", props);
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
        ref: ref,
        className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-card", className),
        __css: {
            display: "flex",
            flexDirection: direction,
            justifyContent: justify,
            alignItems: align,
            position: "relative",
            minWidth: 0,
            wordWrap: "break-word",
            ...styles.container
        },
        ...rest,
        children: /* @__PURE__ */ (0, $kxTYF.jsx)((0, $ca02dd4eedb4fe81$export$f051b3a3c1998e0), {
            value: styles,
            children: children
        })
    });
});


var $kxTYF = parcelRequire("kxTYF");




var $3lBLT = parcelRequire("3lBLT");
"use client";
const $8a82c967ef8ca55a$export$851de33184ecdac4 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function CardBody2(props, ref) {
    const { className: className, ...rest } = props;
    const styles = (0, $ca02dd4eedb4fe81$export$7e0f545483b3a68c)();
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
        ref: ref,
        className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-card__body", className),
        __css: styles.body,
        ...rest
    });
});


var $kxTYF = parcelRequire("kxTYF");




var $3lBLT = parcelRequire("3lBLT");
"use client";
const $c3199ed83ca8041f$export$e9897d434e0741ee = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function CardFooter2(props, ref) {
    const { className: className, justify: justify, ...rest } = props;
    const styles = (0, $ca02dd4eedb4fe81$export$7e0f545483b3a68c)();
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
        ref: ref,
        className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-card__footer", className),
        __css: {
            display: "flex",
            justifyContent: justify,
            ...styles.footer
        },
        ...rest
    });
});


var $kxTYF = parcelRequire("kxTYF");




var $3lBLT = parcelRequire("3lBLT");
"use client";
const $b419a06f98d72db5$export$5665775b26e26c5d = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function CardHeader2(props, ref) {
    const { className: className, ...rest } = props;
    const styles = (0, $ca02dd4eedb4fe81$export$7e0f545483b3a68c)();
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
        ref: ref,
        className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-card__header", className),
        __css: styles.header,
        ...rest
    });
});


var $kxTYF = parcelRequire("kxTYF");

var $kxTYF = parcelRequire("kxTYF");


var $8v0nu = parcelRequire("8v0nu");

var $kxTYF = parcelRequire("kxTYF");

var $3lBLT = parcelRequire("3lBLT");
"use client";
const $d909228c3b8cc83c$export$50d5391cd1a018c6 = (props)=>/* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
        className: "chakra-stack__item",
        ...props,
        __css: {
            display: "inline-block",
            flex: "0 0 auto",
            minWidth: 0,
            ...props["__css"]
        }
    });
$d909228c3b8cc83c$export$50d5391cd1a018c6.displayName = "StackItem";



"use client";
function $c0a2fc4c87e50bb8$export$d4a6a5cc582519a5(options) {
    const { spacing: spacing, direction: direction } = options;
    const dividerStyles = {
        column: {
            my: spacing,
            mx: 0,
            borderLeftWidth: 0,
            borderBottomWidth: "1px"
        },
        "column-reverse": {
            my: spacing,
            mx: 0,
            borderLeftWidth: 0,
            borderBottomWidth: "1px"
        },
        row: {
            mx: spacing,
            my: 0,
            borderLeftWidth: "1px",
            borderBottomWidth: 0
        },
        "row-reverse": {
            mx: spacing,
            my: 0,
            borderLeftWidth: "1px",
            borderBottomWidth: 0
        }
    };
    return {
        "&": (0, $709e79e23fab15a6$export$eca1915781c2aaca)(direction, (value)=>dividerStyles[value])
    };
}




var $3lBLT = parcelRequire("3lBLT");
"use client";
const $b007782d957d7b60$export$694e0d28c7ffc90c = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    const { isInline: isInline, direction: directionProp, align: align, justify: justify, spacing: spacing = "0.5rem", wrap: wrap, children: children, divider: divider, className: className, shouldWrapChildren: shouldWrapChildren, ...rest } = props;
    const direction = isInline ? "row" : directionProp ?? "column";
    const dividerStyle = (0, $8v0nu.useMemo)(()=>(0, $c0a2fc4c87e50bb8$export$d4a6a5cc582519a5)({
            spacing: spacing,
            direction: direction
        }), [
        spacing,
        direction
    ]);
    const hasDivider = !!divider;
    const shouldUseChildren = !shouldWrapChildren && !hasDivider;
    const clones = (0, $8v0nu.useMemo)(()=>{
        const validChildren = (0, $da8753851e8cc1f3$export$b2c43d7d050b2e63)(children);
        return shouldUseChildren ? validChildren : validChildren.map((child, index)=>{
            const key = typeof child.key !== "undefined" ? child.key : index;
            const isLast = index + 1 === validChildren.length;
            const wrappedChild = /* @__PURE__ */ (0, $kxTYF.jsx)((0, $d909228c3b8cc83c$export$50d5391cd1a018c6), {
                children: child
            }, key);
            const _child = shouldWrapChildren ? wrappedChild : child;
            if (!hasDivider) return _child;
            const clonedDivider = (0, $8v0nu.cloneElement)(divider, {
                __css: dividerStyle
            });
            const _divider = isLast ? null : clonedDivider;
            return /* @__PURE__ */ (0, $kxTYF.jsxs)((0, $8v0nu.Fragment), {
                children: [
                    _child,
                    _divider
                ]
            }, key);
        });
    }, [
        divider,
        dividerStyle,
        hasDivider,
        shouldUseChildren,
        shouldWrapChildren,
        children
    ]);
    const _className = (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-stack", className);
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
        ref: ref,
        display: "flex",
        alignItems: align,
        justifyContent: justify,
        flexDirection: direction,
        flexWrap: wrap,
        gap: hasDivider ? void 0 : spacing,
        className: _className,
        ...rest,
        children: clones
    });
});
$b007782d957d7b60$export$694e0d28c7ffc90c.displayName = "Stack";



"use client";
const $ffc809ba2fb36850$export$15e411dc07b9c834 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>/* @__PURE__ */ (0, $kxTYF.jsx)((0, $b007782d957d7b60$export$694e0d28c7ffc90c), {
        align: "center",
        ...props,
        direction: "row",
        ref: ref
    }));
$ffc809ba2fb36850$export$15e411dc07b9c834.displayName = "HStack";


var $kxTYF = parcelRequire("kxTYF");

var $8v0nu = parcelRequire("8v0nu");
"use client";
function $07e0e7593f025b9f$export$5cae361ad82dce8b(value) {
    const ref = (0, $8v0nu.useRef)();
    (0, $8v0nu.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}





var $6iKRa = parcelRequire("6iKRa");

var $8v0nu = parcelRequire("8v0nu");
"use client";
function $81e1230614340116$export$5964c316e853650f() {
    const isFirstRender = (0, $8v0nu.useRef)(true);
    (0, $8v0nu.useEffect)(()=>{
        isFirstRender.current = false;
    }, []);
    return isFirstRender.current;
}




var $3lBLT = parcelRequire("3lBLT");


"use client";
const $408225e060551a18$var$StyledSkeleton = (0, $3lBLT.chakra)("div", {
    baseStyle: {
        boxShadow: "none",
        backgroundClip: "padding-box",
        cursor: "default",
        color: "transparent",
        pointerEvents: "none",
        userSelect: "none",
        "&::before, &::after, *": {
            visibility: "hidden"
        }
    }
});
const $408225e060551a18$var$$startColor = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("skeleton-start-color");
const $408225e060551a18$var$$endColor = (0, $b8e754b253ef3f21$export$8b4981022bd80a4e)("skeleton-end-color");
const $408225e060551a18$var$fade = (0, $6iKRa.keyframes)({
    from: {
        opacity: 0
    },
    to: {
        opacity: 1
    }
});
const $408225e060551a18$var$bgFade = (0, $6iKRa.keyframes)({
    from: {
        borderColor: $408225e060551a18$var$$startColor.reference,
        background: $408225e060551a18$var$$startColor.reference
    },
    to: {
        borderColor: $408225e060551a18$var$$endColor.reference,
        background: $408225e060551a18$var$$endColor.reference
    }
});
const $408225e060551a18$export$8f31e4c4a37b8e9c = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    const skeletonProps = {
        ...props,
        fadeDuration: typeof props.fadeDuration === "number" ? props.fadeDuration : 0.4,
        speed: typeof props.speed === "number" ? props.speed : 0.8
    };
    const styles = (0, $c7d173d35275482d$export$b863f77547fbcb03)("Skeleton", skeletonProps);
    const isFirstRender = (0, $81e1230614340116$export$5964c316e853650f)();
    const { startColor: startColor = "", endColor: endColor = "", isLoaded: isLoaded, fadeDuration: fadeDuration, speed: speed, className: className, fitContent: fitContent, animation: animationProp, ...rest } = (0, $58ff34c9d17adf03$export$adfcf5a5e4d17785)(skeletonProps);
    const [startColorVar, endColorVar] = (0, $0023d2f189964130$export$31dcd79391e423fe)("colors", [
        startColor,
        endColor
    ]);
    const wasPreviouslyLoaded = (0, $07e0e7593f025b9f$export$5cae361ad82dce8b)(isLoaded);
    const _className = (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-skeleton", className);
    const cssVarStyles = {
        ...startColorVar && {
            [$408225e060551a18$var$$startColor.variable]: startColorVar
        },
        ...endColorVar && {
            [$408225e060551a18$var$$endColor.variable]: endColorVar
        }
    };
    if (isLoaded) {
        const animation = isFirstRender || wasPreviouslyLoaded ? "none" : `${$408225e060551a18$var$fade} ${fadeDuration}s`;
        return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
            ref: ref,
            className: _className,
            __css: {
                animation: animation
            },
            ...rest
        });
    }
    return /* @__PURE__ */ (0, $kxTYF.jsx)($408225e060551a18$var$StyledSkeleton, {
        ref: ref,
        className: _className,
        ...rest,
        __css: {
            width: fitContent ? "fit-content" : void 0,
            ...styles,
            ...cssVarStyles,
            _dark: {
                ...styles["_dark"],
                ...cssVarStyles
            },
            animation: animationProp || `${speed}s linear infinite alternate ${$408225e060551a18$var$bgFade}`
        }
    });
});
$408225e060551a18$export$8f31e4c4a37b8e9c.displayName = "Skeleton";


var $kxTYF = parcelRequire("kxTYF");



var $fZQg5 = parcelRequire("fZQg5");

"use client";
function $74c1cb36a9489fed$export$4b9ea961bfd9be6e(values, breakpoint, breakpoints$1 = (0, $709e79e23fab15a6$export$d07517a676ce386f)) {
    let index = Object.keys(values).indexOf(breakpoint);
    if (index !== -1) return values[breakpoint];
    let stopIndex = breakpoints$1.indexOf(breakpoint);
    while(stopIndex >= 0){
        const key = breakpoints$1[stopIndex];
        if (values.hasOwnProperty(key)) {
            index = stopIndex;
            break;
        }
        stopIndex -= 1;
    }
    if (index !== -1) {
        const key = breakpoints$1[index];
        return values[key];
    }
    return void 0;
}



var $fZQg5 = parcelRequire("fZQg5");

var $8v0nu = parcelRequire("8v0nu");

"use client";
function $6e6640f21d6aa8d3$export$32d5543ab307c01(query, options = {}) {
    const { ssr: ssr = true, fallback: fallback } = options;
    const { getWindow: getWindow } = (0, $859eaf816c30ec7c$export$ea7ed2425832167d)();
    const queries = Array.isArray(query) ? query : [
        query
    ];
    let fallbackValues = Array.isArray(fallback) ? fallback : [
        fallback
    ];
    fallbackValues = fallbackValues.filter((v)=>v != null);
    const [value, setValue] = (0, $8v0nu.useState)(()=>{
        return queries.map((query2, index)=>({
                media: query2,
                matches: ssr ? !!fallbackValues[index] : getWindow().matchMedia(query2).matches
            }));
    });
    (0, $8v0nu.useEffect)(()=>{
        const win = getWindow();
        setValue(queries.map((query2)=>({
                media: query2,
                matches: win.matchMedia(query2).matches
            })));
        const mql = queries.map((query2)=>win.matchMedia(query2));
        const handler = (evt)=>{
            setValue((prev)=>{
                return prev.slice().map((item)=>{
                    if (item.media === evt.media) return {
                        ...item,
                        matches: evt.matches
                    };
                    return item;
                });
            });
        };
        mql.forEach((mql2)=>{
            if (typeof mql2.addListener === "function") mql2.addListener(handler);
            else mql2.addEventListener("change", handler);
        });
        return ()=>{
            mql.forEach((mql2)=>{
                if (typeof mql2.removeListener === "function") mql2.removeListener(handler);
                else mql2.removeEventListener("change", handler);
            });
        };
    }, [
        getWindow
    ]);
    return value.map((item)=>item.matches);
}



"use client";
function $336cf69775d67860$export$199d6754bdf4e1e3(arg) {
    const opts = (0, $fZQg5.isObject)(arg) ? arg : {
        fallback: arg ?? "base"
    };
    const theme = (0, $00627e1df6d22967$export$93d4e7f90805808f)();
    const breakpoints = theme.__breakpoints.details.map(({ minMaxQuery: minMaxQuery, breakpoint: breakpoint })=>({
            breakpoint: breakpoint,
            query: minMaxQuery.replace("@media screen and ", "")
        }));
    const fallback = breakpoints.map((bp)=>bp.breakpoint === opts.fallback);
    const values = (0, $6e6640f21d6aa8d3$export$32d5543ab307c01)(breakpoints.map((bp)=>bp.query), {
        fallback: fallback,
        ssr: opts.ssr
    });
    const index = values.findIndex((value)=>value == true);
    return breakpoints[index]?.breakpoint ?? opts.fallback;
}



"use client";
function $358ed25c46213904$export$dc0946e21e709aff(values, arg) {
    const opts = (0, $fZQg5.isObject)(arg) ? arg : {
        fallback: arg ?? "base"
    };
    const breakpoint = (0, $336cf69775d67860$export$199d6754bdf4e1e3)(opts);
    const theme = (0, $00627e1df6d22967$export$93d4e7f90805808f)();
    if (!breakpoint) return;
    const breakpoints = Array.from(theme.__breakpoints?.keys || []);
    const obj = Array.isArray(values) ? Object.fromEntries(Object.entries((0, $709e79e23fab15a6$export$60476530468641e7)(values, breakpoints)).map(([key, value])=>[
            key,
            value
        ])) : values;
    return (0, $74c1cb36a9489fed$export$4b9ea961bfd9be6e)(obj, breakpoint, breakpoints);
}



var $3lBLT = parcelRequire("3lBLT");
"use client";
function $2fb4f0d945397efb$var$range(count) {
    return Array(count).fill(1).map((_, index)=>index + 1);
}
const $2fb4f0d945397efb$var$defaultNoOfLines = 3;
const $2fb4f0d945397efb$export$cb6ddd830302c2a8 = (props)=>{
    const { noOfLines: noOfLines = $2fb4f0d945397efb$var$defaultNoOfLines, spacing: spacing = "0.5rem", skeletonHeight: skeletonHeight = "0.5rem", className: className, startColor: startColor, endColor: endColor, isLoaded: isLoaded, fadeDuration: fadeDuration, speed: speed, variant: variant, size: size, colorScheme: colorScheme, children: children, ...rest } = props;
    const noOfLinesValue = (0, $358ed25c46213904$export$dc0946e21e709aff)(typeof noOfLines === "number" ? [
        noOfLines
    ] : noOfLines) || $2fb4f0d945397efb$var$defaultNoOfLines;
    const numbers = $2fb4f0d945397efb$var$range(noOfLinesValue);
    const getWidth = (index)=>{
        if (noOfLinesValue > 1) return index === numbers.length ? "80%" : "100%";
        return "100%";
    };
    const _className = (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-skeleton__group", className);
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
        className: _className,
        ...rest,
        children: numbers.map((number, index)=>{
            if (isLoaded && index > 0) return null;
            const sizeProps = isLoaded ? null : {
                mb: number === numbers.length ? "0" : spacing,
                width: getWidth(number),
                height: skeletonHeight
            };
            return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $408225e060551a18$export$8f31e4c4a37b8e9c), {
                startColor: startColor,
                endColor: endColor,
                isLoaded: isLoaded,
                fadeDuration: fadeDuration,
                speed: speed,
                variant: variant,
                size: size,
                colorScheme: colorScheme,
                ...sizeProps,
                // allows animating the children
                children: index === 0 ? children : void 0
            }, numbers.length.toString() + number);
        })
    });
};
$2fb4f0d945397efb$export$cb6ddd830302c2a8.displayName = "SkeletonText";


var $kxTYF = parcelRequire("kxTYF");






var $3lBLT = parcelRequire("3lBLT");
"use client";
const [$beacec6ac7efe0d9$var$TagStylesProvider, $beacec6ac7efe0d9$export$fa5e32657e7ee8a0] = (0, $3473b2b1e3b906ba$export$fd42f52fd3ae1109)({
    name: `TagStylesContext`,
    errorMessage: `useTagStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Tag />" `
});
const $beacec6ac7efe0d9$export$3288d34c523a1192 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $c7d173d35275482d$export$31cdfe60c085d76f)("Tag", props);
    const ownProps = (0, $58ff34c9d17adf03$export$adfcf5a5e4d17785)(props);
    const containerStyles = {
        display: "inline-flex",
        verticalAlign: "top",
        alignItems: "center",
        maxWidth: "100%",
        ...styles.container
    };
    return /* @__PURE__ */ (0, $kxTYF.jsx)($beacec6ac7efe0d9$var$TagStylesProvider, {
        value: styles,
        children: /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).span, {
            ref: ref,
            ...ownProps,
            __css: containerStyles
        })
    });
});
$beacec6ac7efe0d9$export$3288d34c523a1192.displayName = "Tag";
const $beacec6ac7efe0d9$export$f5486329f0fd0847 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    const styles = $beacec6ac7efe0d9$export$fa5e32657e7ee8a0();
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).span, {
        ref: ref,
        noOfLines: 1,
        ...props,
        __css: styles.label
    });
});
$beacec6ac7efe0d9$export$f5486329f0fd0847.displayName = "TagLabel";
const $beacec6ac7efe0d9$export$1b1a9388acf57360 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>/* @__PURE__ */ (0, $kxTYF.jsx)((0, $09b0bffb6a1e43af$export$f04a61298a47a40f), {
        ref: ref,
        verticalAlign: "top",
        marginEnd: "0.5rem",
        ...props
    }));
$beacec6ac7efe0d9$export$1b1a9388acf57360.displayName = "TagLeftIcon";
const $beacec6ac7efe0d9$export$469b69b26b54518e = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>/* @__PURE__ */ (0, $kxTYF.jsx)((0, $09b0bffb6a1e43af$export$f04a61298a47a40f), {
        ref: ref,
        verticalAlign: "top",
        marginStart: "0.5rem",
        ...props
    }));
$beacec6ac7efe0d9$export$469b69b26b54518e.displayName = "TagRightIcon";
const $beacec6ac7efe0d9$var$TagCloseIcon = (props)=>/* @__PURE__ */ (0, $kxTYF.jsx)((0, $09b0bffb6a1e43af$export$f04a61298a47a40f), {
        verticalAlign: "inherit",
        viewBox: "0 0 512 512",
        ...props,
        children: /* @__PURE__ */ (0, $kxTYF.jsx)("path", {
            fill: "currentColor",
            d: "M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"
        })
    });
$beacec6ac7efe0d9$var$TagCloseIcon.displayName = "TagCloseIcon";
const $beacec6ac7efe0d9$export$2c1e51182f03e1ee = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    const { isDisabled: isDisabled, children: children, ...rest } = props;
    const styles = $beacec6ac7efe0d9$export$fa5e32657e7ee8a0();
    const btnStyles = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        outline: "0",
        ...styles.closeButton
    };
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).button, {
        ref: ref,
        "aria-label": "close",
        ...rest,
        type: "button",
        disabled: isDisabled,
        __css: btnStyles,
        children: children || /* @__PURE__ */ (0, $kxTYF.jsx)($beacec6ac7efe0d9$var$TagCloseIcon, {})
    });
});
$beacec6ac7efe0d9$export$2c1e51182f03e1ee.displayName = "TagCloseButton";




var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");

var $3lBLT = parcelRequire("3lBLT");
function $98471c1be9617cb6$export$bc53e36006268bd5(props) {
    return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $3lBLT.chakra).svg, {
        viewBox: "0 0 640 320",
        fill: "primary.100",
        xmlns: "http://www.w3.org/2000/svg",
        objectFit: "cover",
        borderRadius: "md",
        ...props,
        children: [
            /*#__PURE__*/ (0, $kxTYF.jsxs)("g", {
                clipPath: "url(#clip0_1139_3165)",
                children: [
                    /*#__PURE__*/ (0, $kxTYF.jsx)("rect", {
                        width: "640",
                        height: "320",
                        fill: ""
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)("path", {
                        d: "M112.905 -168.033C85.1573 -152.445 80.2157 -115.289 78.449 -83.5117C78.1219 -77.645 77.8344 -71.5471 80.0886 -66.1221C86.7094 -50.1888 109.745 -49.3742 121.43 -36.6804C138.401 -18.245 123.103 10.6759 121.707 35.7009C119.83 69.4176 143.764 96.6385 156.232 126.007C167.428 152.372 172.118 197.932 150.366 220.072C139.393 231.241 125.028 239.899 118.526 254.143C113.209 265.787 112.505 281.618 100.895 287.009C87.5178 293.224 72.899 279.295 58.1719 280.105C49.099 280.607 41.4344 286.589 33.4344 290.895C25.4344 295.199 14.7635 297.657 7.84271 291.77C4.36354 288.812 2.6281 284.343 1.02393 280.066C-4.69274 264.822 -10.4115 249.576 -16.1302 234.332C-54.8678 244.082 -94.8824 248.751 -134.824 248.178C-140.089 248.103 -145.695 248.026 -150.162 250.809C-158.728 256.149 -158.555 268.295 -160.139 278.266C-163.226 297.707 -177.503 314.962 -196.02 321.637C-205.13 324.92 -215.503 326.032 -222.674 332.541C-232.699 341.641 -232.395 357.201 -237.272 369.83C-246.962 394.926 -278.316 410.868 -277.939 437.766C-277.745 451.614 -268.693 463.635 -259.401 473.903C-245.228 489.568 -229.482 503.808 -212.476 516.339C-217.61 529.066 -208.845 544.053 -196.639 550.326C-184.432 556.599 -169.982 556.266 -156.307 555.112C-142.632 553.958 -128.589 552.166 -115.393 555.931C-103.399 559.353 -93.1761 567.076 -83.2616 574.643C-64.2657 589.133 -45.274 603.624 -26.2802 618.116C-17.7323 624.639 -8.6969 631.839 -5.59273 642.135C-4.24898 646.589 -3.95731 651.703 -0.684389 655.012C1.69478 657.416 5.16144 658.318 8.44686 659.12C30.0802 664.399 54.4698 669.293 73.3656 657.51C83.3865 651.262 90.2615 641.162 96.8386 631.354C117.834 600.041 133.991 556.833 158.512 529.128C181.118 503.587 220.143 482.887 251.693 471.366C299.141 454.039 354.81 449.718 389.608 413.103C413.57 387.889 421.449 353.37 428.847 320.507C432.651 303.603 438.333 286.487 441.403 269.522C444.276 253.655 439.714 236.764 445.516 221.42C450.406 208.497 459.62 197.757 468.662 187.309C481.556 172.409 494.447 157.509 507.341 142.609C512.703 136.409 518.751 129.816 526.845 128.52C532.906 127.547 538.972 129.774 544.71 131.961C560.618 138.03 576.526 144.097 592.433 150.164C597.372 152.049 602.774 154.347 605.008 159.139C607.014 163.441 605.849 168.493 604.514 173.049C600.666 186.189 595.693 198.999 589.668 211.295C600.947 227.293 616.604 245.253 635.904 241.978C645.818 240.297 653.827 233.155 663.045 229.13C672.264 225.107 685.533 225.78 689.464 235.041C691.141 238.997 690.612 243.516 691.464 247.728C693.441 257.497 702.645 264.33 712.164 267.284C721.683 270.237 731.833 270.243 741.672 271.828C767.25 275.953 791.281 291.999 802.352 315.424C813.427 338.849 809.814 369.207 791.549 387.585C782.174 397.018 769.293 403.522 763.368 415.43C760.831 420.528 759.512 426.672 754.912 430.03C749.818 433.749 742.843 432.57 736.543 432.299C715 431.37 694.525 443.372 680.139 459.437C665.754 475.501 656.447 495.36 647.343 514.908C660.943 521.891 674.86 529.108 685.129 540.435C695.395 551.76 701.397 568.253 696.241 582.645C695.122 585.774 693.491 588.824 693.395 592.143C693.227 598.047 697.802 602.826 701.364 607.537C742.987 662.537 640.854 744.295 616.283 788.679C593.295 830.193 585.162 886.322 616.11 922.295",
                        stroke: "white",
                        strokeWidth: "8",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)("path", {
                        d: "M-107.312 -166.705C-95.6844 -138.803 -106.872 -106.933 -104.268 -76.8179C-101.205 -41.422 -79.1657 -9.78868 -76.0636 25.603C-73.2594 57.6218 -86.0678 91.301 -74.4344 121.266C-60.0969 158.199 -15.6948 172.866 9.78442 203.205C19.3678 214.618 27.3615 229.126 41.5782 233.597C60.0553 239.407 78.9636 224.83 89.2803 208.439C97.6991 195.064 103.199 178.918 99.9574 163.451C95.4116 141.768 75.3553 126.857 66.4511 106.572C57.2907 85.7114 60.8615 61.6968 65.1595 39.3218C66.5282 32.1968 67.9199 24.6259 65.3115 17.8551C62.2574 9.92592 54.524 5.01967 48.3719 -0.842836C26.4073 -21.7741 24.2553 -56.3846 30.5469 -86.0638C36.8407 -115.747 49.9886 -143.889 53.5553 -174.018",
                        stroke: "white",
                        strokeWidth: "8",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)("path", {
                        d: "M-55.2991 -160.516C-49.1553 -132.341 -42.9866 -103.956 -42.3303 -75.1246C-41.9845 -59.9767 -43.1657 -44.7517 -41.3886 -29.7038C-39.6136 -14.6537 -34.4928 0.633777 -23.572 11.138C-21.597 13.038 -19.2824 14.8359 -16.5574 15.1255C-10.4199 15.7755 -6.3657 8.91503 -4.74487 2.96086C-0.555279 -12.4267 -1.4157 -28.6933 -2.70737 -44.5892C-4.58653 -67.6934 -7.30528 -90.9746 -4.38237 -113.968C-1.46153 -136.962 7.85514 -160.139 25.9406 -174.639",
                        stroke: "white",
                        strokeWidth: "8",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)("path", {
                        d: "M-9.74683 120.591C-4.00933 124.772 2.96568 126.838 9.27193 130.103C21.7636 136.57 31.5865 148.02 36.0824 161.347C37.5678 165.753 38.9282 170.895 43.1136 172.92C49.2928 175.909 56.4595 168.863 56.4553 161.999C56.4491 155.136 52.0386 149.174 48.0324 143.599C35.7511 126.497 26.7324 91.5488 7.94902 81.1218C-21.6635 64.6863 -31.6656 104.618 -9.74683 120.591Z",
                        stroke: "white",
                        strokeWidth: "8",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)("path", {
                        d: "M-5.78639 328.88C-27.5781 323.174 -43.751 303.826 -65.4781 297.876C-86.9198 292.005 -110.072 300.449 -127.911 313.714C-145.751 326.98 -159.645 344.724 -175.001 360.801C-187.414 373.793 -201.143 386.145 -209.037 402.287C-216.93 418.428 -217.38 439.918 -204.595 452.543C-194.051 462.953 -176.064 466.262 -170.587 480.028C-168.37 485.601 -168.718 492.06 -165.818 497.308C-160.257 507.389 -146.409 508.135 -134.907 508.645C-77.251 511.203 -21.4281 541.341 12.3449 588.141C19.149 597.57 26.7907 608.67 38.3907 609.499C47.0741 610.122 55.0574 604.414 60.4907 597.612C75.2782 579.103 76.0907 553.489 83.147 530.876C89.6283 510.101 101.882 491.16 118.176 476.733C136.124 460.841 160.276 448.247 166.21 425.022C174.251 393.537 137.726 351.749 113.141 334.47C75.997 308.37 33.4428 339.153 -5.78639 328.88Z",
                        stroke: "white",
                        strokeWidth: "8",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)("path", {
                        d: "M564.781 -183.514C584.57 -159.755 594.124 -128.714 596.268 -97.8679C598.416 -67.02 593.624 -36.1137 587.408 -5.8241C584.008 10.7509 579.991 27.6676 570.485 41.6635C555.187 64.1885 528.508 75.4489 505.935 90.676C443.562 132.749 411.135 207.484 395.558 281.091C392.041 297.718 389.116 314.776 381.249 329.841C372.858 345.914 359.322 358.724 344.899 369.718C327.666 382.855 308.385 394.022 287.151 398.357C265.918 402.695 242.464 399.499 225.278 386.295C213.701 377.399 205.662 364.649 199.485 351.42C189.184 329.364 183.401 304.876 185.291 280.607C189.374 228.124 228.343 178.149 214.205 127.441C204.593 92.9593 171.445 65.7614 172.093 29.9697C172.43 11.3697 182.23 -6.92619 178.359 -25.122C174.093 -45.1825 154.797 -58.2262 145.237 -76.37C138.328 -89.4783 136.807 -104.662 135.409 -119.412C133.812 -136.289 135.491 -158.364 151.755 -163.135C174.184 -169.716 186.416 -188.858 206.62 -200.614C225.482 -211.593 244.503 -222.643 265.172 -229.658C289.528 -237.926 315.497 -240.349 341.216 -240.762C415.762 -241.96 517.062 -240.799 564.781 -183.514Z",
                        stroke: "white",
                        strokeWidth: "8",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)("path", {
                        d: "M199.718 -138.566C216.868 -144.012 226.512 -158.493 242.106 -167.599C256.666 -176.101 271.372 -184.641 287.339 -190.135C306.124 -196.593 326.151 -198.547 346.024 -199.16C381.568 -200.258 423.814 -200.549 459.929 -190.974C484.524 -184.493 506.202 -173.478 520.987 -155.295C536.772 -135.878 543.643 -109.891 544.67 -83.7658C544.783 -80.8846 544.843 -77.9971 544.831 -75.1117C544.76 -52.5429 540.762 -29.8616 535.875 -7.61996C532.852 6.12588 529.406 20.1384 521.752 31.803C509.981 49.7488 489.447 58.9822 472.249 71.351C446.543 89.8468 427.485 115.138 413.758 142.839C401.447 167.682 393.231 195.028 387.647 222.149C384.954 235.237 382.662 248.632 376.679 260.557C370.193 273.484 359.804 284.003 348.581 293.055C336.154 303.093 322.233 311.747 306.831 315.989C305.597 316.328 304.358 316.639 303.106 316.918C286.228 320.687 267.431 318.389 253.539 308.147C244.153 301.237 237.518 291.226 232.533 280.632C228.67 272.437 225.764 263.762 223.803 254.916C221.489 244.497 220.468 233.77 221.126 223.057C222.893 194.949 236.072 167.472 241.616 140.039C244.46 126.155 245.312 112.288 241.645 98.3551C234.256 70.2405 209.318 47.5676 209.933 18.5342C210.255 3.36338 217.741 -11.5512 215.053 -26.3471C212.103 -42.7242 197.991 -53.7783 191.316 -68.5742C188.472 -74.9054 187.066 -81.7659 186.285 -88.7617C185.743 -93.6055 185.503 -98.5159 185.295 -103.364C184.699 -116.903 186.628 -134.41 199.718 -138.566Z",
                        stroke: "white",
                        strokeWidth: "8",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)("path", {
                        d: "M247.678 -113.995C259.557 -118.255 266.605 -128.128 277.591 -134.583C287.851 -140.61 298.241 -146.637 309.503 -150.61C322.718 -155.26 336.81 -156.764 350.83 -157.558C377.295 -159.055 407.551 -159.749 433.21 -153.112C451.187 -148.537 466.756 -140.443 477.193 -127.076C488.968 -111.993 493.185 -91.0763 493.07 -69.6637C493.056 -67.3804 493.018 -65.095 492.92 -62.8033C492.208 -45.0387 488.599 -27.0283 484.341 -9.4137C481.697 1.50297 478.814 12.5988 473.02 21.9447C464.747 35.2863 450.391 42.5405 438.566 52.028C420.339 66.6551 406.953 85.576 397.691 105.17C389.078 123.393 383.614 143.401 379.735 163.205C377.864 172.755 376.21 182.495 372.105 191.272C367.533 201.059 360.285 209.282 352.262 216.395C343.364 224.301 333.235 231.139 321.822 234.695C320.91 234.978 319.987 235.241 319.06 235.478C306.535 238.682 292.397 237.28 281.797 229.999C274.603 225.078 269.374 217.801 265.582 209.847C262.576 203.557 260.53 196.824 259.128 189.999C257.48 182.022 256.668 173.782 256.962 165.505C257.791 144.045 266.085 122.738 269.489 101.374C271.189 90.6926 271.641 80.0093 269.08 69.2697C263.916 47.5218 247.189 29.3759 247.77 7.09673C248.08 -4.64077 253.251 -16.1741 251.749 -27.5741C250.114 -40.2637 241.16 -49.3221 237.393 -60.7783C235.778 -65.6929 235.178 -70.945 235.02 -76.2596C234.914 -79.9409 235.024 -83.6554 235.176 -87.3117C235.585 -97.52 237.76 -110.437 247.678 -113.995Z",
                        stroke: "white",
                        strokeWidth: "8",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)("path", {
                        d: "M295.639 -89.4242C302.268 -92.3825 306.701 -97.7617 313.076 -101.566C319.033 -105.118 325.108 -108.635 331.668 -111.085C339.31 -113.924 347.472 -115.035 355.635 -115.955C373.037 -117.918 391.272 -118.889 406.489 -115.249C417.839 -112.535 427.277 -107.378 433.397 -98.8575C441.137 -88.0784 442.779 -72.2659 441.468 -55.5617C441.335 -53.8804 441.195 -52.1908 441.012 -50.495C439.652 -37.5325 436.437 -24.1971 432.806 -11.2096C430.537 -3.11996 428.191 5.03838 424.285 12.0863C419.46 20.7842 411.356 26.1592 404.881 32.7071C394.158 43.5467 386.456 56.0405 381.626 67.4988C376.726 79.1197 373.997 91.7718 371.822 104.261C370.774 110.274 369.772 116.366 367.533 121.991C364.883 128.643 360.764 134.561 355.941 139.734C350.574 145.511 344.239 150.528 336.814 153.399C336.22 153.628 335.618 153.843 335.01 154.038C326.843 156.676 317.364 156.17 310.056 151.853C305.053 148.918 301.231 144.378 298.633 139.059C296.478 134.678 295.297 129.886 294.453 125.084C293.47 119.547 292.853 113.793 292.795 107.955C292.649 93.1426 296.151 78.0176 297.358 62.7093C297.947 55.2363 297.97 47.728 296.516 40.1842C293.576 24.8051 285.058 11.1842 285.606 -4.33871C285.906 -12.645 288.741 -20.7991 288.441 -28.7992C288.103 -37.8033 284.347 -44.8804 283.47 -52.9804C283.093 -56.4846 283.287 -60.1242 283.756 -63.7575C284.083 -66.2763 284.545 -68.7929 285.058 -71.2617C286.47 -78.1346 288.881 -86.4096 295.639 -89.4242Z",
                        stroke: "white",
                        strokeWidth: "8",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)("path", {
                        d: "M329.78 60.1696C330.066 62.9467 330.385 65.8009 331.68 68.2738C335.247 75.0738 345.326 76.2259 351.805 72.1051C358.283 67.9822 361.589 60.2592 362.96 52.7051C364.33 45.1509 364.149 37.378 365.56 29.83C366.451 25.0717 370.703 14.7175 375.549 2.22586C380.395 -10.2658 385.837 -24.8908 389.101 -38.1888C392.368 -51.4867 393.458 -63.4575 389.603 -70.6409C387.676 -74.2305 384.514 -76.6242 379.77 -77.3867C375.024 -78.1513 368.697 -77.2846 360.443 -74.3534C353.76 -71.9825 348.201 -68.7596 343.599 -64.8554C338.997 -60.9492 335.351 -56.3596 332.493 -51.2554C326.774 -41.045 324.208 -28.7721 323.443 -15.7762C322.683 -2.77831 323.726 10.9425 325.23 24.0467C326.735 37.1509 328.699 49.6384 329.78 60.1696Z",
                        stroke: "white",
                        strokeWidth: "8",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)("path", {
                        d: "M630.837 44.0196C624.25 52.203 614.324 56.8009 605.799 62.9384C597.274 69.0759 589.454 78.4426 590.706 88.8718C591.893 98.7489 600.781 105.866 609.735 110.197C618.689 114.53 628.629 117.382 636.027 124.034C643.956 131.163 647.977 142.395 646.375 152.936C645.472 158.861 643.014 165.291 645.962 170.509C647.633 173.466 650.754 175.318 653.927 176.528C665.027 180.753 677.377 178.557 689.252 178.711C701.129 178.868 714.72 182.845 719.262 193.818C721.766 199.861 720.95 206.87 723.375 212.945C728.966 226.961 747.316 229.111 762.108 232.107C814.558 242.728 855.183 295.066 852.46 348.512C851.581 365.799 847.296 385.207 857.937 398.86C865.779 408.922 879.287 412.257 891.752 414.966C909.239 418.762 929.716 421.853 943.127 410.007C950.775 403.251 954.227 393.053 957.364 383.343C966.244 355.882 975.123 328.424 984 300.966C986.577 292.995 989.162 284.987 990.473 276.712C992.55 263.609 991.352 250.093 987.81 237.309C984.458 225.214 978.971 213.622 971.004 203.922C957.637 187.643 938.137 177.511 923.8 162.078C900.56 137.059 891.843 99.2718 863.548 80.1551C842.191 65.7259 815.641 65.7759 791.464 59.6697C765.364 53.0801 745.295 38.9321 729.858 16.9592C713.341 -6.54916 697.183 -59.7513 659.489 -30.9721C635.485 -12.645 648.495 22.0863 630.837 44.0196Z",
                        stroke: "white",
                        strokeWidth: "8",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)("path", {
                        d: "M216.012 731.908C203.872 719.499 188.097 710.906 176.895 697.643C148.009 663.443 159.845 608.341 190.518 575.737C221.191 543.133 265.259 527.426 307.503 512.612C349.745 497.797 393.743 481.578 423.745 448.355C461.422 406.632 469.47 347.105 482.951 292.53C486.155 279.557 490.016 266.184 498.895 256.201C507.776 246.218 523.106 240.72 534.901 246.997C546.32 253.072 550.353 267.078 557.512 277.851C573.353 301.697 604.766 309.339 633.347 310.92C661.933 312.501 691.76 310.182 718.012 321.601C725.204 324.73 732.547 329.582 734.568 337.162C737.499 348.162 728.114 358.266 719.581 365.801L628.797 445.945C618.774 454.793 608.568 463.864 601.941 475.474C588.703 498.674 593.149 530.56 612.235 549.245C617.974 554.868 624.787 559.316 630.445 565.02C650.951 585.689 652.547 619.266 643.674 646.997C634.804 674.731 617.339 698.735 603.176 724.176C573.762 777.008 558.278 837.516 558.699 897.985C558.743 903.977 558.847 910.331 555.781 915.477C552.735 920.589 547.135 923.531 541.743 926.043C480.512 954.541 408.812 958.683 344.243 939.464C322.726 933.062 288.068 923.71 273.157 905.37C256.526 884.912 255.264 848.952 251.268 824.052C246.037 791.445 240.066 756.497 216.012 731.908Z",
                        stroke: "white",
                        strokeWidth: "8",
                        strokeMiterlimit: "10"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $kxTYF.jsx)("defs", {
                children: /*#__PURE__*/ (0, $kxTYF.jsx)("clipPath", {
                    id: "clip0_1139_3165",
                    children: /*#__PURE__*/ (0, $kxTYF.jsx)("rect", {
                        width: "640",
                        height: "320"
                    })
                })
            })
        ]
    });
}


function $3456399f909bb134$export$f55f1d663c7efb35({ imageSrc: imageSrc, imageAlt: imageAlt, showPlaceholder: showPlaceholder, title: title, subtitle: subtitle, description: description, tags: tags, to: to, renderMenu: renderMenu }) {
    const renderLink = (children)=>{
        return to ? /*#__PURE__*/ (0, $kxTYF.jsx)((0, $78d29a24c660df8a$export$2e2bcd8739ae039), {
            to: to,
            color: "inherit",
            children: children
        }) : /*#__PURE__*/ (0, $kxTYF.jsx)((0, $kxTYF.Fragment), {
            children: children
        });
    };
    const shouldUsePlaceholder = showPlaceholder && !imageSrc;
    return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $6b1f130f71952b48$export$60332b2344f7fe41), {
        as: "article",
        variant: "filled",
        children: [
            imageSrc && renderLink(/*#__PURE__*/ (0, $kxTYF.jsx)((0, $9d94326d5feb12f2$export$3e431a229df88919), {
                src: imageSrc,
                alt: imageAlt,
                width: "100%",
                aspectRatio: 2,
                objectFit: "cover",
                borderRadius: "md"
            })),
            shouldUsePlaceholder && renderLink(/*#__PURE__*/ (0, $kxTYF.jsx)((0, $98471c1be9617cb6$export$bc53e36006268bd5), {})),
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $b419a06f98d72db5$export$5665775b26e26c5d), {
                as: "header",
                children: /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                    direction: "row",
                    gap: 4,
                    children: [
                        (title || subtitle) && /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $9HGsN.Box), {
                            flexBasis: "100%",
                            children: [
                                title && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8651ef577e25eea6$export$a8a3e93435678ff9), {
                                    size: "sm",
                                    as: "h3",
                                    wordBreak: "break-word",
                                    children: renderLink(title)
                                }),
                                subtitle && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3963bf82c5559c75$export$5f1af8db9871e1d6), {
                                    as: "p",
                                    fontSize: "sm",
                                    color: "base.400",
                                    children: subtitle
                                })
                            ]
                        }),
                        renderMenu && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9HGsN.Box), {
                            children: renderMenu()
                        })
                    ]
                })
            }),
            description && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8a82c967ef8ca55a$export$851de33184ecdac4), {
                children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3963bf82c5559c75$export$5f1af8db9871e1d6), {
                    size: "md",
                    children: description
                })
            }),
            tags && tags.length > 0 && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $c3199ed83ca8041f$export$e9897d434e0741ee), {
                as: "footer",
                children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $ffc809ba2fb36850$export$15e411dc07b9c834), {
                    spacing: 2,
                    wrap: "wrap",
                    children: tags.map((tag)=>// <Tag key={tag} size='sm' colorScheme='primary' as='a' href='#'>
                        /*#__PURE__*/ (0, $kxTYF.jsx)((0, $beacec6ac7efe0d9$export$3288d34c523a1192), {
                            size: "sm",
                            colorScheme: "primary",
                            children: tag
                        }, tag))
                })
            })
        ]
    });
}
function $3456399f909bb134$export$d49dc2f4fca0ae8c(props) {
    return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $6b1f130f71952b48$export$60332b2344f7fe41), {
        as: "article",
        variant: "filled",
        p: 8,
        children: [
            /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                direction: "column",
                gap: 2,
                children: [
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $408225e060551a18$export$8f31e4c4a37b8e9c), {
                        h: 6,
                        width: "40%"
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $408225e060551a18$export$8f31e4c4a37b8e9c), {
                        h: 4,
                        width: "30%"
                    })
                ]
            }),
            !props.mini && /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $kxTYF.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $2fb4f0d945397efb$export$cb6ddd830302c2a8), {
                        mt: 8,
                        noOfLines: 4,
                        spacing: "4",
                        skeletonHeight: "2"
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                        gap: 2,
                        mt: 12,
                        children: [
                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $408225e060551a18$export$8f31e4c4a37b8e9c), {
                                h: 4,
                                width: 12
                            }),
                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $408225e060551a18$export$8f31e4c4a37b8e9c), {
                                h: 4,
                                width: 12
                            }),
                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $408225e060551a18$export$8f31e4c4a37b8e9c), {
                                h: 4,
                                width: 12
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");



const $43aa0a8514afe58f$export$c8d4523fa9306542 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    const { isEnabled: isEnabled, isAuthenticated: isAuthenticated } = (0, $c837ac9c698038bc$export$1d39dc5b47e56ff0)();
    if (!isEnabled) return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $b8b7f6458056e8af$export$353f5b6fc5456de1), {
        ref: ref,
        as: (0, $78d29a24c660df8a$export$2e2bcd8739ae039),
        ...props
    });
    return isAuthenticated && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $b8b7f6458056e8af$export$353f5b6fc5456de1), {
        ref: ref,
        as: (0, $78d29a24c660df8a$export$2e2bcd8739ae039),
        ...props
    });
});



var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");


const $488a343786980c50$export$6831baa95aeeaf1e = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    const { isEnabled: isEnabled, isAuthenticated: isAuthenticated } = (0, $c837ac9c698038bc$export$1d39dc5b47e56ff0)();
    if (!isEnabled) return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $293887a95e6a8bc4$export$2ce376c2cc3355c8), {
        ref: ref,
        ...props
    });
    return isAuthenticated && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $293887a95e6a8bc4$export$2ce376c2cc3355c8), {
        ref: ref,
        ...props
    });
});


/**
 * Rounds a number to a specified amount of decimals.
 *
 * @param {number} value The value to round
 * @param {number} decimals The number of decimals to keep. Default to 2
 */ function $f55c5bb8e60e90fc$export$2077e0241d6afd3c(value, decimals = 2) {
    return Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
}
function $f55c5bb8e60e90fc$export$7ecd32ca6b3ae583(value, decimals = 2) {
    if (value / 1e9 >= 1) return {
        num: $f55c5bb8e60e90fc$export$2077e0241d6afd3c(value / 1e9, decimals),
        unit: "B"
    };
    else if (value / 1e6 >= 1) return {
        num: $f55c5bb8e60e90fc$export$2077e0241d6afd3c(value / 1e6, decimals),
        unit: "M"
    };
    else if (value / 1e3 >= 1) return {
        num: $f55c5bb8e60e90fc$export$2077e0241d6afd3c(value / 1e3, decimals),
        unit: "K"
    };
    return {
        num: value,
        unit: ""
    };
}
function $f55c5bb8e60e90fc$export$aa9294712332dc16(num, options) {
    const opts = {
        decimals: 2,
        separator: ",",
        forceDecimals: false,
        shorten: false,
        ...options
    };
    // isNaN(null) === true
    if (isNaN(num) || !num && num !== 0) return "--";
    const repeat = (char, length)=>{
        let str = "";
        for(let i = 0; i < length; i++)str += char + "";
        return str;
    };
    const sign = num < 0 ? "-" : "";
    const absNum = Math.abs(num);
    let [int, dec] = Number($f55c5bb8e60e90fc$export$2077e0241d6afd3c(absNum, opts.decimals)).toString().split(".");
    let largeNumUnit = "";
    if (opts.shorten) {
        const { num: num, unit: unit } = $f55c5bb8e60e90fc$export$7ecd32ca6b3ae583(Number(int), 0);
        int = num.toString();
        largeNumUnit = unit;
    }
    // Space the integer part of the number.
    int = int.replace(/\B(?=(\d{3})+(?!\d))/g, opts.separator);
    // Round the decimals.
    dec = (dec || "").substring(0, opts.decimals);
    // Add decimals if forced.
    dec = opts.forceDecimals ? `${dec}${repeat("0", opts.decimals - dec.length)}` : dec;
    return dec !== "" ? `${sign}${int}.${dec} ${largeNumUnit}` : `${sign}${int} ${largeNumUnit}`;
}
function $f55c5bb8e60e90fc$export$3cdc770bf8b2ed3d(num, length = 2) {
    const prefix = num < 0 ? "-" : "";
    const abdsNum = Math.abs(num);
    const wholeNum = Math.floor(abdsNum);
    const padLength = Math.max(length - String(wholeNum).length, 0);
    const pads = new Array(padLength + 1).join("0");
    return prefix + pads + abdsNum;
}
function $f55c5bb8e60e90fc$export$a5c7fd3700da7bdd(num, decimals = 2) {
    if (!isFinite(num)) return `${Math.sign(num) === -1 ? "-" : ""}\u{221E}`;
    const [coefficient, exponent] = num.toExponential().split("e").map((item)=>Number(item));
    const sups = "\u2070\xb9\xb2\xb3\u2074\u2075\u2076\u2077\u2078\u2079";
    const exponentSup = Math.abs(exponent).toString().split("").map((v)=>sups[Number(v)]).join("");
    const sign = exponent < 0 ? "\u207B" : "";
    return `${$f55c5bb8e60e90fc$export$2077e0241d6afd3c(coefficient, decimals)}x10${sign}${exponentSup}`;
}
function $f55c5bb8e60e90fc$export$7d15b64cf5a3a4c4(num, min, max) {
    return Math.min(Math.max(num, min), max);
}


/**
 * Why this file exists:
 * @developmentseed/stac-react does not allow to change the limit and offset of
 * the collections endpoint. This file is a temporary workaround to allow
 * pagination.
 */ 

var $8v0nu = parcelRequire("8v0nu");

const $2109a06c072f006f$var$debounce = (fn, ms = 250)=>{
    let timeoutId;
    return function(...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>fn.apply(this, args), ms);
    };
};
function $2109a06c072f006f$export$2b5787016ed09c4d(opts) {
    const { limit: limit = 10, initialOffset: initialOffset = 0 } = opts || {};
    const { token: token } = (0, $c837ac9c698038bc$export$1d39dc5b47e56ff0)();
    const stacApiOptions = (0, $8v0nu.useMemo)(()=>token ? {
            headers: {
                Authorization: `Bearer ${token}`
            }
        } : undefined, [
        token
    ]);
    const { stacApi: stacApi } = (0, $eba44fb2c963ffed$export$d5f91e9964fa0ed1)("https://eoapi.develop.eoepca.org/stac/", stacApiOptions);
    const [collections, setCollections] = (0, $8v0nu.useState)();
    const [state, setState] = (0, $8v0nu.useState)("IDLE");
    const [error, setError] = (0, $8v0nu.useState)();
    const [offset, setOffset] = (0, $8v0nu.useState)(initialOffset);
    const [hasNext, setHasNext] = (0, $8v0nu.useState)(false);
    const [hasPrev, setHasPrev] = (0, $8v0nu.useState)(false);
    const _getCollections = (0, $8v0nu.useCallback)(async (offset, limit)=>{
        if (stacApi) {
            setState("LOADING");
            try {
                const res = await stacApi.fetch(`${stacApi.baseUrl}/collections?limit=${limit}&offset=${offset}`);
                const data = await res.json();
                setHasNext(!!data.links.find((l)=>l.rel === "next"));
                setHasPrev(!!data.links.find((l)=>[
                        "prev",
                        "previous"
                    ].includes(l.rel)));
                setCollections(data);
            } catch (err) {
                setError(err);
                setCollections(undefined);
            } finally{
                setState("IDLE");
            }
        }
    }, [
        stacApi
    ]);
    const getCollections = (0, $8v0nu.useCallback)((offset, limit)=>$2109a06c072f006f$var$debounce(()=>_getCollections(offset, limit))(), [
        _getCollections
    ]);
    const nextPage = (0, $8v0nu.useCallback)(()=>{
        setOffset(offset + limit);
    }, [
        offset,
        limit
    ]);
    const prevPage = (0, $8v0nu.useCallback)(()=>{
        setOffset(offset - limit);
    }, [
        offset,
        limit
    ]);
    (0, $8v0nu.useEffect)(()=>{
        if (stacApi && !error && !collections) getCollections(offset, limit);
    }, [
        getCollections,
        stacApi,
        collections,
        error,
        offset,
        limit
    ]);
    return {
        collections: collections,
        reload: (0, $8v0nu.useCallback)(()=>getCollections(offset, limit), [
            getCollections,
            offset,
            limit
        ]),
        nextPage: hasNext ? nextPage : undefined,
        prevPage: hasPrev ? prevPage : undefined,
        setOffset: setOffset,
        state: state,
        error: error
    };
}


function $16109d62536d0cfb$var$CollectionList() {
    (0, $aec39e40387762bd$export$2e2bcd8739ae039)("Collections");
    // const [urlParams, setUrlParams] = useSearchParams({ page: '1' });
    // const page = parseInt(urlParams.get('page') || '1', 10);
    // const setPage = useCallback(
    //   (v: number | ((v: number) => number)) => {
    //     const newVal = typeof v === 'function' ? v(page) : v;
    //     setUrlParams({ page: newVal.toString() });
    //   },
    //   [page]
    // );
    const { collections: collections, state: state } = (0, $2109a06c072f006f$export$2b5787016ed09c4d)({
        limit: 1000
    });
    // Quick search system.
    const [searchTerm, setSearchTerm] = (0, $8v0nu.useState)("");
    const [keyword, setKeyword] = (0, $8v0nu.useState)("");
    const keywords = (0, $8v0nu.useMemo)(()=>{
        if (!collections) return [];
        const k = collections.collections.reduce((acc, col)=>[
                ...acc,
                ...col.keywords || []
            ], []);
        return Array.from(new Set(k));
    }, [
        collections
    ]);
    const filteredCollections = (0, $8v0nu.useMemo)(()=>{
        if (!collections) return [];
        return collections.collections.filter((col)=>{
            const title = col.title?.toLowerCase();
            const description = col.description?.toLowerCase();
            const term = searchTerm.toLowerCase().trim();
            const foundTerm = !term || title?.includes(term) || description?.includes(term);
            const keywords = col.keywords || [];
            const key = keyword.toLowerCase();
            const foundKeyword = !key || keywords.find((k)=>k.toLowerCase() === key);
            return foundTerm && foundKeyword;
        });
    }, [
        collections,
        searchTerm,
        keyword
    ]);
    const collectionsCount = collections?.numberMatched || 0;
    // const collectionsReturned = collections?.numberReturned || 0;
    // const numPages = Math.ceil(collectionsCount / pageSize);
    // const shouldPaginate = collectionsCount > collectionsReturned;
    return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
        direction: "column",
        gap: 8,
        children: [
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $dfd76aae8c4830bc$export$644c29b44a905178), {
                title: "Catalog",
                overline: "Browsing",
                actions: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $43aa0a8514afe58f$export$c8d4523fa9306542), {
                    colorScheme: "primary",
                    to: "/collections/new",
                    leftIcon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$3a9f56a1d1f9a714), {}),
                    children: "Create"
                })
            }),
            /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                direction: "column",
                gap: "8",
                as: "section",
                children: [
                    /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                        direction: "row",
                        px: "8",
                        gap: "8",
                        as: "header",
                        children: [
                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9HGsN.Box), {
                                flexBasis: "100%",
                                children: /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $8651ef577e25eea6$export$a8a3e93435678ff9), {
                                    size: "md",
                                    as: "h2",
                                    children: [
                                        "Collections",
                                        " ",
                                        !!collectionsCount && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $6cea469a0e58db34$export$37acb3580601e69a), {
                                            variant: "solid",
                                            children: (0, $f55c5bb8e60e90fc$export$3cdc770bf8b2ed3d)(collectionsCount)
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                                direction: "row",
                                gap: "4",
                                children: [
                                    /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                                        direction: "row",
                                        gap: "2",
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8651ef577e25eea6$export$a8a3e93435678ff9), {
                                                size: "xs",
                                                as: "h3",
                                                children: "Search"
                                            }),
                                            /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $5678c8a868262504$export$6e5a9cd40e0c9b97), {
                                                width: "16rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3d8cf0c200c5d2d0$export$f5b8910cec6cf069), {
                                                        type: "search",
                                                        placeholder: "Title or description",
                                                        onChange: (e)=>setSearchTerm(e.target.value)
                                                    }),
                                                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $0f6ca7b518b921a6$export$8a7b8bdd4608e7e3), {
                                                        pointerEvents: "none",
                                                        children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$89ad07d969809ef0), {})
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                                        direction: "row",
                                        gap: "2",
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8651ef577e25eea6$export$a8a3e93435678ff9), {
                                                size: "xs",
                                                as: "h3",
                                                children: "Filter"
                                            }),
                                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $10c1d0a50fcf4e99$export$ef9b1a59e592288f), {
                                                placeholder: "All keywords",
                                                size: "md",
                                                width: "12rem",
                                                onChange: (e)=>setKeyword(e.target.value),
                                                children: keywords.map((k)=>/*#__PURE__*/ (0, $kxTYF.jsx)("option", {
                                                        value: k,
                                                        children: k
                                                    }, k))
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $97afd073f9746d02$export$de97fecb6d4b30a5), {
                        gap: 8,
                        templateColumns: "repeat(auto-fill, minmax(26rem, 1fr))",
                        children: !collections || state === "LOADING" ? /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $kxTYF.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3456399f909bb134$export$d49dc2f4fca0ae8c), {}),
                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3456399f909bb134$export$d49dc2f4fca0ae8c), {})
                            ]
                        }) : filteredCollections.map((col)=>/*#__PURE__*/ (0, $kxTYF.jsx)((0, $3456399f909bb134$export$f55f1d663c7efb35), {
                                imageSrc: col.assets?.thumbnail?.href,
                                imageAlt: col.assets?.thumbnail?.title,
                                showPlaceholder: true,
                                title: col.title || col.id,
                                description: col.description,
                                tags: col.keywords,
                                to: `/collections/${col.id}/`,
                                renderMenu: ()=>/*#__PURE__*/ (0, $kxTYF.jsxs)((0, $bbc1594d228c6000$export$d9b273488cd8ce6f), {
                                        placement: "bottom-end",
                                        children: [
                                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $5277a93d60858aae$export$266a769812832828), {
                                                as: (0, $5f067ccb39c91cbc$export$c25acd513dcc8062),
                                                "aria-label": "Options",
                                                icon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$b307b75901e71920), {}),
                                                variant: "soft-outline",
                                                colorScheme: "base",
                                                size: "sm"
                                            }),
                                            /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $caedd5fbd169c955$export$d4c4e98c5044dc8), {
                                                children: [
                                                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $293887a95e6a8bc4$export$2ce376c2cc3355c8), {
                                                        as: (0, $78d29a24c660df8a$export$2e2bcd8739ae039),
                                                        to: `/collections/${col.id}/`,
                                                        icon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$3b8ef319a6c5f131), {}),
                                                        children: "View"
                                                    }),
                                                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $488a343786980c50$export$6831baa95aeeaf1e), {
                                                        as: (0, $78d29a24c660df8a$export$2e2bcd8739ae039),
                                                        to: `/collections/${col.id}/edit`,
                                                        icon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$b8f31e9a5cf17074), {}),
                                                        children: "Edit"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                            }, col.id))
                    })
                ]
            })
        ]
    });
}
var $16109d62536d0cfb$export$2e2bcd8739ae039 = $16109d62536d0cfb$var$CollectionList;



var $kxTYF = parcelRequire("kxTYF");

var $8v0nu = parcelRequire("8v0nu");

var $9HGsN = parcelRequire("9HGsN");
var $8v0nu = parcelRequire("8v0nu");

var $cSr1Y = parcelRequire("cSr1Y");

"use client";
function $9b0a17af928224b0$export$5b03f73d5fd4425(position, dir) {
    const computedPosition = position ?? "bottom";
    const logicals = {
        "top-start": {
            ltr: "top-left",
            rtl: "top-right"
        },
        "top-end": {
            ltr: "top-right",
            rtl: "top-left"
        },
        "bottom-start": {
            ltr: "bottom-left",
            rtl: "bottom-right"
        },
        "bottom-end": {
            ltr: "bottom-right",
            rtl: "bottom-left"
        }
    };
    const logical = logicals[computedPosition];
    return logical?.[dir] ?? computedPosition;
}



"use client";
function $fb15445de6e88785$export$f3af62d19eb14261(dir, defaultOptions) {
    const normalizeToastOptions = (options)=>({
            ...defaultOptions,
            ...options,
            position: (0, $9b0a17af928224b0$export$5b03f73d5fd4425)(options?.position ?? defaultOptions?.position, dir)
        });
    const toast = (options)=>{
        const normalizedToastOptions = normalizeToastOptions(options);
        const Message = (0, $2e391be1c055dce0$export$d9d796c483697359)(normalizedToastOptions);
        return (0, $3f045d9ec09af1a6$export$e80fa18a42ed98ef).notify(Message, normalizedToastOptions);
    };
    toast.update = (id, options)=>{
        (0, $3f045d9ec09af1a6$export$e80fa18a42ed98ef).update(id, normalizeToastOptions(options));
    };
    toast.promise = (promise, options)=>{
        const id = toast({
            ...options.loading,
            status: "loading",
            duration: null
        });
        promise.then((data)=>toast.update(id, {
                status: "success",
                duration: 5e3,
                ...(0, $cSr1Y.runIfFn)(options.success, data)
            })).catch((error)=>toast.update(id, {
                status: "error",
                duration: 5e3,
                ...(0, $cSr1Y.runIfFn)(options.error, error)
            }));
    };
    toast.closeAll = (0, $3f045d9ec09af1a6$export$e80fa18a42ed98ef).closeAll;
    toast.close = (0, $3f045d9ec09af1a6$export$e80fa18a42ed98ef).close;
    toast.isActive = (0, $3f045d9ec09af1a6$export$e80fa18a42ed98ef).isActive;
    return toast;
}




"use client";
function $0ba8f0382a5131e9$export$a407b657d3044108(options) {
    const { theme: theme } = (0, $0023d2f189964130$export$a513a93efd9ab8a7)();
    const defaultOptions = (0, $2a35b1f793a340fa$export$7c4af276256dc908)();
    return (0, $8v0nu.useMemo)(()=>(0, $fb15445de6e88785$export$f3af62d19eb14261)(theme.direction, {
            ...defaultOptions,
            ...options
        }), [
        options,
        theme.direction,
        defaultOptions
    ]);
}





var $8v0nu = parcelRequire("8v0nu");
const $e60c4cd554136647$export$b919fd560f065399 = "https://eoapi.develop.eoepca.org/stac/"?.replace(/\/+$/, "");
// Authed fetcher for direct (non-stac-react) calls to the STAC API — used by
// mutations (PUT/POST/DELETE) and any reads outside the stac-react hook tree.
// Each instance is immutable; the bridge constructs a new one when the token
// changes, which propagates to consumers via ApiContext.
class $e60c4cd554136647$var$Api {
    token;
    stacBaseUrl;
    constructor(token, stacBaseUrl = $e60c4cd554136647$export$b919fd560f065399){
        this.token = token;
        this.stacBaseUrl = stacBaseUrl;
    }
    // Scope guard: only attach Authorization for URLs under the configured STAC
    // base. Prevents leaking the bearer to OIDC discovery, static assets, or
    // unrelated third-party origins. Path-boundary check ensures `/stac-admin`
    // does not match a `/stac` base.
    isStacUrl(url) {
        if (!this.stacBaseUrl) return false;
        return url === this.stacBaseUrl || url.startsWith(`${this.stacBaseUrl}/`);
    }
    fetch(url, options = {}) {
        const injected = this.token && this.isStacUrl(url) ? {
            Authorization: `Bearer ${this.token}`
        } : {};
        // Caller-provided headers win on collision, so a caller can override the
        // injected Authorization (e.g. force an explicit anonymous request).
        const finalOptions = {
            ...options,
            headers: {
                ...injected,
                ...options.headers || {}
            }
        };
        return fetch(url, finalOptions).then(async (response)=>{
            if (response.ok) return response.json();
            const { status: status, statusText: statusText } = response;
            const e = {
                status: status,
                statusText: statusText
            };
            // Some STAC APIs return errors as JSON others as string.
            // Clone the response so we can read the body as text if json fails.
            const clone = response.clone();
            try {
                e.detail = await response.json();
            /* eslint-disable-next-line @typescript-eslint/no-unused-vars */ } catch (err) {
                e.detail = await clone.text();
            }
            return Promise.reject(e);
        });
    }
}
const $e60c4cd554136647$export$f6d52655da4aa77d = (0, $8v0nu.createContext)(null);
function $e60c4cd554136647$export$eb2799109db70ffd() {
    const api = (0, $8v0nu.useContext)($e60c4cd554136647$export$f6d52655da4aa77d);
    if (!api) throw new Error("useApi must be used within an ApiContext.Provider");
    return api;
}
var $e60c4cd554136647$export$2e2bcd8739ae039 = $e60c4cd554136647$var$Api;



var $kxTYF = parcelRequire("kxTYF");

var $8v0nu = parcelRequire("8v0nu");

var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");

var $kxTYF = parcelRequire("kxTYF");





var $3lBLT = parcelRequire("3lBLT");
"use client";
const $247622d5d37db5f3$export$52f0f02147b12c03 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function Code2(props, ref) {
    const styles = (0, $c7d173d35275482d$export$b863f77547fbcb03)("Code", props);
    const { className: className, ...rest } = (0, $58ff34c9d17adf03$export$adfcf5a5e4d17785)(props);
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).code, {
        ref: ref,
        className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-code", props.className),
        ...rest,
        __css: {
            display: "inline-block",
            ...styles
        }
    });
});
$247622d5d37db5f3$export$52f0f02147b12c03.displayName = "Code";



var $jTKGQ = parcelRequire("jTKGQ");

var $kxTYF = parcelRequire("kxTYF");

var $8v0nu = parcelRequire("8v0nu");
// Plugin context provider
const $a8feea9ca12f00da$var$PluginContext = /*#__PURE__*/ (0, $8v0nu.createContext)(undefined);
const $a8feea9ca12f00da$export$cb523441152b28bb = (props)=>{
    return /*#__PURE__*/ (0, $kxTYF.jsx)($a8feea9ca12f00da$var$PluginContext.Provider, {
        value: props.plugin,
        children: props.children
    });
};
const $a8feea9ca12f00da$export$56d29ed512ea644 = ()=>{
    const plugin = (0, $8v0nu.useContext)($a8feea9ca12f00da$var$PluginContext);
    if (!plugin) throw new Error("usePlugin must be used within a PluginProvider");
    return plugin;
};


/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars */ const $c0a25ef586f9da64$var$HIDDEN = Symbol("hidden");
const $c0a25ef586f9da64$var$HOOKS = Symbol("hooks");
class $c0a25ef586f9da64$export$901cf72dabf2112a {
    static HIDDEN = $c0a25ef586f9da64$var$HIDDEN;
    static HOOKS = $c0a25ef586f9da64$var$HOOKS;
    [$c0a25ef586f9da64$var$HOOKS] = [];
    name = "Plugin";
    init(data) {}
    editSchema(formData) {
        return undefined;
    }
    enterData(data) {
        throw new Error(`Plugin [${this.name}] must implement enterData`);
    }
    exitData(data) {
        throw new Error(`Plugin [${this.name}] must implement exitData`);
    }
    /**
   * Registers a hook to be applied on a given plugin.
   *
   * @param targetName - The name of the target plugin to which the hook will be
   * applied.
   * @param hookName - The name of the hook.
   * @param hook - The hook function.
   */ registerHook(targetName, hookName, hook) {
        const hookEntry = this[$c0a25ef586f9da64$export$901cf72dabf2112a.HOOKS].find((h)=>h.name === targetName);
        if (hookEntry) hookEntry[hookName] = hook;
        else this[$c0a25ef586f9da64$export$901cf72dabf2112a.HOOKS].push({
            name: targetName,
            [hookName]: hook
        });
    }
}



var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");

const $f49fc02b2c636efe$export$f04a3ea04edc0e04 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>/*#__PURE__*/ (0, $kxTYF.jsx)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
        ref: ref,
        maxW: "container.md",
        alignItems: "center",
        direction: "column",
        gap: 4,
        py: 16,
        px: 8,
        color: "red.500",
        borderRadius: "md",
        borderWidth: 1,
        borderStyle: "dashed",
        borderColor: "red.500",
        ...props
    }));


function $4f2b90a8dcc95f5b$export$6a4d9223b7302baa(props) {
    const { plugin: plugin, children: children } = props;
    const { values: values } = (0, $jTKGQ.useFormikContext)();
    const editSchema = plugin.editSchema(values);
    if (!editSchema) return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $f49fc02b2c636efe$export$f04a3ea04edc0e04), {
        "data-testid": "plugin-box-error",
        children: [
            "Plugin ",
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $247622d5d37db5f3$export$52f0f02147b12c03), {
                color: "red",
                children: plugin.name
            }),
            " has no edit schema."
        ]
    });
    if (editSchema === (0, $c0a25ef586f9da64$export$901cf72dabf2112a).HIDDEN) return null;
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $a8feea9ca12f00da$export$cb523441152b28bb), {
        plugin: plugin,
        children: children({
            field: editSchema
        })
    });
}


var $8v0nu = parcelRequire("8v0nu");

var $jTKGQ = parcelRequire("jTKGQ");
var $75b98c86abc67c8e$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ "use strict";
function $75b98c86abc67c8e$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$75b98c86abc67c8e$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$75b98c86abc67c8e$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$75b98c86abc67c8e$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $75b98c86abc67c8e$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $75b98c86abc67c8e$var$DIGIT_REGEX = /^\d+$/, $75b98c86abc67c8e$var$LEAD_DIGIT_REGEX = /^\d/, $75b98c86abc67c8e$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $75b98c86abc67c8e$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $75b98c86abc67c8e$var$MAX_CACHE_SIZE = 512;
var $75b98c86abc67c8e$var$pathCache = new $75b98c86abc67c8e$var$Cache($75b98c86abc67c8e$var$MAX_CACHE_SIZE), $75b98c86abc67c8e$var$setCache = new $75b98c86abc67c8e$var$Cache($75b98c86abc67c8e$var$MAX_CACHE_SIZE), $75b98c86abc67c8e$var$getCache = new $75b98c86abc67c8e$var$Cache($75b98c86abc67c8e$var$MAX_CACHE_SIZE);
var $75b98c86abc67c8e$var$config;
$75b98c86abc67c8e$exports = {
    Cache: $75b98c86abc67c8e$var$Cache,
    split: $75b98c86abc67c8e$var$split,
    normalizePath: $75b98c86abc67c8e$var$normalizePath,
    setter: function(path) {
        var parts = $75b98c86abc67c8e$var$normalizePath(path);
        return $75b98c86abc67c8e$var$setCache.get(path) || $75b98c86abc67c8e$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === "__proto__" || part === "constructor" || part === "prototype") return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $75b98c86abc67c8e$var$normalizePath(path);
        return $75b98c86abc67c8e$var$getCache.get(path) || $75b98c86abc67c8e$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($75b98c86abc67c8e$var$isQuoted(part) || $75b98c86abc67c8e$var$DIGIT_REGEX.test(part) ? "[" + part + "]" : (path ? "." : "") + part);
        }, "");
    },
    forEach: function(path, cb, thisArg) {
        $75b98c86abc67c8e$var$forEach(Array.isArray(path) ? path : $75b98c86abc67c8e$var$split(path), cb, thisArg);
    }
};
function $75b98c86abc67c8e$var$normalizePath(path) {
    return $75b98c86abc67c8e$var$pathCache.get(path) || $75b98c86abc67c8e$var$pathCache.set(path, $75b98c86abc67c8e$var$split(path).map(function(part) {
        return part.replace($75b98c86abc67c8e$var$CLEAN_QUOTES_REGEX, "$2");
    }));
}
function $75b98c86abc67c8e$var$split(path) {
    return path.match($75b98c86abc67c8e$var$SPLIT_REGEX) || [
        ""
    ];
}
function $75b98c86abc67c8e$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($75b98c86abc67c8e$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $75b98c86abc67c8e$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $75b98c86abc67c8e$var$isQuoted(str) {
    return typeof str === "string" && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $75b98c86abc67c8e$var$hasLeadingNumber(part) {
    return part.match($75b98c86abc67c8e$var$LEAD_DIGIT_REGEX) && !part.match($75b98c86abc67c8e$var$DIGIT_REGEX);
}
function $75b98c86abc67c8e$var$hasSpecialChars(part) {
    return $75b98c86abc67c8e$var$SPEC_CHAR_REGEX.test(part);
}
function $75b98c86abc67c8e$var$shouldBeQuoted(part) {
    return !$75b98c86abc67c8e$var$isQuoted(part) && ($75b98c86abc67c8e$var$hasLeadingNumber(part) || $75b98c86abc67c8e$var$hasSpecialChars(part));
}


var $a214d9c9202f8fd9$exports = {};
const $a214d9c9202f8fd9$var$reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
const $a214d9c9202f8fd9$var$words = (str)=>str.match($a214d9c9202f8fd9$var$reWords) || [];
const $a214d9c9202f8fd9$var$upperFirst = (str)=>str[0].toUpperCase() + str.slice(1);
const $a214d9c9202f8fd9$var$join = (str, d)=>$a214d9c9202f8fd9$var$words(str).join(d).toLowerCase();
const $a214d9c9202f8fd9$var$camelCase = (str)=>$a214d9c9202f8fd9$var$words(str).reduce((acc, next)=>`${acc}${!acc ? next.toLowerCase() : next[0].toUpperCase() + next.slice(1).toLowerCase()}`, "");
const $a214d9c9202f8fd9$var$pascalCase = (str)=>$a214d9c9202f8fd9$var$upperFirst($a214d9c9202f8fd9$var$camelCase(str));
const $a214d9c9202f8fd9$var$snakeCase = (str)=>$a214d9c9202f8fd9$var$join(str, "_");
const $a214d9c9202f8fd9$var$kebabCase = (str)=>$a214d9c9202f8fd9$var$join(str, "-");
const $a214d9c9202f8fd9$var$sentenceCase = (str)=>$a214d9c9202f8fd9$var$upperFirst($a214d9c9202f8fd9$var$join(str, " "));
const $a214d9c9202f8fd9$var$titleCase = (str)=>$a214d9c9202f8fd9$var$words(str).map($a214d9c9202f8fd9$var$upperFirst).join(" ");
$a214d9c9202f8fd9$exports = {
    words: $a214d9c9202f8fd9$var$words,
    upperFirst: $a214d9c9202f8fd9$var$upperFirst,
    camelCase: $a214d9c9202f8fd9$var$camelCase,
    pascalCase: $a214d9c9202f8fd9$var$pascalCase,
    snakeCase: $a214d9c9202f8fd9$var$snakeCase,
    kebabCase: $a214d9c9202f8fd9$var$kebabCase,
    sentenceCase: $a214d9c9202f8fd9$var$sentenceCase,
    titleCase: $a214d9c9202f8fd9$var$titleCase
};


var $fc86160b8cf91a0e$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $fc86160b8cf91a0e$exports = function(edges) {
    return $fc86160b8cf91a0e$var$toposort($fc86160b8cf91a0e$var$uniqueNodes(edges), edges);
};
$fc86160b8cf91a0e$exports.array = $fc86160b8cf91a0e$var$toposort;
function $fc86160b8cf91a0e$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $fc86160b8cf91a0e$var$makeOutgoingEdges(edges), nodesHash = $fc86160b8cf91a0e$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error("Cyclic dependency" + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $fc86160b8cf91a0e$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $fc86160b8cf91a0e$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $fc86160b8cf91a0e$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}


const $1b19c6085a6e9611$var$toString = Object.prototype.toString;
const $1b19c6085a6e9611$var$errorToString = Error.prototype.toString;
const $1b19c6085a6e9611$var$regExpToString = RegExp.prototype.toString;
const $1b19c6085a6e9611$var$symbolToString = typeof Symbol !== "undefined" ? Symbol.prototype.toString : ()=>"";
const $1b19c6085a6e9611$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $1b19c6085a6e9611$var$printNumber(val) {
    if (val != +val) return "NaN";
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? "-0" : "" + val;
}
function $1b19c6085a6e9611$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return "" + val;
    const typeOf = typeof val;
    if (typeOf === "number") return $1b19c6085a6e9611$var$printNumber(val);
    if (typeOf === "string") return quoteStrings ? `"${val}"` : val;
    if (typeOf === "function") return "[Function " + (val.name || "anonymous") + "]";
    if (typeOf === "symbol") return $1b19c6085a6e9611$var$symbolToString.call(val).replace($1b19c6085a6e9611$var$SYMBOL_REGEXP, "Symbol($1)");
    const tag = $1b19c6085a6e9611$var$toString.call(val).slice(8, -1);
    if (tag === "Date") return isNaN(val.getTime()) ? "" + val : val.toISOString(val);
    if (tag === "Error" || val instanceof Error) return "[" + $1b19c6085a6e9611$var$errorToString.call(val) + "]";
    if (tag === "RegExp") return $1b19c6085a6e9611$var$regExpToString.call(val);
    return null;
}
function $1b19c6085a6e9611$export$5790025c6e6c2ba6(value, quoteStrings) {
    let result = $1b19c6085a6e9611$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $1b19c6085a6e9611$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}
function $1b19c6085a6e9611$var$toArray(value) {
    return value == null ? [] : [].concat(value);
}
let $1b19c6085a6e9611$var$_Symbol$toStringTag, $1b19c6085a6e9611$var$_Symbol$hasInstance, $1b19c6085a6e9611$var$_Symbol$toStringTag2;
let $1b19c6085a6e9611$var$strReg = /\$\{\s*(\w+)\s*\}/g;
$1b19c6085a6e9611$var$_Symbol$toStringTag = Symbol.toStringTag;
class $1b19c6085a6e9611$var$ValidationErrorNoStack {
    constructor(errorOrErrors, value, field, type){
        this.name = void 0;
        this.message = void 0;
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = void 0;
        this.inner = void 0;
        this[$1b19c6085a6e9611$var$_Symbol$toStringTag] = "Error";
        this.name = "ValidationError";
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        $1b19c6085a6e9611$var$toArray(errorOrErrors).forEach((err)=>{
            if ($1b19c6085a6e9611$export$2191b9da168c6cf0.isError(err)) {
                this.errors.push(...err.errors);
                const innerErrors = err.inner.length ? err.inner : [
                    err
                ];
                this.inner.push(...innerErrors);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    }
}
$1b19c6085a6e9611$var$_Symbol$hasInstance = Symbol.hasInstance;
$1b19c6085a6e9611$var$_Symbol$toStringTag2 = Symbol.toStringTag;
class $1b19c6085a6e9611$export$2191b9da168c6cf0 extends Error {
    static formatError(message, params) {
        // Attempt to make the path more friendly for error message interpolation.
        const path = params.label || params.path || "this";
        // Store the original path under `originalPath` so it isn't lost to custom
        // message functions; e.g., ones provided in `setLocale()` calls.
        params = Object.assign({}, params, {
            path: path,
            originalPath: params.path
        });
        if (typeof message === "string") return message.replace($1b19c6085a6e9611$var$strReg, (_, key)=>$1b19c6085a6e9611$export$5790025c6e6c2ba6(params[key]));
        if (typeof message === "function") return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === "ValidationError";
    }
    constructor(errorOrErrors, value, field, type, disableStack){
        const errorNoStack = new $1b19c6085a6e9611$var$ValidationErrorNoStack(errorOrErrors, value, field, type);
        if (disableStack) return errorNoStack;
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = [];
        this.inner = [];
        this[$1b19c6085a6e9611$var$_Symbol$toStringTag2] = "Error";
        this.name = errorNoStack.name;
        this.message = errorNoStack.message;
        this.type = errorNoStack.type;
        this.value = errorNoStack.value;
        this.path = errorNoStack.path;
        this.errors = errorNoStack.errors;
        this.inner = errorNoStack.inner;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $1b19c6085a6e9611$export$2191b9da168c6cf0);
    }
    static [$1b19c6085a6e9611$var$_Symbol$hasInstance](inst) {
        return $1b19c6085a6e9611$var$ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
    }
}
let $1b19c6085a6e9611$var$mixed = {
    default: "${path} is invalid",
    required: "${path} is a required field",
    defined: "${path} must be defined",
    notNull: "${path} cannot be null",
    oneOf: "${path} must be one of the following values: ${values}",
    notOneOf: "${path} must not be one of the following values: ${values}",
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${$1b19c6085a6e9611$export$5790025c6e6c2ba6(originalValue, true)}\`).` : ".";
        return type !== "mixed" ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${$1b19c6085a6e9611$export$5790025c6e6c2ba6(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${$1b19c6085a6e9611$export$5790025c6e6c2ba6(value, true)}\`` + castMsg;
    }
};
let $1b19c6085a6e9611$var$string = {
    length: "${path} must be exactly ${length} characters",
    min: "${path} must be at least ${min} characters",
    max: "${path} must be at most ${max} characters",
    matches: '${path} must match the following: "${regex}"',
    email: "${path} must be a valid email",
    url: "${path} must be a valid URL",
    uuid: "${path} must be a valid UUID",
    datetime: "${path} must be a valid ISO date-time",
    datetime_precision: "${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits",
    datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
    trim: "${path} must be a trimmed string",
    lowercase: "${path} must be a lowercase string",
    uppercase: "${path} must be a upper case string"
};
let $1b19c6085a6e9611$var$number = {
    min: "${path} must be greater than or equal to ${min}",
    max: "${path} must be less than or equal to ${max}",
    lessThan: "${path} must be less than ${less}",
    moreThan: "${path} must be greater than ${more}",
    positive: "${path} must be a positive number",
    negative: "${path} must be a negative number",
    integer: "${path} must be an integer"
};
let $1b19c6085a6e9611$var$date = {
    min: "${path} field must be later than ${min}",
    max: "${path} field must be at earlier than ${max}"
};
let $1b19c6085a6e9611$var$boolean = {
    isValue: "${path} field must be ${value}"
};
let $1b19c6085a6e9611$var$object = {
    noUnknown: "${path} field has unspecified keys: ${unknown}",
    exact: "${path} object contains unknown properties: ${properties}"
};
let $1b19c6085a6e9611$var$array = {
    min: "${path} field must have at least ${min} items",
    max: "${path} field must have less than or equal to ${max} items",
    length: "${path} must have ${length} items"
};
let $1b19c6085a6e9611$var$tuple = {
    notType: (params)=>{
        const { path: path, value: value, spec: spec } = params;
        const typeLen = spec.types.length;
        if (Array.isArray(value)) {
            if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${$1b19c6085a6e9611$export$5790025c6e6c2ba6(value, true)}\``;
            if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${$1b19c6085a6e9611$export$5790025c6e6c2ba6(value, true)}\``;
        }
        return $1b19c6085a6e9611$export$2191b9da168c6cf0.formatError($1b19c6085a6e9611$var$mixed.notType, params);
    }
};
var $1b19c6085a6e9611$export$d7f512c98c859244 = Object.assign(Object.create(null), {
    mixed: $1b19c6085a6e9611$var$mixed,
    string: $1b19c6085a6e9611$var$string,
    number: $1b19c6085a6e9611$var$number,
    date: $1b19c6085a6e9611$var$date,
    object: $1b19c6085a6e9611$var$object,
    array: $1b19c6085a6e9611$var$array,
    boolean: $1b19c6085a6e9611$var$boolean,
    tuple: $1b19c6085a6e9611$var$tuple
});
const $1b19c6085a6e9611$export$213e2a3e7c4f326e = (obj)=>obj && obj.__isYupSchema__;
class $1b19c6085a6e9611$var$Condition {
    static fromOptions(refs, config) {
        if (!config.then && !config.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
        let { is: is, then: then, otherwise: otherwise } = config;
        let check = typeof is === "function" ? is : (...values)=>values.every((value)=>value === is);
        return new $1b19c6085a6e9611$var$Condition(refs, (values, schema)=>{
            var _branch;
            let branch = check(...values) ? then : otherwise;
            return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
        });
    }
    constructor(refs, builder){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        this.fn = builder;
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>// TODO: ? operator here?
            ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn(values, base, options);
        if (schema === undefined || // @ts-ignore this can be base
        schema === base) return base;
        if (!$1b19c6085a6e9611$export$213e2a3e7c4f326e(schema)) throw new TypeError("conditions must return a schema object");
        return schema.resolve(options);
    }
}
const $1b19c6085a6e9611$var$prefixes = {
    context: "$",
    value: "."
};
function $1b19c6085a6e9611$export$eff4d24c3ff7876e(key, options) {
    return new $1b19c6085a6e9611$var$Reference(key, options);
}
class $1b19c6085a6e9611$var$Reference {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== "string") throw new TypeError("ref must be a string, got: " + key);
        this.key = key.trim();
        if (key === "") throw new TypeError("ref must be a non-empty string");
        this.isContext = this.key[0] === $1b19c6085a6e9611$var$prefixes.context;
        this.isValue = this.key[0] === $1b19c6085a6e9611$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $1b19c6085a6e9611$var$prefixes.context : this.isValue ? $1b19c6085a6e9611$var$prefixes.value : "";
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $75b98c86abc67c8e$exports.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: "ref",
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
}
// @ts-ignore
$1b19c6085a6e9611$var$Reference.prototype.__isYupRef = true;
const $1b19c6085a6e9611$var$isAbsent = (value)=>value == null;
function $1b19c6085a6e9611$var$createValidation(config) {
    function validate({ value: value, path: path = "", options: options, originalValue: originalValue, schema: schema }, panic, next) {
        const { name: name, test: test, params: params, message: message, skipAbsent: skipAbsent } = config;
        let { parent: parent, context: context, abortEarly: abortEarly = schema.spec.abortEarly, disableStackTrace: disableStackTrace = schema.spec.disableStackTrace } = options;
        function resolve(item) {
            return $1b19c6085a6e9611$var$Reference.isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = Object.assign({
                value: value,
                originalValue: originalValue,
                label: schema.spec.label,
                path: overrides.path || path,
                spec: schema.spec,
                disableStackTrace: overrides.disableStackTrace || disableStackTrace
            }, params, overrides.params);
            for (const key of Object.keys(nextParams))nextParams[key] = resolve(nextParams[key]);
            const error = new $1b19c6085a6e9611$export$2191b9da168c6cf0($1b19c6085a6e9611$export$2191b9da168c6cf0.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
            error.params = nextParams;
            return error;
        }
        const invalid = abortEarly ? panic : next;
        let ctx = {
            path: path,
            parent: parent,
            type: name,
            from: options.from,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue,
            schema: schema
        };
        const handleResult = (validOrError)=>{
            if ($1b19c6085a6e9611$export$2191b9da168c6cf0.isError(validOrError)) invalid(validOrError);
            else if (!validOrError) invalid(createError());
            else next(null);
        };
        const handleError = (err)=>{
            if ($1b19c6085a6e9611$export$2191b9da168c6cf0.isError(err)) invalid(err);
            else panic(err);
        };
        const shouldSkip = skipAbsent && $1b19c6085a6e9611$var$isAbsent(value);
        if (shouldSkip) return handleResult(true);
        let result;
        try {
            var _result;
            result = test.call(ctx, value, ctx);
            if (typeof ((_result = result) == null ? void 0 : _result.then) === "function") {
                if (options.sync) throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
                return Promise.resolve(result).then(handleResult, handleError);
            }
        } catch (err) {
            handleError(err);
            return;
        }
        handleResult(result);
    }
    validate.OPTIONS = config;
    return validate;
}
function $1b19c6085a6e9611$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug;
    // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $75b98c86abc67c8e$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        let isTuple = schema.type === "tuple";
        let idx = isArray ? parseInt(part, 10) : 0;
        if (schema.innerType || isTuple) {
            if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = isTuple ? schema.spec.types[idx] : schema.innerType;
        }
        // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? "[" + _part + "]" : "." + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
function $1b19c6085a6e9611$export$cfedb76369cc7782(obj, path, value, context) {
    return $1b19c6085a6e9611$export$c52e5867d5879e24(obj, path, value, context).schema;
}
class $1b19c6085a6e9611$var$ReferenceSet extends Set {
    describe() {
        const description = [];
        for (const item of this.values())description.push($1b19c6085a6e9611$var$Reference.isRef(item) ? item.describe() : item);
        return description;
    }
    resolveAll(resolve) {
        let result = [];
        for (const item of this.values())result.push(resolve(item));
        return result;
    }
    clone() {
        return new $1b19c6085a6e9611$var$ReferenceSet(this.values());
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.forEach((value)=>next.add(value));
        removeItems.forEach((value)=>next.delete(value));
        return next;
    }
}
// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function $1b19c6085a6e9611$var$clone(src, seen = new Map()) {
    if ($1b19c6085a6e9611$export$213e2a3e7c4f326e(src) || !src || typeof src !== "object") return src;
    if (seen.has(src)) return seen.get(src);
    let copy;
    if (src instanceof Date) {
        // Date
        copy = new Date(src.getTime());
        seen.set(src, copy);
    } else if (src instanceof RegExp) {
        // RegExp
        copy = new RegExp(src);
        seen.set(src, copy);
    } else if (Array.isArray(src)) {
        // Array
        copy = new Array(src.length);
        seen.set(src, copy);
        for(let i = 0; i < src.length; i++)copy[i] = $1b19c6085a6e9611$var$clone(src[i], seen);
    } else if (src instanceof Map) {
        // Map
        copy = new Map();
        seen.set(src, copy);
        for (const [k, v] of src.entries())copy.set(k, $1b19c6085a6e9611$var$clone(v, seen));
    } else if (src instanceof Set) {
        // Set
        copy = new Set();
        seen.set(src, copy);
        for (const v of src)copy.add($1b19c6085a6e9611$var$clone(v, seen));
    } else if (src instanceof Object) {
        // Object
        copy = {};
        seen.set(src, copy);
        for (const [k, v] of Object.entries(src))copy[k] = $1b19c6085a6e9611$var$clone(v, seen);
    } else throw Error(`Unable to clone ${src}`);
    return copy;
}
// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class $1b19c6085a6e9611$export$19342e026b58ebb7 {
    constructor(options){
        this.type = void 0;
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this.internalTests = {};
        this._whitelist = new $1b19c6085a6e9611$var$ReferenceSet();
        this._blacklist = new $1b19c6085a6e9611$var$ReferenceSet();
        this.exclusiveTests = Object.create(null);
        this._typeCheck = void 0;
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError($1b19c6085a6e9611$var$mixed.notType);
        });
        this.type = options.type;
        this._typeCheck = options.check;
        this.spec = Object.assign({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            disableStackTrace: false,
            nullable: false,
            optional: true,
            coerce: true
        }, options == null ? void 0 : options.spec);
        this.withMutation((s)=>{
            s.nonNullable();
        });
    }
    // TODO: remove
    get _type() {
        return this.type;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        }
        // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this));
        // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeCheck = this._typeCheck;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.internalTests = Object.assign({}, this.internalTests);
        next.exclusiveTests = Object.assign({}, this.exclusiveTests);
        // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = $1b19c6085a6e9611$var$clone(Object.assign({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = Object.assign({}, base.spec, combined.spec);
        combined.spec = mergedSpec;
        combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);
        // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);
        // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests;
        // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (v == null) {
            if (this.spec.nullable && v === null) return true;
            if (this.spec.optional && v === undefined) return true;
            return false;
        }
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((prevSchema, condition)=>condition.resolve(prevSchema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    resolveOptions(options) {
        var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
        return Object.assign({}, options, {
            from: options.from || [],
            strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
            abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
            recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
            disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
        });
    }
    /**
   * Run the configured transform pipeline over an input value.
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve(Object.assign({
            value: value
        }, options));
        let allowOptionality = options.assert === "ignore-optionality";
        let result = resolvedSchema._cast(value, options);
        if (options.assert !== false && !resolvedSchema.isType(result)) {
            if (allowOptionality && $1b19c6085a6e9611$var$isAbsent(result)) return result;
            let formattedValue = $1b19c6085a6e9611$export$5790025c6e6c2ba6(value);
            let formattedResult = $1b19c6085a6e9611$export$5790025c6e6c2ba6(result);
            throw new TypeError(`The value of ${options.path || "field"} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ""));
        }
        return result;
    }
    _cast(rawValue, options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn)=>fn.call(this, prevValue, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault(options);
        return value;
    }
    _validate(_value, options = {}, panic, next) {
        let { path: path, originalValue: originalValue = _value, strict: strict = this.spec.strict } = options;
        let value = _value;
        if (!strict) value = this._cast(value, Object.assign({
            assert: false
        }, options));
        let initialTests = [];
        for (let test of Object.values(this.internalTests))if (test) initialTests.push(test);
        this.runTests({
            path: path,
            value: value,
            originalValue: originalValue,
            options: options,
            tests: initialTests
        }, panic, (initialErrors)=>{
            // even if we aren't ending early we can't proceed further if the types aren't correct
            if (initialErrors.length) return next(initialErrors, value);
            this.runTests({
                path: path,
                value: value,
                originalValue: originalValue,
                options: options,
                tests: this.tests
            }, panic, next);
        });
    }
    /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */ runTests(runOptions, panic, next) {
        let fired = false;
        let { tests: tests, value: value, originalValue: originalValue, path: path, options: options } = runOptions;
        let panicOnce = (arg)=>{
            if (fired) return;
            fired = true;
            panic(arg, value);
        };
        let nextOnce = (arg)=>{
            if (fired) return;
            fired = true;
            next(arg, value);
        };
        let count = tests.length;
        let nestedErrors = [];
        if (!count) return nextOnce([]);
        let args = {
            value: value,
            originalValue: originalValue,
            path: path,
            options: options,
            schema: this
        };
        for(let i = 0; i < tests.length; i++){
            const test = tests[i];
            test(args, panicOnce, function finishTestRun(err) {
                if (err) Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
                if (--count <= 0) nextOnce(nestedErrors);
            });
        }
    }
    asNestedTest({ key: key, index: index, parent: parent, parentPath: parentPath, originalParent: originalParent, options: options }) {
        const k = key != null ? key : index;
        if (k == null) throw TypeError("Must include `key` or `index` for nested validations");
        const isIndex = typeof k === "number";
        let value = parent[k];
        const testOptions = Object.assign({}, options, {
            // Nested validations fields are always strict:
            //    1. parent isn't strict so the casting will also have cast inner values
            //    2. parent is strict in which case the nested values weren't cast either
            strict: true,
            parent: parent,
            value: value,
            originalValue: originalParent[k],
            // FIXME: tests depend on `index` being passed around deeply,
            //   we should not let the options.key/index bleed through
            key: undefined,
            // index: undefined,
            [isIndex ? "index" : "key"]: k,
            path: isIndex || k.includes(".") ? `${parentPath || ""}[${isIndex ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : "") + key
        });
        return (_, panic, next)=>this.resolve(testOptions)._validate(value, testOptions, panic, next);
    }
    validate(value, options) {
        var _options$disableStack2;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
        return new Promise((resolve, reject)=>schema._validate(value, options, (error, parsed)=>{
                if ($1b19c6085a6e9611$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
                reject(error);
            }, (errors, validated)=>{
                if (errors.length) reject(new $1b19c6085a6e9611$export$2191b9da168c6cf0(errors, validated, undefined, undefined, disableStackTrace));
                else resolve(validated);
            }));
    }
    validateSync(value, options) {
        var _options$disableStack3;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let result;
        let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
        schema._validate(value, Object.assign({}, options, {
            sync: true
        }), (error, parsed)=>{
            if ($1b19c6085a6e9611$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
            throw error;
        }, (errors, validated)=>{
            if (errors.length) throw new $1b19c6085a6e9611$export$2191b9da168c6cf0(errors, value, undefined, undefined, disableStackTrace);
            result = validated;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ($1b19c6085a6e9611$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ($1b19c6085a6e9611$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        }
    }
    _getDefault(options) {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === "function" ? defaultValue.call(this, options) : $1b19c6085a6e9611$var$clone(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault(options);
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        return this.clone({
            strict: isStrict
        });
    }
    nullability(nullable, message) {
        const next = this.clone({
            nullable: nullable
        });
        next.internalTests.nullable = $1b19c6085a6e9611$var$createValidation({
            message: message,
            name: "nullable",
            test (value) {
                return value === null ? this.schema.spec.nullable : true;
            }
        });
        return next;
    }
    optionality(optional, message) {
        const next = this.clone({
            optional: optional
        });
        next.internalTests.optionality = $1b19c6085a6e9611$var$createValidation({
            message: message,
            name: "optionality",
            test (value) {
                return value === undefined ? this.schema.spec.optional : true;
            }
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    defined(message = $1b19c6085a6e9611$var$mixed.defined) {
        return this.optionality(false, message);
    }
    nullable() {
        return this.nullability(true);
    }
    nonNullable(message = $1b19c6085a6e9611$var$mixed.notNull) {
        return this.nullability(false, message);
    }
    required(message = $1b19c6085a6e9611$var$mixed.required) {
        return this.clone().withMutation((next)=>next.nonNullable(message).defined(message));
    }
    notRequired() {
        return this.clone().withMutation((next)=>next.nullable().optional());
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === "function") opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = $1b19c6085a6e9611$var$mixed.default;
        if (typeof opts.test !== "function") throw new TypeError("`test` is a required parameters");
        let next = this.clone();
        let validate = $1b19c6085a6e9611$var$createValidation(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== "string") {
            options = keys;
            keys = ".";
        }
        let next = this.clone();
        let deps = $1b19c6085a6e9611$var$toArray(keys).map((key)=>new $1b19c6085a6e9611$var$Reference(key));
        deps.forEach((dep)=>{
            // @ts-ignore readonly array
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(typeof options === "function" ? new $1b19c6085a6e9611$var$Condition(deps, options) : $1b19c6085a6e9611$var$Condition.fromOptions(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next.internalTests.typeError = $1b19c6085a6e9611$var$createValidation({
            message: message,
            name: "typeError",
            skipAbsent: true,
            test (value) {
                if (!this.schema._typeCheck(value)) return this.createError({
                    params: {
                        type: this.schema.type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = $1b19c6085a6e9611$var$mixed.oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next.internalTests.whiteList = $1b19c6085a6e9611$var$createValidation({
            message: message,
            name: "oneOf",
            skipAbsent: true,
            test (value) {
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: Array.from(valids).join(", "),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = $1b19c6085a6e9611$var$mixed.notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next.internalTests.blacklist = $1b19c6085a6e9611$var$createValidation({
            message: message,
            name: "notOneOf",
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: Array.from(invalids).join(", "),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */ describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const { label: label, meta: meta, optional: optional, nullable: nullable } = next.spec;
        const description = {
            meta: meta,
            label: label,
            optional: optional,
            nullable: nullable,
            default: next.getDefault(options),
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
}
// @ts-expect-error
$1b19c6085a6e9611$export$19342e026b58ebb7.prototype.__isYupSchema__ = true;
for (const method of [
    "validate",
    "validateSync"
])$1b19c6085a6e9611$export$19342e026b58ebb7.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = $1b19c6085a6e9611$export$c52e5867d5879e24(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], Object.assign({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    "equals",
    "is"
])$1b19c6085a6e9611$export$19342e026b58ebb7.prototype[alias] = $1b19c6085a6e9611$export$19342e026b58ebb7.prototype.oneOf;
for (const alias of [
    "not",
    "nope"
])$1b19c6085a6e9611$export$19342e026b58ebb7.prototype[alias] = $1b19c6085a6e9611$export$19342e026b58ebb7.prototype.notOneOf;
const $1b19c6085a6e9611$var$returnsTrue = ()=>true;
function $1b19c6085a6e9611$export$9b30b6294c1449a8(spec) {
    return new $1b19c6085a6e9611$export$1e88358c94ddec71(spec);
}
class $1b19c6085a6e9611$export$1e88358c94ddec71 extends $1b19c6085a6e9611$export$19342e026b58ebb7 {
    constructor(spec){
        super(typeof spec === "function" ? {
            type: "mixed",
            check: spec
        } : Object.assign({
            type: "mixed",
            check: $1b19c6085a6e9611$var$returnsTrue
        }, spec));
    }
}
$1b19c6085a6e9611$export$9b30b6294c1449a8.prototype = $1b19c6085a6e9611$export$1e88358c94ddec71.prototype;
function $1b19c6085a6e9611$export$87b259aa03e3d267() {
    return new $1b19c6085a6e9611$export$c7980688f11e1f49();
}
class $1b19c6085a6e9611$export$c7980688f11e1f49 extends $1b19c6085a6e9611$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "boolean",
            check (v) {
                if (v instanceof Boolean) v = v.valueOf();
                return typeof v === "boolean";
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (ctx.spec.coerce && !ctx.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    isTrue(message = $1b19c6085a6e9611$var$boolean.isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "true"
            },
            test (value) {
                return $1b19c6085a6e9611$var$isAbsent(value) || value === true;
            }
        });
    }
    isFalse(message = $1b19c6085a6e9611$var$boolean.isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "false"
            },
            test (value) {
                return $1b19c6085a6e9611$var$isAbsent(value) || value === false;
            }
        });
    }
    default(def) {
        return super.default(def);
    }
    defined(msg) {
        return super.defined(msg);
    }
    optional() {
        return super.optional();
    }
    required(msg) {
        return super.required(msg);
    }
    notRequired() {
        return super.notRequired();
    }
    nullable() {
        return super.nullable();
    }
    nonNullable(msg) {
        return super.nonNullable(msg);
    }
    strip(v) {
        return super.strip(v);
    }
}
$1b19c6085a6e9611$export$87b259aa03e3d267.prototype = $1b19c6085a6e9611$export$c7980688f11e1f49.prototype;
/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ // prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const $1b19c6085a6e9611$var$isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $1b19c6085a6e9611$var$parseIsoDate(date) {
    const struct = $1b19c6085a6e9611$var$parseDateStruct(date);
    if (!struct) return Date.parse ? Date.parse(date) : Number.NaN;
    // timestamps without timezone identifiers should be considered local time
    if (struct.z === undefined && struct.plusMinus === undefined) return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
    let totalMinutesOffset = 0;
    if (struct.z !== "Z" && struct.plusMinus !== undefined) {
        totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
        if (struct.plusMinus === "+") totalMinutesOffset = 0 - totalMinutesOffset;
    }
    return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function $1b19c6085a6e9611$var$parseDateStruct(date) {
    var _regexResult$7$length, _regexResult$;
    const regexResult = $1b19c6085a6e9611$var$isoReg.exec(date);
    if (!regexResult) return null;
    // use of toNumber() avoids NaN timestamps caused by “undefined”
    // values being passed to Date constructor
    return {
        year: $1b19c6085a6e9611$var$toNumber(regexResult[1]),
        month: $1b19c6085a6e9611$var$toNumber(regexResult[2], 1) - 1,
        day: $1b19c6085a6e9611$var$toNumber(regexResult[3], 1),
        hour: $1b19c6085a6e9611$var$toNumber(regexResult[4]),
        minute: $1b19c6085a6e9611$var$toNumber(regexResult[5]),
        second: $1b19c6085a6e9611$var$toNumber(regexResult[6]),
        millisecond: regexResult[7] ? // allow arbitrary sub-second precision beyond milliseconds
        $1b19c6085a6e9611$var$toNumber(regexResult[7].substring(0, 3)) : 0,
        precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : undefined,
        z: regexResult[8] || undefined,
        plusMinus: regexResult[9] || undefined,
        hourOffset: $1b19c6085a6e9611$var$toNumber(regexResult[10]),
        minuteOffset: $1b19c6085a6e9611$var$toNumber(regexResult[11])
    };
}
function $1b19c6085a6e9611$var$toNumber(str, defaultValue = 0) {
    return Number(str) || defaultValue;
}
// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let $1b19c6085a6e9611$var$rEmail = // eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let $1b19c6085a6e9611$var$rUrl = // eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
// eslint-disable-next-line
let $1b19c6085a6e9611$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $1b19c6085a6e9611$var$yearMonthDay = "^\\d{4}-\\d{2}-\\d{2}";
let $1b19c6085a6e9611$var$hourMinuteSecond = "\\d{2}:\\d{2}:\\d{2}";
let $1b19c6085a6e9611$var$zOrOffset = "(([+-]\\d{2}(:?\\d{2})?)|Z)";
let $1b19c6085a6e9611$var$rIsoDateTime = new RegExp(`${$1b19c6085a6e9611$var$yearMonthDay}T${$1b19c6085a6e9611$var$hourMinuteSecond}(\\.\\d+)?${$1b19c6085a6e9611$var$zOrOffset}$`);
let $1b19c6085a6e9611$var$isTrimmed = (value)=>$1b19c6085a6e9611$var$isAbsent(value) || value === value.trim();
let $1b19c6085a6e9611$var$objStringTag = ({}).toString();
function $1b19c6085a6e9611$export$22b082955e083ec3() {
    return new $1b19c6085a6e9611$export$49bf8b2ede5138eb();
}
class $1b19c6085a6e9611$export$49bf8b2ede5138eb extends $1b19c6085a6e9611$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "string",
            check (value) {
                if (value instanceof String) value = value.valueOf();
                return typeof value === "string";
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce || ctx.isType(value)) return value;
                // don't ever convert arrays
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                // no one wants plain objects converted to [Object object]
                if (strValue === $1b19c6085a6e9611$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    required(message) {
        return super.required(message).withMutation((schema)=>schema.test({
                message: message || $1b19c6085a6e9611$var$mixed.required,
                name: "required",
                skipAbsent: true,
                test: (value)=>!!value.length
            }));
    }
    notRequired() {
        return super.notRequired().withMutation((schema)=>{
            schema.tests = schema.tests.filter((t)=>t.OPTIONS.name !== "required");
            return schema;
        });
    }
    length(length, message = $1b19c6085a6e9611$var$string.length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message = $1b19c6085a6e9611$var$string.min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = $1b19c6085a6e9611$var$string.max) {
        return this.test({
            name: "max",
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === "object") ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || "matches",
            message: message || $1b19c6085a6e9611$var$string.matches,
            params: {
                regex: regex
            },
            skipAbsent: true,
            test: (value)=>value === "" && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = $1b19c6085a6e9611$var$string.email) {
        return this.matches($1b19c6085a6e9611$var$rEmail, {
            name: "email",
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = $1b19c6085a6e9611$var$string.url) {
        return this.matches($1b19c6085a6e9611$var$rUrl, {
            name: "url",
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = $1b19c6085a6e9611$var$string.uuid) {
        return this.matches($1b19c6085a6e9611$var$rUUID, {
            name: "uuid",
            message: message,
            excludeEmptyString: false
        });
    }
    datetime(options) {
        let message = "";
        let allowOffset;
        let precision;
        if (options) {
            if (typeof options === "object") ({ message: message = "", allowOffset: allowOffset = false, precision: precision } = options);
            else message = options;
        }
        return this.matches($1b19c6085a6e9611$var$rIsoDateTime, {
            name: "datetime",
            message: message || $1b19c6085a6e9611$var$string.datetime,
            excludeEmptyString: true
        }).test({
            name: "datetime_offset",
            message: message || $1b19c6085a6e9611$var$string.datetime_offset,
            params: {
                allowOffset: allowOffset
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || allowOffset) return true;
                const struct = $1b19c6085a6e9611$var$parseDateStruct(value);
                if (!struct) return false;
                return !!struct.z;
            }
        }).test({
            name: "datetime_precision",
            message: message || $1b19c6085a6e9611$var$string.datetime_precision,
            params: {
                precision: precision
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || precision == undefined) return true;
                const struct = $1b19c6085a6e9611$var$parseDateStruct(value);
                if (!struct) return false;
                return struct.precision === precision;
            }
        });
    }
    //-- transforms --
    ensure() {
        return this.default("").transform((val)=>val === null ? "" : val);
    }
    trim(message = $1b19c6085a6e9611$var$string.trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: "trim",
            test: $1b19c6085a6e9611$var$isTrimmed
        });
    }
    lowercase(message = $1b19c6085a6e9611$var$string.lowercase) {
        return this.transform((value)=>!$1b19c6085a6e9611$var$isAbsent(value) ? value.toLowerCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$1b19c6085a6e9611$var$isAbsent(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = $1b19c6085a6e9611$var$string.uppercase) {
        return this.transform((value)=>!$1b19c6085a6e9611$var$isAbsent(value) ? value.toUpperCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$1b19c6085a6e9611$var$isAbsent(value) || value === value.toUpperCase()
        });
    }
}
$1b19c6085a6e9611$export$22b082955e083ec3.prototype = $1b19c6085a6e9611$export$49bf8b2ede5138eb.prototype;
//
// String Interfaces
//
let $1b19c6085a6e9611$var$isNaN$1 = (value)=>value != +value;
function $1b19c6085a6e9611$export$98e628dec113755e() {
    return new $1b19c6085a6e9611$export$f192ec5e9228ab19();
}
class $1b19c6085a6e9611$export$f192ec5e9228ab19 extends $1b19c6085a6e9611$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "number",
            check (value) {
                if (value instanceof Number) value = value.valueOf();
                return typeof value === "number" && !$1b19c6085a6e9611$var$isNaN$1(value);
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce) return value;
                let parsed = value;
                if (typeof parsed === "string") {
                    parsed = parsed.replace(/\s/g, "");
                    if (parsed === "") return NaN;
                    // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                // null -> NaN isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (ctx.isType(parsed) || parsed === null) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    min(min, message = $1b19c6085a6e9611$var$number.min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(min);
            }
        });
    }
    max(max, message = $1b19c6085a6e9611$var$number.max) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = $1b19c6085a6e9611$var$number.lessThan) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                less: less
            },
            skipAbsent: true,
            test (value) {
                return value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = $1b19c6085a6e9611$var$number.moreThan) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                more: more
            },
            skipAbsent: true,
            test (value) {
                return value > this.resolve(more);
            }
        });
    }
    positive(msg = $1b19c6085a6e9611$var$number.positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = $1b19c6085a6e9611$var$number.negative) {
        return this.lessThan(0, msg);
    }
    integer(message = $1b19c6085a6e9611$var$number.integer) {
        return this.test({
            name: "integer",
            message: message,
            skipAbsent: true,
            test: (val)=>Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!$1b19c6085a6e9611$var$isAbsent(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            "ceil",
            "floor",
            "round",
            "trunc"
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || "round";
        // this exists for symemtry with the new Math.trunc
        if (method === "trunc") return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + avail.join(", "));
        return this.transform((value)=>!$1b19c6085a6e9611$var$isAbsent(value) ? Math[method](value) : value);
    }
}
$1b19c6085a6e9611$export$98e628dec113755e.prototype = $1b19c6085a6e9611$export$f192ec5e9228ab19.prototype;
//
// Number Interfaces
//
let $1b19c6085a6e9611$var$invalidDate = new Date("");
let $1b19c6085a6e9611$var$isDate = (obj)=>Object.prototype.toString.call(obj) === "[object Date]";
function $1b19c6085a6e9611$export$324d90190a8b822a() {
    return new $1b19c6085a6e9611$export$18ec3cc5a157503f();
}
class $1b19c6085a6e9611$export$18ec3cc5a157503f extends $1b19c6085a6e9611$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "date",
            check (v) {
                return $1b19c6085a6e9611$var$isDate(v) && !isNaN(v.getTime());
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (!ctx.spec.coerce || ctx.isType(value) || value === null) return value;
                value = $1b19c6085a6e9611$var$parseIsoDate(value);
                // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $1b19c6085a6e9611$export$18ec3cc5a157503f.INVALID_DATE;
            });
        });
    }
    prepareParam(ref, name) {
        let param;
        if (!$1b19c6085a6e9611$var$Reference.isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = $1b19c6085a6e9611$var$date.min) {
        let limit = this.prepareParam(min, "min");
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(limit);
            }
        });
    }
    max(max, message = $1b19c6085a6e9611$var$date.max) {
        let limit = this.prepareParam(max, "max");
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(limit);
            }
        });
    }
}
$1b19c6085a6e9611$export$18ec3cc5a157503f.INVALID_DATE = $1b19c6085a6e9611$var$invalidDate;
$1b19c6085a6e9611$export$324d90190a8b822a.prototype = $1b19c6085a6e9611$export$18ec3cc5a157503f.prototype;
$1b19c6085a6e9611$export$324d90190a8b822a.INVALID_DATE = $1b19c6085a6e9611$var$invalidDate;
// @ts-expect-error
function $1b19c6085a6e9611$var$sortFields(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $75b98c86abc67c8e$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for (const key of Object.keys(fields)){
        let value = fields[key];
        nodes.add(key);
        if ($1b19c6085a6e9611$var$Reference.isRef(value) && value.isSibling) addNode(value.path, key);
        else if ($1b19c6085a6e9611$export$213e2a3e7c4f326e(value) && "deps" in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fc86160b8cf91a0e$exports))).array(Array.from(nodes), edges).reverse();
}
function $1b19c6085a6e9611$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if ((_err$path = err.path) != null && _err$path.includes(key)) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $1b19c6085a6e9611$var$sortByKeyOrder(keys) {
    return (a, b)=>{
        return $1b19c6085a6e9611$var$findIndex(keys, a) - $1b19c6085a6e9611$var$findIndex(keys, b);
    };
}
const $1b19c6085a6e9611$var$parseJson = (value, _, ctx)=>{
    if (typeof value !== "string") return value;
    let parsed = value;
    try {
        parsed = JSON.parse(value);
    } catch (err) {
    /* */ }
    return ctx.isType(parsed) ? parsed : value;
};
// @ts-ignore
function $1b19c6085a6e9611$var$deepPartial(schema) {
    if ("fields" in schema) {
        const partial = {};
        for (const [key, fieldSchema] of Object.entries(schema.fields))partial[key] = $1b19c6085a6e9611$var$deepPartial(fieldSchema);
        return schema.setFields(partial);
    }
    if (schema.type === "array") {
        const nextArray = schema.optional();
        if (nextArray.innerType) nextArray.innerType = $1b19c6085a6e9611$var$deepPartial(nextArray.innerType);
        return nextArray;
    }
    if (schema.type === "tuple") return schema.optional().clone({
        types: schema.spec.types.map($1b19c6085a6e9611$var$deepPartial)
    });
    if ("optional" in schema) return schema.optional();
    return schema;
}
const $1b19c6085a6e9611$var$deepHas = (obj, p)=>{
    const path = [
        ...(0, $75b98c86abc67c8e$exports.normalizePath)(p)
    ];
    if (path.length === 1) return path[0] in obj;
    let last = path.pop();
    let parent = (0, $75b98c86abc67c8e$exports.getter)((0, $75b98c86abc67c8e$exports.join)(path), true)(obj);
    return !!(parent && last in parent);
};
let $1b19c6085a6e9611$var$isObject = (obj)=>Object.prototype.toString.call(obj) === "[object Object]";
function $1b19c6085a6e9611$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $1b19c6085a6e9611$var$defaultSort = $1b19c6085a6e9611$var$sortByKeyOrder([]);
function $1b19c6085a6e9611$export$be5493f9613cbbe(spec) {
    return new $1b19c6085a6e9611$export$18b4fc70ec7eccf8(spec);
}
class $1b19c6085a6e9611$export$18b4fc70ec7eccf8 extends $1b19c6085a6e9611$export$19342e026b58ebb7 {
    constructor(spec){
        super({
            type: "object",
            check (value) {
                return $1b19c6085a6e9611$var$isObject(value) || typeof value === "function";
            }
        });
        this.fields = Object.create(null);
        this._sortErrors = $1b19c6085a6e9611$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            if (spec) this.shape(spec);
        });
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options);
        //should ignore nulls here
        if (value === undefined) return this.getDefault(options);
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = [].concat(this._nodes, Object.keys(value).filter((v)=>!this._nodes.includes(v)));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = Object.assign({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = prop in value;
            if (field) {
                let fieldValue;
                let inputValue = value[prop];
                // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : "") + prop;
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = field instanceof $1b19c6085a6e9611$export$19342e026b58ebb7 ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec != null && fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? // TODO: use _cast, this is double resolving
                field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (exists !== prop in intermediateValue || intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, options = {}, panic, next) {
        let { from: from = [], originalValue: originalValue = _value, recursive: recursive = this.spec.recursive } = options;
        options.from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ];
        // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        options.__validating = true;
        options.originalValue = originalValue;
        super._validate(_value, options, panic, (objectErrors, value)=>{
            if (!recursive || !$1b19c6085a6e9611$var$isObject(value)) {
                next(objectErrors, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = [];
            for (let key of this._nodes){
                let field = this.fields[key];
                if (!field || $1b19c6085a6e9611$var$Reference.isRef(field)) continue;
                tests.push(field.asNestedTest({
                    options: options,
                    key: key,
                    parent: value,
                    parentPath: options.path,
                    originalParent: originalValue
                }));
            }
            this.runTests({
                tests: tests,
                value: value,
                originalValue: originalValue,
                options: options
            }, panic, (fieldErrors)=>{
                next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
            });
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = Object.assign({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            nextFields[field] = target === undefined ? schemaOrRef : target;
        }
        return next.withMutation((s)=>// XXX: excludes here is wrong
            s.setFields(nextFields, [
                ...this._excludedEdges,
                ...schema._excludedEdges
            ]));
    }
    _getDefault(options) {
        if ("default" in this.spec) return super._getDefault(options);
        // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        let dft = {};
        this._nodes.forEach((key)=>{
            var _innerOptions;
            const field = this.fields[key];
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            dft[key] = field && "getDefault" in field ? field.getDefault(innerOptions) : undefined;
        });
        return dft;
    }
    setFields(shape, excludedEdges) {
        let next = this.clone();
        next.fields = shape;
        next._nodes = $1b19c6085a6e9611$var$sortFields(shape, excludedEdges);
        next._sortErrors = $1b19c6085a6e9611$var$sortByKeyOrder(Object.keys(shape));
        // XXX: this carries over edges which may not be what you want
        if (excludedEdges) next._excludedEdges = excludedEdges;
        return next;
    }
    shape(additions, excludes = []) {
        return this.clone().withMutation((next)=>{
            let edges = next._excludedEdges;
            if (excludes.length) {
                if (!Array.isArray(excludes[0])) excludes = [
                    excludes
                ];
                edges = [
                    ...next._excludedEdges,
                    ...excludes
                ];
            }
            // XXX: excludes here is wrong
            return next.setFields(Object.assign(next.fields, additions), edges);
        });
    }
    partial() {
        const partial = {};
        for (const [key, schema] of Object.entries(this.fields))partial[key] = "optional" in schema && schema.optional instanceof Function ? schema.optional() : schema;
        return this.setFields(partial);
    }
    deepPartial() {
        const next = $1b19c6085a6e9611$var$deepPartial(this);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.setFields(picked, this._excludedEdges.filter(([a, b])=>keys.includes(a) && keys.includes(b)));
    }
    omit(keys) {
        const remaining = [];
        for (const key of Object.keys(this.fields)){
            if (keys.includes(key)) continue;
            remaining.push(key);
        }
        return this.pick(remaining);
    }
    from(from, to, alias) {
        let fromGetter = (0, $75b98c86abc67c8e$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (!obj) return obj;
            let newObj = obj;
            if ($1b19c6085a6e9611$var$deepHas(obj, from)) {
                newObj = Object.assign({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($1b19c6085a6e9611$var$parseJson);
    }
    /**
   * Similar to `noUnknown` but only validates that an object is the right shape without stripping the unknown keys
   */ exact(message) {
        return this.test({
            name: "exact",
            exclusive: true,
            message: message || $1b19c6085a6e9611$var$object.exact,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $1b19c6085a6e9611$var$unknown(this.schema, value);
                return unknownKeys.length === 0 || this.createError({
                    params: {
                        properties: unknownKeys.join(", ")
                    }
                });
            }
        });
    }
    stripUnknown() {
        return this.clone({
            noUnknown: true
        });
    }
    noUnknown(noAllow = true, message = $1b19c6085a6e9611$var$object.noUnknown) {
        if (typeof noAllow !== "boolean") {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: "noUnknown",
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $1b19c6085a6e9611$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(", ")
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = $1b19c6085a6e9611$var$object.noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>{
            if (!obj) return obj;
            const result = {};
            for (const key of Object.keys(obj))result[fn(key)] = obj[key];
            return result;
        });
    }
    camelCase() {
        return this.transformKeys((0, $a214d9c9202f8fd9$exports.camelCase));
    }
    snakeCase() {
        return this.transformKeys((0, $a214d9c9202f8fd9$exports.snakeCase));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, $a214d9c9202f8fd9$exports.snakeCase)(key).toUpperCase());
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.fields = {};
        for (const [key, value] of Object.entries(next.fields)){
            var _innerOptions2;
            let innerOptions = options;
            if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            base.fields[key] = value.describe(innerOptions);
        }
        return base;
    }
}
$1b19c6085a6e9611$export$be5493f9613cbbe.prototype = $1b19c6085a6e9611$export$18b4fc70ec7eccf8.prototype;
function $1b19c6085a6e9611$export$2f23118c22fb2630(type) {
    return new $1b19c6085a6e9611$export$4347112b8447a7d(type);
}
class $1b19c6085a6e9611$export$4347112b8447a7d extends $1b19c6085a6e9611$export$19342e026b58ebb7 {
    constructor(type){
        super({
            type: "array",
            spec: {
                types: type
            },
            check (v) {
                return Array.isArray(v);
            }
        });
        // `undefined` specifically means uninitialized, as opposed to "no subtype"
        this.innerType = void 0;
        this.innerType = type;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts);
        // should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, Object.assign({}, _opts, {
                path: `${_opts.path || ""}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        var _options$recursive;
        // let sync = options.sync;
        // let path = options.path;
        let innerType = this.innerType;
        // let endEarly = options.abortEarly ?? this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, panic, (arrayErrors, value)=>{
            var _options$originalValu2;
            if (!recursive || !innerType || !this._typeCheck(value)) {
                next(arrayErrors, value);
                return;
            }
            // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let index = 0; index < value.length; index++){
                var _options$originalValu;
                tests[index] = innerType.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(arrayErrors), value));
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        return next;
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($1b19c6085a6e9611$var$parseJson);
    }
    concat(schema) {
        let next = super.concat(schema);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        if (schema.innerType) // @ts-expect-error readonly
        next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat and will break
        next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!$1b19c6085a6e9611$export$213e2a3e7c4f326e(schema)) throw new TypeError("`array.of()` sub-schema must be a valid yup schema not: " + $1b19c6085a6e9611$export$5790025c6e6c2ba6(schema));
        // @ts-expect-error readonly
        next.innerType = schema;
        next.spec = Object.assign({}, next.spec, {
            types: schema
        });
        return next;
    }
    length(length, message = $1b19c6085a6e9611$var$array.length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || $1b19c6085a6e9611$var$array.min;
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            // FIXME(ts): Array<typeof T>
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || $1b19c6085a6e9611$var$array.max;
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        if (next.innerType) {
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[0]
            });
            base.innerType = next.innerType.describe(innerOptions);
        }
        return base;
    }
}
$1b19c6085a6e9611$export$2f23118c22fb2630.prototype = $1b19c6085a6e9611$export$4347112b8447a7d.prototype;
// @ts-ignore
function $1b19c6085a6e9611$export$65e3907585753458(schemas) {
    return new $1b19c6085a6e9611$export$411c3b3687e8ecc8(schemas);
}
class $1b19c6085a6e9611$export$411c3b3687e8ecc8 extends $1b19c6085a6e9611$export$19342e026b58ebb7 {
    constructor(schemas){
        super({
            type: "tuple",
            spec: {
                types: schemas
            },
            check (v) {
                const types = this.spec.types;
                return Array.isArray(v) && v.length === types.length;
            }
        });
        this.withMutation(()=>{
            this.typeError($1b19c6085a6e9611$var$tuple.notType);
        });
    }
    _cast(inputValue, options) {
        const { types: types } = this.spec;
        const value = super._cast(inputValue, options);
        if (!this._typeCheck(value)) return value;
        let isChanged = false;
        const castArray = types.map((type, idx)=>{
            const castElement = type.cast(value[idx], Object.assign({}, options, {
                path: `${options.path || ""}[${idx}]`
            }));
            if (castElement !== value[idx]) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        let itemTypes = this.spec.types;
        super._validate(_value, options, panic, (tupleErrors, value)=>{
            var _options$originalValu2;
            // intentionally not respecting recursive
            if (!this._typeCheck(value)) {
                next(tupleErrors, value);
                return;
            }
            let tests = [];
            for (let [index, itemSchema] of itemTypes.entries()){
                var _options$originalValu;
                tests[index] = itemSchema.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(tupleErrors), value));
        });
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.innerType = next.spec.types.map((schema, index)=>{
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[index]
            });
            return schema.describe(innerOptions);
        });
        return base;
    }
}
$1b19c6085a6e9611$export$65e3907585753458.prototype = $1b19c6085a6e9611$export$411c3b3687e8ecc8.prototype;
function $1b19c6085a6e9611$export$488013bae63b21da(builder) {
    return new $1b19c6085a6e9611$var$Lazy(builder);
}
class $1b19c6085a6e9611$var$Lazy {
    constructor(builder){
        this.type = "lazy";
        this.__isYupSchema__ = true;
        this.spec = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!$1b19c6085a6e9611$export$213e2a3e7c4f326e(schema)) throw new TypeError("lazy() functions must return a valid schema");
            if (this.spec.optional) schema = schema.optional();
            return schema.resolve(options);
        };
        this.builder = builder;
        this.spec = {
            meta: undefined,
            optional: false
        };
    }
    clone(spec) {
        const next = new $1b19c6085a6e9611$var$Lazy(this.builder);
        next.spec = Object.assign({}, this.spec, spec);
        return next;
    }
    optionality(optional) {
        const next = this.clone({
            optional: optional
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    asNestedTest(config) {
        let { key: key, index: index, parent: parent, options: options } = config;
        let value = parent[index != null ? index : key];
        return this._resolve(value, Object.assign({}, options, {
            value: value,
            parent: parent
        })).asNestedTest(config);
    }
    validate(value, options) {
        return this._resolve(value, options).validate(value, options);
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    isValid(value, options) {
        return this._resolve(value, options).isValid(value, options);
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
    describe(options) {
        return options ? this.resolve(options).describe(options) : {
            type: "lazy",
            meta: this.spec.meta,
            label: undefined
        };
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
}
function $1b19c6085a6e9611$export$c8aadf3621e41efb(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            $1b19c6085a6e9611$export$d7f512c98c859244[type][method] = custom[type][method];
        });
    });
}
function $1b19c6085a6e9611$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !$1b19c6085a6e9611$export$213e2a3e7c4f326e(schemaType.prototype)) throw new TypeError("You must provide a yup schema constructor function");
    if (typeof name !== "string") throw new TypeError("A Method name must be provided");
    if (typeof fn !== "function") throw new TypeError("Method function must be provided");
    schemaType.prototype[name] = fn;
}



var $jTKGQ = parcelRequire("jTKGQ");

function $27cb5f515eacb0bf$export$51063abe2742d805(plugins, data) {
    const validationSchema = plugins.reduce((acc, plugin)=>{
        const editSchema = plugin.editSchema(data);
        if (!editSchema || editSchema === (0, $c0a25ef586f9da64$export$901cf72dabf2112a).HIDDEN) return acc;
        const schema = $27cb5f515eacb0bf$var$createObjectSchema({
            ...editSchema,
            type: "object"
        });
        return acc.concat(schema);
    }, $1b19c6085a6e9611$export$be5493f9613cbbe());
    try {
        const result = validationSchema.validateSync(data, {
            abortEarly: false
        });
        return [
            result,
            null
        ];
    } catch (error) {
        const e = (0, $jTKGQ.yupToFormErrors)(error);
        return [
            null,
            e
        ];
    }
}
/**
 * Creates a Yup object schema based on the provided data.
 * @param {SchemaFieldObject} data - The schema field object.
 * @param {boolean} [isRequired] - Whether the schema is required.
 * @returns {Yup.ObjectSchema<object>} - The Yup object schema.
 */ function $27cb5f515eacb0bf$var$createObjectSchema(data, isRequired) {
    const required = data.required || [];
    const properties = data.properties || {};
    const mappedProperties = Object.keys(properties).reduce((acc, key)=>{
        const field = properties[key];
        const type = field.type;
        const isFieldRequired = required.includes(key);
        let schema;
        if (type === "object" || type === "root") schema = $27cb5f515eacb0bf$var$createObjectSchema(field, isFieldRequired);
        else if (type === "string") schema = $27cb5f515eacb0bf$var$createStringSchema(field, isFieldRequired);
        else if (type === "number") schema = $27cb5f515eacb0bf$var$createNumberSchema(field, isFieldRequired);
        else if (type === "json") schema = $27cb5f515eacb0bf$var$createJsonSchema(field, isFieldRequired);
        else if (type === "array") schema = $27cb5f515eacb0bf$var$createArraySchema(field, isFieldRequired);
        else throw new Error("Invalid item type");
        return {
            ...acc,
            [key]: schema
        };
    }, {});
    if (isRequired) return $1b19c6085a6e9611$export$be5493f9613cbbe(mappedProperties).required();
    else return $1b19c6085a6e9611$export$be5493f9613cbbe(mappedProperties);
}
/**
 * Creates a Yup string schema based on the provided data.
 * @param {SchemaFieldString} data - The schema field string.
 * @param {boolean} [isRequired] - Whether the schema is required.
 * @returns {Yup.StringSchema} - The Yup string schema.
 */ function $27cb5f515eacb0bf$var$createStringSchema(data, isRequired) {
    let schema = $1b19c6085a6e9611$export$22b082955e083ec3().label(typeof data.label === "string" ? data.label : "Value");
    if (data.enum) schema = schema.test("enum", "${path} value is invalid", (value)=>{
        if (value === "" && !isRequired) return true;
        const inOption = data.enum.some(([v])=>v === value);
        if (inOption) return true;
        if (data.allowOther) return typeof value === data.allowOther.type;
        return false;
    });
    return isRequired ? schema.required() : schema;
}
/**
 * Creates a Yup number schema based on the provided data.
 * @param {SchemaFieldNumber} data - The schema field number.
 * @param {boolean} [isRequired] - Whether the schema is required.
 * @returns {Yup.NumberSchema} - The Yup number schema.
 */ function $27cb5f515eacb0bf$var$createNumberSchema(data, isRequired) {
    const schema = $1b19c6085a6e9611$export$98e628dec113755e().label(typeof data.label === "string" ? data.label : "Value").typeError("Value must be a number");
    return isRequired ? schema.required() : schema;
}
/**
 * Creates a Yup JSON schema based on the provided data.
 * @param {SchemaFieldJson} data - The schema field JSON.
 * @param {boolean} [isRequired] - Whether the schema is required.
 * @returns {Yup.ObjectSchema} - The Yup JSON schema.
 */ function $27cb5f515eacb0bf$var$createJsonSchema(data, isRequired) {
    const schema = $1b19c6085a6e9611$export$be5493f9613cbbe().label(typeof data.label === "string" ? data.label : "Value");
    return isRequired ? schema.required() : schema;
}
/**
 * Creates a Yup array schema based on the provided data.
 * @param {SchemaFieldArray} data - The schema field array.
 * @param {boolean} [isRequired] - Whether the schema is required.
 * @returns {Yup.ArraySchema} - The Yup array schema.
 */ function $27cb5f515eacb0bf$var$createArraySchema(data, isRequired) {
    const field = data.items || {};
    const type = field.type;
    let itemSchema;
    if (type === "object") itemSchema = $27cb5f515eacb0bf$var$createObjectSchema(field);
    else if (type === "string") itemSchema = $27cb5f515eacb0bf$var$createStringSchema(field);
    else if (type === "number") itemSchema = $27cb5f515eacb0bf$var$createNumberSchema(field);
    else if (type === "json") itemSchema = $27cb5f515eacb0bf$var$createJsonSchema(field);
    else if (type === "array") itemSchema = $27cb5f515eacb0bf$var$createArraySchema(field);
    else throw new Error("Invalid item type");
    const schema = $1b19c6085a6e9611$export$2f23118c22fb2630().label(typeof data.label === "string" ? data.label : "Value").of(itemSchema).min(data.minItems || 0).max(data.maxItems || Infinity);
    return isRequired ? schema.required() : schema;
}
function $27cb5f515eacb0bf$export$4c3eba979352498d(obj) {
    if (typeof obj !== "object" || obj === null) return "";
    const firstKey = Object.keys(obj)[0];
    if (!firstKey) return "";
    const path = $27cb5f515eacb0bf$export$4c3eba979352498d(obj[firstKey]);
    return path ? `${firstKey}.${path}` : firstKey;
}


function $1f4c49dac40f32d2$export$bbcdeaee0c64136a() {
    const { errors: errors, isSubmitting: isSubmitting, isValidating: isValidating } = (0, $jTKGQ.useFormikContext)();
    (0, $8v0nu.useEffect)(()=>{
        // Run on submission after validation took place.
        if (!errors || !isSubmitting || isValidating) return;
        const path = (0, $27cb5f515eacb0bf$export$4c3eba979352498d)(errors);
        // Use the parent node because if the element is a hidden input, it won't
        // scroll.
        const element = document.querySelector(`[name="${path}"]`)?.parentNode;
        element?.scrollIntoView({
            block: "center",
            behavior: "smooth"
        });
    }, [
        errors,
        isSubmitting,
        isValidating
    ]);
    return null;
}


var $8v0nu = parcelRequire("8v0nu");
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $69dffeaae91691c1$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $69dffeaae91691c1$export$2e2bcd8739ae039 = $69dffeaae91691c1$var$apply;


/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $019f7528cf907441$var$identity(value) {
    return value;
}
var $019f7528cf907441$export$2e2bcd8739ae039 = $019f7528cf907441$var$identity;



/* Built-in method references for those with the same name as other `lodash` methods. */ var $1e51bc401b6043cd$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $1e51bc401b6043cd$var$overRest(func, start, transform) {
    start = $1e51bc401b6043cd$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $1e51bc401b6043cd$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $69dffeaae91691c1$export$2e2bcd8739ae039)(func, this, otherArgs);
    };
}
var $1e51bc401b6043cd$export$2e2bcd8739ae039 = $1e51bc401b6043cd$var$overRest;


/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $349f7f1053f1b044$var$constant(value) {
    return function() {
        return value;
    };
}
var $349f7f1053f1b044$export$2e2bcd8739ae039 = $349f7f1053f1b044$var$constant;



var $2cPDw = parcelRequire("2cPDw");

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $a51109bbe361e9ec$var$baseSetToString = !(0, $2cPDw.default) ? (0, $019f7528cf907441$export$2e2bcd8739ae039) : function(func, string) {
    return (0, $2cPDw.default)(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": (0, $349f7f1053f1b044$export$2e2bcd8739ae039)(string),
        "writable": true
    });
};
var $a51109bbe361e9ec$export$2e2bcd8739ae039 = $a51109bbe361e9ec$var$baseSetToString;


/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $5df937161dce32d0$var$HOT_COUNT = 800, $5df937161dce32d0$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5df937161dce32d0$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $5df937161dce32d0$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $5df937161dce32d0$var$nativeNow(), remaining = $5df937161dce32d0$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $5df937161dce32d0$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $5df937161dce32d0$export$2e2bcd8739ae039 = $5df937161dce32d0$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $391c7ab9c566c7e5$var$setToString = (0, $5df937161dce32d0$export$2e2bcd8739ae039)((0, $a51109bbe361e9ec$export$2e2bcd8739ae039));
var $391c7ab9c566c7e5$export$2e2bcd8739ae039 = $391c7ab9c566c7e5$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $3b00e771d951739b$var$baseRest(func, start) {
    return (0, $391c7ab9c566c7e5$export$2e2bcd8739ae039)((0, $1e51bc401b6043cd$export$2e2bcd8739ae039)(func, start, (0, $019f7528cf907441$export$2e2bcd8739ae039)), func + "");
}
var $3b00e771d951739b$export$2e2bcd8739ae039 = $3b00e771d951739b$var$baseRest;



var $5dLfO = parcelRequire("5dLfO");

var $8Xlz0 = parcelRequire("8Xlz0");

var $5TPq9 = parcelRequire("5TPq9");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $883fc7d74a4b25ca$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, $5TPq9.default)(object[key], value) || value === undefined && !(key in object)) (0, $8Xlz0.default)(object, key, value);
}
var $883fc7d74a4b25ca$export$2e2bcd8739ae039 = $883fc7d74a4b25ca$var$assignMergeValue;


/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $f2bbfbbebae8ef06$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $f2bbfbbebae8ef06$export$2e2bcd8739ae039 = $f2bbfbbebae8ef06$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $c2253e8a3eee9abf$var$baseFor = (0, $f2bbfbbebae8ef06$export$2e2bcd8739ae039)();
var $c2253e8a3eee9abf$export$2e2bcd8739ae039 = $c2253e8a3eee9abf$var$baseFor;




var $jXF4S = parcelRequire("jXF4S");

var $1Z4Db = parcelRequire("1Z4Db");

var $7KNPo = parcelRequire("7KNPo");

var $55JsH = parcelRequire("55JsH");

var $774DM = parcelRequire("774DM");

var $eA9yl = parcelRequire("eA9yl");

var $b9DUl = parcelRequire("b9DUl");

var $9XysK = parcelRequire("9XysK");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $2d3d78af7e122ce2$var$isArrayLikeObject(value) {
    return (0, $9XysK.default)(value) && (0, $b9DUl.default)(value);
}
var $2d3d78af7e122ce2$export$2e2bcd8739ae039 = $2d3d78af7e122ce2$var$isArrayLikeObject;



var $43Y3b = parcelRequire("43Y3b");

var $65Nb9 = parcelRequire("65Nb9");

var $55CT4 = parcelRequire("55CT4");

var $336aN = parcelRequire("336aN");

var $dK8Wz = parcelRequire("dK8Wz");
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $dd492644efd2ba18$var$safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
var $dd492644efd2ba18$export$2e2bcd8739ae039 = $dd492644efd2ba18$var$safeGet;



var $4Ekk0 = parcelRequire("4Ekk0");

var $efjUI = parcelRequire("efjUI");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $15853149df88a066$var$toPlainObject(value) {
    return (0, $4Ekk0.default)(value, (0, $efjUI.default)(value));
}
var $15853149df88a066$export$2e2bcd8739ae039 = $15853149df88a066$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $75022fcc643a5dcc$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, $dd492644efd2ba18$export$2e2bcd8739ae039)(object, key), srcValue = (0, $dd492644efd2ba18$export$2e2bcd8739ae039)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, $883fc7d74a4b25ca$export$2e2bcd8739ae039)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, $eA9yl.default)(srcValue), isBuff = !isArr && (0, $43Y3b.default)(srcValue), isTyped = !isArr && !isBuff && (0, $dK8Wz.default)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, $eA9yl.default)(objValue)) newValue = objValue;
            else if ((0, $2d3d78af7e122ce2$export$2e2bcd8739ae039)(objValue)) newValue = (0, $7KNPo.default)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, $jXF4S.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, $1Z4Db.default)(srcValue, true);
            } else newValue = [];
        } else if ((0, $336aN.default)(srcValue) || (0, $774DM.default)(srcValue)) {
            newValue = objValue;
            if ((0, $774DM.default)(objValue)) newValue = (0, $15853149df88a066$export$2e2bcd8739ae039)(objValue);
            else if (!(0, $55CT4.default)(objValue) || (0, $65Nb9.default)(objValue)) newValue = (0, $55JsH.default)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    (0, $883fc7d74a4b25ca$export$2e2bcd8739ae039)(object, key, newValue);
}
var $75022fcc643a5dcc$export$2e2bcd8739ae039 = $75022fcc643a5dcc$var$baseMergeDeep;



var $55CT4 = parcelRequire("55CT4");

var $efjUI = parcelRequire("efjUI");

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $bacc30e4bab426fb$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, $c2253e8a3eee9abf$export$2e2bcd8739ae039)(source, function(srcValue, key) {
        stack || (stack = new (0, $5dLfO.default));
        if ((0, $55CT4.default)(srcValue)) (0, $75022fcc643a5dcc$export$2e2bcd8739ae039)(object, source, key, srcIndex, $bacc30e4bab426fb$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, $dd492644efd2ba18$export$2e2bcd8739ae039)(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, $883fc7d74a4b25ca$export$2e2bcd8739ae039)(object, key, newValue);
        }
    }, (0, $efjUI.default));
}
var $bacc30e4bab426fb$export$2e2bcd8739ae039 = $bacc30e4bab426fb$var$baseMerge;



var $55CT4 = parcelRequire("55CT4");
/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */ function $3bc5a02e252daa06$var$customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
    if ((0, $55CT4.default)(objValue) && (0, $55CT4.default)(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        (0, $bacc30e4bab426fb$export$2e2bcd8739ae039)(objValue, srcValue, undefined, $3bc5a02e252daa06$var$customDefaultsMerge, stack);
        stack["delete"](srcValue);
    }
    return objValue;
}
var $3bc5a02e252daa06$export$2e2bcd8739ae039 = $3bc5a02e252daa06$var$customDefaultsMerge;





var $5TPq9 = parcelRequire("5TPq9");

var $b9DUl = parcelRequire("b9DUl");

var $7Jqv7 = parcelRequire("7Jqv7");

var $55CT4 = parcelRequire("55CT4");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $48e480d9285ffdde$var$isIterateeCall(value, index, object) {
    if (!(0, $55CT4.default)(object)) return false;
    var type = typeof index;
    if (type == "number" ? (0, $b9DUl.default)(object) && (0, $7Jqv7.default)(index, object.length) : type == "string" && index in object) return (0, $5TPq9.default)(object[index], value);
    return false;
}
var $48e480d9285ffdde$export$2e2bcd8739ae039 = $48e480d9285ffdde$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $e883878ef1245bc3$var$createAssigner(assigner) {
    return (0, $3b00e771d951739b$export$2e2bcd8739ae039)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && (0, $48e480d9285ffdde$export$2e2bcd8739ae039)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
var $e883878ef1245bc3$export$2e2bcd8739ae039 = $e883878ef1245bc3$var$createAssigner;


/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var $7ebba4c02f8804f7$var$mergeWith = (0, $e883878ef1245bc3$export$2e2bcd8739ae039)(function(object, source, srcIndex, customizer) {
    (0, $bacc30e4bab426fb$export$2e2bcd8739ae039)(object, source, srcIndex, customizer);
});
var $7ebba4c02f8804f7$export$2e2bcd8739ae039 = $7ebba4c02f8804f7$var$mergeWith;


/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */ var $dbc7df56edeb0963$var$defaultsDeep = (0, $3b00e771d951739b$export$2e2bcd8739ae039)(function(args) {
    args.push(undefined, (0, $3bc5a02e252daa06$export$2e2bcd8739ae039));
    return (0, $69dffeaae91691c1$export$2e2bcd8739ae039)((0, $7ebba4c02f8804f7$export$2e2bcd8739ae039), undefined, args);
});
var $dbc7df56edeb0963$export$2e2bcd8739ae039 = $dbc7df56edeb0963$var$defaultsDeep;



var $jGWdr = parcelRequire("jGWdr");

const $f9867bdb459b34dd$export$115139354037a140 = (plugins, data)=>{
    const p = plugins.flatMap((pl)=>{
        if (pl instanceof (0, $c0a25ef586f9da64$export$901cf72dabf2112a)) return pl;
        else if (typeof pl === "function") return pl(data);
        return;
    }).filter((p)=>p instanceof (0, $c0a25ef586f9da64$export$901cf72dabf2112a));
    return $f9867bdb459b34dd$export$6b8f01ca77e7b831(p);
};
const $f9867bdb459b34dd$export$6b8f01ca77e7b831 = (plugins)=>{
    const pluginsCopy = (0, $jGWdr.default)(plugins);
    for (const plSource of pluginsCopy)for (const hook of plSource[(0, $c0a25ef586f9da64$export$901cf72dabf2112a).HOOKS]){
        // Target where to apply the hook
        const plTarget = pluginsCopy.find((p)=>p.name === hook.name);
        if (!plTarget) continue;
        // The onAfterInit hook is made by executing one function after another.
        if (hook.onAfterInit) {
            const fn = hook.onAfterInit;
            const origInit = plTarget.init;
            plTarget.init = async (data)=>{
                await origInit.call(plTarget, data);
                await fn.call(plSource, plTarget, data);
            };
        }
        // The onAfterEditSchema hook is made by composing functions.
        if (hook.onAfterEditSchema) {
            const fn = hook.onAfterEditSchema;
            const origEditSchema = plTarget.editSchema;
            plTarget.editSchema = (formData)=>{
                return fn.call(plSource, plTarget, formData, origEditSchema.call(plTarget, formData));
            };
        }
    }
    return pluginsCopy;
};



function $c1e8126e9c607e51$export$bb0693b91fc28141(field) {
    if ([
        "root",
        "object"
    ].includes(field.type)) return Object.entries(field.properties).reduce((acc, [key, value])=>{
        return {
            ...acc,
            [key]: $c1e8126e9c607e51$export$bb0693b91fc28141(value)
        };
    }, {});
    if (field.type === "array") {
        if ((field.minItems || 0) > 0) return Array.from({
            length: field.minItems
        }).map(()=>$c1e8126e9c607e51$export$bb0693b91fc28141(field.items));
        return [];
    }
    if (field.type === "json") return {};
    return "";
}


const $4509732b37c182a7$var$usePlugins = (plugins, data)=>{
    const [readyPlugins, setReadyPlugins] = (0, $8v0nu.useState)();
    (0, $8v0nu.useEffect)(()=>{
        async function load() {
            // if (!data) return;
            const resolvedPlugins = (0, $f9867bdb459b34dd$export$115139354037a140)(plugins, data);
            await Promise.all(resolvedPlugins.map((pl)=>pl.init(data)));
            setReadyPlugins(resolvedPlugins);
        }
        load();
    }, [
        plugins,
        data
    ]);
    const formData = (0, $8v0nu.useMemo)(()=>{
        if (!readyPlugins) return;
        const emptyStructure = readyPlugins.reduce((acc, pl)=>{
            const schema = pl.editSchema();
            if (!schema || typeof schema === "symbol") return acc;
            return (0, $dbc7df56edeb0963$export$2e2bcd8739ae039)((0, $c1e8126e9c607e51$export$bb0693b91fc28141)(schema), acc);
        }, {});
        return readyPlugins.reduce((acc, pl)=>(0, $dbc7df56edeb0963$export$2e2bcd8739ae039)(pl.enterData(data), acc), emptyStructure);
    }, [
        readyPlugins
    ]);
    const toOutData = (0, $8v0nu.useCallback)((formData)=>readyPlugins && readyPlugins.reduce((acc, pl)=>({
                ...acc,
                ...pl.exitData(formData)
            }), {}), [
        readyPlugins
    ]);
    if (!readyPlugins) return {
        isLoading: true,
        plugins: undefined,
        formData: undefined,
        /* eslint-disable-next-line @typescript-eslint/no-unused-vars */ toOutData: (formData)=>undefined
    };
    return {
        isLoading: false,
        plugins: readyPlugins,
        formData: formData,
        toOutData: toOutData
    };
};
function $4509732b37c182a7$export$43d14ac0efc7a321(data) {
    const config = (0, $c14d6b556e5e27a6$export$bb6ca6e2ef1fe760)();
    return $4509732b37c182a7$var$usePlugins(config.collectionPlugins, data);
}
function $4509732b37c182a7$export$cd20375f87d4c554(data) {
    const config = (0, $c14d6b556e5e27a6$export$bb6ca6e2ef1fe760)();
    return $4509732b37c182a7$var$usePlugins(config.itemPlugins, data);
}


var $kxTYF = parcelRequire("kxTYF");

var $8v0nu = parcelRequire("8v0nu");

var $9HGsN = parcelRequire("9HGsN");


function $a43fa2f2fffac74f$export$bac6ca00840ef02b(props) {
    const { pointer: pointer, field: field, isRequired: isRequired } = props;
    const config = (0, $c14d6b556e5e27a6$export$bb6ca6e2ef1fe760)();
    const renderWidget = (widget)=>{
        const Widget = config["ui:widget"][widget];
        return /*#__PURE__*/ (0, $kxTYF.jsx)($a43fa2f2fffac74f$var$WidgetErrorBoundary, {
            field: field,
            widgetName: widget,
            pointer: pointer,
            children: Widget ? /*#__PURE__*/ (0, $kxTYF.jsx)(Widget, {
                pointer: pointer,
                field: field,
                isRequired: isRequired
            }) : /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $f49fc02b2c636efe$export$f04a3ea04edc0e04), {
                children: [
                    'Widget "',
                    widget,
                    '" not found'
                ]
            })
        });
    };
    // Explicitly defined widget
    if (field["ui:widget"]) return renderWidget(field["ui:widget"]);
    if (field.type === "array") {
        if (field.items.type === "string" && field.items.enum) return renderWidget("checkbox");
        if ([
            "string",
            "number"
        ].includes(field.items.type)) return renderWidget("array:string");
        return renderWidget("array");
    }
    if (field.type === "root" || field.type === "object") return renderWidget("object");
    if (field.type === "string" && field.enum) return renderWidget("radio");
    if (field.type === "json") return renderWidget("json");
    if (field.type === "number") return renderWidget("number");
    return renderWidget("text");
}
class $a43fa2f2fffac74f$var$WidgetErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    render() {
        if (this.state.error) return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $f49fc02b2c636efe$export$f04a3ea04edc0e04), {
            color: "base.500",
            alignItems: "left",
            p: 4,
            children: [
                /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $3963bf82c5559c75$export$5f1af8db9871e1d6), {
                    textTransform: "uppercase",
                    color: "red.500",
                    children: [
                        "\uD83D\uDC94 Error rendering widget (",
                        this.props.widgetName,
                        ")"
                    ]
                }),
                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3963bf82c5559c75$export$5f1af8db9871e1d6), {
                    children: this.state.error.message || "Something is wrong with this widget"
                }),
                /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $9HGsN.Box), {
                    as: "pre",
                    bg: "base.100",
                    borderRadius: "md",
                    p: 2,
                    fontSize: "small",
                    maxH: 64,
                    overflow: "auto",
                    children: [
                        "@.",
                        this.props.pointer,
                        " ",
                        /*#__PURE__*/ (0, $kxTYF.jsx)("br", {}),
                        /*#__PURE__*/ (0, $kxTYF.jsx)("code", {
                            children: JSON.stringify(this.props.field, null, 2)
                        })
                    ]
                })
            ]
        });
        return this.props.children;
    }
}



var $9HGsN = parcelRequire("9HGsN");
var $kxTYF = parcelRequire("kxTYF");


var $8v0nu = parcelRequire("8v0nu");



var $3lBLT = parcelRequire("3lBLT");
"use client";
const $2cf6f5791bed302c$var$attachedStyles = {
    horizontal: {
        "> *:first-of-type:not(:last-of-type)": {
            borderEndRadius: 0
        },
        "> *:not(:first-of-type):not(:last-of-type)": {
            borderRadius: 0
        },
        "> *:not(:first-of-type):last-of-type": {
            borderStartRadius: 0
        }
    },
    vertical: {
        "> *:first-of-type:not(:last-of-type)": {
            borderBottomRadius: 0
        },
        "> *:not(:first-of-type):not(:last-of-type)": {
            borderRadius: 0
        },
        "> *:not(:first-of-type):last-of-type": {
            borderTopRadius: 0
        }
    }
};
const $2cf6f5791bed302c$var$gapStyles = {
    horizontal: (spacing)=>({
            "& > *:not(style) ~ *:not(style)": {
                marginStart: spacing
            }
        }),
    vertical: (spacing)=>({
            "& > *:not(style) ~ *:not(style)": {
                marginTop: spacing
            }
        })
};
const $2cf6f5791bed302c$export$69b1032f2ecdf404 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function ButtonGroup2(props, ref) {
    const { size: size, colorScheme: colorScheme, variant: variant, className: className, spacing: spacing = "0.5rem", isAttached: isAttached, isDisabled: isDisabled, orientation: orientation = "horizontal", ...rest } = props;
    const _className = (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-button__group", className);
    const context = (0, $8v0nu.useMemo)(()=>({
            size: size,
            colorScheme: colorScheme,
            variant: variant,
            isDisabled: isDisabled
        }), [
        size,
        colorScheme,
        variant,
        isDisabled
    ]);
    let groupStyles = {
        display: "inline-flex",
        ...isAttached ? $2cf6f5791bed302c$var$attachedStyles[orientation] : $2cf6f5791bed302c$var$gapStyles[orientation](spacing)
    };
    const isVertical = orientation === "vertical";
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $a656748d54ee87a2$export$85041a2bb9328e33), {
        value: context,
        children: /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
            ref: ref,
            role: "group",
            __css: groupStyles,
            className: _className,
            "data-attached": isAttached ? "" : void 0,
            "data-orientation": orientation,
            flexDir: isVertical ? "column" : void 0,
            ...rest
        })
    });
});
$2cf6f5791bed302c$export$69b1032f2ecdf404.displayName = "ButtonGroup";



var $jTKGQ = parcelRequire("jTKGQ");

var $kxTYF = parcelRequire("kxTYF");

var $8v0nu = parcelRequire("8v0nu");

var $kxTYF = parcelRequire("kxTYF");


var $kxTYF = parcelRequire("kxTYF");

var $3lBLT = parcelRequire("3lBLT");
"use client";
const $0fa2495ce87a2cbe$export$c89a927ffc67e6fa = (props)=>/* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).circle, {
        cx: 50,
        cy: 50,
        r: 42,
        fill: "transparent",
        ...props
    });
$0fa2495ce87a2cbe$export$c89a927ffc67e6fa.displayName = "Circle";



var $6iKRa = parcelRequire("6iKRa");
"use client";
function $f1a1d16603d2ff97$var$valueToPercent(value, min, max) {
    return (value - min) * 100 / (max - min);
}
const $f1a1d16603d2ff97$export$c82e186cf428d56d = (0, $6iKRa.keyframes)({
    "0%": {
        strokeDasharray: "1, 400",
        strokeDashoffset: "0"
    },
    "50%": {
        strokeDasharray: "400, 400",
        strokeDashoffset: "-100"
    },
    "100%": {
        strokeDasharray: "400, 400",
        strokeDashoffset: "-260"
    }
});
const $f1a1d16603d2ff97$export$bb628a54ab399bc9 = (0, $6iKRa.keyframes)({
    "0%": {
        transform: "rotate(0deg)"
    },
    "100%": {
        transform: "rotate(360deg)"
    }
});
const $f1a1d16603d2ff97$export$504d7abb21fa8c9 = (0, $6iKRa.keyframes)({
    "0%": {
        left: "-40%"
    },
    "100%": {
        left: "100%"
    }
});
const $f1a1d16603d2ff97$export$735606310a3da449 = (0, $6iKRa.keyframes)({
    from: {
        backgroundPosition: "1rem 0"
    },
    to: {
        backgroundPosition: "0 0"
    }
});
function $f1a1d16603d2ff97$export$c5752331c2d05cd(options) {
    const { value: value = 0, min: min, max: max, valueText: valueText, getValueText: getValueText, isIndeterminate: isIndeterminate, role: role = "progressbar" } = options;
    const percent = $f1a1d16603d2ff97$var$valueToPercent(value, min, max);
    const getAriaValueText = ()=>{
        if (value == null) return void 0;
        return typeof getValueText === "function" ? getValueText(value, percent) : valueText;
    };
    return {
        bind: {
            "data-indeterminate": isIndeterminate ? "" : void 0,
            "aria-valuemax": max,
            "aria-valuemin": min,
            "aria-valuenow": isIndeterminate ? void 0 : value,
            "aria-valuetext": getAriaValueText(),
            role: role
        },
        percent: percent,
        value: value
    };
}



var $kxTYF = parcelRequire("kxTYF");


var $3lBLT = parcelRequire("3lBLT");
"use client";
const $b1a5aaacf1a06913$export$6428a7f2611ef1fa = (props)=>{
    const { size: size, isIndeterminate: isIndeterminate, ...rest } = props;
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).svg, {
        viewBox: "0 0 100 100",
        __css: {
            width: size,
            height: size,
            animation: isIndeterminate ? `${0, $f1a1d16603d2ff97$export$bb628a54ab399bc9} 2s linear infinite` : void 0
        },
        ...rest
    });
};
$b1a5aaacf1a06913$export$6428a7f2611ef1fa.displayName = "Shape";




var $3lBLT = parcelRequire("3lBLT");
"use client";
const $9b42bacba5a449ff$export$9e72f56a493060bf = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    const { size: size = "48px", max: max = 100, min: min = 0, valueText: valueText, getValueText: getValueText, value: value, capIsRound: capIsRound, children: children, thickness: thickness = "10px", color: color = "#0078d4", trackColor: trackColor = "#edebe9", isIndeterminate: isIndeterminate, ...rest } = props;
    const progress = (0, $f1a1d16603d2ff97$export$c5752331c2d05cd)({
        min: min,
        max: max,
        value: value,
        valueText: valueText,
        getValueText: getValueText,
        isIndeterminate: isIndeterminate
    });
    const determinant = isIndeterminate ? void 0 : (progress.percent ?? 0) * 2.64;
    const strokeDasharray = determinant == null ? void 0 : `${determinant} ${264 - determinant}`;
    const indicatorProps = isIndeterminate ? {
        css: {
            animation: `${0, $f1a1d16603d2ff97$export$c82e186cf428d56d} 1.5s linear infinite`
        }
    } : {
        strokeDashoffset: 66,
        strokeDasharray: strokeDasharray,
        transitionProperty: "stroke-dasharray, stroke",
        transitionDuration: "0.6s",
        transitionTimingFunction: "ease"
    };
    const rootStyles = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        display: "inline-block",
        position: "relative",
        verticalAlign: "middle",
        fontSize: size
    });
    return /* @__PURE__ */ (0, $kxTYF.jsxs)((0, $3lBLT.chakra).div, {
        ref: ref,
        className: "chakra-progress",
        ...progress.bind,
        ...rest,
        __css: rootStyles,
        children: [
            /* @__PURE__ */ (0, $kxTYF.jsxs)((0, $b1a5aaacf1a06913$export$6428a7f2611ef1fa), {
                size: size,
                isIndeterminate: isIndeterminate,
                children: [
                    /* @__PURE__ */ (0, $kxTYF.jsx)((0, $0fa2495ce87a2cbe$export$c89a927ffc67e6fa), {
                        stroke: trackColor,
                        strokeWidth: thickness,
                        className: "chakra-progress__track"
                    }),
                    /* @__PURE__ */ (0, $kxTYF.jsx)((0, $0fa2495ce87a2cbe$export$c89a927ffc67e6fa), {
                        stroke: color,
                        strokeWidth: thickness,
                        className: "chakra-progress__indicator",
                        strokeLinecap: capIsRound ? "round" : void 0,
                        opacity: progress.value === 0 && !isIndeterminate ? 0 : void 0,
                        ...indicatorProps
                    })
                ]
            }),
            children
        ]
    });
});
$9b42bacba5a449ff$export$9e72f56a493060bf.displayName = "CircularProgress";


var $kxTYF = parcelRequire("kxTYF");






var $3lBLT = parcelRequire("3lBLT");
"use client";
const $2d2a7a8f479cc337$export$842aba50ed0ce9d7 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function FormLabel2(passedProps, ref) {
    const styles = (0, $c7d173d35275482d$export$b863f77547fbcb03)("FormLabel", passedProps);
    const props = (0, $58ff34c9d17adf03$export$adfcf5a5e4d17785)(passedProps);
    const { className: className, children: children, requiredIndicator: requiredIndicator = /* @__PURE__ */ (0, $kxTYF.jsx)($2d2a7a8f479cc337$export$b36d93bade3250e4, {}), optionalIndicator: optionalIndicator = null, ...rest } = props;
    const field = (0, $02b238a4ba05f901$export$97a2352498389516)();
    const ownProps = field?.getLabelProps(rest, ref) ?? {
        ref: ref,
        ...rest
    };
    return /* @__PURE__ */ (0, $kxTYF.jsxs)((0, $3lBLT.chakra).label, {
        ...ownProps,
        className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-form__label", props.className),
        __css: {
            display: "block",
            textAlign: "start",
            ...styles
        },
        children: [
            children,
            field?.isRequired ? requiredIndicator : optionalIndicator
        ]
    });
});
$2d2a7a8f479cc337$export$842aba50ed0ce9d7.displayName = "FormLabel";
const $2d2a7a8f479cc337$export$b36d93bade3250e4 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function RequiredIndicator2(props, ref) {
    const field = (0, $02b238a4ba05f901$export$97a2352498389516)();
    const styles = (0, $02b238a4ba05f901$export$2824197c2cd75b1e)();
    if (!field?.isRequired) return null;
    const className = (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-form__required-indicator", props.className);
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).span, {
        ...field?.getRequiredIndicatorProps(props, ref),
        __css: styles.requiredIndicator,
        className: className
    });
});
$2d2a7a8f479cc337$export$b36d93bade3250e4.displayName = "RequiredIndicator";



var $jTKGQ = parcelRequire("jTKGQ");


var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");

var $9HGsN = parcelRequire("9HGsN");

const $8f2967926209c75b$export$e154be390aa0e14 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
        ref: ref,
        as: "fieldset",
        flexDirection: "column",
        gap: 8,
        p: 4,
        bg: "base.50a",
        borderRadius: "md",
        ...props
    });
});
const $8f2967926209c75b$export$4177b95adc81bedf = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
        ref: ref,
        justifyContent: "space-between",
        gap: 4,
        ...props
    });
});
const $8f2967926209c75b$export$47bfc31835db02f5 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
        ref: ref,
        flexDirection: "column",
        gap: 4,
        ...props
    });
});
const $8f2967926209c75b$export$849069c87286ea39 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
        ref: ref,
        gap: 4,
        ...props
    });
});
const $8f2967926209c75b$export$1acdcf5a973a8414 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8651ef577e25eea6$export$a8a3e93435678ff9), {
        ref: ref,
        as: "span",
        size: "sm",
        display: "inline-flex",
        alignItems: "center",
        gap: 2,
        ...props,
        sx: {
            ...props?.sx ?? {},
            small: {
                borderRadius: "sm",
                bg: "base.400a",
                color: "surface.500",
                px: "0.5rem",
                fontSize: "xs"
            }
        }
    });
});
const $8f2967926209c75b$export$90c6246c969554fc = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $5f067ccb39c91cbc$export$c25acd513dcc8062), {
        ref: ref,
        colorScheme: "base",
        variant: "soft-outline",
        size: "xs",
        ...props
    });
});
const $8f2967926209c75b$export$4520a427b44f3477 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    return /*#__PURE__*/ (0, $kxTYF.jsx)($8f2967926209c75b$export$90c6246c969554fc, {
        ref: ref,
        size: "sm",
        icon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$5918e8962b6636e9), {}),
        ...props
    });
});
function $8f2967926209c75b$export$528341e82434bd(props) {
    const { label: label, isRequired: isRequired, children: children, onRemove: onRemove, onAdd: onAdd, addDisabled: addDisabled, removeDisabled: removeDisabled } = props;
    return /*#__PURE__*/ (0, $kxTYF.jsxs)($8f2967926209c75b$export$e154be390aa0e14, {
        className: "widget--array",
        children: [
            (label || onRemove) && /*#__PURE__*/ (0, $kxTYF.jsxs)($8f2967926209c75b$export$4177b95adc81bedf, {
                children: [
                    label && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9HGsN.Box), {
                        children: /*#__PURE__*/ (0, $kxTYF.jsxs)($8f2967926209c75b$export$1acdcf5a973a8414, {
                            children: [
                                label,
                                isRequired && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3963bf82c5559c75$export$5f1af8db9871e1d6), {
                                    as: "span",
                                    color: "danger.500",
                                    role: "presentation",
                                    "aria-hidden": "true",
                                    children: "*"
                                })
                            ]
                        })
                    }),
                    onRemove && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9HGsN.Box), {
                        children: /*#__PURE__*/ (0, $kxTYF.jsx)($8f2967926209c75b$export$4520a427b44f3477, {
                            onClick: onRemove,
                            isDisabled: removeDisabled,
                            "aria-label": "Remove item"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $kxTYF.jsx)($8f2967926209c75b$export$47bfc31835db02f5, {
                children: children
            }),
            onAdd && /*#__PURE__*/ (0, $kxTYF.jsx)($8f2967926209c75b$export$849069c87286ea39, {
                children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $b8b7f6458056e8af$export$353f5b6fc5456de1), {
                    colorScheme: "base",
                    size: "sm",
                    onClick: onAdd,
                    "aria-label": "Add item",
                    leftIcon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$3a9f56a1d1f9a714), {}),
                    isDisabled: addDisabled,
                    children: "Add another"
                })
            })
        ]
    });
}



var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");

const $7dfa35a587ad2e70$export$302c944b8da23f96 = (0, $9138db1f951ed55c$export$7209ba2b0568490)((props)=>/*#__PURE__*/ (0, $kxTYF.jsxs)((0, $kxTYF.Fragment), {
        children: [
            props.title && /*#__PURE__*/ (0, $kxTYF.jsx)("title", {
                children: props.title
            }),
            /*#__PURE__*/ (0, $kxTYF.jsx)("path", {
                d: "M 0,32 v 64 h 416 v -64 z M 160,160 v 64 h 352 v -64 z M 160,288 v 64 h 288 v -64 z M 0,416 v 64 h 320 v -64 z"
            })
        ]
    }), {
    viewBox: "0 0 512 512"
});



const $5d31050dffea9ad7$var$JsonEditor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).lazy(()=>(parcelRequire("bS3sv")));
function $5d31050dffea9ad7$export$28f0f0b6ca7da3eb(props) {
    const field = props.field;
    const editorRef = (0, $8v0nu.useRef)(null);
    const [isLoaded, setIsLoaded] = (0, $8v0nu.useState)(false);
    return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $02b238a4ba05f901$export$fe5d99d8691b3f62), {
        children: [
            /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                gap: 4,
                children: [
                    field.label && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $2d2a7a8f479cc337$export$842aba50ed0ce9d7), {
                        children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8f2967926209c75b$export$1acdcf5a973a8414), {
                            size: "xs",
                            children: field.label
                        })
                    }),
                    isLoaded && /*#__PURE__*/ (0, $kxTYF.jsx)($5d31050dffea9ad7$var$ControlBar, {
                        editor: editorRef.current
                    })
                ]
            }),
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8v0nu.Suspense), {
                fallback: /*#__PURE__*/ (0, $kxTYF.jsx)($5d31050dffea9ad7$var$Loading, {}),
                children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $jTKGQ.FastField), {
                    name: props.pointer,
                    children: ({ field: { value: value }, form: { setFieldValue: setFieldValue } })=>/*#__PURE__*/ (0, $kxTYF.jsx)($5d31050dffea9ad7$var$JsonEditor, {
                            value: value,
                            onChange: (v)=>setFieldValue(props.pointer, v),
                            editorRef: editorRef,
                            onLoad: ()=>setIsLoaded(true)
                        })
                })
            })
        ]
    });
}
function $5d31050dffea9ad7$var$Loading() {
    return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
        alignItems: "center",
        gap: 2,
        justifyContent: "center",
        children: [
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9b42bacba5a449ff$export$9e72f56a493060bf), {
                isIndeterminate: true,
                color: "primary.500",
                size: "1.5rem"
            }),
            " ",
            "Loading json editor..."
        ]
    });
}
function $5d31050dffea9ad7$var$ControlBar(props) {
    const { editor: editor } = props;
    const undoManager = editor.aceEditor.getSession().getUndoManager();
    return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
        ml: "auto",
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8f2967926209c75b$export$90c6246c969554fc), {
                "aria-label": "Fix",
                onClick: ()=>{
                    editor.repair?.();
                    editor._onChange?.();
                },
                icon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$db99d8e121938012), {
                    size: 3
                })
            }),
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8f2967926209c75b$export$90c6246c969554fc), {
                "aria-label": "Compact",
                onClick: ()=>{
                    editor.compact?.();
                },
                icon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$3b8ef319a6c5f131), {
                    size: 3
                })
            }),
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8f2967926209c75b$export$90c6246c969554fc), {
                "aria-label": "Format",
                onClick: ()=>{
                    editor.format?.();
                },
                icon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $7dfa35a587ad2e70$export$302c944b8da23f96), {
                    size: 3
                })
            }),
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8f2967926209c75b$export$90c6246c969554fc), {
                "aria-label": "Undo",
                isDisabled: !undoManager?.canUndo(),
                onClick: ()=>{
                    undoManager?.undo();
                },
                icon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$d33a98b6c97f9bcf), {
                    size: 3
                })
            }),
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8f2967926209c75b$export$90c6246c969554fc), {
                "aria-label": "Redo",
                isDisabled: !undoManager?.canRedo(),
                onClick: ()=>{
                    undoManager?.redo();
                },
                icon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$65b63483548348e7), {
                    size: 3
                })
            })
        ]
    });
}





var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");

const $69e88a791767d218$export$cc646d2f0b9a8ed7 = (0, $9138db1f951ed55c$export$7209ba2b0568490)((props)=>/*#__PURE__*/ (0, $kxTYF.jsxs)((0, $kxTYF.Fragment), {
        children: [
            props.title && /*#__PURE__*/ (0, $kxTYF.jsx)("title", {
                children: props.title
            }),
            /*#__PURE__*/ (0, $kxTYF.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2 9V11H14V9H2ZM1 7C0.447715 7 0 7.44772 0 8V12C0 12.5523 0.447715 13 1 13H15C15.5523 13 16 12.5523 16 12V8C16 7.44772 15.5523 7 15 7H1Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $kxTYF.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2 2V4H14V2H2ZM1 0C0.447715 0 0 0.447715 0 1V5C0 5.55228 0.447715 6 1 6H15C15.5523 6 16 5.55228 16 5V1C16 0.447715 15.5523 0 15 0H1Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $kxTYF.jsx)("rect", {
                y: "14",
                width: "8",
                height: "2",
                fill: "currentColor"
            })
        ]
    }));



var $kxTYF = parcelRequire("kxTYF");

var $9HGsN = parcelRequire("9HGsN");


var $8v0nu = parcelRequire("8v0nu");
function $99f040781eeb1a87$export$909e4416e391c200(response) {
    if (response.status === 400 && response.detail.detail) {
        const notifications = response.detail.detail.reduce((acc, error, i)=>{
            let p = error.loc.slice(1);
            const last = error.loc[error.loc.length - 1];
            if (last === "float" || last === "int") p = p.slice(0, -1);
            const path = p.join(".");
            return acc.has(path) ? acc : acc.set(path, {
                id: i,
                type: "validation-error",
                path: path,
                message: error.msg
            });
        }, new Map());
        return Array.from(notifications.values());
    } else if (response.status === 403) return [
        {
            id: 0,
            type: "error",
            title: "Forbidden",
            message: "You do not have permission to perform this action."
        }
    ];
    return [
        {
            id: 0,
            type: "error",
            title: `Error ${response.status}`,
            message: "An error occurred: " + response.statusText
        }
    ];
}
function $99f040781eeb1a87$var$useNotificationsToast(notifications) {
    const toast = (0, $0ba8f0382a5131e9$export$a407b657d3044108)();
    const show = ()=>{
        if (!toast.isActive("notifications")) toast({
            id: "notifications",
            position: "bottom-right",
            duration: null,
            render: ()=>/*#__PURE__*/ (0, $kxTYF.jsx)($99f040781eeb1a87$export$4cc4937c9c6837aa, {
                    notifications: notifications,
                    onCloseClick: ()=>{
                        toast.close("notifications");
                    }
                })
        });
    };
    (0, $8v0nu.useEffect)(()=>{
        if (notifications.length !== 0) show();
        else toast.close("notifications");
    }, [
        notifications.length
    ]);
    return {
        show: show,
        hide: ()=>{
            toast.close("notifications");
        }
    };
}
function $99f040781eeb1a87$export$595cbcb116fb5622(props) {
    const { notifications: notifications } = props;
    const toast = $99f040781eeb1a87$var$useNotificationsToast(notifications);
    return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $b8b7f6458056e8af$export$353f5b6fc5456de1), {
        "aria-label": "Notifications",
        variant: "outline",
        onClick: ()=>{
            toast.show();
        },
        children: [
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$6d44efda105760b1), {}),
            !!notifications.length && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $6cea469a0e58db34$export$37acb3580601e69a), {
                variant: "solid",
                color: "white",
                bg: "base.400a",
                position: "absolute",
                top: "-0.5rem",
                right: "-0.5rem",
                px: 2,
                children: notifications.length < 10 ? `0${notifications.length}` : notifications.length
            })
        ]
    });
}
function $99f040781eeb1a87$export$4cc4937c9c6837aa(props) {
    const { onCloseClick: onCloseClick, notifications: notifications } = props;
    return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $9HGsN.Box), {
        shadow: "md",
        borderRadius: "md",
        bg: "surface.500",
        w: 80,
        overflow: "hidden",
        children: [
            /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                p: 4,
                borderBottom: "1px solid",
                borderColor: "base.100",
                boxShadow: "0 1px 0 0 rgba(0, 0, 0, 0.08)",
                position: "relative",
                alignItems: "center",
                gap: 4,
                children: [
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8651ef577e25eea6$export$a8a3e93435678ff9), {
                        size: "xs",
                        children: "Notifications"
                    }),
                    !!notifications.length && /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $6cea469a0e58db34$export$37acb3580601e69a), {
                        variant: "solid",
                        color: "white",
                        bg: "base.400a",
                        px: 2,
                        children: [
                            " ",
                            notifications.length < 10 ? `0${notifications.length}` : notifications.length
                        ]
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $5f067ccb39c91cbc$export$c25acd513dcc8062), {
                        icon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$4cca98ab4f54f41d), {}),
                        "aria-label": "Close notifications",
                        size: "sm",
                        variant: "outline",
                        onClick: onCloseClick,
                        ml: "auto"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9HGsN.Box), {
                overflowY: "scroll",
                maxH: "30rem",
                children: notifications.length ? notifications.map((n)=>/*#__PURE__*/ (0, $kxTYF.jsx)($99f040781eeb1a87$var$ErrorNotification, {
                        ...n
                    }, n.id)) : /*#__PURE__*/ (0, $kxTYF.jsx)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                    height: 20,
                    alignItems: "center",
                    justifyContent: "center",
                    px: 8,
                    children: "Nothing to show besides this satellite \uD83D\uDEF0\uFE0F"
                })
            })
        ]
    });
}
function $99f040781eeb1a87$var$ErrorNotification(props) {
    const { message: message, title: title } = props;
    return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
        boxShadow: "0 -1px 0 0 rgba(0, 0, 0, 0.08)",
        position: "relative",
        children: [
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                bg: "danger.200",
                p: 4,
                children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$f72e08a2ef494448), {
                    color: "danger.500"
                })
            }),
            /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $9HGsN.Box), {
                p: 4,
                children: [
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3963bf82c5559c75$export$5f1af8db9871e1d6), {
                        fontWeight: "bold",
                        mb: 2,
                        children: title || props.type === "validation-error" ? "Validation error" : "Error"
                    }),
                    props.type === "validation-error" && /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $kxTYF.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3963bf82c5559c75$export$5f1af8db9871e1d6), {
                                as: "span",
                                fontWeight: "bold",
                                children: "At:"
                            }),
                            " ",
                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3963bf82c5559c75$export$5f1af8db9871e1d6), {
                                as: "span",
                                fontStyle: "italic",
                                children: props.path
                            }),
                            /*#__PURE__*/ (0, $kxTYF.jsx)("br", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3963bf82c5559c75$export$5f1af8db9871e1d6), {
                        children: message
                    })
                ]
            })
        ]
    });
}


function $8f2e993a8ece010b$export$b63a055d7d5b8fe6(props) {
    const { initialData: initialData, onSubmit: onSubmit, notifications: notifications = [] } = props;
    const [stacData, setStacData] = (0, $8v0nu.useState)(initialData || {});
    const { plugins: plugins, formData: formData, toOutData: toOutData, isLoading: isLoading } = (0, $4509732b37c182a7$export$43d14ac0efc7a321)(stacData);
    const [view, setView] = (0, $8v0nu.useState)("fields");
    const editorData = (0, $8v0nu.useMemo)(()=>view === "json" ? {
            jsonData: stacData
        } : formData, [
        view,
        formData
    ]);
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9HGsN.Box), {
        children: isLoading ? /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9HGsN.Box), {
            children: "Loading plugins..."
        }) : /*#__PURE__*/ (0, $kxTYF.jsx)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
            direction: "column",
            gap: 4,
            children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $jTKGQ.Formik), {
                validateOnChange: false,
                enableReinitialize: true,
                initialValues: editorData,
                onSubmit: (values, actions)=>{
                    const exitData = view === "json" ? values.jsonData : toOutData(values);
                    return onSubmit(exitData, actions);
                },
                validate: (values)=>{
                    if (view === "json") return;
                    const [, error] = (0, $27cb5f515eacb0bf$export$51063abe2742d805)(plugins, values);
                    if (error) return error;
                },
                children: ({ handleSubmit: handleSubmit, values: values, isSubmitting: isSubmitting })=>/*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                        as: "form",
                        direction: "column",
                        gap: 8,
                        // @ts-expect-error Can't detect the as=form and throws error
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $1f4c49dac40f32d2$export$bbcdeaee0c64136a), {}),
                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $dfd76aae8c4830bc$export$47c5baa971b64ccb), {
                                overline: initialData ? "Editing Collection" : "Creating Collection",
                                title: initialData ? initialData.title || initialData.id : "New Collection",
                                actions: /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                                    gap: 4,
                                    children: [
                                        /*#__PURE__*/ (0, $kxTYF.jsx)((0, $99f040781eeb1a87$export$595cbcb116fb5622), {
                                            notifications: notifications
                                        }),
                                        /*#__PURE__*/ (0, $kxTYF.jsx)((0, $b8b7f6458056e8af$export$353f5b6fc5456de1), {
                                            type: "submit",
                                            isDisabled: isSubmitting,
                                            colorScheme: "primary",
                                            size: "md",
                                            leftIcon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$7679025d661a5f99), {}),
                                            children: initialData ? "Save" : "Create"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                                alignItems: "center",
                                justifyContent: "space-between",
                                px: 8,
                                children: [
                                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8651ef577e25eea6$export$a8a3e93435678ff9), {
                                        size: "md",
                                        as: "h2",
                                        children: initialData ? "Edit" : "New"
                                    }),
                                    /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $2cf6f5791bed302c$export$69b1032f2ecdf404), {
                                        isAttached: true,
                                        variant: "outline",
                                        size: "md",
                                        children: [
                                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $b8b7f6458056e8af$export$353f5b6fc5456de1), {
                                                "aria-label": "Edit Form",
                                                leftIcon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $69e88a791767d218$export$cc646d2f0b9a8ed7), {}),
                                                onClick: ()=>{
                                                    setView("fields");
                                                    setStacData(values.jsonData);
                                                },
                                                isActive: view === "fields",
                                                children: "Form"
                                            }),
                                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $b8b7f6458056e8af$export$353f5b6fc5456de1), {
                                                "aria-label": "Edit JSON",
                                                leftIcon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$1610bcb056ae58bb), {}),
                                                onClick: ()=>{
                                                    setView("json");
                                                    setStacData(toOutData(values));
                                                },
                                                isActive: view === "json",
                                                children: "JSON"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                                flexFlow: "column",
                                gap: 4,
                                children: view === "fields" ? plugins.map((pl)=>/*#__PURE__*/ (0, $kxTYF.jsx)((0, $4f2b90a8dcc95f5b$export$6a4d9223b7302baa), {
                                        plugin: pl,
                                        children: ({ field: field })=>/*#__PURE__*/ (0, $kxTYF.jsxs)((0, $9HGsN.Box), {
                                                p: "8",
                                                borderRadius: "lg",
                                                bg: "base.50a",
                                                display: "flex",
                                                flexDir: "column",
                                                gap: 8,
                                                children: [
                                                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8651ef577e25eea6$export$a8a3e93435678ff9), {
                                                        size: "sm",
                                                        children: pl.name
                                                    }),
                                                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $a43fa2f2fffac74f$export$bac6ca00840ef02b), {
                                                        pointer: "",
                                                        field: field
                                                    })
                                                ]
                                            })
                                    }, pl.name)) : /*#__PURE__*/ (0, $kxTYF.jsx)((0, $5d31050dffea9ad7$export$28f0f0b6ca7da3eb), {
                                    field: {
                                        type: "json",
                                        label: "Json Document"
                                    },
                                    pointer: "jsonData"
                                })
                            })
                        ]
                    })
            })
        })
    });
}




function $d8d64c35e07ebf83$export$9fbdb99242c1b155() {
    const { collectionId: collectionId } = (0, $aa6b6e9e15323f83$export$99eaa27ddbbb95ef)();
    return collectionId ? /*#__PURE__*/ (0, $kxTYF.jsx)($d8d64c35e07ebf83$export$140ee8e6e165c7dc, {
        id: collectionId
    }) : /*#__PURE__*/ (0, $kxTYF.jsx)($d8d64c35e07ebf83$export$bdbef02b82d36d61, {});
}
function $d8d64c35e07ebf83$export$bdbef02b82d36d61() {
    (0, $aec39e40387762bd$export$2e2bcd8739ae039)("New collection");
    const toast = (0, $0ba8f0382a5131e9$export$a407b657d3044108)();
    const navigate = (0, $aa6b6e9e15323f83$export$9770f232ac06a008)();
    const api = (0, $e60c4cd554136647$export$eb2799109db70ffd)();
    const [notifications, setNotifications] = (0, $8v0nu.useState)();
    const onSubmit = async (data, formikHelpers)=>{
        try {
            toast.closeAll();
            setNotifications(undefined);
            toast({
                id: "collection-submit",
                title: "Creating collection...",
                status: "loading",
                duration: null,
                position: "bottom-right"
            });
            await $d8d64c35e07ebf83$var$collectionTransaction(api).create(data);
            toast.update("collection-submit", {
                title: "Collection created",
                status: "success",
                duration: 5000,
                isClosable: true
            });
            navigate(`/collections/${data.id}`);
        } catch (error) {
            toast.close("collection-submit");
            setNotifications((0, $99f040781eeb1a87$export$909e4416e391c200)(error));
        }
        formikHelpers.setSubmitting(false);
    };
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8f2e993a8ece010b$export$b63a055d7d5b8fe6), {
        onSubmit: onSubmit,
        notifications: notifications
    });
}
function $d8d64c35e07ebf83$export$140ee8e6e165c7dc(props) {
    const { id: id } = props;
    const { collection: collection, state: state, error: error } = (0, $eba44fb2c963ffed$export$6cd28814d92fa9c9)(id);
    const api = (0, $e60c4cd554136647$export$eb2799109db70ffd)();
    const [triedLoading, setTriedLoading] = (0, $8v0nu.useState)(!!collection);
    const [notifications, setNotifications] = (0, $8v0nu.useState)();
    (0, $aec39e40387762bd$export$2e2bcd8739ae039)(collection ? `Edit collection ${id}` : "Edit collection");
    const navigate = (0, $aa6b6e9e15323f83$export$9770f232ac06a008)();
    const toast = (0, $0ba8f0382a5131e9$export$a407b657d3044108)();
    (0, $8v0nu.useEffect)(()=>{
        if (state === "LOADING") setTriedLoading(true);
    }, [
        state
    ]);
    if (state === "LOADING" || !triedLoading) return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9HGsN.Box), {
        children: "Loading collection..."
    });
    if (error) return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $9HGsN.Box), {
        children: [
            "Error loading collection: ",
            error.detail
        ]
    });
    const onSubmit = async (data, formikHelpers)=>{
        try {
            toast.closeAll();
            setNotifications(undefined);
            toast({
                id: "collection-submit",
                title: "Updating collection...",
                status: "loading",
                duration: null,
                position: "bottom-right"
            });
            await $d8d64c35e07ebf83$var$collectionTransaction(api).update(id, data);
            toast.update("collection-submit", {
                title: "Collection updated",
                status: "success",
                duration: 5000,
                isClosable: true
            });
            navigate(`/collections/${data.id}`);
        } catch (error) {
            toast.close("collection-submit");
            setNotifications((0, $99f040781eeb1a87$export$909e4416e391c200)(error));
        }
        formikHelpers.setSubmitting(false);
    };
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8f2e993a8ece010b$export$b63a055d7d5b8fe6), {
        onSubmit: onSubmit,
        initialData: collection,
        notifications: notifications
    });
}
function $d8d64c35e07ebf83$var$collectionTransaction(api) {
    const createRequest = async (url, method, data)=>{
        return api.fetch(url, {
            method: method,
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        });
    };
    return {
        update: (id, data)=>createRequest(`${(0, $e60c4cd554136647$export$b919fd560f065399)}/collections/${id}`, "PUT", data),
        create: (data)=>createRequest(`${(0, $e60c4cd554136647$export$b919fd560f065399)}/collections/`, "POST", data)
    };
}



var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");


var $9HGsN = parcelRequire("9HGsN");
var $kxTYF = parcelRequire("kxTYF");

var $7hYFp = parcelRequire("7hYFp");


var $3lBLT = parcelRequire("3lBLT");
"use client";
function $d3de29280e541829$var$spanFn(span) {
    return (0, $709e79e23fab15a6$export$eca1915781c2aaca)(span, (value)=>value === "auto" ? "auto" : `span ${value}/span ${value}`);
}
const $d3de29280e541829$export$9eb849b9b922d396 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function GridItem2(props, ref) {
    const { area: area, colSpan: colSpan, colStart: colStart, colEnd: colEnd, rowEnd: rowEnd, rowSpan: rowSpan, rowStart: rowStart, ...rest } = props;
    const styles = (0, $7hYFp.compact)({
        gridArea: area,
        gridColumn: $d3de29280e541829$var$spanFn(colSpan),
        gridRow: $d3de29280e541829$var$spanFn(rowSpan),
        gridColumnStart: colStart,
        gridColumnEnd: colEnd,
        gridRowStart: rowStart,
        gridRowEnd: rowEnd
    });
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
        ref: ref,
        __css: styles,
        ...rest
    });
});
$d3de29280e541829$export$9eb849b9b922d396.displayName = "GridItem";

"use client";
const $4418259e0694d88e$export$8fecac46448b5689 = {
    border: "0",
    clip: "rect(0, 0, 0, 0)",
    height: "1px",
    width: "1px",
    margin: "-1px",
    padding: "0",
    overflow: "hidden",
    whiteSpace: "nowrap",
    position: "absolute"
};



var $3lBLT = parcelRequire("3lBLT");
"use client";
const $3380028199317e44$export$439d29a4e110a164 = (0, $3lBLT.chakra)("span", {
    baseStyle: (0, $4418259e0694d88e$export$8fecac46448b5689)
});
$3380028199317e44$export$439d29a4e110a164.displayName = "VisuallyHidden";
const $3380028199317e44$export$43b83385b37b9ca0 = (0, $3lBLT.chakra)("input", {
    baseStyle: (0, $4418259e0694d88e$export$8fecac46448b5689)
});
$3380028199317e44$export$43b83385b37b9ca0.displayName = "VisuallyHiddenInput";







var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");

var $9HGsN = parcelRequire("9HGsN");
var $b9191d8af0471bbc$exports = {};

var $3Dz4Y = parcelRequire("3Dz4Y");

$3Dz4Y.importFields((parcelRequire("aUdEw")));

$3Dz4Y.addDependency("@musement/iso-duration", (parcelRequire("4mRY8")));

$3Dz4Y.addDependency("content-type", (parcelRequire("fJT3K")));

$3Dz4Y.addDependency("commonmark", (parcelRequire("4TV4A")));

$3Dz4Y.addDependency("multihashes", (parcelRequire("hci3a")));





$b9191d8af0471bbc$exports = {
    ...(parcelRequire("5cAwf")),
    Fields: $3Dz4Y.exportFields(),
    Registry: $3Dz4Y,
    Helper: (parcelRequire("f5gxW")),
    DataTypes: (parcelRequire("cbZCz")),
    Formatters: (parcelRequire("e6fPk")),
    I18N: (parcelRequire("3IH32"))
};






function $12023aea359e11c1$var$Asset({ asset: asset, assetKey: assetKey }) {
    const { title: title, description: description, roles: roles, type: type, href: href, alternate: alternate } = asset;
    const formattedProperties = (0, (/*@__PURE__*/$parcel$interopDefault($b9191d8af0471bbc$exports))).formatAsset({
        type: type
    })[0].properties;
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3456399f909bb134$export$f55f1d663c7efb35), {
        title: title || assetKey,
        subtitle: formattedProperties.type.formatted,
        description: description,
        tags: roles,
        renderMenu: ()=>{
            return alternate ? /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $bbc1594d228c6000$export$d9b273488cd8ce6f), {
                placement: "bottom-end",
                children: [
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $5277a93d60858aae$export$266a769812832828), {
                        as: (0, $5f067ccb39c91cbc$export$c25acd513dcc8062),
                        "aria-label": "Download options",
                        icon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$b307b75901e71920), {}),
                        variant: "outline",
                        size: "sm"
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $caedd5fbd169c955$export$d4c4e98c5044dc8), {
                        children: Object.entries(alternate).map(([key, val])=>/*#__PURE__*/ (0, $kxTYF.jsx)((0, $293887a95e6a8bc4$export$2ce376c2cc3355c8), {
                                as: (0, $78d29a24c660df8a$export$2e2bcd8739ae039),
                                to: val.href,
                                children: val.title || val.href
                            }, key))
                    })
                ]
            }) : /*#__PURE__*/ (0, $kxTYF.jsx)((0, $5f067ccb39c91cbc$export$c25acd513dcc8062), {
                as: (0, $78d29a24c660df8a$export$2e2bcd8739ae039),
                to: href,
                "aria-label": "Download",
                icon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$c1c6fe15475bbb7e), {}),
                variant: "outline",
                size: "sm"
            });
        }
    });
}
function $12023aea359e11c1$var$AssetList({ assets: assets }) {
    const assetsList = Object.entries(assets);
    return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
        direction: "column",
        gap: "8",
        as: "section",
        children: [
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                direction: "row",
                px: "8",
                gap: "8",
                as: "header",
                children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9HGsN.Box), {
                    flexBasis: "100%",
                    children: /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $8651ef577e25eea6$export$a8a3e93435678ff9), {
                        size: "md",
                        as: "h2",
                        children: [
                            "Assets ",
                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $6cea469a0e58db34$export$37acb3580601e69a), {
                                variant: "solid",
                                children: (0, $f55c5bb8e60e90fc$export$3cdc770bf8b2ed3d)(assetsList.length)
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $97afd073f9746d02$export$de97fecb6d4b30a5), {
                gap: 8,
                templateColumns: "repeat(auto-fill, minmax(20rem, 1fr))",
                children: assetsList.map(([key, asset])=>/*#__PURE__*/ (0, $kxTYF.jsx)($12023aea359e11c1$var$Asset, {
                        asset: asset,
                        assetKey: key
                    }, key))
            })
        ]
    });
}
var $12023aea359e11c1$export$2e2bcd8739ae039 = $12023aea359e11c1$var$AssetList;




var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");



const $9fe47dbb44516a54$var$baseStacBrowserUrl = `https://radiantearth.github.io/stac-browser/#/external/${"https://eoapi.develop.eoepca.org/stac/"}`;
function $9fe47dbb44516a54$export$2b6a1f5f68a01133(props) {
    const { resourcePath: resourcePath, ...rest } = props;
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $293887a95e6a8bc4$export$2ce376c2cc3355c8), {
        icon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$922c85641f9f6751), {}),
        as: (0, $78d29a24c660df8a$export$2e2bcd8739ae039),
        to: `${$9fe47dbb44516a54$var$baseStacBrowserUrl}${resourcePath}`,
        ...rest,
        children: "View in STAC Browser"
    });
}



var $kxTYF = parcelRequire("kxTYF");

var $8v0nu = parcelRequire("8v0nu");

var $8v0nu = parcelRequire("8v0nu");

var $8v0nu = parcelRequire("8v0nu");

var $8v0nu = parcelRequire("8v0nu");

const $5377e9d4a5edec71$export$c6c68f6e4db55944 = $8v0nu.createContext(null);
const $5377e9d4a5edec71$export$507c997ee09bb471 = (props)=>{
    const [maps, setMaps] = (0, $8v0nu.useState)({});
    const onMapMount = (0, $8v0nu.useCallback)((map, id = "default")=>{
        setMaps((currMaps)=>{
            if (id === "current") throw new Error("'current' cannot be used as map id");
            if (currMaps[id]) throw new Error(`Multiple maps with the same id: ${id}`);
            return {
                ...currMaps,
                [id]: map
            };
        });
    }, []);
    const onMapUnmount = (0, $8v0nu.useCallback)((id = "default")=>{
        setMaps((currMaps)=>{
            if (currMaps[id]) {
                const nextMaps = {
                    ...currMaps
                };
                delete nextMaps[id];
                return nextMaps;
            }
            return currMaps;
        });
    }, []);
    return $8v0nu.createElement($5377e9d4a5edec71$export$c6c68f6e4db55944.Provider, {
        value: {
            maps: maps,
            onMapMount: onMapMount,
            onMapUnmount: onMapUnmount
        }
    }, props.children);
};
function $5377e9d4a5edec71$export$86f8f9f08863e403() {
    var _a;
    const maps = (_a = (0, $8v0nu.useContext)($5377e9d4a5edec71$export$c6c68f6e4db55944)) === null || _a === void 0 ? void 0 : _a.maps;
    const currentMap = (0, $8v0nu.useContext)((0, $b2f07233b90f3c17$export$dc7344301ae78f85));
    const mapsWithCurrent = (0, $8v0nu.useMemo)(()=>{
        return {
            ...maps,
            current: currentMap === null || currentMap === void 0 ? void 0 : currentMap.map
        };
    }, [
        maps,
        currentMap
    ]);
    return mapsWithCurrent;
}


/**
 * Compare two points
 * @param a
 * @param b
 * @returns true if the points are equal
 */ function $87aad2a444d91539$export$cb7477365ef68362(a, b) {
    const ax = Array.isArray(a) ? a[0] : a ? a.x : 0;
    const ay = Array.isArray(a) ? a[1] : a ? a.y : 0;
    const bx = Array.isArray(b) ? b[0] : b ? b.x : 0;
    const by = Array.isArray(b) ? b[1] : b ? b.y : 0;
    return ax === bx && ay === by;
}
function $87aad2a444d91539$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    if (!a || !b) return false;
    if (Array.isArray(a)) {
        if (!Array.isArray(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!$87aad2a444d91539$export$9cb4719e2e525b7a(a[i], b[i])) return false;
        }
        return true;
    } else if (Array.isArray(b)) return false;
    if (typeof a === "object" && typeof b === "object") {
        const aKeys = Object.keys(a);
        const bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) return false;
        for (const key of aKeys){
            if (!b.hasOwnProperty(key)) return false;
            if (!$87aad2a444d91539$export$9cb4719e2e525b7a(a[key], b[key])) return false;
        }
        return true;
    }
    return false;
}


function $36e35180a1a0c360$export$dd516654c5f598fb(tr) {
    const newTransform = tr.clone();
    // Work around mapbox bug - this value is not assigned in clone(), only in resize()
    newTransform.pixelsToGLUnits = tr.pixelsToGLUnits;
    return newTransform;
}
function $36e35180a1a0c360$export$7bd220dfde473c56(src, dest) {
    if (!src.getProjection) return;
    const srcProjection = src.getProjection();
    const destProjection = dest.getProjection();
    if (!(0, $87aad2a444d91539$export$9cb4719e2e525b7a)(srcProjection, destProjection)) dest.setProjection(srcProjection);
}
function $36e35180a1a0c360$export$6a605c5aa5bd97a8(tr) {
    return {
        longitude: tr.center.lng,
        latitude: tr.center.lat,
        zoom: tr.zoom,
        pitch: tr.pitch,
        bearing: tr.bearing,
        padding: tr.padding
    };
}
function $36e35180a1a0c360$export$5cf06eaeb862e3ce(tr, props) {
    const v = props.viewState || props;
    let changed = false;
    if ("longitude" in v && "latitude" in v) {
        const center = tr.center;
        // @ts-ignore
        tr.center = new center.constructor(v.longitude, v.latitude);
        changed = changed || center !== tr.center;
    }
    if ("zoom" in v) {
        const zoom = tr.zoom;
        tr.zoom = v.zoom;
        changed = changed || zoom !== tr.zoom;
    }
    if ("bearing" in v) {
        const bearing = tr.bearing;
        tr.bearing = v.bearing;
        changed = changed || bearing !== tr.bearing;
    }
    if ("pitch" in v) {
        const pitch = tr.pitch;
        tr.pitch = v.pitch;
        changed = changed || pitch !== tr.pitch;
    }
    if (v.padding && !tr.isPaddingEqual(v.padding)) {
        changed = true;
        tr.padding = v.padding;
    }
    return changed;
}


const $67ed04f5529e50d6$var$refProps = [
    "type",
    "source",
    "source-layer",
    "minzoom",
    "maxzoom",
    "filter",
    "layout"
];
function $67ed04f5529e50d6$export$8756898546458274(style) {
    if (!style) return null;
    if (typeof style === "string") return style;
    if ("toJS" in style) style = style.toJS();
    if (!style.layers) return style;
    const layerIndex = {};
    for (const layer of style.layers)layerIndex[layer.id] = layer;
    const layers = style.layers.map((layer)=>{
        let normalizedLayer = null;
        if ("interactive" in layer) {
            normalizedLayer = Object.assign({}, layer);
            // Breaks style diffing :(
            // @ts-ignore legacy field not typed
            delete normalizedLayer.interactive;
        }
        // Style diffing doesn't work with refs so expand them out manually before diffing.
        // @ts-ignore legacy field not typed
        const layerRef = layerIndex[layer.ref];
        if (layerRef) {
            normalizedLayer = normalizedLayer || Object.assign({}, layer);
            // @ts-ignore
            delete normalizedLayer.ref;
            // https://github.com/mapbox/mapbox-gl-js/blob/master/src/style-spec/deref.js
            for (const propName of $67ed04f5529e50d6$var$refProps)if (propName in layerRef) normalizedLayer[propName] = layerRef[propName];
        }
        return normalizedLayer || layer;
    });
    // Do not mutate the style object provided by the user
    return {
        ...style,
        layers: layers
    };
}



const $329a4d9bb02600da$var$DEFAULT_STYLE = {
    version: 8,
    sources: {},
    layers: []
};
const $329a4d9bb02600da$var$pointerEvents = {
    mousedown: "onMouseDown",
    mouseup: "onMouseUp",
    mouseover: "onMouseOver",
    mousemove: "onMouseMove",
    click: "onClick",
    dblclick: "onDblClick",
    mouseenter: "onMouseEnter",
    mouseleave: "onMouseLeave",
    mouseout: "onMouseOut",
    contextmenu: "onContextMenu",
    touchstart: "onTouchStart",
    touchend: "onTouchEnd",
    touchmove: "onTouchMove",
    touchcancel: "onTouchCancel"
};
const $329a4d9bb02600da$var$cameraEvents = {
    movestart: "onMoveStart",
    move: "onMove",
    moveend: "onMoveEnd",
    dragstart: "onDragStart",
    drag: "onDrag",
    dragend: "onDragEnd",
    zoomstart: "onZoomStart",
    zoom: "onZoom",
    zoomend: "onZoomEnd",
    rotatestart: "onRotateStart",
    rotate: "onRotate",
    rotateend: "onRotateEnd",
    pitchstart: "onPitchStart",
    pitch: "onPitch",
    pitchend: "onPitchEnd"
};
const $329a4d9bb02600da$var$otherEvents = {
    wheel: "onWheel",
    boxzoomstart: "onBoxZoomStart",
    boxzoomend: "onBoxZoomEnd",
    boxzoomcancel: "onBoxZoomCancel",
    resize: "onResize",
    load: "onLoad",
    render: "onRender",
    idle: "onIdle",
    remove: "onRemove",
    data: "onData",
    styledata: "onStyleData",
    sourcedata: "onSourceData",
    error: "onError"
};
const $329a4d9bb02600da$var$settingNames = [
    "minZoom",
    "maxZoom",
    "minPitch",
    "maxPitch",
    "maxBounds",
    "projection",
    "renderWorldCopies"
];
const $329a4d9bb02600da$var$handlerNames = [
    "scrollZoom",
    "boxZoom",
    "dragRotate",
    "dragPan",
    "keyboard",
    "doubleClickZoom",
    "touchZoomRotate",
    "touchPitch"
];
class $329a4d9bb02600da$export$2e2bcd8739ae039 {
    constructor(MapClass, props, container){
        // mapboxgl.Map instance
        this._map = null;
        // Internal states
        this._internalUpdate = false;
        this._inRender = false;
        this._hoveredFeatures = null;
        this._deferredEvents = {
            move: false,
            zoom: false,
            pitch: false,
            rotate: false
        };
        this._onEvent = (e)=>{
            // @ts-ignore
            const cb = this.props[$329a4d9bb02600da$var$otherEvents[e.type]];
            if (cb) cb(e);
            else if (e.type === "error") console.error(e.error); // eslint-disable-line
        };
        this._onPointerEvent = (e)=>{
            if (e.type === "mousemove" || e.type === "mouseout") this._updateHover(e);
            // @ts-ignore
            const cb = this.props[$329a4d9bb02600da$var$pointerEvents[e.type]];
            if (cb) {
                if (this.props.interactiveLayerIds && e.type !== "mouseover" && e.type !== "mouseout") e.features = this._hoveredFeatures || this._queryRenderedFeatures(e.point);
                cb(e);
                delete e.features;
            }
        };
        this._onCameraEvent = (e)=>{
            if (!this._internalUpdate) {
                // @ts-ignore
                const cb = this.props[$329a4d9bb02600da$var$cameraEvents[e.type]];
                if (cb) cb(e);
            }
            if (e.type in this._deferredEvents) this._deferredEvents[e.type] = false;
        };
        this._MapClass = MapClass;
        this.props = props;
        this._initialize(container);
    }
    get map() {
        return this._map;
    }
    get transform() {
        return this._renderTransform;
    }
    setProps(props) {
        const oldProps = this.props;
        this.props = props;
        const settingsChanged = this._updateSettings(props, oldProps);
        if (settingsChanged) this._createShadowTransform(this._map);
        const sizeChanged = this._updateSize(props);
        const viewStateChanged = this._updateViewState(props, true);
        this._updateStyle(props, oldProps);
        this._updateStyleComponents(props, oldProps);
        this._updateHandlers(props, oldProps);
        // If 1) view state has changed to match props and
        //    2) the props change is not triggered by map events,
        // it's driven by an external state change. Redraw immediately
        if (settingsChanged || sizeChanged || viewStateChanged && !this._map.isMoving()) this.redraw();
    }
    static reuse(props, container) {
        const that = $329a4d9bb02600da$export$2e2bcd8739ae039.savedMaps.pop();
        if (!that) return null;
        const map = that.map;
        // When reusing the saved map, we need to reparent the map(canvas) and other child nodes
        // intoto the new container from the props.
        // Step 1: reparenting child nodes from old container to new container
        const oldContainer = map.getContainer();
        container.className = oldContainer.className;
        while(oldContainer.childNodes.length > 0)container.appendChild(oldContainer.childNodes[0]);
        // Step 2: replace the internal container with new container from the react component
        // @ts-ignore
        map._container = container;
        // With maplibre-gl as mapLib, map uses ResizeObserver to observe when its container resizes.
        // When reusing the saved map, we need to disconnect the observer and observe the new container.
        // Step 3: telling the ResizeObserver to disconnect and observe the new container
        // @ts-ignore
        const resizeObserver = map._resizeObserver;
        if (resizeObserver) {
            resizeObserver.disconnect();
            resizeObserver.observe(container);
        }
        // Step 4: apply new props
        that.setProps({
            ...props,
            styleDiffing: false
        });
        map.resize();
        const { initialViewState: initialViewState } = props;
        if (initialViewState) {
            if (initialViewState.bounds) map.fitBounds(initialViewState.bounds, {
                ...initialViewState.fitBoundsOptions,
                duration: 0
            });
            else that._updateViewState(initialViewState, false);
        }
        // Simulate load event
        if (map.isStyleLoaded()) map.fire("load");
        else map.once("styledata", ()=>map.fire("load"));
        // Force reload
        // @ts-ignore
        map._update();
        return that;
    }
    /* eslint-disable complexity,max-statements */ _initialize(container) {
        const { props: props } = this;
        const { mapStyle: mapStyle = $329a4d9bb02600da$var$DEFAULT_STYLE } = props;
        const mapOptions = {
            ...props,
            ...props.initialViewState,
            accessToken: props.mapboxAccessToken || $329a4d9bb02600da$var$getAccessTokenFromEnv() || null,
            container: container,
            style: (0, $67ed04f5529e50d6$export$8756898546458274)(mapStyle)
        };
        const viewState = mapOptions.initialViewState || mapOptions.viewState || mapOptions;
        Object.assign(mapOptions, {
            center: [
                viewState.longitude || 0,
                viewState.latitude || 0
            ],
            zoom: viewState.zoom || 0,
            pitch: viewState.pitch || 0,
            bearing: viewState.bearing || 0
        });
        if (props.gl) {
            // eslint-disable-next-line
            const getContext = HTMLCanvasElement.prototype.getContext;
            // Hijack canvas.getContext to return our own WebGLContext
            // This will be called inside the mapboxgl.Map constructor
            // @ts-expect-error
            HTMLCanvasElement.prototype.getContext = ()=>{
                // Unhijack immediately
                HTMLCanvasElement.prototype.getContext = getContext;
                return props.gl;
            };
        }
        const map = new this._MapClass(mapOptions);
        // Props that are not part of constructor options
        if (viewState.padding) map.setPadding(viewState.padding);
        if (props.cursor) map.getCanvas().style.cursor = props.cursor;
        this._createShadowTransform(map);
        // Hack
        // Insert code into map's render cycle
        const renderMap = map._render;
        map._render = (arg)=>{
            this._inRender = true;
            renderMap.call(map, arg);
            this._inRender = false;
        };
        const runRenderTaskQueue = map._renderTaskQueue.run;
        map._renderTaskQueue.run = (arg)=>{
            runRenderTaskQueue.call(map._renderTaskQueue, arg);
            this._onBeforeRepaint();
        };
        map.on("render", ()=>this._onAfterRepaint());
        // Insert code into map's event pipeline
        // eslint-disable-next-line @typescript-eslint/unbound-method
        const fireEvent = map.fire;
        map.fire = this._fireEvent.bind(this, fireEvent);
        // add listeners
        map.on("resize", ()=>{
            this._renderTransform.resize(map.transform.width, map.transform.height);
        });
        map.on("styledata", ()=>{
            this._updateStyleComponents(this.props, {});
            // Projection can be set in stylesheet
            (0, $36e35180a1a0c360$export$7bd220dfde473c56)(map.transform, this._renderTransform);
        });
        map.on("sourcedata", ()=>this._updateStyleComponents(this.props, {}));
        for(const eventName in $329a4d9bb02600da$var$pointerEvents)map.on(eventName, this._onPointerEvent);
        for(const eventName in $329a4d9bb02600da$var$cameraEvents)map.on(eventName, this._onCameraEvent);
        for(const eventName in $329a4d9bb02600da$var$otherEvents)map.on(eventName, this._onEvent);
        this._map = map;
    }
    /* eslint-enable complexity,max-statements */ recycle() {
        // Clean up unnecessary elements before storing for reuse.
        const container = this.map.getContainer();
        const children = container.querySelector("[mapboxgl-children]");
        children === null || children === void 0 || children.remove();
        $329a4d9bb02600da$export$2e2bcd8739ae039.savedMaps.push(this);
    }
    destroy() {
        this._map.remove();
    }
    // Force redraw the map now. Typically resize() and jumpTo() is reflected in the next
    // render cycle, which is managed by Mapbox's animation loop.
    // This removes the synchronization issue caused by requestAnimationFrame.
    redraw() {
        const map = this._map;
        // map._render will throw error if style does not exist
        // https://github.com/mapbox/mapbox-gl-js/blob/fb9fc316da14e99ff4368f3e4faa3888fb43c513
        //   /src/ui/map.js#L1834
        if (!this._inRender && map.style) {
            // cancel the scheduled update
            if (map._frame) {
                map._frame.cancel();
                map._frame = null;
            }
            // the order is important - render() may schedule another update
            map._render();
        }
    }
    _createShadowTransform(map) {
        const renderTransform = (0, $36e35180a1a0c360$export$dd516654c5f598fb)(map.transform);
        map.painter.transform = renderTransform;
        this._renderTransform = renderTransform;
    }
    /* Trigger map resize if size is controlled
       @param {object} nextProps
       @returns {bool} true if size has changed
     */ _updateSize(nextProps) {
        // Check if size is controlled
        const { viewState: viewState } = nextProps;
        if (viewState) {
            const map = this._map;
            if (viewState.width !== map.transform.width || viewState.height !== map.transform.height) {
                map.resize();
                return true;
            }
        }
        return false;
    }
    // Adapted from map.jumpTo
    /* Update camera to match props
       @param {object} nextProps
       @param {bool} triggerEvents - should fire camera events
       @returns {bool} true if anything is changed
     */ _updateViewState(nextProps, triggerEvents) {
        if (this._internalUpdate) return false;
        const map = this._map;
        const tr = this._renderTransform;
        // Take a snapshot of the transform before mutation
        const { zoom: zoom, pitch: pitch, bearing: bearing } = tr;
        const isMoving = map.isMoving();
        if (isMoving) // All movement of the camera is done relative to the sea level
        tr.cameraElevationReference = "sea";
        const changed = (0, $36e35180a1a0c360$export$5cf06eaeb862e3ce)(tr, {
            ...(0, $36e35180a1a0c360$export$6a605c5aa5bd97a8)(map.transform),
            ...nextProps
        });
        if (isMoving) // Reset camera reference
        tr.cameraElevationReference = "ground";
        if (changed && triggerEvents) {
            const deferredEvents = this._deferredEvents;
            // Delay DOM control updates to the next render cycle
            deferredEvents.move = true;
            deferredEvents.zoom || (deferredEvents.zoom = zoom !== tr.zoom);
            deferredEvents.rotate || (deferredEvents.rotate = bearing !== tr.bearing);
            deferredEvents.pitch || (deferredEvents.pitch = pitch !== tr.pitch);
        }
        // Avoid manipulating the real transform when interaction/animation is ongoing
        // as it would interfere with Mapbox's handlers
        if (!isMoving) (0, $36e35180a1a0c360$export$5cf06eaeb862e3ce)(map.transform, nextProps);
        return changed;
    }
    /* Update camera constraints and projection settings to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if anything is changed
     */ _updateSettings(nextProps, currProps) {
        const map = this._map;
        let changed = false;
        for (const propName of $329a4d9bb02600da$var$settingNames)if (propName in nextProps && !(0, $87aad2a444d91539$export$9cb4719e2e525b7a)(nextProps[propName], currProps[propName])) {
            changed = true;
            const setter = map[`set${propName[0].toUpperCase()}${propName.slice(1)}`];
            setter === null || setter === void 0 || setter.call(map, nextProps[propName]);
        }
        return changed;
    }
    /* Update map style to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if style is changed
     */ _updateStyle(nextProps, currProps) {
        if (nextProps.cursor !== currProps.cursor) this._map.getCanvas().style.cursor = nextProps.cursor || "";
        if (nextProps.mapStyle !== currProps.mapStyle) {
            const { mapStyle: mapStyle = $329a4d9bb02600da$var$DEFAULT_STYLE, styleDiffing: styleDiffing = true } = nextProps;
            const options = {
                diff: styleDiffing
            };
            if ("localIdeographFontFamily" in nextProps) // @ts-ignore Mapbox specific prop
            options.localIdeographFontFamily = nextProps.localIdeographFontFamily;
            this._map.setStyle((0, $67ed04f5529e50d6$export$8756898546458274)(mapStyle), options);
            return true;
        }
        return false;
    }
    /* Update fog, light and terrain to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if anything is changed
     */ _updateStyleComponents(nextProps, currProps) {
        const map = this._map;
        let changed = false;
        if (map.isStyleLoaded()) {
            if ("light" in nextProps && map.setLight && !(0, $87aad2a444d91539$export$9cb4719e2e525b7a)(nextProps.light, currProps.light)) {
                changed = true;
                map.setLight(nextProps.light);
            }
            if ("fog" in nextProps && map.setFog && !(0, $87aad2a444d91539$export$9cb4719e2e525b7a)(nextProps.fog, currProps.fog)) {
                changed = true;
                map.setFog(nextProps.fog);
            }
            if ("terrain" in nextProps && map.setTerrain && !(0, $87aad2a444d91539$export$9cb4719e2e525b7a)(nextProps.terrain, currProps.terrain)) {
                if (!nextProps.terrain || map.getSource(nextProps.terrain.source)) {
                    changed = true;
                    map.setTerrain(nextProps.terrain);
                }
            }
        }
        return changed;
    }
    /* Update interaction handlers to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if anything is changed
     */ _updateHandlers(nextProps, currProps) {
        var _a, _b;
        const map = this._map;
        let changed = false;
        for (const propName of $329a4d9bb02600da$var$handlerNames){
            const newValue = (_a = nextProps[propName]) !== null && _a !== void 0 ? _a : true;
            const oldValue = (_b = currProps[propName]) !== null && _b !== void 0 ? _b : true;
            if (!(0, $87aad2a444d91539$export$9cb4719e2e525b7a)(newValue, oldValue)) {
                changed = true;
                if (newValue) map[propName].enable(newValue);
                else map[propName].disable();
            }
        }
        return changed;
    }
    _queryRenderedFeatures(point) {
        const map = this._map;
        const tr = map.transform;
        const { interactiveLayerIds: interactiveLayerIds = [] } = this.props;
        try {
            map.transform = this._renderTransform;
            return map.queryRenderedFeatures(point, {
                layers: interactiveLayerIds.filter(map.getLayer.bind(map))
            });
        } catch (_a) {
            // May fail if style is not loaded
            return [];
        } finally{
            map.transform = tr;
        }
    }
    _updateHover(e) {
        var _a;
        const { props: props } = this;
        const shouldTrackHoveredFeatures = props.interactiveLayerIds && (props.onMouseMove || props.onMouseEnter || props.onMouseLeave);
        if (shouldTrackHoveredFeatures) {
            const eventType = e.type;
            const wasHovering = ((_a = this._hoveredFeatures) === null || _a === void 0 ? void 0 : _a.length) > 0;
            const features = this._queryRenderedFeatures(e.point);
            const isHovering = features.length > 0;
            if (!isHovering && wasHovering) {
                e.type = "mouseleave";
                this._onPointerEvent(e);
            }
            this._hoveredFeatures = features;
            if (isHovering && !wasHovering) {
                e.type = "mouseenter";
                this._onPointerEvent(e);
            }
            e.type = eventType;
        } else this._hoveredFeatures = null;
    }
    _fireEvent(baseFire, event, properties) {
        const map = this._map;
        const tr = map.transform;
        const eventType = typeof event === "string" ? event : event.type;
        if (eventType === "move") this._updateViewState(this.props, false);
        if (eventType in $329a4d9bb02600da$var$cameraEvents) {
            if (typeof event === "object") event.viewState = (0, $36e35180a1a0c360$export$6a605c5aa5bd97a8)(tr);
            if (this._map.isMoving()) {
                // Replace map.transform with ours during the callbacks
                map.transform = this._renderTransform;
                baseFire.call(map, event, properties);
                map.transform = tr;
                return map;
            }
        }
        baseFire.call(map, event, properties);
        return map;
    }
    // All camera manipulations are complete, ready to repaint
    _onBeforeRepaint() {
        const map = this._map;
        // If there are camera changes driven by props, invoke camera events so that DOM controls are synced
        this._internalUpdate = true;
        for(const eventType in this._deferredEvents)if (this._deferredEvents[eventType]) map.fire(eventType);
        this._internalUpdate = false;
        const tr = this._map.transform;
        // Make sure camera matches the current props
        map.transform = this._renderTransform;
        this._onAfterRepaint = ()=>{
            // Mapbox transitions between non-mercator projection and mercator during render time
            // Copy it back to the other
            (0, $36e35180a1a0c360$export$7bd220dfde473c56)(this._renderTransform, tr);
            // Restores camera state before render/load events are fired
            map.transform = tr;
        };
    }
}
$329a4d9bb02600da$export$2e2bcd8739ae039.savedMaps = [];
/**
 * Access token can be provided via one of:
 *   mapboxAccessToken prop
 *   access_token query parameter
 *   MapboxAccessToken environment variable
 *   REACT_APP_MAPBOX_ACCESS_TOKEN environment variable
 * @returns access token
 */ function $329a4d9bb02600da$var$getAccessTokenFromEnv() {
    let accessToken = null;
    /* global location, process */ if (typeof location !== "undefined") {
        const match = /access_token=([^&\/]*)/.exec(location.search);
        accessToken = match && match[1];
    }
    // Note: This depends on bundler plugins (e.g. webpack) importing environment correctly
    try {
        accessToken = accessToken || undefined;
    } catch (_a) {
    // ignore
    }
    try {
        accessToken = accessToken || undefined;
    } catch (_b) {
    // ignore
    }
    return accessToken;
}


/** These methods may break the react binding if called directly */ const $214202ad690e3e14$var$skipMethods = [
    "setMaxBounds",
    "setMinZoom",
    "setMaxZoom",
    "setMinPitch",
    "setMaxPitch",
    "setRenderWorldCopies",
    "setProjection",
    "setStyle",
    "addSource",
    "removeSource",
    "addLayer",
    "removeLayer",
    "setLayerZoomRange",
    "setFilter",
    "setPaintProperty",
    "setLayoutProperty",
    "setLight",
    "setTerrain",
    "setFog",
    "remove"
];
function $214202ad690e3e14$export$2e2bcd8739ae039(mapInstance) {
    if (!mapInstance) return null;
    const map = mapInstance.map;
    const result = {
        getMap: ()=>map,
        // Overwrite getters to use our shadow transform
        getCenter: ()=>mapInstance.transform.center,
        getZoom: ()=>mapInstance.transform.zoom,
        getBearing: ()=>mapInstance.transform.bearing,
        getPitch: ()=>mapInstance.transform.pitch,
        getPadding: ()=>mapInstance.transform.padding,
        getBounds: ()=>mapInstance.transform.getBounds(),
        project: (lnglat)=>{
            const tr = map.transform;
            map.transform = mapInstance.transform;
            const result = map.project(lnglat);
            map.transform = tr;
            return result;
        },
        unproject: (point)=>{
            const tr = map.transform;
            map.transform = mapInstance.transform;
            const result = map.unproject(point);
            map.transform = tr;
            return result;
        },
        // options diverge between mapbox and maplibre
        queryTerrainElevation: (lnglat, options)=>{
            const tr = map.transform;
            map.transform = mapInstance.transform;
            const result = map.queryTerrainElevation(lnglat, options);
            map.transform = tr;
            return result;
        },
        queryRenderedFeatures: (geometry, options)=>{
            const tr = map.transform;
            map.transform = mapInstance.transform;
            const result = map.queryRenderedFeatures(geometry, options);
            map.transform = tr;
            return result;
        }
    };
    for (const key of $214202ad690e3e14$var$getMethodNames(map))// @ts-expect-error
    if (!(key in result) && !$214202ad690e3e14$var$skipMethods.includes(key)) result[key] = map[key].bind(map);
    return result;
}
function $214202ad690e3e14$var$getMethodNames(obj) {
    const result = new Set();
    let proto = obj;
    while(proto){
        for (const key of Object.getOwnPropertyNames(proto))if (key[0] !== "_" && typeof obj[key] === "function" && key !== "fire" && key !== "setEventedParent") result.add(key);
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(result);
}


// From https://github.com/streamich/react-use/blob/master/src/useIsomorphicLayoutEffect.ts
// useLayoutEffect but does not trigger warning in server-side rendering

var $8v0nu = parcelRequire("8v0nu");
const $712c19a90c423e23$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? (0, $8v0nu.useLayoutEffect) : (0, $8v0nu.useEffect);
var $712c19a90c423e23$export$2e2bcd8739ae039 = $712c19a90c423e23$var$useIsomorphicLayoutEffect;


const $c7ac951aa5402f6e$var$globalSettings = [
    "baseApiUrl",
    "maxParallelImageRequests",
    "workerClass",
    "workerCount",
    "workerUrl"
];
function $c7ac951aa5402f6e$export$2e2bcd8739ae039(mapLib, props) {
    for (const key of $c7ac951aa5402f6e$var$globalSettings)if (key in props) mapLib[key] = props[key];
    const { RTLTextPlugin: RTLTextPlugin = "https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js" } = props;
    if (RTLTextPlugin && mapLib.getRTLTextPluginStatus && mapLib.getRTLTextPluginStatus() === "unavailable") mapLib.setRTLTextPlugin(RTLTextPlugin, (error)=>{
        if (error) // eslint-disable-next-line
        console.error(error);
    }, true);
}


const $b2f07233b90f3c17$export$dc7344301ae78f85 = $8v0nu.createContext(null);
function $b2f07233b90f3c17$export$2e2bcd8739ae039(props, ref, defaultLib) {
    const mountedMapsContext = (0, $8v0nu.useContext)((0, $5377e9d4a5edec71$export$c6c68f6e4db55944));
    const [mapInstance, setMapInstance] = (0, $8v0nu.useState)(null);
    const containerRef = (0, $8v0nu.useRef)();
    const { current: contextValue } = (0, $8v0nu.useRef)({
        mapLib: null,
        map: null
    });
    (0, $8v0nu.useEffect)(()=>{
        const mapLib = props.mapLib;
        let isMounted = true;
        let mapbox;
        Promise.resolve(mapLib || defaultLib).then((module)=>{
            if (!isMounted) return;
            if (!module) throw new Error("Invalid mapLib");
            const mapboxgl = "Map" in module ? module : module.default;
            if (!mapboxgl.Map) throw new Error("Invalid mapLib");
            // workerUrl & workerClass may change the result of supported()
            // https://github.com/visgl/react-map-gl/discussions/2027
            (0, $c7ac951aa5402f6e$export$2e2bcd8739ae039)(mapboxgl, props);
            if (!mapboxgl.supported || mapboxgl.supported(props)) {
                if (props.reuseMaps) mapbox = (0, $329a4d9bb02600da$export$2e2bcd8739ae039).reuse(props, containerRef.current);
                if (!mapbox) mapbox = new (0, $329a4d9bb02600da$export$2e2bcd8739ae039)(mapboxgl.Map, props, containerRef.current);
                contextValue.map = (0, $214202ad690e3e14$export$2e2bcd8739ae039)(mapbox);
                contextValue.mapLib = mapboxgl;
                setMapInstance(mapbox);
                mountedMapsContext === null || mountedMapsContext === void 0 || mountedMapsContext.onMapMount(contextValue.map, props.id);
            } else throw new Error("Map is not supported by this browser");
        }).catch((error)=>{
            const { onError: onError } = props;
            if (onError) onError({
                type: "error",
                target: null,
                originalEvent: null,
                error: error
            });
            else console.error(error); // eslint-disable-line
        });
        return ()=>{
            isMounted = false;
            if (mapbox) {
                mountedMapsContext === null || mountedMapsContext === void 0 || mountedMapsContext.onMapUnmount(props.id);
                if (props.reuseMaps) mapbox.recycle();
                else mapbox.destroy();
            }
        };
    }, []);
    (0, $712c19a90c423e23$export$2e2bcd8739ae039)(()=>{
        if (mapInstance) mapInstance.setProps(props);
    });
    (0, $8v0nu.useImperativeHandle)(ref, ()=>contextValue.map, [
        mapInstance
    ]);
    const style = (0, $8v0nu.useMemo)(()=>({
            position: "relative",
            width: "100%",
            height: "100%",
            ...props.style
        }), [
        props.style
    ]);
    const CHILD_CONTAINER_STYLE = {
        height: "100%"
    };
    return $8v0nu.createElement("div", {
        id: props.id,
        ref: containerRef,
        style: style
    }, mapInstance && $8v0nu.createElement($b2f07233b90f3c17$export$dc7344301ae78f85.Provider, {
        value: contextValue
    }, $8v0nu.createElement("div", {
        "mapboxgl-children": "",
        style: CHILD_CONTAINER_STYLE
    }, props.children)));
}


/* global document */ 
var $8v0nu = parcelRequire("8v0nu");

// This is a simplified version of
// https://github.com/facebook/react/blob/4131af3e4bf52f3a003537ec95a1655147c81270/src/renderers/dom/shared/CSSPropertyOperations.js#L62
const $f8cebf08ed85b99f$var$unitlessNumber = /box|flex|grid|column|lineHeight|fontWeight|opacity|order|tabSize|zIndex/;
function $f8cebf08ed85b99f$export$cd93e47e6d398387(element, styles) {
    if (!element || !styles) return;
    const style = element.style;
    for(const key in styles){
        const value = styles[key];
        if (Number.isFinite(value) && !$f8cebf08ed85b99f$var$unitlessNumber.test(key)) style[key] = `${value}px`;
        else style[key] = value;
    }
}




/* eslint-disable complexity,max-statements */ function $6a50da6bce3f3c4f$var$Marker(props, ref) {
    const { map: map, mapLib: mapLib } = (0, $8v0nu.useContext)((0, $b2f07233b90f3c17$export$dc7344301ae78f85));
    const thisRef = (0, $8v0nu.useRef)({
        props: props
    });
    thisRef.current.props = props;
    const marker = (0, $8v0nu.useMemo)(()=>{
        let hasChildren = false;
        $8v0nu.Children.forEach(props.children, (el)=>{
            if (el) hasChildren = true;
        });
        const options = {
            ...props,
            element: hasChildren ? document.createElement("div") : null
        };
        const mk = new mapLib.Marker(options);
        mk.setLngLat([
            props.longitude,
            props.latitude
        ]);
        mk.getElement().addEventListener("click", (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onClick) === null || _b === void 0 || _b.call(_a, {
                type: "click",
                target: mk,
                originalEvent: e
            });
        });
        mk.on("dragstart", (e)=>{
            var _a, _b;
            const evt = e;
            evt.lngLat = marker.getLngLat();
            (_b = (_a = thisRef.current.props).onDragStart) === null || _b === void 0 || _b.call(_a, evt);
        });
        mk.on("drag", (e)=>{
            var _a, _b;
            const evt = e;
            evt.lngLat = marker.getLngLat();
            (_b = (_a = thisRef.current.props).onDrag) === null || _b === void 0 || _b.call(_a, evt);
        });
        mk.on("dragend", (e)=>{
            var _a, _b;
            const evt = e;
            evt.lngLat = marker.getLngLat();
            (_b = (_a = thisRef.current.props).onDragEnd) === null || _b === void 0 || _b.call(_a, evt);
        });
        return mk;
    }, []);
    (0, $8v0nu.useEffect)(()=>{
        marker.addTo(map.getMap());
        return ()=>{
            marker.remove();
        };
    }, []);
    const { longitude: longitude, latitude: latitude, offset: offset, style: style, draggable: draggable = false, popup: popup = null, rotation: rotation = 0, rotationAlignment: rotationAlignment = "auto", pitchAlignment: pitchAlignment = "auto" } = props;
    (0, $8v0nu.useEffect)(()=>{
        (0, $f8cebf08ed85b99f$export$cd93e47e6d398387)(marker.getElement(), style);
    }, [
        style
    ]);
    (0, $8v0nu.useImperativeHandle)(ref, ()=>marker, []);
    if (marker.getLngLat().lng !== longitude || marker.getLngLat().lat !== latitude) marker.setLngLat([
        longitude,
        latitude
    ]);
    if (offset && !(0, $87aad2a444d91539$export$cb7477365ef68362)(marker.getOffset(), offset)) marker.setOffset(offset);
    if (marker.isDraggable() !== draggable) marker.setDraggable(draggable);
    if (marker.getRotation() !== rotation) marker.setRotation(rotation);
    if (marker.getRotationAlignment() !== rotationAlignment) marker.setRotationAlignment(rotationAlignment);
    if (marker.getPitchAlignment() !== pitchAlignment) marker.setPitchAlignment(pitchAlignment);
    if (marker.getPopup() !== popup) marker.setPopup(popup);
    return (0, $e95e39c2a873bfa2$exports.createPortal)(props.children, marker.getElement());
}
var $6a50da6bce3f3c4f$export$2e2bcd8739ae039 = (0, $8v0nu.memo)((0, $8v0nu.forwardRef)($6a50da6bce3f3c4f$var$Marker));




var $8v0nu = parcelRequire("8v0nu");



// Adapted from https://github.com/mapbox/mapbox-gl-js/blob/v1.13.0/src/ui/popup.js
function $00b6207a2230a531$var$getClassList(className) {
    return new Set(className ? className.trim().split(/\s+/) : []);
}
/* eslint-disable complexity,max-statements */ function $00b6207a2230a531$var$Popup(props, ref) {
    const { map: map, mapLib: mapLib } = (0, $8v0nu.useContext)((0, $b2f07233b90f3c17$export$dc7344301ae78f85));
    const container = (0, $8v0nu.useMemo)(()=>{
        return document.createElement("div");
    }, []);
    const thisRef = (0, $8v0nu.useRef)({
        props: props
    });
    thisRef.current.props = props;
    const popup = (0, $8v0nu.useMemo)(()=>{
        const options = {
            ...props
        };
        const pp = new mapLib.Popup(options);
        pp.setLngLat([
            props.longitude,
            props.latitude
        ]);
        pp.once("open", (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onOpen) === null || _b === void 0 || _b.call(_a, e);
        });
        return pp;
    }, []);
    (0, $8v0nu.useEffect)(()=>{
        const onClose = (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onClose) === null || _b === void 0 || _b.call(_a, e);
        };
        popup.on("close", onClose);
        popup.setDOMContent(container).addTo(map.getMap());
        return ()=>{
            // https://github.com/visgl/react-map-gl/issues/1825
            // onClose should not be fired if the popup is removed by unmounting
            // When using React strict mode, the component is mounted twice.
            // Firing the onClose callback here would be a false signal to remove the component.
            popup.off("close", onClose);
            if (popup.isOpen()) popup.remove();
        };
    }, []);
    (0, $8v0nu.useEffect)(()=>{
        (0, $f8cebf08ed85b99f$export$cd93e47e6d398387)(popup.getElement(), props.style);
    }, [
        props.style
    ]);
    (0, $8v0nu.useImperativeHandle)(ref, ()=>popup, []);
    if (popup.isOpen()) {
        if (popup.getLngLat().lng !== props.longitude || popup.getLngLat().lat !== props.latitude) popup.setLngLat([
            props.longitude,
            props.latitude
        ]);
        if (props.offset && !(0, $87aad2a444d91539$export$9cb4719e2e525b7a)(popup.options.offset, props.offset)) popup.setOffset(props.offset);
        if (popup.options.anchor !== props.anchor || popup.options.maxWidth !== props.maxWidth) {
            popup.options.anchor = props.anchor;
            popup.setMaxWidth(props.maxWidth);
        }
        if (popup.options.className !== props.className) {
            const prevClassList = $00b6207a2230a531$var$getClassList(popup.options.className);
            const nextClassList = $00b6207a2230a531$var$getClassList(props.className);
            for (const c of prevClassList)if (!nextClassList.has(c)) popup.removeClassName(c);
            for (const c of nextClassList)if (!prevClassList.has(c)) popup.addClassName(c);
            popup.options.className = props.className;
        }
    }
    return (0, $e95e39c2a873bfa2$exports.createPortal)(props.children, container);
}
var $00b6207a2230a531$export$2e2bcd8739ae039 = (0, $8v0nu.memo)((0, $8v0nu.forwardRef)($00b6207a2230a531$var$Popup));



var $8v0nu = parcelRequire("8v0nu");


var $8v0nu = parcelRequire("8v0nu");

function $292435df3b1ad9f2$var$useControl(onCreate, arg1, arg2, arg3) {
    const context = (0, $8v0nu.useContext)((0, $b2f07233b90f3c17$export$dc7344301ae78f85));
    const ctrl = (0, $8v0nu.useMemo)(()=>onCreate(context), []);
    (0, $8v0nu.useEffect)(()=>{
        const opts = arg3 || arg2 || arg1;
        const onAdd = typeof arg1 === "function" && typeof arg2 === "function" ? arg1 : null;
        const onRemove = typeof arg2 === "function" ? arg2 : typeof arg1 === "function" ? arg1 : null;
        const { map: map } = context;
        if (!map.hasControl(ctrl)) {
            map.addControl(ctrl, opts === null || opts === void 0 ? void 0 : opts.position);
            if (onAdd) onAdd(context);
        }
        return ()=>{
            if (onRemove) onRemove(context);
            // Map might have been removed (parent effects are destroyed before child ones)
            if (map.hasControl(ctrl)) map.removeControl(ctrl);
        };
    }, []);
    return ctrl;
}
var $292435df3b1ad9f2$export$2e2bcd8739ae039 = $292435df3b1ad9f2$var$useControl;


function $8069b126d2ec059e$var$AttributionControl(props) {
    const ctrl = (0, $292435df3b1ad9f2$export$2e2bcd8739ae039)(({ mapLib: mapLib })=>new mapLib.AttributionControl(props), {
        position: props.position
    });
    (0, $8v0nu.useEffect)(()=>{
        (0, $f8cebf08ed85b99f$export$cd93e47e6d398387)(ctrl._container, props.style);
    }, [
        props.style
    ]);
    return null;
}
var $8069b126d2ec059e$export$2e2bcd8739ae039 = (0, $8v0nu.memo)($8069b126d2ec059e$var$AttributionControl);



var $8v0nu = parcelRequire("8v0nu");


function $a7fb663833fbe2de$var$FullscreenControl(props) {
    const ctrl = (0, $292435df3b1ad9f2$export$2e2bcd8739ae039)(({ mapLib: mapLib })=>new mapLib.FullscreenControl({
            container: props.containerId && document.getElementById(props.containerId)
        }), {
        position: props.position
    });
    (0, $8v0nu.useEffect)(()=>{
        (0, $f8cebf08ed85b99f$export$cd93e47e6d398387)(ctrl._controlContainer, props.style);
    }, [
        props.style
    ]);
    return null;
}
var $a7fb663833fbe2de$export$2e2bcd8739ae039 = (0, $8v0nu.memo)($a7fb663833fbe2de$var$FullscreenControl);



var $8v0nu = parcelRequire("8v0nu");


function $51edc6221479b95c$var$GeolocateControl(props, ref) {
    const thisRef = (0, $8v0nu.useRef)({
        props: props
    });
    const ctrl = (0, $292435df3b1ad9f2$export$2e2bcd8739ae039)(({ mapLib: mapLib })=>{
        const gc = new mapLib.GeolocateControl(props);
        // Hack: fix GeolocateControl reuse
        // When using React strict mode, the component is mounted twice.
        // GeolocateControl's UI creation is asynchronous. Removing and adding it back causes the UI to be initialized twice.
        // @ts-expect-error private method
        const setupUI = gc._setupUI;
        // @ts-expect-error private method
        gc._setupUI = (args)=>{
            if (!gc._container.hasChildNodes()) setupUI(args);
        };
        gc.on("geolocate", (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onGeolocate) === null || _b === void 0 || _b.call(_a, e);
        });
        gc.on("error", (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onError) === null || _b === void 0 || _b.call(_a, e);
        });
        gc.on("outofmaxbounds", (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onOutOfMaxBounds) === null || _b === void 0 || _b.call(_a, e);
        });
        gc.on("trackuserlocationstart", (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onTrackUserLocationStart) === null || _b === void 0 || _b.call(_a, e);
        });
        gc.on("trackuserlocationend", (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onTrackUserLocationEnd) === null || _b === void 0 || _b.call(_a, e);
        });
        return gc;
    }, {
        position: props.position
    });
    thisRef.current.props = props;
    (0, $8v0nu.useImperativeHandle)(ref, ()=>ctrl, []);
    (0, $8v0nu.useEffect)(()=>{
        (0, $f8cebf08ed85b99f$export$cd93e47e6d398387)(ctrl._container, props.style);
    }, [
        props.style
    ]);
    return null;
}
var $51edc6221479b95c$export$2e2bcd8739ae039 = (0, $8v0nu.memo)((0, $8v0nu.forwardRef)($51edc6221479b95c$var$GeolocateControl));



var $8v0nu = parcelRequire("8v0nu");


function $2e5681d2a48fa66a$var$NavigationControl(props) {
    const ctrl = (0, $292435df3b1ad9f2$export$2e2bcd8739ae039)(({ mapLib: mapLib })=>new mapLib.NavigationControl(props), {
        position: props.position
    });
    (0, $8v0nu.useEffect)(()=>{
        (0, $f8cebf08ed85b99f$export$cd93e47e6d398387)(ctrl._container, props.style);
    }, [
        props.style
    ]);
    return null;
}
var $2e5681d2a48fa66a$export$2e2bcd8739ae039 = (0, $8v0nu.memo)($2e5681d2a48fa66a$var$NavigationControl);



var $8v0nu = parcelRequire("8v0nu");


function $0332b4ab49423833$var$ScaleControl(props) {
    const ctrl = (0, $292435df3b1ad9f2$export$2e2bcd8739ae039)(({ mapLib: mapLib })=>new mapLib.ScaleControl(props), {
        position: props.position
    });
    const propsRef = (0, $8v0nu.useRef)(props);
    const prevProps = propsRef.current;
    propsRef.current = props;
    const { style: style } = props;
    if (props.maxWidth !== undefined && props.maxWidth !== prevProps.maxWidth) ctrl.options.maxWidth = props.maxWidth;
    if (props.unit !== undefined && props.unit !== prevProps.unit) ctrl.setUnit(props.unit);
    (0, $8v0nu.useEffect)(()=>{
        (0, $f8cebf08ed85b99f$export$cd93e47e6d398387)(ctrl._container, style);
    }, [
        style
    ]);
    return null;
}
var $0332b4ab49423833$export$2e2bcd8739ae039 = (0, $8v0nu.memo)($0332b4ab49423833$var$ScaleControl);



var $8v0nu = parcelRequire("8v0nu");

function $9b69bdaabd4a0af4$export$2e2bcd8739ae039(condition, message) {
    if (!condition) throw new Error(message);
}



/* eslint-disable complexity, max-statements */ function $f48dc7a238e481e1$var$updateLayer(map, id, props, prevProps) {
    (0, $9b69bdaabd4a0af4$export$2e2bcd8739ae039)(props.id === prevProps.id, "layer id changed");
    (0, $9b69bdaabd4a0af4$export$2e2bcd8739ae039)(props.type === prevProps.type, "layer type changed");
    if (props.type === "custom" || prevProps.type === "custom") return;
    const { layout: layout = {}, paint: paint = {}, filter: filter, minzoom: minzoom, maxzoom: maxzoom, beforeId: beforeId } = props;
    if (beforeId !== prevProps.beforeId) map.moveLayer(id, beforeId);
    if (layout !== prevProps.layout) {
        const prevLayout = prevProps.layout || {};
        for(const key in layout)if (!(0, $87aad2a444d91539$export$9cb4719e2e525b7a)(layout[key], prevLayout[key])) map.setLayoutProperty(id, key, layout[key]);
        for(const key in prevLayout)if (!layout.hasOwnProperty(key)) map.setLayoutProperty(id, key, undefined);
    }
    if (paint !== prevProps.paint) {
        const prevPaint = prevProps.paint || {};
        for(const key in paint)if (!(0, $87aad2a444d91539$export$9cb4719e2e525b7a)(paint[key], prevPaint[key])) map.setPaintProperty(id, key, paint[key]);
        for(const key in prevPaint)if (!paint.hasOwnProperty(key)) map.setPaintProperty(id, key, undefined);
    }
    if (!(0, $87aad2a444d91539$export$9cb4719e2e525b7a)(filter, prevProps.filter)) map.setFilter(id, filter);
    if (minzoom !== prevProps.minzoom || maxzoom !== prevProps.maxzoom) map.setLayerZoomRange(id, minzoom, maxzoom);
}
function $f48dc7a238e481e1$var$createLayer(map, id, props) {
    // @ts-ignore
    if (map.style && map.style._loaded && (!("source" in props) || map.getSource(props.source))) {
        const options = {
            ...props,
            id: id
        };
        delete options.beforeId;
        // @ts-ignore
        map.addLayer(options, props.beforeId);
    }
}
/* eslint-enable complexity, max-statements */ let $f48dc7a238e481e1$var$layerCounter = 0;
function $f48dc7a238e481e1$var$Layer(props) {
    const map = (0, $8v0nu.useContext)((0, $b2f07233b90f3c17$export$dc7344301ae78f85)).map.getMap();
    const propsRef = (0, $8v0nu.useRef)(props);
    const [, setStyleLoaded] = (0, $8v0nu.useState)(0);
    const id = (0, $8v0nu.useMemo)(()=>props.id || `jsx-layer-${$f48dc7a238e481e1$var$layerCounter++}`, []);
    (0, $8v0nu.useEffect)(()=>{
        if (map) {
            const forceUpdate = ()=>setStyleLoaded((version)=>version + 1);
            map.on("styledata", forceUpdate);
            forceUpdate();
            return ()=>{
                map.off("styledata", forceUpdate);
                // @ts-ignore
                if (map.style && map.style._loaded && map.getLayer(id)) map.removeLayer(id);
            };
        }
        return undefined;
    }, [
        map
    ]);
    // @ts-ignore
    const layer = map && map.style && map.getLayer(id);
    if (layer) try {
        $f48dc7a238e481e1$var$updateLayer(map, id, props, propsRef.current);
    } catch (error) {
        console.warn(error); // eslint-disable-line
    }
    else $f48dc7a238e481e1$var$createLayer(map, id, props);
    // Store last rendered props
    propsRef.current = props;
    return null;
}
var $f48dc7a238e481e1$export$2e2bcd8739ae039 = $f48dc7a238e481e1$var$Layer;



var $8v0nu = parcelRequire("8v0nu");



let $3421ea1e93ab58a1$var$sourceCounter = 0;
function $3421ea1e93ab58a1$var$createSource(map, id, props) {
    // @ts-ignore
    if (map.style && map.style._loaded) {
        const options = {
            ...props
        };
        delete options.id;
        delete options.children;
        // @ts-ignore
        map.addSource(id, options);
        return map.getSource(id);
    }
    return null;
}
/* eslint-disable complexity */ function $3421ea1e93ab58a1$var$updateSource(source, props, prevProps) {
    (0, $9b69bdaabd4a0af4$export$2e2bcd8739ae039)(props.id === prevProps.id, "source id changed");
    (0, $9b69bdaabd4a0af4$export$2e2bcd8739ae039)(props.type === prevProps.type, "source type changed");
    let changedKey = "";
    let changedKeyCount = 0;
    for(const key in props)if (key !== "children" && key !== "id" && !(0, $87aad2a444d91539$export$9cb4719e2e525b7a)(prevProps[key], props[key])) {
        changedKey = key;
        changedKeyCount++;
    }
    if (!changedKeyCount) return;
    const type = props.type;
    if (type === "geojson") source.setData(props.data);
    else if (type === "image") source.updateImage({
        url: props.url,
        coordinates: props.coordinates
    });
    else if ("setCoordinates" in source && changedKeyCount === 1 && changedKey === "coordinates") source.setCoordinates(props.coordinates);
    else if ("setUrl" in source) // Added in 1.12.0:
    // vectorTileSource.setTiles
    // vectorTileSource.setUrl
    switch(changedKey){
        case "url":
            source.setUrl(props.url);
            break;
        case "tiles":
            source.setTiles(props.tiles);
            break;
        default:
    }
    else // eslint-disable-next-line
    console.warn(`Unable to update <Source> prop: ${changedKey}`);
}
/* eslint-enable complexity */ function $3421ea1e93ab58a1$var$Source(props) {
    const map = (0, $8v0nu.useContext)((0, $b2f07233b90f3c17$export$dc7344301ae78f85)).map.getMap();
    const propsRef = (0, $8v0nu.useRef)(props);
    const [, setStyleLoaded] = (0, $8v0nu.useState)(0);
    const id = (0, $8v0nu.useMemo)(()=>props.id || `jsx-source-${$3421ea1e93ab58a1$var$sourceCounter++}`, []);
    (0, $8v0nu.useEffect)(()=>{
        if (map) {
            /* global setTimeout */ const forceUpdate = ()=>setTimeout(()=>setStyleLoaded((version)=>version + 1), 0);
            map.on("styledata", forceUpdate);
            forceUpdate();
            return ()=>{
                var _a;
                map.off("styledata", forceUpdate);
                // @ts-ignore
                if (map.style && map.style._loaded && map.getSource(id)) {
                    // Parent effects are destroyed before child ones, see
                    // https://github.com/facebook/react/issues/16728
                    // Source can only be removed after all child layers are removed
                    const allLayers = (_a = map.getStyle()) === null || _a === void 0 ? void 0 : _a.layers;
                    if (allLayers) {
                        for (const layer of allLayers)// @ts-ignore (2339) source does not exist on all layer types
                        if (layer.source === id) map.removeLayer(layer.id);
                    }
                    map.removeSource(id);
                }
            };
        }
        return undefined;
    }, [
        map
    ]);
    // @ts-ignore
    let source = map && map.style && map.getSource(id);
    if (source) $3421ea1e93ab58a1$var$updateSource(source, props, propsRef.current);
    else source = $3421ea1e93ab58a1$var$createSource(map, id, props);
    propsRef.current = props;
    return source && $8v0nu.Children.map(props.children, (child)=>child && (0, $8v0nu.cloneElement)(child, {
            source: id
        })) || null;
}
var $3421ea1e93ab58a1$export$2e2bcd8739ae039 = $3421ea1e93ab58a1$var$Source;








function $5364b873ba521936$export$86f8f9f08863e403() {
    return (0, $5377e9d4a5edec71$export$86f8f9f08863e403)();
}

const $5364b873ba521936$var$mapLib = Promise.resolve((parcelRequire("31zZV")));
const $5364b873ba521936$export$a5c7b93649eaf8f8 = (()=>{
    return $8v0nu.forwardRef(function Map(props, ref) {
        return (0, $b2f07233b90f3c17$export$2e2bcd8739ae039)(props, ref, $5364b873ba521936$var$mapLib);
    });
})();
const $5364b873ba521936$export$e98856a975cab58e = (0, $6a50da6bce3f3c4f$export$2e2bcd8739ae039);
const $5364b873ba521936$export$129a32eedafa97c5 = (0, $00b6207a2230a531$export$2e2bcd8739ae039);
const $5364b873ba521936$export$5af5c3cc9905683 = (0, $8069b126d2ec059e$export$2e2bcd8739ae039);
const $5364b873ba521936$export$91e8ffb52c2b32c5 = (0, $a7fb663833fbe2de$export$2e2bcd8739ae039);
const $5364b873ba521936$export$49a437922edc1bd9 = (0, $2e5681d2a48fa66a$export$2e2bcd8739ae039);
const $5364b873ba521936$export$15e4ff48f7e9d8e0 = (0, $51edc6221479b95c$export$2e2bcd8739ae039);
const $5364b873ba521936$export$1fb16e435eedcce9 = (0, $0332b4ab49423833$export$2e2bcd8739ae039);
const $5364b873ba521936$export$936d0764594b6eb3 = (0, $f48dc7a238e481e1$export$2e2bcd8739ae039);
const $5364b873ba521936$export$1d2df86270c81ecb = (0, $3421ea1e93ab58a1$export$2e2bcd8739ae039);
var $5364b873ba521936$export$2e2bcd8739ae039 = $5364b873ba521936$export$a5c7b93649eaf8f8;


// index.ts
// index.js
// index.ts
var $32169f69e04c6230$export$e3a1ee0e9945697f = 63710088e-1;
var $32169f69e04c6230$export$f929e47acbed771a = {
    centimeters: $32169f69e04c6230$export$e3a1ee0e9945697f * 100,
    centimetres: $32169f69e04c6230$export$e3a1ee0e9945697f * 100,
    degrees: 360 / (2 * Math.PI),
    feet: $32169f69e04c6230$export$e3a1ee0e9945697f * 3.28084,
    inches: $32169f69e04c6230$export$e3a1ee0e9945697f * 39.37,
    kilometers: $32169f69e04c6230$export$e3a1ee0e9945697f / 1e3,
    kilometres: $32169f69e04c6230$export$e3a1ee0e9945697f / 1e3,
    meters: $32169f69e04c6230$export$e3a1ee0e9945697f,
    metres: $32169f69e04c6230$export$e3a1ee0e9945697f,
    miles: $32169f69e04c6230$export$e3a1ee0e9945697f / 1609.344,
    millimeters: $32169f69e04c6230$export$e3a1ee0e9945697f * 1e3,
    millimetres: $32169f69e04c6230$export$e3a1ee0e9945697f * 1e3,
    nauticalmiles: $32169f69e04c6230$export$e3a1ee0e9945697f / 1852,
    radians: 1,
    yards: $32169f69e04c6230$export$e3a1ee0e9945697f * 1.0936
};
var $32169f69e04c6230$export$44665ce4f7f4c82b = {
    acres: 247105e-9,
    centimeters: 1e4,
    centimetres: 1e4,
    feet: 10.763910417,
    hectares: 1e-4,
    inches: 1550.003100006,
    kilometers: 1e-6,
    kilometres: 1e-6,
    meters: 1,
    metres: 1,
    miles: 386e-9,
    nauticalmiles: 29155334959812285e-23,
    millimeters: 1e6,
    millimetres: 1e6,
    yards: 1.195990046
};
function $32169f69e04c6230$export$ced6ed16dfd6a264(geom, properties, options = {}) {
    const feat = {
        type: "Feature"
    };
    if (options.id === 0 || options.id) feat.id = options.id;
    if (options.bbox) feat.bbox = options.bbox;
    feat.properties = properties || {};
    feat.geometry = geom;
    return feat;
}
function $32169f69e04c6230$export$42a7622cbf932bb(type, coordinates, _options = {}) {
    switch(type){
        case "Point":
            return $32169f69e04c6230$export$105684a3041cb6f3(coordinates).geometry;
        case "LineString":
            return $32169f69e04c6230$export$98ec381bb06902c3(coordinates).geometry;
        case "Polygon":
            return $32169f69e04c6230$export$b7b19aa0ee06c73(coordinates).geometry;
        case "MultiPoint":
            return $32169f69e04c6230$export$335fc20ed6b6dbb6(coordinates).geometry;
        case "MultiLineString":
            return $32169f69e04c6230$export$bd735230309493da(coordinates).geometry;
        case "MultiPolygon":
            return $32169f69e04c6230$export$79bd594da96638d3(coordinates).geometry;
        default:
            throw new Error(type + " is invalid");
    }
}
function $32169f69e04c6230$export$105684a3041cb6f3(coordinates, properties, options = {}) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!$32169f69e04c6230$export$7e4aa119212bc614(coordinates[0]) || !$32169f69e04c6230$export$7e4aa119212bc614(coordinates[1])) throw new Error("coordinates must contain numbers");
    const geom = {
        type: "Point",
        coordinates: coordinates
    };
    return $32169f69e04c6230$export$ced6ed16dfd6a264(geom, properties, options);
}
function $32169f69e04c6230$export$9f048bf86ee2e9d2(coordinates, properties, options = {}) {
    return $32169f69e04c6230$export$4717c67ac3e5e04d(coordinates.map((coords)=>{
        return $32169f69e04c6230$export$105684a3041cb6f3(coords, properties);
    }), options);
}
function $32169f69e04c6230$export$b7b19aa0ee06c73(coordinates, properties, options = {}) {
    for (const ring of coordinates){
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        if (ring[ring.length - 1].length !== ring[0].length) throw new Error("First and last Position are not equivalent.");
        for(let j = 0; j < ring[ring.length - 1].length; j++){
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    const geom = {
        type: "Polygon",
        coordinates: coordinates
    };
    return $32169f69e04c6230$export$ced6ed16dfd6a264(geom, properties, options);
}
function $32169f69e04c6230$export$8869eb68a940f9c2(coordinates, properties, options = {}) {
    return $32169f69e04c6230$export$4717c67ac3e5e04d(coordinates.map((coords)=>{
        return $32169f69e04c6230$export$b7b19aa0ee06c73(coords, properties);
    }), options);
}
function $32169f69e04c6230$export$98ec381bb06902c3(coordinates, properties, options = {}) {
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    const geom = {
        type: "LineString",
        coordinates: coordinates
    };
    return $32169f69e04c6230$export$ced6ed16dfd6a264(geom, properties, options);
}
function $32169f69e04c6230$export$74f7306c35db993f(coordinates, properties, options = {}) {
    return $32169f69e04c6230$export$4717c67ac3e5e04d(coordinates.map((coords)=>{
        return $32169f69e04c6230$export$98ec381bb06902c3(coords, properties);
    }), options);
}
function $32169f69e04c6230$export$4717c67ac3e5e04d(features, options = {}) {
    const fc = {
        type: "FeatureCollection"
    };
    if (options.id) fc.id = options.id;
    if (options.bbox) fc.bbox = options.bbox;
    fc.features = features;
    return fc;
}
function $32169f69e04c6230$export$bd735230309493da(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiLineString",
        coordinates: coordinates
    };
    return $32169f69e04c6230$export$ced6ed16dfd6a264(geom, properties, options);
}
function $32169f69e04c6230$export$335fc20ed6b6dbb6(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiPoint",
        coordinates: coordinates
    };
    return $32169f69e04c6230$export$ced6ed16dfd6a264(geom, properties, options);
}
function $32169f69e04c6230$export$79bd594da96638d3(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiPolygon",
        coordinates: coordinates
    };
    return $32169f69e04c6230$export$ced6ed16dfd6a264(geom, properties, options);
}
function $32169f69e04c6230$export$9242f1e18250422a(geometries, properties, options = {}) {
    const geom = {
        type: "GeometryCollection",
        geometries: geometries
    };
    return $32169f69e04c6230$export$ced6ed16dfd6a264(geom, properties, options);
}
function $32169f69e04c6230$export$2077e0241d6afd3c(num, precision = 0) {
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    const multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
function $32169f69e04c6230$export$f234631d6a2eedf8(radians, units = "kilometers") {
    const factor = $32169f69e04c6230$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
function $32169f69e04c6230$export$a2280f7debae8f10(distance, units = "kilometers") {
    const factor = $32169f69e04c6230$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
function $32169f69e04c6230$export$c7a138e00a89bd01(distance, units) {
    return $32169f69e04c6230$export$c41dd2a8460d3196($32169f69e04c6230$export$a2280f7debae8f10(distance, units));
}
function $32169f69e04c6230$export$f2077d29c73b33ec(bearing) {
    let angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
function $32169f69e04c6230$export$b4c4eb04cfe49fab(angle) {
    angle = angle % 360;
    if (angle > 0) return angle > 180 ? angle - 360 : angle;
    return angle < -180 ? angle + 360 : angle;
}
function $32169f69e04c6230$export$c41dd2a8460d3196(radians) {
    const degrees = radians % (2 * Math.PI);
    return degrees * 180 / Math.PI;
}
function $32169f69e04c6230$export$c9fcf1a7df975d78(degrees) {
    const radians = degrees % 360;
    return radians * Math.PI / 180;
}
function $32169f69e04c6230$export$ea1536a749e80563(length, originalUnit = "kilometers", finalUnit = "kilometers") {
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return $32169f69e04c6230$export$f234631d6a2eedf8($32169f69e04c6230$export$a2280f7debae8f10(length, originalUnit), finalUnit);
}
function $32169f69e04c6230$export$2e65e2c759f7e341(area, originalUnit = "meters", finalUnit = "kilometers") {
    if (!(area >= 0)) throw new Error("area must be a positive number");
    const startFactor = $32169f69e04c6230$export$44665ce4f7f4c82b[originalUnit];
    if (!startFactor) throw new Error("invalid original units");
    const finalFactor = $32169f69e04c6230$export$44665ce4f7f4c82b[finalUnit];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
function $32169f69e04c6230$export$7e4aa119212bc614(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
function $32169f69e04c6230$export$a6cdc56e425d0d0a(input) {
    return input !== null && typeof input === "object" && !Array.isArray(input);
}
function $32169f69e04c6230$export$28ac7bb8f5309bea(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach((num)=>{
        if (!$32169f69e04c6230$export$7e4aa119212bc614(num)) throw new Error("bbox must only contain numbers");
    });
}
function $32169f69e04c6230$export$f35f128fd59ea256(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}


function $e8099e45e96a17c6$export$6e011439fde007ae(geojson, callback, excludeWrapCoord) {
    if (geojson === null) return;
    var j, k, l, geometry, stopG, coords, geometryMaybeCollection, wrapShrink = 0, coordIndex = 0, isGeometryCollection, type = geojson.type, isFeatureCollection = type === "FeatureCollection", isFeature = type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    for(var featureIndex = 0; featureIndex < stop; featureIndex++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[featureIndex].geometry : isFeature ? geojson.geometry : geojson;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(var geomIndex = 0; geomIndex < stopG; geomIndex++){
            var multiFeatureIndex = 0;
            var geometryIndex = 0;
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
            if (geometry === null) continue;
            coords = geometry.coordinates;
            var geomType = geometry.type;
            wrapShrink = excludeWrapCoord && (geomType === "Polygon" || geomType === "MultiPolygon") ? 1 : 0;
            switch(geomType){
                case null:
                    break;
                case "Point":
                    if (callback(coords, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                    coordIndex++;
                    multiFeatureIndex++;
                    break;
                case "LineString":
                case "MultiPoint":
                    for(j = 0; j < coords.length; j++){
                        if (callback(coords[j], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                        coordIndex++;
                        if (geomType === "MultiPoint") multiFeatureIndex++;
                    }
                    if (geomType === "LineString") multiFeatureIndex++;
                    break;
                case "Polygon":
                case "MultiLineString":
                    for(j = 0; j < coords.length; j++){
                        for(k = 0; k < coords[j].length - wrapShrink; k++){
                            if (callback(coords[j][k], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                            coordIndex++;
                        }
                        if (geomType === "MultiLineString") multiFeatureIndex++;
                        if (geomType === "Polygon") geometryIndex++;
                    }
                    if (geomType === "Polygon") multiFeatureIndex++;
                    break;
                case "MultiPolygon":
                    for(j = 0; j < coords.length; j++){
                        geometryIndex = 0;
                        for(k = 0; k < coords[j].length; k++){
                            for(l = 0; l < coords[j][k].length - wrapShrink; l++){
                                if (callback(coords[j][k][l], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                                coordIndex++;
                            }
                            geometryIndex++;
                        }
                        multiFeatureIndex++;
                    }
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++)if ($e8099e45e96a17c6$export$6e011439fde007ae(geometry.geometries[j], callback, excludeWrapCoord) === false) return false;
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
    }
}
function $e8099e45e96a17c6$export$6f96eac39184ffe9(geojson, callback, initialValue, excludeWrapCoord) {
    var previousValue = initialValue;
    $e8099e45e96a17c6$export$6e011439fde007ae(geojson, function(currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
        if (coordIndex === 0 && initialValue === void 0) previousValue = currentCoord;
        else previousValue = callback(previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex);
    }, excludeWrapCoord);
    return previousValue;
}
function $e8099e45e96a17c6$export$9d63c695566dbaa3(geojson, callback) {
    var i;
    switch(geojson.type){
        case "FeatureCollection":
            for(i = 0; i < geojson.features.length; i++){
                if (callback(geojson.features[i].properties, i) === false) break;
            }
            break;
        case "Feature":
            callback(geojson.properties, 0);
            break;
    }
}
function $e8099e45e96a17c6$export$7ff6f75e5ef85a65(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $e8099e45e96a17c6$export$9d63c695566dbaa3(geojson, function(currentProperties, featureIndex) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentProperties;
        else previousValue = callback(previousValue, currentProperties, featureIndex);
    });
    return previousValue;
}
function $e8099e45e96a17c6$export$45a31c4de8035258(geojson, callback) {
    if (geojson.type === "Feature") callback(geojson, 0);
    else if (geojson.type === "FeatureCollection") for(var i = 0; i < geojson.features.length; i++){
        if (callback(geojson.features[i], i) === false) break;
    }
}
function $e8099e45e96a17c6$export$b18fee751b10b055(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $e8099e45e96a17c6$export$45a31c4de8035258(geojson, function(currentFeature, featureIndex) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex);
    });
    return previousValue;
}
function $e8099e45e96a17c6$export$5485820fc560fe4e(geojson) {
    var coords = [];
    $e8099e45e96a17c6$export$6e011439fde007ae(geojson, function(coord) {
        coords.push(coord);
    });
    return coords;
}
function $e8099e45e96a17c6$export$d2d248a56672ab3d(geojson, callback) {
    var i, j, g, geometry, stopG, geometryMaybeCollection, isGeometryCollection, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    for(i = 0; i < stop; i++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[i].geometry : isFeature ? geojson.geometry : geojson;
        featureProperties = isFeatureCollection ? geojson.features[i].properties : isFeature ? geojson.properties : {};
        featureBBox = isFeatureCollection ? geojson.features[i].bbox : isFeature ? geojson.bbox : void 0;
        featureId = isFeatureCollection ? geojson.features[i].id : isFeature ? geojson.id : void 0;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(g = 0; g < stopG; g++){
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
            if (geometry === null) {
                if (callback(null, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                continue;
            }
            switch(geometry.type){
                case "Point":
                case "LineString":
                case "MultiPoint":
                case "Polygon":
                case "MultiLineString":
                case "MultiPolygon":
                    if (callback(geometry, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++){
                        if (callback(geometry.geometries[j], featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    }
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
        featureIndex++;
    }
}
function $e8099e45e96a17c6$export$30055ae7bd157809(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $e8099e45e96a17c6$export$d2d248a56672ab3d(geojson, function(currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentGeometry;
        else previousValue = callback(previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId);
    });
    return previousValue;
}
function $e8099e45e96a17c6$export$12cba8b31beb353b(geojson, callback) {
    $e8099e45e96a17c6$export$d2d248a56672ab3d(geojson, function(geometry, featureIndex, properties, bbox, id) {
        var type = geometry === null ? null : geometry.type;
        switch(type){
            case null:
            case "Point":
            case "LineString":
            case "Polygon":
                if (callback((0, $32169f69e04c6230$export$ced6ed16dfd6a264)(geometry, properties, {
                    bbox: bbox,
                    id: id
                }), featureIndex, 0) === false) return false;
                return;
        }
        var geomType;
        switch(type){
            case "MultiPoint":
                geomType = "Point";
                break;
            case "MultiLineString":
                geomType = "LineString";
                break;
            case "MultiPolygon":
                geomType = "Polygon";
                break;
        }
        for(var multiFeatureIndex = 0; multiFeatureIndex < geometry.coordinates.length; multiFeatureIndex++){
            var coordinate = geometry.coordinates[multiFeatureIndex];
            var geom = {
                type: geomType,
                coordinates: coordinate
            };
            if (callback((0, $32169f69e04c6230$export$ced6ed16dfd6a264)(geom, properties), featureIndex, multiFeatureIndex) === false) return false;
        }
    });
}
function $e8099e45e96a17c6$export$af6f15fec62b5d18(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $e8099e45e96a17c6$export$12cba8b31beb353b(geojson, function(currentFeature, featureIndex, multiFeatureIndex) {
        if (featureIndex === 0 && multiFeatureIndex === 0 && initialValue === void 0) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex, multiFeatureIndex);
    });
    return previousValue;
}
function $e8099e45e96a17c6$export$d3ecc1efb2be121e(geojson, callback) {
    $e8099e45e96a17c6$export$12cba8b31beb353b(geojson, function(feature2, featureIndex, multiFeatureIndex) {
        var segmentIndex = 0;
        if (!feature2.geometry) return;
        var type = feature2.geometry.type;
        if (type === "Point" || type === "MultiPoint") return;
        var previousCoords;
        var previousFeatureIndex = 0;
        var previousMultiIndex = 0;
        var prevGeomIndex = 0;
        if ($e8099e45e96a17c6$export$6e011439fde007ae(feature2, function(currentCoord, coordIndex, featureIndexCoord, multiPartIndexCoord, geometryIndex) {
            if (previousCoords === void 0 || featureIndex > previousFeatureIndex || multiPartIndexCoord > previousMultiIndex || geometryIndex > prevGeomIndex) {
                previousCoords = currentCoord;
                previousFeatureIndex = featureIndex;
                previousMultiIndex = multiPartIndexCoord;
                prevGeomIndex = geometryIndex;
                segmentIndex = 0;
                return;
            }
            var currentSegment = (0, $32169f69e04c6230$export$98ec381bb06902c3)([
                previousCoords,
                currentCoord
            ], feature2.properties);
            if (callback(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) === false) return false;
            segmentIndex++;
            previousCoords = currentCoord;
        }) === false) return false;
    });
}
function $e8099e45e96a17c6$export$eec78cdd4d343a79(geojson, callback, initialValue) {
    var previousValue = initialValue;
    var started = false;
    $e8099e45e96a17c6$export$d3ecc1efb2be121e(geojson, function(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
        if (started === false && initialValue === void 0) previousValue = currentSegment;
        else previousValue = callback(previousValue, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex);
        started = true;
    });
    return previousValue;
}
function $e8099e45e96a17c6$export$985a91771cfc783d(geojson, callback) {
    if (!geojson) throw new Error("geojson is required");
    $e8099e45e96a17c6$export$12cba8b31beb353b(geojson, function(feature2, featureIndex, multiFeatureIndex) {
        if (feature2.geometry === null) return;
        var type = feature2.geometry.type;
        var coords = feature2.geometry.coordinates;
        switch(type){
            case "LineString":
                if (callback(feature2, featureIndex, multiFeatureIndex, 0, 0) === false) return false;
                break;
            case "Polygon":
                for(var geometryIndex = 0; geometryIndex < coords.length; geometryIndex++){
                    if (callback((0, $32169f69e04c6230$export$98ec381bb06902c3)(coords[geometryIndex], feature2.properties), featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                }
                break;
        }
    });
}
function $e8099e45e96a17c6$export$a150e51c8ec9198a(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $e8099e45e96a17c6$export$985a91771cfc783d(geojson, function(currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentLine;
        else previousValue = callback(previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex);
    });
    return previousValue;
}
function $e8099e45e96a17c6$export$2b6ba91fd8680d67(geojson, options) {
    options = options || {};
    if (!(0, $32169f69e04c6230$export$a6cdc56e425d0d0a)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var segmentIndex = options.segmentIndex || 0;
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
            if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
            return (0, $32169f69e04c6230$export$98ec381bb06902c3)([
                coords[segmentIndex],
                coords[segmentIndex + 1]
            ], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
            return (0, $32169f69e04c6230$export$98ec381bb06902c3)([
                coords[geometryIndex][segmentIndex],
                coords[geometryIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
            return (0, $32169f69e04c6230$export$98ec381bb06902c3)([
                coords[multiFeatureIndex][segmentIndex],
                coords[multiFeatureIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
            return (0, $32169f69e04c6230$export$98ec381bb06902c3)([
                coords[multiFeatureIndex][geometryIndex][segmentIndex],
                coords[multiFeatureIndex][geometryIndex][segmentIndex + 1]
            ], properties, options);
    }
    throw new Error("geojson is invalid");
}
function $e8099e45e96a17c6$export$ed60ae5df1bac687(geojson, options) {
    options = options || {};
    if (!(0, $32169f69e04c6230$export$a6cdc56e425d0d0a)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var coordIndex = options.coordIndex || 0;
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
            return (0, $32169f69e04c6230$export$105684a3041cb6f3)(coords, properties, options);
        case "MultiPoint":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            return (0, $32169f69e04c6230$export$105684a3041cb6f3)(coords[multiFeatureIndex], properties, options);
        case "LineString":
            if (coordIndex < 0) coordIndex = coords.length + coordIndex;
            return (0, $32169f69e04c6230$export$105684a3041cb6f3)(coords[coordIndex], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[geometryIndex].length + coordIndex;
            return (0, $32169f69e04c6230$export$105684a3041cb6f3)(coords[geometryIndex][coordIndex], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex].length + coordIndex;
            return (0, $32169f69e04c6230$export$105684a3041cb6f3)(coords[multiFeatureIndex][coordIndex], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex][geometryIndex].length - coordIndex;
            return (0, $32169f69e04c6230$export$105684a3041cb6f3)(coords[multiFeatureIndex][geometryIndex][coordIndex], properties, options);
    }
    throw new Error("geojson is invalid");
}


function $a4850b24012d1fae$export$bf67010aacbe66fa(geojson, options = {}) {
    if (geojson.bbox != null && true !== options.recompute) return geojson.bbox;
    const result = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    (0, $e8099e45e96a17c6$export$6e011439fde007ae)(geojson, (coord)=>{
        if (result[0] > coord[0]) result[0] = coord[0];
        if (result[1] > coord[1]) result[1] = coord[1];
        if (result[2] < coord[0]) result[2] = coord[0];
        if (result[3] < coord[1]) result[3] = coord[1];
    });
    return result;
}
var $a4850b24012d1fae$export$2e2bcd8739ae039 = $a4850b24012d1fae$export$bf67010aacbe66fa;



var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");

function $3cdef1182cb7804b$var$BackgroundTiles() {
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $5364b873ba521936$export$1d2df86270c81ecb), {
        id: "background",
        type: "raster",
        tiles: [
            "https://tile.openstreetmap.org/{z}/{x}/{y}.png"
        ],
        tileSize: 256,
        attribution: "Background tiles: \xa9 <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap contributors</a>",
        children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $5364b873ba521936$export$936d0764594b6eb3), {
            id: "background-tiles",
            type: "raster"
        })
    });
}
var $3cdef1182cb7804b$export$2e2bcd8739ae039 = $3cdef1182cb7804b$var$BackgroundTiles;




const $854c342785fecb8e$var$resultsOutline = {
    "line-color": "#C53030",
    "line-width": 2
};
const $854c342785fecb8e$var$resultsFill = {
    "fill-color": "#C53030",
    "fill-opacity": 0.1
};
const $854c342785fecb8e$var$cogMediaTypes = [
    "image/tiff; application=geotiff; profile=cloud-optimized",
    "image/vnd.stac.geotiff"
];
function $854c342785fecb8e$export$a9105c4033140ee1(props) {
    const { item: item, ...rest } = props;
    const [map, setMap] = (0, $8v0nu.useState)();
    const setMapRef = (m)=>setMap(m);
    // Fit the map view around the current results bbox
    (0, $8v0nu.useEffect)(()=>{
        const bounds = item && (0, $a4850b24012d1fae$export$2e2bcd8739ae039)(item);
        if (map && bounds) {
            const [x1, y1, x2, y2] = bounds;
            map.fitBounds([
                x1,
                y1,
                x2,
                y2
            ], {
                padding: 30,
                duration: 0
            });
        }
    }, [
        item,
        map
    ]);
    const previewAsset = (0, $8v0nu.useMemo)(()=>{
        if (!item) return;
        return Object.values(item.assets).reduce((preview, asset)=>{
            const { type: type, href: href, roles: roles } = asset;
            if ($854c342785fecb8e$var$cogMediaTypes.includes(type || "")) {
                if (!preview) return href;
                else {
                    if (roles && roles.includes("visual")) return href;
                }
            }
            return preview;
        }, undefined);
    }, [
        item
    ]);
    return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $5364b873ba521936$export$2e2bcd8739ae039), {
        ref: setMapRef,
        ...rest,
        children: [
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3cdef1182cb7804b$export$2e2bcd8739ae039), {}),
            previewAsset && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $5364b873ba521936$export$1d2df86270c81ecb), {
                id: "preview",
                type: "raster",
                tiles: [
                    `http://tiles.rdnt.io/tiles/{z}/{x}/{y}@2x?url=${previewAsset}`
                ],
                tileSize: 256,
                attribution: "Background tiles: \xa9 <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap contributors</a>",
                children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $5364b873ba521936$export$936d0764594b6eb3), {
                    id: "preview-tiles",
                    type: "raster"
                })
            }),
            /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $5364b873ba521936$export$1d2df86270c81ecb), {
                id: "results",
                type: "geojson",
                data: item,
                children: [
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $5364b873ba521936$export$936d0764594b6eb3), {
                        id: "results-line",
                        type: "line",
                        paint: $854c342785fecb8e$var$resultsOutline
                    }),
                    !previewAsset && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $5364b873ba521936$export$936d0764594b6eb3), {
                        id: "results-fill",
                        type: "fill",
                        paint: $854c342785fecb8e$var$resultsFill
                    })
                ]
            })
        ]
    });
}


const $943c638232d86618$var$dateFormat = {
    year: "numeric",
    month: "long",
    day: "numeric"
};
function $943c638232d86618$var$ItemDetail() {
    const { collectionId: collectionId, itemId: itemId } = (0, $aa6b6e9e15323f83$export$99eaa27ddbbb95ef)();
    (0, $aec39e40387762bd$export$2e2bcd8739ae039)(`Item ${itemId}`);
    const itemResource = `${(0, $e60c4cd554136647$export$b919fd560f065399)}/collections/${collectionId}/items/${itemId}`;
    const { item: item, state: state } = (0, $eba44fb2c963ffed$export$9842ce616dcc8723)(itemResource);
    if (!item || state === "LOADING") return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $9HGsN.Box), {
        p: 8,
        children: [
            /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                direction: "column",
                gap: 4,
                children: [
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $408225e060551a18$export$8f31e4c4a37b8e9c), {
                        h: 6,
                        maxW: "25rem"
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $408225e060551a18$export$8f31e4c4a37b8e9c), {
                        h: 12,
                        maxW: "30rem"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $2fb4f0d945397efb$export$cb6ddd830302c2a8), {
                mt: 8,
                noOfLines: 4,
                spacing: "4",
                skeletonHeight: "2",
                maxW: "50rem"
            })
        ]
    });
    const { title: title, description: description, ...properties } = item.properties;
    return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
        direction: "column",
        gap: 8,
        children: [
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $dfd76aae8c4830bc$export$644c29b44a905178), {
                overline: "Viewing Item",
                title: title || item.id,
                actions: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $kxTYF.Fragment), {
                    children: /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $bbc1594d228c6000$export$d9b273488cd8ce6f), {
                        placement: "bottom-end",
                        children: [
                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $5277a93d60858aae$export$266a769812832828), {
                                as: (0, $5f067ccb39c91cbc$export$c25acd513dcc8062),
                                "aria-label": "Options",
                                icon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$b307b75901e71920), {}),
                                variant: "outline",
                                size: "md"
                            }),
                            /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $caedd5fbd169c955$export$d4c4e98c5044dc8), {
                                children: [
                                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9fe47dbb44516a54$export$2b6a1f5f68a01133), {
                                        resourcePath: `/collections/${item.collection}/items/${item.id}`
                                    }),
                                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $293887a95e6a8bc4$export$2ce376c2cc3355c8), {
                                        icon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$5918e8962b6636e9), {}),
                                        color: "danger.500",
                                        _hover: {
                                            bg: "danger.200"
                                        },
                                        _focus: {
                                            bg: "danger.200"
                                        },
                                        onClick: ()=>alert("Soon!"),
                                        children: "Delete"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                direction: "column",
                gap: "8",
                as: "section",
                children: [
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                        direction: "row",
                        px: "8",
                        gap: "8",
                        as: "header",
                        children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9HGsN.Box), {
                            flexBasis: "100%",
                            children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8651ef577e25eea6$export$a8a3e93435678ff9), {
                                size: "md",
                                as: "h2",
                                children: "Overview"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $da89f256d660f801$export$ef2184bd89960b14), {
                        templateColumns: "repeat(12, 1fr)",
                        gap: 8,
                        children: [
                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $d3de29280e541829$export$9eb849b9b922d396), {
                                colSpan: 8,
                                children: /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                                    bg: "base.50",
                                    borderRadius: "md",
                                    p: 8,
                                    direction: "column",
                                    gap: 4,
                                    minH: "100%",
                                    children: [
                                        /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                                            direction: "column",
                                            gap: "2",
                                            children: [
                                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8651ef577e25eea6$export$a8a3e93435678ff9), {
                                                    size: "sm",
                                                    as: "h3",
                                                    children: "Collection"
                                                }),
                                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3963bf82c5559c75$export$5f1af8db9871e1d6), {
                                                    size: "md",
                                                    children: item.collection
                                                })
                                            ]
                                        }),
                                        description && /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                                            direction: "column",
                                            gap: "2",
                                            children: [
                                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8651ef577e25eea6$export$a8a3e93435678ff9), {
                                                    size: "sm",
                                                    as: "h3",
                                                    children: "Description"
                                                }),
                                                /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $3963bf82c5559c75$export$5f1af8db9871e1d6), {
                                                    size: "md",
                                                    children: [
                                                        description,
                                                        " "
                                                    ]
                                                })
                                            ]
                                        }),
                                        properties.datetime && /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                                            direction: "column",
                                            gap: "2",
                                            children: [
                                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8651ef577e25eea6$export$a8a3e93435678ff9), {
                                                    size: "sm",
                                                    as: "h3",
                                                    children: "Date"
                                                }),
                                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3963bf82c5559c75$export$5f1af8db9871e1d6), {
                                                    size: "md",
                                                    children: new Date(properties.datetime).toLocaleString("en-GB", $943c638232d86618$var$dateFormat)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $d3de29280e541829$export$9eb849b9b922d396), {
                                colSpan: 4,
                                children: /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                                    bg: "base.50",
                                    borderRadius: "md",
                                    p: 8,
                                    direction: "column",
                                    gap: 2,
                                    position: "relative",
                                    overflow: "hidden",
                                    height: "20rem",
                                    children: [
                                        /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8651ef577e25eea6$export$a8a3e93435678ff9), {
                                            size: "sm",
                                            as: "h3",
                                            children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3380028199317e44$export$439d29a4e110a164), {
                                                children: "Spacial extent"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9HGsN.Box), {
                                            position: "absolute",
                                            inset: "0",
                                            children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $854c342785fecb8e$export$a9105c4033140ee1), {
                                                item: item
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $12023aea359e11c1$export$2e2bcd8739ae039), {
                assets: item.assets
            })
        ]
    });
}
var $943c638232d86618$export$2e2bcd8739ae039 = $943c638232d86618$var$ItemDetail;



var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");




function $8027973e38821351$var$NotFound() {
    (0, $aec39e40387762bd$export$2e2bcd8739ae039)("Not found");
    return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
        direction: "column",
        gap: 4,
        children: [
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $dfd76aae8c4830bc$export$644c29b44a905178), {
                title: "Not Found",
                overline: "Error 404"
            }),
            /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                direction: "column",
                gap: 2,
                p: 4,
                children: [
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3963bf82c5559c75$export$5f1af8db9871e1d6), {
                        children: "The resource you're looking for could not be found."
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $3963bf82c5559c75$export$5f1af8db9871e1d6), {
                        children: [
                            "Perhaps in the mean time you can check out the",
                            " ",
                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $78d29a24c660df8a$export$2e2bcd8739ae039), {
                                to: "/collections",
                                children: "collections"
                            }),
                            " page."
                        ]
                    })
                ]
            })
        ]
    });
}
var $8027973e38821351$export$2e2bcd8739ae039 = $8027973e38821351$var$NotFound;



var $kxTYF = parcelRequire("kxTYF");

var $8v0nu = parcelRequire("8v0nu");


var $9HGsN = parcelRequire("9HGsN");
var $kxTYF = parcelRequire("kxTYF");


var $cSr1Y = parcelRequire("cSr1Y");

"use client";
const [$6ba3cfa4898a6b5d$export$bf694c7c431c162a, $6ba3cfa4898a6b5d$export$1468d0761b26e6c8] = (0, $3473b2b1e3b906ba$export$fd42f52fd3ae1109)({
    name: "PopoverContext",
    errorMessage: "usePopoverContext: `context` is undefined. Seems you forgot to wrap all popover components within `<Popover />`"
});
const [$6ba3cfa4898a6b5d$export$286407fa0c94e3f1, $6ba3cfa4898a6b5d$export$bdabad59d033c81a] = (0, $3473b2b1e3b906ba$export$fd42f52fd3ae1109)({
    name: `PopoverStylesContext`,
    errorMessage: `usePopoverStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Popover />" `
});



"use client";
function $54f5ca07bbdcb7af$var$isRefObject(val) {
    return "current" in val;
}
const $54f5ca07bbdcb7af$var$isDom = ()=>typeof window !== "undefined";
function $54f5ca07bbdcb7af$var$getPlatform() {
    const agent = navigator.userAgentData;
    return agent?.platform ?? navigator.platform;
}
const $54f5ca07bbdcb7af$var$vn = (v)=>$54f5ca07bbdcb7af$var$isDom() && v.test(navigator.vendor);
const $54f5ca07bbdcb7af$var$pt = (v)=>$54f5ca07bbdcb7af$var$isDom() && v.test($54f5ca07bbdcb7af$var$getPlatform());
const $54f5ca07bbdcb7af$var$isApple = ()=>$54f5ca07bbdcb7af$var$pt(/mac|iphone|ipad|ipod/i);
const $54f5ca07bbdcb7af$var$isSafari = ()=>$54f5ca07bbdcb7af$var$isApple() && $54f5ca07bbdcb7af$var$vn(/apple/i);
function $54f5ca07bbdcb7af$export$16a61b931588d888(props) {
    const { ref: ref, elements: elements, enabled: enabled } = props;
    const doc = ()=>ref.current?.ownerDocument ?? document;
    (0, $0313565cc024e2ed$export$7080b3e976bc91ab)(doc, "pointerdown", (event)=>{
        if (!$54f5ca07bbdcb7af$var$isSafari() || !enabled) return;
        const target = event.composedPath?.()?.[0] ?? event.target;
        const els = elements ?? [
            ref
        ];
        const isValidTarget = els.some((elementOrRef)=>{
            const el = $54f5ca07bbdcb7af$var$isRefObject(elementOrRef) ? elementOrRef.current : elementOrRef;
            return el?.contains(target) || el === target;
        });
        if (doc().activeElement !== target && isValidTarget) {
            event.preventDefault();
            target.focus();
        }
    });
}




var $8v0nu = parcelRequire("8v0nu");


"use client";
const $d48278bbc73be86e$var$TRIGGER = {
    click: "click",
    hover: "hover"
};
function $d48278bbc73be86e$export$542a6fd13ac93354(props = {}) {
    const { closeOnBlur: closeOnBlur = true, closeOnEsc: closeOnEsc = true, initialFocusRef: initialFocusRef, id: id, returnFocusOnClose: returnFocusOnClose = true, autoFocus: autoFocus = true, arrowSize: arrowSize, arrowShadowColor: arrowShadowColor, trigger: trigger = $d48278bbc73be86e$var$TRIGGER.click, openDelay: openDelay = 200, closeDelay: closeDelay = 200, isLazy: isLazy, lazyBehavior: lazyBehavior = "unmount", computePositionOnMount: computePositionOnMount, ...popperProps } = props;
    const { isOpen: isOpen, onClose: onClose, onOpen: onOpen, onToggle: onToggle } = (0, $cc3982b77d606367$export$6e3e27031a30522f)(props);
    const [restoreFocus, setRestoreFocus] = (0, $8v0nu.useState)(returnFocusOnClose);
    (0, $8v0nu.useEffect)(()=>setRestoreFocus(returnFocusOnClose), [
        returnFocusOnClose
    ]);
    const anchorRef = (0, $8v0nu.useRef)(null);
    const triggerRef = (0, $8v0nu.useRef)(null);
    const popoverRef = (0, $8v0nu.useRef)(null);
    const isHoveringRef = (0, $8v0nu.useRef)(false);
    const hasBeenOpened = (0, $8v0nu.useRef)(false);
    if (isOpen) hasBeenOpened.current = true;
    const [hasHeader, setHasHeader] = (0, $8v0nu.useState)(false);
    const [hasBody, setHasBody] = (0, $8v0nu.useState)(false);
    const uuid = (0, $8v0nu.useId)();
    const uid = id ?? uuid;
    const [triggerId, popoverId, headerId, bodyId] = [
        "popover-trigger",
        "popover-content",
        "popover-header",
        "popover-body"
    ].map((id2)=>`${id2}-${uid}`);
    const { referenceRef: referenceRef, getArrowProps: getArrowProps, getPopperProps: getPopperProps, getArrowInnerProps: getArrowInnerProps, forceUpdate: forceUpdate } = (0, $e7e710a1f1f06f28$export$f4d5bf230a36dd6e)({
        ...popperProps,
        enabled: isOpen || !!computePositionOnMount
    });
    const animated = (0, $f7cea9053f03399a$export$7ee548861327febe)({
        isOpen: isOpen,
        ref: popoverRef
    });
    (0, $54f5ca07bbdcb7af$export$16a61b931588d888)({
        enabled: isOpen,
        ref: triggerRef
    });
    (0, $6c3b109dd1e78e88$export$68b323438c1fbb28)(popoverRef, {
        focusRef: triggerRef,
        visible: isOpen,
        shouldFocus: restoreFocus && trigger === $d48278bbc73be86e$var$TRIGGER.click
    });
    (0, $6c3b109dd1e78e88$export$54b5c2a5755195e7)(popoverRef, {
        focusRef: initialFocusRef,
        visible: isOpen,
        shouldFocus: autoFocus && trigger === $d48278bbc73be86e$var$TRIGGER.click
    });
    (0, $313dea541a92f272$export$71b2224f1ce5e08e)({
        enabled: isOpen && closeOnBlur,
        ref: popoverRef,
        handler (event) {
            const relatedTarget = event.composedPath?.()[0] ?? [
                event.target
            ];
            if ($d48278bbc73be86e$var$contains(triggerRef.current, relatedTarget)) return;
            if (relatedTarget) setRestoreFocus(!(0, $2f0f9843592ee423$export$4c063cf1350e6fed)(relatedTarget));
            onClose();
        }
    });
    const shouldRenderChildren = (0, $4b0f1a1d98c64842$export$76655e7dd9ffc0ba)({
        wasSelected: hasBeenOpened.current,
        enabled: isLazy,
        mode: lazyBehavior,
        isSelected: animated.present
    });
    const getPopoverProps = (0, $8v0nu.useCallback)((props2 = {}, _ref = null)=>{
        const popoverProps = {
            ...props2,
            style: {
                ...props2.style,
                transformOrigin: (0, $d220822e16a1bad8$export$fd62969fb0b7081c).transformOrigin.varRef,
                [(0, $d220822e16a1bad8$export$fd62969fb0b7081c).arrowSize.var]: arrowSize ? `${arrowSize}px` : void 0,
                [(0, $d220822e16a1bad8$export$fd62969fb0b7081c).arrowShadowColor.var]: arrowShadowColor
            },
            ref: (0, $95f7db4ddbf3eda0$export$c9058316764c140e)(popoverRef, _ref),
            children: shouldRenderChildren ? props2.children : null,
            id: popoverId,
            tabIndex: -1,
            role: "dialog",
            onKeyDown: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onKeyDown, (event)=>{
                if (event.nativeEvent.isComposing) return;
                if (closeOnEsc && event.key === "Escape") {
                    event.preventDefault();
                    event.stopPropagation();
                    onClose();
                }
            }),
            onBlur: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onBlur, (event)=>{
                const relatedTarget = $d48278bbc73be86e$var$getRelatedTarget(event);
                const targetIsPopover = $d48278bbc73be86e$var$contains(popoverRef.current, relatedTarget);
                const targetIsTrigger = $d48278bbc73be86e$var$contains(triggerRef.current, relatedTarget);
                const isValidBlur = !targetIsPopover && !targetIsTrigger;
                if (relatedTarget) setRestoreFocus(!(0, $2f0f9843592ee423$export$4c063cf1350e6fed)(relatedTarget));
                if (isOpen && closeOnBlur && isValidBlur) onClose();
            }),
            "aria-labelledby": hasHeader ? headerId : void 0,
            "aria-describedby": hasBody ? bodyId : void 0
        };
        if (trigger === $d48278bbc73be86e$var$TRIGGER.hover) {
            popoverProps.role = "tooltip";
            popoverProps.onMouseEnter = (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onMouseEnter, ()=>{
                isHoveringRef.current = true;
            });
            popoverProps.onMouseLeave = (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onMouseLeave, (event)=>{
                if (event.nativeEvent.relatedTarget === null) return;
                isHoveringRef.current = false;
                setTimeout(()=>onClose(), closeDelay);
            });
        }
        return popoverProps;
    }, [
        shouldRenderChildren,
        popoverId,
        hasHeader,
        headerId,
        hasBody,
        bodyId,
        trigger,
        closeOnEsc,
        onClose,
        isOpen,
        closeOnBlur,
        closeDelay,
        arrowShadowColor,
        arrowSize
    ]);
    const getPopoverPositionerProps = (0, $8v0nu.useCallback)((props2 = {}, forwardedRef = null)=>getPopperProps({
            ...props2,
            style: {
                visibility: isOpen ? "visible" : "hidden",
                ...props2.style
            }
        }, forwardedRef), [
        isOpen,
        getPopperProps
    ]);
    const getAnchorProps = (0, $8v0nu.useCallback)((props2, _ref = null)=>{
        return {
            ...props2,
            // If anchor is rendered, it is used as reference.
            ref: (0, $95f7db4ddbf3eda0$export$c9058316764c140e)(_ref, anchorRef, referenceRef)
        };
    }, [
        anchorRef,
        referenceRef
    ]);
    const openTimeout = (0, $8v0nu.useRef)();
    const closeTimeout = (0, $8v0nu.useRef)();
    const maybeReferenceRef = (0, $8v0nu.useCallback)((node)=>{
        if (anchorRef.current == null) referenceRef(node);
    }, [
        referenceRef
    ]);
    const getTriggerProps = (0, $8v0nu.useCallback)((props2 = {}, _ref = null)=>{
        const triggerProps = {
            ...props2,
            ref: (0, $95f7db4ddbf3eda0$export$c9058316764c140e)(triggerRef, _ref, maybeReferenceRef),
            id: triggerId,
            "aria-haspopup": "dialog",
            "aria-expanded": isOpen,
            "aria-controls": popoverId
        };
        if (trigger === $d48278bbc73be86e$var$TRIGGER.click) triggerProps.onClick = (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onClick, onToggle);
        if (trigger === $d48278bbc73be86e$var$TRIGGER.hover) {
            triggerProps.onFocus = (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onFocus, ()=>{
                if (openTimeout.current === void 0) onOpen();
            });
            triggerProps.onBlur = (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onBlur, (event)=>{
                const relatedTarget = $d48278bbc73be86e$var$getRelatedTarget(event);
                const isValidBlur = !$d48278bbc73be86e$var$contains(popoverRef.current, relatedTarget);
                if (isOpen && closeOnBlur && isValidBlur) onClose();
            });
            triggerProps.onKeyDown = (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onKeyDown, (event)=>{
                if (event.key === "Escape") onClose();
            });
            triggerProps.onMouseEnter = (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onMouseEnter, ()=>{
                isHoveringRef.current = true;
                openTimeout.current = window.setTimeout(()=>onOpen(), openDelay);
            });
            triggerProps.onMouseLeave = (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onMouseLeave, ()=>{
                isHoveringRef.current = false;
                if (openTimeout.current) {
                    clearTimeout(openTimeout.current);
                    openTimeout.current = void 0;
                }
                closeTimeout.current = window.setTimeout(()=>{
                    if (isHoveringRef.current === false) onClose();
                }, closeDelay);
            });
        }
        return triggerProps;
    }, [
        triggerId,
        isOpen,
        popoverId,
        trigger,
        maybeReferenceRef,
        onToggle,
        onOpen,
        closeOnBlur,
        onClose,
        openDelay,
        closeDelay
    ]);
    (0, $8v0nu.useEffect)(()=>{
        return ()=>{
            if (openTimeout.current) clearTimeout(openTimeout.current);
            if (closeTimeout.current) clearTimeout(closeTimeout.current);
        };
    }, []);
    const getHeaderProps = (0, $8v0nu.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            id: headerId,
            ref: (0, $95f7db4ddbf3eda0$export$c9058316764c140e)(ref, (node)=>{
                setHasHeader(!!node);
            })
        }), [
        headerId
    ]);
    const getBodyProps = (0, $8v0nu.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            id: bodyId,
            ref: (0, $95f7db4ddbf3eda0$export$c9058316764c140e)(ref, (node)=>{
                setHasBody(!!node);
            })
        }), [
        bodyId
    ]);
    return {
        forceUpdate: forceUpdate,
        isOpen: isOpen,
        onAnimationComplete: animated.onComplete,
        onClose: onClose,
        getAnchorProps: getAnchorProps,
        getArrowProps: getArrowProps,
        getArrowInnerProps: getArrowInnerProps,
        getPopoverPositionerProps: getPopoverPositionerProps,
        getPopoverProps: getPopoverProps,
        getTriggerProps: getTriggerProps,
        getHeaderProps: getHeaderProps,
        getBodyProps: getBodyProps
    };
}
function $d48278bbc73be86e$var$contains(parent, child) {
    return parent === child || parent?.contains(child);
}
function $d48278bbc73be86e$var$getRelatedTarget(event) {
    const activeEl = event.currentTarget.ownerDocument.activeElement;
    return event.relatedTarget ?? activeEl;
}




"use client";
function $8fc3d13117200342$export$5b6b19405a83ff9d(props) {
    const styles = (0, $c7d173d35275482d$export$31cdfe60c085d76f)("Popover", props);
    const { children: children, ...rest } = (0, $58ff34c9d17adf03$export$adfcf5a5e4d17785)(props);
    const theme = (0, $00627e1df6d22967$export$93d4e7f90805808f)();
    const context = (0, $d48278bbc73be86e$export$542a6fd13ac93354)({
        ...rest,
        direction: theme.direction
    });
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $6ba3cfa4898a6b5d$export$bf694c7c431c162a), {
        value: context,
        children: /* @__PURE__ */ (0, $kxTYF.jsx)((0, $6ba3cfa4898a6b5d$export$286407fa0c94e3f1), {
            value: styles,
            children: (0, $cSr1Y.runIfFn)(children, {
                isOpen: context.isOpen,
                onClose: context.onClose,
                forceUpdate: context.forceUpdate
            })
        })
    });
}
$8fc3d13117200342$export$5b6b19405a83ff9d.displayName = "Popover";


var $kxTYF = parcelRequire("kxTYF");



var $3lBLT = parcelRequire("3lBLT");
"use client";
const $55cf9cdcee035038$var$resolveVar = (scale, value)=>value ? `${scale}.${value}, ${value}` : void 0;
function $55cf9cdcee035038$export$3152841115e061b2(props) {
    const { bg: bg, bgColor: bgColor, backgroundColor: backgroundColor, shadow: shadow, boxShadow: boxShadow, shadowColor: shadowColor, ...rest } = props;
    const { getArrowProps: getArrowProps, getArrowInnerProps: getArrowInnerProps } = (0, $6ba3cfa4898a6b5d$export$1468d0761b26e6c8)();
    const styles = (0, $6ba3cfa4898a6b5d$export$bdabad59d033c81a)();
    const arrowBg = bg ?? bgColor ?? backgroundColor;
    const arrowShadow = shadow ?? boxShadow;
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
        ...getArrowProps(),
        className: "chakra-popover__arrow-positioner",
        children: /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
            className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-popover__arrow", props.className),
            ...getArrowInnerProps(rest),
            __css: {
                "--popper-arrow-shadow-color": $55cf9cdcee035038$var$resolveVar("colors", shadowColor),
                "--popper-arrow-bg": $55cf9cdcee035038$var$resolveVar("colors", arrowBg),
                "--popper-arrow-shadow": $55cf9cdcee035038$var$resolveVar("shadows", arrowShadow),
                ...styles.arrow
            }
        })
    });
}
$55cf9cdcee035038$export$3152841115e061b2.displayName = "PopoverArrow";


var $kxTYF = parcelRequire("kxTYF");




var $3lBLT = parcelRequire("3lBLT");
"use client";
const $a6833e7982783a3d$export$472ec417bca1d382 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function PopoverBody2(props, ref) {
    const { getBodyProps: getBodyProps } = (0, $6ba3cfa4898a6b5d$export$1468d0761b26e6c8)();
    const styles = (0, $6ba3cfa4898a6b5d$export$bdabad59d033c81a)();
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
        ...getBodyProps(props, ref),
        className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-popover__body", props.className),
        __css: styles.body
    });
});
$a6833e7982783a3d$export$472ec417bca1d382.displayName = "PopoverBody";


var $kxTYF = parcelRequire("kxTYF");




var $kxTYF = parcelRequire("kxTYF");



var $3lBLT = parcelRequire("3lBLT");

"use client";
function $534527dce2049e28$var$mergeVariants(variants) {
    if (!variants) return;
    return {
        enter: {
            ...variants.enter,
            visibility: "visible"
        },
        exit: {
            ...variants.exit,
            transitionEnd: {
                visibility: "hidden"
            }
        }
    };
}
const $534527dce2049e28$var$scaleFade = {
    exit: {
        opacity: 0,
        scale: 0.95,
        transition: {
            duration: 0.1,
            ease: [
                0.4,
                0,
                1,
                1
            ]
        }
    },
    enter: {
        scale: 1,
        opacity: 1,
        transition: {
            duration: 0.15,
            ease: [
                0,
                0,
                0.2,
                1
            ]
        }
    }
};
const $534527dce2049e28$var$MotionSection = (0, $3lBLT.chakra)((0, $378127958faa4916$export$e25e478948902b8b).section);
const $534527dce2049e28$export$295130c75b678e2c = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function PopoverTransition2(props, ref) {
    const { variants: variants = $534527dce2049e28$var$scaleFade, ...rest } = props;
    const { isOpen: isOpen } = (0, $6ba3cfa4898a6b5d$export$1468d0761b26e6c8)();
    return /* @__PURE__ */ (0, $kxTYF.jsx)($534527dce2049e28$var$MotionSection, {
        ref: ref,
        variants: $534527dce2049e28$var$mergeVariants(variants),
        initial: false,
        animate: isOpen ? "enter" : "exit",
        ...rest
    });
});
$534527dce2049e28$export$295130c75b678e2c.displayName = "PopoverTransition";




var $3lBLT = parcelRequire("3lBLT");
"use client";
const $cecac8d9262b4f89$export$d7e1f420b25549ff = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function PopoverContent2(props, ref) {
    const { rootProps: rootProps, motionProps: motionProps, ...contentProps } = props;
    const { getPopoverProps: getPopoverProps, getPopoverPositionerProps: getPopoverPositionerProps, onAnimationComplete: onAnimationComplete } = (0, $6ba3cfa4898a6b5d$export$1468d0761b26e6c8)();
    const styles = (0, $6ba3cfa4898a6b5d$export$bdabad59d033c81a)();
    const contentStyles = (0, $8d7ccf069e08e0a2$export$9a6b93c1c4f92839)({
        position: "relative",
        display: "flex",
        flexDirection: "column",
        ...styles.content
    });
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
        ...getPopoverPositionerProps(rootProps),
        __css: styles.popper,
        className: "chakra-popover__popper",
        children: /* @__PURE__ */ (0, $kxTYF.jsx)((0, $534527dce2049e28$export$295130c75b678e2c), {
            ...motionProps,
            ...getPopoverProps(contentProps, ref),
            onAnimationComplete: (0, $5bb288c143ca173e$export$9dd9a52f2dd5b9ce)(onAnimationComplete, contentProps.onAnimationComplete),
            className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-popover__content", props.className),
            __css: contentStyles
        })
    });
});
$cecac8d9262b4f89$export$d7e1f420b25549ff.displayName = "PopoverContent";


var $kxTYF = parcelRequire("kxTYF");

var $8v0nu = parcelRequire("8v0nu");

"use client";
function $1c3d422009b18974$export$7dacb05d26466c3(props) {
    const child = (0, $8v0nu.Children).only(props.children);
    const { getTriggerProps: getTriggerProps } = (0, $6ba3cfa4898a6b5d$export$1468d0761b26e6c8)();
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $kxTYF.Fragment), {
        children: (0, $8v0nu.cloneElement)(child, getTriggerProps(child.props, child.ref))
    });
}
$1c3d422009b18974$export$7dacb05d26466c3.displayName = "PopoverTrigger";






var $kxTYF = parcelRequire("kxTYF");

var $8v0nu = parcelRequire("8v0nu");


var $31zZV = parcelRequire("31zZV");
// index.ts

function $d106280e61f380a2$export$b8b8bb64565c10e(bbox, options = {}) {
    const west = Number(bbox[0]);
    const south = Number(bbox[1]);
    const east = Number(bbox[2]);
    const north = Number(bbox[3]);
    if (bbox.length === 6) throw new Error("@turf/bbox-polygon does not support BBox with 6 positions");
    const lowLeft = [
        west,
        south
    ];
    const topLeft = [
        west,
        north
    ];
    const topRight = [
        east,
        north
    ];
    const lowRight = [
        east,
        south
    ];
    return (0, $32169f69e04c6230$export$b7b19aa0ee06c73)([
        [
            lowLeft,
            lowRight,
            topRight,
            topLeft,
            lowLeft
        ]
    ], options.properties, {
        bbox: bbox,
        id: options.id
    });
}
var $d106280e61f380a2$export$2e2bcd8739ae039 = $d106280e61f380a2$export$b8b8bb64565c10e;



const $cd2e1fccb6e85b32$var$extentOutline = {
    "line-color": "#276749",
    "line-width": 2,
    "line-dasharray": [
        2,
        2
    ]
};
const $cd2e1fccb6e85b32$var$dataOutline = {
    "line-color": "#C53030",
    "line-width": 1
};
function $cd2e1fccb6e85b32$var$CollectionMap({ collection: collection }) {
    const [map, setMap] = (0, $8v0nu.useState)();
    const setMapRef = (m)=>setMap(m);
    // Create GeoJSON polygon from extent
    const extent = (0, $8v0nu.useMemo)(()=>{
        if (!collection) return;
        const [x1, y1, x2, y2] = collection.extent.spatial.bbox[0];
        return (0, $d106280e61f380a2$export$2e2bcd8739ae039)([
            x1,
            y1,
            x2,
            y2
        ]);
    }, [
        collection
    ]);
    // Create GeoJSON Feature collection from data extents
    const dataExtents = (0, $8v0nu.useMemo)(()=>{
        if (!collection) return;
        if (collection.extent.spatial.bbox.length > 1) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const [_, ...data] = collection.extent.spatial.bbox;
            return {
                type: "FeatureCollection",
                features: data.map(([x1, y1, x2, y2])=>(0, $d106280e61f380a2$export$2e2bcd8739ae039)([
                        x1,
                        y1,
                        x2,
                        y2
                    ]))
            };
        }
    }, [
        collection
    ]);
    // Fit the map view around the current collection extent
    (0, $8v0nu.useEffect)(()=>{
        if (collection && map) {
            let [x1, y1, x2, y2] = collection.extent.spatial.bbox[0];
            const bounds = new (0, $31zZV.LngLatBounds)([
                x1,
                y1,
                x2,
                y2
            ]);
            for(let i = 1, len = collection.extent.spatial.bbox.length; i < len; i++){
                [x1, y1, x2, y2] = collection.extent.spatial.bbox[i];
                bounds.extend([
                    x1,
                    y1,
                    x2,
                    y2
                ]);
            }
            [x1, y1, x2, y2] = bounds.toArray().flat();
            map.fitBounds([
                x1,
                y1,
                x2,
                y2
            ], {
                padding: 30,
                duration: 0
            });
        }
    }, [
        collection,
        map
    ]);
    return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $5364b873ba521936$export$2e2bcd8739ae039), {
        ref: setMapRef,
        children: [
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3cdef1182cb7804b$export$2e2bcd8739ae039), {}),
            extent && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $5364b873ba521936$export$1d2df86270c81ecb), {
                id: "extent",
                type: "geojson",
                data: extent,
                children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $5364b873ba521936$export$936d0764594b6eb3), {
                    id: "extent-line",
                    type: "line",
                    paint: $cd2e1fccb6e85b32$var$extentOutline
                })
            }),
            dataExtents && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $5364b873ba521936$export$1d2df86270c81ecb), {
                id: "data-extent",
                type: "geojson",
                data: dataExtents,
                children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $5364b873ba521936$export$936d0764594b6eb3), {
                    id: "data-extent-line",
                    type: "line",
                    paint: $cd2e1fccb6e85b32$var$dataOutline
                })
            })
        ]
    });
}
var $cd2e1fccb6e85b32$export$2e2bcd8739ae039 = $cd2e1fccb6e85b32$var$CollectionMap;








var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");


function $72a6bfb38741f9f1$export$5ac124715785374c(props) {
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $488a343786980c50$export$6831baa95aeeaf1e), {
        icon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$5918e8962b6636e9), {}),
        color: "danger.500",
        _hover: {
            bg: "danger.200"
        },
        _focus: {
            bg: "danger.200"
        },
        ...props,
        children: "Delete"
    });
}




const $c3fcc3bc13c840b3$var$dateFormat = {
    year: "numeric",
    month: "long",
    day: "numeric"
};
function $c3fcc3bc13c840b3$var$CollectionDetail() {
    const { collectionId: collectionId } = (0, $aa6b6e9e15323f83$export$99eaa27ddbbb95ef)();
    (0, $aec39e40387762bd$export$2e2bcd8739ae039)(`Collection ${collectionId}`);
    const { collection: collection, state: state } = (0, $eba44fb2c963ffed$export$6cd28814d92fa9c9)(collectionId); // eslint-disable-line @typescript-eslint/no-non-null-assertion
    const { results: results, collections: collections, setCollections: setCollections, submit: submit, nextPage: nextPage, previousPage: previousPage } = (0, $eba44fb2c963ffed$export$47c1284bb8faa96)();
    // The stac search pagination is token based and has no pages, but we can fake
    // it tracking the prev and next clicks.
    const [page, setPage] = (0, $8v0nu.useState)(1);
    const onPageNavigate = (0, $8v0nu.useCallback)((actions)=>{
        if (actions === "next") {
            setPage((prev)=>prev + 1);
            nextPage?.();
        } else {
            setPage((prev)=>prev - 1);
            previousPage?.();
        }
    }, [
        nextPage,
        previousPage
    ]);
    // Initialize the search with the current collection ID
    (0, $8v0nu.useEffect)(()=>{
        setCollections([
            collectionId
        ]);
    }, [
        collectionId,
        setCollections
    ]);
    // Automatically submit whenever the collection ID changes
    (0, $8v0nu.useEffect)(()=>{
        if (!collections) return;
        submit();
    }, [
        collections,
        submit
    ]);
    const dateLabel = (0, $8v0nu.useMemo)(()=>{
        if (!collection) return;
        const [fromDate, toDate] = collection.extent.temporal.interval[0];
        const fromLabel = fromDate && new Date(fromDate).toLocaleString("en-GB", $c3fcc3bc13c840b3$var$dateFormat);
        const toLabel = toDate && new Date(toDate).toLocaleString("en-GB", $c3fcc3bc13c840b3$var$dateFormat);
        if (fromLabel && toLabel) return `${fromLabel} \u{2013} ${toLabel}`;
        if (fromLabel) return `From: ${fromLabel}`;
        if (toLabel) return `To: ${toLabel}`;
        return "\u2014";
    }, [
        collection
    ]);
    if (!collection || state === "LOADING") return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $9HGsN.Box), {
        p: 8,
        children: [
            /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                direction: "column",
                gap: 4,
                children: [
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $408225e060551a18$export$8f31e4c4a37b8e9c), {
                        h: 6,
                        maxW: "25rem"
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $408225e060551a18$export$8f31e4c4a37b8e9c), {
                        h: 12,
                        maxW: "30rem"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $2fb4f0d945397efb$export$cb6ddd830302c2a8), {
                mt: 8,
                noOfLines: 4,
                spacing: "4",
                skeletonHeight: "2",
                maxW: "50rem"
            })
        ]
    });
    const { id: id, title: title, description: description, keywords: keywords, license: license } = collection;
    const resultCount = results?.numberMatched || 0;
    const shouldPaginate = results?.links?.length > 1 && resultCount > results?.numberReturned;
    return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
        direction: "column",
        gap: 8,
        children: [
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $dfd76aae8c4830bc$export$644c29b44a905178), {
                overline: "Viewing Collection",
                title: title || id,
                actions: /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $kxTYF.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $kxTYF.jsx)((0, $43aa0a8514afe58f$export$c8d4523fa9306542), {
                            colorScheme: "primary",
                            to: `/collections/${id}/edit`,
                            leftIcon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$b8f31e9a5cf17074), {}),
                            children: "Edit"
                        }),
                        /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $bbc1594d228c6000$export$d9b273488cd8ce6f), {
                            children: [
                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $5277a93d60858aae$export$266a769812832828), {
                                    as: (0, $5f067ccb39c91cbc$export$c25acd513dcc8062),
                                    "aria-label": "Options",
                                    icon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$b307b75901e71920), {}),
                                    variant: "outline",
                                    size: "md"
                                }),
                                /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $caedd5fbd169c955$export$d4c4e98c5044dc8), {
                                    children: [
                                        /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9fe47dbb44516a54$export$2b6a1f5f68a01133), {
                                            resourcePath: `/collections/${id}`
                                        }),
                                        /*#__PURE__*/ (0, $kxTYF.jsx)((0, $72a6bfb38741f9f1$export$5ac124715785374c), {})
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                direction: "column",
                gap: "8",
                as: "section",
                children: [
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                        direction: "row",
                        px: "8",
                        gap: "8",
                        as: "header",
                        children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9HGsN.Box), {
                            flexBasis: "100%",
                            children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8651ef577e25eea6$export$a8a3e93435678ff9), {
                                size: "md",
                                as: "h2",
                                children: "Overview"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $da89f256d660f801$export$ef2184bd89960b14), {
                        templateColumns: "repeat(12, 1fr)",
                        gap: 8,
                        children: [
                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $d3de29280e541829$export$9eb849b9b922d396), {
                                colSpan: 8,
                                children: /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                                    bg: "base.50",
                                    borderRadius: "md",
                                    p: 8,
                                    direction: "column",
                                    gap: 4,
                                    minH: "100%",
                                    children: [
                                        description && /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                                            direction: "column",
                                            gap: "2",
                                            children: [
                                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8651ef577e25eea6$export$a8a3e93435678ff9), {
                                                    size: "sm",
                                                    as: "h3",
                                                    children: "Description"
                                                }),
                                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3963bf82c5559c75$export$5f1af8db9871e1d6), {
                                                    size: "md",
                                                    children: description
                                                })
                                            ]
                                        }),
                                        dateLabel && /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                                            direction: "column",
                                            gap: "2",
                                            children: [
                                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8651ef577e25eea6$export$a8a3e93435678ff9), {
                                                    size: "sm",
                                                    as: "h3",
                                                    children: "Temporal extent"
                                                }),
                                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3963bf82c5559c75$export$5f1af8db9871e1d6), {
                                                    size: "md",
                                                    children: dateLabel
                                                })
                                            ]
                                        }),
                                        license && /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                                            direction: "column",
                                            gap: "2",
                                            children: [
                                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8651ef577e25eea6$export$a8a3e93435678ff9), {
                                                    size: "sm",
                                                    as: "h3",
                                                    children: "License"
                                                }),
                                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3963bf82c5559c75$export$5f1af8db9871e1d6), {
                                                    size: "md",
                                                    children: license
                                                })
                                            ]
                                        }),
                                        keywords && /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                                            direction: "column",
                                            gap: "2",
                                            children: [
                                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8651ef577e25eea6$export$a8a3e93435678ff9), {
                                                    size: "sm",
                                                    as: "h3",
                                                    children: "Keywords"
                                                }),
                                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $ffc809ba2fb36850$export$15e411dc07b9c834), {
                                                    spacing: 2,
                                                    children: keywords.map((keyword)=>/*#__PURE__*/ (0, $kxTYF.jsx)((0, $beacec6ac7efe0d9$export$3288d34c523a1192), {
                                                            size: "md",
                                                            colorScheme: "primary",
                                                            children: keyword
                                                        }, keyword))
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $d3de29280e541829$export$9eb849b9b922d396), {
                                colSpan: 4,
                                children: /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                                    bg: "base.50",
                                    borderRadius: "md",
                                    p: 8,
                                    direction: "column",
                                    gap: 2,
                                    position: "relative",
                                    overflow: "hidden",
                                    height: "20rem",
                                    children: [
                                        /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8651ef577e25eea6$export$a8a3e93435678ff9), {
                                            size: "sm",
                                            as: "h3",
                                            children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3380028199317e44$export$439d29a4e110a164), {
                                                children: "Spacial extent"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9HGsN.Box), {
                                            position: "absolute",
                                            inset: "0",
                                            children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $cd2e1fccb6e85b32$export$2e2bcd8739ae039), {
                                                collection: collection
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                direction: "column",
                gap: "8",
                as: "section",
                children: [
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                        direction: "row",
                        px: "8",
                        gap: "8",
                        as: "header",
                        children: /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $9HGsN.Box), {
                            flexBasis: "100%",
                            children: [
                                /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $8651ef577e25eea6$export$a8a3e93435678ff9), {
                                    size: "md",
                                    as: "h2",
                                    children: [
                                        "Items",
                                        " ",
                                        results && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $6cea469a0e58db34$export$37acb3580601e69a), {
                                            variant: "solid",
                                            children: (0, $f55c5bb8e60e90fc$export$3cdc770bf8b2ed3d)(resultCount)
                                        })
                                    ]
                                }),
                                !!resultCount && /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $3963bf82c5559c75$export$5f1af8db9871e1d6), {
                                    size: "sm",
                                    color: "base.400",
                                    children: [
                                        "Showing page ",
                                        page,
                                        " of",
                                        " ",
                                        Math.ceil(resultCount / results.numberReturned)
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $97afd073f9746d02$export$de97fecb6d4b30a5), {
                        gap: 8,
                        templateColumns: "repeat(auto-fill, minmax(18rem, 1fr))",
                        children: results ? results.features.map((item)=>/*#__PURE__*/ (0, $kxTYF.jsx)((0, $3456399f909bb134$export$f55f1d663c7efb35), {
                                title: item.id,
                                to: `/collections/${id}/items/${item.id}`,
                                renderMenu: ()=>{
                                    return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                                        gap: 2,
                                        children: [
                                            /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $bbc1594d228c6000$export$d9b273488cd8ce6f), {
                                                placement: "bottom-end",
                                                children: [
                                                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $5277a93d60858aae$export$266a769812832828), {
                                                        as: (0, $5f067ccb39c91cbc$export$c25acd513dcc8062),
                                                        "aria-label": "Options",
                                                        icon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$b307b75901e71920), {}),
                                                        variant: "outline",
                                                        size: "sm"
                                                    }),
                                                    /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $caedd5fbd169c955$export$d4c4e98c5044dc8), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9fe47dbb44516a54$export$2b6a1f5f68a01133), {
                                                                resourcePath: `/collections/${id}/items/${item.id}`
                                                            }),
                                                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $293887a95e6a8bc4$export$2ce376c2cc3355c8), {
                                                                as: (0, $78d29a24c660df8a$export$2e2bcd8739ae039),
                                                                to: `/collections/${id}/items/${item.id}`,
                                                                icon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$3b8ef319a6c5f131), {}),
                                                                children: "View"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8fc3d13117200342$export$5b6b19405a83ff9d), {
                                                placement: "top",
                                                isLazy: true,
                                                children: ({ isOpen: isOpen })=>/*#__PURE__*/ (0, $kxTYF.jsxs)((0, $kxTYF.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $1c3d422009b18974$export$7dacb05d26466c3), {
                                                                children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $5f067ccb39c91cbc$export$c25acd513dcc8062), {
                                                                    "aria-label": "Preview",
                                                                    icon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$5b296b74fc93300b), {}),
                                                                    variant: "outline",
                                                                    size: "sm",
                                                                    isActive: isOpen
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $cecac8d9262b4f89$export$d7e1f420b25549ff), {
                                                                boxShadow: "sm",
                                                                borderColor: "base.200",
                                                                borderWidth: "2px",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $55cf9cdcee035038$export$3152841115e061b2), {
                                                                        bg: "base.200"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $a6833e7982783a3d$export$472ec417bca1d382), {
                                                                        p: 0,
                                                                        overflow: "hidden",
                                                                        borderRadius: "md",
                                                                        children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9HGsN.Box), {
                                                                            h: "15rem",
                                                                            children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $854c342785fecb8e$export$a9105c4033140ee1), {
                                                                                item: item,
                                                                                reuseMaps: true
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                            })
                                        ]
                                    });
                                }
                            }, item.id)) : /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $kxTYF.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3456399f909bb134$export$d49dc2f4fca0ae8c), {
                                    mini: true
                                }),
                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3456399f909bb134$export$d49dc2f4fca0ae8c), {
                                    mini: true
                                }),
                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3456399f909bb134$export$d49dc2f4fca0ae8c), {
                                    mini: true
                                })
                            ]
                        })
                    }),
                    shouldPaginate && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                        direction: "column",
                        alignItems: "center",
                        children: /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $2cf6f5791bed302c$export$69b1032f2ecdf404), {
                            size: "sm",
                            variant: "outline",
                            isAttached: true,
                            children: [
                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $b8b7f6458056e8af$export$353f5b6fc5456de1), {
                                    disabled: !previousPage,
                                    onClick: ()=>onPageNavigate("previous"),
                                    children: "Previous"
                                }),
                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $b8b7f6458056e8af$export$353f5b6fc5456de1), {
                                    disabled: !nextPage,
                                    onClick: ()=>onPageNavigate("next"),
                                    children: "Next"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
var $c3fcc3bc13c840b3$export$2e2bcd8739ae039 = $c3fcc3bc13c840b3$var$CollectionDetail;



var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");




function $ea162eceb2783502$export$2e2bcd8739ae039() {
    (0, $aec39e40387762bd$export$2e2bcd8739ae039)("Sandbox");
    return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
        direction: "column",
        gap: 8,
        p: 4,
        children: [
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $dfd76aae8c4830bc$export$644c29b44a905178), {
                overline: "Sandbox",
                title: "Sandbox"
            }),
            /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                direction: "column",
                gap: 8,
                children: [
                    /*#__PURE__*/ (0, $kxTYF.jsx)("p", {
                        children: "This is the sandbox."
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $97afd073f9746d02$export$de97fecb6d4b30a5), {
                        gap: 8,
                        templateColumns: "repeat(auto-fill, minmax(18rem, 1fr))",
                        children: [
                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3456399f909bb134$export$f55f1d663c7efb35), {}),
                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3456399f909bb134$export$f55f1d663c7efb35), {}),
                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3456399f909bb134$export$f55f1d663c7efb35), {}),
                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3456399f909bb134$export$f55f1d663c7efb35), {})
                        ]
                    })
                ]
            })
        ]
    });
}




const $abca8739d4d09600$var$rotate = (0, $6iKRa.keyframes)`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
const $abca8739d4d09600$var$rotate2 = (0, $6iKRa.keyframes)`
  from {
    transform: rotate(22.5deg);
  }
  to {
    transform: rotate(382.5deg);
  }
`;
function $abca8739d4d09600$export$86fbec116b87613f() {
    const { isLoading: isLoading } = (0, $c837ac9c698038bc$export$1d39dc5b47e56ff0)();
    return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $kxTYF.Fragment), {
        children: [
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $cf1ab35b07148e68$export$c983850c6c9d8b0e), {
                in: isLoading,
                unmountOnExit: true,
                children: /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                    minW: "100vw",
                    minH: "100vh",
                    bg: "white",
                    align: "center",
                    justify: "center",
                    children: [
                        /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$4073c4c5b5a233d4), {
                            size: "5em",
                            color: "base.300",
                            animation: `${$abca8739d4d09600$var$rotate} 4s linear infinite`
                        }),
                        /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$4073c4c5b5a233d4), {
                            ml: -2,
                            size: "5em",
                            color: "base.300",
                            animation: `${$abca8739d4d09600$var$rotate2} 4s linear infinite reverse`
                        })
                    ]
                })
            }),
            !isLoading && /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $f3e451793b23b8d1$export$42a852a2b6b56249), {
                maxW: "container.xl",
                minH: "100vh",
                display: "flex",
                flexDirection: "column",
                gap: 4,
                children: [
                    /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                        as: "header",
                        gap: 4,
                        alignItems: "center",
                        justifyContent: "space-between",
                        py: 8,
                        children: [
                            /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                                gap: 4,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9d94326d5feb12f2$export$3e431a229df88919), {
                                        src: `${"/"}/meta/icon-512.png`,
                                        width: 8,
                                        aspectRatio: 1,
                                        borderRadius: "md"
                                    }),
                                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $a3bfda7295e9946f$export$2e0a83ec2e27ecbb), {
                                        orientation: "vertical",
                                        borderColor: "base.200a",
                                        h: "1rem",
                                        borderLeftWidth: "2px"
                                    }),
                                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8651ef577e25eea6$export$a8a3e93435678ff9), {
                                        as: "p",
                                        size: "sm",
                                        children: "STAC Manager"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $e206030315a52ed9$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9HGsN.Box), {
                        as: "main",
                        children: /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $aa6b6e9e15323f83$export$3565eb3d00ca5a74), {
                            children: [
                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $aa6b6e9e15323f83$export$e7b0ac011bb776c6), {
                                    path: "/",
                                    element: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $d26150280087d264$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $aa6b6e9e15323f83$export$e7b0ac011bb776c6), {
                                    path: "/collections/",
                                    element: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $16109d62536d0cfb$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $aa6b6e9e15323f83$export$e7b0ac011bb776c6), {
                                    path: "/collections/new/",
                                    element: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $ab8658d5c674cf12$export$8ef2ed426dede42d), {
                                        Component: (0, $d8d64c35e07ebf83$export$9fbdb99242c1b155)
                                    })
                                }),
                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $aa6b6e9e15323f83$export$e7b0ac011bb776c6), {
                                    path: "/collections/:collectionId/",
                                    element: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $c3fcc3bc13c840b3$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $aa6b6e9e15323f83$export$e7b0ac011bb776c6), {
                                    path: "/collections/:collectionId/edit/",
                                    element: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $ab8658d5c674cf12$export$8ef2ed426dede42d), {
                                        Component: (0, $d8d64c35e07ebf83$export$9fbdb99242c1b155)
                                    })
                                }),
                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $aa6b6e9e15323f83$export$e7b0ac011bb776c6), {
                                    path: "/collections/:collectionId/items/:itemId/",
                                    element: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $943c638232d86618$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $aa6b6e9e15323f83$export$e7b0ac011bb776c6), {
                                    path: "/sandbox",
                                    element: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $ea162eceb2783502$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $aa6b6e9e15323f83$export$e7b0ac011bb776c6), {
                                    path: "*",
                                    element: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8027973e38821351$export$2e2bcd8739ae039), {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)($abca8739d4d09600$var$AppFooter, {})
                ]
            })
        ]
    });
}
function $abca8739d4d09600$var$AppFooter() {
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
        as: "footer",
        gap: 4,
        alignItems: "center",
        justifyContent: "space-between",
        mt: "auto",
        p: 4,
        children: /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
            gap: 4,
            alignItems: "center",
            width: "100%",
            children: [
                /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $3963bf82c5559c75$export$5f1af8db9871e1d6), {
                    as: "span",
                    children: [
                        "Powered by",
                        " ",
                        /*#__PURE__*/ (0, $kxTYF.jsxs)("strong", {
                            children: [
                                "STAC Manager",
                                " ",
                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $6cea469a0e58db34$export$37acb3580601e69a), {
                                    bg: "base.400a",
                                    color: "surface.500",
                                    px: "0.375rem",
                                    children: "dependabot/github_actions/docker/build-push-action-7.2.0"
                                })
                            ]
                        }),
                        " "
                    ]
                }),
                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $a3bfda7295e9946f$export$2e0a83ec2e27ecbb), {
                    orientation: "vertical",
                    borderColor: "base.200a",
                    h: "1em"
                }),
                new Date().getFullYear(),
                /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $3963bf82c5559c75$export$5f1af8db9871e1d6), {
                    as: "span",
                    ml: "auto",
                    children: [
                        "Made with ",
                        /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$3094a1b9f32c68d5), {
                            meaningful: true,
                            title: "love"
                        }),
                        " by",
                        " ",
                        /*#__PURE__*/ (0, $kxTYF.jsx)((0, $78d29a24c660df8a$export$2e2bcd8739ae039), {
                            to: "https://developmentseed.org",
                            color: "inherit",
                            children: "Development Seed"
                        }),
                        "."
                    ]
                })
            ]
        })
    });
}




var $fZQg5 = parcelRequire("fZQg5");
var $v03Ub = parcelRequire("v03Ub");
"use client";
function $5bade08afca30967$var$isFunction(value) {
    return typeof value === "function";
}
function $5bade08afca30967$var$pipe(...fns) {
    return (v)=>fns.reduce((a, b)=>b(a), v);
}
const $5bade08afca30967$export$1a43c6e7a45b5150 = (theme2)=>{
    return function extendTheme2(...extensions) {
        let overrides = [
            ...extensions
        ];
        let activeTheme = extensions[extensions.length - 1];
        if ((0, $598e53bf8605736b$export$73a6ae01926a4f0e)(activeTheme) && // this ensures backward compatibility
        // previously only `extendTheme(override, activeTheme?)` was allowed
        overrides.length > 1) overrides = overrides.slice(0, overrides.length - 1);
        else activeTheme = theme2;
        return $5bade08afca30967$var$pipe(...overrides.map((extension)=>(prevTheme)=>$5bade08afca30967$var$isFunction(extension) ? extension(prevTheme) : $5bade08afca30967$export$c42236daa9a25fdd(prevTheme, extension)))(activeTheme);
    };
};
const $5bade08afca30967$export$33a2b855d5b8731e = $5bade08afca30967$export$1a43c6e7a45b5150((0, $9336ec4b7857882b$export$bca14c5b3b88a9c9));
const $5bade08afca30967$export$4c7add5200c9692a = $5bade08afca30967$export$1a43c6e7a45b5150((0, $9336ec4b7857882b$export$9e955aef208055a6));
function $5bade08afca30967$export$c42236daa9a25fdd(...overrides) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($v03Ub)))({}, ...overrides, $5bade08afca30967$var$mergeThemeCustomizer);
}
function $5bade08afca30967$var$mergeThemeCustomizer(source, override, key, object) {
    if (($5bade08afca30967$var$isFunction(source) || $5bade08afca30967$var$isFunction(override)) && Object.prototype.hasOwnProperty.call(object, key)) return (...args)=>{
        const sourceValue = $5bade08afca30967$var$isFunction(source) ? source(...args) : source;
        const overrideValue = $5bade08afca30967$var$isFunction(override) ? override(...args) : override;
        return (0, (/*@__PURE__*/$parcel$interopDefault($v03Ub)))({}, sourceValue, overrideValue, $5bade08afca30967$var$mergeThemeCustomizer);
    };
    if ((0, $fZQg5.isArray)(source) && (0, $fZQg5.isArray)(override)) return [
        ...source,
        ...override
    ];
    if ((0, $fZQg5.isArray)(source) && (0, $fZQg5.isObject)(override)) return override;
    return void 0;
}



var $2Jgqn = parcelRequire("2Jgqn");
function $8936f896c18fae91$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $3e402af6c1df600a$export$2e2bcd8739ae039(t, e) {
    return $3e402af6c1df600a$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $3e402af6c1df600a$export$2e2bcd8739ae039(t, e);
}


function $83bdfc144528e1e5$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $3e402af6c1df600a$export$2e2bcd8739ae039)(t, o);
}


function $53a741574f109c42$export$2e2bcd8739ae039(t) {
    return $53a741574f109c42$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $53a741574f109c42$export$2e2bcd8739ae039(t);
}



function $3801ec5cbb6ef197$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}


function $ed6a999545bb9645$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ed6a999545bb9645$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $7aaacdece758a983$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $ed6a999545bb9645$export$2e2bcd8739ae039)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $3e402af6c1df600a$export$2e2bcd8739ae039)(p, r.prototype), p;
}


function $8d007ef8f92c1f83$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $8d007ef8f92c1f83$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $3801ec5cbb6ef197$export$2e2bcd8739ae039)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $7aaacdece758a983$export$2e2bcd8739ae039)(t, arguments, (0, $53a741574f109c42$export$2e2bcd8739ae039)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $3e402af6c1df600a$export$2e2bcd8739ae039)(Wrapper, t);
    }, $8d007ef8f92c1f83$export$2e2bcd8739ae039(t);
}


function $b828f41498135548$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), e.raw = t, e;
}


function $e4334fe97365ceb5$var$last() {
    var _ref;
    return _ref = arguments.length - 1, _ref < 0 || arguments.length <= _ref ? undefined : arguments[_ref];
}
function $e4334fe97365ceb5$var$negation(a) {
    return -a;
}
function $e4334fe97365ceb5$var$addition(a, b) {
    return a + b;
}
function $e4334fe97365ceb5$var$subtraction(a, b) {
    return a - b;
}
function $e4334fe97365ceb5$var$multiplication(a, b) {
    return a * b;
}
function $e4334fe97365ceb5$var$division(a, b) {
    return a / b;
}
function $e4334fe97365ceb5$var$max() {
    return Math.max.apply(Math, arguments);
}
function $e4334fe97365ceb5$var$min() {
    return Math.min.apply(Math, arguments);
}
function $e4334fe97365ceb5$var$comma() {
    return Array.of.apply(Array, arguments);
}
var $e4334fe97365ceb5$var$defaultSymbols = {
    symbols: {
        "*": {
            infix: {
                symbol: "*",
                f: $e4334fe97365ceb5$var$multiplication,
                notation: "infix",
                precedence: 4,
                rightToLeft: 0,
                argCount: 2
            },
            symbol: "*",
            regSymbol: "\\*"
        },
        "/": {
            infix: {
                symbol: "/",
                f: $e4334fe97365ceb5$var$division,
                notation: "infix",
                precedence: 4,
                rightToLeft: 0,
                argCount: 2
            },
            symbol: "/",
            regSymbol: "/"
        },
        "+": {
            infix: {
                symbol: "+",
                f: $e4334fe97365ceb5$var$addition,
                notation: "infix",
                precedence: 2,
                rightToLeft: 0,
                argCount: 2
            },
            prefix: {
                symbol: "+",
                f: $e4334fe97365ceb5$var$last,
                notation: "prefix",
                precedence: 3,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: "+",
            regSymbol: "\\+"
        },
        "-": {
            infix: {
                symbol: "-",
                f: $e4334fe97365ceb5$var$subtraction,
                notation: "infix",
                precedence: 2,
                rightToLeft: 0,
                argCount: 2
            },
            prefix: {
                symbol: "-",
                f: $e4334fe97365ceb5$var$negation,
                notation: "prefix",
                precedence: 3,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: "-",
            regSymbol: "-"
        },
        ",": {
            infix: {
                symbol: ",",
                f: $e4334fe97365ceb5$var$comma,
                notation: "infix",
                precedence: 1,
                rightToLeft: 0,
                argCount: 2
            },
            symbol: ",",
            regSymbol: ","
        },
        "(": {
            prefix: {
                symbol: "(",
                f: $e4334fe97365ceb5$var$last,
                notation: "prefix",
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: "(",
            regSymbol: "\\("
        },
        ")": {
            postfix: {
                symbol: ")",
                f: undefined,
                notation: "postfix",
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: ")",
            regSymbol: "\\)"
        },
        min: {
            func: {
                symbol: "min",
                f: $e4334fe97365ceb5$var$min,
                notation: "func",
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: "min",
            regSymbol: "min\\b"
        },
        max: {
            func: {
                symbol: "max",
                f: $e4334fe97365ceb5$var$max,
                notation: "func",
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: "max",
            regSymbol: "max\\b"
        }
    }
};
var $e4334fe97365ceb5$var$defaultSymbolMap = $e4334fe97365ceb5$var$defaultSymbols;
// based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js
/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */ var $e4334fe97365ceb5$var$ERRORS = {
    "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
    "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
    "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
    "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
    "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
    "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
    "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
    "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
    "9": "Please provide a number of steps to the modularScale helper.\n\n",
    "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
    "11": 'Invalid value passed as base to modularScale, expected number or em string but got "%s"\n\n',
    "12": 'Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.\n\n',
    "13": 'Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.\n\n',
    "14": 'Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.\n\n',
    "15": 'Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.\n\n',
    "16": "You must provide a template to this method.\n\n",
    "17": "You passed an unsupported selector state to this method.\n\n",
    "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
    "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
    "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
    "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    "23": "fontFace expects a name of a font-family.\n\n",
    "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
    "25": "fontFace expects localFonts to be an array.\n\n",
    "26": "fontFace expects fileFormats to be an array.\n\n",
    "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
    "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
    "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
    "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
    "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
    "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
    "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
    "35": 'borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.\n\n',
    "36": "Property must be a string value.\n\n",
    "37": "Syntax Error at %s.\n\n",
    "38": "Formula contains a function that needs parentheses at %s.\n\n",
    "39": "Formula is missing closing parenthesis at %s.\n\n",
    "40": "Formula has too many closing parentheses at %s.\n\n",
    "41": "All values in a formula must have the same unit or be unitless.\n\n",
    "42": "Please provide a number of steps to the modularScale helper.\n\n",
    "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
    "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
    "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
    "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
    "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
    "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
    "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
    "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
    "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
    "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
    "53": "fontFace expects localFonts to be an array.\n\n",
    "54": "fontFace expects fileFormats to be an array.\n\n",
    "55": "fontFace expects a name of a font-family.\n\n",
    "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
    "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
    "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
    "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
    "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    "61": "Property must be a string value.\n\n",
    "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
    "63": 'borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.\n\n',
    "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
    "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
    "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
    "67": "You must provide a template to this method.\n\n",
    "68": "You passed an unsupported selector state to this method.\n\n",
    "69": 'Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.\n\n',
    "70": 'Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.\n\n',
    "71": 'Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.\n\n',
    "72": 'Passed invalid base value %s to %s(), please pass a value like "12px" or 12.\n\n',
    "73": "Please provide a valid CSS variable.\n\n",
    "74": "CSS variable not found and no default was provided.\n\n",
    "75": "important requires a valid style object, got a %s instead.\n\n",
    "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
    "77": 'remToPx expects a value in "rem" but you provided it in "%s".\n\n',
    "78": 'base must be set in "px" or "%" but you set it in "%s".\n'
};
/**
 * super basic version of sprintf
 * @private
 */ function $e4334fe97365ceb5$var$format() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var a = args[0];
    var b = [];
    var c;
    for(c = 1; c < args.length; c += 1)b.push(args[c]);
    b.forEach(function(d) {
        a = a.replace(/%[a-z]/, d);
    });
    return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */ var $e4334fe97365ceb5$var$PolishedError = /*#__PURE__*/ function(_Error) {
    (0, $83bdfc144528e1e5$export$2e2bcd8739ae039)(PolishedError, _Error);
    function PolishedError(code) {
        var _this;
        var _len2, args, _key2;
        _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
        return (0, $8936f896c18fae91$export$2e2bcd8739ae039)(_this);
    }
    return PolishedError;
}(/*#__PURE__*/ (0, $8d007ef8f92c1f83$export$2e2bcd8739ae039)(Error));
var $e4334fe97365ceb5$var$unitRegExp = /((?!\w)a|na|hc|mc|dg|me[r]?|xe|ni(?![a-zA-Z])|mm|cp|tp|xp|q(?!s)|hv|xamv|nimv|wv|sm|s(?!\D|$)|ged|darg?|nrut)/g;
// Merges additional math functionality into the defaults.
function $e4334fe97365ceb5$var$mergeSymbolMaps(additionalSymbols) {
    var symbolMap = {};
    symbolMap.symbols = additionalSymbols ? (0, $2Jgqn.default)({}, $e4334fe97365ceb5$var$defaultSymbolMap.symbols, additionalSymbols.symbols) : (0, $2Jgqn.default)({}, $e4334fe97365ceb5$var$defaultSymbolMap.symbols);
    return symbolMap;
}
function $e4334fe97365ceb5$var$exec(operators, values) {
    var _ref;
    var op = operators.pop();
    values.push(op.f.apply(op, (_ref = []).concat.apply(_ref, values.splice(-op.argCount))));
    return op.precedence;
}
function $e4334fe97365ceb5$var$calculate(expression, additionalSymbols) {
    var symbolMap = $e4334fe97365ceb5$var$mergeSymbolMaps(additionalSymbols);
    var match;
    var operators = [
        symbolMap.symbols["("].prefix
    ];
    var values = [];
    var pattern = new RegExp("\\d+(?:\\.\\d+)?|" + // ...and patterns for individual operators/function names
    Object.keys(symbolMap.symbols).map(function(key) {
        return symbolMap.symbols[key];
    })// longer symbols should be listed first
    // $FlowFixMe
    .sort(function(a, b) {
        return b.symbol.length - a.symbol.length;
    })// $FlowFixMe
    .map(function(val) {
        return val.regSymbol;
    }).join("|") + "|(\\S)", "g");
    pattern.lastIndex = 0; // Reset regular expression object
    var afterValue = false;
    do {
        match = pattern.exec(expression);
        var _ref2 = match || [
            ")",
            undefined
        ], token = _ref2[0], bad = _ref2[1];
        var notNumber = symbolMap.symbols[token];
        var notNewValue = notNumber && !notNumber.prefix && !notNumber.func;
        var notAfterValue = !notNumber || !notNumber.postfix && !notNumber.infix;
        // Check for syntax errors:
        if (bad || (afterValue ? notAfterValue : notNewValue)) throw new $e4334fe97365ceb5$var$PolishedError(37, match ? match.index : expression.length, expression);
        if (afterValue) {
            // We either have an infix or postfix operator (they should be mutually exclusive)
            var curr = notNumber.postfix || notNumber.infix;
            do {
                var prev = operators[operators.length - 1];
                if ((curr.precedence - prev.precedence || prev.rightToLeft) > 0) break;
            // Apply previous operator, since it has precedence over current one
            }while ($e4334fe97365ceb5$var$exec(operators, values)); // Exit loop after executing an opening parenthesis or function
            afterValue = curr.notation === "postfix";
            if (curr.symbol !== ")") {
                operators.push(curr);
                // Postfix always has precedence over any operator that follows after it
                if (afterValue) $e4334fe97365ceb5$var$exec(operators, values);
            }
        } else if (notNumber) {
            // prefix operator or function
            operators.push(notNumber.prefix || notNumber.func);
            if (notNumber.func) {
                // Require an opening parenthesis
                match = pattern.exec(expression);
                if (!match || match[0] !== "(") throw new $e4334fe97365ceb5$var$PolishedError(38, match ? match.index : expression.length, expression);
            }
        } else {
            // number
            values.push(+token);
            afterValue = true;
        }
    }while (match && operators.length);
    if (operators.length) throw new $e4334fe97365ceb5$var$PolishedError(39, match ? match.index : expression.length, expression);
    else if (match) throw new $e4334fe97365ceb5$var$PolishedError(40, match ? match.index : expression.length, expression);
    else return values.pop();
}
function $e4334fe97365ceb5$var$reverseString(str) {
    return str.split("").reverse().join("");
}
/**
 * Helper for doing math with CSS Units. Accepts a formula as a string. All values in the formula must have the same unit (or be unitless). Supports complex formulas utliziing addition, subtraction, multiplication, division, square root, powers, factorial, min, max, as well as parentheses for order of operation.
 *
 *In cases where you need to do calculations with mixed units where one unit is a [relative length unit](https://developer.mozilla.org/en-US/docs/Web/CSS/length#Relative_length_units), you will want to use [CSS Calc](https://developer.mozilla.org/en-US/docs/Web/CSS/calc).
 *
 * *warning* While we've done everything possible to ensure math safely evalutes formulas expressed as strings, you should always use extreme caution when passing `math` user provided values.
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: math('12rem + 8rem'),
 *   fontSize: math('(12px + 2px) * 3'),
 *   fontSize: math('3px^2 + sqrt(4)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${math('12rem + 8rem')};
 *   fontSize: ${math('(12px + 2px) * 3')};
 *   fontSize: ${math('3px^2 + sqrt(4)')};
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   fontSize: '20rem',
 *   fontSize: '42px',
 *   fontSize: '11px',
 * }
 */ function $e4334fe97365ceb5$export$1c891a3202c0ba6a(formula, additionalSymbols) {
    var reversedFormula = $e4334fe97365ceb5$var$reverseString(formula);
    var formulaMatch = reversedFormula.match($e4334fe97365ceb5$var$unitRegExp);
    // Check that all units are the same
    if (formulaMatch && !formulaMatch.every(function(unit) {
        return unit === formulaMatch[0];
    })) throw new $e4334fe97365ceb5$var$PolishedError(41);
    var cleanFormula = $e4334fe97365ceb5$var$reverseString(reversedFormula.replace($e4334fe97365ceb5$var$unitRegExp, ""));
    return "" + $e4334fe97365ceb5$var$calculate(cleanFormula, additionalSymbols) + (formulaMatch ? $e4334fe97365ceb5$var$reverseString(formulaMatch[0]) : "");
}
var $e4334fe97365ceb5$var$cssVariableRegex = /--[\S]*/g;
/**
 * Fetches the value of a passed CSS Variable in the :root scope, or otherwise returns a defaultValue if provided.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'background': cssVar('--background-color'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${cssVar('--background-color')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'background': 'red'
 * }
 */ function $e4334fe97365ceb5$export$8b4981022bd80a4e(cssVariable, defaultValue) {
    if (!cssVariable || !cssVariable.match($e4334fe97365ceb5$var$cssVariableRegex)) throw new $e4334fe97365ceb5$var$PolishedError(73);
    var variableValue;
    /* eslint-disable */ /* istanbul ignore next */ if (typeof document !== "undefined" && document.documentElement !== null) variableValue = getComputedStyle(document.documentElement).getPropertyValue(cssVariable);
    /* eslint-enable */ if (variableValue) return variableValue.trim();
    else if (defaultValue) return defaultValue;
    throw new $e4334fe97365ceb5$var$PolishedError(74);
}
// @private
function $e4334fe97365ceb5$var$capitalizeString(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $e4334fe97365ceb5$var$positionMap$1 = [
    "Top",
    "Right",
    "Bottom",
    "Left"
];
function $e4334fe97365ceb5$var$generateProperty(property, position) {
    if (!property) return position.toLowerCase();
    var splitProperty = property.split("-");
    if (splitProperty.length > 1) {
        splitProperty.splice(1, 0, position);
        return splitProperty.reduce(function(acc, val) {
            return "" + acc + $e4334fe97365ceb5$var$capitalizeString(val);
        });
    }
    var joinedProperty = property.replace(/([a-z])([A-Z])/g, "$1" + position + "$2");
    return property === joinedProperty ? "" + property + position : joinedProperty;
}
function $e4334fe97365ceb5$var$generateStyles(property, valuesWithDefaults) {
    var styles = {};
    for(var i = 0; i < valuesWithDefaults.length; i += 1)if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) styles[$e4334fe97365ceb5$var$generateProperty(property, $e4334fe97365ceb5$var$positionMap$1[i])] = valuesWithDefaults[i];
    return styles;
}
/**
 * Enables shorthand for direction-based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $e4334fe97365ceb5$export$4fc00c04dd60af95(property) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    //  prettier-ignore
    var firstValue = values[0], _values$ = values[1], secondValue = _values$ === void 0 ? firstValue : _values$, _values$2 = values[2], thirdValue = _values$2 === void 0 ? firstValue : _values$2, _values$3 = values[3], fourthValue = _values$3 === void 0 ? secondValue : _values$3;
    var valuesWithDefaults = [
        firstValue,
        secondValue,
        thirdValue,
        fourthValue
    ];
    return $e4334fe97365ceb5$var$generateStyles(property, valuesWithDefaults);
}
/**
 * Check if a string ends with something
 * @private
 */ function $e4334fe97365ceb5$var$endsWith(string, suffix) {
    return string.substr(-suffix.length) === suffix;
}
var $e4334fe97365ceb5$var$cssRegex$1 = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value minus its unit of measure.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */ function $e4334fe97365ceb5$export$ef04e38dc423904(value) {
    if (typeof value !== "string") return value;
    var matchedValue = value.match($e4334fe97365ceb5$var$cssRegex$1);
    return matchedValue ? parseFloat(value) : value;
}
/**
 * Factory function that creates pixel-to-x converters
 * @private
 */ var $e4334fe97365ceb5$var$pxtoFactory = function pxtoFactory(to) {
    return function(pxval, base) {
        if (base === void 0) base = "16px";
        var newPxval = pxval;
        var newBase = base;
        if (typeof pxval === "string") {
            if (!$e4334fe97365ceb5$var$endsWith(pxval, "px")) throw new $e4334fe97365ceb5$var$PolishedError(69, to, pxval);
            newPxval = $e4334fe97365ceb5$export$ef04e38dc423904(pxval);
        }
        if (typeof base === "string") {
            if (!$e4334fe97365ceb5$var$endsWith(base, "px")) throw new $e4334fe97365ceb5$var$PolishedError(70, to, base);
            newBase = $e4334fe97365ceb5$export$ef04e38dc423904(base);
        }
        if (typeof newPxval === "string") throw new $e4334fe97365ceb5$var$PolishedError(71, pxval, to);
        if (typeof newBase === "string") throw new $e4334fe97365ceb5$var$PolishedError(72, base, to);
        return "" + newPxval / newBase + to;
    };
};
var $e4334fe97365ceb5$var$pixelsto = $e4334fe97365ceb5$var$pxtoFactory;
/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */ var $e4334fe97365ceb5$var$em = $e4334fe97365ceb5$var$pixelsto("em");
var $e4334fe97365ceb5$export$c63c6f932822f543 = $e4334fe97365ceb5$var$em;
var $e4334fe97365ceb5$var$cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value and its unit as elements of an array.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': getValueAndUnit('100px')[0],
 *   '--unit': getValueAndUnit('100px')[1],
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${getValueAndUnit('100px')[0]};
 *   --unit: ${getValueAndUnit('100px')[1]};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100,
 *   '--unit': 'px',
 * }
 */ function $e4334fe97365ceb5$export$feec6b849ef388ab(value) {
    if (typeof value !== "string") return [
        value,
        ""
    ];
    var matchedValue = value.match($e4334fe97365ceb5$var$cssRegex);
    if (matchedValue) return [
        parseFloat(value),
        matchedValue[2]
    ];
    return [
        value,
        undefined
    ];
}
/**
 * Helper for targeting rules in a style block generated by polished modules that need !important-level specificity. Can optionally specify a rule (or rules) to target specific rules.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...important(cover())
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${important(cover())}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute !important',
 *   'top': '0 !important',
 *   'right: '0 !important',
 *   'bottom': '0 !important',
 *   'left: '0 !important'
 * }
 */ function $e4334fe97365ceb5$export$929888ab0c9f043c(styleBlock, rules) {
    if (typeof styleBlock !== "object" || styleBlock === null) throw new $e4334fe97365ceb5$var$PolishedError(75, typeof styleBlock);
    var newStyleBlock = {};
    Object.keys(styleBlock).forEach(function(key) {
        if (typeof styleBlock[key] === "object" && styleBlock[key] !== null) newStyleBlock[key] = $e4334fe97365ceb5$export$929888ab0c9f043c(styleBlock[key], rules);
        else if (!rules || rules && (rules === key || rules.indexOf(key) >= 0)) newStyleBlock[key] = styleBlock[key] + " !important";
        else newStyleBlock[key] = styleBlock[key];
    });
    return newStyleBlock;
}
var $e4334fe97365ceb5$var$ratioNames = {
    minorSecond: 1.067,
    majorSecond: 1.125,
    minorThird: 1.2,
    majorThird: 1.25,
    perfectFourth: 1.333,
    augFourth: 1.414,
    perfectFifth: 1.5,
    minorSixth: 1.6,
    goldenSection: 1.618,
    majorSixth: 1.667,
    minorSeventh: 1.778,
    majorSeventh: 1.875,
    octave: 2,
    majorTenth: 2.5,
    majorEleventh: 2.667,
    majorTwelfth: 3,
    doubleOctave: 4
};
function $e4334fe97365ceb5$var$getRatio(ratioName) {
    return $e4334fe97365ceb5$var$ratioNames[ratioName];
}
/**
 * Establish consistent measurements and spacial relationships throughout your projects by incrementing an em or rem value up or down a defined scale. We provide a list of commonly used scales as pre-defined variables.
 * @example
 * // Styles as object usage
 * const styles = {
 *    // Increment two steps up the default scale
 *   'fontSize': modularScale(2)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *    // Increment two steps up the default scale
 *   fontSize: ${modularScale(2)}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'fontSize': '1.77689em'
 * }
 */ function $e4334fe97365ceb5$export$c82a8a23c9e8bdb6(steps, base, ratio) {
    if (base === void 0) base = "1em";
    if (ratio === void 0) ratio = 1.333;
    if (typeof steps !== "number") throw new $e4334fe97365ceb5$var$PolishedError(42);
    if (typeof ratio === "string" && !$e4334fe97365ceb5$var$ratioNames[ratio]) throw new $e4334fe97365ceb5$var$PolishedError(43);
    var _ref = typeof base === "string" ? $e4334fe97365ceb5$export$feec6b849ef388ab(base) : [
        base,
        ""
    ], realBase = _ref[0], unit = _ref[1];
    var realRatio = typeof ratio === "string" ? $e4334fe97365ceb5$var$getRatio(ratio) : ratio;
    if (typeof realBase === "string") throw new $e4334fe97365ceb5$var$PolishedError(44, base);
    return "" + realBase * Math.pow(realRatio, steps) + (unit || "");
}
/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */ var $e4334fe97365ceb5$var$rem = $e4334fe97365ceb5$var$pixelsto("rem");
var $e4334fe97365ceb5$export$fb1897a40d146f7f = $e4334fe97365ceb5$var$rem;
var $e4334fe97365ceb5$var$defaultFontSize = 16;
function $e4334fe97365ceb5$var$convertBase(base) {
    var deconstructedValue = $e4334fe97365ceb5$export$feec6b849ef388ab(base);
    if (deconstructedValue[1] === "px") return parseFloat(base);
    if (deconstructedValue[1] === "%") return parseFloat(base) / 100 * $e4334fe97365ceb5$var$defaultFontSize;
    throw new $e4334fe97365ceb5$var$PolishedError(78, deconstructedValue[1]);
}
function $e4334fe97365ceb5$var$getBaseFromDoc() {
    /* eslint-disable */ /* istanbul ignore next */ if (typeof document !== "undefined" && document.documentElement !== null) {
        var rootFontSize = getComputedStyle(document.documentElement).fontSize;
        return rootFontSize ? $e4334fe97365ceb5$var$convertBase(rootFontSize) : $e4334fe97365ceb5$var$defaultFontSize;
    }
    /* eslint-enable */ /* istanbul ignore next */ return $e4334fe97365ceb5$var$defaultFontSize;
}
/**
 * Convert rem values to px. By default, the base value is pulled from the font-size property on the root element (if it is set in % or px). It defaults to 16px if not found on the root. You can also override the base value by providing your own base in % or px.
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': remToPx('1.6rem')
 *   'height': remToPx('1.6rem', '10px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${remToPx('1.6rem')}
 *   height: ${remToPx('1.6rem', '10px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '25.6px',
 *   'height': '16px',
 * }
 */ function $e4334fe97365ceb5$export$7e5d3caf0359a67a(value, base) {
    var deconstructedValue = $e4334fe97365ceb5$export$feec6b849ef388ab(value);
    if (deconstructedValue[1] !== "rem" && deconstructedValue[1] !== "") throw new $e4334fe97365ceb5$var$PolishedError(77, deconstructedValue[1]);
    var newBase = base ? $e4334fe97365ceb5$var$convertBase(base) : $e4334fe97365ceb5$var$getBaseFromDoc();
    return deconstructedValue[0] * newBase + "px";
}
var $e4334fe97365ceb5$var$functionsMap$3 = {
    back: "cubic-bezier(0.600, -0.280, 0.735, 0.045)",
    circ: "cubic-bezier(0.600,  0.040, 0.980, 0.335)",
    cubic: "cubic-bezier(0.550,  0.055, 0.675, 0.190)",
    expo: "cubic-bezier(0.950,  0.050, 0.795, 0.035)",
    quad: "cubic-bezier(0.550,  0.085, 0.680, 0.530)",
    quart: "cubic-bezier(0.895,  0.030, 0.685, 0.220)",
    quint: "cubic-bezier(0.755,  0.050, 0.855, 0.060)",
    sine: "cubic-bezier(0.470,  0.000, 0.745, 0.715)"
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeIn('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeIn('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */ function $e4334fe97365ceb5$export$929e5a82286172a6(functionName) {
    return $e4334fe97365ceb5$var$functionsMap$3[functionName.toLowerCase().trim()];
}
var $e4334fe97365ceb5$var$functionsMap$2 = {
    back: "cubic-bezier(0.680, -0.550, 0.265, 1.550)",
    circ: "cubic-bezier(0.785,  0.135, 0.150, 0.860)",
    cubic: "cubic-bezier(0.645,  0.045, 0.355, 1.000)",
    expo: "cubic-bezier(1.000,  0.000, 0.000, 1.000)",
    quad: "cubic-bezier(0.455,  0.030, 0.515, 0.955)",
    quart: "cubic-bezier(0.770,  0.000, 0.175, 1.000)",
    quint: "cubic-bezier(0.860,  0.000, 0.070, 1.000)",
    sine: "cubic-bezier(0.445,  0.050, 0.550, 0.950)"
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeInOut('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeInOut('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
 * }
 */ function $e4334fe97365ceb5$export$c07234257a03d5e9(functionName) {
    return $e4334fe97365ceb5$var$functionsMap$2[functionName.toLowerCase().trim()];
}
var $e4334fe97365ceb5$var$functionsMap$1 = {
    back: "cubic-bezier(0.175,  0.885, 0.320, 1.275)",
    cubic: "cubic-bezier(0.215,  0.610, 0.355, 1.000)",
    circ: "cubic-bezier(0.075,  0.820, 0.165, 1.000)",
    expo: "cubic-bezier(0.190,  1.000, 0.220, 1.000)",
    quad: "cubic-bezier(0.250,  0.460, 0.450, 0.940)",
    quart: "cubic-bezier(0.165,  0.840, 0.440, 1.000)",
    quint: "cubic-bezier(0.230,  1.000, 0.320, 1.000)",
    sine: "cubic-bezier(0.390,  0.575, 0.565, 1.000)"
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeOut('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeOut('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
 * }
 */ function $e4334fe97365ceb5$export$57636bb43b1ccbb0(functionName) {
    return $e4334fe97365ceb5$var$functionsMap$1[functionName.toLowerCase().trim()];
}
/**
 * Returns a CSS calc formula for linear interpolation of a property between two values. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px').
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: between('20px', '100px', '400px', '1000px'),
 *   fontSize: between('20px', '100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${between('20px', '100px', '400px', '1000px')};
 *   fontSize: ${between('20px', '100px')}
 * `
 *
 * // CSS as JS Output
 *
 * h1: {
 *   'fontSize': 'calc(-33.33333333333334px + 13.333333333333334vw)',
 *   'fontSize': 'calc(-9.090909090909093px + 9.090909090909092vw)'
 * }
 */ function $e4334fe97365ceb5$export$cf95c51b03f10bae(fromSize, toSize, minScreen, maxScreen) {
    if (minScreen === void 0) minScreen = "320px";
    if (maxScreen === void 0) maxScreen = "1200px";
    var _getValueAndUnit = $e4334fe97365ceb5$export$feec6b849ef388ab(fromSize), unitlessFromSize = _getValueAndUnit[0], fromSizeUnit = _getValueAndUnit[1];
    var _getValueAndUnit2 = $e4334fe97365ceb5$export$feec6b849ef388ab(toSize), unitlessToSize = _getValueAndUnit2[0], toSizeUnit = _getValueAndUnit2[1];
    var _getValueAndUnit3 = $e4334fe97365ceb5$export$feec6b849ef388ab(minScreen), unitlessMinScreen = _getValueAndUnit3[0], minScreenUnit = _getValueAndUnit3[1];
    var _getValueAndUnit4 = $e4334fe97365ceb5$export$feec6b849ef388ab(maxScreen), unitlessMaxScreen = _getValueAndUnit4[0], maxScreenUnit = _getValueAndUnit4[1];
    if (typeof unitlessMinScreen !== "number" || typeof unitlessMaxScreen !== "number" || !minScreenUnit || !maxScreenUnit || minScreenUnit !== maxScreenUnit) throw new $e4334fe97365ceb5$var$PolishedError(47);
    if (typeof unitlessFromSize !== "number" || typeof unitlessToSize !== "number" || fromSizeUnit !== toSizeUnit) throw new $e4334fe97365ceb5$var$PolishedError(48);
    if (fromSizeUnit !== minScreenUnit || toSizeUnit !== maxScreenUnit) throw new $e4334fe97365ceb5$var$PolishedError(76);
    var slope = (unitlessFromSize - unitlessToSize) / (unitlessMinScreen - unitlessMaxScreen);
    var base = unitlessToSize - slope * unitlessMaxScreen;
    return "calc(" + base.toFixed(2) + (fromSizeUnit || "") + " + " + (100 * slope).toFixed(2) + "vw)";
}
/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */ function $e4334fe97365ceb5$export$8c467e8859fdef13(parent) {
    var _ref;
    if (parent === void 0) parent = "&";
    var pseudoSelector = parent + "::after";
    return _ref = {}, _ref[pseudoSelector] = {
        clear: "both",
        content: '""',
        display: "table"
    }, _ref;
}
/**
 * CSS to fully cover an area. Can optionally be passed an offset to act as a "padding".
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...cover()
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${cover()}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute',
 *   'top': '0',
 *   'right: '0',
 *   'bottom': '0',
 *   'left: '0'
 * }
 */ function $e4334fe97365ceb5$export$4bdbf921f0c0fd8c(offset) {
    if (offset === void 0) offset = 0;
    return {
        position: "absolute",
        top: offset,
        right: offset,
        bottom: offset,
        left: offset
    };
}
/**
 * CSS to represent truncated text with an ellipsis. You can optionally pass a max-width and number of lines before truncating.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */ function $e4334fe97365ceb5$export$a5b94313d6908893(width, lines) {
    if (lines === void 0) lines = 1;
    var styles = {
        display: "inline-block",
        maxWidth: width || "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        wordWrap: "normal"
    };
    return lines > 1 ? (0, $2Jgqn.default)({}, styles, {
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: lines,
        display: "-webkit-box",
        whiteSpace: "normal"
    }) : styles;
}
function $e4334fe97365ceb5$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $e4334fe97365ceb5$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e4334fe97365ceb5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e4334fe97365ceb5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e4334fe97365ceb5$var$_arrayLikeToArray(o, minLen);
}
function $e4334fe97365ceb5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * Returns a set of media queries that resizes a property (or set of properties) between a provided fromSize and toSize. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px') to constrain the interpolation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...fluidRange(
 *    {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${fluidRange(
 *      {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   "@media (min-width: 1000px)": Object {
 *     "padding": "100px",
 *   },
 *   "@media (min-width: 400px)": Object {
 *     "padding": "calc(-33.33333333333334px + 13.333333333333334vw)",
 *   },
 *   "padding": "20px",
 * }
 */ function $e4334fe97365ceb5$export$de4c2ac00f6121cf(cssProp, minScreen, maxScreen) {
    if (minScreen === void 0) minScreen = "320px";
    if (maxScreen === void 0) maxScreen = "1200px";
    if (!Array.isArray(cssProp) && typeof cssProp !== "object" || cssProp === null) throw new $e4334fe97365ceb5$var$PolishedError(49);
    if (Array.isArray(cssProp)) {
        var mediaQueries = {};
        var fallbacks = {};
        for(var _iterator = $e4334fe97365ceb5$var$_createForOfIteratorHelperLoose(cssProp), _step; !(_step = _iterator()).done;){
            var _extends2, _extends3;
            var obj = _step.value;
            if (!obj.prop || !obj.fromSize || !obj.toSize) throw new $e4334fe97365ceb5$var$PolishedError(50);
            fallbacks[obj.prop] = obj.fromSize;
            mediaQueries["@media (min-width: " + minScreen + ")"] = (0, $2Jgqn.default)({}, mediaQueries["@media (min-width: " + minScreen + ")"], (_extends2 = {}, _extends2[obj.prop] = $e4334fe97365ceb5$export$cf95c51b03f10bae(obj.fromSize, obj.toSize, minScreen, maxScreen), _extends2));
            mediaQueries["@media (min-width: " + maxScreen + ")"] = (0, $2Jgqn.default)({}, mediaQueries["@media (min-width: " + maxScreen + ")"], (_extends3 = {}, _extends3[obj.prop] = obj.toSize, _extends3));
        }
        return (0, $2Jgqn.default)({}, fallbacks, mediaQueries);
    } else {
        var _ref, _ref2, _ref3;
        if (!cssProp.prop || !cssProp.fromSize || !cssProp.toSize) throw new $e4334fe97365ceb5$var$PolishedError(51);
        return _ref3 = {}, _ref3[cssProp.prop] = cssProp.fromSize, _ref3["@media (min-width: " + minScreen + ")"] = (_ref = {}, _ref[cssProp.prop] = $e4334fe97365ceb5$export$cf95c51b03f10bae(cssProp.fromSize, cssProp.toSize, minScreen, maxScreen), _ref), _ref3["@media (min-width: " + maxScreen + ")"] = (_ref2 = {}, _ref2[cssProp.prop] = cssProp.toSize, _ref2), _ref3;
    }
}
var $e4334fe97365ceb5$var$dataURIRegex = /^\s*data:([a-z]+\/[a-z-]+(;[a-z-]+=[a-z-]+)?)?(;charset=[a-z0-9-]+)?(;base64)?,[a-z0-9!$&',()*+,;=\-._~:@/?%\s]*\s*$/i;
var $e4334fe97365ceb5$var$formatHintMap = {
    woff: "woff",
    woff2: "woff2",
    ttf: "truetype",
    otf: "opentype",
    eot: "embedded-opentype",
    svg: "svg",
    svgz: "svg"
};
function $e4334fe97365ceb5$var$generateFormatHint(format, formatHint) {
    if (!formatHint) return "";
    return ' format("' + $e4334fe97365ceb5$var$formatHintMap[format] + '")';
}
function $e4334fe97365ceb5$var$isDataURI(fontFilePath) {
    return !!fontFilePath.replace(/\s+/g, " ").match($e4334fe97365ceb5$var$dataURIRegex);
}
function $e4334fe97365ceb5$var$generateFileReferences(fontFilePath, fileFormats, formatHint) {
    if ($e4334fe97365ceb5$var$isDataURI(fontFilePath)) return 'url("' + fontFilePath + '")' + $e4334fe97365ceb5$var$generateFormatHint(fileFormats[0], formatHint);
    var fileFontReferences = fileFormats.map(function(format) {
        return 'url("' + fontFilePath + "." + format + '")' + $e4334fe97365ceb5$var$generateFormatHint(format, formatHint);
    });
    return fileFontReferences.join(", ");
}
function $e4334fe97365ceb5$var$generateLocalReferences(localFonts) {
    var localFontReferences = localFonts.map(function(font) {
        return 'local("' + font + '")';
    });
    return localFontReferences.join(", ");
}
function $e4334fe97365ceb5$var$generateSources(fontFilePath, localFonts, fileFormats, formatHint) {
    var fontReferences = [];
    if (localFonts) fontReferences.push($e4334fe97365ceb5$var$generateLocalReferences(localFonts));
    if (fontFilePath) fontReferences.push($e4334fe97365ceb5$var$generateFileReferences(fontFilePath, fileFormats, formatHint));
    return fontReferences.join(", ");
}
/**
 * CSS for a @font-face declaration. Defaults to check for local copies of the font on the user's machine. You can disable this by passing `null` to localFonts.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro',
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * const GlobalStyle = createGlobalStyle`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro',
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */ function $e4334fe97365ceb5$export$566c6c2ff0443c7(_ref) {
    var fontFamily = _ref.fontFamily, fontFilePath = _ref.fontFilePath, fontStretch = _ref.fontStretch, fontStyle = _ref.fontStyle, fontVariant = _ref.fontVariant, fontWeight = _ref.fontWeight, _ref$fileFormats = _ref.fileFormats, fileFormats = _ref$fileFormats === void 0 ? [
        "eot",
        "woff2",
        "woff",
        "ttf",
        "svg"
    ] : _ref$fileFormats, _ref$formatHint = _ref.formatHint, formatHint = _ref$formatHint === void 0 ? false : _ref$formatHint, _ref$localFonts = _ref.localFonts, localFonts = _ref$localFonts === void 0 ? [
        fontFamily
    ] : _ref$localFonts, unicodeRange = _ref.unicodeRange, fontDisplay = _ref.fontDisplay, fontVariationSettings = _ref.fontVariationSettings, fontFeatureSettings = _ref.fontFeatureSettings;
    // Error Handling
    if (!fontFamily) throw new $e4334fe97365ceb5$var$PolishedError(55);
    if (!fontFilePath && !localFonts) throw new $e4334fe97365ceb5$var$PolishedError(52);
    if (localFonts && !Array.isArray(localFonts)) throw new $e4334fe97365ceb5$var$PolishedError(53);
    if (!Array.isArray(fileFormats)) throw new $e4334fe97365ceb5$var$PolishedError(54);
    var fontFaceDeclaration = {
        "@font-face": {
            fontFamily: fontFamily,
            src: $e4334fe97365ceb5$var$generateSources(fontFilePath, localFonts, fileFormats, formatHint),
            unicodeRange: unicodeRange,
            fontStretch: fontStretch,
            fontStyle: fontStyle,
            fontVariant: fontVariant,
            fontWeight: fontWeight,
            fontDisplay: fontDisplay,
            fontVariationSettings: fontVariationSettings,
            fontFeatureSettings: fontFeatureSettings
        }
    };
    // Removes undefined fields for cleaner css object.
    return JSON.parse(JSON.stringify(fontFaceDeclaration));
}
/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */ function $e4334fe97365ceb5$export$27bef6389954e24d() {
    return {
        textIndent: "101%",
        overflow: "hidden",
        whiteSpace: "nowrap"
    };
}
/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */ function $e4334fe97365ceb5$export$36e2157ae4e3cbdd() {
    return {
        border: "0",
        clip: "rect(0 0 0 0)",
        height: "1px",
        margin: "-1px",
        overflow: "hidden",
        padding: "0",
        position: "absolute",
        whiteSpace: "nowrap",
        width: "1px"
    };
}
/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */ function $e4334fe97365ceb5$export$e79006618d7c6cc3(ratio) {
    if (ratio === void 0) ratio = 1.3;
    return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}
function $e4334fe97365ceb5$var$constructGradientValue(literals) {
    var template = "";
    for(var _len = arguments.length, substitutions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)substitutions[_key - 1] = arguments[_key];
    for(var i = 0; i < literals.length; i += 1){
        template += literals[i];
        if (i === substitutions.length - 1 && substitutions[i]) {
            var definedValues = substitutions.filter(function(substitute) {
                return !!substitute;
            });
            // Adds leading coma if properties preceed color-stops
            if (definedValues.length > 1) {
                template = template.slice(0, -1);
                template += ", " + substitutions[i];
            // No trailing space if color-stops is the only param provided
            } else if (definedValues.length === 1) template += "" + substitutions[i];
        } else if (substitutions[i]) template += substitutions[i] + " ";
    }
    return template.trim();
}
var $e4334fe97365ceb5$var$_templateObject$1;
/**
 * CSS for declaring a linear gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#FFF',
 *   'backgroundImage': 'linear-gradient(to top right, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */ function $e4334fe97365ceb5$export$46def8197cf4dd4c(_ref) {
    var colorStops = _ref.colorStops, fallback = _ref.fallback, _ref$toDirection = _ref.toDirection, toDirection = _ref$toDirection === void 0 ? "" : _ref$toDirection;
    if (!colorStops || colorStops.length < 2) throw new $e4334fe97365ceb5$var$PolishedError(56);
    return {
        backgroundColor: fallback || colorStops[0].replace(/,\s+/g, ",").split(" ")[0].replace(/,(?=\S)/g, ", "),
        backgroundImage: $e4334fe97365ceb5$var$constructGradientValue($e4334fe97365ceb5$var$_templateObject$1 || ($e4334fe97365ceb5$var$_templateObject$1 = (0, $b828f41498135548$export$2e2bcd8739ae039)([
            "linear-gradient(",
            "",
            ")"
        ])), toDirection, colorStops.join(", ").replace(/,(?=\S)/g, ", "))
    };
}
/**
 * CSS to normalize abnormalities across browsers (normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * const GlobalStyle = createGlobalStyle`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */ function $e4334fe97365ceb5$export$a3295358bff77e() {
    var _ref;
    return [
        (_ref = {
            html: {
                lineHeight: "1.15",
                textSizeAdjust: "100%"
            },
            body: {
                margin: "0"
            },
            main: {
                display: "block"
            },
            h1: {
                fontSize: "2em",
                margin: "0.67em 0"
            },
            hr: {
                boxSizing: "content-box",
                height: "0",
                overflow: "visible"
            },
            pre: {
                fontFamily: "monospace, monospace",
                fontSize: "1em"
            },
            a: {
                backgroundColor: "transparent"
            },
            "abbr[title]": {
                borderBottom: "none",
                textDecoration: "underline"
            }
        }, _ref["b,\n    strong"] = {
            fontWeight: "bolder"
        }, _ref["code,\n    kbd,\n    samp"] = {
            fontFamily: "monospace, monospace",
            fontSize: "1em"
        }, _ref.small = {
            fontSize: "80%"
        }, _ref["sub,\n    sup"] = {
            fontSize: "75%",
            lineHeight: "0",
            position: "relative",
            verticalAlign: "baseline"
        }, _ref.sub = {
            bottom: "-0.25em"
        }, _ref.sup = {
            top: "-0.5em"
        }, _ref.img = {
            borderStyle: "none"
        }, _ref["button,\n    input,\n    optgroup,\n    select,\n    textarea"] = {
            fontFamily: "inherit",
            fontSize: "100%",
            lineHeight: "1.15",
            margin: "0"
        }, _ref["button,\n    input"] = {
            overflow: "visible"
        }, _ref["button,\n    select"] = {
            textTransform: "none"
        }, _ref['button,\n    html [type="button"],\n    [type="reset"],\n    [type="submit"]'] = {
            WebkitAppearance: "button"
        }, _ref['button::-moz-focus-inner,\n    [type="button"]::-moz-focus-inner,\n    [type="reset"]::-moz-focus-inner,\n    [type="submit"]::-moz-focus-inner'] = {
            borderStyle: "none",
            padding: "0"
        }, _ref['button:-moz-focusring,\n    [type="button"]:-moz-focusring,\n    [type="reset"]:-moz-focusring,\n    [type="submit"]:-moz-focusring'] = {
            outline: "1px dotted ButtonText"
        }, _ref.fieldset = {
            padding: "0.35em 0.625em 0.75em"
        }, _ref.legend = {
            boxSizing: "border-box",
            color: "inherit",
            display: "table",
            maxWidth: "100%",
            padding: "0",
            whiteSpace: "normal"
        }, _ref.progress = {
            verticalAlign: "baseline"
        }, _ref.textarea = {
            overflow: "auto"
        }, _ref['[type="checkbox"],\n    [type="radio"]'] = {
            boxSizing: "border-box",
            padding: "0"
        }, _ref['[type="number"]::-webkit-inner-spin-button,\n    [type="number"]::-webkit-outer-spin-button'] = {
            height: "auto"
        }, _ref['[type="search"]'] = {
            WebkitAppearance: "textfield",
            outlineOffset: "-2px"
        }, _ref['[type="search"]::-webkit-search-decoration'] = {
            WebkitAppearance: "none"
        }, _ref["::-webkit-file-upload-button"] = {
            WebkitAppearance: "button",
            font: "inherit"
        }, _ref.details = {
            display: "block"
        }, _ref.summary = {
            display: "list-item"
        }, _ref.template = {
            display: "none"
        }, _ref["[hidden]"] = {
            display: "none"
        }, _ref),
        {
            "abbr[title]": {
                textDecoration: "underline dotted"
            }
        }
    ];
}
var $e4334fe97365ceb5$var$_templateObject;
/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */ function $e4334fe97365ceb5$export$3922d1ccb8631cd8(_ref) {
    var colorStops = _ref.colorStops, _ref$extent = _ref.extent, extent = _ref$extent === void 0 ? "" : _ref$extent, fallback = _ref.fallback, _ref$position = _ref.position, position = _ref$position === void 0 ? "" : _ref$position, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? "" : _ref$shape;
    if (!colorStops || colorStops.length < 2) throw new $e4334fe97365ceb5$var$PolishedError(57);
    return {
        backgroundColor: fallback || colorStops[0].split(" ")[0],
        backgroundImage: $e4334fe97365ceb5$var$constructGradientValue($e4334fe97365ceb5$var$_templateObject || ($e4334fe97365ceb5$var$_templateObject = (0, $b828f41498135548$export$2e2bcd8739ae039)([
            "radial-gradient(",
            "",
            "",
            "",
            ")"
        ])), position, shape, extent, colorStops.join(", "))
    };
}
/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */ function $e4334fe97365ceb5$export$19389033401d366a(filename, backgroundSize, extension, retinaFilename, retinaSuffix) {
    var _ref;
    if (extension === void 0) extension = "png";
    if (retinaSuffix === void 0) retinaSuffix = "_2x";
    if (!filename) throw new $e4334fe97365ceb5$var$PolishedError(58);
    // Replace the dot at the beginning of the passed extension if one exists
    var ext = extension.replace(/^\./, "");
    var rFilename = retinaFilename ? retinaFilename + "." + ext : "" + filename + retinaSuffix + "." + ext;
    return _ref = {
        backgroundImage: "url(" + filename + "." + ext + ")"
    }, _ref[$e4334fe97365ceb5$export$e79006618d7c6cc3()] = (0, $2Jgqn.default)({
        backgroundImage: "url(" + rFilename + ")"
    }, backgroundSize ? {
        backgroundSize: backgroundSize
    } : {}), _ref;
}
/* eslint-disable key-spacing */ var $e4334fe97365ceb5$var$functionsMap = {
    easeInBack: "cubic-bezier(0.600, -0.280, 0.735, 0.045)",
    easeInCirc: "cubic-bezier(0.600,  0.040, 0.980, 0.335)",
    easeInCubic: "cubic-bezier(0.550,  0.055, 0.675, 0.190)",
    easeInExpo: "cubic-bezier(0.950,  0.050, 0.795, 0.035)",
    easeInQuad: "cubic-bezier(0.550,  0.085, 0.680, 0.530)",
    easeInQuart: "cubic-bezier(0.895,  0.030, 0.685, 0.220)",
    easeInQuint: "cubic-bezier(0.755,  0.050, 0.855, 0.060)",
    easeInSine: "cubic-bezier(0.470,  0.000, 0.745, 0.715)",
    easeOutBack: "cubic-bezier(0.175,  0.885, 0.320, 1.275)",
    easeOutCubic: "cubic-bezier(0.215,  0.610, 0.355, 1.000)",
    easeOutCirc: "cubic-bezier(0.075,  0.820, 0.165, 1.000)",
    easeOutExpo: "cubic-bezier(0.190,  1.000, 0.220, 1.000)",
    easeOutQuad: "cubic-bezier(0.250,  0.460, 0.450, 0.940)",
    easeOutQuart: "cubic-bezier(0.165,  0.840, 0.440, 1.000)",
    easeOutQuint: "cubic-bezier(0.230,  1.000, 0.320, 1.000)",
    easeOutSine: "cubic-bezier(0.390,  0.575, 0.565, 1.000)",
    easeInOutBack: "cubic-bezier(0.680, -0.550, 0.265, 1.550)",
    easeInOutCirc: "cubic-bezier(0.785,  0.135, 0.150, 0.860)",
    easeInOutCubic: "cubic-bezier(0.645,  0.045, 0.355, 1.000)",
    easeInOutExpo: "cubic-bezier(1.000,  0.000, 0.000, 1.000)",
    easeInOutQuad: "cubic-bezier(0.455,  0.030, 0.515, 0.955)",
    easeInOutQuart: "cubic-bezier(0.770,  0.000, 0.175, 1.000)",
    easeInOutQuint: "cubic-bezier(0.860,  0.000, 0.070, 1.000)",
    easeInOutSine: "cubic-bezier(0.445,  0.050, 0.550, 0.950)"
};
/* eslint-enable key-spacing */ function $e4334fe97365ceb5$var$getTimingFunction(functionName) {
    return $e4334fe97365ceb5$var$functionsMap[functionName];
}
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @deprecated - This will be deprecated in v5 in favor of `easeIn`, `easeOut`, `easeInOut`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': timingFunctions('easeInQuad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */ function $e4334fe97365ceb5$export$61210fa83792a81(timingFunction) {
    return $e4334fe97365ceb5$var$getTimingFunction(timingFunction);
}
var $e4334fe97365ceb5$var$getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
    var fullWidth = "" + width[0] + (width[1] || "");
    var halfWidth = "" + width[0] / 2 + (width[1] || "");
    var fullHeight = "" + height[0] + (height[1] || "");
    var halfHeight = "" + height[0] / 2 + (height[1] || "");
    switch(pointingDirection){
        case "top":
            return "0 " + halfWidth + " " + fullHeight + " " + halfWidth;
        case "topLeft":
            return fullWidth + " " + fullHeight + " 0 0";
        case "left":
            return halfHeight + " " + fullWidth + " " + halfHeight + " 0";
        case "bottomLeft":
            return fullWidth + " 0 0 " + fullHeight;
        case "bottom":
            return fullHeight + " " + halfWidth + " 0 " + halfWidth;
        case "bottomRight":
            return "0 0 " + fullWidth + " " + fullHeight;
        case "right":
            return halfHeight + " 0 " + halfHeight + " " + fullWidth;
        case "topRight":
        default:
            return "0 " + fullWidth + " " + fullHeight + " 0";
    }
};
var $e4334fe97365ceb5$var$getBorderColor = function getBorderColor(pointingDirection, foregroundColor) {
    switch(pointingDirection){
        case "top":
        case "bottomRight":
            return {
                borderBottomColor: foregroundColor
            };
        case "right":
        case "bottomLeft":
            return {
                borderLeftColor: foregroundColor
            };
        case "bottom":
        case "topLeft":
            return {
                borderTopColor: foregroundColor
            };
        case "left":
        case "topRight":
            return {
                borderRightColor: foregroundColor
            };
        default:
            throw new $e4334fe97365ceb5$var$PolishedError(59);
    }
};
/**
 * CSS to represent triangle with any pointing direction with an optional background color.
 *
 * @example
 * // Styles as object usage
 *
 * const styles = {
 *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
 * }
 *
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
 *
 *
 * // CSS as JS Output
 *
 * div: {
 *  'borderColor': 'transparent transparent transparent red',
 *  'borderStyle': 'solid',
 *  'borderWidth': '50px 0 50px 100px',
 *  'height': '0',
 *  'width': '0',
 * }
 */ function $e4334fe97365ceb5$export$9eed783d03e0135c(_ref) {
    var pointingDirection = _ref.pointingDirection, height = _ref.height, width = _ref.width, foregroundColor = _ref.foregroundColor, _ref$backgroundColor = _ref.backgroundColor, backgroundColor = _ref$backgroundColor === void 0 ? "transparent" : _ref$backgroundColor;
    var widthAndUnit = $e4334fe97365ceb5$export$feec6b849ef388ab(width);
    var heightAndUnit = $e4334fe97365ceb5$export$feec6b849ef388ab(height);
    if (isNaN(heightAndUnit[0]) || isNaN(widthAndUnit[0])) throw new $e4334fe97365ceb5$var$PolishedError(60);
    return (0, $2Jgqn.default)({
        width: "0",
        height: "0",
        borderColor: backgroundColor
    }, $e4334fe97365ceb5$var$getBorderColor(pointingDirection, foregroundColor), {
        borderStyle: "solid",
        borderWidth: $e4334fe97365ceb5$var$getBorderWidth(pointingDirection, heightAndUnit, widthAndUnit)
    });
}
/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */ function $e4334fe97365ceb5$export$dca3d8ad656c34d2(wrap) {
    if (wrap === void 0) wrap = "break-word";
    var wordBreak = wrap === "break-word" ? "break-all" : wrap;
    return {
        overflowWrap: wrap,
        wordWrap: wrap,
        wordBreak: wordBreak
    };
}
function $e4334fe97365ceb5$var$colorToInt(color) {
    return Math.round(color * 255);
}
function $e4334fe97365ceb5$var$convertToInt(red, green, blue) {
    return $e4334fe97365ceb5$var$colorToInt(red) + "," + $e4334fe97365ceb5$var$colorToInt(green) + "," + $e4334fe97365ceb5$var$colorToInt(blue);
}
function $e4334fe97365ceb5$var$hslToRgb(hue, saturation, lightness, convert) {
    if (convert === void 0) convert = $e4334fe97365ceb5$var$convertToInt;
    if (saturation === 0) // achromatic
    return convert(lightness, lightness, lightness);
    // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
    var huePrime = (hue % 360 + 360) % 360 / 60;
    var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
    var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    var red = 0;
    var green = 0;
    var blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    var lightnessModification = lightness - chroma / 2;
    var finalRed = red + lightnessModification;
    var finalGreen = green + lightnessModification;
    var finalBlue = blue + lightnessModification;
    return convert(finalRed, finalGreen, finalBlue);
}
var $e4334fe97365ceb5$var$namedColorMap = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "00ffff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "0000ff",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "00ffff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "ff00ff",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "639",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */ function $e4334fe97365ceb5$var$nameToHex(color) {
    if (typeof color !== "string") return color;
    var normalizedColorName = color.toLowerCase();
    return $e4334fe97365ceb5$var$namedColorMap[normalizedColorName] ? "#" + $e4334fe97365ceb5$var$namedColorMap[normalizedColorName] : color;
}
var $e4334fe97365ceb5$var$hexRegex = /^#[a-fA-F0-9]{6}$/;
var $e4334fe97365ceb5$var$hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var $e4334fe97365ceb5$var$reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var $e4334fe97365ceb5$var$reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var $e4334fe97365ceb5$var$rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i;
var $e4334fe97365ceb5$var$rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
var $e4334fe97365ceb5$var$hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var $e4334fe97365ceb5$var$hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */ function $e4334fe97365ceb5$export$2f48baff6995707a(color) {
    if (typeof color !== "string") throw new $e4334fe97365ceb5$var$PolishedError(3);
    var normalizedColor = $e4334fe97365ceb5$var$nameToHex(color);
    if (normalizedColor.match($e4334fe97365ceb5$var$hexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
        green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
        blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
    if (normalizedColor.match($e4334fe97365ceb5$var$hexRgbaRegex)) {
        var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
            green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
            blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
            alpha: alpha
        };
    }
    if (normalizedColor.match($e4334fe97365ceb5$var$reducedHexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
        green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
        blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
    if (normalizedColor.match($e4334fe97365ceb5$var$reducedRgbaHexRegex)) {
        var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
            green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
            blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
            alpha: _alpha
        };
    }
    var rgbMatched = $e4334fe97365ceb5$var$rgbRegex.exec(normalizedColor);
    if (rgbMatched) return {
        red: parseInt("" + rgbMatched[1], 10),
        green: parseInt("" + rgbMatched[2], 10),
        blue: parseInt("" + rgbMatched[3], 10)
    };
    var rgbaMatched = $e4334fe97365ceb5$var$rgbaRegex.exec(normalizedColor.substring(0, 50));
    if (rgbaMatched) return {
        red: parseInt("" + rgbaMatched[1], 10),
        green: parseInt("" + rgbaMatched[2], 10),
        blue: parseInt("" + rgbaMatched[3], 10),
        alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
    var hslMatched = $e4334fe97365ceb5$var$hslRegex.exec(normalizedColor);
    if (hslMatched) {
        var hue = parseInt("" + hslMatched[1], 10);
        var saturation = parseInt("" + hslMatched[2], 10) / 100;
        var lightness = parseInt("" + hslMatched[3], 10) / 100;
        var rgbColorString = "rgb(" + $e4334fe97365ceb5$var$hslToRgb(hue, saturation, lightness) + ")";
        var hslRgbMatched = $e4334fe97365ceb5$var$rgbRegex.exec(rgbColorString);
        if (!hslRgbMatched) throw new $e4334fe97365ceb5$var$PolishedError(4, normalizedColor, rgbColorString);
        return {
            red: parseInt("" + hslRgbMatched[1], 10),
            green: parseInt("" + hslRgbMatched[2], 10),
            blue: parseInt("" + hslRgbMatched[3], 10)
        };
    }
    var hslaMatched = $e4334fe97365ceb5$var$hslaRegex.exec(normalizedColor.substring(0, 50));
    if (hslaMatched) {
        var _hue = parseInt("" + hslaMatched[1], 10);
        var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
        var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
        var _rgbColorString = "rgb(" + $e4334fe97365ceb5$var$hslToRgb(_hue, _saturation, _lightness) + ")";
        var _hslRgbMatched = $e4334fe97365ceb5$var$rgbRegex.exec(_rgbColorString);
        if (!_hslRgbMatched) throw new $e4334fe97365ceb5$var$PolishedError(4, normalizedColor, _rgbColorString);
        return {
            red: parseInt("" + _hslRgbMatched[1], 10),
            green: parseInt("" + _hslRgbMatched[2], 10),
            blue: parseInt("" + _hslRgbMatched[3], 10),
            alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
        };
    }
    throw new $e4334fe97365ceb5$var$PolishedError(5);
}
function $e4334fe97365ceb5$var$rgbToHsl(color) {
    // make sure rgb are contained in a set of [0, 255]
    var red = color.red / 255;
    var green = color.green / 255;
    var blue = color.blue / 255;
    var max = Math.max(red, green, blue);
    var min = Math.min(red, green, blue);
    var lightness = (max + min) / 2;
    if (max === min) {
        // achromatic
        if (color.alpha !== undefined) return {
            hue: 0,
            saturation: 0,
            lightness: lightness,
            alpha: color.alpha
        };
        else return {
            hue: 0,
            saturation: 0,
            lightness: lightness
        };
    }
    var hue;
    var delta = max - min;
    var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
    switch(max){
        case red:
            hue = (green - blue) / delta + (green < blue ? 6 : 0);
            break;
        case green:
            hue = (blue - red) / delta + 2;
            break;
        default:
            // blue case
            hue = (red - green) / delta + 4;
            break;
    }
    hue *= 60;
    if (color.alpha !== undefined) return {
        hue: hue,
        saturation: saturation,
        lightness: lightness,
        alpha: color.alpha
    };
    return {
        hue: hue,
        saturation: saturation,
        lightness: lightness
    };
}
/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */ function $e4334fe97365ceb5$export$1286688e1b3fde9c(color) {
    // Note: At a later stage we can optimize this function as right now a hsl
    // color would be parsed converted to rgb values and converted back to hsl.
    return $e4334fe97365ceb5$var$rgbToHsl($e4334fe97365ceb5$export$2f48baff6995707a(color));
}
/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */ var $e4334fe97365ceb5$var$reduceHexValue = function reduceHexValue(value) {
    if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) return "#" + value[1] + value[3] + value[5];
    return value;
};
var $e4334fe97365ceb5$var$reduceHexValue$1 = $e4334fe97365ceb5$var$reduceHexValue;
function $e4334fe97365ceb5$var$numberToHex(value) {
    var hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
function $e4334fe97365ceb5$var$colorToHex(color) {
    return $e4334fe97365ceb5$var$numberToHex(Math.round(color * 255));
}
function $e4334fe97365ceb5$var$convertToHex(red, green, blue) {
    return $e4334fe97365ceb5$var$reduceHexValue$1("#" + $e4334fe97365ceb5$var$colorToHex(red) + $e4334fe97365ceb5$var$colorToHex(green) + $e4334fe97365ceb5$var$colorToHex(blue));
}
function $e4334fe97365ceb5$var$hslToHex(hue, saturation, lightness) {
    return $e4334fe97365ceb5$var$hslToRgb(hue, saturation, lightness, $e4334fe97365ceb5$var$convertToHex);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */ function $e4334fe97365ceb5$export$8f4a7c0bb78e6ea8(value, saturation, lightness) {
    if (typeof value === "number" && typeof saturation === "number" && typeof lightness === "number") return $e4334fe97365ceb5$var$hslToHex(value, saturation, lightness);
    else if (typeof value === "object" && saturation === undefined && lightness === undefined) return $e4334fe97365ceb5$var$hslToHex(value.hue, value.saturation, value.lightness);
    throw new $e4334fe97365ceb5$var$PolishedError(1);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */ function $e4334fe97365ceb5$export$810b04175080204c(value, saturation, lightness, alpha) {
    if (typeof value === "number" && typeof saturation === "number" && typeof lightness === "number" && typeof alpha === "number") return alpha >= 1 ? $e4334fe97365ceb5$var$hslToHex(value, saturation, lightness) : "rgba(" + $e4334fe97365ceb5$var$hslToRgb(value, saturation, lightness) + "," + alpha + ")";
    else if (typeof value === "object" && saturation === undefined && lightness === undefined && alpha === undefined) return value.alpha >= 1 ? $e4334fe97365ceb5$var$hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + $e4334fe97365ceb5$var$hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
    throw new $e4334fe97365ceb5$var$PolishedError(2);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */ function $e4334fe97365ceb5$export$8972dc0e6ad9238f(value, green, blue) {
    if (typeof value === "number" && typeof green === "number" && typeof blue === "number") return $e4334fe97365ceb5$var$reduceHexValue$1("#" + $e4334fe97365ceb5$var$numberToHex(value) + $e4334fe97365ceb5$var$numberToHex(green) + $e4334fe97365ceb5$var$numberToHex(blue));
    else if (typeof value === "object" && green === undefined && blue === undefined) return $e4334fe97365ceb5$var$reduceHexValue$1("#" + $e4334fe97365ceb5$var$numberToHex(value.red) + $e4334fe97365ceb5$var$numberToHex(value.green) + $e4334fe97365ceb5$var$numberToHex(value.blue));
    throw new $e4334fe97365ceb5$var$PolishedError(6);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */ function $e4334fe97365ceb5$export$4e46ac54fc82cf3b(firstValue, secondValue, thirdValue, fourthValue) {
    if (typeof firstValue === "string" && typeof secondValue === "number") {
        var rgbValue = $e4334fe97365ceb5$export$2f48baff6995707a(firstValue);
        return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
    } else if (typeof firstValue === "number" && typeof secondValue === "number" && typeof thirdValue === "number" && typeof fourthValue === "number") return fourthValue >= 1 ? $e4334fe97365ceb5$export$8972dc0e6ad9238f(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
    else if (typeof firstValue === "object" && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) return firstValue.alpha >= 1 ? $e4334fe97365ceb5$export$8972dc0e6ad9238f(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
    throw new $e4334fe97365ceb5$var$PolishedError(7);
}
var $e4334fe97365ceb5$var$isRgb = function isRgb(color) {
    return typeof color.red === "number" && typeof color.green === "number" && typeof color.blue === "number" && (typeof color.alpha !== "number" || typeof color.alpha === "undefined");
};
var $e4334fe97365ceb5$var$isRgba = function isRgba(color) {
    return typeof color.red === "number" && typeof color.green === "number" && typeof color.blue === "number" && typeof color.alpha === "number";
};
var $e4334fe97365ceb5$var$isHsl = function isHsl(color) {
    return typeof color.hue === "number" && typeof color.saturation === "number" && typeof color.lightness === "number" && (typeof color.alpha !== "number" || typeof color.alpha === "undefined");
};
var $e4334fe97365ceb5$var$isHsla = function isHsla(color) {
    return typeof color.hue === "number" && typeof color.saturation === "number" && typeof color.lightness === "number" && typeof color.alpha === "number";
};
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function $e4334fe97365ceb5$export$42fe740cdf79b2df(color) {
    if (typeof color !== "object") throw new $e4334fe97365ceb5$var$PolishedError(8);
    if ($e4334fe97365ceb5$var$isRgba(color)) return $e4334fe97365ceb5$export$4e46ac54fc82cf3b(color);
    if ($e4334fe97365ceb5$var$isRgb(color)) return $e4334fe97365ceb5$export$8972dc0e6ad9238f(color);
    if ($e4334fe97365ceb5$var$isHsla(color)) return $e4334fe97365ceb5$export$810b04175080204c(color);
    if ($e4334fe97365ceb5$var$isHsl(color)) return $e4334fe97365ceb5$export$8f4a7c0bb78e6ea8(color);
    throw new $e4334fe97365ceb5$var$PolishedError(8);
}
// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function $e4334fe97365ceb5$var$curried(f, length, acc) {
    return function fn() {
        // eslint-disable-next-line prefer-rest-params
        var combined = acc.concat(Array.prototype.slice.call(arguments));
        return combined.length >= length ? f.apply(this, combined) : $e4334fe97365ceb5$var$curried(f, length, combined);
    };
}
// eslint-disable-next-line no-redeclare
function $e4334fe97365ceb5$var$curry(f) {
    // eslint-disable-line no-redeclare
    return $e4334fe97365ceb5$var$curried(f, f.length, []);
}
/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated around
 * the color wheel, always producing a positive hue value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue('180', 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue('180', 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */ function $e4334fe97365ceb5$var$adjustHue(degree, color) {
    if (color === "transparent") return color;
    var hslColor = $e4334fe97365ceb5$export$1286688e1b3fde9c(color);
    return $e4334fe97365ceb5$export$42fe740cdf79b2df((0, $2Jgqn.default)({}, hslColor, {
        hue: hslColor.hue + parseFloat(degree)
    }));
}
// prettier-ignore
var $e4334fe97365ceb5$var$curriedAdjustHue = $e4334fe97365ceb5$var$curry /* ::<number | string, string, string> */ ($e4334fe97365ceb5$var$adjustHue);
var $e4334fe97365ceb5$export$2b372a09365374d6 = $e4334fe97365ceb5$var$curriedAdjustHue;
/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $e4334fe97365ceb5$export$bd4f6f7e1823bc9e(color) {
    if (color === "transparent") return color;
    var hslColor = $e4334fe97365ceb5$export$1286688e1b3fde9c(color);
    return $e4334fe97365ceb5$export$42fe740cdf79b2df((0, $2Jgqn.default)({}, hslColor, {
        hue: (hslColor.hue + 180) % 360
    }));
}
function $e4334fe97365ceb5$var$guard(lowerBoundary, upperBoundary, value) {
    return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */ function $e4334fe97365ceb5$var$darken(amount, color) {
    if (color === "transparent") return color;
    var hslColor = $e4334fe97365ceb5$export$1286688e1b3fde9c(color);
    return $e4334fe97365ceb5$export$42fe740cdf79b2df((0, $2Jgqn.default)({}, hslColor, {
        lightness: $e4334fe97365ceb5$var$guard(0, 1, hslColor.lightness - parseFloat(amount))
    }));
}
// prettier-ignore
var $e4334fe97365ceb5$var$curriedDarken = $e4334fe97365ceb5$var$curry /* ::<number | string, string, string> */ ($e4334fe97365ceb5$var$darken);
var $e4334fe97365ceb5$export$4b073707ff63303 = $e4334fe97365ceb5$var$curriedDarken;
/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */ function $e4334fe97365ceb5$var$desaturate(amount, color) {
    if (color === "transparent") return color;
    var hslColor = $e4334fe97365ceb5$export$1286688e1b3fde9c(color);
    return $e4334fe97365ceb5$export$42fe740cdf79b2df((0, $2Jgqn.default)({}, hslColor, {
        saturation: $e4334fe97365ceb5$var$guard(0, 1, hslColor.saturation - parseFloat(amount))
    }));
}
// prettier-ignore
var $e4334fe97365ceb5$var$curriedDesaturate = $e4334fe97365ceb5$var$curry /* ::<number | string, string, string> */ ($e4334fe97365ceb5$var$desaturate);
var $e4334fe97365ceb5$export$fb75607d98509d9 = $e4334fe97365ceb5$var$curriedDesaturate;
/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */ function $e4334fe97365ceb5$export$c852d90bf7403b62(color) {
    if (color === "transparent") return 0;
    var rgbColor = $e4334fe97365ceb5$export$2f48baff6995707a(color);
    var _Object$keys$map = Object.keys(rgbColor).map(function(key) {
        var channel = rgbColor[key] / 255;
        return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }), r = _Object$keys$map[0], g = _Object$keys$map[1], b = _Object$keys$map[2];
    return parseFloat((0.2126 * r + 0.7152 * g + 0.0722 * b).toFixed(3));
}
/**
 * Returns the contrast ratio between two colors based on
 * [W3's recommended equation for calculating contrast](http://www.w3.org/TR/WCAG20/#contrast-ratiodef).
 *
 * @example
 * const contrastRatio = getContrast('#444', '#fff');
 */ function $e4334fe97365ceb5$export$850ce485a60d103b(color1, color2) {
    var luminance1 = $e4334fe97365ceb5$export$c852d90bf7403b62(color1);
    var luminance2 = $e4334fe97365ceb5$export$c852d90bf7403b62(color2);
    return parseFloat((luminance1 > luminance2 ? (luminance1 + 0.05) / (luminance2 + 0.05) : (luminance2 + 0.05) / (luminance1 + 0.05)).toFixed(2));
}
/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $e4334fe97365ceb5$export$6f416a6db2dfcd5c(color) {
    if (color === "transparent") return color;
    return $e4334fe97365ceb5$export$42fe740cdf79b2df((0, $2Jgqn.default)({}, $e4334fe97365ceb5$export$1286688e1b3fde9c(color), {
        saturation: 0
    }));
}
/**
 * Converts a HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function $e4334fe97365ceb5$export$97fc773b219a4ae(color) {
    if (typeof color === "object" && typeof color.hue === "number" && typeof color.saturation === "number" && typeof color.lightness === "number") {
        if (color.alpha && typeof color.alpha === "number") return $e4334fe97365ceb5$export$810b04175080204c({
            hue: color.hue,
            saturation: color.saturation,
            lightness: color.lightness,
            alpha: color.alpha
        });
        return $e4334fe97365ceb5$export$8f4a7c0bb78e6ea8({
            hue: color.hue,
            saturation: color.saturation,
            lightness: color.lightness
        });
    }
    throw new $e4334fe97365ceb5$var$PolishedError(45);
}
/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */ function $e4334fe97365ceb5$export$6897c284b6f9f4dc(color) {
    if (color === "transparent") return color;
    // parse color string to rgb
    var value = $e4334fe97365ceb5$export$2f48baff6995707a(color);
    return $e4334fe97365ceb5$export$42fe740cdf79b2df((0, $2Jgqn.default)({}, value, {
        red: 255 - value.red,
        green: 255 - value.green,
        blue: 255 - value.blue
    }));
}
/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */ function $e4334fe97365ceb5$var$lighten(amount, color) {
    if (color === "transparent") return color;
    var hslColor = $e4334fe97365ceb5$export$1286688e1b3fde9c(color);
    return $e4334fe97365ceb5$export$42fe740cdf79b2df((0, $2Jgqn.default)({}, hslColor, {
        lightness: $e4334fe97365ceb5$var$guard(0, 1, hslColor.lightness + parseFloat(amount))
    }));
}
// prettier-ignore
var $e4334fe97365ceb5$var$curriedLighten = $e4334fe97365ceb5$var$curry /* ::<number | string, string, string> */ ($e4334fe97365ceb5$var$lighten);
var $e4334fe97365ceb5$export$c0816ed86df316af = $e4334fe97365ceb5$var$curriedLighten;
/**
 * Determines which contrast guidelines have been met for two colors.
 * Based on the [contrast calculations recommended by W3](https://www.w3.org/WAI/WCAG21/Understanding/contrast-enhanced.html).
 *
 * @example
 * const scores = meetsContrastGuidelines('#444', '#fff');
 */ function $e4334fe97365ceb5$export$bc0d548020bc5a2(color1, color2) {
    var contrastRatio = $e4334fe97365ceb5$export$850ce485a60d103b(color1, color2);
    return {
        AA: contrastRatio >= 4.5,
        AALarge: contrastRatio >= 3,
        AAA: contrastRatio >= 7,
        AAALarge: contrastRatio >= 4.5
    };
}
/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */ function $e4334fe97365ceb5$var$mix(weight, color, otherColor) {
    if (color === "transparent") return otherColor;
    if (otherColor === "transparent") return color;
    if (weight === 0) return otherColor;
    var parsedColor1 = $e4334fe97365ceb5$export$2f48baff6995707a(color);
    var color1 = (0, $2Jgqn.default)({}, parsedColor1, {
        alpha: typeof parsedColor1.alpha === "number" ? parsedColor1.alpha : 1
    });
    var parsedColor2 = $e4334fe97365ceb5$export$2f48baff6995707a(otherColor);
    var color2 = (0, $2Jgqn.default)({}, parsedColor2, {
        alpha: typeof parsedColor2.alpha === "number" ? parsedColor2.alpha : 1
    });
    // The formula is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
    var alphaDelta = color1.alpha - color2.alpha;
    var x = parseFloat(weight) * 2 - 1;
    var y = x * alphaDelta === -1 ? x : x + alphaDelta;
    var z = 1 + x * alphaDelta;
    var weight1 = (y / z + 1) / 2.0;
    var weight2 = 1 - weight1;
    var mixedColor = {
        red: Math.floor(color1.red * weight1 + color2.red * weight2),
        green: Math.floor(color1.green * weight1 + color2.green * weight2),
        blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
        alpha: color1.alpha * parseFloat(weight) + color2.alpha * (1 - parseFloat(weight))
    };
    return $e4334fe97365ceb5$export$4e46ac54fc82cf3b(mixedColor);
}
// prettier-ignore
var $e4334fe97365ceb5$var$curriedMix = $e4334fe97365ceb5$var$curry /* ::<number | string, string, string, string> */ ($e4334fe97365ceb5$var$mix);
var $e4334fe97365ceb5$export$2c9e8a9632a706b2 = $e4334fe97365ceb5$var$curriedMix;
/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify('0.5', 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify('0.5', 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */ function $e4334fe97365ceb5$var$opacify(amount, color) {
    if (color === "transparent") return color;
    var parsedColor = $e4334fe97365ceb5$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === "number" ? parsedColor.alpha : 1;
    var colorWithAlpha = (0, $2Jgqn.default)({}, parsedColor, {
        alpha: $e4334fe97365ceb5$var$guard(0, 1, (alpha * 100 + parseFloat(amount) * 100) / 100)
    });
    return $e4334fe97365ceb5$export$4e46ac54fc82cf3b(colorWithAlpha);
}
// prettier-ignore
var $e4334fe97365ceb5$var$curriedOpacify = $e4334fe97365ceb5$var$curry /* ::<number | string, string, string> */ ($e4334fe97365ceb5$var$opacify);
var $e4334fe97365ceb5$export$f4f50e3877dd0530 = $e4334fe97365ceb5$var$curriedOpacify;
var $e4334fe97365ceb5$var$defaultReturnIfLightColor = "#000";
var $e4334fe97365ceb5$var$defaultReturnIfDarkColor = "#fff";
/**
 * Returns black or white (or optional passed colors) for best
 * contrast depending on the luminosity of the given color.
 * When passing custom return colors, strict mode ensures that the
 * return color always meets or exceeds WCAG level AA or greater. If this test
 * fails, the default return color (black or white) is returned in place of the
 * custom return color. You can optionally turn off strict mode.
 *
 * Follows [W3C specs for readability](https://www.w3.org/TR/WCAG20-TECHS/G18.html).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('black', '#001', '#ff8'),
 *   color: readableColor('white', '#001', '#ff8'),
 *   color: readableColor('red', '#333', '#ddd', true)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('black', '#001', '#ff8')};
 *   color: ${readableColor('white', '#001', '#ff8')};
 *   color: ${readableColor('red', '#333', '#ddd', true)};
 * `
 *
 * // CSS in JS Output
 * element {
 *   color: "#fff";
 *   color: "#ff8";
 *   color: "#001";
 *   color: "#000";
 * }
 */ function $e4334fe97365ceb5$export$61654c1796c44811(color, returnIfLightColor, returnIfDarkColor, strict) {
    if (returnIfLightColor === void 0) returnIfLightColor = $e4334fe97365ceb5$var$defaultReturnIfLightColor;
    if (returnIfDarkColor === void 0) returnIfDarkColor = $e4334fe97365ceb5$var$defaultReturnIfDarkColor;
    if (strict === void 0) strict = true;
    var isColorLight = $e4334fe97365ceb5$export$c852d90bf7403b62(color) > 0.179;
    var preferredReturnColor = isColorLight ? returnIfLightColor : returnIfDarkColor;
    if (!strict || $e4334fe97365ceb5$export$850ce485a60d103b(color, preferredReturnColor) >= 4.5) return preferredReturnColor;
    return isColorLight ? $e4334fe97365ceb5$var$defaultReturnIfLightColor : $e4334fe97365ceb5$var$defaultReturnIfDarkColor;
}
/**
 * Converts a RgbColor or RgbaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb` or `rgba`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgbToColorString({ red: 255, green: 205, blue: 100 }),
 *   background: rgbToColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgbToColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${rgbToColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 * }
 */ function $e4334fe97365ceb5$export$34b0917fcca19deb(color) {
    if (typeof color === "object" && typeof color.red === "number" && typeof color.green === "number" && typeof color.blue === "number") {
        if (typeof color.alpha === "number") return $e4334fe97365ceb5$export$4e46ac54fc82cf3b({
            red: color.red,
            green: color.green,
            blue: color.blue,
            alpha: color.alpha
        });
        return $e4334fe97365ceb5$export$8972dc0e6ad9238f({
            red: color.red,
            green: color.green,
            blue: color.blue
        });
    }
    throw new $e4334fe97365ceb5$var$PolishedError(46);
}
/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */ function $e4334fe97365ceb5$var$saturate(amount, color) {
    if (color === "transparent") return color;
    var hslColor = $e4334fe97365ceb5$export$1286688e1b3fde9c(color);
    return $e4334fe97365ceb5$export$42fe740cdf79b2df((0, $2Jgqn.default)({}, hslColor, {
        saturation: $e4334fe97365ceb5$var$guard(0, 1, hslColor.saturation + parseFloat(amount))
    }));
}
// prettier-ignore
var $e4334fe97365ceb5$var$curriedSaturate = $e4334fe97365ceb5$var$curry /* ::<number | string, string, string> */ ($e4334fe97365ceb5$var$saturate);
var $e4334fe97365ceb5$export$5fcac96f5a87e3db = $e4334fe97365ceb5$var$curriedSaturate;
/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue('244', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue('244', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */ function $e4334fe97365ceb5$var$setHue(hue, color) {
    if (color === "transparent") return color;
    return $e4334fe97365ceb5$export$42fe740cdf79b2df((0, $2Jgqn.default)({}, $e4334fe97365ceb5$export$1286688e1b3fde9c(color), {
        hue: parseFloat(hue)
    }));
}
// prettier-ignore
var $e4334fe97365ceb5$var$curriedSetHue = $e4334fe97365ceb5$var$curry /* ::<number | string, string, string> */ ($e4334fe97365ceb5$var$setHue);
var $e4334fe97365ceb5$export$3bf58ce3e497a846 = $e4334fe97365ceb5$var$curriedSetHue;
/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */ function $e4334fe97365ceb5$var$setLightness(lightness, color) {
    if (color === "transparent") return color;
    return $e4334fe97365ceb5$export$42fe740cdf79b2df((0, $2Jgqn.default)({}, $e4334fe97365ceb5$export$1286688e1b3fde9c(color), {
        lightness: parseFloat(lightness)
    }));
}
// prettier-ignore
var $e4334fe97365ceb5$var$curriedSetLightness = $e4334fe97365ceb5$var$curry /* ::<number | string, string, string> */ ($e4334fe97365ceb5$var$setLightness);
var $e4334fe97365ceb5$export$7ef5d725337b805d = $e4334fe97365ceb5$var$curriedSetLightness;
/**
 * Sets the saturation of a color to the provided value. The saturation range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */ function $e4334fe97365ceb5$var$setSaturation(saturation, color) {
    if (color === "transparent") return color;
    return $e4334fe97365ceb5$export$42fe740cdf79b2df((0, $2Jgqn.default)({}, $e4334fe97365ceb5$export$1286688e1b3fde9c(color), {
        saturation: parseFloat(saturation)
    }));
}
// prettier-ignore
var $e4334fe97365ceb5$var$curriedSetSaturation = $e4334fe97365ceb5$var$curry /* ::<number | string, string, string> */ ($e4334fe97365ceb5$var$setSaturation);
var $e4334fe97365ceb5$export$b40fe421ea7a4f7e = $e4334fe97365ceb5$var$curriedSetSaturation;
/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */ function $e4334fe97365ceb5$var$shade(percentage, color) {
    if (color === "transparent") return color;
    return $e4334fe97365ceb5$export$2c9e8a9632a706b2(parseFloat(percentage), "rgb(0, 0, 0)", color);
}
// prettier-ignore
var $e4334fe97365ceb5$var$curriedShade = $e4334fe97365ceb5$var$curry /* ::<number | string, string, string> */ ($e4334fe97365ceb5$var$shade);
var $e4334fe97365ceb5$export$3e32adda0df4ef5d = $e4334fe97365ceb5$var$curriedShade;
/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */ function $e4334fe97365ceb5$var$tint(percentage, color) {
    if (color === "transparent") return color;
    return $e4334fe97365ceb5$export$2c9e8a9632a706b2(parseFloat(percentage), "rgb(255, 255, 255)", color);
}
// prettier-ignore
var $e4334fe97365ceb5$var$curriedTint = $e4334fe97365ceb5$var$curry /* ::<number | string, string, string> */ ($e4334fe97365ceb5$var$tint);
var $e4334fe97365ceb5$export$fc176dd65a27d98b = $e4334fe97365ceb5$var$curriedTint;
/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff'),
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')};
 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */ function $e4334fe97365ceb5$var$transparentize(amount, color) {
    if (color === "transparent") return color;
    var parsedColor = $e4334fe97365ceb5$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === "number" ? parsedColor.alpha : 1;
    var colorWithAlpha = (0, $2Jgqn.default)({}, parsedColor, {
        alpha: $e4334fe97365ceb5$var$guard(0, 1, +(alpha * 100 - parseFloat(amount) * 100).toFixed(2) / 100)
    });
    return $e4334fe97365ceb5$export$4e46ac54fc82cf3b(colorWithAlpha);
}
// prettier-ignore
var $e4334fe97365ceb5$var$curriedTransparentize = $e4334fe97365ceb5$var$curry /* ::<number | string, string, string> */ ($e4334fe97365ceb5$var$transparentize);
var $e4334fe97365ceb5$export$d11da87e55cc498f = $e4334fe97365ceb5$var$curriedTransparentize;
/**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */ function $e4334fe97365ceb5$export$ecad260a8a5fef4f() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    // Allow single or multiple animations passed
    var multiMode = Array.isArray(args[0]);
    if (!multiMode && args.length > 8) throw new $e4334fe97365ceb5$var$PolishedError(64);
    var code = args.map(function(arg) {
        if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) throw new $e4334fe97365ceb5$var$PolishedError(65);
        if (Array.isArray(arg) && arg.length > 8) throw new $e4334fe97365ceb5$var$PolishedError(66);
        return Array.isArray(arg) ? arg.join(" ") : arg;
    }).join(", ");
    return {
        animation: code
    };
}
/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */ function $e4334fe97365ceb5$export$c7de706fee81cfb4() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        backgroundImage: properties.join(", ")
    };
}
/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */ function $e4334fe97365ceb5$export$d041fef2b78b7906() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        background: properties.join(", ")
    };
}
var $e4334fe97365ceb5$var$sideMap = [
    "top",
    "right",
    "bottom",
    "left"
];
/**
 * Shorthand for the border property that splits out individual properties for use with tools like Fela and Styletron. A side keyword can optionally be passed to target only one side's border properties.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...border('1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderColor': 'red',
 *   'borderStyle': 'solid',
 *   'borderWidth': `1px`,
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...border('top', '1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('top', '1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderTopStyle': 'solid',
 *   'borderTopWidth': `1px`,
 * }
 */ function $e4334fe97365ceb5$export$1edee58a52776cd9(sideKeyword) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if (typeof sideKeyword === "string" && $e4334fe97365ceb5$var$sideMap.indexOf(sideKeyword) >= 0) {
        var _ref;
        return _ref = {}, _ref["border" + $e4334fe97365ceb5$var$capitalizeString(sideKeyword) + "Width"] = values[0], _ref["border" + $e4334fe97365ceb5$var$capitalizeString(sideKeyword) + "Style"] = values[1], _ref["border" + $e4334fe97365ceb5$var$capitalizeString(sideKeyword) + "Color"] = values[2], _ref;
    } else {
        values.unshift(sideKeyword);
        return {
            borderWidth: values[0],
            borderStyle: values[1],
            borderColor: values[2]
        };
    }
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */ function $e4334fe97365ceb5$export$e7fb0694ba2404fc() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $e4334fe97365ceb5$export$4fc00c04dd60af95.apply(void 0, [
        "borderColor"
    ].concat(values));
}
/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */ function $e4334fe97365ceb5$export$7a57f79000377ca2(side, radius) {
    var uppercaseSide = $e4334fe97365ceb5$var$capitalizeString(side);
    if (!radius && radius !== 0) throw new $e4334fe97365ceb5$var$PolishedError(62);
    if (uppercaseSide === "Top" || uppercaseSide === "Bottom") {
        var _ref;
        return _ref = {}, _ref["border" + uppercaseSide + "RightRadius"] = radius, _ref["border" + uppercaseSide + "LeftRadius"] = radius, _ref;
    }
    if (uppercaseSide === "Left" || uppercaseSide === "Right") {
        var _ref2;
        return _ref2 = {}, _ref2["borderTop" + uppercaseSide + "Radius"] = radius, _ref2["borderBottom" + uppercaseSide + "Radius"] = radius, _ref2;
    }
    throw new $e4334fe97365ceb5$var$PolishedError(63);
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */ function $e4334fe97365ceb5$export$4d0a7f76ad443516() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $e4334fe97365ceb5$export$4fc00c04dd60af95.apply(void 0, [
        "borderStyle"
    ].concat(values));
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */ function $e4334fe97365ceb5$export$12879c7697ed953d() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $e4334fe97365ceb5$export$4fc00c04dd60af95.apply(void 0, [
        "borderWidth"
    ].concat(values));
}
function $e4334fe97365ceb5$var$generateSelectors(template, state) {
    var stateSuffix = state ? ":" + state : "";
    return template(stateSuffix);
}
/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */ function $e4334fe97365ceb5$var$statefulSelectors(states, template, stateMap) {
    if (!template) throw new $e4334fe97365ceb5$var$PolishedError(67);
    if (states.length === 0) return $e4334fe97365ceb5$var$generateSelectors(template, null);
    var selectors = [];
    for(var i = 0; i < states.length; i += 1){
        if (stateMap && stateMap.indexOf(states[i]) < 0) throw new $e4334fe97365ceb5$var$PolishedError(68);
        selectors.push($e4334fe97365ceb5$var$generateSelectors(template, states[i]));
    }
    selectors = selectors.join(",");
    return selectors;
}
var $e4334fe97365ceb5$var$stateMap$1 = [
    undefined,
    null,
    "active",
    "focus",
    "hover"
];
function $e4334fe97365ceb5$var$template$1(state) {
    return "button" + state + ',\n  input[type="button"]' + state + ',\n  input[type="reset"]' + state + ',\n  input[type="submit"]' + state;
}
/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */ function $e4334fe97365ceb5$export$bbea856fdb3e3c5f() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $e4334fe97365ceb5$var$statefulSelectors(states, $e4334fe97365ceb5$var$template$1, $e4334fe97365ceb5$var$stateMap$1);
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */ function $e4334fe97365ceb5$export$7ede87f9b603dd3c() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $e4334fe97365ceb5$export$4fc00c04dd60af95.apply(void 0, [
        "margin"
    ].concat(values));
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $e4334fe97365ceb5$export$6f98e8eaf0be1996() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $e4334fe97365ceb5$export$4fc00c04dd60af95.apply(void 0, [
        "padding"
    ].concat(values));
}
var $e4334fe97365ceb5$var$positionMap = [
    "absolute",
    "fixed",
    "relative",
    "static",
    "sticky"
];
/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */ function $e4334fe97365ceb5$export$5880b8b5730aff45(firstValue) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if ($e4334fe97365ceb5$var$positionMap.indexOf(firstValue) >= 0 && firstValue) return (0, $2Jgqn.default)({}, $e4334fe97365ceb5$export$4fc00c04dd60af95.apply(void 0, [
        ""
    ].concat(values)), {
        position: firstValue
    });
    else return $e4334fe97365ceb5$export$4fc00c04dd60af95.apply(void 0, [
        "",
        firstValue
    ].concat(values));
}
/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */ function $e4334fe97365ceb5$export$346677f925de839c(height, width) {
    if (width === void 0) width = height;
    return {
        height: height,
        width: width
    };
}
var $e4334fe97365ceb5$var$stateMap = [
    undefined,
    null,
    "active",
    "focus",
    "hover"
];
function $e4334fe97365ceb5$var$template(state) {
    return 'input[type="color"]' + state + ',\n    input[type="date"]' + state + ',\n    input[type="datetime"]' + state + ',\n    input[type="datetime-local"]' + state + ',\n    input[type="email"]' + state + ',\n    input[type="month"]' + state + ',\n    input[type="number"]' + state + ',\n    input[type="password"]' + state + ',\n    input[type="search"]' + state + ',\n    input[type="tel"]' + state + ',\n    input[type="text"]' + state + ',\n    input[type="time"]' + state + ',\n    input[type="url"]' + state + ',\n    input[type="week"]' + state + ",\n    input:not([type])" + state + ",\n    textarea" + state;
}
/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */ function $e4334fe97365ceb5$export$baad927ee93ccf9c() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $e4334fe97365ceb5$var$statefulSelectors(states, $e4334fe97365ceb5$var$template, $e4334fe97365ceb5$var$stateMap);
}
/**
 * Accepts any number of transition values as parameters for creating a single transition statement. You may also pass an array of properties as the first parameter that you would like to apply the same transition values to (second parameter).
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s'),
 *   ...transitions(['color', 'background-color'], '2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')};
 *   ${transitions(['color', 'background-color'], '2.0s ease-in 2s'),};
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 *   'transition': 'color 2.0s ease-in 2s, background-color 2.0s ease-in 2s',
 * }
 */ function $e4334fe97365ceb5$export$622eca585e740ed5() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    if (Array.isArray(properties[0]) && properties.length === 2) {
        var value = properties[1];
        if (typeof value !== "string") throw new $e4334fe97365ceb5$var$PolishedError(61);
        var transitionsString = properties[0].map(function(property) {
            return property + " " + value;
        }).join(", ");
        return {
            transition: transitionsString
        };
    } else return {
        transition: properties.join(", ")
    };
}


/**
 * Curry the polished rgba function to allow switching the parameters.
 */ const $ecd1a6a8f958a3d3$var$_rgba = (alpha)=>(color)=>(0, $e4334fe97365ceb5$export$4e46ac54fc82cf3b)(color, alpha);
const $ecd1a6a8f958a3d3$var$colorPaletteSettings = [
    {
        code: "50",
        colorFn: (0, $e4334fe97365ceb5$export$fc176dd65a27d98b)(0.96)
    },
    {
        code: "50a",
        colorFn: $ecd1a6a8f958a3d3$var$_rgba(0.04)
    },
    {
        code: "100",
        colorFn: (0, $e4334fe97365ceb5$export$fc176dd65a27d98b)(0.92)
    },
    {
        code: "100a",
        colorFn: $ecd1a6a8f958a3d3$var$_rgba(0.08)
    },
    {
        code: "200",
        colorFn: (0, $e4334fe97365ceb5$export$fc176dd65a27d98b)(0.84)
    },
    {
        code: "200a",
        colorFn: $ecd1a6a8f958a3d3$var$_rgba(0.16)
    },
    {
        code: "300",
        colorFn: (0, $e4334fe97365ceb5$export$fc176dd65a27d98b)(0.68)
    },
    {
        code: "300a",
        colorFn: $ecd1a6a8f958a3d3$var$_rgba(0.32)
    },
    {
        code: "400",
        colorFn: (0, $e4334fe97365ceb5$export$fc176dd65a27d98b)(0.36)
    },
    {
        code: "400a",
        colorFn: $ecd1a6a8f958a3d3$var$_rgba(0.64)
    },
    {
        code: "500",
        colorFn: (v)=>v
    },
    {
        code: "600",
        colorFn: (0, $e4334fe97365ceb5$export$3e32adda0df4ef5d)(0.16)
    },
    {
        code: "700",
        colorFn: (0, $e4334fe97365ceb5$export$3e32adda0df4ef5d)(0.32)
    },
    {
        code: "800",
        colorFn: (0, $e4334fe97365ceb5$export$3e32adda0df4ef5d)(0.48)
    },
    {
        code: "900",
        colorFn: (0, $e4334fe97365ceb5$export$3e32adda0df4ef5d)(0.64)
    }
];
function $ecd1a6a8f958a3d3$export$e48ea82efb9e52cb(baseColor) {
    return $ecd1a6a8f958a3d3$var$colorPaletteSettings.reduce((acc, c)=>({
            ...acc,
            [c.code]: c.colorFn(baseColor)
        }), {});
}



const $9f3e244f4ad36284$var$primary = "#6A5ACD";
const $9f3e244f4ad36284$var$secondary = "#048A81";
const $9f3e244f4ad36284$var$base = (0, $e4334fe97365ceb5$export$b40fe421ea7a4f7e)(0.32, (0, $e4334fe97365ceb5$export$7ef5d725337b805d)(0.16, (0, $e4334fe97365ceb5$export$2b372a09365374d6)(48, $9f3e244f4ad36284$var$primary)));
const $9f3e244f4ad36284$var$theme = {
    colors: {
        primary: (0, $ecd1a6a8f958a3d3$export$e48ea82efb9e52cb)($9f3e244f4ad36284$var$primary),
        secondary: (0, $ecd1a6a8f958a3d3$export$e48ea82efb9e52cb)($9f3e244f4ad36284$var$secondary),
        base: (0, $ecd1a6a8f958a3d3$export$e48ea82efb9e52cb)($9f3e244f4ad36284$var$base),
        danger: (0, $ecd1a6a8f958a3d3$export$e48ea82efb9e52cb)("#FF5353"),
        warning: (0, $ecd1a6a8f958a3d3$export$e48ea82efb9e52cb)("#FFC849"),
        success: (0, $ecd1a6a8f958a3d3$export$e48ea82efb9e52cb)("#46D6CD"),
        info: (0, $ecd1a6a8f958a3d3$export$e48ea82efb9e52cb)("#1A5BDB"),
        surface: (0, $ecd1a6a8f958a3d3$export$e48ea82efb9e52cb)("#FFF"),
        gray: (0, $ecd1a6a8f958a3d3$export$e48ea82efb9e52cb)($9f3e244f4ad36284$var$base)
    },
    fonts: {
        body: "Inter",
        heading: "Inter"
    },
    fontSizes: {
        xs: "0.75rem",
        sm: "1rem",
        md: "1.25rem",
        lg: "1.5rem",
        xl: "1.75rem",
        "2xl": "2rem",
        "3xl": "2.25rem",
        "4xl": "2.5rem",
        "5xl": "2.75rem",
        "6xl": "3rem",
        "7xl": "3.25rem",
        "8xl": "3.5rem",
        "9xl": "3.75rem",
        "10xl": "4rem"
    },
    styles: {
        global: {
            body: {
                fontSize: "sm",
                color: "base.500",
                mW: "100vw",
                overflowX: "hidden"
            },
            "*": {
                lineHeight: "calc(0.5rem + 1em)"
            }
        }
    },
    textStyles: {
        lead: {
            sm: {
                fontSize: "md"
            },
            lg: {
                fontSize: "lg"
            }
        }
    },
    components: {
        Heading: {
            baseStyle: {
                fontWeight: "700"
            }
        },
        Link: {
            baseStyle: {
                color: "primary.500"
            }
        },
        Menu: {
            baseStyle: {
                item: {
                    _hover: {
                        textDecoration: "none !important"
                    }
                }
            }
        },
        FormLabel: {
            baseStyle: {
                fontSize: "sm"
            }
        },
        Card: {
            variants: {
                filled: {
                    container: {
                        background: "base.50"
                    }
                }
            }
        },
        Input: {
            variants: {
                outline: {
                    field: {
                        border: "2px solid"
                    }
                }
            }
        },
        Select: {
            variants: {
                outline: {
                    field: {
                        border: "2px solid"
                    }
                }
            }
        },
        Button: {
            baseStyle: {
                borderRadius: "md",
                fontWeight: "700",
                ":is(a):hover": {
                    textDecoration: "none"
                }
            },
            sizes: {
                xs: {
                    fontSize: "xs"
                },
                sm: {
                    fontSize: "xs"
                },
                md: {
                    fontSize: "sm"
                },
                lg: {
                    fontSize: "sm"
                }
            },
            variants: {
                outline: {
                    border: "2px solid",
                    ".chakra-button__group[data-attached][data-orientation=horizontal] > &:not(:last-of-type)": {
                        marginEnd: "-2px"
                    },
                    ".chakra-button__group[data-attached][data-orientation=vertical] > &:not(:last-of-type)": {
                        marginBottom: "-2px"
                    }
                },
                "soft-outline": (props)=>{
                    const { colorScheme: c } = props;
                    return {
                        border: "2px solid",
                        borderColor: `${c}.200`,
                        ".chakra-button__group[data-attached][data-orientation=horizontal] > &:not(:last-of-type)": {
                            marginEnd: "-2px"
                        },
                        ".chakra-button__group[data-attached][data-orientation=vertical] > &:not(:last-of-type)": {
                            marginBottom: "-2px"
                        },
                        _hover: {
                            bg: `${c}.50a`
                        },
                        _active: {
                            bg: `${c}.100a`
                        }
                    };
                }
            }
        }
    }
};
var $9f3e244f4ad36284$export$2e2bcd8739ae039 = (0, $5bade08afca30967$export$33a2b855d5b8731e)($9f3e244f4ad36284$var$theme);


const $aa58e4af7634fac0$var$configStructure = {
    collectionPlugins: [],
    itemPlugins: [],
    "ui:widget": {}
};
function $aa58e4af7634fac0$export$afcbd3cdfffb6e7c(...config) {
    return config.reduce((acc, c)=>{
        const { collectionPlugins: collectionPlugins = [], itemPlugins: itemPlugins = [], "ui:widget": uiWidget = {} } = c;
        return {
            collectionPlugins: [
                ...acc.collectionPlugins,
                ...collectionPlugins
            ],
            itemPlugins: [
                ...acc.itemPlugins,
                ...itemPlugins
            ],
            "ui:widget": {
                ...acc["ui:widget"],
                ...uiWidget
            }
        };
    }, $aa58e4af7634fac0$var$configStructure);
}




var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");

var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");

var $kxTYF = parcelRequire("kxTYF");







var $3lBLT = parcelRequire("3lBLT");
"use client";
const [$210fc61c9a876d6f$var$FormErrorStylesProvider, $210fc61c9a876d6f$export$13b57d826b8f5004] = (0, $3473b2b1e3b906ba$export$fd42f52fd3ae1109)({
    name: `FormErrorStylesContext`,
    errorMessage: `useFormErrorStyles returned is 'undefined'. Seems you forgot to wrap the components in "<FormError />" `
});
const $210fc61c9a876d6f$export$185a8afe504e8fca = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $c7d173d35275482d$export$31cdfe60c085d76f)("FormError", props);
    const ownProps = (0, $58ff34c9d17adf03$export$adfcf5a5e4d17785)(props);
    const field = (0, $02b238a4ba05f901$export$97a2352498389516)();
    if (!field?.isInvalid) return null;
    return /* @__PURE__ */ (0, $kxTYF.jsx)($210fc61c9a876d6f$var$FormErrorStylesProvider, {
        value: styles,
        children: /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
            ...field?.getErrorMessageProps(ownProps, ref),
            className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-form__error-message", props.className),
            __css: {
                display: "flex",
                alignItems: "center",
                ...styles.text
            }
        })
    });
});
$210fc61c9a876d6f$export$185a8afe504e8fca.displayName = "FormErrorMessage";
const $210fc61c9a876d6f$export$67864f4c98b1437d = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    const styles = $210fc61c9a876d6f$export$13b57d826b8f5004();
    const field = (0, $02b238a4ba05f901$export$97a2352498389516)();
    if (!field?.isInvalid) return null;
    const _className = (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-form__error-icon", props.className);
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $09b0bffb6a1e43af$export$f04a61298a47a40f), {
        ref: ref,
        "aria-hidden": true,
        ...props,
        __css: styles.icon,
        className: _className,
        children: /* @__PURE__ */ (0, $kxTYF.jsx)("path", {
            fill: "currentColor",
            d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
        })
    });
});
$210fc61c9a876d6f$export$67864f4c98b1437d.displayName = "FormErrorIcon";



var $jTKGQ = parcelRequire("jTKGQ");


const $02719087c988c832$var$identity = (v)=>v;
function $02719087c988c832$export$2a4b7b80ff003e13(props) {
    const { label: label, isDeletable: isDeletable, onDeleteClick: onDeleteClick, isDeleteDisabled: isDeleteDisabled, pointer: pointer, isRequired: isRequired, type: type, transformValue: transformValue = $02719087c988c832$var$identity } = props;
    const field = props.field;
    const fieldLabel = label || field.label;
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $jTKGQ.FastField), {
        name: pointer,
        children: ({ field: { value: value, onBlur: onBlur }, meta: meta, form: { setFieldValue: setFieldValue } })=>/*#__PURE__*/ (0, $kxTYF.jsxs)((0, $02b238a4ba05f901$export$fe5d99d8691b3f62), {
                isRequired: isRequired,
                isInvalid: meta.touched && meta.error ? true : false,
                children: [
                    /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                        gap: 4,
                        children: [
                            fieldLabel && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $2d2a7a8f479cc337$export$842aba50ed0ce9d7), {
                                children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8f2967926209c75b$export$1acdcf5a973a8414), {
                                    size: "xs",
                                    children: fieldLabel
                                })
                            }),
                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                                ml: "auto",
                                gap: 2,
                                children: isDeletable && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8f2967926209c75b$export$90c6246c969554fc), {
                                    "aria-label": "Remove item",
                                    onClick: onDeleteClick,
                                    icon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$5918e8962b6636e9), {
                                        size: 3
                                    }),
                                    isDisabled: isDeleteDisabled
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3d8cf0c200c5d2d0$export$f5b8910cec6cf069), {
                        type: type,
                        size: "sm",
                        name: pointer,
                        bg: "surface.500",
                        borderColor: "base.200",
                        borderRadius: "md",
                        value: value === null ? "" : value,
                        onBlur: onBlur,
                        onChange: (e)=>{
                            setFieldValue(pointer, transformValue(e.target.value));
                        }
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $210fc61c9a876d6f$export$185a8afe504e8fca), {
                        children: meta.error
                    })
                ]
            })
    });
}


function $17485d2c0739238f$export$b63d030f4611938c(props) {
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $02719087c988c832$export$2a4b7b80ff003e13), {
        ...props
    });
}



var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");


var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");

function $81cc9f2a42ee34ee$export$842a2cf37af977e1(a, n) {
    return (a % n + n) % n;
}
function $81cc9f2a42ee34ee$export$ebfdb425fb84a7c7(field, index) {
    const label = field.label === undefined ? "Item" : field.label;
    if (label === null) return null;
    if (typeof label === "string") {
        const n = index + 1;
        return {
            label: label,
            num: n,
            formatted: /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $kxTYF.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3963bf82c5559c75$export$5f1af8db9871e1d6), {
                        as: "span",
                        children: label
                    }),
                    " ",
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3963bf82c5559c75$export$5f1af8db9871e1d6), {
                        as: "small",
                        children: n <= 9 ? `0${n}` : n
                    })
                ]
            })
        };
    }
    const l = label[$81cc9f2a42ee34ee$export$842a2cf37af977e1(index, label.length)];
    return {
        label: l,
        num: null,
        formatted: l
    };
}
function $81cc9f2a42ee34ee$export$a0a81dc3380ce7d3(v) {
    const n = Number(v);
    return isNaN(n) ? null : n;
}
function $81cc9f2a42ee34ee$export$ff8cd4c6525ea2f6(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}


function $c0c33d699328ac6c$export$7833621d74bfe8fb(props) {
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $02719087c988c832$export$2a4b7b80ff003e13), {
        ...props,
        type: "number",
        transformValue: (0, $81cc9f2a42ee34ee$export$a0a81dc3380ce7d3)
    });
}



var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");

var $kxTYF = parcelRequire("kxTYF");

var $lA3d6 = parcelRequire("lA3d6");


var $kxTYF = parcelRequire("kxTYF");


var $8v0nu = parcelRequire("8v0nu");


var $fZQg5 = parcelRequire("fZQg5");

var $8v0nu = parcelRequire("8v0nu");
"use client";
function $8a4671c1e7a4a0b8$var$isInputEvent(value) {
    return value && (0, $fZQg5.isObject)(value) && (0, $fZQg5.isObject)(value.target);
}
function $8a4671c1e7a4a0b8$export$62b9571f283ff5c2(props = {}) {
    const { onChange: onChangeProp, value: valueProp, defaultValue: defaultValue, name: nameProp, isDisabled: isDisabled, isFocusable: isFocusable, isNative: isNative, ...htmlProps } = props;
    const [valueState, setValue] = (0, $8v0nu.useState)(defaultValue || "");
    const isControlled = typeof valueProp !== "undefined";
    const value = isControlled ? valueProp : valueState;
    const ref = (0, $8v0nu.useRef)(null);
    const focus = (0, $8v0nu.useCallback)(()=>{
        const rootNode = ref.current;
        if (!rootNode) return;
        let query = `input:not(:disabled):checked`;
        const firstEnabledAndCheckedInput = rootNode.querySelector(query);
        if (firstEnabledAndCheckedInput) {
            firstEnabledAndCheckedInput.focus();
            return;
        }
        query = `input:not(:disabled)`;
        const firstEnabledInput = rootNode.querySelector(query);
        firstEnabledInput?.focus();
    }, []);
    const uuid = (0, $8v0nu.useId)();
    const fallbackName = `radio-${uuid}`;
    const name = nameProp || fallbackName;
    const onChange = (0, $8v0nu.useCallback)((eventOrValue)=>{
        const nextValue = $8a4671c1e7a4a0b8$var$isInputEvent(eventOrValue) ? eventOrValue.target.value : eventOrValue;
        if (!isControlled) setValue(nextValue);
        onChangeProp?.(String(nextValue));
    }, [
        onChangeProp,
        isControlled
    ]);
    const getRootProps = (0, $8v0nu.useCallback)((props2 = {}, forwardedRef = null)=>({
            ...props2,
            ref: (0, $95f7db4ddbf3eda0$export$c9058316764c140e)(forwardedRef, ref),
            role: "radiogroup"
        }), []);
    const getRadioProps = (0, $8v0nu.useCallback)((props2 = {}, ref2 = null)=>{
        const checkedKey = isNative ? "checked" : "isChecked";
        return {
            ...props2,
            ref: ref2,
            name: name,
            [checkedKey]: value != null ? props2.value === value : void 0,
            onChange (event) {
                onChange(event);
            },
            "data-radiogroup": true
        };
    }, [
        isNative,
        name,
        onChange,
        value
    ]);
    return {
        getRootProps: getRootProps,
        getRadioProps: getRadioProps,
        name: name,
        ref: ref,
        focus: focus,
        setValue: setValue,
        value: value,
        onChange: onChange,
        isDisabled: isDisabled,
        isFocusable: isFocusable,
        htmlProps: htmlProps
    };
}




var $3lBLT = parcelRequire("3lBLT");
"use client";
const [$af7f31f27e6b9bae$var$RadioGroupProvider, $af7f31f27e6b9bae$export$7bea016dc7ad2ddf] = (0, $3473b2b1e3b906ba$export$fd42f52fd3ae1109)({
    name: "RadioGroupContext",
    strict: false
});
const $af7f31f27e6b9bae$export$a98f0dcb43a68a25 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    const { colorScheme: colorScheme, size: size, variant: variant, children: children, className: className, isDisabled: isDisabled, isFocusable: isFocusable, ...rest } = props;
    const { value: value, onChange: onChange, getRootProps: getRootProps, name: name, htmlProps: htmlProps } = (0, $8a4671c1e7a4a0b8$export$62b9571f283ff5c2)(rest);
    const group = (0, $8v0nu.useMemo)(()=>({
            name: name,
            size: size,
            onChange: onChange,
            colorScheme: colorScheme,
            value: value,
            variant: variant,
            isDisabled: isDisabled,
            isFocusable: isFocusable
        }), [
        name,
        size,
        onChange,
        colorScheme,
        value,
        variant,
        isDisabled,
        isFocusable
    ]);
    return /* @__PURE__ */ (0, $kxTYF.jsx)($af7f31f27e6b9bae$var$RadioGroupProvider, {
        value: group,
        children: /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
            ...getRootProps(htmlProps, ref),
            className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-radio-group", className),
            children: children
        })
    });
});
$af7f31f27e6b9bae$export$a98f0dcb43a68a25.displayName = "RadioGroup";



// src/index.ts
// src/attrs.ts
var $47270bc1d198d885$export$5cc3b7b83e34ade7 = (guard)=>{
    return guard ? "" : void 0;
};
var $47270bc1d198d885$export$91a6105db3d4be7b = (guard)=>{
    return guard ? "true" : void 0;
};
// src/is-html-element.ts
var $47270bc1d198d885$export$1b3bfaa9684536aa = (v)=>typeof v === "object" && v?.nodeType === Node.ELEMENT_NODE && typeof v?.nodeName === "string";
// src/contains.ts
function $47270bc1d198d885$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    if (!$47270bc1d198d885$export$1b3bfaa9684536aa(parent) || !$47270bc1d198d885$export$1b3bfaa9684536aa(child)) return false;
    return parent === child || parent.contains(child);
}
var $47270bc1d198d885$export$245b4e23316e2551 = (event)=>$47270bc1d198d885$export$2344b14b097df817(event.currentTarget, event.target);
// src/create-scope.ts
var $47270bc1d198d885$var$getDocument = (node)=>{
    if (node.nodeType === Node.DOCUMENT_NODE) return node;
    return node.ownerDocument ?? document;
};
function $47270bc1d198d885$export$41a9651decfe2bde(methods) {
    const screen = {
        getRootNode: (ctx)=>ctx.getRootNode?.() ?? document,
        getDoc: (ctx)=>$47270bc1d198d885$var$getDocument(screen.getRootNode(ctx)),
        getWin: (ctx)=>screen.getDoc(ctx).defaultView ?? window,
        getActiveElement: (ctx)=>screen.getDoc(ctx).activeElement,
        isActiveElement: (ctx, elem)=>elem === screen.getActiveElement(ctx),
        focus (ctx, elem) {
            if (elem == null) return;
            if (!screen.isActiveElement(ctx, elem)) elem.focus({
                preventScroll: true
            });
        },
        getById: (ctx, id)=>screen.getRootNode(ctx).getElementById(id),
        setValue: (elem, value)=>{
            if (elem == null || value == null) return;
            const valueAsString = value.toString();
            if (elem.value === valueAsString) return;
            elem.value = value.toString();
        }
    };
    return {
        ...screen,
        ...methods
    };
}
// src/is-document.ts
var $47270bc1d198d885$var$isDocument = (el)=>el.nodeType === Node.DOCUMENT_NODE;
// src/is-shadow-root.ts
var $47270bc1d198d885$var$isNode = (el)=>el.nodeType !== void 0;
var $47270bc1d198d885$var$isShadowRoot = (el)=>el && $47270bc1d198d885$var$isNode(el) && el.nodeType === Node.DOCUMENT_FRAGMENT_NODE && "host" in el;
// src/env.ts
function $47270bc1d198d885$export$f65ca476c09acec0(el) {
    if ($47270bc1d198d885$var$isDocument(el)) return el;
    return el?.ownerDocument ?? document;
}
function $47270bc1d198d885$export$38b2d434cce3ea22(el) {
    if ($47270bc1d198d885$var$isShadowRoot(el)) return $47270bc1d198d885$export$38b2d434cce3ea22(el.host);
    if ($47270bc1d198d885$var$isDocument(el)) return el.defaultView ?? window;
    if ($47270bc1d198d885$export$1b3bfaa9684536aa(el)) return el.ownerDocument?.defaultView ?? window;
    return window;
}
// src/get-active-element.ts
function $47270bc1d198d885$export$cd4e5573fbe2b576(el) {
    let activeElement = el.ownerDocument.activeElement;
    while(activeElement?.shadowRoot){
        const el2 = activeElement.shadowRoot.activeElement;
        if (el2 === activeElement) break;
        else activeElement = el2;
    }
    return activeElement;
}
// src/get-before-input-value.ts
function $47270bc1d198d885$export$28ed887a50e27461(event) {
    const { selectionStart: selectionStart, selectionEnd: selectionEnd, value: value } = event.currentTarget;
    return value.slice(0, selectionStart) + event.data + value.slice(selectionEnd);
}
// src/get-by-id.ts
function $47270bc1d198d885$export$9c576e34c0103ac9(v, id) {
    return v.find((node)=>node.id === id);
}
function $47270bc1d198d885$export$b3919dc3604f191c(v, id) {
    const item = $47270bc1d198d885$export$9c576e34c0103ac9(v, id);
    return item ? v.indexOf(item) : -1;
}
function $47270bc1d198d885$export$f3d559454b8c0d00(v, id, loop = true) {
    let idx = $47270bc1d198d885$export$b3919dc3604f191c(v, id);
    idx = loop ? (idx + 1) % v.length : Math.min(idx + 1, v.length - 1);
    return v[idx];
}
function $47270bc1d198d885$export$326274ae311c62fd(v, id, loop = true) {
    let idx = $47270bc1d198d885$export$b3919dc3604f191c(v, id);
    if (idx === -1) return loop ? v[v.length - 1] : null;
    idx = loop ? (idx - 1 + v.length) % v.length : Math.max(0, idx - 1);
    return v[idx];
}
// src/get-by-text.ts
var $47270bc1d198d885$var$getValueText = (item)=>item.dataset.valuetext ?? item.textContent ?? "";
var $47270bc1d198d885$var$match = (valueText, query2)=>valueText.trim().toLowerCase().startsWith(query2.toLowerCase());
var $47270bc1d198d885$var$wrap = (v, idx)=>{
    return v.map((_, index)=>v[(Math.max(idx, 0) + index) % v.length]);
};
function $47270bc1d198d885$export$cade8123d3662a60(v, text, currentId) {
    const index = currentId ? $47270bc1d198d885$export$b3919dc3604f191c(v, currentId) : -1;
    let items = currentId ? $47270bc1d198d885$var$wrap(v, index) : v;
    const isSingleKey = text.length === 1;
    if (isSingleKey) items = items.filter((item)=>item.id !== currentId);
    return items.find((item)=>$47270bc1d198d885$var$match($47270bc1d198d885$var$getValueText(item), text));
}
// src/get-by-typeahead.ts
function $47270bc1d198d885$var$getByTypeaheadImpl(_items, options) {
    const { state: state, activeId: activeId, key: key, timeout: timeout = 350 } = options;
    const search = state.keysSoFar + key;
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
    const query2 = isRepeated ? search[0] : search;
    let items = _items.slice();
    const next = $47270bc1d198d885$export$cade8123d3662a60(items, query2, activeId);
    function cleanup() {
        clearTimeout(state.timer);
        state.timer = -1;
    }
    function update(value) {
        state.keysSoFar = value;
        cleanup();
        if (value !== "") state.timer = +setTimeout(()=>{
            update("");
            cleanup();
        }, timeout);
    }
    update(search);
    return next;
}
var $47270bc1d198d885$export$ec2dfd1ac255c804 = /* @__PURE__ */ Object.assign($47270bc1d198d885$var$getByTypeaheadImpl, {
    defaultOptions: {
        keysSoFar: "",
        timer: -1
    },
    isValidEvent: $47270bc1d198d885$var$isValidTypeaheadEvent
});
function $47270bc1d198d885$var$isValidTypeaheadEvent(event) {
    return event.key.length === 1 && !event.ctrlKey && !event.metaKey;
}
// src/get-computed-style.ts
var $47270bc1d198d885$var$styleCache = /* @__PURE__ */ new WeakMap();
function $47270bc1d198d885$export$3735103072e4a80(el) {
    if (!$47270bc1d198d885$var$styleCache.has(el)) {
        const win = el.ownerDocument.defaultView || window;
        $47270bc1d198d885$var$styleCache.set(el, win.getComputedStyle(el));
    }
    return $47270bc1d198d885$var$styleCache.get(el);
}
// src/get-event-target.ts
function $47270bc1d198d885$export$e58f029f0fbfdb29(event) {
    return event.composedPath?.()[0] ?? event.target;
}
// src/get-scroll-parent.ts
function $47270bc1d198d885$var$isScrollParent(el) {
    const win = el.ownerDocument.defaultView || window;
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY } = win.getComputedStyle(el);
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function $47270bc1d198d885$export$58081aedf094d85b(el) {
    if (el.localName === "html") return el;
    return el.assignedSlot || el.parentElement || el.ownerDocument.documentElement;
}
function $47270bc1d198d885$export$cfa2225e87938781(el) {
    if ([
        "html",
        "body",
        "#document"
    ].includes(el.localName)) return el.ownerDocument.body;
    if ($47270bc1d198d885$export$1b3bfaa9684536aa(el) && $47270bc1d198d885$var$isScrollParent(el)) return el;
    return $47270bc1d198d885$export$cfa2225e87938781($47270bc1d198d885$export$58081aedf094d85b(el));
}
function $47270bc1d198d885$export$94ed1c92c7beeb22(el, list = []) {
    const parent = $47270bc1d198d885$export$cfa2225e87938781(el);
    const isBody = parent === el.ownerDocument.body;
    const win = parent.ownerDocument.defaultView || window;
    const target = isBody ? [
        win
    ].concat(win.visualViewport || [], $47270bc1d198d885$var$isScrollParent(parent) ? parent : []) : parent;
    const parents = list.concat(target);
    return isBody ? parents : parents.concat($47270bc1d198d885$export$94ed1c92c7beeb22($47270bc1d198d885$export$58081aedf094d85b(target)));
}
// src/is-editable-element.ts
function $47270bc1d198d885$export$2780cb57de98fa3a(el) {
    if (el == null || !$47270bc1d198d885$export$1b3bfaa9684536aa(el)) return false;
    try {
        const win = el.ownerDocument.defaultView || window;
        return el instanceof win.HTMLInputElement && el.selectionStart != null || /(textarea|select)/.test(el.localName) || el.isContentEditable;
    } catch  {
        return false;
    }
}
// src/platform.ts
var $47270bc1d198d885$export$9f57505b7bd8dae = ()=>typeof document !== "undefined";
function $47270bc1d198d885$export$867a782338812cb4() {
    const agent = navigator.userAgentData;
    return agent?.platform ?? navigator.platform;
}
var $47270bc1d198d885$var$pt = (v)=>$47270bc1d198d885$export$9f57505b7bd8dae() && v.test($47270bc1d198d885$export$867a782338812cb4());
var $47270bc1d198d885$var$ua = (v)=>$47270bc1d198d885$export$9f57505b7bd8dae() && v.test(navigator.userAgent);
var $47270bc1d198d885$var$vn = (v)=>$47270bc1d198d885$export$9f57505b7bd8dae() && v.test(navigator.vendor);
var $47270bc1d198d885$export$a1d0d20ee9546562 = ()=>$47270bc1d198d885$export$9f57505b7bd8dae() && !!navigator.maxTouchPoints;
var $47270bc1d198d885$export$9ac100e40613ea10 = ()=>$47270bc1d198d885$var$pt(/^Mac/) && !$47270bc1d198d885$export$a1d0d20ee9546562();
var $47270bc1d198d885$export$186c6964ca17d99 = ()=>$47270bc1d198d885$var$pt(/^iPhone/);
var $47270bc1d198d885$export$95df08bae54cb4df = ()=>$47270bc1d198d885$export$5231b1f790f5c149() && $47270bc1d198d885$var$vn(/apple/i);
var $47270bc1d198d885$export$b7d78993b74f766d = ()=>$47270bc1d198d885$var$ua(/firefox\//i);
var $47270bc1d198d885$export$5231b1f790f5c149 = ()=>$47270bc1d198d885$var$pt(/mac|iphone|ipad|ipod/i);
var $47270bc1d198d885$export$41a665f744414057 = ()=>$47270bc1d198d885$export$5231b1f790f5c149() && !$47270bc1d198d885$export$9ac100e40613ea10();
// src/query.ts
function $47270bc1d198d885$export$dcd0d083aa86c355(root, selector) {
    return Array.from(root?.querySelectorAll(selector) ?? []);
}
function $47270bc1d198d885$export$2fa187e846a241c4(root, selector) {
    return root?.querySelector(selector);
}
// src/raf.ts
function $47270bc1d198d885$export$bdd553fddd433dcb(fn) {
    const set = /* @__PURE__ */ new Set();
    function raf2(fn2) {
        const id = globalThis.requestAnimationFrame(fn2);
        set.add(()=>globalThis.cancelAnimationFrame(id));
    }
    raf2(()=>raf2(fn));
    return function cleanup() {
        set.forEach((fn2)=>fn2());
    };
}
function $47270bc1d198d885$export$27f233d61a9e2fa4(fn) {
    const id = globalThis.requestAnimationFrame(fn);
    return ()=>{
        globalThis.cancelAnimationFrame(id);
    };
}
// src/index.ts
var $47270bc1d198d885$export$e2f9a725ee199e81 = 2147483647;


var $855e001ba27d7a0a$var$hasSetup = false;
var $855e001ba27d7a0a$var$modality = null;
var $855e001ba27d7a0a$var$hasEventBeforeFocus = false;
var $855e001ba27d7a0a$var$hasBlurredWindowRecently = false;
var $855e001ba27d7a0a$var$handlers = /* @__PURE__ */ new Set();
function $855e001ba27d7a0a$var$trigger(modality2, event) {
    $855e001ba27d7a0a$var$handlers.forEach((handler)=>handler(modality2, event));
}
var $855e001ba27d7a0a$var$isMac = typeof window !== "undefined" && window.navigator != null ? /^Mac/.test(window.navigator.platform) : false;
function $855e001ba27d7a0a$var$isValidKey(e) {
    return !(e.metaKey || !$855e001ba27d7a0a$var$isMac && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $855e001ba27d7a0a$var$onKeyboardEvent(event) {
    $855e001ba27d7a0a$var$hasEventBeforeFocus = true;
    if ($855e001ba27d7a0a$var$isValidKey(event)) {
        $855e001ba27d7a0a$var$modality = "keyboard";
        $855e001ba27d7a0a$var$trigger("keyboard", event);
    }
}
function $855e001ba27d7a0a$var$onPointerEvent(event) {
    $855e001ba27d7a0a$var$modality = "pointer";
    if (event.type === "mousedown" || event.type === "pointerdown") {
        $855e001ba27d7a0a$var$hasEventBeforeFocus = true;
        const target = event.composedPath ? event.composedPath()[0] : event.target;
        let matches = false;
        try {
            matches = target.matches(":focus-visible");
        } catch  {}
        if (matches) return;
        $855e001ba27d7a0a$var$trigger("pointer", event);
    }
}
function $855e001ba27d7a0a$var$isVirtualClick(event) {
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    return event.detail === 0 && !event.pointerType;
}
function $855e001ba27d7a0a$var$onClickEvent(e) {
    if ($855e001ba27d7a0a$var$isVirtualClick(e)) {
        $855e001ba27d7a0a$var$hasEventBeforeFocus = true;
        $855e001ba27d7a0a$var$modality = "virtual";
    }
}
function $855e001ba27d7a0a$var$onWindowFocus(event) {
    if (event.target === window || event.target === document) return;
    if (event.target instanceof Element && event.target.hasAttribute("tabindex")) return;
    if (!$855e001ba27d7a0a$var$hasEventBeforeFocus && !$855e001ba27d7a0a$var$hasBlurredWindowRecently) {
        $855e001ba27d7a0a$var$modality = "virtual";
        $855e001ba27d7a0a$var$trigger("virtual", event);
    }
    $855e001ba27d7a0a$var$hasEventBeforeFocus = false;
    $855e001ba27d7a0a$var$hasBlurredWindowRecently = false;
}
function $855e001ba27d7a0a$var$onWindowBlur() {
    $855e001ba27d7a0a$var$hasEventBeforeFocus = false;
    $855e001ba27d7a0a$var$hasBlurredWindowRecently = true;
}
function $855e001ba27d7a0a$var$isFocusVisible() {
    return $855e001ba27d7a0a$var$modality !== "pointer";
}
function $855e001ba27d7a0a$var$setupGlobalFocusEvents() {
    if (!(0, $47270bc1d198d885$export$9f57505b7bd8dae)() || $855e001ba27d7a0a$var$hasSetup) return;
    const { focus: focus } = HTMLElement.prototype;
    HTMLElement.prototype.focus = function focusElement(...args) {
        $855e001ba27d7a0a$var$hasEventBeforeFocus = true;
        focus.apply(this, args);
    };
    document.addEventListener("keydown", $855e001ba27d7a0a$var$onKeyboardEvent, true);
    document.addEventListener("keyup", $855e001ba27d7a0a$var$onKeyboardEvent, true);
    document.addEventListener("click", $855e001ba27d7a0a$var$onClickEvent, true);
    window.addEventListener("focus", $855e001ba27d7a0a$var$onWindowFocus, true);
    window.addEventListener("blur", $855e001ba27d7a0a$var$onWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        document.addEventListener("pointerdown", $855e001ba27d7a0a$var$onPointerEvent, true);
        document.addEventListener("pointermove", $855e001ba27d7a0a$var$onPointerEvent, true);
        document.addEventListener("pointerup", $855e001ba27d7a0a$var$onPointerEvent, true);
    } else {
        document.addEventListener("mousedown", $855e001ba27d7a0a$var$onPointerEvent, true);
        document.addEventListener("mousemove", $855e001ba27d7a0a$var$onPointerEvent, true);
        document.addEventListener("mouseup", $855e001ba27d7a0a$var$onPointerEvent, true);
    }
    $855e001ba27d7a0a$var$hasSetup = true;
}
function $855e001ba27d7a0a$export$920b4983565c6f4d(fn) {
    $855e001ba27d7a0a$var$setupGlobalFocusEvents();
    fn($855e001ba27d7a0a$var$isFocusVisible());
    const handler = ()=>fn($855e001ba27d7a0a$var$isFocusVisible());
    $855e001ba27d7a0a$var$handlers.add(handler);
    return ()=>{
        $855e001ba27d7a0a$var$handlers.delete(handler);
    };
}
function $855e001ba27d7a0a$export$1238a82db5699f92(fn) {
    $855e001ba27d7a0a$var$setupGlobalFocusEvents();
    fn($855e001ba27d7a0a$var$modality);
    const handler = ()=>fn($855e001ba27d7a0a$var$modality);
    $855e001ba27d7a0a$var$handlers.add(handler);
    return ()=>{
        $855e001ba27d7a0a$var$handlers.delete(handler);
    };
}
function $855e001ba27d7a0a$export$8397ddfc504fdb9a(value) {
    $855e001ba27d7a0a$var$modality = value;
    $855e001ba27d7a0a$var$trigger(value, null);
}
function $855e001ba27d7a0a$export$630ff653c5ada6a9() {
    return $855e001ba27d7a0a$var$modality;
}



var $8v0nu = parcelRequire("8v0nu");



"use client";
function $2487511efe1457c8$export$37b0961d2f4751e2(props = {}) {
    const { defaultChecked: defaultChecked, isChecked: isCheckedProp, isFocusable: isFocusable, isDisabled: isDisabledProp, isReadOnly: isReadOnlyProp, isRequired: isRequiredProp, onChange: onChange, isInvalid: isInvalidProp, name: name, value: value, id: idProp, "data-radiogroup": dataRadioGroup, "aria-describedby": ariaDescribedBy, ...htmlProps } = props;
    const uuid = `radio-${(0, $8v0nu.useId)()}`;
    const formControl = (0, $02b238a4ba05f901$export$97a2352498389516)();
    const group = (0, $af7f31f27e6b9bae$export$7bea016dc7ad2ddf)();
    const isWithinRadioGroup = !!group || !!dataRadioGroup;
    const isWithinFormControl = !!formControl;
    let id = isWithinFormControl && !isWithinRadioGroup ? formControl.id : uuid;
    id = idProp ?? id;
    const isDisabled = isDisabledProp ?? formControl?.isDisabled;
    const isReadOnly = isReadOnlyProp ?? formControl?.isReadOnly;
    const isRequired = isRequiredProp ?? formControl?.isRequired;
    const isInvalid = isInvalidProp ?? formControl?.isInvalid;
    const [isFocusVisible, setIsFocusVisible] = (0, $8v0nu.useState)(false);
    const [isFocused, setFocused] = (0, $8v0nu.useState)(false);
    const [isHovered, setHovering] = (0, $8v0nu.useState)(false);
    const [isActive, setActive] = (0, $8v0nu.useState)(false);
    const [isCheckedState, setChecked] = (0, $8v0nu.useState)(Boolean(defaultChecked));
    const isControlled = typeof isCheckedProp !== "undefined";
    const isChecked = isControlled ? isCheckedProp : isCheckedState;
    (0, $8v0nu.useEffect)(()=>{
        return (0, $855e001ba27d7a0a$export$920b4983565c6f4d)(setIsFocusVisible);
    }, []);
    const handleChange = (0, $8v0nu.useCallback)((event)=>{
        if (isReadOnly || isDisabled) {
            event.preventDefault();
            return;
        }
        if (!isControlled) setChecked(event.currentTarget.checked);
        onChange?.(event);
    }, [
        isControlled,
        isDisabled,
        isReadOnly,
        onChange
    ]);
    const onKeyDown = (0, $8v0nu.useCallback)((event)=>{
        if (event.key === " ") setActive(true);
    }, [
        setActive
    ]);
    const onKeyUp = (0, $8v0nu.useCallback)((event)=>{
        if (event.key === " ") setActive(false);
    }, [
        setActive
    ]);
    const getRadioProps = (0, $8v0nu.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            ref: ref,
            "data-active": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isActive),
            "data-hover": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isHovered),
            "data-disabled": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isDisabled),
            "data-invalid": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isInvalid),
            "data-checked": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isChecked),
            "data-focus": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isFocused),
            "data-focus-visible": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isFocused && isFocusVisible),
            "data-readonly": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isReadOnly),
            "aria-hidden": true,
            onMouseDown: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onMouseDown, ()=>setActive(true)),
            onMouseUp: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onMouseUp, ()=>setActive(false)),
            onMouseEnter: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onMouseEnter, ()=>setHovering(true)),
            onMouseLeave: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onMouseLeave, ()=>setHovering(false))
        }), [
        isActive,
        isHovered,
        isDisabled,
        isInvalid,
        isChecked,
        isFocused,
        isReadOnly,
        isFocusVisible
    ]);
    const { onFocus: onFocus, onBlur: onBlur } = formControl ?? {};
    const getInputProps = (0, $8v0nu.useCallback)((props2 = {}, ref = null)=>{
        const trulyDisabled = isDisabled && !isFocusable;
        return {
            ...props2,
            id: id,
            ref: ref,
            type: "radio",
            name: name,
            value: value,
            onChange: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onChange, handleChange),
            onBlur: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(onBlur, props2.onBlur, ()=>setFocused(false)),
            onFocus: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(onFocus, props2.onFocus, ()=>setFocused(true)),
            onKeyDown: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onKeyDown, onKeyDown),
            onKeyUp: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onKeyUp, onKeyUp),
            checked: isChecked,
            disabled: trulyDisabled,
            readOnly: isReadOnly,
            required: isRequired,
            "aria-invalid": (0, $2892ce0537b3699a$export$91a6105db3d4be7b)(isInvalid),
            "aria-disabled": (0, $2892ce0537b3699a$export$91a6105db3d4be7b)(trulyDisabled),
            "aria-required": (0, $2892ce0537b3699a$export$91a6105db3d4be7b)(isRequired),
            "data-readonly": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isReadOnly),
            "aria-describedby": ariaDescribedBy,
            style: (0, $4418259e0694d88e$export$8fecac46448b5689)
        };
    }, [
        isDisabled,
        isFocusable,
        id,
        name,
        value,
        handleChange,
        onBlur,
        onFocus,
        onKeyDown,
        onKeyUp,
        isChecked,
        isReadOnly,
        isRequired,
        isInvalid,
        ariaDescribedBy
    ]);
    const getLabelProps = (props2 = {}, ref = null)=>({
            ...props2,
            ref: ref,
            onMouseDown: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onMouseDown, $2487511efe1457c8$var$stopEvent),
            "data-disabled": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isDisabled),
            "data-checked": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isChecked),
            "data-invalid": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isInvalid)
        });
    const getRootProps = (props2, ref = null)=>({
            htmlFor: id,
            ...props2,
            ref: ref,
            "data-disabled": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isDisabled),
            "data-checked": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isChecked),
            "data-invalid": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isInvalid)
        });
    const state = {
        isInvalid: isInvalid,
        isFocused: isFocused,
        isChecked: isChecked,
        isActive: isActive,
        isHovered: isHovered,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isRequired: isRequired
    };
    return {
        state: state,
        getRadioProps: getRadioProps,
        getInputProps: getInputProps,
        getLabelProps: getLabelProps,
        getRootProps: getRootProps,
        htmlProps: htmlProps
    };
}
function $2487511efe1457c8$var$stopEvent(event) {
    event.preventDefault();
    event.stopPropagation();
}





var $3lBLT = parcelRequire("3lBLT");
"use client";
const $0ca1c2d3e41f8fec$export$d7b12c4107be0d61 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)((props, ref)=>{
    const group = (0, $af7f31f27e6b9bae$export$7bea016dc7ad2ddf)();
    const { onChange: onChangeProp, value: valueProp } = props;
    const styles = (0, $c7d173d35275482d$export$31cdfe60c085d76f)("Radio", {
        ...group,
        ...props
    });
    const ownProps = (0, $58ff34c9d17adf03$export$adfcf5a5e4d17785)(props);
    const { spacing: spacing = "0.5rem", children: children, isDisabled: isDisabled = group?.isDisabled, isFocusable: isFocusable = group?.isFocusable, inputProps: htmlInputProps, ...rest } = ownProps;
    let isChecked = props.isChecked;
    if (group?.value != null && valueProp != null) isChecked = group.value === valueProp;
    let onChange = onChangeProp;
    if (group?.onChange && valueProp != null) onChange = (0, $5bb288c143ca173e$export$9dd9a52f2dd5b9ce)(group.onChange, onChangeProp);
    const name = props?.name ?? group?.name;
    const { getInputProps: getInputProps, getRadioProps: getRadioProps, getLabelProps: getLabelProps, getRootProps: getRootProps, htmlProps: htmlProps } = (0, $2487511efe1457c8$export$37b0961d2f4751e2)({
        ...rest,
        isChecked: isChecked,
        isFocusable: isFocusable,
        isDisabled: isDisabled,
        onChange: onChange,
        name: name
    });
    const [layoutProps, otherProps] = (0, $24a367edf3ea1eb0$export$65980d18b75784e2)(htmlProps, (0, $lA3d6.layoutPropNames));
    const checkboxProps = getRadioProps(otherProps);
    const inputProps = getInputProps(htmlInputProps, ref);
    const labelProps = getLabelProps();
    const rootProps = Object.assign({}, layoutProps, getRootProps());
    const rootStyles = {
        display: "inline-flex",
        alignItems: "center",
        verticalAlign: "top",
        cursor: "pointer",
        position: "relative",
        ...styles.container
    };
    const checkboxStyles = {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        ...styles.control
    };
    const labelStyles = {
        userSelect: "none",
        marginStart: spacing,
        ...styles.label
    };
    return /* @__PURE__ */ (0, $kxTYF.jsxs)((0, $3lBLT.chakra).label, {
        className: "chakra-radio",
        ...rootProps,
        __css: rootStyles,
        children: [
            /* @__PURE__ */ (0, $kxTYF.jsx)("input", {
                className: "chakra-radio__input",
                ...inputProps
            }),
            /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).span, {
                className: "chakra-radio__control",
                ...checkboxProps,
                __css: checkboxStyles
            }),
            children && /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).span, {
                className: "chakra-radio__label",
                ...labelProps,
                __css: labelStyles,
                children: children
            })
        ]
    });
});
$0ca1c2d3e41f8fec$export$d7b12c4107be0d61.displayName = "Radio";



var $jTKGQ = parcelRequire("jTKGQ");

function $d8f83a902ec18287$export$578a0ba473f83a10(props) {
    const { pointer: pointer, isRequired: isRequired } = props;
    const field = props.field;
    const options = field.enum;
    if (field.allowOther) throw new Error("WidgetCheckbox: allowOther is not supported. Use widget 'tagger' instead");
    if (!options?.length) throw new Error("WidgetRadio: enum is required");
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $jTKGQ.FastField), {
        name: pointer,
        children: ({ field: { value: value }, meta: meta, form: { setFieldValue: setFieldValue, setFieldTouched: setFieldTouched } })=>/*#__PURE__*/ (0, $kxTYF.jsxs)((0, $02b238a4ba05f901$export$fe5d99d8691b3f62), {
                isRequired: isRequired,
                isInvalid: !!(meta.touched && meta.error),
                children: [
                    field.label && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $2d2a7a8f479cc337$export$842aba50ed0ce9d7), {
                        children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8f2967926209c75b$export$1acdcf5a973a8414), {
                            size: "xs",
                            children: field.label
                        })
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $af7f31f27e6b9bae$export$a98f0dcb43a68a25), {
                        size: "sm",
                        gap: 4,
                        display: "flex",
                        value: value,
                        onChange: (v)=>{
                            setFieldValue(pointer, v);
                            setFieldTouched(pointer, true);
                        },
                        children: options.map(([radioValue, label])=>/*#__PURE__*/ (0, $kxTYF.jsx)((0, $0ca1c2d3e41f8fec$export$d7b12c4107be0d61), {
                                size: "sm",
                                value: radioValue,
                                children: label
                            }, radioValue))
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $210fc61c9a876d6f$export$185a8afe504e8fca), {
                        children: meta.error
                    })
                ]
            })
    });
}



var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");

var $kxTYF = parcelRequire("kxTYF");


var $7hYFp = parcelRequire("7hYFp");

var $6iKRa = parcelRequire("6iKRa");

var $8v0nu = parcelRequire("8v0nu");

"use client";
const [$4fa07110a47b22e2$export$95a3c27e07a551c3, $4fa07110a47b22e2$export$5575526870d5c2ae] = (0, $3473b2b1e3b906ba$export$fd42f52fd3ae1109)({
    name: "CheckboxGroupContext",
    strict: false
});



var $kxTYF = parcelRequire("kxTYF");

var $3lBLT = parcelRequire("3lBLT");
"use client";
function $5d191b37e914fc42$var$CheckIcon(props) {
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).svg, {
        width: "1.2em",
        viewBox: "0 0 12 10",
        style: {
            fill: "none",
            strokeWidth: 2,
            stroke: "currentColor",
            strokeDasharray: 16
        },
        ...props,
        children: /* @__PURE__ */ (0, $kxTYF.jsx)("polyline", {
            points: "1.5 6 4.5 9 10.5 1"
        })
    });
}
function $5d191b37e914fc42$var$IndeterminateIcon(props) {
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).svg, {
        width: "1.2em",
        viewBox: "0 0 24 24",
        style: {
            stroke: "currentColor",
            strokeWidth: 4
        },
        ...props,
        children: /* @__PURE__ */ (0, $kxTYF.jsx)("line", {
            x1: "21",
            x2: "3",
            y1: "12",
            y2: "12"
        })
    });
}
function $5d191b37e914fc42$export$c0a1936901b0e55(props) {
    const { isIndeterminate: isIndeterminate, isChecked: isChecked, ...rest } = props;
    const BaseIcon = isIndeterminate ? $5d191b37e914fc42$var$IndeterminateIcon : $5d191b37e914fc42$var$CheckIcon;
    return isChecked || isIndeterminate ? /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).div, {
        style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%"
        },
        children: /* @__PURE__ */ (0, $kxTYF.jsx)(BaseIcon, {
            ...rest
        })
    }) : null;
}






var $8v0nu = parcelRequire("8v0nu");


"use client";
function $40af1377af70cc96$export$e375f10ce42261c5(props = {}) {
    const formControlProps = (0, $4f32164aecdf11bb$export$1819803dd567b95f)(props);
    const { isDisabled: isDisabled, isReadOnly: isReadOnly, isRequired: isRequired, isInvalid: isInvalid, id: id, onBlur: onBlur, onFocus: onFocus, "aria-describedby": ariaDescribedBy } = formControlProps;
    const { defaultChecked: defaultChecked, isChecked: checkedProp, isFocusable: isFocusable, onChange: onChange, isIndeterminate: isIndeterminate, name: name, value: value, tabIndex: tabIndex, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-invalid": ariaInvalid, ...rest } = props;
    const htmlProps = (0, $26295883b405048e$export$30a06c8d3562193f)(rest, [
        "isDisabled",
        "isReadOnly",
        "isRequired",
        "isInvalid",
        "id",
        "onBlur",
        "onFocus",
        "aria-describedby"
    ]);
    const onChangeProp = (0, $7bf98d1f0832a6d6$export$25bec8c6f54ee79a)(onChange);
    const onBlurProp = (0, $7bf98d1f0832a6d6$export$25bec8c6f54ee79a)(onBlur);
    const onFocusProp = (0, $7bf98d1f0832a6d6$export$25bec8c6f54ee79a)(onFocus);
    const [isFocusVisible, setIsFocusVisible] = (0, $8v0nu.useState)(false);
    const [isFocused, setFocused] = (0, $8v0nu.useState)(false);
    const [isHovered, setHovered] = (0, $8v0nu.useState)(false);
    const [isActive, setActive] = (0, $8v0nu.useState)(false);
    (0, $8v0nu.useEffect)(()=>{
        return (0, $855e001ba27d7a0a$export$920b4983565c6f4d)(setIsFocusVisible);
    }, []);
    const inputRef = (0, $8v0nu.useRef)(null);
    const [rootIsLabelElement, setRootIsLabelElement] = (0, $8v0nu.useState)(true);
    const [checkedState, setCheckedState] = (0, $8v0nu.useState)(!!defaultChecked);
    const isControlled = checkedProp !== void 0;
    const isChecked = isControlled ? checkedProp : checkedState;
    const handleChange = (0, $8v0nu.useCallback)((event)=>{
        if (isReadOnly || isDisabled) {
            event.preventDefault();
            return;
        }
        if (!isControlled) {
            if (isChecked) setCheckedState(event.currentTarget.checked);
            else setCheckedState(isIndeterminate ? true : event.currentTarget.checked);
        }
        onChangeProp?.(event);
    }, [
        isReadOnly,
        isDisabled,
        isChecked,
        isControlled,
        isIndeterminate,
        onChangeProp
    ]);
    (0, $456f92579f2f647e$export$deebe11a338de063)(()=>{
        if (inputRef.current) inputRef.current.indeterminate = Boolean(isIndeterminate);
    }, [
        isIndeterminate
    ]);
    (0, $9fe29ceca799989a$export$496315a1608d9602)(()=>{
        if (isDisabled) setFocused(false);
    }, [
        isDisabled,
        setFocused
    ]);
    (0, $456f92579f2f647e$export$deebe11a338de063)(()=>{
        const el = inputRef.current;
        if (!el?.form) return;
        const formResetListener = ()=>{
            setCheckedState(!!defaultChecked);
        };
        el.form.addEventListener("reset", formResetListener);
        return ()=>el.form?.removeEventListener("reset", formResetListener);
    }, []);
    const trulyDisabled = isDisabled && !isFocusable;
    const onKeyDown = (0, $8v0nu.useCallback)((event)=>{
        if (event.key === " ") setActive(true);
    }, [
        setActive
    ]);
    const onKeyUp = (0, $8v0nu.useCallback)((event)=>{
        if (event.key === " ") setActive(false);
    }, [
        setActive
    ]);
    (0, $456f92579f2f647e$export$deebe11a338de063)(()=>{
        if (!inputRef.current) return;
        const notInSync = inputRef.current.checked !== isChecked;
        if (notInSync) setCheckedState(inputRef.current.checked);
    }, [
        inputRef.current
    ]);
    const getCheckboxProps = (0, $8v0nu.useCallback)((props2 = {}, forwardedRef = null)=>{
        const onPressDown = (event)=>{
            if (isFocused) event.preventDefault();
            setActive(true);
        };
        return {
            ...props2,
            ref: forwardedRef,
            "data-active": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isActive),
            "data-hover": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isHovered),
            "data-checked": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isChecked),
            "data-focus": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isFocused),
            "data-focus-visible": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isFocused && isFocusVisible),
            "data-indeterminate": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isIndeterminate),
            "data-disabled": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isDisabled),
            "data-invalid": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isInvalid),
            "data-readonly": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isReadOnly),
            "aria-hidden": true,
            onMouseDown: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onMouseDown, onPressDown),
            onMouseUp: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onMouseUp, ()=>setActive(false)),
            onMouseEnter: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onMouseEnter, ()=>setHovered(true)),
            onMouseLeave: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onMouseLeave, ()=>setHovered(false))
        };
    }, [
        isActive,
        isChecked,
        isDisabled,
        isFocused,
        isFocusVisible,
        isHovered,
        isIndeterminate,
        isInvalid,
        isReadOnly
    ]);
    const getIndicatorProps = (0, $8v0nu.useCallback)((props2 = {}, forwardedRef = null)=>({
            ...props2,
            ref: forwardedRef,
            "data-active": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isActive),
            "data-hover": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isHovered),
            "data-checked": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isChecked),
            "data-focus": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isFocused),
            "data-focus-visible": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isFocused && isFocusVisible),
            "data-indeterminate": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isIndeterminate),
            "data-disabled": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isDisabled),
            "data-invalid": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isInvalid),
            "data-readonly": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isReadOnly)
        }), [
        isActive,
        isChecked,
        isDisabled,
        isFocused,
        isFocusVisible,
        isHovered,
        isIndeterminate,
        isInvalid,
        isReadOnly
    ]);
    const getRootProps = (0, $8v0nu.useCallback)((props2 = {}, forwardedRef = null)=>({
            ...htmlProps,
            ...props2,
            ref: (0, $95f7db4ddbf3eda0$export$c9058316764c140e)(forwardedRef, (node)=>{
                if (!node) return;
                setRootIsLabelElement(node.tagName === "LABEL");
            }),
            onClick: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onClick, ()=>{
                if (!rootIsLabelElement) {
                    inputRef.current?.click();
                    requestAnimationFrame(()=>{
                        inputRef.current?.focus({
                            preventScroll: true
                        });
                    });
                }
            }),
            "data-disabled": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isDisabled),
            "data-checked": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isChecked),
            "data-invalid": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isInvalid)
        }), [
        htmlProps,
        isDisabled,
        isChecked,
        isInvalid,
        rootIsLabelElement
    ]);
    const getInputProps = (0, $8v0nu.useCallback)((props2 = {}, forwardedRef = null)=>{
        return {
            ...props2,
            ref: (0, $95f7db4ddbf3eda0$export$c9058316764c140e)(inputRef, forwardedRef),
            type: "checkbox",
            name: name,
            value: value,
            id: id,
            tabIndex: tabIndex,
            onChange: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onChange, handleChange),
            onBlur: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onBlur, onBlurProp, ()=>setFocused(false)),
            onFocus: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onFocus, onFocusProp, ()=>setFocused(true)),
            onKeyDown: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onKeyDown, onKeyDown),
            onKeyUp: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onKeyUp, onKeyUp),
            required: isRequired,
            checked: isChecked,
            disabled: trulyDisabled,
            readOnly: isReadOnly,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            "aria-invalid": ariaInvalid ? Boolean(ariaInvalid) : isInvalid,
            "aria-describedby": ariaDescribedBy,
            "aria-disabled": isDisabled,
            style: (0, $4418259e0694d88e$export$8fecac46448b5689)
        };
    }, [
        name,
        value,
        id,
        handleChange,
        onBlurProp,
        onFocusProp,
        onKeyDown,
        onKeyUp,
        isRequired,
        isChecked,
        trulyDisabled,
        isReadOnly,
        ariaLabel,
        ariaLabelledBy,
        ariaInvalid,
        isInvalid,
        ariaDescribedBy,
        isDisabled,
        tabIndex
    ]);
    const getLabelProps = (0, $8v0nu.useCallback)((props2 = {}, forwardedRef = null)=>({
            ...props2,
            ref: forwardedRef,
            onMouseDown: (0, $5bb288c143ca173e$export$5bdd3f730ec2c47e)(props2.onMouseDown, $40af1377af70cc96$var$stopEvent),
            "data-disabled": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isDisabled),
            "data-checked": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isChecked),
            "data-invalid": (0, $2892ce0537b3699a$export$5cc3b7b83e34ade7)(isInvalid)
        }), [
        isChecked,
        isDisabled,
        isInvalid
    ]);
    const state = {
        isInvalid: isInvalid,
        isFocused: isFocused,
        isChecked: isChecked,
        isActive: isActive,
        isHovered: isHovered,
        isIndeterminate: isIndeterminate,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isRequired: isRequired
    };
    return {
        state: state,
        getRootProps: getRootProps,
        getCheckboxProps: getCheckboxProps,
        getIndicatorProps: getIndicatorProps,
        getInputProps: getInputProps,
        getLabelProps: getLabelProps,
        htmlProps: htmlProps
    };
}
function $40af1377af70cc96$var$stopEvent(event) {
    event.preventDefault();
    event.stopPropagation();
}



var $8v0nu = parcelRequire("8v0nu");
"use client";
function $c51c0b14bee430eb$export$c4008d6206288921(isChecked) {
    const [previousIsChecked, setPreviousIsChecked] = (0, $8v0nu.useState)(isChecked);
    const [shouldAnimate, setShouldAnimate] = (0, $8v0nu.useState)(false);
    if (isChecked !== previousIsChecked) {
        setShouldAnimate(true);
        setPreviousIsChecked(isChecked);
    }
    return shouldAnimate;
}





var $3lBLT = parcelRequire("3lBLT");
"use client";
const $126a571048714ba6$var$controlStyles = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    verticalAlign: "top",
    userSelect: "none",
    flexShrink: 0
};
const $126a571048714ba6$var$rootStyles = {
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    verticalAlign: "top",
    position: "relative"
};
const $126a571048714ba6$var$checkAnim = (0, $6iKRa.keyframes)({
    from: {
        opacity: 0,
        strokeDashoffset: 16,
        transform: "scale(0.95)"
    },
    to: {
        opacity: 1,
        strokeDashoffset: 0,
        transform: "scale(1)"
    }
});
const $126a571048714ba6$var$indeterminateOpacityAnim = (0, $6iKRa.keyframes)({
    from: {
        opacity: 0
    },
    to: {
        opacity: 1
    }
});
const $126a571048714ba6$var$indeterminateScaleAnim = (0, $6iKRa.keyframes)({
    from: {
        transform: "scaleX(0.65)"
    },
    to: {
        transform: "scaleX(1)"
    }
});
const $126a571048714ba6$export$48513f6b9f8ce62d = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function Checkbox2(props, ref) {
    const group = (0, $4fa07110a47b22e2$export$5575526870d5c2ae)();
    const mergedProps = {
        ...group,
        ...props
    };
    const styles = (0, $c7d173d35275482d$export$31cdfe60c085d76f)("Checkbox", mergedProps);
    const ownProps = (0, $58ff34c9d17adf03$export$adfcf5a5e4d17785)(props);
    const { spacing: spacing = "0.5rem", className: className, children: children, iconColor: iconColor, iconSize: iconSize, icon: icon = /* @__PURE__ */ (0, $kxTYF.jsx)((0, $5d191b37e914fc42$export$c0a1936901b0e55), {}), isChecked: isCheckedProp, isDisabled: isDisabled = group?.isDisabled, onChange: onChangeProp, inputProps: inputProps, ...rest } = ownProps;
    let isChecked = isCheckedProp;
    if (group?.value && ownProps.value) isChecked = group.value.includes(ownProps.value);
    let onChange = onChangeProp;
    if (group?.onChange && ownProps.value) onChange = (0, $5bb288c143ca173e$export$9dd9a52f2dd5b9ce)(group.onChange, onChangeProp);
    const { state: state, getInputProps: getInputProps, getCheckboxProps: getCheckboxProps, getLabelProps: getLabelProps, getRootProps: getRootProps } = (0, $40af1377af70cc96$export$e375f10ce42261c5)({
        ...rest,
        isDisabled: isDisabled,
        isChecked: isChecked,
        onChange: onChange
    });
    const shouldAnimate = (0, $c51c0b14bee430eb$export$c4008d6206288921)(state.isChecked);
    const iconStyles = (0, $8v0nu.useMemo)(()=>({
            animation: !shouldAnimate ? void 0 : state.isIndeterminate ? `${$126a571048714ba6$var$indeterminateOpacityAnim} 20ms linear, ${$126a571048714ba6$var$indeterminateScaleAnim} 200ms linear` : `${$126a571048714ba6$var$checkAnim} 200ms linear`,
            ...styles.icon,
            ...(0, $7hYFp.compact)({
                fontSize: iconSize,
                color: iconColor
            })
        }), [
        iconColor,
        iconSize,
        shouldAnimate,
        state.isIndeterminate,
        styles.icon
    ]);
    const clonedIcon = (0, $8v0nu.cloneElement)(icon, {
        __css: iconStyles,
        isIndeterminate: state.isIndeterminate,
        isChecked: state.isChecked
    });
    return /* @__PURE__ */ (0, $kxTYF.jsxs)((0, $3lBLT.chakra).label, {
        __css: {
            ...$126a571048714ba6$var$rootStyles,
            ...styles.container
        },
        className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-checkbox", className),
        ...getRootProps(),
        children: [
            /* @__PURE__ */ (0, $kxTYF.jsx)("input", {
                className: "chakra-checkbox__input",
                ...getInputProps(inputProps, ref)
            }),
            /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).span, {
                __css: {
                    ...$126a571048714ba6$var$controlStyles,
                    ...styles.control
                },
                className: "chakra-checkbox__control",
                ...getCheckboxProps(),
                children: clonedIcon
            }),
            children && /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).span, {
                className: "chakra-checkbox__label",
                ...getLabelProps(),
                __css: {
                    marginStart: spacing,
                    ...styles.label
                },
                children: children
            })
        ]
    });
});
$126a571048714ba6$export$48513f6b9f8ce62d.displayName = "Checkbox";


var $kxTYF = parcelRequire("kxTYF");

var $8v0nu = parcelRequire("8v0nu");



var $fZQg5 = parcelRequire("fZQg5");

var $8v0nu = parcelRequire("8v0nu");
"use client";
function $74ac34f4cf2c0f10$var$isInputEvent(value) {
    return value && (0, $fZQg5.isObject)(value) && (0, $fZQg5.isObject)(value.target);
}
function $74ac34f4cf2c0f10$export$49ff6f28c54f1cbe(props = {}) {
    const { defaultValue: defaultValue, value: valueProp, onChange: onChange, isDisabled: isDisabled, isNative: isNative } = props;
    const onChangeProp = (0, $7bf98d1f0832a6d6$export$25bec8c6f54ee79a)(onChange);
    const [value, setValue] = (0, $3268be99fa453fba$export$6f32135080cb4c3)({
        value: valueProp,
        defaultValue: defaultValue || [],
        onChange: onChangeProp
    });
    const handleChange = (0, $8v0nu.useCallback)((eventOrValue)=>{
        if (!value) return;
        const isChecked = $74ac34f4cf2c0f10$var$isInputEvent(eventOrValue) ? eventOrValue.target.checked : !value.includes(eventOrValue);
        const selectedValue = $74ac34f4cf2c0f10$var$isInputEvent(eventOrValue) ? eventOrValue.target.value : eventOrValue;
        const nextValue = isChecked ? [
            ...value,
            selectedValue
        ] : value.filter((v)=>String(v) !== String(selectedValue));
        setValue(nextValue);
    }, [
        setValue,
        value
    ]);
    const getCheckboxProps = (0, $8v0nu.useCallback)((props2 = {})=>{
        const checkedKey = isNative ? "checked" : "isChecked";
        return {
            ...props2,
            [checkedKey]: value.some((val)=>String(props2.value) === String(val)),
            onChange: handleChange
        };
    }, [
        handleChange,
        isNative,
        value
    ]);
    return {
        value: value,
        isDisabled: isDisabled,
        onChange: handleChange,
        setValue: setValue,
        getCheckboxProps: getCheckboxProps
    };
}


"use client";
function $b54e341e9aee88e8$export$4aa08d5625cb8ead(props) {
    const { colorScheme: colorScheme, size: size, variant: variant, children: children, isDisabled: isDisabled } = props;
    const { value: value, onChange: onChange } = (0, $74ac34f4cf2c0f10$export$49ff6f28c54f1cbe)(props);
    const group = (0, $8v0nu.useMemo)(()=>({
            size: size,
            onChange: onChange,
            colorScheme: colorScheme,
            value: value,
            variant: variant,
            isDisabled: isDisabled
        }), [
        size,
        onChange,
        colorScheme,
        value,
        variant,
        isDisabled
    ]);
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $4fa07110a47b22e2$export$95a3c27e07a551c3), {
        value: group,
        children: children
    });
}
$b54e341e9aee88e8$export$4aa08d5625cb8ead.displayName = "CheckboxGroup";



var $jTKGQ = parcelRequire("jTKGQ");

function $6369dd324fce8d1d$export$7125ae6e0d206208(props) {
    const { pointer: pointer, isRequired: isRequired } = props;
    const field = props.field;
    const options = field.items.enum;
    if (field.items.allowOther) throw new Error("WidgetCheckbox: allowOther is not supported. Use widget 'tagger' instead");
    if (!options?.length) throw new Error("WidgetCheckbox: items.enum is required");
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $jTKGQ.FastField), {
        name: pointer,
        children: ({ field: { value: value }, meta: meta, form: { setFieldValue: setFieldValue, setFieldTouched: setFieldTouched } })=>/*#__PURE__*/ (0, $kxTYF.jsxs)((0, $02b238a4ba05f901$export$fe5d99d8691b3f62), {
                isRequired: isRequired,
                isInvalid: !!(meta.touched && meta.error),
                children: [
                    field.label && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $2d2a7a8f479cc337$export$842aba50ed0ce9d7), {
                        children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8f2967926209c75b$export$1acdcf5a973a8414), {
                            size: "xs",
                            children: field.label
                        })
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                        gap: 4,
                        children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $b54e341e9aee88e8$export$4aa08d5625cb8ead), {
                            value: value,
                            onChange: (v)=>{
                                setFieldValue(pointer, v);
                                setFieldTouched(pointer, true);
                            },
                            children: options.map(([checkboxVal, label])=>/*#__PURE__*/ (0, $kxTYF.jsx)((0, $126a571048714ba6$export$48513f6b9f8ce62d), {
                                    size: "sm",
                                    value: checkboxVal,
                                    children: label
                                }, checkboxVal))
                        })
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $210fc61c9a876d6f$export$185a8afe504e8fca), {
                        children: meta.error
                    })
                ]
            })
    });
}



var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");


var $jTKGQ = parcelRequire("jTKGQ");



var $eA9yl = parcelRequire("eA9yl");

var $eA9yl = parcelRequire("eA9yl");

var $fdbzE = parcelRequire("fdbzE");
/** Used to match property names within property paths. */ var $052e06a52ad6a01d$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $052e06a52ad6a01d$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $052e06a52ad6a01d$var$isKey(value, object) {
    if ((0, $eA9yl.default)(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || (0, $fdbzE.default)(value)) return true;
    return $052e06a52ad6a01d$var$reIsPlainProp.test(value) || !$052e06a52ad6a01d$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
var $052e06a52ad6a01d$export$2e2bcd8739ae039 = $052e06a52ad6a01d$var$isKey;



var $2nPhd = parcelRequire("2nPhd");

var $hghOo = parcelRequire("hghOo");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $9bf1bc98bfb8909a$var$castPath(value, object) {
    if ((0, $eA9yl.default)(value)) return value;
    return (0, $052e06a52ad6a01d$export$2e2bcd8739ae039)(value, object) ? [
        value
    ] : (0, $2nPhd.default)((0, $hghOo.default)(value));
}
var $9bf1bc98bfb8909a$export$2e2bcd8739ae039 = $9bf1bc98bfb8909a$var$castPath;



var $e9clf = parcelRequire("e9clf");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $ec9ff061c841039c$var$baseGet(object, path) {
    path = (0, $9bf1bc98bfb8909a$export$2e2bcd8739ae039)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, $e9clf.default)(path[index++])];
    return index && index == length ? object : undefined;
}
var $ec9ff061c841039c$export$2e2bcd8739ae039 = $ec9ff061c841039c$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $de005c3c82706228$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : (0, $ec9ff061c841039c$export$2e2bcd8739ae039)(object, path);
    return result === undefined ? defaultValue : result;
}
var $de005c3c82706228$export$2e2bcd8739ae039 = $de005c3c82706228$var$get;



var $kxTYF = parcelRequire("kxTYF");

var $8v0nu = parcelRequire("8v0nu");



var $9HGsN = parcelRequire("9HGsN");


var $jTKGQ = parcelRequire("jTKGQ");

var $jGWdr = parcelRequire("jGWdr");
var $8Xlz0 = parcelRequire("8Xlz0");


var $31LnV = parcelRequire("31LnV");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $7c466d0ea92d97f8$var$baseForOwn(object, iteratee) {
    return object && (0, $c2253e8a3eee9abf$export$2e2bcd8739ae039)(object, iteratee, (0, $31LnV.default));
}
var $7c466d0ea92d97f8$export$2e2bcd8739ae039 = $7c466d0ea92d97f8$var$baseForOwn;



var $5dLfO = parcelRequire("5dLfO");

var $5dLfO = parcelRequire("5dLfO");

var $5Sw7u = parcelRequire("5Sw7u");
/** Used to stand-in for `undefined` hash values. */ var $72e5ab95c7257c18$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $72e5ab95c7257c18$var$setCacheAdd(value) {
    this.__data__.set(value, $72e5ab95c7257c18$var$HASH_UNDEFINED);
    return this;
}
var $72e5ab95c7257c18$export$2e2bcd8739ae039 = $72e5ab95c7257c18$var$setCacheAdd;


/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $b6b113104971d0a8$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $b6b113104971d0a8$export$2e2bcd8739ae039 = $b6b113104971d0a8$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $c131592e54ba9b88$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $5Sw7u.default);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$c131592e54ba9b88$var$SetCache.prototype.add = $c131592e54ba9b88$var$SetCache.prototype.push = (0, $72e5ab95c7257c18$export$2e2bcd8739ae039);
$c131592e54ba9b88$var$SetCache.prototype.has = (0, $b6b113104971d0a8$export$2e2bcd8739ae039);
var $c131592e54ba9b88$export$2e2bcd8739ae039 = $c131592e54ba9b88$var$SetCache;


/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $884b246c373683d7$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $884b246c373683d7$export$2e2bcd8739ae039 = $884b246c373683d7$var$arraySome;


/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e583086f10c4851b$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $e583086f10c4851b$export$2e2bcd8739ae039 = $e583086f10c4851b$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $78cd4d6f13b9771e$var$COMPARE_PARTIAL_FLAG = 1, $78cd4d6f13b9771e$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $78cd4d6f13b9771e$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $78cd4d6f13b9771e$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $78cd4d6f13b9771e$var$COMPARE_UNORDERED_FLAG ? new (0, $c131592e54ba9b88$export$2e2bcd8739ae039) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $884b246c373683d7$export$2e2bcd8739ae039)(other, function(othValue, othIndex) {
                if (!(0, $e583086f10c4851b$export$2e2bcd8739ae039)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
var $78cd4d6f13b9771e$export$2e2bcd8739ae039 = $78cd4d6f13b9771e$var$equalArrays;



var $hwtsf = parcelRequire("hwtsf");

var $hNU6C = parcelRequire("hNU6C");

var $5TPq9 = parcelRequire("5TPq9");

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $0a44bb80313e2977$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $0a44bb80313e2977$export$2e2bcd8739ae039 = $0a44bb80313e2977$var$mapToArray;


/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $35f29b582870dbac$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $35f29b582870dbac$export$2e2bcd8739ae039 = $35f29b582870dbac$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $64cd6d0f849c3e76$var$COMPARE_PARTIAL_FLAG = 1, $64cd6d0f849c3e76$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $64cd6d0f849c3e76$var$boolTag = "[object Boolean]", $64cd6d0f849c3e76$var$dateTag = "[object Date]", $64cd6d0f849c3e76$var$errorTag = "[object Error]", $64cd6d0f849c3e76$var$mapTag = "[object Map]", $64cd6d0f849c3e76$var$numberTag = "[object Number]", $64cd6d0f849c3e76$var$regexpTag = "[object RegExp]", $64cd6d0f849c3e76$var$setTag = "[object Set]", $64cd6d0f849c3e76$var$stringTag = "[object String]", $64cd6d0f849c3e76$var$symbolTag = "[object Symbol]";
var $64cd6d0f849c3e76$var$arrayBufferTag = "[object ArrayBuffer]", $64cd6d0f849c3e76$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $64cd6d0f849c3e76$var$symbolProto = (0, $hwtsf.default) ? (0, $hwtsf.default).prototype : undefined, $64cd6d0f849c3e76$var$symbolValueOf = $64cd6d0f849c3e76$var$symbolProto ? $64cd6d0f849c3e76$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $64cd6d0f849c3e76$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $64cd6d0f849c3e76$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $64cd6d0f849c3e76$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $hNU6C.default)(object), new (0, $hNU6C.default)(other))) return false;
            return true;
        case $64cd6d0f849c3e76$var$boolTag:
        case $64cd6d0f849c3e76$var$dateTag:
        case $64cd6d0f849c3e76$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $5TPq9.default)(+object, +other);
        case $64cd6d0f849c3e76$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $64cd6d0f849c3e76$var$regexpTag:
        case $64cd6d0f849c3e76$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $64cd6d0f849c3e76$var$mapTag:
            var convert = (0, $0a44bb80313e2977$export$2e2bcd8739ae039);
        case $64cd6d0f849c3e76$var$setTag:
            var isPartial = bitmask & $64cd6d0f849c3e76$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $35f29b582870dbac$export$2e2bcd8739ae039));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $64cd6d0f849c3e76$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $78cd4d6f13b9771e$export$2e2bcd8739ae039)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $64cd6d0f849c3e76$var$symbolTag:
            if ($64cd6d0f849c3e76$var$symbolValueOf) return $64cd6d0f849c3e76$var$symbolValueOf.call(object) == $64cd6d0f849c3e76$var$symbolValueOf.call(other);
    }
    return false;
}
var $64cd6d0f849c3e76$export$2e2bcd8739ae039 = $64cd6d0f849c3e76$var$equalByTag;



var $eNbR6 = parcelRequire("eNbR6");
/** Used to compose bitmasks for value comparisons. */ var $ebc0361046d549c9$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $ebc0361046d549c9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ebc0361046d549c9$var$hasOwnProperty = $ebc0361046d549c9$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ebc0361046d549c9$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $ebc0361046d549c9$var$COMPARE_PARTIAL_FLAG, objProps = (0, $eNbR6.default)(object), objLength = objProps.length, othProps = (0, $eNbR6.default)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $ebc0361046d549c9$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
var $ebc0361046d549c9$export$2e2bcd8739ae039 = $ebc0361046d549c9$var$equalObjects;



var $6JaTE = parcelRequire("6JaTE");

var $eA9yl = parcelRequire("eA9yl");

var $43Y3b = parcelRequire("43Y3b");

var $dK8Wz = parcelRequire("dK8Wz");
/** Used to compose bitmasks for value comparisons. */ var $5a2a119a9a30679a$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $5a2a119a9a30679a$var$argsTag = "[object Arguments]", $5a2a119a9a30679a$var$arrayTag = "[object Array]", $5a2a119a9a30679a$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $5a2a119a9a30679a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5a2a119a9a30679a$var$hasOwnProperty = $5a2a119a9a30679a$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $5a2a119a9a30679a$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $eA9yl.default)(object), othIsArr = (0, $eA9yl.default)(other), objTag = objIsArr ? $5a2a119a9a30679a$var$arrayTag : (0, $6JaTE.default)(object), othTag = othIsArr ? $5a2a119a9a30679a$var$arrayTag : (0, $6JaTE.default)(other);
    objTag = objTag == $5a2a119a9a30679a$var$argsTag ? $5a2a119a9a30679a$var$objectTag : objTag;
    othTag = othTag == $5a2a119a9a30679a$var$argsTag ? $5a2a119a9a30679a$var$objectTag : othTag;
    var objIsObj = objTag == $5a2a119a9a30679a$var$objectTag, othIsObj = othTag == $5a2a119a9a30679a$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $43Y3b.default)(object)) {
        if (!(0, $43Y3b.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $5dLfO.default));
        return objIsArr || (0, $dK8Wz.default)(object) ? (0, $78cd4d6f13b9771e$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack) : (0, $64cd6d0f849c3e76$export$2e2bcd8739ae039)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $5a2a119a9a30679a$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $5a2a119a9a30679a$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $5a2a119a9a30679a$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $5dLfO.default));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $5dLfO.default));
    return (0, $ebc0361046d549c9$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack);
}
var $5a2a119a9a30679a$export$2e2bcd8739ae039 = $5a2a119a9a30679a$var$baseIsEqualDeep;



var $9XysK = parcelRequire("9XysK");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $8cdf62866f460374$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $9XysK.default)(value) && !(0, $9XysK.default)(other)) return value !== value && other !== other;
    return (0, $5a2a119a9a30679a$export$2e2bcd8739ae039)(value, other, bitmask, customizer, $8cdf62866f460374$var$baseIsEqual, stack);
}
var $8cdf62866f460374$export$2e2bcd8739ae039 = $8cdf62866f460374$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $3883254551e1c45c$var$COMPARE_PARTIAL_FLAG = 1, $3883254551e1c45c$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $3883254551e1c45c$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new (0, $5dLfO.default);
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? (0, $8cdf62866f460374$export$2e2bcd8739ae039)(srcValue, objValue, $3883254551e1c45c$var$COMPARE_PARTIAL_FLAG | $3883254551e1c45c$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
var $3883254551e1c45c$export$2e2bcd8739ae039 = $3883254551e1c45c$var$baseIsMatch;



var $55CT4 = parcelRequire("55CT4");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $93045016c4f0fe00$var$isStrictComparable(value) {
    return value === value && !(0, $55CT4.default)(value);
}
var $93045016c4f0fe00$export$2e2bcd8739ae039 = $93045016c4f0fe00$var$isStrictComparable;



var $31LnV = parcelRequire("31LnV");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $a261f4d6329851d0$var$getMatchData(object) {
    var result = (0, $31LnV.default)(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            (0, $93045016c4f0fe00$export$2e2bcd8739ae039)(value)
        ];
    }
    return result;
}
var $a261f4d6329851d0$export$2e2bcd8739ae039 = $a261f4d6329851d0$var$getMatchData;


/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $b24731c0968b40bc$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
var $b24731c0968b40bc$export$2e2bcd8739ae039 = $b24731c0968b40bc$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $0a2d5f2939faa887$var$baseMatches(source) {
    var matchData = (0, $a261f4d6329851d0$export$2e2bcd8739ae039)(source);
    if (matchData.length == 1 && matchData[0][2]) return (0, $b24731c0968b40bc$export$2e2bcd8739ae039)(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || (0, $3883254551e1c45c$export$2e2bcd8739ae039)(object, source, matchData);
    };
}
var $0a2d5f2939faa887$export$2e2bcd8739ae039 = $0a2d5f2939faa887$var$baseMatches;




/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $22a992897f809c7e$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
var $22a992897f809c7e$export$2e2bcd8739ae039 = $22a992897f809c7e$var$baseHasIn;




var $774DM = parcelRequire("774DM");

var $eA9yl = parcelRequire("eA9yl");

var $7Jqv7 = parcelRequire("7Jqv7");

var $XPYOH = parcelRequire("XPYOH");

var $e9clf = parcelRequire("e9clf");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $c9d7e073f88ea34c$var$hasPath(object, path, hasFunc) {
    path = (0, $9bf1bc98bfb8909a$export$2e2bcd8739ae039)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, $e9clf.default)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, $XPYOH.default)(length) && (0, $7Jqv7.default)(key, length) && ((0, $eA9yl.default)(object) || (0, $774DM.default)(object));
}
var $c9d7e073f88ea34c$export$2e2bcd8739ae039 = $c9d7e073f88ea34c$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $f537a0e45d3ec359$var$hasIn(object, path) {
    return object != null && (0, $c9d7e073f88ea34c$export$2e2bcd8739ae039)(object, path, (0, $22a992897f809c7e$export$2e2bcd8739ae039));
}
var $f537a0e45d3ec359$export$2e2bcd8739ae039 = $f537a0e45d3ec359$var$hasIn;






var $e9clf = parcelRequire("e9clf");
/** Used to compose bitmasks for value comparisons. */ var $07a91392a8336763$var$COMPARE_PARTIAL_FLAG = 1, $07a91392a8336763$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $07a91392a8336763$var$baseMatchesProperty(path, srcValue) {
    if ((0, $052e06a52ad6a01d$export$2e2bcd8739ae039)(path) && (0, $93045016c4f0fe00$export$2e2bcd8739ae039)(srcValue)) return (0, $b24731c0968b40bc$export$2e2bcd8739ae039)((0, $e9clf.default)(path), srcValue);
    return function(object) {
        var objValue = (0, $de005c3c82706228$export$2e2bcd8739ae039)(object, path);
        return objValue === undefined && objValue === srcValue ? (0, $f537a0e45d3ec359$export$2e2bcd8739ae039)(object, path) : (0, $8cdf62866f460374$export$2e2bcd8739ae039)(srcValue, objValue, $07a91392a8336763$var$COMPARE_PARTIAL_FLAG | $07a91392a8336763$var$COMPARE_UNORDERED_FLAG);
    };
}
var $07a91392a8336763$export$2e2bcd8739ae039 = $07a91392a8336763$var$baseMatchesProperty;




var $eA9yl = parcelRequire("eA9yl");
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $4a424799a0d7eb91$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
var $4a424799a0d7eb91$export$2e2bcd8739ae039 = $4a424799a0d7eb91$var$baseProperty;



/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $b8acccd980ba5911$var$basePropertyDeep(path) {
    return function(object) {
        return (0, $ec9ff061c841039c$export$2e2bcd8739ae039)(object, path);
    };
}
var $b8acccd980ba5911$export$2e2bcd8739ae039 = $b8acccd980ba5911$var$basePropertyDeep;




var $e9clf = parcelRequire("e9clf");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $47d7b0945c901d16$var$property(path) {
    return (0, $052e06a52ad6a01d$export$2e2bcd8739ae039)(path) ? (0, $4a424799a0d7eb91$export$2e2bcd8739ae039)((0, $e9clf.default)(path)) : (0, $b8acccd980ba5911$export$2e2bcd8739ae039)(path);
}
var $47d7b0945c901d16$export$2e2bcd8739ae039 = $47d7b0945c901d16$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $c522323f288f6e96$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return 0, $019f7528cf907441$export$2e2bcd8739ae039;
    if (typeof value == "object") return (0, $eA9yl.default)(value) ? (0, $07a91392a8336763$export$2e2bcd8739ae039)(value[0], value[1]) : (0, $0a2d5f2939faa887$export$2e2bcd8739ae039)(value);
    return (0, $47d7b0945c901d16$export$2e2bcd8739ae039)(value);
}
var $c522323f288f6e96$export$2e2bcd8739ae039 = $c522323f288f6e96$var$baseIteratee;


/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $6fa26b60fab43204$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = (0, $c522323f288f6e96$export$2e2bcd8739ae039)(iteratee, 3);
    (0, $7c466d0ea92d97f8$export$2e2bcd8739ae039)(object, function(value, key, object) {
        (0, $8Xlz0.default)(result, iteratee(value, key, object), value);
    });
    return result;
}
var $6fa26b60fab43204$export$2e2bcd8739ae039 = $6fa26b60fab43204$var$mapKeys;


var $fOFG0 = parcelRequire("fOFG0");


var $7Jqv7 = parcelRequire("7Jqv7");

var $55CT4 = parcelRequire("55CT4");

var $e9clf = parcelRequire("e9clf");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $aaefeec8d4fe0837$var$baseSet(object, path, value, customizer) {
    if (!(0, $55CT4.default)(object)) return object;
    path = (0, $9bf1bc98bfb8909a$export$2e2bcd8739ae039)(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = (0, $e9clf.default)(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = (0, $55CT4.default)(objValue) ? objValue : (0, $7Jqv7.default)(path[index + 1]) ? [] : {};
        }
        (0, $fOFG0.default)(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
var $aaefeec8d4fe0837$export$2e2bcd8739ae039 = $aaefeec8d4fe0837$var$baseSet;


/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $c26094c110838037$var$set(object, path, value) {
    return object == null ? object : (0, $aaefeec8d4fe0837$export$2e2bcd8739ae039)(object, path, value);
}
var $c26094c110838037$export$2e2bcd8739ae039 = $c26094c110838037$var$set;


var $cDRNl = parcelRequire("cDRNl");
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $0e1ef112a5678cb5$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
var $0e1ef112a5678cb5$export$2e2bcd8739ae039 = $0e1ef112a5678cb5$var$last;



/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $df6e0a0e3e355d0e$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
var $df6e0a0e3e355d0e$export$2e2bcd8739ae039 = $df6e0a0e3e355d0e$var$baseSlice;


/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $c3d90c86e994234b$var$parent(object, path) {
    return path.length < 2 ? object : (0, $ec9ff061c841039c$export$2e2bcd8739ae039)(object, (0, $df6e0a0e3e355d0e$export$2e2bcd8739ae039)(path, 0, -1));
}
var $c3d90c86e994234b$export$2e2bcd8739ae039 = $c3d90c86e994234b$var$parent;



var $e9clf = parcelRequire("e9clf");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $0a59692353704216$var$baseUnset(object, path) {
    path = (0, $9bf1bc98bfb8909a$export$2e2bcd8739ae039)(path, object);
    object = (0, $c3d90c86e994234b$export$2e2bcd8739ae039)(object, path);
    return object == null || delete object[(0, $e9clf.default)((0, $0e1ef112a5678cb5$export$2e2bcd8739ae039)(path))];
}
var $0a59692353704216$export$2e2bcd8739ae039 = $0a59692353704216$var$baseUnset;


/**
 * Removes the property at `path` of `object`.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 7 } }] };
 * _.unset(object, 'a[0].b.c');
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 *
 * _.unset(object, ['a', '0', 'b', 'c']);
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 */ function $21a8c6b920d6a9a0$var$unset(object, path) {
    return object == null ? true : (0, $0a59692353704216$export$2e2bcd8739ae039)(object, path);
}
var $21a8c6b920d6a9a0$export$2e2bcd8739ae039 = $21a8c6b920d6a9a0$var$unset;


const $b7a8d4f3365bbf44$var$fieldTypes = [
    {
        value: "string",
        label: "String"
    },
    {
        value: "number",
        label: "Number"
    },
    {
        value: "string[]",
        label: "List of String"
    },
    {
        value: "number[]",
        label: "List of Number"
    },
    {
        value: "json",
        label: "JSON"
    }
];
const $b7a8d4f3365bbf44$export$831af5b09d04fe74 = (value)=>{
    if (typeof value === "number") return "number";
    if (Array.isArray(value)) {
        if (value.every((v)=>typeof v === "number")) return "number[]";
        if (value.every((v)=>typeof v === "string")) return "string[]";
        return "json";
    }
    if (typeof value === "object") return "json";
    return "string";
};
const $b7a8d4f3365bbf44$export$5700206816b2d436 = (type)=>{
    if (type === "string") return {
        type: "string",
        label: "Value"
    };
    if (type === "number") return {
        type: "number",
        label: "Value"
    };
    if ([
        "string[]",
        "number[]"
    ].includes(type)) return {
        type: "array",
        label: "Value",
        minItems: 1,
        items: {
            type: type.replace("[]", "")
        }
    };
    if (type === "json") return {
        type: "json",
        label: "Value"
    };
    return null;
};
const $b7a8d4f3365bbf44$export$3e0178b40c01d493 = (obj, path, newKey)=>{
    const parts = (0, $cDRNl.default)(path);
    const last = parts.pop();
    const isRoot = !parts.length;
    const valuesAtPath = isRoot ? obj : (0, $de005c3c82706228$export$2e2bcd8739ae039)(obj, parts);
    const valuesWithNewKey = (0, $6fa26b60fab43204$export$2e2bcd8739ae039)(valuesAtPath, (_, key)=>{
        return key === last ? newKey : key;
    });
    valuesWithNewKey[newKey] = valuesAtPath[last];
    return isRoot ? valuesWithNewKey : (0, $c26094c110838037$export$2e2bcd8739ae039)((0, $jGWdr.default)(obj), parts, valuesWithNewKey);
};
function $b7a8d4f3365bbf44$export$70bee8710139c684(props) {
    const { pointer: pointer, property: property, existentProperties: existentProperties } = props;
    const ctx = (0, $jTKGQ.useFormikContext)();
    const value = pointer ? (0, $de005c3c82706228$export$2e2bcd8739ae039)(ctx.values, pointer) : ctx.values;
    const [fieldType, setFieldType] = (0, $8v0nu.useState)($b7a8d4f3365bbf44$export$831af5b09d04fe74(value));
    const [keyFieldValue, setKeyFieldValue] = (0, $8v0nu.useState)(property);
    const [keyError, setKeyError] = (0, $8v0nu.useState)();
    const onFieldKeyBlur = (0, $8v0nu.useCallback)((e)=>{
        const newProp = e.target.value;
        const keyExists = existentProperties.includes(newProp);
        // Revert to original value in case of error.
        setKeyError(undefined);
        if (keyExists || newProp === "") {
            setKeyFieldValue(property);
            return;
        }
        // Update the form values with the new property name.
        if (newProp === property) return;
        ctx.setValues($b7a8d4f3365bbf44$export$3e0178b40c01d493(ctx.values, pointer, newProp));
        const newPointer = pointer.replace(new RegExp(`${property}$`, "g"), newProp);
        ctx.unregisterField(pointer);
        ctx.registerField(newPointer, {});
    }, [
        pointer,
        property,
        value,
        ctx
    ]);
    const removeProperty = (0, $8v0nu.useCallback)((pointer)=>{
        ctx.unregisterField(pointer);
        const valuesCopy = {
            ...ctx.values
        };
        (0, $21a8c6b920d6a9a0$export$2e2bcd8739ae039)(valuesCopy, pointer);
        ctx.setValues(valuesCopy);
    }, [
        ctx
    ]);
    const field = (0, $8v0nu.useMemo)(()=>$b7a8d4f3365bbf44$export$5700206816b2d436(fieldType), [
        fieldType
    ]);
    return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $8f2967926209c75b$export$e154be390aa0e14), {
        children: [
            /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $8f2967926209c75b$export$4177b95adc81bedf), {
                children: [
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9HGsN.Box), {
                        children: /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $02b238a4ba05f901$export$fe5d99d8691b3f62), {
                            isInvalid: !!keyError,
                            children: [
                                /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $5678c8a868262504$export$6e5a9cd40e0c9b97), {
                                    size: "sm",
                                    bg: "surface.500",
                                    borderColor: "base.200",
                                    children: [
                                        /*#__PURE__*/ (0, $kxTYF.jsx)((0, $0f6ca7b518b921a6$export$b5cdbc34a3b65f4c), {
                                            pointerEvents: "none",
                                            children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$7b73804de18dac8e), {
                                                title: "Value for the object property"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3d8cf0c200c5d2d0$export$f5b8910cec6cf069), {
                                            type: "text",
                                            placeholder: "Property name",
                                            value: keyFieldValue,
                                            onChange: (e)=>{
                                                const value = e.target.value;
                                                setKeyFieldValue(value);
                                                if (existentProperties.includes(value)) setKeyError("Property already exists");
                                                else if (value === "") setKeyError("Property name cannot be empty");
                                            },
                                            onBlur: onFieldKeyBlur
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $210fc61c9a876d6f$export$185a8afe504e8fca), {
                                    children: keyError
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $fa11479c07f903fc$export$f51f4c4ede09e011), {
                        gap: 4,
                        children: [
                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $10c1d0a50fcf4e99$export$ef9b1a59e592288f), {
                                size: "sm",
                                bg: "surface.500",
                                borderColor: "base.200",
                                borderRadius: "md",
                                value: fieldType,
                                onChange: (e)=>{
                                    const type = e.target.value;
                                    setFieldType(type);
                                    const schema = $b7a8d4f3365bbf44$export$5700206816b2d436(type);
                                    if (schema) {
                                        const valuesForSchema = (0, $c1e8126e9c607e51$export$bb0693b91fc28141)(schema);
                                        ctx.setFieldValue(pointer, valuesForSchema);
                                    }
                                },
                                children: $b7a8d4f3365bbf44$var$fieldTypes.map((type)=>/*#__PURE__*/ (0, $kxTYF.jsx)("option", {
                                        value: type.value,
                                        children: type.label
                                    }, type.value))
                            }),
                            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8f2967926209c75b$export$4520a427b44f3477), {
                                "aria-label": "Remove item",
                                onClick: ()=>removeProperty(pointer)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8f2967926209c75b$export$47bfc31835db02f5), {
                children: field && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $a43fa2f2fffac74f$export$bac6ca00840ef02b), {
                    field: field,
                    pointer: pointer
                })
            })
        ]
    });
}


/**
 * Finds the next unique value by appending an incrementing number to the given
 * value.
 *
 * @param value - The base value to which the incrementing number will be
 * appended.
 * @param valueKeys - An array of existing values to check against for
 * uniqueness.
 * @returns The next unique value that is not present in the valueKeys array.
 */ const $0fcc824096db126c$var$findNextValue = (value, valueKeys)=>{
    let i = 0;
    while(true){
        const v = `${value}-${++i}`;
        if (!valueKeys.includes(v)) return v;
    }
};
function $0fcc824096db126c$export$fc949cf2e017c75f(props) {
    const { pointer: pointer } = props;
    const field = props.field;
    const ctx = (0, $jTKGQ.useFormikContext)();
    const values = pointer ? (0, $de005c3c82706228$export$2e2bcd8739ae039)(ctx.values, pointer) : ctx.values;
    const schemaKeys = Object.keys(field.properties);
    const valueKeys = Object.keys(values || {});
    const unlistedKeys = valueKeys.filter((key)=>!schemaKeys.includes(key));
    return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $kxTYF.Fragment), {
        children: [
            Object.entries(field.properties).map(([key, item])=>/*#__PURE__*/ (0, $kxTYF.jsx)((0, $a43fa2f2fffac74f$export$bac6ca00840ef02b), {
                    pointer: pointer ? `${pointer}.${key}` : key,
                    field: item,
                    isRequired: field.required?.includes(key)
                }, key)),
            field.additionalProperties && /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $kxTYF.Fragment), {
                children: [
                    unlistedKeys.map((key)=>/*#__PURE__*/ (0, $kxTYF.jsx)((0, $b7a8d4f3365bbf44$export$70bee8710139c684), {
                            property: key,
                            existentProperties: valueKeys.filter((k)=>k !== key),
                            pointer: pointer ? `${pointer}.${key}` : key
                        }, key)),
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $b8b7f6458056e8af$export$353f5b6fc5456de1), {
                        colorScheme: "base",
                        size: "sm",
                        onClick: ()=>{
                            const nextKey = $0fcc824096db126c$var$findNextValue("property", valueKeys);
                            ctx.setFieldValue(pointer ? `${pointer}.${nextKey}` : nextKey, "");
                        },
                        "aria-label": "Add property",
                        leftIcon: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $9138db1f951ed55c$export$3a9f56a1d1f9a714), {}),
                        children: "Add property"
                    })
                ]
            })
        ]
    });
}



var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");


function $b10f7d2a328f4eb8$export$a9edb623e575de0d(props) {
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8f2967926209c75b$export$528341e82434bd), {
        label: props.field.label,
        children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $0fcc824096db126c$export$fc949cf2e017c75f), {
            ...props
        })
    });
}



var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");



var $jTKGQ = parcelRequire("jTKGQ");



function $a19b114acf696fe3$export$a7e262ad5a444678(props) {
    const { pointer: pointer, isRequired: isRequired } = props;
    const field = props.field;
    return /*#__PURE__*/ (0, $kxTYF.jsx)($a19b114acf696fe3$var$ArrayItem, {
        label: field.label,
        pointer: pointer,
        field: field,
        isRequired: isRequired
    });
}
function $a19b114acf696fe3$var$ArrayItem(props) {
    const { label: label, field: field, pointer: pointer, onRemove: onRemove, removeDisabled: removeDisabled, isRequired: isRequired } = props;
    const { values: values } = (0, $jTKGQ.useFormikContext)();
    const fields = (0, $de005c3c82706228$export$2e2bcd8739ae039)(values, pointer) || [];
    const items = field.items;
    const minItems = field.minItems || 0;
    const maxItems = field.maxItems || Infinity;
    const isFixedCount = minItems === maxItems;
    // Check if the nested array is special like an array of strings (Checkboxes)
    // for example. Same logic as widget renderer.
    const isRegularNestedArray = items.type === "array" && ![
        "string",
        "number"
    ].includes(items.items.type);
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $jTKGQ.FieldArray), {
        name: pointer,
        render: ({ remove: remove, push: push })=>/*#__PURE__*/ (0, $kxTYF.jsx)((0, $8f2967926209c75b$export$528341e82434bd), {
                label: label,
                isRequired: isRequired,
                onRemove: onRemove,
                onAdd: isFixedCount ? undefined : ()=>{
                    push((0, $c1e8126e9c607e51$export$bb0693b91fc28141)(items));
                },
                addDisabled: fields.length >= maxItems,
                removeDisabled: removeDisabled,
                children: fields.length ? /*#__PURE__*/ (0, $kxTYF.jsx)((0, $95452836d4e53d4d$export$54c2e3dc7acea9f5), {
                    display: "flex",
                    flexDirection: "column",
                    gap: 4,
                    children: fields.map((_, index)=>/*#__PURE__*/ (0, $kxTYF.jsx)((0, $95452836d4e53d4d$export$a7b06bfba60a8a78), {
                            children: isRegularNestedArray ? /*#__PURE__*/ (0, $kxTYF.jsx)($a19b114acf696fe3$var$ArrayItem, {
                                label: (0, $81cc9f2a42ee34ee$export$ebfdb425fb84a7c7)(items, index)?.formatted,
                                pointer: `${pointer}.${index}`,
                                field: items,
                                onRemove: isFixedCount ? undefined : ()=>{
                                    remove(index);
                                },
                                removeDisabled: fields.length <= minItems
                            }) : /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8f2967926209c75b$export$528341e82434bd), {
                                label: (0, $81cc9f2a42ee34ee$export$ebfdb425fb84a7c7)(items, index)?.formatted,
                                onRemove: isFixedCount ? undefined : ()=>{
                                    remove(index);
                                },
                                removeDisabled: fields.length <= minItems,
                                children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $a43fa2f2fffac74f$export$bac6ca00840ef02b), {
                                    pointer: `${pointer}.${index}`,
                                    field: items,
                                    isRequired: false
                                })
                            })
                        }, index /* eslint-disable-line react/no-array-index-key */ ))
                }) : /*#__PURE__*/ (0, $kxTYF.jsx)("p", {
                    children: "No items"
                })
            })
    });
}



var $kxTYF = parcelRequire("kxTYF");
parcelRequire("8v0nu");



var $jTKGQ = parcelRequire("jTKGQ");




function $a3347928c80810e5$export$9436aa8cdadea878(props) {
    const { pointer: pointer, isRequired: isRequired } = props;
    const field = props.field;
    const { values: values } = (0, $jTKGQ.useFormikContext)();
    const fields = (0, $de005c3c82706228$export$2e2bcd8739ae039)(values, pointer) || [];
    const minItems = field.minItems || 0;
    const maxItems = field.maxItems || Infinity;
    const isFixed = minItems === maxItems;
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $jTKGQ.FieldArray), {
        name: pointer,
        render: ({ remove: remove, push: push })=>/*#__PURE__*/ (0, $kxTYF.jsx)((0, $8f2967926209c75b$export$528341e82434bd), {
                isRequired: isRequired,
                label: field.label,
                onAdd: isFixed ? undefined : ()=>{
                    push((0, $c1e8126e9c607e51$export$bb0693b91fc28141)(field.items));
                },
                addDisabled: fields.length >= maxItems,
                children: fields.length ? /*#__PURE__*/ (0, $kxTYF.jsx)((0, $95452836d4e53d4d$export$54c2e3dc7acea9f5), {
                    display: "flex",
                    gap: 4,
                    flexDir: isFixed ? "row" : "column",
                    children: fields.map((_, index)=>/*#__PURE__*/ (0, $kxTYF.jsx)((0, $95452836d4e53d4d$export$a7b06bfba60a8a78), {
                            display: "flex",
                            width: "100%",
                            children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $02719087c988c832$export$2a4b7b80ff003e13), {
                                pointer: `${pointer}.${index}`,
                                type: field.items.type,
                                field: field.items,
                                label: (0, $81cc9f2a42ee34ee$export$ebfdb425fb84a7c7)(field.items, index)?.formatted,
                                isDeletable: !isFixed,
                                onDeleteClick: ()=>{
                                    remove(index);
                                },
                                transformValue: (v)=>{
                                    if (field.items.type === "number") {
                                        const n = Number(v);
                                        return isNaN(n) ? null : n;
                                    }
                                    return v;
                                },
                                isDeleteDisabled: fields.length <= minItems
                            })
                        }, index /* eslint-disable-line react/no-array-index-key */ ))
                }) : /*#__PURE__*/ (0, $kxTYF.jsx)("p", {
                    children: "No items"
                })
            })
    });
}



var $kxTYF = parcelRequire("kxTYF");

var $8v0nu = parcelRequire("8v0nu");


var $jTKGQ = parcelRequire("jTKGQ");
function $2b339004796b0e2f$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $2b339004796b0e2f$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2b339004796b0e2f$export$2e2bcd8739ae039(o);
}



function $efdd2b035d469606$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $2b339004796b0e2f$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $2b339004796b0e2f$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $61a2d357b836eaab$export$2e2bcd8739ae039(t) {
    var i = (0, $efdd2b035d469606$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $2b339004796b0e2f$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $a038852823ee2701$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $61a2d357b836eaab$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $0604ab8b4211d13c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0604ab8b4211d13c$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0604ab8b4211d13c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $a038852823ee2701$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0604ab8b4211d13c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


function $2c46bfc13d730b1c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $86e2ab5507bf31b8$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $1cdff5d382dc9bd7$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $fb95e850070d972e$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $1cdff5d382dc9bd7$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $1cdff5d382dc9bd7$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $c06b5feaeed0bffe$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $5e8d680428cd6d3c$export$2e2bcd8739ae039(r, e) {
    return (0, $2c46bfc13d730b1c$export$2e2bcd8739ae039)(r) || (0, $86e2ab5507bf31b8$export$2e2bcd8739ae039)(r, e) || (0, $fb95e850070d972e$export$2e2bcd8739ae039)(r, e) || (0, $c06b5feaeed0bffe$export$2e2bcd8739ae039)();
}


function $49760e397f3641cf$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $a69ac13ab3c3f3dd$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $49760e397f3641cf$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $8v0nu = parcelRequire("8v0nu");
var $502643e4fe0f2f4b$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $502643e4fe0f2f4b$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $a69ac13ab3c3f3dd$export$2e2bcd8739ae039)(_ref, $502643e4fe0f2f4b$var$_excluded);
    var _useState = (0, $8v0nu.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $5e8d680428cd6d3c$export$2e2bcd8739ae039)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $8v0nu.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $5e8d680428cd6d3c$export$2e2bcd8739ae039)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $8v0nu.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $5e8d680428cd6d3c$export$2e2bcd8739ae039)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $8v0nu.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === "function") propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $8v0nu.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === "function") newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $8v0nu.useCallback)(function() {
        if (typeof propsOnMenuOpen === "function") propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $8v0nu.useCallback)(function() {
        if (typeof propsOnMenuClose === "function") propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}



var $2Jgqn = parcelRequire("2Jgqn");

var $8v0nu = parcelRequire("8v0nu");

var $2Jgqn = parcelRequire("2Jgqn");

function $cad7451c9e32255d$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $bd6fca2392fb7de2$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $61a2d357b836eaab$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $bd6fca2392fb7de2$export$2e2bcd8739ae039(e, r, t) {
    return r && $bd6fca2392fb7de2$var$_defineProperties(e.prototype, r), t && $bd6fca2392fb7de2$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



function $6c7ef991d1028cee$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $3e402af6c1df600a$export$2e2bcd8739ae039)(t, e);
}






function $3688045288b2795c$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $2b339004796b0e2f$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $8936f896c18fae91$export$2e2bcd8739ae039)(t);
}


function $1a0a5e846fa7425c$export$2e2bcd8739ae039(t) {
    var r = (0, $ed6a999545bb9645$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $53a741574f109c42$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $53a741574f109c42$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $3688045288b2795c$export$2e2bcd8739ae039)(this, e);
    };
}



function $4b5563dfee11916e$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $1cdff5d382dc9bd7$export$2e2bcd8739ae039)(r);
}


function $688e32403021fe54$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $c8c95eadc4281afa$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $aba02085c81f3bc8$export$2e2bcd8739ae039(r) {
    return (0, $4b5563dfee11916e$export$2e2bcd8739ae039)(r) || (0, $688e32403021fe54$export$2e2bcd8739ae039)(r) || (0, $fb95e850070d972e$export$2e2bcd8739ae039)(r) || (0, $c8c95eadc4281afa$export$2e2bcd8739ae039)();
}



var $8v0nu = parcelRequire("8v0nu");


var $2Jgqn = parcelRequire("2Jgqn");

var $6iKRa = parcelRequire("6iKRa");



function $440595ef322c396e$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}




var $8v0nu = parcelRequire("8v0nu");

/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $abcde9a5beae68a3$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $abcde9a5beae68a3$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $abcde9a5beae68a3$export$803cd8101b6c182b = /*#__PURE__*/ $abcde9a5beae68a3$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $abcde9a5beae68a3$export$27b07d8a310ed8b5[0], side + "-" + $abcde9a5beae68a3$export$27b07d8a310ed8b5[1]), []);
const $abcde9a5beae68a3$export$96ec731ed4dcb222 = Math.min;
const $abcde9a5beae68a3$export$8960430cfd85939f = Math.max;
const $abcde9a5beae68a3$export$2077e0241d6afd3c = Math.round;
const $abcde9a5beae68a3$export$a3fe094919f356fd = Math.floor;
const $abcde9a5beae68a3$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $abcde9a5beae68a3$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $abcde9a5beae68a3$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $abcde9a5beae68a3$export$7d15b64cf5a3a4c4(start, value, end) {
    return $abcde9a5beae68a3$export$8960430cfd85939f(start, $abcde9a5beae68a3$export$96ec731ed4dcb222(value, end));
}
function $abcde9a5beae68a3$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $abcde9a5beae68a3$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $abcde9a5beae68a3$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $abcde9a5beae68a3$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $abcde9a5beae68a3$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $abcde9a5beae68a3$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($abcde9a5beae68a3$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $abcde9a5beae68a3$export$2b57e0052a6d6d4c(placement) {
    return $abcde9a5beae68a3$export$8a000a963141ac32($abcde9a5beae68a3$export$f28e8f882010718a(placement));
}
function $abcde9a5beae68a3$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $abcde9a5beae68a3$export$f0989780f32bfcda(placement);
    const alignmentAxis = $abcde9a5beae68a3$export$2b57e0052a6d6d4c(placement);
    const length = $abcde9a5beae68a3$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $abcde9a5beae68a3$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $abcde9a5beae68a3$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $abcde9a5beae68a3$export$496432a3699e50b1(placement) {
    const oppositePlacement = $abcde9a5beae68a3$export$9c5e28bad23365fa(placement);
    return [
        $abcde9a5beae68a3$export$2b182c584985588b(placement),
        oppositePlacement,
        $abcde9a5beae68a3$export$2b182c584985588b(oppositePlacement)
    ];
}
function $abcde9a5beae68a3$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$abcde9a5beae68a3$var$oppositeAlignmentMap[alignment]);
}
function $abcde9a5beae68a3$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $abcde9a5beae68a3$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $abcde9a5beae68a3$export$f0989780f32bfcda(placement);
    let list = $abcde9a5beae68a3$var$getSideList($abcde9a5beae68a3$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($abcde9a5beae68a3$export$2b182c584985588b));
    }
    return list;
}
function $abcde9a5beae68a3$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$abcde9a5beae68a3$var$oppositeSideMap[side]);
}
function $abcde9a5beae68a3$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $abcde9a5beae68a3$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $abcde9a5beae68a3$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $abcde9a5beae68a3$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $baea33fbd448a692$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $abcde9a5beae68a3$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $abcde9a5beae68a3$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $abcde9a5beae68a3$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $abcde9a5beae68a3$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $abcde9a5beae68a3$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $baea33fbd448a692$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $baea33fbd448a692$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $baea33fbd448a692$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $baea33fbd448a692$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $abcde9a5beae68a3$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $abcde9a5beae68a3$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $abcde9a5beae68a3$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $abcde9a5beae68a3$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $baea33fbd448a692$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $abcde9a5beae68a3$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $abcde9a5beae68a3$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $abcde9a5beae68a3$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $abcde9a5beae68a3$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $abcde9a5beae68a3$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $abcde9a5beae68a3$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $abcde9a5beae68a3$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $abcde9a5beae68a3$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $baea33fbd448a692$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $abcde9a5beae68a3$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $abcde9a5beae68a3$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $abcde9a5beae68a3$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $abcde9a5beae68a3$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $abcde9a5beae68a3$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $baea33fbd448a692$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $abcde9a5beae68a3$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $abcde9a5beae68a3$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $abcde9a5beae68a3$export$803cd8101b6c182b) ? $baea33fbd448a692$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $baea33fbd448a692$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $abcde9a5beae68a3$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $abcde9a5beae68a3$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $abcde9a5beae68a3$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $abcde9a5beae68a3$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $baea33fbd448a692$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $abcde9a5beae68a3$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $abcde9a5beae68a3$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $abcde9a5beae68a3$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $abcde9a5beae68a3$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $abcde9a5beae68a3$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $abcde9a5beae68a3$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $abcde9a5beae68a3$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $baea33fbd448a692$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $abcde9a5beae68a3$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $abcde9a5beae68a3$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === "y";
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $baea33fbd448a692$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $baea33fbd448a692$var$isAnySideFullyClipped(overflow) {
    return (0, $abcde9a5beae68a3$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $baea33fbd448a692$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $abcde9a5beae68a3$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $baea33fbd448a692$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $baea33fbd448a692$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $baea33fbd448a692$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $baea33fbd448a692$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $baea33fbd448a692$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $baea33fbd448a692$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $baea33fbd448a692$var$getBoundingRect(rects) {
    const minX = (0, $abcde9a5beae68a3$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $abcde9a5beae68a3$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $abcde9a5beae68a3$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $abcde9a5beae68a3$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $baea33fbd448a692$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $abcde9a5beae68a3$export$ee05aea0aeecbad4)($baea33fbd448a692$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $baea33fbd448a692$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $abcde9a5beae68a3$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $baea33fbd448a692$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $abcde9a5beae68a3$export$ee05aea0aeecbad4)($baea33fbd448a692$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $abcde9a5beae68a3$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $abcde9a5beae68a3$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $abcde9a5beae68a3$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $abcde9a5beae68a3$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $abcde9a5beae68a3$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $abcde9a5beae68a3$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $baea33fbd448a692$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $abcde9a5beae68a3$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $abcde9a5beae68a3$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $abcde9a5beae68a3$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $abcde9a5beae68a3$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $baea33fbd448a692$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $baea33fbd448a692$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $baea33fbd448a692$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $abcde9a5beae68a3$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $baea33fbd448a692$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $abcde9a5beae68a3$export$f28e8f882010718a)((0, $abcde9a5beae68a3$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $abcde9a5beae68a3$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $abcde9a5beae68a3$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $abcde9a5beae68a3$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $baea33fbd448a692$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $abcde9a5beae68a3$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $abcde9a5beae68a3$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $abcde9a5beae68a3$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $abcde9a5beae68a3$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $abcde9a5beae68a3$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $baea33fbd448a692$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $abcde9a5beae68a3$export$fef61f332f2c0afc)(options, state);
            const overflow = await $baea33fbd448a692$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $abcde9a5beae68a3$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $abcde9a5beae68a3$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $abcde9a5beae68a3$export$f28e8f882010718a)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $abcde9a5beae68a3$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $abcde9a5beae68a3$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $abcde9a5beae68a3$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $abcde9a5beae68a3$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $abcde9a5beae68a3$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $abcde9a5beae68a3$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $abcde9a5beae68a3$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $abcde9a5beae68a3$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $4e9f7fee644b6873$var$hasWindow() {
    return typeof window !== "undefined";
}
function $4e9f7fee644b6873$export$651544f548703224(node) {
    if ($4e9f7fee644b6873$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $4e9f7fee644b6873$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $4e9f7fee644b6873$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($4e9f7fee644b6873$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $4e9f7fee644b6873$export$8ee0fc9ee280b4ee(value) {
    if (!$4e9f7fee644b6873$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $4e9f7fee644b6873$export$38b2d434cce3ea22(value).Node;
}
function $4e9f7fee644b6873$export$45a5e7f76e0caa8d(value) {
    if (!$4e9f7fee644b6873$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $4e9f7fee644b6873$export$38b2d434cce3ea22(value).Element;
}
function $4e9f7fee644b6873$export$1b3bfaa9684536aa(value) {
    if (!$4e9f7fee644b6873$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $4e9f7fee644b6873$export$38b2d434cce3ea22(value).HTMLElement;
}
function $4e9f7fee644b6873$export$af51f0f06c0f328a(value) {
    if (!$4e9f7fee644b6873$var$hasWindow() || typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $4e9f7fee644b6873$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $4e9f7fee644b6873$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $4e9f7fee644b6873$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $4e9f7fee644b6873$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($4e9f7fee644b6873$export$651544f548703224(element));
}
function $4e9f7fee644b6873$export$89e651af02346cd4(element) {
    return [
        ":popover-open",
        ":modal"
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $4e9f7fee644b6873$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $4e9f7fee644b6873$export$78551043582a6a98();
    const css = $4e9f7fee644b6873$export$45a5e7f76e0caa8d(elementOrCss) ? $4e9f7fee644b6873$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $4e9f7fee644b6873$export$940d8225183e1404(element) {
    let currentNode = $4e9f7fee644b6873$export$4e12058fc4d51d56(element);
    while($4e9f7fee644b6873$export$1b3bfaa9684536aa(currentNode) && !$4e9f7fee644b6873$export$d1162fb0b6d4cd51(currentNode)){
        if ($4e9f7fee644b6873$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($4e9f7fee644b6873$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $4e9f7fee644b6873$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $4e9f7fee644b6873$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $4e9f7fee644b6873$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($4e9f7fee644b6873$export$651544f548703224(node));
}
function $4e9f7fee644b6873$export$3735103072e4a80(element) {
    return $4e9f7fee644b6873$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $4e9f7fee644b6873$export$dc8fc79fa2800137(element) {
    if ($4e9f7fee644b6873$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $4e9f7fee644b6873$export$4e12058fc4d51d56(node) {
    if ($4e9f7fee644b6873$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $4e9f7fee644b6873$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $4e9f7fee644b6873$export$e495491855dc5418(node);
    return $4e9f7fee644b6873$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $4e9f7fee644b6873$export$7cd01a57c8ca906c(node) {
    const parentNode = $4e9f7fee644b6873$export$4e12058fc4d51d56(node);
    if ($4e9f7fee644b6873$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($4e9f7fee644b6873$export$1b3bfaa9684536aa(parentNode) && $4e9f7fee644b6873$export$989e911fa9af580a(parentNode)) return parentNode;
    return $4e9f7fee644b6873$export$7cd01a57c8ca906c(parentNode);
}
function $4e9f7fee644b6873$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $4e9f7fee644b6873$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $4e9f7fee644b6873$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $4e9f7fee644b6873$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $4e9f7fee644b6873$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $4e9f7fee644b6873$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $4e9f7fee644b6873$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $4e9f7fee644b6873$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $e09b833f247449ac$var$getCssDimensions(element) {
    const css = (0, $4e9f7fee644b6873$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $4e9f7fee644b6873$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $abcde9a5beae68a3$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $abcde9a5beae68a3$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $e09b833f247449ac$var$unwrapElement(element) {
    return !(0, $4e9f7fee644b6873$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $e09b833f247449ac$var$getScale(element) {
    const domElement = $e09b833f247449ac$var$unwrapElement(element);
    if (!(0, $4e9f7fee644b6873$export$1b3bfaa9684536aa)(domElement)) return (0, $abcde9a5beae68a3$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $e09b833f247449ac$var$getCssDimensions(domElement);
    let x = ($ ? (0, $abcde9a5beae68a3$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $abcde9a5beae68a3$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $e09b833f247449ac$var$noOffsets = /*#__PURE__*/ (0, $abcde9a5beae68a3$export$a397704b5e280835)(0);
function $e09b833f247449ac$var$getVisualOffsets(element) {
    const win = (0, $4e9f7fee644b6873$export$38b2d434cce3ea22)(element);
    if (!(0, $4e9f7fee644b6873$export$78551043582a6a98)() || !win.visualViewport) return $e09b833f247449ac$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $e09b833f247449ac$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $4e9f7fee644b6873$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $e09b833f247449ac$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $e09b833f247449ac$var$unwrapElement(element);
    let scale = (0, $abcde9a5beae68a3$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $4e9f7fee644b6873$export$45a5e7f76e0caa8d)(offsetParent)) scale = $e09b833f247449ac$var$getScale(offsetParent);
        } else scale = $e09b833f247449ac$var$getScale(element);
    }
    const visualOffsets = $e09b833f247449ac$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $e09b833f247449ac$var$getVisualOffsets(domElement) : (0, $abcde9a5beae68a3$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $4e9f7fee644b6873$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $4e9f7fee644b6873$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $4e9f7fee644b6873$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $4e9f7fee644b6873$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $e09b833f247449ac$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $4e9f7fee644b6873$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $4e9f7fee644b6873$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $4e9f7fee644b6873$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $abcde9a5beae68a3$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $e09b833f247449ac$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $4e9f7fee644b6873$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $4e9f7fee644b6873$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $abcde9a5beae68a3$export$a397704b5e280835)(1);
    const offsets = (0, $abcde9a5beae68a3$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $4e9f7fee644b6873$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4e9f7fee644b6873$export$651544f548703224)(offsetParent) !== "body" || (0, $4e9f7fee644b6873$export$989e911fa9af580a)(documentElement)) scroll = (0, $4e9f7fee644b6873$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $4e9f7fee644b6873$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $e09b833f247449ac$var$getBoundingClientRect(offsetParent);
            scale = $e09b833f247449ac$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $e09b833f247449ac$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $e09b833f247449ac$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $4e9f7fee644b6873$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $e09b833f247449ac$var$getBoundingClientRect((0, $4e9f7fee644b6873$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $e09b833f247449ac$var$getDocumentRect(element) {
    const html = (0, $4e9f7fee644b6873$export$e495491855dc5418)(element);
    const scroll = (0, $4e9f7fee644b6873$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $abcde9a5beae68a3$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $abcde9a5beae68a3$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $e09b833f247449ac$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $4e9f7fee644b6873$export$3735103072e4a80)(body).direction === "rtl") x += (0, $abcde9a5beae68a3$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $e09b833f247449ac$var$getViewportRect(element, strategy) {
    const win = (0, $4e9f7fee644b6873$export$38b2d434cce3ea22)(element);
    const html = (0, $4e9f7fee644b6873$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $4e9f7fee644b6873$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $e09b833f247449ac$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $e09b833f247449ac$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $4e9f7fee644b6873$export$1b3bfaa9684536aa)(element) ? $e09b833f247449ac$var$getScale(element) : (0, $abcde9a5beae68a3$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $e09b833f247449ac$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $e09b833f247449ac$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $e09b833f247449ac$var$getDocumentRect((0, $4e9f7fee644b6873$export$e495491855dc5418)(element));
    else if ((0, $4e9f7fee644b6873$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $e09b833f247449ac$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $e09b833f247449ac$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $abcde9a5beae68a3$export$ee05aea0aeecbad4)(rect);
}
function $e09b833f247449ac$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $4e9f7fee644b6873$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $4e9f7fee644b6873$export$45a5e7f76e0caa8d)(parentNode) || (0, $4e9f7fee644b6873$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $4e9f7fee644b6873$export$3735103072e4a80)(parentNode).position === "fixed" || $e09b833f247449ac$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $e09b833f247449ac$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $4e9f7fee644b6873$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $4e9f7fee644b6873$export$45a5e7f76e0caa8d)(el) && (0, $4e9f7fee644b6873$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $4e9f7fee644b6873$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $4e9f7fee644b6873$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $4e9f7fee644b6873$export$45a5e7f76e0caa8d)(currentNode) && !(0, $4e9f7fee644b6873$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $4e9f7fee644b6873$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $4e9f7fee644b6873$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $4e9f7fee644b6873$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $e09b833f247449ac$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $4e9f7fee644b6873$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $e09b833f247449ac$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? (0, $4e9f7fee644b6873$export$89e651af02346cd4)(element) ? [] : $e09b833f247449ac$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $e09b833f247449ac$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $abcde9a5beae68a3$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $abcde9a5beae68a3$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $abcde9a5beae68a3$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $abcde9a5beae68a3$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $e09b833f247449ac$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $e09b833f247449ac$var$getDimensions(element) {
    const { width: width, height: height } = $e09b833f247449ac$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $e09b833f247449ac$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $4e9f7fee644b6873$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $4e9f7fee644b6873$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $e09b833f247449ac$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $abcde9a5beae68a3$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4e9f7fee644b6873$export$651544f548703224)(offsetParent) !== "body" || (0, $4e9f7fee644b6873$export$989e911fa9af580a)(documentElement)) scroll = (0, $4e9f7fee644b6873$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $e09b833f247449ac$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $e09b833f247449ac$var$getWindowScrollBarX(documentElement);
    }
    let htmlX = 0;
    let htmlY = 0;
    if (documentElement && !isOffsetParentAnElement && !isFixed) {
        const htmlRect = documentElement.getBoundingClientRect();
        htmlY = htmlRect.top + scroll.scrollTop;
        htmlX = htmlRect.left + scroll.scrollLeft - // RTL <body> scrollbar.
        $e09b833f247449ac$var$getWindowScrollBarX(documentElement, htmlRect);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlX;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlY;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $e09b833f247449ac$var$isStaticPositioned(element) {
    return (0, $4e9f7fee644b6873$export$3735103072e4a80)(element).position === "static";
}
function $e09b833f247449ac$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $4e9f7fee644b6873$export$1b3bfaa9684536aa)(element) || (0, $4e9f7fee644b6873$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $4e9f7fee644b6873$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $e09b833f247449ac$var$getOffsetParent(element, polyfill) {
    const win = (0, $4e9f7fee644b6873$export$38b2d434cce3ea22)(element);
    if ((0, $4e9f7fee644b6873$export$89e651af02346cd4)(element)) return win;
    if (!(0, $4e9f7fee644b6873$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $4e9f7fee644b6873$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $4e9f7fee644b6873$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $4e9f7fee644b6873$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$e09b833f247449ac$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $4e9f7fee644b6873$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $e09b833f247449ac$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $4e9f7fee644b6873$export$71535ffaa902797f)(offsetParent) && $e09b833f247449ac$var$isStaticPositioned(offsetParent))offsetParent = $e09b833f247449ac$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $4e9f7fee644b6873$export$d1162fb0b6d4cd51)(offsetParent) && $e09b833f247449ac$var$isStaticPositioned(offsetParent) && !(0, $4e9f7fee644b6873$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $4e9f7fee644b6873$export$940d8225183e1404)(element) || win;
}
const $e09b833f247449ac$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $e09b833f247449ac$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $e09b833f247449ac$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $e09b833f247449ac$var$isRTL(element) {
    return (0, $4e9f7fee644b6873$export$3735103072e4a80)(element).direction === "rtl";
}
const $e09b833f247449ac$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $e09b833f247449ac$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $4e9f7fee644b6873$export$e495491855dc5418,
    getClippingRect: $e09b833f247449ac$var$getClippingRect,
    getOffsetParent: $e09b833f247449ac$var$getOffsetParent,
    getElementRects: $e09b833f247449ac$var$getElementRects,
    getClientRects: $e09b833f247449ac$var$getClientRects,
    getDimensions: $e09b833f247449ac$var$getDimensions,
    getScale: $e09b833f247449ac$var$getScale,
    isElement: $4e9f7fee644b6873$export$45a5e7f76e0caa8d,
    isRTL: $e09b833f247449ac$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $e09b833f247449ac$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $4e9f7fee644b6873$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $abcde9a5beae68a3$export$a3fe094919f356fd)(top);
        const insetRight = (0, $abcde9a5beae68a3$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $abcde9a5beae68a3$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $abcde9a5beae68a3$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $abcde9a5beae68a3$export$8960430cfd85939f)(0, (0, $abcde9a5beae68a3$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $e09b833f247449ac$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $e09b833f247449ac$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $4e9f7fee644b6873$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $4e9f7fee644b6873$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $e09b833f247449ac$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $e09b833f247449ac$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $e09b833f247449ac$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $e09b833f247449ac$export$37b6bde19b108ecc = (0, $baea33fbd448a692$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $e09b833f247449ac$export$cc800923e997bb8 = (0, $baea33fbd448a692$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $e09b833f247449ac$export$91fb6ecbd551914 = (0, $baea33fbd448a692$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $e09b833f247449ac$export$fba63a578e423eb = (0, $baea33fbd448a692$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $e09b833f247449ac$export$8a83211c878a3f1f = (0, $baea33fbd448a692$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $e09b833f247449ac$export$346677f925de839c = (0, $baea33fbd448a692$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $e09b833f247449ac$export$fe8985bb6374093c = (0, $baea33fbd448a692$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $e09b833f247449ac$export$f2120bbfa5450bd2 = (0, $baea33fbd448a692$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $e09b833f247449ac$export$18c8ad048e32c7d5 = (0, $baea33fbd448a692$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $e09b833f247449ac$export$7bf07e38f3dc4b69 = (0, $baea33fbd448a692$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $e09b833f247449ac$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $e09b833f247449ac$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $baea33fbd448a692$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $8v0nu = parcelRequire("8v0nu");
var $33f8f3cd8d043d49$var$index = (0, $8v0nu.useLayoutEffect);
var $33f8f3cd8d043d49$export$2e2bcd8739ae039 = $33f8f3cd8d043d49$var$index;


var $b0015ad11dc7ba35$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $b0015ad11dc7ba35$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $b0015ad11dc7ba35$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function $b0015ad11dc7ba35$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($b0015ad11dc7ba35$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
}
// ==============================
// Clean Value
// ==============================
var $b0015ad11dc7ba35$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($b0015ad11dc7ba35$var$isArray(value)) return value.filter(Boolean);
    if ((0, $2b339004796b0e2f$export$2e2bcd8739ae039)(value) === "object" && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $b0015ad11dc7ba35$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $a69ac13ab3c3f3dd$export$2e2bcd8739ae039)(props, $b0015ad11dc7ba35$var$_excluded$4);
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $b0015ad11dc7ba35$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $b0015ad11dc7ba35$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === "string") return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $b0015ad11dc7ba35$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $b0015ad11dc7ba35$var$normalizedHeight(el) {
    if ($b0015ad11dc7ba35$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $b0015ad11dc7ba35$var$getScrollTop(el) {
    if ($b0015ad11dc7ba35$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $b0015ad11dc7ba35$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($b0015ad11dc7ba35$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $b0015ad11dc7ba35$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    if (style.position === "fixed") return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $b0015ad11dc7ba35$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $b0015ad11dc7ba35$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $b0015ad11dc7ba35$export$b4171a6734a65d42;
    var start = $b0015ad11dc7ba35$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $b0015ad11dc7ba35$var$easeOutCubic(currentTime, start, change, duration);
        $b0015ad11dc7ba35$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $b0015ad11dc7ba35$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $b0015ad11dc7ba35$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $b0015ad11dc7ba35$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $b0015ad11dc7ba35$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $b0015ad11dc7ba35$export$df995fae86a55f06() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $b0015ad11dc7ba35$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $b0015ad11dc7ba35$var$passiveOptionAccessed = false;
var $b0015ad11dc7ba35$var$options = {
    get passive () {
        return $b0015ad11dc7ba35$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $b0015ad11dc7ba35$var$w = typeof window !== "undefined" ? window : {};
if ($b0015ad11dc7ba35$var$w.addEventListener && $b0015ad11dc7ba35$var$w.removeEventListener) {
    $b0015ad11dc7ba35$var$w.addEventListener("p", $b0015ad11dc7ba35$export$b4171a6734a65d42, $b0015ad11dc7ba35$var$options);
    $b0015ad11dc7ba35$var$w.removeEventListener("p", $b0015ad11dc7ba35$export$b4171a6734a65d42, false);
}
var $b0015ad11dc7ba35$export$2408f22a0fab9ae5 = $b0015ad11dc7ba35$var$passiveOptionAccessed;
function $b0015ad11dc7ba35$export$3466f893ebf79586(item) {
    return item != null;
}
function $b0015ad11dc7ba35$var$isArray(arg) {
    return Array.isArray(arg);
}
function $b0015ad11dc7ba35$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $b0015ad11dc7ba35$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $b0015ad11dc7ba35$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $b0015ad11dc7ba35$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $5e8d680428cd6d3c$export$2e2bcd8739ae039)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $5e8d680428cd6d3c$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $b0015ad11dc7ba35$var$_excluded$3 = [
    "children",
    "innerProps"
], $b0015ad11dc7ba35$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $b0015ad11dc7ba35$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $b0015ad11dc7ba35$var$getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $b0015ad11dc7ba35$var$normalizedHeight(scrollParent);
    var scrollTop = $b0015ad11dc7ba35$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $b0015ad11dc7ba35$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $b0015ad11dc7ba35$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === "bottom") {
                if (shouldScroll) $b0015ad11dc7ba35$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $b0015ad11dc7ba35$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $b0015ad11dc7ba35$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $b0015ad11dc7ba35$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: "top",
        top: "bottom"
    };
    return placement ? placementToCSSProp[placement] : "bottom";
}
var $b0015ad11dc7ba35$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var $b0015ad11dc7ba35$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((_objectSpread2 = {
        label: "menu"
    }, (0, $a038852823ee2701$export$2e2bcd8739ae039)(_objectSpread2, $b0015ad11dc7ba35$var$alignToControl(placement), "100%"), (0, $a038852823ee2701$export$2e2bcd8739ae039)(_objectSpread2, "position", "absolute"), (0, $a038852823ee2701$export$2e2bcd8739ae039)(_objectSpread2, "width", "100%"), (0, $a038852823ee2701$export$2e2bcd8739ae039)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $b0015ad11dc7ba35$var$PortalPlacementContext = /*#__PURE__*/ (0, $8v0nu.createContext)(null);
// NOTE: internal only
var $b0015ad11dc7ba35$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $8v0nu.useContext)($b0015ad11dc7ba35$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $8v0nu.useRef)(null);
    var _useState = (0, $8v0nu.useState)(maxMenuHeight), _useState2 = (0, $5e8d680428cd6d3c$export$2e2bcd8739ae039)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $8v0nu.useState)(null), _useState4 = (0, $5e8d680428cd6d3c$export$2e2bcd8739ae039)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $33f8f3cd8d043d49$export$2e2bcd8739ae039)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === "fixed";
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $b0015ad11dc7ba35$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, props), {}, {
            placement: placement || $b0015ad11dc7ba35$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $b0015ad11dc7ba35$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $6iKRa.jsx)("div", (0, $2Jgqn.default)({}, $b0015ad11dc7ba35$var$getStyleProps(props, "menu", {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $b0015ad11dc7ba35$var$Menu$1 = $b0015ad11dc7ba35$var$Menu;
// ==============================
// Menu List
// ==============================
var $b0015ad11dc7ba35$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        maxHeight: maxHeight,
        overflowY: "auto",
        position: "relative",
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: "touch"
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $b0015ad11dc7ba35$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $6iKRa.jsx)("div", (0, $2Jgqn.default)({}, $b0015ad11dc7ba35$var$getStyleProps(props, "menuList", {
        "menu-list": true,
        "menu-list--is-multi": isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $b0015ad11dc7ba35$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        textAlign: "center"
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $b0015ad11dc7ba35$export$3b14a55fb2447963 = $b0015ad11dc7ba35$var$noticeCSS;
var $b0015ad11dc7ba35$export$342063e11d6c3cad = $b0015ad11dc7ba35$var$noticeCSS;
var $b0015ad11dc7ba35$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? "No options" : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $a69ac13ab3c3f3dd$export$2e2bcd8739ae039)(_ref6, $b0015ad11dc7ba35$var$_excluded$3);
    return (0, $6iKRa.jsx)("div", (0, $2Jgqn.default)({}, $b0015ad11dc7ba35$var$getStyleProps((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "noOptionsMessage", {
        "menu-notice": true,
        "menu-notice--no-options": true
    }), innerProps), children);
};
var $b0015ad11dc7ba35$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? "Loading..." : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $a69ac13ab3c3f3dd$export$2e2bcd8739ae039)(_ref7, $b0015ad11dc7ba35$var$_excluded2$1);
    return (0, $6iKRa.jsx)("div", (0, $2Jgqn.default)({}, $b0015ad11dc7ba35$var$getStyleProps((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "loadingMessage", {
        "menu-notice": true,
        "menu-notice--loading": true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $b0015ad11dc7ba35$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $b0015ad11dc7ba35$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $8v0nu.useRef)(null);
    var cleanupRef = (0, $8v0nu.useRef)(null);
    var _useState5 = (0, $8v0nu.useState)($b0015ad11dc7ba35$var$coercePlacement(menuPlacement)), _useState6 = (0, $5e8d680428cd6d3c$export$2e2bcd8739ae039)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $8v0nu.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $8v0nu.useState)(null), _useState8 = (0, $5e8d680428cd6d3c$export$2e2bcd8739ae039)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $8v0nu.useCallback)(function() {
        if (!controlElement) return;
        var rect = $b0015ad11dc7ba35$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $33f8f3cd8d043d49$export$2e2bcd8739ae039)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $8v0nu.useCallback)(function() {
        if (typeof cleanupRef.current === "function") {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $e09b833f247449ac$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: "ResizeObserver" in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $33f8f3cd8d043d49$export$2e2bcd8739ae039)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $8v0nu.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $6iKRa.jsx)("div", (0, $2Jgqn.default)({
        ref: setMenuPortalElement
    }, $b0015ad11dc7ba35$var$getStyleProps((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), "menuPortal", {
        "menu-portal": true
    }), innerProps), children);
    return (0, $6iKRa.jsx)($b0015ad11dc7ba35$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $e95e39c2a873bfa2$exports.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $b0015ad11dc7ba35$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: "container",
        direction: isRtl ? "rtl" : undefined,
        pointerEvents: isDisabled ? "none" : undefined,
        // cancel mouse events when disabled
        position: "relative"
    };
};
var $b0015ad11dc7ba35$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $6iKRa.jsx)("div", (0, $2Jgqn.default)({}, $b0015ad11dc7ba35$var$getStyleProps(props, "container", {
        "--is-disabled": isDisabled,
        "--is-rtl": isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $b0015ad11dc7ba35$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        alignItems: "center",
        display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
        flex: 1,
        flexWrap: "wrap",
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $b0015ad11dc7ba35$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $6iKRa.jsx)("div", (0, $2Jgqn.default)({}, $b0015ad11dc7ba35$var$getStyleProps(props, "valueContainer", {
        "value-container": true,
        "value-container--is-multi": isMulti,
        "value-container--has-value": hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $b0015ad11dc7ba35$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: "center",
        alignSelf: "stretch",
        display: "flex",
        flexShrink: 0
    };
};
var $b0015ad11dc7ba35$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $6iKRa.jsx)("div", (0, $2Jgqn.default)({}, $b0015ad11dc7ba35$var$getStyleProps(props, "indicatorsContainer", {
        indicators: true
    }), innerProps), children);
};
var $b0015ad11dc7ba35$var$_templateObject;
var $b0015ad11dc7ba35$var$_excluded$2 = [
    "size"
], $b0015ad11dc7ba35$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $b0015ad11dc7ba35$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $b0015ad11dc7ba35$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $b0015ad11dc7ba35$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $a69ac13ab3c3f3dd$export$2e2bcd8739ae039)(_ref, $b0015ad11dc7ba35$var$_excluded$2);
    return (0, $6iKRa.jsx)("svg", (0, $2Jgqn.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $b0015ad11dc7ba35$var$_ref2
    }, props));
};
var $b0015ad11dc7ba35$var$CrossIcon = function CrossIcon(props) {
    return (0, $6iKRa.jsx)($b0015ad11dc7ba35$var$Svg, (0, $2Jgqn.default)({
        size: 20
    }, props), (0, $6iKRa.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $b0015ad11dc7ba35$var$DownChevron = function DownChevron(props) {
    return (0, $6iKRa.jsx)($b0015ad11dc7ba35$var$Svg, (0, $2Jgqn.default)({
        size: 20
    }, props), (0, $6iKRa.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $b0015ad11dc7ba35$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        label: "indicatorContainer",
        display: "flex",
        transition: "color 150ms"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ":hover": {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $b0015ad11dc7ba35$export$f1e1789686576879 = $b0015ad11dc7ba35$var$baseCSS;
var $b0015ad11dc7ba35$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $6iKRa.jsx)("div", (0, $2Jgqn.default)({}, $b0015ad11dc7ba35$var$getStyleProps(props, "dropdownIndicator", {
        indicator: true,
        "dropdown-indicator": true
    }), innerProps), children || (0, $6iKRa.jsx)($b0015ad11dc7ba35$var$DownChevron, null));
};
var $b0015ad11dc7ba35$export$407448d2b89b1813 = $b0015ad11dc7ba35$var$baseCSS;
var $b0015ad11dc7ba35$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $6iKRa.jsx)("div", (0, $2Jgqn.default)({}, $b0015ad11dc7ba35$var$getStyleProps(props, "clearIndicator", {
        indicator: true,
        "clear-indicator": true
    }), innerProps), children || (0, $6iKRa.jsx)($b0015ad11dc7ba35$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $b0015ad11dc7ba35$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        label: "indicatorSeparator",
        alignSelf: "stretch",
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $b0015ad11dc7ba35$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $6iKRa.jsx)("span", (0, $2Jgqn.default)({}, innerProps, $b0015ad11dc7ba35$var$getStyleProps(props, "indicatorSeparator", {
        "indicator-separator": true
    })));
};
// ==============================
// Loading
// ==============================
var $b0015ad11dc7ba35$var$loadingDotAnimations = (0, $6iKRa.keyframes)($b0015ad11dc7ba35$var$_templateObject || ($b0015ad11dc7ba35$var$_templateObject = (0, $440595ef322c396e$export$2e2bcd8739ae039)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $b0015ad11dc7ba35$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        label: "loadingIndicator",
        display: "flex",
        transition: "color 150ms",
        alignSelf: "center",
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: "center",
        verticalAlign: "middle"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $b0015ad11dc7ba35$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $6iKRa.jsx)("span", {
        css: /*#__PURE__*/ (0, $6iKRa.css)({
            animation: "".concat($b0015ad11dc7ba35$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: "currentColor",
            borderRadius: "1em",
            display: "inline-block",
            marginLeft: offset ? "1em" : undefined,
            height: "1em",
            verticalAlign: "top",
            width: "1em"
        }, "", "")
    });
};
var $b0015ad11dc7ba35$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $a69ac13ab3c3f3dd$export$2e2bcd8739ae039)(_ref7, $b0015ad11dc7ba35$var$_excluded2);
    return (0, $6iKRa.jsx)("div", (0, $2Jgqn.default)({}, $b0015ad11dc7ba35$var$getStyleProps((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), "loadingIndicator", {
        indicator: true,
        "loading-indicator": true
    }), innerProps), (0, $6iKRa.jsx)($b0015ad11dc7ba35$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $6iKRa.jsx)($b0015ad11dc7ba35$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $6iKRa.jsx)($b0015ad11dc7ba35$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $b0015ad11dc7ba35$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        label: "control",
        alignItems: "center",
        cursor: "default",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        minHeight: spacing.controlHeight,
        outline: "0 !important",
        position: "relative",
        transition: "all 100ms"
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: "solid",
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        "&:hover": {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $b0015ad11dc7ba35$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $6iKRa.jsx)("div", (0, $2Jgqn.default)({
        ref: innerRef
    }, $b0015ad11dc7ba35$var$getStyleProps(props, "control", {
        control: true,
        "control--is-disabled": isDisabled,
        "control--is-focused": isFocused,
        "control--menu-is-open": menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $b0015ad11dc7ba35$var$Control$1 = $b0015ad11dc7ba35$var$Control;
var $b0015ad11dc7ba35$var$_excluded$1 = [
    "data"
];
var $b0015ad11dc7ba35$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $b0015ad11dc7ba35$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $6iKRa.jsx)("div", (0, $2Jgqn.default)({}, $b0015ad11dc7ba35$var$getStyleProps(props, "group", {
        group: true
    }), innerProps), (0, $6iKRa.jsx)(Heading, (0, $2Jgqn.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $6iKRa.jsx)("div", null, children));
};
var $b0015ad11dc7ba35$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        label: "group",
        cursor: "default",
        display: "block"
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: "75%",
        fontWeight: 500,
        marginBottom: "0.25em",
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: "uppercase"
    });
};
var $b0015ad11dc7ba35$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $b0015ad11dc7ba35$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $a69ac13ab3c3f3dd$export$2e2bcd8739ae039)(_cleanCommonProps, $b0015ad11dc7ba35$var$_excluded$1);
    return (0, $6iKRa.jsx)("div", (0, $2Jgqn.default)({}, $b0015ad11dc7ba35$var$getStyleProps(props, "groupHeading", {
        "group-heading": true
    }), innerProps));
};
var $b0015ad11dc7ba35$var$Group$1 = $b0015ad11dc7ba35$var$Group;
var $b0015ad11dc7ba35$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $b0015ad11dc7ba35$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        visibility: isDisabled ? "hidden" : "visible",
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? "translateZ(0)" : ""
    }, $b0015ad11dc7ba35$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $b0015ad11dc7ba35$var$spacingStyle = {
    gridArea: "1 / 2",
    font: "inherit",
    minWidth: "2px",
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $b0015ad11dc7ba35$var$containerStyle = {
    flex: "1 1 auto",
    display: "inline-grid",
    gridArea: "1 / 1 / 2 / 3",
    gridTemplateColumns: "0 min-content",
    "&:after": (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        content: 'attr(data-value) " "',
        visibility: "hidden",
        whiteSpace: "pre"
    }, $b0015ad11dc7ba35$var$spacingStyle)
};
var $b0015ad11dc7ba35$var$inputStyle = function inputStyle(isHidden) {
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        label: "input",
        color: "inherit",
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: "100%"
    }, $b0015ad11dc7ba35$var$spacingStyle);
};
var $b0015ad11dc7ba35$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $b0015ad11dc7ba35$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $a69ac13ab3c3f3dd$export$2e2bcd8739ae039)(_cleanCommonProps, $b0015ad11dc7ba35$var$_excluded);
    return (0, $6iKRa.jsx)("div", (0, $2Jgqn.default)({}, $b0015ad11dc7ba35$var$getStyleProps(props, "input", {
        "input-container": true
    }), {
        "data-value": value || ""
    }), (0, $6iKRa.jsx)("input", (0, $2Jgqn.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $b0015ad11dc7ba35$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $b0015ad11dc7ba35$var$Input$1 = $b0015ad11dc7ba35$var$Input;
var $b0015ad11dc7ba35$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        label: "multiValue",
        display: "flex",
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $b0015ad11dc7ba35$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        overflow: "hidden",
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? "ellipsis" : undefined,
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: "85%",
        padding: 3,
        paddingLeft: 6
    });
};
var $b0015ad11dc7ba35$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        alignItems: "center",
        display: "flex"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ":hover": {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $b0015ad11dc7ba35$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $6iKRa.jsx)("div", innerProps, children);
};
var $b0015ad11dc7ba35$var$MultiValueContainer = $b0015ad11dc7ba35$var$MultiValueGeneric;
var $b0015ad11dc7ba35$var$MultiValueLabel = $b0015ad11dc7ba35$var$MultiValueGeneric;
function $b0015ad11dc7ba35$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $6iKRa.jsx)("div", (0, $2Jgqn.default)({
        role: "button"
    }, innerProps), children || (0, $6iKRa.jsx)($b0015ad11dc7ba35$var$CrossIcon, {
        size: 14
    }));
}
var $b0015ad11dc7ba35$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $6iKRa.jsx)(Container, {
        data: data,
        innerProps: (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, $b0015ad11dc7ba35$var$getStyleProps(props, "multiValue", {
            "multi-value": true,
            "multi-value--is-disabled": isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $6iKRa.jsx)(Label, {
        data: data,
        innerProps: (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, $b0015ad11dc7ba35$var$getStyleProps(props, "multiValueLabel", {
            "multi-value__label": true
        })),
        selectProps: selectProps
    }, children), (0, $6iKRa.jsx)(Remove, {
        data: data,
        innerProps: (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, $b0015ad11dc7ba35$var$getStyleProps(props, "multiValueRemove", {
            "multi-value__remove": true
        })), {}, {
            "aria-label": "Remove ".concat(children || "option")
        }, removeProps),
        selectProps: selectProps
    }));
};
var $b0015ad11dc7ba35$var$MultiValue$1 = $b0015ad11dc7ba35$var$MultiValue;
var $b0015ad11dc7ba35$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        label: "option",
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        width: "100%",
        userSelect: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : "transparent",
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : "inherit",
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ":active": {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $b0015ad11dc7ba35$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $6iKRa.jsx)("div", (0, $2Jgqn.default)({}, $b0015ad11dc7ba35$var$getStyleProps(props, "option", {
        option: true,
        "option--is-disabled": isDisabled,
        "option--is-focused": isFocused,
        "option--is-selected": isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $b0015ad11dc7ba35$var$Option$1 = $b0015ad11dc7ba35$var$Option;
var $b0015ad11dc7ba35$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        label: "placeholder",
        gridArea: "1 / 1 / 2 / 3"
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $b0015ad11dc7ba35$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $6iKRa.jsx)("div", (0, $2Jgqn.default)({}, $b0015ad11dc7ba35$var$getStyleProps(props, "placeholder", {
        placeholder: true
    }), innerProps), children);
};
var $b0015ad11dc7ba35$var$Placeholder$1 = $b0015ad11dc7ba35$var$Placeholder;
var $b0015ad11dc7ba35$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
        label: "singleValue",
        gridArea: "1 / 1 / 2 / 3",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $b0015ad11dc7ba35$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $6iKRa.jsx)("div", (0, $2Jgqn.default)({}, $b0015ad11dc7ba35$var$getStyleProps(props, "singleValue", {
        "single-value": true,
        "single-value--is-disabled": isDisabled
    }), innerProps), children);
};
var $b0015ad11dc7ba35$var$SingleValue$1 = $b0015ad11dc7ba35$var$SingleValue;
var $b0015ad11dc7ba35$export$db3b6bfb95261072 = {
    ClearIndicator: $b0015ad11dc7ba35$var$ClearIndicator,
    Control: $b0015ad11dc7ba35$var$Control$1,
    DropdownIndicator: $b0015ad11dc7ba35$var$DropdownIndicator,
    DownChevron: $b0015ad11dc7ba35$var$DownChevron,
    CrossIcon: $b0015ad11dc7ba35$var$CrossIcon,
    Group: $b0015ad11dc7ba35$var$Group$1,
    GroupHeading: $b0015ad11dc7ba35$var$GroupHeading,
    IndicatorsContainer: $b0015ad11dc7ba35$var$IndicatorsContainer,
    IndicatorSeparator: $b0015ad11dc7ba35$var$IndicatorSeparator,
    Input: $b0015ad11dc7ba35$var$Input$1,
    LoadingIndicator: $b0015ad11dc7ba35$var$LoadingIndicator,
    Menu: $b0015ad11dc7ba35$var$Menu$1,
    MenuList: $b0015ad11dc7ba35$var$MenuList,
    MenuPortal: $b0015ad11dc7ba35$var$MenuPortal,
    LoadingMessage: $b0015ad11dc7ba35$var$LoadingMessage,
    NoOptionsMessage: $b0015ad11dc7ba35$var$NoOptionsMessage,
    MultiValue: $b0015ad11dc7ba35$var$MultiValue$1,
    MultiValueContainer: $b0015ad11dc7ba35$var$MultiValueContainer,
    MultiValueLabel: $b0015ad11dc7ba35$var$MultiValueLabel,
    MultiValueRemove: $b0015ad11dc7ba35$var$MultiValueRemove,
    Option: $b0015ad11dc7ba35$var$Option$1,
    Placeholder: $b0015ad11dc7ba35$var$Placeholder$1,
    SelectContainer: $b0015ad11dc7ba35$var$SelectContainer,
    SingleValue: $b0015ad11dc7ba35$var$SingleValue$1,
    ValueContainer: $b0015ad11dc7ba35$var$ValueContainer
};
var $b0015ad11dc7ba35$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, $b0015ad11dc7ba35$export$db3b6bfb95261072), props.components);
};



var $6iKRa = parcelRequire("6iKRa");
var $c7b670e7608f7d67$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $c7b670e7608f7d67$var$isEqual(first, second) {
    if (first === second) return true;
    if ($c7b670e7608f7d67$var$safeIsNaN(first) && $c7b670e7608f7d67$var$safeIsNaN(second)) return true;
    return false;
}
function $c7b670e7608f7d67$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$c7b670e7608f7d67$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $c7b670e7608f7d67$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $c7b670e7608f7d67$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



function $ce6dd352cf0458f3$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $ce6dd352cf0458f3$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $ce6dd352cf0458f3$var$A11yText = function A11yText(props) {
    return (0, $6iKRa.jsx)("span", (0, $2Jgqn.default)({
        css: $ce6dd352cf0458f3$var$_ref
    }, props));
};
var $ce6dd352cf0458f3$var$A11yText$1 = $ce6dd352cf0458f3$var$A11yText;
var $ce6dd352cf0458f3$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case "menu":
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
            case "input":
                return isInitialFocus ? "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "") : "";
            case "value":
                return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
            default:
                return "";
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case "deselect-option":
            case "pop-value":
            case "remove-value":
                return "option ".concat(label, ", deselected.");
            case "clear":
                return "All selected options have been cleared.";
            case "initial-input-focus":
                return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
            case "select-option":
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return "";
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
        };
        if (context === "value" && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === "menu" && isAppleDevice) {
            var disabled = isDisabled ? " disabled" : "";
            var status = "".concat(isSelected ? " selected" : "").concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return "";
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
    }
};
var $ce6dd352cf0458f3$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps["aria-label"];
    var ariaLive = selectProps["aria-live"];
    // Update aria live message configuration when prop changes
    var messages = (0, $8v0nu.useMemo)(function() {
        return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, $ce6dd352cf0458f3$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $8v0nu.useMemo)(function() {
        var message = "";
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : "";
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $8v0nu.useMemo)(function() {
        var focusMsg = "";
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? "menu" : "value",
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $8v0nu.useMemo)(function() {
        var resultsMsg = "";
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
    var ariaGuidance = (0, $8v0nu.useMemo)(function() {
        var guidanceMsg = "";
        if (messages.guidance) {
            var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
            guidanceMsg = messages.guidance({
                "aria-label": ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $6iKRa.jsx)((0, $8v0nu.Fragment), null, (0, $6iKRa.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $6iKRa.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $6iKRa.jsx)("span", {
        id: "aria-results"
    }, ariaResults), (0, $6iKRa.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $6iKRa.jsx)((0, $8v0nu.Fragment), null, (0, $6iKRa.jsx)($ce6dd352cf0458f3$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $6iKRa.jsx)($ce6dd352cf0458f3$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $ce6dd352cf0458f3$var$LiveRegion$1 = $ce6dd352cf0458f3$var$LiveRegion;
var $ce6dd352cf0458f3$var$diacritics = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $ce6dd352cf0458f3$var$anyDiacritic = new RegExp("[" + $ce6dd352cf0458f3$var$diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var $ce6dd352cf0458f3$var$diacriticToBase = {};
for(var $ce6dd352cf0458f3$var$i = 0; $ce6dd352cf0458f3$var$i < $ce6dd352cf0458f3$var$diacritics.length; $ce6dd352cf0458f3$var$i++){
    var $ce6dd352cf0458f3$var$diacritic = $ce6dd352cf0458f3$var$diacritics[$ce6dd352cf0458f3$var$i];
    for(var $ce6dd352cf0458f3$var$j = 0; $ce6dd352cf0458f3$var$j < $ce6dd352cf0458f3$var$diacritic.letters.length; $ce6dd352cf0458f3$var$j++)$ce6dd352cf0458f3$var$diacriticToBase[$ce6dd352cf0458f3$var$diacritic.letters[$ce6dd352cf0458f3$var$j]] = $ce6dd352cf0458f3$var$diacritic.base;
}
var $ce6dd352cf0458f3$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($ce6dd352cf0458f3$var$anyDiacritic, function(match) {
        return $ce6dd352cf0458f3$var$diacriticToBase[match];
    });
};
var $ce6dd352cf0458f3$var$memoizedStripDiacriticsForInput = (0, $c7b670e7608f7d67$export$2e2bcd8739ae039)($ce6dd352cf0458f3$var$stripDiacritics);
var $ce6dd352cf0458f3$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var $ce6dd352cf0458f3$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $ce6dd352cf0458f3$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $ce6dd352cf0458f3$var$defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $ce6dd352cf0458f3$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $ce6dd352cf0458f3$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $ce6dd352cf0458f3$var$memoizedStripDiacriticsForInput(input);
            candidate = $ce6dd352cf0458f3$var$stripDiacritics(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $ce6dd352cf0458f3$var$_excluded = [
    "innerRef"
];
function $ce6dd352cf0458f3$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $a69ac13ab3c3f3dd$export$2e2bcd8739ae039)(_ref, $ce6dd352cf0458f3$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $b0015ad11dc7ba35$export$43caf9889c228507)(props, "onExited", "in", "enter", "exit", "appear");
    return (0, $6iKRa.jsx)("input", (0, $2Jgqn.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $6iKRa.css)({
            label: "dummyInput",
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: "transparent",
            fontSize: "inherit",
            gridArea: "1 / 1 / 2 / 3",
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: "transparent",
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: "relative",
            transform: "scale(.01)"
        }, "", "")
    }));
}
var $ce6dd352cf0458f3$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $ce6dd352cf0458f3$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $8v0nu.useRef)(false);
    var isTop = (0, $8v0nu.useRef)(false);
    var touchStart = (0, $8v0nu.useRef)(0);
    var scrollTarget = (0, $8v0nu.useRef)(null);
    var handleEventDelta = (0, $8v0nu.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $ce6dd352cf0458f3$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $8v0nu.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $8v0nu.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $8v0nu.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $8v0nu.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $b0015ad11dc7ba35$export$2408f22a0fab9ae5) ? {
            passive: false
        } : false;
        el.addEventListener("wheel", onWheel, notPassive);
        el.addEventListener("touchstart", onTouchStart, notPassive);
        el.addEventListener("touchmove", onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $8v0nu.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener("wheel", onWheel, false);
        el.removeEventListener("touchstart", onTouchStart, false);
        el.removeEventListener("touchmove", onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $8v0nu.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $ce6dd352cf0458f3$var$STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var $ce6dd352cf0458f3$var$LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function $ce6dd352cf0458f3$var$preventTouchMove(e) {
    if (e.cancelable) e.preventDefault();
}
function $ce6dd352cf0458f3$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $ce6dd352cf0458f3$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $ce6dd352cf0458f3$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
var $ce6dd352cf0458f3$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $ce6dd352cf0458f3$var$activeScrollLocks = 0;
var $ce6dd352cf0458f3$var$listenerOptions = {
    capture: false,
    passive: false
};
function $ce6dd352cf0458f3$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $8v0nu.useRef)({});
    var scrollTarget = (0, $8v0nu.useRef)(null);
    var addScrollLock = (0, $8v0nu.useCallback)(function(touchScrollTarget) {
        if (!$ce6dd352cf0458f3$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $ce6dd352cf0458f3$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $ce6dd352cf0458f3$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($ce6dd352cf0458f3$var$LOCK_STYLES).forEach(function(key) {
                var val = $ce6dd352cf0458f3$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $ce6dd352cf0458f3$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener("touchmove", $ce6dd352cf0458f3$var$preventTouchMove, $ce6dd352cf0458f3$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener("touchstart", $ce6dd352cf0458f3$var$preventInertiaScroll, $ce6dd352cf0458f3$var$listenerOptions);
                touchScrollTarget.addEventListener("touchmove", $ce6dd352cf0458f3$var$allowTouchMove, $ce6dd352cf0458f3$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $ce6dd352cf0458f3$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $8v0nu.useCallback)(function(touchScrollTarget) {
        if (!$ce6dd352cf0458f3$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $ce6dd352cf0458f3$var$activeScrollLocks = Math.max($ce6dd352cf0458f3$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $ce6dd352cf0458f3$var$activeScrollLocks < 1) $ce6dd352cf0458f3$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $ce6dd352cf0458f3$var$isTouchDevice()) {
            target.removeEventListener("touchmove", $ce6dd352cf0458f3$var$preventTouchMove, $ce6dd352cf0458f3$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener("touchstart", $ce6dd352cf0458f3$var$preventInertiaScroll, $ce6dd352cf0458f3$var$listenerOptions);
                touchScrollTarget.removeEventListener("touchmove", $ce6dd352cf0458f3$var$allowTouchMove, $ce6dd352cf0458f3$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $8v0nu.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $ce6dd352cf0458f3$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ce6dd352cf0458f3$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $ce6dd352cf0458f3$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $ce6dd352cf0458f3$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $ce6dd352cf0458f3$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $ce6dd352cf0458f3$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $6iKRa.jsx)((0, $8v0nu.Fragment), null, lockEnabled && (0, $6iKRa.jsx)("div", {
        onClick: $ce6dd352cf0458f3$var$blurSelectInput,
        css: $ce6dd352cf0458f3$var$_ref2$1
    }), children(targetRef));
}
function $ce6dd352cf0458f3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ce6dd352cf0458f3$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $ce6dd352cf0458f3$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $6iKRa.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $ce6dd352cf0458f3$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $ce6dd352cf0458f3$var$RequiredInput$1 = $ce6dd352cf0458f3$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $ce6dd352cf0458f3$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window$navigator$use = window.navigator["userAgentData"]) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $ce6dd352cf0458f3$var$isIPhone() {
    return $ce6dd352cf0458f3$var$testPlatform(/^iPhone/i);
}
function $ce6dd352cf0458f3$var$isMac() {
    return $ce6dd352cf0458f3$var$testPlatform(/^Mac/i);
}
function $ce6dd352cf0458f3$var$isIPad() {
    return $ce6dd352cf0458f3$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $ce6dd352cf0458f3$var$isMac() && navigator.maxTouchPoints > 1;
}
function $ce6dd352cf0458f3$var$isIOS() {
    return $ce6dd352cf0458f3$var$isIPhone() || $ce6dd352cf0458f3$var$isIPad();
}
function $ce6dd352cf0458f3$var$isAppleDevice() {
    return $ce6dd352cf0458f3$var$isMac() || $ce6dd352cf0458f3$var$isIOS();
}
var $ce6dd352cf0458f3$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $ce6dd352cf0458f3$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $ce6dd352cf0458f3$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $ce6dd352cf0458f3$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $ce6dd352cf0458f3$var$defaultStyles = {
    clearIndicator: (0, $b0015ad11dc7ba35$export$407448d2b89b1813),
    container: (0, $b0015ad11dc7ba35$export$8b22cf2602fb60ce),
    control: (0, $b0015ad11dc7ba35$export$4368d992c4eafac0),
    dropdownIndicator: (0, $b0015ad11dc7ba35$export$f1e1789686576879),
    group: (0, $b0015ad11dc7ba35$export$39b482c5e57630a8),
    groupHeading: (0, $b0015ad11dc7ba35$export$2d1720544b23b823),
    indicatorsContainer: (0, $b0015ad11dc7ba35$export$23f2a1d2818174ef),
    indicatorSeparator: (0, $b0015ad11dc7ba35$export$dda1d9f60106f0e9),
    input: (0, $b0015ad11dc7ba35$export$35e795649ee09318),
    loadingIndicator: (0, $b0015ad11dc7ba35$export$882b5998b3b9117c),
    loadingMessage: (0, $b0015ad11dc7ba35$export$342063e11d6c3cad),
    menu: (0, $b0015ad11dc7ba35$export$953cecd6e717a553),
    menuList: (0, $b0015ad11dc7ba35$export$7ccc53e8f1e7dfc5),
    menuPortal: (0, $b0015ad11dc7ba35$export$ae1af26003f05816),
    multiValue: (0, $b0015ad11dc7ba35$export$ffb5f4729a158638),
    multiValueLabel: (0, $b0015ad11dc7ba35$export$9e5f44173e64f162),
    multiValueRemove: (0, $b0015ad11dc7ba35$export$625550452a3fa3ec),
    noOptionsMessage: (0, $b0015ad11dc7ba35$export$3b14a55fb2447963),
    option: (0, $b0015ad11dc7ba35$export$90a7f3efeed30595),
    placeholder: (0, $b0015ad11dc7ba35$export$efccba1c4a2ef57b),
    singleValue: (0, $b0015ad11dc7ba35$export$d141bba7fdc215a3),
    valueContainer: (0, $b0015ad11dc7ba35$export$4a5767248b18ef41)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $ce6dd352cf0458f3$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $ce6dd352cf0458f3$var$colors = {
    primary: "#2684FF",
    primary75: "#4C9AFF",
    primary50: "#B2D4FF",
    primary25: "#DEEBFF",
    danger: "#DE350B",
    dangerLight: "#FFBDAD",
    neutral0: "hsl(0, 0%, 100%)",
    neutral5: "hsl(0, 0%, 95%)",
    neutral10: "hsl(0, 0%, 90%)",
    neutral20: "hsl(0, 0%, 80%)",
    neutral30: "hsl(0, 0%, 70%)",
    neutral40: "hsl(0, 0%, 60%)",
    neutral50: "hsl(0, 0%, 50%)",
    neutral60: "hsl(0, 0%, 40%)",
    neutral70: "hsl(0, 0%, 30%)",
    neutral80: "hsl(0, 0%, 20%)",
    neutral90: "hsl(0, 0%, 10%)"
};
var $ce6dd352cf0458f3$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $ce6dd352cf0458f3$var$baseUnit = 4;
// The minimum height of the control
var $ce6dd352cf0458f3$var$controlHeight = 38;
// The amount of space between the control and menu */
var $ce6dd352cf0458f3$var$menuGutter = $ce6dd352cf0458f3$var$baseUnit * 2;
var $ce6dd352cf0458f3$var$spacing = {
    baseUnit: $ce6dd352cf0458f3$var$baseUnit,
    controlHeight: $ce6dd352cf0458f3$var$controlHeight,
    menuGutter: $ce6dd352cf0458f3$var$menuGutter
};
var $ce6dd352cf0458f3$export$4368d992c4eafac0 = {
    borderRadius: $ce6dd352cf0458f3$var$borderRadius,
    colors: $ce6dd352cf0458f3$var$colors,
    spacing: $ce6dd352cf0458f3$var$spacing
};
var $ce6dd352cf0458f3$export$407448d2b89b1813 = {
    "aria-live": "polite",
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $b0015ad11dc7ba35$export$df995fae86a55f06)(),
    captureMenuScroll: !(0, $b0015ad11dc7ba35$export$df995fae86a55f06)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $ce6dd352cf0458f3$export$db3b6bfb95261072(),
    formatGroupLabel: $ce6dd352cf0458f3$var$formatGroupLabel,
    getOptionLabel: $ce6dd352cf0458f3$export$8b22cf2602fb60ce,
    getOptionValue: $ce6dd352cf0458f3$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $ce6dd352cf0458f3$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $b0015ad11dc7ba35$export$ebd11618f299a286)(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $ce6dd352cf0458f3$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $ce6dd352cf0458f3$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $ce6dd352cf0458f3$var$_isOptionSelected(props, option, selectValue);
    var label = $ce6dd352cf0458f3$var$getOptionLabel(props, option);
    var value = $ce6dd352cf0458f3$var$getOptionValue(props, option);
    return {
        type: "option",
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $ce6dd352cf0458f3$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ("options" in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $ce6dd352cf0458f3$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $ce6dd352cf0458f3$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: "group",
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $ce6dd352cf0458f3$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $ce6dd352cf0458f3$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $b0015ad11dc7ba35$export$3466f893ebf79586));
}
function $ce6dd352cf0458f3$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $aba02085c81f3bc8$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $ce6dd352cf0458f3$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $aba02085c81f3bc8$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $ce6dd352cf0458f3$var$buildFocusableOptions(props, selectValue) {
    return $ce6dd352cf0458f3$var$buildFocusableOptionsFromCategorizedOptions($ce6dd352cf0458f3$var$buildCategorizedOptions(props, selectValue));
}
function $ce6dd352cf0458f3$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$ce6dd352cf0458f3$var$shouldHideSelectedOptions(props) || !isSelected) && $ce6dd352cf0458f3$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $ce6dd352cf0458f3$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $ce6dd352cf0458f3$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $ce6dd352cf0458f3$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $ce6dd352cf0458f3$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $ce6dd352cf0458f3$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $ce6dd352cf0458f3$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function $ce6dd352cf0458f3$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === "function") return props.isOptionSelected(option, selectValue);
    var candidate = $ce6dd352cf0458f3$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $ce6dd352cf0458f3$var$getOptionValue(props, i) === candidate;
    });
}
function $ce6dd352cf0458f3$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $ce6dd352cf0458f3$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $ce6dd352cf0458f3$var$instanceId = 1;
var $ce6dd352cf0458f3$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $6c7ef991d1028cee$export$2e2bcd8739ae039)(Select, _Component);
    var _super = (0, $1a0a5e846fa7425c$export$2e2bcd8739ae039)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $cad7451c9e32255d$export$2e2bcd8739ae039)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ""
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = $ce6dd352cf0458f3$var$isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange("", {
                action: "set-value",
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $b0015ad11dc7ba35$export$ef35774e6d314e91)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), "deselect-option", newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $b0015ad11dc7ba35$export$ef35774e6d314e91)([].concat((0, $aba02085c81f3bc8$export$2e2bcd8739ae039)(selectValue), [
                    newValue
                ])), "select-option", newValue);
                else _this.setValue((0, $b0015ad11dc7ba35$export$e7094788287c5e9b)(newValue), "select-option");
            } else {
                _this.ariaOnChange((0, $b0015ad11dc7ba35$export$e7094788287c5e9b)(newValue), {
                    action: "select-option",
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $b0015ad11dc7ba35$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $b0015ad11dc7ba35$export$96f57966bedc81b4)(_this.props.isMulti, [], null), {
                action: "clear",
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $b0015ad11dc7ba35$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            if (lastSelectedValue) _this.onChange(newValue, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $ce6dd352cf0458f3$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $ce6dd352cf0458f3$var$buildFocusableOptionsWithIds($ce6dd352cf0458f3$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId("option"));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $b0015ad11dc7ba35$export$a9c23c6ac3fc3eca).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $ce6dd352cf0458f3$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $ce6dd352cf0458f3$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $ce6dd352cf0458f3$var$defaultStyles[key](props, unstyled);
            base.boxSizing = "border-box";
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $b0015ad11dc7ba35$export$d66501df72047452)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $ce6dd352cf0458f3$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $ce6dd352cf0458f3$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, $b0015ad11dc7ba35$export$2329c99376c9d0a4)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: "input-change",
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur",
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $ce6dd352cf0458f3$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange("", {
                            action: "menu-close",
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = "react-select-" + (_this.props.instanceId || ++$ce6dd352cf0458f3$var$instanceId);
        _this.state.selectValue = (0, $b0015ad11dc7ba35$export$7f8ddf7c7c20b3cd)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $ce6dd352cf0458f3$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $bd6fca2392fb7de2$export$2e2bcd8739ae039)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $b0015ad11dc7ba35$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $b0015ad11dc7ba35$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener("scroll", this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange("", {
                    action: "menu-close",
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $ce6dd352cf0458f3$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === "function") return this.props.theme($ce6dd352cf0458f3$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, $ce6dd352cf0458f3$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $ce6dd352cf0458f3$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $ce6dd352cf0458f3$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $ce6dd352cf0458f3$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === "function") {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("touchstart", this.onTouchStart);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId("input");
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({
                    "aria-autocomplete": "list",
                    "aria-expanded": menuIsOpen,
                    "aria-haspopup": true,
                    "aria-errormessage": this.props["aria-errormessage"],
                    "aria-invalid": this.props["aria-invalid"],
                    "aria-label": this.props["aria-label"],
                    "aria-labelledby": this.props["aria-labelledby"],
                    "aria-required": required,
                    role: "combobox",
                    "aria-activedescendant": this.isAppleDevice ? undefined : this.state.focusedOptionId || ""
                }, menuIsOpen && {
                    "aria-controls": this.getElementId("listbox")
                }), !isSearchable && {
                    "aria-readonly": true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
                    "aria-describedby": this.getElementId("live-region")
                } : {
                    "aria-describedby": this.getElementId("placeholder")
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $8v0nu.createElement($ce6dd352cf0458f3$var$DummyInput, (0, $2Jgqn.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $b0015ad11dc7ba35$export$b4171a6734a65d42),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $8v0nu.createElement(Input, (0, $2Jgqn.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $8v0nu.createElement(Placeholder, (0, $2Jgqn.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId("placeholder")
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $8v0nu.createElement(MultiValue, (0, $2Jgqn.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, "value"));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $8v0nu.createElement(SingleValue, (0, $2Jgqn.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $8v0nu.createElement(ClearIndicator, (0, $2Jgqn.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $8v0nu.createElement(LoadingIndicator, (0, $2Jgqn.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $8v0nu.createElement(IndicatorSeparator, (0, $2Jgqn.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $8v0nu.createElement(DropdownIndicator, (0, $2Jgqn.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: "option",
                        "aria-selected": _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $8v0nu.createElement(Option, (0, $2Jgqn.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === "group") {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $8v0nu.createElement(Group, (0, $2Jgqn.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === "option") return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $8v0nu.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $8v0nu.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $8v0nu.createElement((0, $b0015ad11dc7ba35$export$3a1a48c8f6ef640e), (0, $2Jgqn.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $8v0nu.createElement(Menu, (0, $2Jgqn.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $8v0nu.createElement($ce6dd352cf0458f3$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $8v0nu.createElement(MenuList, (0, $2Jgqn.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: "listbox",
                                "aria-multiselectable": commonProps.isMulti,
                                id: _this4.getElementId("listbox")
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ $8v0nu.createElement(MenuPortal, (0, $2Jgqn.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $8v0nu.createElement($ce6dd352cf0458f3$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $8v0nu.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $8v0nu.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $8v0nu.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $8v0nu.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ $8v0nu.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $8v0nu.createElement($ce6dd352cf0458f3$var$LiveRegion$1, (0, $2Jgqn.default)({}, commonProps, {
                    id: this.getElementId("live-region"),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $8v0nu.createElement(SelectContainer, (0, $2Jgqn.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $8v0nu.createElement(Control, (0, $2Jgqn.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $8v0nu.createElement(ValueContainer, (0, $2Jgqn.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $8v0nu.createElement(IndicatorsContainer, (0, $2Jgqn.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $b0015ad11dc7ba35$export$7f8ddf7c7c20b3cd)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $ce6dd352cf0458f3$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $ce6dd352cf0458f3$var$buildFocusableOptionsWithIds($ce6dd352cf0458f3$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $ce6dd352cf0458f3$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $ce6dd352cf0458f3$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $ce6dd352cf0458f3$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $b0015ad11dc7ba35$export$96f57966bedc81b4)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: "initial-input-focus"
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") newAriaSelection = null;
                return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $8v0nu.Component));
$ce6dd352cf0458f3$export$25ce5a424b770e84.defaultProps = $ce6dd352cf0458f3$export$407448d2b89b1813;



var $FTTp4 = parcelRequire("FTTp4");

var $2rHYb = parcelRequire("2rHYb");
















var $3ca06130fd21d224$var$StateManagedSelect = /*#__PURE__*/ (0, $8v0nu.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $502643e4fe0f2f4b$export$3b14a55fb2447963)(props);
    return /*#__PURE__*/ $8v0nu.createElement((0, $ce6dd352cf0458f3$export$25ce5a424b770e84), (0, $2Jgqn.default)({
        ref: ref
    }, baseSelectProps));
});
var $3ca06130fd21d224$export$2e2bcd8739ae039 = $3ca06130fd21d224$var$StateManagedSelect;
var $3ca06130fd21d224$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $8v0nu.useMemo)(function() {
        return (0, $2rHYb.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $8v0nu.createElement((0, $FTTp4.C), {
        value: emotionCache
    }, children);
};





var $8v0nu = parcelRequire("8v0nu");

var $8v0nu = parcelRequire("8v0nu");
var $8c3e330d32b9f1f7$var$isPrimitive = function(val) {
    return val !== Object(val);
};
var $8c3e330d32b9f1f7$var$useCustomCompareEffect = function(effect, deps, depsEqual) {
    var ref = (0, $8v0nu.useRef)(undefined);
    if (!ref.current || !depsEqual(deps, ref.current)) ref.current = deps;
    (0, $8v0nu.useEffect)(effect, ref.current);
};
var $8c3e330d32b9f1f7$export$2e2bcd8739ae039 = $8c3e330d32b9f1f7$var$useCustomCompareEffect;


var $7c4e9ac5f6edde4e$exports = {};
"use strict";
// do not edit .js files directly - edit src/index.jst
$7c4e9ac5f6edde4e$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};


var $7852941372b3df78$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($7c4e9ac5f6edde4e$exports)));


var $e8d4da89a8771ae1$var$isPrimitive = function(val) {
    return val !== Object(val);
};
var $e8d4da89a8771ae1$var$useDeepCompareEffect = function(effect, deps) {
    (0, $8c3e330d32b9f1f7$export$2e2bcd8739ae039)(effect, deps, (0, $7852941372b3df78$export$2e2bcd8739ae039));
};
var $e8d4da89a8771ae1$export$2e2bcd8739ae039 = $e8d4da89a8771ae1$var$useDeepCompareEffect;


const $b250f793f6b3703c$export$ae66a4a39529a5d9 = (props)=>{
    const [renderKey, setSenderKey] = (0, $8v0nu.useState)(-1);
    (0, $e8d4da89a8771ae1$export$2e2bcd8739ae039)(()=>{
        setSenderKey((v)=>v + 1);
    }, props);
    return `key-${Math.max(0, renderKey)}`;
};


function $4e9a8f866a5de52c$export$a42fc98e48605119(props) {
    const { pointer: pointer, isRequired: isRequired, field: field } = props;
    const isMulti = field.type === "array";
    if (isMulti ? !field.items?.enum?.length : !field.enum?.length) throw new Error("WidgetSelect: enum is required");
    if (isMulti ? field.items.allowOther : field.allowOther) throw new Error("WidgetSelect: allowOther is not supported. Use widget 'tagger' instead");
    const key = (0, $b250f793f6b3703c$export$ae66a4a39529a5d9)([
        pointer,
        isRequired,
        isMulti,
        field
    ]);
    const options = (0, $8v0nu.useMemo)(()=>{
        const enums = isMulti ? field.items?.enum : field.enum;
        return enums.map(([value, label])=>({
                value: value,
                label: label
            }));
    }, [
        field
    ]);
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $jTKGQ.FastField), {
        name: pointer,
        children: ({ field: { name: name, value: value }, meta: meta, form: { setFieldValue: setFieldValue } })=>{
            const selectedOpts = options.filter((option)=>(0, $81cc9f2a42ee34ee$export$ff8cd4c6525ea2f6)(value).includes(option.value));
            return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, $02b238a4ba05f901$export$fe5d99d8691b3f62), {
                isRequired: isRequired,
                isInvalid: !!(meta.touched && meta.error),
                children: [
                    field.label && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $2d2a7a8f479cc337$export$842aba50ed0ce9d7), {
                        children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8f2967926209c75b$export$1acdcf5a973a8414), {
                            size: "xs",
                            children: field.label
                        })
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $3ca06130fd21d224$export$2e2bcd8739ae039), {
                        name: name,
                        options: options,
                        isMulti: isMulti,
                        isClearable: !isRequired,
                        onChange: (option)=>{
                            if (option) setFieldValue(name, isMulti ? option.map((o)=>o.value) : option.value);
                            else setFieldValue(name, isMulti ? [] : undefined);
                        },
                        value: selectedOpts
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $210fc61c9a876d6f$export$185a8afe504e8fca), {
                        children: meta.error
                    })
                ]
            });
        }
    }, key);
}




var $kxTYF = parcelRequire("kxTYF");

var $8v0nu = parcelRequire("8v0nu");

var $kxTYF = parcelRequire("kxTYF");





var $3lBLT = parcelRequire("3lBLT");
"use client";
const $0c12d517d4e767ab$export$5e66ad77b1eb2956 = (0, $5c5c853bf41fd64f$export$257a8862b851cb5b)(function Kbd2(props, ref) {
    const styles = (0, $c7d173d35275482d$export$b863f77547fbcb03)("Kbd", props);
    const { className: className, ...rest } = (0, $58ff34c9d17adf03$export$adfcf5a5e4d17785)(props);
    return /* @__PURE__ */ (0, $kxTYF.jsx)((0, $3lBLT.chakra).kbd, {
        ref: ref,
        className: (0, $94ee945bf8ea8e46$export$a274e22fb40f762e)("chakra-kbd", className),
        ...rest,
        __css: {
            fontFamily: "mono",
            ...styles
        }
    });
});
$0c12d517d4e767ab$export$5e66ad77b1eb2956.displayName = "Kbd";



var $jTKGQ = parcelRequire("jTKGQ");

var $2Jgqn = parcelRequire("2Jgqn");

var $8v0nu = parcelRequire("8v0nu");






var $8v0nu = parcelRequire("8v0nu");


var $2bd67411dc7bee78$var$_excluded = [
    "allowCreateWhileLoading",
    "createOptionPosition",
    "formatCreateLabel",
    "isValidNewOption",
    "getNewOptionData",
    "onCreateOption",
    "options",
    "onChange"
];
var $2bd67411dc7bee78$var$compareOption = function compareOption() {
    var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var option = arguments.length > 1 ? arguments[1] : undefined;
    var accessors = arguments.length > 2 ? arguments[2] : undefined;
    var candidate = String(inputValue).toLowerCase();
    var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
var $2bd67411dc7bee78$var$builtins = {
    formatCreateLabel: function formatCreateLabel(inputValue) {
        return 'Create "'.concat(inputValue, '"');
    },
    isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
        return !(!inputValue || selectValue.some(function(option) {
            return $2bd67411dc7bee78$var$compareOption(inputValue, option, accessors);
        }) || selectOptions.some(function(option) {
            return $2bd67411dc7bee78$var$compareOption(inputValue, option, accessors);
        }));
    },
    getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
        return {
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        };
    }
};
function $2bd67411dc7bee78$export$3b14a55fb2447963(_ref) {
    var _ref$allowCreateWhile = _ref.allowCreateWhileLoading, allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile, _ref$createOptionPosi = _ref.createOptionPosition, createOptionPosition = _ref$createOptionPosi === void 0 ? "last" : _ref$createOptionPosi, _ref$formatCreateLabe = _ref.formatCreateLabel, formatCreateLabel = _ref$formatCreateLabe === void 0 ? $2bd67411dc7bee78$var$builtins.formatCreateLabel : _ref$formatCreateLabe, _ref$isValidNewOption = _ref.isValidNewOption, isValidNewOption = _ref$isValidNewOption === void 0 ? $2bd67411dc7bee78$var$builtins.isValidNewOption : _ref$isValidNewOption, _ref$getNewOptionData = _ref.getNewOptionData, getNewOptionData = _ref$getNewOptionData === void 0 ? $2bd67411dc7bee78$var$builtins.getNewOptionData : _ref$getNewOptionData, onCreateOption = _ref.onCreateOption, _ref$options = _ref.options, propsOptions = _ref$options === void 0 ? [] : _ref$options, propsOnChange = _ref.onChange, restSelectProps = (0, $a69ac13ab3c3f3dd$export$2e2bcd8739ae039)(_ref, $2bd67411dc7bee78$var$_excluded);
    var _restSelectProps$getO = restSelectProps.getOptionValue, getOptionValue$1 = _restSelectProps$getO === void 0 ? (0, $ce6dd352cf0458f3$export$39b482c5e57630a8) : _restSelectProps$getO, _restSelectProps$getO2 = restSelectProps.getOptionLabel, getOptionLabel$1 = _restSelectProps$getO2 === void 0 ? (0, $ce6dd352cf0458f3$export$8b22cf2602fb60ce) : _restSelectProps$getO2, inputValue = restSelectProps.inputValue, isLoading = restSelectProps.isLoading, isMulti = restSelectProps.isMulti, value = restSelectProps.value, name = restSelectProps.name;
    var newOption = (0, $8v0nu.useMemo)(function() {
        return isValidNewOption(inputValue, (0, $b0015ad11dc7ba35$export$7f8ddf7c7c20b3cd)(value), propsOptions, {
            getOptionValue: getOptionValue$1,
            getOptionLabel: getOptionLabel$1
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined;
    }, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel$1,
        getOptionValue$1,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    var options = (0, $8v0nu.useMemo)(function() {
        return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === "first" ? [
            newOption
        ].concat((0, $aba02085c81f3bc8$export$2e2bcd8739ae039)(propsOptions)) : [].concat((0, $aba02085c81f3bc8$export$2e2bcd8739ae039)(propsOptions), [
            newOption
        ]) : propsOptions;
    }, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    var onChange = (0, $8v0nu.useCallback)(function(newValue, actionMeta) {
        if (actionMeta.action !== "select-option") return propsOnChange(newValue, actionMeta);
        var valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                var newOptionData = getNewOptionData(inputValue, inputValue);
                var newActionMeta = {
                    action: "create-option",
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $b0015ad11dc7ba35$export$96f57966bedc81b4)(isMulti, [].concat((0, $aba02085c81f3bc8$export$2e2bcd8739ae039)((0, $b0015ad11dc7ba35$export$7f8ddf7c7c20b3cd)(value)), [
                    newOptionData
                ]), newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return (0, $0604ab8b4211d13c$export$2e2bcd8739ae039)((0, $0604ab8b4211d13c$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        options: options,
        onChange: onChange
    });
}



















var $32cb2715631b50e8$var$CreatableSelect = /*#__PURE__*/ (0, $8v0nu.forwardRef)(function(props, ref) {
    var creatableProps = (0, $502643e4fe0f2f4b$export$3b14a55fb2447963)(props);
    var selectProps = (0, $2bd67411dc7bee78$export$3b14a55fb2447963)(creatableProps);
    return /*#__PURE__*/ $8v0nu.createElement((0, $ce6dd352cf0458f3$export$25ce5a424b770e84), (0, $2Jgqn.default)({
        ref: ref
    }, selectProps));
});
var $32cb2715631b50e8$export$2e2bcd8739ae039 = $32cb2715631b50e8$var$CreatableSelect;




const $46645db2fc870d87$var$createOption = (label)=>({
        label: label,
        value: label
    });
const $46645db2fc870d87$var$onTabOrEnter = (cb)=>(event)=>{
        switch(event.key){
            case "Enter":
            case "Tab":
                cb(event);
        }
    };
function $46645db2fc870d87$export$20cd3f91cc937f5(props) {
    const { field: field } = props;
    if (field.type === "string") {
        if (!field.enum) throw new Error("WidgetTagger: 'enum' is required when type is 'string'");
        if (field.allowOther?.type !== "string") throw new Error("WidgetTagger: 'allowOther.type' is required for the 'tagger' widget with 'enum' options. Use the 'select' widget instead.");
        return /*#__PURE__*/ (0, $kxTYF.jsx)($46645db2fc870d87$var$WidgetTaggerWithOptions, {
            ...props
        });
    }
    if (field.type === "array") {
        if (field.items.type !== "string") throw new Error("WidgetTagger: 'items.type' must be 'string' when type is 'array'");
        if (field.items.enum) {
            if (field.items.allowOther?.type !== "string") throw new Error("WidgetTagger: 'items.allowOther.type' is required for the 'tagger' widget with 'enum' options. Use the 'select' widget instead.");
            return /*#__PURE__*/ (0, $kxTYF.jsx)($46645db2fc870d87$var$WidgetTaggerWithOptions, {
                ...props,
                isMulti: true
            });
        }
        return /*#__PURE__*/ (0, $kxTYF.jsx)($46645db2fc870d87$var$WidgetTaggerNoOptions, {
            ...props
        });
    }
    throw new Error(`WidgetTagger: Field type must be 'string' or 'array'. Got: ${field.type}`);
}
/******************************************************************************/ /*                                                                            */ /*                  N O   O P T I O N S   C O M P O N E N T                   */ /*    with CreatableSelect is in a separate component because of FastField    */ /*                                                                            */ /*  Tagger with no options to choose from. The user can only create new ones  */ /*                                                                            */ /******************************************************************************/ function $46645db2fc870d87$var$WidgetTaggerNoOptions(props) {
    const { pointer: pointer, isRequired: isRequired, field: field } = props;
    const key = (0, $b250f793f6b3703c$export$ae66a4a39529a5d9)([
        pointer,
        isRequired,
        field
    ]);
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $jTKGQ.FastField), {
        name: pointer,
        children: ({ field: { value: value, name: name }, meta: meta, form: { setFieldValue: setFieldValue } })=>/*#__PURE__*/ (0, $kxTYF.jsxs)((0, $02b238a4ba05f901$export$fe5d99d8691b3f62), {
                isRequired: isRequired,
                isInvalid: !!(meta.touched && meta.error),
                children: [
                    field.label && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $2d2a7a8f479cc337$export$842aba50ed0ce9d7), {
                        children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8f2967926209c75b$export$1acdcf5a973a8414), {
                            size: "xs",
                            children: field.label
                        })
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)($46645db2fc870d87$var$WidgetTaggerNoOptionsSelect, {
                        pointer: pointer,
                        value: value,
                        onChange: (v)=>setFieldValue(name, v)
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $210fc61c9a876d6f$export$185a8afe504e8fca), {
                        children: meta.error
                    })
                ]
            })
    }, key);
}
const $46645db2fc870d87$var$components = {
    DropdownIndicator: null
};
function $46645db2fc870d87$var$WidgetTaggerNoOptionsSelect(props) {
    const { value: value, onChange: onChange, pointer: pointer } = props;
    const [inputValue, setInputValue] = (0, $8v0nu.useState)("");
    const selectedValues = Array.isArray(value) ? value.map($46645db2fc870d87$var$createOption) : [];
    const handleKeyDown = $46645db2fc870d87$var$onTabOrEnter((event)=>{
        if (!inputValue) return;
        if (!value.includes(inputValue)) onChange([
            ...value,
            inputValue
        ]);
        setInputValue("");
        event.preventDefault();
    });
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $32cb2715631b50e8$export$2e2bcd8739ae039), {
        name: pointer,
        components: $46645db2fc870d87$var$components,
        inputValue: inputValue,
        isClearable: true,
        isMulti: true,
        menuIsOpen: false,
        onChange: (newValue)=>{
            onChange(newValue.map((option)=>option.value));
        },
        onInputChange: (newValue)=>setInputValue(newValue),
        onKeyDown: handleKeyDown,
        placeholder: /*#__PURE__*/ (0, $kxTYF.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).Fragment, {
            children: [
                "Type & ",
                /*#__PURE__*/ (0, $kxTYF.jsx)((0, $0c12d517d4e767ab$export$5e66ad77b1eb2956), {
                    children: "enter"
                }),
                " to add options"
            ]
        }),
        value: selectedValues
    });
}
/******************************************************************************/ /*                                                                            */ /*                     O P T I O N S   C O M P O N E N T                      */ /*    with CreatableSelect is in a separate component because of FastField    */ /*                                                                            */ /*  Tagger with options to choose from as well as the option to create        */ /*  new ones.                                                                 */ /*                                                                            */ /******************************************************************************/ function $46645db2fc870d87$var$WidgetTaggerWithOptions(props) {
    const { pointer: pointer, isRequired: isRequired, isMulti: isMulti, field: field } = props;
    const key = (0, $b250f793f6b3703c$export$ae66a4a39529a5d9)([
        pointer,
        isRequired,
        isMulti,
        field
    ]);
    const options = (0, $8v0nu.useMemo)(()=>{
        const enums = isMulti ? field.items.enum : field.enum;
        return enums.map(([value, label])=>({
                value: value,
                label: label
            }));
    }, [
        field
    ]);
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $jTKGQ.FastField), {
        name: pointer,
        children: ({ field: { name: name, value: value }, meta: meta, form: { setFieldValue: setFieldValue } })=>/*#__PURE__*/ (0, $kxTYF.jsxs)((0, $02b238a4ba05f901$export$fe5d99d8691b3f62), {
                isRequired: isRequired,
                isInvalid: !!(meta.touched && meta.error),
                children: [
                    field.label && /*#__PURE__*/ (0, $kxTYF.jsx)((0, $2d2a7a8f479cc337$export$842aba50ed0ce9d7), {
                        children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8f2967926209c75b$export$1acdcf5a973a8414), {
                            size: "xs",
                            children: field.label
                        })
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)($46645db2fc870d87$var$WidgetTaggerWithOptionsSelect, {
                        pointer: pointer,
                        isMulti: !!isMulti,
                        value: value,
                        onChange: (v)=>setFieldValue(name, v),
                        options: options
                    }),
                    /*#__PURE__*/ (0, $kxTYF.jsx)((0, $210fc61c9a876d6f$export$185a8afe504e8fca), {
                        children: meta.error
                    })
                ]
            })
    }, key);
}
function $46645db2fc870d87$var$WidgetTaggerWithOptionsSelect(props) {
    const { isMulti: isMulti, onChange: onChange, value: value, options: options, pointer: pointer } = props;
    const [inputValue, setInputValue] = (0, $8v0nu.useState)("");
    const selectedValues = value ? isMulti ? value.map($46645db2fc870d87$var$createOption) : $46645db2fc870d87$var$createOption(value) : isMulti ? [] : undefined;
    const handleKeyDown = $46645db2fc870d87$var$onTabOrEnter((event)=>{
        if (!inputValue) return;
        if (value.includes(inputValue)) {
            setInputValue("");
            event.preventDefault();
        }
    });
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $32cb2715631b50e8$export$2e2bcd8739ae039), {
        name: pointer,
        inputValue: inputValue,
        isClearable: true,
        isMulti: isMulti,
        onChange: (newValue)=>{
            if (isMulti) onChange((newValue || []).map((option)=>option.value));
            else onChange(newValue?.value);
        },
        onInputChange: (newValue)=>setInputValue(newValue),
        onKeyDown: handleKeyDown,
        options: options,
        placeholder: "Select or type to add",
        value: selectedValues
    });
}


const $ac885aba5ffedc46$export$41be205aae9631a4 = (0, $aa58e4af7634fac0$export$afcbd3cdfffb6e7c)({
    "ui:widget": {
        object: (0, $0fcc824096db126c$export$fc949cf2e017c75f),
        "object:fieldset": (0, $b10f7d2a328f4eb8$export$a9edb623e575de0d),
        text: (0, $17485d2c0739238f$export$b63d030f4611938c),
        number: (0, $c0c33d699328ac6c$export$7833621d74bfe8fb),
        radio: (0, $d8f83a902ec18287$export$578a0ba473f83a10),
        checkbox: (0, $6369dd324fce8d1d$export$7125ae6e0d206208),
        select: (0, $4e9a8f866a5de52c$export$a42fc98e48605119),
        tagger: (0, $46645db2fc870d87$export$20cd3f91cc937f5),
        array: (0, $a19b114acf696fe3$export$a7e262ad5a444678),
        "array:string": (0, $a3347928c80810e5$export$9436aa8cdadea878),
        json: (0, $5d31050dffea9ad7$export$28f0f0b6ca7da3eb)
    }
});




function $cec627a8235eede2$export$9558ee0e4173beb4(condition, id, ifTrue, ifFalse) {
    return condition ? {
        [id]: ifTrue
    } : ifFalse ? {
        [id]: ifFalse
    } : {};
}
function $cec627a8235eede2$export$daa8453c5457a43f(v) {
    if (Array.isArray(v)) return v.map($cec627a8235eede2$export$daa8453c5457a43f);
    return v === "" ? null : v;
}
function $cec627a8235eede2$export$4a3dd5ab3487d8b5(v) {
    if (Array.isArray(v)) return v.map($cec627a8235eede2$export$4a3dd5ab3487d8b5);
    return v === null ? "" : v;
}
function $cec627a8235eede2$export$1f4191cf9967a565(stack, keyName, each = (v)=>v) {
    return Object.entries(stack || {}).map(([key, value])=>{
        return {
            [keyName]: key,
            ...each(value)
        };
    });
}
function $cec627a8235eede2$export$f91e2d43f34fbadd(stack) {
    return Object.entries(stack || {}).map(([key, value])=>[
            key
        ].concat(value));
}
function $cec627a8235eede2$export$916f5f00d1f59607(stack, keyName, each = (v)=>v) {
    return (stack || []).reduce((acc, item)=>{
        const newItem = {
            ...item
        };
        delete newItem[keyName];
        return {
            ...acc,
            [item[keyName]]: each(newItem)
        };
    }, {});
}
function $cec627a8235eede2$export$9ad71af9b9b65995(stack) {
    return (stack || []).reduce((acc, [key, item])=>{
        return {
            ...acc,
            [key]: item
        };
    }, {});
}
function $cec627a8235eede2$export$7344ca394fcf1a58(data, extension, version) {
    const regex = new RegExp(`/${extension}/v([0-9.]+)/schema.json`);
    return data?.stac_extensions?.some((ext)=>{
        const match = ext.match(regex);
        return match && (!version || version(match[1]));
    });
}
function $cec627a8235eede2$export$66c404fc598e0f86($this, label, value) {
    // Quick way to get the name.
    const name = new (0, $6b77bd4fc5b65248$export$e620499b4783e2c1)().name;
    $this.registerHook(name, "onAfterEditSchema", (pl, formData, schema)=>{
        if (!schema || typeof schema === "symbol") return schema;
        const stac_extensions = schema.properties.stac_extensions;
        // Set the new extension value in the schema.
        stac_extensions.items.enum.push([
            value,
            label
        ]);
        return schema;
    });
}


class $6b77bd4fc5b65248$export$e620499b4783e2c1 extends (0, $c0a25ef586f9da64$export$901cf72dabf2112a) {
    name = "CollectionsCore";
    isNew = false;
    async init(data) {
        this.isNew = !data?.id;
    }
    editSchema() {
        return {
            type: "root",
            required: [
                "id",
                "description",
                "license",
                "spatial",
                "temporal",
                "links"
            ],
            properties: {
                ...(0, $cec627a8235eede2$export$9558ee0e4173beb4)(this.isNew, "id", {
                    label: "Collection ID",
                    type: "string"
                }),
                title: {
                    label: "Title",
                    type: "string"
                },
                description: {
                    label: "Description",
                    type: "string"
                },
                keywords: {
                    type: "array",
                    label: "Keywords",
                    "ui:widget": "tagger",
                    items: {
                        label: "Keyword",
                        type: "string"
                    }
                },
                license: {
                    label: "License",
                    type: "string",
                    "ui:widget": "tagger",
                    allowOther: {
                        type: "string"
                    },
                    enum: [
                        [
                            "Apache-2.0",
                            "Apache License 2.0"
                        ],
                        [
                            "MIT",
                            "MIT License"
                        ],
                        [
                            "GPL-3.0",
                            "GNU General Public License v3.0"
                        ],
                        [
                            "BSD-3-Clause",
                            "BSD 3-Clause License"
                        ],
                        [
                            "MPL-2.0",
                            "Mozilla Public License 2.0"
                        ]
                    ]
                },
                providers: {
                    type: "array",
                    label: "Providers",
                    items: {
                        type: "object",
                        required: [
                            "name"
                        ],
                        properties: {
                            name: {
                                label: "Name",
                                type: "string"
                            },
                            roles: {
                                label: "Roles",
                                type: "array",
                                items: {
                                    label: "Role",
                                    type: "string",
                                    enum: [
                                        [
                                            "licensor",
                                            "Licensor"
                                        ],
                                        [
                                            "producer",
                                            "Producer"
                                        ],
                                        [
                                            "processor",
                                            "Processor"
                                        ],
                                        [
                                            "host",
                                            "Host"
                                        ]
                                    ]
                                }
                            },
                            url: {
                                label: "URL",
                                type: "string"
                            }
                        }
                    }
                },
                stac_extensions: {
                    type: "array",
                    label: "STAC Extensions",
                    "ui:widget": "tagger",
                    items: {
                        type: "string",
                        allowOther: {
                            type: "string"
                        },
                        enum: []
                    }
                },
                spatial: {
                    label: "Spatial Extent",
                    type: "array",
                    minItems: 1,
                    items: {
                        type: "array",
                        label: "Extent",
                        minItems: 4,
                        maxItems: 4,
                        items: {
                            label: [
                                "Min Longitude",
                                "Min Latitude",
                                "Max Longitude",
                                "Max Latitude"
                            ],
                            type: "number"
                        }
                    }
                },
                temporal: {
                    label: "Temporal Extent",
                    type: "array",
                    minItems: 1,
                    items: {
                        type: "array",
                        label: "Extent",
                        minItems: 2,
                        maxItems: 2,
                        items: {
                            label: [
                                "Start",
                                "End"
                            ],
                            type: "string"
                        }
                    }
                },
                links: {
                    type: "array",
                    label: "Links",
                    minItems: 1,
                    items: {
                        type: "object",
                        required: [
                            "rel",
                            "href",
                            "type"
                        ],
                        properties: {
                            href: {
                                label: "URL",
                                type: "string"
                            },
                            rel: {
                                label: "Relation",
                                type: "string"
                            },
                            type: {
                                label: "Type",
                                type: "string",
                                "ui:widget": "select",
                                enum: [
                                    [
                                        "application/geo+json",
                                        "geo+json"
                                    ],
                                    [
                                        "application/geopackage+sqlite3",
                                        "geopackage+sqlite3"
                                    ],
                                    [
                                        "application/json",
                                        "json"
                                    ],
                                    [
                                        "application/schema+json",
                                        "schema+json"
                                    ],
                                    [
                                        "application/vnd.google-earth.kml+xml",
                                        "vnd.google-earth.kml+xml"
                                    ],
                                    [
                                        "application/vnd.google-earth.kmz",
                                        "vnd.google-earth.kmz"
                                    ],
                                    [
                                        "application/vnd.oai.openapi+json;version=3.0",
                                        "vnd.oai.openapi+json;version=3.0"
                                    ],
                                    [
                                        "application/x-hdf",
                                        "x-hdf"
                                    ],
                                    [
                                        "application/x-hdf5",
                                        "x-hdf5"
                                    ],
                                    [
                                        "application/xml",
                                        "xml"
                                    ],
                                    [
                                        "image/jp2",
                                        "jp2"
                                    ],
                                    [
                                        "image/jpeg",
                                        "jpeg"
                                    ],
                                    [
                                        "image/png",
                                        "png"
                                    ],
                                    [
                                        "image/tiff; application=geotiff; profile=cloud-optimized",
                                        "COG"
                                    ],
                                    [
                                        "image/tiff; application=geotiff",
                                        "Geotiff"
                                    ],
                                    [
                                        "text/html",
                                        "HTML"
                                    ],
                                    [
                                        "text/plain",
                                        "Text"
                                    ]
                                ]
                            },
                            title: {
                                label: "Title",
                                type: "string"
                            }
                        }
                    }
                },
                thumbnail: {
                    type: "object",
                    "ui:widget": "object:fieldset",
                    label: "Thumbnail",
                    properties: {
                        title: {
                            label: "Title",
                            type: "string"
                        },
                        href: {
                            label: "Href",
                            type: "string"
                        }
                    }
                },
                assets: {
                    type: "array",
                    label: "Assets",
                    items: {
                        type: "object",
                        required: [
                            "id",
                            "href"
                        ],
                        properties: {
                            id: {
                                label: "Id",
                                type: "string"
                            },
                            href: {
                                label: "Href",
                                type: "string"
                            },
                            title: {
                                label: "Title",
                                type: "string"
                            },
                            description: {
                                label: "Description",
                                type: "string"
                            },
                            type: {
                                label: "Type",
                                type: "string"
                            },
                            roles: {
                                label: "Roles",
                                type: "array",
                                items: {
                                    label: "Role",
                                    type: "string"
                                }
                            }
                        }
                    }
                },
                summaries: {
                    type: "json",
                    label: "Summaries"
                }
            }
        };
    }
    enterData(data = {}) {
        return {
            id: data?.id,
            title: data?.title,
            description: data?.description,
            keywords: data?.keywords || [],
            license: data?.license,
            providers: data?.providers || [],
            stac_extensions: data?.stac_extensions,
            spatial: data?.extent?.spatial.bbox || [],
            temporal: data?.extent?.temporal.interval.map((0, $cec627a8235eede2$export$4a3dd5ab3487d8b5)) || [],
            links: data?.links || [],
            thumbnail: {
                title: data?.assets?.thumbnail?.title || "",
                href: data?.assets?.thumbnail?.href || ""
            },
            assets: Object.entries(data?.assets || {}).map(([key, value])=>({
                    id: key,
                    ...value
                })),
            summaries: data?.summaries || {}
        };
    }
    exitData(data) {
        const thumbnail = data.thumbnail.title ? {
            thumbnail: {
                href: data.thumbnail.href,
                title: data.thumbnail.title,
                roles: [
                    "thumbnail"
                ],
                type: data.thumbnail.href.match(/\.jpe?g$/) ? "image/jpeg" : "image/png"
            }
        } : {};
        return {
            type: "Collection",
            stac_version: "1.0.0",
            id: data.id,
            title: data.title,
            description: data.description,
            keywords: data.keywords,
            license: data.license,
            providers: data.providers,
            stac_extensions: data.stac_extensions,
            extent: {
                spatial: {
                    bbox: data.spatial
                },
                temporal: {
                    interval: data.temporal.map((0, $cec627a8235eede2$export$daa8453c5457a43f))
                }
            },
            links: data.links,
            assets: data.assets.reduce((acc, asset)=>{
                return {
                    ...acc,
                    [asset.id]: asset
                };
            }, {
                ...thumbnail
            }),
            summaries: data.summaries
        };
    }
}



class $97855730a133c737$export$8708d1ece48244f6 extends (0, $c0a25ef586f9da64$export$901cf72dabf2112a) {
    name = "Item Assets Extension";
    constructor(){
        super();
        (0, $cec627a8235eede2$export$66c404fc598e0f86)(this, "Item Assets Definition", "https://stac-extensions.github.io/item-assets/v1.0.0/schema.json");
    }
    editSchema(data) {
        if (!(0, $cec627a8235eede2$export$7344ca394fcf1a58)(data, "item-assets")) return (0, $c0a25ef586f9da64$export$901cf72dabf2112a).HIDDEN;
        return {
            type: "root",
            properties: {
                item_assets: {
                    type: "array",
                    label: "Item Assets",
                    minItems: 1,
                    items: {
                        type: "object",
                        required: [
                            "id"
                        ],
                        properties: {
                            id: {
                                label: "Item Asset ID",
                                type: "string"
                            },
                            type: {
                                label: "Type",
                                type: "string"
                            },
                            title: {
                                label: "Title",
                                type: "string"
                            },
                            description: {
                                label: "Description",
                                type: "string"
                            },
                            roles: {
                                label: "Roles",
                                type: "array",
                                "ui:widget": "tagger",
                                items: {
                                    label: "Role",
                                    type: "string",
                                    enum: [
                                        [
                                            "thumbnail",
                                            "Thumbnail"
                                        ],
                                        [
                                            "overview",
                                            "Overview"
                                        ],
                                        [
                                            "data",
                                            "Data"
                                        ],
                                        [
                                            "metadata",
                                            "Metadata"
                                        ]
                                    ]
                                }
                            }
                        }
                    }
                }
            }
        };
    }
    enterData(data = {}) {
        return {
            item_assets: (0, $cec627a8235eede2$export$1f4191cf9967a565)(data.item_assets, "id")
        };
    }
    exitData(data) {
        return {
            item_assets: (0, $cec627a8235eede2$export$916f5f00d1f59607)(data.item_assets, "id")
        };
    }
}



class $ee9b29702898ba23$export$c6379ecf8f55f1e4 extends (0, $c0a25ef586f9da64$export$901cf72dabf2112a) {
    name = "Render Extension";
    constructor(){
        super();
        (0, $cec627a8235eede2$export$66c404fc598e0f86)(this, "Render", "https://stac-extensions.github.io/render/v2.0.0/schema.json");
    }
    editSchema(data) {
        if (!(0, $cec627a8235eede2$export$7344ca394fcf1a58)(data, "render")) return (0, $c0a25ef586f9da64$export$901cf72dabf2112a).HIDDEN;
        return {
            type: "root",
            properties: {
                renders: {
                    type: "array",
                    label: "Renders",
                    items: {
                        type: "object",
                        required: [
                            "id",
                            "assets"
                        ],
                        additionalProperties: true,
                        properties: {
                            id: {
                                label: "Render ID",
                                type: "string"
                            },
                            assets: {
                                type: "array",
                                label: "Assets",
                                minItems: 1,
                                items: {
                                    type: "string"
                                }
                            },
                            rescale: {
                                type: "array",
                                label: "Rescale",
                                items: {
                                    type: "array",
                                    minItems: 2,
                                    maxItems: 2,
                                    items: {
                                        type: "number",
                                        label: [
                                            "Min",
                                            "Max"
                                        ]
                                    }
                                }
                            },
                            nodata: {
                                label: "No Data Value",
                                type: "string"
                            },
                            colormap_name: {
                                label: "Colormap",
                                type: "string",
                                "ui:widget": "tagger",
                                allowOther: {
                                    type: "string"
                                },
                                enum: $ee9b29702898ba23$var$colorMaps
                            },
                            colormap: {
                                type: "array",
                                label: "Colormap (Custom)",
                                items: {
                                    type: "array",
                                    minItems: 2,
                                    maxItems: 2,
                                    items: {
                                        type: "string",
                                        label: [
                                            "Value",
                                            "Color"
                                        ]
                                    }
                                }
                            },
                            resampling: {
                                label: "Resampling",
                                type: "string",
                                "ui:widget": "tagger",
                                allowOther: {
                                    type: "string"
                                },
                                enum: [
                                    [
                                        "near",
                                        "Nearest neighbour"
                                    ],
                                    [
                                        "bilinear",
                                        "Bilinear"
                                    ],
                                    [
                                        "cubic",
                                        "Cubic"
                                    ],
                                    [
                                        "cubicspline",
                                        "Cubic spline"
                                    ],
                                    [
                                        "lanczos",
                                        "Lanczos windowed sinc"
                                    ],
                                    [
                                        "average",
                                        "Average"
                                    ],
                                    [
                                        "rms",
                                        "Root mean square"
                                    ],
                                    [
                                        "mode",
                                        "Mode"
                                    ],
                                    [
                                        "max",
                                        "Maximum"
                                    ],
                                    [
                                        "min",
                                        "Minimum"
                                    ],
                                    [
                                        "med",
                                        "Median"
                                    ],
                                    [
                                        "q1",
                                        "First quartile"
                                    ],
                                    [
                                        "q3",
                                        "Third quartile"
                                    ],
                                    [
                                        "sum",
                                        "Weighted sum"
                                    ]
                                ]
                            },
                            expression: {
                                label: "Expression",
                                type: "string"
                            },
                            minmax_zoom: {
                                type: "array",
                                label: "Min/Max Zoom",
                                minItems: 2,
                                maxItems: 2,
                                items: {
                                    type: "number",
                                    label: [
                                        "Min",
                                        "Max"
                                    ]
                                }
                            }
                        }
                    }
                }
            }
        };
    }
    enterData(data = {}) {
        return {
            renders: (0, $cec627a8235eede2$export$1f4191cf9967a565)(data.renders, "id", (v)=>({
                    ...v,
                    colormap: (0, $cec627a8235eede2$export$f91e2d43f34fbadd)(v.colormap)
                }))
        };
    }
    exitData(data) {
        return {
            renders: (0, $cec627a8235eede2$export$916f5f00d1f59607)(data.renders, "id", (v)=>({
                    ...v,
                    colormap: (0, $cec627a8235eede2$export$9ad71af9b9b65995)(v.colormap)
                }))
        };
    }
}
const $ee9b29702898ba23$var$colorMaps = [
    "dense_r",
    "turbid",
    "rdbu",
    "ice",
    "purd_r",
    "bugn",
    "bone",
    "plasma_r",
    "gist_yarg",
    "rdpu_r",
    "afmhot_r",
    "plasma",
    "amp_r",
    "piyg_r",
    "ylorbr",
    "phase_r",
    "matter_r",
    "pastel1",
    "inferno_r",
    "purd",
    "paired",
    "thermal",
    "gist_heat_r",
    "greens_r",
    "summer",
    "terrain",
    "gist_earth_r",
    "gnbu",
    "topo_r",
    "algae_r",
    "gist_heat",
    "puor_r",
    "wistia_r",
    "speed",
    "gist_gray",
    "cubehelix_r",
    "brbg",
    "haline_r",
    "ylgnbu",
    "algae",
    "thermal_r",
    "rdgy_r",
    "winter",
    "rdylgn",
    "spring",
    "flag",
    "hot_r",
    "matter",
    "rdpu",
    "nipy_spectral_r",
    "prgn",
    "tab20b_r",
    "bupu_r",
    "coolwarm",
    "twilight_shifted",
    "hsv_r",
    "delta_r",
    "seismic",
    "amp",
    "oranges",
    "cmrmap",
    "diff_r",
    "tab20c",
    "paired_r",
    "ocean_r",
    "bwr",
    "topo",
    "seismic_r",
    "gist_stern_r",
    "tempo_r",
    "gnbu_r",
    "brg",
    "cividis",
    "gist_gray_r",
    "set2_r",
    "pubugn",
    "pastel2_r",
    "cool_r",
    "blues",
    "flag_r",
    "jet_r",
    "tab20",
    "curl",
    "winter_r",
    "nipy_spectral",
    "phase",
    "hot",
    "spectral_r",
    "summer_r",
    "hsv",
    "tarn",
    "twilight_shifted_r",
    "ylgnbu_r",
    "ylorbr_r",
    "ylgn_r",
    "pink_r",
    "puor",
    "viridis_r",
    "balance_r",
    "gist_earth",
    "magma",
    "pastel2",
    "rain_r",
    "brg_r",
    "solar",
    "binary_r",
    "reds",
    "tab10",
    "gray_r",
    "gist_yarg_r",
    "cubehelix",
    "accent_r",
    "delta",
    "gist_rainbow_r",
    "spectral",
    "pink",
    "set3",
    "gist_ncar",
    "balance",
    "greys",
    "rainbow",
    "diff",
    "bone_r",
    "speed_r",
    "bugn_r",
    "solar_r",
    "pubugn_r",
    "coolwarm_r",
    "cmrmap_r",
    "set1",
    "rain",
    "ylorrd",
    "set3_r",
    "twilight_r",
    "schwarzwald",
    "gnuplot2_r",
    "rdylgn_r",
    "greys_r",
    "set1_r",
    "cool",
    "pubu",
    "reds_r",
    "gray",
    "gnuplot_r",
    "spring_r",
    "pubu_r",
    "prism_r",
    "set2",
    "prgn_r",
    "tab20_r",
    "copper",
    "cividis_r",
    "bupu",
    "viridis",
    "rplumbo",
    "turbo_r",
    "dense",
    "accent",
    "gnuplot2",
    "prism",
    "orrd",
    "jet",
    "piyg",
    "brbg_r",
    "purples",
    "terrain_r",
    "deep_r",
    "rdbu_r",
    "turbo",
    "turbid_r",
    "deep",
    "rainbow_r",
    "tempo",
    "wistia",
    "dark2",
    "oranges_r",
    "cfastie",
    "twilight",
    "ylorrd_r",
    "autumn_r",
    "gist_rainbow",
    "tab20b",
    "rdylbu_r",
    "orrd_r",
    "rdgy",
    "gist_ncar_r",
    "binary",
    "magma_r",
    "gnuplot",
    "haline",
    "dark2_r",
    "tarn_r",
    "gist_stern",
    "inferno",
    "curl_r",
    "purples_r",
    "blues_r",
    "autumn",
    "rdylbu",
    "ocean",
    "afmhot",
    "tab20c_r",
    "oxy",
    "oxy_r",
    "ylgn",
    "pastel1_r",
    "greens",
    "ice_r",
    "copper_r",
    "tab10_r",
    "bwr_r"
].map((v)=>[
        v,
        v
    ]);


const $e23560f758eaee83$export$e506a1d27d1eaa20 = (0, $aa58e4af7634fac0$export$afcbd3cdfffb6e7c)((0, $ac885aba5ffedc46$export$41be205aae9631a4), {
    collectionPlugins: [
        new (0, $6b77bd4fc5b65248$export$e620499b4783e2c1)(),
        new (0, $97855730a133c737$export$8708d1ece48244f6)(),
        new (0, $ee9b29702898ba23$export$c6379ecf8f55f1e4)()
    ],
    // collectionPlugins: [new PluginKitchenSink()],
    itemPlugins: [],
    "ui:widget": {}
});




const $7a411f40ee06088b$var$publicUrl = "/";
const $7a411f40ee06088b$var$stacApiUrl = "https://eoapi.develop.eoepca.org/stac/";
let $7a411f40ee06088b$var$basename;
if ($7a411f40ee06088b$var$publicUrl) try {
    $7a411f40ee06088b$var$basename = new URL($7a411f40ee06088b$var$publicUrl).pathname;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
} catch (error) {
// no-op
}
// Single source of truth for auth-to-API wiring. Reads the current OIDC token
// from useAuth() and feeds it into two consumers:
//   1. ApiContext — for direct Api.fetch calls (mutations, ad-hoc reads).
//   2. StacApiProvider — for stac-react hooks (useCollection, useStacSearch…).
// A token change rebuilds both: a new Api instance via useMemo, and a new
// `options` identity that triggers stac-react's useStacApi effect to rebuild
// its StacApi with fresh headers.
//
// During OIDC load we render children without StacApiProvider so the rest of
// the app can still mount and read from ApiContext; stac-react hooks defer
// their requests until the provider appears.
function $7a411f40ee06088b$var$StacApiAuthBridge({ children: children }) {
    const { token: token, isLoading: isLoading } = (0, $c837ac9c698038bc$export$1d39dc5b47e56ff0)();
    const api = (0, $8v0nu.useMemo)(()=>new (0, $e60c4cd554136647$export$2e2bcd8739ae039)(token), [
        token
    ]);
    const options = (0, $8v0nu.useMemo)(()=>token ? {
            headers: {
                Authorization: `Bearer ${token}`
            }
        } : undefined, [
        token
    ]);
    return /*#__PURE__*/ (0, $kxTYF.jsx)((0, $e60c4cd554136647$export$f6d52655da4aa77d).Provider, {
        value: api,
        children: isLoading ? children : /*#__PURE__*/ (0, $kxTYF.jsx)((0, $eba44fb2c963ffed$export$dc253927969915ae), {
            apiUrl: $7a411f40ee06088b$var$stacApiUrl,
            options: options,
            children: children
        })
    });
}
// Root component.
function $7a411f40ee06088b$var$Root() {
    (0, $8v0nu.useEffect)(()=>{
        // Hide the welcome banner.
        const banner = document.querySelector("#welcome-banner");
        if (!banner) return;
        banner.classList.add("dismissed");
        setTimeout(()=>banner.remove(), 500);
    }, []);
    return /*#__PURE__*/ (0, $kxTYF.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8v0nu))).StrictMode, {
        children: [
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $e573fadeff6283fe$export$7730ada0bba3cb70), {}),
            /*#__PURE__*/ (0, $kxTYF.jsx)((0, $8cf81b0fc725af40$export$80dbe0482bcbd25a), {
                theme: (0, $9f3e244f4ad36284$export$2e2bcd8739ae039),
                children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $d9197f3f1e79e9d9$export$9ba4e89fdfa1fc54), {
                    basename: $7a411f40ee06088b$var$basename,
                    children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $c837ac9c698038bc$export$87091915187a1a85), {
                        children: /*#__PURE__*/ (0, $kxTYF.jsx)($7a411f40ee06088b$var$StacApiAuthBridge, {
                            children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $c14d6b556e5e27a6$export$1bd450f81b7fc15b), {
                                config: (0, $e23560f758eaee83$export$e506a1d27d1eaa20),
                                children: /*#__PURE__*/ (0, $kxTYF.jsx)((0, $abca8739d4d09600$export$86fbec116b87613f), {})
                            })
                        })
                    })
                })
            })
        ]
    });
}
const $7a411f40ee06088b$var$rootNode = document.querySelector("#app-container");
const $7a411f40ee06088b$var$root = (0, $70200245338e5781$export$882461b6382ed46c)($7a411f40ee06088b$var$rootNode);
$7a411f40ee06088b$var$root.render(/*#__PURE__*/ (0, $kxTYF.jsx)($7a411f40ee06088b$var$Root, {}));


//# sourceMappingURL=index.788a50b3.js.map
